export const drcdata = {
  type: "FeatureCollection",
  crs: {
    type: "geojsondata.json",
    properties: {
      name: "Basic DRCongo Infos data",
      auther: "developer.david.maene@gmail.com",
      repository: "git@github.com:davmaene/drc-geojson.git",
      version: "1.0.0",
      lastUpdate: "2021/03/26",
    },
  },
  features: [
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Mbuji-Mayi",
        AREA: 9481,
        POPULATION: 3145000,
        DISTRICTS: ["Ngandajika", "Miabi", "Kabinda", "Tshilenge"],
        OBJECTID: 10,
        NOM: "Kasaï-Oriental",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [23.73511230397807, -5.689228568556442],
            [23.737809960047638, -5.693169901492515],
            [23.737576591211543, -5.693816589522682],
            [23.733659879978934, -5.704670058673239],
            [23.735030039857605, -5.713869945495723],
            [23.730926109838283, -5.72544056158555],
            [23.726059919774535, -5.739159983009705],
            [23.721618688535731, -5.747842004423886],
            [23.720300086564471, -5.750419671311651],
            [23.715939959721076, -5.751630012801459],
            [23.71203000022615, -5.752710023178955],
            [23.710420101557695, -5.75845998456916],
            [23.712019920230318, -5.763520054560582],
            [23.718700453843109, -5.766576845116617],
            [23.721012325718952, -5.763993971034131],
            [23.725461667846478, -5.764225786230343],
            [23.729936330786892, -5.764458921242618],
            [23.731397369629594, -5.763584145523096],
            [23.731645442090251, -5.76343561783508],
            [23.73338515899535, -5.762393984879082],
            [23.736599119079521, -5.763087889115935],
            [23.737892189133781, -5.764968647263041],
            [23.73884914374473, -5.76636062325696],
            [23.741188148335404, -5.769762899869461],
            [23.745802882883165, -5.77213611907481],
            [23.746441589541742, -5.772464584510923],
            [23.750601445077361, -5.774603856316746],
            [23.751090833769432, -5.774616703406911],
            [23.759788249586737, -5.774845025093668],
            [23.761052659790167, -5.777000249641932],
            [23.761280191373523, -5.777388078999049],
            [23.762083267271237, -5.778756954562868],
            [23.76552737393455, -5.779680909056283],
            [23.769854519132306, -5.772699492143492],
            [23.770671287151547, -5.771381710594336],
            [23.771509146715371, -5.770029891086486],
            [23.778864306123346, -5.764058880702347],
            [23.779206577721329, -5.763423231153716],
            [23.779453239826974, -5.76296514328641],
            [23.780473160949438, -5.761071027158269],
            [23.785757182604666, -5.761996974086653],
            [23.796791161391734, -5.751890971696659],
            [23.806900384780917, -5.748223023873671],
            [23.808496674871112, -5.74709345940001],
            [23.809790562392294, -5.746177878363847],
            [23.812416304730093, -5.74431984655033],
            [23.820810424154647, -5.742442934103604],
            [23.823673162725683, -5.741802949267383],
            [23.828117721324301, -5.741919007223222],
            [23.832861406336143, -5.742042876970775],
            [23.843422402363167, -5.748263908136845],
            [23.848245643074858, -5.748353924766489],
            [23.847893516059916, -5.748786052974906],
            [23.846182503023073, -5.750885675592535],
            [23.84411934320838, -5.753417235951827],
            [23.843779143125438, -5.756291093454863],
            [23.843438943042489, -5.759164936234488],
            [23.841719943084485, -5.759511905304928],
            [23.840000583800339, -5.759858873260901],
            [23.83851054374701, -5.761469989243704],
            [23.837020503693648, -5.763081099695204],
            [23.836870743756002, -5.765610094741032],
            [23.8367213431445, -5.768139077466753],
            [23.836571583206819, -5.770668049666809],
            [23.83508046337851, -5.771244526003573],
            [23.833588983325768, -5.771820822701299],
            [23.83198554354421, -5.774198622647197],
            [23.830382104660984, -5.776576411582485],
            [23.828778663981129, -5.778954011360148],
            [23.828133904474143, -5.781780401460107],
            [23.8274895042933, -5.78460641827396],
            [23.826844743888017, -5.787432600719754],
            [23.826200344605468, -5.790258768848992],
            [23.825580424414429, -5.792980927546928],
            [23.826197464606675, -5.795202824375123],
            [23.826814144574488, -5.79742435426901],
            [23.82743120542797, -5.799645853709314],
            [23.829728704259285, -5.798723738847773],
            [23.832025863527431, -5.797801421830075],
            [23.834323383020017, -5.796879282321843],
            [23.836620903410896, -5.795957141286958],
            [23.837631445223433, -5.792528576042184],
            [23.847744543046463, -5.798186915549673],
            [23.857142001591626, -5.800691725741873],
            [23.873014365787785, -5.800961930203321],
            [23.880594181271906, -5.80441897659211],
            [23.882265656758133, -5.806642835827862],
            [23.89183842063267, -5.81937900816528],
            [23.899646111754937, -5.82306615450111],
            [23.901010140631787, -5.845604975531337],
            [23.899629377039506, -5.848822974678403],
            [23.903764123764621, -5.849516938405051],
            [23.905316514983522, -5.847120317217561],
            [23.905521658753383, -5.846803619518768],
            [23.906294233253917, -5.845610920116187],
            [23.911575408148011, -5.849065843865109],
            [23.915254259866433, -5.844239903570648],
            [23.920002795780803, -5.84363572393903],
            [23.920255724533899, -5.843603542280798],
            [23.924213219280404, -5.843100010141579],
            [23.929958459358687, -5.840805872814783],
            [23.935936258891015, -5.834372880504914],
            [23.93570729898634, -5.83069298394368],
            [23.939615398070313, -5.826557026327835],
            [23.94163084746199, -5.826727271471057],
            [23.945129207876903, -5.827022832058078],
            [23.945250245979985, -5.826524684440815],
            [23.946972417889274, -5.819434947304837],
            [23.948067890022056, -5.819078454959162],
            [23.957540162060727, -5.815996093535777],
            [23.955644817422542, -5.823085156715526],
            [23.955912297086591, -5.832430113474414],
            [23.957549937527642, -5.840861989712411],
            [23.959395657432903, -5.842928434116878],
            [23.961241737562567, -5.844995049814901],
            [23.959634697333374, -5.847679469815152],
            [23.958027296879713, -5.850363876763716],
            [23.956420257548817, -5.853048270654717],
            [23.956961697323408, -5.855652692520376],
            [23.957503497322396, -5.858257102083842],
            [23.95804493709695, -5.860861498440092],
            [23.958586737095974, -5.863465883382935],
            [23.959128176870525, -5.866070255107875],
            [23.959669976869517, -5.868674973436052],
            [23.961283137320766, -5.871508256373928],
            [23.962896296873684, -5.874341524712829],
            [23.964509457324933, -5.877174778445808],
            [23.966698976862475, -5.878665798490101],
            [23.968888857522749, -5.88015681448635],
            [23.970493377079251, -5.886126932340982],
            [23.972064417323462, -5.901383226516573],
            [23.972811814741547, -5.908832937614876],
            [23.972814462974988, -5.908858912496116],
            [23.973255000383567, -5.913249800128895],
            [23.974959240123166, -5.933480956093256],
            [23.976267480027612, -5.939230367830012],
            [23.981488560324141, -5.943325581250126],
            [23.989161959599649, -5.943947586723775],
            [23.996848856062247, -5.943237575169054],
            [23.99821127964972, -5.943111733059215],
            [24.005002679741587, -5.942626497138128],
            [24.011348759794263, -5.946404768737946],
            [24.015201839762074, -5.952240799920305],
            [24.015178080221109, -5.961308948719404],
            [24.012321479838441, -5.970461011574625],
            [24.007764600388242, -5.979663463968312],
            [24.005361599816712, -5.994751878114728],
            [24.002569800305366, -6.006168325486906],
            [23.997396239989062, -6.021154912489386],
            [23.989867560204146, -6.025357742125026],
            [23.989582440322867, -6.025516907746131],
            [23.9923382398492, -6.028739005195978],
            [23.993026247847208, -6.029007540095205],
            [23.996473200373362, -6.030352914063909],
            [24.0041436280219, -6.02673942389859],
            [24.008653440242746, -6.024614868178563],
            [24.016464359910145, -6.028760870807426],
            [24.024502440156663, -6.037275909058831],
            [24.03001619965762, -6.039809909339096],
            [24.037530587246341, -6.039816608095864],
            [24.041275200135154, -6.039819946233149],
            [24.052307400257938, -6.035460934469757],
            [24.055752239946546, -6.035923864484436],
            [24.057819360433374, -6.037304943436683],
            [24.061950360285429, -6.049035010565364],
            [24.063711785877686, -6.05004388214816],
            [24.066774360073534, -6.051797993659363],
            [24.071367240407039, -6.056861005444509],
            [24.074656762281364, -6.057193009903306],
            [24.075964439840426, -6.05732499150998],
            [24.080330519819217, -6.055259004587644],
            [24.08837328028838, -6.054805948996334],
            [24.093113399886843, -6.050832913263682],
            [24.095499479791712, -6.048832853471525],
            [24.106298400011614, -6.048611879121201],
            [24.108143299755024, -6.049536373352607],
            [24.111812343667207, -6.051375129689201],
            [24.116863319879826, -6.058737915113452],
            [24.117735399866081, -6.06155294483833],
            [24.118929323760728, -6.065406840434902],
            [24.124671827570687, -6.064261845602746],
            [24.130418399850534, -6.063115912195163],
            [24.130654065678804, -6.063185221375743],
            [24.132387240153676, -6.063694947295216],
            [24.139839239745918, -6.065882944389589],
            [24.145355159695089, -6.062437951481263],
            [24.15156037582641, -6.062212864229247],
            [24.152212755741939, -6.0626797465945],
            [24.154775280039967, -6.064513946089182],
            [24.156114002476951, -6.067864887128638],
            [24.157072440206409, -6.070263928396749],
            [24.160976280377643, -6.075094869343601],
            [24.163271280095834, -6.085213951303873],
            [24.168325320461921, -6.087976925409282],
            [24.174755279805943, -6.102926985780566],
            [24.173977437584593, -6.10448153549868],
            [24.172685280218651, -6.107063955781609],
            [24.166248480203734, -6.113038009157216],
            [24.162342479584247, -6.113954951550806],
            [24.155676179777135, -6.119698034047014],
            [24.155283032991363, -6.119887355788181],
            [24.142803479859193, -6.125896921060603],
            [24.141306918935197, -6.127392859599016],
            [24.139816199755526, -6.128882953129462],
            [24.139763545005128, -6.129442899692467],
            [24.139124279594427, -6.136240984721616],
            [24.140501280143997, -6.141069889588298],
            [24.139222200452, -6.145881906298227],
            [24.115759920114659, -6.174742330335788],
            [24.114940433793365, -6.175784668107729],
            [24.114040920156651, -6.176928791481719],
            [24.113010600136484, -6.179535761996238],
            [24.111980640340725, -6.182142181871527],
            [24.110950320320555, -6.184748768540905],
            [24.109920359626496, -6.187355163282778],
            [24.108890399830734, -6.189961544101708],
            [24.107860440035005, -6.192568091695848],
            [24.10533395973945, -6.192648538013263],
            [24.102807480342193, -6.192728805412811],
            [24.100281000046671, -6.192809072799955],
            [24.097864319929975, -6.190973670310171],
            [24.095448000037713, -6.189138260459094],
            [24.092917920192825, -6.190291574078367],
            [24.090388199674042, -6.191444884247272],
            [24.088089600406512, -6.190299456741248],
            [24.085791000240654, -6.189154027617683],
            [24.083605799802992, -6.18927210058721],
            [24.081420959589796, -6.189389993724436],
            [24.079587480128584, -6.191384682876207],
            [24.077754359993513, -6.193379365294019],
            [24.075920879634008, -6.195374039177321],
            [24.073392600012934, -6.195377980470353],
            [24.070864320391859, -6.195381742858864],
            [24.068336400096925, -6.195385506146352],
            [24.065808119577522, -6.195389268534774],
            [24.064663320054184, -6.198091821541095],
            [24.063518519632517, -6.200793823812467],
            [24.062373720109179, -6.203495990957966],
            [24.061228919687508, -6.20619814316912],
            [24.059651039670733, -6.207356076703705],
            [24.058073519878391, -6.20851418655935],
            [24.055386480098822, -6.208147619473808],
            [24.052699440319284, -6.207781589729467],
            [24.050012759865854, -6.207415737728745],
            [24.04732608031075, -6.207049707469117],
            [24.044639399857317, -6.206683676951812],
            [24.041952360077783, -6.206317645277816],
            [24.03926567962435, -6.205951793146043],
            [24.036579000069249, -6.20558576185589],
            [24.0342260401506, -6.206954571959301],
            [24.03187308023195, -6.208323198660085],
            [24.029520479639441, -6.209691822656507],
            [24.0267434403465, -6.210692622767488],
            [24.023966760379697, -6.211693242052092],
            [24.021301319692874, -6.212654623092512],
            [24.018635879904313, -6.213615644557232],
            [24.015970079891346, -6.214576663344802],
            [24.013304640102817, -6.215537680353896],
            [24.010639200314287, -6.216498696483209],
            [24.007973759627429, -6.217459709934535],
            [24.005277360300934, -6.229304363504325],
            [24.003247319574132, -6.257401657017799],
            [24.001232760412908, -6.276151982208936],
            [24.000755729844208, -6.289192269561146],
            [24.004082848908087, -6.296455955212125],
            [24.009328407397792, -6.301397296579185],
            [24.020215527805576, -6.305321316024353],
            [24.04586732678213, -6.319849921508268],
            [24.055661486746647, -6.325222183507103],
            [24.068629046961956, -6.332481956366777],
            [24.076974565733043, -6.336764511102801],
            [24.08580608564921, -6.348111162635131],
            [24.09139149657382, -6.35502384973129],
            [24.088204392523409, -6.359825267408564],
            [24.083250450531125, -6.358612881876335],
            [24.076752891165331, -6.362336331707464],
            [24.076221446046581, -6.362640876454861],
            [24.076276271126705, -6.363824196648268],
            [24.076517257676386, -6.369027927535791],
            [24.067552458314786, -6.374852809783595],
            [24.066835678176542, -6.37676256339322],
            [24.06661704081278, -6.37734519383946],
            [24.065693111864956, -6.379806928222181],
            [24.056505337175114, -6.379316014285401],
            [24.048187155934762, -6.385211878457109],
            [24.048159067412453, -6.385213376564926],
            [24.042661178447652, -6.385506853731295],
            [24.037882036931574, -6.389512964508985],
            [24.026848178518748, -6.389043908663523],
            [24.025423674158631, -6.388608936578384],
            [24.021562104213121, -6.387430237837681],
            [24.016502212221273, -6.39500810451864],
            [24.015405207562605, -6.394942880125073],
            [24.007841481803531, -6.394467467651192],
            [23.990524179269514, -6.393378999220623],
            [23.9858748281423, -6.398200109298785],
            [23.984544341459838, -6.399579732146307],
            [23.979948357447025, -6.399575865215025],
            [23.979655498579582, -6.399362596226213],
            [23.979339554805929, -6.399132513215816],
            [23.974891173875761, -6.395893007262736],
            [23.974687322781623, -6.396077189711302],
            [23.970062479491993, -6.400255960284455],
            [23.965925379180813, -6.399562865208397],
            [23.948679209742558, -6.406211935719251],
            [23.946691183221571, -6.407975901362573],
            [23.946255132897825, -6.408362805367075],
            [23.942468130307379, -6.411722973918321],
            [23.940170251488723, -6.412180011859031],
            [23.937924860333776, -6.411361492280156],
            [23.937805247857053, -6.41131788944704],
            [23.935114410000491, -6.410336982415075],
            [23.928451248907002, -6.404812927376469],
            [23.927070210430241, -6.406419862946426],
            [23.927297354839716, -6.410327833359387],
            [23.92510149948448, -6.409163058628189],
            [23.924975521545694, -6.409096235584458],
            [23.923391363203404, -6.408255927863196],
            [23.920183261931502, -6.408252445618107],
            [23.916956380480279, -6.408248941805549],
            [23.912590196296929, -6.404566929058747],
            [23.912265115758526, -6.404467597617574],
            [23.912196481775894, -6.404446625806887],
            [23.907302582278874, -6.402951254464983],
            [23.907728817609829, -6.402101955335331],
            [23.907741815333701, -6.402076117209877],
            [23.909379153042497, -6.398817503074453],
            [23.907886866302626, -6.393221024619997],
            [23.907868486771914, -6.393152094775674],
            [23.906620039631072, -6.388470096060668],
            [23.904978644232116, -6.387003870139474],
            [23.904559597220068, -6.386630119940109],
            [23.896280101927452, -6.388690005497152],
            [23.892690964058119, -6.387787244131426],
            [23.881569782213173, -6.384989968830382],
            [23.87999074786126, -6.386945059502978],
            [23.876740022427448, -6.390969942073553],
            [23.86438295727924, -6.39056673083785],
            [23.862029346081989, -6.390490266135267],
            [23.857810970695521, -6.392312099274441],
            [23.855129944238488, -6.393469978807725],
            [23.852972491861635, -6.392685069714619],
            [23.852599864393596, -6.392549503280833],
            [23.852151320300855, -6.392009707633292],
            [23.849160064253738, -6.388409894439433],
            [23.846640992364311, -6.383251898504575],
            [23.848879983921172, -6.37584999656425],
            [23.844441088302091, -6.370935334116562],
            [23.843189837519276, -6.369549951406849],
            [23.839284640891957, -6.367712232346361],
            [23.808235327107184, -6.390430830426535],
            [23.808280848335901, -6.390773870087627],
            [23.808332481701804, -6.391162655637289],
            [23.808693212780543, -6.393878861024968],
            [23.813976213051305, -6.397792853568545],
            [23.81512235825096, -6.401242003898861],
            [23.813808137363338, -6.402883171583555],
            [23.813705783319858, -6.403010988848562],
            [23.813282124357141, -6.403540031130034],
            [23.809558590436453, -6.403386389420742],
            [23.807535462245752, -6.403302909981171],
            [23.79926732525157, -6.394097896396311],
            [23.796766366093252, -6.393738094309915],
            [23.796049301189061, -6.393634933300047],
            [23.795134337427768, -6.395233243146779],
            [23.79501240460268, -6.395446240687093],
            [23.794208254319905, -6.396850983341743],
            [23.793504453939217, -6.412481964545289],
            [23.791433441950602, -6.416847004256163],
            [23.798553453858226, -6.423521931441315],
            [23.805210212658668, -6.436172932486762],
            [23.805210226133422, -6.437318549509127],
            [23.805209942265776, -6.437663680567599],
            [23.805208413333183, -6.439620919084573],
            [23.803135173522627, -6.443986016612449],
            [23.801713755773839, -6.444410650267688],
            [23.801409800916016, -6.444501453482614],
            [23.798536173865426, -6.44535991739759],
            [23.797850040651426, -6.446729791491437],
            [23.797431405067744, -6.447565601242359],
            [23.797155241389856, -6.448116964748402],
            [23.798136945485172, -6.450353577748676],
            [23.798778149460244, -6.451814347885474],
            [23.799679174063275, -6.453867023978829],
            [23.797204474457313, -6.462707793153479],
            [23.796913293642813, -6.463748015748393],
            [23.796542144801702, -6.463953611654405],
            [23.792772213794926, -6.466041935971188],
            [23.79264687455828, -6.466505897033199],
            [23.792490555122427, -6.467084535438634],
            [23.791158333793138, -6.472015929763836],
            [23.789274567540673, -6.472870248208202],
            [23.789179034405151, -6.472913574327182],
            [23.788629333723222, -6.473162871731072],
            [23.788577016739399, -6.473356404623938],
            [23.787014293996414, -6.47913695538799],
            [23.776439383065615, -6.478664937395837],
            [23.776169232710231, -6.481078908516912],
            [23.776135456953863, -6.48138072529116],
            [23.775976413826047, -6.482801921358218],
            [23.779450898817373, -6.487747782274294],
            [23.77970372336587, -6.488107671381964],
            [23.78034033425488, -6.489013868492726],
            [23.780365292148442, -6.489227706679417],
            [23.780427265123269, -6.489758697421065],
            [23.780796453840413, -6.492921924173215],
            [23.780011388265841, -6.49497701950661],
            [23.779874856919054, -6.495334420858451],
            [23.77895325370951, -6.497746921099802],
            [23.774355952766523, -6.501889869361816],
            [23.773649337964031, -6.502526645531336],
            [23.771820205450478, -6.504174983925487],
            [23.769981233689649, -6.503942932963801],
            [23.768621141230341, -6.505156854976184],
            [23.768412740169275, -6.505342842648072],
            [23.765609134998471, -6.507844953833312],
            [23.766489854082813, -6.510136635654583],
            [23.766548115218864, -6.5102882337885],
            [23.766758212299187, -6.51083490257598],
            [23.770680846124492, -6.511820076641938],
            [23.773193247124606, -6.512450996496491],
            [23.77525927526003, -6.517050872509484],
            [23.784912254197884, -6.5200509270602],
            [23.786060319097267, -6.522350029195692],
            [23.784509893392219, -6.523565460386526],
            [23.78432623732396, -6.523709434772485],
            [23.782839252440894, -6.524874978881552],
            [23.780273290290307, -6.524983668702371],
            [23.777551545896372, -6.525098956594574],
            [23.771791413547305, -6.5388830082628],
            [23.769716390580946, -6.546466059284657],
            [23.770401454799771, -6.552903001657085],
            [23.766712243709481, -6.565310680681693],
            [23.771072135194267, -6.574739951694779],
            [23.76738935424477, -6.58094110794607],
            [23.765839244746697, -6.581924622786852],
            [23.762327399721055, -6.584152876122822],
            [23.755659480251509, -6.583914945532932],
            [23.748304319945206, -6.581147857109594],
            [23.745533399976026, -6.594706012777107],
            [23.746549311019013, -6.599805767088215],
            [23.748281279954817, -6.608499920209469],
            [23.747125319762372, -6.615622917073783],
            [23.748729479992768, -6.621140934221502],
            [23.748293948895245, -6.622371838465643],
            [23.747347439894448, -6.625046867051315],
            [23.740213347793048, -6.631473678041224],
            [23.741020133732878, -6.633036559448286],
            [23.741303702223671, -6.633585830260579],
            [23.743656335155546, -6.638142850709501],
            [23.746645422669602, -6.64021488358954],
            [23.757681079509616, -6.639999002968682],
            [23.762284274299198, -6.642605634105013],
            [23.762968175199745, -6.64299291411394],
            [23.762014662034673, -6.644147989625472],
            [23.756523454738954, -6.650799921507156],
            [23.760660222673469, -6.652872976396587],
            [23.764136084782077, -6.653193217464585],
            [23.764806334883563, -6.653254969498749],
            [23.773306285730069, -6.654037931903135],
            [23.778824222397059, -6.656342896200751],
            [23.783878413680092, -6.661633898728878],
            [23.78486121731332, -6.664589997751373],
            [23.785252071598496, -6.665765615156274],
            [23.785713311581119, -6.66715293799288],
            [23.784119647266508, -6.668123760903829],
            [23.783754235066791, -6.668346342822146],
            [23.77742936693291, -6.672198962476335],
            [23.773078496330214, -6.672918888193994],
            [23.771911301806803, -6.673112018988594],
            [23.765014414347771, -6.670345981913012],
            [23.763901397219175, -6.670668987655139],
            [23.763569370906989, -6.67076534378977],
            [23.759494175298688, -6.671948004853231],
            [23.755121254649033, -6.675389928864752],
            [23.749625385995309, -6.686352145444622],
            [23.748039044746868, -6.689516260272358],
            [23.74683032739609, -6.691927082818173],
            [23.727922304326651, -6.719249796483075],
            [23.72865425970496, -6.721034707260231],
            [23.72872377852817, -6.721204185104432],
            [23.728866456148133, -6.721552013555785],
            [23.731331375795563, -6.723352894190468],
            [23.737369240281048, -6.727768010114105],
            [23.724946775983479, -6.736714315905843],
            [23.72061777576468, -6.74008651449193],
            [23.71596765567962, -6.743767234370747],
            [23.709075447544873, -6.74865686029254],
            [23.704676984198418, -6.748250961246002],
            [23.701959336122215, -6.72994550569275],
            [23.695420293454884, -6.726609750895503],
            [23.690942984077623, -6.727127704068324],
            [23.68693437698807, -6.730349990563153],
            [23.682439776838244, -6.735143108615975],
            [23.675063376765365, -6.741128845302361],
            [23.669141009574297, -6.743351489659453],
            [23.659544136714128, -6.745162485427366],
            [23.648351737331762, -6.746299121126499],
            [23.638284344892121, -6.745881228743633],
            [23.628044497477468, -6.748625720540779],
            [23.62418961728584, -6.753276913350399],
            [23.620795897126794, -6.762532095571888],
            [23.619329617512722, -6.769303306934128],
            [23.6164442099555, -6.771445643302527],
            [23.609410538723065, -6.771739314139103],
            [23.599027779228205, -6.770363286601433],
            [23.586741338729301, -6.76545437963948],
            [23.580042818149593, -6.761956190912056],
            [23.571594338073915, -6.756512801807338],
            [23.56091097892876, -6.75037835665368],
            [23.550065979626346, -6.744714702996947],
            [23.543614588276238, -6.741858750047228],
            [23.542089098905183, -6.741183431422519],
            [23.534278179237784, -6.736231266582244],
            [23.514539435516085, -6.718039955366996],
            [23.507181346701945, -6.716649941963999],
            [23.495695180255371, -6.706289895966959],
            [23.487894209429761, -6.691109885871282],
            [23.480543140051271, -6.685352916912016],
            [23.477800300519529, -6.670639891567388],
            [23.475046300318716, -6.666038915385965],
            [23.468385215231855, -6.66005295708639],
            [23.457811305922618, -6.656588912877194],
            [23.450235455602154, -6.646463861192025],
            [23.446098340019624, -6.644847974470989],
            [23.441959408043562, -6.645530906639646],
            [23.440803303222388, -6.647367867364209],
            [23.434139842091604, -6.641610076997818],
            [23.432690149869238, -6.635209730742647],
            [23.431849881922126, -6.631499936248756],
            [23.431640002234104, -6.622989984183953],
            [23.426979802153213, -6.615589975795534],
            [23.428091964085674, -6.610168808337614],
            [23.428259675955942, -6.609351306535893],
            [23.420000122364325, -6.601160020575381],
            [23.419853945806338, -6.595627778361354],
            [23.419720042031763, -6.590559938902624],
            [23.416509922245449, -6.584580038767199],
            [23.416584450972969, -6.583437843417036],
            [23.416749890105589, -6.580902402431845],
            [23.421119487887012, -6.580680077884534],
            [23.422797654923819, -6.579545111322816],
            [23.427551531322532, -6.576326737108203],
            [23.42939119119287, -6.572369446339148],
            [23.430329802205691, -6.570350390597644],
            [23.432664556866797, -6.568845325274015],
            [23.434239922499064, -6.567829949189067],
            [23.43930980106191, -6.556119997593924],
            [23.446139850270566, -6.549521958660504],
            [23.446678115398914, -6.54900197443503],
            [23.446449887621203, -6.54625000882205],
            [23.440929801285726, -6.547389944921874],
            [23.439779961315342, -6.544629991633895],
            [23.441502806961086, -6.537216799308922],
            [23.442557022167811, -6.532678609537751],
            [23.437734302478969, -6.532669904749523],
            [23.43220738265914, -6.535878954199926],
            [23.428997183821046, -6.52828887829043],
            [23.426691792391637, -6.526900218943718],
            [23.425552422285886, -6.526213916639728],
            [23.413356341524754, -6.534238888916781],
            [23.404165178389661, -6.529856863849686],
            [23.400715307237139, -6.530080850086034],
            [23.399788023081719, -6.53119581596075],
            [23.39940101089103, -6.531661160793226],
            [23.392887456123283, -6.539493017289794],
            [23.385990227304422, -6.53902194889523],
            [23.379577737497723, -6.535472086659324],
            [23.379356196778978, -6.535349444069115],
            [23.379326262218765, -6.535332872807666],
            [23.369222231990236, -6.525890993327527],
            [23.3670447498775, -6.525392610379052],
            [23.364166303365419, -6.524733882519425],
            [23.360487467816675, -6.525646856047882],
            [23.350207354317721, -6.532046726323464],
            [23.347410341882785, -6.533787989475816],
            [23.340236376260854, -6.538254017784],
            [23.330353302846127, -6.53685799342683],
            [23.324356062872784, -6.535244427452591],
            [23.324057557195417, -6.535295925496055],
            [23.322197508263091, -6.535616840094405],
            [23.318709102978143, -6.539170735140293],
            [23.316404023264155, -6.540914638724476],
            [23.313309102531523, -6.543745156946493],
            [23.31022174291866, -6.547368997993201],
            [23.308242103069176, -6.549616160126955],
            [23.306733343023634, -6.550922806527175],
            [23.303470302585573, -6.552960474796026],
            [23.300931223418164, -6.555354961652972],
            [23.297198383849476, -6.558477229734767],
            [23.292909344287796, -6.562035254941475],
            [23.290216184286201, -6.56500762777464],
            [23.284733024098809, -6.5692935622351],
            [23.281956703458114, -6.571977646408215],
            [23.278621303723959, -6.574809238182625],
            [23.276000864141267, -6.577059675990967],
            [23.267644904251647, -6.582370991849774],
            [23.261350303952934, -6.585579021715056],
            [23.255933023513514, -6.588421635440298],
            [23.25018994388348, -6.590761166564278],
            [23.246523702715006, -6.592512226229833],
            [23.237334704519718, -6.594581588357625],
            [23.234461183470355, -6.595534898149123],
            [23.231263664352497, -6.596129263829627],
            [23.229826544052543, -6.596569842955097],
            [23.217837104552896, -6.598870842119235],
            [23.213343226648533, -6.597957461993872],
            [23.209561424405287, -6.596174377536251],
            [23.206829384419883, -6.595251326609046],
            [23.20243522939354, -6.59628501169541],
            [23.198936024562254, -6.598756627925996],
            [23.19583462517982, -6.60093749502924],
            [23.19424162382187, -6.601811664477318],
            [23.189611304402266, -6.603279292852331],
            [23.185456545009245, -6.604239568078722],
            [23.180739110566652, -6.604986447006063],
            [23.179878363726012, -6.606917862583166],
            [23.173446225967428, -6.601848902323402],
            [23.173235258419584, -6.598801638085833],
            [23.173223392572993, -6.598630237262241],
            [23.174016195337099, -6.597615136692448],
            [23.176449360437566, -6.594499953848019],
            [23.175309949907582, -6.587707772289656],
            [23.173942319684766, -6.57955501994781],
            [23.174416303168009, -6.578272952705204],
            [23.174503199900371, -6.578037907414105],
            [23.179714175048286, -6.563935893962612],
            [23.171447160049912, -6.557483921462079],
            [23.168468159718195, -6.551271939134454],
            [23.169624442405798, -6.546907030665645],
            [23.168253239583091, -6.542307968074118],
            [23.169951502831097, -6.538291079870546],
            [23.171943240292528, -6.533579998558735],
            [23.172416278748091, -6.52530595741506],
            [23.166214200432066, -6.522536022989091],
            [23.165738761678053, -6.520432095687235],
            [23.165071388880435, -6.517477548007791],
            [23.167379486035475, -6.512424755279368],
            [23.166928423066672, -6.511064723930438],
            [23.166006480293962, -6.508284899488189],
            [23.167297832769403, -6.505070788765448],
            [23.167852200199221, -6.503690990615892],
            [23.166706320002579, -6.502079997533934],
            [23.162109479895296, -6.500691927766503],
            [23.161655012311595, -6.499321300805465],
            [23.160736440017825, -6.496550974026513],
            [23.151087359768312, -6.4923949449872],
            [23.147646564295098, -6.488019992103101],
            [23.153629319832849, -6.484353887522018],
            [23.154869160214933, -6.478662968743923],
            [23.155481520184534, -6.475852851711516],
            [23.152506479626592, -6.467571928491891],
            [23.151826986759168, -6.460444800089756],
            [23.150449440033892, -6.458832974252643],
            [23.139877298609147, -6.458352857245136],
            [23.13870505106226, -6.457397188306679],
            [23.136202439902153, -6.455356941209017],
            [23.138511480288209, -6.449154960505791],
            [23.139980174573779, -6.447325562546183],
            [23.142196439652267, -6.444564983913547],
            [23.141759668879651, -6.442249701061457],
            [23.141285311697246, -6.439735161926557],
            [23.133938399721895, -6.433973905611133],
            [23.131921635196662, -6.431344676757601],
            [23.1316434000037, -6.430981944901073],
            [23.131568525424761, -6.42998694389235],
            [23.131418412449225, -6.427992096049946],
            [23.13224858782408, -6.426706475732609],
            [23.13349343990717, -6.424778946234961],
            [23.133843359761478, -6.421330971762822],
            [23.134193279615786, -6.417882974527976],
            [23.135401224415393, -6.417368190570499],
            [23.135803199843803, -6.417196882463167],
            [23.140398239727233, -6.419504985906387],
            [23.144081399765771, -6.416523863617386],
            [23.14540271734413, -6.416614315123725],
            [23.147529479677612, -6.416759903778114],
            [23.148346972637309, -6.416047219720491],
            [23.149370520258557, -6.415154898233991],
            [23.148841602100713, -6.41284652230713],
            [23.148685439870057, -6.412164974069148],
            [23.145475341643273, -6.410552200400672],
            [23.142254399852728, -6.408933973992316],
            [23.139961200358353, -6.404791902559865],
            [23.141119320100753, -6.399735870592335],
            [23.139751319771996, -6.393067011311553],
            [23.136424920258662, -6.388808035255638],
            [23.133098631238106, -6.38454898733537],
            [23.135164991750184, -6.383863966966132],
            [23.137237440144961, -6.383176927213912],
            [23.139993239671295, -6.384561920327267],
            [23.140858260696024, -6.381614366901211],
            [23.141611439671262, -6.379047898318976],
            [23.14483020035232, -6.378364977042688],
            [23.148518295735016, -6.379601416506775],
            [23.14896732042644, -6.379751952377132],
            [23.149310290015368, -6.378814116005824],
            [23.149891439817083, -6.377224982058967],
            [23.145515445132528, -6.370199368026151],
            [23.144157410713539, -6.368018857985297],
            [23.146925400378286, -6.362506009267026],
            [23.146346351736018, -6.361537001869817],
            [23.146238160439829, -6.36135594879483],
            [23.143928399604899, -6.361229855542122],
            [23.141870361983926, -6.361117021188283],
            [23.141735945271339, -6.36075659799205],
            [23.141184234159805, -6.359276891719812],
            [23.12924040033047, -6.353045915648377],
            [23.119335885028224, -6.352505314851626],
            [23.11614036017032, -6.352330898470364],
            [23.11164965331891, -6.349901872694247],
            [23.107181399858053, -6.347484981039547],
            [23.0998284, -6.347009969795617],
            [23.09430743960375, -6.349527955819224],
            [23.089494240260315, -6.353654001432135],
            [23.085819720218158, -6.356483071832876],
            [23.082638400419857, -6.356394052930336],
            [23.077243440420283, -6.353800157358044],
            [23.074234200101174, -6.351272877911261],
            [23.071228920454136, -6.34809432813478],
            [23.069985839848787, -6.342684513561788],
            [23.067500399985327, -6.331702070524742],
            [23.066917560452573, -6.321912712352844],
            [23.066312399581644, -6.316194882761873],
            [23.065233840030711, -6.309812067231656],
            [23.065757999812465, -6.30119344749809],
            [23.064370199716553, -6.293172988290373],
            [23.061415680272969, -6.28071016408091],
            [23.057504640104735, -6.268546204597659],
            [23.054993639578129, -6.262285689619641],
            [23.054227559897111, -6.256888404328029],
            [23.053787323424125, -6.254238520600004],
            [23.053765320089553, -6.254106078867611],
            [23.060228400318124, -6.248762989587754],
            [23.06623428028789, -6.22992191280969],
            [23.067417240244527, -6.210152986896499],
            [23.068532547178787, -6.209677222113657],
            [23.068697399711503, -6.209606899291534],
            [23.070515658118524, -6.208831704258561],
            [23.072246293954432, -6.208093851448927],
            [23.083534230963874, -6.193401137784463],
            [23.083078343143725, -6.190642169060199],
            [23.077365480144891, -6.186014610442485],
            [23.06848176002589, -6.181367084418087],
            [23.062286879910236, -6.179564608749162],
            [23.054979599808558, -6.17756808261277],
            [23.041797120356478, -6.173452093116383],
            [23.033689199689853, -6.172410727968267],
            [23.026849199842818, -6.172219369017629],
            [23.020009199995744, -6.172028188909441],
            [23.013815399655069, -6.170062809830569],
            [23.008588560259248, -6.165843197578599],
            [23.005275480066643, -6.160699702602635],
            [23.004204840063256, -6.152848725958986],
            [23.00424660004586, -6.145191688119281],
            [23.004277919808228, -6.139489646789498],
            [23.004458279957731, -6.13558408337195],
            [23.004173160076448, -6.129547031611396],
            [23.004030239911373, -6.126610100608545],
            [23.007206159936523, -6.114369967269157],
            [23.010149491761556, -6.103119016455726],
            [23.003073359860618, -6.097903836965273],
            [22.99594931990724, -6.091512249501527],
            [22.982775120227107, -6.085929157697931],
            [22.971825000070147, -6.080897244955279],
            [22.964217479644347, -6.075632673753153],
            [22.959313919664773, -6.070443676614016],
            [22.956001920145443, -6.065136169267512],
            [22.95463067959346, -6.054015967846801],
            [22.955617440305502, -6.048176739408031],
            [22.955335201321347, -6.044137895702418],
            [22.967545829400144, -6.034627225435548],
            [22.975353359723961, -6.028545980927901],
            [22.976278185190456, -6.025328860880538],
            [22.973993279841086, -6.018885004888144],
            [22.970863573645744, -6.015071613891208],
            [22.963217399611569, -6.005755017836669],
            [22.960325795475537, -5.996875090526047],
            [22.958646480391806, -5.991717954735155],
            [22.958158319696768, -5.991080948827569],
            [22.956773305276521, -5.989271165683708],
            [22.951771200110294, -5.982734916984683],
            [22.948618320075568, -5.948006018120767],
            [22.950634733359532, -5.944990279989303],
            [22.951843200080322, -5.943182896172844],
            [22.952596788687334, -5.940859300882635],
            [22.954153320241389, -5.936059898898811],
            [22.958259712542858, -5.931323676961195],
            [22.965894360293639, -5.922517935310643],
            [22.986398159616968, -5.890827941028147],
            [22.987487681309315, -5.887398587067604],
            [22.987785213212856, -5.886461901304788],
            [22.987472312931402, -5.885411489712268],
            [22.986414359834789, -5.881859909502778],
            [22.985305917825944, -5.880157637572618],
            [22.984947359771848, -5.879606987207416],
            [22.978166399900214, -5.869193983534648],
            [22.966924320089369, -5.860660888607647],
            [22.956560323705819, -5.849085288688593],
            [22.954546393365298, -5.846835908942832],
            [22.950225719630865, -5.841175922712788],
            [22.950247319621869, -5.837263715461765],
            [22.95091727956753, -5.83108724419452],
            [22.952378519632848, -5.825747812854916],
            [22.955280839771927, -5.818655385734676],
            [22.959133200189164, -5.812404479020424],
            [22.966372440094585, -5.797770047226219],
            [22.970540879931068, -5.791854020234267],
            [22.974705359993777, -5.786753044515419],
            [22.976480880152828, -5.78207428458357],
            [22.980471120288094, -5.779740090244332],
            [22.989382559721836, -5.779337190551632],
            [22.989564705722103, -5.779323146953577],
            [22.995589680281572, -5.778858622966261],
            [23.006887920069019, -5.778359615288172],
            [23.022649080019491, -5.776354791690448],
            [23.034749040146902, -5.774736725931107],
            [23.045728319618011, -5.774391738480543],
            [23.056113599785562, -5.77351994646457],
            [23.064979320361257, -5.774278058006592],
            [23.072941439965682, -5.772870314284052],
            [23.077888920376104, -5.770073823832254],
            [23.079660840087524, -5.766047075409936],
            [23.082557040004573, -5.760095029625841],
            [23.083724880416632, -5.750181149908132],
            [23.083744319959386, -5.746594300163745],
            [23.079945599744402, -5.743063733320111],
            [23.075028720444099, -5.74031712440786],
            [23.074579799957274, -5.735086568733311],
            [23.07635171966869, -5.731059569396666],
            [23.078586959860903, -5.729654406766755],
            [23.085595799862233, -5.72805682966275],
            [23.094189719877349, -5.727482101385504],
            [23.101507079974819, -5.727686708365337],
            [23.108183280114645, -5.728688938941945],
            [23.116134239948291, -5.729400667380783],
            [23.124560399584087, -5.730451669826281],
            [23.129170559910399, -5.73106997005754],
            [23.133306600209533, -5.731185631619907],
            [23.137442280284237, -5.731301294058353],
            [23.147301959772353, -5.732066455773334],
            [23.157637919735858, -5.733007889029428],
            [23.167654560056917, -5.734103536534565],
            [23.174812799771491, -5.734303837443983],
            [23.195639159858825, -5.737006363121592],
            [23.205017880445499, -5.738410251317645],
            [23.217899760247313, -5.739259863540655],
            [23.228397360368113, -5.73971676685108],
            [23.238258119631208, -5.740318737703002],
            [23.242552920088805, -5.74043888093907],
            [23.255592839600247, -5.741455972853157],
            [23.264499959934113, -5.741868403164535],
            [23.272613280373925, -5.741932240164465],
            [23.277862440209589, -5.742079101767573],
            [23.282001000283085, -5.741705762205538],
            [23.290758720005414, -5.740320172842847],
            [23.297616360069721, -5.737250775570081],
            [23.306400720230101, -5.730974032749252],
            [23.312160000077956, -5.72978997469675],
            [23.320660830375118, -5.725670139589777],
            [23.33168999958216, -5.726840128092271],
            [23.334228331351255, -5.72408197750303],
            [23.337669960461039, -5.72428997796175],
            [23.347498198914209, -5.724893559743054],
            [23.3531465143666, -5.725237382670391],
            [23.35479083378177, -5.724580847168963],
            [23.358800160421868, -5.722980020003427],
            [23.365680120027726, -5.724140063197529],
            [23.367237643321843, -5.72332403305529],
            [23.374879919565977, -5.719320011776522],
            [23.381550000382077, -5.713810050113509],
            [23.393842599730583, -5.713838743461271],
            [23.39438015968144, -5.713839907823766],
            [23.402360160251586, -5.707790024336348],
            [23.402373431961607, -5.707788006026447],
            [23.407808849386591, -5.706961317205313],
            [23.412414179471639, -5.706260092978996],
            [23.420683068355693, -5.699533668431097],
            [23.421990160213216, -5.698469849634731],
            [23.423831279845906, -5.698221513291263],
            [23.426357616411021, -5.696641427587056],
            [23.425179204624659, -5.698468356798708],
            [23.42512008020763, -5.698559912002736],
            [23.422209839622706, -5.703069899472911],
            [23.416919999579381, -5.706509976201111],
            [23.416153393485597, -5.708675091674352],
            [23.415779880278652, -5.709729996543222],
            [23.418059660739289, -5.715930506003414],
            [23.414150907681794, -5.719849345915246],
            [23.412224515470765, -5.720640021860855],
            [23.410249719337262, -5.721450563478933],
            [23.409560159948764, -5.72329007005278],
            [23.412539879831023, -5.724900034695436],
            [23.413286731073406, -5.726499635388326],
            [23.414370119967298, -5.728820023437803],
            [23.414283083097725, -5.728994706440447],
            [23.412996942647574, -5.731569287932748],
            [23.409290458750995, -5.730797096387673],
            [23.407480080365676, -5.730419930634221],
            [23.405931373137737, -5.73118866300833],
            [23.400591134013723, -5.733845574664057],
            [23.400949808848775, -5.735694777325016],
            [23.401039796684049, -5.736158720715903],
            [23.395476919100034, -5.743794019308067],
            [23.393679998375966, -5.746260350800838],
            [23.394413620129125, -5.747634408562687],
            [23.396359927091712, -5.75127977903811],
            [23.392180080447751, -5.754530059525236],
            [23.391923810860117, -5.756594344644082],
            [23.391820079699315, -5.757429912211018],
            [23.393352507657653, -5.759717513738737],
            [23.393890080184939, -5.76051999854419],
            [23.388368818853053, -5.768330005450628],
            [23.382159839679023, -5.768089949530045],
            [23.381470079966206, -5.76946991270053],
            [23.390972502160761, -5.779510376904526],
            [23.394549581045723, -5.783289949581736],
            [23.397997274681977, -5.781916872696232],
            [23.403790439880677, -5.775400700146189],
            [23.406879599717357, -5.772542719117852],
            [23.416899480261648, -5.766228896113642],
            [23.419231200413726, -5.761878463092661],
            [23.421961800399714, -5.755203740808486],
            [23.424699959708814, -5.747377552407944],
            [23.429327400027919, -5.744049977332475],
            [23.439685320206873, -5.744623074512467],
            [23.448502800353506, -5.746049537695299],
            [23.457322800274465, -5.747092081862288],
            [23.465768759677452, -5.746620838706702],
            [23.472300599652819, -5.74548899460429],
            [23.478465960229919, -5.741691954304637],
            [23.483889359993032, -5.734099411924094],
            [23.491684799891448, -5.716014866176654],
            [23.494817159710145, -5.706631202831262],
            [23.498351280259914, -5.694539107837952],
            [23.504562359695058, -5.683832308032691],
            [23.510206280589077, -5.68228198854478],
            [23.519623319712508, -5.682755931866041],
            [23.527429199831161, -5.685987923003685],
            [23.531998762594842, -5.686085833237332],
            [23.538912479990724, -5.686233970958619],
            [23.547416431933499, -5.680957007281621],
            [23.552009279927645, -5.681193909354387],
            [23.553188655606299, -5.681470265135518],
            [23.561884440083041, -5.683507888933434],
            [23.566702311564281, -5.688344915115191],
            [23.571525239662282, -5.68812201060563],
            [23.576803200384258, -5.691578855913887],
            [23.58093816001012, -5.692275028551244],
            [23.589899279872341, -5.687917927431104],
            [23.604969240110613, -5.668109506685548],
            [23.611747477188615, -5.659199905409778],
            [23.612148677370929, -5.659046838182463],
            [23.615503200440859, -5.657767006907813],
            [23.630359320319009, -5.652095933068367],
            [23.638000320057166, -5.64338520810478],
            [23.647608359874589, -5.641314084099041],
            [23.659891199925866, -5.641012418083327],
            [23.665291200372451, -5.636873554378283],
            [23.675707800302401, -5.628617258719112],
            [23.683002479735595, -5.628210126081324],
            [23.691832559652347, -5.627717441872146],
            [23.709096000100267, -5.628672858597437],
            [23.725192679911039, -5.631995729224085],
            [23.742276804950144, -5.633757272392412],
            [23.742718719476077, -5.633799302431975],
            [23.745670062476819, -5.634079820896701],
            [23.750709840291126, -5.642589974529321],
            [23.750939879970776, -5.646040101857984],
            [23.749019999647235, -5.648550071018742],
            [23.747950580454305, -5.64994939782011],
            [23.747181318940534, -5.650167981466509],
            [23.744739960306376, -5.650860057921573],
            [23.74318141742442, -5.652167059584968],
            [23.730490080175809, -5.662809965696797],
            [23.725483151954794, -5.67399735800725],
            [23.72473007987908, -5.675679990116612],
            [23.72496958600518, -5.677117350145092],
            [23.725649880169847, -5.68120000686182],
            [23.728257402877077, -5.682736984291277],
            [23.732300160320488, -5.685119939216629],
            [23.73511230397807, -5.689228568556442],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kisangani",
        AREA: 199567,
        POPULATION: 2352000,
        DISTRICTS: [],
        OBJECTID: 25,
        NOM: "Tshopo",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [23.59907575375593, 2.20184318270975],
            [23.593958413603371, 2.191128264750935],
            [23.612758599312876, 2.191755009975768],
            [23.618879280382675, 2.191959146533105],
            [23.624025922681522, 2.190805803080153],
            [23.626894319740508, 2.190163005029919],
            [23.631858920243616, 2.190117279616997],
            [23.636984244622443, 2.19007007484564],
            [23.648611319906159, 2.191435054399689],
            [23.6559355197762, 2.190325095362829],
            [23.664863519652197, 2.188763983698311],
            [23.680225440442651, 2.181256106589124],
            [23.686863321147424, 2.180142024447683],
            [23.698091159966047, 2.176063047362998],
            [23.712333479875209, 2.164407144700469],
            [23.717364674286983, 2.162482512907747],
            [23.722416360168676, 2.160550039791505],
            [23.731615440156421, 2.150937132020597],
            [23.742168479804988, 2.144553107247052],
            [23.746946372662833, 2.142067499184711],
            [23.75661419985401, 2.137037984604346],
            [23.766494400456455, 2.128349061147518],
            [23.773830479647813, 2.125167991287631],
            [23.786159800328466, 2.124575994142243],
            [23.799675240340619, 2.123927043985165],
            [23.804308623913659, 2.124824063380541],
            [23.824117661704662, 2.128659028531151],
            [23.844696480235694, 2.128769072974125],
            [23.866886519755241, 2.126815981298949],
            [23.874623075985081, 2.124771831764659],
            [23.876276400112694, 2.124334990299956],
            [23.882700404524719, 2.120227894847675],
            [23.888440012166171, 2.111232394981033],
            [23.890308480109361, 2.108303994941322],
            [23.893100279620707, 2.098885997680173],
            [23.89578709482144, 2.094213387598171],
            [23.899563359849282, 2.087646103321072],
            [23.903925480054262, 2.084448018134267],
            [23.911757899999657, 2.082878419509085],
            [23.913995400353169, 2.082430029604718],
            [23.918535107608353, 2.079128136146287],
            [23.919962269185085, 2.078090108867451],
            [23.930475480228907, 2.079294974079137],
            [23.946270479716141, 2.075696118386889],
            [23.960209319976208, 2.077379103655718],
            [23.961115114633394, 2.078301511644404],
            [23.961572279857883, 2.078767060742623],
            [23.962547366962813, 2.086311676752284],
            [23.962673159848695, 2.087284977477958],
            [23.96674832671092, 2.092066353245582],
            [23.971536359751671, 2.097684113817917],
            [23.971782240323037, 2.0987311013596],
            [23.974891199926912, 2.111965993659739],
            [23.978540520428687, 2.114055987465806],
            [23.983223940163054, 2.114770032263676],
            [23.98790735989742, 2.115484075824781],
            [23.993689515343991, 2.119580683449308],
            [24.000665399750808, 2.124523023258917],
            [24.012083519712945, 2.127803154048128],
            [24.02399232014448, 2.123952079386809],
            [24.03222227963742, 2.124224043604316],
            [24.036431476936645, 2.129195762395552],
            [24.040634400401945, 2.134160053412346],
            [24.043273763894426, 2.135060546144001],
            [24.047481240021579, 2.136496042591565],
            [24.052973760654226, 2.135603072481495],
            [24.058466280388576, 2.134710100941791],
            [24.068251800356709, 2.140936934599765],
            [24.079289400252712, 2.149077364081168],
            [24.085681560286201, 2.154313382345749],
            [24.076441800090862, 2.163124266474636],
            [24.068936160296374, 2.170758306483198],
            [24.060842999848191, 2.176055663160107],
            [24.057397439710705, 2.184842105697672],
            [24.058019879676142, 2.197120092310971],
            [24.063832799726242, 2.202358642685984],
            [24.065585279894904, 2.206444724290199],
            [24.058054799886175, 2.207061381433857],
            [24.059805479830988, 2.210562851022745],
            [24.066189360092526, 2.213459725864042],
            [24.075468359597846, 2.21575957066544],
            [24.085306079768817, 2.212209307207242],
            [24.094560239958192, 2.207491816871558],
            [24.104404080351184, 2.205695694314085],
            [24.115427639579288, 2.209742684834922],
            [24.13340208040486, 2.213175351316716],
            [24.151955760315584, 2.216605488466763],
            [24.161236560044685, 2.219490283564447],
            [24.17224752040093, 2.22002841341235],
            [24.195455280170489, 2.228702033048822],
            [24.202437120407627, 2.236859629169514],
            [24.203624759688577, 2.245041672281346],
            [24.210606599925715, 2.25319917614982],
            [24.215266800006606, 2.26019702239944],
            [24.224549760183994, 2.263666488040243],
            [24.236138160299806, 2.263617323823087],
            [24.253512479803231, 2.26120463609104],
            [24.263937719729565, 2.259990997739454],
            [24.266255400112072, 2.259981272586806],
            [24.273208440361199, 2.259951737473035],
            [24.28017372015611, 2.263431108664876],
            [24.294108599744078, 2.271559153760054],
            [24.304554720110914, 2.27619323340182],
            [24.310365479712761, 2.280847106714175],
            [24.319636200344398, 2.28080784792553],
            [24.331211999791691, 2.27724999954863],
            [24.336997920077632, 2.274886500506365],
            [24.347378159798133, 2.260807534407189],
            [24.351976439904828, 2.250261860423501],
            [24.356586960455569, 2.243224884929699],
            [24.364686600451883, 2.239681891707828],
            [24.370488720057317, 2.241996463662348],
            [24.390222119701416, 2.251269660918237],
            [24.40995120024564, 2.259373102505895],
            [24.425015759812428, 2.259309530233238],
            [24.440117760261945, 2.269771755081642],
            [24.445936799635742, 2.276764657685289],
            [24.448271040460508, 2.281433117539271],
            [24.457545719967584, 2.28256335675416],
            [24.488169673380476, 2.280903452494429],
            [24.574567679978081, 2.276220426831864],
            [24.585095691664549, 2.275679271783536],
            [24.698542320013303, 2.269847932812203],
            [24.738175022863114, 2.268225506217938],
            [24.825997799722145, 2.264630337148414],
            [24.844534920088908, 2.263382304094106],
            [24.855257160116171, 2.264213965994612],
            [24.861630960381916, 2.26418713289359],
            [24.863740972728582, 2.266315681028531],
            [24.863249160381912, 2.268087005364557],
            [24.861187439668274, 2.275510151582849],
            [24.863455439622271, 2.28058111563603],
            [24.866647156521712, 2.282664120098417],
            [24.869634479744537, 2.279225042366515],
            [24.873306040736122, 2.27739727391008],
            [24.876968400284234, 2.275574083689303],
            [24.879503519677876, 2.270751987758981],
            [24.878886132735946, 2.26771105736879],
            [24.878381399920524, 2.265224998992818],
            [24.879310380993491, 2.2620078458613],
            [24.88734827978033, 2.253987081492581],
            [24.888421313793952, 2.251437067930715],
            [24.891504480071063, 2.244110046526788],
            [24.896082358539342, 2.240683754360439],
            [24.897009240249499, 2.239990032993623],
            [24.899517359878942, 2.241611061888578],
            [24.902460360225646, 2.249446038881579],
            [24.905654137860328, 2.249458980243118],
            [24.907612148972728, 2.251574848367711],
            [24.912264239961555, 2.256618052932456],
            [24.917997597125268, 2.25829132705169],
            [24.91866128772855, 2.258485024259389],
            [24.919703981143435, 2.260229361554186],
            [24.9225213601825, 2.264943155818977],
            [24.924841757968728, 2.265887202320447],
            [24.925947450234492, 2.266337049702178],
            [24.933973319681368, 2.260847154305313],
            [24.941749320037026, 2.260878129828383],
            [24.948211985243937, 2.265109702764253],
            [24.948820283930161, 2.265507999690708],
            [24.950884319602288, 2.264366143121104],
            [24.952972304359864, 2.25678100428448],
            [24.950023199960821, 2.250786111237041],
            [24.951612584701422, 2.248479993610528],
            [24.952553279805709, 2.247115090016699],
            [24.956440200208579, 2.247131118317898],
            [24.959863439906179, 2.249214978491958],
            [24.960996360108204, 2.251519990665701],
            [24.960762196263072, 2.254111588722207],
            [24.960518280307259, 2.256811111479444],
            [24.960636298274331, 2.257005846287029],
            [24.962335200224508, 2.259809105203406],
            [24.963404845792876, 2.259966899927953],
            [24.964470360009258, 2.260124085570604],
            [24.965161169852614, 2.260226440936455],
            [24.965536319790001, 2.260282025749117],
            [24.971739479677634, 2.253404121910418],
            [24.974714160011143, 2.252495013578353],
            [24.978813479876425, 2.257113126814029],
            [24.983528036116823, 2.259061662502634],
            [24.986120399753631, 2.260133090508043],
            [24.989782320025601, 2.259457025130736],
            [24.991734420223434, 2.257278541482475],
            [24.993686520421267, 2.255100053621914],
            [24.998899935393464, 2.257967600680589],
            [24.99916429431023, 2.258112997422713],
            [25.000000200038301, 2.258032137215685],
            [25.001728926055879, 2.257865189126613],
            [25.006027319774638, 2.257450079319986],
            [25.007700798503958, 2.258837947683143],
            [25.00853544030241, 2.259530142724909],
            [25.01080127980816, 2.264831138926493],
            [25.011288404745706, 2.265017204799621],
            [25.012628279721202, 2.265528992456772],
            [25.014919319665623, 2.264387033791071],
            [25.015496958851212, 2.262884991314981],
            [25.017923334484749, 2.256576016533907],
            [25.023191400263897, 2.25429503989091],
            [25.023401279951955, 2.259127997266261],
            [25.02590345632747, 2.262358929478886],
            [25.026078970964331, 2.262263519759291],
            [25.028425439656722, 2.260987986388829],
            [25.030195550161149, 2.256841774423872],
            [25.032348360044569, 2.251799134529577],
            [25.03331134684263, 2.251030840169932],
            [25.034643359762761, 2.249968128430583],
            [25.036697520254997, 2.250896148398721],
            [25.03827958642098, 2.253840326130724],
            [25.039423291796322, 2.255968723365482],
            [25.041362832648169, 2.255586140230746],
            [25.041712164105942, 2.255517178365337],
            [25.044714359836615, 2.247936136058474],
            [25.046547479971718, 2.247253041660028],
            [25.049284096873468, 2.248642950403489],
            [25.050067140340342, 2.252115830900704],
            [25.050634200066781, 2.254631093013035],
            [25.051677334554508, 2.255795092475964],
            [25.052910230959462, 2.257170838959327],
            [25.056647700445122, 2.256906665243791],
            [25.059087360365101, 2.25673403210696],
            [25.061643996206421, 2.254988929679368],
            [25.063444440123035, 2.253759985287767],
            [25.068304439896156, 2.239053001842288],
            [25.069024745023579, 2.238766118288996],
            [25.071739199588968, 2.237685003299438],
            [25.081574138575824, 2.226403562374752],
            [25.082535087096502, 2.225301275832443],
            [25.086654360340848, 2.224626999696437],
            [25.089700850201567, 2.221416821047497],
            [25.090788179106294, 2.220271069075037],
            [25.093990440430503, 2.219593118951519],
            [25.095598200210269, 2.217758110404792],
            [25.096540320042582, 2.210629127459898],
            [25.097978859680683, 2.209480716513051],
            [25.098835204776414, 2.208797081703695],
            [25.107067439701932, 2.209058132000365],
            [25.111960355543729, 2.21100649643526],
            [25.112318278488878, 2.211149040431088],
            [25.116580534780397, 2.221914158049714],
            [25.118822126959991, 2.227575706828259],
            [25.11884902970613, 2.227643655198559],
            [25.118887230563601, 2.22774013896913],
            [25.120957688291675, 2.229606087635536],
            [25.121911353272022, 2.230465554329164],
            [25.122989451987209, 2.231437136705643],
            [25.122520401153192, 2.234656923658093],
            [25.123158349633684, 2.235789514056454],
            [25.123531539447104, 2.236451923416675],
            [25.124338350539748, 2.237884006016928],
            [25.125900352833863, 2.247784990078127],
            [25.126526580096524, 2.248657931341365],
            [25.129541069271873, 2.252860059281505],
            [25.137991283096017, 2.256343009905601],
            [25.13825453977994, 2.256569864424887],
            [25.142549308796507, 2.260271039094032],
            [25.146093945024965, 2.26247567539187],
            [25.147010445803691, 2.263045704505219],
            [25.149622228321991, 2.264670135864077],
            [25.155565107644254, 2.265382036762399],
            [25.164224187856824, 2.273928059429513],
            [25.165890365079505, 2.276780628724761],
            [25.166426765305342, 2.277698967711514],
            [25.167860187241242, 2.280153041533698],
            [25.168425505134376, 2.282907516119159],
            [25.168793800926146, 2.284702005420495],
            [25.169656226718025, 2.288904095907084],
            [25.17107345921594, 2.290657898575016],
            [25.17147367484467, 2.29115315851802],
            [25.171707146987032, 2.291442076487314],
            [25.17452290366867, 2.292563347257761],
            [25.17521079488569, 2.292837274525119],
            [25.17695810614822, 2.2935330756965],
            [25.180396511204417, 2.297575392124303],
            [25.182651154108473, 2.300226029961856],
            [25.188133225537783, 2.302087033332205],
            [25.192005417163241, 2.306473038750066],
            [25.211439239439837, 2.308155030080189],
            [25.249244333318838, 2.28942400951497],
            [25.254002359035844, 2.289362967866981],
            [25.263197145974832, 2.289245004248956],
            [25.282673178290008, 2.279420077741008],
            [25.283753516505193, 2.27926860977549],
            [25.283925664256369, 2.279244473432891],
            [25.285875354274289, 2.278971126387508],
            [25.289377083371516, 2.280571290319343],
            [25.29053948987443, 2.281102475416087],
            [25.295009297420766, 2.28314504204008],
            [25.303441336530099, 2.284306478103856],
            [25.304386643585048, 2.284436685566978],
            [25.305296230929347, 2.28456196817445],
            [25.311933276200886, 2.282974982036831],
            [25.313423455493098, 2.281486349342466],
            [25.317901336198883, 2.277012999467213],
            [25.325291407732053, 2.274793843230165],
            [25.326202117072157, 2.274520372433204],
            [25.327745192761558, 2.274057015388183],
            [25.329007256565468, 2.274273023324915],
            [25.329233470320315, 2.274311740105466],
            [25.33323117725222, 2.274995979168037],
            [25.333583300673908, 2.274688529463502],
            [25.333877258180973, 2.274431861067867],
            [25.334282413645472, 2.27407807399468],
            [25.338737399887929, 2.270183903665045],
            [25.3397360884303, 2.266712498339905],
            [25.340126232148105, 2.265356194990896],
            [25.344499628904853, 2.259738957039673],
            [25.346557299114881, 2.257095986220621],
            [25.346681509169212, 2.254446685814861],
            [25.34680537337216, 2.251803995326323],
            [25.349758452816364, 2.248327397306571],
            [25.351864263742446, 2.245848265374333],
            [25.353235332716217, 2.244234129887402],
            [25.36194841245711, 2.238282014984523],
            [25.369955171144632, 2.237159124732806],
            [25.375879976363393, 2.233098661557688],
            [25.379202108879145, 2.230821889655472],
            [25.381647204504894, 2.229146204305636],
            [25.382341303978823, 2.227973289378864],
            [25.384636330646494, 2.224094993068997],
            [25.397680209931707, 2.221609120684102],
            [25.399252851872077, 2.220486605220959],
            [25.399928532289419, 2.220004319452983],
            [25.402494128825719, 2.218173052669977],
            [25.412790128132141, 2.216598102659614],
            [25.414260200433358, 2.215374367067897],
            [25.415542281396757, 2.2143069887761],
            [25.414719986941872, 2.212636531239263],
            [25.413685514010126, 2.210535037329706],
            [25.413046087801007, 2.209236066426721],
            [25.41534036796866, 2.206713068686262],
            [25.419304591994951, 2.206402951219175],
            [25.419556031341294, 2.206383281501901],
            [25.423803284869255, 2.206051025361665],
            [25.425494613123234, 2.206057079182603],
            [25.426319248587756, 2.206060031538605],
            [25.436405045710963, 2.199192135941756],
            [25.445234938778189, 2.1988113172388],
            [25.445473737031843, 2.198801017830324],
            [25.451271203364112, 2.198550986270002],
            [25.456255673703019, 2.200450848042479],
            [25.456752253408919, 2.20064012125136],
            [25.460825521232614, 2.200023922296781],
            [25.461503161773923, 2.199921409962439],
            [25.46270213779378, 2.199740033140431],
            [25.464057526674214, 2.20058606862668],
            [25.46467030975035, 2.200968637324484],
            [25.465667322036399, 2.201591060520698],
            [25.471613007695627, 2.2018410328245],
            [25.478254361287277, 2.199102090919109],
            [25.483794863634191, 2.199483579184307],
            [25.488769140789564, 2.199826077470388],
            [25.49769936040266, 2.196405094399256],
            [25.499212047882615, 2.196219966804709],
            [25.500363921638829, 2.196078996503357],
            [25.506851279736253, 2.1952850538424],
            [25.51189631898319, 2.191160039725291],
            [25.513862202930753, 2.187906096620181],
            [25.518078372953216, 2.180927439733725],
            [25.519943037429499, 2.177841014316584],
            [25.52244137889711, 2.176556729724825],
            [25.524250699067043, 2.175626639194165],
            [25.527502317426237, 2.173955127524335],
            [25.533735569079241, 2.173218548677164],
            [25.534840787932868, 2.17308794626481],
            [25.540771163604692, 2.172387166589595],
            [25.541471204535924, 2.172712764523405],
            [25.542594104929286, 2.173235082960937],
            [25.546251115908216, 2.174936145828667],
            [25.555011718324291, 2.175943921396392],
            [25.555607026473194, 2.176012401725657],
            [25.564766232940411, 2.177066024381909],
            [25.569574125037157, 2.175011086821545],
            [25.57819764903245, 2.176395246986507],
            [25.580356686935747, 2.176741796517968],
            [25.584202271360812, 2.177359044434112],
            [25.587412108177837, 2.17529816991004],
            [25.588415537129993, 2.175495639361084],
            [25.588832168572246, 2.175577629255069],
            [25.593351316085528, 2.176466996008039],
            [25.596101164273122, 2.174866075825196],
            [25.598650190485664, 2.174676978254764],
            [25.600432114734385, 2.174544418535496],
            [25.600548378291723, 2.174535770035517],
            [25.602049310417897, 2.174424114913814],
            [25.606994312376465, 2.167692082390578],
            [25.62395606980585, 2.173044888982685],
            [25.641877501944865, 2.173212923984209],
            [25.659799425462328, 2.178494964033595],
            [25.67900218218325, 2.1914595464556],
            [25.693084301934505, 2.199262373784764],
            [25.704606100955147, 2.208319365649361],
            [25.720315834152249, 2.21920066341257],
            [25.728929858463399, 2.225167105799218],
            [25.740450936136874, 2.226553486105008],
            [25.751973455606386, 2.242002584205216],
            [25.762215841660041, 2.258078649388819],
            [25.777577585482362, 2.264614484351481],
            [25.792299781823033, 2.274340461639469],
            [25.807021259511455, 2.278313603695582],
            [25.81086137858631, 2.275153748719511],
            [25.820460775712423, 2.264377483977109],
            [25.831341774101556, 2.265118739298188],
            [25.840302531044383, 2.265202842316788],
            [25.849903008843771, 2.26273613044436],
            [25.863982965451846, 2.253919361179769],
            [25.879983882158406, 2.251512781250548],
            [25.894065638990263, 2.255479862651616],
            [25.9080789954015, 2.232398128276851],
            [25.909223149934455, 2.23194090353747],
            [25.916122114298439, 2.218844990351052],
            [25.921392151879651, 2.215178029850695],
            [25.926360037521778, 2.21553307122623],
            [25.931451990386098, 2.215896979464646],
            [25.953211105368908, 2.20399213377988],
            [25.958243903273466, 2.20285606930356],
            [25.965774021261129, 2.208168079995172],
            [25.967496931585565, 2.211218622528998],
            [25.967595981625426, 2.211393997451529],
            [25.967559734603711, 2.211517742915358],
            [25.96597994117538, 2.216911107043376],
            [25.970992940211076, 2.223598102325294],
            [25.97166218060616, 2.230042118307934],
            [25.972709397038532, 2.230950306372672],
            [25.976451979734804, 2.234196018068059],
            [25.979323248707743, 2.238891106682208],
            [25.979411898951572, 2.239036067070652],
            [25.981219320082978, 2.245058461492365],
            [25.985079017041176, 2.257919032682021],
            [25.990534081519748, 2.270129015951741],
            [26.012698930482088, 2.277091153987493],
            [26.013580068181376, 2.276871929499058],
            [26.016360849855758, 2.276180079925159],
            [26.02641813085857, 2.277587300628534],
            [26.039436123392257, 2.284755031974507],
            [26.053612964202024, 2.285482038020002],
            [26.065972340715469, 2.281787061822887],
            [26.0696350757594, 2.280692044206923],
            [26.087478111025224, 2.279128147280252],
            [26.09867439023132, 2.283068180964661],
            [26.105075986168586, 2.284005141741401],
            [26.111927144888099, 2.287934134768189],
            [26.113974824933841, 2.291619998014905],
            [26.112342641758122, 2.296510152416163],
            [26.112133099836637, 2.29713795700856],
            [26.113494944909046, 2.300822999213621],
            [26.125686974268241, 2.310766153256627],
            [26.127645101263301, 2.312363088614669],
            [26.137244916105999, 2.315149059219014],
            [26.146369775488328, 2.323916048887578],
            [26.150075502105118, 2.325790949980797],
            [26.153681013567113, 2.327615144094628],
            [26.156973929276571, 2.328153875551001],
            [26.165111010155609, 2.329485127264801],
            [26.166022066245429, 2.328635751490333],
            [26.171758048286396, 2.323288096350356],
            [26.174501838235699, 2.322704206583464],
            [26.174962868910864, 2.322606053042334],
            [26.190082117912148, 2.312749006155837],
            [26.193056004134952, 2.312526072413148],
            [26.194359922244594, 2.315946060307549],
            [26.196918080730295, 2.322660144433815],
            [26.204224999709236, 2.327740121946057],
            [26.213118796230784, 2.338346083906436],
            [26.217685311010715, 2.341578027036852],
            [26.226096170540579, 2.342127486979112],
            [26.228661787738115, 2.342295075669808],
            [26.239928349335386, 2.343119865066306],
            [26.246026387470177, 2.343587176048834],
            [26.256578343750512, 2.347862836849063],
            [26.262151862777376, 2.357355034009816],
            [26.271341580523206, 2.362561840277006],
            [26.283734065344774, 2.36313288583847],
            [26.289021175407957, 2.363376515390779],
            [26.298769611124545, 2.363162942858835],
            [26.316897766271651, 2.364362085870767],
            [26.326608403576035, 2.318098610136727],
            [26.32663108334199, 2.305486516267328],
            [26.318325885452484, 2.296162527312086],
            [26.313171407149426, 2.269971106681667],
            [26.313207046910001, 2.250001257617109],
            [26.328830681977031, 2.23923723027642],
            [26.329895561982795, 2.225556468247913],
            [26.327832042841965, 2.216130563730218],
            [26.316399884906922, 2.210009942394675],
            [26.325434802268028, 2.134983135966617],
            [26.32409596215172, 2.120944977854196],
            [26.325933262147817, 2.117038053484488],
            [26.33119408031925, 2.117050119369853],
            [26.330863096951159, 2.11007968194632],
            [26.330757084069532, 2.107846128468459],
            [26.331715496646137, 2.107410231108858],
            [26.333274879452915, 2.106701005295526],
            [26.336491839011828, 2.099345994256039],
            [26.340384877840059, 2.097284078218231],
            [26.34221979730065, 2.094528008097108],
            [26.341804168378253, 2.087781852765068],
            [26.356184912384489, 2.06851602555205],
            [26.368678348979373, 2.063057452847223],
            [26.397812778870197, 2.059431001825499],
            [26.424849489859028, 2.065298987850813],
            [26.435216767788308, 2.085102541275758],
            [26.444566323670951, 2.092308666275013],
            [26.45806991939607, 2.103651910508106],
            [26.471574955120609, 2.113943951010177],
            [26.475212753830547, 2.115724333666784],
            [26.482499871245672, 2.112978202550231],
            [26.486162510169851, 2.100830831220851],
            [26.488269589517131, 2.08608073482391],
            [26.493510828008631, 2.063921465540773],
            [26.494375821185582, 2.058720314403111],
            [26.495614306908241, 2.051273346501988],
            [26.503944344113684, 2.046933423597834],
            [26.564014282920898, 2.050425716061125],
            [26.575350130677734, 2.052004322665998],
            [26.584294309211991, 2.053249879883873],
            [26.599872884784347, 2.06771324689996],
            [26.603985162847593, 2.094976119760279],
            [26.599812405707858, 2.101350806605032],
            [26.597195566572829, 2.110327879157225],
            [26.602646324527917, 2.116283207493413],
            [26.614862306565847, 2.120552148426935],
            [26.622144273041112, 2.120434003151694],
            [26.62658343096825, 2.110376329081644],
            [26.626348127161037, 2.096715556216061],
            [26.642202022893237, 2.102502076565828],
            [26.654293661027836, 2.113334423167277],
            [26.663233930992323, 2.121343552264429],
            [26.705551186186646, 2.16270064753598],
            [26.719054418992407, 2.17404336484906],
            [26.735160089142564, 2.184555550409199],
            [26.740872926090248, 2.189455375233126],
            [26.745547523470183, 2.193058103623842],
            [26.752024112564005, 2.193771123156094],
            [26.755948658902536, 2.194203169255935],
            [26.763751272746802, 2.193813802994467],
            [26.769476349240207, 2.191881507951654],
            [26.774701025492817, 2.178920891976111],
            [26.772901746691137, 2.167125611969405],
            [26.77500162514308, 2.156317752657678],
            [26.780474701741419, 2.149922403533947],
            [26.788798977152648, 2.148736048847832],
            [26.796619251875384, 2.138623629594178],
            [26.800797049462201, 2.129358730522242],
            [26.809123077486536, 2.12738407641978],
            [26.815359400479515, 2.130436135145357],
            [26.821315596427546, 2.144529318425699],
            [26.826247234149626, 2.149967609633445],
            [26.836908902573935, 2.150582837925138],
            [26.847053780096747, 2.149367138011109],
            [26.855383197464661, 2.145553067930114],
            [26.859283332085337, 2.146015191363784],
            [26.861100971553125, 2.147562300202439],
            [26.8644727297001, 2.152763202363443],
            [26.868613087302489, 2.164257822853445],
            [26.868899010277644, 2.173089243089215],
            [26.874373832302574, 2.171816301395873],
            [26.874589840297496, 2.171766052343371],
            [26.8817091578074, 2.170109920235932],
            [26.886299155447155, 2.159310006278211],
            [26.892729110299623, 2.150639942434153],
            [26.893367834026208, 2.149790761614851],
            [26.893423258282592, 2.149717075536806],
            [26.89363919081903, 2.149429994773704],
            [26.89363608174984, 2.149313036531062],
            [26.893604489797916, 2.148124302759817],
            [26.893418870910768, 2.141139897827261],
            [26.895029149566565, 2.136309975828302],
            [26.896991621712687, 2.134183491747959],
            [26.897225156737075, 2.133930438136432],
            [26.897779187298681, 2.133330102934728],
            [26.899278258115565, 2.133246349357793],
            [26.899309034397191, 2.133244629551332],
            [26.901897192121861, 2.13310002843617],
            [26.901449054965937, 2.127580351993939],
            [26.90467747612955, 2.126098134683067],
            [26.906328007394951, 2.125340543998018],
            [26.906939105231597, 2.125059916735792],
            [26.910608858812822, 2.117469945425426],
            [26.915869080502915, 2.117250041976019],
            [26.916374779905585, 2.115155282563033],
            [26.91908901258709, 2.103910001223024],
            [26.923219764504147, 2.094260261876679],
            [26.926869841387383, 2.095309591565459],
            [26.926977144249776, 2.095340434974483],
            [26.928019031875863, 2.095639926359812],
            [26.92939875521904, 2.091960735491501],
            [26.929136423799893, 2.091105571683346],
            [26.92889826424841, 2.09033076609605],
            [26.927351111105921, 2.085289888555424],
            [26.927953093737386, 2.085252058861522],
            [26.927985896618296, 2.085249997379077],
            [26.931008964704592, 2.085060026471483],
            [26.931928799131349, 2.080462109769878],
            [26.930846698421554, 2.076921045471091],
            [26.930644918842425, 2.076261345721686],
            [26.929889005395459, 2.073789952734779],
            [26.926460639910854, 2.071251245706598],
            [26.928528926410909, 2.062969907733457],
            [26.932793679120568, 2.059696989854078],
            [26.93316123829381, 2.059414911874184],
            [26.93540534395958, 2.05769270500415],
            [26.935628941820315, 2.057142912935865],
            [26.935649997432247, 2.057090568776119],
            [26.935777416268778, 2.05677379877052],
            [26.936374875882795, 2.055346112821443],
            [26.936471491488216, 2.055115264831897],
            [26.936549000825874, 2.054930067646113],
            [26.934499162128514, 2.051479932120334],
            [26.938618470407182, 2.046428605544391],
            [26.938111690331201, 2.045105950029007],
            [26.937957035473577, 2.044702312945301],
            [26.93702887995234, 2.042279895398714],
            [26.938540371774689, 2.037017420400997],
            [26.938893179712633, 2.035789065828999],
            [26.941388837912477, 2.027100023153557],
            [26.937739159881186, 2.020890025439434],
            [26.938880101140391, 2.018950126259469],
            [26.939150907265955, 2.0184896849972],
            [26.940038838025394, 2.016979968164944],
            [26.937069808993328, 2.013521151596819],
            [26.936618840347652, 2.007539989580676],
            [26.938592764217006, 2.005100538603644],
            [26.938875487393098, 2.004751138011364],
            [26.940519077376294, 2.00271992104859],
            [26.941091553045599, 2.001073900230758],
            [26.94125410229795, 2.00060652705354],
            [26.942118916710182, 1.998119948979869],
            [26.945789114059174, 1.995589940653262],
            [26.95126903043008, 1.994679958220676],
            [26.952148989539676, 1.991039796534007],
            [26.952254961098806, 1.99060141760893],
            [26.952658953244999, 1.988930669611283],
            [26.954306867717957, 1.989031949572998],
            [26.95433440377635, 1.989033652364776],
            [26.956539280912004, 1.989169494290945],
            [26.956688878254571, 1.988997055898268],
            [26.959519291848419, 1.985729996153567],
            [26.960948675857136, 1.985867263677801],
            [26.961809000489577, 1.98594987364087],
            [26.962655126350626, 1.984847119179935],
            [26.966388792369408, 1.97997984444813],
            [26.970729684485914, 1.978838280319347],
            [26.974629053741992, 1.971020053137736],
            [26.974980496240676, 1.970712749132375],
            [26.975147112166326, 1.970567059376549],
            [26.978288811769044, 1.967819933049169],
            [26.982281304879031, 1.96717752560937],
            [26.982314994397143, 1.967172104440872],
            [26.982638698716524, 1.967120019465202],
            [26.982886347172343, 1.966697671685069],
            [26.98348341512089, 1.965678105456419],
            [26.984349047898345, 1.964199932101719],
            [26.984928810701238, 1.963210289286449],
            [26.984760073853209, 1.96281798387211],
            [26.984416106235972, 1.96201988216432],
            [26.982649129055286, 1.957919984896232],
            [26.983643392496585, 1.955931346392834],
            [26.983885052782728, 1.955447998586189],
            [26.98402882904227, 1.955160429649213],
            [26.999569117518902, 1.954720020163552],
            [27.007819006136415, 1.945299903637803],
            [27.015129025201372, 1.946459885033307],
            [27.028608730231518, 1.952919861318656],
            [27.02970591455324, 1.949970117425597],
            [27.029977728588513, 1.949239341928037],
            [27.031599014301513, 1.944879976201718],
            [27.034058925841258, 1.94222790869887],
            [27.034368275980682, 1.941894393319518],
            [27.03479883041155, 1.941430205621854],
            [27.039465064476179, 1.941309477445968],
            [27.044041803880674, 1.941191297196292],
            [27.047854524339389, 1.923965906643764],
            [27.048123244576825, 1.923847430514796],
            [27.053574118414605, 1.92144308158717],
            [27.060441116229207, 1.914781992122706],
            [27.073123936550608, 1.909039521934583],
            [27.074624477909637, 1.90836013933823],
            [27.089652593723653, 1.910838171458221],
            [27.092461303121894, 1.911301308279995],
            [27.092908006566617, 1.911374991817374],
            [27.09590947286528, 1.912086215261086],
            [27.103648281171544, 1.913920061404564],
            [27.106389449836851, 1.915764037799888],
            [27.110961447933263, 1.915310084487313],
            [27.136807136585773, 1.904300982531432],
            [27.140240093359779, 1.901315093599162],
            [27.142991391428257, 1.896028015226336],
            [27.14416133749134, 1.896116629511623],
            [27.144644814370512, 1.896153253325545],
            [27.144841249872009, 1.896168133698684],
            [27.149163046500551, 1.896495978213349],
            [27.152814413364549, 1.902021089687696],
            [27.158196418759385, 1.903183918258858],
            [27.16092182199143, 1.903772764716932],
            [27.16995318921057, 1.905723915905571],
            [27.172688197229654, 1.904941135482537],
            [27.179557282728979, 1.90297515189079],
            [27.187096217681155, 1.906204987655723],
            [27.192576617345697, 1.912422941640965],
            [27.198623777597714, 1.912035142696923],
            [27.204878046235109, 1.911634057834437],
            [27.210178847521519, 1.911294122596094],
            [27.212909998174798, 1.921189094023712],
            [27.215878195366887, 1.923033097728322],
            [27.219529312499258, 1.929479076275956],
            [27.218838113685358, 1.933388981609471],
            [27.224774148743467, 1.939607057570869],
            [27.22522630855519, 1.944669043977665],
            [27.2224719508249, 1.953177042740228],
            [27.224732029434726, 1.958429021659223],
            [27.228408081104433, 1.95962593535561],
            [27.242582813568209, 1.958262082578526],
            [27.246236972396122, 1.961717062199462],
            [27.242571095045342, 1.968154065042593],
            [27.243939093577431, 1.972067121308477],
            [27.248504970553491, 1.975983051449605],
            [27.246901171445828, 1.980582005105467],
            [27.240035256101155, 1.98563504000944],
            [27.238883258377445, 1.992995982561584],
            [27.235904981189528, 1.997593086914193],
            [27.236588260455882, 2.000355090470338],
            [27.234755334356883, 2.00334395179636],
            [27.232981476979429, 2.0040279256246],
            [27.228808306614631, 2.005636998473412],
            [27.226975187377889, 2.008856136257082],
            [27.227192987511788, 2.018519096483256],
            [27.22878706594976, 2.023812112198454],
            [27.23107018455001, 2.025885113048454],
            [27.244097134185388, 2.028891128830637],
            [27.247296092404298, 2.031885971681807],
            [27.251218288750053, 2.037256033684621],
            [27.253688247047936, 2.040635053104213],
            [27.253678715024435, 2.047996960000765],
            [27.266691076917919, 2.047192420249619],
            [27.272658431738424, 2.041652900942245],
            [27.286388099284586, 2.028427500935635],
            [27.29411765135016, 2.023771176483358],
            [27.313765449632509, 2.036509879685295],
            [27.326988866210421, 2.029025137213061],
            [27.328482864240893, 2.014808246063046],
            [27.333042260770494, 2.012238998102634],
            [27.346083969726017, 2.003882607601573],
            [27.357187079264087, 1.995518967781077],
            [27.358570918687896, 1.989059197856617],
            [27.358726438623162, 1.978069621207406],
            [27.356215440791512, 1.972888494381195],
            [27.357008159113995, 1.962547446218031],
            [27.365490112213784, 1.956760140760809],
            [27.378559180259575, 1.946463843855445],
            [27.381908978191106, 1.938071632219617],
            [27.382064497228043, 1.927081536879378],
            [27.391994727703604, 1.910308587233284],
            [27.399876561277839, 1.901286269346639],
            [27.407102834900421, 1.892907883598779],
            [27.409797433104767, 1.885159570621028],
            [27.401562439452995, 1.873491999868772],
            [27.395119525504267, 1.872175383066373],
            [27.383498537204883, 1.871486381215174],
            [27.373769955154408, 1.874036913528791],
            [27.36537037846449, 1.874006289194236],
            [27.349892875938025, 1.876022963873972],
            [27.365683070336782, 1.858785969504544],
            [27.36522911030124, 1.855565101749246],
            [27.358831917007183, 1.852567959934045],
            [27.354038880350267, 1.846582127666252],
            [27.352673041368099, 1.840370019683702],
            [27.353417161732036, 1.836959070719797],
            [27.355429199322241, 1.82772110179328],
            [27.359552995584071, 1.819904044560071],
            [27.360247075295064, 1.811164082049557],
            [27.363223192034731, 1.807486105240786],
            [27.369856906353199, 1.803122133071997],
            [27.368262107466354, 1.798750044867827],
            [27.37192618459332, 1.79024308638203],
            [27.371328396195931, 1.788862180266658],
            [27.370449930984641, 1.786832902197879],
            [27.368738162464673, 1.782880670755006],
            [27.366678391095203, 1.784719206120374],
            [27.365258161817504, 1.783072471147919],
            [27.362108971163661, 1.779420348143974],
            [27.361865760385299, 1.779315224080349],
            [27.361572998535905, 1.779188987876556],
            [27.358908404960378, 1.778040046658179],
            [27.34565901090107, 1.778259985036031],
            [27.339946770434729, 1.773424653826111],
            [27.334468575235928, 1.763059933987809],
            [27.324420310623584, 1.75661096662223],
            [27.3188636844156, 1.747448950238207],
            [27.317933875095942, 1.745915599670302],
            [27.317578974981693, 1.745330566104295],
            [27.317481965914173, 1.744791506071178],
            [27.316668833376887, 1.74027033684315],
            [27.315897603654307, 1.740218196288991],
            [27.315857591793257, 1.740215515182765],
            [27.313238673956644, 1.740040003961151],
            [27.306168639819834, 1.72829996958563],
            [27.306172414540672, 1.726922017240641],
            [27.306173821302394, 1.726408306879675],
            [27.30617871981563, 1.724620023910411],
            [27.307180612648651, 1.723686686307992],
            [27.307366189315001, 1.723513807659476],
            [27.308368596882652, 1.722579990411244],
            [27.309148759452402, 1.721860019694461],
            [27.309046290424554, 1.720242419267777],
            [27.308478757285947, 1.711279959139356],
            [27.305816608026287, 1.704476734843773],
            [27.305075252676815, 1.702582525300413],
            [27.305058574555268, 1.702540089572792],
            [27.302290405227467, 1.702996966031818],
            [27.30219544970868, 1.703012638067382],
            [27.300939289632794, 1.703219955121718],
            [27.298428645737403, 1.701839945128989],
            [27.297288886661111, 1.698849936769393],
            [27.297476674081352, 1.698213008994816],
            [27.297697143109961, 1.69746523292404],
            [27.298435875378811, 1.694944202947445],
            [27.296159191410936, 1.690339345717975],
            [27.298203783947052, 1.686458358849605],
            [27.298218780422399, 1.686429636027108],
            [27.29730868642827, 1.684359942830698],
            [27.288178449730683, 1.67652912096007],
            [27.287069253136977, 1.67298323474426],
            [27.286809034555368, 1.672150917762107],
            [27.287498606520291, 1.664332614535825],
            [27.284951460481611, 1.656254751690368],
            [27.284370454410368, 1.654412835652374],
            [27.284088776873229, 1.653519856763656],
            [27.284003305767229, 1.650749311014836],
            [27.283868817189408, 1.646389914399365],
            [27.283512588466852, 1.645582550706514],
            [27.281128859453119, 1.640180018831529],
            [27.283203833910434, 1.636366644878282],
            [27.283794465429978, 1.635281185264897],
            [27.285258775936942, 1.632590080682136],
            [27.276808863048394, 1.623840059416152],
            [27.268278669519546, 1.623150044947587],
            [27.263718202198142, 1.622798044717094],
            [27.263697399911088, 1.622796439209705],
            [27.262189043209109, 1.62268002907298],
            [27.252581956504173, 1.625199244090268],
            [27.251110937378648, 1.626224166503672],
            [27.250281722302827, 1.626802708564126],
            [27.247318766780403, 1.628869958619875],
            [27.247182149195361, 1.63131392785584],
            [27.247158257602056, 1.631741320905641],
            [27.246868767416892, 1.636920038444442],
            [27.244798637573894, 1.640139907713846],
            [27.241099748933038, 1.638828733579069],
            [27.240783284136569, 1.638716547845161],
            [27.240228932876402, 1.638520032956602],
            [27.234758736276859, 1.627930062346755],
            [27.231795358546265, 1.626351061932867],
            [27.231471673989819, 1.626178590421469],
            [27.226988863329765, 1.62378997592815],
            [27.223897549333014, 1.623113658877023],
            [27.223790155740812, 1.623090212687208],
            [27.221683264141426, 1.624327174200378],
            [27.221473661134475, 1.624450344361634],
            [27.221049035584517, 1.624699787192901],
            [27.217388719703663, 1.630210042890331],
            [27.214410145173371, 1.63112956919966],
            [27.21326891465667, 1.630209989554426],
            [27.215099793495114, 1.619101265628079],
            [27.215421663454656, 1.617148336707585],
            [27.215808711577996, 1.614799941475554],
            [27.21352754681347, 1.611809892179574],
            [27.211565061192658, 1.611675229504433],
            [27.211431274199068, 1.611666049314105],
            [27.206674954382784, 1.611338028564905],
            [27.204571049681714, 1.610281488095917],
            [27.20442742972903, 1.610209364564084],
            [27.202096109327261, 1.609037911418501],
            [27.196861182398969, 1.605052227922954],
            [27.194740808883779, 1.603437850015953],
            [27.209868715847787, 1.598699932931607],
            [27.209881497077657, 1.598697517409559],
            [27.226798782510606, 1.595500056177776],
            [27.235848825704469, 1.591949326803113],
            [27.236472520616349, 1.591704624190381],
            [27.241428810804774, 1.589760050806736],
            [27.277079001725685, 1.586810049567212],
            [27.28424317121943, 1.583148242623304],
            [27.288739314674942, 1.580850042590228],
            [27.292731137641724, 1.578918640412217],
            [27.29491907075446, 1.577860030948402],
            [27.306549874046627, 1.57716580704111],
            [27.309999102903721, 1.57695992770783],
            [27.318218978807575, 1.579960029536715],
            [27.320173103808035, 1.582859583706029],
            [27.322559136102193, 1.586400000509975],
            [27.328121115370944, 1.588147553741648],
            [27.329179172672156, 1.588479991661181],
            [27.344489243602705, 1.589649975016176],
            [27.349954968388765, 1.591858380105045],
            [27.351030497023924, 1.592286982984084],
            [27.351338959627881, 1.592409900172824],
            [27.36595927174395, 1.587370002775452],
            [27.37031840594895, 1.583230794983614],
            [27.370186781200239, 1.579983573860865],
            [27.369870546372461, 1.572195741448497],
            [27.371019067616039, 1.568510002369694],
            [27.375589532288274, 1.565070154942504],
            [27.384499259533083, 1.566920041361626],
            [27.398218143702582, 1.564170205226479],
            [27.419458978377175, 1.573849819890339],
            [27.42055622558096, 1.573656976248609],
            [27.432478951696066, 1.57156002139969],
            [27.442999226192967, 1.562140059329704],
            [27.445208763788262, 1.558505313160388],
            [27.446208983059918, 1.556859925559047],
            [27.44649670715722, 1.556026388768159],
            [27.446989654076088, 1.554600167347824],
            [27.448266850000977, 1.550933557994559],
            [27.448665013877633, 1.549791486438492],
            [27.449648672707003, 1.546970015396743],
            [27.449391624280018, 1.540269630232254],
            [27.449274343829796, 1.537212516600385],
            [27.449198672445196, 1.535240005124231],
            [27.449356772341925, 1.534991458159941],
            [27.450530372751604, 1.53314645964953],
            [27.45606854576701, 1.524439963524693],
            [27.462478322661575, 1.509030933581729],
            [27.465380525121333, 1.506072997554613],
            [27.470499646633101, 1.500856481374505],
            [27.478258565523657, 1.492949919532063],
            [27.479612261978126, 1.48947363692858],
            [27.48031848331852, 1.487660065057679],
            [27.479952974100751, 1.485691499397179],
            [27.478268645519453, 1.476619974002798],
            [27.480580724906126, 1.463780657481588],
            [27.481109763438212, 1.460842819979038],
            [27.482408641100776, 1.453629920667426],
            [27.483012158953048, 1.45085346805315],
            [27.483244391420317, 1.449785092652409],
            [27.484008479536335, 1.446269932624143],
            [27.488357721493433, 1.441211026448517],
            [27.48898002671157, 1.440391604750673],
            [27.489761136105624, 1.43936288365377],
            [27.492018472158911, 1.436389972738308],
            [27.492435368604177, 1.434505734120723],
            [27.492845839400204, 1.432650533076519],
            [27.494308429633396, 1.426040066583211],
            [27.497497766895627, 1.422223588850081],
            [27.498429468067304, 1.421108680061029],
            [27.500258503562772, 1.418919985119144],
            [27.503477524755258, 1.417424295041807],
            [27.503943544673536, 1.417207762992104],
            [27.506198498394653, 1.416160018374428],
            [27.516248608146569, 1.415249938147203],
            [27.518262083041261, 1.413232523009821],
            [27.518637930969593, 1.412855939365266],
            [27.521288604251502, 1.41020007692023],
            [27.533868431827244, 1.38951007159632],
            [27.534789829322616, 1.388730645965064],
            [27.535726508059245, 1.387938292338958],
            [27.543925507115887, 1.38100259729931],
            [27.557178409096363, 1.373659921930675],
            [27.565417842222253, 1.363761433921793],
            [27.567091512292727, 1.361750755986783],
            [27.568848517275466, 1.359639960477199],
            [27.570435875416784, 1.355174690001663],
            [27.570718355149463, 1.354380065736667],
            [27.570809606914352, 1.354121571553579],
            [27.57113680029029, 1.353194461709852],
            [27.570698555382307, 1.343320052180247],
            [27.572298393817867, 1.339869890830922],
            [27.574527631467376, 1.339447356253098],
            [27.574655119474183, 1.339423191863057],
            [27.575939851365984, 1.339180434978582],
            [27.576985125640665, 1.339475141639696],
            [27.577347718927022, 1.339577383035345],
            [27.581650352693913, 1.340789870508652],
            [27.589087133926924, 1.34007613028739],
            [27.589239843931967, 1.340061475425451],
            [27.595818449302698, 1.339430104757412],
            [27.599247045654323, 1.341039404503445],
            [27.599974131265505, 1.342487303668857],
            [27.600492962241013, 1.343521885577256],
            [27.607668359777477, 1.357830025414717],
            [27.611042288254211, 1.360909328088691],
            [27.611287372019884, 1.361132978007374],
            [27.612708521172408, 1.362429821641383],
            [27.614083018117306, 1.362173866169053],
            [27.614201525666196, 1.362151797736151],
            [27.61635839054485, 1.36175007699968],
            [27.617495741237853, 1.360906255919642],
            [27.618056533418578, 1.360490193962268],
            [27.620698546042831, 1.358530035034783],
            [27.623448583774952, 1.348639971019927],
            [27.626235108378943, 1.345287555035883],
            [27.626681099459599, 1.344750990548664],
            [27.62802849872395, 1.343129957830275],
            [27.630784209317074, 1.34208903065319],
            [27.631167690230374, 1.341944176469039],
            [27.633508588469695, 1.341060004842419],
            [27.645618263876884, 1.341069920309447],
            [27.64577501809736, 1.341185020913696],
            [27.650638489859062, 1.344760042568694],
            [27.6616637819373, 1.343994528338321],
            [27.661794698813559, 1.343985438342443],
            [27.663888657367803, 1.343840350105802],
            [27.665589091843824, 1.344728280936078],
            [27.676678488599102, 1.350520002736842],
            [27.680160280486916, 1.350800504366866],
            [27.680304373851733, 1.350812112296617],
            [27.682388353919819, 1.350979984707702],
            [27.700208424653741, 1.348689880913115],
            [27.711410653401948, 1.335588685169532],
            [27.71506848813598, 1.333520016816629],
            [27.726718435425159, 1.331459966601253],
            [27.731838350149335, 1.326489928589762],
            [27.732483539050996, 1.325866097502698],
            [27.73280107553764, 1.325559072307306],
            [27.733348189071528, 1.325030069169518],
            [27.734602062935, 1.324462699389094],
            [27.734863142102661, 1.324344562846308],
            [27.739978301145733, 1.322029984518554],
            [27.750708450839074, 1.320429938591977],
            [27.755509419619926, 1.313309159392582],
            [27.764927038156717, 1.307904097427745],
            [27.765108637082989, 1.307799949705136],
            [27.768456800080703, 1.307507151466268],
            [27.768720604736924, 1.307484079855072],
            [27.770368214680996, 1.307340013831137],
            [27.773788955265506, 1.308720275070383],
            [27.782608099091998, 1.301479413145177],
            [27.777190460224801, 1.282489630300309],
            [27.765082224816997, 1.256636095890076],
            [27.768030262915818, 1.244479907080748],
            [27.772642941219861, 1.239742504744483],
            [27.783545177578937, 1.228841094024509],
            [27.778531099666591, 1.221016427929903],
            [27.755512707453867, 1.211650185645133],
            [27.75637346776923, 1.194875595889226],
            [27.77091403823415, 1.149609003539408],
            [27.766791863431447, 1.145937108556843],
            [27.739411713034769, 1.121543137750766],
            [27.737821067957803, 1.109127025213011],
            [27.740796803811801, 1.098782962788075],
            [27.738972718033541, 1.093033632488581],
            [27.740815523803981, 1.068436038162327],
            [27.742095587151269, 1.068188782794958],
            [27.744318858190656, 1.067759270256327],
            [27.746752805723727, 1.067289217380432],
            [27.753144878620663, 1.073729981331188],
            [27.757025786599325, 1.073502060185435],
            [27.769362622585664, 1.065692100048328],
            [27.770362023492066, 1.063682236458785],
            [27.773019978517649, 1.058337432783177],
            [27.782836954792106, 1.065239008948339],
            [27.785414865434287, 1.065096080298403],
            [27.786946816387232, 1.065011115194185],
            [27.795626772548651, 1.0608770888259],
            [27.802935699262239, 1.059961176702721],
            [27.805636928829994, 1.061096035708386],
            [27.808413607898501, 1.062263027273106],
            [27.813985342871227, 1.062665933250264],
            [27.816032827982568, 1.062813988895264],
            [27.82439952902801, 1.063418990626237],
            [27.82561272897204, 1.062809151362086],
            [27.828053760619458, 1.061582041652143],
            [27.831254879286654, 1.053537066389666],
            [27.833195010331625, 1.051802880957045],
            [27.835368598247609, 1.049860019672371],
            [27.841312147713072, 1.047255004093752],
            [27.844275714988186, 1.045956093359852],
            [27.847474673207131, 1.041818977882044],
            [27.850070933735616, 1.040404569060219],
            [27.852956008017888, 1.038833046150602],
            [27.860720868365707, 1.039526064712502],
            [27.860947667822096, 1.042974084483105],
            [27.863457587675391, 1.045734082816886],
            [27.869277228920442, 1.048263737787659],
            [27.875102966133035, 1.050795949616913],
            [27.879675007348574, 1.050384103005612],
            [27.883456113397507, 1.050043494059925],
            [27.895426690971131, 1.048964977182538],
            [27.898751719655362, 1.04692533943937],
            [27.904791837115535, 1.043220322829248],
            [27.907515633261575, 1.04459253236277],
            [27.910271608857709, 1.045981141972707],
            [27.912345567320472, 1.046330015906453],
            [27.917123952455064, 1.047132969238907],
            [27.91945533304397, 1.046965997533415],
            [27.921236079601332, 1.046838442425386],
            [27.926714068187668, 1.046446069399987],
            [27.933337879478433, 1.042770093881232],
            [27.936080857350728, 1.037023906267463],
            [27.928721601625057, 1.016759562484298],
            [27.922457244008694, 1.00430087147316],
            [27.877730860834273, 0.946435708560771],
            [27.886115817442935, 0.93149132128336],
            [27.892506834819415, 0.934021771694269],
            [27.898373613362395, 0.930426080378429],
            [27.907125091590121, 0.925062176405569],
            [27.912375807307864, 0.92552400760957],
            [27.916711645502598, 0.931732061125271],
            [27.919678822208553, 0.932651884981152],
            [27.922646604379018, 0.931044020333743],
            [27.924704722848364, 0.926447044093915],
            [27.929272761170971, 0.922540988066867],
            [27.945712844457006, 0.920247142970809],
            [27.950736464274318, 0.921168151704284],
            [27.954157336012806, 0.924155159253781],
            [27.957583509608124, 0.927146980290481],
            [27.965344746152088, 0.931517070659634],
            [27.969827200180994, 0.935915477463721],
            [27.974248673873433, 0.940254005833205],
            [27.976160876296248, 0.940367809720985],
            [27.977138134629229, 0.940425976251508],
            [27.982011407010663, 0.940715945334559],
            [27.984979048145615, 0.938648015602544],
            [27.987037484618565, 0.933234220683748],
            [27.987950791886476, 0.93083295245575],
            [27.988641298997614, 0.930769864843433],
            [27.990464530478036, 0.930603227203762],
            [27.992972432715185, 0.930374087889727],
            [27.995560825798425, 0.931294534227753],
            [28.00073514159789, 0.933134551764999],
            [27.995011614698349, 0.922930603439759],
            [27.987071817330435, 0.910966964573393],
            [27.963755835721951, 0.864725603658469],
            [27.954498310443515, 0.84636548060624],
            [27.936150917858054, 0.789890322151946],
            [27.937490102927413, 0.7771294970966],
            [27.938696476573597, 0.765634178307942],
            [27.946239193433119, 0.761774995157999],
            [27.943733235150223, 0.757163579911547],
            [27.934531998307513, 0.748946711569173],
            [27.939565875987046, 0.742338820284861],
            [27.966414664808308, 0.706474988641336],
            [27.987404959350151, 0.679725594840952],
            [28.010879327417936, 0.64981039530806],
            [28.017941637839936, 0.636186917792379],
            [28.010666973769638, 0.633744096549192],
            [28.009343204688836, 0.633299018787769],
            [28.009040368233531, 0.633197198513246],
            [28.003334859741937, 0.625612978647123],
            [28.00242513944697, 0.621706101927238],
            [27.993069107609454, 0.612741070964013],
            [27.98827635931174, 0.611821084712954],
            [27.982917853844743, 0.612560174991684],
            [27.976634397147123, 0.61342695291362],
            [27.969099967246091, 0.621238061650444],
            [27.955246458853171, 0.621852081963029],
            [27.941165070330555, 0.614170423478452],
            [27.922733085191389, 0.598436892629096],
            [27.915850610302762, 0.587586315825312],
            [27.903798416293981, 0.57389042454277],
            [27.901381501717005, 0.571143883969978],
            [27.893061548998944, 0.561698289428262],
            [27.876475281070078, 0.559979482126503],
            [27.863133331790426, 0.558254365735985],
            [27.855201097338878, 0.55756950968695],
            [27.842927267389925, 0.551636490021009],
            [27.830290916019884, 0.545003286626884],
            [27.818746445318094, 0.541872405449759],
            [27.812247370494426, 0.538381070662284],
            [27.800688505188514, 0.53198346579639],
            [27.796598902399669, 0.529719949157312],
            [27.80753111374316, 0.522019520207694],
            [27.810298691979504, 0.520070092409162],
            [27.814912627924944, 0.518632162300681],
            [27.816910283487452, 0.518008067430168],
            [27.821663526573914, 0.512096331372004],
            [27.821708883410924, 0.512039919087217],
            [27.825483792881013, 0.510138663825239],
            [27.825818639903154, 0.509970015638014],
            [27.829929316270245, 0.503539817373578],
            [27.832865334910576, 0.502246504652372],
            [27.837238596021727, 0.500320087894056],
            [27.837840266937764, 0.499180697721317],
            [27.841118628142986, 0.492969927553919],
            [27.843968448940227, 0.491477281760602],
            [27.846368864160379, 0.490220019807222],
            [27.849832469655254, 0.489193381403858],
            [27.854128658009969, 0.487919959432027],
            [27.858667643918015, 0.488033701418083],
            [27.863711524338228, 0.488158715048781],
            [27.864488730552363, 0.487810020178011],
            [27.872084474963117, 0.484390357639762],
            [27.881058797365078, 0.480350046713537],
            [27.885629206341726, 0.480580269274269],
            [27.892009275051514, 0.483340472357925],
            [27.898158783957133, 0.490929935232185],
            [27.898171541830809, 0.490931904875656],
            [27.901138861368867, 0.491390054958644],
            [27.902765432768984, 0.487537161122665],
            [27.905019867263913, 0.482199666676819],
            [27.907038089754831, 0.481549303633435],
            [27.91072889445644, 0.480359959154331],
            [27.912629728699354, 0.482177234596953],
            [27.915048890861161, 0.484490051719625],
            [27.917569032644064, 0.491849995594481],
            [27.920988886591338, 0.491849995594481],
            [27.924868602505619, 0.487950057550922],
            [27.929438798581586, 0.4868000266173],
            [27.932863070443453, 0.482781973780936],
            [27.934918714952495, 0.480369871595113],
            [27.935150403040684, 0.480300294598456],
            [27.941078670366522, 0.478520016002219],
            [27.953628619077609, 0.480829992050364],
            [27.959788574491672, 0.474400012200394],
            [27.962640306903804, 0.47390574983189],
            [27.965040330458521, 0.473489865514067],
            [27.980508603693771, 0.47169313341171],
            [27.982841876134632, 0.471422109512307],
            [27.989245368415471, 0.472186350524734],
            [28.004065158626904, 0.473954867148446],
            [28.007487094869017, 0.47142805644199],
            [28.012967010341622, 0.461090003295786],
            [28.017304508622995, 0.460631426133144],
            [28.023921082187513, 0.463850015266946],
            [28.024495039178735, 0.463753629864024],
            [28.026659959250527, 0.463390073636652],
            [28.029169877307197, 0.458336118953516],
            [28.028486957366944, 0.451903053468995],
            [28.030084996477019, 0.447538103943855],
            [28.02484016113111, 0.438806032930684],
            [28.025983392195982, 0.436279064146958],
            [28.032599129429002, 0.436739775296823],
            [28.036935790480548, 0.431686098630183],
            [28.04278614602346, 0.429600130661786],
            [28.047889861428143, 0.427781982672447],
            [28.052685056736649, 0.412619132284192],
            [28.051773955731107, 0.407564382551098],
            [28.045384487948489, 0.410779779708554],
            [28.041051069815133, 0.40595421009633],
            [28.039420162247126, 0.405760758626847],
            [28.037170869708916, 0.405494127432175],
            [28.03443415219586, 0.402736077150071],
            [28.042876144638534, 0.396994145532282],
            [28.044018064163076, 0.394697118894934],
            [28.044703143653248, 0.390332136908646],
            [28.039457948082937, 0.380912065348829],
            [28.04196828205956, 0.377466261692408],
            [28.050410519742343, 0.381372991335684],
            [28.056344094314866, 0.380455002717104],
            [28.059082971377876, 0.376550140136383],
            [28.057714971947451, 0.364833018694058],
            [28.058175024357279, 0.350818826335809],
            [28.056579893093808, 0.339561998324792],
            [28.062058008342564, 0.331981130115831],
            [28.061601888757068, 0.329454112139013],
            [28.056811013446737, 0.326467144200069],
            [28.055899133601809, 0.324169018825896],
            [28.056812812772254, 0.317967086386137],
            [28.054534015068512, 0.307399048249652],
            [28.055219814109229, 0.30211610589068],
            [28.058414811656068, 0.296832981866071],
            [28.062068088338364, 0.284888132660501],
            [28.06777408281852, 0.28052400146081],
            [28.06845700275877, 0.277997152113108],
            [28.065948884925952, 0.272943090939569],
            [28.066177844830626, 0.26972703226544],
            [28.069601802282108, 0.264903123514609],
            [28.070386819347672, 0.265083009697556],
            [28.074620260379795, 0.26605276176634],
            [28.076217876383343, 0.265134001112995],
            [28.07736087478456, 0.258013033074234],
            [28.080326912426731, 0.255257103633471],
            [28.083295109618856, 0.247447101065666],
            [28.086945361673589, 0.244921273198009],
            [28.094245245047198, 0.246529869238725],
            [28.096754777726577, 0.245152023644677],
            [28.099950855048395, 0.234815157953818],
            [28.101776773389837, 0.233437100447719],
            [28.106186996581695, 0.232451137970625],
            [28.107936008355029, 0.232060124421621],
            [28.112954175398556, 0.234357002842067],
            [28.120025877706844, 0.234128111579021],
            [28.127782789761014, 0.228616062242599],
            [28.134172784854695, 0.220806045290468],
            [28.134046770983257, 0.219535859724291],
            [28.134027573985652, 0.219342355034269],
            [28.133986557808079, 0.218928920165954],
            [28.133717024595303, 0.216212095634987],
            [28.128013910113939, 0.210240084868898],
            [28.126873790813214, 0.205646132922832],
            [28.128245030466864, 0.197147074632101],
            [28.12710383139116, 0.192553118042184],
            [28.120262757159026, 0.186809994983841],
            [28.121859479338891, 0.184973155310387],
            [28.131211349281724, 0.186810935523044],
            [28.137598901856133, 0.183596080030488],
            [28.140564939498333, 0.180150023959344],
            [28.15197404845982, 0.158101021125244],
            [28.154028926705934, 0.15098108485187],
            [28.152203008364495, 0.144779074666569],
            [28.139658819650997, 0.138118008884821],
            [28.138289020895087, 0.134213071131232],
            [28.139432020194608, 0.132605028842758],
            [28.13692181916862, 0.127782128573682],
            [28.130307347661844, 0.127322066123593],
            [28.127798989978835, 0.124566073813289],
            [28.130765027621003, 0.119284150369957],
            [28.128027949883506, 0.115838084960438],
            [28.104305771663121, 0.106419977484724],
            [28.102482012871636, 0.102974090523673],
            [28.105903809874899, 0.098152118472611],
            [28.106817849269746, 0.093788119610227],
            [28.100205015391744, 0.083222998770096],
            [28.099522095451494, 0.079089156320566],
            [28.105909930096924, 0.068983988144112],
            [28.106595008688799, 0.063013021109496],
            [28.102718892323857, 0.049233060588287],
            [28.098387016597815, 0.041884023634999],
            [28.098387016597815, 0.039408150941006],
            [28.098387016597815, 0.037980158197406],
            [28.102722852995925, 0.033387076341181],
            [28.102493892192953, 0.028335119965782],
            [28.097021898064519, 0.022363067883257],
            [28.097250857070893, 0.018688999257359],
            [28.101812773374849, 0.015245089004032],
            [28.102268892960382, 0.012719110073451],
            [28.09999009525664, 0.008813981252912],
            [28.100674094073536, 0.004681036294669],
            [28.091286428063263, -0.005040543055901],
            [28.098871936171356, -0.018324025600654],
            [28.101187094084516, -0.025889886051419],
            [28.103754971443312, -0.039193853409574],
            [28.101511813500149, -0.047696927187015],
            [28.10198089308027, -0.050679977940246],
            [28.107711008224125, -0.056854971083163],
            [28.110323886687084, -0.080260856266977],
            [28.116335880590661, -0.098372003826443],
            [28.113899762727868, -0.10985198653196],
            [28.113653883054798, -0.111009986962249],
            [28.118314799092975, -0.133490876221289],
            [28.118635918060974, -0.153923934173877],
            [28.127606030957505, -0.170188901683227],
            [28.131324827163365, -0.186015888683981],
            [28.137998861465054, -0.198845949546052],
            [28.142686777267393, -0.226609893769159],
            [28.144984884258147, -0.230045328823043],
            [28.143849835947201, -0.240145494189801],
            [28.143668769721913, -0.241759904042192],
            [28.145729398982478, -0.245573588846022],
            [28.146887989442089, -0.247717032904571],
            [28.152848504489999, -0.253892926568138],
            [28.154467423142204, -0.258708008534754],
            [28.153128583924229, -0.265371908294588],
            [28.151847445293587, -0.267107528074638],
            [28.150407705506229, -0.269058012542682],
            [28.145627627945643, -0.271603968394156],
            [28.139266697842981, -0.277830830601005],
            [28.137690405149311, -0.278345549962499],
            [28.135148070487315, -0.279175374971701],
            [28.133568533078826, -0.279690887396082],
            [28.118268770316131, -0.276998032868763],
            [28.116293436091805, -0.277290458176705],
            [28.113480722003999, -0.277706979580432],
            [28.106892724746981, -0.284393938000586],
            [28.100741767757142, -0.286485887410075],
            [28.096209729419517, -0.293622879678288],
            [28.087998726175726, -0.294574807185634],
            [28.085877297140112, -0.296420202494045],
            [28.081633696162115, -0.30011193451405],
            [28.077284491934261, -0.304167966327454],
            [28.073224932401807, -0.307953985670298],
            [28.035577103884666, -0.309024913421898],
            [28.028406700082833, -0.311189940004909],
            [28.009370567372393, -0.316937968816885],
            [27.996186652412483, -0.328702911093615],
            [27.990756773999536, -0.339746016149271],
            [27.986199536121564, -0.35843394249437],
            [27.985598697045468, -0.360894988379505],
            [27.970374796110189, -0.376112028824677],
            [27.963307506326583, -0.37820699632142],
            [27.951481870127406, -0.387668884361325],
            [27.949730411343211, -0.390514811627605],
            [27.949214591520544, -0.39135296058319],
            [27.948470381325127, -0.394105802066006],
            [27.94629355318591, -0.402157903779337],
            [27.941975947198198, -0.406539005721835],
            [27.949774751287343, -0.416154870001849],
            [27.957144669117127, -0.431971943507023],
            [27.969294663609208, -0.444326975506137],
            [27.972955660413056, -0.458087213791252],
            [27.973933621228568, -0.46176297676939],
            [27.97807685972808, -0.470015973399656],
            [27.97564470074073, -0.488399906034282],
            [27.978717659461257, -0.513193010324155],
            [27.978331260819918, -0.516827930308877],
            [27.977852580944347, -0.521330958594459],
            [27.977727848070504, -0.522516145553905],
            [27.97762074104088, -0.523533865521133],
            [27.974655144471523, -0.530173714959446],
            [27.970837623415918, -0.538720978991786],
            [27.970406703370763, -0.544694923426067],
            [27.962668615513369, -0.550007920760269],
            [27.951022596556928, -0.548905037506246],
            [27.947375712286178, -0.549837841218733],
            [27.941458754749764, -0.554455939475307],
            [27.938065756836217, -0.561588895892101],
            [27.936844303171355, -0.568925883469901],
            [27.935616851455343, -0.576299953310351],
            [27.911592806960151, -0.584849971877644],
            [27.903752370449158, -0.593959588721595],
            [27.886855928625728, -0.596174361666241],
            [27.841009074102498, -0.596021892430571],
            [27.660464639729149, -0.59542138420028],
            [27.650115742228909, -0.59068706714326],
            [27.641204292913702, -0.588650902632889],
            [27.640195841480807, -0.588342708181629],
            [27.637536255114632, -0.587529906976338],
            [27.635262136735239, -0.586834961339804],
            [27.629986340054771, -0.579961920859649],
            [27.620825425890207, -0.572413929034134],
            [27.616998575830376, -0.571328155343951],
            [27.614428230799518, -0.570598884076178],
            [27.605861777672526, -0.57214268345194],
            [27.601426479806154, -0.572941988058309],
            [27.595687363543185, -0.564003010272204],
            [27.578082294691036, -0.556484914238376],
            [27.571673218482406, -0.551911874768402],
            [27.567776221676993, -0.548020985945043],
            [27.566842382514992, -0.542052992612035],
            [27.562039264963943, -0.539311938046924],
            [27.559510320589588, -0.534497122783571],
            [27.556998694835571, -0.534047087663596],
            [27.553035250546923, -0.536058996562845],
            [27.552897431016032, -0.536128968142766],
            [27.548329393591722, -0.535454922603044],
            [27.542153657473079, -0.532030140074762],
            [27.538737200055863, -0.534134947811672],
            [27.535777281737424, -0.53595685165581],
            [27.52733528749809, -0.536674871959316],
            [27.519135632671301, -0.541526664379778],
            [27.498545385773227, -0.528502882316006],
            [27.4982865461056, -0.520005932786093],
            [27.49457854764945, -0.505318903624138],
            [27.496823506714726, -0.494974954927543],
            [27.495217548057141, -0.492683006293179],
            [27.488135272577953, -0.490869920792942],
            [27.47193024246917, -0.491153958205797],
            [27.471221194130578, -0.49133150193017],
            [27.459845409971148, -0.494179973631506],
            [27.454346413383593, -0.498441983744965],
            [27.452107324808711, -0.500177844209026],
            [27.449661854585475, -0.500596041954389],
            [27.446633417268728, -0.501113849397374],
            [27.435261384473947, -0.512864997083749],
            [27.430083441277365, -0.513016216893307],
            [27.426362674167773, -0.513124880610078],
            [27.419755473624903, -0.516591001600455],
            [27.415192872804695, -0.516835908327497],
            [27.40605028157696, -0.51365096529851],
            [27.398974898870964, -0.513213941104809],
            [27.39327748958997, -0.516217932894469],
            [27.384152619427876, -0.517395887072958],
            [27.375235380470642, -0.5132908726881],
            [27.369134192842491, -0.514151843481201],
            [27.358583102538095, -0.51564079343288],
            [27.350331757751519, -0.506019987486254],
            [27.35026833938743, -0.505356284263082],
            [27.349541917631242, -0.497753878978451],
            [27.347962957839485, -0.481221989661167],
            [27.345673017432979, -0.477866454866448],
            [27.344522078822976, -0.476179942803085],
            [27.33925984760161, -0.472291915748748],
            [27.334918772228761, -0.471157065992697],
            [27.330359969485546, -0.473008956538368],
            [27.329137017430792, -0.472753884313909],
            [27.327935514450072, -0.472503275893878],
            [27.32602103120476, -0.47210380251924],
            [27.320515821868714, -0.464312111907764],
            [27.313974545989634, -0.464074780693086],
            [27.313602850972817, -0.464061304227127],
            [27.30887380939846, -0.463889848706367],
            [27.300391851807085, -0.452661997171611],
            [27.285318000066983, -0.44972397755148],
            [27.283035049451694, -0.450881040482222],
            [27.278481779432333, -0.45318893758912],
            [27.275151460569433, -0.452700769882203],
            [27.273471944263086, -0.452454585684508],
            [27.267750994630081, -0.451615978561026],
            [27.264280809874066, -0.451990167729875],
            [27.262875404595206, -0.452141709047317],
            [27.256798926925583, -0.452796941107082],
            [27.25489794446068, -0.451141951928241],
            [27.251534696952675, -0.448220015399503],
            [27.237390977925752, -0.44939576407148],
            [27.234594264629816, -0.449628270212486],
            [27.231458121107146, -0.449888977322802],
            [27.225744072332144, -0.447610017181115],
            [27.213294238164515, -0.447209102683068],
            [27.21244680615305, -0.44718181327209],
            [27.193103960756833, -0.446558925384802],
            [27.176655832159092, -0.441784865408005],
            [27.140995054592555, -0.424206964664349],
            [27.138805857550203, -0.424021380539013],
            [27.137897972513372, -0.423944416310114],
            [27.135745840857957, -0.423761985627343],
            [27.133517382946135, -0.421824634576864],
            [27.130480897622753, -0.419184882869098],
            [27.120624236473986, -0.405662959883219],
            [27.121523018882062, -0.401526019391884],
            [27.118544245824111, -0.390612595179428],
            [27.117827813333879, -0.387987974679589],
            [27.112812130132124, -0.389150862723624],
            [27.103673887648704, -0.386191080209598],
            [27.101413337423338, -0.388831371823505],
            [27.100716861905486, -0.389644879266968],
            [27.10022919977537, -0.389711752204939],
            [27.098229044201442, -0.389985872824131],
            [27.097295334396819, -0.390113820917514],
            [27.096265970184096, -0.389084038615946],
            [27.095235695977983, -0.388053009090432],
            [27.093838394401306, -0.388291260592462],
            [27.091131178460493, -0.388752915984383],
            [27.08861103847422, -0.386004090748428],
            [27.082227031550222, -0.3880898070291],
            [27.081109968409599, -0.387569095834305],
            [27.078800033301466, -0.386492043820382],
            [27.074278040823678, -0.381622214590654],
            [27.072844911738532, -0.38007886485506],
            [27.070543071349441, -0.373425854679006],
            [27.06982379209807, -0.362862924410913],
            [27.073679030717507, -0.355043990047229],
            [27.072755992000136, -0.351601948365923],
            [27.068947247484878, -0.34797396508496],
            [27.067948912878695, -0.347023010268854],
            [27.063151913753085, -0.345198896395698],
            [27.070102718095466, -0.336791574641641],
            [27.071334957831979, -0.335300925702063],
            [27.071782911731525, -0.332544894493194],
            [27.070174791727357, -0.329333000102517],
            [27.061355154725756, -0.320969920154972],
            [27.056887609137316, -0.316734204869748],
            [27.048201690857326, -0.308499034831017],
            [27.038622021633202, -0.309443922416598],
            [27.038020772925329, -0.308924633890058],
            [27.033587993036686, -0.305095069225994],
            [27.030573011584597, -0.304525875379025],
            [27.028792801321437, -0.304189850851867],
            [27.022613215023501, -0.298465930664745],
            [27.010711086379544, -0.286787956550256],
            [27.008646127239299, -0.282659929619889],
            [27.010223035278951, -0.27622689064468],
            [27.010180556644105, -0.276085939990238],
            [27.009627454940535, -0.27424557775174],
            [27.009533165971654, -0.273931844765608],
            [27.00678816688999, -0.272101950148723],
            [27.002450979425682, -0.27165503484388],
            [26.994021834688198, -0.275811943677059],
            [26.985340197778875, -0.272161953473302],
            [26.980070064077939, -0.265058136189223],
            [26.977980798322733, -0.26831241162665],
            [26.977117113092824, -0.269657967248205],
            [26.976392468204253, -0.269822171770046],
            [26.975065043878597, -0.270122940874034],
            [26.972548882530734, -0.268293041152079],
            [26.967762023588026, -0.269682825373021],
            [26.964662962520269, -0.268694532418426],
            [26.962052253488732, -0.267861965561313],
            [26.956342098910483, -0.266040930029708],
            [26.951884749200531, -0.260307815179742],
            [26.949927848405842, -0.257791081378336],
            [26.941943999452992, -0.258271829303812],
            [26.939469138150287, -0.256980989850258],
            [26.936687162614895, -0.255530023315367],
            [26.934598460103402, -0.253440134972918],
            [26.930958145212326, -0.249797872237894],
            [26.928761119352274, -0.247599630579272],
            [26.927532071330017, -0.246370013484211],
            [26.924995585598825, -0.245500226172325],
            [26.923143153481753, -0.244865111468987],
            [26.920222946987067, -0.243863905005721],
            [26.905804800725683, -0.228976939827276],
            [26.903523989897412, -0.229441889588131],
            [26.899440151597773, -0.237488906915093],
            [26.896325719457181, -0.240827328426886],
            [26.895573998447638, -0.241632900964185],
            [26.894051898420127, -0.241372895271428],
            [26.893113785073968, -0.241212603552673],
            [26.88895403284458, -0.240501863231605],
            [26.887561954072993, -0.2324688933085],
            [26.886928162995634, -0.231755907907314],
            [26.885729914611197, -0.230407935511425],
            [26.874992196611576, -0.225383953736125],
            [26.873192698620937, -0.223015082985468],
            [26.870640157300688, -0.219654900992573],
            [26.861083060044663, -0.213334199018008],
            [26.857153111238024, -0.210735105300028],
            [26.856131114108965, -0.211331864771618],
            [26.854190939046532, -0.212464774129539],
            [26.851229935563204, -0.21419385311811],
            [26.848471605482711, -0.214201478707507],
            [26.845754189171824, -0.214208990347196],
            [26.84595809146996, -0.20571214694177],
            [26.83469454641541, -0.208432401784125],
            [26.832506085991614, -0.20896097505902],
            [26.829592991459013, -0.212462625362623],
            [26.828869102053606, -0.213332928387825],
            [26.828447840694377, -0.215480607069891],
            [26.82796792743196, -0.217927911711949],
            [26.828424401852011, -0.225989503924861],
            [26.828448886333401, -0.226421913018405],
            [26.830982206401522, -0.234451990675778],
            [26.83373030916249, -0.237889026326822],
            [26.838803801647728, -0.240727732011985],
            [26.8472131627877, -0.245433007727366],
            [26.848369206523472, -0.25048175977976],
            [26.840866002960045, -0.259226041383204],
            [26.839856520261186, -0.259647391788906],
            [26.831166141845841, -0.26327506797673],
            [26.828952886123524, -0.264198959202335],
            [26.825366927392018, -0.265695966578223],
            [26.816473206328926, -0.266865820808219],
            [26.816170863048693, -0.266745087000842],
            [26.81407896163644, -0.265909310437572],
            [26.811902930302917, -0.265039921481101],
            [26.803667211710721, -0.257023920736008],
            [26.799787098741088, -0.256803861848707],
            [26.795211860421443, -0.252911982997376],
            [26.793409617179304, -0.252735449104026],
            [26.792726558898504, -0.252668568927303],
            [26.7906471548485, -0.252464972040264],
            [26.787258290083564, -0.254093931535331],
            [26.777203977114429, -0.25892699120021],
            [26.75534010150151, -0.273906972179917],
            [26.750129102997409, -0.287237994924091],
            [26.746031943580409, -0.291381880804096],
            [26.728803067609707, -0.302345003100002],
            [26.728786957223395, -0.302356230688656],
            [26.728771276231797, -0.302367159839528],
            [26.714917866653558, -0.312022497302789],
            [26.709135911531302, -0.316052313585102],
            [26.698465153054631, -0.319233212756845],
            [26.685523156197359, -0.32199831835283],
            [26.665997120060183, -0.326950526243617],
            [26.616759289731103, -0.356952677849316],
            [26.614759642603598, -0.352090100499038],
            [26.611721050730861, -0.353558645318389],
            [26.611391209121479, -0.353718052735935],
            [26.604269731163292, -0.357159895567461],
            [26.592189573498032, -0.360860024349608],
            [26.582079695236999, -0.368399956976776],
            [26.567788518654499, -0.375890422442008],
            [26.559909743843811, -0.378440015534863],
            [26.551372778814372, -0.377652201391888],
            [26.551093765680392, -0.377626452750945],
            [26.539969868228322, -0.37659990469069],
            [26.524934648537034, -0.383289910221219],
            [26.51510971139253, -0.383079876979],
            [26.50470942037655, -0.380409381009233],
            [26.504119441033932, -0.380257895269173],
            [26.498129896029287, -0.378719969574525],
            [26.494869711335539, -0.379960093946012],
            [26.490239233812446, -0.38171000518809],
            [26.47083978736681, -0.384329920516334],
            [26.468690081162659, -0.383164663314049],
            [26.468607370579505, -0.383119826595635],
            [26.467869715390712, -0.382719954211418],
            [26.461591061086608, -0.382187272719662],
            [26.461523828475777, -0.38218156898996],
            [26.457377639010566, -0.381828569881117],
            [26.456601450587641, -0.381292016814533],
            [26.456438288684268, -0.381179228192338],
            [26.454399597181254, -0.379769950880959],
            [26.453019718429516, -0.37448993273358],
            [26.448439798090632, -0.368299929476859],
            [26.442539973223294, -0.346940696993066],
            [26.440860133523458, -0.345319068609456],
            [26.439999705584786, -0.344488746967963],
            [26.438539800415953, -0.343079924191983],
            [26.436933179699974, -0.339509672437969],
            [26.436829817746744, -0.339279906083151],
            [26.434474126949656, -0.337959455961991],
            [26.434171612989509, -0.337789880629374],
            [26.431709882361339, -0.33640994553554],
            [26.432471794757756, -0.332974486166201],
            [26.432557662919141, -0.332587308697607],
            [26.432829840772143, -0.331360056783601],
            [26.431253630723468, -0.328557881586871],
            [26.431104946069215, -0.328293551450637],
            [26.429859841559544, -0.326080010788519],
            [26.430693258055989, -0.323775050211133],
            [26.430785126065121, -0.323520972618843],
            [26.43143988202457, -0.321710129348209],
            [26.430749762087352, -0.319189957445065],
            [26.425179853389587, -0.318230069305308],
            [26.418659390577293, -0.319569669079122],
            [26.416959603786577, -0.318390092268554],
            [26.415661919985023, -0.317491449714754],
            [26.415431787778903, -0.317332084203751],
            [26.407919645978389, -0.312129942016484],
            [26.407912902325549, -0.312117307260493],
            [26.405149804885859, -0.306940148015985],
            [26.404992216130513, -0.306991078651075],
            [26.40490775383255, -0.307018454421276],
            [26.399009647442359, -0.30893007811413],
            [26.388030757840088, -0.305261932943869],
            [26.387851115444533, -0.305201911709154],
            [26.385989888820845, -0.304580052665698],
            [26.38210212579823, -0.301831775224665],
            [26.381343554236352, -0.299769157919702],
            [26.381238431585182, -0.299482652213226],
            [26.379768137400081, -0.295477771802646],
            [26.372651980163337, -0.286306241209648],
            [26.372082052116163, -0.2855716953635],
            [26.370109932063915, -0.283029946013638],
            [26.369949342935495, -0.281170160159404],
            [26.369898862108105, -0.280585544864823],
            [26.369768975599513, -0.279089433773837],
            [26.368916550751685, -0.278360332609189],
            [26.36816818225477, -0.27772023386172],
            [26.36285989261216, -0.273179917257717],
            [26.354940455560122, -0.267996902322738],
            [26.353765472643243, -0.267227913700014],
            [26.343730909135626, -0.260660662088306],
            [26.336289299457952, -0.26699590207445],
            [26.336050067318002, -0.267199505054719],
            [26.333838472580688, -0.265237537633131],
            [26.333614765125478, -0.265038989990627],
            [26.326449858114913, -0.258679892882512],
            [26.325713518059668, -0.256238386158568],
            [26.325689897757588, -0.256160067650949],
            [26.325303353589149, -0.254875593774406],
            [26.320799658895339, -0.239909968628241],
            [26.321719750240266, -0.228130861071603],
            [26.31957292942483, -0.226718627962239],
            [26.319210521191437, -0.226480383659763],
            [26.316669739716559, -0.22481009328554],
            [26.315585581864781, -0.223337518069433],
            [26.31537275660094, -0.223048444919324],
            [26.312789660882917, -0.219539913078163],
            [26.310109053040801, -0.210699101693506],
            [26.30995136547077, -0.210179037632471],
            [26.309099661071812, -0.207370060516676],
            [26.309769621017438, -0.202089961521581],
            [26.307466626293213, -0.199340504586348],
            [26.307236564155701, -0.199065842023461],
            [26.301309585912264, -0.191989977617082],
            [26.295833297836801, -0.195234548033754],
            [26.295727322684417, -0.19529733713263],
            [26.294929703153738, -0.195769916231522],
            [26.286548738658212, -0.197405466813834],
            [26.28618761950726, -0.197475939381294],
            [26.282989944980866, -0.198099966831147],
            [26.279539631857244, -0.200289954648244],
            [26.272992302231426, -0.199500309309472],
            [26.270159906954078, -0.194509907245926],
            [26.268874370171812, -0.186745797757824],
            [26.268758018579554, -0.186043083833229],
            [26.267899827445927, -0.180859963089706],
            [26.266541557668361, -0.17904264623083],
            [26.266407267618202, -0.178862970608707],
            [26.265769708108255, -0.178009938239705],
            [26.264909668241764, -0.176860050698579],
            [26.261469043448468, -0.175672085694245],
            [26.261421130006148, -0.175655542142182],
            [26.25847970889771, -0.17463993912392],
            [26.254966939505653, -0.163533905919467],
            [26.254863520958541, -0.163206937003847],
            [26.254579828500248, -0.162310008728704],
            [26.254186335863096, -0.161916506504283],
            [26.253877815766955, -0.161607979390171],
            [26.252738800495727, -0.160469823202345],
            [26.25196040401384, -0.160335174878745],
            [26.251822868350562, -0.16031138372527],
            [26.243489670871963, -0.158869896795161],
            [26.237666746284521, -0.15264369348894],
            [26.237305566946429, -0.152257500167805],
            [26.230059548353911, -0.144509478474195],
            [26.226280185934943, -0.136970547338622],
            [26.223050035514415, -0.136460072033789],
            [26.219513812906907, -0.14113592687091],
            [26.218886726854851, -0.141965129827558],
            [26.218799794189842, -0.142080081160806],
            [26.215699899485514, -0.142809987340472],
            [26.214380751338549, -0.141400566269587],
            [26.214262256366048, -0.14127395222007],
            [26.212779875348804, -0.13969000545502],
            [26.213199508062431, -0.13025279180944],
            [26.212208016822103, -0.1295155553489],
            [26.212171392507976, -0.129488474074986],
            [26.212159977615659, -0.129480054416934],
            [26.209199675716558, -0.13293990419214],
            [26.205709829533905, -0.134199881843446],
            [26.197444915695005, -0.131558708732561],
            [26.197338445570889, -0.13152468463498],
            [26.197229523046062, -0.131489964174683],
            [26.192569932022938, -0.132289948274462],
            [26.192258053125947, -0.130730619592996],
            [26.192225424518206, -0.130567428359529],
            [26.192179958985044, -0.13034003610427],
            [26.197769678229765, -0.120490094548078],
            [26.197389877714173, -0.119710043244746],
            [26.196210399627585, -0.117283605300661],
            [26.195762004655194, -0.116361161229638],
            [26.194769797457582, -0.114319978189004],
            [26.194479608383144, -0.106251072309774],
            [26.191679090721966, -0.108033818334979],
            [26.191427074657224, -0.108194339105755],
            [26.188199798845574, -0.110249942723988],
            [26.18551207904137, -0.110619443883146],
            [26.185478226928215, -0.110624097759671],
            [26.183180615807494, -0.110939958149277],
            [26.177252746435304, -0.100615384749634],
            [26.175894936595157, -0.098250201718254],
            [26.173569369902797, -0.094199956247322],
            [26.170599827034387, -0.094210047188083],
            [26.169759622867673, -0.095184992309661],
            [26.169319895739477, -0.095695213337646],
            [26.166049675067356, -0.099489933944828],
            [26.149839574867123, -0.092860109353849],
            [26.143221873018582, -0.093329826475062],
            [26.144799645237509, -0.082770072025792],
            [26.144698841686218, -0.082648749179828],
            [26.144053669852529, -0.081872255644734],
            [26.140228338843894, -0.077269800880918],
            [26.136349814993995, -0.076590068359176],
            [26.134129966535813, -0.08585999979171],
            [26.132583567079852, -0.086752725389718],
            [26.132551368765156, -0.086771312873988],
            [26.132190284648487, -0.086979727290297],
            [26.123599974962513, -0.085249748236697],
            [26.123749727713612, -0.081690111298255],
            [26.123789550928475, -0.080892781997036],
            [26.122794888635195, -0.080029833504348],
            [26.122759248874615, -0.079999015336155],
            [26.122610241725173, -0.079870222397197],
            [26.116859735722706, -0.082799917995718],
            [26.111199684679431, -0.075830001661644],
            [26.102076664148498, -0.076435818336181],
            [26.102030642558162, -0.076438874197916],
            [26.10141001988459, -0.076480080851552],
            [26.097089930953402, -0.065859996103273],
            [26.096252965213289, -0.061152218711705],
            [26.096111557811156, -0.060356828922908],
            [26.09500985226861, -0.054159935044851],
            [26.091809748697703, -0.050720023404793],
            [26.091177950083637, -0.050850669471799],
            [26.090940961036978, -0.050899675425444],
            [26.080639803604186, -0.053030015416841],
            [26.078359854260263, -0.049820082976115],
            [26.084338622176428, -0.045790419300555],
            [26.084771901197527, -0.045498391255343],
            [26.086549853096052, -0.044300059565838],
            [26.089509155170251, -0.040160770653431],
            [26.089707568761991, -0.039173337792843],
            [26.089813848443256, -0.038643238130242],
            [26.091119386215329, -0.032131472576536],
            [26.090032395077142, -0.031641023138025],
            [26.089975486803887, -0.031615433103227],
            [26.089430662177335, -0.031370471102343],
            [26.088407842191469, -0.032152666471833],
            [26.088301122335725, -0.032234385284699],
            [26.083879733084913, -0.035619994918116],
            [26.079489865717417, -0.03685998560477],
            [26.077619558922834, -0.036580130337068],
            [26.077445904696926, -0.036554145094256],
            [26.067059816045592, -0.034999990072545],
            [26.065010600779047, -0.034030266513554],
            [26.064693022071577, -0.03288193271606],
            [26.064563354751911, -0.032412262975328],
            [26.064110646069523, -0.030771557931636],
            [26.069240286853269, -0.030736331841272],
            [26.070220035316208, -0.030729663021717],
            [26.070304336815752, -0.030647925215901],
            [26.0736298146576, -0.027420071803745],
            [26.072079654853855, -0.022790042384657],
            [26.068816014341206, -0.019604027618586],
            [26.0686422990299, -0.019434443881684],
            [26.067461027906006, -0.018281270631536],
            [26.064329935610147, -0.014290029651895],
            [26.057069879044686, -0.013799981692383],
            [26.058229737027133, -0.023459972106857],
            [26.056751311292107, -0.028496958672263],
            [26.056648570973039, -0.028846995738343],
            [26.056410055688708, -0.029659614111458],
            [26.056274715508003, -0.029848421110142],
            [26.055964591919079, -0.030280510698585],
            [26.051629857753841, -0.036320022876382],
            [26.049316593489298, -0.03644818014444],
            [26.049290987012135, -0.036449599099854],
            [26.047299717572958, -0.036559914970309],
            [26.039575619179466, -0.039575768548288],
            [26.033574060106208, -0.048950274306079],
            [26.035574939722299, -0.060608342071807],
            [26.048245857366155, -0.085885953357407],
            [26.0649829156003, -0.161273574746992],
            [26.067625016259438, -0.164861930795269],
            [26.068971238730725, -0.168612556492121],
            [26.072820239448816, -0.179336013191551],
            [26.074049214707543, -0.182759980309248],
            [26.075666831700925, -0.186000901553044],
            [26.079234744176706, -0.193149265935588],
            [26.081836013711243, -0.198360943670095],
            [26.082536212745964, -0.199077009109441],
            [26.092809172061997, -0.209593952542572],
            [26.095753453406292, -0.214019176293885],
            [26.098838769351893, -0.218656371446068],
            [26.099676171673231, -0.219914976723295],
            [26.101058285433382, -0.221231807473262],
            [26.104248110480835, -0.224270901546926],
            [26.107799676313402, -0.225176956036769],
            [26.109067036584232, -0.225500241173107],
            [26.114977249569506, -0.227007849354032],
            [26.122247967340751, -0.234818512231668],
            [26.124580248041585, -0.237323994766857],
            [26.135799286065378, -0.255903958232583],
            [26.142202207017661, -0.262552914044838],
            [26.157734083670004, -0.270333875442131],
            [26.159190404560817, -0.271870749827469],
            [26.163347441183113, -0.276257724758852],
            [26.170768241387226, -0.284088987511418],
            [26.164861002723843, -0.29695896605509],
            [26.157806083639997, -0.305007921817424],
            [26.154169004480597, -0.311672875119661],
            [26.153170902538101, -0.314852345861664],
            [26.150995244005404, -0.321782942588833],
            [26.148611800655917, -0.324658654594286],
            [26.142799124947558, -0.331671856385171],
            [26.13119709828721, -0.349603026783653],
            [26.129007740446411, -0.352103877400026],
            [26.125961207466599, -0.355583960452509],
            [26.123522754882352, -0.357431333100011],
            [26.114113249929243, -0.36455997254514],
            [26.109110330889344, -0.37260598810203],
            [26.123607527997407, -0.389691784194942],
            [26.138945326327534, -0.40332128539279],
            [26.152282604367713, -0.41500392864132],
            [26.188293398806611, -0.437095126864222],
            [26.273465991067287, -0.498403737617566],
            [26.273706477255356, -0.504145905665844],
            [26.267364359671372, -0.525977916918014],
            [26.257889520247637, -0.576987858298796],
            [26.258367424877076, -0.588545491346106],
            [26.25861132017166, -0.594443853993346],
            [26.257665713977744, -0.608876412682818],
            [26.256752280047372, -0.622817904391264],
            [26.256624480325172, -0.624769901222588],
            [26.2520834399701, -0.635574985438411],
            [26.24069843999418, -0.649148982537907],
            [26.236640173137381, -0.661878071932932],
            [26.235935280405293, -0.664089022095906],
            [26.231127253561247, -0.667393837771798],
            [26.230238279857776, -0.668004877273968],
            [26.237646720141893, -0.687745403258327],
            [26.238980880035555, -0.712348721398073],
            [26.236981799744985, -0.774491870023507],
            [26.24415197178147, -0.821486419495136],
            [26.244984959781501, -0.826945932493958],
            [26.248986719911947, -0.839901922345504],
            [26.253654480214273, -0.845091010212369],
            [26.259656759736405, -0.855461956913107],
            [26.243652960336092, -0.894267689293981],
            [26.228315520433771, -0.911065003751866],
            [26.209643759673913, -0.922676150934599],
            [26.185127399775471, -0.929084962738938],
            [26.170057440435496, -0.929800937067492],
            [26.163440280271072, -0.932569860638554],
            [26.149398346654074, -0.946007048741598],
            [26.146120201044528, -0.949143925029407],
            [26.126262359580746, -0.954462934777083],
            [26.11278703653257, -0.953106903793259],
            [26.073605879945166, -0.962511943236666],
            [26.082944639874729, -1.090702106896698],
            [26.105618159866737, -1.103697984399277],
            [26.132292720438645, -1.116702813755392],
            [26.140962239973117, -1.132904304471485],
            [26.132293079764747, -1.141300089004177],
            [26.111620799613267, -1.147727734794197],
            [26.086947120454042, -1.14767331457448],
            [26.080278839861762, -1.155426293278282],
            [26.074277640114641, -1.191661294269072],
            [26.060274720330387, -1.238881916363148],
            [26.0589416402117, -1.259591575735583],
            [26.07961427968932, -1.264815273862415],
            [26.081118532887061, -1.275595676252204],
            [26.081919978342544, -1.281340037859112],
            [26.074609735597075, -1.28250008486993],
            [26.072773796548645, -1.284437632409874],
            [26.07257887650502, -1.284643340343774],
            [26.069369936206659, -1.28802987434199],
            [26.069283238900255, -1.293526828807406],
            [26.069273489484491, -1.294144977424117],
            [26.069159696294204, -1.301359952755065],
            [26.067337418824597, -1.307925213400381],
            [26.067170100416419, -1.308528022580744],
            [26.066670005602777, -1.310329749638798],
            [26.066777849250958, -1.31068254378252],
            [26.067147020001794, -1.311888605483624],
            [26.071728667800993, -1.326865083913149],
            [26.071686894343671, -1.327062179263064],
            [26.067439976785622, -1.347099957869661],
            [26.069319953944259, -1.378591550626218],
            [26.069559656801388, -1.384799988001409],
            [26.065919696744864, -1.393999992337896],
            [26.0650558318519, -1.394595189064489],
            [26.064910193384772, -1.394695532188035],
            [26.061579897878058, -1.396990075646893],
            [26.054101805820061, -1.39755725093285],
            [26.054047316709887, -1.397561383559579],
            [26.052219916148204, -1.397699974370191],
            [26.030049722209899, -1.394520013313878],
            [26.026016811200343, -1.397277921151863],
            [26.025848712156186, -1.397392876173817],
            [26.023659662437527, -1.398889890217127],
            [26.021680342388276, -1.401604526469846],
            [26.021289640816704, -1.402140372827015],
            [26.017279742848089, -1.407639931338435],
            [26.017279742848089, -1.409481952091446],
            [26.017279742848089, -1.409707965180959],
            [26.017279742848089, -1.411317019808602],
            [26.017279742848089, -1.411329990808737],
            [26.026449661725056, -1.423950021257666],
            [26.027867625451574, -1.424993013131376],
            [26.028041333576372, -1.425120784896436],
            [26.034239700951957, -1.429680020898656],
            [26.038391543515267, -1.441971717956029],
            [26.03851228966586, -1.442329189959847],
            [26.039049660072195, -1.443920092882594],
            [26.035639741491948, -1.453660023637175],
            [26.034050090850005, -1.458189669282888],
            [26.033730545730386, -1.458440443663003],
            [26.033438732501935, -1.458669245437084],
            [26.027889662023803, -1.463020103600341],
            [26.022410872140259, -1.46447687566431],
            [26.022266822792865, -1.464515177498807],
            [26.018299982872456, -1.465569930527335],
            [26.016627624342313, -1.466786522290079],
            [26.016483601046069, -1.466891294864639],
            [26.014189864359164, -1.468559920171325],
            [26.01373986409736, -1.472699953104107],
            [26.015087155563862, -1.477447126547506],
            [26.015203868278817, -1.477858361175432],
            [26.016739743072915, -1.483269993131809],
            [26.015757514361461, -1.486733315081628],
            [26.015670919463027, -1.487038648087011],
            [26.015370321609389, -1.488100007104662],
            [25.999400609680869, -1.50076956823086],
            [25.991095659726366, -1.501051320601468],
            [25.985229839685786, -1.501250081600987],
            [25.982039879891069, -1.502630013384029],
            [25.958260080135098, -1.494159970584864],
            [25.943479920000748, -1.494870028364915],
            [25.934571859130756, -1.495301913799863],
            [25.933579554915092, -1.495349808047641],
            [25.930600042543663, -1.493740098949691],
            [25.928539919932927, -1.490759944608604],
            [25.928743196105323, -1.485127279132479],
            [25.928979840198931, -1.478570004572102],
            [25.920547307016196, -1.471204292587418],
            [25.920050296118923, -1.470770157587135],
            [25.901300160045501, -1.461599971683625],
            [25.895915443535127, -1.456933712164813],
            [25.892830079978815, -1.454260009000905],
            [25.892368912759725, -1.452466568997865],
            [25.890760080391527, -1.44620995069625],
            [25.890749074232655, -1.446075899498522],
            [25.889590172057684, -1.431961098267454],
            [25.878840120189185, -1.425769997203826],
            [25.868513428144468, -1.416495532310019],
            [25.865489880357785, -1.4137800592612],
            [25.861015629744074, -1.411547897633125],
            [25.860999857124305, -1.411542549932692],
            [25.859900160214767, -1.437749961326537],
            [25.862948501503237, -1.450587753870507],
            [25.866339840228481, -1.464869956278091],
            [25.86508784474227, -1.470502337505474],
            [25.863170040425356, -1.479129982853036],
            [25.85679024480342, -1.492469697233616],
            [25.856643856243046, -1.493446958110187],
            [25.854760080109084, -1.506030020688526],
            [25.856948974419183, -1.519812209437963],
            [25.858509840344464, -1.529640020097462],
            [25.863557856608249, -1.561371008157544],
            [25.866309959567193, -1.57867006250599],
            [25.868700000144134, -1.639359951474558],
            [25.867638358564935, -1.643174836547984],
            [25.866651780210905, -1.64671998142474],
            [25.863009840267477, -1.655459991827869],
            [25.863260012989279, -1.668568597619339],
            [25.861890295980039, -1.669029824880699],
            [25.84937015965826, -1.700309918279312],
            [25.848627111882823, -1.704993916066546],
            [25.848020159771213, -1.708819992026666],
            [25.851998985912456, -1.766075105507083],
            [25.851993178304156, -1.766120189221674],
            [25.850235372922505, -1.779847109458099],
            [25.84675373105334, -1.80703535697343],
            [25.843436595865501, -1.832938590712083],
            [25.843428356517727, -1.832990133832669],
            [25.827161379485265, -1.833758955298555],
            [25.823309247240093, -1.833941017046512],
            [25.815122240692503, -1.837349891980569],
            [25.810030753155477, -1.839469863033462],
            [25.801149029093022, -1.843167956615944],
            [25.795497754590091, -1.842819838478195],
            [25.79527748858073, -1.842806270103023],
            [25.790174130705559, -1.842491900645992],
            [25.787201250595864, -1.84088595573494],
            [25.7781736248599, -1.830579435807439],
            [25.772314181959551, -1.823889847813806],
            [25.765905093174496, -1.819298964458348],
            [25.763784267806763, -1.818679560827672],
            [25.762821930490638, -1.818398502419287],
            [25.760416125378772, -1.817695887389103],
            [25.742357135118652, -1.818406901532088],
            [25.730247096792073, -1.821640987266982],
            [25.726391136825502, -1.821817887147777],
            [25.719961178379776, -1.822112959175861],
            [25.713335018892831, -1.824650971962121],
            [25.698953352316813, -1.839153893985727],
            [25.698205298230285, -1.839555357244822],
            [25.693690663852955, -1.841978055777181],
            [25.677482262366933, -1.850675980598121],
            [25.675961675102336, -1.852538900759443],
            [25.675314234124251, -1.853332099721337],
            [25.674288342798409, -1.854588948458898],
            [25.670660206367685, -1.875287996809196],
            [25.667469223391837, -1.881499958448865],
            [25.662066687899507, -1.886833536216781],
            [25.656509274767334, -1.892320068321582],
            [25.647292796209172, -1.896426462668355],
            [25.640928637561373, -1.899262073468133],
            [25.638917874680551, -1.900157970758868],
            [25.637285218991028, -1.900691334496016],
            [25.632780101365817, -1.902162814738618],
            [25.628423558800442, -1.903585765267269],
            [25.623376968163019, -1.905234100954055],
            [25.613098049423375, -1.91122387733733],
            [25.608969904417297, -1.914977755045546],
            [25.603440089327282, -1.920006213135947],
            [25.601451993636019, -1.921813987148363],
            [25.60025540264326, -1.921888706043896],
            [25.571504393478634, -1.923683927134199],
            [25.564026031926073, -1.928208271926187],
            [25.563509164667789, -1.928520985205483],
            [25.561355965813824, -1.928942447872679],
            [25.560310065413365, -1.929147174438838],
            [25.556423274367912, -1.92990798280816],
            [25.551669777956537, -1.934939125888219],
            [25.547289774090874, -1.939574948498454],
            [25.538156156134512, -1.949241982946081],
            [25.53633199849105, -1.95039220013483],
            [25.535615760935219, -1.950843821980115],
            [25.534502157206749, -1.95154600205175],
            [25.518045092168588, -1.955701004798507],
            [25.515555013404981, -1.957234919830367],
            [25.509821278948856, -1.960766909065446],
            [25.501133399646598, -1.961924945435965],
            [25.50074364220438, -1.962103674636944],
            [25.499279897636018, -1.962774900019516],
            [25.496107080391877, -1.964229848003596],
            [25.4932196776764, -1.966841435722895],
            [25.48869895541641, -1.97093031574293],
            [25.478292121071906, -1.980342996596691],
            [25.474334306525169, -1.986277259447338],
            [25.472373516025247, -1.989217220358534],
            [25.469391122756726, -1.99368893473429],
            [25.457744403114351, -2.005427893431956],
            [25.448147163741563, -2.011184945891048],
            [25.439926205367811, -2.019930898696123],
            [25.439396284690133, -2.020720006289698],
            [25.430340125765795, -2.034196916019292],
            [25.429211248880847, -2.037178481253303],
            [25.425059194315153, -2.048144746765959],
            [25.422588246972133, -2.054670894218895],
            [25.329770893727247, -2.081050539542988],
            [25.298458096883149, -2.091108584816453],
            [25.240084503420807, -2.111983789340608],
            [25.232086302982996, -2.075869610227403],
            [25.211604504299284, -2.086081100847562],
            [25.200372513467411, -2.087979479098932],
            [25.185175826095371, -2.083458834695923],
            [25.175925626578096, -2.077669265305668],
            [25.175264666853295, -2.068693264325412],
            [25.172621546606312, -2.062277017259059],
            [25.178568025477908, -2.051392230008333],
            [25.185175105646501, -2.046278342247826],
            [25.190460624793321, -2.041802597098966],
            [25.197067704961913, -2.037970942417055],
            [25.203013823609105, -2.033496613586218],
            [25.208960304277326, -2.027740182607497],
            [25.207638744153854, -2.020044554254614],
            [25.198388544636547, -2.014254572700056],
            [25.197066984513075, -2.009764327504627],
            [25.200370344035989, -1.998232360623233],
            [25.201691543935056, -1.992465536108259],
            [25.19706662518697, -1.982839345933382],
            [25.188477015288562, -1.980256187192269],
            [25.160066516125646, -1.98532236192639],
            [25.13495909890624, -1.985267062642135],
            [25.118441159532832, -1.976255776859506],
            [25.086726631602101, -1.974903939754881],
            [25.068226622436359, -1.975504293725611],
            [25.055673419128986, -1.98060523061864],
            [25.049065926633663, -1.97033342356664],
            [25.028783403924404, -1.96887747682221],
            [25.024513440986084, -1.968570964170177],
            [25.024499874628649, -1.968569995265934],
            [25.000876825499866, -1.972716924655838],
            [25.000826113805456, -1.972725827345009],
            [24.999999953899895, -1.97287085711621],
            [24.990498534225203, -1.974545222374752],
            [24.989892917908413, -1.974651943352339],
            [24.983949151948988, -1.976953881612969],
            [24.980700492640331, -1.979569687120944],
            [24.97823501064752, -1.981554860715821],
            [24.598389880215485, -1.980783041311686],
            [24.573266898785437, -1.943420205501381],
            [24.532535046998415, -1.912390575353429],
            [24.515102048642323, -1.904045208169783],
            [24.50287673580354, -1.86342347159248],
            [24.489424382677146, -1.818723544981712],
            [24.472652786915297, -1.780348253024772],
            [24.453371880357949, -1.736230390972557],
            [24.444044255046311, -1.715305850640144],
            [24.422831279823637, -1.667718426015931],
            [24.405585120266849, -1.652370284900953],
            [24.409238040317963, -1.625755002018338],
            [24.396153840151229, -1.509575419401458],
            [24.385265279744033, -1.421389519483822],
            [24.368355359598123, -1.393435310590322],
            [24.359886360204708, -1.324843234564429],
            [24.265715040112465, -1.325137476435274],
            [24.126003720116575, -1.32277308607743],
            [24.073567557694297, -1.307883601688653],
            [24.0719491807262, -1.30742405189407],
            [24.068209836456528, -1.311033550411713],
            [24.060291480077808, -1.318676930557199],
            [24.046808400077129, -1.326710852152619],
            [24.024416220754013, -1.331748184413379],
            [24.020783398710762, -1.333450248490029],
            [24.017561280127151, -1.334959887367018],
            [24.01452035712628, -1.338205287124416],
            [24.010244280254149, -1.34276888575239],
            [24.008224830664528, -1.346210298339305],
            [24.00498619116453, -1.351728928815672],
            [23.998359240261841, -1.353101864172039],
            [23.997707797289152, -1.353082156296697],
            [23.974827202149459, -1.352390142874806],
            [23.972907524845162, -1.353650281531782],
            [23.968883160407191, -1.356292002701728],
            [23.966673343435829, -1.360328555161918],
            [23.963852160031529, -1.365481846809998],
            [23.961650201522275, -1.367119528898508],
            [23.95767924013132, -1.370072882782909],
            [23.956038712504963, -1.373041094677625],
            [23.955393092411928, -1.374208981883388],
            [23.951411810276682, -1.37507575979124],
            [23.934370198906745, -1.378785721461511],
            [23.909292719840803, -1.338854569619192],
            [23.905401480338057, -1.319261273036776],
            [23.898268440163861, -1.310881009283434],
            [23.89094891961814, -1.309503485147335],
            [23.865413807305423, -1.296384506097492],
            [23.850309240369135, -1.288624316014647],
            [23.841742320118215, -1.278848029743246],
            [23.838637157693039, -1.259205447540095],
            [23.836715999965165, -1.246653733930202],
            [23.822375923590194, -1.236951989050847],
            [23.803732439998868, -1.214546433823332],
            [23.804330399974464, -1.192137188496506],
            [23.80002840041816, -1.187949106308472],
            [23.768065079577898, -1.175051640262007],
            [23.756976272117488, -1.169363689940594],
            [23.754936959878609, -1.168483324542003],
            [23.738975640011443, -1.160130327394413],
            [23.728675680032918, -1.160162583169098],
            [23.702396258710106, -1.150154984751525],
            [23.677474320240631, -1.149118496694328],
            [23.658233759717621, -1.153380157747674],
            [23.650988759814613, -1.149201387867868],
            [23.648344920017092, -1.138005531965536],
            [23.661050400341505, -1.102953216923198],
            [23.670626399947722, -1.074912864918977],
            [23.665488120065884, -1.046918204267091],
            [23.638502519623479, -1.010588074114479],
            [23.6105452798102, -1.010675473070689],
            [23.581154159920171, -1.009366820479905],
            [23.560890480272292, -0.996825026446215],
            [23.537767680467386, -0.992244899017057],
            [23.537161298785968, -0.992105295532108],
            [23.509689119581711, -0.985780523237587],
            [23.496235545644865, -0.975079448215747],
            [23.469348599983594, -0.953693263523664],
            [23.439158639752428, -0.927176539301948],
            [23.423075650266586, -0.915828115789694],
            [23.401611359665036, -0.900682499634474],
            [23.385500279860256, -0.897931572052028],
            [23.368665239683136, -0.867170776389061],
            [23.35579631987591, -0.85320478110845],
            [23.352088269317498, -0.850601072017537],
            [23.344031160058293, -0.842547467552447],
            [23.308135920405963, -0.819738589729602],
            [23.303982960338459, -0.809947122180634],
            [23.298620399876235, -0.790354923425684],
            [23.28454550796976, -0.783520364903298],
            [23.282263080173983, -0.782412051036361],
            [23.255262360187025, -0.761076835566023],
            [23.256995399914601, -0.751266846307024],
            [23.277744719584859, -0.745599338113974],
            [23.296798799736376, -0.748341181874978],
            [23.309641361176531, -0.757433853934792],
            [23.311161818185415, -0.757130714415535],
            [23.313066480149693, -0.75675088388812],
            [23.315130360413288, -0.751010935649943],
            [23.320844279830872, -0.74527692730124],
            [23.322506607772556, -0.739044188270075],
            [23.322681352553204, -0.738388863189225],
            [23.322233519926201, -0.731495957519257],
            [23.327043479944734, -0.719788010391261],
            [23.328436319589393, -0.703018910819459],
            [23.333475240410902, -0.69154193349002],
            [23.333945532716672, -0.69099709287635],
            [23.336446320296773, -0.68809989743336],
            [23.347183319644181, -0.683294849104305],
            [23.361567133193699, -0.678221773395149],
            [23.371164359990093, -0.674836891558836],
            [23.382353520047523, -0.672787954582789],
            [23.38419132040524, -0.670945010557399],
            [23.385787626665149, -0.669342682920714],
            [23.387382359974936, -0.667741934578267],
            [23.393104199838398, -0.655576964123281],
            [23.397678360179686, -0.649840855199796],
            [23.427079560065515, -0.649186468023085],
            [23.440877280384328, -0.642139954211106],
            [23.457890517567709, -0.637055504911473],
            [23.470857122873902, -0.63318036652584],
            [23.477584679698523, -0.631169799563995],
            [23.496522840347453, -0.624457394368656],
            [23.51723508025772, -0.620190610865551],
            [23.534352719643437, -0.612783430079731],
            [23.539252680073673, -0.594559017354901],
            [23.528441160083545, -0.586188501718244],
            [23.510705119557947, -0.575306097594866],
            [23.502385079703298, -0.570161843246408],
            [23.484422159771206, -0.554109728891449],
            [23.474383560133031, -0.54433609689187],
            [23.466227760160074, -0.519148779981644],
            [23.456656079653737, -0.491864417940342],
            [23.454986407984613, -0.45239508367032],
            [23.445863279655864, -0.447326880509513],
            [23.441929200395535, -0.443166847617986],
            [23.431503240020294, -0.43214586683352],
            [23.423532480419453, -0.418582920099614],
            [23.418747359716861, -0.413522986884142],
            [23.418197446134222, -0.413203279001062],
            [23.411220593343501, -0.409146998349431],
            [23.39866617012401, -0.410963907249397],
            [23.371721223838076, -0.423549850842917],
            [23.355974480949591, -0.423063958318528],
            [23.355020900410871, -0.423507458793014],
            [23.354732030961603, -0.423641808201979],
            [23.349580158671188, -0.426037911788569],
            [23.34153671368577, -0.432295863038528],
            [23.340981291633792, -0.43272799175904],
            [23.338386319289409, -0.434746928042727],
            [23.333370309999207, -0.43664400267515],
            [23.332914746470845, -0.436816298075545],
            [23.3281111860504, -0.438633019528593],
            [23.324655872005568, -0.43870594843019],
            [23.318069360562049, -0.438844966688179],
            [23.310081332646508, -0.439060880288197],
            [23.289524229090844, -0.450507013132642],
            [23.280070527924035, -0.451994274342148],
            [23.24478129445734, -0.457545998725705],
            [23.215770324527568, -0.475176977819724],
            [23.205665123794226, -0.486107957830921],
            [23.200646565983558, -0.491537756501258],
            [23.195425279074495, -0.497186894436083],
            [23.190739317107909, -0.499504936970308],
            [23.189835210385134, -0.499952179273092],
            [23.176922364757139, -0.506339891919701],
            [23.159092169111663, -0.523760998250012],
            [23.126203406560634, -0.536557910531602],
            [23.12042238927955, -0.541744516217528],
            [23.119462172885804, -0.542606001198157],
            [23.117517326583901, -0.544350875421943],
            [23.115577258420991, -0.546719417898367],
            [23.114007731838054, -0.548635582293357],
            [23.106998487594829, -0.557192844296771],
            [23.106411422386994, -0.557410582514815],
            [23.106372066296093, -0.557425179242512],
            [23.105531487531888, -0.557736944754299],
            [23.100830097898584, -0.559477630171489],
            [23.098110447477616, -0.547986928064869],
            [23.098750590542348, -0.542900152987348],
            [23.098918594365077, -0.541565142654846],
            [23.099035287317129, -0.540637863996004],
            [23.107509328055887, -0.52273997118046],
            [23.108346195879616, -0.51621544688502],
            [23.10849980689488, -0.515017837723432],
            [23.109129326483075, -0.510109876188],
            [23.113712487045188, -0.497946002210653],
            [23.113726305829204, -0.489879888202336],
            [23.113729417593351, -0.488069813372364],
            [23.11855735020578, -0.466259871470673],
            [23.11905553699772, -0.465416361755666],
            [23.124860246446154, -0.455588004134969],
            [23.128854446355191, -0.448824938402752],
            [23.126590407073262, -0.438026909183811],
            [23.13117731361011, -0.426449092640999],
            [23.132250132926387, -0.423741186610212],
            [23.132318367158749, -0.423568956023414],
            [23.135076327133334, -0.412090884944959],
            [23.110700006502849, -0.407187028678587],
            [23.092762287907725, -0.405824674219504],
            [23.073017728492882, -0.406321743729375],
            [23.047905929291503, -0.404233067650864],
            [23.010217890385618, -0.404274699249621],
            [22.943618321458665, -0.403650916166555],
            [22.948345501723768, -0.397965033935063],
            [22.949621741841177, -0.396429991851985],
            [22.96648833085106, -0.376143003707272],
            [22.97588558907194, -0.367968152195682],
            [22.976484687212992, -0.367446984890644],
            [22.978603411421314, -0.365603866565603],
            [22.979460036791409, -0.364153637717218],
            [22.97993052403158, -0.363357124237219],
            [22.985241451127877, -0.354365963955718],
            [22.99232121042596, -0.350476950413035],
            [22.99872813067789, -0.340615991385605],
            [23.004898170579303, -0.336267023287641],
            [23.007203443431102, -0.33305096738375],
            [23.007624787435329, -0.332463155357232],
            [23.010158129961344, -0.328928922819687],
            [23.021419289090503, -0.320464012144702],
            [23.023104463884803, -0.319198237721758],
            [23.02327500544823, -0.319070139416528],
            [23.024782409037691, -0.317937892890605],
            [23.028715541473709, -0.316758921809182],
            [23.028987410306243, -0.31667742762425],
            [23.031631409105582, -0.315884879391516],
            [23.039889582884925, -0.310736764510695],
            [23.04163799727862, -0.309646809281941],
            [23.041910379947495, -0.309477000145669],
            [23.044687333900441, -0.307014504192857],
            [23.046504213393522, -0.305403342642323],
            [23.053795168411511, -0.298937908264387],
            [23.055592017270378, -0.298339554906583],
            [23.055682228786129, -0.29830951397396],
            [23.057903128273178, -0.297569951549126],
            [23.072356429204874, -0.286549048678402],
            [23.073804956312337, -0.285444520005889],
            [23.084634364454697, -0.277187055606138],
            [23.116877607523996, -0.28550038130146],
            [23.138387607102121, -0.289493590965405],
            [23.16352280562003, -0.287954056490706],
            [23.192242164442259, -0.287231148934345],
            [23.275594389051594, -0.295236851922244],
            [23.276797508999827, -0.286661769669613],
            [23.276979319928511, -0.285365916816668],
            [23.279211791513035, -0.282780110701364],
            [23.279949320937703, -0.281925846570312],
            [23.28035506659533, -0.281761162907717],
            [23.288397441687241, -0.278496937792873],
            [23.292282243862655, -0.274383315240816],
            [23.292511095071177, -0.274140970548225],
            [23.305317440930686, -0.254186887129723],
            [23.318380814555876, -0.237543066418368],
            [23.31971528077505, -0.235842845703237],
            [23.323831159285966, -0.228961931032881],
            [23.327497399556108, -0.21863496517852],
            [23.356514478928137, -0.187687911424434],
            [23.349682144405396, -0.174922930373208],
            [23.349001526847204, -0.173651318692163],
            [23.347412239124655, -0.170682021399601],
            [23.345823198438808, -0.163790985446004],
            [23.321439319383508, -0.142855987044684],
            [23.308235240838716, -0.123775931699102],
            [23.306900380259115, -0.123504834926843],
            [23.293409360947958, -0.120764950806592],
            [23.286806241451437, -0.112257925811911],
            [23.281235676983524, -0.109644543551348],
            [23.280608978105349, -0.1093505326741],
            [23.280422328850566, -0.109262959121634],
            [23.273575055344629, -0.100394825656703],
            [23.269947441733382, -0.095697876702013],
            [23.263113201883932, -0.089256864502705],
            [23.257968285248779, -0.086513976646194],
            [23.257667927245329, -0.086353848266899],
            [23.254905202606469, -0.084880969385095],
            [23.242603283236914, -0.07406784378539],
            [23.23827139403615, -0.072222973176799],
            [23.229374359087998, -0.072894872125028],
            [23.224132580709011, -0.069212109750367],
            [23.191703936144826, -0.035076062905411],
            [23.158382366188242, 0.0],
            [23.153488165755597, 0.007513052106811],
            [23.141145082884773, 0.011800201975876],
            [23.118492926626871, 0.031070529775457],
            [23.093511447820379, 0.053115840042885],
            [23.086857207895999, 0.064738941341737],
            [23.068158088944166, 0.086942483589945],
            [23.056720498896574, 0.10669531952443],
            [23.052629488447707, 0.113760532736027],
            [23.049040288594608, 0.150864115019325],
            [23.045122409552135, 0.157270147518156],
            [23.044116300925474, 0.158176596277648],
            [23.043486864880641, 0.158743683482239],
            [23.037780209240424, 0.163885067517256],
            [23.034755489152332, 0.17328314525744],
            [23.032940549121953, 0.175474691716414],
            [23.032771236453851, 0.175679137933814],
            [23.031538169368982, 0.177168070217805],
            [23.030079760793416, 0.178182179085204],
            [23.029924700795593, 0.178289998389948],
            [23.029247119543097, 0.178761150864892],
            [23.025472974539337, 0.178970035668979],
            [23.018064459695029, 0.179380069331886],
            [23.01576049838356, 0.180777428034629],
            [23.01550453422314, 0.18093267131531],
            [23.013942450182324, 0.18188008306285],
            [23.005672170706195, 0.191015012246847],
            [22.995990456459058, 0.206573952042937],
            [22.994929828179487, 0.2076285140301],
            [22.994428191856858, 0.208127244243469],
            [22.986808069864239, 0.215703503607075],
            [22.980132823735264, 0.24096552841066],
            [22.98010632972257, 0.241067146975829],
            [22.977257760278519, 0.251988955509637],
            [22.971512880424669, 0.26544868842835],
            [22.956279633417193, 0.280517004439168],
            [22.941274320438335, 0.30798804734364],
            [22.931741159691406, 0.335494013372106],
            [22.930559142067523, 0.336589332225414],
            [22.930176239669251, 0.336944149952372],
            [22.930155745504337, 0.340572075990094],
            [22.930135200135489, 0.344209070399676],
            [22.958780400336064, 0.353358115201827],
            [22.960028146790965, 0.354771953762526],
            [22.96285848043474, 0.357979042804275],
            [22.967863199698453, 0.360307980264212],
            [22.971231322363479, 0.368830162845005],
            [22.970969387101384, 0.37004500932834],
            [22.969351440426301, 0.377548978027117],
            [22.969763280254838, 0.384444033967603],
            [22.958452439798869, 0.404818992931227],
            [22.957659063909613, 0.405765119385654],
            [22.952703381880621, 0.411675110156331],
            [22.952224439696998, 0.414889123796036],
            [22.956056279898235, 0.42249515183709],
            [22.952287440344502, 0.440851992022236],
            [22.953376440115665, 0.449130064979208],
            [22.952444333803829, 0.452934598062491],
            [22.951971210906638, 0.454865253358518],
            [22.943025359709285, 0.463545073808467],
            [22.942325520000672, 0.464223993077593],
            [22.931909280295155, 0.486904022589335],
            [22.930139833645718, 0.493128138344304],
            [22.927475520344547, 0.502499978690163],
            [22.936157266848351, 0.536334197547457],
            [22.935428280402011, 0.543223022611175],
            [22.937200171367355, 0.551506956933008],
            [22.938102788683373, 0.553109767838616],
            [22.946678782816974, 0.568340686144475],
            [22.944210559165917, 0.569741605630392],
            [22.937060159947144, 0.573800042833729],
            [22.937029919959755, 0.578410010948004],
            [22.93700803610113, 0.581619950749323],
            [22.936979891883269, 0.585748336769135],
            [22.932382365463106, 0.591236458263622],
            [22.924609919741023, 0.59301990315661],
            [22.923486727395208, 0.594376700987053],
            [22.916099879915588, 0.603299880238983],
            [22.910150159922431, 0.605559886067673],
            [22.907244774731623, 0.610632236598199],
            [22.903459920013038, 0.617239994918341],
            [22.896330120062039, 0.625700032514868],
            [22.887619920319938, 0.630240030079263],
            [22.875220080092838, 0.642110037764108],
            [22.874479709296917, 0.650600671318879],
            [22.871131565163807, 0.662013293155165],
            [22.87097997625624, 0.662529951590038],
            [22.868783538792684, 0.664978182774925],
            [22.863389488786538, 0.670989391214156],
            [22.846089960318722, 0.698910068701671],
            [22.850169637621974, 0.703071956181515],
            [22.849920000296109, 0.705369882596675],
            [22.847733838661121, 0.706731796215371],
            [22.846260687833418, 0.707649524733138],
            [22.847336573998053, 0.710646998324034],
            [22.847829514628746, 0.712020354270629],
            [22.845300644814547, 0.714761866109036],
            [22.847979959980975, 0.723970002997741],
            [22.851823393839219, 0.729739837494197],
            [22.85182911880252, 0.729753373888206],
            [22.849499879797296, 0.737310001274274],
            [22.853559960352634, 0.743780032690888],
            [22.853309837038172, 0.74797572428352],
            [22.853300040011696, 0.748140058440647],
            [22.849829999884413, 0.75455006051516],
            [22.850366935506152, 0.755307266779554],
            [22.852779840003713, 0.758710033963112],
            [22.850000280038085, 0.76420901982299],
            [22.857450120080401, 0.777130069509142],
            [22.853499839703922, 0.78791010511505],
            [22.853263964568193, 0.790119780183856],
            [22.853009879683331, 0.792500041402999],
            [22.854570120381204, 0.797800024603287],
            [22.849009919776705, 0.810629959551408],
            [22.849430033987307, 0.81660978197989],
            [22.849372966712263, 0.816698657880074],
            [22.847810040051701, 0.819130003107359],
            [22.84846468462008, 0.82375057674767],
            [22.848689879685388, 0.825340036448172],
            [22.846916229818728, 0.825847265625477],
            [22.843199879725397, 0.826910068985997],
            [22.839070184227126, 0.829871391698436],
            [22.839553171524479, 0.832653410264309],
            [22.839949933130935, 0.834938770756127],
            [22.836260770549689, 0.84187285284735],
            [22.830929999668747, 0.85188994104271],
            [22.831975222739491, 0.856938053673032],
            [22.832930159734293, 0.861550108117289],
            [22.830860612897911, 0.867432786117798],
            [22.83082992015958, 0.867520029550711],
            [22.828630310744774, 0.874268828271796],
            [22.828253028206909, 0.874325753422247],
            [22.827819960289929, 0.874389923525066],
            [22.826259997171494, 0.874680223507759],
            [22.822289999672826, 0.882170057353685],
            [22.820839920276576, 0.894570084861524],
            [22.821513950488786, 0.898984960692811],
            [22.821929999822718, 0.901710064632281],
            [22.830329880143193, 0.909119987148282],
            [22.831240454736001, 0.910553414093187],
            [22.832820000229301, 0.913039933792981],
            [22.831890119942734, 0.915569911932409],
            [22.826409839754142, 0.915299956390305],
            [22.826281837910994, 0.915415323639829],
            [22.823880120133687, 0.917579980501869],
            [22.824473688245874, 0.920025366297502],
            [22.824549966891574, 0.920340289892867],
            [22.821820212220288, 0.925303341688588],
            [22.82180003965227, 0.925340018067041],
            [22.821787907006037, 0.925362045595936],
            [22.820390565005155, 0.927901006731543],
            [22.820804408975086, 0.928494282835105],
            [22.822650000421259, 0.931140075935664],
            [22.823070120021779, 0.936429951588356],
            [22.820574087224443, 0.941376677788735],
            [22.820299919603109, 0.941920031800498],
            [22.822558728893465, 0.946307638609015],
            [22.82226983968123, 0.955500035449721],
            [22.825887246634224, 0.960345044924515],
            [22.823799840391676, 0.964250050621774],
            [22.82347594203619, 0.969312590070517],
            [22.823300159701397, 0.972060080027915],
            [22.82473722969571, 0.974857540368414],
            [22.825550160112083, 0.976440024059558],
            [22.823051771033764, 0.981470482607916],
            [22.818149999599914, 0.991340081803607],
            [22.811720040255892, 0.997049923100705],
            [22.807269835745721, 1.00313001989045],
            [22.805030159672604, 1.006189974648459],
            [22.804171354091295, 1.01059210515812],
            [22.804089464568317, 1.011010718792254],
            [22.802992758150324, 1.013298923577904],
            [22.797608455763314, 1.024530460525055],
            [22.792799880048637, 1.026110040892239],
            [22.787949960271316, 1.033669977611116],
            [22.78718399916788, 1.034685649268357],
            [22.785189839848446, 1.03732992392537],
            [22.78355003985747, 1.044209925503768],
            [22.78406529194487, 1.045816240861568],
            [22.784659693693634, 1.047669306973797],
            [22.788910079646975, 1.060799966742434],
            [22.788564566029127, 1.064440509074376],
            [22.788429840296075, 1.065860053611291],
            [22.783619880277541, 1.067670004802111],
            [22.782430079650041, 1.075239931473605],
            [22.774828512359601, 1.085079357795014],
            [22.778679984343039, 1.089240242883408],
            [22.774290491573002, 1.096569361376764],
            [22.768130159764851, 1.095839988847318],
            [22.759202339551909, 1.098769282227589],
            [22.756430265247591, 1.103579770265702],
            [22.756080725380624, 1.103807766868562],
            [22.754390040320363, 1.104910009252216],
            [22.752510119755613, 1.108150004098],
            [22.749509700892599, 1.114103654951839],
            [22.749345308297269, 1.117449446693036],
            [22.748990039873775, 1.124680044194686],
            [22.740249960368686, 1.133360025401777],
            [22.741329959919, 1.143019895912328],
            [22.740270393448132, 1.14397004721834],
            [22.736494200285492, 1.147357210357878],
            [22.736469972722276, 1.151037766483675],
            [22.738173593522639, 1.156177648565151],
            [22.740289920127438, 1.162559916581544],
            [22.734960120325361, 1.173099941507103],
            [22.730169960073979, 1.172149950190332],
            [22.727210453183947, 1.169830252393749],
            [22.723549375531725, 1.171641796851021],
            [22.720980141716844, 1.180130340320033],
            [22.725740165287061, 1.184760082627638],
            [22.725835852034489, 1.185860656920154],
            [22.725957757011802, 1.187289871349641],
            [22.717959840441608, 1.18700993132536],
            [22.711960079795574, 1.196400044487669],
            [22.714880040151886, 1.203779885446864],
            [22.714160040451645, 1.208600060721178],
            [22.710710160315987, 1.212239963079349],
            [22.705705836310997, 1.212440227339693],
            [22.705459919807012, 1.212450068263794],
            [22.702709880278299, 1.214270017441108],
            [22.700840039709341, 1.220010058151266],
            [22.690559880396304, 1.220409904654534],
            [22.688256451785815, 1.222226008415593],
            [22.687111361208316, 1.223128837397558],
            [22.689353736718843, 1.225903511508021],
            [22.690539781490148, 1.227370411673971],
            [22.689180562193322, 1.229188638140049],
            [22.687518567526592, 1.23141037816742],
            [22.681789920229928, 1.233210030454481],
            [22.682327552045987, 1.23477118036232],
            [22.683139920116979, 1.237130096909262],
            [22.680831241751982, 1.241028151278293],
            [22.68675785168611, 1.242449527877819],
            [22.686520362277829, 1.244286906509507],
            [22.681479960134407, 1.24608991790287],
            [22.676313298879478, 1.250155074061825],
            [22.674820110231053, 1.251330294210853],
            [22.678992296042267, 1.258387932921158],
            [22.680690120014095, 1.261259953426533],
            [22.681349999963921, 1.265169886299021],
            [22.678350120090069, 1.269059993444541],
            [22.67286164636775, 1.271091373365808],
            [22.673509920084111, 1.27639007730343],
            [22.669380000006996, 1.280269896259513],
            [22.668915544055668, 1.283530976828478],
            [22.668890245700609, 1.283710469312812],
            [22.670470080451473, 1.28693991958177],
            [22.669539839940438, 1.288779997671345],
            [22.664299763868922, 1.28972969824351],
            [22.658559840020491, 1.29076999026548],
            [22.654429919943379, 1.293489921074375],
            [22.654426780331491, 1.293502347518716],
            [22.653893958993756, 1.295611297048243],
            [22.653730080234766, 1.296259940717403],
            [22.654056380685322, 1.297026882104454],
            [22.655300022737691, 1.299949952278768],
            [22.655083411973248, 1.300102140562939],
            [22.649789879854119, 1.303820044336867],
            [22.649408593525024, 1.305568929233097],
            [22.649090040145502, 1.307030067788899],
            [22.652999999640429, 1.310410002008749],
            [22.65499015157538, 1.312131455492731],
            [22.655189880300703, 1.31604009408125],
            [22.648524021566431, 1.321059477907331],
            [22.647620160083765, 1.321740083885391],
            [22.646715173012005, 1.32505074378242],
            [22.646679871916298, 1.325180065213565],
            [22.648269960037762, 1.328409995815934],
            [22.647445709052203, 1.329487354163556],
            [22.646869920396131, 1.330239953068436],
            [22.64190856820106, 1.333114684754038],
            [22.638620160237704, 1.335020069258406],
            [22.637909880308857, 1.338689881575333],
            [22.638963535865191, 1.34158850632026],
            [22.639920120370203, 1.344220085715987],
            [22.637850816977263, 1.346509267954422],
            [22.630309134976933, 1.349915551222313],
            [22.627311983286599, 1.351269065427493],
            [22.629369725361823, 1.355480459237181],
            [22.630018741086623, 1.35680720766045],
            [22.625444574457116, 1.365294264028972],
            [22.62446057606455, 1.367118846296488],
            [22.621250092460542, 1.369849902746763],
            [22.617628531697669, 1.364770305511002],
            [22.614287918141596, 1.365584944190809],
            [22.606639919629085, 1.367449975143924],
            [22.606026427782204, 1.368470716102736],
            [22.605419879912485, 1.369479903933161],
            [22.604865954453778, 1.370388108872802],
            [22.604559840045962, 1.370890006837174],
            [22.605220080220228, 1.374570033829405],
            [22.601892360183427, 1.376814314349805],
            [22.598799839749269, 1.378899969481005],
            [22.598759879990485, 1.385339991675495],
            [22.595858798628171, 1.387452939446076],
            [22.594384514126599, 1.388526706246214],
            [22.59435996586485, 1.392668720859086],
            [22.591534132780634, 1.395472822150522],
            [22.590680039761327, 1.396319989536884],
            [22.590517625256272, 1.396392332692366],
            [22.586100120320744, 1.398359983925292],
            [22.584091806247375, 1.397556668694492],
            [22.577899043460846, 1.395081376758792],
            [22.574054011499701, 1.400419076443619],
            [22.572129960298302, 1.403090053072523],
            [22.569888395966458, 1.404609823091492],
            [22.562719919949259, 1.409470009033658],
            [22.562198620403329, 1.410900189307159],
            [22.561549919987211, 1.412679890267073],
            [22.562094136454327, 1.414803405385585],
            [22.56266988019464, 1.417049934338253],
            [22.562279320556879, 1.417526453485702],
            [22.559670000320789, 1.420710068712216],
            [22.559884773132168, 1.422135621168991],
            [22.560329880270618, 1.42509000709667],
            [22.556878473897289, 1.428740439468009],
            [22.555514183610683, 1.429097895486536],
            [22.550010119626602, 1.43054000820831],
            [22.548973161056487, 1.432584052236821],
            [22.547919960047718, 1.434660112488132],
            [22.541289839888705, 1.43598999710475],
            [22.539899880242839, 1.438740030101067],
            [22.535079840228473, 1.441239975979883],
            [22.533289480799237, 1.441228125305148],
            [22.527541155906288, 1.441190075308726],
            [22.52677754838891, 1.44194919101322],
            [22.525179839858868, 1.443539924238503],
            [22.52475365483355, 1.443958422192949],
            [22.524090119638831, 1.444609988726406],
            [22.522920937143713, 1.448287508174658],
            [22.514479920271455, 1.446849934440904],
            [22.513977432345911, 1.447398297930766],
            [22.512179880106181, 1.449359960771395],
            [22.511230494699841, 1.452683232372225],
            [22.510540080115209, 1.455099985164646],
            [22.509059119334442, 1.456063307385894],
            [22.502501636050965, 1.460328753050973],
            [22.497930071840848, 1.461219969690917],
            [22.495220173530569, 1.456370492572232],
            [22.492489615765411, 1.45566163108658],
            [22.491550080386176, 1.45934004090693],
            [22.489597681049339, 1.460839748847766],
            [22.489480079900556, 1.460930082776924],
            [22.483990079940565, 1.461579971818274],
            [22.483982420904479, 1.462861572082008],
            [22.483959839953172, 1.466639988040651],
            [22.480290000133664, 1.468459925677996],
            [22.479360119847101, 1.472590050226655],
            [22.477372096021039, 1.473654397864509],
            [22.476820651709179, 1.473949630659073],
            [22.476268018926156, 1.471059324476384],
            [22.475720159790576, 1.468190025053767],
            [22.473910079645897, 1.466330088453302],
            [22.469749881852149, 1.465913947093634],
            [22.469109840297051, 1.46584992450451],
            [22.463120159646813, 1.473399930291599],
            [22.465130040382018, 1.479620053346701],
            [22.464851064078953, 1.480200642202474],
            [22.463039879904805, 1.483969966942111],
            [22.462762036377313, 1.483722782788723],
            [22.461229338924376, 1.482355842117215],
            [22.460397307630156, 1.478196676597986],
            [22.460122667494947, 1.476823803615349],
            [22.460119920446822, 1.476810072675246],
            [22.457329957091908, 1.47397260388612],
            [22.457171991044142, 1.473811948599228],
            [22.451900040051385, 1.474889965121027],
            [22.448480039678714, 1.47558993889857],
            [22.44559435993197, 1.473339676069066],
            [22.444620119938339, 1.472579959937118],
            [22.441849920418001, 1.475780021387096],
            [22.438224356762223, 1.475293325816198],
            [22.434549840313359, 1.474800058482483],
            [22.434421296786095, 1.474988628537324],
            [22.429706685748446, 1.481896466982346],
            [22.423119840131609, 1.474949962546338],
            [22.420262709742914, 1.475508160742507],
            [22.419690119987546, 1.475620028008441],
            [22.41825850276701, 1.47744383303942],
            [22.413229919757768, 1.483849972584272],
            [22.409754138497537, 1.485872706741982],
            [22.406579999831596, 1.487719898497586],
            [22.399970039664179, 1.485140008320067],
            [22.395621612479051, 1.486029583975622],
            [22.394409539920712, 1.487418627532322],
            [22.392630460636497, 1.48945947483153],
            [22.396014061273842, 1.496183808946595],
            [22.396459951743225, 1.497069940143513],
            [22.38479097005148, 1.499059739890543],
            [22.384483876480029, 1.498665482016125],
            [22.38388992029563, 1.497899975188607],
            [22.384150888072217, 1.496237896869363],
            [22.385080080249267, 1.490319964225123],
            [22.382809919846988, 1.487549995680403],
            [22.380540119669138, 1.487310006448112],
            [22.377549959566647, 1.489349917243172],
            [22.371794617933002, 1.498881847011684],
            [22.364479362588263, 1.50146886378009],
            [22.362630812989845, 1.498671075410463],
            [22.357327478454355, 1.498360234724121],
            [22.353729730233006, 1.498149362721847],
            [22.353104149757353, 1.494224572750884],
            [22.353069959877658, 1.494010067840952],
            [22.351416543223579, 1.491639742377621],
            [22.350809195853248, 1.490769957969174],
            [22.346470079706034, 1.490279966825908],
            [22.33730015993077, 1.494590040813517],
            [22.33635542240771, 1.497625591370805],
            [22.335659999715325, 1.499860060580103],
            [22.333129919870437, 1.502370026330212],
            [22.332738278661068, 1.502231091240636],
            [22.327210079640267, 1.500269950256959],
            [22.323759715312676, 1.50344954208815],
            [22.322419920287221, 1.498840109462862],
            [22.319920080429725, 1.498359952658626],
            [22.317040922451937, 1.493760943815827],
            [22.31674085729928, 1.493281635699785],
            [22.311259920442208, 1.492780034300841],
            [22.30003008017712, 1.498679936967175],
            [22.298727322690826, 1.49798883397681],
            [22.29478991966397, 1.495900069727929],
            [22.291193028435423, 1.495477319007382],
            [22.2904516578146, 1.495390184153415],
            [22.287660119712971, 1.501810054038288],
            [22.28658693927396, 1.502130075805756],
            [22.285377752104299, 1.502488209746652],
            [22.281289919894895, 1.499010011395609],
            [22.277170079813612, 1.499669979290061],
            [22.275220983582074, 1.504602289255659],
            [22.273909920272683, 1.507920012047129],
            [22.269999959879424, 1.511109931294543],
            [22.266393851936055, 1.510837583274808],
            [22.263379919716208, 1.510609958622322],
            [22.259699999900899, 1.514260029649787],
            [22.251260361942588, 1.511900036251684],
            [22.248776425858868, 1.520905817726726],
            [22.247272535580489, 1.526358797496576],
            [22.250757309875034, 1.5316466481179],
            [22.254278400361603, 1.536989095845413],
            [22.257168480056599, 1.548280029253163],
            [22.253389200282665, 1.565042004427248],
            [22.253574239756482, 1.571023140920623],
            [22.261928400320549, 1.584884111481205],
            [22.262087159580716, 1.594545027363989],
            [22.263646217197341, 1.598822909396854],
            [22.265449199752958, 1.603770083836265],
            [22.266309667217534, 1.611135134110262],
            [22.267170360159248, 1.61850209015947],
            [22.26481635549991, 1.628145945569791],
            [22.265877633261415, 1.631919716735815],
            [22.268381399654988, 1.640822122945238],
            [22.269481383127133, 1.642433838181106],
            [22.271335200446362, 1.6451500793121],
            [22.276746359765429, 1.653073080602393],
            [22.28483753403853, 1.671993064906219],
            [22.309143479751338, 1.681503958507173],
            [22.333812120260145, 1.695917590553876],
            [22.346586719657459, 1.700836687191389],
            [22.372439039673409, 1.710682410266664],
            [22.377376079863637, 1.72337357442381],
            [22.374164159853475, 1.742602650015433],
            [22.362104519709284, 1.754252699990863],
            [22.358573280056678, 1.771021552988802],
            [22.357628299988466, 1.784307776520249],
            [22.363655593099676, 1.784350583700933],
            [22.367685239631484, 1.784379022991699],
            [22.381370279772675, 1.788387072939469],
            [22.38188091272287, 1.788860973529659],
            [22.388864399571951, 1.795342097674217],
            [22.391213336834731, 1.796544511904997],
            [22.39478748002535, 1.798374103573311],
            [22.408260480030229, 1.800080066437386],
            [22.413954240354514, 1.802881120208894],
            [22.417474860123871, 1.806011112166121],
            [22.420995496961208, 1.809141132104532],
            [22.425618447500522, 1.818728892500242],
            [22.43023343986475, 1.82830009419454],
            [22.431335388850709, 1.834058232992185],
            [22.431247535412574, 1.835008047221664],
            [22.430254320305217, 1.845746120843646],
            [22.429804324534999, 1.85059791058916],
            [22.429355400454881, 1.855438123430954],
            [22.430467415063653, 1.860047029135134],
            [22.432934261597357, 1.865915855388494],
            [22.435413479729188, 1.871814048757504],
            [22.446350279667151, 1.876952074542196],
            [22.457714382134593, 1.886234081492621],
            [22.467741479743896, 1.890904989247283],
            [22.470948310797969, 1.891176072621774],
            [22.47368040019068, 1.891407024118528],
            [22.480327440118089, 1.888923148239458],
            [22.481992460310678, 1.892657294835823],
            [22.491131399886743, 1.913153076078519],
            [22.491285478924297, 1.923736977880108],
            [22.491218107074616, 1.924201457905021],
            [22.490085239873192, 1.932010104349194],
            [22.486836304781729, 1.94024825098787],
            [22.485199320110855, 1.944399048378014],
            [22.482632091335699, 1.965103838771573],
            [22.482292319749131, 1.967844086071602],
            [22.47950769238701, 1.973533369744754],
            [22.475334239951255, 1.982060128455995],
            [22.467488825875279, 1.989980942996183],
            [22.462209359576864, 1.995311126771896],
            [22.461546834986819, 1.99535775723683],
            [22.452804359674868, 1.99597307896355],
            [22.450315320262039, 1.996148159366222],
            [22.447779981679474, 1.998090508199734],
            [22.445257320122213, 2.000023143254223],
            [22.412990214205681, 2.036835955559568],
            [22.382532360187142, 2.043752014262092],
            [22.38023246195571, 2.046602032833145],
            [22.375148439418698, 2.052902102178715],
            [22.371250701503183, 2.059130472272556],
            [22.367981159957434, 2.064355011741188],
            [22.366890574659791, 2.068783779818545],
            [22.366567439872341, 2.070096000372401],
            [22.363826552379724, 2.087494670895784],
            [22.3631039269039, 2.092081738832134],
            [22.362039360410154, 2.09883934857696],
            [22.363794719679312, 2.127765331726637],
            [22.364083443601515, 2.151605674172587],
            [22.364129873925293, 2.155439381239844],
            [22.353810119569459, 2.16043009110774],
            [22.354424279762917, 2.161905947800455],
            [22.354480178329801, 2.162040017849126],
            [22.371890039677417, 2.158019935502957],
            [22.38093684624134, 2.157519442006409],
            [22.386530159645517, 2.157210005604447],
            [22.387010039670276, 2.153989913193103],
            [22.399589879822447, 2.154079966368732],
            [22.428669667889487, 2.147610109102907],
            [22.43278350812302, 2.147182709118936],
            [22.438969919820501, 2.146540035980065],
            [22.490954529692161, 2.13286413927459],
            [22.490976022783649, 2.132857773368353],
            [22.500213970178777, 2.129313770527221],
            [22.502311243516409, 2.128509181689189],
            [22.516878579285216, 2.122920618148883],
            [22.518167067033211, 2.12113716030834],
            [22.51919016010693, 2.119719884180211],
            [22.550353835715555, 2.113149561884708],
            [22.558815494076448, 2.111365562150495],
            [22.577339879925731, 2.107459997888471],
            [22.577354349090012, 2.107454625097151],
            [22.605320159729427, 2.097069932418799],
            [22.622929919583953, 2.096960064643246],
            [22.631410079646432, 2.093800002600126],
            [22.632906450127578, 2.092932217018941],
            [22.633599960306707, 2.092530031955721],
            [22.644730080388737, 2.086070116522921],
            [22.680869778579336, 2.049960282369384],
            [22.683198813667019, 2.056565068274173],
            [22.68454771132123, 2.060390322509697],
            [22.686478906824107, 2.065866529893527],
            [22.69354807678161, 2.069368985722194],
            [22.701819959750491, 2.062299893634068],
            [22.707982899367909, 2.062337672368805],
            [22.713249959932241, 2.062369958856924],
            [22.716238209318139, 2.060551231857044],
            [22.723160040297671, 2.050709948460239],
            [22.726415384868691, 2.049382817376293],
            [22.727059919796837, 2.049120055017724],
            [22.73018476341155, 2.049600213392289],
            [22.739619960181816, 2.051050009251258],
            [22.744029318296032, 2.049282197372563],
            [22.748100120244295, 2.047650118363091],
            [22.755010113225012, 2.039879935108234],
            [22.757166079788366, 2.038703314750018],
            [22.764189960282501, 2.034870022152813],
            [22.77324863987953, 2.025098908285981],
            [22.778097039707397, 2.019869003758925],
            [22.780079999730184, 2.017730006786536],
            [22.782787434859955, 2.017583459022549],
            [22.783965041755792, 2.01752341497995],
            [22.789093609951102, 2.021068499614239],
            [22.790339999949925, 2.021930056071308],
            [22.80192034127931, 2.034431981439397],
            [22.808778815878487, 2.035169801649337],
            [22.826660040323716, 2.027930030284233],
            [22.831127293959671, 2.031506657744218],
            [22.833029879917358, 2.033029927692504],
            [22.833213865667314, 2.03326325438817],
            [22.833849960025059, 2.034069934150763],
            [22.841870039829942, 2.044130081666627],
            [22.846200119823685, 2.046459902713877],
            [22.848403415026116, 2.046579250223928],
            [22.85579987986916, 2.046979901628286],
            [22.857494593873504, 2.047899587205226],
            [22.859669879605335, 2.049080068926768],
            [22.868250120075313, 2.065470105726574],
            [22.871442376862213, 2.06843660113758],
            [22.873479840368226, 2.070329969592414],
            [22.877820000357801, 2.071279894334018],
            [22.888580039695597, 2.069049892789323],
            [22.892209919756322, 2.074139931007135],
            [22.892600159593851, 2.084029976150755],
            [22.890269880339481, 2.092530031955721],
            [22.894549919680344, 2.100599936647959],
            [22.897739880373397, 2.102930034045349],
            [22.904382102635939, 2.102766379867162],
            [22.90505028301898, 2.102749786070185],
            [22.911940080075485, 2.098880053686003],
            [22.91861987976468, 2.091560128138882],
            [22.919793608633444, 2.091468613508986],
            [22.923879840045021, 2.091150012232645],
            [22.928076711560237, 2.095220994484237],
            [22.928879879984418, 2.09600006967839],
            [22.931577997788029, 2.101300473878294],
            [22.93452000010646, 2.10707996481149],
            [22.937226683346328, 2.110009827642902],
            [22.938158461773089, 2.111018434583321],
            [22.941569879641555, 2.112929941591038],
            [22.945958869355017, 2.115381018179492],
            [22.947729840445469, 2.116370033829683],
            [22.948749476801986, 2.117831676024881],
            [22.948859144928502, 2.117988883098365],
            [22.948599960307789, 2.123049915388042],
            [22.947029642309076, 2.124864201155203],
            [22.945830120113555, 2.126250082050653],
            [22.945825575536539, 2.127494470701467],
            [22.945820040117756, 2.129010057136081],
            [22.933879919923822, 2.136069909209821],
            [22.933510794088736, 2.13697897361003],
            [22.932950039637223, 2.138359968726176],
            [22.933104154607364, 2.138931042743045],
            [22.934069999844652, 2.142509982946981],
            [22.938609960424785, 2.147139968300501],
            [22.940406340363065, 2.147732453682724],
            [22.944309840072801, 2.149019910675075],
            [22.952499839806919, 2.156670052698451],
            [22.956922444478337, 2.159269722112056],
            [22.958420040261522, 2.160150028859629],
            [22.963847567783368, 2.159555343297535],
            [22.974210000200035, 2.158419947003046],
            [22.975485454291551, 2.161679512413227],
            [22.975559958764585, 2.161870153370986],
            [22.972962668766758, 2.169949060360358],
            [22.971129839685844, 2.175650073268141],
            [22.971257146232972, 2.17621012683143],
            [22.972230000126086, 2.180489953968197],
            [22.978149840356249, 2.186050043757558],
            [22.981488138953871, 2.186533377215067],
            [22.984779463746936, 2.187009910157892],
            [22.997199959835697, 2.175600005086735],
            [23.000640120199993, 2.173769984473106],
            [23.002498372501758, 2.174440592250481],
            [23.004519938522208, 2.175170231814552],
            [23.006790000109778, 2.178179967851331],
            [23.004587814326761, 2.185382578878077],
            [23.003280000223739, 2.189659984743332],
            [23.00550011997311, 2.200719920102775],
            [23.007290040126165, 2.206250037821422],
            [23.013209880356328, 2.210429939375458],
            [23.014363096195574, 2.212464954659111],
            [23.01661008006354, 2.216430073503402],
            [23.020940160057282, 2.218989974428292],
            [23.030539920102761, 2.218819962868251],
            [23.040582020475622, 2.21289157585792],
            [23.041329840101874, 2.212450097152735],
            [23.048650351489332, 2.211577912193671],
            [23.049285985011334, 2.206583545527113],
            [23.04961629015142, 2.203988234351013],
            [23.057630280276978, 2.202197994162135],
            [23.064762252354324, 2.195570150292244],
            [23.073132781121203, 2.192821547039859],
            [23.075762399689474, 2.191958066612937],
            [23.089800239683733, 2.177781041574311],
            [23.093920007899815, 2.176771443567952],
            [23.098043160069562, 2.175761016175384],
            [23.100405808318538, 2.174355017277828],
            [23.104929239897441, 2.171663143131668],
            [23.108382080880268, 2.168232196701543],
            [23.11045235984362, 2.166175040999049],
            [23.113731615770849, 2.158325730652782],
            [23.114862360253266, 2.155619141286891],
            [23.123827439889258, 2.148312095991505],
            [23.127765479821687, 2.139823155962182],
            [23.130758159698534, 2.136621036910367],
            [23.147272440233799, 2.128440015972348],
            [23.150370867989267, 2.124833440579896],
            [23.155334280021282, 2.119056003031606],
            [23.158046520239495, 2.11896810952759],
            [23.166698515439393, 2.11868719551065],
            [23.167227060796378, 2.118670035239048],
            [23.169525177668596, 2.11638523752067],
            [23.172977159862029, 2.112952995257023],
            [23.175752399829413, 2.107909013155535],
            [23.177406239589992, 2.099405979142751],
            [23.187963239910662, 2.093029123382853],
            [23.193714860722395, 2.092841453493203],
            [23.193908279681171, 2.09283514254994],
            [23.210331840254195, 2.086124330499708],
            [23.224255199846951, 2.085449267075557],
            [23.232755880125463, 2.086013020446764],
            [23.24202177680402, 2.09164816871438],
            [23.256470879908409, 2.100435495052775],
            [23.271167159853114, 2.106117994227245],
            [23.312563199910109, 2.089857165251117],
            [23.315292359896684, 2.098401137766067],
            [23.320235425985807, 2.103781596179096],
            [23.321880346373938, 2.105572154204684],
            [23.321680239457869, 2.106662009384599],
            [23.319517319934214, 2.118442010926648],
            [23.321760892899004, 2.132286147593106],
            [23.321943359597835, 2.133412068017015],
            [23.323457767351599, 2.135960253901008],
            [23.326471403127403, 2.1410312125876],
            [23.314420439810547, 2.167878999282202],
            [23.315494320037164, 2.179390073000673],
            [23.311973529587927, 2.194784064100545],
            [23.313307320274014, 2.201004117229499],
            [23.319668519871271, 2.208175109791425],
            [23.320221275723462, 2.214846215799978],
            [23.320232280085673, 2.21497902854452],
            [23.320947240237164, 2.223599009619418],
            [23.315393406891424, 2.241894122361545],
            [23.314184279908872, 2.245877126643448],
            [23.313419280002826, 2.258988065946173],
            [23.317465319890264, 2.270977101371002],
            [23.323137480223544, 2.278374118994289],
            [23.324142530634795, 2.27900473473732],
            [23.329061401500059, 2.282090946025182],
            [23.332727160273222, 2.280962004065828],
            [23.33550730863535, 2.278627741395453],
            [23.346060480336256, 2.269767072365017],
            [23.359276202843759, 2.262271614702518],
            [23.362121160162051, 2.260658057930693],
            [23.363588165614875, 2.257881675462519],
            [23.364666360449785, 2.25584113391516],
            [23.367535423160419, 2.253102691367973],
            [23.370416445142414, 2.250352912575861],
            [23.376379320064565, 2.247627095516122],
            [23.389198200117207, 2.245402039789159],
            [23.409618480373624, 2.23424699153914],
            [23.41329740036403, 2.230817079393935],
            [23.421985199716211, 2.231098025570977],
            [23.423373890940908, 2.230548464712656],
            [23.425424280305524, 2.229737042884976],
            [23.428892159984557, 2.223314997615735],
            [23.434160400036877, 2.22173501062022],
            [23.443578359933468, 2.214657014008137],
            [23.449764239828266, 2.212622091237647],
            [23.454342777659949, 2.206386196805968],
            [23.455988187629899, 2.204145169411132],
            [23.457829817505672, 2.203001785146931],
            [23.459659199750853, 2.201866071441672],
            [23.465160360379919, 2.200057154737776],
            [23.470461360194019, 2.192955101000622],
            [23.474594519596032, 2.189988127322878],
            [23.484913199566741, 2.184985105884274],
            [23.500471245939924, 2.183464158236386],
            [23.511444324340637, 2.184217143263505],
            [23.520427199602395, 2.183809045110725],
            [23.524940519744433, 2.183604089577148],
            [23.536110240259145, 2.189650079284288],
            [23.544624050313836, 2.192625085712973],
            [23.546152440344983, 2.193159155155563],
            [23.557394296475316, 2.193145724393437],
            [23.579769220958447, 2.193119172837317],
            [23.566262040057008, 2.321830864554103],
            [23.561203679692746, 2.360018234373002],
            [23.572582560344941, 2.396248575257309],
            [23.569617599782791, 2.376963026636884],
            [23.576492159615462, 2.354711834993472],
            [23.581453319571054, 2.340389118283918],
            [23.58361654631852, 2.338734986988789],
            [23.584440240348613, 2.338105141770294],
            [23.584522162210948, 2.33646998892735],
            [23.585212440251691, 2.32269202583266],
            [23.595504479784342, 2.306905061852842],
            [23.606437319948533, 2.290138061326358],
            [23.607147239652946, 2.285999991985786],
            [23.603729399728529, 2.28368008833742],
            [23.603292368444489, 2.280226133668638],
            [23.604112728826557, 2.277684412694731],
            [23.611669199791404, 2.25427198842223],
            [23.610328200125142, 2.248973113863766],
            [23.605335360182778, 2.242042027502507],
            [23.601572279728337, 2.219932061971988],
            [23.60215284832006, 2.214930142814137],
            [23.602773240126609, 2.209585098814443],
            [23.59907575375593, 2.20184318270975],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Bunia",
        AREA: 65658,
        POPULATION: 3650000,
        DISTRICTS: ["Mambasa", "Aru", "Irumu", "Djugu", "Managi"],
        OBJECTID: 7,
        NOM: "Ituri",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.304940172350928, 2.118999216354669],
            [31.2602594945599, 2.045226257461566],
            [31.244941940663022, 2.016999271560968],
            [31.176508918325979, 1.93477132127637],
            [31.160944360963633, 1.919999330280507],
            [31.149944671769266, 1.90899933718627],
            [31.143944840156294, 1.900999341918167],
            [31.081946552607437, 1.821999385181537],
            [31.046947499231973, 1.776999408939991],
            [31.034947818938079, 1.758999418138062],
            [31.025948059840537, 1.749999423521938],
            [30.998948777158009, 1.727999436973184],
            [30.972949459523921, 1.707999449355632],
            [30.951950005759436, 1.692999459274498],
            [30.898951358730436, 1.649999484428396],
            [30.854952457324252, 1.614999505203832],
            [30.8459526802604, 1.608999509153588],
            [30.818953340085724, 1.584999522144003],
            [30.812953486014887, 1.582999523250103],
            [30.799953800248382, 1.572999530239423],
            [30.700956132171889, 1.495999571158554],
            [30.699956155445378, 1.493999572632428],
            [30.657957107779197, 1.444999593955593],
            [30.632497675834248, 1.411027607456763],
            [30.620824932896394, 1.390836615537837],
            [30.605212272547174, 1.35773862781337],
            [30.600011765467329, 1.348378100249828],
            [30.578740846213879, 1.310091644326422],
            [30.559297263741652, 1.277782656437001],
            [30.540628661458392, 1.246280667000175],
            [30.51084328985479, 1.208097681861023],
            [30.501999507934972, 1.208954769378671],
            [30.472795641865904, 1.211773038097423],
            [30.472786188894215, 1.211770463941076],
            [30.472762291910996, 1.211772769560635],
            [30.468539580356634, 1.210622777836038],
            [30.458211752841382, 1.204719825869454],
            [30.446125002440258, 1.202520744606912],
            [30.424733080118017, 1.194244801481284],
            [30.42343130269369, 1.194280947501277],
            [30.419395918622126, 1.19439299771876],
            [30.418818120434782, 1.194409034988283],
            [30.415095011417222, 1.195504976028555],
            [30.408276062690565, 1.197510503873056],
            [30.408262863744078, 1.197504652993427],
            [30.408241894370402, 1.197510820332356],
            [30.404299973715936, 1.195759695167247],
            [30.398864082878784, 1.193345813634713],
            [30.395507150527269, 1.191855787830032],
            [30.389144236046125, 1.190869698542556],
            [30.362995745074265, 1.200460452294545],
            [30.362984738017129, 1.20045270447614],
            [30.362962721207797, 1.200460781411868],
            [30.358653605197819, 1.197425775973791],
            [30.340147085042915, 1.176079730626673],
            [30.336256277629804, 1.155584766739114],
            [30.332640147182854, 1.151867845750413],
            [30.329474033167354, 1.151377311269085],
            [30.323475269651233, 1.156822057829031],
            [30.320048594795999, 1.157013838586268],
            [30.320046554721987, 1.157011994053618],
            [30.320015553861523, 1.1570137291802],
            [30.314358622667239, 1.151895778715181],
            [30.309055563914523, 1.148997849457222],
            [30.306635690287042, 1.147673760337959],
            [30.301006837733599, 1.139797868512952],
            [30.290317921610061, 1.135083712465192],
            [30.284688347709452, 1.127667831501334],
            [30.271076170819327, 1.119479611912902],
            [30.271066564235632, 1.119473833205517],
            [30.257436857621027, 1.091287864284904],
            [30.252910661926016, 1.087330833150635],
            [30.247433004818049, 1.08681077358651],
            [30.245847953550342, 1.085413854902095],
            [30.243844950316976, 1.080566801128375],
            [30.241540990802136, 1.060210818051196],
            [30.241344073803663, 1.058479791191387],
            [30.238165691496306, 1.050339661718959],
            [30.238165307017344, 1.050338679740919],
            [30.235121227336542, 1.042554873785705],
            [30.231417253332854, 1.026199905236734],
            [30.227779159975501, 1.019655768181749],
            [30.225796316733732, 1.017864890764135],
            [30.222679493277834, 1.010477914859383],
            [30.226221106675393, 0.999947769661087],
            [30.224449218405045, 0.994872800652001],
            [30.214273644550644, 0.985338789607651],
            [30.211138462225303, 0.979559910321735],
            [30.207293732098048, 0.976069835085082],
            [30.197294914352263, 0.971132870158974],
            [30.194588842865123, 0.967885886148142],
            [30.1940258120827, 0.956850840768337],
            [30.191340980362124, 0.951766796892584],
            [30.18862087000371, 0.949667905294661],
            [30.183345164951348, 0.949343890386196],
            [30.178165218511673, 0.944955802791599],
            [30.173019109812135, 0.935017798589009],
            [30.171718092362557, 0.928799842170324],
            [30.173415101562444, 0.919858895432861],
            [30.171634212172943, 0.915702881351011],
            [30.16664038228711, 0.912660925122702],
            [30.164428220712797, 0.906202887513316],
            [30.161258477503591, 0.903639925425418],
            [30.154193604188038, 0.902181836650194],
            [30.148852738938281, 0.889255800532714],
            [30.144571386260463, 0.885314590554837],
            [30.139351592351478, 0.8892691256947],
            [30.136521639593369, 0.891414007739385],
            [30.13050569489916, 0.892321014228568],
            [30.129427857593697, 0.892483024765254],
            [30.12271459476186, 0.895287118705092],
            [30.121338677580518, 0.895588973441537],
            [30.119011559497668, 0.895702200949287],
            [30.118975643954283, 0.895703948879001],
            [30.116461770615427, 0.895825952201751],
            [30.116460512075761, 0.895824508102601],
            [30.116434232760401, 0.895825784009821],
            [30.112971462698731, 0.891851935612638],
            [30.11200966167684, 0.892623049159351],
            [30.110452359368306, 0.893876630306351],
            [30.110427450882124, 0.893874417587157],
            [30.11042449811973, 0.893876794881265],
            [30.106129412896216, 0.893494926730158],
            [30.104490362100186, 0.893349856609524],
            [30.096534826248423, 0.890222211037788],
            [30.096507500395852, 0.890211468442579],
            [30.072637032779937, 0.881960822238496],
            [30.067661197047563, 0.877538950319594],
            [30.063396493745181, 0.870831456167468],
            [30.051097091455087, 0.872293122069147],
            [30.05108367781126, 0.872291398543345],
            [30.051070520187245, 0.872292962918834],
            [30.04450063116975, 0.871448846626339],
            [30.036327689544549, 0.867143922445776],
            [30.031694567381262, 0.86610193015805],
            [30.030936780946949, 0.865273852316031],
            [30.028083827724291, 0.862154902783427],
            [30.026963585445873, 0.86053812596326],
            [30.024989954427308, 0.860834994707217],
            [30.019895047902335, 0.861601688346285],
            [30.019892999743451, 0.8615979112279],
            [30.019866965668232, 0.861601828507566],
            [30.018675025253717, 0.859399802152862],
            [30.015617071093374, 0.853745258355996],
            [30.012938257186857, 0.853983575397605],
            [30.010998947202065, 0.85415610333708],
            [30.008782824955681, 0.854352914470619],
            [30.008780053653034, 0.85435070263212],
            [30.00875503018252, 0.854352924417664],
            [30.007677208148433, 0.853490961983197],
            [30.002440014770599, 0.849740895567331],
            [30.001070237574289, 0.849252876193165],
            [29.999970095998655, 0.848692952004153],
            [29.998862394201556, 0.845178959490999],
            [29.991097322749646, 0.844276808321177],
            [29.988140328447432, 0.841996987488952],
            [29.988123411374023, 0.841983944290976],
            [29.988573402652655, 0.838305951504854],
            [29.986744273732388, 0.837160868866119],
            [29.98674565264637, 0.837157276194767],
            [29.984379032945519, 0.836836086124988],
            [29.983024107595718, 0.836652103899413],
            [29.976621023150035, 0.83578338618995],
            [29.970102879787845, 0.834898922194237],
            [29.970017238900226, 0.834852863994841],
            [29.964614088061914, 0.831923093338346],
            [29.95764752547278, 0.824758798665979],
            [29.955692939636577, 0.822748017141002],
            [29.957050816850373, 0.816309184218031],
            [29.955012102889427, 0.814413969504637],
            [29.953845956700029, 0.813330030729107],
            [29.949868889460067, 0.816503692271849],
            [29.949516426475178, 0.816785028932778],
            [29.944953386378788, 0.817024947910776],
            [29.938436749491331, 0.809435457292461],
            [29.936483361109392, 0.807160073400909],
            [29.930976091936369, 0.803513082046453],
            [29.923682833637987, 0.798683311361314],
            [29.922949126544864, 0.798783131260294],
            [29.920257459543247, 0.799150013180485],
            [29.910682973598345, 0.804686916960791],
            [29.90779612065182, 0.80501583309463],
            [29.907030963540556, 0.80510287266208],
            [29.90703910856524, 0.810900079966928],
            [29.908870424883233, 0.813653953639099],
            [29.89976136507013, 0.824246107529129],
            [29.898639248007701, 0.834362106403964],
            [29.895233295489444, 0.843793084437095],
            [29.887935392002703, 0.847486031297351],
            [29.882471324608357, 0.855083124044541],
            [29.878824172639668, 0.857847959546448],
            [29.87495922053709, 0.866591006248216],
            [29.876829417737191, 0.888193984984491],
            [29.875236751450824, 0.890725438291007],
            [29.868384417734969, 0.888901207065981],
            [29.864959524238941, 0.889827966814337],
            [29.860179453864838, 0.897422990789453],
            [29.860961373539272, 0.904289043366833],
            [29.862037410620889, 0.913740027282377],
            [29.861375372019435, 0.925463977170356],
            [29.862756329647791, 0.930748094155333],
            [29.862567330400228, 0.950517959269338],
            [29.861204373213514, 0.954199083188723],
            [29.854836346420122, 0.945207561725583],
            [29.85147791478035, 0.939948876120341],
            [29.84335309231167, 0.940661423824456],
            [29.838057143724416, 0.941405508761108],
            [29.830231840232688, 0.936498405804058],
            [29.826022369845646, 0.932033351220566],
            [29.821641539529917, 0.930779631632061],
            [29.816730430108642, 0.924298557970373],
            [29.813032158610394, 0.917830989984349],
            [29.807759969564103, 0.910542547675881],
            [29.798104429529388, 0.909631401587748],
            [29.794638716586825, 0.906379673853347],
            [29.786918173725244, 0.907096553427227],
            [29.780792427055577, 0.908233144340128],
            [29.762947984129671, 0.909238722040933],
            [29.756142558641287, 0.907957602661025],
            [29.751847047616252, 0.905098193554208],
            [29.74918989298958, 0.901855471704275],
            [29.743508702791079, 0.896964885995337],
            [29.74531774089003, 0.88730608085501],
            [29.740955630566447, 0.874902065361598],
            [29.738638683209267, 0.87471980127679],
            [29.735248574277655, 0.874453117927267],
            [29.726783540047897, 0.865505043925212],
            [29.714409141007998, 0.864114332154707],
            [29.704689332802907, 0.864407197434057],
            [29.695989222039742, 0.868326471469148],
            [29.688712908662541, 0.875876306941465],
            [29.6689471283457, 0.897745762619887],
            [29.663648654594205, 0.906120904150664],
            [29.659118275444882, 0.907676460008461],
            [29.648528309648263, 0.901533987902905],
            [29.640871837327662, 0.901046875998659],
            [29.636726441074892, 0.895377602335886],
            [29.633985763788058, 0.886109304859504],
            [29.627351690143417, 0.881616975206422],
            [29.626163332210286, 0.873570845846664],
            [29.627910770135276, 0.863549382450223],
            [29.627487770535961, 0.856315077879603],
            [29.623192614345474, 0.853455628623117],
            [29.618748172527816, 0.853405902936092],
            [29.613834063631867, 0.854556012966292],
            [29.607962828546814, 0.858506834471235],
            [29.60013434232404, 0.861230681611571],
            [29.590862695529367, 0.860725694260968],
            [29.585948850738092, 0.861875563335921],
            [29.57252518441198, 0.870963347535916],
            [29.566718029749349, 0.873709971221206],
            [29.559784803640461, 0.874837359039855],
            [29.547535447393106, 0.869479295153131],
            [29.537349976799213, 0.863340876931721],
            [29.528502624974504, 0.862438729176276],
            [29.522909310671999, 0.861171289423819],
            [29.520848672428261, 0.854320293017105],
            [29.521638151425805, 0.847099486025894],
            [29.528213185094977, 0.83753353456799],
            [29.529238104443664, 0.825897252098674],
            [29.5291146247197, 0.813043037569638],
            [29.532307101593858, 0.806250706386241],
            [29.533286659613935, 0.803048449722129],
            [29.536858432150481, 0.788718135090023],
            [29.521140271857707, 0.789858598117213],
            [29.509634322711953, 0.790211642608297],
            [29.494569057069306, 0.801024442999428],
            [29.491466579708561, 0.820550990916988],
            [29.486108703960561, 0.842017989171561],
            [29.481319628874047, 0.845014049618424],
            [29.475398125862284, 0.8528380579709],
            [29.458051101668801, 0.86021850676286],
            [29.454856772468531, 0.858617126058206],
            [29.451879935279997, 0.851956071078346],
            [29.44707861974943, 0.847366023014076],
            [29.445250675707033, 0.839323584022858],
            [29.444780741829103, 0.837256005476725],
            [29.442436677028411, 0.83451148676009],
            [29.442036365279897, 0.834042174849711],
            [29.436417896352832, 0.832271336943914],
            [29.429700715069725, 0.830154108228828],
            [29.425631122253851, 0.827303677749711],
            [29.419876684325356, 0.823273141348267],
            [29.416830360652966, 0.817672653843298],
            [29.41575468738904, 0.815695089120046],
            [29.413925889947169, 0.815493067391924],
            [29.411281841740493, 0.815200983310771],
            [29.409590328433506, 0.815014178726682],
            [29.409574538745758, 0.814998840384343],
            [29.40456034854401, 0.809965546843035],
            [29.403208017528765, 0.810334010230278],
            [29.398626983278948, 0.811583110690186],
            [29.396122825219866, 0.816414148107128],
            [29.389042013096283, 0.818731086330974],
            [29.388364236011018, 0.818953054411105],
            [29.386730674819717, 0.820865601008641],
            [29.382665169338342, 0.825627107386809],
            [29.377507161554583, 0.827816712110661],
            [29.369724695125512, 0.822106779416432],
            [29.370599853638225, 0.813280193302644],
            [29.369092896511454, 0.803623871638683],
            [29.369545055424847, 0.78756280985682],
            [29.365720421508858, 0.775872136295155],
            [29.364341983654867, 0.763807298921983],
            [29.370555932309006, 0.753433593184393],
            [29.370090093850443, 0.747001962413713],
            [29.361229068768736, 0.723606844817029],
            [29.354276400422147, 0.717504432508654],
            [29.347620732176477, 0.713413444307399],
            [29.347302492308977, 0.71180318059987],
            [29.347005132881943, 0.709791565768677],
            [29.347507845386257, 0.708893569492176],
            [29.350133527536983, 0.704203302859361],
            [29.362855905171866, 0.69309902405639],
            [29.376749002319407, 0.69704278924634],
            [29.389447619515032, 0.683689517328913],
            [29.394274130992716, 0.671448715659888],
            [29.411335220532983, 0.6657967883088],
            [29.431905944344969, 0.651330737323186],
            [29.469513996359598, 0.64871607363466],
            [29.473918588911253, 0.625300283746496],
            [29.45687909936203, 0.61539377318913],
            [29.433713860448112, 0.608513378840001],
            [29.424256649563478, 0.606785075337847],
            [29.407047628157194, 0.603640129224084],
            [29.392181813660507, 0.602932389534864],
            [29.38125943258115, 0.596320154304246],
            [29.365021300452458, 0.610997040045319],
            [29.364338382308869, 0.612606977018753],
            [29.367081218247357, 0.615360071117354],
            [29.366171726124481, 0.616740777934831],
            [29.359096712625998, 0.616291191599925],
            [29.347462331344122, 0.622742016961112],
            [29.339250125256122, 0.625051886524108],
            [29.333999419419847, 0.624140193196225],
            [29.330119361247473, 0.625293976150093],
            [29.328070244795605, 0.628285137889945],
            [29.328303524698423, 0.632421073191641],
            [29.331967238007692, 0.640688969249876],
            [29.331286479414061, 0.644596012336116],
            [29.338830266167058, 0.652629059011565],
            [29.339518225656025, 0.656075083987927],
            [29.336327550802352, 0.659527054197883],
            [29.336560470480833, 0.662744013093906],
            [29.328835243803351, 0.670881018201889],
            [29.326075488096468, 0.673789971068054],
            [29.329741361853991, 0.68435597503082],
            [29.32540840904797, 0.686890061428763],
            [29.308583477612711, 0.679639590914675],
            [29.304352404539703, 0.675575603625914],
            [29.296254218017495, 0.660623704787755],
            [29.295194380255403, 0.650168485990066],
            [29.295004300334568, 0.646149889605075],
            [29.288987990026005, 0.637647713122757],
            [29.287138673266334, 0.634413616698159],
            [29.28554639595054, 0.626362519951459],
            [29.280742563340546, 0.617874007418532],
            [29.281829041540689, 0.612664469881777],
            [29.286340913598508, 0.603878205563223],
            [29.290148987072275, 0.600707347194639],
            [29.291703824403704, 0.594298039601365],
            [29.291939264754841, 0.58988236628683],
            [29.290493867377801, 0.586652926863513],
            [29.286027354851985, 0.587004546017717],
            [29.282709239602148, 0.588574119440043],
            [29.276645049987323, 0.596138128282149],
            [29.271582019281883, 0.600098189670464],
            [29.267433744826906, 0.602060287989561],
            [29.263711351766673, 0.603625351753645],
            [29.260243117253118, 0.608004788682038],
            [29.256603883035286, 0.615595803847117],
            [29.253604007653021, 0.61877566483888],
            [29.22215095594526, 0.616936216074859],
            [29.221242580428282, 0.621533081043795],
            [29.2187355441671, 0.625213057147928],
            [29.21485871094654, 0.625907096190124],
            [29.204594767122678, 0.633503132286669],
            [29.203688648173703, 0.638560000896819],
            [29.197276698254459, 0.640572005511299],
            [29.19456554320114, 0.644546992323567],
            [29.18726259477577, 0.645475137758837],
            [29.185439557331488, 0.64869408893631],
            [29.181795148817642, 0.654903005729689],
            [29.176994134222696, 0.648245700905392],
            [29.175170573060576, 0.649626017238054],
            [29.173350775839459, 0.656063010553197],
            [29.165135589141386, 0.65837111234562],
            [29.162401139874405, 0.661820510898916],
            [29.164916709232543, 0.665495098623589],
            [29.164921749679593, 0.671011139788673],
            [29.162873818105595, 0.676758822469547],
            [29.157602972938964, 0.676151070323851],
            [29.157040115531345, 0.676086138464102],
            [29.134326942106131, 0.66208410772921],
            [29.13379123897294, 0.662007729850541],
            [29.127932885729034, 0.661173021564916],
            [29.122448654749807, 0.654743965700558],
            [29.117652742585644, 0.651762011006379],
            [29.110118691773689, 0.65016223177879],
            [29.103960806078035, 0.653615573431457],
            [29.101664806534977, 0.642358011843937],
            [29.098921610372088, 0.639144103579863],
            [29.08499467099286, 0.633184138417504],
            [29.075633965220913, 0.631356138859282],
            [29.072663969601599, 0.628831035373183],
            [29.070597932483043, 0.617114006474744],
            [29.067626857088719, 0.612291047502946],
            [29.065999659562895, 0.611064986834603],
            [29.062144784761148, 0.608160143256396],
            [29.046151808263364, 0.589518495575969],
            [29.039620697720011, 0.587958473863698],
            [29.034596545201751, 0.586930293997485],
            [29.029069113342235, 0.58647000072018],
            [29.017011290489844, 0.583890629320136],
            [29.012501216859281, 0.574471370070982],
            [29.005480506519735, 0.563420156454146],
            [28.991413167648194, 0.560317940481315],
            [28.971810114450129, 0.562902189722545],
            [28.961751728519484, 0.568110693839579],
            [28.948173267198566, 0.575058181884589],
            [28.940630918648321, 0.57798665312823],
            [28.935821005342202, 0.58027303945132],
            [28.932081650292766, 0.582050537445401],
            [28.915995072037322, 0.585689810884506],
            [28.900915413587246, 0.587634791967515],
            [28.887851030255622, 0.586191194787745],
            [28.875791046056712, 0.585288270378338],
            [28.860214226690712, 0.583330492314435],
            [28.840619453264637, 0.579767813451868],
            [28.826549231699371, 0.578900933398124],
            [28.813482327695084, 0.579133603867182],
            [28.803434741310753, 0.576518543577138],
            [28.790871477770519, 0.576183506334304],
            [28.780821370713596, 0.57524489570814],
            [28.762728873293312, 0.575567137737322],
            [28.753546466037289, 0.573504855351662],
            [28.742628659179427, 0.574248793466951],
            [28.733584029233398, 0.573292160253639],
            [28.720517126127451, 0.573525010915241],
            [28.709966259503563, 0.571477656362765],
            [28.700920549782591, 0.571079900337788],
            [28.689864963818007, 0.570718008870801],
            [28.674284542207715, 0.571554433460523],
            [28.660369111145673, 0.581364642483739],
            [28.657392313483044, 0.572417084219605],
            [28.653578471028553, 0.572418070836916],
            [28.64741129495625, 0.564379136240666],
            [28.646495455337519, 0.558634999239479],
            [28.638733504632967, 0.554273005060254],
            [28.635992467121699, 0.548071084787008],
            [28.631654472970261, 0.544856039415909],
            [28.627318006853123, 0.543939145668865],
            [28.61648950421257, 0.546725009356956],
            [28.615680571299215, 0.546933140385703],
            [28.610885376889037, 0.545326068416856],
            [28.608373299282412, 0.540732114034384],
            [28.604950769253918, 0.538206323546502],
            [28.591942448880847, 0.540280854014432],
            [28.579982292662848, 0.529237120856247],
            [28.57801633505342, 0.527420080301443],
            [28.573906579459489, 0.526733057556819],
            [28.568428465109058, 0.522599026618854],
            [28.554963187920691, 0.519618273794815],
            [28.553592522290486, 0.521457112842941],
            [28.558845636510043, 0.528808001606523],
            [28.554281561554465, 0.532486057105817],
            [28.555654600533639, 0.540298131214877],
            [28.554742386515393, 0.54420495755718],
            [28.547365547166372, 0.544672506037654],
            [28.543790030451692, 0.544899072769742],
            [28.540365585214982, 0.543292120526426],
            [28.533291385590204, 0.543984007580897],
            [28.531692666455459, 0.542147067188462],
            [28.528954261906321, 0.542148148765165],
            [28.526216567026221, 0.544676879368265],
            [28.523248516259489, 0.544908125997709],
            [28.520509639196479, 0.541232061263046],
            [28.516628484181116, 0.540085103918438],
            [28.512291568008031, 0.53549114551932],
            [28.507042833973816, 0.53388527957162],
            [28.505100576616545, 0.536328115028476],
            [28.502479419279936, 0.539631114585407],
            [28.498373623459809, 0.541930075381693],
            [28.497688544867934, 0.544688070427981],
            [28.499515542984351, 0.548364133025973],
            [28.498375423683594, 0.551811126414239],
            [28.501114660971073, 0.555487003700355],
            [28.499975622343587, 0.55962299511355],
            [28.504997616210257, 0.566745130333528],
            [28.498380464130641, 0.572722109895915],
            [28.48788467501349, 0.577781019152518],
            [28.482179401880504, 0.58605602856253],
            [28.476932407882934, 0.587206039669109],
            [28.477161727113749, 0.593181015065954],
            [28.458906507066303, 0.606745029419945],
            [28.452745473673922, 0.615708989013313],
            [28.447040559867038, 0.621225985419867],
            [28.447956759710205, 0.626513010578082],
            [28.446357835759557, 0.629729598136789],
            [28.44247905588982, 0.628352153010757],
            [28.434263633833108, 0.635018843709207],
            [28.423308378906007, 0.635481948802518],
            [28.418287750478594, 0.645135062432187],
            [28.410072627560918, 0.65249095368704],
            [28.402770033071771, 0.652723126243647],
            [28.397976629902239, 0.657549967174313],
            [28.394376181345219, 0.657708509743115],
            [28.39272777639211, 0.657781070600033],
            [28.390901531063861, 0.663526982032397],
            [28.38473974488328, 0.663988089575237],
            [28.378119443310307, 0.661921380162882],
            [28.376979592605878, 0.67042398250263],
            [28.374696836026665, 0.674791106550372],
            [28.375383714842357, 0.677778993863863],
            [28.35803677239554, 0.686975131077929],
            [28.351645449591881, 0.686287136847546],
            [28.349590821077427, 0.687666097653426],
            [28.343427064891412, 0.695022756149668],
            [28.337744761680238, 0.697827820682649],
            [28.326390022352978, 0.697500380330965],
            [28.314313108504237, 0.696999188341747],
            [28.269956637190795, 0.690430359025278],
            [28.261099344609065, 0.690879015341785],
            [28.259145194455751, 0.690977984053266],
            [28.248502260396712, 0.688020597260133],
            [28.239670744972095, 0.687863444699665],
            [28.228226015114668, 0.687180257876679],
            [28.182888260117455, 0.684473866442468],
            [28.159100823783223, 0.685223008160794],
            [28.140710030891427, 0.682807167714619],
            [28.126283396448937, 0.680032664248904],
            [28.116542520953818, 0.677248788754093],
            [28.105360566283242, 0.674818144392948],
            [28.095984820916819, 0.673435370927359],
            [28.086979694385423, 0.675556331061259],
            [28.073851839689109, 0.678940936575637],
            [28.069517040845213, 0.676412986174012],
            [28.068148595850399, 0.664232169515716],
            [28.064684726250778, 0.663733298094663],
            [28.061759545784394, 0.663312083173682],
            [28.056395661205446, 0.658558770922863],
            [28.0503475505359, 0.653199110697158],
            [28.045098956638803, 0.650899940174117],
            [28.044541651718045, 0.649121627140495],
            [28.043730752392541, 0.64653305167113],
            [28.044317984687002, 0.642987851464706],
            [28.044416045681757, 0.64239710253341],
            [28.043698194751673, 0.641157130739212],
            [28.042819707980819, 0.63963895508751],
            [28.027527307810239, 0.632972079607052],
            [28.025249103892879, 0.633189812080519],
            [28.023240983855647, 0.633381739055246],
            [28.022734481359077, 0.633430151477198],
            [28.020170147854063, 0.634905220372993],
            [28.017941637839936, 0.636186917792442],
            [28.010879327417936, 0.64981039530806],
            [27.987404959350183, 0.679725594841016],
            [27.96641466480834, 0.706474988641399],
            [27.939565875987082, 0.742338820284937],
            [27.934531998307548, 0.748946711569237],
            [27.943733235150255, 0.757163579911573],
            [27.946239193433154, 0.761774995157974],
            [27.938696476573632, 0.765634178307904],
            [27.937490102927445, 0.777129497096574],
            [27.936150917858054, 0.789890322151946],
            [27.954498310443515, 0.84636548060624],
            [27.963755835721951, 0.864725603658443],
            [27.987071817330435, 0.910966964573456],
            [27.995011614698385, 0.922930603439759],
            [28.00073514159789, 0.933134551764999],
            [27.99556082579846, 0.931294534227791],
            [27.992972432715185, 0.930374087889765],
            [27.990464530478068, 0.930603227203762],
            [27.988641298997614, 0.930769864843484],
            [27.987950791886512, 0.93083295245575],
            [27.987037484618597, 0.93323422068385],
            [27.984979048145615, 0.938648015602621],
            [27.982011407010663, 0.940715945334559],
            [27.977138134629229, 0.940425976251508],
            [27.976160876296248, 0.940367809720985],
            [27.974248673873468, 0.940254005833269],
            [27.969827200180994, 0.935915477463721],
            [27.965344746152088, 0.931517070659711],
            [27.957583509608124, 0.927146980290481],
            [27.954157336012837, 0.924155159253819],
            [27.950736464274353, 0.921168151704284],
            [27.945712844457042, 0.920247142970885],
            [27.929272761171003, 0.922540988066905],
            [27.924704722848364, 0.926447044093953],
            [27.922646604379018, 0.931044020333845],
            [27.919678822208585, 0.932651884981215],
            [27.916711645502598, 0.931732061125296],
            [27.9123758073079, 0.92552400760957],
            [27.907125091590121, 0.925062176405633],
            [27.898373613362395, 0.930426080378391],
            [27.89250683481945, 0.934021771694269],
            [27.886115817442967, 0.931491321283424],
            [27.877730860834273, 0.946435708560834],
            [27.922457244008694, 1.00430087147316],
            [27.928721601625057, 1.016759562484336],
            [27.936080857350728, 1.037023906267539],
            [27.933337879478433, 1.042770093881334],
            [27.926714068187668, 1.046446069400012],
            [27.921236079601364, 1.046838442425488],
            [27.91945533304397, 1.04696599753339],
            [27.917123952455096, 1.047132969238907],
            [27.912345567320472, 1.046330015906453],
            [27.910271608857741, 1.045981141972796],
            [27.90751563326161, 1.04459253236277],
            [27.904791837115535, 1.043220322829248],
            [27.898751719655394, 1.046925339439434],
            [27.895426690971131, 1.048964977182538],
            [27.883456113397543, 1.050043494059899],
            [27.879675007348574, 1.050384103005688],
            [27.875102966133067, 1.050795949616913],
            [27.869277228920442, 1.048263737787761],
            [27.863457587675391, 1.045734082816988],
            [27.860947667822128, 1.042974084483105],
            [27.860720868365707, 1.039526064712565],
            [27.852956008017888, 1.038833046150678],
            [27.850070933735616, 1.040404569060282],
            [27.847474673207163, 1.041818977882044],
            [27.844275714988186, 1.045956093359852],
            [27.841312147713104, 1.047255004093816],
            [27.835368598247609, 1.049860019672409],
            [27.833195010331625, 1.051802880957006],
            [27.831254879286686, 1.05353706638973],
            [27.828053760619486, 1.061582041652182],
            [27.825612728972072, 1.062809151362163],
            [27.82439952902801, 1.063418990626262],
            [27.816032827982568, 1.062813988895327],
            [27.813985342871227, 1.062665933250302],
            [27.808413607898501, 1.062263027273169],
            [27.80563692883003, 1.061096035708462],
            [27.802935699262239, 1.059961176702683],
            [27.795626772548651, 1.060877088825862],
            [27.786946816387232, 1.065011115194185],
            [27.785414865434287, 1.065096080298403],
            [27.782836954792106, 1.065239008948313],
            [27.773019978517681, 1.058337432783215],
            [27.770362023492101, 1.063682236458849],
            [27.769362622585664, 1.065692100048366],
            [27.757025786599325, 1.073502060185473],
            [27.753144878620695, 1.07372998133115],
            [27.746752805723762, 1.067289217380432],
            [27.744318858190656, 1.067759270256327],
            [27.742095587151269, 1.068188782795034],
            [27.740815523803981, 1.068436038162365],
            [27.738972718033576, 1.093033632488645],
            [27.740796803811836, 1.098782962788177],
            [27.737821067957803, 1.109127025213049],
            [27.739411713034805, 1.121543137750829],
            [27.766791863431482, 1.145937108556805],
            [27.77091403823415, 1.149609003539523],
            [27.75637346776923, 1.194875595889251],
            [27.755512707453903, 1.211650185645133],
            [27.778531099666591, 1.221016427929941],
            [27.783545177578937, 1.228841094024611],
            [27.772642941219893, 1.239742504744585],
            [27.768030262915818, 1.244479907080748],
            [27.765082224816997, 1.25663609589014],
            [27.777190460224837, 1.282489630300385],
            [27.782608099091998, 1.301479413145177],
            [27.773788955265506, 1.308720275070409],
            [27.770368214680996, 1.3073400138312],
            [27.768720604736924, 1.307484079855098],
            [27.768456800080703, 1.307507151466306],
            [27.765108637083021, 1.307799949705174],
            [27.764927038156753, 1.307904097427745],
            [27.755509419619926, 1.313309159392608],
            [27.750708450839074, 1.320429938592053],
            [27.739978301145765, 1.322029984518554],
            [27.734863142102661, 1.324344562846269],
            [27.734602062935036, 1.324462699389119],
            [27.733348189071528, 1.325030069169594],
            [27.732801075537672, 1.325559072307408],
            [27.732483539051032, 1.325866097502698],
            [27.731838350149335, 1.326489928589825],
            [27.726718435425195, 1.331459966601317],
            [27.715068488136016, 1.333520016816731],
            [27.711410653401948, 1.33558868516957],
            [27.700208424653741, 1.348689880913179],
            [27.682388353919819, 1.350979984707778],
            [27.680304373851733, 1.350812112296655],
            [27.680160280486948, 1.350800504366904],
            [27.676678488599133, 1.350520002736804],
            [27.665589091843859, 1.344728280936078],
            [27.663888657367803, 1.343840350105802],
            [27.661794698813559, 1.343985438342417],
            [27.661663781937332, 1.343994528338359],
            [27.650638489859062, 1.344760042568669],
            [27.645775018097392, 1.341185020913798],
            [27.645618263876884, 1.34106992030951],
            [27.633508588469695, 1.341060004842444],
            [27.631167690230406, 1.341944176469102],
            [27.630784209317106, 1.342089030653228],
            [27.62802849872395, 1.343129957830275],
            [27.626681099459635, 1.344750990548702],
            [27.626235108378978, 1.345287555035908],
            [27.623448583774952, 1.348639971019889],
            [27.620698546042831, 1.358530035034783],
            [27.61805653341861, 1.36049019396223],
            [27.617495741237885, 1.360906255919731],
            [27.61635839054485, 1.36175007699968],
            [27.614201525666228, 1.362151797736151],
            [27.614083018117338, 1.362173866169129],
            [27.61270852117244, 1.362429821641409],
            [27.611287372019916, 1.361132978007374],
            [27.611042288254243, 1.360909328088691],
            [27.607668359777477, 1.357830025414756],
            [27.600492962241013, 1.343521885577294],
            [27.599974131265505, 1.342487303668819],
            [27.599247045654359, 1.341039404503509],
            [27.595818449302698, 1.339430104757374],
            [27.589239843932003, 1.340061475425477],
            [27.589087133926924, 1.340076130287352],
            [27.581650352693948, 1.340789870508614],
            [27.577347718927022, 1.339577383035345],
            [27.576985125640665, 1.339475141639772],
            [27.575939851366016, 1.339180434978582],
            [27.574655119474215, 1.339423191863031],
            [27.574527631467376, 1.339447356253199],
            [27.572298393817867, 1.339869890831023],
            [27.570698555382339, 1.343320052180311],
            [27.57113680029029, 1.353194461709814],
            [27.570809606914352, 1.354121571553579],
            [27.570718355149463, 1.354380065736731],
            [27.570435875416816, 1.355174690001688],
            [27.568848517275466, 1.359639960477301],
            [27.567091512292759, 1.361750755986745],
            [27.565417842222288, 1.363761433921857],
            [27.557178409096394, 1.373659921930789],
            [27.543925507115919, 1.381002597299348],
            [27.53572650805928, 1.387938292339021],
            [27.534789829322648, 1.388730645965103],
            [27.533868431827244, 1.389510071596358],
            [27.521288604251502, 1.410200076920204],
            [27.518637930969625, 1.412855939365304],
            [27.518262083041297, 1.41323252300986],
            [27.516248608146601, 1.415249938147203],
            [27.506198498394653, 1.416160018374428],
            [27.503943544673568, 1.417207762992181],
            [27.503477524755258, 1.417424295041833],
            [27.500258503562772, 1.418919985119144],
            [27.498429468067304, 1.421108680061029],
            [27.497497766895659, 1.422223588850107],
            [27.494308429633428, 1.426040066583211],
            [27.492845839400204, 1.432650533076557],
            [27.492435368604209, 1.434505734120825],
            [27.492018472158943, 1.436389972738346],
            [27.48976113610566, 1.43936288365377],
            [27.48898002671157, 1.440391604750775],
            [27.488357721493468, 1.441211026448581],
            [27.484008479536335, 1.446269932624168],
            [27.483244391420349, 1.449785092652447],
            [27.483012158953048, 1.450853468053213],
            [27.482408641100811, 1.453629920667464],
            [27.481109763438212, 1.460842819979102],
            [27.480580724906126, 1.463780657481562],
            [27.478268645519485, 1.476619974002798],
            [27.479952974100751, 1.485691499397217],
            [27.48031848331852, 1.487660065057679],
            [27.479612261978158, 1.489473636928605],
            [27.478258565523689, 1.492949919532126],
            [27.470499646633101, 1.50085648137453],
            [27.465380525121333, 1.506072997554715],
            [27.462478322661575, 1.509030933581806],
            [27.456068545767046, 1.524439963524667],
            [27.45053037275164, 1.533146459649568],
            [27.449356772341925, 1.534991458159967],
            [27.449198672445231, 1.535240005124231],
            [27.449274343829828, 1.537212516600487],
            [27.449391624280018, 1.540269630232293],
            [27.449648672707003, 1.546970015396845],
            [27.448665013877633, 1.549791486438466],
            [27.448266850000977, 1.550933557994661],
            [27.446989654076088, 1.554600167347824],
            [27.452324729683859, 1.555816045933838],
            [27.473637250816456, 1.560673321694844],
            [27.488702156234663, 1.56785239199457],
            [27.504692822265511, 1.570246011969837],
            [27.512465527600682, 1.565192937253983],
            [27.524577025689577, 1.564512915877878],
            [27.529881649307573, 1.56296782958112],
            [27.531662595290893, 1.562449008460117],
            [27.533302384502132, 1.561432351058219],
            [27.542406905128111, 1.555787027422641],
            [27.548139256178708, 1.555071006221731],
            [27.549886488389454, 1.55485276114679],
            [27.551548909755905, 1.55464501005395],
            [27.574182994605263, 1.538793101866911],
            [27.580816708025438, 1.529828098980516],
            [27.587182940883228, 1.512570194260486],
            [27.586365022122042, 1.498155079973269],
            [27.58301022416763, 1.483787321980397],
            [27.58095314684569, 1.474977332235],
            [27.583902263821194, 1.461891296887268],
            [27.607782120628439, 1.453552984826733],
            [27.610663485766857, 1.453501661416778],
            [27.614063754644349, 1.453441095650976],
            [27.61825101867764, 1.453366514918229],
            [27.623684024126057, 1.461183030235212],
            [27.635808092340735, 1.47539713515602],
            [27.650460725840766, 1.477929054507877],
            [27.66344670421433, 1.474439513360563],
            [27.673929533336921, 1.464012309238064],
            [27.691524875231131, 1.458113032848023],
            [27.715818369395837, 1.453491183192302],
            [27.750579571341895, 1.449613809100359],
            [27.77348533817419, 1.443248183473127],
            [27.773483466983468, 1.446697126388937],
            [27.767992981933247, 1.459802985503625],
            [27.760005787654276, 1.461914050550562],
            [27.752525729184164, 1.463891050804198],
            [27.750625651322707, 1.464393015926223],
            [27.749481573146571, 1.468992140790504],
            [27.750848491005389, 1.473591976601832],
            [27.756557725708777, 1.477964963953353],
            [27.775291745107673, 1.48326403084034],
            [27.791284726995304, 1.484192100413567],
            [27.796764641569652, 1.489944105990309],
            [27.799047759271531, 1.494773976766283],
            [27.799728518763565, 1.502133982225393],
            [27.803611474002711, 1.504436028387269],
            [27.811194505455575, 1.524873086067706],
            [27.806561311427053, 1.544505140497906],
            [27.792298847695978, 1.562912241771421],
            [27.772999628981534, 1.589787070058206],
            [27.761250322632023, 1.607683545899261],
            [27.756219265662544, 1.611962015737104],
            [27.749106455548514, 1.607899741380873],
            [27.739898296288207, 1.604805698080463],
            [27.726495600234131, 1.60690596716966],
            [27.715605472266766, 1.608961519115685],
            [27.707250740374114, 1.594215848504373],
            [27.701392090686166, 1.591527566349564],
            [27.6938503772448, 1.594454492108683],
            [27.677105271004095, 1.591028931892378],
            [27.665799842897702, 1.590764825363706],
            [27.656176512855787, 1.584885352699221],
            [27.645724283945089, 1.572969446124714],
            [27.64153913634259, 1.571647720838651],
            [27.636916532552988, 1.583366389784335],
            [27.643100247507981, 1.654470005625526],
            [27.596130735136505, 1.705573257292418],
            [27.583839969249475, 1.723230961968184],
            [27.579901599635413, 1.728889041027136],
            [27.560047611045881, 1.757412118360081],
            [27.553326057662296, 1.773355871944601],
            [27.555802856631075, 1.799374782180666],
            [27.566651085376922, 1.828036526025141],
            [27.578353234665567, 1.844582399442772],
            [27.585049146537699, 1.8472553537791],
            [27.606007327206473, 1.831989716330787],
            [27.627796665108697, 1.821363190620816],
            [27.650418321766047, 1.814444834428741],
            [27.682251156921414, 1.80829340375182],
            [27.693966397358729, 1.815531092536154],
            [27.713194697674719, 1.840320296323151],
            [27.716536933588252, 1.845845534716222],
            [27.723087856475161, 1.849236908913606],
            [27.73913320475399, 1.857543322061317],
            [27.750021938536062, 1.856418770379854],
            [27.763427243297706, 1.852456989298917],
            [27.769298836810631, 1.845837067037888],
            [27.775172950996211, 1.837355373219911],
            [27.782721781789512, 1.828843734774369],
            [27.792644470908304, 1.828667095014246],
            [27.814547184284265, 1.828277201045095],
            [27.828783607651811, 1.828954505328652],
            [27.847210309798783, 1.827695695785301],
            [27.867358766138491, 1.791966344429941],
            [27.878264233737628, 1.778740797894083],
            [27.8858016110111, 1.778606603468942],
            [27.892490337259254, 1.786865002341307],
            [27.900855166215649, 1.794162112517539],
            [27.910092156006705, 1.776312609179527],
            [27.92016278417799, 1.76124007565206],
            [27.930033611758788, 1.739189688960616],
            [27.934651326916651, 1.730729834980424],
            [27.938223602509737, 1.72112507919056],
            [27.942457251951019, 1.720460099197526],
            [27.943419317975888, 1.721974500251967],
            [27.944651701442833, 1.72391593284308],
            [27.946107952265105, 1.726210030098602],
            [27.944489558229002, 1.727838903101233],
            [27.942261786630056, 1.730081098786867],
            [27.939937924041789, 1.732419784897047],
            [27.940342136275206, 1.734184216032255],
            [27.941308078530515, 1.738400092641953],
            [27.940900374545617, 1.739797997479216],
            [27.940679292865987, 1.740556025581078],
            [27.939698539188235, 1.743918757329307],
            [27.941297998534719, 1.748529893423729],
            [27.945707815688088, 1.7492364583277],
            [27.94578622423931, 1.749249021319182],
            [27.946056238050801, 1.749292580494745],
            [27.956611186619334, 1.753811297022382],
            [27.962671963534451, 1.755828962679881],
            [27.966350108278728, 1.755808408910831],
            [27.981725370847773, 1.755722500336617],
            [28.006856438912028, 1.751319135022223],
            [28.021099820629797, 1.746876664568027],
            [28.040717701419979, 1.739829312010828],
            [28.112430982204046, 1.714067445652384],
            [28.153903646758092, 1.701693289420551],
            [28.180300610839275, 1.690053001234274],
            [28.198730784076464, 1.686001322049785],
            [28.209203454151545, 1.68302241234291],
            [28.212132924073433, 1.684366248045795],
            [28.215476201134333, 1.689892131486359],
            [28.209602806499262, 1.697908991325989],
            [28.199535776080655, 1.710189492915398],
            [28.190704624473796, 1.737806684345023],
            [28.191907743523661, 1.776414757682204],
            [28.188127386669709, 1.784859450063149],
            [28.190624704956221, 1.795984831393623],
            [28.231198828749044, 1.828306017470476],
            [28.240402219751793, 1.834657776189707],
            [28.251699008760028, 1.841437525031115],
            [28.261771941110073, 1.844509798628749],
            [28.264674836170958, 1.84539518849071],
            [28.288949973262746, 1.854270804665705],
            [28.298553684098856, 1.874111486280533],
            [28.305218872689927, 2.01421417179252],
            [28.306954214799628, 2.050689201228569],
            [28.308729077391899, 2.087994055860061],
            [28.307447478823811, 2.106629663265876],
            [28.309763779394007, 2.133651017137163],
            [28.312202301148499, 2.211378245284205],
            [28.312362486035024, 2.216483960169868],
            [28.312585809011313, 2.223602088455165],
            [28.31274495095381, 2.22867370912456],
            [28.316793793584889, 2.314446472610369],
            [28.313896943287606, 2.336125285185342],
            [28.321375868982145, 2.335288089596277],
            [28.322131613545857, 2.335203209143768],
            [28.349123209344491, 2.321158197372318],
            [28.378868645443792, 2.296384747973537],
            [28.399566392833588, 2.251626062502955],
            [28.409990989566232, 2.251929687445706],
            [28.425372340916269, 2.26071549251079],
            [28.44036741399918, 2.265958855668426],
            [28.456065713439362, 2.274938033698175],
            [28.460642963086904, 2.277556137509924],
            [28.478448193652344, 2.285621069423364],
            [28.520198998177957, 2.305845945863863],
            [28.556678310749927, 2.323516974168638],
            [28.580580594896571, 2.33396977951533],
            [28.58071302273915, 2.333832155308795],
            [28.587897494158266, 2.326373099900235],
            [28.590178452310262, 2.312566036048193],
            [28.591928915761105, 2.309355083652026],
            [28.596577448523096, 2.300828033339962],
            [28.598006986143712, 2.299460420235443],
            [28.601149766419777, 2.29645396539336],
            [28.601374760262431, 2.288400139462241],
            [28.604575782809871, 2.284717145021117],
            [28.609370923321222, 2.269069172108739],
            [28.610712769200415, 2.269261065977175],
            [28.612521176682037, 2.269519691707572],
            [28.614173359050902, 2.269755974633856],
            [28.619660594894757, 2.264692233810885],
            [28.625149200669451, 2.265608985637038],
            [28.628121349550472, 2.26284597511471],
            [28.629211873762678, 2.259926454063314],
            [28.636115505772885, 2.241444098339695],
            [28.639544289872436, 2.240522168437778],
            [28.644331952807249, 2.242605741757343],
            [28.646407519254417, 2.243508801762587],
            [28.650107411313392, 2.240979506136619],
            [28.652808335454001, 2.239133127527922],
            [28.671328524374271, 2.232220003290883],
            [28.681163530734743, 2.231524131642277],
            [28.683959228934427, 2.229790242265609],
            [28.690077312974783, 2.225996075085144],
            [28.695565768730795, 2.224842039982092],
            [28.696364097930513, 2.221737052034612],
            [28.697163609313179, 2.218630092866209],
            [28.706107716880535, 2.214663135569928],
            [28.706599503176086, 2.214445023061969],
            [28.714310338842736, 2.211024966897687],
            [28.718651649574191, 2.204121220684657],
            [28.728376737178156, 2.205718674258794],
            [28.738789603709833, 2.204959074343296],
            [28.751208875394852, 2.197100804732826],
            [28.764830160303639, 2.181771630682273],
            [28.769245648521387, 2.187417026912588],
            [28.774901181038757, 2.194648025137881],
            [28.77597068646994, 2.198942950306107],
            [28.77650568173069, 2.201089967191523],
            [28.772622381538419, 2.206154027972252],
            [28.779717258584423, 2.216962964018897],
            [28.777432338862031, 2.220646128462463],
            [28.77720536423411, 2.223637559678397],
            [28.776978379724721, 2.226629111263683],
            [28.772616567641876, 2.230173781095884],
            [28.769894304920076, 2.232386050674743],
            [28.765101267364834, 2.247575031794216],
            [28.759164150735121, 2.262304979459015],
            [28.757532308919235, 2.263705528616807],
            [28.752993394876452, 2.267601103730525],
            [28.75147652214552, 2.276790815526067],
            [28.750714236948276, 2.281408968582491],
            [28.749225309009219, 2.28244713298509],
            [28.747742439308489, 2.283481073006589],
            [28.744541994377748, 2.283713492352814],
            [28.74133982827497, 2.283946005639546],
            [28.73791467696244, 2.294302137816486],
            [28.737134127218813, 2.294979301710156],
            [28.723056173853863, 2.307198044717198],
            [28.719172497267444, 2.315484132842509],
            [28.713002460060991, 2.321930073574582],
            [28.711492668749482, 2.325542733375022],
            [28.709347382256549, 2.33067600620592],
            [28.709349796029752, 2.33619864910046],
            [28.715294277048162, 2.333664099331475],
            [28.723293467429411, 2.325375058624406],
            [28.735870412311435, 2.319613993684699],
            [28.745700199460103, 2.312935011508734],
            [28.75301420884157, 2.303726384962403],
            [28.765367654677473, 2.30900885330672],
            [28.768568091523409, 2.307856960000666],
            [28.774511323883527, 2.302330115157146],
            [28.781829875147078, 2.301865108153965],
            [28.798971133038251, 2.30745050620318],
            [28.807284242390459, 2.305283530760618],
            [28.819033472383175, 2.299555378350025],
            [28.828153320064498, 2.298098768872564],
            [28.841920178761793, 2.295899769603946],
            [28.857141329055594, 2.290154971998142],
            [28.922343765289188, 2.280622156416005],
            [28.947994208707986, 2.275015486198602],
            [28.968780403322299, 2.270472165333967],
            [28.977591127239663, 2.28559207069995],
            [28.976910007523266, 2.291115018717441],
            [28.979886426096854, 2.294104024904078],
            [28.987342080933949, 2.321098983314571],
            [28.988145240375029, 2.324008058653516],
            [28.992947267371296, 2.334032855954308],
            [28.993874276642202, 2.335968088142107],
            [28.996385618528603, 2.338837273388001],
            [29.000514112080992, 2.343554028278733],
            [28.997992613842005, 2.346774581992754],
            [28.997087994181221, 2.347929994216036],
            [29.000527072075581, 2.357130102363398],
            [28.998246113923621, 2.364955971601753],
            [28.987504081315709, 2.372790079256427],
            [28.986375401161823, 2.389128164337178],
            [28.97814624835598, 2.397189982649017],
            [28.974038291189302, 2.405708001907611],
            [28.973259763553369, 2.409145854828401],
            [28.972214172173349, 2.413763002232441],
            [28.968786975396895, 2.41675813454733],
            [28.967419755704153, 2.423202048885041],
            [28.969712152104687, 2.429181108447444],
            [28.974511331441491, 2.423886065853091],
            [28.982514124965324, 2.420427086833759],
            [28.990279827932891, 2.406613200613443],
            [28.998744330360001, 2.407755067398262],
            [29.00023584993858, 2.409146368050198],
            [29.005151989925377, 2.413731129282192],
            [29.011788224916529, 2.414644994006192],
            [29.012680178331838, 2.415698494413245],
            [29.015681730868785, 2.419242942765459],
            [29.016596924598737, 2.419119392778305],
            [29.01911025984673, 2.418779974960587],
            [29.023219296788415, 2.409571100557828],
            [29.027791293088235, 2.406345098633457],
            [29.030149089536359, 2.399344935119887],
            [29.031668963538596, 2.394835619910221],
            [29.042467403159851, 2.400535754195155],
            [29.043895882565089, 2.404072756533083],
            [29.039922564893143, 2.421811470303303],
            [29.052998835630895, 2.427000020903391],
            [29.06578314581644, 2.435860881989509],
            [29.072051093100665, 2.437247743201694],
            [29.082386334412028, 2.429401073972831],
            [29.095546350592123, 2.425793610197082],
            [29.086710650814894, 2.44355538469922],
            [29.093751837353011, 2.452025910476466],
            [29.110354444738515, 2.445566746794239],
            [29.11948754616358, 2.454735931356505],
            [29.127152606378264, 2.456824518964465],
            [29.134771335083883, 2.454661383928097],
            [29.14786164469291, 2.444674865511403],
            [29.16626051074412, 2.411981727371952],
            [29.17517461637765, 2.40130752698302],
            [29.179452340760054, 2.411208676750762],
            [29.188032026969459, 2.430376153105528],
            [29.190848851748012, 2.436669029940149],
            [29.199271045321826, 2.444424391023054],
            [29.204259201448355, 2.455740160440715],
            [29.205117441090966, 2.470619847631808],
            [29.205297080791599, 2.486920236025345],
            [29.20298624377498, 2.52945520754098],
            [29.208637519176236, 2.537932216101679],
            [29.22924555810679, 2.543720944724289],
            [29.23539948043538, 2.524153111977717],
            [29.255949359739549, 2.492370003014013],
            [29.259778349586362, 2.481890619907706],
            [29.263015440390731, 2.473031108877829],
            [29.26613797264028, 2.469252471533255],
            [29.268726479809555, 2.466120060304742],
            [29.272360319644051, 2.443565130240025],
            [29.284023240402547, 2.441938035939828],
            [29.298425400245119, 2.434325095668354],
            [29.301614280264893, 2.424426118186979],
            [29.307050361544864, 2.420385832462961],
            [29.310299279568355, 2.417971116820343],
            [29.315101320039339, 2.41796499434184],
            [29.316296798019433, 2.418763967616178],
            [29.317848479569292, 2.419801000254143],
            [29.323564200109022, 2.417952029252651],
            [29.327905439873543, 2.41380515946002],
            [29.333418363042931, 2.414019014957707],
            [29.333624223668412, 2.414027001490596],
            [29.343466439907349, 2.417234084411775],
            [29.344947834574445, 2.416689997514275],
            [29.348495279834797, 2.415387090459154],
            [29.352041485420045, 2.416421627383683],
            [29.353986359569731, 2.416989007113188],
            [29.36096387980869, 2.417324570823925],
            [29.367941400047624, 2.417660133547152],
            [29.377189804730996, 2.419619447677737],
            [29.383041240048886, 2.420859097489371],
            [29.389223520394417, 2.424992079563428],
            [29.405277938064309, 2.423914816797963],
            [29.410265200367128, 2.423580168229305],
            [29.416675391385024, 2.427022133418665],
            [29.421491399760345, 2.435299088750809],
            [29.426067360325526, 2.436443067007577],
            [29.43155339961341, 2.433673064957176],
            [29.437736109353587, 2.434930122901281],
            [29.443908273770603, 2.436185088862718],
            [29.452947479688916, 2.452401931749209],
            [29.479400280353154, 2.460061045640361],
            [29.47821748568655, 2.463990694330202],
            [29.477806256712441, 2.46535693928223],
            [29.47863251812764, 2.466598021757788],
            [29.479183199769832, 2.46742498928603],
            [29.493829439959917, 2.472004024099034],
            [29.496687672581519, 2.473634103520991],
            [29.507108400270166, 2.479577134034915],
            [29.517529566336727, 2.481172070112633],
            [29.527931520134302, 2.482764064221835],
            [29.532251520132281, 2.484834060868861],
            [29.543421331376791, 2.490185888630634],
            [29.548992239899459, 2.492855088007985],
            [29.56386240044554, 2.49214006521511],
            [29.570957280186434, 2.49511899417574],
            [29.574388440329912, 2.494883114539171],
            [29.581470360076217, 2.488888155309821],
            [29.587188240165901, 2.48818807612189],
            [29.600685359936151, 2.488395146901119],
            [29.613733199893467, 2.493435064906093],
            [29.621511359799051, 2.493652038130969],
            [29.628279741460123, 2.492091343831825],
            [29.63157230682658, 2.491332229660828],
            [29.633816879616273, 2.473491891979333],
            [29.639921039769721, 2.459995861741768],
            [29.649990211771939, 2.425257241280275],
            [29.648151360385356, 2.419968105910553],
            [29.648576520432922, 2.401789088033254],
            [29.648018220178809, 2.398008879269407],
            [29.647421279791054, 2.393967032266997],
            [29.643111859252159, 2.38572638087272],
            [29.642372279872049, 2.384312120628395],
            [29.639152440314305, 2.37350302649317],
            [29.639364480450581, 2.363838065433644],
            [29.644871039954566, 2.341604308366011],
            [29.647556280408551, 2.333085350038991],
            [29.641210200355875, 2.324610458433313],
            [29.643185159982714, 2.314677188941007],
            [29.649390839644738, 2.310394042551409],
            [29.660412600445589, 2.301834193165133],
            [29.665104120288913, 2.286216818610919],
            [29.659476239712593, 2.279864719474312],
            [29.645480159700941, 2.270717771058],
            [29.625427080189922, 2.27932175039175],
            [29.607410880280018, 2.283662620041349],
            [29.605935600445161, 2.275872493122229],
            [29.613929039811953, 2.244643845005876],
            [29.621235600363054, 2.214126626763738],
            [29.610081000291192, 2.210636511489856],
            [29.609971919662904, 2.200712716761668],
            [29.613320639616088, 2.189354173433796],
            [29.623022475227316, 2.187180238078409],
            [29.655989299579886, 2.189398176417381],
            [29.661000562172088, 2.192694899130552],
            [29.663315415556401, 2.194216801533005],
            [29.670631163177951, 2.193053337519434],
            [29.670907744572421, 2.19318352066523],
            [29.67119462245676, 2.193319056403013],
            [29.672902702494142, 2.194124275556655],
            [29.674520610541684, 2.194886532511172],
            [29.676507758510311, 2.193994083456936],
            [29.680690393524895, 2.192115643677127],
            [29.686874406720559, 2.196705115171844],
            [29.690305649509039, 2.197618749724827],
            [29.695561329317037, 2.194848146168841],
            [29.702649833714435, 2.195065086781161],
            [29.710583419232155, 2.192007746555126],
            [29.717046696191755, 2.189516956993623],
            [29.734624397868792, 2.173148061982418],
            [29.737941988502428, 2.172335316180774],
            [29.741253431066319, 2.171524075518976],
            [29.743061187269348, 2.170480483760453],
            [29.747650624360347, 2.167831063603909],
            [29.765001525682635, 2.152612982864489],
            [29.771618319334411, 2.144546955573372],
            [29.772764557958869, 2.140584077798314],
            [29.775478594807606, 2.13119509697113],
            [29.783701345320367, 2.125196960645341],
            [29.784752765868291, 2.121108352643339],
            [29.786424382389999, 2.114607995244203],
            [29.794862414160566, 2.102627959343498],
            [29.801258526781318, 2.09916406126341],
            [29.801305105327113, 2.099117004575334],
            [29.808788278256401, 2.091557038187186],
            [29.82043895857084, 2.08578204684224],
            [29.833694491716745, 2.08299501770921],
            [29.836095922931513, 2.081108159985173],
            [29.839860635624785, 2.078151134812163],
            [29.840280274626618, 2.078173763323022],
            [29.84809041725126, 2.078594861610569],
            [29.852661654474666, 2.076745377475407],
            [29.865040543294366, 2.079565448639866],
            [29.868673156030194, 2.080392753006253],
            [29.875291365426889, 2.074628013206709],
            [29.877249027094624, 2.073966711912733],
            [29.878719281753817, 2.07347005815707],
            [29.880425611873061, 2.070941461997938],
            [29.882139278533263, 2.068401992079442],
            [29.883438312502722, 2.068014452638561],
            [29.886024394220698, 2.067242951506388],
            [29.888822791857791, 2.063708787400487],
            [29.895148266354514, 2.055721546548781],
            [29.897205261929756, 2.05617700171971],
            [29.897228845400953, 2.056666070111826],
            [29.897682921319156, 2.066068722158806],
            [29.901812118252469, 2.072962003188766],
            [29.896814302541717, 2.088847065916925],
            [29.899114340012034, 2.09597410475931],
            [29.902781517225009, 2.098730089154383],
            [29.903694809221541, 2.099415954782884],
            [29.90348617549682, 2.109538982044743],
            [29.901583399096285, 2.110753589548693],
            [29.899147191401987, 2.112308766760655],
            [29.896568584565419, 2.111768559283075],
            [29.890455894908367, 2.110487447590212],
            [29.883833436480433, 2.114872034375675],
            [29.880776271939208, 2.119333011909032],
            [29.879728362007413, 2.120862106551388],
            [29.876985408389668, 2.121787662472201],
            [29.874123092026803, 2.120758351580133],
            [29.871266355100239, 2.119730843863759],
            [29.870687029776828, 2.121095171572986],
            [29.869899292612622, 2.122954069198205],
            [29.872903489789756, 2.139052990384156],
            [29.872214435254463, 2.140405821572558],
            [29.869032413871892, 2.146653113837004],
            [29.865609064579818, 2.149420991868626],
            [29.861492020954, 2.149888940427829],
            [29.852992341398753, 2.148546880199242],
            [29.851430722685194, 2.148301323585479],
            [29.870603249300231, 2.183695876078059],
            [29.871266581475673, 2.181862697947255],
            [29.87343628956793, 2.175864004630454],
            [29.875033250699616, 2.175631230035227],
            [29.879172356050553, 2.185975260565992],
            [29.883970136710442, 2.184355503896422],
            [29.889693167739953, 2.186643809620918],
            [29.898379390548858, 2.185936128437683],
            [29.903873047550331, 2.188454572762452],
            [29.910497291829067, 2.184760650403799],
            [29.914388404669388, 2.186592116953908],
            [29.916454441787945, 2.190039065281806],
            [29.91578124251739, 2.196713036067117],
            [29.917146963820276, 2.204086140286547],
            [29.917400161169599, 2.205453070574587],
            [29.921529356306255, 2.212115985312158],
            [29.920396437900859, 2.217411032826791],
            [29.921321276842079, 2.22224105085835],
            [29.92476035383811, 2.226604965000145],
            [29.925661781784704, 2.237427335151807],
            [29.925699232548933, 2.237876952868648],
            [29.929840943014081, 2.249833367881606],
            [29.931283190897698, 2.250216857114108],
            [29.936704420331129, 2.251658990134588],
            [29.944955251281364, 2.26061498425319],
            [29.945877898333233, 2.264064561262562],
            [29.94680024983942, 2.267513024784853],
            [29.950920126751651, 2.269804207879693],
            [29.957069236805253, 2.25736702499329],
            [29.963913188341223, 2.248609113616991],
            [29.964363188603031, 2.245617039940525],
            [29.965971870952583, 2.244965065799254],
            [29.966647849610663, 2.244691673350041],
            [29.969625302145111, 2.246755951017827],
            [29.96940496606717, 2.250668055869631],
            [29.970422182362277, 2.251049485433418],
            [29.971234538755169, 2.251353419550371],
            [29.975115272460659, 2.246974471645376],
            [29.98243801346668, 2.248799117049256],
            [29.984270085267873, 2.25086495939593],
            [29.985485554356305, 2.25810453557094],
            [29.985660403341516, 2.259145973718307],
            [29.986856184952192, 2.261630106125117],
            [29.988648002347087, 2.265351169775223],
            [29.98751691650487, 2.271336009292106],
            [29.989349319784356, 2.273403066160531],
            [29.994842193454964, 2.274772110513347],
            [29.997825407783697, 2.279365086464785],
            [29.998560436298611, 2.277845701646585],
            [29.999999139430045, 2.274871289412929],
            [30.013824251178519, 2.27684404388869],
            [30.027256451499831, 2.282976202857301],
            [30.030447240439567, 2.304631114970577],
            [30.033321480141215, 2.313633056366666],
            [30.04299143993283, 2.328692048365971],
            [30.046991399839456, 2.339317092624397],
            [30.04817734938937, 2.344105556685316],
            [30.05237051984561, 2.361036040183248],
            [30.053205991687417, 2.364409356239462],
            [30.053560319574821, 2.365839996598861],
            [30.055890326639659, 2.36778659820355],
            [30.057188378750457, 2.368871053091823],
            [30.0576067259749, 2.368823253375665],
            [30.060854280355763, 2.368452029338598],
            [30.066642512905197, 2.362538916186717],
            [30.068458584812824, 2.361802269271516],
            [30.07215935991578, 2.360301138200215],
            [30.079248479659149, 2.36084209510346],
            [30.098171464169614, 2.367266017227674],
            [30.10665344152396, 2.365982084948311],
            [30.114603360210207, 2.371361005758348],
            [30.120125083276097, 2.371979483108693],
            [30.121460279825577, 2.372129036232104],
            [30.125443337031882, 2.369963563488516],
            [30.125604252248717, 2.36987609007678],
            [30.12696072000583, 2.398085330967834],
            [30.131503559686422, 2.432084673589153],
            [30.135538800027494, 2.483095558992317],
            [30.144041279631558, 2.502790101859082],
            [30.144583946504778, 2.504588733801071],
            [30.14536438934892, 2.507174975574787],
            [30.144401470822807, 2.511534177115962],
            [30.147234453598323, 2.512186405763807],
            [30.149652240439444, 2.512743045023452],
            [30.151624992905717, 2.515922715467522],
            [30.154825439633012, 2.521081159713406],
            [30.164791573075568, 2.530623420241057],
            [30.176534520251188, 2.546681073178113],
            [30.187056959687897, 2.555842885849772],
            [30.194191439861505, 2.572816838794883],
            [30.184708319767456, 2.584316570790432],
            [30.208262399841953, 2.592957233897423],
            [30.213267840452868, 2.604517454569495],
            [30.210922800081796, 2.631741083121789],
            [30.208627079914702, 2.669317829981134],
            [30.196401120288971, 2.700599181989392],
            [30.1853077197425, 2.709857066014121],
            [30.179250360018706, 2.737144577584468],
            [30.185585639626744, 2.768092908406981],
            [30.176991719611664, 2.782482426222517],
            [30.160936440457359, 2.789239766150749],
            [30.148623719744833, 2.802401136257743],
            [30.151766880008164, 2.812698519044614],
            [30.160453680433772, 2.817720175997451],
            [30.18026447982108, 2.819955216637162],
            [30.204997560078439, 2.816278630313656],
            [30.213699480048561, 2.824535453202627],
            [30.212502480322353, 2.832968807301348],
            [30.208845599599172, 2.844681146582503],
            [30.210166440172138, 2.862128193766508],
            [30.210651357050686, 2.876855929178077],
            [30.201166260663022, 2.885491125011186],
            [30.198648420363881, 2.885463048804566],
            [30.19638419962228, 2.883137052995457],
            [30.194421759815519, 2.872459817657357],
            [30.194223480072711, 2.871381010844549],
            [30.189184199925105, 2.87155507555899],
            [30.1709714396479, 2.876821998119277],
            [30.167215037269312, 2.877907756270453],
            [30.166210439608967, 2.878198126771895],
            [30.15544931959786, 2.878076984171044],
            [30.146989559377172, 2.875891980337101],
            [30.143346480369988, 2.87495103738893],
            [30.128643359754424, 2.879386148925517],
            [30.126339932940489, 2.879289754476041],
            [30.121090199979673, 2.879070063362449],
            [30.114727200158633, 2.874628110523007],
            [30.111878159997371, 2.881998174870966],
            [30.113137439922177, 2.886505079785965],
            [30.113165160135274, 2.892327957099271],
            [30.116905199700934, 2.89808456362152],
            [30.129938280338102, 2.906263570287619],
            [30.146031000375167, 2.907270664551333],
            [30.167048520158314, 2.903013682907344],
            [30.188712599672321, 2.904568337760385],
            [30.206251440230098, 2.922813998528374],
            [30.17972503250979, 2.9434546510484],
            [30.175068230755585, 2.94707818962166],
            [30.173487990864601, 2.955554907027934],
            [30.171901319934431, 2.964066053480979],
            [30.168976070297735, 2.971487140485554],
            [30.162241440138605, 2.988572082865199],
            [30.161207519670775, 2.999142042608653],
            [30.159338299837675, 3.002571123049127],
            [30.151521359661263, 3.00524401597103],
            [30.145042440337608, 3.011152114308071],
            [30.144380596670523, 3.012884518651495],
            [30.140917199584809, 3.021950067308619],
            [30.139618320125621, 3.02535402318229],
            [30.156566760030934, 3.040362040297433],
            [30.170243160175673, 3.053704182177977],
            [30.185129520041251, 3.061201897936313],
            [30.221113320105832, 3.081262075426844],
            [30.228656266934074, 3.085247994595258],
            [30.234140280521011, 3.088145901974206],
            [30.249700560106014, 3.107275862834472],
            [30.260927160147869, 3.125835892457769],
            [30.273416086301694, 3.142769994372995],
            [30.280233600418885, 3.152013944651905],
            [30.292047720216107, 3.164094069988767],
            [30.311301960284286, 3.179275545325961],
            [30.33366515995634, 3.197635609655646],
            [30.351706560304919, 3.218013075565179],
            [30.359111400141369, 3.229548985295062],
            [30.357880786355508, 3.231589847883565],
            [30.356079480056213, 3.234577144600951],
            [30.35340936004507, 3.248351145913946],
            [30.343608477987274, 3.266461465494446],
            [30.342889440382692, 3.267790108424704],
            [30.342727484018454, 3.269947483011127],
            [30.342354480156303, 3.274916127558192],
            [30.345913440021977, 3.284617132614129],
            [30.346498345679855, 3.291705744914936],
            [30.346521473705192, 3.291986045100916],
            [30.345924425519584, 3.293580559156939],
            [30.342746520217645, 3.302067148872214],
            [30.339965286690692, 3.303369801383447],
            [30.336988346195923, 3.304764114453895],
            [30.342130199575941, 3.316553984309112],
            [30.349243581916788, 3.321690220965869],
            [30.350542207152763, 3.322627895033535],
            [30.352095922488356, 3.322818517413076],
            [30.354660317078803, 3.323133025885205],
            [30.362504039627112, 3.341035227229581],
            [30.368149560420665, 3.357103343962475],
            [30.369191759762149, 3.381014126631083],
            [30.36680622872791, 3.407469047309564],
            [30.375207338842038, 3.402671253168444],
            [30.377874240189545, 3.401148140114606],
            [30.385001415263229, 3.399086237587133],
            [30.396263399944154, 3.395828119742397],
            [30.399159940322704, 3.393695910304123],
            [30.400882277521994, 3.392428188280606],
            [30.406324320022176, 3.397779097467247],
            [30.411701279580107, 3.409111023156894],
            [30.414087193296616, 3.410644512248757],
            [30.417162480450351, 3.412621075837565],
            [30.420206412807435, 3.418423591113736],
            [30.421653480152546, 3.421182058215838],
            [30.422135742509443, 3.424933267318782],
            [30.423134433746839, 3.432702113608383],
            [30.410001720063121, 3.439784050174866],
            [30.40294297954609, 3.445835870303163],
            [30.402298800350767, 3.446388156030411],
            [30.394923480052906, 3.456866405510952],
            [30.384810719996448, 3.477093427033377],
            [30.374265307942935, 3.501646270830458],
            [30.375247858251214, 3.504320983151709],
            [30.376047233988253, 3.506497228905298],
            [30.376046195535839, 3.506523282200785],
            [30.375992520299242, 3.507869101852538],
            [30.375736203999253, 3.514086050770148],
            [30.370483488631677, 3.53358481201521],
            [30.371042732116869, 3.535710068697263],
            [30.372244200063307, 3.540275132379739],
            [30.376081440037698, 3.545609079063589],
            [30.383154360461514, 3.548677001932613],
            [30.391166519820516, 3.549454998313215],
            [30.401514360003638, 3.546347144588261],
            [30.403702944394968, 3.546298075751043],
            [30.408390359835725, 3.546192983422319],
            [30.410585898983978, 3.547377816115604],
            [30.417961319893188, 3.551357985678544],
            [30.431366163819121, 3.562088043465747],
            [30.45108636002518, 3.56115203432047],
            [30.452129339104346, 3.560694391689434],
            [30.455692200353312, 3.559131065783839],
            [30.492652680235818, 3.578955250746518],
            [30.54099240009668, 3.594905050781943],
            [30.558962801198472, 3.595997866443886],
            [30.562960016751898, 3.593998989388376],
            [30.572959881035029, 3.591999136729829],
            [30.572989229893668, 3.59200222532129],
            [30.572999999795634, 3.592000071791392],
            [30.592000080418792, 3.593999920837592],
            [30.596000040325421, 3.596000126466974],
            [30.623000039863534, 3.607000095714175],
            [30.632000039709528, 3.612999891238627],
            [30.64399992032774, 3.622000048397049],
            [30.666999959959231, 3.636000052867931],
            [30.673971372552526, 3.636995817798446],
            [30.686957510826275, 3.633998942049977],
            [30.696957000511951, 3.627998924697014],
            [30.708956963775158, 3.623999008327025],
            [30.718956811888606, 3.620998968807547],
            [30.718990891275567, 3.621002755865139],
            [30.719000160092616, 3.62099997513959],
            [30.728000159938674, 3.622000048397049],
            [30.734999999719186, 3.624000011045474],
            [30.741000119691329, 3.63000005260424],
            [30.746000159630761, 3.637999985003311],
            [30.755000160375058, 3.66599998837273],
            [30.760999920122792, 3.671999925380621],
            [30.770966115549079, 3.67498980277262],
            [30.777955145003453, 3.668999006693031],
            [30.78395511495701, 3.656998871496016],
            [30.785955222021901, 3.64799888954986],
            [30.785955221123633, 3.646999026003928],
            [30.785955204953954, 3.620998938121212],
            [30.790955114637647, 3.602998875148299],
            [30.798954835024912, 3.58999900344425],
            [30.806954559903723, 3.582998937046245],
            [30.813954229902684, 3.579998941097835],
            [30.856953376466212, 3.568998985444451],
            [30.859953180881572, 3.565998946704286],
            [30.861953289743127, 3.562998896238941],
            [30.86195328345498, 3.553998872246348],
            [30.85995316830515, 3.546998892550226],
            [30.849953320191702, 3.523998993984333],
            [30.84595344742166, 3.507999028731718],
            [30.846953495115105, 3.496998946148835],
            [30.853592086387245, 3.486566841180045],
            [30.853615268311476, 3.486530414704363],
            [30.853953517253562, 3.485998909709885],
            [30.86195323764089, 3.480999044019417],
            [30.867952849166606, 3.480999041311417],
            [30.867954405048678, 3.48100007848923],
            [30.867999840039079, 3.48100007848923],
            [30.873999960011282, 3.484999899351728],
            [30.896999999642741, 3.501999935077392],
            [30.908976185398714, 3.504994079872964],
            [30.913951793857287, 3.5039989172748],
            [30.922951561937996, 3.497998940110778],
            [30.928951528298267, 3.495998877990441],
            [30.932951376813786, 3.481998878312108],
            [30.93395141552406, 3.456999011519999],
            [30.935951129126916, 3.401998977562976],
            [30.915953770316364, 3.378001294008963],
            [30.91595182276879, 3.377998957621635],
            [30.910951902305335, 3.365998989565555],
            [30.893952396769414, 3.344999002685563],
            [30.889952533880809, 3.339998938638873],
            [30.886952362952798, 3.329998911024802],
            [30.886952357562915, 3.321784735504889],
            [30.886952353969626, 3.315998984662834],
            [30.884952601739261, 3.310998951151111],
            [30.870692258032239, 3.279882796023046],
            [30.842953498377494, 3.273999104463638],
            [30.83295365655226, 3.263999125666119],
            [30.8289537891721, 3.254999147255392],
            [30.804122621868903, 3.169914150250952],
            [30.778954848642144, 3.067999121668355],
            [30.77695509461515, 3.064999162849701],
            [30.765955189825121, 3.05399900137835],
            [30.762955377324882, 3.047999176464466],
            [30.768954987053938, 3.031999048834599],
            [30.76897936463584, 3.031965806217075],
            [30.779954877470949, 3.016999193880781],
            [30.784954795239447, 3.012999111541052],
            [30.787954602349799, 3.009998995080394],
            [30.795954329025278, 3.006999049967666],
            [30.804954109682345, 3.000999135569513],
            [30.811954139905744, 2.999999143729648],
            [30.815954000099328, 2.99599917884503],
            [30.827953578883612, 2.977999157933821],
            [30.845953129418085, 2.961999066037015],
            [30.850953039101775, 2.948999216418674],
            [30.860952856672455, 2.919999054157574],
            [30.8639526574946, 2.911999247605279],
            [30.869951002395776, 2.905000991091089],
            [30.869952624753164, 2.904999098001178],
            [30.888833780110783, 2.882820629784093],
            [30.890388934547524, 2.87135457453098],
            [30.880952471152689, 2.832999088738497],
            [30.87895235600293, 2.82299909213061],
            [30.869952570854277, 2.80199903316],
            [30.869952569955942, 2.800999046314014],
            [30.860952788400546, 2.790999134828876],
            [30.847953140363284, 2.772999074374123],
            [30.838953359706178, 2.767999191013396],
            [30.828953518779205, 2.755999125818112],
            [30.816953917537028, 2.72699910450005],
            [30.815953859962178, 2.721999202073654],
            [30.803954258720029, 2.696999199239984],
            [30.800435203815887, 2.685337718730992],
            [30.800430658340538, 2.685322654247693],
            [30.772955000859525, 2.608999275330036],
            [30.756955173809409, 2.592999154908985],
            [30.75495541978238, 2.58799924359991],
            [30.754955417087423, 2.582999311402313],
            [30.754955414392498, 2.576999186292806],
            [30.757955217011236, 2.563999205330979],
            [30.76095500256196, 2.511999216446784],
            [30.75895524494171, 2.499999348351949],
            [30.746955280780174, 2.480999274660557],
            [30.745957849879204, 2.469026569293375],
            [30.745955578039808, 2.468999301099127],
            [30.746955271797002, 2.460999197748054],
            [30.74795532488033, 2.452999406254261],
            [30.752955240852231, 2.438999336512443],
            [30.754955352408729, 2.436999313830399],
            [30.760954970222667, 2.436999312023411],
            [30.760956856684736, 2.437000019495638],
            [30.760999920122792, 2.437000019495638],
            [30.768999839936114, 2.439999961581572],
            [30.77497331587691, 2.440995620051785],
            [30.779954598094889, 2.43999924688259],
            [30.802954079872578, 2.429999288904817],
            [30.833953281139202, 2.425999386058763],
            [30.842953052813169, 2.411999211210236],
            [30.857952791745667, 2.389999259787885],
            [30.875952326110394, 2.353999259293313],
            [30.88095223669238, 2.345999370867892],
            [30.885951789744954, 2.34399920988561],
            [30.925951089672285, 2.336999248047221],
            [30.93095064002987, 2.33599924996375],
            [30.93096574520133, 2.336006802318458],
            [30.930999839859663, 2.335999982789845],
            [30.935000159990693, 2.337999973715807],
            [30.936999959831805, 2.339999962656987],
            [30.940999919738434, 2.352999995496321],
            [30.938000039864583, 2.375000007376348],
            [30.944000159836726, 2.393000031713981],
            [30.948000119743348, 2.397999976424669],
            [30.961000080394371, 2.405999920090447],
            [30.984956024506165, 2.40899463511099],
            [31.021743153793381, 2.38338737437238],
            [31.021786441810317, 2.383393913556801],
            [31.021794719785667, 2.383388151448311],
            [31.035396590304586, 2.385442806443032],
            [31.056951272084941, 2.365504807766453],
            [31.068947213590612, 2.342999158126907],
            [31.072947056716249, 2.328999213375876],
            [31.073947106206287, 2.321999188528307],
            [31.075946848555255, 2.316999148741998],
            [31.07594684406363, 2.30799921243142],
            [31.075946841368708, 2.30299930337428],
            [31.077946945738699, 2.300999262299075],
            [31.091946593858665, 2.292999246707674],
            [31.10394613491367, 2.282999299948111],
            [31.103976428800024, 2.282978094180033],
            [31.103976456647796, 2.282978075203661],
            [31.123945727834343, 2.268999291879933],
            [31.126945523266595, 2.268999290976261],
            [31.126945870016247, 2.268999844914234],
            [31.126984463437548, 2.268999844914234],
            [31.1369844651629, 2.284999735204483],
            [31.139967957969368, 2.285994313511152],
            [31.153944762829973, 2.28299928277879],
            [31.153971360148862, 2.28300260818158],
            [31.153984246481627, 2.28299984665148],
            [31.161984100717891, 2.283999879837474],
            [31.175984027315621, 2.289999705383996],
            [31.18198409788042, 2.292999788889057],
            [31.189982416895816, 2.295999110582228],
            [31.198943469384453, 2.295999106967769],
            [31.201943227985726, 2.226999159026429],
            [31.202943277475764, 2.223999118136513],
            [31.211444390742283, 2.218417825065924],
            [31.211478844726624, 2.218422485357119],
            [31.30494019031724, 2.156999202962386],
            [31.305193007679257, 2.131584392759304],
            [31.305219250721358, 2.128946208118947],
            [31.30522057158543, 2.128813422962829],
            [31.304940174147593, 2.123999214841908],
            [31.304940172350928, 2.118999216354669],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Matadi",
        AREA: 53920,
        POPULATION: 5575000,
        DISTRICTS: [
          "Mbanza-Ngungu",
          "Tshela",
          "Lukula",
          "Songololo",
          "Luozi",
          "Moanda",
          "Madimba",
        ],
        OBJECTID: 11,
        NOM: "Kongo-Central",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [14.412763440317027, -4.31460007468092],
            [14.41882224004017, -4.326963740029593],
            [14.41883627980974, -4.334745468366632],
            [14.416066080289399, -4.34389829979391],
            [14.410046159651735, -4.35350639640443],
            [14.403557519658417, -4.360825466162807],
            [14.398456679760979, -4.364941423110631],
            [14.39939735959388, -4.371807890171078],
            [14.405448239769512, -4.379593462405032],
            [14.412429000231672, -4.387837363135509],
            [14.422659480014559, -4.39562582104426],
            [14.431961879734672, -4.403871340174439],
            [14.439409200002594, -4.413488359162375],
            [14.445927719758936, -4.423104534199744],
            [14.455688759737267, -4.428146258457765],
            [14.463589319591895, -4.431355673174671],
            [14.47056071960883, -4.434564533700368],
            [14.473814040275492, -4.435940038556128],
            [14.480509298174074, -4.436333011387589],
            [14.473540055012133, -4.442506537607506],
            [14.470228439971729, -4.445440020048105],
            [14.469568199797497, -4.446024893139581],
            [14.466138479653434, -4.451091974250721],
            [14.464225755309439, -4.458685290264093],
            [14.462949240307553, -4.463752875328396],
            [14.461336005296145, -4.467131571449502],
            [14.459980319971637, -4.469970854415505],
            [14.448375871453276, -4.480163898349715],
            [14.44738536027492, -4.481033930221982],
            [14.444983796109513, -4.481956378155344],
            [14.442571561755187, -4.482882923427664],
            [14.442571439584281, -4.482882970309103],
            [14.438460240397713, -4.49232286505591],
            [14.432957280443132, -4.493250874641458],
            [14.435260199708866, -4.498770935750964],
            [14.433192403688958, -4.511789616113695],
            [14.431860360226125, -4.520175931094524],
            [14.430218639637022, -4.518097227016536],
            [14.430218645026937, -4.518097325282368],
            [14.430218399786861, -4.518097014257389],
            [14.430788640447757, -4.527897210992607],
            [14.427547560225149, -4.533386463121002],
            [14.418734039852319, -4.538871360242993],
            [14.409451079674932, -4.541610469618277],
            [14.395065480274619, -4.547549122540156],
            [14.395076640045394, -4.553955553466182],
            [14.39602344010032, -4.564023481734102],
            [14.396504760124527, -4.573633511883353],
            [14.398395839561726, -4.592395977959764],
            [14.395634640262205, -4.606578833858106],
            [14.392870920290031, -4.61938877003972],
            [14.389175159583004, -4.630367604951137],
            [14.385013560417386, -4.640430846430292],
            [14.380386120098278, -4.649578353519201],
            [14.380402320316131, -4.658729333002118],
            [14.381338319926389, -4.662847890222753],
            [14.386924080295667, -4.670172423994956],
            [14.395295159729836, -4.6770413489173],
            [14.402273400417636, -4.68390930787006],
            [14.405995799766089, -4.688029690821216],
            [14.408326800367627, -4.693063964919021],
            [14.408805599719111, -4.701299567504956],
            [14.408817119714321, -4.707704767909374],
            [14.409762120443762, -4.716855516656242],
            [14.413032359980454, -4.727837833554626],
            [14.419558079733797, -4.741567097915384],
            [14.421427920302756, -4.748430638266205],
            [14.423298480422254, -4.755751743550203],
            [14.424240240030132, -4.763071872373978],
            [14.422869000376478, -4.775422536179496],
            [14.418727560304157, -4.796919951735328],
            [14.416422839916271, -4.806524583776222],
            [14.41226267985177, -4.817500060489524],
            [14.408571959591791, -4.831220141692052],
            [14.406266879877801, -4.840824282570916],
            [14.40535283958466, -4.849057191634796],
            [14.402120759582868, -4.859575125288654],
            [14.402135519801311, -4.867808341329672],
            [14.402149919795313, -4.876041455275878],
            [14.404484159721749, -4.882903981092718],
            [14.407747200159772, -4.889767153882292],
            [14.410071360090411, -4.891141036831646],
            [14.412639596775312, -4.894319486594669],
            [14.412639959694708, -4.89431993710865],
            [14.416210080229455, -4.897479968161361],
            [14.426979840236942, -4.895590020477879],
            [14.429117159571648, -4.894356389097188],
            [14.430020040094018, -4.896379938036777],
            [14.433463164000436, -4.889738368541146],
            [14.435510040054005, -4.885790041708912],
            [14.438030295922941, -4.884323363785199],
            [14.445820080028332, -4.879790030235497],
            [14.446036969270539, -4.879838225479315],
            [14.449960080101238, -4.880709976890621],
            [14.45456016043175, -4.876390005878787],
            [14.457679919581961, -4.874869919658638],
            [14.460500159755215, -4.873560110393168],
            [14.471039880083051, -4.862970028500675],
            [14.471842900285209, -4.861753955040473],
            [14.477630039584982, -4.852989987837795],
            [14.485429437460507, -4.850065166703564],
            [14.485469899377536, -4.850049993280338],
            [14.487347547204635, -4.850536723978579],
            [14.487360120025345, -4.850539984113131],
            [14.490561352778572, -4.851378518484057],
            [14.495109840167352, -4.852569952722709],
            [14.497183290183658, -4.854044452827556],
            [14.498330039949495, -4.854859943931156],
            [14.499533562342961, -4.857267114319107],
            [14.501779920085152, -4.861760040882764],
            [14.502928984809472, -4.861909915320541],
            [14.505230160445244, -4.862210060566184],
            [14.506384427313392, -4.861630740599407],
            [14.507979839749552, -4.86083001197362],
            [14.508271687113998, -4.860902366374449],
            [14.511650039793501, -4.86173992804766],
            [14.514845876366797, -4.864136780622665],
            [14.51625012012401, -4.865189950227312],
            [14.521068647375397, -4.86518007632792],
            [14.525669880244418, -4.86953998242726],
            [14.529634841787596, -4.871220225280181],
            [14.531640120453604, -4.872070006708827],
            [14.535963993088769, -4.870701402245883],
            [14.538970080321233, -4.869749905452293],
            [14.54210722905872, -4.869427869612098],
            [14.552510039849057, -4.868359995968285],
            [14.556469660009562, -4.871960369528768],
            [14.557799879892388, -4.873169897040883],
            [14.559646635555167, -4.873355409295518],
            [14.560089840061829, -4.873399930498861],
            [14.563320119839769, -4.879379887559344],
            [14.566977033800645, -4.881294032312977],
            [14.572509840280556, -4.884190068175869],
            [14.575113911660475, -4.88824083798017],
            [14.578719839940756, -4.893850007580059],
            [14.580339840164573, -4.900750057106428],
            [14.582487065221903, -4.902786096148574],
            [14.585169960174737, -4.905330058946334],
            [14.596692090673702, -4.909808627842834],
            [14.596692423948658, -4.909808756686824],
            [14.597570159727942, -4.910149925545602],
            [14.597571163146132, -4.910149955278814],
            [14.599209692020979, -4.910199033995752],
            [14.604919920261057, -4.910370071101643],
            [14.60636429445694, -4.910849192624835],
            [14.611124000921848, -4.912428058580354],
            [14.613727173986467, -4.916173483348826],
            [14.614800119965203, -4.917719929497845],
            [14.622369638061228, -4.915630064120043],
            [14.636683877092013, -4.921805490425628],
            [14.639362701778294, -4.922962579131903],
            [14.64358361939702, -4.926963874509998],
            [14.643968051626247, -4.92732830324428],
            [14.64396984017197, -4.927329998893956],
            [14.648098499912718, -4.927549872002781],
            [14.648100119575185, -4.9275499584971],
            [14.650644049645125, -4.925883657679198],
            [14.652680039914101, -4.924550060051137],
            [14.662320119942764, -4.925450012645081],
            [14.665280725472419, -4.92330945342974],
            [14.668056181933803, -4.921302752000369],
            [14.678530842675523, -4.923275991622726],
            [14.681360160324711, -4.923809914423539],
            [14.681360704703785, -4.923809396355632],
            [14.687930159835014, -4.917560119815497],
            [14.687951786775502, -4.917548258199972],
            [14.693697254127553, -4.914396919859138],
            [14.69370995989893, -4.914389950619718],
            [14.694959378118568, -4.913910460462619],
            [14.697409813330367, -4.912970054168015],
            [14.697410039705833, -4.912969967671812],
            [14.699794149605269, -4.910597154328561],
            [14.714340119843373, -4.896119924636276],
            [14.719372764135992, -4.894378923806327],
            [14.719629959886701, -4.894289949093446],
            [14.723071522521131, -4.891825529132767],
            [14.728330079633004, -4.888059986452658],
            [14.732679960292268, -4.881840020771961],
            [14.736621833335981, -4.881702406853885],
            [14.738410079927677, -4.881639977933323],
            [14.739559919898092, -4.881609990244024],
            [14.739563495192908, -4.881605530069627],
            [14.744369879916629, -4.875609940894884],
            [14.752400039717308, -4.873059997835037],
            [14.757120000222473, -4.867299963474714],
            [14.763392104909837, -4.863380903078551],
            [14.765090040272769, -4.862319961567937],
            [14.765858870595203, -4.861840009242477],
            [14.771769839961932, -4.858149997545989],
            [14.771875244684123, -4.858094562373769],
            [14.777740080171117, -4.855010072226267],
            [14.78217996034375, -4.853679931415257],
            [14.782180400518262, -4.853679601618796],
            [14.783453293512917, -4.852726315236994],
            [14.786759879784336, -4.85024996273339],
            [14.797917986879035, -4.844351017068607],
            [14.800033044164373, -4.845119180117907],
            [14.802590159706043, -4.846049933822283],
            [14.807630160302558, -4.843750034521573],
            [14.815019164637176, -4.845680151955372],
            [14.815440000194947, -4.845790080015069],
            [14.820019919635532, -4.843250078870471],
            [14.820299671184694, -4.842848291158949],
            [14.823939960024621, -4.837619984518175],
            [14.825748032434623, -4.836519378543276],
            [14.829949799768157, -4.833961682185335],
            [14.835419950553614, -4.830253664254061],
            [14.835440159952549, -4.830239965505688],
            [14.835443756806962, -4.830235317555108],
            [14.854615469548293, -4.805462913120457],
            [14.868538898311359, -4.787471419031013],
            [14.8685399996459, -4.78746999517888],
            [14.870589840139891, -4.783790047448959],
            [14.871970702546854, -4.771837267125941],
            [14.872775004644939, -4.7682434105063],
            [14.872779359677434, -4.768223951842175],
            [14.875369916802182, -4.756649948229673],
            [14.875370023701704, -4.756649472389076],
            [14.875560000316304, -4.75577006343685],
            [14.882150159818234, -4.742619964600733],
            [14.896490040360472, -4.72092002135769],
            [14.898937972865888, -4.713305826173444],
            [14.898939834175176, -4.713300018386565],
            [14.903570159882991, -4.698849912264699],
            [14.903592743529222, -4.698805015431639],
            [14.905209959873964, -4.695589978533259],
            [14.913061559748989, -4.681092617849152],
            [14.925129839889562, -4.668560084418061],
            [14.942490119623416, -4.654209993363171],
            [14.94708011995813, -4.649890016301731],
            [14.958937361583954, -4.638752437865136],
            [14.961301694174093, -4.636621326533353],
            [14.974139879920486, -4.625049944616695],
            [14.974144292445162, -4.625045432281532],
            [14.978115930267535, -4.620983846527413],
            [14.983844345798849, -4.615132235847359],
            [14.992347789295163, -4.60520278549382],
            [14.99554115999303, -4.603437213177616],
            [14.997580200042387, -4.600925774248177],
            [15.002090279961195, -4.594219040247513],
            [15.002437196747508, -4.593774309468638],
            [15.005356559724151, -4.590031812266189],
            [15.009037199988331, -4.585004698453355],
            [15.013970999955294, -4.577035940582676],
            [15.02398052112772, -4.563909497068556],
            [15.03141012033004, -4.556449912489803],
            [15.031449167400508, -4.556404160921743],
            [15.041021457862907, -4.545189336976162],
            [15.052449959654767, -4.540010051778793],
            [15.061020120128916, -4.533100080991786],
            [15.062823359602701, -4.529299666959353],
            [15.065291520371691, -4.527033386024326],
            [15.071377319859028, -4.522658011655448],
            [15.072302519922978, -4.520728404311197],
            [15.07358483983824, -4.519347491376131],
            [15.075656999873782, -4.517277016695274],
            [15.082687439866122, -4.513850406232435],
            [15.084762479900494, -4.512176981658855],
            [15.087234959769363, -4.510506427258556],
            [15.089405760212987, -4.508337288390563],
            [15.091970760267946, -4.505674770517111],
            [15.093544320286515, -4.503303129310954],
            [15.095018520346427, -4.50093094024569],
            [15.096494879956326, -4.498856639412879],
            [15.098169600157371, -4.496783409943145],
            [15.100051320047612, -4.495902838145219],
            [15.104794319644901, -4.494968003635159],
            [15.104794848752592, -4.494967473523344],
            [15.104795377860283, -4.494966943411479],
            [15.104795373368729, -4.494966625164046],
            [15.10479535719905, -4.494965625344239],
            [15.104728330302418, -4.490682932710891],
            [15.104710280453441, -4.489529615201902],
            [15.104695186061713, -4.488565120145607],
            [15.10472315151482, -4.487606175604225],
            [15.104739541277162, -4.487044201491769],
            [15.105809145523031, -4.486238858516411],
            [15.107992892486557, -4.484449230183114],
            [15.108037325855454, -4.483509836915799],
            [15.107814330764274, -4.482570482995228],
            [15.108304432718672, -4.481317894398456],
            [15.109418629335226, -4.480736202588024],
            [15.110532770256256, -4.47979664851362],
            [15.112266801723925, -4.478771562079101],
            [15.113340027078694, -4.478675651143437],
            [15.115009328641946, -4.477502515893217],
            [15.115247679534576, -4.476568965697791],
            [15.114737473284135, -4.475276325921462],
            [15.114078621905286, -4.473840420527019],
            [15.114952156263975, -4.473322539079549],
            [15.11534250928924, -4.472930645629558],
            [15.115413822048051, -4.471422652438201],
            [15.115843046073987, -4.470991732135561],
            [15.116215187553461, -4.469636980488294],
            [15.116772814071146, -4.468693707373642],
            [15.118036747269151, -4.468142972115873],
            [15.119062249624449, -4.467999188340836],
            [15.120159065636926, -4.466419219341206],
            [15.120850489927932, -4.465150485961998],
            [15.121613578219083, -4.464599826446594],
            [15.122472121492311, -4.464408193742727],
            [15.122686646368692, -4.463690071484862],
            [15.12347361277839, -4.463330896037762],
            [15.12428438364481, -4.462708417103702],
            [15.124785177347725, -4.462468969806785],
            [15.123711929535066, -4.462277662013792],
            [15.123234912441088, -4.462086252290383],
            [15.123234844169144, -4.461679336735502],
            [15.123544760247206, -4.460937261849792],
            [15.123812576779496, -4.460152850044999],
            [15.124283815909543, -4.459333410416612],
            [15.124832253560184, -4.458782783445904],
            [15.125500061142397, -4.458974159781021],
            [15.126000827895837, -4.458591094206392],
            [15.126215355467146, -4.457920843692099],
            [15.125714451271483, -4.457490077642888],
            [15.125165861805563, -4.457131127227894],
            [15.124927200994133, -4.456125846573276],
            [15.124926998873189, -4.454929035705125],
            [15.125356139355793, -4.454091194794938],
            [15.125975968816995, -4.452654915609279],
            [15.126882022188978, -4.451457948450719],
            [15.127167979300086, -4.450117470594891],
            [15.127549403969731, -4.449207827302205],
            [15.127930745994377, -4.447819459911799],
            [15.128455215694895, -4.446646493787626],
            [15.12900350332689, -4.445305969190239],
            [15.129480401843217, -4.444875033369049],
            [15.130243655424369, -4.445425431957675],
            [15.130696776433455, -4.445401415704488],
            [15.13148368175775, -4.444826806077097],
            [15.131602882806035, -4.444587422306353],
            [15.131197455152012, -4.444587494435442],
            [15.131112250845648, -4.444595284376567],
            [15.131846900271524, -4.444341399873958],
            [15.132048500187565, -4.444131100212563],
            [15.13227499960669, -4.444081599792089],
            [15.132727899630225, -4.444115599662342],
            [15.133124999901552, -4.444891899847052],
            [15.13354090011517, -4.445077699760174],
            [15.133934600263155, -4.444966099903432],
            [15.134483699972156, -4.445021799754874],
            [15.134784599659721, -4.445164100422735],
            [15.13519410027525, -4.445093000131817],
            [15.135635700390829, -4.445305600430673],
            [15.135826899612544, -4.445689900107501],
            [15.137188699769164, -4.446271299990646],
            [15.137846299794825, -4.445832099664091],
            [15.137706699803054, -4.445324900351241],
            [15.138023499671142, -4.445176600383103],
            [15.13853190030788, -4.445538300312508],
            [15.139403600306764, -4.445516700384344],
            [15.139868899776136, -4.445550700187487],
            [15.140241099646119, -4.445423900117989],
            [15.140524899902266, -4.44556489968052],
            [15.14083669974751, -4.445553799930789],
            [15.140855300263775, -4.445726999645155],
            [15.141013599586493, -4.445767199824883],
            [15.140904999556859, -4.446036200252828],
            [15.141665000338385, -4.446317699620412],
            [15.14210860010377, -4.446967200359037],
            [15.142397100345462, -4.447152700407275],
            [15.142521199907019, -4.447032100091137],
            [15.142677300153942, -4.447073099927221],
            [15.142635900395778, -4.447554799592033],
            [15.142803499976646, -4.447662999982671],
            [15.142759999957333, -4.447811499601019],
            [15.142877900245086, -4.448031100101219],
            [15.143029899682761, -4.448089800273362],
            [15.143248672692081, -4.448701128933956],
            [15.143454899830173, -4.449277399867191],
            [15.143359499645321, -4.449452700341524],
            [15.143333900354667, -4.449685700032711],
            [15.14351379966843, -4.450131000104932],
            [15.143377299762674, -4.450857800218202],
            [15.143619299612013, -4.450857800218202],
            [15.143858200273636, -4.450681500201826],
            [15.143938799815842, -4.450758800289971],
            [15.144165300133265, -4.451402100327658],
            [15.144509600127163, -4.451349599860265],
            [15.144792099622778, -4.451194400233945],
            [15.145430899706152, -4.45172069955328],
            [15.146012000100525, -4.451962199745093],
            [15.146368700438591, -4.452577600395675],
            [15.146615700310775, -4.45265840030697],
            [15.146950300296249, -4.452596499811116],
            [15.147247700147455, -4.452514299702339],
            [15.147507299789861, -4.452559800034607],
            [15.147624699715996, -4.452518400196051],
            [15.147837499827052, -4.452343499872086],
            [15.147984400427134, -4.452347899699312],
            [15.148060399696808, -4.452197100114435],
            [15.148247000442547, -4.452200999552232],
            [15.148303800019654, -4.452299000306692],
            [15.148511200357524, -4.452335399862273],
            [15.148618399913619, -4.452118199831865],
            [15.148845399694359, -4.452173900036819],
            [15.148940799879211, -4.452041699611469],
            [15.14916019991264, -4.452122599660479],
            [15.149375100284777, -4.451995799835959],
            [15.149438700108579, -4.451855799597308],
            [15.149568099730308, -4.451849299930084],
            [15.149646599909735, -4.451798000432428],
            [15.149870799641722, -4.451838300354479],
            [15.149925799893312, -4.451909299907421],
            [15.149995899926511, -4.452444099931092],
            [15.150099199895973, -4.452917599560101],
            [15.150463100231038, -4.452824600082897],
            [15.150754500234463, -4.452685800038299],
            [15.150853499968683, -4.452721800164136],
            [15.150906199634807, -4.452555600364712],
            [15.150943649500702, -4.452516095696977],
            [15.150966147806974, -4.452492363683283],
            [15.151057500183173, -4.452396000267623],
            [15.151073247650123, -4.452347650856607],
            [15.151086000133889, -4.45230849960632],
            [15.151383799735399, -4.452063999892239],
            [15.151638199928907, -4.452131999785921],
            [15.151707393562001, -4.452404551078698],
            [15.151746299596958, -4.45255780027767],
            [15.15183430035882, -4.45274299956622],
            [15.151904999568316, -4.453127900285507],
            [15.152277200336599, -4.453146400276522],
            [15.15277349976814, -4.452793899586855],
            [15.15302169978958, -4.452187699989807],
            [15.153071300267982, -4.451909299907421],
            [15.153345399617374, -4.451604299670714],
            [15.153575699808449, -4.45106630013226],
            [15.153901899647666, -4.451072699728218],
            [15.154056000244784, -4.45118439962717],
            [15.154183299605366, -4.451011699801206],
            [15.154363100104446, -4.451147300368082],
            [15.154554099900142, -4.451123800022314],
            [15.155038699673417, -4.451352799657048],
            [15.155098000160276, -4.451455599769568],
            [15.155069399598256, -4.451512500061542],
            [15.155284999758029, -4.451561599663425],
            [15.15521179963878, -4.451983600227098],
            [15.155025700152953, -4.452119600023228],
            [15.155521299796888, -4.452839900291467],
            [15.155488399897921, -4.452999600368961],
            [15.155645499969751, -4.453160200211023],
            [15.156082799850058, -4.453686199675208],
            [15.156628999797297, -4.454088599985048],
            [15.156705800364215, -4.453996799788376],
            [15.156908000354886, -4.453678600069646],
            [15.157159899638639, -4.453670900386098],
            [15.157330900241185, -4.45378459963896],
            [15.157629299917328, -4.453778099989012],
            [15.157670899999811, -4.453850300286254],
            [15.157609500150134, -4.454300699967831],
            [15.157657799868041, -4.454453800002339],
            [15.158287299693264, -4.454738100087333],
            [15.158704100018806, -4.454781899860929],
            [15.158958500212314, -4.454921800359254],
            [15.159030899932615, -4.455094600234438],
            [15.159487200079496, -4.455422599725701],
            [15.159702099553369, -4.4551076995883],
            [15.159967499617535, -4.4551076995883],
            [15.160248300398939, -4.455201699549411],
            [15.16026319985623, -4.455363499835733],
            [15.160362399914739, -4.455367899644653],
            [15.160447899766847, -4.455317600270267],
            [15.160526900307888, -4.455367899644653],
            [15.16053570020442, -4.455719999675609],
            [15.160693599776829, -4.455949700206468],
            [15.160880000198286, -4.456006500068675],
            [15.160884400146569, -4.455671900229181],
            [15.161187100057948, -4.455702499624345],
            [15.161441599964466, -4.45587530021518],
            [15.16155559976729, -4.456159599743296],
            [15.161788099932492, -4.456284199840386],
            [15.161940199981441, -4.456154099988152],
            [15.162509593531039, -4.45681158189552],
            [15.162575599941468, -4.456887800314561],
            [15.163027500140098, -4.457371100116179],
            [15.163003300424657, -4.45757009983027],
            [15.163069100222582, -4.457817199698743],
            [15.162944099650806, -4.458020599984858],
            [15.163074800033067, -4.458134999998379],
            [15.163074645522833, -4.458136290183337],
            [15.163051000067934, -4.458333600095647],
            [15.163119200164306, -4.458413999958847],
            [15.163022999580541, -4.458729500025537],
            [15.16308820020217, -4.459041800192153],
            [15.163209199677675, -4.45932639961191],
            [15.163655917495419, -4.459525525914329],
            [15.163854400257435, -4.459614000329381],
            [15.164080799963545, -4.459815000066508],
            [15.164049800001411, -4.460034599640263],
            [15.164304200194952, -4.46001910033107],
            [15.164474400398552, -4.460369000017911],
            [15.164294899936801, -4.460643800397171],
            [15.164419000396654, -4.46074900013684],
            [15.164530599901031, -4.46075520039526],
            [15.164580300092444, -4.46106140041186],
            [15.16477569983642, -4.461089200133129],
            [15.164885628474366, -4.461294223269931],
            [15.164983199887269, -4.461476199839326],
            [15.16503320011598, -4.46164279970519],
            [15.165256499736044, -4.461871600374131],
            [15.165365099765712, -4.461822200338247],
            [15.165724900189826, -4.462159300158349],
            [15.165635000389436, -4.462363399762717],
            [15.165684599969541, -4.462583000367456],
            [15.165793199999175, -4.462784000182722],
            [15.165684599969541, -4.46298190027339],
            [15.165749799692874, -4.463127299793462],
            [15.16569080014164, -4.463427300375315],
            [15.166887300404529, -4.464408300130233],
            [15.167748499996073, -4.465522041107084],
            [15.168306551416849, -4.466243738142386],
            [15.168870299953189, -4.466972800413812],
            [15.168893153992347, -4.467006568405548],
            [15.169634892024114, -4.468102534256207],
            [15.169802158330029, -4.468349681922476],
            [15.170880741237152, -4.469961759256123],
            [15.171288480256406, -4.470571177055953],
            [15.172296600210968, -4.472773300360885],
            [15.172314500939629, -4.472823300100505],
            [15.173232577363367, -4.475387630804657],
            [15.17325530024848, -4.475451099896646],
            [15.174081000216592, -4.478252000031256],
            [15.174206187637965, -4.481380568687846],
            [15.17421389967468, -4.481573300410666],
            [15.174204399990542, -4.484364600371659],
            [15.174906700184739, -4.486247600058543],
            [15.175410900299184, -4.487105000037356],
            [15.175273699707528, -4.487638600208377],
            [15.175841300219821, -4.488269000397163],
            [15.175675700288755, -4.490059600136629],
            [15.175070599604963, -4.491179299595522],
            [15.175295599735867, -4.49231489982555],
            [15.175908699917278, -4.49299799982251],
            [15.17587749963082, -4.493688500014432],
            [15.175487000180164, -4.49439740020956],
            [15.176064699552859, -4.496807400148048],
            [15.175808400320854, -4.498018499659429],
            [15.174735899906514, -4.49954189960837],
            [15.174175900039859, -4.501017999570885],
            [15.173701400025319, -4.50321319975809],
            [15.174166400355722, -4.505805799940483],
            [15.175328000171511, -4.506705299968199],
            [15.176442099770043, -4.507641999803341],
            [15.177119999924477, -4.509281200159627],
            [15.177697100120875, -4.511228099960096],
            [15.177643399731489, -4.514118400423092],
            [15.176905200163617, -4.516239300171222],
            [15.173784000115697, -4.520571400359921],
            [15.17320499998247, -4.524554799599694],
            [15.172438400176866, -4.52684979971229],
            [15.172333999771194, -4.529101700377471],
            [15.172457299832132, -4.530908800261056],
            [15.172479581644437, -4.533222487928375],
            [15.172106699953156, -4.535480200282327],
            [15.172615600053183, -4.536827200113155],
            [15.173773700032642, -4.537282000326797],
            [15.17420787467408, -4.537554527469659],
            [15.175247800379577, -4.538121699657564],
            [15.175884986190399, -4.539341891138777],
            [15.175914600052048, -4.539398599671381],
            [15.176476100105218, -4.540780599773776],
            [15.17640590035904, -4.54179519972869],
            [15.176072499624489, -4.542704799830563],
            [15.176156599901388, -4.543051300284005],
            [15.175142789119512, -4.544196596651841],
            [15.17476610036803, -4.544685399896075],
            [15.174323853465475, -4.545403284259429],
            [15.174059799975891, -4.545990900413904],
            [15.173883099562897, -4.546532699873423],
            [15.173822260261943, -4.54728456294119],
            [15.173771400345508, -4.547913100408828],
            [15.173873800203078, -4.548292199576053],
            [15.174184355881607, -4.548801259931558],
            [15.174338707108681, -4.549124566778374],
            [15.17443201601556, -4.549477031013375],
            [15.174485100160638, -4.549928100023449],
            [15.174354999853005, -4.550408200036986],
            [15.174141257409229, -4.550727914654522],
            [15.173593799820587, -4.551546800083622],
            [15.173473200095355, -4.552013100067163],
            [15.173520800025658, -4.552418300252737],
            [15.173751199929709, -4.553117399932353],
            [15.173798899572988, -4.553506700139668],
            [15.173767100110235, -4.553919900075891],
            [15.173663800140773, -4.554603099854816],
            [15.173342124217307, -4.55528672988105],
            [15.173128012565993, -4.555764601433516],
            [15.173076000111015, -4.556128600333275],
            [15.173181299730315, -4.556493000201822],
            [15.173682604574616, -4.55719390963017],
            [15.17405579977795, -4.557715699594216],
            [15.174551500033195, -4.558524200134329],
            [15.174752199837345, -4.559068000309316],
            [15.176614199910469, -4.559350441573947],
            [15.17722297560212, -4.559491421471782],
            [15.177541150790896, -4.559565104864917],
            [15.178852092827745, -4.559729547254272],
            [15.179252445000433, -4.559779767189394],
            [15.179270884718253, -4.559782542812265],
            [15.179332245042058, -4.559791779262954],
            [15.179612559834899, -4.559833974317773],
            [15.179629060988351, -4.559836457864519],
            [15.179976328117627, -4.559888731338002],
            [15.180678523208897, -4.559994430350318],
            [15.182603728745432, -4.560137538487198],
            [15.184174493206866, -4.560362720772343],
            [15.187167180270226, -4.560781525647148],
            [15.188807169805756, -4.561353959188668],
            [15.191302807344334, -4.561568620971433],
            [15.193513228881905, -4.561640174884586],
            [15.194796699539051, -4.561854837482144],
            [15.197434943730682, -4.562641930712911],
            [15.200928835925364, -4.564287669999951],
            [15.202497522583515, -4.565074761429176],
            [15.203780993240658, -4.565432530053432],
            [15.205908800314798, -4.566110500181022],
            [15.206789900284807, -4.566521899766851],
            [15.207609199756538, -4.5676139000642],
            [15.207897699998229, -4.568384800314494],
            [15.207540599909857, -4.568823500118737],
            [15.208407562193946, -4.570627234813539],
            [15.208892052372743, -4.571635225901413],
            [15.209702799882971, -4.573321999992877],
            [15.209960900237157, -4.575551500171088],
            [15.211251299600079, -4.57735229971683],
            [15.211980735204031, -4.579102811207004],
            [15.213573900055355, -4.582926100260332],
            [15.215156455803193, -4.58445263671784],
            [15.216240699893223, -4.585498499940619],
            [15.218047200251506, -4.586441799957178],
            [15.220972100443561, -4.58687049975016],
            [15.224069000164731, -4.588242499593211],
            [15.226047500052131, -4.588242499593211],
            [15.22991869993753, -4.589528800429419],
            [15.231381099727901, -4.591929700099143],
            [15.234133899779492, -4.592701499557855],
            [15.234133899779492, -4.594244900327127],
            [15.234908100230708, -4.595359699799802],
            [15.236972700044811, -4.596731600168563],
            [15.238865199718488, -4.600675999834542],
            [15.2412739001005, -4.605649400199835],
            [15.243166500385517, -4.609422199717611],
            [15.245575199869201, -4.615595999627082],
            [15.250837598177228, -4.616336728974033],
            [15.252917295976316, -4.616634847803812],
            [15.255591192504953, -4.615740491835142],
            [15.258265089931887, -4.615740491835142],
            [15.262721584445705, -4.615144253287228],
            [15.268109300430785, -4.615065399876492],
            [15.268535100078818, -4.615550499781961],
            [15.272732300377442, -4.616035500197757],
            [15.274800499740913, -4.618642699559228],
            [15.277902800133601, -4.620461600448123],
            [15.27911929958967, -4.622159300349135],
            [15.282708200303738, -4.621916700448048],
            [15.286120741066307, -4.621916700448048],
            [15.289186499789865, -4.621795499618784],
            [15.29189340042203, -4.621280100204218],
            [15.294146199983107, -4.622305600289657],
            [15.298447400038798, -4.622048399736729],
            [15.301183300084963, -4.622267999752137],
            [15.304437599915291, -4.624238499917569],
            [15.310611700201786, -4.62366250024528],
            [15.314352700066538, -4.624632600365866],
            [15.31474900443054, -4.625073297708214],
            [15.318823599964244, -4.629604300094714],
            [15.323416200023358, -4.632181000367001],
            [15.32670089974123, -4.633211799858491],
            [15.330472300391786, -4.640214499749881],
            [15.328890800164441, -4.642488100161476],
            [15.330563599767387, -4.645216400219722],
            [15.33430449991913, -4.646823000104397],
            [15.341695200273, -4.646156100002588],
            [15.346531100043686, -4.647823400435609],
            [15.353690699807565, -4.646852999975957],
            [15.353815700379377, -4.646217599661647],
            [15.355303199997083, -4.645976099672142],
            [15.357063788359509, -4.646499072075518],
            [15.357790800308829, -4.64656170020394],
            [15.357978399981175, -4.645739400234856],
            [15.357724200111987, -4.643285100042545],
            [15.358754200331921, -4.642600700199818],
            [15.359690899729815, -4.642325499696182],
            [15.359903399803541, -4.642998300179785],
            [15.359290899696724, -4.64340949967725],
            [15.358765899990182, -4.644019999758465],
            [15.359165900023243, -4.644443599567498],
            [15.360728499697059, -4.644007499686128],
            [15.361978500025016, -4.644007499686128],
            [15.362766000033991, -4.642350399849763],
            [15.363828600115589, -4.641901900401165],
            [15.364666100353276, -4.641154300025959],
            [15.366091200296433, -4.641154300025959],
            [15.36836230033648, -4.638949300140519],
            [15.368085199715756, -4.637725199759956],
            [15.368570200137636, -4.637627600420034],
            [15.369605099769139, -4.637724400245644],
            [15.370510500065897, -4.637415700225892],
            [15.371481000372979, -4.638096599740487],
            [15.373065899825377, -4.638679800246829],
            [15.373320148203609, -4.638628654835662],
            [15.37452879638411, -4.63762395798739],
            [15.374616212342726, -4.637551292309007],
            [15.374734273428926, -4.637290811879928],
            [15.374972904595953, -4.63676431631654],
            [15.375555075782133, -4.636893803546946],
            [15.375943607922311, -4.637769720175769],
            [15.37639635523224, -4.637769479510257],
            [15.37739884993648, -4.637736495716045],
            [15.37801313679239, -4.637444125810466],
            [15.377786160367872, -4.63630853109753],
            [15.377041348301168, -4.634394435978362],
            [15.377235089755137, -4.633842699756398],
            [15.378237216150131, -4.633128285673154],
            [15.379433754142266, -4.633127643894164],
            [15.380274287092352, -4.63260800826196],
            [15.381308661209419, -4.631731327093031],
            [15.381631579502901, -4.630855029711229],
            [15.381760464389997, -4.629978836690767],
            [15.382406855237511, -4.629264609745062],
            [15.382827171569058, -4.629102136896446],
            [15.38434708869042, -4.629101313034988],
            [15.384982341326756, -4.628353626827629],
            [15.385504849106713, -4.627486345338776],
            [15.386027194291596, -4.626322459819142],
            [15.386936368410861, -4.625683123377948],
            [15.388095770947482, -4.625248990306468],
            [15.389232658109819, -4.625225550687832],
            [15.389823720820669, -4.624997068448024],
            [15.389823409105277, -4.624426676924145],
            [15.389368188733339, -4.623582746407111],
            [15.389367927323617, -4.623103616552966],
            [15.389594808526708, -4.6221908642901],
            [15.390117424104485, -4.621540328808301],
            [15.390185325960186, -4.620969899310494],
            [15.391094439892351, -4.620239295690961],
            [15.391867074580022, -4.619417503732869],
            [15.391912136769621, -4.618664561058296],
            [15.391161453314222, -4.618048952232573],
            [15.390569997141275, -4.617547332388651],
            [15.390887825580371, -4.616634529610931],
            [15.391273704097193, -4.615425084717184],
            [15.392250165624482, -4.613131568106676],
            [15.393386191302469, -4.611579472446554],
            [15.393796212940845, -4.611404346103874],
            [15.3942954795078, -4.611191101179648],
            [15.396136953076681, -4.610710946963416],
            [15.39617670891789, -4.610662450534619],
            [15.396455063586799, -4.610322903326555],
            [15.396795404705223, -4.609022218949493],
            [15.396544761266213, -4.608064099440637],
            [15.396838767282317, -4.605211974476498],
            [15.397543333027626, -4.604686820408405],
            [15.398747864229163, -4.603705071655175],
            [15.399452312295187, -4.602974574434992],
            [15.399952047782692, -4.602107297578031],
            [15.400496771797933, -4.60199103127497],
            [15.40058988846533, -4.60197115597481],
            [15.402339186801271, -4.601626822552697],
            [15.402520880050638, -4.601528642173346],
            [15.402600065644613, -4.601485852874097],
            [15.402678484077335, -4.601443478223418],
            [15.403193065123238, -4.601165416656297],
            [15.403260016561344, -4.600149044047219],
            [15.403011735691534, -4.598906997959786],
            [15.40301143116265, -4.598364952883764],
            [15.403731084113179, -4.597325625145263],
            [15.403955724917976, -4.596557600505701],
            [15.404405134088321, -4.595247403152052],
            [15.4050791939449, -4.593191766565869],
            [15.405371202107794, -4.592152680880123],
            [15.404628157925577, -4.591611057876913],
            [15.404245027355211, -4.590707865774722],
            [15.403817060072415, -4.590120892509264],
            [15.40404175118285, -4.589443208649876],
            [15.404572693244988, -4.589404850952511],
            [15.404671925642859, -4.589397681870482],
            [15.406337313246389, -4.589148297289572],
            [15.406833550694197, -4.588855216613937],
            [15.407709761134106, -4.588289276734221],
            [15.407709543741809, -4.587905328549142],
            [15.407641126253139, -4.586324402468943],
            [15.406447703618408, -4.585353918581689],
            [15.405681866482505, -4.58429284879223],
            [15.405456351616932, -4.58350249482468],
            [15.405523400971422, -4.58266680386259],
            [15.406076376012571, -4.582599897196861],
            [15.406648671120497, -4.582530653090975],
            [15.406791330774148, -4.582458973287359],
            [15.406998617924282, -4.582354821799444],
            [15.407368687888715, -4.582168879007104],
            [15.407390862801497, -4.581581650734897],
            [15.406580627330984, -4.581604697880541],
            [15.406242781732431, -4.581175770427539],
            [15.405814629396666, -4.580250019869591],
            [15.404913694625177, -4.579076098706891],
            [15.404598078736596, -4.578150283195617],
            [15.404710104940765, -4.577246810629965],
            [15.405204808964358, -4.576456048529389],
            [15.405451710021863, -4.575258891615158],
            [15.405968906063549, -4.574445530636086],
            [15.406238565938787, -4.573700065128379],
            [15.405832798721594, -4.5725484485424],
            [15.405269752667818, -4.571871211155055],
            [15.405381967518142, -4.571306516989057],
            [15.405291345472284, -4.570245061904775],
            [15.404795441299468, -4.568890228699129],
            [15.404367235963109, -4.567851549850499],
            [15.403961652002225, -4.56701612523886],
            [15.404028893596193, -4.566519211612058],
            [15.404478805823082, -4.5661350072963],
            [15.404638356498991, -4.566044016535986],
            [15.406143747862252, -4.565185488924804],
            [15.406435873704432, -4.564372255189178],
            [15.405917529615818, -4.563130360671778],
            [15.404948973262989, -4.561730623527802],
            [15.403980837321733, -4.561076197337504],
            [15.402967803582582, -4.560625061492449],
            [15.402900045457315, -4.560195980686891],
            [15.403102363127307, -4.559766747273345],
            [15.403709614377885, -4.559021093225689],
            [15.404654382443676, -4.558139737268787],
            [15.405464034907572, -4.557122945732683],
            [15.406453276766433, -4.555292982509186],
            [15.406925434873012, -4.55445706170687],
            [15.407240837860844, -4.554349082938553],
            [15.40730900022797, -4.554168300048365],
            [15.406901200123281, -4.553778499884369],
            [15.405955399893259, -4.552980100402515],
            [15.406090099575161, -4.552669199647505],
            [15.40638250030182, -4.552669199647505],
            [15.406559499853817, -4.552567600367844],
            [15.406607799571722, -4.552380400301247],
            [15.407108199812509, -4.551933300256951],
            [15.407406400062664, -4.552075599590264],
            [15.407622300259735, -4.552054200287838],
            [15.407724199755686, -4.551774800414245],
            [15.407649900098523, -4.551611700287182],
            [15.407869000094623, -4.551448900315375],
            [15.408047400120161, -4.551316299876635],
            [15.408290200368414, -4.551329600307914],
            [15.408346600195214, -4.55130280021811],
            [15.408405599746448, -4.551214600339188],
            [15.408483400138268, -4.55123599966688],
            [15.408604099576475, -4.55136160013129],
            [15.408710699956272, -4.551381999713665],
            [15.408794500195871, -4.551345599769051],
            [15.408877700360877, -4.55129209965383],
            [15.408987699965724, -4.551308100017278],
            [15.409051999577132, -4.551415100241256],
            [15.409126699882899, -4.551449599863505],
            [15.409247799969716, -4.55142309997089],
            [15.409363200246043, -4.551326900376277],
            [15.409398000081836, -4.551203899773585],
            [15.409381899577024, -4.551112999949934],
            [15.409226400303027, -4.551011400447686],
            [15.409164700416051, -4.550923099566776],
            [15.409127099633208, -4.550816200234509],
            [15.409178099686823, -4.550722600427329],
            [15.409258600414383, -4.550690499609368],
            [15.409338999632306, -4.550802799729317],
            [15.409387300248508, -4.550880299990366],
            [15.409510700022457, -4.550917799764708],
            [15.409695799683382, -4.550810800367318],
            [15.409760100193086, -4.550752000408554],
            [15.409775793761112, -4.550657566723408],
            [15.409794999741891, -4.550583600242065],
            [15.409864700024782, -4.550508699819045],
            [15.409969299856474, -4.550479299827756],
            [15.410113100370507, -4.550573399988768],
            [15.410202700133567, -4.550539399744252],
            [15.410336799740881, -4.550475299957621],
            [15.410419999905852, -4.550427099582664],
            [15.410532600133463, -4.550341600431903],
            [15.410613099962728, -4.550309499596692],
            [15.410733800299232, -4.550290800176668],
            [15.41080890035531, -4.550253400433633],
            [15.410916199624415, -4.55017849997578],
            [15.411034199625178, -4.550047500330708],
            [15.411091699888219, -4.550056900076214],
            [15.411213900411244, -4.550036799747548],
            [15.411323900016091, -4.549953900422258],
            [15.411474100128247, -4.549822899834292],
            [15.411557199681912, -4.549713300398702],
            [15.411584000020117, -4.549638399883891],
            [15.411683299791603, -4.549534100232317],
            [15.411782499850109, -4.549397699689033],
            [15.411851200308098, -4.549129499690433],
            [15.411895199790733, -4.549028799584153],
            [15.411999799622393, -4.548911100203684],
            [15.412053400298769, -4.548710599594998],
            [15.41208679966102, -4.548618499578378],
            [15.412273400406795, -4.5483736999929],
            [15.412340400353944, -4.54825870044729],
            [15.412485300405924, -4.548223999639259],
            [15.412672999791281, -4.548221299695803],
            [15.412809799734301, -4.548119699780058],
            [15.413025600218393, -4.548065000448513],
            [15.413340899899961, -4.548101000302414],
            [15.41381560023879, -4.548416499720297],
            [15.413952400181845, -4.548416499720297],
            [15.414069633021352, -4.548349509586227],
            [15.414117600362598, -4.548322099981172],
            [15.414392299786584, -4.548084899802026],
            [15.414671300344173, -4.547876400092286],
            [15.414875100234342, -4.547699900309673],
            [15.415327499896259, -4.547573300353321],
            [15.415620799836544, -4.547512699862082],
            [15.41576289983977, -4.547453899630428],
            [15.415832699835638, -4.547381699725641],
            [15.415915800287632, -4.547384399672276],
            [15.416058000003838, -4.54741649973806],
            [15.416167899895708, -4.547392400348786],
            [15.416280599836297, -4.547333600107157],
            [15.416502199843851, -4.547426299777568],
            [15.416610499836191, -4.547445899856063],
            [15.416709699894696, -4.547400400123698],
            [15.416790199723961, -4.547317599654234],
            [15.416918899558087, -4.547250699565051],
            [15.417044999667779, -4.547178499639654],
            [15.417162999668539, -4.547181199587053],
            [15.41754660005779, -4.547050200291003],
            [15.417813732073826, -4.547023357670021],
            [15.418053499609679, -4.546991400021104],
            [15.418227900335571, -4.546959299936073],
            [15.418329799831525, -4.546913800172564],
            [15.418404899887568, -4.546812200069967],
            [15.418442400059135, -4.546715999851177],
            [15.418522899888366, -4.546646399756022],
            [15.418665099604571, -4.546616999604954],
            [15.418855500224, -4.546638399972599],
            [15.419242938216149, -4.546640965600695],
            [15.419523654555894, -4.546668329294813],
            [15.419611899659531, -4.546678499855176],
            [15.419703100220421, -4.546665200238311],
            [15.41973790005621, -4.546629100246823],
            [15.41973790005621, -4.546568899934742],
            [15.419797000218752, -4.5464686997904],
            [15.419939100221979, -4.546325599716276],
            [15.420030299884571, -4.546264100337043],
            [15.420153699658519, -4.545919199784118],
            [15.420255600052769, -4.545836299978615],
            [15.420475600160795, -4.545643800100458],
            [15.420733699616648, -4.545389999944022],
            [15.421103200049224, -4.545082299755476],
            [15.421548399714139, -4.544884399761052],
            [15.421972199712366, -4.544772099607606],
            [15.422117099764311, -4.544681199862985],
            [15.422208300325201, -4.544560899870711],
            [15.422326300325993, -4.544459300333476],
            [15.422476500438119, -4.544459300333476],
            [15.422613300381171, -4.544512800061432],
            [15.422675199694135, -4.544661899903806],
            [15.423104100326546, -4.544897800377817],
            [15.42351719959308, -4.545007399654264],
            [15.423785399706, -4.545004799763783],
            [15.424313800434215, -4.544820300366022],
            [15.424387400303774, -4.544834899962936],
            [15.424574000151219, -4.544972699589084],
            [15.42485829987065, -4.545060900242523],
            [15.425091600434767, -4.545250700323721],
            [15.425338399982666, -4.545408500264314],
            [15.425676400091486, -4.545469999717552],
            [15.425998562003516, -4.545556880532335],
            [15.426352299697752, -4.545641100147232],
            [15.426585600261902, -4.545643800100458],
            [15.426679500260233, -4.545520800317255],
            [15.426792200200822, -4.54543259972085],
            [15.42703619969997, -4.545373700153577],
            [15.427151599976334, -4.545424499858716],
            [15.427304500424198, -4.545451300170178],
            [15.42753240031683, -4.545379100062076],
            [15.427830199918375, -4.545400499565501],
            [15.428004500032927, -4.545494100073498],
            [15.428149400084907, -4.545502099869796],
            [15.428157399582492, -4.545403100356055],
            [15.428101100367, -4.54530419999215],
            [15.428151999809341, -4.54523469982389],
            [15.428280800254774, -4.545293500239064],
            [15.428345199579161, -4.54537110026443],
            [15.428433699804341, -4.54553949986281],
            [15.428597300085563, -4.545555500355757],
            [15.428718000422068, -4.545528800113247],
            [15.42877160020015, -4.545582299760773],
            [15.428814500144835, -4.545662499642731],
            [15.428836000422864, -4.545790800143227],
            [15.428916500252095, -4.545871100066707],
            [15.429078301207801, -4.545873704461478],
            [15.429187399802426, -4.545857700369758],
            [15.429367099690197, -4.545774799655597],
            [15.429514600364909, -4.545673200291728],
            [15.429678462055854, -4.545673532940408],
            [15.429756000139619, -4.545638400193994],
            [15.429756000139619, -4.545574299965417],
            [15.429678199747803, -4.545526100159589],
            [15.429640699576268, -4.545437899563845],
            [15.429702400361576, -4.545395099657179],
            [15.429860599971315, -4.545397799611346],
            [15.430056400363897, -4.545416500061591],
            [15.43009470542593, -4.545417917199408],
            [15.430418499576819, -4.545429899766822],
            [15.430662599687272, -4.545376400107833],
            [15.430863799853041, -4.54515979973876],
            [15.430842299575046, -4.544849699689854],
            [15.430993600123411, -4.54465000026036],
            [15.431196299577367, -4.544560899870711],
            [15.431469900361771, -4.544608999676732],
            [15.431818600303918, -4.544716000007589],
            [15.43209220018999, -4.544828300169865],
            [15.432451599965498, -4.545063600197949],
            [15.432612599623992, -4.545071599999082],
            [15.432827100245854, -4.544903100224794],
            [15.433063199960392, -4.544758799955119],
            [15.434093099569015, -4.544956599919355],
            [15.434285100087944, -4.544898399867236],
            [15.435374517575726, -4.544823845918029],
            [15.435940599935156, -4.544782199879021],
            [15.436074200079148, -4.544660399827543],
            [15.436277300181741, -4.544582200234998],
            [15.436531200013667, -4.544701799767432],
            [15.436715800211275, -4.544890400064144],
            [15.436761899955018, -4.545019300193266],
            [15.436895800136343, -4.545111299709498],
            [15.436895800136343, -4.545304500187429],
            [15.437043500237042, -4.545580599556338],
            [15.437149600255255, -4.545718600069589],
            [15.437170979260674, -4.545559372242394],
            [15.437191200337738, -4.545442599917829],
            [15.437343899562988, -4.545622799963089],
            [15.437472700008421, -4.545516200028865],
            [15.437638900014079, -4.545566799593708],
            [15.437772699584089, -4.545644999979507],
            [15.43774039975972, -4.545773799906793],
            [15.437717299582195, -4.545930199722776],
            [15.43774039975972, -4.546040700326539],
            [15.437837300131093, -4.546022300087681],
            [15.437888099860421, -4.545967100269764],
            [15.43807270005806, -4.545957899698709],
            [15.438132700332492, -4.546068300233175],
            [15.438165000156861, -4.546160299613738],
            [15.4383172996318, -4.546155700230954],
            [15.438432699908164, -4.546220099700542],
            [15.43832650017694, -4.546362700372632],
            [15.437957299781697, -4.546413299877236],
            [15.437851199763482, -4.546417900159863],
            [15.437906500052401, -4.546509999560105],
            [15.438081899704867, -4.546555999674061],
            [15.43804959988053, -4.546629599669846],
            [15.438003500136752, -4.5467215998793],
            [15.438081899704867, -4.54680899979675],
            [15.438174199803669, -4.546818200356826],
            [15.438156733859604, -4.546896627779295],
            [15.438146087925169, -4.546944430838687],
            [15.438128100059922, -4.547025200305623],
            [15.43804959988053, -4.547227699981651],
            [15.438169600429431, -4.547315099836941],
            [15.43831270025756, -4.547397900306748],
            [15.438500800291523, -4.547412699980321],
            [15.438506500102008, -4.547549700391714],
            [15.438423500261321, -4.547614199799801],
            [15.438575799736293, -4.547802800225581],
            [15.438534199653807, -4.547977599783951],
            [15.438418800275773, -4.54817090044924],
            [15.43849270018263, -4.548405499820097],
            [15.438691200012626, -4.548566500227336],
            [15.438621900378338, -4.548732200028833],
            [15.438561900103906, -4.548773599731643],
            [15.43875120028709, -4.54901740033665],
            [15.438880399584502, -4.54913700002451],
            [15.439028099685201, -4.549173800340528],
            [15.439088099959665, -4.549311900220808],
            [15.439069600054708, -4.549495899933441],
            [15.4391757997859, -4.549698299742584],
            [15.439300399709072, -4.549873199800693],
            [15.439263499612165, -4.549942200094748],
            [15.439295800334834, -4.550130799902749],
            [15.439207099785365, -4.550262499983224],
            [15.439263499612165, -4.550337899852663],
            [15.439378800175517, -4.550360900236864],
            [15.439397300080476, -4.550439100095264],
            [15.439323499886598, -4.550498899822067],
            [15.439475800259867, -4.550669100265188],
            [15.439454373643731, -4.550919465700116],
            [15.439383500161066, -4.551064799618233],
            [15.439295800334834, -4.551138400048608],
            [15.439295800334834, -4.551414399791629],
            [15.439194199977882, -4.551524900444194],
            [15.439258799626584, -4.551823900373866],
            [15.439318799901052, -4.551833099967485],
            [15.439383500161066, -4.551745699766406],
            [15.439489600179277, -4.551741100419816],
            [15.439725000106211, -4.552081599832633],
            [15.43974350001117, -4.552242600308317],
            [15.439711200186833, -4.552362200354753],
            [15.439604999557311, -4.552398999602193],
            [15.439604999557311, -4.552555499827105],
            [15.439512700356806, -4.552638299686221],
            [15.439517299731044, -4.552716500195337],
            [15.439669600104349, -4.552836100161941],
            [15.439678799751155, -4.552941900288976],
            [15.439512700356806, -4.55301090028491],
            [15.439471199987297, -4.552900499927587],
            [15.439359499871612, -4.552879299876595],
            [15.439272700157305, -4.552974100167728],
            [15.439309600254209, -4.553112200210662],
            [15.439346500351148, -4.553227199872095],
            [15.439489600179277, -4.553296199840333],
            [15.439623500360566, -4.553305400316367],
            [15.439720399833641, -4.553411200373455],
            [15.439738800025623, -4.553539999794586],
            [15.439637300279976, -4.553599800161788],
            [15.439521900003614, -4.553622800440356],
            [15.439461899729181, -4.553659599622442],
            [15.439508100084236, -4.553816099569551],
            [15.439401900353046, -4.553963299852345],
            [15.439457300354908, -4.554105899871862],
            [15.439581900278082, -4.55414269993037],
            [15.439706500201254, -4.554013899717165],
            [15.439831199837437, -4.554059900246744],
            [15.439840400382574, -4.554188699550157],
            [15.439738800025623, -4.554280799746034],
            [15.439678799751155, -4.55440499967997],
            [15.439817300205046, -4.554496999783969],
            [15.43989120011187, -4.554501600014219],
            [15.440059308139196, -4.554691414701707],
            [15.440327322300849, -4.554973938841542],
            [15.440960600440162, -4.555641499733063],
            [15.440986320105058, -4.55569366083143],
            [15.441814399710383, -4.557372999686579],
            [15.4431175003531, -4.559136100042721],
            [15.443306999962308, -4.559191299738466],
            [15.443896199567245, -4.559017900219288],
            [15.444099700318446, -4.55924230038441],
            [15.444090900421948, -4.559751699953324],
            [15.444307399795317, -4.560437200071259],
            [15.44481199966007, -4.561084399788365],
            [15.44490179974745, -4.56213389984348],
            [15.445467500322881, -4.562553699790936],
            [15.445504999596116, -4.562954400152986],
            [15.445582700274926, -4.563320500281183],
            [15.445281699976055, -4.563690399890791],
            [15.446306799886086, -4.56522090015677],
            [15.446686600401714, -4.56528509957457],
            [15.447037999781271, -4.565012400073925],
            [15.448049200058948, -4.565651400425423],
            [15.447834199973805, -4.566475099549034],
            [15.448030300403682, -4.567096600347725],
            [15.450033099719537, -4.569500799920409],
            [15.450503899573402, -4.571013099874067],
            [15.449791799657802, -4.572073600068063],
            [15.449209599725513, -4.572643799693722],
            [15.449204199952362, -4.573445900010736],
            [15.448827500421116, -4.57448039963293],
            [15.449316899892951, -4.576114199646787],
            [15.449885500230147, -4.576130300411771],
            [15.450622199611495, -4.57697909984229],
            [15.450619200136755, -4.577245399865917],
            [15.450509199633576, -4.577896099847137],
            [15.450517200029495, -4.578617999861062],
            [15.450855200138314, -4.57912330013471],
            [15.451150499728403, -4.58013879984114],
            [15.451053699968341, -4.580730200287321],
            [15.451678600419324, -4.581000200216508],
            [15.452193600080109, -4.581256900173588],
            [15.452274099909374, -4.58171950000444],
            [15.452920499740054, -4.581660599848358],
            [15.453212300392085, -4.581966700318189],
            [15.452923200075796, -4.582393199712109],
            [15.453601800017806, -4.582866399726685],
            [15.453617899624355, -4.582339700140445],
            [15.454224000133049, -4.582034899709771],
            [15.455425699844834, -4.582631199695137],
            [15.45525400035298, -4.583262100012217],
            [15.455526100052564, -4.583476299916942],
            [15.456090899617775, -4.583497399893118],
            [15.456513500365078, -4.584575399872763],
            [15.457667999896872, -4.585026699820521],
            [15.457871799787073, -4.584922500034216],
            [15.458006000005692, -4.584724600355278],
            [15.458596000009578, -4.585090900143164],
            [15.458735500288338, -4.584673799863435],
            [15.459104900109605, -4.584872199854158],
            [15.459263900118257, -4.585695100433235],
            [15.459566999779945, -4.585569499752522],
            [15.460006900283016, -4.58568979999012],
            [15.460594858416233, -4.585912781844703],
            [15.460636107257452, -4.585940162049716],
            [15.461234999684336, -4.58647280030421],
            [15.461964899717323, -4.58687420013835],
            [15.462127100423336, -4.587538400121735],
            [15.462976099994968, -4.58908819975157],
            [15.463960700258758, -4.59021390027208],
            [15.464359200105331, -4.59104699969118],
            [15.46496360010322, -4.591048999962222],
            [15.464933599067656, -4.591440940302076],
            [15.464915300385314, -4.591680000013571],
            [15.464346700048154, -4.59209709975132],
            [15.464314499936794, -4.592834999972515],
            [15.464126699940127, -4.593546100030069],
            [15.464509499930463, -4.59400979964509],
            [15.464994999815666, -4.595313600097679],
            [15.46530889992202, -4.596617199821046],
            [15.465699700308271, -4.596760299634288],
            [15.466037299768455, -4.597190799592174],
            [15.466140100274629, -4.597545000336102],
            [15.466125199919006, -4.598041499992861],
            [15.466308099605804, -4.598286499620776],
            [15.466338099743041, -4.598790500363914],
            [15.466496099926758, -4.599110699690057],
            [15.466360800170257, -4.600001900263112],
            [15.467288800282931, -4.601084300021079],
            [15.467846300138159, -4.601983700066558],
            [15.468493200330458, -4.602448199981273],
            [15.468678399704363, -4.602997500090825],
            [15.469807900020099, -4.60334399983854],
            [15.471482000383613, -4.603761199925232],
            [15.4729467995741, -4.604074100052969],
            [15.474202300286549, -4.605117000015889],
            [15.475457899813646, -4.607098499637248],
            [15.476713399627799, -4.607880700003834],
            [15.478282800446607, -4.607567799770299],
            [15.479538399973739, -4.607724200327098],
            [15.481003200062522, -4.60808930008202],
            [15.482677199814693, -4.608297800041994],
            [15.484246700346516, -4.608402100026801],
            [15.485920700098687, -4.608141399613054],
            [15.489321100130184, -4.607150700199592],
            [15.490661700046138, -4.606911699834385],
            [15.490978700238545, -4.606929399895555],
            [15.491203200007831, -4.606682999788526],
            [15.491159399951185, -4.606509500168285],
            [15.491065499952853, -4.606429800264499],
            [15.491068800363223, -4.606313300310715],
            [15.491309300026012, -4.60627670038085],
            [15.491457300164042, -4.606200000341826],
            [15.491537499955973, -4.606061899867253],
            [15.491639599776212, -4.60604699956313],
            [15.491743100069993, -4.605996599935638],
            [15.49208211168181, -4.605746902142585],
            [15.4924306139946, -4.605468470898282],
            [15.493043096135073, -4.60497913639941],
            [15.493099884034084, -4.604956669626602],
            [15.493268900258146, -4.604944200405098],
            [15.49348629974344, -4.605099600078919],
            [15.493684300110145, -4.605115900294478],
            [15.493900800381844, -4.605039999680239],
            [15.493961000082301, -4.605269299699674],
            [15.494453300214195, -4.605193600116668],
            [15.495007499659055, -4.605032900166304],
            [15.496410639386735, -4.604336142377226],
            [15.496441299785701, -4.604321099613375],
            [15.496606899716767, -4.604325100080004],
            [15.4968068000203, -4.60440689961115],
            [15.497023799755286, -4.604404900279504],
            [15.497271600026417, -4.604279899673763],
            [15.49754350029998, -4.604535699644856],
            [15.497834799692097, -4.604440000357615],
            [15.497996023031101, -4.604219024608699],
            [15.498149500197368, -4.604036600396766],
            [15.49829600014888, -4.603956199814633],
            [15.498395584686312, -4.603974292966167],
            [15.498501300225566, -4.603993500262989],
            [15.498709586302308, -4.604046732272042],
            [15.49888458440787, -4.604073515937779],
            [15.498985699674558, -4.604086499881131],
            [15.499227999561196, -4.604068499577991],
            [15.499461000088012, -4.603800100391505],
            [15.499793300386349, -4.603678199636949],
            [15.500125700397666, -4.603641799683341],
            [15.500042399621353, -4.603405499658814],
            [15.500285700231224, -4.603304399850268],
            [15.500350099555643, -4.603172100303491],
            [15.500624000377343, -4.60308269990886],
            [15.500863699641217, -4.603112799911916],
            [15.500954900202139, -4.603197500332881],
            [15.501235799798222, -4.603121400298881],
            [15.501563600435265, -4.603091899736226],
            [15.501793899728046, -4.602879300402376],
            [15.502958499916872, -4.602300899832561],
            [15.503109099779337, -4.601909400027036],
            [15.503182899973181, -4.601894699748952],
            [15.503280400419181, -4.602130099768333],
            [15.503652399964846, -4.602465700040933],
            [15.504027499596559, -4.602568700151528],
            [15.504110200298246, -4.602783599987996],
            [15.50465501414503, -4.602750884067249],
            [15.504747999658385, -4.602745299807184],
            [15.505104399959153, -4.602805699954837],
            [15.505651700342636, -4.603198600057344],
            [15.506375199879205, -4.603054400027556],
            [15.50737330002511, -4.603369399861708],
            [15.507559400409233, -4.60355779971386],
            [15.507683499970788, -4.603500499590503],
            [15.507752116885445, -4.603577755194863],
            [15.507922600058398, -4.603769700247444],
            [15.508362600274447, -4.604043399750446],
            [15.50877010034184, -4.603731400120421],
            [15.508920700204269, -4.603719699782325],
            [15.509272200195172, -4.603925699620601],
            [15.509343000015976, -4.603952200247389],
            [15.509361671499146, -4.603934755210918],
            [15.50961869387498, -4.603694622477598],
            [15.509918001747854, -4.603466064708305],
            [15.510663100377132, -4.603098599943555],
            [15.511314599943672, -4.602574900078954],
            [15.512358100045684, -4.602136000429901],
            [15.5123787999248, -4.601959399719624],
            [15.512833800209449, -4.60165329982943],
            [15.513366299950324, -4.601048800447884],
            [15.514297300436066, -4.60132009963923],
            [15.514786999945198, -4.601252399697312],
            [15.515382300009257, -4.600735200374575],
            [15.515900800404729, -4.599442700238718],
            [15.516005299625082, -4.598699700409108],
            [15.515600899643738, -4.597999800298237],
            [15.516424599962045, -4.597126400257226],
            [15.51712750023084, -4.594607899556108],
            [15.519084300414253, -4.59317830015821],
            [15.519635999847658, -4.592260100397554],
            [15.521593700142999, -4.589856600325699],
            [15.523230300334944, -4.588406599977675],
            [15.524927499977618, -4.587741899615712],
            [15.526927800180349, -4.587983599978394],
            [15.529837299655163, -4.589312899560285],
            [15.531595099646934, -4.5903400004185],
            [15.532097311789672, -4.590744332202153],
            [15.534746999619697, -4.592877599597134],
            [15.535271206113865, -4.593095446454339],
            [15.538665562280125, -4.594506052102625],
            [15.540148743696284, -4.595086791971045],
            [15.542748099819267, -4.595777799738974],
            [15.54426350021139, -4.597046600132533],
            [15.546385000213911, -4.600550900310752],
            [15.548567099667192, -4.60133629988535],
            [15.549355100037818, -4.60296760019668],
            [15.550567399869921, -4.604296900305513],
            [15.552590099564242, -4.604028899630609],
            [15.553078996877833, -4.603787551825188],
            [15.553568160092764, -4.604259985677676],
            [15.571231199925137, -4.603979021776013],
            [15.576158867991978, -4.605073234707088],
            [15.582480479732981, -4.606476976421346],
            [15.592739428923815, -4.603559722427827],
            [15.595963200407517, -4.602643002825528],
            [15.605094600423445, -4.602735880030226],
            [15.626166119734981, -4.602950375982152],
            [15.634610279812414, -4.602290180209735],
            [15.647165309394749, -4.604216762064182],
            [15.649305631797452, -4.596355651302063],
            [15.650112228192725, -4.59339310821513],
            [15.651283418422524, -4.586085169667348],
            [15.652945018728827, -4.584445130447843],
            [15.652096762962225, -4.582686009938068],
            [15.655782803897857, -4.579420764970897],
            [15.654390079237558, -4.577449746082873],
            [15.654359014596729, -4.576539483819311],
            [15.655416031648835, -4.575112395283018],
            [15.656291841440138, -4.573928216084244],
            [15.658650582017644, -4.574168794364842],
            [15.659800325868304, -4.574956652751865],
            [15.660920279787522, -4.576230024004027],
            [15.661857781380991, -4.576380872294404],
            [15.662492294703815, -4.57586445519927],
            [15.662491290387328, -4.574772109765774],
            [15.662520440718307, -4.5735887070479],
            [15.663183904946122, -4.571676486344348],
            [15.663848846004262, -4.571372441238085],
            [15.664332251018198, -4.570947191817713],
            [15.664906031939623, -4.570157742400626],
            [15.665993590813077, -4.569094729677563],
            [15.666960955999819, -4.568851086518549],
            [15.6674447499843, -4.568850635789843],
            [15.668321935994625, -4.569183590804351],
            [15.668594801957132, -4.569972252534629],
            [15.668565351588857, -4.570821882388051],
            [15.66814248044863, -4.57130776370031],
            [15.667719720699509, -4.571915016387437],
            [15.667720254298786, -4.572491531719049],
            [15.668053342419611, -4.573007050728259],
            [15.668748828892358, -4.573036744559801],
            [15.669081129190696, -4.572702661839301],
            [15.669080594693089, -4.572126146679846],
            [15.669654736737279, -4.571731152303363],
            [15.670289662386837, -4.571669872377835],
            [15.67150560039585, -4.584759117283917],
            [15.678328679576195, -4.594527853056781],
            [15.698419920418772, -4.608162214906126],
            [15.717260879760703, -4.614322524756406],
            [15.732621000327338, -4.61895547676504],
            [15.743627639787045, -4.630258565185605],
            [15.750998279862298, -4.647492812750595],
            [15.745772520241456, -4.662360555477688],
            [15.737690879788483, -4.679436834224505],
            [15.726097440123953, -4.696476946497945],
            [15.720184799890754, -4.710590501997725],
            [15.715614960445999, -4.727701507560669],
            [15.71484636009226, -4.742070900611349],
            [15.712766279610843, -4.763477775757062],
            [15.709694040440855, -4.776126927110934],
            [15.698787479591985, -4.793917667844933],
            [15.683758920010209, -4.807190689493178],
            [15.668037409899723, -4.81031897670004],
            [15.647921639660035, -4.807571961491967],
            [15.635918879941327, -4.810433206308144],
            [15.624510839974988, -4.818521740668234],
            [15.620018400273414, -4.831901487730353],
            [15.613781399950723, -4.861671150094415],
            [15.616250999820798, -4.878104027062269],
            [15.624385920251584, -4.892356716676528],
            [15.638904720045611, -4.903690987256271],
            [15.646537355570132, -4.906584481358775],
            [15.659119439713884, -4.911354258231102],
            [15.668860319700586, -4.915927901845734],
            [15.678210240299252, -4.923167986531338],
            [15.680440440044416, -4.924527974165159],
            [15.682670279565183, -4.925887958980639],
            [15.684900480208643, -4.927247760780439],
            [15.685725239640698, -4.929425808634606],
            [15.686549999971014, -4.931603848351909],
            [15.686002079750001, -4.934426492240765],
            [15.685454519753389, -4.937249123063661],
            [15.69913199967314, -4.946810965264802],
            [15.717895920394621, -4.956696038335033],
            [15.734645280158221, -4.962086315475518],
            [15.743621879789421, -4.969634531444734],
            [15.744825720186528, -4.979340791186151],
            [15.744640319589976, -4.988286903671281],
            [15.747951240232657, -4.998014248696455],
            [15.754350240038745, -5.018192920285108],
            [15.764899319913539, -5.018706925581822],
            [15.777291769700819, -5.022804694520563],
            [15.779376359724932, -5.023493996054081],
            [15.780602541223148, -5.023489978265541],
            [15.783047280217753, -5.023481967912244],
            [15.783418134411416, -5.023321788751233],
            [15.783547320234103, -5.023265990119575],
            [15.792673319578547, -5.019310877272373],
            [15.799048164584951, -5.022179763480825],
            [15.804857159895567, -5.024793988946675],
            [15.813335160408126, -5.020625958903328],
            [15.815843895383551, -5.020617932298999],
            [15.815860020142885, -5.020617880049484],
            [15.820922159719569, -5.0242828613172],
            [15.821928917828165, -5.024396977170768],
            [15.830794439876168, -5.025401884236109],
            [15.830826825040463, -5.025395373816485],
            [15.831767291074355, -5.025206305868899],
            [15.832268250965573, -5.024903599571392],
            [15.833171624663047, -5.024929089950773],
            [15.833330766605544, -5.024715736813466],
            [15.833250653950197, -5.024396114158195],
            [15.833117235265885, -5.023943340498568],
            [15.833488859315761, -5.023676428849975],
            [15.834206046390827, -5.023542293293276],
            [15.834205098668189, -5.022796269767491],
            [15.834071577575942, -5.022263565165685],
            [15.834071137401464, -5.021917197709732],
            [15.834229939780759, -5.021437406645838],
            [15.834575298888367, -5.021410321619441],
            [15.834654462922778, -5.020983921031881],
            [15.834282095067838, -5.020664671277678],
            [15.834414159092693, -5.020051697000191],
            [15.833855643242881, -5.019599466201632],
            [15.83409425285034, -5.019199505423401],
            [15.83457282582639, -5.019465331596835],
            [15.835263982419461, -5.019757529280697],
            [15.835422851274073, -5.019331025801608],
            [15.83534260297313, -5.018904828330962],
            [15.835448030153186, -5.018238600032274],
            [15.835234905750344, -5.017785929242701],
            [15.835446911750664, -5.017359358695014],
            [15.836244237532226, -5.017571488203713],
            [15.83677513288198, -5.017197796093859],
            [15.837863760750617, -5.016663525670645],
            [15.838288414148352, -5.016316612884433],
            [15.838979464740229, -5.016528875162843],
            [15.839311280846632, -5.016301977521113],
            [15.84012228258007, -5.01682048772006],
            [15.840520775240101, -5.016793331331571],
            [15.841158280851156, -5.016685936339563],
            [15.841636819691217, -5.016925113450192],
            [15.841928901515971, -5.016791518803621],
            [15.84174237712698, -5.01636545928554],
            [15.841901342999682, -5.016018886863868],
            [15.842432369503449, -5.015751765632536],
            [15.84283062231332, -5.015538102259892],
            [15.842511528147977, -5.015325364000546],
            [15.842218764501959, -5.014926086123676],
            [15.842005432588255, -5.014313555914661],
            [15.842563230684153, -5.014206262306791],
            [15.843094801567029, -5.014365439274144],
            [15.843758736512056, -5.014151433114077],
            [15.844370046351084, -5.014337149497462],
            [15.844582285015054, -5.014097081373879],
            [15.844502203800737, -5.013804104578378],
            [15.843731312743065, -5.013485375567856],
            [15.843545061441928, -5.013272467268461],
            [15.843891606325705, -5.013061231803289],
            [15.843983096144129, -5.013005464713624],
            [15.844261173233598, -5.012312370121887],
            [15.844260660295589, -5.011912715618426],
            [15.84396837545159, -5.011886449078427],
            [15.843597411663414, -5.012659594060237],
            [15.842907235132309, -5.013126748938634],
            [15.842455369967995, -5.012967469867689],
            [15.842268709035116, -5.012434836412028],
            [15.842321163461165, -5.011901894420261],
            [15.841868787155473, -5.011342959289243],
            [15.841815309548263, -5.011076591046432],
            [15.842558400442893, -5.010436185234538],
            [15.842690660300484, -5.009983072043472],
            [15.842145485330965, -5.009570796724926],
            [15.842769614129111, -5.009396809185982],
            [15.843460368276947, -5.009382597074061],
            [15.843220725606924, -5.008969928592506],
            [15.842874896680398, -5.008624006226888],
            [15.842874317267038, -5.008171063829331],
            [15.843405575536188, -5.008090448493971],
            [15.843804643117991, -5.008516233310127],
            [15.844123699554089, -5.008702327880241],
            [15.844389175076746, -5.008542123423567],
            [15.8440955939638, -5.007503397455592],
            [15.844414102427567, -5.00726319345903],
            [15.84505207695921, -5.007528807445015],
            [15.845716757505926, -5.007900960165425],
            [15.846061936052154, -5.00774065190958],
            [15.845769105930781, -5.007288088159081],
            [15.845423311140246, -5.006968810900547],
            [15.845821180369491, -5.006462066291982],
            [15.846272836226346, -5.006461482526131],
            [15.846803887882963, -5.006221003375332],
            [15.847521359723974, -5.006326649713248],
            [15.847520501832879, -5.005660558862511],
            [15.847068059051836, -5.005048339665218],
            [15.847545698678299, -5.004594779460194],
            [15.848130261179753, -5.004647310430149],
            [15.848502520338545, -5.004886620830789],
            [15.848847525509932, -5.004593093020564],
            [15.848209141346549, -5.004007759476064],
            [15.848394463789653, -5.003501290013645],
            [15.848207906163005, -5.003048589961468],
            [15.848366969952057, -5.00278194713094],
            [15.848792020405174, -5.002754752314518],
            [15.849323445760952, -5.002807351000047],
            [15.849668483271669, -5.002540467535342],
            [15.849853942258733, -5.002140571850942],
            [15.84949159331415, -5.001421785998751],
            [15.849586591053736, -5.001062663487493],
            [15.849968401998968, -5.001038235203713],
            [15.850422147337172, -5.001276979386793],
            [15.850684477858021, -5.001133039389575],
            [15.850492877987698, -5.000606755489518],
            [15.850158180085876, -5.000152457046125],
            [15.850372687894245, -4.999936779540641],
            [15.850730941419458, -5.000151713818407],
            [15.851185057761898, -5.000677656655054],
            [15.851615092966508, -5.001036097413527],
            [15.851853156398271, -5.000581055143899],
            [15.851733274426955, -5.000150412043851],
            [15.851207408744481, -4.999504896396366],
            [15.851635866507454, -4.998642741824832],
            [15.851349239253111, -4.998451648051084],
            [15.850872186226514, -4.99864373369829],
            [15.850967152525103, -4.998260677642082],
            [15.851205369568769, -4.997925302509358],
            [15.851157083325617, -4.99749456574976],
            [15.850918094629113, -4.997231609756478],
            [15.850917631098445, -4.996872611041415],
            [15.851334896751284, -4.996584869591879],
            [15.851777047534119, -4.997086894997094],
            [15.851825271793533, -4.997469764364398],
            [15.851992697101233, -4.997756746874658],
            [15.85227946359443, -4.998055539859694],
            [15.852613093399368, -4.997684140913403],
            [15.85297060311952, -4.997324676691517],
            [15.853280754556188, -4.997252473377824],
            [15.853471364483076, -4.997012892586653],
            [15.853041610451156, -4.996869851625696],
            [15.852993415836144, -4.996510914871031],
            [15.852920955030406, -4.995840877921876],
            [15.852872266341988, -4.995099009692605],
            [15.853230146168043, -4.995026743969088],
            [15.853683145006258, -4.994691088784504],
            [15.853348572868562, -4.994332524690355],
            [15.852822805102472, -4.993758809654437],
            [15.853156045936867, -4.99308824463509],
            [15.852845308798626, -4.992705715914772],
            [15.852462854659672, -4.992227547264021],
            [15.852701130992179, -4.991940038882008],
            [15.853059256956605, -4.992059239692333],
            [15.853775168423955, -4.992034375936993],
            [15.853488172860368, -4.991556083367862],
            [15.852796002967638, -4.991485183004233],
            [15.852222878714691, -4.991198727438248],
            [15.852150666742251, -4.990720155875135],
            [15.851911432805672, -4.990265733372183],
            [15.851529567063253, -4.990242295666103],
            [15.851434880140729, -4.990840750594667],
            [15.851148194495872, -4.990601789047392],
            [15.85112389776241, -4.990266754087127],
            [15.851409688685193, -4.989811651089171],
            [15.851528332778042, -4.989284965187765],
            [15.851122295167922, -4.989022224776945],
            [15.850620952594376, -4.988879274842432],
            [15.850930607262718, -4.988424141139923],
            [15.850596162685811, -4.988161307587322],
            [15.850048077174762, -4.988784283275946],
            [15.84954685767042, -4.988737064513609],
            [15.84935526408831, -4.988210779539249],
            [15.850022611733078, -4.987539784450719],
            [15.850857225683788, -4.987036104795707],
            [15.851452946159391, -4.986341267940707],
            [15.8515712821301, -4.985575249149633],
            [15.851284106903424, -4.984953355063449],
            [15.850974145909573, -4.985169156480761],
            [15.850855346408196, -4.985576176178133],
            [15.850402012498396, -4.985648562776327],
            [15.850425108184336, -4.985050200349146],
            [15.850806385530291, -4.984618907274315],
            [15.851450203602816, -4.984211207694119],
            [15.852118562750617, -4.984330008123294],
            [15.852380794456785, -4.984114269489966],
            [15.852261102030022, -4.983827225077004],
            [15.851926321483198, -4.983301126206834],
            [15.852092725406431, -4.982798310831058],
            [15.852569982350564, -4.982773759334804],
            [15.852427381985757, -4.983228677184097],
            [15.852690137409734, -4.983419802477816],
            [15.852999819925818, -4.982988602012748],
            [15.853166253493455, -4.982509719879895],
            [15.852903343559243, -4.982198928649536],
            [15.853093919350139, -4.981935415090515],
            [15.853428113297092, -4.98200678136715],
            [15.853834333265187, -4.982413120162305],
            [15.854096841652463, -4.982412779619565],
            [15.854382719711863, -4.982029475221665],
            [15.854286767961426, -4.981646667898331],
            [15.853761752085205, -4.981647348984652],
            [15.853355563558107, -4.981264943240964],
            [15.853569880025331, -4.980905666304666],
            [15.854071031257725, -4.980905015848499],
            [15.854500805950913, -4.981071991170562],
            [15.854786961589717, -4.980904086110587],
            [15.85464329582295, -4.980533307064912],
            [15.85366436482694, -4.980151644816147],
            [15.85373558775421, -4.979864353602065],
            [15.854164774050901, -4.979576597390836],
            [15.854736961361006, -4.979145054727727],
            [15.855429210305481, -4.979287755454203],
            [15.855476505706864, -4.978952628159307],
            [15.85509415217922, -4.978546259268751],
            [15.855141355054137, -4.978139332458881],
            [15.855571375885694, -4.978497772177464],
            [15.856311353219521, -4.978640409982404],
            [15.856549685247543, -4.978400767352968],
            [15.856334443515578, -4.978042048297844],
            [15.855928287327878, -4.97768357769657],
            [15.85614266308391, -4.97737216612799],
            [15.856213513210349, -4.976797675708272],
            [15.855950357137768, -4.976295418365419],
            [15.856069368641563, -4.976055931629802],
            [15.856642325807849, -4.976222719007024],
            [15.856952838367283, -4.976437714306531],
            [15.857286533749246, -4.976126148083861],
            [15.857071198592484, -4.975695629270603],
            [15.856546094681347, -4.975624512754772],
            [15.856092335868421, -4.975361836180788],
            [15.85611567499781, -4.974954940709228],
            [15.856473358092799, -4.974739076434563],
            [15.856807733499434, -4.974954040693052],
            [15.857261616279891, -4.97531244883603],
            [15.857356360694595, -4.974761860634884],
            [15.856974008963579, -4.974355492725402],
            [15.85694977331552, -4.97406832507522],
            [15.857307393528446, -4.973804593797154],
            [15.857139757116663, -4.97335008016261],
            [15.856710080339859, -4.973254905237527],
            [15.856447143456203, -4.972920181144334],
            [15.85630323244936, -4.972357936606006],
            [15.856206880050284, -4.971663996669588],
            [15.856039491573499, -4.971400948215572],
            [15.855705396441261, -4.971401381559061],
            [15.855395503719388, -4.971665049847004],
            [15.855061407688787, -4.971665483190302],
            [15.855013216667063, -4.9713065468972],
            [15.855442459557603, -4.971066657412231],
            [15.855847838702582, -4.970826798470091],
            [15.855894361552828, -4.969893339963707],
            [15.855583204901373, -4.969175745410384],
            [15.855678227793813, -4.968840556141094],
            [15.856131055053783, -4.96838523631063],
            [15.856655875097301, -4.968240954766597],
            [15.857133431180436, -4.968455733781439],
            [15.857299921341923, -4.968024718882347],
            [15.857514417472197, -4.967809040600032],
            [15.858015171649244, -4.967509223740235],
            [15.857513953941529, -4.967450041816179],
            [15.856726632697278, -4.967594664086166],
            [15.856010315191403, -4.967284462133827],
            [15.855627815238366, -4.966758425542379],
            [15.855651123825053, -4.966327596011102],
            [15.856318877508343, -4.965991663809366],
            [15.857177201592643, -4.965392218373037],
            [15.857463134449265, -4.965056780299463],
            [15.856914020367244, -4.96486602799462],
            [15.856484534931585, -4.964914451235763],
            [15.856197799879389, -4.964627624473157],
            [15.856483731837715, -4.964292187807412],
            [15.857032597984739, -4.964291475170319],
            [15.85748582319839, -4.964147287316433],
            [15.857246599143279, -4.963692865134692],
            [15.857413150390236, -4.963309716367605],
            [15.857866591199556, -4.963333061348798],
            [15.858462688967604, -4.962949353791039],
            [15.858986606204207, -4.962111008299134],
            [15.858985801313743, -4.961488743993446],
            [15.858865215063236, -4.960507636847646],
            [15.858577429880498, -4.959407080892388],
            [15.858624259954585, -4.958712955067271],
            [15.859314941338891, -4.957658993653994],
            [15.859600745736426, -4.957227822953001],
            [15.860030567141997, -4.957442663260669],
            [15.860699084393286, -4.95770505966842],
            [15.86115177690599, -4.957154005197271],
            [15.861652909273749, -4.957153352014542],
            [15.86244077579537, -4.957439523480113],
            [15.862750690076808, -4.957199786549827],
            [15.862749944475116, -4.956625390034688],
            [15.863202448341632, -4.955930735096525],
            [15.863416162937598, -4.955116725899456],
            [15.864107609686531, -4.9546610910544],
            [15.864774538716381, -4.953702890107938],
            [15.865417540220346, -4.952696853729522],
            [15.865224768048579, -4.951261111504086],
            [15.86496093554458, -4.950232326846545],
            [15.865652190054035, -4.949633093056233],
            [15.865865698037503, -4.948663517398059],
            [15.866103053596818, -4.947681944988151],
            [15.865076040275198, -4.946989222991157],
            [15.864955948098132, -4.946391048452979],
            [15.864907507344746, -4.945840647533338],
            [15.864191957898425, -4.946104846915924],
            [15.863451894326346, -4.945866478880953],
            [15.862807065649086, -4.945460454232721],
            [15.862400465693618, -4.94474298594668],
            [15.862089101531302, -4.943857859935622],
            [15.860966491293798, -4.94304558805674],
            [15.860249646476865, -4.942304587591192],
            [15.858936692213783, -4.941923357027752],
            [15.857766640149476, -4.941326539209511],
            [15.857932756611804, -4.940608325794048],
            [15.857430559740417, -4.939771310261858],
            [15.856785617875454, -4.939269544244604],
            [15.85671326127428, -4.938671304981745],
            [15.856283239544391, -4.938288927170871],
            [15.855710102715019, -4.937954600476091],
            [15.855852880946289, -4.937643283449116],
            [15.856497083497773, -4.937570652758909],
            [15.857021910727806, -4.937450308550906],
            [15.856925692177693, -4.936852100060027],
            [15.85635258678939, -4.936541706904051],
            [15.855588182466358, -4.935920426418541],
            [15.855706821169289, -4.935393741076099],
            [15.855634466364743, -4.934795501874979],
            [15.855633179078936, -4.933790304936607],
            [15.855059434090132, -4.932977310593049],
            [15.855010820860205, -4.932283307153996],
            [15.855224726797353, -4.931612899566292],
            [15.854865962130759, -4.930967161868077],
            [15.854936539169348, -4.93017727142837],
            [15.854864064888856, -4.929483298360458],
            [15.854242967006483, -4.92895756378386],
            [15.853741549872781, -4.928718875061868],
            [15.853264330657856, -4.928743420484484],
            [15.852548853076769, -4.929055471535223],
            [15.852214473178586, -4.928816567514398],
            [15.852214106665937, -4.928529368114278],
            [15.85252392213269, -4.928217837580587],
            [15.852547068124306, -4.92765537434476],
            [15.852617954183364, -4.927104817118807],
            [15.85307140128093, -4.927152102513956],
            [15.853430008742334, -4.927678175505427],
            [15.853692251228303, -4.927486371652465],
            [15.85388238684469, -4.926887794572371],
            [15.85407264463198, -4.926384951021066],
            [15.85392898156017, -4.926002202042095],
            [15.853188759884567, -4.925620218677238],
            [15.852436119898522, -4.924855316957666],
            [15.852829634993569, -4.924687279401483],
            [15.853199333055469, -4.924555172249333],
            [15.853521246134171, -4.924375258708273],
            [15.853736495052644, -4.924757915834733],
            [15.854047255547115, -4.925188316876492],
            [15.854309497134752, -4.924996514097514],
            [15.854308915924763, -4.924541781785814],
            [15.853854860667759, -4.924015831516694],
            [15.853400958124366, -4.923609547351446],
            [15.85342430174534, -4.923202650262536],
            [15.85387747126347, -4.923034535699196],
            [15.854212123351209, -4.923488839283879],
            [15.854737827336939, -4.92406256482924],
            [15.855358827302961, -4.924516499198827],
            [15.855405879260898, -4.92398990650542],
            [15.855380947418521, -4.923152272390051],
            [15.855762039711506, -4.922601315851475],
            [15.855546606638361, -4.922075060393973],
            [15.854877853130169, -4.921597252588118],
            [15.854996431645963, -4.921022700481121],
            [15.855521093585995, -4.92078269342485],
            [15.855902216421681, -4.920255670666227],
            [15.855901145629877, -4.919418006559463],
            [15.855519260124487, -4.919346697410373],
            [15.854994629625519, -4.919610637179052],
            [15.854970431706704, -4.91934740198752],
            [15.855399338627331, -4.918868184844056],
            [15.855995891841209, -4.918867418097777],
            [15.856687984478821, -4.918938329059397],
            [15.85695013084503, -4.918674725091595],
            [15.856639403588222, -4.918268258323934],
            [15.856019035137864, -4.918304955859933],
            [15.856113780450864, -4.917754367366558],
            [15.855516281311012, -4.917013202260818],
            [15.854703263758053, -4.915673979704912],
            [15.855060431220076, -4.915075188231819],
            [15.855202808802737, -4.914452739544962],
            [15.854820560377954, -4.914094229549733],
            [15.854843751285356, -4.913567666344699],
            [15.854962603787333, -4.913208514353438],
            [15.854484740480355, -4.912718493314664],
            [15.853912176776134, -4.912814960080539],
            [15.853959535059614, -4.912527699622852],
            [15.853911049390478, -4.911929427867573],
            [15.853719698353483, -4.911570673225884],
            [15.853314107206057, -4.911619058964496],
            [15.852824802057318, -4.911511984497123],
            [15.85275989787973, -4.911407557164051],
            [15.852549827748852, -4.911069568604303],
            [15.852263455616052, -4.911046001913804],
            [15.851285119304755, -4.911047250706986],
            [15.850235136959654, -4.911000722799102],
            [15.848945688014291, -4.910284363793476],
            [15.848538947023313, -4.909423279713839],
            [15.847917150251634, -4.908323134369005],
            [15.847153572378666, -4.908324103854551],
            [15.846485321927014, -4.908229218602227],
            [15.846031224449218, -4.907655392742146],
            [15.846006699543626, -4.907128889258196],
            [15.845838823281653, -4.906458966873804],
            [15.845384878517461, -4.906004807398411],
            [15.845026260276256, -4.905454793369317],
            [15.844929715637702, -4.904581346468913],
            [15.844690046018233, -4.903743980464329],
            [15.84404488047276, -4.903026793640966],
            [15.843542945011132, -4.902357292366021],
            [15.843781410888127, -4.902237324638813],
            [15.844497258575116, -4.902236420017576],
            [15.845284631023338, -4.902187558753546],
            [15.845355825204535, -4.901876333798007],
            [15.844878443394569, -4.901757270605258],
            [15.844352707069476, -4.901135667098632],
            [15.843731916410913, -4.900825316536149],
            [15.843468689371425, -4.900227313468098],
            [15.843086364589857, -4.89979699430701],
            [15.843372403447704, -4.899557299372882],
            [15.843443087385815, -4.898839207875],
            [15.843180161281957, -4.898480538009763],
            [15.843155910362547, -4.898169434745032],
            [15.843512842465964, -4.897379182344959],
            [15.844513715711107, -4.896336816771013],
            [15.844560687719005, -4.895738422193564],
            [15.844439580445647, -4.894302570694371],
            [15.843936964061051, -4.893082601024151],
            [15.843530513225902, -4.892436911106824],
            [15.84276665418024, -4.892198538916585],
            [15.842360444093611, -4.891744314660584],
            [15.842550675829756, -4.891217539880409],
            [15.843384650179965, -4.890283087682321],
            [15.843742058390477, -4.8898757699455],
            [15.843693707468638, -4.889373228808394],
            [15.843145110816174, -4.889541453779793],
            [15.842453466437913, -4.889805591100344],
            [15.842285690787246, -4.889207466322796],
            [15.842404129165862, -4.888513248231402],
            [15.842929103719618, -4.888536521989239],
            [15.843430485819033, -4.888775225279443],
            [15.843764212642029, -4.888511537164138],
            [15.844050156278415, -4.888200042658982],
            [15.844287987944822, -4.887577474893849],
            [15.844167903852595, -4.886955357061558],
            [15.843976446814411, -4.886500863396138],
            [15.843832592401451, -4.885950576319388],
            [15.844166047034893, -4.885471488074939],
            [15.844619406097545, -4.885470917716576],
            [15.845025462572268, -4.885805473814766],
            [15.845168029699453, -4.885326626042998],
            [15.844952620880829, -4.884800362445961],
            [15.845119168534495, -4.884417218078458],
            [15.845357208610066, -4.883962183846041],
            [15.845141830334175, -4.883459853564686],
            [15.844616889916441, -4.883460514029066],
            [15.844473365185184, -4.883173493984674],
            [15.84456832968711, -4.882790439680659],
            [15.845117131155444, -4.882789749481159],
            [15.845832927638467, -4.882764914012235],
            [15.846214282239506, -4.88242936522812],
            [15.846046715896296, -4.881998775876202],
            [15.846356547532732, -4.881711183935267],
            [15.846809903002097, -4.881710611771597],
            [15.847454446913408, -4.88194913281051],
            [15.847668413037663, -4.881326594304215],
            [15.847619970487653, -4.88075225399407],
            [15.847905218828055, -4.879890291620503],
            [15.848215138499372, -4.879674499676525],
            [15.84850173790594, -4.87988953834465],
            [15.849002663661198, -4.879769237655732],
            [15.849503769977805, -4.879792537851535],
            [15.849790611031194, -4.880199041843314],
            [15.850196725896398, -4.880581462408755],
            [15.85043518368858, -4.880461493430813],
            [15.851174264503737, -4.879981889418151],
            [15.851746379050313, -4.879550363186639],
            [15.852175903113544, -4.879573751692846],
            [15.852605003171943, -4.879262072770795],
            [15.852747171447117, -4.878472091512958],
            [15.852841888912341, -4.877897570319554],
            [15.853103963413353, -4.877586104157961],
            [15.85339041280124, -4.877681473171316],
            [15.854034831846723, -4.877824254548377],
            [15.854487549512248, -4.877321078029063],
            [15.854869137675266, -4.877176992722239],
            [15.855394253264496, -4.877319924683552],
            [15.855919703027016, -4.877726122033346],
            [15.856277643040174, -4.877749598906888],
            [15.856588104395607, -4.877964603959947],
            [15.857257022295535, -4.878609950286711],
            [15.857711135044683, -4.879207703500003],
            [15.8578297997988, -4.878704952425615],
            [15.857685967843702, -4.878178602470386],
            [15.857709312362974, -4.87777170618281],
            [15.858019409002418, -4.877699510403685],
            [15.858425769107729, -4.878273391122382],
            [15.858927208699328, -4.878559949250301],
            [15.859547189975805, -4.878248022963588],
            [15.859880873679675, -4.877960396055049],
            [15.860119723137291, -4.87815155745384],
            [15.860692378469684, -4.878150823999089],
            [15.861216916442185, -4.8778390182605],
            [15.86152652439811, -4.877383888501345],
            [15.861883945185049, -4.877000496558461],
            [15.862504473535525, -4.877119366880376],
            [15.862742192912529, -4.876424996447271],
            [15.863290496714205, -4.876041358863228],
            [15.864077956298976, -4.876088213613104],
            [15.864363823578611, -4.875728846607328],
            [15.864387041435426, -4.875226217239027],
            [15.864911972870019, -4.875225542349534],
            [15.865007078407455, -4.874962153393653],
            [15.864815429129793, -4.874364067465729],
            [15.865459355898501, -4.874123906478244],
            [15.866436285448078, -4.873069583278984],
            [15.866363815659168, -4.872375611377217],
            [15.865481072670498, -4.87244854840564],
            [15.865575932069566, -4.871993693372951],
            [15.865598843600868, -4.871251731724669],
            [15.865311662086015, -4.870581969412874],
            [15.865692907092608, -4.870174613427758],
            [15.864594629521186, -4.869625559860034],
            [15.864569592575881, -4.868704159728148],
            [15.864510787959089, -4.867497996760841],
            [15.863708131574619, -4.866752308686326],
            [15.862847627279129, -4.865547172994519],
            [15.860842113254513, -4.864558900715235],
            [15.859003243003288, -4.863268847793235],
            [15.858381636674459, -4.862288373603223],
            [15.857569213806213, -4.861356007149157],
            [15.857090953443889, -4.860518948692635],
            [15.857328570412957, -4.859740812283825],
            [15.857518634164139, -4.859094370826477],
            [15.86233944044143, -4.860103981467424],
            [15.879239279693246, -4.866609136566711],
            [15.888169440017501, -4.876395393271295],
            [15.898365720039193, -4.892906375808403],
            [15.90370667961208, -4.906384643337362],
            [15.904848600034954, -4.919074002575488],
            [15.907380119879225, -4.932523183865907],
            [15.909958079928776, -4.943735382509506],
            [15.916703760264269, -4.957226790473912],
            [15.927911280089479, -4.958832152966242],
            [15.935074200026662, -4.952193602964396],
            [15.944969520173656, -4.949311425141254],
            [15.955598160239914, -4.944945219646533],
            [15.964729200031371, -4.945038049907656],
            [15.980150880347804, -4.946686354927929],
            [15.991921800163041, -4.955008975625534],
            [15.997401720127202, -4.961776054139195],
            [16.006331880451491, -4.971560892484947],
            [16.021175040335045, -4.967237749029953],
            [16.02754272037873, -4.965065393197878],
            [16.035078105188909, -4.960697090377387],
            [16.038920160133209, -4.958469820259988],
            [16.054280279801514, -4.963100230440617],
            [16.083780480319863, -4.963400257447116],
            [16.094988000145104, -4.965005783109435],
            [16.152537959764459, -4.967828102413055],
            [16.169395320381426, -4.967999570414185],
            [16.184847960235793, -4.968156855084169],
            [16.196788439755835, -4.968278228793182],
            [16.205919839771727, -4.968371054831241],
            [16.222761719721415, -4.969288005172567],
            [16.235389440078247, -4.97016222070701],
            [16.24803227997959, -4.970290777105279],
            [16.257087765167476, -4.969951673895894],
            [16.268081399716802, -4.980634947649457],
            [16.269254279677639, -4.986843022911258],
            [16.267902479566708, -4.99283002374227],
            [16.262956025930663, -4.997941103133921],
            [16.260963479985481, -4.999999953011676],
            [16.257847661744407, -5.003220520705786],
            [16.256035440016078, -5.00966895269142],
            [16.258111143007135, -5.016379804570721],
            [16.258594319848978, -5.017941931605643],
            [16.257688244917464, -5.021166920274972],
            [16.249916160318119, -5.029018006315923],
            [16.247167199666055, -5.030178851501645],
            [16.246263240267002, -5.033633908906316],
            [16.250646240014156, -5.039368956154021],
            [16.250522637220932, -5.040003447153741],
            [16.25022935973854, -5.041508926086292],
            [16.249073400444427, -5.047427019857293],
            [16.25002491934957, -5.050623243414948],
            [16.250236200409436, -5.051332949041147],
            [16.245662400292577, -5.055491983189651],
            [16.242191280390315, -5.069873986395788],
            [16.242050176618772, -5.070460048930788],
            [16.242524791617676, -5.073696415705315],
            [16.242994421865053, -5.076898774417472],
            [16.24281372933892, -5.077406437973753],
            [16.241008320433714, -5.082477023328427],
            [16.24004315971268, -5.08519201559941],
            [16.235471159819635, -5.090039981982839],
            [16.231775400010907, -5.106305873478895],
            [16.230747252117091, -5.113984899417701],
            [16.231676400276719, -5.116511962419888],
            [16.239727262651439, -5.120393866605736],
            [16.24572215981852, -5.127273987660678],
            [16.247303276465278, -5.130065375947353],
            [16.251964199689965, -5.138293949803668],
            [16.251879441846292, -5.145592562884426],
            [16.251793199985748, -5.153018883001122],
            [16.253660142589602, -5.160143055202536],
            [16.252563240338869, -5.173030912362077],
            [16.256473199833827, -5.174626935307477],
            [16.255125398124246, -5.177201005874393],
            [16.254421199789881, -5.178545900338538],
            [16.253765370343665, -5.179075433917188],
            [16.252578359883419, -5.180033857389809],
            [16.250080931104161, -5.182052591108854],
            [16.24870116015024, -5.183167891222692],
            [16.245842400217615, -5.214006970936599],
            [16.242253072803791, -5.221135761675142],
            [16.239692160083393, -5.22622196165787],
            [16.23698243963954, -5.237503998248858],
            [16.235260481529291, -5.240212184672091],
            [16.232876280001722, -5.243961885211043],
            [16.232507217048703, -5.245802193802388],
            [16.231662359608819, -5.250015005040276],
            [16.228504188497055, -5.265784147869482],
            [16.227249480098678, -5.272048948615964],
            [16.224743159794752, -5.276889002502528],
            [16.224985439918452, -5.279878976777098],
            [16.221958192869458, -5.296172991356431],
            [16.221176280381531, -5.303587930700487],
            [16.217979479915918, -5.308200908560528],
            [16.21792134274736, -5.3089677196243],
            [16.217107199605376, -5.319705924577492],
            [16.214637030203409, -5.32807865633763],
            [16.213030200179968, -5.333525006662899],
            [16.213047480172772, -5.33789389582614],
            [16.213640399701319, -5.338622968060424],
            [16.216970400560655, -5.342711264910847],
            [16.217012159644923, -5.353063907731983],
            [16.214279400109014, -5.358593964970094],
            [16.212286440040469, -5.377464933033496],
            [16.21552641533528, -5.383894102131897],
            [16.214197320143185, -5.3958609088178],
            [16.21121813116525, -5.397482225744258],
            [16.206478200213009, -5.417972976463495],
            [16.209266400175018, -5.426244987723967],
            [16.20609624014746, -5.437527965387374],
            [16.202896230899647, -5.441220040169064],
            [16.202904521451391, -5.441258953050391],
            [16.206371311473976, -5.457530185052465],
            [16.20687393863837, -5.460062667474571],
            [16.201639440206463, -5.471588919019339],
            [16.201271162381005, -5.494363015026227],
            [16.204546447754662, -5.510586933862204],
            [16.206190186858173, -5.518728916396016],
            [16.202310479927068, -5.524723005731422],
            [16.201421279848127, -5.532086917313804],
            [16.202006036385686, -5.53552323995212],
            [16.202125440453248, -5.536224917431155],
            [16.203134584487234, -5.537161177362087],
            [16.20558324013648, -5.539432977240519],
            [16.208410320082269, -5.557134929680294],
            [16.212127319657569, -5.567471895845156],
            [16.208250489131999, -5.574385966120183],
            [16.209376193167333, -5.577360897179519],
            [16.209413280113836, -5.577458907865221],
            [16.209505241547799, -5.57770150487423],
            [16.211731319822452, -5.5835739346878],
            [16.211323439767686, -5.596226913215843],
            [16.21248840018098, -5.600822905271332],
            [16.21779444044213, -5.606783973536234],
            [16.21780217942829, -5.608393938815179],
            [16.216888935042476, -5.608550125408761],
            [16.215048359788859, -5.608864906820865],
            [16.214756898699967, -5.610352372752497],
            [16.214597279752077, -5.611166982535196],
            [16.216567100117189, -5.613904868003702],
            [16.216907380150211, -5.614377916738132],
            [16.216226280196711, -5.616449973157279],
            [16.210481400342864, -5.615780970921388],
            [16.210262181769149, -5.618311905886342],
            [16.214418359601986, -5.623817920747334],
            [16.213056480393586, -5.628192908203758],
            [16.214683433577704, -5.632786842262015],
            [16.217899200173907, -5.632544905606741],
            [16.218423500991172, -5.634270970464808],
            [16.218597222590727, -5.634842881686796],
            [16.215404399865189, -5.640604936077371],
            [16.215885359664927, -5.646353960983477],
            [16.211736363862784, -5.651799861209954],
            [16.211317331223754, -5.652349905906073],
            [16.214094359736897, -5.657630884517177],
            [16.210203479560253, -5.661094909072784],
            [16.20999144750882, -5.665695783376449],
            [16.210735824790895, -5.667902549282229],
            [16.211851148793137, -5.671208996638498],
            [16.21071215957306, -5.673742950269974],
            [16.206348240042523, -5.673759987699038],
            [16.205980319746576, -5.676409001609617],
            [16.205960860440886, -5.676551728201204],
            [16.205902230995555, -5.676981764203157],
            [16.213527360197563, -5.688453958870462],
            [16.212177360310481, -5.695128933028654],
            [16.207123293893243, -5.694917057903911],
            [16.205990399742372, -5.699060963805355],
            [16.206492357661862, -5.704817743423249],
            [16.206712199666399, -5.70733901332982],
            [16.205131485464911, -5.714244180813225],
            [16.209091439798701, -5.728260897457703],
            [16.205435280422655, -5.732873936989766],
            [16.205238362525851, -5.741154808161739],
            [16.201147319737618, -5.751978958796142],
            [16.204380378004718, -5.756107885713437],
            [16.208601765442388, -5.753862516444528],
            [16.208734319947393, -5.75379200463588],
            [16.209369301292469, -5.756493841870024],
            [16.20943630932446, -5.75677905030678],
            [16.208531550424826, -5.76058087237343],
            [16.207628415679213, -5.764375840560243],
            [16.208225766597046, -5.765391775228186],
            [16.210867320182185, -5.769883936527423],
            [16.210884239052252, -5.774023711684428],
            [16.209572475955223, -5.775876873846077],
            [16.207456320030339, -5.778865974515746],
            [16.207733879690181, -5.787263162270437],
            [16.206202439878652, -5.794813924176236],
            [16.203007439636885, -5.803182362908523],
            [16.199326079822161, -5.808177940850999],
            [16.193479320235298, -5.809776545210378],
            [16.182567359613277, -5.810040289283712],
            [16.173747000366177, -5.809913347861395],
            [16.164095400342301, -5.810195201161346],
            [16.160339880109298, -5.811403294427148],
            [16.154534160056201, -5.815106090145475],
            [16.150408199752857, -5.818833244323873],
            [16.148423520354626, -5.824694658646177],
            [16.144792200294521, -5.832215329601339],
            [16.141629959814502, -5.842267054071592],
            [16.139686680174435, -5.850232645411508],
            [16.139431440056143, -5.858643274302506],
            [16.141273560412063, -5.869705459287523],
            [16.137911160015385, -5.869775735992355],
            [16.097292983739337, -5.871044491508083],
            [16.013954093722084, -5.873647668724876],
            [16.010141039988412, -5.873766772950571],
            [15.913981440050261, -5.875777160552642],
            [15.856148159875113, -5.87764609347539],
            [15.781442400436781, -5.878501946288531],
            [15.780815413199404, -5.878474251826231],
            [15.604047359736587, -5.879279993061308],
            [15.490553039829363, -5.883410434154862],
            [15.469677360436286, -5.885929379364947],
            [15.447895200073173, -5.885783631646361],
            [15.431867640233598, -5.882131327352274],
            [15.418080720359427, -5.881152857674549],
            [15.37983539988894, -5.878681219479714],
            [15.336273599835401, -5.87883288542452],
            [15.310934640054867, -5.87866329234311],
            [15.295384799791801, -5.87988844602873],
            [15.198845759562461, -5.86834170190362],
            [15.109344360220794, -5.867920939109021],
            [15.086131199779755, -5.864984911010454],
            [15.080835240412732, -5.860396989646044],
            [15.07280847534552, -5.858548387180881],
            [15.070948200037687, -5.858119956046974],
            [14.981921640273736, -5.868459665728088],
            [14.819280480392566, -5.859898054398676],
            [14.776346520077617, -5.859736343906957],
            [14.753899440215926, -5.862684949084381],
            [14.75389922012867, -5.862684992264074],
            [14.716214639736647, -5.870106142443422],
            [14.697946079707235, -5.875231806878773],
            [14.680342800299137, -5.880983445219054],
            [14.660170199939605, -5.889973901108122],
            [14.639659920169821, -5.898332292227198],
            [14.628265919973082, -5.903011143760918],
            [14.619129120184002, -5.905414371798749],
            [14.611550399746209, -5.910774900413881],
            [14.610061080141719, -5.915302168629892],
            [14.609855160227433, -5.919691369174068],
            [14.60974248004978, -5.925496855777996],
            [14.577379199600633, -5.919887300781137],
            [14.542923960247048, -5.910831368165888],
            [14.526414720158865, -5.906542842702637],
            [14.511583799821061, -5.903219449614248],
            [14.499633240305222, -5.901828706530965],
            [14.488399080041926, -5.900433836537339],
            [14.481012449056275, -5.894888179981182],
            [14.481012239748818, -5.894888023464063],
            [14.478066669322086, -5.897106765976263],
            [14.47734024037935, -5.89765394551173],
            [14.466716056855224, -5.899137362022731],
            [14.464018440311529, -5.899514020099237],
            [14.44564440010147, -5.903450881779504],
            [14.420589120202834, -5.901817950163649],
            [14.397648840097323, -5.899762124555409],
            [14.37876216010069, -5.896950679446302],
            [14.365367999838435, -5.894105875411329],
            [14.346955439868973, -5.890803919070953],
            [14.333324400154469, -5.88820432509387],
            [14.318504639587438, -5.886343495175516],
            [14.310852480078537, -5.884926894245024],
            [14.306593320279843, -5.877430964693779],
            [14.305416438324434, -5.874659899546628],
            [14.304055319989079, -5.871455015796804],
            [14.298760440397002, -5.86479200752244],
            [14.295947918548709, -5.865016442829218],
            [14.287044252237084, -5.865726940981834],
            [14.286914845428845, -5.865518432882885],
            [14.284049400233888, -5.860900943194535],
            [14.283508548855833, -5.861288854244886],
            [14.279229360219521, -5.864357976001516],
            [14.276091024807565, -5.868643397748153],
            [14.273498159910808, -5.872183950230172],
            [14.266834200215065, -5.871502882390764],
            [14.265919039722707, -5.872192168618093],
            [14.264999279856143, -5.872884918185663],
            [14.264533948945708, -5.874374934270797],
            [14.262484382437865, -5.8809377113763],
            [14.26055316088387, -5.880617936887838],
            [14.259726359581215, -5.880480943951754],
            [14.258113200028262, -5.877033872495232],
            [14.258113041026474, -5.877033827517597],
            [14.254894440245531, -5.876117961346219],
            [14.240182084948833, -5.884680989643695],
            [14.239055339766061, -5.885336783877225],
            [14.238983518560756, -5.88418258377482],
            [14.238979200359209, -5.884113000660277],
            [14.238971242184087, -5.883984733249917],
            [14.238584280299033, -5.877747920943374],
            [14.233292279807488, -5.872924896416718],
            [14.231624504481905, -5.868544505679274],
            [14.230754280415018, -5.866258859100291],
            [14.230754186990255, -5.866258905877967],
            [14.227999380102313, -5.867641893998098],
            [14.227999200439227, -5.867641983954934],
            [14.226398361280433, -5.871783777740062],
            [14.222490479588725, -5.870638951393592],
            [14.22133636363759, -5.867650395817905],
            [14.215823279669753, -5.868116888335446],
            [14.213995067031059, -5.874097920937529],
            [14.211697320264742, -5.874560960883323],
            [14.208016319776126, -5.871116004940383],
            [14.201580240210047, -5.868823956036806],
            [14.197662399795119, -5.861468973252896],
            [14.198731317728104, -5.858552276978341],
            [14.199264360051389, -5.857097878529203],
            [14.199264342085115, -5.857097838047865],
            [14.197914597319576, -5.854111912258335],
            [14.191887240427974, -5.840777908373324],
            [14.191887108375631, -5.840778014527531],
            [14.188445100176807, -5.843541771627768],
            [14.185223279833901, -5.840325928674557],
            [14.181778440145292, -5.840789919993949],
            [14.179946399785198, -5.844701923266469],
            [14.177877479972853, -5.844244030965123],
            [14.175584279580182, -5.846776959804248],
            [14.173299399383659, -5.847307218450628],
            [14.172598440374195, -5.847469891561356],
            [14.168921399659384, -5.84701397258272],
            [14.168560568867631, -5.848541457693853],
            [14.167780075717882, -5.851844875977944],
            [14.165597638498024, -5.850840093252749],
            [14.164791438259771, -5.850468824579715],
            [14.164200360277572, -5.848831010796228],
            [14.162714279997978, -5.844722003365231],
            [14.162714173996788, -5.844722118514757],
            [14.16166615177562, -5.84586156599164],
            [14.159962440245415, -5.847713896639504],
            [14.153071319970486, -5.848412026007292],
            [14.149622160283704, -5.84703602452484],
            [14.147315280345863, -5.840368957154915],
            [14.145709024345907, -5.840237234938161],
            [14.144558340857447, -5.840142797157668],
            [14.14283198100229, -5.837845779579838],
            [14.141104316793379, -5.83554701619394],
            [14.141104200012391, -5.835546860559578],
            [14.135370479929284, -5.841532880326159],
            [14.13306828021409, -5.838545974338821],
            [14.133068176009525, -5.838545982435368],
            [14.131341390352945, -5.838680670187784],
            [14.131335996867971, -5.838681091207857],
            [14.130082440109806, -5.838778867710565],
            [14.130082359261435, -5.838778949575575],
            [14.127329160357831, -5.841542023970985],
            [14.121128160020154, -5.843389020934471],
            [14.117303410221473, -5.842481664914822],
            [14.116301356590043, -5.84224394489769],
            [14.110322400027652, -5.838111025253888],
            [14.107739668127319, -5.838113174437572],
            [14.106876479665768, -5.838113893231111],
            [14.103665280104444, -5.841797864243879],
            [14.096775239604492, -5.843415017801562],
            [14.086204200412585, -5.841815972502157],
            [14.080233239754525, -5.843891914988914],
            [14.073118200022002, -5.848959916119259],
            [14.070358439823565, -5.846662935196609],
            [14.065766279938931, -5.848966907800902],
            [14.064819388255833, -5.847948749075214],
            [14.062775400285897, -5.845750916509242],
            [14.060477160344474, -5.845522866846752],
            [14.05872150103802, -5.847667633766451],
            [14.055201360070717, -5.851967920642528],
            [14.047222364715388, -5.852574966254565],
            [14.046013402124535, -5.852666917233956],
            [14.038884360351654, -5.848073897873761],
            [14.036745280319035, -5.848571029326461],
            [14.035898160022933, -5.848767903923656],
            [14.035807713148577, -5.84837718361136],
            [14.035206239861864, -5.845778885197084],
            [14.036741715803986, -5.844134602824527],
            [14.038646378666595, -5.842094963211384],
            [14.03864640022616, -5.842094940721134],
            [14.037915984560239, -5.841203724304478],
            [14.037913705534336, -5.841200942705981],
            [14.036575319965594, -5.839567907180857],
            [14.030120322777941, -5.839245523187528],
            [14.023020239994889, -5.838890921089011],
            [14.01628044092956, -5.836579711320828],
            [14.008308494654253, -5.833845781523332],
            [13.996253520359657, -5.840257800090531],
            [13.988167199684041, -5.844695110552348],
            [13.974583319725356, -5.848434256913906],
            [13.952634120330098, -5.851248639996419],
            [13.932354960014905, -5.853808967019292],
            [13.920194880137149, -5.856320338341321],
            [13.906598040183841, -5.858352841161159],
            [13.892766120103801, -5.860874410102515],
            [13.871555640400997, -5.866609704993931],
            [13.857009120393935, -5.869379355217302],
            [13.848436079920958, -5.872600408066659],
            [13.838667479721224, -5.875584977795493],
            [13.831511040230499, -5.876603256345932],
            [13.816722240099736, -5.878886666815871],
            [13.801444919947796, -5.879710249091719],
            [13.787367120194716, -5.881257912063314],
            [13.773764879569926, -5.882558892411371],
            [13.759205759792708, -5.883621796009705],
            [13.752289800201838, -5.884882614387628],
            [13.747122360107555, -5.885525660113545],
            [13.737735359748934, -5.902825962446981],
            [13.729926240305383, -5.905130954371226],
            [13.729642279250823, -5.905116176373871],
            [13.70809728041092, -5.903994951665502],
            [13.702585320235485, -5.906757960054619],
            [13.690635480270187, -5.905154975699689],
            [13.685122440319773, -5.906308006320813],
            [13.677010917408888, -5.90304924071865],
            [13.662827279945683, -5.897350983800008],
            [13.657083479866779, -5.897123851458685],
            [13.653918045875947, -5.898348999873834],
            [13.643991360152503, -5.902191002951213],
            [13.632964199578437, -5.903576008942099],
            [13.626992160043731, -5.906799011622068],
            [13.626398506591585, -5.906659487731773],
            [13.625060721097437, -5.90634507311584],
            [13.624690221738291, -5.906257995647349],
            [13.623086160322575, -5.905880998604015],
            [13.622991783318817, -5.905903271260804],
            [13.622845614845668, -5.905937765497584],
            [13.622112503335558, -5.906110774553142],
            [13.619179440152514, -5.906802955047815],
            [13.615593488607519, -5.903131077252929],
            [13.609751400260128, -5.897148948964566],
            [13.594389123736825, -5.892734538959989],
            [13.588272828242223, -5.890976987781592],
            [13.586839316474778, -5.890565059531368],
            [13.585038910287372, -5.89004770138262],
            [13.582217698136994, -5.889237006940556],
            [13.574589479628735, -5.887044982078844],
            [13.571825040106017, -5.888242151422313],
            [13.566960360110254, -5.889723281623589],
            [13.557232800342547, -5.892892763967517],
            [13.551150959730686, -5.894588644825633],
            [13.542423840220188, -5.895678236416659],
            [13.531043160242477, -5.895124656597941],
            [13.523872376453303, -5.892602531532656],
            [13.523506920236162, -5.892473991752454],
            [13.516175520369121, -5.890029474173888],
            [13.510245978333867, -5.886866129904377],
            [13.506181199589609, -5.884697605953439],
            [13.499491968488256, -5.880997427768805],
            [13.493941919744788, -5.877927374290983],
            [13.489310898740984, -5.876152649062922],
            [13.487015159709282, -5.875272860807822],
            [13.483203229768044, -5.874267729522892],
            [13.480094519895832, -5.873448017086091],
            [13.469532480026414, -5.873719264577967],
            [13.456742399961783, -5.874833279197707],
            [13.451466959912461, -5.8756946938443],
            [13.448021399775012, -5.8767525921217],
            [13.443153839780456, -5.877818913562592],
            [13.438887840209164, -5.877844549883887],
            [13.430368063544353, -5.875675111428801],
            [13.430260351050217, -5.873433089807405],
            [13.42963037152461, -5.870909679424376],
            [13.429000392897301, -5.86987327489469],
            [13.42614996034737, -5.862030043594378],
            [13.423184131114361, -5.862818422814494],
            [13.422957922749397, -5.862878553180833],
            [13.422475609188501, -5.862618391222946],
            [13.421890628072134, -5.862302959133614],
            [13.421620637616867, -5.862663452806728],
            [13.421485641490886, -5.863294316391747],
            [13.420947350311394, -5.863450813700535],
            [13.4185701601346, -5.86409999441059],
            [13.418163989573845, -5.86460897678322],
            [13.417390399977025, -5.865035046889305],
            [13.41583686789771, -5.865405452956039],
            [13.413691515827757, -5.865257290739175],
            [13.41102831913248, -5.865183209166001],
            [13.409474787053167, -5.86547953449929],
            [13.407995233932452, -5.866146264341707],
            [13.405923859024472, -5.865998102324239],
            [13.404222371722916, -5.866220344885705],
            [13.402594862481628, -5.867479721603378],
            [13.401411219805397, -5.867998287543569],
            [13.400301554291106, -5.868516852994959],
            [13.399043934452935, -5.868813176533131],
            [13.398748023110121, -5.868442772760149],
            [13.398674045948148, -5.867553802867441],
            [13.398674045948148, -5.866590750154756],
            [13.398156202221154, -5.865924020850795],
            [13.397342447151379, -5.865331371402825],
            [13.395936871192603, -5.865109128482428],
            [13.394679250456102, -5.865775858773506],
            [13.394235384789377, -5.866812993376416],
            [13.39334765255763, -5.867479721603378],
            [13.392755830770332, -5.867183398246612],
            [13.390758433922622, -5.866368507742916],
            [13.387207504995597, -5.864960966185795],
            [13.383434642786062, -5.863923827193733],
            [13.379365870132011, -5.864516478157096],
            [13.377220517163762, -5.865998102324239],
            [13.37633278493198, -5.866072182888185],
            [13.37502546759732, -5.866623401846122],
            [13.375000898674305, -5.866633761293533],
            [13.372707878842983, -5.867331559944918],
            [13.370636503935003, -5.868813176533131],
            [13.369378883198468, -5.869257660191773],
            [13.3693049051382, -5.870442949991324],
            [13.368343195744481, -5.871554155621452],
            [13.367529440674705, -5.872813520127119],
            [13.367381485452464, -5.873924721865635],
            [13.366271819938172, -5.876591596331787],
            [13.364940222039698, -5.878813981381589],
            [13.364422378312703, -5.880814120866831],
            [13.36332532783995, -5.884956580862686],
            [13.362963357984444, -5.886466839765426],
            [13.362239420069995, -5.887675044972835],
            [13.361817122054948, -5.891178823398946],
            [13.361515481257246, -5.895226264035826],
            [13.3610931832422, -5.89631363074154],
            [13.360429572588993, -5.898125904984806],
            [13.360389797883144, -5.899758834127257],
            [13.360369244429453, -5.900602669090429],
            [13.359886619153166, -5.902414928230691],
            [13.358318085208623, -5.90422718136641],
            [13.356990863902208, -5.90386473068001],
            [13.354638062985378, -5.903260647167999],
            [13.351923293111307, -5.902475336705343],
            [13.350053118369095, -5.902052476343213],
            [13.349570492194477, -5.901085938301751],
            [13.349519890094511, -5.901021935217531],
            [13.349469286197948, -5.900957927628245],
            [13.34842425626498, -5.899636127588168],
            [13.346373096145816, -5.898186313932978],
            [13.344563249563148, -5.896796904639563],
            [13.342934387459032, -5.89631363074154],
            [13.341365853514491, -5.895951175712704],
            [13.340340273904074, -5.89468257942352],
            [13.338832068119039, -5.893534800024734],
            [13.336117298245002, -5.893957666966986],
            [13.33593631376638, -5.894984626896783],
            [13.335091718634585, -5.895165854761061],
            [13.334609092459965, -5.894501351399361],
            [13.33370416916863, -5.893474390563449],
            [13.332497605079594, -5.893595209479391],
            [13.332497605079594, -5.892930704212246],
            [13.331894322585926, -5.892326608633172],
            [13.330748086656429, -5.892205788537881],
            [13.330205132322304, -5.892809885149732],
            [13.329916224245462, -5.893352317681333],
            [13.329722506147684, -5.893716028368742],
            [13.329179552711889, -5.893716028368742],
            [13.32827462942052, -5.892991113733515],
            [13.326525110099059, -5.892689066060552],
            [13.325559858648152, -5.892991113733515],
            [13.324172310080526, -5.893413981095461],
            [13.323207057731322, -5.893293162139496],
            [13.322905416933652, -5.892447427802259],
            [13.322422790759035, -5.89087677472697],
            [13.321336882989078, -5.889547756793616],
            [13.320371631538203, -5.890091446501208],
            [13.319104738391328, -5.889789396330441],
            [13.317958502461833, -5.889004067446291],
            [13.315847015081461, -5.887795865167257],
            [13.311684367581925, -5.88755422475181],
            [13.309391894824637, -5.887433404504132],
            [13.309271238505556, -5.886708481559567],
            [13.308125001677762, -5.885500274222865],
            [13.305953186137851, -5.884412886064157],
            [13.304935835993744, -5.883373772400816],
            [13.302936774567781, -5.881331940196059],
            [13.299799706678696, -5.878190566790845],
            [13.29587837181729, -5.875169997492184],
            [13.293585899958298, -5.873720118258805],
            [13.291715724317758, -5.872511883242525],
            [13.290086862213673, -5.872149411590126],
            [13.289302596139684, -5.871243232763025],
            [13.28803570299281, -5.870941173121952],
            [13.282002880751067, -5.871243232763025],
            [13.275668416813291, -5.87069952439008],
            [13.273436272215541, -5.870034992303798],
            [13.272893318779712, -5.86846427510906],
            [13.270600846022422, -5.86846427510906],
            [13.269695922731053, -5.868222626188633],
            [13.269213296556467, -5.867316439992517],
            [13.26824804510556, -5.867256027646316],
            [13.266679511161016, -5.866531078075075],
            [13.265231634433851, -5.866108190908923],
            [13.263844084967898, -5.865262414702306],
            [13.262818505357483, -5.864356224531591],
            [13.261792924848734, -5.864235399182774],
            [13.260948329716941, -5.864839525661828],
            [13.259138483134238, -5.865020764375844],
            [13.257992247204742, -5.864537462505173],
            [13.256966667594327, -5.863027142436766],
            [13.255699774447452, -5.862302187296502],
            [13.254493210358415, -5.861637645070917],
            [13.253165989052, -5.86200012274791],
            [13.252140409441585, -5.861758470989765],
            [13.250390891018423, -5.861093927208571],
            [13.248279402739719, -5.86048979572092],
            [13.246650540635638, -5.859885663570721],
            [13.244736236155047, -5.860284304630393],
            [13.243959238350072, -5.859661830691686],
            [13.242767842314592, -5.859143102172088],
            [13.241110248494479, -5.859765576696818],
            [13.239245454660782, -5.860439923005223],
            [13.238002259071106, -5.861166140906596],
            [13.237225261266097, -5.860803032075562],
            [13.235308667878204, -5.860906777865828],
            [13.233236674929289, -5.860906777865828],
            [13.232563277131037, -5.860543667964231],
            [13.23157908021081, -5.859713704146476],
            [13.229610686370355, -5.8592468482749],
            [13.22784949254345, -5.858831864645991],
            [13.226036499162316, -5.857846279186544],
            [13.224534304004857, -5.85727567527857],
            [13.222462311055942, -5.857171929704276],
            [13.220079518985051, -5.856860691065062],
            [13.218370124712376, -5.856808818241308],
            [13.217075128670139, -5.856808818241308],
            [13.216349931317691, -5.857068183210867],
            [13.215521133958452, -5.85727567527857],
            [13.214329737923006, -5.857586913683504],
            [13.213656340124754, -5.857483168167771],
            [13.212775743211319, -5.857638786434042],
            [13.211584347175839, -5.858157516369662],
            [13.209823153348934, -5.859143102172088],
            [13.207388560825482, -5.860076813695501],
            [13.205575567444345, -5.861062395165172],
            [13.204332371854669, -5.861477377113959],
            [13.20386617317167, -5.861269886628429],
            [13.203192775373452, -5.861840485500454],
            [13.202881976251442, -5.862359211480126],
            [13.202208578453225, -5.862255465963464],
            [13.201068981971977, -5.863033554613205],
            [13.200343784619529, -5.863915386487444],
            [13.19951498726029, -5.864278493266385],
            [13.198789789907842, -5.864122875976213],
            [13.197909192994407, -5.863241044434304],
            [13.196873196519949, -5.86370789692051],
            [13.196614196952169, -5.864797216949327],
            [13.196355198282721, -5.865886535722169],
            [13.195422800916722, -5.866509001724857],
            [13.193350807967807, -5.86780580521],
            [13.192677410169557, -5.868272653824428],
            [13.19179681325612, -5.868065165000585],
            [13.191123415457904, -5.86770206071983],
            [13.190450017659654, -5.866923979568439],
            [13.189414021185195, -5.865938407691067],
            [13.188274425602309, -5.865990279655054],
            [13.1874974277973, -5.867183339774608],
            [13.186927630005842, -5.868376397307456],
            [13.186357831316052, -5.869673196391131],
            [13.185529034855145, -5.870399402110764],
            [13.184648437043377, -5.870762504611019],
            [13.18366424102148, -5.870762504611019],
            [13.182680044101254, -5.870088170948486],
            [13.181644047626797, -5.869984427788285],
            [13.180867049821789, -5.870191914988658],
            [13.179468454671122, -5.870503146092274],
            [13.178328858189873, -5.871073735391707],
            [13.177344662167977, -5.871177479245968],
            [13.175635267895302, -5.871592452668209],
            [13.173563274946385, -5.872111169455378],
            [13.17206107978893, -5.872163040837286],
            [13.169678287718003, -5.872163040837286],
            [13.16802069299956, -5.87294111547681],
            [13.166155899165862, -5.872992986780425],
            [13.16398030710852, -5.873978546016683],
            [13.160354318549587, -5.875171588806679],
            [13.15615853309756, -5.875949658287624],
            [13.153309542343637, -5.877609537483566],
            [13.149528155122045, -5.878646959209065],
            [13.14724896305791, -5.880151217499932],
            [13.146100772394364, -5.880726100212915],
            [13.145384169224215, -5.881084892459626],
            [13.143085998453069, -5.882943742328612],
            [13.14083002604241, -5.884543905069151],
            [13.140294065092753, -5.885885634813834],
            [13.13989003791224, -5.886897075768558],
            [13.138480055717032, -5.888403099717474],
            [13.137851394019936, -5.888999482525081],
            [13.136694078269739, -5.890097371715247],
            [13.133686116253269, -5.892074016659564],
            [13.131336145029561, -5.893580026383921],
            [13.127495036011272, -5.894705767352015],
            [13.127482193695968, -5.894709530960141],
            [13.124614101165863, -5.896219427466486],
            [13.124608618747676, -5.896222314030807],
            [13.123602525392398, -5.89751390836175],
            [13.122764113364692, -5.898056376712237],
            [13.1220801441922, -5.898284672642976],
            [13.122067587541137, -5.898288863497583],
            [13.121461796951209, -5.898415238572498],
            [13.121448995958403, -5.89841790924097],
            [13.120778700941161, -5.898418022580227],
            [13.120764824664962, -5.898418022580227],
            [13.120300473816528, -5.898056376712237],
            [13.11991514686529, -5.897760563700112],
            [13.119913514626397, -5.897759310670267],
            [13.119475133174484, -5.897872189488578],
            [13.119462062687118, -5.897875554588151],
            [13.119474960697975, -5.898534265458693],
            [13.119492293691371, -5.899039276919045],
            [13.117616612276453, -5.899602733961355],
            [13.115926090709566, -5.898853586933043],
            [13.115920338796784, -5.898851027806852],
            [13.114705188610291, -5.898383037631937],
            [13.114704958641566, -5.898382948579675],
            [13.114698353329274, -5.898380404743059],
            [13.113764650711197, -5.898473899725761],
            [13.111972387751845, -5.897062658011778],
            [13.110468406743626, -5.894333029693517],
            [13.108306434044277, -5.892356393798234],
            [13.105674466381529, -5.889814993412597],
            [13.103606492495194, -5.887555961755174],
            [13.10219651029999, -5.88426152390689],
            [13.101490330282095, -5.881503657179839],
            [13.10125652216982, -5.880590554675119],
            [13.100773947199199, -5.879228704359664],
            [13.100597757927586, -5.878669194292281],
            [13.100582227852964, -5.878640941217699],
            [13.100222535226669, -5.877672587977258],
            [13.098342558068063, -5.874566347430389],
            [13.096556580620769, -5.871648348738248],
            [13.094394607921421, -5.869012723705934],
            [13.093454619791284, -5.867412516632228],
            [13.093266622165258, -5.866282955895898],
            [13.092514631661114, -5.865718173758784],
            [13.090446657774779, -5.864965131207199],
            [13.089224672307269, -5.864023826569136],
            [13.086310709103813, -5.863082520321714],
            [13.083960738778437, -5.863082520321714],
            [13.083490744713369, -5.862329474165237],
            [13.083208748274327, -5.862047081591094],
            [13.081892763993805, -5.862141212465223],
            [13.081892763993805, -5.862800128133716],
            [13.081046774676649, -5.863082520321714],
            [13.079448794855415, -5.863082520321714],
            [13.078132811473189, -5.862800128133716],
            [13.076628830464971, -5.863459043013814],
            [13.074936851830691, -5.863741434863884],
            [13.073432869924142, -5.864400348617505],
            [13.071458894850819, -5.864117957105388],
            [13.06826293520832, -5.863553173646589],
            [13.065912964882946, -5.863364912364945],
            [13.064126986537319, -5.862517735800889],
            [13.063186998407183, -5.861482296008397],
            [13.061871015024991, -5.860729247663978],
            [13.060743029268794, -5.861011640913797],
            [13.059803041138657, -5.861388165021664],
            [13.058675055382459, -5.861388165021664],
            [13.055855090093718, -5.860823378763353],
            [13.053035125703239, -5.860164460730105],
            [13.050121162499783, -5.859317279243745],
            [13.04805318771515, -5.859034885125495],
            [13.045609218576759, -5.858658359409374],
            [13.043259248251385, -5.857905307205327],
            [13.041379271991078, -5.858187701902413],
            [13.040533282673954, -5.857999438787115],
            [13.038465307889288, -5.857340516477509],
            [13.036679330442029, -5.858093570352799],
            [13.030099412632639, -5.859599673217281],
            [13.022579506693145, -5.859034885125495],
            [13.017973564855408, -5.858187701902413],
            [13.012991626867283, -5.857340516477509],
            [13.009043676720674, -5.856210935084901],
            [13.005095725675735, -5.855740275488239],
            [13.002996338602234, -5.856176948688788],
            [12.995652553662376, -5.859009663534752],
            [12.99260624346471, -5.858955188421117],
            [12.989614330749115, -5.858682811872787],
            [12.986466998709563, -5.857791028516202],
            [12.984788195665578, -5.857142731860684],
            [12.984329160148635, -5.860086118957593],
            [13.003761013318158, -5.86447268242479],
            [13.003685743480498, -5.864965131207199],
            [13.002839754163373, -5.866659476398937],
            [13.000207787398956, -5.868259685662785],
            [12.99710582567114, -5.870330537800931],
            [12.999141921042979, -5.875406170463208],
            [12.999003847288876, -5.87741099463314],
            [12.997277931201484, -5.879554073051612],
            [12.994654537958132, -5.882664979207131],
            [12.992031145613076, -5.884393253585301],
            [12.990443302381491, -5.885637606831134],
            [12.988234129502185, -5.888195435892847],
            [12.986232066804885, -5.88930152053767],
            [12.982296977838187, -5.887227610448012],
            [12.980225878712982, -5.88930152053767],
            [12.979121292273312, -5.891513683131639],
            [12.977947668507442, -5.892758021116292],
            [12.97649789902996, -5.894278873815566],
            [12.974357763476855, -5.894970169755273],
            [12.973184139710984, -5.894693651663999],
            [12.972010516843444, -5.894278873815566],
            [12.971803406661405, -5.893449318075876],
            [12.970905930403774, -5.894140615062609],
            [12.969870380392008, -5.89455539211626],
            [12.968627721096563, -5.895661463922877],
            [12.965866254997406, -5.897320567443769],
            [12.963035752470345, -5.899187053119404],
            [12.960343322799124, -5.899947470618301],
            [12.956753416870203, -5.900569630830757],
            [12.953508694877462, -5.901606561146958],
            [12.949987825376477, -5.902228719472672],
            [12.94612177283765, -5.903196518406832],
            [12.942600903336668, -5.903334775771616],
            [12.938251594904253, -5.903403903991154],
            [12.933349992353691, -5.903127390161073],
            [12.929967196606812, -5.90278174790174],
            [12.927758023727472, -5.903818674024405],
            [12.924444264408496, -5.904371700845652],
            [12.920992432233712, -5.903818674024405],
            [12.918161929706685, -5.90278174790174],
            [12.915676610217435, -5.901330046408256],
            [12.912569961080498, -5.902574362081483],
            [12.910429824629063, -5.903127390161073],
            [12.908634872113767, -5.904924727107605],
            [12.90697799245428, -5.906583802536807],
            [12.903802305991109, -5.907758977694104],
            [12.892411258556697, -5.909901938286026],
            [12.891444745871162, -5.910731469074556],
            [12.888752316199909, -5.910731469074556],
            [12.886543143320601, -5.909971065674995],
            [12.883919750975579, -5.909625427743252],
            [12.882124797561955, -5.910247576042801],
            [12.87963947807274, -5.910800596358529],
            [12.876670902689872, -5.910869724533272],
            [12.873219069616793, -5.909003278735126],
            [12.869698201014106, -5.910662341781844],
            [12.867074807770754, -5.911422744219046],
            [12.861413802716665, -5.911560998603257],
            [12.85934270359146, -5.911560998603257],
            [12.854510137468802, -5.912874418004861],
            [12.848918168842616, -5.915086485265724],
            [12.845466336667835, -5.917989809489575],
            [12.843464273970534, -5.920270982097158],
            [12.842704870568674, -5.922966901547943],
            [12.841669320556909, -5.924280293488587],
            [12.840495697689368, -5.926630565050254],
            [12.839805330715413, -5.928358699540976],
            [12.838838818029881, -5.929188202256544],
            [12.837458084980302, -5.930847203896395],
            [12.836146388358626, -5.932367951407498],
            [12.83483469263528, -5.935202059365229],
            [12.834006252805517, -5.937275787254801],
            [12.832832629039649, -5.940178994091924],
            [12.83262551975594, -5.942252702995506],
            [12.831935152782018, -5.943496925257955],
            [12.831106712952257, -5.944257280954768],
            [12.829725979902678, -5.944602897809918],
            [12.829449833292768, -5.946261851515031],
            [12.827516807023372, -5.948957642159954],
            [12.82489341467835, -5.951100440601729],
            [12.821717728215146, -5.952897619226813],
            [12.819853739271981, -5.953727084483462],
            [12.815435393513335, -5.954694792795464],
            [12.81274296384208, -5.955593376896063],
            [12.809567278277239, -5.958150877751134],
            [12.805770262166314, -5.960639245593291],
            [12.805148932518593, -5.960224518863127],
            [12.80425145626093, -5.960224518863127],
            [12.802732649457246, -5.96167606237832],
            [12.797831047805015, -5.965201223156727],
            [12.793688848656277, -5.967896919587794],
            [12.791134492739159, -5.967966039601871],
            [12.790651235947211, -5.967205717162514],
            [12.78864917324991, -5.967205717162514],
            [12.787751696992279, -5.966721874399679],
            [12.786509036798506, -5.966652754226677],
            [12.78319527747953, -5.966030669573755],
            [12.781193214782229, -5.965615946973885],
            [12.776429685985772, -5.964440896832235],
            [12.769940241101921, -5.962989359830003],
            [12.765798041953216, -5.962367271865818],
            [12.761448732622473, -5.962367271865818],
            [12.757375569901638, -5.9625055141971],
            [12.753095297897127, -5.96278199785429],
            [12.748607915710577, -5.962574634899779],
            [12.74550126657364, -5.962574634899779],
            [12.743982459769926, -5.962159909651856],
            [12.741290030997, -5.962920239180274],
            [12.740208608515253, -5.963636514537795],
            [12.736802648810485, -5.965892429042235],
            [12.732798522517554, -5.968726361871907],
            [12.732522375907644, -5.972458835956799],
            [12.731348753040072, -5.974739780604002],
            [12.729968019990492, -5.976951595866387],
            [12.729001507304959, -5.977228072137375],
            [12.728932469978758, -5.979301639208218],
            [12.726378114061607, -5.982619330674685],
            [12.724030868326494, -5.9849002315006],
            [12.721614585265147, -5.985660529932455],
            [12.718024679336262, -5.988356123354184],
            [12.714772989111834, -5.991330973859764],
            [12.71402055394166, -5.992019345680674],
            [12.709809318365053, -5.994023739213464],
            [12.704424459022544, -5.997203106663048],
            [12.702905653117158, -5.997686922096077],
            [12.701732030249619, -5.997686922096077],
            [12.699039600578363, -5.997617805889226],
            [12.696278134479204, -5.999207480897644],
            [12.693447631952177, -5.999829527300172],
            [12.690755202280922, -6.001280964310395],
            [12.687510480288145, -6.002663281845455],
            [12.684610940434885, -6.003216207864619],
            [12.681918511661959, -6.002801512953882],
            [12.676878835357295, -6.002939744926097],
            [12.673288930326706, -6.002870629394097],
            [12.672253380314938, -6.002870629394097],
            [12.67142494048521, -6.002317703019626],
            [12.671217830303204, -6.001350080046702],
            [12.668180217594138, -6.001764776076626],
            [12.663209578615673, -6.001903007415986],
            [12.65637495069401, -6.001695659494291],
            [12.649954542238063, -6.001833891750733],
            [12.645045980438987, -6.001715028722161],
            [12.640944145290929, -6.001480369359465],
            [12.632609216758757, -6.000989930043476],
            [12.626383803804925, -6.002041205444036],
            [12.62113345549813, -6.003693206263836],
            [12.618508280895567, -6.006171197076793],
            [12.615208061882873, -6.006847011342681],
            [12.613107922021172, -6.007748095108899],
            [12.610557753151555, -6.009775527607798],
            [12.60770756404507, -6.011352414160823],
            [12.604857374040256, -6.012779118208385],
            [12.602532219674597, -6.013304744633657],
            [12.600957115452049, -6.015181978050498],
            [12.599457016064155, -6.015707602122642],
            [12.593981652355106, -6.014731442593293],
            [12.591131463248589, -6.01653358215256],
            [12.591131463248589, -6.018786248088955],
            [12.589931383199302, -6.020212931471893],
            [12.587981253905198, -6.020888727160237],
            [12.582355880526846, -6.02103890366435],
            [12.579130666348805, -6.02156452289606],
            [12.575680436768478, -6.022991198885785],
            [12.572755242827339, -6.024117519021591],
            [12.564279680342503, -6.025919627033788],
            [12.56300459545853, -6.026069802128089],
            [12.560454425690619, -6.028247340759943],
            [12.557904256821038, -6.029824172993675],
            [12.555654107290032, -6.0298992608979],
            [12.551978863205782, -6.030274695764462],
            [12.548003598884629, -6.03117574016844],
            [12.54455337020263, -6.032226957322053],
            [12.538917952761064, -6.033583755911923],
            [12.529279638820229, -6.037778596741189],
            [12.526043692469498, -6.040613102172838],
            [12.520583035079964, -6.041625421319752],
            [12.514111144175097, -6.041018030421431],
            [12.511886431339667, -6.041625421319752],
            [12.505819033840938, -6.041625421319752],
            [12.501976348279277, -6.042232812426794],
            [12.497526923506749, -6.043852517769973],
            [12.497324676803695, -6.046079604933241],
            [12.493279744539011, -6.048306681906941],
            [12.472246099098172, -6.054582941200956],
            [12.451010206055948, -6.057619815179669],
            [12.44231360321398, -6.058429644658474],
            [12.437361410241547, -6.057309712299038],
            [12.405934852546487, -6.026562884968564],
            [12.404076178036519, -6.026190739857251],
            [12.403332708052877, -6.021104737958413],
            [12.399987093575595, -6.010064226047626],
            [12.395774098199341, -6.001628624890762],
            [12.392428483722059, -5.997038610270075],
            [12.386604635666531, -5.991207994820507],
            [12.386167626840384, -5.990876899204702],
            [12.38201990484929, -5.98773440635972],
            [12.379665583982973, -5.984508911641381],
            [12.3722308850448, -5.975824791146449],
            [12.369380916923868, -5.971730800079057],
            [12.363185335223982, -5.964535225911763],
            [12.361202748900352, -5.964535225911763],
            [12.359467985305715, -5.963790850584234],
            [12.359344073492052, -5.962426159975093],
            [12.358724515322075, -5.958952387358663],
            [12.350546347298559, -5.947786535905053],
            [12.344970322870321, -5.942203524909542],
            [12.343359471987677, -5.939846235651152],
            [12.343731206530364, -5.937861142455583],
            [12.342244266563052, -5.934511281197534],
            [12.337039977575833, -5.928431851510623],
            [12.325268371447711, -5.917141300660588],
            [12.31473588165958, -5.907835725938137],
            [12.30296427463316, -5.898902224721072],
            [12.299370837426885, -5.896172514722401],
            [12.292431784845029, -5.889968578578992],
            [12.288342700384105, -5.882399680320733],
            [12.283510146837873, -5.878801314817875],
            [12.282642765040537, -5.876443752872111],
            [12.28016453236059, -5.873341682030877],
            [12.271986363438744, -5.864655789673041],
            [12.268021190791517, -5.861801823446028],
            [12.268021190791517, -5.860560964186353],
            [12.26826901441884, -5.859071929025577],
            [12.265047311755218, -5.854232537419237],
            [12.25463873288242, -5.843684999035322],
            [12.240512805888045, -5.828669920865613],
            [12.229112934302577, -5.815888169430318],
            [12.222421705348046, -5.806704982155848],
            [12.218580444514448, -5.799383142937129],
            [12.213623978256223, -5.790820191995666],
            [12.208543601082665, -5.781512487356224],
            [12.205664553597657, -5.777571674752167],
            [12.22136963980981, -5.772405190218038],
            [12.238043039829641, -5.770331670085337],
            [12.257841959895604, -5.768101066589653],
            [12.282845399815837, -5.766844107772789],
            [12.317225039650026, -5.76511573856839],
            [12.35160432015811, -5.763387543977767],
            [12.381821280153435, -5.760633144666048],
            [12.438069120090367, -5.760276135166559],
            [12.477657960001471, -5.758285950440726],
            [12.507879600219407, -5.754295875772306],
            [12.509187479899451, -5.664097824422313],
            [12.508477199970603, -5.159747786209481],
            [12.503522160237035, -5.160044669391719],
            [12.493607759873429, -5.160145365383825],
            [12.483678960414112, -5.158273960828064],
            [12.475725479907743, -5.155297578438575],
            [12.47321880027771, -5.151501603484442],
            [12.475168560364205, -5.146945433188638],
            [12.4835529600174, -5.141017139041192],
            [12.490479720052905, -5.139122342468286],
            [12.500864279771616, -5.135540592745647],
            [12.507801840251792, -5.135124868870244],
            [12.51225791974395, -5.134364682186528],
            [12.521510279709476, -5.133498947702386],
            [12.521510170115031, -5.133498898164242],
            [12.52151040098205, -5.133498876547602],
            [12.514028400354249, -5.130116952650106],
            [12.508971479989368, -5.1278318826084],
            [12.501019905708072, -5.124237309243841],
            [12.4939713601712, -5.121050940487695],
            [12.487317479572891, -5.115983855038801],
            [12.48317890871963, -5.109753584420641],
            [12.480436440192088, -5.105624994092111],
            [12.477827884422295, -5.101042685962772],
            [12.475850399631181, -5.097568923978821],
            [12.475850164272574, -5.097568699693318],
            [12.471262200418614, -5.093192953943271],
            [12.470805360384244, -5.088820903544955],
            [12.474944279783845, -5.075710853841301],
            [12.479309279987657, -5.069272954977089],
            [12.492164160025311, -5.065143990707093],
            [12.510524162262429, -5.070220987287474],
            [12.510524199991673, -5.070220998096869],
            [12.519017279624578, -5.070457962716515],
            [12.529117439910841, -5.067935891318573],
            [12.532517626143333, -5.066313072960681],
            [12.539220480195935, -5.063113966071396],
            [12.552308279912037, -5.050469973949481],
            [12.555981359954778, -5.049322988478045],
            [12.574802160203411, -5.050947868717032],
            [12.574802313815315, -5.050947776834344],
            [12.575977995621502, -5.050241854190747],
            [12.58054128005967, -5.047501882153616],
            [12.580541402230542, -5.047501737122269],
            [12.586742280397345, -5.040143977839945],
            [12.593104200443442, -5.040284907561198],
            [12.594214644797086, -5.040309235264604],
            [12.597529320397634, -5.040381852634089],
            [12.601203334688291, -5.037624050645001],
            [12.601203480215354, -5.037623941644619],
            [12.606486479587783, -5.026814978849051],
            [12.61498032009373, -5.021759890074934],
            [12.622647424874009, -5.023452392123047],
            [12.624389279769469, -5.023836903401135],
            [12.628530796198577, -5.022179804919979],
            [12.628980365269042, -5.021999914803538],
            [12.630305603993627, -5.019070236256569],
            [12.634494479604516, -5.009809888190532],
            [12.636333359737176, -4.999999953011676],
            [12.640467239588061, -4.991868940363855],
            [12.640694012993333, -4.989006298709855],
            [12.640998240040711, -4.985165913230285],
            [12.64115916064746, -4.983125941504577],
            [12.640472280035141, -4.977602975681156],
            [12.635500319634879, -4.967329857177178],
            [12.632675400137312, -4.961492904514707],
            [12.634284239692056, -4.955051888520934],
            [12.635602621576064, -4.954018693402504],
            [12.639564359963989, -4.950913933081649],
            [12.640584921585218, -4.950825765173421],
            [12.644843399562646, -4.950457869151982],
            [12.649662359802035, -4.950922012804345],
            [12.661364168629179, -4.956910961704604],
            [12.665754786988249, -4.957514275479585],
            [12.666395160021706, -4.957676924182227],
            [12.675134159751817, -4.957151020377322],
            [12.690284002676748, -4.952099116875705],
            [12.702680280185428, -4.954255935882594],
            [12.706207318417478, -4.952822685505305],
            [12.707724239657388, -4.952339937719893],
            [12.715759439905112, -4.945901883799582],
            [12.720066120582361, -4.938482040570825],
            [12.721499280210242, -4.936012876849707],
            [12.721760538142627, -4.935013611979405],
            [12.724025400281363, -4.926350862285886],
            [12.72294967311851, -4.919625674759096],
            [12.721964400016596, -4.91346592071941],
            [12.724051921243502, -4.905672925831045],
            [12.724491239638255, -4.904032880095919],
            [12.726127901813934, -4.901901442457786],
            [12.729082319747912, -4.898053864148996],
            [12.734438117692656, -4.893526645434235],
            [12.73642632028344, -4.891846023993174],
            [12.739625378215361, -4.886825312027545],
            [12.743314139249703, -4.881035995280414],
            [12.750199200388044, -4.87620791937455],
            [12.757867394824769, -4.87509431553183],
            [12.76282044029838, -4.874375015286254],
            [12.770394479615231, -4.871157949453405],
            [12.774117447597281, -4.867314366995164],
            [12.777968159605974, -4.863338878969742],
            [12.784165809227645, -4.854024621798096],
            [12.786232218248768, -4.850919049886732],
            [12.787651439616688, -4.850429901849633],
            [12.788351864128545, -4.850188554492391],
            [12.796941239566642, -4.847228882144331],
            [12.80023019999388, -4.846095008322832],
            [12.800971510427564, -4.844773526363909],
            [12.80229516003242, -4.842413945617408],
            [12.801998931584329, -4.841024374636246],
            [12.801608280318398, -4.839191876434194],
            [12.79403748032648, -4.834816861940677],
            [12.792431159647798, -4.832054852579969],
            [12.794038199877022, -4.826533852643364],
            [12.800923199929928, -4.819174903273416],
            [12.802522043032171, -4.81542725719375],
            [12.808187280049554, -4.802147919673923],
            [12.811179990469137, -4.795133860044821],
            [12.815154360068282, -4.785818960023127],
            [12.816529642140708, -4.783751501398027],
            [12.817449359786474, -4.782368888702925],
            [12.821429159701507, -4.780042909167773],
            [12.823074369347134, -4.779081493136442],
            [12.831217200342328, -4.774323024290612],
            [12.831217404259869, -4.77432266651826],
            [12.836725192659117, -4.764661008043449],
            [12.836496239940985, -4.759828948855938],
            [12.839479200046476, -4.75522891281083],
            [12.842182258584154, -4.754655288242915],
            [12.847051440037804, -4.753621982166636],
            [12.854349815140054, -4.754521116110447],
            [12.85829315962421, -4.755006920959857],
            [12.857147294698914, -4.751324957559475],
            [12.860590319790655, -4.741202850898328],
            [12.861851760163781, -4.740167852614585],
            [12.863113199638542, -4.739132853661157],
            [12.867451200078193, -4.738823925065423],
            [12.869396578182746, -4.738685524814475],
            [12.872750399668446, -4.738446924074946],
            [12.875188313263502, -4.735284680430212],
            [12.87665140475664, -4.733386935350157],
            [12.8920242993666, -4.731781947654784],
            [12.898448280422439, -4.734314989841461],
            [12.914279279894686, -4.73455099824977],
            [12.921159284416298, -4.732828924483558],
            [12.923456399666987, -4.732253952622018],
            [12.930086688709254, -4.728854462327371],
            [12.943188360209968, -4.722136907537422],
            [12.949268400598012, -4.720758457786134],
            [12.955348440087759, -4.71938000616103],
            [12.955351519512543, -4.719378376678493],
            [12.964331159940986, -4.714627921969815],
            [12.967322477073573, -4.713724130901928],
            [12.972051920194865, -4.71149045326595],
            [12.974380199799393, -4.71039094728118],
            [12.974759993128476, -4.710211304365044],
            [12.975308279862141, -4.709951962571309],
            [12.981112505118604, -4.706238461241276],
            [12.986091360088654, -4.703053010396329],
            [12.987077882747167, -4.702764284933401],
            [12.98761523967878, -4.702607016213097],
            [12.988477439993524, -4.702355010710517],
            [12.997103400219878, -4.69983387086114],
            [13.01362236007942, -4.698226989399249],
            [13.021878022169245, -4.693654422359529],
            [13.02234104171445, -4.693397968383265],
            [13.023943039699965, -4.693256602706029],
            [13.023945174995401, -4.693256414335019],
            [13.030141319938965, -4.692709929956913],
            [13.035417480437159, -4.689719940322299],
            [13.045740480406073, -4.680287898407316],
            [13.052393196787744, -4.677527989226836],
            [13.057040160192937, -4.679204938503263],
            [13.07529739605987, -4.685794381293366],
            [13.078914479619375, -4.687392926752319],
            [13.083489360409509, -4.688970015707397],
            [13.084307280068961, -4.689250946187729],
            [13.092988999623318, -4.687661592028259],
            [13.093003440041524, -4.687658948503429],
            [13.099585190414059, -4.682708689367566],
            [13.1012614799719, -4.681447915204239],
            [13.104471240432106, -4.672934911478921],
            [13.105159199921074, -4.668102931107068],
            [13.10114084700901, -4.659696702789417],
            [13.099879449755045, -4.657057799888976],
            [13.100567491889047, -4.652225879214328],
            [13.106273039906478, -4.647281563633999],
            [13.109727240040343, -4.648081111565523],
            [13.113553679570064, -4.649300282258843],
            [13.117394880216558, -4.650094259310566],
            [13.120863839670536, -4.650468793904879],
            [13.125494159988436, -4.650826262098328],
            [13.130868959996384, -4.652022794165887],
            [13.137047639894213, -4.652357808029507],
            [13.144402439976082, -4.652250568097542],
            [13.149881280165296, -4.650470769669531],
            [13.156462080120269, -4.650374665657978],
            [13.16234268014219, -4.648164102073359],
            [13.169012760059992, -4.645516841235705],
            [13.175682479753355, -4.642869570326951],
            [13.182923159658156, -4.638734009403028],
            [13.184778720607351, -4.640243857232485],
            [13.188201479706272, -4.643028906832963],
            [13.191715187837827, -4.651248243441706],
            [13.192333200007202, -4.652693899745768],
            [13.195006042812011, -4.654225331595743],
            [13.20036516003173, -4.657295879935127],
            [13.202376589462498, -4.659804790633889],
            [13.206203279622178, -4.664577899662075],
            [13.207663968121913, -4.666398892430943],
            [13.209775200380776, -4.669030889848244],
            [13.220046576865256, -4.674813304515975],
            [13.22285436010046, -4.676393977007228],
            [13.222857036181679, -4.676394377192761],
            [13.228619399945934, -4.677256899969209],
            [13.231414439680481, -4.678926878228401],
            [13.23294504316048, -4.679841859744765],
            [13.235026707371746, -4.682273507659777],
            [13.243260592502468, -4.691903305204253],
            [13.245233862398267, -4.694211088824862],
            [13.246722360044282, -4.695951915454939],
            [13.256366399846751, -4.719419880715442],
            [13.256366511237824, -4.719419982558113],
            [13.259399023312707, -4.72220673797028],
            [13.264630199774714, -4.727013949645902],
            [13.264731955540197, -4.727471976786851],
            [13.265090280032314, -4.729084882170455],
            [13.258436400332338, -4.728623996442922],
            [13.256811178201794, -4.729752584392583],
            [13.25545415977739, -4.73069492408947],
            [13.25423016927016, -4.733613068250681],
            [13.253620337159756, -4.735066978299135],
            [13.253620320091777, -4.735067019756253],
            [13.254002360107368, -4.736138875696454],
            [13.254768359838346, -4.738287969223206],
            [13.257826207997498, -4.740587171022436],
            [13.259323439963023, -4.741712939963776],
            [13.262112360373873, -4.743809870744077],
            [13.26341722890108, -4.745584845000153],
            [13.265326439933993, -4.748181882336878],
            [13.268998440201758, -4.750021955787079],
            [13.273132320052607, -4.758764973444505],
            [13.276305758930974, -4.76152758604532],
            [13.281854400014355, -4.766357885710187],
            [13.283744469745217, -4.769829721424819],
            [13.284610096234458, -4.77141976678107],
            [13.284610200439021, -4.771419959636471],
            [13.289887439813862, -4.770498965267373],
            [13.294018439665919, -4.77464001861385],
            [13.298379343552032, -4.775099960259768],
            [13.300007399867319, -4.777003014026795],
            [13.300730279566322, -4.778513983455388],
            [13.302512280171864, -4.782231855404864],
            [13.306184117844555, -4.784302886437811],
            [13.306184280439629, -4.784302978357826],
            [13.310084159938759, -4.783841950744336],
            [13.313298240397174, -4.786602901120903],
            [13.315435939719253, -4.786449184354007],
            [13.316510160407336, -4.786371939353883],
            [13.319721359968661, -4.782919895474889],
            [13.324081319725392, -4.783609911126341],
            [13.332344245592614, -4.789130800387059],
            [13.332344400102848, -4.789130904021629],
            [13.340373313041887, -4.784757990307914],
            [13.342207769870106, -4.784941822946734],
            [13.344962399789953, -4.785218027805813],
            [13.349088745470548, -4.78647582304487],
            [13.349102488796076, -4.786480012600704],
            [13.350240400936134, -4.786826905752689],
            [13.359424320056833, -4.797409884999102],
            [13.359424470973778, -4.797409939969798],
            [13.363785102670372, -4.799019848595126],
            [13.363785359588542, -4.799019944117692],
            [13.37273316013003, -4.798557849679128],
            [13.374973153308455, -4.801430204406882],
            [13.378474440434541, -4.805919898718537],
            [13.38146244008878, -4.816502983300683],
            [13.380236809257852, -4.818554004749192],
            [13.378934159569409, -4.820733907328898],
            [13.377336479785475, -4.823406888187668],
            [13.377751199612772, -4.826170010976846],
            [13.378718159659327, -4.832609949328262],
            [13.379727239912954, -4.833561927198661],
            [13.382621280280018, -4.836289989248062],
            [13.381913396158062, -4.838706599949774],
            [13.381912424180904, -4.838709919614959],
            [13.381475400083406, -4.840201849732953],
            [13.381475444999161, -4.840201965975038],
            [13.382007421022193, -4.841578200591843],
            [13.384232280283015, -4.847333936844192],
            [13.384232613557971, -4.847334433345763],
            [13.388790959957028, -4.854141090341166],
            [13.394120759759108, -4.85983012593436],
            [13.398713640092616, -4.864786801625764],
            [13.403293919757639, -4.870122523095983],
            [13.408648919998392, -4.875053263501101],
            [13.412314439819696, -4.879283816873694],
            [13.415811839935577, -4.892710646845885],
            [13.427867160081558, -4.88219952232221],
            [13.437140399589254, -4.873973130137738],
            [13.443631560255293, -4.868031733102997],
            [13.454314199849875, -4.868954210036937],
            [13.463138519769076, -4.869418051641576],
            [13.471954559916261, -4.865307751296017],
            [13.480763400066479, -4.857080969519778],
            [13.491891719924691, -4.847483348665177],
            [13.502093759943971, -4.839257244231746],
            [13.5067229995886, -4.83102690867323],
            [13.502526480212975, -4.821417957504127],
            [13.498330680387861, -4.812266285131635],
            [13.503416399842456, -4.799461564871791],
            [13.512223439768823, -4.790319111858629],
            [13.518712800211013, -4.783461922464229],
            [13.527524160135588, -4.77660645864471],
            [13.532632200030029, -4.776610050774948],
            [13.54006583985449, -4.778445377201971],
            [13.543324560294337, -4.783022266618556],
            [13.546590840057291, -4.791716188218444],
            [13.550324039850414, -4.801782628353569],
            [13.558230000376527, -4.808192629565426],
            [13.565203199718949, -4.81231459519419],
            [13.572638999991696, -4.815521888056252],
            [13.582863000226423, -4.819646142613546],
            [13.589831520244534, -4.821023582867794],
            [13.600049759583341, -4.821945765259954],
            [13.607475119635819, -4.819206511300508],
            [13.617207719850576, -4.808235192421573],
            [13.619511000239045, -4.797715553539378],
            [13.62135059992228, -4.787653004309425],
            [13.622215320011415, -4.782187853525758],
            [13.622251405336353, -4.782011732431982],
            [13.62413386993002, -4.772823958359572],
            [13.625031600410862, -4.768442348098446],
            [13.629663359829882, -4.761583678954468],
            [13.635223919760486, -4.754725658780203],
            [13.643107199622316, -4.748326646006106],
            [13.649146920027137, -4.749703512516343],
            [13.658911200228697, -4.756572718756954],
            [13.668212880398299, -4.764356394285483],
            [13.677510599895763, -4.769852759592139],
            [13.68494567971964, -4.772602811275156],
            [13.690052279614667, -4.771691516254981],
            [13.692352319779939, -4.75934168298852],
            [13.692332880237183, -4.7483622083147],
            [13.689532079606685, -4.740125554948304],
            [13.685343479778608, -4.735090009532858],
            [13.678363080439148, -4.726850143394123],
            [13.680671759702506, -4.719531959898288],
            [13.689030240264779, -4.719080408424467],
            [13.701110040400561, -4.722291734776615],
            [13.709937599644663, -4.724585581075736],
            [13.716904320337287, -4.725048085475305],
            [13.722468840041662, -4.720477092262156],
            [13.727555279945063, -4.708128127711435],
            [13.730327639913689, -4.700352612461838],
            [13.731713639785751, -4.69623589576675],
            [13.732161839823739, -4.687085951411308],
            [13.723323840359404, -4.678844070765393],
            [13.709843280133084, -4.671513881921038],
            [13.702869360341788, -4.666933551431275],
            [13.705642800085359, -4.659615090907931],
            [13.716308159687173, -4.65092937135439],
            [13.718149559594226, -4.64177972596423],
            [13.721380199596602, -4.630343354263564],
            [13.730150880211852, -4.600607802248497],
            [13.733361720447036, -4.57818840442495],
            [13.733336520008359, -4.564002821090845],
            [13.733308080244786, -4.54798659208609],
            [13.731434279902057, -4.538833092660908],
            [13.729981679833154, -4.505425209615017],
            [13.73087339968645, -4.484374092939364],
            [13.730381999666447, -4.469271006450757],
            [13.735934279825104, -4.457833474428542],
            [13.748459400000046, -4.450062029894982],
            [13.760984880399423, -4.442748341098184],
            [13.772118960255224, -4.43634882586857],
            [13.778150399989768, -4.433149315861051],
            [13.793937119705053, -4.431787822471985],
            [13.810193280123162, -4.433172495807715],
            [13.818558959784141, -4.436840088934469],
            [13.828316760437572, -4.440050902567195],
            [13.83471252002043, -4.446384620823096],
            [13.835590200104157, -4.448621866726667],
            [13.835724839598923, -4.451554119949025],
            [13.835859840216456, -4.454486360431658],
            [13.835994479711255, -4.457418589969952],
            [13.836129480328788, -4.460350986170226],
            [13.838650199728422, -4.46010374561493],
            [13.840235279742169, -4.457447338311552],
            [13.84182035975595, -4.454790922181194],
            [13.843889639792698, -4.455237072938247],
            [13.844660040370256, -4.457697994121569],
            [13.845423240052481, -4.460167891341494],
            [13.846186439734739, -4.462637781047423],
            [13.846949640315295, -4.465107840847636],
            [13.858573680191684, -4.480347389314676],
            [13.866020280010737, -4.489505768102012],
            [13.870419530281383, -4.495497440028551],
            [13.872071879736877, -4.497747886771236],
            [13.881834000388514, -4.503246533312824],
            [13.890201120048875, -4.507829005154232],
            [13.900422599610913, -4.510582247836121],
            [13.913898120288481, -4.51516826627291],
            [13.924116359627288, -4.516090856108996],
            [13.943620800265007, -4.516104870302951],
            [13.954294799863241, -4.511993899996551],
            [13.96542311972142, -4.502391661564446],
            [13.9732981198113, -4.49141389962791],
            [13.97699855984264, -4.483178715416029],
            [13.985799480445278, -4.470370818624308],
            [13.993676279860679, -4.46030786292846],
            [14.000623560112217, -4.449786396030185],
            [14.009891039622291, -4.438351251954659],
            [14.016846240319705, -4.432406307521218],
            [14.029374960043983, -4.426923116210929],
            [14.041907280215927, -4.42327074702938],
            [14.053511160100722, -4.420075133421135],
            [14.067902520396956, -4.417339516495368],
            [14.082293879794891, -4.414603709015242],
            [14.101334639727378, -4.415075041304079],
            [14.114802960407911, -4.415542420458437],
            [14.128270200415203, -4.415552303437918],
            [14.14405404013166, -4.412359710929447],
            [14.155657199567584, -4.408706549545821],
            [14.171432760410392, -4.400936919082207],
            [14.184894599746166, -4.397742825714789],
            [14.199278399820992, -4.390887561679204],
            [14.206700519650242, -4.386315673359929],
            [14.217370200148563, -4.379915485046385],
            [14.230825559936207, -4.373059337498496],
            [14.238712080021267, -4.368487877992735],
            [14.251701959778124, -4.361173555663669],
            [14.262834599634544, -4.353857903268872],
            [14.277212639711747, -4.343798022129907],
            [14.286024720085162, -4.337396029333957],
            [14.301336960447138, -4.330083198297414],
            [14.313832560185231, -4.31740148828027],
            [14.320583280069476, -4.314119153937702],
            [14.33428596042787, -4.317289885346902],
            [14.343564959933154, -4.312261242458805],
            [14.350985999987424, -4.307231308764487],
            [14.357944079785334, -4.302658725903098],
            [14.370016319699682, -4.301751862530122],
            [14.381699759775909, -4.298126193567878],
            [14.386783319680548, -4.299341281696934],
            [14.401134720217993, -4.304063050818225],
            [14.408571600265686, -4.30773056531972],
            [14.412763440317027, -4.31460007468092],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Inongo",
        AREA: 127465,
        POPULATION: 1852000,
        DISTRICTS: ["Mushie", "Oshwe", "Kiri", "Inongo", "Kutu"],
        OBJECTID: 16,
        NOM: "Maï-Ndombe",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [19.154727720231747, -0.822036874426257],
            [19.169914320421444, -0.850655657279912],
            [19.182877559740248, -0.874438220198605],
            [19.190294279796344, -0.892678041625038],
            [19.195118250838373, -0.915086810497127],
            [19.19737691999152, -0.928505587757877],
            [19.198880999814453, -0.942703401407787],
            [19.200772440374422, -0.965875166988882],
            [19.201558680047064, -0.990182975310092],
            [19.204203599619564, -1.021201441679688],
            [19.206825119875536, -1.040622429622167],
            [19.211637959892865, -1.048418758399526],
            [19.216811520209173, -1.052095265211582],
            [19.240059599961953, -1.051805498659651],
            [19.271797560446906, -1.052906179558915],
            [19.281029400196402, -1.056158123736703],
            [19.288419479814408, -1.060929352301105],
            [19.294706159667282, -1.067584769410984],
            [19.300998600416037, -1.077233142734589],
            [19.302882836487413, -1.082486323305067],
            [19.304338320148435, -1.086544148953462],
            [19.311384600134158, -1.104039102661867],
            [19.3202960395679, -1.131611381634542],
            [19.327359959770899, -1.158084015368973],
            [19.337010119795391, -1.186020662115281],
            [19.350349560080449, -1.213536812936661],
            [19.360739160246204, -1.24221184928633],
            [19.377437040255842, -1.288389531335183],
            [19.38196733676013, -1.305905508457884],
            [19.391849351959475, -1.344112126879164],
            [19.415656439838809, -1.394148282526591],
            [19.427153400441838, -1.422807337955976],
            [19.43336735987581, -1.424721184275884],
            [19.433271240140417, -1.431476027707577],
            [19.434365639684767, -1.436596471270802],
            [19.437706079866004, -1.442746428758114],
            [19.441847519938296, -1.44828413325633],
            [19.44557387995885, -1.453206885164148],
            [19.4481032402532, -1.459354635344704],
            [19.451466360200421, -1.466937455730127],
            [19.454838839694567, -1.475134280767058],
            [19.45713995963478, -1.479643836555609],
            [19.459901159832601, -1.487634496416463],
            [19.462871520167933, -1.496035018332887],
            [19.463782679563984, -1.50238317851408],
            [19.465723440327992, -1.509757391380384],
            [19.468279079937663, -1.517542907233155],
            [19.470667320290751, -1.527579427803256],
            [19.475555759827476, -1.541921375428852],
            [19.480543560221125, -1.549713259450977],
            [19.484479080379163, -1.55504583978033],
            [19.490496480344138, -1.563863899730944],
            [19.494680039725168, -1.572062874255963],
            [19.495394999876659, -1.578819959229609],
            [19.494585359989156, -1.585935007844022],
            [19.490385240165864, -1.600392936545572],
            [19.491108920263816, -1.603930039443033],
            [19.49193935974338, -1.607988942621587],
            [19.491329160222033, -1.612411915461083],
            [19.488355200337363, -1.633946880054906],
            [19.48894683078348, -1.642802644672847],
            [19.488985199625905, -1.643376956630701],
            [19.492811279829521, -1.653058848214283],
            [19.509868476071336, -1.667194049911042],
            [19.513263240072746, -1.672963857958158],
            [19.515712319726788, -1.683785984665343],
            [19.515184200171227, -1.695738877872545],
            [19.517450015422483, -1.701997360723453],
            [19.52035740026313, -1.710027916162275],
            [19.517782331890469, -1.719898947427927],
            [19.517830153704619, -1.720446615784714],
            [19.518425286682053, -1.72726007311786],
            [19.519047360134834, -1.738070984247348],
            [19.517849279735355, -1.747260949010813],
            [19.510244279982238, -1.757329991938917],
            [19.506752279639514, -1.768113982963705],
            [19.504331618189479, -1.771716870677082],
            [19.502599467794031, -1.774295103444999],
            [19.527181199892347, -1.792158944735168],
            [19.53127619975939, -1.795404967992527],
            [19.543365360340463, -1.800080966738909],
            [19.581991469473348, -1.801476006944371],
            [19.601283239357464, -1.80201859269254],
            [19.602869038921785, -1.799771119257773],
            [19.607447159036852, -1.794461010875801],
            [19.61531063913149, -1.791820813097671],
            [19.62093131881247, -1.788355727598866],
            [19.628932319299036, -1.781621714984737],
            [19.634340599517635, -1.777542132192521],
            [19.638310678762977, -1.772230337059186],
            [19.64104163897337, -1.765482573871402],
            [19.644368039385036, -1.757917454205485],
            [19.644689159251332, -1.752596055737558],
            [19.645599238872407, -1.746048005769897],
            [19.646499239396015, -1.738885981628725],
            [19.646817479263515, -1.733359876983941],
            [19.646733238849404, -1.728037506941034],
            [19.64802275876167, -1.719852873663164],
            [19.649116079429373, -1.712077151093257],
            [19.650634199021841, -1.705530761066055],
            [19.652553358896544, -1.696609021116654],
            [19.660399429640965, -1.683550795990055],
            [19.665209879241349, -1.681739961913781],
            [19.679690159275975, -1.667350005700435],
            [19.679481367447767, -1.66435796040678],
            [19.681131103704104, -1.663970150826785],
            [19.685203199226386, -1.663012910318082],
            [19.689575301510818, -1.658212007338585],
            [19.69402757394278, -1.649339248369127],
            [19.712232358976919, -1.613058875811946],
            [19.714725120109957, -1.610935884592429],
            [19.718664478769224, -1.607580875818376],
            [19.727367479412653, -1.604185898778748],
            [19.72973627662973, -1.589715942926612],
            [19.729330199493774, -1.580745918391943],
            [19.732236119182186, -1.578423056663416],
            [19.735495559172541, -1.579455219598458],
            [19.7381469591915, -1.580485760200595],
            [19.743658559142499, -1.582956715204219],
            [19.749183479312528, -1.586246511772946],
            [19.753286039401011, -1.589327853024499],
            [19.759254838712483, -1.595075247220642],
            [19.767238198981811, -1.600009189750353],
            [19.771990919248758, -1.605753490879929],
            [19.776534479378224, -1.611087727069787],
            [19.782310318770005, -1.617448688550585],
            [19.78808291883692, -1.623604966597821],
            [19.794277438728137, -1.630785795860567],
            [19.800654839441545, -1.636738993453483],
            [19.807003439268613, -1.640849867415539],
            [19.812086999173218, -1.641886862703335],
            [19.817579518907603, -1.64312959894896],
            [19.824323759243683, -1.646627199403459],
            [19.82946239934995, -1.651144309027241],
            [19.835434799109059, -1.657096363931373],
            [19.839588838951538, -1.663453033600589],
            [19.842530399298862, -1.670011277343608],
            [19.843872838964501, -1.677998133009379],
            [19.847435039053412, -1.685376753638139],
            [19.850186878805975, -1.692753183638515],
            [19.852310878819914, -1.698899856518955],
            [19.855072079017766, -1.706890555769502],
            [19.858931279207567, -1.720206150727143],
            [19.863430558681742, -1.735570681843415],
            [19.867727159363156, -1.750934544985471],
            [19.869896518909105, -1.759947001238176],
            [19.873546558961426, -1.772852924017554],
            [19.880575558954355, -1.794364994679439],
            [19.885306679230293, -1.811572304764792],
            [19.890404278904501, -1.826324126951249],
            [19.897462439109876, -1.849678734970564],
            [19.898363878734564, -1.855412723246761],
            [19.899545758916226, -1.866060299586309],
            [19.901380496018806, -1.879090110204922],
            [19.902245789233088, -1.879986770066096],
            [19.913656319329384, -1.891810885914516],
            [19.927641238671935, -1.8972489547892],
            [19.933042319791831, -1.895011510822058],
            [19.943174160064935, -1.894833718118369],
            [19.950065999890406, -1.894851912084364],
            [19.957978079740247, -1.8952822518836],
            [19.969538400316885, -1.895722319904543],
            [19.981333800121931, -1.898209787816615],
            [19.995343200352647, -1.89967985926743],
            [20.013618600154622, -1.901775171627659],
            [20.022138719975857, -1.902207131213003],
            [20.034136800370252, -1.904695310942487],
            [20.042258040357574, -1.905535631377787],
            [20.051800919977602, -1.906584364841771],
            [20.063184840178543, -1.908661474876794],
            [20.07476136007471, -1.910125052095762],
            [20.086534440338202, -1.911179727408416],
            [20.095469279986766, -1.912226836763804],
            [20.104404479859802, -1.913273944567909],
            [20.111505479822757, -1.913702118580025],
            [20.121473520388612, -1.915980247664631],
            [20.130398999591957, -1.916413284645393],
            [20.135466360177073, -1.916426614726564],
            [20.143571399946573, -1.916243421006473],
            [20.15354880005939, -1.919135614398368],
            [20.161319399743565, -1.924515954326906],
            [20.165840298971649, -1.934660790725814],
            [20.167850035078125, -1.936703932161518],
            [20.176075440112545, -1.945065885549177],
            [20.18492136002272, -1.958452997667694],
            [20.189478240371216, -1.961698887938352],
            [20.19539996436853, -1.964014946809068],
            [20.199457439809549, -1.965601873705345],
            [20.208566572386193, -1.969164270595811],
            [20.223478439914246, -1.974995983494017],
            [20.227443909005551, -1.979103584868569],
            [20.235532320060813, -1.987481872346526],
            [20.24187623966527, -1.999245013160837],
            [20.241084387318725, -2.000984328983511],
            [20.238638399665891, -2.00635696456633],
            [20.239496279982426, -2.017628959092345],
            [20.24029080391864, -2.019323517861103],
            [20.241983159845333, -2.022932965223849],
            [20.245738821113815, -2.027066969527366],
            [20.247442200267358, -2.028941941989307],
            [20.255422339178057, -2.033125936673701],
            [20.257111972311115, -2.033630354962768],
            [20.267980200250175, -2.036874922483862],
            [20.276309112764888, -2.038410632475255],
            [20.28204323978478, -2.039467907725171],
            [20.288542319998363, -2.040666954118683],
            [20.293378413805158, -2.043131412872321],
            [20.298122230869343, -2.045548842932412],
            [20.307939480231621, -2.048591951674593],
            [20.315692983179304, -2.052773812229976],
            [20.326151159835547, -2.065018917256316],
            [20.342266573113257, -2.076873833563816],
            [20.347568279901509, -2.080773887101382],
            [20.352502180479782, -2.082728410951044],
            [20.358751319736918, -2.085203952482096],
            [20.385181439736868, -2.105124864419373],
            [20.39700743975374, -2.118527022424257],
            [20.397663359929794, -2.119545899306012],
            [20.405364120092194, -2.115904631631998],
            [20.408970960162534, -2.113253057997055],
            [20.414218319774388, -2.111834153243013],
            [20.418426720267956, -2.108774802960859],
            [20.42221320003889, -2.104690797288145],
            [20.427602039816403, -2.099382744522746],
            [20.433029759577732, -2.096531398769773],
            [20.441308319724168, -2.094506222126443],
            [20.448997920115797, -2.09370778497924],
            [20.458891440038972, -2.091277531739618],
            [20.465368199812673, -2.090680639424783],
            [20.470821839563214, -2.089466862027463],
            [20.475444959884115, -2.087022733009476],
            [20.480258160125878, -2.083760166632433],
            [20.484051479669414, -2.080085673371914],
            [20.489475599881402, -2.077029502077228],
            [20.49530543969987, -2.073974406603051],
            [20.501376840091531, -2.07337642673814],
            [20.507428800042103, -2.071550065713639],
            [20.513641320374994, -2.067063224481451],
            [20.517843240422099, -2.063594383934042],
            [20.521436760273406, -2.060123914342058],
            [20.524801680444448, -2.055015278743527],
            [20.528552879780911, -2.04867948854968],
            [20.533906079797848, -2.041119770951033],
            [20.537859959723662, -2.034784645481218],
            [20.543277959713627, -2.031318975982461],
            [20.549542320024916, -2.03010731370983],
            [20.55883428042312, -2.028084933593401],
            [20.566121759859307, -2.027490178264873],
            [20.57360544033665, -2.026486551644461],
            [20.583511920254416, -2.024875019654801],
            [20.594013840373457, -2.02244646136245],
            [20.606941439931646, -2.019614789189038],
            [20.613601439853646, -2.017790167411782],
            [20.618639640226316, -2.015961220673802],
            [20.625498008824302, -2.013234146925091],
            [20.626661520255013, -2.00909986024338],
            [20.629881359812721, -2.004976869600019],
            [20.637909360063478, -1.999727921440563],
            [20.641592159877579, -1.994227864893998],
            [20.646492479633917, -1.973094938219408],
            [20.648932577931749, -1.968091558951291],
            [20.650184418009395, -1.965524864656732],
            [20.652242646971548, -1.964116357558907],
            [20.657524108428216, -1.96050208872294],
            [20.66864615984235, -1.978494916140485],
            [20.683199160295871, -1.996045848596925],
            [20.685953946522577, -2.002459011059367],
            [20.686367159875179, -2.003420973521137],
            [20.69466996375445, -2.011457604835168],
            [20.710726199614534, -2.026998992318978],
            [20.716860240429263, -2.035997925596549],
            [20.722280399969151, -2.050974000251781],
            [20.729910239936501, -2.062100865906579],
            [20.731140359648926, -2.063895897747569],
            [20.739525479750959, -2.080725976700407],
            [20.758651199648067, -2.099217943103511],
            [20.767513319776096, -2.111910879555392],
            [20.774120399944689, -2.117692936934952],
            [20.780281439625281, -2.120713005433548],
            [20.782561784227926, -2.12302785327751],
            [20.785972319950776, -2.126489985740399],
            [20.797559280067173, -2.14379486063658],
            [20.799504517136249, -2.145966475974864],
            [20.809908360090851, -2.157581020568451],
            [20.811214440445376, -2.159040947502049],
            [20.824209359750984, -2.16830296197227],
            [20.83194936012163, -2.176619923332677],
            [20.843540280011798, -2.19323497723664],
            [20.845999029131566, -2.194989855812011],
            [20.851976160317285, -2.199255893392056],
            [20.855985241717306, -2.201069944059015],
            [20.860195320263852, -2.202974940972224],
            [20.878023239578418, -2.205358909624307],
            [20.88742834099002, -2.213483655460549],
            [20.88873308285477, -2.214610774256573],
            [20.891509789771014, -2.219988296273979],
            [20.900205360448719, -2.236829012790836],
            [20.905519320257447, -2.247119952636603],
            [20.92099427965336, -2.265592925010755],
            [20.927807279736239, -2.276894863129191],
            [20.928845949596958, -2.2838212073295],
            [20.92980924002557, -2.290244854104165],
            [20.934783672589479, -2.298137892539961],
            [20.937078359693981, -2.301778906370178],
            [20.939795521781619, -2.30524302835587],
            [20.954824199941015, -2.324403002805645],
            [20.957049675446111, -2.337400285142204],
            [20.957504399947982, -2.340055967206814],
            [20.958747979118289, -2.342585075522729],
            [20.959989479587041, -2.345109949450029],
            [20.960329681466618, -2.345801629445696],
            [20.960905320104036, -2.346971986232465],
            [20.968145088218815, -2.354666407625927],
            [20.970470520163911, -2.357137866946889],
            [20.974895836849132, -2.360941675411854],
            [20.986881480068412, -2.37124395539739],
            [21.01176436248425, -2.38377902691403],
            [21.014975159600308, -2.392225350103206],
            [21.017674800048365, -2.39632654776026],
            [21.019348439576099, -2.399606235545593],
            [21.022250759715146, -2.403707950209837],
            [21.02314247956847, -2.408827782890821],
            [21.023210519764696, -2.413126648133532],
            [21.02327208041282, -2.417016017961098],
            [21.022715520195391, -2.42028989332177],
            [21.021989040048719, -2.425610080567467],
            [21.020104440159649, -2.434611945059372],
            [21.020159160136846, -2.438091956006658],
            [21.020027759966979, -2.442595104327964],
            [21.019906079568507, -2.447712266983532],
            [21.019754879631453, -2.450986967612969],
            [21.019829400274165, -2.455695347267298],
            [21.019779000295145, -2.465316070306647],
            [21.01866624008472, -2.4718635742379],
            [21.017939399713612, -2.477183915362675],
            [21.017830680208032, -2.483119867900719],
            [21.017097360288762, -2.488030701729272],
            [21.016336328241298, -2.49444189528112],
            [20.998298853530528, -2.492904179798402],
            [20.962133248825477, -2.489821043708165],
            [20.957437080200602, -2.51497828758471],
            [20.957387399772124, -2.534423507528951],
            [20.949886440200245, -2.558095337887873],
            [20.938134959927762, -2.581254307286938],
            [20.923189560086787, -2.606524418367147],
            [20.905588080004211, -2.631276755637908],
            [20.893325399944597, -2.646553532410957],
            [20.874646079861627, -2.677088688998979],
            [20.868229439838302, -2.692347067069314],
            [20.864483999601099, -2.702342421747704],
            [20.863930679606899, -2.710751452767596],
            [20.864966759624686, -2.721257392706399],
            [20.865990600096723, -2.736492524779861],
            [20.865428279881701, -2.748579566876863],
            [20.855310480276497, -2.756492127630764],
            [20.839868279744035, -2.768098849411889],
            [20.828152079906022, -2.777592570255504],
            [20.816960400074201, -2.789711591802941],
            [20.806826040026742, -2.803928926586989],
            [20.800402920455255, -2.82181276781771],
            [20.796379134532344, -2.8300559921412],
            [20.78704656040183, -2.849174699716869],
            [20.775824999908686, -2.872851648011822],
            [20.765131199645001, -2.898102743178088],
            [20.753903159603727, -2.92440552583039],
            [20.745877680025696, -2.945444349538298],
            [20.735708399768196, -2.973318919877222],
            [20.726610479962925, -2.998037301241863],
            [20.71803420016505, -3.026430839973622],
            [20.709470520137362, -3.050096044899266],
            [20.700365400335087, -3.077439147603525],
            [20.694473639644059, -3.095316910878076],
            [20.690192519629921, -3.106886057918104],
            [20.687505479850387, -3.118450216457216],
            [20.684173325729311, -3.136553816103543],
            [20.682971627814183, -3.137588116020528],
            [20.675668320062709, -3.143873887828689],
            [20.672754426927856, -3.149304275894408],
            [20.671974359579533, -3.150758019088025],
            [20.667309480174328, -3.169140911108452],
            [20.665517911612699, -3.183853257939816],
            [20.665405439844172, -3.184776869315551],
            [20.658195360151201, -3.20935997716908],
            [20.655828366751194, -3.226143940889223],
            [20.656944359998342, -3.232361863677665],
            [20.658544200230562, -3.233060943546866],
            [20.657842200073659, -3.236047997505121],
            [20.638799217709188, -3.293704058077769],
            [20.627475119916291, -3.316378014614981],
            [20.625322319914304, -3.326887736875275],
            [20.625275520382949, -3.345268278713634],
            [20.626284599738213, -3.366270971705398],
            [20.62781712022305, -3.39042225007972],
            [20.628834120024191, -3.408273358663602],
            [20.625590184955602, -3.426170216947274],
            [20.626651020746007, -3.434972464764742],
            [20.627420760163499, -3.441359296102511],
            [20.62792187995483, -3.453172297983293],
            [20.628951120200053, -3.466296261807166],
            [20.631023999786134, -3.487030565056529],
            [20.63096676003455, -3.509346012455199],
            [20.630640599721207, -3.532974273888581],
            [20.630567880200637, -3.561326339881906],
            [20.632603680026762, -3.596496399946715],
            [20.634645960299316, -3.629040098631607],
            [20.636146439674583, -3.665783976359888],
            [20.639251799729116, -3.698321896810369],
            [20.640773519769251, -3.726663846824957],
            [20.642787719604371, -3.770225834186219],
            [20.643755039875362, -3.807490295109691],
            [20.644177680148537, -3.850003214292608],
            [20.646728640433892, -3.891457942381684],
            [20.644519320230895, -3.924003432226439],
            [20.644458840256046, -3.947619685330588],
            [20.643459479773849, -3.971134932047415],
            [20.653360559918429, -3.99954535318238],
            [20.657534400426393, -4.029967982475682],
            [20.661713279584816, -4.058290754825619],
            [20.661678360273076, -4.071933479244718],
            [20.660152328319572, -4.07959599491533],
            [20.662129080085421, -4.103414148521001],
            [20.660491799868804, -4.120209125876594],
            [20.659933440325855, -4.130704455633969],
            [20.656434960435028, -4.147766683620693],
            [20.651214836844275, -4.155150420979379],
            [20.648549879451053, -4.158919899288168],
            [20.637290159422975, -4.164389944469284],
            [20.63567020770817, -4.168520679220335],
            [20.635716829373099, -4.169094998877459],
            [20.636529838841213, -4.179110035192684],
            [20.635599959452946, -4.183019911192491],
            [20.627529732095667, -4.193790864214039],
            [20.627464632983639, -4.194352495004204],
            [20.627049958970392, -4.197929997473751],
            [20.631139919288721, -4.202769947730489],
            [20.630753442493933, -4.206642466120705],
            [20.630678523897537, -4.20738044052012],
            [20.613909959949787, -4.213279978515745],
            [20.609977286552887, -4.217308077349522],
            [20.60607996006577, -4.22129995162167],
            [20.596776393434098, -4.221915357807002],
            [20.593230119576869, -4.222149934742201],
            [20.591279702821861, -4.223802932731552],
            [20.588636959867298, -4.226041161283496],
            [20.571465716211947, -4.232346703129695],
            [20.557427940896382, -4.237501550287378],
            [20.535639243492955, -4.245538128607337],
            [20.535580080448316, -4.245559949884678],
            [20.514259869736897, -4.257541642269126],
            [20.506380120254164, -4.261969915231022],
            [20.494963277696364, -4.263912622817553],
            [20.484870119777707, -4.265630085976677],
            [20.483670881449832, -4.266389900683149],
            [20.481540119816703, -4.267739910140905],
            [20.479759920333343, -4.270999981225096],
            [20.477528626440144, -4.282884024947474],
            [20.477179454882485, -4.284741597758225],
            [20.476249920447273, -4.286889996540886],
            [20.475984748555202, -4.287512014862729],
            [20.474629920223457, -4.290690049484501],
            [20.469237745001283, -4.294570097859375],
            [20.460049920005769, -4.295460038683814],
            [20.446580160224119, -4.289180023662871],
            [20.426950080312452, -4.289109931937471],
            [20.416524569993193, -4.284668994084514],
            [20.415730920117756, -4.284330923245189],
            [20.41128567340963, -4.289554185165995],
            [20.408553296556011, -4.292105442877039],
            [20.408119918720235, -4.292510092746859],
            [20.401808450755421, -4.294271197394733],
            [20.398812228821384, -4.297017934442956],
            [20.398148479827626, -4.296921829408893],
            [20.39753015953611, -4.296830050266717],
            [20.387439359695069, -4.297470392929576],
            [20.382839998915134, -4.299760028969502],
            [20.377945958382607, -4.30904333305352],
            [20.377019878867994, -4.310799963127124],
            [20.371669919074286, -4.331209995451538],
            [20.367804477389885, -4.337247708528008],
            [20.36521007906898, -4.341300058373965],
            [20.362880159140719, -4.348189925875191],
            [20.366211504778043, -4.354647896792086],
            [20.372640119344073, -4.367109911402284],
            [20.371294659542457, -4.370731142356078],
            [20.371019248652772, -4.371471072453428],
            [20.368976052996906, -4.373874091985225],
            [20.359720079108993, -4.384760017493292],
            [20.362668401075432, -4.390753526075392],
            [20.362488822460236, -4.391180852785642],
            [20.361508930266865, -4.393510694784847],
            [20.361135301177267, -4.393729784109174],
            [20.352539879179005, -4.39876996838548],
            [20.346421742138055, -4.398503819681754],
            [20.346118650561209, -4.398490910466744],
            [20.343949848869059, -4.398399142956212],
            [20.339933083280098, -4.398227628974884],
            [20.332135723681919, -4.395529289632288],
            [20.327109840110126, -4.393790036817801],
            [20.31338987975893, -4.385199921700172],
            [20.308120793493615, -4.383560280200532],
            [20.306446239480898, -4.383809923490049],
            [20.302160040392138, -4.384450036299119],
            [20.29900340539951, -4.386848238268568],
            [20.295249839900592, -4.389699937627813],
            [20.286647196345768, -4.390240485372938],
            [20.281719960368562, -4.390550089032535],
            [20.27574000038798, -4.393280055817436],
            [20.274806503484072, -4.394079138483721],
            [20.270670120028509, -4.397619913477384],
            [20.268438608743011, -4.398281160262034],
            [20.266080119693829, -4.398980033133499],
            [20.263196695616763, -4.398180453561205],
            [20.260130040374534, -4.397330063012165],
            [20.254219022498795, -4.386949525401239],
            [20.253385669782741, -4.386499628862611],
            [20.250330120412393, -4.384850047349426],
            [20.234060543655502, -4.382000118184084],
            [20.230689974877986, -4.368869894211907],
            [20.234170079729683, -4.361300068208073],
            [20.231250120271696, -4.348849994121944],
            [20.219177018872969, -4.34055741552153],
            [20.216400119717246, -4.338650050531739],
            [20.200600079782962, -4.33487989283413],
            [20.194929684639185, -4.337765856434118],
            [20.184959879782092, -4.342839990802923],
            [20.179697270369982, -4.341430376939204],
            [20.178558968361081, -4.341597471134091],
            [20.178270000097136, -4.341639889871723],
            [20.173506715642421, -4.3423182061059],
            [20.170158868851683, -4.340621572586949],
            [20.169839879789237, -4.340459913868566],
            [20.169328559627829, -4.339875780175699],
            [20.166191235718873, -4.336291682377118],
            [20.165498947248526, -4.330383834790186],
            [20.164439880240945, -4.321330063252763],
            [20.162890480411942, -4.319588258554679],
            [20.160330120155461, -4.316709942095335],
            [20.155769145285895, -4.31417523699573],
            [20.155306262284618, -4.313919321938517],
            [20.145449879613583, -4.312019882305492],
            [20.140880040168827, -4.308770053386089],
            [20.139540450857574, -4.305251556495062],
            [20.137719960137066, -4.300469922346122],
            [20.13274171512311, -4.296353314193047],
            [20.13044004002402, -4.294450005627827],
            [20.126109960030245, -4.292459950926504],
            [20.108859839801383, -4.293179915254926],
            [20.103189600964498, -4.292280011364919],
            [20.101299840254107, -4.29198009366346],
            [20.097426396377159, -4.290009345425856],
            [20.092160159567932, -4.287329958485329],
            [20.081475138539513, -4.289229065502053],
            [20.071630080030953, -4.290980120938094],
            [20.05499987999314, -4.290110086602754],
            [20.038049863544515, -4.285869699358011],
            [20.033529840173799, -4.273650047451656],
            [20.030569920058731, -4.269719965594046],
            [20.029240080163245, -4.261430009715178],
            [20.018070000322432, -4.249170054085832],
            [20.018053050909668, -4.247248084789516],
            [20.017929960156184, -4.233290032779673],
            [20.014959960045285, -4.230739939144632],
            [20.013963399611807, -4.229037827445447],
            [20.009959920105885, -4.222199901729614],
            [20.004699959825547, -4.219640065042108],
            [20.002782465427398, -4.215359893828521],
            [20.001080159760619, -4.211560040853834],
            [20.000529753901201, -4.210979007518789],
            [20.000000160210305, -4.210419943935026],
            [19.997044623873808, -4.207273495046134],
            [19.996290000407573, -4.206470124621668],
            [19.989200160215393, -4.203899989847779],
            [19.98714322842055, -4.20206039157251],
            [19.985319617851051, -4.200428410828501],
            [19.983427296942132, -4.194446409603247],
            [19.982840040393114, -4.192589965292127],
            [19.982596719122011, -4.191800534925697],
            [19.980140039720652, -4.183830032630289],
            [19.977239507229001, -4.181293164951879],
            [19.973520000455768, -4.17803999311039],
            [19.968372501164158, -4.175264177888699],
            [19.965748981258347, -4.173850142788409],
            [19.958410080458709, -4.174500015665036],
            [19.951902257840771, -4.180252338547513],
            [19.949880293866673, -4.182039561479326],
            [19.945754451242621, -4.180694968501867],
            [19.944849960040926, -4.180400088436059],
            [19.941429959668255, -4.17715994309602],
            [19.939363119455823, -4.170831725252544],
            [19.938039866906319, -4.166780182943938],
            [19.933071955213077, -4.16247999551592],
            [19.924130159909218, -4.154740091014929],
            [19.915430040162914, -4.151240093389216],
            [19.90236995976155, -4.150010030201425],
            [19.897112023385539, -4.147008147006163],
            [19.890950039575593, -4.143490106747257],
            [19.886199839981334, -4.131729982953836],
            [19.880049960071513, -4.124329976814145],
            [19.873929959924688, -4.112100023193655],
            [19.856158969544644, -4.092199438075601],
            [19.850669999952292, -4.089629948580392],
            [19.846230782736349, -4.089428266841518],
            [19.845169919996504, -4.089380070143651],
            [19.841695614668268, -4.090469619145003],
            [19.839430079691372, -4.091180094077394],
            [19.833133311757898, -4.09075901447595],
            [19.829109959721254, -4.090489962740454],
            [19.828199880100179, -4.090429919680939],
            [19.825669529862395, -4.092249771517759],
            [19.820859840236754, -4.091299999671143],
            [19.811250000195447, -4.087790012248916],
            [19.804034421016311, -4.080988635814522],
            [19.801670039917163, -4.078759967017376],
            [19.797471207379679, -4.076139675485886],
            [19.784540160087396, -4.068069970725962],
            [19.780200000097825, -4.066190073517554],
            [19.774692440769005, -4.065940125453484],
            [19.769875147802797, -4.066139709554983],
            [19.764360000404725, -4.068640033067545],
            [19.760211822967804, -4.072988010107075],
            [19.758463882884609, -4.072624021843905],
            [19.757921176485482, -4.072510265442086],
            [19.755430895600927, -4.067432128000138],
            [19.734131467413626, -4.063620265218125],
            [19.731581506953169, -4.061637811338074],
            [19.730259502163602, -4.060610023497209],
            [19.71260999994259, -4.060039973444411],
            [19.706209920361523, -4.056090113880994],
            [19.698189839658312, -4.05512003997136],
            [19.688778405123973, -4.058510025845647],
            [19.684154799712804, -4.058362612040614],
            [19.670900040016303, -4.057940012177376],
            [19.664290079848882, -4.051920007580978],
            [19.659759839938477, -4.051169975623616],
            [19.656743025923173, -4.050672019390201],
            [19.633830120179312, -4.046889998606912],
            [19.629772989691375, -4.045092859394765],
            [19.623309840292531, -4.042229944749177],
            [19.615759919842748, -4.040799976094632],
            [19.613108126361695, -4.041063203597783],
            [19.604980079839464, -4.041870026202636],
            [19.596300120084756, -4.036759951644364],
            [19.592409041380456, -4.032703106103805],
            [19.58808996035901, -4.028200000140489],
            [19.583340120090853, -4.017579982069779],
            [19.582896713463246, -4.017219241465243],
            [19.574219879845735, -4.010160035610993],
            [19.571489190028235, -4.006462806423912],
            [19.568525399970905, -4.003683010218539],
            [19.564475482056366, -4.003544076314902],
            [19.560276360261351, -4.003400023683087],
            [19.55656694695864, -4.000932271271863],
            [19.554340319813328, -3.999450964324275],
            [19.550328900996963, -3.999275877419889],
            [19.548153360143552, -3.999180921085526],
            [19.545418440159356, -3.996401913568455],
            [19.53902848099829, -3.993236513468865],
            [19.537420319671622, -3.992439875163507],
            [19.534696288166977, -3.987820107416835],
            [19.533732758786499, -3.987499031031581],
            [19.525544102033709, -3.984771344882344],
            [19.514134989478968, -3.979445508804656],
            [19.501549920233526, -3.973570077889318],
            [19.497459959915197, -3.967099952359328],
            [19.481960383985559, -3.955186933068392],
            [19.477839959999329, -3.952019934572396],
            [19.476731262868906, -3.95162412464565],
            [19.462064622836998, -3.946390090759579],
            [19.458619919692314, -3.94613992516422],
            [19.455400080134606, -3.947730083334708],
            [19.453858764244856, -3.947334163973332],
            [19.451739960086488, -3.946789905357494],
            [19.441959839891542, -3.932460015219327],
            [19.425980160256596, -3.925449968322154],
            [19.421830080187892, -3.922830018901164],
            [19.406900264320463, -3.91341591726738],
            [19.395380576340735, -3.906152382947001],
            [19.388888517359433, -3.899675065215886],
            [19.383080040376704, -3.893880018589132],
            [19.382236099218431, -3.89376537819822],
            [19.381245603311424, -3.893630829553025],
            [19.378617308859873, -3.892839181424555],
            [19.377359999838767, -3.892460039329996],
            [19.372999950250492, -3.893119909915619],
            [19.368889919772116, -3.891250078687336],
            [19.356339960281232, -3.881040059425945],
            [19.356045161951087, -3.880628621579137],
            [19.352700000224708, -3.875959907871295],
            [19.320509879928029, -3.857339911472408],
            [19.313201997955129, -3.857104635722922],
            [19.302189840144653, -3.856750101003667],
            [19.294639919694841, -3.852559916347147],
            [19.29248148995098, -3.850974394013995],
            [19.282319999883608, -3.843510004332362],
            [19.27838420753605, -3.83846271221585],
            [19.275379919629074, -3.834609969258693],
            [19.262900159884403, -3.826660045455931],
            [19.259671957909713, -3.825690682071704],
            [19.25449434259821, -3.824855722985437],
            [19.24440983994732, -3.823230021923311],
            [19.231644829167323, -3.813538386855267],
            [19.230040359916458, -3.812320209454162],
            [19.229322529647639, -3.812079903224968],
            [19.219520159979748, -3.808800001625307],
            [19.218757947545999, -3.808282195117086],
            [19.217430000400832, -3.807380058111827],
            [19.20194999965954, -3.796939914308865],
            [19.178610120169573, -3.791950071659392],
            [19.164575097292012, -3.78444959773653],
            [19.159429493445678, -3.781699248288927],
            [19.156249120471649, -3.777301770813581],
            [19.155111479622818, -3.775683920777702],
            [19.148195660169158, -3.77413367053819],
            [19.146644280453256, -3.773785913205757],
            [19.141435287887198, -3.771008158357996],
            [19.13134427963703, -3.765626987092895],
            [19.120799879984851, -3.765550015850288],
            [19.10474999970543, -3.767050056410454],
            [19.098704884018971, -3.766433504924569],
            [19.095140159664123, -3.76606993188336],
            [19.092852618657734, -3.764742606528424],
            [19.083489839574113, -3.759309916046272],
            [19.073921899652625, -3.75644374231406],
            [19.06543008035608, -3.753899923706009],
            [19.063163915660187, -3.752359097691969],
            [19.05789995967346, -3.748779983008478],
            [19.053585312736285, -3.743344961122494],
            [19.048349880056463, -3.736750010395842],
            [19.043827800442092, -3.733411490611156],
            [19.041739919889075, -3.731870064054958],
            [19.024483735133714, -3.726839534907357],
            [19.019099531561384, -3.725269773810779],
            [19.018793857328081, -3.725049544010304],
            [19.01445012024703, -3.72191998984863],
            [19.000000080199801, -3.711500031076297],
            [19.000000080199801, -3.712488400811276],
            [18.995432839581149, -3.711617957477024],
            [18.988319880346801, -3.710259958300672],
            [18.975874362584122, -3.699539751737262],
            [18.968748684103677, -3.699175368198993],
            [18.963950040162779, -3.69892998113658],
            [18.96155876889388, -3.698014567273411],
            [18.954521295991199, -3.695320511242504],
            [18.950470901969563, -3.692974372196769],
            [18.947459880291241, -3.69123005972423],
            [18.936810000458411, -3.685079894429475],
            [18.933083869508248, -3.680919613684891],
            [18.931489920427659, -3.679139938816518],
            [18.917419188619277, -3.675474930739576],
            [18.907380645574953, -3.672860178381599],
            [18.903925772602928, -3.670355476892488],
            [18.883919879797183, -3.660830071321878],
            [18.868564734100605, -3.659100497963167],
            [18.862855917113833, -3.65967604899388],
            [18.861230999512173, -3.659838609202817],
            [18.859474447280306, -3.658796725016141],
            [18.856277943258764, -3.65689740664381],
            [18.847429920392482, -3.651640011244429],
            [18.838000142260011, -3.651111472118477],
            [18.832979880345249, -3.650830086792631],
            [18.828380160239178, -3.648329983441576],
            [18.816843650407435, -3.647547888565044],
            [18.815995481777421, -3.647490387653601],
            [18.810433074910616, -3.645588536949764],
            [18.805439880133665, -3.643879961568647],
            [18.799449840157319, -3.64000998386949],
            [18.798996822454466, -3.640058779551411],
            [18.792579959648965, -3.640749950342016],
            [18.786831167632055, -3.638260558618368],
            [18.785697703050928, -3.638426290607218],
            [18.785400119943414, -3.638469974490077],
            [18.784828829151948, -3.638557107593619],
            [18.783630000455815, -3.638739952246434],
            [18.781473914416548, -3.63600872432565],
            [18.779470329074833, -3.633470669501833],
            [18.77093866769879, -3.625479553910355],
            [18.765880984664239, -3.623900361940194],
            [18.763001678464438, -3.623843051741043],
            [18.748699919727922, -3.623560052174579],
            [18.746241457170733, -3.623881535018068],
            [18.745030079908414, -3.624039941984811],
            [18.743253649755971, -3.623509380116205],
            [18.736760159758393, -3.621569981274971],
            [18.733538463382985, -3.619554170877039],
            [18.726180120345632, -3.614950049868563],
            [18.721398560564797, -3.615870349421268],
            [18.721141568731699, -3.615919812502348],
            [18.715230000188672, -3.623319927567729],
            [18.713800054732872, -3.623428354817333],
            [18.711799919820177, -3.623580018105574],
            [18.699084531976474, -3.618036346768357],
            [18.684226044139244, -3.611558958645053],
            [18.675020337279676, -3.609109558807178],
            [18.674120159787972, -3.608870044057364],
            [18.667898028379842, -3.601435349869913],
            [18.666269233649409, -3.599489642170028],
            [18.663665226049886, -3.5981310196789],
            [18.65798999976651, -3.595170005369174],
            [18.656958541580888, -3.595260988523713],
            [18.646539839593164, -3.596180000453447],
            [18.642198927713689, -3.598038906805714],
            [18.635060303611702, -3.59167233083532],
            [18.63297647985048, -3.589813866232405],
            [18.629979840199859, -3.587529982471948],
            [18.622413568615279, -3.586975367076789],
            [18.618519960255117, -3.586689961353547],
            [18.615499920389638, -3.580729923199011],
            [18.60397991979622, -3.570910002846678],
            [18.597712242006551, -3.569570424438698],
            [18.587229839583713, -3.567330036981832],
            [18.58127383048528, -3.568519710724106],
            [18.565340040388328, -3.583350013692551],
            [18.559159919592787, -3.584079953312925],
            [18.552509999666579, -3.583439951952628],
            [18.552056092631602, -3.58223018475792],
            [18.549880561659691, -3.576431863978803],
            [18.547340039797941, -3.577359913706806],
            [18.541980000008405, -3.58535006244181],
            [18.540194541787365, -3.585579429480418],
            [18.534429424686806, -3.586319518556546],
            [18.532615584194339, -3.585108883332679],
            [18.525830040219816, -3.580579905300088],
            [18.52453008008732, -3.579710017614769],
            [18.51099984033085, -3.577730102942176],
            [18.507571676967192, -3.576165155582107],
            [18.502040159569717, -3.573640027161553],
            [18.493844621721856, -3.574081676638924],
            [18.487379879610025, -3.574430055306225],
            [18.481447775579614, -3.577918973008563],
            [18.469029960063661, -3.571779898992361],
            [18.462838972348131, -3.570901132190297],
            [18.455063497506909, -3.56482102055656],
            [18.454089959995837, -3.564059990797503],
            [18.447892752345275, -3.563640153120387],
            [18.441280637119519, -3.568279592186976],
            [18.438002027979298, -3.566550786846434],
            [18.437831819690828, -3.566461000349042],
            [18.437808736581278, -3.562699770680503],
            [18.437788111262353, -3.559338921438533],
            [18.425139840146795, -3.552280065915472],
            [18.419691905596618, -3.54644545736189],
            [18.419368511196037, -3.546099107875869],
            [18.418998030701498, -3.545731903334867],
            [18.412910863079983, -3.539697900023155],
            [18.412065018391626, -3.539439837894299],
            [18.410659920336602, -3.539009997749809],
            [18.407204226304401, -3.5379624900838],
            [18.403269839820268, -3.536769878097899],
            [18.401901713727383, -3.538158338462215],
            [18.403769879836652, -3.544819925775761],
            [18.403349181721104, -3.544907330599738],
            [18.395778354779708, -3.546479231389594],
            [18.393479999853927, -3.545570044561426],
            [18.392973507238853, -3.544336030458739],
            [18.392541857761689, -3.543279076687407],
            [18.393105947657823, -3.543013201607195],
            [18.395510039682428, -3.541880068875916],
            [18.397504337342419, -3.539177011655422],
            [18.398239920117877, -3.538180005016359],
            [18.397770120088914, -3.536570025381128],
            [18.395709840272986, -3.536350024238031],
            [18.39280108729816, -3.538046794152029],
            [18.390909960250248, -3.539149948349923],
            [18.363129840363211, -3.530579976569121],
            [18.360438531789434, -3.527015927333172],
            [18.356900040037527, -3.522329947871421],
            [18.355446235327779, -3.517069441936646],
            [18.355250169932187, -3.516359989211781],
            [18.34700003966789, -3.514110065675798],
            [18.341849858006846, -3.498959909146014],
            [18.333576359867049, -3.495095978828469],
            [18.32185008003324, -3.488959945746705],
            [18.316909355852051, -3.487335291083724],
            [18.312210000004544, -3.485790002993494],
            [18.310619743898123, -3.484218570848638],
            [18.309669840163856, -3.483279909716424],
            [18.30913136932131, -3.482035071171965],
            [18.305499960327992, -3.47363992378983],
            [18.301622129079156, -3.470212576699153],
            [18.301110119909943, -3.469760046815531],
            [18.294404393045021, -3.468279164519002],
            [18.294000119726135, -3.468189885670974],
            [18.284589660762176, -3.460935500971377],
            [18.281560618879247, -3.458600443860782],
            [18.273080159677765, -3.457269924945037],
            [18.27417216161863, -3.45211372167643],
            [18.275519879784884, -3.44575003767679],
            [18.271073455385398, -3.434994347673472],
            [18.268309497359656, -3.42830951113629],
            [18.262779840373135, -3.424200017936199],
            [18.26184465014493, -3.423864814031155],
            [18.252680535283009, -3.420580081014663],
            [18.250850160399434, -3.418129906648622],
            [18.248749919926418, -3.415310008100881],
            [18.246186618585671, -3.403947548538041],
            [18.246158890287798, -3.403828331921276],
            [18.244828423368272, -3.4020657859057],
            [18.243387561585138, -3.400159203684831],
            [18.241549639954883, -3.399480064449345],
            [18.238691810676887, -3.400216019548828],
            [18.226910159587288, -3.403250052713832],
            [18.218973305100192, -3.403880416239258],
            [18.214319880113177, -3.404250002216608],
            [18.212189262210519, -3.40366351453357],
            [18.208580039808083, -3.402670016395635],
            [18.205202616884911, -3.404220953451301],
            [18.201959458859044, -3.405708457085368],
            [18.194000039590364, -3.414040025544777],
            [18.190245914441022, -3.415950423763882],
            [18.186689880388226, -3.417760012828285],
            [18.178908770415241, -3.418500693133079],
            [18.173660039974287, -3.421760104414217],
            [18.171983776467592, -3.424388165599664],
            [18.171159839892351, -3.425679938853246],
            [18.16916004005127, -3.435589917185093],
            [18.166786172742707, -3.440063087617612],
            [18.166219919703362, -3.441130097155353],
            [18.156638981159706, -3.44716981589374],
            [18.151130159697896, -3.446040042206729],
            [18.142848462634493, -3.439010321777881],
            [18.138229920128268, -3.435089959576144],
            [18.123008846191226, -3.417823897893915],
            [18.113370119923687, -3.406890021938203],
            [18.109159920104567, -3.402120025194856],
            [18.101706299951562, -3.403418229317619],
            [18.094060080103304, -3.404749977024864],
            [18.085119457999255, -3.403189551991874],
            [18.06805007970387, -3.384879974558783],
            [18.043490159598978, -3.377430011928603],
            [18.037383573095973, -3.37791820058853],
            [18.034109999911216, -3.378179904845053],
            [18.013089960353682, -3.387049931297062],
            [18.005342618052225, -3.386000731207552],
            [18.000020063162868, -3.38527989105536],
            [17.991759815173527, -3.382340156764817],
            [17.971869960447986, -3.38912992512052],
            [17.970487002271462, -3.38959991255495],
            [17.967750120366702, -3.390530018601629],
            [17.958235051689581, -3.399348594152102],
            [17.957499839918324, -3.400029984955731],
            [17.952480000211764, -3.402589955667919],
            [17.940180013118361, -3.40285456544268],
            [17.938049797660938, -3.40290056976834],
            [17.928240120198193, -3.410090096789346],
            [17.926919320947729, -3.410137621892876],
            [17.92046016006876, -3.41037003762463],
            [17.915429880141936, -3.412469950999713],
            [17.905794561184255, -3.41114066236711],
            [17.902594940906983, -3.412537827455305],
            [17.902237412322194, -3.412555411111722],
            [17.880249959967198, -3.41352008604084],
            [17.879264136197996, -3.413566410323686],
            [17.878550040225814, -3.413599966200973],
            [17.869870079572806, -3.41640997399499],
            [17.860049999619076, -3.422679975362777],
            [17.84953007995669, -3.425270109303924],
            [17.848072027114011, -3.425066963818278],
            [17.844720119938156, -3.424599953093879],
            [17.832539880068772, -3.418229935555476],
            [17.826530189445588, -3.40952017632073],
            [17.825947150486847, -3.40678328440303],
            [17.822760120098227, -3.391820003505837],
            [17.819300159966776, -3.387009990103502],
            [17.799109920288306, -3.38183004560118],
            [17.781881833038423, -3.374330856793307],
            [17.779103284575829, -3.372985829167517],
            [17.777170080440005, -3.372049947217775],
            [17.758450080149412, -3.362959919825399],
            [17.754999839789317, -3.360220103165056],
            [17.751059999633071, -3.353339938744116],
            [17.739569879700905, -3.345810026482995],
            [17.739293908262496, -3.345511922152397],
            [17.728970039622691, -3.334360041134976],
            [17.726420160010608, -3.32954002540581],
            [17.724484825070938, -3.32774549877578],
            [17.719269839843612, -3.322909921597764],
            [17.711820234261605, -3.319627046837279],
            [17.711009999689388, -3.319269993982771],
            [17.709109004648095, -3.31914545371124],
            [17.704599840112525, -3.318850043372326],
            [17.699339879832184, -3.320489902586875],
            [17.692729919664799, -3.32743003480042],
            [17.690370405637825, -3.328947818793886],
            [17.685889919817729, -3.331829936328469],
            [17.681161434300506, -3.331684792591747],
            [17.679700080149122, -3.331639935050064],
            [17.678495745678649, -3.330200004694128],
            [17.677398750003121, -3.328888725410888],
            [17.6610499202786, -3.313330027195253],
            [17.656909920205692, -3.311969945732194],
            [17.646992544621867, -3.313614745097732],
            [17.64683999990682, -3.313640044403611],
            [17.633670284616596, -3.301216897780753],
            [17.633259929703229, -3.300829890698531],
            [17.62751988009067, -3.298790065411743],
            [17.614699920263053, -3.299319962938161],
            [17.60643048610163, -3.303364292212664],
            [17.602819919819495, -3.305130104456505],
            [17.597099880179886, -3.305850004895624],
            [17.595259920272216, -3.305790088524879],
            [17.593187912950281, -3.305720634500502],
            [17.585412412057909, -3.305459998587628],
            [17.573259959775203, -3.302759882179325],
            [17.573200805713736, -3.302733068517103],
            [17.565227528135168, -3.299118268832208],
            [17.559378739254093, -3.295141695713662],
            [17.557170119736998, -3.29364005734866],
            [17.530899839670486, -3.264560054090005],
            [17.527227192615712, -3.262278684601597],
            [17.503110000012089, -3.250440072726371],
            [17.499219840284322, -3.250690009415238],
            [17.496312280272207, -3.252362440233324],
            [17.492370119767557, -3.254629969507616],
            [17.489319839914685, -3.254649943269302],
            [17.48481012022031, -3.254669916127673],
            [17.473089959710194, -3.24691000114174],
            [17.464871815758212, -3.245747266056965],
            [17.463690000255276, -3.245580058106856],
            [17.46157473815407, -3.244725045291883],
            [17.442339839712265, -3.236950050194079],
            [17.434496027332443, -3.232386880645616],
            [17.4329219750371, -3.231471166391779],
            [17.431530134319043, -3.227799605928518],
            [17.43194016044901, -3.218360011560446],
            [17.430090119647243, -3.21561007487467],
            [17.425720079894681, -3.212409903081417],
            [17.419989960259276, -3.211750036631583],
            [17.417044217356001, -3.212390701384291],
            [17.411299919610439, -3.213640019053349],
            [17.406709920174055, -3.212279981462505],
            [17.404918904974672, -3.210903069871519],
            [17.401650425237595, -3.20839029349114],
            [17.400009959594968, -3.201500019738657],
            [17.397470159978685, -3.198059930297984],
            [17.397229057546344, -3.197976232062841],
            [17.392888746639791, -3.196469582285225],
            [17.379748635329747, -3.192850561351352],
            [17.37568069810893, -3.19173017610178],
            [17.373415906038801, -3.193190220118058],
            [17.366330160367692, -3.197759954779995],
            [17.364591369625632, -3.198068831502587],
            [17.360870040170688, -3.198729882523944],
            [17.353730303056032, -3.198510864070721],
            [17.356249709118746, -3.214057229634384],
            [17.35910028000923, -3.218605097630188],
            [17.368297058513182, -3.23327110415034],
            [17.377589880395771, -3.248090051536684],
            [17.380889999695452, -3.264879983156008],
            [17.365989960284743, -3.305450020346768],
            [17.365124853920058, -3.306536485139207],
            [17.363842651684116, -3.308146768956352],
            [17.360300159734233, -3.312609952598056],
            [17.356271753775818, -3.315340711138331],
            [17.346610080044325, -3.3218900957269],
            [17.339100120251626, -3.329289928187834],
            [17.338650119989826, -3.33251005326163],
            [17.339753948251378, -3.33426791125824],
            [17.342110080121312, -3.338020063975932],
            [17.352249839941958, -3.349240065461915],
            [17.354681795910032, -3.35329178788724],
            [17.358030000230279, -3.35886998208408],
            [17.359200000192288, -3.363469991368471],
            [17.355879714612769, -3.378841010926863],
            [17.355443117215025, -3.380026518083638],
            [17.353139084038322, -3.38628094544193],
            [17.348350624297783, -3.391139255016816],
            [17.345778023597248, -3.391726784077806],
            [17.344231928670172, -3.392079566211626],
            [17.342160119875892, -3.390710113048823],
            [17.334380159746459, -3.390979984729241],
            [17.332874547397644, -3.392845476195556],
            [17.330280120330634, -3.396060028009654],
            [17.330079960414004, -3.397179987029672],
            [17.326500120107863, -3.417480075078394],
            [17.32088723600689, -3.431179201416114],
            [17.320169880048571, -3.432930007461541],
            [17.319761783499807, -3.433287229212065],
            [17.308540080174563, -3.443109946002308],
            [17.302360132753893, -3.446274008984598],
            [17.301449879757946, -3.446740047573591],
            [17.299997529420668, -3.447853568918231],
            [17.286320159993725, -3.458339978677284],
            [17.28404027263354, -3.463154667766607],
            [17.280060119680613, -3.471559935774231],
            [17.274369959803959, -3.478719881500359],
            [17.274014393139801, -3.482218085430886],
            [17.273270159588158, -3.489540108392451],
            [17.276950080301766, -3.500880101185294],
            [17.278629840051558, -3.506079896767573],
            [17.279289002247474, -3.518401678566937],
            [17.279910000416866, -3.53000991401187],
            [17.282229840349295, -3.535520029090897],
            [17.284880722938624, -3.537894218396339],
            [17.286829919781475, -3.53963995715972],
            [17.290760040166358, -3.54697997646999],
            [17.291250000186917, -3.552960024259828],
            [17.286519959685954, -3.570479911300777],
            [17.286723668846282, -3.573429940878979],
            [17.286789960022691, -3.574389941645675],
            [17.29578961042408, -3.587229450688507],
            [17.304990119631405, -3.59454997846054],
            [17.311029840036262, -3.614669991592773],
            [17.313586792982889, -3.623170081043784],
            [17.314790039593547, -3.627170011959887],
            [17.317392675465634, -3.63044966808136],
            [17.318249999725033, -3.631530004412342],
            [17.328819960040295, -3.637919943869402],
            [17.331552991765758, -3.646331669306485],
            [17.332549769591537, -3.649401329786715],
            [17.332110000242508, -3.653319931511653],
            [17.329161240796513, -3.658628060093969],
            [17.321715312018959, -3.660004314595436],
            [17.313829920217888, -3.661459945340563],
            [17.311709243072144, -3.662293945928357],
            [17.307879840000297, -3.663799935814271],
            [17.303550120230991, -3.667730062639403],
            [17.303590079989743, -3.675549975029656],
            [17.306879618033715, -3.690262401987042],
            [17.30576015998453, -3.695789913375207],
            [17.30189988001975, -3.702489994143426],
            [17.297790119934266, -3.706190096660336],
            [17.296980598624412, -3.706559337882084],
            [17.294479919740422, -3.707699953156015],
            [17.287738684268962, -3.71079184603805],
            [17.28407988025273, -3.71246996563695],
            [17.278152331579104, -3.718487680171537],
            [17.270757133360597, -3.733051664058381],
            [17.267259959620187, -3.739939927005571],
            [17.260733054989007, -3.762405461677716],
            [17.259159960297733, -3.767819948561729],
            [17.2409198400319, -3.785629957888264],
            [17.235720000400274, -3.797160030052765],
            [17.234517679054324, -3.811110275010991],
            [17.234410143528319, -3.812357974253095],
            [17.234927039532675, -3.814874365560566],
            [17.236299959934232, -3.821550072261313],
            [17.233700039669266, -3.825920057258485],
            [17.225344885568447, -3.834188698625564],
            [17.219199959867453, -3.840269944427607],
            [17.218504579395898, -3.84241017374111],
            [17.217399959718566, -3.845809939866995],
            [17.219130120345678, -3.869959958090323],
            [17.218001437496834, -3.883626968293995],
            [17.217399959718566, -3.89091005232502],
            [17.20697003956959, -3.912590000457782],
            [17.199219960101441, -3.920450102652691],
            [17.199154778344418, -3.920595428525735],
            [17.197002013376753, -3.925395138637409],
            [17.191969919751386, -3.936610059976014],
            [17.188089840019419, -3.940070002172948],
            [17.182685093773163, -3.940455187020714],
            [17.174339999905236, -3.941049924456153],
            [17.171790689825045, -3.942823880668571],
            [17.169999839915661, -3.944070053984873],
            [17.154757621433436, -3.965542214549648],
            [17.138099879947344, -3.981039982956982],
            [17.134070040277731, -3.999470021983036],
            [17.126790120164685, -4.01101995584285],
            [17.120969777335365, -4.015524752955829],
            [17.12032991993491, -4.016019984964671],
            [17.108290080456211, -4.025359966681784],
            [17.101549709164061, -4.027429941752945],
            [17.099138199750158, -4.028169515288155],
            [17.080999919691465, -4.023420101349778],
            [17.079173676159876, -4.02203504691594],
            [17.059600079618303, -4.007189952545514],
            [17.043770159921035, -4.003809941220926],
            [17.041922675724543, -4.002508514319278],
            [17.032740120246473, -3.996039997030452],
            [17.024165347821658, -3.986202520803566],
            [17.022350159856281, -3.984120015560279],
            [17.015696481378953, -3.982127409434377],
            [17.014770000317405, -3.981849951907933],
            [17.01348640659106, -3.981833552492478],
            [17.012419920397551, -3.981819926308293],
            [16.990239959975504, -3.981509963034408],
            [16.984080000069888, -3.985679894694899],
            [16.973730000336776, -3.980440013254368],
            [16.959309840052502, -3.98325988811419],
            [16.955375958421538, -3.983275828303617],
            [16.946930159816993, -3.983310049775455],
            [16.93685086020826, -3.985659774877574],
            [16.932499920435284, -3.986830025333134],
            [16.915389840372676, -4.003480029370438],
            [16.910430120416496, -4.021450027688599],
            [16.878279959878604, -4.057029985206605],
            [16.872800039914409, -4.061660109551535],
            [16.863419880226683, -4.065149899002399],
            [16.860992163408415, -4.06754688280849],
            [16.854749999569442, -4.073709993787514],
            [16.853180039998541, -4.074900086396702],
            [16.827339960426674, -4.094539961391578],
            [16.823469215987139, -4.096337850196687],
            [16.82184995956835, -4.097089963754393],
            [16.81725996013197, -4.096879995187265],
            [16.795419839568396, -4.084089991363524],
            [16.785399109217852, -4.084136491642083],
            [16.784650079560908, -4.084139967210844],
            [16.781205751013715, -4.08503570275839],
            [16.772962788407057, -4.087179370124294],
            [16.765481766942923, -4.092869023233108],
            [16.761089880162686, -4.096210003006998],
            [16.747359839815662, -4.101560041965318],
            [16.739927050695787, -4.108473975032043],
            [16.730459999665548, -4.117280078841733],
            [16.726259031832633, -4.117810750358944],
            [16.715339999672693, -4.119190054448426],
            [16.710540290329835, -4.12288995836154],
            [16.702589880265144, -4.139949972008437],
            [16.698239999605878, -4.146019996680592],
            [16.698085846008198, -4.146235284551169],
            [16.697447858900134, -4.147126284330755],
            [16.697130120292577, -4.147570030861259],
            [16.694100659794703, -4.149614020765648],
            [16.693011351003104, -4.150348981056161],
            [16.688429999647944, -4.151059979041559],
            [16.680849840109069, -4.148099950341595],
            [16.678835471390698, -4.146324768183142],
            [16.67486988012849, -4.142830039992387],
            [16.662260160213364, -4.143110101343888],
            [16.643633283776676, -4.136668236409423],
            [16.634009880072931, -4.133340085275936],
            [16.617744296327469, -4.136629165253658],
            [16.612689960415668, -4.134349970531649],
            [16.611141682582446, -4.134526626918376],
            [16.608570120334356, -4.134820038807434],
            [16.599635079463173, -4.140290153021612],
            [16.596450000215384, -4.142240078734401],
            [16.592013310858643, -4.142540794628639],
            [16.585679879983463, -4.142970070680701],
            [16.581840120234677, -4.145730049863408],
            [16.580659447388783, -4.146580135934538],
            [16.578590039791248, -4.148070111409027],
            [16.566459839676448, -4.15295009841572],
            [16.561402061420502, -4.155915672873608],
            [16.553430000160805, -4.160589983175807],
            [16.547039999677239, -4.167290053497252],
            [16.518541241935964, -4.177024952266616],
            [16.517103251168486, -4.176781319681598],
            [16.512758386701783, -4.177880845930471],
            [16.510645947107189, -4.179894890399051],
            [16.508074380367546, -4.181105830408629],
            [16.504816543869943, -4.182375512061463],
            [16.501959404498081, -4.18381669943907],
            [16.500300781208626, -4.183877310755491],
            [16.498698372693035, -4.183420959791871],
            [16.497441986241714, -4.184457069364752],
            [16.496241377983036, -4.18474650836628],
            [16.495216066070554, -4.186988161562692],
            [16.494646482976467, -4.188252667341086],
            [16.494993925277214, -4.190491694793418],
            [16.494767858846057, -4.19192782801135],
            [16.494483613025551, -4.192847219953578],
            [16.495400862999222, -4.193936594829675],
            [16.496033543758902, -4.195773076556673],
            [16.496494194446694, -4.19738017531154],
            [16.496955341004547, -4.199245698428051],
            [16.497760178498503, -4.201368983830708],
            [16.497706924571837, -4.203436491416529],
            [16.497537957755089, -4.204815086167764],
            [16.497024479840384, -4.20550520920992],
            [16.495193442898451, -4.205164163035454],
            [16.493478336238866, -4.205626881182471],
            [16.492223227191886, -4.207352130788854],
            [16.491025750460285, -4.209306982517344],
            [16.490115141731486, -4.211720708890843],
            [16.489147111791421, -4.21401968989486],
            [16.486690585103673, -4.215713772075361],
            [16.485492540636812, -4.2173814838198],
            [16.48538119445735, -4.218989687298798],
            [16.484468601350095, -4.220369711569114],
            [16.483500005471424, -4.222381555236038],
            [16.483388763496528, -4.222882381024536],
            [16.480547279963446, -4.220948024022424],
            [16.477129646651527, -4.220244301817938],
            [16.470678240030075, -4.218915896778984],
            [16.468836479898588, -4.217082915548471],
            [16.467430320034897, -4.209954954090302],
            [16.465918027813665, -4.207325441770521],
            [16.463733480451225, -4.203527023668792],
            [16.455904200117754, -4.195733882107901],
            [16.45496748005862, -4.191134926383979],
            [16.456777199978834, -4.185834931418578],
            [16.460893439612484, -4.183056939855312],
            [16.467317279632809, -4.183951901036161],
            [16.470966239910183, -4.179564978078019],
            [16.471641240302855, -4.176571984931527],
            [16.469337240363846, -4.173588865469853],
            [16.453966320250871, -4.171578903024205],
            [16.451109359643766, -4.163692866747919],
            [16.450718400255692, -4.16261687125074],
            [16.441978319852272, -4.156668848589865],
            [16.435102320020221, -4.156695992139956],
            [16.429811400201913, -4.152804857073652],
            [16.427026439564838, -4.144991971610334],
            [16.425276162963591, -4.14406351584744],
            [16.423580159876849, -4.14316384820294],
            [16.413855119883529, -4.133614217669491],
            [16.38159911983885, -4.111742293054111],
            [16.34754743964352, -4.091700344840094],
            [16.313115959830903, -4.070920098835763],
            [16.269829920111686, -4.046414304967977],
            [16.229886840348065, -4.024500781651527],
            [16.185150360109876, -4.000722072642684],
            [16.123084919900226, -3.97023038063946],
            [16.099934063014011, -3.959346432212209],
            [16.089848639589963, -3.95460491049863],
            [16.0758136795945, -3.947909164517077],
            [16.06403087955961, -3.944168944919605],
            [16.055943119782945, -3.942287500687034],
            [16.047544680360183, -3.943348510950872],
            [16.042883399605984, -3.94847643555956],
            [16.03829843971835, -3.95765249944035],
            [16.034386679999574, -3.963704132109323],
            [16.032915397667665, -3.9645734165625],
            [16.029138239714445, -3.966805086773681],
            [16.025142960030429, -3.968440513632314],
            [16.019862839758499, -3.969885352798077],
            [16.010469359851708, -3.971403007064045],
            [16.009546320236009, -3.969563877787099],
            [16.002851384832621, -3.967998750478433],
            [16.002772331290984, -3.967531293193724],
            [16.002805144951694, -3.966646579302199],
            [16.002803709443864, -3.965455673372738],
            [16.002498253501159, -3.965013707416512],
            [16.001481312090529, -3.964572604603695],
            [16.000430532939738, -3.964165567752523],
            [15.999752763939343, -3.9640302854142],
            [15.999244355217797, -3.963860771743557],
            [15.999176186562456, -3.963520594020171],
            [15.999616262236993, -3.963213827413657],
            [15.999649488224405, -3.962669371864527],
            [15.999782721855745, -3.960763756539341],
            [15.999477229082157, -3.960287762280027],
            [15.9993066857221, -3.959335241543917],
            [15.999000622518254, -3.958382883894501],
            [15.998491932624018, -3.957975187167988],
            [15.997949770603965, -3.95790778952956],
            [15.997338871294975, -3.957023851011085],
            [15.996389458040891, -3.956378501742793],
            [15.99466129347033, -3.956142400667177],
            [15.992323330027061, -3.955941053532337],
            [15.990731008693777, -3.955976988501166],
            [15.990256243676223, -3.955603270522028],
            [15.988831063783024, -3.953733541307315],
            [15.98784769870274, -3.953020167988645],
            [15.986933262252546, -3.9532934681168],
            [15.986052422793959, -3.953328544318182],
            [15.986051578377587, -3.95261399689765],
            [15.985576215082066, -3.951729883947989],
            [15.984695296571738, -3.951696906173574],
            [15.981815702012732, -3.951870457865271],
            [15.981001302850871, -3.950782585954743],
            [15.980525585619125, -3.949592232504882],
            [15.979982629488338, -3.948844299750987],
            [15.978526353513281, -3.949322387443416],
            [15.97771279786946, -3.948949060683979],
            [15.976137058538033, -3.948008137990535],
            [15.975949811005247, -3.947896326284527],
            [15.974491984537998, -3.947047386660057],
            [15.97413849388043, -3.946242190064779],
            [15.973451851321641, -3.945955798509734],
            [15.972651158654392, -3.945956738599004],
            [15.97202197593448, -3.94590003732127],
            [15.971792872299336, -3.945613107937024],
            [15.97166725997487, -3.945361531969652],
            [15.97133426617714, -3.944694611869621],
            [15.969960385476551, -3.943604867389154],
            [15.969330272101979, -3.942744009763114],
            [15.96852904942871, -3.942285428331264],
            [15.967556915086107, -3.942401441449845],
            [15.966755561258829, -3.941827978906013],
            [15.966869281685588, -3.941253449558493],
            [15.966524869402283, -3.940162496968031],
            [15.965723848849962, -3.939876230501085],
            [15.964980285441523, -3.939819656013797],
            [15.964293848596936, -3.939705574148757],
            [15.96429285685684, -3.938843978940103],
            [15.963948845222177, -3.938097662158742],
            [15.96343391922322, -3.937925940833988],
            [15.961889142124651, -3.937410773035352],
            [15.960516205553448, -3.937125162415689],
            [15.95925798204736, -3.937126615870656],
            [15.958457294769996, -3.937127540632489],
            [15.957942369669372, -3.936955814593886],
            [15.956624724403881, -3.935004377601126],
            [15.954604684621133, -3.933111641951397],
            [15.953549428266975, -3.932120320674307],
            [15.952461871190145, -3.931691468437365],
            [15.951308544858126, -3.931361944222334],
            [15.950451055308729, -3.930469644241713],
            [15.9499233184355, -3.92987472682717],
            [15.948308105333851, -3.928917119255918],
            [15.946627161604514, -3.928091919889356],
            [15.945868988894615, -3.927629598712828],
            [15.945177219650491, -3.927630384543923],
            [15.944552412624304, -3.928590544176578],
            [15.943432702148534, -3.928856489456861],
            [15.942906195967231, -3.929353353961382],
            [15.942280827493992, -3.929817244925775],
            [15.941557080022426, -3.930678261352164],
            [15.940931895703791, -3.931307575059922],
            [15.940206995693719, -3.93114297168155],
            [15.939679930760319, -3.931143567142288],
            [15.939318240280841, -3.931739497726494],
            [15.938561361144927, -3.932435127706198],
            [15.938166653087201, -3.932964925272362],
            [15.938101584517913, -3.933692858763889],
            [15.938464238889674, -3.93395712608848],
            [15.938892999384906, -3.934419826246661],
            [15.938992565057733, -3.935081404594607],
            [15.938597671947038, -3.935445780537737],
            [15.937609752408271, -3.935744656908482],
            [15.936655550235397, -3.936738269932365],
            [15.935767895258731, -3.938327329393901],
            [15.934715157780664, -3.939585728988855],
            [15.934518576752073, -3.940545403709995],
            [15.933926433367947, -3.941273930449305],
            [15.932773794247106, -3.941572988748236],
            [15.930566860867762, -3.941740889388537],
            [15.928952699693314, -3.941742697400596],
            [15.927734062246854, -3.941942569317663],
            [15.927273459169776, -3.942472438341438],
            [15.927274156262424, -3.943101045614695],
            [15.927538353482442, -3.943696273733198],
            [15.926913331758884, -3.944491004618782],
            [15.92566251665896, -3.945385687408759],
            [15.924378828609553, -3.94634657601671],
            [15.923819723464909, -3.947174315672156],
            [15.92382085713878, -3.948199940054766],
            [15.923328403394983, -3.949722383755516],
            [15.921120857364652, -3.949360911095279],
            [15.919770690390942, -3.949792512103591],
            [15.919409233473417, -3.950620031751011],
            [15.919640486777011, -3.951215299517558],
            [15.918752422168604, -3.95247350520735],
            [15.918588437408456, -3.953135382052083],
            [15.917082801703449, -3.95312459096853],
            [15.915196477947351, -3.954103167816025],
            [15.914738674918993, -3.953873911888021],
            [15.913536346386538, -3.952726429568017],
            [15.912276136705369, -3.950947162839476],
            [15.910673209861853, -3.949570353422715],
            [15.908499476418806, -3.949228097414611],
            [15.908129625643298, -3.949324386703703],
            [15.906726971904147, -3.949689564686149],
            [15.904381158083607, -3.94888796051657],
            [15.902144819251777, -3.94863622315966],
            [15.902358951564359, -3.94745366155811],
            [15.901928378268886, -3.947036084853452],
            [15.902011004410411, -3.94687290197786],
            [15.904929827499567, -3.941108360102033],
            [15.904969643527918, -3.940976774786404],
            [15.905913445904762, -3.937857677232973],
            [15.908486067266564, -3.936878377271931],
            [15.910429498721909, -3.935842319136417],
            [15.911171256516615, -3.934233168971362],
            [15.910654714448446, -3.932567957637517],
            [15.909967346050935, -3.931592219626341],
            [15.909965698540693, -3.930072877498894],
            [15.910421147983023, -3.928145285999399],
            [15.911335100241287, -3.927110355463544],
            [15.913793484645032, -3.926303493683379],
            [15.914764373024328, -3.925038736575354],
            [15.91744731558787, -3.920383105228713],
            [15.917960598568166, -3.919061409453058],
            [15.91773070621224, -3.918027732437923],
            [15.918682701224448, -3.916286898668226],
            [15.919386246483622, -3.915268768124873],
            [15.91966994612846, -3.913200597613521],
            [15.920354670784077, -3.911763832001907],
            [15.921268156816746, -3.910326814876674],
            [15.920981136998602, -3.909350642747353],
            [15.921494411894091, -3.908028946468852],
            [15.922007119952616, -3.906190286974677],
            [15.922004111494704, -3.903433148112845],
            [15.922343056631203, -3.899584264814861],
            [15.923444180065427, -3.894918507690093],
            [15.923584041466956, -3.893727416760717],
            [15.924823550370713, -3.891259111179867],
            [15.92569641278957, -3.889131477831929],
            [15.926117473824515, -3.886919274588957],
            [15.926283492370457, -3.883828327661147],
            [15.929312960054842, -3.878318914421153],
            [15.929342797597002, -3.878264651854243],
            [15.929342944920727, -3.878264383879763],
            [15.929342985344929, -3.878264309893573],
            [15.929549955389753, -3.877185380935825],
            [15.930370080413216, -3.872910038863153],
            [15.943690080257221, -3.841069980563106],
            [15.952809960277904, -3.825389927294117],
            [15.957519839888974, -3.817289939493701],
            [15.964310160205866, -3.803439955160776],
            [15.981739920135356, -3.767889906237118],
            [16.001020080192717, -3.738549903745335],
            [16.009749212827778, -3.716764261462689],
            [16.009750079702009, -3.71745646121632],
            [16.009750079702009, -3.718510050759792],
            [16.011047022393456, -3.718096530942983],
            [16.013419396702044, -3.717340116683332],
            [16.013419920419853, -3.717339949731691],
            [16.013773495519047, -3.716862085259292],
            [16.013773600621942, -3.716861943575898],
            [16.016150160181404, -3.713649965813442],
            [16.017739161341385, -3.708812307615038],
            [16.017739920417796, -3.708809996440133],
            [16.017480996308507, -3.708047839944784],
            [16.017040079810887, -3.706749975535081],
            [16.016954508991841, -3.706796538462349],
            [16.012850039983391, -3.709029955102697],
            [16.023570119562404, -3.682259922897456],
            [16.037169840412837, -3.660319983882686],
            [16.046840160428925, -3.632190116793872],
            [16.052619959594512, -3.620279958271928],
            [16.058149920211584, -3.608870044057364],
            [16.065560159821221, -3.600430061224877],
            [16.086579840052654, -3.576479950078936],
            [16.110150120345004, -3.538360070091881],
            [16.112890079877914, -3.536280048275115],
            [16.125279840109219, -3.504210096380658],
            [16.128280080207542, -3.492719932461663],
            [16.13243016027625, -3.476789939738874],
            [16.144880040257931, -3.454850065905743],
            [16.164879839791098, -3.431019941462021],
            [16.187100120196401, -3.395440046469496],
            [16.191950039973722, -3.384870079289219],
            [16.204259879789159, -3.358059981292596],
            [16.211229839806681, -3.339599976557345],
            [16.222389839651665, -3.296269943340563],
            [16.219379879782014, -3.290079911252344],
            [16.197909839962676, -3.276280038841122],
            [16.189279919962551, -3.267340086168075],
            [16.184070000335126, -3.250490095823807],
            [16.186410000259148, -3.222410045869989],
            [16.192659959678135, -3.198899934413546],
            [16.190979763347119, -3.17900178528867],
            [16.190921324344639, -3.178662255415622],
            [16.184999879723357, -3.155999998418276],
            [16.17999983978396, -3.138000006589614],
            [16.17800003994288, -3.10199998255909],
            [16.172609948812173, -3.074169124078511],
            [16.172301959620384, -3.072578850671298],
            [16.178002919941672, -3.033888612241898],
            [16.186171875741955, -3.025291153514098],
            [16.194999959602161, -3.015999913203439],
            [16.194999959602161, -3.000000025168433],
            [16.190999999695535, -2.9770000299236],
            [16.181999999849506, -2.956999998257363],
            [16.180999919816731, -2.942000004595014],
            [16.179000119975651, -2.928000042129348],
            [16.17999983978396, -2.906999945980065],
            [16.17999983978396, -2.874999998921244],
            [16.184999879723357, -2.853000046577244],
            [16.194999959602161, -2.822999949321762],
            [16.200000000439889, -2.809999926466075],
            [16.203999960346518, -2.79299996679451],
            [16.205000040379293, -2.784999983878842],
            [16.205000040379293, -2.783999982365295],
            [16.193408400040248, -2.750838863425269],
            [16.193683079701298, -2.718583433798045],
            [16.215064199782248, -2.679881022814868],
            [16.22219220040769, -2.655511347305501],
            [16.237000079856774, -2.624999957331029],
            [16.23499991979126, -2.603000032242894],
            [16.218000000131948, -2.545000091742496],
            [16.215999840066431, -2.541000009886607],
            [16.214000040225319, -2.536000070602658],
            [16.209000000285918, -2.516999977591406],
            [16.193999879569422, -2.446999921130891],
            [16.188999839630018, -2.423999891400715],
            [16.18800011982168, -2.418000108237769],
            [16.185988570914965, -2.400398978809367],
            [16.18574563591941, -2.398273274669948],
            [16.184000159915051, -2.383000087801524],
            [16.184999879723357, -2.319999949886858],
            [16.186439182031162, -2.30656762409677],
            [16.187516394109146, -2.29651442931312],
            [16.18800011982168, -2.291999990683092],
            [16.189817191554205, -2.274736153484216],
            [16.189999919662757, -2.273000056200545],
            [16.190414320588189, -2.253110584846483],
            [16.190999999695535, -2.224999978598062],
            [16.201000079574335, -2.198000059442603],
            [16.215000120258093, -2.171000005088737],
            [16.242000119796177, -2.123000025302814],
            [16.267803840056956, -2.107139941263129],
            [16.289999999798528, -2.090999979169015],
            [16.301000159710103, -2.08400007694931],
            [16.323999840015453, -2.069000000960172],
            [16.366039920028857, -2.031530075936501],
            [16.366446689765908, -2.031262005353717],
            [16.369530120147736, -2.029229952482027],
            [16.371311532356746, -2.026258353002437],
            [16.395999839682037, -2.000999947735141],
            [16.405999919560841, -1.9919999183718],
            [16.428587360287381, -1.965769461897509],
            [16.432965941221642, -1.960684633156659],
            [16.43699987990388, -1.956000022525684],
            [16.438753626697082, -1.953912264283615],
            [16.440686738306436, -1.95161097715021],
            [16.45773911418846, -1.93131070985021],
            [16.463086800346183, -1.92494442194993],
            [16.467188049792661, -1.92006197104316],
            [16.474796322108372, -1.911004444604875],
            [16.479000000158496, -1.906000013361516],
            [16.488000000004522, -1.896000086617414],
            [16.503999839631064, -1.874000004521388],
            [16.550580453349742, -1.864753509587964],
            [16.56026972153014, -1.862831924065912],
            [16.55850006736987, -1.874568709020923],
            [16.558990104645577, -1.881920598498963],
            [16.562679661587246, -1.889729593026042],
            [16.565429160330176, -1.891327945419894],
            [16.566295320418689, -1.892693004007966],
            [16.568193239628492, -1.895685932894748],
            [16.570060200198618, -1.904646854839675],
            [16.574232213533325, -1.911177348449758],
            [16.579731239765284, -1.919784988294945],
            [16.57980720040738, -1.936803810753017],
            [16.583509439764239, -1.946677856140687],
            [16.584948963955892, -1.949286505158932],
            [16.592499359614468, -1.962968962632747],
            [16.611826227575047, -1.989336841463486],
            [16.616520359719164, -1.992214985809926],
            [16.621284608066166, -1.995135325939277],
            [16.623749160302648, -1.996646019444357],
            [16.626453480074986, -1.997055979055058],
            [16.629193574355234, -1.997472165830896],
            [16.634223385361441, -1.998235967737611],
            [16.63702415994079, -1.998242989454377],
            [16.733478975925731, -1.999189829134349],
            [16.755321620755247, -1.999404244875129],
            [16.945014959716101, -2.001266349512168],
            [16.942682520013516, -1.866093805641823],
            [16.925180399889559, -1.86079596499174],
            [16.912124308906371, -1.855795888073092],
            [16.911293989801049, -1.855854828852122],
            [16.887897360141316, -1.857516015608176],
            [16.881949047808213, -1.856315837366165],
            [16.878971159590801, -1.855714995448043],
            [16.866821159708842, -1.849329986304401],
            [16.854246360003717, -1.845940851232219],
            [16.852959765006037, -1.845594523354492],
            [16.851713400160033, -1.845259024965223],
            [16.849200788954168, -1.845631180777615],
            [16.846914239687838, -1.84596985357097],
            [16.842430800207083, -1.838738872171409],
            [16.837928639835816, -1.83056374407283],
            [16.833087360054879, -1.82570822387894],
            [16.827883559751182, -1.821587307885649],
            [16.822716840105738, -1.821528581993404],
            [16.815372480244108, -1.825507366401053],
            [16.809145559917212, -1.83060661794103],
            [16.804760399721808, -1.83535746309539],
            [16.799241240447699, -1.837141210776687],
            [16.794067680131391, -1.836343910740796],
            [16.790323679893604, -1.830393150683806],
            [16.788763800318495, -1.821143619073981],
            [16.788683519678191, -1.812280085346365],
            [16.790069160224149, -1.802325197439392],
            [16.793376358248292, -1.795376947389865],
            [16.795139039685324, -1.791673634808833],
            [16.800960240405704, -1.782507491271345],
            [16.806070079625666, -1.776287593846101],
            [16.811166600423228, -1.768590471366449],
            [16.814461319949757, -1.765673530010005],
            [16.818883199680716, -1.764985007616],
            [16.823721240136724, -1.769471389921105],
            [16.836544252439676, -1.780247765256978],
            [16.846343999925274, -1.781914451539254],
            [16.858150200174954, -1.781679001322082],
            [16.872134399966992, -1.777406121686611],
            [16.884008851517045, -1.77157281565125],
            [16.884625320380774, -1.771269976000629],
            [16.893808200150666, -1.766573365687942],
            [16.904826359605579, -1.760789731711179],
            [16.921396800117417, -1.756915471034316],
            [16.94060784020358, -1.759349090102214],
            [16.95761136031053, -1.762496270379973],
            [16.97093063970566, -1.766340254681019],
            [16.983491759865615, -1.767959777388262],
            [16.993838879599931, -1.769554257927804],
            [17.002722959943405, -1.772609365273108],
            [17.011660679590765, -1.781573436272871],
            [17.016907679876514, -1.790495849209513],
            [17.026536600134438, -1.794297800874988],
            [17.037608399791569, -1.794423360798152],
            [17.048680200347064, -1.794548921616528],
            [17.054605080125985, -1.796831890326823],
            [17.063529120228214, -1.804318664847747],
            [17.07015888016279, -1.802916788726284],
            [17.077459679818006, -1.794136751228717],
            [17.08768619982709, -1.78243579366741],
            [17.094288959997506, -1.77807914697687],
            [17.100932040151111, -1.778154448714163],
            [17.107648560274157, -1.786355036466095],
            [17.113553280061478, -1.786421869899897],
            [17.18831159992709, -1.72892222782679],
            [17.480755799662564, -1.504740717018342],
            [17.506426320427924, -1.479804370270709],
            [17.520408719996151, -1.477689498169625],
            [17.545872959724495, -1.477847510591728],
            [17.554312799803753, -1.475331209784345],
            [17.57768399995442, -1.462265356305923],
            [17.590880159849995, -1.457576490034593],
            [17.598260879921082, -1.457622435020771],
            [17.608245840255336, -1.458785283138451],
            [17.612660519989294, -1.4580788182157],
            [17.621031600321757, -1.451892146783183],
            [17.632758599706108, -1.447561267760465],
            [17.671322160044092, -1.437892480642813],
            [17.710248240006578, -1.427858792313489],
            [17.718555405206555, -1.42291975573655],
            [17.723696760021621, -1.416932818620687],
            [17.73208151989925, -1.411480261652759],
            [17.739428040209138, -1.409690908579422],
            [17.781340679826446, -1.401510601818202],
            [17.825071320034276, -1.391873510715244],
            [17.883522465953405, -1.379922842783952],
            [17.910386640220551, -1.376255990639534],
            [18.037136146523999, -1.277880968269618],
            [18.116908979086542, -1.214668065521562],
            [18.120222360214775, -1.2120424718763],
            [18.127458720121403, -1.204380290382981],
            [18.128093759856988, -1.198878973726681],
            [18.128891160198709, -1.182368290272956],
            [18.130133520355187, -1.169897502474133],
            [18.134007479865129, -1.160012118304574],
            [18.133835400385941, -1.150835595332814],
            [18.133197839977658, -1.136517997383182],
            [18.130905720258262, -1.112647246742232],
            [18.131526720224283, -1.106411795816639],
            [18.13699368019385, -1.102775359937764],
            [18.142898399981139, -1.102812120177495],
            [18.151942728093204, -1.103367510334109],
            [18.156197520283008, -1.103628786919153],
            [18.170659080325422, -1.107388839213242],
            [18.185755680103451, -1.105647388022693],
            [18.205335720260571, -1.106870044539136],
            [18.219212507595742, -1.110320653729429],
            [18.223501319883688, -1.111387110963734],
            [18.245336760224617, -1.114826038021387],
            [18.268245000118885, -1.116436299432314],
            [18.287804159835503, -1.116557753681507],
            [18.314799480049309, -1.119661504203234],
            [18.328516200177269, -1.123049965644557],
            [18.333368639728981, -1.12601621768228],
            [18.338262479937157, -1.131185032162071],
            [18.346532760311614, -1.139310705464165],
            [18.352178640431276, -1.145218124931172],
            [18.360024839634782, -1.150405104868896],
            [18.367071119620544, -1.152284020042841],
            [18.374882759736781, -1.155635682192107],
            [18.384643080164569, -1.164504774498768],
            [18.392920200311561, -1.172997410501785],
            [18.40597451981704, -1.180418759496944],
            [18.420370200111481, -1.184270969900994],
            [18.424097853706023, -1.184578386233826],
            [18.428142239795037, -1.184911923200506],
            [18.436490873923493, -1.187465485193582],
            [18.438444360221816, -1.18806298954445],
            [18.442912664886673, -1.191288603890753],
            [18.446020199762515, -1.193531892862963],
            [18.447587147282249, -1.196690033389646],
            [18.452272319629753, -1.206132853000542],
            [18.459071588065196, -1.213023340005998],
            [18.4635432003269, -1.217554933352229],
            [18.463890502490464, -1.218135382141347],
            [18.467241479909987, -1.223735896217905],
            [18.473394982725335, -1.230229574010697],
            [18.474603479988858, -1.231504876220225],
            [18.495231480383378, -1.241254854447144],
            [18.503957159894462, -1.247635953535113],
            [18.513387517440293, -1.256997990567198],
            [18.522323279658679, -1.260847859267509],
            [18.529632359984138, -1.260340985042956],
            [18.541248480312984, -1.254977991767414],
            [18.554043239701926, -1.254894023388946],
            [18.561704447042395, -1.258324054832762],
            [18.566189279810146, -1.260331976114683],
            [18.572132160030741, -1.260752899357923],
            [18.584434439624701, -1.255384860881972],
            [18.59836248033843, -1.253913968359706],
            [18.617973480033481, -1.248497985666755],
            [18.620432101592495, -1.247228094059884],
            [18.641422440151796, -1.236388969296664],
            [18.65453844067958, -1.234440797880346],
            [18.657627271732892, -1.233982001567105],
            [18.658457207257584, -1.233976677891068],
            [18.660141359769117, -1.233965933794167],
            [18.666395718238022, -1.231145590111704],
            [18.668342159947873, -1.230267859686322],
            [18.671098361919473, -1.229025911289957],
            [18.677223360292551, -1.226265975547825],
            [18.697294440245205, -1.221304019948621],
            [18.709398360146356, -1.220762901971757],
            [18.726322320061872, -1.2229470142999],
            [18.751083479858405, -1.235421881940292],
            [18.760358976832372, -1.236206656157524],
            [18.761142229606705, -1.236272913624794],
            [18.745999919953764, -1.218000009141289],
            [18.720000000448419, -1.182999874061594],
            [18.732999960201109, -1.143999990268592],
            [18.74499983992099, -1.118000068050842],
            [18.798000120087178, -1.143999990268592],
            [18.830000159564662, -1.183999956475349],
            [18.831212259970812, -1.183467814877648],
            [18.870999840460396, -1.166000043104138],
            [18.869000039720991, -1.132999989507056],
            [18.851000040028932, -1.078000081492504],
            [18.83736223061047, -1.061469460905048],
            [18.817999919620348, -1.037999922307666],
            [18.752000039925939, -1.023000067313532],
            [18.743000040079909, -1.01199998435617],
            [18.749000160052052, -0.934999988531307],
            [18.759061569711925, -0.901940451868662],
            [18.762999839613077, -0.889000097753316],
            [18.768999959585219, -0.867999936215212],
            [18.788182585958957, -0.831233459519253],
            [18.793000080147781, -0.821999930264718],
            [18.86982983960009, -0.815487489813492],
            [18.882376200439936, -0.815331062609803],
            [18.897510240202362, -0.817387140393486],
            [18.91375740039965, -0.822422535100435],
            [18.927788040396941, -0.826362937040673],
            [18.948261240406733, -0.82818995563441],
            [18.950309820564399, -0.8272569828516],
            [18.952358399823733, -0.82632400984652],
            [18.95990719558278, -0.825553695683309],
            [18.964452239729088, -0.825089897866002],
            [18.982226340076679, -0.822301880389509],
            [19.000000440424234, -0.819513860939775],
            [19.009657440221297, -0.816148880413257],
            [19.026665945978102, -0.800865976079967],
            [19.03629834181783, -0.792210925316814],
            [19.056198239708252, -0.786836013211322],
            [19.057649129384885, -0.785775771934527],
            [19.060558200363317, -0.78364996052337],
            [19.069080479734506, -0.772221852649098],
            [19.070340267207506, -0.769367024544792],
            [19.078581240045793, -0.750691949789517],
            [19.081644479893292, -0.736009001121285],
            [19.0903557603087, -0.74052960902734],
            [19.102933440012585, -0.75608659997449],
            [19.121790240246227, -0.774558369388346],
            [19.139917320109973, -0.797154670209594],
            [19.154727720231747, -0.822036874426257],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kikwit",
        AREA: 78219,
        POPULATION: 5490000,
        DISTRICTS: ["Masi-Manimba", "Gungu", "Bulungu", "Bagata"],
        OBJECTID: 13,
        NOM: "Kwilu",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [17.397470159978685, -3.198059930297984],
            [17.400009959594968, -3.201500019738657],
            [17.401650425237595, -3.20839029349114],
            [17.404918904974672, -3.210903069871519],
            [17.406709920174055, -3.212279981462505],
            [17.411299919610439, -3.213640019053349],
            [17.417044217356001, -3.212390701384291],
            [17.419989960259276, -3.211750036631583],
            [17.425720079894681, -3.212409903081417],
            [17.430090119647243, -3.21561007487467],
            [17.43194016044901, -3.218360011560446],
            [17.431530134319043, -3.227799605928518],
            [17.4329219750371, -3.231471166391779],
            [17.434496027332443, -3.232386880645616],
            [17.442339839712265, -3.236950050194079],
            [17.46157473815407, -3.244725045291883],
            [17.463690000255276, -3.245580058106856],
            [17.464871815758212, -3.245747266056965],
            [17.473089959710194, -3.24691000114174],
            [17.48481012022031, -3.254669916127673],
            [17.489319839914685, -3.254649943269302],
            [17.492370119767557, -3.254629969507616],
            [17.496312280272207, -3.252362440233324],
            [17.499219840284322, -3.250690009415238],
            [17.503110000012089, -3.250440072726371],
            [17.527227192615712, -3.262278684601597],
            [17.530899839670486, -3.264560054090005],
            [17.557170119736998, -3.29364005734866],
            [17.559378739254093, -3.295141695713662],
            [17.565227528135168, -3.299118268832208],
            [17.573200805713736, -3.302733068517103],
            [17.573259959775203, -3.302759882179325],
            [17.585412412057909, -3.305459998587628],
            [17.593187912950281, -3.305720634500502],
            [17.595259920272216, -3.305790088524879],
            [17.597099880179886, -3.305850004895624],
            [17.602819919819495, -3.305130104456505],
            [17.60643048610163, -3.303364292212664],
            [17.614699920263053, -3.299319962938161],
            [17.62751988009067, -3.298790065411743],
            [17.633259929703229, -3.300829890698531],
            [17.633670284616596, -3.301216897780753],
            [17.64683999990682, -3.313640044403611],
            [17.646992544621867, -3.313614745097732],
            [17.656909920205692, -3.311969945732194],
            [17.6610499202786, -3.313330027195253],
            [17.677398750003121, -3.328888725410888],
            [17.678495745678649, -3.330200004694128],
            [17.679700080149122, -3.331639935050064],
            [17.681161434300506, -3.331684792591747],
            [17.685889919817729, -3.331829936328469],
            [17.690370405637825, -3.328947818793886],
            [17.692729919664799, -3.32743003480042],
            [17.699339879832184, -3.320489902586875],
            [17.704599840112525, -3.318850043372326],
            [17.709109004648095, -3.31914545371124],
            [17.711009999689388, -3.319269993982771],
            [17.711820234261605, -3.319627046837279],
            [17.719269839843612, -3.322909921597764],
            [17.724484825070938, -3.32774549877578],
            [17.726420160010608, -3.32954002540581],
            [17.728970039622691, -3.334360041134976],
            [17.739293908262496, -3.345511922152397],
            [17.739569879700905, -3.345810026482995],
            [17.751059999633071, -3.353339938744116],
            [17.754999839789317, -3.360220103165056],
            [17.758450080149412, -3.362959919825399],
            [17.777170080440005, -3.372049947217775],
            [17.779103284575829, -3.372985829167517],
            [17.781881833038423, -3.374330856793307],
            [17.799109920288306, -3.38183004560118],
            [17.819300159966776, -3.387009990103502],
            [17.822760120098227, -3.391820003505837],
            [17.825947150486847, -3.40678328440303],
            [17.826530189445588, -3.40952017632073],
            [17.832539880068772, -3.418229935555476],
            [17.844720119938156, -3.424599953093879],
            [17.848072027114011, -3.425066963818278],
            [17.84953007995669, -3.425270109303924],
            [17.860049999619076, -3.422679975362777],
            [17.869870079572806, -3.41640997399499],
            [17.878550040225814, -3.413599966200973],
            [17.879264136197996, -3.413566410323686],
            [17.880249959967198, -3.41352008604084],
            [17.902237412322194, -3.412555411111722],
            [17.902594940906983, -3.412537827455305],
            [17.905794561184255, -3.41114066236711],
            [17.915429880141936, -3.412469950999713],
            [17.92046016006876, -3.41037003762463],
            [17.926919320947729, -3.410137621892876],
            [17.928240120198193, -3.410090096789346],
            [17.938049797660938, -3.40290056976834],
            [17.940180013118361, -3.40285456544268],
            [17.952480000211764, -3.402589955667919],
            [17.957499839918324, -3.400029984955731],
            [17.958235051689581, -3.399348594152102],
            [17.967750120366702, -3.390530018601629],
            [17.970487002271462, -3.38959991255495],
            [17.971869960447986, -3.38912992512052],
            [17.991759815173527, -3.382340156764817],
            [18.000020063162868, -3.38527989105536],
            [18.005342618052225, -3.386000731207552],
            [18.013089960353682, -3.387049931297062],
            [18.034109999911216, -3.378179904845053],
            [18.037383573095973, -3.37791820058853],
            [18.043490159598978, -3.377430011928603],
            [18.06805007970387, -3.384879974558783],
            [18.085119457999255, -3.403189551991874],
            [18.094060080103304, -3.404749977024864],
            [18.101706299951562, -3.403418229317619],
            [18.109159920104567, -3.402120025194856],
            [18.113370119923687, -3.406890021938203],
            [18.123008846191226, -3.417823897893915],
            [18.138229920128268, -3.435089959576144],
            [18.142848462634493, -3.439010321777881],
            [18.151130159697896, -3.446040042206729],
            [18.156638981159706, -3.44716981589374],
            [18.166219919703362, -3.441130097155353],
            [18.166786172742707, -3.440063087617612],
            [18.16916004005127, -3.435589917185093],
            [18.171159839892351, -3.425679938853246],
            [18.171983776467592, -3.424388165599664],
            [18.173660039974287, -3.421760104414217],
            [18.178908770415241, -3.418500693133079],
            [18.186689880388226, -3.417760012828285],
            [18.190245914441022, -3.415950423763882],
            [18.194000039590364, -3.414040025544777],
            [18.201959458859044, -3.405708457085368],
            [18.205202616884911, -3.404220953451301],
            [18.208580039808083, -3.402670016395635],
            [18.212189262210519, -3.40366351453357],
            [18.214319880113177, -3.404250002216608],
            [18.218973305100192, -3.403880416239258],
            [18.226910159587288, -3.403250052713832],
            [18.238691810676887, -3.400216019548828],
            [18.241549639954883, -3.399480064449345],
            [18.243387561585138, -3.400159203684831],
            [18.244828423368272, -3.4020657859057],
            [18.246158890287798, -3.403828331921276],
            [18.246186618585671, -3.403947548538041],
            [18.248749919926418, -3.415310008100881],
            [18.250850160399434, -3.418129906648622],
            [18.252680535283009, -3.420580081014663],
            [18.26184465014493, -3.423864814031155],
            [18.262779840373135, -3.424200017936199],
            [18.268309497359656, -3.42830951113629],
            [18.271073455385398, -3.434994347673472],
            [18.275519879784884, -3.44575003767679],
            [18.27417216161863, -3.45211372167643],
            [18.273080159677765, -3.457269924945037],
            [18.281560618879247, -3.458600443860782],
            [18.284589660762176, -3.460935500971377],
            [18.294000119726135, -3.468189885670974],
            [18.294404393045021, -3.468279164519002],
            [18.301110119909943, -3.469760046815531],
            [18.301622129079156, -3.470212576699153],
            [18.305499960327992, -3.47363992378983],
            [18.30913136932131, -3.482035071171965],
            [18.309669840163856, -3.483279909716424],
            [18.310619743898123, -3.484218570848638],
            [18.312210000004544, -3.485790002993494],
            [18.316909355852051, -3.487335291083724],
            [18.32185008003324, -3.488959945746705],
            [18.333576359867049, -3.495095978828469],
            [18.341849858006846, -3.498959909146014],
            [18.34700003966789, -3.514110065675798],
            [18.355250169932187, -3.516359989211781],
            [18.355446235327779, -3.517069441936646],
            [18.356900040037527, -3.522329947871421],
            [18.360438531789434, -3.527015927333172],
            [18.363129840363211, -3.530579976569121],
            [18.390909960250248, -3.539149948349923],
            [18.39280108729816, -3.538046794152029],
            [18.395709840272986, -3.536350024238031],
            [18.397770120088914, -3.536570025381128],
            [18.398239920117877, -3.538180005016359],
            [18.397504337342419, -3.539177011655422],
            [18.395510039682428, -3.541880068875916],
            [18.393105947657823, -3.543013201607195],
            [18.392541857761689, -3.543279076687407],
            [18.392973507238853, -3.544336030458739],
            [18.393479999853927, -3.545570044561426],
            [18.395778354779708, -3.546479231389594],
            [18.403349181721104, -3.544907330599738],
            [18.403769879836652, -3.544819925775761],
            [18.401901713727383, -3.538158338462215],
            [18.403269839820268, -3.536769878097899],
            [18.407204226304401, -3.5379624900838],
            [18.410659920336602, -3.539009997749809],
            [18.412065018391626, -3.539439837894299],
            [18.412910863079983, -3.539697900023155],
            [18.418998030701498, -3.545731903334867],
            [18.419368511196037, -3.546099107875869],
            [18.419691905596618, -3.54644545736189],
            [18.425139840146795, -3.552280065915472],
            [18.437788111262353, -3.559338921438533],
            [18.437808736581278, -3.562699770680503],
            [18.437831819690828, -3.566461000349042],
            [18.438002027979298, -3.566550786846434],
            [18.441280637119519, -3.568279592186976],
            [18.447892752345275, -3.563640153120387],
            [18.454089959995837, -3.564059990797503],
            [18.455063497506909, -3.56482102055656],
            [18.462838972348131, -3.570901132190297],
            [18.469029960063661, -3.571779898992361],
            [18.481447775579614, -3.577918973008563],
            [18.487379879610025, -3.574430055306225],
            [18.493844621721856, -3.574081676638924],
            [18.502040159569717, -3.573640027161553],
            [18.507571676967192, -3.576165155582107],
            [18.51099984033085, -3.577730102942176],
            [18.52453008008732, -3.579710017614769],
            [18.525830040219816, -3.580579905300088],
            [18.532615584194339, -3.585108883332679],
            [18.534429424686806, -3.586319518556546],
            [18.540194541787365, -3.585579429480418],
            [18.541980000008405, -3.58535006244181],
            [18.547340039797941, -3.577359913706806],
            [18.549880561659691, -3.576431863978803],
            [18.552056092631602, -3.58223018475792],
            [18.552509999666579, -3.583439951952628],
            [18.559159919592787, -3.584079953312925],
            [18.565340040388328, -3.583350013692551],
            [18.58127383048528, -3.568519710724106],
            [18.587229839583713, -3.567330036981832],
            [18.597712242006551, -3.569570424438698],
            [18.60397991979622, -3.570910002846678],
            [18.615499920389638, -3.580729923199011],
            [18.618519960255117, -3.586689961353547],
            [18.622413568615279, -3.586975367076789],
            [18.629979840199859, -3.587529982471948],
            [18.63297647985048, -3.589813866232405],
            [18.635060303611702, -3.59167233083532],
            [18.642198927713689, -3.598038906805714],
            [18.646539839593164, -3.596180000453447],
            [18.656958541580888, -3.595260988523713],
            [18.65798999976651, -3.595170005369174],
            [18.663665226049886, -3.5981310196789],
            [18.666269233649409, -3.599489642170028],
            [18.667898028379842, -3.601435349869913],
            [18.674120159787972, -3.608870044057364],
            [18.675020337279676, -3.609109558807178],
            [18.684226044139244, -3.611558958645053],
            [18.699084531976474, -3.618036346768357],
            [18.711799919820177, -3.623580018105574],
            [18.713800054732872, -3.623428354817333],
            [18.715230000188672, -3.623319927567729],
            [18.721141568731699, -3.615919812502348],
            [18.721398560564797, -3.615870349421268],
            [18.726180120345632, -3.614950049868563],
            [18.733538463382985, -3.619554170877039],
            [18.736760159758393, -3.621569981274971],
            [18.743253649755971, -3.623509380116205],
            [18.745030079908414, -3.624039941984811],
            [18.746241457170733, -3.623881535018068],
            [18.748699919727922, -3.623560052174579],
            [18.763001678464438, -3.623843051741043],
            [18.765880984664239, -3.623900361940194],
            [18.77093866769879, -3.625479553910355],
            [18.779470329074833, -3.633470669501833],
            [18.781473914416548, -3.63600872432565],
            [18.783630000455815, -3.638739952246434],
            [18.784828829151948, -3.638557107593619],
            [18.785400119943414, -3.638469974490077],
            [18.785697703050928, -3.638426290607218],
            [18.786831167632055, -3.638260558618368],
            [18.792579959648965, -3.640749950342016],
            [18.798996822454466, -3.640058779551411],
            [18.799449840157319, -3.64000998386949],
            [18.805439880133665, -3.643879961568647],
            [18.810433074910616, -3.645588536949764],
            [18.815995481777421, -3.647490387653601],
            [18.816843650407435, -3.647547888565044],
            [18.828380160239178, -3.648329983441576],
            [18.832979880345249, -3.650830086792631],
            [18.838000142260011, -3.651111472118477],
            [18.847429920392482, -3.651640011244429],
            [18.856277943258764, -3.65689740664381],
            [18.859474447280306, -3.658796725016141],
            [18.861230999512173, -3.659838609202817],
            [18.862855917113833, -3.65967604899388],
            [18.868564734100605, -3.659100497963167],
            [18.883919879797183, -3.660830071321878],
            [18.903925772602928, -3.670355476892488],
            [18.907380645574953, -3.672860178381599],
            [18.917419188619277, -3.675474930739576],
            [18.931489920427659, -3.679139938816518],
            [18.933083869508248, -3.680919613684891],
            [18.936810000458411, -3.685079894429475],
            [18.947459880291241, -3.69123005972423],
            [18.950470901969563, -3.692974372196769],
            [18.954521295991199, -3.695320511242504],
            [18.96155876889388, -3.698014567273411],
            [18.963950040162779, -3.69892998113658],
            [18.968748684103677, -3.699175368198993],
            [18.975874362584122, -3.699539751737262],
            [18.988319880346801, -3.710259958300672],
            [18.995432839581149, -3.711617957477024],
            [19.000000080199801, -3.712488400811276],
            [19.000000080199801, -3.711500031076297],
            [19.01445012024703, -3.72191998984863],
            [19.018793857328081, -3.725049544010304],
            [19.019099531561384, -3.725269773810779],
            [19.024483735133714, -3.726839534907357],
            [19.041739919889075, -3.731870064054958],
            [19.043827800442092, -3.733411490611156],
            [19.048349880056463, -3.736750010395842],
            [19.053585312736285, -3.743344961122494],
            [19.05789995967346, -3.748779983008478],
            [19.063163915660187, -3.752359097691969],
            [19.06543008035608, -3.753899923706009],
            [19.073921899652625, -3.75644374231406],
            [19.083489839574113, -3.759309916046272],
            [19.092852618657734, -3.764742606528424],
            [19.095140159664123, -3.76606993188336],
            [19.098704884018971, -3.766433504924569],
            [19.10474999970543, -3.767050056410454],
            [19.120799879984851, -3.765550015850288],
            [19.13134427963703, -3.765626987092895],
            [19.141435287887198, -3.771008158357996],
            [19.146644280453256, -3.773785913205757],
            [19.148195660169158, -3.77413367053819],
            [19.155111479622818, -3.775683920777702],
            [19.156249120471649, -3.777301770813581],
            [19.159429493445678, -3.781699248288927],
            [19.164575097292012, -3.78444959773653],
            [19.178610120169573, -3.791950071659392],
            [19.20194999965954, -3.796939914308865],
            [19.217430000400832, -3.807380058111827],
            [19.218757947545999, -3.808282195117086],
            [19.219520159979748, -3.808800001625307],
            [19.229322529647639, -3.812079903224968],
            [19.230040359916458, -3.812320209454162],
            [19.231644829167323, -3.813538386855267],
            [19.24440983994732, -3.823230021923311],
            [19.25449434259821, -3.824855722985437],
            [19.259671957909713, -3.825690682071704],
            [19.262900159884403, -3.826660045455931],
            [19.275379919629074, -3.834609969258693],
            [19.27838420753605, -3.83846271221585],
            [19.282319999883608, -3.843510004332362],
            [19.29248148995098, -3.850974394013995],
            [19.294639919694841, -3.852559916347147],
            [19.302189840144653, -3.856750101003667],
            [19.313201997955129, -3.857104635722922],
            [19.320509879928029, -3.857339911472408],
            [19.352700000224708, -3.875959907871295],
            [19.356045161951087, -3.880628621579137],
            [19.356339960281232, -3.881040059425945],
            [19.368889919772116, -3.891250078687336],
            [19.372999950250492, -3.893119909915619],
            [19.377359999838767, -3.892460039329996],
            [19.378617308859873, -3.892839181424555],
            [19.381245603311424, -3.893630829553025],
            [19.382236099218431, -3.89376537819822],
            [19.383080040376704, -3.893880018589132],
            [19.388888517359433, -3.899675065215886],
            [19.395380576340735, -3.906152382947001],
            [19.406900264320463, -3.91341591726738],
            [19.421830080187892, -3.922830018901164],
            [19.425980160256596, -3.925449968322154],
            [19.441959839891542, -3.932460015219327],
            [19.451739960086488, -3.946789905357494],
            [19.453858764244856, -3.947334163973332],
            [19.455400080134606, -3.947730083334708],
            [19.458619919692314, -3.94613992516422],
            [19.462064622836998, -3.946390090759579],
            [19.476731262868906, -3.95162412464565],
            [19.477839959999329, -3.952019934572396],
            [19.481960383985559, -3.955186933068392],
            [19.497459959915197, -3.967099952359328],
            [19.501549920233526, -3.973570077889318],
            [19.514134989478968, -3.979445508804656],
            [19.525544102033709, -3.984771344882344],
            [19.533732758786499, -3.987499031031581],
            [19.534696288166977, -3.987820107416835],
            [19.537420319671622, -3.992439875163507],
            [19.53902848099829, -3.993236513468865],
            [19.545418440159356, -3.996401913568455],
            [19.548153360143552, -3.999180921085526],
            [19.550328900996963, -3.999275877419889],
            [19.554340319813328, -3.999450964324275],
            [19.55656694695864, -4.000932271271863],
            [19.560276360261351, -4.003400023683087],
            [19.564475482056366, -4.003544076314902],
            [19.568525399970905, -4.003683010218539],
            [19.571489190028235, -4.006462806423912],
            [19.574219879845735, -4.010160035610993],
            [19.582896713463246, -4.017219241465243],
            [19.583340120090853, -4.017579982069779],
            [19.58808996035901, -4.028200000140489],
            [19.592409041380456, -4.032703106103805],
            [19.596300120084756, -4.036759951644364],
            [19.604980079839464, -4.041870026202636],
            [19.613108126361695, -4.041063203597783],
            [19.615759919842748, -4.040799976094632],
            [19.623309840292531, -4.042229944749177],
            [19.629772989691375, -4.045092859394765],
            [19.633830120179312, -4.046889998606912],
            [19.656743025923173, -4.050672019390201],
            [19.659759839938477, -4.051169975623616],
            [19.664290079848882, -4.051920007580978],
            [19.670900040016303, -4.057940012177376],
            [19.684154799712804, -4.058362612040614],
            [19.688778405123973, -4.058510025845647],
            [19.698189839658312, -4.05512003997136],
            [19.706209920361523, -4.056090113880994],
            [19.71260999994259, -4.060039973444411],
            [19.730259502163602, -4.060610023497209],
            [19.731581506953169, -4.061637811338074],
            [19.734131467413626, -4.063620265218125],
            [19.755430895600927, -4.067432128000138],
            [19.757921176485482, -4.072510265442086],
            [19.758463882884609, -4.072624021843905],
            [19.760211822967804, -4.072988010107075],
            [19.764360000404725, -4.068640033067545],
            [19.769875147802797, -4.066139709554983],
            [19.774692440769005, -4.065940125453484],
            [19.780200000097825, -4.066190073517554],
            [19.784540160087396, -4.068069970725962],
            [19.797471207379679, -4.076139675485886],
            [19.801670039917163, -4.078759967017376],
            [19.804034421016311, -4.080988635814522],
            [19.811250000195447, -4.087790012248916],
            [19.820859840236754, -4.091299999671143],
            [19.825669529862395, -4.092249771517759],
            [19.828199880100179, -4.090429919680939],
            [19.829109959721254, -4.090489962740454],
            [19.833133311757898, -4.09075901447595],
            [19.839430079691372, -4.091180094077394],
            [19.841695614668268, -4.090469619145003],
            [19.845169919996504, -4.089380070143651],
            [19.846230782736349, -4.089428266841518],
            [19.850669999952292, -4.089629948580392],
            [19.856158969544644, -4.092199438075601],
            [19.873929959924688, -4.112100023193655],
            [19.880049960071513, -4.124329976814145],
            [19.886199839981334, -4.131729982953836],
            [19.890950039575593, -4.143490106747257],
            [19.897112023385539, -4.147008147006163],
            [19.90236995976155, -4.150010030201425],
            [19.915430040162914, -4.151240093389216],
            [19.924130159909218, -4.154740091014929],
            [19.933071955213077, -4.16247999551592],
            [19.938039866906319, -4.166780182943938],
            [19.939363119455823, -4.170831725252544],
            [19.941429959668255, -4.17715994309602],
            [19.944849960040926, -4.180400088436059],
            [19.945754451242621, -4.180694968501867],
            [19.949880293866673, -4.182039561479326],
            [19.951902257840771, -4.180252338547513],
            [19.958410080458709, -4.174500015665036],
            [19.965748981258347, -4.173850142788409],
            [19.968372501164158, -4.175264177888699],
            [19.973520000455768, -4.17803999311039],
            [19.977239507229001, -4.181293164951879],
            [19.980140039720652, -4.183830032630289],
            [19.982596719122011, -4.191800534925697],
            [19.982840040393114, -4.192589965292127],
            [19.983427296942132, -4.194446409603247],
            [19.985319617851051, -4.200428410828501],
            [19.98714322842055, -4.20206039157251],
            [19.989200160215393, -4.203899989847779],
            [19.996290000407573, -4.206470124621668],
            [19.997044623873808, -4.207273495046134],
            [20.000000160210305, -4.210419943935026],
            [20.000529753901201, -4.210979007518789],
            [20.001080159760619, -4.211560040853834],
            [20.002782465427398, -4.215359893828521],
            [20.004699959825547, -4.219640065042108],
            [20.009959920105885, -4.222199901729614],
            [20.013963399611807, -4.229037827445447],
            [20.014959960045285, -4.230739939144632],
            [20.017929960156184, -4.233290032779673],
            [20.018053050909668, -4.247248084789516],
            [20.018070000322432, -4.249170054085832],
            [20.029240080163245, -4.261430009715178],
            [20.030569920058731, -4.269719965594046],
            [20.033529840173799, -4.273650047451656],
            [20.038049863544515, -4.285869699358011],
            [20.037587909401235, -4.286235691236296],
            [20.035749959923173, -4.287689942734712],
            [20.032970039733137, -4.292739956725088],
            [20.033081369742952, -4.295054868259327],
            [20.033589959924214, -4.305630017824512],
            [20.037690000238339, -4.309789950687149],
            [20.043420119873744, -4.311439935877822],
            [20.044106517192457, -4.312943058997071],
            [20.045000160338773, -4.314900021228229],
            [20.04398531290105, -4.318741681663484],
            [20.040569999937535, -4.331670059411755],
            [20.042881100160571, -4.339906077798449],
            [20.043479880298019, -4.342039924030923],
            [20.043565836494285, -4.347206916790477],
            [20.043659880223089, -4.352859989836647],
            [20.045823218361658, -4.357268372181468],
            [20.046309840242632, -4.358259990194221],
            [20.047280039614122, -4.360239986882302],
            [20.048331976693273, -4.361305796808681],
            [20.051849879957206, -4.364870080603401],
            [20.061910079586387, -4.369759997125746],
            [20.064869999701489, -4.374149949170581],
            [20.06559397444682, -4.376712637934497],
            [20.066889090863302, -4.381296998463725],
            [20.069695988359634, -4.384653760860849],
            [20.071910160363522, -4.387300064198407],
            [20.074457291130816, -4.400256112994918],
            [20.074809959829878, -4.402049951802939],
            [20.085728303880305, -4.417028277723677],
            [20.087100156184981, -4.418910411498429],
            [20.093209920029153, -4.434369933036494],
            [20.089938308764992, -4.440264006540739],
            [20.088119879678086, -4.443540034209162],
            [20.088289372009271, -4.444050171324064],
            [20.092179960233423, -4.455759947756023],
            [20.090059919993219, -4.465410062121113],
            [20.092330080395502, -4.470949921327649],
            [20.099189880009732, -4.476050068328613],
            [20.104619374842056, -4.476324733827368],
            [20.109270925943392, -4.476561650328108],
            [20.111652958039574, -4.480343736156845],
            [20.114510039919253, -4.484880057706963],
            [20.12386010873994, -4.493671130706268],
            [20.124048764831073, -4.495038451710045],
            [20.124749880147398, -4.500119906038709],
            [20.12264354370685, -4.502207224190466],
            [20.119209840432827, -4.505609910312602],
            [20.112999839874295, -4.508569959849155],
            [20.111831693136729, -4.515813767175191],
            [20.111108656232499, -4.520291100147682],
            [20.109221108072692, -4.522014905947781],
            [20.102349960041462, -4.528289956132752],
            [20.095400185168387, -4.540909927954923],
            [20.095176764275749, -4.540924248169267],
            [20.085540032268131, -4.541541920163383],
            [20.084874670798449, -4.555674492786634],
            [20.084760071819328, -4.558108604966177],
            [20.081853119068356, -4.563672409374115],
            [20.081286512991081, -4.564752819453892],
            [20.078619839815673, -4.56693011065013],
            [20.076920424927486, -4.568323783324811],
            [20.073449879946999, -4.571169934935333],
            [20.069259840119507, -4.58402003853798],
            [20.062090080409757, -4.595020085699534],
            [20.063019302231243, -4.598487938967873],
            [20.063879999664511, -4.601700046332105],
            [20.05929555271489, -4.611913232944804],
            [20.056460040283515, -4.618230086508916],
            [20.066709959609128, -4.630709994391435],
            [20.068970022049303, -4.636939933862684],
            [20.062048545904293, -4.645638008199083],
            [20.061541765828313, -4.647618239179137],
            [20.060870930025285, -4.650236466656334],
            [20.064940547994006, -4.661990753011431],
            [20.065021853612066, -4.662079597846158],
            [20.070870119673632, -4.668470091219665],
            [20.06944992004037, -4.676510015481089],
            [20.069200079695232, -4.679729983199104],
            [20.067586928227154, -4.681483389949642],
            [20.06666999985034, -4.682480037661443],
            [20.062370392507638, -4.68305500163209],
            [20.056798902774982, -4.683801081384128],
            [20.054490120205394, -4.68654995513975],
            [20.054909481627792, -4.68933344776192],
            [20.055149974104072, -4.690929702924464],
            [20.051889839715994, -4.700800045660115],
            [20.053363921198319, -4.704140067900081],
            [20.053730159848065, -4.704969901624371],
            [20.058230159771082, -4.713559924912236],
            [20.058919920382227, -4.714889982023578],
            [20.059542786149084, -4.71846605600714],
            [20.060039879691324, -4.721320022256863],
            [20.057903067904782, -4.726102023086468],
            [20.056550039796882, -4.729129964480895],
            [20.055117266444586, -4.730788471777907],
            [20.049630120432273, -4.737140082728414],
            [20.050759995345501, -4.740369531867334],
            [20.060579203035086, -4.748479470192595],
            [20.059496840017243, -4.751771246209335],
            [20.058009839862823, -4.756290020690598],
            [20.058440040357436, -4.762500015385307],
            [20.055610080412819, -4.776980025667967],
            [20.055810412806025, -4.782270191567736],
            [20.057329622953272, -4.783016647772669],
            [20.069079840194469, -4.788790030069988],
            [20.077226848355732, -4.808810766654356],
            [20.07837000036886, -4.81161994013607],
            [20.079447216040101, -4.812830026668913],
            [20.084450039858574, -4.818449905232481],
            [20.085125943058127, -4.82012559811214],
            [20.085890040157324, -4.822019935138494],
            [20.085051276888347, -4.826558635241711],
            [20.084700742586396, -4.828455429447707],
            [20.08549751680237, -4.832265075771821],
            [20.086049880090798, -4.834900009940382],
            [20.089131547978017, -4.841583553123449],
            [20.091260159942657, -4.846200063201314],
            [20.09125240748174, -4.848499628759539],
            [20.091239999951028, -4.852179905461318],
            [20.102609458174229, -4.87111351370023],
            [20.10117002201746, -4.883070980488475],
            [20.102050079941741, -4.889750094601024],
            [20.102789880307469, -4.891550094582035],
            [20.107940040408948, -4.904049939008001],
            [20.110089960412108, -4.931440092166603],
            [20.115223180083959, -4.9590653944263],
            [20.119089896477778, -4.965539833089357],
            [20.122697026703907, -4.96784752189351],
            [20.129609879920515, -4.972269922955213],
            [20.130329518497991, -4.974756755136209],
            [20.13140988006937, -4.978490107216643],
            [20.134776669634533, -4.984466732914587],
            [20.143239839860041, -4.999490062457482],
            [20.143274795104364, -4.999786529463478],
            [20.143299959610424, -4.999999953011676],
            [20.14394754881053, -5.004872198715558],
            [20.144120007378767, -5.006170051764929],
            [20.143672707452737, -5.007441638186543],
            [20.139919919894837, -5.018109975686111],
            [20.139135813721001, -5.028600254354521],
            [20.138939999853662, -5.031219948826714],
            [20.1398376279266, -5.035366664024453],
            [20.14018194409018, -5.035787685208217],
            [20.146449959646354, -5.043449974018935],
            [20.150989920226486, -5.052909892176483],
            [20.155472946482213, -5.054595362310856],
            [20.164047125120611, -5.057818958722754],
            [20.168610120301246, -5.061979928804793],
            [20.1696007662269, -5.065735564119166],
            [20.170190159867978, -5.067970000515483],
            [20.168290529367578, -5.080841157462043],
            [20.169650160092804, -5.084300004274533],
            [20.175609473194864, -5.087047096343777],
            [20.179260000134079, -5.088729890113877],
            [20.182219920249178, -5.093119892211254],
            [20.182590013569801, -5.096602849072736],
            [20.182659839616854, -5.097259983701483],
            [20.179169999722411, -5.109080001043159],
            [20.17846008001797, -5.111499948719805],
            [20.179471747419601, -5.120901345801151],
            [20.179550159564112, -5.121630022954732],
            [20.183199840290325, -5.12601997690374],
            [20.183310611548013, -5.126131863294961],
            [20.186174444267046, -5.129025824774708],
            [20.190329211744906, -5.144352145648164],
            [20.190670514060692, -5.14561099162351],
            [20.193410160081587, -5.149770000412103],
            [20.193989786340588, -5.153716105959337],
            [20.19428999971527, -5.15575995765178],
            [20.193812480463048, -5.15699262736988],
            [20.190110558211501, -5.166548694034942],
            [20.187540000279899, -5.174579909569925],
            [20.187884301172094, -5.175551655809905],
            [20.188439999905174, -5.177120041853003],
            [20.195344148446676, -5.182654624569842],
            [20.199416797331139, -5.185919365485112],
            [20.199430079820917, -5.1859300125947],
            [20.200319164017198, -5.188681779966925],
            [20.199390120062166, -5.19074992112593],
            [20.19250007956218, -5.192089954580664],
            [20.189949839725696, -5.193919977548171],
            [20.191343129426304, -5.197037570346896],
            [20.192010120439921, -5.198530008728138],
            [20.1970300472831, -5.203160138477607],
            [20.197190823261082, -5.203550771618633],
            [20.198170080345538, -5.205930037716386],
            [20.196983643908766, -5.211048923101357],
            [20.196519840134332, -5.213049992127942],
            [20.197020756906419, -5.214371722767426],
            [20.198789999638283, -5.219040059836209],
            [20.198990160453246, -5.226639958159449],
            [20.195140326098578, -5.230839537882319],
            [20.194589879814995, -5.231439987669167],
            [20.187229832673545, -5.234390996577101],
            [20.186290079901983, -5.238990019995657],
            [20.190620159895758, -5.244759986497155],
            [20.191954831829129, -5.250396085524917],
            [20.192640119728463, -5.253289925088139],
            [20.201540040065325, -5.263000081217546],
            [20.201939999674217, -5.264350007652595],
            [20.20366859184286, -5.270158046852577],
            [20.203800000995862, -5.270600203515587],
            [20.199849840095332, -5.278169986131833],
            [20.183500079716154, -5.289119971587096],
            [20.176390080430679, -5.287929996131361],
            [20.172930120299224, -5.290440051226229],
            [20.171155783221383, -5.298058343301318],
            [20.171059920404161, -5.298469935491921],
            [20.181080160274554, -5.313719890411281],
            [20.17529999998624, -5.321510085702581],
            [20.177281677214808, -5.325132608508034],
            [20.177570340051574, -5.325660106134971],
            [20.179879131604302, -5.327583004741199],
            [20.183969879745153, -5.33099000622686],
            [20.18121304625792, -5.331199732282037],
            [20.17944584000681, -5.329858140311516],
            [20.174818784166629, -5.326340333105209],
            [20.167229880426774, -5.327910022126958],
            [20.164034180397369, -5.33057331004243],
            [20.162850120004517, -5.331560099612693],
            [20.157329837836343, -5.333600079468103],
            [20.155479112518321, -5.336448876519293],
            [20.153379959905095, -5.339680057987217],
            [20.152394266391603, -5.341201293939932],
            [20.149001033119447, -5.346438096304979],
            [20.154960000370124, -5.346699945541578],
            [20.156418806001042, -5.347732057389763],
            [20.157250080913844, -5.348321111406065],
            [20.15746992022342, -5.350160064284488],
            [20.146219919966704, -5.350329992438135],
            [20.145745668785526, -5.351138009923464],
            [20.144601829561182, -5.353086851031448],
            [20.149989840193712, -5.374969950959033],
            [20.149742039922579, -5.379101149811394],
            [20.156379926915566, -5.382590151286171],
            [20.157289247460223, -5.384438692385585],
            [20.148109919628958, -5.383700098807782],
            [20.145350160328853, -5.385979911428438],
            [20.142180171879538, -5.392822261110496],
            [20.141629919632024, -5.394009961299901],
            [20.14260983967317, -5.400309907271284],
            [20.142740046880359, -5.401149234835322],
            [20.14234837961984, -5.402955958338338],
            [20.14014995957449, -5.413089915038376],
            [20.142640079660595, -5.419780072183186],
            [20.143618954062752, -5.420588025825483],
            [20.145160080407987, -5.421860055779952],
            [20.150669880135133, -5.422120030149615],
            [20.165540039782883, -5.412719951830829],
            [20.168629920068437, -5.41323004223113],
            [20.167893458740618, -5.414641022773216],
            [20.167319879940141, -5.4157399355366],
            [20.16201891516036, -5.417870910434599],
            [20.156776018378821, -5.422486142477427],
            [20.154419999696653, -5.424560093850328],
            [20.147199840007882, -5.426020000285022],
            [20.146961108229551, -5.426443994400815],
            [20.14603992004167, -5.428080046534437],
            [20.147711405409364, -5.437547636657916],
            [20.149170120310444, -5.445809930382278],
            [20.146780079733507, -5.463050048049139],
            [20.147344254071267, -5.464835598789875],
            [20.150660160363774, -5.475329973063855],
            [20.150942856590422, -5.476213767381973],
            [20.151299880322011, -5.477329928842727],
            [20.153092685863776, -5.479645159369744],
            [20.155280039563145, -5.482469897638858],
            [20.164359959825074, -5.481319952285515],
            [20.166192509529921, -5.482709703951127],
            [20.17377000017412, -5.482059972008097],
            [20.178587954300358, -5.483699321751283],
            [20.177612813296502, -5.4846631172967],
            [20.176509959707037, -5.485750010752644],
            [20.170429681265425, -5.48605895343779],
            [20.164110120378233, -5.486380054576487],
            [20.151719999922495, -5.484470008326023],
            [20.150330040276661, -5.486990005020692],
            [20.15086133717335, -5.488071737113466],
            [20.152820218753241, -5.49206114587891],
            [20.153239919738809, -5.500810059483877],
            [20.15642015976217, -5.506799958366291],
            [20.152600943585639, -5.508984129969503],
            [20.150439840455519, -5.510220038992194],
            [20.147429879687536, -5.514800028978655],
            [20.144810159655382, -5.532730006900881],
            [20.145259451146408, -5.534806673124001],
            [20.148469920377394, -5.534369925165647],
            [20.152006313664817, -5.531656251109316],
            [20.153069999809571, -5.530840022819285],
            [20.153153243093705, -5.530778855404746],
            [20.1535579574854, -5.530481471110114],
            [20.155839840003807, -5.531409924666415],
            [20.155809960240816, -5.53692988840946],
            [20.153009880059194, -5.545659978457913],
            [20.150939879573571, -5.547940062812325],
            [20.155065106851648, -5.551464399967128],
            [20.156640120344324, -5.552809987940853],
            [20.156744412952175, -5.554336729290864],
            [20.156860080028174, -5.556029974943653],
            [20.155037017431006, -5.5605134252401],
            [20.154530452052406, -5.561760746727916],
            [20.155439880394916, -5.564300044919791],
            [20.153706157049385, -5.567886613734052],
            [20.153109959568361, -5.569119966894182],
            [20.153698519572831, -5.57192768145208],
            [20.154459960353737, -5.575560100319908],
            [20.16017865611369, -5.579969036722431],
            [20.163390119779692, -5.580680012703149],
            [20.172750120374154, -5.59039003637272],
            [20.17256395980289, -5.59068626498183],
            [20.170448306934546, -5.594048851664274],
            [20.170438180226334, -5.594057039011418],
            [20.166980040081633, -5.596109967870884],
            [20.165360039857816, -5.599780093158106],
            [20.165820390508308, -5.600435950653136],
            [20.166491326922682, -5.601390096904028],
            [20.173381008994824, -5.601660759157316],
            [20.17909122465851, -5.606615359462912],
            [20.181390120370079, -5.608610037244302],
            [20.181819959741958, -5.61390004594204],
            [20.19072946061133, -5.623149484164086],
            [20.189790762461925, -5.626827013733728],
            [20.188768817435133, -5.627968507878477],
            [20.186309879669174, -5.630709950872136],
            [20.182714640442455, -5.6418053707271],
            [20.182590000095079, -5.642190026059049],
            [20.184520706016109, -5.648351071715756],
            [20.186200080388613, -5.653710044848778],
            [20.1841099199114, -5.6578299561795],
            [20.179725929322515, -5.658914073637026],
            [20.177679959669046, -5.659420020749507],
            [20.176059960343562, -5.661250041020654],
            [20.176061300629964, -5.661270061991072],
            [20.176260120260228, -5.664240042958913],
            [20.181149478773449, -5.670295904232713],
            [20.181290023792936, -5.670470252525703],
            [20.18091898364797, -5.676119894821198],
            [20.180549880270782, -5.681739989659342],
            [20.18188008039067, -5.69048994057535],
            [20.180260080166853, -5.692550125447994],
            [20.176359840443286, -5.692759945299867],
            [20.176322482205563, -5.692732560165617],
            [20.17224000036197, -5.689739966134947],
            [20.168099983221083, -5.690640105416763],
            [20.167959837053612, -5.691132534631905],
            [20.167379999690525, -5.693169901492515],
            [20.171704520909323, -5.700523358410634],
            [20.17172015698517, -5.700549996303357],
            [20.171210039667912, -5.709750081491859],
            [20.173019746113432, -5.715738722501702],
            [20.170479959971907, -5.718940021948392],
            [20.170799900350215, -5.719730376136851],
            [20.171159999913328, -5.7206199363995],
            [20.171599920179336, -5.721710048090617],
            [20.168600191222428, -5.726520783299671],
            [20.168851408684883, -5.727767751039427],
            [20.171059835064206, -5.738729553378576],
            [20.165969880053058, -5.746290000745736],
            [20.160450000330115, -5.747180125498981],
            [20.158616172322599, -5.749629218936848],
            [20.155828094531458, -5.753354974825218],
            [20.155819029631914, -5.753377248218113],
            [20.152090079768428, -5.762539941390383],
            [20.154075367326097, -5.765869168486804],
            [20.154151997213098, -5.765998136233589],
            [20.149300079582598, -5.771720054541352],
            [20.139630119790915, -5.775580006698465],
            [20.139104486772084, -5.775967093874775],
            [20.137240080112303, -5.777340080117041],
            [20.12579262027467, -5.785847872188625],
            [20.124108286303485, -5.787541433640762],
            [20.114939648424112, -5.797280988061249],
            [20.110709879704856, -5.814970005797544],
            [20.111191889635165, -5.817799214327422],
            [20.112710039770366, -5.826710065052902],
            [20.112544771317669, -5.831097376703019],
            [20.112450120327761, -5.833610013576165],
            [20.10969709659566, -5.836719892623941],
            [20.109210951720073, -5.837269051095022],
            [20.100377876820129, -5.839256472396696],
            [20.097249839694598, -5.839960005634009],
            [20.094672677349003, -5.843739060937577],
            [20.091463169315382, -5.848445327386873],
            [20.088427260710443, -5.849292951084502],
            [20.085021390837149, -5.850239586699629],
            [20.079029880318689, -5.854109980837817],
            [20.071884509868898, -5.855920447586271],
            [20.065690079809194, -5.857489964531488],
            [20.058941783579584, -5.85682064869634],
            [20.055809880105048, -5.856510017079663],
            [20.054009232270857, -5.857544217592483],
            [20.051439840352518, -5.859019942162984],
            [20.049580079779361, -5.86313995822932],
            [20.049934626855684, -5.866942409947124],
            [20.050009864354017, -5.867749305139257],
            [20.04297011961194, -5.883339981084698],
            [20.041580301899916, -5.886404271534532],
            [20.041409879812399, -5.886780019938216],
            [20.034250032113487, -5.893640930572713],
            [20.034266090397537, -5.893722354731958],
            [20.03693003988101, -5.907229962943882],
            [20.033459999753727, -5.912720080095825],
            [20.026976018423458, -5.917854876735992],
            [20.026540080389118, -5.918200102889858],
            [20.028110039960019, -5.925110016489792],
            [20.022750000170518, -5.939340071101909],
            [20.021237172553345, -5.94157686999811],
            [20.020430160238085, -5.942770078208476],
            [20.012839919805081, -5.943420047120921],
            [20.00823011970321, -5.946150052149079],
            [20.007500040007173, -5.952819954522449],
            [20.005753580347559, -5.957426850229909],
            [20.00401991988409, -5.961999943715917],
            [20.000518761217087, -5.965980390972552],
            [20.000000160210305, -5.966569982873054],
            [19.993428274237896, -5.965611807004464],
            [19.98784880656719, -5.970579336456844],
            [19.986500160441231, -5.971780060928232],
            [19.980989999591351, -5.971060042267043],
            [19.976397600754819, -5.970572261788067],
            [19.976262514797362, -5.970681797725319],
            [19.973859840314244, -5.972630030446321],
            [19.968801277829037, -5.972599924993029],
            [19.966390390947623, -5.977165226536034],
            [19.960449840058573, -5.988419997429408],
            [19.953055272457402, -5.996188336557453],
            [19.943083576646622, -5.993011660300002],
            [19.938369960043989, -5.991510040787993],
            [19.930330079573618, -5.991000113053675],
            [19.918809821163702, -5.997140013369446],
            [19.918010361883336, -5.997172426994615],
            [19.908699839596405, -5.997549912794346],
            [19.903129920118875, -6.007629956454683],
            [19.900984574337102, -6.009566954233536],
            [19.900351256671915, -6.010138765428149],
            [19.898631520993689, -6.009342025493495],
            [19.897831271195873, -6.008970475485413],
            [19.896064490746223, -6.006834842399953],
            [19.890759164645697, -6.000421359362966],
            [19.885730039952339, -5.995790008115913],
            [19.883880000048904, -5.997160077962176],
            [19.88543015985265, -6.007750041273096],
            [19.884957944253859, -6.00899651481455],
            [19.884037541193539, -6.01142189013272],
            [19.868799959814833, -6.024209997662521],
            [19.860660217227558, -6.029511372261668],
            [19.857960000061134, -6.031269999097959],
            [19.854960120187247, -6.032860063637892],
            [19.842344752563939, -6.032994978461645],
            [19.840950000406025, -6.033009894154232],
            [19.83542003978895, -6.034589916531546],
            [19.832420159915095, -6.037559974847488],
            [19.83089508017575, -6.041818891406497],
            [19.829379960057988, -6.046049962224995],
            [19.82919563115157, -6.046209671142917],
            [19.818299879730542, -6.055650051599811],
            [19.815080040172834, -6.056540031933978],
            [19.809969839830142, -6.065939933640736],
            [19.808004852401247, -6.067958901279628],
            [19.806689879623754, -6.069309993282883],
            [19.804420080344208, -6.071649937001305],
            [19.790160120217838, -6.075000068734958],
            [19.790153298411582, -6.07501191510265],
            [19.784350080166533, -6.085089940889877],
            [19.773529920180025, -6.088250031663342],
            [19.77211771375617, -6.090174602152794],
            [19.767984804085788, -6.095803372043052],
            [19.76502806670177, -6.098134921029582],
            [19.763359920371986, -6.099449977009542],
            [19.752453842816752, -6.099923729634781],
            [19.74934000985246, -6.100058638244773],
            [19.749095297989285, -6.100210582695358],
            [19.748450160291586, -6.100610117237329],
            [19.746203016523502, -6.10201367221383],
            [19.744959960172711, -6.102790077235118],
            [19.743849435869024, -6.106865858945365],
            [19.740020039983687, -6.120920043156654],
            [19.738180080076017, -6.12274995711327],
            [19.728290159702212, -6.123379996449809],
            [19.725289919603924, -6.125429948757724],
            [19.719690120363371, -6.140569960323052],
            [19.717481337352908, -6.141917229882093],
            [19.716689880265086, -6.142399985790667],
            [19.708880040372694, -6.142580066424445],
            [19.706109839954024, -6.144860017603192],
            [19.695440160354035, -6.161810075311978],
            [19.693559879564845, -6.169610031642799],
            [19.697399861197479, -6.180210534294015],
            [19.696407041348845, -6.184097493946772],
            [19.695521229715158, -6.187565488040759],
            [19.690144814536332, -6.194863448190397],
            [19.689960310458449, -6.195113792404689],
            [19.687959833287625, -6.204950598236931],
            [19.686411359621665, -6.21256486365715],
            [19.684474882923251, -6.216243361529083],
            [19.680137280437314, -6.224482903810751],
            [19.681955280129507, -6.227942957750761],
            [19.685347551306005, -6.228735372578831],
            [19.68700643959847, -6.229122878962147],
            [19.688275932469779, -6.231703636878567],
            [19.68904851595348, -6.23327404811089],
            [19.695913199707896, -6.239778951291889],
            [19.695486247521355, -6.249534788967664],
            [19.69696616805302, -6.255394732288669],
            [19.68867144002812, -6.268402890862282],
            [19.688204186722995, -6.271345021246886],
            [19.687898160350098, -6.273271949836015],
            [19.688815590885152, -6.275943261968351],
            [19.689480360365081, -6.277878883420509],
            [19.697710314468072, -6.285516970940988],
            [19.695585240069033, -6.295389939526325],
            [19.68730919969699, -6.295568892958865],
            [19.685907429001784, -6.299468762180883],
            [19.687088380325445, -6.303862374399841],
            [19.688383440148044, -6.308679979218993],
            [19.686099314536346, -6.313305912855113],
            [19.684196280319345, -6.317160009156263],
            [19.686475440044152, -6.320393026874367],
            [19.688538469603159, -6.321094357057873],
            [19.690605360121229, -6.321796998521724],
            [19.692461343278627, -6.324304220327935],
            [19.694709353022613, -6.327341008210521],
            [19.694329016212787, -6.327867029559314],
            [19.687759185585737, -6.336953006669368],
            [19.687140114302654, -6.336914933852874],
            [19.683622440109115, -6.336698955656338],
            [19.678042975133359, -6.340687743704108],
            [19.676929320200927, -6.341483896866599],
            [19.660362160336486, -6.34437013486963],
            [19.657939361794394, -6.345442760193921],
            [19.655752319810411, -6.346411010095227],
            [19.653510856988206, -6.348445895946423],
            [19.64720124045121, -6.354173964138396],
            [19.634536440334386, -6.358003007261998],
            [19.620100079832323, -6.355516765323773],
            [19.610274239880969, -6.354279640674419],
            [19.597647239973007, -6.351009761213825],
            [19.587830400242506, -6.347352256944583],
            [19.574506080400326, -6.34270976872644],
            [19.565731079786872, -6.342148418021238],
            [19.558360799936022, -6.341566468862585],
            [19.552398480172673, -6.339926296913049],
            [19.544340600158964, -6.335205465862088],
            [19.537332120382068, -6.331506113140702],
            [19.529629199771414, -6.325742714534111],
            [19.524719879794223, -6.324086907472847],
            [19.521211319907597, -6.323447439122868],
            [19.517358239939789, -6.321084266248062],
            [19.514211840351518, -6.317327670478068],
            [19.503598833666146, -6.305219392724603],
            [19.499699880330059, -6.303590031026642],
            [19.492560982241891, -6.305379826007773],
            [19.49047991990188, -6.307200021008377],
            [19.47758156230277, -6.30267595867953],
            [19.475805239948183, -6.302052915761321],
            [19.473194721359466, -6.299815396531173],
            [19.472831449845096, -6.299504028925402],
            [19.471366065851367, -6.294779594714091],
            [19.469902177552569, -6.290059939307611],
            [19.467350634260598, -6.289020032842709],
            [19.463022359880554, -6.287255996824553],
            [19.460611625712712, -6.28481430125268],
            [19.459367316212102, -6.283554005150004],
            [19.456844400431596, -6.282617978239752],
            [19.454540399594258, -6.283752990299241],
            [19.451559262170477, -6.282353939895059],
            [19.449490511241422, -6.282110756923353],
            [19.445358240273201, -6.281625019841984],
            [19.440502200273858, -6.286420866437681],
            [19.429662239621862, -6.292328015251991],
            [19.427448903949507, -6.296368611160813],
            [19.425625199955242, -6.299697883622517],
            [19.423387439988637, -6.303782953889081],
            [19.414028159843014, -6.330620006006449],
            [19.410398279782321, -6.337539377655833],
            [19.408450680144046, -6.342235827041766],
            [19.406152079978188, -6.346937427866129],
            [19.40295311996265, -6.358048322288408],
            [19.40135903972805, -6.36204802675749],
            [19.399760280169104, -6.367430411098628],
            [19.398518639563168, -6.371078993837856],
            [19.396396799997479, -6.375431969842821],
            [19.393575119824849, -6.379103957169026],
            [19.39075416010105, -6.382602905742911],
            [19.386532440286754, -6.385085611408869],
            [19.382664960324938, -6.386698772981928],
            [19.378271879683691, -6.387973967410027],
            [19.370892959836425, -6.389812068488618],
            [19.365972840312924, -6.39126778614758],
            [19.362110760124295, -6.391325098190956],
            [19.35877536039014, -6.391374708591908],
            [19.352287079722895, -6.389569567695256],
            [19.3473846004166, -6.386012459625396],
            [19.342479959763754, -6.383146659382096],
            [19.33721712038292, -6.382187568091727],
            [19.330486226317017, -6.3836368883943],
            [19.331964360099583, -6.367784864773062],
            [19.331363168883893, -6.353757195754472],
            [19.323999359598069, -6.354857992904702],
            [19.320677102216482, -6.334835673445569],
            [19.314302400042223, -6.325137998228176],
            [19.314273759954325, -6.324497343890767],
            [19.313616239878741, -6.309788959512602],
            [19.313293319788595, -6.302599979608348],
            [19.312348508603705, -6.300591559541791],
            [19.310798160153738, -6.297295907715568],
            [19.304196422266152, -6.289678510031639],
            [19.302582240430404, -6.287815974160035],
            [19.2991791598261, -6.280665917238371],
            [19.297857240376487, -6.271690854803415],
            [19.298372385564399, -6.262958001863],
            [19.296823516639719, -6.261388324486941],
            [19.294718400111329, -6.259254918434189],
            [19.301418959866712, -6.241213121034996],
            [19.304769240193586, -6.232191986592077],
            [19.305553320316278, -6.217251884736998],
            [19.310157360420561, -6.215902989044061],
            [19.312036760860764, -6.213431330809912],
            [19.313635320095354, -6.211329006491979],
            [19.314025179047217, -6.211760018079261],
            [19.316145239948654, -6.214103857577549],
            [19.317763927733843, -6.214239398457246],
            [19.319132159827912, -6.214353966886404],
            [19.320784667386931, -6.210684993029961],
            [19.321670160118678, -6.208718969459493],
            [19.32402255409869, -6.203501090106066],
            [19.330084440433161, -6.190054890956296],
            [19.334713191394265, -6.184797112395786],
            [19.341175320306942, -6.180700921051262],
            [19.355455440424937, -6.175506866568345],
            [19.359735548936072, -6.173324593567963],
            [19.3683664804392, -6.16892396601415],
            [19.381996440378725, -6.157516931610481],
            [19.381451362427264, -6.153728045828569],
            [19.381334426930092, -6.152914936793052],
            [19.382742360068153, -6.148324900069406],
            [19.385205789410527, -6.146867249946577],
            [19.394273160207941, -6.141501906795064],
            [19.396373399782657, -6.136457981686661],
            [19.395996278941539, -6.134101825784582],
            [19.395710129590917, -6.132314886324298],
            [19.391130399694852, -6.12975571977694],
            [19.391608430986782, -6.126768427572659],
            [19.392086119122258, -6.123783256584185],
            [19.386348479689616, -6.12236594773591],
            [19.365194159963384, -6.124527002531607],
            [19.356024240188123, -6.120787977577942],
            [19.352879259937968, -6.120690605503714],
            [19.349918279810858, -6.120598929500439],
            [19.33792994883223, -6.120227080411873],
            [19.337185440396112, -6.120203987632317],
            [19.330742159934733, -6.121540945778146],
            [19.321026480386671, -6.13159391367596],
            [19.315265400315003, -6.134084995104677],
            [19.30744940336961, -6.134722890893106],
            [19.29814739980652, -6.131139489258289],
            [19.287778319856795, -6.127268448175815],
            [19.275402959619498, -6.122209154286439],
            [19.263892679695736, -6.117447453459843],
            [19.256422320335719, -6.113878792933215],
            [19.251836639999215, -6.111204656392549],
            [19.243168200239719, -6.109113612705011],
            [19.235045880477418, -6.108503985398368],
            [19.228425840314202, -6.105825341080579],
            [19.224400319744461, -6.104040346947777],
            [19.22047343958284, -6.098110992841514],
            [19.217169359611024, -6.093189942999456],
            [19.210228199581511, -6.100500984664127],
            [19.207471912269988, -6.104850633417306],
            [19.205585280391748, -6.10782787383947],
            [19.205774380250649, -6.115571970845507],
            [19.205950319790603, -6.122777014998124],
            [19.201557940733554, -6.131219335402466],
            [19.201063320253294, -6.13217000655976],
            [19.189012320105519, -6.147953989454681],
            [19.18371196618013, -6.164254005430607],
            [19.182447360143964, -6.168142934911204],
            [19.182394440390556, -6.176418863023788],
            [19.178644680155177, -6.182393380886518],
            [19.173357359886239, -6.184750202503144],
            [19.163732400300418, -6.186209726793544],
            [19.157580720166784, -6.188268750102111],
            [19.150493040422827, -6.19299021221568],
            [19.144603440180081, -6.196233862469371],
            [19.132864200351648, -6.194704848724868],
            [19.124202055087348, -6.187457307624551],
            [19.123722153503021, -6.187055724605818],
            [19.116812519848377, -6.179595426206666],
            [19.111390199860239, -6.175439139193442],
            [19.106421839907647, -6.176612549875347],
            [19.101085200332964, -6.181041707633295],
            [19.09798812005041, -6.189028250846132],
            [19.096889759833989, -6.198499245927933],
            [19.096627679943097, -6.209452461264527],
            [19.095394680231905, -6.212410246711691],
            [19.090419120282309, -6.213879727933362],
            [19.086329520188421, -6.214758869467004],
            [19.082233080321963, -6.215934341942259],
            [19.076931720283422, -6.218883311963515],
            [19.072998000349202, -6.225387826795136],
            [19.069603559741317, -6.233669651548278],
            [19.066151880280138, -6.244319898648599],
            [19.063940759853292, -6.25171625102656],
            [19.061417880005372, -6.259999983054938],
            [19.05923520024043, -6.266212158091214],
            [19.05536555983036, -6.270052429237501],
            [19.052119440059034, -6.272117747723041],
            [19.045712159582671, -6.272696013157105],
            [19.040647458010795, -6.273158900094377],
            [19.032316560219297, -6.27385128993349],
            [19.024165799795096, -6.274425792503716],
            [19.013378759794808, -6.275882736040051],
            [19.005766560044691, -6.278234653226715],
            [18.997821360208629, -6.282362170814709],
            [18.9934059600258, -6.284720864528479],
            [18.99012455982, -6.288266320119245],
            [18.982711079987133, -6.294467226330314],
            [18.977919839960816, -6.30037786520221],
            [18.972583200386136, -6.30480703710677],
            [18.969620759598342, -6.307168852527593],
            [18.962866079940362, -6.310114792725781],
            [18.955558799838684, -6.31187525543392],
            [18.948903480139325, -6.310676715281358],
            [18.944020080151386, -6.308297898679502],
            [18.935217360223195, -6.299268863618642],
            [18.934257239949204, -6.298637963409142],
            [18.931753440317966, -6.296992995771435],
            [18.931963319107659, -6.294232937783145],
            [18.936073367552378, -6.290524917508566],
            [18.93521137834172, -6.288126873368978],
            [18.933023159564708, -6.28203990284126],
            [18.93322552664204, -6.279734601441881],
            [18.933447239837296, -6.277208903474591],
            [18.931143828294786, -6.274114451742857],
            [18.930893402248103, -6.273777996946509],
            [18.931522314575123, -6.265495928246591],
            [18.9301143598775, -6.261596879837509],
            [18.934667280452221, -6.255586906472658],
            [18.926296200119758, -6.242310005125494],
            [18.922832280214532, -6.240033884508526],
            [18.92507148018052, -6.231970909523284],
            [18.923433480413362, -6.2278438841246],
            [18.916525440370069, -6.226281998387281],
            [18.90904788011472, -6.227402443553134],
            [18.901407239702696, -6.230938439788375],
            [18.894298680416636, -6.236547934510046],
            [18.88519103994167, -6.240672919141492],
            [18.879018120041465, -6.243619956760367],
            [18.873439919893624, -6.245976320750273],
            [18.867330720191461, -6.246259198626108],
            [18.861157079842382, -6.23706855359113],
            [18.855791640279691, -6.23054393998116],
            [18.852134040005932, -6.225503203629453],
            [18.847073520091715, -6.218387398299276],
            [18.841686839864156, -6.212750832748008],
            [18.837781200367402, -6.205933339387062],
            [18.834704999626986, -6.2008939769139],
            [18.83253600030547, -6.194376434383489],
            [18.831791879941569, -6.189045988678488],
            [18.832784040426795, -6.184015420851169],
            [18.838588679806623, -6.18432395412954],
            [18.842593319935862, -6.186997001635663],
            [18.848617919897841, -6.190266490343856],
            [18.854862120217529, -6.196496879448631],
            [18.860298479975274, -6.200061036307287],
            [18.865500840279587, -6.201256428960583],
            [18.869972759765165, -6.196529487643648],
            [18.870163920359307, -6.188536609677127],
            [18.870411959582299, -6.178175659971108],
            [18.870893279606474, -6.158045692673187],
            [18.871275599896425, -6.142060070479135],
            [18.871842240109686, -6.130515730626438],
            [18.871990920272353, -6.124299070708949],
            [18.868893479765362, -6.120147721737623],
            [18.863911080043199, -6.121913307351167],
            [18.860586840079787, -6.127234939231415],
            [18.85694400002447, -6.133740058208342],
            [18.852734160429815, -6.139651809991638],
            [18.849438720454415, -6.143789208350601],
            [18.845611200251419, -6.145853416431858],
            [18.837850320338603, -6.142284052016812],
            [18.833030639650378, -6.137240851009378],
            [18.828870120259769, -6.128942623102929],
            [18.829302120079898, -6.123022687545255],
            [18.838253520170724, -6.113272575340307],
            [18.841591799903707, -6.107358914568804],
            [18.841655520101753, -6.104694600861231],
            [18.837693360403957, -6.100245445722556],
            [18.834567480133391, -6.097278246983636],
            [18.82786284022999, -6.098151849967941],
            [18.819882359959458, -6.103759542912764],
            [18.812823119979107, -6.10729691240839],
            [18.806926319739365, -6.110836587957223],
            [18.801887039591715, -6.114970449687644],
            [18.797159879987845, -6.118216733412012],
            [18.793070279893954, -6.119096035649605],
            [18.786053520345082, -6.120857146141048],
            [18.779334480447673, -6.122322762803062],
            [18.776031839576973, -6.126756320715415],
            [18.77099256032766, -6.130890057644661],
            [18.764847719966589, -6.132653099596927],
            [18.747629279724539, -6.137963871298819],
            [18.729374400138592, -6.122477943156888],
            [18.729324361282305, -6.115350072977011],
            [18.729172511863315, -6.114953774849791],
            [18.727918382878297, -6.111680694941048],
            [18.73065023960736, -6.10775296957658],
            [18.728559359579606, -6.10477792810911],
            [18.724870440441773, -6.102963004069736],
            [18.724605488636957, -6.098135884055702],
            [18.726873479607818, -6.093751025319264],
            [18.720840279175295, -6.085513992883866],
            [18.714275219500731, -6.07070542291513],
            [18.712200239653502, -6.066024879311842],
            [18.710064360318206, -6.056380889941734],
            [18.707474551490073, -6.052078037417359],
            [18.706342320295864, -6.050196874158449],
            [18.705006179617001, -6.041802398623657],
            [18.70466040009785, -6.039629972734217],
            [18.700285319898239, -6.038279904447268],
            [18.69896612593719, -6.03385406358414],
            [18.698795279844877, -6.033280878385235],
            [18.698723223280997, -6.033038456634293],
            [18.69816636033131, -6.031164974681444],
            [18.693482958563255, -6.026763177232116],
            [18.693308164375299, -6.026598880547609],
            [18.696262282271945, -6.02197968174885],
            [18.696083455546653, -6.021002964368606],
            [18.695547359849698, -6.018074896966291],
            [18.702837359958576, -6.009056991452852],
            [18.702431490333414, -6.003007763249007],
            [18.702066239830476, -5.997563892345814],
            [18.703195200258723, -5.994566907076102],
            [18.706855320306872, -5.992242937117187],
            [18.705483534477519, -5.981858371409569],
            [18.705398408324569, -5.981213950151714],
            [18.700239960366268, -5.978570814564701],
            [18.69152940039973, -5.978255888443275],
            [18.683399879742097, -5.977942396659266],
            [18.674979840328323, -5.977628186982654],
            [18.666850319670726, -5.977314514956789],
            [18.658167840141626, -5.975815520236397],
            [18.650052360151889, -5.974909991336268],
            [18.644283000308242, -5.973121154815252],
            [18.6369757202066, -5.97488167130185],
            [18.624693240379763, -5.978111778947238],
            [18.613289160187225, -5.98104755568172],
            [18.599518080306471, -5.985754552218375],
            [18.584003519579543, -5.990457742929099],
            [18.576689040379197, -5.992514300771864],
            [18.568857240271367, -5.991905256102331],
            [18.560203199607543, -5.989222262580308],
            [18.553519800369045, -5.989207744990588],
            [18.54739619977455, -5.9900827793769],
            [18.540095760343771, -5.991547142235035],
            [18.535680360160974, -5.993906066111502],
            [18.532838159772275, -5.991235450608463],
            [18.534971520231505, -5.987095431517646],
            [18.539394120411341, -5.984440554615758],
            [18.546204960045966, -5.979126459862434],
            [18.546333478420376, -5.973984116652403],
            [18.546563491150582, -5.973646687732293],
            [18.548380439813904, -5.970981891794706],
            [18.548635219096486, -5.962537555746555],
            [18.54875519988245, -5.958560916500855],
            [18.545881320405275, -5.941561019049565],
            [18.539098200085387, -5.924126962621418],
            [18.541097280375958, -5.913994992147894],
            [18.548645278431017, -5.908886084611392],
            [18.549746762988008, -5.905366149262234],
            [18.552467159909, -5.896671918050983],
            [18.563190479711238, -5.885562948702464],
            [18.565758725379315, -5.878097850059278],
            [18.56747232017425, -5.873116900192172],
            [18.569975400254979, -5.862171852965824],
            [18.571264183548692, -5.85653284138697],
            [18.569810519874459, -5.854838939131846],
            [18.564905880119909, -5.853348033556428],
            [18.55938456039755, -5.85333620122768],
            [18.554642999901375, -5.857174610468707],
            [18.551262599961355, -5.864864436632997],
            [18.546988679944221, -5.873440492276806],
            [18.543324600122332, -5.880833573564363],
            [18.539440919942692, -5.885265896576897],
            [18.535046760424766, -5.886736637068827],
            [18.530517600289304, -5.881694081953451],
            [18.526016519693016, -5.875467553433898],
            [18.522408960072134, -5.868354609792314],
            [18.518971320380565, -5.866274993797315],
            [18.511416000157599, -5.86625868008576],
            [18.503265239733391, -5.866833084364366],
            [18.494256960115386, -5.866813722927418],
            [18.49020984045297, -5.865916797294883],
            [18.484560720110078, -5.859095597934523],
            [18.480357720287994, -5.852573535901888],
            [18.479010959725812, -5.848130013133493],
            [18.477947519719429, -5.843983171118795],
            [18.475098480456495, -5.84160853939466],
            [18.470512800119991, -5.838934308627441],
            [18.465317279588241, -5.837442823043324],
            [18.461015280031965, -5.835065293436571],
            [18.459313920291166, -5.833285323072557],
            [18.455344919922503, -5.829132093908494],
            [18.451432439754857, -5.822610754299543],
            [18.450035999662528, -5.820239436956152],
            [18.446648040399399, -5.816087365957935],
            [18.442033920299316, -5.814597252925816],
            [18.437965559972, -5.814588466898793],
            [18.429807959775228, -5.815458940547471],
            [18.412677545447888, -5.814085022639216],
            [18.404823239847207, -5.807694916795293],
            [18.399456360285136, -5.795078930403767],
            [18.39701215578814, -5.781184540071107],
            [18.396829440255978, -5.78014585882257],
            [18.392242319920094, -5.78132496926992],
            [18.389860560013432, -5.785882256963371],
            [18.382715280293482, -5.799553897530798],
            [18.368458180402975, -5.797803954434281],
            [18.34951428041769, -5.816552991554663],
            [18.341241924934938, -5.834207963479145],
            [18.33460775966223, -5.83479241750898],
            [18.326747519790789, -5.835367572439941],
            [18.322055639723089, -5.837133732366574],
            [18.320503679695531, -5.841275067982686],
            [18.32007131965096, -5.84719504893115],
            [18.31849811985683, -5.852224294941457],
            [18.316052999976559, -5.857251880349559],
            [18.309220560350926, -5.863454053970169],
            [18.303040440453717, -5.866697192664387],
            [18.294266160289098, -5.869046618453779],
            [18.284960160121322, -5.869322525167599],
            [18.278318880191531, -5.867531907371514],
            [18.274597919944163, -5.865155583299906],
            [18.274108680372443, -5.861305935444298],
            [18.275696280160584, -5.855684429079701],
            [18.278445960363193, -5.850065554294635],
            [18.279983879722884, -5.846516460095663],
            [18.27860183962456, -5.843552887179208],
            [18.27477224790649, -5.840476060542627],
            [18.272706893507561, -5.842047103959504],
            [18.269285400134848, -5.844649931451358],
            [18.263876236872367, -5.860782032292317],
            [18.262270349181652, -5.862061561189128],
            [18.254276280095826, -5.868430981236135],
            [18.250256117078447, -5.869867092186914],
            [18.249691320208196, -5.870068852805173],
            [18.24864631183479, -5.869640839038548],
            [18.246925439787734, -5.868936004210783],
            [18.244184759805943, -5.860945225883236],
            [18.244453680367702, -5.849696231829689],
            [18.244368360178647, -5.841110663094806],
            [18.245126520312155, -5.833711311202312],
            [18.245296440241393, -5.82660661511847],
            [18.24431112042706, -5.81920330440595],
            [18.24166727973121, -5.808244101312203],
            [18.238115880086973, -5.798763008092008],
            [18.234827279884172, -5.790466582821385],
            [18.23294160022013, -5.784245661514218],
            [18.229879800372043, -5.778614229551267],
            [18.226534319743763, -5.772685986412589],
            [18.223408440371493, -5.76971879255222],
            [18.216438480353968, -5.772755916422279],
            [18.212461940425136, -5.778302574371663],
            [18.21097336372738, -5.780378894529658],
            [18.204321240233792, -5.78179994850784],
            [18.204342480000367, -5.785018999461527],
            [18.207365399864639, -5.790520910818565],
            [18.19968992458254, -5.804595859997493],
            [18.198053280373134, -5.807597020553339],
            [18.195539399847771, -5.80968187732431],
            [18.19094831973808, -5.810169920665725],
            [18.185682275168332, -5.812961978013719],
            [18.188244360190176, -5.818236019141778],
            [18.184393439772322, -5.826768872388441],
            [18.185581245241604, -5.83320106605454],
            [18.180559438224535, -5.838061908892847],
            [18.180126360426087, -5.839629940065659],
            [18.178087331156494, -5.847046922302276],
            [18.17844390034055, -5.848769426944923],
            [18.178800480304371, -5.850491888429632],
            [18.182922479935609, -5.848396966708602],
            [18.183857205734849, -5.850921230482898],
            [18.183120731830602, -5.85212585691878],
            [18.179764200127696, -5.857615999055482],
            [18.181410479666834, -5.863355988578137],
            [18.179136360389109, -5.867278947762196],
            [18.176491439918276, -5.872344940114814],
            [18.174903840130142, -5.877966455302396],
            [18.173082600214684, -5.881219009396238],
            [18.168957719686322, -5.883578411991004],
            [18.163145880309525, -5.883565863377283],
            [18.160005960269391, -5.881190684489185],
            [18.156299039791556, -5.87822227956163],
            [18.154009439846554, -5.876737174676166],
            [18.148871159964717, -5.872877387971305],
            [18.144278279631212, -5.870499115147751],
            [18.139380480547558, -5.868712446680356],
            [18.132406199633532, -5.868697387036844],
            [18.123383880245918, -5.869269996834819],
            [18.112561199586722, -5.872207077039691],
            [18.104133960175982, -5.872188790767091],
            [18.099867240155817, -5.868331124793091],
            [18.097039080435017, -5.865068454313846],
            [18.097435799820715, -5.860628617984542],
            [18.101581920115649, -5.857381141739554],
            [18.108003240361583, -5.856210797448128],
            [18.116770679855303, -5.854157490002925],
            [18.122681519864617, -5.850025574404399],
            [18.129719520078396, -5.84737630514043],
            [18.134744760456471, -5.843834723368436],
            [18.139266360370492, -5.837035303349817],
            [18.140031360276566, -5.829339890646275],
            [18.139676760199617, -5.81986579157596],
            [18.139223160388479, -5.814535934263207],
            [18.135055440102533, -5.80653379071896],
            [18.132808679915112, -5.803272369795924],
            [18.129357000453933, -5.801784732501922],
            [18.12344580022015, -5.805916650743031],
            [18.120185639780924, -5.808574006534671],
            [18.117194760127887, -5.812120116793638],
            [18.114217920244425, -5.81507399589526],
            [18.108618839656121, -5.818318493532189],
            [18.104791679677525, -5.820382512054855],
            [18.0997095597723, -5.814154574997261],
            [18.099574920277533, -5.80764130660792],
            [18.0997236004402, -5.801424701203459],
            [18.099808560404817, -5.797872427411288],
            [18.09989352036947, -5.794320130060328],
            [18.103529160427787, -5.788110906416626],
            [18.111594599764604, -5.778950965834376],
            [18.114911639731016, -5.77392536057004],
            [18.119107080229991, -5.768605642845624],
            [18.119277000159229, -5.761501012288319],
            [18.118823400348088, -5.756171135358489],
            [18.116300160275763, -5.752317146203712],
            [18.111707279942291, -5.749938895304091],
            [18.105066000012467, -5.74814843093767],
            [18.09900611961605, -5.746359036982781],
            [18.09323675977237, -5.74457035534404],
            [18.090104039729237, -5.741899066483951],
            [18.089933759575562, -5.736865956113802],
            [18.091861560344942, -5.729173108229314],
            [18.092867759701445, -5.723550448220716],
            [18.088877160240074, -5.720285316575716],
            [18.082788840080049, -5.719680095815527],
            [18.075240719854087, -5.719367712381392],
            [18.069436079575961, -5.719059094471463],
            [18.063042840665762, -5.719045286015632],
            [18.055785240094266, -5.718733619377762],
            [18.047372040453098, -5.718123376016569],
            [18.031854410182852, -5.718199947111263],
            [18.031462812990945, -5.711437362201615],
            [18.031082399824331, -5.704864989937465],
            [18.030163641579264, -5.702034967530182],
            [18.027803160066753, -5.694763991289018],
            [18.028238400110116, -5.690850940109324],
            [18.020048759702103, -5.69408485852619],
            [18.013287240271548, -5.697326828291335],
            [18.006554159706244, -5.699384476871704],
            [18.001543320220474, -5.702334108673975],
            [17.993357280260124, -5.704388870402093],
            [17.986056839931049, -5.70585327406415],
            [17.979359039800215, -5.706430892102352],
            [17.969479200320507, -5.706409552675255],
            [17.963965079696852, -5.706101644853814],
            [17.957345040431932, -5.703423000359339],
            [17.950484160144427, -5.69867145625071],
            [17.944260840265201, -5.691553031965603],
            [17.936592120314003, -5.684135385781377],
            [17.931212279859015, -5.678202921092102],
            [17.926945559838881, -5.674344992215168],
            [17.921828160397482, -5.66959732897575],
            [17.914034159600181, -5.666329914071281],
            [17.91249119979344, -5.657249957088219],
            [17.913185297470775, -5.655123483992354],
            [17.913845134301475, -5.653101963398946],
            [17.913410894981315, -5.649926973672649],
            [17.913122301314822, -5.647816873479493],
            [17.916088320092381, -5.64411892338318],
            [17.916270533466299, -5.642879327788769],
            [17.916528249341528, -5.641126505109581],
            [17.912974680265869, -5.638789555544498],
            [17.906879520333273, -5.638480355737395],
            [17.900202959969015, -5.638169900352454],
            [17.893810080384952, -5.638156090832269],
            [17.886566519583059, -5.637252342730305],
            [17.876700359648481, -5.636638962946702],
            [17.870066279715697, -5.634552391340323],
            [17.864034839981151, -5.631578913760268],
            [17.860278239973205, -5.630682688751234],
            [17.855387639988226, -5.628599861763493],
            [17.849611440371977, -5.628626943993138],
            [17.849333427062898, -5.629377347943978],
            [17.847831239990281, -5.633431980678628],
            [17.846960041251346, -5.635785597387905],
            [17.845770239725514, -5.63899993334917],
            [17.83092924029021, -5.654033942771365],
            [17.820221400256955, -5.668814865322071],
            [17.817428059236587, -5.67645787476499],
            [17.815925159799939, -5.680569996137425],
            [17.800014239911793, -5.7089499205574],
            [17.795446383048866, -5.713344699922117],
            [17.789032439768029, -5.716371007545448],
            [17.787116177858429, -5.716666009170466],
            [17.782835400102421, -5.717325019360223],
            [17.781716842165125, -5.716828966890636],
            [17.778228479999342, -5.715281960825117],
            [17.768561964348461, -5.714544622932452],
            [17.766967319971851, -5.714422987682917],
            [17.760713760105233, -5.710991925795107],
            [17.75349863996518, -5.708904012423036],
            [17.747686799690054, -5.708891458973994],
            [17.74069127990775, -5.709764428268961],
            [17.732845440030349, -5.709747570985815],
            [17.724751199807187, -5.70795393123197],
            [17.715544200271893, -5.704085444444232],
            [17.710058520310145, -5.702593419393958],
            [17.697980735095523, -5.701922616792139],
            [17.691276239820883, -5.698112121375455],
            [17.684698680089145, -5.693657328953356],
            [17.678603520156553, -5.693348158911665],
            [17.672791679881392, -5.693335605117852],
            [17.664258239841132, -5.697757761898923],
            [17.660983680306195, -5.701007242289288],
            [17.657425800215499, -5.703959913371574],
            [17.654172839773274, -5.706321322706503],
            [17.644930920027949, -5.716070815645584],
            [17.641573199853916, -5.719709864134603],
            [17.637394319797195, -5.711912951209968],
            [17.63574606037119, -5.705020922482868],
            [17.63136844243088, -5.702974033894452],
            [17.631081876262002, -5.701309776359072],
            [17.630418961803148, -5.69745981063],
            [17.627430239903408, -5.696785963178149],
            [17.624460239792509, -5.699791917723535],
            [17.619619320236044, -5.696826850268518],
            [17.617320900631537, -5.696724899790675],
            [17.615022480128765, -5.696622950194327],
            [17.614456254937192, -5.695029987732276],
            [17.613390072374237, -5.69203098808323],
            [17.612634238877344, -5.692177036598907],
            [17.606046239823666, -5.693450020011801],
            [17.599903199686448, -5.703602867953343],
            [17.593466399671495, -5.702716978333127],
            [17.586319125691624, -5.704382939612721],
            [17.583629413424124, -5.705009884262251],
            [17.582501167156501, -5.704901110941428],
            [17.579689920017557, -5.704630068380808],
            [17.573510160344782, -5.70764996908947],
            [17.565460199878615, -5.706317018827197],
            [17.557430400302373, -5.708199969651855],
            [17.553549095268327, -5.707133597232447],
            [17.551679400226465, -5.706619905491606],
            [17.540201236870768, -5.707830007206878],
            [17.541990339556929, -5.699311049968855],
            [17.539877159750528, -5.691041930272789],
            [17.537327280138481, -5.686914907436538],
            [17.532037471536182, -5.686022898787869],
            [17.523252360384227, -5.675718907096146],
            [17.516052359788723, -5.661726017624239],
            [17.518549319647427, -5.65642299856961],
            [17.520786905340863, -5.645104270370859],
            [17.521007397725661, -5.643988911845612],
            [17.520746400304702, -5.638240026971745],
            [17.518421159700793, -5.633192007973288],
            [17.51907348032751, -5.626748931024571],
            [17.519720219721364, -5.619154682331261],
            [17.514871200055936, -5.614578915871347],
            [17.519740163218991, -5.608828129952685],
            [17.521717320125028, -5.606492871412764],
            [17.522441027172427, -5.603521244837025],
            [17.523063360238339, -5.600965856799646],
            [17.521256675725418, -5.591549125037592],
            [17.520462360198366, -5.587408976604684],
            [17.522314206613864, -5.580999857556868],
            [17.523391319877202, -5.577272004694421],
            [17.522447399821036, -5.572906854415456],
            [17.524271086747319, -5.570365985523],
            [17.522644346463949, -5.566694014814277],
            [17.528339159613768, -5.558383920834068],
            [17.528934033876368, -5.556120856224925],
            [17.529913440081177, -5.55239491006038],
            [17.534239003345711, -5.545701799787481],
            [17.526626279877757, -5.539760886206542],
            [17.52337835988261, -5.533911960660518],
            [17.520130439887431, -5.528062976498041],
            [17.518044847343425, -5.527913816972458],
            [17.514158400352731, -5.527635861853323],
            [17.513690204714848, -5.526103273664477],
            [17.513456436128447, -5.525338057746864],
            [17.51466071759836, -5.523301638900218],
            [17.515503359792728, -5.521876867072055],
            [17.514118289676961, -5.520504050250063],
            [17.509300199905095, -5.521449927031163],
            [17.507909159585953, -5.519386977987947],
            [17.507650319918326, -5.51409790092082],
            [17.500066199707348, -5.512986944524949],
            [17.494352065592388, -5.509846372173385],
            [17.491773239566935, -5.508429006342736],
            [17.491207163495687, -5.507775057776334],
            [17.487611280176914, -5.503620960792151],
            [17.485046280121953, -5.496273015654026],
            [17.485233480044023, -5.488680999876649],
            [17.47647647987224, -5.483435958238262],
            [17.475057413912854, -5.475622154312645],
            [17.47497642989169, -5.474361084287544],
            [17.474806439893843, -5.471712885624489],
            [17.477060400078269, -5.464109968857226],
            [17.479349279574436, -5.462717970585518],
            [17.479318320036501, -5.457196950413412],
            [17.487079199949285, -5.448875853988151],
            [17.483859477172569, -5.446838813256364],
            [17.478784439585024, -5.443627946454929],
            [17.478650028262322, -5.442815008890494],
            [17.477834400205165, -5.437881945529861],
            [17.472999239747956, -5.435837003394715],
            [17.47021823978298, -5.431251018838657],
            [17.471349359761184, -5.428253900238541],
            [17.473404225430873, -5.427728394031697],
            [17.474102280187019, -5.427549875022063],
            [17.47747440035506, -5.414419950775602],
            [17.474428197955245, -5.4036240610252],
            [17.473489585145799, -5.402984734563352],
            [17.470741319789752, -5.401113004931711],
            [17.469452880550797, -5.396518500233409],
            [17.468164463769703, -5.391924043097618],
            [17.46826159949968, -5.391525664550153],
            [17.46906336026381, -5.388238900881669],
            [17.471360136849629, -5.385912733783241],
            [17.472488400185227, -5.384770029316752],
            [17.475208199726548, -5.37831489313335],
            [17.468971200302189, -5.371675948795851],
            [17.468721371635144, -5.367997027974711],
            [17.471225159588322, -5.36407301221143],
            [17.472511440175651, -5.347272894541246],
            [17.476635052282813, -5.34564096717716],
            [17.476368479917202, -5.338971981509355],
            [17.478466610247629, -5.33487302657167],
            [17.479320451738648, -5.333204934409457],
            [17.477203320243348, -5.323783851106824],
            [17.477367480174998, -5.312051011650633],
            [17.477428941110109, -5.311388465821461],
            [17.478883440217544, -5.295708855897954],
            [17.480178077831972, -5.294267890097455],
            [17.481167280164961, -5.293166878588984],
            [17.476776378836572, -5.288127957093011],
            [17.477354643249608, -5.287665497595521],
            [17.481119399960335, -5.284654901807918],
            [17.481323156731374, -5.280052962337954],
            [17.481123359734106, -5.27926289330486],
            [17.479212479631386, -5.271781910127805],
            [17.47643147966641, -5.267194858229478],
            [17.479949011926106, -5.25909616973103],
            [17.480737439894785, -5.257280895586629],
            [17.478853930560458, -5.25383859744734],
            [17.477724352091307, -5.251774171071485],
            [17.478838404977424, -5.250234691697224],
            [17.480230165745404, -5.248311451466244],
            [17.47949221231594, -5.239572904917924],
            [17.480169359682144, -5.237498973216843],
            [17.481590518716136, -5.237583191127179],
            [17.487289439861744, -5.237920910064323],
            [17.488201319706672, -5.236537005727443],
            [17.482183200191152, -5.22805601115487],
            [17.486282159831969, -5.221823020168394],
            [17.487606407714793, -5.220864579209528],
            [17.491083479854122, -5.218347996406648],
            [17.494255440105498, -5.210737944890553],
            [17.491638094320638, -5.205197857261605],
            [17.491003232451476, -5.203853870547103],
            [17.491455403042998, -5.202282098071244],
            [17.492130360316544, -5.199935895161255],
            [17.49344930364764, -5.198689354577601],
            [17.49555648001294, -5.196697845985435],
            [17.498012295234986, -5.196021068796822],
            [17.501514479778077, -5.195055930697775],
            [17.507664182719768, -5.189560774414328],
            [17.509283280136735, -5.188113999121486],
            [17.510317186231511, -5.180997086027611],
            [17.514053280396482, -5.179115954979667],
            [17.516026351764623, -5.176500835205109],
            [17.517015376231186, -5.175189910943919],
            [17.518247443491152, -5.168596708935516],
            [17.519468400387652, -5.162062894879614],
            [17.52607332010799, -5.152825925248608],
            [17.529285240118153, -5.152578939166705],
            [17.529942912907345, -5.153013343006274],
            [17.532741428223762, -5.154861600021457],
            [17.535881159617674, -5.141731007322793],
            [17.53850670252951, -5.140340509626708],
            [17.541145439896219, -5.138943022234028],
            [17.54497528493917, -5.125808843650934],
            [17.541997197295803, -5.125251018968929],
            [17.539001416434576, -5.124689879194144],
            [17.538233833872045, -5.123549711888656],
            [17.536686480405265, -5.121250909216636],
            [17.54352431980405, -5.112701931018918],
            [17.540991209941719, -5.111104960816335],
            [17.537788440171056, -5.113423011034297],
            [17.536410360744803, -5.113084998658936],
            [17.535032280420285, -5.112746987003475],
            [17.530880305804633, -5.109318009514376],
            [17.529251564074794, -5.108986884617964],
            [17.525366280402373, -5.108196999100662],
            [17.524152296229111, -5.106694376407203],
            [17.522590319986111, -5.104761015348921],
            [17.522346239638598, -5.102000869934574],
            [17.525573345668622, -5.098479508904045],
            [17.528278282583567, -5.09552782455039],
            [17.526270239801423, -5.092985975705729],
            [17.525594026683102, -5.092129498313351],
            [17.52411636002449, -5.090257911663723],
            [17.519279400241761, -5.087062021934798],
            [17.515658629996334, -5.086318482971169],
            [17.514911159814719, -5.086164986988176],
            [17.513521262152619, -5.083641832960272],
            [17.518695568968948, -5.077936123218539],
            [17.521278479634002, -5.075087927343276],
            [17.524221479980707, -5.067709875731244],
            [17.529241319687298, -5.062621898294998],
            [17.529676200404555, -5.058248920001964],
            [17.526651255737622, -5.050234293676593],
            [17.525949480159561, -5.048374915238603],
            [17.525697480264501, -5.044465017909997],
            [17.527519998482592, -5.040760943419114],
            [17.5279672436114, -5.039851872304004],
            [17.515318320318944, -5.035316996606475],
            [17.511825076707865, -5.032520061217314],
            [17.509323239895519, -5.030516907864828],
            [17.507454479999872, -5.024544978401286],
            [17.509712399958069, -5.017859884228221],
            [17.509125334750202, -5.015747564020238],
            [17.509010399801202, -5.015334015868287],
            [17.506400139028987, -5.014118985847317],
            [17.505098279857989, -5.013512992436976],
            [17.505067639221959, -5.013306282088903],
            [17.504621279831994, -5.010294994926661],
            [17.506654275117814, -5.004762597295684],
            [17.507551320184103, -5.000845940362851],
            [17.508154319708485, -4.999999953011676],
            [17.509532984836245, -4.998064942396137],
            [17.510513399849128, -4.996688886900157],
            [17.512797070913287, -4.995319707663159],
            [17.515545479999769, -4.993671890787981],
            [17.516340100055704, -4.990613220508417],
            [17.516443302108815, -4.990215973290512],
            [17.514784439867501, -4.980561873097857],
            [17.518394240784968, -4.969496814314923],
            [17.519521320141028, -4.966041958197201],
            [17.513454239747578, -4.947896904661883],
            [17.514581579615093, -4.944209772146351],
            [17.519146199848048, -4.939814977365625],
            [17.518900320175007, -4.936593921726591],
            [17.506736279625148, -4.936887855943845],
            [17.502357409433351, -4.93346006817046],
            [17.501254023142906, -4.928435730935809],
            [17.500944265168332, -4.927025039562325],
            [17.504335440400165, -4.917573945602528],
            [17.503626066871458, -4.913896723797657],
            [17.498783160241544, -4.909780024478727],
            [17.501917320284093, -4.895498979874622],
            [17.500868820159202, -4.892627954792777],
            [17.499820359560182, -4.889757024455407],
            [17.504131319811435, -4.880991904389123],
            [17.508238040896305, -4.876598121928202],
            [17.514190439665636, -4.874035980573676],
            [17.516342277571969, -4.868079735472752],
            [17.517355179258782, -4.865276025610017],
            [17.517896557049568, -4.864864343044856],
            [17.521925399589236, -4.861800984705781],
            [17.522685659983861, -4.860476746891337],
            [17.523515159825632, -4.859031903735925],
            [17.521421399799078, -4.853980905765732],
            [17.523475200066844, -4.851898864114026],
            [17.52625562331345, -4.851466080643993],
            [17.532648360065373, -4.850471025686066],
            [17.534694239887298, -4.847468981660205],
            [17.534889532731754, -4.845547362216011],
            [17.535349428834717, -4.841022111072182],
            [17.536417199619073, -4.826981022418815],
            [17.547157406850349, -4.819101924373844],
            [17.545997235355848, -4.816806098361551],
            [17.543701291508306, -4.816129043490719],
            [17.541401308835216, -4.815450795735563],
            [17.541011716683027, -4.814790361846085],
            [17.539777439567466, -4.812698019808978],
            [17.546367239743294, -4.800929022255998],
            [17.546466774873384, -4.798282122489034],
            [17.546566171662956, -4.795634954589044],
            [17.546420461330595, -4.790741885881599],
            [17.546285163370722, -4.786203059382196],
            [17.544773685023127, -4.784929046980056],
            [17.54167320012564, -4.782315907484183],
            [17.541048077790773, -4.780163156593074],
            [17.540739360065306, -4.77910001515898],
            [17.545273200423377, -4.7694120170737],
            [17.553270240237836, -4.763386896519564],
            [17.554146477627224, -4.755788949285598],
            [17.561241360063111, -4.752759874493793],
            [17.561683157808051, -4.752312287836043],
            [17.564436360304875, -4.749523007550541],
            [17.571148200205311, -4.719113996688172],
            [17.571581279800423, -4.714509914339503],
            [17.576591399735619, -4.708270025689941],
            [17.576557199974424, -4.702057920126242],
            [17.577257373856327, -4.699910806614965],
            [17.578361284762909, -4.696525883977071],
            [17.580851397662471, -4.694541929989639],
            [17.581560480137053, -4.693976980883303],
            [17.586830160188786, -4.693028938713948],
            [17.588190222105357, -4.689800903319091],
            [17.586326160398627, -4.684978967910818],
            [17.586534239862836, -4.681295956656913],
            [17.592254280400777, -4.678503861002715],
            [17.596298159839961, -4.678249870099457],
            [17.60028227975317, -4.678000909351251],
            [17.601652231222719, -4.675915372964443],
            [17.602102431808806, -4.675229921922365],
            [17.601373439972583, -4.668100955392618],
            [17.60234577463951, -4.66665360244091],
            [17.604786240348286, -4.663020873784931],
            [17.610166236211843, -4.663837394661516],
            [17.616495240189295, -4.664797945942662],
            [17.616944838904164, -4.663884236145312],
            [17.618538240012423, -4.66064598855943],
            [17.617134090578336, -4.655748248662186],
            [17.616430486030353, -4.653293851303382],
            [17.622839159793752, -4.650497894069426],
            [17.628140197337064, -4.643544730950494],
            [17.632175379287684, -4.638251893799982],
            [17.631696427222593, -4.634728821955985],
            [17.631456489006826, -4.632963882978253],
            [17.63178556794654, -4.632124313719564],
            [17.632812361180935, -4.629504953646387],
            [17.634627727012735, -4.629060978075616],
            [17.635315628111222, -4.628892734542284],
            [17.637624581360733, -4.628328179035964],
            [17.638042235085749, -4.626718397012641],
            [17.638188301150961, -4.626155642516998],
            [17.638521480001629, -4.624871921886616],
            [17.637868576368291, -4.6191452515599],
            [17.6373154800546, -4.614293962120064],
            [17.640274371598693, -4.609458369512963],
            [17.642542320348721, -4.605751932912906],
            [17.641928907553588, -4.604796968385839],
            [17.640922320124908, -4.603229903442372],
            [17.635635360080407, -4.601418003313123],
            [17.634647161165578, -4.588996863094446],
            [17.634607200508491, -4.582094100915761],
            [17.6358612603232, -4.580821995947911],
            [17.637115320137937, -4.579549979732866],
            [17.640221605457217, -4.579763489357344],
            [17.643312359803545, -4.579975931608471],
            [17.652652200406379, -4.568651015232597],
            [17.65240035681818, -4.567184306955707],
            [17.652178439705317, -4.565891889571764],
            [17.648849713555396, -4.563913782626875],
            [17.646423559805747, -4.562471937774572],
            [17.670435308161302, -4.54945503575304],
            [17.674345440132807, -4.551274880489411],
            [17.675295796617974, -4.553408114617585],
            [17.67690216041575, -4.557013854953013],
            [17.681495431516396, -4.558138826783052],
            [17.686603313307348, -4.55224254531813],
            [17.688104258009943, -4.550509860024721],
            [17.687049298998158, -4.548768839901833],
            [17.686714365737728, -4.548216090021953],
            [17.68708046694525, -4.547363638479752],
            [17.688299399937421, -4.54452599424436],
            [17.696056320076433, -4.537120021044594],
            [17.696705399581624, -4.530442865086449],
            [17.6929894797813, -4.522409893687962],
            [17.689316212888997, -4.521739772895949],
            [17.688106207354114, -4.520780317343931],
            [17.685857160055946, -4.51899696313717],
            [17.689502159661217, -4.514605908037766],
            [17.67658427987439, -4.501789945500946],
            [17.6751803074084, -4.496964971868868],
            [17.676950388268423, -4.485680044215389],
            [17.674179479977305, -4.482474028919969],
            [17.654286736269832, -4.480570713346015],
            [17.646869274205297, -4.479861016984568],
            [17.652549240000088, -4.470625961639275],
            [17.657592589515986, -4.469908066438385],
            [17.658895864431873, -4.471097465008864],
            [17.663357123609931, -4.475168899599044],
            [17.664540573148386, -4.474152903505468],
            [17.672258033890259, -4.467526971601242],
            [17.668806480193208, -4.465704916398513],
            [17.663067360336949, -4.465260927780777],
            [17.662123800505221, -4.460556451296791],
            [17.661180239775195, -4.455851944278413],
            [17.662623054495747, -4.449919539045255],
            [17.662973400151476, -4.448479018557475],
            [17.667089279560692, -4.446155882893498],
            [17.669326839203013, -4.45044574642277],
            [17.670799440261721, -4.453269011955149],
            [17.673318763679433, -4.454884645391899],
            [17.674713360428786, -4.455778993147792],
            [17.679699291428307, -4.445396139467836],
            [17.686763279903246, -4.437303860295591],
            [17.68419432007455, -4.429263922084394],
            [17.690135443190449, -4.424526648307321],
            [17.693783279675355, -4.421617957141558],
            [17.696001239874803, -4.408720026625627],
            [17.698384245744737, -4.410881208012134],
            [17.704071235466731, -4.416038794538169],
            [17.704556510773127, -4.414246657996117],
            [17.705194199640491, -4.411890892508106],
            [17.70472994131849, -4.408335708396738],
            [17.704233359815962, -4.404532975359089],
            [17.706911400272972, -4.391631869957243],
            [17.707820940006592, -4.39024639949539],
            [17.708730616284104, -4.388860902983395],
            [17.711479359543873, -4.388384918322575],
            [17.712593964893905, -4.389551994274802],
            [17.715633480234722, -4.39273485404149],
            [17.719246838480768, -4.393404116614357],
            [17.720455319574608, -4.393627949689746],
            [17.724563280334575, -4.390383868790185],
            [17.726929439199672, -4.384431363250497],
            [17.727955129302899, -4.381851037155594],
            [17.730692081276231, -4.381836025807507],
            [17.730707220583717, -4.381835943753623],
            [17.732798575820272, -4.383738213111672],
            [17.736240239964342, -4.386868967096951],
            [17.739225359619784, -4.387541939117296],
            [17.743330440380955, -4.383606885781951],
            [17.746968398991044, -4.384084595752139],
            [17.748380277529822, -4.384269879095866],
            [17.750674965532621, -4.382348497982682],
            [17.757509400316476, -4.376625879344742],
            [17.760081910287202, -4.375009996607019],
            [17.761699440143968, -4.373993968549733],
            [17.770076279575722, -4.368731915053638],
            [17.773029359918258, -4.363882964665557],
            [17.774801279629639, -4.353287872264238],
            [17.776389761563394, -4.350794310155957],
            [17.777302128295212, -4.349362095966819],
            [17.777641103076082, -4.349155388688884],
            [17.779587480107242, -4.347968884339491],
            [17.790145296996506, -4.346672752549687],
            [17.793337282492182, -4.346280886984052],
            [17.794114141956637, -4.345816419855868],
            [17.797222373026791, -4.343958003794782],
            [17.803369440311467, -4.33632998404405],
            [17.822117019779615, -4.326790028164883],
            [17.823379346789878, -4.323323392361186],
            [17.82572724021033, -4.316874920858571],
            [17.825087520252097, -4.309571054841638],
            [17.822348999820267, -4.303223224306389],
            [17.820042480106864, -4.298926847458276],
            [17.816917320285171, -4.295048297775182],
            [17.813790360239626, -4.290964306059696],
            [17.810875080105959, -4.287494943697459],
            [17.80650971967771, -4.283010306340984],
            [17.800091639655005, -4.278953747591244],
            [17.793881279770371, -4.275100975624757],
            [17.791213680431888, -4.275739900133956],
            [17.787536280390935, -4.278237004501568],
            [17.783051039788067, -4.282179442001675],
            [17.7763154403467, -4.287373990016441],
            [17.771221079997389, -4.292143460931698],
            [17.760801960293083, -4.299218353192938],
            [17.752416840191014, -4.304015425748208],
            [17.743005359842591, -4.309026690721852],
            [17.732162520090096, -4.314871986039262],
            [17.721520920029246, -4.320304430197887],
            [17.710455599920209, -4.324507412800332],
            [17.700809040343383, -4.326643310380287],
            [17.691384960224767, -4.330421417161255],
            [17.6809323603098, -4.334208130953876],
            [17.667997199631845, -4.33657726623114],
            [17.657120879668728, -4.339134550737821],
            [17.651997360005304, -4.341027079053997],
            [17.644187520112883, -4.34170907764912],
            [17.638218359678675, -4.341348220310811],
            [17.632847520342828, -4.339132753564597],
            [17.627653079586057, -4.334038663503003],
            [17.626171320203003, -4.329941045837473],
            [17.626131719770324, -4.326036777912657],
            [17.629869130865508, -4.314733213236204],
            [17.631231996424084, -4.312078101826333],
            [17.632593359999479, -4.309426022714523],
            [17.633919984824555, -4.296347731184963],
            [17.634111479591983, -4.294459891121117],
            [17.637358769868161, -4.290646242695568],
            [17.638441188581524, -4.289374946512965],
            [17.636535359705682, -4.277189026976389],
            [17.629806239812446, -4.263417989827612],
            [17.624496239777525, -4.257003989108763],
            [17.625356279644016, -4.246873975442386],
            [17.623960199776125, -4.243199875371921],
            [17.612207280402554, -4.233137976709314],
            [17.600739840236411, -4.236233379273569],
            [17.588824560256715, -4.23777208877522],
            [17.575677360340773, -4.239526655842868],
            [17.563344479636619, -4.240452286620924],
            [17.552656799594956, -4.241364076336686],
            [17.54689751974707, -4.241412425033465],
            [17.538867359946394, -4.240657542890526],
            [17.532472319914078, -4.238861459374119],
            [17.526933529756064, -4.237963892665064],
            [17.521965360246323, -4.237305497597725],
            [17.517855960385273, -4.237751060013381],
            [17.51335163956572, -4.23984406606139],
            [17.507422079564193, -4.243387875666192],
            [17.500896720035286, -4.248991760034006],
            [17.49396600022601, -4.255215672956709],
            [17.486629920136352, -4.262059420571807],
            [17.479514520179361, -4.270340023951839],
            [17.471572200342131, -4.278216335782883],
            [17.465054760360765, -4.284642197754877],
            [17.461396080312031, -4.288988618696083],
            [17.45751960012943, -4.29210392244342],
            [17.452794960299951, -4.29276008577041],
            [17.445818159611527, -4.294462766048322],
            [17.439460559563607, -4.296365651639794],
            [17.436683286708725, -4.297343761357607],
            [17.428376520360722, -4.298719270438543],
            [17.423672760073377, -4.301430523921112],
            [17.417764439838422, -4.307028765979005],
            [17.412057360193405, -4.312214516077032],
            [17.405128439709646, -4.318643323188541],
            [17.398195560350409, -4.324661248597465],
            [17.390247120291118, -4.331920577725858],
            [17.381674800267017, -4.33856846259684],
            [17.371883520301292, -4.346665099536721],
            [17.361474839918888, -4.354766860316149],
            [17.351874360322871, -4.361423345375071],
            [17.3406322796137, -4.368504410791788],
            [17.328966479754708, -4.374356067882699],
            [17.3199582001367, -4.378541493686895],
            [17.309709359687734, -4.382120767981739],
            [17.300692440073309, -4.385484205420806],
            [17.292687119588575, -4.387195300219487],
            [17.284673880454591, -4.388084448704983],
            [17.278706520244196, -4.387929009334074],
            [17.269983301218662, -4.387700972680816],
            [17.264717640229541, -4.387840957245757],
            [17.258960519931613, -4.388094691825491],
            [17.256091319778754, -4.389146287147132],
            [17.25159959962772, -4.392471776973639],
            [17.243443080104221, -4.399526667540658],
            [17.238758400033529, -4.404086614177264],
            [17.23305743971224, -4.409888034159293],
            [17.226544319729086, -4.416723533390151],
            [17.219636639910195, -4.425206005453346],
            [17.213346000283586, -4.433683347058908],
            [17.20870091974724, -4.442146754811022],
            [17.201855520127019, -4.456792578906017],
            [17.198664839883424, -4.466681653073376],
            [17.19511488023857, -4.481710228670897],
            [17.193748319909229, -4.488912844974068],
            [17.192400479572104, -4.497964391514668],
            [17.190687239611687, -4.511538800606959],
            [17.187695640408116, -4.520809073974656],
            [17.186119200390753, -4.527602202818521],
            [17.183724120265062, -4.534812981969991],
            [17.181330840363223, -4.542229040705229],
            [17.177901120219161, -4.548831886008955],
            [17.173648439968602, -4.555441678031853],
            [17.167532040269403, -4.560834421965079],
            [17.159545800001283, -4.564393929967664],
            [17.153601840005752, -4.566498042617909],
            [17.146402559859116, -4.566558586498328],
            [17.140626719569006, -4.564963435345243],
            [17.135868600427198, -4.562332747878955],
            [17.129872440228798, -4.559301418760016],
            [17.125322040326761, -4.55687426102759],
            [17.119225526633048, -4.551809770591098],
            [17.116009284828049, -4.551592517708498],
            [17.106825239943223, -4.550027873279494],
            [17.094845159990502, -4.539959926906227],
            [17.075309399590374, -4.532458864323467],
            [17.0674723829657, -4.524902203173839],
            [17.065103475255814, -4.521726766708523],
            [17.058235320411111, -4.512519967441567],
            [17.05668575708874, -4.509360642323654],
            [17.054294399581593, -4.504484998096679],
            [17.036072279757427, -4.483860941444743],
            [17.031940200130393, -4.483420019387834],
            [17.027884794407782, -4.481103011980703],
            [17.024349240146847, -4.479083008822568],
            [17.019659160302972, -4.479015989664307],
            [17.012296342757175, -4.478911471464214],
            [17.012191500380364, -4.478909982970754],
            [17.006721479850619, -4.486067886336149],
            [17.003749860077289, -4.487922932324419],
            [17.000778240303923, -4.489777973535852],
            [16.995081166992875, -4.497397025220056],
            [16.994517133690589, -4.49768335311252],
            [16.992792360260243, -4.498558923655532],
            [16.987555800194759, -4.501737122337973],
            [16.98407568007168, -4.503410033051126],
            [16.977919679939834, -4.50489985549095],
            [16.971753239587756, -4.505362504964625],
            [16.965993959739905, -4.505410836400228],
            [16.959617639699768, -4.505464198412354],
            [16.954664400190051, -4.503862082281004],
            [16.95093299972245, -4.501017002464155],
            [16.948647360449513, -4.498776146686795],
            [16.946346960059838, -4.495097368044338],
            [16.944456239948746, -4.491209431383222],
            [16.942976640115614, -4.487318059514406],
            [16.940649239961747, -4.480968348344742],
            [16.939361160048897, -4.475637171465231],
            [16.939304639847851, -4.470090160753098],
            [16.939265040313501, -4.466186637050965],
            [16.940455200267142, -4.461861920881309],
            [16.945765559628168, -4.458118808222268],
            [16.951077720111343, -4.45458141264178],
            [16.955156160434459, -4.451054241158254],
            [16.96025664010746, -4.44690193186241],
            [16.964729280041876, -4.441727729284026],
            [16.969200119752447, -4.436347747526529],
            [16.973446679780984, -4.429120530942395],
            [16.97420051991628, -4.422333483618714],
            [16.973720279667084, -4.41555679545538],
            [16.973239830110401, -4.41133730563446],
            [16.973042400173885, -4.409603400113042],
            [16.971764400256831, -4.405299013402633],
            [16.970075280061813, -4.400998015160885],
            [16.967168279700125, -4.398351096539757],
            [16.962844680152813, -4.397976430682299],
            [16.958949119753559, -4.399242029476883],
            [16.955666639772748, -4.400091631559089],
            [16.952383799567535, -4.400941052325543],
            [16.94582891960178, -4.403667386500651],
            [16.942539960072875, -4.40390045038945],
            [16.938629999679581, -4.40372776372597],
            [16.935723000216221, -4.401080854939792],
            [16.933431239822934, -4.398223153081397],
            [16.931758680070171, -4.395565982354339],
            [16.928184599761622, -4.387992981960782],
            [16.926455519807817, -4.379787898161777],
            [16.925164920120576, -4.374250403071536],
            [16.923056039651151, -4.369130856174142],
            [16.921156680441971, -4.364420460973023],
            [16.919683560157001, -4.361144802645685],
            [16.917374879995347, -4.356643355017793],
            [16.914035879813525, -4.351944920352374],
            [16.911114480356126, -4.347859442018647],
            [16.907578200256438, -4.343984560847053],
            [16.9030134003604, -4.34011846410816],
            [16.896375000429405, -4.334625600795753],
            [16.892431199601091, -4.331165067445556],
            [16.887022920280817, -4.325250889520862],
            [16.883685720322813, -4.320757671804929],
            [16.879517639812434, -4.31544959332238],
            [16.875141840062284, -4.309937499606101],
            [16.870982400446653, -4.305451198722979],
            [16.867863359948654, -4.302189119446854],
            [16.864541280433492, -4.299134424420708],
            [16.862877000452716, -4.297298760981678],
            [16.856258400288883, -4.294379914392703],
            [16.855602480112825, -4.296383983312356],
            [16.853094359585047, -4.304058917035861],
            [16.852431075020284, -4.309233202598363],
            [16.851766319913413, -4.314418921224776],
            [16.852216541160768, -4.320143052940541],
            [16.852743359955799, -4.326840995504477],
            [16.851951863342101, -4.335408419692696],
            [16.851871439869658, -4.336278945212596],
            [16.851348782071049, -4.338168888266551],
            [16.848940319742571, -4.346877874368731],
            [16.846660289550275, -4.349302373463298],
            [16.844377320070382, -4.351729990940234],
            [16.839802440178545, -4.354280932942816],
            [16.832942709734592, -4.35431184044615],
            [16.826042159844128, -4.354342931899954],
            [16.818954480100171, -4.358975938015562],
            [16.807260239579303, -4.359487919261143],
            [16.806376449154985, -4.360084899637993],
            [16.803146160393911, -4.362266880972719],
            [16.799738040240857, -4.359274249929857],
            [16.79579244008702, -4.355608426004597],
            [16.789806359884413, -4.353603617714207],
            [16.785889919943028, -4.35281452390461],
            [16.781988240220048, -4.353463806114052],
            [16.778300399958866, -4.35493326890965],
            [16.775038800418553, -4.357837502016555],
            [16.77221532002207, -4.363409623065842],
            [16.770393359657774, -4.366301783345542],
            [16.767754919633404, -4.369817322150594],
            [16.763901480339523, -4.375192400398556],
            [16.760643839674653, -4.378507530449292],
            [16.757990640330174, -4.380584689828801],
            [16.753687920325028, -4.382264707517865],
            [16.75080827995194, -4.382288966592331],
            [16.746896160008724, -4.38191069842471],
            [16.745427000395864, -4.379046273091205],
            [16.744990679679191, -4.376584009036298],
            [16.744942440148424, -4.371858026661179],
            [16.744907159713986, -4.368364960880888],
            [16.744858920183219, -4.36363910544766],
            [16.74481931975054, -4.359735014306063],
            [16.744764959997749, -4.354392531242282],
            [16.744668840262353, -4.344940433749164],
            [16.743785400181039, -4.338988266413276],
            [16.743135240002569, -4.335705846526611],
            [16.741879919851502, -4.333661267975913],
            [16.740005760182669, -4.3314164849759],
            [16.737094800047174, -4.32835831469733],
            [16.734009599984265, -4.328384193283092],
            [16.73133552019932, -4.328406656919173],
            [16.728886080320841, -4.330276748873668],
            [16.727070600403007, -4.333785449669864],
            [16.726081680141004, -4.337698303153251],
            [16.724070719630824, -4.34223616680154],
            [16.72197099838403, -4.345154559874066],
            [16.721839440110678, -4.345337411055949],
            [16.719811920056532, -4.348231437996691],
            [16.718384520426273, -4.349476456102926],
            [16.713197392854234, -4.35207083842831],
            [16.70807016045374, -4.33391502109711],
            [16.702741440426603, -4.322431892968034],
            [16.702226663548, -4.322855391360234],
            [16.695432360101147, -4.328444936446838],
            [16.692343962035803, -4.32920320524164],
            [16.689705479790639, -4.329851009319312],
            [16.685889398734449, -4.328948868886852],
            [16.683965280159402, -4.328493997362299],
            [16.679842137871123, -4.329201956311389],
            [16.675564247300418, -4.333973342614931],
            [16.668659160019448, -4.341674933278443],
            [16.668205609615651, -4.343140504024531],
            [16.665949439575598, -4.350430884591304],
            [16.662979351429819, -4.353205032535826],
            [16.658394410406789, -4.35345399624392],
            [16.654056480035781, -4.358074893303375],
            [16.647417359655911, -4.36063390099709],
            [16.635957581220811, -4.362292923392999],
            [16.62842340015311, -4.369457017695307],
            [16.620887520371227, -4.370432984738404],
            [16.616593080138031, -4.372934983833773],
            [16.613958599887471, -4.376861288087735],
            [16.611738119913664, -4.380989734415291],
            [16.610335919823747, -4.384700357356289],
            [16.609162320312365, -4.390669408354487],
            [16.607973959684276, -4.395199939593909],
            [16.607805839978855, -4.398900068543048],
            [16.607238840439486, -4.403836479146285],
            [16.606289879936273, -4.411652799025765],
            [16.606816200166318, -4.422949820852971],
            [16.606901879681477, -4.43137364175744],
            [16.607398680372963, -4.439793951874712],
            [16.608974399941456, -4.453136226588834],
            [16.60990176045366, -4.463401960281825],
            [16.610405039794948, -4.472438194367665],
            [16.610475959989994, -4.4794233155964],
            [16.610758920321356, -4.487023034649635],
            [16.611469919800744, -4.496262720424836],
            [16.611351839849906, -4.504892848735221],
            [16.611672600390097, -4.516190032782267],
            [16.611762239679031, -4.525023660420031],
            [16.611850079642476, -4.533651644511425],
            [16.611709319925652, -4.54002172973231],
            [16.610957280014201, -4.547013019438372],
            [16.609787999602698, -4.553391608572812],
            [16.607344679946277, -4.555877346079047],
            [16.603025400397172, -4.555913636712996],
            [16.598896920319472, -4.554510155919587],
            [16.594134839607268, -4.551468372272857],
            [16.587716759584531, -4.547413479764534],
            [16.579416240121013, -4.540292478982904],
            [16.570087199962813, -4.533180210159148],
            [16.562628000373572, -4.527901164111043],
            [16.555376520024101, -4.522825818913214],
            [16.543344239868542, -4.512859539873961],
            [16.535245320321071, -4.505325672640103],
            [16.527985560199618, -4.499428352707627],
            [16.523620199771372, -4.49494500597635],
            [16.518841200189097, -4.490259498717164],
            [16.514889479813238, -4.485978049292491],
            [16.513029720138409, -4.485171849542379],
            [16.50830328008508, -4.485622293732308],
            [16.502789879910267, -4.485250007840408],
            [16.501923228443307, -4.484990354964316],
            [16.497508525353119, -4.483667688327182],
            [16.494233545406644, -4.483520310397623],
            [16.494860594627784, -4.482406225713863],
            [16.496008536458003, -4.48065043095492],
            [16.496955346394429, -4.47761981679185],
            [16.4976261489598, -4.475546191728833],
            [16.498734451729796, -4.473830330976669],
            [16.498413478288892, -4.472197098596762],
            [16.497217750577143, -4.469967890013852],
            [16.496935197182601, -4.467696960034045],
            [16.496971348084596, -4.465943442105208],
            [16.49759994061138, -4.462634526303378],
            [16.497754404127861, -4.460482257341503],
            [16.497949704158827, -4.458887819365162],
            [16.497667648430976, -4.456855993729206],
            [16.498022457815388, -4.455599964281922],
            [16.497184044889348, -4.453330165866603],
            [16.495749011375786, -4.450543514799644],
            [16.493759402023279, -4.448395599909245],
            [16.491570316372037, -4.445769866793479],
            [16.491407249690091, -4.44365808714117],
            [16.492516749016019, -4.442540009204305],
            [16.494060033114579, -4.43994656177839],
            [16.494531440229583, -4.437434988665497],
            [16.495283665194002, -4.436357485063126],
            [16.495877912432562, -4.435698738616439],
            [16.496431250393037, -4.434442309273688],
            [16.49635079907285, -4.433924408734531],
            [16.496108643814946, -4.431972197546811],
            [16.496221748895756, -4.428983140138945],
            [16.496534337461785, -4.426471890826734],
            [16.497285992894312, -4.425115434154506],
            [16.497204823820177, -4.424238875939015],
            [16.497834523071422, -4.421467954560415],
            [16.4986264374017, -4.420390374193869],
            [16.499180928799049, -4.419711785282138],
            [16.49993553968886, -4.419829809610719],
            [16.501164589507741, -4.418950597828089],
            [16.503264226312904, -4.416634986142458],
            [16.503856407426277, -4.414960045753398],
            [16.504448426842931, -4.413205403587702],
            [16.50567681909504, -4.412007384384208],
            [16.507145353480492, -4.411765297513792],
            [16.50901236615292, -4.412239711677179],
            [16.51123541800338, -4.412075783837846],
            [16.514012694451523, -4.411113702468239],
            [16.515201441355227, -4.409955605188483],
            [16.514999658182845, -4.408342062382829],
            [16.514955355967952, -4.406070660781939],
            [16.512883164491381, -4.402289060972237],
            [16.511886259104816, -4.400139145877421],
            [16.509059363313632, -4.396159801157777],
            [16.508300773785447, -4.394049242520042],
            [16.508576605985006, -4.393012561628282],
            [16.509088168691562, -4.390740027025778],
            [16.510909891002292, -4.388464839873187],
            [16.512060441540111, -4.388063999432587],
            [16.512974706412098, -4.388620056415504],
            [16.513410783685288, -4.388300365720052],
            [16.514998051096804, -4.387898636130175],
            [16.516545935467896, -4.387656386227948],
            [16.516703295152855, -4.386938752975989],
            [16.517457304171408, -4.386777816693173],
            [16.518405636752249, -4.384544249121345],
            [16.519434333516692, -4.382788726432723],
            [16.520064323822098, -4.380197150484087],
            [16.522164540938917, -4.378240195008682],
            [16.525139135034173, -4.376759660532231],
            [16.52704106612001, -4.374922654417946],
            [16.528623281406343, -4.372050185850595],
            [16.530324750741592, -4.36925717529609],
            [16.531470727956258, -4.366624702664722],
            [16.531505904186165, -4.36439300384127],
            [16.531620804999211, -4.362320544714641],
            [16.532452406000459, -4.36128273542629],
            [16.532250595878594, -4.359649278077862],
            [16.532446108810305, -4.358174412498174],
            [16.532403665209742, -4.356819582935358],
            [16.531049359697541, -4.354590717575085],
            [16.529021617759515, -4.353080525853001],
            [16.526873338978351, -4.350853259758252],
            [16.526154976008584, -4.348981739706615],
            [16.523965938866354, -4.346216558175167],
            [16.521974257100478, -4.342873130583839],
            [16.519184750988053, -4.337598538649037],
            [16.517711195020162, -4.335250310023263],
            [16.51643685753454, -4.333260332079336],
            [16.51635452244717, -4.331786018364242],
            [16.516628127723159, -4.329633526978418],
            [16.517261083367284, -4.328516434844158],
            [16.518886977437688, -4.32763645437071],
            [16.52051111709833, -4.325879759190286],
            [16.522134692616959, -4.323844109128337],
            [16.522646633514228, -4.32177084456991],
            [16.522086807022415, -4.319739584846372],
            [16.521287685508629, -4.317150894763555],
            [16.521245131415288, -4.315716354358426],
            [16.521674668054914, -4.312128929490686],
            [16.521154160823091, -4.309898332684369],
            [16.519797640065377, -4.306473886138128],
            [16.517848124320626, -4.304285989166968],
            [16.516691617952482, -4.301618293322875],
            [16.516607219434917, -4.299087935295006],
            [16.515769565585295, -4.297057212054875],
            [16.513939653334091, -4.295108159879341],
            [16.513102641779891, -4.293396234928166],
            [16.511106008500182, -4.28740263314556],
            [16.510028961712198, -4.284734751230927],
            [16.507401193673413, -4.280754843217824],
            [16.506087244077015, -4.278725031031118],
            [16.505046703923838, -4.274403241062134],
            [16.504842939966256, -4.27169377074144],
            [16.504481096773173, -4.269343269155317],
            [16.503207420447584, -4.267592320498004],
            [16.50054533227339, -4.266322298601058],
            [16.497526375776143, -4.265252216025812],
            [16.49422955419184, -4.264182661315953],
            [16.491445055288803, -4.26117930470352],
            [16.490012255885354, -4.259229370901714],
            [16.489650933715158, -4.257117950258561],
            [16.489446482546391, -4.254009941799635],
            [16.489678683572595, -4.250901087325185],
            [16.491101618575915, -4.247730152878777],
            [16.492682980462707, -4.244379580757214],
            [16.493631516961127, -4.242225774831004],
            [16.493189750657216, -4.239556594048867],
            [16.491440596950042, -4.238205031143564],
            [16.488462981820515, -4.237931817881331],
            [16.487710311291703, -4.238730296065794],
            [16.486123064541491, -4.239012313023617],
            [16.48493207634116, -4.238934902555886],
            [16.484098414604674, -4.23889665366157],
            [16.483501704185606, -4.238220325845321],
            [16.482069741113719, -4.236668868480387],
            [16.480043502955468, -4.23571631691123],
            [16.478652530908306, -4.234842246462826],
            [16.477914979025741, -4.23330362124333],
            [16.477740542367229, -4.23181081608888],
            [16.477852332314459, -4.230432321281856],
            [16.478936005075973, -4.228764827354193],
            [16.480593212620533, -4.227900233078269],
            [16.48230609055992, -4.226231534132645],
            [16.482989559370793, -4.224679662817056],
            [16.483388763496528, -4.222882381024536],
            [16.483500005471424, -4.222381555236038],
            [16.484468601350095, -4.220369711569114],
            [16.48538119445735, -4.218989687298798],
            [16.485492540636812, -4.2173814838198],
            [16.486690585103673, -4.215713772075361],
            [16.489147111791421, -4.21401968989486],
            [16.490115141731486, -4.211720708890843],
            [16.491025750460285, -4.209306982517344],
            [16.492223227191886, -4.207352130788854],
            [16.493478336238866, -4.205626881182471],
            [16.495193442898451, -4.205164163035454],
            [16.497024479840384, -4.20550520920992],
            [16.497537957755089, -4.204815086167764],
            [16.497706924571837, -4.203436491416529],
            [16.497760178498503, -4.201368983830708],
            [16.496955341004547, -4.199245698428051],
            [16.496494194446694, -4.19738017531154],
            [16.496033543758902, -4.195773076556673],
            [16.495400862999222, -4.193936594829675],
            [16.494483613025551, -4.192847219953578],
            [16.494767858846057, -4.19192782801135],
            [16.494993925277214, -4.190491694793418],
            [16.494646482976467, -4.188252667341086],
            [16.495216066070554, -4.186988161562692],
            [16.496241377983036, -4.18474650836628],
            [16.497441986241714, -4.184457069364752],
            [16.498698372693035, -4.183420959791871],
            [16.500300781208626, -4.183877310755491],
            [16.501959404498081, -4.18381669943907],
            [16.504816543869943, -4.182375512061463],
            [16.508074380367546, -4.181105830408629],
            [16.510645947107189, -4.179894890399051],
            [16.512758386701783, -4.177880845930471],
            [16.517103251168486, -4.176781319681598],
            [16.518541241935964, -4.177024952266616],
            [16.547039999677239, -4.167290053497252],
            [16.553430000160805, -4.160589983175807],
            [16.561402061420502, -4.155915672873608],
            [16.566459839676448, -4.15295009841572],
            [16.578590039791248, -4.148070111409027],
            [16.580659447388783, -4.146580135934538],
            [16.581840120234677, -4.145730049863408],
            [16.585679879983463, -4.142970070680701],
            [16.592013310858643, -4.142540794628639],
            [16.596450000215384, -4.142240078734401],
            [16.599635079463173, -4.140290153021612],
            [16.608570120334356, -4.134820038807434],
            [16.611141682582446, -4.134526626918376],
            [16.612689960415668, -4.134349970531649],
            [16.617744296327469, -4.136629165253658],
            [16.634009880072931, -4.133340085275936],
            [16.643633283776676, -4.136668236409423],
            [16.662260160213364, -4.143110101343888],
            [16.67486988012849, -4.142830039992387],
            [16.678835471390698, -4.146324768183142],
            [16.680849840109069, -4.148099950341595],
            [16.688429999647944, -4.151059979041559],
            [16.693011351003104, -4.150348981056161],
            [16.694100659794703, -4.149614020765648],
            [16.697130120292577, -4.147570030861259],
            [16.697447858900134, -4.147126284330755],
            [16.698085846008198, -4.146235284551169],
            [16.698239999605878, -4.146019996680592],
            [16.702589880265144, -4.139949972008437],
            [16.710540290329835, -4.12288995836154],
            [16.715339999672693, -4.119190054448426],
            [16.726259031832633, -4.117810750358944],
            [16.730459999665548, -4.117280078841733],
            [16.739927050695787, -4.108473975032043],
            [16.747359839815662, -4.101560041965318],
            [16.761089880162686, -4.096210003006998],
            [16.765481766942923, -4.092869023233108],
            [16.772962788407057, -4.087179370124294],
            [16.781205751013715, -4.08503570275839],
            [16.784650079560908, -4.084139967210844],
            [16.785399109217852, -4.084136491642083],
            [16.795419839568396, -4.084089991363524],
            [16.81725996013197, -4.096879995187265],
            [16.82184995956835, -4.097089963754393],
            [16.823469215987139, -4.096337850196687],
            [16.827339960426674, -4.094539961391578],
            [16.853180039998541, -4.074900086396702],
            [16.854749999569442, -4.073709993787514],
            [16.860992163408415, -4.06754688280849],
            [16.863419880226683, -4.065149899002399],
            [16.872800039914409, -4.061660109551535],
            [16.878279959878604, -4.057029985206605],
            [16.910430120416496, -4.021450027688599],
            [16.915389840372676, -4.003480029370438],
            [16.932499920435284, -3.986830025333134],
            [16.93685086020826, -3.985659774877574],
            [16.946930159816993, -3.983310049775455],
            [16.955375958421538, -3.983275828303617],
            [16.959309840052502, -3.98325988811419],
            [16.973730000336776, -3.980440013254368],
            [16.984080000069888, -3.985679894694899],
            [16.990239959975504, -3.981509963034408],
            [17.012419920397551, -3.981819926308293],
            [17.01348640659106, -3.981833552492478],
            [17.014770000317405, -3.981849951907933],
            [17.015696481378953, -3.982127409434377],
            [17.022350159856281, -3.984120015560279],
            [17.024165347821658, -3.986202520803566],
            [17.032740120246473, -3.996039997030452],
            [17.041922675724543, -4.002508514319278],
            [17.043770159921035, -4.003809941220926],
            [17.059600079618303, -4.007189952545514],
            [17.079173676159876, -4.02203504691594],
            [17.080999919691465, -4.023420101349778],
            [17.099138199750158, -4.028169515288155],
            [17.101549709164061, -4.027429941752945],
            [17.108290080456211, -4.025359966681784],
            [17.12032991993491, -4.016019984964671],
            [17.120969777335365, -4.015524752955829],
            [17.126790120164685, -4.01101995584285],
            [17.134070040277731, -3.999470021983036],
            [17.138099879947344, -3.981039982956982],
            [17.154757621433436, -3.965542214549648],
            [17.169999839915661, -3.944070053984873],
            [17.171790689825045, -3.942823880668571],
            [17.174339999905236, -3.941049924456153],
            [17.182685093773163, -3.940455187020714],
            [17.188089840019419, -3.940070002172948],
            [17.191969919751386, -3.936610059976014],
            [17.197002013376753, -3.925395138637409],
            [17.199154778344418, -3.920595428525735],
            [17.199219960101441, -3.920450102652691],
            [17.20697003956959, -3.912590000457782],
            [17.217399959718566, -3.89091005232502],
            [17.218001437496834, -3.883626968293995],
            [17.219130120345678, -3.869959958090323],
            [17.217399959718566, -3.845809939866995],
            [17.218504579395898, -3.84241017374111],
            [17.219199959867453, -3.840269944427607],
            [17.225344885568447, -3.834188698625564],
            [17.233700039669266, -3.825920057258485],
            [17.236299959934232, -3.821550072261313],
            [17.234927039532675, -3.814874365560566],
            [17.234410143528319, -3.812357974253095],
            [17.234517679054324, -3.811110275010991],
            [17.235720000400274, -3.797160030052765],
            [17.2409198400319, -3.785629957888264],
            [17.259159960297733, -3.767819948561729],
            [17.260733054989007, -3.762405461677716],
            [17.267259959620187, -3.739939927005571],
            [17.270757133360597, -3.733051664058381],
            [17.278152331579104, -3.718487680171537],
            [17.28407988025273, -3.71246996563695],
            [17.287738684268962, -3.71079184603805],
            [17.294479919740422, -3.707699953156015],
            [17.296980598624412, -3.706559337882084],
            [17.297790119934266, -3.706190096660336],
            [17.30189988001975, -3.702489994143426],
            [17.30576015998453, -3.695789913375207],
            [17.306879618033715, -3.690262401987042],
            [17.303590079989743, -3.675549975029656],
            [17.303550120230991, -3.667730062639403],
            [17.307879840000297, -3.663799935814271],
            [17.311709243072144, -3.662293945928357],
            [17.313829920217888, -3.661459945340563],
            [17.321715312018959, -3.660004314595436],
            [17.329161240796513, -3.658628060093969],
            [17.332110000242508, -3.653319931511653],
            [17.332549769591537, -3.649401329786715],
            [17.331552991765758, -3.646331669306485],
            [17.328819960040295, -3.637919943869402],
            [17.318249999725033, -3.631530004412342],
            [17.317392675465634, -3.63044966808136],
            [17.314790039593547, -3.627170011959887],
            [17.313586792982889, -3.623170081043784],
            [17.311029840036262, -3.614669991592773],
            [17.304990119631405, -3.59454997846054],
            [17.29578961042408, -3.587229450688507],
            [17.286789960022691, -3.574389941645675],
            [17.286723668846282, -3.573429940878979],
            [17.286519959685954, -3.570479911300777],
            [17.291250000186917, -3.552960024259828],
            [17.290760040166358, -3.54697997646999],
            [17.286829919781475, -3.53963995715972],
            [17.284880722938624, -3.537894218396339],
            [17.282229840349295, -3.535520029090897],
            [17.279910000416866, -3.53000991401187],
            [17.279289002247474, -3.518401678566937],
            [17.278629840051558, -3.506079896767573],
            [17.276950080301766, -3.500880101185294],
            [17.273270159588158, -3.489540108392451],
            [17.274014393139801, -3.482218085430886],
            [17.274369959803959, -3.478719881500359],
            [17.280060119680613, -3.471559935774231],
            [17.28404027263354, -3.463154667766607],
            [17.286320159993725, -3.458339978677284],
            [17.299997529420668, -3.447853568918231],
            [17.301449879757946, -3.446740047573591],
            [17.302360132753893, -3.446274008984598],
            [17.308540080174563, -3.443109946002308],
            [17.319761783499807, -3.433287229212065],
            [17.320169880048571, -3.432930007461541],
            [17.32088723600689, -3.431179201416114],
            [17.326500120107863, -3.417480075078394],
            [17.330079960414004, -3.397179987029672],
            [17.330280120330634, -3.396060028009654],
            [17.332874547397644, -3.392845476195556],
            [17.334380159746459, -3.390979984729241],
            [17.342160119875892, -3.390710113048823],
            [17.344231928670172, -3.392079566211626],
            [17.345778023597248, -3.391726784077806],
            [17.348350624297783, -3.391139255016816],
            [17.353139084038322, -3.38628094544193],
            [17.355443117215025, -3.380026518083638],
            [17.355879714612769, -3.378841010926863],
            [17.359200000192288, -3.363469991368471],
            [17.358030000230279, -3.35886998208408],
            [17.354681795910032, -3.35329178788724],
            [17.352249839941958, -3.349240065461915],
            [17.342110080121312, -3.338020063975932],
            [17.339753948251378, -3.33426791125824],
            [17.338650119989826, -3.33251005326163],
            [17.339100120251626, -3.329289928187834],
            [17.346610080044325, -3.3218900957269],
            [17.356271753775818, -3.315340711138331],
            [17.360300159734233, -3.312609952598056],
            [17.363842651684116, -3.308146768956352],
            [17.365124853920058, -3.306536485139207],
            [17.365989960284743, -3.305450020346768],
            [17.380889999695452, -3.264879983156008],
            [17.377589880395771, -3.248090051536684],
            [17.368297058513182, -3.23327110415034],
            [17.35910028000923, -3.218605097630188],
            [17.356249709118746, -3.214057229634384],
            [17.353730303056032, -3.198510864070721],
            [17.360870040170688, -3.198729882523944],
            [17.364591369625632, -3.198068831502587],
            [17.366330160367692, -3.197759954779995],
            [17.373415906038801, -3.193190220118058],
            [17.37568069810893, -3.19173017610178],
            [17.379748635329747, -3.192850561351352],
            [17.392888746639791, -3.196469582285225],
            [17.397229057546344, -3.197976232062841],
            [17.397470159978685, -3.198059930297984],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kenge",
        AREA: 89974,
        POPULATION: 2152000,
        DISTRICTS: ["Kahemba", "Feshi", "Kenge"],
        OBJECTID: 12,
        NOM: "Kwango",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [17.612207280402554, -4.233137976709314],
            [17.623960199776125, -4.243199875371921],
            [17.625356279644016, -4.246873975442386],
            [17.624496239777525, -4.257003989108763],
            [17.629806239812446, -4.263417989827612],
            [17.636535359705682, -4.277189026976389],
            [17.638441188581524, -4.289374946512965],
            [17.637358769868161, -4.290646242695568],
            [17.634111479591983, -4.294459891121117],
            [17.633919984824555, -4.296347731184963],
            [17.632593359999479, -4.309426022714523],
            [17.631231996424084, -4.312078101826333],
            [17.629869130865508, -4.314733213236204],
            [17.626131719770324, -4.326036777912657],
            [17.626171320203003, -4.329941045837473],
            [17.627653079586057, -4.334038663503003],
            [17.632847520342828, -4.339132753564597],
            [17.638218359678675, -4.341348220310811],
            [17.644187520112883, -4.34170907764912],
            [17.651997360005304, -4.341027079053997],
            [17.657120879668728, -4.339134550737821],
            [17.667997199631845, -4.33657726623114],
            [17.6809323603098, -4.334208130953876],
            [17.691384960224767, -4.330421417161255],
            [17.700809040343383, -4.326643310380287],
            [17.710455599920209, -4.324507412800332],
            [17.721520920029246, -4.320304430197887],
            [17.732162520090096, -4.314871986039262],
            [17.743005359842591, -4.309026690721852],
            [17.752416840191014, -4.304015425748208],
            [17.760801960293083, -4.299218353192938],
            [17.771221079997389, -4.292143460931698],
            [17.7763154403467, -4.287373990016441],
            [17.783051039788067, -4.282179442001675],
            [17.787536280390935, -4.278237004501568],
            [17.791213680431888, -4.275739900133956],
            [17.793881279770371, -4.275100975624757],
            [17.800091639655005, -4.278953747591244],
            [17.80650971967771, -4.283010306340984],
            [17.810875080105959, -4.287494943697459],
            [17.813790360239626, -4.290964306059696],
            [17.816917320285171, -4.295048297775182],
            [17.820042480106864, -4.298926847458276],
            [17.822348999820267, -4.303223224306389],
            [17.825087520252097, -4.309571054841638],
            [17.82572724021033, -4.316874920858571],
            [17.823379346789878, -4.323323392361186],
            [17.822117019779615, -4.326790028164883],
            [17.803369440311467, -4.33632998404405],
            [17.797222373026791, -4.343958003794782],
            [17.794114141956637, -4.345816419855868],
            [17.793337282492182, -4.346280886984052],
            [17.790145296996506, -4.346672752549687],
            [17.779587480107242, -4.347968884339491],
            [17.777641103076082, -4.349155388688884],
            [17.777302128295212, -4.349362095966819],
            [17.776389761563394, -4.350794310155957],
            [17.774801279629639, -4.353287872264238],
            [17.773029359918258, -4.363882964665557],
            [17.770076279575722, -4.368731915053638],
            [17.761699440143968, -4.373993968549733],
            [17.760081910287202, -4.375009996607019],
            [17.757509400316476, -4.376625879344742],
            [17.750674965532621, -4.382348497982682],
            [17.748380277529822, -4.384269879095866],
            [17.746968398991044, -4.384084595752139],
            [17.743330440380955, -4.383606885781951],
            [17.739225359619784, -4.387541939117296],
            [17.736240239964342, -4.386868967096951],
            [17.732798575820272, -4.383738213111672],
            [17.730707220583717, -4.381835943753623],
            [17.730692081276231, -4.381836025807507],
            [17.727955129302899, -4.381851037155594],
            [17.726929439199672, -4.384431363250497],
            [17.724563280334575, -4.390383868790185],
            [17.720455319574608, -4.393627949689746],
            [17.719246838480768, -4.393404116614357],
            [17.715633480234722, -4.39273485404149],
            [17.712593964893905, -4.389551994274802],
            [17.711479359543873, -4.388384918322575],
            [17.708730616284104, -4.388860902983395],
            [17.707820940006592, -4.39024639949539],
            [17.706911400272972, -4.391631869957243],
            [17.704233359815962, -4.404532975359089],
            [17.70472994131849, -4.408335708396738],
            [17.705194199640491, -4.411890892508106],
            [17.704556510773127, -4.414246657996117],
            [17.704071235466731, -4.416038794538169],
            [17.698384245744737, -4.410881208012134],
            [17.696001239874803, -4.408720026625627],
            [17.693783279675355, -4.421617957141558],
            [17.690135443190449, -4.424526648307321],
            [17.68419432007455, -4.429263922084394],
            [17.686763279903246, -4.437303860295591],
            [17.679699291428307, -4.445396139467836],
            [17.674713360428786, -4.455778993147792],
            [17.673318763679433, -4.454884645391899],
            [17.670799440261721, -4.453269011955149],
            [17.669326839203013, -4.45044574642277],
            [17.667089279560692, -4.446155882893498],
            [17.662973400151476, -4.448479018557475],
            [17.662623054495747, -4.449919539045255],
            [17.661180239775195, -4.455851944278413],
            [17.662123800505221, -4.460556451296791],
            [17.663067360336949, -4.465260927780777],
            [17.668806480193208, -4.465704916398513],
            [17.672258033890259, -4.467526971601242],
            [17.664540573148386, -4.474152903505468],
            [17.663357123609931, -4.475168899599044],
            [17.658895864431873, -4.471097465008864],
            [17.657592589515986, -4.469908066438385],
            [17.652549240000088, -4.470625961639275],
            [17.646869274205297, -4.479861016984568],
            [17.654286736269832, -4.480570713346015],
            [17.674179479977305, -4.482474028919969],
            [17.676950388268423, -4.485680044215389],
            [17.6751803074084, -4.496964971868868],
            [17.67658427987439, -4.501789945500946],
            [17.689502159661217, -4.514605908037766],
            [17.685857160055946, -4.51899696313717],
            [17.688106207354114, -4.520780317343931],
            [17.689316212888997, -4.521739772895949],
            [17.6929894797813, -4.522409893687962],
            [17.696705399581624, -4.530442865086449],
            [17.696056320076433, -4.537120021044594],
            [17.688299399937421, -4.54452599424436],
            [17.68708046694525, -4.547363638479752],
            [17.686714365737728, -4.548216090021953],
            [17.687049298998158, -4.548768839901833],
            [17.688104258009943, -4.550509860024721],
            [17.686603313307348, -4.55224254531813],
            [17.681495431516396, -4.558138826783052],
            [17.67690216041575, -4.557013854953013],
            [17.675295796617974, -4.553408114617585],
            [17.674345440132807, -4.551274880489411],
            [17.670435308161302, -4.54945503575304],
            [17.646423559805747, -4.562471937774572],
            [17.648849713555396, -4.563913782626875],
            [17.652178439705317, -4.565891889571764],
            [17.65240035681818, -4.567184306955707],
            [17.652652200406379, -4.568651015232597],
            [17.643312359803545, -4.579975931608471],
            [17.640221605457217, -4.579763489357344],
            [17.637115320137937, -4.579549979732866],
            [17.6358612603232, -4.580821995947911],
            [17.634607200508491, -4.582094100915761],
            [17.634647161165578, -4.588996863094446],
            [17.635635360080407, -4.601418003313123],
            [17.640922320124908, -4.603229903442372],
            [17.641928907553588, -4.604796968385839],
            [17.642542320348721, -4.605751932912906],
            [17.640274371598693, -4.609458369512963],
            [17.6373154800546, -4.614293962120064],
            [17.637868576368291, -4.6191452515599],
            [17.638521480001629, -4.624871921886616],
            [17.638188301150961, -4.626155642516998],
            [17.638042235085749, -4.626718397012641],
            [17.637624581360733, -4.628328179035964],
            [17.635315628111222, -4.628892734542284],
            [17.634627727012735, -4.629060978075616],
            [17.632812361180935, -4.629504953646387],
            [17.63178556794654, -4.632124313719564],
            [17.631456489006826, -4.632963882978253],
            [17.631696427222593, -4.634728821955985],
            [17.632175379287684, -4.638251893799982],
            [17.628140197337064, -4.643544730950494],
            [17.622839159793752, -4.650497894069426],
            [17.616430486030353, -4.653293851303382],
            [17.617134090578336, -4.655748248662186],
            [17.618538240012423, -4.66064598855943],
            [17.616944838904164, -4.663884236145312],
            [17.616495240189295, -4.664797945942662],
            [17.610166236211843, -4.663837394661516],
            [17.604786240348286, -4.663020873784931],
            [17.60234577463951, -4.66665360244091],
            [17.601373439972583, -4.668100955392618],
            [17.602102431808806, -4.675229921922365],
            [17.601652231222719, -4.675915372964443],
            [17.60028227975317, -4.678000909351251],
            [17.596298159839961, -4.678249870099457],
            [17.592254280400777, -4.678503861002715],
            [17.586534239862836, -4.681295956656913],
            [17.586326160398627, -4.684978967910818],
            [17.588190222105357, -4.689800903319091],
            [17.586830160188786, -4.693028938713948],
            [17.581560480137053, -4.693976980883303],
            [17.580851397662471, -4.694541929989639],
            [17.578361284762909, -4.696525883977071],
            [17.577257373856327, -4.699910806614965],
            [17.576557199974424, -4.702057920126242],
            [17.576591399735619, -4.708270025689941],
            [17.571581279800423, -4.714509914339503],
            [17.571148200205311, -4.719113996688172],
            [17.564436360304875, -4.749523007550541],
            [17.561683157808051, -4.752312287836043],
            [17.561241360063111, -4.752759874493793],
            [17.554146477627224, -4.755788949285598],
            [17.553270240237836, -4.763386896519564],
            [17.545273200423377, -4.7694120170737],
            [17.540739360065306, -4.77910001515898],
            [17.541048077790773, -4.780163156593074],
            [17.54167320012564, -4.782315907484183],
            [17.544773685023127, -4.784929046980056],
            [17.546285163370722, -4.786203059382196],
            [17.546420461330595, -4.790741885881599],
            [17.546566171662956, -4.795634954589044],
            [17.546466774873384, -4.798282122489034],
            [17.546367239743294, -4.800929022255998],
            [17.539777439567466, -4.812698019808978],
            [17.541011716683027, -4.814790361846085],
            [17.541401308835216, -4.815450795735563],
            [17.543701291508306, -4.816129043490719],
            [17.545997235355848, -4.816806098361551],
            [17.547157406850349, -4.819101924373844],
            [17.536417199619073, -4.826981022418815],
            [17.535349428834717, -4.841022111072182],
            [17.534889532731754, -4.845547362216011],
            [17.534694239887298, -4.847468981660205],
            [17.532648360065373, -4.850471025686066],
            [17.52625562331345, -4.851466080643993],
            [17.523475200066844, -4.851898864114026],
            [17.521421399799078, -4.853980905765732],
            [17.523515159825632, -4.859031903735925],
            [17.522685659983861, -4.860476746891337],
            [17.521925399589236, -4.861800984705781],
            [17.517896557049568, -4.864864343044856],
            [17.517355179258782, -4.865276025610017],
            [17.516342277571969, -4.868079735472752],
            [17.514190439665636, -4.874035980573676],
            [17.508238040896305, -4.876598121928202],
            [17.504131319811435, -4.880991904389123],
            [17.499820359560182, -4.889757024455407],
            [17.500868820159202, -4.892627954792777],
            [17.501917320284093, -4.895498979874622],
            [17.498783160241544, -4.909780024478727],
            [17.503626066871458, -4.913896723797657],
            [17.504335440400165, -4.917573945602528],
            [17.500944265168332, -4.927025039562325],
            [17.501254023142906, -4.928435730935809],
            [17.502357409433351, -4.93346006817046],
            [17.506736279625148, -4.936887855943845],
            [17.518900320175007, -4.936593921726591],
            [17.519146199848048, -4.939814977365625],
            [17.514581579615093, -4.944209772146351],
            [17.513454239747578, -4.947896904661883],
            [17.519521320141028, -4.966041958197201],
            [17.518394240784968, -4.969496814314923],
            [17.514784439867501, -4.980561873097857],
            [17.516443302108815, -4.990215973290512],
            [17.516340100055704, -4.990613220508417],
            [17.515545479999769, -4.993671890787981],
            [17.512797070913287, -4.995319707663159],
            [17.510513399849128, -4.996688886900157],
            [17.509532984836245, -4.998064942396137],
            [17.508154319708485, -4.999999953011676],
            [17.507551320184103, -5.000845940362851],
            [17.506654275117814, -5.004762597295684],
            [17.504621279831994, -5.010294994926661],
            [17.505067639221959, -5.013306282088903],
            [17.505098279857989, -5.013512992436976],
            [17.506400139028987, -5.014118985847317],
            [17.509010399801202, -5.015334015868287],
            [17.509125334750202, -5.015747564020238],
            [17.509712399958069, -5.017859884228221],
            [17.507454479999872, -5.024544978401286],
            [17.509323239895519, -5.030516907864828],
            [17.511825076707865, -5.032520061217314],
            [17.515318320318944, -5.035316996606475],
            [17.5279672436114, -5.039851872304004],
            [17.527519998482592, -5.040760943419114],
            [17.525697480264501, -5.044465017909997],
            [17.525949480159561, -5.048374915238603],
            [17.526651255737622, -5.050234293676593],
            [17.529676200404555, -5.058248920001964],
            [17.529241319687298, -5.062621898294998],
            [17.524221479980707, -5.067709875731244],
            [17.521278479634002, -5.075087927343276],
            [17.518695568968948, -5.077936123218539],
            [17.513521262152619, -5.083641832960272],
            [17.514911159814719, -5.086164986988176],
            [17.515658629996334, -5.086318482971169],
            [17.519279400241761, -5.087062021934798],
            [17.52411636002449, -5.090257911663723],
            [17.525594026683102, -5.092129498313351],
            [17.526270239801423, -5.092985975705729],
            [17.528278282583567, -5.09552782455039],
            [17.525573345668622, -5.098479508904045],
            [17.522346239638598, -5.102000869934574],
            [17.522590319986111, -5.104761015348921],
            [17.524152296229111, -5.106694376407203],
            [17.525366280402373, -5.108196999100662],
            [17.529251564074794, -5.108986884617964],
            [17.530880305804633, -5.109318009514376],
            [17.535032280420285, -5.112746987003475],
            [17.536410360744803, -5.113084998658936],
            [17.537788440171056, -5.113423011034297],
            [17.540991209941719, -5.111104960816335],
            [17.54352431980405, -5.112701931018918],
            [17.536686480405265, -5.121250909216636],
            [17.538233833872045, -5.123549711888656],
            [17.539001416434576, -5.124689879194144],
            [17.541997197295803, -5.125251018968929],
            [17.54497528493917, -5.125808843650934],
            [17.541145439896219, -5.138943022234028],
            [17.53850670252951, -5.140340509626708],
            [17.535881159617674, -5.141731007322793],
            [17.532741428223762, -5.154861600021457],
            [17.529942912907345, -5.153013343006274],
            [17.529285240118153, -5.152578939166705],
            [17.52607332010799, -5.152825925248608],
            [17.519468400387652, -5.162062894879614],
            [17.518247443491152, -5.168596708935516],
            [17.517015376231186, -5.175189910943919],
            [17.516026351764623, -5.176500835205109],
            [17.514053280396482, -5.179115954979667],
            [17.510317186231511, -5.180997086027611],
            [17.509283280136735, -5.188113999121486],
            [17.507664182719768, -5.189560774414328],
            [17.501514479778077, -5.195055930697775],
            [17.498012295234986, -5.196021068796822],
            [17.49555648001294, -5.196697845985435],
            [17.49344930364764, -5.198689354577601],
            [17.492130360316544, -5.199935895161255],
            [17.491455403042998, -5.202282098071244],
            [17.491003232451476, -5.203853870547103],
            [17.491638094320638, -5.205197857261605],
            [17.494255440105498, -5.210737944890553],
            [17.491083479854122, -5.218347996406648],
            [17.487606407714793, -5.220864579209528],
            [17.486282159831969, -5.221823020168394],
            [17.482183200191152, -5.22805601115487],
            [17.488201319706672, -5.236537005727443],
            [17.487289439861744, -5.237920910064323],
            [17.481590518716136, -5.237583191127179],
            [17.480169359682144, -5.237498973216843],
            [17.47949221231594, -5.239572904917924],
            [17.480230165745404, -5.248311451466244],
            [17.478838404977424, -5.250234691697224],
            [17.477724352091307, -5.251774171071485],
            [17.478853930560458, -5.25383859744734],
            [17.480737439894785, -5.257280895586629],
            [17.479949011926106, -5.25909616973103],
            [17.47643147966641, -5.267194858229478],
            [17.479212479631386, -5.271781910127805],
            [17.481123359734106, -5.27926289330486],
            [17.481323156731374, -5.280052962337954],
            [17.481119399960335, -5.284654901807918],
            [17.477354643249608, -5.287665497595521],
            [17.476776378836572, -5.288127957093011],
            [17.481167280164961, -5.293166878588984],
            [17.480178077831972, -5.294267890097455],
            [17.478883440217544, -5.295708855897954],
            [17.477428941110109, -5.311388465821461],
            [17.477367480174998, -5.312051011650633],
            [17.477203320243348, -5.323783851106824],
            [17.479320451738648, -5.333204934409457],
            [17.478466610247629, -5.33487302657167],
            [17.476368479917202, -5.338971981509355],
            [17.476635052282813, -5.34564096717716],
            [17.472511440175651, -5.347272894541246],
            [17.471225159588322, -5.36407301221143],
            [17.468721371635144, -5.367997027974711],
            [17.468971200302189, -5.371675948795851],
            [17.475208199726548, -5.37831489313335],
            [17.472488400185227, -5.384770029316752],
            [17.471360136849629, -5.385912733783241],
            [17.46906336026381, -5.388238900881669],
            [17.46826159949968, -5.391525664550153],
            [17.468164463769703, -5.391924043097618],
            [17.469452880550797, -5.396518500233409],
            [17.470741319789752, -5.401113004931711],
            [17.473489585145799, -5.402984734563352],
            [17.474428197955245, -5.4036240610252],
            [17.47747440035506, -5.414419950775602],
            [17.474102280187019, -5.427549875022063],
            [17.473404225430873, -5.427728394031697],
            [17.471349359761184, -5.428253900238541],
            [17.47021823978298, -5.431251018838657],
            [17.472999239747956, -5.435837003394715],
            [17.477834400205165, -5.437881945529861],
            [17.478650028262322, -5.442815008890494],
            [17.478784439585024, -5.443627946454929],
            [17.483859477172569, -5.446838813256364],
            [17.487079199949285, -5.448875853988151],
            [17.479318320036501, -5.457196950413412],
            [17.479349279574436, -5.462717970585518],
            [17.477060400078269, -5.464109968857226],
            [17.474806439893843, -5.471712885624489],
            [17.47497642989169, -5.474361084287544],
            [17.475057413912854, -5.475622154312645],
            [17.47647647987224, -5.483435958238262],
            [17.485233480044023, -5.488680999876649],
            [17.485046280121953, -5.496273015654026],
            [17.487611280176914, -5.503620960792151],
            [17.491207163495687, -5.507775057776334],
            [17.491773239566935, -5.508429006342736],
            [17.494352065592388, -5.509846372173385],
            [17.500066199707348, -5.512986944524949],
            [17.507650319918326, -5.51409790092082],
            [17.507909159585953, -5.519386977987947],
            [17.509300199905095, -5.521449927031163],
            [17.514118289676961, -5.520504050250063],
            [17.515503359792728, -5.521876867072055],
            [17.51466071759836, -5.523301638900218],
            [17.513456436128447, -5.525338057746864],
            [17.513690204714848, -5.526103273664477],
            [17.514158400352731, -5.527635861853323],
            [17.518044847343425, -5.527913816972458],
            [17.520130439887431, -5.528062976498041],
            [17.52337835988261, -5.533911960660518],
            [17.526626279877757, -5.539760886206542],
            [17.534239003345711, -5.545701799787481],
            [17.529913440081177, -5.55239491006038],
            [17.528934033876368, -5.556120856224925],
            [17.528339159613768, -5.558383920834068],
            [17.522644346463949, -5.566694014814277],
            [17.524271086747319, -5.570365985523],
            [17.522447399821036, -5.572906854415456],
            [17.523391319877202, -5.577272004694421],
            [17.522314206613864, -5.580999857556868],
            [17.520462360198366, -5.587408976604684],
            [17.521256675725418, -5.591549125037592],
            [17.523063360238339, -5.600965856799646],
            [17.522441027172427, -5.603521244837025],
            [17.521717320125028, -5.606492871412764],
            [17.519740163218991, -5.608828129952685],
            [17.514871200055936, -5.614578915871347],
            [17.519720219721364, -5.619154682331261],
            [17.51907348032751, -5.626748931024571],
            [17.518421159700793, -5.633192007973288],
            [17.520746400304702, -5.638240026971745],
            [17.521007397725661, -5.643988911845612],
            [17.520786905340863, -5.645104270370859],
            [17.518549319647427, -5.65642299856961],
            [17.516052359788723, -5.661726017624239],
            [17.523252360384227, -5.675718907096146],
            [17.532037471536182, -5.686022898787869],
            [17.537327280138481, -5.686914907436538],
            [17.539877159750528, -5.691041930272789],
            [17.541990339556929, -5.699311049968855],
            [17.540201236870768, -5.707830007206878],
            [17.551679400226465, -5.706619905491606],
            [17.553549095268327, -5.707133597232447],
            [17.557430400302373, -5.708199969651855],
            [17.565460199878615, -5.706317018827197],
            [17.573510160344782, -5.70764996908947],
            [17.579689920017557, -5.704630068380808],
            [17.582501167156501, -5.704901110941428],
            [17.583629413424124, -5.705009884262251],
            [17.586319125691624, -5.704382939612721],
            [17.593466399671495, -5.702716978333127],
            [17.599903199686448, -5.703602867953343],
            [17.606046239823666, -5.693450020011801],
            [17.612634238877344, -5.692177036598907],
            [17.613390072374237, -5.69203098808323],
            [17.614456254937192, -5.695029987732276],
            [17.615022480128765, -5.696622950194327],
            [17.617320900631537, -5.696724899790675],
            [17.619619320236044, -5.696826850268518],
            [17.624460239792509, -5.699791917723535],
            [17.627430239903408, -5.696785963178149],
            [17.630418961803148, -5.69745981063],
            [17.631081876262002, -5.701309776359072],
            [17.63136844243088, -5.702974033894452],
            [17.63574606037119, -5.705020922482868],
            [17.637394319797195, -5.711912951209968],
            [17.641573199853916, -5.719709864134603],
            [17.644930920027949, -5.716070815645584],
            [17.654172839773274, -5.706321322706503],
            [17.657425800215499, -5.703959913371574],
            [17.660983680306195, -5.701007242289288],
            [17.664258239841132, -5.697757761898923],
            [17.672791679881392, -5.693335605117852],
            [17.678603520156553, -5.693348158911665],
            [17.684698680089145, -5.693657328953356],
            [17.691276239820883, -5.698112121375455],
            [17.697980735095523, -5.701922616792139],
            [17.710058520310145, -5.702593419393958],
            [17.715544200271893, -5.704085444444232],
            [17.724751199807187, -5.70795393123197],
            [17.732845440030349, -5.709747570985815],
            [17.74069127990775, -5.709764428268961],
            [17.747686799690054, -5.708891458973994],
            [17.75349863996518, -5.708904012423036],
            [17.760713760105233, -5.710991925795107],
            [17.766967319971851, -5.714422987682917],
            [17.768561964348461, -5.714544622932452],
            [17.778228479999342, -5.715281960825117],
            [17.781716842165125, -5.716828966890636],
            [17.782835400102421, -5.717325019360223],
            [17.787116177858429, -5.716666009170466],
            [17.789032439768029, -5.716371007545448],
            [17.795446383048866, -5.713344699922117],
            [17.800014239911793, -5.7089499205574],
            [17.815925159799939, -5.680569996137425],
            [17.817428059236587, -5.67645787476499],
            [17.820221400256955, -5.668814865322071],
            [17.83092924029021, -5.654033942771365],
            [17.845770239725514, -5.63899993334917],
            [17.846960041251346, -5.635785597387905],
            [17.847831239990281, -5.633431980678628],
            [17.849333427062898, -5.629377347943978],
            [17.849611440371977, -5.628626943993138],
            [17.855387639988226, -5.628599861763493],
            [17.860278239973205, -5.630682688751234],
            [17.864034839981151, -5.631578913760268],
            [17.870066279715697, -5.634552391340323],
            [17.876700359648481, -5.636638962946702],
            [17.886566519583059, -5.637252342730305],
            [17.893810080384952, -5.638156090832269],
            [17.900202959969015, -5.638169900352454],
            [17.906879520333273, -5.638480355737395],
            [17.912974680265869, -5.638789555544498],
            [17.916528249341528, -5.641126505109581],
            [17.916270533466299, -5.642879327788769],
            [17.916088320092381, -5.64411892338318],
            [17.913122301314822, -5.647816873479493],
            [17.913410894981315, -5.649926973672649],
            [17.913845134301475, -5.653101963398946],
            [17.913185297470775, -5.655123483992354],
            [17.91249119979344, -5.657249957088219],
            [17.914034159600181, -5.666329914071281],
            [17.921828160397482, -5.66959732897575],
            [17.926945559838881, -5.674344992215168],
            [17.931212279859015, -5.678202921092102],
            [17.936592120314003, -5.684135385781377],
            [17.944260840265201, -5.691553031965603],
            [17.950484160144427, -5.69867145625071],
            [17.957345040431932, -5.703423000359339],
            [17.963965079696852, -5.706101644853814],
            [17.969479200320507, -5.706409552675255],
            [17.979359039800215, -5.706430892102352],
            [17.986056839931049, -5.70585327406415],
            [17.993357280260124, -5.704388870402093],
            [18.001543320220474, -5.702334108673975],
            [18.006554159706244, -5.699384476871704],
            [18.013287240271548, -5.697326828291335],
            [18.020048759702103, -5.69408485852619],
            [18.028238400110116, -5.690850940109324],
            [18.027803160066753, -5.694763991289018],
            [18.030163641579264, -5.702034967530182],
            [18.031082399824331, -5.704864989937465],
            [18.031462812990945, -5.711437362201615],
            [18.031854410182852, -5.718199947111263],
            [18.047372040453098, -5.718123376016569],
            [18.055785240094266, -5.718733619377762],
            [18.063042840665762, -5.719045286015632],
            [18.069436079575961, -5.719059094471463],
            [18.075240719854087, -5.719367712381392],
            [18.082788840080049, -5.719680095815527],
            [18.088877160240074, -5.720285316575716],
            [18.092867759701445, -5.723550448220716],
            [18.091861560344942, -5.729173108229314],
            [18.089933759575562, -5.736865956113802],
            [18.090104039729237, -5.741899066483951],
            [18.09323675977237, -5.74457035534404],
            [18.09900611961605, -5.746359036982781],
            [18.105066000012467, -5.74814843093767],
            [18.111707279942291, -5.749938895304091],
            [18.116300160275763, -5.752317146203712],
            [18.118823400348088, -5.756171135358489],
            [18.119277000159229, -5.761501012288319],
            [18.119107080229991, -5.768605642845624],
            [18.114911639731016, -5.77392536057004],
            [18.111594599764604, -5.778950965834376],
            [18.103529160427787, -5.788110906416626],
            [18.09989352036947, -5.794320130060328],
            [18.099808560404817, -5.797872427411288],
            [18.0997236004402, -5.801424701203459],
            [18.099574920277533, -5.80764130660792],
            [18.0997095597723, -5.814154574997261],
            [18.104791679677525, -5.820382512054855],
            [18.108618839656121, -5.818318493532189],
            [18.114217920244425, -5.81507399589526],
            [18.117194760127887, -5.812120116793638],
            [18.120185639780924, -5.808574006534671],
            [18.12344580022015, -5.805916650743031],
            [18.129357000453933, -5.801784732501922],
            [18.132808679915112, -5.803272369795924],
            [18.135055440102533, -5.80653379071896],
            [18.139223160388479, -5.814535934263207],
            [18.139676760199617, -5.81986579157596],
            [18.140031360276566, -5.829339890646275],
            [18.139266360370492, -5.837035303349817],
            [18.134744760456471, -5.843834723368436],
            [18.129719520078396, -5.84737630514043],
            [18.122681519864617, -5.850025574404399],
            [18.116770679855303, -5.854157490002925],
            [18.108003240361583, -5.856210797448128],
            [18.101581920115649, -5.857381141739554],
            [18.097435799820715, -5.860628617984542],
            [18.097039080435017, -5.865068454313846],
            [18.099867240155817, -5.868331124793091],
            [18.104133960175982, -5.872188790767091],
            [18.112561199586722, -5.872207077039691],
            [18.123383880245918, -5.869269996834819],
            [18.132406199633532, -5.868697387036844],
            [18.139380480547558, -5.868712446680356],
            [18.144278279631212, -5.870499115147751],
            [18.148871159964717, -5.872877387971305],
            [18.154009439846554, -5.876737174676166],
            [18.156299039791556, -5.87822227956163],
            [18.160005960269391, -5.881190684489185],
            [18.163145880309525, -5.883565863377283],
            [18.168957719686322, -5.883578411991004],
            [18.173082600214684, -5.881219009396238],
            [18.174903840130142, -5.877966455302396],
            [18.176491439918276, -5.872344940114814],
            [18.179136360389109, -5.867278947762196],
            [18.181410479666834, -5.863355988578137],
            [18.179764200127696, -5.857615999055482],
            [18.183120731830602, -5.85212585691878],
            [18.183857205734849, -5.850921230482898],
            [18.182922479935609, -5.848396966708602],
            [18.178800480304371, -5.850491888429632],
            [18.17844390034055, -5.848769426944923],
            [18.178087331156494, -5.847046922302276],
            [18.180126360426087, -5.839629940065659],
            [18.180559438224535, -5.838061908892847],
            [18.185581245241604, -5.83320106605454],
            [18.184393439772322, -5.826768872388441],
            [18.188244360190176, -5.818236019141778],
            [18.185682275168332, -5.812961978013719],
            [18.19094831973808, -5.810169920665725],
            [18.195539399847771, -5.80968187732431],
            [18.198053280373134, -5.807597020553339],
            [18.19968992458254, -5.804595859997493],
            [18.207365399864639, -5.790520910818565],
            [18.204342480000367, -5.785018999461527],
            [18.204321240233792, -5.78179994850784],
            [18.21097336372738, -5.780378894529658],
            [18.212461940425136, -5.778302574371663],
            [18.216438480353968, -5.772755916422279],
            [18.223408440371493, -5.76971879255222],
            [18.226534319743763, -5.772685986412589],
            [18.229879800372043, -5.778614229551267],
            [18.23294160022013, -5.784245661514218],
            [18.234827279884172, -5.790466582821385],
            [18.238115880086973, -5.798763008092008],
            [18.24166727973121, -5.808244101312203],
            [18.24431112042706, -5.81920330440595],
            [18.245296440241393, -5.82660661511847],
            [18.245126520312155, -5.833711311202312],
            [18.244368360178647, -5.841110663094806],
            [18.244453680367702, -5.849696231829689],
            [18.244184759805943, -5.860945225883236],
            [18.246925439787734, -5.868936004210783],
            [18.24864631183479, -5.869640839038548],
            [18.249691320208196, -5.870068852805173],
            [18.250256117078447, -5.869867092186914],
            [18.254276280095826, -5.868430981236135],
            [18.262270349181652, -5.862061561189128],
            [18.263876236872367, -5.860782032292317],
            [18.269285400134848, -5.844649931451358],
            [18.272706893507561, -5.842047103959504],
            [18.27477224790649, -5.840476060542627],
            [18.27860183962456, -5.843552887179208],
            [18.279983879722884, -5.846516460095663],
            [18.278445960363193, -5.850065554294635],
            [18.275696280160584, -5.855684429079701],
            [18.274108680372443, -5.861305935444298],
            [18.274597919944163, -5.865155583299906],
            [18.278318880191531, -5.867531907371514],
            [18.284960160121322, -5.869322525167599],
            [18.294266160289098, -5.869046618453779],
            [18.303040440453717, -5.866697192664387],
            [18.309220560350926, -5.863454053970169],
            [18.316052999976559, -5.857251880349559],
            [18.31849811985683, -5.852224294941457],
            [18.32007131965096, -5.84719504893115],
            [18.320503679695531, -5.841275067982686],
            [18.322055639723089, -5.837133732366574],
            [18.326747519790789, -5.835367572439941],
            [18.33460775966223, -5.83479241750898],
            [18.341241924934938, -5.834207963479145],
            [18.34951428041769, -5.816552991554663],
            [18.368458180402975, -5.797803954434281],
            [18.382715280293482, -5.799553897530798],
            [18.389860560013432, -5.785882256963371],
            [18.392242319920094, -5.78132496926992],
            [18.396829440255978, -5.78014585882257],
            [18.39701215578814, -5.781184540071107],
            [18.399456360285136, -5.795078930403767],
            [18.404823239847207, -5.807694916795293],
            [18.412677545447888, -5.814085022639216],
            [18.429807959775228, -5.815458940547471],
            [18.437965559972, -5.814588466898793],
            [18.442033920299316, -5.814597252925816],
            [18.446648040399399, -5.816087365957935],
            [18.450035999662528, -5.820239436956152],
            [18.451432439754857, -5.822610754299543],
            [18.455344919922503, -5.829132093908494],
            [18.459313920291166, -5.833285323072557],
            [18.461015280031965, -5.835065293436571],
            [18.465317279588241, -5.837442823043324],
            [18.470512800119991, -5.838934308627441],
            [18.475098480456495, -5.84160853939466],
            [18.477947519719429, -5.843983171118795],
            [18.479010959725812, -5.848130013133493],
            [18.480357720287994, -5.852573535901888],
            [18.484560720110078, -5.859095597934523],
            [18.49020984045297, -5.865916797294883],
            [18.494256960115386, -5.866813722927418],
            [18.503265239733391, -5.866833084364366],
            [18.511416000157599, -5.86625868008576],
            [18.518971320380565, -5.866274993797315],
            [18.522408960072134, -5.868354609792314],
            [18.526016519693016, -5.875467553433898],
            [18.530517600289304, -5.881694081953451],
            [18.535046760424766, -5.886736637068827],
            [18.539440919942692, -5.885265896576897],
            [18.543324600122332, -5.880833573564363],
            [18.546988679944221, -5.873440492276806],
            [18.551262599961355, -5.864864436632997],
            [18.554642999901375, -5.857174610468707],
            [18.55938456039755, -5.85333620122768],
            [18.564905880119909, -5.853348033556428],
            [18.569810519874459, -5.854838939131846],
            [18.571264183548692, -5.85653284138697],
            [18.569975400254979, -5.862171852965824],
            [18.56747232017425, -5.873116900192172],
            [18.565758725379315, -5.878097850059278],
            [18.563190479711238, -5.885562948702464],
            [18.552467159909, -5.896671918050983],
            [18.549746762988008, -5.905366149262234],
            [18.548645278431017, -5.908886084611392],
            [18.541097280375958, -5.913994992147894],
            [18.539098200085387, -5.924126962621418],
            [18.545881320405275, -5.941561019049565],
            [18.54875519988245, -5.958560916500855],
            [18.548635219096486, -5.962537555746555],
            [18.548380439813904, -5.970981891794706],
            [18.546563491150582, -5.973646687732293],
            [18.546333478420376, -5.973984116652403],
            [18.546204960045966, -5.979126459862434],
            [18.539394120411341, -5.984440554615758],
            [18.534971520231505, -5.987095431517646],
            [18.532838159772275, -5.991235450608463],
            [18.535680360160974, -5.993906066111502],
            [18.540095760343771, -5.991547142235035],
            [18.54739619977455, -5.9900827793769],
            [18.553519800369045, -5.989207744990588],
            [18.560203199607543, -5.989222262580308],
            [18.568857240271367, -5.991905256102331],
            [18.576689040379197, -5.992514300771864],
            [18.584003519579543, -5.990457742929099],
            [18.599518080306471, -5.985754552218375],
            [18.613289160187225, -5.98104755568172],
            [18.624693240379763, -5.978111778947238],
            [18.6369757202066, -5.97488167130185],
            [18.644283000308242, -5.973121154815252],
            [18.650052360151889, -5.974909991336268],
            [18.658167840141626, -5.975815520236397],
            [18.666850319670726, -5.977314514956789],
            [18.674979840328323, -5.977628186982654],
            [18.683399879742097, -5.977942396659266],
            [18.69152940039973, -5.978255888443275],
            [18.700239960366268, -5.978570814564701],
            [18.705398408324569, -5.981213950151714],
            [18.705483534477519, -5.981858371409569],
            [18.706855320306872, -5.992242937117187],
            [18.703195200258723, -5.994566907076102],
            [18.702066239830476, -5.997563892345814],
            [18.702431490333414, -6.003007763249007],
            [18.702837359958576, -6.009056991452852],
            [18.695547359849698, -6.018074896966291],
            [18.696083455546653, -6.021002964368606],
            [18.696262282271945, -6.02197968174885],
            [18.693308164375299, -6.026598880547609],
            [18.693482958563255, -6.026763177232116],
            [18.69816636033131, -6.031164974681444],
            [18.698723223280997, -6.033038456634293],
            [18.698795279844877, -6.033280878385235],
            [18.69896612593719, -6.03385406358414],
            [18.700285319898239, -6.038279904447268],
            [18.70466040009785, -6.039629972734217],
            [18.705006179617001, -6.041802398623657],
            [18.706342320295864, -6.050196874158449],
            [18.707474551490073, -6.052078037417359],
            [18.710064360318206, -6.056380889941734],
            [18.712200239653502, -6.066024879311842],
            [18.714275219500731, -6.07070542291513],
            [18.720840279175295, -6.085513992883866],
            [18.726873479607818, -6.093751025319264],
            [18.724605488636957, -6.098135884055702],
            [18.724870440441773, -6.102963004069736],
            [18.728559359579606, -6.10477792810911],
            [18.73065023960736, -6.10775296957658],
            [18.727918382878297, -6.111680694941048],
            [18.729172511863315, -6.114953774849791],
            [18.729324361282305, -6.115350072977011],
            [18.729374400138592, -6.122477943156888],
            [18.747629279724539, -6.137963871298819],
            [18.764847719966589, -6.132653099596927],
            [18.77099256032766, -6.130890057644661],
            [18.776031839576973, -6.126756320715415],
            [18.779334480447673, -6.122322762803062],
            [18.786053520345082, -6.120857146141048],
            [18.793070279893954, -6.119096035649605],
            [18.797159879987845, -6.118216733412012],
            [18.801887039591715, -6.114970449687644],
            [18.806926319739365, -6.110836587957223],
            [18.812823119979107, -6.10729691240839],
            [18.819882359959458, -6.103759542912764],
            [18.82786284022999, -6.098151849967941],
            [18.834567480133391, -6.097278246983636],
            [18.837693360403957, -6.100245445722556],
            [18.841655520101753, -6.104694600861231],
            [18.841591799903707, -6.107358914568804],
            [18.838253520170724, -6.113272575340307],
            [18.829302120079898, -6.123022687545255],
            [18.828870120259769, -6.128942623102929],
            [18.833030639650378, -6.137240851009378],
            [18.837850320338603, -6.142284052016812],
            [18.845611200251419, -6.145853416431858],
            [18.849438720454415, -6.143789208350601],
            [18.852734160429815, -6.139651809991638],
            [18.85694400002447, -6.133740058208342],
            [18.860586840079787, -6.127234939231415],
            [18.863911080043199, -6.121913307351167],
            [18.868893479765362, -6.120147721737623],
            [18.871990920272353, -6.124299070708949],
            [18.871842240109686, -6.130515730626438],
            [18.871275599896425, -6.142060070479135],
            [18.870893279606474, -6.158045692673187],
            [18.870411959582299, -6.178175659971108],
            [18.870163920359307, -6.188536609677127],
            [18.869972759765165, -6.196529487643648],
            [18.865500840279587, -6.201256428960583],
            [18.860298479975274, -6.200061036307287],
            [18.854862120217529, -6.196496879448631],
            [18.848617919897841, -6.190266490343856],
            [18.842593319935862, -6.186997001635663],
            [18.838588679806623, -6.18432395412954],
            [18.832784040426795, -6.184015420851169],
            [18.831791879941569, -6.189045988678488],
            [18.83253600030547, -6.194376434383489],
            [18.834704999626986, -6.2008939769139],
            [18.837781200367402, -6.205933339387062],
            [18.841686839864156, -6.212750832748008],
            [18.847073520091715, -6.218387398299276],
            [18.852134040005932, -6.225503203629453],
            [18.855791640279691, -6.23054393998116],
            [18.861157079842382, -6.23706855359113],
            [18.867330720191461, -6.246259198626108],
            [18.873439919893624, -6.245976320750273],
            [18.879018120041465, -6.243619956760367],
            [18.88519103994167, -6.240672919141492],
            [18.894298680416636, -6.236547934510046],
            [18.901407239702696, -6.230938439788375],
            [18.90904788011472, -6.227402443553134],
            [18.916525440370069, -6.226281998387281],
            [18.923433480413362, -6.2278438841246],
            [18.92507148018052, -6.231970909523284],
            [18.922832280214532, -6.240033884508526],
            [18.926296200119758, -6.242310005125494],
            [18.934667280452221, -6.255586906472658],
            [18.9301143598775, -6.261596879837509],
            [18.931522314575123, -6.265495928246591],
            [18.930893402248103, -6.273777996946509],
            [18.931143828294786, -6.274114451742857],
            [18.933447239837296, -6.277208903474591],
            [18.93322552664204, -6.279734601441881],
            [18.933023159564708, -6.28203990284126],
            [18.93521137834172, -6.288126873368978],
            [18.936073367552378, -6.290524917508566],
            [18.931963319107659, -6.294232937783145],
            [18.931753440317966, -6.296992995771435],
            [18.934257239949204, -6.298637963409142],
            [18.935217360223195, -6.299268863618642],
            [18.944020080151386, -6.308297898679502],
            [18.948903480139325, -6.310676715281358],
            [18.955558799838684, -6.31187525543392],
            [18.962866079940362, -6.310114792725781],
            [18.969620759598342, -6.307168852527593],
            [18.972583200386136, -6.30480703710677],
            [18.977919839960816, -6.30037786520221],
            [18.982711079987133, -6.294467226330314],
            [18.99012455982, -6.288266320119245],
            [18.9934059600258, -6.284720864528479],
            [18.997821360208629, -6.282362170814709],
            [19.005766560044691, -6.278234653226715],
            [19.013378759794808, -6.275882736040051],
            [19.024165799795096, -6.274425792503716],
            [19.032316560219297, -6.27385128993349],
            [19.040647458010795, -6.273158900094377],
            [19.045712159582671, -6.272696013157105],
            [19.052119440059034, -6.272117747723041],
            [19.05536555983036, -6.270052429237501],
            [19.05923520024043, -6.266212158091214],
            [19.061417880005372, -6.259999983054938],
            [19.063940759853292, -6.25171625102656],
            [19.066151880280138, -6.244319898648599],
            [19.069603559741317, -6.233669651548278],
            [19.072998000349202, -6.225387826795136],
            [19.076931720283422, -6.218883311963515],
            [19.082233080321963, -6.215934341942259],
            [19.086329520188421, -6.214758869467004],
            [19.090419120282309, -6.213879727933362],
            [19.095394680231905, -6.212410246711691],
            [19.096627679943097, -6.209452461264527],
            [19.096889759833989, -6.198499245927933],
            [19.09798812005041, -6.189028250846132],
            [19.101085200332964, -6.181041707633295],
            [19.106421839907647, -6.176612549875347],
            [19.111390199860239, -6.175439139193442],
            [19.116812519848377, -6.179595426206666],
            [19.123722153503021, -6.187055724605818],
            [19.124202055087348, -6.187457307624551],
            [19.132864200351648, -6.194704848724868],
            [19.144603440180081, -6.196233862469371],
            [19.150493040422827, -6.19299021221568],
            [19.157580720166784, -6.188268750102111],
            [19.163732400300418, -6.186209726793544],
            [19.173357359886239, -6.184750202503144],
            [19.178644680155177, -6.182393380886518],
            [19.182394440390556, -6.176418863023788],
            [19.182447360143964, -6.168142934911204],
            [19.18371196618013, -6.164254005430607],
            [19.189012320105519, -6.147953989454681],
            [19.201063320253294, -6.13217000655976],
            [19.201557940733554, -6.131219335402466],
            [19.205950319790603, -6.122777014998124],
            [19.205774380250649, -6.115571970845507],
            [19.205585280391748, -6.10782787383947],
            [19.207471912269988, -6.104850633417306],
            [19.210228199581511, -6.100500984664127],
            [19.217169359611024, -6.093189942999456],
            [19.22047343958284, -6.098110992841514],
            [19.224400319744461, -6.104040346947777],
            [19.228425840314202, -6.105825341080579],
            [19.235045880477418, -6.108503985398368],
            [19.243168200239719, -6.109113612705011],
            [19.251836639999215, -6.111204656392549],
            [19.256422320335719, -6.113878792933215],
            [19.263892679695736, -6.117447453459843],
            [19.275402959619498, -6.122209154286439],
            [19.287778319856795, -6.127268448175815],
            [19.29814739980652, -6.131139489258289],
            [19.30744940336961, -6.134722890893106],
            [19.315265400315003, -6.134084995104677],
            [19.321026480386671, -6.13159391367596],
            [19.330742159934733, -6.121540945778146],
            [19.337185440396112, -6.120203987632317],
            [19.33792994883223, -6.120227080411873],
            [19.349918279810858, -6.120598929500439],
            [19.352879259937968, -6.120690605503714],
            [19.356024240188123, -6.120787977577942],
            [19.365194159963384, -6.124527002531607],
            [19.386348479689616, -6.12236594773591],
            [19.392086119122258, -6.123783256584185],
            [19.391608430986782, -6.126768427572659],
            [19.391130399694852, -6.12975571977694],
            [19.395710129590917, -6.132314886324298],
            [19.395996278941539, -6.134101825784582],
            [19.396373399782657, -6.136457981686661],
            [19.394273160207941, -6.141501906795064],
            [19.385205789410527, -6.146867249946577],
            [19.382742360068153, -6.148324900069406],
            [19.381334426930092, -6.152914936793052],
            [19.381451362427264, -6.153728045828569],
            [19.381996440378725, -6.157516931610481],
            [19.3683664804392, -6.16892396601415],
            [19.359735548936072, -6.173324593567963],
            [19.355455440424937, -6.175506866568345],
            [19.341175320306942, -6.180700921051262],
            [19.334713191394265, -6.184797112395786],
            [19.330084440433161, -6.190054890956296],
            [19.32402255409869, -6.203501090106066],
            [19.321670160118678, -6.208718969459493],
            [19.320784667386931, -6.210684993029961],
            [19.319132159827912, -6.214353966886404],
            [19.317763927733843, -6.214239398457246],
            [19.316145239948654, -6.214103857577549],
            [19.314025179047217, -6.211760018079261],
            [19.313635320095354, -6.211329006491979],
            [19.312036760860764, -6.213431330809912],
            [19.310157360420561, -6.215902989044061],
            [19.305553320316278, -6.217251884736998],
            [19.304769240193586, -6.232191986592077],
            [19.301418959866712, -6.241213121034996],
            [19.294718400111329, -6.259254918434189],
            [19.296823516639719, -6.261388324486941],
            [19.298372385564399, -6.262958001863],
            [19.297857240376487, -6.271690854803415],
            [19.2991791598261, -6.280665917238371],
            [19.302582240430404, -6.287815974160035],
            [19.304196422266152, -6.289678510031639],
            [19.310798160153738, -6.297295907715568],
            [19.312348508603705, -6.300591559541791],
            [19.313293319788595, -6.302599979608348],
            [19.313616239878741, -6.309788959512602],
            [19.314273759954325, -6.324497343890767],
            [19.314302400042223, -6.325137998228176],
            [19.320677102216482, -6.334835673445569],
            [19.323999359598069, -6.354857992904702],
            [19.331363168883893, -6.353757195754472],
            [19.331964360099583, -6.367784864773062],
            [19.330486226317017, -6.3836368883943],
            [19.33721712038292, -6.382187568091727],
            [19.342479959763754, -6.383146659382096],
            [19.3473846004166, -6.386012459625396],
            [19.352287079722895, -6.389569567695256],
            [19.35877536039014, -6.391374708591908],
            [19.362110760124295, -6.391325098190956],
            [19.365972840312924, -6.39126778614758],
            [19.370892959836425, -6.389812068488618],
            [19.378271879683691, -6.387973967410027],
            [19.382664960324938, -6.386698772981928],
            [19.386532440286754, -6.385085611408869],
            [19.39075416010105, -6.382602905742911],
            [19.393575119824849, -6.379103957169026],
            [19.396396799997479, -6.375431969842821],
            [19.398518639563168, -6.371078993837856],
            [19.399760280169104, -6.367430411098628],
            [19.40135903972805, -6.36204802675749],
            [19.40295311996265, -6.358048322288408],
            [19.406152079978188, -6.346937427866129],
            [19.408450680144046, -6.342235827041766],
            [19.410398279782321, -6.337539377655833],
            [19.414028159843014, -6.330620006006449],
            [19.423387439988637, -6.303782953889081],
            [19.425625199955242, -6.299697883622517],
            [19.427448903949507, -6.296368611160813],
            [19.429662239621862, -6.292328015251991],
            [19.440502200273858, -6.286420866437681],
            [19.445358240273201, -6.281625019841984],
            [19.449490511241422, -6.282110756923353],
            [19.451559262170477, -6.282353939895059],
            [19.454540399594258, -6.283752990299241],
            [19.456844400431596, -6.282617978239752],
            [19.459367316212102, -6.283554005150004],
            [19.460611625712712, -6.28481430125268],
            [19.463022359880554, -6.287255996824553],
            [19.467350634260598, -6.289020032842709],
            [19.469902177552569, -6.290059939307611],
            [19.471366065851367, -6.294779594714091],
            [19.472831449845096, -6.299504028925402],
            [19.473194721359466, -6.299815396531173],
            [19.475805239948183, -6.302052915761321],
            [19.47758156230277, -6.30267595867953],
            [19.49047991990188, -6.307200021008377],
            [19.492560982241891, -6.305379826007773],
            [19.499699880330059, -6.303590031026642],
            [19.503598833666146, -6.305219392724603],
            [19.514211840351518, -6.317327670478068],
            [19.517358239939789, -6.321084266248062],
            [19.521211319907597, -6.323447439122868],
            [19.524719879794223, -6.324086907472847],
            [19.529629199771414, -6.325742714534111],
            [19.537332120382068, -6.331506113140702],
            [19.544340600158964, -6.335205465862088],
            [19.552398480172673, -6.339926296913049],
            [19.558360799936022, -6.341566468862585],
            [19.565731079786872, -6.342148418021238],
            [19.574506080400326, -6.34270976872644],
            [19.587830400242506, -6.347352256944583],
            [19.597647239973007, -6.351009761213825],
            [19.610274239880969, -6.354279640674419],
            [19.620100079832323, -6.355516765323773],
            [19.634536440334386, -6.358003007261998],
            [19.64720124045121, -6.354173964138396],
            [19.653510856988206, -6.348445895946423],
            [19.655752319810411, -6.346411010095227],
            [19.657939361794394, -6.345442760193921],
            [19.660362160336486, -6.34437013486963],
            [19.676929320200927, -6.341483896866599],
            [19.678042975133359, -6.340687743704108],
            [19.683622440109115, -6.336698955656338],
            [19.687140114302654, -6.336914933852874],
            [19.687759185585737, -6.336953006669368],
            [19.687286159706602, -6.339019964199759],
            [19.688588671054486, -6.341529210669843],
            [19.689560279882624, -6.343400976930966],
            [19.6957512002245, -6.346197863409938],
            [19.696886279976511, -6.348733944388198],
            [19.696944830370096, -6.358604056326479],
            [19.697002200377394, -6.368274901961892],
            [19.698973118483792, -6.374987979243739],
            [19.701059400035604, -6.382093897590486],
            [19.704481185360773, -6.386712991034439],
            [19.704379444866639, -6.387183147233261],
            [19.703537279677661, -6.391074896483795],
            [19.706728320145686, -6.395922009009001],
            [19.706907240295745, -6.404659014662951],
            [19.708369759562064, -6.407378049968916],
            [19.709636512571759, -6.409732958362667],
            [19.710822131541605, -6.410295241475833],
            [19.713075479973341, -6.411363897036356],
            [19.713673320473028, -6.413972541226786],
            [19.713972240273719, -6.415276858698651],
            [19.716488245314721, -6.417590847978518],
            [19.718546399716683, -6.419212891751399],
            [19.720024702382538, -6.424503262955146],
            [19.720348179428154, -6.42566087435061],
            [19.719403486820848, -6.430361599151158],
            [19.718456400203316, -6.435074015574369],
            [19.717605609391004, -6.436219313411571],
            [19.715906160366828, -6.438507031139659],
            [19.713373199624815, -6.439410857974207],
            [19.710366891406764, -6.44023634889158],
            [19.706005412598874, -6.441434078122937],
            [19.704822479591716, -6.44717399286729],
            [19.71374543991897, -6.454584943205821],
            [19.71347616362436, -6.461249852044729],
            [19.714057511953733, -6.466366821077365],
            [19.71522718313237, -6.476661913156187],
            [19.713136320172595, -6.480326863201849],
            [19.708517158727137, -6.483976147736765],
            [19.708498439633253, -6.487194935118231],
            [19.714668480432998, -6.493668974602375],
            [19.716484319676937, -6.497818009972261],
            [19.704763440514611, -6.497055926953629],
            [19.703827440006023, -6.50003889665793],
            [19.708614360034137, -6.506963993974217],
            [19.709963280146237, -6.512258875032257],
            [19.708518765813178, -6.515460018508934],
            [19.708101360023157, -6.516385015128914],
            [19.702810440204853, -6.516811879875364],
            [19.701421200109561, -6.518182894216258],
            [19.701631440022023, -6.521631988583505],
            [19.707325200346308, -6.531322020029606],
            [19.701996480319171, -6.538414983096261],
            [19.702135478439722, -6.540217412417379],
            [19.702209245395906, -6.541174061091711],
            [19.702402199925686, -6.547610885733274],
            [19.703623119092939, -6.549964046697767],
            [19.704675287039144, -6.551991875335666],
            [19.709284648763166, -6.553174539585217],
            [19.710186324644759, -6.553405889149381],
            [19.710797008358078, -6.554645503680369],
            [19.712003399970573, -6.557094869470648],
            [19.708763411201037, -6.560751965984803],
            [19.709251795576584, -6.563265140902983],
            [19.70943439881934, -6.564204790903577],
            [19.707771286648423, -6.57338871275271],
            [19.708504941639276, -6.576396231786812],
            [19.709568360086099, -6.580754884680918],
            [19.711584137362856, -6.582686792991015],
            [19.713913052974593, -6.584918801449518],
            [19.714653586365554, -6.58779988592475],
            [19.716161399586824, -6.593666947080792],
            [19.719814319637937, -6.598285974799448],
            [19.72229544040152, -6.60657598192284],
            [19.725713442921009, -6.61188292158612],
            [19.727277070267508, -6.612485202722449],
            [19.734203160159812, -6.615152994330091],
            [19.73432840956492, -6.615600788245761],
            [19.736006399633595, -6.621599931083906],
            [19.740343320298237, -6.627141869102661],
            [19.752289199591463, -6.629053910722893],
            [19.753238972171687, -6.629249991749863],
            [19.754585279982965, -6.629527936699213],
            [19.755037311335606, -6.63153840959974],
            [19.756603423422174, -6.638503842316363],
            [19.759811399828212, -6.640591878171709],
            [19.762752239726662, -6.649113872400931],
            [19.76961131979035, -6.65605100688346],
            [19.77015159355167, -6.657936242274809],
            [19.772316360011558, -6.665489924726966],
            [19.773713458568995, -6.665371800251014],
            [19.777378227398724, -6.665061943866883],
            [19.778309403055935, -6.667046368914971],
            [19.779649199878016, -6.669901885939265],
            [19.78698343392977, -6.674312883590654],
            [19.786631239541144, -6.67547637379356],
            [19.785108240300037, -6.680506859639169],
            [19.785264600160058, -6.680744107089411],
            [19.786020480369366, -6.68189101820748],
            [19.793133952541723, -6.684818825881616],
            [19.795656240399854, -6.685856961052373],
            [19.798642144284532, -6.689163223739951],
            [19.805256359771434, -6.696486999994306],
            [19.808578247945416, -6.697855262748861],
            [19.811908440145896, -6.699226941629214],
            [19.811885781041177, -6.703306100663801],
            [19.811863439940062, -6.707328006416193],
            [19.817613405156745, -6.706903197936256],
            [19.818164974334437, -6.710323430407641],
            [19.818281138178765, -6.711043924253521],
            [19.817737463395801, -6.712159599545527],
            [19.815489360227016, -6.716772901710558],
            [19.816892821551587, -6.718450213237342],
            [19.818002469997868, -6.719776036052879],
            [19.823059439770095, -6.720265872535567],
            [19.824657479778466, -6.7223439957608],
            [19.825659174982121, -6.728448148677074],
            [19.82665836029285, -6.734536925632057],
            [19.831051389730128, -6.733811172175034],
            [19.834715159633287, -6.733205895433025],
            [19.836532424503588, -6.73689406270841],
            [19.836361417612828, -6.737507482716209],
            [19.835125200136272, -6.741941913287184],
            [19.841382102634089, -6.749818041292817],
            [19.84631537439169, -6.756027901941966],
            [19.845060962437355, -6.75783796153226],
            [19.843301160100822, -6.760377015159454],
            [19.845817200176143, -6.762689943164174],
            [19.851522237950526, -6.763614847215536],
            [19.853170222492089, -6.763882079719515],
            [19.855088907157956, -6.769413038453637],
            [19.855886400026176, -6.771711936621176],
            [19.857946319617671, -6.773562915679606],
            [19.861499255381045, -6.774396782904986],
            [19.865986200088042, -6.775449858418165],
            [19.866590393473398, -6.776152123277726],
            [19.870556506656751, -6.780761984735928],
            [19.874495750331661, -6.785542343943151],
            [19.876266348621279, -6.787690987997365],
            [19.876233083107994, -6.788151582351638],
            [19.875768479832942, -6.794581932755706],
            [19.876566893474322, -6.795735803957665],
            [19.877365433778124, -6.796889853735643],
            [19.887256440215154, -6.796489013434886],
            [19.888080002192908, -6.800945298189081],
            [19.888149229063629, -6.801319968411087],
            [19.887868569317735, -6.802037909516809],
            [19.886984280328463, -6.804299964621318],
            [19.889963279761847, -6.806156006629675],
            [19.890831234684335, -6.815583855134693],
            [19.900251360419055, -6.817247905462635],
            [19.902990209634293, -6.82117098654275],
            [19.902641925612134, -6.822696693371856],
            [19.901104200288547, -6.829432857265158],
            [19.905308972486704, -6.838108975992573],
            [19.907470556215539, -6.842568930379134],
            [19.909765440051043, -6.843502019524942],
            [19.917564480397122, -6.847453913823777],
            [19.924090380711814, -6.852777985546769],
            [19.930616280128209, -6.858101997030883],
            [19.931047200173364, -6.86338998404555],
            [19.93224705115226, -6.865684099021011],
            [19.933096358846061, -6.867307964027249],
            [19.936056240333581, -6.872610986748523],
            [19.937553480383951, -6.893301936489585],
            [19.946296439887835, -6.89266285613056],
            [19.94464836012488, -6.899776963156454],
            [19.945647731386877, -6.901802168379485],
            [19.945942200035319, -6.902398902082894],
            [19.946143830494098, -6.902805992863552],
            [19.946241359686205, -6.903002903021219],
            [19.952203320123409, -6.906024864698399],
            [19.950563159908, -6.911529861878481],
            [19.952804994632707, -6.920866615866036],
            [19.953712387392795, -6.924645922053626],
            [19.950708239622998, -6.92715586302439],
            [19.950577290407409, -6.927730078313902],
            [19.949295239986743, -6.9333518750529],
            [19.951803359616189, -6.937272956062527],
            [19.959615355465278, -6.938926995649683],
            [19.959060239738843, -6.956156938081312],
            [19.960809815654191, -6.958890506808984],
            [19.96407935989486, -6.963998859324217],
            [19.962213515032296, -6.968583795563523],
            [19.963911806128078, -6.973183114250335],
            [19.96561440015406, -6.977793857390534],
            [19.969961399916201, -6.981954976817351],
            [19.964431440197423, -6.9835319780925],
            [19.96281036019866, -6.985589977827911],
            [19.968757147192395, -6.991827982270036],
            [19.957606555403345, -6.996651893912373],
            [19.95722765230472, -6.996815812658042],
            [19.955837159957909, -6.999419926470213],
            [19.915999919701076, -7.000000010905992],
            [19.868000039698725, -7.000000010905992],
            [19.833999840155691, -6.998000030742634],
            [19.819000079663592, -6.999000111663855],
            [19.789999920059962, -6.999000111663855],
            [19.725974489749341, -6.999000111663855],
            [19.706000039775166, -6.999000111663855],
            [19.676000160363198, -7.001000087484713],
            [19.663999920418849, -7.000000010905992],
            [19.544000039851614, -6.999000111663855],
            [19.544000039851614, -7.005999900174825],
            [19.544000039851614, -7.012000068425732],
            [19.544487777440185, -7.0149266355208],
            [19.546999919725469, -7.029999925390009],
            [19.558717270305362, -7.049772914411642],
            [19.559173173396893, -7.050542232334367],
            [19.563000119576447, -7.056999994244698],
            [19.563000119576447, -7.057999946542076],
            [19.559000159669818, -7.058999896650263],
            [19.551999959664869, -7.068999990694571],
            [19.537999919879439, -7.081000027638933],
            [19.532999879940039, -7.087999993485139],
            [19.522000080252898, -7.113000011647746],
            [19.521495103994031, -7.113865702988402],
            [19.519830332634776, -7.116719641843803],
            [19.508000039569175, -7.136999947676818],
            [19.502999999629775, -7.169999966620854],
            [19.497165160686723, -7.173889830239229],
            [19.496999879657597, -7.174000015780375],
            [19.4965139261232, -7.175944384057262],
            [19.496000159849263, -7.178000029326944],
            [19.497993699331136, -7.183981111631085],
            [19.497999959690372, -7.183999893112461],
            [19.501999919597001, -7.190000034630361],
            [19.502999999629775, -7.192999896742329],
            [19.502000087581958, -7.196499332788392],
            [19.501046575315218, -7.199836353032407],
            [19.500999839564226, -7.199999913161313],
            [19.505000159695289, -7.208999953225859],
            [19.502999999629775, -7.213999976358465],
            [19.503482768636498, -7.216896329604546],
            [19.504000079662514, -7.21999989418658],
            [19.500999839564226, -7.227000024276452],
            [19.500004762249286, -7.229986066118812],
            [19.500000119755889, -7.229999996033984],
            [19.502809110326822, -7.233745514462984],
            [19.502999999629775, -7.234000045384121],
            [19.501595583396053, -7.238681631380327],
            [19.500000119755889, -7.244000011593882],
            [19.500641569869362, -7.249133059751682],
            [19.500999839564226, -7.252000001256309],
            [19.500000119755889, -7.256999898912292],
            [19.497855925614331, -7.258429309975997],
            [19.496999879657597, -7.258999986097919],
            [19.493999999783714, -7.266000039078512],
            [19.493715862659357, -7.268272956932194],
            [19.492999919750972, -7.273999990229687],
            [19.494308681576598, -7.282506354557972],
            [19.495000079816485, -7.287000071135472],
            [19.492133487472902, -7.289866361441703],
            [19.491999839718201, -7.289999994509235],
            [19.492256055406905, -7.291280976061015],
            [19.492999919750972, -7.295000000646102],
            [19.490864512929519, -7.296601599283674],
            [19.488999959844346, -7.298000048204559],
            [19.487999879811571, -7.302000020710715],
            [19.490185781833436, -7.305278905452058],
            [19.491999839718201, -7.30800000028402],
            [19.487000160003234, -7.312999980995227],
            [19.48716392467616, -7.313545889274209],
            [19.4880993924838, -7.31666425103069],
            [19.490000039877085, -7.322999950663892],
            [19.490039246847672, -7.323052227100163],
            [19.491603051162262, -7.325137315132472],
            [19.496000159849263, -7.331000119398213],
            [19.495000079816485, -7.333000050046786],
            [19.497999959690372, -7.341000037651418],
            [19.500966818392687, -7.341989062567455],
            [19.500999839564226, -7.342000070584519],
            [19.500999839564226, -7.344999976341038],
            [19.501957121161919, -7.349786009382542],
            [19.502999999629775, -7.354999932521086],
            [19.500000119755889, -7.358000107158477],
            [19.497999959690372, -7.3630000550994],
            [19.493999999783714, -7.36799994591639],
            [19.495043702905001, -7.369391627276636],
            [19.496999879657597, -7.371999995877525],
            [19.500297958883305, -7.378596385185789],
            [19.503657985032657, -7.385316571408646],
            [19.505970041961469, -7.389940716342581],
            [19.514999880247984, -7.408000046844879],
            [19.515854001115066, -7.410420042739916],
            [19.520893539977511, -7.424698383911472],
            [19.521000000220159, -7.425000008551096],
            [19.521157249412305, -7.425098292495171],
            [19.528999920033414, -7.430000080910864],
            [19.532999879940039, -7.432000094252269],
            [19.532344531092505, -7.433966578249869],
            [19.532000160131702, -7.434999917182067],
            [19.527000120192302, -7.435999913919705],
            [19.526000040159563, -7.44499995282209],
            [19.528999920033414, -7.446999896006945],
            [19.533318510574677, -7.44807961652127],
            [19.534804545938517, -7.448451150055977],
            [19.536999839846665, -7.44900000927405],
            [19.543433953898898, -7.455433911406265],
            [19.545000119884389, -7.45700001118002],
            [19.547799895537132, -7.464279419568602],
            [19.550000159823792, -7.470000012089536],
            [19.550000159823792, -7.472000017952591],
            [19.5492539607583, -7.473492294644191],
            [19.549000079791014, -7.47400001543533],
            [19.541999879786069, -7.46900009399447],
            [19.536999839846665, -7.46900009399447],
            [19.526784043925431, -7.472405366337025],
            [19.522000080252898, -7.47400001543533],
            [19.517000040313498, -7.48400004112991],
            [19.512000000374098, -7.488999966885535],
            [19.501091762370613, -7.496499527344391],
            [19.496000159849263, -7.500000027662357],
            [19.487836502312529, -7.502449160106979],
            [19.486000079970459, -7.503000093251392],
            [19.485968549104005, -7.503063145775779],
            [19.484999999937685, -7.504999945729894],
            [19.48940053839247, -7.516001509773635],
            [19.492999919750972, -7.524999929936658],
            [19.493999999783714, -7.532999948122552],
            [19.492626607766649, -7.534373347755212],
            [19.484999999937685, -7.54199992292489],
            [19.482999839872171, -7.545000051085752],
            [19.48200012006383, -7.551000065768373],
            [19.484999999937685, -7.55300005251146],
            [19.483999919904946, -7.556000103337416],
            [19.479999959998285, -7.560999902985981],
            [19.473999840026142, -7.56700004926241],
            [19.468000080278404, -7.570000001501374],
            [19.46199996030623, -7.571000040640425],
            [19.380999959895288, -7.568999960908569],
            [19.380999959895288, -7.571000040640425],
            [19.380999959895288, -7.571412265594837],
            [19.380999959895288, -7.573999964678403],
            [19.380600181746079, -7.575199239238115],
            [19.379999879862513, -7.577000046830176],
            [19.378790230060513, -7.5776598633023],
            [19.369000080175407, -7.582999967446086],
            [19.369951671844088, -7.587758010103631],
            [19.372480499437454, -7.600402109236899],
            [19.374000120114808, -7.608000005933645],
            [19.375454025435825, -7.611271346649111],
            [19.378000080021433, -7.617000002426233],
            [19.384999919801917, -7.627999974912995],
            [19.387000079867462, -7.637000080512959],
            [19.38726603509047, -7.637299283520181],
            [19.394999999680717, -7.645999994059696],
            [19.396766483686363, -7.648944251366493],
            [19.3979998804529, -7.650999981860386],
            [19.398996977180612, -7.665955213556185],
            [19.398999959587378, -7.665999946379987],
            [19.401000119652892, -7.674999953809612],
            [19.405938094989327, -7.680761239252238],
            [19.406999880298958, -7.682000045214448],
            [19.407582735103066, -7.687536793310572],
            [19.409000040364475, -7.700999982820108],
            [19.407999960331701, -7.704000053105487],
            [19.401999840359561, -7.709000064752156],
            [19.401264136311525, -7.712679583738179],
            [19.401000119652892, -7.714000015662304],
            [19.401000119652892, -7.714810640388862],
            [19.401000119652892, -7.719000085907462],
            [19.398999959587378, -7.722000027789637],
            [19.398079481966867, -7.7302837267598],
            [19.3979998804529, -7.731000080556669],
            [19.397938344957627, -7.731307849815642],
            [19.397000159746263, -7.736000125227254],
            [19.396246710378133, -7.737757988902731],
            [19.393999919647975, -7.742999907844275],
            [19.389999959741314, -7.757999964615534],
            [19.390315349254426, -7.761469013471006],
            [19.391000039774088, -7.768999983532948],
            [19.389999959741314, -7.772000099563926],
            [19.385999999834688, -7.774000105717811],
            [19.386479000408823, -7.778310786352754],
            [19.387000079867462, -7.783000103472354],
            [19.385368200322329, -7.784631706068665],
            [19.385342429453463, -7.784657474661125],
            [19.383999839769174, -7.785999940671443],
            [19.379999879862513, -7.788000057468442],
            [19.37000016020815, -7.802000070961412],
            [19.368195701720534, -7.803443591016777],
            [19.36500012026875, -7.805999961652327],
            [19.361999880170458, -7.811999993275702],
            [19.361999880170458, -7.820000078444434],
            [19.361999880170458, -7.822880173657037],
            [19.361999880170458, -7.833999897523901],
            [19.36500012026875, -7.849000042419195],
            [19.364000040236007, -7.861000012695481],
            [19.355000040389946, -7.866999955161865],
            [19.356000120422721, -7.878999933555257],
            [19.347999840385032, -7.883999969497408],
            [19.346000039645624, -7.89500001127815],
            [19.343000159771737, -7.899000066356136],
            [19.343000159771737, -7.901999948226485],
            [19.343475619187011, -7.902316948594864],
            [19.346000039645624, -7.90400003544075],
            [19.353999960357203, -7.908000003065555],
            [19.356999840231058, -7.913000039887129],
            [19.356999840231058, -7.927999961555448],
            [19.436508359690926, -7.958249612623976],
            [19.440631800219908, -7.979626100107879],
            [19.43568395958501, -7.998535179727083],
            [19.374000120114808, -7.999999955761689],
            [19.299999960382674, -7.999999955761689],
            [19.284648840036891, -7.999999955761689],
            [19.212907680037937, -7.999999955761689],
            [19.199999880246907, -7.999999955761689],
            [19.128517199691213, -7.999999955761689],
            [19.100000160335568, -7.999999955761689],
            [19.084283999692602, -7.999999955761689],
            [19.000000080199801, -7.999999955761689],
            [18.970567559653304, -7.999999955761689],
            [18.900000000064029, -7.999999955761689],
            [18.799999919928293, -7.999999955761689],
            [18.799999919928293, -7.992999927399378],
            [18.792963460325236, -7.983618151224974],
            [18.790999920082232, -7.981000105952874],
            [18.789776678769979, -7.978064339816648],
            [18.785999880142828, -7.968999926615638],
            [18.781868504794986, -7.967622784997],
            [18.780000120395126, -7.966999981607522],
            [18.779890464845, -7.966835515652089],
            [18.778848346351889, -7.96527249782203],
            [18.777999960329577, -7.96400004464106],
            [18.779000040362352, -7.959999916141242],
            [18.781421435735943, -7.959394564977242],
            [18.783000000268977, -7.958999921715344],
            [18.783000000268977, -7.958597704452991],
            [18.783000000268977, -7.956999927238408],
            [18.783000000268977, -7.949236017240994],
            [18.783000000268977, -7.945000106600134],
            [18.781999920236203, -7.938000018052861],
            [18.781999920236203, -7.936999969309935],
            [18.781999920236203, -7.936000097220244],
            [18.781999920236203, -7.932000049546131],
            [18.781999920236203, -7.927999961555448],
            [18.780000120395126, -7.922000023489413],
            [18.775599203749628, -7.922229811198945],
            [18.558158040234492, -7.933583045855988],
            [18.555684120366209, -7.948382844987431],
            [18.544961880338949, -7.963182817111431],
            [18.533000160154003, -7.972000004665793],
            [18.53156931907786, -7.987738128632215],
            [18.531000000088454, -7.994000015784573],
            [18.528393441273543, -7.995737781815835],
            [18.528000120214603, -7.996000005116033],
            [18.527993783498577, -7.996025350243094],
            [18.527463552003809, -7.998146082697878],
            [18.527000040181829, -7.999999955761689],
            [18.500000039745416, -7.999999955761689],
            [18.427417199647749, -7.999999955761689],
            [18.399999959609644, -7.999999955761689],
            [18.390999959763615, -7.999999955761689],
            [18.398000159768532, -8.012999965690113],
            [18.389999879730844, -8.017000103591078],
            [18.387836861392508, -8.017540782987492],
            [18.385999919824219, -8.01799995410124],
            [18.376506879634483, -8.026543761716324],
            [18.375999839945415, -8.027000096671197],
            [18.365000040258273, -8.021000023456688],
            [18.359054180325913, -8.025954874786734],
            [18.358999920286102, -8.026000090402617],
            [18.353999880346699, -8.027000096671197],
            [18.334654091171291, -8.020271050059437],
            [18.330999839816911, -8.018999979412563],
            [18.330000120008577, -8.014000004347908],
            [18.327878341528322, -8.013469534264537],
            [18.326000160101948, -8.012999965690113],
            [18.325430423395925, -8.012999965690113],
            [18.324000000036435, -8.012999965690113],
            [18.3192794008291, -8.017720518306577],
            [18.318999960097035, -8.01799995410124],
            [18.31299984012486, -8.01799995410124],
            [18.303999840278831, -8.014000004347908],
            [18.302000040437719, -8.011999925438388],
            [18.302000040437719, -8.011736647908037],
            [18.302000040437719, -8.002999981303354],
            [18.299999880372205, -7.999999955761689],
            [18.308000160409893, -7.994000015784573],
            [18.300999960404944, -7.990000005534585],
            [18.294000119726135, -7.987999985516382],
            [18.285000119880106, -7.987999985516382],
            [18.275000040001306, -7.989000086313997],
            [18.26600004015528, -7.992999927399378],
            [18.261000000215876, -7.994000015784573],
            [18.252000000369851, -7.994000015784573],
            [18.241999919592718, -7.992999927399378],
            [18.235000079812238, -7.990999922273614],
            [18.227000159998951, -7.989000086313997],
            [18.217000080120151, -7.989000086313997],
            [18.2090001603069, -7.994000015784573],
            [18.181000079837709, -7.999999955761689],
            [18.153000000266854, -8.008999966149853],
            [18.13499999967647, -8.035000053442335],
            [18.122063819410634, -8.036232056676106],
            [18.114000120110525, -8.037000017680732],
            [18.106137573365441, -8.038474194400559],
            [18.09799992025955, -8.039999945760394],
            [18.095000040385699, -8.054999961507816],
            [18.087000119674112, -8.06799997141839],
            [18.10299996019895, -8.086999978261622],
            [18.100000080325099, -8.09900001339882],
            [18.000000000189328, -8.098000009307446],
            [17.981999999598941, -8.112999982686087],
            [17.97199991972014, -8.108999914972458],
            [17.958999959967485, -8.090999911132926],
            [17.943108955729191, -8.08347268052459],
            [17.939999880242659, -8.081999960881811],
            [17.924000039717786, -8.08000004378389],
            [17.91500003987176, -8.08000004378389],
            [17.891627494943105, -8.079220915418077],
            [17.885000159561461, -8.078999991942073],
            [17.878286160111102, -8.081402966623571],
            [17.847933479947734, -8.085258971774435],
            [17.832676902794006, -8.089438790837768],
            [17.825237280189739, -8.091476995906238],
            [17.817939359635059, -8.095304892318966],
            [17.812101240044576, -8.102777882197239],
            [17.806332379664212, -8.107181524247421],
            [17.806330593813414, -8.1071828876553],
            [17.805294244301066, -8.107973928411269],
            [17.803712867142888, -8.10852146097748],
            [17.796823200342093, -8.110906914475791],
            [17.790269457643497, -8.111847139429365],
            [17.783718479959301, -8.112786965581609],
            [17.775342897270651, -8.109189749132371],
            [17.766584280131358, -8.105427989861045],
            [17.757192240223951, -8.101393946369177],
            [17.728725281047097, -8.096468872884323],
            [17.728725239724596, -8.096468874674796],
            [17.721124199745255, -8.096854953127847],
            [17.716984288605559, -8.097390528160165],
            [17.685249480308954, -8.101495998429854],
            [17.661230280428107, -8.110944023348576],
            [17.64447952468252, -8.11495993878469],
            [17.644479479766765, -8.114959949527027],
            [17.644424943944173, -8.114991703863183],
            [17.64380448027239, -8.11535297729294],
            [17.630579160164398, -8.12305091100497],
            [17.620972935842108, -8.125765155546478],
            [17.611318439649757, -8.128493020205489],
            [17.601978090600465, -8.128681443205299],
            [17.582966279776308, -8.129064968639129],
            [17.561960568347576, -8.127567021325302],
            [17.560333439991961, -8.127450988104828],
            [17.543024279787701, -8.115392939626666],
            [17.529377400079774, -8.101882972594415],
            [17.528265360318223, -8.092487899898476],
            [17.524139711730307, -8.089483951820309],
            [17.523351431983649, -8.088909990220744],
            [17.523351360118415, -8.088909938296039],
            [17.505476280149765, -8.082833003945108],
            [17.504211360601552, -8.078190258359445],
            [17.503484399856198, -8.075522004498216],
            [17.504225013197235, -8.071561473775574],
            [17.504734320234114, -8.068837861341599],
            [17.506116121380543, -8.067229888113591],
            [17.513971200430657, -8.058088968998442],
            [17.517198239985365, -8.046540930764701],
            [17.521637533558128, -8.045592893754041],
            [17.524315179654753, -8.045021065311154],
            [17.528825017028446, -8.047536263974484],
            [17.531076240046183, -8.048791896126254],
            [17.531076266995662, -8.048791810173316],
            [17.532592200088768, -8.043938967836766],
            [17.529559298145042, -8.038334466201976],
            [17.528042160411136, -8.035530915880546],
            [17.52182379563903, -8.028759449267509],
            [17.513282160268382, -8.019457878272391],
            [17.507539439964489, -8.013200901278735],
            [17.495603280442623, -8.00425095242057],
            [17.485641360098789, -8.001691009006993],
            [17.483764320431163, -7.999999955761689],
            [17.48612584848096, -7.990651206478623],
            [17.488493280258847, -7.981278867866216],
            [17.49090023970582, -7.958541955044818],
            [17.489952359875918, -7.953956902622547],
            [17.4894468814588, -7.953237573995991],
            [17.487863280071977, -7.950983998145889],
            [17.484405480388777, -7.950542978076728],
            [17.481849723998117, -7.952325429632402],
            [17.47843919995336, -7.954704007326868],
            [17.473676172416848, -7.960241097766714],
            [17.472488400185227, -7.961621888774568],
            [17.46833039967068, -7.959578001535914],
            [17.468232257827555, -7.959070137661328],
            [17.46762120041511, -7.955908010639074],
            [17.471266200020381, -7.948773893053634],
            [17.47055843986589, -7.945793990139529],
            [17.471704320062535, -7.944869993996726],
            [17.471703942770123, -7.94487003071525],
            [17.461805400366213, -7.945838966674045],
            [17.458109280333044, -7.944020958171048],
            [17.453978107106149, -7.938142525129396],
            [17.451841319574093, -7.935101959689573],
            [17.445600360375959, -7.931230949039968],
            [17.442356387578126, -7.927345911104354],
            [17.441406378740968, -7.922299986045152],
            [17.441790809173568, -7.920621422578689],
            [17.441793113352258, -7.920611361990775],
            [17.443880279744644, -7.911498892802028],
            [17.446222005332331, -7.905328531149315],
            [17.44728444012393, -7.902529022156817],
            [17.454145320411435, -7.893311011557709],
            [17.455497479848436, -7.888253968233228],
            [17.455086257162538, -7.884176462523365],
            [17.455011479601652, -7.883434992096144],
            [17.453146320153639, -7.87931286194109],
            [17.452007279729592, -7.878081855142354],
            [17.445509280189281, -7.872694910285319],
            [17.43330923965441, -7.874364001691354],
            [17.424762596176073, -7.869587054694487],
            [17.423627866767067, -7.867557376382112],
            [17.422203272575405, -7.865009025809633],
            [17.423408207120506, -7.860408290167873],
            [17.424009359708659, -7.858113010620077],
            [17.424981814749792, -7.856425794256124],
            [17.431308360038319, -7.845449023485282],
            [17.431524353660187, -7.842463990335344],
            [17.431524359948401, -7.842463901651225],
            [17.427582360242198, -7.837662953175344],
            [17.427582059306605, -7.837662936154975],
            [17.424565671092758, -7.837490252674238],
            [17.420210280167531, -7.837240911925761],
            [17.419536192463177, -7.837418090687095],
            [17.413080480216568, -7.839114919284324],
            [17.408951279689997, -7.842350001659207],
            [17.405271359874689, -7.843056964207039],
            [17.404169018324932, -7.842405403269972],
            [17.402960159938676, -7.841690882623783],
            [17.402097781757508, -7.839855775703059],
            [17.401561200071988, -7.838713946229797],
            [17.401956183014189, -7.837430503929309],
            [17.402693399825171, -7.835035011765388],
            [17.405297042708671, -7.833346781412803],
            [17.409118319620472, -7.830869011745747],
            [17.411630399921989, -7.826724929086199],
            [17.410917239994347, -7.822595979360815],
            [17.407676159771771, -7.819628010134674],
            [17.405403285559025, -7.81938793597567],
            [17.403528240151317, -7.819189882415797],
            [17.402713558918467, -7.819600691219128],
            [17.402713199592331, -7.819600873076489],
            [17.402652128526054, -7.81963172163702],
            [17.396639280324639, -7.822669000374189],
            [17.392207414920978, -7.823322573297707],
            [17.391805338881259, -7.823381868109482],
            [17.389289183821607, -7.822143935184012],
            [17.386724324802159, -7.820881945960505],
            [17.385534359782955, -7.8135418547648],
            [17.390987279982955, -7.799968955101893],
            [17.390987263813273, -7.799968906723774],
            [17.388412199932198, -7.792405923150352],
            [17.385634798618231, -7.789665201280892],
            [17.384939279806154, -7.788978865154871],
            [17.37870624015553, -7.78602600841661],
            [17.360941319691847, -7.782992962026405],
            [17.352914883408037, -7.781622991914844],
            [17.351274239898988, -7.781342962170742],
            [17.344118159734368, -7.778164894368457],
            [17.33353847964775, -7.766897995324405],
            [17.332195320431566, -7.765467917149381],
            [17.330405024782689, -7.763560864411234],
            [17.329527359970346, -7.762625957543746],
            [17.32952718210392, -7.762625867050514],
            [17.321443199742983, -7.758532973526413],
            [17.320999319703201, -7.75735088927854],
            [17.320007189760709, -7.754706677284065],
            [17.319809159749596, -7.754178887983369],
            [17.320244399792958, -7.749354949593153],
            [17.326752138867565, -7.743024597533353],
            [17.326887298486884, -7.742893121674133],
            [17.326887479946564, -7.742892945159149],
            [17.327793507267398, -7.741060905637433],
            [17.327796821152489, -7.741054206102968],
            [17.328708359637584, -7.73921101464569],
            [17.328672359652572, -7.73232295531686],
            [17.332071479584805, -7.721973955129482],
            [17.331123240428763, -7.716926953858703],
            [17.329502323025043, -7.716576605204495],
            [17.326973160360055, -7.716029945553464],
            [17.325832319712159, -7.717872891874171],
            [17.323299359868475, -7.718113974666005],
            [17.319835439963217, -7.716294959021514],
            [17.319087106500621, -7.714611940978023],
            [17.318205359743601, -7.712628865603466],
            [17.319551399856913, -7.706192901185256],
            [17.317451160282197, -7.700923011864706],
            [17.31571189972129, -7.700398511261876],
            [17.314453439958264, -7.70001900286146],
            [17.306411399937971, -7.703272852264858],
            [17.300159280070737, -7.697104983790502],
            [17.297489995492764, -7.695947018112046],
            [17.292312360418322, -7.693700892123812],
            [17.291737491637114, -7.692009842556743],
            [17.290909439879567, -7.689574013533795],
            [17.29232994134675, -7.686288454481057],
            [17.292501359665916, -7.685891969407856],
            [17.294514372826534, -7.684244352946655],
            [17.299839239979416, -7.679886010505894],
            [17.299806571845771, -7.674161937843578],
            [17.299806476624344, -7.674145897430382],
            [17.299806476624344, -7.674145838283668],
            [17.299700279588112, -7.672314903404633],
            [17.298794159740776, -7.656699867068436],
            [17.30035440043865, -7.647047899167818],
            [17.30628648021457, -7.636914881081984],
            [17.301344366339634, -7.630267406448142],
            [17.296081199972058, -7.623187979786844],
            [17.288242199867188, -7.62115992337511],
            [17.287006607618078, -7.619786727896607],
            [17.286390359739904, -7.619101848893318],
            [17.279936279732187, -7.617755932259126],
            [17.276710319952457, -7.614326906359008],
            [17.273914200442899, -7.611356026022157],
            [17.271680167586382, -7.610692970760349],
            [17.266306319792662, -7.609098021622231],
            [17.262269614299328, -7.605486978563534],
            [17.258901479956211, -7.60247398378974],
            [17.25521328036892, -7.601343976603656],
            [17.249927400099363, -7.603436969956443],
            [17.245058400105428, -7.596800875856305],
            [17.239806100657837, -7.596192273952616],
            [17.237455199677804, -7.59591986629173],
            [17.237054694791539, -7.595366470775203],
            [17.235136440418682, -7.592715919945884],
            [17.233490159981208, -7.5860639370229],
            [17.231682194470729, -7.584949801745803],
            [17.226968400001674, -7.582044973427706],
            [17.220554279752708, -7.578090996028679],
            [17.219159421593602, -7.576080187815553],
            [17.217537480110458, -7.573742007594719],
            [17.215397279878662, -7.560661904474874],
            [17.209783917873967, -7.550017054799054],
            [17.206096320157933, -7.543023967184665],
            [17.199857160285287, -7.538920986609557],
            [17.197984439717533, -7.532958856132938],
            [17.204309133578278, -7.514921688806312],
            [17.205244199838987, -7.512254941041525],
            [17.20524418816089, -7.512254884561744],
            [17.204063400330636, -7.50651899179322],
            [17.199882359825665, -7.499419880780343],
            [17.196166608908594, -7.49666806201893],
            [17.186941440048415, -7.489835992022716],
            [17.182059669604371, -7.489033253213002],
            [17.174730239742765, -7.487828027771298],
            [17.166650400411903, -7.48373291710502],
            [17.160261264107646, -7.478403767950693],
            [17.156246400252144, -7.475054955050068],
            [17.153658360206794, -7.464043893135798],
            [17.158116335144197, -7.456877464768742],
            [17.159820479662333, -7.454137932446999],
            [17.162458200136157, -7.452541864136559],
            [17.165754359662103, -7.451123946243281],
            [17.170614360333548, -7.449032888925617],
            [17.177699874239309, -7.448886822376958],
            [17.185116240359182, -7.448733935959241],
            [17.187066942778433, -7.446009916857355],
            [17.188087320245025, -7.444585024066514],
            [17.188108772912344, -7.444237910060845],
            [17.188513199843133, -7.437693968355312],
            [17.188513012095235, -7.437693650937774],
            [17.185260240299236, -7.432195948782208],
            [17.183381407594268, -7.430546366743709],
            [17.179016400203945, -7.426713943272611],
            [17.175962811855868, -7.426458802974423],
            [17.160824049649996, -7.425193817315529],
            [17.159812376858483, -7.424429926624229],
            [17.152965360270748, -7.419259861396271],
            [17.150243289788399, -7.412565898711385],
            [17.148304439740986, -7.407797925872496],
            [17.145069479740432, -7.40551597537195],
            [17.144487301367707, -7.405615793537833],
            [17.140928399892545, -7.406225991816417],
            [17.138872440074827, -7.409220989132193],
            [17.138022864683087, -7.415640339008806],
            [17.137321199597807, -7.420942009449599],
            [17.136555552006421, -7.42163269579192],
            [17.132969160286915, -7.424867947312149],
            [17.127910439698219, -7.426269868248975],
            [17.113634280252327, -7.425418888023826],
            [17.110167258464426, -7.42267631597417],
            [17.10839232041366, -7.4175939702983],
            [17.111848622605265, -7.391920168462145],
            [17.111852279646818, -7.391893002190502],
            [17.10740447992664, -7.37721389289402],
            [17.109605332609796, -7.372458304564241],
            [17.112411359638607, -7.366394982532872],
            [17.113294440393815, -7.358580980440263],
            [17.113294425122465, -7.358580935599149],
            [17.111658239952177, -7.35376489730881],
            [17.105409360308172, -7.34713300066438],
            [17.10102635966269, -7.345315980565759],
            [17.100129272375568, -7.345157381628139],
            [17.095958280425364, -7.344419980119076],
            [17.08722828001774, -7.347677961641295],
            [17.084919651060051, -7.347579131114125],
            [17.082393479784965, -7.34747098772278],
            [17.080774382368034, -7.346730113027725],
            [17.075933280453523, -7.344514888530099],
            [17.06135940045786, -7.33011195449041],
            [17.049143159705132, -7.32626398988389],
            [17.04198038978663, -7.321014026263295],
            [17.039060989080742, -7.31440265440997],
            [17.034996239980856, -7.305197004846917],
            [17.03083031991876, -7.300622012288043],
            [17.024389199905638, -7.298199895837698],
            [17.018846280192268, -7.297461996780076],
            [17.014908240259839, -7.298225993370757],
            [17.014327569260178, -7.298338547485439],
            [17.013046320136755, -7.298586899061359],
            [17.008205424834777, -7.299526766336801],
            [17.005510440354843, -7.300050000454322],
            [17.005085576751355, -7.299184578837247],
            [17.002022399785918, -7.29294501904302],
            [17.004902400383447, -7.27018997123722],
            [17.003946239883234, -7.263301893470358],
            [16.994888279836747, -7.246803930774912],
            [16.988596200210722, -7.230751952447404],
            [16.980268319860276, -7.222059861258797],
            [16.969459424747406, -7.215489835641415],
            [16.968265199917131, -7.214763938003844],
            [16.959999240439213, -7.210589932827946],
            [16.95904673877714, -7.209882274734712],
            [16.958532240376272, -7.20950002973641],
            [16.95711245845963, -7.208444115232707],
            [16.955801280165876, -7.207468968553985],
            [16.953710400138089, -7.203342990797648],
            [16.953674450458745, -7.202873277324289],
            [16.953218279669279, -7.196913025033349],
            [16.954788240138477, -7.188634910608534],
            [16.958446199738379, -7.183564872029566],
            [16.968532320255072, -7.175706878422364],
            [16.970346348495433, -7.170184886587418],
            [16.970346360173526, -7.170184851596444],
            [16.968933359638939, -7.163528933816675],
            [16.962688439768705, -7.157353919672174],
            [16.956690359870539, -7.154165232359589],
            [16.953691319921472, -7.152570879791051],
            [16.953051364604633, -7.150951730789581],
            [16.95042828038175, -7.144315016226874],
            [16.949461320335192, -7.134669929878483],
            [16.9508001604515, -7.126163027813399],
            [16.949627871582116, -7.123432841730741],
            [16.948240199945289, -7.12020102018522],
            [16.944120552103488, -7.11648540981504],
            [16.940382479848243, -7.1131139251566],
            [16.938946353983308, -7.108015462483875],
            [16.938545399939397, -7.106592004277617],
            [16.936634159612275, -7.099804959349607],
            [16.933601159752172, -7.09131796937122],
            [16.928045280044209, -7.084219871995447],
            [16.92859032026643, -7.074128901612807],
            [16.928890195874569, -7.068591952547242],
            [16.929952043167965, -7.06710854616029],
            [16.931860199578718, -7.064442976083467],
            [16.938974160434629, -7.060734914073027],
            [16.941161596779001, -7.06106935289124],
            [16.943350320409181, -7.061403987999231],
            [16.945179289429333, -7.065907017848208],
            [16.947654480413743, -7.072001013104335],
            [16.948940399878342, -7.075164942675447],
            [16.949682726306644, -7.075715415118448],
            [16.952635440136525, -7.077904993274835],
            [16.955910032010792, -7.078706815515164],
            [16.960006440436214, -7.079709866444797],
            [16.962910535646291, -7.078788801494751],
            [16.963682271120337, -7.078544037034186],
            [16.963682399579422, -7.078543996651816],
            [16.968034439788642, -7.074388940287879],
            [16.969285490247174, -7.071743376300446],
            [16.970539320093188, -7.069091917168703],
            [16.970062204184533, -7.062692241940764],
            [16.969906439907518, -7.060602923267196],
            [16.969741691579372, -7.058389592461586],
            [16.969307400156943, -7.052555000831074],
            [16.970875200177925, -7.044046026558866],
            [16.971788474208147, -7.042789734996561],
            [16.97508215977378, -7.038258938722982],
            [16.979381094278324, -7.032345241744718],
            [16.980930360258355, -7.030214022031577],
            [16.981116779544418, -7.029502332253882],
            [16.982738279954784, -7.023311904093516],
            [16.981343822444284, -7.017978641609368],
            [16.98015816035528, -7.013443889938904],
            [16.977981484929703, -7.008832741343757],
            [16.973880479824963, -7.000144897943072],
            [16.973457480225651, -6.994152982528623],
            [16.972891200236859, -6.98613287285496],
            [16.971357943133498, -6.98429196989489],
            [16.969650480238684, -6.982241899822459],
            [16.965581162307259, -6.981925205173845],
            [16.963651440041488, -6.981775023902524],
            [16.961267160360471, -6.981589882933897],
            [16.951003483336276, -6.980793156056719],
            [16.950086280074988, -6.980721957584495],
            [16.938741239857855, -6.966066963300719],
            [16.938174273556179, -6.96322494004581],
            [16.937092439646026, -6.957802004166626],
            [16.94025827967538, -6.946527920041211],
            [16.940751780854825, -6.945747746430743],
            [16.944002279913168, -6.940609014624844],
            [16.945093440132588, -6.938885888311169],
            [16.945146547633858, -6.938802011160805],
            [16.945507440409376, -6.938232021358131],
            [16.945507460172312, -6.938231926206253],
            [16.946583534983176, -6.932881804439853],
            [16.947080279979073, -6.930412026672795],
            [16.945357468469322, -6.925690253802088],
            [16.943815440215534, -6.921463918557562],
            [16.936884360181818, -6.915060933606801],
            [16.937744493473108, -6.910320942277322],
            [16.938427319988559, -6.906558013780777],
            [16.940338200091247, -6.896032870489204],
            [16.941810239702939, -6.887921966031733],
            [16.940366294901771, -6.874829031676865],
            [16.940366279630421, -6.874828895214148],
            [16.937813159795105, -6.870015004020362],
            [16.934513742977952, -6.867460312690814],
            [16.932502440209642, -6.865902983130683],
            [16.929783597374101, -6.865289096265088],
            [16.9205263496751, -6.863198898344087],
            [16.917520319934781, -6.859766017645943],
            [16.915416491590531, -6.852880905691108],
            [16.915416479912434, -6.852880869778192],
            [16.910349480450051, -6.851295016471863],
            [16.910349333126362, -6.851295082910992],
            [16.905705976457046, -6.853389587632919],
            [16.903410479970496, -6.854425026574079],
            [16.901009024501242, -6.855508587175398],
            [16.895427479925608, -6.858027026053263],
            [16.894691280007542, -6.857650921228899],
            [16.88489891577526, -6.851689760739807],
            [16.884815400301605, -6.851638919590703],
            [16.882445171169955, -6.851135554479141],
            [16.879518360261308, -6.850513987170676],
            [16.876281239812471, -6.846850914257701],
            [16.874868240176216, -6.839962893825389],
            [16.874439479680984, -6.828621908865434],
            [16.874049557847094, -6.818339287678861],
            [16.873815240390062, -6.81215999740711],
            [16.87171140036768, -6.805274870637136],
            [16.868240279567122, -6.800923030630111],
            [16.863265804782419, -6.797825232056129],
            [16.862011199690308, -6.797043938379387],
            [16.860956808413782, -6.796319995131016],
            [16.860859200169934, -6.796252977194141],
            [16.850704319906441, -6.789279932560626],
            [16.836635160149779, -6.771430969454139],
            [16.832653199786495, -6.766376930989914],
            [16.829864280273942, -6.760413881577067],
            [16.829197620738686, -6.756840904166162],
            [16.828644239659049, -6.7538750219154],
            [16.82844948041387, -6.75283486604692],
            [16.830594453394777, -6.734782973321655],
            [16.830881267498686, -6.732369115743112],
            [16.830881280075079, -6.73236901067116],
            [16.829825270932748, -6.726109272562936],
            [16.829813145473029, -6.72603739432389],
            [16.828750440288534, -6.71973788315568],
            [16.826736359929367, -6.715302633764311],
            [16.825729319749783, -6.713084993707222],
            [16.825125319502199, -6.712566770322363],
            [16.822265399844554, -6.710112990319121],
            [16.816742279898346, -6.709217895724919],
            [16.811844479916399, -6.705228877195774],
            [16.811226359949174, -6.705001029660307],
            [16.802979270482115, -6.703744465614184],
            [16.800153574840156, -6.703313929446802],
            [16.792578800701378, -6.688657285300881],
            [16.789013280439203, -6.681758026249509],
            [16.788067199934783, -6.676244993526787],
            [16.789837320320679, -6.66129702080044],
            [16.788986859190071, -6.659063603648671],
            [16.787740320070895, -6.655790019741639],
            [16.784097480015582, -6.65177997477592],
            [16.782155866750362, -6.649643265719142],
            [16.781500439749415, -6.648921978744804],
            [16.777807135934683, -6.635065098355521],
            [16.776115200419529, -6.628717008385276],
            [16.776006480015649, -6.605501853497147],
            [16.77314160704751, -6.597443017710156],
            [16.772743439577628, -6.596322968605202],
            [16.772743401848384, -6.596322920096858],
            [16.771146913230499, -6.594266433585067],
            [16.768118159706773, -6.590364980493483],
            [16.757055360270428, -6.585125900179359],
            [16.751278440205336, -6.579174936448172],
            [16.750432720382776, -6.576371708006216],
            [16.749408240310274, -6.572975939050481],
            [16.749156596148062, -6.566106300128776],
            [16.749147246482572, -6.565851045812473],
            [16.751178359797841, -6.557796882680677],
            [16.757944395059365, -6.547113459047189],
            [16.759639439643674, -6.544436984282234],
            [16.759958043328865, -6.543933684252389],
            [16.761175200351744, -6.542010932879928],
            [16.761869280062733, -6.538254916193525],
            [16.761994139599032, -6.537580540798795],
            [16.762659480407482, -6.533986973672032],
            [16.763068172539256, -6.531769114212724],
            [16.763202360181449, -6.531040913545865],
            [16.761940210139251, -6.527616009426644],
            [16.760679480333561, -6.524194935858592],
            [16.755825239659703, -6.518698926297055],
            [16.755825201032163, -6.518698906531268],
            [16.739389440439258, -6.510401886312385],
            [16.737916191695206, -6.509657902367555],
            [16.733700360337583, -6.507528919650375],
            [16.727230440336445, -6.500890863272816],
            [16.726541330105597, -6.499228903788267],
            [16.725137399860436, -6.495842965374602],
            [16.727184360355633, -6.490775856647228],
            [16.728421480639074, -6.489911634250866],
            [16.733143439895752, -6.486612974946766],
            [16.735640471619657, -6.480497235006145],
            [16.735870422366059, -6.479934033390987],
            [16.735870440332366, -6.479933990262233],
            [16.732380278841067, -6.470984049302964],
            [16.732380240213491, -6.470983949565985],
            [16.727522399990331, -6.464337883752706],
            [16.717418667104141, -6.45632967945904],
            [16.713674279692466, -6.453361850261564],
            [16.712238115199991, -6.449371984143069],
            [16.711113240309643, -6.446246899741068],
            [16.713152280358965, -6.439800898095749],
            [16.714826949356041, -6.438501218162409],
            [16.716131279792386, -6.437488948563715],
            [16.718641199645681, -6.436776915759419],
            [16.721682244817423, -6.43591470167827],
            [16.726005360172802, -6.434688985943398],
            [16.729669439994691, -6.43191390074885],
            [16.73239932043014, -6.425465027946581],
            [16.729845480145986, -6.419729025349306],
            [16.724300399984369, -6.414234908944305],
            [16.72137754256125, -6.41248663475834],
            [16.71323436032479, -6.407615850372354],
            [16.70037443984009, -6.411118899408247],
            [16.697134857109074, -6.410700586477086],
            [16.693474320242636, -6.410227917141074],
            [16.690695479827586, -6.405641881925281],
            [16.690202803301606, -6.402155026294516],
            [16.689981240124965, -6.400586934179059],
            [16.691791320269644, -6.394371919412588],
            [16.696649950111954, -6.388087064482263],
            [16.700706360151056, -6.382839857778501],
            [16.703207279783499, -6.37685101253729],
            [16.702881240742695, -6.374340249343041],
            [16.702491239857061, -6.371336906482385],
            [16.697645279853514, -6.367218885537772],
            [16.690513320352593, -6.366098924865546],
            [16.690197594869566, -6.365848713376755],
            [16.688205359741477, -6.36426987314906],
            [16.687870157884781, -6.362736654469763],
            [16.687502279809632, -6.361053970042527],
            [16.690006435173757, -6.355525909979163],
            [16.699432320007773, -6.355945916857755],
            [16.715780280163099, -6.361393920021621],
            [16.719682320110515, -6.359997938578022],
            [16.722192239963778, -6.356078996404666],
            [16.724897280184987, -6.344111887664093],
            [16.724872440869078, -6.338824188485821],
            [16.724872439970749, -6.338824009631159],
            [16.718147284342905, -6.326207902974336],
            [16.718769359592315, -6.311721026909693],
            [16.717123440277614, -6.303451026175376],
            [16.71628207458922, -6.302319938870226],
            [16.710645239606169, -6.294742015815793],
            [16.709478489748854, -6.290837921984119],
            [16.710487680495223, -6.285078645743062],
            [16.711494479926319, -6.27933295066919],
            [16.714512360241844, -6.270207923340248],
            [16.716049199826561, -6.266508997279854],
            [16.71852816014189, -6.259529906522967],
            [16.718360039538137, -6.255464410663941],
            [16.718271480024182, -6.253322846703463],
            [16.711086239647152, -6.240707853712022],
            [16.710375240167728, -6.235652884390494],
            [16.716064320269403, -6.223441998513579],
            [16.722934199879433, -6.217894888593253],
            [16.722934231320497, -6.217894829260667],
            [16.723734641018424, -6.216400836992553],
            [16.725897360217765, -6.212364023436952],
            [16.729916520715282, -6.197476362353614],
            [16.730869297261801, -6.193947054500883],
            [16.730869319719694, -6.193946969094021],
            [16.730656667830694, -6.193078754156834],
            [16.729463159856007, -6.18820586206287],
            [16.72253471637767, -6.181336502614113],
            [16.721149320173424, -6.179962909727389],
            [16.719984359760161, -6.176288961936297],
            [16.72202735958329, -6.170531892985291],
            [16.721612959556193, -6.166589736707246],
            [16.721544240233598, -6.165936011100133],
            [16.718963400185253, -6.164280946096791],
            [16.716473278302519, -6.162683847246916],
            [16.713707401475315, -6.160909878050342],
            [16.713707335898292, -6.16090983579376],
            [16.706693148226073, -6.15613047411296],
            [16.702640280244164, -6.153368891036322],
            [16.697780279572715, -6.146031883791116],
            [16.693621546032865, -6.143042551345673],
            [16.689422160133173, -6.14002397983151],
            [16.688757910777795, -6.139546810629916],
            [16.688556438422509, -6.139402080311883],
            [16.688556360269061, -6.139402024566822],
            [16.670624399874931, -6.137868005723146],
            [16.668299460206644, -6.136057621928684],
            [16.667394480321423, -6.135352930290965],
            [16.665817537247488, -6.132051439687099],
            [16.663448159718719, -6.127090869987765],
            [16.659528480452398, -6.12434799019134],
            [16.649911705417129, -6.127222649860597],
            [16.64782344038516, -6.127846874547815],
            [16.646864863416852, -6.127658904366439],
            [16.645523400219918, -6.127395851917823],
            [16.64251344753675, -6.122579913115616],
            [16.642529861553644, -6.122381137854694],
            [16.642950479719119, -6.117289941924367],
            [16.648214399773231, -6.112438957801344],
            [16.648214404264817, -6.112438778868541],
            [16.648403399919118, -6.103699870091658],
            [16.648003848145343, -6.100427313937692],
            [16.64792639989312, -6.099792966216019],
            [16.64512158828488, -6.097784329041327],
            [16.643776319824411, -6.096820926418824],
            [16.641051849043617, -6.096122073861206],
            [16.633192319739585, -6.094106024215323],
            [16.619171400412021, -6.093703895092666],
            [16.611578237759392, -6.0916659525326],
            [16.609765225513616, -6.089439648784987],
            [16.606725480204073, -6.085706943465195],
            [16.605327239887931, -6.081344006317027],
            [16.606578421500505, -6.078600796636281],
            [16.608059279873334, -6.075354004709095],
            [16.61953265520857, -6.07530604376459],
            [16.625293199884368, -6.075281963476952],
            [16.628299199980244, -6.074173917470173],
            [16.630342199803373, -6.073421957363899],
            [16.631277735882964, -6.071355484391817],
            [16.632845279884073, -6.067892975644082],
            [16.632845093932804, -6.067892720261253],
            [16.627989239884727, -6.061244932297852],
            [16.623151755485893, -6.060892082218606],
            [16.622011440352431, -6.060808906346428],
            [16.617490199764514, -6.062744942689706],
            [16.612027218433322, -6.06508547191308],
            [16.610084280153085, -6.065917890603787],
            [16.602885923474567, -6.065510719676027],
            [16.602499440391565, -6.065488858267631],
            [16.599022200267314, -6.058834870526633],
            [16.603250399629744, -6.049939876692297],
            [16.606028731598375, -6.044093045238881],
            [16.607673360034013, -6.040631992476294],
            [16.60534632010458, -6.034202976451361],
            [16.605661319748851, -6.029118959862084],
            [16.606044172739779, -6.0229633787007],
            [16.606203479972276, -6.020401981969709],
            [16.599712320204535, -6.00777997209017],
            [16.599440424422557, -6.006625225550914],
            [16.598306160340844, -6.001807965392316],
            [16.598620639860563, -6.000580824665769],
            [16.59966335932663, -5.996511968755943],
            [16.603098480142176, -5.993968978113449],
            [16.604868977820487, -5.991029148136173],
            [16.605665280420919, -5.98970691979465],
            [16.605866295533755, -5.989373007337893],
            [16.606291319935689, -5.988666986529046],
            [16.606173933484246, -5.986808950297484],
            [16.606044359589344, -5.984757986384192],
            [16.604149553042021, -5.982721536933868],
            [16.603273439620164, -5.981779929301714],
            [16.596145439893018, -5.98088892821782],
            [16.593953172409019, -5.979694371277886],
            [16.591539240238813, -5.9783790269287],
            [16.591197398933833, -5.977803074513933],
            [16.589224439855098, -5.974478914706605],
            [16.589199739778071, -5.969270453697766],
            [16.589187360095139, -5.966659963857484],
            [16.591907159636463, -5.957909890022682],
            [16.599193199971531, -5.942931943147003],
            [16.597091160172997, -5.935352022244868],
            [16.596784440300709, -5.918104915752298],
            [16.59309871916528, -5.915209399715981],
            [16.591251240358702, -5.91375800738357],
            [16.590330360292956, -5.910732952346079],
            [16.585655399993623, -5.895382982522346],
            [16.587585310007324, -5.885390006017437],
            [16.588550433897446, -5.880393374817242],
            [16.586917430559875, -5.88021883470547],
            [16.586740012392966, -5.880199855148283],
            [16.585809840153914, -5.877899945167385],
            [16.586476353263809, -5.876839507861555],
            [16.587399959716443, -5.875370028117926],
            [16.579120319795059, -5.872641999229662],
            [16.564420440301021, -5.873851928727465],
            [16.559126280259481, -5.871573874917137],
            [16.551780480398435, -5.873213887971604],
            [16.545134606484289, -5.870208903256664],
            [16.541191439866559, -5.868425961652295],
            [16.534296359817859, -5.867763891635899],
            [16.52989032008028, -5.858353020178259],
            [16.529890219468971, -5.858353010282828],
            [16.528044010880226, -5.858181474084245],
            [16.522764479903088, -5.857690938050895],
            [16.517687400444942, -5.85265295825331],
            [16.517687271087528, -5.852653007730923],
            [16.511036399845462, -5.855208975126018],
            [16.510226064661936, -5.855121993898618],
            [16.506899279771346, -5.85476489573973],
            [16.501475832397485, -5.852980680696837],
            [16.4999962801751, -5.852493934520019],
            [16.49628470103422, -5.848009431618568],
            [16.494684479916327, -5.846075958634086],
            [16.494684443085415, -5.846075952336841],
            [16.491761291913246, -5.845578543358863],
            [16.489395360321872, -5.845175952301948],
            [16.48591434907004, -5.846300325093024],
            [16.475971320296633, -5.849511928544472],
            [16.475323237023119, -5.849720787244602],
            [16.474252320338625, -5.85006591233423],
            [16.468307279669787, -5.856529020843378],
            [16.466467319762113, -5.855846857731507],
            [16.465883050111447, -5.853667101520635],
            [16.465297319800101, -5.851481886950746],
            [16.46023547666746, -5.849662030028334],
            [16.460235359886472, -5.849661988646861],
            [16.45816250455491, -5.853945353074832],
            [16.454771279915729, -5.860952934377543],
            [16.449714505077914, -5.860512995887794],
            [16.449714360449146, -5.860512983293663],
            [16.448453719576673, -5.8642230777196],
            [16.447445172024025, -5.867190888058308],
            [16.444781484848598, -5.86635476500625],
            [16.442383319908242, -5.865601986000565],
            [16.439867279832924, -5.868140911285164],
            [16.435501199854134, -5.867927930550112],
            [16.432758360322424, -5.871387966036036],
            [16.432758316304966, -5.871388141450623],
            [16.432426612488001, -5.872697575849215],
            [16.430950439727699, -5.878524892922006],
            [16.422950159689975, -5.887530089309639],
            [16.423356772221869, -5.889529404533259],
            [16.423650359623025, -5.890972970480326],
            [16.425269999622405, -5.892350116893241],
            [16.431569999694304, -5.891640031884576],
            [16.432218029967217, -5.891566027631399],
            [16.433761587153629, -5.891391305771752],
            [16.434246765441937, -5.891776503005463],
            [16.438370039782555, -5.895050081618119],
            [16.443918693442399, -5.895429120844978],
            [16.448029360826318, -5.895709928386692],
            [16.448138194417929, -5.895872289436458],
            [16.448370119661355, -5.896219984270279],
            [16.443349919730363, -5.896150069860891],
            [16.414599959797979, -5.892200068439073],
            [16.407590040021667, -5.889539888583658],
            [16.404469919748724, -5.888359931965245],
            [16.396390080417863, -5.882429994956906],
            [16.391279880075171, -5.874190041037877],
            [16.384330080049274, -5.867560053968389],
            [16.365939839621358, -5.864689998640261],
            [16.299309959740111, -5.866039961159035],
            [16.299309615685356, -5.8660399683556],
            [16.290870119660852, -5.866209916163573],
            [16.249020119568282, -5.867060050226665],
            [16.222219919722427, -5.868619939748239],
            [16.207546679768143, -5.863410131313261],
            [16.194880439651943, -5.859862018984419],
            [16.175140200235276, -5.859578040082803],
            [16.15372811971806, -5.859690448171897],
            [16.144891560253146, -5.858721978812101],
            [16.139431440056143, -5.858643274302506],
            [16.139686680174435, -5.850232645411508],
            [16.141629959814502, -5.842267054071592],
            [16.144792200294521, -5.832215329601339],
            [16.148423520354626, -5.824694658646177],
            [16.150408199752857, -5.818833244323873],
            [16.154534160056201, -5.815106090145475],
            [16.160339880109298, -5.811403294427148],
            [16.164095400342301, -5.810195201161346],
            [16.173747000366177, -5.809913347861395],
            [16.182567359613277, -5.810040289283712],
            [16.193479320235298, -5.809776545210378],
            [16.199326079822161, -5.808177940850999],
            [16.203007439636885, -5.803182362908523],
            [16.206202439878652, -5.794813924176236],
            [16.207733879690181, -5.787263162270437],
            [16.207456320030339, -5.778865974515746],
            [16.209572475955223, -5.775876873846077],
            [16.210884239052252, -5.774023711684428],
            [16.210867320182185, -5.769883936527423],
            [16.208225766597046, -5.765391775228186],
            [16.207628415679213, -5.764375840560243],
            [16.208531550424826, -5.76058087237343],
            [16.20943630932446, -5.75677905030678],
            [16.209369301292469, -5.756493841870024],
            [16.208734319947393, -5.75379200463588],
            [16.208601765442388, -5.753862516444528],
            [16.204380378004718, -5.756107885713437],
            [16.201147319737618, -5.751978958796142],
            [16.205238362525851, -5.741154808161739],
            [16.205435280422655, -5.732873936989766],
            [16.209091439798701, -5.728260897457703],
            [16.205131485464911, -5.714244180813225],
            [16.206712199666399, -5.70733901332982],
            [16.206492357661862, -5.704817743423249],
            [16.205990399742372, -5.699060963805355],
            [16.207123293893243, -5.694917057903911],
            [16.212177360310481, -5.695128933028654],
            [16.213527360197563, -5.688453958870462],
            [16.205902230995555, -5.676981764203157],
            [16.205960860440886, -5.676551728201204],
            [16.205980319746576, -5.676409001609617],
            [16.206348240042523, -5.673759987699038],
            [16.21071215957306, -5.673742950269974],
            [16.211851148793137, -5.671208996638498],
            [16.210735824790895, -5.667902549282229],
            [16.20999144750882, -5.665695783376449],
            [16.210203479560253, -5.661094909072784],
            [16.214094359736897, -5.657630884517177],
            [16.211317331223754, -5.652349905906073],
            [16.211736363862784, -5.651799861209954],
            [16.215885359664927, -5.646353960983477],
            [16.215404399865189, -5.640604936077371],
            [16.218597222590727, -5.634842881686796],
            [16.218423500991172, -5.634270970464808],
            [16.217899200173907, -5.632544905606741],
            [16.214683433577704, -5.632786842262015],
            [16.213056480393586, -5.628192908203758],
            [16.214418359601986, -5.623817920747334],
            [16.210262181769149, -5.618311905886342],
            [16.210481400342864, -5.615780970921388],
            [16.216226280196711, -5.616449973157279],
            [16.216907380150211, -5.614377916738132],
            [16.216567100117189, -5.613904868003702],
            [16.214597279752077, -5.611166982535196],
            [16.214756898699967, -5.610352372752497],
            [16.215048359788859, -5.608864906820865],
            [16.216888935042476, -5.608550125408761],
            [16.21780217942829, -5.608393938815179],
            [16.21779444044213, -5.606783973536234],
            [16.21248840018098, -5.600822905271332],
            [16.211323439767686, -5.596226913215843],
            [16.211731319822452, -5.5835739346878],
            [16.209505241547799, -5.57770150487423],
            [16.209413280113836, -5.577458907865221],
            [16.209376193167333, -5.577360897179519],
            [16.208250489131999, -5.574385966120183],
            [16.212127319657569, -5.567471895845156],
            [16.208410320082269, -5.557134929680294],
            [16.20558324013648, -5.539432977240519],
            [16.203134584487234, -5.537161177362087],
            [16.202125440453248, -5.536224917431155],
            [16.202006036385686, -5.53552323995212],
            [16.201421279848127, -5.532086917313804],
            [16.202310479927068, -5.524723005731422],
            [16.206190186858173, -5.518728916396016],
            [16.204546447754662, -5.510586933862204],
            [16.201271162381005, -5.494363015026227],
            [16.201639440206463, -5.471588919019339],
            [16.20687393863837, -5.460062667474571],
            [16.206371311473976, -5.457530185052465],
            [16.202904521451391, -5.441258953050391],
            [16.202896230899647, -5.441220040169064],
            [16.20609624014746, -5.437527965387374],
            [16.209266400175018, -5.426244987723967],
            [16.206478200213009, -5.417972976463495],
            [16.21121813116525, -5.397482225744258],
            [16.214197320143185, -5.3958609088178],
            [16.21552641533528, -5.383894102131897],
            [16.212286440040469, -5.377464933033496],
            [16.214279400109014, -5.358593964970094],
            [16.217012159644923, -5.353063907731983],
            [16.216970400560655, -5.342711264910847],
            [16.213640399701319, -5.338622968060424],
            [16.213047480172772, -5.33789389582614],
            [16.213030200179968, -5.333525006662899],
            [16.214637030203409, -5.32807865633763],
            [16.217107199605376, -5.319705924577492],
            [16.21792134274736, -5.3089677196243],
            [16.217979479915918, -5.308200908560528],
            [16.221176280381531, -5.303587930700487],
            [16.221958192869458, -5.296172991356431],
            [16.224985439918452, -5.279878976777098],
            [16.224743159794752, -5.276889002502528],
            [16.227249480098678, -5.272048948615964],
            [16.228504188497055, -5.265784147869482],
            [16.231662359608819, -5.250015005040276],
            [16.232507217048703, -5.245802193802388],
            [16.232876280001722, -5.243961885211043],
            [16.235260481529291, -5.240212184672091],
            [16.23698243963954, -5.237503998248858],
            [16.239692160083393, -5.22622196165787],
            [16.242253072803791, -5.221135761675142],
            [16.245842400217615, -5.214006970936599],
            [16.24870116015024, -5.183167891222692],
            [16.250080931104161, -5.182052591108854],
            [16.252578359883419, -5.180033857389809],
            [16.253765370343665, -5.179075433917188],
            [16.254421199789881, -5.178545900338538],
            [16.255125398124246, -5.177201005874393],
            [16.256473199833827, -5.174626935307477],
            [16.252563240338869, -5.173030912362077],
            [16.253660142589602, -5.160143055202536],
            [16.251793199985748, -5.153018883001122],
            [16.251879441846292, -5.145592562884426],
            [16.251964199689965, -5.138293949803668],
            [16.247303276465278, -5.130065375947353],
            [16.24572215981852, -5.127273987660678],
            [16.239727262651439, -5.120393866605736],
            [16.231676400276719, -5.116511962419888],
            [16.230747252117091, -5.113984899417701],
            [16.231775400010907, -5.106305873478895],
            [16.235471159819635, -5.090039981982839],
            [16.24004315971268, -5.08519201559941],
            [16.241008320433714, -5.082477023328427],
            [16.24281372933892, -5.077406437973753],
            [16.242994421865053, -5.076898774417472],
            [16.242524791617676, -5.073696415705315],
            [16.242050176618772, -5.070460048930788],
            [16.242191280390315, -5.069873986395788],
            [16.245662400292577, -5.055491983189651],
            [16.250236200409436, -5.051332949041147],
            [16.25002491934957, -5.050623243414948],
            [16.249073400444427, -5.047427019857293],
            [16.25022935973854, -5.041508926086292],
            [16.250522637220932, -5.040003447153741],
            [16.250646240014156, -5.039368956154021],
            [16.246263240267002, -5.033633908906316],
            [16.247167199666055, -5.030178851501645],
            [16.249916160318119, -5.029018006315923],
            [16.257688244917464, -5.021166920274972],
            [16.258594319848978, -5.017941931605643],
            [16.258111143007135, -5.016379804570721],
            [16.256035440016078, -5.00966895269142],
            [16.257847661744407, -5.003220520705786],
            [16.260963479985481, -4.999999953011676],
            [16.262956025930663, -4.997941103133921],
            [16.267902479566708, -4.99283002374227],
            [16.269254279677639, -4.986843022911258],
            [16.268081399716802, -4.980634947649457],
            [16.257087765167476, -4.969951673895894],
            [16.257029857967609, -4.969578902960486],
            [16.257100691924407, -4.969183919503725],
            [16.257422609494657, -4.969075620190927],
            [16.257638377639388, -4.969613638105175],
            [16.258032148754307, -4.969648782267745],
            [16.258747087346205, -4.969180778878884],
            [16.259319133620831, -4.968856628652957],
            [16.259926696586835, -4.968388830105188],
            [16.260140352792323, -4.967814097503228],
            [16.259459163007314, -4.967205177787015],
            [16.259780669149198, -4.966881506771395],
            [16.260137489861506, -4.966306500757249],
            [16.260637677201583, -4.965838906688689],
            [16.260600454609488, -4.96508517673681],
            [16.261172428120553, -4.964725131369914],
            [16.261745627831985, -4.965011197703943],
            [16.262569024519738, -4.965117309332582],
            [16.262675099385099, -4.96443509630623],
            [16.262924133941446, -4.963644924702614],
            [16.263424863863971, -4.963464490369859],
            [16.263746707772359, -4.963320293323495],
            [16.263209163092888, -4.962962369580382],
            [16.263208139013464, -4.962423942548395],
            [16.263028093274308, -4.961849963266727],
            [16.262883838212744, -4.961275915008065],
            [16.264207411460781, -4.960914430541125],
            [16.264457194313739, -4.960519104875865],
            [16.264885930554449, -4.96012343661441],
            [16.265316648478656, -4.960768725662995],
            [16.26545871704085, -4.960194129582452],
            [16.265493140482526, -4.959476159456319],
            [16.266064353120548, -4.958721266234859],
            [16.265632475471321, -4.957465760693236],
            [16.264986881429433, -4.956749092125916],
            [16.264591889504061, -4.956067837949361],
            [16.26476947565596, -4.955349593895984],
            [16.265162146334635, -4.954810414591826],
            [16.264552550481135, -4.954201361092348],
            [16.264836962490005, -4.953195750729677],
            [16.264299562439263, -4.9529096161427],
            [16.263725556040704, -4.952192807426795],
            [16.264368483882805, -4.951509570006654],
            [16.264939625553922, -4.950718783602734],
            [16.264544366828908, -4.949893948373782],
            [16.26429240466306, -4.949140628838847],
            [16.264972211042537, -4.949031645074549],
            [16.265364673312082, -4.948384780358348],
            [16.265040859398226, -4.947488018941234],
            [16.264287840323103, -4.946735656149386],
            [16.263987548794979, -4.945823710435889],
            [16.26384025383447, -4.94534682181199],
            [16.264141071775363, -4.94483348815914],
            [16.263960353198083, -4.943900556432558],
            [16.263887208774388, -4.943075104446013],
            [16.264567077137595, -4.943002017571533],
            [16.264565647917983, -4.942248219788205],
            [16.265029687949355, -4.941601220420486],
            [16.265744526828271, -4.941097323225343],
            [16.265742722112869, -4.940146102881431],
            [16.266171651491355, -4.939858121906421],
            [16.266170765752484, -4.939391485531145],
            [16.265418914487224, -4.939249339171685],
            [16.26516750298866, -4.938783180775764],
            [16.265810760512498, -4.938279421060009],
            [16.266382505851464, -4.937811691585236],
            [16.266488375900988, -4.937021794984146],
            [16.266093127057442, -4.936196958690598],
            [16.266736313614341, -4.935657303186808],
            [16.266305345060143, -4.934868430193974],
            [16.266625746274229, -4.933970438434587],
            [16.267519454099236, -4.933430304480503],
            [16.267553132837552, -4.932317488381245],
            [16.267550749607118, -4.931061160878037],
            [16.267548368173312, -4.929804832768499],
            [16.267940140536687, -4.928799019111477],
            [16.268582672221772, -4.927918360236402],
            [16.267937860612488, -4.927596533885985],
            [16.267471722116628, -4.927130784353218],
            [16.267434504914416, -4.926377055697159],
            [16.268078022051348, -4.926016876378939],
            [16.268147899302335, -4.925119363531152],
            [16.267788380949241, -4.924258562876849],
            [16.267500576003567, -4.923469416683147],
            [16.267965284381482, -4.923181368913995],
            [16.267892483114242, -4.922535394063776],
            [16.267248289545897, -4.922536620310336],
            [16.266533332987695, -4.9229687247766],
            [16.266067266357034, -4.922538868278918],
            [16.265887102040264, -4.921893096420287],
            [16.265420968934286, -4.921427343740769],
            [16.266134330982876, -4.920151706931239],
            [16.266168151654998, -4.91911068024461],
            [16.266166795198945, -4.918392777659273],
            [16.265664606412404, -4.917783512783439],
            [16.265735030737389, -4.917173158938594],
            [16.265482886213558, -4.916312151451942],
            [16.265194548566942, -4.915235840952729],
            [16.264513015625475, -4.914411543098184],
            [16.26329658893297, -4.914611273265295],
            [16.263116702195639, -4.914109079847737],
            [16.262972130028729, -4.913355552489366],
            [16.263507869992836, -4.912780212909155],
            [16.263220348914814, -4.912134642296711],
            [16.263649061799299, -4.911738981734577],
            [16.263612530909967, -4.911344203018186],
            [16.263504085390529, -4.910770083442619],
            [16.263824420129296, -4.909836199552925],
            [16.263286655362535, -4.90933468275129],
            [16.263786402528133, -4.908651726821103],
            [16.263392466123218, -4.908508890839452],
            [16.263391452823591, -4.90797046317904],
            [16.263032426747237, -4.907360922852094],
            [16.26324573620305, -4.906606717415356],
            [16.263889578530097, -4.906426023191882],
            [16.265071791088417, -4.907069899195899],
            [16.265786869817489, -4.906709591265817],
            [16.265785719973941, -4.906099374012997],
            [16.265069898338098, -4.906064834620889],
            [16.265069221906682, -4.905705883966844],
            [16.265533853927845, -4.905381945578734],
            [16.266250148077525, -4.905667750415177],
            [16.266463927352216, -4.905164811343278],
            [16.265854185073319, -4.904448062157051],
            [16.26588909360526, -4.903981357367306],
            [16.266425772308832, -4.903908549959476],
            [16.266281878369966, -4.903513974683372],
            [16.265635505488763, -4.902348602957582],
            [16.266706223645564, -4.900803077581459],
            [16.266275625197274, -4.900193673887262],
            [16.266775634670957, -4.899654297866382],
            [16.267277333875651, -4.900012300338427],
            [16.26806431735336, -4.899831331297918],
            [16.267956144023479, -4.899400793831406],
            [16.267275035086847, -4.898791865482239],
            [16.267774366332489, -4.897893537912776],
            [16.268632989555758, -4.897748329007366],
            [16.269347989233122, -4.897352125499435],
            [16.269203757527713, -4.896778075727285],
            [16.268345406493967, -4.897066864881316],
            [16.267701237180145, -4.897068085769176],
            [16.267664098131345, -4.8963502510576],
            [16.268307252348915, -4.895810603389158],
            [16.26920125392304, -4.895449956827875],
            [16.268949526217497, -4.89480431968282],
            [16.268124700310125, -4.893890553868549],
            [16.267408757401739, -4.89378422347431],
            [16.266549057996716, -4.893355107491589],
            [16.266083354285453, -4.893104721303071],
            [16.266082140661506, -4.892458608824093],
            [16.266474650541735, -4.89184764675072],
            [16.266044532692121, -4.891489507399128],
            [16.265936294683552, -4.89102307276412],
            [16.266508750589921, -4.890950199953272],
            [16.267296804859438, -4.891343558239018],
            [16.267439074644251, -4.89087665045883],
            [16.266471614236078, -4.890232364899087],
            [16.264895039471416, -4.889194379690452],
            [16.264893489877558, -4.888368790529918],
            [16.26467715399756, -4.887507712083921],
            [16.26503300183445, -4.886430181413108],
            [16.265639220022464, -4.885280388258391],
            [16.265887639232826, -4.884167165494326],
            [16.26699756076696, -4.884452231649871],
            [16.267245404157222, -4.883033900751442],
            [16.266314619267146, -4.882856181630228],
            [16.266277486506556, -4.882138345900558],
            [16.265668646136216, -4.881888227580174],
            [16.265452380324824, -4.881063042882332],
            [16.265880672797802, -4.880452015318373],
            [16.266524692991275, -4.880379009790128],
            [16.266201404591889, -4.879733504800428],
            [16.265806140476993, -4.878872762923501],
            [16.265124857267185, -4.878156141095424],
            [16.26397902647788, -4.877799345007108],
            [16.263190789850388, -4.877298293147633],
            [16.262042413235541, -4.875577475035428],
            [16.261074245853255, -4.874538327012058],
            [16.261179930849806, -4.873640744113229],
            [16.260212035657041, -4.872745174763838],
            [16.259351433445165, -4.871813507796288],
            [16.259420600128784, -4.870521143332385],
            [16.259131842070587, -4.869193554731411],
            [16.258128771546243, -4.868621104251873],
            [16.257410788563853, -4.867402001845482],
            [16.257408722438697, -4.866289247344763],
            [16.257405924186568, -4.86478164481244],
            [16.25815342401259, -4.862626524057036],
            [16.258401258419713, -4.861190244866314],
            [16.259149953005039, -4.859681238606168],
            [16.258647492927302, -4.858892478430115],
            [16.256893081380785, -4.858393214455003],
            [16.255424886558501, -4.857857517737131],
            [16.253238071848287, -4.855743751255758],
            [16.250267037776531, -4.855282621373529],
            [16.247977507900099, -4.855681710962809],
            [16.24690193884074, -4.854588884099398],
            [16.24532462296597, -4.853084181764499],
            [16.24450268154898, -4.853695922939396],
            [16.2433768876821, -4.853833204756255],
            [16.241826761116016, -4.854147153726108],
            [16.240538272469717, -4.854029871506339],
            [16.240155207476374, -4.853288731416679],
            [16.240487586826458, -4.852402694252351],
            [16.240294766145642, -4.851326178880952],
            [16.240411429453292, -4.849890137519412],
            [16.240385956825101, -4.849004757234941],
            [16.240695439016896, -4.848645232312767],
            [16.241338345299432, -4.847973999181256],
            [16.240835696575445, -4.847065565512903],
            [16.240953625609336, -4.846323505771138],
            [16.241405852794713, -4.845748344047085],
            [16.242288284067985, -4.845603140848189],
            [16.242668720590792, -4.84490845906145],
            [16.242667409948794, -4.844190548998274],
            [16.242070036573068, -4.843665176440818],
            [16.242187659281417, -4.842755604224051],
            [16.242854940450865, -4.842371491262665],
            [16.243044263091942, -4.841533578138187],
            [16.243305197630839, -4.840719464736732],
            [16.242684276716563, -4.840361648342911],
            [16.242778305173982, -4.839595701936389],
            [16.242920744740374, -4.839212554040278],
            [16.242442395444872, -4.838543379453068],
            [16.242416794357556, -4.837586209301961],
            [16.242153720929974, -4.837227735224749],
            [16.241604983242066, -4.83720481110123],
            [16.24098450160394, -4.837086295893143],
            [16.241030646263475, -4.836224714875322],
            [16.240624523313397, -4.835914362800522],
            [16.240169688318751, -4.835053699402446],
            [16.240311737118009, -4.834455177528207],
            [16.240644809069153, -4.833952028595205],
            [16.241383522473363, -4.833495997452209],
            [16.242051363293271, -4.833422982266629],
            [16.242028291861814, -4.833853772467204],
            [16.242172300785008, -4.83433211753798],
            [16.242554216833099, -4.834451069371291],
            [16.243197264151146, -4.833863594566328],
            [16.243411445871072, -4.833576035884237],
            [16.243124605716012, -4.833265467214324],
            [16.242742209967574, -4.832883280779207],
            [16.242478005561043, -4.831902617725619],
            [16.241880427369413, -4.831257590168588],
            [16.241068886646786, -4.831019770950578],
            [16.241139149275057, -4.830301728818277],
            [16.241185425088602, -4.82951193907399],
            [16.241136929537998, -4.82908128034373],
            [16.241517885287056, -4.828673765625667],
            [16.241564552766071, -4.828099349251704],
            [16.24199361150194, -4.827907120078329],
            [16.242352234234723, -4.828337211860075],
            [16.242829135446044, -4.82821668648942],
            [16.242946019739211, -4.826900297446071],
            [16.243231331859974, -4.826373305502622],
            [16.243994501897824, -4.826252255326413],
            [16.244280271261044, -4.82597653139533],
            [16.244780371464568, -4.825497006190668],
            [16.244898691265565, -4.824970319524491],
            [16.245398965742261, -4.824586515343427],
            [16.24630539820329, -4.824536991451502],
            [16.247092900907223, -4.824679128201514],
            [16.24761847104395, -4.825084979176411],
            [16.247904696751359, -4.825060522729658],
            [16.248261833670682, -4.824676979925739],
            [16.249048461415505, -4.824340507955858],
            [16.249835700913057, -4.824339059851487],
            [16.250527342596392, -4.824242064785479],
            [16.250956044701113, -4.823858389047847],
            [16.251719251569881, -4.823761261447095],
            [16.252148171965231, -4.8234972366843],
            [16.252027688122695, -4.822839373517367],
            [16.252241863554403, -4.822551814605208],
            [16.252193362613916, -4.822121157707342],
            [16.251381000831106, -4.821428673703429],
            [16.251737695779287, -4.820805827225959],
            [16.252285410286134, -4.820278350187885],
            [16.25207014070639, -4.81996765189579],
            [16.2519257805419, -4.819297867826125],
            [16.251900830733216, -4.818699654473043],
            [16.251471124312005, -4.818532933611932],
            [16.251374476367218, -4.817863060699808],
            [16.250682098963658, -4.817553239892484],
            [16.250371277383753, -4.817170925542772],
            [16.250322604865055, -4.816644546830902],
            [16.249606896416946, -4.816621931992471],
            [16.249153205875967, -4.81638346146686],
            [16.248747356912073, -4.816216694072352],
            [16.248794413361598, -4.815857651654114],
            [16.249032443555659, -4.815570049197349],
            [16.248888917926109, -4.815354939319556],
            [16.248840595750345, -4.815020002712513],
            [16.248983073944281, -4.814660784833734],
            [16.249244260909791, -4.81399025473226],
            [16.249792759645839, -4.813893525807218],
            [16.250747237601523, -4.814035354821987],
            [16.251367214386448, -4.813890632256759],
            [16.251294774241945, -4.81341215814752],
            [16.250983998476126, -4.813053773862291],
            [16.251699046662498, -4.812717433935809],
            [16.251888489677825, -4.811951313531407],
            [16.252220888790841, -4.811089209068507],
            [16.251742865583747, -4.81058755020292],
            [16.251765409704106, -4.809869597930817],
            [16.252288650509364, -4.809007142955512],
            [16.252287645294544, -4.808456745957952],
            [16.251642900160611, -4.808098975412285],
            [16.250999291395512, -4.808363391922626],
            [16.250545562226989, -4.808100990371688],
            [16.250162789186103, -4.807503432989829],
            [16.250567060708359, -4.806808709878208],
            [16.251256938998793, -4.805754507482687],
            [16.251803597086852, -4.804652706535113],
            [16.251730940448347, -4.804054580167047],
            [16.25122976675809, -4.803935848229946],
            [16.25094437917884, -4.804414979715398],
            [16.250754978384347, -4.805205029697427],
            [16.250183459420779, -4.805756477391735],
            [16.24951569136444, -4.805853422862348],
            [16.248822630342989, -4.805160711212054],
            [16.248963930845601, -4.804155375595442],
            [16.249367767583266, -4.803221350177068],
            [16.249605097989726, -4.80255086453513],
            [16.249770557783609, -4.801712997151291],
            [16.250461131370059, -4.801041680945016],
            [16.250794271593186, -4.800586393414089],
            [16.250911933827407, -4.799700753313592],
            [16.251077240009351, -4.798779130647849],
            [16.251291061504872, -4.798300130324744],
            [16.251576578441504, -4.797892790674207],
            [16.251479328625461, -4.796887892981641],
            [16.251263458971128, -4.796242168529598],
            [16.250499976319585, -4.796171775273797],
            [16.250522656085568, -4.795525613072267],
            [16.25042562635678, -4.794640366435085],
            [16.250854401225034, -4.79430455619963],
            [16.250734649509464, -4.794041540883354],
            [16.250137716308213, -4.79373153788092],
            [16.250041557945245, -4.793324897476156],
            [16.250183163875072, -4.792487074490608],
            [16.250157874503184, -4.791697416918736],
            [16.250371304333235, -4.791003045178472],
            [16.251538806978751, -4.790247102189343],
            [16.251560790550386, -4.789218055266788],
            [16.251250203430789, -4.788955389423563],
            [16.251106119947437, -4.788429184195925],
            [16.251558006671313, -4.787686515290066],
            [16.252629497379289, -4.786607687252742],
            [16.252508311054182, -4.785554972636455],
            [16.252889066478957, -4.78505173752387],
            [16.25539093832559, -4.783491681149558],
            [16.256224223667996, -4.782604729918928],
            [16.256293867357037, -4.781551666616942],
            [16.256603448363485, -4.781263935061768],
            [16.257675839183381, -4.780687638892613],
            [16.258056719473952, -4.78025619371269],
            [16.258510778324208, -4.780710035950488],
            [16.258844561741054, -4.780613701470701],
            [16.259153354026715, -4.779895224324318],
            [16.259151913129003, -4.77910552679655],
            [16.259508980878014, -4.778698054803705],
            [16.259269610397514, -4.77824381829921],
            [16.25926886838911, -4.777837004553567],
            [16.259650226583403, -4.777668792030033],
            [16.259506098184264, -4.777118658734285],
            [16.259313824577482, -4.77632931123049],
            [16.259050426858085, -4.775779397636798],
            [16.258477320571448, -4.775445424559305],
            [16.258070887702608, -4.774943632836758],
            [16.257618185308434, -4.775231627523788],
            [16.257188378275917, -4.774993111711862],
            [16.256829131214012, -4.774204068133706],
            [16.256636645604818, -4.773295067898529],
            [16.256301297322732, -4.772529910241986],
            [16.255727456214203, -4.771789119082457],
            [16.255798060202274, -4.771262521994313],
            [16.256775850337867, -4.771141080708016],
            [16.257371891512033, -4.770972477204785],
            [16.257585660905256, -4.770469548464689],
            [16.25813351465095, -4.770037798475711],
            [16.258919271928292, -4.769258622633616],
            [16.259299973454137, -4.768731457627015],
            [16.260230486154658, -4.768849402700689],
            [16.260539668309161, -4.768346298453781],
            [16.261110629418894, -4.767507689311131],
            [16.261396567665397, -4.767339652659409],
            [16.261658303501537, -4.766980217436281],
            [16.261418675204567, -4.766382399260427],
            [16.261178786396137, -4.765641000280206],
            [16.261224617543622, -4.764611912326231],
            [16.261437467960278, -4.763606448775775],
            [16.261031827405546, -4.763535401453217],
            [16.26074514894723, -4.763296623780461],
            [16.260792070649455, -4.762865792058305],
            [16.261364511284512, -4.762840812457991],
            [16.262032365579106, -4.762815656220548],
            [16.262246611079423, -4.762575959966286],
            [16.261983699348583, -4.762289279267053],
            [16.261506236690249, -4.76207478235058],
            [16.261505190152928, -4.761500456116349],
            [16.262006026076644, -4.76145167739527],
            [16.262196199422309, -4.761092373332594],
            [16.262028658231916, -4.760781587403381],
            [16.261383917589573, -4.760399884356292],
            [16.261454955463943, -4.760112589916198],
            [16.262098997216977, -4.760111409332874],
            [16.262695200986219, -4.76003852498104],
            [16.262693892140845, -4.759320618113442],
            [16.262764275143365, -4.758674370247755],
            [16.262405994668708, -4.758411794391951],
            [16.262238105830306, -4.757909565593597],
            [16.262643263091434, -4.75771738039751],
            [16.262928892317504, -4.757381832117322],
            [16.262927889797641, -4.756831436329518],
            [16.262664413924792, -4.75623366238742],
            [16.26294943229647, -4.755563091406594],
            [16.263400681216506, -4.754485400015839],
            [16.262899284744037, -4.754223085696627],
            [16.262493475306012, -4.754056317373702],
            [16.262612131076956, -4.753721075502274],
            [16.26316049237078, -4.753576488718272],
            [16.263589326527843, -4.75328853891159],
            [16.26339667023877, -4.75228381922887],
            [16.262942502692361, -4.751758184832034],
            [16.262918039770536, -4.751423204984078],
            [16.263204015746282, -4.751279099864421],
            [16.263633763490027, -4.751493684903441],
            [16.26406290127764, -4.751373246743609],
            [16.264014104791404, -4.750775078675392],
            [16.263345609099684, -4.750441278943511],
            [16.263106468587903, -4.750106693182323],
            [16.263487333607124, -4.749675250179948],
            [16.263414816207501, -4.749148916221077],
            [16.263128536601165, -4.749125509652321],
            [16.262652433992169, -4.749652848492381],
            [16.262270741624587, -4.749629616778119],
            [16.262174372157535, -4.749103326943935],
            [16.262483634262075, -4.748648084687874],
            [16.262482024481077, -4.747762665935459],
            [16.27079615970937, -4.744326962214497],
            [16.275168359910186, -4.741685819158086],
            [16.278644160035057, -4.739602891554694],
            [16.283555639562174, -4.737096976462847],
            [16.287631560110931, -4.733365925549372],
            [16.290872640333507, -4.72840936004606],
            [16.294069439900827, -4.719140040479449],
            [16.298897400361032, -4.708419107717214],
            [16.30373363969489, -4.698519411154423],
            [16.306939080156923, -4.690071281931022],
            [16.312365359918832, -4.677496161008277],
            [16.317808200123036, -4.666564055153926],
            [16.322858279817016, -4.657483594635624],
            [16.326672479800987, -4.648208112555903],
            [16.331292720123091, -4.637282371455373],
            [16.336739520101066, -4.626760467269886],
            [16.341762960255323, -4.615009295947423],
            [16.34860152010295, -4.599750533617114],
            [16.355068920329728, -4.58839772988251],
            [16.359499800281508, -4.57911612283517],
            [16.365345840317833, -4.567357328567624],
            [16.371623880174283, -4.557648940212722],
            [16.376921639765158, -4.552674056810823],
            [16.383015000372229, -4.545021495315736],
            [16.388599319843799, -4.535666916182997],
            [16.394905440137684, -4.521506894761657],
            [16.395854389861135, -4.514374683685742],
            [16.397094240124687, -4.505055988384798],
            [16.3970643603617, -4.489125938175645],
            [16.398779399647633, -4.486395971852891],
            [16.401848400391049, -4.481514023244748],
            [16.404087240132633, -4.468618952565385],
            [16.406137439952733, -4.465158869828924],
            [16.415737199998205, -4.457298022914604],
            [16.419634200396871, -4.456592952367572],
            [16.424696319312289, -4.460895221456493],
            [16.441732440179234, -4.475373943990589],
            [16.445005217456629, -4.476214104367681],
            [16.453212480115571, -4.478321001816354],
            [16.458777986170123, -4.480968319494541],
            [16.464245399788929, -4.483568969667322],
            [16.468629594295386, -4.484101059631134],
            [16.475261399693888, -4.484905930772809],
            [16.478693262319894, -4.482820993060727],
            [16.486803665929965, -4.483185958593405],
            [16.494233545406644, -4.483520310397623],
            [16.497508525353119, -4.483667688327182],
            [16.501923228443307, -4.484990354964316],
            [16.502789879910267, -4.485250007840408],
            [16.50830328008508, -4.485622293732308],
            [16.513029720138409, -4.485171849542379],
            [16.514889479813238, -4.485978049292491],
            [16.518841200189097, -4.490259498717164],
            [16.523620199771372, -4.49494500597635],
            [16.527985560199618, -4.499428352707627],
            [16.535245320321071, -4.505325672640103],
            [16.543344239868542, -4.512859539873961],
            [16.555376520024101, -4.522825818913214],
            [16.562628000373572, -4.527901164111043],
            [16.570087199962813, -4.533180210159148],
            [16.579416240121013, -4.540292478982904],
            [16.587716759584531, -4.547413479764534],
            [16.594134839607268, -4.551468372272857],
            [16.598896920319472, -4.554510155919587],
            [16.603025400397172, -4.555913636712996],
            [16.607344679946277, -4.555877346079047],
            [16.609787999602698, -4.553391608572812],
            [16.610957280014201, -4.547013019438372],
            [16.611709319925652, -4.54002172973231],
            [16.611850079642476, -4.533651644511425],
            [16.611762239679031, -4.525023660420031],
            [16.611672600390097, -4.516190032782267],
            [16.611351839849906, -4.504892848735221],
            [16.611469919800744, -4.496262720424836],
            [16.610758920321356, -4.487023034649635],
            [16.610475959989994, -4.4794233155964],
            [16.610405039794948, -4.472438194367665],
            [16.60990176045366, -4.463401960281825],
            [16.608974399941456, -4.453136226588834],
            [16.607398680372963, -4.439793951874712],
            [16.606901879681477, -4.43137364175744],
            [16.606816200166318, -4.422949820852971],
            [16.606289879936273, -4.411652799025765],
            [16.607238840439486, -4.403836479146285],
            [16.607805839978855, -4.398900068543048],
            [16.607973959684276, -4.395199939593909],
            [16.609162320312365, -4.390669408354487],
            [16.610335919823747, -4.384700357356289],
            [16.611738119913664, -4.380989734415291],
            [16.613958599887471, -4.376861288087735],
            [16.616593080138031, -4.372934983833773],
            [16.620887520371227, -4.370432984738404],
            [16.62842340015311, -4.369457017695307],
            [16.635957581220811, -4.362292923392999],
            [16.647417359655911, -4.36063390099709],
            [16.654056480035781, -4.358074893303375],
            [16.658394410406789, -4.35345399624392],
            [16.662979351429819, -4.353205032535826],
            [16.665949439575598, -4.350430884591304],
            [16.668205609615651, -4.343140504024531],
            [16.668659160019448, -4.341674933278443],
            [16.675564247300418, -4.333973342614931],
            [16.679842137871123, -4.329201956311389],
            [16.683965280159402, -4.328493997362299],
            [16.685889398734449, -4.328948868886852],
            [16.689705479790639, -4.329851009319312],
            [16.692343962035803, -4.32920320524164],
            [16.695432360101147, -4.328444936446838],
            [16.702226663548, -4.322855391360234],
            [16.702741440426603, -4.322431892968034],
            [16.70807016045374, -4.33391502109711],
            [16.713197392854234, -4.35207083842831],
            [16.718384520426273, -4.349476456102926],
            [16.719811920056532, -4.348231437996691],
            [16.721839440110678, -4.345337411055949],
            [16.72197099838403, -4.345154559874066],
            [16.724070719630824, -4.34223616680154],
            [16.726081680141004, -4.337698303153251],
            [16.727070600403007, -4.333785449669864],
            [16.728886080320841, -4.330276748873668],
            [16.73133552019932, -4.328406656919173],
            [16.734009599984265, -4.328384193283092],
            [16.737094800047174, -4.32835831469733],
            [16.740005760182669, -4.3314164849759],
            [16.741879919851502, -4.333661267975913],
            [16.743135240002569, -4.335705846526611],
            [16.743785400181039, -4.338988266413276],
            [16.744668840262353, -4.344940433749164],
            [16.744764959997749, -4.354392531242282],
            [16.74481931975054, -4.359735014306063],
            [16.744858920183219, -4.36363910544766],
            [16.744907159713986, -4.368364960880888],
            [16.744942440148424, -4.371858026661179],
            [16.744990679679191, -4.376584009036298],
            [16.745427000395864, -4.379046273091205],
            [16.746896160008724, -4.38191069842471],
            [16.75080827995194, -4.382288966592331],
            [16.753687920325028, -4.382264707517865],
            [16.757990640330174, -4.380584689828801],
            [16.760643839674653, -4.378507530449292],
            [16.763901480339523, -4.375192400398556],
            [16.767754919633404, -4.369817322150594],
            [16.770393359657774, -4.366301783345542],
            [16.77221532002207, -4.363409623065842],
            [16.775038800418553, -4.357837502016555],
            [16.778300399958866, -4.35493326890965],
            [16.781988240220048, -4.353463806114052],
            [16.785889919943028, -4.35281452390461],
            [16.789806359884413, -4.353603617714207],
            [16.79579244008702, -4.355608426004597],
            [16.799738040240857, -4.359274249929857],
            [16.803146160393911, -4.362266880972719],
            [16.806376449154985, -4.360084899637993],
            [16.807260239579303, -4.359487919261143],
            [16.818954480100171, -4.358975938015562],
            [16.826042159844128, -4.354342931899954],
            [16.832942709734592, -4.35431184044615],
            [16.839802440178545, -4.354280932942816],
            [16.844377320070382, -4.351729990940234],
            [16.846660289550275, -4.349302373463298],
            [16.848940319742571, -4.346877874368731],
            [16.851348782071049, -4.338168888266551],
            [16.851871439869658, -4.336278945212596],
            [16.851951863342101, -4.335408419692696],
            [16.852743359955799, -4.326840995504477],
            [16.852216541160768, -4.320143052940541],
            [16.851766319913413, -4.314418921224776],
            [16.852431075020284, -4.309233202598363],
            [16.853094359585047, -4.304058917035861],
            [16.855602480112825, -4.296383983312356],
            [16.856258400288883, -4.294379914392703],
            [16.862877000452716, -4.297298760981678],
            [16.864541280433492, -4.299134424420708],
            [16.867863359948654, -4.302189119446854],
            [16.870982400446653, -4.305451198722979],
            [16.875141840062284, -4.309937499606101],
            [16.879517639812434, -4.31544959332238],
            [16.883685720322813, -4.320757671804929],
            [16.887022920280817, -4.325250889520862],
            [16.892431199601091, -4.331165067445556],
            [16.896375000429405, -4.334625600795753],
            [16.9030134003604, -4.34011846410816],
            [16.907578200256438, -4.343984560847053],
            [16.911114480356126, -4.347859442018647],
            [16.914035879813525, -4.351944920352374],
            [16.917374879995347, -4.356643355017793],
            [16.919683560157001, -4.361144802645685],
            [16.921156680441971, -4.364420460973023],
            [16.923056039651151, -4.369130856174142],
            [16.925164920120576, -4.374250403071536],
            [16.926455519807817, -4.379787898161777],
            [16.928184599761622, -4.387992981960782],
            [16.931758680070171, -4.395565982354339],
            [16.933431239822934, -4.398223153081397],
            [16.935723000216221, -4.401080854939792],
            [16.938629999679581, -4.40372776372597],
            [16.942539960072875, -4.40390045038945],
            [16.94582891960178, -4.403667386500651],
            [16.952383799567535, -4.400941052325543],
            [16.955666639772748, -4.400091631559089],
            [16.958949119753559, -4.399242029476883],
            [16.962844680152813, -4.397976430682299],
            [16.967168279700125, -4.398351096539757],
            [16.970075280061813, -4.400998015160885],
            [16.971764400256831, -4.405299013402633],
            [16.973042400173885, -4.409603400113042],
            [16.973239830110401, -4.41133730563446],
            [16.973720279667084, -4.41555679545538],
            [16.97420051991628, -4.422333483618714],
            [16.973446679780984, -4.429120530942395],
            [16.969200119752447, -4.436347747526529],
            [16.964729280041876, -4.441727729284026],
            [16.96025664010746, -4.44690193186241],
            [16.955156160434459, -4.451054241158254],
            [16.951077720111343, -4.45458141264178],
            [16.945765559628168, -4.458118808222268],
            [16.940455200267142, -4.461861920881309],
            [16.939265040313501, -4.466186637050965],
            [16.939304639847851, -4.470090160753098],
            [16.939361160048897, -4.475637171465231],
            [16.940649239961747, -4.480968348344742],
            [16.942976640115614, -4.487318059514406],
            [16.944456239948746, -4.491209431383222],
            [16.946346960059838, -4.495097368044338],
            [16.948647360449513, -4.498776146686795],
            [16.95093299972245, -4.501017002464155],
            [16.954664400190051, -4.503862082281004],
            [16.959617639699768, -4.505464198412354],
            [16.965993959739905, -4.505410836400228],
            [16.971753239587756, -4.505362504964625],
            [16.977919679939834, -4.50489985549095],
            [16.98407568007168, -4.503410033051126],
            [16.987555800194759, -4.501737122337973],
            [16.992792360260243, -4.498558923655532],
            [16.994517133690589, -4.49768335311252],
            [16.995081166992875, -4.497397025220056],
            [17.000778240303923, -4.489777973535852],
            [17.003749860077289, -4.487922932324419],
            [17.006721479850619, -4.486067886336149],
            [17.012191500380364, -4.478909982970754],
            [17.012296342757175, -4.478911471464214],
            [17.019659160302972, -4.479015989664307],
            [17.024349240146847, -4.479083008822568],
            [17.027884794407782, -4.481103011980703],
            [17.031940200130393, -4.483420019387834],
            [17.036072279757427, -4.483860941444743],
            [17.054294399581593, -4.504484998096679],
            [17.05668575708874, -4.509360642323654],
            [17.058235320411111, -4.512519967441567],
            [17.065103475255814, -4.521726766708523],
            [17.0674723829657, -4.524902203173839],
            [17.075309399590374, -4.532458864323467],
            [17.094845159990502, -4.539959926906227],
            [17.106825239943223, -4.550027873279494],
            [17.116009284828049, -4.551592517708498],
            [17.119225526633048, -4.551809770591098],
            [17.125322040326761, -4.55687426102759],
            [17.129872440228798, -4.559301418760016],
            [17.135868600427198, -4.562332747878955],
            [17.140626719569006, -4.564963435345243],
            [17.146402559859116, -4.566558586498328],
            [17.153601840005752, -4.566498042617909],
            [17.159545800001283, -4.564393929967664],
            [17.167532040269403, -4.560834421965079],
            [17.173648439968602, -4.555441678031853],
            [17.177901120219161, -4.548831886008955],
            [17.181330840363223, -4.542229040705229],
            [17.183724120265062, -4.534812981969991],
            [17.186119200390753, -4.527602202818521],
            [17.187695640408116, -4.520809073974656],
            [17.190687239611687, -4.511538800606959],
            [17.192400479572104, -4.497964391514668],
            [17.193748319909229, -4.488912844974068],
            [17.19511488023857, -4.481710228670897],
            [17.198664839883424, -4.466681653073376],
            [17.201855520127019, -4.456792578906017],
            [17.20870091974724, -4.442146754811022],
            [17.213346000283586, -4.433683347058908],
            [17.219636639910195, -4.425206005453346],
            [17.226544319729086, -4.416723533390151],
            [17.23305743971224, -4.409888034159293],
            [17.238758400033529, -4.404086614177264],
            [17.243443080104221, -4.399526667540658],
            [17.25159959962772, -4.392471776973639],
            [17.256091319778754, -4.389146287147132],
            [17.258960519931613, -4.388094691825491],
            [17.264717640229541, -4.387840957245757],
            [17.269983301218662, -4.387700972680816],
            [17.278706520244196, -4.387929009334074],
            [17.284673880454591, -4.388084448704983],
            [17.292687119588575, -4.387195300219487],
            [17.300692440073309, -4.385484205420806],
            [17.309709359687734, -4.382120767981739],
            [17.3199582001367, -4.378541493686895],
            [17.328966479754708, -4.374356067882699],
            [17.3406322796137, -4.368504410791788],
            [17.351874360322871, -4.361423345375071],
            [17.361474839918888, -4.354766860316149],
            [17.371883520301292, -4.346665099536721],
            [17.381674800267017, -4.33856846259684],
            [17.390247120291118, -4.331920577725858],
            [17.398195560350409, -4.324661248597465],
            [17.405128439709646, -4.318643323188541],
            [17.412057360193405, -4.312214516077032],
            [17.417764439838422, -4.307028765979005],
            [17.423672760073377, -4.301430523921112],
            [17.428376520360722, -4.298719270438543],
            [17.436683286708725, -4.297343761357607],
            [17.439460559563607, -4.296365651639794],
            [17.445818159611527, -4.294462766048322],
            [17.452794960299951, -4.29276008577041],
            [17.45751960012943, -4.29210392244342],
            [17.461396080312031, -4.288988618696083],
            [17.465054760360765, -4.284642197754877],
            [17.471572200342131, -4.278216335782883],
            [17.479514520179361, -4.270340023951839],
            [17.486629920136352, -4.262059420571807],
            [17.49396600022601, -4.255215672956709],
            [17.500896720035286, -4.248991760034006],
            [17.507422079564193, -4.243387875666192],
            [17.51335163956572, -4.23984406606139],
            [17.517855960385273, -4.237751060013381],
            [17.521965360246323, -4.237305497597725],
            [17.526933529756064, -4.237963892665064],
            [17.532472319914078, -4.238861459374119],
            [17.538867359946394, -4.240657542890526],
            [17.54689751974707, -4.241412425033465],
            [17.552656799594956, -4.241364076336686],
            [17.563344479636619, -4.240452286620924],
            [17.575677360340773, -4.239526655842868],
            [17.588824560256715, -4.23777208877522],
            [17.600739840236411, -4.236233379273569],
            [17.612207280402554, -4.233137976709314],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Mbandaka",
        AREA: 103902,
        POPULATION: 1528000,
        DISTRICTS: [
          "Basankusu",
          "Bomongo",
          "Lukolela",
          "Bolomba",
          "Bikoro",
          "Ingende",
        ],
        OBJECTID: 3,
        NOM: "Equateur",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [19.511884587521344, 2.021958127160518],
            [19.600317086896332, 2.005178118798215],
            [19.636901906598428, 2.004872042282159],
            [19.680539031286884, 2.004256703150031],
            [19.721283625676197, 2.003682153594018],
            [19.818458317393848, 2.005409947417081],
            [19.905069960434005, 2.006949926436954],
            [19.904239723075388, 1.994588635028163],
            [19.904080061906669, 1.99221144646827],
            [19.905819171550629, 1.988700956280637],
            [19.908050039642372, 1.984200007705246],
            [19.907349912472888, 1.981081925233411],
            [19.907170020345671, 1.980280757597417],
            [19.895349959989442, 1.974180014545192],
            [19.892039226196321, 1.970533263458334],
            [19.889240039838409, 1.967449970486791],
            [19.888239959805635, 1.95294001327191],
            [19.887651826500921, 1.95237697866899],
            [19.88168004029113, 1.946660023366344],
            [19.877780159893671, 1.947310107857042],
            [19.86441012029508, 1.95821991328737],
            [19.857790080131863, 1.957920001165253],
            [19.855817919655443, 1.955852479511202],
            [19.855310040041555, 1.955320041645558],
            [19.848509999953301, 1.948170041100332],
            [19.841982916557367, 1.947051829168467],
            [19.838469960315717, 1.946449993400911],
            [19.835741401302062, 1.944580803722694],
            [19.834914137367036, 1.943486828621883],
            [19.831010040277601, 1.938320051349742],
            [19.82731866245085, 1.927685319283672],
            [19.824119999777647, 1.918470028694788],
            [19.813551891788503, 1.900193199821563],
            [19.81518328265015, 1.895977161819795],
            [19.818969572876565, 1.886210646779991],
            [19.820750040057895, 1.867590023137808],
            [19.821847947523413, 1.862603854849525],
            [19.824590626256708, 1.850149867797071],
            [19.822139999703726, 1.843220027312082],
            [19.802310120099833, 1.832159970602888],
            [19.802207066268743, 1.832102291778264],
            [19.799875930919946, 1.830799208660078],
            [19.772025424437135, 1.826139122212026],
            [19.754022301302804, 1.822716686980985],
            [19.749128686571769, 1.821786398670204],
            [19.748990160066725, 1.821760064265526],
            [19.732349880033116, 1.817219948861923],
            [19.728090278263284, 1.817176625427942],
            [19.712689920358457, 1.817019990718186],
            [19.708188704116541, 1.818186827951427],
            [19.700769960156116, 1.820109965455071],
            [19.688212721616516, 1.819520133437257],
            [19.6844612500905, 1.819623157183495],
            [19.682030160098332, 1.819690055364625],
            [19.680540120044999, 1.818839965590693],
            [19.663573655443489, 1.815952247385973],
            [19.646074241943523, 1.812973815259523],
            [19.633902493848499, 1.81090215917341],
            [19.6338868119586, 1.810899187111568],
            [19.606309919734919, 1.803480097206272],
            [19.600840079766556, 1.802499936161206],
            [19.599125040480622, 1.803768822257966],
            [19.597151360054713, 1.805229064386187],
            [19.585951049209644, 1.805110045039763],
            [19.581510397384175, 1.804472470512012],
            [19.568608442930685, 1.802619480855813],
            [19.553113316356669, 1.798330930637872],
            [19.54238524985643, 1.795909024202377],
            [19.522550160023869, 1.79155996397382],
            [19.515480119598884, 1.789639981291893],
            [19.513730084644422, 1.788790277723429],
            [19.508205412409428, 1.786108759620775],
            [19.480399368041592, 1.778220156155147],
            [19.478771361133678, 1.778616027821573],
            [19.476740159783496, 1.779109942113595],
            [19.469479693586226, 1.773969292666638],
            [19.468809182075013, 1.772579540072432],
            [19.432214225783273, 1.753779933914171],
            [19.4271800399816, 1.753730089748087],
            [19.425515910917767, 1.752415696045029],
            [19.421280000416921, 1.74907000546271],
            [19.4158198963896, 1.747169979764178],
            [19.413147826135962, 1.745938270586211],
            [19.411719839905796, 1.74528002928934],
            [19.394439839913947, 1.736820022170733],
            [19.39389484909907, 1.736920376716082],
            [19.393300079939362, 1.737029897292211],
            [19.387075555419326, 1.730833700799964],
            [19.38605891584259, 1.729822533328185],
            [19.373994566729721, 1.725781550634093],
            [19.357140449030904, 1.7198501907199],
            [19.356019920189912, 1.718000012967465],
            [19.353329200012631, 1.717208645002302],
            [19.344629879766948, 1.714650086265521],
            [19.331859320093411, 1.711989796882732],
            [19.318409999679453, 1.708620022987023],
            [19.314332560079571, 1.704892187601635],
            [19.311849016559652, 1.702569527189395],
            [19.310503407637682, 1.702043698880629],
            [19.302739919915624, 1.699009930723639],
            [19.293689880314979, 1.690639972893387],
            [19.282560120457386, 1.683849939903755],
            [19.271840437035401, 1.675115980855756],
            [19.267390079811619, 1.671490000370203],
            [19.262369879880623, 1.670050011087113],
            [19.251089932487268, 1.659795957762265],
            [19.242910080122595, 1.65236001559284],
            [19.230450120145115, 1.642789998717729],
            [19.224150120073215, 1.633519901510944],
            [19.224359332312996, 1.632807388098552],
            [19.224619920102178, 1.631919902959353],
            [19.220715163649373, 1.627897034721968],
            [19.215359999915211, 1.622379874184353],
            [19.21064012115675, 1.593580246491116],
            [19.208530956819704, 1.577457586540769],
            [19.211020601697012, 1.570897409122116],
            [19.212530039970598, 1.566920052209926],
            [19.212183171693329, 1.565947623822783],
            [19.211870377413067, 1.565070718151705],
            [19.212246436445518, 1.564639641591467],
            [19.213260060377827, 1.56348003398901],
            [19.216259307837724, 1.560290862032306],
            [19.210055040327372, 1.459232296289471],
            [19.212896520267162, 1.349838566722429],
            [19.223101440285273, 1.355229824628424],
            [19.232181719873306, 1.359504479373153],
            [19.245022199916956, 1.365356981185878],
            [19.258949159957382, 1.370994511677233],
            [19.27020348021227, 1.374839945544077],
            [19.282400279625616, 1.381131690585909],
            [19.297038959594303, 1.388770627991717],
            [19.30850568020994, 1.392395492253183],
            [19.31867316024362, 1.396455665612074],
            [19.329271560322454, 1.400296553386098],
            [19.342998719772353, 1.406598499250699],
            [19.355352119794208, 1.41067288167566],
            [19.365944040324912, 1.414292126111869],
            [19.377241919887926, 1.41969062275684],
            [19.387490039888053, 1.426635028080433],
            [19.396189079859379, 1.43290392944332],
            [19.404239040325546, 1.439390287231636],
            [19.416204720284263, 1.445236820402367],
            [19.427258879724192, 1.449746437974389],
            [19.436582880333642, 1.454910080808364],
            [19.44340919973725, 1.45672984816955],
            [19.446725520153084, 1.458082601760052],
            [19.480348455124563, 1.48237526319357],
            [19.495169280195217, 1.493083263617284],
            [19.51263108033595, 1.503554471110683],
            [19.52494524014956, 1.516699171690345],
            [19.532018880123914, 1.522516131157927],
            [19.53797436011466, 1.527239448555171],
            [19.548714240359192, 1.530035670815996],
            [19.562430240038282, 1.53500832484538],
            [19.57689216030516, 1.540710287401029],
            [19.582840440298902, 1.544692715409705],
            [19.590666480409144, 1.551979940621319],
            [19.612253879730485, 1.569055013407267],
            [19.629404640000718, 1.585828891447896],
            [19.640217239765786, 1.596403770009658],
            [19.652825160355423, 1.601393739940438],
            [19.679855425932079, 1.611769118757534],
            [19.689937200399452, 1.619338217607614],
            [19.705911120036777, 1.628721342058256],
            [19.723310639978841, 1.632525239655594],
            [19.739588400387994, 1.634864793710522],
            [19.762128719986283, 1.635254298608869],
            [19.783929959667717, 1.635655513795627],
            [19.810964880314167, 1.642643349385476],
            [19.844296920135388, 1.651385360378453],
            [19.879482959633851, 1.660839314317765],
            [19.899868679904671, 1.667930829964555],
            [19.919547000245398, 1.678367452562846],
            [19.931464080448947, 1.688554684401277],
            [19.945604879951201, 1.699448064287319],
            [19.959728040134515, 1.708489412224835],
            [19.96639451960468, 1.710237793372309],
            [19.974897719657555, 1.710846169125557],
            [19.987460640041324, 1.711020917422444],
            [20.002616279794793, 1.711896097769894],
            [20.010394439700377, 1.71399757501323],
            [20.019677399877761, 1.719039308907746],
            [20.043795240166723, 1.730147793246192],
            [20.058640200274098, 1.737325523629718],
            [20.072000520101291, 1.743785691197925],
            [20.087570520355953, 1.749470295556704],
            [20.09942928013464, 1.753360605056964],
            [20.111277599693061, 1.75613957332926],
            [20.120888879733744, 1.756730819862777],
            [20.130492959777396, 1.756581116755221],
            [20.140094159822283, 1.756061028257971],
            [20.150057520165532, 1.754794225927577],
            [20.161125720273365, 1.753139923365977],
            [20.175511319673678, 1.750692965680986],
            [20.190642839661745, 1.748975246977843],
            [20.202094439834507, 1.748796899108538],
            [20.215779479975662, 1.750435892782305],
            [20.2305794398772, 1.752798362187879],
            [20.237596200324408, 1.752503819428151],
            [20.251227600263316, 1.74840165286987],
            [20.270006639631017, 1.741625878649725],
            [20.284183800241014, 1.736588889771623],
            [20.298362399952129, 1.73173726231699],
            [20.308510799769163, 1.730467560698289],
            [20.317745520415784, 1.730323619973233],
            [20.32772112030478, 1.730353525403261],
            [20.33451179994778, 1.72561681770664],
            [20.340910799753868, 1.718478495698856],
            [20.352766320207618, 1.70217865002241],
            [20.367065879868335, 1.690471528825104],
            [20.37733308008508, 1.682161345163697],
            [20.386868759708069, 1.674603457905023],
            [20.396604239921619, 1.668709646654775],
            [20.400096240264315, 1.666802869948916],
            [20.40470856014058, 1.666175383605594],
            [20.408036759877763, 1.666493900730692],
            [20.411739360357352, 1.667362436349253],
            [20.417110920142072, 1.668945832419427],
            [20.421933840155198, 1.671093296150282],
            [20.428797240217094, 1.674135232466703],
            [20.437886880250385, 1.678253954718865],
            [20.44715112043556, 1.681258407288268],
            [20.451033359717485, 1.681568454398368],
            [20.453983560061193, 1.68096673522987],
            [20.458216080320156, 1.679233640652875],
            [20.465767800095456, 1.676893238406976],
            [20.480342040315552, 1.674813879579264],
            [20.487714479716328, 1.673031776598363],
            [20.498616719668657, 1.673417670644926],
            [20.508043320459961, 1.6740116450719],
            [20.520996479782966, 1.676403035125293],
            [20.533372919795241, 1.676395288040464],
            [20.543711040207032, 1.675678448431487],
            [20.550527639839245, 1.673719972822656],
            [20.556962639630349, 1.6704706755104],
            [20.563209719948869, 1.666854034408552],
            [20.567085120356492, 1.666423099063377],
            [20.57041476009309, 1.666926997480298],
            [20.574876959807241, 1.670006233134018],
            [20.586580199650662, 1.677047812138595],
            [20.597166720408179, 1.683180663853441],
            [20.606294519976441, 1.691373741904613],
            [20.615044320151224, 1.698646560534225],
            [20.617265879899971, 1.699167745201211],
            [20.622064680147766, 1.698722405150486],
            [20.635093868384814, 1.697000997746687],
            [20.647346039952279, 1.695920472403953],
            [20.65752000043242, 1.69742890066981],
            [20.667148559567579, 1.699872145596301],
            [20.677717800332299, 1.704152950287745],
            [20.685139920161546, 1.707741777597206],
            [20.689210440038821, 1.708419332564539],
            [20.691419760241853, 1.707643955301393],
            [20.693615400001384, 1.705386999229605],
            [20.69470836044465, 1.703702927060207],
            [20.697587639695012, 1.695507920331298],
            [20.698797600314109, 1.686598023500119],
            [20.69942112005452, 1.674177929168454],
            [20.698754759658197, 1.662148335822867],
            [20.697135840107688, 1.646984633808706],
            [20.695555080092117, 1.635895486766429],
            [20.691869759605325, 1.617059539963583],
            [20.687109119790833, 1.601759650328739],
            [20.681625240052867, 1.588138051614417],
            [20.676027600362303, 1.582112645368407],
            [20.666908439892129, 1.57484552405576],
            [20.661320880197362, 1.569931518712107],
            [20.659815719701154, 1.56699121719685],
            [20.65903019957905, 1.562002243740378],
            [20.658792240351854, 1.556263766641243],
            [20.658683519947971, 1.544596145331641],
            [20.657095920159801, 1.512946408364624],
            [20.660459634791732, 1.487269878808809],
            [20.658210480594079, 1.483339542650445],
            [20.657930055308462, 1.483027140262583],
            [20.65550004059968, 1.480320025613747],
            [20.655254159130017, 1.477627806601978],
            [20.655079920100867, 1.475720023984468],
            [20.649218429939999, 1.466926087965001],
            [20.642829839811409, 1.448894026935178],
            [20.637834840319091, 1.428225993600643],
            [20.637359999843046, 1.416934439652681],
            [20.63834928032945, 1.4041381553451],
            [20.64100967967093, 1.392241978973251],
            [20.646173054888546, 1.376058482543147],
            [20.651092559964429, 1.364115165981715],
            [20.655459719718163, 1.357008228933813],
            [20.663830439826224, 1.344027109110913],
            [20.677732559652409, 1.328691444819677],
            [20.699793360348675, 1.297414219693035],
            [20.703344258732994, 1.291223406754151],
            [20.70815508023588, 1.282835957447552],
            [20.713939559624112, 1.269223965501816],
            [20.714799240164464, 1.262357127966417],
            [20.71474415996283, 1.256430504139714],
            [20.713214879701258, 1.250897582916524],
            [20.710007639913705, 1.243723471521952],
            [20.702283480434776, 1.227543717288238],
            [20.700313919682792, 1.214423001929766],
            [20.69089025728076, 1.182391514895027],
            [20.680149960217943, 1.183899948521671],
            [20.679472962870392, 1.184405570621754],
            [20.669799959586538, 1.191629941226196],
            [20.66686954463697, 1.192700033142376],
            [20.666130119767026, 1.192970046594099],
            [20.662658013514616, 1.19172670653831],
            [20.660209920210754, 1.190850059032702],
            [20.657330446025991, 1.192402993088121],
            [20.65308984003115, 1.194690001388399],
            [20.647547317373132, 1.201761549296061],
            [20.641809960011479, 1.204699954089238],
            [20.639480040083253, 1.209510037226876],
            [20.636920079577042, 1.209699960754027],
            [20.634000120119058, 1.209909885305001],
            [20.632789775021003, 1.209299568337034],
            [20.631719879720976, 1.208760072708837],
            [20.628143346113418, 1.204160199848933],
            [20.627209003894837, 1.202960149245201],
            [20.623780079658104, 1.203389946129682],
            [20.620990080370603, 1.208649974277818],
            [20.619282594119564, 1.20878304845912],
            [20.615730120090269, 1.209059913874777],
            [20.613690000265933, 1.207659992361183],
            [20.60726379677811, 1.210128639011435],
            [20.606319215561914, 1.210016867027082],
            [20.601110160113763, 1.209390028270621],
            [20.59937892779655, 1.211867829799431],
            [20.598559920277278, 1.21304002092927],
            [20.59407694971711, 1.213861575034122],
            [20.58780996003695, 1.215010069877781],
            [20.586596035152496, 1.223046854437055],
            [20.582960040259628, 1.22024989427],
            [20.579500978443438, 1.223669057964125],
            [20.57610023256056, 1.220880316376816],
            [20.575813546915736, 1.220993062591505],
            [20.574960120446374, 1.221329967568856],
            [20.573979840180758, 1.228680008201095],
            [20.567360160241979, 1.227699944230095],
            [20.566640536037557, 1.228249257892462],
            [20.56529015975639, 1.229280047666976],
            [20.559369540686873, 1.228540850027312],
            [20.555866325776147, 1.235635906610373],
            [20.55340127317805, 1.230843588694031],
            [20.540401559563765, 1.205570648591207],
            [20.504884656173125, 1.142724604661065],
            [20.500871759628062, 1.134675652557094],
            [20.496176640235468, 1.12355542329041],
            [20.488073399791485, 1.108767007999278],
            [20.479439159793152, 1.104087036076826],
            [20.475591479598524, 1.100142094056734],
            [20.473911330878256, 1.097261928207472],
            [20.47019724004786, 1.090895101877846],
            [20.458448280448064, 1.077449024980253],
            [20.44775623908566, 1.073209021528782],
            [20.44277028023836, 1.069023143554706],
            [20.437813440280976, 1.061849107035225],
            [20.434820400179657, 1.040209041774447],
            [20.433468159894282, 1.037162212041841],
            [20.432361239631518, 1.034668129100734],
            [20.431175405065972, 1.015115103795084],
            [20.432557320298464, 0.965700965291448],
            [20.434555396272543, 0.963666542887475],
            [20.440159919753132, 0.957960061194881],
            [20.437326394395171, 0.944137242289378],
            [20.433710158845294, 0.940195067977843],
            [20.43365312211295, 0.939780463886954],
            [20.43285515942588, 0.933980001779806],
            [20.432333538283093, 0.933614483132104],
            [20.427866279257255, 0.930484112342915],
            [20.420898478789653, 0.918694042243473],
            [20.419344109480509, 0.91688623562209],
            [20.414123278915639, 0.91081415022595],
            [20.405155319280819, 0.893258143137037],
            [20.403974159548032, 0.873478046763857],
            [20.400005159179376, 0.858499094853432],
            [20.402078078291328, 0.849554644245195],
            [20.405958478721864, 0.832811022280136],
            [20.405647439749664, 0.769138242677611],
            [20.409877439335943, 0.732404080996993],
            [20.420143199553269, 0.70905898754],
            [20.421041398954731, 0.700969086326523],
            [20.425541398877744, 0.695041996984346],
            [20.42687087944709, 0.687048309133378],
            [20.428741079342156, 0.680352380340551],
            [20.430052559469864, 0.673448105366896],
            [20.42861687916929, 0.667430871868649],
            [20.427061318694061, 0.664109387110168],
            [20.419069319326649, 0.654052105477411],
            [20.412180718826114, 0.643832964200098],
            [20.400266351534732, 0.627705274297062],
            [20.371278958787919, 0.592748125030584],
            [20.358471598730493, 0.574264662534761],
            [20.356458838894788, 0.567267070320026],
            [20.356279199194155, 0.55974231094899],
            [20.357027279331831, 0.55243633554701],
            [20.360761198675494, 0.5444040417759],
            [20.362721746630267, 0.538383073751068],
            [20.363819398974243, 0.535012112242768],
            [20.363712565930765, 0.534531300112008],
            [20.363605199288006, 0.534048083330552],
            [20.358787318823602, 0.512215103737225],
            [20.354160340238568, 0.503171246963558],
            [20.352289319283322, 0.499514158470711],
            [20.348221319180443, 0.495339017692064],
            [20.343883805627684, 0.493027086986738],
            [20.34163619922726, 0.491829093683226],
            [20.339475043994838, 0.487972287944385],
            [20.338270199281247, 0.485822116954836],
            [20.333261519345459, 0.460728110011201],
            [20.32812995616699, 0.453288683666573],
            [20.320657199203492, 0.442455124953979],
            [20.316576015425472, 0.440722747934408],
            [20.311794359524917, 0.438693034417681],
            [20.307170374126379, 0.434986920800573],
            [20.302509216441379, 0.431250997272492],
            [20.300033159481071, 0.427551113610606],
            [20.30262515930016, 0.41907512523483],
            [20.297706478877746, 0.408458004148623],
            [20.301700319460643, 0.396548982283006],
            [20.295061258369618, 0.375118010047434],
            [20.302574226620195, 0.371961276893667],
            [20.30468345653426, 0.371075058000586],
            [20.311779239082039, 0.368846027865597],
            [20.339935198812597, 0.359468106408025],
            [20.353508107646729, 0.347881235484512],
            [20.35778615901588, 0.330003099513072],
            [20.361629027833821, 0.324526795147005],
            [20.36195027885416, 0.324068994470505],
            [20.362179838833427, 0.323922848017852],
            [20.365857220009769, 0.321581696463422],
            [20.3708902227302, 0.317463573863626],
            [20.372519878944981, 0.316129994107751],
            [20.374387322808747, 0.312801948951605],
            [20.376239684857214, 0.30950078199821],
            [20.377792512657372, 0.308737972969156],
            [20.378990159170552, 0.30815007542307],
            [20.379000964106808, 0.306643917957941],
            [20.379009986785523, 0.30538999253227],
            [20.391716865786851, 0.295764583287241],
            [20.391882430683594, 0.295639168829557],
            [20.392942691552182, 0.29520931152904],
            [20.398525199121806, 0.292946111904575],
            [20.410778159410089, 0.276063086842412],
            [20.414377875840181, 0.272018932692252],
            [20.42253827878066, 0.262851004614753],
            [20.425754755944265, 0.255974773264093],
            [20.426496478704685, 0.254389107552707],
            [20.430643319448457, 0.250293151732939],
            [20.447147223543848, 0.241950979308878],
            [20.457213912602661, 0.222999767605944],
            [20.468515318951479, 0.201724089394996],
            [20.49522047883692, 0.176019985023546],
            [20.506944238896374, 0.16648312920889],
            [20.51535023943887, 0.161698117532372],
            [20.517265439539798, 0.160608067283759],
            [20.524133582706369, 0.158259584517672],
            [20.530996199437332, 0.155912990702844],
            [20.548349279174182, 0.154238082943566],
            [20.553129716060909, 0.151264878610854],
            [20.563265159476604, 0.144961112800142],
            [20.571043462214327, 0.142506885244855],
            [20.574717479199904, 0.138119813096638],
            [20.576723399263042, 0.131699717644308],
            [20.576999158699071, 0.125933687869189],
            [20.576868839202479, 0.121274110575576],
            [20.576100959297644, 0.117275988717094],
            [20.573304119339216, 0.111046035061017],
            [20.570094719103444, 0.10570066586084],
            [20.564012519165445, 0.099227213203309],
            [20.55578759922129, 0.094292595207661],
            [20.546925479093257, 0.090019433326218],
            [20.537176679558979, 0.085296589096824],
            [20.526710038976148, 0.078350559379492],
            [20.518023239448837, 0.072525583098461],
            [20.507556598866007, 0.065579732189153],
            [20.498238719376879, 0.060637900466997],
            [20.490444719477882, 0.055484293092645],
            [20.484424439514111, 0.051229692375963],
            [20.475743759310561, 0.045626401096346],
            [20.471472719292223, 0.041383334982286],
            [20.465396638677916, 0.035131921275532],
            [20.463729838922749, 0.030240372978132],
            [20.464008490933995, 0.026202862972287],
            [20.464299719359207, 0.019373888209372],
            [20.464812719370222, 0.01427488960298],
            [20.46816755954546, 0.009194634882128],
            [20.472240238972656, 0.006337566237146],
            [20.483139238701757, 0.005300139599548],
            [20.494731239265203, 0.005598246908341],
            [20.504343599080869, 0.005439641303617],
            [20.515692238847336, 0.004848833910888],
            [20.527902718704144, 0.003819878499735],
            [20.537702638666286, 0.00255337416626],
            [20.546409238859049, 0.001279661102482],
            [20.562032210071052, -0.00156896528003],
            [20.566583998768532, -0.004133665767071],
            [20.576448359377558, -0.018710266408819],
            [20.57212763982907, -0.024728458709066],
            [20.566445040173857, -0.032530244285023],
            [20.554319160057261, -0.051910255450414],
            [20.548967400039707, -0.063483973032605],
            [20.527527239983357, -0.062684996552116],
            [20.508991200289898, -0.065856932101519],
            [20.492367479800212, -0.068700841120403],
            [20.483313250457108, -0.069859758093717],
            [20.47342139960374, -0.071125887955962],
            [20.464789855449595, -0.073250163329316],
            [20.457891360006197, -0.074947925666028],
            [20.455631279599711, -0.070574011380127],
            [20.452731526845735, -0.071224844891134],
            [20.45193336024106, -0.071403988587139],
            [20.450407187252047, -0.071746424201345],
            [20.447637480008481, -0.072367878372454],
            [20.444960892127273, -0.073725818772397],
            [20.436889319992002, -0.077820852587962],
            [20.424741662017976, -0.089694834724967],
            [20.413545479829931, -0.093308879497383],
            [20.39958215958006, -0.102876945122006],
            [20.393278008393239, -0.10537615694548],
            [20.387010239873767, -0.107860945707266],
            [20.380602239846827, -0.112188896328304],
            [20.374634160085893, -0.119273878564002],
            [20.346941159713435, -0.137261901781372],
            [20.345270039960088, -0.141578492275106],
            [20.343141359723472, -0.147360379023976],
            [20.340756719818014, -0.154474909307591],
            [20.338990560104222, -0.162916494512038],
            [20.338129799788859, -0.170242972788086],
            [20.337306480356251, -0.17623806725251],
            [20.336945039608402, -0.181342808935398],
            [20.336084280191372, -0.18866909991694],
            [20.335485599766901, -0.194441059808274],
            [20.335780080093471, -0.199541469624577],
            [20.336674319721126, -0.206634351769269],
            [20.338106399574031, -0.217938906955473],
            [20.338800840407789, -0.22436762401562],
            [20.339982000140576, -0.22901852420795],
            [20.340926280421147, -0.234336642944631],
            [20.343679335594317, -0.24240653322159],
            [20.338859880383193, -0.249039997092775],
            [20.331640080020563, -0.242710058566633],
            [20.330828609366538, -0.242008588028289],
            [20.330679959746575, -0.241880089139054],
            [20.326928901445587, -0.240595659074207],
            [20.325890159719631, -0.240239974636481],
            [20.322889112035888, -0.240897177682357],
            [20.321780778723191, -0.241139892899492],
            [20.315360160061488, -0.247070058518709],
            [20.310967329151868, -0.254289300525037],
            [20.310760079730979, -0.254629898040421],
            [20.304349920154117, -0.259419927142938],
            [20.294759879880004, -0.260279994352489],
            [20.288149919712581, -0.258409906108812],
            [20.283682091154851, -0.254526637262112],
            [20.272709879628408, -0.244989997406826],
            [20.268600120441221, -0.244519952099824],
            [20.264934269141587, -0.247148481987508],
            [20.257149960267874, -0.252730070871769],
            [20.253470040452566, -0.258679893786896],
            [20.252829082615865, -0.26071950427112],
            [20.250449999688755, -0.268290045913638],
            [20.247327825867046, -0.27214880499576],
            [20.246550120189625, -0.273109987693178],
            [20.244556292348513, -0.274294141828799],
            [20.24426087328251, -0.274469593799122],
            [20.235779999957703, -0.273490097037125],
            [20.232161515924656, -0.272062289478497],
            [20.229900120384617, -0.271169971842019],
            [20.226729433944325, -0.267717574624442],
            [20.222939880138487, -0.250469958776753],
            [20.22402113104199, -0.246986699951666],
            [20.224789920041921, -0.244510039397474],
            [20.224434694737557, -0.243412502160734],
            [20.224119960096299, -0.242440070555048],
            [20.220764316827182, -0.24019504867412],
            [20.219919840273004, -0.239630068758768],
            [20.219770080335362, -0.232229906621891],
            [20.216156242388973, -0.226166619672218],
            [20.213499960026454, -0.221709914151987],
            [20.207280385223626, -0.220062586806743],
            [20.206439651050925, -0.219839622507664],
            [20.19759366107214, -0.210256499967275],
            [20.195999664380839, -0.208529434551855],
            [20.192159880377567, -0.201619914824549],
            [20.18970172863747, -0.191267227714889],
            [20.192259959886766, -0.181410035803496],
            [20.194836938975985, -0.176860550812496],
            [20.198570039954429, -0.170270007888298],
            [20.206770119684379, -0.155779978347594],
            [20.208054927034638, -0.147627329005504],
            [20.209119840278092, -0.140869995129155],
            [20.208240378835153, -0.134432844058919],
            [20.207271838652009, -0.133204516551636],
            [20.198949839571725, -0.122670018841011],
            [20.193950159856762, -0.119889916509068],
            [20.188699920246112, -0.119859997320012],
            [20.178410040263383, -0.124849943858309],
            [20.176049304527659, -0.125272389195519],
            [20.173380119662696, -0.125750029869079],
            [20.167479355157596, -0.124862122068397],
            [20.163809880054107, -0.124309964224484],
            [20.144220120125627, -0.117999987390472],
            [20.138739839936999, -0.118200046149263],
            [20.13298379671912, -0.120649550807749],
            [20.130210000344366, -0.121829950162873],
            [20.126200262275869, -0.123529725829323],
            [20.125940085016762, -0.123640017044538],
            [20.125823304029826, -0.123623860521949],
            [20.11727988011349, -0.122440040929219],
            [20.086459919695482, -0.125250062175914],
            [20.078700120455977, -0.127269938397324],
            [20.077692203520655, -0.128120311258865],
            [20.072750040238386, -0.132289981736048],
            [20.070200159728003, -0.138249941532772],
            [20.070629999998214, -0.142839946293802],
            [20.070730163050676, -0.142993980730633],
            [20.072880000408869, -0.146300066315778],
            [20.072893481426345, -0.146299092313043],
            [20.076582041238037, -0.146032504062054],
            [20.07882876998443, -0.145870123247622],
            [20.079682000621091, -0.143894362696201],
            [20.080210515435336, -0.142670521344503],
            [20.083159364712873, -0.145520464404836],
            [20.084979959637952, -0.147279995316657],
            [20.090440803877044, -0.149380949714399],
            [20.094069739808418, -0.153769749689366],
            [20.093942114359358, -0.154314925127025],
            [20.090789999689257, -0.167749988024968],
            [20.083259879904968, -0.171380063968156],
            [20.074579920150256, -0.172250048971095],
            [20.071014800536688, -0.170373854361656],
            [20.067528959043557, -0.168538779258133],
            [20.050059959804152, -0.149610051939349],
            [20.048104879894513, -0.149095248621937],
            [20.039349960220907, -0.146789940837174],
            [20.024960039924085, -0.150609986278793],
            [20.023223865076144, -0.150519380531022],
            [20.020169879672711, -0.150360002246097],
            [20.016167809623472, -0.147259628984209],
            [20.014490160016326, -0.145959965729315],
            [20.01133007998456, -0.139969909676547],
            [20.009792624155569, -0.134095111834919],
            [20.00729988009051, -0.124570040368322],
            [20.002550039822353, -0.116730061809629],
            [20.000000160210305, -0.114219948795856],
            [19.999610650703119, -0.113835963330236],
            [19.995749999734105, -0.110030057454148],
            [19.99195992041383, -0.108810056240484],
            [19.987779959683806, -0.10745992638937],
            [19.977279839788615, -0.107860044956891],
            [19.969750066754038, -0.107360070611354],
            [19.963609920090338, -0.104800038395851],
            [19.956701315905033, -0.104928646752183],
            [19.954479960073822, -0.10496999897622],
            [19.947200039960777, -0.101249976196347],
            [19.942179840029784, -0.101909991224495],
            [19.932099839735081, -0.109199902075973],
            [19.922742199913191, -0.109829839469093],
            [19.918199880357147, -0.107049895040202],
            [19.917770040086939, -0.100839943860953],
            [19.917698042811868, -0.099821093643569],
            [19.917560160398914, -0.097869873316643],
            [19.913065686013212, -0.097152784436427],
            [19.910040119712122, -0.09667005803167],
            [19.9060497942369, -0.094324383751154],
            [19.904124250933823, -0.093192471023299],
            [19.89704987973083, -0.093840027634606],
            [19.890680040137159, -0.09105000987744],
            [19.881878411662072, -0.092814659421847],
            [19.866240000206954, -0.095950024502902],
            [19.864541771094935, -0.097136532036195],
            [19.86395042002485, -0.097549693531904],
            [19.849661308669209, -0.122487402649105],
            [19.835769959643255, -0.120339959602809],
            [19.827299879576572, -0.125110019996727],
            [19.824530040280667, -0.131060068765447],
            [19.824762881805697, -0.132869608648705],
            [19.8251798402347, -0.136110030500633],
            [19.826799840458513, -0.137739881360017],
            [19.827447357793421, -0.138382698058173],
            [19.828190160328816, -0.139120108790451],
            [19.829821333798133, -0.138117571171288],
            [19.832990040351554, -0.136170047904891],
            [19.837339920112488, -0.137499990822539],
            [19.822960458900511, -0.166639342992869],
            [19.8318398401567, -0.169910082200459],
            [19.843199999918379, -0.177779961822519],
            [19.853930160391521, -0.177389937201028],
            [19.858470120073321, -0.18040000942058],
            [19.858900633181651, -0.184107219757214],
            [19.859010119848492, -0.185050021788016],
            [19.859296160502932, -0.18755549255631],
            [19.860209999573492, -0.195559945488945],
            [19.86383987963422, -0.199490103562633],
            [19.867891860080629, -0.199991327362652],
            [19.871600039996459, -0.200450023436297],
            [19.871861377878915, -0.200347157472098],
            [19.875030120364958, -0.19909989946524],
            [19.883829960294321, -0.186000029745526],
            [19.884505127773654, -0.185849632095206],
            [19.886031513663383, -0.185512042713987],
            [19.888319880221538, -0.18848003528054],
            [19.89162384610729, -0.200050516170649],
            [19.893020040061216, -0.204939983219449],
            [19.898030159996413, -0.205660013094943],
            [19.900060415420583, -0.204149709577214],
            [19.901699999815921, -0.202930026820048],
            [19.907709840457755, -0.189649927511982],
            [19.91180987987358, -0.190130068160616],
            [19.91189074980872, -0.1903891007408],
            [19.915400160399926, -0.201630007524577],
            [19.916390620374315, -0.203236760767316],
            [19.918100160174088, -0.206010025307291],
            [19.920055114319567, -0.214367833580714],
            [19.920790079952418, -0.217509953181142],
            [19.921158365862716, -0.218049614532966],
            [19.922079960089118, -0.219400053378339],
            [19.92581407167226, -0.224823713888003],
            [19.928710080248134, -0.229030058442888],
            [19.927530000290322, -0.236149961511322],
            [19.922700702238636, -0.242548923999171],
            [19.923776671946609, -0.244926007528396],
            [19.925409960050121, -0.248529939389199],
            [19.924229880092277, -0.255639919377425],
            [19.925359355255196, -0.257718936043152],
            [19.928194935060255, -0.257979360127064],
            [19.933340040341601, -0.258450098587157],
            [19.939250488685481, -0.261471021972759],
            [19.943520120145468, -0.27389994440609],
            [19.946715895633329, -0.274226229895735],
            [19.96017011995048, -0.275599891418778],
            [19.965839374233809, -0.2829889632087],
            [19.966375240860376, -0.283237243924571],
            [19.968345445704408, -0.284147783456041],
            [19.974359702464206, -0.276661139327377],
            [19.974770214582769, -0.276150127762895],
            [19.978409879991876, -0.278240107168149],
            [19.984269959797768, -0.288459966951199],
            [19.986379987415788, -0.292131424135578],
            [19.986999840233182, -0.293209970862484],
            [19.991090159877647, -0.297140099750676],
            [19.99227369475603, -0.297016257985886],
            [19.995198648847008, -0.296710200004372],
            [19.995184898334934, -0.29890200619566],
            [19.995170040200144, -0.301070046350708],
            [20.000000160210305, -0.304210037899006],
            [20.01085565273355, -0.311261177932307],
            [20.01259785527705, -0.311624263275925],
            [20.016560159603614, -0.312450033348331],
            [20.025720000281414, -0.306759951399032],
            [20.030739839987969, -0.306790050186721],
            [20.037634065738832, -0.311257307288834],
            [20.038240080009309, -0.311649986775741],
            [20.039401289956256, -0.311622440998723],
            [20.040770159854198, -0.311589970099308],
            [20.043950039653119, -0.31123004819166],
            [20.049680160186856, -0.306670015873519],
            [20.051029997478864, -0.306901582644722],
            [20.052420119719773, -0.307140059597432],
            [20.054220119868656, -0.311969897251186],
            [20.054840040059698, -0.325299972328508],
            [20.061332211330441, -0.330232870609906],
            [20.067329067723158, -0.334789415049267],
            [20.066345710727717, -0.337333712931375],
            [20.064849839709861, -0.341199938612474],
            [20.064355815710936, -0.342486485895145],
            [20.064320714041219, -0.3425778988108],
            [20.069448326429054, -0.349272608057159],
            [20.070088025726058, -0.350107422999696],
            [20.071016301621501, -0.359002265925758],
            [20.071510931983269, -0.363740843091494],
            [20.07575339030419, -0.366602546544775],
            [20.086289999766244, -0.373709898352287],
            [20.108788955538955, -0.392439057256169],
            [20.11143996029919, -0.409449985942585],
            [20.10712848351664, -0.416201489002029],
            [20.105449920322812, -0.418830013381081],
            [20.099870237056464, -0.438778771523002],
            [20.096010000210811, -0.442250025577425],
            [20.094440787139895, -0.443659810790066],
            [20.092759919767381, -0.445169907133969],
            [20.095210074704816, -0.454174678950299],
            [20.096240039890429, -0.457959986691093],
            [20.094069959895645, -0.466699964477543],
            [20.095412491189457, -0.472731130258427],
            [20.097362024900516, -0.481481361690489],
            [20.100999960154379, -0.483789872601261],
            [20.109470040221069, -0.479710062571402],
            [20.110738544047237, -0.481066528676862],
            [20.114229959586723, -0.484800047485191],
            [20.120162157940221, -0.487818192664828],
            [20.12106996033209, -0.488280057976487],
            [20.12116649688577, -0.48994394051073],
            [20.12126999807785, -0.491727860534212],
            [20.120069535346229, -0.494268232243112],
            [20.119430160341082, -0.495619991928341],
            [20.120929738706128, -0.500789358823981],
            [20.120519879662787, -0.505959974090679],
            [20.123460000010699, -0.509879906071188],
            [20.129829839604337, -0.515200017302048],
            [20.141439839711158, -0.521240127533981],
            [20.146430159879198, -0.526319986386637],
            [20.150409959794196, -0.527289964302118],
            [20.155460040386512, -0.528530100854976],
            [20.15345035548404, -0.537159202664466],
            [20.154931027905604, -0.542366756598855],
            [20.155019973695147, -0.542679487826187],
            [20.155688027415732, -0.543203587691925],
            [20.162980329906663, -0.548921259331487],
            [20.163880079800283, -0.550999938732506],
            [20.161109645819668, -0.553419057534516],
            [20.156310915640482, -0.557612892017604],
            [20.156483080459633, -0.558144774087322],
            [20.157429959566304, -0.561070030096289],
            [20.163991749373267, -0.567621761774662],
            [20.170379879564411, -0.574000091853088],
            [20.173434253040021, -0.575872895745152],
            [20.174929282336464, -0.576789580050164],
            [20.174447574240077, -0.58327350013429],
            [20.173700159754016, -0.593319975643986],
            [20.175959879936062, -0.597469995955362],
            [20.179879047162675, -0.599661568965034],
            [20.1805182443014, -0.600019002958361],
            [20.183710926889752, -0.599578756830427],
            [20.188280696265934, -0.593419991663881],
            [20.191015414129186, -0.593375663690163],
            [20.191360298926327, -0.593370285697147],
            [20.195600039843566, -0.595969991703187],
            [20.202319803783098, -0.597535694777463],
            [20.203840080230599, -0.597889918576735],
            [20.203961043773486, -0.598005528599067],
            [20.205650160375246, -0.599619887984833],
            [20.216186356612237, -0.609641079282227],
            [20.218119840124121, -0.611480053111116],
            [20.220309334508844, -0.61076347295057],
            [20.22086987965287, -0.610580016788014],
            [20.224559724055442, -0.603020313731614],
            [20.226380573203727, -0.602800700830533],
            [20.232290833799713, -0.611238757741782],
            [20.234189880395171, -0.613950016142875],
            [20.23988074814427, -0.617010801373813],
            [20.246699880127267, -0.624439913054486],
            [20.249499960308892, -0.635319970044853],
            [20.251513976887704, -0.637108928095793],
            [20.254960079607564, -0.640169941960802],
            [20.255600040314288, -0.648218431412536],
            [20.260149840141725, -0.650309973500066],
            [20.265532320745354, -0.650449452532683],
            [20.271340079974134, -0.650599951487779],
            [20.280880079595335, -0.660300040083602],
            [20.28381932318754, -0.665600312105404],
            [20.279613598775196, -0.668136799413608],
            [20.277004319861572, -0.669767444010475],
            [20.275225560377624, -0.672628639323048],
            [20.273893920258317, -0.678151880544642],
            [20.272568759687147, -0.684084757040828],
            [20.272649759878025, -0.689202488197671],
            [20.272428360194759, -0.693821904366159],
            [20.26649628041887, -0.70547891585819],
            [20.265564013308587, -0.713425341257513],
            [20.264826240440438, -0.719713939410415],
            [20.25721796453151, -0.747557171187848],
            [20.254358159858196, -0.758022862792396],
            [20.250727709367279, -0.762921289160817],
            [20.244013199673837, -0.771980901956742],
            [20.225439359771517, -0.787730969396906],
            [20.223366480185433, -0.791165898165961],
            [20.220865200328554, -0.80421391566787],
            [20.220550199785951, -0.805854961435492],
            [20.219314287736609, -0.807934768748182],
            [20.217556440134125, -0.810892893672092],
            [20.201038199825121, -0.826194976250714],
            [20.195443055654394, -0.834405531368261],
            [20.19183527953955, -0.839699726438325],
            [20.194528320065199, -0.848674926307083],
            [20.190366359776846, -0.858761846686044],
            [20.190864684011043, -0.860694819904511],
            [20.192383439610758, -0.866585984866637],
            [20.191926037231038, -0.871761115918471],
            [20.191896359588995, -0.8720968960306],
            [20.18728439993717, -0.880802966611405],
            [20.177077721916074, -0.891990895718981],
            [20.166845399688537, -0.90320690004788],
            [20.163635279902223, -0.912416944938578],
            [20.159891279664432, -0.923157852453954],
            [20.153913480132136, -0.931166927593402],
            [20.137397400271354, -0.945090992817438],
            [20.136230280308137, -0.950139006226045],
            [20.136633906840043, -0.953678329054163],
            [20.137541400211411, -0.961635950518683],
            [20.134975320381503, -0.971733002809878],
            [20.134939321294823, -0.978625943384106],
            [20.137634279723571, -0.987373912173283],
            [20.142154788184556, -0.994893953335235],
            [20.144426400264312, -0.998672861302215],
            [20.159424181767836, -1.013234757880777],
            [20.161909187745032, -1.018534245860279],
            [20.156614200355136, -1.026547937738735],
            [20.148817167743736, -1.032707934949726],
            [20.134624319853923, -1.039061864145576],
            [20.122610236871068, -1.04261543648226],
            [20.118612239783335, -1.043797979455783],
            [20.115059760364115, -1.046075482522956],
            [20.111507280046574, -1.04835298391493],
            [20.11000592211898, -1.04995689281212],
            [20.102091479699936, -1.058411920051736],
            [20.098888199686158, -1.05931293392412],
            [20.092231439987419, -1.06548000651146],
            [20.080806503608905, -1.066563019637274],
            [20.070268199924261, -1.072477977741574],
            [20.063469094083889, -1.07401575733486],
            [20.061350280044056, -1.07449497693361],
            [20.055900999817599, -1.077464906479617],
            [20.055484440240541, -1.077691936681192],
            [20.049667200192232, -1.080861861777834],
            [20.012605199902822, -1.092138847814714],
            [20.00504843968044, -1.095771873512261],
            [20.000000160210305, -1.095505897092745],
            [19.985410440221226, -1.094737882316184],
            [19.979230695819805, -1.096386126718418],
            [19.971916200449776, -1.098337027118768],
            [19.957075200116176, -1.097100851953444],
            [19.953904340301008, -1.097408956780185],
            [19.948162319784689, -1.097966895091055],
            [19.94477079420988, -1.099609289320354],
            [19.935177479576584, -1.104254982054586],
            [19.928467439899997, -1.107503987056781],
            [19.922933226658365, -1.106982140733407],
            [19.91545523970326, -1.106277006022959],
            [19.910182621262251, -1.107227273438784],
            [19.909280447714, -1.107389869095105],
            [19.901493360351097, -1.111479914132435],
            [19.88220024029911, -1.130670926366788],
            [19.872316016142534, -1.135099216604886],
            [19.862964359998742, -1.139288901867515],
            [19.848016440383379, -1.157584870541295],
            [19.822151879923375, -1.156569281794257],
            [19.809786959906312, -1.156536486180985],
            [19.79621244039285, -1.156910033898466],
            [19.784253239982267, -1.156878318787518],
            [19.772097480102683, -1.157255651367525],
            [19.761161399715292, -1.15784074963819],
            [19.749462840094516, -1.161494415226384],
            [19.741618800440932, -1.165362869399696],
            [19.73355912020337, -1.168412147578205],
            [19.724815440250616, -1.171314922970311],
            [19.711343348442501, -1.170541893191436],
            [19.703621159867303, -1.162910938543631],
            [19.699623422392694, -1.160926333509925],
            [19.695648239818244, -1.158952923550164],
            [19.681961400351533, -1.155880930083599],
            [19.68453648040229, -1.144864937942397],
            [19.67982335966969, -1.13058695414439],
            [19.679615446393811, -1.12765563666403],
            [19.679399280295403, -1.124607964646909],
            [19.682324015197455, -1.115951844103235],
            [19.684513440411866, -1.109471948610868],
            [19.684417268574173, -1.106670391181733],
            [19.684316159595699, -1.103725014537353],
            [19.679841245127001, -1.09310544788409],
            [19.67868432014394, -1.090359904761389],
            [19.677743476817636, -1.086321878252839],
            [19.673711279968703, -1.069015935192877],
            [19.671552359744691, -1.059749925493333],
            [19.671350334925521, -1.054757404952017],
            [19.671152400135803, -1.049865971219634],
            [19.673288280369427, -1.035860900005976],
            [19.676231697534416, -1.030163623489053],
            [19.68760836024617, -1.008142863644162],
            [19.688043437694461, -1.001200740004901],
            [19.688616047212765, -0.99206261035184],
            [19.684704960332148, -0.988556068724145],
            [19.682858159753579, -0.987118198575876],
            [19.678572000190695, -0.985264589976854],
            [19.671850799845036, -0.983199778277029],
            [19.665537839778544, -0.981340761953866],
            [19.659639959763787, -0.980096971935452],
            [19.652107680429573, -0.978030174012484],
            [19.641145680052968, -0.976977582605008],
            [19.632213720403165, -0.976135113725376],
            [19.621663559855094, -0.975493214273682],
            [19.616393160252819, -0.97547915791491],
            [19.610920440285661, -0.975464741669875],
            [19.605257640397639, -0.976268466901246],
            [19.601684489845415, -0.977960875176301],
            [19.609697160345839, -1.013860965188893],
            [19.610719920144561, -1.033859912703794],
            [19.607730120266506, -1.036830038012383],
            [19.606804860015451, -1.039839922603965],
            [19.60611012004269, -1.042099920202702],
            [19.607240160245919, -1.045560010220775],
            [19.612016248388361, -1.046737137622585],
            [19.607017319664973, -1.081407872192506],
            [19.609012440181768, -1.091533012763148],
            [19.6095784291164, -1.093106999495924],
            [19.615307399806589, -1.109038929223192],
            [19.61058419997649, -1.13520885863753],
            [19.612497229747664, -1.159582943929909],
            [19.610374320288464, -1.171060846235626],
            [19.608896961751991, -1.171778474182293],
            [19.60600139963881, -1.173184993856099],
            [19.598692320211615, -1.176733945583599],
            [19.589515200439347, -1.183340983678177],
            [19.584274284443044, -1.187594627266824],
            [19.556921159861673, -1.209794922512571],
            [19.545173280036856, -1.226268858008569],
            [19.54366987484871, -1.226959868208808],
            [19.538759159787926, -1.229216979894819],
            [19.533916440007577, -1.236770975223039],
            [19.524271320430163, -1.245212928472418],
            [19.514377440282548, -1.257101891743819],
            [19.511100720299364, -1.264441921136116],
            [19.509543719824755, -1.268531858974721],
            [19.507604039734058, -1.274053570577559],
            [19.504297079763443, -1.28284694907476],
            [19.49838120020538, -1.293270993587815],
            [19.494459719816913, -1.301653298719355],
            [19.489325399708818, -1.310237203812619],
            [19.483612199841772, -1.320661854162055],
            [19.477947240403797, -1.334156985533965],
            [19.472433480004575, -1.344377385840935],
            [19.467926640308963, -1.354191069855998],
            [19.464574319908117, -1.360118540973803],
            [19.458867599589201, -1.370952529462818],
            [19.45395539961325, -1.38076520327411],
            [19.448670239792534, -1.392623779917572],
            [19.446318719873297, -1.397735121132967],
            [19.442168639804592, -1.404479233928362],
            [19.438803360307446, -1.409587845694067],
            [19.435676759588009, -1.416948673633689],
            [19.43336735987581, -1.424721184275884],
            [19.427153400441838, -1.422807337955976],
            [19.415656439838809, -1.394148282526591],
            [19.391849351959475, -1.344112126879164],
            [19.38196733676013, -1.305905508457884],
            [19.377437040255842, -1.288389531335183],
            [19.360739160246204, -1.24221184928633],
            [19.350349560080449, -1.213536812936661],
            [19.337010119795391, -1.186020662115281],
            [19.327359959770899, -1.158084015368973],
            [19.3202960395679, -1.131611381634542],
            [19.311384600134158, -1.104039102661867],
            [19.304338320148435, -1.086544148953462],
            [19.302882836487413, -1.082486323305067],
            [19.300998600416037, -1.077233142734589],
            [19.294706159667282, -1.067584769410984],
            [19.288419479814408, -1.060929352301105],
            [19.281029400196402, -1.056158123736703],
            [19.271797560446906, -1.052906179558915],
            [19.240059599961953, -1.051805498659651],
            [19.216811520209173, -1.052095265211582],
            [19.211637959892865, -1.048418758399526],
            [19.206825119875536, -1.040622429622167],
            [19.204203599619564, -1.021201441679688],
            [19.201558680047064, -0.990182975310092],
            [19.200772440374422, -0.965875166988882],
            [19.198880999814453, -0.942703401407787],
            [19.19737691999152, -0.928505587757877],
            [19.195118250838373, -0.915086810497127],
            [19.190294279796344, -0.892678041625038],
            [19.182877559740248, -0.874438220198605],
            [19.169914320421444, -0.850655657279912],
            [19.154727720231747, -0.822036874426257],
            [19.139917320109973, -0.797154670209594],
            [19.121790240246227, -0.774558369388346],
            [19.102933440012585, -0.75608659997449],
            [19.0903557603087, -0.74052960902734],
            [19.081644479893292, -0.736009001121285],
            [19.078581240045793, -0.750691949789517],
            [19.070340267207506, -0.769367024544792],
            [19.069080479734506, -0.772221852649098],
            [19.060558200363317, -0.78364996052337],
            [19.057649129384885, -0.785775771934527],
            [19.056198239708252, -0.786836013211322],
            [19.03629834181783, -0.792210925316814],
            [19.026665945978102, -0.800865976079967],
            [19.009657440221297, -0.816148880413257],
            [19.000000440424234, -0.819513860939775],
            [18.982226340076679, -0.822301880389509],
            [18.964452239729088, -0.825089897866002],
            [18.95990719558278, -0.825553695683309],
            [18.952358399823733, -0.82632400984652],
            [18.950309820564399, -0.8272569828516],
            [18.948261240406733, -0.82818995563441],
            [18.927788040396941, -0.826362937040673],
            [18.91375740039965, -0.822422535100435],
            [18.897510240202362, -0.817387140393486],
            [18.882376200439936, -0.815331062609803],
            [18.86982983960009, -0.815487489813492],
            [18.793000080147781, -0.821999930264718],
            [18.788182585958957, -0.831233459519253],
            [18.768999959585219, -0.867999936215212],
            [18.762999839613077, -0.889000097753316],
            [18.759061569711925, -0.901940451868662],
            [18.749000160052052, -0.934999988531307],
            [18.743000040079909, -1.01199998435617],
            [18.752000039925939, -1.023000067313532],
            [18.817999919620348, -1.037999922307666],
            [18.83736223061047, -1.061469460905048],
            [18.851000040028932, -1.078000081492504],
            [18.869000039720991, -1.132999989507056],
            [18.870999840460396, -1.166000043104138],
            [18.831212259970812, -1.183467814877648],
            [18.830000159564662, -1.183999956475349],
            [18.798000120087178, -1.143999990268592],
            [18.74499983992099, -1.118000068050842],
            [18.732999960201109, -1.143999990268592],
            [18.720000000448419, -1.182999874061594],
            [18.745999919953764, -1.218000009141289],
            [18.761142229606705, -1.236272913624794],
            [18.760358976832372, -1.236206656157524],
            [18.751083479858405, -1.235421881940292],
            [18.726322320061872, -1.2229470142999],
            [18.709398360146356, -1.220762901971757],
            [18.697294440245205, -1.221304019948621],
            [18.677223360292551, -1.226265975547825],
            [18.671098361919473, -1.229025911289957],
            [18.668342159947873, -1.230267859686322],
            [18.666395718238022, -1.231145590111704],
            [18.660141359769117, -1.233965933794167],
            [18.658457207257584, -1.233976677891068],
            [18.657627271732892, -1.233982001567105],
            [18.65453844067958, -1.234440797880346],
            [18.641422440151796, -1.236388969296664],
            [18.620432101592495, -1.247228094059884],
            [18.617973480033481, -1.248497985666755],
            [18.59836248033843, -1.253913968359706],
            [18.584434439624701, -1.255384860881972],
            [18.572132160030741, -1.260752899357923],
            [18.566189279810146, -1.260331976114683],
            [18.561704447042395, -1.258324054832762],
            [18.554043239701926, -1.254894023388946],
            [18.541248480312984, -1.254977991767414],
            [18.529632359984138, -1.260340985042956],
            [18.522323279658679, -1.260847859267509],
            [18.513387517440293, -1.256997990567198],
            [18.503957159894462, -1.247635953535113],
            [18.495231480383378, -1.241254854447144],
            [18.474603479988858, -1.231504876220225],
            [18.473394982725335, -1.230229574010697],
            [18.467241479909987, -1.223735896217905],
            [18.463890502490464, -1.218135382141347],
            [18.4635432003269, -1.217554933352229],
            [18.459071588065196, -1.213023340005998],
            [18.452272319629753, -1.206132853000542],
            [18.447587147282249, -1.196690033389646],
            [18.446020199762515, -1.193531892862963],
            [18.442912664886673, -1.191288603890753],
            [18.438444360221816, -1.18806298954445],
            [18.436490873923493, -1.187465485193582],
            [18.428142239795037, -1.184911923200506],
            [18.424097853706023, -1.184578386233826],
            [18.420370200111481, -1.184270969900994],
            [18.40597451981704, -1.180418759496944],
            [18.392920200311561, -1.172997410501785],
            [18.384643080164569, -1.164504774498768],
            [18.374882759736781, -1.155635682192107],
            [18.367071119620544, -1.152284020042841],
            [18.360024839634782, -1.150405104868896],
            [18.352178640431276, -1.145218124931172],
            [18.346532760311614, -1.139310705464165],
            [18.338262479937157, -1.131185032162071],
            [18.333368639728981, -1.12601621768228],
            [18.328516200177269, -1.123049965644557],
            [18.314799480049309, -1.119661504203234],
            [18.287804159835503, -1.116557753681507],
            [18.268245000118885, -1.116436299432314],
            [18.245336760224617, -1.114826038021387],
            [18.223501319883688, -1.111387110963734],
            [18.219212507595742, -1.110320653729429],
            [18.205335720260571, -1.106870044539136],
            [18.185755680103451, -1.105647388022693],
            [18.170659080325422, -1.107388839213242],
            [18.156197520283008, -1.103628786919153],
            [18.151942728093204, -1.103367510334109],
            [18.142898399981139, -1.102812120177495],
            [18.13699368019385, -1.102775359937764],
            [18.131526720224283, -1.106411795816639],
            [18.130905720258262, -1.112647246742232],
            [18.133197839977658, -1.136517997383182],
            [18.133835400385941, -1.150835595332814],
            [18.134007479865129, -1.160012118304574],
            [18.130133520355187, -1.169897502474133],
            [18.128891160198709, -1.182368290272956],
            [18.128093759856988, -1.198878973726681],
            [18.127458720121403, -1.204380290382981],
            [18.120222360214775, -1.2120424718763],
            [18.116908979086542, -1.214668065521562],
            [18.037136146523999, -1.277880968269618],
            [17.910386640220551, -1.376255990639534],
            [17.883522465953405, -1.379922842783952],
            [17.825071320034276, -1.391873510715244],
            [17.781340679826446, -1.401510601818202],
            [17.739428040209138, -1.409690908579422],
            [17.73208151989925, -1.411480261652759],
            [17.723696760021621, -1.416932818620687],
            [17.718555405206555, -1.42291975573655],
            [17.710248240006578, -1.427858792313489],
            [17.671322160044092, -1.437892480642813],
            [17.632758599706108, -1.447561267760465],
            [17.621031600321757, -1.451892146783183],
            [17.612660519989294, -1.4580788182157],
            [17.608245840255336, -1.458785283138451],
            [17.598260879921082, -1.457622435020771],
            [17.590880159849995, -1.457576490034593],
            [17.57768399995442, -1.462265356305923],
            [17.554312799803753, -1.475331209784345],
            [17.545872959724495, -1.477847510591728],
            [17.520408719996151, -1.477689498169625],
            [17.506426320427924, -1.479804370270709],
            [17.480755799662564, -1.504740717018342],
            [17.18831159992709, -1.72892222782679],
            [17.113553280061478, -1.786421869899897],
            [17.107648560274157, -1.786355036466095],
            [17.100932040151111, -1.778154448714163],
            [17.094288959997506, -1.77807914697687],
            [17.08768619982709, -1.78243579366741],
            [17.077459679818006, -1.794136751228717],
            [17.07015888016279, -1.802916788726284],
            [17.063529120228214, -1.804318664847747],
            [17.054605080125985, -1.796831890326823],
            [17.048680200347064, -1.794548921616528],
            [17.037608399791569, -1.794423360798152],
            [17.026536600134438, -1.794297800874988],
            [17.016907679876514, -1.790495849209513],
            [17.011660679590765, -1.781573436272871],
            [17.002722959943405, -1.772609365273108],
            [16.993838879599931, -1.769554257927804],
            [16.983491759865615, -1.767959777388262],
            [16.97093063970566, -1.766340254681019],
            [16.95761136031053, -1.762496270379973],
            [16.94060784020358, -1.759349090102214],
            [16.921396800117417, -1.756915471034316],
            [16.904826359605579, -1.760789731711179],
            [16.893808200150666, -1.766573365687942],
            [16.884625320380774, -1.771269976000629],
            [16.884008851517045, -1.77157281565125],
            [16.872134399966992, -1.777406121686611],
            [16.858150200174954, -1.781679001322082],
            [16.846343999925274, -1.781914451539254],
            [16.836544252439676, -1.780247765256978],
            [16.823721240136724, -1.769471389921105],
            [16.818883199680716, -1.764985007616],
            [16.814461319949757, -1.765673530010005],
            [16.811166600423228, -1.768590471366449],
            [16.806070079625666, -1.776287593846101],
            [16.800960240405704, -1.782507491271345],
            [16.795139039685324, -1.791673634808833],
            [16.793376358248292, -1.795376947389865],
            [16.790069160224149, -1.802325197439392],
            [16.788683519678191, -1.812280085346365],
            [16.788763800318495, -1.821143619073981],
            [16.790323679893604, -1.830393150683806],
            [16.794067680131391, -1.836343910740796],
            [16.799241240447699, -1.837141210776687],
            [16.804760399721808, -1.83535746309539],
            [16.809145559917212, -1.83060661794103],
            [16.815372480244108, -1.825507366401053],
            [16.822716840105738, -1.821528581993404],
            [16.827883559751182, -1.821587307885649],
            [16.833087360054879, -1.82570822387894],
            [16.837928639835816, -1.83056374407283],
            [16.842430800207083, -1.838738872171409],
            [16.846914239687838, -1.84596985357097],
            [16.849200788954168, -1.845631180777615],
            [16.851713400160033, -1.845259024965223],
            [16.852959765006037, -1.845594523354492],
            [16.854246360003717, -1.845940851232219],
            [16.866821159708842, -1.849329986304401],
            [16.878971159590801, -1.855714995448043],
            [16.881949047808213, -1.856315837366165],
            [16.887897360141316, -1.857516015608176],
            [16.911293989801049, -1.855854828852122],
            [16.912124308906371, -1.855795888073092],
            [16.925180399889559, -1.86079596499174],
            [16.942682520013516, -1.866093805641823],
            [16.945014959716101, -2.001266349512168],
            [16.755321620755247, -1.999404244875129],
            [16.733478975925731, -1.999189829134349],
            [16.63702415994079, -1.998242989454377],
            [16.634223385361441, -1.998235967737611],
            [16.629193574355234, -1.997472165830896],
            [16.626453480074986, -1.997055979055058],
            [16.623749160302648, -1.996646019444357],
            [16.621284608066166, -1.995135325939277],
            [16.616520359719164, -1.992214985809926],
            [16.611826227575047, -1.989336841463486],
            [16.592499359614468, -1.962968962632747],
            [16.584948963955892, -1.949286505158932],
            [16.583509439764239, -1.946677856140687],
            [16.57980720040738, -1.936803810753017],
            [16.579731239765284, -1.919784988294945],
            [16.574232213533325, -1.911177348449758],
            [16.570060200198618, -1.904646854839675],
            [16.568193239628492, -1.895685932894748],
            [16.566295320418689, -1.892693004007966],
            [16.565429160330176, -1.891327945419894],
            [16.562679661587246, -1.889729593026042],
            [16.558990104645577, -1.881920598498963],
            [16.55850006736987, -1.874568709020923],
            [16.56026972153014, -1.862831924065912],
            [16.550580453349742, -1.864753509587964],
            [16.503999839631064, -1.874000004521388],
            [16.538000040072426, -1.82899994179958],
            [16.540129177551499, -1.825197951780356],
            [16.544763489084207, -1.81692245625901],
            [16.552000079857851, -1.803999991364952],
            [16.553999879698967, -1.801000060488425],
            [16.586297601098675, -1.749324197686834],
            [16.589000160173068, -1.745000077709303],
            [16.611939066754516, -1.700004421152397],
            [16.61500007967841, -1.69400003021766],
            [16.647343517241239, -1.630292835594852],
            [16.64799983986256, -1.62900004951713],
            [16.656000119900249, -1.614000040169137],
            [16.659313205482771, -1.607072553433653],
            [16.66699991958739, -1.590999951846224],
            [16.671999960425122, -1.582000042429323],
            [16.690759238653204, -1.543092586585316],
            [16.704407712870712, -1.514784676588818],
            [16.71434861982344, -1.494166290853424],
            [16.723912756278018, -1.474329176618355],
            [16.725999960399616, -1.470000052828464],
            [16.72700004043239, -1.467999941909601],
            [16.735977478191753, -1.445556487872696],
            [16.74100008021782, -1.432999963838167],
            [16.742201724234054, -1.431197512122954],
            [16.745000040124445, -1.427000067897841],
            [16.760999879750987, -1.398999982025151],
            [16.773420941778383, -1.374157975845107],
            [16.776190406476797, -1.368619036837427],
            [16.782999840247996, -1.355000091282522],
            [16.796000160225088, -1.330999971871611],
            [16.81599995975829, -1.301000121320585],
            [16.819287679612103, -1.296957553057569],
            [16.822103807297978, -1.293494847711122],
            [16.825048155117624, -1.289860649869764],
            [16.831825677136667, -1.281495162111185],
            [16.83335507867082, -1.279607419630548],
            [16.845999840068554, -1.263999916514969],
            [16.856999999980129, -1.253999919570999],
            [16.879473533430314, -1.233324200190016],
            [16.881999840350996, -1.230999979092799],
            [16.886323353660057, -1.226100078533771],
            [16.896999960169197, -1.214000088405238],
            [16.928472560115857, -1.187296025149127],
            [16.930000079679488, -1.185999939371109],
            [16.940402394599797, -1.178718300584526],
            [16.949999880110951, -1.172000026673453],
            [16.950999960143726, -1.170999940801062],
            [16.973787756619629, -1.153470815734198],
            [16.976999879649068, -1.150999935402008],
            [16.982798296398901, -1.147431732440293],
            [16.989999840300055, -1.143000073418179],
            [17.02299995981031, -1.130999968698116],
            [17.040999960400693, -1.123000050550056],
            [17.043434144190705, -1.121214986777075],
            [17.049578855194355, -1.116708870056272],
            [17.056000080218901, -1.111999969342025],
            [17.057702356241272, -1.111148808008561],
            [17.060000040125527, -1.109999933990597],
            [17.062562744086602, -1.108901619551251],
            [17.06484921160623, -1.107921694076424],
            [17.066999879906039, -1.106999967909618],
            [17.069457136025793, -1.10489377345364],
            [17.070759396743725, -1.103777562991288],
            [17.073100895057642, -1.101770585901564],
            [17.088000119696382, -1.088999928994421],
            [17.111000160226169, -1.073999962621294],
            [17.129999879726562, -1.064000004411442],
            [17.164000080167924, -1.051999938346696],
            [17.169999839915661, -1.050999990325677],
            [17.18300015989275, -1.047999965282404],
            [17.209000080296388, -1.047000016869668],
            [17.215999920076904, -1.049000094214875],
            [17.237000159867282, -1.047000016869668],
            [17.255000160457666, -1.040999956120835],
            [17.286999839710713, -1.020000015416212],
            [17.295000119748437, -1.014000083972435],
            [17.29882331546164, -1.012670272940138],
            [17.304094868500719, -1.010836682254816],
            [17.318000160278189, -1.006000036996694],
            [17.330000039998101, -0.998999934935562],
            [17.340999839685242, -0.990000065322043],
            [17.366088121890808, -0.962698264629704],
            [17.374423320815875, -0.953627607377788],
            [17.375000040126604, -0.953000000605307],
            [17.384000039972634, -0.94300002554466],
            [17.385000120005408, -0.942000044878937],
            [17.393000039818659, -0.936999954536477],
            [17.429000040101098, -0.90300001721021],
            [17.457000119671989, -0.875999943119361],
            [17.466000120416314, -0.864999929648341],
            [17.467999920257427, -0.863999926322031],
            [17.469000000290201, -0.861000096501421],
            [17.474000040229601, -0.856000074605617],
            [17.486999999982253, -0.842999986130304],
            [17.493000119954431, -0.838999949887958],
            [17.493999839762768, -0.835000089451445],
            [17.530999920077981, -0.791999940073181],
            [17.534000160176269, -0.788000033327894],
            [17.543166601674773, -0.771499904816932],
            [17.543999879830636, -0.769999952047047],
            [17.552999879676662, -0.760000033856563],
            [17.555000039742215, -0.757999975230841],
            [17.560000079681615, -0.751999973701048],
            [17.560267901603787, -0.749095323683537],
            [17.56210320015342, -0.729190594813732],
            [17.584909919640811, -0.687577797844579],
            [17.63300016027927, -0.662999942245709],
            [17.637999839994233, -0.655999944919709],
            [17.655000119877982, -0.62500004666983],
            [17.673000119570037, -0.604999931248634],
            [17.683999920155507, -0.595000025327801],
            [17.70000012000645, -0.568000045223437],
            [17.703058796412293, -0.559102378366446],
            [17.709999839660817, -0.540999937292313],
            [17.718152314070583, -0.506578382795913],
            [17.718999840405175, -0.502999928093815],
            [17.719222907361587, -0.501488038554506],
            [17.722929075051187, -0.476368565062559],
            [17.72602237701965, -0.455402875683593],
            [17.727999840251201, -0.442000048213207],
            [17.73000000031675, -0.435999878112133],
            [17.740000080195554, -0.398000010473852],
            [17.74199988003663, -0.381000021449533],
            [17.740000080195554, -0.332999978096764],
            [17.73699984009723, -0.318999994908767],
            [17.736000120288892, -0.311999996023939],
            [17.73500004025615, -0.307000019117667],
            [17.722000079605166, -0.275000079901661],
            [17.714999879600217, -0.233000039531665],
            [17.71400015979188, -0.217000075193319],
            [17.715999959632992, -0.199000050450674],
            [17.714999879600217, -0.189000007791675],
            [17.711999999726363, -0.156999977210217],
            [17.71400015979188, -0.128000064788812],
            [17.72499996037735, -0.095000011930624],
            [17.739000000162779, -0.068000092745166],
            [17.74699991997603, -0.054000067915808],
            [17.77100003964026, 0.0],
            [17.762075372513959, 0.01235724472411],
            [17.761790288565294, 0.012751977572487],
            [17.758000079887605, 0.017999964711813],
            [17.763999839635346, 0.040999977383223],
            [17.764999919668117, 0.051000074867058],
            [17.764999919668117, 0.052000012274872],
            [17.768000159766409, 0.080000058977466],
            [17.77484774768266, 0.107391061489455],
            [17.775000000445218, 0.108000086318624],
            [17.779653860216829, 0.121573948167119],
            [17.786999880165133, 0.142999992959927],
            [17.799999839917785, 0.172999999336734],
            [17.80026351970821, 0.173527329309153],
            [17.801999999983334, 0.177000092539825],
            [17.813000159894877, 0.196000074187187],
            [17.821000079708163, 0.215999964642101],
            [17.828907891662091, 0.226064482798234],
            [17.843000040205176, 0.243999981518026],
            [17.844999840046285, 0.248999985456964],
            [17.854999919925088, 0.26000009401858],
            [17.872999919617147, 0.273000046569835],
            [17.894999880114156, 0.28800001595926],
            [17.922999959685011, 0.316000047261265],
            [17.925999840457195, 0.321999941670027],
            [17.942000040308173, 0.34199998279989],
            [17.953999920028085, 0.365000095712129],
            [17.953999920028085, 0.366000012911258],
            [17.960000040000224, 0.389000063541189],
            [17.960000040000224, 0.400000017836106],
            [17.962999919874111, 0.408000041416781],
            [17.960000040000224, 0.465999958973472],
            [17.957000160126373, 0.483000116125996],
            [17.955000000060828, 0.489999966836847],
            [17.952999839995311, 0.495000010440687],
            [17.943999840149285, 0.512000093171424],
            [17.937000000368773, 0.518000016162203],
            [17.904999959992956, 0.548999975606704],
            [17.901000000086331, 0.555000041997129],
            [17.885999880268127, 0.571999956740281],
            [17.877999960454876, 0.590000065460181],
            [17.876000159715431, 0.593999962098211],
            [17.872999919617147, 0.611999998447261],
            [17.873331187751216, 0.627899631369695],
            [17.873349516077962, 0.628779315830612],
            [17.873999999649918, 0.659999970580133],
            [17.880000119622061, 0.674999991265493],
            [17.880688800458231, 0.685009290389304],
            [17.883353326660107, 0.689032993746445],
            [17.884964880025318, 0.691466601455399],
            [17.889777996723787, 0.703854913033733],
            [17.89099992020753, 0.70699997353523],
            [17.885000159561461, 0.738999912264343],
            [17.894999880114156, 0.774999902247639],
            [17.886999960300905, 0.80299998034274],
            [17.886999960300905, 0.816000022030211],
            [17.885999880268127, 0.826999996324584],
            [17.883000000394244, 0.837999939726902],
            [17.879000039589318, 0.846000010128396],
            [17.867999879677743, 0.862000100626941],
            [17.861000039897231, 0.87099994127464],
            [17.844999840046285, 0.919000039186186],
            [17.844999840046285, 0.935999972130494],
            [17.849999879985688, 0.960000020095855],
            [17.852000040051202, 0.978000080135381],
            [17.853000120083976, 0.997000005947888],
            [17.849999879985688, 1.011999984356158],
            [17.853999839892314, 1.023000067313519],
            [17.859999959864492, 1.029999935911428],
            [17.861000039897231, 1.0449999382314],
            [17.863999919771118, 1.051999938346684],
            [17.880999840328727, 1.079000019732262],
            [17.883000000394244, 1.08399988857812],
            [17.91500003987176, 1.114999930278063],
            [17.929000079657186, 1.135000008916729],
            [17.930000159689961, 1.13999996178858],
            [17.942000040308173, 1.164000044793654],
            [17.943000120340944, 1.168999946095011],
            [17.94499992018206, 1.185999939371109],
            [17.944874654607236, 1.195011957409127],
            [17.944833599802124, 1.197965570441282],
            [17.944167360678406, 1.205443671046324],
            [17.942982480123707, 1.218743123842573],
            [17.939844719633495, 1.230247137284149],
            [17.927728560186594, 1.251049843760152],
            [17.961094235627005, 1.295734278415907],
            [17.966462739343129, 1.302923885520036],
            [17.970999839687366, 1.309000044648077],
            [17.97199991972014, 1.317999973690273],
            [17.975999879626766, 1.337999956148609],
            [17.987000040436673, 1.359999981244286],
            [18.000000000189328, 1.392999996181981],
            [18.002999880063179, 1.395999990591079],
            [18.007999920002582, 1.405999945097264],
            [18.008934247848142, 1.410359814583865],
            [18.011000160100902, 1.419999988139954],
            [18.012999959941979, 1.429000034675542],
            [18.019000079914157, 1.443999913064959],
            [18.022241435021247, 1.449834394633751],
            [18.024000119853557, 1.453000044613339],
            [18.029000159792957, 1.460999990110061],
            [18.038000159638987, 1.476999975149135],
            [18.045001924509144, 1.485274871707495],
            [18.047534481009269, 1.488267915521852],
            [18.058550829460568, 1.501287286171993],
            [18.060000120135996, 1.503000084373119],
            [18.065958309445655, 1.513923828106696],
            [18.065999879883737, 1.514000044004142],
            [18.066097199768354, 1.514340635599166],
            [18.068000039949286, 1.521000004916748],
            [18.066315499365572, 1.537001925073431],
            [18.065999879883737, 1.54000006496753],
            [18.071999999855912, 1.558000030591336],
            [18.072157407151579, 1.561462730958458],
            [18.072596830649225, 1.571129281587129],
            [18.073000079888686, 1.580000036987997],
            [18.071999999855912, 1.590000043726689],
            [18.075999959762537, 1.600000002274786],
            [18.078999839636424, 1.617000087202841],
            [18.077265776727721, 1.626248737233046],
            [18.075999959762537, 1.632999961222059],
            [18.078000119828086, 1.653999993582965],
            [18.080719802588419, 1.657324071714959],
            [18.087000119674112, 1.665000041230813],
            [18.087978518867509, 1.677722682318032],
            [18.08799984038075, 1.677999934634464],
            [18.083000159767487, 1.703999999550942],
            [18.079287502648256, 1.71637556174215],
            [18.0755152036824, 1.728949847184006],
            [18.074000159921425, 1.733999951296761],
            [18.073000079888686, 1.743000059727113],
            [18.072755689622369, 1.74369829959559],
            [18.068896743655777, 1.754723513436717],
            [18.065999879883737, 1.762999963281791],
            [18.065999879883737, 1.764999959599416],
            [18.065278943240688, 1.771849581353909],
            [18.064000080042657, 1.783999996323463],
            [18.062256627942592, 1.789811407463704],
            [18.057999960070486, 1.803999991364939],
            [18.057999960070486, 1.806713672132265],
            [18.057999960070486, 1.821000046164325],
            [18.060000120135996, 1.848999972544602],
            [18.068000039949286, 1.858000046605473],
            [18.068000039949286, 1.879999972985346],
            [18.074999879729763, 1.901999978123373],
            [18.078000119828086, 1.920999974247181],
            [18.080999999701941, 1.931000114809072],
            [18.080355070413372, 1.936738272884731],
            [18.078824880158404, 1.950352835254458],
            [18.08452656003027, 1.961826597639073],
            [18.091000079580738, 1.968000076103012],
            [18.086000039641341, 1.983999889296933],
            [18.096080039936012, 1.987270046279116],
            [18.097670160396873, 1.987980094798461],
            [18.102937656644126, 1.987580205951363],
            [18.165134356886458, 1.986740115847405],
            [18.200947539929157, 1.985708168921503],
            [18.294132227768447, 1.98302307550456],
            [18.318960234798524, 1.980692992632839],
            [18.368570838122768, 1.979000370109845],
            [18.409186439827202, 1.977614645500401],
            [18.465865321081829, 1.977125636178896],
            [18.465903016187799, 1.977125310802261],
            [18.472152960335436, 1.977071387764499],
            [18.513919439564432, 1.975409731055181],
            [18.541607040163708, 1.975552390760593],
            [18.565054560282608, 1.975471154085874],
            [18.580874760208516, 1.977526744132247],
            [18.590673600395679, 1.976993933668337],
            [18.593497896462424, 1.97601522398677],
            [18.598989429846593, 1.968337124715166],
            [18.601167239844404, 1.965292056039505],
            [18.602846262077314, 1.95863914049106],
            [18.602132609872896, 1.954326818840265],
            [18.601778172391022, 1.952185084023303],
            [18.603051299845983, 1.950819547594891],
            [18.604324439877338, 1.949453995581672],
            [18.614393280401234, 1.948652064191195],
            [18.616468337503584, 1.946447242109855],
            [18.622959480203313, 1.939550154238387],
            [18.627525455095757, 1.938923784511277],
            [18.629141110168547, 1.938702145491244],
            [18.634212360458825, 1.935081140117666],
            [18.642456359721301, 1.934027020272145],
            [18.645685200398155, 1.931534020161731],
            [18.649666427736179, 1.923528141739054],
            [18.653320440138696, 1.923801014052759],
            [18.663871320237305, 1.920703118602554],
            [18.667564200047206, 1.917755987000885],
            [18.668285280420726, 1.916598099866075],
            [18.672689127370685, 1.909533188945756],
            [18.686488493403111, 1.902330831385046],
            [18.687306979001196, 1.903434983619626],
            [18.689410079710068, 1.906279940437085],
            [18.690480706238734, 1.905947944557694],
            [18.695149920015201, 1.90450004666888],
            [18.697160918254632, 1.905724392241164],
            [18.699009839755544, 1.906850060514234],
            [18.70312204595356, 1.906898421648686],
            [18.708659999780039, 1.902819944870315],
            [18.713210040355964, 1.904709901100977],
            [18.714981916049922, 1.906791112442701],
            [18.719745311895714, 1.912381772670363],
            [18.725219022704636, 1.914289729428979],
            [18.731474280387168, 1.926781098536868],
            [18.733248052424695, 1.931754306166004],
            [18.735017400259423, 1.936715096466816],
            [18.735770827169691, 1.937000722611504],
            [18.737520480340152, 1.937664019665668],
            [18.73908035991526, 1.941133130344508],
            [18.739589649884124, 1.941548007144297],
            [18.753120000133368, 1.952570031108118],
            [18.755369999645726, 1.955819895334997],
            [18.75679625122903, 1.963612745537042],
            [18.75731003996086, 1.966420007970047],
            [18.762729479950206, 1.972235017950554],
            [18.767434093637057, 1.972515496102919],
            [18.772325280221906, 1.972807097597277],
            [18.778413315615985, 1.980238849171731],
            [18.778527962205814, 1.979906481189579],
            [18.780310079592315, 1.974740024735931],
            [18.78146236567526, 1.973854953668116],
            [18.782380080077935, 1.973150056246015],
            [18.792635400075032, 1.976261003675796],
            [18.797280578527758, 1.978236987594315],
            [18.79764014718652, 1.978389942503471],
            [18.800119451556604, 1.981869101323595],
            [18.802642860512218, 1.98088558712975],
            [18.805859999734182, 1.979630064272908],
            [18.808762197702357, 1.980695217842415],
            [18.810410040310078, 1.981300002030305],
            [18.814799879829831, 1.977210084057674],
            [18.816305504755036, 1.977115927302672],
            [18.817999919620348, 1.97700996479383],
            [18.821490119739224, 1.971990046583229],
            [18.821509288889054, 1.972021181605671],
            [18.824632003496582, 1.977089149711999],
            [18.831280303760323, 1.974410422247284],
            [18.833532876945963, 1.976940522190621],
            [18.833550120107816, 1.976959890234752],
            [18.842939999566969, 1.976830019762263],
            [18.846780120438453, 1.979639971071359],
            [18.849100816465349, 1.976680171150933],
            [18.8522899201656, 1.977410022532352],
            [18.852806452352301, 1.978854378309641],
            [18.85385987973654, 1.981800028589545],
            [18.856799240109702, 1.983669598155082],
            [18.860929920161528, 1.982110022998516],
            [18.86640874957094, 1.982859912373914],
            [18.871819919669807, 1.989590043100394],
            [18.880277759292408, 1.9899199462089],
            [18.882185952534112, 1.991211013654651],
            [18.886849920149295, 1.994369982472859],
            [18.890344349536541, 1.994405903669162],
            [18.894629880278725, 1.994449957385584],
            [18.897120000364833, 1.99655001370674],
            [18.897250376455272, 1.998044652380457],
            [18.897321231971631, 1.998856929061684],
            [18.902986200392782, 2.003293087214546],
            [18.906416279862949, 2.003331993495178],
            [18.911934360260378, 2.000634119494779],
            [18.91857132019199, 2.000019000183787],
            [18.922443480376383, 2.001443049874834],
            [18.929247480238441, 2.006352101177419],
            [18.939243240119037, 2.011987028279339],
            [18.941095439572425, 2.009937065557193],
            [18.946811160112155, 2.010002088948089],
            [18.950195293450516, 2.013952149273666],
            [18.95133711056712, 2.013931877867657],
            [18.958200119861846, 2.013810035224749],
            [18.964289880021287, 2.021470028701287],
            [18.971315279566547, 2.026844088904495],
            [18.979862116182691, 2.030221399654822],
            [18.989298360388567, 2.033950155494987],
            [18.991102296056702, 2.036270953578088],
            [18.9903211085092, 2.03809932755949],
            [18.988754451145294, 2.041766095828279],
            [18.993717360120737, 2.047804118676959],
            [19.004459399915191, 2.048154987542322],
            [19.009262834571508, 2.050719001649785],
            [19.011505319676512, 2.051916011434176],
            [19.022243399697196, 2.052727077696072],
            [19.024285564087087, 2.054750504604405],
            [19.028349360074454, 2.058777007487863],
            [19.029739425721512, 2.062999489208609],
            [19.030782240408975, 2.066167152149398],
            [19.034723128000834, 2.07109410256687],
            [19.03709621377509, 2.074060957859152],
            [19.041895401196765, 2.074345079334882],
            [19.044344794362832, 2.077417915032173],
            [19.049112360188179, 2.083399038981695],
            [19.057283279705647, 2.088782073787141],
            [19.060859160238017, 2.096185044183605],
            [19.064708380145031, 2.099679044871698],
            [19.073381400414164, 2.101156120082491],
            [19.081836113899566, 2.106965649492973],
            [19.094486399936319, 2.11565806116114],
            [19.098418680769456, 2.116736556340643],
            [19.099729518601706, 2.117096075652229],
            [19.110674159933769, 2.11997906119984],
            [19.117799803379931, 2.123050742310491],
            [19.125467376182499, 2.12635596043362],
            [19.31435927956937, 2.07755309328463],
            [19.325622956676259, 2.074382901159875],
            [19.449819679114345, 2.039426976931054],
            [19.472027251951609, 2.033176428851034],
            [19.511884587521344, 2.021958127160518],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Gemena",
        AREA: 51648,
        POPULATION: 2458000,
        DISTRICTS: [],
        OBJECTID: 23,
        NOM: "Sud-Ubangi",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [19.072905372365327, 4.775668450593295],
            [19.075088159928118, 4.7714081062367],
            [19.073765700591021, 4.766560118643055],
            [19.072443240355621, 4.761712095488416],
            [19.074359842726686, 4.761558046833298],
            [19.074968279753463, 4.761509142848643],
            [19.076820491783284, 4.763409857402229],
            [19.082452456999167, 4.769188997991399],
            [19.087324200448009, 4.764409017329494],
            [19.089409030322347, 4.765173654247088],
            [19.09509228035779, 4.767258052685857],
            [19.098537925835231, 4.766746773375552],
            [19.105201439966613, 4.765758013148277],
            [19.114143479612181, 4.766318013901967],
            [19.120010400088972, 4.754414043523189],
            [19.12171031983036, 4.745916134491275],
            [19.12428144010731, 4.741571048921754],
            [19.124588156386345, 4.734669092547589],
            [19.128470592399303, 4.733144077082562],
            [19.135416240411985, 4.730415986108484],
            [19.145057400215659, 4.729832068224115],
            [19.14779771997301, 4.732375334158846],
            [19.149826319802131, 4.734258052924637],
            [19.151792615178067, 4.734639265031038],
            [19.152343443245687, 4.734746020785305],
            [19.153160964053125, 4.726173962047977],
            [19.153900429347239, 4.718420261897036],
            [19.156941388280732, 4.717296003862333],
            [19.158737399909768, 4.71663207480432],
            [19.160871566157795, 4.713703720743255],
            [19.162231199577985, 4.711838120980504],
            [19.161844199963685, 4.705388053708927],
            [19.163475359958277, 4.703104022163018],
            [19.17958032043936, 4.69867801561954],
            [19.186218360145919, 4.699902126309834],
            [19.187088480008207, 4.698205075427873],
            [19.187860291839073, 4.696697935280836],
            [19.187279124071086, 4.694092837042082],
            [19.186985177343786, 4.692775206422904],
            [19.188264378308393, 4.691519940474678],
            [19.189537200336147, 4.690271021902703],
            [19.20556224040136, 4.692979003250374],
            [19.207294876785369, 4.695220317330154],
            [19.210766279656919, 4.699710854933262],
            [19.215658440015556, 4.692860094210332],
            [19.216869549579904, 4.692769192065436],
            [19.223692038567123, 4.692257116157719],
            [19.226027740052537, 4.68233116002239],
            [19.226339280284652, 4.681007115720641],
            [19.227566850578285, 4.680737268035103],
            [19.229328173762568, 4.68035008995111],
            [19.229172200178102, 4.683604399483968],
            [19.229030279837961, 4.686561990272256],
            [19.230163200039982, 4.687955146701272],
            [19.232074538283491, 4.687874906333359],
            [19.234523159796748, 4.687772110825736],
            [19.237989240150227, 4.685508138904772],
            [19.242342360134387, 4.686016114376116],
            [19.248168742337363, 4.68708447507403],
            [19.250353241190759, 4.68748503735408],
            [19.255352387306448, 4.691913116739888],
            [19.275781387509323, 4.690524836232988],
            [19.277593199605874, 4.685887144654423],
            [19.27837727972857, 4.683878053178103],
            [19.282543199790695, 4.680470037658393],
            [19.285351200418194, 4.675437109289265],
            [19.288337399848587, 4.675009059657536],
            [19.289653192787959, 4.676058745827032],
            [19.290384360343783, 4.676642040621084],
            [19.291479476743717, 4.681488134456722],
            [19.298316960409686, 4.684349116765119],
            [19.298340839426565, 4.68433785401528],
            [19.303984842965587, 4.68167577409772],
            [19.304092439577062, 4.681625024828659],
            [19.306236240256528, 4.674282111776193],
            [19.3120060474612, 4.671122264149136],
            [19.308613319940545, 4.666712069106714],
            [19.309260748342204, 4.666012712207726],
            [19.310934124663593, 4.664205114059679],
            [19.321012662500987, 4.661357265665155],
            [19.328190480098836, 4.659329119806987],
            [19.330164359950729, 4.646460099173003],
            [19.332088859411446, 4.64562632298413],
            [19.334312279571183, 4.644663040204203],
            [19.340401603149367, 4.645075073377122],
            [19.346460480127625, 4.645485045799504],
            [19.347920953930053, 4.644505047098982],
            [19.350849239872399, 4.64254012051255],
            [19.353906540957553, 4.635667892306698],
            [19.358057160015417, 4.633641138076504],
            [19.373642279814629, 4.634730097398577],
            [19.37993828687506, 4.625130114727452],
            [19.383272617614068, 4.626285529225785],
            [19.384737315294917, 4.626793104550375],
            [19.386194423109952, 4.629901437074389],
            [19.388099159634425, 4.633965023409921],
            [19.389101197096206, 4.634877762989638],
            [19.390648319695963, 4.636287007263309],
            [19.392189480177191, 4.637691043282511],
            [19.393648199569817, 4.651288097597554],
            [19.404592200403084, 4.657391084349586],
            [19.41525431978167, 4.668553079289148],
            [19.416320216680347, 4.670262100606359],
            [19.420891199680472, 4.677591003921705],
            [19.427067359803946, 4.67926798639385],
            [19.458511200186766, 4.677532984327262],
            [19.464640583236712, 4.674137015218037],
            [19.47073932026078, 4.670758009515975],
            [19.474949159855463, 4.663207149305312],
            [19.475031239821288, 4.655611119725634],
            [19.47330323964243, 4.65215608135451],
            [19.471561901278235, 4.648674077999441],
            [19.471212359614672, 4.647975128365036],
            [19.469707200016764, 4.638522039238592],
            [19.472164200116683, 4.623125107442224],
            [19.474043373283116, 4.619002064370435],
            [19.483062480295239, 4.611962024947027],
            [19.483772638053217, 4.610012876057963],
            [19.484482319704064, 4.608065026988687],
            [19.491407280414084, 4.603763987093453],
            [19.501772399691742, 4.599731131497983],
            [19.509115320452292, 4.599348127030678],
            [19.511802593793803, 4.597464825267827],
            [19.512350280452843, 4.597080992962467],
            [19.518646318954339, 4.587249953949613],
            [19.518645866203439, 4.587170403303977],
            [19.518566400335065, 4.573208095251426],
            [19.516546439604063, 4.569043019392799],
            [19.510172280012217, 4.564602149877647],
            [19.508646239973839, 4.556990139916649],
            [19.48934014285928, 4.517652071690315],
            [19.487665080400109, 4.508988587797375],
            [19.482220800196529, 4.496904328320985],
            [19.476806040429793, 4.482810381629164],
            [19.459556371155212, 4.45035023295039],
            [19.458636394794649, 4.44692687131532],
            [19.457571155462745, 4.442962786787677],
            [19.454225039725547, 4.43188557261708],
            [19.432721879919988, 4.384124241170842],
            [19.418860080076993, 4.35190268976165],
            [19.396324800027454, 4.297819590502369],
            [19.386357438587932, 4.272983426219571],
            [19.384665120390483, 4.2687665130183],
            [19.376230680084412, 4.24977754752353],
            [19.362414960222225, 4.214397603266607],
            [19.357027231660719, 4.197416208477095],
            [19.352340719925145, 4.192242876864936],
            [19.35124596015639, 4.190227930191232],
            [19.349362800266704, 4.184476762930894],
            [19.346384879709962, 4.176710750440338],
            [19.342601640162258, 4.166356785388147],
            [19.338630480243609, 4.160155160791795],
            [19.338469079936509, 4.160067580972134],
            [19.334301480024845, 4.157806148456509],
            [19.329470280239708, 4.141890990655829],
            [19.313863560449491, 4.104062383284566],
            [19.31103647960537, 4.095579198917016],
            [19.3076683201094, 4.085657944973879],
            [19.302537600449007, 4.081040544039531],
            [19.296516239811965, 4.079721204497508],
            [19.287681120346424, 4.078676373289789],
            [19.281785399881624, 4.078362672348178],
            [19.277711639781153, 4.078344335499811],
            [19.272375719757015, 4.078176609424927],
            [19.269180360189107, 4.075721645843678],
            [19.268232480359202, 4.073276741596682],
            [19.268318159874362, 4.070074085937303],
            [19.272947400417291, 4.065980097664424],
            [19.273430160440874, 4.063114130511797],
            [19.274418360254003, 4.057249132087446],
            [19.274112612358874, 4.05480297852721],
            [19.273784400293394, 4.052177089169519],
            [19.270021319838985, 4.039936133864297],
            [19.26593640266266, 4.036208011300698],
            [19.266424200438337, 4.033451077837153],
            [19.273123321990969, 4.028689093637945],
            [19.274767995342362, 4.028038067673203],
            [19.286705160079048, 4.023313129936015],
            [19.305019439864832, 4.004175091132306],
            [19.31097386613175, 4.004859532402191],
            [19.311657347519052, 4.004938096338723],
            [19.317177045782319, 4.003156152658804],
            [19.327007159917798, 4.005565031533368],
            [19.339568303433943, 3.996552691103437],
            [19.345024273414321, 3.992638123421022],
            [19.345439620265726, 3.992133464989123],
            [19.346311439740525, 3.991074003145089],
            [19.347906282644825, 3.989138514731143],
            [19.348970399980921, 3.987847107883439],
            [19.353798360441129, 3.986518085552587],
            [19.356692287620493, 3.98378669727013],
            [19.359586440276992, 3.981055085987166],
            [19.364040360219196, 3.971895107562486],
            [19.367981055571612, 3.967794379477716],
            [19.372300000049101, 3.964918114651149],
            [19.38090743970923, 3.959185998937105],
            [19.383951240013971, 3.953234121226826],
            [19.388525400355267, 3.932794990156024],
            [19.392702822446296, 3.92759478756736],
            [19.395492480373996, 3.92412210406257],
            [19.414880280161963, 3.911209072212377],
            [19.417440239769842, 3.907553016412824],
            [19.417730685762447, 3.901907549438081],
            [19.418020193015586, 3.896280139569416],
            [19.425779279891099, 3.899356005132942],
            [19.430477242451573, 3.909995187134796],
            [19.429754399583484, 3.913440134093547],
            [19.422817228073818, 3.919121218946543],
            [19.424604240380333, 3.923514000605692],
            [19.430988436848853, 3.926575170592591],
            [19.430736898687829, 3.927502604427859],
            [19.429556400115075, 3.931855154155866],
            [19.431572400174005, 3.936250093637925],
            [19.431095288756936, 3.938086068816426],
            [19.427535552746868, 3.938313126876873],
            [19.424902320256205, 3.938481087729439],
            [19.42367864056607, 3.939281476877857],
            [19.423309319796587, 3.939523043853507],
            [19.420747199740454, 3.941198081410496],
            [19.420482423107071, 3.94464825872052],
            [19.426164480179875, 3.949083081544876],
            [19.431669787432273, 3.949757426728752],
            [19.432344262310544, 3.949840021572709],
            [19.434194279756117, 3.948248987857832],
            [19.435507418173803, 3.94285524566579],
            [19.43587116040538, 3.94136116166207],
            [19.437968718508994, 3.944313111787619],
            [19.4419692003368, 3.94994306640801],
            [19.44293589987193, 3.950034590232354],
            [19.444715328600783, 3.950202864451525],
            [19.448543159620872, 3.935050087117521],
            [19.452224477214767, 3.933708228821078],
            [19.454500145188057, 3.935112804171466],
            [19.455641279585034, 3.935817127681506],
            [19.456232039563663, 3.941497505128786],
            [19.456264439999309, 3.941809048011287],
            [19.459796828597206, 3.943284766018],
            [19.469269440199042, 3.947242103943091],
            [19.469240429106947, 3.949989881180146],
            [19.469240279986593, 3.950004018537111],
            [19.460062415510933, 3.951057179670312],
            [19.459116360159367, 3.953810018011033],
            [19.460446380616201, 3.957967596194056],
            [19.461776400174742, 3.962125152323151],
            [19.458943256600747, 3.967395052403429],
            [19.457100360100434, 3.970822987146289],
            [19.458392806723875, 3.973295611734537],
            [19.458673237399374, 3.97383203631955],
            [19.46165436045013, 3.973634085696433],
            [19.46832236795456, 3.971633263084404],
            [19.469452938163808, 3.97314317440291],
            [19.470581279652858, 3.974650105775437],
            [19.470771480846263, 3.989021671065757],
            [19.470962159943426, 4.00342914995813],
            [19.468120319779167, 4.012146137860333],
            [19.468627422350334, 4.013192466948892],
            [19.468897199904887, 4.013749111428056],
            [19.469114968597722, 4.014198892054155],
            [19.469690280248397, 4.01538713999099],
            [19.474074419059338, 4.01488317957768],
            [19.475197199976751, 4.014754114998106],
            [19.477747284404707, 4.015728918864443],
            [19.479534318270787, 4.016412035942319],
            [19.48032043577253, 4.021482090591598],
            [19.480392360284068, 4.021946052616783],
            [19.481977440297847, 4.02380501844055],
            [19.490463360357918, 4.023204001560356],
            [19.493183763567121, 4.025607697422068],
            [19.498638239649193, 4.030427145824692],
            [19.498730530764856, 4.031265702460671],
            [19.499475240423592, 4.038032079943809],
            [19.499922550231123, 4.03865582479475],
            [19.502636400230301, 4.042440107271555],
            [19.504804600949527, 4.043384487061721],
            [19.506971160446717, 4.044328150381618],
            [19.509006239823975, 4.046882088228156],
            [19.509582239584127, 4.057477088548143],
            [19.511848440212638, 4.060033142071261],
            [19.514176196099356, 4.060578599022358],
            [19.515962160071894, 4.060997098486626],
            [19.520545449093127, 4.058841043559591],
            [19.522182319677967, 4.058070937089756],
            [19.523080815523471, 4.056582610090244],
            [19.528948440279414, 4.046863031693301],
            [19.531633102218404, 4.046386806710215],
            [19.532623319647676, 4.046211154496469],
            [19.533871491904041, 4.047201658807645],
            [19.537622279812098, 4.05017814205541],
            [19.540601281940443, 4.050209061774847],
            [19.543058087105926, 4.047515106816854],
            [19.54663127987898, 4.043596987493387],
            [19.548741679399534, 4.043222628025466],
            [19.550306160145539, 4.042945107633858],
            [19.551361716536999, 4.043848642994932],
            [19.5516682262035, 4.044111008903504],
            [19.551994894065004, 4.045723664779858],
            [19.552322160204472, 4.047339984374411],
            [19.549919171311039, 4.057904096180669],
            [19.551910320375935, 4.064601048008706],
            [19.560627359890635, 4.064002038209428],
            [19.561956417353485, 4.063220264898258],
            [19.568699279673918, 4.059253994399034],
            [19.575344160051372, 4.059554040127895],
            [19.581258240283951, 4.063760061911936],
            [19.58904828040918, 4.064072150315326],
            [19.593218075803417, 4.059972102626658],
            [19.59580214260027, 4.059799520440927],
            [19.596199150345132, 4.059773018529601],
            [19.599596279610665, 4.063722129159386],
            [19.604170185728748, 4.064691060503298],
            [19.609009199958539, 4.062210042347546],
            [19.613088359832194, 4.066626025835842],
            [19.623363479596485, 4.070417093503877],
            [19.624566669613287, 4.071592256600573],
            [19.628128440307481, 4.075071050630883],
            [19.630443428439055, 4.074909111434357],
            [19.634202686561949, 4.075616153583534],
            [19.637972279802177, 4.07632513992499],
            [19.640389520467597, 4.07497072163372],
            [19.642812479808139, 4.073613096032523],
            [19.647382382134992, 4.075042159691276],
            [19.648660563511726, 4.076145899640055],
            [19.65169942757398, 4.078770023954421],
            [19.651826319099413, 4.078761563642977],
            [19.654680239807611, 4.078571027554442],
            [19.65492416833985, 4.077235735657612],
            [19.655897400423743, 4.071908131467453],
            [19.657526386495324, 4.070389519399439],
            [19.660293360165486, 4.067810017594465],
            [19.661897166459696, 4.06782718471328],
            [19.661998439829869, 4.069350778337709],
            [19.662096239414836, 4.070822100230417],
            [19.663686359875697, 4.072220038065312],
            [19.664630569189359, 4.072103491546656],
            [19.667129400238785, 4.07179505421146],
            [19.673145360204348, 4.066332994504235],
            [19.67496606292724, 4.066352276089326],
            [19.67589539973309, 4.066362117590596],
            [19.677385439786423, 4.077427141643005],
            [19.681482239877315, 4.080232113979632],
            [19.686529439572507, 4.079824033368475],
            [19.695076199831828, 4.073467121096994],
            [19.695716212640818, 4.072445752237072],
            [19.69693919972989, 4.07049403632749],
            [19.698398280245286, 4.062452019116243],
            [19.699797779999461, 4.060598234357887],
            [19.703743199591916, 4.055372086950955],
            [19.710735462981305, 4.056851703085193],
            [19.715179319995723, 4.057792056121547],
            [19.716219359787249, 4.059101005032843],
            [19.718672621997282, 4.062191379480174],
            [19.720155337187776, 4.064059011737973],
            [19.724734804775792, 4.06331952733268],
            [19.728193320416278, 4.06276105273318],
            [19.730961337030468, 4.060948035880407],
            [19.738928160213728, 4.066325084318399],
            [19.739916645691132, 4.070044869172846],
            [19.740032280427737, 4.070480013839653],
            [19.749620160253599, 4.074262075058466],
            [19.751220198115149, 4.075902360176768],
            [19.754383319842454, 4.079145037836239],
            [19.758228962658027, 4.079547703806043],
            [19.761709319936308, 4.079912120973463],
            [19.763564635645427, 4.077359974104656],
            [19.765197464709829, 4.075114028923474],
            [19.771148336343163, 4.075865819869479],
            [19.775087279980774, 4.071762156218525],
            [19.776917340453995, 4.072126645517717],
            [19.778747400028887, 4.072491134649651],
            [19.783052279583988, 4.077369074886533],
            [19.787469526703052, 4.078660321337439],
            [19.788765480349362, 4.079039152738433],
            [19.79306244035692, 4.084838014088034],
            [19.807059854366763, 4.084982158492338],
            [19.807342379913528, 4.084985067575456],
            [19.808416439803199, 4.084996031886979],
            [19.813253399585896, 4.082743151779537],
            [19.815525360211993, 4.084838014088034],
            [19.820343197557278, 4.084427063747959],
            [19.824987239641146, 4.078490130932441],
            [19.828203403292729, 4.077832003171347],
            [19.830471302635416, 4.080156967173239],
            [19.843219263391337, 4.078752693801455],
            [19.847681279849184, 4.078261101645943],
            [19.850003282924821, 4.079185572260458],
            [19.853616239623893, 4.080624014377557],
            [19.857971159831909, 4.080668058587836],
            [19.859240365242311, 4.079703764315543],
            [19.863054360410409, 4.076806029548287],
            [19.869926399570392, 4.077106068652802],
            [19.876674122674817, 4.074261814365039],
            [19.880056439619644, 4.072836119379366],
            [19.893800183766324, 4.073666109756521],
            [19.897499160442059, 4.070480013839653],
            [19.900481220435658, 4.070280556213814],
            [19.903463280429222, 4.070081097635857],
            [19.905484328121744, 4.066875691339015],
            [19.906492319617222, 4.065276999783496],
            [19.908531624669557, 4.064659725493926],
            [19.913849280147343, 4.063050130722071],
            [19.919174291030661, 4.05780924149784],
            [19.917399966529249, 4.055444237603314],
            [19.916912165160284, 4.054794014602615],
            [19.917183238983785, 4.050652036509382],
            [19.915611479189067, 4.047414053583002],
            [19.906944479428947, 4.043182057491403],
            [19.90287215932786, 4.037847085607862],
            [19.901020319200573, 4.017110023855396],
            [19.891348198960671, 3.998826016308149],
            [19.888313650405031, 3.982095959339025],
            [19.887876375677543, 3.979684968186523],
            [19.889578438799209, 3.970034044025851],
            [19.893772439298772, 3.963170134934623],
            [19.901299679084264, 3.955307744894978],
            [19.906327799461138, 3.949373279262202],
            [19.91069227504881, 3.944465263088135],
            [19.935940319034405, 3.917786982889443],
            [19.947434758964746, 3.908152140814409],
            [19.958854679150697, 3.899406352372512],
            [19.966671123457083, 3.892775271087879],
            [19.973362319173919, 3.888560073355046],
            [19.980780479229431, 3.882266757520664],
            [19.990252079328268, 3.877007516034817],
            [19.996082638697278, 3.873851379936441],
            [20.003786278858477, 3.871904143271849],
            [20.011514038785073, 3.871000202163865],
            [20.019254039155715, 3.870617910201468],
            [20.02164407883436, 3.870259533884888],
            [20.030398199007315, 3.865872876762595],
            [20.043145799538802, 3.858686044653916],
            [20.050624438670798, 3.855000806354669],
            [20.054138971455789, 3.853632158548399],
            [20.058303959066627, 3.852010203400936],
            [20.065995358783773, 3.849541252137436],
            [20.076445799148782, 3.846712109845841],
            [20.086547758760599, 3.844754199902375],
            [20.093533558771512, 3.84367975737566],
            [20.09993399947534, 3.841216536592069],
            [20.105744039526616, 3.837190634839692],
            [20.108382119326549, 3.83161371840945],
            [20.111761798817728, 3.826207421318173],
            [20.116077478817466, 3.823593094156174],
            [20.120649478710508, 3.824789125745732],
            [20.121796213204995, 3.824570613385423],
            [20.124092158849162, 3.824133115675041],
            [20.135879278882257, 3.813890090149787],
            [20.138974403532433, 3.812668183877504],
            [20.146690439546241, 3.809622007134619],
            [20.159630642467874, 3.808902472856056],
            [20.16778333606657, 3.808449106528103],
            [20.176799456180376, 3.805396673104305],
            [20.183645159431187, 3.803079032726755],
            [20.196960479052549, 3.800447011308212],
            [20.202720479349274, 3.797281056961729],
            [20.213625239075963, 3.783345145318642],
            [20.216737874585991, 3.775446725557487],
            [20.218324319140663, 3.771421041030914],
            [20.192302439419912, 3.761268022673687],
            [20.178681397954534, 3.753516353518518],
            [20.141264158885999, 3.732222024652128],
            [20.130966359355728, 3.730970110907904],
            [20.137121269831127, 3.710773103995475],
            [20.134962359488583, 3.697400146125532],
            [20.136915452324811, 3.689870131884379],
            [20.137344465246624, 3.688216096479283],
            [20.131983359156866, 3.674120999895599],
            [20.133366454775643, 3.661059639182681],
            [20.134004582020857, 3.655034924464867],
            [20.149963137771891, 3.639538976250428],
            [20.142583229777816, 3.62527925330211],
            [20.138946479401824, 3.618252107752397],
            [20.132978586490488, 3.608546818406113],
            [20.125417319420336, 3.596250151406717],
            [20.125388596687444, 3.596221485043989],
            [20.116798198966546, 3.587647981325099],
            [20.114547479005349, 3.583482043661798],
            [20.111274359469828, 3.567106086295638],
            [20.111440448982712, 3.565248356453639],
            [20.111788439255786, 3.56135602006799],
            [20.115200664709675, 3.552861361074249],
            [20.116485358872232, 3.549663124252922],
            [20.126714399554004, 3.534341053509422],
            [20.138506198911379, 3.523178123246717],
            [20.152606843720442, 3.512559647460506],
            [20.154197159115707, 3.511362054148984],
            [20.180717279527329, 3.493207087392427],
            [20.201675399110666, 3.481442084902759],
            [20.20916663891115, 3.476487711588211],
            [20.213509319573379, 3.472814909254932],
            [20.217278160025408, 3.46827443893182],
            [20.22028919967007, 3.462867545428324],
            [20.222537760081309, 3.45642024946339],
            [20.223286200443425, 3.448935408347957],
            [20.222562959621687, 3.441631311747806],
            [20.219974919576341, 3.433465408082889],
            [20.216091240295032, 3.425131040672322],
            [20.212793639871379, 3.418186217708453],
            [20.211405120224924, 3.41401645672949],
            [20.210197320054046, 3.409672164654777],
            [20.209084920068058, 3.401499329008081],
            [20.211336041576189, 3.383015044405741],
            [20.215059480275453, 3.377067119594325],
            [20.220144480179474, 3.372282040905823],
            [20.227436279613833, 3.3525571013002],
            [20.23021005802228, 3.34982169777296],
            [20.249498160085079, 3.338331153083391],
            [20.261820240344559, 3.328705889265866],
            [20.272674600092234, 3.319434987427817],
            [20.27748600011018, 3.312105072702875],
            [20.281153680379738, 3.303214206570599],
            [20.282259239694863, 3.295204746542254],
            [20.281724639692875, 3.288072396892878],
            [20.280391200248051, 3.278333460156428],
            [20.279523960384559, 3.272768772175247],
            [20.278472399699492, 3.26720495304802],
            [20.278166400276071, 3.26198568413389],
            [20.278422359944908, 3.257112050775106],
            [20.28049056020668, 3.25083792074388],
            [20.283497279853133, 3.245255804260137],
            [20.285697599835306, 3.236719003403555],
            [20.285799839792759, 3.225232841162433],
            [20.285597520326142, 3.216532299245915],
            [20.285683560065738, 3.2043498660284],
            [20.2855136401365, 3.197041415444736],
            [20.285023680115909, 3.191822680400041],
            [20.284405560148684, 3.189040819898767],
            [20.277417959913926, 3.182110698872456],
            [20.266729200097288, 3.174674860611014],
            [20.25732744041855, 3.16705919316373],
            [20.247953760278921, 3.160661592558265],
            [20.24020440036135, 3.15269040514288],
            [20.233020239759263, 3.145238696996836],
            [20.228471640081082, 3.140037693016659],
            [20.225587320383674, 3.135003307465501],
            [20.224916639989178, 3.129959178348217],
            [20.223680400054729, 3.124395293529355],
            [20.22169824043085, 3.118486569026743],
            [20.2158216001827, 3.111724958359083],
            [20.210474520387788, 3.103916802111463],
            [20.203787159578887, 3.094025823811343],
            [20.198038680175674, 3.084826733044852],
            [20.191668120133158, 3.072671536314368],
            [20.187214919741496, 3.063640713634849],
            [20.181979440349291, 3.052698663175849],
            [20.178308519856508, 3.04557865718651],
            [20.175375600403932, 3.038455363237855],
            [20.174560920069379, 3.035151877471503],
            [20.175313320205262, 3.027838096398926],
            [20.179615289218837, 3.019941184630524],
            [20.180399399884262, 3.010050985035034],
            [20.181062957536874, 3.009179235407777],
            [20.185964520561566, 3.002739795337806],
            [20.195310599964074, 2.991195908656748],
            [20.199744720139083, 2.983517176621742],
            [20.20470012009709, 2.974443664684598],
            [20.207313359682782, 2.967817390467081],
            [20.208547486779658, 2.963832961173249],
            [20.209866480416391, 2.958580315928799],
            [20.209749120016095, 2.953532830804435],
            [20.208601798921737, 2.951797172484102],
            [20.211834959596803, 2.944709439071823],
            [20.216876400192699, 2.935534088292651],
            [20.222100359589696, 2.926722073189065],
            [20.227068983646969, 2.922420334184873],
            [20.231192879621783, 2.918849931851607],
            [20.261808360124913, 2.90036606589853],
            [20.275686360185734, 2.885310044530173],
            [20.278434630931692, 2.883093320497119],
            [20.288374200292942, 2.875076140024881],
            [20.301828120081172, 2.867062691478145],
            [20.32352423890806, 2.850445736251723],
            [20.337049078891376, 2.841890644996789],
            [20.371936675594537, 2.824785485302765],
            [20.378392130922975, 2.819834092213843],
            [20.382311211911333, 2.816828073981628],
            [20.394712799361656, 2.826872187898341],
            [20.411000279542165, 2.847276871593104],
            [20.444712839429556, 2.883394097338341],
            [20.488441308409335, 2.933974964630185],
            [20.551523038751078, 2.998843269802761],
            [20.554153961673137, 3.001786539353634],
            [20.572220519341236, 3.021997762467286],
            [20.578939825139983, 3.02921917493919],
            [20.592923759030683, 3.044247913833397],
            [20.606833079752199, 3.061553025446889],
            [20.620726559582003, 3.08120790449109],
            [20.629687680342517, 3.093404394754873],
            [20.647093679832746, 3.112006603390678],
            [20.664326112233688, 3.128223479017468],
            [20.677167000112455, 3.140307452372049],
            [20.694216239975809, 3.157097555906397],
            [20.700990360074879, 3.165114777735642],
            [20.706495479579416, 3.169685273310071],
            [20.733431184895974, 3.18835188665712],
            [20.732208479877922, 3.172484102879119],
            [20.728086559298429, 3.164784377703901],
            [20.724779160051671, 3.158606132188818],
            [20.724455766549386, 3.156957658330811],
            [20.723467319699559, 3.151919107047802],
            [20.727180360399384, 3.146198056434642],
            [20.728134360451349, 3.142064037450435],
            [20.725208279873009, 3.136512095853656],
            [20.725082698091242, 3.135681384664239],
            [20.72412828032266, 3.129368005104119],
            [20.721508942074507, 3.127846998570017],
            [20.718891360032746, 3.126327009293239],
            [20.719746782558691, 3.125379555583115],
            [20.72837231967851, 3.1158259850579],
            [20.727693946111938, 3.111263776905521],
            [20.726864280081838, 3.105684067528321],
            [20.721674160221571, 3.097351081611615],
            [20.718996479988959, 3.089729984971968],
            [20.713562279781172, 3.083006161875771],
            [20.713131359736021, 3.080240025345224],
            [20.719850399633422, 3.071324989286401],
            [20.720482220705382, 3.068732994340969],
            [20.720802225762412, 3.06742019672638],
            [20.718334303945284, 3.061874107092755],
            [20.717733589734983, 3.061911569682138],
            [20.715128279578337, 3.062074048431752],
            [20.707946333323431, 3.071216039537029],
            [20.707054179583835, 3.071375603605061],
            [20.704277160053863, 3.07187210295898],
            [20.702705400259113, 3.068636030578146],
            [20.703886199767499, 3.06473314887062],
            [20.706741786850507, 3.060107218551691],
            [20.717085239661838, 3.04335109196352],
            [20.72154418927132, 3.036124044150672],
            [20.721468542141245, 3.035618289505362],
            [20.720682359960779, 3.030362118261378],
            [20.717985261745007, 3.0248130482424],
            [20.718919439571884, 3.022750078291681],
            [20.722110567176497, 3.021831438539934],
            [20.725116480135789, 3.020966116783371],
            [20.728359345310864, 3.016852051008449],
            [20.727262440365209, 3.011548073931146],
            [20.728693440443138, 3.005347146511554],
            [20.731833824912272, 3.001215235057697],
            [20.73355844383239, 2.998946088478092],
            [20.73338636884478, 2.998319328714192],
            [20.732671440134322, 2.995716046254538],
            [20.729948956426938, 2.994315601538542],
            [20.728571244411665, 2.993606999363373],
            [20.72785850220064, 2.993665547654106],
            [20.718490485938876, 2.994435083175166],
            [20.718082457662124, 2.988908087037507],
            [20.721363595559868, 2.983576114705799],
            [20.722730400230951, 2.981354998373713],
            [20.720688546658153, 2.975002585775988],
            [20.719391400049133, 2.970967012772917],
            [20.721729610529106, 2.968542247023],
            [20.72401235992178, 2.966174989749641],
            [20.724031872228068, 2.96580503125079],
            [20.724291359581034, 2.960885091959589],
            [20.72282393281834, 2.957804460090975],
            [20.718675360122663, 2.949095135177331],
            [20.714821336923833, 2.944917134096165],
            [20.723301360442392, 2.943843133684044],
            [20.726215716209612, 2.942047992278862],
            [20.728824480388568, 2.940441082456932],
            [20.738451197977408, 2.939148014381665],
            [20.740071240422051, 2.937091578633371],
            [20.741691239747539, 2.935035144466576],
            [20.740565745019659, 2.932952231872196],
            [20.73944124023518, 2.93087114697663],
            [20.733528239777613, 2.926674014390852],
            [20.728342439915558, 2.918111044135726],
            [20.728170365826244, 2.911895184304744],
            [20.735767439743597, 2.906901126134484],
            [20.74264128002573, 2.906043070694634],
            [20.74311957721897, 2.904996220432115],
            [20.745678239659572, 2.899396045219563],
            [20.745077263141223, 2.897170940265005],
            [20.743684199816084, 2.892013134247034],
            [20.736852479740993, 2.888268020502308],
            [20.736403380489445, 2.887343080087704],
            [20.735954280339534, 2.886418138909932],
            [20.735508231766691, 2.885187442209336],
            [20.734615477054174, 2.882724047761684],
            [20.736715319573538, 2.878139985117178],
            [20.747345398740848, 2.877765283342593],
            [20.752285319828196, 2.877591154556704],
            [20.757574261556229, 2.87487714799445],
            [20.760130213779625, 2.870528048555252],
            [20.75853528014548, 2.869823070118037],
            [20.75383547963191, 2.858042047633443],
            [20.756391480364346, 2.85369199552531],
            [20.763969480353264, 2.850999080816604],
            [20.767896359616589, 2.846892013514293],
            [20.768146199961731, 2.844593122212096],
            [20.763533016804491, 2.840043162376393],
            [20.76202224004113, 2.838553087260202],
            [20.7611391646758, 2.835092049405435],
            [20.76181323261725, 2.83416663737317],
            [20.766468193723405, 2.827776090335271],
            [20.768049916732966, 2.827473034279099],
            [20.772199439846172, 2.826678134543807],
            [20.779760159842322, 2.825826138601168],
            [20.783827090051698, 2.827451298379831],
            [20.786829479818472, 2.828651061773164],
            [20.793243239843001, 2.828019041124998],
            [20.795553360004039, 2.825738112777005],
            [20.796437204327248, 2.824322857407665],
            [20.79741132035338, 2.822763052905944],
            [20.797924320364359, 2.816554050402317],
            [20.796396480102164, 2.808255046229107],
            [20.800392480235018, 2.796553136574735],
            [20.796646320447305, 2.780638134447844],
            [20.797097186685043, 2.777452792913892],
            [20.79762227981638, 2.773743029010511],
            [20.802524399796539, 2.763200112433347],
            [20.802162243091434, 2.752610199204039],
            [20.804744160219801, 2.745269103657944],
            [20.806481095940786, 2.743646532575863],
            [20.813284440032664, 2.737291118394197],
            [20.82041748020686, 2.732983098811689],
            [20.824057892115956, 2.72812012138492],
            [20.824354253514716, 2.727724231177234],
            [20.823017399573526, 2.723800105622401],
            [20.827385366014386, 2.711762527313045],
            [20.82817836011964, 2.709577119473049],
            [20.830382280549522, 2.706260066850582],
            [20.832586212657461, 2.702942918308057],
            [20.832630989182782, 2.702620407905363],
            [20.83332024044914, 2.697656029817742],
            [20.842294320305989, 2.691983041803775],
            [20.848901690630441, 2.685456897613694],
            [20.85222240021476, 2.68217699701886],
            [20.855347414509392, 2.677722605643639],
            [20.85848028007959, 2.673257005978313],
            [20.863406371603123, 2.669029403964491],
            [20.872545480062477, 2.661186126157638],
            [20.881639440093977, 2.642166150874271],
            [20.892254399716773, 2.632135012785813],
            [20.895089789977277, 2.624465231933399],
            [20.896240319853831, 2.62135301472604],
            [20.900219199894003, 2.615603283234102],
            [20.902729320071582, 2.611975988436577],
            [20.907095222183948, 2.609944090964103],
            [20.908158319033909, 2.608313031360014],
            [20.909183400079336, 2.606740111992153],
            [20.909230394545091, 2.606018494201732],
            [20.909977199973419, 2.594551008294171],
            [20.910642730326394, 2.592789929278502],
            [20.911201200362086, 2.591312143413705],
            [20.915865320690909, 2.578966764517041],
            [20.9163034721741, 2.57780698664051],
            [20.912927483860422, 2.571563306404552],
            [20.91137384488162, 2.569700819213054],
            [20.903644440139736, 2.56043511022166],
            [20.892408479652627, 2.538369053069713],
            [20.890378979711578, 2.5347200589637],
            [20.888349479770564, 2.53107105352911],
            [20.884268160346949, 2.526892132384656],
            [20.878548428829479, 2.51499403445482],
            [20.873935439708344, 2.505398084380923],
            [20.865995280319368, 2.497963051967244],
            [20.863605305319417, 2.49632848458283],
            [20.861221320285811, 2.494698012514884],
            [20.853360543221875, 2.494511555212788],
            [20.845667160024568, 2.494329067867977],
            [20.842025399744198, 2.492225054095769],
            [20.822516456750289, 2.47619365835404],
            [20.819090160085768, 2.473378092376778],
            [20.81229839976946, 2.465491994012095],
            [20.807144279894207, 2.453479090984821],
            [20.806370279767311, 2.448963013998763],
            [20.806188948539013, 2.44790594565889],
            [20.804746319769723, 2.439496130308985],
            [20.804583298901861, 2.438538966920832],
            [20.804537159632243, 2.438268063143498],
            [20.804241094677526, 2.437888974856278],
            [20.801822399639672, 2.434792014689601],
            [20.801192371605055, 2.434728257142497],
            [20.800735200092323, 2.434681992169185],
            [20.794281341070157, 2.434033117707412],
            [20.790589951565309, 2.436541465328254],
            [20.783922480355081, 2.441072088268359],
            [20.778454439712238, 2.438722015891971],
            [20.777011615110215, 2.436873203047148],
            [20.776645440240831, 2.436403991569793],
            [20.778789240021997, 2.426987978423537],
            [20.778256883113261, 2.424178903505075],
            [20.77748748056398, 2.420119005436613],
            [20.777260200508909, 2.418920992462935],
            [20.774309261750023, 2.415903099013935],
            [20.76824448014538, 2.416056056392384],
            [20.764229515678565, 2.418111932012086],
            [20.758415143052655, 2.416816393017956],
            [20.756695148659599, 2.416433018495836],
            [20.753872074301633, 2.415560448364272],
            [20.748254400383605, 2.41382406727916],
            [20.744133411357033, 2.414247134860126],
            [20.739742200109884, 2.419270150542349],
            [20.737154169945999, 2.427070061185113],
            [20.73813614533254, 2.433223845050451],
            [20.739103189820721, 2.439284034471329],
            [20.738714448373116, 2.440198946962112],
            [20.737934280413487, 2.442035093003942],
            [20.735172359766796, 2.443851078615996],
            [20.728775160184526, 2.443101995604653],
            [20.722854277908628, 2.44005616258285],
            [20.721170889863423, 2.440282381505533],
            [20.713234188988267, 2.441348937654517],
            [20.711643300467891, 2.440183541631757],
            [20.710052279895137, 2.439018048810139],
            [20.706805260011851, 2.431394557383625],
            [20.703558240128601, 2.423771021407235],
            [20.701500239338575, 2.422363220841008],
            [20.699466608943872, 2.420972090220304],
            [20.690319239577146, 2.420658138573494],
            [20.68053445173598, 2.415045141740162],
            [20.675981520381459, 2.412702038730835],
            [20.670709319657067, 2.413804078806569],
            [20.668632480297212, 2.41585599669631],
            [20.667575880063396, 2.418838069800097],
            [20.666519294202633, 2.42182009560022],
            [20.667848565464521, 2.426434299818534],
            [20.671013160428895, 2.430605041843621],
            [20.670742439643291, 2.435205993225089],
            [20.669594945174094, 2.437337560539894],
            [20.668647239617325, 2.439097999380704],
            [20.667800626869383, 2.439481948362131],
            [20.665661400411338, 2.440452113889373],
            [20.659263480380229, 2.439702129033112],
            [20.651293440329933, 2.435717029157785],
            [20.639164313701894, 2.436295039878998],
            [20.638487937090201, 2.435136572297361],
            [20.637813240328082, 2.4339809832968],
            [20.638874068033608, 2.431384112410067],
            [20.640154320027083, 2.428250088985078],
            [20.637659519718333, 2.425925024050039],
            [20.625855561663581, 2.427346679467154],
            [20.62346039979122, 2.427635150420976],
            [20.616633820774521, 2.423665428080997],
            [20.60616743980475, 2.41757910104057],
            [20.596594320197365, 2.415077006527174],
            [20.588159160340712, 2.410737991589921],
            [20.580156359630337, 2.410434029096555],
            [20.571598409057536, 2.420709099791258],
            [20.568434252471011, 2.420831538263136],
            [20.566791363173753, 2.420895021794959],
            [20.567053440369687, 2.417445128406271],
            [20.56254213784376, 2.410499994292642],
            [20.555507199088492, 2.404451146917589],
            [20.555056369681701, 2.404560004521012],
            [20.553673319877003, 2.404894092206103],
            [20.546495280395273, 2.414262001970708],
            [20.542587480450269, 2.416296092026767],
            [20.535265440130186, 2.416457075635219],
            [20.525957280412452, 2.409006055200006],
            [20.520796319866303, 2.398142054183686],
            [20.516473439869564, 2.395570055083116],
            [20.51121527981304, 2.395291119829112],
            [20.507526359776914, 2.398478072573951],
            [20.505645360335478, 2.403983102312989],
            [20.508102816779555, 2.410100345774947],
            [20.510563320309057, 2.416225144011609],
            [20.509971237112033, 2.418098688629719],
            [20.509620665080835, 2.419208050272509],
            [20.499290280061949, 2.423023008639591],
            [20.49623316043651, 2.431967988111236],
            [20.493925199825398, 2.43401807733675],
            [20.489591160057849, 2.432826018544344],
            [20.485472001797863, 2.430039102727123],
            [20.479589279955231, 2.426058995834558],
            [20.479183416618284, 2.426065148996686],
            [20.478330360254795, 2.426078083286669],
            [20.470438440396581, 2.42620215217048],
            [20.456455320379519, 2.429291073595488],
            [20.451174840781444, 2.431312535425846],
            [20.445894297403012, 2.433333894797764],
            [20.442964410662839, 2.428703287980003],
            [20.439550080456218, 2.4272899556786],
            [20.438875440287948, 2.425673105773281],
            [20.434801148384828, 2.421032155610418],
            [20.434160513043317, 2.421068996112579],
            [20.427934320351806, 2.421427040960705],
            [20.422305881921691, 2.424363205865933],
            [20.416670280325519, 2.427303101386769],
            [20.406805200165955, 2.43043109497186],
            [20.402384972436792, 2.430541685269936],
            [20.400169320009319, 2.430597118657903],
            [20.3913250853386, 2.422458997194362],
            [20.387674439821769, 2.42150411116248],
            [20.383308359843014, 2.423533148404964],
            [20.375919359999948, 2.430825987480075],
            [20.371330440338543, 2.432163003619018],
            [20.36470032017953, 2.431869130451773],
            [20.3612956800999, 2.42907510985713],
            [20.354486399940601, 2.423487050199737],
            [20.343361320305622, 2.414636010854929],
            [20.336963400274509, 2.413884030887974],
            [20.334873454494637, 2.41459412652744],
            [20.321817480292438, 2.41903011544104],
            [20.314483200426601, 2.420340132615617],
            [20.313012401388335, 2.419514584997529],
            [20.309478480264591, 2.417531022040262],
            [20.301353279605163, 2.406177112114986],
            [20.299095487207719, 2.404226212218004],
            [20.297043359602984, 2.402453018847975],
            [20.292927459532535, 2.402183111622085],
            [20.290771882838023, 2.404442873898413],
            [20.289230280385663, 2.406058984101188],
            [20.284559279860101, 2.416139069582944],
            [20.280410279566375, 2.419321110909455],
            [20.276296337823233, 2.418821070355406],
            [20.271478137558589, 2.418179764475302],
            [20.265102360100901, 2.417331142371699],
            [20.258066178975579, 2.411740107932314],
            [20.258320845968758, 2.410701447170901],
            [20.261162159720254, 2.399114093859694],
            [20.258688200326098, 2.394718103522878],
            [20.255956378631321, 2.393310212893558],
            [20.249776980979579, 2.393710246792244],
            [20.239151399676867, 2.404423020820698],
            [20.236043724663848, 2.405491592524613],
            [20.235248279954508, 2.405765105202291],
            [20.235223568199352, 2.405764859433478],
            [20.232732239879187, 2.405740075638886],
            [20.232150477426455, 2.40519016695111],
            [20.221172280425282, 2.39481302255184],
            [20.20919825511756, 2.389741704620311],
            [20.197254239828542, 2.384683077403083],
            [20.193912359647928, 2.37544605886993],
            [20.192027999609017, 2.373203377477439],
            [20.188259280429563, 2.368718004539376],
            [20.186522632169481, 2.367645919637329],
            [20.183712480076899, 2.36591112797166],
            [20.1761913596151, 2.363076153030003],
            [20.173351319674687, 2.361092585129047],
            [20.170511279734274, 2.359109014358761],
            [20.162599331038479, 2.349596277845089],
            [20.161710489387314, 2.349188501632379],
            [20.158500240243587, 2.347716079530287],
            [20.148734715875381, 2.347619264184601],
            [20.142261359818278, 2.347555086876363],
            [20.132477279849525, 2.3423961265794],
            [20.108232360287236, 2.342387122168444],
            [20.102985360001487, 2.340954034856145],
            [20.097765360378265, 2.336760109277098],
            [20.096922287890852, 2.334384677944163],
            [20.096469024947957, 2.333107568899687],
            [20.096208359903624, 2.332373122820976],
            [20.097326525277118, 2.329715243819554],
            [20.097847350512545, 2.328477243360539],
            [20.103114627570879, 2.325197434149796],
            [20.109123359691658, 2.321456110098923],
            [20.109346052050618, 2.320596808606397],
            [20.110313160319194, 2.316865039748223],
            [20.109527457839079, 2.314952754682152],
            [20.10894623976542, 2.313538151614399],
            [20.106516240328023, 2.307624145230249],
            [20.109942925064729, 2.302746096497535],
            [20.112777360416082, 2.298711128782823],
            [20.110071240419895, 2.29500313235607],
            [20.104905971553666, 2.293879587266451],
            [20.102310359608815, 2.293314991429042],
            [20.100798347661911, 2.29176347561003],
            [20.099367322431164, 2.290294973449028],
            [20.097595440448995, 2.284525065280925],
            [20.101547131180482, 2.277890897466594],
            [20.101480698070269, 2.277386374136718],
            [20.101122360103428, 2.274664989450428],
            [20.096813159651823, 2.270940002032821],
            [20.087272853705112, 2.267571244363046],
            [20.085417258619927, 2.266915965599584],
            [20.082914079724549, 2.264741478416242],
            [20.082470366771428, 2.264356005932024],
            [20.077277257317892, 2.256160419281983],
            [20.072786400447836, 2.249073065375817],
            [20.068905240042589, 2.248344047315068],
            [20.064884632359142, 2.25048783212088],
            [20.060857440024673, 2.252635125360035],
            [20.057197365790607, 2.252829083585324],
            [20.05682721946939, 2.252575350877358],
            [20.054472479988156, 2.250960981652839],
            [20.048445824680819, 2.247331007132095],
            [20.045150279602524, 2.245346030581727],
            [20.042440199832598, 2.241867156004595],
            [20.042241611069358, 2.241139144602609],
            [20.041117530289707, 2.237020897409252],
            [20.038548506680616, 2.227347370242487],
            [20.037809159964123, 2.224564146126292],
            [20.041799379438153, 2.214249147503055],
            [20.041153199694694, 2.210331065110255],
            [20.03821235979624, 2.207080111304907],
            [20.026838160264994, 2.200984125725076],
            [20.022693479969472, 2.180695089769354],
            [20.019298495880808, 2.177209218710982],
            [20.016527076448309, 2.17688777068435],
            [20.014959239596415, 2.176706012385062],
            [20.00741421496495, 2.182960166903173],
            [20.004810120228839, 2.185120001647917],
            [20.000000160210305, 2.183529888247591],
            [19.998638947551854, 2.183079214588555],
            [19.995469920299868, 2.182030003566117],
            [19.990071543108968, 2.178974900207448],
            [19.986369840046343, 2.176879991565139],
            [19.981972310049471, 2.171684411975845],
            [19.981850714990927, 2.171540749896743],
            [19.980911009830109, 2.169396721246137],
            [19.975370040359206, 2.156750018387898],
            [19.963730159591098, 2.153869963985056],
            [19.958739840321389, 2.151059964340994],
            [19.954498078194781, 2.145923786634393],
            [19.953759960373617, 2.145030028617713],
            [19.95379704372683, 2.144740055938129],
            [19.954260000389969, 2.14111992269127],
            [19.954967347319428, 2.139975173350659],
            [19.957510079935101, 2.135860085067241],
            [19.96279991997843, 2.132460019852541],
            [19.963393109001544, 2.129124554264747],
            [19.963779840019576, 2.126949982164285],
            [19.962230040440264, 2.122800105256792],
            [19.962216586372271, 2.122792940401796],
            [19.958409928643402, 2.120765755936163],
            [19.955620080272848, 2.119280058014791],
            [19.951328512851969, 2.113716860466737],
            [19.949132174203093, 2.108827965080466],
            [19.946859839877831, 2.10376989078631],
            [19.942978012024341, 2.094046452759684],
            [19.942620119621861, 2.093149978423649],
            [19.938095757388368, 2.087197911813205],
            [19.936980000398123, 2.085730063338898],
            [19.938927002656726, 2.071533818630646],
            [19.939690080168081, 2.06596992613362],
            [19.940135136102558, 2.064841256908369],
            [19.942040160087938, 2.060010081801678],
            [19.93956011999763, 2.05630004947134],
            [19.935468862512025, 2.056012430714245],
            [19.93201992021751, 2.055769966542884],
            [19.929951159407015, 2.054426857263155],
            [19.925889840074881, 2.05179011010082],
            [19.922339880430059, 2.040710002456656],
            [19.922871862741303, 2.036749748410058],
            [19.923080040121896, 2.0352000000306],
            [19.925619839738143, 2.032230018620712],
            [19.9334401198508, 2.027940116641879],
            [19.931659920367402, 2.022860016948769],
            [19.929409919956747, 2.02008994670239],
            [19.924739974951645, 2.01911146368963],
            [19.918910295033296, 2.017896173349011],
            [19.918924667179521, 2.018559782883589],
            [19.919067657413173, 2.025267908391392],
            [19.918483843208335, 2.024741006405288],
            [19.917020159725446, 2.023420010312364],
            [19.914797262385214, 2.021410317402314],
            [19.90774008044518, 2.015029994991447],
            [19.906392073919726, 2.010950787189172],
            [19.905069960434005, 2.006949926436954],
            [19.818458317393848, 2.005409947417081],
            [19.721283625676197, 2.003682153594018],
            [19.680539031286884, 2.004256703150031],
            [19.636901906598428, 2.004872042282159],
            [19.600317086896332, 2.005178118798215],
            [19.511884587521344, 2.021958127160518],
            [19.472027251951609, 2.033176428851034],
            [19.449819679114345, 2.039426976931054],
            [19.325622956676259, 2.074382901159875],
            [19.31435927956937, 2.07755309328463],
            [19.125467376182499, 2.12635596043362],
            [19.117799803379931, 2.123050742310491],
            [19.110674159933769, 2.11997906119984],
            [19.099729518601706, 2.117096075652229],
            [19.098418680769456, 2.116736556340643],
            [19.094486399936319, 2.11565806116114],
            [19.081836113899566, 2.106965649492973],
            [19.073381400414164, 2.101156120082491],
            [19.064708380145031, 2.099679044871698],
            [19.060859160238017, 2.096185044183605],
            [19.057283279705647, 2.088782073787141],
            [19.049112360188179, 2.083399038981695],
            [19.044344794362832, 2.077417915032173],
            [19.041895401196765, 2.074345079334882],
            [19.03709621377509, 2.074060957859152],
            [19.034723128000834, 2.07109410256687],
            [19.030782240408975, 2.066167152149398],
            [19.029739425721512, 2.062999489208609],
            [19.028349360074454, 2.058777007487863],
            [19.024285564087087, 2.054750504604405],
            [19.022243399697196, 2.052727077696072],
            [19.011505319676512, 2.051916011434176],
            [19.009262834571508, 2.050719001649785],
            [19.004459399915191, 2.048154987542322],
            [18.993717360120737, 2.047804118676959],
            [18.988754451145294, 2.041766095828279],
            [18.9903211085092, 2.03809932755949],
            [18.991102296056702, 2.036270953578088],
            [18.989298360388567, 2.033950155494987],
            [18.979862116182691, 2.030221399654822],
            [18.971315279566547, 2.026844088904495],
            [18.964289880021287, 2.021470028701287],
            [18.958200119861846, 2.013810035224749],
            [18.95133711056712, 2.013931877867657],
            [18.950195293450516, 2.013952149273666],
            [18.946811160112155, 2.010002088948089],
            [18.941095439572425, 2.009937065557193],
            [18.939243240119037, 2.011987028279339],
            [18.929247480238441, 2.006352101177419],
            [18.922443480376383, 2.001443049874834],
            [18.91857132019199, 2.000019000183787],
            [18.911934360260378, 2.000634119494779],
            [18.906416279862949, 2.003331993495178],
            [18.902986200392782, 2.003293087214546],
            [18.897321231971631, 1.998856929061684],
            [18.897250376455272, 1.998044652380457],
            [18.897120000364833, 1.99655001370674],
            [18.894629880278725, 1.994449957385584],
            [18.890344349536541, 1.994405903669162],
            [18.886849920149295, 1.994369982472859],
            [18.882185952534112, 1.991211013654651],
            [18.880277759292408, 1.9899199462089],
            [18.871819919669807, 1.989590043100394],
            [18.86640874957094, 1.982859912373914],
            [18.860929920161528, 1.982110022998516],
            [18.856799240109702, 1.983669598155082],
            [18.85385987973654, 1.981800028589545],
            [18.852806452352301, 1.978854378309641],
            [18.8522899201656, 1.977410022532352],
            [18.849100816465349, 1.976680171150933],
            [18.846780120438453, 1.979639971071359],
            [18.842939999566969, 1.976830019762263],
            [18.833550120107816, 1.976959890234752],
            [18.833532876945963, 1.976940522190621],
            [18.831280303760323, 1.974410422247284],
            [18.824632003496582, 1.977089149711999],
            [18.821509288889054, 1.972021181605671],
            [18.821490119739224, 1.971990046583229],
            [18.817999919620348, 1.97700996479383],
            [18.816305504755036, 1.977115927302672],
            [18.814799879829831, 1.977210084057674],
            [18.810410040310078, 1.981300002030305],
            [18.808762197702357, 1.980695217842415],
            [18.805859999734182, 1.979630064272908],
            [18.802642860512218, 1.98088558712975],
            [18.800119451556604, 1.981869101323595],
            [18.79764014718652, 1.978389942503471],
            [18.797280578527758, 1.978236987594315],
            [18.792635400075032, 1.976261003675796],
            [18.782380080077935, 1.973150056246015],
            [18.78146236567526, 1.973854953668116],
            [18.780310079592315, 1.974740024735931],
            [18.778527962205814, 1.979906481189579],
            [18.778413315615985, 1.980238849171731],
            [18.772325280221906, 1.972807097597277],
            [18.767434093637057, 1.972515496102919],
            [18.762729479950206, 1.972235017950554],
            [18.75731003996086, 1.966420007970047],
            [18.75679625122903, 1.963612745537042],
            [18.755369999645726, 1.955819895334997],
            [18.753120000133368, 1.952570031108118],
            [18.739589649884124, 1.941548007144297],
            [18.73908035991526, 1.941133130344508],
            [18.737520480340152, 1.937664019665668],
            [18.735770827169691, 1.937000722611504],
            [18.735017400259423, 1.936715096466816],
            [18.733248052424695, 1.931754306166004],
            [18.731474280387168, 1.926781098536868],
            [18.725219022704636, 1.914289729428979],
            [18.719745311895714, 1.912381772670363],
            [18.714981916049922, 1.906791112442701],
            [18.713210040355964, 1.904709901100977],
            [18.708659999780039, 1.902819944870315],
            [18.70312204595356, 1.906898421648686],
            [18.699009839755544, 1.906850060514234],
            [18.697160918254632, 1.905724392241164],
            [18.695149920015201, 1.90450004666888],
            [18.690480706238734, 1.905947944557694],
            [18.689410079710068, 1.906279940437085],
            [18.687306979001196, 1.903434983619626],
            [18.686488493403111, 1.902330831385046],
            [18.672689127370685, 1.909533188945756],
            [18.668285280420726, 1.916598099866075],
            [18.667564200047206, 1.917755987000885],
            [18.663871320237305, 1.920703118602554],
            [18.653320440138696, 1.923801014052759],
            [18.649666427736179, 1.923528141739054],
            [18.645685200398155, 1.931534020161731],
            [18.642456359721301, 1.934027020272145],
            [18.634212360458825, 1.935081140117666],
            [18.629141110168547, 1.938702145491244],
            [18.627525455095757, 1.938923784511277],
            [18.622959480203313, 1.939550154238387],
            [18.616468337503584, 1.946447242109855],
            [18.614393280401234, 1.948652064191195],
            [18.604324439877338, 1.949453995581672],
            [18.603051299845983, 1.950819547594891],
            [18.601778172391022, 1.952185084023303],
            [18.602132609872896, 1.954326818840265],
            [18.602846262077314, 1.95863914049106],
            [18.601167239844404, 1.965292056039505],
            [18.598989429846593, 1.968337124715166],
            [18.593497896462424, 1.97601522398677],
            [18.590673600395679, 1.976993933668337],
            [18.580874760208516, 1.977526744132247],
            [18.565054560282608, 1.975471154085874],
            [18.541607040163708, 1.975552390760593],
            [18.513919439564432, 1.975409731055181],
            [18.472152960335436, 1.977071387764499],
            [18.465903016187799, 1.977125310802261],
            [18.465865321081829, 1.977125636178896],
            [18.409186439827202, 1.977614645500401],
            [18.368570838122768, 1.979000370109845],
            [18.318960234798524, 1.980692992632839],
            [18.294132227768447, 1.98302307550456],
            [18.200947539929157, 1.985708168921503],
            [18.165134356886458, 1.986740115847405],
            [18.102937656644126, 1.987580205951363],
            [18.097670160396873, 1.987980094798461],
            [18.096080039936012, 1.987270046279116],
            [18.086000039641341, 1.983999889296933],
            [18.084999959608567, 2.000999947735141],
            [18.083999879575824, 2.005000105610244],
            [18.073830880490988, 2.014570986940424],
            [18.066999959916508, 2.021000095557652],
            [18.0650001600754, 2.026999892499792],
            [18.067876101186144, 2.031930229532781],
            [18.071876640506165, 2.038788481532001],
            [18.071999999855912, 2.038999960086535],
            [18.071803955121549, 2.041352312875111],
            [18.070999919823137, 2.050999936998069],
            [18.074999879729763, 2.060999998586444],
            [18.078999839636424, 2.06400000448466],
            [18.080999999701941, 2.07199999244573],
            [18.081901988197256, 2.074029496753293],
            [18.084680579778979, 2.080281407295995],
            [18.088999920413524, 2.089999994555931],
            [18.089377397885787, 2.095661745753488],
            [18.089444523597098, 2.096668553678658],
            [18.089588031260377, 2.098820999646136],
            [18.0897617420801, 2.101426457974454],
            [18.090000000446295, 2.105000047368442],
            [18.091000079580738, 2.12700005196407],
            [18.091000079580738, 2.13313469207316],
            [18.091000079580738, 2.148858392432555],
            [18.091000079580738, 2.172329626417245],
            [18.091000079580738, 2.174918372578367],
            [18.091000079580738, 2.185000054038073],
            [18.091000079580738, 2.202000065584727],
            [18.091013417766074, 2.202120113930435],
            [18.092526956848946, 2.215742171128698],
            [18.093381592450701, 2.223433953471658],
            [18.094232578197445, 2.231092846611043],
            [18.09445939292522, 2.233134174118081],
            [18.094534993342876, 2.233814575919047],
            [18.095000040385699, 2.237999988506868],
            [18.099000000292325, 2.251000062336363],
            [18.105999840072837, 2.266999977243494],
            [18.107439965237411, 2.268296085910755],
            [18.115999919951637, 2.275999996744736],
            [18.118797161456968, 2.277048950113327],
            [18.123999839764892, 2.278999930059056],
            [18.131157792018563, 2.285561267406002],
            [18.135196124360867, 2.289262992068012],
            [18.136000079709241, 2.289999934004302],
            [18.144000000420792, 2.298999988275483],
            [18.154000080299593, 2.304999931673069],
            [18.158850995410265, 2.312006921865711],
            [18.163000080145654, 2.318000112896194],
            [18.168000120085054, 2.324999979820839],
            [18.169398814050403, 2.32650627544986],
            [18.181000079837709, 2.33899996854753],
            [18.185000039744338, 2.34500010036629],
            [18.185139054034568, 2.345389337716734],
            [18.189567360313063, 2.357788469860595],
            [18.190000079683738, 2.359000066370615],
            [18.190000079683738, 2.369999978890359],
            [18.192999960455921, 2.375999975272882],
            [18.203000040334722, 2.384000049818702],
            [18.207000000241347, 2.389999984452829],
            [18.208119690055884, 2.392015442461854],
            [18.212000040180751, 2.39900010717447],
            [18.212197419811631, 2.400776704297989],
            [18.213999840021859, 2.416999991621055],
            [18.218940654932894, 2.425741253191152],
            [18.220477362465235, 2.428459975603956],
            [18.227000159998951, 2.439999961581508],
            [18.228999959840063, 2.452000023427846],
            [18.228220290445421, 2.461355282914882],
            [18.227999879807289, 2.463999975309725],
            [18.231999839713918, 2.474999925517146],
            [18.234506913704408, 2.485028202987574],
            [18.236999879653318, 2.494999974227683],
            [18.237882192348977, 2.497117533278817],
            [18.241999919592718, 2.507000071219023],
            [18.264766865272591, 2.533561363584197],
            [18.26600004015528, 2.535000044255734],
            [18.267999839996389, 2.537999941155387],
            [18.276999839842418, 2.545000091742483],
            [18.294999840432805, 2.553000037006974],
            [18.300042788401733, 2.559229468542037],
            [18.301781310547526, 2.561377015431192],
            [18.312000120316519, 2.573999946414849],
            [18.318851766821226, 2.578567821061438],
            [18.321000120162548, 2.58000008766473],
            [18.330000120008577, 2.585000032735278],
            [18.330593727646669, 2.585923421697268],
            [18.339000119854635, 2.598999954923773],
            [18.341120360419126, 2.611191488578966],
            [18.343000079761264, 2.621999908864854],
            [18.347671290492578, 2.629940960332285],
            [18.353000159640064, 2.638999967024674],
            [18.354999960379473, 2.644999973681064],
            [18.360000000318877, 2.652000065019032],
            [18.384000119983106, 2.698999963959176],
            [18.39399983963747, 2.710000009456893],
            [18.397000079735793, 2.717999962192188],
            [18.398000159768532, 2.724000116418198],
            [18.401000039642419, 2.733000020837977],
            [18.411000120419516, 2.739999959351985],
            [18.420999840073883, 2.752000014453218],
            [18.429000120111606, 2.768000018436338],
            [18.428483175598206, 2.771236095104967],
            [18.42734375967834, 2.778368813754549],
            [18.430907759991062, 2.79270185879476],
            [18.438000119957632, 2.805000017329625],
            [18.444999959738112, 2.821999980719259],
            [18.446000039770883, 2.836999960900382],
            [18.43899983976597, 2.856000048849959],
            [18.438000119957632, 2.872000047082381],
            [18.439999919798712, 2.881999974969181],
            [18.440466708674869, 2.88410034621544],
            [18.441533396090996, 2.888900021072282],
            [18.442000079864258, 2.890999906115975],
            [18.442999582280297, 2.893998434322024],
            [18.447000119803661, 2.906000051709771],
            [18.451825427538839, 2.922889280159422],
            [18.452999880449699, 2.926999986147696],
            [18.457999920389096, 2.93299994628991],
            [18.461000159589091, 2.940000097742461],
            [18.462999960328499, 2.942000004595014],
            [18.464191243176241, 2.945812105790553],
            [18.468000000267899, 2.958000026964678],
            [18.474999840048412, 2.969999934305089],
            [18.493999919773241, 2.987000087667016],
            [18.497000159871529, 2.99099990521988],
            [18.505000079684816, 2.996000061190159],
            [18.512195392871135, 3.006793115214875],
            [18.516999960303028, 3.013999962796345],
            [18.521758975065172, 3.024469752867752],
            [18.522000000242429, 3.025000003757892],
            [18.524103710009062, 3.036570633996976],
            [18.525999960149054, 3.047000106324654],
            [18.528143137397699, 3.057716295967307],
            [18.528999840022941, 3.061999898992576],
            [18.530713411461686, 3.065426834115559],
            [18.533000160154003, 3.070000037982909],
            [18.543999959841145, 3.079999945268225],
            [18.570115574270229, 3.092241675388552],
            [18.576000000216954, 3.094999987978061],
            [18.585000000062983, 3.098000043517408],
            [18.595000079941787, 3.105999907168739],
            [18.600999839689525, 3.114999950242382],
            [18.614999880373251, 3.138000006589601],
            [18.626000040284826, 3.15900005683502],
            [18.636000120163626, 3.191000126216664],
            [18.641999879911367, 3.209000081895078],
            [18.64265352106155, 3.216843111511724],
            [18.642999959944138, 3.220999994664429],
            [18.640000080070251, 3.228999976405925],
            [18.635000040130855, 3.260000066378673],
            [18.635290988281703, 3.262909700355815],
            [18.637999920004738, 3.290000020871308],
            [18.645000120009655, 3.30500001530143],
            [18.647999999883542, 3.317000025106833],
            [18.650000159949055, 3.330999940686517],
            [18.649000079916281, 3.344000002546884],
            [18.645000120009655, 3.359000064926199],
            [18.632999880065338, 3.385999946700739],
            [18.632000160257, 3.396999893804587],
            [18.636000120163626, 3.409000018582359],
            [18.63900000003748, 3.41700007649557],
            [18.640000080070251, 3.427000100317174],
            [18.640000080070251, 3.448383490619905],
            [18.640000080070251, 3.448999993608349],
            [18.640000080070251, 3.449000451282102],
            [18.635937512978217, 3.46687535084215],
            [18.635000040130855, 3.471000091352144],
            [18.635000040130855, 3.473000024975935],
            [18.623000160410971, 3.508000063171239],
            [18.6220571090257, 3.512715320801555],
            [18.618000119573242, 3.532999997877185],
            [18.617000040438796, 3.543000032412436],
            [18.618000119573242, 3.55500007405958],
            [18.615999960406022, 3.589000108480459],
            [18.613000652758988, 3.615394028402656],
            [18.610999919568325, 3.633000058240506],
            [18.609033739176716, 3.643224175506941],
            [18.605999879628925, 3.658999980978519],
            [18.601999919722264, 3.675999980720429],
            [18.601768855963222, 3.676462124583999],
            [18.595000079941787, 3.690000030657035],
            [18.593741997471209, 3.694403389749755],
            [18.591000120035158, 3.704000036625933],
            [18.589323268131935, 3.728312514779838],
            [18.588999959969609, 3.733000039932286],
            [18.590000040002383, 3.733000039932286],
            [18.587672545525418, 3.74153444638625],
            [18.587446320990775, 3.742363957748258],
            [18.587000160128497, 3.743999918710123],
            [18.587000160128497, 3.747639483991353],
            [18.587000160128497, 3.750999964834928],
            [18.58708376902695, 3.751395225907525],
            [18.589886845090064, 3.764646697609157],
            [18.597999959815638, 3.803000086901975],
            [18.597999959815638, 3.804260784678366],
            [18.597999959815638, 3.814999997288582],
            [18.596818403027498, 3.825240675970321],
            [18.595000079941787, 3.841000028908405],
            [18.595690872717164, 3.850670290798425],
            [18.596000159974526, 3.854999907667927],
            [18.59782660023718, 3.863523775570728],
            [18.599000039848413, 3.869000092416147],
            [18.600000119881184, 3.876000006702037],
            [18.600000119881184, 3.885000118012217],
            [18.601999919722264, 3.896000003121342],
            [18.608000039694442, 3.908999941314391],
            [18.610268016292245, 3.911834974989723],
            [18.619999920312647, 3.924000015515229],
            [18.636000120163626, 3.93899999810374],
            [18.642999959944138, 3.951999977220476],
            [18.647999999883542, 3.962000013750571],
            [18.651981353883983, 3.977925608720618],
            [18.651999959790167, 3.978000033444766],
            [18.651999959790167, 4.008999870401526],
            [18.649000079916281, 4.044000053022397],
            [18.647999999883542, 4.058000057694454],
            [18.649000079916281, 4.075999932386788],
            [18.645999839817993, 4.092000018389644],
            [18.641000160103026, 4.108999990885193],
            [18.632000160257, 4.131999981201184],
            [18.627000120317597, 4.141999923189622],
            [18.621000000345425, 4.160000034465746],
            [18.618000119573242, 4.166999935119016],
            [18.595000079941787, 4.203999927097357],
            [18.583999920030212, 4.226999977622762],
            [18.578000160282471, 4.237999991563155],
            [18.570999960277558, 4.246999967927717],
            [18.564000119598713, 4.262000109576823],
            [18.551000159846058, 4.289000121193817],
            [18.546000119906658, 4.302000055220938],
            [18.546000119906658, 4.307999962299833],
            [18.548999999780541, 4.316000064078758],
            [18.560999880398754, 4.329000069633729],
            [18.578000160282471, 4.344000015714624],
            [18.599000039848413, 4.354000051163534],
            [18.606999959661668, 4.357999955880123],
            [18.613000079633839, 4.356000006216032],
            [18.627618240284821, 4.357346365609822],
            [18.639734399731726, 4.357346365609822],
            [18.647999999883542, 4.34900005025172],
            [18.66399984040838, 4.352000090725034],
            [18.676000080352694, 4.352999981895636],
            [18.698889600254784, 4.37022399029748],
            [18.713856960311205, 4.375231574706275],
            [18.733100119660314, 4.386677959609145],
            [18.733100418799317, 4.386677859522101],
            [18.733100399934713, 4.386678126420841],
            [18.743306079927532, 4.38325319202232],
            [18.749577062619089, 4.381148699059805],
            [18.753000119958678, 4.379999944834139],
            [18.753000119958678, 4.379000090116357],
            [18.762999839613077, 4.386999967435868],
            [18.764999999678594, 4.390000033290593],
            [18.774000000422948, 4.397999970607475],
            [18.775006677683141, 4.401538921581882],
            [18.780140159663077, 4.419585296296395],
            [18.790231705105775, 4.422071529790439],
            [18.794000160180552, 4.422999953855975],
            [18.799999919928293, 4.438999919492801],
            [18.801357873498876, 4.44171583244625],
            [18.80590234541836, 4.450804721782156],
            [18.811000079839832, 4.46099999380447],
            [18.816000119779236, 4.48499990071601],
            [18.816600441425734, 4.487701638178456],
            [18.817999919620348, 4.493999929492513],
            [18.818999999653123, 4.510999975783241],
            [18.819277684178793, 4.512110638125369],
            [18.821000159718636, 4.519000017488854],
            [18.82260065212775, 4.529404267071808],
            [18.822999960458045, 4.532000005165837],
            [18.8266128093593, 4.542437231957487],
            [18.831999960304106, 4.557999989413372],
            [18.839999880117357, 4.570999982807441],
            [18.843999840023983, 4.574999946671139],
            [18.856000079968336, 4.590000014309844],
            [18.875000159693162, 4.602000053537884],
            [18.884000160437523, 4.614000067153807],
            [18.889999920185261, 4.625000004260358],
            [18.890121348157148, 4.626092779097196],
            [18.891000000218, 4.634000052599702],
            [18.894838024421624, 4.639757174549334],
            [18.894999960124629, 4.640000081024279],
            [18.902999879937916, 4.645000034295009],
            [18.904020647273349, 4.648742562935054],
            [18.906000120036207, 4.65600002149424],
            [18.907570625782807, 4.656523531668334],
            [18.917999999756116, 4.660000038957764],
            [18.932000040439874, 4.666000021448783],
            [18.938000160412017, 4.672999935641801],
            [18.947000160258046, 4.69600005352437],
            [18.984999960381597, 4.733999952240715],
            [18.993999960227658, 4.737999875063387],
            [19.002999960073687, 4.746000010824224],
            [19.00626059212842, 4.749912711447366],
            [19.00627249031438, 4.749926988608755],
            [19.006412616718915, 4.75009513771493],
            [19.008000000013087, 4.751999961312196],
            [19.010000160078604, 4.753000007697339],
            [19.01400011998523, 4.767999987913321],
            [19.033361982716034, 4.76887018340285],
            [19.036378978191017, 4.765912290656098],
            [19.040739328714885, 4.765731079850292],
            [19.04216219993781, 4.761604153468929],
            [19.052227351979159, 4.764248070576445],
            [19.058370446913635, 4.768690264803245],
            [19.058268957049457, 4.769437631775328],
            [19.057871159685448, 4.772366995410692],
            [19.061281778053331, 4.773608123598467],
            [19.062441360253004, 4.774030096102141],
            [19.067953320428405, 4.773401135381808],
            [19.072273320426348, 4.776902079364022],
            [19.072905372365327, 4.775668450593295],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Gbadolite",
        AREA: 56644,
        POPULATION: 1269000,
        DISTRICTS: [],
        OBJECTID: 20,
        NOM: "Nord-Ubangi",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [19.601999999732769, 5.131999929491664],
            [19.613000159644315, 5.128000076939746],
            [19.635000119243028, 5.128000076939746],
            [19.681999919212608, 5.132999933469466],
            [19.695999958998033, 5.132999933469466],
            [19.725000119499999, 5.119000093639387],
            [19.740999959126537, 5.114999979392474],
            [19.761000118884141, 5.107000034320229],
            [19.775999879376204, 5.101999972798899],
            [19.775999879376204, 5.10300002429195],
            [19.793000159259954, 5.101000098974],
            [19.811588925569012, 5.096958921196451],
            [19.815999838666972, 5.095999990087456],
            [19.824999839411333, 5.092999977886895],
            [19.828110165352754, 5.090380793593649],
            [19.840582072923535, 5.079878175571532],
            [19.843999919136163, 5.076999970091448],
            [19.847999879042789, 5.074000047443423],
            [19.851784322333003, 5.068593893310141],
            [19.855000079047738, 5.064000083461539],
            [19.856000159080512, 5.059999982087144],
            [19.867392359053397, 5.034167111253125],
            [19.869000118833167, 5.023999918305642],
            [19.872196395580975, 5.019525174496144],
            [19.874000158772564, 5.016999916242447],
            [19.876152642567575, 5.014847443618766],
            [19.889999999297402, 5.000999984703941],
            [19.892000159362954, 4.999999953011676],
            [19.894445939504958, 4.998369475675001],
            [19.901000159208976, 4.994000091631371],
            [19.914999838769972, 4.979999899142469],
            [19.925340257072271, 4.97612238315812],
            [19.92717473905331, 4.975434475274186],
            [19.931000039519276, 4.9740000318595],
            [19.94100011939808, 4.971999884498987],
            [19.949000039211334, 4.971999884498987],
            [19.960825813751065, 4.975284942950954],
            [19.967000038903386, 4.977000062522546],
            [19.97200007884279, 4.979000015203711],
            [19.98799991936766, 4.977000062522546],
            [20.000000159311977, 4.972999959399241],
            [20.004000119218603, 4.970999988244473],
            [20.02399991875177, 4.965999943351478],
            [20.036999879402753, 4.957999935779553],
            [20.050999919188214, 4.946000099846512],
            [20.067999838847498, 4.924000067841385],
            [20.068653529405026, 4.92355065967843],
            [20.074326703037961, 4.919650379997676],
            [20.084000038698473, 4.912999954837044],
            [20.091999959410057, 4.906000015816311],
            [20.095999919316686, 4.905000018710542],
            [20.108000159261, 4.896999984549447],
            [20.117999878915398, 4.893999946841409],
            [20.122999918854802, 4.893999946841409],
            [20.138000038672967, 4.888000009852652],
            [20.140465599717526, 4.887373621500188],
            [20.150697958775979, 4.884774031324404],
            [20.156501955860378, 4.877803768264145],
            [20.162999879043866, 4.870000053582794],
            [20.169267669122938, 4.854778724030911],
            [20.170000079048783, 4.853000044838234],
            [20.172031724166732, 4.850968431253498],
            [20.186530625378889, 4.836469573488218],
            [20.188532666516625, 4.834467513713125],
            [20.195999999452457, 4.827000058563197],
            [20.199821456925608, 4.82481625918759],
            [20.202999839232934, 4.822999944033164],
            [20.212538313514798, 4.819531494646972],
            [20.213999999144509, 4.818999984049705],
            [20.238999839515408, 4.804000058784204],
            [20.255000039366351, 4.793000115942133],
            [20.271999959025663, 4.779999984960056],
            [20.278475824975654, 4.776402380376483],
            [20.280999958871693, 4.77500011755406],
            [20.292575796946558, 4.774142559215747],
            [20.307999959308106, 4.772999907915183],
            [20.313153642602135, 4.770423133321857],
            [20.318000039186906, 4.767999987913321],
            [20.320256950337068, 4.766495389043023],
            [20.336000038878996, 4.755999958686281],
            [20.342999879557805, 4.751000092799675],
            [20.344900391305494, 4.749226297942331],
            [20.348487055214523, 4.745878764192531],
            [20.357999998477677, 4.736999986904823],
            [20.364000118449855, 4.7280000236265],
            [20.365895347205345, 4.723999021136233],
            [20.373000118295877, 4.708999991235118],
            [20.377131617611255, 4.70336605687393],
            [20.383999917983019, 4.693999972037699],
            [20.39348467121426, 4.686322006823689],
            [20.400339906488504, 4.680772599508223],
            [20.405000158671694, 4.677000035205862],
            [20.429999999940886, 4.647999917449678],
            [20.440866171636259, 4.639051381794819],
            [20.445849519979362, 4.634947444502018],
            [20.446999919600202, 4.634000052599702],
            [20.448989945770993, 4.631678367602148],
            [20.451987090274852, 4.628181702783951],
            [20.453000039572377, 4.626999925973493],
            [20.458000080410077, 4.614999954756819],
            [20.458459052146626, 4.613623002588176],
            [20.460999960283964, 4.606000020786111],
            [20.460999960283964, 4.601054426186555],
            [20.460999960283964, 4.598999973011514],
            [20.451999960437902, 4.574000003125058],
            [20.45000015969849, 4.563999946323507],
            [20.45000015969849, 4.544999936237598],
            [20.453000039572377, 4.529999994656514],
            [20.453000039572377, 4.524999944318028],
            [20.457000000377299, 4.51200000875961],
            [20.462000040316703, 4.50300002508476],
            [20.463700463114666, 4.500874454048883],
            [20.466000000223364, 4.497999965657164],
            [20.471469890497364, 4.492074191154283],
            [20.477999879943244, 4.48499990071601],
            [20.490000119887593, 4.480999971753213],
            [20.492815673549988, 4.480999971753213],
            [20.494862298075269, 4.480999971753213],
            [20.500999919574735, 4.480999971753213],
            [20.508999840286315, 4.475999938985523],
            [20.522999880071744, 4.456999931184181],
            [20.527999920011148, 4.448999921014556],
            [20.532999959950544, 4.441999951780563],
            [20.539000079922687, 4.440000051243599],
            [20.55499992044756, 4.437999965791426],
            [20.57154512189318, 4.42718352830728],
            [20.587768306055537, 4.416577453778381],
            [20.589732715867733, 4.415293190083643],
            [20.606000035158321, 4.403000003324124],
            [20.612999874040501, 4.401999997699773],
            [20.624000033053743, 4.401999996798098],
            [20.630999871037599, 4.405000001470541],
            [20.637484915074868, 4.416366305779926],
            [20.64525952214353, 4.418617264915098],
            [20.656015905338137, 4.421731520740467],
            [20.663999986056304, 4.411999964675132],
            [20.670999831226698, 4.41499992754216],
            [20.670999825836816, 4.413999942787618],
            [20.698999911695886, 4.41700007869406],
            [20.728000001230907, 4.420999995827713],
            [20.728000064113004, 4.420999995827713],
            [20.734999903893485, 4.421000000335907],
            [20.735171234177734, 4.421005731177012],
            [20.746174663956943, 4.421373756393256],
            [20.756865584221835, 4.421373756393256],
            [20.765871353946956, 4.421095632162974],
            [20.780028712094804, 4.42065840930567],
            [20.789101471885601, 4.421102618991459],
            [20.794639302642882, 4.421373756393256],
            [20.810000089759463, 4.419000053068097],
            [20.810000141861732, 4.419000042248346],
            [20.819999871397599, 4.425000081330337],
            [20.825999982386598, 4.428999959198261],
            [20.850000101152503, 4.441000001297171],
            [20.856999940933015, 4.445999915788048],
            [20.864999860746266, 4.445999915788048],
            [20.885000021402199, 4.43799996488979],
            [20.900999860130408, 4.43799996488979],
            [20.910999940009212, 4.438999918591165],
            [20.923999909643335, 4.435000094650207],
            [20.928292172360266, 4.432853915511444],
            [20.933999979640667, 4.429999925241652],
            [20.946999939393358, 4.427999990883509],
            [20.953000059365529, 4.429999925241652],
            [20.969999987109649, 4.427999998096587],
            [20.977999910516193, 4.424000109342923],
            [20.9879999787169, 4.421999977328955],
            [21.008999857384509, 4.407999993881514],
            [21.023999987084181, 4.402000003109769],
            [21.038000008004971, 4.400999996123951],
            [21.047000008749325, 4.401999996798098],
            [21.047571086640051, 4.401918415848856],
            [21.053999855716352, 4.400999991615642],
            [21.053999855716352, 4.399999985071997],
            [21.056520175365677, 4.399019853575721],
            [21.071999855408439, 4.392999906589894],
            [21.075000101794942, 4.392000070405383],
            [21.084999815161094, 4.384999914944494],
            [21.086999975226608, 4.380999976732658],
            [21.101000015012069, 4.37000007888798],
            [21.107000134984208, 4.357999954978423],
            [21.113999973866392, 4.343000111541304],
            [21.119000013805795, 4.336000033266752],
            [21.119000039856942, 4.336000034168477],
            [21.138999829508641, 4.327000046586048],
            [21.152000149485733, 4.320999932711138],
            [21.156447105687871, 4.317765789320154],
            [21.162999933003224, 4.313000057443913],
            [21.171999931950921, 4.305999877760288],
            [21.174999811824808, 4.302000054319135],
            [21.174999839672584, 4.302000055220938],
            [21.178159729261459, 4.301548673488854],
            [21.182000012728054, 4.301000099415816],
            [21.182000039677501, 4.301000095808672],
            [21.187000055362379, 4.303000003383224],
            [21.187000079616901, 4.303000013302865],
            [21.191502965826921, 4.303900544637727],
            [21.192000095301779, 4.303999964643519],
            [21.201999811362889, 4.295999918987504],
            [21.206000131493955, 4.290000095644496],
            [21.210999811208918, 4.286999986149239],
            [21.210999839955026, 4.286999987051066],
            [21.21900009034831, 4.286999987051066],
            [21.219000119992714, 4.286999987051066],
            [21.228000092889292, 4.290000087528267],
            [21.22800011983874, 4.290000096546272],
            [21.237000119684769, 4.294999952501202],
            [21.23978901853609, 4.304482170602675],
            [21.241238982049641, 4.309411979317186],
            [21.242000159624169, 4.311999934131062],
            [21.251000160368527, 4.329000069633729],
            [21.256999920116264, 4.332000011202199],
            [21.269999849326219, 4.332999925623037],
            [21.269999879868919, 4.332999928328264],
            [21.278999878816652, 4.338000036705244],
            [21.282000088372236, 4.338000037606982],
            [21.282000119813269, 4.338000037606982],
            [21.286410433734936, 4.336109800155683],
            [21.287683613292195, 4.335564121664016],
            [21.28899992815272, 4.334999939811944],
            [21.300000088064294, 4.32099992639878],
            [21.305999847812032, 4.316000063177007],
            [21.313000047816981, 4.311999933229286],
            [21.31400012784972, 4.310999987134322],
            [21.318000086858049, 4.305999877760288],
            [21.327000086704079, 4.298000029234696],
            [21.333999926484591, 4.293999982883148],
            [21.333999959722249, 4.293999983784924],
            [21.345962984260979, 4.291185222845822],
            [21.350999847940532, 4.290000103760673],
            [21.350999880279861, 4.290000096546272],
            [21.353292608158696, 4.288941920627518],
            [21.377000124975321, 4.277999945924979],
            [21.37700016000964, 4.277999946826806],
            [21.392529474666762, 4.27447057638576],
            [21.399000093557206, 4.272999984575983],
            [21.399000119608321, 4.272999978263231],
            [21.400167307843518, 4.273545079947172],
            [21.406729898049363, 4.276609943816106],
            [21.419707319969874, 4.282670628634112],
            [21.43175144710742, 4.284182460282047],
            [21.446805201737956, 4.278137255541196],
            [21.450999921788092, 4.264999958421527],
            [21.450999957720676, 4.264999968341677],
            [21.459999958465033, 4.268999978001965],
            [21.468999920581815, 4.268999978903779],
            [21.481999880334502, 4.262999940265437],
            [21.494999839188861, 4.258000052177783],
            [21.494999879613029, 4.258000053079622],
            [21.540999919350103, 4.248000007739646],
            [21.540999959774272, 4.247999998721145],
            [21.550879757033186, 4.247101820495925],
            [21.552000076566721, 4.246999971535115],
            [21.552000119685847, 4.246999967927717],
            [21.560069156775409, 4.246999967927717],
            [21.565000036319375, 4.246999967927717],
            [21.565000080336834, 4.246999967927717],
            [21.576999960056746, 4.253999974611775],
            [21.584000160061663, 4.259000069405332],
            [21.597000119814346, 4.271999980404701],
            [21.606999840367013, 4.275999963007298],
            [21.624000120250759, 4.285000027064269],
            [21.6299998799985, 4.290000096546272],
            [21.642000119942818, 4.303000013302865],
            [21.651000117992218, 4.309000090945545],
            [21.660000071125861, 4.309000091847348],
            [21.667999990939116, 4.3049999227693],
            [21.676999990785177, 4.295999918085702],
            [21.677000040192514, 4.295999919889293],
            [21.683000109859019, 4.295999919889293],
            [21.683000160164656, 4.295999919889293],
            [21.692000149230921, 4.299999951101287],
            [21.696000799942013, 4.299333200750857],
            [21.69856227860102, 4.298906299244968],
            [21.704000001103058, 4.298000036449022],
            [21.704000039730598, 4.298000030136473],
            [21.720999960288211, 4.303000013302865],
            [21.729861289000464, 4.303632936231241],
            [21.734999949768003, 4.303999966447097],
            [21.743999946020772, 4.299999953806654],
            [21.751999865834026, 4.293000011937212],
            [21.759000064940647, 4.282000076244901],
            [21.760999864781756, 4.276999953774743],
            [21.77200002559163, 4.269999978921041],
            [21.772000080388853, 4.269999980724682],
            [21.786623564456203, 4.270664686402509],
            [21.793999983393718, 4.270999978519614],
            [21.794000039987566, 4.270999981225096],
            [21.804999783080859, 4.269999986135633],
            [21.817000021228544, 4.262000107773143],
            [21.829999980981199, 4.259000067601664],
            [21.849000059807732, 4.245000080066396],
            [21.858999778563767, 4.240000073653928],
            [21.858999839649236, 4.240000075457658],
            [21.872000097642559, 4.240000075457658],
            [21.872000159626324, 4.240000075457658],
            [21.875000014347361, 4.24099992694939],
            [21.912000055136701, 4.233999986618612],
            [21.912000119815392, 4.233999988422342],
            [21.912363226938091, 4.233984200313961],
            [21.923942996040626, 4.233480708655519],
            [21.93500009476816, 4.232999941975191],
            [21.954999892504699, 4.223999977345196],
            [21.954999959878347, 4.223999979148952],
            [21.958999851513028, 4.223999979148952],
            [21.958999919784976, 4.223999979148952],
            [21.9650163756206, 4.225052481629391],
            [21.965016442095919, 4.225052493353807],
            [21.981999960314759, 4.236999948551626],
            [21.993000109446537, 4.240000072752087],
            [22.007000089044862, 4.239000039577073],
            [22.011000048053191, 4.23699994584603],
            [22.017999886935371, 4.229999961626802],
            [22.030999846688026, 4.222000030152841],
            [22.030999920349888, 4.2220000328585],
            [22.038999766501313, 4.2220000328585],
            [22.038999840163143, 4.2220000328585],
            [22.040663337711347, 4.22184879796277],
            [22.049999926412855, 4.220999974330585],
            [22.050000000074718, 4.220999968017387],
            [22.055683602249793, 4.220368529198585],
            [22.058999925360585, 4.220000090364779],
            [22.06900000344276, 4.214999909617826],
            [22.069000079799544, 4.214999912323473],
            [22.072000680122272, 4.214799890057426],
            [22.083999763036527, 4.214000023239061],
            [22.083999840291643, 4.214000017827678],
            [22.086681898014611, 4.213512385433839],
            [22.094999922049773, 4.212000043647146],
            [22.119000039019042, 4.195999901413508],
            [22.126999957934, 4.192000038255344],
            [22.148999916634384, 4.168000067302077],
            [22.155000036606559, 4.16300009972927],
            [22.164000035554288, 4.154000040586777],
            [22.173000034501985, 4.148999983001563],
            [22.187000072490786, 4.142999907102399],
            [22.197999872177927, 4.134999974701572],
            [22.21899974994724, 4.125999952495956],
            [22.218999839778782, 4.125999955201946],
            [22.23236289407771, 4.124727286207034],
            [22.239999988839287, 4.123999945345629],
            [22.265999905649672, 4.113999941372773],
            [22.281000023671243, 4.112000071428929],
            [22.281000119790971, 4.112000074134983],
            [22.305999863143814, 4.11499995561761],
            [22.305999960161866, 4.114999967343704],
            [22.328999899182016, 4.113999948588853],
            [22.328999999793322, 4.113999944078814],
            [22.340000058195258, 4.113999944078814],
            [22.340000159704896, 4.113999944078814],
            [22.358999869323824, 4.11800002499251],
            [22.366358800757709, 4.1180000276985],
            [22.380893041693145, 4.1180000276985],
            [22.386864371558776, 4.1180000276985],
            [22.386999852774956, 4.1180000276985],
            [22.386999959674476, 4.1180000276985],
            [22.38842490780236, 4.118855004782053],
            [22.391999996020626, 4.121000074789022],
            [22.397804028139312, 4.121000077495037],
            [22.398000011788202, 4.121000077495037],
            [22.398000119586051, 4.121000077495037],
            [22.39819870295938, 4.121090342439313],
            [22.408999911188353, 4.125999951593938],
            [22.423433282097179, 4.125240300642649],
            [22.427409009949002, 4.125031051263194],
            [22.427999889403541, 4.124999951362536],
            [22.42799999989635, 4.124999945950542],
            [22.444999807266228, 4.123999942639664],
            [22.444999920453967, 4.123999936325678],
            [22.444895887459204, 4.124407964305943],
            [22.44521976695005, 4.124340040385954],
            [22.445221603106521, 4.124340665469335],
            [22.445221667785209, 4.124340651939396],
            [22.462919999730151, 4.117099956674733],
            [22.465531594500558, 4.116933153468349],
            [22.469339879976701, 4.116689917934083],
            [22.473251189639502, 4.118026516834886],
            [22.476890159752589, 4.119270048503637],
            [22.478532012393998, 4.118733673707791],
            [22.487910120329655, 4.115669943541314],
            [22.498249881065146, 4.114440865355443],
            [22.49892860856794, 4.11436018528264],
            [22.518355319780781, 4.12602404295946],
            [22.527057599975336, 4.129903086804661],
            [22.546883519805494, 4.136264757201836],
            [22.557634199596365, 4.134539255603007],
            [22.563865800145869, 4.131750295716698],
            [22.574246400090843, 4.126166772716806],
            [22.574942640250082, 4.126519282760611],
            [22.585329719743182, 4.121987688459322],
            [22.599907560410948, 4.121674363738158],
            [22.614864839573237, 4.126621207140871],
            [22.621475880413932, 4.129092370727217],
            [22.629106800156261, 4.128060009168227],
            [22.635334079809262, 4.124569777886068],
            [22.640849999758469, 4.118272727663773],
            [22.648459679734195, 4.113733894040577],
            [22.659248880182769, 4.1183196453582],
            [22.664130479946891, 4.121838306600078],
            [22.667610239845537, 4.123249792294028],
            [22.673505600085903, 4.122212929283161],
            [22.676546879717954, 4.108546265171165],
            [22.680267479740923, 4.09242678825483],
            [22.685451120053024, 4.088582973675599],
            [22.694102279819724, 4.084046845777624],
            [22.702744009970889, 4.093701551680953],
            [22.709830680008444, 4.101618825857368],
            [22.714349760148075, 4.102682141630654],
            [22.722215039568265, 4.083066738285657],
            [22.734316080368917, 4.075032938909716],
            [22.747499280269871, 4.073663971888195],
            [22.76086355987087, 4.044944972222665],
            [22.76007983997258, 4.030215183161848],
            [22.775695199759213, 4.029203187758875],
            [22.786310869051054, 4.033575726343735],
            [22.786831440063267, 4.033790146338977],
            [22.793397479799797, 4.02889773695838],
            [22.800287160075349, 4.020148568821879],
            [22.811734799576005, 4.018775192962263],
            [22.818287880216275, 4.011778655054778],
            [22.837045213591743, 3.987149295876053],
            [22.829380200089439, 3.98607507822659],
            [22.822075439762155, 3.981883033113083],
            [22.810052087063884, 3.96585707639934],
            [22.809580185875479, 3.965228041840623],
            [22.804422479925613, 3.94792912287082],
            [22.798536480130505, 3.936841106199369],
            [22.801861439644458, 3.919368025652247],
            [22.800537359746595, 3.911533087313406],
            [22.798778115263822, 3.90908895154674],
            [22.798040399887892, 3.908064034524275],
            [22.792196339738471, 3.908140094127369],
            [22.786352279589053, 3.908216152821243],
            [22.78503036552932, 3.906381184808014],
            [22.783853160180424, 3.904747086129437],
            [22.783281300755359, 3.89834312921684],
            [22.782709440432029, 3.89193912197601],
            [22.782171743038919, 3.885913993195904],
            [22.782146406954649, 3.88562999788545],
            [22.783085899214786, 3.884234892602481],
            [22.783998328828634, 3.882880062130878],
            [22.786460939805792, 3.881663324164129],
            [22.791355200425542, 3.879245142690362],
            [22.792228824615776, 3.878193756821757],
            [22.794588360202276, 3.875354105993283],
            [22.795763399713042, 3.870988154036313],
            [22.807873913248418, 3.862868649258071],
            [22.810722815069095, 3.860957978474653],
            [22.81397003976825, 3.855920049613003],
            [22.826310321692027, 3.859678807952452],
            [22.827029184125074, 3.855765108412386],
            [22.828889737910639, 3.851640266081005],
            [22.830160165928159, 3.85277217393611],
            [22.838000040093767, 3.85975992841226],
            [22.844180159990977, 3.861639941253308],
            [22.848999839780905, 3.859830058060775],
            [22.854570120381204, 3.849279970758863],
            [22.859610120079392, 3.848620024048266],
            [22.862086569603498, 3.847236812579295],
            [22.868579879937993, 3.84360998639948],
            [22.868828436590579, 3.843787674318968],
            [22.870860120336072, 3.845240081222115],
            [22.873602209774539, 3.845375375742737],
            [22.876130159713913, 3.845500105139095],
            [22.881830040260223, 3.850140059102386],
            [22.890340080085696, 3.845130029607804],
            [22.893580508131379, 3.839859193973817],
            [22.89515686191049, 3.837090856836136],
            [22.895669682258415, 3.836190258309411],
            [22.896371095815407, 3.835998137140282],
            [22.901410080417342, 3.834620039125354],
            [22.905116115156272, 3.837537679571432],
            [22.913489879654794, 3.844130034258312],
            [22.918079879989506, 3.843009916063848],
            [22.920653103222566, 3.844795839562082],
            [22.928799959568519, 3.850450071678049],
            [22.93553136208088, 3.852748320777072],
            [22.937029919959755, 3.85325996078477],
            [22.944102823315557, 3.85250385834025],
            [22.949189246151015, 3.851960114066629],
            [22.952910353722107, 3.854487424171287],
            [22.959451057374366, 3.858929735634465],
            [22.963129919872561, 3.857799891509491],
            [22.964359638936379, 3.858807463369011],
            [22.965400080274843, 3.859659948267775],
            [22.966169582537105, 3.859663886767669],
            [22.969299959774006, 3.859679908747376],
            [22.971468169476367, 3.858206993346927],
            [22.972980467087485, 3.857177993097739],
            [22.974622478730709, 3.851429706334051],
            [22.981509096649422, 3.850320039291067],
            [22.982291807739635, 3.848660005084088],
            [22.983130079630165, 3.846880063949829],
            [22.985608507244546, 3.84601025895112],
            [22.986348599562735, 3.845750523027425],
            [22.987069919786407, 3.840230023448025],
            [22.990060079888899, 3.838180029021678],
            [22.993040159995594, 3.838429984395617],
            [23.005559880397382, 3.850710093983468],
            [23.010613323383801, 3.85024806634902],
            [23.012669879682861, 3.850060038520141],
            [23.0131236861065, 3.850569606678618],
            [23.021539920256732, 3.860019946930287],
            [23.025219597526924, 3.860691633391548],
            [23.025430079984503, 3.860730054695503],
            [23.028367279011118, 3.859738938420734],
            [23.03277983961932, 3.858249980364531],
            [23.039636882303924, 3.861086828115993],
            [23.041239839690174, 3.861749990703163],
            [23.049489960073007, 3.861799980201054],
            [23.058470160151874, 3.854259945270264],
            [23.062820039912808, 3.855439928408156],
            [23.068969919822628, 3.860769974700945],
            [23.070195014359324, 3.859011831544009],
            [23.071520159659112, 3.857110100915691],
            [23.076032403619465, 3.855325550720309],
            [23.077259999964244, 3.854840046979012],
            [23.084513671304702, 3.857415360342618],
            [23.088470039563845, 3.858820009736993],
            [23.088970738943633, 3.858996627930054],
            [23.089148863186399, 3.859059459908215],
            [23.092570079877969, 3.861379922335689],
            [23.096911235200857, 3.867916648200598],
            [23.097790344504201, 3.869240002545473],
            [23.09891522837772, 3.869381339375435],
            [23.101687070018386, 3.869729608727275],
            [23.102020082680756, 3.86995395341809],
            [23.106478997255923, 3.872979225432639],
            [23.111295161938141, 3.872780239140946],
            [23.11517557494507, 3.86929634455322],
            [23.118426127004042, 3.866378824371039],
            [23.119210248449235, 3.866235803372006],
            [23.129439839798295, 3.864369953203116],
            [23.132469715317793, 3.865850220405268],
            [23.134700160303034, 3.866939918314845],
            [23.136893739327359, 3.866218200716418],
            [23.140900079967437, 3.864900058604341],
            [23.149473183322478, 3.876124116189128],
            [23.150440431728232, 3.87739001259427],
            [23.153649840048878, 3.877639928309185],
            [23.154482861286567, 3.876491209553027],
            [23.154810120239496, 3.876039925978484],
            [23.15318004001988, 3.87052008960603],
            [23.148749879618642, 3.855519948477683],
            [23.149450080449991, 3.852990049179434],
            [23.150377062771451, 3.852026471854521],
            [23.154519959911166, 3.847720014427181],
            [23.156186082336625, 3.847234660583568],
            [23.156820000076404, 3.847049995871657],
            [23.159652330675058, 3.847515516278346],
            [23.165520119822741, 3.848479942430291],
            [23.166325981396124, 3.847627507533816],
            [23.168979714339876, 3.844820402160037],
            [23.17299091486565, 3.844943833219254],
            [23.178369960311645, 3.845109890125632],
            [23.188640039628851, 3.851619990507554],
            [23.198029919986304, 3.85237002578885],
            [23.205356276711342, 3.861374358821263],
            [23.207810476762475, 3.864391719044432],
            [23.214685387836443, 3.865084153654126],
            [23.21514000004888, 3.865130046578873],
            [23.22638243738923, 3.862902013141086],
            [23.233738708013213, 3.858422432794343],
            [23.235046572421872, 3.857626589893791],
            [23.243387354376434, 3.85448272049968],
            [23.243954450035524, 3.853994480506198],
            [23.248689372880076, 3.849910470345276],
            [23.251889144972658, 3.851080313230781],
            [23.254650000217389, 3.849490003198005],
            [23.253980040271763, 3.846490029135322],
            [23.25536999991763, 3.844199985652856],
            [23.264368392677618, 3.839209743698916],
            [23.268930120335384, 3.836679933392867],
            [23.270062993825022, 3.836461389821432],
            [23.277120120069501, 3.835099992651867],
            [23.277847900078406, 3.834945589006822],
            [23.278110120106479, 3.834889956622782],
            [23.284062798251842, 3.836089820594338],
            [23.285201040073634, 3.836319252509086],
            [23.285512912682378, 3.836128938708652],
            [23.286711960567434, 3.835397244786247],
            [23.290637798683356, 3.833003361099067],
            [23.291181719604726, 3.832671690032526],
            [23.291501929477626, 3.832618142759959],
            [23.297830355838379, 3.831560435449832],
            [23.2989146753869, 3.832580396009224],
            [23.301028600794961, 3.834568844319053],
            [23.311580039645698, 3.831869970318701],
            [23.32095012023596, 3.836299963700244],
            [23.324159879797868, 3.835400120470411],
            [23.32341896911446, 3.833186344260166],
            [23.32168991970336, 3.828020073873712],
            [23.325140160063452, 3.824589877197001],
            [23.336581116996733, 3.826958545771388],
            [23.345570160091263, 3.816420107617231],
            [23.345583023067803, 3.816415889190727],
            [23.35798008031416, 3.812350029135799],
            [23.363506317414402, 3.808002863981158],
            [23.365599840285718, 3.801809959365411],
            [23.369745811460302, 3.797691928223775],
            [23.374100160339793, 3.799100066150241],
            [23.374365526267969, 3.799458762356744],
            [23.376830039876911, 3.802790042913132],
            [23.383469879807322, 3.80351998015641],
            [23.388030000379043, 3.807459903169564],
            [23.393061176824506, 3.807952264918308],
            [23.402819274820278, 3.824588844933183],
            [23.402310121395335, 3.833329940248182],
            [23.414000040121397, 3.832250121568352],
            [23.417983953422105, 3.830844958605728],
            [23.423640120150061, 3.828849972308524],
            [23.423664660327002, 3.828838154571537],
            [23.425504199823099, 3.82795227949816],
            [23.433308699231141, 3.822460972064962],
            [23.436097394164886, 3.822722042487037],
            [23.443840079599891, 3.82344995128756],
            [23.452059959995331, 3.828789910916508],
            [23.455730160039277, 3.828350054908771],
            [23.456739508889136, 3.824701794799322],
            [23.457830040287853, 3.820760087662951],
            [23.459962193411354, 3.818951314930793],
            [23.461059959841357, 3.818020043834658],
            [23.462501298629878, 3.817688149428359],
            [23.467010040058948, 3.816649929265725],
            [23.481679431630567, 3.813295065349018],
            [23.482620000072394, 3.813079958164697],
            [23.4911601532228, 3.814638087194383],
            [23.507342216104728, 3.81758973796605],
            [23.511099791683087, 3.816988109755487],
            [23.512399919800512, 3.816779945185323],
            [23.514435325266209, 3.816449083469417],
            [23.519724897611567, 3.81559155050076],
            [23.529110157933513, 3.818630207400339],
            [23.532121440123291, 3.812211020702072],
            [23.533071473214939, 3.806232063728091],
            [23.531744519606494, 3.798167992749799],
            [23.532108923896434, 3.794261415874328],
            [23.532474239976391, 3.790345050291588],
            [23.531483907562791, 3.783435522409008],
            [23.530493160127495, 3.776523042051053],
            [23.525590813771867, 3.768147285461356],
            [23.524139290782955, 3.765667314942594],
            [23.512701239899648, 3.754883119437669],
            [23.510965437852533, 3.753247004040727],
            [23.506471439573961, 3.749011081694968],
            [23.505586048351816, 3.74817536633632],
            [23.505224400093173, 3.747834008323874],
            [23.501300619119235, 3.745951754061632],
            [23.497455240408406, 3.744107105583934],
            [23.488582319835707, 3.733467101624476],
            [23.483558520355377, 3.730446037001458],
            [23.469120359629461, 3.731514147979127],
            [23.463644346438443, 3.72756893114836],
            [23.461925203648299, 3.724736274152131],
            [23.458877280076415, 3.719714142379514],
            [23.449308479568874, 3.710682068633098],
            [23.447903744433212, 3.709937675775014],
            [23.443598159700628, 3.707656068752567],
            [23.439212027528097, 3.708396310480371],
            [23.438324090480442, 3.708546136216935],
            [23.436797250043181, 3.708133060188787],
            [23.433977159888581, 3.70737010443231],
            [23.431760274972557, 3.705000563695073],
            [23.425098480216619, 3.697879995841603],
            [23.422392360220435, 3.690268014443627],
            [23.413862404745146, 3.689178940892671],
            [23.407284240447186, 3.688339064517523],
            [23.386537799877427, 3.696645299552212],
            [23.384630164489522, 3.697534267302664],
            [23.351834879728656, 3.712816897539555],
            [23.340682079880644, 3.724888747523285],
            [23.323238999732126, 3.748666502414031],
            [23.30238204033126, 3.764872379491798],
            [23.285246399605576, 3.77768443071019],
            [23.269545719629921, 3.78029116648032],
            [23.262442560117012, 3.781407230985326],
            [23.255357760371879, 3.785548312361586],
            [23.248275480401105, 3.790067565826852],
            [23.2430500801064, 3.792322867586809],
            [23.236704371956222, 3.78561414475865],
            [23.240619360220133, 3.782185023152436],
            [23.246414279828564, 3.77140107937564],
            [23.210669879888851, 3.75305916142659],
            [23.19075648031972, 3.731010036992124],
            [23.186866319693621, 3.72983509683469],
            [23.180940360139761, 3.724965003149931],
            [23.172546232630332, 3.720613360876959],
            [23.167009440325529, 3.717742992569173],
            [23.156265240082824, 3.713994019349746],
            [23.143036258441729, 3.704474931852872],
            [23.140312186512912, 3.700314128634334],
            [23.12328275989147, 3.696200520684115],
            [23.118716880220457, 3.691896961890359],
            [23.108900001862377, 3.676381466923954],
            [23.108487480212577, 3.67572947374738],
            [23.102277120327944, 3.660625928623056],
            [23.099025599885099, 3.64956240995939],
            [23.091226200212912, 3.639328473092298],
            [23.084253720421028, 3.635845728341893],
            [23.07568284039634, 3.634531083414429],
            [23.066848080256907, 3.634298336306458],
            [23.061494880239966, 3.634591159169245],
            [23.056675200450073, 3.63255920398964],
            [23.046726959651373, 3.611562721373755],
            [23.036809680187233, 3.599424387866511],
            [23.023613160067253, 3.590621866654962],
            [22.995052919831299, 3.580777051432775],
            [22.965410879821182, 3.575365963193849],
            [22.933559519608067, 3.565535191431503],
            [22.898616120457742, 3.562248590534151],
            [22.882101468918279, 3.562026075531803],
            [22.866445788250125, 3.558875994061602],
            [22.841803070425495, 3.554009638542351],
            [22.828736506882709, 3.545585336670332],
            [22.819692588402457, 3.527787582191845],
            [22.806907190357098, 3.517023028913654],
            [22.786871027919521, 3.503949972545408],
            [22.773237109104553, 3.499037093891521],
            [22.760186028924011, 3.494998655298132],
            [22.746840830437989, 3.489792141133568],
            [22.737550307344236, 3.484275815818976],
            [22.728833269626161, 3.477002938532658],
            [22.720981309526703, 3.46855670042332],
            [22.713708949635098, 3.460107867309036],
            [22.705280629551048, 3.45254138152098],
            [22.697736829323294, 3.449356922192364],
            [22.68759059085281, 3.447645501309006],
            [22.681497590470176, 3.445039595302668],
            [22.673650669919468, 3.438055341917309],
            [22.665796550270052, 3.429024415685672],
            [22.659675830572681, 3.418524086705439],
            [22.65471358994381, 3.408018784450382],
            [22.644242990485509, 3.396367319376597],
            [22.631455431093567, 3.385017972978466],
            [22.622149790251896, 3.375115919926006],
            [22.616624870081868, 3.369291444432826],
            [22.613114149746959, 3.35965713337095],
            [22.612187509683594, 3.343286967301688],
            [22.615918549926793, 3.33332979158915],
            [22.619868109854401, 3.323962313201829],
            [22.623091190533671, 3.319713155311034],
            [22.624968230201297, 3.314917356950128],
            [22.624152109867364, 3.307959502285466],
            [22.623069230318226, 3.302603341988314],
            [22.621177070207718, 3.295903422763953],
            [22.615787509981331, 3.288905667538806],
            [22.611473269980973, 3.281382635195579],
            [22.607160830204467, 3.275196287156772],
            [22.603654790092168, 3.268482325917026],
            [22.59421307065465, 3.248884488846869],
            [22.588009551440877, 3.236532943034467],
            [22.582615671216317, 3.226327084961008],
            [22.578841070766696, 3.220145612764155],
            [22.570479711103925, 3.203497810421327],
            [22.566163670879718, 3.194638004548586],
            [22.559147270656947, 3.178002018436015],
            [22.555909430657604, 3.170488410172578],
            [22.555631151447184, 3.163267894159514],
            [22.557871431188179, 3.144759105886921],
            [22.557346296734309, 3.124467926009756],
            [22.557329270964754, 3.123810055286155],
            [22.555076390555271, 3.118500062740494],
            [22.551208191042946, 3.115021009464329],
            [22.549877271372516, 3.108797109920287],
            [22.543300430292984, 3.099775053396029],
            [22.541721311499444, 3.098749396619151],
            [22.540792309765209, 3.098145998462019],
            [22.533018473451055, 3.09694201494706],
            [22.527778497092545, 3.091914259188767],
            [22.527597847685541, 3.091740942300807],
            [22.521419271093979, 3.085813147386466],
            [22.518744190585803, 3.079133267617946],
            [22.51624319100328, 3.0728880420919],
            [22.514246271160999, 3.063898074773359],
            [22.51631411119833, 3.056437927598056],
            [22.518003231393379, 3.050344050805442],
            [22.512555735221056, 3.041164109146598],
            [22.508951390670624, 3.035090144459637],
            [22.508854191160253, 3.016216070186028],
            [22.486454119239038, 2.978543105085356],
            [22.485691534902791, 2.978752025550624],
            [22.480720193441766, 2.980113989947766],
            [22.475879272088637, 2.984914047186374],
            [22.47455975293747, 2.989652601330963],
            [22.473768230272658, 2.992495043634549],
            [22.470345114542557, 2.994895973175838],
            [22.468246190999757, 2.996368129111558],
            [22.46227018989465, 2.99977900437023],
            [22.45356565133546, 3.000638042162548],
            [22.434091191970328, 3.003263124679289],
            [22.416208191555807, 3.007279980528999],
            [22.411797621614269, 3.008793730172115],
            [22.401750231961028, 3.012242083709363],
            [22.372360193642638, 3.024922073194321],
            [22.364759340512858, 3.031542971048858],
            [22.357987694374096, 3.031803842136792],
            [22.354685272692318, 3.031930988615285],
            [22.341905272623489, 3.02631511333432],
            [22.334067528363395, 3.020579442658395],
            [22.31776619166962, 3.00865000714239],
            [22.316230427368328, 3.008804180013219],
            [22.31135157555066, 3.009293958739477],
            [22.303566353988593, 3.009698038867452],
            [22.283298351647584, 2.995282105628867],
            [22.280242523799505, 2.995169802064212],
            [22.275516233764826, 2.994996107258076],
            [22.269243774242938, 2.992736919857567],
            [22.266384472626196, 2.99170706772299],
            [22.259521433687034, 2.991196987886188],
            [22.252220272909085, 2.987922155580121],
            [22.242301598361355, 2.987184360244383],
            [22.238493474581951, 2.986901094394159],
            [22.230980272769397, 2.981322061256062],
            [22.224125514500546, 2.9796611405516],
            [22.221393472718514, 2.977570052808749],
            [22.212236154510066, 2.977733116930648],
            [22.204506232338588, 2.970542061116189],
            [22.19194223397643, 2.966997000083358],
            [22.185796313840417, 2.962349131351178],
            [22.164558541522602, 2.961246822661038],
            [22.159940490394852, 2.961007131367703],
            [22.153804280148702, 2.954977165151948],
            [22.149696234048779, 2.953566129118967],
            [22.145157177173829, 2.948239098524644],
            [22.14478684579964, 2.948251539504908],
            [22.133938313423208, 2.948615995587762],
            [22.116573366941466, 2.944344272712523],
            [22.108562314306884, 2.944285017308278],
            [22.104531208911023, 2.941811508432282],
            [22.10058810337873, 2.939391985124732],
            [22.10026882326212, 2.939220250333841],
            [22.087137239659093, 2.932157031012699],
            [22.076372520098648, 2.933227099584651],
            [22.06906740044526, 2.930641112985082],
            [22.063167494729548, 2.923691279573439],
            [22.060203480093413, 2.922288049364713],
            [22.053813095130891, 2.922721968371199],
            [22.05104220031453, 2.922910117361134],
            [22.047851159846505, 2.921275028512617],
            [22.046115417088231, 2.920873340684326],
            [22.043737439987247, 2.920323026434253],
            [22.040095036513154, 2.91737797512745],
            [22.038278399565222, 2.915909136947386],
            [22.030048440072317, 2.914466096277537],
            [22.012487279972962, 2.906278149592542],
            [22.002439319889497, 2.90321006242161],
            [21.996029519638743, 2.903392041390899],
            [21.990059142885631, 2.905877994475996],
            [21.982513316956922, 2.904900076566214],
            [21.980465079955714, 2.903273118854963],
            [21.969753830815939, 2.907741593103039],
            [21.966919195140264, 2.908924132234275],
            [21.965530900970915, 2.908774091825486],
            [21.964632396142278, 2.908676915037812],
            [21.955091395797876, 2.899167084930287],
            [21.949604275836677, 2.898435024018511],
            [21.948472106626234, 2.897568105307554],
            [21.946872235851309, 2.896343058631595],
            [21.939295315637334, 2.89950710494246],
            [21.934035862905123, 2.900338054192019],
            [21.917066395235647, 2.903019082197417],
            [21.90997943594056, 2.902044024001637],
            [21.901081228690963, 2.898523080312349],
            [21.8939632200264, 2.901460104301031],
            [21.889385275082837, 2.901425005253433],
            [21.873178435767031, 2.895776056484298],
            [21.858357446304709, 2.902262889604552],
            [21.856643275689667, 2.903013142797723],
            [21.846336475938575, 2.903854100423529],
            [21.841505228542754, 2.907038110279388],
            [21.836466355331925, 2.907459123244065],
            [21.831765078886356, 2.90718630028589],
            [21.827316235323821, 2.906928126103026],
            [21.821538548097475, 2.911290539829474],
            [21.818567155597876, 2.913534067708794],
            [21.810322120577883, 2.914160277199191],
            [21.802597039427464, 2.918477614585418],
            [21.798137156468396, 2.920970114490111],
            [21.794677196336941, 2.924395086019052],
            [21.792875109401667, 2.924762048174192],
            [21.790321196353982, 2.925282106556449],
            [21.787871677423759, 2.926831178421596],
            [21.786709316734928, 2.92756625254009],
            [21.784570248380376, 2.928919066396136],
            [21.783960901360203, 2.928340801143249],
            [21.781391396254133, 2.92590201247621],
            [21.774373916256383, 2.926938787987359],
            [21.76816069164434, 2.927856828677662],
            [21.748850276328167, 2.930710051114571],
            [21.745626476098391, 2.93321611976169],
            [21.74177103715467, 2.932510410536225],
            [21.740370476490121, 2.932254047686937],
            [21.723949436589823, 2.924759037889538],
            [21.723371952812798, 2.92481124054091],
            [21.721958276745092, 2.924939033567532],
            [21.711906439532893, 2.925844118068653],
            [21.705166436550019, 2.926450998996607],
            [21.698547476161782, 2.924097012609272],
            [21.690298436452224, 2.925182028408883],
            [21.685768196541787, 2.919162046610485],
            [21.683258276688523, 2.918221021786263],
            [21.675447356122831, 2.921842018570206],
            [21.672487404566695, 2.919977075282044],
            [21.663555476357956, 2.920596081895657],
            [21.653442356077068, 2.925809134494629],
            [21.647077196706039, 2.920464139162612],
            [21.640413239705222, 2.923632982233419],
            [21.633781320220685, 2.922889057074642],
            [21.629236320091806, 2.918940110810414],
            [21.627004320122822, 2.911788087191859],
            [21.621467160407043, 2.917267037311079],
            [21.616207200126706, 2.916764124791225],
            [21.615836540867441, 2.915458989587251],
            [21.615093360141298, 2.912842155644642],
            [21.614061026098277, 2.91294920839987],
            [21.613031280101556, 2.913055992898783],
            [21.610706399722076, 2.917639991726592],
            [21.608185280572137, 2.918080060506821],
            [21.606622725814109, 2.917120269353818],
            [21.604768382980442, 2.915981248875486],
            [21.601730544794236, 2.916372823734543],
            [21.599727479577076, 2.916631106815273],
            [21.592201319566556, 2.913348129931668],
            [21.588508439756655, 2.917001001463865],
            [21.582554399765293, 2.917643051705529],
            [21.57933239975933, 2.91968907746096],
            [21.578798150100315, 2.920949375698412],
            [21.576999315066363, 2.925192830386129],
            [21.576183299835321, 2.927028065823106],
            [21.575367361859367, 2.928863116676642],
            [21.573753480060947, 2.930231084158577],
            [21.571241399759401, 2.929520103017727],
            [21.56876331979306, 2.924666292578868],
            [21.563596662131385, 2.928069369691144],
            [21.563240376814978, 2.928304041107302],
            [21.556406160321718, 2.924336047208557],
            [21.543083279580621, 2.930212004666072],
            [21.533735160104104, 2.9257630554161],
            [21.529434286136858, 2.926699022379384],
            [21.524563277509916, 2.927759164945222],
            [21.518985555265829, 2.932458389785571],
            [21.512117173147367, 2.938244968392922],
            [21.510717014029755, 2.938153752369759],
            [21.499992360229324, 2.937454986226705],
            [21.492822374144101, 2.94660297246946],
            [21.488695200216849, 2.947490144932247],
            [21.487872145787222, 2.94886413410083],
            [21.485677319901292, 2.952528118782856],
            [21.482471241635423, 2.952732043471283],
            [21.481417584282497, 2.95075074217107],
            [21.479767042237327, 2.947647049497691],
            [21.475885320385029, 2.946464008084049],
            [21.471296399825295, 2.947807110573777],
            [21.468530160078725, 2.950085990528287],
            [21.465047645945415, 2.955814864400739],
            [21.461569200282021, 2.961537015993129],
            [21.457163519870587, 2.968636160001207],
            [21.450975480425829, 2.969505145251144],
            [21.449341440432445, 2.973405134115222],
            [21.442880344582328, 2.979565933435577],
            [21.441462816538738, 2.979643049041729],
            [21.439216439931908, 2.97976499422969],
            [21.439190526230902, 2.980112920641733],
            [21.438959399589766, 2.983216059498152],
            [21.435848607422713, 2.989494755435095],
            [21.434303168265814, 2.992614175965],
            [21.434562360073041, 2.998305118200894],
            [21.434632120543071, 2.999849333443811],
            [21.434690157100317, 3.001134028985537],
            [21.421134833686164, 3.009045325578631],
            [21.418359637736234, 3.010664991555538],
            [21.414245400447349, 3.010286041587765],
            [21.413198309779141, 3.010189484318443],
            [21.410125200141636, 3.009906099876924],
            [21.409170354775004, 3.010495649501811],
            [21.408285240233962, 3.011042145115366],
            [21.408113666506267, 3.011867521574742],
            [21.407631479607861, 3.01418714326392],
            [21.406614479806723, 3.019084062375799],
            [21.405374760697182, 3.019750746793203],
            [21.401556479666866, 3.021804103654989],
            [21.397327199631128, 3.020264013678297],
            [21.393797399977899, 3.018978054078584],
            [21.380455439918482, 3.022502065965033],
            [21.376945020519166, 3.023428928713795],
            [21.375213480079783, 3.023886109929168],
            [21.373862444435215, 3.024407053832121],
            [21.368784240286306, 3.026365147305169],
            [21.365555399609445, 3.029329041120649],
            [21.361221359841899, 3.034073089910656],
            [21.359085479608311, 3.036411000569697],
            [21.355367400258032, 3.043055030784368],
            [21.352952514076971, 3.043680529871783],
            [21.351927239893769, 3.04394609398541],
            [21.348053280383823, 3.041611979250928],
            [21.347036367719273, 3.041964620484598],
            [21.337034399581736, 3.04543305618966],
            [21.335926569325583, 3.046526930737248],
            [21.335186159902118, 3.047258011544292],
            [21.333503159929094, 3.056911144819891],
            [21.329826480337015, 3.058722042293347],
            [21.328018200416185, 3.055945043188291],
            [21.320913239781127, 3.056806039739839],
            [21.319730096568179, 3.058148620057996],
            [21.314672279684665, 3.063887996629813],
            [21.309404396263528, 3.064304184143146],
            [21.309120186375605, 3.070977048289708],
            [21.307983698065279, 3.070609843236638],
            [21.305465280149406, 3.069796129221034],
            [21.302696160404011, 3.072534038519934],
            [21.29792220037049, 3.068581139257368],
            [21.294491400451452, 3.068322159178817],
            [21.289818240375968, 3.079560998165094],
            [21.284821797290945, 3.084387243425183],
            [21.27966119966419, 3.08937202815919],
            [21.274400159608906, 3.088867035875038],
            [21.273958440017378, 3.094938079664519],
            [21.273926959456563, 3.09537738515371],
            [21.273882480273581, 3.095998087903204],
            [21.273871627726646, 3.097231991722614],
            [21.273866281852385, 3.097839869437792],
            [21.270466113586238, 3.101200796420393],
            [21.268787400373764, 3.102860041968472],
            [21.264408360400381, 3.10627507455948],
            [21.254074199762364, 3.110101136136865],
            [21.250110317994164, 3.118583942651923],
            [21.249106067981863, 3.118709644663302],
            [21.246671160149727, 3.119014041895568],
            [21.246242342162351, 3.11835551934848],
            [21.245315429011168, 3.116931906551032],
            [21.245794199616544, 3.114634083555156],
            [21.243978360372605, 3.112777031876408],
            [21.24327178329936, 3.113562730705923],
            [21.240280440115622, 3.11688903236171],
            [21.237727116362738, 3.116989340931162],
            [21.235470480097089, 3.117077994294525],
            [21.22192728034603, 3.121336107332168],
            [21.213544814765655, 3.12853828237732],
            [21.211317360271984, 3.130452092909233],
            [21.211290416203344, 3.133667908070058],
            [21.211263359845297, 3.136897030607104],
            [21.209817075831122, 3.139744713105144],
            [21.208004280079347, 3.143314034662393],
            [21.205238399658885, 3.145362148226394],
            [21.202567473858913, 3.14587525076247],
            [21.197212199631977, 3.14690403399918],
            [21.192893251561234, 3.146365956231448],
            [21.191265359637651, 3.146163145106218],
            [21.187706554282208, 3.14835671325811],
            [21.185741159916496, 3.149568137230405],
            [21.181514399655118, 3.161961055538566],
            [21.170284200063922, 3.163246119865366],
            [21.168897839967393, 3.154954987801079],
            [21.167475119661447, 3.148718374539844],
            [21.16620467996583, 3.140965924820273],
            [21.16583279989608, 3.132070304525198],
            [21.165272279904876, 3.122986726822656],
            [21.165277320351958, 3.114466716802344],
            [21.165458760276405, 3.1055665498513],
            [21.164709959689855, 3.096294853932293],
            [21.160652399807208, 3.087617153753029],
            [21.156190200093022, 3.077238660125085],
            [21.154598999857217, 3.071760160549502],
            [21.154218840015485, 3.062485466693187],
            [21.154438440373237, 3.037868637598654],
            [21.151655279959972, 3.002103132448589],
            [21.151032120443997, 2.981278863687354],
            [21.148469279939025, 2.947214036230331],
            [21.147901920175226, 2.929039335523584],
            [21.14704044030935, 2.923175791422504],
            [21.144810960114725, 2.922435826390362],
            [21.138261840146559, 2.926842850139318],
            [21.131528040030712, 2.931251295979549],
            [21.117216062957816, 2.945278183666919],
            [21.106549440324716, 2.954171619265509],
            [21.094778160285042, 2.964679277749733],
            [21.076100640425924, 2.980164384606264],
            [21.051976679914933, 2.999858017784532],
            [21.045659760074674, 3.006535211975311],
            [21.043601639808699, 3.01393624896505],
            [21.043227960413429, 3.022459950147398],
            [21.042921599867242, 3.034202134402851],
            [21.04240715985685, 3.044809619855182],
            [21.040545599958204, 3.052776772320797],
            [21.039522479935041, 3.056761046306057],
            [21.036289680382708, 3.060952094769867],
            [21.033041039938695, 3.064385801718829],
            [21.022717679745345, 3.073555555161569],
            [21.022108455794374, 3.074147301859153],
            [21.013677359916095, 3.082336494725166],
            [21.002812559948158, 3.092078210669468],
            [20.988318240143933, 3.104688676907082],
            [20.982530879858608, 3.11022495186351],
            [20.979602999954782, 3.111383925335486],
            [20.974453919628282, 3.112181889103154],
            [20.96648963957557, 3.11072975411658],
            [20.961076319808253, 3.107743052955387],
            [20.956749480037708, 3.103801083964305],
            [20.952984240033377, 3.100233251813792],
            [20.947190039975453, 3.096681423632229],
            [20.943131400317828, 3.096713457763206],
            [20.938371119829441, 3.098454999934184],
            [20.930881409859914, 3.101999041605295],
            [20.924848440294411, 3.111152131286196],
            [20.915401320185406, 3.117974032624922],
            [20.907545400312177, 3.125958986611796],
            [20.897497440228715, 3.148886995410723],
            [20.895879240228748, 3.150613153331667],
            [20.893805174866465, 3.152824784272474],
            [20.891718310308033, 3.15505013755576],
            [20.888670066935912, 3.163079282921935],
            [20.884052160436902, 3.1674110054783],
            [20.867750280262381, 3.17255914378084],
            [20.854637280107607, 3.179577146215238],
            [20.852224431305633, 3.180065467964789],
            [20.850279479900834, 3.180459094482551],
            [20.841929658199547, 3.189788066966674],
            [20.841491159966647, 3.190277983835045],
            [20.838928320359972, 3.195088059474244],
            [20.827398239770723, 3.204192051654883],
            [20.826353765894922, 3.20606631911156],
            [20.823442200294952, 3.211290992329616],
            [20.820600360130722, 3.221854014669755],
            [20.812286160223739, 3.229605127583771],
            [20.81201148056266, 3.234667105079747],
            [20.805980400154223, 3.243359043776393],
            [20.800220399857526, 3.247450002814824],
            [20.79655397722934, 3.24741734680532],
            [20.794725360348789, 3.247401059430577],
            [20.790639900590051, 3.24333556201575],
            [20.786554439932985, 3.239270047132783],
            [20.785207799745084, 3.236265728364291],
            [20.782514520267576, 3.230257063756599],
            [20.779879169549456, 3.228980550200111],
            [20.7786394243888, 3.228380126308436],
            [20.772400320211709, 3.234769143768354],
            [20.770925244294357, 3.234458229609824],
            [20.770113240041059, 3.234287076763013],
            [20.76721416012521, 3.225744064117138],
            [20.766480895901495, 3.215096684254243],
            [20.766405239788281, 3.213998113134682],
            [20.76368147957486, 3.211211095625548],
            [20.759371626946358, 3.209973176262179],
            [20.750437440372984, 3.207407005279014],
            [20.743654320053096, 3.197908052691667],
            [20.736485382301822, 3.191206840010842],
            [20.733431184895974, 3.18835188665712],
            [20.706495479579416, 3.169685273310071],
            [20.700990360074879, 3.165114777735642],
            [20.694216239975809, 3.157097555906397],
            [20.677167000112455, 3.140307452372049],
            [20.664326112233688, 3.128223479017468],
            [20.647093679832746, 3.112006603390678],
            [20.629687680342517, 3.093404394754873],
            [20.620726559582003, 3.08120790449109],
            [20.606833079752199, 3.061553025446889],
            [20.592923759030683, 3.044247913833397],
            [20.578939825139983, 3.02921917493919],
            [20.572220519341236, 3.021997762467286],
            [20.554153961673137, 3.001786539353634],
            [20.551523038751078, 2.998843269802761],
            [20.488441308409335, 2.933974964630185],
            [20.444712839429556, 2.883394097338341],
            [20.411000279542165, 2.847276871593104],
            [20.394712799361656, 2.826872187898341],
            [20.382311211911333, 2.816828073981628],
            [20.378392130922975, 2.819834092213843],
            [20.371936675594537, 2.824785485302765],
            [20.337049078891376, 2.841890644996789],
            [20.32352423890806, 2.850445736251723],
            [20.301828120081172, 2.867062691478145],
            [20.288374200292942, 2.875076140024881],
            [20.278434630931692, 2.883093320497119],
            [20.275686360185734, 2.885310044530173],
            [20.261808360124913, 2.90036606589853],
            [20.231192879621783, 2.918849931851607],
            [20.227068983646969, 2.922420334184873],
            [20.222100359589696, 2.926722073189065],
            [20.216876400192699, 2.935534088292651],
            [20.211834959596803, 2.944709439071823],
            [20.208601798921737, 2.951797172484102],
            [20.209749120016095, 2.953532830804435],
            [20.209866480416391, 2.958580315928799],
            [20.208547486779658, 2.963832961173249],
            [20.207313359682782, 2.967817390467081],
            [20.20470012009709, 2.974443664684598],
            [20.199744720139083, 2.983517176621742],
            [20.195310599964074, 2.991195908656748],
            [20.185964520561566, 3.002739795337806],
            [20.181062957536874, 3.009179235407777],
            [20.180399399884262, 3.010050985035034],
            [20.179615289218837, 3.019941184630524],
            [20.175313320205262, 3.027838096398926],
            [20.174560920069379, 3.035151877471503],
            [20.175375600403932, 3.038455363237855],
            [20.178308519856508, 3.04557865718651],
            [20.181979440349291, 3.052698663175849],
            [20.187214919741496, 3.063640713634849],
            [20.191668120133158, 3.072671536314368],
            [20.198038680175674, 3.084826733044852],
            [20.203787159578887, 3.094025823811343],
            [20.210474520387788, 3.103916802111463],
            [20.2158216001827, 3.111724958359083],
            [20.22169824043085, 3.118486569026743],
            [20.223680400054729, 3.124395293529355],
            [20.224916639989178, 3.129959178348217],
            [20.225587320383674, 3.135003307465501],
            [20.228471640081082, 3.140037693016659],
            [20.233020239759263, 3.145238696996836],
            [20.24020440036135, 3.15269040514288],
            [20.247953760278921, 3.160661592558265],
            [20.25732744041855, 3.16705919316373],
            [20.266729200097288, 3.174674860611014],
            [20.277417959913926, 3.182110698872456],
            [20.284405560148684, 3.189040819898767],
            [20.285023680115909, 3.191822680400041],
            [20.2855136401365, 3.197041415444736],
            [20.285683560065738, 3.2043498660284],
            [20.285597520326142, 3.216532299245915],
            [20.285799839792759, 3.225232841162433],
            [20.285697599835306, 3.236719003403555],
            [20.283497279853133, 3.245255804260137],
            [20.28049056020668, 3.25083792074388],
            [20.278422359944908, 3.257112050775106],
            [20.278166400276071, 3.26198568413389],
            [20.278472399699492, 3.26720495304802],
            [20.279523960384559, 3.272768772175247],
            [20.280391200248051, 3.278333460156428],
            [20.281724639692875, 3.288072396892878],
            [20.282259239694863, 3.295204746542254],
            [20.281153680379738, 3.303214206570599],
            [20.27748600011018, 3.312105072702875],
            [20.272674600092234, 3.319434987427817],
            [20.261820240344559, 3.328705889265866],
            [20.249498160085079, 3.338331153083391],
            [20.23021005802228, 3.34982169777296],
            [20.227436279613833, 3.3525571013002],
            [20.220144480179474, 3.372282040905823],
            [20.215059480275453, 3.377067119594325],
            [20.211336041576189, 3.383015044405741],
            [20.209084920068058, 3.401499329008081],
            [20.210197320054046, 3.409672164654777],
            [20.211405120224924, 3.41401645672949],
            [20.212793639871379, 3.418186217708453],
            [20.216091240295032, 3.425131040672322],
            [20.219974919576341, 3.433465408082889],
            [20.222562959621687, 3.441631311747806],
            [20.223286200443425, 3.448935408347957],
            [20.222537760081309, 3.45642024946339],
            [20.22028919967007, 3.462867545428324],
            [20.217278160025408, 3.46827443893182],
            [20.213509319573379, 3.472814909254932],
            [20.20916663891115, 3.476487711588211],
            [20.201675399110666, 3.481442084902759],
            [20.180717279527329, 3.493207087392427],
            [20.154197159115707, 3.511362054148984],
            [20.152606843720442, 3.512559647460506],
            [20.138506198911379, 3.523178123246717],
            [20.126714399554004, 3.534341053509422],
            [20.116485358872232, 3.549663124252922],
            [20.115200664709675, 3.552861361074249],
            [20.111788439255786, 3.56135602006799],
            [20.111440448982712, 3.565248356453639],
            [20.111274359469828, 3.567106086295638],
            [20.114547479005349, 3.583482043661798],
            [20.116798198966546, 3.587647981325099],
            [20.125388596687444, 3.596221485043989],
            [20.125417319420336, 3.596250151406717],
            [20.132978586490488, 3.608546818406113],
            [20.138946479401824, 3.618252107752397],
            [20.142583229777816, 3.62527925330211],
            [20.149963137771891, 3.639538976250428],
            [20.134004582020857, 3.655034924464867],
            [20.133366454775643, 3.661059639182681],
            [20.131983359156866, 3.674120999895599],
            [20.137344465246624, 3.688216096479283],
            [20.136915452324811, 3.689870131884379],
            [20.134962359488583, 3.697400146125532],
            [20.137121269831127, 3.710773103995475],
            [20.130966359355728, 3.730970110907904],
            [20.141264158885999, 3.732222024652128],
            [20.178681397954534, 3.753516353518518],
            [20.192302439419912, 3.761268022673687],
            [20.218324319140663, 3.771421041030914],
            [20.216737874585991, 3.775446725557487],
            [20.213625239075963, 3.783345145318642],
            [20.202720479349274, 3.797281056961729],
            [20.196960479052549, 3.800447011308212],
            [20.183645159431187, 3.803079032726755],
            [20.176799456180376, 3.805396673104305],
            [20.16778333606657, 3.808449106528103],
            [20.159630642467874, 3.808902472856056],
            [20.146690439546241, 3.809622007134619],
            [20.138974403532433, 3.812668183877504],
            [20.135879278882257, 3.813890090149787],
            [20.124092158849162, 3.824133115675041],
            [20.121796213204995, 3.824570613385423],
            [20.120649478710508, 3.824789125745732],
            [20.116077478817466, 3.823593094156174],
            [20.111761798817728, 3.826207421318173],
            [20.108382119326549, 3.83161371840945],
            [20.105744039526616, 3.837190634839692],
            [20.09993399947534, 3.841216536592069],
            [20.093533558771512, 3.84367975737566],
            [20.086547758760599, 3.844754199902375],
            [20.076445799148782, 3.846712109845841],
            [20.065995358783773, 3.849541252137436],
            [20.058303959066627, 3.852010203400936],
            [20.054138971455789, 3.853632158548399],
            [20.050624438670798, 3.855000806354669],
            [20.043145799538802, 3.858686044653916],
            [20.030398199007315, 3.865872876762595],
            [20.02164407883436, 3.870259533884888],
            [20.019254039155715, 3.870617910201468],
            [20.011514038785073, 3.871000202163865],
            [20.003786278858477, 3.871904143271849],
            [19.996082638697278, 3.873851379936441],
            [19.990252079328268, 3.877007516034817],
            [19.980780479229431, 3.882266757520664],
            [19.973362319173919, 3.888560073355046],
            [19.966671123457083, 3.892775271087879],
            [19.958854679150697, 3.899406352372512],
            [19.947434758964746, 3.908152140814409],
            [19.935940319034405, 3.917786982889443],
            [19.91069227504881, 3.944465263088135],
            [19.906327799461138, 3.949373279262202],
            [19.901299679084264, 3.955307744894978],
            [19.893772439298772, 3.963170134934623],
            [19.889578438799209, 3.970034044025851],
            [19.887876375677543, 3.979684968186523],
            [19.888313650405031, 3.982095959339025],
            [19.891348198960671, 3.998826016308149],
            [19.901020319200573, 4.017110023855396],
            [19.90287215932786, 4.037847085607862],
            [19.906944479428947, 4.043182057491403],
            [19.915611479189067, 4.047414053583002],
            [19.917183238983785, 4.050652036509382],
            [19.916912165160284, 4.054794014602615],
            [19.917399966529249, 4.055444237603314],
            [19.919174291030661, 4.05780924149784],
            [19.913849280147343, 4.063050130722071],
            [19.908531624669557, 4.064659725493926],
            [19.906492319617222, 4.065276999783496],
            [19.905484328121744, 4.066875691339015],
            [19.903463280429222, 4.070081097635857],
            [19.900481220435658, 4.070280556213814],
            [19.897499160442059, 4.070480013839653],
            [19.893800183766324, 4.073666109756521],
            [19.880056439619644, 4.072836119379366],
            [19.876674122674817, 4.074261814365039],
            [19.869926399570392, 4.077106068652802],
            [19.863054360410409, 4.076806029548287],
            [19.859240365242311, 4.079703764315543],
            [19.857971159831909, 4.080668058587836],
            [19.853616239623893, 4.080624014377557],
            [19.850003282924821, 4.079185572260458],
            [19.847681279849184, 4.078261101645943],
            [19.843219263391337, 4.078752693801455],
            [19.830471302635416, 4.080156967173239],
            [19.828203403292729, 4.077832003171347],
            [19.824987239641146, 4.078490130932441],
            [19.820343197557278, 4.084427063747959],
            [19.815525360211993, 4.084838014088034],
            [19.813253399585896, 4.082743151779537],
            [19.808416439803199, 4.084996031886979],
            [19.807342379913528, 4.084985067575456],
            [19.807059854366763, 4.084982158492338],
            [19.79306244035692, 4.084838014088034],
            [19.788765480349362, 4.079039152738433],
            [19.787469526703052, 4.078660321337439],
            [19.783052279583988, 4.077369074886533],
            [19.778747400028887, 4.072491134649651],
            [19.776917340453995, 4.072126645517717],
            [19.775087279980774, 4.071762156218525],
            [19.771148336343163, 4.075865819869479],
            [19.765197464709829, 4.075114028923474],
            [19.763564635645427, 4.077359974104656],
            [19.761709319936308, 4.079912120973463],
            [19.758228962658027, 4.079547703806043],
            [19.754383319842454, 4.079145037836239],
            [19.751220198115149, 4.075902360176768],
            [19.749620160253599, 4.074262075058466],
            [19.740032280427737, 4.070480013839653],
            [19.739916645691132, 4.070044869172846],
            [19.738928160213728, 4.066325084318399],
            [19.730961337030468, 4.060948035880407],
            [19.728193320416278, 4.06276105273318],
            [19.724734804775792, 4.06331952733268],
            [19.720155337187776, 4.064059011737973],
            [19.718672621997282, 4.062191379480174],
            [19.716219359787249, 4.059101005032843],
            [19.715179319995723, 4.057792056121547],
            [19.710735462981305, 4.056851703085193],
            [19.703743199591916, 4.055372086950955],
            [19.699797779999461, 4.060598234357887],
            [19.698398280245286, 4.062452019116243],
            [19.69693919972989, 4.07049403632749],
            [19.695716212640818, 4.072445752237072],
            [19.695076199831828, 4.073467121096994],
            [19.686529439572507, 4.079824033368475],
            [19.681482239877315, 4.080232113979632],
            [19.677385439786423, 4.077427141643005],
            [19.67589539973309, 4.066362117590596],
            [19.67496606292724, 4.066352276089326],
            [19.673145360204348, 4.066332994504235],
            [19.667129400238785, 4.07179505421146],
            [19.664630569189359, 4.072103491546656],
            [19.663686359875697, 4.072220038065312],
            [19.662096239414836, 4.070822100230417],
            [19.661998439829869, 4.069350778337709],
            [19.661897166459696, 4.06782718471328],
            [19.660293360165486, 4.067810017594465],
            [19.657526386495324, 4.070389519399439],
            [19.655897400423743, 4.071908131467453],
            [19.65492416833985, 4.077235735657612],
            [19.654680239807611, 4.078571027554442],
            [19.651826319099413, 4.078761563642977],
            [19.65169942757398, 4.078770023954421],
            [19.648660563511726, 4.076145899640055],
            [19.647382382134992, 4.075042159691276],
            [19.642812479808139, 4.073613096032523],
            [19.640389520467597, 4.07497072163372],
            [19.637972279802177, 4.07632513992499],
            [19.634202686561949, 4.075616153583534],
            [19.630443428439055, 4.074909111434357],
            [19.628128440307481, 4.075071050630883],
            [19.624566669613287, 4.071592256600573],
            [19.623363479596485, 4.070417093503877],
            [19.613088359832194, 4.066626025835842],
            [19.609009199958539, 4.062210042347546],
            [19.604170185728748, 4.064691060503298],
            [19.599596279610665, 4.063722129159386],
            [19.596199150345132, 4.059773018529601],
            [19.59580214260027, 4.059799520440927],
            [19.593218075803417, 4.059972102626658],
            [19.58904828040918, 4.064072150315326],
            [19.581258240283951, 4.063760061911936],
            [19.575344160051372, 4.059554040127895],
            [19.568699279673918, 4.059253994399034],
            [19.561956417353485, 4.063220264898258],
            [19.560627359890635, 4.064002038209428],
            [19.551910320375935, 4.064601048008706],
            [19.549919171311039, 4.057904096180669],
            [19.552322160204472, 4.047339984374411],
            [19.551994894065004, 4.045723664779858],
            [19.5516682262035, 4.044111008903504],
            [19.551361716536999, 4.043848642994932],
            [19.550306160145539, 4.042945107633858],
            [19.548741679399534, 4.043222628025466],
            [19.54663127987898, 4.043596987493387],
            [19.543058087105926, 4.047515106816854],
            [19.540601281940443, 4.050209061774847],
            [19.537622279812098, 4.05017814205541],
            [19.533871491904041, 4.047201658807645],
            [19.532623319647676, 4.046211154496469],
            [19.531633102218404, 4.046386806710215],
            [19.528948440279414, 4.046863031693301],
            [19.523080815523471, 4.056582610090244],
            [19.522182319677967, 4.058070937089756],
            [19.520545449093127, 4.058841043559591],
            [19.515962160071894, 4.060997098486626],
            [19.514176196099356, 4.060578599022358],
            [19.511848440212638, 4.060033142071261],
            [19.509582239584127, 4.057477088548143],
            [19.509006239823975, 4.046882088228156],
            [19.506971160446717, 4.044328150381618],
            [19.504804600949527, 4.043384487061721],
            [19.502636400230301, 4.042440107271555],
            [19.499922550231123, 4.03865582479475],
            [19.499475240423592, 4.038032079943809],
            [19.498730530764856, 4.031265702460671],
            [19.498638239649193, 4.030427145824692],
            [19.493183763567121, 4.025607697422068],
            [19.490463360357918, 4.023204001560356],
            [19.481977440297847, 4.02380501844055],
            [19.480392360284068, 4.021946052616783],
            [19.48032043577253, 4.021482090591598],
            [19.479534318270787, 4.016412035942319],
            [19.477747284404707, 4.015728918864443],
            [19.475197199976751, 4.014754114998106],
            [19.474074419059338, 4.01488317957768],
            [19.469690280248397, 4.01538713999099],
            [19.469114968597722, 4.014198892054155],
            [19.468897199904887, 4.013749111428056],
            [19.468627422350334, 4.013192466948892],
            [19.468120319779167, 4.012146137860333],
            [19.470962159943426, 4.00342914995813],
            [19.470771480846263, 3.989021671065757],
            [19.470581279652858, 3.974650105775437],
            [19.469452938163808, 3.97314317440291],
            [19.46832236795456, 3.971633263084404],
            [19.46165436045013, 3.973634085696433],
            [19.458673237399374, 3.97383203631955],
            [19.458392806723875, 3.973295611734537],
            [19.457100360100434, 3.970822987146289],
            [19.458943256600747, 3.967395052403429],
            [19.461776400174742, 3.962125152323151],
            [19.460446380616201, 3.957967596194056],
            [19.459116360159367, 3.953810018011033],
            [19.460062415510933, 3.951057179670312],
            [19.469240279986593, 3.950004018537111],
            [19.469240429106947, 3.949989881180146],
            [19.469269440199042, 3.947242103943091],
            [19.459796828597206, 3.943284766018],
            [19.456264439999309, 3.941809048011287],
            [19.456232039563663, 3.941497505128786],
            [19.455641279585034, 3.935817127681506],
            [19.454500145188057, 3.935112804171466],
            [19.452224477214767, 3.933708228821078],
            [19.448543159620872, 3.935050087117521],
            [19.444715328600783, 3.950202864451525],
            [19.44293589987193, 3.950034590232354],
            [19.4419692003368, 3.94994306640801],
            [19.437968718508994, 3.944313111787619],
            [19.43587116040538, 3.94136116166207],
            [19.435507418173803, 3.94285524566579],
            [19.434194279756117, 3.948248987857832],
            [19.432344262310544, 3.949840021572709],
            [19.431669787432273, 3.949757426728752],
            [19.426164480179875, 3.949083081544876],
            [19.420482423107071, 3.94464825872052],
            [19.420747199740454, 3.941198081410496],
            [19.423309319796587, 3.939523043853507],
            [19.42367864056607, 3.939281476877857],
            [19.424902320256205, 3.938481087729439],
            [19.427535552746868, 3.938313126876873],
            [19.431095288756936, 3.938086068816426],
            [19.431572400174005, 3.936250093637925],
            [19.429556400115075, 3.931855154155866],
            [19.430736898687829, 3.927502604427859],
            [19.430988436848853, 3.926575170592591],
            [19.424604240380333, 3.923514000605692],
            [19.422817228073818, 3.919121218946543],
            [19.429754399583484, 3.913440134093547],
            [19.430477242451573, 3.909995187134796],
            [19.425779279891099, 3.899356005132942],
            [19.418020193015586, 3.896280139569416],
            [19.417730685762447, 3.901907549438081],
            [19.417440239769842, 3.907553016412824],
            [19.414880280161963, 3.911209072212377],
            [19.395492480373996, 3.92412210406257],
            [19.392702822446296, 3.92759478756736],
            [19.388525400355267, 3.932794990156024],
            [19.383951240013971, 3.953234121226826],
            [19.38090743970923, 3.959185998937105],
            [19.372300000049101, 3.964918114651149],
            [19.367981055571612, 3.967794379477716],
            [19.364040360219196, 3.971895107562486],
            [19.359586440276992, 3.981055085987166],
            [19.356692287620493, 3.98378669727013],
            [19.353798360441129, 3.986518085552587],
            [19.348970399980921, 3.987847107883439],
            [19.347906282644825, 3.989138514731143],
            [19.346311439740525, 3.991074003145089],
            [19.345439620265726, 3.992133464989123],
            [19.345024273414321, 3.992638123421022],
            [19.339568303433943, 3.996552691103437],
            [19.327007159917798, 4.005565031533368],
            [19.317177045782319, 4.003156152658804],
            [19.311657347519052, 4.004938096338723],
            [19.31097386613175, 4.004859532402191],
            [19.305019439864832, 4.004175091132306],
            [19.286705160079048, 4.023313129936015],
            [19.274767995342362, 4.028038067673203],
            [19.273123321990969, 4.028689093637945],
            [19.266424200438337, 4.033451077837153],
            [19.26593640266266, 4.036208011300698],
            [19.270021319838985, 4.039936133864297],
            [19.273784400293394, 4.052177089169519],
            [19.274112612358874, 4.05480297852721],
            [19.274418360254003, 4.057249132087446],
            [19.273430160440874, 4.063114130511797],
            [19.272947400417291, 4.065980097664424],
            [19.268318159874362, 4.070074085937303],
            [19.268232480359202, 4.073276741596682],
            [19.269180360189107, 4.075721645843678],
            [19.272375719757015, 4.078176609424927],
            [19.277711639781153, 4.078344335499811],
            [19.281785399881624, 4.078362672348178],
            [19.287681120346424, 4.078676373289789],
            [19.296516239811965, 4.079721204497508],
            [19.302537600449007, 4.081040544039531],
            [19.3076683201094, 4.085657944973879],
            [19.31103647960537, 4.095579198917016],
            [19.313863560449491, 4.104062383284566],
            [19.329470280239708, 4.141890990655829],
            [19.334301480024845, 4.157806148456509],
            [19.338469079936509, 4.160067580972134],
            [19.338630480243609, 4.160155160791795],
            [19.342601640162258, 4.166356785388147],
            [19.346384879709962, 4.176710750440338],
            [19.349362800266704, 4.184476762930894],
            [19.35124596015639, 4.190227930191232],
            [19.352340719925145, 4.192242876864936],
            [19.357027231660719, 4.197416208477095],
            [19.362414960222225, 4.214397603266607],
            [19.376230680084412, 4.24977754752353],
            [19.384665120390483, 4.2687665130183],
            [19.386357438587932, 4.272983426219571],
            [19.396324800027454, 4.297819590502369],
            [19.418860080076993, 4.35190268976165],
            [19.432721879919988, 4.384124241170842],
            [19.454225039725547, 4.43188557261708],
            [19.457571155462745, 4.442962786787677],
            [19.458636394794649, 4.44692687131532],
            [19.459556371155212, 4.45035023295039],
            [19.476806040429793, 4.482810381629164],
            [19.482220800196529, 4.496904328320985],
            [19.487665080400109, 4.508988587797375],
            [19.48934014285928, 4.517652071690315],
            [19.508646239973839, 4.556990139916649],
            [19.510172280012217, 4.564602149877647],
            [19.516546439604063, 4.569043019392799],
            [19.518566400335065, 4.573208095251426],
            [19.518645866203439, 4.587170403303977],
            [19.518646318954339, 4.587249953949613],
            [19.512350280452843, 4.597080992962467],
            [19.511802593793803, 4.597464825267827],
            [19.509115320452292, 4.599348127030678],
            [19.501772399691742, 4.599731131497983],
            [19.491407280414084, 4.603763987093453],
            [19.484482319704064, 4.608065026988687],
            [19.483772638053217, 4.610012876057963],
            [19.483062480295239, 4.611962024947027],
            [19.474043373283116, 4.619002064370435],
            [19.472164200116683, 4.623125107442224],
            [19.469707200016764, 4.638522039238592],
            [19.471212359614672, 4.647975128365036],
            [19.471561901278235, 4.648674077999441],
            [19.47330323964243, 4.65215608135451],
            [19.475031239821288, 4.655611119725634],
            [19.474949159855463, 4.663207149305312],
            [19.47073932026078, 4.670758009515975],
            [19.464640583236712, 4.674137015218037],
            [19.458511200186766, 4.677532984327262],
            [19.427067359803946, 4.67926798639385],
            [19.420891199680472, 4.677591003921705],
            [19.416320216680347, 4.670262100606359],
            [19.41525431978167, 4.668553079289148],
            [19.404592200403084, 4.657391084349586],
            [19.393648199569817, 4.651288097597554],
            [19.392189480177191, 4.637691043282511],
            [19.390648319695963, 4.636287007263309],
            [19.389101197096206, 4.634877762989638],
            [19.388099159634425, 4.633965023409921],
            [19.386194423109952, 4.629901437074389],
            [19.384737315294917, 4.626793104550375],
            [19.383272617614068, 4.626285529225785],
            [19.37993828687506, 4.625130114727452],
            [19.373642279814629, 4.634730097398577],
            [19.358057160015417, 4.633641138076504],
            [19.353906540957553, 4.635667892306698],
            [19.350849239872399, 4.64254012051255],
            [19.347920953930053, 4.644505047098982],
            [19.346460480127625, 4.645485045799504],
            [19.340401603149367, 4.645075073377122],
            [19.334312279571183, 4.644663040204203],
            [19.332088859411446, 4.64562632298413],
            [19.330164359950729, 4.646460099173003],
            [19.328190480098836, 4.659329119806987],
            [19.321012662500987, 4.661357265665155],
            [19.310934124663593, 4.664205114059679],
            [19.309260748342204, 4.666012712207726],
            [19.308613319940545, 4.666712069106714],
            [19.3120060474612, 4.671122264149136],
            [19.306236240256528, 4.674282111776193],
            [19.304092439577062, 4.681625024828659],
            [19.303984842965587, 4.68167577409772],
            [19.298340839426565, 4.68433785401528],
            [19.298316960409686, 4.684349116765119],
            [19.291479476743717, 4.681488134456722],
            [19.290384360343783, 4.676642040621084],
            [19.289653192787959, 4.676058745827032],
            [19.288337399848587, 4.675009059657536],
            [19.285351200418194, 4.675437109289265],
            [19.282543199790695, 4.680470037658393],
            [19.27837727972857, 4.683878053178103],
            [19.277593199605874, 4.685887144654423],
            [19.275781387509323, 4.690524836232988],
            [19.255352387306448, 4.691913116739888],
            [19.250353241190759, 4.68748503735408],
            [19.248168742337363, 4.68708447507403],
            [19.242342360134387, 4.686016114376116],
            [19.237989240150227, 4.685508138904772],
            [19.234523159796748, 4.687772110825736],
            [19.232074538283491, 4.687874906333359],
            [19.230163200039982, 4.687955146701272],
            [19.229030279837961, 4.686561990272256],
            [19.229172200178102, 4.683604399483968],
            [19.229328173762568, 4.68035008995111],
            [19.227566850578285, 4.680737268035103],
            [19.226339280284652, 4.681007115720641],
            [19.226027740052537, 4.68233116002239],
            [19.223692038567123, 4.692257116157719],
            [19.216869549579904, 4.692769192065436],
            [19.215658440015556, 4.692860094210332],
            [19.210766279656919, 4.699710854933262],
            [19.207294876785369, 4.695220317330154],
            [19.20556224040136, 4.692979003250374],
            [19.189537200336147, 4.690271021902703],
            [19.188264378308393, 4.691519940474678],
            [19.186985177343786, 4.692775206422904],
            [19.187279124071086, 4.694092837042082],
            [19.187860291839073, 4.696697935280836],
            [19.187088480008207, 4.698205075427873],
            [19.186218360145919, 4.699902126309834],
            [19.17958032043936, 4.69867801561954],
            [19.163475359958277, 4.703104022163018],
            [19.161844199963685, 4.705388053708927],
            [19.162231199577985, 4.711838120980504],
            [19.160871566157795, 4.713703720743255],
            [19.158737399909768, 4.71663207480432],
            [19.156941388280732, 4.717296003862333],
            [19.153900429347239, 4.718420261897036],
            [19.153160964053125, 4.726173962047977],
            [19.152343443245687, 4.734746020785305],
            [19.151792615178067, 4.734639265031038],
            [19.149826319802131, 4.734258052924637],
            [19.14779771997301, 4.732375334158846],
            [19.145057400215659, 4.729832068224115],
            [19.135416240411985, 4.730415986108484],
            [19.128470592399303, 4.733144077082562],
            [19.124588156386345, 4.734669092547589],
            [19.12428144010731, 4.741571048921754],
            [19.12171031983036, 4.745916134491275],
            [19.120010400088972, 4.754414043523189],
            [19.114143479612181, 4.766318013901967],
            [19.105201439966613, 4.765758013148277],
            [19.098537925835231, 4.766746773375552],
            [19.09509228035779, 4.767258052685857],
            [19.089409030322347, 4.765173654247088],
            [19.087324200448009, 4.764409017329494],
            [19.082452456999167, 4.769188997991399],
            [19.076820491783284, 4.763409857402229],
            [19.074968279753463, 4.761509142848643],
            [19.074359842726686, 4.761558046833298],
            [19.072443240355621, 4.761712095488416],
            [19.073765700591021, 4.766560118643055],
            [19.075088159928118, 4.7714081062367],
            [19.072905372365327, 4.775668450593295],
            [19.072273320426348, 4.776902079364022],
            [19.067953320428405, 4.773401135381808],
            [19.062441360253004, 4.774030096102141],
            [19.061281778053331, 4.773608123598467],
            [19.057871159685448, 4.772366995410692],
            [19.058268957049457, 4.769437631775328],
            [19.058370446913635, 4.768690264803245],
            [19.052227351979159, 4.764248070576445],
            [19.04216219993781, 4.761604153468929],
            [19.040739328714885, 4.765731079850292],
            [19.036378978191017, 4.765912290656098],
            [19.033361982716034, 4.76887018340285],
            [19.01400011998523, 4.767999987913321],
            [19.019000159924627, 4.786999990440922],
            [19.023908488161727, 4.793953678342165],
            [19.042999920262755, 4.821000057137306],
            [19.04824314043778, 4.828537164385298],
            [19.05900012011373, 4.844000012206619],
            [19.059355269061307, 4.845278549530548],
            [19.064000160053133, 4.861999955844802],
            [19.065539837415812, 4.868158809216591],
            [19.066785530321987, 4.873141656117533],
            [19.068000119959759, 4.878000054881954],
            [19.077000119805785, 4.894999960625154],
            [19.079547414964782, 4.897830321225115],
            [19.086000119651811, 4.905000018710542],
            [19.095999840204509, 4.918000045494709],
            [19.098000000270055, 4.921999946652003],
            [19.10599992008331, 4.929000074749652],
            [19.107000000116084, 4.929000074749652],
            [19.113000120088259, 4.932999909750149],
            [19.136000159719714, 4.941000043444375],
            [19.148000040337926, 4.941999985706937],
            [19.161000000090581, 4.941000043444375],
            [19.173999959843268, 4.940000099653086],
            [19.187999999628694, 4.938999974140017],
            [19.202000040312456, 4.941999985706937],
            [19.212000120191256, 4.950000010208051],
            [19.217000160130656, 4.961999951849065],
            [19.226000159976685, 4.987999994439373],
            [19.230999839691648, 4.997000028829198],
            [19.234000079789936, 4.999999953011676],
            [19.240999919570452, 5.006999960369743],
            [19.256000040286949, 5.014999901804032],
            [19.262999880067461, 5.015999909348941],
            [19.27000008007241, 5.020000105975553],
            [19.284999839666177, 5.025999904778712],
            [19.298000159643266, 5.036000104108895],
            [19.308999960228704, 5.045999968327504],
            [19.317332137221168, 5.050999316727203],
            [19.322750125533037, 5.054250116703344],
            [19.324000080046904, 5.055000088801497],
            [19.338000119832333, 5.060999919475621],
            [19.359000000296607, 5.072999950282875],
            [19.368000000142633, 5.082000049349204],
            [19.375151898649595, 5.094158181934743],
            [19.377562781039426, 5.098256598231624],
            [19.378000080021433, 5.098999988994712],
            [19.392000119806866, 5.112999912769044],
            [19.4029999203923, 5.120999961115642],
            [19.413000000271101, 5.124000020656458],
            [19.423000080149905, 5.128000076939746],
            [19.429999919930417, 5.12999991677132],
            [19.441000079841992, 5.129000087268748],
            [19.446999839589729, 5.129000087268748],
            [19.46199996030623, 5.125000037332014],
            [19.474999920058885, 5.121999982547948],
            [19.490000039877085, 5.121999982547948],
            [19.508000039569175, 5.125000037332014],
            [19.516378680123079, 5.134934418550365],
            [19.527999840000636, 5.138999923063795],
            [19.54799999975824, 5.145000035536743],
            [19.554999840437052, 5.146000018838179],
            [19.56600000034863, 5.144000050642968],
            [19.577000160260205, 5.138999923063795],
            [19.591999919853968, 5.133999935858671],
            [19.601999999732769, 5.131999929491664],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Lisala",
        AREA: 58141,
        POPULATION: 1740000,
        DISTRICTS: ["Bumba", "Bongandanga", "Lisala"],
        OBJECTID: 18,
        NOM: "Mongala",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [22.715724600249391, 3.12764595098376],
            [22.726123199737671, 3.11883011912255],
            [22.736558879884271, 3.120540310599657],
            [22.74989580039497, 3.123407839309815],
            [22.759747919661617, 3.123950966021202],
            [22.769577360060637, 3.118061495733417],
            [22.781702160402254, 3.10572959887447],
            [22.781619720211992, 3.082338294491166],
            [22.781520719579472, 3.054268762175167],
            [22.788424439624592, 3.040204560380181],
            [22.81154759965397, 3.024902274695905],
            [22.827750480094263, 3.018985792721688],
            [22.843965960304747, 3.016578011793213],
            [22.857884280348785, 3.020027879206871],
            [22.86720035961406, 3.032853738663531],
            [22.891659479760914, 3.067837674217362],
            [22.905598680245422, 3.077135356844553],
            [22.921834679773639, 3.080575489516279],
            [22.941538920103586, 3.081661608454909],
            [22.955440679705369, 3.08043331317429],
            [22.965860159634143, 3.077465242976911],
            [22.975967880141848, 3.068358153170967],
            [22.991270039609699, 3.053381307269175],
            [22.999973759803666, 3.056853193304279],
            [23.008704120435731, 3.067927299820517],
            [23.01219072010694, 3.07083654671815],
            [23.01972515988944, 3.07138941941361],
            [23.023189440019102, 3.067865929035677],
            [23.028038146172477, 3.050273517344634],
            [23.03814132030654, 3.045273238058118],
            [23.048038523322376, 3.036162902912177],
            [23.050806292001571, 3.033615197810053],
            [23.052729404463502, 3.033577658363253],
            [23.059734438302964, 3.033440935763808],
            [23.033341080059365, 2.988876258280951],
            [23.021070120227769, 2.95968869735858],
            [23.01104623499392, 2.941100893314525],
            [22.997157480302519, 2.915345744848706],
            [22.983160679842022, 2.889674194662714],
            [22.974303747484765, 2.878017833620502],
            [22.962786479566414, 2.862860098552666],
            [22.95406007960646, 2.852955584904763],
            [22.952132279735373, 2.799163011923444],
            [22.948569360095927, 2.774616846302855],
            [22.942837080012268, 2.792184849511934],
            [22.932444599847685, 2.802755046881357],
            [22.916245680079459, 2.809841153702326],
            [22.905816120154885, 2.809885257551096],
            [22.896524880205551, 2.804076539333923],
            [22.884903360103518, 2.794769172802532],
            [22.886000639646664, 2.777220829983827],
            [22.880161080056801, 2.764380152849542],
            [22.878977399651326, 2.757367577433776],
            [22.887023400343722, 2.738620245707985],
            [22.899717000448518, 2.723362098718178],
            [22.925409480531034, 2.697230074910115],
            [22.939553520256514, 2.682550567494304],
            [22.949454706402317, 2.672354237853324],
            [22.962646799624572, 2.658768767999915],
            [23.014032839564532, 2.606797366306197],
            [23.029620480036431, 2.590649749357118],
            [23.040281292366274, 2.580872080906701],
            [23.040387597200358, 2.580774582575165],
            [23.047235999888578, 2.574493462083806],
            [23.064580439629015, 2.563601493958839],
            [23.074997760007836, 2.560048540035977],
            [23.088902759832848, 2.559697438474886],
            [23.098438440354137, 2.553137057525859],
            [23.102739360135462, 2.560528016965391],
            [23.107071240353058, 2.563087088006685],
            [23.121263519609307, 2.561794139107094],
            [23.157072360195937, 2.542455028602965],
            [23.168998439721975, 2.537696008223471],
            [23.178910328396064, 2.536361860457704],
            [23.180446440345399, 2.536155098242087],
            [23.197418279567245, 2.529355120406171],
            [23.211815399861063, 2.526075036245903],
            [23.213278041298256, 2.525741967794343],
            [23.214142048125026, 2.525545218930085],
            [23.21529613802505, 2.523711235057253],
            [23.234669999553081, 2.51936551317595],
            [23.240267279917575, 2.518110033494946],
            [23.245721880865442, 2.515369378921837],
            [23.256559440320697, 2.509924049134062],
            [23.273327159852105, 2.498749015125789],
            [23.297931359713992, 2.477496145042538],
            [23.298497422310486, 2.474916633217316],
            [23.298637278322129, 2.474279049898397],
            [23.296432118217194, 2.469949033537843],
            [23.295698279969997, 2.468508077764857],
            [23.294565404683734, 2.467483604227576],
            [23.29364928209575, 2.466655143217074],
            [23.288379143004899, 2.46846065837406],
            [23.285857562120913, 2.470838187156234],
            [23.28400945179871, 2.472579879394789],
            [23.278160479661295, 2.471175613831267],
            [23.274179927856359, 2.47021903994054],
            [23.273761228492319, 2.464927060985956],
            [23.273759880121109, 2.464910024184314],
            [23.277544747416091, 2.467873321149853],
            [23.277629879857251, 2.467939973780215],
            [23.281980119842622, 2.467979948189936],
            [23.286849840285431, 2.456260034883606],
            [23.290310159743026, 2.451680044430621],
            [23.293749959882884, 2.450319999782443],
            [23.308379999855184, 2.451100049039241],
            [23.311711104743981, 2.453981684519567],
            [23.314529879765001, 2.456420113737492],
            [23.314970992993686, 2.458253377587182],
            [23.315419308914301, 2.460116571758888],
            [23.316277510827732, 2.46326008443032],
            [23.316990120088118, 2.465869950394776],
            [23.316275617179116, 2.468498975714002],
            [23.314179959910664, 2.476209952320712],
            [23.316660000000969, 2.482210011485921],
            [23.314780080334543, 2.490020022444259],
            [23.315386594068308, 2.491004457615216],
            [23.315919840309167, 2.491869972997854],
            [23.316369960945217, 2.491979102587721],
            [23.318889840420031, 2.492590038386201],
            [23.325872779296784, 2.487431393717167],
            [23.326010085889667, 2.487330081783307],
            [23.334469919772189, 2.487379958025565],
            [23.336510972946076, 2.487647653270964],
            [23.338130606657277, 2.487860608668611],
            [23.339727186005003, 2.48956596725353],
            [23.342680080396235, 2.492720042432469],
            [23.343574071190595, 2.497369324934386],
            [23.344229879975547, 2.500779913689315],
            [23.342780098819965, 2.503947999184554],
            [23.338450079911659, 2.513409980937836],
            [23.338614835426352, 2.516998475998807],
            [23.338640159832526, 2.517550053662105],
            [23.347950119774076, 2.528879953058213],
            [23.350160160425943, 2.542699902559747],
            [23.349909959856401, 2.550039967546663],
            [23.34988115897006, 2.550982185855722],
            [23.355989544798582, 2.563219053519905],
            [23.356684754590223, 2.563596726441197],
            [23.359414766179711, 2.565077192036655],
            [23.363160041126886, 2.562887913725521],
            [23.363309880116276, 2.562800086367195],
            [23.373939960181918, 2.545139993372298],
            [23.377150079968263, 2.543090079250262],
            [23.382869648890662, 2.543814771517403],
            [23.387947920413222, 2.535917605297743],
            [23.391111960218723, 2.529471436689944],
            [23.40008736958217, 2.533560991353081],
            [23.405503372617254, 2.531447547934197],
            [23.408802360039694, 2.530160151239973],
            [23.409271432433307, 2.529767524886446],
            [23.413170240242298, 2.526504110963078],
            [23.419650933738659, 2.517042807311739],
            [23.424474240027369, 2.510001114141495],
            [23.426803802426118, 2.504052488313831],
            [23.427261360214402, 2.502884093371278],
            [23.430877199607231, 2.510499155800105],
            [23.431667947924275, 2.511001983953811],
            [23.432701320419778, 2.511659093518884],
            [23.451921359828461, 2.511081105238851],
            [23.457943440016049, 2.498460018582991],
            [23.460551327439301, 2.496039568815446],
            [23.464843200287394, 2.492056156917955],
            [23.471610853414724, 2.488097435550303],
            [23.477697359876178, 2.484537138369815],
            [23.479688696688999, 2.482786847109414],
            [23.48152127963154, 2.481176091636899],
            [23.487583319577912, 2.47584910515089],
            [23.491708200106274, 2.474492146619144],
            [23.519088360384419, 2.456430017300722],
            [23.519839645711038, 2.45593469809691],
            [23.520412440282282, 2.455557056901931],
            [23.528430900424695, 2.453416607410103],
            [23.536449359668779, 2.451276154446331],
            [23.542886519908134, 2.445560101295948],
            [23.545720407287195, 2.439207174919269],
            [23.547289320320811, 2.435690018688412],
            [23.566858560033225, 2.416155636258961],
            [23.572582560344941, 2.396248575257309],
            [23.561203679692746, 2.360018234373002],
            [23.566262040057008, 2.321830864554103],
            [23.579769220958447, 2.193119172837317],
            [23.557394296475316, 2.193145724393437],
            [23.546152440344983, 2.193159155155563],
            [23.544624050313836, 2.192625085712973],
            [23.536110240259145, 2.189650079284288],
            [23.524940519744433, 2.183604089577148],
            [23.520427199602395, 2.183809045110725],
            [23.511444324340637, 2.184217143263505],
            [23.500471245939924, 2.183464158236386],
            [23.484913199566741, 2.184985105884274],
            [23.474594519596032, 2.189988127322878],
            [23.470461360194019, 2.192955101000622],
            [23.465160360379919, 2.200057154737776],
            [23.459659199750853, 2.201866071441672],
            [23.457829817505672, 2.203001785146931],
            [23.455988187629899, 2.204145169411132],
            [23.454342777659949, 2.206386196805968],
            [23.449764239828266, 2.212622091237647],
            [23.443578359933468, 2.214657014008137],
            [23.434160400036877, 2.22173501062022],
            [23.428892159984557, 2.223314997615735],
            [23.425424280305524, 2.229737042884976],
            [23.423373890940908, 2.230548464712656],
            [23.421985199716211, 2.231098025570977],
            [23.41329740036403, 2.230817079393935],
            [23.409618480373624, 2.23424699153914],
            [23.389198200117207, 2.245402039789159],
            [23.376379320064565, 2.247627095516122],
            [23.370416445142414, 2.250352912575861],
            [23.367535423160419, 2.253102691367973],
            [23.364666360449785, 2.25584113391516],
            [23.363588165614875, 2.257881675462519],
            [23.362121160162051, 2.260658057930693],
            [23.359276202843759, 2.262271614702518],
            [23.346060480336256, 2.269767072365017],
            [23.33550730863535, 2.278627741395453],
            [23.332727160273222, 2.280962004065828],
            [23.329061401500059, 2.282090946025182],
            [23.324142530634795, 2.27900473473732],
            [23.323137480223544, 2.278374118994289],
            [23.317465319890264, 2.270977101371002],
            [23.313419280002826, 2.258988065946173],
            [23.314184279908872, 2.245877126643448],
            [23.315393406891424, 2.241894122361545],
            [23.320947240237164, 2.223599009619418],
            [23.320232280085673, 2.21497902854452],
            [23.320221275723462, 2.214846215799978],
            [23.319668519871271, 2.208175109791425],
            [23.313307320274014, 2.201004117229499],
            [23.311973529587927, 2.194784064100545],
            [23.315494320037164, 2.179390073000673],
            [23.314420439810547, 2.167878999282202],
            [23.326471403127403, 2.1410312125876],
            [23.323457767351599, 2.135960253901008],
            [23.321943359597835, 2.133412068017015],
            [23.321760892899004, 2.132286147593106],
            [23.319517319934214, 2.118442010926648],
            [23.321680239457869, 2.106662009384599],
            [23.321880346373938, 2.105572154204684],
            [23.320235425985807, 2.103781596179096],
            [23.315292359896684, 2.098401137766067],
            [23.312563199910109, 2.089857165251117],
            [23.271167159853114, 2.106117994227245],
            [23.256470879908409, 2.100435495052775],
            [23.24202177680402, 2.09164816871438],
            [23.232755880125463, 2.086013020446764],
            [23.224255199846951, 2.085449267075557],
            [23.210331840254195, 2.086124330499708],
            [23.193908279681171, 2.09283514254994],
            [23.193714860722395, 2.092841453493203],
            [23.187963239910662, 2.093029123382853],
            [23.177406239589992, 2.099405979142751],
            [23.175752399829413, 2.107909013155535],
            [23.172977159862029, 2.112952995257023],
            [23.169525177668596, 2.11638523752067],
            [23.167227060796378, 2.118670035239048],
            [23.166698515439393, 2.11868719551065],
            [23.158046520239495, 2.11896810952759],
            [23.155334280021282, 2.119056003031606],
            [23.150370867989267, 2.124833440579896],
            [23.147272440233799, 2.128440015972348],
            [23.130758159698534, 2.136621036910367],
            [23.127765479821687, 2.139823155962182],
            [23.123827439889258, 2.148312095991505],
            [23.114862360253266, 2.155619141286891],
            [23.113731615770849, 2.158325730652782],
            [23.11045235984362, 2.166175040999049],
            [23.108382080880268, 2.168232196701543],
            [23.104929239897441, 2.171663143131668],
            [23.100405808318538, 2.174355017277828],
            [23.098043160069562, 2.175761016175384],
            [23.093920007899815, 2.176771443567952],
            [23.089800239683733, 2.177781041574311],
            [23.075762399689474, 2.191958066612937],
            [23.073132781121203, 2.192821547039859],
            [23.064762252354324, 2.195570150292244],
            [23.057630280276978, 2.202197994162135],
            [23.04961629015142, 2.203988234351013],
            [23.049285985011334, 2.206583545527113],
            [23.048650351489332, 2.211577912193671],
            [23.041329840101874, 2.212450097152735],
            [23.040582020475622, 2.21289157585792],
            [23.030539920102761, 2.218819962868251],
            [23.020940160057282, 2.218989974428292],
            [23.01661008006354, 2.216430073503402],
            [23.014363096195574, 2.212464954659111],
            [23.013209880356328, 2.210429939375458],
            [23.007290040126165, 2.206250037821422],
            [23.00550011997311, 2.200719920102775],
            [23.003280000223739, 2.189659984743332],
            [23.004587814326761, 2.185382578878077],
            [23.006790000109778, 2.178179967851331],
            [23.004519938522208, 2.175170231814552],
            [23.002498372501758, 2.174440592250481],
            [23.000640120199993, 2.173769984473106],
            [22.997199959835697, 2.175600005086735],
            [22.984779463746936, 2.187009910157892],
            [22.981488138953871, 2.186533377215067],
            [22.978149840356249, 2.186050043757558],
            [22.972230000126086, 2.180489953968197],
            [22.971257146232972, 2.17621012683143],
            [22.971129839685844, 2.175650073268141],
            [22.972962668766758, 2.169949060360358],
            [22.975559958764585, 2.161870153370986],
            [22.975485454291551, 2.161679512413227],
            [22.974210000200035, 2.158419947003046],
            [22.963847567783368, 2.159555343297535],
            [22.958420040261522, 2.160150028859629],
            [22.956922444478337, 2.159269722112056],
            [22.952499839806919, 2.156670052698451],
            [22.944309840072801, 2.149019910675075],
            [22.940406340363065, 2.147732453682724],
            [22.938609960424785, 2.147139968300501],
            [22.934069999844652, 2.142509982946981],
            [22.933104154607364, 2.138931042743045],
            [22.932950039637223, 2.138359968726176],
            [22.933510794088736, 2.13697897361003],
            [22.933879919923822, 2.136069909209821],
            [22.945820040117756, 2.129010057136081],
            [22.945825575536539, 2.127494470701467],
            [22.945830120113555, 2.126250082050653],
            [22.947029642309076, 2.124864201155203],
            [22.948599960307789, 2.123049915388042],
            [22.948859144928502, 2.117988883098365],
            [22.948749476801986, 2.117831676024881],
            [22.947729840445469, 2.116370033829683],
            [22.945958869355017, 2.115381018179492],
            [22.941569879641555, 2.112929941591038],
            [22.938158461773089, 2.111018434583321],
            [22.937226683346328, 2.110009827642902],
            [22.93452000010646, 2.10707996481149],
            [22.931577997788029, 2.101300473878294],
            [22.928879879984418, 2.09600006967839],
            [22.928076711560237, 2.095220994484237],
            [22.923879840045021, 2.091150012232645],
            [22.919793608633444, 2.091468613508986],
            [22.91861987976468, 2.091560128138882],
            [22.911940080075485, 2.098880053686003],
            [22.90505028301898, 2.102749786070185],
            [22.904382102635939, 2.102766379867162],
            [22.897739880373397, 2.102930034045349],
            [22.894549919680344, 2.100599936647959],
            [22.890269880339481, 2.092530031955721],
            [22.892600159593851, 2.084029976150755],
            [22.892209919756322, 2.074139931007135],
            [22.888580039695597, 2.069049892789323],
            [22.877820000357801, 2.071279894334018],
            [22.873479840368226, 2.070329969592414],
            [22.871442376862213, 2.06843660113758],
            [22.868250120075313, 2.065470105726574],
            [22.859669879605335, 2.049080068926768],
            [22.857494593873504, 2.047899587205226],
            [22.85579987986916, 2.046979901628286],
            [22.848403415026116, 2.046579250223928],
            [22.846200119823685, 2.046459902713877],
            [22.841870039829942, 2.044130081666627],
            [22.833849960025059, 2.034069934150763],
            [22.833213865667314, 2.03326325438817],
            [22.833029879917358, 2.033029927692504],
            [22.831127293959671, 2.031506657744218],
            [22.826660040323716, 2.027930030284233],
            [22.808778815878487, 2.035169801649337],
            [22.80192034127931, 2.034431981439397],
            [22.790339999949925, 2.021930056071308],
            [22.789093609951102, 2.021068499614239],
            [22.783965041755792, 2.01752341497995],
            [22.782787434859955, 2.017583459022549],
            [22.780079999730184, 2.017730006786536],
            [22.778097039707397, 2.019869003758925],
            [22.77324863987953, 2.025098908285981],
            [22.764189960282501, 2.034870022152813],
            [22.757166079788366, 2.038703314750018],
            [22.755010113225012, 2.039879935108234],
            [22.748100120244295, 2.047650118363091],
            [22.744029318296032, 2.049282197372563],
            [22.739619960181816, 2.051050009251258],
            [22.73018476341155, 2.049600213392289],
            [22.727059919796837, 2.049120055017724],
            [22.726415384868691, 2.049382817376293],
            [22.723160040297671, 2.050709948460239],
            [22.716238209318139, 2.060551231857044],
            [22.713249959932241, 2.062369958856924],
            [22.707982899367909, 2.062337672368805],
            [22.701819959750491, 2.062299893634068],
            [22.69354807678161, 2.069368985722194],
            [22.686478906824107, 2.065866529893527],
            [22.68454771132123, 2.060390322509697],
            [22.683198813667019, 2.056565068274173],
            [22.680869778579336, 2.049960282369384],
            [22.644730080388737, 2.086070116522921],
            [22.633599960306707, 2.092530031955721],
            [22.632906450127578, 2.092932217018941],
            [22.631410079646432, 2.093800002600126],
            [22.622929919583953, 2.096960064643246],
            [22.605320159729427, 2.097069932418799],
            [22.577354349090012, 2.107454625097151],
            [22.577339879925731, 2.107459997888471],
            [22.558815494076448, 2.111365562150495],
            [22.550353835715555, 2.113149561884708],
            [22.51919016010693, 2.119719884180211],
            [22.518167067033211, 2.12113716030834],
            [22.516878579285216, 2.122920618148883],
            [22.502311243516409, 2.128509181689189],
            [22.500213970178777, 2.129313770527221],
            [22.490976022783649, 2.132857773368353],
            [22.490954529692161, 2.13286413927459],
            [22.438969919820501, 2.146540035980065],
            [22.43278350812302, 2.147182709118936],
            [22.428669667889487, 2.147610109102907],
            [22.399589879822447, 2.154079966368732],
            [22.387010039670276, 2.153989913193103],
            [22.386530159645517, 2.157210005604447],
            [22.38093684624134, 2.157519442006409],
            [22.371890039677417, 2.158019935502957],
            [22.354480178329801, 2.162040017849126],
            [22.354424279762917, 2.161905947800455],
            [22.353810119569459, 2.16043009110774],
            [22.364129873925293, 2.155439381239844],
            [22.364083443601515, 2.151605674172587],
            [22.363794719679312, 2.127765331726637],
            [22.362039360410154, 2.09883934857696],
            [22.3631039269039, 2.092081738832134],
            [22.363826552379724, 2.087494670895784],
            [22.366567439872341, 2.070096000372401],
            [22.366890574659791, 2.068783779818545],
            [22.367981159957434, 2.064355011741188],
            [22.371250701503183, 2.059130472272556],
            [22.375148439418698, 2.052902102178715],
            [22.38023246195571, 2.046602032833145],
            [22.382532360187142, 2.043752014262092],
            [22.412990214205681, 2.036835955559568],
            [22.445257320122213, 2.000023143254223],
            [22.447779981679474, 1.998090508199734],
            [22.450315320262039, 1.996148159366222],
            [22.452804359674868, 1.99597307896355],
            [22.461546834986819, 1.99535775723683],
            [22.462209359576864, 1.995311126771896],
            [22.467488825875279, 1.989980942996183],
            [22.475334239951255, 1.982060128455995],
            [22.47950769238701, 1.973533369744754],
            [22.482292319749131, 1.967844086071602],
            [22.482632091335699, 1.965103838771573],
            [22.485199320110855, 1.944399048378014],
            [22.486836304781729, 1.94024825098787],
            [22.490085239873192, 1.932010104349194],
            [22.491218107074616, 1.924201457905021],
            [22.491285478924297, 1.923736977880108],
            [22.491131399886743, 1.913153076078519],
            [22.481992460310678, 1.892657294835823],
            [22.480327440118089, 1.888923148239458],
            [22.47368040019068, 1.891407024118528],
            [22.470948310797969, 1.891176072621774],
            [22.467741479743896, 1.890904989247283],
            [22.457714382134593, 1.886234081492621],
            [22.446350279667151, 1.876952074542196],
            [22.435413479729188, 1.871814048757504],
            [22.432934261597357, 1.865915855388494],
            [22.430467415063653, 1.860047029135134],
            [22.429355400454881, 1.855438123430954],
            [22.429804324534999, 1.85059791058916],
            [22.430254320305217, 1.845746120843646],
            [22.431247535412574, 1.835008047221664],
            [22.431335388850709, 1.834058232992185],
            [22.43023343986475, 1.82830009419454],
            [22.425618447500522, 1.818728892500242],
            [22.420995496961208, 1.809141132104532],
            [22.417474860123871, 1.806011112166121],
            [22.413954240354514, 1.802881120208894],
            [22.408260480030229, 1.800080066437386],
            [22.39478748002535, 1.798374103573311],
            [22.391213336834731, 1.796544511904997],
            [22.388864399571951, 1.795342097674217],
            [22.38188091272287, 1.788860973529659],
            [22.381370279772675, 1.788387072939469],
            [22.367685239631484, 1.784379022991699],
            [22.363655593099676, 1.784350583700933],
            [22.357628299988466, 1.784307776520249],
            [22.358573280056678, 1.771021552988802],
            [22.362104519709284, 1.754252699990863],
            [22.374164159853475, 1.742602650015433],
            [22.377376079863637, 1.72337357442381],
            [22.372439039673409, 1.710682410266664],
            [22.344665760457271, 1.741545171627624],
            [22.334118840132433, 1.752741074947727],
            [22.323966839867737, 1.757399168538509],
            [22.302745200394121, 1.750732598099961],
            [22.281162307920589, 1.737981984253294],
            [22.271322960002312, 1.737673573482981],
            [22.25057904010524, 1.74329586500138],
            [22.198040072685203, 1.759228059201451],
            [22.177758960330916, 1.761945018546818],
            [22.166317440153989, 1.762478616511717],
            [22.157415360267173, 1.762257034688705],
            [22.127389918395465, 1.76261713745324],
            [22.095954359581253, 1.761545992150975],
            [22.072641840079921, 1.761375031561519],
            [22.051863720421647, 1.759221004873135],
            [22.02936840013086, 1.752113437184011],
            [21.996258120217309, 1.740649287560249],
            [21.948282359980322, 1.722267445122777],
            [21.921804359775741, 1.716438996110421],
            [21.919990319857288, 1.714585050925485],
            [21.898073519999375, 1.71165613422487],
            [21.893745240229446, 1.709552133231914],
            [21.89059019974647, 1.703777150667017],
            [21.875712120551174, 1.701227080108491],
            [21.873930050775385, 1.645347354701041],
            [21.872732559670734, 1.607797138207625],
            [21.872620182225305, 1.604273247866799],
            [21.869562599967495, 1.555378787490147],
            [21.86837532001265, 1.477995612646606],
            [21.866960159928141, 1.445217181117264],
            [21.866901119952704, 1.431709177259032],
            [21.866428439924949, 1.420646466138301],
            [21.862078199939578, 1.395161614534807],
            [21.86103672014864, 1.350930658016173],
            [21.861412199767692, 1.339888645873212],
            [21.863073599749708, 1.332153154151023],
            [21.865830276930073, 1.328933890830516],
            [21.883381199828474, 1.323653831392985],
            [21.890986199581587, 1.318112769860853],
            [21.898152719966404, 1.309286181078986],
            [21.904210079690163, 1.299569977445046],
            [21.905359919660583, 1.297739998327159],
            [21.907214649668131, 1.292909936787317],
            [21.908619551890418, 1.28925130468757],
            [21.913271279959883, 1.277326337045068],
            [21.934689119576383, 1.23201517920912],
            [21.935576687416429, 1.205635809165406],
            [21.937689000348566, 1.142854834741607],
            [21.994702994526676, 1.128734408023946],
            [22.017286080220721, 1.123141326251449],
            [22.044708359807572, 1.09394175568667],
            [22.05277619764621, 1.081663564527141],
            [22.053971159993331, 1.079844984749972],
            [22.059844560018284, 1.066073413016809],
            [22.066156440309801, 1.055587240178038],
            [22.068056268439562, 1.046743985254451],
            [22.077928439899985, 1.033775217101612],
            [22.080444840199739, 1.027697462786904],
            [22.085887320179506, 1.012277320565355],
            [22.090467599844526, 0.993560767070486],
            [22.096330559649214, 0.977332231275751],
            [22.102175159686123, 0.957009461935731],
            [22.104634320234293, 0.93783054050434],
            [22.105862999947306, 0.928036321306199],
            [22.090210919726822, 0.935015126537822],
            [22.066074000119539, 0.940145510770587],
            [22.03770383980445, 0.946398409381405],
            [22.010594040087476, 0.950226407685593],
            [21.98686499963663, 0.951682495217658],
            [21.977115479653509, 0.951439753873373],
            [21.96707507979152, 0.95109609535392],
            [21.950808840275876, 0.94505368910222],
            [21.909992759752878, 0.91620046882416],
            [21.89584722882401, 0.900604951522579],
            [21.863569319767887, 0.86510102919084],
            [21.79572264039324, 0.858090010951148],
            [21.786008760170699, 0.866035794040647],
            [21.76364484004981, 0.888813398072432],
            [21.742494840321786, 0.898521043534465],
            [21.72767831997799, 0.902655273340772],
            [21.727354923780752, 0.902610925925951],
            [21.709441800159823, 0.900154479960999],
            [21.659790239946847, 0.886227714975563],
            [21.658078800210248, 0.882500747339815],
            [21.664363679839301, 0.865872881693252],
            [21.665967479845264, 0.845034422817105],
            [21.664160639923811, 0.819607933647258],
            [21.658112999971447, 0.793666222048307],
            [21.648627720327472, 0.756994719225751],
            [21.633867359960281, 0.725617568184978],
            [21.630921479614788, 0.725920696326653],
            [21.624291360354068, 0.726506048846469],
            [21.614142600312604, 0.726606971874048],
            [21.605864040166196, 0.727724511312612],
            [21.600591119891231, 0.731047212060123],
            [21.593697479841946, 0.736059642481569],
            [21.584770116871454, 0.742304090024792],
            [21.580796880047913, 0.744566866355698],
            [21.576414960075738, 0.746564949013632],
            [21.569807879907113, 0.748114827807676],
            [21.563916120114417, 0.748720901916857],
            [21.558745079572468, 0.748575826472725],
            [21.55468175969223, 0.748461928274374],
            [21.547091159933093, 0.747477935359876],
            [21.537284400198384, 0.746431587692094],
            [21.531212639582321, 0.747225449934889],
            [21.523049280286259, 0.753166165614883],
            [21.511270440025175, 0.762283393342885],
            [21.50416927567052, 0.772216218945821],
            [21.477328560008711, 0.793915461026234],
            [21.459838320104403, 0.803450701238752],
            [21.449518919684792, 0.804125429234443],
            [21.412849340342394, 0.800194019158165],
            [21.40574796039207, 0.802897978521355],
            [21.398175360176303, 0.810397841392554],
            [21.389462639761511, 0.816515978675541],
            [21.375453959979666, 0.817279912222487],
            [21.356260560110741, 0.817320100067007],
            [21.341900879801315, 0.818845442869518],
            [21.319193005537912, 0.833888094067593],
            [21.299223240277968, 0.847918568561639],
            [21.291720120257839, 0.850600151472191],
            [21.279595319916222, 0.852959329343988],
            [21.261025079563236, 0.855909066440875],
            [21.242427119895584, 0.85770111023939],
            [21.233035440212614, 0.858594608011878],
            [21.211343280261168, 0.877651951416912],
            [21.204414295997044, 0.880265049624923],
            [21.187887839696426, 0.884706184433207],
            [21.174493320108031, 0.887993613764243],
            [21.160105919585572, 0.896073410385522],
            [21.145219559720001, 0.906452683385541],
            [21.13016256037465, 0.917405536731884],
            [21.118772159727246, 0.911880637707649],
            [21.1137397202505, 0.909811456635884],
            [21.090168360183171, 0.919754400143066],
            [21.045394800184983, 0.938356932313799],
            [21.041984967842996, 0.940090840955023],
            [21.02096052025237, 0.950781811143286],
            [21.010982399690683, 0.958020971798101],
            [21.004841159777282, 0.963632657403072],
            [21.001839839904012, 0.969332275338884],
            [20.9993972397981, 0.97524038336677],
            [20.998058040355691, 0.980986654445481],
            [20.997831600225407, 0.986956913161206],
            [20.99783124000097, 0.994668676754468],
            [20.997969479943404, 1.000456181025021],
            [20.999081879929427, 1.008391907811626],
            [21.00188879988362, 1.017724565913164],
            [21.003320797989822, 1.021600898843713],
            [21.008005920031653, 1.034283212549155],
            [21.014958960280783, 1.047202205089866],
            [21.022687439757917, 1.061685302680546],
            [21.017612880074132, 1.073303121623397],
            [21.014478448740363, 1.079549314565084],
            [21.016596599823536, 1.084841788737451],
            [21.018761999595679, 1.090493253982277],
            [21.021393239623041, 1.100206425211735],
            [21.01971203987387, 1.114810900876154],
            [21.016903679920262, 1.144035308708982],
            [21.016547639843896, 1.160026173808286],
            [21.014877187538797, 1.175322190728251],
            [21.014340119864716, 1.180240005904939],
            [21.010410000378162, 1.185040041870166],
            [21.005560079702509, 1.190970068813357],
            [21.002360039911995, 1.192320085125552],
            [20.999888593105691, 1.187470751095136],
            [20.997140343919323, 1.187909955639132],
            [20.995461232753168, 1.186458119126293],
            [20.989889178878503, 1.181640264366954],
            [20.984159880303277, 1.183890036968061],
            [20.975019840290969, 1.183579921598651],
            [20.969804589162301, 1.181185649870137],
            [20.966829839658516, 1.179819970451964],
            [20.961570276433527, 1.179657602284651],
            [20.956788725635867, 1.17950790702851],
            [20.952729269409648, 1.173490917728468],
            [20.94904007987892, 1.177370035273278],
            [20.94699996005459, 1.175050018168891],
            [20.946800160362361, 1.172289962103666],
            [20.941107239064532, 1.172238737726527],
            [20.939029920004323, 1.172220045661471],
            [20.937313175715964, 1.174043476672654],
            [20.935810080446618, 1.175639978968393],
            [20.928489840350348, 1.176729980770976],
            [20.925269999894311, 1.179000082357759],
            [20.921077378308695, 1.178381974386463],
            [20.920250160187752, 1.178260020075501],
            [20.920176144398237, 1.178219125112661],
            [20.917299959844048, 1.176629972552358],
            [20.917034900241347, 1.176233453270866],
            [20.914819919753739, 1.17291992611229],
            [20.910049920392289, 1.170730007464993],
            [20.909467241657978, 1.170974069553642],
            [20.909412359984007, 1.170997057377157],
            [20.90599239105234, 1.171445110128543],
            [20.90663978262312, 1.173224754151108],
            [20.907930177494457, 1.176771973425829],
            [20.89938874783801, 1.177686728320039],
            [20.896042320385419, 1.178045046870366],
            [20.892872160357861, 1.175028034919487],
            [20.891031480001349, 1.176621143271432],
            [20.887161480265206, 1.174977039349888],
            [20.886902280373111, 1.178653026342786],
            [20.881624319651131, 1.181365143919596],
            [20.879790119741049, 1.181810045743892],
            [20.877502760194371, 1.179796880530226],
            [20.876619959713523, 1.17901990369196],
            [20.875645484361282, 1.178943249504957],
            [20.870898777416841, 1.178570781627837],
            [20.869149819542432, 1.179834023142615],
            [20.868739920074923, 1.180130086246817],
            [20.868334695440147, 1.180194791727329],
            [20.862540000410522, 1.181120079117765],
            [20.855155237920666, 1.184463483848806],
            [20.851430040320089, 1.186150042054422],
            [20.846309364722874, 1.181674513595722],
            [20.843729999708231, 1.179420117031995],
            [20.840249258849287, 1.180909086314144],
            [20.840060159888715, 1.180989978313514],
            [20.834833397748014, 1.179256904341196],
            [20.834361678917617, 1.179100493752445],
            [20.831005785018551, 1.179745351585664],
            [20.830929839647801, 1.179759965769517],
            [20.830388311838334, 1.179480605455664],
            [20.826839880227773, 1.17765005856261],
            [20.823239879930036, 1.171870106273762],
            [20.821146552891456, 1.171487284603633],
            [20.817989999645526, 1.170910023002447],
            [20.817199731028833, 1.171883961894217],
            [20.816140403509795, 1.17318949304262],
            [20.81202951244536, 1.174069774662907],
            [20.807249399850456, 1.171728111477161],
            [20.803795221276154, 1.174916114109856],
            [20.805835320439222, 1.176544019750088],
            [20.805611430625998, 1.177519174577633],
            [20.805361200412047, 1.17860905809297],
            [20.802843341248273, 1.179046003620244],
            [20.800815388206161, 1.176038074314803],
            [20.800319271132633, 1.176269530811646],
            [20.796459840075777, 1.17807009434733],
            [20.792346938581741, 1.178036987951755],
            [20.789146043595053, 1.175732223059141],
            [20.787810120308492, 1.174769994615178],
            [20.784650040276727, 1.170140045616556],
            [20.782259321471745, 1.1703407813422],
            [20.782149840194826, 1.170349974122906],
            [20.781762635764657, 1.173319995670427],
            [20.781640387630887, 1.17425768796893],
            [20.778033654460103, 1.174395572246953],
            [20.776849920155701, 1.174440056849084],
            [20.773649842635944, 1.171336444214351],
            [20.772541694376176, 1.170261700099325],
            [20.77003920987849, 1.169780718784798],
            [20.76480929465114, 1.173654373984732],
            [20.763600120057905, 1.174549975830385],
            [20.760628034058914, 1.17498180436152],
            [20.752800120062993, 1.182039974603758],
            [20.743641228904458, 1.184026074439718],
            [20.743489887033594, 1.184013828309813],
            [20.734049879784973, 1.183249984890665],
            [20.728389959895747, 1.177910080550393],
            [20.717430119967393, 1.178040001569605],
            [20.713120547613254, 1.174090584298128],
            [20.710379880207896, 1.174979922769632],
            [20.709053457503767, 1.176618400000718],
            [20.706680159727096, 1.179550037979771],
            [20.692289880104138, 1.179650046996365],
            [20.691882041371873, 1.180448236505467],
            [20.69089025728076, 1.182391514895027],
            [20.700313919682792, 1.214423001929766],
            [20.702283480434776, 1.227543717288238],
            [20.710007639913705, 1.243723471521952],
            [20.713214879701258, 1.250897582916524],
            [20.71474415996283, 1.256430504139714],
            [20.714799240164464, 1.262357127966417],
            [20.713939559624112, 1.269223965501816],
            [20.70815508023588, 1.282835957447552],
            [20.703344258732994, 1.291223406754151],
            [20.699793360348675, 1.297414219693035],
            [20.677732559652409, 1.328691444819677],
            [20.663830439826224, 1.344027109110913],
            [20.655459719718163, 1.357008228933813],
            [20.651092559964429, 1.364115165981715],
            [20.646173054888546, 1.376058482543147],
            [20.64100967967093, 1.392241978973251],
            [20.63834928032945, 1.4041381553451],
            [20.637359999843046, 1.416934439652681],
            [20.637834840319091, 1.428225993600643],
            [20.642829839811409, 1.448894026935178],
            [20.649218429939999, 1.466926087965001],
            [20.655079920100867, 1.475720023984468],
            [20.655254159130017, 1.477627806601978],
            [20.65550004059968, 1.480320025613747],
            [20.657930055308462, 1.483027140262583],
            [20.658210480594079, 1.483339542650445],
            [20.660459634791732, 1.487269878808809],
            [20.657095920159801, 1.512946408364624],
            [20.658683519947971, 1.544596145331641],
            [20.658792240351854, 1.556263766641243],
            [20.65903019957905, 1.562002243740378],
            [20.659815719701154, 1.56699121719685],
            [20.661320880197362, 1.569931518712107],
            [20.666908439892129, 1.57484552405576],
            [20.676027600362303, 1.582112645368407],
            [20.681625240052867, 1.588138051614417],
            [20.687109119790833, 1.601759650328739],
            [20.691869759605325, 1.617059539963583],
            [20.695555080092117, 1.635895486766429],
            [20.697135840107688, 1.646984633808706],
            [20.698754759658197, 1.662148335822867],
            [20.69942112005452, 1.674177929168454],
            [20.698797600314109, 1.686598023500119],
            [20.697587639695012, 1.695507920331298],
            [20.69470836044465, 1.703702927060207],
            [20.693615400001384, 1.705386999229605],
            [20.691419760241853, 1.707643955301393],
            [20.689210440038821, 1.708419332564539],
            [20.685139920161546, 1.707741777597206],
            [20.677717800332299, 1.704152950287745],
            [20.667148559567579, 1.699872145596301],
            [20.65752000043242, 1.69742890066981],
            [20.647346039952279, 1.695920472403953],
            [20.635093868384814, 1.697000997746687],
            [20.622064680147766, 1.698722405150486],
            [20.617265879899971, 1.699167745201211],
            [20.615044320151224, 1.698646560534225],
            [20.606294519976441, 1.691373741904613],
            [20.597166720408179, 1.683180663853441],
            [20.586580199650662, 1.677047812138595],
            [20.574876959807241, 1.670006233134018],
            [20.57041476009309, 1.666926997480298],
            [20.567085120356492, 1.666423099063377],
            [20.563209719948869, 1.666854034408552],
            [20.556962639630349, 1.6704706755104],
            [20.550527639839245, 1.673719972822656],
            [20.543711040207032, 1.675678448431487],
            [20.533372919795241, 1.676395288040464],
            [20.520996479782966, 1.676403035125293],
            [20.508043320459961, 1.6740116450719],
            [20.498616719668657, 1.673417670644926],
            [20.487714479716328, 1.673031776598363],
            [20.480342040315552, 1.674813879579264],
            [20.465767800095456, 1.676893238406976],
            [20.458216080320156, 1.679233640652875],
            [20.453983560061193, 1.68096673522987],
            [20.451033359717485, 1.681568454398368],
            [20.44715112043556, 1.681258407288268],
            [20.437886880250385, 1.678253954718865],
            [20.428797240217094, 1.674135232466703],
            [20.421933840155198, 1.671093296150282],
            [20.417110920142072, 1.668945832419427],
            [20.411739360357352, 1.667362436349253],
            [20.408036759877763, 1.666493900730692],
            [20.40470856014058, 1.666175383605594],
            [20.400096240264315, 1.666802869948916],
            [20.396604239921619, 1.668709646654775],
            [20.386868759708069, 1.674603457905023],
            [20.37733308008508, 1.682161345163697],
            [20.367065879868335, 1.690471528825104],
            [20.352766320207618, 1.70217865002241],
            [20.340910799753868, 1.718478495698856],
            [20.33451179994778, 1.72561681770664],
            [20.32772112030478, 1.730353525403261],
            [20.317745520415784, 1.730323619973233],
            [20.308510799769163, 1.730467560698289],
            [20.298362399952129, 1.73173726231699],
            [20.284183800241014, 1.736588889771623],
            [20.270006639631017, 1.741625878649725],
            [20.251227600263316, 1.74840165286987],
            [20.237596200324408, 1.752503819428151],
            [20.2305794398772, 1.752798362187879],
            [20.215779479975662, 1.750435892782305],
            [20.202094439834507, 1.748796899108538],
            [20.190642839661745, 1.748975246977843],
            [20.175511319673678, 1.750692965680986],
            [20.161125720273365, 1.753139923365977],
            [20.150057520165532, 1.754794225927577],
            [20.140094159822283, 1.756061028257971],
            [20.130492959777396, 1.756581116755221],
            [20.120888879733744, 1.756730819862777],
            [20.111277599693061, 1.75613957332926],
            [20.09942928013464, 1.753360605056964],
            [20.087570520355953, 1.749470295556704],
            [20.072000520101291, 1.743785691197925],
            [20.058640200274098, 1.737325523629718],
            [20.043795240166723, 1.730147793246192],
            [20.019677399877761, 1.719039308907746],
            [20.010394439700377, 1.71399757501323],
            [20.002616279794793, 1.711896097769894],
            [19.987460640041324, 1.711020917422444],
            [19.974897719657555, 1.710846169125557],
            [19.96639451960468, 1.710237793372309],
            [19.959728040134515, 1.708489412224835],
            [19.945604879951201, 1.699448064287319],
            [19.931464080448947, 1.688554684401277],
            [19.919547000245398, 1.678367452562846],
            [19.899868679904671, 1.667930829964555],
            [19.879482959633851, 1.660839314317765],
            [19.844296920135388, 1.651385360378453],
            [19.810964880314167, 1.642643349385476],
            [19.783929959667717, 1.635655513795627],
            [19.762128719986283, 1.635254298608869],
            [19.739588400387994, 1.634864793710522],
            [19.723310639978841, 1.632525239655594],
            [19.705911120036777, 1.628721342058256],
            [19.689937200399452, 1.619338217607614],
            [19.679855425932079, 1.611769118757534],
            [19.652825160355423, 1.601393739940438],
            [19.640217239765786, 1.596403770009658],
            [19.629404640000718, 1.585828891447896],
            [19.612253879730485, 1.569055013407267],
            [19.590666480409144, 1.551979940621319],
            [19.582840440298902, 1.544692715409705],
            [19.57689216030516, 1.540710287401029],
            [19.562430240038282, 1.53500832484538],
            [19.548714240359192, 1.530035670815996],
            [19.53797436011466, 1.527239448555171],
            [19.532018880123914, 1.522516131157927],
            [19.52494524014956, 1.516699171690345],
            [19.51263108033595, 1.503554471110683],
            [19.495169280195217, 1.493083263617284],
            [19.480348455124563, 1.48237526319357],
            [19.446725520153084, 1.458082601760052],
            [19.44340919973725, 1.45672984816955],
            [19.436582880333642, 1.454910080808364],
            [19.427258879724192, 1.449746437974389],
            [19.416204720284263, 1.445236820402367],
            [19.404239040325546, 1.439390287231636],
            [19.396189079859379, 1.43290392944332],
            [19.387490039888053, 1.426635028080433],
            [19.377241919887926, 1.41969062275684],
            [19.365944040324912, 1.414292126111869],
            [19.355352119794208, 1.41067288167566],
            [19.342998719772353, 1.406598499250699],
            [19.329271560322454, 1.400296553386098],
            [19.31867316024362, 1.396455665612074],
            [19.30850568020994, 1.392395492253183],
            [19.297038959594303, 1.388770627991717],
            [19.282400279625616, 1.381131690585909],
            [19.27020348021227, 1.374839945544077],
            [19.258949159957382, 1.370994511677233],
            [19.245022199916956, 1.365356981185878],
            [19.232181719873306, 1.359504479373153],
            [19.223101440285273, 1.355229824628424],
            [19.212896520267162, 1.349838566722429],
            [19.210055040327372, 1.459232296289471],
            [19.216259307837724, 1.560290862032306],
            [19.213260060377827, 1.56348003398901],
            [19.212246436445518, 1.564639641591467],
            [19.211870377413067, 1.565070718151705],
            [19.212183171693329, 1.565947623822783],
            [19.212530039970598, 1.566920052209926],
            [19.211020601697012, 1.570897409122116],
            [19.208530956819704, 1.577457586540769],
            [19.21064012115675, 1.593580246491116],
            [19.215359999915211, 1.622379874184353],
            [19.220715163649373, 1.627897034721968],
            [19.224619920102178, 1.631919902959353],
            [19.224359332312996, 1.632807388098552],
            [19.224150120073215, 1.633519901510944],
            [19.230450120145115, 1.642789998717729],
            [19.242910080122595, 1.65236001559284],
            [19.251089932487268, 1.659795957762265],
            [19.262369879880623, 1.670050011087113],
            [19.267390079811619, 1.671490000370203],
            [19.271840437035401, 1.675115980855756],
            [19.282560120457386, 1.683849939903755],
            [19.293689880314979, 1.690639972893387],
            [19.302739919915624, 1.699009930723639],
            [19.310503407637682, 1.702043698880629],
            [19.311849016559652, 1.702569527189395],
            [19.314332560079571, 1.704892187601635],
            [19.318409999679453, 1.708620022987023],
            [19.331859320093411, 1.711989796882732],
            [19.344629879766948, 1.714650086265521],
            [19.353329200012631, 1.717208645002302],
            [19.356019920189912, 1.718000012967465],
            [19.357140449030904, 1.7198501907199],
            [19.373994566729721, 1.725781550634093],
            [19.38605891584259, 1.729822533328185],
            [19.387075555419326, 1.730833700799964],
            [19.393300079939362, 1.737029897292211],
            [19.39389484909907, 1.736920376716082],
            [19.394439839913947, 1.736820022170733],
            [19.411719839905796, 1.74528002928934],
            [19.413147826135962, 1.745938270586211],
            [19.4158198963896, 1.747169979764178],
            [19.421280000416921, 1.74907000546271],
            [19.425515910917767, 1.752415696045029],
            [19.4271800399816, 1.753730089748087],
            [19.432214225783273, 1.753779933914171],
            [19.468809182075013, 1.772579540072432],
            [19.469479693586226, 1.773969292666638],
            [19.476740159783496, 1.779109942113595],
            [19.478771361133678, 1.778616027821573],
            [19.480399368041592, 1.778220156155147],
            [19.508205412409428, 1.786108759620775],
            [19.513730084644422, 1.788790277723429],
            [19.515480119598884, 1.789639981291893],
            [19.522550160023869, 1.79155996397382],
            [19.54238524985643, 1.795909024202377],
            [19.553113316356669, 1.798330930637872],
            [19.568608442930685, 1.802619480855813],
            [19.581510397384175, 1.804472470512012],
            [19.585951049209644, 1.805110045039763],
            [19.597151360054713, 1.805229064386187],
            [19.599125040480622, 1.803768822257966],
            [19.600840079766556, 1.802499936161206],
            [19.606309919734919, 1.803480097206272],
            [19.6338868119586, 1.810899187111568],
            [19.633902493848499, 1.81090215917341],
            [19.646074241943523, 1.812973815259523],
            [19.663573655443489, 1.815952247385973],
            [19.680540120044999, 1.818839965590693],
            [19.682030160098332, 1.819690055364625],
            [19.6844612500905, 1.819623157183495],
            [19.688212721616516, 1.819520133437257],
            [19.700769960156116, 1.820109965455071],
            [19.708188704116541, 1.818186827951427],
            [19.712689920358457, 1.817019990718186],
            [19.728090278263284, 1.817176625427942],
            [19.732349880033116, 1.817219948861923],
            [19.748990160066725, 1.821760064265526],
            [19.749128686571769, 1.821786398670204],
            [19.754022301302804, 1.822716686980985],
            [19.772025424437135, 1.826139122212026],
            [19.799875930919946, 1.830799208660078],
            [19.802207066268743, 1.832102291778264],
            [19.802310120099833, 1.832159970602888],
            [19.822139999703726, 1.843220027312082],
            [19.824590626256708, 1.850149867797071],
            [19.821847947523413, 1.862603854849525],
            [19.820750040057895, 1.867590023137808],
            [19.818969572876565, 1.886210646779991],
            [19.81518328265015, 1.895977161819795],
            [19.813551891788503, 1.900193199821563],
            [19.824119999777647, 1.918470028694788],
            [19.82731866245085, 1.927685319283672],
            [19.831010040277601, 1.938320051349742],
            [19.834914137367036, 1.943486828621883],
            [19.835741401302062, 1.944580803722694],
            [19.838469960315717, 1.946449993400911],
            [19.841982916557367, 1.947051829168467],
            [19.848509999953301, 1.948170041100332],
            [19.855310040041555, 1.955320041645558],
            [19.855817919655443, 1.955852479511202],
            [19.857790080131863, 1.957920001165253],
            [19.86441012029508, 1.95821991328737],
            [19.877780159893671, 1.947310107857042],
            [19.88168004029113, 1.946660023366344],
            [19.887651826500921, 1.95237697866899],
            [19.888239959805635, 1.95294001327191],
            [19.889240039838409, 1.967449970486791],
            [19.892039226196321, 1.970533263458334],
            [19.895349959989442, 1.974180014545192],
            [19.907170020345671, 1.980280757597417],
            [19.907349912472888, 1.981081925233411],
            [19.908050039642372, 1.984200007705246],
            [19.905819171550629, 1.988700956280637],
            [19.904080061906669, 1.99221144646827],
            [19.904239723075388, 1.994588635028163],
            [19.905069960434005, 2.006949926436954],
            [19.906392073919726, 2.010950787189172],
            [19.90774008044518, 2.015029994991447],
            [19.914797262385214, 2.021410317402314],
            [19.917020159725446, 2.023420010312364],
            [19.918483843208335, 2.024741006405288],
            [19.919067657413173, 2.025267908391392],
            [19.918924667179521, 2.018559782883589],
            [19.918910295033296, 2.017896173349011],
            [19.924739974951645, 2.01911146368963],
            [19.929409919956747, 2.02008994670239],
            [19.931659920367402, 2.022860016948769],
            [19.9334401198508, 2.027940116641879],
            [19.925619839738143, 2.032230018620712],
            [19.923080040121896, 2.0352000000306],
            [19.922871862741303, 2.036749748410058],
            [19.922339880430059, 2.040710002456656],
            [19.925889840074881, 2.05179011010082],
            [19.929951159407015, 2.054426857263155],
            [19.93201992021751, 2.055769966542884],
            [19.935468862512025, 2.056012430714245],
            [19.93956011999763, 2.05630004947134],
            [19.942040160087938, 2.060010081801678],
            [19.940135136102558, 2.064841256908369],
            [19.939690080168081, 2.06596992613362],
            [19.938927002656726, 2.071533818630646],
            [19.936980000398123, 2.085730063338898],
            [19.938095757388368, 2.087197911813205],
            [19.942620119621861, 2.093149978423649],
            [19.942978012024341, 2.094046452759684],
            [19.946859839877831, 2.10376989078631],
            [19.949132174203093, 2.108827965080466],
            [19.951328512851969, 2.113716860466737],
            [19.955620080272848, 2.119280058014791],
            [19.958409928643402, 2.120765755936163],
            [19.962216586372271, 2.122792940401796],
            [19.962230040440264, 2.122800105256792],
            [19.963779840019576, 2.126949982164285],
            [19.963393109001544, 2.129124554264747],
            [19.96279991997843, 2.132460019852541],
            [19.957510079935101, 2.135860085067241],
            [19.954967347319428, 2.139975173350659],
            [19.954260000389969, 2.14111992269127],
            [19.95379704372683, 2.144740055938129],
            [19.953759960373617, 2.145030028617713],
            [19.954498078194781, 2.145923786634393],
            [19.958739840321389, 2.151059964340994],
            [19.963730159591098, 2.153869963985056],
            [19.975370040359206, 2.156750018387898],
            [19.980911009830109, 2.169396721246137],
            [19.981850714990927, 2.171540749896743],
            [19.981972310049471, 2.171684411975845],
            [19.986369840046343, 2.176879991565139],
            [19.990071543108968, 2.178974900207448],
            [19.995469920299868, 2.182030003566117],
            [19.998638947551854, 2.183079214588555],
            [20.000000160210305, 2.183529888247591],
            [20.004810120228839, 2.185120001647917],
            [20.00741421496495, 2.182960166903173],
            [20.014959239596415, 2.176706012385062],
            [20.016527076448309, 2.17688777068435],
            [20.019298495880808, 2.177209218710982],
            [20.022693479969472, 2.180695089769354],
            [20.026838160264994, 2.200984125725076],
            [20.03821235979624, 2.207080111304907],
            [20.041153199694694, 2.210331065110255],
            [20.041799379438153, 2.214249147503055],
            [20.037809159964123, 2.224564146126292],
            [20.038548506680616, 2.227347370242487],
            [20.041117530289707, 2.237020897409252],
            [20.042241611069358, 2.241139144602609],
            [20.042440199832598, 2.241867156004595],
            [20.045150279602524, 2.245346030581727],
            [20.048445824680819, 2.247331007132095],
            [20.054472479988156, 2.250960981652839],
            [20.05682721946939, 2.252575350877358],
            [20.057197365790607, 2.252829083585324],
            [20.060857440024673, 2.252635125360035],
            [20.064884632359142, 2.25048783212088],
            [20.068905240042589, 2.248344047315068],
            [20.072786400447836, 2.249073065375817],
            [20.077277257317892, 2.256160419281983],
            [20.082470366771428, 2.264356005932024],
            [20.082914079724549, 2.264741478416242],
            [20.085417258619927, 2.266915965599584],
            [20.087272853705112, 2.267571244363046],
            [20.096813159651823, 2.270940002032821],
            [20.101122360103428, 2.274664989450428],
            [20.101480698070269, 2.277386374136718],
            [20.101547131180482, 2.277890897466594],
            [20.097595440448995, 2.284525065280925],
            [20.099367322431164, 2.290294973449028],
            [20.100798347661911, 2.29176347561003],
            [20.102310359608815, 2.293314991429042],
            [20.104905971553666, 2.293879587266451],
            [20.110071240419895, 2.29500313235607],
            [20.112777360416082, 2.298711128782823],
            [20.109942925064729, 2.302746096497535],
            [20.106516240328023, 2.307624145230249],
            [20.10894623976542, 2.313538151614399],
            [20.109527457839079, 2.314952754682152],
            [20.110313160319194, 2.316865039748223],
            [20.109346052050618, 2.320596808606397],
            [20.109123359691658, 2.321456110098923],
            [20.103114627570879, 2.325197434149796],
            [20.097847350512545, 2.328477243360539],
            [20.097326525277118, 2.329715243819554],
            [20.096208359903624, 2.332373122820976],
            [20.096469024947957, 2.333107568899687],
            [20.096922287890852, 2.334384677944163],
            [20.097765360378265, 2.336760109277098],
            [20.102985360001487, 2.340954034856145],
            [20.108232360287236, 2.342387122168444],
            [20.132477279849525, 2.3423961265794],
            [20.142261359818278, 2.347555086876363],
            [20.148734715875381, 2.347619264184601],
            [20.158500240243587, 2.347716079530287],
            [20.161710489387314, 2.349188501632379],
            [20.162599331038479, 2.349596277845089],
            [20.170511279734274, 2.359109014358761],
            [20.173351319674687, 2.361092585129047],
            [20.1761913596151, 2.363076153030003],
            [20.183712480076899, 2.36591112797166],
            [20.186522632169481, 2.367645919637329],
            [20.188259280429563, 2.368718004539376],
            [20.192027999609017, 2.373203377477439],
            [20.193912359647928, 2.37544605886993],
            [20.197254239828542, 2.384683077403083],
            [20.20919825511756, 2.389741704620311],
            [20.221172280425282, 2.39481302255184],
            [20.232150477426455, 2.40519016695111],
            [20.232732239879187, 2.405740075638886],
            [20.235223568199352, 2.405764859433478],
            [20.235248279954508, 2.405765105202291],
            [20.236043724663848, 2.405491592524613],
            [20.239151399676867, 2.404423020820698],
            [20.249776980979579, 2.393710246792244],
            [20.255956378631321, 2.393310212893558],
            [20.258688200326098, 2.394718103522878],
            [20.261162159720254, 2.399114093859694],
            [20.258320845968758, 2.410701447170901],
            [20.258066178975579, 2.411740107932314],
            [20.265102360100901, 2.417331142371699],
            [20.271478137558589, 2.418179764475302],
            [20.276296337823233, 2.418821070355406],
            [20.280410279566375, 2.419321110909455],
            [20.284559279860101, 2.416139069582944],
            [20.289230280385663, 2.406058984101188],
            [20.290771882838023, 2.404442873898413],
            [20.292927459532535, 2.402183111622085],
            [20.297043359602984, 2.402453018847975],
            [20.299095487207719, 2.404226212218004],
            [20.301353279605163, 2.406177112114986],
            [20.309478480264591, 2.417531022040262],
            [20.313012401388335, 2.419514584997529],
            [20.314483200426601, 2.420340132615617],
            [20.321817480292438, 2.41903011544104],
            [20.334873454494637, 2.41459412652744],
            [20.336963400274509, 2.413884030887974],
            [20.343361320305622, 2.414636010854929],
            [20.354486399940601, 2.423487050199737],
            [20.3612956800999, 2.42907510985713],
            [20.36470032017953, 2.431869130451773],
            [20.371330440338543, 2.432163003619018],
            [20.375919359999948, 2.430825987480075],
            [20.383308359843014, 2.423533148404964],
            [20.387674439821769, 2.42150411116248],
            [20.3913250853386, 2.422458997194362],
            [20.400169320009319, 2.430597118657903],
            [20.402384972436792, 2.430541685269936],
            [20.406805200165955, 2.43043109497186],
            [20.416670280325519, 2.427303101386769],
            [20.422305881921691, 2.424363205865933],
            [20.427934320351806, 2.421427040960705],
            [20.434160513043317, 2.421068996112579],
            [20.434801148384828, 2.421032155610418],
            [20.438875440287948, 2.425673105773281],
            [20.439550080456218, 2.4272899556786],
            [20.442964410662839, 2.428703287980003],
            [20.445894297403012, 2.433333894797764],
            [20.451174840781444, 2.431312535425846],
            [20.456455320379519, 2.429291073595488],
            [20.470438440396581, 2.42620215217048],
            [20.478330360254795, 2.426078083286669],
            [20.479183416618284, 2.426065148996686],
            [20.479589279955231, 2.426058995834558],
            [20.485472001797863, 2.430039102727123],
            [20.489591160057849, 2.432826018544344],
            [20.493925199825398, 2.43401807733675],
            [20.49623316043651, 2.431967988111236],
            [20.499290280061949, 2.423023008639591],
            [20.509620665080835, 2.419208050272509],
            [20.509971237112033, 2.418098688629719],
            [20.510563320309057, 2.416225144011609],
            [20.508102816779555, 2.410100345774947],
            [20.505645360335478, 2.403983102312989],
            [20.507526359776914, 2.398478072573951],
            [20.51121527981304, 2.395291119829112],
            [20.516473439869564, 2.395570055083116],
            [20.520796319866303, 2.398142054183686],
            [20.525957280412452, 2.409006055200006],
            [20.535265440130186, 2.416457075635219],
            [20.542587480450269, 2.416296092026767],
            [20.546495280395273, 2.414262001970708],
            [20.553673319877003, 2.404894092206103],
            [20.555056369681701, 2.404560004521012],
            [20.555507199088492, 2.404451146917589],
            [20.56254213784376, 2.410499994292642],
            [20.567053440369687, 2.417445128406271],
            [20.566791363173753, 2.420895021794959],
            [20.568434252471011, 2.420831538263136],
            [20.571598409057536, 2.420709099791258],
            [20.580156359630337, 2.410434029096555],
            [20.588159160340712, 2.410737991589921],
            [20.596594320197365, 2.415077006527174],
            [20.60616743980475, 2.41757910104057],
            [20.616633820774521, 2.423665428080997],
            [20.62346039979122, 2.427635150420976],
            [20.625855561663581, 2.427346679467154],
            [20.637659519718333, 2.425925024050039],
            [20.640154320027083, 2.428250088985078],
            [20.638874068033608, 2.431384112410067],
            [20.637813240328082, 2.4339809832968],
            [20.638487937090201, 2.435136572297361],
            [20.639164313701894, 2.436295039878998],
            [20.651293440329933, 2.435717029157785],
            [20.659263480380229, 2.439702129033112],
            [20.665661400411338, 2.440452113889373],
            [20.667800626869383, 2.439481948362131],
            [20.668647239617325, 2.439097999380704],
            [20.669594945174094, 2.437337560539894],
            [20.670742439643291, 2.435205993225089],
            [20.671013160428895, 2.430605041843621],
            [20.667848565464521, 2.426434299818534],
            [20.666519294202633, 2.42182009560022],
            [20.667575880063396, 2.418838069800097],
            [20.668632480297212, 2.41585599669631],
            [20.670709319657067, 2.413804078806569],
            [20.675981520381459, 2.412702038730835],
            [20.68053445173598, 2.415045141740162],
            [20.690319239577146, 2.420658138573494],
            [20.699466608943872, 2.420972090220304],
            [20.701500239338575, 2.422363220841008],
            [20.703558240128601, 2.423771021407235],
            [20.706805260011851, 2.431394557383625],
            [20.710052279895137, 2.439018048810139],
            [20.711643300467891, 2.440183541631757],
            [20.713234188988267, 2.441348937654517],
            [20.721170889863423, 2.440282381505533],
            [20.722854277908628, 2.44005616258285],
            [20.728775160184526, 2.443101995604653],
            [20.735172359766796, 2.443851078615996],
            [20.737934280413487, 2.442035093003942],
            [20.738714448373116, 2.440198946962112],
            [20.739103189820721, 2.439284034471329],
            [20.73813614533254, 2.433223845050451],
            [20.737154169945999, 2.427070061185113],
            [20.739742200109884, 2.419270150542349],
            [20.744133411357033, 2.414247134860126],
            [20.748254400383605, 2.41382406727916],
            [20.753872074301633, 2.415560448364272],
            [20.756695148659599, 2.416433018495836],
            [20.758415143052655, 2.416816393017956],
            [20.764229515678565, 2.418111932012086],
            [20.76824448014538, 2.416056056392384],
            [20.774309261750023, 2.415903099013935],
            [20.777260200508909, 2.418920992462935],
            [20.77748748056398, 2.420119005436613],
            [20.778256883113261, 2.424178903505075],
            [20.778789240021997, 2.426987978423537],
            [20.776645440240831, 2.436403991569793],
            [20.777011615110215, 2.436873203047148],
            [20.778454439712238, 2.438722015891971],
            [20.783922480355081, 2.441072088268359],
            [20.790589951565309, 2.436541465328254],
            [20.794281341070157, 2.434033117707412],
            [20.800735200092323, 2.434681992169185],
            [20.801192371605055, 2.434728257142497],
            [20.801822399639672, 2.434792014689601],
            [20.804241094677526, 2.437888974856278],
            [20.804537159632243, 2.438268063143498],
            [20.804583298901861, 2.438538966920832],
            [20.804746319769723, 2.439496130308985],
            [20.806188948539013, 2.44790594565889],
            [20.806370279767311, 2.448963013998763],
            [20.807144279894207, 2.453479090984821],
            [20.81229839976946, 2.465491994012095],
            [20.819090160085768, 2.473378092376778],
            [20.822516456750289, 2.47619365835404],
            [20.842025399744198, 2.492225054095769],
            [20.845667160024568, 2.494329067867977],
            [20.853360543221875, 2.494511555212788],
            [20.861221320285811, 2.494698012514884],
            [20.863605305319417, 2.49632848458283],
            [20.865995280319368, 2.497963051967244],
            [20.873935439708344, 2.505398084380923],
            [20.878548428829479, 2.51499403445482],
            [20.884268160346949, 2.526892132384656],
            [20.888349479770564, 2.53107105352911],
            [20.890378979711578, 2.5347200589637],
            [20.892408479652627, 2.538369053069713],
            [20.903644440139736, 2.56043511022166],
            [20.91137384488162, 2.569700819213054],
            [20.912927483860422, 2.571563306404552],
            [20.9163034721741, 2.57780698664051],
            [20.915865320690909, 2.578966764517041],
            [20.911201200362086, 2.591312143413705],
            [20.910642730326394, 2.592789929278502],
            [20.909977199973419, 2.594551008294171],
            [20.909230394545091, 2.606018494201732],
            [20.909183400079336, 2.606740111992153],
            [20.908158319033909, 2.608313031360014],
            [20.907095222183948, 2.609944090964103],
            [20.902729320071582, 2.611975988436577],
            [20.900219199894003, 2.615603283234102],
            [20.896240319853831, 2.62135301472604],
            [20.895089789977277, 2.624465231933399],
            [20.892254399716773, 2.632135012785813],
            [20.881639440093977, 2.642166150874271],
            [20.872545480062477, 2.661186126157638],
            [20.863406371603123, 2.669029403964491],
            [20.85848028007959, 2.673257005978313],
            [20.855347414509392, 2.677722605643639],
            [20.85222240021476, 2.68217699701886],
            [20.848901690630441, 2.685456897613694],
            [20.842294320305989, 2.691983041803775],
            [20.83332024044914, 2.697656029817742],
            [20.832630989182782, 2.702620407905363],
            [20.832586212657461, 2.702942918308057],
            [20.830382280549522, 2.706260066850582],
            [20.82817836011964, 2.709577119473049],
            [20.827385366014386, 2.711762527313045],
            [20.823017399573526, 2.723800105622401],
            [20.824354253514716, 2.727724231177234],
            [20.824057892115956, 2.72812012138492],
            [20.82041748020686, 2.732983098811689],
            [20.813284440032664, 2.737291118394197],
            [20.806481095940786, 2.743646532575863],
            [20.804744160219801, 2.745269103657944],
            [20.802162243091434, 2.752610199204039],
            [20.802524399796539, 2.763200112433347],
            [20.79762227981638, 2.773743029010511],
            [20.797097186685043, 2.777452792913892],
            [20.796646320447305, 2.780638134447844],
            [20.800392480235018, 2.796553136574735],
            [20.796396480102164, 2.808255046229107],
            [20.797924320364359, 2.816554050402317],
            [20.79741132035338, 2.822763052905944],
            [20.796437204327248, 2.824322857407665],
            [20.795553360004039, 2.825738112777005],
            [20.793243239843001, 2.828019041124998],
            [20.786829479818472, 2.828651061773164],
            [20.783827090051698, 2.827451298379831],
            [20.779760159842322, 2.825826138601168],
            [20.772199439846172, 2.826678134543807],
            [20.768049916732966, 2.827473034279099],
            [20.766468193723405, 2.827776090335271],
            [20.76181323261725, 2.83416663737317],
            [20.7611391646758, 2.835092049405435],
            [20.76202224004113, 2.838553087260202],
            [20.763533016804491, 2.840043162376393],
            [20.768146199961731, 2.844593122212096],
            [20.767896359616589, 2.846892013514293],
            [20.763969480353264, 2.850999080816604],
            [20.756391480364346, 2.85369199552531],
            [20.75383547963191, 2.858042047633443],
            [20.75853528014548, 2.869823070118037],
            [20.760130213779625, 2.870528048555252],
            [20.757574261556229, 2.87487714799445],
            [20.752285319828196, 2.877591154556704],
            [20.747345398740848, 2.877765283342593],
            [20.736715319573538, 2.878139985117178],
            [20.734615477054174, 2.882724047761684],
            [20.735508231766691, 2.885187442209336],
            [20.735954280339534, 2.886418138909932],
            [20.736403380489445, 2.887343080087704],
            [20.736852479740993, 2.888268020502308],
            [20.743684199816084, 2.892013134247034],
            [20.745077263141223, 2.897170940265005],
            [20.745678239659572, 2.899396045219563],
            [20.74311957721897, 2.904996220432115],
            [20.74264128002573, 2.906043070694634],
            [20.735767439743597, 2.906901126134484],
            [20.728170365826244, 2.911895184304744],
            [20.728342439915558, 2.918111044135726],
            [20.733528239777613, 2.926674014390852],
            [20.73944124023518, 2.93087114697663],
            [20.740565745019659, 2.932952231872196],
            [20.741691239747539, 2.935035144466576],
            [20.740071240422051, 2.937091578633371],
            [20.738451197977408, 2.939148014381665],
            [20.728824480388568, 2.940441082456932],
            [20.726215716209612, 2.942047992278862],
            [20.723301360442392, 2.943843133684044],
            [20.714821336923833, 2.944917134096165],
            [20.718675360122663, 2.949095135177331],
            [20.72282393281834, 2.957804460090975],
            [20.724291359581034, 2.960885091959589],
            [20.724031872228068, 2.96580503125079],
            [20.72401235992178, 2.966174989749641],
            [20.721729610529106, 2.968542247023],
            [20.719391400049133, 2.970967012772917],
            [20.720688546658153, 2.975002585775988],
            [20.722730400230951, 2.981354998373713],
            [20.721363595559868, 2.983576114705799],
            [20.718082457662124, 2.988908087037507],
            [20.718490485938876, 2.994435083175166],
            [20.72785850220064, 2.993665547654106],
            [20.728571244411665, 2.993606999363373],
            [20.729948956426938, 2.994315601538542],
            [20.732671440134322, 2.995716046254538],
            [20.73338636884478, 2.998319328714192],
            [20.73355844383239, 2.998946088478092],
            [20.731833824912272, 3.001215235057697],
            [20.728693440443138, 3.005347146511554],
            [20.727262440365209, 3.011548073931146],
            [20.728359345310864, 3.016852051008449],
            [20.725116480135789, 3.020966116783371],
            [20.722110567176497, 3.021831438539934],
            [20.718919439571884, 3.022750078291681],
            [20.717985261745007, 3.0248130482424],
            [20.720682359960779, 3.030362118261378],
            [20.721468542141245, 3.035618289505362],
            [20.72154418927132, 3.036124044150672],
            [20.717085239661838, 3.04335109196352],
            [20.706741786850507, 3.060107218551691],
            [20.703886199767499, 3.06473314887062],
            [20.702705400259113, 3.068636030578146],
            [20.704277160053863, 3.07187210295898],
            [20.707054179583835, 3.071375603605061],
            [20.707946333323431, 3.071216039537029],
            [20.715128279578337, 3.062074048431752],
            [20.717733589734983, 3.061911569682138],
            [20.718334303945284, 3.061874107092755],
            [20.720802225762412, 3.06742019672638],
            [20.720482220705382, 3.068732994340969],
            [20.719850399633422, 3.071324989286401],
            [20.713131359736021, 3.080240025345224],
            [20.713562279781172, 3.083006161875771],
            [20.718996479988959, 3.089729984971968],
            [20.721674160221571, 3.097351081611615],
            [20.726864280081838, 3.105684067528321],
            [20.727693946111938, 3.111263776905521],
            [20.72837231967851, 3.1158259850579],
            [20.719746782558691, 3.125379555583115],
            [20.718891360032746, 3.126327009293239],
            [20.721508942074507, 3.127846998570017],
            [20.72412828032266, 3.129368005104119],
            [20.725082698091242, 3.135681384664239],
            [20.725208279873009, 3.136512095853656],
            [20.728134360451349, 3.142064037450435],
            [20.727180360399384, 3.146198056434642],
            [20.723467319699559, 3.151919107047802],
            [20.724455766549386, 3.156957658330811],
            [20.724779160051671, 3.158606132188818],
            [20.728086559298429, 3.164784377703901],
            [20.732208479877922, 3.172484102879119],
            [20.733431184895974, 3.18835188665712],
            [20.736485382301822, 3.191206840010842],
            [20.743654320053096, 3.197908052691667],
            [20.750437440372984, 3.207407005279014],
            [20.759371626946358, 3.209973176262179],
            [20.76368147957486, 3.211211095625548],
            [20.766405239788281, 3.213998113134682],
            [20.766480895901495, 3.215096684254243],
            [20.76721416012521, 3.225744064117138],
            [20.770113240041059, 3.234287076763013],
            [20.770925244294357, 3.234458229609824],
            [20.772400320211709, 3.234769143768354],
            [20.7786394243888, 3.228380126308436],
            [20.779879169549456, 3.228980550200111],
            [20.782514520267576, 3.230257063756599],
            [20.785207799745084, 3.236265728364291],
            [20.786554439932985, 3.239270047132783],
            [20.790639900590051, 3.24333556201575],
            [20.794725360348789, 3.247401059430577],
            [20.79655397722934, 3.24741734680532],
            [20.800220399857526, 3.247450002814824],
            [20.805980400154223, 3.243359043776393],
            [20.81201148056266, 3.234667105079747],
            [20.812286160223739, 3.229605127583771],
            [20.820600360130722, 3.221854014669755],
            [20.823442200294952, 3.211290992329616],
            [20.826353765894922, 3.20606631911156],
            [20.827398239770723, 3.204192051654883],
            [20.838928320359972, 3.195088059474244],
            [20.841491159966647, 3.190277983835045],
            [20.841929658199547, 3.189788066966674],
            [20.850279479900834, 3.180459094482551],
            [20.852224431305633, 3.180065467964789],
            [20.854637280107607, 3.179577146215238],
            [20.867750280262381, 3.17255914378084],
            [20.884052160436902, 3.1674110054783],
            [20.888670066935912, 3.163079282921935],
            [20.891718310308033, 3.15505013755576],
            [20.893805174866465, 3.152824784272474],
            [20.895879240228748, 3.150613153331667],
            [20.897497440228715, 3.148886995410723],
            [20.907545400312177, 3.125958986611796],
            [20.915401320185406, 3.117974032624922],
            [20.924848440294411, 3.111152131286196],
            [20.930881409859914, 3.101999041605295],
            [20.938371119829441, 3.098454999934184],
            [20.943131400317828, 3.096713457763206],
            [20.947190039975453, 3.096681423632229],
            [20.952984240033377, 3.100233251813792],
            [20.956749480037708, 3.103801083964305],
            [20.961076319808253, 3.107743052955387],
            [20.96648963957557, 3.11072975411658],
            [20.974453919628282, 3.112181889103154],
            [20.979602999954782, 3.111383925335486],
            [20.982530879858608, 3.11022495186351],
            [20.988318240143933, 3.104688676907082],
            [21.002812559948158, 3.092078210669468],
            [21.013677359916095, 3.082336494725166],
            [21.022108455794374, 3.074147301859153],
            [21.022717679745345, 3.073555555161569],
            [21.033041039938695, 3.064385801718829],
            [21.036289680382708, 3.060952094769867],
            [21.039522479935041, 3.056761046306057],
            [21.040545599958204, 3.052776772320797],
            [21.04240715985685, 3.044809619855182],
            [21.042921599867242, 3.034202134402851],
            [21.043227960413429, 3.022459950147398],
            [21.043601639808699, 3.01393624896505],
            [21.045659760074674, 3.006535211975311],
            [21.051976679914933, 2.999858017784532],
            [21.076100640425924, 2.980164384606264],
            [21.094778160285042, 2.964679277749733],
            [21.106549440324716, 2.954171619265509],
            [21.117216062957816, 2.945278183666919],
            [21.131528040030712, 2.931251295979549],
            [21.138261840146559, 2.926842850139318],
            [21.144810960114725, 2.922435826390362],
            [21.14704044030935, 2.923175791422504],
            [21.147901920175226, 2.929039335523584],
            [21.148469279939025, 2.947214036230331],
            [21.151032120443997, 2.981278863687354],
            [21.151655279959972, 3.002103132448589],
            [21.154438440373237, 3.037868637598654],
            [21.154218840015485, 3.062485466693187],
            [21.154598999857217, 3.071760160549502],
            [21.156190200093022, 3.077238660125085],
            [21.160652399807208, 3.087617153753029],
            [21.164709959689855, 3.096294853932293],
            [21.165458760276405, 3.1055665498513],
            [21.165277320351958, 3.114466716802344],
            [21.165272279904876, 3.122986726822656],
            [21.16583279989608, 3.132070304525198],
            [21.16620467996583, 3.140965924820273],
            [21.167475119661447, 3.148718374539844],
            [21.168897839967393, 3.154954987801079],
            [21.170284200063922, 3.163246119865366],
            [21.181514399655118, 3.161961055538566],
            [21.185741159916496, 3.149568137230405],
            [21.187706554282208, 3.14835671325811],
            [21.191265359637651, 3.146163145106218],
            [21.192893251561234, 3.146365956231448],
            [21.197212199631977, 3.14690403399918],
            [21.202567473858913, 3.14587525076247],
            [21.205238399658885, 3.145362148226394],
            [21.208004280079347, 3.143314034662393],
            [21.209817075831122, 3.139744713105144],
            [21.211263359845297, 3.136897030607104],
            [21.211290416203344, 3.133667908070058],
            [21.211317360271984, 3.130452092909233],
            [21.213544814765655, 3.12853828237732],
            [21.22192728034603, 3.121336107332168],
            [21.235470480097089, 3.117077994294525],
            [21.237727116362738, 3.116989340931162],
            [21.240280440115622, 3.11688903236171],
            [21.24327178329936, 3.113562730705923],
            [21.243978360372605, 3.112777031876408],
            [21.245794199616544, 3.114634083555156],
            [21.245315429011168, 3.116931906551032],
            [21.246242342162351, 3.11835551934848],
            [21.246671160149727, 3.119014041895568],
            [21.249106067981863, 3.118709644663302],
            [21.250110317994164, 3.118583942651923],
            [21.254074199762364, 3.110101136136865],
            [21.264408360400381, 3.10627507455948],
            [21.268787400373764, 3.102860041968472],
            [21.270466113586238, 3.101200796420393],
            [21.273866281852385, 3.097839869437792],
            [21.273871627726646, 3.097231991722614],
            [21.273882480273581, 3.095998087903204],
            [21.273926959456563, 3.09537738515371],
            [21.273958440017378, 3.094938079664519],
            [21.274400159608906, 3.088867035875038],
            [21.27966119966419, 3.08937202815919],
            [21.284821797290945, 3.084387243425183],
            [21.289818240375968, 3.079560998165094],
            [21.294491400451452, 3.068322159178817],
            [21.29792220037049, 3.068581139257368],
            [21.302696160404011, 3.072534038519934],
            [21.305465280149406, 3.069796129221034],
            [21.307983698065279, 3.070609843236638],
            [21.309120186375605, 3.070977048289708],
            [21.309404396263528, 3.064304184143146],
            [21.314672279684665, 3.063887996629813],
            [21.319730096568179, 3.058148620057996],
            [21.320913239781127, 3.056806039739839],
            [21.328018200416185, 3.055945043188291],
            [21.329826480337015, 3.058722042293347],
            [21.333503159929094, 3.056911144819891],
            [21.335186159902118, 3.047258011544292],
            [21.335926569325583, 3.046526930737248],
            [21.337034399581736, 3.04543305618966],
            [21.347036367719273, 3.041964620484598],
            [21.348053280383823, 3.041611979250928],
            [21.351927239893769, 3.04394609398541],
            [21.352952514076971, 3.043680529871783],
            [21.355367400258032, 3.043055030784368],
            [21.359085479608311, 3.036411000569697],
            [21.361221359841899, 3.034073089910656],
            [21.365555399609445, 3.029329041120649],
            [21.368784240286306, 3.026365147305169],
            [21.373862444435215, 3.024407053832121],
            [21.375213480079783, 3.023886109929168],
            [21.376945020519166, 3.023428928713795],
            [21.380455439918482, 3.022502065965033],
            [21.393797399977899, 3.018978054078584],
            [21.397327199631128, 3.020264013678297],
            [21.401556479666866, 3.021804103654989],
            [21.405374760697182, 3.019750746793203],
            [21.406614479806723, 3.019084062375799],
            [21.407631479607861, 3.01418714326392],
            [21.408113666506267, 3.011867521574742],
            [21.408285240233962, 3.011042145115366],
            [21.409170354775004, 3.010495649501811],
            [21.410125200141636, 3.009906099876924],
            [21.413198309779141, 3.010189484318443],
            [21.414245400447349, 3.010286041587765],
            [21.418359637736234, 3.010664991555538],
            [21.421134833686164, 3.009045325578631],
            [21.434690157100317, 3.001134028985537],
            [21.434632120543071, 2.999849333443811],
            [21.434562360073041, 2.998305118200894],
            [21.434303168265814, 2.992614175965],
            [21.435848607422713, 2.989494755435095],
            [21.438959399589766, 2.983216059498152],
            [21.439190526230902, 2.980112920641733],
            [21.439216439931908, 2.97976499422969],
            [21.441462816538738, 2.979643049041729],
            [21.442880344582328, 2.979565933435577],
            [21.449341440432445, 2.973405134115222],
            [21.450975480425829, 2.969505145251144],
            [21.457163519870587, 2.968636160001207],
            [21.461569200282021, 2.961537015993129],
            [21.465047645945415, 2.955814864400739],
            [21.468530160078725, 2.950085990528287],
            [21.471296399825295, 2.947807110573777],
            [21.475885320385029, 2.946464008084049],
            [21.479767042237327, 2.947647049497691],
            [21.481417584282497, 2.95075074217107],
            [21.482471241635423, 2.952732043471283],
            [21.485677319901292, 2.952528118782856],
            [21.487872145787222, 2.94886413410083],
            [21.488695200216849, 2.947490144932247],
            [21.492822374144101, 2.94660297246946],
            [21.499992360229324, 2.937454986226705],
            [21.510717014029755, 2.938153752369759],
            [21.512117173147367, 2.938244968392922],
            [21.518985555265829, 2.932458389785571],
            [21.524563277509916, 2.927759164945222],
            [21.529434286136858, 2.926699022379384],
            [21.533735160104104, 2.9257630554161],
            [21.543083279580621, 2.930212004666072],
            [21.556406160321718, 2.924336047208557],
            [21.563240376814978, 2.928304041107302],
            [21.563596662131385, 2.928069369691144],
            [21.56876331979306, 2.924666292578868],
            [21.571241399759401, 2.929520103017727],
            [21.573753480060947, 2.930231084158577],
            [21.575367361859367, 2.928863116676642],
            [21.576183299835321, 2.927028065823106],
            [21.576999315066363, 2.925192830386129],
            [21.578798150100315, 2.920949375698412],
            [21.57933239975933, 2.91968907746096],
            [21.582554399765293, 2.917643051705529],
            [21.588508439756655, 2.917001001463865],
            [21.592201319566556, 2.913348129931668],
            [21.599727479577076, 2.916631106815273],
            [21.601730544794236, 2.916372823734543],
            [21.604768382980442, 2.915981248875486],
            [21.606622725814109, 2.917120269353818],
            [21.608185280572137, 2.918080060506821],
            [21.610706399722076, 2.917639991726592],
            [21.613031280101556, 2.913055992898783],
            [21.614061026098277, 2.91294920839987],
            [21.615093360141298, 2.912842155644642],
            [21.615836540867441, 2.915458989587251],
            [21.616207200126706, 2.916764124791225],
            [21.621467160407043, 2.917267037311079],
            [21.627004320122822, 2.911788087191859],
            [21.629236320091806, 2.918940110810414],
            [21.633781320220685, 2.922889057074642],
            [21.640413239705222, 2.923632982233419],
            [21.647077196706039, 2.920464139162612],
            [21.653442356077068, 2.925809134494629],
            [21.663555476357956, 2.920596081895657],
            [21.672487404566695, 2.919977075282044],
            [21.675447356122831, 2.921842018570206],
            [21.683258276688523, 2.918221021786263],
            [21.685768196541787, 2.919162046610485],
            [21.690298436452224, 2.925182028408883],
            [21.698547476161782, 2.924097012609272],
            [21.705166436550019, 2.926450998996607],
            [21.711906439532893, 2.925844118068653],
            [21.721958276745092, 2.924939033567532],
            [21.723371952812798, 2.92481124054091],
            [21.723949436589823, 2.924759037889538],
            [21.740370476490121, 2.932254047686937],
            [21.74177103715467, 2.932510410536225],
            [21.745626476098391, 2.93321611976169],
            [21.748850276328167, 2.930710051114571],
            [21.76816069164434, 2.927856828677662],
            [21.774373916256383, 2.926938787987359],
            [21.781391396254133, 2.92590201247621],
            [21.783960901360203, 2.928340801143249],
            [21.784570248380376, 2.928919066396136],
            [21.786709316734928, 2.92756625254009],
            [21.787871677423759, 2.926831178421596],
            [21.790321196353982, 2.925282106556449],
            [21.792875109401667, 2.924762048174192],
            [21.794677196336941, 2.924395086019052],
            [21.798137156468396, 2.920970114490111],
            [21.802597039427464, 2.918477614585418],
            [21.810322120577883, 2.914160277199191],
            [21.818567155597876, 2.913534067708794],
            [21.821538548097475, 2.911290539829474],
            [21.827316235323821, 2.906928126103026],
            [21.831765078886356, 2.90718630028589],
            [21.836466355331925, 2.907459123244065],
            [21.841505228542754, 2.907038110279388],
            [21.846336475938575, 2.903854100423529],
            [21.856643275689667, 2.903013142797723],
            [21.858357446304709, 2.902262889604552],
            [21.873178435767031, 2.895776056484298],
            [21.889385275082837, 2.901425005253433],
            [21.8939632200264, 2.901460104301031],
            [21.901081228690963, 2.898523080312349],
            [21.90997943594056, 2.902044024001637],
            [21.917066395235647, 2.903019082197417],
            [21.934035862905123, 2.900338054192019],
            [21.939295315637334, 2.89950710494246],
            [21.946872235851309, 2.896343058631595],
            [21.948472106626234, 2.897568105307554],
            [21.949604275836677, 2.898435024018511],
            [21.955091395797876, 2.899167084930287],
            [21.964632396142278, 2.908676915037812],
            [21.965530900970915, 2.908774091825486],
            [21.966919195140264, 2.908924132234275],
            [21.969753830815939, 2.907741593103039],
            [21.980465079955714, 2.903273118854963],
            [21.982513316956922, 2.904900076566214],
            [21.990059142885631, 2.905877994475996],
            [21.996029519638743, 2.903392041390899],
            [22.002439319889497, 2.90321006242161],
            [22.012487279972962, 2.906278149592542],
            [22.030048440072317, 2.914466096277537],
            [22.038278399565222, 2.915909136947386],
            [22.040095036513154, 2.91737797512745],
            [22.043737439987247, 2.920323026434253],
            [22.046115417088231, 2.920873340684326],
            [22.047851159846505, 2.921275028512617],
            [22.05104220031453, 2.922910117361134],
            [22.053813095130891, 2.922721968371199],
            [22.060203480093413, 2.922288049364713],
            [22.063167494729548, 2.923691279573439],
            [22.06906740044526, 2.930641112985082],
            [22.076372520098648, 2.933227099584651],
            [22.087137239659093, 2.932157031012699],
            [22.10026882326212, 2.939220250333841],
            [22.10058810337873, 2.939391985124732],
            [22.104531208911023, 2.941811508432282],
            [22.108562314306884, 2.944285017308278],
            [22.116573366941466, 2.944344272712523],
            [22.133938313423208, 2.948615995587762],
            [22.14478684579964, 2.948251539504908],
            [22.145157177173829, 2.948239098524644],
            [22.149696234048779, 2.953566129118967],
            [22.153804280148702, 2.954977165151948],
            [22.159940490394852, 2.961007131367703],
            [22.164558541522602, 2.961246822661038],
            [22.185796313840417, 2.962349131351178],
            [22.19194223397643, 2.966997000083358],
            [22.204506232338588, 2.970542061116189],
            [22.212236154510066, 2.977733116930648],
            [22.221393472718514, 2.977570052808749],
            [22.224125514500546, 2.9796611405516],
            [22.230980272769397, 2.981322061256062],
            [22.238493474581951, 2.986901094394159],
            [22.242301598361355, 2.987184360244383],
            [22.252220272909085, 2.987922155580121],
            [22.259521433687034, 2.991196987886188],
            [22.266384472626196, 2.99170706772299],
            [22.269243774242938, 2.992736919857567],
            [22.275516233764826, 2.994996107258076],
            [22.280242523799505, 2.995169802064212],
            [22.283298351647584, 2.995282105628867],
            [22.303566353988593, 3.009698038867452],
            [22.31135157555066, 3.009293958739477],
            [22.316230427368328, 3.008804180013219],
            [22.31776619166962, 3.00865000714239],
            [22.334067528363395, 3.020579442658395],
            [22.341905272623489, 3.02631511333432],
            [22.354685272692318, 3.031930988615285],
            [22.357987694374096, 3.031803842136792],
            [22.364759340512858, 3.031542971048858],
            [22.372360193642638, 3.024922073194321],
            [22.401750231961028, 3.012242083709363],
            [22.411797621614269, 3.008793730172115],
            [22.416208191555807, 3.007279980528999],
            [22.434091191970328, 3.003263124679289],
            [22.45356565133546, 3.000638042162548],
            [22.46227018989465, 2.99977900437023],
            [22.468246190999757, 2.996368129111558],
            [22.470345114542557, 2.994895973175838],
            [22.473768230272658, 2.992495043634549],
            [22.47455975293747, 2.989652601330963],
            [22.475879272088637, 2.984914047186374],
            [22.480720193441766, 2.980113989947766],
            [22.485691534902791, 2.978752025550624],
            [22.486454119239038, 2.978543105085356],
            [22.508854191160253, 3.016216070186028],
            [22.508951390670624, 3.035090144459637],
            [22.512555735221056, 3.041164109146598],
            [22.518003231393379, 3.050344050805442],
            [22.51631411119833, 3.056437927598056],
            [22.514246271160999, 3.063898074773359],
            [22.51624319100328, 3.0728880420919],
            [22.518744190585803, 3.079133267617946],
            [22.521419271093979, 3.085813147386466],
            [22.527597847685541, 3.091740942300807],
            [22.527778497092545, 3.091914259188767],
            [22.533018473451055, 3.09694201494706],
            [22.540792309765209, 3.098145998462019],
            [22.541721311499444, 3.098749396619151],
            [22.543300430292984, 3.099775053396029],
            [22.549877271372516, 3.108797109920287],
            [22.551208191042946, 3.115021009464329],
            [22.555076390555271, 3.118500062740494],
            [22.557329270964754, 3.123810055286155],
            [22.557346296734309, 3.124467926009756],
            [22.557871431188179, 3.144759105886921],
            [22.555631151447184, 3.163267894159514],
            [22.555909430657604, 3.170488410172578],
            [22.559147270656947, 3.178002018436015],
            [22.566163670879718, 3.194638004548586],
            [22.570479711103925, 3.203497810421327],
            [22.578841070766696, 3.220145612764155],
            [22.582615671216317, 3.226327084961008],
            [22.588009551440877, 3.236532943034467],
            [22.59421307065465, 3.248884488846869],
            [22.603654790092168, 3.268482325917026],
            [22.607160830204467, 3.275196287156772],
            [22.611473269980973, 3.281382635195579],
            [22.615787509981331, 3.288905667538806],
            [22.621177070207718, 3.295903422763953],
            [22.623069230318226, 3.302603341988314],
            [22.624152109867364, 3.307959502285466],
            [22.624968230201297, 3.314917356950128],
            [22.623091190533671, 3.319713155311034],
            [22.619868109854401, 3.323962313201829],
            [22.615918549926793, 3.33332979158915],
            [22.628630879905277, 3.32333454891454],
            [22.640202719578795, 3.318607320453642],
            [22.648582439907674, 3.312431463274027],
            [22.652900280355698, 3.304518522403982],
            [22.652858160148661, 3.292530594246494],
            [22.651378919641633, 3.283764964991585],
            [22.646140200026199, 3.277062038195546],
            [22.635970560442598, 3.268625555877993],
            [22.623462720260452, 3.254351063629749],
            [22.612979520133628, 3.239190872272126],
            [22.605968879908477, 3.22284641277587],
            [22.595498280450141, 3.211194899761215],
            [22.588514279764752, 3.202452668879598],
            [22.578584040306023, 3.179687817341323],
            [22.574490839764465, 3.169178880909427],
            [22.577358960142345, 3.16097975499629],
            [22.584297600397502, 3.156856773031963],
            [22.595296320309661, 3.153886401984382],
            [22.61267459958686, 3.152643255913486],
            [22.636431000026302, 3.152542660047736],
            [22.652654760008769, 3.152474095675608],
            [22.65960744003349, 3.15244458259074],
            [22.670600039723592, 3.147719786288824],
            [22.679848079690945, 3.141247921286978],
            [22.696043039685399, 3.132992424770273],
            [22.700678400450379, 3.132972808907195],
            [22.715724600249391, 3.12764595098376],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Boende",
        AREA: 132957,
        POPULATION: 1600000,
        DISTRICTS: [],
        OBJECTID: 26,
        NOM: "Tshuapa",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [22.127389918395465, 1.76261713745324],
            [22.157415360267173, 1.762257034688705],
            [22.166317440153989, 1.762478616511717],
            [22.177758960330916, 1.761945018546818],
            [22.198040072685203, 1.759228059201451],
            [22.25057904010524, 1.74329586500138],
            [22.271322960002312, 1.737673573482981],
            [22.281162307920589, 1.737981984253294],
            [22.302745200394121, 1.750732598099961],
            [22.323966839867737, 1.757399168538509],
            [22.334118840132433, 1.752741074947727],
            [22.344665760457271, 1.741545171627624],
            [22.372439039673409, 1.710682410266664],
            [22.346586719657459, 1.700836687191389],
            [22.333812120260145, 1.695917590553876],
            [22.309143479751338, 1.681503958507173],
            [22.28483753403853, 1.671993064906219],
            [22.276746359765429, 1.653073080602393],
            [22.271335200446362, 1.6451500793121],
            [22.269481383127133, 1.642433838181106],
            [22.268381399654988, 1.640822122945238],
            [22.265877633261415, 1.631919716735815],
            [22.26481635549991, 1.628145945569791],
            [22.267170360159248, 1.61850209015947],
            [22.266309667217534, 1.611135134110262],
            [22.265449199752958, 1.603770083836265],
            [22.263646217197341, 1.598822909396854],
            [22.262087159580716, 1.594545027363989],
            [22.261928400320549, 1.584884111481205],
            [22.253574239756482, 1.571023140920623],
            [22.253389200282665, 1.565042004427248],
            [22.257168480056599, 1.548280029253163],
            [22.254278400361603, 1.536989095845413],
            [22.250757309875034, 1.5316466481179],
            [22.247272535580489, 1.526358797496576],
            [22.248776425858868, 1.520905817726726],
            [22.251260361942588, 1.511900036251684],
            [22.259699999900899, 1.514260029649787],
            [22.263379919716208, 1.510609958622322],
            [22.266393851936055, 1.510837583274808],
            [22.269999959879424, 1.511109931294543],
            [22.273909920272683, 1.507920012047129],
            [22.275220983582074, 1.504602289255659],
            [22.277170079813612, 1.499669979290061],
            [22.281289919894895, 1.499010011395609],
            [22.285377752104299, 1.502488209746652],
            [22.28658693927396, 1.502130075805756],
            [22.287660119712971, 1.501810054038288],
            [22.2904516578146, 1.495390184153415],
            [22.291193028435423, 1.495477319007382],
            [22.29478991966397, 1.495900069727929],
            [22.298727322690826, 1.49798883397681],
            [22.30003008017712, 1.498679936967175],
            [22.311259920442208, 1.492780034300841],
            [22.31674085729928, 1.493281635699785],
            [22.317040922451937, 1.493760943815827],
            [22.319920080429725, 1.498359952658626],
            [22.322419920287221, 1.498840109462862],
            [22.323759715312676, 1.50344954208815],
            [22.327210079640267, 1.500269950256959],
            [22.332738278661068, 1.502231091240636],
            [22.333129919870437, 1.502370026330212],
            [22.335659999715325, 1.499860060580103],
            [22.33635542240771, 1.497625591370805],
            [22.33730015993077, 1.494590040813517],
            [22.346470079706034, 1.490279966825908],
            [22.350809195853248, 1.490769957969174],
            [22.351416543223579, 1.491639742377621],
            [22.353069959877658, 1.494010067840952],
            [22.353104149757353, 1.494224572750884],
            [22.353729730233006, 1.498149362721847],
            [22.357327478454355, 1.498360234724121],
            [22.362630812989845, 1.498671075410463],
            [22.364479362588263, 1.50146886378009],
            [22.371794617933002, 1.498881847011684],
            [22.377549959566647, 1.489349917243172],
            [22.380540119669138, 1.487310006448112],
            [22.382809919846988, 1.487549995680403],
            [22.385080080249267, 1.490319964225123],
            [22.384150888072217, 1.496237896869363],
            [22.38388992029563, 1.497899975188607],
            [22.384483876480029, 1.498665482016125],
            [22.38479097005148, 1.499059739890543],
            [22.396459951743225, 1.497069940143513],
            [22.396014061273842, 1.496183808946595],
            [22.392630460636497, 1.48945947483153],
            [22.394409539920712, 1.487418627532322],
            [22.395621612479051, 1.486029583975622],
            [22.399970039664179, 1.485140008320067],
            [22.406579999831596, 1.487719898497586],
            [22.409754138497537, 1.485872706741982],
            [22.413229919757768, 1.483849972584272],
            [22.41825850276701, 1.47744383303942],
            [22.419690119987546, 1.475620028008441],
            [22.420262709742914, 1.475508160742507],
            [22.423119840131609, 1.474949962546338],
            [22.429706685748446, 1.481896466982346],
            [22.434421296786095, 1.474988628537324],
            [22.434549840313359, 1.474800058482483],
            [22.438224356762223, 1.475293325816198],
            [22.441849920418001, 1.475780021387096],
            [22.444620119938339, 1.472579959937118],
            [22.44559435993197, 1.473339676069066],
            [22.448480039678714, 1.47558993889857],
            [22.451900040051385, 1.474889965121027],
            [22.457171991044142, 1.473811948599228],
            [22.457329957091908, 1.47397260388612],
            [22.460119920446822, 1.476810072675246],
            [22.460122667494947, 1.476823803615349],
            [22.460397307630156, 1.478196676597986],
            [22.461229338924376, 1.482355842117215],
            [22.462762036377313, 1.483722782788723],
            [22.463039879904805, 1.483969966942111],
            [22.464851064078953, 1.480200642202474],
            [22.465130040382018, 1.479620053346701],
            [22.463120159646813, 1.473399930291599],
            [22.469109840297051, 1.46584992450451],
            [22.469749881852149, 1.465913947093634],
            [22.473910079645897, 1.466330088453302],
            [22.475720159790576, 1.468190025053767],
            [22.476268018926156, 1.471059324476384],
            [22.476820651709179, 1.473949630659073],
            [22.477372096021039, 1.473654397864509],
            [22.479360119847101, 1.472590050226655],
            [22.480290000133664, 1.468459925677996],
            [22.483959839953172, 1.466639988040651],
            [22.483982420904479, 1.462861572082008],
            [22.483990079940565, 1.461579971818274],
            [22.489480079900556, 1.460930082776924],
            [22.489597681049339, 1.460839748847766],
            [22.491550080386176, 1.45934004090693],
            [22.492489615765411, 1.45566163108658],
            [22.495220173530569, 1.456370492572232],
            [22.497930071840848, 1.461219969690917],
            [22.502501636050965, 1.460328753050973],
            [22.509059119334442, 1.456063307385894],
            [22.510540080115209, 1.455099985164646],
            [22.511230494699841, 1.452683232372225],
            [22.512179880106181, 1.449359960771395],
            [22.513977432345911, 1.447398297930766],
            [22.514479920271455, 1.446849934440904],
            [22.522920937143713, 1.448287508174658],
            [22.524090119638831, 1.444609988726406],
            [22.52475365483355, 1.443958422192949],
            [22.525179839858868, 1.443539924238503],
            [22.52677754838891, 1.44194919101322],
            [22.527541155906288, 1.441190075308726],
            [22.533289480799237, 1.441228125305148],
            [22.535079840228473, 1.441239975979883],
            [22.539899880242839, 1.438740030101067],
            [22.541289839888705, 1.43598999710475],
            [22.547919960047718, 1.434660112488132],
            [22.548973161056487, 1.432584052236821],
            [22.550010119626602, 1.43054000820831],
            [22.555514183610683, 1.429097895486536],
            [22.556878473897289, 1.428740439468009],
            [22.560329880270618, 1.42509000709667],
            [22.559884773132168, 1.422135621168991],
            [22.559670000320789, 1.420710068712216],
            [22.562279320556879, 1.417526453485702],
            [22.56266988019464, 1.417049934338253],
            [22.562094136454327, 1.414803405385585],
            [22.561549919987211, 1.412679890267073],
            [22.562198620403329, 1.410900189307159],
            [22.562719919949259, 1.409470009033658],
            [22.569888395966458, 1.404609823091492],
            [22.572129960298302, 1.403090053072523],
            [22.574054011499701, 1.400419076443619],
            [22.577899043460846, 1.395081376758792],
            [22.584091806247375, 1.397556668694492],
            [22.586100120320744, 1.398359983925292],
            [22.590517625256272, 1.396392332692366],
            [22.590680039761327, 1.396319989536884],
            [22.591534132780634, 1.395472822150522],
            [22.59435996586485, 1.392668720859086],
            [22.594384514126599, 1.388526706246214],
            [22.595858798628171, 1.387452939446076],
            [22.598759879990485, 1.385339991675495],
            [22.598799839749269, 1.378899969481005],
            [22.601892360183427, 1.376814314349805],
            [22.605220080220228, 1.374570033829405],
            [22.604559840045962, 1.370890006837174],
            [22.604865954453778, 1.370388108872802],
            [22.605419879912485, 1.369479903933161],
            [22.606026427782204, 1.368470716102736],
            [22.606639919629085, 1.367449975143924],
            [22.614287918141596, 1.365584944190809],
            [22.617628531697669, 1.364770305511002],
            [22.621250092460542, 1.369849902746763],
            [22.62446057606455, 1.367118846296488],
            [22.625444574457116, 1.365294264028972],
            [22.630018741086623, 1.35680720766045],
            [22.629369725361823, 1.355480459237181],
            [22.627311983286599, 1.351269065427493],
            [22.630309134976933, 1.349915551222313],
            [22.637850816977263, 1.346509267954422],
            [22.639920120370203, 1.344220085715987],
            [22.638963535865191, 1.34158850632026],
            [22.637909880308857, 1.338689881575333],
            [22.638620160237704, 1.335020069258406],
            [22.64190856820106, 1.333114684754038],
            [22.646869920396131, 1.330239953068436],
            [22.647445709052203, 1.329487354163556],
            [22.648269960037762, 1.328409995815934],
            [22.646679871916298, 1.325180065213565],
            [22.646715173012005, 1.32505074378242],
            [22.647620160083765, 1.321740083885391],
            [22.648524021566431, 1.321059477907331],
            [22.655189880300703, 1.31604009408125],
            [22.65499015157538, 1.312131455492731],
            [22.652999999640429, 1.310410002008749],
            [22.649090040145502, 1.307030067788899],
            [22.649408593525024, 1.305568929233097],
            [22.649789879854119, 1.303820044336867],
            [22.655083411973248, 1.300102140562939],
            [22.655300022737691, 1.299949952278768],
            [22.654056380685322, 1.297026882104454],
            [22.653730080234766, 1.296259940717403],
            [22.653893958993756, 1.295611297048243],
            [22.654426780331491, 1.293502347518716],
            [22.654429919943379, 1.293489921074375],
            [22.658559840020491, 1.29076999026548],
            [22.664299763868922, 1.28972969824351],
            [22.669539839940438, 1.288779997671345],
            [22.670470080451473, 1.28693991958177],
            [22.668890245700609, 1.283710469312812],
            [22.668915544055668, 1.283530976828478],
            [22.669380000006996, 1.280269896259513],
            [22.673509920084111, 1.27639007730343],
            [22.67286164636775, 1.271091373365808],
            [22.678350120090069, 1.269059993444541],
            [22.681349999963921, 1.265169886299021],
            [22.680690120014095, 1.261259953426533],
            [22.678992296042267, 1.258387932921158],
            [22.674820110231053, 1.251330294210853],
            [22.676313298879478, 1.250155074061825],
            [22.681479960134407, 1.24608991790287],
            [22.686520362277829, 1.244286906509507],
            [22.68675785168611, 1.242449527877819],
            [22.680831241751982, 1.241028151278293],
            [22.683139920116979, 1.237130096909262],
            [22.682327552045987, 1.23477118036232],
            [22.681789920229928, 1.233210030454481],
            [22.687518567526592, 1.23141037816742],
            [22.689180562193322, 1.229188638140049],
            [22.690539781490148, 1.227370411673971],
            [22.689353736718843, 1.225903511508021],
            [22.687111361208316, 1.223128837397558],
            [22.688256451785815, 1.222226008415593],
            [22.690559880396304, 1.220409904654534],
            [22.700840039709341, 1.220010058151266],
            [22.702709880278299, 1.214270017441108],
            [22.705459919807012, 1.212450068263794],
            [22.705705836310997, 1.212440227339693],
            [22.710710160315987, 1.212239963079349],
            [22.714160040451645, 1.208600060721178],
            [22.714880040151886, 1.203779885446864],
            [22.711960079795574, 1.196400044487669],
            [22.717959840441608, 1.18700993132536],
            [22.725957757011802, 1.187289871349641],
            [22.725835852034489, 1.185860656920154],
            [22.725740165287061, 1.184760082627638],
            [22.720980141716844, 1.180130340320033],
            [22.723549375531725, 1.171641796851021],
            [22.727210453183947, 1.169830252393749],
            [22.730169960073979, 1.172149950190332],
            [22.734960120325361, 1.173099941507103],
            [22.740289920127438, 1.162559916581544],
            [22.738173593522639, 1.156177648565151],
            [22.736469972722276, 1.151037766483675],
            [22.736494200285492, 1.147357210357878],
            [22.740270393448132, 1.14397004721834],
            [22.741329959919, 1.143019895912328],
            [22.740249960368686, 1.133360025401777],
            [22.748990039873775, 1.124680044194686],
            [22.749345308297269, 1.117449446693036],
            [22.749509700892599, 1.114103654951839],
            [22.752510119755613, 1.108150004098],
            [22.754390040320363, 1.104910009252216],
            [22.756080725380624, 1.103807766868562],
            [22.756430265247591, 1.103579770265702],
            [22.759202339551909, 1.098769282227589],
            [22.768130159764851, 1.095839988847318],
            [22.774290491573002, 1.096569361376764],
            [22.778679984343039, 1.089240242883408],
            [22.774828512359601, 1.085079357795014],
            [22.782430079650041, 1.075239931473605],
            [22.783619880277541, 1.067670004802111],
            [22.788429840296075, 1.065860053611291],
            [22.788564566029127, 1.064440509074376],
            [22.788910079646975, 1.060799966742434],
            [22.784659693693634, 1.047669306973797],
            [22.78406529194487, 1.045816240861568],
            [22.78355003985747, 1.044209925503768],
            [22.785189839848446, 1.03732992392537],
            [22.78718399916788, 1.034685649268357],
            [22.787949960271316, 1.033669977611116],
            [22.792799880048637, 1.026110040892239],
            [22.797608455763314, 1.024530460525055],
            [22.802992758150324, 1.013298923577904],
            [22.804089464568317, 1.011010718792254],
            [22.804171354091295, 1.01059210515812],
            [22.805030159672604, 1.006189974648459],
            [22.807269835745721, 1.00313001989045],
            [22.811720040255892, 0.997049923100705],
            [22.818149999599914, 0.991340081803607],
            [22.823051771033764, 0.981470482607916],
            [22.825550160112083, 0.976440024059558],
            [22.82473722969571, 0.974857540368414],
            [22.823300159701397, 0.972060080027915],
            [22.82347594203619, 0.969312590070517],
            [22.823799840391676, 0.964250050621774],
            [22.825887246634224, 0.960345044924515],
            [22.82226983968123, 0.955500035449721],
            [22.822558728893465, 0.946307638609015],
            [22.820299919603109, 0.941920031800498],
            [22.820574087224443, 0.941376677788735],
            [22.823070120021779, 0.936429951588356],
            [22.822650000421259, 0.931140075935664],
            [22.820804408975086, 0.928494282835105],
            [22.820390565005155, 0.927901006731543],
            [22.821787907006037, 0.925362045595936],
            [22.82180003965227, 0.925340018067041],
            [22.821820212220288, 0.925303341688588],
            [22.824549966891574, 0.920340289892867],
            [22.824473688245874, 0.920025366297502],
            [22.823880120133687, 0.917579980501869],
            [22.826281837910994, 0.915415323639829],
            [22.826409839754142, 0.915299956390305],
            [22.831890119942734, 0.915569911932409],
            [22.832820000229301, 0.913039933792981],
            [22.831240454736001, 0.910553414093187],
            [22.830329880143193, 0.909119987148282],
            [22.821929999822718, 0.901710064632281],
            [22.821513950488786, 0.898984960692811],
            [22.820839920276576, 0.894570084861524],
            [22.822289999672826, 0.882170057353685],
            [22.826259997171494, 0.874680223507759],
            [22.827819960289929, 0.874389923525066],
            [22.828253028206909, 0.874325753422247],
            [22.828630310744774, 0.874268828271796],
            [22.83082992015958, 0.867520029550711],
            [22.830860612897911, 0.867432786117798],
            [22.832930159734293, 0.861550108117289],
            [22.831975222739491, 0.856938053673032],
            [22.830929999668747, 0.85188994104271],
            [22.836260770549689, 0.84187285284735],
            [22.839949933130935, 0.834938770756127],
            [22.839553171524479, 0.832653410264309],
            [22.839070184227126, 0.829871391698436],
            [22.843199879725397, 0.826910068985997],
            [22.846916229818728, 0.825847265625477],
            [22.848689879685388, 0.825340036448172],
            [22.84846468462008, 0.82375057674767],
            [22.847810040051701, 0.819130003107359],
            [22.849372966712263, 0.816698657880074],
            [22.849430033987307, 0.81660978197989],
            [22.849009919776705, 0.810629959551408],
            [22.854570120381204, 0.797800024603287],
            [22.853009879683331, 0.792500041402999],
            [22.853263964568193, 0.790119780183856],
            [22.853499839703922, 0.78791010511505],
            [22.857450120080401, 0.777130069509142],
            [22.850000280038085, 0.76420901982299],
            [22.852779840003713, 0.758710033963112],
            [22.850366935506152, 0.755307266779554],
            [22.849829999884413, 0.75455006051516],
            [22.853300040011696, 0.748140058440647],
            [22.853309837038172, 0.74797572428352],
            [22.853559960352634, 0.743780032690888],
            [22.849499879797296, 0.737310001274274],
            [22.85182911880252, 0.729753373888206],
            [22.851823393839219, 0.729739837494197],
            [22.847979959980975, 0.723970002997741],
            [22.845300644814547, 0.714761866109036],
            [22.847829514628746, 0.712020354270629],
            [22.847336573998053, 0.710646998324034],
            [22.846260687833418, 0.707649524733138],
            [22.847733838661121, 0.706731796215371],
            [22.849920000296109, 0.705369882596675],
            [22.850169637621974, 0.703071956181515],
            [22.846089960318722, 0.698910068701671],
            [22.863389488786538, 0.670989391214156],
            [22.868783538792684, 0.664978182774925],
            [22.87097997625624, 0.662529951590038],
            [22.871131565163807, 0.662013293155165],
            [22.874479709296917, 0.650600671318879],
            [22.875220080092838, 0.642110037764108],
            [22.887619920319938, 0.630240030079263],
            [22.896330120062039, 0.625700032514868],
            [22.903459920013038, 0.617239994918341],
            [22.907244774731623, 0.610632236598199],
            [22.910150159922431, 0.605559886067673],
            [22.916099879915588, 0.603299880238983],
            [22.923486727395208, 0.594376700987053],
            [22.924609919741023, 0.59301990315661],
            [22.932382365463106, 0.591236458263622],
            [22.936979891883269, 0.585748336769135],
            [22.93700803610113, 0.581619950749323],
            [22.937029919959755, 0.578410010948004],
            [22.937060159947144, 0.573800042833729],
            [22.944210559165917, 0.569741605630392],
            [22.946678782816974, 0.568340686144475],
            [22.938102788683373, 0.553109767838616],
            [22.937200171367355, 0.551506956933008],
            [22.935428280402011, 0.543223022611175],
            [22.936157266848351, 0.536334197547457],
            [22.927475520344547, 0.502499978690163],
            [22.930139833645718, 0.493128138344304],
            [22.931909280295155, 0.486904022589335],
            [22.942325520000672, 0.464223993077593],
            [22.943025359709285, 0.463545073808467],
            [22.951971210906638, 0.454865253358518],
            [22.952444333803829, 0.452934598062491],
            [22.953376440115665, 0.449130064979208],
            [22.952287440344502, 0.440851992022236],
            [22.956056279898235, 0.42249515183709],
            [22.952224439696998, 0.414889123796036],
            [22.952703381880621, 0.411675110156331],
            [22.957659063909613, 0.405765119385654],
            [22.958452439798869, 0.404818992931227],
            [22.969763280254838, 0.384444033967603],
            [22.969351440426301, 0.377548978027117],
            [22.970969387101384, 0.37004500932834],
            [22.971231322363479, 0.368830162845005],
            [22.967863199698453, 0.360307980264212],
            [22.96285848043474, 0.357979042804275],
            [22.960028146790965, 0.354771953762526],
            [22.958780400336064, 0.353358115201827],
            [22.930135200135489, 0.344209070399676],
            [22.930155745504337, 0.340572075990094],
            [22.930176239669251, 0.336944149952372],
            [22.930559142067523, 0.336589332225414],
            [22.931741159691406, 0.335494013372106],
            [22.941274320438335, 0.30798804734364],
            [22.956279633417193, 0.280517004439168],
            [22.971512880424669, 0.26544868842835],
            [22.977257760278519, 0.251988955509637],
            [22.98010632972257, 0.241067146975829],
            [22.980132823735264, 0.24096552841066],
            [22.986808069864239, 0.215703503607075],
            [22.994428191856858, 0.208127244243469],
            [22.994929828179487, 0.2076285140301],
            [22.995990456459058, 0.206573952042937],
            [23.005672170706195, 0.191015012246847],
            [23.013942450182324, 0.18188008306285],
            [23.01550453422314, 0.18093267131531],
            [23.01576049838356, 0.180777428034629],
            [23.018064459695029, 0.179380069331886],
            [23.025472974539337, 0.178970035668979],
            [23.029247119543097, 0.178761150864892],
            [23.029924700795593, 0.178289998389948],
            [23.030079760793416, 0.178182179085204],
            [23.031538169368982, 0.177168070217805],
            [23.032771236453851, 0.175679137933814],
            [23.032940549121953, 0.175474691716414],
            [23.034755489152332, 0.17328314525744],
            [23.037780209240424, 0.163885067517256],
            [23.043486864880641, 0.158743683482239],
            [23.044116300925474, 0.158176596277648],
            [23.045122409552135, 0.157270147518156],
            [23.049040288594608, 0.150864115019325],
            [23.052629488447707, 0.113760532736027],
            [23.056720498896574, 0.10669531952443],
            [23.068158088944166, 0.086942483589945],
            [23.086857207895999, 0.064738941341737],
            [23.093511447820379, 0.053115840042885],
            [23.118492926626871, 0.031070529775457],
            [23.141145082884773, 0.011800201975876],
            [23.153488165755597, 0.007513052106811],
            [23.158382366188242, 0.0],
            [23.191703936144826, -0.035076062905411],
            [23.224132580709011, -0.069212109750367],
            [23.229374359087998, -0.072894872125028],
            [23.23827139403615, -0.072222973176799],
            [23.242603283236914, -0.07406784378539],
            [23.254905202606469, -0.084880969385095],
            [23.257667927245329, -0.086353848266899],
            [23.257968285248779, -0.086513976646194],
            [23.263113201883932, -0.089256864502705],
            [23.269947441733382, -0.095697876702013],
            [23.273575055344629, -0.100394825656703],
            [23.280422328850566, -0.109262959121634],
            [23.280608978105349, -0.1093505326741],
            [23.281235676983524, -0.109644543551348],
            [23.286806241451437, -0.112257925811911],
            [23.293409360947958, -0.120764950806592],
            [23.306900380259115, -0.123504834926843],
            [23.308235240838716, -0.123775931699102],
            [23.321439319383508, -0.142855987044684],
            [23.345823198438808, -0.163790985446004],
            [23.347412239124655, -0.170682021399601],
            [23.349001526847204, -0.173651318692163],
            [23.349682144405396, -0.174922930373208],
            [23.356514478928137, -0.187687911424434],
            [23.327497399556108, -0.21863496517852],
            [23.323831159285966, -0.228961931032881],
            [23.31971528077505, -0.235842845703237],
            [23.318380814555876, -0.237543066418368],
            [23.305317440930686, -0.254186887129723],
            [23.292511095071177, -0.274140970548225],
            [23.292282243862655, -0.274383315240816],
            [23.288397441687241, -0.278496937792873],
            [23.28035506659533, -0.281761162907717],
            [23.279949320937703, -0.281925846570312],
            [23.279211791513035, -0.282780110701364],
            [23.276979319928511, -0.285365916816668],
            [23.276797508999827, -0.286661769669613],
            [23.275594389051594, -0.295236851922244],
            [23.192242164442259, -0.287231148934345],
            [23.16352280562003, -0.287954056490706],
            [23.138387607102121, -0.289493590965405],
            [23.116877607523996, -0.28550038130146],
            [23.084634364454697, -0.277187055606138],
            [23.073804956312337, -0.285444520005889],
            [23.072356429204874, -0.286549048678402],
            [23.057903128273178, -0.297569951549126],
            [23.055682228786129, -0.29830951397396],
            [23.055592017270378, -0.298339554906583],
            [23.053795168411511, -0.298937908264387],
            [23.046504213393522, -0.305403342642323],
            [23.044687333900441, -0.307014504192857],
            [23.041910379947495, -0.309477000145669],
            [23.04163799727862, -0.309646809281941],
            [23.039889582884925, -0.310736764510695],
            [23.031631409105582, -0.315884879391516],
            [23.028987410306243, -0.31667742762425],
            [23.028715541473709, -0.316758921809182],
            [23.024782409037691, -0.317937892890605],
            [23.02327500544823, -0.319070139416528],
            [23.023104463884803, -0.319198237721758],
            [23.021419289090503, -0.320464012144702],
            [23.010158129961344, -0.328928922819687],
            [23.007624787435329, -0.332463155357232],
            [23.007203443431102, -0.33305096738375],
            [23.004898170579303, -0.336267023287641],
            [22.99872813067789, -0.340615991385605],
            [22.99232121042596, -0.350476950413035],
            [22.985241451127877, -0.354365963955718],
            [22.97993052403158, -0.363357124237219],
            [22.979460036791409, -0.364153637717218],
            [22.978603411421314, -0.365603866565603],
            [22.976484687212992, -0.367446984890644],
            [22.97588558907194, -0.367968152195682],
            [22.96648833085106, -0.376143003707272],
            [22.949621741841177, -0.396429991851985],
            [22.948345501723768, -0.397965033935063],
            [22.943618321458665, -0.403650916166555],
            [23.010217890385618, -0.404274699249621],
            [23.047905929291503, -0.404233067650864],
            [23.073017728492882, -0.406321743729375],
            [23.092762287907725, -0.405824674219504],
            [23.110700006502849, -0.407187028678587],
            [23.135076327133334, -0.412090884944959],
            [23.132318367158749, -0.423568956023414],
            [23.132250132926387, -0.423741186610212],
            [23.13117731361011, -0.426449092640999],
            [23.126590407073262, -0.438026909183811],
            [23.128854446355191, -0.448824938402752],
            [23.124860246446154, -0.455588004134969],
            [23.11905553699772, -0.465416361755666],
            [23.11855735020578, -0.466259871470673],
            [23.113729417593351, -0.488069813372364],
            [23.113726305829204, -0.489879888202336],
            [23.113712487045188, -0.497946002210653],
            [23.109129326483075, -0.510109876188],
            [23.10849980689488, -0.515017837723432],
            [23.108346195879616, -0.51621544688502],
            [23.107509328055887, -0.52273997118046],
            [23.099035287317129, -0.540637863996004],
            [23.098918594365077, -0.541565142654846],
            [23.098750590542348, -0.542900152987348],
            [23.098110447477616, -0.547986928064869],
            [23.100830097898584, -0.559477630171489],
            [23.105531487531888, -0.557736944754299],
            [23.106372066296093, -0.557425179242512],
            [23.106411422386994, -0.557410582514815],
            [23.106998487594829, -0.557192844296771],
            [23.114007731838054, -0.548635582293357],
            [23.115577258420991, -0.546719417898367],
            [23.117517326583901, -0.544350875421943],
            [23.119462172885804, -0.542606001198157],
            [23.12042238927955, -0.541744516217528],
            [23.126203406560634, -0.536557910531602],
            [23.159092169111663, -0.523760998250012],
            [23.176922364757139, -0.506339891919701],
            [23.189835210385134, -0.499952179273092],
            [23.190739317107909, -0.499504936970308],
            [23.195425279074495, -0.497186894436083],
            [23.200646565983558, -0.491537756501258],
            [23.205665123794226, -0.486107957830921],
            [23.215770324527568, -0.475176977819724],
            [23.24478129445734, -0.457545998725705],
            [23.280070527924035, -0.451994274342148],
            [23.289524229090844, -0.450507013132642],
            [23.310081332646508, -0.439060880288197],
            [23.318069360562049, -0.438844966688179],
            [23.324655872005568, -0.43870594843019],
            [23.3281111860504, -0.438633019528593],
            [23.332914746470845, -0.436816298075545],
            [23.333370309999207, -0.43664400267515],
            [23.338386319289409, -0.434746928042727],
            [23.340981291633792, -0.43272799175904],
            [23.34153671368577, -0.432295863038528],
            [23.349580158671188, -0.426037911788569],
            [23.354732030961603, -0.423641808201979],
            [23.355020900410871, -0.423507458793014],
            [23.355974480949591, -0.423063958318528],
            [23.371721223838076, -0.423549850842917],
            [23.39866617012401, -0.410963907249397],
            [23.411220593343501, -0.409146998349431],
            [23.418197446134222, -0.413203279001062],
            [23.418747359716861, -0.413522986884142],
            [23.423532480419453, -0.418582920099614],
            [23.431503240020294, -0.43214586683352],
            [23.441929200395535, -0.443166847617986],
            [23.445863279655864, -0.447326880509513],
            [23.454986407984613, -0.45239508367032],
            [23.456656079653737, -0.491864417940342],
            [23.466227760160074, -0.519148779981644],
            [23.474383560133031, -0.54433609689187],
            [23.484422159771206, -0.554109728891449],
            [23.502385079703298, -0.570161843246408],
            [23.510705119557947, -0.575306097594866],
            [23.528441160083545, -0.586188501718244],
            [23.539252680073673, -0.594559017354901],
            [23.534352719643437, -0.612783430079731],
            [23.51723508025772, -0.620190610865551],
            [23.496522840347453, -0.624457394368656],
            [23.477584679698523, -0.631169799563995],
            [23.470857122873902, -0.63318036652584],
            [23.457890517567709, -0.637055504911473],
            [23.440877280384328, -0.642139954211106],
            [23.427079560065515, -0.649186468023085],
            [23.397678360179686, -0.649840855199796],
            [23.393104199838398, -0.655576964123281],
            [23.387382359974936, -0.667741934578267],
            [23.385787626665149, -0.669342682920714],
            [23.38419132040524, -0.670945010557399],
            [23.382353520047523, -0.672787954582789],
            [23.371164359990093, -0.674836891558836],
            [23.361567133193699, -0.678221773395149],
            [23.347183319644181, -0.683294849104305],
            [23.336446320296773, -0.68809989743336],
            [23.333945532716672, -0.69099709287635],
            [23.333475240410902, -0.69154193349002],
            [23.328436319589393, -0.703018910819459],
            [23.327043479944734, -0.719788010391261],
            [23.322233519926201, -0.731495957519257],
            [23.322681352553204, -0.738388863189225],
            [23.322506607772556, -0.739044188270075],
            [23.320844279830872, -0.74527692730124],
            [23.315130360413288, -0.751010935649943],
            [23.313066480149693, -0.75675088388812],
            [23.311161818185415, -0.757130714415535],
            [23.309641361176531, -0.757433853934792],
            [23.296798799736376, -0.748341181874978],
            [23.277744719584859, -0.745599338113974],
            [23.256995399914601, -0.751266846307024],
            [23.255262360187025, -0.761076835566023],
            [23.282263080173983, -0.782412051036361],
            [23.28454550796976, -0.783520364903298],
            [23.298620399876235, -0.790354923425684],
            [23.303982960338459, -0.809947122180634],
            [23.308135920405963, -0.819738589729602],
            [23.344031160058293, -0.842547467552447],
            [23.352088269317498, -0.850601072017537],
            [23.35579631987591, -0.85320478110845],
            [23.368665239683136, -0.867170776389061],
            [23.385500279860256, -0.897931572052028],
            [23.401611359665036, -0.900682499634474],
            [23.423075650266586, -0.915828115789694],
            [23.439158639752428, -0.927176539301948],
            [23.469348599983594, -0.953693263523664],
            [23.496235545644865, -0.975079448215747],
            [23.509689119581711, -0.985780523237587],
            [23.537161298785968, -0.992105295532108],
            [23.537767680467386, -0.992244899017057],
            [23.560890480272292, -0.996825026446215],
            [23.581154159920171, -1.009366820479905],
            [23.6105452798102, -1.010675473070689],
            [23.638502519623479, -1.010588074114479],
            [23.665488120065884, -1.046918204267091],
            [23.670626399947722, -1.074912864918977],
            [23.661050400341505, -1.102953216923198],
            [23.648344920017092, -1.138005531965536],
            [23.650988759814613, -1.149201387867868],
            [23.658233759717621, -1.153380157747674],
            [23.677474320240631, -1.149118496694328],
            [23.702396258710106, -1.150154984751525],
            [23.728675680032918, -1.160162583169098],
            [23.738975640011443, -1.160130327394413],
            [23.754936959878609, -1.168483324542003],
            [23.756976272117488, -1.169363689940594],
            [23.768065079577898, -1.175051640262007],
            [23.80002840041816, -1.187949106308472],
            [23.804330399974464, -1.192137188496506],
            [23.803732439998868, -1.214546433823332],
            [23.822375923590194, -1.236951989050847],
            [23.836715999965165, -1.246653733930202],
            [23.838637157693039, -1.259205447540095],
            [23.841742320118215, -1.278848029743246],
            [23.850309240369135, -1.288624316014647],
            [23.865413807305423, -1.296384506097492],
            [23.89094891961814, -1.309503485147335],
            [23.898268440163861, -1.310881009283434],
            [23.905401480338057, -1.319261273036776],
            [23.909292719840803, -1.338854569619192],
            [23.934370198906745, -1.378785721461511],
            [23.951411810276682, -1.37507575979124],
            [23.955393092411928, -1.374208981883388],
            [23.956038712504963, -1.373041094677625],
            [23.95767924013132, -1.370072882782909],
            [23.961650201522275, -1.367119528898508],
            [23.963852160031529, -1.365481846809998],
            [23.966673343435829, -1.360328555161918],
            [23.968883160407191, -1.356292002701728],
            [23.972907524845162, -1.353650281531782],
            [23.974827202149459, -1.352390142874806],
            [23.997707797289152, -1.353082156296697],
            [23.998359240261841, -1.353101864172039],
            [24.00498619116453, -1.351728928815672],
            [24.008224830664528, -1.346210298339305],
            [24.010244280254149, -1.34276888575239],
            [24.01452035712628, -1.338205287124416],
            [24.017561280127151, -1.334959887367018],
            [24.020783398710762, -1.333450248490029],
            [24.024416220754013, -1.331748184413379],
            [24.046808400077129, -1.326710852152619],
            [24.060291480077808, -1.318676930557199],
            [24.068209836456528, -1.311033550411713],
            [24.0719491807262, -1.30742405189407],
            [24.073567557694297, -1.307883601688653],
            [24.126003720116575, -1.32277308607743],
            [24.265715040112465, -1.325137476435274],
            [24.359886360204708, -1.324843234564429],
            [24.368355359598123, -1.393435310590322],
            [24.385265279744033, -1.421389519483822],
            [24.396153840151229, -1.509575419401458],
            [24.409238040317963, -1.625755002018338],
            [24.405585120266849, -1.652370284900953],
            [24.422831279823637, -1.667718426015931],
            [24.444044255046311, -1.715305850640144],
            [24.439673880222163, -1.716473405281422],
            [24.431863680105344, -1.715784143319691],
            [24.417434519600246, -1.715618584202944],
            [24.404809319916136, -1.715473561206108],
            [24.370545599584503, -1.71448074307612],
            [24.315852240347819, -1.712054091064573],
            [24.290016840100265, -1.709958557016083],
            [24.267176280177814, -1.709096887289729],
            [24.247308959691161, -1.711866732614863],
            [24.230458799969494, -1.713472070779437],
            [24.195879360443076, -1.716726878772781],
            [24.190766204643097, -1.713918129632861],
            [24.188337360439139, -1.712583919333751],
            [24.183771636176687, -1.712580411064562],
            [24.17005152041693, -1.712569867273791],
            [24.166851300065026, -1.708889891783722],
            [24.161594400344867, -1.708885927910889],
            [24.147649439862775, -1.714854018528121],
            [24.137890930438601, -1.714378865967413],
            [24.133249439570125, -1.71415286619781],
            [24.125023439850992, -1.706098963493545],
            [24.122737158282632, -1.705330655181227],
            [24.12159515970631, -1.704946884641106],
            [24.102394199615979, -1.709070945394557],
            [24.10020732921021, -1.707520587019722],
            [24.096224313326466, -1.704697030851718],
            [24.090967439657458, -1.705152980229535],
            [24.085251359791588, -1.709056893308542],
            [24.083684366457735, -1.708807956677781],
            [24.080656319908154, -1.708326914189368],
            [24.067571770296752, -1.706249241946294],
            [24.05759436030247, -1.704664945557855],
            [24.040909321709812, -1.707869820253836],
            [24.034825983606353, -1.705502488704258],
            [24.027881400097304, -1.70279999934983],
            [24.022396439686062, -1.703025010631778],
            [24.01965143970607, -1.704631977090697],
            [24.010738200048475, -1.702554990530099],
            [24.003904850429485, -1.702952356278371],
            [23.999080319737025, -1.703232907126079],
            [23.995447362048147, -1.701364548851994],
            [23.987884319906996, -1.697475020178023],
            [23.967714330949999, -1.698341191503972],
            [23.964909289373068, -1.708935364681187],
            [23.955772320700703, -1.71577909019124],
            [23.95518966711921, -1.727374522611677],
            [23.95470695290971, -1.736965019110862],
            [23.952229420017371, -1.737620508117246],
            [23.947025353812332, -1.738998751780154],
            [23.918200526487521, -1.735070405639703],
            [23.874317607465983, -1.733966984247011],
            [23.83642508864526, -1.735330720418053],
            [23.811168578936453, -1.735640398912323],
            [23.797291289443006, -1.740877356884876],
            [23.786376090394381, -1.750944992742116],
            [23.777275290590314, -1.759834407726689],
            [23.767606761814903, -1.765119578174211],
            [23.754970052017054, -1.766173619862614],
            [23.743525291616859, -1.768440587534649],
            [23.728472972494117, -1.770666123395183],
            [23.714016460085265, -1.77349802405617],
            [23.702522012070084, -1.781160541598971],
            [23.693857170961625, -1.790728947180844],
            [23.691540572150725, -1.798422201053291],
            [23.685374492921376, -1.815139124828646],
            [23.678099604272244, -1.821650901311424],
            [23.66123830094951, -1.824455157249953],
            [23.641464213911245, -1.817033320659197],
            [23.579142086397347, -1.794134048507302],
            [23.562313903959133, -1.793341233486944],
            [23.559202236832977, -1.801119741774191],
            [23.564895455473181, -1.820672907857782],
            [23.576078495308586, -1.839084920287801],
            [23.584053214683198, -1.864390967950232],
            [23.585950816787687, -1.867614790426364],
            [23.586413935147572, -1.868401577608677],
            [23.588388335124023, -1.871755864163924],
            [23.592491227589161, -1.884638914122372],
            [23.592245832108059, -1.885778838619443],
            [23.592052100535561, -1.886678603411517],
            [23.590690174614778, -1.893003914293623],
            [23.588167317224787, -1.904733492832033],
            [23.587811418183932, -1.90638817613417],
            [23.585369375033519, -1.917741935653],
            [23.587088224074577, -1.922633766241893],
            [23.587435562170757, -1.9236222843599],
            [23.587875335113043, -1.924873849160673],
            [23.587490831018613, -1.926413551878739],
            [23.586727319620962, -1.929471118781773],
            [23.587637374987516, -1.934301897420275],
            [23.586733963560796, -1.935985265099801],
            [23.586621504368697, -1.936194816440545],
            [23.58603430800682, -1.937288979802103],
            [23.58601324610667, -1.93729821981612],
            [23.582374366723425, -1.938893858210895],
            [23.582247239839386, -1.95114767882894],
            [23.58222934180565, -1.952875490144125],
            [23.58211929459009, -1.963498894421206],
            [23.583273969293352, -1.969219906647921],
            [23.583460332883892, -1.970143271780113],
            [23.584394135214982, -1.97476992508099],
            [23.583469311545148, -1.983508025812855],
            [23.58377395810577, -1.984532720073011],
            [23.585521294521119, -1.990409965779734],
            [23.459727570527111, -2.030177017936587],
            [23.445921945932106, -2.027620586946767],
            [23.435254058471088, -2.010712488121692],
            [23.423952214642718, -1.997393894753974],
            [23.327456380683607, -2.029258410267184],
            [23.302995461211239, -2.073938563118819],
            [23.287540289904385, -2.08779000559406],
            [23.280370149308965, -2.080755871445985],
            [23.275722324419423, -2.08002801312622],
            [23.274425237997537, -2.079824887270308],
            [23.270254796714585, -2.075234250324101],
            [23.268744559838716, -2.073571803611843],
            [23.266891401882887, -2.071531873716433],
            [23.260952123008298, -2.068070967344359],
            [23.256599915712449, -2.063681224068436],
            [23.255470402820286, -2.062541968175064],
            [23.251594282862087, -2.055174860987717],
            [23.241321323546089, -2.043657992445927],
            [23.237678123266335, -2.03330190597637],
            [23.229461483992456, -2.022708895529861],
            [23.212003284299357, -1.991114969635484],
            [23.211482690829278, -1.990172285514039],
            [23.211340109329075, -1.989914099418014],
            [23.210762364142294, -1.988867925705671],
            [23.205783174998956, -1.983720106342412],
            [23.204572576575988, -1.982468506438671],
            [23.201402365344457, -1.979190918551387],
            [23.17810640628538, -1.961439864927071],
            [23.146808366964734, -1.944821990246984],
            [23.107738287960562, -1.928187017880431],
            [23.107072397383153, -1.927642383657229],
            [23.106975491621867, -1.927563124070323],
            [23.105652447481521, -1.926480999988816],
            [23.102943447486574, -1.924267011628639],
            [23.083517128837499, -1.919168937739603],
            [23.07860707673337, -1.917182180149019],
            [23.077825711319473, -1.916866016551321],
            [23.073236237397527, -1.915008976095987],
            [23.038255418924042, -1.914475966650304],
            [23.029115359148793, -1.911926915494959],
            [23.015627260260633, -1.911438938072843],
            [23.013179825421872, -1.910296806320262],
            [23.012729921279828, -1.91008685225028],
            [23.006717240165038, -1.907280936887816],
            [22.990030180363007, -1.906324973566976],
            [22.984321291511002, -1.902402935356772],
            [22.980403274127944, -1.901092703044324],
            [22.979787894920662, -1.900886912847781],
            [22.960787372326401, -1.894532893530303],
            [22.953834212601326, -1.889201575882075],
            [22.953520432869212, -1.888960987010625],
            [22.9484573635362, -1.885078886355007],
            [22.936573421285178, -1.88298301936104],
            [22.936066937653283, -1.882494608842921],
            [22.934782187795168, -1.881255681590475],
            [22.931553139607484, -1.878141861090042],
            [22.928999249915989, -1.877793652328265],
            [22.924696292755613, -1.877206969861277],
            [22.914404261307769, -1.878792879383134],
            [22.90960725319902, -1.876942892047988],
            [22.902515244473712, -1.879455961469409],
            [22.89819875958348, -1.879103622256835],
            [22.893829182463286, -1.878746949786743],
            [22.887420444919531, -1.882642017267879],
            [22.884464383068597, -1.882344872023508],
            [22.878048214660783, -1.881699914652896],
            [22.874584605572618, -1.88232541973086],
            [22.870500461845769, -1.883062992376195],
            [22.86965494144923, -1.883815888084013],
            [22.869547908081429, -1.883911195284802],
            [22.868439917026862, -1.88489780975179],
            [22.86436359493117, -1.883466827212326],
            [22.842839867298864, -1.875909989031318],
            [22.838448883325476, -1.875550266214803],
            [22.830389601041595, -1.87488826728192],
            [22.830015430267881, -1.873155993449784],
            [22.829119907846003, -1.869010042098676],
            [22.829322925303565, -1.86867167748504],
            [22.830648229605174, -1.866458240559345],
            [22.83053426483664, -1.866337169009478],
            [22.828237234925908, -1.863898927601577],
            [22.825674934308392, -1.863008762856559],
            [22.824930334244137, -1.862750081784333],
            [22.817180147876471, -1.864789969561998],
            [22.815348347366537, -1.864706088209994],
            [22.811720028577799, -1.864539941638869],
            [22.807779828197116, -1.861089947624288],
            [22.795480068377511, -1.857510071641371],
            [22.79546700507662, -1.85750782276829],
            [22.792827905688849, -1.857053577460337],
            [22.788740148937936, -1.856349985370167],
            [22.786082862258898, -1.857490999606592],
            [22.780100146247054, -1.860059919461645],
            [22.777410295639001, -1.860097128856051],
            [22.77648061747335, -1.860109989353934],
            [22.775542556229489, -1.859599753456551],
            [22.770275224373933, -1.856733544989845],
            [22.762711594734583, -1.855876380271636],
            [22.759289988174174, -1.855490003041682],
            [22.751780028381507, -1.842440023361929],
            [22.748515292822532, -1.839548869070976],
            [22.747759909381582, -1.838879922671771],
            [22.738759908637228, -1.833630097098483],
            [22.72268095797687, -1.828690348815858],
            [22.715979829587923, -1.821140015198489],
            [22.711457844296646, -1.820638937231762],
            [22.700159988089791, -1.815450049823681],
            [22.693582388832173, -1.809392340259457],
            [22.690299949275602, -1.808330095391172],
            [22.690191834336197, -1.808339662406998],
            [22.68951010915529, -1.808399989563275],
            [22.674660110397497, -1.809390052456857],
            [22.663115835528444, -1.805891862373486],
            [22.65638781786808, -1.809134161130183],
            [22.655109949105036, -1.809749978637225],
            [22.650117111857597, -1.810595374207195],
            [22.648849909690252, -1.810809939381502],
            [22.644705656992787, -1.815922239407955],
            [22.644440452761355, -1.816249392145781],
            [22.641375853762845, -1.815913876439829],
            [22.638149990102836, -1.815559938093279],
            [22.629669830040356, -1.801189930000063],
            [22.629408203798697, -1.80110229618195],
            [22.627640151334621, -1.800510073363803],
            [22.625590323417018, -1.801731324472761],
            [22.62377986867488, -1.802809960339559],
            [22.623344997839094, -1.802709280382411],
            [22.621749829744676, -1.802339970139903],
            [22.618770109862417, -1.785640039605669],
            [22.620534931984768, -1.782798294185773],
            [22.622898994181977, -1.778985172066378],
            [22.622668057983685, -1.777917029254588],
            [22.622500071228934, -1.777140043071344],
            [22.618664340424235, -1.775415884196075],
            [22.618540069284467, -1.775360024062514],
            [22.616589038081813, -1.775686628242543],
            [22.60952296910866, -1.776869493585385],
            [22.608629220859449, -1.773792057248253],
            [22.608159830462263, -1.77216998790618],
            [22.607619182103452, -1.77032563844099],
            [22.607380070337747, -1.769509941736297],
            [22.606485572893593, -1.768481558296176],
            [22.602369949504219, -1.763749914247677],
            [22.596429951079088, -1.759819998967509],
            [22.594640922054786, -1.755976473796236],
            [22.59278998742931, -1.751999941965055],
            [22.589590485729619, -1.7508401626358],
            [22.588775920379462, -1.752381164600441],
            [22.58752921507196, -1.75474000039315],
            [22.584318558093084, -1.758180573407646],
            [22.577530660532496, -1.761429616667334],
            [22.573762540529337, -1.766393758534179],
            [22.568973099828504, -1.775656182092623],
            [22.563974141460708, -1.785139235566733],
            [22.559602660810469, -1.793739893158306],
            [22.55188354088029, -1.806973616954002],
            [22.546886741164119, -1.81667699983118],
            [22.542913420797216, -1.822412717003265],
            [22.53791050085902, -1.831455080478469],
            [22.532503301313728, -1.842701766222562],
            [22.527294461461249, -1.852405493751655],
            [22.522705540901544, -1.860345620811121],
            [22.519587221750715, -1.866961164741516],
            [22.512319181857318, -1.883278617966045],
            [22.508588862062989, -1.892539348900193],
            [22.506100181976269, -1.898492597699314],
            [22.501932461690323, -1.906211669909877],
            [22.497969222217552, -1.913048959697261],
            [22.492707461713394, -1.916803810425103],
            [22.488469541681273, -1.916590714452347],
            [22.480400141672352, -1.914180910344121],
            [22.472960022299727, -1.911109115177851],
            [22.465304263241489, -1.907596890771379],
            [22.454251903127076, -1.90320921198682],
            [22.445113663338581, -1.899699493039971],
            [22.438951903209151, -1.897506725909376],
            [22.423856116406458, -1.892028141889939],
            [22.419616302725689, -1.890489419401168],
            [22.39878634398735, -1.882152411730127],
            [22.375205264148626, -1.874040715245115],
            [22.352471265080133, -1.865927358210264],
            [22.334615984878642, -1.858687092372975],
            [22.296803745799895, -1.845972736088506],
            [22.270457505989615, -1.83654350604931],
            [22.250478585998586, -1.828645964479759],
            [22.232841106829323, -1.822066125089679],
            [22.224351946546019, -1.820097716610002],
            [22.214784226711753, -1.815927788506619],
            [22.195396074784192, -1.810929736617124],
            [22.189830472609913, -1.817874764509374],
            [22.185448914658803, -1.822776061838289],
            [22.181543631793197, -1.83218194805054],
            [22.177560593451595, -1.836674828064361],
            [22.16880359327978, -1.846886581584234],
            [22.159125713940583, -1.850136287728017],
            [22.15198367354553, -1.859942833606167],
            [22.134764873977375, -1.873407535935737],
            [22.133609993559908, -1.877293792728987],
            [22.1346950335573, -1.8818000667422],
            [22.13617535383927, -1.885693330411353],
            [22.137237353846245, -1.888766611250948],
            [22.138318793396003, -1.893068223690755],
            [22.139722074159195, -1.898496381284123],
            [22.139561549709498, -1.900030175013978],
            [22.138946634032884, -1.905905623909145],
            [22.139254073455717, -1.906432152646228],
            [22.141349184548471, -1.910026952526304],
            [22.15131983382193, -1.935240014692549],
            [22.15132991381773, -1.93857997819688],
            [22.151059019657282, -1.961689004531404],
            [22.151025353495395, -1.964560922161979],
            [22.147115394000433, -1.973056931427285],
            [22.145800550580326, -1.985232171598245],
            [22.144533473278813, -1.996965017521408],
            [22.146141849302854, -2.003721623842197],
            [22.146341393873541, -2.004559886691219],
            [22.150922168510295, -2.015327835032009],
            [22.162016153860009, -2.041405978894043],
            [22.16061113844999, -2.05824137890676],
            [22.160423153400391, -2.060493872752692],
            [22.160055642736186, -2.064907321912438],
            [22.159887485301521, -2.066926741176788],
            [22.160789293235453, -2.071759084326422],
            [22.162370393712528, -2.078892959909652],
            [22.177150193622438, -2.109528024095678],
            [22.179312333408447, -2.117958317593117],
            [22.1812232341724, -2.125408976019632],
            [22.181801393482512, -2.164508903982258],
            [22.184289150101115, -2.172534162376043],
            [22.185655193899159, -2.176940865340692],
            [22.184969472113561, -2.182402922791147],
            [22.183592393410542, -2.193371853153998],
            [22.183317372389695, -2.195562803238206],
            [22.188247803674344, -2.206625599640524],
            [22.192863440130623, -2.216981986556612],
            [22.186641234162362, -2.233752990599826],
            [22.187355198082173, -2.241130083518837],
            [22.187977191584917, -2.24755686090948],
            [22.192060309435721, -2.25976000410979],
            [22.192040038053019, -2.260003313675601],
            [22.191351472201212, -2.268267998618299],
            [22.195448274987026, -2.276099944561847],
            [22.196322607049709, -2.282152259079329],
            [22.196392194144863, -2.28263395200139],
            [22.197052512472574, -2.287202996735129],
            [22.20263135222088, -2.325804955102232],
            [22.210140234933561, -2.340778993070852],
            [22.208965204405935, -2.351585902892875],
            [22.209270236343812, -2.353279168914788],
            [22.212572393920908, -2.371607892170471],
            [22.212986393299367, -2.387480913888281],
            [22.220516152859222, -2.394864883800322],
            [22.223474274547101, -2.400163921693042],
            [22.224168353359829, -2.402374866889835],
            [22.223362314818321, -2.406886060692151],
            [22.22118755280426, -2.410360199322933],
            [22.216210913079717, -2.416078565749233],
            [22.211816033112921, -2.420160961875508],
            [22.206002393512275, -2.424239565093573],
            [22.200787072315034, -2.427705736411775],
            [22.191684833409887, -2.428909866645288],
            [22.183033313418754, -2.432980878653832],
            [22.177209954046749, -2.436445408082254],
            [22.17058559388532, -2.440521979983564],
            [22.16615543348405, -2.442352552562155],
            [22.155113513589871, -2.449078437554181],
            [22.148620553598345, -2.448651858166104],
            [22.141847153948149, -2.443311775068125],
            [22.136502593927595, -2.438589485623991],
            [22.131154791887216, -2.433662441100013],
            [22.131205193662858, -2.424041667911459],
            [22.131121313473184, -2.418719313124298],
            [22.13105327327693, -2.414420464902491],
            [22.130704793422037, -2.405207959895965],
            [22.130395553775386, -2.39845196220958],
            [22.126270313920887, -2.393937680711103],
            [22.118669994390416, -2.387571849567317],
            [22.111465314470628, -2.380593010038208],
            [22.105499754484054, -2.375050429071622],
            [22.100956194354588, -2.369716176192553],
            [22.09685003471677, -2.366430112823357],
            [22.093748274211571, -2.362532495272761],
            [22.092827395044157, -2.355570274973196],
            [22.093293234401052, -2.346564642972139],
            [22.093929354809916, -2.335512680528358],
            [22.094394834840703, -2.32650709864227],
            [22.094529834559903, -2.322208681266059],
            [22.094452074592287, -2.31729562198585],
            [22.094174874258549, -2.31258676154698],
            [22.093276674857087, -2.307057594940348],
            [22.088549874579357, -2.302951090235134],
            [22.083466314674716, -2.301914151766217],
            [22.078598034231323, -2.301696426633369],
            [22.074334914658824, -2.301275744297389],
            [22.068655914552945, -2.301056039211315],
            [22.061152794532852, -2.300831470750858],
            [22.05591479446792, -2.302864648152451],
            [22.051510554954195, -2.306332928664471],
            [22.04751455482134, -2.310007039108086],
            [22.042537554872361, -2.31572546293467],
            [22.037007594255289, -2.324922183082223],
            [22.031059314261515, -2.333299287770264],
            [22.02313535419206, -2.344946256529199],
            [22.019992555051431, -2.351283652144815],
            [22.016601714891173, -2.354754513621707],
            [22.011454434788522, -2.362519529652839],
            [22.009469112196534, -2.366725286951215],
            [22.005374394400441, -2.375399598492613],
            [22.000805994955069, -2.38132375909971],
            [21.996057594686331, -2.388680393316018],
            [21.992091114990323, -2.394196807291066],
            [21.985904514646652, -2.400321488141991],
            [21.980097354594136, -2.404809457329653],
            [21.974093634174331, -2.409706357032388],
            [21.961096195094331, -2.420930585582637],
            [21.951296275132194, -2.429297195118616],
            [21.942523075640885, -2.438485585802337],
            [21.935548075176314, -2.446041061806556],
            [21.926568955770751, -2.455024060240271],
            [21.919005355775806, -2.463806225813566],
            [21.913835395907164, -2.470138200387741],
            [21.90886811572955, -2.476470684672533],
            [21.900278155488206, -2.484431261688177],
            [21.892663075739296, -2.489938094491577],
            [21.885272995222959, -2.49687836707487],
            [21.876503035954883, -2.506271371932522],
            [21.86467919548793, -2.514837481880892],
            [21.85008911527445, -2.527899727179449],
            [21.844079275530913, -2.53238726020406],
            [21.830955557576466, -2.53042790537128],
            [21.817903499130587, -2.526390353964982],
            [21.812898250759179, -2.524842010986355],
            [21.79439538225591, -2.51534401715335],
            [21.776121359571249, -2.506307023759074],
            [21.774570276299393, -2.50454027670613],
            [21.768827399688636, -2.497998883818929],
            [21.755350439909986, -2.491279012414994],
            [21.753929169484888, -2.490810442878634],
            [21.751810200036523, -2.490111853700193],
            [21.744113513733925, -2.487575311366051],
            [21.731353200244548, -2.483369974512895],
            [21.708022799777456, -2.478219648108349],
            [21.696373439986477, -2.475647974792263],
            [21.681068399621505, -2.468919884513109],
            [21.673080360027864, -2.462909860932351],
            [21.670023712916233, -2.458836218649003],
            [21.664425239589065, -2.451375011562491],
            [21.653017199622756, -2.442590963418791],
            [21.646419564341048, -2.431295031962203],
            [21.634112384437184, -2.431248069333153],
            [21.634065539990043, -2.431247891334873],
            [21.62423898138648, -2.428449887508302],
            [21.623277610657627, -2.42802349665824],
            [21.608021160166356, -2.421256874254784],
            [21.602499972496336, -2.420442468900189],
            [21.595215240108342, -2.419367929389647],
            [21.586048877661582, -2.41207001849394],
            [21.572859240433296, -2.401568858653248],
            [21.566515147453998, -2.383373765604023],
            [21.565932019562041, -2.382836669578791],
            [21.561498360222743, -2.378752988581653],
            [21.55771063538683, -2.376906952209737],
            [21.55579019990445, -2.375970982954049],
            [21.547371511556879, -2.375019517523908],
            [21.536810280171217, -2.373825904755561],
            [21.514221359919421, -2.357634886046303],
            [21.502468392036814, -2.352825783837772],
            [21.495491279633001, -2.349970867466445],
            [21.485662200356746, -2.347631981454982],
            [21.470888160444424, -2.340730013173927],
            [21.465793427294283, -2.338350942597782],
            [21.45530520019517, -2.329338006553048],
            [21.434520239866004, -2.320513909795161],
            [21.416465159972283, -2.31629993356812],
            [21.410085240382845, -2.309602927226076],
            [21.407963399918827, -2.325918946068304],
            [21.407784479768736, -2.340247394155154],
            [21.408857640444811, -2.356831011799152],
            [21.409302959585641, -2.372184679846148],
            [21.410549280414219, -2.386926459114887],
            [21.411181440151015, -2.401257150538871],
            [21.411375479845653, -2.413539553634689],
            [21.411524160008319, -2.422956201951405],
            [21.412117439761303, -2.434830369148156],
            [21.412233720386627, -2.442199854806061],
            [21.412697400193565, -2.445885662907314],
            [21.443254218013706, -2.497663864685804],
            [21.427728480448028, -2.488859885543332],
            [21.424000320203657, -2.485203909006878],
            [21.421529229130201, -2.482780883948878],
            [21.420662399796779, -2.48193091463708],
            [21.403290239843312, -2.477488942238156],
            [21.402060953767492, -2.476709538395939],
            [21.397812480327403, -2.47401587761858],
            [21.391409159624779, -2.473068922825746],
            [21.379687288722387, -2.475667270239622],
            [21.371031359799833, -2.477585996680832],
            [21.360874505039355, -2.481621831135968],
            [21.353845319993461, -2.484414876569785],
            [21.345587505540223, -2.48328104936934],
            [21.322746359916199, -2.480144872466537],
            [21.317070123926452, -2.48072749779557],
            [21.311989199678898, -2.481249017564665],
            [21.303812159939373, -2.484240935899062],
            [21.27460823997141, -2.504093913530504],
            [21.270597147243457, -2.505112786419123],
            [21.266592329247757, -2.506130018664766],
            [21.251037240128518, -2.505372876010232],
            [21.244640399872353, -2.502814949785577],
            [21.221403724232125, -2.508266306951679],
            [21.202274519770047, -2.51275402873057],
            [21.195543133427364, -2.513119003614918],
            [21.185972280269421, -2.513637934510768],
            [21.174812280424405, -2.514244011062551],
            [21.159725400417734, -2.510726930093414],
            [21.15622665462557, -2.509243745174109],
            [21.1515022797991, -2.507240991037378],
            [21.138271199693484, -2.497750940286966],
            [21.132557280275901, -2.496115990454705],
            [21.122032320166472, -2.496528869974218],
            [21.101292342975196, -2.503263684173366],
            [21.0940822803502, -2.505604972616579],
            [21.088840865788907, -2.505079537852779],
            [21.0844764000827, -2.504642014648394],
            [21.081240967568274, -2.503179088133218],
            [21.078310319955062, -2.501853971106136],
            [21.071299613254556, -2.496637467914637],
            [21.068905320053059, -2.494855925489948],
            [21.068689370448649, -2.494695039996913],
            [21.068046359961546, -2.494215989271622],
            [21.060021563103106, -2.493911360240174],
            [21.054319199613349, -2.493694893019654],
            [21.038742359586092, -2.498454976159066],
            [21.016336328241298, -2.49444189528112],
            [21.017097360288762, -2.488030701729272],
            [21.017830680208032, -2.483119867900719],
            [21.017939399713612, -2.477183915362675],
            [21.01866624008472, -2.4718635742379],
            [21.019779000295145, -2.465316070306647],
            [21.019829400274165, -2.455695347267298],
            [21.019754879631453, -2.450986967612969],
            [21.019906079568507, -2.447712266983532],
            [21.020027759966979, -2.442595104327964],
            [21.020159160136846, -2.438091956006658],
            [21.020104440159649, -2.434611945059372],
            [21.021989040048719, -2.425610080567467],
            [21.022715520195391, -2.42028989332177],
            [21.02327208041282, -2.417016017961098],
            [21.023210519764696, -2.413126648133532],
            [21.02314247956847, -2.408827782890821],
            [21.022250759715146, -2.403707950209837],
            [21.019348439576099, -2.399606235545593],
            [21.017674800048365, -2.39632654776026],
            [21.014975159600308, -2.392225350103206],
            [21.01176436248425, -2.38377902691403],
            [20.986881480068412, -2.37124395539739],
            [20.974895836849132, -2.360941675411854],
            [20.970470520163911, -2.357137866946889],
            [20.968145088218815, -2.354666407625927],
            [20.960905320104036, -2.346971986232465],
            [20.960329681466618, -2.345801629445696],
            [20.959989479587041, -2.345109949450029],
            [20.958747979118289, -2.342585075522729],
            [20.957504399947982, -2.340055967206814],
            [20.957049675446111, -2.337400285142204],
            [20.954824199941015, -2.324403002805645],
            [20.939795521781619, -2.30524302835587],
            [20.937078359693981, -2.301778906370178],
            [20.934783672589479, -2.298137892539961],
            [20.92980924002557, -2.290244854104165],
            [20.928845949596958, -2.2838212073295],
            [20.927807279736239, -2.276894863129191],
            [20.92099427965336, -2.265592925010755],
            [20.905519320257447, -2.247119952636603],
            [20.900205360448719, -2.236829012790836],
            [20.891509789771014, -2.219988296273979],
            [20.88873308285477, -2.214610774256573],
            [20.88742834099002, -2.213483655460549],
            [20.878023239578418, -2.205358909624307],
            [20.860195320263852, -2.202974940972224],
            [20.855985241717306, -2.201069944059015],
            [20.851976160317285, -2.199255893392056],
            [20.845999029131566, -2.194989855812011],
            [20.843540280011798, -2.19323497723664],
            [20.83194936012163, -2.176619923332677],
            [20.824209359750984, -2.16830296197227],
            [20.811214440445376, -2.159040947502049],
            [20.809908360090851, -2.157581020568451],
            [20.799504517136249, -2.145966475974864],
            [20.797559280067173, -2.14379486063658],
            [20.785972319950776, -2.126489985740399],
            [20.782561784227926, -2.12302785327751],
            [20.780281439625281, -2.120713005433548],
            [20.774120399944689, -2.117692936934952],
            [20.767513319776096, -2.111910879555392],
            [20.758651199648067, -2.099217943103511],
            [20.739525479750959, -2.080725976700407],
            [20.731140359648926, -2.063895897747569],
            [20.729910239936501, -2.062100865906579],
            [20.722280399969151, -2.050974000251781],
            [20.716860240429263, -2.035997925596549],
            [20.710726199614534, -2.026998992318978],
            [20.69466996375445, -2.011457604835168],
            [20.686367159875179, -2.003420973521137],
            [20.685953946522577, -2.002459011059367],
            [20.683199160295871, -1.996045848596925],
            [20.66864615984235, -1.978494916140485],
            [20.657524108428216, -1.96050208872294],
            [20.652242646971548, -1.964116357558907],
            [20.650184418009395, -1.965524864656732],
            [20.648932577931749, -1.968091558951291],
            [20.646492479633917, -1.973094938219408],
            [20.641592159877579, -1.994227864893998],
            [20.637909360063478, -1.999727921440563],
            [20.629881359812721, -2.004976869600019],
            [20.626661520255013, -2.00909986024338],
            [20.625498008824302, -2.013234146925091],
            [20.618639640226316, -2.015961220673802],
            [20.613601439853646, -2.017790167411782],
            [20.606941439931646, -2.019614789189038],
            [20.594013840373457, -2.02244646136245],
            [20.583511920254416, -2.024875019654801],
            [20.57360544033665, -2.026486551644461],
            [20.566121759859307, -2.027490178264873],
            [20.55883428042312, -2.028084933593401],
            [20.549542320024916, -2.03010731370983],
            [20.543277959713627, -2.031318975982461],
            [20.537859959723662, -2.034784645481218],
            [20.533906079797848, -2.041119770951033],
            [20.528552879780911, -2.04867948854968],
            [20.524801680444448, -2.055015278743527],
            [20.521436760273406, -2.060123914342058],
            [20.517843240422099, -2.063594383934042],
            [20.513641320374994, -2.067063224481451],
            [20.507428800042103, -2.071550065713639],
            [20.501376840091531, -2.07337642673814],
            [20.49530543969987, -2.073974406603051],
            [20.489475599881402, -2.077029502077228],
            [20.484051479669414, -2.080085673371914],
            [20.480258160125878, -2.083760166632433],
            [20.475444959884115, -2.087022733009476],
            [20.470821839563214, -2.089466862027463],
            [20.465368199812673, -2.090680639424783],
            [20.458891440038972, -2.091277531739618],
            [20.448997920115797, -2.09370778497924],
            [20.441308319724168, -2.094506222126443],
            [20.433029759577732, -2.096531398769773],
            [20.427602039816403, -2.099382744522746],
            [20.42221320003889, -2.104690797288145],
            [20.418426720267956, -2.108774802960859],
            [20.414218319774388, -2.111834153243013],
            [20.408970960162534, -2.113253057997055],
            [20.405364120092194, -2.115904631631998],
            [20.397663359929794, -2.119545899306012],
            [20.39700743975374, -2.118527022424257],
            [20.385181439736868, -2.105124864419373],
            [20.358751319736918, -2.085203952482096],
            [20.352502180479782, -2.082728410951044],
            [20.347568279901509, -2.080773887101382],
            [20.342266573113257, -2.076873833563816],
            [20.326151159835547, -2.065018917256316],
            [20.315692983179304, -2.052773812229976],
            [20.307939480231621, -2.048591951674593],
            [20.298122230869343, -2.045548842932412],
            [20.293378413805158, -2.043131412872321],
            [20.288542319998363, -2.040666954118683],
            [20.28204323978478, -2.039467907725171],
            [20.276309112764888, -2.038410632475255],
            [20.267980200250175, -2.036874922483862],
            [20.257111972311115, -2.033630354962768],
            [20.255422339178057, -2.033125936673701],
            [20.247442200267358, -2.028941941989307],
            [20.245738821113815, -2.027066969527366],
            [20.241983159845333, -2.022932965223849],
            [20.24029080391864, -2.019323517861103],
            [20.239496279982426, -2.017628959092345],
            [20.238638399665891, -2.00635696456633],
            [20.241084387318725, -2.000984328983511],
            [20.24187623966527, -1.999245013160837],
            [20.235532320060813, -1.987481872346526],
            [20.227443909005551, -1.979103584868569],
            [20.223478439914246, -1.974995983494017],
            [20.208566572386193, -1.969164270595811],
            [20.199457439809549, -1.965601873705345],
            [20.19539996436853, -1.964014946809068],
            [20.189478240371216, -1.961698887938352],
            [20.18492136002272, -1.958452997667694],
            [20.176075440112545, -1.945065885549177],
            [20.167850035078125, -1.936703932161518],
            [20.165840298971649, -1.934660790725814],
            [20.161319399743565, -1.924515954326906],
            [20.15354880005939, -1.919135614398368],
            [20.143571399946573, -1.916243421006473],
            [20.135466360177073, -1.916426614726564],
            [20.130398999591957, -1.916413284645393],
            [20.121473520388612, -1.915980247664631],
            [20.111505479822757, -1.913702118580025],
            [20.104404479859802, -1.913273944567909],
            [20.095469279986766, -1.912226836763804],
            [20.086534440338202, -1.911179727408416],
            [20.07476136007471, -1.910125052095762],
            [20.063184840178543, -1.908661474876794],
            [20.051800919977602, -1.906584364841771],
            [20.042258040357574, -1.905535631377787],
            [20.034136800370252, -1.904695310942487],
            [20.022138719975857, -1.902207131213003],
            [20.013618600154622, -1.901775171627659],
            [19.995343200352647, -1.89967985926743],
            [19.981333800121931, -1.898209787816615],
            [19.969538400316885, -1.895722319904543],
            [19.957978079740247, -1.8952822518836],
            [19.950065999890406, -1.894851912084364],
            [19.943174160064935, -1.894833718118369],
            [19.933042319791831, -1.895011510822058],
            [19.927641238671935, -1.8972489547892],
            [19.913656319329384, -1.891810885914516],
            [19.902245789233088, -1.879986770066096],
            [19.901380496018806, -1.879090110204922],
            [19.899545758916226, -1.866060299586309],
            [19.898363878734564, -1.855412723246761],
            [19.897462439109876, -1.849678734970564],
            [19.890404278904501, -1.826324126951249],
            [19.885306679230293, -1.811572304764792],
            [19.880575558954355, -1.794364994679439],
            [19.873546558961426, -1.772852924017554],
            [19.869896518909105, -1.759947001238176],
            [19.867727159363156, -1.750934544985471],
            [19.863430558681742, -1.735570681843415],
            [19.858931279207567, -1.720206150727143],
            [19.855072079017766, -1.706890555769502],
            [19.852310878819914, -1.698899856518955],
            [19.850186878805975, -1.692753183638515],
            [19.847435039053412, -1.685376753638139],
            [19.843872838964501, -1.677998133009379],
            [19.842530399298862, -1.670011277343608],
            [19.839588838951538, -1.663453033600589],
            [19.835434799109059, -1.657096363931373],
            [19.82946239934995, -1.651144309027241],
            [19.824323759243683, -1.646627199403459],
            [19.817579518907603, -1.64312959894896],
            [19.812086999173218, -1.641886862703335],
            [19.807003439268613, -1.640849867415539],
            [19.800654839441545, -1.636738993453483],
            [19.794277438728137, -1.630785795860567],
            [19.78808291883692, -1.623604966597821],
            [19.782310318770005, -1.617448688550585],
            [19.776534479378224, -1.611087727069787],
            [19.771990919248758, -1.605753490879929],
            [19.767238198981811, -1.600009189750353],
            [19.759254838712483, -1.595075247220642],
            [19.753286039401011, -1.589327853024499],
            [19.749183479312528, -1.586246511772946],
            [19.743658559142499, -1.582956715204219],
            [19.7381469591915, -1.580485760200595],
            [19.735495559172541, -1.579455219598458],
            [19.732236119182186, -1.578423056663416],
            [19.729330199493774, -1.580745918391943],
            [19.72973627662973, -1.589715942926612],
            [19.727367479412653, -1.604185898778748],
            [19.718664478769224, -1.607580875818376],
            [19.714725120109957, -1.610935884592429],
            [19.712232358976919, -1.613058875811946],
            [19.69402757394278, -1.649339248369127],
            [19.689575301510818, -1.658212007338585],
            [19.685203199226386, -1.663012910318082],
            [19.681131103704104, -1.663970150826785],
            [19.679481367447767, -1.66435796040678],
            [19.679690159275975, -1.667350005700435],
            [19.665209879241349, -1.681739961913781],
            [19.660399429640965, -1.683550795990055],
            [19.652553358896544, -1.696609021116654],
            [19.650634199021841, -1.705530761066055],
            [19.649116079429373, -1.712077151093257],
            [19.64802275876167, -1.719852873663164],
            [19.646733238849404, -1.728037506941034],
            [19.646817479263515, -1.733359876983941],
            [19.646499239396015, -1.738885981628725],
            [19.645599238872407, -1.746048005769897],
            [19.644689159251332, -1.752596055737558],
            [19.644368039385036, -1.757917454205485],
            [19.64104163897337, -1.765482573871402],
            [19.638310678762977, -1.772230337059186],
            [19.634340599517635, -1.777542132192521],
            [19.628932319299036, -1.781621714984737],
            [19.62093131881247, -1.788355727598866],
            [19.61531063913149, -1.791820813097671],
            [19.607447159036852, -1.794461010875801],
            [19.602869038921785, -1.799771119257773],
            [19.601283239357464, -1.80201859269254],
            [19.581991469473348, -1.801476006944371],
            [19.543365360340463, -1.800080966738909],
            [19.53127619975939, -1.795404967992527],
            [19.527181199892347, -1.792158944735168],
            [19.502599467794031, -1.774295103444999],
            [19.504331618189479, -1.771716870677082],
            [19.506752279639514, -1.768113982963705],
            [19.510244279982238, -1.757329991938917],
            [19.517849279735355, -1.747260949010813],
            [19.519047360134834, -1.738070984247348],
            [19.518425286682053, -1.72726007311786],
            [19.517830153704619, -1.720446615784714],
            [19.517782331890469, -1.719898947427927],
            [19.52035740026313, -1.710027916162275],
            [19.517450015422483, -1.701997360723453],
            [19.515184200171227, -1.695738877872545],
            [19.515712319726788, -1.683785984665343],
            [19.513263240072746, -1.672963857958158],
            [19.509868476071336, -1.667194049911042],
            [19.492811279829521, -1.653058848214283],
            [19.488985199625905, -1.643376956630701],
            [19.48894683078348, -1.642802644672847],
            [19.488355200337363, -1.633946880054906],
            [19.491329160222033, -1.612411915461083],
            [19.49193935974338, -1.607988942621587],
            [19.491108920263816, -1.603930039443033],
            [19.490385240165864, -1.600392936545572],
            [19.494585359989156, -1.585935007844022],
            [19.495394999876659, -1.578819959229609],
            [19.494680039725168, -1.572062874255963],
            [19.490496480344138, -1.563863899730944],
            [19.484479080379163, -1.55504583978033],
            [19.480543560221125, -1.549713259450977],
            [19.475555759827476, -1.541921375428852],
            [19.470667320290751, -1.527579427803256],
            [19.468279079937663, -1.517542907233155],
            [19.465723440327992, -1.509757391380384],
            [19.463782679563984, -1.50238317851408],
            [19.462871520167933, -1.496035018332887],
            [19.459901159832601, -1.487634496416463],
            [19.45713995963478, -1.479643836555609],
            [19.454838839694567, -1.475134280767058],
            [19.451466360200421, -1.466937455730127],
            [19.4481032402532, -1.459354635344704],
            [19.44557387995885, -1.453206885164148],
            [19.441847519938296, -1.44828413325633],
            [19.437706079866004, -1.442746428758114],
            [19.434365639684767, -1.436596471270802],
            [19.433271240140417, -1.431476027707577],
            [19.43336735987581, -1.424721184275884],
            [19.435676759588009, -1.416948673633689],
            [19.438803360307446, -1.409587845694067],
            [19.442168639804592, -1.404479233928362],
            [19.446318719873297, -1.397735121132967],
            [19.448670239792534, -1.392623779917572],
            [19.45395539961325, -1.38076520327411],
            [19.458867599589201, -1.370952529462818],
            [19.464574319908117, -1.360118540973803],
            [19.467926640308963, -1.354191069855998],
            [19.472433480004575, -1.344377385840935],
            [19.477947240403797, -1.334156985533965],
            [19.483612199841772, -1.320661854162055],
            [19.489325399708818, -1.310237203812619],
            [19.494459719816913, -1.301653298719355],
            [19.49838120020538, -1.293270993587815],
            [19.504297079763443, -1.28284694907476],
            [19.507604039734058, -1.274053570577559],
            [19.509543719824755, -1.268531858974721],
            [19.511100720299364, -1.264441921136116],
            [19.514377440282548, -1.257101891743819],
            [19.524271320430163, -1.245212928472418],
            [19.533916440007577, -1.236770975223039],
            [19.538759159787926, -1.229216979894819],
            [19.54366987484871, -1.226959868208808],
            [19.545173280036856, -1.226268858008569],
            [19.556921159861673, -1.209794922512571],
            [19.584274284443044, -1.187594627266824],
            [19.589515200439347, -1.183340983678177],
            [19.598692320211615, -1.176733945583599],
            [19.60600139963881, -1.173184993856099],
            [19.608896961751991, -1.171778474182293],
            [19.610374320288464, -1.171060846235626],
            [19.612497229747664, -1.159582943929909],
            [19.61058419997649, -1.13520885863753],
            [19.615307399806589, -1.109038929223192],
            [19.6095784291164, -1.093106999495924],
            [19.609012440181768, -1.091533012763148],
            [19.607017319664973, -1.081407872192506],
            [19.612016248388361, -1.046737137622585],
            [19.607240160245919, -1.045560010220775],
            [19.60611012004269, -1.042099920202702],
            [19.606804860015451, -1.039839922603965],
            [19.607730120266506, -1.036830038012383],
            [19.610719920144561, -1.033859912703794],
            [19.609697160345839, -1.013860965188893],
            [19.601684489845415, -0.977960875176301],
            [19.605257640397639, -0.976268466901246],
            [19.610920440285661, -0.975464741669875],
            [19.616393160252819, -0.97547915791491],
            [19.621663559855094, -0.975493214273682],
            [19.632213720403165, -0.976135113725376],
            [19.641145680052968, -0.976977582605008],
            [19.652107680429573, -0.978030174012484],
            [19.659639959763787, -0.980096971935452],
            [19.665537839778544, -0.981340761953866],
            [19.671850799845036, -0.983199778277029],
            [19.678572000190695, -0.985264589976854],
            [19.682858159753579, -0.987118198575876],
            [19.684704960332148, -0.988556068724145],
            [19.688616047212765, -0.99206261035184],
            [19.688043437694461, -1.001200740004901],
            [19.68760836024617, -1.008142863644162],
            [19.676231697534416, -1.030163623489053],
            [19.673288280369427, -1.035860900005976],
            [19.671152400135803, -1.049865971219634],
            [19.671350334925521, -1.054757404952017],
            [19.671552359744691, -1.059749925493333],
            [19.673711279968703, -1.069015935192877],
            [19.677743476817636, -1.086321878252839],
            [19.67868432014394, -1.090359904761389],
            [19.679841245127001, -1.09310544788409],
            [19.684316159595699, -1.103725014537353],
            [19.684417268574173, -1.106670391181733],
            [19.684513440411866, -1.109471948610868],
            [19.682324015197455, -1.115951844103235],
            [19.679399280295403, -1.124607964646909],
            [19.679615446393811, -1.12765563666403],
            [19.67982335966969, -1.13058695414439],
            [19.68453648040229, -1.144864937942397],
            [19.681961400351533, -1.155880930083599],
            [19.695648239818244, -1.158952923550164],
            [19.699623422392694, -1.160926333509925],
            [19.703621159867303, -1.162910938543631],
            [19.711343348442501, -1.170541893191436],
            [19.724815440250616, -1.171314922970311],
            [19.73355912020337, -1.168412147578205],
            [19.741618800440932, -1.165362869399696],
            [19.749462840094516, -1.161494415226384],
            [19.761161399715292, -1.15784074963819],
            [19.772097480102683, -1.157255651367525],
            [19.784253239982267, -1.156878318787518],
            [19.79621244039285, -1.156910033898466],
            [19.809786959906312, -1.156536486180985],
            [19.822151879923375, -1.156569281794257],
            [19.848016440383379, -1.157584870541295],
            [19.862964359998742, -1.139288901867515],
            [19.872316016142534, -1.135099216604886],
            [19.88220024029911, -1.130670926366788],
            [19.901493360351097, -1.111479914132435],
            [19.909280447714, -1.107389869095105],
            [19.910182621262251, -1.107227273438784],
            [19.91545523970326, -1.106277006022959],
            [19.922933226658365, -1.106982140733407],
            [19.928467439899997, -1.107503987056781],
            [19.935177479576584, -1.104254982054586],
            [19.94477079420988, -1.099609289320354],
            [19.948162319784689, -1.097966895091055],
            [19.953904340301008, -1.097408956780185],
            [19.957075200116176, -1.097100851953444],
            [19.971916200449776, -1.098337027118768],
            [19.979230695819805, -1.096386126718418],
            [19.985410440221226, -1.094737882316184],
            [20.000000160210305, -1.095505897092745],
            [20.00504843968044, -1.095771873512261],
            [20.012605199902822, -1.092138847814714],
            [20.049667200192232, -1.080861861777834],
            [20.055484440240541, -1.077691936681192],
            [20.055900999817599, -1.077464906479617],
            [20.061350280044056, -1.07449497693361],
            [20.063469094083889, -1.07401575733486],
            [20.070268199924261, -1.072477977741574],
            [20.080806503608905, -1.066563019637274],
            [20.092231439987419, -1.06548000651146],
            [20.098888199686158, -1.05931293392412],
            [20.102091479699936, -1.058411920051736],
            [20.11000592211898, -1.04995689281212],
            [20.111507280046574, -1.04835298391493],
            [20.115059760364115, -1.046075482522956],
            [20.118612239783335, -1.043797979455783],
            [20.122610236871068, -1.04261543648226],
            [20.134624319853923, -1.039061864145576],
            [20.148817167743736, -1.032707934949726],
            [20.156614200355136, -1.026547937738735],
            [20.161909187745032, -1.018534245860279],
            [20.159424181767836, -1.013234757880777],
            [20.144426400264312, -0.998672861302215],
            [20.142154788184556, -0.994893953335235],
            [20.137634279723571, -0.987373912173283],
            [20.134939321294823, -0.978625943384106],
            [20.134975320381503, -0.971733002809878],
            [20.137541400211411, -0.961635950518683],
            [20.136633906840043, -0.953678329054163],
            [20.136230280308137, -0.950139006226045],
            [20.137397400271354, -0.945090992817438],
            [20.153913480132136, -0.931166927593402],
            [20.159891279664432, -0.923157852453954],
            [20.163635279902223, -0.912416944938578],
            [20.166845399688537, -0.90320690004788],
            [20.177077721916074, -0.891990895718981],
            [20.18728439993717, -0.880802966611405],
            [20.191896359588995, -0.8720968960306],
            [20.191926037231038, -0.871761115918471],
            [20.192383439610758, -0.866585984866637],
            [20.190864684011043, -0.860694819904511],
            [20.190366359776846, -0.858761846686044],
            [20.194528320065199, -0.848674926307083],
            [20.19183527953955, -0.839699726438325],
            [20.195443055654394, -0.834405531368261],
            [20.201038199825121, -0.826194976250714],
            [20.217556440134125, -0.810892893672092],
            [20.219314287736609, -0.807934768748182],
            [20.220550199785951, -0.805854961435492],
            [20.220865200328554, -0.80421391566787],
            [20.223366480185433, -0.791165898165961],
            [20.225439359771517, -0.787730969396906],
            [20.244013199673837, -0.771980901956742],
            [20.250727709367279, -0.762921289160817],
            [20.254358159858196, -0.758022862792396],
            [20.25721796453151, -0.747557171187848],
            [20.264826240440438, -0.719713939410415],
            [20.265564013308587, -0.713425341257513],
            [20.26649628041887, -0.70547891585819],
            [20.272428360194759, -0.693821904366159],
            [20.272649759878025, -0.689202488197671],
            [20.272568759687147, -0.684084757040828],
            [20.273893920258317, -0.678151880544642],
            [20.275225560377624, -0.672628639323048],
            [20.277004319861572, -0.669767444010475],
            [20.279613598775196, -0.668136799413608],
            [20.28381932318754, -0.665600312105404],
            [20.280880079595335, -0.660300040083602],
            [20.271340079974134, -0.650599951487779],
            [20.265532320745354, -0.650449452532683],
            [20.260149840141725, -0.650309973500066],
            [20.255600040314288, -0.648218431412536],
            [20.254960079607564, -0.640169941960802],
            [20.251513976887704, -0.637108928095793],
            [20.249499960308892, -0.635319970044853],
            [20.246699880127267, -0.624439913054486],
            [20.23988074814427, -0.617010801373813],
            [20.234189880395171, -0.613950016142875],
            [20.232290833799713, -0.611238757741782],
            [20.226380573203727, -0.602800700830533],
            [20.224559724055442, -0.603020313731614],
            [20.22086987965287, -0.610580016788014],
            [20.220309334508844, -0.61076347295057],
            [20.218119840124121, -0.611480053111116],
            [20.216186356612237, -0.609641079282227],
            [20.205650160375246, -0.599619887984833],
            [20.203961043773486, -0.598005528599067],
            [20.203840080230599, -0.597889918576735],
            [20.202319803783098, -0.597535694777463],
            [20.195600039843566, -0.595969991703187],
            [20.191360298926327, -0.593370285697147],
            [20.191015414129186, -0.593375663690163],
            [20.188280696265934, -0.593419991663881],
            [20.183710926889752, -0.599578756830427],
            [20.1805182443014, -0.600019002958361],
            [20.179879047162675, -0.599661568965034],
            [20.175959879936062, -0.597469995955362],
            [20.173700159754016, -0.593319975643986],
            [20.174447574240077, -0.58327350013429],
            [20.174929282336464, -0.576789580050164],
            [20.173434253040021, -0.575872895745152],
            [20.170379879564411, -0.574000091853088],
            [20.163991749373267, -0.567621761774662],
            [20.157429959566304, -0.561070030096289],
            [20.156483080459633, -0.558144774087322],
            [20.156310915640482, -0.557612892017604],
            [20.161109645819668, -0.553419057534516],
            [20.163880079800283, -0.550999938732506],
            [20.162980329906663, -0.548921259331487],
            [20.155688027415732, -0.543203587691925],
            [20.155019973695147, -0.542679487826187],
            [20.154931027905604, -0.542366756598855],
            [20.15345035548404, -0.537159202664466],
            [20.155460040386512, -0.528530100854976],
            [20.150409959794196, -0.527289964302118],
            [20.146430159879198, -0.526319986386637],
            [20.141439839711158, -0.521240127533981],
            [20.129829839604337, -0.515200017302048],
            [20.123460000010699, -0.509879906071188],
            [20.120519879662787, -0.505959974090679],
            [20.120929738706128, -0.500789358823981],
            [20.119430160341082, -0.495619991928341],
            [20.120069535346229, -0.494268232243112],
            [20.12126999807785, -0.491727860534212],
            [20.12116649688577, -0.48994394051073],
            [20.12106996033209, -0.488280057976487],
            [20.120162157940221, -0.487818192664828],
            [20.114229959586723, -0.484800047485191],
            [20.110738544047237, -0.481066528676862],
            [20.109470040221069, -0.479710062571402],
            [20.100999960154379, -0.483789872601261],
            [20.097362024900516, -0.481481361690489],
            [20.095412491189457, -0.472731130258427],
            [20.094069959895645, -0.466699964477543],
            [20.096240039890429, -0.457959986691093],
            [20.095210074704816, -0.454174678950299],
            [20.092759919767381, -0.445169907133969],
            [20.094440787139895, -0.443659810790066],
            [20.096010000210811, -0.442250025577425],
            [20.099870237056464, -0.438778771523002],
            [20.105449920322812, -0.418830013381081],
            [20.10712848351664, -0.416201489002029],
            [20.11143996029919, -0.409449985942585],
            [20.108788955538955, -0.392439057256169],
            [20.086289999766244, -0.373709898352287],
            [20.07575339030419, -0.366602546544775],
            [20.071510931983269, -0.363740843091494],
            [20.071016301621501, -0.359002265925758],
            [20.070088025726058, -0.350107422999696],
            [20.069448326429054, -0.349272608057159],
            [20.064320714041219, -0.3425778988108],
            [20.064355815710936, -0.342486485895145],
            [20.064849839709861, -0.341199938612474],
            [20.066345710727717, -0.337333712931375],
            [20.067329067723158, -0.334789415049267],
            [20.061332211330441, -0.330232870609906],
            [20.054840040059698, -0.325299972328508],
            [20.054220119868656, -0.311969897251186],
            [20.052420119719773, -0.307140059597432],
            [20.051029997478864, -0.306901582644722],
            [20.049680160186856, -0.306670015873519],
            [20.043950039653119, -0.31123004819166],
            [20.040770159854198, -0.311589970099308],
            [20.039401289956256, -0.311622440998723],
            [20.038240080009309, -0.311649986775741],
            [20.037634065738832, -0.311257307288834],
            [20.030739839987969, -0.306790050186721],
            [20.025720000281414, -0.306759951399032],
            [20.016560159603614, -0.312450033348331],
            [20.01259785527705, -0.311624263275925],
            [20.01085565273355, -0.311261177932307],
            [20.000000160210305, -0.304210037899006],
            [19.995170040200144, -0.301070046350708],
            [19.995184898334934, -0.29890200619566],
            [19.995198648847008, -0.296710200004372],
            [19.99227369475603, -0.297016257985886],
            [19.991090159877647, -0.297140099750676],
            [19.986999840233182, -0.293209970862484],
            [19.986379987415788, -0.292131424135578],
            [19.984269959797768, -0.288459966951199],
            [19.978409879991876, -0.278240107168149],
            [19.974770214582769, -0.276150127762895],
            [19.974359702464206, -0.276661139327377],
            [19.968345445704408, -0.284147783456041],
            [19.966375240860376, -0.283237243924571],
            [19.965839374233809, -0.2829889632087],
            [19.96017011995048, -0.275599891418778],
            [19.946715895633329, -0.274226229895735],
            [19.943520120145468, -0.27389994440609],
            [19.939250488685481, -0.261471021972759],
            [19.933340040341601, -0.258450098587157],
            [19.928194935060255, -0.257979360127064],
            [19.925359355255196, -0.257718936043152],
            [19.924229880092277, -0.255639919377425],
            [19.925409960050121, -0.248529939389199],
            [19.923776671946609, -0.244926007528396],
            [19.922700702238636, -0.242548923999171],
            [19.927530000290322, -0.236149961511322],
            [19.928710080248134, -0.229030058442888],
            [19.92581407167226, -0.224823713888003],
            [19.922079960089118, -0.219400053378339],
            [19.921158365862716, -0.218049614532966],
            [19.920790079952418, -0.217509953181142],
            [19.920055114319567, -0.214367833580714],
            [19.918100160174088, -0.206010025307291],
            [19.916390620374315, -0.203236760767316],
            [19.915400160399926, -0.201630007524577],
            [19.91189074980872, -0.1903891007408],
            [19.91180987987358, -0.190130068160616],
            [19.907709840457755, -0.189649927511982],
            [19.901699999815921, -0.202930026820048],
            [19.900060415420583, -0.204149709577214],
            [19.898030159996413, -0.205660013094943],
            [19.893020040061216, -0.204939983219449],
            [19.89162384610729, -0.200050516170649],
            [19.888319880221538, -0.18848003528054],
            [19.886031513663383, -0.185512042713987],
            [19.884505127773654, -0.185849632095206],
            [19.883829960294321, -0.186000029745526],
            [19.875030120364958, -0.19909989946524],
            [19.871861377878915, -0.200347157472098],
            [19.871600039996459, -0.200450023436297],
            [19.867891860080629, -0.199991327362652],
            [19.86383987963422, -0.199490103562633],
            [19.860209999573492, -0.195559945488945],
            [19.859296160502932, -0.18755549255631],
            [19.859010119848492, -0.185050021788016],
            [19.858900633181651, -0.184107219757214],
            [19.858470120073321, -0.18040000942058],
            [19.853930160391521, -0.177389937201028],
            [19.843199999918379, -0.177779961822519],
            [19.8318398401567, -0.169910082200459],
            [19.822960458900511, -0.166639342992869],
            [19.837339920112488, -0.137499990822539],
            [19.832990040351554, -0.136170047904891],
            [19.829821333798133, -0.138117571171288],
            [19.828190160328816, -0.139120108790451],
            [19.827447357793421, -0.138382698058173],
            [19.826799840458513, -0.137739881360017],
            [19.8251798402347, -0.136110030500633],
            [19.824762881805697, -0.132869608648705],
            [19.824530040280667, -0.131060068765447],
            [19.827299879576572, -0.125110019996727],
            [19.835769959643255, -0.120339959602809],
            [19.849661308669209, -0.122487402649105],
            [19.86395042002485, -0.097549693531904],
            [19.864541771094935, -0.097136532036195],
            [19.866240000206954, -0.095950024502902],
            [19.881878411662072, -0.092814659421847],
            [19.890680040137159, -0.09105000987744],
            [19.89704987973083, -0.093840027634606],
            [19.904124250933823, -0.093192471023299],
            [19.9060497942369, -0.094324383751154],
            [19.910040119712122, -0.09667005803167],
            [19.913065686013212, -0.097152784436427],
            [19.917560160398914, -0.097869873316643],
            [19.917698042811868, -0.099821093643569],
            [19.917770040086939, -0.100839943860953],
            [19.918199880357147, -0.107049895040202],
            [19.922742199913191, -0.109829839469093],
            [19.932099839735081, -0.109199902075973],
            [19.942179840029784, -0.101909991224495],
            [19.947200039960777, -0.101249976196347],
            [19.954479960073822, -0.10496999897622],
            [19.956701315905033, -0.104928646752183],
            [19.963609920090338, -0.104800038395851],
            [19.969750066754038, -0.107360070611354],
            [19.977279839788615, -0.107860044956891],
            [19.987779959683806, -0.10745992638937],
            [19.99195992041383, -0.108810056240484],
            [19.995749999734105, -0.110030057454148],
            [19.999610650703119, -0.113835963330236],
            [20.000000160210305, -0.114219948795856],
            [20.002550039822353, -0.116730061809629],
            [20.00729988009051, -0.124570040368322],
            [20.009792624155569, -0.134095111834919],
            [20.01133007998456, -0.139969909676547],
            [20.014490160016326, -0.145959965729315],
            [20.016167809623472, -0.147259628984209],
            [20.020169879672711, -0.150360002246097],
            [20.023223865076144, -0.150519380531022],
            [20.024960039924085, -0.150609986278793],
            [20.039349960220907, -0.146789940837174],
            [20.048104879894513, -0.149095248621937],
            [20.050059959804152, -0.149610051939349],
            [20.067528959043557, -0.168538779258133],
            [20.071014800536688, -0.170373854361656],
            [20.074579920150256, -0.172250048971095],
            [20.083259879904968, -0.171380063968156],
            [20.090789999689257, -0.167749988024968],
            [20.093942114359358, -0.154314925127025],
            [20.094069739808418, -0.153769749689366],
            [20.090440803877044, -0.149380949714399],
            [20.084979959637952, -0.147279995316657],
            [20.083159364712873, -0.145520464404836],
            [20.080210515435336, -0.142670521344503],
            [20.079682000621091, -0.143894362696201],
            [20.07882876998443, -0.145870123247622],
            [20.076582041238037, -0.146032504062054],
            [20.072893481426345, -0.146299092313043],
            [20.072880000408869, -0.146300066315778],
            [20.070730163050676, -0.142993980730633],
            [20.070629999998214, -0.142839946293802],
            [20.070200159728003, -0.138249941532772],
            [20.072750040238386, -0.132289981736048],
            [20.077692203520655, -0.128120311258865],
            [20.078700120455977, -0.127269938397324],
            [20.086459919695482, -0.125250062175914],
            [20.11727988011349, -0.122440040929219],
            [20.125823304029826, -0.123623860521949],
            [20.125940085016762, -0.123640017044538],
            [20.126200262275869, -0.123529725829323],
            [20.130210000344366, -0.121829950162873],
            [20.13298379671912, -0.120649550807749],
            [20.138739839936999, -0.118200046149263],
            [20.144220120125627, -0.117999987390472],
            [20.163809880054107, -0.124309964224484],
            [20.167479355157596, -0.124862122068397],
            [20.173380119662696, -0.125750029869079],
            [20.176049304527659, -0.125272389195519],
            [20.178410040263383, -0.124849943858309],
            [20.188699920246112, -0.119859997320012],
            [20.193950159856762, -0.119889916509068],
            [20.198949839571725, -0.122670018841011],
            [20.207271838652009, -0.133204516551636],
            [20.208240378835153, -0.134432844058919],
            [20.209119840278092, -0.140869995129155],
            [20.208054927034638, -0.147627329005504],
            [20.206770119684379, -0.155779978347594],
            [20.198570039954429, -0.170270007888298],
            [20.194836938975985, -0.176860550812496],
            [20.192259959886766, -0.181410035803496],
            [20.18970172863747, -0.191267227714889],
            [20.192159880377567, -0.201619914824549],
            [20.195999664380839, -0.208529434551855],
            [20.19759366107214, -0.210256499967275],
            [20.206439651050925, -0.219839622507664],
            [20.207280385223626, -0.220062586806743],
            [20.213499960026454, -0.221709914151987],
            [20.216156242388973, -0.226166619672218],
            [20.219770080335362, -0.232229906621891],
            [20.219919840273004, -0.239630068758768],
            [20.220764316827182, -0.24019504867412],
            [20.224119960096299, -0.242440070555048],
            [20.224434694737557, -0.243412502160734],
            [20.224789920041921, -0.244510039397474],
            [20.22402113104199, -0.246986699951666],
            [20.222939880138487, -0.250469958776753],
            [20.226729433944325, -0.267717574624442],
            [20.229900120384617, -0.271169971842019],
            [20.232161515924656, -0.272062289478497],
            [20.235779999957703, -0.273490097037125],
            [20.24426087328251, -0.274469593799122],
            [20.244556292348513, -0.274294141828799],
            [20.246550120189625, -0.273109987693178],
            [20.247327825867046, -0.27214880499576],
            [20.250449999688755, -0.268290045913638],
            [20.252829082615865, -0.26071950427112],
            [20.253470040452566, -0.258679893786896],
            [20.257149960267874, -0.252730070871769],
            [20.264934269141587, -0.247148481987508],
            [20.268600120441221, -0.244519952099824],
            [20.272709879628408, -0.244989997406826],
            [20.283682091154851, -0.254526637262112],
            [20.288149919712581, -0.258409906108812],
            [20.294759879880004, -0.260279994352489],
            [20.304349920154117, -0.259419927142938],
            [20.310760079730979, -0.254629898040421],
            [20.310967329151868, -0.254289300525037],
            [20.315360160061488, -0.247070058518709],
            [20.321780778723191, -0.241139892899492],
            [20.322889112035888, -0.240897177682357],
            [20.325890159719631, -0.240239974636481],
            [20.326928901445587, -0.240595659074207],
            [20.330679959746575, -0.241880089139054],
            [20.330828609366538, -0.242008588028289],
            [20.331640080020563, -0.242710058566633],
            [20.338859880383193, -0.249039997092775],
            [20.343679335594317, -0.24240653322159],
            [20.340926280421147, -0.234336642944631],
            [20.339982000140576, -0.22901852420795],
            [20.338800840407789, -0.22436762401562],
            [20.338106399574031, -0.217938906955473],
            [20.336674319721126, -0.206634351769269],
            [20.335780080093471, -0.199541469624577],
            [20.335485599766901, -0.194441059808274],
            [20.336084280191372, -0.18866909991694],
            [20.336945039608402, -0.181342808935398],
            [20.337306480356251, -0.17623806725251],
            [20.338129799788859, -0.170242972788086],
            [20.338990560104222, -0.162916494512038],
            [20.340756719818014, -0.154474909307591],
            [20.343141359723472, -0.147360379023976],
            [20.345270039960088, -0.141578492275106],
            [20.346941159713435, -0.137261901781372],
            [20.374634160085893, -0.119273878564002],
            [20.380602239846827, -0.112188896328304],
            [20.387010239873767, -0.107860945707266],
            [20.393278008393239, -0.10537615694548],
            [20.39958215958006, -0.102876945122006],
            [20.413545479829931, -0.093308879497383],
            [20.424741662017976, -0.089694834724967],
            [20.436889319992002, -0.077820852587962],
            [20.444960892127273, -0.073725818772397],
            [20.447637480008481, -0.072367878372454],
            [20.450407187252047, -0.071746424201345],
            [20.45193336024106, -0.071403988587139],
            [20.452731526845735, -0.071224844891134],
            [20.455631279599711, -0.070574011380127],
            [20.457891360006197, -0.074947925666028],
            [20.464789855449595, -0.073250163329316],
            [20.47342139960374, -0.071125887955962],
            [20.483313250457108, -0.069859758093717],
            [20.492367479800212, -0.068700841120403],
            [20.508991200289898, -0.065856932101519],
            [20.527527239983357, -0.062684996552116],
            [20.548967400039707, -0.063483973032605],
            [20.554319160057261, -0.051910255450414],
            [20.566445040173857, -0.032530244285023],
            [20.57212763982907, -0.024728458709066],
            [20.576448359377558, -0.018710266408819],
            [20.566583998768532, -0.004133665767071],
            [20.562032210071052, -0.00156896528003],
            [20.546409238859049, 0.001279661102482],
            [20.537702638666286, 0.00255337416626],
            [20.527902718704144, 0.003819878499735],
            [20.515692238847336, 0.004848833910888],
            [20.504343599080869, 0.005439641303617],
            [20.494731239265203, 0.005598246908341],
            [20.483139238701757, 0.005300139599548],
            [20.472240238972656, 0.006337566237146],
            [20.46816755954546, 0.009194634882128],
            [20.464812719370222, 0.01427488960298],
            [20.464299719359207, 0.019373888209372],
            [20.464008490933995, 0.026202862972287],
            [20.463729838922749, 0.030240372978132],
            [20.465396638677916, 0.035131921275532],
            [20.471472719292223, 0.041383334982286],
            [20.475743759310561, 0.045626401096346],
            [20.484424439514111, 0.051229692375963],
            [20.490444719477882, 0.055484293092645],
            [20.498238719376879, 0.060637900466997],
            [20.507556598866007, 0.065579732189153],
            [20.518023239448837, 0.072525583098461],
            [20.526710038976148, 0.078350559379492],
            [20.537176679558979, 0.085296589096824],
            [20.546925479093257, 0.090019433326218],
            [20.55578759922129, 0.094292595207661],
            [20.564012519165445, 0.099227213203309],
            [20.570094719103444, 0.10570066586084],
            [20.573304119339216, 0.111046035061017],
            [20.576100959297644, 0.117275988717094],
            [20.576868839202479, 0.121274110575576],
            [20.576999158699071, 0.125933687869189],
            [20.576723399263042, 0.131699717644308],
            [20.574717479199904, 0.138119813096638],
            [20.571043462214327, 0.142506885244855],
            [20.563265159476604, 0.144961112800142],
            [20.553129716060909, 0.151264878610854],
            [20.548349279174182, 0.154238082943566],
            [20.530996199437332, 0.155912990702844],
            [20.524133582706369, 0.158259584517672],
            [20.517265439539798, 0.160608067283759],
            [20.51535023943887, 0.161698117532372],
            [20.506944238896374, 0.16648312920889],
            [20.49522047883692, 0.176019985023546],
            [20.468515318951479, 0.201724089394996],
            [20.457213912602661, 0.222999767605944],
            [20.447147223543848, 0.241950979308878],
            [20.430643319448457, 0.250293151732939],
            [20.426496478704685, 0.254389107552707],
            [20.425754755944265, 0.255974773264093],
            [20.42253827878066, 0.262851004614753],
            [20.414377875840181, 0.272018932692252],
            [20.410778159410089, 0.276063086842412],
            [20.398525199121806, 0.292946111904575],
            [20.392942691552182, 0.29520931152904],
            [20.391882430683594, 0.295639168829557],
            [20.391716865786851, 0.295764583287241],
            [20.379009986785523, 0.30538999253227],
            [20.379000964106808, 0.306643917957941],
            [20.378990159170552, 0.30815007542307],
            [20.377792512657372, 0.308737972969156],
            [20.376239684857214, 0.30950078199821],
            [20.374387322808747, 0.312801948951605],
            [20.372519878944981, 0.316129994107751],
            [20.3708902227302, 0.317463573863626],
            [20.365857220009769, 0.321581696463422],
            [20.362179838833427, 0.323922848017852],
            [20.36195027885416, 0.324068994470505],
            [20.361629027833821, 0.324526795147005],
            [20.35778615901588, 0.330003099513072],
            [20.353508107646729, 0.347881235484512],
            [20.339935198812597, 0.359468106408025],
            [20.311779239082039, 0.368846027865597],
            [20.30468345653426, 0.371075058000586],
            [20.302574226620195, 0.371961276893667],
            [20.295061258369618, 0.375118010047434],
            [20.301700319460643, 0.396548982283006],
            [20.297706478877746, 0.408458004148623],
            [20.30262515930016, 0.41907512523483],
            [20.300033159481071, 0.427551113610606],
            [20.302509216441379, 0.431250997272492],
            [20.307170374126379, 0.434986920800573],
            [20.311794359524917, 0.438693034417681],
            [20.316576015425472, 0.440722747934408],
            [20.320657199203492, 0.442455124953979],
            [20.32812995616699, 0.453288683666573],
            [20.333261519345459, 0.460728110011201],
            [20.338270199281247, 0.485822116954836],
            [20.339475043994838, 0.487972287944385],
            [20.34163619922726, 0.491829093683226],
            [20.343883805627684, 0.493027086986738],
            [20.348221319180443, 0.495339017692064],
            [20.352289319283322, 0.499514158470711],
            [20.354160340238568, 0.503171246963558],
            [20.358787318823602, 0.512215103737225],
            [20.363605199288006, 0.534048083330552],
            [20.363712565930765, 0.534531300112008],
            [20.363819398974243, 0.535012112242768],
            [20.362721746630267, 0.538383073751068],
            [20.360761198675494, 0.5444040417759],
            [20.357027279331831, 0.55243633554701],
            [20.356279199194155, 0.55974231094899],
            [20.356458838894788, 0.567267070320026],
            [20.358471598730493, 0.574264662534761],
            [20.371278958787919, 0.592748125030584],
            [20.400266351534732, 0.627705274297062],
            [20.412180718826114, 0.643832964200098],
            [20.419069319326649, 0.654052105477411],
            [20.427061318694061, 0.664109387110168],
            [20.42861687916929, 0.667430871868649],
            [20.430052559469864, 0.673448105366896],
            [20.428741079342156, 0.680352380340551],
            [20.42687087944709, 0.687048309133378],
            [20.425541398877744, 0.695041996984346],
            [20.421041398954731, 0.700969086326523],
            [20.420143199553269, 0.70905898754],
            [20.409877439335943, 0.732404080996993],
            [20.405647439749664, 0.769138242677611],
            [20.405958478721864, 0.832811022280136],
            [20.402078078291328, 0.849554644245195],
            [20.400005159179376, 0.858499094853432],
            [20.403974159548032, 0.873478046763857],
            [20.405155319280819, 0.893258143137037],
            [20.414123278915639, 0.91081415022595],
            [20.419344109480509, 0.91688623562209],
            [20.420898478789653, 0.918694042243473],
            [20.427866279257255, 0.930484112342915],
            [20.432333538283093, 0.933614483132104],
            [20.43285515942588, 0.933980001779806],
            [20.43365312211295, 0.939780463886954],
            [20.433710158845294, 0.940195067977843],
            [20.437326394395171, 0.944137242289378],
            [20.440159919753132, 0.957960061194881],
            [20.434555396272543, 0.963666542887475],
            [20.432557320298464, 0.965700965291448],
            [20.431175405065972, 1.015115103795084],
            [20.432361239631518, 1.034668129100734],
            [20.433468159894282, 1.037162212041841],
            [20.434820400179657, 1.040209041774447],
            [20.437813440280976, 1.061849107035225],
            [20.44277028023836, 1.069023143554706],
            [20.44775623908566, 1.073209021528782],
            [20.458448280448064, 1.077449024980253],
            [20.47019724004786, 1.090895101877846],
            [20.473911330878256, 1.097261928207472],
            [20.475591479598524, 1.100142094056734],
            [20.479439159793152, 1.104087036076826],
            [20.488073399791485, 1.108767007999278],
            [20.496176640235468, 1.12355542329041],
            [20.500871759628062, 1.134675652557094],
            [20.504884656173125, 1.142724604661065],
            [20.540401559563765, 1.205570648591207],
            [20.55340127317805, 1.230843588694031],
            [20.555866325776147, 1.235635906610373],
            [20.559369540686873, 1.228540850027312],
            [20.56529015975639, 1.229280047666976],
            [20.566640536037557, 1.228249257892462],
            [20.567360160241979, 1.227699944230095],
            [20.573979840180758, 1.228680008201095],
            [20.574960120446374, 1.221329967568856],
            [20.575813546915736, 1.220993062591505],
            [20.57610023256056, 1.220880316376816],
            [20.579500978443438, 1.223669057964125],
            [20.582960040259628, 1.22024989427],
            [20.586596035152496, 1.223046854437055],
            [20.58780996003695, 1.215010069877781],
            [20.59407694971711, 1.213861575034122],
            [20.598559920277278, 1.21304002092927],
            [20.59937892779655, 1.211867829799431],
            [20.601110160113763, 1.209390028270621],
            [20.606319215561914, 1.210016867027082],
            [20.60726379677811, 1.210128639011435],
            [20.613690000265933, 1.207659992361183],
            [20.615730120090269, 1.209059913874777],
            [20.619282594119564, 1.20878304845912],
            [20.620990080370603, 1.208649974277818],
            [20.623780079658104, 1.203389946129682],
            [20.627209003894837, 1.202960149245201],
            [20.628143346113418, 1.204160199848933],
            [20.631719879720976, 1.208760072708837],
            [20.632789775021003, 1.209299568337034],
            [20.634000120119058, 1.209909885305001],
            [20.636920079577042, 1.209699960754027],
            [20.639480040083253, 1.209510037226876],
            [20.641809960011479, 1.204699954089238],
            [20.647547317373132, 1.201761549296061],
            [20.65308984003115, 1.194690001388399],
            [20.657330446025991, 1.192402993088121],
            [20.660209920210754, 1.190850059032702],
            [20.662658013514616, 1.19172670653831],
            [20.666130119767026, 1.192970046594099],
            [20.66686954463697, 1.192700033142376],
            [20.669799959586538, 1.191629941226196],
            [20.679472962870392, 1.184405570621754],
            [20.680149960217943, 1.183899948521671],
            [20.69089025728076, 1.182391514895027],
            [20.691882041371873, 1.180448236505467],
            [20.692289880104138, 1.179650046996365],
            [20.706680159727096, 1.179550037979771],
            [20.709053457503767, 1.176618400000718],
            [20.710379880207896, 1.174979922769632],
            [20.713120547613254, 1.174090584298128],
            [20.717430119967393, 1.178040001569605],
            [20.728389959895747, 1.177910080550393],
            [20.734049879784973, 1.183249984890665],
            [20.743489887033594, 1.184013828309813],
            [20.743641228904458, 1.184026074439718],
            [20.752800120062993, 1.182039974603758],
            [20.760628034058914, 1.17498180436152],
            [20.763600120057905, 1.174549975830385],
            [20.76480929465114, 1.173654373984732],
            [20.77003920987849, 1.169780718784798],
            [20.772541694376176, 1.170261700099325],
            [20.773649842635944, 1.171336444214351],
            [20.776849920155701, 1.174440056849084],
            [20.778033654460103, 1.174395572246953],
            [20.781640387630887, 1.17425768796893],
            [20.781762635764657, 1.173319995670427],
            [20.782149840194826, 1.170349974122906],
            [20.782259321471745, 1.1703407813422],
            [20.784650040276727, 1.170140045616556],
            [20.787810120308492, 1.174769994615178],
            [20.789146043595053, 1.175732223059141],
            [20.792346938581741, 1.178036987951755],
            [20.796459840075777, 1.17807009434733],
            [20.800319271132633, 1.176269530811646],
            [20.800815388206161, 1.176038074314803],
            [20.802843341248273, 1.179046003620244],
            [20.805361200412047, 1.17860905809297],
            [20.805611430625998, 1.177519174577633],
            [20.805835320439222, 1.176544019750088],
            [20.803795221276154, 1.174916114109856],
            [20.807249399850456, 1.171728111477161],
            [20.81202951244536, 1.174069774662907],
            [20.816140403509795, 1.17318949304262],
            [20.817199731028833, 1.171883961894217],
            [20.817989999645526, 1.170910023002447],
            [20.821146552891456, 1.171487284603633],
            [20.823239879930036, 1.171870106273762],
            [20.826839880227773, 1.17765005856261],
            [20.830388311838334, 1.179480605455664],
            [20.830929839647801, 1.179759965769517],
            [20.831005785018551, 1.179745351585664],
            [20.834361678917617, 1.179100493752445],
            [20.834833397748014, 1.179256904341196],
            [20.840060159888715, 1.180989978313514],
            [20.840249258849287, 1.180909086314144],
            [20.843729999708231, 1.179420117031995],
            [20.846309364722874, 1.181674513595722],
            [20.851430040320089, 1.186150042054422],
            [20.855155237920666, 1.184463483848806],
            [20.862540000410522, 1.181120079117765],
            [20.868334695440147, 1.180194791727329],
            [20.868739920074923, 1.180130086246817],
            [20.869149819542432, 1.179834023142615],
            [20.870898777416841, 1.178570781627837],
            [20.875645484361282, 1.178943249504957],
            [20.876619959713523, 1.17901990369196],
            [20.877502760194371, 1.179796880530226],
            [20.879790119741049, 1.181810045743892],
            [20.881624319651131, 1.181365143919596],
            [20.886902280373111, 1.178653026342786],
            [20.887161480265206, 1.174977039349888],
            [20.891031480001349, 1.176621143271432],
            [20.892872160357861, 1.175028034919487],
            [20.896042320385419, 1.178045046870366],
            [20.89938874783801, 1.177686728320039],
            [20.907930177494457, 1.176771973425829],
            [20.90663978262312, 1.173224754151108],
            [20.90599239105234, 1.171445110128543],
            [20.909412359984007, 1.170997057377157],
            [20.909467241657978, 1.170974069553642],
            [20.910049920392289, 1.170730007464993],
            [20.914819919753739, 1.17291992611229],
            [20.917034900241347, 1.176233453270866],
            [20.917299959844048, 1.176629972552358],
            [20.920176144398237, 1.178219125112661],
            [20.920250160187752, 1.178260020075501],
            [20.921077378308695, 1.178381974386463],
            [20.925269999894311, 1.179000082357759],
            [20.928489840350348, 1.176729980770976],
            [20.935810080446618, 1.175639978968393],
            [20.937313175715964, 1.174043476672654],
            [20.939029920004323, 1.172220045661471],
            [20.941107239064532, 1.172238737726527],
            [20.946800160362361, 1.172289962103666],
            [20.94699996005459, 1.175050018168891],
            [20.94904007987892, 1.177370035273278],
            [20.952729269409648, 1.173490917728468],
            [20.956788725635867, 1.17950790702851],
            [20.961570276433527, 1.179657602284651],
            [20.966829839658516, 1.179819970451964],
            [20.969804589162301, 1.181185649870137],
            [20.975019840290969, 1.183579921598651],
            [20.984159880303277, 1.183890036968061],
            [20.989889178878503, 1.181640264366954],
            [20.995461232753168, 1.186458119126293],
            [20.997140343919323, 1.187909955639132],
            [20.999888593105691, 1.187470751095136],
            [21.002360039911995, 1.192320085125552],
            [21.005560079702509, 1.190970068813357],
            [21.010410000378162, 1.185040041870166],
            [21.014340119864716, 1.180240005904939],
            [21.014877187538797, 1.175322190728251],
            [21.016547639843896, 1.160026173808286],
            [21.016903679920262, 1.144035308708982],
            [21.01971203987387, 1.114810900876154],
            [21.021393239623041, 1.100206425211735],
            [21.018761999595679, 1.090493253982277],
            [21.016596599823536, 1.084841788737451],
            [21.014478448740363, 1.079549314565084],
            [21.017612880074132, 1.073303121623397],
            [21.022687439757917, 1.061685302680546],
            [21.014958960280783, 1.047202205089866],
            [21.008005920031653, 1.034283212549155],
            [21.003320797989822, 1.021600898843713],
            [21.00188879988362, 1.017724565913164],
            [20.999081879929427, 1.008391907811626],
            [20.997969479943404, 1.000456181025021],
            [20.99783124000097, 0.994668676754468],
            [20.997831600225407, 0.986956913161206],
            [20.998058040355691, 0.980986654445481],
            [20.9993972397981, 0.97524038336677],
            [21.001839839904012, 0.969332275338884],
            [21.004841159777282, 0.963632657403072],
            [21.010982399690683, 0.958020971798101],
            [21.02096052025237, 0.950781811143286],
            [21.041984967842996, 0.940090840955023],
            [21.045394800184983, 0.938356932313799],
            [21.090168360183171, 0.919754400143066],
            [21.1137397202505, 0.909811456635884],
            [21.118772159727246, 0.911880637707649],
            [21.13016256037465, 0.917405536731884],
            [21.145219559720001, 0.906452683385541],
            [21.160105919585572, 0.896073410385522],
            [21.174493320108031, 0.887993613764243],
            [21.187887839696426, 0.884706184433207],
            [21.204414295997044, 0.880265049624923],
            [21.211343280261168, 0.877651951416912],
            [21.233035440212614, 0.858594608011878],
            [21.242427119895584, 0.85770111023939],
            [21.261025079563236, 0.855909066440875],
            [21.279595319916222, 0.852959329343988],
            [21.291720120257839, 0.850600151472191],
            [21.299223240277968, 0.847918568561639],
            [21.319193005537912, 0.833888094067593],
            [21.341900879801315, 0.818845442869518],
            [21.356260560110741, 0.817320100067007],
            [21.375453959979666, 0.817279912222487],
            [21.389462639761511, 0.816515978675541],
            [21.398175360176303, 0.810397841392554],
            [21.40574796039207, 0.802897978521355],
            [21.412849340342394, 0.800194019158165],
            [21.449518919684792, 0.804125429234443],
            [21.459838320104403, 0.803450701238752],
            [21.477328560008711, 0.793915461026234],
            [21.50416927567052, 0.772216218945821],
            [21.511270440025175, 0.762283393342885],
            [21.523049280286259, 0.753166165614883],
            [21.531212639582321, 0.747225449934889],
            [21.537284400198384, 0.746431587692094],
            [21.547091159933093, 0.747477935359876],
            [21.55468175969223, 0.748461928274374],
            [21.558745079572468, 0.748575826472725],
            [21.563916120114417, 0.748720901916857],
            [21.569807879907113, 0.748114827807676],
            [21.576414960075738, 0.746564949013632],
            [21.580796880047913, 0.744566866355698],
            [21.584770116871454, 0.742304090024792],
            [21.593697479841946, 0.736059642481569],
            [21.600591119891231, 0.731047212060123],
            [21.605864040166196, 0.727724511312612],
            [21.614142600312604, 0.726606971874048],
            [21.624291360354068, 0.726506048846469],
            [21.630921479614788, 0.725920696326653],
            [21.633867359960281, 0.725617568184978],
            [21.648627720327472, 0.756994719225751],
            [21.658112999971447, 0.793666222048307],
            [21.664160639923811, 0.819607933647258],
            [21.665967479845264, 0.845034422817105],
            [21.664363679839301, 0.865872881693252],
            [21.658078800210248, 0.882500747339815],
            [21.659790239946847, 0.886227714975563],
            [21.709441800159823, 0.900154479960999],
            [21.727354923780752, 0.902610925925951],
            [21.72767831997799, 0.902655273340772],
            [21.742494840321786, 0.898521043534465],
            [21.76364484004981, 0.888813398072432],
            [21.786008760170699, 0.866035794040647],
            [21.79572264039324, 0.858090010951148],
            [21.863569319767887, 0.86510102919084],
            [21.89584722882401, 0.900604951522579],
            [21.909992759752878, 0.91620046882416],
            [21.950808840275876, 0.94505368910222],
            [21.96707507979152, 0.95109609535392],
            [21.977115479653509, 0.951439753873373],
            [21.98686499963663, 0.951682495217658],
            [22.010594040087476, 0.950226407685593],
            [22.03770383980445, 0.946398409381405],
            [22.066074000119539, 0.940145510770587],
            [22.090210919726822, 0.935015126537822],
            [22.105862999947306, 0.928036321306199],
            [22.104634320234293, 0.93783054050434],
            [22.102175159686123, 0.957009461935731],
            [22.096330559649214, 0.977332231275751],
            [22.090467599844526, 0.993560767070486],
            [22.085887320179506, 1.012277320565355],
            [22.080444840199739, 1.027697462786904],
            [22.077928439899985, 1.033775217101612],
            [22.068056268439562, 1.046743985254451],
            [22.066156440309801, 1.055587240178038],
            [22.059844560018284, 1.066073413016809],
            [22.053971159993331, 1.079844984749972],
            [22.05277619764621, 1.081663564527141],
            [22.044708359807572, 1.09394175568667],
            [22.017286080220721, 1.123141326251449],
            [21.994702994526676, 1.128734408023946],
            [21.937689000348566, 1.142854834741607],
            [21.935576687416429, 1.205635809165406],
            [21.934689119576383, 1.23201517920912],
            [21.913271279959883, 1.277326337045068],
            [21.908619551890418, 1.28925130468757],
            [21.907214649668131, 1.292909936787317],
            [21.905359919660583, 1.297739998327159],
            [21.904210079690163, 1.299569977445046],
            [21.898152719966404, 1.309286181078986],
            [21.890986199581587, 1.318112769860853],
            [21.883381199828474, 1.323653831392985],
            [21.865830276930073, 1.328933890830516],
            [21.863073599749708, 1.332153154151023],
            [21.861412199767692, 1.339888645873212],
            [21.86103672014864, 1.350930658016173],
            [21.862078199939578, 1.395161614534807],
            [21.866428439924949, 1.420646466138301],
            [21.866901119952704, 1.431709177259032],
            [21.866960159928141, 1.445217181117264],
            [21.86837532001265, 1.477995612646606],
            [21.869562599967495, 1.555378787490147],
            [21.872620182225305, 1.604273247866799],
            [21.872732559670734, 1.607797138207625],
            [21.873930050775385, 1.645347354701041],
            [21.875712120551174, 1.701227080108491],
            [21.89059019974647, 1.703777150667017],
            [21.893745240229446, 1.709552133231914],
            [21.898073519999375, 1.71165613422487],
            [21.919990319857288, 1.714585050925485],
            [21.921804359775741, 1.716438996110421],
            [21.948282359980322, 1.722267445122777],
            [21.996258120217309, 1.740649287560249],
            [22.02936840013086, 1.752113437184011],
            [22.051863720421647, 1.759221004873135],
            [22.072641840079921, 1.761375031561519],
            [22.095954359581253, 1.761545992150975],
            [22.127389918395465, 1.76261713745324],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Buta",
        AREA: 148331,
        POPULATION: 1138000,
        DISTRICTS: ["Buta", "Aketi", "Bondo", "Ango", "Bambesa", "Poko"],
        OBJECTID: 2,
        NOM: "Bas-Uele",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [25.555046573855638, 5.376462920898376],
            [25.560329567838188, 5.375328022395617],
            [25.560330883870066, 5.375328162848581],
            [25.560331200077048, 5.375328095323102],
            [25.571042221943056, 5.376473920325449],
            [25.57364088187169, 5.376751914863894],
            [25.581451820403693, 5.375165995472892],
            [25.587896532779649, 5.36989393383114],
            [25.586553733787898, 5.358844024966293],
            [25.58771581240574, 5.354706043240856],
            [25.597156799716323, 5.3455310014836],
            [25.601059554722699, 5.345312982452958],
            [25.601059797267812, 5.34531313821944],
            [25.601061239962153, 5.345313057184848],
            [25.60358022471496, 5.346931949704811],
            [25.611616541568608, 5.346267062286528],
            [25.611617153321333, 5.346267227956978],
            [25.611618240282819, 5.346267137918693],
            [25.618497381523422, 5.348129853581749],
            [25.622631448223871, 5.347452078525401],
            [25.626781522004364, 5.341481929382863],
            [25.62449876542518, 5.337792972297],
            [25.612344820142503, 5.334072950497857],
            [25.607994585547015, 5.330378027192666],
            [25.601820593058342, 5.322762906837873],
            [25.603435550140151, 5.3202379110207],
            [25.603437223701544, 5.320238010967519],
            [25.603437239871191, 5.32023798575572],
            [25.623861586800903, 5.321452920751322],
            [25.627317559310839, 5.317551938338576],
            [25.627491800136582, 5.315010053114133],
            [25.627521679899573, 5.314556944273277],
            [25.628038638786027, 5.306968004886486],
            [25.630575554810228, 5.303523970196476],
            [25.634483709589787, 5.301694989765291],
            [25.634485011248614, 5.301695267103604],
            [25.634485439744996, 5.301695066303444],
            [25.634899440021787, 5.301782998752004],
            [25.639990199923428, 5.302863123234126],
            [25.641652651832612, 5.306410807059812],
            [25.642042173916231, 5.307242047827946],
            [25.639616661563668, 5.310462805590872],
            [25.637201280410874, 5.313670093857325],
            [25.637191200415078, 5.316892004339676],
            [25.639476588159727, 5.320891734731157],
            [25.640615519887657, 5.322885005292362],
            [25.644964319873612, 5.327041149023583],
            [25.658731539693605, 5.32800393220754],
            [25.661722715790681, 5.32594196793825],
            [25.662883713735248, 5.321574069526546],
            [25.660867715472943, 5.306148988151698],
            [25.663692734683487, 5.306315929267861],
            [25.663870912825143, 5.30632643202622],
            [25.664999396247996, 5.306393118774685],
            [25.669803239637762, 5.311240078659181],
            [25.673489287759935, 5.311990283693093],
            [25.674390927708913, 5.312173790284462],
            [25.679691370567546, 5.305287081279193],
            [25.686349561282562, 5.304847064862547],
            [25.691410434234673, 5.301410914220919],
            [25.704271417426373, 5.299378966386691],
            [25.708870410795395, 5.297090932084509],
            [25.712556445442814, 5.292039998384942],
            [25.713974482831194, 5.27961796322427],
            [25.719036435558316, 5.274800003687905],
            [25.718132477057562, 5.270195029303224],
            [25.720209673946929, 5.266979960193827],
            [25.728481382642673, 5.263552928652595],
            [25.728482546859279, 5.263553296959238],
            [25.728483240358671, 5.263553009698065],
            [25.735821283267214, 5.265875694694174],
            [25.739954565738429, 5.26496799807545],
            [25.740198646085982, 5.26059607383255],
            [25.745964397397124, 5.251407950971316],
            [25.749221311324941, 5.236690012769554],
            [25.749222649814715, 5.236693394314363],
            [25.749223315466331, 5.236690386495517],
            [25.7496793200675, 5.237842122473641],
            [25.760443778218185, 5.239837316115212],
            [25.764818277207809, 5.240648128444497],
            [25.766778651787707, 5.241107956881344],
            [25.770782520264138, 5.242047121954051],
            [25.773525882615356, 5.245367563950148],
            [25.775356320381029, 5.247583032289744],
            [25.780737875719879, 5.250223599033107],
            [25.783378200409725, 5.251519123232696],
            [25.785888479589129, 5.256359158928841],
            [25.784961480199655, 5.259118082784357],
            [25.783735648146109, 5.259932184489831],
            [25.782201359776817, 5.26095113745464],
            [25.782199657469352, 5.260950899720251],
            [25.782199426602332, 5.26095105280676],
            [25.773991276407891, 5.259803442084048],
            [25.772108262045297, 5.259540280369385],
            [25.770029399679412, 5.26367612135999],
            [25.779785557314153, 5.269049279186682],
            [25.787673923437112, 5.273393725035782],
            [25.792493252884075, 5.272716997724894],
            [25.798952362559074, 5.262610019690655],
            [25.800815358863879, 5.253180902689123],
            [25.798992321419561, 5.248573074483003],
            [25.790525493254201, 5.240263999006235],
            [25.790073334340775, 5.237730048101422],
            [25.791456451519117, 5.236123956316427],
            [25.791458247251381, 5.236124219275681],
            [25.791458380202052, 5.236124064381866],
            [25.792868870843716, 5.236330425222703],
            [25.796276266056342, 5.236829004602082],
            [25.799917320260864, 5.238760118088207],
            [25.806503880213459, 5.242254768579855],
            [25.809797159740576, 5.244002086845709],
            [25.817362406347435, 5.246324868219329],
            [25.820118170839482, 5.245872967449436],
            [25.820816209425949, 5.24288390372182],
            [25.817844413582787, 5.23827204959779],
            [25.816951254628407, 5.229755005342801],
            [25.808490546685107, 5.219375057479916],
            [25.808961425590716, 5.21523397697794],
            [25.811491500944054, 5.213629980934785],
            [25.81149264180447, 5.213630598731426],
            [25.811493238285809, 5.213630220488565],
            [25.815424315376468, 5.215756595311054],
            [25.817909252183387, 5.217100909251504],
            [25.820661408142925, 5.217108980187574],
            [25.821840405630834, 5.206295912829423],
            [25.824844241685206, 5.199631048060419],
            [25.83128139114476, 5.195507066138683],
            [25.832664508323102, 5.193439052465443],
            [25.831989149502618, 5.189525926092259],
            [25.835897304282181, 5.186774947787891],
            [25.835897872017412, 5.186776053745644],
            [25.835899320101667, 5.18677503424711],
            [25.839096479893389, 5.192998146432373],
            [25.841229408262983, 5.194264819771186],
            [25.842991220130788, 5.195311097284265],
            [25.845724439604147, 5.202453129971636],
            [25.845018506622957, 5.208433921355592],
            [25.847072279941273, 5.211891995964621],
            [25.854520860545563, 5.215825083139495],
            [25.861969283944656, 5.219758062488857],
            [25.867475378121242, 5.219774927448642],
            [25.877037323584833, 5.219125940013134],
            [25.883773274267501, 5.218669888417849],
            [25.887231067662487, 5.213615976944482],
            [25.89229842016276, 5.20637972612],
            [25.89479825642697, 5.205451093320766],
            [25.903878521641953, 5.205384504591615],
            [25.911142230757413, 5.205558779562043],
            [25.937748348687798, 5.205471910458738],
            [25.9377487412516, 5.20547200952364],
            [25.937750163284701, 5.205472005020686],
            [25.942335990944898, 5.206634709738823],
            [25.950143128704916, 5.204584915140392],
            [25.959131233958274, 5.192183012740082],
            [25.9639512658878, 5.191735916825825],
            [25.963951496754824, 5.191736195114271],
            [25.963953480234981, 5.191736011389861],
            [25.96624020018119, 5.194504018039438],
            [25.962202440065699, 5.200013072804342],
            [25.961970520212191, 5.200328016315858],
            [25.961862239982786, 5.200475059546118],
            [25.961166360047947, 5.203925056963829],
            [25.966621439797866, 5.223041123048697],
            [25.970453279999074, 5.227493000578966],
            [25.975343760508139, 5.233174351545105],
            [25.97714424035734, 5.235265985419727],
            [25.98516449533372, 5.239658898410354],
            [25.989339147020367, 5.223791951096796],
            [25.992562941860292, 5.220118975410209],
            [25.992564362995068, 5.220120026373895],
            [25.992565200224899, 5.220119072671622],
            [25.994077945197066, 5.221238044490238],
            [25.99442136035039, 5.22149206649376],
            [25.996000320142148, 5.222660095911436],
            [25.998203159898715, 5.225790134066346],
            [26.001030239844535, 5.229807138450709],
            [26.006536090577679, 5.230281839508741],
            [26.009293914906671, 5.228447883971916],
            [26.01130091115153, 5.223065972323186],
            [26.011607990349926, 5.222240921481608],
            [26.01144022997061, 5.221706981298402],
            [26.008649154501388, 5.212797906509467],
            [26.010957110620918, 5.208200903769868],
            [26.016471221363137, 5.205684948586937],
            [26.023356929288454, 5.205471904154611],
            [26.023357415277051, 5.205472059956691],
            [26.02335923975539, 5.205472003219501],
            [26.025677106089127, 5.206213299111939],
            [26.027713774586115, 5.206864662311314],
            [26.038283944208832, 5.202289881009894],
            [26.038285651906214, 5.202290252955446],
            [26.038286279828586, 5.202289980975859],
            [26.041498199838749, 5.202989061742283],
            [26.046526320215616, 5.210826069568619],
            [26.050192066412354, 5.213367935153786],
            [26.053631799178568, 5.213376901313522],
            [26.053892077049017, 5.202100885799291],
            [26.05894790865575, 5.197813053217523],
            [26.063092941090897, 5.194300022666694],
            [26.067912973020391, 5.194083026071803],
            [26.06791308980138, 5.194083229608868],
            [26.067915359844111, 5.194083127840329],
            [26.070429240369478, 5.198461984600868],
            [26.070896160399645, 5.204762155981546],
            [26.070954903931039, 5.205556049874143],
            [26.071094318869839, 5.20743819248903],
            [26.076816359955917, 5.213206138095396],
            [26.076829193288084, 5.213207186369108],
            [26.077597433417388, 5.213269963910028],
            [26.086454022618192, 5.213461970854535],
            [26.092667971272363, 5.206573013132808],
            [26.098177761118077, 5.205896908636536],
            [26.098178109664385, 5.205897494019596],
            [26.098180324909894, 5.205897222041651],
            [26.099214479838004, 5.207633126345485],
            [26.099326851893519, 5.207822460293393],
            [26.099552001144769, 5.208202524824724],
            [26.097480360335449, 5.214017021382487],
            [26.101351439846571, 5.222245147836026],
            [26.100883440041457, 5.225235029255143],
            [26.097200280002919, 5.227786081697793],
            [26.092607399669411, 5.230967075098735],
            [26.090534171536984, 5.233493233405655],
            [26.090758560813494, 5.234978488540713],
            [26.090986319670616, 5.236486035791217],
            [26.092819439805687, 5.237872094340901],
            [26.103143117104345, 5.238818782963228],
            [26.103834074271429, 5.238543031706282],
            [26.107735746807897, 5.236988988987668],
            [26.112114058247567, 5.231246051016996],
            [26.116705850721257, 5.229877923839182],
            [26.116706842461351, 5.229878524509044],
            [26.116708379478784, 5.229878066126791],
            [26.117270899119827, 5.230218232482519],
            [26.12014632010602, 5.231957049414531],
            [26.122650479961692, 5.240249007727651],
            [26.122952463915816, 5.240424734450903],
            [26.128608479726829, 5.243716012381356],
            [26.129633939861296, 5.246940086022597],
            [26.130659399995796, 5.250164142782279],
            [26.132502381836069, 5.250433223155196],
            [26.133871181665409, 5.250633072016054],
            [26.135006399757938, 5.255008137912652],
            [26.134300441623925, 5.262140073016317],
            [26.134440177261325, 5.262265312860023],
            [26.136359808751504, 5.263985560937289],
            [26.14095072896108, 5.263076962817911],
            [26.14670279803213, 5.257798006782875],
            [26.146705469621796, 5.25779814366096],
            [26.146705490283065, 5.257798124750183],
            [26.147387074428465, 5.257832897184649],
            [26.160931792332352, 5.258523923943568],
            [26.163462927697697, 5.255999040756401],
            [26.15777385657919, 5.237574960161781],
            [26.160080732025445, 5.232057984114898],
            [26.164219644238536, 5.228845946061874],
            [26.164222347269234, 5.228846082045853],
            [26.164222369727128, 5.22884606493527],
            [26.164466525533136, 5.228858319701195],
            [26.169042239959879, 5.229087986649316],
            [26.169178735374015, 5.22921359793924],
            [26.174308320462242, 5.233934121435157],
            [26.176918319824704, 5.234778000617593],
            [26.180042399871418, 5.235789146059323],
            [26.181696653755356, 5.237872855299587],
            [26.184618275994936, 5.241552934212136],
            [26.186911843798555, 5.241557953807908],
            [26.18785072161101, 5.233507045128946],
            [26.191536753563504, 5.227072021103647],
            [26.184439726849046, 5.219920999757119],
            [26.186741922072656, 5.217855041500486],
            [26.1906446752824, 5.21763500200247],
            [26.190645029218622, 5.217635240654157],
            [26.19064728039675, 5.21763511367345],
            [26.196832439842709, 5.221792150558431],
            [26.199004685675629, 5.229707655076766],
            [26.200245240218376, 5.234228097344113],
            [26.202991121445656, 5.237224882873096],
            [26.208039843785258, 5.237008004877043],
            [26.211264717501802, 5.231952987927446],
            [26.210589718007427, 5.226656894976347],
            [26.211749635278714, 5.221827932757128],
            [26.218422581720588, 5.214249871076031],
            [26.209715638371364, 5.208476031840544],
            [26.215924546578492, 5.204117886339729],
            [26.218005702343302, 5.197448869840835],
            [26.221226615387774, 5.19400493898044],
            [26.221227065443749, 5.194007792102195],
            [26.22122933009657, 5.194005371271611],
            [26.223264493915448, 5.20689687093864],
            [26.229689840410504, 5.206683023597676],
            [26.229690588707157, 5.20668320191415],
            [26.229692520085013, 5.206683137972369],
            [26.234120263119831, 5.207738768776879],
            [26.237487019447304, 5.20854144587438],
            [26.239560661703088, 5.205554987178091],
            [26.232234675083955, 5.198173979809178],
            [26.236607585852141, 5.192660960481197],
            [26.23823262203145, 5.185300978131972],
            [26.243287732291016, 5.183472006977421],
            [26.243287940700174, 5.183473026481337],
            [26.243290272726643, 5.183472182598669],
            [26.244476615738613, 5.189275869015415],
            [26.24578451967318, 5.195675149524356],
            [26.249449938883171, 5.198444764225078],
            [26.253808712863734, 5.19799503315136],
            [26.254050631864704, 5.192702957658023],
            [26.254284632216425, 5.191091903865191],
            [26.260493539525253, 5.185813949003796],
            [26.253865590594256, 5.174982030217459],
            [26.254561468732472, 5.171531873366799],
            [26.257088664985311, 5.169926866721477],
            [26.257091400355339, 5.169926982003545],
            [26.282561494404437, 5.170906895280614],
            [26.285550568443735, 5.169302953390537],
            [26.287394484531891, 5.165394880452956],
            [26.282130574359247, 5.159860032260535],
            [26.283057572850389, 5.155949926106238],
            [26.283060080048354, 5.155951224860145],
            [26.283060360322715, 5.155950043192239],
            [26.291540520385198, 5.160342090124288],
            [26.292819432990569, 5.160505084375075],
            [26.29520942326187, 5.160809682204886],
            [26.29728942379321, 5.154371982272258],
            [26.30119865565279, 5.151388042762306],
            [26.30168069432921, 5.141723888332909],
            [26.303288450515687, 5.140807903154412],
            [26.306502523787593, 5.140355026849749],
            [26.306503327779758, 5.140355432157488],
            [26.306505359768927, 5.140355145740015],
            [26.309701300546823, 5.141966004197262],
            [26.309715300790518, 5.141973061037389],
            [26.311546409597689, 5.144278235093542],
            [26.311197444652528, 5.14588843860761],
            [26.310848424011816, 5.147498891982301],
            [26.312673259883354, 5.152565122044028],
            [26.314504525895682, 5.152963854124649],
            [26.315881011710584, 5.153263563206414],
            [26.317952662401375, 5.151658004445348],
            [26.318890459540558, 5.142684027140971],
            [26.324414647583616, 5.136022970118788],
            [26.324417423377845, 5.136023208801644],
            [26.324417508717804, 5.136023105222314],
            [26.327169346673738, 5.136259222886824],
            [26.325771491734848, 5.145231064607239],
            [26.328289274541806, 5.14845907510063],
            [26.331017379906257, 5.149087188312679],
            [26.333334268872953, 5.149620582780321],
            [26.342059292613893, 5.146878897662407],
            [26.342060124453869, 5.146879671341849],
            [26.342062200460461, 5.146879019253485],
            [26.348632906046618, 5.15300136235064],
            [26.351222317819367, 5.155414064704358],
            [26.353747388658242, 5.154039013091088],
            [26.361113332341237, 5.144619914505109],
            [26.366395242057219, 5.142791003662692],
            [26.366397818425462, 5.142791260356597],
            [26.366398200209431, 5.142791127956594],
            [26.373510359943193, 5.143497993241932],
            [26.379926280415972, 5.148114140945742],
            [26.385984359690244, 5.148620143201852],
            [26.388413714137286, 5.148822920470841],
            [26.390940350739701, 5.147447900341933],
            [26.393719183069916, 5.136637933992002],
            [26.390746310146767, 5.132259003791005],
            [26.393275303928466, 5.129961915390924],
            [26.397179495340964, 5.129050939895888],
            [26.399491410335965, 5.12123193483397],
            [26.399494012755358, 5.121233506575076],
            [26.399494440353411, 5.121232060933536],
            [26.400518897069755, 5.121850915001994],
            [26.401787279623353, 5.12261711911123],
            [26.402715595943032, 5.126924379846838],
            [26.403375239635924, 5.129985018313777],
            [26.405435177193723, 5.132751103977509],
            [26.414153459078445, 5.132999984809077],
            [26.414847177666736, 5.130470982921036],
            [26.411879344292306, 5.1235599286186],
            [26.413031341117723, 5.121261014295625],
            [26.418080330256963, 5.120811891611395],
            [26.418081199826151, 5.120812214966901],
            [26.418083399800278, 5.120812019512453],
            [26.422437975953503, 5.122431412650158],
            [26.421767081759999, 5.115065910301037],
            [26.424065316311538, 5.112999964110244],
            [26.43370933545274, 5.110948910973678],
            [26.433710602975609, 5.110949430692497],
            [26.433712440030341, 5.11094903977748],
            [26.43983244017717, 5.113458014906341],
            [26.440051718938026, 5.113547944818531],
            [26.441046369553209, 5.113955794400733],
            [26.442898314783388, 5.105676025145581],
            [26.438790363006561, 5.09554102861282],
            [26.440865397651049, 5.09117294329848],
            [26.444310230153114, 5.090489893047811],
            [26.444310933533973, 5.090490503759702],
            [26.444313297899804, 5.090490035367099],
            [26.450954279588924, 5.096257051567933],
            [26.457146567166685, 5.096959685028897],
            [26.458987038215735, 5.095124019164834],
            [26.456931081991272, 5.090285964786845],
            [26.456940082212093, 5.086373990558335],
            [26.461779190764975, 5.077177920694499],
            [26.460866232941736, 5.075564955146365],
            [26.454899245532172, 5.07486196383566],
            [26.45283824975899, 5.073016875033741],
            [26.455838122446334, 5.065658905981723],
            [26.459971273763504, 5.064056860409401],
            [26.463654064594472, 5.058540872112184],
            [26.463657135934412, 5.058541158566666],
            [26.463657240138978, 5.058541002728239],
            [26.464553256634289, 5.058624391597826],
            [26.466179099500728, 5.058775865615774],
            [26.466182459199871, 5.05877617819336],
            [26.470532003889222, 5.063156883486746],
            [26.478570991434211, 5.058573006356539],
            [26.478572850048508, 5.058573908057467],
            [26.478574200216375, 5.058573137873328],
            [26.484761674620856, 5.061575759824867],
            [26.485913174677911, 5.05881787351495],
            [26.484873136682978, 5.056369002232988],
            [26.483174300309823, 5.05236795496924],
            [26.488005129090727, 5.04639389585282],
            [26.490759122105032, 5.046399998889966],
            [26.490759246970864, 5.046400124103583],
            [26.490759480532844, 5.046400125004405],
            [26.492822280123132, 5.048475987519461],
            [26.493476885165602, 5.050679949486617],
            [26.494236360432691, 5.05323698543183],
            [26.494873200392096, 5.055384090223909],
            [26.499688432623064, 5.055853788506901],
            [26.502905135263774, 5.053789964894274],
            [26.50383609263039, 5.047808019805035],
            [26.509121240772981, 5.043906017411913],
            [26.509122748146009, 5.043907592947471],
            [26.509124594183945, 5.043906230005633],
            [26.515304513756835, 5.050361145093934],
            [26.51898593825025, 5.045307938961212],
            [26.526791079953714, 5.044172971095224],
            [26.526791380889346, 5.044173545818644],
            [26.52679440012702, 5.044173107119101],
            [26.53342232839675, 5.056844093798036],
            [26.531803440287241, 5.063054006535078],
            [26.533859400104962, 5.067201115395044],
            [26.541656952840917, 5.067906691408854],
            [26.54373192190835, 5.062847957121485],
            [26.543744162352432, 5.057324957348442],
            [26.538480973526962, 5.049949932521604],
            [26.540323808941839, 5.046501965994046],
            [26.540326348479134, 5.046503620795134],
            [26.540327159657846, 5.046502102918261],
            [26.544224036088977, 5.049041053709865],
            [26.545219091844388, 5.050796229797413],
            [26.548795440399012, 5.057104999501919],
            [26.551662678631274, 5.05780084000699],
            [26.554531320032041, 5.0584970202567],
            [26.550388554944664, 5.064012855798071],
            [26.551844167963065, 5.065478489400635],
            [26.5542814796869, 5.067932121525273],
            [26.555643359793596, 5.075070155016456],
            [26.556072896433218, 5.075440798456332],
            [26.557247006187652, 5.076453925095088],
            [26.559767006036743, 5.076458944212723],
            [26.56093484285558, 5.066794003243183],
            [26.564382913784247, 5.063578966438515],
            [26.57448089026607, 5.063370003127868],
            [26.574481095980275, 5.063370210310319],
            [26.574484320033854, 5.06337014365163],
            [26.575630152619755, 5.064522979773567],
            [26.5750141041676, 5.066211103612811],
            [26.574707159716471, 5.067052114238667],
            [26.573836274489555, 5.067559238863709],
            [26.571949199741884, 5.068658099531262],
            [26.571710525455732, 5.07303002011244],
            [26.572323525025833, 5.074430688711586],
            [26.575138439986063, 5.080862096730261],
            [26.578345174022115, 5.081327681352032],
            [26.583400950831621, 5.077655964805008],
            [26.583402781598174, 5.077657281735403],
            [26.583404400362312, 5.0776561062264],
            [26.584520521170212, 5.078459156721618],
            [26.585008200368268, 5.078810041565885],
            [26.585231575446823, 5.082032022074152],
            [26.587410761663655, 5.082266416012843],
            [26.58958905405677, 5.082500714383893],
            [26.59235772823774, 5.074681894857597],
            [26.596488718208359, 5.073769940868602],
            [26.596489913865998, 5.073770588528489],
            [26.596492200078412, 5.073770084092414],
            [26.598956907723426, 5.07510566453933],
            [26.599474439735026, 5.075386106018347],
            [26.599827616880578, 5.07626116464546],
            [26.600324399605721, 5.077492027667794],
            [26.601383137829899, 5.080112554090232],
            [26.601986149032374, 5.081605088105029],
            [26.603930417717546, 5.082327709577582],
            [26.619410940380021, 5.088081108390908],
            [26.621017619486476, 5.086933882527005],
            [26.614604955406609, 5.080248005518532],
            [26.62149281839033, 5.078880985428319],
            [26.62196189617379, 5.073817870399633],
            [26.620363859758676, 5.070132887933277],
            [26.621284737129493, 5.06783395826167],
            [26.625186768093737, 5.067380849592552],
            [26.628866678027578, 5.063475017610938],
            [26.628869240921063, 5.063476223773046],
            [26.628870185050449, 5.063475222090974],
            [26.632309320436988, 5.06509300684252],
            [26.633449406500056, 5.069007150371696],
            [26.630456092412587, 5.074637990065279],
            [26.627460548706591, 5.080272973948166],
            [26.630896523819978, 5.082810455418784],
            [26.638240696832046, 5.081443941663487],
            [26.638240988784503, 5.081444701010752],
            [26.638244280211701, 5.081444088488641],
            [26.640317673634161, 5.0868477374342],
            [26.640982635353534, 5.088580739968842],
            [26.645576759853721, 5.084910926291491],
            [26.645579964144336, 5.084911390184386],
            [26.645580360301388, 5.084911074016603],
            [26.648332941164057, 5.085309834423688],
            [26.650394757997418, 5.085608524443265],
            [26.652931899498761, 5.078709901884165],
            [26.655460893280491, 5.076182836836144],
            [26.662115837484063, 5.076425005716819],
            [26.662116028825213, 5.076425030037706],
            [26.662119480152526, 5.076425155245432],
            [26.669691359919454, 5.077360082364391],
            [26.676105480168385, 5.082205056686218],
            [26.681152319639139, 5.084055145107483],
            [26.681916144548811, 5.085499951096333],
            [26.682979320450517, 5.087510987511101],
            [26.681319122414351, 5.090828194915007],
            [26.679987360124176, 5.093489149678385],
            [26.681086874675767, 5.095706698634363],
            [26.681358240451722, 5.096253999837764],
            [26.683340882470905, 5.096438157496132],
            [26.68892464049539, 5.096956806245295],
            [26.689390809533982, 5.093966860849843],
            [26.687789533793968, 5.09097186434287],
            [26.690549646131966, 5.087524837584707],
            [26.690553282512251, 5.087525222208892],
            [26.690553459480345, 5.087525000622128],
            [26.697206519916801, 5.088228147276073],
            [26.705656486704243, 5.091923273659158],
            [26.709360479572535, 5.093543003761123],
            [26.710949227407628, 5.102519435766333],
            [26.717836497503232, 5.099541957663378],
            [26.721521446087493, 5.091723842418921],
            [26.72152484980413, 5.091724824239969],
            [26.721525239672935, 5.091723998249257],
            [26.723131200127181, 5.092187142878339],
            [26.725181399947314, 5.100015123636274],
            [26.726555151290487, 5.100247459045397],
            [26.73253237769763, 5.094734990309139],
            [26.73253443573795, 5.094736773792072],
            [26.73253620002918, 5.094735147039457],
            [26.740783440413217, 5.101883111857491],
            [26.749956631852744, 5.103510455654952],
            [26.753868441877191, 5.097303985111762],
            [26.753871055076349, 5.097306150503476],
            [26.75387222108958, 5.09730430127335],
            [26.756271859267006, 5.099292841163193],
            [26.757767445518919, 5.100532205772237],
            [26.766489288325431, 5.098706865567141],
            [26.766490660951199, 5.098707557338002],
            [26.766493199590197, 5.09870702589945],
            [26.772450340565904, 5.101707465964143],
            [26.77337030973996, 5.10032982461075],
            [26.771316514862047, 5.093652884523034],
            [26.772239552681118, 5.090661837244438],
            [26.770637556492225, 5.088127997368248],
            [26.771331274182188, 5.085597917971587],
            [26.774187506255583, 5.085016828076751],
            [26.781431406620676, 5.083543903615563],
            [26.781432772059929, 5.08354459089913],
            [26.781435231647187, 5.083544090974673],
            [26.786477224706964, 5.086082427721635],
            [26.789009385948365, 5.081484855437234],
            [26.783741519595239, 5.075492938089771],
            [26.793153333218655, 5.072516883527864],
            [26.792245414944126, 5.067222855011465],
            [26.793859290454332, 5.063082926520083],
            [26.797769240067826, 5.058485907083921],
            [26.797773240265801, 5.058486069227962],
            [26.803735502536931, 5.058725929773751],
            [26.806274215191696, 5.050445933990882],
            [26.808111290608988, 5.049067899755388],
            [26.821193293496549, 5.047708889576844],
            [26.821194347220377, 5.04770936700903],
            [26.821197360169844, 5.047709054426075],
            [26.823544938281614, 5.048773581385612],
            [26.825782320057478, 5.04978813760519],
            [26.828738431315749, 5.057532906533148],
            [26.829210239977723, 5.058768997016839],
            [26.831501889878204, 5.059232384514679],
            [26.835176375784371, 5.056707907746919],
            [26.845964104792497, 5.054653979539934],
            [26.850101213188484, 5.051208910146952],
            [26.848276017990841, 5.04499193974687],
            [26.854476279913371, 5.042240870526461],
            [26.856317314206102, 5.039020862026623],
            [26.872159068308935, 5.033752947063634],
            [26.872159996268635, 5.033754628922706],
            [26.872163476342024, 5.033753472250462],
            [26.875595520427744, 5.039973067687483],
            [26.878807440437907, 5.040668019687888],
            [26.880865199581148, 5.044354070205421],
            [26.882929800293578, 5.044933043279507],
            [26.884994384836332, 5.04551201132614],
            [26.884931556665371, 5.046212431587454],
            [26.884292399950816, 5.053336082374472],
            [26.889791400131624, 5.059098061825847],
            [26.891391240363848, 5.063013075363329],
            [26.889493570885712, 5.066486984708521],
            [26.888628239942182, 5.068071069696153],
            [26.891144257559606, 5.07359895323489],
            [26.89481058316974, 5.074524427240097],
            [26.901010109372049, 5.072233950126314],
            [26.901012879776363, 5.072234685163481],
            [26.901014399725852, 5.072234123977011],
            [26.905372199932625, 5.073391120984052],
            [26.910573311578712, 5.078449785989959],
            [26.912245319765884, 5.080075993648417],
            [26.912231279996316, 5.088360898303758],
            [26.912238753081169, 5.088375711269111],
            [26.925110018389613, 5.113732351448861],
            [26.926288317886545, 5.11570831701399],
            [26.927561451629689, 5.117842884411602],
            [26.934900465617062, 5.119465009827592],
            [26.935004686359711, 5.119632530855359],
            [26.936046360186761, 5.121307093778008],
            [26.93324554608154, 5.125916980446624],
            [26.932134460330801, 5.127745719666004],
            [26.935108200128216, 5.134194155860352],
            [26.9479522797212, 5.138585996542844],
            [26.955057240356258, 5.14481012681384],
            [26.966755439752596, 5.148740046956275],
            [26.970192359893662, 5.152197151087908],
            [26.977353479607032, 5.142663144862097],
            [26.98169868004365, 5.131935846780107],
            [26.988311880434267, 5.121874688350636],
            [26.987482439881305, 5.095483533876742],
            [26.980682399793054, 5.092120004380184],
            [26.965017359577942, 5.092690138234923],
            [26.944374960087746, 5.087607746158324],
            [26.936447759795062, 5.081521818441219],
            [26.935584479705341, 5.06650906484748],
            [26.936518319765675, 5.057854867360216],
            [26.941313519565771, 5.048489632154538],
            [26.940873960422532, 5.043714057876358],
            [26.936119439931765, 5.0394253281144],
            [26.931368519888633, 5.033998712837187],
            [26.928898559794124, 5.024914455684096],
            [26.929336395968662, 5.010829126490229],
            [26.933469569743728, 5.009454975602043],
            [26.934850440235532, 5.007155080686122],
            [26.944265159908888, 5.002337007647273],
            [26.945268705642032, 5.000499394739235],
            [26.945541359602128, 5.000000132287215],
            [26.947027439881687, 4.997278136018566],
            [26.95621140032485, 4.994300103454424],
            [26.966076195718504, 4.994774975119852],
            [26.9653276798979, 4.988692309703842],
            [26.95038372005634, 4.975831041444955],
            [26.957453040032487, 4.965083707318716],
            [26.972938439648637, 4.948585671410997],
            [26.982278639577576, 4.937594050916737],
            [26.986869000136725, 4.920720936740091],
            [26.98784352040472, 4.898412638764772],
            [26.9887924800096, 4.884751945006251],
            [26.998842240316879, 4.864197792007104],
            [27.013631759998187, 4.852711101325537],
            [27.027491759617334, 4.848513242430887],
            [27.03907871973373, 4.845242357064838],
            [27.046842479645338, 4.838386984778654],
            [27.046413359824005, 4.817903057421693],
            [27.043791586243117, 4.812953035638818],
            [27.035433472193457, 4.797172314225898],
            [27.030384359985046, 4.79716509774242],
            [27.010671479658651, 4.787010047529933],
            [27.003251916434706, 4.786585933828159],
            [27.002414681199998, 4.78653807611133],
            [27.00113904115722, 4.787147876495349],
            [26.997133320354671, 4.789063016177604],
            [26.990486986503079, 4.788707802765612],
            [26.983829519830191, 4.788351994393769],
            [26.981422006122646, 4.787053721068102],
            [26.977411572758125, 4.784890603728149],
            [26.981956359087928, 4.772003297508324],
            [26.988931440400904, 4.752224109860976],
            [27.006160319964859, 4.735216994485826],
            [27.012894668951368, 4.724693473982359],
            [27.01719647986145, 4.717971107053493],
            [27.020153112142609, 4.712059277867377],
            [27.027549359593355, 4.697270151971464],
            [27.027786239943904, 4.693128089494031],
            [27.025041239963908, 4.68760003205624],
            [27.0154142133546, 4.677910986782503],
            [27.013818240369684, 4.676306139881317],
            [27.003862633385651, 4.669147467650136],
            [27.002592359878367, 4.668234060127334],
            [26.994131280032533, 4.651649159055886],
            [26.981071299344148, 4.641502087847634],
            [26.97672244905252, 4.635971942024664],
            [26.978887079866812, 4.628818047059462],
            [26.981396999720076, 4.624475996266391],
            [26.981348399964908, 4.611349982490907],
            [26.981238518039348, 4.607756331002527],
            [26.981130239606571, 4.604215074620565],
            [26.976324240260137, 4.597532982594857],
            [26.974342639388361, 4.595921378378502],
            [26.970369479819901, 4.592690061351393],
            [26.968315320226033, 4.584862055984056],
            [26.971540452657372, 4.576808272904525],
            [26.972000279590091, 4.575659988631003],
            [26.973925883080273, 4.573913923579707],
            [26.979349319674334, 4.568996130097455],
            [26.98050744031503, 4.562092009621088],
            [26.972723520411861, 4.553104157229111],
            [26.969978520431866, 4.547576071516482],
            [26.969873141760822, 4.542706653295216],
            [26.969764319847304, 4.537678049694604],
            [26.961080031111248, 4.513230362706726],
            [26.959947508862875, 4.510042064586341],
            [26.969583240147287, 4.50660402050148],
            [26.980816319737279, 4.509843091974227],
            [26.982818336620493, 4.509042810507457],
            [26.988846480436287, 4.506633127497388],
            [26.994528861800873, 4.507063544154003],
            [26.995037399879838, 4.50710206406383],
            [27.006038280240251, 4.511261033764423],
            [27.016817354878942, 4.511046152180815],
            [27.030819077208903, 4.501859226311628],
            [27.033796439911843, 4.504856016386577],
            [27.037466279731351, 4.504861046970581],
            [27.039716612518667, 4.506939253038476],
            [27.040212409791963, 4.507397050036396],
            [27.056039450388766, 4.49764340554789],
            [27.07188839999705, 4.487876126955261],
            [27.072578519934272, 4.485805022390002],
            [27.077858153319344, 4.481899162003351],
            [27.090009359638739, 4.482836075357651],
            [27.112035240124968, 4.4741190781465],
            [27.115405769376647, 4.473710039832188],
            [27.132677280289055, 4.471614011908859],
            [27.137497320303389, 4.468628116262018],
            [27.145296359751139, 4.467026996534164],
            [27.151718400445947, 4.459402091235067],
            [27.155172240355377, 4.455300140781305],
            [27.164348280352698, 4.451399052902345],
            [27.168131598053851, 4.451518533601977],
            [27.171915479896981, 4.45163803141246],
            [27.173107084341588, 4.451310786658146],
            [27.181091159669869, 4.449118153381742],
            [27.188434439756527, 4.444523089471089],
            [27.194397479968707, 4.444070104211106],
            [27.210209400122668, 4.451915102633808],
            [27.216895343390046, 4.457991866993123],
            [27.217310400085623, 4.458369104063236],
            [27.255600359639207, 4.461636063006847],
            [27.26362294933698, 4.465834997406127],
            [27.267545520280191, 4.467888018459516],
            [27.27278748011889, 4.470632070753418],
            [27.281042100162946, 4.470871037512096],
            [27.292191119900277, 4.464722248658052],
            [27.29401488048839, 4.462205649184981],
            [27.294703919752369, 4.459469831683309],
            [27.294262919711382, 4.455149387791325],
            [27.291777479847887, 4.451299149639449],
            [27.27323495970797, 4.427086094006429],
            [27.266906519872531, 4.417802580726439],
            [27.264672360353561, 4.405758132357193],
            [27.265872600302998, 4.383903389796156],
            [27.265470839571961, 4.366384087798981],
            [27.254409840359461, 4.345529699751141],
            [27.246507839607119, 4.331023813337064],
            [27.240890400149333, 4.311722271106882],
            [27.240551257383508, 4.297753827283463],
            [27.239879519671923, 4.270085890440448],
            [27.239450039626149, 4.261896765565687],
            [27.240169680000253, 4.248920585976216],
            [27.240524276483949, 4.224761258546935],
            [27.232271279695581, 4.224752001657798],
            [27.227920320159669, 4.221754150776096],
            [27.226093354382577, 4.214846992216341],
            [27.226824472531096, 4.211814314725774],
            [27.229089240346703, 4.202419987712749],
            [27.214481159691548, 4.151762101046812],
            [27.215142839865194, 4.145199904181705],
            [27.215177394460913, 4.144857118607277],
            [27.215052999353645, 4.144064649628101],
            [27.213587280288298, 4.134727103767644],
            [27.210582474053393, 4.131015219607699],
            [27.208551240363882, 4.128505993540706],
            [27.207652193851128, 4.128031639717442],
            [27.205799399713023, 4.12705407013692],
            [27.203741280345348, 4.125968137352212],
            [27.202086221570941, 4.123532264476297],
            [27.200767320460677, 4.121591134456223],
            [27.199517767493742, 4.113657337878014],
            [27.198265320154928, 4.105705079920215],
            [27.194923507347958, 4.093085268303422],
            [27.191192399731147, 4.078995108437649],
            [27.197635319968089, 4.058976061019195],
            [27.200851183582341, 4.054376146942889],
            [27.204634800422461, 4.052884603455526],
            [27.208418400194603, 4.051393079732322],
            [27.218046239779252, 4.050714059934679],
            [27.22102919988474, 4.047495132877909],
            [27.223564305803659, 4.036449083025652],
            [27.223247145711134, 4.035831555512901],
            [27.220133520257669, 4.029769142594985],
            [27.221977439939081, 4.02240611995672],
            [27.223905144588738, 4.021879950317797],
            [27.224498160237047, 4.02171808603958],
            [27.228839105354147, 4.011992202194762],
            [27.229324308795306, 4.010905007095317],
            [27.227504160332924, 4.000314131924473],
            [27.224071199965632, 3.995706127019953],
            [27.223845125449667, 3.991385797731585],
            [27.223625519702033, 3.987189069024065],
            [27.227085479833523, 3.96785707507728],
            [27.232599240232773, 3.957045139865073],
            [27.23808131974689, 3.953430101907271],
            [27.250717319875665, 3.945095999825471],
            [27.253357920348286, 3.941070511811924],
            [27.255998519922578, 3.937045003151883],
            [27.256244399595616, 3.922774099157418],
            [27.258316200305053, 3.91425915970997],
            [27.264970440229469, 3.907822010819572],
            [27.266683907463648, 3.905075354221075],
            [27.270710279636269, 3.898621116619749],
            [27.276620551910348, 3.881488377248739],
            [27.277378200004112, 3.879292075154192],
            [27.259678080411781, 3.873300781397958],
            [27.25650971970974, 3.870138157433589],
            [27.254490518055118, 3.856707876347667],
            [27.276263600043997, 3.851669081016589],
            [27.287959991131679, 3.844085066855015],
            [27.295302909197272, 3.834885988230368],
            [27.303338827198914, 3.820853046863952],
            [27.310218785008143, 3.813954996359264],
            [27.317337063167265, 3.800382078800916],
            [27.319974105413053, 3.797508617065265],
            [27.322614369017426, 3.794632184090022],
            [27.329043899865066, 3.781287986722581],
            [27.329278953940648, 3.780134517689321],
            [27.33434297638615, 3.755283068511623],
            [27.336633073997849, 3.75505489980082],
            [27.337421843326318, 3.748581185983566],
            [27.338483817282178, 3.739865099419073],
            [27.34238816589983, 3.731582002334991],
            [27.332930817572976, 3.712932170571139],
            [27.333909297614742, 3.69663413699066],
            [27.321644460700099, 3.654689393889389],
            [27.327355499220591, 3.645976270852977],
            [27.331157818086616, 3.643041060119027],
            [27.346350173782351, 3.640879081981983],
            [27.362506969750285, 3.630080801131715],
            [27.36726551020196, 3.623298547354445],
            [27.369220534416048, 3.591656665839977],
            [27.369247893506316, 3.576329726588055],
            [27.374044170386458, 3.548471909448193],
            [27.367416573595094, 3.538999899216808],
            [27.351090779369379, 3.520971505183639],
            [27.337100925580973, 3.505004286195726],
            [27.319112819583253, 3.478471948439813],
            [27.313455063735532, 3.457487031874566],
            [27.298278557016353, 3.451026746798425],
            [27.298031522109849, 3.447973011974676],
            [27.297349756504769, 3.439545282928949],
            [27.294524479477722, 3.42713625646483],
            [27.289786523022471, 3.422422672441688],
            [27.280310394516263, 3.412995416775804],
            [27.285078703248345, 3.400462978397307],
            [27.286078061035617, 3.37266161214699],
            [27.272862117542562, 3.331675507082592],
            [27.253896982282289, 3.320485171752847],
            [27.243498035145969, 3.29669902968091],
            [27.246380550127974, 3.277488073079252],
            [27.258720816780396, 3.277287996054459],
            [27.273899245894295, 3.282791028956271],
            [27.283399301028059, 3.27880411700144],
            [27.288159214105502, 3.27106112385142],
            [27.290701648480475, 3.262517122791933],
            [27.293889685880504, 3.251803425376015],
            [27.30034896713375, 3.227211947660585],
            [27.303178988163801, 3.226704653141125],
            [27.306016195716133, 3.226196024756597],
            [27.3092788912011, 3.225611126670935],
            [27.313390978821495, 3.234131034083843],
            [27.317965441895044, 3.238739052934967],
            [27.323714530355996, 3.239634743133019],
            [27.324980340134637, 3.239831951992313],
            [27.326893064478632, 3.240129855432067],
            [27.329417086085229, 3.236910969655118],
            [27.328735966368832, 3.231154950209207],
            [27.330346244126325, 3.224252110223201],
            [27.332867224935718, 3.221723362904556],
            [27.334022921921779, 3.222821008217167],
            [27.340872515776052, 3.229326027810309],
            [27.346274881486831, 3.229544886968275],
            [27.352549082842053, 3.229799066260556],
            [27.358267101272293, 3.23486808005048],
            [27.361004179009786, 3.245919033620101],
            [27.364662856363566, 3.249376052687214],
            [27.37267608741271, 3.251915933171477],
            [27.377259191380968, 3.247087217494952],
            [27.381608022807992, 3.248932942788367],
            [27.383272278534282, 3.248184997499003],
            [27.388251070622267, 3.245947099339173],
            [27.391456770697395, 3.245949985907921],
            [27.393512871550627, 3.249404123726324],
            [27.392135872797681, 3.25377594410078],
            [27.384575879538612, 3.258372128281708],
            [27.382969920880996, 3.261824066867752],
            [27.38388108027705, 3.264355971972671],
            [27.395323616448593, 3.271273326860995],
            [27.403791897189759, 3.274042790908714],
            [27.405400062109717, 3.27013195167763],
            [27.403348062964064, 3.262303959946335],
            [27.404038182002989, 3.257470995162746],
            [27.411372502293027, 3.251263083866439],
            [27.417324851654985, 3.251269027620134],
            [27.420258839204479, 3.252562162938231],
            [27.420987181558733, 3.252883162186103],
            [27.424876044119223, 3.257490967061556],
            [27.425326044381027, 3.264165956725154],
            [27.421188927900204, 3.280044066346341],
            [27.421874008288672, 3.282806960923264],
            [27.425536130681586, 3.284190939196987],
            [27.437216432942517, 3.281900306454974],
            [27.443625425607852, 3.284898046057895],
            [27.447911503424034, 3.285413355386342],
            [27.45047375553251, 3.285721411372434],
            [27.457133096989406, 3.286522055471074],
            [27.460107054179119, 3.288595967537625],
            [27.462163012200211, 3.295042953241562],
            [27.461241053257819, 3.299415110732628],
            [27.45597175499012, 3.303323400477299],
            [27.462380199683089, 3.306551999607204],
            [27.462896111133926, 3.306474685478157],
            [27.465321919032196, 3.306110964825688],
            [27.466961808854713, 3.305865083300619],
            [27.470858084312958, 3.30149511237941],
            [27.473150922684564, 3.296663058215941],
            [27.471560083571493, 3.284922984056147],
            [27.47316604222911, 3.280091028129541],
            [27.476374580082236, 3.278021999847985],
            [27.480038075999211, 3.278256051714915],
            [27.483239358159778, 3.283322026668817],
            [27.487134029226905, 3.282865078381963],
            [27.489881891239385, 3.280336532384987],
            [27.491018786486531, 3.290003942890916],
            [27.493992023227403, 3.292768968251328],
            [27.49971781837305, 3.293003960098778],
            [27.50589458216437, 3.298992987462252],
            [27.517802041411201, 3.299003066888134],
            [27.523185845233257, 3.296194434107166],
            [27.523528000050256, 3.296016018533826],
            [27.526282382933367, 3.289112693323287],
            [27.528803472438902, 3.287273260930917],
            [27.53773198255799, 3.289352045050821],
            [27.545052358299849, 3.296492892999104],
            [27.547175874121891, 3.296094788887492],
            [27.548716115626583, 3.295805992214885],
            [27.551012730515655, 3.289592074767527],
            [27.55307475396155, 3.289134111867179],
            [27.555252805606145, 3.292151078356036],
            [27.558562259299965, 3.296733462683298],
            [27.564292394206756, 3.291214066673271],
            [27.580776781504277, 3.293758954407095],
            [27.588097015312332, 3.30297108161324],
            [27.590376893689346, 3.315862121176012],
            [27.592435930236924, 3.317704491891435],
            [27.598852901738578, 3.309884530338381],
            [27.608933471565141, 3.304137024889489],
            [27.611910421043085, 3.303909071589474],
            [27.616255258560344, 3.311968120192149],
            [27.621962737955638, 3.312450055424451],
            [27.624497453107416, 3.312664084969762],
            [27.626918770327595, 3.311560842302093],
            [27.627019261265165, 3.311515041269639],
            [27.629540329211142, 3.306683054598762],
            [27.636183404873197, 3.304845969127373],
            [27.64534666274232, 3.298638058705057],
            [27.657709748399579, 3.302788758846816],
            [27.661892621467725, 3.292548366980628],
            [27.665480377728159, 3.276919309647206],
            [27.661702180424129, 3.266440000411762],
            [27.65509150789271, 3.247382485918076],
            [27.660897580085404, 3.185958573656638],
            [27.656178704745102, 3.170701977135612],
            [27.648610431714054, 3.156449852789302],
            [27.646737712942929, 3.142105030567279],
            [27.655509442790422, 3.116165703641057],
            [27.660098378621509, 3.102595272925654],
            [27.647802230927667, 3.077876438500553],
            [27.662997817863459, 3.07379639527231],
            [27.692408360228235, 3.082903288107749],
            [27.705703491111898, 3.079812377251602],
            [27.704768211950476, 3.072160378991096],
            [27.690557946625642, 3.056097804056729],
            [27.673548322466317, 3.013243643702388],
            [27.658378946573865, 3.008746373091399],
            [27.633700682413419, 3.001429958159444],
            [27.616624099629483, 2.995956109201209],
            [27.603339031673606, 2.993296117811788],
            [27.578505120017176, 2.984874213905536],
            [27.569645747835597, 2.991199631320971],
            [27.568199870758274, 2.992231893462818],
            [27.563274602989843, 2.992438504722071],
            [27.562533254826917, 2.992469579268785],
            [27.557439940116595, 2.992683065029281],
            [27.555031039410263, 2.992063695477014],
            [27.545769524713684, 2.989682190321804],
            [27.546690926700606, 2.983699108885654],
            [27.553109000435128, 2.972196119264134],
            [27.553571959793196, 2.96552195400709],
            [27.551976563526715, 2.958385619793591],
            [27.558793394025948, 2.954720378543938],
            [27.577792736233924, 2.946743861466331],
            [27.588243525145273, 2.94178181879574],
            [27.605369848544832, 2.936894667738007],
            [27.638105275863371, 2.927553257680947],
            [27.660914132442823, 2.912805040142742],
            [27.660945092879089, 2.895550479741342],
            [27.659902745315584, 2.892392616427161],
            [27.658112614956742, 2.886969270139138],
            [27.655752456837718, 2.879818121937471],
            [27.644383308533314, 2.867540930438467],
            [27.637270436435553, 2.863822016340035],
            [27.623233382467156, 2.862465003180556],
            [27.610689991457651, 2.864732590433918],
            [27.602630189947547, 2.859591151160198],
            [27.602638829943928, 2.85479792792366],
            [27.603612988190857, 2.840882378567572],
            [27.607912049357857, 2.825953842604077],
            [27.604602417797611, 2.818817873000844],
            [27.59463402419383, 2.819458898805717],
            [27.580858993522476, 2.825434230606042],
            [27.566610203048317, 2.830937902416469],
            [27.558056608406307, 2.836828389261616],
            [27.536673341351865, 2.85059602109446],
            [27.532882401445541, 2.84908005045337],
            [27.528610427179288, 2.847371714299721],
            [27.522450470866925, 2.841719974626867],
            [27.51876702696077, 2.831029898531989],
            [27.518672993113469, 2.830756992056316],
            [27.518216513303535, 2.820698827659742],
            [27.518224433749378, 2.816384995802554],
            [27.515850954513027, 2.816423339295626],
            [27.513003356147806, 2.816469603495885],
            [27.507306719417944, 2.817041325126675],
            [27.499715763925984, 2.815247312617687],
            [27.49972944436945, 2.80757798999103],
            [27.504960961292959, 2.801741178271749],
            [27.506404559344414, 2.790693205693872],
            [27.504035041678463, 2.78881436368958],
            [27.498813964975191, 2.788899151349636],
            [27.487896971092628, 2.789076288943726],
            [27.475093579792144, 2.782573315157933],
            [27.460893027950458, 2.761233714805794],
            [27.45092067367457, 2.764271580339362],
            [27.439996840019443, 2.768283530917129],
            [27.436701992932125, 2.766318112876386],
            [27.424350889004121, 2.758950494280934],
            [27.403954020640658, 2.752091447744715],
            [27.39493998641494, 2.74984097446385],
            [27.384047472522184, 2.736596020459995],
            [27.373131558414602, 2.736293757259326],
            [27.361733245406164, 2.740313544740011],
            [27.344155895868752, 2.749226913057124],
            [27.327434647983655, 2.753807667011816],
            [27.32010358947641, 2.759554111091239],
            [27.304524597984067, 2.776568061443466],
            [27.285975608177488, 2.787824988992614],
            [27.271992496245261, 2.80783199384179],
            [27.269467456847419, 2.814963073653196],
            [27.261569110441638, 2.820024726082552],
            [27.261220782402024, 2.820247951328459],
            [27.257323584373996, 2.825997132001493],
            [27.252503547054587, 2.837728083731613],
            [27.246775589664061, 2.843936070752691],
            [27.23921847460716, 2.846918996858191],
            [27.232348978577761, 2.851743847626382],
            [27.223189481954719, 2.854035071367259],
            [27.21769055992732, 2.859321986385652],
            [27.217445699842123, 2.85946609648574],
            [27.215047727141247, 2.860877132557753],
            [27.199351062634882, 2.870117502677206],
            [27.196620416834808, 2.871724981828156],
            [27.196594250707221, 2.871723302744805],
            [27.187290669702495, 2.871126282320027],
            [27.185635742082134, 2.871020083622635],
            [27.182656743547042, 2.873779011944248],
            [27.181271465022117, 2.882983132549528],
            [27.176459707474692, 2.886889006704215],
            [27.175018357008074, 2.885954758505326],
            [27.173258880759985, 2.884814308948371],
            [27.169367711325844, 2.884809080276749],
            [27.163403594033607, 2.89584911897816],
            [27.155854001468903, 2.898306261524052],
            [27.154244715451501, 2.898830030874512],
            [27.151133178581055, 2.900869880896041],
            [27.14233172437914, 2.90664011044833],
            [27.142097172461803, 2.906953678257024],
            [27.139580830552557, 2.910317724265318],
            [27.134555728515068, 2.902947065167603],
            [27.132275489913614, 2.895808978999348],
            [27.127719692035022, 2.880614114351153],
            [27.126368612372996, 2.863811052995884],
            [27.122718573218975, 2.855751082185157],
            [27.127535731437884, 2.847012062021636],
            [27.12481449279548, 2.828366086365664],
            [27.120936574410091, 2.819846112795234],
            [27.118715208697413, 2.809505022468703],
            [27.118661735581828, 2.809256090837125],
            [27.118204794936144, 2.808318537901254],
            [27.111815619105982, 2.79520911677557],
            [27.097657545000811, 2.773096021554106],
            [27.088742509610992, 2.766640123562096],
            [27.081118433234515, 2.757478095406102],
            [27.072064797677793, 2.746596046803295],
            [27.062099471820726, 2.737213483130714],
            [27.06178260278233, 2.736915142321054],
            [27.045187210665148, 2.722441241064663],
            [27.037594454051042, 2.721605731669385],
            [27.028098017331217, 2.723677131133983],
            [27.018603381733577, 2.724790061804913],
            [27.010532906441259, 2.725879586991657],
            [27.000098311459521, 2.721734812017729],
            [26.999843816044589, 2.719519789383039],
            [26.999163750950313, 2.713600763390738],
            [27.002021069985229, 2.708281430452855],
            [27.003929069190825, 2.702977556355207],
            [26.994795878832548, 2.696086415325969],
            [26.987004756237415, 2.704359110814476],
            [26.978539737279043, 2.70388599171998],
            [26.975567561448546, 2.701350977188053],
            [26.970780644115358, 2.68960713802766],
            [26.962010751322598, 2.682338010160989],
            [26.957984809443019, 2.679001001015976],
            [26.957609136686123, 2.677289325493581],
            [26.956620769786369, 2.672786020171992],
            [26.963513687590158, 2.654616004477517],
            [26.962374647166111, 2.651392060393017],
            [26.95551665047066, 2.64770000674297],
            [26.945449615560459, 2.646534074251281],
            [26.941107982333815, 2.643075237130348],
            [26.938480205311894, 2.642819638785022],
            [26.936303819143816, 2.642608135091104],
            [26.933333820829546, 2.640532094864298],
            [26.931752700589573, 2.627182054778494],
            [26.934968579475175, 2.618902075898173],
            [26.931317820770612, 2.611993079285613],
            [26.919207786037322, 2.60207908522433],
            [26.910079629837913, 2.588717107212625],
            [26.909725166304888, 2.574067632498748],
            [26.909650837901651, 2.570996979893491],
            [26.905547627432902, 2.56086514999009],
            [26.90327779222077, 2.550046075852894],
            [26.893236030512778, 2.534842209386289],
            [26.90146987342267, 2.536466040673598],
            [26.903761375999462, 2.535317844324055],
            [26.915663587288385, 2.529354026296023],
            [26.919555053166597, 2.528900144864288],
            [26.922692333058102, 2.529443830060875],
            [26.928931741764075, 2.530525110334419],
            [26.929534608337786, 2.530981361909395],
            [26.930041621077411, 2.53136507059031],
            [26.938071777284833, 2.537443017426321],
            [26.94026367017134, 2.53770564644899],
            [26.941960855440996, 2.53790899961894],
            [26.949511852970794, 2.536769972091545],
            [26.95089252493494, 2.537155541991267],
            [26.956143768862074, 2.53862201657909],
            [26.9730767218119, 2.534965099741275],
            [26.980395834522476, 2.536816877613659],
            [26.984976516632731, 2.532911028639144],
            [26.987754762363071, 2.532516169741466],
            [26.989781793733695, 2.532228077931249],
            [26.995271110075727, 2.534306957696157],
            [27.00190478846158, 2.533626028804675],
            [27.006210103699605, 2.534215685225439],
            [27.013798463060386, 2.535254987941027],
            [27.018141501252124, 2.537332102817618],
            [27.025662617222341, 2.556442085130328],
            [27.033200925150446, 2.5656579303443],
            [27.042584769727497, 2.56244897201862],
            [27.052714709165439, 2.562106455737978],
            [27.0556257627257, 2.562008026299568],
            [27.069121796432789, 2.56432798592146],
            [27.074313313173313, 2.563961727431666],
            [27.078730552207499, 2.563650093365957],
            [27.079144455466235, 2.563718197400618],
            [27.095656664486427, 2.566435120944974],
            [27.099783814159188, 2.565517850290063],
            [27.101834727241648, 2.565062118856511],
            [27.110064577140111, 2.570136058778759],
            [27.113040695676403, 2.568529109076401],
            [27.125703642568748, 2.568717504325209],
            [27.129971561839806, 2.568781090843494],
            [27.135451862689667, 2.575461974050363],
            [27.144196520009434, 2.563115881041961],
            [27.148977317120597, 2.543861415678441],
            [27.14838550251984, 2.484351079864888],
            [27.152510714526532, 2.477912976107116],
            [27.16031947105072, 2.454451074087095],
            [27.166970467158613, 2.440653054458653],
            [27.166718467263554, 2.436609075486676],
            [27.165402921360879, 2.415569127914811],
            [27.164261468061962, 2.413958025818564],
            [27.160829022429343, 2.414183082676385],
            [27.160140581443365, 2.417173970059198],
            [27.159426859170338, 2.41769433847592],
            [27.157620561831333, 2.419011006202995],
            [27.151444754745789, 2.41877313958233],
            [27.145051518530579, 2.41163203610196],
            [27.137049902698038, 2.406788893549561],
            [27.145058718527583, 2.405188136647057],
            [27.15193471476638, 2.394382089618899],
            [27.153084553838465, 2.389782078947074],
            [27.166598586190567, 2.375072023782658],
            [27.178275540430452, 2.365883020955134],
            [27.179917340071267, 2.365334716252228],
            [27.183081538878586, 2.364277982488999],
            [27.188347614889363, 2.360143014116878],
            [27.191102693966862, 2.3518620558717],
            [27.19065557370385, 2.343577985503446],
            [27.188466774615183, 2.328018343536095],
            [27.184074776443836, 2.311799594487727],
            [27.177916620355326, 2.28995003513652],
            [27.176231898311897, 2.290181628399822],
            [27.171282948257655, 2.290861946155228],
            [27.168802219159542, 2.289907577722936],
            [27.166482665789683, 2.289015017501023],
            [27.16543325836636, 2.288132911816457],
            [27.163741627380091, 2.286710967728192],
            [27.15826938621495, 2.273358677155645],
            [27.14673307580923, 2.251447579327205],
            [27.146104607249942, 2.250164895599594],
            [27.142701593120957, 2.243219431298348],
            [27.136601540065008, 2.230769300293217],
            [27.13363559584764, 2.224088213668438],
            [27.128606724479198, 2.222471051920254],
            [27.127775305835964, 2.221555522481122],
            [27.126095725749256, 2.219706026768856],
            [27.12611660529139, 2.203371145759286],
            [27.121321408186219, 2.197612112081908],
            [27.121567647185397, 2.185188067658041],
            [27.114049770540081, 2.16539211851602],
            [27.111535607943729, 2.163778078953029],
            [27.109475659606126, 2.16607592158112],
            [27.107904165712718, 2.165465295936631],
            [27.106503979645659, 2.164921172648178],
            [27.104224689665173, 2.158936200153957],
            [27.102397657412766, 2.157783085063673],
            [27.094850085159131, 2.159153941277006],
            [27.091660661658647, 2.150407069929062],
            [27.087092624234302, 2.146489053158459],
            [27.085047464861251, 2.136363110780096],
            [27.083937586446247, 2.135491033091295],
            [27.082993786764359, 2.134750166156767],
            [27.07590066412812, 2.137271003767843],
            [27.073310844520186, 2.136500654337967],
            [27.072015253793236, 2.136115253091139],
            [27.055800719508763, 2.122058045528982],
            [27.053750520586966, 2.115844102431404],
            [27.054923759873876, 2.096059134671223],
            [27.053570523356854, 2.082253181914256],
            [27.055415518321656, 2.071443065604988],
            [27.058621843624227, 2.067764749293124],
            [27.059301702106005, 2.06253822835105],
            [27.059309276700464, 2.062479997175625],
            [27.056129460681934, 2.053039575437689],
            [27.056154150877525, 2.052825515752144],
            [27.056819157512656, 2.047060042019354],
            [27.051809506498042, 2.031638072019859],
            [27.052279200525817, 2.023360018908734],
            [27.045659163057554, 2.016899998887272],
            [27.04397849241607, 2.012879562972516],
            [27.043159324098387, 2.010919977378166],
            [27.042729168519529, 1.991591900688669],
            [27.041829124876795, 1.983770039698475],
            [27.039127380574367, 1.979520974700792],
            [27.036119167927939, 1.974789908655692],
            [27.03557498649511, 1.968998560904608],
            [27.035449207982278, 1.967659986940733],
            [27.036369366700857, 1.963980002890824],
            [27.038364398284443, 1.961384817911042],
            [27.040259165305891, 1.958920056606046],
            [27.042765522440767, 1.95700765687921],
            [27.045069123527799, 1.955249960923542],
            [27.045148949620572, 1.953573928375146],
            [27.045298379876517, 1.950414256506559],
            [27.044041803880674, 1.941191297196292],
            [27.039465064476179, 1.941309477445968],
            [27.03479883041155, 1.941430205621854],
            [27.034368275980682, 1.941894393319518],
            [27.034058925841258, 1.94222790869887],
            [27.031599014301513, 1.944879976201718],
            [27.029977728588513, 1.949239341928037],
            [27.02970591455324, 1.949970117425597],
            [27.028608730231518, 1.952919861318656],
            [27.015129025201372, 1.946459885033307],
            [27.007819006136415, 1.945299903637803],
            [26.999569117518902, 1.954720020163552],
            [26.98402882904227, 1.955160429649213],
            [26.983885052782728, 1.955447998586189],
            [26.983643392496585, 1.955931346392834],
            [26.982649129055286, 1.957919984896232],
            [26.984416106235972, 1.96201988216432],
            [26.984760073853209, 1.96281798387211],
            [26.984928810701238, 1.963210289286449],
            [26.984349047898345, 1.964199932101719],
            [26.98348341512089, 1.965678105456419],
            [26.982886347172343, 1.966697671685069],
            [26.982638698716524, 1.967120019465202],
            [26.982314994397143, 1.967172104440872],
            [26.982281304879031, 1.96717752560937],
            [26.978288811769044, 1.967819933049169],
            [26.975147112166326, 1.970567059376549],
            [26.974980496240676, 1.970712749132375],
            [26.974629053741992, 1.971020053137736],
            [26.970729684485914, 1.978838280319347],
            [26.966388792369408, 1.97997984444813],
            [26.962655126350626, 1.984847119179935],
            [26.961809000489577, 1.98594987364087],
            [26.960948675857136, 1.985867263677801],
            [26.959519291848419, 1.985729996153567],
            [26.956688878254571, 1.988997055898268],
            [26.956539280912004, 1.989169494290945],
            [26.95433440377635, 1.989033652364776],
            [26.954306867717957, 1.989031949572998],
            [26.952658953244999, 1.988930669611283],
            [26.952254961098806, 1.99060141760893],
            [26.952148989539676, 1.991039796534007],
            [26.95126903043008, 1.994679958220676],
            [26.945789114059174, 1.995589940653262],
            [26.942118916710182, 1.998119948979869],
            [26.94125410229795, 2.00060652705354],
            [26.941091553045599, 2.001073900230758],
            [26.940519077376294, 2.00271992104859],
            [26.938875487393098, 2.004751138011364],
            [26.938592764217006, 2.005100538603644],
            [26.936618840347652, 2.007539989580676],
            [26.937069808993328, 2.013521151596819],
            [26.940038838025394, 2.016979968164944],
            [26.939150907265955, 2.0184896849972],
            [26.938880101140391, 2.018950126259469],
            [26.937739159881186, 2.020890025439434],
            [26.941388837912477, 2.027100023153557],
            [26.938893179712633, 2.035789065828999],
            [26.938540371774689, 2.037017420400997],
            [26.93702887995234, 2.042279895398714],
            [26.937957035473577, 2.044702312945301],
            [26.938111690331201, 2.045105950029007],
            [26.938618470407182, 2.046428605544391],
            [26.934499162128514, 2.051479932120334],
            [26.936549000825874, 2.054930067646113],
            [26.936471491488216, 2.055115264831897],
            [26.936374875882795, 2.055346112821443],
            [26.935777416268778, 2.05677379877052],
            [26.935649997432247, 2.057090568776119],
            [26.935628941820315, 2.057142912935865],
            [26.93540534395958, 2.05769270500415],
            [26.93316123829381, 2.059414911874184],
            [26.932793679120568, 2.059696989854078],
            [26.928528926410909, 2.062969907733457],
            [26.926460639910854, 2.071251245706598],
            [26.929889005395459, 2.073789952734779],
            [26.930644918842425, 2.076261345721686],
            [26.930846698421554, 2.076921045471091],
            [26.931928799131349, 2.080462109769878],
            [26.931008964704592, 2.085060026471483],
            [26.927985896618296, 2.085249997379077],
            [26.927953093737386, 2.085252058861522],
            [26.927351111105921, 2.085289888555424],
            [26.92889826424841, 2.09033076609605],
            [26.929136423799893, 2.091105571683346],
            [26.92939875521904, 2.091960735491501],
            [26.928019031875863, 2.095639926359812],
            [26.926977144249776, 2.095340434974483],
            [26.926869841387383, 2.095309591565459],
            [26.923219764504147, 2.094260261876679],
            [26.91908901258709, 2.103910001223024],
            [26.916374779905585, 2.115155282563033],
            [26.915869080502915, 2.117250041976019],
            [26.910608858812822, 2.117469945425426],
            [26.906939105231597, 2.125059916735792],
            [26.906328007394951, 2.125340543998018],
            [26.90467747612955, 2.126098134683067],
            [26.901449054965937, 2.127580351993939],
            [26.901897192121861, 2.13310002843617],
            [26.899309034397191, 2.133244629551332],
            [26.899278258115565, 2.133246349357793],
            [26.897779187298681, 2.133330102934728],
            [26.897225156737075, 2.133930438136432],
            [26.896991621712687, 2.134183491747959],
            [26.895029149566565, 2.136309975828302],
            [26.893418870910768, 2.141139897827261],
            [26.893604489797916, 2.148124302759817],
            [26.89363608174984, 2.149313036531062],
            [26.89363919081903, 2.149429994773704],
            [26.893423258282592, 2.149717075536806],
            [26.893367834026208, 2.149790761614851],
            [26.892729110299623, 2.150639942434153],
            [26.886299155447155, 2.159310006278211],
            [26.8817091578074, 2.170109920235932],
            [26.874589840297496, 2.171766052343371],
            [26.874373832302574, 2.171816301395873],
            [26.868899010277644, 2.173089243089215],
            [26.868613087302489, 2.164257822853445],
            [26.8644727297001, 2.152763202363443],
            [26.861100971553125, 2.147562300202439],
            [26.859283332085337, 2.146015191363784],
            [26.855383197464661, 2.145553067930114],
            [26.847053780096747, 2.149367138011109],
            [26.836908902573935, 2.150582837925138],
            [26.826247234149626, 2.149967609633445],
            [26.821315596427546, 2.144529318425699],
            [26.815359400479515, 2.130436135145357],
            [26.809123077486536, 2.12738407641978],
            [26.800797049462201, 2.129358730522242],
            [26.796619251875384, 2.138623629594178],
            [26.788798977152648, 2.148736048847832],
            [26.780474701741419, 2.149922403533947],
            [26.77500162514308, 2.156317752657678],
            [26.772901746691137, 2.167125611969405],
            [26.774701025492817, 2.178920891976111],
            [26.769476349240207, 2.191881507951654],
            [26.763751272746802, 2.193813802994467],
            [26.755948658902536, 2.194203169255935],
            [26.752024112564005, 2.193771123156094],
            [26.745547523470183, 2.193058103623842],
            [26.740872926090248, 2.189455375233126],
            [26.735160089142564, 2.184555550409199],
            [26.719054418992407, 2.17404336484906],
            [26.705551186186646, 2.16270064753598],
            [26.663233930992323, 2.121343552264429],
            [26.654293661027836, 2.113334423167277],
            [26.642202022893237, 2.102502076565828],
            [26.626348127161037, 2.096715556216061],
            [26.62658343096825, 2.110376329081644],
            [26.622144273041112, 2.120434003151694],
            [26.614862306565847, 2.120552148426935],
            [26.602646324527917, 2.116283207493413],
            [26.597195566572829, 2.110327879157225],
            [26.599812405707858, 2.101350806605032],
            [26.603985162847593, 2.094976119760279],
            [26.599872884784347, 2.06771324689996],
            [26.584294309211991, 2.053249879883873],
            [26.575350130677734, 2.052004322665998],
            [26.564014282920898, 2.050425716061125],
            [26.503944344113684, 2.046933423597834],
            [26.495614306908241, 2.051273346501988],
            [26.494375821185582, 2.058720314403111],
            [26.493510828008631, 2.063921465540773],
            [26.488269589517131, 2.08608073482391],
            [26.486162510169851, 2.100830831220851],
            [26.482499871245672, 2.112978202550231],
            [26.475212753830547, 2.115724333666784],
            [26.471574955120609, 2.113943951010177],
            [26.45806991939607, 2.103651910508106],
            [26.444566323670951, 2.092308666275013],
            [26.435216767788308, 2.085102541275758],
            [26.424849489859028, 2.065298987850813],
            [26.397812778870197, 2.059431001825499],
            [26.368678348979373, 2.063057452847223],
            [26.356184912384489, 2.06851602555205],
            [26.341804168378253, 2.087781852765068],
            [26.34221979730065, 2.094528008097108],
            [26.340384877840059, 2.097284078218231],
            [26.336491839011828, 2.099345994256039],
            [26.333274879452915, 2.106701005295526],
            [26.331715496646137, 2.107410231108858],
            [26.330757084069532, 2.107846128468459],
            [26.330863096951159, 2.11007968194632],
            [26.33119408031925, 2.117050119369853],
            [26.325933262147817, 2.117038053484488],
            [26.32409596215172, 2.120944977854196],
            [26.325434802268028, 2.134983135966617],
            [26.316399884906922, 2.210009942394675],
            [26.327832042841965, 2.216130563730218],
            [26.329895561982795, 2.225556468247913],
            [26.328830681977031, 2.23923723027642],
            [26.313207046910001, 2.250001257617109],
            [26.313171407149426, 2.269971106681667],
            [26.318325885452484, 2.296162527312086],
            [26.32663108334199, 2.305486516267328],
            [26.326608403576035, 2.318098610136727],
            [26.316897766271651, 2.364362085870767],
            [26.298769611124545, 2.363162942858835],
            [26.289021175407957, 2.363376515390779],
            [26.283734065344774, 2.36313288583847],
            [26.271341580523206, 2.362561840277006],
            [26.262151862777376, 2.357355034009816],
            [26.256578343750512, 2.347862836849063],
            [26.246026387470177, 2.343587176048834],
            [26.239928349335386, 2.343119865066306],
            [26.228661787738115, 2.342295075669808],
            [26.226096170540579, 2.342127486979112],
            [26.217685311010715, 2.341578027036852],
            [26.213118796230784, 2.338346083906436],
            [26.204224999709236, 2.327740121946057],
            [26.196918080730295, 2.322660144433815],
            [26.194359922244594, 2.315946060307549],
            [26.193056004134952, 2.312526072413148],
            [26.190082117912148, 2.312749006155837],
            [26.174962868910864, 2.322606053042334],
            [26.174501838235699, 2.322704206583464],
            [26.171758048286396, 2.323288096350356],
            [26.166022066245429, 2.328635751490333],
            [26.165111010155609, 2.329485127264801],
            [26.156973929276571, 2.328153875551001],
            [26.153681013567113, 2.327615144094628],
            [26.150075502105118, 2.325790949980797],
            [26.146369775488328, 2.323916048887578],
            [26.137244916105999, 2.315149059219014],
            [26.127645101263301, 2.312363088614669],
            [26.125686974268241, 2.310766153256627],
            [26.113494944909046, 2.300822999213621],
            [26.112133099836637, 2.29713795700856],
            [26.112342641758122, 2.296510152416163],
            [26.113974824933841, 2.291619998014905],
            [26.111927144888099, 2.287934134768189],
            [26.105075986168586, 2.284005141741401],
            [26.09867439023132, 2.283068180964661],
            [26.087478111025224, 2.279128147280252],
            [26.0696350757594, 2.280692044206923],
            [26.065972340715469, 2.281787061822887],
            [26.053612964202024, 2.285482038020002],
            [26.039436123392257, 2.284755031974507],
            [26.02641813085857, 2.277587300628534],
            [26.016360849855758, 2.276180079925159],
            [26.013580068181376, 2.276871929499058],
            [26.012698930482088, 2.277091153987493],
            [25.990534081519748, 2.270129015951741],
            [25.985079017041176, 2.257919032682021],
            [25.981219320082978, 2.245058461492365],
            [25.979411898951572, 2.239036067070652],
            [25.979323248707743, 2.238891106682208],
            [25.976451979734804, 2.234196018068059],
            [25.972709397038532, 2.230950306372672],
            [25.97166218060616, 2.230042118307934],
            [25.970992940211076, 2.223598102325294],
            [25.96597994117538, 2.216911107043376],
            [25.967559734603711, 2.211517742915358],
            [25.967595981625426, 2.211393997451529],
            [25.967496931585565, 2.211218622528998],
            [25.965774021261129, 2.208168079995172],
            [25.958243903273466, 2.20285606930356],
            [25.953211105368908, 2.20399213377988],
            [25.931451990386098, 2.215896979464646],
            [25.926360037521778, 2.21553307122623],
            [25.921392151879651, 2.215178029850695],
            [25.916122114298439, 2.218844990351052],
            [25.909223149934455, 2.23194090353747],
            [25.9080789954015, 2.232398128276851],
            [25.894065638990263, 2.255479862651616],
            [25.879983882158406, 2.251512781250548],
            [25.863982965451846, 2.253919361179769],
            [25.849903008843771, 2.26273613044436],
            [25.840302531044383, 2.265202842316788],
            [25.831341774101556, 2.265118739298188],
            [25.820460775712423, 2.264377483977109],
            [25.81086137858631, 2.275153748719511],
            [25.807021259511455, 2.278313603695582],
            [25.792299781823033, 2.274340461639469],
            [25.777577585482362, 2.264614484351481],
            [25.762215841660041, 2.258078649388819],
            [25.751973455606386, 2.242002584205216],
            [25.740450936136874, 2.226553486105008],
            [25.728929858463399, 2.225167105799218],
            [25.720315834152249, 2.21920066341257],
            [25.704606100955147, 2.208319365649361],
            [25.693084301934505, 2.199262373784764],
            [25.67900218218325, 2.1914595464556],
            [25.659799425462328, 2.178494964033595],
            [25.641877501944865, 2.173212923984209],
            [25.62395606980585, 2.173044888982685],
            [25.606994312376465, 2.167692082390578],
            [25.602049310417897, 2.174424114913814],
            [25.600548378291723, 2.174535770035517],
            [25.600432114734385, 2.174544418535496],
            [25.598650190485664, 2.174676978254764],
            [25.596101164273122, 2.174866075825196],
            [25.593351316085528, 2.176466996008039],
            [25.588832168572246, 2.175577629255069],
            [25.588415537129993, 2.175495639361084],
            [25.587412108177837, 2.17529816991004],
            [25.584202271360812, 2.177359044434112],
            [25.580356686935747, 2.176741796517968],
            [25.57819764903245, 2.176395246986507],
            [25.569574125037157, 2.175011086821545],
            [25.564766232940411, 2.177066024381909],
            [25.555607026473194, 2.176012401725657],
            [25.555011718324291, 2.175943921396392],
            [25.546251115908216, 2.174936145828667],
            [25.542594104929286, 2.173235082960937],
            [25.541471204535924, 2.172712764523405],
            [25.540771163604692, 2.172387166589595],
            [25.534840787932868, 2.17308794626481],
            [25.533735569079241, 2.173218548677164],
            [25.527502317426237, 2.173955127524335],
            [25.524250699067043, 2.175626639194165],
            [25.52244137889711, 2.176556729724825],
            [25.519943037429499, 2.177841014316584],
            [25.518078372953216, 2.180927439733725],
            [25.513862202930753, 2.187906096620181],
            [25.51189631898319, 2.191160039725291],
            [25.506851279736253, 2.1952850538424],
            [25.500363921638829, 2.196078996503357],
            [25.499212047882615, 2.196219966804709],
            [25.49769936040266, 2.196405094399256],
            [25.488769140789564, 2.199826077470388],
            [25.483794863634191, 2.199483579184307],
            [25.478254361287277, 2.199102090919109],
            [25.471613007695627, 2.2018410328245],
            [25.465667322036399, 2.201591060520698],
            [25.46467030975035, 2.200968637324484],
            [25.464057526674214, 2.20058606862668],
            [25.46270213779378, 2.199740033140431],
            [25.461503161773923, 2.199921409962439],
            [25.460825521232614, 2.200023922296781],
            [25.456752253408919, 2.20064012125136],
            [25.456255673703019, 2.200450848042479],
            [25.451271203364112, 2.198550986270002],
            [25.445473737031843, 2.198801017830324],
            [25.445234938778189, 2.1988113172388],
            [25.436405045710963, 2.199192135941756],
            [25.426319248587756, 2.206060031538605],
            [25.425494613123234, 2.206057079182603],
            [25.423803284869255, 2.206051025361665],
            [25.419556031341294, 2.206383281501901],
            [25.419304591994951, 2.206402951219175],
            [25.41534036796866, 2.206713068686262],
            [25.413046087801007, 2.209236066426721],
            [25.413685514010126, 2.210535037329706],
            [25.414719986941872, 2.212636531239263],
            [25.415542281396757, 2.2143069887761],
            [25.414260200433358, 2.215374367067897],
            [25.412790128132141, 2.216598102659614],
            [25.402494128825719, 2.218173052669977],
            [25.399928532289419, 2.220004319452983],
            [25.399252851872077, 2.220486605220959],
            [25.397680209931707, 2.221609120684102],
            [25.384636330646494, 2.224094993068997],
            [25.382341303978823, 2.227973289378864],
            [25.381647204504894, 2.229146204305636],
            [25.379202108879145, 2.230821889655472],
            [25.375879976363393, 2.233098661557688],
            [25.369955171144632, 2.237159124732806],
            [25.36194841245711, 2.238282014984523],
            [25.353235332716217, 2.244234129887402],
            [25.351864263742446, 2.245848265374333],
            [25.349758452816364, 2.248327397306571],
            [25.34680537337216, 2.251803995326323],
            [25.346681509169212, 2.254446685814861],
            [25.346557299114881, 2.257095986220621],
            [25.344499628904853, 2.259738957039673],
            [25.340126232148105, 2.265356194990896],
            [25.3397360884303, 2.266712498339905],
            [25.338737399887929, 2.270183903665045],
            [25.334282413645472, 2.27407807399468],
            [25.333877258180973, 2.274431861067867],
            [25.333583300673908, 2.274688529463502],
            [25.33323117725222, 2.274995979168037],
            [25.329233470320315, 2.274311740105466],
            [25.329007256565468, 2.274273023324915],
            [25.327745192761558, 2.274057015388183],
            [25.326202117072157, 2.274520372433204],
            [25.325291407732053, 2.274793843230165],
            [25.317901336198883, 2.277012999467213],
            [25.313423455493098, 2.281486349342466],
            [25.311933276200886, 2.282974982036831],
            [25.305296230929347, 2.28456196817445],
            [25.304386643585048, 2.284436685566978],
            [25.303441336530099, 2.284306478103856],
            [25.295009297420766, 2.28314504204008],
            [25.29053948987443, 2.281102475416087],
            [25.289377083371516, 2.280571290319343],
            [25.285875354274289, 2.278971126387508],
            [25.283925664256369, 2.279244473432891],
            [25.283753516505193, 2.27926860977549],
            [25.282673178290008, 2.279420077741008],
            [25.263197145974832, 2.289245004248956],
            [25.254002359035844, 2.289362967866981],
            [25.249244333318838, 2.28942400951497],
            [25.211439239439837, 2.308155030080189],
            [25.192005417163241, 2.306473038750066],
            [25.188133225537783, 2.302087033332205],
            [25.182651154108473, 2.300226029961856],
            [25.180396511204417, 2.297575392124303],
            [25.17695810614822, 2.2935330756965],
            [25.17521079488569, 2.292837274525119],
            [25.17452290366867, 2.292563347257761],
            [25.171707146987032, 2.291442076487314],
            [25.17147367484467, 2.29115315851802],
            [25.17107345921594, 2.290657898575016],
            [25.169656226718025, 2.288904095907084],
            [25.168793800926146, 2.284702005420495],
            [25.168425505134376, 2.282907516119159],
            [25.167860187241242, 2.280153041533698],
            [25.166426765305342, 2.277698967711514],
            [25.165890365079505, 2.276780628724761],
            [25.164224187856824, 2.273928059429513],
            [25.155565107644254, 2.265382036762399],
            [25.149622228321991, 2.264670135864077],
            [25.147010445803691, 2.263045704505219],
            [25.146093945024965, 2.26247567539187],
            [25.142549308796507, 2.260271039094032],
            [25.13825453977994, 2.256569864424887],
            [25.137991283096017, 2.256343009905601],
            [25.129541069271873, 2.252860059281505],
            [25.126526580096524, 2.248657931341365],
            [25.125900352833863, 2.247784990078127],
            [25.124338350539748, 2.237884006016928],
            [25.123531539447104, 2.236451923416675],
            [25.123158349633684, 2.235789514056454],
            [25.122520401153192, 2.234656923658093],
            [25.122989451987209, 2.231437136705643],
            [25.121911353272022, 2.230465554329164],
            [25.120957688291675, 2.229606087635536],
            [25.118887230563601, 2.22774013896913],
            [25.11884902970613, 2.227643655198559],
            [25.118822126959991, 2.227575706828259],
            [25.116580534780397, 2.221914158049714],
            [25.112318278488878, 2.211149040431088],
            [25.111960355543729, 2.21100649643526],
            [25.107067439701932, 2.209058132000365],
            [25.098835204776414, 2.208797081703695],
            [25.097978859680683, 2.209480716513051],
            [25.096540320042582, 2.210629127459898],
            [25.095598200210269, 2.217758110404792],
            [25.093990440430503, 2.219593118951519],
            [25.090788179106294, 2.220271069075037],
            [25.089700850201567, 2.221416821047497],
            [25.086654360340848, 2.224626999696437],
            [25.082535087096502, 2.225301275832443],
            [25.081574138575824, 2.226403562374752],
            [25.071739199588968, 2.237685003299438],
            [25.069024745023579, 2.238766118288996],
            [25.068304439896156, 2.239053001842288],
            [25.063444440123035, 2.253759985287767],
            [25.061643996206421, 2.254988929679368],
            [25.059087360365101, 2.25673403210696],
            [25.056647700445122, 2.256906665243791],
            [25.052910230959462, 2.257170838959327],
            [25.051677334554508, 2.255795092475964],
            [25.050634200066781, 2.254631093013035],
            [25.050067140340342, 2.252115830900704],
            [25.049284096873468, 2.248642950403489],
            [25.046547479971718, 2.247253041660028],
            [25.044714359836615, 2.247936136058474],
            [25.041712164105942, 2.255517178365337],
            [25.041362832648169, 2.255586140230746],
            [25.039423291796322, 2.255968723365482],
            [25.03827958642098, 2.253840326130724],
            [25.036697520254997, 2.250896148398721],
            [25.034643359762761, 2.249968128430583],
            [25.03331134684263, 2.251030840169932],
            [25.032348360044569, 2.251799134529577],
            [25.030195550161149, 2.256841774423872],
            [25.028425439656722, 2.260987986388829],
            [25.026078970964331, 2.262263519759291],
            [25.02590345632747, 2.262358929478886],
            [25.023401279951955, 2.259127997266261],
            [25.023191400263897, 2.25429503989091],
            [25.017923334484749, 2.256576016533907],
            [25.015496958851212, 2.262884991314981],
            [25.014919319665623, 2.264387033791071],
            [25.012628279721202, 2.265528992456772],
            [25.011288404745706, 2.265017204799621],
            [25.01080127980816, 2.264831138926493],
            [25.00853544030241, 2.259530142724909],
            [25.007700798503958, 2.258837947683143],
            [25.006027319774638, 2.257450079319986],
            [25.001728926055879, 2.257865189126613],
            [25.000000200038301, 2.258032137215685],
            [24.99916429431023, 2.258112997422713],
            [24.998899935393464, 2.257967600680589],
            [24.993686520421267, 2.255100053621914],
            [24.991734420223434, 2.257278541482475],
            [24.989782320025601, 2.259457025130736],
            [24.986120399753631, 2.260133090508043],
            [24.983528036116823, 2.259061662502634],
            [24.978813479876425, 2.257113126814029],
            [24.974714160011143, 2.252495013578353],
            [24.971739479677634, 2.253404121910418],
            [24.965536319790001, 2.260282025749117],
            [24.965161169852614, 2.260226440936455],
            [24.964470360009258, 2.260124085570604],
            [24.963404845792876, 2.259966899927953],
            [24.962335200224508, 2.259809105203406],
            [24.960636298274331, 2.257005846287029],
            [24.960518280307259, 2.256811111479444],
            [24.960762196263072, 2.254111588722207],
            [24.960996360108204, 2.251519990665701],
            [24.959863439906179, 2.249214978491958],
            [24.956440200208579, 2.247131118317898],
            [24.952553279805709, 2.247115090016699],
            [24.951612584701422, 2.248479993610528],
            [24.950023199960821, 2.250786111237041],
            [24.952972304359864, 2.25678100428448],
            [24.950884319602288, 2.264366143121104],
            [24.948820283930161, 2.265507999690708],
            [24.948211985243937, 2.265109702764253],
            [24.941749320037026, 2.260878129828383],
            [24.933973319681368, 2.260847154305313],
            [24.925947450234492, 2.266337049702178],
            [24.924841757968728, 2.265887202320447],
            [24.9225213601825, 2.264943155818977],
            [24.919703981143435, 2.260229361554186],
            [24.91866128772855, 2.258485024259389],
            [24.917997597125268, 2.25829132705169],
            [24.912264239961555, 2.256618052932456],
            [24.907612148972728, 2.251574848367711],
            [24.905654137860328, 2.249458980243118],
            [24.902460360225646, 2.249446038881579],
            [24.899517359878942, 2.241611061888578],
            [24.897009240249499, 2.239990032993623],
            [24.896082358539342, 2.240683754360439],
            [24.891504480071063, 2.244110046526788],
            [24.888421313793952, 2.251437067930715],
            [24.88734827978033, 2.253987081492581],
            [24.879310380993491, 2.2620078458613],
            [24.878381399920524, 2.265224998992818],
            [24.878886132735946, 2.26771105736879],
            [24.879503519677876, 2.270751987758981],
            [24.876968400284234, 2.275574083689303],
            [24.873306040736122, 2.27739727391008],
            [24.869634479744537, 2.279225042366515],
            [24.866647156521712, 2.282664120098417],
            [24.863455439622271, 2.28058111563603],
            [24.861187439668274, 2.275510151582849],
            [24.863249160381912, 2.268087005364557],
            [24.863740972728582, 2.266315681028531],
            [24.861630960381916, 2.26418713289359],
            [24.855257160116171, 2.264213965994612],
            [24.844534920088908, 2.263382304094106],
            [24.825997799722145, 2.264630337148414],
            [24.738175022863114, 2.268225506217938],
            [24.698542320013303, 2.269847932812203],
            [24.585095691664549, 2.275679271783536],
            [24.574567679978081, 2.276220426831864],
            [24.488169673380476, 2.280903452494429],
            [24.457545719967584, 2.28256335675416],
            [24.448271040460508, 2.281433117539271],
            [24.445936799635742, 2.276764657685289],
            [24.440117760261945, 2.269771755081642],
            [24.425015759812428, 2.259309530233238],
            [24.40995120024564, 2.259373102505895],
            [24.390222119701416, 2.251269660918237],
            [24.370488720057317, 2.241996463662348],
            [24.364686600451883, 2.239681891707828],
            [24.356586960455569, 2.243224884929699],
            [24.351976439904828, 2.250261860423501],
            [24.347378159798133, 2.260807534407189],
            [24.336997920077632, 2.274886500506365],
            [24.331211999791691, 2.27724999954863],
            [24.319636200344398, 2.28080784792553],
            [24.310365479712761, 2.280847106714175],
            [24.304554720110914, 2.27619323340182],
            [24.294108599744078, 2.271559153760054],
            [24.28017372015611, 2.263431108664876],
            [24.273208440361199, 2.259951737473035],
            [24.266255400112072, 2.259981272586806],
            [24.263937719729565, 2.259990997739454],
            [24.253512479803231, 2.26120463609104],
            [24.236138160299806, 2.263617323823087],
            [24.224549760183994, 2.263666488040243],
            [24.215266800006606, 2.26019702239944],
            [24.210606599925715, 2.25319917614982],
            [24.203624759688577, 2.245041672281346],
            [24.202437120407627, 2.236859629169514],
            [24.195455280170489, 2.228702033048822],
            [24.17224752040093, 2.22002841341235],
            [24.161236560044685, 2.219490283564447],
            [24.151955760315584, 2.216605488466763],
            [24.13340208040486, 2.213175351316716],
            [24.115427639579288, 2.209742684834922],
            [24.104404080351184, 2.205695694314085],
            [24.094560239958192, 2.207491816871558],
            [24.085306079768817, 2.212209307207242],
            [24.075468359597846, 2.21575957066544],
            [24.066189360092526, 2.213459725864042],
            [24.059805479830988, 2.210562851022745],
            [24.058054799886175, 2.207061381433857],
            [24.065585279894904, 2.206444724290199],
            [24.063832799726242, 2.202358642685984],
            [24.058019879676142, 2.197120092310971],
            [24.057397439710705, 2.184842105697672],
            [24.060842999848191, 2.176055663160107],
            [24.068936160296374, 2.170758306483198],
            [24.076441800090862, 2.163124266474636],
            [24.085681560286201, 2.154313382345749],
            [24.079289400252712, 2.149077364081168],
            [24.068251800356709, 2.140936934599765],
            [24.058466280388576, 2.134710100941791],
            [24.052973760654226, 2.135603072481495],
            [24.047481240021579, 2.136496042591565],
            [24.043273763894426, 2.135060546144001],
            [24.040634400401945, 2.134160053412346],
            [24.036431476936645, 2.129195762395552],
            [24.03222227963742, 2.124224043604316],
            [24.02399232014448, 2.123952079386809],
            [24.012083519712945, 2.127803154048128],
            [24.000665399750808, 2.124523023258917],
            [23.993689515343991, 2.119580683449308],
            [23.98790735989742, 2.115484075824781],
            [23.983223940163054, 2.114770032263676],
            [23.978540520428687, 2.114055987465806],
            [23.974891199926912, 2.111965993659739],
            [23.971782240323037, 2.0987311013596],
            [23.971536359751671, 2.097684113817917],
            [23.96674832671092, 2.092066353245582],
            [23.962673159848695, 2.087284977477958],
            [23.962547366962813, 2.086311676752284],
            [23.961572279857883, 2.078767060742623],
            [23.961115114633394, 2.078301511644404],
            [23.960209319976208, 2.077379103655718],
            [23.946270479716141, 2.075696118386889],
            [23.930475480228907, 2.079294974079137],
            [23.919962269185085, 2.078090108867451],
            [23.918535107608353, 2.079128136146287],
            [23.913995400353169, 2.082430029604718],
            [23.911757899999657, 2.082878419509085],
            [23.903925480054262, 2.084448018134267],
            [23.899563359849282, 2.087646103321072],
            [23.89578709482144, 2.094213387598171],
            [23.893100279620707, 2.098885997680173],
            [23.890308480109361, 2.108303994941322],
            [23.888440012166171, 2.111232394981033],
            [23.882700404524719, 2.120227894847675],
            [23.876276400112694, 2.124334990299956],
            [23.874623075985081, 2.124771831764659],
            [23.866886519755241, 2.126815981298949],
            [23.844696480235694, 2.128769072974125],
            [23.824117661704662, 2.128659028531151],
            [23.804308623913659, 2.124824063380541],
            [23.799675240340619, 2.123927043985165],
            [23.786159800328466, 2.124575994142243],
            [23.773830479647813, 2.125167991287631],
            [23.766494400456455, 2.128349061147518],
            [23.75661419985401, 2.137037984604346],
            [23.746946372662833, 2.142067499184711],
            [23.742168479804988, 2.144553107247052],
            [23.731615440156421, 2.150937132020597],
            [23.722416360168676, 2.160550039791505],
            [23.717364674286983, 2.162482512907747],
            [23.712333479875209, 2.164407144700469],
            [23.698091159966047, 2.176063047362998],
            [23.686863321147424, 2.180142024447683],
            [23.680225440442651, 2.181256106589124],
            [23.664863519652197, 2.188763983698311],
            [23.6559355197762, 2.190325095362829],
            [23.648611319906159, 2.191435054399689],
            [23.636984244622443, 2.19007007484564],
            [23.631858920243616, 2.190117279616997],
            [23.626894319740508, 2.190163005029919],
            [23.624025922681522, 2.190805803080153],
            [23.618879280382675, 2.191959146533105],
            [23.612758599312876, 2.191755009975768],
            [23.593958413603371, 2.191128264750935],
            [23.59907575375593, 2.20184318270975],
            [23.602773240126609, 2.209585098814443],
            [23.60215284832006, 2.214930142814137],
            [23.601572279728337, 2.219932061971988],
            [23.605335360182778, 2.242042027502507],
            [23.610328200125142, 2.248973113863766],
            [23.611669199791404, 2.25427198842223],
            [23.604112728826557, 2.277684412694731],
            [23.603292368444489, 2.280226133668638],
            [23.603729399728529, 2.28368008833742],
            [23.607147239652946, 2.285999991985786],
            [23.606437319948533, 2.290138061326358],
            [23.595504479784342, 2.306905061852842],
            [23.585212440251691, 2.32269202583266],
            [23.584522162210948, 2.33646998892735],
            [23.584440240348613, 2.338105141770294],
            [23.58361654631852, 2.338734986988789],
            [23.581453319571054, 2.340389118283918],
            [23.576492159615462, 2.354711834993472],
            [23.569617599782791, 2.376963026636884],
            [23.572582560344941, 2.396248575257309],
            [23.566858560033225, 2.416155636258961],
            [23.547289320320811, 2.435690018688412],
            [23.545720407287195, 2.439207174919269],
            [23.542886519908134, 2.445560101295948],
            [23.536449359668779, 2.451276154446331],
            [23.528430900424695, 2.453416607410103],
            [23.520412440282282, 2.455557056901931],
            [23.519839645711038, 2.45593469809691],
            [23.519088360384419, 2.456430017300722],
            [23.491708200106274, 2.474492146619144],
            [23.487583319577912, 2.47584910515089],
            [23.48152127963154, 2.481176091636899],
            [23.479688696688999, 2.482786847109414],
            [23.477697359876178, 2.484537138369815],
            [23.471610853414724, 2.488097435550303],
            [23.464843200287394, 2.492056156917955],
            [23.460551327439301, 2.496039568815446],
            [23.457943440016049, 2.498460018582991],
            [23.451921359828461, 2.511081105238851],
            [23.432701320419778, 2.511659093518884],
            [23.431667947924275, 2.511001983953811],
            [23.430877199607231, 2.510499155800105],
            [23.427261360214402, 2.502884093371278],
            [23.426803802426118, 2.504052488313831],
            [23.424474240027369, 2.510001114141495],
            [23.419650933738659, 2.517042807311739],
            [23.413170240242298, 2.526504110963078],
            [23.409271432433307, 2.529767524886446],
            [23.408802360039694, 2.530160151239973],
            [23.405503372617254, 2.531447547934197],
            [23.40008736958217, 2.533560991353081],
            [23.391111960218723, 2.529471436689944],
            [23.387947920413222, 2.535917605297743],
            [23.382869648890662, 2.543814771517403],
            [23.377150079968263, 2.543090079250262],
            [23.373939960181918, 2.545139993372298],
            [23.363309880116276, 2.562800086367195],
            [23.363160041126886, 2.562887913725521],
            [23.359414766179711, 2.565077192036655],
            [23.356684754590223, 2.563596726441197],
            [23.355989544798582, 2.563219053519905],
            [23.34988115897006, 2.550982185855722],
            [23.349909959856401, 2.550039967546663],
            [23.350160160425943, 2.542699902559747],
            [23.347950119774076, 2.528879953058213],
            [23.338640159832526, 2.517550053662105],
            [23.338614835426352, 2.516998475998807],
            [23.338450079911659, 2.513409980937836],
            [23.342780098819965, 2.503947999184554],
            [23.344229879975547, 2.500779913689315],
            [23.343574071190595, 2.497369324934386],
            [23.342680080396235, 2.492720042432469],
            [23.339727186005003, 2.48956596725353],
            [23.338130606657277, 2.487860608668611],
            [23.336510972946076, 2.487647653270964],
            [23.334469919772189, 2.487379958025565],
            [23.326010085889667, 2.487330081783307],
            [23.325872779296784, 2.487431393717167],
            [23.318889840420031, 2.492590038386201],
            [23.316369960945217, 2.491979102587721],
            [23.315919840309167, 2.491869972997854],
            [23.315386594068308, 2.491004457615216],
            [23.314780080334543, 2.490020022444259],
            [23.316660000000969, 2.482210011485921],
            [23.314179959910664, 2.476209952320712],
            [23.316275617179116, 2.468498975714002],
            [23.316990120088118, 2.465869950394776],
            [23.316277510827732, 2.46326008443032],
            [23.315419308914301, 2.460116571758888],
            [23.314970992993686, 2.458253377587182],
            [23.314529879765001, 2.456420113737492],
            [23.311711104743981, 2.453981684519567],
            [23.308379999855184, 2.451100049039241],
            [23.293749959882884, 2.450319999782443],
            [23.290310159743026, 2.451680044430621],
            [23.286849840285431, 2.456260034883606],
            [23.281980119842622, 2.467979948189936],
            [23.277629879857251, 2.467939973780215],
            [23.277544747416091, 2.467873321149853],
            [23.273759880121109, 2.464910024184314],
            [23.273761228492319, 2.464927060985956],
            [23.274179927856359, 2.47021903994054],
            [23.278160479661295, 2.471175613831267],
            [23.28400945179871, 2.472579879394789],
            [23.285857562120913, 2.470838187156234],
            [23.288379143004899, 2.46846065837406],
            [23.29364928209575, 2.466655143217074],
            [23.294565404683734, 2.467483604227576],
            [23.295698279969997, 2.468508077764857],
            [23.296432118217194, 2.469949033537843],
            [23.298637278322129, 2.474279049898397],
            [23.298497422310486, 2.474916633217316],
            [23.297931359713992, 2.477496145042538],
            [23.273327159852105, 2.498749015125789],
            [23.256559440320697, 2.509924049134062],
            [23.245721880865442, 2.515369378921837],
            [23.240267279917575, 2.518110033494946],
            [23.234669999553081, 2.51936551317595],
            [23.21529613802505, 2.523711235057253],
            [23.214142048125026, 2.525545218930085],
            [23.213278041298256, 2.525741967794343],
            [23.211815399861063, 2.526075036245903],
            [23.197418279567245, 2.529355120406171],
            [23.180446440345399, 2.536155098242087],
            [23.178910328396064, 2.536361860457704],
            [23.168998439721975, 2.537696008223471],
            [23.157072360195937, 2.542455028602965],
            [23.121263519609307, 2.561794139107094],
            [23.107071240353058, 2.563087088006685],
            [23.102739360135462, 2.560528016965391],
            [23.098438440354137, 2.553137057525859],
            [23.088902759832848, 2.559697438474886],
            [23.074997760007836, 2.560048540035977],
            [23.064580439629015, 2.563601493958839],
            [23.047235999888578, 2.574493462083806],
            [23.040387597200358, 2.580774582575165],
            [23.040281292366274, 2.580872080906701],
            [23.029620480036431, 2.590649749357118],
            [23.014032839564532, 2.606797366306197],
            [22.962646799624572, 2.658768767999915],
            [22.949454706402317, 2.672354237853324],
            [22.939553520256514, 2.682550567494304],
            [22.925409480531034, 2.697230074910115],
            [22.899717000448518, 2.723362098718178],
            [22.887023400343722, 2.738620245707985],
            [22.878977399651326, 2.757367577433776],
            [22.880161080056801, 2.764380152849542],
            [22.886000639646664, 2.777220829983827],
            [22.884903360103518, 2.794769172802532],
            [22.896524880205551, 2.804076539333923],
            [22.905816120154885, 2.809885257551096],
            [22.916245680079459, 2.809841153702326],
            [22.932444599847685, 2.802755046881357],
            [22.942837080012268, 2.792184849511934],
            [22.948569360095927, 2.774616846302855],
            [22.952132279735373, 2.799163011923444],
            [22.95406007960646, 2.852955584904763],
            [22.962786479566414, 2.862860098552666],
            [22.974303747484765, 2.878017833620502],
            [22.983160679842022, 2.889674194662714],
            [22.997157480302519, 2.915345744848706],
            [23.01104623499392, 2.941100893314525],
            [23.021070120227769, 2.95968869735858],
            [23.033341080059365, 2.988876258280951],
            [23.059734438302964, 3.033440935763808],
            [23.052729404463502, 3.033577658363253],
            [23.050806292001571, 3.033615197810053],
            [23.048038523322376, 3.036162902912177],
            [23.03814132030654, 3.045273238058118],
            [23.028038146172477, 3.050273517344634],
            [23.023189440019102, 3.067865929035677],
            [23.01972515988944, 3.07138941941361],
            [23.01219072010694, 3.07083654671815],
            [23.008704120435731, 3.067927299820517],
            [22.999973759803666, 3.056853193304279],
            [22.991270039609699, 3.053381307269175],
            [22.975967880141848, 3.068358153170967],
            [22.965860159634143, 3.077465242976911],
            [22.955440679705369, 3.08043331317429],
            [22.941538920103586, 3.081661608454909],
            [22.921834679773639, 3.080575489516279],
            [22.905598680245422, 3.077135356844553],
            [22.891659479760914, 3.067837674217362],
            [22.86720035961406, 3.032853738663531],
            [22.857884280348785, 3.020027879206871],
            [22.843965960304747, 3.016578011793213],
            [22.827750480094263, 3.018985792721688],
            [22.81154759965397, 3.024902274695905],
            [22.788424439624592, 3.040204560380181],
            [22.781520719579472, 3.054268762175167],
            [22.781619720211992, 3.082338294491166],
            [22.781702160402254, 3.10572959887447],
            [22.769577360060637, 3.118061495733417],
            [22.759747919661617, 3.123950966021202],
            [22.74989580039497, 3.123407839309815],
            [22.736558879884271, 3.120540310599657],
            [22.726123199737671, 3.11883011912255],
            [22.715724600249391, 3.12764595098376],
            [22.700678400450379, 3.132972808907195],
            [22.696043039685399, 3.132992424770273],
            [22.679848079690945, 3.141247921286978],
            [22.670600039723592, 3.147719786288824],
            [22.65960744003349, 3.15244458259074],
            [22.652654760008769, 3.152474095675608],
            [22.636431000026302, 3.152542660047736],
            [22.61267459958686, 3.152643255913486],
            [22.595296320309661, 3.153886401984382],
            [22.584297600397502, 3.156856773031963],
            [22.577358960142345, 3.16097975499629],
            [22.574490839764465, 3.169178880909427],
            [22.578584040306023, 3.179687817341323],
            [22.588514279764752, 3.202452668879598],
            [22.595498280450141, 3.211194899761215],
            [22.605968879908477, 3.22284641277587],
            [22.612979520133628, 3.239190872272126],
            [22.623462720260452, 3.254351063629749],
            [22.635970560442598, 3.268625555877993],
            [22.646140200026199, 3.277062038195546],
            [22.651378919641633, 3.283764964991585],
            [22.652858160148661, 3.292530594246494],
            [22.652900280355698, 3.304518522403982],
            [22.648582439907674, 3.312431463274027],
            [22.640202719578795, 3.318607320453642],
            [22.628630879905277, 3.32333454891454],
            [22.615918549926793, 3.33332979158915],
            [22.612187509683594, 3.343286967301688],
            [22.613114149746959, 3.35965713337095],
            [22.616624870081868, 3.369291444432826],
            [22.622149790251896, 3.375115919926006],
            [22.631455431093567, 3.385017972978466],
            [22.644242990485509, 3.396367319376597],
            [22.65471358994381, 3.408018784450382],
            [22.659675830572681, 3.418524086705439],
            [22.665796550270052, 3.429024415685672],
            [22.673650669919468, 3.438055341917309],
            [22.681497590470176, 3.445039595302668],
            [22.68759059085281, 3.447645501309006],
            [22.697736829323294, 3.449356922192364],
            [22.705280629551048, 3.45254138152098],
            [22.713708949635098, 3.460107867309036],
            [22.720981309526703, 3.46855670042332],
            [22.728833269626161, 3.477002938532658],
            [22.737550307344236, 3.484275815818976],
            [22.746840830437989, 3.489792141133568],
            [22.760186028924011, 3.494998655298132],
            [22.773237109104553, 3.499037093891521],
            [22.786871027919521, 3.503949972545408],
            [22.806907190357098, 3.517023028913654],
            [22.819692588402457, 3.527787582191845],
            [22.828736506882709, 3.545585336670332],
            [22.841803070425495, 3.554009638542351],
            [22.866445788250125, 3.558875994061602],
            [22.882101468918279, 3.562026075531803],
            [22.898616120457742, 3.562248590534151],
            [22.933559519608067, 3.565535191431503],
            [22.965410879821182, 3.575365963193849],
            [22.995052919831299, 3.580777051432775],
            [23.023613160067253, 3.590621866654962],
            [23.036809680187233, 3.599424387866511],
            [23.046726959651373, 3.611562721373755],
            [23.056675200450073, 3.63255920398964],
            [23.061494880239966, 3.634591159169245],
            [23.066848080256907, 3.634298336306458],
            [23.07568284039634, 3.634531083414429],
            [23.084253720421028, 3.635845728341893],
            [23.091226200212912, 3.639328473092298],
            [23.099025599885099, 3.64956240995939],
            [23.102277120327944, 3.660625928623056],
            [23.108487480212577, 3.67572947374738],
            [23.108900001862377, 3.676381466923954],
            [23.118716880220457, 3.691896961890359],
            [23.12328275989147, 3.696200520684115],
            [23.140312186512912, 3.700314128634334],
            [23.143036258441729, 3.704474931852872],
            [23.156265240082824, 3.713994019349746],
            [23.167009440325529, 3.717742992569173],
            [23.172546232630332, 3.720613360876959],
            [23.180940360139761, 3.724965003149931],
            [23.186866319693621, 3.72983509683469],
            [23.19075648031972, 3.731010036992124],
            [23.210669879888851, 3.75305916142659],
            [23.246414279828564, 3.77140107937564],
            [23.240619360220133, 3.782185023152436],
            [23.236704371956222, 3.78561414475865],
            [23.2430500801064, 3.792322867586809],
            [23.248275480401105, 3.790067565826852],
            [23.255357760371879, 3.785548312361586],
            [23.262442560117012, 3.781407230985326],
            [23.269545719629921, 3.78029116648032],
            [23.285246399605576, 3.77768443071019],
            [23.30238204033126, 3.764872379491798],
            [23.323238999732126, 3.748666502414031],
            [23.340682079880644, 3.724888747523285],
            [23.351834879728656, 3.712816897539555],
            [23.384630164489522, 3.697534267302664],
            [23.386537799877427, 3.696645299552212],
            [23.407284240447186, 3.688339064517523],
            [23.413862404745146, 3.689178940892671],
            [23.422392360220435, 3.690268014443627],
            [23.425098480216619, 3.697879995841603],
            [23.431760274972557, 3.705000563695073],
            [23.433977159888581, 3.70737010443231],
            [23.436797250043181, 3.708133060188787],
            [23.438324090480442, 3.708546136216935],
            [23.439212027528097, 3.708396310480371],
            [23.443598159700628, 3.707656068752567],
            [23.447903744433212, 3.709937675775014],
            [23.449308479568874, 3.710682068633098],
            [23.458877280076415, 3.719714142379514],
            [23.461925203648299, 3.724736274152131],
            [23.463644346438443, 3.72756893114836],
            [23.469120359629461, 3.731514147979127],
            [23.483558520355377, 3.730446037001458],
            [23.488582319835707, 3.733467101624476],
            [23.497455240408406, 3.744107105583934],
            [23.501300619119235, 3.745951754061632],
            [23.505224400093173, 3.747834008323874],
            [23.505586048351816, 3.74817536633632],
            [23.506471439573961, 3.749011081694968],
            [23.510965437852533, 3.753247004040727],
            [23.512701239899648, 3.754883119437669],
            [23.524139290782955, 3.765667314942594],
            [23.525590813771867, 3.768147285461356],
            [23.530493160127495, 3.776523042051053],
            [23.531483907562791, 3.783435522409008],
            [23.532474239976391, 3.790345050291588],
            [23.532108923896434, 3.794261415874328],
            [23.531744519606494, 3.798167992749799],
            [23.533071473214939, 3.806232063728091],
            [23.532121440123291, 3.812211020702072],
            [23.529110157933513, 3.818630207400339],
            [23.519724897611567, 3.81559155050076],
            [23.514435325266209, 3.816449083469417],
            [23.512399919800512, 3.816779945185323],
            [23.511099791683087, 3.816988109755487],
            [23.507342216104728, 3.81758973796605],
            [23.4911601532228, 3.814638087194383],
            [23.482620000072394, 3.813079958164697],
            [23.481679431630567, 3.813295065349018],
            [23.467010040058948, 3.816649929265725],
            [23.462501298629878, 3.817688149428359],
            [23.461059959841357, 3.818020043834658],
            [23.459962193411354, 3.818951314930793],
            [23.457830040287853, 3.820760087662951],
            [23.456739508889136, 3.824701794799322],
            [23.455730160039277, 3.828350054908771],
            [23.452059959995331, 3.828789910916508],
            [23.443840079599891, 3.82344995128756],
            [23.436097394164886, 3.822722042487037],
            [23.433308699231141, 3.822460972064962],
            [23.425504199823099, 3.82795227949816],
            [23.423664660327002, 3.828838154571537],
            [23.423640120150061, 3.828849972308524],
            [23.417983953422105, 3.830844958605728],
            [23.414000040121397, 3.832250121568352],
            [23.402310121395335, 3.833329940248182],
            [23.402819274820278, 3.824588844933183],
            [23.393061176824506, 3.807952264918308],
            [23.388030000379043, 3.807459903169564],
            [23.383469879807322, 3.80351998015641],
            [23.376830039876911, 3.802790042913132],
            [23.374365526267969, 3.799458762356744],
            [23.374100160339793, 3.799100066150241],
            [23.369745811460302, 3.797691928223775],
            [23.365599840285718, 3.801809959365411],
            [23.363506317414402, 3.808002863981158],
            [23.35798008031416, 3.812350029135799],
            [23.345583023067803, 3.816415889190727],
            [23.345570160091263, 3.816420107617231],
            [23.336581116996733, 3.826958545771388],
            [23.325140160063452, 3.824589877197001],
            [23.32168991970336, 3.828020073873712],
            [23.32341896911446, 3.833186344260166],
            [23.324159879797868, 3.835400120470411],
            [23.32095012023596, 3.836299963700244],
            [23.311580039645698, 3.831869970318701],
            [23.301028600794961, 3.834568844319053],
            [23.2989146753869, 3.832580396009224],
            [23.297830355838379, 3.831560435449832],
            [23.291501929477626, 3.832618142759959],
            [23.291181719604726, 3.832671690032526],
            [23.290637798683356, 3.833003361099067],
            [23.286711960567434, 3.835397244786247],
            [23.285512912682378, 3.836128938708652],
            [23.285201040073634, 3.836319252509086],
            [23.284062798251842, 3.836089820594338],
            [23.278110120106479, 3.834889956622782],
            [23.277847900078406, 3.834945589006822],
            [23.277120120069501, 3.835099992651867],
            [23.270062993825022, 3.836461389821432],
            [23.268930120335384, 3.836679933392867],
            [23.264368392677618, 3.839209743698916],
            [23.25536999991763, 3.844199985652856],
            [23.253980040271763, 3.846490029135322],
            [23.254650000217389, 3.849490003198005],
            [23.251889144972658, 3.851080313230781],
            [23.248689372880076, 3.849910470345276],
            [23.243954450035524, 3.853994480506198],
            [23.243387354376434, 3.85448272049968],
            [23.235046572421872, 3.857626589893791],
            [23.233738708013213, 3.858422432794343],
            [23.22638243738923, 3.862902013141086],
            [23.21514000004888, 3.865130046578873],
            [23.214685387836443, 3.865084153654126],
            [23.207810476762475, 3.864391719044432],
            [23.205356276711342, 3.861374358821263],
            [23.198029919986304, 3.85237002578885],
            [23.188640039628851, 3.851619990507554],
            [23.178369960311645, 3.845109890125632],
            [23.17299091486565, 3.844943833219254],
            [23.168979714339876, 3.844820402160037],
            [23.166325981396124, 3.847627507533816],
            [23.165520119822741, 3.848479942430291],
            [23.159652330675058, 3.847515516278346],
            [23.156820000076404, 3.847049995871657],
            [23.156186082336625, 3.847234660583568],
            [23.154519959911166, 3.847720014427181],
            [23.150377062771451, 3.852026471854521],
            [23.149450080449991, 3.852990049179434],
            [23.148749879618642, 3.855519948477683],
            [23.15318004001988, 3.87052008960603],
            [23.154810120239496, 3.876039925978484],
            [23.154482861286567, 3.876491209553027],
            [23.153649840048878, 3.877639928309185],
            [23.150440431728232, 3.87739001259427],
            [23.149473183322478, 3.876124116189128],
            [23.140900079967437, 3.864900058604341],
            [23.136893739327359, 3.866218200716418],
            [23.134700160303034, 3.866939918314845],
            [23.132469715317793, 3.865850220405268],
            [23.129439839798295, 3.864369953203116],
            [23.119210248449235, 3.866235803372006],
            [23.118426127004042, 3.866378824371039],
            [23.11517557494507, 3.86929634455322],
            [23.111295161938141, 3.872780239140946],
            [23.106478997255923, 3.872979225432639],
            [23.102020082680756, 3.86995395341809],
            [23.101687070018386, 3.869729608727275],
            [23.09891522837772, 3.869381339375435],
            [23.097790344504201, 3.869240002545473],
            [23.096911235200857, 3.867916648200598],
            [23.092570079877969, 3.861379922335689],
            [23.089148863186399, 3.859059459908215],
            [23.088970738943633, 3.858996627930054],
            [23.088470039563845, 3.858820009736993],
            [23.084513671304702, 3.857415360342618],
            [23.077259999964244, 3.854840046979012],
            [23.076032403619465, 3.855325550720309],
            [23.071520159659112, 3.857110100915691],
            [23.070195014359324, 3.859011831544009],
            [23.068969919822628, 3.860769974700945],
            [23.062820039912808, 3.855439928408156],
            [23.058470160151874, 3.854259945270264],
            [23.049489960073007, 3.861799980201054],
            [23.041239839690174, 3.861749990703163],
            [23.039636882303924, 3.861086828115993],
            [23.03277983961932, 3.858249980364531],
            [23.028367279011118, 3.859738938420734],
            [23.025430079984503, 3.860730054695503],
            [23.025219597526924, 3.860691633391548],
            [23.021539920256732, 3.860019946930287],
            [23.0131236861065, 3.850569606678618],
            [23.012669879682861, 3.850060038520141],
            [23.010613323383801, 3.85024806634902],
            [23.005559880397382, 3.850710093983468],
            [22.993040159995594, 3.838429984395617],
            [22.990060079888899, 3.838180029021678],
            [22.987069919786407, 3.840230023448025],
            [22.986348599562735, 3.845750523027425],
            [22.985608507244546, 3.84601025895112],
            [22.983130079630165, 3.846880063949829],
            [22.982291807739635, 3.848660005084088],
            [22.981509096649422, 3.850320039291067],
            [22.974622478730709, 3.851429706334051],
            [22.972980467087485, 3.857177993097739],
            [22.971468169476367, 3.858206993346927],
            [22.969299959774006, 3.859679908747376],
            [22.966169582537105, 3.859663886767669],
            [22.965400080274843, 3.859659948267775],
            [22.964359638936379, 3.858807463369011],
            [22.963129919872561, 3.857799891509491],
            [22.959451057374366, 3.858929735634465],
            [22.952910353722107, 3.854487424171287],
            [22.949189246151015, 3.851960114066629],
            [22.944102823315557, 3.85250385834025],
            [22.937029919959755, 3.85325996078477],
            [22.93553136208088, 3.852748320777072],
            [22.928799959568519, 3.850450071678049],
            [22.920653103222566, 3.844795839562082],
            [22.918079879989506, 3.843009916063848],
            [22.913489879654794, 3.844130034258312],
            [22.905116115156272, 3.837537679571432],
            [22.901410080417342, 3.834620039125354],
            [22.896371095815407, 3.835998137140282],
            [22.895669682258415, 3.836190258309411],
            [22.89515686191049, 3.837090856836136],
            [22.893580508131379, 3.839859193973817],
            [22.890340080085696, 3.845130029607804],
            [22.881830040260223, 3.850140059102386],
            [22.876130159713913, 3.845500105139095],
            [22.873602209774539, 3.845375375742737],
            [22.870860120336072, 3.845240081222115],
            [22.868828436590579, 3.843787674318968],
            [22.868579879937993, 3.84360998639948],
            [22.862086569603498, 3.847236812579295],
            [22.859610120079392, 3.848620024048266],
            [22.854570120381204, 3.849279970758863],
            [22.848999839780905, 3.859830058060775],
            [22.844180159990977, 3.861639941253308],
            [22.838000040093767, 3.85975992841226],
            [22.830160165928159, 3.85277217393611],
            [22.828889737910639, 3.851640266081005],
            [22.827029184125074, 3.855765108412386],
            [22.826310321692027, 3.859678807952452],
            [22.81397003976825, 3.855920049613003],
            [22.810722815069095, 3.860957978474653],
            [22.807873913248418, 3.862868649258071],
            [22.795763399713042, 3.870988154036313],
            [22.794588360202276, 3.875354105993283],
            [22.792228824615776, 3.878193756821757],
            [22.791355200425542, 3.879245142690362],
            [22.786460939805792, 3.881663324164129],
            [22.783998328828634, 3.882880062130878],
            [22.783085899214786, 3.884234892602481],
            [22.782146406954649, 3.88562999788545],
            [22.782171743038919, 3.885913993195904],
            [22.782709440432029, 3.89193912197601],
            [22.783281300755359, 3.89834312921684],
            [22.783853160180424, 3.904747086129437],
            [22.78503036552932, 3.906381184808014],
            [22.786352279589053, 3.908216152821243],
            [22.792196339738471, 3.908140094127369],
            [22.798040399887892, 3.908064034524275],
            [22.798778115263822, 3.90908895154674],
            [22.800537359746595, 3.911533087313406],
            [22.801861439644458, 3.919368025652247],
            [22.798536480130505, 3.936841106199369],
            [22.804422479925613, 3.94792912287082],
            [22.809580185875479, 3.965228041840623],
            [22.810052087063884, 3.96585707639934],
            [22.822075439762155, 3.981883033113083],
            [22.829380200089439, 3.98607507822659],
            [22.837045213591743, 3.987149295876053],
            [22.818287880216275, 4.011778655054778],
            [22.811734799576005, 4.018775192962263],
            [22.800287160075349, 4.020148568821879],
            [22.793397479799797, 4.02889773695838],
            [22.786831440063267, 4.033790146338977],
            [22.786310869051054, 4.033575726343735],
            [22.775695199759213, 4.029203187758875],
            [22.76007983997258, 4.030215183161848],
            [22.76086355987087, 4.044944972222665],
            [22.747499280269871, 4.073663971888195],
            [22.734316080368917, 4.075032938909716],
            [22.722215039568265, 4.083066738285657],
            [22.714349760148075, 4.102682141630654],
            [22.709830680008444, 4.101618825857368],
            [22.702744009970889, 4.093701551680953],
            [22.694102279819724, 4.084046845777624],
            [22.685451120053024, 4.088582973675599],
            [22.680267479740923, 4.09242678825483],
            [22.676546879717954, 4.108546265171165],
            [22.673505600085903, 4.122212929283161],
            [22.667610239845537, 4.123249792294028],
            [22.664130479946891, 4.121838306600078],
            [22.659248880182769, 4.1183196453582],
            [22.648459679734195, 4.113733894040577],
            [22.640849999758469, 4.118272727663773],
            [22.635334079809262, 4.124569777886068],
            [22.629106800156261, 4.128060009168227],
            [22.621475880413932, 4.129092370727217],
            [22.614864839573237, 4.126621207140871],
            [22.599907560410948, 4.121674363738158],
            [22.585329719743182, 4.121987688459322],
            [22.574942640250082, 4.126519282760611],
            [22.574246400090843, 4.126166772716806],
            [22.563865800145869, 4.131750295716698],
            [22.557634199596365, 4.134539255603007],
            [22.546883519805494, 4.136264757201836],
            [22.527057599975336, 4.129903086804661],
            [22.518355319780781, 4.12602404295946],
            [22.49892860856794, 4.11436018528264],
            [22.498249881065146, 4.114440865355443],
            [22.487910120329655, 4.115669943541314],
            [22.478532012393998, 4.118733673707791],
            [22.476890159752589, 4.119270048503637],
            [22.473251189639502, 4.118026516834886],
            [22.469339879976701, 4.116689917934083],
            [22.465531594500558, 4.116933153468349],
            [22.462919999730151, 4.117099956674733],
            [22.445221667785209, 4.124340651939396],
            [22.445240037434456, 4.124346903675145],
            [22.45588127996583, 4.127968151206372],
            [22.469879879751844, 4.143409934772199],
            [22.485219840326884, 4.152879994225586],
            [22.493689920393539, 4.159579952410672],
            [22.501460159853281, 4.170420053362037],
            [22.504219920051714, 4.171110114244502],
            [22.507485033801402, 4.176699814471235],
            [22.52045015958231, 4.189570059673692],
            [22.531679999847398, 4.195580021081298],
            [22.531679999847398, 4.196499952521821],
            [22.540600080175889, 4.20342996253082],
            [22.550439959896813, 4.215410078614099],
            [22.550579784467391, 4.217576737132108],
            [22.550929919917369, 4.218080109382782],
            [22.551314070075573, 4.219314307600516],
            [22.556099879786043, 4.23468999319248],
            [22.554690120372982, 4.238589880522693],
            [22.546140119890428, 4.248200040255158],
            [22.545200159608068, 4.251419934963287],
            [22.544449919920435, 4.261540003926876],
            [22.54620982376661, 4.2707593284125],
            [22.557971508002385, 4.294490095892382],
            [22.562190000169881, 4.298549974415788],
            [22.564919879706999, 4.30592008351756],
            [22.567711457334465, 4.316637402828913],
            [22.567719959888656, 4.316670045093865],
            [22.569249959700777, 4.320869992927824],
            [22.570118792277256, 4.322549369217248],
            [22.57119000001591, 4.324619913712261],
            [22.574959920242918, 4.328729960608132],
            [22.580690039878323, 4.330820019944873],
            [22.585039919639257, 4.334510046267739],
            [22.598330039720274, 4.341449936579886],
            [22.608629999698799, 4.348139967229608],
            [22.619409839702119, 4.350470061109598],
            [22.621920119779819, 4.358070041149429],
            [22.623500160244848, 4.372120033544427],
            [22.622986861993198, 4.372931800826922],
            [22.622950079575581, 4.372989972303729],
            [22.622767022683586, 4.373274842322952],
            [22.620039839888957, 4.377639933577527],
            [22.614825964081014, 4.379425548115343],
            [22.606520696122871, 4.382269874203058],
            [22.60652046256093, 4.382269903958827],
            [22.606519908300385, 4.382270094215473],
            [22.60242118850973, 4.382795084246218],
            [22.601679840346765, 4.382890062814222],
            [22.589970120056915, 4.389309991976988],
            [22.588480539940999, 4.39290894900213],
            [22.588292669875727, 4.394634360481138],
            [22.587739920311716, 4.399720020541377],
            [22.585889880408285, 4.401490021492351],
            [22.586730119609285, 4.406109973204596],
            [22.593269880030494, 4.416509880654962],
            [22.594022660153751, 4.416901315810661],
            [22.594269960063269, 4.417029907902577],
            [22.598046775758363, 4.421324053362124],
            [22.598139959799443, 4.42143000083511],
            [22.599390604219451, 4.431440113518219],
            [22.600959839748224, 4.44400002714548],
            [22.599081802052321, 4.450498240644215],
            [22.597350119679128, 4.456489994301149],
            [22.597170119754061, 4.458400009887415],
            [22.598548754339156, 4.462651681779543],
            [22.599439919931907, 4.465400000402397],
            [22.598140117902933, 4.468220584995147],
            [22.599209880252289, 4.471739966224913],
            [22.602639959722456, 4.474970030041837],
            [22.609749827853889, 4.475440056502221],
            [22.609749959906228, 4.475440065517987],
            [22.614339960240944, 4.480520057800623],
            [22.623260039671102, 4.484449916273261],
            [22.627159785321265, 4.484689953122755],
            [22.627919745678589, 4.484559872805335],
            [22.648039782915887, 4.481569896993221],
            [22.648039782915887, 4.48157022516382],
            [22.648039920358144, 4.481570204427748],
            [22.648039920358144, 4.481970027880353],
            [22.651009782128458, 4.481699982357787],
            [22.662729940841942, 4.480619951621827],
            [22.669159900185996, 4.472809942313993],
            [22.672059698754055, 4.467019984000703],
            [22.681029817938796, 4.461740092335713],
            [22.688219743928357, 4.461339950252902],
            [22.68821987957395, 4.461339949351304],
            [22.692120120195845, 4.464800049434522],
            [22.698979919810078, 4.471720021476195],
            [22.707200160429917, 4.491310048573293],
            [22.706799839698295, 4.505039997803247],
            [22.708562851715325, 4.515168396994077],
            [22.709429999950682, 4.520150059299489],
            [22.715176721350879, 4.528223123673],
            [22.715391722334324, 4.528525358083073],
            [22.719039692668261, 4.533650022709202],
            [22.719038271533456, 4.533651422741906],
            [22.719038334415554, 4.533651511089127],
            [22.718401652559603, 4.534281986198984],
            [22.721559839841049, 4.538530003493889],
            [22.72797000031624, 4.544979994427828],
            [22.73027003958315, 4.546140055838582],
            [22.730749859420804, 4.547540369125866],
            [22.730758273041751, 4.547564923759814],
            [22.732779960334778, 4.551699951501097],
            [22.732829099977433, 4.552770141735257],
            [22.732869959848145, 4.553660017006187],
            [22.733690039955849, 4.556040115286723],
            [22.734110160454666, 4.577679990788765],
            [22.734079919568941, 4.591719963932079],
            [22.7342699815235, 4.594779766931397],
            [22.735689839796962, 4.596830026404676],
            [22.738979879999178, 4.619180027299815],
            [22.741143640345914, 4.62470874313278],
            [22.742600040288508, 4.628430027885378],
            [22.758519960397475, 4.646790086143512],
            [22.762410120125242, 4.650710039955603],
            [22.769039880059825, 4.668220048961496],
            [22.777699935842776, 4.681429794322479],
            [22.778030004725959, 4.680440033833874],
            [22.782168741767581, 4.6896671339738],
            [22.782885842604355, 4.691265519035166],
            [22.782999411215837, 4.691518711102816],
            [22.782999351927028, 4.691518920204198],
            [22.782999804677935, 4.691519928757795],
            [22.782980847530485, 4.69158407871288],
            [22.782976959621951, 4.691597768542343],
            [22.782010639175894, 4.694867760698539],
            [22.783339877200092, 4.7044279329619],
            [22.783353272877608, 4.704448441636154],
            [22.790509919879163, 4.714530031561813],
            [22.801970160048338, 4.722610010586211],
            [22.809080160232146, 4.725150105732254],
            [22.813711014149327, 4.72991302648912],
            [22.819041341262501, 4.735395328544996],
            [22.824592397915712, 4.734884169487469],
            [22.826752397016371, 4.73331311354773],
            [22.831497196837475, 4.728595790913038],
            [22.841487556046584, 4.715965515206143],
            [22.843631354929425, 4.711723160072591],
            [22.845649154313843, 4.708181108391861],
            [22.851831793985443, 4.704452593842735],
            [22.854430992903239, 4.70371472011346],
            [22.859742792263678, 4.703093239202906],
            [22.859742821908082, 4.703093261734999],
            [22.859742960248639, 4.703093245511893],
            [22.859930856365061, 4.703238566704609],
            [22.865789879752164, 4.70776996994863],
            [22.870130039741738, 4.713069931207733],
            [22.870890000099063, 4.714705066963019],
            [22.873669920289093, 4.716969931437905],
            [22.873997519703522, 4.72112873161482],
            [22.874030114175302, 4.721540466792499],
            [22.874479920401004, 4.722509965508856],
            [22.874259959818851, 4.724379923525194],
            [22.875053366250807, 4.734401032386325],
            [22.875150168705829, 4.735620760516024],
            [22.876559999984089, 4.739140038317918],
            [22.888199879853897, 4.746009889177118],
            [22.90080995999346, 4.75341004737867],
            [22.902630120133939, 4.757089980770714],
            [22.902300000046822, 4.758599916733977],
            [22.902898983203514, 4.759003189454801],
            [22.904349839642485, 4.759979995976808],
            [22.903880101597288, 4.762279699449813],
            [22.903879886899915, 4.762279885999408],
            [22.903879864442054, 4.762279994144081],
            [22.903342833598888, 4.762746375177265],
            [22.90239330805537, 4.763571140503161],
            [22.890729959698788, 4.773699990972869],
            [22.890222862517536, 4.77554931083046],
            [22.889090159707781, 4.779680120177821],
            [22.892385421816755, 4.794019282145704],
            [22.894440120399818, 4.802960038815546],
            [22.897813670685771, 4.809493391657599],
            [22.906670039799351, 4.817870013830673],
            [22.911479936037523, 4.819249952961051],
            [22.922499782528522, 4.818130050600669],
            [22.935359700318301, 4.81447002516438],
            [22.93535983237064, 4.814470045890528],
            [22.935359879981355, 4.814470032373489],
            [22.941320040194743, 4.815399946500675],
            [22.946235298035916, 4.820176028865228],
            [22.946259960383731, 4.820199992573006],
            [22.95461016027576, 4.82636001308002],
            [22.963410455650951, 4.83680999881855],
            [22.967210160419523, 4.837769936473334],
            [22.969606766782881, 4.840680429050741],
            [22.974784835743584, 4.846968746754635],
            [22.979272132590175, 4.842777053059634],
            [22.982362372201834, 4.837180716440844],
            [22.988187170674959, 4.824585510591814],
            [22.996431529263539, 4.810244808231707],
            [23.003663927599764, 4.800805455074117],
            [23.014696125925919, 4.78822285747071],
            [23.032264482429024, 4.765848165700134],
            [23.048874518881991, 4.757132718977023],
            [23.063077595887918, 4.75226451241342],
            [23.073085234191531, 4.742481119010464],
            [23.079983553565135, 4.735141909340451],
            [23.091724951146865, 4.725012155140913],
            [23.10623690757507, 4.713838501142722],
            [23.11334978596101, 4.707910063643554],
            [23.113349901843701, 4.707910153771287],
            [23.113349999760054, 4.707910071755061],
            [23.120198618043943, 4.713221020222973],
            [23.12021015959872, 4.713229969839701],
            [23.123250000129687, 4.714410048332988],
            [23.124545847774808, 4.715679856779932],
            [23.125250160195204, 4.716370015416578],
            [23.142929899708719, 4.724350009039033],
            [23.142929899708719, 4.723430119025299],
            [23.142930119795974, 4.723430274041539],
            [23.142930119795974, 4.723430127136617],
            [23.15140991963402, 4.729429916514265],
            [23.159430000337199, 4.73612007582184],
            [23.171589896958647, 4.738209987837921],
            [23.174499733301705, 4.736640039065908],
            [23.188296371150614, 4.735768569442128],
            [23.197296729424451, 4.731587584886374],
            [23.20281912712516, 4.726346858502549],
            [23.207988006320527, 4.720053911324274],
            [23.214866884354745, 4.709561466197735],
            [23.217955323742586, 4.703613412285837],
            [23.232797400257908, 4.689637484760734],
            [23.242155597933596, 4.687208804655441],
            [23.253605035861476, 4.686187106565757],
            [23.258803794819794, 4.684798974962007],
            [23.269196991839994, 4.681321808999511],
            [23.274368031483611, 4.675379079599563],
            [23.279541229778854, 4.669786394595168],
            [23.284013508590505, 4.663141036310273],
            [23.286028428874495, 4.651934405028681],
            [23.291212066491639, 4.648093496191168],
            [23.297799345096447, 4.646708881962013],
            [23.306458782838494, 4.643577680217966],
            [23.315071781273598, 4.632737912699414],
            [23.32299213909879, 4.622246658467073],
            [23.333381017019079, 4.618068579193548],
            [23.339966135175633, 4.61633342445414],
            [23.339966319330269, 4.616333456003017],
            [23.339966400178643, 4.616333434369494],
            [23.350391640104977, 4.618112062456014],
            [23.363939159854244, 4.61954811190578],
            [23.372276934249253, 4.620620540950828],
            [23.383374924288528, 4.61889690333005],
            [23.389947082450458, 4.615059405578249],
            [23.398229960798446, 4.607021645547141],
            [23.412744075878244, 4.596196402423412],
            [23.41274436064419, 4.596196413240504],
            [23.429699712187308, 4.597019898228297],
            [23.429699999648214, 4.597019912651057],
            [23.430972423722285, 4.599459506281169],
            [23.4317483462439, 4.600947162154548],
            [23.431748274378666, 4.6009475668905],
            [23.431749551783003, 4.600950016038771],
            [23.429757998476212, 4.612183684223809],
            [23.429420593052139, 4.614088490842842],
            [23.427470160127452, 4.625090003983725],
            [23.428069801749277, 4.640746960644866],
            [23.430089880159603, 4.647889981791445],
            [23.433860159712719, 4.651939983487416],
            [23.433874788777114, 4.651948880718971],
            [23.44952988015044, 4.661469950977031],
            [23.457319920275669, 4.66953007506487],
            [23.464889963886129, 4.673459941108118],
            [23.496549534684434, 4.672569897984038],
            [23.4965496379907, 4.672569915109213],
            [23.496549840111612, 4.672569909701252],
            [23.500680120413161, 4.673269915237448],
            [23.52635999982715, 4.691249963509363],
            [23.537754564165901, 4.69532705939445],
            [23.5372545286411, 4.694982580218787],
            [23.536799683764983, 4.694669947225597],
            [23.532599564839987, 4.69175001864347],
            [23.536729844243208, 4.691089907142076],
            [23.536729914311817, 4.691089959417456],
            [23.536730160450183, 4.69108991976029],
            [23.555774132758124, 4.705044050942851],
            [23.567109840377778, 4.713349953274994],
            [23.571322543801578, 4.715497059009994],
            [23.578999919918804, 4.719410001977994],
            [23.581922382981496, 4.723686742935419],
            [23.583099960232925, 4.725410005958735],
            [23.586364349042192, 4.727007940094748],
            [23.588819954956779, 4.728209968240006],
            [23.595239546844134, 4.728009888721213],
            [23.60491958393666, 4.720010081169435],
            [23.607679703461201, 4.719799932157303],
            [23.609719449586343, 4.721947423246844],
            [23.611131311955475, 4.723433517665959],
            [23.619989880144846, 4.732759917070773],
            [23.623834766578931, 4.733183300136098],
            [23.624348139390772, 4.733239830681389],
            [23.626502773752563, 4.731099614769001],
            [23.629419736430766, 4.728200097740729],
            [23.630629696151566, 4.728000010107755],
            [23.634699494681634, 4.727309938000021],
            [23.63469974531159, 4.727309967741337],
            [23.63469983963472, 4.72730995151879],
            [23.641976372200812, 4.728165560004545],
            [23.64294996001755, 4.728280038686909],
            [23.645098497513473, 4.729500821392794],
            [23.648669999657159, 4.73153011780929],
            [23.654827367024851, 4.742078517828737],
            [23.660939879713808, 4.752549914908487],
            [23.66939882785746, 4.758119320750811],
            [23.669399115318367, 4.758119730801928],
            [23.669399524051812, 4.758119999362902],
            [23.66951107145389, 4.758279204626569],
            [23.669686856483647, 4.758529598868137],
            [23.671669396094895, 4.761359153183708],
            [23.677499880005414, 4.763900023126282],
            [23.690339999824626, 4.771509940208472],
            [23.709149999628622, 4.782350030630154],
            [23.723609989415937, 4.785119942083714],
            [23.72887978535033, 4.784899945315114],
            [23.743199500511057, 4.781999979248664],
            [23.743199781683746, 4.782000014394697],
            [23.74319987960013, 4.781999994568747],
            [23.761659615495031, 4.784287084308464],
            [23.766503159928785, 4.784887179260597],
            [23.780279488665748, 4.783550089166812],
            [23.780279534479831, 4.78355013783038],
            [23.780279880331214, 4.783550104486818],
            [23.795439840082857, 4.799580096640327],
            [23.803549920299439, 4.808150065805441],
            [23.806419840002839, 4.811200057466598],
            [23.815829880351885, 4.819029975457898],
            [23.833489884776899, 4.829399953791399],
            [23.834069589189316, 4.829229960936441],
            [23.830999510467546, 4.822979993133597],
            [23.833089670046466, 4.818619959396053],
            [23.840889426349801, 4.817500044269129],
            [23.848105354075276, 4.814009963493463],
            [23.849470700780639, 4.813348521615891],
            [23.851169582967881, 4.810769921351865],
            [23.856219661763568, 4.810769921351865],
            [23.856219703086069, 4.810769938473567],
            [23.856220080378481, 4.810769938473567],
            [23.870210040168114, 4.816529921780784],
            [23.873048585311889, 4.821217582928674],
            [23.874196577447776, 4.821611525811261],
            [23.875509960207239, 4.822059982976598],
            [23.877326659138898, 4.823689379714337],
            [23.883270119671145, 4.82902004136834],
            [23.883850743958426, 4.83038058356781],
            [23.884660080215344, 4.831040018077034],
            [23.892230159758423, 4.832660053839909],
            [23.904168854325999, 4.837260008316359],
            [23.905074157604705, 4.837608818926737],
            [23.917394438538704, 4.837114978085657],
            [23.922935917354327, 4.835027496070729],
            [23.922936503954229, 4.835027133825143],
            [23.931409233152657, 4.829794935353225],
            [23.936932710628344, 4.824729887521586],
            [23.949209425965975, 4.809530025813463],
            [23.952439704845585, 4.807740041297825],
            [23.952440134240298, 4.807740073739062],
            [23.952440160291449, 4.807740059320743],
            [23.958860039639671, 4.808229984707758],
            [23.96159876219248, 4.811008794878829],
            [23.961598774768873, 4.811009254460596],
            [23.961599541031834, 4.81101003304621],
            [23.961605803187663, 4.811265471250645],
            [23.961610115101031, 4.811422635522985],
            [23.9616399598297, 4.812640012622171],
            [23.962380120419869, 4.836789950110133],
            [23.961890400249469, 4.83827408005414],
            [23.959119959980608, 4.846670026474153],
            [23.958609618982869, 4.852423130859219],
            [23.957650440143308, 4.863235878532848],
            [23.959689840417099, 4.869230036937459],
            [23.959929266593125, 4.869546875549569],
            [23.96538000029372, 4.876759925646406],
            [23.96557618696189, 4.876893729142434],
            [23.972165601760427, 4.881387833874101],
            [23.980842974367128, 4.881234846217916],
            [23.980843074080106, 4.881234871447183],
            [23.980843439694425, 4.881234865139863],
            [23.98223398055028, 4.881588585911652],
            [23.988827410818143, 4.881255317078251],
            [23.995059009571051, 4.878469078403043],
            [24.008267762948574, 4.869492016205541],
            [24.009463103486443, 4.869842257037189],
            [24.009818597387074, 4.869946298076183],
            [24.010616160323863, 4.870179987354854],
            [24.013694519715909, 4.871602036503736],
            [24.018169320098579, 4.873670009516166],
            [24.031624319661788, 4.874965990984204],
            [24.040872359629137, 4.875857033146094],
            [24.049797480404642, 4.880275054185769],
            [24.055507440048487, 4.885137123729463],
            [24.070125239576704, 4.898330038429141],
            [24.070143074728342, 4.898341591340131],
            [24.084228239768425, 4.907465084128115],
            [24.09034931969023, 4.910050986027135],
            [24.091686359582688, 4.910523059213716],
            [24.092590380067175, 4.910842176495553],
            [24.095981160040289, 4.912039113375982],
            [24.100682094227764, 4.912752724214696],
            [24.105381212920005, 4.913466059473678],
            [24.116625918506429, 4.912601124165679],
            [24.131373671018622, 4.900017046012046],
            [24.136204869007098, 4.89750903608647],
            [24.159611698138544, 4.896243085808941],
            [24.159611895767906, 4.89624313716738],
            [24.159612271263725, 4.896243116443776],
            [24.160337626719663, 4.89642869431104],
            [24.163192440353239, 4.897159081104794],
            [24.165442498256073, 4.897735393916139],
            [24.168779279599168, 4.898590050958857],
            [24.173349480166689, 4.902295043798595],
            [24.18198948016261, 4.918218033242129],
            [24.182001319958054, 4.918233871838889],
            [24.190349399826001, 4.929401028982687],
            [24.191290439883343, 4.930493102302289],
            [24.192624163195781, 4.931658606124848],
            [24.192829439916309, 4.931837992398298],
            [24.196819319827139, 4.935322121927682],
            [24.209000856863767, 4.943323466055553],
            [24.215076359861335, 4.947314074224083],
            [24.218366715372202, 4.949475414704111],
            [24.229295280453943, 4.956654023787392],
            [24.232651972056999, 4.957866651519955],
            [24.235049667178469, 4.958733008180081],
            [24.235050873615872, 4.958733444234827],
            [24.236322394883093, 4.959544014538532],
            [24.24805357682343, 4.958813096295527],
            [24.252013935399077, 4.956072971523874],
            [24.253390934152023, 4.951994994224454],
            [24.25322857444419, 4.951351119092877],
            [24.250474935366107, 4.940401022825537],
            [24.252803774621064, 4.934903012219064],
            [24.258099731293157, 4.93440007300689],
            [24.258742691474591, 4.93433902306638],
            [24.258743010376527, 4.934339072619906],
            [24.258743237650293, 4.934339050996549],
            [24.275110234903142, 4.936876000984648],
            [24.275799275065385, 4.93720405117763],
            [24.280069234410448, 4.939239139330614],
            [24.281338790163851, 4.941599750048529],
            [24.282434434773148, 4.943636983227246],
            [24.28439296870506, 4.95024251930845],
            [24.282352558724899, 4.958318190253007],
            [24.279848178781968, 4.962171493460304],
            [24.27741027506838, 4.965922015648167],
            [24.274061784185559, 4.97107563870834],
            [24.273275361256605, 4.972286007094242],
            [24.273353074511835, 4.974625028391604],
            [24.273475114236447, 4.978269981900175],
            [24.274152275077405, 4.980575156104516],
            [24.274506144824016, 4.980790177890627],
            [24.27503990220626, 4.981114706849435],
            [24.299051312795307, 5.003939022582012],
            [24.317059161068002, 5.006694627580854],
            [24.31853883186804, 5.006921050239947],
            [24.31859960649027, 5.006930381478379],
            [24.319228866465334, 5.007026998255548],
            [24.322441780910516, 5.005262552443124],
            [24.325440579212763, 5.003603084645468],
            [24.329644657013201, 5.003496080239722],
            [24.333012814712543, 5.003409004127979],
            [24.333012897357541, 5.003409038361332],
            [24.333013351006741, 5.003409026649893],
            [24.337827355240712, 5.005423482918006],
            [24.348587187067675, 5.009925993023205],
            [24.34912460688135, 5.009890114135811],
            [24.350102725800387, 5.009825121878005],
            [24.355012763531459, 5.009496031807873],
            [24.362826559604361, 5.006771023402291],
            [24.3628270024738, 5.006771083760746],
            [24.362827108475024, 5.006771046824965],
            [24.373938687329595, 5.008278080072351],
            [24.376665420966575, 5.009317473238169],
            [24.380952594727418, 5.010951680446203],
            [24.380977227430829, 5.010961070182669],
            [24.381655473436648, 5.011756949624398],
            [24.381687147135274, 5.011794116646016],
            [24.391880186933701, 5.022600099649953],
            [24.405182286049047, 5.026994746905484],
            [24.405194395339084, 5.026998747556051],
            [24.411044373589583, 5.031783478082413],
            [24.41236764949528, 5.036284222825265],
            [24.412386144908652, 5.036347129687855],
            [24.412476697784268, 5.036673840440536],
            [24.412481184869101, 5.0366900301743],
            [24.411477070502396, 5.039288322207861],
            [24.409462224778601, 5.044501996570351],
            [24.402775225990734, 5.051375133988266],
            [24.39907838550873, 5.052917069815566],
            [24.397712185403826, 5.053488135964112],
            [24.397711684143911, 5.053488085518899],
            [24.397711621261816, 5.053488111642308],
            [24.396713068365042, 5.053387483350535],
            [24.391714438780649, 5.053212731185026],
            [24.390146059346307, 5.053157987297244],
            [24.390145505085798, 5.053157966578652],
            [24.384348610980346, 5.050513567822681],
            [24.374344059288063, 5.045950115263996],
            [24.368850268437587, 5.046183081149257],
            [24.368450428304612, 5.046369015278568],
            [24.363086308367087, 5.04934901567259],
            [24.362199848149764, 5.050464792481349],
            [24.361873108423062, 5.050876055168204],
            [24.359623108910704, 5.053706078148431],
            [24.357300388979478, 5.059910037387437],
            [24.357846923998334, 5.063884242438091],
            [24.357965309376386, 5.064745091559328],
            [24.358675229080799, 5.065519006050707],
            [24.359253647105703, 5.066149735532854],
            [24.360933148140699, 5.0679811270349],
            [24.361187308484016, 5.068055088838423],
            [24.370378108699782, 5.070705156540074],
            [24.372171268177738, 5.071221992295158],
            [24.37605121495907, 5.073804998273134],
            [24.376154997323841, 5.073997077577157],
            [24.376775307383721, 5.075146087797323],
            [24.379919074908226, 5.080957925895861],
            [24.382166307609488, 5.096831126971384],
            [24.382698167749862, 5.09774018709498],
            [24.382709187383458, 5.097759022567073],
            [24.38863514693735, 5.107219292151971],
            [24.389656106512263, 5.108849149674172],
            [24.389697907817364, 5.108874561037201],
            [24.39581821878129, 5.112595115122041],
            [24.401416471122907, 5.112767312726041],
            [24.401507820804149, 5.112770122982799],
            [24.401508385844455, 5.112770140096512],
            [24.402947819306267, 5.112823971822712],
            [24.405003779123987, 5.111751051016774],
            [24.407296617495597, 5.110554092963227],
            [24.410788615143364, 5.104575014503965],
            [24.430943563607563, 5.063472082826585],
            [24.435952600174563, 5.059399988995953],
            [24.43595362155903, 5.059400088083831],
            [24.435953656593316, 5.059400059258247],
            [24.442798235153393, 5.060064785501376],
            [24.442894342312361, 5.060074119570603],
            [24.443176221970415, 5.060300137862549],
            [24.445486342131481, 5.062147059647391],
            [24.447237382300727, 5.063547146822923],
            [24.447271025106424, 5.063697536919896],
            [24.447434122331106, 5.064426620271441],
            [24.44858738218781, 5.06953702365959],
            [24.447744262089682, 5.072853996920043],
            [24.447418101776339, 5.074135040775771],
            [24.439869221575634, 5.085104620912649],
            [24.43794614324969, 5.087899093013529],
            [24.437715789159686, 5.088972264992374],
            [24.437008343415584, 5.092268098912477],
            [24.438822383334038, 5.097109009750379],
            [24.439100303218318, 5.097242028242816],
            [24.452816737682035, 5.103793047254785],
            [24.454391301118761, 5.104545038043195],
            [24.461533826604047, 5.104578065293339],
            [24.467242703777956, 5.104603017453086],
            [24.475070539620461, 5.09888507130345],
            [24.475071140593386, 5.098885096524282],
            [24.483719423056215, 5.099302069269926],
            [24.485625736124025, 5.099393981926431],
            [24.494376607988944, 5.092759040344745],
            [24.534362503255622, 5.080511110330236],
            [24.539200541016669, 5.075930013489359],
            [24.543843457511507, 5.06444310926666],
            [24.545029655894712, 5.055472024965077],
            [24.548272534544513, 5.049043076937132],
            [24.565310603857327, 5.036230048617917],
            [24.59194842692737, 5.031515064389009],
            [24.591949089884064, 5.031515092314993],
            [24.603298962139082, 5.031845435002248],
            [24.610533414922337, 5.032055996779834],
            [24.613999132356486, 5.030000005895545],
            [24.617678690150733, 5.024953021863118],
            [24.622999125914301, 5.014000037746055],
            [24.62926744150781, 4.984843959278724],
            [24.629999320529336, 4.98199998852605],
            [24.632999198606562, 4.975000070347339],
            [24.651999265754995, 4.973999997624582],
            [24.659676620312656, 4.970820047855422],
            [24.672307572807878, 4.968573011825368],
            [24.672307779420379, 4.968573130747593],
            [24.672308186357228, 4.968573058673552],
            [24.673909645353554, 4.969499678354364],
            [24.675999009923441, 4.95999991264834],
            [24.672999131846215, 4.949999975971925],
            [24.667999094601736, 4.937000043778127],
            [24.657999021011147, 4.928000078399265],
            [24.655999222966667, 4.924000034504822],
            [24.657999021011147, 4.918999989505304],
            [24.661999338447252, 4.916999852188384],
            [24.667999094601736, 4.915999871797576],
            [24.667999366791292, 4.915999974511401],
            [24.667999802474185, 4.91599990153052],
            [24.67599972138914, 4.919000018337147],
            [24.693163106582382, 4.921020079496895],
            [24.705541341428592, 4.923605015382096],
            [24.720912578646843, 4.923901095269246],
            [24.725051495351519, 4.921616010313129],
            [24.727378533484323, 4.915624046348517],
            [24.729691530949228, 4.909668120314427],
            [24.734753488167904, 4.906237005372459],
            [24.734754178074041, 4.906237164851526],
            [24.734754360432053, 4.90623704141294],
            [24.748963973580029, 4.909519046880136],
            [24.759749350798721, 4.908873009950413],
            [24.759749479257806, 4.908873092843161],
            [24.759750240130849, 4.908873046891779],
            [24.764099400341237, 4.911654129657768],
            [24.767862452947906, 4.916878228393998],
            [24.772081319712854, 4.922735066801088],
            [24.777356640286229, 4.923216930029016],
            [24.780577495838521, 4.921159027686425],
            [24.781052335416266, 4.917249081426461],
            [24.779013296265205, 4.911025081474724],
            [24.779944615652887, 4.908038037076072],
            [24.78454325239073, 4.905525030016996],
            [24.784543968348014, 4.905525171476008],
            [24.784544159689162, 4.905525066958553],
            [24.786964440253492, 4.906005043463582],
            [24.788921064367109, 4.90639381743675],
            [24.791650200099198, 4.906936086494189],
            [24.797517335273326, 4.91017787386203],
            [24.799204439648857, 4.91111005256532],
            [24.80446044015542, 4.916424031961006],
            [24.8112852315247, 4.930262908567458],
            [24.812708519565913, 4.93165449947222],
            [24.818140439849532, 4.936965064536236],
            [24.820545317899995, 4.9381265475343],
            [24.822948146893346, 4.939287039209957],
            [24.842221330634217, 4.939134960572216],
            [24.873206506504324, 4.936499973063998],
            [24.87320690715293, 4.936500062260046],
            [24.873207480278079, 4.936500013607635],
            [24.878481425530765, 4.93767214597894],
            [24.880003166232168, 4.93895484561365],
            [24.883968240064746, 4.942297149247016],
            [24.886231380133083, 4.950131173433414],
            [24.888494520201412, 4.957965103614562],
            [24.889030145181124, 4.958832877321541],
            [24.890773495771548, 4.961657011739742],
            [24.907519520090524, 4.962185036312022],
            [24.907520519915462, 4.96218506784474],
            [24.912184180306802, 4.962662306334743],
            [24.919217504789522, 4.963382035174083],
            [24.92840418443307, 4.96065705724791],
            [24.928405345954747, 4.960657163558459],
            [24.928405476210465, 4.960657124818184],
            [24.929823026711947, 4.960786359697491],
            [24.933681360027517, 4.961138114124325],
            [24.939403303197206, 4.964613242905112],
            [24.944425200045789, 4.97107701351604],
            [24.946116840015193, 4.975445793487097],
            [24.946924402099448, 4.97753133053794],
            [24.947529792040772, 4.978814684173126],
            [24.949426319760168, 4.982835080415704],
            [24.950963887878562, 4.984206151819514],
            [24.953314319938013, 4.986302060715889],
            [24.969126554502292, 4.989879358859351],
            [24.98334497922486, 4.993096063475804],
            [24.999999125653208, 4.993159975445376],
            [25.000325285966582, 4.993161950200189],
            [25.010623076513681, 4.989317070459939],
            [25.017115311564783, 4.982410055277578],
            [25.019450268346805, 4.972521960908649],
            [25.022677306104885, 4.968622017689678],
            [25.027735301753157, 4.965879959351916],
            [25.046551405609502, 4.965721956991307],
            [25.061038151717565, 4.957723021728278],
            [25.073020021114338, 4.944649088007267],
            [25.08221909211888, 4.938930977199756],
            [25.08841828684286, 4.937803006249663],
            [25.088418568015548, 4.937803212571444],
            [25.088419440279697, 4.937803054000997],
            [25.090936336449452, 4.939653436006059],
            [25.091791427497068, 4.942259799856552],
            [25.097967398974316, 4.961084216513431],
            [25.100215776129247, 4.969673351377772],
            [25.100681399890473, 4.971452087249917],
            [25.106624280111028, 4.977458082661517],
            [25.109042279852893, 4.984672424553806],
            [25.110254160171753, 4.98828816042478],
            [25.113192942029887, 4.990640526645487],
            [25.11574343968287, 4.992682081902427],
            [25.133625360322416, 4.997122116047831],
            [25.135200360340399, 4.998740126493903],
            [25.135791295490499, 4.999347017540156],
            [25.136427239829562, 5.000000132287215],
            [25.140216463953696, 5.003892371577577],
            [25.147567439907419, 5.01144312752135],
            [25.149133439704553, 5.022265992959546],
            [25.150905910083221, 5.024885284441289],
            [25.152099480041677, 5.026649091863388],
            [25.154159340344361, 5.028268058766665],
            [25.160584183782845, 5.028291931099142],
            [25.163571100967179, 5.026922107302256],
            [25.166569177023963, 5.022791075463964],
            [25.167285216950397, 5.015658024808199],
            [25.179946043818692, 5.004888011782488],
            [25.18385203994659, 5.003292099044479],
            [25.183853215841324, 5.003292177420852],
            [25.183853279621687, 5.003292151295395],
            [25.19119440015842, 5.003779057477305],
            [25.193652914817878, 5.005376858146151],
            [25.194399480396015, 5.005862053797918],
            [25.196937194124175, 5.012110695226268],
            [25.197582240193732, 5.013698990974466],
            [25.20169847084421, 5.017396139826308],
            [25.204294411572494, 5.017482000594113],
            [25.209498056467663, 5.017654096852156],
            [25.223509241650813, 5.01402210077466],
            [25.223510519953482, 5.014022153925558],
            [25.231311153910848, 5.014281001453463],
            [25.231312440298325, 5.014281043793973],
            [25.237585439707733, 5.018300999676912],
            [25.247566323487224, 5.024696967650772],
            [25.253717399952976, 5.026172076231416],
            [25.257414328469896, 5.02705814653907],
            [25.259258108912455, 5.027500059233943],
            [25.280785705588656, 5.029343811849142],
            [25.284490199716895, 5.02966108535404],
            [25.298791618890238, 5.032464248069986],
            [25.302545279610616, 5.033199985439942],
            [25.317970286388498, 5.036223142842966],
            [25.324229196620994, 5.040850600745058],
            [25.327354319611775, 5.04316111474997],
            [25.328945159623142, 5.047539043504154],
            [25.329279055329426, 5.048457736119277],
            [25.33053635985895, 5.051917122482043],
            [25.329215278537497, 5.062321907555829],
            [25.327703159691101, 5.074231087141081],
            [25.328181708412632, 5.076241209773088],
            [25.329107520229272, 5.080130028121479],
            [25.329397217925266, 5.081350726599711],
            [25.329511439611935, 5.08183202204662],
            [25.335899279647251, 5.092441153254834],
            [25.348699439707708, 5.10698405804494],
            [25.351200360238479, 5.114127037770024],
            [25.351757895127964, 5.12348991298577],
            [25.352283239787592, 5.132312082674009],
            [25.354953161271105, 5.147659875666616],
            [25.35520751205727, 5.149122057803527],
            [25.354507320209059, 5.152571041223396],
            [25.353207846963461, 5.153379701292702],
            [25.352667239927147, 5.153716007786859],
            [25.352666352391648, 5.15371573758748],
            [25.352665955336295, 5.153715984369581],
            [25.34191996654787, 5.150441976715391],
            [25.341202825286857, 5.15022427947504],
            [25.337070360282571, 5.151131122642078],
            [25.334723544840465, 5.15368933910404],
            [25.332231240051584, 5.156406139814585],
            [25.328836340404582, 5.164635338382931],
            [25.324362360183766, 5.175480049155509],
            [25.3241063996166, 5.182613095940055],
            [25.322580736870666, 5.184738916744611],
            [25.320646452959867, 5.187434179322079],
            [25.320776125669447, 5.188164099438846],
            [25.321996620831875, 5.195033311099936],
            [25.328172240169526, 5.201038095572897],
            [25.330480502614598, 5.202553964111465],
            [25.332752519834546, 5.204046027202852],
            [25.334680341265194, 5.207946175660663],
            [25.335943200078137, 5.210501033150365],
            [25.336050754468783, 5.211165375534053],
            [25.338398399954208, 5.225666127780266],
            [25.343008200056079, 5.254154057447005],
            [25.343962356414902, 5.260058207327323],
            [25.344028440080443, 5.260467120846631],
            [25.346928515329644, 5.267374826710435],
            [25.347898439816621, 5.26968507849192],
            [25.357252320189058, 5.286285990728528],
            [25.359672527091558, 5.286750229700601],
            [25.360921671325048, 5.286989837819734],
            [25.361242951989755, 5.28693197446481],
            [25.371025941403769, 5.285182983788688],
            [25.371026403137808, 5.285183217011332],
            [25.37102735984358, 5.285183045921371],
            [25.374693060226271, 5.287036927937616],
            [25.38041148020341, 5.293040003525491],
            [25.381396243062277, 5.294796047508909],
            [25.384290480160409, 5.299957065626226],
            [25.38471548569774, 5.304154405698427],
            [25.384733272340366, 5.304330153715442],
            [25.3815062399722, 5.308001000161226],
            [25.381505165587104, 5.308000533733454],
            [25.381504810752585, 5.308000937130431],
            [25.373484430910406, 5.304522272670817],
            [25.369581240221109, 5.304968992229109],
            [25.366808159803647, 5.310252026965791],
            [25.367643057621972, 5.315165018792222],
            [25.367708160327254, 5.315548115259464],
            [25.376182254964931, 5.320869918438484],
            [25.391791080406179, 5.320692999251836],
            [25.391791235814708, 5.320693077588453],
            [25.391792520405556, 5.320693063181736],
            [25.393934860424373, 5.321776281236604],
            [25.395000479743651, 5.322315082934598],
            [25.398199262791096, 5.326698884492266],
            [25.39839924034975, 5.335213026483679],
            [25.400217240041975, 5.340512127464775],
            [25.404112653117505, 5.342595690164964],
            [25.408483902900755, 5.339620060313161],
            [25.409900861412485, 5.327427967498823],
            [25.41062193998934, 5.326516026985024],
            [25.414975054583625, 5.321002006538831],
            [25.419801929878968, 5.318946976050356],
            [25.419803400421085, 5.318947040880849],
            [25.422858136816092, 5.319075561922151],
            [25.425768922678415, 5.319198025789549],
            [25.425770400407039, 5.319198087918759],
            [25.426733399781526, 5.319588027755937],
            [25.42920840032308, 5.320590060417643],
            [25.430185814962922, 5.321857863726672],
            [25.431343199883397, 5.323359102043479],
            [25.432148034682427, 5.324403983755123],
            [25.43240915966414, 5.324742990079279],
            [25.43549363029507, 5.328384038415829],
            [25.44589835988684, 5.3406660880913],
            [25.460331328350435, 5.348999009739479],
            [25.464232063944031, 5.349241966124374],
            [25.471817910717, 5.346506082397179],
            [25.471818918626742, 5.346506339006213],
            [25.471819439649593, 5.34650615082624],
            [25.476406199761076, 5.347672146951414],
            [25.478747909179074, 5.350035850942656],
            [25.480522440293019, 5.351827043629255],
            [25.482587312296676, 5.361715295702222],
            [25.482782519801177, 5.362650098134455],
            [25.483486745085017, 5.363202717215602],
            [25.48634940011269, 5.365449091899167],
            [25.486904156513052, 5.365885112624558],
            [25.488892919652557, 5.365968432246473],
            [25.492868887354604, 5.366135001228171],
            [25.497467882520223, 5.364079043698704],
            [25.502077677232212, 5.358802040082756],
            [25.506706910588658, 5.347311045502556],
            [25.511308784854773, 5.343874057579285],
            [25.511309982309037, 5.34387470405682],
            [25.511310588671879, 5.343874251162385],
            [25.516725479592619, 5.346797022051961],
            [25.528038479598511, 5.352903131739695],
            [25.547544360235648, 5.354577102088495],
            [25.55028713868192, 5.358268027511575],
            [25.548556226164937, 5.361023759486176],
            [25.546825440310382, 5.363779098907303],
            [25.536699360034898, 5.37180101300448],
            [25.536543514909521, 5.372340817190168],
            [25.535305439716964, 5.37662914664586],
            [25.536892307378135, 5.382847046501866],
            [25.537330025873391, 5.383184844163566],
            [25.540785359681124, 5.385851082317642],
            [25.543485223809657, 5.385977441840917],
            [25.546062787702159, 5.386098077981958],
            [25.555046573855638, 5.376462920898376],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Isiro",
        AREA: 89683,
        POPULATION: 1864000,
        DISTRICTS: ["Rungu", "Niangara", "Dungu", "Watsa", "Wamba", "Faradje"],
        OBJECTID: 6,
        NOM: "Haut-Uele",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.394130325866204, 5.096104766791089],
            [27.414564203921085, 5.087838899812636],
            [27.431554334638729, 5.077728747273994],
            [27.438217187610082, 5.07083075990964],
            [27.44258324872423, 5.063469892998249],
            [27.446266032368651, 5.052886848603416],
            [27.446500030025447, 5.047593914887727],
            [27.44215016643416, 5.037693894664439],
            [27.440330371009704, 5.02043074483082],
            [27.455480186086859, 4.999999889049029],
            [27.460314966556698, 4.997434810895673],
            [27.46238315783533, 4.994674741240523],
            [27.464462146863674, 4.97948579910212],
            [27.470435960571049, 4.971897837148356],
            [27.478242167676438, 4.965459796253231],
            [27.485825894425322, 4.952577779039933],
            [27.490190155315652, 4.947978894220332],
            [27.491111030889812, 4.943606755104604],
            [27.527318598596747, 4.934425164206456],
            [27.53695035303938, 4.908639182981547],
            [27.547714305438564, 4.89847290094434],
            [27.562068880622252, 4.884116548564952],
            [27.566877018857376, 4.873324974307219],
            [27.589836636097708, 4.860598818984537],
            [27.589842801235484, 4.860599482174919],
            [27.589843518091104, 4.860599084801328],
            [27.592768142500347, 4.860913721702131],
            [27.600626520164205, 4.861759142513721],
            [27.6097714748594, 4.867228930731628],
            [27.610255111638722, 4.86751820403342],
            [27.621033379590255, 4.86637578573295],
            [27.621037466924811, 4.866376350701354],
            [27.621040319974128, 4.866376047943171],
            [27.637787520187839, 4.868689157031004],
            [27.644978069608214, 4.870858032615581],
            [27.653842400490134, 4.873531759557584],
            [27.67241918686657, 4.87331382463269],
            [27.672420002536835, 4.873314169737389],
            [27.672426359914123, 4.873314094949661],
            [27.675228240319566, 4.874499998836232],
            [27.676630987483517, 4.874993501975864],
            [27.684349172267485, 4.871249798952211],
            [27.690226142197336, 4.861261800877296],
            [27.699509056560636, 4.845481823826584],
            [27.703417196068813, 4.831213761807963],
            [27.702246120823411, 4.827864852234837],
            [27.700442168087296, 4.82269688674057],
            [27.702740036126187, 4.814411752295497],
            [27.705389980874379, 4.80000761574635],
            [27.705433539284204, 4.788594536428506],
            [27.706650691815462, 4.781991640634454],
            [27.710853670078016, 4.773598783657936],
            [27.723372610742125, 4.771847675004537],
            [27.732905724776675, 4.7718864668582],
            [27.73290746571168, 4.771886719192251],
            [27.732913199658157, 4.771886742623271],
            [27.758518232340982, 4.775595056039167],
            [27.7751950818915, 4.775663096635565],
            [27.78177224816115, 4.769682573268313],
            [27.788981929900476, 4.754093163616472],
            [27.789023327862015, 4.743279921920719],
            [27.789154000396497, 4.709037070634785],
            [27.791001508847479, 4.693424363754037],
            [27.791033547262092, 4.68501335459657],
            [27.771470158277104, 4.659098917279984],
            [27.763629754105473, 4.646195763362406],
            [27.763631301004374, 4.646195011629796],
            [27.771201597041454, 4.642516852733786],
            [27.778087641835018, 4.633083808227004],
            [27.779237474618924, 4.628250832418174],
            [27.777862640805814, 4.624566799192128],
            [27.786828389686679, 4.586362751319658],
            [27.797157455978727, 4.570255763084365],
            [27.805873371700994, 4.567497720923617],
            [27.805876858960925, 4.567499533757905],
            [27.805881418809321, 4.567498090521856],
            [27.812529913109138, 4.570953717448455],
            [27.818256589502102, 4.570956767069764],
            [27.829269293488277, 4.563365843940968],
            [27.838441326101119, 4.562678841208751],
            [27.848216355543347, 4.556620841699385],
            [27.876292967084854, 4.539216742003842],
            [27.876301013294857, 4.539217144070609],
            [27.876301200144454, 4.539217028679271],
            [27.905397480381772, 4.540672641465459],
            [27.92146607975511, 4.545545382967042],
            [27.944170562878309, 4.556960485077028],
            [27.953535598529967, 4.55162778718547],
            [27.964121699774239, 4.547991680061283],
            [27.98086448746324, 4.544543834697719],
            [27.980867063831482, 4.544545419514111],
            [27.980873280173231, 4.544544139400748],
            [27.987978331538127, 4.548916639815123],
            [27.993477378431354, 4.546618719639588],
            [27.993485475845326, 4.546619346172105],
            [27.993486240311618, 4.54661902704619],
            [28.00092064100912, 4.547194646136257],
            [28.008384588194659, 4.547772551825719],
            [28.014574339828346, 4.546162740838433],
            [28.02627427207489, 4.538108744252439],
            [28.028338139762056, 4.534656722149265],
            [28.027193344730271, 4.528211670001983],
            [28.032494306815128, 4.487388720204576],
            [28.03238126641304, 4.485364688439435],
            [28.033856176142059, 4.476883818634056],
            [28.038904065743353, 4.466987695511748],
            [28.066617782164609, 4.44788017700146],
            [28.076784481562282, 4.438005220442798],
            [28.085733307979854, 4.435036614085767],
            [28.085741088288515, 4.435037472433114],
            [28.085742719629078, 4.435036931457899],
            [28.102716720197506, 4.436909088348019],
            [28.114613640409427, 4.442066076351281],
            [28.122346857601357, 4.443598884411886],
            [28.12980208753536, 4.440925646659701],
            [28.13995762536566, 4.434055512466855],
            [28.143860359710764, 4.42625829864442],
            [28.146863460044944, 4.419959804146086],
            [28.156491956298037, 4.39505621447844],
            [28.167253368261598, 4.385483517434158],
            [28.18343130428309, 4.367391715171737],
            [28.20011323560319, 4.34615672991613],
            [28.218913035935412, 4.337408812468409],
            [28.231295876444104, 4.333955658415899],
            [28.238630829148068, 4.329581820390819],
            [28.255367841568127, 4.327969792234399],
            [28.255374968801565, 4.327970456828717],
            [28.2553783204159, 4.327970133999973],
            [28.258938360056558, 4.328302064073967],
            [28.26523009023791, 4.328889313375544],
            [28.272562769305921, 4.32750774573687],
            [28.272567408206061, 4.327509212895143],
            [28.272573360443129, 4.327508091109715],
            [28.278143070613204, 4.329269144249053],
            [28.28931047976268, 4.332800088749244],
            [28.301223466343487, 4.333488535165753],
            [28.309017569548722, 4.331646703139554],
            [28.309026593125765, 4.331647525537181],
            [28.309028529893506, 4.331647067447284],
            [28.309608965534558, 4.331699932642775],
            [28.316593439632122, 4.332336072209442],
            [28.32108038254249, 4.336196001693563],
            [28.321408575743334, 4.336478332084935],
            [28.331486460505538, 4.336016748941528],
            [28.331488268814198, 4.336017526247019],
            [28.33149743971493, 4.336017106033127],
            [28.3338231474428, 4.337016962768283],
            [28.337915432601083, 4.338776294583234],
            [28.35189328220234, 4.338083780772232],
            [28.353520111418959, 4.337661640026388],
            [28.358999274103368, 4.336241742771671],
            [28.361061339770057, 4.333478677239653],
            [28.361141257491003, 4.330397692032914],
            [28.361290296081478, 4.324731693199173],
            [28.367621209877225, 4.316470735899806],
            [28.38535756391488, 4.299515784479566],
            [28.414470915735873, 4.282824641635887],
            [28.414482297390531, 4.282825115988164],
            [28.414482479748543, 4.282825011378169],
            [28.43786231989559, 4.283800372818489],
            [28.453636800065123, 4.287772076387681],
            [28.464915959635956, 4.298638216521917],
            [28.480390200379627, 4.303209745311062],
            [28.488105000311631, 4.311356187924757],
            [28.494916560395094, 4.321903172968338],
            [28.502295480242328, 4.339966069774986],
            [28.511747279675678, 4.36134283749012],
            [28.523922479996312, 4.371610576782829],
            [28.539995020278816, 4.37528226190218],
            [28.558750681889553, 4.375659035744452],
            [28.558752484808327, 4.375659226904504],
            [28.558763279863115, 4.375659444213791],
            [28.582288920174033, 4.378159629441535],
            [28.590886080412378, 4.389314125285654],
            [28.59319692012399, 4.408256238032362],
            [28.603595160286162, 4.415811418503815],
            [28.619966519758016, 4.419484310306327],
            [28.640813400061383, 4.421372320077141],
            [28.659567960337608, 4.425054886479407],
            [28.679185439580792, 4.436854464413902],
            [28.690154279729995, 4.451022796762749],
            [28.70258723994332, 4.471807344886917],
            [28.704325320117935, 4.48473541897533],
            [28.704267720141946, 4.499759126850229],
            [28.713395160384071, 4.528040762817794],
            [28.719015119616184, 4.538579769671717],
            [28.727636399619925, 4.543422343626318],
            [28.745502839592156, 4.545598382288076],
            [28.758904199851447, 4.546854740263555],
            [28.776419279969989, 4.563150717546898],
            [28.786982268460346, 4.571278058978703],
            [28.799126904501737, 4.566668590790832],
            [28.804857695178676, 4.566203643621123],
            [28.809898729736084, 4.559065584370106],
            [28.815393718040827, 4.547322625431746],
            [28.821123786472295, 4.540642509956567],
            [28.822954728192805, 4.534886517370199],
            [28.822891728443597, 4.531882558997673],
            [28.822716766270688, 4.523378522673206],
            [28.826380452630481, 4.515089626208948],
            [28.818626117842847, 4.506835312270908],
            [28.81836295727868, 4.497669608121337],
            [28.830311610569513, 4.489304947920097],
            [28.830326253108634, 4.489305535735824],
            [28.830326400432323, 4.489305432056662],
            [28.863687959792134, 4.490643280467951],
            [28.883920863158352, 4.494329539524888],
            [28.919721121240745, 4.480053831156055],
            [28.937600355917606, 4.478924741685501],
            [28.955474908575191, 4.478997506562636],
            [28.955479455847165, 4.478997976280984],
            [28.955490840196752, 4.478998022261106],
            [28.991809429791363, 4.482750684435136],
            [29.000154444607546, 4.480982553454494],
            [29.000161672452325, 4.480985015637429],
            [29.000170800233899, 4.480983081773506],
            [29.009096639661678, 4.484024266177157],
            [29.028129300383537, 4.490709609756369],
            [29.034681711778902, 4.488935843727191],
            [29.040672049995951, 4.480546648671682],
            [29.0472560228005, 4.472760893738804],
            [29.054435788844192, 4.464977390959748],
            [29.061005722777505, 4.460797309317796],
            [29.068765084537457, 4.457222909897673],
            [29.079499096088224, 4.454862785178983],
            [29.088436365679634, 4.454899079118713],
            [29.093819389764008, 4.449512186600542],
            [29.093244114045952, 4.444100818599861],
            [29.088528156433682, 4.430859365397545],
            [29.094504815105594, 4.426075692038821],
            [29.094521826502131, 4.426076476462546],
            [29.094522120251217, 4.426076241135417],
            [29.108819520362012, 4.42673552102153],
            [29.124883523954328, 4.430404898377438],
            [29.139186477450213, 4.427459823508628],
            [29.141588371297317, 4.422661394174314],
            [29.150605909850942, 4.401662325473769],
            [29.180514024560015, 4.371130741544172],
            [29.199041582360575, 4.356179500323619],
            [29.214546614657255, 4.3526363969025],
            [29.214556108951474, 4.352639050683169],
            [29.214565199902168, 4.352636973105653],
            [29.240754120451694, 4.359956591566784],
            [29.253843720391615, 4.36481832596944],
            [29.256774480294268, 4.377452684675204],
            [29.273379065770079, 4.397351344270188],
            [29.286479600003631, 4.395003646846815],
            [29.30019508494809, 4.392054272092622],
            [29.310323931136367, 4.39209559961413],
            [29.310324541990759, 4.392096131604279],
            [29.310343560223643, 4.392096209148619],
            [29.326971599813209, 4.406588858754268],
            [29.344151520295856, 4.432502799811668],
            [29.368467720277661, 4.462050764733462],
            [29.389236480388973, 4.48437157757571],
            [29.412982080383749, 4.507304731026538],
            [29.43430991958855, 4.539241103103607],
            [29.450300759892567, 4.564544659986177],
            [29.463919560061324, 4.586832988359657],
            [29.475159839648349, 4.607909276422625],
            [29.46848867995557, 4.638525451817689],
            [29.475528480393166, 4.667393759221963],
            [29.494528199893555, 4.684894544227716],
            [29.520122800441026, 4.686199327373664],
            [29.537430207133884, 4.67845984793705],
            [29.537453409719348, 4.678457019607173],
            [29.556505642934628, 4.676134407064545],
            [29.581530001024575, 4.676236246202836],
            [29.593473922888794, 4.669075234301421],
            [29.59379646748312, 4.669058141511063],
            [29.650090011905078, 4.665701075593376],
            [29.670994202926931, 4.652568108284966],
            [29.69309213548549, 4.638839039462128],
            [29.733140483427341, 4.605354672312881],
            [29.756381755746879, 4.604247514640979],
            [29.77187333487386, 4.605511515955449],
            [29.789687758797932, 4.602387280588093],
            [29.792204481592844, 4.599160307464684],
            [29.810530370307056, 4.588306193919234],
            [29.822667227836448, 4.578154172933079],
            [29.833666144479643, 4.573759167873428],
            [29.837694843288837, 4.57100922271762],
            [29.840767036644774, 4.568910332099129],
            [29.826959062056968, 4.533629454037637],
            [29.815114146215183, 4.514952221991686],
            [29.815178217654491, 4.4981258342239],
            [29.809985991244897, 4.453632616548605],
            [29.808934428763202, 4.41696694855212],
            [29.810238675656219, 4.387521389742933],
            [29.810260292715203, 4.387492725213185],
            [29.816096146754539, 4.379754229835216],
            [29.822508010435499, 4.376059214765921],
            [29.822530323688827, 4.376062279636869],
            [29.822534279869352, 4.376059999243028],
            [29.830771097101131, 4.377191328002037],
            [29.833744885407555, 4.376249514464449],
            [29.843925531150063, 4.370254646462046],
            [29.848533459162883, 4.363389961207974],
            [29.864565453984994, 4.351799998351088],
            [29.864588489483829, 4.351803593538068],
            [29.864592360324387, 4.351800795478063],
            [29.8831690802255, 4.354699829775371],
            [29.897712815455165, 4.357990755632593],
            [29.907900517464206, 4.356519261900075],
            [29.914703332448394, 4.355752092966652],
            [29.925187087734052, 4.348459746507897],
            [29.948324999897, 4.334805025214219],
            [29.959404539438655, 4.322656785384346],
            [29.979133300182607, 4.307770346467132],
            [29.978372257355382, 4.278066514384671],
            [29.967133944180535, 4.256946912481368],
            [29.969803650068354, 4.232994807631658],
            [29.979027057332292, 4.220877824992781],
            [30.00715160297732, 4.214885307249211],
            [30.017027680312623, 4.209863711900334],
            [30.029938501137959, 4.192512018910258],
            [30.038741058471075, 4.157141127645902],
            [30.057218464227613, 4.139366003126533],
            [30.057248355668698, 4.139356146301044],
            [30.092431989478836, 4.127754106662316],
            [30.108471512183055, 4.117775909562527],
            [30.128551605831252, 4.111602655473858],
            [30.155133903135276, 4.106605912657656],
            [30.155165152829067, 4.106606873305306],
            [30.15516563971596, 4.106606782201638],
            [30.168470880239823, 4.107016107292087],
            [30.169067338232271, 4.107316021274154],
            [30.180124657945392, 4.092267714757677],
            [30.174382019388169, 4.055858952855683],
            [30.173331904092397, 4.030351313237505],
            [30.186376267569546, 4.018109661951106],
            [30.186399453087034, 4.018096261005319],
            [30.190895265962506, 4.015497739881963],
            [30.195718086262655, 3.988914744712439],
            [30.197490685998741, 3.971433430002494],
            [30.207343344254575, 3.961563500501708],
            [30.201664073755804, 3.938397342331924],
            [30.202229978248809, 3.927399822028675],
            [30.21398520719098, 3.927190343371875],
            [30.213990517132626, 3.927191693991609],
            [30.214018080140502, 3.927191203185242],
            [30.228267239822195, 3.930815346406527],
            [30.245664960438777, 3.946017120836178],
            [30.253739399996419, 3.952336561806],
            [30.2599447203323, 3.956103893573931],
            [30.266104743119982, 3.956637261132056],
            [30.285856463904313, 3.947238693643828],
            [30.29136903493411, 3.935506794191896],
            [30.301877597196317, 3.933380612687656],
            [30.319816778248718, 3.932414699825564],
            [30.335841147272404, 3.919202774797113],
            [30.351896116507916, 3.912453332815141],
            [30.374101198316925, 3.897838017553201],
            [30.379038500815202, 3.895164754996685],
            [30.403829758665321, 3.866200658513454],
            [30.403857894798307, 3.866211334336238],
            [30.403866240147309, 3.866201584256729],
            [30.415463999810044, 3.870601906476746],
            [30.425342110032847, 3.871070790130183],
            [30.430279156511254, 3.87098272141619],
            [30.445592150559758, 3.838390744575749],
            [30.4529824367903, 3.831148648498218],
            [30.471524578739508, 3.826939808972174],
            [30.471537233306883, 3.826946476258969],
            [30.471562440033772, 3.826940754609794],
            [30.498856919898426, 3.841321733384636],
            [30.516202440312135, 3.845537508434707],
            [30.526088992901954, 3.848584179166766],
            [30.555676788143639, 3.827379807379031],
            [30.571466014158567, 3.7650411727493],
            [30.579824996879115, 3.701537247529411],
            [30.573576243897534, 3.68871850126662],
            [30.563316823989485, 3.672572884177121],
            [30.563312494109805, 3.672566070396712],
            [30.565399367651409, 3.670288154765175],
            [30.569414355474414, 3.659058205851216],
            [30.569267474637265, 3.651234191727254],
            [30.564813282505543, 3.638993160165001],
            [30.565428500914376, 3.624275170136762],
            [30.540952964954034, 3.594904128359205],
            [30.540993695467328, 3.594906605000852],
            [30.54099240009668, 3.594905050781855],
            [30.492652680235818, 3.578955250746493],
            [30.45569220035328, 3.559131065783839],
            [30.452129339104314, 3.560694391689473],
            [30.45108636002518, 3.561152034320407],
            [30.431366163819121, 3.562088043465683],
            [30.417961319893188, 3.55135798567848],
            [30.410585898983946, 3.547377816115643],
            [30.408390359835693, 3.546192983422281],
            [30.403702944394968, 3.546298075751005],
            [30.401514360003638, 3.546347144588185],
            [30.391166519820484, 3.549454998313152],
            [30.383154360461482, 3.548677001932587],
            [30.376081440037666, 3.545609079063525],
            [30.372244200063275, 3.540275132379777],
            [30.371042732116837, 3.5357100686972],
            [30.370483488631677, 3.533584812015109],
            [30.375736203999221, 3.514086050770148],
            [30.375992520299242, 3.507869101852461],
            [30.376046195535807, 3.506523282200785],
            [30.376047233988253, 3.50649722890526],
            [30.375247858251214, 3.504320983151646],
            [30.374265307942903, 3.501646270830356],
            [30.384810719996416, 3.477093427033351],
            [30.394923480052867, 3.456866405510888],
            [30.402298800350767, 3.446388156030373],
            [30.402942979546058, 3.445835870303163],
            [30.410001720063121, 3.439784050174841],
            [30.423134433746807, 3.432702113608306],
            [30.422135742509443, 3.424933267318744],
            [30.421653480152546, 3.421182058215761],
            [30.420206412807435, 3.418423591113659],
            [30.417162480450351, 3.412621075837501],
            [30.414087193296584, 3.410644512248693],
            [30.411701279580075, 3.409111023156818],
            [30.406324320022176, 3.397779097467196],
            [30.400882277521958, 3.392428188280581],
            [30.399159940322672, 3.393695910304161],
            [30.396263399944154, 3.395828119742372],
            [30.385001415263229, 3.39908623758707],
            [30.377874240189513, 3.40114814011458],
            [30.375207338842007, 3.402671253168406],
            [30.36680622872791, 3.407469047309602],
            [30.369191759762113, 3.381014126631083],
            [30.368149560420633, 3.357103343962514],
            [30.362504039627083, 3.341035227229543],
            [30.354660317078803, 3.323133025885167],
            [30.352095922488356, 3.322818517413076],
            [30.350542207152735, 3.322627895033509],
            [30.349243581916749, 3.321690220965907],
            [30.342130199575909, 3.316553984309087],
            [30.336988346195884, 3.304764114453831],
            [30.33996528669066, 3.303369801383447],
            [30.342746520217613, 3.302067148872176],
            [30.345924425519552, 3.293580559156978],
            [30.34652147370516, 3.291986045100814],
            [30.346498345679855, 3.291705744914835],
            [30.345913440021945, 3.284617132614155],
            [30.342354480156271, 3.274916127558192],
            [30.342727484018454, 3.269947483011101],
            [30.342889440382692, 3.267790108424729],
            [30.343608477987242, 3.266461465494446],
            [30.35340936004507, 3.248351145913869],
            [30.356079480056213, 3.234577144600925],
            [30.357880786355508, 3.231589847883463],
            [30.359111400141337, 3.229548985294998],
            [30.351706560304887, 3.218013075565103],
            [30.333665159956301, 3.19763560965557],
            [30.311301960284254, 3.179275545325897],
            [30.292047720216107, 3.164094069988665],
            [30.280233600418853, 3.152013944651804],
            [30.273416086301694, 3.142769994372931],
            [30.260927160147837, 3.125835892457807],
            [30.249700560105982, 3.107275862834409],
            [30.234140280521011, 3.088145901974232],
            [30.228656266934074, 3.08524799459522],
            [30.221113320105832, 3.081262075426844],
            [30.185129520041212, 3.06120189793625],
            [30.170243160175673, 3.053704182177977],
            [30.156566760030902, 3.040362040297433],
            [30.139618320125582, 3.02535402318229],
            [30.140917199584777, 3.021950067308517],
            [30.144380596670523, 3.012884518651521],
            [30.145042440337569, 3.011152114308007],
            [30.151521359661231, 3.005244015970954],
            [30.159338299837643, 3.002571123049088],
            [30.161207519670736, 2.999142042608653],
            [30.162241440138573, 2.988572082865199],
            [30.168976070297735, 2.971487140485528],
            [30.171901319934431, 2.964066053480903],
            [30.173487990864569, 2.955554907027973],
            [30.175068230755585, 2.94707818962166],
            [30.17972503250979, 2.943454651048362],
            [30.206251440230098, 2.922813998528336],
            [30.188712599672289, 2.904568337760347],
            [30.167048520158314, 2.903013682907344],
            [30.146031000375135, 2.907270664551371],
            [30.129938280338102, 2.906263570287517],
            [30.116905199700934, 2.898084563621481],
            [30.113165160135242, 2.89232795709917],
            [30.113137439922177, 2.886505079785863],
            [30.111878159997332, 2.881998174870928],
            [30.114727200158597, 2.874628110523007],
            [30.121090199979673, 2.879070063362386],
            [30.126339932940489, 2.879289754476041],
            [30.128643359754385, 2.879386148925441],
            [30.143346480369956, 2.874951037388905],
            [30.146989559377172, 2.875891980337062],
            [30.155449319597828, 2.87807698417093],
            [30.166210439608935, 2.878198126771832],
            [30.16721503726928, 2.877907756270478],
            [30.170971439647861, 2.876821998119188],
            [30.189184199925066, 2.871555075558952],
            [30.194223480072711, 2.871381010844447],
            [30.194421759815487, 2.87245981765728],
            [30.196384199622241, 2.883137052995457],
            [30.198648420363853, 2.885463048804502],
            [30.20116626066299, 2.885491125011161],
            [30.210651357050654, 2.876855929178052],
            [30.210166440172099, 2.862128193766508],
            [30.20884559959914, 2.844681146582503],
            [30.212502480322353, 2.832968807301348],
            [30.213699480048561, 2.824535453202563],
            [30.204997560078407, 2.816278630313681],
            [30.180264479821048, 2.819955216637162],
            [30.160453680433772, 2.817720175997489],
            [30.151766880008164, 2.812698519044639],
            [30.148623719744801, 2.802401136257717],
            [30.16093644045732, 2.789239766150788],
            [30.176991719611632, 2.782482426222415],
            [30.185585639626744, 2.76809290840688],
            [30.179250360018706, 2.737144577584493],
            [30.185307719742468, 2.709857066014095],
            [30.19640112028894, 2.70059918198943],
            [30.208627079914702, 2.669317829981134],
            [30.210922800081761, 2.631741083121713],
            [30.213267840452868, 2.604517454569419],
            [30.208262399841953, 2.592957233897423],
            [30.184708319767456, 2.584316570790393],
            [30.19419143986147, 2.572816838794845],
            [30.187056959687897, 2.55584288584967],
            [30.176534520251156, 2.546681073178049],
            [30.164791573075536, 2.530623420240994],
            [30.154825439633012, 2.521081159713304],
            [30.151624992905678, 2.515922715467458],
            [30.149652240439444, 2.512743045023375],
            [30.147234453598323, 2.512186405763807],
            [30.144401470822775, 2.511534177115898],
            [30.145364389348888, 2.507174975574711],
            [30.144583946504778, 2.504588733801008],
            [30.144041279631526, 2.502790101859107],
            [30.135538800027494, 2.483095558992279],
            [30.13150355968639, 2.432084673589178],
            [30.126960720005801, 2.39808533096772],
            [30.125604252248685, 2.36987609007678],
            [30.125443337031847, 2.36996356348849],
            [30.121460279825577, 2.372129036232104],
            [30.120125083276097, 2.371979483108654],
            [30.114603360210168, 2.371361005758259],
            [30.106653441523928, 2.365982084948311],
            [30.098171464169614, 2.367266017227611],
            [30.079248479659118, 2.360842095103383],
            [30.07215935991578, 2.360301138200114],
            [30.068458584812824, 2.361802269271478],
            [30.066642512905197, 2.362538916186717],
            [30.060854280355763, 2.368452029338598],
            [30.0576067259749, 2.368823253375665],
            [30.057188378750457, 2.368871053091721],
            [30.055890326639627, 2.367786598203512],
            [30.053560319574821, 2.365839996598798],
            [30.053205991687385, 2.364409356239423],
            [30.05237051984561, 2.361036040183159],
            [30.04817734938937, 2.344105556685239],
            [30.046991399839456, 2.339317092624372],
            [30.04299143993283, 2.328692048366009],
            [30.033321480141176, 2.313633056366666],
            [30.030447240439567, 2.304631114970475],
            [30.027256451499831, 2.282976202857238],
            [30.013824251178519, 2.276844043888665],
            [29.999999139430045, 2.274871289412929],
            [29.998560436298579, 2.277845701646509],
            [29.997825407783658, 2.279365086464785],
            [29.994842193454925, 2.274772110513385],
            [29.989349319784356, 2.273403066160468],
            [29.98751691650487, 2.271336009292106],
            [29.988648002347087, 2.265351169775223],
            [29.98685618495216, 2.261630106125117],
            [29.985660403341484, 2.259145973718282],
            [29.98548555435627, 2.25810453557094],
            [29.984270085267841, 2.25086495939593],
            [29.98243801346668, 2.248799117049141],
            [29.975115272460659, 2.246974471645338],
            [29.971234538755169, 2.251353419550295],
            [29.970422182362277, 2.251049485433393],
            [29.969404966067138, 2.250668055869606],
            [29.969625302145111, 2.246755951017801],
            [29.966647849610624, 2.244691673350002],
            [29.965971870952583, 2.244965065799228],
            [29.964363188603031, 2.245617039940525],
            [29.963913188341223, 2.248609113616916],
            [29.957069236805253, 2.257367024993252],
            [29.950920126751619, 2.26980420787973],
            [29.946800249839384, 2.267513024784777],
            [29.945877898333233, 2.264064561262562],
            [29.944955251281328, 2.260614984253215],
            [29.936704420331093, 2.251658990134614],
            [29.931283190897698, 2.250216857114083],
            [29.929840943014081, 2.249833367881543],
            [29.925699232548894, 2.237876952868648],
            [29.925661781784704, 2.237427335151743],
            [29.92476035383811, 2.226604965000145],
            [29.921321276842047, 2.222241050858248],
            [29.920396437900859, 2.217411032826689],
            [29.921529356306255, 2.212115985312094],
            [29.917400161169599, 2.205453070574499],
            [29.917146963820237, 2.20408614028647],
            [29.91578124251739, 2.196713036067155],
            [29.916454441787945, 2.190039065281832],
            [29.914388404669356, 2.186592116953806],
            [29.910497291829067, 2.18476065040376],
            [29.903873047550331, 2.188454572762338],
            [29.898379390548826, 2.185936128437645],
            [29.889693167739953, 2.186643809620957],
            [29.883970136710442, 2.184355503896422],
            [29.879172356050521, 2.185975260565992],
            [29.875033250699616, 2.175631230035125],
            [29.873436289567895, 2.175864004630377],
            [29.871266581475641, 2.181862697947255],
            [29.870603249300203, 2.183695876078059],
            [29.851430722685194, 2.148301323585517],
            [29.852992341398718, 2.148546880199242],
            [29.861492020954, 2.149888940427791],
            [29.865609064579818, 2.149420991868588],
            [29.86903241387186, 2.146653113836979],
            [29.872214435254431, 2.140405821572558],
            [29.872903489789756, 2.139052990384194],
            [29.869899292612622, 2.122954069198103],
            [29.870687029776828, 2.121095171572922],
            [29.871266355100207, 2.119730843863759],
            [29.874123092026803, 2.120758351580069],
            [29.876985408389636, 2.121787662472201],
            [29.879728362007413, 2.120862106551426],
            [29.880776271939176, 2.119333011908993],
            [29.883833436480401, 2.114872034375675],
            [29.890455894908335, 2.110487447590237],
            [29.896568584565387, 2.111768559283113],
            [29.899147191401948, 2.112308766760616],
            [29.901583399096285, 2.110753589548693],
            [29.903486175496788, 2.109538982044705],
            [29.903694809221541, 2.099415954782909],
            [29.902781517225009, 2.098730089154319],
            [29.899114340011995, 2.095974104759246],
            [29.896814302541685, 2.088847065916823],
            [29.901812118252437, 2.072962003188652],
            [29.897682921319156, 2.066068722158806],
            [29.897228845400917, 2.056666070111864],
            [29.897205261929756, 2.056177001719647],
            [29.895148266354514, 2.055721546548743],
            [29.888822791857791, 2.063708787400462],
            [29.886024394220698, 2.067242951506414],
            [29.883438312502683, 2.068014452638523],
            [29.882139278533231, 2.068401992079442],
            [29.880425611873061, 2.070941461997899],
            [29.878719281753817, 2.073470058157108],
            [29.877249027094592, 2.073966711912631],
            [29.875291365426857, 2.074628013206709],
            [29.868673156030194, 2.080392753006227],
            [29.865040543294366, 2.079565448639892],
            [29.852661654474634, 2.076745377475344],
            [29.84809041725126, 2.078594861610608],
            [29.840280274626618, 2.078173763322933],
            [29.839860635624785, 2.078151134812138],
            [29.836095922931481, 2.081108159985134],
            [29.833694491716745, 2.08299501770921],
            [29.820438958570808, 2.08578204684224],
            [29.808788278256362, 2.091557038187186],
            [29.801305105327113, 2.09911700457527],
            [29.801258526781318, 2.099164061263347],
            [29.794862414160566, 2.102627959343434],
            [29.786424382389967, 2.114607995244127],
            [29.784752765868259, 2.121108352643339],
            [29.783701345320367, 2.125196960645265],
            [29.775478594807606, 2.13119509697113],
            [29.77276455795883, 2.140584077798251],
            [29.77161831933438, 2.144546955573372],
            [29.765001525682603, 2.152612982864388],
            [29.747650624360347, 2.167831063603871],
            [29.743061187269316, 2.170480483760415],
            [29.741253431066287, 2.171524075518938],
            [29.737941988502428, 2.172335316180736],
            [29.734624397868764, 2.173148061982418],
            [29.717046696191755, 2.189516956993598],
            [29.710583419232155, 2.192007746555126],
            [29.702649833714396, 2.195065086781186],
            [29.695561329317037, 2.194848146168841],
            [29.690305649509039, 2.197618749724827],
            [29.686874406720559, 2.196705115171844],
            [29.680690393524895, 2.192115643677127],
            [29.676507758510311, 2.193994083456834],
            [29.674520610541652, 2.194886532511134],
            [29.672902702494142, 2.194124275556553],
            [29.671194622456721, 2.193319056403013],
            [29.670907744572421, 2.193183520665154],
            [29.670631163177912, 2.193053337519434],
            [29.663315415556401, 2.194216801532967],
            [29.661000562172088, 2.192694899130552],
            [29.655989299579854, 2.189398176417267],
            [29.623022475227284, 2.187180238078345],
            [29.613320639616088, 2.189354173433834],
            [29.609971919662872, 2.200712716761668],
            [29.610081000291192, 2.210636511489818],
            [29.621235600363022, 2.214126626763738],
            [29.613929039811918, 2.24464384500585],
            [29.605935600445129, 2.275872493122204],
            [29.607410880280018, 2.283662620041374],
            [29.625427080189922, 2.27932175039175],
            [29.645480159700909, 2.270717771057937],
            [29.659476239712561, 2.279864719474223],
            [29.665104120288881, 2.286216818610919],
            [29.660412600445589, 2.301834193165031],
            [29.649390839644706, 2.31039404255132],
            [29.643185159982714, 2.314677188940931],
            [29.641210200355843, 2.324610458433275],
            [29.647556280408551, 2.333085350038991],
            [29.644871039954534, 2.341604308365909],
            [29.639364480450581, 2.363838065433682],
            [29.639152440314305, 2.37350302649317],
            [29.642372279872017, 2.384312120628331],
            [29.643111859252159, 2.385726380872759],
            [29.647421279791022, 2.393967032266934],
            [29.648018220178777, 2.398008879269445],
            [29.648576520432922, 2.401789088033152],
            [29.648151360385356, 2.419968105910553],
            [29.649990211771939, 2.425257241280237],
            [29.639921039769721, 2.45999586174173],
            [29.633816879616273, 2.473491891979333],
            [29.63157230682658, 2.491332229660828],
            [29.628279741460091, 2.492091343831825],
            [29.621511359799051, 2.493652038130905],
            [29.613733199893467, 2.493435064906093],
            [29.600685359936151, 2.488395146901119],
            [29.587188240165901, 2.488188076121827],
            [29.581470360076217, 2.488888155309847],
            [29.57438844032988, 2.49488311453907],
            [29.570957280186434, 2.49511899417574],
            [29.563862400445508, 2.492140065215008],
            [29.548992239899459, 2.492855088007947],
            [29.543421331376791, 2.490185888630609],
            [29.532251520132242, 2.484834060868899],
            [29.527931520134263, 2.482764064221835],
            [29.517529566336727, 2.481172070112556],
            [29.507108400270166, 2.479577134034877],
            [29.496687672581487, 2.473634103520991],
            [29.493829439959917, 2.472004024098958],
            [29.4791831997698, 2.467424989286068],
            [29.478632518127608, 2.466598021757724],
            [29.477806256712409, 2.465356939282268],
            [29.47821748568655, 2.46399069433024],
            [29.479400280353154, 2.460061045640259],
            [29.452947479688916, 2.452401931749184],
            [29.443908273770603, 2.436185088862718],
            [29.437736109353555, 2.434930122901281],
            [29.431553399613378, 2.433673064957139],
            [29.42606736032549, 2.436443067007513],
            [29.421491399760345, 2.435299088750771],
            [29.416675391384985, 2.427022133418602],
            [29.410265200367096, 2.423580168229267],
            [29.405277938064309, 2.423914816797988],
            [29.389223520394385, 2.424992079563365],
            [29.383041240048886, 2.420859097489308],
            [29.377189804730961, 2.419619447677737],
            [29.367941400047624, 2.417660133547037],
            [29.36096387980869, 2.417324570823887],
            [29.353986359569731, 2.416989007113124],
            [29.352041485420045, 2.416421627383683],
            [29.348495279834758, 2.41538709045909],
            [29.344947834574413, 2.416689997514249],
            [29.343466439907349, 2.417234084411673],
            [29.333624223668373, 2.414027001490596],
            [29.333418363042931, 2.414019014957644],
            [29.327905439873543, 2.413805159459931],
            [29.32356420010899, 2.417952029252536],
            [29.31784847956926, 2.419801000254105],
            [29.316296798019433, 2.418763967616203],
            [29.315101320039339, 2.41796499434184],
            [29.310299279568316, 2.417971116820369],
            [29.307050361544864, 2.420385832462961],
            [29.301614280264893, 2.424426118186941],
            [29.298425400245119, 2.43432509566829],
            [29.284023240402547, 2.441938035939789],
            [29.272360319644019, 2.44356513024],
            [29.268726479809523, 2.466120060304717],
            [29.266137972640248, 2.469252471533255],
            [29.263015440390731, 2.473031108877791],
            [29.25977834958633, 2.481890619907706],
            [29.255949359739517, 2.492370003013937],
            [29.23539948043538, 2.524153111977641],
            [29.22924555810679, 2.543720944724187],
            [29.208637519176204, 2.537932216101717],
            [29.202986243774941, 2.52945520754098],
            [29.205297080791599, 2.486920236025345],
            [29.205117441090966, 2.470619847631808],
            [29.204259201448323, 2.455740160440689],
            [29.199271045321794, 2.444424391023016],
            [29.19084885174798, 2.436669029940175],
            [29.188032026969459, 2.43037615310549],
            [29.179452340760022, 2.411208676750788],
            [29.17517461637765, 2.401307526982981],
            [29.16626051074412, 2.411981727371952],
            [29.147861644692878, 2.444674865511327],
            [29.134771335083883, 2.454661383928033],
            [29.127152606378264, 2.456824518964401],
            [29.11948754616358, 2.454735931356428],
            [29.110354444738515, 2.445566746794239],
            [29.093751837352979, 2.45202591047644],
            [29.086710650814894, 2.443555384699144],
            [29.095546350592091, 2.425793610197044],
            [29.082386334411996, 2.429401073972793],
            [29.072051093100665, 2.437247743201732],
            [29.06578314581644, 2.435860881989509],
            [29.052998835630895, 2.427000020903327],
            [29.039922564893143, 2.421811470303239],
            [29.043895882565089, 2.404072756533019],
            [29.042467403159851, 2.40053575419513],
            [29.031668963538596, 2.394835619910158],
            [29.030149089536327, 2.399344935119848],
            [29.027791293088203, 2.406345098633457],
            [29.023219296788415, 2.409571100557764],
            [29.01911025984673, 2.418779974960485],
            [29.016596924598737, 2.419119392778305],
            [29.015681730868753, 2.419242942765421],
            [29.012680178331838, 2.415698494413207],
            [29.011788224916529, 2.414644994006167],
            [29.005151989925377, 2.41373112928223],
            [29.00023584993858, 2.409146368050198],
            [28.998744330359962, 2.407755067398262],
            [28.990279827932891, 2.406613200613481],
            [28.982514124965324, 2.420427086833683],
            [28.974511331441459, 2.423886065853027],
            [28.969712152104655, 2.42918110844738],
            [28.967419755704153, 2.423202048884939],
            [28.968786975396895, 2.416758134547305],
            [28.972214172173349, 2.413763002232479],
            [28.973259763553337, 2.409145854828426],
            [28.97403829118927, 2.405708001907611],
            [28.97814624835598, 2.397189982648954],
            [28.986375401161787, 2.389128164337102],
            [28.987504081315677, 2.372790079256402],
            [28.998246113923621, 2.364955971601753],
            [29.000527072075581, 2.357130102363309],
            [28.997087994181221, 2.347929994216036],
            [28.997992613842005, 2.346774581992754],
            [29.000514112080992, 2.343554028278695],
            [28.996385618528571, 2.338837273387887],
            [28.99387427664217, 2.33596808814203],
            [28.992947267371257, 2.334032855954269],
            [28.98814524037499, 2.324008058653453],
            [28.987342080933949, 2.321098983314571],
            [28.979886426096822, 2.294104024904001],
            [28.976910007523227, 2.291115018717467],
            [28.977591127239663, 2.285592070699924],
            [28.968780403322299, 2.270472165333967],
            [28.947994208707954, 2.275015486198577],
            [28.922343765289149, 2.280622156416043],
            [28.857141329055594, 2.290154971998167],
            [28.841920178761761, 2.295899769603971],
            [28.828153320064498, 2.298098768872564],
            [28.819033472383143, 2.29955537835],
            [28.807284242390459, 2.305283530760554],
            [28.798971133038219, 2.30745050620318],
            [28.781829875147046, 2.301865108154003],
            [28.774511323883527, 2.302330115157108],
            [28.76856809152337, 2.307856960000666],
            [28.765367654677473, 2.309008853306759],
            [28.753014208841531, 2.303726384962403],
            [28.745700199460103, 2.312935011508734],
            [28.735870412311403, 2.319613993684661],
            [28.723293467429372, 2.325375058624291],
            [28.71529427704813, 2.333664099331412],
            [28.709349796029713, 2.33619864910046],
            [28.709347382256549, 2.33067600620592],
            [28.711492668749482, 2.32554273337492],
            [28.713002460060991, 2.32193007357448],
            [28.719172497267444, 2.315484132842445],
            [28.723056173853831, 2.307198044717172],
            [28.737134127218773, 2.294979301710156],
            [28.737914676962408, 2.294302137816448],
            [28.741339828274931, 2.283946005639585],
            [28.744541994377748, 2.283713492352751],
            [28.747742439308489, 2.283481073006525],
            [28.749225309009219, 2.282447132985115],
            [28.750714236948244, 2.281408968582491],
            [28.75147652214552, 2.276790815526092],
            [28.75299339487642, 2.267601103730462],
            [28.757532308919235, 2.263705528616807],
            [28.759164150735121, 2.262304979459015],
            [28.765101267364834, 2.247575031794113],
            [28.769894304920044, 2.232386050674768],
            [28.772616567641876, 2.23017378109582],
            [28.776978379724721, 2.226629111263619],
            [28.77720536423411, 2.223637559678359],
            [28.777432338861999, 2.220646128462399],
            [28.779717258584391, 2.216962964018821],
            [28.772622381538387, 2.206154027972252],
            [28.776505681730651, 2.201089967191523],
            [28.77597068646994, 2.198942950306005],
            [28.774901181038757, 2.194648025137856],
            [28.769245648521348, 2.187417026912588],
            [28.764830160303639, 2.18177163068221],
            [28.751208875394813, 2.1971008047328],
            [28.738789603709801, 2.204959074343233],
            [28.728376737178156, 2.20571867425873],
            [28.718651649574159, 2.204121220684657],
            [28.714310338842704, 2.211024966897649],
            [28.706599503176054, 2.214445023061931],
            [28.706107716880503, 2.214663135569851],
            [28.697163609313147, 2.218630092866107],
            [28.696364097930484, 2.221737052034612],
            [28.695565768730763, 2.224842039982015],
            [28.690077312974751, 2.225996075085068],
            [28.683959228934427, 2.229790242265609],
            [28.681163530734743, 2.231524131642252],
            [28.671328524374239, 2.232220003290844],
            [28.652808335453969, 2.23913312752796],
            [28.650107411313392, 2.240979506136556],
            [28.646407519254382, 2.243508801762587],
            [28.644331952807249, 2.242605741757343],
            [28.639544289872401, 2.240522168437663],
            [28.63611550577285, 2.241444098339632],
            [28.629211873762646, 2.259926454063314],
            [28.62812134955044, 2.26284597511471],
            [28.625149200669419, 2.265608985637038],
            [28.619660594894757, 2.264692233810847],
            [28.614173359050902, 2.269755974633792],
            [28.612521176682037, 2.269519691707572],
            [28.610712769200415, 2.269261065977111],
            [28.60937092332119, 2.269069172108675],
            [28.604575782809871, 2.284717145021015],
            [28.601374760262431, 2.288400139462177],
            [28.601149766419741, 2.29645396539336],
            [28.598006986143712, 2.299460420235341],
            [28.596577448523096, 2.300828033339886],
            [28.591928915761105, 2.309355083652026],
            [28.590178452310262, 2.31256603604813],
            [28.587897494158266, 2.326373099900133],
            [28.580713022739115, 2.333832155308706],
            [28.580580594896539, 2.333969779515253],
            [28.556678310749927, 2.323516974168638],
            [28.520198998177957, 2.3058459458638],
            [28.478448193652344, 2.285621069423364],
            [28.460642963086904, 2.277556137509924],
            [28.456065713439362, 2.274938033698112],
            [28.44036741399918, 2.265958855668464],
            [28.425372340916237, 2.26071549251079],
            [28.4099909895662, 2.251929687445605],
            [28.399566392833588, 2.251626062502853],
            [28.378868645443792, 2.296384747973474],
            [28.349123209344459, 2.321158197372279],
            [28.322131613545857, 2.335203209143768],
            [28.321375868982145, 2.335288089596188],
            [28.313896943287606, 2.33612528518524],
            [28.316793793584889, 2.314446472610293],
            [28.312744950953775, 2.228673709124521],
            [28.312585809011281, 2.223602088455127],
            [28.312362486035024, 2.216483960169804],
            [28.312202301148499, 2.211378245284167],
            [28.309763779394007, 2.133651017137087],
            [28.307447478823775, 2.106629663265799],
            [28.30872907739187, 2.087994055859997],
            [28.306954214799596, 2.050689201228506],
            [28.305218872689927, 2.014214171792482],
            [28.298553684098856, 1.874111486280457],
            [28.288949973262746, 1.854270804665603],
            [28.264674836170922, 1.845395188490647],
            [28.261771941110073, 1.84450979862866],
            [28.251699008760028, 1.841437525031013],
            [28.240402219751761, 1.834657776189643],
            [28.231198828749008, 1.828306017470412],
            [28.190624704956189, 1.795984831393559],
            [28.188127386669709, 1.784859450063149],
            [28.191907743523661, 1.77641475768214],
            [28.19070462447376, 1.737806684344959],
            [28.199535776080655, 1.710189492915296],
            [28.209602806499262, 1.697908991325951],
            [28.215476201134301, 1.689892131486359],
            [28.212132924073401, 1.684366248045795],
            [28.209203454151513, 1.683022412342885],
            [28.198730784076464, 1.686001322049722],
            [28.180300610839243, 1.690053001234211],
            [28.153903646758092, 1.701693289420551],
            [28.112430982204014, 1.714067445652346],
            [28.040717701419947, 1.739829312010765],
            [28.021099820629797, 1.746876664567964],
            [28.006856438911996, 1.751319135022223],
            [27.981725370847773, 1.755722500336553],
            [27.966350108278728, 1.755808408910831],
            [27.962671963534419, 1.755828962679919],
            [27.956611186619334, 1.753811297022357],
            [27.946056238050801, 1.749292580494745],
            [27.94578622423931, 1.749249021319144],
            [27.945707815688053, 1.749236458327738],
            [27.941297998534719, 1.748529893423653],
            [27.9396985391882, 1.743918757329269],
            [27.940679292865951, 1.740556025581078],
            [27.940900374545581, 1.739797997479178],
            [27.941308078530515, 1.738400092641915],
            [27.940342136275206, 1.734184216032153],
            [27.939937924041757, 1.732419784896971],
            [27.942261786630024, 1.730081098786867],
            [27.94448955822897, 1.727838903101207],
            [27.946107952265073, 1.7262100300985],
            [27.944651701442801, 1.723915932843042],
            [27.943419317975888, 1.721974500251903],
            [27.942457251950987, 1.720460099197449],
            [27.938223602509737, 1.72112507919056],
            [27.934651326916615, 1.730729834980399],
            [27.930033611758752, 1.739189688960552],
            [27.92016278417799, 1.761240075652022],
            [27.910092156006669, 1.776312609179552],
            [27.900855166215617, 1.794162112517462],
            [27.892490337259218, 1.786865002341218],
            [27.885801611011068, 1.778606603468904],
            [27.878264233737596, 1.778740797894083],
            [27.867358766138455, 1.79196634442998],
            [27.847210309798783, 1.827695695785301],
            [27.828783607651811, 1.828954505328614],
            [27.81454718428423, 1.828277201045019],
            [27.792644470908268, 1.828667095014183],
            [27.782721781789512, 1.828843734774369],
            [27.775172950996176, 1.837355373219835],
            [27.769298836810599, 1.845837067037888],
            [27.763427243297706, 1.852456989298955],
            [27.75002193853603, 1.856418770379791],
            [27.73913320475399, 1.857543322061317],
            [27.723087856475161, 1.849236908913632],
            [27.71653693358822, 1.845845534716222],
            [27.713194697674719, 1.840320296323087],
            [27.693966397358697, 1.815531092536116],
            [27.682251156921414, 1.808293403751858],
            [27.650418321766047, 1.814444834428677],
            [27.627796665108662, 1.821363190620854],
            [27.606007327206441, 1.831989716330762],
            [27.585049146537667, 1.847255353779036],
            [27.578353234665567, 1.844582399442708],
            [27.566651085376922, 1.828036526025039],
            [27.55580285663104, 1.799374782180603],
            [27.553326057662261, 1.773355871944563],
            [27.560047611045846, 1.757412118360043],
            [27.579901599635377, 1.728889041027136],
            [27.583839969249475, 1.72323096196812],
            [27.596130735136473, 1.705573257292418],
            [27.643100247507949, 1.654470005625462],
            [27.636916532552952, 1.583366389784297],
            [27.64153913634259, 1.571647720838575],
            [27.645724283945054, 1.572969446124689],
            [27.656176512855787, 1.584885352699132],
            [27.665799842897702, 1.590764825363745],
            [27.677105271004059, 1.591028931892315],
            [27.6938503772448, 1.594454492108683],
            [27.701392090686166, 1.591527566349525],
            [27.707250740374114, 1.594215848504297],
            [27.715605472266734, 1.608961519115647],
            [27.726495600234099, 1.606905967169558],
            [27.739898296288207, 1.6048056980804],
            [27.749106455548514, 1.60789974138081],
            [27.756219265662509, 1.611962015737027],
            [27.761250322632023, 1.607683545899236],
            [27.772999628981534, 1.589787070058206],
            [27.792298847695978, 1.562912241771421],
            [27.806561311427053, 1.544505140497932],
            [27.811194505455539, 1.524873086067744],
            [27.803611474002711, 1.504436028387155],
            [27.79972851876353, 1.502133982225393],
            [27.799047759271531, 1.494773976766321],
            [27.796764641569617, 1.489944105990309],
            [27.791284726995304, 1.484192100413465],
            [27.775291745107673, 1.48326403084034],
            [27.756557725708745, 1.477964963953391],
            [27.750848491005357, 1.473591976601832],
            [27.749481573146539, 1.468992140790504],
            [27.750625651322707, 1.464393015926248],
            [27.752525729184129, 1.463891050804096],
            [27.760005787654276, 1.461914050550562],
            [27.767992981933212, 1.459802985503587],
            [27.773483466983436, 1.446697126388874],
            [27.77348533817419, 1.443248183473127],
            [27.750579571341895, 1.449613809100397],
            [27.715818369395805, 1.453491183192239],
            [27.691524875231131, 1.458113032847985],
            [27.673929533336921, 1.464012309238103],
            [27.66344670421433, 1.474439513360538],
            [27.650460725840734, 1.477929054507839],
            [27.635808092340735, 1.47539713515602],
            [27.623684024126057, 1.461183030235148],
            [27.618251018677608, 1.45336651491814],
            [27.614063754644349, 1.453441095650874],
            [27.610663485766857, 1.453501661416778],
            [27.607782120628439, 1.453552984826772],
            [27.583902263821194, 1.461891296887243],
            [27.58095314684569, 1.474977332234974],
            [27.58301022416763, 1.483787321980397],
            [27.586365022122042, 1.498155079973231],
            [27.587182940883196, 1.512570194260384],
            [27.580816708025402, 1.529828098980453],
            [27.574182994605263, 1.538793101866848],
            [27.551548909755905, 1.55464501005395],
            [27.549886488389422, 1.55485276114679],
            [27.548139256178672, 1.555071006221731],
            [27.542406905128075, 1.555787027422615],
            [27.5333023845021, 1.561432351058219],
            [27.531662595290893, 1.562449008460117],
            [27.529881649307541, 1.562967829581018],
            [27.524577025689577, 1.564512915877878],
            [27.512465527600682, 1.565192937253907],
            [27.504692822265476, 1.570246011969799],
            [27.488702156234627, 1.567852391994532],
            [27.473637250816456, 1.56067332169478],
            [27.452324729683859, 1.555816045933762],
            [27.446989654076088, 1.554600167347824],
            [27.44649670715722, 1.556026388768159],
            [27.446208983059918, 1.556859925559047],
            [27.445208763788262, 1.558505313160388],
            [27.442999226192967, 1.562140059329704],
            [27.432478951696066, 1.57156002139969],
            [27.42055622558096, 1.573656976248609],
            [27.419458978377175, 1.573849819890339],
            [27.398218143702582, 1.564170205226479],
            [27.384499259533083, 1.566920041361626],
            [27.375589532288274, 1.565070154942504],
            [27.371019067616039, 1.568510002369694],
            [27.369870546372461, 1.572195741448497],
            [27.370186781200239, 1.579983573860865],
            [27.37031840594895, 1.583230794983614],
            [27.36595927174395, 1.587370002775452],
            [27.351338959627881, 1.592409900172824],
            [27.351030497023924, 1.592286982984084],
            [27.349954968388765, 1.591858380105045],
            [27.344489243602705, 1.589649975016176],
            [27.329179172672156, 1.588479991661181],
            [27.328121115370944, 1.588147553741648],
            [27.322559136102193, 1.586400000509975],
            [27.320173103808035, 1.582859583706029],
            [27.318218978807575, 1.579960029536715],
            [27.309999102903721, 1.57695992770783],
            [27.306549874046627, 1.57716580704111],
            [27.29491907075446, 1.577860030948402],
            [27.292731137641724, 1.578918640412217],
            [27.288739314674942, 1.580850042590228],
            [27.28424317121943, 1.583148242623304],
            [27.277079001725685, 1.586810049567212],
            [27.241428810804774, 1.589760050806736],
            [27.236472520616349, 1.591704624190381],
            [27.235848825704469, 1.591949326803113],
            [27.226798782510606, 1.595500056177776],
            [27.209881497077657, 1.598697517409559],
            [27.209868715847787, 1.598699932931607],
            [27.194740808883779, 1.603437850015953],
            [27.196861182398969, 1.605052227922954],
            [27.202096109327261, 1.609037911418501],
            [27.20442742972903, 1.610209364564084],
            [27.204571049681714, 1.610281488095917],
            [27.206674954382784, 1.611338028564905],
            [27.211431274199068, 1.611666049314105],
            [27.211565061192658, 1.611675229504433],
            [27.21352754681347, 1.611809892179574],
            [27.215808711577996, 1.614799941475554],
            [27.215421663454656, 1.617148336707585],
            [27.215099793495114, 1.619101265628079],
            [27.21326891465667, 1.630209989554426],
            [27.214410145173371, 1.63112956919966],
            [27.217388719703663, 1.630210042890331],
            [27.221049035584517, 1.624699787192901],
            [27.221473661134475, 1.624450344361634],
            [27.221683264141426, 1.624327174200378],
            [27.223790155740812, 1.623090212687208],
            [27.223897549333014, 1.623113658877023],
            [27.226988863329765, 1.62378997592815],
            [27.231471673989819, 1.626178590421469],
            [27.231795358546265, 1.626351061932867],
            [27.234758736276859, 1.627930062346755],
            [27.240228932876402, 1.638520032956602],
            [27.240783284136569, 1.638716547845161],
            [27.241099748933038, 1.638828733579069],
            [27.244798637573894, 1.640139907713846],
            [27.246868767416892, 1.636920038444442],
            [27.247158257602056, 1.631741320905641],
            [27.247182149195361, 1.63131392785584],
            [27.247318766780403, 1.628869958619875],
            [27.250281722302827, 1.626802708564126],
            [27.251110937378648, 1.626224166503672],
            [27.252581956504173, 1.625199244090268],
            [27.262189043209109, 1.62268002907298],
            [27.263697399911088, 1.622796439209705],
            [27.263718202198142, 1.622798044717094],
            [27.268278669519546, 1.623150044947587],
            [27.276808863048394, 1.623840059416152],
            [27.285258775936942, 1.632590080682136],
            [27.283794465429978, 1.635281185264897],
            [27.283203833910434, 1.636366644878282],
            [27.281128859453119, 1.640180018831529],
            [27.283512588466852, 1.645582550706514],
            [27.283868817189408, 1.646389914399365],
            [27.284003305767229, 1.650749311014836],
            [27.284088776873229, 1.653519856763656],
            [27.284370454410368, 1.654412835652374],
            [27.284951460481611, 1.656254751690368],
            [27.287498606520291, 1.664332614535825],
            [27.286809034555368, 1.672150917762107],
            [27.287069253136977, 1.67298323474426],
            [27.288178449730683, 1.67652912096007],
            [27.29730868642827, 1.684359942830698],
            [27.298218780422399, 1.686429636027108],
            [27.298203783947052, 1.686458358849605],
            [27.296159191410936, 1.690339345717975],
            [27.298435875378811, 1.694944202947445],
            [27.297697143109961, 1.69746523292404],
            [27.297476674081352, 1.698213008994816],
            [27.297288886661111, 1.698849936769393],
            [27.298428645737403, 1.701839945128989],
            [27.300939289632794, 1.703219955121718],
            [27.30219544970868, 1.703012638067382],
            [27.302290405227467, 1.702996966031818],
            [27.305058574555268, 1.702540089572792],
            [27.305075252676815, 1.702582525300413],
            [27.305816608026287, 1.704476734843773],
            [27.308478757285947, 1.711279959139356],
            [27.309046290424554, 1.720242419267777],
            [27.309148759452402, 1.721860019694461],
            [27.308368596882652, 1.722579990411244],
            [27.307366189315001, 1.723513807659476],
            [27.307180612648651, 1.723686686307992],
            [27.30617871981563, 1.724620023910411],
            [27.306173821302394, 1.726408306879675],
            [27.306172414540672, 1.726922017240641],
            [27.306168639819834, 1.72829996958563],
            [27.313238673956644, 1.740040003961151],
            [27.315857591793257, 1.740215515182765],
            [27.315897603654307, 1.740218196288991],
            [27.316668833376887, 1.74027033684315],
            [27.317481965914173, 1.744791506071178],
            [27.317578974981693, 1.745330566104295],
            [27.317933875095942, 1.745915599670302],
            [27.3188636844156, 1.747448950238207],
            [27.324420310623584, 1.75661096662223],
            [27.334468575235928, 1.763059933987809],
            [27.339946770434729, 1.773424653826111],
            [27.34565901090107, 1.778259985036031],
            [27.358908404960378, 1.778040046658179],
            [27.361572998535905, 1.779188987876556],
            [27.361865760385299, 1.779315224080349],
            [27.362108971163661, 1.779420348143974],
            [27.365258161817504, 1.783072471147919],
            [27.366678391095203, 1.784719206120374],
            [27.368738162464673, 1.782880670755006],
            [27.370449930984641, 1.786832902197879],
            [27.371328396195931, 1.788862180266658],
            [27.37192618459332, 1.79024308638203],
            [27.368262107466354, 1.798750044867827],
            [27.369856906353199, 1.803122133071997],
            [27.363223192034731, 1.807486105240786],
            [27.360247075295064, 1.811164082049557],
            [27.359552995584071, 1.819904044560071],
            [27.355429199322241, 1.82772110179328],
            [27.353417161732036, 1.836959070719797],
            [27.352673041368099, 1.840370019683702],
            [27.354038880350267, 1.846582127666252],
            [27.358831917007183, 1.852567959934045],
            [27.36522911030124, 1.855565101749246],
            [27.365683070336782, 1.858785969504544],
            [27.349892875938025, 1.876022963873972],
            [27.36537037846449, 1.874006289194236],
            [27.373769955154408, 1.874036913528791],
            [27.383498537204883, 1.871486381215174],
            [27.395119525504267, 1.872175383066373],
            [27.401562439452995, 1.873491999868772],
            [27.409797433104767, 1.885159570621028],
            [27.407102834900421, 1.892907883598779],
            [27.399876561277839, 1.901286269346639],
            [27.391994727703604, 1.910308587233284],
            [27.382064497228043, 1.927081536879378],
            [27.381908978191106, 1.938071632219617],
            [27.378559180259575, 1.946463843855445],
            [27.365490112213784, 1.956760140760809],
            [27.357008159113995, 1.962547446218031],
            [27.356215440791512, 1.972888494381195],
            [27.358726438623162, 1.978069621207406],
            [27.358570918687896, 1.989059197856617],
            [27.357187079264087, 1.995518967781077],
            [27.346083969726017, 2.003882607601573],
            [27.333042260770494, 2.012238998102634],
            [27.328482864240893, 2.014808246063046],
            [27.326988866210421, 2.029025137213061],
            [27.313765449632509, 2.036509879685295],
            [27.29411765135016, 2.023771176483358],
            [27.286388099284586, 2.028427500935635],
            [27.272658431738424, 2.041652900942245],
            [27.266691076917919, 2.047192420249619],
            [27.253678715024435, 2.047996960000765],
            [27.253688247047936, 2.040635053104213],
            [27.251218288750053, 2.037256033684621],
            [27.247296092404298, 2.031885971681807],
            [27.244097134185388, 2.028891128830637],
            [27.23107018455001, 2.025885113048454],
            [27.22878706594976, 2.023812112198454],
            [27.227192987511788, 2.018519096483256],
            [27.226975187377889, 2.008856136257082],
            [27.228808306614631, 2.005636998473412],
            [27.232981476979429, 2.0040279256246],
            [27.234755334356883, 2.00334395179636],
            [27.236588260455882, 2.000355090470338],
            [27.235904981189528, 1.997593086914193],
            [27.238883258377445, 1.992995982561584],
            [27.240035256101155, 1.98563504000944],
            [27.246901171445828, 1.980582005105467],
            [27.248504970553491, 1.975983051449605],
            [27.243939093577431, 1.972067121308477],
            [27.242571095045342, 1.968154065042593],
            [27.246236972396122, 1.961717062199462],
            [27.242582813568209, 1.958262082578526],
            [27.228408081104433, 1.95962593535561],
            [27.224732029434726, 1.958429021659223],
            [27.2224719508249, 1.953177042740228],
            [27.22522630855519, 1.944669043977665],
            [27.224774148743467, 1.939607057570869],
            [27.218838113685358, 1.933388981609471],
            [27.219529312499258, 1.929479076275956],
            [27.215878195366887, 1.923033097728322],
            [27.212909998174798, 1.921189094023712],
            [27.210178847521519, 1.911294122596094],
            [27.204878046235109, 1.911634057834437],
            [27.198623777597714, 1.912035142696923],
            [27.192576617345697, 1.912422941640965],
            [27.187096217681155, 1.906204987655723],
            [27.179557282728979, 1.90297515189079],
            [27.172688197229654, 1.904941135482537],
            [27.16995318921057, 1.905723915905571],
            [27.16092182199143, 1.903772764716932],
            [27.158196418759385, 1.903183918258858],
            [27.152814413364549, 1.902021089687696],
            [27.149163046500551, 1.896495978213349],
            [27.144841249872009, 1.896168133698684],
            [27.144644814370512, 1.896153253325545],
            [27.14416133749134, 1.896116629511623],
            [27.142991391428257, 1.896028015226336],
            [27.140240093359779, 1.901315093599162],
            [27.136807136585773, 1.904300982531432],
            [27.110961447933263, 1.915310084487313],
            [27.106389449836851, 1.915764037799888],
            [27.103648281171544, 1.913920061404564],
            [27.09590947286528, 1.912086215261086],
            [27.092908006566617, 1.911374991817374],
            [27.092461303121894, 1.911301308279995],
            [27.089652593723653, 1.910838171458221],
            [27.074624477909637, 1.90836013933823],
            [27.073123936550608, 1.909039521934583],
            [27.060441116229207, 1.914781992122706],
            [27.053574118414605, 1.92144308158717],
            [27.048123244576825, 1.923847430514796],
            [27.047854524339389, 1.923965906643764],
            [27.044041803880674, 1.941191297196292],
            [27.045298379876517, 1.950414256506559],
            [27.045148949620572, 1.953573928375146],
            [27.045069123527799, 1.955249960923542],
            [27.042765522440767, 1.95700765687921],
            [27.040259165305891, 1.958920056606046],
            [27.038364398284443, 1.961384817911042],
            [27.036369366700857, 1.963980002890824],
            [27.035449207982278, 1.967659986940733],
            [27.03557498649511, 1.968998560904608],
            [27.036119167927939, 1.974789908655692],
            [27.039127380574367, 1.979520974700792],
            [27.041829124876795, 1.983770039698475],
            [27.042729168519529, 1.991591900688669],
            [27.043159324098387, 2.010919977378166],
            [27.04397849241607, 2.012879562972516],
            [27.045659163057554, 2.016899998887272],
            [27.052279200525817, 2.023360018908734],
            [27.051809506498042, 2.031638072019859],
            [27.056819157512656, 2.047060042019354],
            [27.056154150877525, 2.052825515752144],
            [27.056129460681934, 2.053039575437689],
            [27.059309276700464, 2.062479997175625],
            [27.059301702106005, 2.06253822835105],
            [27.058621843624227, 2.067764749293124],
            [27.055415518321656, 2.071443065604988],
            [27.053570523356854, 2.082253181914256],
            [27.054923759873876, 2.096059134671223],
            [27.053750520586966, 2.115844102431404],
            [27.055800719508763, 2.122058045528982],
            [27.072015253793236, 2.136115253091139],
            [27.073310844520186, 2.136500654337967],
            [27.07590066412812, 2.137271003767843],
            [27.082993786764359, 2.134750166156767],
            [27.083937586446247, 2.135491033091295],
            [27.085047464861251, 2.136363110780096],
            [27.087092624234302, 2.146489053158459],
            [27.091660661658647, 2.150407069929062],
            [27.094850085159131, 2.159153941277006],
            [27.102397657412766, 2.157783085063673],
            [27.104224689665173, 2.158936200153957],
            [27.106503979645659, 2.164921172648178],
            [27.107904165712718, 2.165465295936631],
            [27.109475659606126, 2.16607592158112],
            [27.111535607943729, 2.163778078953029],
            [27.114049770540081, 2.16539211851602],
            [27.121567647185397, 2.185188067658041],
            [27.121321408186219, 2.197612112081908],
            [27.12611660529139, 2.203371145759286],
            [27.126095725749256, 2.219706026768856],
            [27.127775305835964, 2.221555522481122],
            [27.128606724479198, 2.222471051920254],
            [27.13363559584764, 2.224088213668438],
            [27.136601540065008, 2.230769300293217],
            [27.142701593120957, 2.243219431298348],
            [27.146104607249942, 2.250164895599594],
            [27.14673307580923, 2.251447579327205],
            [27.15826938621495, 2.273358677155645],
            [27.163741627380091, 2.286710967728192],
            [27.16543325836636, 2.288132911816457],
            [27.166482665789683, 2.289015017501023],
            [27.168802219159542, 2.289907577722936],
            [27.171282948257655, 2.290861946155228],
            [27.176231898311897, 2.290181628399822],
            [27.177916620355326, 2.28995003513652],
            [27.184074776443836, 2.311799594487727],
            [27.188466774615183, 2.328018343536095],
            [27.19065557370385, 2.343577985503446],
            [27.191102693966862, 2.3518620558717],
            [27.188347614889363, 2.360143014116878],
            [27.183081538878586, 2.364277982488999],
            [27.179917340071267, 2.365334716252228],
            [27.178275540430452, 2.365883020955134],
            [27.166598586190567, 2.375072023782658],
            [27.153084553838465, 2.389782078947074],
            [27.15193471476638, 2.394382089618899],
            [27.145058718527583, 2.405188136647057],
            [27.137049902698038, 2.406788893549561],
            [27.145051518530579, 2.41163203610196],
            [27.151444754745789, 2.41877313958233],
            [27.157620561831333, 2.419011006202995],
            [27.159426859170338, 2.41769433847592],
            [27.160140581443365, 2.417173970059198],
            [27.160829022429343, 2.414183082676385],
            [27.164261468061962, 2.413958025818564],
            [27.165402921360879, 2.415569127914811],
            [27.166718467263554, 2.436609075486676],
            [27.166970467158613, 2.440653054458653],
            [27.16031947105072, 2.454451074087095],
            [27.152510714526532, 2.477912976107116],
            [27.14838550251984, 2.484351079864888],
            [27.148977317120597, 2.543861415678441],
            [27.144196520009434, 2.563115881041961],
            [27.135451862689667, 2.575461974050363],
            [27.129971561839806, 2.568781090843494],
            [27.125703642568748, 2.568717504325209],
            [27.113040695676403, 2.568529109076401],
            [27.110064577140111, 2.570136058778759],
            [27.101834727241648, 2.565062118856511],
            [27.099783814159188, 2.565517850290063],
            [27.095656664486427, 2.566435120944974],
            [27.079144455466235, 2.563718197400618],
            [27.078730552207499, 2.563650093365957],
            [27.074313313173313, 2.563961727431666],
            [27.069121796432789, 2.56432798592146],
            [27.0556257627257, 2.562008026299568],
            [27.052714709165439, 2.562106455737978],
            [27.042584769727497, 2.56244897201862],
            [27.033200925150446, 2.5656579303443],
            [27.025662617222341, 2.556442085130328],
            [27.018141501252124, 2.537332102817618],
            [27.013798463060386, 2.535254987941027],
            [27.006210103699605, 2.534215685225439],
            [27.00190478846158, 2.533626028804675],
            [26.995271110075727, 2.534306957696157],
            [26.989781793733695, 2.532228077931249],
            [26.987754762363071, 2.532516169741466],
            [26.984976516632731, 2.532911028639144],
            [26.980395834522476, 2.536816877613659],
            [26.9730767218119, 2.534965099741275],
            [26.956143768862074, 2.53862201657909],
            [26.95089252493494, 2.537155541991267],
            [26.949511852970794, 2.536769972091545],
            [26.941960855440996, 2.53790899961894],
            [26.94026367017134, 2.53770564644899],
            [26.938071777284833, 2.537443017426321],
            [26.930041621077411, 2.53136507059031],
            [26.929534608337786, 2.530981361909395],
            [26.928931741764075, 2.530525110334419],
            [26.922692333058102, 2.529443830060875],
            [26.919555053166597, 2.528900144864288],
            [26.915663587288385, 2.529354026296023],
            [26.903761375999462, 2.535317844324055],
            [26.90146987342267, 2.536466040673598],
            [26.893236030512778, 2.534842209386289],
            [26.90327779222077, 2.550046075852894],
            [26.905547627432902, 2.56086514999009],
            [26.909650837901651, 2.570996979893491],
            [26.909725166304888, 2.574067632498748],
            [26.910079629837913, 2.588717107212625],
            [26.919207786037322, 2.60207908522433],
            [26.931317820770612, 2.611993079285613],
            [26.934968579475175, 2.618902075898173],
            [26.931752700589573, 2.627182054778494],
            [26.933333820829546, 2.640532094864298],
            [26.936303819143816, 2.642608135091104],
            [26.938480205311894, 2.642819638785022],
            [26.941107982333815, 2.643075237130348],
            [26.945449615560459, 2.646534074251281],
            [26.95551665047066, 2.64770000674297],
            [26.962374647166111, 2.651392060393017],
            [26.963513687590158, 2.654616004477517],
            [26.956620769786369, 2.672786020171992],
            [26.957609136686123, 2.677289325493581],
            [26.957984809443019, 2.679001001015976],
            [26.962010751322598, 2.682338010160989],
            [26.970780644115358, 2.68960713802766],
            [26.975567561448546, 2.701350977188053],
            [26.978539737279043, 2.70388599171998],
            [26.987004756237415, 2.704359110814476],
            [26.994795878832548, 2.696086415325969],
            [27.003929069190825, 2.702977556355207],
            [27.002021069985229, 2.708281430452855],
            [26.999163750950313, 2.713600763390738],
            [26.999843816044589, 2.719519789383039],
            [27.000098311459521, 2.721734812017729],
            [27.010532906441259, 2.725879586991657],
            [27.018603381733577, 2.724790061804913],
            [27.028098017331217, 2.723677131133983],
            [27.037594454051042, 2.721605731669385],
            [27.045187210665148, 2.722441241064663],
            [27.06178260278233, 2.736915142321054],
            [27.062099471820726, 2.737213483130714],
            [27.072064797677793, 2.746596046803295],
            [27.081118433234515, 2.757478095406102],
            [27.088742509610992, 2.766640123562096],
            [27.097657545000811, 2.773096021554106],
            [27.111815619105982, 2.79520911677557],
            [27.118204794936144, 2.808318537901254],
            [27.118661735581828, 2.809256090837125],
            [27.118715208697413, 2.809505022468703],
            [27.120936574410091, 2.819846112795234],
            [27.12481449279548, 2.828366086365664],
            [27.127535731437884, 2.847012062021636],
            [27.122718573218975, 2.855751082185157],
            [27.126368612372996, 2.863811052995884],
            [27.127719692035022, 2.880614114351153],
            [27.132275489913614, 2.895808978999348],
            [27.134555728515068, 2.902947065167603],
            [27.139580830552557, 2.910317724265318],
            [27.142097172461803, 2.906953678257024],
            [27.14233172437914, 2.90664011044833],
            [27.151133178581055, 2.900869880896041],
            [27.154244715451501, 2.898830030874512],
            [27.155854001468903, 2.898306261524052],
            [27.163403594033607, 2.89584911897816],
            [27.169367711325844, 2.884809080276749],
            [27.173258880759985, 2.884814308948371],
            [27.175018357008074, 2.885954758505326],
            [27.176459707474692, 2.886889006704215],
            [27.181271465022117, 2.882983132549528],
            [27.182656743547042, 2.873779011944248],
            [27.185635742082134, 2.871020083622635],
            [27.187290669702495, 2.871126282320027],
            [27.196594250707221, 2.871723302744805],
            [27.196620416834808, 2.871724981828156],
            [27.199351062634882, 2.870117502677206],
            [27.215047727141247, 2.860877132557753],
            [27.217445699842123, 2.85946609648574],
            [27.21769055992732, 2.859321986385652],
            [27.223189481954719, 2.854035071367259],
            [27.232348978577761, 2.851743847626382],
            [27.23921847460716, 2.846918996858191],
            [27.246775589664061, 2.843936070752691],
            [27.252503547054587, 2.837728083731613],
            [27.257323584373996, 2.825997132001493],
            [27.261220782402024, 2.820247951328459],
            [27.261569110441638, 2.820024726082552],
            [27.269467456847419, 2.814963073653196],
            [27.271992496245261, 2.80783199384179],
            [27.285975608177488, 2.787824988992614],
            [27.304524597984067, 2.776568061443466],
            [27.32010358947641, 2.759554111091239],
            [27.327434647983655, 2.753807667011816],
            [27.344155895868752, 2.749226913057124],
            [27.361733245406164, 2.740313544740011],
            [27.373131558414602, 2.736293757259326],
            [27.384047472522184, 2.736596020459995],
            [27.39493998641494, 2.74984097446385],
            [27.403954020640658, 2.752091447744715],
            [27.424350889004121, 2.758950494280934],
            [27.436701992932125, 2.766318112876386],
            [27.439996840019443, 2.768283530917129],
            [27.45092067367457, 2.764271580339362],
            [27.460893027950458, 2.761233714805794],
            [27.475093579792144, 2.782573315157933],
            [27.487896971092628, 2.789076288943726],
            [27.498813964975191, 2.788899151349636],
            [27.504035041678463, 2.78881436368958],
            [27.506404559344414, 2.790693205693872],
            [27.504960961292959, 2.801741178271749],
            [27.49972944436945, 2.80757798999103],
            [27.499715763925984, 2.815247312617687],
            [27.507306719417944, 2.817041325126675],
            [27.513003356147806, 2.816469603495885],
            [27.515850954513027, 2.816423339295626],
            [27.518224433749378, 2.816384995802554],
            [27.518216513303535, 2.820698827659742],
            [27.518672993113469, 2.830756992056316],
            [27.51876702696077, 2.831029898531989],
            [27.522450470866925, 2.841719974626867],
            [27.528610427179288, 2.847371714299721],
            [27.532882401445541, 2.84908005045337],
            [27.536673341351865, 2.85059602109446],
            [27.558056608406307, 2.836828389261616],
            [27.566610203048317, 2.830937902416469],
            [27.580858993522476, 2.825434230606042],
            [27.59463402419383, 2.819458898805717],
            [27.604602417797611, 2.818817873000844],
            [27.607912049357857, 2.825953842604077],
            [27.603612988190857, 2.840882378567572],
            [27.602638829943928, 2.85479792792366],
            [27.602630189947547, 2.859591151160198],
            [27.610689991457651, 2.864732590433918],
            [27.623233382467156, 2.862465003180556],
            [27.637270436435553, 2.863822016340035],
            [27.644383308533314, 2.867540930438467],
            [27.655752456837718, 2.879818121937471],
            [27.658112614956742, 2.886969270139138],
            [27.659902745315584, 2.892392616427161],
            [27.660945092879089, 2.895550479741342],
            [27.660914132442823, 2.912805040142742],
            [27.638105275863371, 2.927553257680947],
            [27.605369848544832, 2.936894667738007],
            [27.588243525145273, 2.94178181879574],
            [27.577792736233924, 2.946743861466331],
            [27.558793394025948, 2.954720378543938],
            [27.551976563526715, 2.958385619793591],
            [27.553571959793196, 2.96552195400709],
            [27.553109000435128, 2.972196119264134],
            [27.546690926700606, 2.983699108885654],
            [27.545769524713684, 2.989682190321804],
            [27.555031039410263, 2.992063695477014],
            [27.557439940116595, 2.992683065029281],
            [27.562533254826917, 2.992469579268785],
            [27.563274602989843, 2.992438504722071],
            [27.568199870758274, 2.992231893462818],
            [27.569645747835597, 2.991199631320971],
            [27.578505120017176, 2.984874213905536],
            [27.603339031673606, 2.993296117811788],
            [27.616624099629483, 2.995956109201209],
            [27.633700682413419, 3.001429958159444],
            [27.658378946573865, 3.008746373091399],
            [27.673548322466317, 3.013243643702388],
            [27.690557946625642, 3.056097804056729],
            [27.704768211950476, 3.072160378991096],
            [27.705703491111898, 3.079812377251602],
            [27.692408360228235, 3.082903288107749],
            [27.662997817863459, 3.07379639527231],
            [27.647802230927667, 3.077876438500553],
            [27.660098378621509, 3.102595272925654],
            [27.655509442790422, 3.116165703641057],
            [27.646737712942929, 3.142105030567279],
            [27.648610431714054, 3.156449852789302],
            [27.656178704745102, 3.170701977135612],
            [27.660897580085404, 3.185958573656638],
            [27.65509150789271, 3.247382485918076],
            [27.661702180424129, 3.266440000411762],
            [27.665480377728159, 3.276919309647206],
            [27.661892621467725, 3.292548366980628],
            [27.657709748399579, 3.302788758846816],
            [27.64534666274232, 3.298638058705057],
            [27.636183404873197, 3.304845969127373],
            [27.629540329211142, 3.306683054598762],
            [27.627019261265165, 3.311515041269639],
            [27.626918770327595, 3.311560842302093],
            [27.624497453107416, 3.312664084969762],
            [27.621962737955638, 3.312450055424451],
            [27.616255258560344, 3.311968120192149],
            [27.611910421043085, 3.303909071589474],
            [27.608933471565141, 3.304137024889489],
            [27.598852901738578, 3.309884530338381],
            [27.592435930236924, 3.317704491891435],
            [27.590376893689346, 3.315862121176012],
            [27.588097015312332, 3.30297108161324],
            [27.580776781504277, 3.293758954407095],
            [27.564292394206756, 3.291214066673271],
            [27.558562259299965, 3.296733462683298],
            [27.555252805606145, 3.292151078356036],
            [27.55307475396155, 3.289134111867179],
            [27.551012730515655, 3.289592074767527],
            [27.548716115626583, 3.295805992214885],
            [27.547175874121891, 3.296094788887492],
            [27.545052358299849, 3.296492892999104],
            [27.53773198255799, 3.289352045050821],
            [27.528803472438902, 3.287273260930917],
            [27.526282382933367, 3.289112693323287],
            [27.523528000050256, 3.296016018533826],
            [27.523185845233257, 3.296194434107166],
            [27.517802041411201, 3.299003066888134],
            [27.50589458216437, 3.298992987462252],
            [27.49971781837305, 3.293003960098778],
            [27.493992023227403, 3.292768968251328],
            [27.491018786486531, 3.290003942890916],
            [27.489881891239385, 3.280336532384987],
            [27.487134029226905, 3.282865078381963],
            [27.483239358159778, 3.283322026668817],
            [27.480038075999211, 3.278256051714915],
            [27.476374580082236, 3.278021999847985],
            [27.47316604222911, 3.280091028129541],
            [27.471560083571493, 3.284922984056147],
            [27.473150922684564, 3.296663058215941],
            [27.470858084312958, 3.30149511237941],
            [27.466961808854713, 3.305865083300619],
            [27.465321919032196, 3.306110964825688],
            [27.462896111133926, 3.306474685478157],
            [27.462380199683089, 3.306551999607204],
            [27.45597175499012, 3.303323400477299],
            [27.461241053257819, 3.299415110732628],
            [27.462163012200211, 3.295042953241562],
            [27.460107054179119, 3.288595967537625],
            [27.457133096989406, 3.286522055471074],
            [27.45047375553251, 3.285721411372434],
            [27.447911503424034, 3.285413355386342],
            [27.443625425607852, 3.284898046057895],
            [27.437216432942517, 3.281900306454974],
            [27.425536130681586, 3.284190939196987],
            [27.421874008288672, 3.282806960923264],
            [27.421188927900204, 3.280044066346341],
            [27.425326044381027, 3.264165956725154],
            [27.424876044119223, 3.257490967061556],
            [27.420987181558733, 3.252883162186103],
            [27.420258839204479, 3.252562162938231],
            [27.417324851654985, 3.251269027620134],
            [27.411372502293027, 3.251263083866439],
            [27.404038182002989, 3.257470995162746],
            [27.403348062964064, 3.262303959946335],
            [27.405400062109717, 3.27013195167763],
            [27.403791897189759, 3.274042790908714],
            [27.395323616448593, 3.271273326860995],
            [27.38388108027705, 3.264355971972671],
            [27.382969920880996, 3.261824066867752],
            [27.384575879538612, 3.258372128281708],
            [27.392135872797681, 3.25377594410078],
            [27.393512871550627, 3.249404123726324],
            [27.391456770697395, 3.245949985907921],
            [27.388251070622267, 3.245947099339173],
            [27.383272278534282, 3.248184997499003],
            [27.381608022807992, 3.248932942788367],
            [27.377259191380968, 3.247087217494952],
            [27.37267608741271, 3.251915933171477],
            [27.364662856363566, 3.249376052687214],
            [27.361004179009786, 3.245919033620101],
            [27.358267101272293, 3.23486808005048],
            [27.352549082842053, 3.229799066260556],
            [27.346274881486831, 3.229544886968275],
            [27.340872515776052, 3.229326027810309],
            [27.334022921921779, 3.222821008217167],
            [27.332867224935718, 3.221723362904556],
            [27.330346244126325, 3.224252110223201],
            [27.328735966368832, 3.231154950209207],
            [27.329417086085229, 3.236910969655118],
            [27.326893064478632, 3.240129855432067],
            [27.324980340134637, 3.239831951992313],
            [27.323714530355996, 3.239634743133019],
            [27.317965441895044, 3.238739052934967],
            [27.313390978821495, 3.234131034083843],
            [27.3092788912011, 3.225611126670935],
            [27.306016195716133, 3.226196024756597],
            [27.303178988163801, 3.226704653141125],
            [27.30034896713375, 3.227211947660585],
            [27.293889685880504, 3.251803425376015],
            [27.290701648480475, 3.262517122791933],
            [27.288159214105502, 3.27106112385142],
            [27.283399301028059, 3.27880411700144],
            [27.273899245894295, 3.282791028956271],
            [27.258720816780396, 3.277287996054459],
            [27.246380550127974, 3.277488073079252],
            [27.243498035145969, 3.29669902968091],
            [27.253896982282289, 3.320485171752847],
            [27.272862117542562, 3.331675507082592],
            [27.286078061035617, 3.37266161214699],
            [27.285078703248345, 3.400462978397307],
            [27.280310394516263, 3.412995416775804],
            [27.289786523022471, 3.422422672441688],
            [27.294524479477722, 3.42713625646483],
            [27.297349756504769, 3.439545282928949],
            [27.298031522109849, 3.447973011974676],
            [27.298278557016353, 3.451026746798425],
            [27.313455063735532, 3.457487031874566],
            [27.319112819583253, 3.478471948439813],
            [27.337100925580973, 3.505004286195726],
            [27.351090779369379, 3.520971505183639],
            [27.367416573595094, 3.538999899216808],
            [27.374044170386458, 3.548471909448193],
            [27.369247893506316, 3.576329726588055],
            [27.369220534416048, 3.591656665839977],
            [27.36726551020196, 3.623298547354445],
            [27.362506969750285, 3.630080801131715],
            [27.346350173782351, 3.640879081981983],
            [27.331157818086616, 3.643041060119027],
            [27.327355499220591, 3.645976270852977],
            [27.321644460700099, 3.654689393889389],
            [27.333909297614742, 3.69663413699066],
            [27.332930817572976, 3.712932170571139],
            [27.34238816589983, 3.731582002334991],
            [27.338483817282178, 3.739865099419073],
            [27.337421843326318, 3.748581185983566],
            [27.336633073997849, 3.75505489980082],
            [27.33434297638615, 3.755283068511623],
            [27.329278953940648, 3.780134517689321],
            [27.329043899865066, 3.781287986722581],
            [27.322614369017426, 3.794632184090022],
            [27.319974105413053, 3.797508617065265],
            [27.317337063167265, 3.800382078800916],
            [27.310218785008143, 3.813954996359264],
            [27.303338827198914, 3.820853046863952],
            [27.295302909197272, 3.834885988230368],
            [27.287959991131679, 3.844085066855015],
            [27.276263600043997, 3.851669081016589],
            [27.254490518055118, 3.856707876347667],
            [27.25650971970974, 3.870138157433589],
            [27.259678080411781, 3.873300781397958],
            [27.277378200004112, 3.879292075154192],
            [27.276620551910348, 3.881488377248739],
            [27.270710279636269, 3.898621116619749],
            [27.266683907463648, 3.905075354221075],
            [27.264970440229469, 3.907822010819572],
            [27.258316200305053, 3.91425915970997],
            [27.256244399595616, 3.922774099157418],
            [27.255998519922578, 3.937045003151883],
            [27.253357920348286, 3.941070511811924],
            [27.250717319875665, 3.945095999825471],
            [27.23808131974689, 3.953430101907271],
            [27.232599240232773, 3.957045139865073],
            [27.227085479833523, 3.96785707507728],
            [27.223625519702033, 3.987189069024065],
            [27.223845125449667, 3.991385797731585],
            [27.224071199965632, 3.995706127019953],
            [27.227504160332924, 4.000314131924473],
            [27.229324308795306, 4.010905007095317],
            [27.228839105354147, 4.011992202194762],
            [27.224498160237047, 4.02171808603958],
            [27.223905144588738, 4.021879950317797],
            [27.221977439939081, 4.02240611995672],
            [27.220133520257669, 4.029769142594985],
            [27.223247145711134, 4.035831555512901],
            [27.223564305803659, 4.036449083025652],
            [27.22102919988474, 4.047495132877909],
            [27.218046239779252, 4.050714059934679],
            [27.208418400194603, 4.051393079732322],
            [27.204634800422461, 4.052884603455526],
            [27.200851183582341, 4.054376146942889],
            [27.197635319968089, 4.058976061019195],
            [27.191192399731147, 4.078995108437649],
            [27.194923507347958, 4.093085268303422],
            [27.198265320154928, 4.105705079920215],
            [27.199517767493742, 4.113657337878014],
            [27.200767320460677, 4.121591134456223],
            [27.202086221570941, 4.123532264476297],
            [27.203741280345348, 4.125968137352212],
            [27.205799399713023, 4.12705407013692],
            [27.207652193851128, 4.128031639717442],
            [27.208551240363882, 4.128505993540706],
            [27.210582474053393, 4.131015219607699],
            [27.213587280288298, 4.134727103767644],
            [27.215052999353645, 4.144064649628101],
            [27.215177394460913, 4.144857118607277],
            [27.215142839865194, 4.145199904181705],
            [27.214481159691548, 4.151762101046812],
            [27.229089240346703, 4.202419987712749],
            [27.226824472531096, 4.211814314725774],
            [27.226093354382577, 4.214846992216341],
            [27.227920320159669, 4.221754150776096],
            [27.232271279695581, 4.224752001657798],
            [27.240524276483949, 4.224761258546935],
            [27.240169680000253, 4.248920585976216],
            [27.239450039626149, 4.261896765565687],
            [27.239879519671923, 4.270085890440448],
            [27.240551257383508, 4.297753827283463],
            [27.240890400149333, 4.311722271106882],
            [27.246507839607119, 4.331023813337064],
            [27.254409840359461, 4.345529699751141],
            [27.265470839571961, 4.366384087798981],
            [27.265872600302998, 4.383903389796156],
            [27.264672360353561, 4.405758132357193],
            [27.266906519872531, 4.417802580726439],
            [27.27323495970797, 4.427086094006429],
            [27.291777479847887, 4.451299149639449],
            [27.294262919711382, 4.455149387791325],
            [27.294703919752369, 4.459469831683309],
            [27.29401488048839, 4.462205649184981],
            [27.292191119900277, 4.464722248658052],
            [27.281042100162946, 4.470871037512096],
            [27.27278748011889, 4.470632070753418],
            [27.267545520280191, 4.467888018459516],
            [27.26362294933698, 4.465834997406127],
            [27.255600359639207, 4.461636063006847],
            [27.217310400085623, 4.458369104063236],
            [27.216895343390046, 4.457991866993123],
            [27.210209400122668, 4.451915102633808],
            [27.194397479968707, 4.444070104211106],
            [27.188434439756527, 4.444523089471089],
            [27.181091159669869, 4.449118153381742],
            [27.173107084341588, 4.451310786658146],
            [27.171915479896981, 4.45163803141246],
            [27.168131598053851, 4.451518533601977],
            [27.164348280352698, 4.451399052902345],
            [27.155172240355377, 4.455300140781305],
            [27.151718400445947, 4.459402091235067],
            [27.145296359751139, 4.467026996534164],
            [27.137497320303389, 4.468628116262018],
            [27.132677280289055, 4.471614011908859],
            [27.115405769376647, 4.473710039832188],
            [27.112035240124968, 4.4741190781465],
            [27.090009359638739, 4.482836075357651],
            [27.077858153319344, 4.481899162003351],
            [27.072578519934272, 4.485805022390002],
            [27.07188839999705, 4.487876126955261],
            [27.056039450388766, 4.49764340554789],
            [27.040212409791963, 4.507397050036396],
            [27.039716612518667, 4.506939253038476],
            [27.037466279731351, 4.504861046970581],
            [27.033796439911843, 4.504856016386577],
            [27.030819077208903, 4.501859226311628],
            [27.016817354878942, 4.511046152180815],
            [27.006038280240251, 4.511261033764423],
            [26.995037399879838, 4.50710206406383],
            [26.994528861800873, 4.507063544154003],
            [26.988846480436287, 4.506633127497388],
            [26.982818336620493, 4.509042810507457],
            [26.980816319737279, 4.509843091974227],
            [26.969583240147287, 4.50660402050148],
            [26.959947508862875, 4.510042064586341],
            [26.961080031111248, 4.513230362706726],
            [26.969764319847304, 4.537678049694604],
            [26.969873141760822, 4.542706653295216],
            [26.969978520431866, 4.547576071516482],
            [26.972723520411861, 4.553104157229111],
            [26.98050744031503, 4.562092009621088],
            [26.979349319674334, 4.568996130097455],
            [26.973925883080273, 4.573913923579707],
            [26.972000279590091, 4.575659988631003],
            [26.971540452657372, 4.576808272904525],
            [26.968315320226033, 4.584862055984056],
            [26.970369479819901, 4.592690061351393],
            [26.974342639388361, 4.595921378378502],
            [26.976324240260137, 4.597532982594857],
            [26.981130239606571, 4.604215074620565],
            [26.981238518039348, 4.607756331002527],
            [26.981348399964908, 4.611349982490907],
            [26.981396999720076, 4.624475996266391],
            [26.978887079866812, 4.628818047059462],
            [26.97672244905252, 4.635971942024664],
            [26.981071299344148, 4.641502087847634],
            [26.994131280032533, 4.651649159055886],
            [27.002592359878367, 4.668234060127334],
            [27.003862633385651, 4.669147467650136],
            [27.013818240369684, 4.676306139881317],
            [27.0154142133546, 4.677910986782503],
            [27.025041239963908, 4.68760003205624],
            [27.027786239943904, 4.693128089494031],
            [27.027549359593355, 4.697270151971464],
            [27.020153112142609, 4.712059277867377],
            [27.01719647986145, 4.717971107053493],
            [27.012894668951368, 4.724693473982359],
            [27.006160319964859, 4.735216994485826],
            [26.988931440400904, 4.752224109860976],
            [26.981956359087928, 4.772003297508324],
            [26.977411572758125, 4.784890603728149],
            [26.981422006122646, 4.787053721068102],
            [26.983829519830191, 4.788351994393769],
            [26.990486986503079, 4.788707802765612],
            [26.997133320354671, 4.789063016177604],
            [27.00113904115722, 4.787147876495349],
            [27.002414681199998, 4.78653807611133],
            [27.003251916434706, 4.786585933828159],
            [27.010671479658651, 4.787010047529933],
            [27.030384359985046, 4.79716509774242],
            [27.035433472193457, 4.797172314225898],
            [27.043791586243117, 4.812953035638818],
            [27.046413359824005, 4.817903057421693],
            [27.046842479645338, 4.838386984778654],
            [27.03907871973373, 4.845242357064838],
            [27.027491759617334, 4.848513242430887],
            [27.013631759998187, 4.852711101325537],
            [26.998842240316879, 4.864197792007104],
            [26.9887924800096, 4.884751945006251],
            [26.98784352040472, 4.898412638764772],
            [26.986869000136725, 4.920720936740091],
            [26.982278639577576, 4.937594050916737],
            [26.972938439648637, 4.948585671410997],
            [26.957453040032487, 4.965083707318716],
            [26.95038372005634, 4.975831041444955],
            [26.9653276798979, 4.988692309703842],
            [26.966076195718504, 4.994774975119852],
            [26.95621140032485, 4.994300103454424],
            [26.947027439881687, 4.997278136018566],
            [26.945541359602128, 5.000000132287215],
            [26.945268705642032, 5.000499394739235],
            [26.944265159908888, 5.002337007647273],
            [26.934850440235532, 5.007155080686122],
            [26.933469569743728, 5.009454975602043],
            [26.929336395968662, 5.010829126490229],
            [26.928898559794124, 5.024914455684096],
            [26.931368519888633, 5.033998712837187],
            [26.936119439931765, 5.0394253281144],
            [26.940873960422532, 5.043714057876358],
            [26.941313519565771, 5.048489632154538],
            [26.936518319765675, 5.057854867360216],
            [26.935584479705341, 5.06650906484748],
            [26.936447759795062, 5.081521818441219],
            [26.944374960087746, 5.087607746158324],
            [26.965017359577942, 5.092690138234923],
            [26.980682399793054, 5.092120004380184],
            [26.987482439881305, 5.095483533876742],
            [26.988311880434267, 5.121874688350636],
            [26.98169868004365, 5.131935846780107],
            [26.977353479607032, 5.142663144862097],
            [26.970192359893662, 5.152197151087908],
            [26.979593400021887, 5.15750410927774],
            [26.985328199879941, 5.158894113204478],
            [26.99794826748883, 5.165335686266272],
            [27.001152359579621, 5.166971117702269],
            [27.01380557053092, 5.177281980692811],
            [27.01874519966578, 5.181307145164789],
            [27.029123279836359, 5.187033135735928],
            [27.050916239745813, 5.193277064688806],
            [27.057222359141438, 5.196311802513258],
            [27.066742199669338, 5.200893073414735],
            [27.07867223986748, 5.204131100725374],
            [27.112175424021682, 5.206706715371882],
            [27.142931171066536, 5.204215788782925],
            [27.157397361924247, 5.199631822575088],
            [27.158041399185734, 5.199242883698099],
            [27.173436385165182, 5.189948848453589],
            [27.181744076777928, 5.184932933681782],
            [27.195990305256863, 5.172062887239692],
            [27.231818096702728, 5.152314862836523],
            [27.257532804698617, 5.143138775181378],
            [27.268548764179407, 5.141079922042932],
            [27.290588962912942, 5.13512087520462],
            [27.306201744534704, 5.128463865120265],
            [27.318138579589618, 5.126405861067747],
            [27.324336676572312, 5.122959923558089],
            [27.333066641945649, 5.114683817540952],
            [27.340644613188495, 5.110780789560835],
            [27.360845575158184, 5.105276872214322],
            [27.373472525658766, 5.100226890621267],
            [27.385421240035036, 5.097842800823382],
            [27.394130325866204, 5.096104766791089],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Goma",
        AREA: 59483,
        POPULATION: 6655000,
        DISTRICTS: [
          "Beni",
          "Lubero",
          "Butembo",
          "Rutshuru",
          "Goma",
          "Walikale",
          "Masisi",
          "Nyiragongo",
          "Beni town",
        ],
        OBJECTID: 19,
        NOM: "Nord-Kivu",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.862567330400228, 0.950517959269274],
            [29.862756329647791, 0.93074809415527],
            [29.861375372019403, 0.92546397717028],
            [29.862037410620857, 0.913740027282377],
            [29.86096137353924, 0.904289043366794],
            [29.860179453864799, 0.897422990789453],
            [29.864959524238909, 0.889827966814362],
            [29.868384417734937, 0.888901207065904],
            [29.875236751450824, 0.890725438290943],
            [29.876829417737191, 0.888193984984428],
            [29.87495922053709, 0.866591006248241],
            [29.878824172639668, 0.857847959546385],
            [29.882471324608357, 0.855083124044503],
            [29.887935392002703, 0.847486031297313],
            [29.895233295489412, 0.843793084437095],
            [29.898639248007701, 0.834362106403925],
            [29.89976136507013, 0.824246107529155],
            [29.908870424883233, 0.813653953639022],
            [29.90703910856524, 0.810900079966928],
            [29.907030963540556, 0.805102872662042],
            [29.907796120651788, 0.805015833094554],
            [29.910682973598313, 0.804686916960727],
            [29.920257459543247, 0.799150013180485],
            [29.922949126544832, 0.798783131260294],
            [29.923682833637951, 0.79868331136125],
            [29.93097609193633, 0.803513082046351],
            [29.93648336110936, 0.807160073400846],
            [29.938436749491299, 0.809435457292461],
            [29.944953386378788, 0.817024947910776],
            [29.949516426475178, 0.81678502893274],
            [29.949868889460067, 0.816503692271849],
            [29.953845956699997, 0.813330030729031],
            [29.955012102889427, 0.814413969504599],
            [29.957050816850341, 0.816309184217967],
            [29.955692939636545, 0.822748017140977],
            [29.957647525472744, 0.824758798665915],
            [29.964614088061882, 0.831923093338346],
            [29.970017238900187, 0.834852863994803],
            [29.970102879787806, 0.834898922194237],
            [29.976621023150035, 0.835783386189912],
            [29.983024107595718, 0.836652103899439],
            [29.984379032945487, 0.836836086125026],
            [29.986745652646331, 0.837157276194805],
            [29.988333286570462, 0.83301990021733],
            [29.986496596530458, 0.828426947687955],
            [29.971628838977782, 0.814438829884912],
            [29.968189814084013, 0.807550988471722],
            [29.960291541340101, 0.786933890999811],
            [29.961739797156305, 0.779524995769437],
            [29.959904906441789, 0.775620952918137],
            [29.958619007638458, 0.774622910069283],
            [29.95075889442947, 0.768515885256999],
            [29.950587896521885, 0.767397995528173],
            [29.94821517456532, 0.751973870450217],
            [29.94135224342401, 0.745092954526672],
            [29.939958345563934, 0.733604912625034],
            [29.942439063882283, 0.718660952146841],
            [29.938075213522058, 0.706259848477372],
            [29.932813178133422, 0.699605939345933],
            [29.922067348346779, 0.691584867974504],
            [29.918861599762611, 0.686076963090647],
            [29.911966627511724, 0.662879963164493],
            [29.910808525735668, 0.654378898599156],
            [29.929650623243059, 0.641191314640634],
            [29.943774995253687, 0.634119198505403],
            [29.949667740498267, 0.629766816992964],
            [29.958520354653945, 0.615405735489261],
            [29.964525056034088, 0.593782851085423],
            [29.971421101771703, 0.578194704351135],
            [29.976039825737601, 0.567401401401464],
            [29.981680931311523, 0.552602569815569],
            [29.981694457244753, 0.55258403834967],
            [29.988660135891646, 0.543040521925552],
            [29.991322650765625, 0.531019995279757],
            [29.992673706173164, 0.498098010952233],
            [29.992317311262273, 0.482026968146715],
            [29.981521807335369, 0.457002520959285],
            [29.971852725197714, 0.433597160613302],
            [29.962970229482423, 0.410602288253965],
            [29.959504565947231, 0.407350050668696],
            [29.952699236578567, 0.406068981610787],
            [29.939407170746637, 0.405117011304816],
            [29.92898641790514, 0.403393837516465],
            [29.918247069463256, 0.400060495146701],
            [29.898660500350701, 0.39582474096015],
            [29.887581314745262, 0.391282595970384],
            [29.883032065585109, 0.385608242852844],
            [29.878781972482557, 0.374313595353307],
            [29.873236977660891, 0.356979415911407],
            [29.873477453069196, 0.337299679392559],
            [29.861557677021487, 0.303023335729939],
            [29.854189670806626, 0.266789383435608],
            [29.847494852184191, 0.221725912326615],
            [29.845309324759786, 0.20583479944176],
            [29.839404335477901, 0.183876850019673],
            [29.831831490920393, 0.172344097539542],
            [29.826096418872783, 0.166154351611107],
            [29.814417115538458, 0.159596747456057],
            [29.804150791179115, 0.156871080631778],
            [29.790350038147874, 0.150289864115921],
            [29.784348927333969, 0.145302087019902],
            [29.768817318379597, 0.131370766786674],
            [29.763256841093988, 0.127593074227751],
            [29.758972903963123, 0.122624397124248],
            [29.751016661137275, 0.11259386043372],
            [29.747988025292837, 0.106835937878272],
            [29.747894786454566, 0.099102292837046],
            [29.748887651218954, 0.088066945424542],
            [29.748092783228021, 0.080225156317323],
            [29.740863008870782, 0.0755250205081],
            [29.734244865051107, 0.070731162638667],
            [29.731008872886292, 0.065071280629802],
            [29.731863140178763, 0.054737394587832],
            [29.733732953798242, 0.044314290719575],
            [29.736447313142207, 0.019941982332424],
            [29.73963038735031, 0.009533653149623],
            [29.746066372593258, 0.002576082883774],
            [29.756918413789187, -0.013269902722484],
            [29.760163045052121, -0.017250548129685],
            [29.76059539880848, -0.021563907384487],
            [29.760192565488975, -0.025384325477652],
            [29.752787474124233, -0.030588578690685],
            [29.746643084717441, -0.036682647831008],
            [29.744453955947069, -0.041125773335986],
            [29.745737696997111, -0.048141015852546],
            [29.749562641730193, -0.053520995582096],
            [29.754247612855046, -0.056079595823729],
            [29.758031518054402, -0.06638103918218],
            [29.757733440873452, -0.06728004603282],
            [29.757736545451056, -0.067308691915982],
            [29.757820560387991, -0.068083888847898],
            [29.75739576685308, -0.071509050915193],
            [29.757067451481365, -0.076734929226245],
            [29.752992670894724, -0.085617930201565],
            [29.749253766799534, -0.098915030758995],
            [29.741770916365475, -0.11024595807955],
            [29.742284988066626, -0.119881063655894],
            [29.746221891630192, -0.16441798762444],
            [29.714355253769007, -0.300591438099668],
            [29.685359724980685, -0.424494503660676],
            [29.680417959652061, -0.445611362481529],
            [29.680396719885486, -0.445702120411233],
            [29.683714562945731, -0.446649863266652],
            [29.683449607547633, -0.455345876908581],
            [29.683941359707234, -0.46243226409005],
            [29.674152020102504, -0.491678877189451],
            [29.676959260755261, -0.49414077973568],
            [29.676975100748646, -0.496667924609404],
            [29.667459355640144, -0.507750797917854],
            [29.669548406697977, -0.513249874764967],
            [29.668659219195465, -0.516930821607492],
            [29.670972187015966, -0.521969772030712],
            [29.668972415920962, -0.530480773954899],
            [29.669250332211988, -0.538288885170215],
            [29.665655423565262, -0.547267910742596],
            [29.665451306569786, -0.551174841016698],
            [29.668083230215075, -0.55499381661365],
            [29.668577142822894, -0.555187919437819],
            [29.674421299990367, -0.555583874239708],
            [29.679223992638285, -0.563265793572107],
            [29.679245952853698, -0.567169828299367],
            [29.665697186242827, -0.590222899165468],
            [29.660966492666638, -0.594049779290609],
            [29.649765608696423, -0.597669760162118],
            [29.654068629637194, -0.608899865258716],
            [29.659513554831165, -0.623109756782876],
            [29.659088401071806, -0.628165913985422],
            [29.649150381304416, -0.645223807933102],
            [29.647638402595209, -0.658786782469115],
            [29.643114706911621, -0.665476793627979],
            [29.641328771685163, -0.671919891902125],
            [29.63974155457932, -0.673537738385069],
            [29.636541557907929, -0.672866774823087],
            [29.636602758331588, -0.682745777201459],
            [29.632970769026574, -0.685982905549907],
            [29.631900863845114, -0.697475753486302],
            [29.62804495777743, -0.701174775889616],
            [29.626016746020525, -0.705781744216747],
            [29.627201850255734, -0.712667767896347],
            [29.626430740907395, -0.720287814498703],
            [29.626693897878312, -0.721049782369615],
            [29.62679952897594, -0.721345964916495],
            [29.627211129852618, -0.722526959259192],
            [29.627785823462357, -0.724111482866967],
            [29.629229208613097, -0.728158657257324],
            [29.629565939402422, -0.729158388338052],
            [29.629889754214577, -0.729273459004541],
            [29.629913670960701, -0.729273362244918],
            [29.629914299781401, -0.729273585605846],
            [29.630362754042597, -0.72927176254666],
            [29.630440607435016, -0.729585928266454],
            [29.630075692003661, -0.72961614528966],
            [29.629784726784798, -0.729745137568012],
            [29.629630738477115, -0.730062758565837],
            [29.629909554880065, -0.730291786661714],
            [29.630200010754141, -0.730484141062522],
            [29.629888854102653, -0.730658352585236],
            [29.62954969426881, -0.730934741287487],
            [29.629666018013292, -0.731252895734062],
            [29.630011312442178, -0.731371629644468],
            [29.63028160922299, -0.731811754429139],
            [29.630524606202272, -0.732101366560319],
            [29.630578785393684, -0.732386593747996],
            [29.630481766444692, -0.73274483817981],
            [29.630406257655167, -0.733167361640832],
            [29.630224010145259, -0.733456974587506],
            [29.630142832087991, -0.733748478394612],
            [29.630178291287187, -0.734071160440074],
            [29.630265049679025, -0.73438708376712],
            [29.630357207844021, -0.73472175037596],
            [29.630493286439908, -0.735217352361336],
            [29.630559165289576, -0.735695022142429],
            [29.630447207357388, -0.736093576108234],
            [29.630267077176605, -0.736401584006833],
            [29.630041740177493, -0.73626905703822],
            [29.629613700131138, -0.735829952741517],
            [29.629028160262642, -0.735695149647876],
            [29.629023394700035, -0.735699573453788],
            [29.62900362727224, -0.735695022142429],
            [29.628723191206827, -0.735955348461803],
            [29.629182185401234, -0.73779808648058],
            [29.629458301468446, -0.737938115421662],
            [29.629741617532655, -0.737970195232236],
            [29.629748393524824, -0.737968310684645],
            [29.629766160404518, -0.737970322737607],
            [29.630065685669695, -0.737887048160756],
            [29.630255150244579, -0.738075082420666],
            [29.63012681153322, -0.738299273939568],
            [29.629872115793969, -0.738350727328934],
            [29.629790936838365, -0.738636163908021],
            [29.629679383148076, -0.739134137413171],
            [29.630252510994275, -0.7418451967922],
            [29.63028844989385, -0.742111079624416],
            [29.630357929191188, -0.742514769388273],
            [29.630284969820462, -0.743191429725228],
            [29.630236658424462, -0.743619180798378],
            [29.630454768477126, -0.744023589334884],
            [29.630357749528137, -0.744529207111309],
            [29.630425968489114, -0.744844634132095],
            [29.630650965925096, -0.745001694282972],
            [29.631016360158466, -0.745066543774903],
            [29.63124765747952, -0.745214802444097],
            [29.631401194832925, -0.745496755242015],
            [29.631526112759708, -0.745735094025908],
            [29.631838139878713, -0.745902516424484],
            [29.631858748129627, -0.746297736240338],
            [29.631731490989843, -0.746528415629673],
            [29.631474633904034, -0.746630359143082],
            [29.631496414456429, -0.746912686225774],
            [29.631801989875051, -0.746944119401859],
            [29.631804376698735, -0.746941967187858],
            [29.631826560594693, -0.746944248715554],
            [29.632011440168363, -0.74677747202137],
            [29.632226303709583, -0.746911019616367],
            [29.632372462301266, -0.747274309710801],
            [29.632041806818247, -0.747595443515614],
            [29.631642391588397, -0.747667936944416],
            [29.631341976092774, -0.747777239554613],
            [29.630887122233478, -0.747816646766196],
            [29.631038680598351, -0.748273334706265],
            [29.63131803688875, -0.748543798284843],
            [29.631516633736833, -0.748982450060802],
            [29.631647432035443, -0.74927133943079],
            [29.631726811665526, -0.749622674599628],
            [29.631527013769929, -0.749932919662541],
            [29.631428375158471, -0.750247581259969],
            [29.631274958179311, -0.750519230240311],
            [29.630957099197513, -0.750533145467922],
            [29.630652228058043, -0.750371629172145],
            [29.630642197469594, -0.750379193565366],
            [29.630627674406387, -0.750371498954244],
            [29.630299970787391, -0.750618650688251],
            [29.630091533793674, -0.751080910571814],
            [29.630000094280923, -0.751337451515294],
            [29.630096124184774, -0.751693494252873],
            [29.630184053081432, -0.752038950431794],
            [29.629577281531208, -0.752617992036832],
            [29.62928694423475, -0.752842123122307],
            [29.629178766413283, -0.753157384956089],
            [29.629260665817725, -0.753485021074272],
            [29.629103257623765, -0.753774136215107],
            [29.628949810101862, -0.75422571790262],
            [29.629091828358387, -0.754518933044538],
            [29.629110907676708, -0.754839000152059],
            [29.629050427701891, -0.755258548163873],
            [29.629066448256662, -0.755629165919383],
            [29.629080667689319, -0.755956892277867],
            [29.629339144437584, -0.756166034587905],
            [29.62935800995686, -0.75616157824843],
            [29.629363680122946, -0.75616616570991],
            [29.629726107220939, -0.756080547563632],
            [29.62961886095243, -0.756384369895945],
            [29.629464242925749, -0.756657940103853],
            [29.629364884763749, -0.757014771845105],
            [29.629060148371586, -0.757258787121295],
            [29.628743712321185, -0.757564271453805],
            [29.628943510216786, -0.757859723578949],
            [29.62929846602659, -0.757905769990167],
            [29.629304157752195, -0.75790345681814],
            [29.629323000813613, -0.757905901112108],
            [29.629771102935216, -0.757723807989824],
            [29.630095674128828, -0.757750962894164],
            [29.630443789267733, -0.757806740363901],
            [29.630467387111924, -0.757806718660966],
            [29.630468340224443, -0.757806871485855],
            [29.630805053047457, -0.757806563123204],
            [29.630735775871063, -0.758310524434283],
            [29.630441629717776, -0.758452820669227],
            [29.630136353438157, -0.758679535907952],
            [29.63061973689253, -0.758717470836892],
            [29.630759384495047, -0.759077531622418],
            [29.630519028562659, -0.759409147967808],
            [29.630348640611171, -0.759717808009171],
            [29.630085480047004, -0.759676992928939],
            [29.630084358051196, -0.75968049433561],
            [29.630060934480174, -0.759676861807048],
            [29.629959416768223, -0.759993775273373],
            [29.630147693770311, -0.760377998547196],
            [29.630226352951528, -0.760624355738912],
            [29.629871937029215, -0.760830165516603],
            [29.629611121067938, -0.761024169796247],
            [29.629423023728933, -0.761340361540059],
            [29.629342384660813, -0.761612490898708],
            [29.62969481979793, -0.761699355043529],
            [29.629700033619816, -0.761694724182159],
            [29.629719359974839, -0.761699487069665],
            [29.629922039665892, -0.761519450461456],
            [29.630192400227063, -0.761235516513634],
            [29.630609193366062, -0.761022876663499],
            [29.630531807995904, -0.761359284682616],
            [29.630316051529263, -0.761592816293545],
            [29.630360990649702, -0.761874482262083],
            [29.63038465227428, -0.761869051105625],
            [29.630385539809776, -0.761874614288193],
            [29.630676240025593, -0.7618078886512],
            [29.63094434851034, -0.761743666083669],
            [29.631076480807181, -0.762045103404245],
            [29.63078236429833, -0.76229942094987],
            [29.630740487534705, -0.762575042608575],
            [29.63046267005836, -0.762484290946116],
            [29.63045404443503, -0.762489361290756],
            [29.630438119999983, -0.762484158920032],
            [29.630120739820203, -0.762670728970209],
            [29.630262531701298, -0.763110415614516],
            [29.629861905542459, -0.763327239501471],
            [29.62947312007736, -0.763318834143167],
            [29.629473161399865, -0.763319233838525],
            [29.629448583493712, -0.763318702117083],
            [29.629496912855988, -0.763788169612615],
            [29.629734660080768, -0.76452571049665],
            [29.629757411711953, -0.764520294716457],
            [29.629759200257713, -0.764525842522658],
            [29.630191596234859, -0.764422930038127],
            [29.630506609353858, -0.764597482017248],
            [29.630438749718984, -0.764990852649984],
            [29.630721286045517, -0.765426077298161],
            [29.630743305549771, -0.765737853981786],
            [29.630492928910389, -0.765998448870288],
            [29.630339840714637, -0.766233542834586],
            [29.630526769345487, -0.766427006103189],
            [29.630446729453666, -0.766729171042058],
            [29.630184053979729, -0.767001539690871],
            [29.630260373049669, -0.767429646486977],
            [29.630556648210142, -0.767473439310615],
            [29.630573495214975, -0.767472433743165],
            [29.63058120006518, -0.767473572240829],
            [29.630914261236558, -0.767453682442492],
            [29.631178719866298, -0.7675780563023],
            [29.63181699084198, -0.767954530052228],
            [29.63214170666436, -0.768197283219385],
            [29.632021599215907, -0.768552932088154],
            [29.63167200006016, -0.768529917983206],
            [29.631398400174088, -0.768325032760956],
            [29.6313834378347, -0.768332088912989],
            [29.631373837539254, -0.768324899830754],
            [29.631046962166952, -0.768479053645875],
            [29.630640887725921, -0.769004567368472],
            [29.630983332698751, -0.771121356046642],
            [29.631373117090416, -0.771410379558661],
            [29.631880349917264, -0.771567169255549],
            [29.632087168146814, -0.771838485906436],
            [29.631825631736699, -0.772292768583909],
            [29.631385984558538, -0.772489395671432],
            [29.631147840278409, -0.772385669523763],
            [29.630851200401917, -0.772245895811571],
            [29.630847193017431, -0.772255444169895],
            [29.630826645851954, -0.772245761977202],
            [29.630697407028638, -0.772553678662683],
            [29.630841405172063, -0.772834096889441],
            [29.630891204178159, -0.773192909462618],
            [29.63098540241716, -0.773583140516077],
            [29.630986843314869, -0.773910804898259],
            [29.630416610738816, -0.774104628623742],
            [29.630206013296878, -0.774688893084911],
            [29.630272972819824, -0.77497453793967],
            [29.630476010040358, -0.775293431547064],
            [29.630455971321304, -0.775568173390085],
            [29.630106655134885, -0.775646928519187],
            [29.629674301378525, -0.775687657537834],
            [29.629262106715437, -0.775726584315143],
            [29.628879432489263, -0.776034394943095],
            [29.628658035500951, -0.776463672771688],
            [29.628525197128333, -0.776721562277465],
            [29.628456617942888, -0.776982967628219],
            [29.628756494449355, -0.777313124857828],
            [29.62873879404501, -0.777695336326506],
            [29.628429902046342, -0.777804937482241],
            [29.627985780359776, -0.777719379457479],
            [29.627986757726781, -0.777724155891081],
            [29.627961265335657, -0.777719244718992],
            [29.628473987767229, -0.780225884140719],
            [29.628495957864143, -0.780213541561498],
            [29.628498509977863, -0.780226018879091],
            [29.628898200092156, -0.780001468753514],
            [29.62918352568764, -0.779984975507509],
            [29.629491694542516, -0.780181054236173],
            [29.629425185075476, -0.780555501255121],
            [29.629283347380337, -0.780862409954416],
            [29.629356786451449, -0.781368865233838],
            [29.629716602146917, -0.782037379018308],
            [29.629618862749055, -0.782352623298214],
            [29.629376225994207, -0.782606369009291],
            [29.629176069670795, -0.783081240152498],
            [29.629199829211764, -0.783470329072587],
            [29.629248067844195, -0.78374425832816],
            [29.629410965642862, -0.784479813505092],
            [29.629210765302027, -0.784751628478887],
            [29.628941220411118, -0.784627546310141],
            [29.628690120627951, -0.784340280738529],
            [29.628674182718179, -0.784349967424494],
            [29.628665596620689, -0.784340145095989],
            [29.628392359654011, -0.784506214968279],
            [29.628255201283149, -0.784829613888528],
            [29.628480079243179, -0.785190078456692],
            [29.628609796868513, -0.785539939366885],
            [29.628450858843628, -0.785954392296289],
            [29.628435019748537, -0.786400743772449],
            [29.628627437085754, -0.786884536135654],
            [29.628978071100715, -0.786968336949106],
            [29.628983826606724, -0.786963985539183],
            [29.629002599599531, -0.78696847259157],
            [29.62923623972685, -0.786791860686477],
            [29.629208160187677, -0.786378577983697],
            [29.629006200047197, -0.786039575777762],
            [29.629072800244035, -0.785586029784321],
            [29.629335898824472, -0.785451353056828],
            [29.629746720861768, -0.785563127000288],
            [29.629925099327743, -0.785834232944606],
            [29.630039877071582, -0.786358483907569],
            [29.630096936261815, -0.786900394547422],
            [29.630222214413031, -0.787186037656973],
            [29.630472770715425, -0.787354000078824],
            [29.630832046523437, -0.787488261678259],
            [29.631092562447382, -0.787627028410643],
            [29.63112220325851, -0.787929386233348],
            [29.630840686519818, -0.788135419834026],
            [29.630461972067419, -0.788325368043184],
            [29.630048817105294, -0.788571483953824],
            [29.629845659510519, -0.788777531086553],
            [29.629931159362663, -0.789056236409774],
            [29.629945799206823, -0.789407583631642],
            [29.629659388446481, -0.78956302798059],
            [29.62931877064695, -0.789530622114296],
            [29.629446660200692, -0.7890903432353],
            [29.629379520116331, -0.788808365315568],
            [29.629356449583202, -0.788814371560763],
            [29.629354987125932, -0.788808228768897],
            [29.629029551753014, -0.78889296004997],
            [29.628854593173319, -0.789330165293845],
            [29.628478708414043, -0.789412612346575],
            [29.628059970422459, -0.789362711325544],
            [29.628060491445311, -0.789365558006828],
            [29.62803545539834, -0.789362574778861],
            [29.628113544149361, -0.789789627594156],
            [29.628064045180594, -0.790066621042176],
            [29.627640690746762, -0.790278104645001],
            [29.627690009154172, -0.790627995867777],
            [29.627596771214201, -0.790922109128987],
            [29.627369794789654, -0.791240100841948],
            [29.631818074210219, -0.79693052251011],
            [29.632242507520697, -0.796939172860485],
            [29.632702940816191, -0.796948543922668],
            [29.632991297327447, -0.796954491377612],
            [29.633301973380252, -0.797286450140782],
            [29.633371092453157, -0.797541275543205],
            [29.632911738932638, -0.797888642295839],
            [29.632724901031636, -0.798239613480943],
            [29.632830739640092, -0.79848020183161],
            [29.632880870124513, -0.798828694332972],
            [29.63273750170012, -0.799250355742051],
            [29.632529244369486, -0.799540143208395],
            [29.631953072132788, -0.799623313478814],
            [29.631922111696525, -0.799987350457599],
            [29.631930392366804, -0.800366885859652],
            [29.632245027295053, -0.80061288077418],
            [29.632472185179285, -0.800790753551679],
            [29.63277493988792, -0.801134065234735],
            [29.632818500992666, -0.801440431632486],
            [29.632621583095862, -0.801675434056871],
            [29.632516643700999, -0.802073170641916],
            [29.632643902637412, -0.802434503604163],
            [29.6327763798873, -0.802688968779317],
            [29.633013797430383, -0.802882205174107],
            [29.633177414779617, -0.803223489284927],
            [29.633054427332365, -0.8036126766606],
            [29.632693680083943, -0.80356964381544],
            [29.632403550298317, -0.803549954036957],
            [29.632401267679157, -0.803551327637255],
            [29.632378976883714, -0.803549814777935],
            [29.631972632948084, -0.803794398822884],
            [29.638104308498654, -0.816908586539091],
            [29.638126641514969, -0.816903770363377],
            [29.638128960066705, -0.816908728510477],
            [29.638535138712299, -0.816821128548949],
            [29.638869478186322, -0.816896992812285],
            [29.639098075171631, -0.817073603401098],
            [29.639410250512626, -0.817374562815561],
            [29.639335311254996, -0.817627315245263],
            [29.639022850249727, -0.817818514488177],
            [29.638330380319701, -0.817604840365488],
            [29.638334360754737, -0.81761353407653],
            [29.638305726056728, -0.817604698394102],
            [29.638826818990122, -0.818742757820154],
            [29.63870190016501, -0.819803864869034],
            [29.638729565580821, -0.819778474616822],
            [29.638726559817865, -0.819804007744601],
            [29.638978200386859, -0.819573062062918],
            [29.639246039377014, -0.819332684771456],
            [29.639548598252915, -0.819331640332945],
            [29.639528314293788, -0.81975610735806],
            [29.639671097016642, -0.820201464007642],
            [29.639173674690994, -0.820359918404751],
            [29.638854539203155, -0.820469039140933],
            [29.638586341785192, -0.820782613843772],
            [29.638547102475247, -0.821338712455366],
            [29.63884967931746, -0.821365699647735],
            [29.63885282611589, -0.821363923651013],
            [29.638874340766971, -0.821365842523226],
            [29.63916828030769, -0.82119995502319],
            [29.639403288569188, -0.821151781562431],
            [29.639691167176721, -0.821256940646482],
            [29.639927413316656, -0.821388317381628],
            [29.640148840847669, -0.821691679126966],
            [29.640389377341403, -0.82180182075301],
            [29.640682713214275, -0.821970291741877],
            [29.640814531999055, -0.822480601314749],
            [29.640768272355189, -0.82276678265551],
            [29.640705993054851, -0.823153343915972],
            [29.640599794221995, -0.823407447866625],
            [29.640666873220887, -0.823699336018104],
            [29.640439115262062, -0.823963900583367],
            [29.640029760173601, -0.823954182343018],
            [29.640029620934747, -0.823954621820524],
            [29.640005082554435, -0.823954039467629],
            [29.639851814695593, -0.824438240566969],
            [29.639498130001947, -0.824398187531863],
            [29.63949495266078, -0.824400478059448],
            [29.639473459569292, -0.824398044656449],
            [29.639243692977491, -0.824563707761634],
            [29.639191472113389, -0.824875185125815],
            [29.639216871079725, -0.824870957642542],
            [29.639216138054454, -0.824875328905448],
            [29.63962154325062, -0.824807847420272],
            [29.639611968107992, -0.825089934036924],
            [29.639525389379234, -0.825403373634786],
            [29.639700527621979, -0.825749070480503],
            [29.639563368352821, -0.826109771013611],
            [29.639460050417057, -0.826414874930854],
            [29.639523229829283, -0.827014539763486],
            [29.639377251798987, -0.827321897060987],
            [29.639338417629265, -0.827623869383429],
            [29.639628108138705, -0.827805353527186],
            [29.63963466314533, -0.827794147765941],
            [29.639652780367989, -0.827805497306718],
            [29.639853194507864, -0.827462895971975],
            [29.640196360827893, -0.827485652024705],
            [29.640014082775252, -0.827927148358216],
            [29.639984323386543, -0.828182843521458],
            [29.640263650032541, -0.828338308972153],
            [29.640560735473432, -0.828553620151679],
            [29.640155561144287, -0.82876338993073],
            [29.640142421486644, -0.829110800078165],
            [29.640385058241524, -0.829329129679998],
            [29.640776102969518, -0.829735512870162],
            [29.640873390514805, -0.830188393750053],
            [29.640888330396301, -0.830562834304843],
            [29.640975990696667, -0.830920515930305],
            [29.640734964621075, -0.831085229272652],
            [29.640530879964963, -0.83095372988126],
            [29.640399660356447, -0.830660520223165],
            [29.640123599984825, -0.830573161104624],
            [29.640120925700195, -0.83057998022872],
            [29.640098921467331, -0.830573016420937],
            [29.639969024178939, -0.830904206460579],
            [29.639586123577264, -0.831120583636543],
            [29.639677307968508, -0.831423043972698],
            [29.639499830512754, -0.831639572133434],
            [29.638927618948163, -0.831907641123498],
            [29.638676942271488, -0.832114347950137],
            [29.638812059670009, -0.832370050073158],
            [29.639291093481773, -0.832471893792224],
            [29.639163355743303, -0.832867405488916],
            [29.639181631069452, -0.833182408854323],
            [29.639519270953841, -0.833321756351845],
            [29.639339812712883, -0.833619411213008],
            [29.639271414088856, -0.833872763033074],
            [29.639475620915881, -0.834195015868305],
            [29.63972275823032, -0.834475745398392],
            [29.639384452694316, -0.834754792961828],
            [29.639556289628359, -0.835035927565324],
            [29.639889345409856, -0.835171732962491],
            [29.639825806671492, -0.835513284663732],
            [29.639452221599349, -0.835674351786782],
            [29.639267033903508, -0.836081981305058],
            [29.639104736179444, -0.836416069970702],
            [29.638859579650198, -0.836564205969642],
            [29.638760461338396, -0.836806414256754],
            [29.638642502660137, -0.837094757565133],
            [29.638163349372395, -0.837206670224911],
            [29.637873786423736, -0.837274191283401],
            [29.637489240108472, -0.837110221514867],
            [29.637134279807121, -0.83695902096003],
            [29.63713075391961, -0.836967868354304],
            [29.637109643510453, -0.83695887537229],
            [29.636993365580061, -0.837250643145982],
            [29.636717969063426, -0.837353184834605],
            [29.636585130690776, -0.837687122377198],
            [29.636406574358375, -0.838004749546762],
            [29.636222616456195, -0.838336209329513],
            [29.635978899926332, -0.838604954251707],
            [29.635738243058359, -0.838785888990163],
            [29.635896820858836, -0.839033323825737],
            [29.635948659938943, -0.839338606679306],
            [29.635667234828393, -0.839653621273955],
            [29.635497225965938, -0.840082531485628],
            [29.635393908030171, -0.840342040063198],
            [29.63527006987837, -0.840654171760451],
            [29.635153791947971, -0.840947199808351],
            [29.634882715429516, -0.841202923954779],
            [29.634539639839364, -0.841327272025798],
            [29.634205384806972, -0.841502980856534],
            [29.634015846570257, -0.841840522462374],
            [29.634142564720854, -0.842198067405712],
            [29.634200345258257, -0.842602917412215],
            [29.634042126783879, -0.843002903306242],
            [29.633731451629398, -0.843137522924815],
            [29.633604013029935, -0.843594726456804],
            [29.633624713807343, -0.844184116125604],
            [29.633597713144855, -0.844629605620709],
            [29.633414656252864, -0.845091584423668],
            [29.633106320311398, -0.845343343975773],
            [29.632868543442211, -0.845624838610706],
            [29.632755504836748, -0.845910838296109],
            [29.632772784829548, -0.846274149386873],
            [29.632580727716739, -0.846490450647411],
            [29.632169072941171, -0.84660610399653],
            [29.631828757873865, -0.846663832556595],
            [29.631441972956935, -0.846796904841689],
            [29.63146780311461, -0.84731722774073],
            [29.63119564592288, -0.847518347166442],
            [29.630857251453662, -0.847694415612687],
            [29.63060669425294, -0.847824710851396],
            [29.630633334690994, -0.848113053333492],
            [29.630670413552657, -0.848514028826741],
            [29.630542974953187, -0.848839315162945],
            [29.630578974938203, -0.849162799263677],
            [29.630469536780407, -0.849441949752737],
            [29.630357217725489, -0.849728129101899],
            [29.630133662085552, -0.850012776598537],
            [29.630109901646293, -0.850487459723419],
            [29.629901465550937, -0.850867981319618],
            [29.6299630244024, -0.851152539208517],
            [29.62985610512067, -0.851424301679891],
            [29.629705807990458, -0.85180725566383],
            [29.629387392053193, -0.852258150888588],
            [29.629289833216681, -0.852505944752553],
            [29.628978977500825, -0.852665883540205],
            [29.629053137020804, -0.853078482917872],
            [29.629141154850643, -0.85333600845877],
            [29.629132875976996, -0.853675080849051],
            [29.628935598754083, -0.853874668109465],
            [29.62879520105832, -0.854231400798283],
            [29.628676762679675, -0.854532988505993],
            [29.628529974368995, -0.854906479921753],
            [29.628222808932311, -0.855339624010073],
            [29.628145470274564, -0.85571251581708],
            [29.628193829281251, -0.856158964295933],
            [29.628133889193922, -0.856414417047323],
            [29.627971532181046, -0.856683205007421],
            [29.627728174977324, -0.856846568982194],
            [29.62747653889992, -0.85701596983607],
            [29.627356300297457, -0.857322603131122],
            [29.627234621695614, -0.857632480910629],
            [29.627116544439694, -0.857933437169078],
            [29.627140843868148, -0.858501109559408],
            [29.627052464915543, -0.858882441478042],
            [29.62690774632328, -0.859249716536686],
            [29.626760869977684, -0.859623208390561],
            [29.626827108153496, -0.860084058655165],
            [29.626840427474196, -0.860471202132026],
            [29.626997295780701, -0.860845347649148],
            [29.627137513813377, -0.861404030293411],
            [29.627127523649122, -0.861837849122501],
            [29.627116724102784, -0.862134570368579],
            [29.62735720130771, -0.862517704120572],
            [29.627802334497275, -0.862661514003066],
            [29.628146490760738, -0.862711253132095],
            [29.628152250758326, -0.863009235759557],
            [29.628289768455289, -0.863380204339535],
            [29.62864004314412, -0.863572671805156],
            [29.628913279212533, -0.863722609853493],
            [29.629093277340942, -0.864014374672615],
            [29.62931791455248, -0.864378405630635],
            [29.629368313633169, -0.864691075199645],
            [29.629417272714477, -0.864995996095456],
            [29.629469112692881, -0.865316415163578],
            [29.629466412357136, -0.865611152177286],
            [29.629492511111106, -0.86590679162406],
            [29.62988724611828, -0.866249376855705],
            [29.63011062299346, -0.866721355091255],
            [29.630211601716255, -0.867286232880102],
            [29.630212862052584, -0.867671708149837],
            [29.629960505526338, -0.867729827030269],
            [29.629614911060127, -0.867738477223283],
            [29.629230076385664, -0.867747849019233],
            [29.628896000118029, -0.867756138410734],
            [29.628564805645823, -0.867764427802197],
            [29.628461666474806, -0.868039252722998],
            [29.628622764049648, -0.868373998692568],
            [29.629011378834797, -0.868595660069967],
            [29.629275074794901, -0.868821737860091],
            [29.629536791766405, -0.869091786380316],
            [29.62977780796049, -0.869340300738437],
            [29.629961225975212, -0.869529433876097],
            [29.629981924955995, -0.869922568028727],
            [29.630210883064009, -0.870256953027897],
            [29.630278021351714, -0.870603141350875],
            [29.630289361683875, -0.870910764607605],
            [29.630207102953289, -0.871218117464122],
            [29.629773668523665, -0.871234066864219],
            [29.629360754310063, -0.871249385088316],
            [29.629136117098522, -0.871571154588952],
            [29.628716183449299, -0.871728931375501],
            [29.628617004052032, -0.87196555087742],
            [29.628492986237177, -0.872261910518081],
            [29.628381568192481, -0.872527363322943],
            [29.628134943816079, -0.872576529921914],
            [29.627916119602755, -0.872456060359562],
            [29.627527050270047, -0.872428307616714],
            [29.62719972035018, -0.872326667523451],
            [29.627196982285195, -0.87233327316658],
            [29.627175225089026, -0.872326516511504],
            [29.627055345812668, -0.87261575866779],
            [29.627370341863685, -0.872870759069892],
            [29.627574459757493, -0.873036194909573],
            [29.627801255620628, -0.873219831748435],
            [29.62798413284953, -0.873441402410714],
            [29.627857235035886, -0.873743529322401],
            [29.627784426582107, -0.874172706040626],
            [29.628210030397398, -0.874256279817065],
            [29.628046051925434, -0.87449339469381],
            [29.628126331667438, -0.874776689345561],
            [29.628215160675992, -0.875126075623691],
            [29.628141090987551, -0.875453747813588],
            [29.628278249358413, -0.875771102340293],
            [29.628301244433047, -0.875767746622427],
            [29.628302759890918, -0.8757712533521],
            [29.628592380331792, -0.875728993551963],
            [29.628753570433101, -0.875281615113487],
            [29.628990701413606, -0.874996208142934],
            [29.629186517077539, -0.875248575168694],
            [29.629171396634696, -0.875559892856728],
            [29.629250955927834, -0.875810208072657],
            [29.62913539754798, -0.876080888163895],
            [29.628882321471195, -0.876254072483893],
            [29.628641845164594, -0.876418786571127],
            [29.628372839262884, -0.876571020928113],
            [29.628593155577885, -0.877060432026179],
            [29.628879801696836, -0.877298853381801],
            [29.628860721480184, -0.877817054274451],
            [29.628986359855837, -0.878181263829344],
            [29.629271296480812, -0.878433110687052],
            [29.629469653478701, -0.878872559273266],
            [29.629955647437299, -0.878943292428139],
            [29.630200983629596, -0.879200005065314],
            [29.63036406109131, -0.879462214690373],
            [29.630511479121022, -0.879699734342077],
            [29.630615217468367, -0.880055522324796],
            [29.630405159913881, -0.879955607771987],
            [29.630049840286425, -0.879839010497493],
            [29.630055016379064, -0.879848607423929],
            [29.630025306397698, -0.879838858581543],
            [29.630229783617612, -0.880218025323328],
            [29.630464679589672, -0.880584216781546],
            [29.630669337370964, -0.880797948866066],
            [29.630691168228996, -0.88079526863593],
            [29.630693880242834, -0.880798100781953],
            [29.631121747812646, -0.880745575866285],
            [29.631064971591766, -0.88114017101756],
            [29.630946173887015, -0.881407606228887],
            [29.630832414832675, -0.8816636884243],
            [29.630621458064638, -0.882139088228021],
            [29.630725496449244, -0.882441664749317],
            [29.631068931365537, -0.882648728707197],
            [29.631246949607078, -0.882874038825374],
            [29.631056691819786, -0.883245050631991],
            [29.630807514431336, -0.883597709530054],
            [29.630476080108931, -0.883362341366219],
            [29.630470224889919, -0.883375457665555],
            [29.63045153993199, -0.88336218854619],
            [29.630293142692892, -0.883717026700717],
            [29.630145184775721, -0.884049878633944],
            [29.629910108242282, -0.884273071792596],
            [29.6294370742783, -0.88439048004776],
            [29.629321876122884, -0.884775593638785],
            [29.629193357748438, -0.885190261122429],
            [29.628984560530313, -0.885371555321908],
            [29.628845242609533, -0.885686746003106],
            [29.629165097647917, -0.885923994878173],
            [29.629183225650344, -0.885919404854781],
            [29.62918961985855, -0.8859241476981],
            [29.629511594920981, -0.885842629569443],
            [29.629903448132762, -0.885876598998302],
            [29.63017236420297, -0.88611682197177],
            [29.63044506038386, -0.886216388216718],
            [29.630775896428261, -0.886270001782858],
            [29.630905314914632, -0.886519414722573],
            [29.630642338505101, -0.886779731208893],
            [29.630728737570806, -0.887055816156365],
            [29.630809915628078, -0.887364159638825],
            [29.630655297601393, -0.88770493978727],
            [29.630729457121344, -0.887995262229157],
            [29.630589958639181, -0.888301802539142],
            [29.630564579435784, -0.888576985824972],
            [29.631101152138129, -0.888824506896782],
            [29.631451967612772, -0.888986247215705],
            [29.631278089706392, -0.889364781837463],
            [29.630810276750843, -0.889618160645605],
            [29.630608498968339, -0.889877576268831],
            [29.630879935711235, -0.89000372400617],
            [29.630921694795507, -0.890308192490189],
            [29.631247309831512, -0.890523634864149],
            [29.631582285312735, -0.890785122983813],
            [29.631876761147723, -0.891065350940898],
            [29.631897679317401, -0.891062040450011],
            [29.631901320189272, -0.891065505569123],
            [29.632279319582718, -0.891005676199513],
            [29.632583519680651, -0.890687841925471],
            [29.632894560449447, -0.89031825779526],
            [29.633299641353787, -0.890301431346854],
            [29.633626696389172, -0.890452090812865],
            [29.633990652419794, -0.890619507091762],
            [29.634304207573066, -0.890764037478971],
            [29.634682202474959, -0.890937941799528],
            [29.63484888038434, -0.891210962803744],
            [29.635022398066322, -0.891495697552565],
            [29.635293114360344, -0.891938838465789],
            [29.635148576329428, -0.892238710442474],
            [29.635019878291963, -0.892506144841194],
            [29.635004757849089, -0.892932796483191],
            [29.634897239391051, -0.893384857726826],
            [29.634630723619296, -0.89358723519845],
            [29.634382687091257, -0.893695362753712],
            [29.633993532418589, -0.893911256151469],
            [29.633832974731238, -0.894246089286659],
            [29.633490259365516, -0.894269336851788],
            [29.633205503301891, -0.894453874171862],
            [29.633087064923277, -0.894702025110899],
            [29.632877547256285, -0.895140660620763],
            [29.632676671382331, -0.89556082390476],
            [29.632435833953007, -0.895888267295566],
            [29.632181316978475, -0.896244275242381],
            [29.631990880426461, -0.896643383672286],
            [29.631633585403687, -0.896949983837066],
            [29.631274490157057, -0.897138666135043],
            [29.631125092240477, -0.897452594356967],
            [29.63076617755523, -0.897774092086673],
            [29.630625418736706, -0.898070720010391],
            [29.630508061031364, -0.898317970061271],
            [29.630196665428016, -0.898573510321285],
            [29.630055187058982, -0.898872481108309],
            [29.629708872143894, -0.899085851320691],
            [29.629299198153522, -0.899338507852014],
            [29.629134679794067, -0.899687937896675],
            [29.628826704077031, -0.899982853001217],
            [29.628119216112061, -0.901960608637429],
            [29.616292800175202, -0.901276656521677],
            [29.615066280012151, -0.901205833375275],
            [29.615061798317196, -0.901206824439955],
            [29.615041953634254, -0.901205678747507],
            [29.609786385217355, -0.902368221864128],
            [29.608611001651834, -0.902628266838568],
            [29.607683654614355, -0.90283352746296],
            [29.606610509209663, -0.9030708665446],
            [29.605660122181757, -0.903280992038758],
            [29.604580856555007, -0.903519772474092],
            [29.603269754618076, -0.903809731944133],
            [29.601811621825284, -0.904132326871531],
            [29.60041896004708, -0.903225101808918],
            [29.599323479829458, -0.902511104227337],
            [29.599316427156143, -0.902522068328663],
            [29.599299368148898, -0.902510950503839],
            [29.598419196138586, -0.903879270092146],
            [29.596515119875846, -0.903865211632859],
            [29.595248639953972, -0.903855840833721],
            [29.593636199951593, -0.903843947161843],
            [29.593122120165638, -0.903463520545811],
            [29.593104550915307, -0.903468145812878],
            [29.593098092926738, -0.903463366822352],
            [29.592813335964816, -0.903538335031503],
            [29.58828783826079, -0.909589643138662],
            [29.592299986509204, -0.926990764857817],
            [29.592762940477382, -0.930026581497829],
            [29.59355744914221, -0.931272732798396],
            [29.59432243916682, -0.932472209078224],
            [29.59406828331506, -0.933150878865684],
            [29.59535886503599, -0.933640328342918],
            [29.595064028976566, -0.93441306678128],
            [29.594800153353443, -0.935103810604848],
            [29.594131642390373, -0.93685508694181],
            [29.593890445634898, -0.937486901418865],
            [29.595528423842495, -0.948295669253594],
            [29.595779343064283, -0.966406435541803],
            [29.596172098184589, -0.967071402973542],
            [29.597428481042655, -0.968136070906217],
            [29.598960619743458, -0.968674352374304],
            [29.600340121202784, -0.969906792150616],
            [29.600800554498278, -0.971602186743166],
            [29.600648997930069, -0.973298121207393],
            [29.600022605377411, -0.974526596004013],
            [29.598505586221119, -0.974610212598898],
            [29.596614172610636, -0.974714552492148],
            [29.596729370766045, -0.976830908248736],
            [29.598278789459659, -0.97846448755753],
            [29.599477933464431, -0.979728641573649],
            [29.600848795825673, -0.981174083397961],
            [29.600809916740197, -0.983472985499299],
            [29.60077319630631, -0.985632404306737],
            [29.599646053169856, -0.987669102768998],
            [29.597297969306585, -0.988637676661921],
            [29.595017519601043, -0.988257105747584],
            [29.593775879893442, -0.987249028496589],
            [29.593773860480699, -0.987266728865929],
            [29.593751852654545, -0.987248861213407],
            [29.591706722027567, -1.005171280988676],
            [29.592613193116168, -1.04035969631827],
            [29.595009323372395, -1.0620927406447],
            [29.594784687059182, -1.066353806976686],
            [29.594408133055037, -1.073504946419347],
            [29.5943458537547, -1.074684366977724],
            [29.592114247247775, -1.095083682670408],
            [29.589079488486387, -1.102258539219834],
            [29.587500552050827, -1.125022773074823],
            [29.5893091688399, -1.13459004658131],
            [29.593273436883688, -1.148514641994117],
            [29.595142173423145, -1.1624256529592],
            [29.593790755096247, -1.185870538628915],
            [29.588497747593216, -1.198688486138208],
            [29.587761918679391, -1.20438495226808],
            [29.587813398433354, -1.208102522764418],
            [29.589043862200537, -1.210287906779947],
            [29.594187833808007, -1.21453847899219],
            [29.599696118975587, -1.218917883914127],
            [29.601145820181127, -1.221943495169578],
            [29.604445175014508, -1.224881890406232],
            [29.611138566213921, -1.241020032875014],
            [29.607403258074847, -1.24670577695031],
            [29.607217140622708, -1.247632497865365],
            [29.60440414087066, -1.256300192738686],
            [29.60118182465769, -1.263944743688575],
            [29.600573073220591, -1.268082071275832],
            [29.600077361287223, -1.276684468658563],
            [29.603043005467331, -1.309277128927396],
            [29.609719839817732, -1.33755088984994],
            [29.609141862865602, -1.361356794261407],
            [29.609003092917149, -1.367072441113944],
            [29.60089816633538, -1.389147148656303],
            [29.60091375030893, -1.390278230076741],
            [29.600925885650085, -1.391159040893071],
            [29.595805316054097, -1.39514858558153],
            [29.589335123863403, -1.395106063149635],
            [29.575137275052416, -1.39769470710222],
            [29.56493357314984, -1.408356269351585],
            [29.552825495845557, -1.421687297852819],
            [29.546345940514687, -1.420974154536075],
            [29.530169913413157, -1.420867852812655],
            [29.523145325944874, -1.427526852995862],
            [29.511777397552631, -1.4475678801796],
            [29.485939753313495, -1.476574472403919],
            [29.485937293726241, -1.476577232514856],
            [29.466441028655904, -1.513633158069811],
            [29.456646633332781, -1.522445985329256],
            [29.443554998708738, -1.529936336407328],
            [29.403915120116441, -1.529163653626879],
            [29.377913400387285, -1.52789544441634],
            [29.377912233475719, -1.527896189348275],
            [29.377892207333097, -1.527895212981166],
            [29.349165635039139, -1.546236340778223],
            [29.335792155791331, -1.557196978183548],
            [29.326003153953152, -1.579945214439627],
            [29.313760059861657, -1.590960983324974],
            [29.291259247271245, -1.630507753091007],
            [29.282782786471113, -1.637061783122567],
            [29.261871346943213, -1.643009378772488],
            [29.256036174725207, -1.658982196664694],
            [29.252369933556739, -1.662280707079512],
            [29.252363136903298, -1.662286821625927],
            [29.248342706187948, -1.680380092374553],
            [29.243494642329996, -1.691175153204227],
            [29.24227317788537, -1.699244070706882],
            [29.242363361553377, -1.700123112801564],
            [29.240883702431436, -1.700714780180466],
            [29.239579295638311, -1.700598315035946],
            [29.239346365180065, -1.700342092235309],
            [29.238717454649674, -1.699573423626665],
            [29.238251595529839, -1.699177442953763],
            [29.237762442196377, -1.699084271125124],
            [29.237180117398296, -1.698804755611869],
            [29.236621085915512, -1.69836218884674],
            [29.23629498399265, -1.698199137621964],
            [29.235200214342431, -1.6972208326922],
            [29.234617889544307, -1.697197539259593],
            [29.234221908573833, -1.696824851530816],
            [29.233429947531135, -1.696754973025552],
            [29.232777743685407, -1.696894730937499],
            [29.231752852184503, -1.696871437500909],
            [29.231333578796985, -1.696545335686465],
            [29.230867718778857, -1.696242527260927],
            [29.23079783973121, -1.695776667355521],
            [29.230355273028387, -1.694565431973707],
            [29.230075757736159, -1.694262623234249],
            [29.23019222251612, -1.693284318095981],
            [29.229749655813297, -1.692934923088729],
            [29.230052464420858, -1.691793566403877],
            [29.229819534860948, -1.691118070192198],
            [29.229283795795173, -1.69074538218226],
            [29.228701470997056, -1.690279522745821],
            [29.228095853781966, -1.690116471735517],
            [29.227746458543795, -1.689534147231183],
            [29.227117548013371, -1.68885865022289],
            [29.226302293655369, -1.687926931223755],
            [29.226209122190753, -1.687414485807337],
            [29.226558516530588, -1.686855454041423],
            [29.226465344167636, -1.686273129451125],
            [29.225836433637244, -1.686086785436468],
            [29.225091058326861, -1.686226543223165],
            [29.223903116313689, -1.686273129451125],
            [29.223693479170777, -1.686436179884159],
            [29.223250912467954, -1.686878746695915],
            [29.222854931497448, -1.687088384189667],
            [29.222132849502401, -1.686925332908074],
            [29.221573818019618, -1.686715696300488],
            [29.22127100851376, -1.686063492772346],
            [29.221387474192049, -1.685900441403708],
            [29.221597110436626, -1.685760683593284],
            [29.221876626627179, -1.685574339528922],
            [29.222179435234708, -1.685411289022773],
            [29.222761760032824, -1.685155065996],
            [29.222994689592742, -1.684712499691072],
            [29.223786651533729, -1.683617728926149],
            [29.223530428658517, -1.68287235353741],
            [29.223087861955687, -1.682429786707271],
            [29.222202728550045, -1.68203380610602],
            [29.221876626627179, -1.681521360022601],
            [29.221107958001493, -1.681265137381756],
            [29.22071197703098, -1.681730997196491],
            [29.22003648076824, -1.68224344322411],
            [29.218359385421611, -1.683035404258895],
            [29.217916818718788, -1.682849060834371],
            [29.217381080551341, -1.682429786707271],
            [29.216938513848518, -1.682196856898507],
            [29.216356189050433, -1.682266735934478],
            [29.215564228007743, -1.682057098818919],
            [29.214469457459188, -1.681963927061589],
            [29.213654203101193, -1.681754289913054],
            [29.212373088725037, -1.680449882886871],
            [29.211674299146992, -1.680123780992339],
            [29.210998802884262, -1.679844265426248],
            [29.210369891455532, -1.679634628951063],
            [29.209438172317579, -1.679494870685629],
            [29.209251828489972, -1.679075596732569],
            [29.208855847519498, -1.678842667422338],
            [29.208087178893813, -1.678493272500325],
            [29.207667905506291, -1.678004120045526],
            [29.206875944463594, -1.677375209047808],
            [29.206247033933202, -1.676792884302528],
            [29.205897638694996, -1.676210559381681],
            [29.204234758289434, -1.675681461388723],
            [29.203335409942721, -1.675395305463214],
            [29.202683206995321, -1.675092496415738],
            [29.202147467929546, -1.67474310171924],
            [29.201704901226726, -1.674533464690269],
            [29.201192455476253, -1.674160777084834],
            [29.199422188664997, -1.67313588602572],
            [29.198374004747084, -1.673275643847212],
            [29.196603737935796, -1.671784892929942],
            [29.196114584602331, -1.671458790477096],
            [29.19576519026246, -1.671388911954085],
            [29.194553954933951, -1.670736708668187],
            [29.194041509183513, -1.670596950663521],
            [29.193598942480691, -1.670596950663521],
            [29.193039910997911, -1.670270848914761],
            [29.192411000467487, -1.670154383732926],
            [29.191805382354101, -1.670084504258879],
            [29.191060007043717, -1.669968039969826],
            [29.190244752685715, -1.669106199493562],
            [29.189732306935252, -1.668943148500726],
            [29.189382912595413, -1.669152785230724],
            [29.188404606826815, -1.669269250472722],
            [29.187542766736474, -1.669152785230724],
            [29.186657633330832, -1.669362421938078],
            [29.185819085657528, -1.669525472895699],
            [29.185073710347144, -1.669641938115293],
            [29.184444799816752, -1.669688523839606],
            [29.183792595971017, -1.669688523839606],
            [29.183186977857599, -1.669502180031736],
            [29.182674532107129, -1.669665230977577],
            [29.182511481594862, -1.669409007669108],
            [29.182581360642509, -1.669059613755306],
            [29.18176610628451, -1.668989734241794],
            [29.180927558611174, -1.668896562758576],
            [29.180019131890226, -1.668686925096891],
            [29.179064119436934, -1.668686925096891],
            [29.178854483192357, -1.66833753105308],
            [29.178411916489534, -1.668290944392374],
            [29.177689833596158, -1.667918257394349],
            [29.176851285922861, -1.667475690756772],
            [29.17647859826765, -1.667172881375682],
            [29.176012739147822, -1.666846779955575],
            [29.175244070522169, -1.666380920172506],
            [29.175127605742208, -1.665961646091447],
            [29.1745685733611, -1.665821888646966],
            [29.173613560907839, -1.665239564045599],
            [29.17335733893092, -1.665029926893325],
            [29.172938064645106, -1.665146391478525],
            [29.172542083674593, -1.664610653424943],
            [29.172239275067064, -1.664354430353781],
            [29.172029637924151, -1.664261258648307],
            [29.17172682931659, -1.66405162139059],
            [29.17144731402437, -1.663911863808887],
            [29.17116779783381, -1.663632347711427],
            [29.170795110178638, -1.663399418352851],
            [29.170026441552952, -1.66332953863586],
            [29.169304358659573, -1.663492590099622],
            [29.169048136682651, -1.663376124511478],
            [29.168745327176794, -1.663096609241052],
            [29.16865215571217, -1.662677335356208],
            [29.168558983349225, -1.662025131858205],
            [29.168838499539742, -1.661396221103253],
            [29.16897825763504, -1.660837189954252],
            [29.169001550052045, -1.660254864766302],
            [29.168791913807432, -1.659695833290175],
            [29.168419225253924, -1.659090215676912],
            [29.168116416646402, -1.659043629698868],
            [29.167603970895929, -1.65841471888664],
            [29.166928474633192, -1.658018737900949],
            [29.166509201245709, -1.657552878718979],
            [29.166416028882757, -1.657063726413195],
            [29.166718837490286, -1.656807503254454],
            [29.1673011622884, -1.656481401003828],
            [29.16741762706836, -1.655899076324996],
            [29.167254576556061, -1.655060528989136],
            [29.166928474633192, -1.654617962144532],
            [29.166322857418102, -1.654524790878177],
            [29.16583370408464, -1.654082223912431],
            [29.165926876447624, -1.653057332226303],
            [29.165647360257072, -1.652335249926723],
            [29.165670653572374, -1.651776217994682],
            [29.165856997399978, -1.651217186807223],
            [29.165367844964845, -1.651077429211461],
            [29.165321258334203, -1.650588276191884],
            [29.164622468756164, -1.650541690011467],
            [29.164040144856379, -1.650005951569195],
            [29.163574284838255, -1.649959365374949],
            [29.163574284838255, -1.649423626773701],
            [29.163807214398133, -1.649050938886316],
            [29.163550991522914, -1.648771423376317],
            [29.163318061963, -1.648398735365158],
            [29.163178303867742, -1.647210793326782],
            [29.163690749618173, -1.6469778638211],
            [29.163085132403086, -1.646675054880083],
            [29.163271476230687, -1.646185901668286],
            [29.164296366833295, -1.645370647852984],
            [29.164925278262022, -1.644648564535499],
            [29.165134914506599, -1.644182704890021],
            [29.16427307441629, -1.643740138305534],
            [29.163807214398133, -1.643810017817481],
            [29.163457820058294, -1.643553794736232],
            [29.162782322897229, -1.642971469838565],
            [29.162432928557358, -1.642389145672858],
            [29.161873897074578, -1.642202801071847],
            [29.16180401802696, -1.641504011599208],
            [29.162176705682139, -1.641271082322628],
            [29.161710845664011, -1.640851808289952],
            [29.161338158008803, -1.640735343164617],
            [29.160709247478408, -1.64012972602934],
            [29.160196801727938, -1.640059846387003],
            [29.159987164585033, -1.63971045175423],
            [29.159940578852723, -1.639128127530281],
            [29.15954459788221, -1.638802025962227],
            [29.159567891197547, -1.638312872605257],
            [29.159707649292805, -1.637916892088545],
            [29.159777528340456, -1.63705505197274],
            [29.159381547369943, -1.636239797097028],
            [29.159358254054641, -1.635098440610961],
            [29.15898556639943, -1.635098440610961],
            [29.158542999696639, -1.63484221820783],
            [29.158682757791901, -1.634283186737619],
            [29.158403241601345, -1.634026963325095],
            [29.157890796749211, -1.634003670943406],
            [29.1577044529216, -1.634609288146429],
            [29.157424936731079, -1.635773937275576],
            [29.157192007171169, -1.636519313479694],
            [29.156819318617661, -1.636565899087599],
            [29.156679561420695, -1.636123332603936],
            [29.155794428015053, -1.635913695052718],
            [29.154769536514145, -1.63598357484159],
            [29.153930988840841, -1.635913695052718],
            [29.15351171545333, -1.636565899087599],
            [29.153208905947466, -1.637404446170897],
            [29.152649874464689, -1.637753841211328],
            [29.152114136297246, -1.637777134452887],
            [29.15178803437438, -1.637707255631387],
            [29.151019365748695, -1.637823720031225],
            [29.150739849558136, -1.638406044639537],
            [29.150273990438308, -1.638732146272907],
            [29.149482028497317, -1.639034955530045],
            [29.148643480823981, -1.63950081548732],
            [29.147828226465982, -1.639314471517585],
            [29.14733907403085, -1.638871904745077],
            [29.146710163500426, -1.638918490297576],
            [29.146197717749988, -1.639593987465584],
            [29.145685271999522, -1.640013260861411],
            [29.145568807219561, -1.639547401024998],
            [29.145568807219561, -1.638871904745077],
            [29.145033068153786, -1.638755439502977],
            [29.144639450650807, -1.63882291727777],
            [29.144217813795795, -1.638895197973455],
            [29.143682075628316, -1.639477522266053],
            [29.143565610848356, -1.640851808289952],
            [29.142890113687326, -1.641760234946849],
            [29.142028273597017, -1.642598782536949],
            [29.140980088780776, -1.643064641652942],
            [29.140258006785729, -1.642994763018548],
            [29.139302994332436, -1.642761833014091],
            [29.138837134314311, -1.64252890298209],
            [29.138674083802041, -1.642645368001525],
            [29.138184931366911, -1.642575489352285],
            [29.138068465688626, -1.642226094260977],
            [29.137695778033446, -1.642202801071847],
            [29.137206625598314, -1.642319266110556],
            [29.137206625598314, -1.641760234946849],
            [29.136903816990753, -1.641340961018088],
            [29.136391371240283, -1.641271082322628],
            [29.13590221880515, -1.641364254217371],
            [29.135366479739375, -1.641201202720709],
            [29.135180135911806, -1.640781929577176],
            [29.134854033988944, -1.640176311552171],
            [29.135040377816512, -1.639873503374017],
            [29.135599409299292, -1.639407643504653],
            [29.135366479739375, -1.639058248756515],
            [29.135319894007068, -1.638382752309373],
            [29.134970498768894, -1.637753841211328],
            [29.13490061972125, -1.637031758722645],
            [29.134854033988944, -1.63635626248724],
            [29.134318295821465, -1.635843816165381],
            [29.133945607267957, -1.635517714959847],
            [29.134248416773815, -1.634888803855237],
            [29.134481346333732, -1.634306479116039],
            [29.1339921938986, -1.633561103887218],
            [29.133968900583298, -1.632815728378165],
            [29.133503040565135, -1.632373161960874],
            [29.133153646225299, -1.631814129794554],
            [29.133386575785178, -1.631255098374748],
            [29.133735971023381, -1.630742652542313],
            [29.133526333880475, -1.630439843825742],
            [29.133153646225299, -1.630393258073848],
            [29.132454856647225, -1.630486429576517],
            [29.131732773753878, -1.630672773472743],
            [29.131616308973921, -1.630090449303996],
            [29.131942410896791, -1.629601296508737],
            [29.131942410896791, -1.629018972026006],
            [29.13163960228923, -1.628646283905893],
            [29.131127156538788, -1.628646283905893],
            [29.130428366960714, -1.628646283905893],
            [29.130055679305542, -1.628786042185131],
            [29.129496647822762, -1.629135436936195],
            [29.128867737292371, -1.629624589846107],
            [29.128168947714297, -1.630067155972097],
            [29.126817954290527, -1.630300085662824],
            [29.126258922807747, -1.629973984449746],
            [29.125839648521929, -1.629368366736104],
            [29.125466960866749, -1.629624589846107],
            [29.124279018853578, -1.629810932919154],
            [29.122881439697469, -1.629717761384806],
            [29.121460567226048, -1.629741054720827],
            [29.120971414790912, -1.629508124964555],
            [29.120528848088089, -1.629298487618215],
            [29.120016402337622, -1.628995678681524],
            [29.119387491807231, -1.628925799550506],
            [29.119247733711934, -1.628203717463603],
            [29.118222843109361, -1.628227010817321],
            [29.118222843109361, -1.629251901839566],
            [29.117989912651115, -1.629904105353166],
            [29.117151364977811, -1.630113741731638],
            [29.116522454447388, -1.630183620820851],
            [29.115893543916997, -1.630206914151402],
            [29.115241340969558, -1.630276793237371],
            [29.114915239046695, -1.629950691116498],
            [29.114589137123833, -1.62976434715254],
            [29.113634124670568, -1.628762748837953],
            [29.112981920824843, -1.628040666691815],
            [29.112446182657365, -1.627388462567052],
            [29.111817272126974, -1.627504927572734],
            [29.1113048263765, -1.627458341752089],
            [29.110699208263082, -1.627225411728459],
            [29.110466278703203, -1.627574806753662],
            [29.110047005315685, -1.627551513392273],
            [29.109627731029867, -1.627248705093627],
            [29.109068699547088, -1.626782844970086],
            [29.108509668064308, -1.626223813943537],
            [29.107647827075667, -1.625921004538948],
            [29.107112088908227, -1.625408559140188],
            [29.106529764110107, -1.625571610127541],
            [29.106296834550196, -1.625851126203971],
            [29.105761095484421, -1.624989285369705],
            [29.105202064001677, -1.624733062567008],
            [29.10452656773894, -1.624406960441708],
            [29.104293637280694, -1.624057565764878],
            [29.103571555285644, -1.623801342842439],
            [29.102383612374144, -1.623778050340945],
            [29.101568358016142, -1.623847928748591],
            [29.101102498896314, -1.624010979863624],
            [29.099821384520194, -1.623917808057809],
            [29.099308938769724, -1.623754756935168],
            [29.098680028239329, -1.623242311883572],
            [29.098214168221169, -1.6227764517275],
            [29.098051117708899, -1.622264006424666],
            [29.097492086226126, -1.621192528553286],
            [29.09721257003557, -1.620517032360932],
            [29.096933053845049, -1.619911414485642],
            [29.096397315677571, -1.619958000482554],
            [29.096187678534665, -1.620330688418856],
            [29.095535475587262, -1.620517032360932],
            [29.0950463222538, -1.620633496863909],
            [29.094580463133973, -1.62070337628563],
            [29.093881673555931, -1.620633496863909],
            [29.093229469710199, -1.620493738917116],
            [29.092786903007376, -1.620237516441291],
            [29.092297750572243, -1.619655191935201],
            [29.09190176960173, -1.619049573798877],
            [29.091435909583605, -1.61846724985086],
            [29.091435909583605, -1.617791752737952],
            [29.091389323851296, -1.617279307061314],
            [29.091039928613093, -1.616673690014087],
            [29.090876878100826, -1.616207830135602],
            [29.090387725665693, -1.615695384053773],
            [29.090341139035051, -1.61497330170235],
            [29.090084917058135, -1.614437563598706],
            [29.089758815135269, -1.614111461602651],
            [29.089414515141371, -1.613955970786092],
            [29.089036732241926, -1.613785359553583],
            [29.088896974146632, -1.613435964829579],
            [29.088687337902048, -1.61222472913499],
            [29.088268063616233, -1.611199838422302],
            [29.087802204496406, -1.610966908313281],
            [29.08752268830585, -1.610524341574105],
            [29.087173293067686, -1.609942016959291],
            [29.08703353587072, -1.608707489194758],
            [29.087391250406743, -1.608170916828911],
            [29.087452809258206, -1.608078577782525],
            [29.087429515942905, -1.60717015205019],
            [29.087056828287725, -1.606401483038073],
            [29.086870484460125, -1.605539642881277],
            [29.08691707109076, -1.604724388706495],
            [29.087266465430638, -1.604351700586625],
            [29.087196586382987, -1.60367620415447],
            [29.087336344478281, -1.603373394961592],
            [29.0875925673535, -1.603117172110639],
            [29.087103414918371, -1.603024000238974],
            [29.086893777775458, -1.602767777343685],
            [29.086660848215541, -1.602185453200548],
            [29.086567675852596, -1.60150995604413],
            [29.086567675852596, -1.600881046004955],
            [29.086404625340297, -1.600461772536879],
            [29.086148402465074, -1.600158962862553],
            [29.085519491934683, -1.599530052403469],
            [29.084168498510877, -1.599506759620636],
            [29.083423123200525, -1.5990409002918],
            [29.082048836461421, -1.599157365134066],
            [29.081210289686414, -1.598644919235628],
            [29.080814308715901, -1.598016008306382],
            [29.08074442966829, -1.597014410422455],
            [29.080534792525377, -1.59629232770995],
            [29.079859296262644, -1.596152569881702],
            [29.079533194339774, -1.59557024564442],
            [29.078974162857001, -1.59536060837187],
            [29.078461717106528, -1.59568670978204],
            [29.077856099891438, -1.595500366254632],
            [29.077693048480874, -1.595710003512781],
            [29.076831208390534, -1.595896347020903],
            [29.076295469324759, -1.595942932669264],
            [29.075783023574292, -1.595733296339226],
            [29.075363750186806, -1.59536060837187],
            [29.075130820626889, -1.595057799743527],
            [29.074664960608764, -1.594708404490355],
            [29.074455323465859, -1.594102786993996],
            [29.074664960608764, -1.593147774699552],
            [29.074385444418208, -1.592518863875098],
            [29.073872998667742, -1.592402399555881],
            [29.073313967184962, -1.592379106691269],
            [29.07266176333923, -1.592146176222146],
            [29.072032852808835, -1.591983125239513],
            [29.071520407058365, -1.591633730361862],
            [29.071287477498455, -1.591167871034299],
            [29.070891496527974, -1.590702011600175],
            [29.070588687920413, -1.590189565376303],
            [29.07009953548528, -1.589933342667992],
            [29.069633675467156, -1.589746998613349],
            [29.069214402079638, -1.589397604255961],
            [29.069074643984376, -1.588675521550466],
            [29.068888300156768, -1.588396005741584],
            [29.06842244013864, -1.588396005741584],
            [29.06823609631104, -1.588139782807798],
            [29.068142924846423, -1.587650630666626],
            [29.067979873435821, -1.587254649199794],
            [29.067933287703511, -1.586812082703765],
            [29.067420841953037, -1.586276344375777],
            [29.067281083857782, -1.5860667070502],
            [29.067118033345476, -1.585624140296661],
            [29.067001568565527, -1.585228160244743],
            [29.066349364719791, -1.585228160244743],
            [29.066186314207524, -1.585530968526685],
            [29.06583691896936, -1.585437796752396],
            [29.065464231314181, -1.58534462497387],
            [29.064742148420802, -1.585787191787967],
            [29.063996773110421, -1.585903656485225],
            [29.062575901537329, -1.585950242362268],
            [29.062179920566816, -1.585740605907209],
            [29.061714060548692, -1.585321332028574],
            [29.061248201428864, -1.585740605907209],
            [29.060549411850822, -1.585437796752396],
            [29.059710864177493, -1.585274746137193],
            [29.05905866033179, -1.58485547216295],
            [29.058266699289099, -1.584459491058065],
            [29.05759120212803, -1.584040217820566],
            [29.057125343008234, -1.584203268534239],
            [29.056543018210121, -1.584459491058065],
            [29.055588005756857, -1.58497193691331],
            [29.05507556000639, -1.585484382640075],
            [29.054563114255952, -1.585414503808168],
            [29.054260305648391, -1.585414503808168],
            [29.053841031362573, -1.585251453191095],
            [29.053305293195102, -1.585251453191095],
            [29.052769554129327, -1.584808886260946],
            [29.052420159789492, -1.584343026278481],
            [29.05204747213428, -1.58394704597834],
            [29.051395268288552, -1.58394704597834],
            [29.050726461779767, -1.583851273268235],
            [29.05045282326612, -1.583625225029153],
            [29.050226774801271, -1.583672814419657],
            [29.050095904637427, -1.583875067961031],
            [29.049869855274281, -1.583958348931522],
            [29.049489142070335, -1.583958348931522],
            [29.049346373720535, -1.584172501145293],
            [29.049227400844316, -1.584386652432607],
            [29.049037044242343, -1.584386652432607],
            [29.048810994879197, -1.584600803697466],
            [29.04851356268863, -1.584850647414114],
            [29.04826371964857, -1.58515997734328],
            [29.04822802778569, -1.585552588131172],
            [29.048299411511408, -1.58607606996828],
            [29.048037670285389, -1.586385399711842],
            [29.047811621820571, -1.586492475242322],
            [29.047692648944356, -1.586540064566085],
            [29.0476688543691, -1.587027853714453],
            [29.047430907718329, -1.587325286439608],
            [29.047181064678231, -1.58753943830035],
            [29.04677655600074, -1.587943946405227],
            [29.046621891261644, -1.588110508914967],
            [29.046621891261644, -1.588479325400444],
            [29.046669480412145, -1.588800552549321],
            [29.046681377699773, -1.589169368909942],
            [29.046633788549272, -1.589740439067997],
            [29.04655050753593, -1.590073563780262],
            [29.046027025982184, -1.590549456131882],
            [29.045610620017065, -1.590846889247176],
            [29.045348879689374, -1.591084835346506],
            [29.044861089998506, -1.591263294450737],
            [29.044397094882918, -1.591132424563009],
            [29.043968792528474, -1.591001553762881],
            [29.043064596872519, -1.591120526806993],
            [29.042588704469278, -1.591465549047584],
            [29.041958147326969, -1.59133467826883],
            [29.041458461246808, -1.591417959838817],
            [29.041089644432159, -1.591525035104904],
            [29.040827904104468, -1.591929543322461],
            [29.040566162878449, -1.592334052363553],
            [29.0403877035641, -1.592845636520801],
            [29.0403877035641, -1.593143068396366],
            [29.040625649316571, -1.593499988036051],
            [29.040708930329917, -1.593916393600439],
            [29.040768417666339, -1.594368491386994],
            [29.040625649316571, -1.59497525328634],
            [29.040447190002226, -1.595320275776681],
            [29.04035201170122, -1.595736680967863],
            [29.040054578612363, -1.595915140567662],
            [29.039995092174237, -1.596248265172208],
            [29.039852324722762, -1.596783643789487],
            [29.039435918757643, -1.597128665972332],
            [29.039031410978488, -1.597473687192474],
            [29.038496032137115, -1.598080449971218],
            [29.038329470110391, -1.598413575124054],
            [29.038246188198716, -1.598925158652977],
            [29.038055831596747, -1.599175002418554],
            [29.037758399406179, -1.599650894445236],
            [29.03756804190591, -1.599781764687761],
            [29.037603733768787, -1.600245759773286],
            [29.037675118392841, -1.600543192371765],
            [29.037591836481159, -1.600947700599335],
            [29.037401479879193, -1.601221338605066],
            [29.037234917852469, -1.601697231054545],
            [29.036949382051198, -1.601982765747243],
            [29.036747128161601, -1.602220712348388],
            [29.036735230874005, -1.602839372295395],
            [29.036770922736853, -1.603267675433298],
            [29.036949382051198, -1.603529415441762],
            [29.03708025311337, -1.603684080798075],
            [29.037199225989593, -1.604243253710555],
            [29.037127842263875, -1.604766735248628],
            [29.037187328701965, -1.60505227041145],
            [29.037341993441064, -1.605290216650903],
            [29.037603733768787, -1.605528162862329],
            [29.037794091269056, -1.605742314609411],
            [29.037829783131933, -1.605992157532243],
            [29.0379249614329, -1.606253898995365],
            [29.038044214583515, -1.606541391127606],
            [29.038091523459624, -1.606872558610194],
            [29.037996345158657, -1.607324656213841],
            [29.037805988556684, -1.607824342540305],
            [29.037777513758822, -1.607837331336623],
            [29.037127842263875, -1.608133672582368],
            [29.036568668847284, -1.608407310517834],
            [29.036354516771734, -1.608645257265221],
            [29.035783446965848, -1.608811818977228],
            [29.035307554562607, -1.608906997479645],
            [29.035200478974012, -1.60914494326396],
            [29.034950635035617, -1.609311505838686],
            [29.034712689283143, -1.609549451575153],
            [29.03445094805716, -1.609763603798759],
            [29.034236796879931, -1.609763603798759],
            [29.034022645702709, -1.610049139157427],
            [29.033570547874717, -1.610275188067287],
            [29.033558650587089, -1.610667798510127],
            [29.033427780423246, -1.610786771301703],
            [29.033392088560404, -1.611191280186719],
            [29.033249320210604, -1.611583891354624],
            [29.032892401581908, -1.611809940091946],
            [29.032904298869536, -1.612166859146638],
            [29.032904298869536, -1.612726032415747],
            [29.032951888020037, -1.613035362607881],
            [29.032951888020037, -1.613380383819767],
            [29.032987579882874, -1.613725405876357],
            [29.032999477170502, -1.614141811790084],
            [29.033166039197226, -1.614510628048597],
            [29.033273114785853, -1.614808060349097],
            [29.033380191272776, -1.615069801568767],
            [29.033594342449966, -1.615307747527135],
            [29.03390367282649, -1.615521899136728],
            [29.034236796879931, -1.61579553696992],
            [29.034407558530582, -1.61612701480938],
            [29.034439050769532, -1.616188148141196],
            [29.0345818191193, -1.616521273012349],
            [29.03465320284505, -1.616878192132827],
            [29.034712689283143, -1.617342186894367],
            [29.03453751780274, -1.617488162802968],
            [29.034498537207625, -1.617520646389437],
            [29.033808493627188, -1.617437364992409],
            [29.033201731060103, -1.61723511118972],
            [29.032797223280941, -1.616878192132827],
            [29.032487892904417, -1.616568861629406],
            [29.032059590550006, -1.615902612751511],
            [29.031821643899239, -1.61581933128722],
            [29.031666979160136, -1.61614055861104],
            [29.031417136120044, -1.616509375405895],
            [29.031012627442554, -1.616985267856596],
            [29.030988832867298, -1.617175624081978],
            [29.031024524730174, -1.617520646389437],
            [29.031036422017802, -1.618044128085812],
            [29.031381443358868, -1.618353457457325],
            [29.031619390009638, -1.618746069031068],
            [29.031809746611611, -1.618924528400926],
            [29.032202358001477, -1.619150577214581],
            [29.032571173917795, -1.619400420277435],
            [29.032773428705692, -1.619590777177107],
            [29.033035169033383, -1.619935799068104],
            [29.033189833772475, -1.620411691607911],
            [29.033154141909598, -1.620780507615541],
            [29.032761531418064, -1.62095896770783],
            [29.032083385125254, -1.620911378291156],
            [29.031666979160136, -1.620625842671453],
            [29.031393340646488, -1.620352204594618],
            [29.03110780574352, -1.620090464065562],
            [29.03045345402596, -1.619555085316303],
            [29.030286891999239, -1.619269550406894],
            [29.029822896883619, -1.619269550406894],
            [29.029513566507134, -1.619352830823676],
            [29.029251826179404, -1.619424215455876],
            [29.028835420214293, -1.619650264213045],
            [29.028454707010379, -1.619650264213045],
            [29.028014506470011, -1.619638366625204],
            [29.027574305929644, -1.619412317866675],
            [29.027229284588575, -1.618924528400926],
            [29.026777186760587, -1.618531916862181],
            [29.026467857282391, -1.618282073690909],
            [29.026432164521221, -1.617925154820664],
            [29.026110937755405, -1.617853771038956],
            [29.025754018228412, -1.617829975841838],
            [29.02553986705119, -1.617925154820664],
            [29.025290024011124, -1.618103614263738],
            [29.024968796346979, -1.618151203747216],
            [29.024683261444032, -1.618293971286803],
            [29.024730850594498, -1.61852002017169],
            [29.024933104484099, -1.618865041343436],
            [29.024945001771727, -1.619150577214581],
            [29.024635672293531, -1.619257652816751],
            [29.024397725642764, -1.619114885345915],
            [29.024100293452197, -1.619114885345915],
            [29.023850449513802, -1.618936425089013],
            [29.023588709186079, -1.618924528400926],
            [29.023445941734607, -1.619102987754881],
            [29.02324368694671, -1.619257652816751],
            [29.022827281879923, -1.619174371492023],
            [29.022601232516745, -1.619400420277435],
            [29.022434670490025, -1.619697852755715],
            [29.022137238299457, -1.619995286093801],
            [29.021816010635341, -1.620280820899574],
            [29.021518578444777, -1.620542561403696],
            [29.021482886581904, -1.620863788873376],
            [29.021685140471497, -1.62106604321312],
            [29.021732729621966, -1.621303989362614],
            [29.022018264524942, -1.621506243657792],
            [29.022196724737583, -1.621839367643326],
            [29.022398978627184, -1.622172492477267],
            [29.022506054215778, -1.622434232733546],
            [29.022529848791027, -1.622648384484229],
            [29.022577437941528, -1.622886330445128],
            [29.022648821667246, -1.623159969078726],
            [29.022744000866549, -1.623397914978636],
            [29.023005741194268, -1.623397914978636],
            [29.023065227632365, -1.623659655074183],
            [29.022803487304675, -1.623873806693305],
            [29.022839179167551, -1.624206931187638],
            [29.022898665605641, -1.624444877866656],
            [29.022720206291297, -1.624801796475918],
            [29.023041433057116, -1.625015947972398],
            [29.023184200508581, -1.625253894554829],
            [29.023219892371458, -1.625503737757805],
            [29.023029535769489, -1.625789272679427],
            [29.022648821667246, -1.625801170230615],
            [29.022589335229156, -1.626015321619693],
            [29.022601232516745, -1.626491214517414],
            [29.022898665605641, -1.626776749297412],
            [29.022970049331398, -1.627109874210371],
            [29.023136611358115, -1.627371614722291],
            [29.023259279005099, -1.627438884060488],
            [29.023505428172733, -1.627573868401917],
            [29.023909935951895, -1.627716636171407],
            [29.024385828355136, -1.627597663482881],
            [29.024790337032627, -1.627288333736241],
            [29.025040180072725, -1.626883825394387],
            [29.025480380613065, -1.626681570740621],
            [29.025968170303933, -1.626455521876],
            [29.026134732330654, -1.626229472985707],
            [29.026479754570019, -1.626015321619693],
            [29.026943748787307, -1.626169987049897],
            [29.027193592725705, -1.626515008707264],
            [29.027491024916305, -1.62661018727207],
            [29.027788458005169, -1.626622084818309],
            [29.027978814607138, -1.626860030304899],
            [29.028169171209111, -1.627145565936039],
            [29.028323836846535, -1.627169360118115],
            [29.028407117859881, -1.627597663482881],
            [29.028656960899941, -1.627716636171407],
            [29.028752139200947, -1.628073556002295],
            [29.028954393988844, -1.628252015441704],
            [29.029335107192782, -1.628109247710635],
            [29.029501669219506, -1.627859403930669],
            [29.029906177896997, -1.627669046916077],
            [29.030441556738339, -1.627669046916077],
            [29.030691399778433, -1.627669046916077],
            [29.03091744914158, -1.62781181467871],
            [29.031440930695293, -1.627835609756824],
            [29.031869233049704, -1.627930788258414],
            [29.032154768850972, -1.628014069217582],
            [29.032535482054918, -1.628156836955457],
            [29.032725839555187, -1.628299604683104],
            [29.032880504294287, -1.628442372400535],
            [29.032987579882874, -1.628799291197157],
            [29.032987579882874, -1.629477437819057],
            [29.032887893835809, -1.629691050029196],
            [29.032821017856193, -1.629834356429871],
            [29.032606865780636, -1.630119891633964],
            [29.032214255289102, -1.630238865075582],
            [29.031678876447732, -1.630334043462125],
            [29.03147662255817, -1.6304887085565],
            [29.031191086756895, -1.630774243666551],
            [29.03091744914158, -1.631035984600022],
            [29.03091744914158, -1.631499979683078],
            [29.030893654566327, -1.632427969523819],
            [29.03071519435365, -1.632820580131946],
            [29.030631913340311, -1.633213191566343],
            [29.030786578079404, -1.63364149453195],
            [29.030667605203181, -1.634046002401618],
            [29.030584324189803, -1.63477173812505],
            [29.03045345402596, -1.635033478530943],
            [29.03038207030021, -1.635330911384783],
            [29.030346378437365, -1.635604549209235],
            [29.030215508273489, -1.635854392918237],
            [29.029977561622719, -1.636199414700676],
            [29.029656334856902, -1.63646115582185],
            [29.029156647878438, -1.636627717924569],
            [29.029120956015561, -1.637365351087565],
            [29.029299415329913, -1.637781756579792],
            [29.029239928891784, -1.638459902841031],
            [29.028775933776195, -1.638947692033837],
            [29.028764036488575, -1.639459276044817],
            [29.028811625639044, -1.639899476933139],
            [29.028764036488575, -1.640351574283282],
            [29.028680755475197, -1.641005925646655],
            [29.028680755475197, -1.641362844891569],
            [29.028466604298007, -1.641660277697052],
            [29.028371425997001, -1.642112375547777],
            [29.028419015147502, -1.642469294592546],
            [29.028502296160848, -1.642719137433409],
            [29.028526090736097, -1.642968981146635],
            [29.028561782598974, -1.643242618817148],
            [29.028764036488575, -1.643444873587807],
            [29.028835420214293, -1.643920765914084],
            [29.028811625639044, -1.644253889750882],
            [29.028906803940043, -1.644563220462567],
            [29.028954393988844, -1.644967728807944],
            [29.028977513031009, -1.645391583394521],
            [29.028990085851717, -1.645622080446918],
            [29.028966291276465, -1.646062280863156],
            [29.029144750590817, -1.646300226724339],
            [29.029263723467032, -1.646561967409599],
            [29.029263723467032, -1.64732339441299],
            [29.029061469577432, -1.647668416901436],
            [29.029061469577432, -1.648751070944368],
            [29.028990085851717, -1.649036607030111],
            [29.028894906652422, -1.649393525722983],
            [29.028894906652422, -1.649726650440668],
            [29.028978188564093, -1.650083569912089],
            [29.028978188564093, -1.650404797109654],
            [29.029097161440312, -1.650642742444913],
            [29.029263723467032, -1.650904483455557],
            [29.029382696343287, -1.651344683592135],
            [29.029501669219506, -1.651903857573447],
            [29.029442182781377, -1.652760463425655],
            [29.029280991781739, -1.653147323332594],
            [29.029263723467032, -1.653188765759336],
            [29.029001983139345, -1.653664658437154],
            [29.028740241913319, -1.654033474572706],
            [29.028490398873227, -1.654461777531964],
            [29.028073992908137, -1.654890080397561],
            [29.0277408688547, -1.654997156777288],
            [29.027348257464798, -1.655056642748376],
            [29.02691995421209, -1.655187512963269],
            [29.026515446432896, -1.655354075288792],
            [29.026301294357378, -1.655365972661792],
            [29.0260633486049, -1.65581807007],
            [29.025896786578176, -1.656056016555692],
            [29.025908683865804, -1.656841238216282],
            [29.025646942639785, -1.657495590413838],
            [29.025408996887347, -1.658364093884776],
            [29.025254332148247, -1.658839986207173],
            [29.025242434860623, -1.659351569555987],
            [29.025230537572995, -1.659660899693467],
            [29.025123461086071, -1.660267662478242],
            [29.024671364156411, -1.660767349016696],
            [29.023981320575974, -1.66094580910943],
            [29.023743373925175, -1.661362214120859],
            [29.023529222747982, -1.661457392809962],
            [29.023529222747982, -1.66182620928231],
            [29.023374558008889, -1.662147436358937],
            [29.023196097796209, -1.662230717678602],
            [29.023029535769489, -1.662409177637282],
            [29.022827281879923, -1.662563842017635],
            [29.022387081339556, -1.662563842017635],
            [29.022077750963032, -1.662551944688488],
            [29.021697037759125, -1.662551944688488],
            [29.021423399245478, -1.66267091797651],
            [29.02117355620538, -1.662896967203676],
            [29.020995096891028, -1.663123015500669],
            [29.020697663802171, -1.663646496855999],
            [29.020459718049693, -1.663932032574502],
            [29.020352642461098, -1.66441982175937],
            [29.020209874111298, -1.664503102981811],
            [29.020233669584851, -1.665074173221505],
            [29.02013849038558, -1.665585757645359],
            [29.019912441920734, -1.665776114605932],
            [29.019793469044512, -1.666061650011825],
            [29.019484138667988, -1.666275801538686],
            [29.019067733601204, -1.666335288069756],
            [29.018865478813275, -1.66648995304201],
            [29.018710814074183, -1.666751693736214],
            [29.018413381883615, -1.666894461372706],
            [29.018211127095718, -1.667120510109099],
            [29.017937489480367, -1.667263277718506],
            [29.017889900329902, -1.667548812905895],
            [29.017759030166054, -1.667941423719944],
            [29.017687645541972, -1.66822695971158],
            [29.017592467241005, -1.668571981219766],
            [29.017461597077158, -1.668690954139417],
            [29.017425905214282, -1.669035976469114],
            [29.017021396536791, -1.669404792408083],
            [29.016831039934818, -1.669571354422039],
            [29.016807245359569, -1.669916376595164],
            [29.016938115523445, -1.670356576960309],
            [29.017104678448465, -1.670654009876094],
            [29.017259343187558, -1.670987133675108],
            [29.017318829625687, -1.671260771942585],
            [29.017497288940039, -1.671522512897251],
            [29.017628159103882, -1.671796151089108],
            [29.017685343159911, -1.671926114391453],
            [29.017759030166054, -1.672093583783933],
            [29.0178423111794, -1.672260145566841],
            [29.017949386767995, -1.672462400045092],
            [29.018163537945217, -1.672664653598234],
            [29.018401484595987, -1.67286690803426],
            [29.01852045747221, -1.67303347065462],
            [29.018722711361804, -1.67328331410629],
            [29.018865478813275, -1.673568849311032],
            [29.01874650593706, -1.67406853604392],
            [29.018484765609362, -1.67427079033322],
            [29.018460971034113, -1.674568222647727],
            [29.018401484595987, -1.67500842285938],
            [29.018270613533812, -1.675341547716996],
            [29.018044565069001, -1.675627082617868],
            [29.017866105754649, -1.675924515627734],
            [29.017548242281265, -1.675924515627734],
            [29.017548177602542, -1.675924301385074],
            [29.017296422947556, -1.675094529461888],
            [29.011724472379154, -1.682815551414478],
            [29.00114236234965, -1.68861036633388],
            [28.999063102030114, -1.689749279674134],
            [28.996040107605651, -1.693748063321378],
            [28.983878032569638, -1.709836744602693],
            [28.979909376255701, -1.730632859976898],
            [28.979455837529994, -1.733009430857882],
            [28.979455798902457, -1.733009634246721],
            [28.969178533062966, -1.741662058188388],
            [28.935568204149856, -1.744867938198609],
            [28.921774194771455, -1.742914215642525],
            [28.917005539289697, -1.742238998075375],
            [28.917005166488835, -1.742238750394208],
            [28.917004730805946, -1.742238688925892],
            [28.903302447502899, -1.733132288545213],
            [28.882958182685833, -1.728749404801824],
            [28.869891656872298, -1.715889835961534],
            [28.862975949708044, -1.707375125884367],
            [28.862692162926617, -1.707025877191803],
            [28.858285771947781, -1.714045161245087],
            [28.857595281904654, -1.715145102350627],
            [28.852270126392572, -1.723630905065367],
            [28.846048439650531, -1.729776452575348],
            [28.845723555843197, -1.73009745308099],
            [28.844928112032125, -1.730883388292522],
            [28.835897445498951, -1.739807129151735],
            [28.832723617650071, -1.744651794201437],
            [28.832314519479816, -1.747547195310192],
            [28.832231926575943, -1.748134363289959],
            [28.831541220038819, -1.753044714927251],
            [28.829716449744303, -1.755496925000356],
            [28.825269699256399, -1.761474609198463],
            [28.817846755672015, -1.766636335529739],
            [28.816609444047458, -1.767496836071927],
            [28.805176784852463, -1.766404313771245],
            [28.790338500125955, -1.770386085279504],
            [28.764513130466831, -1.77143314106612],
            [28.762683129282415, -1.773021026211234],
            [28.755186080975328, -1.779527664225682],
            [28.749479294181068, -1.781854629695993],
            [28.749477197513208, -1.78185445523823],
            [28.749476804051113, -1.781854616137098],
            [28.720664217170384, -1.779466027217499],
            [28.717853075134329, -1.779903939368049],
            [28.716096877737048, -1.780178069762536],
            [28.716096401629919, -1.780177588873304],
            [28.716095571586603, -1.780177718134875],
            [28.69931743159793, -1.763243829738084],
            [28.690326452633954, -1.748571840886297],
            [28.684600125685659, -1.741858940348344],
            [28.675657207487728, -1.740824071951419],
            [28.667676550249102, -1.739758070139936],
            [28.66544914246785, -1.742916107600414],
            [28.665945052928844, -1.747348785185433],
            [28.667768478445371, -1.752510071082771],
            [28.670984268397799, -1.761594772172531],
            [28.675100326571734, -1.770023346366724],
            [28.673350315871794, -1.774811520433101],
            [28.673250119581642, -1.775086018589249],
            [28.673006942040974, -1.776131688669613],
            [28.668870925996355, -1.79392051723429],
            [28.695737838328487, -1.805971145598007],
            [28.696187973337594, -1.815860748270467],
            [28.696294784821472, -1.81645011869859],
            [28.700315475149917, -1.828617095633557],
            [28.680011795319086, -1.863789931772062],
            [28.677747959954729, -1.867712155758375],
            [28.661730119886517, -1.877707114207092],
            [28.647354240257567, -1.883065697672778],
            [28.64704663913799, -1.883288913999837],
            [28.644166946662601, -1.885379791239865],
            [28.640993117915428, -1.89091300928958],
            [28.640991495558037, -1.890912800495516],
            [28.640990925127845, -1.89091379475299],
            [28.638378985404351, -1.890576451295987],
            [28.637556075603491, -1.890470505003877],
            [28.636059437424414, -1.889114790674347],
            [28.629978360380516, -1.88360794006965],
            [28.617158167889251, -1.8802194060849],
            [28.605505140276957, -1.880734204998517],
            [28.598294281744632, -1.882612678396139],
            [28.591119539978312, -1.884481741319862],
            [28.585518642996508, -1.887440502813853],
            [28.583621007654362, -1.888442957412524],
            [28.5792636871479, -1.890745163255026],
            [28.571949695732776, -1.898982736366807],
            [28.568040847453826, -1.903385162646566],
            [28.566755294501878, -1.904830932887347],
            [28.560213088866437, -1.904678344527703],
            [28.559446334550628, -1.90466117835901],
            [28.559103011923774, -1.904653548850177],
            [28.558647212138506, -1.90464298449768],
            [28.558526830703908, -1.904640123770799],
            [28.558525274821832, -1.904640086712414],
            [28.541564768745637, -1.896900723693238],
            [28.524191793121869, -1.896751760035231],
            [28.524191407744613, -1.89675140843084],
            [28.522366857537353, -1.895086300495695],
            [28.521432846797101, -1.894233910069749],
            [28.514274802016967, -1.879780785712199],
            [28.51105874975649, -1.876805933771006],
            [28.50602816080923, -1.87591021228926],
            [28.498723821791817, -1.878702658013984],
            [28.481567416508323, -1.876711658405538],
            [28.474636882650309, -1.875285448775317],
            [28.471727371497401, -1.874687194901281],
            [28.463573714904719, -1.869477918432902],
            [28.459574408971612, -1.866923076919839],
            [28.459524612660474, -1.866914071533407],
            [28.451740634366761, -1.865494066222385],
            [28.449750411464905, -1.865130995967128],
            [28.449746563980568, -1.865130293649307],
            [28.449736019555736, -1.865128370184284],
            [28.451349258160434, -1.868570327894443],
            [28.449808121035403, -1.88053512544193],
            [28.450706847747927, -1.892003592784991],
            [28.450781018945975, -1.892948384177139],
            [28.441670231672578, -1.896304914176629],
            [28.433397293183241, -1.899353027694459],
            [28.427292195188627, -1.899710171310204],
            [28.424398186262597, -1.89987955303574],
            [28.372022628680963, -1.921522140806739],
            [28.362371444577047, -1.927659987960167],
            [28.359304428212116, -1.934650420888396],
            [28.353857040735942, -1.939922332927325],
            [28.350993117287068, -1.945883637694088],
            [28.350183676825583, -1.947568994789869],
            [28.350183548366498, -1.947569263230376],
            [28.353979596991849, -1.949598747206891],
            [28.358533859649601, -1.952033996721797],
            [28.359867357484902, -1.952531575539818],
            [28.365704196976086, -1.954710621171124],
            [28.377036974291276, -1.960858725829436],
            [28.382268124702133, -1.977890366813404],
            [28.374324970329965, -1.993215800319342],
            [28.374324741259574, -1.993216241381045],
            [28.366519237535041, -1.994292119770405],
            [28.353050014945957, -1.994050057475842],
            [28.350332259970195, -1.994001388871571],
            [28.34831581255024, -1.99317832363112],
            [28.338387812591538, -1.989127436059911],
            [28.327120959041778, -1.976164458058321],
            [28.326070028974041, -1.976396905412906],
            [28.315705520550811, -1.978689945795412],
            [28.304197311243762, -1.990509033106679],
            [28.304197178293123, -1.990509041241024],
            [28.304196880950752, -1.990509346730986],
            [28.298197493105544, -1.990860587851802],
            [28.286580880499923, -1.99236669485439],
            [28.280786514253702, -1.993118285911578],
            [28.277351594660772, -1.993318975314084],
            [28.266388314184873, -1.993960695525492],
            [28.240211798471098, -1.990571590762826],
            [28.240038523334267, -1.990549160750054],
            [28.193445027774445, -1.992854333038721],
            [28.174734041179391, -1.993780043773352],
            [28.171651840591192, -1.993932724272328],
            [28.159870193094847, -1.998878325902781],
            [28.154963481825259, -2.000938301522204],
            [28.154763868084295, -2.005224446203195],
            [28.1545467380936, -2.009908676118327],
            [28.151163101523601, -2.020040512461244],
            [28.15145079687483, -2.022815053883711],
            [28.151640507588091, -2.024638836636914],
            [28.154032180403885, -2.02725018703765],
            [28.161292090543988, -2.035176899123099],
            [28.167056365923166, -2.045962088844991],
            [28.158573578288472, -2.047778339136622],
            [28.147496748065727, -2.046913596369315],
            [28.099762950847168, -2.065770155065835],
            [28.100122949798941, -2.0474247696799],
            [28.094860114011393, -2.025056378305689],
            [28.100786428399807, -2.008339724790347],
            [28.087134160596861, -1.998684268456095],
            [28.07765572881026, -1.998626809515798],
            [28.043032038272926, -2.004001667263283],
            [28.011623865498457, -2.011789053511334],
            [27.997892036605748, -2.03244722176777],
            [27.99061500188138, -2.025223531054511],
            [27.988642563825525, -2.008459147453483],
            [27.984655926832854, -2.006839492026323],
            [27.973653615456197, -2.009166125497575],
            [27.961973785709102, -2.016275151833846],
            [27.949751795738546, -2.00024647498075],
            [27.932374608812754, -2.000141284024144],
            [27.908659627894412, -1.99920014343277],
            [27.885019166720493, -2.0014502351674],
            [27.861603344554737, -2.013274875938025],
            [27.838393082977095, -2.033875567340683],
            [27.815467939484144, -2.032939308924878],
            [27.784569522005842, -2.028763605166259],
            [27.760517939655625, -2.013461122767106],
            [27.739681874169953, -2.000571238662255],
            [27.742771031311708, -1.986675439493217],
            [27.74653266907178, -1.977680554124828],
            [27.745055229686933, -1.961839910184943],
            [27.742907111704216, -1.939081980837492],
            [27.74354431098973, -1.926890961660631],
            [27.750542345156511, -1.904329983890127],
            [27.749587266227898, -1.889057872989129],
            [27.748587186195159, -1.873063999277685],
            [27.754056303019727, -1.868214001245273],
            [27.754723382068228, -1.863841893387463],
            [27.751732144885715, -1.858794978548627],
            [27.751719184891122, -1.855575912260531],
            [27.756249060983837, -1.844750835669831],
            [27.755549221275221, -1.841534985827882],
            [27.749137265067798, -1.838798843063274],
            [27.742020071175201, -1.831006873724321],
            [27.741318071916666, -1.826870838698024],
            [27.744025268992871, -1.817891861933456],
            [27.744881348187263, -1.803402980557267],
            [27.747586386611847, -1.7939648780266],
            [27.746655067224197, -1.789369928113808],
            [27.743220761180588, -1.788233002861215],
            [27.739113879297268, -1.790087621709795],
            [27.737256193832437, -1.784220839713379],
            [27.73656715456849, -1.782049005483036],
            [27.727158200282602, -1.772885875006355],
            [27.720515481251734, -1.769461108593218],
            [27.716485540970808, -1.769363019262741],
            [27.712285171415857, -1.769260963470918],
            [27.709828011415858, -1.770069370073654],
            [27.697446342310307, -1.774142937657273],
            [27.697203310296704, -1.77391651398712],
            [27.694005337529642, -1.770937085993338],
            [27.687609501589964, -1.772338917259617],
            [27.684636110338893, -1.771659978140738],
            [27.680718233093049, -1.764085877132301],
            [27.680445352757484, -1.752360947058996],
            [27.673791117324658, -1.745945846540953],
            [27.673321318194024, -1.742958970886705],
            [27.67806323442305, -1.727766905972467],
            [27.677367354488208, -1.725239926764385],
            [27.672780238643874, -1.721117883700665],
            [27.670174199953514, -1.713757957951434],
            [27.668389419062187, -1.708717206131404],
            [27.659024652905124, -1.710589904317694],
            [27.6558123699756, -1.707382899058689],
            [27.65534725016925, -1.705314923503163],
            [27.658072448585422, -1.700706962684517],
            [27.656911448844266, -1.696111961751315],
            [27.653462290954074, -1.691065843307061],
            [27.645445545695519, -1.686725968138643],
            [27.623038651069752, -1.684966009953281],
            [27.617997626393844, -1.681305128328847],
            [27.617753195703358, -1.6771668812629],
            [27.615449196662642, -1.672806928130994],
            [27.606064363040453, -1.669390985010027],
            [27.597340534058855, -1.658845012365983],
            [27.595902632224597, -1.65871445246304],
            [27.590024213312191, -1.658180898478864],
            [27.587273455131204, -1.656350858118672],
            [27.578086346092977, -1.644196957230272],
            [27.573971463813709, -1.644440961871513],
            [27.571467423433983, -1.647208788275278],
            [27.570176346741317, -1.646756000041356],
            [27.567578228496796, -1.645842956291965],
            [27.560687472039589, -1.636899863073247],
            [27.553512721290101, -1.638188631166126],
            [27.551551452886489, -1.638540924275122],
            [27.550915852602145, -1.638423181668905],
            [27.547892698277593, -1.637863057376174],
            [27.545137589555694, -1.63575928892427],
            [27.543996532413832, -1.634887909802792],
            [27.540766525723743, -1.627081871003752],
            [27.528405212442522, -1.622065841008323],
            [27.526335214651862, -1.618854833333798],
            [27.525614494502779, -1.608970993120973],
            [27.51941745843046, -1.601864852841457],
            [27.515299421267919, -1.600958995321941],
            [27.508174305132854, -1.589716995202099],
            [27.506323546577143, -1.58374600292604],
            [27.507891345699825, -1.575233947576304],
            [27.50394754846473, -1.558923912666065],
            [27.498616310459862, -1.53871095093984],
            [27.494019473945837, -1.531829959809293],
            [27.481787401284564, -1.518197992996718],
            [27.472220407289086, -1.507532994540615],
            [27.458462295487763, -1.49470497999253],
            [27.454541537344795, -1.48483298354919],
            [27.452189299671645, -1.466448992557034],
            [27.449419699327603, -1.459329763413914],
            [27.444003345051225, -1.45556120115155],
            [27.430574094797318, -1.446217506072243],
            [27.421302599817917, -1.451319909571018],
            [27.411477120090996, -1.45813377137197],
            [27.403307306399622, -1.458670666639039],
            [27.391423495302647, -1.450051645008968],
            [27.378877502772077, -1.423434886295191],
            [27.368052308626702, -1.402252209383702],
            [27.35580871507192, -1.379349510783175],
            [27.352087037968932, -1.368764932745231],
            [27.346934360788019, -1.360818000222023],
            [27.345753561279668, -1.349558913944144],
            [27.348229639799577, -1.339205919385034],
            [27.356633475402234, -1.324928993482604],
            [27.364794309534027, -1.306742841619246],
            [27.362958310298492, -1.304680967002896],
            [27.355876657351789, -1.304472858437873],
            [27.345341361226726, -1.297380876115737],
            [27.341457264228804, -1.296934088049887],
            [27.333240027575254, -1.299487946293466],
            [27.326378372041656, -1.297670977609898],
            [27.320949183534811, -1.293328266083411],
            [27.320653669247378, -1.293091888756368],
            [27.315976537720029, -1.286459889908528],
            [27.313534659859616, -1.282999919573494],
            [27.309182621447025, -1.279106951357541],
            [27.296137668675048, -1.272941977262217],
            [27.286742393934325, -1.264466959659831],
            [27.282359396882129, -1.25206791127341],
            [27.264725525347043, -1.239251841509124],
            [27.260815568547041, -1.231677851544932],
            [27.253249451472662, -1.223427940055074],
            [27.239733618896746, -1.212205898686963],
            [27.235367593715178, -1.205095007183762],
            [27.232767341073558, -1.205030088008969],
            [27.227144235042978, -1.204889585911028],
            [27.228249673085529, -1.192710022422662],
            [27.232109591927578, -1.188110016457752],
            [27.247407169987493, -1.176433856720756],
            [27.248517886530657, -1.175586080099145],
            [27.250569666487351, -1.174020016894046],
            [27.253822266705171, -1.173755083952819],
            [27.254082832036492, -1.17373386020191],
            [27.265179373991515, -1.172830037309813],
            [27.267647011042698, -1.174960253308049],
            [27.267886836070733, -1.175167285370017],
            [27.268620153295043, -1.175801225289874],
            [27.268771719744716, -1.1761188317353],
            [27.274679580940557, -1.188510047633756],
            [27.274978145906694, -1.189161885265634],
            [27.274999709965119, -1.189208964601957],
            [27.275061496090348, -1.189340809162767],
            [27.275694050187536, -1.189623286958269],
            [27.275818884571017, -1.189679033678682],
            [27.277119622644534, -1.190259809462981],
            [27.287609696679883, -1.183790024489497],
            [27.295139647580921, -1.181240093846905],
            [27.297873233566897, -1.181312538132423],
            [27.297892080221569, -1.181313037236844],
            [27.302679652426605, -1.181439920972386],
            [27.322359551107304, -1.192409995892609],
            [27.326089881681398, -1.192402295972275],
            [27.327159500300318, -1.192400088890805],
            [27.334033567856213, -1.189127961632653],
            [27.334449848955501, -1.188929784279383],
            [27.335854718838458, -1.186173815477411],
            [27.336330844803648, -1.185239883184992],
            [27.338089602399492, -1.181790039978256],
            [27.333479443869845, -1.171459975717891],
            [27.329329609041178, -1.167643548371261],
            [27.328602397665868, -1.16697476312435],
            [27.324769606148774, -1.163449901625731],
            [27.323572569591654, -1.160546749109403],
            [27.323208759986425, -1.15966440889964],
            [27.321549407264957, -1.155640002378804],
            [27.312384898940945, -1.146247530122844],
            [27.308617555082176, -1.14392676017867],
            [27.308323275978257, -1.143745514115613],
            [27.306609411688726, -1.142689948973553],
            [27.299118843828069, -1.138059054511503],
            [27.297834746146886, -1.137265185770339],
            [27.294979588458521, -1.135500126121828],
            [27.290389615971616, -1.1293100642884],
            [27.290253125947331, -1.128948502513232],
            [27.288309536388496, -1.123799949691545],
            [27.285616209300276, -1.103666492036656],
            [27.285097601106983, -1.099789720756489],
            [27.284099697692145, -1.092330037009174],
            [27.280429498546525, -1.087739959414116],
            [27.275390606471095, -1.085230489349662],
            [27.268289581355319, -1.078359940592862],
            [27.268126961136062, -1.077289143921437],
            [27.266649422038206, -1.067560078137812],
            [27.268957326953768, -1.062886505777146],
            [27.269365943627051, -1.062059045183529],
            [27.269829661163232, -1.061120003664176],
            [27.277118717142727, -1.055120629578638],
            [27.277881879095705, -1.053413434940453],
            [27.278249698780378, -1.052589919588998],
            [27.278128357945075, -1.05022153862235],
            [27.277519619084341, -1.038339962917799],
            [27.277284081715184, -1.037819706013728],
            [27.277236310206671, -1.037714189064058],
            [27.277039739957878, -1.037280003787081],
            [27.268539421700428, -1.018150026306572],
            [27.268611819624134, -1.015932363622877],
            [27.268654109612761, -1.014636946527093],
            [27.268749515187526, -1.011710244846574],
            [27.269910711659751, -1.009387886262447],
            [27.276689459879165, -0.995830102976998],
            [27.274442348450446, -0.986532781501347],
            [27.274139715912678, -0.985275110739162],
            [27.274349459955108, -0.980220049221152],
            [27.276140228117821, -0.977948504323883],
            [27.276168915816399, -0.977912057283981],
            [27.282109875438923, -0.980189802548179],
            [27.285759656776445, -0.978800016004236],
            [27.297609109110443, -0.969570314260565],
            [27.298044105710357, -0.969091237041521],
            [27.310339729686426, -0.955549949609941],
            [27.310799449719589, -0.955050051123954],
            [27.321529606599473, -0.953409972468154],
            [27.32654058891735, -0.950410008886162],
            [27.328477804929211, -0.950347039184144],
            [27.32852982097744, -0.950345348248977],
            [27.334539642754667, -0.950149995496869],
            [27.335857769517133, -0.949065433055837],
            [27.337487326018937, -0.947724622872488],
            [27.341819561071084, -0.944160028360412],
            [27.344879949665863, -0.943166290037776],
            [27.345153543263752, -0.943077451552059],
            [27.346839576847444, -0.942530053033252],
            [27.354487490918327, -0.942857248817583],
            [27.354625534129728, -0.942863154444214],
            [27.356889515919477, -0.942960015400339],
            [27.366039633232624, -0.947299991622778],
            [27.368730546547681, -0.947674213975969],
            [27.368821215305953, -0.947686822755951],
            [27.372439650829925, -0.948190005633205],
            [27.385899388107958, -0.945160009301177],
            [27.393189386420175, -0.94259995753754],
            [27.408827255292877, -0.930344882466618],
            [27.409369645484993, -0.9299199425376],
            [27.423950635646147, -0.921369513935538],
            [27.441729611150755, -0.913500007800645],
            [27.44615274582819, -0.912931229907496],
            [27.446391016770779, -0.912900592906687],
            [27.449039294245797, -0.912560075569142],
            [27.457039824913476, -0.915749900668843],
            [27.457454046175819, -0.91571029260401],
            [27.463659364715078, -0.914809959991631],
            [27.468323759928346, -0.912672361212962],
            [27.471293177930921, -0.911311536736579],
            [27.482358886112138, -0.906240413185095],
            [27.485320523806056, -0.906459492424112],
            [27.499689755901887, -0.900439929272293],
            [27.508049843550236, -0.900401331996071],
            [27.509643056012273, -0.900393927945374],
            [27.511767592320449, -0.900006313029651],
            [27.517266849419428, -0.899002989762224],
            [27.517821278833011, -0.89925173900661],
            [27.52057494306391, -0.900487732781478],
            [27.521840900166278, -0.901055854357895],
            [27.524407831599063, -0.900812056945261],
            [27.525288063796509, -0.900728446702377],
            [27.52686252841859, -0.900578961389002],
            [27.527408680755116, -0.901179105373062],
            [27.529154863733659, -0.903098950011944],
            [27.536245891498634, -0.906291530710889],
            [27.543336627311152, -0.909484017228342],
            [27.54813458404087, -0.90992692805304],
            [27.555423320220129, -0.905076918239459],
            [27.557088040375419, -0.904934718691228],
            [27.559852425100914, -0.90469858510523],
            [27.575055789650477, -0.903400044518953],
            [27.580846900402115, -0.908382088589919],
            [27.583302806354002, -0.91049499297089],
            [27.5862765811857, -0.912092533211198],
            [27.589251782542092, -0.913690869379717],
            [27.607072879152067, -0.91592690536324],
            [27.607716021691513, -0.916155522962977],
            [27.610944538076549, -0.917303164553188],
            [27.613475883647684, -0.918202920522022],
            [27.616915995502936, -0.922325998844243],
            [27.620807073308939, -0.924380802240261],
            [27.624181088023924, -0.923519770567883],
            [27.625369952606881, -0.923215925230414],
            [27.626981956926368, -0.923453334384114],
            [27.628870736676465, -0.92373151436279],
            [27.62993955309981, -0.923888992274397],
            [27.635226669451203, -0.93283188097855],
            [27.636832985638272, -0.933632993084769],
            [27.638429101455326, -0.934428782604583],
            [27.639334719144383, -0.934172402177833],
            [27.642087603637634, -0.933392902624557],
            [27.642535579995076, -0.933265986008441],
            [27.646166105944484, -0.927049146824026],
            [27.650837732595786, -0.9293028098771],
            [27.653257055556043, -0.930469756491715],
            [27.655447806683842, -0.929948892061892],
            [27.663067993355149, -0.928136937119918],
            [27.665906445972457, -0.928785636417552],
            [27.669009777631082, -0.929494935642322],
            [27.679516681603282, -0.92991690878296],
            [27.689997770689196, -0.923674871214731],
            [27.692064462679603, -0.921519625924912],
            [27.697957727150406, -0.915373838343051],
            [27.70631781749368, -0.893054893942179],
            [27.706920889781593, -0.892900893350089],
            [27.708142616534303, -0.892589123197848],
            [27.70940035854338, -0.893918661119719],
            [27.712041642633924, -0.896710994082367],
            [27.714326454558467, -0.89727674438787],
            [27.716612887043805, -0.897842775828631],
            [27.717745570988924, -0.896909857424528],
            [27.720254619476371, -0.894842906655654],
            [27.720669049147872, -0.894799816967239],
            [27.720858120260665, -0.894780149361841],
            [27.721186719500029, -0.894745966611283],
            [27.740048666181909, -0.892792314546303],
            [27.751032362669282, -0.891654663487684],
            [27.752438753399993, -0.891508954886995],
            [27.759730825023908, -0.887344845558696],
            [27.766345934334524, -0.885712866456833],
            [27.769072822481739, -0.882945866962897],
            [27.76948204731449, -0.881361697800055],
            [27.772221740946101, -0.870755928451701],
            [27.772198700955677, -0.865010918277049],
            [27.768168670843213, -0.846032483352923],
            [27.767080069025727, -0.840905058982002],
            [27.769101621571451, -0.833085846105847],
            [27.776593938451956, -0.822258895672744],
            [27.779534967894925, -0.815355879579068],
            [27.779208618037032, -0.811607985556641],
            [27.779178365473211, -0.811259748264118],
            [27.778815857526844, -0.807086913649476],
            [27.781308856713412, -0.802252981226411],
            [27.782832535080889, -0.794223263967459],
            [27.783097878551203, -0.792825937319975],
            [27.780078737899352, -0.780430921604138],
            [27.782055432173021, -0.774378782759123],
            [27.782332697185449, -0.773529866317843],
            [27.787410515058774, -0.764830831688173],
            [27.78959075949102, -0.761096089679377],
            [27.793004376435277, -0.75811488869339],
            [27.797780651427317, -0.753943983608275],
            [27.799007825563898, -0.750186662798196],
            [27.800034916140628, -0.747042857191827],
            [27.800642915687856, -0.746887351592112],
            [27.801860711412868, -0.746576112494364],
            [27.805297643232027, -0.750009533001808],
            [27.806428927601935, -0.746789858103862],
            [27.804622107443418, -0.741056478090097],
            [27.804115080330774, -0.73944678321803],
            [27.806561739923438, -0.734610084518612],
            [27.80819094248902, -0.731390031139544],
            [27.806685945486183, -0.726342034905233],
            [27.805181012263741, -0.721292922480421],
            [27.805236945864912, -0.720454844492286],
            [27.806042648436506, -0.708424969693462],
            [27.805588688400931, -0.704701983730088],
            [27.805063327571627, -0.700395856286556],
            [27.804389889349242, -0.694876010532319],
            [27.805512727758835, -0.690277861897008],
            [27.80892183336374, -0.686129843157852],
            [27.81050903519823, -0.68528140358725],
            [27.817576683409648, -0.681502907387385],
            [27.826905719974555, -0.673886940715107],
            [27.830983798276609, -0.666289885515103],
            [27.829417147200882, -0.661913095794304],
            [27.827288759815083, -0.655966961138219],
            [27.822714602168716, -0.653686972310406],
            [27.824423880558729, -0.625194865044772],
            [27.828142314743527, -0.617090568404288],
            [27.830758958944156, -0.611388043348192],
            [27.832259006229748, -0.610759824934156],
            [27.834633704479959, -0.609764336865112],
            [27.841009074102498, -0.596021892430571],
            [27.886855928625728, -0.596174361666241],
            [27.903752370449158, -0.593959588721595],
            [27.911592806960151, -0.584849971877644],
            [27.935616851455343, -0.576299953310351],
            [27.936844303171355, -0.568925883469901],
            [27.938065756836217, -0.561588895892101],
            [27.941458754749764, -0.554455939475307],
            [27.947375712286178, -0.549837841218733],
            [27.951022596556928, -0.548905037506246],
            [27.962668615513369, -0.550007920760269],
            [27.970406703370763, -0.544694923426067],
            [27.970837623415918, -0.538720978991786],
            [27.974655144471523, -0.530173714959446],
            [27.97762074104088, -0.523533865521133],
            [27.977727848070504, -0.522516145553905],
            [27.977852580944347, -0.521330958594459],
            [27.978331260819918, -0.516827930308877],
            [27.978717659461257, -0.513193010324155],
            [27.97564470074073, -0.488399906034282],
            [27.97807685972808, -0.470015973399656],
            [27.973933621228568, -0.46176297676939],
            [27.972955660413056, -0.458087213791252],
            [27.969294663609208, -0.444326975506137],
            [27.957144669117127, -0.431971943507023],
            [27.949774751287343, -0.416154870001849],
            [27.941975947198198, -0.406539005721835],
            [27.94629355318591, -0.402157903779337],
            [27.948470381325127, -0.394105802066006],
            [27.949214591520544, -0.39135296058319],
            [27.949730411343211, -0.390514811627605],
            [27.951481870127406, -0.387668884361325],
            [27.963307506326583, -0.37820699632142],
            [27.970374796110189, -0.376112028824677],
            [27.985598697045468, -0.360894988379505],
            [27.986199536121564, -0.35843394249437],
            [27.990756773999536, -0.339746016149271],
            [27.996186652412483, -0.328702911093615],
            [28.009370567372393, -0.316937968816885],
            [28.028406700082833, -0.311189940004909],
            [28.035577103884666, -0.309024913421898],
            [28.073224932401807, -0.307953985670298],
            [28.077284491934261, -0.304167966327454],
            [28.081633696162115, -0.30011193451405],
            [28.085877297140112, -0.296420202494045],
            [28.087998726175726, -0.294574807185634],
            [28.096209729419517, -0.293622879678288],
            [28.100741767757142, -0.286485887410075],
            [28.106892724746981, -0.284393938000586],
            [28.113480722003999, -0.277706979580432],
            [28.116293436091805, -0.277290458176705],
            [28.118268770316131, -0.276998032868763],
            [28.133568533078826, -0.279690887396082],
            [28.135148070487315, -0.279175374971701],
            [28.137690405149311, -0.278345549962499],
            [28.139266697842981, -0.277830830601005],
            [28.145627627945643, -0.271603968394156],
            [28.150407705506229, -0.269058012542682],
            [28.151847445293587, -0.267107528074638],
            [28.153128583924229, -0.265371908294588],
            [28.154467423142204, -0.258708008534754],
            [28.152848504489999, -0.253892926568138],
            [28.146887989442089, -0.247717032904571],
            [28.145729398982478, -0.245573588846022],
            [28.143668769721913, -0.241759904042192],
            [28.143849835947201, -0.240145494189801],
            [28.144984884258147, -0.230045328823043],
            [28.142686777267393, -0.226609893769159],
            [28.137998861465054, -0.198845949546052],
            [28.131324827163365, -0.186015888683981],
            [28.127606030957505, -0.170188901683227],
            [28.118635918060974, -0.153923934173877],
            [28.118314799092975, -0.133490876221289],
            [28.113653883054798, -0.111009986962249],
            [28.113899762727868, -0.10985198653196],
            [28.116335880590661, -0.098372003826443],
            [28.110323886687084, -0.080260856266977],
            [28.107711008224125, -0.056854971083163],
            [28.10198089308027, -0.050679977940246],
            [28.101511813500149, -0.047696927187015],
            [28.103754971443312, -0.039193853409574],
            [28.101187094084516, -0.025889886051419],
            [28.098871936171356, -0.018324025600654],
            [28.091286428063263, -0.005040543055901],
            [28.100674094073536, 0.004681036294669],
            [28.09999009525664, 0.008813981252912],
            [28.102268892960382, 0.012719110073451],
            [28.101812773374849, 0.015245089004032],
            [28.097250857070893, 0.018688999257359],
            [28.097021898064519, 0.022363067883257],
            [28.102493892192953, 0.028335119965782],
            [28.102722852995925, 0.033387076341181],
            [28.098387016597815, 0.037980158197406],
            [28.098387016597815, 0.039408150941006],
            [28.098387016597815, 0.041884023634999],
            [28.102718892323857, 0.049233060588287],
            [28.106595008688799, 0.063013021109496],
            [28.105909930096924, 0.068983988144112],
            [28.099522095451494, 0.079089156320566],
            [28.100205015391744, 0.083222998770096],
            [28.106817849269746, 0.093788119610227],
            [28.105903809874899, 0.098152118472611],
            [28.102482012871636, 0.102974090523673],
            [28.104305771663121, 0.106419977484724],
            [28.128027949883506, 0.115838084960438],
            [28.130765027621003, 0.119284150369957],
            [28.127798989978835, 0.124566073813289],
            [28.130307347661844, 0.127322066123593],
            [28.13692181916862, 0.127782128573682],
            [28.139432020194608, 0.132605028842758],
            [28.138289020895087, 0.134213071131232],
            [28.139658819650997, 0.138118008884821],
            [28.152203008364495, 0.144779074666569],
            [28.154028926705934, 0.15098108485187],
            [28.15197404845982, 0.158101021125244],
            [28.140564939498333, 0.180150023959344],
            [28.137598901856133, 0.183596080030488],
            [28.131211349281724, 0.186810935523044],
            [28.121859479338891, 0.184973155310387],
            [28.120262757159026, 0.186809994983841],
            [28.12710383139116, 0.192553118042184],
            [28.128245030466864, 0.197147074632101],
            [28.126873790813214, 0.205646132922832],
            [28.128013910113939, 0.210240084868898],
            [28.133717024595303, 0.216212095634987],
            [28.133986557808079, 0.218928920165954],
            [28.134027573985652, 0.219342355034269],
            [28.134046770983257, 0.219535859724291],
            [28.134172784854695, 0.220806045290468],
            [28.127782789761014, 0.228616062242599],
            [28.120025877706844, 0.234128111579021],
            [28.112954175398556, 0.234357002842067],
            [28.107936008355029, 0.232060124421621],
            [28.106186996581695, 0.232451137970625],
            [28.101776773389837, 0.233437100447719],
            [28.099950855048395, 0.234815157953818],
            [28.096754777726577, 0.245152023644677],
            [28.094245245047198, 0.246529869238725],
            [28.086945361673589, 0.244921273198009],
            [28.083295109618856, 0.247447101065666],
            [28.080326912426731, 0.255257103633471],
            [28.07736087478456, 0.258013033074234],
            [28.076217876383343, 0.265134001112995],
            [28.074620260379795, 0.26605276176634],
            [28.070386819347672, 0.265083009697556],
            [28.069601802282108, 0.264903123514609],
            [28.066177844830626, 0.26972703226544],
            [28.065948884925952, 0.272943090939569],
            [28.06845700275877, 0.277997152113108],
            [28.06777408281852, 0.28052400146081],
            [28.062068088338364, 0.284888132660501],
            [28.058414811656068, 0.296832981866071],
            [28.055219814109229, 0.30211610589068],
            [28.054534015068512, 0.307399048249652],
            [28.056812812772254, 0.317967086386137],
            [28.055899133601809, 0.324169018825896],
            [28.056811013446737, 0.326467144200069],
            [28.061601888757068, 0.329454112139013],
            [28.062058008342564, 0.331981130115831],
            [28.056579893093808, 0.339561998324792],
            [28.058175024357279, 0.350818826335809],
            [28.057714971947451, 0.364833018694058],
            [28.059082971377876, 0.376550140136383],
            [28.056344094314866, 0.380455002717104],
            [28.050410519742343, 0.381372991335684],
            [28.04196828205956, 0.377466261692408],
            [28.039457948082937, 0.380912065348829],
            [28.044703143653248, 0.390332136908646],
            [28.044018064163076, 0.394697118894934],
            [28.042876144638534, 0.396994145532282],
            [28.03443415219586, 0.402736077150071],
            [28.037170869708916, 0.405494127432175],
            [28.039420162247126, 0.405760758626847],
            [28.041051069815133, 0.40595421009633],
            [28.045384487948489, 0.410779779708554],
            [28.051773955731107, 0.407564382551098],
            [28.052685056736649, 0.412619132284192],
            [28.047889861428143, 0.427781982672447],
            [28.04278614602346, 0.429600130661786],
            [28.036935790480548, 0.431686098630183],
            [28.032599129429002, 0.436739775296823],
            [28.025983392195982, 0.436279064146958],
            [28.02484016113111, 0.438806032930684],
            [28.030084996477019, 0.447538103943855],
            [28.028486957366944, 0.451903053468995],
            [28.029169877307197, 0.458336118953516],
            [28.026659959250527, 0.463390073636652],
            [28.024495039178735, 0.463753629864024],
            [28.023921082187513, 0.463850015266946],
            [28.017304508622995, 0.460631426133144],
            [28.012967010341622, 0.461090003295786],
            [28.007487094869017, 0.47142805644199],
            [28.004065158626904, 0.473954867148446],
            [27.989245368415471, 0.472186350524734],
            [27.982841876134632, 0.471422109512307],
            [27.980508603693771, 0.47169313341171],
            [27.965040330458521, 0.473489865514067],
            [27.962640306903804, 0.47390574983189],
            [27.959788574491672, 0.474400012200394],
            [27.953628619077609, 0.480829992050364],
            [27.941078670366522, 0.478520016002219],
            [27.935150403040684, 0.480300294598456],
            [27.934918714952495, 0.480369871595113],
            [27.932863070443453, 0.482781973780936],
            [27.929438798581586, 0.4868000266173],
            [27.924868602505619, 0.487950057550922],
            [27.920988886591338, 0.491849995594481],
            [27.917569032644064, 0.491849995594481],
            [27.915048890861161, 0.484490051719625],
            [27.912629728699354, 0.482177234596953],
            [27.91072889445644, 0.480359959154331],
            [27.907038089754831, 0.481549303633435],
            [27.905019867263913, 0.482199666676819],
            [27.902765432768984, 0.487537161122665],
            [27.901138861368867, 0.491390054958644],
            [27.898171541830809, 0.490931904875656],
            [27.898158783957133, 0.490929935232185],
            [27.892009275051514, 0.483340472357925],
            [27.885629206341726, 0.480580269274269],
            [27.881058797365078, 0.480350046713537],
            [27.872084474963117, 0.484390357639762],
            [27.864488730552363, 0.487810020178011],
            [27.863711524338228, 0.488158715048781],
            [27.858667643918015, 0.488033701418083],
            [27.854128658009969, 0.487919959432027],
            [27.849832469655254, 0.489193381403858],
            [27.846368864160379, 0.490220019807222],
            [27.843968448940227, 0.491477281760602],
            [27.841118628142986, 0.492969927553919],
            [27.837840266937764, 0.499180697721317],
            [27.837238596021727, 0.500320087894056],
            [27.832865334910576, 0.502246504652372],
            [27.829929316270245, 0.503539817373578],
            [27.825818639903154, 0.509970015638014],
            [27.825483792881013, 0.510138663825239],
            [27.821708883410924, 0.512039919087217],
            [27.821663526573914, 0.512096331372004],
            [27.816910283487452, 0.518008067430168],
            [27.814912627924944, 0.518632162300681],
            [27.810298691979504, 0.520070092409162],
            [27.80753111374316, 0.522019520207694],
            [27.796598902399669, 0.529719949157312],
            [27.800688505188514, 0.53198346579639],
            [27.812247370494426, 0.538381070662284],
            [27.818746445318094, 0.541872405449759],
            [27.830290916019884, 0.545003286626884],
            [27.842927267389925, 0.551636490021009],
            [27.855201097338878, 0.55756950968695],
            [27.863133331790426, 0.558254365735985],
            [27.876475281070078, 0.559979482126503],
            [27.893061548998944, 0.561698289428262],
            [27.901381501717005, 0.571143883969978],
            [27.903798416293981, 0.57389042454277],
            [27.915850610302762, 0.587586315825312],
            [27.922733085191389, 0.598436892629096],
            [27.941165070330555, 0.614170423478452],
            [27.955246458853171, 0.621852081963029],
            [27.969099967246091, 0.621238061650444],
            [27.976634397147123, 0.61342695291362],
            [27.982917853844743, 0.612560174991684],
            [27.98827635931174, 0.611821084712954],
            [27.993069107609454, 0.612741070964013],
            [28.00242513944697, 0.621706101927238],
            [28.003334859741937, 0.625612978647123],
            [28.009040368233531, 0.633197198513246],
            [28.009343204688836, 0.633299018787769],
            [28.010666973769638, 0.633744096549192],
            [28.017941637839936, 0.636186917792379],
            [28.020170147854063, 0.634905220372929],
            [28.022734481359077, 0.63343015147716],
            [28.023240983855612, 0.633381739055284],
            [28.025249103892879, 0.633189812080481],
            [28.027527307810203, 0.632972079607027],
            [28.042819707980819, 0.639638955087396],
            [28.043698194751673, 0.641157130739212],
            [28.044416045681722, 0.64239710253341],
            [28.044317984687002, 0.642987851464668],
            [28.043730752392506, 0.646533051671028],
            [28.04454165171801, 0.649121627140444],
            [28.045098956638803, 0.650899940174053],
            [28.050347550535868, 0.653199110697184],
            [28.056395661205446, 0.658558770922889],
            [28.061759545784358, 0.663312083173657],
            [28.064684726250778, 0.663733298094586],
            [28.068148595850364, 0.664232169515639],
            [28.069517040845181, 0.676412986173949],
            [28.073851839689109, 0.678940936575599],
            [28.086979694385423, 0.675556331061233],
            [28.095984820916787, 0.673435370927397],
            [28.105360566283242, 0.674818144392973],
            [28.116542520953786, 0.677248788754017],
            [28.126283396448937, 0.680032664248866],
            [28.140710030891427, 0.682807167714555],
            [28.159100823783223, 0.685223008160819],
            [28.182888260117423, 0.684473866442404],
            [28.228226015114636, 0.687180257876628],
            [28.239670744972095, 0.687863444699602],
            [28.248502260396712, 0.688020597260172],
            [28.259145194455751, 0.690977984053266],
            [28.261099344609065, 0.690879015341721],
            [28.269956637190763, 0.690430359025316],
            [28.314313108504201, 0.696999188341747],
            [28.326390022352978, 0.697500380330965],
            [28.337744761680238, 0.697827820682649],
            [28.343427064891412, 0.695022756149668],
            [28.349590821077427, 0.687666097653362],
            [28.351645449591881, 0.686287136847572],
            [28.35803677239554, 0.686975131077891],
            [28.375383714842357, 0.677778993863863],
            [28.374696836026665, 0.674791106550411],
            [28.376979592605846, 0.670423982502592],
            [28.378119443310307, 0.661921380162819],
            [28.38473974488328, 0.663988089575237],
            [28.390901531063861, 0.663526982032359],
            [28.392727776392078, 0.657781070599995],
            [28.394376181345184, 0.657708509743077],
            [28.397976629902239, 0.657549967174313],
            [28.402770033071771, 0.652723126243583],
            [28.410072627560918, 0.652490953687002],
            [28.418287750478594, 0.645135062432149],
            [28.423308378905972, 0.635481948802493],
            [28.434263633833108, 0.635018843709169],
            [28.442479055889784, 0.628352153010656],
            [28.446357835759557, 0.629729598136751],
            [28.44795675971017, 0.626513010578018],
            [28.447040559867038, 0.621225985419829],
            [28.452745473673922, 0.615708989013313],
            [28.458906507066303, 0.606745029419983],
            [28.477161727113749, 0.593181015065992],
            [28.476932407882934, 0.587206039669147],
            [28.482179401880469, 0.58605602856253],
            [28.487884675013454, 0.577781019152493],
            [28.498380464130641, 0.572722109895953],
            [28.504997616210222, 0.566745130333528],
            [28.499975622343587, 0.55962299511355],
            [28.501114660971041, 0.555487003700291],
            [28.498375423683594, 0.551811126414125],
            [28.499515542984319, 0.548364133025998],
            [28.497688544867902, 0.544688070428007],
            [28.498373623459774, 0.541930075381655],
            [28.502479419279901, 0.539631114585381],
            [28.505100576616513, 0.536328115028451],
            [28.507042833973784, 0.533885279571581],
            [28.512291568008031, 0.535491145519282],
            [28.51662848418108, 0.540085103918387],
            [28.520509639196447, 0.541232061263008],
            [28.523248516259461, 0.54490812599767],
            [28.526216567026186, 0.544676879368201],
            [28.528954261906286, 0.542148148765165],
            [28.531692666455459, 0.542147067188361],
            [28.533291385590204, 0.543984007580897],
            [28.540365585214982, 0.543292120526464],
            [28.543790030451692, 0.544899072769742],
            [28.547365547166336, 0.544672506037654],
            [28.554742386515393, 0.544204957557142],
            [28.555654600533604, 0.540298131214839],
            [28.554281561554429, 0.532486057105855],
            [28.558845636510043, 0.528808001606523],
            [28.553592522290486, 0.521457112842916],
            [28.554963187920659, 0.519618273794815],
            [28.568428465109026, 0.52259902661879],
            [28.573906579459489, 0.526733057556781],
            [28.57801633505342, 0.527420080301468],
            [28.579982292662812, 0.529237120856158],
            [28.591942448880847, 0.540280854014432],
            [28.604950769253882, 0.538206323546426],
            [28.60837329928238, 0.540732114034359],
            [28.610885376889001, 0.545326068416818],
            [28.615680571299215, 0.546933140385703],
            [28.61648950421257, 0.546725009356892],
            [28.627318006853123, 0.543939145668827],
            [28.631654472970226, 0.544856039415871],
            [28.635992467121667, 0.548071084787046],
            [28.638733504632931, 0.554273005060216],
            [28.646495455337519, 0.558634999239479],
            [28.647411294956218, 0.56437913624064],
            [28.653578471028521, 0.572418070836839],
            [28.657392313483005, 0.572417084219643],
            [28.660369111145641, 0.581364642483713],
            [28.674284542207715, 0.571554433460523],
            [28.689864963818007, 0.570718008870775],
            [28.700920549782591, 0.571079900337686],
            [28.709966259503563, 0.571477656362765],
            [28.720517126127451, 0.573525010915279],
            [28.733584029233398, 0.573292160253562],
            [28.742628659179395, 0.574248793466951],
            [28.753546466037257, 0.573504855351662],
            [28.762728873293312, 0.575567137737348],
            [28.780821370713557, 0.575244895708115],
            [28.790871477770519, 0.576183506334278],
            [28.803434741310753, 0.576518543577061],
            [28.813482327695052, 0.57913360386722],
            [28.826549231699339, 0.578900933398048],
            [28.840619453264637, 0.579767813451907],
            [28.860214226690712, 0.583330492314371],
            [28.875791046056712, 0.585288270378313],
            [28.887851030255622, 0.586191194787706],
            [28.900915413587214, 0.587634791967515],
            [28.915995072037283, 0.585689810884506],
            [28.932081650292734, 0.582050537445338],
            [28.935821005342163, 0.58027303945132],
            [28.940630918648321, 0.577986653128128],
            [28.948173267198566, 0.575058181884589],
            [28.961751728519484, 0.568110693839604],
            [28.971810114450129, 0.562902189722506],
            [28.991413167648155, 0.560317940481251],
            [29.005480506519735, 0.563420156454121],
            [29.012501216859249, 0.574471370070918],
            [29.017011290489844, 0.583890629320161],
            [29.029069113342207, 0.586470000720205],
            [29.034596545201751, 0.586930293997383],
            [29.039620697720011, 0.587958473863673],
            [29.046151808263364, 0.589518495575969],
            [29.062144784761117, 0.608160143256396],
            [29.065999659562856, 0.611064986834565],
            [29.067626857088719, 0.612291047502844],
            [29.070597932483011, 0.617114006474681],
            [29.072663969601567, 0.628831035373221],
            [29.075633965220881, 0.631356138859282],
            [29.08499467099286, 0.633184138417504],
            [29.098921610372056, 0.639144103579863],
            [29.101664806534945, 0.642358011843899],
            [29.103960806078035, 0.653615573431457],
            [29.110118691773657, 0.650162231778815],
            [29.117652742585644, 0.651762011006353],
            [29.122448654749768, 0.654743965700558],
            [29.127932885729003, 0.661173021564916],
            [29.133791238972908, 0.662007729850503],
            [29.134326942106092, 0.662084107729172],
            [29.157040115531345, 0.676086138464013],
            [29.157602972938932, 0.676151070323851],
            [29.162873818105563, 0.676758822469483],
            [29.164921749679593, 0.671011139788609],
            [29.164916709232511, 0.665495098623589],
            [29.162401139874405, 0.661820510898954],
            [29.165135589141386, 0.658371112345582],
            [29.173350775839459, 0.656063010553108],
            [29.175170573060544, 0.649626017238016],
            [29.176994134222696, 0.648245700905392],
            [29.181795148817642, 0.654903005729727],
            [29.185439557331456, 0.648694088936348],
            [29.18726259477577, 0.645475137758773],
            [29.19456554320114, 0.644546992323605],
            [29.197276698254459, 0.640572005511235],
            [29.203688648173703, 0.638560000896755],
            [29.204594767122678, 0.633503132286669],
            [29.21485871094654, 0.625907096190086],
            [29.218735544167068, 0.62521305714789],
            [29.221242580428282, 0.621533081043694],
            [29.22215095594526, 0.616936216074821],
            [29.253604007653021, 0.618775664838816],
            [29.256603883035286, 0.615595803847117],
            [29.260243117253086, 0.608004788682038],
            [29.263711351766634, 0.603625351753607],
            [29.267433744826878, 0.6020602879896],
            [29.271582019281851, 0.600098189670502],
            [29.276645049987291, 0.596138128282085],
            [29.282709239602148, 0.588574119439941],
            [29.286027354851949, 0.587004546017679],
            [29.290493867377801, 0.586652926863474],
            [29.291939264754809, 0.58988236628683],
            [29.291703824403672, 0.594298039601365],
            [29.290148987072243, 0.600707347194563],
            [29.286340913598508, 0.603878205563197],
            [29.281829041540689, 0.612664469881815],
            [29.280742563340546, 0.617874007418456],
            [29.285546395950508, 0.626362519951485],
            [29.287138673266334, 0.634413616698121],
            [29.288987990026005, 0.637647713122655],
            [29.295004300334536, 0.646149889604973],
            [29.295194380255403, 0.650168485990028],
            [29.296254218017495, 0.660623704787692],
            [29.304352404539671, 0.675575603625837],
            [29.308583477612711, 0.679639590914586],
            [29.325408409047931, 0.686890061428699],
            [29.329741361853991, 0.684355975030846],
            [29.326075488096468, 0.673789971068016],
            [29.328835243803319, 0.670881018201889],
            [29.336560470480794, 0.66274401309383],
            [29.336327550802352, 0.659527054197807],
            [29.339518225656025, 0.656075083987863],
            [29.338830266167058, 0.652629059011501],
            [29.331286479414032, 0.644596012336154],
            [29.331967238007692, 0.640688969249876],
            [29.328303524698423, 0.632421073191667],
            [29.328070244795573, 0.628285137889868],
            [29.330119361247441, 0.625293976150093],
            [29.333999419419847, 0.6241401931962],
            [29.339250125256122, 0.625051886524146],
            [29.34746233134409, 0.622742016961048],
            [29.359096712625998, 0.616291191599899],
            [29.366171726124449, 0.616740777934729],
            [29.367081218247325, 0.615360071117392],
            [29.364338382308834, 0.612606977018677],
            [29.365021300452458, 0.610997040045281],
            [29.38125943258115, 0.59632015430422],
            [29.392181813660475, 0.6029323895348],
            [29.407047628157162, 0.603640129224109],
            [29.424256649563478, 0.606785075337809],
            [29.43371386044808, 0.608513378840001],
            [29.456879099361991, 0.615393773189104],
            [29.473918588911253, 0.625300283746534],
            [29.469513996359598, 0.64871607363466],
            [29.431905944344937, 0.651330737323122],
            [29.411335220532951, 0.665796788308851],
            [29.394274130992684, 0.671448715659786],
            [29.389447619515032, 0.683689517328888],
            [29.376749002319375, 0.69704278924634],
            [29.362855905171866, 0.693099024056288],
            [29.350133527536951, 0.704203302859323],
            [29.347507845386257, 0.708893569492138],
            [29.347005132881911, 0.709791565768651],
            [29.347302492308945, 0.711803180599908],
            [29.347620732176445, 0.713413444307335],
            [29.354276400422147, 0.717504432508654],
            [29.361229068768736, 0.723606844816965],
            [29.370090093850443, 0.747001962413611],
            [29.370555932309006, 0.753433593184355],
            [29.364341983654828, 0.763807298921919],
            [29.365720421508858, 0.775872136295129],
            [29.369545055424847, 0.787562809856782],
            [29.369092896511425, 0.803623871638721],
            [29.370599853638193, 0.813280193302682],
            [29.36972469512548, 0.822106779416368],
            [29.377507161554551, 0.8278167121107],
            [29.382665169338342, 0.825627107386745],
            [29.386730674819681, 0.820865601008641],
            [29.388364236011018, 0.818953054411105],
            [29.389042013096248, 0.818731086330999],
            [29.396122825219834, 0.816414148107026],
            [29.398626983278916, 0.811583110690237],
            [29.403208017528765, 0.810334010230316],
            [29.404560348543978, 0.809965546842934],
            [29.409574538745758, 0.814998840384267],
            [29.409590328433506, 0.815014178726657],
            [29.411281841740454, 0.815200983310669],
            [29.413925889947137, 0.81549306739186],
            [29.41575468738904, 0.815695089120046],
            [29.416830360652966, 0.817672653843234],
            [29.419876684325356, 0.823273141348229],
            [29.425631122253819, 0.827303677749648],
            [29.429700715069725, 0.830154108228765],
            [29.4364178963528, 0.832271336943838],
            [29.442036365279897, 0.834042174849711],
            [29.442436677028379, 0.834511486759988],
            [29.444780741829071, 0.837256005476725],
            [29.445250675707033, 0.839323584022795],
            [29.44707861974943, 0.847366023014076],
            [29.451879935279997, 0.851956071078257],
            [29.454856772468499, 0.858617126058091],
            [29.458051101668769, 0.86021850676286],
            [29.475398125862284, 0.852838057970785],
            [29.481319628874047, 0.845014049618424],
            [29.486108703960561, 0.842017989171561],
            [29.491466579708526, 0.820550990916988],
            [29.494569057069306, 0.801024442999428],
            [29.509634322711921, 0.790211642608195],
            [29.521140271857707, 0.789858598117137],
            [29.536858432150481, 0.788718135090023],
            [29.533286659613903, 0.803048449722104],
            [29.532307101593819, 0.806250706386139],
            [29.529114624719668, 0.813043037569676],
            [29.529238104443664, 0.825897252098598],
            [29.528213185094977, 0.837533534567964],
            [29.521638151425805, 0.847099486025933],
            [29.520848672428261, 0.85432029301713],
            [29.522909310671967, 0.861171289423819],
            [29.528502624974468, 0.862438729176237],
            [29.537349976799213, 0.863340876931619],
            [29.547535447393106, 0.869479295153106],
            [29.559784803640429, 0.874837359039855],
            [29.566718029749349, 0.873709971221206],
            [29.57252518441198, 0.870963347535814],
            [29.58594885073806, 0.861875563335959],
            [29.590862695529335, 0.860725694260905],
            [29.600134342324008, 0.861230681611533],
            [29.607962828546782, 0.858506834471235],
            [29.613834063631867, 0.854556012966254],
            [29.618748172527816, 0.853405902936092],
            [29.623192614345474, 0.853455628623015],
            [29.627487770535929, 0.856315077879539],
            [29.627910770135244, 0.863549382450223],
            [29.626163332210254, 0.873570845846664],
            [29.627351690143417, 0.881616975206358],
            [29.633985763788026, 0.886109304859428],
            [29.636726441074853, 0.895377602335886],
            [29.640871837327662, 0.901046875998595],
            [29.648528309648263, 0.901533987902803],
            [29.659118275444882, 0.907676460008487],
            [29.663648654594205, 0.906120904150638],
            [29.6689471283457, 0.897745762619887],
            [29.688712908662509, 0.875876306941401],
            [29.69598922203971, 0.868326471469109],
            [29.704689332802875, 0.864407197434057],
            [29.714409141007959, 0.864114332154681],
            [29.726783540047897, 0.865505043925187],
            [29.735248574277623, 0.874453117927267],
            [29.738638683209235, 0.87471980127679],
            [29.740955630566447, 0.874902065361534],
            [29.745317740889991, 0.887306080854946],
            [29.743508702791047, 0.896964885995337],
            [29.74918989298958, 0.901855471704275],
            [29.751847047616252, 0.905098193554208],
            [29.756142558641248, 0.907957602661063],
            [29.762947984129639, 0.909238722040869],
            [29.780792427055545, 0.908233144340128],
            [29.786918173725244, 0.907096553427125],
            [29.794638716586825, 0.906379673853347],
            [29.798104429529388, 0.909631401587748],
            [29.807759969564103, 0.910542547675881],
            [29.813032158610394, 0.917830989984247],
            [29.816730430108642, 0.924298557970373],
            [29.821641539529885, 0.930779631632023],
            [29.826022369845614, 0.932033351220502],
            [29.830231840232688, 0.936498405804058],
            [29.838057143724416, 0.941405508761044],
            [29.84335309231167, 0.940661423824418],
            [29.85147791478035, 0.939948876120277],
            [29.85483634642009, 0.945207561725481],
            [29.861204373213482, 0.954199083188659],
            [29.862567330400228, 0.950517959269274],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kindu",
        AREA: 132520,
        POPULATION: 2333000,
        DISTRICTS: [
          "Lubutu",
          "Punia",
          "Kabambare",
          "Kasongo",
          "Kibombo",
          "Pangi",
          "Kindu",
          "Kailo",
        ],
        OBJECTID: 17,
        NOM: "Maniema",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.077619558922834, -0.036580130337068],
            [26.079489865717417, -0.03685998560477],
            [26.083879733084913, -0.035619994918116],
            [26.088301122335725, -0.032234385284699],
            [26.088407842191469, -0.032152666471833],
            [26.089430662177335, -0.031370471102343],
            [26.089975486803887, -0.031615433103227],
            [26.090032395077142, -0.031641023138025],
            [26.091119386215329, -0.032131472576536],
            [26.089813848443256, -0.038643238130242],
            [26.089707568761991, -0.039173337792843],
            [26.089509155170251, -0.040160770653431],
            [26.086549853096052, -0.044300059565838],
            [26.084771901197527, -0.045498391255343],
            [26.084338622176428, -0.045790419300555],
            [26.078359854260263, -0.049820082976115],
            [26.080639803604186, -0.053030015416841],
            [26.090940961036978, -0.050899675425444],
            [26.091177950083637, -0.050850669471799],
            [26.091809748697703, -0.050720023404793],
            [26.09500985226861, -0.054159935044851],
            [26.096111557811156, -0.060356828922908],
            [26.096252965213289, -0.061152218711705],
            [26.097089930953402, -0.065859996103273],
            [26.10141001988459, -0.076480080851552],
            [26.102030642558162, -0.076438874197916],
            [26.102076664148498, -0.076435818336181],
            [26.111199684679431, -0.075830001661644],
            [26.116859735722706, -0.082799917995718],
            [26.122610241725173, -0.079870222397197],
            [26.122759248874615, -0.079999015336155],
            [26.122794888635195, -0.080029833504348],
            [26.123789550928475, -0.080892781997036],
            [26.123749727713612, -0.081690111298255],
            [26.123599974962513, -0.085249748236697],
            [26.132190284648487, -0.086979727290297],
            [26.132551368765156, -0.086771312873988],
            [26.132583567079852, -0.086752725389718],
            [26.134129966535813, -0.08585999979171],
            [26.136349814993995, -0.076590068359176],
            [26.140228338843894, -0.077269800880918],
            [26.144053669852529, -0.081872255644734],
            [26.144698841686218, -0.082648749179828],
            [26.144799645237509, -0.082770072025792],
            [26.143221873018582, -0.093329826475062],
            [26.149839574867123, -0.092860109353849],
            [26.166049675067356, -0.099489933944828],
            [26.169319895739477, -0.095695213337646],
            [26.169759622867673, -0.095184992309661],
            [26.170599827034387, -0.094210047188083],
            [26.173569369902797, -0.094199956247322],
            [26.175894936595157, -0.098250201718254],
            [26.177252746435304, -0.100615384749634],
            [26.183180615807494, -0.110939958149277],
            [26.185478226928215, -0.110624097759671],
            [26.18551207904137, -0.110619443883146],
            [26.188199798845574, -0.110249942723988],
            [26.191427074657224, -0.108194339105755],
            [26.191679090721966, -0.108033818334979],
            [26.194479608383144, -0.106251072309774],
            [26.194769797457582, -0.114319978189004],
            [26.195762004655194, -0.116361161229638],
            [26.196210399627585, -0.117283605300661],
            [26.197389877714173, -0.119710043244746],
            [26.197769678229765, -0.120490094548078],
            [26.192179958985044, -0.13034003610427],
            [26.192225424518206, -0.130567428359529],
            [26.192258053125947, -0.130730619592996],
            [26.192569932022938, -0.132289948274462],
            [26.197229523046062, -0.131489964174683],
            [26.197338445570889, -0.13152468463498],
            [26.197444915695005, -0.131558708732561],
            [26.205709829533905, -0.134199881843446],
            [26.209199675716558, -0.13293990419214],
            [26.212159977615659, -0.129480054416934],
            [26.212171392507976, -0.129488474074986],
            [26.212208016822103, -0.1295155553489],
            [26.213199508062431, -0.13025279180944],
            [26.212779875348804, -0.13969000545502],
            [26.214262256366048, -0.14127395222007],
            [26.214380751338549, -0.141400566269587],
            [26.215699899485514, -0.142809987340472],
            [26.218799794189842, -0.142080081160806],
            [26.218886726854851, -0.141965129827558],
            [26.219513812906907, -0.14113592687091],
            [26.223050035514415, -0.136460072033789],
            [26.226280185934943, -0.136970547338622],
            [26.230059548353911, -0.144509478474195],
            [26.237305566946429, -0.152257500167805],
            [26.237666746284521, -0.15264369348894],
            [26.243489670871963, -0.158869896795161],
            [26.251822868350562, -0.16031138372527],
            [26.25196040401384, -0.160335174878745],
            [26.252738800495727, -0.160469823202345],
            [26.253877815766955, -0.161607979390171],
            [26.254186335863096, -0.161916506504283],
            [26.254579828500248, -0.162310008728704],
            [26.254863520958541, -0.163206937003847],
            [26.254966939505653, -0.163533905919467],
            [26.25847970889771, -0.17463993912392],
            [26.261421130006148, -0.175655542142182],
            [26.261469043448468, -0.175672085694245],
            [26.264909668241764, -0.176860050698579],
            [26.265769708108255, -0.178009938239705],
            [26.266407267618202, -0.178862970608707],
            [26.266541557668361, -0.17904264623083],
            [26.267899827445927, -0.180859963089706],
            [26.268758018579554, -0.186043083833229],
            [26.268874370171812, -0.186745797757824],
            [26.270159906954078, -0.194509907245926],
            [26.272992302231426, -0.199500309309472],
            [26.279539631857244, -0.200289954648244],
            [26.282989944980866, -0.198099966831147],
            [26.28618761950726, -0.197475939381294],
            [26.286548738658212, -0.197405466813834],
            [26.294929703153738, -0.195769916231522],
            [26.295727322684417, -0.19529733713263],
            [26.295833297836801, -0.195234548033754],
            [26.301309585912264, -0.191989977617082],
            [26.307236564155701, -0.199065842023461],
            [26.307466626293213, -0.199340504586348],
            [26.309769621017438, -0.202089961521581],
            [26.309099661071812, -0.207370060516676],
            [26.30995136547077, -0.210179037632471],
            [26.310109053040801, -0.210699101693506],
            [26.312789660882917, -0.219539913078163],
            [26.31537275660094, -0.223048444919324],
            [26.315585581864781, -0.223337518069433],
            [26.316669739716559, -0.22481009328554],
            [26.319210521191437, -0.226480383659763],
            [26.31957292942483, -0.226718627962239],
            [26.321719750240266, -0.228130861071603],
            [26.320799658895339, -0.239909968628241],
            [26.325303353589149, -0.254875593774406],
            [26.325689897757588, -0.256160067650949],
            [26.325713518059668, -0.256238386158568],
            [26.326449858114913, -0.258679892882512],
            [26.333614765125478, -0.265038989990627],
            [26.333838472580688, -0.265237537633131],
            [26.336050067318002, -0.267199505054719],
            [26.336289299457952, -0.26699590207445],
            [26.343730909135626, -0.260660662088306],
            [26.353765472643243, -0.267227913700014],
            [26.354940455560122, -0.267996902322738],
            [26.36285989261216, -0.273179917257717],
            [26.36816818225477, -0.27772023386172],
            [26.368916550751685, -0.278360332609189],
            [26.369768975599513, -0.279089433773837],
            [26.369898862108105, -0.280585544864823],
            [26.369949342935495, -0.281170160159404],
            [26.370109932063915, -0.283029946013638],
            [26.372082052116163, -0.2855716953635],
            [26.372651980163337, -0.286306241209648],
            [26.379768137400081, -0.295477771802646],
            [26.381238431585182, -0.299482652213226],
            [26.381343554236352, -0.299769157919702],
            [26.38210212579823, -0.301831775224665],
            [26.385989888820845, -0.304580052665698],
            [26.387851115444533, -0.305201911709154],
            [26.388030757840088, -0.305261932943869],
            [26.399009647442359, -0.30893007811413],
            [26.40490775383255, -0.307018454421276],
            [26.404992216130513, -0.306991078651075],
            [26.405149804885859, -0.306940148015985],
            [26.407912902325549, -0.312117307260493],
            [26.407919645978389, -0.312129942016484],
            [26.415431787778903, -0.317332084203751],
            [26.415661919985023, -0.317491449714754],
            [26.416959603786577, -0.318390092268554],
            [26.418659390577293, -0.319569669079122],
            [26.425179853389587, -0.318230069305308],
            [26.430749762087352, -0.319189957445065],
            [26.43143988202457, -0.321710129348209],
            [26.430785126065121, -0.323520972618843],
            [26.430693258055989, -0.323775050211133],
            [26.429859841559544, -0.326080010788519],
            [26.431104946069215, -0.328293551450637],
            [26.431253630723468, -0.328557881586871],
            [26.432829840772143, -0.331360056783601],
            [26.432557662919141, -0.332587308697607],
            [26.432471794757756, -0.332974486166201],
            [26.431709882361339, -0.33640994553554],
            [26.434171612989509, -0.337789880629374],
            [26.434474126949656, -0.337959455961991],
            [26.436829817746744, -0.339279906083151],
            [26.436933179699974, -0.339509672437969],
            [26.438539800415953, -0.343079924191983],
            [26.439999705584786, -0.344488746967963],
            [26.440860133523458, -0.345319068609456],
            [26.442539973223294, -0.346940696993066],
            [26.448439798090632, -0.368299929476859],
            [26.453019718429516, -0.37448993273358],
            [26.454399597181254, -0.379769950880959],
            [26.456438288684268, -0.381179228192338],
            [26.456601450587641, -0.381292016814533],
            [26.457377639010566, -0.381828569881117],
            [26.461523828475777, -0.38218156898996],
            [26.461591061086608, -0.382187272719662],
            [26.467869715390712, -0.382719954211418],
            [26.468607370579505, -0.383119826595635],
            [26.468690081162659, -0.383164663314049],
            [26.47083978736681, -0.384329920516334],
            [26.490239233812446, -0.38171000518809],
            [26.494869711335539, -0.379960093946012],
            [26.498129896029287, -0.378719969574525],
            [26.504119441033932, -0.380257895269173],
            [26.50470942037655, -0.380409381009233],
            [26.51510971139253, -0.383079876979],
            [26.524934648537034, -0.383289910221219],
            [26.539969868228322, -0.37659990469069],
            [26.551093765680392, -0.377626452750945],
            [26.551372778814372, -0.377652201391888],
            [26.559909743843811, -0.378440015534863],
            [26.567788518654499, -0.375890422442008],
            [26.582079695236999, -0.368399956976776],
            [26.592189573498032, -0.360860024349608],
            [26.604269731163292, -0.357159895567461],
            [26.611391209121479, -0.353718052735935],
            [26.611721050730861, -0.353558645318389],
            [26.614759642603598, -0.352090100499038],
            [26.616759289731103, -0.356952677849316],
            [26.665997120060183, -0.326950526243617],
            [26.685523156197359, -0.32199831835283],
            [26.698465153054631, -0.319233212756845],
            [26.709135911531302, -0.316052313585102],
            [26.714917866653558, -0.312022497302789],
            [26.728771276231797, -0.302367159839528],
            [26.728786957223395, -0.302356230688656],
            [26.728803067609707, -0.302345003100002],
            [26.746031943580409, -0.291381880804096],
            [26.750129102997409, -0.287237994924091],
            [26.75534010150151, -0.273906972179917],
            [26.777203977114429, -0.25892699120021],
            [26.787258290083564, -0.254093931535331],
            [26.7906471548485, -0.252464972040264],
            [26.792726558898504, -0.252668568927303],
            [26.793409617179304, -0.252735449104026],
            [26.795211860421443, -0.252911982997376],
            [26.799787098741088, -0.256803861848707],
            [26.803667211710721, -0.257023920736008],
            [26.811902930302917, -0.265039921481101],
            [26.81407896163644, -0.265909310437572],
            [26.816170863048693, -0.266745087000842],
            [26.816473206328926, -0.266865820808219],
            [26.825366927392018, -0.265695966578223],
            [26.828952886123524, -0.264198959202335],
            [26.831166141845841, -0.26327506797673],
            [26.839856520261186, -0.259647391788906],
            [26.840866002960045, -0.259226041383204],
            [26.848369206523472, -0.25048175977976],
            [26.8472131627877, -0.245433007727366],
            [26.838803801647728, -0.240727732011985],
            [26.83373030916249, -0.237889026326822],
            [26.830982206401522, -0.234451990675778],
            [26.828448886333401, -0.226421913018405],
            [26.828424401852011, -0.225989503924861],
            [26.82796792743196, -0.217927911711949],
            [26.828447840694377, -0.215480607069891],
            [26.828869102053606, -0.213332928387825],
            [26.829592991459013, -0.212462625362623],
            [26.832506085991614, -0.20896097505902],
            [26.83469454641541, -0.208432401784125],
            [26.84595809146996, -0.20571214694177],
            [26.845754189171824, -0.214208990347196],
            [26.848471605482711, -0.214201478707507],
            [26.851229935563204, -0.21419385311811],
            [26.854190939046532, -0.212464774129539],
            [26.856131114108965, -0.211331864771618],
            [26.857153111238024, -0.210735105300028],
            [26.861083060044663, -0.213334199018008],
            [26.870640157300688, -0.219654900992573],
            [26.873192698620937, -0.223015082985468],
            [26.874992196611576, -0.225383953736125],
            [26.885729914611197, -0.230407935511425],
            [26.886928162995634, -0.231755907907314],
            [26.887561954072993, -0.2324688933085],
            [26.88895403284458, -0.240501863231605],
            [26.893113785073968, -0.241212603552673],
            [26.894051898420127, -0.241372895271428],
            [26.895573998447638, -0.241632900964185],
            [26.896325719457181, -0.240827328426886],
            [26.899440151597773, -0.237488906915093],
            [26.903523989897412, -0.229441889588131],
            [26.905804800725683, -0.228976939827276],
            [26.920222946987067, -0.243863905005721],
            [26.923143153481753, -0.244865111468987],
            [26.924995585598825, -0.245500226172325],
            [26.927532071330017, -0.246370013484211],
            [26.928761119352274, -0.247599630579272],
            [26.930958145212326, -0.249797872237894],
            [26.934598460103402, -0.253440134972918],
            [26.936687162614895, -0.255530023315367],
            [26.939469138150287, -0.256980989850258],
            [26.941943999452992, -0.258271829303812],
            [26.949927848405842, -0.257791081378336],
            [26.951884749200531, -0.260307815179742],
            [26.956342098910483, -0.266040930029708],
            [26.962052253488732, -0.267861965561313],
            [26.964662962520269, -0.268694532418426],
            [26.967762023588026, -0.269682825373021],
            [26.972548882530734, -0.268293041152079],
            [26.975065043878597, -0.270122940874034],
            [26.976392468204253, -0.269822171770046],
            [26.977117113092824, -0.269657967248205],
            [26.977980798322733, -0.26831241162665],
            [26.980070064077939, -0.265058136189223],
            [26.985340197778875, -0.272161953473302],
            [26.994021834688198, -0.275811943677059],
            [27.002450979425682, -0.27165503484388],
            [27.00678816688999, -0.272101950148723],
            [27.009533165971654, -0.273931844765608],
            [27.009627454940535, -0.27424557775174],
            [27.010180556644105, -0.276085939990238],
            [27.010223035278951, -0.27622689064468],
            [27.008646127239299, -0.282659929619889],
            [27.010711086379544, -0.286787956550256],
            [27.022613215023501, -0.298465930664745],
            [27.028792801321437, -0.304189850851867],
            [27.030573011584597, -0.304525875379025],
            [27.033587993036686, -0.305095069225994],
            [27.038020772925329, -0.308924633890058],
            [27.038622021633202, -0.309443922416598],
            [27.048201690857326, -0.308499034831017],
            [27.056887609137316, -0.316734204869748],
            [27.061355154725756, -0.320969920154972],
            [27.070174791727357, -0.329333000102517],
            [27.071782911731525, -0.332544894493194],
            [27.071334957831979, -0.335300925702063],
            [27.070102718095466, -0.336791574641641],
            [27.063151913753085, -0.345198896395698],
            [27.067948912878695, -0.347023010268854],
            [27.068947247484878, -0.34797396508496],
            [27.072755992000136, -0.351601948365923],
            [27.073679030717507, -0.355043990047229],
            [27.06982379209807, -0.362862924410913],
            [27.070543071349441, -0.373425854679006],
            [27.072844911738532, -0.38007886485506],
            [27.074278040823678, -0.381622214590654],
            [27.078800033301466, -0.386492043820382],
            [27.081109968409599, -0.387569095834305],
            [27.082227031550222, -0.3880898070291],
            [27.08861103847422, -0.386004090748428],
            [27.091131178460493, -0.388752915984383],
            [27.093838394401306, -0.388291260592462],
            [27.095235695977983, -0.388053009090432],
            [27.096265970184096, -0.389084038615946],
            [27.097295334396819, -0.390113820917514],
            [27.098229044201442, -0.389985872824131],
            [27.10022919977537, -0.389711752204939],
            [27.100716861905486, -0.389644879266968],
            [27.101413337423338, -0.388831371823505],
            [27.103673887648704, -0.386191080209598],
            [27.112812130132124, -0.389150862723624],
            [27.117827813333879, -0.387987974679589],
            [27.118544245824111, -0.390612595179428],
            [27.121523018882062, -0.401526019391884],
            [27.120624236473986, -0.405662959883219],
            [27.130480897622753, -0.419184882869098],
            [27.133517382946135, -0.421824634576864],
            [27.135745840857957, -0.423761985627343],
            [27.137897972513372, -0.423944416310114],
            [27.138805857550203, -0.424021380539013],
            [27.140995054592555, -0.424206964664349],
            [27.176655832159092, -0.441784865408005],
            [27.193103960756833, -0.446558925384802],
            [27.21244680615305, -0.44718181327209],
            [27.213294238164515, -0.447209102683068],
            [27.225744072332144, -0.447610017181115],
            [27.231458121107146, -0.449888977322802],
            [27.234594264629816, -0.449628270212486],
            [27.237390977925752, -0.44939576407148],
            [27.251534696952675, -0.448220015399503],
            [27.25489794446068, -0.451141951928241],
            [27.256798926925583, -0.452796941107082],
            [27.262875404595206, -0.452141709047317],
            [27.264280809874066, -0.451990167729875],
            [27.267750994630081, -0.451615978561026],
            [27.273471944263086, -0.452454585684508],
            [27.275151460569433, -0.452700769882203],
            [27.278481779432333, -0.45318893758912],
            [27.283035049451694, -0.450881040482222],
            [27.285318000066983, -0.44972397755148],
            [27.300391851807085, -0.452661997171611],
            [27.30887380939846, -0.463889848706367],
            [27.313602850972817, -0.464061304227127],
            [27.313974545989634, -0.464074780693086],
            [27.320515821868714, -0.464312111907764],
            [27.32602103120476, -0.47210380251924],
            [27.327935514450072, -0.472503275893878],
            [27.329137017430792, -0.472753884313909],
            [27.330359969485546, -0.473008956538368],
            [27.334918772228761, -0.471157065992697],
            [27.33925984760161, -0.472291915748748],
            [27.344522078822976, -0.476179942803085],
            [27.345673017432979, -0.477866454866448],
            [27.347962957839485, -0.481221989661167],
            [27.349541917631242, -0.497753878978451],
            [27.35026833938743, -0.505356284263082],
            [27.350331757751519, -0.506019987486254],
            [27.358583102538095, -0.51564079343288],
            [27.369134192842491, -0.514151843481201],
            [27.375235380470642, -0.5132908726881],
            [27.384152619427876, -0.517395887072958],
            [27.39327748958997, -0.516217932894469],
            [27.398974898870964, -0.513213941104809],
            [27.40605028157696, -0.51365096529851],
            [27.415192872804695, -0.516835908327497],
            [27.419755473624903, -0.516591001600455],
            [27.426362674167773, -0.513124880610078],
            [27.430083441277365, -0.513016216893307],
            [27.435261384473947, -0.512864997083749],
            [27.446633417268728, -0.501113849397374],
            [27.449661854585475, -0.500596041954389],
            [27.452107324808711, -0.500177844209026],
            [27.454346413383593, -0.498441983744965],
            [27.459845409971148, -0.494179973631506],
            [27.471221194130578, -0.49133150193017],
            [27.47193024246917, -0.491153958205797],
            [27.488135272577953, -0.490869920792942],
            [27.495217548057141, -0.492683006293179],
            [27.496823506714726, -0.494974954927543],
            [27.49457854764945, -0.505318903624138],
            [27.4982865461056, -0.520005932786093],
            [27.498545385773227, -0.528502882316006],
            [27.519135632671301, -0.541526664379778],
            [27.52733528749809, -0.536674871959316],
            [27.535777281737424, -0.53595685165581],
            [27.538737200055863, -0.534134947811672],
            [27.542153657473079, -0.532030140074762],
            [27.548329393591722, -0.535454922603044],
            [27.552897431016032, -0.536128968142766],
            [27.553035250546923, -0.536058996562845],
            [27.556998694835571, -0.534047087663596],
            [27.559510320589588, -0.534497122783571],
            [27.562039264963943, -0.539311938046924],
            [27.566842382514992, -0.542052992612035],
            [27.567776221676993, -0.548020985945043],
            [27.571673218482406, -0.551911874768402],
            [27.578082294691036, -0.556484914238376],
            [27.595687363543185, -0.564003010272204],
            [27.601426479806154, -0.572941988058309],
            [27.605861777672526, -0.57214268345194],
            [27.614428230799518, -0.570598884076178],
            [27.616998575830376, -0.571328155343951],
            [27.620825425890207, -0.572413929034134],
            [27.629986340054771, -0.579961920859649],
            [27.635262136735239, -0.586834961339804],
            [27.637536255114632, -0.587529906976338],
            [27.640195841480807, -0.588342708181629],
            [27.641204292913702, -0.588650902632889],
            [27.650115742228909, -0.59068706714326],
            [27.660464639729149, -0.59542138420028],
            [27.841009074102498, -0.596021892430571],
            [27.834633704479959, -0.609764336865112],
            [27.832259006229748, -0.610759824934156],
            [27.830758958944156, -0.611388043348192],
            [27.828142314743527, -0.617090568404288],
            [27.824423880558729, -0.625194865044772],
            [27.822714602168716, -0.653686972310406],
            [27.827288759815083, -0.655966961138219],
            [27.829417147200882, -0.661913095794304],
            [27.830983798276609, -0.666289885515103],
            [27.826905719974555, -0.673886940715107],
            [27.817576683409648, -0.681502907387385],
            [27.81050903519823, -0.68528140358725],
            [27.80892183336374, -0.686129843157852],
            [27.805512727758835, -0.690277861897008],
            [27.804389889349242, -0.694876010532319],
            [27.805063327571627, -0.700395856286556],
            [27.805588688400931, -0.704701983730088],
            [27.806042648436506, -0.708424969693462],
            [27.805236945864912, -0.720454844492286],
            [27.805181012263741, -0.721292922480421],
            [27.806685945486183, -0.726342034905233],
            [27.80819094248902, -0.731390031139544],
            [27.806561739923438, -0.734610084518612],
            [27.804115080330774, -0.73944678321803],
            [27.804622107443418, -0.741056478090097],
            [27.806428927601935, -0.746789858103862],
            [27.805297643232027, -0.750009533001808],
            [27.801860711412868, -0.746576112494364],
            [27.800642915687856, -0.746887351592112],
            [27.800034916140628, -0.747042857191827],
            [27.799007825563898, -0.750186662798196],
            [27.797780651427317, -0.753943983608275],
            [27.793004376435277, -0.75811488869339],
            [27.78959075949102, -0.761096089679377],
            [27.787410515058774, -0.764830831688173],
            [27.782332697185449, -0.773529866317843],
            [27.782055432173021, -0.774378782759123],
            [27.780078737899352, -0.780430921604138],
            [27.783097878551203, -0.792825937319975],
            [27.782832535080889, -0.794223263967459],
            [27.781308856713412, -0.802252981226411],
            [27.778815857526844, -0.807086913649476],
            [27.779178365473211, -0.811259748264118],
            [27.779208618037032, -0.811607985556641],
            [27.779534967894925, -0.815355879579068],
            [27.776593938451956, -0.822258895672744],
            [27.769101621571451, -0.833085846105847],
            [27.767080069025727, -0.840905058982002],
            [27.768168670843213, -0.846032483352923],
            [27.772198700955677, -0.865010918277049],
            [27.772221740946101, -0.870755928451701],
            [27.76948204731449, -0.881361697800055],
            [27.769072822481739, -0.882945866962897],
            [27.766345934334524, -0.885712866456833],
            [27.759730825023908, -0.887344845558696],
            [27.752438753399993, -0.891508954886995],
            [27.751032362669282, -0.891654663487684],
            [27.740048666181909, -0.892792314546303],
            [27.721186719500029, -0.894745966611283],
            [27.720858120260665, -0.894780149361841],
            [27.720669049147872, -0.894799816967239],
            [27.720254619476371, -0.894842906655654],
            [27.717745570988924, -0.896909857424528],
            [27.716612887043805, -0.897842775828631],
            [27.714326454558467, -0.89727674438787],
            [27.712041642633924, -0.896710994082367],
            [27.70940035854338, -0.893918661119719],
            [27.708142616534303, -0.892589123197848],
            [27.706920889781593, -0.892900893350089],
            [27.70631781749368, -0.893054893942179],
            [27.697957727150406, -0.915373838343051],
            [27.692064462679603, -0.921519625924912],
            [27.689997770689196, -0.923674871214731],
            [27.679516681603282, -0.92991690878296],
            [27.669009777631082, -0.929494935642322],
            [27.665906445972457, -0.928785636417552],
            [27.663067993355149, -0.928136937119918],
            [27.655447806683842, -0.929948892061892],
            [27.653257055556043, -0.930469756491715],
            [27.650837732595786, -0.9293028098771],
            [27.646166105944484, -0.927049146824026],
            [27.642535579995076, -0.933265986008441],
            [27.642087603637634, -0.933392902624557],
            [27.639334719144383, -0.934172402177833],
            [27.638429101455326, -0.934428782604583],
            [27.636832985638272, -0.933632993084769],
            [27.635226669451203, -0.93283188097855],
            [27.62993955309981, -0.923888992274397],
            [27.628870736676465, -0.92373151436279],
            [27.626981956926368, -0.923453334384114],
            [27.625369952606881, -0.923215925230414],
            [27.624181088023924, -0.923519770567883],
            [27.620807073308939, -0.924380802240261],
            [27.616915995502936, -0.922325998844243],
            [27.613475883647684, -0.918202920522022],
            [27.610944538076549, -0.917303164553188],
            [27.607716021691513, -0.916155522962977],
            [27.607072879152067, -0.91592690536324],
            [27.589251782542092, -0.913690869379717],
            [27.5862765811857, -0.912092533211198],
            [27.583302806354002, -0.91049499297089],
            [27.580846900402115, -0.908382088589919],
            [27.575055789650477, -0.903400044518953],
            [27.559852425100914, -0.90469858510523],
            [27.557088040375419, -0.904934718691228],
            [27.555423320220129, -0.905076918239459],
            [27.54813458404087, -0.90992692805304],
            [27.543336627311152, -0.909484017228342],
            [27.536245891498634, -0.906291530710889],
            [27.529154863733659, -0.903098950011944],
            [27.527408680755116, -0.901179105373062],
            [27.52686252841859, -0.900578961389002],
            [27.525288063796509, -0.900728446702377],
            [27.524407831599063, -0.900812056945261],
            [27.521840900166278, -0.901055854357895],
            [27.52057494306391, -0.900487732781478],
            [27.517821278833011, -0.89925173900661],
            [27.517266849419428, -0.899002989762224],
            [27.511767592320449, -0.900006313029651],
            [27.509643056012273, -0.900393927945374],
            [27.508049843550236, -0.900401331996071],
            [27.499689755901887, -0.900439929272293],
            [27.485320523806056, -0.906459492424112],
            [27.482358886112138, -0.906240413185095],
            [27.471293177930921, -0.911311536736579],
            [27.468323759928346, -0.912672361212962],
            [27.463659364715078, -0.914809959991631],
            [27.457454046175819, -0.91571029260401],
            [27.457039824913476, -0.915749900668843],
            [27.449039294245797, -0.912560075569142],
            [27.446391016770779, -0.912900592906687],
            [27.44615274582819, -0.912931229907496],
            [27.441729611150755, -0.913500007800645],
            [27.423950635646147, -0.921369513935538],
            [27.409369645484993, -0.9299199425376],
            [27.408827255292877, -0.930344882466618],
            [27.393189386420175, -0.94259995753754],
            [27.385899388107958, -0.945160009301177],
            [27.372439650829925, -0.948190005633205],
            [27.368821215305953, -0.947686822755951],
            [27.368730546547681, -0.947674213975969],
            [27.366039633232624, -0.947299991622778],
            [27.356889515919477, -0.942960015400339],
            [27.354625534129728, -0.942863154444214],
            [27.354487490918327, -0.942857248817583],
            [27.346839576847444, -0.942530053033252],
            [27.345153543263752, -0.943077451552059],
            [27.344879949665863, -0.943166290037776],
            [27.341819561071084, -0.944160028360412],
            [27.337487326018937, -0.947724622872488],
            [27.335857769517133, -0.949065433055837],
            [27.334539642754667, -0.950149995496869],
            [27.32852982097744, -0.950345348248977],
            [27.328477804929211, -0.950347039184144],
            [27.32654058891735, -0.950410008886162],
            [27.321529606599473, -0.953409972468154],
            [27.310799449719589, -0.955050051123954],
            [27.310339729686426, -0.955549949609941],
            [27.298044105710357, -0.969091237041521],
            [27.297609109110443, -0.969570314260565],
            [27.285759656776445, -0.978800016004236],
            [27.282109875438923, -0.980189802548179],
            [27.276168915816399, -0.977912057283981],
            [27.276140228117821, -0.977948504323883],
            [27.274349459955108, -0.980220049221152],
            [27.274139715912678, -0.985275110739162],
            [27.274442348450446, -0.986532781501347],
            [27.276689459879165, -0.995830102976998],
            [27.269910711659751, -1.009387886262447],
            [27.268749515187526, -1.011710244846574],
            [27.268654109612761, -1.014636946527093],
            [27.268611819624134, -1.015932363622877],
            [27.268539421700428, -1.018150026306572],
            [27.277039739957878, -1.037280003787081],
            [27.277236310206671, -1.037714189064058],
            [27.277284081715184, -1.037819706013728],
            [27.277519619084341, -1.038339962917799],
            [27.278128357945075, -1.05022153862235],
            [27.278249698780378, -1.052589919588998],
            [27.277881879095705, -1.053413434940453],
            [27.277118717142727, -1.055120629578638],
            [27.269829661163232, -1.061120003664176],
            [27.269365943627051, -1.062059045183529],
            [27.268957326953768, -1.062886505777146],
            [27.266649422038206, -1.067560078137812],
            [27.268126961136062, -1.077289143921437],
            [27.268289581355319, -1.078359940592862],
            [27.275390606471095, -1.085230489349662],
            [27.280429498546525, -1.087739959414116],
            [27.284099697692145, -1.092330037009174],
            [27.285097601106983, -1.099789720756489],
            [27.285616209300276, -1.103666492036656],
            [27.288309536388496, -1.123799949691545],
            [27.290253125947331, -1.128948502513232],
            [27.290389615971616, -1.1293100642884],
            [27.294979588458521, -1.135500126121828],
            [27.297834746146886, -1.137265185770339],
            [27.299118843828069, -1.138059054511503],
            [27.306609411688726, -1.142689948973553],
            [27.308323275978257, -1.143745514115613],
            [27.308617555082176, -1.14392676017867],
            [27.312384898940945, -1.146247530122844],
            [27.321549407264957, -1.155640002378804],
            [27.323208759986425, -1.15966440889964],
            [27.323572569591654, -1.160546749109403],
            [27.324769606148774, -1.163449901625731],
            [27.328602397665868, -1.16697476312435],
            [27.329329609041178, -1.167643548371261],
            [27.333479443869845, -1.171459975717891],
            [27.338089602399492, -1.181790039978256],
            [27.336330844803648, -1.185239883184992],
            [27.335854718838458, -1.186173815477411],
            [27.334449848955501, -1.188929784279383],
            [27.334033567856213, -1.189127961632653],
            [27.327159500300318, -1.192400088890805],
            [27.326089881681398, -1.192402295972275],
            [27.322359551107304, -1.192409995892609],
            [27.302679652426605, -1.181439920972386],
            [27.297892080221569, -1.181313037236844],
            [27.297873233566897, -1.181312538132423],
            [27.295139647580921, -1.181240093846905],
            [27.287609696679883, -1.183790024489497],
            [27.277119622644534, -1.190259809462981],
            [27.275818884571017, -1.189679033678682],
            [27.275694050187536, -1.189623286958269],
            [27.275061496090348, -1.189340809162767],
            [27.274999709965119, -1.189208964601957],
            [27.274978145906694, -1.189161885265634],
            [27.274679580940557, -1.188510047633756],
            [27.268771719744716, -1.1761188317353],
            [27.268620153295043, -1.175801225289874],
            [27.267886836070733, -1.175167285370017],
            [27.267647011042698, -1.174960253308049],
            [27.265179373991515, -1.172830037309813],
            [27.254082832036492, -1.17373386020191],
            [27.253822266705171, -1.173755083952819],
            [27.250569666487351, -1.174020016894046],
            [27.248517886530657, -1.175586080099145],
            [27.247407169987493, -1.176433856720756],
            [27.232109591927578, -1.188110016457752],
            [27.228249673085529, -1.192710022422662],
            [27.227144235042978, -1.204889585911028],
            [27.232767341073558, -1.205030088008969],
            [27.235367593715178, -1.205095007183762],
            [27.239733618896746, -1.212205898686963],
            [27.253249451472662, -1.223427940055074],
            [27.260815568547041, -1.231677851544932],
            [27.264725525347043, -1.239251841509124],
            [27.282359396882129, -1.25206791127341],
            [27.286742393934325, -1.264466959659831],
            [27.296137668675048, -1.272941977262217],
            [27.309182621447025, -1.279106951357541],
            [27.313534659859616, -1.282999919573494],
            [27.315976537720029, -1.286459889908528],
            [27.320653669247378, -1.293091888756368],
            [27.320949183534811, -1.293328266083411],
            [27.326378372041656, -1.297670977609898],
            [27.333240027575254, -1.299487946293466],
            [27.341457264228804, -1.296934088049887],
            [27.345341361226726, -1.297380876115737],
            [27.355876657351789, -1.304472858437873],
            [27.362958310298492, -1.304680967002896],
            [27.364794309534027, -1.306742841619246],
            [27.356633475402234, -1.324928993482604],
            [27.348229639799577, -1.339205919385034],
            [27.345753561279668, -1.349558913944144],
            [27.346934360788019, -1.360818000222023],
            [27.352087037968932, -1.368764932745231],
            [27.35580871507192, -1.379349510783175],
            [27.368052308626702, -1.402252209383702],
            [27.378877502772077, -1.423434886295191],
            [27.391423495302647, -1.450051645008968],
            [27.403307306399622, -1.458670666639039],
            [27.411477120090996, -1.45813377137197],
            [27.421302599817917, -1.451319909571018],
            [27.430574094797318, -1.446217506072243],
            [27.444003345051225, -1.45556120115155],
            [27.449419699327603, -1.459329763413914],
            [27.452189299671645, -1.466448992557034],
            [27.454541537344795, -1.48483298354919],
            [27.458462295487763, -1.49470497999253],
            [27.472220407289086, -1.507532994540615],
            [27.481787401284564, -1.518197992996718],
            [27.494019473945837, -1.531829959809293],
            [27.498616310459862, -1.53871095093984],
            [27.50394754846473, -1.558923912666065],
            [27.507891345699825, -1.575233947576304],
            [27.506323546577143, -1.58374600292604],
            [27.508174305132854, -1.589716995202099],
            [27.515299421267919, -1.600958995321941],
            [27.51941745843046, -1.601864852841457],
            [27.525614494502779, -1.608970993120973],
            [27.526335214651862, -1.618854833333798],
            [27.528405212442522, -1.622065841008323],
            [27.540766525723743, -1.627081871003752],
            [27.543996532413832, -1.634887909802792],
            [27.545137589555694, -1.63575928892427],
            [27.547892698277593, -1.637863057376174],
            [27.550915852602145, -1.638423181668905],
            [27.551551452886489, -1.638540924275122],
            [27.553512721290101, -1.638188631166126],
            [27.560687472039589, -1.636899863073247],
            [27.567578228496796, -1.645842956291965],
            [27.570176346741317, -1.646756000041356],
            [27.571467423433983, -1.647208788275278],
            [27.573971463813709, -1.644440961871513],
            [27.578086346092977, -1.644196957230272],
            [27.587273455131204, -1.656350858118672],
            [27.590024213312191, -1.658180898478864],
            [27.595902632224597, -1.65871445246304],
            [27.597340534058855, -1.658845012365983],
            [27.606064363040453, -1.669390985010027],
            [27.615449196662642, -1.672806928130994],
            [27.617753195703358, -1.6771668812629],
            [27.617997626393844, -1.681305128328847],
            [27.623038651069752, -1.684966009953281],
            [27.645445545695519, -1.686725968138643],
            [27.653462290954074, -1.691065843307061],
            [27.656911448844266, -1.696111961751315],
            [27.658072448585422, -1.700706962684517],
            [27.65534725016925, -1.705314923503163],
            [27.6558123699756, -1.707382899058689],
            [27.659024652905124, -1.710589904317694],
            [27.668389419062187, -1.708717206131404],
            [27.670174199953514, -1.713757957951434],
            [27.672780238643874, -1.721117883700665],
            [27.677367354488208, -1.725239926764385],
            [27.67806323442305, -1.727766905972467],
            [27.673321318194024, -1.742958970886705],
            [27.673791117324658, -1.745945846540953],
            [27.680445352757484, -1.752360947058996],
            [27.680718233093049, -1.764085877132301],
            [27.684636110338893, -1.771659978140738],
            [27.687609501589964, -1.772338917259617],
            [27.694005337529642, -1.770937085993338],
            [27.697203310296704, -1.77391651398712],
            [27.697446342310307, -1.774142937657273],
            [27.709828011415858, -1.770069370073654],
            [27.712285171415857, -1.769260963470918],
            [27.716485540970808, -1.769363019262741],
            [27.720515481251734, -1.769461108593218],
            [27.727158200282602, -1.772885875006355],
            [27.73656715456849, -1.782049005483036],
            [27.737256193832437, -1.784220839713379],
            [27.739113879297268, -1.790087621709795],
            [27.743220761180588, -1.788233002861215],
            [27.746655067224197, -1.789369928113808],
            [27.747586386611847, -1.7939648780266],
            [27.744881348187263, -1.803402980557267],
            [27.744025268992871, -1.817891861933456],
            [27.741318071916666, -1.826870838698024],
            [27.742020071175201, -1.831006873724321],
            [27.749137265067798, -1.838798843063274],
            [27.755549221275221, -1.841534985827882],
            [27.756249060983837, -1.844750835669831],
            [27.751719184891122, -1.855575912260531],
            [27.751732144885715, -1.858794978548627],
            [27.754723382068228, -1.863841893387463],
            [27.754056303019727, -1.868214001245273],
            [27.748587186195159, -1.873063999277685],
            [27.749587266227898, -1.889057872989129],
            [27.750542345156511, -1.904329983890127],
            [27.74354431098973, -1.926890961660631],
            [27.742907111704216, -1.939081980837492],
            [27.745055229686933, -1.961839910184943],
            [27.74653266907178, -1.977680554124828],
            [27.742771031311708, -1.986675439493217],
            [27.739681874169953, -2.000571238662255],
            [27.548601517545794, -1.995591378620785],
            [27.380909705743793, -1.991221049628431],
            [27.374856669611496, -1.999864261375757],
            [27.37831410817196, -2.006156654571365],
            [27.384319264099595, -2.01133983726091],
            [27.39364181931975, -2.016894592345394],
            [27.420305922603447, -2.025046658871474],
            [27.435108754418941, -2.029123307408847],
            [27.45643334172242, -2.029131952206203],
            [27.472356492173148, -2.033949059195242],
            [27.473625851195489, -2.040980705085343],
            [27.467786295198916, -2.058370470061432],
            [27.452956463619227, -2.084267529411672],
            [27.446145268251755, -2.107206927195457],
            [27.453445704089244, -2.12053107949263],
            [27.452578824450185, -2.130521506564673],
            [27.443868630097967, -2.135328393677831],
            [27.423848322026867, -2.143830866968583],
            [27.408686211708435, -2.155665413605872],
            [27.384691145067649, -2.167126332229472],
            [27.368811914149475, -2.164159667573213],
            [27.353028444538918, -2.165263341827203],
            [27.345447568144429, -2.171180453702565],
            [27.328543057653139, -2.187084348986795],
            [27.319193862893226, -2.195960775842991],
            [27.309248869504305, -2.210757162792245],
            [27.294611996945946, -2.229251490683232],
            [27.288039121030103, -2.242130079093169],
            [27.278879286640514, -2.238939887684928],
            [27.270936452068614, -2.238394507468312],
            [27.270902712244865, -2.237749626591987],
            [27.270356048766889, -2.236817149395752],
            [27.268597218407514, -2.233804527074771],
            [27.268858665884416, -2.231246183036474],
            [27.268834898258646, -2.229261670592073],
            [27.267028532647664, -2.227731442886997],
            [27.264152607706599, -2.226631590051022],
            [27.261443058840992, -2.226655499550545],
            [27.26008828440817, -2.227253245946866],
            [27.255833817408515, -2.230552799642013],
            [27.254312666900237, -2.233302422745631],
            [27.25340948364558, -2.23583685290356],
            [27.252078477736898, -2.241073066555238],
            [27.250486023452943, -2.242818466890833],
            [27.248441977990826, -2.24399003598126],
            [27.246112716527705, -2.245185514217661],
            [27.242951575585604, -2.248676302825478],
            [27.241905784779625, -2.25111506781657],
            [27.241192746124522, -2.253792923714597],
            [27.241192746124522, -2.259141671406544],
            [27.241192746124522, -2.2663931213462],
            [27.240028115392963, -2.270075132191768],
            [27.237484942602812, -2.271342314957989],
            [27.233872210482545, -2.270816314973975],
            [27.231424109093844, -2.26931003932974],
            [27.229261223706175, -2.266034483277909],
            [27.228358040451518, -2.263500106295648],
            [27.228049056824709, -2.261802549808162],
            [27.227869848315414, -2.259927703820509],
            [27.227811376973573, -2.259315984151962],
            [27.227930216899157, -2.256685957464292],
            [27.229023543855043, -2.253147369269155],
            [27.229189919930498, -2.249632681480119],
            [27.228928471555264, -2.247409099113001],
            [27.228952240079366, -2.245209423410833],
            [27.228619487928455, -2.241670807005066],
            [27.227336018169641, -2.238538645566746],
            [27.225577187810234, -2.23734316273358],
            [27.222986478870173, -2.236123768666101],
            [27.220110553929111, -2.234808735211236],
            [27.218803315646198, -2.234497908914614],
            [27.217163325212372, -2.234330540603076],
            [27.214643920047987, -2.233398061205528],
            [27.212362194734737, -2.233278512451923],
            [27.211530316154089, -2.233876256121363],
            [27.209323361215219, -2.236007567337307],
            [27.209153518541061, -2.236171588255573],
            [27.208939607214031, -2.237295343182821],
            [27.208773231138576, -2.239423302172945],
            [27.208440479885994, -2.240762241604321],
            [27.207299616780205, -2.242364185074731],
            [27.20653904197523, -2.242675009680914],
            [27.205659626346378, -2.242029451156194],
            [27.204423691839143, -2.240403597138586],
            [27.203163989706098, -2.238490826055503],
            [27.203098560912373, -2.237954871856158],
            [27.202997613630647, -2.23712797519458],
            [27.202831237555188, -2.2353825679905],
            [27.202641093853963, -2.233087234606384],
            [27.20304514978055, -2.229787686671144],
            [27.203805724585521, -2.225794744669627],
            [27.203520509482814, -2.224407972347865],
            [27.202474718676804, -2.223714585691491],
            [27.200858495868751, -2.22378631523626],
            [27.19950372143596, -2.224455792323214],
            [27.198933290332217, -2.225723015223837],
            [27.198481699154051, -2.227372795196662],
            [27.197768659600655, -2.228711744857211],
            [27.196984316271578, -2.230791897588623],
            [27.195938525465568, -2.232704678839596],
            [27.194701216535972, -2.233574622692149],
            [27.193728103928031, -2.234258811578976],
            [27.19156521854033, -2.234713095940756],
            [27.190139140331866, -2.234593547295634],
            [27.188309006196778, -2.233493700562774],
            [27.188071327243975, -2.231987385827155],
            [27.187358287690582, -2.229596408365455],
            [27.187263215390804, -2.227707532501511],
            [27.189188421825634, -2.225579556321634],
            [27.19089971513684, -2.224790530299402],
            [27.192967529123056, -2.224336242833731],
            [27.1939971547455, -2.224030219157731],
            [27.195059110735045, -2.223714585691491],
            [27.197412139823975, -2.222160441674869],
            [27.197768659600655, -2.220391105982401],
            [27.196532725093416, -2.218597858511758],
            [27.195059110735045, -2.218215298934818],
            [27.193775640077902, -2.2184065787358],
            [27.192777385421795, -2.218860868049767],
            [27.190804643735358, -2.219076058293779],
            [27.186312496884572, -2.220582385498125],
            [27.183032516915215, -2.222710368982578],
            [27.182343244987621, -2.224025414295784],
            [27.181226150405934, -2.226416400923207],
            [27.180881992345842, -2.22732266280753],
            [27.180418039451055, -2.228544376781899],
            [27.180346735675379, -2.232848137038056],
            [27.180655719302187, -2.234234902204716],
            [27.180940935303227, -2.235621665140699],
            [27.180750791601966, -2.23748662047268],
            [27.180370503301184, -2.238921199792429],
            [27.179253408719493, -2.240523145303725],
            [27.177589650659897, -2.241479530268739],
            [27.176068500151619, -2.241599078344886],
            [27.175556755087086, -2.241477949752966],
            [27.174856334168485, -2.241312162764832],
            [27.174024454689505, -2.240833970306039],
            [27.172598376481041, -2.23944721236518],
            [27.171528818049225, -2.237414891604911],
            [27.171077225972763, -2.235286929661579],
            [27.171077225972763, -2.233589339010063],
            [27.17114853064674, -2.231748288077524],
            [27.171861569301836, -2.228831293987012],
            [27.173406487435884, -2.225460006924425],
            [27.175379229122324, -2.222375630528227],
            [27.175688212749133, -2.219578167534713],
            [27.175284157720842, -2.218573948880012],
            [27.174143294615085, -2.217378448719998],
            [27.173240111360428, -2.217282809207083],
            [27.172669680256718, -2.21701979938477],
            [27.171409978123677, -2.216469869028143],
            [27.170340418793561, -2.216469869028143],
            [27.169056949034747, -2.217163259129426],
            [27.168129997256024, -2.218215298934818],
            [27.168225069555803, -2.219339067745582],
            [27.168320141855581, -2.221514873116821],
            [27.168011158228772, -2.222232171296187],
            [27.167607102302185, -2.223116837841454],
            [27.166965367422758, -2.223953684762796],
            [27.166894902673572, -2.224018315896163],
            [27.166157255569583, -2.224694891272768],
            [27.164564802183961, -2.224623160869109],
            [27.164344253205275, -2.224529603003814],
            [27.162592059599223, -2.22378631523626],
            [27.160880766288017, -2.222519089746132],
            [27.159003096003058, -2.221825702190501],
            [27.157363105569203, -2.221825702190501],
            [27.156055867286284, -2.222160441674869],
            [27.15484370130315, -2.222638639384821],
            [27.153395243365996, -2.224211390545932],
            [27.153346318420677, -2.224264513316035],
            [27.152799654942736, -2.225842564599381],
            [27.152585743615706, -2.229022572393499],
            [27.152775887316967, -2.233039414915108],
            [27.152324296138801, -2.234378360251744],
            [27.151516184285594, -2.235071741817016],
            [27.150042570825551, -2.234928283838637],
            [27.148830403944089, -2.234163173175896],
            [27.147974756839336, -2.233015505520747],
            [27.147570700912748, -2.231915656687144],
            [27.147404325735621, -2.230672348620255],
            [27.14793646435373, -2.228309584483658],
            [27.14809359676492, -2.227611893666728],
            [27.149638514898964, -2.225388277462134],
            [27.150921985556074, -2.22335593701091],
            [27.151920240212181, -2.221658332419469],
            [27.153037334793872, -2.21902823814187],
            [27.153322550794908, -2.216206858155763],
            [27.153013567168095, -2.213839764500048],
            [27.151777632660828, -2.213098552476216],
            [27.150589233405164, -2.212979002056357],
            [27.149353298897928, -2.212572531278576],
            [27.146572446256641, -2.21216605948424],
            [27.144837384421333, -2.211855228354866],
            [27.143149857837635, -2.212142149747294],
            [27.142151603181496, -2.21228560997056],
            [27.140677988823128, -2.212572531278576],
            [27.140131325345184, -2.212715991459667],
            [27.139180606838988, -2.213552844344219],
            [27.137968439957518, -2.21496353667701],
            [27.13706525760119, -2.215465647332006],
            [27.136162074346533, -2.215943848139678],
            [27.136125467100417, -2.215966932750921],
            [27.134569620062617, -2.216948068603453],
            [27.133214845629794, -2.217593639182488],
            [27.130719208091218, -2.218789138262615],
            [27.12741546049606, -2.220630205599056],
            [27.125014895257259, -2.221634422837926],
            [27.12311345734653, -2.223236387431112],
            [27.122305346391652, -2.224981809237449],
            [27.122400417793099, -2.227229335553517],
            [27.123351137197663, -2.229405130034538],
            [27.124872286807609, -2.232513400918346],
            [27.125276342734196, -2.234832644576057],
            [27.124800983031932, -2.235884671598813],
            [27.123588817048795, -2.236578053346649],
            [27.121734914389609, -2.23645850485544],
            [27.119857245002947, -2.235430387604425],
            [27.119604680067578, -2.235272113956992],
            [27.118407398270381, -2.234521818284574],
            [27.116767408734852, -2.233182873984138],
            [27.1151749544509, -2.231413551704018],
            [27.113416124091525, -2.227301065828707],
            [27.11246540558529, -2.225723015223837],
            [27.11160975848054, -2.225101358673944],
            [27.110849183675569, -2.223977594306275],
            [27.110849183675569, -2.223284207444934],
            [27.111134398778276, -2.221514873116821],
            [27.112227725734158, -2.219793356769216],
            [27.114509451047407, -2.217856648901483],
            [27.115483938077709, -2.215991668392614],
            [27.116767408734852, -2.213218102886368],
            [27.116933783911975, -2.212118239106257],
            [27.116696104959175, -2.211233565898161],
            [27.115959297779973, -2.210444532121889],
            [27.115198722076705, -2.210253251279364],
            [27.114200467420599, -2.210277161950858],
            [27.112655549286519, -2.210396712591359],
            [27.112394101809617, -2.210157611300561],
            [27.111799902181765, -2.209464217878728],
            [27.111158167302378, -2.209344667162136],
            [27.109660784419905, -2.209177295961763],
            [27.108781369689346, -2.208842553503653],
            [27.10557269349567, -2.208459991375386],
            [27.103908935436074, -2.207790506958882],
            [27.100343739465682, -2.204921285603361],
            [27.098679981406086, -2.203725775200841],
            [27.097919405702783, -2.203917056894508],
            [27.096873614896769, -2.20377359585253],
            [27.09404522700391, -2.203271480287915],
            [27.092238860494628, -2.203199749737174],
            [27.091693031551589, -2.203699785028003],
            [27.090956224372388, -2.2044888224325],
            [27.090913401682787, -2.204523285599956],
            [27.090243184818991, -2.205062667140574],
            [27.088698266684943, -2.205206128960326],
            [27.087890155730065, -2.205182218206149],
            [27.086725524998503, -2.204584463684593],
            [27.083588152580504, -2.203197670341896],
            [27.0809261398648, -2.201380491905988],
            [27.079523736755608, -2.200819571287998],
            [27.078953398178363, -2.200591452833164],
            [27.078438064344258, -2.20071893326944],
            [27.077503551445766, -2.200950107091814],
            [27.076410225388209, -2.200830555681963],
            [27.075174289982641, -2.201523953181509],
            [27.074936611029838, -2.201978248634481],
            [27.074271107626313, -2.202265171054902],
            [27.07348676429724, -2.20298247866834],
            [27.072702420968167, -2.203986708016027],
            [27.072678653342361, -2.206449458722109],
            [27.072345902089779, -2.207166763388127],
            [27.071514022610803, -2.207884068607154],
            [27.071276342759667, -2.20843400219006],
            [27.069588817074266, -2.209653419438147],
            [27.068210274117344, -2.210251171894047],
            [27.066213764805134, -2.210538093600765],
            [27.064431166819954, -2.20946213849233],
            [27.063809172418914, -2.208721349889865],
            [27.062363352833735, -2.206999392842859],
            [27.062220745282382, -2.206066895969677],
            [27.061745385580117, -2.204632283404621],
            [27.061600759514317, -2.204424438047341],
            [27.06074713092401, -2.203197670341896],
            [27.060366843521525, -2.202121709851695],
            [27.060390611147294, -2.199372028965159],
            [27.060248003595941, -2.196933176392151],
            [27.060224235970171, -2.195498555824462],
            [27.060496432687774, -2.194327181854093],
            [27.060652058624232, -2.193657456947987],
            [27.060865970849594, -2.191314237039294],
            [27.060604523372657, -2.189186208036994],
            [27.060295539745848, -2.187990684873554],
            [27.059915252343362, -2.185145335155916],
            [27.059368588865418, -2.183304223390599],
            [27.058869461537348, -2.182323890195798],
            [27.057752366057365, -2.180411043271257],
            [27.056540200074227, -2.178354730373109],
            [27.055565713043926, -2.178354730373109],
            [27.05506658571586, -2.178282998613084],
            [27.052879931804089, -2.178067802408459],
            [27.051413599189392, -2.17827459684686],
            [27.050336759013902, -2.178426462129674],
            [27.048910680805438, -2.178067802408459],
            [27.047698513923976, -2.177756964094136],
            [27.046272435715508, -2.177350483610129],
            [27.043277670848862, -2.176083218138444],
            [27.040805801834388, -2.174289916746446],
            [27.038001180668967, -2.171468452085056],
            [27.037597125640708, -2.170009895559483],
            [27.037874150802949, -2.167895129665199],
            [27.038001180668967, -2.166925403156281],
            [27.037240605863996, -2.16501253645818],
            [27.036361191133473, -2.164701695422486],
            [27.0351014881021, -2.164510408668722],
            [27.034697433073841, -2.164845161149574],
            [27.03331889011692, -2.165610307846664],
            [27.031488756880165, -2.166877582219042],
            [27.030901754554392, -2.167178417784996],
            [27.030229053848828, -2.167523173779739],
            [27.029135726892942, -2.167642727875747],
            [27.027852256235796, -2.167236243729586],
            [27.026393828795623, -2.16633962639225],
            [27.024857492267483, -2.165395110716574],
            [27.024737679466476, -2.165299689249129],
            [27.023716629161694, -2.16448649816165],
            [27.02243315850458, -2.163243133194179],
            [27.020793168969053, -2.161378083806607],
            [27.020507952968014, -2.160134716258167],
            [27.020436649192337, -2.158795703481661],
            [27.020793168969053, -2.157695799299753],
            [27.021197223997344, -2.155711187973192],
            [27.02094752648431, -2.153986273904933],
            [27.02084070511896, -2.153248353142609],
            [27.020246505491109, -2.151478936004048],
            [27.019842449564521, -2.14990080452149],
            [27.018891731058289, -2.148968271833074],
            [27.018392603730256, -2.148776983074632],
            [27.016895220847783, -2.148179205886955],
            [27.015873198565874, -2.147174937978961],
            [27.015017551461121, -2.14540551370704],
            [27.014377982419866, -2.145101675212407],
            [27.014161904356371, -2.144999023541285],
            [27.013211185850135, -2.145118579430604],
            [27.012997273624809, -2.145644625411813],
            [27.012593217698221, -2.145525069564185],
            [27.011452355490761, -2.144449066509231],
            [27.011190908013823, -2.143062218080815],
            [27.010858155862916, -2.140838475048296],
            [27.010715015610582, -2.139727594601806],
            [27.010525404610298, -2.138256059507014],
            [27.010002508758163, -2.137419165188791],
            [27.008956717952152, -2.136940939140071],
            [27.008267446922854, -2.137801745557577],
            [27.007673248193338, -2.138279971334513],
            [27.00684136871439, -2.138734285140507],
            [27.006294705236449, -2.13921251062291],
            [27.005652970357026, -2.140455895447042],
            [27.00584239450771, -2.140846556200193],
            [27.006128329160962, -2.141436256046392],
            [27.006128329160962, -2.142416615106355],
            [27.005748041758476, -2.14322959671861],
            [27.005272682954541, -2.144090399557572],
            [27.005320218206116, -2.144712090091285],
            [27.004963699327728, -2.146792359982716],
            [27.003965443773296, -2.149924716164605],
            [27.002681973116182, -2.151024626033486],
            [27.000970679804979, -2.151478936004048],
            [27.000171021996952, -2.151174541136232],
            [26.998332434715046, -2.150474671199475],
            [26.995694189625084, -2.14822702742],
            [26.994719702594782, -2.146314136899087],
            [26.994030431565488, -2.143683909037746],
            [26.992937104609602, -2.140862385931271],
            [26.991748706252238, -2.13751480983815],
            [26.990156251968283, -2.134262872105679],
            [26.988563797684364, -2.1318717362814],
            [26.986495983698148, -2.130030559158381],
            [26.983334843654376, -2.128667608610796],
            [26.980981814565446, -2.126515579610233],
            [26.978105889624384, -2.124459192135622],
            [26.976869955117145, -2.123885316507353],
            [26.975634020609874, -2.124172254800358],
            [26.974825909655031, -2.124985245282799],
            [26.974445622252542, -2.125678677918861],
            [26.974374317578537, -2.127065542243892],
            [26.974374317578537, -2.12775897483642],
            [26.974920981056478, -2.128882811885704],
            [26.975443876908649, -2.129887091022608],
            [26.975729092011356, -2.131297863448622],
            [26.975943004236687, -2.132373874945188],
            [26.976133147937944, -2.13366508827685],
            [26.976418363938951, -2.135099768166642],
            [26.977107634968281, -2.137706100022561],
            [26.977701833697797, -2.139619001441213],
            [26.978557480802547, -2.140862385931271],
            [26.979840951459657, -2.142225325517457],
            [26.980934278415543, -2.143612175617891],
            [26.982693108774953, -2.145644625411813],
            [26.984261794534802, -2.147916182909397],
            [26.98466449220868, -2.149226872701635],
            [26.984523242011704, -2.150928981336024],
            [26.98416672313332, -2.152459289439722],
            [26.982574268849401, -2.154563460201348],
            [26.981171958266675, -2.154922124659401],
            [26.97955573635695, -2.154730836657854],
            [26.978391105625388, -2.153702663345378],
            [26.977202706369727, -2.153104887209929],
            [26.975681556759781, -2.152459289439722],
            [26.975016053356256, -2.151598491379352],
            [26.973970262550278, -2.150665959742263],
            [26.973304759146753, -2.150355115734886],
            [26.972710559518937, -2.149972538545968],
            [26.971545928787343, -2.148776983074632],
            [26.97088042628215, -2.147772716468618],
            [26.970167386728754, -2.145907647881805],
            [26.969335508148102, -2.144305599738794],
            [26.968788844670161, -2.142368793389194],
            [26.96876507614606, -2.141436256046392],
            [26.969040699936492, -2.140391103424693],
            [26.969074059772868, -2.140264605610124],
            [26.968978988371422, -2.138782107876298],
            [26.96895521984732, -2.134717187115856],
            [26.967980733715315, -2.132397786865444],
            [26.966198135730103, -2.129934914037271],
            [26.964724521371732, -2.128978457072971],
            [26.963345978414843, -2.129050192089159],
            [26.962300187608832, -2.129791445892477],
            [26.962205116207386, -2.130580521425043],
            [26.961896132580577, -2.131106572456171],
            [26.961777292654993, -2.13203911615568],
            [26.961040485475792, -2.133186861044175],
            [26.959757014818681, -2.135051946218369],
            [26.959733246294579, -2.135721462394239],
            [26.95913904756506, -2.136462712940427],
            [26.958616151712892, -2.137108318455031],
            [26.958426008011664, -2.138064769392078],
            [26.957760504608139, -2.138566906005222],
            [26.956286890249771, -2.139284244251499],
            [26.953696181309709, -2.139953759460581],
            [26.95295937413054, -2.140288516502145],
            [26.951770975773176, -2.140790652377515],
            [26.949703161786957, -2.142034035904387],
            [26.948609835729403, -2.143277418408533],
            [26.9478492600261, -2.144042576989689],
            [26.947445204997845, -2.144592534169804],
            [26.946256805742149, -2.146170670305921],
            [26.94556753471285, -2.14734231616069],
            [26.945258551086042, -2.148203116653687],
            [26.944902031309361, -2.149303027779663],
            [26.945163479684595, -2.150020360022107],
            [26.944830727533684, -2.150905070612547],
            [26.944188992654261, -2.151311558281897],
            [26.943618561550547, -2.151192002883783],
            [26.942691610670121, -2.15116809216453],
            [26.941907267341012, -2.150355115734886],
            [26.940433652982641, -2.150139915513272],
            [26.938864966324491, -2.150163827152596],
            [26.937581495667384, -2.150426848834015],
            [26.936868457012281, -2.151383291335467],
            [26.936511937235565, -2.152124534194916],
            [26.936607009535344, -2.15329617541839],
            [26.936583241011242, -2.154037417335162],
            [26.935965273757624, -2.15461128153155],
            [26.93570037136012, -2.154722838722779],
            [26.934943251475747, -2.155041679760961],
            [26.93456296317493, -2.155400345008593],
            [26.93453919554916, -2.155854654560773],
            [26.93475310777449, -2.156356785250223],
            [26.935513682579462, -2.157217580585353],
            [26.936250489758663, -2.157743621433948],
            [26.936868457012281, -2.15860441597366],
            [26.937462656640129, -2.159034813058274],
            [26.938888734848593, -2.159895606856955],
            [26.939649309653568, -2.161258529209954],
            [26.939411629802432, -2.162932291790914],
            [26.939340326026759, -2.163577885054874],
            [26.93915018232553, -2.164390854322201],
            [26.93803308774384, -2.164940804056243],
            [26.936868457012281, -2.165347288826657],
            [26.936036577533301, -2.166136346651574],
            [26.935727593906492, -2.166662384367666],
            [26.934349051847899, -2.167810103774817],
            [26.933754852220087, -2.168551338511842],
            [26.932922973639435, -2.1699381633975],
            [26.932019790384778, -2.172257506674852],
            [26.932209934086007, -2.173620417753459],
            [26.932804133713852, -2.174648577378406],
            [26.93382615599576, -2.17574846908282],
            [26.93453919554916, -2.175724558755856],
            [26.936535704861374, -2.175868022519245],
            [26.936939760787961, -2.176107129363342],
            [26.936844689386476, -2.177446125714841],
            [26.937486424265899, -2.178402551845762],
            [26.937914247818291, -2.179526351040225],
            [26.937819175518516, -2.181630483685104],
            [26.93739135196612, -2.182252158627458],
            [26.936702080936826, -2.182323890195798],
            [26.934063835846896, -2.181750036648377],
            [26.932043558010548, -2.181008808482377],
            [26.929048794042235, -2.178785121764365],
            [26.928620970489874, -2.178019981828715],
            [26.927717787235217, -2.176178861228338],
            [26.9256737417731, -2.173572596127122],
            [26.924247663564636, -2.17311829195569],
            [26.921728258400254, -2.172305327439704],
            [26.920112036490533, -2.171229344496403],
            [26.919042477160417, -2.170201181609098],
            [26.918638422132158, -2.169483859022474],
            [26.91861465360806, -2.168814356967809],
            [26.918163062429894, -2.166686295743615],
            [26.917354951475016, -2.164606052500512],
            [26.9169984316983, -2.163482242061033],
            [26.915810033340968, -2.160660756083629],
            [26.915263369863027, -2.160230359465729],
            [26.914455258908148, -2.159680408001745],
            [26.914288882832693, -2.159010902463813],
            [26.913314395802391, -2.159082635149761],
            [26.913100484475361, -2.158365306328411],
            [26.911983388995342, -2.158078374523075],
            [26.910723686862333, -2.15860441597366],
            [26.910533543161076, -2.159608675344383],
            [26.909772968356101, -2.160015161562307],
            [26.909131232578382, -2.16068466755549],
            [26.907610082070104, -2.161306351230515],
            [26.906088932460158, -2.161354172345814],
            [26.904781693278945, -2.161067242016231],
            [26.903141703743419, -2.160517290859297],
            [26.902547504115571, -2.160015161562307],
            [26.901834465460503, -2.158915258274707],
            [26.900598530054936, -2.158150108157363],
            [26.89926752414625, -2.157504511651553],
            [26.897698837488068, -2.156332873709369],
            [26.896534206756506, -2.156332873709369],
            [26.896486671504928, -2.155759010170553],
            [26.895940008026987, -2.155735099523931],
            [26.89437132136884, -2.155806832366452],
            [26.892826403234793, -2.155519900072087],
            [26.890877430072454, -2.15614158588746],
            [26.887526145429124, -2.156452428698642],
            [26.88598122729508, -2.156332873709369],
            [26.884864132713389, -2.15638069588696],
            [26.882511103624466, -2.156404606523341],
            [26.880419522012474, -2.156356785250223],
            [26.878423011801967, -2.156930648560547],
            [26.877424757145828, -2.157456689509724],
            [26.876236358788496, -2.158030553303327],
            [26.873574345174465, -2.161210707187892],
            [26.872980146444913, -2.161306351230515],
            [26.872599858144131, -2.160349914144428],
            [26.871720443413572, -2.15877179288337],
            [26.87034190135498, -2.158269663001896],
            [26.869177270623421, -2.158508771758626],
            [26.868042001326927, -2.158908994598647],
            [26.867779599839171, -2.159551407603157],
            [26.865571765449637, -2.164956629918876],
            [26.864332646414692, -2.179236254906266],
            [26.864482766576771, -2.185582851177909],
            [26.861629407315629, -2.198275060190218],
            [26.858062889025177, -2.214139943469736],
            [26.855528490080374, -2.240318154335079],
            [26.851154133024597, -2.288707069314769],
            [26.852111012177023, -2.29584683021689],
            [26.857778850715498, -2.302195435473277],
            [26.861982928515932, -2.31330276878883],
            [26.861419528525936, -2.322821674919383],
            [26.856698851165152, -2.330984853301212],
            [26.853955652307302, -2.331221842472755],
            [26.851216772549332, -2.333758846388444],
            [26.848014575005489, -2.333536984976508],
            [26.844597823839187, -2.338835889063471],
            [26.842744539220941, -2.338077132679115],
            [26.835665860596162, -2.335178976173488],
            [26.834115828353205, -2.337307731388263],
            [26.832476621250283, -2.339556949319336],
            [26.82904385851235, -2.339336001477485],
            [26.82605890414694, -2.334743896785683],
            [26.823543156024076, -2.335209895845929],
            [26.82058490048723, -2.340507685714653],
            [26.820222726714118, -2.340483029950045],
            [26.810649209153048, -2.339823748774727],
            [26.810653685458117, -2.339839120909454],
            [26.81400862893959, -2.351359274249585],
            [26.821440825171415, -2.365640458083158],
            [26.824105544511074, -2.378333218796339],
            [26.818211626965081, -2.395781631063663],
            [26.820199907709281, -2.44654721990173],
            [26.826899864695111, -2.463206776592657],
            [26.845480536285155, -2.482250333310734],
            [26.856009451676769, -2.494152054811787],
            [26.862822089738582, -2.51556976497375],
            [26.870553806743995, -2.542539461236772],
            [26.871041246990192, -2.563160716684266],
            [26.865729449426379, -2.571882907814455],
            [26.854880854167885, -2.579809402980706],
            [26.854373973480598, -2.591705713712657],
            [26.85955371240944, -2.601657272622749],
            [26.859776461362248, -2.602085227607748],
            [26.858830561419214, -2.602324467048954],
            [26.857592730568406, -2.6031714036081],
            [26.856941239985002, -2.604083489947633],
            [26.856550346173954, -2.604995576521434],
            [26.856289750299929, -2.606168258017375],
            [26.856550346173954, -2.606950046270866],
            [26.857788177024762, -2.60701519557094],
            [26.860915330208083, -2.606884897870826],
            [26.862455729816261, -2.607232729378844],
            [26.862934948680991, -2.607340940213051],
            [26.864237928949464, -2.608774219056037],
            [26.86451778380486, -2.610502717153712],
            [26.864577167835051, -2.611308496550726],
            [26.865292011205518, -2.61268187156481],
            [26.873366846920245, -2.628195330136756],
            [26.881643603249547, -2.644853048526555],
            [26.889751519424586, -2.654372954773074],
            [26.904972673311704, -2.664688907363092],
            [26.910020950086913, -2.678172663901182],
            [26.900749155070219, -2.686099194875173],
            [26.905703832782724, -2.695617696824514],
            [26.942944737052542, -2.712378004695374],
            [26.945773616323883, -2.739745929896894],
            [26.938250699231517, -2.749657894341875],
            [26.937144779691987, -2.762773985958635],
            [26.93327082197867, -2.768305858686237],
            [26.933512741877969, -2.772446870215812],
            [26.931693662410765, -2.776361942475047],
            [26.927006824586744, -2.78238592153167],
            [26.919825547576739, -2.787665856387027],
            [26.918692628273014, -2.79134991545363],
            [26.915496550052897, -2.794118937884194],
            [26.918253128418584, -2.79779634277314],
            [26.915068869332643, -2.80424285882603],
            [26.915121337233451, -2.804389201532481],
            [26.916222669975131, -2.807460986786642],
            [26.944908536908638, -2.820132334109639],
            [26.957126571596977, -2.836788973394993],
            [26.961686689473741, -2.862957286535765],
            [26.975827843810549, -2.902607947591092],
            [26.979796842382576, -2.92877454707624],
            [26.983470641077531, -2.93412777615846],
            [26.991249157614327, -2.942070005938337],
            [26.998359154204845, -2.945510030854257],
            [27.00157036095268, -2.958478709974185],
            [27.001397839502349, -2.958435443763904],
            [27.001421608026448, -2.959008943536688],
            [27.00162298156706, -2.959106126728714],
            [27.002383556372031, -2.959130022205222],
            [27.003358043402365, -2.959464564240807],
            [27.005069337611868, -2.959870792556685],
            [27.006709327147398, -2.960109750744061],
            [27.007683814177732, -2.960468187927221],
            [27.00884844490929, -2.960396500680623],
            [27.009680324388238, -2.960396500680623],
            [27.010535970594695, -2.960468187927221],
            [27.011843209775904, -2.961208957372059],
            [27.012841464432046, -2.961280644565377],
            [27.013744647686668, -2.961304540897531],
            [27.015075653595385, -2.961328436326038],
            [27.015907533074333, -2.961113373838204],
            [27.017024627656024, -2.960181438009474],
            [27.017904042386579, -2.958580417984491],
            [27.018403169714613, -2.956931604569015],
            [27.018759689491329, -2.95482876570545],
            [27.019734176521631, -2.952940986037615],
            [27.020756198803539, -2.950718659416931],
            [27.022253581686012, -2.949261002429815],
            [27.023228068716346, -2.949022041875992],
            [27.024535306999262, -2.94916541785326],
            [27.025295881804233, -2.949738923381436],
            [27.025628633955144, -2.950694763756879],
            [27.025913849057851, -2.951985147619892],
            [27.025652401580913, -2.953442800986163],
            [27.024701683074717, -2.955258892206168],
            [27.023632123744605, -2.956907708141317],
            [27.023560819968928, -2.959655730685281],
            [27.024107483446869, -2.961113373838204],
            [27.025081970477203, -2.962547120549156],
            [27.026032688983403, -2.964124238493565],
            [27.029003686224279, -2.968521041302503],
            [27.029669188729471, -2.968998953838656],
            [27.030263388357287, -2.969333491947412],
            [27.031499322864523, -2.970241524729557],
            [27.032354969969308, -2.970862809643709],
            [27.033186849448256, -2.971531885517278],
            [27.034018728028908, -2.972200960979842],
            [27.034898142759463, -2.972583289373013],
            [27.036181613416574, -2.973108990468612],
            [27.037156100446907, -2.973228468119149],
            [27.038320731178469, -2.97363469221349],
            [27.040745064043072, -2.974805571515752],
            [27.041957230924538, -2.975164003869239],
            [27.043121861656097, -2.975450748944464],
            [27.043597221358361, -2.975856972209163],
            [27.044619243640238, -2.976454357918764],
            [27.045926482821482, -2.976956162961716],
            [27.047257488730203, -2.977577444042791],
            [27.048992550565476, -2.978628842055872],
            [27.049681822493106, -2.979345703220626],
            [27.050561237223626, -2.979704134077179],
            [27.052272531433161, -2.981090064525798],
            [27.053817449567209, -2.982738842295678],
            [27.055005847924544, -2.984292036061325],
            [27.056075406356324, -2.985869123395515],
            [27.057311341761892, -2.987589578457111],
            [27.057501485463153, -2.988712653056971],
            [27.057660031822572, -2.989270535435064],
            [27.057797557604381, -2.987701813268021],
            [27.057976844267088, -2.988091378351483],
            [27.058380900193676, -2.991006587412395],
            [27.058499740119256, -2.994543059977492],
            [27.058880027521745, -2.996621926506674],
            [27.058998867447293, -2.998342365369247],
            [27.058998867447293, -2.999465427896803],
            [27.058095684192669, -3.001138072220461],
            [27.058095684192669, -3.005415251767598],
            [27.058190756492451, -3.006968412943462],
            [27.05885625989594, -3.009740202147461],
            [27.059284083448333, -3.011173884536631],
            [27.059426690999686, -3.011914619327253],
            [27.059664370850818, -3.013563349129038],
            [27.059521762401133, -3.014327977434657],
            [27.060401178029988, -3.017338693214995],
            [27.060781465432473, -3.018867942998193],
            [27.060591321731245, -3.021018446673927],
            [27.059165243522749, -3.022404324031672],
            [27.057335109387697, -3.024507031640705],
            [27.055671351328066, -3.02613184808073],
            [27.054692578435514, -3.027131954664855],
            [27.054221504595468, -3.027613296478615],
            [27.054007593268437, -3.028879694724943],
            [27.054316576895246, -3.031006283488244],
            [27.054863240373187, -3.03411252943044],
            [27.055647583702264, -3.036645308097539],
            [27.056764678283947, -3.039201975352547],
            [27.057976844267088, -3.041280755315454],
            [27.059545530925234, -3.042977228873687],
            [27.060710161656793, -3.044076350112825],
            [27.061470736461768, -3.044530335524373],
            [27.0621837760152, -3.044721486885868],
            [27.062242343476765, -3.044717281261859],
            [27.063182030671307, -3.044649805242199],
            [27.064204053851512, -3.043980774829901],
            [27.06524984465749, -3.042642712742448],
            [27.066105490863944, -3.040946239553897],
            [27.067079977894277, -3.040611722784156],
            [27.069575615432857, -3.040683405603014],
            [27.072926899177887, -3.041065709674331],
            [27.074400513536258, -3.042069257433869],
            [27.076016736344279, -3.043502895577197],
            [27.07727643847732, -3.044458653867829],
            [27.078018429834007, -3.045287512969697],
            [27.078850308414655, -3.046506102232317],
            [27.079991171520444, -3.048226460048899],
            [27.080965658550781, -3.049827346859084],
            [27.081441017354717, -3.051069824348227],
            [27.081892609431208, -3.051906106940521],
            [27.083413759041154, -3.052503451245508],
            [27.084245638520102, -3.053053006625247],
            [27.085148821774759, -3.053793712350816],
            [27.08612330790676, -3.054916717546634],
            [27.087430547088008, -3.056469806724179],
            [27.088595177819567, -3.058118467641575],
            [27.089926183728288, -3.06024499881751],
            [27.090853134608714, -3.061439676779064],
            [27.092136605265825, -3.062204269821505],
            [27.092920948594902, -3.063112224018288],
            [27.094014275550784, -3.064402473091583],
            [27.094822386505665, -3.065262638264788],
            [27.095392817609408, -3.065740507703344],
            [27.096652520640749, -3.066313950202251],
            [27.097460631595592, -3.066624564871979],
            [27.097959758923661, -3.06695907252826],
            [27.098767869878511, -3.06753251436504],
            [27.100859451490532, -3.06738915416083],
            [27.103141176803746, -3.067221899962594],
            [27.104068127684176, -3.067102433693965],
            [27.104828702489183, -3.067150219841813],
            [27.105922029445068, -3.06738915416083],
            [27.106944052625273, -3.06738915416083],
            [27.108370130833737, -3.067675875452859],
            [27.109510993041194, -3.068177636849085],
            [27.110437944819953, -3.068177636849085],
            [27.111459967101865, -3.068440463979853],
            [27.112814741534653, -3.069061691975715],
            [27.113717924789309, -3.068966118947944],
            [27.11426458826725, -3.070304146869447],
            [27.115025163072222, -3.071522707324726],
            [27.115357914324839, -3.072048359852785],
            [27.115738202625622, -3.072382866691409],
            [27.116189793803784, -3.072669586625227],
            [27.116712689655955, -3.073075772086286],
            [27.117520800610802, -3.073314705062193],
            [27.118138767864423, -3.073601424742343],
            [27.118495286742803, -3.074318222246614],
            [27.119113254894753, -3.075393418942422],
            [27.119303398596017, -3.07599074906239],
            [27.119897597325529, -3.076731438698728],
            [27.11996890110121, -3.077926097983072],
            [27.119921365849631, -3.079622512755648],
            [27.119493542297239, -3.080721596794052],
            [27.118519055266908, -3.081964037921325],
            [27.117924855639092, -3.082776402409538],
            [27.117330656909573, -3.08313479854652],
            [27.117235584609794, -3.084496702028483],
            [27.117425728311023, -3.085810817541615],
            [27.117639640536385, -3.086599286420435],
            [27.11854282289271, -3.08753111218443],
            [27.119255862446106, -3.088128435400724],
            [27.119873829699728, -3.088773545247814],
            [27.120301653252117, -3.089609797024998],
            [27.120753244430283, -3.092022978322988],
            [27.120800780580154, -3.092978692651459],
            [27.120990924281415, -3.093695476921926],
            [27.121632659160806, -3.095033474237141],
            [27.122464538639782, -3.097374964967221],
            [27.122417002489879, -3.098689064314256],
            [27.121775267610488, -3.10155618458655],
            [27.121680195310709, -3.102464104755419],
            [27.121680195310709, -3.103109205756801],
            [27.121703963834811, -3.103634842445175],
            [27.121109764206967, -3.105235644932355],
            [27.121585123909231, -3.106549734378782],
            [27.121608891535036, -3.107409864985159],
            [27.121941642787615, -3.108437242529305],
            [27.122844826042272, -3.110085821826428],
            [27.122892362192143, -3.111591045259704],
            [27.122773522266595, -3.115509392576958],
            [27.12210801886307, -3.117062392025534],
            [27.12175149908639, -3.117874729203965],
            [27.121394980208002, -3.119260480137588],
            [27.120753244430283, -3.120359521544485],
            [27.119683685998503, -3.121721376429354],
            [27.119065718744849, -3.122270896425842],
            [27.118828038893717, -3.122677063506628],
            [27.118376447715551, -3.123537180761521],
            [27.118089907597827, -3.124049245752773],
            [27.117592104386478, -3.124851247059869],
            [27.116760224907534, -3.125568010285179],
            [27.116261097579461, -3.12640423251795],
            [27.115928346326882, -3.12757494323131],
            [27.115405450474711, -3.128315596245508],
            [27.115096466847902, -3.128889004404336],
            [27.114692411819643, -3.129629656477687],
            [27.114478499594281, -3.13037030802056],
            [27.113575317237956, -3.131517122644443],
            [27.112814741534653, -3.13228166441811],
            [27.112030398205579, -3.133117882125409],
            [27.111721414578767, -3.134431936251763],
            [27.111745183102869, -3.135459287020192],
            [27.111697646952997, -3.136080475108896],
            [27.111721414578767, -3.136462744377158],
            [27.112220542805133, -3.137179498647705],
            [27.112600830207619, -3.138374089496831],
            [27.112933581460236, -3.139329760276828],
            [27.113480244938177, -3.139950946034478],
            [27.1143596596687, -3.140452672649812],
            [27.114953859296548, -3.1407393738502],
            [27.115952113952652, -3.140787157526337],
            [27.1165463135805, -3.140978291305764],
            [27.117401960685253, -3.141097750012726],
            [27.118566591416812, -3.141026074970807],
            [27.119802525924051, -3.141073857730652],
            [27.121775267610488, -3.140763265237037],
            [27.122821058416466, -3.141049966351029],
            [27.123415257145986, -3.141145533672286],
            [27.124698727803128, -3.142268444066507],
            [27.12531669505675, -3.143152436340644],
            [27.126029734610142, -3.143749728476265],
            [27.126386254386858, -3.144299235851307],
            [27.126695238013671, -3.144657610775019],
            [27.127859868745233, -3.144968202093993],
            [27.128525371250426, -3.145111552527042],
            [27.129238410803822, -3.144800961251325],
            [27.129761306655993, -3.144824852543954],
            [27.130117825534377, -3.145326576784698],
            [27.1307595613121, -3.145828300780832],
            [27.13078332893787, -3.146377807948922],
            [27.130379273909611, -3.147070664080492],
            [27.130331737759704, -3.147739628520872],
            [27.130735792787995, -3.14881474841832],
            [27.131211152490263, -3.149603169443252],
            [27.131211152490263, -3.150343806633159],
            [27.131353760041616, -3.151036660091257],
            [27.131734048342398, -3.151729513984926],
            [27.131734048342398, -3.152852412822321],
            [27.131734048342398, -3.153473590413337],
            [27.131686512192527, -3.154357573051564],
            [27.131377528565714, -3.155528252004274],
            [27.131163616340356, -3.156555581707801],
            [27.130379273909611, -3.157224539065149],
            [27.129214643178049, -3.15808462748652],
            [27.128121316222135, -3.159279194042492],
            [27.12721813296751, -3.161190496731262],
            [27.126695238013671, -3.161620539367153],
            [27.126338718236955, -3.162408949644508],
            [27.125934662310367, -3.162982339704872],
            [27.125174087505396, -3.164009661028693],
            [27.124674960177359, -3.164702505248858],
            [27.124223368999193, -3.165897064080789],
            [27.122773522266595, -3.167497770004561],
            [27.122203091162849, -3.168333958143515],
            [27.12175149908639, -3.169217927949692],
            [27.121085996581193, -3.169982442564895],
            [27.120943388131511, -3.170938083900119],
            [27.120420493177669, -3.171774270124482],
            [27.119897597325529, -3.173040492590408],
            [27.119232093922005, -3.17411558682298],
            [27.118923110295199, -3.175357915801911],
            [27.118804270369615, -3.176791370364819],
            [27.118756735118037, -3.177747005318603],
            [27.118566591416812, -3.178630967868319],
            [27.118661662818262, -3.179395474521958],
            [27.118970646445071, -3.180231652904026],
            [27.119018182594974, -3.181712882371254],
            [27.118923110295199, -3.182166807681387],
            [27.119588613698724, -3.183122437587529],
            [27.11996890110121, -3.184149739524966],
            [27.119921365849631, -3.18529649306753],
            [27.119921365849631, -3.186968840340702],
            [27.120159045700763, -3.187948356918076],
            [27.120586868354827, -3.188927872550304],
            [27.121513820133554, -3.189716262604535],
            [27.122512074789658, -3.189692371458593],
            [27.122274394938525, -3.19074355696832],
            [27.122369466340007, -3.192272552374724],
            [27.12293989834205, -3.192630910466534],
            [27.122725986116691, -3.194136011985003],
            [27.122725986116691, -3.195688892375519],
            [27.122630914715241, -3.196620619466926],
            [27.121941642787615, -3.197958482925458],
            [27.12118106798264, -3.199487467440408],
            [27.121014691907185, -3.200108616598385],
            [27.121204836506745, -3.201470365409783],
            [27.122036715087393, -3.202306525592285],
            [27.122155555012977, -3.202593209414288],
            [27.123177578193182, -3.202593209414288],
            [27.123700473147021, -3.202569319475138],
            [27.124128296699382, -3.202043732543984],
            [27.124865103878584, -3.20199595173616],
            [27.125506838758007, -3.202234854849777],
            [27.125887127058789, -3.202664880131365],
            [27.12671900563944, -3.203524930145553],
            [27.126980453116378, -3.203883284252484],
            [27.127574652744194, -3.20450443070886],
            [27.127883636371003, -3.204599991182065],
            [27.127598420369999, -3.205842282831016],
            [27.127432045192837, -3.207251804474526],
            [27.127479580444415, -3.208446313259705],
            [27.126956685490573, -3.209186907634957],
            [27.126433789638437, -3.209808050826875],
            [27.126338718236955, -3.210763654642965],
            [27.125649447207657, -3.211098115538859],
            [27.12531669505675, -3.211575917400068],
            [27.124817567728712, -3.212149278792694],
            [27.12457988787758, -3.212579299848788],
            [27.123652936997118, -3.212627080155433],
            [27.123272649594632, -3.213080991601299],
            [27.123296417220434, -3.214490502220828],
            [27.123005479849351, -3.215020534999468],
            [27.122916129817948, -3.215183312873278],
            [27.122488306265559, -3.216091131449607],
            [27.121989178937522, -3.216855610708505],
            [27.121656427684908, -3.217548418829666],
            [27.121133531832768, -3.218217336905294],
            [27.120777012954385, -3.219364051797134],
            [27.121585123909231, -3.22139469055765],
            [27.121442515459577, -3.22211138592954],
            [27.121299907908224, -3.222875859706905],
            [27.120943388131511, -3.223258096377306],
            [27.120943388131511, -3.223855341447829],
            [27.12032542087789, -3.224189797990358],
            [27.119992669625312, -3.224882601054348],
            [27.119897597325529, -3.225838191449821],
            [27.119160790146331, -3.226411544708471],
            [27.118495286742803, -3.227199905468253],
            [27.11761587201228, -3.228322720772807],
            [27.116665153506048, -3.229373866010008],
            [27.116522545056398, -3.230257782475662],
            [27.1165463135805, -3.231022250946666],
            [27.116879064833082, -3.23159560123983],
            [27.117734711937832, -3.232312288418904],
            [27.117972391788964, -3.233052865203514],
            [27.11768717578796, -3.233936779324654],
            [27.117188048459891, -3.235011807837717],
            [27.116379937505044, -3.236110725241022],
            [27.116273773706435, -3.236613771329591],
            [27.116213561429589, -3.236899078364979],
            [27.115239075297588, -3.238093550981374],
            [27.114835019371, -3.238714676286081],
            [27.113979372266211, -3.239574695440224],
            [27.112779108960616, -3.240925137880171],
            [27.112386917982292, -3.241366399482524],
            [27.111935326804129, -3.242059190657677],
            [27.111317359550512, -3.242871428068252],
            [27.110984607399597, -3.243420882598149],
            [27.110628088521217, -3.244376455287004],
            [27.110461712445758, -3.244639237254824],
            [27.110533016221435, -3.245618697691528],
            [27.110628088521217, -3.246407042405094],
            [27.111697646952997, -3.247434279751776],
            [27.112695901609104, -3.248079288098435],
            [27.11393183611634, -3.248795964351986],
            [27.114146820930134, -3.248824149172386],
            [27.114478499594281, -3.248867631768385],
            [27.115857042551205, -3.249632085093167],
            [27.115999650102559, -3.250062090056177],
            [27.116522545056398, -3.250062090056177],
            [27.116926600982985, -3.250730986396555],
            [27.117568335862376, -3.25123265813115],
            [27.118067464088742, -3.251519327967224],
            [27.11832891156568, -3.251949332115032],
            [27.11946977377314, -3.252570448789126],
            [27.120277884728019, -3.253311010540042],
            [27.121109764206967, -3.254027683026824],
            [27.122226858788654, -3.255102689885691],
            [27.123296417220434, -3.256368807564146],
            [27.12389061684825, -3.257276589653954],
            [27.12457988787758, -3.25832770438905],
            [27.12531669505675, -3.259259373276332],
            [27.126528861938212, -3.259928263428763],
            [27.127527116594319, -3.260549375116091],
            [27.12795494014668, -3.260931597360819],
            [27.129024499476792, -3.261266042381369],
            [27.129808841907568, -3.261672152879591],
            [27.130307969235606, -3.261982708226109],
            [27.131211152490263, -3.262197708510626],
            [27.132043031969211, -3.262269374960798],
            [27.132898679073961, -3.262221597026936],
            [27.133469110177707, -3.261791597324615],
            [27.134039541281417, -3.261696042311468],
            [27.134205917356908, -3.262030486171472],
            [27.13646387414602, -3.262102152633717],
            [27.137367057400677, -3.262317152892344],
            [27.138080096954077, -3.263248818034409],
            [27.13936356761122, -3.264204370769748],
            [27.140052838640514, -3.264586591605999],
            [27.140718342044011, -3.264299926444056],
            [27.142025580326923, -3.265303255953919],
            [27.141573989148757, -3.266067696631493],
            [27.141407613073305, -3.26728602353232],
            [27.140837181969594, -3.268074351958011],
            [27.140147910041964, -3.268982122431567],
            [27.139482407536772, -3.269483784942198],
            [27.139078351610184, -3.269889892975592],
            [27.138674295683597, -3.270821550995911],
            [27.138294008281111, -3.271203769278228],
            [27.138056328429975, -3.271681542374894],
            [27.137248217475097, -3.271657654086681],
            [27.136535178820029, -3.271848763084778],
            [27.136083586743535, -3.272517644738729],
            [27.135631995565372, -3.273210414191507],
            [27.134633740909269, -3.273688185415756],
            [27.134633740909269, -3.275025945782065],
            [27.134752580834849, -3.276674255074509],
            [27.135346779564369, -3.27765368389164],
            [27.135513155639824, -3.278991437984152],
            [27.135536923265594, -3.280472521434227],
            [27.135061564461658, -3.28116528530662],
            [27.13496649216188, -3.282096932692487],
            [27.134681277059173, -3.282622477469536],
            [27.133492877803477, -3.28422299720127],
            [27.132779839148409, -3.28501131210968],
            [27.132138103370689, -3.286014620588266],
            [27.131472599967164, -3.2868507099053],
            [27.130664489012322, -3.288284004870289],
            [27.130379273909611, -3.289430639881036],
            [27.129428554505083, -3.29012339745312],
            [27.128263923773488, -3.290911707636078],
            [27.127265669117381, -3.291222253788858],
            [27.125744518609139, -3.291867233599314],
            [27.124865103878584, -3.292416660946218],
            [27.123748009296897, -3.293396074111369],
            [27.123130042043279, -3.294518814523084],
            [27.122678449966816, -3.295784882592354],
            [27.122512074789658, -3.297767588883921],
            [27.122203091162849, -3.298890324296325],
            [27.121917875161841, -3.298961988080735],
            [27.121799035236261, -3.300156385823233],
            [27.121537587759356, -3.300873024312124],
            [27.121062228057092, -3.30151799778194],
            [27.120468029327576, -3.302258522821686],
            [27.119945133475404, -3.302712393313228],
            [27.119113254894753, -3.302999047301819],
            [27.118804270369615, -3.303524580901139],
            [27.117877319489185, -3.303644020275189],
            [27.1165463135805, -3.303787347143649],
            [27.11590457780278, -3.303859010570042],
            [27.115120235372004, -3.303715683712052],
            [27.114430963444374, -3.304265104424243],
            [27.11314749368556, -3.30448009458274],
            [27.112624597833424, -3.305125066580787],
            [27.112291846580813, -3.305292280704784],
            [27.111887790654222, -3.306295569363273],
            [27.11122228725073, -3.307155529736084],
            [27.11122228725073, -3.307537733902997],
            [27.110865767474014, -3.308134927276314],
            [27.110414176295855, -3.308158815581474],
            [27.110224032594626, -3.308469356272835],
            [27.109344617864071, -3.308827672541025],
            [27.108488970759321, -3.308923222981985],
            [27.107823467355797, -3.309472640770636],
            [27.106848980325495, -3.310332598350208],
            [27.105826958043583, -3.3111686669422],
            [27.104947542414731, -3.311718083468807],
            [27.103854216357142, -3.312506376285046],
            [27.103806680207271, -3.313079679341465],
            [27.103236248205231, -3.313270780285507],
            [27.102832193176937, -3.313915746485517],
            [27.101833938520834, -3.313987409169708],
            [27.101287275042889, -3.314656262139878],
            [27.100740611564948, -3.315181788571716],
            [27.100360324162462, -3.31561176494318],
            [27.099861196834425, -3.316734479880242],
            [27.099766124534646, -3.317331668534405],
            [27.099100621131122, -3.318048294436785],
            [27.099029317355448, -3.318717144623371],
            [27.098767869878511, -3.319027681957326],
            [27.098649029952959, -3.320054842717155],
            [27.098601493803052, -3.320675916433837],
            [27.098553957653181, -3.321416426955788],
            [27.09886294127999, -3.321703076359356],
            [27.098601493803052, -3.322180824876949],
            [27.098435117727597, -3.322849671324489],
            [27.098126134100788, -3.323685730092117],
            [27.097698311446724, -3.324784548733716],
            [27.096985271893331, -3.325572830083788],
            [27.096310442180538, -3.326081493969972],
            [27.095844408787574, -3.326432773467157],
            [27.095369049983606, -3.327197167449125],
            [27.09529774530963, -3.328272094313034],
            [27.095178906282378, -3.328725951804925],
            [27.095178906282378, -3.329323133105225],
            [27.095226441533953, -3.329872539396883],
            [27.095250210058055, -3.330302509282293],
            [27.095174333857553, -3.330764797274911],
            [27.094603902753839, -3.331672509718408],
            [27.094437526678384, -3.332126366524875],
            [27.09429491912703, -3.333057965390618],
            [27.094936654006418, -3.334586740523598],
            [27.094865350230741, -3.336163288485523],
            [27.094770278829294, -3.339388036630785],
            [27.094603902753839, -3.341155672250112],
            [27.094960422530519, -3.342230583651678],
            [27.095792301111207, -3.344667045497684],
            [27.096267660813467, -3.346936294269936],
            [27.09693316421696, -3.348393388260833],
            [27.097931418873067, -3.35004157286154],
            [27.10014184041064, -3.353648461680163],
            [27.101377774917879, -3.354842792270987],
            [27.102637477050916, -3.356586512512489],
            [27.105038042289717, -3.361626563833466],
            [27.105014274663912, -3.363704680846593],
            [27.103588196455448, -3.366666587862422],
            [27.102542405649437, -3.368147537948047],
            [27.101045023665296, -3.370201754992678],
            [27.09942880085724, -3.371587155376085],
            [27.098430546201133, -3.372232081820446],
            [27.09536447755881, -3.37431017679715],
            [27.093272895946821, -3.376436038706788],
            [27.092179569889236, -3.378012518237399],
            [27.091941890038104, -3.378752984808805],
            [27.091918121514002, -3.379899512039802],
            [27.091965657663909, -3.380377231765527],
            [27.091870586262427, -3.381595415625894],
            [27.092227105140811, -3.383100228204391],
            [27.092892608544336, -3.384413951578706],
            [27.093795791798961, -3.385536586535669],
            [27.093819559424762, -3.386300933658156],
            [27.094152311575677, -3.386874192921746],
            [27.094698974155285, -3.387638538071449],
            [27.09607751711221, -3.389453856704558],
            [27.096410268364824, -3.39012265648593],
            [27.097265915469574, -3.390576485738337],
            [27.097931418873067, -3.391364714171816],
            [27.098478082351008, -3.391818541930723],
            [27.099832856783827, -3.392487340957502],
            [27.100569663963029, -3.392821739843674],
            [27.101520382469232, -3.392965053487171],
            [27.102209654396855, -3.392773968323464],
            [27.1029939968276, -3.39234402633947],
            [27.103707036381, -3.391364714171816],
            [27.103897180082257, -3.390767571342157],
            [27.103968483857933, -3.388976141514381],
            [27.105299490664951, -3.387065279266495],
            [27.105941225544374, -3.386157618111453],
            [27.106582961322093, -3.385393271777108],
            [27.108199183231818, -3.384605038415384],
            [27.109553957664605, -3.384557266484094],
            [27.110599748470616, -3.38472446778173],
            [27.111098875798689, -3.38448560903409],
            [27.111693075426501, -3.384700582270789],
            [27.112382346455796, -3.385106641292726],
            [27.113380601111903, -3.385799331407574],
            [27.114545231843465, -3.387208593774289],
            [27.115234502872791, -3.390027114075629],
            [27.115377111322442, -3.391125857084808],
            [27.116185222277323, -3.393251681612331],
            [27.116185222277323, -3.394637047713239],
            [27.116755653381034, -3.396476238245239],
            [27.117373620634655, -3.398315425226697],
            [27.118015355514078, -3.400560661098244],
            [27.118752162693248, -3.403594109985519],
            [27.119227522395512, -3.406985828967562],
            [27.119346362321096, -3.409637093828685],
            [27.119298826171185, -3.410711928434385],
            [27.119084914844159, -3.412049499449819],
            [27.118704627441673, -3.412981020716744],
            [27.116304062202872, -3.414318588531306],
            [27.115258271396893, -3.415441188213781],
            [27.114616535619138, -3.416444361195813],
            [27.113903496964074, -3.418474589538189],
            [27.11364204858884, -3.420146538861859],
            [27.113285529710453, -3.421579635801469],
            [27.113261761186354, -3.423442658666451],
            [27.11364204858884, -3.424063665472151],
            [27.114735375544722, -3.424517478504734],
            [27.115091895321438, -3.425281793368177],
            [27.115543486499604, -3.426882076400411],
            [27.115567255023706, -3.428816742919564],
            [27.11542464657402, -3.430058749054141],
            [27.115448415098122, -3.430560327921718],
            [27.116232757528898, -3.430990252582006],
            [27.118466947590541, -3.431181330045616],
            [27.12053476067846, -3.430536443563677],
            [27.122412430963418, -3.428936166726833],
            [27.1235057579193, -3.427909122573709],
            [27.124361405024054, -3.427073154695864],
            [27.12514574745483, -3.425496756473588],
            [27.125977626933778, -3.424684671869748],
            [27.126619361813201, -3.424302514273801],
            [27.127379937516473, -3.42435028420741],
            [27.128615872023708, -3.423657623092988],
            [27.13049354141037, -3.42458913293662],
            [27.13227613939555, -3.426738767879121],
            [27.132585123022356, -3.428721204404513],
            [27.13227613939555, -3.431300753553519],
            [27.131277884739443, -3.435791064485505],
            [27.130802525037176, -3.437558521668666],
            [27.130731221261502, -3.438537786093968],
            [27.130446005260499, -3.439755895289783],
            [27.130327165334915, -3.441547229105086],
            [27.129946877932429, -3.442526490280446],
            [27.129780502755303, -3.443099715530638],
            [27.128544567349735, -3.443983437219187],
            [27.127308632842496, -3.444867158979184],
            [27.125264587380379, -3.446252449509336],
            [27.124361405024054, -3.44708840035624],
            [27.123838509171883, -3.448067654851927],
            [27.123790973022007, -3.449906741452713],
            [27.123624597844849, -3.451674172083089],
            [27.123125469618483, -3.453178873290482],
            [27.122269823412061, -3.453895397341565],
            [27.121128960306272, -3.454898529370203],
            [27.120130705650169, -3.45621215306395],
            [27.119061146320053, -3.457191398930206],
            [27.119108682469964, -3.458672207629947],
            [27.119797953499258, -3.460415737216165],
            [27.120772440529592, -3.461968192392678],
            [27.120867512829367, -3.46278024477306],
            [27.120059401874492, -3.464786489601033],
            [27.119750418247683, -3.465455236919333],
            [27.119726649723582, -3.466888264758326],
            [27.119726649723582, -3.467939150562211],
            [27.11984548964913, -3.469754313834345],
            [27.120178241800073, -3.470518592762572],
            [27.120178241800073, -3.47137840434102],
            [27.121461711558887, -3.473026376196587],
            [27.121794463709801, -3.473623466925465],
            [27.123648365470654, -3.474029487680355],
            [27.123862276797688, -3.474578810392889],
            [27.124004885247338, -3.475868523196153],
            [27.123695901620529, -3.477564254328537],
            [27.123481989395199, -3.479212214332238],
            [27.12360082932075, -3.479713766875737],
            [27.124908067603663, -3.480788522188861],
            [27.126548058037525, -3.4815050241379],
            [27.127807761068862, -3.482030459392002],
            [27.128901087126415, -3.482603660409954],
            [27.129661662829719, -3.483941128979162],
            [27.129471519128458, -3.48530247858301],
            [27.129445706038798, -3.485406230172622],
            [27.128972390902092, -3.487308673980265],
            [27.128877319500642, -3.488431186265067],
            [27.129923110306656, -3.49079562266705],
            [27.131943388142968, -3.494569156357505],
            [27.133226858800079, -3.497793365118377],
            [27.133576369920938, -3.498900183667122],
            [27.1332152570582, -3.50051684123804],
            [27.132490080366985, -3.503760004904231],
            [27.127940039791092, -3.512520012193077],
            [27.129020040239734, -3.52181996253386],
            [27.126889920003734, -3.527939946610007],
            [27.128452042672091, -3.531941788986053],
            [27.125859687120119, -3.531448646638506],
            [27.123374540107445, -3.534731840122351],
            [27.123292745805863, -3.534839900700564],
            [27.122318258775532, -3.536057883470832],
            [27.118919438880628, -3.536869870782752],
            [27.117089304745541, -3.539019246012925],
            [27.116780321118732, -3.539711821148952],
            [27.118325239252812, -3.541383552478232],
            [27.118301471627007, -3.545180759119342],
            [27.118818780856429, -3.545917121755954],
            [27.11915711873176, -3.546398728106829],
            [27.120345517089124, -3.546852480436273],
            [27.120678268341706, -3.546255438040669],
            [27.120702036865808, -3.544607597052078],
            [27.121841756416224, -3.54451950621094],
            [27.121937971373047, -3.544512070457174],
            [27.122175651224175, -3.541216379212148],
            [27.123649265582582, -3.539616293139427],
            [27.127166925403035, -3.540953678948363],
            [27.128593003611531, -3.540929797430698],
            [27.132633559284155, -3.538828190741801],
            [27.135176732074342, -3.538780426692103],
            [27.134416157269367, -3.540117813724077],
            [27.134392388745265, -3.543819498057823],
            [27.133441670239034, -3.544918059996027],
            [27.133631813940294, -3.545825566804526],
            [27.134986588373081, -3.546542018150483],
            [27.13472514089618, -3.547592813222277],
            [27.133560510164617, -3.549025714380285],
            [27.132277039507475, -3.553133349353899],
            [27.132277039507475, -3.554948344805707],
            [27.134653836222171, -3.558267867462919],
            [27.134606300970596, -3.559366411977904],
            [27.133917029043001, -3.559915683737569],
            [27.131317580393549, -3.559760742313385],
            [27.131112408775913, -3.559748513871269],
            [27.128688075013009, -3.557049914344746],
            [27.125812150970248, -3.556309589244947],
            [27.123863176909612, -3.556620048202007],
            [27.122128115074304, -3.55745589919957],
            [27.121462611670779, -3.558363393518031],
            [27.121389929879456, -3.558640903177074],
            [27.121224931819647, -3.559270886028169],
            [27.12127246796955, -3.560823174697861],
            [27.121676523896138, -3.561659021830719],
            [27.123268977281764, -3.562256055026213],
            [27.12512287994095, -3.564405369474753],
            [27.125622007268984, -3.567056184581297],
            [27.125669542520562, -3.568632341632989],
            [27.12714315687893, -3.571474192841237],
            [27.12719069302884, -3.573575724120556],
            [27.126287509774183, -3.574363796415861],
            [27.122817386103598, -3.57386229561547],
            [27.122983762179057, -3.575677250521796],
            [27.124885200089818, -3.577969819128885],
            [27.124790127790039, -3.579951931061599],
            [27.123506657132896, -3.580644475006944],
            [27.120416820864804, -3.580548951299959],
            [27.119062046431981, -3.580142977689121],
            [27.116827857268635, -3.582148965290268],
            [27.117255680820996, -3.583104196603217],
            [27.117113072371346, -3.583940022270524],
            [27.115187866834813, -3.585540030252053],
            [27.115449314311718, -3.587641528827319],
            [27.114902650833773, -3.589862425469804],
            [27.114902650833773, -3.591032573141592],
            [27.115473082835816, -3.591772869844953],
            [27.116281193790694, -3.592035555392821],
            [27.116352497566375, -3.592871373684078],
            [27.115164099209007, -3.594447484801614],
            [27.114379755879931, -3.59456688714229],
            [27.113595412550858, -3.594113158705019],
            [27.112026726791008, -3.594495245920303],
            [27.111765140075221, -3.59459573768127],
            [27.111218615836158, -3.594805691776124],
            [27.111080291452065, -3.595056922876042],
            [27.110600648582544, -3.595928071984207],
            [27.111503830938869, -3.597742982504976],
            [27.111693974640094, -3.598578794592562],
            [27.111575134714545, -3.601014586392449],
            [27.111099775910578, -3.60261456403253],
            [27.110576880058439, -3.604811543879439],
            [27.109745001477791, -3.605910031786377],
            [27.106845308910923, -3.606578675077551],
            [27.107415740014638, -3.609157726197188],
            [27.107558347565991, -3.610709929062397],
            [27.108865585848939, -3.611665130044609],
            [27.109459785476755, -3.613575528050592],
            [27.108984425774487, -3.614196406457261],
            [27.107748491267248, -3.614482965021222],
            [27.106393716834429, -3.615844119654714],
            [27.105181549952995, -3.615820240115075],
            [27.104159527671086, -3.617205272217602],
            [27.103131563033575, -3.616975760723289],
            [27.10287605701394, -3.616918714525457],
            [27.102709680938489, -3.617563470106234],
            [27.102720550553432, -3.617606632438493],
            [27.103208808266558, -3.619545494746551],
            [27.103898080194181, -3.62179019272895],
            [27.103993151595631, -3.623414012594085],
            [27.102353162060101, -3.624034884168198],
            [27.100689403102177, -3.623796087321176],
            [27.100148835591771, -3.623136596892852],
            [27.10002390059698, -3.622984178105079],
            [27.099287093417811, -3.623461772169569],
            [27.099334025001504, -3.623829919826685],
            [27.099905060671432, -3.628309334574515],
            [27.099809988371653, -3.629574949649672],
            [27.099905060671432, -3.632273331733389],
            [27.098526517714507, -3.632440488124416],
            [27.099049413566679, -3.63683429491448],
            [27.099358397193487, -3.640678857941648],
            [27.099120717342355, -3.642589193807606],
            [27.098669126164193, -3.64509650367783],
            [27.09790855046089, -3.645717360128546],
            [27.096886528178981, -3.64609942528195],
            [27.09670495440556, -3.646687230070162],
            [27.096672615953651, -3.646791918065961],
            [27.096743600827391, -3.646861748262734],
            [27.097813479059408, -3.647914232964929],
            [27.099049413566679, -3.648272418502424],
            [27.099453468594938, -3.649490247886779],
            [27.100118971998459, -3.650779711408396],
            [27.100000132072879, -3.653406392594257],
            [27.09790855046089, -3.654934639864686],
            [27.097956086610761, -3.658349307048306],
            [27.097623335358183, -3.659113426293464],
            [27.098265070237574, -3.660164089628503],
            [27.100190275774139, -3.662504199054243],
            [27.100071435848555, -3.665751687816469],
            [27.099501004744841, -3.669763274657708],
            [27.097305740481062, -3.67176394638173],
            [27.096831557571797, -3.672196095577736],
            [27.096173488625581, -3.672795831043618],
            [27.095864504998772, -3.674061382578569],
            [27.096553776028067, -3.675016514523025],
            [27.097979854236566, -3.675685106718779],
            [27.100095204372657, -3.678669887014327],
            [27.099905060671432, -3.680030943156206],
            [27.096548731987767, -3.683734076293778],
            [27.095365377670738, -3.684209610633474],
            [27.09374915576101, -3.68456778143864],
            [27.092727132580769, -3.68545126807804],
            [27.093128160286543, -3.686536816684388],
            [27.094226372280946, -3.689509578015209],
            [27.094438426790308, -3.69008359031087],
            [27.095151465445372, -3.690417881189831],
            [27.095983344924356, -3.689892567281003],
            [27.096848378525511, -3.68902353276538],
            [27.097837246685209, -3.688030089882268],
            [27.099073181192448, -3.688030089882268],
            [27.099857524521525, -3.689223985897545],
            [27.097455600131685, -3.6909249757475],
            [27.096957831954658, -3.691277484432495],
            [27.096993362120791, -3.69165227129791],
            [27.097147975655915, -3.693283221451352],
            [27.098074926536345, -3.694692010655955],
            [27.098098694162118, -3.696363452274984],
            [27.096170279843381, -3.698186810120522],
            [27.096078417224135, -3.698273667488395],
            [27.096176822273613, -3.698361541921081],
            [27.097361886982949, -3.699419794072845],
            [27.098811733715547, -3.699945102265568],
            [27.098431446313025, -3.70101959404148],
            [27.097632110101863, -3.701937334000771],
            [27.097433191656922, -3.702165717928769],
            [27.095769433597326, -3.701449390562551],
            [27.094058139387823, -3.700518164650254],
            [27.092228005252736, -3.69999285770427],
            [27.090778158520138, -3.700613675462393],
            [27.089280776535993, -3.702691023568829],
            [27.089874976163809, -3.703646125236097],
            [27.088472665581119, -3.70553244651665],
            [27.091752645550471, -3.707776925029784],
            [27.091372358147986, -3.708779776091071],
            [27.090350334967781, -3.708421615194554],
            [27.089470920237222, -3.70851712423987],
            [27.08863904165657, -3.709925888888618],
            [27.087403107149335, -3.710546699583976],
            [27.087331802475326, -3.711931584013018],
            [27.087617018476365, -3.713817887376387],
            [27.087967376708523, -3.714302917123895],
            [27.089565992537004, -3.71651601138575],
            [27.089375848835775, -3.718688830444978],
            [27.091229750596632, -3.720455734736568],
            [27.092228005252736, -3.721291430815432],
            [27.092584525029416, -3.723488115469781],
            [27.089470920237222, -3.724347685233266],
            [27.088520201730987, -3.724968486542908],
            [27.08873411305802, -3.725756424257506],
            [27.089399616461545, -3.72609070146806],
            [27.090160191266516, -3.725613163072106],
            [27.090588014818913, -3.726233962574659],
            [27.09053541127248, -3.726506994263948],
            [27.090445407267556, -3.726974146086226],
            [27.088924256759281, -3.728000851522579],
            [27.088116145804399, -3.728191866206543],
            [27.087260498699649, -3.727833713301195],
            [27.086821988788653, -3.727345996443172],
            [27.086594995296156, -3.727093530522644],
            [27.085786884341282, -3.727356175864102],
            [27.085596740640053, -3.728072481921202],
            [27.085596740640053, -3.728454511215595],
            [27.086166692043417, -3.728922103277429],
            [27.087022818848521, -3.729624475447238],
            [27.088781649207924, -3.731677877929106],
            [27.089613527788575, -3.732609070506557],
            [27.090801927044236, -3.732704577797517],
            [27.0909920707455, -3.734065549684173],
            [27.090255263566295, -3.734996739695756],
            [27.088448897955313, -3.734710219451741],
            [27.088139914328501, -3.735641408770269],
            [27.0902790311921, -3.737288895528029],
            [27.092489452729641, -3.738339464960474],
            [27.093772923386783, -3.73915126761622],
            [27.094818714192797, -3.739175143808364],
            [27.095935808774453, -3.740368970622786],
            [27.096934063430552, -3.743258022527707],
            [27.097433191656922, -3.745072629703226],
            [27.097528263058404, -3.746314200362643],
            [27.09805115891054, -3.747484140450759],
            [27.099405933343363, -3.749656881863793],
            [27.099501004744841, -3.751375970371267],
            [27.098526517714507, -3.751925122972469],
            [27.096434936102519, -3.751948998811445],
            [27.096577544552172, -3.753429321195953],
            [27.097765942909536, -3.753787463501059],
            [27.098859269865418, -3.753596454470658],
            [27.101402442655569, -3.752283265000117],
            [27.102139249834774, -3.75242652267192],
            [27.102353162060101, -3.757106239433558],
            [27.102186785984646, -3.759708725141059],
            [27.10230562591023, -3.760353375760047],
            [27.103103229271223, -3.7605313851756],
            [27.103840036450393, -3.760340377641243],
            [27.105099738583437, -3.759647974860937],
            [27.106454513016224, -3.759027199356318],
            [27.107595376122013, -3.758764563639332],
            [27.108474790852569, -3.758597431367494],
            [27.109021454330513, -3.758597431367494],
            [27.109140294256061, -3.759791230405382],
            [27.108783774479381, -3.761605801878793],
            [27.107547839972142, -3.762513086631028],
            [27.107143784943851, -3.762895100692167],
            [27.107167552569621, -3.764065018262401],
            [27.107215088719528, -3.764590287281135],
            [27.106739729017264, -3.765593071631497],
            [27.106430745390451, -3.766142215161286],
            [27.106406977764646, -3.766858488135987],
            [27.106953640344294, -3.767527009701773],
            [27.108046967300176, -3.767503134295048],
            [27.109187830405968, -3.767765767342174],
            [27.110352461137527, -3.768529790623331],
            [27.111374483419404, -3.768434288201572],
            [27.111921146897348, -3.768529790623331],
            [27.112491578001091, -3.768959553645744],
            [27.111635931794638, -3.770439846753246],
            [27.111113035942498, -3.770988987182657],
            [27.112206362898384, -3.772254396634368],
            [27.112966937703359, -3.772970664507572],
            [27.114416784435956, -3.773973439968602],
            [27.115961702570004, -3.774212194912478],
            [27.116722277374976, -3.774928462052259],
            [27.116841117300524, -3.776313242408604],
            [27.116579669823622, -3.776886255124132],
            [27.116270686196813, -3.77769802142881],
            [27.115795326494549, -3.778390409648015],
            [27.114939679389796, -3.778772416639443],
            [27.114084032285042, -3.778772416639443],
            [27.113370993629946, -3.779106673293894],
            [27.112919401553484, -3.779226050509969],
            [27.112182594374282, -3.78015719168229],
            [27.112301434299834, -3.78125545883035],
            [27.113370993629946, -3.782377601366255],
            [27.113370993629946, -3.782735730692942],
            [27.112824330152005, -3.783690743903883],
            [27.112182594374282, -3.784024997734242],
            [27.112253899048291, -3.784550254520678],
            [27.113062010003134, -3.784932258761295],
            [27.115367502942156, -3.785027759343574],
            [27.116437062272269, -3.785505264802086],
            [27.116793581150656, -3.786794527665816],
            [27.117126333301563, -3.78720040666374],
            [27.117744300555184, -3.787176530903095],
            [27.118623715285739, -3.786555775330148],
            [27.119099074988004, -3.78607827045869],
            [27.119360522464909, -3.785290387920189],
            [27.120786600673405, -3.785553015513758],
            [27.121594711628248, -3.786340898712441],
            [27.12180862385361, -3.787081030560961],
            [27.121642247778158, -3.788250915107165],
            [27.121238192749868, -3.789253671756192],
            [27.122141375106192, -3.790519053293727],
            [27.122212678881869, -3.791569557653333],
            [27.122402823481462, -3.792357435299823],
            [27.122711807108271, -3.793002061349598],
            [27.123828901689926, -3.79321693719284],
            [27.124304260493894, -3.794458438197334],
            [27.124423100419442, -3.796058062034318],
            [27.124898460121706, -3.796702685285879],
            [27.125920483301911, -3.796702685285879],
            [27.126752361882563, -3.796965310269256],
            [27.127679312763025, -3.797156309632094],
            [27.128344816166514, -3.79739505809863],
            [27.12879640734468, -3.797800932052703],
            [27.128820175868782, -3.798087431251039],
            [27.128225976240966, -3.799591548430694],
            [27.128202208615161, -3.800379418660601],
            [27.128867712018685, -3.801811907544972],
            [27.129461910748205, -3.803029521606653],
            [27.128748872093105, -3.804008385576164],
            [27.128416119942194, -3.804820126982863],
            [27.128630032167557, -3.805416994002072],
            [27.129319303196851, -3.805464743598171],
            [27.13048393392841, -3.804963374961315],
            [27.131149437331903, -3.804748502082249],
            [27.131838708361233, -3.804772377350581],
            [27.132147691988042, -3.804820126982863],
            [27.131814939837099, -3.80589448803757],
            [27.131719868435649, -3.806849474401486],
            [27.131814939837099, -3.80780446059448],
            [27.131791172211326, -3.80859232321505],
            [27.131767404585556, -3.809451808712677],
            [27.131571997655033, -3.809584587811963],
            [27.130959293630678, -3.810000923139653],
            [27.130246254077278, -3.810120296029525],
            [27.130341326377057, -3.811003655073685],
            [27.131006828882253, -3.811648266996466],
            [27.131814939837099, -3.811194651283422],
            [27.132327458351096, -3.810526781113097],
            [27.132694355465983, -3.810048672478076],
            [27.133621306346413, -3.808974316676411],
            [27.134334345001477, -3.808114830695582],
            [27.134904777003523, -3.807828334874589],
            [27.135617815658623, -3.807780585411322],
            [27.136497231287475, -3.808377451253586],
            [27.138089684673098, -3.80961893014007],
            [27.138374900674137, -3.809977048920572],
            [27.139682138957049, -3.810550038113799],
            [27.140205034809188, -3.810860407211424],
            [27.141726185317463, -3.811266274738194],
            [27.142486760122438, -3.811266274738194],
            [27.143104727376056, -3.811600517748002],
            [27.143580087078323, -3.81205413414648],
            [27.144055445882291, -3.812674871128158],
            [27.143413711002868, -3.813653723982407],
            [27.142843279899154, -3.814417707079507],
            [27.142819511375052, -3.815850172290692],
            [27.141512273092104, -3.816518655468252],
            [27.141108218063845, -3.817067766223163],
            [27.141108218063845, -3.818547975815623],
            [27.14101314576407, -3.819789439814744],
            [27.141203289465292, -3.820362422376947],
            [27.141963864270299, -3.820625039142229],
            [27.142962119824702, -3.819693942232186],
            [27.143984142106614, -3.81892996479342],
            [27.144221821957746, -3.818476352975906],
            [27.145029932912589, -3.818643472625077],
            [27.145814276241662, -3.818906089923394],
            [27.148191073854694, -3.818858341985992],
            [27.149355704586252, -3.819025461559796],
            [27.150662942869168, -3.820052056757768],
            [27.151803805076661, -3.820768285354532],
            [27.15251684463006, -3.821221895944389],
            [27.153277419435032, -3.821914248766247],
            [27.153919155212751, -3.822343984871206],
            [27.154394514016687, -3.822869217993119],
            [27.155392769571122, -3.825399879968113],
            [27.155582913272347, -3.826354844357552],
            [27.156319720451553, -3.827381430662641],
            [27.156652471704163, -3.829434598629363],
            [27.15672377547984, -3.830723794821556],
            [27.157080295256524, -3.831750374915277],
            [27.157508118808916, -3.833063442042437],
            [27.157555654958788, -3.833851280255354],
            [27.158696517166248, -3.83554632558183],
            [27.159362020569773, -3.836692268949219],
            [27.159718540346454, -3.837623347126787],
            [27.160336507600071, -3.837790463891538],
            [27.161524905957439, -3.837217493148875],
            [27.162190409360964, -3.836931007180323],
            [27.16311736024139, -3.836811638073238],
            [27.163973007346144, -3.836931007180323],
            [27.164852422076667, -3.837169745343822],
            [27.165208941853383, -3.837289114400235],
            [27.165375317928838, -3.837599473687261],
            [27.164377063272731, -3.838697667447596],
            [27.163616487569428, -3.83903189961558],
            [27.16364025609353, -3.840177839146329],
            [27.16375909601911, -3.841753502440544],
            [27.163711559869206, -3.842421965120955],
            [27.164305758598722, -3.843209795488017],
            [27.165018798152122, -3.843400784420111],
            [27.165446621704511, -3.843663394018254],
            [27.165850677631102, -3.843973750956441],
            [27.166135892733809, -3.844116992304009],
            [27.166421108734848, -3.844355728430604],
            [27.166587484810304, -3.844594464489465],
            [27.16718168353982, -3.845644901802291],
            [27.166848932287206, -3.8458836374953],
            [27.165969517556654, -3.845310672259614],
            [27.165185174227574, -3.844785453107308],
            [27.164424598524306, -3.84442734907491],
            [27.163949239720338, -3.84442734907491],
            [27.163521416167978, -3.844618337730691],
            [27.163450112392304, -3.845048062273316],
            [27.163806631270688, -3.846337234583983],
            [27.164258223347147, -3.84729217616331],
            [27.164210687197276, -3.848127748253275],
            [27.163925471196237, -3.848557471002537],
            [27.163259967792744, -3.848605218161645],
            [27.162428089212096, -3.848557471002537],
            [27.16226171313664, -3.848915573276178],
            [27.162356785436419, -3.850180865671403],
            [27.162546929137648, -3.850419600076224],
            [27.163212432541172, -3.850515094180082],
            [27.163877935944662, -3.850300232882306],
            [27.164424598524306, -3.849584030264872],
            [27.165090101927799, -3.848915573276178],
            [27.165399085554608, -3.84824711575577],
            [27.165826909106997, -3.84824711575577],
            [27.166349804959168, -3.848461977578517],
            [27.16665878858598, -3.848915573276178],
            [27.166920236062882, -3.849560156262311],
            [27.166254732659361, -3.849727270656734],
            [27.165399085554608, -3.850133119504145],
            [27.164709814525313, -3.850324106863837],
            [27.164353294748629, -3.850443474054358],
            [27.164495903198279, -3.851780384166317],
            [27.165803141481195, -3.852544332748509],
            [27.166539948660397, -3.853427646499725],
            [27.167918490718989, -3.854907792270525],
            [27.167958936466338, -3.854989042220155],
            [27.16844138657116, -3.855958216688479],
            [27.16903558530068, -3.856960893109924],
            [27.169297033675914, -3.857533850397938],
            [27.169653552554294, -3.857772582711315],
            [27.170081376106655, -3.857963568332642],
            [27.170437895883371, -3.857509977523812],
            [27.170889487061533, -3.856674414770276],
            [27.171103399286864, -3.856101455992834],
            [27.171412382913704, -3.856053709259984],
            [27.172481941345488, -3.856960893109924],
            [27.172630758950376, -3.857017451592113],
            [27.17336135697434, -3.85729511891891],
            [27.174003091853731, -3.857915822608105],
            [27.175167722585293, -3.85793969547073],
            [27.17599960206427, -3.857581597046528],
            [27.176546264643914, -3.857104132243063],
            [27.177188000421637, -3.857104132243063],
            [27.177235536571509, -3.857891948842521],
            [27.176974088196275, -3.858512652089924],
            [27.176546264643914, -3.859324340189038],
            [27.176023369690039, -3.860517998526463],
            [27.175809457464716, -3.861090953383071],
            [27.176879016794828, -3.862451720160922],
            [27.178400167303071, -3.865244865950323],
            [27.178590311004331, -3.866987593146816],
            [27.179659869436112, -3.868587079568114],
            [27.180658124092218, -3.869422631336713],
            [27.180943340093222, -3.869995580096909],
            [27.180800732541869, -3.872311245466754],
            [27.180967107719027, -3.873194538367183],
            [27.181109716168709, -3.873624248259791],
            [27.182916081779663, -3.87465077590086],
            [27.183866800285895, -3.875701175537738],
            [27.184888823466103, -3.876536720190012],
            [27.185530558345491, -3.876584465753905],
            [27.186148525599112, -3.876870937275321],
            [27.186338670198701, -3.877420008619445],
            [27.186338670198701, -3.87832716929655],
            [27.187289388704901, -3.879544672746248],
            [27.187004172703894, -3.880881536364554],
            [27.186433741600148, -3.882170653499581],
            [27.186148525599112, -3.882719721353492],
            [27.185910846646308, -3.883125553294016],
            [27.186291134048794, -3.883507513807566],
            [27.187075477377867, -3.883770110825941],
            [27.18759837233171, -3.884008835644328],
            [27.187883588332745, -3.884247560394308],
            [27.188002428258297, -3.884581774387953],
            [27.187479532406158, -3.885154712737329],
            [27.188097499659779, -3.885632161511804],
            [27.188097499659779, -3.886133482069372],
            [27.187479532406158, -3.88618122708345],
            [27.187133568732335, -3.886575041013743],
            [27.187123012629446, -3.886587057336931],
            [27.187455764780356, -3.887112250250436],
            [27.187740979883063, -3.887422591074635],
            [27.18778851603297, -3.887900038548123],
            [27.18843025181069, -3.887900038548123],
            [27.188596626987813, -3.887923910553678],
            [27.188691699287595, -3.888281995968698],
            [27.188549090837945, -3.888568464370155],
            [27.188691699287595, -3.889308506456959],
            [27.18916705898986, -3.88935625038657],
            [27.189262130391338, -3.888902676628655],
            [27.189048219064311, -3.888425229730644],
            [27.18916705898986, -3.887995527468542],
            [27.189547346392345, -3.888162634180807],
            [27.189880097644959, -3.888783314929832],
            [27.190307921197316, -3.88887880465114],
            [27.190569368674254, -3.888640081229551],
            [27.190569368674254, -3.888091017280306],
            [27.191234872077782, -3.887709059772036],
            [27.191472551928914, -3.887685186858039],
            [27.191496319554684, -3.888043272375817],
            [27.191187335927872, -3.888401357739427],
            [27.191020960750748, -3.888711698082777],
            [27.191234872077782, -3.889022038310328],
            [27.191781535555723, -3.888974293459286],
            [27.192185591482307, -3.88861620834227],
            [27.192185591482307, -3.887971655465049],
            [27.192283608459572, -3.887880239345443],
            [27.192518342734889, -3.88766131484564],
            [27.193041237688732, -3.887637441930218],
            [27.193255149914094, -3.887732931783112],
            [27.193088773838635, -3.888138762182084],
            [27.192819880226324, -3.888185731137423],
            [27.192542110360694, -3.888234251075138],
            [27.192447038959212, -3.888902676628655],
            [27.192494575109119, -3.889213016784975],
            [27.192898630137378, -3.888974293459286],
            [27.19313630998851, -3.888496846602355],
            [27.19333548624995, -3.888479451033928],
            [27.193682973466451, -3.888449102623408],
            [27.193691910805207, -3.888682491941308],
            [27.193706741092253, -3.889069783158674],
            [27.194229636944392, -3.889284633588864],
            [27.194498225129525, -3.889141815916318],
            [27.194633691972683, -3.889069783158674],
            [27.194633691972683, -3.888783314929832],
            [27.194633691972683, -3.888258123973385],
            [27.194633691972683, -3.887971655465049],
            [27.194942675599492, -3.887637441930218],
            [27.195322963900278, -3.887637441930218],
            [27.195322963900278, -3.888162634180807],
            [27.195489339077433, -3.888592336356576],
            [27.196083538705285, -3.888926548605445],
            [27.196321218556417, -3.888401357739427],
            [27.196939185810031, -3.888281995968698],
            [27.197462080763877, -3.888377484845302],
            [27.197723529139111, -3.88852071949307],
            [27.197794832914784, -3.889475612003156],
            [27.198293960242822, -3.890000803093097],
            [27.198650480019538, -3.889976930244874],
            [27.198935695122245, -3.889881441551877],
            [27.199434822450279, -3.890120164617155],
            [27.199886414526777, -3.890406631483219],
            [27.200195398153586, -3.890669227226751],
            [27.200599453181841, -3.891003438640954],
            [27.200385541854811, -3.891266033293709],
            [27.200314238079134, -3.891719606664664],
            [27.200385541854811, -3.892197050768698],
            [27.200979740584327, -3.892746112006457],
            [27.201336260361042, -3.892388028513993],
            [27.201360028885144, -3.891791223252644],
            [27.201597708736276, -3.891433139348756],
            [27.202001763764567, -3.891266033293709],
            [27.202286979765571, -3.891552500667197],
            [27.202239443615699, -3.892173178885824],
            [27.202500891092605, -3.892674495500764],
            [27.202762338569542, -3.892913217763907],
            [27.202928714644994, -3.893175811813234],
            [27.203641754198394, -3.892913217763907],
            [27.204069577750751, -3.893223556423],
            [27.203689290348265, -3.894082955320458],
            [27.203855665525428, -3.894584270782981],
            [27.204687545004372, -3.894560398066433],
            [27.204972760107083, -3.894250059906751],
            [27.205519423585024, -3.894250059906751],
            [27.205638263510604, -3.894321677178881],
            [27.205804639586059, -3.894990096934768],
            [27.205566959734927, -3.895372051999443],
            [27.206137390838677, -3.895944982913725],
            [27.206351303064, -3.896207576004497],
            [27.206161159362775, -3.896995355680756],
            [27.206316091799806, -3.897237416832354],
            [27.206375070689806, -3.897329564549713],
            [27.206588982915132, -3.897329564549713],
            [27.206615704201596, -3.897308690089495],
            [27.206802894242166, -3.897162460583208],
            [27.20694550179352, -3.89658952960688],
            [27.206993037943423, -3.896255320439994],
            [27.207397093870014, -3.896207576004497],
            [27.207801148898273, -3.896350808400407],
            [27.2077773812725, -3.897114716199898],
            [27.208300276226343, -3.897234076701891],
            [27.208751868302802, -3.896541786092866],
            [27.209322299406548, -3.896446297252139],
            [27.20955997925768, -3.896732762839161],
            [27.209464906957901, -3.897257948439299],
            [27.209132155705287, -3.897568285474694],
            [27.209138510387621, -3.897593814635558],
            [27.209274763256641, -3.898141214873111],
            [27.20977389058471, -3.898642528787239],
            [27.210106642735621, -3.898833505050064],
            [27.210653306213562, -3.898618656187391],
            [27.210368090212526, -3.898093471448369],
            [27.210082874211523, -3.897783134609368],
            [27.210082874211523, -3.897482873080139],
            [27.210082874211523, -3.897401180653981],
            [27.210320554062651, -3.897210204061472],
            [27.210819681390685, -3.897090843556096],
            [27.211199969691503, -3.896637274020393],
            [27.211722864645346, -3.896756634590997],
            [27.211865472196703, -3.89706697181384],
            [27.211812528188801, -3.897279678234002],
            [27.211770400795253, -3.897448925020804],
            [27.211199969691503, -3.897544413746191],
            [27.210890986064697, -3.897878622394036],
            [27.211271273467183, -3.898379935564601],
            [27.211746632271151, -3.898475424182855],
            [27.212317064273194, -3.898045727118607],
            [27.212649815525776, -3.897997982786147],
            [27.212935031526811, -3.898212831809553],
            [27.213053871452363, -3.899048352954869],
            [27.2133153189293, -3.899549665418638],
            [27.213529230256331, -3.899812257368761],
            [27.213814446257334, -3.899860001596835],
            [27.214052126108466, -3.899525793747093],
            [27.214052126108466, -3.89902448126896],
            [27.214313573585404, -3.898475424182855],
            [27.214622557212213, -3.898618656187391],
            [27.21512168454025, -3.899000608680104],
            [27.215787187943771, -3.899740641472615],
            [27.216975586301142, -3.899669025570299],
            [27.217498482153278, -3.8995974096618],
            [27.217498482153278, -3.899191584860489],
            [27.217141962376594, -3.898594784489079],
            [27.217284569927948, -3.897974111069998],
            [27.21773616200441, -3.897735390261769],
            [27.218710649034744, -3.897950238450915],
            [27.218758184286319, -3.898570911887844],
            [27.218972096511646, -3.899096097226923],
            [27.219399920064042, -3.898666400484127],
            [27.219946583541983, -3.898618656187391],
            [27.220659622197051, -3.898690272180391],
            [27.221111214273542, -3.898379935564601],
            [27.22087353442241, -3.897997982786147],
            [27.220326870944469, -3.897711517635803],
            [27.220065423467531, -3.896995355680756],
            [27.220421942345919, -3.896828250744691],
            [27.220730925972724, -3.896661145774976],
            [27.220968605823892, -3.896279192205556],
            [27.221004839370849, -3.896199790477193],
            [27.221230054199125, -3.895706261521928],
            [27.221515269301833, -3.895300434817908],
            [27.221824252928645, -3.895157202240795],
            [27.222204540331131, -3.895491412751975],
            [27.222050213358575, -3.8960769832257],
            [27.221990629004097, -3.896303064872679],
            [27.221729181527163, -3.897019227425072],
            [27.221848021452743, -3.897520541114767],
            [27.222323380256679, -3.897663774186341],
            [27.22287004373462, -3.89737730892067],
            [27.223321635811114, -3.897090843556096],
            [27.223535547138145, -3.896565657850235],
            [27.223844530764957, -3.895968854688193],
            [27.223983972653237, -3.895849809792463],
            [27.224319890467218, -3.8955630290148],
            [27.224747714019578, -3.895539156326368],
            [27.225208894713425, -3.895705908741443],
            [27.225341912749094, -3.895754005986202],
            [27.225508288824585, -3.896565657850235],
            [27.225627128750137, -3.896947611287853],
            [27.226221328377981, -3.897568285474694],
            [27.227076975482735, -3.898021855403857],
            [27.227528566660897, -3.897759261984775],
            [27.22798015783906, -3.897711517635803],
            [27.228345917686752, -3.897390076661988],
            [27.228360445241549, -3.89737730892067],
            [27.228336677615744, -3.896923739541488],
            [27.228075230138842, -3.89639855282766],
            [27.228075230138842, -3.895968854688193],
            [27.228455517541327, -3.895539156326368],
            [27.228954644869361, -3.895706261521928],
            [27.229643915898656, -3.896326936636931],
            [27.230261883152277, -3.896828250744691],
            [27.231046226481386, -3.89706697181384],
            [27.231664193735003, -3.89718633232269],
            [27.231901873586136, -3.897425053288841],
            [27.232068249661591, -3.898045727118607],
            [27.232068249661591, -3.898761888167209],
            [27.232305929512723, -3.899215457443862],
            [27.232876360616434, -3.899119968910771],
            [27.23330418416883, -3.898547040188221],
            [27.233589399271537, -3.898117343161071],
            [27.234231135049257, -3.898021855403857],
            [27.234397511124712, -3.898332192153574],
            [27.234088527497903, -3.898785760762934],
            [27.233779542972766, -3.899907745822135],
            [27.233830772096805, -3.90033223415278],
            [27.233874615272541, -3.900695521985293],
            [27.234658958601614, -3.901149089302279],
            [27.235063013629908, -3.900981985202878],
            [27.235276925855267, -3.900528417794483],
            [27.235421350698417, -3.900291052896229],
            [27.235538373332172, -3.900098721793723],
            [27.236037500660242, -3.900003234264542],
            [27.236171118770542, -3.900271640150612],
            [27.236441556586829, -3.900814881972087],
            [27.236679236437961, -3.901459424881972],
            [27.237059523840447, -3.901531040629662],
            [27.237629954944161, -3.901531040629662],
            [27.23772502724394, -3.9010774735216],
            [27.237439811242933, -3.900504546151168],
            [27.237525880626936, -3.900236563494335],
            [27.237677491094068, -3.899764514040186],
            [27.237891402421099, -3.899525793747093],
            [27.238770818049954, -3.899573537991679],
            [27.238392089224462, -3.900215438282595],
            [27.238342994497557, -3.90088649777545],
            [27.239056033152661, -3.90155491314567],
            [27.23950762522912, -3.901578784758782],
            [27.24019689625845, -3.901340064987986],
            [27.240933703437619, -3.90088649777545],
            [27.24148036691556, -3.900623906165417],
            [27.241813118168174, -3.900719393623137],
            [27.241836885793944, -3.901363937509503],
            [27.242383549271885, -3.901578784758782],
            [27.242953981273931, -3.90086262524018],
            [27.243565628879537, -3.900537395149033],
            [27.24376209222881, -3.900432930314817],
            [27.244380059482427, -3.900480673604906],
            [27.245284804009042, -3.900916384683695],
            [27.245425850288438, -3.901459424881972],
            [27.245283241838756, -3.902080095692806],
            [27.245592225465561, -3.902629150392337],
            [27.246067585167829, -3.902820125737013],
            [27.24659048102, -3.902223327074794],
            [27.247042072198163, -3.902223327074794],
            [27.246780624721225, -3.902867869791899],
            [27.24680439234703, -3.903393051507117],
            [27.24766003945178, -3.903488539548075],
            [27.248420614256752, -3.903440795528963],
            [27.248848437809116, -3.903440795528963],
            [27.249038581510373, -3.903918233791718],
            [27.249181189960023, -3.90441954331065],
            [27.249656549662287, -3.904467287273338],
            [27.249870460989321, -3.90441954331065],
            [27.249846693363551, -3.904013720869934],
            [27.249585244988317, -3.9035362835644],
            [27.249704084913866, -3.903082716651382],
            [27.250084372316351, -3.902581406323699],
            [27.250607268168523, -3.902342686841633],
            [27.251063544060884, -3.902202659351787],
            [27.251462915273272, -3.902080095692806],
            [27.252271026228154, -3.901912991781058],
            [27.252722617406317, -3.901960735888208],
            [27.252841457331865, -3.902151711386898],
            [27.25270880401218, -3.902568066639262],
            [27.25265131363064, -3.902748510100693],
            [27.253411889333911, -3.903345308384757],
            [27.253958551913556, -3.902867869791899],
            [27.255788686048639, -3.902939485417914],
            [27.256477957077937, -3.90284399821591],
            [27.256882013004525, -3.902772381679417],
            [27.257476212632337, -3.903655643142162],
            [27.25847446728844, -3.903393051507117],
            [27.259258810617517, -3.903011101037746],
            [27.259829241721263, -3.902987229465892],
            [27.260684888826017, -3.903082716651382],
            [27.261112712378406, -3.902557534739504],
            [27.261158844461484, -3.902294975237311],
            [27.261255319929759, -3.901745888737894],
            [27.261445463630988, -3.901316193367991],
            [27.261730679632027, -3.90086262524018],
            [27.261516767406665, -3.900456801960193],
            [27.261136480004179, -3.900313570273037],
            [27.260542280376363, -3.900146466005283],
            [27.260375905199204, -3.899382561899192],
            [27.260803728751597, -3.899167713178715],
            [27.261112712378406, -3.899239329124313],
            [27.261469231256793, -3.898905121024515],
            [27.262348646885645, -3.899000608680104],
            [27.26310922169062, -3.900146466005283],
            [27.262847774213682, -3.900981985202878],
            [27.262728934288134, -3.901244577601739],
            [27.262871541839488, -3.901531040629662],
            [27.263085454064814, -3.901817504460853],
            [27.264297620047948, -3.902724638521307],
            [27.264250084796377, -3.903225948762302],
            [27.263727188944237, -3.903607899132656],
            [27.263703421318432, -3.904300183842961],
            [27.264701675974536, -3.904109208839368],
            [27.266056450407358, -3.904658262194427],
            [27.26679325758656, -3.905111827342708],
            [27.26700716891359, -3.905469905343296],
            [27.266389201659972, -3.905756367812764],
            [27.266698185286781, -3.906448650727429],
            [27.266959763917729, -3.90664664281461],
            [27.268338175720608, -3.907689984408348],
            [27.268908606824318, -3.90847775317178],
            [27.26952657407794, -3.908525495998259],
            [27.269835557704749, -3.90847775317178],
            [27.270334685931147, -3.908143547895959],
            [27.271129489243393, -3.908143547895959],
            [27.271237868287475, -3.908143547895959],
            [27.271903371690968, -3.90819129164396],
            [27.273472058349117, -3.907976446109686],
            [27.275302191585904, -3.907976446109686],
            [27.276775805944276, -3.909814570218648],
            [27.277417541721995, -3.910530721996187],
            [27.277274933272313, -3.911437846510449],
            [27.277322469422216, -3.912058509841115],
            [27.278582172453557, -3.91215399598019],
            [27.279105067407396, -3.912631429216867],
            [27.279794338436695, -3.912535942230695],
            [27.280554914139994, -3.913275962927239],
            [27.280602449391573, -3.9142308278288],
            [27.280721289317121, -3.914636644356075],
            [27.280602449391573, -3.915209562846908],
            [27.279841874586598, -3.915806351240897],
            [27.279556658585562, -3.916379268920548],
            [27.279105067407396, -3.916450883377009],
            [27.278487100153775, -3.916450883377009],
            [27.278225652676838, -3.91688057088757],
            [27.278154348901165, -3.917381872550278],
            [27.277968792896083, -3.917535825166907],
            [27.27760768542322, -3.917835430720384],
            [27.277441309347765, -3.918169632077672],
            [27.277726525348804, -3.918527703521407],
            [27.278130580377063, -3.918169632077672],
            [27.278415796378102, -3.917883173908581],
            [27.279105067407396, -3.918050274594471],
            [27.279556658585562, -3.918050274594471],
            [27.279556658585562, -3.91757657790912],
            [27.279556658585562, -3.917501230130041],
            [27.279627963259568, -3.916999928539838],
            [27.280317234288866, -3.916665726709104],
            [27.280745057841223, -3.917143157338896],
            [27.280558050158628, -3.91760227787624],
            [27.280531145615893, -3.917668329991035],
            [27.280127090587602, -3.918145760041063],
            [27.280127090587602, -3.918670932957607],
            [27.280578681765768, -3.918814161466777],
            [27.280840129242705, -3.918503832397362],
            [27.281600704945973, -3.918575446669567],
            [27.281838383898808, -3.918479961272694],
            [27.281838383898808, -3.917883173908581],
            [27.281430875746576, -3.917624679296843],
            [27.281386792720646, -3.917596715640155],
            [27.281386792720646, -3.917143157338896],
            [27.281933456198587, -3.917214771729101],
            [27.28259895960208, -3.917071542942471],
            [27.283549678108312, -3.916498625743033],
            [27.284167645361929, -3.91640314010599],
            [27.28507082861659, -3.916641855531283],
            [27.285593724468725, -3.916713469964971],
            [27.286259226973918, -3.916713469964971],
            [27.286591979124832, -3.917262514953187],
            [27.287043570302991, -3.91769220204141],
            [27.287661537556613, -3.917286386113096],
            [27.288231968660359, -3.917572844489203],
            [27.288707328362623, -3.918074145731607],
            [27.288517184661366, -3.918432218118973],
            [27.288422112361584, -3.919148361525598],
            [27.288634981642883, -3.919445299513551],
            [27.28884993591398, -3.919745147974907],
            [27.28982442294431, -3.920103219637349],
            [27.290180942720994, -3.920246447897927],
            [27.290513693973608, -3.919959990449677],
            [27.290513693973608, -3.919363205057928],
            [27.290550118861749, -3.919290039025001],
            [27.290727606198935, -3.918933518839524],
            [27.29148818100391, -3.918742547215296],
            [27.291541829290999, -3.919209525254446],
            [27.291559484779587, -3.919363205057928],
            [27.291298037302685, -3.919840634127633],
            [27.291464413378137, -3.920365805063467],
            [27.291773397004945, -3.920532905246702],
            [27.292367596632761, -3.920318062018904],
            [27.292676580259574, -3.919936119367107],
            [27.292676580259574, -3.919196104637844],
            [27.292717450910082, -3.919114008352982],
            [27.292795420185154, -3.918957389951089],
            [27.293793674841258, -3.918957389951089],
            [27.294482945870556, -3.918670932957607],
            [27.29517221689985, -3.9177876875294],
            [27.29588525645325, -3.917334129333036],
            [27.296122936304382, -3.917119286174827],
            [27.296550759856775, -3.917429615764684],
            [27.296859743483584, -3.918050274594471],
            [27.297263798511842, -3.918193503211322],
            [27.298095677990819, -3.918026402554426],
            [27.29864234146876, -3.917238642890383],
            [27.298832485169989, -3.916952185300548],
            [27.299569292349194, -3.916904442058497],
            [27.300234794854386, -3.916952185300548],
            [27.300662618406779, -3.916832827641372],
            [27.300900298257911, -3.916498625743033],
            [27.301185514258915, -3.916236039086791],
            [27.301637105437081, -3.915997323544224],
            [27.302373912616282, -3.915997323544224],
            [27.302516521065932, -3.916522497827249],
            [27.302587824841609, -3.916808955566125],
            [27.303015648394002, -3.916785084392439],
            [27.303324632020811, -3.916164424611717],
            [27.303966366900198, -3.916212167896514],
            [27.304013903050109, -3.916737341140719],
            [27.303514775722039, -3.916928313228748],
            [27.303182023571125, -3.917023799707316],
            [27.303110719795448, -3.917525101283067],
            [27.302944343719993, -3.918050274594471],
            [27.302825504692741, -3.918193503211322],
            [27.30288204645338, -3.918288149569919],
            [27.303110719795448, -3.918670932957607],
            [27.303443471946359, -3.918694804076817],
            [27.303814638753781, -3.91821237780892],
            [27.30384752697465, -3.918169632077672],
            [27.303946187145673, -3.918201690022975],
            [27.304655637929532, -3.918432218118973],
            [27.305012157706212, -3.918241246378821],
            [27.305085229366377, -3.91810914494237],
            [27.305249837557344, -3.917811559576352],
            [27.305226069931575, -3.917405743706701],
            [27.305226069931575, -3.916999928539838],
            [27.305368677482928, -3.916832827641372],
            [27.306034180886417, -3.916832827641372],
            [27.306485772064583, -3.917811559576352],
            [27.306770988065619, -3.917477358074119],
            [27.30719881161798, -3.91688057088757],
            [27.307721706571822, -3.916641855531283],
            [27.308268370049763, -3.916594112271268],
            [27.308410977601117, -3.917310258174539],
            [27.30919532093019, -3.918002531415929],
            [27.309718216782361, -3.917978659374524],
            [27.310217344110431, -3.917596715640155],
            [27.310383719287557, -3.916999928539838],
            [27.31074023906427, -3.916307653555669],
            [27.311595886169023, -3.915901837849193],
            [27.31202370972138, -3.915472149829501],
            [27.312499069423644, -3.91537666317155],
            [27.312499069423644, -3.915997323544224],
            [27.31285558920036, -3.916450883377009],
            [27.313021964377487, -3.916665726709104],
            [27.313473556453982, -3.916140553419366],
            [27.313687467781008, -3.915758607932665],
            [27.314234131258953, -3.915734736728572],
            [27.31428166740886, -3.916164424611717],
            [27.31428166740886, -3.916594112271268],
            [27.314757026212796, -3.917023799707316],
            [27.315683977991551, -3.917334129333036],
            [27.315802817018806, -3.916952185300548],
            [27.315897889318585, -3.916212167896514],
            [27.316373249020849, -3.9156153788935],
            [27.316848607824781, -3.915806351240897],
            [27.31680107257321, -3.916498625743033],
            [27.31691991249879, -3.9169760564694],
            [27.317680487303765, -3.916928313228748],
            [27.318108310856122, -3.91688057088757],
            [27.318512365884413, -3.916546369008556],
            [27.31889265418523, -3.916450883377009],
            [27.319082797886459, -3.916713469964971],
            [27.319082797886459, -3.917095414107889],
            [27.318821349511225, -3.917763816384007],
            [27.318369758333059, -3.91809801686803],
            [27.318441062108736, -3.918551575546947],
            [27.31889265418523, -3.918336731803314],
            [27.319106565512261, -3.91809801686803],
            [27.319700765140077, -3.918241246378821],
            [27.320009748766886, -3.918575446669567],
            [27.320199892468146, -3.919243847747367],
            [27.320936699647312, -3.920055476577544],
            [27.320794092095959, -3.9210342046911],
            [27.320223660093916, -3.921440017874251],
            [27.3203425000195, -3.921917445742126],
            [27.321031771048794, -3.921726474808588],
            [27.32155466690093, -3.922180030590758],
            [27.322291474080135, -3.922943914541699],
            [27.322766833782399, -3.922776814846934],
            [27.323313496362012, -3.922012931643436],
            [27.323479872437463, -3.921607117839885],
            [27.323978999765533, -3.921463889815559],
            [27.32438305569212, -3.921941317669617],
            [27.324977255319972, -3.922394873333649],
            [27.325191166647002, -3.92265745803025],
            [27.325405077974033, -3.923325855800667],
            [27.326260725078786, -3.924113609652336],
            [27.327306515884761, -3.924972976467845],
            [27.327781875587029, -3.925378787712308],
            [27.328209699139418, -3.925354916786603],
            [27.328423611364748, -3.924972976467845],
            [27.329065346244171, -3.924471678515839],
            [27.32916041854395, -3.923731667856083],
            [27.328851434018809, -3.923158756183304],
            [27.328994042468494, -3.922561973105803],
            [27.329469402170758, -3.922323259392972],
            [27.329968529498828, -3.923206499063446],
            [27.330443888302764, -3.924280708173896],
            [27.331014320304806, -3.924352322846775],
            [27.331703591334101, -3.923803282576658],
            [27.332559238438854, -3.923588440200777],
            [27.333676333020541, -3.924089737787757],
            [27.334555747751097, -3.924328450989091],
            [27.33491226752778, -3.924853619969139],
            [27.335102411229038, -3.925092332949248],
            [27.335007339827559, -3.925426530463892],
            [27.334745891452325, -3.925880084210303],
            [27.334032852797257, -3.925903956023002],
            [27.333937780497479, -3.92652460847537],
            [27.334199227974381, -3.926954290737889],
            [27.334603283900972, -3.927121388683374],
            [27.335268787304496, -3.927002032495918],
            [27.335696610856854, -3.926906548074826],
            [27.335720378482659, -3.926262024108567],
            [27.336171969660821, -3.925474273212677],
            [27.336980081513996, -3.924853619969139],
            [27.337502976467835, -3.924567164121319],
            [27.337978336170103, -3.924829748125997],
            [27.338358623572589, -3.925665243278026],
            [27.33840615972246, -3.926166539601689],
            [27.337859496244519, -3.926262024108567],
            [27.336885009214217, -3.926357509506598],
            [27.336861241588412, -3.927049775153434],
            [27.336789937812739, -3.927670426742434],
            [27.337336600392383, -3.928219464435463],
            [27.337811960094648, -3.92919818285409],
            [27.33826355127281, -3.929866575317803],
            [27.338786447124981, -3.930534967238761],
            [27.33930934207882, -3.931084002118983],
            [27.340117453931999, -3.931680779924003],
            [27.340640348885838, -3.931752393051056],
            [27.341757443467493, -3.932182072584773],
            [27.342565554422372, -3.932540138841774],
            [27.343944097379296, -3.933447239148083],
            [27.344775975959944, -3.933709820320286],
            [27.345441479363437, -3.934354337551556],
            [27.345988142841378, -3.93487950013491],
            [27.346606110094996, -3.935261435856355],
            [27.347319149648392, -3.935237565217319],
            [27.347723204676683, -3.935094338661747],
            [27.348982907708024, -3.934712402862659],
            [27.350955649394464, -3.934712402862659],
            [27.352500567528512, -3.934712402862659],
            [27.35416432558814, -3.935165952393755],
            [27.355495331496826, -3.934831757931731],
            [27.356826338303843, -3.934998855179733],
            [27.357373001781784, -3.935380790845696],
            [27.35832372028802, -3.935356920210095],
            [27.359155599766996, -3.935380790845696],
            [27.359559655693584, -3.934998855179733],
            [27.359583423319357, -3.934497564236029],
            [27.360248926722882, -3.934211111744317],
            [27.360557910349691, -3.934115628159686],
            [27.360684588974415, -3.934766096045259],
            [27.361324812887521, -3.935354756713814],
            [27.361739605478384, -3.935119292857851],
            [27.361965036800623, -3.934412899080864],
            [27.362668381735482, -3.93424082873307],
            [27.36296595046997, -3.934883828032252],
            [27.364075070706861, -3.935535883196742],
            [27.365012863354455, -3.936468683184851],
            [27.364895639498084, -3.937238468741527],
            [27.365130087210826, -3.938062591621114],
            [27.365716207391014, -3.938234661168655],
            [27.366356431304087, -3.9376460025633],
            [27.367357344973467, -3.937709396073644],
            [27.367536056714396, -3.937888880925079],
            [27.367997568886537, -3.938352392658655],
            [27.368529586232103, -3.938877657342446],
            [27.36922391297983, -3.938823319352128],
            [27.369547173531444, -3.93849865907772],
            [27.369755930325361, -3.93828899919794],
            [27.369927257914686, -3.937591664491459],
            [27.369990378038107, -3.936704147556406],
            [27.370278930382096, -3.936233219648062],
            [27.370278930382096, -3.935526826828422],
            [27.371270825864315, -3.935526826828422],
            [27.37197417079917, -3.935707953273476],
            [27.372677515734026, -3.935707953273476],
            [27.37356120464867, -3.935526826828422],
            [27.374841652474885, -3.935880023314156],
            [27.375427772655069, -3.93559022140452],
            [27.375779445122479, -3.935409094933538],
            [27.376545910180788, -3.93594341786299],
            [27.377709134150596, -3.936405289578784],
            [27.378412478187151, -3.937229412391961],
            [27.379061719389053, -3.937582608145836],
            [27.379115823122007, -3.937935803747821],
            [27.380116736791354, -3.937464876545484],
            [27.380522512093386, -3.936586414927959],
            [27.381514408473901, -3.936350951424898],
            [27.381541460340394, -3.93581662876045],
            [27.382190701542296, -3.935345700343497],
            [27.383065373168144, -3.935291363021771],
            [27.384066286837491, -3.935409094933538],
            [27.385058182319714, -3.935345700343497],
            [27.386050078700229, -3.935345700343497],
            [27.386582096045792, -3.935345700343497],
            [27.387050992369577, -3.936224163287466],
            [27.386636198880417, -3.936758484784713],
            [27.386230423578347, -3.937401482114076],
            [27.38587875111094, -3.938524462145498],
            [27.385995975865608, -3.939520653012767],
            [27.386582096045792, -3.939574990956915],
            [27.387808440139054, -3.939520653012767],
            [27.38891756037594, -3.939457258740006],
            [27.390441473203722, -3.938931995329162],
            [27.391262041994949, -3.939991579036187],
            [27.391902265908058, -3.940453448475506],
            [27.392136714519097, -3.940109310274274],
            [27.392199834642547, -3.939285190350848],
            [27.393191731023066, -3.939982522717027],
            [27.394075420836042, -3.940399111491657],
            [27.3953017649293, -3.940987768123287],
            [27.39652810902259, -3.941983956001216],
            [27.397348677813817, -3.942744680098116],
            [27.398052022748672, -3.943451065805693],
            [27.399043918230859, -3.944682712775241],
            [27.399539866421133, -3.945189859981408],
            [27.399575935576426, -3.946276605258071],
            [27.399350504254183, -3.947046381613938],
            [27.39898981539627, -3.947625977239516],
            [27.399287384130762, -3.948069729919597],
            [27.400008762744946, -3.948169348442763],
            [27.400243211355988, -3.948893841917615],
            [27.400243211355988, -3.949790402776914],
            [27.401190021292415, -3.949917188817571],
            [27.401947469061891, -3.949618335653859],
            [27.403056589298778, -3.949681728238852],
            [27.403669761345427, -3.950170760839957],
            [27.4044362264037, -3.950677905551399],
            [27.405455174650712, -3.951194106144114],
            [27.405806847118118, -3.95179181121204],
            [27.405987191097946, -3.952443852934603],
            [27.405987191097946, -3.952969108589358],
            [27.407213536089532, -3.954264133477307],
            [27.408300239766817, -3.954829741895746],
            [27.408448897471622, -3.954907116173128],
            [27.410549914089025, -3.955196912156628],
            [27.410667137945399, -3.95596668012457],
            [27.41213694793856, -3.957026241800732],
            [27.412605844262341, -3.957316036130929],
            [27.413074740586158, -3.957316036130929],
            [27.413246068175447, -3.956491933517035],
            [27.414301084679416, -3.956437596694873],
            [27.414652757146829, -3.957252644137442],
            [27.414589636125076, -3.958194475525053],
            [27.413714964499263, -3.958728782695683],
            [27.413246068175447, -3.95967061328402],
            [27.4133091882989, -3.960367928291163],
            [27.413430095247939, -3.96038076181709],
            [27.413602467577885, -3.960399058049062],
            [27.41441830853579, -3.960485656599527],
            [27.415761877383748, -3.960132471623547],
            [27.416880014909466, -3.960666777526598],
            [27.418394910448388, -3.961717277930879],
            [27.418232600147928, -3.96270438451097],
            [27.418169480024474, -3.963075680502069],
            [27.417610410812451, -3.963546592973973],
            [27.416852963043009, -3.964723873415855],
            [27.41732185936679, -3.965131392652507],
            [27.418250634725556, -3.965013665014223],
            [27.419422875984228, -3.965013665014223],
            [27.420658237366315, -3.966073214951416],
            [27.42165013374683, -3.966535069667718],
            [27.42247070253806, -3.96700598104476],
            [27.423291270430955, -3.967476891247669],
            [27.423534736330858, -3.967648953707725],
            [27.423899934731498, -3.967920633149155],
            [27.424400390667873, -3.968536437984053],
            [27.424436459823166, -3.968780948226736],
            [27.424211029399221, -3.969632207307437],
            [27.423651960187229, -3.97018461986008],
            [27.422912546995381, -3.970872869902107],
            [27.422725833061907, -3.97124789985986],
            [27.42254283995031, -3.971615456079856],
            [27.422353477783393, -3.972729333174715],
            [27.422605960972092, -3.97372548146381],
            [27.423904443375932, -3.974096773336472],
            [27.424304147863278, -3.974096773336472],
            [27.424887321569319, -3.974096773336472],
            [27.425996441806205, -3.974404673477293],
            [27.426248924994908, -3.9748393556715],
            [27.426312045118362, -3.97588983780983],
            [27.426312045118362, -3.976451301129301],
            [27.427240820477127, -3.976822591758099],
            [27.427389797982165, -3.977506298311722],
            [27.428331553996792, -3.978710027973991],
            [27.429444537887729, -3.978538067089426],
            [27.429444537887729, -3.979655814895338],
            [27.430814364491411, -3.979655814895338],
            [27.431413663855114, -3.981375424249633],
            [27.432612262582523, -3.981117482852953],
            [27.434238931000696, -3.980773561164063],
            [27.435951214255333, -3.97999973705733],
            [27.436721741495351, -3.980343659073741],
            [27.438177182935537, -3.981461404396264],
            [27.439033324113694, -3.982235227110804],
            [27.440060694066457, -3.982235227110804],
            [27.44245789062294, -3.983352970732595],
            [27.443913331164833, -3.984728652245203],
            [27.444255787815756, -3.985846391531923],
            [27.445111929892207, -3.987222068818045],
            [27.444512630528536, -3.987823926220548],
            [27.446053685008533, -3.989457538980813],
            [27.447166669797799, -3.990231354070241],
            [27.447166669797799, -3.991349086675468],
            [27.445882457132221, -3.991349086675468],
            [27.446139299845004, -3.993154650154558],
            [27.446452757081925, -3.993644327846336],
            [27.446909827085019, -3.994358356603981],
            [27.447650887787081, -3.994110283374914],
            [27.447937197037785, -3.994014440529265],
            [27.447937197037785, -3.992208878966537],
            [27.449050180928719, -3.992036920942156],
            [27.450077550881517, -3.994014440529265],
            [27.451618605361517, -3.995476082612458],
            [27.451618605361517, -3.996593807979798],
            [27.452395847508267, -3.996621685034919],
            [27.459398160350759, -3.979898115115404],
            [27.463802039640047, -3.976902749827721],
            [27.477225271181567, -3.976908323389355],
            [27.495230186454872, -3.981411227284118],
            [27.510287897265925, -3.987411442086845],
            [27.531312486790394, -3.993414140314248],
            [27.553686044935972, -3.993423329557363],
            [27.580569214978112, -3.994932639224971],
            [27.597331163732136, -4.00992466375386],
            [27.61846135021824, -4.020422528335901],
            [27.63639623552692, -4.021928400980551],
            [27.685441079885223, -4.014456029939646],
            [27.721132560071556, -4.009975034859841],
            [27.767229480417065, -4.003999797760774],
            [27.79855127299043, -4.004012562035199],
            [27.818296493565335, -4.019005462572991],
            [27.837782067785447, -4.022388089443514],
            [27.834876720323884, -4.029171006086203],
            [27.827117280410484, -4.044187562760342],
            [27.828129599989012, -4.054372167885617],
            [27.823262039994454, -4.058726531957429],
            [27.822326399710267, -4.070361723387803],
            [27.833587200411621, -4.079111240806179],
            [27.834173140928755, -4.088351814891156],
            [27.834196704636952, -4.088347589747841],
            [27.83514742404148, -4.088562388285144],
            [27.834695831965021, -4.089206781743106],
            [27.834476475050717, -4.089573891552826],
            [27.834268008412625, -4.089922774660195],
            [27.835171191667285, -4.089994373735838],
            [27.836502198474303, -4.090352369918845],
            [27.837167700979496, -4.091426356593323],
            [27.838451171636638, -4.092285545243089],
            [27.839092907414358, -4.092333278118898],
            [27.839853482219333, -4.091927549935511],
            [27.840637825548406, -4.091593421376705],
            [27.841469704129057, -4.091855951034939],
            [27.842230279832361, -4.092524208691363],
            [27.842444191159391, -4.093574326466264],
            [27.841778687755866, -4.094290314524968],
            [27.842372887383714, -4.094815372864103],
            [27.843014622263105, -4.095006302836728],
            [27.843656358040825, -4.094934704215167],
            [27.844369397594225, -4.095101768256729],
            [27.84453577277138, -4.095579092477553],
            [27.845320116100456, -4.09603255143785],
            [27.845866779578397, -4.09612801583179],
            [27.846460978307913, -4.096175748475419],
            [27.847174017861313, -4.097058797803131],
            [27.846722426683147, -4.097225861395267],
            [27.845843011054296, -4.097297459809061],
            [27.845843011054296, -4.098037311208],
            [27.846128227055331, -4.098466902053718],
            [27.846698658159049, -4.098896492665539],
            [27.84736416156257, -4.099159019895967],
            [27.848148504891647, -4.099278350590361],
            [27.848885312070813, -4.099111287432727],
            [27.849717190651464, -4.098681697839867],
            [27.850162818812795, -4.098809545531192],
            [27.850881821383059, -4.099015823399652],
            [27.851666164712135, -4.09954087769372],
            [27.852260364339948, -4.100495522281451],
            [27.852618425625682, -4.100655318445602],
            [27.852902099219371, -4.100781915612887],
            [27.853733978698319, -4.101378566774771],
            [27.854304409802062, -4.101617227473926],
            [27.85456585727897, -4.101951351790166],
            [27.85456585727897, -4.10235707482141],
            [27.854161802250708, -4.103144653696543],
            [27.854161802250708, -4.104170890808737],
            [27.85456585727897, -4.104815272428292],
            [27.855231360682492, -4.104982333475221],
            [27.855920631711786, -4.105125529789889],
            [27.856372223788284, -4.105960837047469],
            [27.85677627881654, -4.105984703523082],
            [27.857418014594259, -4.105889239420327],
            [27.858107285623554, -4.106008569095978],
            [27.85835271344402, -4.106154192552009],
            [27.858630180577396, -4.106318825987577],
            [27.859010467979882, -4.107106400902587],
            [27.859153076429568, -4.10815649926323],
            [27.858511340651845, -4.108419023409042],
            [27.858297429324818, -4.10894407234002],
            [27.858440036876171, -4.109636180980314],
            [27.858844092802759, -4.11013736275032],
            [27.859366987756598, -4.110543080662653],
            [27.859984955010216, -4.111068128176453],
            [27.860412778562576, -4.11156930903429],
            [27.861720016845524, -4.112046624183701],
            [27.862623200100149, -4.112118221250721],
            [27.863716527056031, -4.112356878695075],
            [27.864500870385108, -4.113335373098827],
            [27.864904925413398, -4.113884284082501],
            [27.865451588891339, -4.114385463145461],
            [27.866592451997128, -4.114457059999524],
            [27.867469496971939, -4.113350601714231],
            [27.867519402877555, -4.113287641494782],
            [27.867757082728691, -4.11309671595146],
            [27.869848664340676, -4.113072849691514],
            [27.870918222772463, -4.113120581308664],
            [27.871702566101536, -4.113311506846158],
            [27.873318788011261, -4.113359238448816],
            [27.874245738891688, -4.113192178277914],
            [27.874887473771111, -4.114194537868772],
            [27.874646371338738, -4.114553195058329],
            [27.874245738891688, -4.115149163788441],
            [27.874578490144302, -4.115888998416888],
            [27.875481673398962, -4.116461772872802],
            [27.876479928055062, -4.116008326575718],
            [27.876931520131524, -4.115769670239915],
            [27.877644558786628, -4.115316223543417],
            [27.877727779612862, -4.115286976881427],
            [27.878119918488888, -4.115149163788441],
            [27.878619045816926, -4.115173029083306],
            [27.879783676548485, -4.115554880016938],
            [27.880377876176336, -4.1155787452995],
            [27.880995843429954, -4.115769670239915],
            [27.881613810683575, -4.115769670239915],
            [27.882255545562998, -4.115984461306223],
            [27.882778441415134, -4.115769670239915],
            [27.883372640144653, -4.115698073505441],
            [27.8842282872494, -4.11615151998159],
            [27.884355944139497, -4.116373700171488],
            [27.884584807026119, -4.116772025641487],
            [27.88513147050406, -4.117177741031983],
            [27.88598711760881, -4.117416396940028],
            [27.886557548712556, -4.117702783212362],
            [27.887246819741854, -4.118227825943777],
            [27.887294355891726, -4.118919926410733],
            [27.887579571892765, -4.11934950585957],
            [27.888340146697736, -4.118991522851528],
            [27.888981882475459, -4.119254043379242],
            [27.889647384980652, -4.119516564721178],
            [27.890217816982695, -4.119826816283046],
            [27.891120999339019, -4.119802950227571],
            [27.891151915757828, -4.119786393991152],
            [27.891834038892419, -4.11942110226118],
            [27.892428238520267, -4.119325640691585],
            [27.892832293548526, -4.120232529193244],
            [27.893141277175335, -4.12073370420573],
            [27.893474029326246, -4.121115552435534],
            [27.893759244428953, -4.12159286088306],
            [27.893790583954292, -4.121769868318089],
            [27.893949388130213, -4.122666805857781],
            [27.894258371757022, -4.12350209447525],
            [27.894282140281124, -4.124098729301665],
            [27.894638659159508, -4.125363592549877],
            [27.895137787385877, -4.125721572650333],
            [27.896017202116433, -4.125912495123325],
            [27.896373721893116, -4.125339727564863],
            [27.896468793294595, -4.124647632760643],
            [27.896373721893116, -4.124050998351835],
            [27.896944152996859, -4.123788479428978],
            [27.897823567727382, -4.123597556438777],
            [27.897823567727382, -4.122786132986456],
            [27.898750518607809, -4.12214176609563],
            [27.899178342160205, -4.122523612738235],
            [27.899249645935878, -4.123454363489149],
            [27.899748773263916, -4.123716883425853],
            [27.900747028818351, -4.123406633402102],
            [27.90155513977323, -4.123191844366541],
            [27.902529626803531, -4.122929325156097],
            [27.902743958542136, -4.122795746481101],
            [27.903218897832826, -4.122499747666748],
            [27.90376556131077, -4.122523612738235],
            [27.90388440123635, -4.123287306367826],
            [27.904169616339061, -4.123907806386984],
            [27.904787583592679, -4.124289652169835],
            [27.905619463071659, -4.124050998351835],
            [27.906427574026502, -4.124528305915191],
            [27.90709307743003, -4.124599901844221],
            [27.907829884609196, -4.124647632760643],
            [27.908542923264299, -4.124862420495459],
            [27.909255962817696, -4.124719228678771],
            [27.90992146622122, -4.124313517186845],
            [27.910586969624713, -4.124098729301665],
            [27.91151392050514, -4.124456709979608],
            [27.911989279309108, -4.125148804952346],
            [27.91222695916024, -4.126270474973077],
            [27.91220948692796, -4.126489774035952],
            [27.912131887758758, -4.127463739056004],
            [27.912797391162282, -4.12808423576923],
            [27.913605502117129, -4.128728597775551],
            [27.914247236996555, -4.128704731990984],
            [27.914247236996555, -4.128012640158471],
            [27.914366076922104, -4.126938703408078],
            [27.914385974605679, -4.126852125583685],
            [27.914508684473457, -4.126318205787759],
            [27.915483171503791, -4.125124939058774],
            [27.916410122384221, -4.124814689592129],
            [27.917265769488971, -4.125196535835347],
            [27.918168952743628, -4.125172669943225],
            [27.919024599848377, -4.124456709979608],
            [27.919214743549606, -4.124599901844221],
            [27.919618798577897, -4.124623766851805],
            [27.920165462055838, -4.124671497766738],
            [27.920902269235039, -4.124695363674101],
            [27.921686612564113, -4.124838555495153],
            [27.922280812191929, -4.125268131703374],
            [27.923065154622705, -4.125411323419799],
            [27.923115419854426, -4.125423941427485],
            [27.924015874027234, -4.125649976823716],
            [27.924348625279816, -4.126079552587296],
            [27.924633841280855, -4.127225086204384],
            [27.925109200983119, -4.127439874134894],
            [27.925846008162324, -4.127177356346922],
            [27.926368903116163, -4.126676185452198],
            [27.926749190518649, -4.126676185452198],
            [27.927438461547943, -4.126819376911381],
            [27.927937589774309, -4.127225086204384],
            [27.928484252353922, -4.127606931273265],
            [27.929244828057225, -4.127630796189287],
            [27.929934099086523, -4.127010299116977],
            [27.930670906265725, -4.126485262263251],
            [27.931669160921828, -4.126867107692666],
            [27.932928863953165, -4.127630796189287],
            [27.93368943875814, -4.127988775254065],
            [27.934806533339831, -4.127702391834918],
            [27.935156600517828, -4.126662536486032],
            [27.935376964443545, -4.126007956793375],
            [27.936589131325007, -4.125912495123325],
            [27.937040722503173, -4.126103417549792],
            [27.937777529682339, -4.126198879196598],
            [27.938318106175917, -4.1262189819383],
            [27.938419265460059, -4.126222744155506],
            [27.939369983966294, -4.126652319605127],
            [27.940130559669598, -4.127010299116977],
            [27.941223885727148, -4.127320547714541],
            [27.942245908907356, -4.127201221276009],
            [27.942031997580326, -4.126676185452198],
            [27.941532870252292, -4.126270474973077],
            [27.940796063073087, -4.125817034343626],
            [27.940724758399114, -4.125053343177681],
            [27.941366494176837, -4.124957882293381],
            [27.941675477803646, -4.124552170924937],
            [27.941675477803646, -4.123840528253395],
            [27.941675477803646, -4.12374074846028],
            [27.941271421877058, -4.122595209752268],
            [27.941366494176837, -4.122117901012514],
            [27.942103301356003, -4.121473533572876],
            [27.94272126860962, -4.121211013787466],
            [27.943481843414595, -4.121282610019298],
            [27.943790827041408, -4.12214176609563],
            [27.943723467768148, -4.12234467249043],
            [27.966894812531034, -4.105019344192539],
            [27.985677287954701, -4.109031409830192],
            [27.983120930591113, -4.111445283430271],
            [28.003427074500816, -4.118852241046352],
            [28.008659681979069, -4.119434304862425],
            [28.025558416303056, -4.121314080789247],
            [28.036212967375359, -4.122530346155544],
            [28.033647970015394, -4.133875905276841],
            [28.030797630890227, -4.137379750164],
            [28.030592441306279, -4.137817557279798],
            [28.03014085012812, -4.138414181196414],
            [28.029760562725631, -4.139488102196497],
            [28.027882892440672, -4.141230237948606],
            [28.026124062979594, -4.141970047944738],
            [28.024935663723934, -4.142375750281334],
            [28.023697758312963, -4.142620837710574],
            [28.023248138038532, -4.142709857239875],
            [28.021750756054356, -4.143282612079858],
            [28.020063229470626, -4.143903096241051],
            [28.017757736531607, -4.144619039307245],
            [28.017044696978207, -4.145287252062596],
            [28.016640641949952, -4.145836140651362],
            [28.016616873425814, -4.146313434017243],
            [28.016830785651177, -4.146957780995978],
            [28.017282376829339, -4.147960096458027],
            [28.017757736531607, -4.148747629517943],
            [28.01832816763535, -4.14943970298569],
            [28.019041207188749, -4.150251098775811],
            [28.019920621919272, -4.151110223021355],
            [28.021251628726286, -4.153019384519036],
            [28.022035971157063, -4.154308065951659],
            [28.022463794709459, -4.15521491386841],
            [28.022844082111945, -4.156169490620711],
            [28.023129298112949, -4.157171794228669],
            [28.023414514113988, -4.158579790445266],
            [28.023390745589886, -4.159749141205873],
            [28.02363967863656, -4.160516816636893],
            [28.023723497740797, -4.160775304102712],
            [28.02422262506883, -4.162302614882083],
            [28.024412768770095, -4.163113997258876],
            [28.024270161218741, -4.165166314613169],
            [28.023889872917923, -4.166192470354244],
            [28.022820314486136, -4.166383382921539],
            [28.022035971157063, -4.166622023790151],
            [28.020895108949606, -4.167314081353039],
            [28.019064974814519, -4.168578875423207],
            [28.018147702382954, -4.168959278773901],
            [28.017971647858634, -4.16903229118675],
            [28.017377449129121, -4.16972434659971],
            [28.016975009271743, -4.170277740286477],
            [28.016284122173236, -4.171227776191622],
            [28.016284122173236, -4.171609186613584],
            [28.016284122173236, -4.172015284778913],
            [28.016569337275943, -4.172325515460859],
            [28.017496288156373, -4.172874384963446],
            [28.017947880232864, -4.173089160311783],
            [28.01839947141103, -4.173303934698626],
            [28.018732223561937, -4.17335166263268],
            [28.019326422291456, -4.173470982004083],
            [28.020115648862419, -4.173494287214947],
            [28.020134533246299, -4.173494845515369],
            [28.020586125322797, -4.173828940007954],
            [28.021061484126733, -4.174115305570449],
            [28.02146554005332, -4.17442553541166],
            [28.021513076203224, -4.174974403426715],
            [28.021204092576415, -4.175594862296798],
            [28.020918876575376, -4.176573277405466],
            [28.020584336777073, -4.176951151413358],
            [28.020348445471665, -4.177217599293009],
            [28.018946134888971, -4.178864195331787],
            [28.018066720158416, -4.180009652202919],
            [28.017971647858634, -4.182539195920574],
            [28.01782904030728, -4.183302829793483],
            [28.017306144455144, -4.184114190182427],
            [28.016807017127075, -4.184734641722922],
            [28.016807017127075, -4.187001672378146],
            [28.017020929352437, -4.187598258524237],
            [28.017258609203569, -4.18848120445307],
            [28.017377449129121, -4.190294820169799],
            [28.017805271783182, -4.19091526674471],
            [28.018613383636357, -4.191082310245626],
            [28.019564102142589, -4.190461863805024],
            [28.020372213097435, -4.190175503394213],
            [28.021322932501967, -4.189769826940779],
            [28.022178579606749, -4.189769826940779],
            [28.022962922037493, -4.189769826940779],
            [28.02365219396512, -4.18991300678376],
            [28.024602912471316, -4.18991300678376],
            [28.025292183500614, -4.189483466273207],
            [28.026742030233212, -4.188672111523819],
            [28.027668981113642, -4.187908482957691],
            [28.028239412217388, -4.1869778092835],
            [28.028338619462406, -4.186885072589843],
            [28.028928683246683, -4.186333495527872],
            [28.029808098875538, -4.185736908404931],
            [28.031020264858675, -4.18556986464952],
            [28.031242885352398, -4.185630823069606],
            [28.031543160710847, -4.185713045271203],
            [28.032113591814557, -4.185927817055932],
            [28.03289793514363, -4.186142587879013],
            [28.033706046098512, -4.186643720469324],
            [28.034609229353133, -4.187311897051234],
            [28.03546487555959, -4.188385750449035],
            [28.036439362589888, -4.189745963029749],
            [28.03724747354477, -4.190294820169799],
            [28.037794137022711, -4.190318684063871],
            [28.038388336650559, -4.190223230287055],
            [28.039243983755309, -4.190008460598947],
            [28.039953090484381, -4.189469684924976],
            [28.040123398485832, -4.189340286350546],
            [28.041145421666037, -4.188576657543396],
            [28.042381356173312, -4.187383487203959],
            [28.043189467128155, -4.186524403129495],
            [28.045257281114374, -4.184042599726762],
            [28.046825966874227, -4.182133514555079],
            [28.048465957308053, -4.180868743517928],
            [28.049369139664378, -4.180582379551626],
            [28.050272322919003, -4.180510788768962],
            [28.051127970023785, -4.180534652063295],
            [28.051767362096914, -4.180940103373189],
            [28.052482744456572, -4.181393742795194],
            [28.05295810415884, -4.181871015212123],
            [28.053552302888356, -4.18249146855299],
            [28.054075198740527, -4.183064194063717],
            [28.054550558442791, -4.183589192752339],
            [28.055192293322182, -4.183875554703162],
            [28.055762724425929, -4.183827828320011],
            [28.056998658933168, -4.183827828320011],
            [28.059266209729547, -4.183673102677441],
            [28.059446760321872, -4.183660783249987],
            [28.061134286905602, -4.183541465449548],
            [28.061696171437699, -4.183797894254495],
            [28.061918629336347, -4.18389941879556],
            [28.062346452888736, -4.184281235154464],
            [28.063107028592007, -4.184973276936915],
            [28.063915139546889, -4.185760772439837],
            [28.064889626577187, -4.186691447580468],
            [28.065911648859096, -4.187168716725878],
            [28.066719759813978, -4.187216442902675],
            [28.067694246844276, -4.187192579814671],
            [28.068549893949029, -4.187311897051234],
            [28.069236394574009, -4.187331042175326],
            [28.069405541053783, -4.187335760135601],
            [28.070427564233988, -4.187407351188014],
            [28.071283211338773, -4.187693711723669],
            [28.071467524973801, -4.187795490996923],
            [28.071758570142705, -4.187956209088752],
            [28.0722101622192, -4.188194843307512],
            [28.072780593322914, -4.188457340502194],
            [28.073541168127885, -4.188910745521327],
            [28.074254207681285, -4.189483466273207],
            [28.074682031233674, -4.190032323599919],
            [28.074515655158223, -4.191106173213431],
            [28.073707544203344, -4.192180022234317],
            [28.0731608807254, -4.192872056936803],
            [28.072257697470775, -4.193325458459972],
            [28.071972482368068, -4.194399304391101],
            [28.071449586515897, -4.19521065311713],
            [28.07135451511445, -4.195950411638007],
            [28.071901178592391, -4.196332222035139],
            [28.073184648351205, -4.196594716460702],
            [28.073707544203344, -4.196594716460702],
            [28.074586958933899, -4.196570853662752],
            [28.075561445964198, -4.196570853662752],
            [28.076607236770208, -4.196570853662752],
            [28.077035060322604, -4.196141316860217],
            [28.077914475053127, -4.19568791699301],
            [28.078675050756431, -4.195640190438325],
            [28.079245928322866, -4.195651887354284],
            [28.079839681487989, -4.195664053265091],
            [28.080647792442868, -4.195735642642828],
            [28.081574743323294, -4.195926547918204],
            [28.082335318128269, -4.195926547918204],
            [28.082881981606214, -4.196117453146343],
            [28.082925769984726, -4.196140390595648],
            [28.083428645084155, -4.196403811350791],
            [28.083927772412189, -4.197024253010499],
            [28.084331828338776, -4.197406062875549],
            [28.084783419516942, -4.198050367382925],
            [28.085187475443529, -4.198360587612245],
            [28.08556776284605, -4.198646944081065],
            [28.085852977948758, -4.199362836591185],
            [28.086470945202375, -4.200102591125058],
            [28.087516736008354, -4.201343467985503],
            [28.088134703261971, -4.201916179499844],
            [28.088562526814364, -4.202488891489907],
            [28.088895278965275, -4.203491135093964],
            [28.089228030217853, -4.204899046995189],
            [28.089513246218896, -4.205209264464107],
            [28.089893533621382, -4.205567206848183],
            [28.090202517248191, -4.205949013377405],
            [28.090796716876039, -4.206402407200846],
            [28.091319611829878, -4.206736486546701],
            [28.091937579083499, -4.207189880807608],
            [28.09241293878576, -4.207595548085815],
            [28.093078442189256, -4.208096666723262],
            [28.093648873292999, -4.208597785033888],
            [28.09429060817239, -4.209003452470817],
            [28.09500364772579, -4.209409119693544],
            [28.095621614979439, -4.209719335342179],
            [28.096548565859869, -4.210077275625804],
            [28.097998412592432, -4.210554530280379],
            [28.098331163845049, -4.210745431878779],
            [28.098758987397407, -4.211079510238217],
            [28.099258114725476, -4.211676076829636],
            [28.099567098352285, -4.212415819516833],
            [28.100137529455999, -4.212797621740678],
            [28.101040712710656, -4.212869210425639],
            [28.102110272040768, -4.212368094901943],
            [28.102792017882912, -4.21193252783619],
            [28.103156062846747, -4.211699940060853],
            [28.1040117090532, -4.21112723493322],
            [28.104914892307825, -4.211055646987712],
            [28.105723003262703, -4.211222686118126],
            [28.106792562592815, -4.211866978149229],
            [28.107267921396751, -4.212272643859436],
            [28.107630012524865, -4.212573498499265],
            [28.107957193324374, -4.212845347230755],
            [28.108860375680703, -4.213680539670528],
            [28.109288199233063, -4.213895302752713],
            [28.109763558935327, -4.214253241991322],
            [28.110262686263397, -4.214587317922318],
            [28.111094565742377, -4.215517959116901],
            [28.111498620770636, -4.216520185723005],
            [28.112045284248577, -4.217164473306217],
            [28.112663251502195, -4.217403098466923],
            [28.113233682605944, -4.21799966104373],
            [28.113899186009434, -4.218524635005841],
            [28.11480236926409, -4.219479133509463],
            [28.115063816740992, -4.219932519341123],
            [28.115349032742031, -4.220290455761788],
            [28.115658016368844, -4.221006327199512],
            [28.115610480218969, -4.221722198870219],
            [28.115349032742031, -4.222605105621208],
            [28.115349032742031, -4.223106214454201],
            [28.115491640293385, -4.223511874217903],
            [28.115824391545999, -4.224251605485217],
            [28.116085839921233, -4.225754927767097],
            [28.116323519772369, -4.225874239018697],
            [28.116822647100403, -4.226160586127105],
            [28.117345542054242, -4.22661396800283],
            [28.117915973157988, -4.22699576315316],
            [28.118819156412616, -4.22699576315316],
            [28.119555963591814, -4.227210523405134],
            [28.12057798677202, -4.22711507421128],
            [28.120886970398832, -4.226518519636392],
            [28.121386097726901, -4.226065136802251],
            [28.121908992680744, -4.225229958760455],
            [28.122574496084233, -4.223869808965901],
            [28.122965673762931, -4.22303814406229],
            [28.123382607039112, -4.222151721371199],
            [28.124000574292729, -4.220529079949308],
            [28.124285790293737, -4.218882572083977],
            [28.124594773920546, -4.217188336366779],
            [28.125426652501226, -4.216186109731884],
            [28.126282299605979, -4.215589546646188],
            [28.12704287530925, -4.215565683535907],
            [28.12754200263732, -4.215565683535907],
            [28.127969826189677, -4.215565683535907],
            [28.128492721143516, -4.215637271060768],
            [28.128968080845784, -4.215971347290938],
            [28.129657351875082, -4.216424735196982],
            [28.130441695204187, -4.217140611146845],
            [28.13067612674725, -4.217449018090925],
            [28.131130966233481, -4.218047385308327],
            [28.131558789785842, -4.219145058807637],
            [28.13196284571243, -4.220218868671404],
            [28.132699652891631, -4.221268814097568],
            [28.133365155396827, -4.222056271546527],
            [28.134008994130621, -4.222709026752477],
            [28.134363410951231, -4.222700555377498],
            [28.135123985756234, -4.222819867105151],
            [28.135623113084268, -4.223177801274733],
            [28.136146008936439, -4.223774359355382],
            [28.136692672414384, -4.223416424562767],
            [28.137025423666962, -4.222891453952451],
            [28.137548318620805, -4.222557380738604],
            [28.138499038025333, -4.222652830500835],
            [28.139853812458156, -4.222628968512349],
            [28.140329172160421, -4.222748280251146],
            [28.140923370889936, -4.222891453952451],
            [28.141470034367877, -4.22296304079306],
            [28.142682201249347, -4.222581243631221],
            [28.143585384503972, -4.222485793860083],
            [28.144559870635973, -4.222438069871927],
            [28.145296677815175, -4.222533518747153],
            [28.145700733741762, -4.222986902771165],
            [28.146817828323453, -4.222772142235943],
            [28.147136546992975, -4.222444539071729],
            [28.147816082979556, -4.221746060887],
            [28.14867173008431, -4.221650611913635],
            [28.149218393562251, -4.221769923804908],
            [28.150026504517129, -4.221602886971592],
            [28.150620704144945, -4.221316538158584],
            [28.151191135248691, -4.220934740176035],
            [28.151761566352402, -4.219837069239972],
            [28.152403302130125, -4.219049609510275],
            [28.154209667741107, -4.218596222254451],
            [28.154518651367919, -4.217832623388635],
            [28.154471115218008, -4.216806535425983],
            [28.154898938770405, -4.216281560287588],
            [28.155302994696992, -4.216663360587871],
            [28.156206177951649, -4.216687222762102],
            [28.156206177951649, -4.216209972822853],
            [28.156443856904453, -4.215637271060768],
            [28.156919216606713, -4.215470233793001],
            [28.157465880084658, -4.214945256838114],
            [28.157988775936829, -4.214038479009326],
            [28.158440367114991, -4.213966890433407],
            [28.158939494443025, -4.213704401937542],
            [28.159557461696679, -4.213227149240955],
            [28.160056589024716, -4.21306011144855],
            [28.16053194872698, -4.213131699207168],
            [28.160460644951304, -4.213680539670528],
            [28.160009052874845, -4.214205516588812],
            [28.159961517623266, -4.214611181063018],
            [28.160222965100171, -4.215040707548266],
            [28.160627020128462, -4.215374783136333],
            [28.161221219756275, -4.215637271060768],
            [28.161720347084348, -4.215661134168834],
            [28.161696579458543, -4.214682768676946],
            [28.161744115608446, -4.213823715065338],
            [28.162243242936484, -4.213370325622234],
            [28.162980050115685, -4.213370325622234],
            [28.163859464846208, -4.213441913351909],
            [28.164406128324185, -4.21315556149123],
            [28.165047863203572, -4.212558996049443],
            [28.165998582608104, -4.211914703697154],
            [28.166117422533688, -4.210387491004639],
            [28.166402637636395, -4.209719335342179],
            [28.167091909563986, -4.208764824698787],
            [28.167971324294541, -4.208048941839984],
            [28.168232771771446, -4.207595548085815],
            [28.168422915472707, -4.20730919494738],
            [28.168613059173932, -4.206497858972704],
            [28.168945811324843, -4.205710384657099],
            [28.16918349117601, -4.205066086561899],
            [28.169278562577457, -4.204278611682],
            [28.169349866353134, -4.202918424751747],
            [28.169373634877235, -4.201605960703084],
            [28.169468706278717, -4.199840097894874],
            [28.169516242428589, -4.198169682939927],
            [28.169730153755623, -4.19723902164658],
            [28.170276817233564, -4.196308359229085],
            [28.170871016861412, -4.195544737320112],
            [28.171441447965123, -4.195234515957166],
            [28.172606078696685, -4.194518620513352],
            [28.172796222397945, -4.193802723502887],
            [28.172273327444106, -4.193325458459972],
            [28.172511007295238, -4.193158416346745],
            [28.173010134623272, -4.193062962921278],
            [28.173675638026797, -4.192967510385895],
            [28.174459980457573, -4.19289591984924],
            [28.174792732608488, -4.19249024482614],
            [28.174911572534036, -4.19158343962948],
            [28.175553307413459, -4.190891403771054],
            [28.17560084356333, -4.190294820169799],
            [28.17560084356333, -4.18817098024971],
            [28.17560084356333, -4.187598258524237],
            [28.175553307413459, -4.186906218191241],
            [28.174959107785611, -4.186214178140117],
            [28.174792732608488, -4.185617591826984],
            [28.175149251486868, -4.185402819956023],
            [28.175648379713238, -4.185880089897602],
            [28.176337650742532, -4.18619031502116],
            [28.177145761697378, -4.18619031502116],
            [28.177739961325226, -4.185832362736321],
            [28.178262856279066, -4.18549827432871],
            [28.178286623904839, -4.184615324088266],
            [28.17683677807057, -4.182157378701266],
            [28.175743451114684, -4.181417606964206],
            [28.174483748981675, -4.181513060927021],
            [28.174174765354866, -4.180892606801181],
            [28.174364909056091, -4.180343742982397],
            [28.17505418008539, -4.180200561366282],
            [28.175482003637782, -4.179198287507758],
            [28.175482003637782, -4.177981238418896],
            [28.175838523414463, -4.17776646442718],
            [28.17612373851717, -4.177933510770139],
            [28.176670401995111, -4.178243739081693],
            [28.177193297847285, -4.178076692805718],
            [28.177549816725669, -4.177408509145127],
            [28.17790633650235, -4.176597141723112],
            [28.178239088653264, -4.176430095091817],
            [28.179094735758046, -4.1759289558837],
            [28.179213575683594, -4.174831220817465],
            [28.17966516686176, -4.174306216187313],
            [28.180045454264246, -4.173590301357065],
            [28.180663421517867, -4.171967557664475],
            [28.181043708920352, -4.171275503351605],
            [28.180901101368999, -4.170655041023229],
            [28.180972405144676, -4.170201626208293],
            [28.18216080350204, -4.16855501085865],
            [28.182279643427588, -4.167242489344373],
            [28.181186317370038, -4.167075440697205],
            [28.180235597965506, -4.167075440697205],
            [28.179641398337658, -4.167266353949299],
            [28.178999663458235, -4.164736760371768],
            [28.180116758039922, -4.163567417116442],
            [28.180544581592315, -4.162350343492883],
            [28.180568350116417, -4.161037811490741],
            [28.180829797593322, -4.160226426946094],
            [28.181281388771485, -4.159796869973474],
            [28.18216080350204, -4.159558227008125],
            [28.182968915355218, -4.158913890455465],
            [28.184537601115068, -4.157792267329494],
            [28.185139226217025, -4.157324603988441],
            [28.174647102226199, -4.136288547891319],
            [28.181185203459069, -4.122973454497038],
            [28.185965279223062, -4.119193244829991],
            [28.19031501525356, -4.119044805031273],
            [28.198172160428832, -4.121301537581375],
            [28.205170560209933, -4.126567099249563],
            [28.210347359851138, -4.136630385635377],
            [28.21318595979217, -4.145090477813721],
            [28.215365012159999, -4.152917689073715],
            [28.217159972760133, -4.15936564053756],
            [28.224721046692508, -4.178023948605587],
            [28.242659470465089, -4.199636257511298],
            [28.263244252012953, -4.214352620525252],
            [28.292073385861215, -4.233010495652932],
            [28.307582531543606, -4.243138176590688],
            [28.349949812119455, -4.276714501470027],
            [28.358444783604348, -4.282032233035077],
            [28.368415800288759, -4.275551548025224],
            [28.373296061563106, -4.273143167764602],
            [28.378940223205618, -4.274408619519345],
            [28.384975977548489, -4.285564486400438],
            [28.393451089977379, -4.303796475915579],
            [28.397144685744568, -4.306059852617121],
            [28.399717604448739, -4.317092863204768],
            [28.397447806965818, -4.321704894981682],
            [28.399995884557455, -4.326985971054982],
            [28.396364568090572, -4.334825925927944],
            [28.397779727276784, -4.343332880755874],
            [28.403593721711982, -4.359873873412875],
            [28.402465842855303, -4.364249867858227],
            [28.406444103956275, -4.367273825804816],
            [28.416775108812693, -4.375126575474142],
            [28.445691360378905, -4.387251130701933],
            [28.47760388687972, -4.395228814815406],
            [28.480845324631808, -4.396711851304025],
            [28.491800832883857, -4.40849750915924],
            [28.49171659336811, -4.427332032099661],
            [28.493872632694995, -4.454600941322674],
            [28.503376216411191, -4.461016901381194],
            [28.513014892373093, -4.459538950663985],
            [28.526978707594701, -4.459660495577155],
            [28.535474188424349, -4.459734442579585],
            [28.550022860794822, -4.459191322597005],
            [28.553137559735049, -4.460062239818702],
            [28.554634440459274, -4.464217168659291],
            [28.553635440201479, -4.47937174848293],
            [28.552746600346978, -4.516251298554555],
            [28.552787279656304, -4.523391764126034],
            [28.558118160131695, -4.529202288809744],
            [28.567439279844049, -4.540623593923975],
            [28.571864760022645, -4.559008219333868],
            [28.578017880155695, -4.575176006058109],
            [28.583656560278353, -4.593147623718346],
            [28.588535999594225, -4.611395252751048],
            [28.594419839839375, -4.634993803895159],
            [28.598450399957866, -4.647742862476859],
            [28.598916600437491, -4.651404319643616],
            [28.607288040096059, -4.676608989272538],
            [28.613833200290454, -4.686106285550999],
            [28.619634959671487, -4.691325045348653],
            [28.630517673842807, -4.69832939218665],
            [28.630792022025528, -4.698072484800421],
            [28.631505061578927, -4.697714785061242],
            [28.632455780085124, -4.697619397831871],
            [28.63314505201275, -4.697595551473088],
            [28.633549107041009, -4.69781017137609],
            [28.633739250742266, -4.698764039205182],
            [28.634309682744313, -4.699765598281215],
            [28.634655223311601, -4.700487856039567],
            [28.634880113848059, -4.700957928569993],
            [28.636020976055516, -4.701244087928249],
            [28.636254575758631, -4.701200390863581],
            [28.63742328663821, -4.700981775713457],
            [28.638374006042742, -4.700504843502054],
            [28.639324724548974, -4.700409456659552],
            [28.640037764102374, -4.701124854951868],
            [28.640182694697053, -4.701161750012908],
            [28.64163021838629, -4.701530246266119],
            [28.643412815473173, -4.701625632953117],
            [28.644393314927679, -4.701611579203634],
            [28.645076574431101, -4.701601786733235],
            [28.646146132862885, -4.701458706692815],
            [28.646692796340826, -4.7019356382426],
            [28.647239459818767, -4.702913346524694],
            [28.6477206585704, -4.703345374219632],
            [28.650619164462764, -4.703638436413039],
            [28.650786727212726, -4.703655378733504],
            [28.65147599824202, -4.703965383107509],
            [28.65268816512345, -4.703345374219632],
            [28.655635393840228, -4.703321528059456],
            [28.656372201019394, -4.704704623812036],
            [28.656918863599042, -4.705849252487695],
            [28.659295661212031, -4.705706174232865],
            [28.662005210077673, -4.708329276543563],
            [28.662361729854361, -4.709235436060932],
            [28.662979697107975, -4.710117749359068],
            [28.663906647988405, -4.710761598035199],
            [28.663431288286141, -4.713790065101614],
            [28.663431288286141, -4.714505449453483],
            [28.66374027191295, -4.715363909329906],
            [28.66374027191295, -4.716079291138196],
            [28.664976206420217, -4.717653130110328],
            [28.664667222793408, -4.718463893875558],
            [28.664358239166564, -4.718988504841256],
            [28.665499102272356, -4.720562337129949],
            [28.666711269153826, -4.721206175995659],
            [28.667023148949109, -4.722124023140864],
            [28.667067788032206, -4.722255394224801],
            [28.667566915360243, -4.723328457212283],
            [28.668289102458186, -4.723814548348152],
            [28.669444585645234, -4.724592283713761],
            [28.671060807554962, -4.724735358026867],
            [28.673104853017044, -4.724902278621837],
            [28.674031804795803, -4.725593805079662],
            [28.674673539675222, -4.725736880084539],
            [28.675386579228622, -4.727596844313235],
            [28.674982523302035, -4.728407596298684],
            [28.674435859824094, -4.728956045811532],
            [28.674388323674187, -4.730029097384804],
            [28.674863683376451, -4.730553700383849],
            [28.6761471540336, -4.730649082130517],
            [28.676527441436086, -4.730672928241026],
            [28.676717585137311, -4.730482162938527],
            [28.677002801138347, -4.730863692589026],
            [28.677121641063898, -4.732413651505035],
            [28.677192944839575, -4.733748997419286],
            [28.677240480989475, -4.734416669847796],
            [28.677739608317513, -4.734893578454294],
            [28.677430624690704, -4.735442022759645],
            [28.677573232242061, -4.735895084722445],
            [28.679046846600432, -4.736801208647067],
            [28.679332062601468, -4.736944280403681],
            [28.679308294077366, -4.737540413902021],
            [28.680377853407482, -4.737349651419467],
            [28.680496693333033, -4.738351154083108],
            [28.681043355912674, -4.738971131271542],
            [28.681352339539483, -4.738899595609519],
            [28.68178016309184, -4.73961495279337],
            [28.682516970271045, -4.739972631554501],
            [28.683847977078063, -4.739567262998708],
            [28.683871744703829, -4.741164892736696],
            [28.683039866123185, -4.742524067220073],
            [28.682849722421956, -4.744169379504198],
            [28.68178016309184, -4.745981604156689],
            [28.681466878331463, -4.746353050323211],
            [28.681257268138005, -4.74660157440425],
            [28.68071060466006, -4.747841513206018],
            [28.67999756510666, -4.748938379639667],
            [28.679545973928498, -4.749892176198788],
            [28.679545973928498, -4.750726746190193],
            [28.680853212211417, -4.751752074562294],
            [28.682305346953022, -4.752710513859358],
            [28.682659578720699, -4.752944314220429],
            [28.683396385899897, -4.753516589307007],
            [28.683657833376799, -4.7528489355933],
            [28.683657833376799, -4.752538953385713],
            [28.684061889303425, -4.75213359140816],
            [28.684965071659747, -4.752205125680294],
            [28.685559271287563, -4.753373520129899],
            [28.686509989793798, -4.754518068197733],
            [28.687508245348202, -4.75535263251265],
            [28.688554036154208, -4.75571030300589],
            [28.689029394958144, -4.755996439445209],
            [28.689005627332378, -4.756735623863078],
            [28.687579549123875, -4.758953172291568],
            [28.687246796972964, -4.759835420437859],
            [28.687056653271735, -4.760717667437919],
            [28.686509989793798, -4.761933736381287],
            [28.686105934765507, -4.762553692082365],
            [28.685297823810661, -4.766440324809468],
            [28.685012607809622, -4.767370251971077],
            [28.684870000258265, -4.768204801387207],
            [28.684656088032941, -4.768514776442719],
            [28.684870000258265, -4.770136181976555],
            [28.6865337583179, -4.771590674524452],
            [28.68738940542265, -4.773092853196995],
            [28.687698389049459, -4.773951239256343],
            [28.68738940542265, -4.776049511508135],
            [28.687365636898548, -4.776693297892136],
            [28.687009117121836, -4.777289396517234],
            [28.686105934765507, -4.776836361249592],
            [28.68570187883892, -4.776836361249592],
            [28.685274055286555, -4.777360928136734],
            [28.684965071659747, -4.778123932808894],
            [28.685202751510882, -4.7789346245554],
            [28.685725647363022, -4.779196907686856],
            [28.685725647363022, -4.779936066807586],
            [28.685297823810661, -4.780579849492653],
            [28.685749414988827, -4.781247475900802],
            [28.685963326315854, -4.781724351631661],
            [28.687127957047419, -4.782105851613666],
            [28.687151725571514, -4.784680971309546],
            [28.687532012974007, -4.785777779053754],
            [28.687555780599773, -4.787065333580511],
            [28.687532012974007, -4.788019075590804],
            [28.688149980227621, -4.788853599532969],
            [28.688126212601816, -4.789878870211957],
            [28.68762708437545, -4.790403426072472],
            [28.68781722897501, -4.79157175463377],
            [28.688007372676271, -4.792620864215393],
            [28.68881548363111, -4.793622285270658],
            [28.689433450884763, -4.794313741755032],
            [28.690003881988478, -4.79529131735787],
            [28.690312865615287, -4.796125832302322],
            [28.689956345838606, -4.796650383303267],
            [28.69043170554087, -4.797484896564658],
            [28.690455473166644, -4.798438623839365],
            [28.689932578212801, -4.79898701674881],
            [28.689908810587035, -4.799487722732403],
            [28.690574313092227, -4.800369918898763],
            [28.690693153017772, -4.800536819991157],
            [28.692000392199017, -4.800012272016676],
            [28.692356911077407, -4.800155330431855],
            [28.692523287152859, -4.800965995712317],
            [28.693426470407484, -4.801204426650402],
            [28.694448492689396, -4.801013682086889],
            [28.695304139794146, -4.801180583920823],
            [28.695684427196632, -4.800799094726293],
            [28.696373699124255, -4.801037524822359],
            [28.696635146601164, -4.801585915615234],
            [28.696730218002646, -4.802515794399156],
            [28.697324417630455, -4.8029449688585],
            [28.697609633631497, -4.803517201645966],
            [28.697229345330676, -4.804327862877174],
            [28.697134273929233, -4.805376952591182],
            [28.695922107047767, -4.806139925573262],
            [28.696064715497446, -4.806807526673039],
            [28.696611378077062, -4.808118883499257],
            [28.695185299868594, -4.808476526071872],
            [28.694876316241785, -4.808762640173162],
            [28.694828780091882, -4.80945408110558],
            [28.695085849180099, -4.809910325955184],
            [28.695137763718694, -4.81000246503609],
            [28.695185195663999, -4.809978673983552],
            [28.696706450376841, -4.809215653091772],
            [28.697823544958531, -4.809096439053151],
            [28.699653679093611, -4.809477923541873],
            [28.701198597227663, -4.810455477118913],
            [28.70160265315425, -4.810956174565934],
            [28.703147571288298, -4.810622376609795],
            [28.703908146093269, -4.810813118448044],
            [28.705191616750412, -4.812124467458076],
            [28.705453064227314, -4.812744377073527],
            [28.706071031480935, -4.812792062612847],
            [28.706498855033328, -4.812458264667853],
            [28.707045518511265, -4.812505950227441],
            [28.707378269763851, -4.813125859490754],
            [28.707259429838299, -4.813841139114806],
            [28.709018260197709, -4.815128639977069],
            [28.711513897736282, -4.816392295278716],
            [28.713843158301078, -4.817822845901653],
            [28.715102861332447, -4.81863348987063],
            [28.716077348362749, -4.8199686665667],
            [28.71669531561637, -4.821709160156661],
            [28.716433868139468, -4.822352903796551],
            [28.71598227606297, -4.823211227087195],
            [28.717313282869991, -4.824641763161321],
            [28.717337050495797, -4.825047080694782],
            [28.716315028213884, -4.826382244613852],
            [28.715673292436161, -4.826382244613852],
            [28.71491271763119, -4.825976926987264],
            [28.714175910452024, -4.825762347604097],
            [28.713819390675305, -4.825976926987264],
            [28.713676783123955, -4.826978299236383],
            [28.713605479348274, -4.828075037093844],
            [28.712963743570555, -4.828265773968328],
            [28.712535920018162, -4.828384984599888],
            [28.712393312466805, -4.82943403670166],
            [28.711894185138775, -4.830173140624601],
            [28.711727809063316, -4.830387719495088],
            [28.712369544841039, -4.831722871860679],
            [28.713153887271783, -4.833630228661025],
            [28.713153887271783, -4.83420243527105],
            [28.713843158301078, -4.834870007528627],
            [28.715578221034711, -4.836038258726851],
            [28.715934739913102, -4.836658146214917],
            [28.715910972287297, -4.837325716920777],
            [28.717265746720113, -4.83820786332026],
            [28.717836177823827, -4.838517806129731],
            [28.718501681227355, -4.838517806129731],
            [28.7186205211529, -4.839256900010529],
            [28.718763128704257, -4.839519158700338],
            [28.720189207811085, -4.839471475064109],
            [28.721068622541608, -4.840210567889484],
            [28.722257020898972, -4.840854292825219],
            [28.72377817140725, -4.84195100882059],
            [28.72351672393031, -4.842165583909487],
            [28.724491210960643, -4.842666257647103],
            [28.725085409690163, -4.842189425181253],
            [28.725513233242523, -4.84276162355873],
            [28.725679609317975, -4.84385833642011],
            [28.726036129094695, -4.844192117806552],
            [28.727105687526475, -4.844430533366541],
            [28.728056406032675, -4.844907364230906],
            [28.728412925809394, -4.845503402332096],
            [28.728246550632232, -4.846004073565064],
            [28.727438438779053, -4.847100781095796],
            [28.726915543825218, -4.84776834045639],
            [28.726915543825218, -4.848173644864528],
            [28.727961334631225, -4.848841204051921],
            [28.728460461959262, -4.849031934996821],
            [28.72926857291414, -4.848006754737936],
            [28.729886540167762, -4.848102120787141],
            [28.730552043571286, -4.848817362116807],
            [28.732905072660177, -4.848698156032729],
            [28.734663903019591, -4.848936569080665],
            [28.735020422796303, -4.849532603580069],
            [28.735139262721855, -4.851082289882695],
            [28.735139262721855, -4.851487592275418],
            [28.736565340930348, -4.852298195420016],
            [28.737254611959642, -4.853037274030487],
            [28.736707948481705, -4.854896887376549],
            [28.737112004408292, -4.856971065850113],
            [28.737706203137812, -4.858711463012614],
            [28.73877576246792, -4.85990351307576],
            [28.739132281346304, -4.860523378372319],
            [28.73972648097412, -4.861262447847702],
            [28.740059233125031, -4.862120721104239],
            [28.740605895704679, -4.862549857316942],
            [28.741057487781138, -4.86307435625563],
            [28.740463288153322, -4.86343196942254],
            [28.739678944824249, -4.863551173768712],
            [28.738704457793915, -4.864409444069688],
            [28.73877576246792, -4.865506121274289],
            [28.739465033497215, -4.866531273670764],
            [28.739583873422767, -4.867699469350155],
            [28.740059233125031, -4.868772300802912],
            [28.74065343185455, -4.869272954527066],
            [28.741675455034759, -4.86932063602899],
            [28.741722991184659, -4.870083535989403],
            [28.741342702883845, -4.871204044054123],
            [28.741437775183623, -4.872610636969704],
            [28.742150813838727, -4.873445054505991],
            [28.74326790931871, -4.872968244999955],
            [28.743790804272546, -4.873302011780284],
            [28.743053997093352, -4.873826503125447],
            [28.742412262213957, -4.87416026947382],
            [28.741746758810432, -4.874970844964106],
            [28.7415090789593, -4.874970844964106],
            [28.741675455034759, -4.876115185728576],
            [28.742031974811471, -4.877068800772233],
            [28.742626173540987, -4.878117776185744],
            [28.742958925691902, -4.87921443072888],
            [28.743838340422457, -4.879834277989099],
            [28.744884131228432, -4.880621006645821],
            [28.745763545958994, -4.881717656142906],
            [28.745335722406598, -4.882146779678135],
            [28.745264418630917, -4.882838145439351],
            [28.745882385884538, -4.883839431260064],
            [28.745977458184317, -4.885389037496055],
            [28.746452816988281, -4.88662871987143],
            [28.746547889288067, -4.887773040486819],
            [28.746761800615094, -4.888726638736041],
            [28.746547889288067, -4.889656396042518],
            [28.746191369511347, -4.890204713979585],
            [28.747213392691556, -4.891039109340638],
            [28.747403536392817, -4.891396707416173],
            [28.747379767868715, -4.892231102172997],
            [28.747118320391778, -4.893160854548547],
            [28.74733223261714, -4.893399252521366],
            [28.74818787972189, -4.893542290903352],
            [28.748259183497566, -4.893876047307847],
            [28.747831359945177, -4.894591240193606],
            [28.748758310825632, -4.895616348465407],
            [28.749400045705027, -4.896665294460454],
            [28.749566421780482, -4.897261285166571],
            [28.750422068885232, -4.897595040591887],
            [28.750612212586496, -4.897904955677927],
            [28.750089317632654, -4.898381747209961],
            [28.749281205779475, -4.898548624660326],
            [28.749566421780482, -4.899669084517518],
            [28.750041781482746, -4.900884900928967],
            [28.7508974285875, -4.90179080198417],
            [28.751658003392471, -4.902243751594525],
            [28.752561186647128, -4.902362948950984],
            [28.752798866498264, -4.902982774496563],
            [28.752347274421769, -4.903507241394813],
            [28.752228434496217, -4.903888672668949],
            [28.753702048854585, -4.904794568695136],
            [28.754676535884926, -4.905509749742273],
            [28.756482901495872, -4.90534287405386],
            [28.757980284378377, -4.906940108606299],
            [28.759620273913871, -4.907035466173944],
            [28.760903744571021, -4.907655287323984],
            [28.761307800497608, -4.90815591160386],
            [28.762591271154712, -4.910039208970828],
            [28.763660829586531, -4.910849740436143],
            [28.763969813213343, -4.91094509743751],
            [28.764278796840152, -4.911779467456451],
            [28.765681107422839, -4.912017857795075],
            [28.766132698601009, -4.912280088599523],
            [28.766346610826336, -4.912876065182171],
            [28.766821969630303, -4.913329008069063],
            [28.768034136511773, -4.913495880832015],
            [28.768248048737092, -4.914163374163492],
            [28.767416169258119, -4.914854705474312],
            [28.767439936883925, -4.915212290629543],
            [28.767606312959376, -4.915951298973598],
            [28.768889783616519, -4.917000212587188],
            [28.768866015990714, -4.917763057472606],
            [28.768248048737092, -4.918215996992703],
            [28.76660805830327, -4.918549740896333],
            [28.765395891421804, -4.918740451750992],
            [28.76468285276674, -4.918740451750992],
            [28.764017349363211, -4.919241067593798],
            [28.763470685885274, -4.920003910778612],
            [28.763066629958686, -4.920027749247812],
            [28.762567502630617, -4.919574811877695],
            [28.762210982853929, -4.919646328230495],
            [28.76156924797451, -4.920552203460776],
            [28.760761137019664, -4.920790591519044],
            [28.759667810063778, -4.921005140156896],
            [28.759002306660257, -4.921338882643462],
            [28.758526947856321, -4.922197077859747],
            [28.758027820528252, -4.922650014322299],
            [28.757861444452793, -4.92348436858093],
            [28.757504924676081, -4.923722755574589],
            [28.756055077943518, -4.923603562088561],
            [28.755484646839765, -4.923698917239494],
            [28.756459133870106, -4.925462976923992],
            [28.757219708675077, -4.927084000804154],
            [28.757100868749493, -4.928156735708197],
            [28.756411597720195, -4.929157952647981],
            [28.757100868749493, -4.931041190707082],
            [28.757718836003114, -4.931947049303419],
            [28.757742604527209, -4.932876745550754],
            [28.757005797348043, -4.933353512622555],
            [28.757932748228473, -4.934974516989823],
            [28.758669555407671, -4.936047238977493],
            [28.758051588154057, -4.93671470936922],
            [28.758693323033444, -4.938216514586514],
            [28.759762882363557, -4.938145000259232],
            [28.759976793690587, -4.938812468511755],
            [28.758408107930737, -4.938860144081564],
            [28.757528692301886, -4.939694478604242],
            [28.756649277571324, -4.940385783005],
            [28.755983774167834, -4.940719515622916],
            [28.755318270764313, -4.941553847774096],
            [28.754747839660599, -4.942268988770823],
            [28.753892192555845, -4.942912614278412],
            [28.753488137527558, -4.943007966618739],
            [28.752703794198478, -4.94245969272434],
            [28.751990754645089, -4.94245969272434],
            [28.751539163466919, -4.942912614278412],
            [28.751562931092693, -4.944438243748006],
            [28.750992499988982, -4.945153380688482],
            [28.750303228959684, -4.944319054031659],
            [28.749091062078218, -4.94367542900777],
            [28.749209902003802, -4.944271377958878],
            [28.748710774675732, -4.946202247566442],
            [28.748924686901095, -4.94717959942147],
            [28.749661494080261, -4.948180787258836],
            [28.750683516362169, -4.950588399817892],
            [28.751491627317012, -4.950493049484889],
            [28.75175307569225, -4.951494232241687],
            [28.751871914719505, -4.952638439869563],
            [28.751824379467926, -4.9536157811888],
            [28.752608721898703, -4.954235558291618],
            [28.753297993826333, -4.955594298410243],
            [28.75351190515336, -4.956810011138026],
            [28.754153640931083, -4.958478632353247],
            [28.754248712332529, -4.959312941809402],
            [28.754866679586144, -4.960218761214054],
            [28.754557695959342, -4.960933881760603],
            [28.755888702766352, -4.961291441739466],
            [28.757647532227431, -4.961339116568714],
            [28.758764626809121, -4.961458302275068],
            [28.759905489914914, -4.96098155661597],
            [28.760570993318403, -4.960171087203785],
            [28.761545480348737, -4.96045713481679],
            [28.76290025478156, -4.963246097866082],
            [28.763446918259501, -4.964318773405174],
            [28.764492709065475, -4.965391446275742],
            [28.766512986003494, -4.965892026403718],
            [28.767867760436278, -4.966535629503141],
            [28.768961087392196, -4.966392606146668],
            [28.769341374794681, -4.966702488694602],
            [28.76965035842149, -4.967322253347712],
            [28.770506005526247, -4.966702488694602],
            [28.771028901378379, -4.966511791828786],
            [28.771480492556549, -4.967083883159467],
            [28.771908316108934, -4.967012371094959],
            [28.772977874540722, -4.966082723451182],
            [28.772312372035522, -4.965558306661502],
            [28.772573819512431, -4.965105400830273],
            [28.773667146468348, -4.965796678309532],
            [28.774380185123412, -4.966249583659683],
            [28.775402208303618, -4.965892026403718],
            [28.776709446586537, -4.96596353769044],
            [28.777565093691283, -4.966940859923486],
            [28.776875822661989, -4.967632136353785],
            [28.775758728080337, -4.967942018311307],
            [28.775616119630651, -4.970135024521754],
            [28.77499815237703, -4.971303036003608],
            [28.774166273796386, -4.971922796272297],
            [28.772264835885622, -4.972423371373253],
            [28.771266581229515, -4.973019294038756],
            [28.771337885005192, -4.974020442165815],
            [28.773619610318438, -4.976475632918119],
            [28.775235832228166, -4.979669750647033],
            [28.775425975929426, -4.980861581230494],
            [28.775675539593461, -4.982148756234001],
            [28.776091479332916, -4.983841148560089],
            [28.777565093691283, -4.985605046493942],
            [28.778301900870488, -4.986320138201778],
            [28.779418995452179, -4.987130574997324],
            [28.780963913586223, -4.989275844504635],
            [28.78237103554557, -4.991414871817659],
            [28.783221871273668, -4.992708260935851],
            [28.784980701633078, -4.994281445117166],
            [28.785598668886692, -4.994066920595272],
            [28.787523874423229, -4.99194550280099],
            [28.787841601352685, -4.991739325186578],
            [28.788736041304698, -4.991158908800035],
            [28.790518639289878, -4.991111236159899],
            [28.790563626020987, -4.991900765329979],
            [28.79056617454145, -4.99194550280099],
            [28.793656011707878, -4.992088520526507],
            [28.794796873915335, -4.993113475012942],
            [28.795723824795765, -4.993471017270938],
            [28.796650775676195, -4.994400625676619],
            [28.796817151751647, -4.995497085433605],
            [28.798005550109014, -4.997642327212841],
            [28.799265253140351, -4.998214390185098],
            [28.800453651497683, -4.999978248955776],
            [28.801067770368636, -5.000807793453045],
            [28.801392001999076, -5.001245760273729],
            [28.801987662287573, -5.007570144845415],
            [28.802143094187926, -5.008619310891234],
            [28.803514509013041, -5.010333579097649],
            [28.801756115234891, -5.01034523993094],
            [28.592894196856385, -5.015307786402996],
            [28.406990008357806, -5.019724850776682],
            [28.287895164269607, -5.018149739511801],
            [28.094994232483309, -5.015598477932682],
            [28.010810308058048, -5.014485078269106],
            [27.97172418424455, -5.013968132791094],
            [27.85894267392203, -5.012476497809312],
            [27.857873325696037, -5.012462359636204],
            [27.673555699431414, -5.010024600270651],
            [27.638966574269595, -5.013861806652488],
            [27.625776869667657, -5.013508845762678],
            [27.60211086939022, -5.016573495617711],
            [27.596296790513399, -5.016332182438721],
            [27.596269205047626, -5.016331037446326],
            [27.550619956530713, -5.014436361449597],
            [27.535172447853238, -5.013795210357943],
            [27.410295964849794, -5.011350624761713],
            [27.392496818573797, -5.011002181245549],
            [27.388628407059056, -5.010926453467587],
            [27.329598573620427, -5.009770879679073],
            [27.320190916501815, -5.009503929726514],
            [27.313211827804384, -5.009305891662773],
            [27.264169816732494, -5.007993347207385],
            [27.106247799889566, -5.00344113932888],
            [27.088518319760471, -5.002930073141692],
            [26.968362159283256, -4.999520568156088],
            [26.958055373905218, -4.999544502813391],
            [26.956885849151973, -4.999547218975322],
            [26.954550148564891, -4.999552648596539],
            [26.952442483516034, -4.999557534084389],
            [26.943835842458192, -4.999577505756718],
            [26.735795784648303, -5.000060253563275],
            [26.617061906099185, -5.000335770301867],
            [26.596110885003213, -5.000384382782668],
            [26.569757967117109, -5.000445531928902],
            [26.487654607365197, -5.000636050350843],
            [26.467842712033264, -5.000682024127681],
            [26.387572140039765, -5.000868293924846],
            [26.313480645897776, -5.001040224348539],
            [26.279764161270933, -5.001118464040816],
            [26.270477074233145, -4.999999962020482],
            [26.225170664151122, -5.00109118266981],
            [26.177515942033757, -5.00036343367861],
            [26.100138785179944, -4.999181787436805],
            [26.047148731434945, -4.999142447659063],
            [25.937100255532819, -4.999060750136461],
            [25.833465051870032, -4.998983813773775],
            [25.801165554500994, -4.998959834952396],
            [25.658533181797388, -4.998853945071927],
            [25.378743164092043, -4.993117059661626],
            [25.324774278165712, -4.992010462623209],
            [25.218511958641038, -4.98984111941146],
            [25.19861932183305, -4.98943620058227],
            [25.061397411355863, -4.986643009438083],
            [25.061329132207746, -4.986200221019526],
            [25.060936239645184, -4.983652898178447],
            [25.055055197652159, -4.98005382311352],
            [25.054251152472276, -4.979561762995491],
            [25.052671359942245, -4.978594958070786],
            [25.049920327775141, -4.975840256012436],
            [25.047572412795123, -4.973489200108059],
            [25.041647081163632, -4.967555904391192],
            [25.041115841759122, -4.963251251204587],
            [25.04074140867732, -4.960217185474354],
            [25.039888120548511, -4.953302871541141],
            [25.039800280585066, -4.952602978556494],
            [25.030843122293245, -4.941102925418749],
            [25.028768082258907, -4.927069993218756],
            [25.024636285601161, -4.924885528827012],
            [25.024059740563636, -4.924580711615986],
            [25.020504281432615, -4.922700947242694],
            [25.014765162474689, -4.916950863177618],
            [25.013529154305587, -4.911736143571301],
            [25.012874198021816, -4.908972865971067],
            [25.012693395002909, -4.908209882948548],
            [25.013123178679233, -4.90618233107688],
            [25.016351322263411, -4.890953922118999],
            [25.011628918340673, -4.875953214257104],
            [25.01106436311721, -4.874159882921036],
            [25.006779301295609, -4.869043965771699],
            [25.005092503245592, -4.867030076494911],
            [25.003251415952228, -4.865323929962594],
            [25.000000122783185, -4.862310978785693],
            [24.986726368210022, -4.850010012898821],
            [24.984428345660895, -4.844949937368858],
            [24.984121456006989, -4.840677601396413],
            [24.983734158152021, -4.83528707382189],
            [24.982574672970433, -4.833042855861513],
            [24.981754971053437, -4.831456496529812],
            [24.980287244253446, -4.828615969781324],
            [24.977533244950926, -4.82631601138363],
            [24.976379444308442, -4.817343994317837],
            [24.970798633656369, -4.812635063569281],
            [24.968919610508614, -4.811049589518641],
            [24.963295245040005, -4.806303862263011],
            [24.960308216464597, -4.799171859310749],
            [24.956939951865731, -4.798653626484516],
            [24.956840078070769, -4.798638259950299],
            [24.954342418424488, -4.79825397933091],
            [24.949318766267851, -4.799130853079969],
            [24.949066266909469, -4.799174918737364],
            [24.94612402474085, -4.796763145440144],
            [24.941490406707533, -4.792964911936574],
            [24.93254116706493, -4.790205962943887],
            [24.929556407633918, -4.786755914937749],
            [24.927449890632023, -4.77671088905432],
            [24.926953076465814, -4.774341782555071],
            [24.926565166858154, -4.772491994383969],
            [24.925367028068163, -4.771013438282961],
            [24.924980191048938, -4.770536063853277],
            [24.923582207650963, -4.768810888241824],
            [24.912907255838572, -4.766532309410438],
            [24.912249497709421, -4.766391910528495],
            [24.90958427082164, -4.765822956403367],
            [24.908472858982421, -4.764480018599274],
            [24.906339114044268, -4.761901767892087],
            [24.901779168644008, -4.756391854227805],
            [24.89613020550631, -4.745881078544772],
            [24.895349353928758, -4.74442812702741],
            [24.895841809469182, -4.740336433117584],
            [24.896000393557848, -4.739019248294046],
            [24.896263248694837, -4.736836000096059],
            [24.890064408805415, -4.729015010080993],
            [24.88958206021023, -4.727687473271956],
            [24.889144493530285, -4.726483184766599],
            [24.888225169346612, -4.723952979550694],
            [24.889829328678715, -4.719350906197723],
            [24.889118982274514, -4.718006214001881],
            [24.888539391049832, -4.716909042829645],
            [24.888014208985279, -4.715914866704713],
            [24.887764345283951, -4.71543995739756],
            [24.880420386070956, -4.714520871966416],
            [24.875938369521599, -4.708178956141932],
            [24.873075289590769, -4.702558875902191],
            [24.869956265262449, -4.700259697830077],
            [24.869105463670341, -4.699632531172945],
            [24.865272291267573, -4.696806906912705],
            [24.864796687223532, -4.695934449293326],
            [24.864386052035805, -4.695181172320115],
            [24.863893131168044, -4.694276945582826],
            [24.865268330595473, -4.691055968705317],
            [24.873525289852569, -4.686222858669778],
            [24.869621090355235, -4.681161949518608],
            [24.867553279063941, -4.672648963902708],
            [24.865478801374952, -4.670858462305185],
            [24.859291250613719, -4.665517895920625],
            [24.857914250962477, -4.660686941809675],
            [24.859745210649294, -4.65424394081838],
            [24.859673463105853, -4.651575534001592],
            [24.859628449425298, -4.649901394083568],
            [24.859510130522597, -4.645500851128502],
            [24.863868290953807, -4.64250886125123],
            [24.859966224056944, -4.636757924700174],
            [24.85982500889429, -4.636298343804421],
            [24.8594738565514, -4.635155524529019],
            [24.859047171164498, -4.633766881578765],
            [24.863677584008901, -4.627348249963815],
            [24.863861090956807, -4.627093873495654],
            [24.864420877024411, -4.625594316262856],
            [24.86798417036302, -4.616048879632932],
            [24.871085192453037, -4.613756444040392],
            [24.871843670590152, -4.613195737017564],
            [24.872341241137818, -4.612827864507599],
            [24.87262799685125, -4.612135645809058],
            [24.87348528338137, -4.610066005751638],
            [24.871544174071055, -4.606352020353701],
            [24.870960327526856, -4.605234942425593],
            [24.872106319114607, -4.602703867210264],
            [24.874792586343009, -4.602104311190539],
            [24.875204169253376, -4.602012448895649],
            [24.878298093754328, -4.601321906978081],
            [24.878510159941751, -4.600816114231391],
            [24.878971379263142, -4.599715718152746],
            [24.880130209572911, -4.596950925966532],
            [24.87875140969782, -4.589587898242955],
            [24.881014336865441, -4.588273327687394],
            [24.881522998013605, -4.58797783801883],
            [24.883108129231349, -4.587057008304783],
            [24.885446914633132, -4.586899888313729],
            [24.885547251958769, -4.586893147387552],
            [24.886980289415778, -4.586796875993508],
            [24.888050332937794, -4.58672535888179],
            [24.888126852332022, -4.586720245043395],
            [24.889988088837178, -4.586595848862187],
            [24.894726308498811, -4.584812184883737],
            [24.895376792969099, -4.584567314881325],
            [24.897327408251762, -4.583833020768741],
            [24.898771499478325, -4.581554392956699],
            [24.900375168330275, -4.579023959163425],
            [24.90123811694167, -4.577661999726497],
            [24.902139168494148, -4.576239901169607],
            [24.905803414504369, -4.565194978615888],
            [24.908556077113737, -4.564734032972683],
            [24.909215271649014, -4.565188442114506],
            [24.909627795993771, -4.565472863253943],
            [24.912227111692555, -4.567264979465075],
            [24.916815022545919, -4.567032887882414],
            [24.917463973591992, -4.568117319648754],
            [24.917503230868217, -4.568182952122499],
            [24.920480086921362, -4.561511001924099],
            [24.916345127295529, -4.549546924714489],
            [24.917139947675754, -4.547683250796286],
            [24.917556083247977, -4.546707505153001],
            [24.917719198438935, -4.546325070543985],
            [24.921749384858263, -4.54651694640959],
            [24.927353182500095, -4.546783950221218],
            [24.927612473122036, -4.544778028694135],
            [24.927748676583715, -4.543724235335693],
            [24.928037206469845, -4.541491890956878],
            [24.922069776190845, -4.533439329924543],
            [24.922080547889443, -4.533427736604415],
            [24.927395326063362, -4.527720957781477],
            [24.9291690945076, -4.519647504589176],
            [24.929172305086428, -4.519632946848184],
            [24.953703405440372, -4.501909962395724],
            [24.955618268673057, -4.500103945098185],
            [24.957262500053346, -4.498553171790337],
            [24.961267364761422, -4.494775931825248],
            [24.965158244938067, -4.482119886337128],
            [24.967909364241756, -4.481198882924784],
            [24.972498188681769, -4.483038878082032],
            [24.978224107794912, -4.471992954883406],
            [24.984585869737518, -4.47275038493935],
            [24.987858320926467, -4.473140002002465],
            [24.993818202662123, -4.470607991322723],
            [24.994627706904001, -4.470005100105779],
            [24.996287176406454, -4.468769183440979],
            [24.999999980849374, -4.466004004408111],
            [25.000000121884852, -4.465055012292797],
            [25.000897445428912, -4.463169724134824],
            [25.001605707741607, -4.461681653827805],
            [25.002067241473348, -4.460711962675192],
            [25.000445443720672, -4.457562642717731],
            [25.000054469959551, -4.45680342062685],
            [25.000000121884852, -4.456697884018541],
            [24.998394162328935, -4.453579860187446],
            [24.998560175485032, -4.452797876559363],
            [24.998688809742134, -4.452191960069325],
            [24.999078162044132, -4.450357966028566],
            [24.999833217600003, -4.450037756837104],
            [24.999911329707217, -4.450004630900863],
            [25.000000121884852, -4.44996697529008],
            [25.002675482667392, -4.448830663009849],
            [25.005041202256312, -4.447825864946048],
            [25.005672038774719, -4.446499922477675],
            [25.007559401881593, -4.44253289635489],
            [25.000000121884852, -4.435414990096991],
            [24.999725773702131, -4.435156656479753],
            [24.997565306579219, -4.433122302192435],
            [24.992414202348389, -4.428271858754293],
            [24.991495122506461, -4.425510935596034],
            [24.995159212209821, -4.418606905908105],
            [24.995082512254243, -4.418146655322201],
            [24.994699151715189, -4.415845937237559],
            [24.988946470891378, -4.410927231196003],
            [24.979097571186699, -4.402505964748441],
            [24.977258046063657, -4.39935694904611],
            [24.973587283674327, -4.393072862184538],
            [24.973360952240192, -4.390593033350837],
            [24.973207767026381, -4.388914636026983],
            [24.972894283738313, -4.385479889950031],
            [24.991686157336474, -4.368218076366197],
            [24.993746202692094, -4.359705000630908],
            [24.992198705494882, -4.34594998928494],
            [24.990976397532183, -4.33508502421284],
            [24.991522492376529, -4.332887506228967],
            [24.992480622882177, -4.329032314587034],
            [24.993721362477856, -4.324039974337382],
            [24.993946380575068, -4.315986829692806],
            [24.994631442098932, -4.311845015405555],
            [25.000000121884852, -4.304832963781815],
            [25.015529549729706, -4.284551202592333],
            [25.017540327881914, -4.281925008558546],
            [25.01849322210775, -4.279124507150637],
            [25.02051544120339, -4.273180959514894],
            [25.019136271222393, -4.270189985457577],
            [25.013172161116731, -4.26604992782948],
            [25.008581441231481, -4.256847981393928],
            [25.007944427897201, -4.255094741173746],
            [25.007458027900107, -4.253756029181533],
            [25.006742200874385, -4.251785865025686],
            [25.007958531447162, -4.24775154120432],
            [25.008372922491091, -4.246377083942728],
            [25.009031440594949, -4.244192898319746],
            [25.007881128110693, -4.241200873083204],
            [25.006197315162364, -4.239071956794313],
            [25.00524337350091, -4.237865947553685],
            [25.002605441923002, -4.234530924477112],
            [25.001915560039311, -4.232322449129955],
            [25.001455290237192, -4.230848929495985],
            [25.004052721270529, -4.225321748365982],
            [25.00534829043788, -4.222564924078729],
            [25.003485003977246, -4.219896577419983],
            [25.00120217643116, -4.216627361694422],
            [25.000000121884852, -4.214905905535645],
            [24.999820631304573, -4.214648971206989],
            [24.999479174478552, -4.21416018841161],
            [24.998922358241284, -4.213362890418767],
            [24.999736045937411, -4.212023623673494],
            [25.000000121884852, -4.21158897634501],
            [25.001440127573517, -4.209219964738653],
            [25.006941281016069, -4.205076940957803],
            [25.008231750447568, -4.20150830496633],
            [25.009266298837801, -4.198647374292152],
            [25.009687376042393, -4.197483002229507],
            [25.009132537895361, -4.196037467895773],
            [25.007391281277837, -4.191500885245193],
            [25.002571242161835, -4.185979984387028],
            [25.002412091236206, -4.184945346093412],
            [25.002315773871448, -4.184319181016306],
            [25.002111161904235, -4.182988992190066],
            [25.009251923996615, -4.178804487359496],
            [25.011047674215867, -4.177752169669398],
            [25.013111320917481, -4.176542862327466],
            [25.014014629936266, -4.17518098228801],
            [25.014757331860352, -4.174061242466199],
            [25.015859200896273, -4.172399997719956],
            [25.01310736114371, -4.168949870589607],
            [25.000000121884852, -4.164068905249829],
            [24.99859396381779, -4.163545208379706],
            [24.996980965961619, -4.162944477278039],
            [24.989029122185727, -4.159982955045371],
            [24.988035440852741, -4.158986745068426],
            [24.98765155569755, -4.158601882971518],
            [24.986276202658185, -4.157223026360215],
            [24.985595674931574, -4.154837667868279],
            [24.98534168077655, -4.153947374123399],
            [24.984831162810686, -4.152157918174397],
            [24.983978379535081, -4.149170049906729],
            [24.984138643473319, -4.148524048742394],
            [24.984326389571095, -4.147767769591599],
            [24.984892362336044, -4.145487915564395],
            [24.995434242213836, -4.138122014487084],
            [25.000000121884852, -4.132369023844848],
            [25.000000121884852, -4.13152793046573],
            [25.000517252349518, -4.129510575918259],
            [25.000924870994531, -4.127920428610154],
            [25.001613281437773, -4.125234890475537],
            [25.000797450361372, -4.119730710733695],
            [25.000692383405752, -4.11902202857082],
            [25.000000213513026, -4.117980722117347],
            [24.997940202293361, -4.11488186034934],
            [24.996466262744875, -4.113835038039851],
            [24.995992617926468, -4.113498644802935],
            [24.992435081890527, -4.110972001711698],
            [24.976845238749547, -4.108444830945269],
            [24.975746590173923, -4.107343548088528],
            [24.975328579817724, -4.106924535514291],
            [24.97432128721152, -4.10591474847174],
            [24.972944322594564, -4.101542962172016],
            [24.973573243006459, -4.099771903312513],
            [24.983926122738364, -4.070706884943546],
            [24.983924203038598, -4.066872474586428],
            [24.983923788915234, -4.066045785880049],
            [24.983923242739568, -4.064953942754059],
            [24.981331650755596, -4.059484939747026],
            [24.98028334376848, -4.057272700542159],
            [24.979562202309531, -4.055750873518114],
            [24.981622122799319, -4.050688888289751],
            [24.981086566091555, -4.049768551280506],
            [24.980911028098536, -4.049466894361535],
            [24.98001544279456, -4.04792785694088],
            [24.971304162379155, -4.046089980985842],
            [24.96900916355926, -4.043788989723956],
            [24.96510928406013, -4.034585856103737],
            [24.963449374383199, -4.033615768734174],
            [24.963247543600101, -4.033497817420964],
            [24.962356338481442, -4.03297698736374],
            [24.952041309264036, -4.032059028672525],
            [24.950662299183193, -4.031021175027382],
            [24.950429453166574, -4.030845929900056],
            [24.949289417409179, -4.029987942418138],
            [24.948193646137426, -4.03008873984943],
            [24.948128602720953, -4.030094723501238],
            [24.946768364734588, -4.030219854252477],
            [24.945392444858289, -4.032290944418704],
            [24.944457994841891, -4.034282587725261],
            [24.943031197082853, -4.037323566524678],
            [24.939670219617611, -4.044486896091314],
            [24.939450648005966, -4.044494304933288],
            [24.932794270091197, -4.044718984145671],
            [24.926836138273718, -4.047020865794464],
            [24.926612066102518, -4.047003662144181],
            [24.92385531526029, -4.046791884285596],
            [24.922718202620818, -4.04573912653011],
            [24.921865940368061, -4.044950076228999],
            [24.920873206757687, -4.044030972078763],
            [24.920019216146315, -4.0380505864114],
            [24.919641371263069, -4.035404574877738],
            [24.919033245951717, -4.031145912317609],
            [24.916277086200946, -4.022862948453096],
            [24.913766426135872, -4.021999429711813],
            [24.912264772662535, -4.021482949403218],
            [24.908252326173454, -4.020102901075466],
            [24.905040407061588, -4.01366101382408],
            [24.897476087516132, -4.012051927291517],
            [24.895641189615105, -4.009060937182704],
            [24.895408247478763, -4.002157862763457],
            [24.899524126887979, -3.986049904560089],
            [24.901918356309082, -3.983731174129963],
            [24.90258209811633, -3.983088360325285],
            [24.90593932691192, -3.979836982983649],
            [24.906079124533051, -3.977992679925818],
            [24.906160045672156, -3.976925114442844],
            [24.906163626356886, -3.976877881710111],
            [24.903915399220601, -3.973920184266783],
            [24.900892127216729, -3.969942885115017],
            [24.900447442286453, -3.969882863709494],
            [24.888971448362145, -3.968333891310483],
            [24.887937562030302, -3.967296309527628],
            [24.887686892540174, -3.967044743841182],
            [24.887367316877821, -3.966723942536033],
            [24.887609726358939, -3.964191732686344],
            [24.888050208071999, -3.959590901001947],
            [24.884451288447536, -3.95617886701456],
            [24.871540229568634, -3.943945991681172],
            [24.858019387986701, -3.944868903945073],
            [24.855254182201026, -3.941326006456842],
            [24.854727449644287, -3.940651134669114],
            [24.853889089718844, -3.939576981218955],
            [24.853492903034162, -3.937489143188411],
            [24.853322474658437, -3.936591012576272],
            [24.852972170325202, -3.934744958183791],
            [24.854820307596885, -3.929013834065938],
            [24.85740735141059, -3.920991271443317],
            [24.858463262636565, -3.917716888802939],
            [24.857440337547803, -3.914982169103824],
            [24.854332250208081, -3.906672845669142],
            [24.852285215152691, -3.905645591557553],
            [24.851124298954829, -3.905063031403251],
            [24.849345822440167, -3.90649125902196],
            [24.849092528971081, -3.906694669952272],
            [24.847686290055648, -3.907823985820191],
            [24.845294882242861, -3.914102742487333],
            [24.844612741141962, -3.915893729508744],
            [24.84356716952491, -3.91863890660848],
            [24.843249788446798, -3.918681416834234],
            [24.842953515082954, -3.918721099478849],
            [24.836691185862506, -3.919559869584194],
            [24.830717966839842, -3.916777432588529],
            [24.830272515646641, -3.916569922604469],
            [24.823852131445214, -3.909436874052082],
            [24.822772572069379, -3.906029180183661],
            [24.82217599729594, -3.904146051020836],
            [24.820692411637889, -3.899462990081046],
            [24.818943798716532, -3.893945276808064],
            [24.818243046319601, -3.891734057200875],
            [24.817655452004043, -3.889879900494765],
            [24.813299091796647, -3.883896954823035],
            [24.810712166560567, -3.881993025153766],
            [24.809341814442408, -3.880984468897788],
            [24.802982212948056, -3.876303893194828],
            [24.802892838662135, -3.876005327407665],
            [24.802452220405151, -3.874533381826695],
            [24.800916172236207, -3.869401981747219],
            [24.802976452950467, -3.860426876254361],
            [24.80663730422722, -3.858150816614732],
            [24.807101780839819, -3.857862037834767],
            [24.807787124434704, -3.857435947969513],
            [24.808411830849579, -3.857501928165783],
            [24.812141308922495, -3.857895909005758],
            [24.820394311999078, -3.862497827072231],
            [24.82088108569533, -3.861580157400361],
            [24.821345787785063, -3.86070403356036],
            [24.822225291448834, -3.859045861471839],
            [24.820817052883562, -3.856348733442794],
            [24.820399580618218, -3.855549166606115],
            [24.819702411600943, -3.854213908285027],
            [24.79609539111177, -3.84455099403858],
            [24.782114474662119, -3.843170859968813],
            [24.771115190607947, -3.840290137261956],
            [24.766987221671631, -3.838109776656486],
            [24.766696851137514, -3.837043167674405],
            [24.766406391670184, -3.835976229802068],
            [24.766298269544272, -3.835578855906626],
            [24.779360093575605, -3.833737994145299],
            [24.780944926552682, -3.831260739379932],
            [24.781421453166509, -3.830515879062826],
            [24.780323499886908, -3.828801828812165],
            [24.779358177469092, -3.82729497072823],
            [24.773399209320086, -3.825223954031086],
            [24.766641462813713, -3.826615909066116],
            [24.765970933336192, -3.826754023637264],
            [24.764461234551185, -3.827064986844515],
            [24.762985994242133, -3.826429944097015],
            [24.762484109086174, -3.826213875661617],
            [24.761253239280506, -3.825683969658626],
            [24.764917266101801, -3.818320915827581],
            [24.764721204299462, -3.817533634322861],
            [24.764000312572168, -3.814638899299595],
            [24.762734487522145, -3.814639439800691],
            [24.761478227733278, -3.814639976692481],
            [24.761362186958149, -3.814767106337952],
            [24.760896933302831, -3.815277058545036],
            [24.758959254658567, -3.817400891659005],
            [24.757387727527497, -3.817821429839346],
            [24.757238161625928, -3.817861453841763],
            [24.755521304149866, -3.818320876124831],
            [24.754860131524349, -3.817507382660326],
            [24.753599890402146, -3.815956652658821],
            [24.748415193671256, -3.809576879985279],
            [24.745665174803779, -3.810177536214019],
            [24.74534361296638, -3.810247772852246],
            [24.743145165971548, -3.810727876456094],
            [24.741310255494092, -3.805665906010937],
            [24.741624719742465, -3.803605099817368],
            [24.741783141236056, -3.802566895820069],
            [24.742223215113963, -3.79968290014824],
            [24.733741256624292, -3.790708853955759],
            [24.732795022507972, -3.787793105355944],
            [24.732394958694517, -3.786560335000119],
            [24.730530416389108, -3.780814848208496],
            [24.731111847363515, -3.777540046569414],
            [24.731238805364299, -3.776824977265405],
            [24.731624116145852, -3.774654896139971],
            [24.733884661879639, -3.775038771823746],
            [24.738090415038055, -3.775752976333703],
            [24.739074502363838, -3.77799605615157],
            [24.740614263269848, -3.781505703479617],
            [24.741645166296632, -3.781850532180924],
            [24.741741192607261, -3.781882632325331],
            [24.742675354264456, -3.782194895118483],
            [24.74688742347767, -3.776484106180907],
            [24.747257109861476, -3.775982822486132],
            [24.752979295576317, -3.759416019944815],
            [24.762144174006238, -3.755043895008151],
            [24.762527615393669, -3.754413210509823],
            [24.762999173425683, -3.753637590535344],
            [24.764662374529813, -3.750901947265716],
            [24.76489822541102, -3.748763588049157],
            [24.764953156492332, -3.74826555040171],
            [24.765119214564184, -3.746759979631482],
            [24.763513232550373, -3.744689974247829],
            [24.756534343278933, -3.743944067429292],
            [24.75274433851882, -3.743538990094514],
            [24.752112313529324, -3.742143272060802],
            [24.751706367547378, -3.741246640558433],
            [24.751598395440112, -3.741008158928513],
            [24.754575174238141, -3.736175941309965],
            [24.758011396388227, -3.734334856410259],
            [24.761219314403789, -3.734334859117497],
            [24.764721048890898, -3.736412533698648],
            [24.765239676847159, -3.736720251253188],
            [24.766262185117633, -3.737326917213711],
            [24.76706591049728, -3.729086753292083],
            [24.767470498226515, -3.72493853477758],
            [24.767631294865733, -3.723289893806347],
            [24.770517969945796, -3.720547026271863],
            [24.771213161771126, -3.719886465770877],
            [24.776106413582838, -3.715236961996207],
            [24.777474363605918, -3.710496276182563],
            [24.777742253800039, -3.709567887293821],
            [24.777900544139623, -3.709018646502504],
            [24.778164173624376, -3.708103896586219],
            [24.778960474428214, -3.707818175172124],
            [24.779506857631763, -3.70762212755641],
            [24.781372142843935, -3.70695285581146],
            [24.797184326204246, -3.7108638695164],
            [24.797681785360805, -3.708759325666983],
            [24.798173674064298, -3.706677960741604],
            [24.798326350831683, -3.706032023001016],
            [24.798090587087025, -3.703666493656491],
            [24.79763837247808, -3.699128896014045],
            [24.799410372139533, -3.694612664147416],
            [24.800505456200106, -3.691821650964202],
            [24.801069181380257, -3.690384952797574],
            [24.800387811932193, -3.689069720305951],
            [24.795109372408131, -3.6788809412468],
            [24.797024141317721, -3.676570131995742],
            [24.797283772401123, -3.676256799640229],
            [24.797397279028839, -3.676119894658173],
            [24.805874451294709, -3.672206940774242],
            [24.807370575637449, -3.666833801465898],
            [24.807476098038929, -3.666454792986643],
            [24.807146754994534, -3.665244177135407],
            [24.806690583306736, -3.663567242417078],
            [24.806099092099473, -3.661392854476889],
            [24.803999193884589, -3.65894188786722],
            [24.803173387016923, -3.659018857696567],
            [24.79945237915884, -3.657712001411365],
            [24.799142668794975, -3.657779323595051],
            [24.79910764977026, -3.6577869362044],
            [24.798753292238423, -3.657863971114473],
            [24.788913547264801, -3.660012922643492],
            [24.785705480128918, -3.656101809744596],
            [24.786161230506845, -3.651499880488436],
            [24.795782212352584, -3.648047954643897],
            [24.797411762566174, -3.645135219787551],
            [24.797841998095109, -3.644365456784658],
            [24.796966252982497, -3.640461983260713],
            [24.796711373088606, -3.639885873729063],
            [24.788217375377499, -3.636542967369898],
            [24.78798655506187, -3.632401831931308],
            [24.788080786538565, -3.632271576315389],
            [24.791649927011349, -3.627339170224854],
            [24.78304861745471, -3.628090621128318],
            [24.78111043126232, -3.62826000394925],
            [24.780176704389685, -3.626666379963248],
            [24.779911603464519, -3.626213913276459],
            [24.778818275610305, -3.624347883899674],
            [24.778940031467265, -3.624088152795193],
            [24.780651413711684, -3.620436982282811],
            [24.785919295336196, -3.618365911160664],
            [24.786219112553855, -3.61776315239727],
            [24.788208173035734, -3.613763980836346],
            [24.788206372811917, -3.610541949089431],
            [24.782705261590163, -3.602488960378049],
            [24.782844009979051, -3.601483068197152],
            [24.783221785692021, -3.598745433791684],
            [24.78384808032833, -3.594205887530761],
            [24.78333128852854, -3.594239722055591],
            [24.773309235857866, -3.594895871683525],
            [24.769184333769939, -3.593975996490832],
            [24.766893349521073, -3.59121498073173],
            [24.767757280889391, -3.590289091560043],
            [24.768451835809184, -3.589544827738106],
            [24.770328413742771, -3.587533938451993],
            [24.774424501469632, -3.586598279643376],
            [24.774701216713137, -3.586535070542204],
            [24.775367333665979, -3.586382910895479],
            [24.775891803366498, -3.585855865762075],
            [24.776091403632737, -3.585655285536065],
            [24.777199373127775, -3.584541874975399],
            [24.777466930046938, -3.581712528538745],
            [24.777526615911054, -3.581081370785101],
            [24.777656213162146, -3.57971091568325],
            [24.775988025509861, -3.576211119719283],
            [24.775674213438389, -3.575552752391546],
            [24.775133333314258, -3.574418001261073],
            [24.773599501289123, -3.572755148933465],
            [24.772727671932827, -3.571809983196418],
            [24.769403339442945, -3.568205701424042],
            [24.771465293718563, -3.565444889451526],
            [24.77220779531833, -3.565294989065498],
            [24.7722403017552, -3.565288426291602],
            [24.772356293123021, -3.565265009346364],
            [24.777191093355796, -3.564292934807176],
            [24.778564133233264, -3.561302953522892],
            [24.773290133183355, -3.547956924662121],
            [24.773977373121816, -3.545655847171517],
            [24.776954222886712, -3.545425969089653],
            [24.783142274907892, -3.549567956524201],
            [24.784614292960022, -3.549419919219374],
            [24.786649587034617, -3.549215014645369],
            [24.787723328920681, -3.549107006313924],
            [24.791160182586427, -3.552327829258591],
            [24.792953333081243, -3.547736927164221],
            [24.792821929318123, -3.546980223786182],
            [24.792541505829131, -3.545365361165916],
            [24.792072412774285, -3.542664005766239],
            [24.793203755534702, -3.540817613501093],
            [24.793905172684955, -3.539672873949046],
            [24.794738656555019, -3.539479667867792],
            [24.804836211726965, -3.537139002511054],
            [24.805297426556766, -3.537031645348272],
            [24.805335584295108, -3.537022763530282],
            [24.805816131768147, -3.536910907676381],
            [24.806635095269957, -3.535057571627104],
            [24.806854477337048, -3.534561102974672],
            [24.807646371904422, -3.532769020822536],
            [24.804613372044351, -3.527141962060174],
            [24.801199723659025, -3.52080884590536],
            [24.800081331910096, -3.51873395912008],
            [24.798471398207351, -3.504238058858111],
            [24.792318727231955, -3.497608766150745],
            [24.789076140534611, -3.494115008121201],
            [24.786780960255037, -3.493135347046978],
            [24.786185465256573, -3.492881166867437],
            [24.782783332374873, -3.491429005499294],
            [24.781233719645162, -3.490768018142884],
            [24.780958974407092, -3.490650825505423],
            [24.779911152510241, -3.490203803730812],
            [24.776167309477607, -3.486623526348205],
            [24.775099133553059, -3.485602009385182],
            [24.772577412531895, -3.482150086736616],
            [24.772690305610258, -3.481753012355651],
            [24.772770293399812, -3.481471946399695],
            [24.773883500971227, -3.477554592020787],
            [24.774408293166967, -3.47570785181923],
            [24.778586568657506, -3.472074400868749],
            [24.781392126765734, -3.469634664134896],
            [24.793552372831851, -3.459059941675649],
            [24.796685065027209, -3.456335032546388],
            [24.797422240515655, -3.455693814761134],
            [24.798221350351383, -3.454998819765839],
            [24.801425672410861, -3.454461797520659],
            [24.802343202658896, -3.454308027246718],
            [24.805767011888388, -3.455491546955494],
            [24.816318434569446, -3.459138917078175],
            [24.824794227921338, -3.458907927005872],
            [24.830747209697289, -3.454075945515024],
            [24.833950130384931, -3.444411011400496],
            [24.833942233295279, -3.42807492423191],
            [24.837148369951631, -3.425543926932778],
            [24.847271209105585, -3.424335846795326],
            [24.84832553929667, -3.424210195351802],
            [24.848456742735504, -3.424194559107681],
            [24.850660249041987, -3.423931953039076],
            [24.852108273991171, -3.422622157905929],
            [24.852952840376926, -3.421858213721478],
            [24.853885129046777, -3.421014921103653],
            [24.854123264343734, -3.420799639215725],
            [24.854339409780881, -3.420604237348219],
            [24.855240169380906, -3.41978992419639],
            [24.857627999203917, -3.414071141290997],
            [24.858573624262476, -3.411806387502264],
            [24.86004436850352, -3.408283971375123],
            [24.860730838585763, -3.404761273158925],
            [24.861673377032997, -3.399924573702369],
            [24.862745481290318, -3.3944230444746],
            [24.864628086919431, -3.384759145917062],
            [24.864841440392663, -3.383663926325418],
            [24.866009376924477, -3.381119994068578],
            [24.867588140883498, -3.377681211599819],
            [24.86929505311106, -3.376537236576886],
            [24.871708440003896, -3.374919990488661],
            [24.877996000205755, -3.374659884165927],
            [24.881111280355938, -3.374531009557971],
            [24.894487440176551, -3.373977943529339],
            [24.897474562176761, -3.373854691350293],
            [24.899650319524138, -3.373764833934114],
            [24.903084091968438, -3.371233049428577],
            [24.906515400333934, -3.363640014855135],
            [24.906921480164851, -3.351457961143466],
            [24.906967068767216, -3.350068025904088],
            [24.906860925629875, -3.349426917016244],
            [24.906276360433463, -3.345923017332618],
            [24.906447661073308, -3.345275255612848],
            [24.910101359963772, -3.331458930343145],
            [24.910098127825382, -3.331438281027052],
            [24.907863239772762, -3.317161961037222],
            [24.909692400134062, -3.310718899266035],
            [24.916330439840621, -3.303814994104187],
            [24.917377320303043, -3.301556865406569],
            [24.917930280072841, -3.300363922957704],
            [24.917057147261055, -3.298696947165808],
            [24.915640319903368, -3.295991949361959],
            [24.914548831798875, -3.295956933993011],
            [24.913677239597845, -3.295928972617875],
            [24.91304651986043, -3.295907920780654],
            [24.907028203613883, -3.295710628288445],
            [24.901668403674535, -3.295534922994715],
            [24.897773515215114, -3.293005060680567],
            [24.896627280183949, -3.289783921538321],
            [24.898226399967296, -3.281960943867274],
            [24.901661519884513, -3.274615994521159],
            [24.901859769084581, -3.274193278264696],
            [24.901886159790976, -3.274137005768938],
            [24.902660954028608, -3.273462019975372],
            [24.905092319803554, -3.27134385773932],
            [24.909648538991981, -3.267372928418825],
            [24.912185400218959, -3.26516194503918],
            [24.925008355928068, -3.262858035537855],
            [24.941040480107592, -3.264465946664084],
            [24.944575279783699, -3.266594862476833],
            [24.949058400362517, -3.269294920041974],
            [24.950253601661501, -3.269372349048547],
            [24.951683159943425, -3.269464960842636],
            [24.956157263233411, -3.269753927750438],
            [24.960279240406788, -3.267911925802024],
            [24.962114957571334, -3.264350984449853],
            [24.963482160196097, -3.261698862923921],
            [24.963249244110941, -3.256867063533429],
            [24.957514439761301, -3.240072948070904],
            [24.958242086819535, -3.236106406631638],
            [24.958654388382115, -3.233859864928635],
            [24.96526893714401, -3.225982541739686],
            [24.966876532532037, -3.224068103485079],
            [24.967350281555007, -3.22350392886957],
            [24.968098646458632, -3.221792346973697],
            [24.968748161646719, -3.220306841296717],
            [24.968878851249212, -3.220008229488836],
            [24.969866321630331, -3.217751971468371],
            [24.968260362074414, -3.211770008540189],
            [24.966607161016004, -3.207381147960757],
            [24.966091999658445, -3.206013511854109],
            [24.965456322119014, -3.204325930081025],
            [24.964814878293751, -3.202622014045422],
            [24.964361251533166, -3.201416943913358],
            [24.965959242134197, -3.197504962878575],
            [24.966018018903217, -3.196976441458986],
            [24.966039045769076, -3.196787367841069],
            [24.966189784870391, -3.195431914377301],
            [24.969620107784007, -3.193359992121648],
            [24.98027896897305, -3.192999155698717],
            [24.99000001325998, -3.192670067669205],
            [24.99175503296593, -3.191407596110788],
            [24.991862233420356, -3.191330480721716],
            [24.994810000227961, -3.189209971367297],
            [24.995179728832593, -3.188541549669452],
            [24.995267796069808, -3.18838233506386],
            [24.997099960397435, -3.185070007896174],
            [24.998919760313477, -3.173799923364325],
            [24.998767738417939, -3.171499548219646],
            [24.998746714247037, -3.171181405309413],
            [24.998219919706532, -3.163209945857636],
            [24.999099760238511, -3.157659917257555],
            [24.99999975986379, -3.152920028134857],
            [25.003351748786308, -3.149760598572681],
            [25.003769070134702, -3.14936725009574],
            [25.00713999913669, -3.146189955727906],
            [25.016081209637271, -3.143819412235135],
            [25.016208476658527, -3.143785670198429],
            [25.020189998643929, -3.142730065006188],
            [25.021450664669256, -3.140978655211841],
            [25.021512749035189, -3.140892402245869],
            [25.023170077852324, -3.138589913408336],
            [25.023595623277142, -3.134239921738616],
            [25.023615242482954, -3.134039376560118],
            [25.023620078114131, -3.133989945501511],
            [25.008959799052732, -3.123639988213883],
            [25.007579919402698, -3.120650085075153],
            [25.007978853135537, -3.118855169580088],
            [25.008000910369002, -3.11875592674525],
            [25.008500079019569, -3.116510025678934],
            [25.018339957842162, -3.10569000310168],
            [25.020619899999573, -3.098788237722763],
            [25.020629713195731, -3.098522935762576],
            [25.020637632743277, -3.098308798505593],
            [25.02084987859379, -3.09257006044229],
            [25.01923995836577, -3.088659889769448],
            [25.014660038026854, -3.084980064061914],
            [25.010212308375284, -3.083360650468281],
            [25.010153528911303, -3.083339248354639],
            [25.004580039528811, -3.081309944012086],
            [25.003129407668681, -3.079626158352219],
            [25.003087633313026, -3.079577670200713],
            [25.001719839596806, -3.077990034642338],
            [25.001149959160312, -3.074159895803806],
            [25.003658439014231, -3.069111873839685],
            [25.008919866243428, -3.063589956261696],
            [25.01372977865125, -3.063359958666902],
            [25.018310078079207, -3.065660005508939],
            [25.030910077324641, -3.077620015429701],
            [25.032417833952028, -3.077817230191175],
            [25.034346717191344, -3.078069524481683],
            [25.035441585656248, -3.076110458146459],
            [25.035495332758018, -3.076013988127487],
            [25.036400077284632, -3.074390078877774],
            [25.036850077546433, -3.065879931702747],
            [25.031624278399718, -3.057259318022507],
            [25.031395102899374, -3.056881262384829],
            [25.027229797284928, -3.050010013815505],
            [25.027584664161484, -3.047652183247103],
            [25.027597851429878, -3.047564560749996],
            [25.027680489249462, -3.047019192790475],
            [25.028350723181269, -3.04615702152183],
            [25.02858067392771, -3.0458612194035],
            [25.031799351065441, -3.041720793875312],
            [25.031339917594853, -3.040110070251243],
            [25.023744220794814, -3.038702746024605],
            [25.02368638995177, -3.038692030969603],
            [25.018980038024832, -3.037820040969903],
            [25.015236705235285, -3.03570577571752],
            [25.014728510312782, -3.035418742346553],
            [25.011650079055503, -3.033680014943135],
            [25.007849918841103, -3.029820020607631],
            [25.007379759486035, -3.024289983171399],
            [25.008558933942037, -3.022101167746159],
            [25.008628893838054, -3.021971306298126],
            [25.009049799464435, -3.021190009585786],
            [25.016669917863762, -3.015500103184479],
            [25.023069875273958, -2.999160352346393],
            [25.023133351130227, -2.99859176774424],
            [25.023245465369271, -2.997586121073451],
            [25.024659758579553, -2.984900009897178],
            [25.028880289024425, -2.979240263604718],
            [25.029318711798837, -2.978652335211081],
            [25.032899797169954, -2.973850062007827],
            [25.036814438684154, -2.96535075255083],
            [25.037100790155691, -2.964729035503696],
            [25.043179956482991, -2.95153006208364],
            [25.050489756358992, -2.929440002512761],
            [25.064889754855013, -2.90343991875184],
            [25.065369995104209, -2.900240062889444],
            [25.067272117531225, -2.887612751187612],
            [25.067339600771984, -2.887164760103887],
            [25.068769834586988, -2.877669994287937],
            [25.070431735828915, -2.873057741496377],
            [25.070529846230979, -2.872785457507747],
            [25.072418416673617, -2.867544107973288],
            [25.086589833455673, -2.841550065664878],
            [25.088409993596155, -2.830730010136441],
            [25.094358029248152, -2.823132981050636],
            [25.102590032408322, -2.816689957962029],
            [25.104879433825666, -2.810941404534403],
            [25.105119002833863, -2.809158598396091],
            [25.1052589235242, -2.808115763963693],
            [25.108059872376717, -2.787239946606051],
            [25.108557330634948, -2.785778548399319],
            [25.10857693816266, -2.785720946725041],
            [25.108710031656852, -2.785329955492119],
            [25.109400209086257, -2.783276284197911],
            [25.109502149006374, -2.782972953596565],
            [25.112398662435449, -2.774354129217281],
            [25.110099992201018, -2.761480002813245],
            [25.097039912697952, -2.742849932367341],
            [25.095429992469963, -2.730889930009938],
            [25.086710122363808, -2.702368834807665],
            [25.086891504796078, -2.698183389618102],
            [25.086900798766013, -2.697968920839958],
            [25.086939753309981, -2.697070024929241],
            [25.082349753873601, -2.680509880947785],
            [25.082698379255589, -2.676820173289947],
            [25.082742645537827, -2.676351678557561],
            [25.083479794076826, -2.668549975373287],
            [25.082675990543763, -2.66415233563188],
            [25.08262717519289, -2.663885263367261],
            [25.081419873587034, -2.657280036297758],
            [25.082779390226232, -2.645778575435353],
            [25.081758583364898, -2.643046559773957],
            [25.081383960738606, -2.642043943178606],
            [25.077279873514126, -2.631059984017071],
            [25.074278009261786, -2.600691865233198],
            [25.073973361802864, -2.600724726433515],
            [25.05884394207591, -2.602356718394704],
            [25.046967875355012, -2.595038573105918],
            [25.03599363633095, -2.583629684442992],
            [25.006751917950787, -2.562151179387915],
            [25.001692478709877, -2.545303480852436],
            [25.003935638449637, -2.530754693448424],
            [25.022371237511191, -2.51739790317828],
            [25.034435916305799, -2.509478221782323],
            [25.04671551523548, -2.496327919895486],
            [25.042691250510519, -2.494258389680672],
            [25.037810890421486, -2.49174861087232],
            [25.032338584577655, -2.49173006285998],
            [25.017976023371105, -2.492818527791443],
            [25.002681398073545, -2.486170480070614],
            [24.999453638069966, -2.472284742169125],
            [25.004905837821124, -2.464342277340633],
            [25.014238477528661, -2.458005233157659],
            [25.032901596495474, -2.444421170822301],
            [25.049268635969121, -2.424687579079658],
            [25.048323953243287, -2.411946279905707],
            [25.026255276118604, -2.413464101244318],
            [24.997265199205728, -2.419051722098672],
            [24.989061170481804, -2.420843597062327],
            [24.979016439841807, -2.416260256146019],
            [24.960730575565076, -2.39891060893407],
            [24.952521521665457, -2.398882874869334],
            [24.931541108591752, -2.397901655689819],
            [24.931517682325776, -2.388802842832805],
            [24.931480602565784, -2.374244582594407],
            [24.926003539244196, -2.372406174496733],
            [24.912322124703522, -2.372359711305147],
            [24.86853460676517, -2.369481355924489],
            [24.824753928599382, -2.369332608509787],
            [24.784621851384834, -2.369196288098415],
            [24.719853915881153, -2.365336678846738],
            [24.706181824954825, -2.368929763610272],
            [24.694308306754358, -2.362520265175486],
            [24.693368336590495, -2.351598250555169],
            [24.689645576119311, -2.322468540663301],
            [24.684868736086962, -2.237827096462136],
            [24.681097016534466, -2.189584700180501],
            [24.663639177065804, -2.139474287967816],
            [24.648085017702893, -2.120310460720037],
            [24.621559859539115, -2.091098679615887],
            [24.608722979943135, -2.064662828331981],
            [24.604048380766567, -2.020052480580124],
            [24.598389880215485, -1.980783041311686],
            [24.97823501064752, -1.981554860715821],
            [24.980700492640331, -1.979569687120944],
            [24.983949151948988, -1.976953881612969],
            [24.989892917908413, -1.974651943352339],
            [24.990498534225203, -1.974545222374752],
            [24.999999953899895, -1.97287085711621],
            [25.000826113805456, -1.972725827345009],
            [25.000876825499866, -1.972716924655838],
            [25.024499874628649, -1.968569995265934],
            [25.024513440986084, -1.968570964170177],
            [25.028783403924404, -1.96887747682221],
            [25.049065926633663, -1.97033342356664],
            [25.055673419128986, -1.98060523061864],
            [25.068226622436359, -1.975504293725611],
            [25.086726631602101, -1.974903939754881],
            [25.118441159532832, -1.976255776859506],
            [25.13495909890624, -1.985267062642135],
            [25.160066516125646, -1.98532236192639],
            [25.188477015288562, -1.980256187192269],
            [25.19706662518697, -1.982839345933382],
            [25.201691543935056, -1.992465536108259],
            [25.200370344035989, -1.998232360623233],
            [25.197066984513075, -2.009764327504627],
            [25.198388544636547, -2.014254572700056],
            [25.207638744153854, -2.020044554254614],
            [25.208960304277326, -2.027740182607497],
            [25.203013823609105, -2.033496613586218],
            [25.197067704961913, -2.037970942417055],
            [25.190460624793321, -2.041802597098966],
            [25.185175105646501, -2.046278342247826],
            [25.178568025477908, -2.051392230008333],
            [25.172621546606312, -2.062277017259059],
            [25.175264666853295, -2.068693264325412],
            [25.175925626578096, -2.077669265305668],
            [25.185175826095371, -2.083458834695923],
            [25.200372513467411, -2.087979479098932],
            [25.211604504299284, -2.086081100847562],
            [25.232086302982996, -2.075869610227403],
            [25.240084503420807, -2.111983789340608],
            [25.298458096883149, -2.091108584816453],
            [25.329770893727247, -2.081050539542988],
            [25.422588246972133, -2.054670894218895],
            [25.425059194315153, -2.048144746765959],
            [25.429211248880847, -2.037178481253303],
            [25.430340125765795, -2.034196916019292],
            [25.439396284690133, -2.020720006289698],
            [25.439926205367811, -2.019930898696123],
            [25.448147163741563, -2.011184945891048],
            [25.457744403114351, -2.005427893431956],
            [25.469391122756726, -1.99368893473429],
            [25.472373516025247, -1.989217220358534],
            [25.474334306525169, -1.986277259447338],
            [25.478292121071906, -1.980342996596691],
            [25.48869895541641, -1.97093031574293],
            [25.4932196776764, -1.966841435722895],
            [25.496107080391877, -1.964229848003596],
            [25.499279897636018, -1.962774900019516],
            [25.50074364220438, -1.962103674636944],
            [25.501133399646598, -1.961924945435965],
            [25.509821278948856, -1.960766909065446],
            [25.515555013404981, -1.957234919830367],
            [25.518045092168588, -1.955701004798507],
            [25.534502157206749, -1.95154600205175],
            [25.535615760935219, -1.950843821980115],
            [25.53633199849105, -1.95039220013483],
            [25.538156156134512, -1.949241982946081],
            [25.547289774090874, -1.939574948498454],
            [25.551669777956537, -1.934939125888219],
            [25.556423274367912, -1.92990798280816],
            [25.560310065413365, -1.929147174438838],
            [25.561355965813824, -1.928942447872679],
            [25.563509164667789, -1.928520985205483],
            [25.564026031926073, -1.928208271926187],
            [25.571504393478634, -1.923683927134199],
            [25.60025540264326, -1.921888706043896],
            [25.601451993636019, -1.921813987148363],
            [25.603440089327282, -1.920006213135947],
            [25.608969904417297, -1.914977755045546],
            [25.613098049423375, -1.91122387733733],
            [25.623376968163019, -1.905234100954055],
            [25.628423558800442, -1.903585765267269],
            [25.632780101365817, -1.902162814738618],
            [25.637285218991028, -1.900691334496016],
            [25.638917874680551, -1.900157970758868],
            [25.640928637561373, -1.899262073468133],
            [25.647292796209172, -1.896426462668355],
            [25.656509274767334, -1.892320068321582],
            [25.662066687899507, -1.886833536216781],
            [25.667469223391837, -1.881499958448865],
            [25.670660206367685, -1.875287996809196],
            [25.674288342798409, -1.854588948458898],
            [25.675314234124251, -1.853332099721337],
            [25.675961675102336, -1.852538900759443],
            [25.677482262366933, -1.850675980598121],
            [25.693690663852955, -1.841978055777181],
            [25.698205298230285, -1.839555357244822],
            [25.698953352316813, -1.839153893985727],
            [25.713335018892831, -1.824650971962121],
            [25.719961178379776, -1.822112959175861],
            [25.726391136825502, -1.821817887147777],
            [25.730247096792073, -1.821640987266982],
            [25.742357135118652, -1.818406901532088],
            [25.760416125378772, -1.817695887389103],
            [25.762821930490638, -1.818398502419287],
            [25.763784267806763, -1.818679560827672],
            [25.765905093174496, -1.819298964458348],
            [25.772314181959551, -1.823889847813806],
            [25.7781736248599, -1.830579435807439],
            [25.787201250595864, -1.84088595573494],
            [25.790174130705559, -1.842491900645992],
            [25.79527748858073, -1.842806270103023],
            [25.795497754590091, -1.842819838478195],
            [25.801149029093022, -1.843167956615944],
            [25.810030753155477, -1.839469863033462],
            [25.815122240692503, -1.837349891980569],
            [25.823309247240093, -1.833941017046512],
            [25.827161379485265, -1.833758955298555],
            [25.843428356517727, -1.832990133832669],
            [25.843436595865501, -1.832938590712083],
            [25.84675373105334, -1.80703535697343],
            [25.850235372922505, -1.779847109458099],
            [25.851993178304156, -1.766120189221674],
            [25.851998985912456, -1.766075105507083],
            [25.848020159771213, -1.708819992026666],
            [25.848627111882823, -1.704993916066546],
            [25.84937015965826, -1.700309918279312],
            [25.861890295980039, -1.669029824880699],
            [25.863260012989279, -1.668568597619339],
            [25.863009840267477, -1.655459991827869],
            [25.866651780210905, -1.64671998142474],
            [25.867638358564935, -1.643174836547984],
            [25.868700000144134, -1.639359951474558],
            [25.866309959567193, -1.57867006250599],
            [25.863557856608249, -1.561371008157544],
            [25.858509840344464, -1.529640020097462],
            [25.856948974419183, -1.519812209437963],
            [25.854760080109084, -1.506030020688526],
            [25.856643856243046, -1.493446958110187],
            [25.85679024480342, -1.492469697233616],
            [25.863170040425356, -1.479129982853036],
            [25.86508784474227, -1.470502337505474],
            [25.866339840228481, -1.464869956278091],
            [25.862948501503237, -1.450587753870507],
            [25.859900160214767, -1.437749961326537],
            [25.860999857124305, -1.411542549932692],
            [25.861015629744074, -1.411547897633125],
            [25.865489880357785, -1.4137800592612],
            [25.868513428144468, -1.416495532310019],
            [25.878840120189185, -1.425769997203826],
            [25.889590172057684, -1.431961098267454],
            [25.890749074232655, -1.446075899498522],
            [25.890760080391527, -1.44620995069625],
            [25.892368912759725, -1.452466568997865],
            [25.892830079978815, -1.454260009000905],
            [25.895915443535127, -1.456933712164813],
            [25.901300160045501, -1.461599971683625],
            [25.920050296118923, -1.470770157587135],
            [25.920547307016196, -1.471204292587418],
            [25.928979840198931, -1.478570004572102],
            [25.928743196105323, -1.485127279132479],
            [25.928539919932927, -1.490759944608604],
            [25.930600042543663, -1.493740098949691],
            [25.933579554915092, -1.495349808047641],
            [25.934571859130756, -1.495301913799863],
            [25.943479920000748, -1.494870028364915],
            [25.958260080135098, -1.494159970584864],
            [25.982039879891069, -1.502630013384029],
            [25.985229839685786, -1.501250081600987],
            [25.991095659726366, -1.501051320601468],
            [25.999400609680869, -1.50076956823086],
            [26.015370321609389, -1.488100007104662],
            [26.015670919463027, -1.487038648087011],
            [26.015757514361461, -1.486733315081628],
            [26.016739743072915, -1.483269993131809],
            [26.015203868278817, -1.477858361175432],
            [26.015087155563862, -1.477447126547506],
            [26.01373986409736, -1.472699953104107],
            [26.014189864359164, -1.468559920171325],
            [26.016483601046069, -1.466891294864639],
            [26.016627624342313, -1.466786522290079],
            [26.018299982872456, -1.465569930527335],
            [26.022266822792865, -1.464515177498807],
            [26.022410872140259, -1.46447687566431],
            [26.027889662023803, -1.463020103600341],
            [26.033438732501935, -1.458669245437084],
            [26.033730545730386, -1.458440443663003],
            [26.034050090850005, -1.458189669282888],
            [26.035639741491948, -1.453660023637175],
            [26.039049660072195, -1.443920092882594],
            [26.03851228966586, -1.442329189959847],
            [26.038391543515267, -1.441971717956029],
            [26.034239700951957, -1.429680020898656],
            [26.028041333576372, -1.425120784896436],
            [26.027867625451574, -1.424993013131376],
            [26.026449661725056, -1.423950021257666],
            [26.017279742848089, -1.411329990808737],
            [26.017279742848089, -1.411317019808602],
            [26.017279742848089, -1.409707965180959],
            [26.017279742848089, -1.409481952091446],
            [26.017279742848089, -1.407639931338435],
            [26.021289640816704, -1.402140372827015],
            [26.021680342388276, -1.401604526469846],
            [26.023659662437527, -1.398889890217127],
            [26.025848712156186, -1.397392876173817],
            [26.026016811200343, -1.397277921151863],
            [26.030049722209899, -1.394520013313878],
            [26.052219916148204, -1.397699974370191],
            [26.054047316709887, -1.397561383559579],
            [26.054101805820061, -1.39755725093285],
            [26.061579897878058, -1.396990075646893],
            [26.064910193384772, -1.394695532188035],
            [26.0650558318519, -1.394595189064489],
            [26.065919696744864, -1.393999992337896],
            [26.069559656801388, -1.384799988001409],
            [26.069319953944259, -1.378591550626218],
            [26.067439976785622, -1.347099957869661],
            [26.071686894343671, -1.327062179263064],
            [26.071728667800993, -1.326865083913149],
            [26.067147020001794, -1.311888605483624],
            [26.066777849250958, -1.31068254378252],
            [26.066670005602777, -1.310329749638798],
            [26.067170100416419, -1.308528022580744],
            [26.067337418824597, -1.307925213400381],
            [26.069159696294204, -1.301359952755065],
            [26.069273489484491, -1.294144977424117],
            [26.069283238900255, -1.293526828807406],
            [26.069369936206659, -1.28802987434199],
            [26.07257887650502, -1.284643340343774],
            [26.072773796548645, -1.284437632409874],
            [26.074609735597075, -1.28250008486993],
            [26.081919978342544, -1.281340037859112],
            [26.081118532887061, -1.275595676252204],
            [26.07961427968932, -1.264815273862415],
            [26.0589416402117, -1.259591575735583],
            [26.060274720330387, -1.238881916363148],
            [26.074277640114641, -1.191661294269072],
            [26.080278839861762, -1.155426293278282],
            [26.086947120454042, -1.14767331457448],
            [26.111620799613267, -1.147727734794197],
            [26.132293079764747, -1.141300089004177],
            [26.140962239973117, -1.132904304471485],
            [26.132292720438645, -1.116702813755392],
            [26.105618159866737, -1.103697984399277],
            [26.082944639874729, -1.090702106896698],
            [26.073605879945166, -0.962511943236666],
            [26.11278703653257, -0.953106903793259],
            [26.126262359580746, -0.954462934777083],
            [26.146120201044528, -0.949143925029407],
            [26.149398346654074, -0.946007048741598],
            [26.163440280271072, -0.932569860638554],
            [26.170057440435496, -0.929800937067492],
            [26.185127399775471, -0.929084962738938],
            [26.209643759673913, -0.922676150934599],
            [26.228315520433771, -0.911065003751866],
            [26.243652960336092, -0.894267689293981],
            [26.259656759736405, -0.855461956913107],
            [26.253654480214273, -0.845091010212369],
            [26.248986719911947, -0.839901922345504],
            [26.244984959781501, -0.826945932493958],
            [26.24415197178147, -0.821486419495136],
            [26.236981799744985, -0.774491870023507],
            [26.238980880035555, -0.712348721398073],
            [26.237646720141893, -0.687745403258327],
            [26.230238279857776, -0.668004877273968],
            [26.231127253561247, -0.667393837771798],
            [26.235935280405293, -0.664089022095906],
            [26.236640173137381, -0.661878071932932],
            [26.24069843999418, -0.649148982537907],
            [26.2520834399701, -0.635574985438411],
            [26.256624480325172, -0.624769901222588],
            [26.256752280047372, -0.622817904391264],
            [26.257665713977744, -0.608876412682818],
            [26.25861132017166, -0.594443853993346],
            [26.258367424877076, -0.588545491346106],
            [26.257889520247637, -0.576987858298796],
            [26.267364359671372, -0.525977916918014],
            [26.273706477255356, -0.504145905665844],
            [26.273465991067287, -0.498403737617566],
            [26.188293398806611, -0.437095126864222],
            [26.152282604367713, -0.41500392864132],
            [26.138945326327534, -0.40332128539279],
            [26.123607527997407, -0.389691784194942],
            [26.109110330889344, -0.37260598810203],
            [26.114113249929243, -0.36455997254514],
            [26.123522754882352, -0.357431333100011],
            [26.125961207466599, -0.355583960452509],
            [26.129007740446411, -0.352103877400026],
            [26.13119709828721, -0.349603026783653],
            [26.142799124947558, -0.331671856385171],
            [26.148611800655917, -0.324658654594286],
            [26.150995244005404, -0.321782942588833],
            [26.153170902538101, -0.314852345861664],
            [26.154169004480597, -0.311672875119661],
            [26.157806083639997, -0.305007921817424],
            [26.164861002723843, -0.29695896605509],
            [26.170768241387226, -0.284088987511418],
            [26.163347441183113, -0.276257724758852],
            [26.159190404560817, -0.271870749827469],
            [26.157734083670004, -0.270333875442131],
            [26.142202207017661, -0.262552914044838],
            [26.135799286065378, -0.255903958232583],
            [26.124580248041585, -0.237323994766857],
            [26.122247967340751, -0.234818512231668],
            [26.114977249569506, -0.227007849354032],
            [26.109067036584232, -0.225500241173107],
            [26.107799676313402, -0.225176956036769],
            [26.104248110480835, -0.224270901546926],
            [26.101058285433382, -0.221231807473262],
            [26.099676171673231, -0.219914976723295],
            [26.098838769351893, -0.218656371446068],
            [26.095753453406292, -0.214019176293885],
            [26.092809172061997, -0.209593952542572],
            [26.082536212745964, -0.199077009109441],
            [26.081836013711243, -0.198360943670095],
            [26.079234744176706, -0.193149265935588],
            [26.075666831700925, -0.186000901553044],
            [26.074049214707543, -0.182759980309248],
            [26.072820239448816, -0.179336013191551],
            [26.068971238730725, -0.168612556492121],
            [26.067625016259438, -0.164861930795269],
            [26.0649829156003, -0.161273574746992],
            [26.048245857366155, -0.085885953357407],
            [26.035574939722299, -0.060608342071807],
            [26.033574060106208, -0.048950274306079],
            [26.039575619179466, -0.039575768548288],
            [26.047299717572958, -0.036559914970309],
            [26.049290987012135, -0.036449599099854],
            [26.049316593489298, -0.03644818014444],
            [26.051629857753841, -0.036320022876382],
            [26.055964591919079, -0.030280510698585],
            [26.056274715508003, -0.029848421110142],
            [26.056410055688708, -0.029659614111458],
            [26.056648570973039, -0.028846995738343],
            [26.056751311292107, -0.028496958672263],
            [26.058229737027133, -0.023459972106857],
            [26.057069879044686, -0.013799981692383],
            [26.064329935610147, -0.014290029651895],
            [26.067461027906006, -0.018281270631536],
            [26.0686422990299, -0.019434443881684],
            [26.068816014341206, -0.019604027618586],
            [26.072079654853855, -0.022790042384657],
            [26.0736298146576, -0.027420071803745],
            [26.070304336815752, -0.030647925215901],
            [26.070220035316208, -0.030729663021717],
            [26.069240286853269, -0.030736331841272],
            [26.064110646069523, -0.030771557931636],
            [26.064563354751911, -0.032412262975328],
            [26.064693022071577, -0.03288193271606],
            [26.065010600779047, -0.034030266513554],
            [26.067059816045592, -0.034999990072545],
            [26.077445904696926, -0.036554145094256],
            [26.077619558922834, -0.036580130337068],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kolwezi",
        AREA: 121308,
        POPULATION: 2570000,
        DISTRICTS: ["Sandoa", "Lubudi", "Kapanga", "Dilolo", "Mutshatsha"],
        OBJECTID: 15,
        NOM: "Lualaba",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [21.9628375199838, -7.699764338075724],
            [21.970014479690555, -7.703349286919889],
            [21.979943999598742, -7.698644414258684],
            [21.994734059167538, -7.691633079445459],
            [21.994764479716313, -7.688105985832433],
            [21.998412983649498, -7.682520960088669],
            [22.002397199682459, -7.676421948770226],
            [22.002403316311231, -7.674241894351717],
            [22.00240944012651, -7.672058970732401],
            [22.008436199638442, -7.673393997558522],
            [22.023705240018401, -7.674981915886133],
            [22.033460519999142, -7.682579406639094],
            [22.038806159794643, -7.696752270698547],
            [22.042504799602167, -7.72170215940102],
            [22.052631959652626, -7.734483867761605],
            [22.059075240114002, -7.740765825851632],
            [22.060795035081039, -7.742282533526705],
            [22.06662227966666, -7.747421609311386],
            [22.072514399683794, -7.754861538311435],
            [22.079695320062651, -7.763634287396848],
            [22.086691560293826, -7.771447824354644],
            [22.094240760294735, -7.780409131124487],
            [22.132171799773189, -7.828476689312254],
            [22.138251479936798, -7.840140021671946],
            [22.14372631813141, -7.852736774456312],
            [22.14739717125055, -7.856826605783178],
            [22.151991240055182, -7.861944906295809],
            [22.160499479656806, -7.86610291510815],
            [22.163252400082676, -7.870243921771044],
            [22.165096319764086, -7.881365899453367],
            [22.181879880187211, -7.881808422308331],
            [22.189054320119606, -7.882125990125182],
            [22.204688760122856, -7.880635975074719],
            [22.246297753902741, -7.875021337623488],
            [22.253613840189129, -7.874034110657251],
            [22.266305640070112, -7.873147797191739],
            [22.291137359837258, -7.871188259278598],
            [22.316805711171231, -7.863160942545925],
            [22.32975708015185, -7.859110574573653],
            [22.348513799978004, -7.851251569350437],
            [22.397239080352083, -7.824285628058059],
            [22.41010944015872, -7.81648058859267],
            [22.421320919757701, -7.804463785898052],
            [22.427024760077817, -7.806332227662206],
            [22.430761220755404, -7.813652940768723],
            [22.432594324720828, -7.816872030818311],
            [22.432599492728659, -7.816980457027542],
            [22.432813371716332, -7.821463997463759],
            [22.446910080107813, -7.830356626682339],
            [22.473225360380159, -7.843753391867606],
            [22.48536887981566, -7.847482949845659],
            [22.496587919636113, -7.844881136196245],
            [22.512579120164531, -7.829170285783713],
            [22.521934439638052, -7.820102915530737],
            [22.524509160362669, -7.802433931028658],
            [22.542749279730206, -7.781591863671004],
            [22.545297360016736, -7.774712006536516],
            [22.548526199795297, -7.772424885553588],
            [22.55384051982843, -7.765322926465505],
            [22.559837399577336, -7.760976948168875],
            [22.564845986088358, -7.759015230741849],
            [22.570900199911982, -7.756643959150089],
            [22.576071052706038, -7.756219238532542],
            [22.581724319672261, -7.755754892440978],
            [22.590510109950589, -7.752520502520875],
            [22.59163318461712, -7.752107053786614],
            [22.600170359852381, -7.744553990767302],
            [22.6079993679963, -7.74296870054112],
            [22.605479999662865, -7.737449948435011],
            [22.599730360534629, -7.736288735476419],
            [22.604339880362144, -7.733089928071356],
            [22.609409126511029, -7.732640011023824],
            [22.609805882727603, -7.733171593699343],
            [22.61077991970199, -7.734480117862637],
            [22.610941247245524, -7.739702221350367],
            [22.610999856927954, -7.741599354496039],
            [22.611981856568981, -7.742459341720683],
            [22.612839180828381, -7.74320950627836],
            [22.616750159911177, -7.743449901501815],
            [22.619834433811043, -7.746538270752772],
            [22.624559999803566, -7.751270067949037],
            [22.628438358363468, -7.752309570165617],
            [22.631469840070707, -7.753130001333809],
            [22.636980000022294, -7.760490010856497],
            [22.645500119843565, -7.76463993674985],
            [22.65163895047538, -7.775378379586281],
            [22.65167986783824, -7.775449953040279],
            [22.651562947612454, -7.776063177538134],
            [22.65098003980772, -7.779119977621356],
            [22.645450080088981, -7.781860049039764],
            [22.645378840991992, -7.781942598317099],
            [22.642679879670311, -7.785070048762759],
            [22.644088488341453, -7.787424458648189],
            [22.646120040034603, -7.790820059742633],
            [22.646714280984952, -7.793817074546975],
            [22.647030119655678, -7.795409977198086],
            [22.646679429945159, -7.796680110153155],
            [22.644939960076794, -7.802980095235108],
            [22.64721984025044, -7.811710046282913],
            [22.6464855106248, -7.813028819238661],
            [22.644920160309606, -7.815839996531603],
            [22.646519999643495, -7.823420094531017],
            [22.648135047455145, -7.825421198082129],
            [22.64948999975439, -7.82710002606189],
            [22.655413998285987, -7.828771865994797],
            [22.656859920279103, -7.829179925790978],
            [22.663749959880761, -7.836769954450485],
            [22.670507851015898, -7.849685848543271],
            [22.670613757896302, -7.849888519502309],
            [22.671089999744183, -7.850799907844666],
            [22.672153723618219, -7.851021439808882],
            [22.675460040395045, -7.851710014093497],
            [22.675465305420929, -7.851722157274075],
            [22.676328721156278, -7.853713631331677],
            [22.677059879728933, -7.85540004639592],
            [22.674980160370282, -7.859299982693381],
            [22.666449948875123, -7.866620626424926],
            [22.666190040212278, -7.880159890234557],
            [22.661089919865379, -7.895989988354922],
            [22.687740359773628, -7.882201320433347],
            [22.719361680307124, -7.859622744590765],
            [22.743625319861625, -7.837111122383416],
            [22.756897069395066, -7.825801388175665],
            [22.766419799803266, -7.817686249308244],
            [22.773777479883925, -7.817617869723354],
            [22.777459560147488, -7.821426397952147],
            [22.784081759860662, -7.821364981497251],
            [22.798796399573146, -7.819691211379585],
            [22.817193479773593, -7.822594551387817],
            [22.834858680054218, -7.830115788371702],
            [22.892276880177601, -7.863396072532563],
            [22.917308040310864, -7.881606172014862],
            [22.940858880162164, -7.88830323615574],
            [22.963655879878164, -7.871954616625279],
            [22.984252559611981, -7.864847233626422],
            [23.000444639607643, -7.87084444234419],
            [23.021045640237965, -7.869116248130881],
            [23.045323679786478, -7.865048600041404],
            [23.052873977528673, -7.867528936496607],
            [23.070347279698307, -7.8732690067531],
            [23.083963199868265, -7.874910962415384],
            [23.087879399061162, -7.865007787883172],
            [23.089039200449761, -7.862074867132194],
            [23.091591239611766, -7.850832935289993],
            [23.097920991885868, -7.837776148569402],
            [23.103376200094903, -7.826523008157959],
            [23.113510088526859, -7.818048254470482],
            [23.120901360209249, -7.811866982301728],
            [23.150661480170204, -7.776572013101144],
            [23.15518452008364, -7.774435959978237],
            [23.166786240418478, -7.772470952682213],
            [23.170475519780712, -7.769493873341111],
            [23.184984230595774, -7.76883278236209],
            [23.185065745521289, -7.769547267040799],
            [23.186346479910075, -7.780773021761777],
            [23.181740280255838, -7.781682925245528],
            [23.182062637102302, -7.783306063830545],
            [23.182424279971066, -7.785127006230941],
            [23.178788686625133, -7.790288454163889],
            [23.175964450745489, -7.794297974590672],
            [23.176185480322854, -7.799807907787631],
            [23.177055304639431, -7.802987340258312],
            [23.179390154521929, -7.81152169753884],
            [23.184595649048283, -7.811952077903037],
            [23.187910206071216, -7.812226014721091],
            [23.184437400031204, -7.824156904954273],
            [23.185577520230229, -7.831963940751751],
            [23.18142348038775, -7.837235913302451],
            [23.18165027984417, -7.839530887733938],
            [23.187007409990478, -7.841265345615125],
            [23.188785452618845, -7.841841014350877],
            [23.185316371892291, -7.85216407886524],
            [23.174713389507197, -7.858112044985343],
            [23.172865200133216, -7.862010958491861],
            [23.173090200264117, -7.865224974051348],
            [23.176996155967846, -7.87051190066995],
            [23.170541400427012, -7.874860978982174],
            [23.172883929108565, -7.889009177072388],
            [23.174875440194562, -7.901036940068257],
            [23.17832027988317, -7.90815886547731],
            [23.176702440107604, -7.91113993754455],
            [23.18075640044092, -7.923726208599265],
            [23.200384300141398, -7.937350879017258],
            [23.197843476445723, -7.94216610450419],
            [23.198162220268095, -7.943124844500842],
            [23.19944723962077, -7.946989987581329],
            [23.20353606626519, -7.948695988679463],
            [23.204971440240254, -7.94929487464443],
            [23.20565616040432, -7.953656882879073],
            [23.209797240252172, -7.957336889391942],
            [23.214177169557715, -7.956722117554285],
            [23.214634200034901, -7.956657967644884],
            [23.224086359692691, -7.950478904206311],
            [23.22823140021265, -7.950715923563354],
            [23.235549403503839, -7.959381677228914],
            [23.236967410349518, -7.961060814570429],
            [23.241972240106008, -7.964508870392657],
            [23.247322199899717, -7.968195024425363],
            [23.25538224036168, -7.968898019901463],
            [23.263557694574732, -7.973291244659142],
            [23.26780943967908, -7.97557597620309],
            [23.279757480318892, -7.970441608882069],
            [23.29078463999463, -7.95766278589788],
            [23.309536679598168, -7.944043625204824],
            [23.322045600453585, -7.94469579668744],
            [23.340587847505653, -7.947480348395656],
            [23.376091320184486, -7.952811970705413],
            [23.380237439581126, -7.952359886219939],
            [23.38422087407978, -7.953501514816835],
            [23.389906319597802, -7.955130924193321],
            [23.399349479933065, -7.954916930276227],
            [23.40073435511443, -7.953541988539494],
            [23.437002004842498, -7.945193374124107],
            [23.442347879996603, -7.943962773474825],
            [23.449710240299911, -7.949656652120363],
            [23.460018480050415, -7.958780398071887],
            [23.479261200123382, -7.961929933783662],
            [23.48178631767464, -7.967670888961101],
            [23.48453312147171, -7.968903169148159],
            [23.488462439661053, -7.970665945866209],
            [23.492828519639808, -7.978934900913648],
            [23.49743435996794, -7.979630917883705],
            [23.508497160302586, -7.974138952797686],
            [23.510979626742454, -7.97379735784945],
            [23.518402200220937, -7.972775988546719],
            [23.526008279749028, -7.967278932292904],
            [23.532489284960782, -7.95917393734379],
            [23.541434946613581, -7.948056029322996],
            [23.541462221262254, -7.948022131203343],
            [23.559429240206974, -7.945293886132231],
            [23.55994224021795, -7.944903905813767],
            [23.567266440087991, -7.939337932566458],
            [23.57348436019403, -7.939805916583273],
            [23.574867310285747, -7.93820109307747],
            [23.583614759569425, -7.936504496312272],
            [23.589138239740038, -7.942983978979773],
            [23.592084839636112, -7.947182210817957],
            [23.625578879839026, -7.966846674798157],
            [23.63073047993992, -7.96795123261749],
            [23.647654439855401, -7.968946564310124],
            [23.688383256235095, -7.967504882081477],
            [23.684595650875128, -7.976539672431386],
            [23.682613355605625, -7.981268075375941],
            [23.685140520417434, -7.987927886931803],
            [23.683523400192414, -7.992285908611804],
            [23.691078360190943, -7.999999955761689],
            [23.689920240448576, -8.003351003811874],
            [23.674129199836788, -8.029343961696069],
            [23.671956530897365, -8.03608043626496],
            [23.667755399571043, -8.049105941207152],
            [23.668230240047087, -8.052775974391515],
            [23.673728285318749, -8.059090430569979],
            [23.675401439756218, -8.061012013909343],
            [23.677148012603567, -8.06528297784177],
            [23.677591320416528, -8.066367008675872],
            [23.681213280031375, -8.075222967247969],
            [23.689071360352862, -8.081849909344847],
            [23.692787255000329, -8.089870837408535],
            [23.691947381413648, -8.096955898948362],
            [23.691671285109411, -8.099284980362913],
            [23.69179288465951, -8.100224556043029],
            [23.693809320401368, -8.115804877011188],
            [23.698290696451927, -8.128740617980842],
            [23.700798359737213, -8.135978943539804],
            [23.693321519930734, -8.168601938599883],
            [23.687473320344456, -8.184168961183579],
            [23.684425200041542, -8.192279908535461],
            [23.68468835970738, -8.200771857364829],
            [23.688200978182486, -8.21320503532062],
            [23.692398480315035, -8.228061894897545],
            [23.700552480064172, -8.250299892832608],
            [23.701373958848762, -8.25677751577928],
            [23.701978439695019, -8.26154396732314],
            [23.701368835756714, -8.275430598313697],
            [23.701343399959434, -8.276010016470661],
            [23.692703399963506, -8.306040903860202],
            [23.689970280203159, -8.31554088269003],
            [23.690933266102892, -8.326098123543158],
            [23.689594440359638, -8.33804186384466],
            [23.681867399983613, -8.367229970614488],
            [23.675115240099959, -8.410879887501368],
            [23.6723635234166, -8.418235693624885],
            [23.669180280325243, -8.426744868916481],
            [23.669394273398979, -8.42727259586127],
            [23.670110159713509, -8.429038030860577],
            [23.668289596229467, -8.432864604717601],
            [23.667593400087647, -8.434327903095165],
            [23.665668607776148, -8.43545806000483],
            [23.655395520001026, -8.441489924600228],
            [23.653768227253739, -8.443196087311787],
            [23.650341479634971, -8.446788893045881],
            [23.647580094384189, -8.452070596156478],
            [23.645530439841458, -8.455990923190388],
            [23.643590968159891, -8.461974026574719],
            [23.641655399658237, -8.467944993852393],
            [23.640091200084925, -8.481729006507656],
            [23.646896279721926, -8.513392869867909],
            [23.648565239925347, -8.527625933625595],
            [23.651128439756459, -8.534734868932839],
            [23.653179360923758, -8.536962845000353],
            [23.656515480208455, -8.540586941358265],
            [23.657827367272983, -8.542014788903538],
            [23.658079320455663, -8.542289012093152],
            [23.664939359920083, -8.546244678627801],
            [23.678659439747225, -8.554155887841784],
            [23.688177480051277, -8.568819000958149],
            [23.688419399950579, -8.572032923925724],
            [23.681524319901875, -8.579177904758641],
            [23.679237239731229, -8.584467992672991],
            [23.678146449617682, -8.601006731865869],
            [23.680717199788763, -8.609724960327064],
            [23.686765199965564, -8.622103899837372],
            [23.692796280374001, -8.629661983922306],
            [23.691605039747085, -8.653997504780833],
            [23.690885040046879, -8.673943201488472],
            [23.696059680138163, -8.704568338173432],
            [23.729001480121855, -8.781284256848888],
            [23.748411600349701, -8.767001946928506],
            [23.755012560296272, -8.768612149188481],
            [23.763004200337576, -8.773411369709919],
            [23.77166724032389, -8.777074814243839],
            [23.781440519847969, -8.77778327759553],
            [23.795519759600431, -8.777365643760643],
            [23.805055800346189, -8.776935899735491],
            [23.820067079935168, -8.779250957722951],
            [23.837604839819665, -8.784758132170925],
            [23.850556199817149, -8.785247528639355],
            [23.858065800283743, -8.786859966056003],
            [23.871475080090541, -8.78780580519291],
            [23.880312360004332, -8.785326600561996],
            [23.892309359725452, -8.780580608898548],
            [23.898661560000154, -8.77968728868284],
            [23.911197479721469, -8.790466999339515],
            [23.922687240327495, -8.778241872582422],
            [23.9250768155771, -8.778231232049977],
            [23.929846199592575, -8.778209993878676],
            [23.931734213978046, -8.776693297870578],
            [23.933298240176519, -8.775436865785528],
            [23.935350219559197, -8.770144926926466],
            [23.938358399866299, -8.771508929219555],
            [23.942770053176069, -8.776542852569799],
            [23.949709200081021, -8.778807857849264],
            [23.959173239958421, -8.777959858600797],
            [23.968637279835853, -8.777111858282556],
            [23.973032159802624, -8.7784700117081],
            [23.977227959627736, -8.786490071533731],
            [23.980079160237221, -8.802785032806067],
            [23.982872040421878, -8.806906920000877],
            [23.991213959643595, -8.812839997992505],
            [23.995868378167302, -8.819708215490163],
            [24.00050699981675, -8.821972977314529],
            [24.001795079729632, -8.82321005284963],
            [24.004377000451253, -8.826434051834346],
            [24.007979879849451, -8.829646981166881],
            [24.010543079680566, -8.830868004679774],
            [24.013875959640359, -8.832581917714258],
            [24.018254999613742, -8.837036986640856],
            [24.022537021536429, -8.840941253029246],
            [24.02623799965863, -8.844704085273365],
            [24.03112283964602, -8.848652066046046],
            [24.038326079566392, -8.854826978037467],
            [24.043209120228262, -8.858525037684819],
            [24.048366120102308, -8.864222065410306],
            [24.052993919747525, -8.86792305618015],
            [24.057384120390012, -8.873379927085493],
            [24.062268960377367, -8.877327953159527],
            [24.065628840101322, -8.88179493465551],
            [24.070002120077113, -8.885498950400912],
            [24.073857000268742, -8.888458005482173],
            [24.082545960244271, -8.890108976239544],
            [24.088425120266812, -8.89129205186004],
            [24.09304283991623, -8.89399094487638],
            [24.099702120287692, -8.89666702938047],
            [24.10614215962751, -8.903101052395851],
            [24.110283959924267, -8.909310997933355],
            [24.110574839803139, -8.913062977208062],
            [24.107806080282213, -8.916851057519716],
            [24.104037960279058, -8.920014940358557],
            [24.099208920043871, -8.92417608418393],
            [24.096247920153825, -8.932461912222385],
            [24.097896291869237, -8.937965999150055],
            [24.105975840145938, -8.936546008980294],
            [24.124875459475895, -8.9392051329478],
            [24.146907840171522, -8.942305002299893],
            [24.158243159718964, -8.944771918530529],
            [24.165660960448335, -8.948866912023556],
            [24.175366920225038, -8.949044033215475],
            [24.179195545355828, -8.950522331138279],
            [24.192968198186669, -8.955840069378485],
            [24.194519018252112, -8.955756317668193],
            [24.211910659969167, -8.954817077242931],
            [24.216445436371782, -8.958076443429908],
            [24.219897839875085, -8.960557964778902],
            [24.221423879913427, -8.961656078810721],
            [24.223766040285739, -8.966926942733185],
            [24.245543879752347, -8.976222990492523],
            [24.249724920257318, -8.979876017842091],
            [24.25206492018134, -8.984915934310642],
            [24.25049209228974, -8.992276091243351],
            [24.253778879692298, -9.000758056723406],
            [24.25302388701849, -9.003130523631508],
            [24.251507999739474, -9.007893955613113],
            [24.266754000129044, -9.045256087649717],
            [24.274222949134053, -9.057158983060617],
            [24.274909561150139, -9.057791424505162],
            [24.278353920240068, -9.060964018410631],
            [24.28521533412685, -9.06728037619021],
            [24.285381120009177, -9.067432991358354],
            [24.294594450870544, -9.072728593489767],
            [24.305564880139485, -9.079034031311776],
            [24.308118931527719, -9.08131340958006],
            [24.31579391992296, -9.088162911757975],
            [24.323577839826164, -9.11316105048348],
            [24.336601021028919, -9.125261171695431],
            [24.34425299997644, -9.128891941023369],
            [24.350271120390286, -9.129774073086159],
            [24.35956415966514, -9.136610964387851],
            [24.372551619360618, -9.14250590496887],
            [24.380885880444545, -9.144292989842613],
            [24.386924159951658, -9.148391020542684],
            [24.394613039894445, -9.157304972461443],
            [24.413648039829308, -9.168214932950223],
            [24.425000999593987, -9.171590058791947],
            [24.431664960188058, -9.174848983901397],
            [24.434746111544015, -9.176353905534103],
            [24.440198681401046, -9.180465270623902],
            [24.443811000296282, -9.18318891188631],
            [24.445198079943317, -9.182951068910384],
            [24.450802919630917, -9.191187983636292],
            [24.454806840209649, -9.201962051568302],
            [24.466596119792634, -9.201196082131816],
            [24.470564046674561, -9.202480815804309],
            [24.473550960265609, -9.203447914286158],
            [24.475586983772246, -9.205811536819949],
            [24.482409840170408, -9.213732083560179],
            [24.487266369751605, -9.217505944468492],
            [24.489152985460162, -9.218972141804361],
            [24.488607959610963, -9.225327047991167],
            [24.488912159708892, -9.230330020781203],
            [24.488957880363596, -9.235086042033339],
            [24.491595890094921, -9.238028940523517],
            [24.496683119617504, -9.24250604586909],
            [24.500268000370692, -9.243965945030377],
            [24.503091119644413, -9.245686050027581],
            [24.505653960149417, -9.246907957990238],
            [24.510504959701716, -9.247352076715307],
            [24.51408912000603, -9.24856099443662],
            [24.519481920455654, -9.252252996985471],
            [24.52433292000795, -9.252696931278086],
            [24.529196880453167, -9.254392982729907],
            [24.534035999785822, -9.253584975757049],
            [24.540405119828918, -9.252760071080226],
            [24.543986039910042, -9.253719080880852],
            [24.554217959692309, -9.256603918389681],
            [24.556530959852175, -9.258328940562665],
            [24.558860879780401, -9.261805992505913],
            [24.564259080003172, -9.265999040361827],
            [24.569637120234351, -9.268188916171136],
            [24.573519000190139, -9.273901949494336],
            [24.575339160330618, -9.277385070489016],
            [24.5748599998564, -9.280646028931667],
            [24.574893840291459, -9.284150066974867],
            [24.573428999778471, -9.290925957950387],
            [24.570137160250738, -9.293467971492388],
            [24.565298040019755, -9.294276063007469],
            [24.557648040060773, -9.294616086678475],
            [24.552546120388389, -9.294676017124207],
            [24.548736959953139, -9.296473051174315],
            [24.545432879981352, -9.297763068414257],
            [24.541113959758388, -9.299565954351708],
            [24.536787119987842, -9.300618019102394],
            [24.531937919761063, -9.300424002703553],
            [24.527345040325887, -9.300228030218074],
            [24.520454999825901, -9.300058020739844],
            [24.513307919882138, -9.299641000852247],
            [24.503613119876242, -9.299504067880129],
            [24.496215119812362, -9.299591028747283],
            [24.481420919908409, -9.299764061658452],
            [24.476319000236025, -9.299822924880877],
            [24.472238040138521, -9.299870940080289],
            [24.46662600045395, -9.299936916017694],
            [24.461012159647204, -9.299751968845912],
            [24.454384920385312, -9.300329928428845],
            [24.454363136239667, -9.3003342008824],
            [24.450311160284809, -9.301128934320559],
            [24.447250079987267, -9.301165034147639],
            [24.445464840056822, -9.301186018910435],
            [24.441380999960558, -9.300982933253593],
            [24.437554919756941, -9.301027925099707],
            [24.434001000338345, -9.302822080500572],
            [24.430434120026796, -9.303363935351703],
            [24.424058160211132, -9.303438980134578],
            [24.418190880408236, -9.303507979452863],
            [24.411045960014391, -9.303340994761243],
            [24.409496160435086, -9.301356026941042],
            [24.405140880002666, -9.299405015058726],
            [24.402308040059225, -9.296683964365968],
            [24.400757880255515, -9.294698958290104],
            [24.400746000035866, -9.293448053503115],
            [24.398173080433395, -9.291225081434277],
            [24.396870959852645, -9.288486004999362],
            [24.393308040213199, -9.289278991686228],
            [24.388962120226033, -9.288328082957491],
            [24.386379119729437, -9.285104010521261],
            [24.378167880228744, -9.28019306120005],
            [24.372037079637245, -9.279264002402003],
            [24.362825039654908, -9.276367081358137],
            [24.352086959634228, -9.273988916798565],
            [24.345956159941057, -9.273060019833249],
            [24.334458120461345, -9.271192080760875],
            [24.329859119905812, -9.270494024776868],
            [24.323731919761983, -9.270065052095308],
            [24.314291999649981, -9.269925084844813],
            [24.307144919706182, -9.26950802863294],
            [24.30026496010036, -9.270340006819941],
            [24.294425040286061, -9.273161926940489],
            [24.292644120353827, -9.273684086726],
            [24.287545079781903, -9.273994074831593],
            [24.281422920085156, -9.274065036150962],
            [24.277352039983445, -9.275113976578741],
            [24.27276312032204, -9.275417916572799],
            [24.268429079656194, -9.275719010472219],
            [24.266660039943574, -9.277491955827669],
            [24.263381160410464, -9.281286088672697],
            [24.257261160263631, -9.281607984944939],
            [24.251425919773649, -9.284930970271498],
            [24.246618120203369, -9.288991958815803],
            [24.244878960253768, -9.293769049683139],
            [24.242865119744756, -9.296547031114061],
            [24.240354839667056, -9.300831952956964],
            [24.239108879961247, -9.303851017203499],
            [24.23330999968071, -9.310927940162786],
            [24.229002959677324, -9.313983014574108],
            [24.224921999579848, -9.314031027803535],
            [24.218069039738186, -9.317615992550218],
            [24.215297039994031, -9.321153086238002],
            [24.211463040242872, -9.320446950816772],
            [24.20784107972969, -9.315232066626699],
            [24.204000959756506, -9.313774957466794],
            [24.20065296025216, -9.310558946227612],
            [24.195260159802576, -9.306867031907792],
            [24.190902000269631, -9.30466495228568],
            [24.185791080376426, -9.303724045045762],
            [24.183257039859431, -9.305505916254987],
            [24.180473159895627, -9.307791036550539],
            [24.174654119623497, -9.312866083400571],
            [24.169101119914302, -9.318940073743793],
            [24.164292960119617, -9.323001017379037],
            [24.160503959675992, -9.326801051258673],
            [24.15115115997683, -9.335672020994908],
            [24.148118879667297, -9.338711940084163],
            [24.149683080138942, -9.342199029542401],
            [24.150000959782009, -9.348704043677431],
            [24.148001880389735, -9.352982982343029],
            [24.140630880090047, -9.35582307368437],
            [24.136022880211993, -9.359167035749349],
            [24.13854777498107, -9.36125610644863],
            [24.140437920170385, -9.362819983974415],
            [24.144666120431147, -9.37405897876258],
            [24.141948120215346, -9.384873043915313],
            [24.143363999850397, -9.389693072346063],
            [24.151749840401301, -9.399530085783987],
            [24.146360167885508, -9.415887150401302],
            [24.145605015311617, -9.418178893832131],
            [24.146091000287047, -9.422541983725356],
            [24.149184479223639, -9.426471271909971],
            [24.150054960208664, -9.427576934546956],
            [24.150204269192027, -9.428176677097001],
            [24.151712040192468, -9.434233024696582],
            [24.157775880362692, -9.442244052101305],
            [24.162234839853642, -9.453020938097968],
            [24.162666120123234, -9.458210082338383],
            [24.162730920096223, -9.458993965884304],
            [24.156603000401851, -9.481090038028562],
            [24.152919119914472, -9.484788069920814],
            [24.151586467393841, -9.502217052155812],
            [24.15140718162943, -9.504561063054039],
            [24.131032920268385, -9.546958027984134],
            [24.122811960098005, -9.56837808178663],
            [24.121232962577036, -9.575969338087955],
            [24.120493058905041, -9.581209690144462],
            [24.119355959740325, -9.589263010468084],
            [24.118977710615219, -9.59194076422237],
            [24.117887168436702, -9.599661048685077],
            [24.119786879785476, -9.608386085231084],
            [24.127842711640341, -9.623040740040736],
            [24.129613980073159, -9.626262832416465],
            [24.132022917610406, -9.643029108164168],
            [24.129972000036396, -9.649474921793896],
            [24.122373632545017, -9.661307114927855],
            [24.118715175278464, -9.667003924006353],
            [24.119450999700742, -9.674583986704956],
            [24.112366920404479, -9.692550959039856],
            [24.113542317444722, -9.701699965389878],
            [24.113576872938769, -9.701969019810996],
            [24.109903079633696, -9.717772920485578],
            [24.109725959707422, -9.718538080717963],
            [24.106506120149714, -9.722922974377781],
            [24.091257759885902, -9.731301730688239],
            [24.082013880016643, -9.736381006821444],
            [24.078736011986532, -9.739738875272172],
            [24.071641920068124, -9.747005989856445],
            [24.07000974318062, -9.749719016965345],
            [24.064288920210071, -9.759228069265665],
            [24.046993080224809, -9.776094041605221],
            [24.044762419643895, -9.779000385906334],
            [24.040086119956491, -9.78509308707967],
            [24.031682035520468, -9.8021480410191],
            [24.028845119920625, -9.807904977077602],
            [24.028373439717743, -9.808400652081007],
            [24.027017040232604, -9.80982604931801],
            [24.021180662475462, -9.815957005003895],
            [24.019391879589566, -9.817836049205374],
            [24.01299125473113, -9.835567783619556],
            [24.020664120407329, -9.840127926225835],
            [24.027624000429054, -9.841243989268065],
            [24.027884999646641, -9.846989007717108],
            [24.0233129997536, -9.85942608127006],
            [24.01993511958797, -9.879211999851096],
            [24.021826920372337, -9.88655902315084],
            [24.025798976809622, -9.892287710914228],
            [24.033480867859495, -9.89845599901335],
            [24.059910960011671, -9.897636052703914],
            [24.061392210049934, -9.898252197080403],
            [24.070835160179445, -9.902180083709823],
            [24.079857839791426, -9.904274029946754],
            [24.087318120053975, -9.906004064171222],
            [24.104522160302025, -9.914192043939915],
            [24.105259079770629, -9.921775064281734],
            [24.108314039846146, -9.92911508818629],
            [24.105800231185981, -9.9362557727879],
            [24.100665547260228, -9.939365403138449],
            [24.093549000154642, -9.943675006787107],
            [24.086858039796375, -9.950146087482119],
            [24.085034999657104, -9.956363059082378],
            [24.085923840409901, -9.992682943599275],
            [24.092390159963404, -10.000000056523039],
            [24.092884079757734, -10.000559054904731],
            [24.09502608021338, -10.002981015571406],
            [24.103586159793437, -10.008406935055985],
            [24.111775079752579, -10.011065027432883],
            [24.122247839659135, -10.012445083061037],
            [24.133350014949322, -10.01174893303306],
            [24.137277119689784, -10.008968935542098],
            [24.140189637503944, -10.00916747986091],
            [24.143542920000485, -10.009396069641697],
            [24.155867880258764, -10.01461798834182],
            [24.159734407108061, -10.014491104046641],
            [24.164217000375817, -10.014344002042288],
            [24.175787039825522, -10.009223938132688],
            [24.183868194289929, -10.002513080828392],
            [24.205848119661177, -10.004706970708963],
            [24.208121879612797, -10.002426990086025],
            [24.218251919662052, -9.99479901799682],
            [24.221814119750956, -9.993755002509575],
            [24.226908119875798, -9.992945057963986],
            [24.233303880356985, -9.994873020059156],
            [24.238945080253998, -9.997811080930878],
            [24.244836119597856, -10.00024495163],
            [24.251495039744885, -10.002921034501307],
            [24.25917204036632, -10.005334991013306],
            [24.264028080365698, -10.006279948241968],
            [24.265323000051119, -10.00826692251205],
            [24.266651039722756, -10.013758942189098],
            [24.270780959799868, -10.018717987928516],
            [24.274920959872777, -10.024677931765295],
            [24.279042960402307, -10.028884978123132],
            [24.279081840386119, -10.032890041163377],
            [24.282191160214428, -10.03786103262024],
            [24.288344999898015, -10.041043030540056],
            [24.291993917056232, -10.045127027877376],
            [24.297492943288191, -10.03359993238241],
            [24.294893040091207, -10.025797083513067],
            [24.296264233930774, -10.022571834655103],
            [24.306904079581894, -10.017222084156836],
            [24.319338119570194, -10.000000056523039],
            [24.322826440413476, -9.995167367423045],
            [24.325072920326541, -9.992055075731244],
            [24.33015796424802, -9.988804975060084],
            [24.340218057876008, -9.988522961273899],
            [24.3509540403305, -9.988221999544093],
            [24.35635511965377, -9.986807944210438],
            [24.359581112671162, -9.983340082820796],
            [24.362156879933099, -9.987002980370008],
            [24.362911080292836, -9.996194937737583],
            [24.364616039582941, -10.000000056523039],
            [24.373499014100286, -10.019811015842894],
            [24.373327841021233, -10.020575247399442],
            [24.371694000453839, -10.02786804576194],
            [24.374531879945994, -10.036357943325735],
            [24.379764293388142, -10.040623291981873],
            [24.382928880267674, -10.043202966213277],
            [24.383073124549473, -10.043691900409687],
            [24.384351052601293, -10.048023258928211],
            [24.388737839645675, -10.05513992849896],
            [24.388269120289987, -10.059401043955376],
            [24.388318080269592, -10.064407994578666],
            [24.388111079682066, -10.069416996031133],
            [24.388152120114128, -10.073672065451285],
            [24.389723879908878, -10.077910046954035],
            [24.391532159829712, -10.080141940960646],
            [24.396411960268317, -10.08358892728765],
            [24.399249120209937, -10.08681091803663],
            [24.4020769197063, -10.089031040758803],
            [24.406192079564967, -10.092486978641388],
            [24.408779039835341, -10.09621200419924],
            [24.409059120167903, -10.098713070898146],
            [24.410370959621687, -10.102452039076748],
            [24.412444919881079, -10.105933021419732],
            [24.414509879919621, -10.108412014204536],
            [24.414995880166437, -10.105903041008473],
            [24.414703919614254, -10.102150986207514],
            [24.413883119956008, -10.096403071013246],
            [24.413326919963012, -10.091652979453176],
            [24.412520879624878, -10.087405956725748],
            [24.411674880426254, -10.079154977760698],
            [24.411621959774578, -10.073647937139167],
            [24.412096079801749, -10.069886985465038],
            [24.413072040069125, -10.065369987841589],
            [24.414552000126658, -10.060094960640017],
            [24.416305920294732, -10.056820003179658],
            [24.420596039631388, -10.052013075048412],
            [24.423881040284854, -10.048719936299165],
            [24.427136160277037, -10.042424020796608],
            [24.430690079695665, -10.040629956156458],
            [24.436244160078104, -10.03455603710902],
            [24.441505919683962, -10.024730988716122],
            [24.445796039918953, -10.019923933076376],
            [24.449578920140553, -10.015373931913475],
            [24.452822159913083, -10.007825946086397],
            [24.454797120438254, -10.001042987605624],
            [24.455521079912266, -9.996778964654522],
            [24.458555160445613, -9.993989963881255],
            [24.4613199601928, -9.989701001967621],
            [24.461790839996741, -9.985690075786074],
            [24.463022282029229, -9.981544865360879],
            [24.466334039901774, -9.980630071486402],
            [24.470439840213484, -9.983086079280126],
            [24.472014119782592, -9.987573004217134],
            [24.474601080052967, -9.991298011287274],
            [24.477701040334317, -9.995268052137998],
            [24.485906880061854, -9.999677966244391],
            [24.490279080262667, -10.003382071293867],
            [24.498743040107293, -10.008039070090655],
            [24.50234304040503, -10.011000966191432],
            [24.508015920288884, -10.017194047163528],
            [24.516993959919468, -10.022345924552791],
            [24.524187119844079, -10.027519012301811],
            [24.532926119574189, -10.034175958920539],
            [24.536527920095775, -10.037387980400762],
            [24.542456040097889, -10.043578065627463],
            [24.54477983980409, -10.046555069954534],
            [24.55019495979526, -10.052499945380333],
            [24.554332079869376, -10.058209087334255],
            [24.558989039727035, -10.064914008147449],
            [24.561081000428068, -10.070147084220597],
            [24.564722040259568, -10.07736395786571],
            [24.567849000305113, -10.084086926914669],
            [24.571239839567035, -10.091808035311047],
            [24.576146999994272, -10.098008949758519],
            [24.582615119771592, -10.098231947896677],
            [24.59141702762274, -10.095391097826765],
            [24.592802040246326, -10.094944077252496],
            [24.594397381715584, -10.092958476696269],
            [24.602461920042185, -10.082920964503286],
            [24.607755000308739, -10.076906931512383],
            [24.624834119935048, -10.064371977775972],
            [24.63295896037004, -10.061339073471538],
            [24.633628920315701, -10.061091031713232],
            [24.644280959698456, -10.058486939050619],
            [24.644738722302613, -10.058456539293413],
            [24.671414880079126, -10.056684979667878],
            [24.688187629277781, -10.052085959902572],
            [24.692946839872661, -10.050780991306318],
            [24.694683373148411, -10.049351933590621],
            [24.695484119714553, -10.048692966884506],
            [24.700712039783685, -10.034400954286406],
            [24.69667212011824, -10.021555926655971],
            [24.697329839619812, -10.016722915254979],
            [24.70356000016994, -10.012078996441611],
            [24.707683079576153, -10.005382017578668],
            [24.709511879713052, -10.000000056523039],
            [24.71199416109998, -9.992704975621976],
            [24.713045030980581, -9.993043383631672],
            [24.714785879762957, -9.993603980946636],
            [24.720801839728519, -10.000000056523039],
            [24.725309039648536, -10.004791972725197],
            [24.723953993026193, -10.009633011432326],
            [24.721697879580024, -10.017693037250734],
            [24.722347280682076, -10.023396713560146],
            [24.72269184028907, -10.026422933571434],
            [24.728070960295224, -10.032130057554911],
            [24.730209149199123, -10.038552064236008],
            [24.732255574298414, -10.039709720028338],
            [24.737432039766333, -10.042638009416539],
            [24.745399502550093, -10.052924727025509],
            [24.751801079622719, -10.059904049192138],
            [24.756395039731203, -10.060100992307106],
            [24.761004120282536, -10.061798961259965],
            [24.780426119831699, -10.06532705109171],
            [24.784021079682386, -10.067788972788822],
            [24.794009999790379, -10.071928031478789],
            [24.79837607976917, -10.074880997219518],
            [24.807859920312058, -10.079525954065289],
            [24.814523160457295, -10.082702923049021],
            [24.822924119654417, -10.080851956688015],
            [24.827703120135016, -10.07414098387372],
            [24.830209080214541, -10.068143994625522],
            [24.832609007649502, -10.065861063875873],
            [24.834351960286245, -10.064203070170073],
            [24.843605039802313, -10.060453007323311],
            [24.845428097907892, -10.056529902251356],
            [24.84607104012305, -10.049856924932859],
            [24.844190741367584, -10.038086799991447],
            [24.843869999692, -10.036079008380154],
            [24.84279030377224, -10.035055359819587],
            [24.840711000333545, -10.033083985299749],
            [24.83653813359933, -10.029124662073762],
            [24.835454999826979, -10.028096948958032],
            [24.83517601903236, -10.022351458315343],
            [24.842181379858598, -10.023977579902152],
            [24.842846030760878, -10.024131898488122],
            [24.845267341692878, -10.026929977852587],
            [24.855492959793413, -10.038746984313333],
            [24.863500487438817, -10.04455462156284],
            [24.86552795988225, -10.046025074031691],
            [24.870679920207579, -10.051732024164126],
            [24.888175920109475, -10.063318963463814],
            [24.901098119894513, -10.082529056848276],
            [24.902088119931491, -10.0891889358585],
            [24.903936000285004, -10.095676059027364],
            [24.90886800002815, -10.104380048413168],
            [24.912763919753509, -10.111595080180617],
            [24.916430160023683, -10.121314916646659],
            [24.924404880296589, -10.12823208279419],
            [24.930289079867883, -10.12991496293575],
            [24.94302804040295, -10.128264012175302],
            [24.950399039804342, -10.125424008773665],
            [24.96262103965633, -10.123027991249526],
            [24.976827000254342, -10.119390025082325],
            [24.980677919773868, -10.108321008157789],
            [24.991792246574889, -10.098790549044226],
            [24.996111120085477, -10.09508706771622],
            [24.999999839813864, -10.09311997155605],
            [25.010898119992426, -10.087606076888646],
            [25.020406268048607, -10.083714893899918],
            [25.026390000055031, -10.081266043665062],
            [25.029460851327936, -10.081068172670605],
            [25.038681119878252, -10.080474062202718],
            [25.051388040202081, -10.074156952174988],
            [25.053149368776282, -10.073891929191888],
            [25.056253116354895, -10.073425010784806],
            [25.058338116010784, -10.070555832917989],
            [25.058774816714795, -10.069954931547031],
            [25.05939876584992, -10.069639213876444],
            [25.059852928904739, -10.069409407480951],
            [25.062009776715378, -10.068318039613313],
            [25.072053735702539, -10.049838009373113],
            [25.062495417636057, -10.047711935516375],
            [25.061494002706798, -10.047489196688828],
            [25.041346857907449, -10.043007958931517],
            [25.040204938382907, -10.042754048994279],
            [25.016973079509217, -10.039272023320343],
            [25.0063238868876, -10.041889924262804],
            [24.999999780525055, -10.040472031652609],
            [24.998418359349419, -10.040118803323097],
            [24.988598960318686, -10.039608974498],
            [24.98297286110158, -10.038172964836336],
            [24.981418021973521, -10.03568792459285],
            [24.980879101973326, -10.032690058492042],
            [24.980811061777072, -10.02568102887582],
            [24.983272020752434, -10.016388947754857],
            [24.987850860418039, -10.015083971444092],
            [24.992687840862036, -10.014025999808254],
            [24.998809980795851, -10.013955024223032],
            [25.008765059570489, -10.014589056258723],
            [25.019225918596202, -10.014717001883144],
            [25.024565098606473, -10.012902018261498],
            [25.030912978883034, -10.009823907496575],
            [25.036508097900906, -10.008006057472169],
            [25.044623938115077, -10.003154031969705],
            [25.054516017140539, -9.99728099805186],
            [25.059827096950404, -9.992461995507064],
            [25.066662776799266, -9.987125071367698],
            [25.073770975860928, -9.983537022294575],
            [25.080104816367886, -9.978955980145981],
            [25.08542707301654, -9.975388964750996],
            [25.094369793585106, -9.976786911051331],
            [25.1030688542177, -9.979439057570213],
            [25.10691186946103, -9.98114596764982],
            [25.115582094173028, -9.980794047962076],
            [25.121702093421529, -9.980471939307751],
            [25.128328973357313, -9.979893915914039],
            [25.130566013773375, -9.973860020064617],
            [25.135607093246538, -9.967542047244091],
            [25.138865092339216, -9.961496028131577],
            [25.144466254323998, -9.951491598897501],
            [25.150931931582075, -9.943078984952596],
            [25.158243891906363, -9.934230918661289],
            [25.164283971637293, -9.925649039081602],
            [25.169343771102668, -9.921333962239018],
            [25.177467891088789, -9.917233077181637],
            [25.185872810059713, -9.915882966943959],
            [25.192732969898348, -9.913049066325941],
            [25.203138048934786, -9.907420065523544],
            [25.215097967997586, -9.904275976158505],
            [25.225009848586868, -9.900404934313167],
            [25.240630896505852, -9.893606077183467],
            [25.251185806446845, -9.890084947614815],
            [25.266665085840966, -9.881641964653211],
            [25.27709896486542, -9.879016003351502],
            [25.286502884094109, -9.875402076505351],
            [25.293098803593629, -9.871569036645568],
            [25.303771002968013, -9.867188972868165],
            [25.311135883045679, -9.863847962510112],
            [25.321557881850481, -9.859970935030667],
            [25.334533001388934, -9.856314009158702],
            [25.348756959733656, -9.849888991068422],
            [25.362467918965699, -9.843220075159021],
            [25.389394836962182, -9.831389081313217],
            [25.396254997699177, -9.828554975734122],
            [25.406657916287333, -9.822675044906395],
            [25.41709575598389, -9.820550032742995],
            [25.4239497947022, -9.816964932775347],
            [25.430825074983712, -9.815633049484136],
            [25.439496754068141, -9.815530953766924],
            [25.445621793763689, -9.815709937318159],
            [25.450729804013726, -9.816400994180544],
            [25.454837821367573, -9.819107018323894],
            [25.459692004549257, -9.819800907448913],
            [25.464550982039576, -9.820996061284703],
            [25.472209922032235, -9.821656927235715],
            [25.479123774175417, -9.824330045764755],
            [25.488306990813552, -9.824222984025949],
            [25.493641830164417, -9.821906930528604],
            [25.49972187055246, -9.817579999469928],
            [25.509345029016131, -9.81020798170173],
            [25.515179908383349, -9.806885032340032],
            [25.519989868401883, -9.803073916272488],
            [25.524555028522357, -9.8002660234323],
            [25.533972987520652, -9.798152941471765],
            [25.537288947712049, -9.798114940996783],
            [25.541587050376648, -9.794059016046059],
            [25.54211987979922, -9.788126986710472],
            [25.544568960351594, -9.778676081071037],
            [25.538973840435361, -9.767866010432995],
            [25.538178959867999, -9.766327926023479],
            [25.537672145656067, -9.76219685532368],
            [25.538696483794759, -9.759451852037644],
            [25.540601039757881, -9.754347993627182],
            [25.546344120286211, -9.749691973646199],
            [25.54722900036694, -9.746438918031084],
            [25.548352879923971, -9.742316091208552],
            [25.545066409626688, -9.741873572006368],
            [25.538837039594007, -9.741035084235808],
            [25.536948840155606, -9.73783593457455],
            [25.525274040075761, -9.72968100911784],
            [25.52080103991694, -9.723059912161826],
            [25.519089960404777, -9.714571947273802],
            [25.519246918542798, -9.70744406516738],
            [25.520510520262473, -9.706396997280406],
            [25.521774120185519, -9.705350014312272],
            [25.527660119980631, -9.704432069847869],
            [25.534359230753463, -9.708283687283185],
            [25.535017079612452, -9.708661911495884],
            [25.537496185454845, -9.708710908707978],
            [25.542665121244092, -9.708812884310614],
            [25.544730959834961, -9.706951970553664],
            [25.543528919661707, -9.702827081801031],
            [25.5448595006673, -9.699614813168466],
            [25.546015079974072, -9.696825004059493],
            [25.545307364735336, -9.695458343020595],
            [25.543647023867067, -9.692252058304739],
            [25.541127946587757, -9.691937642572942],
            [25.538543235698885, -9.69161507833946],
            [25.534940402114739, -9.694762066701749],
            [25.531885080018156, -9.697431060037806],
            [25.52724611970384, -9.697018970435943],
            [25.523970839720064, -9.694062920757961],
            [25.523009999895535, -9.690856033383975],
            [25.525906920261427, -9.680021057995967],
            [25.524527497853846, -9.674617083906336],
            [25.523975880167111, -9.672456064683425],
            [25.524157830334648, -9.667108320008149],
            [25.524327959571377, -9.66210794285089],
            [25.521954839661131, -9.65684698098476],
            [25.518220920317464, -9.654127022796619],
            [25.508949119910852, -9.653761067923643],
            [25.500978000085581, -9.644876938843437],
            [25.49752272646495, -9.643832932493339],
            [25.496562960127186, -9.643542939557731],
            [25.489347290218205, -9.640397995564266],
            [25.486521839816319, -9.636057950104675],
            [25.486259252377302, -9.633074802353216],
            [25.490377080232385, -9.627976026492352],
            [25.491746002232595, -9.6277347382998],
            [25.493151959975336, -9.627486922623667],
            [25.499420071651269, -9.628802147837749],
            [25.500190938454452, -9.62967264220844],
            [25.508094840041952, -9.638597912953525],
            [25.511955886269689, -9.641275860276355],
            [25.512994194109378, -9.641995934873375],
            [25.519254120336427, -9.6423919196575],
            [25.521311880377965, -9.639842037362355],
            [25.521266886460342, -9.635474610198425],
            [25.516956908067687, -9.63049086192952],
            [25.516342080425989, -9.62978000154652],
            [25.51531608040403, -9.620365077282738],
            [25.510866120235598, -9.615813064752984],
            [25.510124154031736, -9.614305415054677],
            [25.504000919949853, -9.601862956142213],
            [25.504216919859935, -9.601388916621922],
            [25.504540919725024, -9.600670926164982],
            [25.506717119941836, -9.595859056434223],
            [25.506456119825923, -9.592874033850482],
            [25.502465926403072, -9.587857063819738],
            [25.496660880086431, -9.586536993090688],
            [25.494303215690646, -9.573923765246208],
            [25.492244039904215, -9.562907027670441],
            [25.492930962737365, -9.559499605556907],
            [25.493125971714171, -9.558531739770999],
            [25.490672978998774, -9.551663981944786],
            [25.490262971733415, -9.550516051137095],
            [25.490555865635177, -9.549140493529571],
            [25.491146039912199, -9.546368935688966],
            [25.49253629690044, -9.545038662275097],
            [25.495273079990518, -9.542419944978102],
            [25.497982079985498, -9.535725997418471],
            [25.502559120325586, -9.508558945145033],
            [25.502501879675705, -9.503043019371427],
            [25.4987018030046, -9.496837623548668],
            [25.498026022874249, -9.495734084317061],
            [25.501640195892225, -9.487193049936097],
            [25.502923950416982, -9.487357601087369],
            [25.511609820187964, -9.488470944825867],
            [25.509674879608685, -9.502511078748091],
            [25.51004839461222, -9.504046253494318],
            [25.51039991975594, -9.505491038416663],
            [25.516673999838623, -9.507495080433237],
            [25.530351120432268, -9.508963980394114],
            [25.537256669447277, -9.505446583601826],
            [25.537721040058685, -9.505210051498775],
            [25.543406730816777, -9.506052291878287],
            [25.549318080170877, -9.506927956960693],
            [25.552603197605336, -9.509000358784782],
            [25.553980079577286, -9.509868955125539],
            [25.556942214937862, -9.51050467176638],
            [25.559087039696756, -9.510964980466591],
            [25.568108999758223, -9.51018103978506],
            [25.578597959882639, -9.51650707929255],
            [25.590183119775187, -9.5170750757548],
            [25.600164839886208, -9.512994937815911],
            [25.606724039850175, -9.507431987590472],
            [25.611571079628703, -9.502198987893321],
            [25.619149079617657, -9.496958975098947],
            [25.626363840431566, -9.493351010180715],
            [25.633212839601129, -9.491701997043885],
            [25.636988880050161, -9.490060085538719],
            [25.64074799983247, -9.489723988478273],
            [25.645142160248728, -9.492974926181033],
            [25.64745299996034, -9.498840966877657],
            [25.65039600030704, -9.508620971206946],
            [25.652050919842562, -9.512531080852336],
            [25.654695119864517, -9.519049013843452],
            [25.662429000013137, -9.527836961839554],
            [25.67187900012097, -9.535968039389367],
            [25.676229959656883, -9.5424810766844],
            [25.683959880031733, -9.551595030201122],
            [25.694429040388954, -9.560050010436186],
            [25.700141159582721, -9.566884918659095],
            [25.709632919673155, -9.571754066402798],
            [25.717389120261654, -9.578911063042941],
            [25.72312607966963, -9.583788920751642],
            [25.727520959636429, -9.587040016409972],
            [25.736308920244479, -9.593541046723463],
            [25.743075119897671, -9.598089987277875],
            [25.752238920349242, -9.601980932780309],
            [25.760034000023222, -9.606201062490181],
            [25.765818839635855, -9.60749097043106],
            [25.773959159839826, -9.611383938090874],
            [25.7848171200352, -9.616249063315928],
            [25.789898160165446, -9.619172048004057],
            [25.796347920174991, -9.621764017442304],
            [25.804518839692459, -9.623374015950528],
            [25.810977960147255, -9.625313928724793],
            [25.817757119795075, -9.628884944124822],
            [25.824527999670881, -9.633107931321657],
            [25.828873919658076, -9.639947032020226],
            [25.833570840172818, -9.646132942856831],
            [25.836582959592459, -9.650693069277777],
            [25.841314079868397, -9.654268963888384],
            [25.845024960119972, -9.657520972045358],
            [25.850111039798968, -9.660117971662281],
            [25.857901079924201, -9.66466404997723],
            [25.865704080044019, -9.668231977948938],
            [25.876536120250176, -9.675055079579561],
            [25.879884119754518, -9.679938991067205],
            [25.888016160186506, -9.684484975234593],
            [25.894457999750177, -9.687729936610312],
            [25.902257040096259, -9.691623919968789],
            [25.90766999963914, -9.695199018797606],
            [25.914786120044969, -9.699095045354548],
            [25.926365880164369, -9.701021016865742],
            [25.934893920431477, -9.701324929299023],
            [25.944451919596052, -9.701298996097769],
            [25.959146039990802, -9.699954922295404],
            [25.972850879899152, -9.696004018969028],
            [25.982454959942803, -9.692390028429825],
            [25.99170983968272, -9.689428963977994],
            [25.998225120114128, -9.687127947730053],
            [26.007816959713761, -9.684492080777561],
            [26.014997159643745, -9.683493966194858],
            [26.02286099996282, -9.682494959962709],
            [26.02869803977832, -9.67986900335322],
            [26.032156405400162, -9.677520037538967],
            [26.033519880016502, -9.676593944021297],
            [26.035549919845007, -9.677894059508638],
            [26.035534802097086, -9.679043098011327],
            [26.035494120092803, -9.682135075933875],
            [26.03475611995092, -9.686377991850298],
            [26.034694920425562, -9.690945913376074],
            [26.033627879971512, -9.694211061487989],
            [26.032197959668562, -9.699108012487397],
            [26.031084119683157, -9.705961916456085],
            [26.031326039582421, -9.71346504488608],
            [26.032609079946557, -9.719660063334167],
            [26.037690120076803, -9.722583026132344],
            [26.038727787417695, -9.722540608107105],
            [26.04622788011531, -9.7222340192708],
            [26.053071120185578, -9.720910988400144],
            [26.06299595987112, -9.71892705377949],
            [26.07325703986584, -9.717269029858942],
            [26.083176840002633, -9.715610996723983],
            [26.088319079658238, -9.71396592181749],
            [26.098575839654746, -9.71263397754451],
            [26.10405396029342, -9.711313927742568],
            [26.108146080161667, -9.711630086148825],
            [26.111174039574692, -9.714884018053013],
            [26.115900839852461, -9.718786028928534],
            [26.122792071518461, -9.720656936071151],
            [26.123042880247475, -9.720725028456382],
            [26.128859039622512, -9.719730042632454],
            [26.134017120169833, -9.716780945239043],
            [26.134619922064818, -9.71621033763371],
            [26.138510999870821, -9.712527052299526],
            [26.141289119837037, -9.708931003924032],
            [26.145747000451308, -9.707288026747698],
            [26.148486959984258, -9.706627992276996],
            [26.154596159686417, -9.709221943243787],
            [26.159703119805883, -9.710186942752797],
            [26.164823039919938, -9.710173976945541],
            [26.172695160010992, -9.70852105962185],
            [26.176129919703804, -9.706880922611496],
            [26.179572960066892, -9.70458802138061],
            [26.183703959918951, -9.701967034962895],
            [26.188503839941685, -9.700322958123353],
            [26.19225792017528, -9.700313010660404],
            [26.196665039687829, -9.702584982568588],
            [26.201742120044305, -9.705834030301039],
            [26.205090839997521, -9.710719085852535],
            [26.212578120024229, -9.712330074614307],
            [26.220108960257363, -9.710678944318113],
            [26.226455253210784, -9.704354848504673],
            [26.23243112136522, -9.700599934372867],
            [26.233631452942827, -9.698897001726415],
            [26.24289587997756, -9.685753085849923],
            [26.247214720250486, -9.681647551825952],
            [26.249758919815022, -9.679228986009848],
            [26.251185960119177, -9.67843495833924],
            [26.256913048838843, -9.675251545530287],
            [26.260341119676035, -9.673346031166975],
            [26.268699126826174, -9.674616920791296],
            [26.280038880457855, -9.669739076829206],
            [26.290369080423773, -9.66286097444862],
            [26.297246879581376, -9.658927038704707],
            [26.301048840019593, -9.655327921765259],
            [26.308268999708364, -9.651394074251385],
            [26.314796879909959, -9.648115003582259],
            [26.320283999871123, -9.646142003202943],
            [26.326125000358694, -9.643191007610566],
            [26.332635845807562, -9.641216013332501],
            [26.33741077781821, -9.641529924410866],
            [26.342849708554311, -9.643146046890926],
            [26.346903005032601, -9.646397990861761],
            [26.350652649385321, -9.646714024857912],
            [26.352679866707213, -9.648340073860314],
            [26.352986946803938, -9.650949048086332],
            [26.352256866209604, -9.654540040140175],
            [26.345697667143938, -9.660103035733453],
            [26.34154182887427, -9.664681977124204],
            [26.337735909560575, -9.668606963246475],
            [26.33496570914194, -9.671549917861112],
            [26.330766669991924, -9.679390975667731],
            [26.330023990525731, -9.683960947259402],
            [26.330654710263111, -9.687873981068854],
            [26.330092962274907, -9.691055028377386],
            [26.332620670567465, -9.694066993046908],
            [26.334283868976669, -9.697325004221057],
            [26.336275749270204, -9.701560975971503],
            [26.337234789769212, -9.70645195642178],
            [26.339248989604329, -9.709056921009328],
            [26.339883669115515, -9.712643909485756],
            [26.340143045975676, -9.71759815966892],
            [26.340156909675482, -9.717862957148046],
            [26.33841090905495, -9.720804051575065],
            [26.331860710210137, -9.725714995285816],
            [26.327034911096511, -9.729316011982585],
            [26.321167992416353, -9.734225940494339],
            [26.312168713019197, -9.743710980754562],
            [26.30559691418334, -9.750252987279319],
            [26.297988675105326, -9.757776951991859],
            [26.292103755983526, -9.763991027701355],
            [26.288971755490902, -9.768566931813728],
            [26.286846676600277, -9.774444993445357],
            [26.285744716834525, -9.780319930952558],
            [26.285299756121468, -9.788150945676451],
            [26.285235676597317, -9.793044902665454],
            [26.280694997364975, -9.800886978050379],
            [26.278590797118156, -9.805134046361974],
            [26.275103838120838, -9.810688996744844],
            [26.270938998732024, -9.81591998219402],
            [26.267102839430905, -9.822129049891398],
            [26.266005919213899, -9.827678029166886],
            [26.2669048390642, -9.83713604269491],
            [26.266498759233283, -9.842031041122766],
            [26.267380726975858, -9.844657561973889],
            [26.269125679262441, -9.849854008623087],
            [26.269043959521017, -9.856053020480317],
            [26.270050879326359, -9.857354912422775],
            [26.269985719128929, -9.862249074334548],
            [26.269925959602951, -9.866815969059948],
            [26.271925679493989, -9.870400052230739],
            [26.273576556610774, -9.874636020346385],
            [26.275581756225037, -9.877894014268632],
            [26.279633556110095, -9.881145051493263],
            [26.282667634846817, -9.88407296416027],
            [26.286075754101542, -9.884390021205816],
            [26.291187752871458, -9.885028927588397],
            [26.29528383251348, -9.885017921263401],
            [26.299046550946859, -9.884355936804383],
            [26.303539709300644, -9.880102976407393],
            [26.305669829536644, -9.873898919558322],
            [26.307786628655318, -9.868672947802878],
            [26.308538668566769, -9.863450974704952],
            [26.310287547389432, -9.860183959757128],
            [26.316816505569378, -9.856903951110034],
            [26.326031783978284, -9.856879982041534],
            [26.341737500807763, -9.856511944460642],
            [26.347556538384968, -9.855191053565962],
            [26.355761656765303, -9.85419097202994],
            [26.360198655142515, -9.854178899201665],
            [26.361866534672664, -9.85711096019182],
            [26.36405965375954, -9.859061924389479],
            [26.366746694437406, -9.862317056242855],
            [26.368267693130374, -9.863455057364085],
            [26.371987572704473, -9.866055046057774],
            [26.375552651893837, -9.867514013846407],
            [26.378944570930742, -9.869135949040659],
            [26.38542780935428, -9.869282058080881],
            [26.3895235278736, -9.86927105122234],
            [26.394288486787971, -9.870237000521591],
            [26.400415685135176, -9.871526052651131],
            [26.403966724554977, -9.873963005352994],
            [26.404798683983998, -9.875592009772491],
            [26.406639724564947, -9.878360020351415],
            [26.409488763827877, -9.882267896068194],
            [26.412003722331594, -9.885685938420071],
            [26.415535681534781, -9.889591949779396],
            [26.419577760750144, -9.893658924134646],
            [26.422781759416139, -9.896586900242092],
            [26.425840680163724, -9.897557028643291],
            [26.430098758390844, -9.898198927780479],
            [26.432997477183925, -9.898353898984489],
            [26.437774676542379, -9.898503899837573],
            [26.443237674043218, -9.898326916068109],
            [26.450768512479751, -9.896674948582188],
            [26.455909671462084, -9.89503096172699],
            [26.461392469628411, -9.893385011351777],
            [26.467216548550994, -9.891737989958859],
            [26.47131658706849, -9.89140105765992],
            [26.479175745368291, -9.890727014752438],
            [26.483937464059466, -9.89201989058334],
            [26.487674622728029, -9.893314891922461],
            [26.494129780714129, -9.895580909583105],
            [26.499210459721613, -9.898503898946865],
            [26.50498269866576, -9.900772010058461],
            [26.508698617567784, -9.903699034757015],
            [26.514138575976531, -9.905314931796267],
            [26.518908574439653, -9.905955039488868],
            [26.526404492666149, -9.906913956118695],
            [26.532544651007949, -9.90722389100628],
            [26.540394447964196, -9.907202944257323],
            [26.546205566892151, -9.906534969652682],
            [26.549605765701035, -9.907504890127397],
            [26.553658644462743, -9.910755985883153],
            [26.558761643910106, -9.912047894671263],
            [26.569001480544994, -9.912020025764928],
            [26.575486518294053, -9.912002985017336],
            [26.579923517569558, -9.911990914338775],
            [26.583669676458978, -9.912634026496898],
            [26.589070754883917, -9.917186899920136],
            [26.593136593640214, -9.919460027358465],
            [26.599254432440492, -9.921401032190342],
            [26.60675970931559, -9.921707047629189],
            [26.613248707736744, -9.921363934100185],
            [26.619059465541969, -9.92069598783416],
            [26.623855745117041, -9.91937802041536],
            [26.629005543197461, -9.917080040661496],
            [26.635512541161962, -9.915431895455674],
            [26.641686539938817, -9.913131935280177],
            [26.647173658103384, -9.91115999418068],
            [26.652071868615405, -9.911816445242172],
            [26.654328654899732, -9.912118896286071],
            [26.664909412066411, -9.912091027385904],
            [26.670024651059524, -9.912403974983306],
            [26.675149608925704, -9.912064045613874],
            [26.686075605724039, -9.911709028416865],
            [26.697339642157072, -9.911679028940419],
            [26.70894459912185, -9.911647965081247],
            [26.720886514149754, -9.911941918174405],
            [26.731796671853004, -9.912891942227098],
            [26.740325428975698, -9.913194948056702],
            [26.750560585387944, -9.913494048820311],
            [26.755680503705371, -9.913480912042122],
            [26.761495581508804, -9.912487045399129],
            [26.769005539504839, -9.912466987010898],
            [26.773433538559527, -9.913106903316343],
            [26.777486416422938, -9.916359008060567],
            [26.779841536789807, -9.918963011862454],
            [26.780122696897351, -9.923528930797138],
            [26.78039845633338, -9.928421916965348],
            [26.782343535298931, -9.93624688433348],
            [26.782576455875709, -9.944401972192367],
            [26.782460536373122, -9.95321089019227],
            [26.782681576730251, -9.962344888996951],
            [26.782612456759022, -9.967564910973557],
            [26.782171456718068, -9.975070008463112],
            [26.781774376209643, -9.979311958108562],
            [26.779346537220501, -9.98225495223223],
            [26.776214539422831, -9.986830978433895],
            [26.772420500328789, -9.98977692062474],
            [26.747066429088548, -10.005506910906348],
            [26.752752333645681, -10.007695784994375],
            [26.755698715251128, -10.008829893807773],
            [26.763554722260945, -10.006645127012478],
            [26.770182381036079, -10.010816910146353],
            [26.771048541124593, -10.011362935856019],
            [26.775083420342959, -10.017282912884246],
            [26.783915657114747, -10.018300942909704],
            [26.790028837251946, -10.023728031979124],
            [26.79583237350057, -10.023871932303043],
            [26.801990322078282, -10.02081239995646],
            [26.802510371169287, -10.020554015974872],
            [26.81017656865113, -10.021130901193187],
            [26.81155789638542, -10.020628135855768],
            [26.814789606281309, -10.019451880953463],
            [26.821881605125114, -10.012908018764419],
            [26.825055104190586, -10.012466558997096],
            [26.83114167173747, -10.011619765460091],
            [26.834349480158586, -10.009042896046607],
            [26.835889559068203, -10.003501994070982],
            [26.835934559274033, -10.000000018233663],
            [26.836100519429536, -9.987172955468209],
            [26.839083987981478, -9.985059931506422],
            [26.843120462607793, -9.984314359314856],
            [26.848569475136284, -9.983307877122824],
            [26.855212611883776, -9.977920923360871],
            [26.860304322202978, -9.977153019227437],
            [26.860645623620432, -9.97727407562882],
            [26.863923469192684, -9.978437019784518],
            [26.867540471903784, -9.979719128230002],
            [26.867768641291011, -9.9798000271762],
            [26.870396626722094, -9.984819023125926],
            [26.872956603397949, -9.985239958607469],
            [26.878890464533082, -9.978941927028742],
            [26.879812958871408, -9.978797262079301],
            [26.882129383409108, -9.978434002736327],
            [26.883864582686638, -9.985534929240464],
            [26.886193502789965, -9.986189796114816],
            [26.888667340911542, -9.981092875881689],
            [26.884263462520583, -9.966445020904251],
            [26.886050641913691, -9.962050023554481],
            [26.892390850577709, -9.9670116089767],
            [26.894351532381446, -9.965622124909867],
            [26.895373418119433, -9.964897937790393],
            [26.900516192272644, -9.965040566965763],
            [26.900710424206729, -9.965045967243741],
            [26.908089371003442, -9.977118275835863],
            [26.908816532971407, -9.96423203283393],
            [26.913685589559229, -9.964158053105347],
            [26.919490050174328, -9.966996588209271],
            [26.922803608270691, -9.968616995207444],
            [26.924307042204912, -9.969886339596281],
            [26.928961405931393, -9.973815973024879],
            [26.930560548172636, -9.97516592718485],
            [26.932952538093744, -9.965014122166538],
            [26.935816279184607, -9.966912827402988],
            [26.936000483225193, -9.967034957198521],
            [26.937726349006947, -9.967123190272003],
            [26.939482532031175, -9.967212785849235],
            [26.941298601243872, -9.964654966045213],
            [26.941237795180577, -9.960753130883379],
            [26.941223364643868, -9.959827140526645],
            [26.943305601081953, -9.959565879039975],
            [26.949248649287501, -9.953957042973048],
            [26.952729317382911, -9.954132923137035],
            [26.956277475905587, -9.958447028937242],
            [26.958637678042038, -9.958229862709807],
            [26.95928851465192, -9.958169978374588],
            [26.963341393413625, -9.95052089938247],
            [26.965411514273491, -9.949339125267862],
            [26.97153587214774, -9.955221980700081],
            [26.984297345362165, -9.955482872559124],
            [26.982600306517902, -9.950911903486269],
            [26.986966384700033, -9.948315966888135],
            [26.988007503368241, -9.940941945626358],
            [26.990058650910974, -9.938610107338],
            [26.991308973734121, -9.938978195107817],
            [26.995000500681229, -9.940064954400663],
            [26.999240202072592, -9.941314011775683],
            [27.006371631567458, -9.943414701189887],
            [27.008414456219121, -9.940623877908267],
            [27.007397456417984, -9.935121024228676],
            [27.016419804551632, -9.919116145465884],
            [27.023648663525627, -9.921532689761635],
            [27.026330803893597, -9.915283162761648],
            [27.033858630278964, -9.921831870101681],
            [27.035903346782614, -9.919272027615195],
            [27.045478601685435, -9.913534867331458],
            [27.059114316232669, -9.913180029885851],
            [27.069717392042563, -9.916011976981004],
            [27.074961509634559, -9.921718928233185],
            [27.074229270388592, -9.926805950071433],
            [27.073185271721592, -9.930304994892655],
            [27.069452432152872, -9.936034948060932],
            [27.065711313710537, -9.942400929746848],
            [27.063286354720191, -9.949716878832945],
            [27.063211475649666, -9.955437967163617],
            [27.063771276090325, -9.963381900782881],
            [27.064364555843312, -9.968782932536708],
            [27.067601314271091, -9.97544802037212],
            [27.071533593307599, -9.979886956609208],
            [27.076120351622421, -9.984959927488401],
            [27.081386429429859, -9.989077875420339],
            [27.085014507470106, -9.991292997916139],
            [27.089825547263619, -10.004627956862029],
            [27.092085265649043, -10.009706925481563],
            [27.094657464802641, -10.016374002310661],
            [27.096589583773603, -10.021136039642904],
            [27.098534303413086, -10.024943877984489],
            [27.099805463557541, -10.029389938600465],
            [27.099418463044945, -10.033522929859785],
            [27.095369544955339, -10.037982888774158],
            [27.090597387840557, -10.046893924074709],
            [27.08752946866878, -10.052623037921538],
            [27.083139270721254, -10.057719874461474],
            [27.079742312135604, -10.063131912396432],
            [27.076346433324925, -10.068542972626135],
            [27.070277556300915, -10.074915903592917],
            [27.061838439365452, -10.084472933196595],
            [27.054414522905638, -10.092754999429891],
            [27.04835879092915, -10.098173907507729],
            [27.042592763835202, -10.106769976687955],
            [27.039869724968977, -10.111545032122606],
            [27.034078766032618, -10.122048056141791],
            [27.03032360692238, -10.129368054529085],
            [27.026919807665834, -10.135414973982432],
            [27.024520767766372, -10.14082391496728],
            [27.021771808910934, -10.147505984708328],
            [27.01903688982507, -10.153232928439659],
            [27.015615047906049, -10.158029541156084],
            [27.010875690078958, -10.166920981244159],
            [27.006818851543478, -10.172017044733689],
            [26.997689612874133, -10.183481998835783],
            [26.993948853757907, -10.189848006837364],
            [26.989890575223011, -10.194944053564761],
            [26.98614585633301, -10.201627990381114],
            [26.983763737100244, -10.205766007612825],
            [26.980703736577677, -10.210858959424138],
            [26.979945577342502, -10.217852898960771],
            [26.982168577090668, -10.225792050020903],
            [26.988381816075798, -10.233720892894979],
            [26.993633855011929, -10.238791933786494],
            [27.000183694530641, -10.246401977579096],
            [27.005444732789329, -10.250836945606091],
            [27.008723612322438, -10.254323913822333],
            [27.012565904422004, -10.257637271891657],
            [27.014969611069354, -10.25971006412597],
            [27.021569850567083, -10.263507051471155],
            [27.026165610001055, -10.267943905851787],
            [27.031106609066722, -10.271425895753287],
            [27.039007886675265, -10.277444018570296],
            [27.044609846364072, -10.281242919165567],
            [27.051200725416511, -10.285674024239544],
            [27.056457803901427, -10.290427038725815],
            [27.059798257557382, -10.291822895698166],
            [27.061748723719731, -10.292637924246778],
            [27.070577121091958, -10.297668218906955],
            [27.078247879320529, -10.302128065471388],
            [27.083508559151412, -10.306564014319859],
            [27.092426083772892, -10.312959124664719],
            [27.09734371586136, -10.316379044179993],
            [27.105597795119667, -10.320805926261169],
            [27.108876674652777, -10.324294061511408],
            [27.113127553781222, -10.329685029458419],
            [27.119352672985968, -10.336659997352523],
            [27.122294591761069, -10.340465974547183],
            [27.126882790973632, -10.345539000809081],
            [27.130481710598097, -10.349978939481243],
            [27.13537662968292, -10.356956995971148],
            [27.139278668732004, -10.363620976196497],
            [27.144834548439999, -10.370916004142545],
            [27.151021866537583, -10.380750974329663],
            [27.155239626578108, -10.388684906338561],
            [27.15947754571193, -10.395030062363572],
            [27.163396864753818, -10.400422987666389],
            [27.165483747278557, -10.402911131141749],
            [27.167651703656038, -10.40549591634181],
            [27.173868543088801, -10.413107013955852],
            [27.176802541418059, -10.417548993027744],
            [27.180080701400627, -10.421036036621963],
            [27.181117760582051, -10.42227245113077],
            [27.184336620976122, -10.426110043909606],
            [27.187976578337686, -10.429631092478168],
            [27.187909619713039, -10.432456023036355],
            [27.185544780473069, -10.435323003537519],
            [27.179488861647055, -10.440741981277048],
            [27.174100742318377, -10.445841003969145],
            [27.169719543693372, -10.450302002237555],
            [27.160249746513308, -10.462403999955828],
            [27.154530787546971, -10.467503901792627],
            [27.148136829086262, -10.473241965780417],
            [27.141402669644311, -10.479616028379141],
            [27.136011671215172, -10.485032982502089],
            [27.131264712742439, -10.49203703410609],
            [27.12552379356066, -10.498726966364782],
            [27.120468674317923, -10.50382502297076],
            [27.115376836437964, -10.511783942406682],
            [27.109319836938639, -10.517202983732599],
            [27.105902718361396, -10.524203992576867],
            [27.10319587791637, -10.527707006140886],
            [27.103153758607625, -10.530884893181588],
            [27.102745878552863, -10.536607060862229],
            [27.102341598945763, -10.542010956015149],
            [27.101946678885621, -10.54677896724851],
            [27.09958579941943, -10.549326894617323],
            [27.092872880642378, -10.554113036855476],
            [27.087177681216975, -10.557306058876611],
            [27.080153723467724, -10.560502944917852],
            [27.073132552292503, -10.563382001457171],
            [27.065834452074732, -10.562129961501629],
            [27.059222334154015, -10.559287023254381],
            [27.05395229567451, -10.555486949439521],
            [27.049663617235559, -10.552955901906186],
            [27.043703459717133, -10.551065042770629],
            [27.038051462070371, -10.551079923492319],
            [27.03238146398197, -10.552366892050907],
            [27.029010425385536, -10.555871884162219],
            [27.021981428087535, -10.559385869230496],
            [27.014346551266392, -10.558453038047864],
            [27.007696634035142, -10.558470929855782],
            [27.004900107588767, -10.557920042305105],
            [26.999737396226141, -10.556903037635044],
            [26.988761359673219, -10.557249885544874],
            [26.980444643585102, -10.557589999945298],
            [26.972422406026926, -10.5607890082366],
            [26.965721369266117, -10.56462090097887],
            [26.961012570328354, -10.568765038414465],
            [26.956268492752745, -10.575452043568431],
            [26.953823373770806, -10.584356897715185],
            [26.950701455070639, -10.594216885986388],
            [26.948954376471793, -10.600577963670226],
            [26.946543457251018, -10.606941032391742],
            [26.938891659763176, -10.607278966060511],
            [26.93194654175652, -10.604436982338751],
            [26.928330343037555, -10.601268899978368],
            [26.926457623368133, -10.592056881196239],
            [26.924908543339367, -10.583479940355286],
            [26.923982623724875, -10.57807997185421],
            [26.922088664288879, -10.570457927503984],
            [26.920522665390045, -10.563151886177833],
            [26.920623464449758, -10.555525039121987],
            [26.919705464382805, -10.54948896746231],
            [26.920778624160587, -10.543764916004511],
            [26.923530463014817, -10.536765951042998],
            [26.923614342306163, -10.530409912826505],
            [26.920714542839807, -10.52342587646142],
            [26.917802503827662, -10.51739501445118],
            [26.913534345604745, -10.513274981199581],
            [26.910975917624416, -10.511637730468623],
            [26.909577586578429, -10.510742873901942],
            [26.902317469825832, -10.506630901172285],
            [26.897022591132089, -10.504737983275998],
            [26.89078847350315, -10.498397931094209],
            [26.886200634515021, -10.49332494477556],
            [26.881600555981137, -10.489206003620959],
            [26.872323359394624, -10.486687871899704],
            [26.86404948216579, -10.483849899741898],
            [26.857104364159131, -10.481008001715477],
            [26.848509366165668, -10.477217936993329],
            [26.840588649014371, -10.472789047795068],
            [26.833980491765761, -10.469628983562519],
            [26.827027454211557, -10.46742290983037],
            [26.820410655169866, -10.464898041435225],
            [26.813773697933247, -10.463961909577698],
            [26.806125500893039, -10.463981932848547],
            [26.79978266286022, -10.46590593634086],
            [26.793456384371328, -10.466558903542177],
            [26.783797587943674, -10.467855975449444],
            [26.775485551179901, -10.467877948309043],
            [26.765842593847335, -10.467902932621209],
            [26.757513636416867, -10.469196985614545],
            [26.749524518844879, -10.469854022392179],
            [26.742209680318425, -10.469872982784464],
            [26.736224683484085, -10.469888929962726],
            [26.728614645080523, -10.46704902902416],
            [26.718003648824784, -10.464853035443518],
            [26.71333265009585, -10.466135939233263],
            [26.705996572701125, -10.467744876137635],
            [26.699346654571578, -10.467762950206083],
            [26.69083769721604, -10.467237919776366],
            [26.680428659304159, -10.465907001515237],
            [26.671465741913046, -10.462759980117204],
            [26.664379504863458, -10.460966907876777],
            [26.659166706135537, -10.460980020046673],
            [26.654900707462577, -10.46099189275278],
            [26.647140552490217, -10.462246467003604],
            [26.646351430123818, -10.462374043138432],
            [26.638246752375384, -10.466018990620869],
            [26.631563715157913, -10.469660884167487],
            [26.623500436269346, -10.470134877917332],
            [26.612108600114116, -10.471524960579032],
            [26.605952601778899, -10.471088002283141],
            [26.597433564427568, -10.470205046858062],
            [26.585591727112238, -10.469782971367977],
            [26.575632690360454, -10.470262989568919],
            [26.568510452427525, -10.471187939360716],
            [26.56469553379134, -10.473010012193081],
            [26.559926614204869, -10.475287986292704],
            [26.546151579041894, -10.477588978948143],
            [26.536174541848474, -10.479428023686939],
            [26.525777744380637, -10.477191010770373],
            [26.523882704271337, -10.477195972806236],
            [26.513953547282508, -10.475409894317359],
            [26.508283549194111, -10.474065899982884],
            [26.495596792455135, -10.474778918363013],
            [26.490957473713042, -10.476150906355356],
            [26.484868795125205, -10.479678036881491],
            [26.453803850654502, -10.501513879680115],
            [26.45612352350031, -10.501251902085972],
            [26.463893761163419, -10.508275955795961],
            [26.471342519634099, -10.509093955651199],
            [26.472727753243234, -10.510093540223847],
            [26.47509659896939, -10.51180289219557],
            [26.475453726905506, -10.520537949998777],
            [26.479472938606996, -10.525311956898745],
            [26.480940657322183, -10.530581943871383],
            [26.483982289093831, -10.534731847335731],
            [26.485445336569509, -10.536727961234579],
            [26.486908525978997, -10.542676314322465],
            [26.487418928960498, -10.544750970600328],
            [26.497459025191972, -10.548063080257689],
            [26.499292270192875, -10.550097427188703],
            [26.509740830383986, -10.561691906511122],
            [26.514952907764741, -10.561238863114415],
            [26.516009508896857, -10.561147020986482],
            [26.520108251145409, -10.567906548461547],
            [26.520295835546406, -10.568215938328713],
            [26.515719889354315, -10.573339916820764],
            [26.519330688300094, -10.582028913615625],
            [26.519623548065866, -10.586394042538195],
            [26.521737648645395, -10.587745954804365],
            [26.527863743861431, -10.593640001610844],
            [26.53752285020785, -10.593138771458811],
            [26.539946622523697, -10.593012997416368],
            [26.554442946469319, -10.598789965785439],
            [26.559560420470877, -10.599511325865667],
            [26.566325795470636, -10.600464970940083],
            [26.556746738897498, -10.613477899086229],
            [26.554864742326153, -10.627993406916964],
            [26.54341561072378, -10.640339969069089],
            [26.535134505650166, -10.646666895751952],
            [26.527852787109932, -10.65780605429212],
            [26.521853929270748, -10.661109896474164],
            [26.518895689903548, -10.665787584061878],
            [26.517305511052211, -10.668302007760923],
            [26.514700857564009, -10.670523658569143],
            [26.510180933008009, -10.674378910272708],
            [26.510468932888084, -10.678285944242067],
            [26.515982725626664, -10.685413608299545],
            [26.516630510659539, -10.686250986562239],
            [26.535011746375016, -10.693021969276286],
            [26.549370702642314, -10.700231905043838],
            [26.56022361969568, -10.703826893397821],
            [26.571073656750219, -10.707647937284635],
            [26.575306535436994, -10.710128995615653],
            [26.577400655687981, -10.713067889899936],
            [26.582334453858316, -10.71622487953988],
            [26.584911692560699, -10.718484024596901],
            [26.591033492033013, -10.721412036744228],
            [26.594078731438838, -10.724121900098671],
            [26.5971416101636, -10.725472928411561],
            [26.599413710926882, -10.727261505022089],
            [26.599721728864779, -10.727503972724451],
            [26.601820528440079, -10.729990000868296],
            [26.605093647077272, -10.733378911200946],
            [26.605996527599672, -10.736773979153371],
            [26.606185527745559, -10.740397915250739],
            [26.603510728410072, -10.745614040150626],
            [26.601527489011218, -10.752187884859881],
            [26.596440690680009, -10.760581920990827],
            [26.595162690762955, -10.767607010806604],
            [26.588635533705194, -10.777363973183014],
            [26.585714494472228, -10.783260939341439],
            [26.582348495424512, -10.78689404475665],
            [26.578521696568682, -10.789621899069637],
            [26.574207458364956, -10.793257051119701],
            [26.568472659405234, -10.796896936887487],
            [26.564395723760192, -10.805184801040232],
            [26.561639502025688, -10.811864004571863],
            [26.560554462028296, -10.822286043674469],
            [26.560470582736951, -10.828627935824189],
            [26.56030246303153, -10.841312905145427],
            [26.561160702674204, -10.848106020408682],
            [26.56150954275353, -10.857617887421959],
            [26.562853782642993, -10.863502990885289],
            [26.566572581543813, -10.868928946044765],
            [26.566009541778214, -10.875726025459088],
            [26.565931781810601, -10.881615013982605],
            [26.56117978378915, -10.882533919654627],
            [26.556380624215251, -10.88707602537645],
            [26.551551586675025, -10.893884010268801],
            [26.549595707264803, -10.898419924603127],
            [26.541058668573502, -10.89889501044679],
            [26.531141752028756, -10.896203909342347],
            [26.523588593152372, -10.893959035265841],
            [26.514115555749076, -10.893531007816254],
            [26.506040757763596, -10.894912051983919],
            [26.497947600908702, -10.897650939137817],
            [26.494625856465159, -10.899697678264298],
            [26.489824562494157, -10.902656036676925],
            [26.480267644901218, -10.90856996513148],
            [26.474082487251888, -10.910398934683858],
            [26.466949809098722, -10.912230015576267],
            [26.44043999146508, -10.909241008678025],
            [26.427381904425339, -10.917524650189396],
            [26.42636468004536, -10.918169936340229],
            [26.418914661238322, -10.918039893425725],
            [26.40813158370673, -10.929454957567369],
            [26.401149746164549, -10.942302940092361],
            [26.396266707299308, -10.953187928774687],
            [26.389007669423357, -10.964532983779467],
            [26.381748631547406, -10.975876890541464],
            [26.372066794231063, -10.991305006606812],
            [26.360938836393917, -11.008547925622384],
            [26.355095678153013, -11.02034201363414],
            [26.348784520107003, -11.031683922099749],
            [26.34580264067479, -11.042111056080305],
            [26.344747840664823, -11.050267968429589],
            [26.344477624732384, -11.053703004779367],
            [26.344177601800553, -11.057516910164791],
            [26.34732760093819, -11.070193013618942],
            [26.349127601087041, -11.07743597435352],
            [26.351377600599399, -11.086489994658956],
            [26.352277600224674, -11.090111912261099],
            [26.354581600163687, -11.09508894678981],
            [26.355901720287779, -11.10278605573302],
            [26.355805600552383, -11.110034917261784],
            [26.35335256112457, -11.116382936595954],
            [26.354186681001877, -11.124987891740787],
            [26.356016560015387, -11.129965915246119],
            [26.355884800519416, -11.139933017839995],
            [26.355309521208103, -11.147634938241993],
            [26.355237521238074, -11.153070975018968],
            [26.34944260252794, -11.161241011383538],
            [26.348842843226823, -11.17075589895377],
            [26.35018060266982, -11.177093914676279],
            [26.350569758240784, -11.180473005892592],
            [26.353306842266491, -11.191582046275098],
            [26.357374841471074, -11.206519988319382],
            [26.358676600929062, -11.21557700789843],
            [26.360020840818553, -11.221461920137004],
            [26.360398892314297, -11.228708991034333],
            [26.355677960730304, -11.22736298436973],
            [26.345310682801021, -11.222859972020496],
            [26.33209976358533, -11.218365019320419],
            [26.317953925432658, -11.212966986812763],
            [26.310423806546698, -11.208910043309428],
            [26.309055806217945, -11.204836958978319],
            [26.314886725811423, -11.193949071772035],
            [26.320238845155053, -11.183515945206867],
            [26.321839764263924, -11.169921005187929],
            [26.321924004678003, -11.163578941998981],
            [26.320142004970787, -11.154976910710079],
            [26.316445885835986, -11.147738905359795],
            [26.317968684752771, -11.140033982226083],
            [26.320968924851094, -11.128247960006167],
            [26.322965844693378, -11.120540922762581],
            [26.319282684654837, -11.112396957026109],
            [26.315130804362315, -11.103800997288056],
            [26.314710684761799, -11.099725004338724],
            [26.320535844357654, -11.089290930828959],
            [26.324428884084249, -11.081578961808873],
            [26.327823683119945, -11.075680924522835],
            [26.331255923038363, -11.067064948731618],
            [26.330859923203246, -11.061177049664778],
            [26.327814682899092, -11.055478963024816],
            [26.324166803295025, -11.052521027598734],
            [26.31080972458939, -11.048506032695856],
            [26.303231725498769, -11.039174929124108],
            [26.300564845710827, -11.027936954528029],
            [26.300078597528977, -11.025884077375922],
            [26.30002196593686, -11.025644985373933],
            [26.286849893467316, -10.998445977788244],
            [26.284959836312915, -10.996398913475147],
            [26.284908777868793, -10.996399563160514],
            [26.281001787305836, -10.996450014062427],
            [26.28049028837971, -10.995958026199819],
            [26.278955306511026, -10.994481568581042],
            [26.277934840111186, -10.993499974675343],
            [26.272574880271723, -10.993110970560227],
            [26.271708688742176, -10.991453958413079],
            [26.269707809126086, -10.987625973732657],
            [26.271247852103119, -10.98093513105497],
            [26.271039422295942, -10.98023287361497],
            [26.268057604847495, -10.97019017111316],
            [26.265397889123939, -10.961232008459364],
            [26.26457384924246, -10.951811950888922],
            [26.258487118202169, -10.949360063465189],
            [26.255257742129409, -10.951469950033554],
            [26.251338186830584, -10.949810029444359],
            [26.251042989648464, -10.949684997390539],
            [26.241429811467579, -10.944517917191341],
            [26.240654316544045, -10.941912181970128],
            [26.239926826691008, -10.939467723454309],
            [26.239724852177439, -10.938789062315095],
            [26.236457113550497, -10.937574469447817],
            [26.236222192425586, -10.937487150816935],
            [26.2343439328458, -10.93678901362647],
            [26.231712608376807, -10.931105207103599],
            [26.230485075812421, -10.928453629568711],
            [26.229791701278884, -10.926955972740554],
            [26.233018772274658, -10.924615935425813],
            [26.224074933303537, -10.917138985993402],
            [26.222390853555567, -10.913020035714757],
            [26.222982634020333, -10.909666908231216],
            [26.223041674894066, -10.909332088508654],
            [26.224482431574302, -10.907612074218656],
            [26.226935852786116, -10.904683054255329],
            [26.225907659078214, -10.897336108064037],
            [26.225241653516445, -10.897592677657636],
            [26.224566155457083, -10.89785299818247],
            [26.222204692984306, -10.898763012836417],
            [26.219401773228054, -10.898109058588577],
            [26.217499893346186, -10.895142980650055],
            [26.217639933512437, -10.888011035174831],
            [26.215022672169237, -10.88367404038879],
            [26.213562316944458, -10.883742208152684],
            [26.213377968275108, -10.883750813582596],
            [26.208276018958284, -10.883988987312495],
            [26.20474310754091, -10.881680076362548],
            [26.203390875340347, -10.880796345692939],
            [26.202407965705923, -10.880153980321763],
            [26.200375855260678, -10.880830266092886],
            [26.199671692858928, -10.881064608242985],
            [26.195223758391453, -10.882544899347478],
            [26.188349872295273, -10.881588536909721],
            [26.186132778071759, -10.881280073507334],
            [26.184669069436016, -10.882087256417355],
            [26.183278112660204, -10.88285429726273],
            [26.180585828516048, -10.8843389752974],
            [26.174458596032853, -10.882129619661075],
            [26.173804987222027, -10.881893963385778],
            [26.169665114709872, -10.882607700945107],
            [26.168376859625557, -10.882829824275325],
            [26.166606709595253, -10.883135024826215],
            [26.163280354997674, -10.886856480106353],
            [26.159953899788785, -10.890577996617345],
            [26.157247983710171, -10.891919114040329],
            [26.154740628547025, -10.893161813008684],
            [26.151858940913414, -10.894590034322629],
            [26.150934022920485, -10.895061797787267],
            [26.151093941007339, -10.897819938294774],
            [26.151532780600068, -10.905404072570834],
            [26.149306901751409, -10.913251994193724],
            [26.141556822283263, -10.92599895684616],
            [26.12345098398275, -10.948072964934035],
            [26.116777011664826, -10.954135932829292],
            [26.106319132350922, -10.955415006731572],
            [26.096661947500891, -10.964963930811233],
            [26.080231909176366, -10.972755064159976],
            [26.069562950025247, -10.975874961763235],
            [26.065182787157759, -10.979379027510696],
            [26.044752832045738, -10.976470918128191],
            [26.035472033214933, -10.973897987539209],
            [26.02695695384071, -10.972066054314682],
            [26.020392714327997, -10.969487070295219],
            [26.004906956284074, -10.966559925413401],
            [25.99523769987325, -10.963989036014683],
            [25.984757717511794, -10.964016977363839],
            [25.973129079159495, -10.962935055446909],
            [25.962304919873308, -10.959625020358081],
            [25.953014040148414, -10.957794943329297],
            [25.94915196175641, -10.956320967052468],
            [25.947269870861934, -10.951874115388728],
            [25.931472840283831, -10.962182874833569],
            [25.924794479695755, -10.971919241536142],
            [25.87703939959146, -11.016103923918896],
            [25.877115907307591, -11.016142248316731],
            [25.882427346443595, -11.018802854228781],
            [25.88256270908219, -11.020605081574232],
            [25.882703280152793, -11.022478943091004],
            [25.878835439966572, -11.030113960138534],
            [25.878621838558306, -11.032331527547454],
            [25.878214440000555, -11.036561005724199],
            [25.879564368022397, -11.039481013492011],
            [25.87358879990526, -11.048616400798144],
            [25.866588960124748, -11.060198240403707],
            [25.854194879895239, -11.07473788562479],
            [25.849386720100554, -11.097202337828978],
            [25.82970480021045, -11.111556589069149],
            [25.793529120001114, -11.13261015275279],
            [25.790608079869859, -11.160685065273904],
            [25.790502240363068, -11.203673046607896],
            [25.795856880379421, -11.216796413717971],
            [25.809448319661243, -11.230744719530465],
            [25.814807639900209, -11.242011703289252],
            [25.814904714544749, -11.245132666130971],
            [25.815394800329468, -11.260888393942039],
            [25.809659280022579, -11.273730096033963],
            [25.802980920332796, -11.28345592661856],
            [25.789642559822717, -11.295487158476698],
            [25.770590640119455, -11.311393192196245],
            [25.756581239888771, -11.338553528325511],
            [25.758501448097384, -11.359238590436627],
            [25.75854639170937, -11.36322416304338],
            [25.758592200398954, -11.367288938337516],
            [25.757833279392404, -11.371200366845869],
            [25.755953400150183, -11.380888909626277],
            [25.756693067565209, -11.384561362588487],
            [25.759475817448401, -11.387436808028536],
            [25.763300015681498, -11.391388343232785],
            [25.761631242327638, -11.394179721043859],
            [25.758039581090692, -11.400187442115133],
            [25.760172239965652, -11.40315488169905],
            [25.77113927989101, -11.403952894686743],
            [25.77787437178425, -11.401577977720121],
            [25.780964400291825, -11.406603030458511],
            [25.78123572744024, -11.40901022702562],
            [25.781482439851555, -11.411199024979897],
            [25.780087084924119, -11.415178423203621],
            [25.778324520268075, -11.420204983297175],
            [25.779972239806593, -11.421566007481541],
            [25.777254239590793, -11.428498015317034],
            [25.773779520139193, -11.430605895488162],
            [25.773588360443384, -11.434288950940619],
            [25.777687320084201, -11.44574401495772],
            [25.77688087999579, -11.453233317066848],
            [25.776844199986108, -11.453573956447936],
            [25.774797240389205, -11.45819796373819],
            [25.768125360247591, -11.466092010700713],
            [25.760637359772005, -11.463874911743861],
            [25.754125320462162, -11.465556942680859],
            [25.748714117125637, -11.468393355476952],
            [25.740679320221442, -11.472604934882552],
            [25.7368631520287, -11.476299397193758],
            [25.734911354563117, -11.478189108372032],
            [25.733504485030355, -11.484975401751804],
            [25.731374399828642, -11.495249944728862],
            [25.728660360284909, -11.523111918934745],
            [25.722525509189797, -11.529733127986038],
            [25.712297279686737, -11.540771878979951],
            [25.707032297823957, -11.540470965096452],
            [25.705526399810903, -11.540384896880047],
            [25.702123320104892, -11.548932978387455],
            [25.694965439716459, -11.555451021250452],
            [25.688179343278055, -11.553684114414164],
            [25.687472123909348, -11.555118773013843],
            [25.686811486679737, -11.556459107093691],
            [25.688054416368107, -11.558649050231539],
            [25.689666240126208, -11.561488927999827],
            [25.68439619985007, -11.570055951296851],
            [25.683517023173078, -11.573479847802444],
            [25.682930280460404, -11.575764857670332],
            [25.681490280161658, -11.581358910145218],
            [25.675989479756996, -11.590159018851361],
            [25.682396400008958, -11.62045303524622],
            [25.674360389480853, -11.632271102848808],
            [25.656553440438262, -11.646952887547787],
            [25.638620400269154, -11.650363948128527],
            [25.630506360278837, -11.655282019478603],
            [25.625447268685935, -11.655142708631656],
            [25.624437479661566, -11.655114902770325],
            [25.616689200417269, -11.651055013989669],
            [25.612751500946342, -11.650358953045721],
            [25.611778440440698, -11.650186946282723],
            [25.609503475848271, -11.651717463450552],
            [25.609083480215286, -11.652000021017329],
            [25.607609251409269, -11.652990981593947],
            [25.605127464994034, -11.659453686338257],
            [25.599893400448394, -11.673082972887133],
            [25.583753102938985, -11.684506004072933],
            [25.578119519857257, -11.688492967364004],
            [25.574307946547169, -11.697626688810667],
            [25.572431179967356, -11.702123896485107],
            [25.559934479793053, -11.712144980108574],
            [25.551693359631077, -11.727179990233614],
            [25.545021324979192, -11.733221871077744],
            [25.544756160273636, -11.733461988959755],
            [25.540156278470818, -11.73404337344941],
            [25.536829320205353, -11.734463870902927],
            [25.531746001947567, -11.739346717669434],
            [25.508136239800152, -11.729862136291651],
            [25.499916000078606, -11.722247333830905],
            [25.497407160000289, -11.711688724703574],
            [25.489849680227401, -11.692358916411626],
            [25.474673879584007, -11.678393777147855],
            [25.456939200006076, -11.674243534519372],
            [25.456938515489821, -11.674243517696425],
            [25.456938115739511, -11.674243423842009],
            [25.435392656063861, -11.673702252669848],
            [25.413237000460118, -11.663265909729651],
            [25.39804931959711, -11.654239259318212],
            [25.37335727977181, -11.644356049022422],
            [25.345528560129605, -11.621424268010774],
            [25.339892760005746, -11.593797950520285],
            [25.33548131959672, -11.583804364140315],
            [25.320003840426413, -11.563648935525215],
            [25.316613000266159, -11.525261633093644],
            [25.317960839704988, -11.492549266282323],
            [25.316441280113104, -11.466249529291654],
            [25.302274919947738, -11.428505080145824],
            [25.290962280166283, -11.389900256716018],
            [25.292590920386484, -11.372015236581433],
            [25.302427199659775, -11.366699095252441],
            [25.314820200114312, -11.35248330247733],
            [25.312641119898672, -11.336664030818401],
            [25.3031803202445, -11.31818762909592],
            [25.312714920092549, -11.306680013008581],
            [25.322554439589037, -11.300126134876139],
            [25.328940120074392, -11.280499990912764],
            [25.328343600098176, -11.265334785184015],
            [25.333462080212854, -11.245674424345363],
            [25.349979239848576, -11.229700904479435],
            [25.347135600358833, -11.226227797315282],
            [25.34713482062115, -11.226227995080659],
            [25.347134576279409, -11.226227696215462],
            [25.321978156859529, -11.232612908711747],
            [25.207537486055028, -11.254605872212585],
            [25.167941474892995, -11.257032799851865],
            [25.154067511861069, -11.26865777318743],
            [25.146597239637636, -11.267343865669178],
            [25.14659706177121, -11.267343900250941],
            [25.146596370966741, -11.267343778771371],
            [25.140315743063951, -11.268548739998089],
            [25.134010200386761, -11.266995029347639],
            [25.133251319804415, -11.265758904063553],
            [25.130224440166366, -11.260817882753765],
            [25.121591279943043, -11.259743958961741],
            [25.12159117394182, -11.25974396605565],
            [25.121590428340127, -11.259743872948359],
            [25.109944737268762, -11.260534850004751],
            [25.102009440460407, -11.258995019965532],
            [25.102009277865363, -11.258995066962655],
            [25.102008602332248, -11.258994935725399],
            [25.094569567226184, -11.26112882421125],
            [25.060315911619028, -11.261654912688741],
            [25.047945360063427, -11.259459970127379],
            [25.047945206451523, -11.259460003823385],
            [25.047944557867886, -11.259459889434329],
            [25.033988447496483, -11.262567845777653],
            [25.016038499237073, -11.262029916728752],
            [25.009774502743479, -11.265071929799284],
            [24.957265655834949, -11.271152149111209],
            [24.929701193599836, -11.269531161537067],
            [24.903691659426027, -11.280007753283385],
            [24.8954569199975, -11.278563985078714],
            [24.883741799934462, -11.274868289989488],
            [24.883741557389314, -11.274868362697923],
            [24.883741101045157, -11.274868218167665],
            [24.874227746353597, -11.277720839029922],
            [24.86691471074592, -11.287739681919589],
            [24.843415725246071, -11.308171561353847],
            [24.819014386534921, -11.30963771816889],
            [24.805709279860029, -11.307532543385461],
            [24.80570895556821, -11.307532528313486],
            [24.805708626784838, -11.307532476004901],
            [24.791450834293236, -11.306864764816803],
            [24.770219846052463, -11.306949047454925],
            [24.754376253996572, -11.306859819426004],
            [24.73914898258235, -11.313896426374722],
            [24.697883645602577, -11.342843877645835],
            [24.669304700645796, -11.367162217869794],
            [24.649585711775497, -11.396645933450454],
            [24.633716559056495, -11.407063617241818],
            [24.62547724271159, -11.407165531544935],
            [24.611209730448628, -11.410515251458092],
            [24.598175216998552, -11.427802097791394],
            [24.594332579047638, -11.444082824887209],
            [24.587037182758863, -11.44698953770884],
            [24.566443032680901, -11.445853806345509],
            [24.55028407985797, -11.445138740607957],
            [24.538863445511357, -11.450413483076733],
            [24.523308707633383, -11.461763952602066],
            [24.502416120150038, -11.453205396092745],
            [24.502415621585047, -11.453205335836119],
            [24.4894280397187, -11.451643025770377],
            [24.489427546543592, -11.451642973488559],
            [24.472633193760636, -11.451529774539162],
            [24.456458631811344, -11.457302843835564],
            [24.445066320447346, -11.451145898212648],
            [24.437815200322316, -11.436131697145891],
            [24.425162999975683, -11.426852320983],
            [24.425162585852352, -11.426852310348485],
            [24.425162531953429, -11.426852271355216],
            [24.415973895779199, -11.426621261872674],
            [24.403935959830587, -11.425391711045755],
            [24.399205920227953, -11.416002120789154],
            [24.38402256026145, -11.405113171419828],
            [24.37389467976212, -11.400222809709927],
            [24.373894286300025, -11.40022278843886],
            [24.373894231502803, -11.400222761850035],
            [24.363121595988073, -11.399643056230429],
            [24.347901162549825, -11.403895973156706],
            [24.333959130575536, -11.403854643997402],
            [24.325622279648673, -11.39117293306254],
            [24.322437120450807, -11.39014596162065],
            [24.31721124045572, -11.388461004523309],
            [24.317211077860648, -11.388461044408253],
            [24.317210813755963, -11.388460959320374],
            [24.310460816117221, -11.390110941082398],
            [24.309375055670991, -11.390090981004475],
            [24.301599412844805, -11.389934840321208],
            [24.299618711186653, -11.38882245398645],
            [24.295517280280457, -11.386519025994895],
            [24.29948627975082, -11.3767179613096],
            [24.309631799569054, -11.37450050830312],
            [24.327395640257798, -11.366911078743529],
            [24.345794519783766, -11.358719218171947],
            [24.355323359634191, -11.349685849026422],
            [24.374995919977369, -11.339052622119077],
            [24.384555720264057, -11.317345024803803],
            [24.396018840431992, -11.2947561598581],
            [24.406236720444696, -11.263167706248888],
            [24.411373200102712, -11.23608621382866],
            [24.408931320445674, -11.198296831401391],
            [24.398817839940346, -11.187526950833481],
            [24.399273239975336, -11.171531969103526],
            [24.405058439812407, -11.16551592038369],
            [24.40688723994927, -11.160213943565026],
            [24.404661759952617, -11.151365361418447],
            [24.403537440221108, -11.146894927346265],
            [24.40437524498768, -11.138050045453403],
            [24.404409360307213, -11.137689877973841],
            [24.404735874556813, -11.136768933391201],
            [24.406698239803379, -11.131233951104189],
            [24.385133160023624, -11.082627220079184],
            [24.368685479685237, -11.070456175616892],
            [24.344005680303987, -11.055602061303246],
            [24.326906040461644, -11.050839748185092],
            [24.311081519639199, -11.043014983283756],
            [24.310107135016835, -11.042640742698849],
            [24.287541772185026, -11.033970876594342],
            [24.255950947658796, -11.040389492455471],
            [24.240128040210635, -11.031945881111678],
            [24.22494180024534, -11.022279968998633],
            [24.20341524022496, -11.013692119627756],
            [24.203415018341072, -11.013692148915093],
            [24.203414842271275, -11.013692078802945],
            [24.187565847747273, -11.015768891627944],
            [24.176243189953755, -11.022844406893958],
            [24.176242898899595, -11.022844588824778],
            [24.178999650640151, -11.032999925074877],
            [24.167999495220162, -11.044000013636033],
            [24.163999536211833, -11.044999936533303],
            [24.162999742741633, -11.044999936533303],
            [24.140999880161004, -11.036000014650918],
            [24.132999960347714, -11.028999909726727],
            [24.131000159608305, -11.023999984074038],
            [24.135999840221601, -11.009000044781795],
            [24.143000040226518, -10.994999957415073],
            [24.145999920100405, -10.977000018696177],
            [24.144000120259292, -10.96900008133006],
            [24.12399995960336, -10.952000019099041],
            [24.12200015976228, -10.945000018428292],
            [24.12399995960336, -10.936999913230716],
            [24.127999920408318, -10.932000002097336],
            [24.130000079575531, -10.922000099556236],
            [24.130000079575531, -10.91899993867753],
            [24.125000039636134, -10.909999979472595],
            [24.11700011982288, -10.904999962068866],
            [24.116999809005783, -10.904999962068866],
            [24.11699974792035, -10.904999923892325],
            [24.106999671634803, -10.904999924780183],
            [24.09500006410444, -10.905999947858973],
            [24.07399992043382, -10.893000031267221],
            [24.059000159941725, -10.88900000433213],
            [24.058999941651098, -10.88900000433213],
            [24.058999806005499, -10.888999967929296],
            [24.038999652536109, -10.888999975032302],
            [24.027000119565908, -10.888000077882957],
            [24.009999839682159, -10.884999922981835],
            [24.009999748952318, -10.884999931860698],
            [24.009999501017322, -10.884999888354258],
            [23.999999784956213, -10.886000002580683],
            [23.99599982594788, -10.891999906222699],
            [23.986999828796812, -10.891999907110543],
            [23.97999963148682, -10.896999970029853],
            [23.972999792604639, -10.904999928331463],
            [23.969999555201273, -10.920999898419183],
            [23.959999837343535, -10.937999994045644],
            [23.944999722915217, -10.954999986466147],
            [23.925999648580305, -10.967000031650475],
            [23.916999651429201, -10.972999868843845],
            [23.895999777253142, -10.982999972394385],
            [23.889999659077628, -10.987999895530542],
            [23.884999620934856, -11.000999894512439],
            [23.884999620934856, -11.001999965489173],
            [23.871999664775455, -11.016999912813931],
            [23.862999666726054, -11.022999958613942],
            [23.851999869733842, -11.027999901490086],
            [23.829999557097231, -11.03000002278608],
            [23.815000079574489, -11.027999931663448],
            [23.802000119821798, -11.020999987884631],
            [23.780999880031455, -11.00600007035275],
            [23.762999880339368, -10.996999960544429],
            [23.744999879748985, -10.992000015273263],
            [23.744999766561282, -10.992000029474223],
            [23.7449996165426, -10.991999987758845],
            [23.736999698525974, -10.992999913032257],
            [23.730999580350428, -10.998000017752897],
            [23.716999903484393, -11.004999986501526],
            [23.707999936876025, -11.007999960596981],
            [23.70200003968603, -11.006999947523962],
            [23.693000039840001, -11.005000013127221],
            [23.692999955398378, -11.005000023777461],
            [23.692999789210045, -11.004999986501526],
            [23.684999871193419, -11.006000044614696],
            [23.68099991218509, -11.006999921785997],
            [23.671999915033986, -11.007999966809571],
            [23.663999880236371, -11.006999947523962],
            [23.650999919585384, -11.003000064091912],
            [23.636000159991621, -10.994000039009853],
            [23.628999959986707, -10.990999909941259],
            [23.628999816256236, -10.990999925029849],
            [23.628999723729766, -10.990999885089462],
            [23.599999928842159, -10.994000023921416],
            [23.585000039890978, -10.992999940546573],
            [23.576000040044949, -10.989999977801043],
            [23.558000040352862, -10.971999906912211],
            [23.540000040660807, -10.959000029677089],
            [23.533999919790336, -10.957999987836144],
            [23.505999840219445, -10.945999927204612],
            [23.50599963001369, -10.945999896135046],
            [23.459000040249865, -10.938999959590477],
            [23.458999837230621, -10.938999950713256],
            [23.435999999720078, -10.938000026891538],
            [23.43599980119242, -10.938000006473827],
            [23.428999963208536, -10.940000045999517],
            [23.417999805093618, -10.944999998011065],
            [23.383999972063204, -10.965999852104069],
            [23.35999985689056, -10.982999983933043],
            [23.346999898934499, -10.994000019483625],
            [23.337999899986805, -11.003000045453797],
            [23.333999940978472, -11.003999932937742],
            [23.331999780912959, -11.00699992888614],
            [23.319999903888004, -11.01300000277106],
            [23.288999948934848, -11.031000014368828],
            [23.271999671746052, -11.045999879052701],
            [23.251999875806142, -11.058999933981521],
            [23.224999879861315, -11.086999974475303],
            [23.215999881811914, -11.094000091547304],
            [23.202999923855852, -11.10199994016129],
            [23.196999805680342, -11.104000083892549],
            [23.182999920405113, -11.101999957018547],
            [23.164999919814726, -11.095999958941693],
            [23.151999960062074, -11.093000000930772],
            [23.151999917841241, -11.093000009803285],
            [23.151999811840049, -11.092999984960215],
            [23.141999732859581, -11.095000018992412],
            [23.126999975062443, -11.104999981982193],
            [23.101999778958692, -11.118999879121732],
            [23.083999781961563, -11.123999932333481],
            [23.073000119716681, -11.122999941417172],
            [23.032000080393136, -11.108999886541929],
            [23.014000079802749, -11.099999971532137],
            [23.013999954038624, -11.099999959998135],
            [23.002999919891174, -11.099000062309686],
            [23.002999791432089, -11.099000048113929],
            [23.000999992489309, -11.099000048113929],
            [22.97599979728389, -11.100999855993409],
            [22.958999999795481, -11.097999972172374],
            [22.938999840037877, -11.090999953033659],
            [22.92099984034579, -11.086999991333439],
            [22.903999919788177, -11.081000034479917],
            [22.87900008031561, -11.067000063449273],
            [22.866999840371296, -11.061999908740198],
            [22.86699975772629, -11.061999908740198],
            [22.86699972808189, -11.061999908740198],
            [22.858999919659709, -11.061999908740198],
            [22.858999808268603, -11.061999896317321],
            [22.849999809320906, -11.068000071950753],
            [22.840999811271473, -11.076999923601772],
            [22.83299989235655, -11.081000022945178],
            [22.821000013534963, -11.082999975093664],
            [22.811000039657355, -11.082999975093664],
            [22.810999933656163, -11.082999963558988],
            [22.805999894615059, -11.092999989396491],
            [22.800999855573991, -11.106000052270668],
            [22.792999936659033, -11.110999974587108],
            [22.786999817585187, -11.113000061164307],
            [22.745999781854898, -11.113999916483186],
            [22.722999840139796, -11.109999937623632],
            [22.709999880387141, -11.104999997952076],
            [22.694000039862271, -11.100999877286879],
            [22.691999879796754, -11.097000055127554],
            [22.671000000230816, -11.089000067839564],
            [22.654000079673203, -11.082999975093664],
            [22.610000159577478, -11.055999963620597],
            [22.58499995988047, -11.036000014650918],
            [22.573000080160593, -11.031000033005149],
            [22.573000007397059, -11.031000033005149],
            [22.561999920249018, -11.031000033005149],
            [22.561999838502313, -11.031000024130714],
            [22.544999918843033, -11.036000005776661],
            [22.533999760728083, -11.041000090246634],
            [22.510000080340035, -11.0420000199436],
            [22.510000002186622, -11.042000011956908],
            [22.502999803080005, -11.046999981401866],
            [22.497999764038898, -11.052000041152835],
            [22.490999923360089, -11.061000036556846],
            [22.488999764192872, -11.068000075500112],
            [22.489999844225647, -11.08199999897607],
            [22.497999764038898, -11.097999964187236],
            [22.497000043332264, -11.113000064713068],
            [22.494999884165043, -11.120000080003592],
            [22.48699996435176, -11.132000013063978],
            [22.483000005343463, -11.133999953666898],
            [22.466999806390817, -11.143000041958258],
            [22.452000048593643, -11.161999951956004],
            [22.436999928775478, -11.175000076047818],
            [22.425999769762196, -11.179000054268387],
            [22.370000040015196, -11.176000082716509],
            [22.369999974438176, -11.176000086264482],
            [22.35099996029037, -11.177000077909494],
            [22.350999895611643, -11.177000070813561],
            [22.346999935705018, -11.179000050720452],
            [22.339000015891763, -11.199999880743656],
            [22.333999975952363, -11.206999893917697],
            [22.314999898024162, -11.225999971492191],
            [22.299999779104255, -11.243999910536012],
            [22.290000059449891, -11.250999904626269],
            [22.277999879692679, -11.249999996713749],
            [22.272000119944941, -11.245999958348763],
            [22.260999960033399, -11.233000060558009],
            [22.259000160192286, -11.226999976121308],
            [22.259000160192286, -11.225999978586914],
            [22.261057674993751, -11.220201666915367],
            [22.265761655368348, -11.206944872403623],
            [22.269999959879424, -11.19499992507513],
            [22.268999879846653, -11.182000002361116],
            [22.263999839907253, -11.166000115256702],
            [22.254000120252883, -11.148000036962497],
            [22.245999840215195, -11.135999887450733],
            [22.242641748138627, -11.132222049778774],
            [22.237999920401911, -11.126999933018602],
            [22.22700011981647, -11.11700002674044],
            [22.220999999844299, -11.104000106072986],
            [22.21700003993767, -11.08799994303576],
            [22.21700003993767, -11.084269898167099],
            [22.21700003993767, -11.072999956989451],
            [22.21765176587968, -11.068763861790698],
            [22.219638714422317, -11.055848683639052],
            [22.220999999844299, -11.046999989388418],
            [22.219999919811524, -11.035000060713379],
            [22.21700003993767, -11.024999975916256],
            [22.209999839932724, -11.013000021408537],
            [22.206999960058873, -10.99800004526673],
            [22.208000040091644, -10.953999963778669],
            [22.205999880026095, -10.945000018428292],
            [22.199000040245615, -10.92999990703256],
            [22.196302030239824, -10.926402638037123],
            [22.194724597584035, -10.924299419890643],
            [22.18700015962737, -10.914000074642132],
            [22.18200011968797, -10.907000050098599],
            [22.18200011968797, -10.895000024323162],
            [22.178999879589682, -10.891000024602793],
            [22.176772235551493, -10.883871723752989],
            [22.173999839650282, -10.875000013526007],
            [22.175999999715831, -10.863999932268346],
            [22.176795807344565, -10.862090068253782],
            [22.181000039655231, -10.852000099509182],
            [22.191999840240666, -10.841999954858089],
            [22.200080583276673, -10.837286323378477],
            [22.204000080185018, -10.834999988236744],
            [22.214835162086711, -10.826486922886373],
            [22.232000159755874, -10.812999975538984],
            [22.241999880308569, -10.806000030557396],
            [22.267000080005538, -10.796000100986339],
            [22.282694265161712, -10.775596896390223],
            [22.297539896310617, -10.783751460675523],
            [22.297539960091012, -10.783751466892832],
            [22.310999936320872, -10.783000063943737],
            [22.31100000010127, -10.783000060390968],
            [22.312743470167643, -10.781871950517759],
            [22.327999919760583, -10.772000098498051],
            [22.328668202551558, -10.770440831320942],
            [22.33018918417655, -10.766891977810968],
            [22.334000039732722, -10.758000056985232],
            [22.3350001197655, -10.753999975678701],
            [22.3350001197655, -10.750640017225125],
            [22.3350001197655, -10.747999928870595],
            [22.334000040631054, -10.741000045363021],
            [22.328999999793322, -10.733000079831095],
            [22.328890535584378, -10.729935436579174],
            [22.32879642627859, -10.727300649667891],
            [22.328161504222287, -10.709524135355867],
            [22.327999919760583, -10.704999926898344],
            [22.327651597110847, -10.703955086508401],
            [22.326999839727808, -10.702000045873678],
            [22.326197249818687, -10.698789603942963],
            [22.323999959853921, -10.69000004437035],
            [22.323668120391364, -10.689535483684281],
            [22.315956619971395, -10.678739518250417],
            [22.314932702244278, -10.677306022769164],
            [22.313999879975153, -10.676000054682929],
            [22.314465704060662, -10.67413682335653],
            [22.316329152218042, -10.666683177292361],
            [22.316659124981463, -10.665363294617091],
            [22.318687025921278, -10.657251606147815],
            [22.318999919914521, -10.655999998885695],
            [22.318999919914521, -10.652662181661379],
            [22.318999919914521, -10.648514199689524],
            [22.318999919914521, -10.644999967776833],
            [22.318581309483729, -10.637255291628593],
            [22.317289803396381, -10.61335997980744],
            [22.317000120073441, -10.608000037483073],
            [22.316586300358036, -10.604689787293088],
            [22.316060137333189, -10.6004808126231],
            [22.316000040040667, -10.600000069386628],
            [22.316061565654472, -10.599077271834252],
            [22.316886795803708, -10.586699692224398],
            [22.317000120073441, -10.584999911656547],
            [22.317427940930877, -10.581576467665771],
            [22.317999839881782, -10.577000042681147],
            [22.317814430302089, -10.575702166327826],
            [22.314999960007896, -10.556000002448139],
            [22.315256636532347, -10.554460100393058],
            [22.317000120073441, -10.544000036260851],
            [22.314999960007896, -10.539999942200728],
            [22.31100000010127, -10.535999972402458],
            [22.30942957160978, -10.534929251222694],
            [22.289000039604254, -10.521000015734947],
            [22.287824688378102, -10.52046578],
            [22.279330882906439, -10.516605037065387],
            [22.277999879692679, -10.516000043158288],
            [22.277999879692679, -10.507999952847895],
            [22.283999999664854, -10.505000063669394],
            [22.287967685798261, -10.504338699164656],
            [22.290000119637028, -10.503999916546455],
            [22.293000000409211, -10.498000030913847],
            [22.294838567029853, -10.482373526607317],
            [22.295000159576432, -10.481000067535918],
            [22.295999880283066, -10.466999982280003],
            [22.296496551617139, -10.466388709797915],
            [22.299299077911293, -10.462939511804228],
            [22.307512264959527, -10.452830940578114],
            [22.308999840035753, -10.451000037397963],
            [22.309711735135483, -10.441034339484879],
            [22.309999920068492, -10.436999998730839],
            [22.312658685374487, -10.432568879790166],
            [22.316000040040667, -10.427000061461198],
            [22.319674701118302, -10.423325313177495],
            [22.321252222707269, -10.421747741242836],
            [22.322999879821179, -10.420000018218982],
            [22.32463608834766, -10.414273540064636],
            [22.325508407285778, -10.41122051244273],
            [22.328999999793322, -10.398999995766825],
            [22.328805388770196, -10.39627571648305],
            [22.327999920658879, -10.385000072669762],
            [22.311559799643597, -10.36840242175764],
            [22.309790912644619, -10.352729580398655],
            [22.309757174617495, -10.352430643636595],
            [22.307000040194641, -10.328000052144416],
            [22.306291565879491, -10.326937348121449],
            [22.304101872967109, -10.323652807057323],
            [22.299960440081332, -10.317440558525732],
            [22.299000120381354, -10.316000036955938],
            [22.296680962270251, -10.314260739761366],
            [22.290999840343666, -10.310000033464901],
            [22.285000079697628, -10.306999987852256],
            [22.285000020408823, -10.306999986962692],
            [22.255477559637729, -10.30633728624229],
            [22.246405559821678, -10.299803448103965],
            [22.24063260042869, -10.290002256704595],
            [22.26125124037792, -10.26386471261957],
            [22.248055079584045, -10.240992390144511],
            [22.244756040059308, -10.230372211800459],
            [22.244990059275668, -10.221386272361976],
            [22.245000120406861, -10.22099994751993],
            [22.240777977486058, -10.216777985805956],
            [22.239000000434682, -10.215000069174623],
            [22.236000119662499, -10.208999898168235],
            [22.239000000434682, -10.199000067995479],
            [22.238132655468299, -10.194374098062399],
            [22.237232825624606, -10.189574797339242],
            [22.23604560675523, -10.183242580062169],
            [22.236000119662499, -10.182999962670449],
            [22.235402871152605, -10.181805591039096],
            [22.232999879564211, -10.17700006747997],
            [22.225441292168568, -10.163394313589349],
            [22.223000159909844, -10.159000053537547],
            [22.223000159909844, -10.143000046146003],
            [22.223999879718185, -10.136999923661918],
            [22.223508761769203, -10.136017697146169],
            [22.219999919811524, -10.128999996334432],
            [22.220048069510781, -10.128922958153222],
            [22.222850507770019, -10.124439143678112],
            [22.223856802347917, -10.122829088835154],
            [22.224999959750924, -10.121000044885035],
            [22.226000039783699, -10.113000068589756],
            [22.22569335943728, -10.111834726818341],
            [22.225055728960395, -10.109411808758818],
            [22.220999999844299, -10.094000092885986],
            [22.220610751746865, -10.090917345725323],
            [22.219440512832961, -10.081648900201321],
            [22.219765855679409, -10.080988907975016],
            [22.223631176989599, -10.073149914943707],
            [22.22363135755095, -10.07314722283831],
            [22.223631431212812, -10.073147074167149],
            [22.223961359958778, -10.068238028375792],
            [22.22110943979872, -10.052682877017018],
            [22.212385200287049, -10.036993000274347],
            [22.21230923964492, -10.036455890624101],
            [22.214082240029608, -10.031872943466164],
            [22.213262574943563, -10.025084302606293],
            [22.216013280123924, -10.022666926251791],
            [22.216729133200801, -10.02203815549413],
            [22.217443200426874, -10.021410951479336],
            [22.217237279614327, -10.016883862829987],
            [22.215518267079897, -10.012974856826602],
            [22.214676177349403, -10.011059874574833],
            [22.209339226059331, -10.012200004053614],
            [22.20882096371739, -10.011598819265986],
            [22.207950359663165, -10.010588917961092],
            [22.208068732464792, -10.007229727036098],
            [22.208110676602033, -10.00603763109677],
            [22.208193298251974, -10.003692971254642],
            [22.2081931769794, -10.003692918718697],
            [22.198673388553797, -9.99999996747799],
            [22.198673340943081, -9.99999996747799],
            [22.198673098397929, -9.999999873980725],
            [22.197761466488043, -9.99999987576162],
            [22.197838320055549, -9.998917903817517],
            [22.19823559639671, -9.993329436175745],
            [22.205047319973545, -9.990442985500472],
            [22.206362732925548, -9.986449245206549],
            [22.206362701484515, -9.986449144581419],
            [22.206363418340132, -9.986446969119497],
            [22.203910110316016, -9.978597798668337],
            [22.203804240266528, -9.9782588776455],
            [22.201978320128461, -9.972415913948504],
            [22.201299359961983, -9.961379961820624],
            [22.201286418831998, -9.96135459162349],
            [22.190597279926315, -9.940398860480979],
            [22.191809987593565, -9.934662262267768],
            [22.192533359569378, -9.932168944301052],
            [22.19154947975446, -9.930135883100604],
            [22.189365288124868, -9.925619121947694],
            [22.187065319824836, -9.920862874329728],
            [22.186656925035429, -9.920016601295407],
            [22.186525320049661, -9.919743890054637],
            [22.183723439644218, -9.916108938441232],
            [22.183517066979029, -9.915841185900723],
            [22.181202360020148, -9.912838015332685],
            [22.173788159738407, -9.909146006201892],
            [22.172271825098402, -9.905115872767693],
            [22.171711248513315, -9.903625922079229],
            [22.166843400159557, -9.902697003152589],
            [22.155876360234203, -9.894111980233191],
            [22.152691439988235, -9.891659024141024],
            [22.149475199979864, -9.889100956287605],
            [22.149475141589384, -9.889100946489283],
            [22.143911393537813, -9.888170036965029],
            [22.143911341435551, -9.888170029838971],
            [22.136024103596576, -9.890684959676197],
            [22.134797049834212, -9.890421821600357],
            [22.129533359748823, -9.889293034498039],
            [22.129503475494282, -9.889267205247489],
            [22.12648950374853, -9.886662248363665],
            [22.124432638429003, -9.88094673033685],
            [22.123884030098477, -9.87942226568574],
            [22.123295222158973, -9.877785921677614],
            [22.123295146700485, -9.877785877138209],
            [22.12329513322576, -9.877785839725128],
            [22.117042440233377, -9.87409600324588],
            [22.117042384537822, -9.874095991665531],
            [22.11124823478557, -9.872933897775848],
            [22.111248183581601, -9.872933889758636],
            [22.095928384794814, -9.881407999338053],
            [22.091753520207423, -9.88185997243315],
            [22.091753467206829, -9.881859958180716],
            [22.084755479752431, -9.880009979733414],
            [22.083671520428346, -9.879207916499098],
            [22.083671469224377, -9.879207899574183],
            [22.08021732029448, -9.878073875735222],
            [22.080217269090511, -9.878073858810295],
            [22.079331091842505, -9.877782961590702],
            [22.07553552022258, -9.876537020950867],
            [22.071575069120428, -9.872596470274214],
            [22.070905199904644, -9.871929962830901],
            [22.065826320222651, -9.862033913857335],
            [22.064241240208869, -9.860680023926513],
            [22.055378399632001, -9.853108003165946],
            [22.054548240426794, -9.852398904903151],
            [22.051098360291139, -9.846940005308635],
            [22.046402160225234, -9.838542954093567],
            [22.044550320097947, -9.836576952469041],
            [22.043326201131634, -9.835281488240732],
            [22.043298240170113, -9.835251896869194],
            [22.043213625158543, -9.835162108889563],
            [22.041975240047226, -9.833848003035952],
            [22.040464798355448, -9.832247132356777],
            [22.039232399617152, -9.830940945695964],
            [22.039232348413186, -9.830940935895899],
            [22.035524400262705, -9.830242984690559],
            [22.03552434816044, -9.830242980235949],
            [22.035403789757709, -9.83036199789243],
            [22.029482391848841, -9.836204947937366],
            [22.024486440142297, -9.833806988314249],
            [22.023311012559326, -9.831022061775361],
            [22.022775359731838, -9.829752937786164],
            [22.021622660423859, -9.828656689630426],
            [22.019975280448509, -9.827089981893529],
            [22.017685320279067, -9.824912975148328],
            [22.017666240062418, -9.823650905006179],
            [22.0175960735539, -9.818992490509096],
            [22.017484439913535, -9.811580911735605],
            [22.016050347834398, -9.809538172174461],
            [22.014250200361818, -9.806974001260334],
            [22.014046974495095, -9.797941665403949],
            [22.014038166513757, -9.79754957905137],
            [22.014044280447568, -9.794790989449352],
            [22.005024479936054, -9.786263854314502],
            [22.002933239683859, -9.780641896932252],
            [22.002469894050211, -9.779396338459202],
            [22.002029312624142, -9.778211791434485],
            [22.002035957462304, -9.778192846624094],
            [22.006386360042747, -9.765790012880048],
            [22.006436963041011, -9.765581327764401],
            [22.006548360424443, -9.76512192598226],
            [22.006372320273179, -9.761652895515624],
            [22.00208147958935, -9.756373982576976],
            [22.000818343196968, -9.755019831761832],
            [21.999790439644929, -9.753917860304593],
            [21.999439316946443, -9.753540205731655],
            [21.999075480391735, -9.753148875487977],
            [21.999075436374312, -9.753148880834756],
            [21.995598189961811, -9.753599961969753],
            [21.985838229758457, -9.76414997990471],
            [21.983752259922035, -9.764029488370857],
            [21.98166623977998, -9.763908995010667],
            [21.977504280389955, -9.759991889262626],
            [21.972261653103011, -9.742123155771866],
            [21.971035450943564, -9.7379438470547],
            [21.969000310480872, -9.731007019713108],
            [21.969000216157777, -9.731006970697809],
            [21.969000208971234, -9.731006945744577],
            [21.959228160139105, -9.725926897947978],
            [21.952355269376245, -9.715334314678474],
            [21.952355212782393, -9.715334298636341],
            [21.952354271347968, -9.715332847714901],
            [21.951272354792813, -9.715023400250221],
            [21.951263434522037, -9.715020838854564],
            [21.944250359862455, -9.713014964956962],
            [21.943008504559177, -9.711776195899237],
            [21.941013240311946, -9.709785881258163],
            [21.939636239762375, -9.704955873802561],
            [21.93935040033055, -9.697985960116158],
            [21.939113519980033, -9.69224401885457],
            [21.939441479618896, -9.690475908183245],
            [21.93938532593047, -9.690419938332342],
            [21.935743152425101, -9.686786893121251],
            [21.935739736132071, -9.686786299511253],
            [21.93428447974485, -9.686533951888327],
            [21.93428443303247, -9.686533943866561],
            [21.928991400376621, -9.685617020362807],
            [21.928991353664205, -9.685617012341003],
            [21.926325240139221, -9.685155889521031],
            [21.926325197020095, -9.685155874368728],
            [21.924191037060247, -9.684429224525891],
            [21.91976748017467, -9.682377011853767],
            [21.913997399882145, -9.67385691704848],
            [21.91075919965833, -9.672008948892648],
            [21.910759155640871, -9.672008947109948],
            [21.903835319621617, -9.671678007999963],
            [21.903835273807534, -9.671678006217276],
            [21.9013399318147, -9.671558143213341],
            [21.900566159859871, -9.67152097581503],
            [21.898523655906807, -9.668153150858627],
            [21.899106943698879, -9.665751817445518],
            [21.899660400237003, -9.663474021119589],
            [21.899173631930633, -9.66139661517871],
            [21.898744200393871, -9.659563896922513],
            [21.894813360458478, -9.656793865030025],
            [21.89481331644102, -9.65679385433336],
            [21.885553440271512, -9.654469883947298],
            [21.880233360240762, -9.650776920000135],
            [21.879355690038501, -9.646826022076018],
            [21.87809748000717, -9.641162016824651],
            [21.875429160219849, -9.629156944095504],
            [21.873295104464564, -9.62771575010219],
            [21.870985320273444, -9.626155874889754],
            [21.869476928537143, -9.62513688518716],
            [21.867567480348995, -9.623846958951768],
            [21.870403793179314, -9.616491030219626],
            [21.870489890411093, -9.616267618899476],
            [21.872701395316898, -9.610532001835834],
            [21.872701251586427, -9.610529346025755],
            [21.8727012911123, -9.610529243502013],
            [21.872497319643887, -9.606765885878847],
            [21.87135144034557, -9.604832972572513],
            [21.86957519973765, -9.601832928393206],
            [21.866358240178737, -9.595794025898467],
            [21.864645360442754, -9.592579972139346],
            [21.868421399993458, -9.580087000603291],
            [21.869087400165345, -9.577882958970237],
            [21.868452215800993, -9.570403767934986],
            [21.868019279936316, -9.565305922278711],
            [21.867740314413048, -9.562019298922431],
            [21.867740260514122, -9.56201918479254],
            [21.867740235361303, -9.56201889590127],
            [21.867729990973807, -9.56199751527071],
            [21.867726165947332, -9.561989443255312],
            [21.864151439750099, -9.554528885899865],
            [21.84604019987977, -9.537822979516537],
            [21.844009439602399, -9.530622989782685],
            [21.842601480413187, -9.525631865912647],
            [21.836033280228403, -9.516251871654347],
            [21.835405439591486, -9.515354023174405],
            [21.83235119996484, -9.49861293888706],
            [21.830301360369145, -9.489044862031072],
            [21.830445731313404, -9.48607648334097],
            [21.830446440084145, -9.486061913339983],
            [21.830448160357921, -9.485274320779839],
            [21.830448240307994, -9.485237923782977],
            [21.830457239630483, -9.482157896578595],
            [21.832680758604905, -9.475857162377928],
            [21.834427319774157, -9.470907890059445],
            [21.834206892068046, -9.468661557403486],
            [21.833976239737375, -9.466311018090042],
            [21.829616889936705, -9.461956629208162],
            [21.826128240310016, -9.458471910716243],
            [21.825170825761688, -9.456671078633377],
            [21.823230240169149, -9.453020938097968],
            [21.822509016963526, -9.451661472723018],
            [21.82221432014299, -9.451105984677952],
            [21.808206359911686, -9.439111906094592],
            [21.797970480355644, -9.430346899220559],
            [21.797321399952153, -9.428779886652661],
            [21.794691083392937, -9.422427837075585],
            [21.794065107658525, -9.420907119178638],
            [21.797291159964761, -9.411679867591996],
            [21.79843343971374, -9.410738009290379],
            [21.802671359745862, -9.40691988264034],
            [21.803104440239302, -9.399633910845481],
            [21.804352200168932, -9.392173019441223],
            [21.804666480262657, -9.390285992735283],
            [21.805374240417148, -9.387197994206367],
            [21.80574828003682, -9.386158996077565],
            [21.80807351974244, -9.38119792885713],
            [21.811546398545982, -9.380749898363547],
            [21.811546439868483, -9.380749893010863],
            [21.812244480251611, -9.378912940535717],
            [21.810177359764786, -9.37431091554504],
            [21.81367331988125, -9.36604901916399],
            [21.812260976913475, -9.362060985011201],
            [21.811147199810133, -9.358915977336428],
            [21.812980266046313, -9.355006296606],
            [21.813944399992966, -9.352949910683932],
            [21.814171200347719, -9.339455023404824],
            [21.814899479819907, -9.337304007355483],
            [21.818411279929794, -9.329293900703298],
            [21.826765439595565, -9.321277028965124],
            [21.828453480015636, -9.298073034942485],
            [21.831387747839454, -9.295175222939784],
            [21.831569280290402, -9.29499594492613],
            [21.831878010592298, -9.29469113871593],
            [21.8351822396844, -9.291428884028093],
            [21.835604562852296, -9.290704851498562],
            [21.837518279834686, -9.287423944594584],
            [21.839599440091046, -9.283858940126516],
            [21.840154358188151, -9.280343121545448],
            [21.840961535793447, -9.275233288257857],
            [21.841957440456778, -9.268930016664543],
            [21.845449439901145, -9.260667906490959],
            [21.847950360431916, -9.257112942349538],
            [21.848551200406341, -9.256258877585502],
            [21.857063399781737, -9.244157859155091],
            [21.858001204107428, -9.240820090999025],
            [21.85893432012567, -9.237498979411704],
            [21.859008187693163, -9.236893924397814],
            [21.862896479823466, -9.205042990054576],
            [21.863189681847334, -9.202631052513714],
            [21.863195274758297, -9.202585048229656],
            [21.86305623531528, -9.201566167952965],
            [21.861156240098857, -9.187643873132812],
            [21.861076842502463, -9.180142936228245],
            [21.860992440391641, -9.172168942823859],
            [21.86097336197162, -9.170410049053919],
            [21.86097331525924, -9.170409947290837],
            [21.860973314360908, -9.170409867844208],
            [21.860524199838011, -9.169432421320288],
            [21.859970539382306, -9.168227341875699],
            [21.856250519671033, -9.16013100977738],
            [21.847450320415529, -9.140969908476762],
            [21.846880466030221, -9.1397286263485],
            [21.846494198542889, -9.138885474803951],
            [21.843918360314049, -9.119118954905391],
            [21.843590399776858, -9.116597021459022],
            [21.843576360007283, -9.115930861564166],
            [21.8412644396224, -9.108543939352534],
            [21.841297739271671, -9.108120968525173],
            [21.842964360262119, -9.086950949483809],
            [21.841358399807874, -9.075687914349043],
            [21.842973359584605, -9.068043010272243],
            [21.843301918399799, -9.066487814188868],
            [21.844171439984091, -9.062371997788686],
            [21.857616360449832, -9.049544975209285],
            [21.85777617702708, -9.04921235466837],
            [21.859152479585678, -9.046347890364649],
            [21.859709400027544, -9.045185970322519],
            [21.859052725266626, -9.043676923250105],
            [21.85886520015444, -9.04324598811869],
            [21.850969319624124, -9.025670876339735],
            [21.850509240264817, -9.022720961987087],
            [21.849469634359558, -9.018399943496233],
            [21.849384266559788, -9.01804511866529],
            [21.853637280085337, -9.006356011390894],
            [21.853475394687976, -9.001377411099529],
            [21.853475330009282, -9.001376842204133],
            [21.853475233889561, -9.001373882519038],
            [21.852433467536013, -8.992219235079906],
            [21.852236159770403, -8.990484945826742],
            [21.852240908264989, -8.990461613258248],
            [21.857284440138866, -8.965677008777575],
            [21.857458181501322, -8.961206433347623],
            [21.857458159043464, -8.961205818835886],
            [21.857458273129492, -8.961202874002709],
            [21.85723893597816, -8.955216954435025],
            [21.85719335995222, -8.953971881574256],
            [21.857199180136949, -8.953957082975341],
            [21.863363399853633, -8.938282920008943],
            [21.863842200103417, -8.936380986918259],
            [21.864837239689141, -8.921622863247748],
            [21.864458159622387, -8.918156883086061],
            [21.864235164531209, -8.917756651142225],
            [21.863363399853633, -8.91619200020237],
            [21.858940440347695, -8.908260971268687],
            [21.863344319636987, -8.898912959912131],
            [21.866239439779061, -8.892765861796683],
            [21.870626400198283, -8.883451990248922],
            [21.871258199710674, -8.882110963240532],
            [21.868314479813396, -8.868264913910494],
            [21.867153480072236, -8.862802980665725],
            [21.869947440031837, -8.854770000107505],
            [21.872118239577166, -8.851530939338751],
            [21.881313303197256, -8.837804976824094],
            [21.881313354401222, -8.837804900877371],
            [21.881090159884021, -8.834817917296879],
            [21.881090112273341, -8.834817917296879],
            [21.877626240877127, -8.83480687723261],
            [21.877639199973387, -8.830213955399048],
            [21.885830280380816, -8.821950895513261],
            [21.889219320317217, -8.81853186454442],
            [21.889997234403832, -8.816079797207129],
            [21.892112280011041, -8.809412868150748],
            [21.893879160173707, -8.803843913456442],
            [21.894578051261384, -8.802634181829902],
            [21.894706440278412, -8.802411949134491],
            [21.897138645079849, -8.798205528733515],
            [21.903160320127245, -8.787791023933973],
            [21.903162597356488, -8.786796624784387],
            [21.903167159899809, -8.784803901638435],
            [21.899116439789729, -8.780226023093833],
            [21.898749865170068, -8.779811532270513],
            [21.897871199634459, -8.778818009546457],
            [21.900820109099101, -8.771938156823234],
            [21.902984279975946, -8.76688903066251],
            [21.898582200012179, -8.742754905431315],
            [21.898409385711091, -8.741808102872422],
            [21.898205280393675, -8.740689866558922],
            [21.898367332877669, -8.739877784948975],
            [21.898927439643838, -8.737070944212714],
            [21.899151359999767, -8.735954874226149],
            [21.900321562082723, -8.730101976131731],
            [21.900545278521108, -8.72898292757904],
            [21.900339360403446, -8.719564854555387],
            [21.899372400356896, -8.716442872557653],
            [21.89713535994083, -8.70922001281901],
            [21.897157423462541, -8.709200612792621],
            [21.905023019988004, -8.702284246704613],
            [21.905023023581261, -8.702284195756809],
            [21.905023269719667, -8.702283979452082],
            [21.905541663215619, -8.694686461856371],
            [21.905653286076188, -8.693051235861013],
            [21.906028439606828, -8.687552904868642],
            [21.915733319608517, -8.670898861698999],
            [21.916726558072096, -8.669195944604454],
            [21.917328479618092, -8.668163940559758],
            [21.913918684107053, -8.652564443843143],
            [21.91329936039735, -8.649731023889338],
            [21.912884569603115, -8.647832227010193],
            [21.911854319651521, -8.643115994818993],
            [21.912518203392583, -8.640070743511188],
            [21.913255439966463, -8.636688987921865],
            [21.918457475978958, -8.628425713864917],
            [21.919691160206437, -8.62646601695193],
            [21.920904360150463, -8.624537876284148],
            [21.931764479895758, -8.619514899578199],
            [21.933155481587356, -8.61767938241316],
            [21.933849233413277, -8.616763929269986],
            [21.933628200242691, -8.61285888779468],
            [21.936008520149937, -8.609186867951909],
            [21.935966399942895, -8.608559864543921],
            [21.936197520295824, -8.601383015847302],
            [21.935090513794773, -8.599724013066623],
            [21.934816199748042, -8.599312913269319],
            [21.934816147645744, -8.599312907904896],
            [21.924896399611249, -8.598366948753688],
            [21.924619660113223, -8.59803452222704],
            [21.923708400105863, -8.596939889579499],
            [21.922596360344308, -8.595604945378783],
            [21.923525496825807, -8.593311071035247],
            [21.929298479575017, -8.591259930318037],
            [21.930917173648425, -8.589121290455489],
            [21.930917170953464, -8.589121221610311],
            [21.930917347921593, -8.589120988251958],
            [21.930583624691852, -8.579486655735153],
            [21.930490439752475, -8.576794952101126],
            [21.932575200456537, -8.573356012793338],
            [21.94274916003835, -8.565115008046446],
            [21.944875319602247, -8.545600996913501],
            [21.941483582923354, -8.540247407442248],
            [21.938900400068746, -8.536170005086355],
            [21.939787439699433, -8.531103964843158],
            [21.94003541693866, -8.529683246820301],
            [21.940305480157491, -8.528135985163768],
            [21.943315309771428, -8.523171606236824],
            [21.946560480023525, -8.517818984188247],
            [21.949484129760684, -8.515052091900442],
            [21.955587479633746, -8.509275922740159],
            [21.956966280407133, -8.507971856438719],
            [21.957710399872742, -8.503008987664353],
            [21.953079360004267, -8.493953890223363],
            [21.948280221091633, -8.475801771179635],
            [21.95178444031885, -8.45789889336293],
            [21.951349697942142, -8.453840989405018],
            [21.951011159742496, -8.450681030449337],
            [21.950742461962918, -8.448167997429277],
            [21.950432279983517, -8.445266964965652],
            [21.944944439573479, -8.426193858859055],
            [21.943051636269253, -8.422141457447809],
            [21.939897239878288, -8.415387950831263],
            [21.9380623204177, -8.411939878513902],
            [21.938049005588553, -8.411926015366932],
            [21.934007280309409, -8.407717900881456],
            [21.924503279774925, -8.397820857371393],
            [21.924137159702763, -8.397438990241994],
            [21.923839691579577, -8.396994387267807],
            [21.924559782907959, -8.385069894170678],
            [21.925005480239562, -8.377691898665477],
            [21.924557820089067, -8.372295429980642],
            [21.924110159938603, -8.366898885510238],
            [21.923115042199463, -8.362636408840514],
            [21.920912279698008, -8.353200948833921],
            [21.920560501229374, -8.351698968184266],
            [21.920461199661226, -8.351274983239232],
            [21.920498738460335, -8.351241584932845],
            [21.9266891997631, -8.345733988275411],
            [21.931650359718692, -8.341319964320963],
            [21.934797479755826, -8.335472854964497],
            [21.935655272935811, -8.326728326670437],
            [21.935743188357716, -8.325832083597126],
            [21.93569886997318, -8.325599355420211],
            [21.935146319835159, -8.322699949540073],
            [21.934606320060016, -8.319859982737384],
            [21.933326419307807, -8.316865440701244],
            [21.932543160245295, -8.315032865471068],
            [21.929166454177707, -8.311768573371745],
            [21.925874227476086, -8.308585921371801],
            [21.925874144831088, -8.308585889160733],
            [21.925874107101844, -8.308585853370651],
            [21.92399573702928, -8.307857977097317],
            [21.922563240358087, -8.307302861516094],
            [21.90909420012698, -8.302080965084572],
            [21.902614351945324, -8.299569016820152],
            [21.90224615317161, -8.299177046065342],
            [21.899914200355919, -8.296693870313568],
            [21.899229480191817, -8.295488941978826],
            [21.898395963982423, -8.294025963586309],
            [21.89687724162037, -8.289450780168353],
            [21.89741940004717, -8.25983601109073],
            [21.895787986727662, -8.25388358608293],
            [21.895593479909067, -8.253173896888786],
            [21.895414672048414, -8.252810121792917],
            [21.891966479847166, -8.245794895662906],
            [21.88734048042577, -8.236390948350884],
            [21.886642440042678, -8.228577873403934],
            [21.886478280111028, -8.22674189310759],
            [21.885328440140611, -8.213888007069231],
            [21.883528680740216, -8.209135783415197],
            [21.879938160363682, -8.199654923831526],
            [21.8791504968613, -8.197571902486144],
            [21.881006279694379, -8.192755978756013],
            [21.885393331741771, -8.189155335176869],
            [21.888107279657333, -8.186927864565407],
            [21.889089360146766, -8.186121974873041],
            [21.889938345345378, -8.181955722140419],
            [21.889941298107701, -8.181940975417954],
            [21.890024228778113, -8.181534005579898],
            [21.890023164274485, -8.181532168950456],
            [21.89002317685091, -8.181532106297434],
            [21.887342279751294, -8.176906032930566],
            [21.867964199734686, -8.159661904687873],
            [21.86787831809858, -8.159142415479732],
            [21.86766035986119, -8.157823997322899],
            [21.867031558925241, -8.15399534083816],
            [21.867026287611143, -8.153963543981741],
            [21.866604430668868, -8.151394905739513],
            [21.866600127738671, -8.15139280491157],
            [21.85804944004494, -8.147237887818155],
            [21.855097440375715, -8.143739983860627],
            [21.854295359811353, -8.142929011031431],
            [21.852155129935149, -8.130960006287111],
            [21.852148319806954, -8.130921919985092],
            [21.849146729540795, -8.126502622797059],
            [21.84594120014555, -8.121783007399502],
            [21.844806479719711, -8.12011190870709],
            [21.844167202630913, -8.11743144657803],
            [21.843248400368424, -8.11357891095421],
            [21.842386767788913, -8.109971255529191],
            [21.841846200278507, -8.107707880800254],
            [21.838928442591275, -8.103749374944263],
            [21.83522435989147, -8.098724009283846],
            [21.834045359708607, -8.097124892430713],
            [21.830843160368136, -8.089311912128775],
            [21.829035239773408, -8.07736992929393],
            [21.823303319914153, -8.068630886237731],
            [21.816841320358858, -8.062387882735388],
            [21.810671280457445, -8.056426881947264],
            [21.810238072403251, -8.054973655837287],
            [21.809423160303378, -8.052239960686141],
            [21.808530809832753, -8.049241002702718],
            [21.807934200024995, -8.047235938849035],
            [21.799886405396993, -8.043079972299086],
            [21.789665279771182, -8.033126951647956],
            [21.789665233957098, -8.033126944484952],
            [21.783798360192691, -8.032240985556545],
            [21.779663399668529, -8.028325938884338],
            [21.779234279847227, -8.018455890465475],
            [21.775795200156207, -8.013394877545133],
            [21.776727239992724, -8.009954866293246],
            [21.770523359656252, -8.006032999295124],
            [21.763441439909915, -7.99815185301767],
            [21.759401160020065, -7.994119940080136],
            [21.758278319813844, -7.986270862437969],
            [21.760826416270053, -7.967985693246952],
            [21.760826464779097, -7.967985020709022],
            [21.760829954733957, -7.967959975611087],
            [21.760828576718339, -7.967955675308429],
            [21.760828584803146, -7.967955561576984],
            [21.759750000099398, -7.964589896228967],
            [21.759750000099398, -7.960810113853385],
            [21.759749955183644, -7.960810047583462],
            [21.759749955183644, -7.960810008179735],
            [21.748139955975152, -7.943589922476104],
            [21.748137210723623, -7.943586088510177],
            [21.748136528902325, -7.943585077403536],
            [21.747560040458652, -7.942779974201595],
            [21.745450080214244, -7.938799982908351],
            [21.744749880281194, -7.932939959387509],
            [21.745260000293378, -7.929479985683148],
            [21.759641740531261, -7.915382961771328],
            [21.765480119734839, -7.909660024881462],
            [21.765830039589144, -7.909319988666958],
            [21.765841438311778, -7.909310421304197],
            [21.768069960003999, -7.90743987754943],
            [21.769430451315284, -7.900227748021309],
            [21.77065449302648, -7.893711906053757],
            [21.770669880268965, -7.893629998151418],
            [21.770930159936007, -7.878869978095383],
            [21.762060120260465, -7.845360117840206],
            [21.764149919614916, -7.83138996472131],
            [21.765257280052186, -7.830411971681508],
            [21.765263270916829, -7.830296288342964],
            [21.765413520436294, -7.827394961857632],
            [21.765690359647294, -7.823444911110143],
            [21.763866239733044, -7.817929951766754],
            [21.765266280273007, -7.812196029220078],
            [21.769651439570115, -7.809456873928881],
            [21.7719654233852, -7.806022066560403],
            [21.7719654233852, -7.806021994890101],
            [21.771965474589166, -7.806021919636295],
            [21.771969697569322, -7.803857001031601],
            [21.771973580986309, -7.801889899207615],
            [21.771979920397257, -7.798640046351702],
            [21.769419959891081, -7.795629946063959],
            [21.76944983965404, -7.782349996651363],
            [21.768040080241015, -7.777419967950226],
            [21.780650160380606, -7.764409951507872],
            [21.783610079597377, -7.760000038294515],
            [21.785839920016439, -7.754669939019524],
            [21.784359959958874, -7.745480044526243],
            [21.786040079933066, -7.740510114299424],
            [21.790469880109903, -7.737209948476999],
            [21.793610160374474, -7.734819941009288],
            [21.795469920049303, -7.730780077416757],
            [21.795839999895207, -7.727470012894323],
            [21.796589880256732, -7.713860008051968],
            [21.807330119827373, -7.692550056441206],
            [21.811039920303966, -7.682249899542139],
            [21.812339880436461, -7.67250993337726],
            [21.810329999701224, -7.661840110363102],
            [21.812919839970391, -7.656510008898936],
            [21.823809840377002, -7.653030037620152],
            [21.829349880091574, -7.637219954529615],
            [21.830297047557448, -7.640788054034921],
            [21.835145159924441, -7.659051027123116],
            [21.839379480407228, -7.663816890302349],
            [21.853363319974832, -7.668299975130494],
            [21.86918820012335, -7.674880114699455],
            [21.873419999933478, -7.676378371308065],
            [21.902853959581059, -7.679180020026204],
            [21.928608359637764, -7.68105491863583],
            [21.940935480344329, -7.684015663981111],
            [21.94866539982085, -7.68913307005678],
            [21.9628375199838, -7.699764338075724],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kamina",
        AREA: 108204,
        POPULATION: 2957000,
        DISTRICTS: [
          "Kabongo",
          "Bukama",
          "Kaniama",
          "Kamina",
          "Malemoa",
          "Nkulu",
        ],
        OBJECTID: 5,
        NOM: "Haut-Lomami",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [25.948896479991298, -6.234092813810884],
            [25.948967400186348, -6.247541551277174],
            [25.953755039765035, -6.25559855099347],
            [25.95984335992506, -6.264935942781026],
            [25.971115320397189, -6.275612593548607],
            [25.977141360358544, -6.273182917335051],
            [25.981485321120068, -6.252645376490151],
            [25.982191440052528, -6.249306885692456],
            [25.982994240167432, -6.237972737227846],
            [25.985915999849265, -6.219526134902289],
            [25.994517119861381, -6.214613750045102],
            [26.005684319703402, -6.205537566467228],
            [26.016462360381166, -6.204440366355252],
            [26.01994464005417, -6.210377118148533],
            [26.026669079724762, -6.258387138288661],
            [26.02798560029952, -6.262609223934029],
            [26.036624519622166, -6.264841533434132],
            [26.046110519715011, -6.264145203290746],
            [26.055181080429982, -6.266384134581475],
            [26.06038199983659, -6.271085537161724],
            [26.065196279853332, -6.284185067731883],
            [26.07216084009767, -6.296056491825905],
            [26.085105000098153, -6.296673244755174],
            [26.09328779983527, -6.29427644909926],
            [26.105340239982453, -6.289417083792884],
            [26.112653999632261, -6.285746419509516],
            [26.116496143509774, -6.295480555534438],
            [26.105068631661347, -6.319666311792425],
            [26.096932273027775, -6.330887423129274],
            [26.06353075750247, -6.377016316656742],
            [26.059697117077448, -6.386200864097545],
            [26.055509958147081, -6.410083559531251],
            [26.051236038129911, -6.41758048411072],
            [26.040488959685035, -6.424558839585017],
            [26.024145322222843, -6.433552512443725],
            [26.010356271544822, -6.436283508953674],
            [26.000836764291876, -6.430678029998906],
            [25.995635485559163, -6.425978103433782],
            [25.987859543594013, -6.423759608289681],
            [25.984010366806125, -6.430002521210411],
            [25.98106592735834, -6.444240303888123],
            [25.985012966613258, -6.456482245558783],
            [25.984617326104246, -6.46319717986108],
            [25.975564716423605, -6.464319783494987],
            [25.960893019774971, -6.463256995126903],
            [25.945783120439174, -6.460927260300444],
            [25.943652931032897, -6.465935561369314],
            [25.949098651235861, -6.516842132432363],
            [25.948442667279444, -6.527970843783551],
            [25.947911371281052, -6.536984037029362],
            [25.941914132205998, -6.544872948014579],
            [25.930319973889226, -6.554776475734931],
            [25.934237852931734, -6.561555427470458],
            [25.93734429276121, -6.577981325663766],
            [25.934389052868756, -6.59011505053916],
            [25.934451406729284, -6.601874322222607],
            [25.952145281233761, -6.60340280598809],
            [25.965945192543558, -6.602772302803529],
            [25.983650007629915, -6.606400532562391],
            [25.991021366357412, -6.61365119997261],
            [25.999704925661458, -6.624281212149424],
            [26.010603204941688, -6.645861858343507],
            [26.017114163578292, -6.653518814274552],
            [26.01461684439348, -6.670696268547764],
            [26.011809088107757, -6.682222259400861],
            [26.011661711400546, -6.68282763176467],
            [26.006155919956182, -6.702057613362586],
            [26.01051875971174, -6.711360500241277],
            [26.031663719891011, -6.712940913598276],
            [26.034307559688532, -6.723476928104513],
            [26.032232879878599, -6.73897903770691],
            [26.033794856121595, -6.742821950573444],
            [26.037040320122774, -6.750806628865855],
            [26.060370119616941, -6.759504921592306],
            [26.085443039732812, -6.763731687650751],
            [26.090784338868868, -6.789584761002152],
            [26.10090035980982, -6.788418986953396],
            [26.10657819659739, -6.790698850299282],
            [26.112869279991767, -6.793224942022866],
            [26.120456280201541, -6.79137386081577],
            [26.12575115979358, -6.794581932755706],
            [26.130167383731521, -6.794964140763152],
            [26.133573240130055, -6.795258905120788],
            [26.134774559854471, -6.81383634839647],
            [26.111849400191836, -6.814096532892506],
            [26.094880440070487, -6.810843499436761],
            [26.09483724008847, -6.819355667802876],
            [26.086665960346533, -6.835933457204692],
            [26.079799320061436, -6.842544906804971],
            [26.081587079766241, -6.854324290266127],
            [26.075594520015503, -6.863047341956541],
            [26.068274279919237, -6.865454598337582],
            [26.045009999948633, -6.870977427812988],
            [26.038152359884361, -6.879267365915953],
            [26.04078972013372, -6.888540478124026],
            [26.052497279975345, -6.900049445726845],
            [26.072801639830846, -6.905813215227829],
            [26.089634879784153, -6.907747218474579],
            [26.108629200409691, -6.91055338700749],
            [26.113401360219395, -6.91566169809853],
            [26.113863960251354, -6.921544067131332],
            [26.10923556412477, -6.929957753964669],
            [26.102346480330592, -6.935253920227262],
            [26.098402320176174, -6.941243021246059],
            [26.094320280303688, -6.947444926994794],
            [26.101558080209696, -6.959964052595074],
            [26.108466839803562, -6.961327715714691],
            [26.116665480432395, -6.961871712779167],
            [26.135210879672812, -6.961313762299342],
            [26.150311800347346, -6.961962409413298],
            [26.176292999860475, -6.944186199609653],
            [26.188991640412322, -6.944171172092033],
            [26.203513320205143, -6.942330525058463],
            [26.216813520281992, -6.942922667424938],
            [26.220386169574269, -6.951366512875505],
            [26.220651477111968, -6.968367792492823],
            [26.21981613911916, -6.971659901900178],
            [26.218143360177447, -6.978251972451239],
            [26.214927359120939, -6.980785325598597],
            [26.213199480214655, -6.986524615454143],
            [26.215339680446451, -6.98998768006228],
            [26.217814680089713, -6.993992173747271],
            [26.22386412026593, -7.003779218815919],
            [26.226074520243937, -7.013882651511173],
            [26.234791200432497, -7.03079728685586],
            [26.24534571870802, -7.034758078128066],
            [26.26158852027956, -7.040853443618356],
            [26.269800480229122, -7.043914746204374],
            [26.278855560276813, -7.043213095099477],
            [26.287016399798489, -7.036623997022204],
            [26.298394199777402, -7.01302605527733],
            [26.314981560057639, -7.02121096617643],
            [26.338753440266068, -7.043668462502796],
            [26.36298288005937, -7.050324529408368],
            [26.378704799801632, -7.050305929050509],
            [26.39019059973559, -7.050899899865137],
            [26.399861279976115, -7.051800065045167],
            [26.413377479962978, -7.045200000802311],
            [26.41405824035327, -7.041063957917499],
            [26.416050630889924, -7.039429149182303],
            [26.419111200046085, -7.036917861039082],
            [26.428960044055213, -7.038127012329477],
            [26.433838440427053, -7.038725936796178],
            [26.43885100018657, -7.041840000773008],
            [26.443352382616816, -7.044636275691757],
            [26.458025399788919, -7.05062285657313],
            [26.468691520263746, -7.055524671036077],
            [26.473455359877299, -7.057713964701797],
            [26.485657614759351, -7.061822726209966],
            [26.477519039981974, -7.090447032119433],
            [26.481477960354869, -7.102920409801238],
            [26.475514199693816, -7.117092482905493],
            [26.470853280062382, -7.132961659158093],
            [26.469187920306624, -7.144261729142141],
            [26.457151320152828, -7.152048746711844],
            [26.407211278562794, -7.160542210265038],
            [26.394469305078264, -7.190142241370743],
            [26.385931596243726, -7.209974533171618],
            [26.385704100592953, -7.213245777631895],
            [26.385484319673889, -7.216407891518485],
            [26.383673236111015, -7.221452168251686],
            [26.3825130682098, -7.224683145088612],
            [26.382190722143132, -7.224977051042286],
            [26.379987691045415, -7.226985708518969],
            [26.382301190668564, -7.232723886234043],
            [26.381622240383553, -7.237548999574783],
            [26.380894045352992, -7.238644848077529],
            [26.377954199889562, -7.243068943311045],
            [26.376848285739918, -7.261906959785819],
            [26.380991519747845, -7.262357994316251],
            [26.383299480358957, -7.264880953622303],
            [26.382843359875128, -7.266948935794171],
            [26.379149528749334, -7.269481932473878],
            [26.37847723767554, -7.269943001250654],
            [26.371605178752624, -7.283509151959383],
            [26.370237790176596, -7.289256711633972],
            [26.368871399628873, -7.295000000646102],
            [26.367780731686231, -7.296421525073574],
            [26.364282479967432, -7.300980949030214],
            [26.359480440394776, -7.313852967597218],
            [26.352600479890622, -7.324202898178734],
            [26.352377279983536, -7.32718898425163],
            [26.358158360146714, -7.339121131078189],
            [26.372871595792404, -7.374292421430656],
            [26.387707842241529, -7.370024179632823],
            [26.396173506190284, -7.370014178528597],
            [26.410825598904463, -7.40218049273838],
            [26.4176997976144, -7.417959767766555],
            [26.424044374785634, -7.418862928060463],
            [26.433733115654935, -7.416119096874804],
            [26.438311234871669, -7.407612948334852],
            [26.436239435060568, -7.398810685139466],
            [26.428432115840831, -7.388193547103346],
            [26.421852756783572, -7.37393091790016],
            [26.421908197209671, -7.363000221009905],
            [26.427673955707359, -7.358742539415026],
            [26.43463272002149, -7.357823355708915],
            [26.443983754531089, -7.362063148497314],
            [26.449703793272402, -7.3669145282898],
            [26.454513752392639, -7.372374231897725],
            [26.460802952019836, -7.38420812112174],
            [26.465548471391482, -7.402419430780046],
            [26.471388030981348, -7.432827997424598],
            [26.47553190369144, -7.433507922755865],
            [26.478584823692952, -7.430448639972332],
            [26.479206149747416, -7.429826014616094],
            [26.479201106605412, -7.427872827538005],
            [26.47919606975162, -7.425921922692754],
            [26.479479431629883, -7.42587786860268],
            [26.479938107820686, -7.425806559789725],
            [26.482186938624857, -7.425456776554364],
            [26.482991902781301, -7.423354569649317],
            [26.483331028479153, -7.422468843201989],
            [26.483628548704601, -7.419739181985291],
            [26.484007108646804, -7.416265992259169],
            [26.487462471200644, -7.412801648620431],
            [26.490894267351333, -7.409360904999557],
            [26.494426434963643, -7.407841386373093],
            [26.495722146963168, -7.407284040499334],
            [26.496885839853558, -7.407977287167244],
            [26.497588741020682, -7.408396114006298],
            [26.498028105229519, -7.408657853113839],
            [26.510456215438605, -7.40840196151889],
            [26.515760183286389, -7.41321296355371],
            [26.517791982016242, -7.413824950866595],
            [26.518985351650379, -7.414184399226584],
            [26.521059022652238, -7.414808997355781],
            [26.521593175293201, -7.415214893387242],
            [26.522694087623346, -7.416051462947321],
            [26.524977982368014, -7.417786959197503],
            [26.526687955155722, -7.421343780339818],
            [26.527294221852781, -7.422604836263917],
            [26.52787814116051, -7.432861274632206],
            [26.528496981576577, -7.443730849186891],
            [26.530586061380514, -7.450387007453107],
            [26.533958059377685, -7.457073526816096],
            [26.534519060865865, -7.458185958564697],
            [26.537375857081269, -7.460776226888987],
            [26.539825101127011, -7.462996953916179],
            [26.543148212806404, -7.464120898055721],
            [26.544923680863189, -7.464721509061361],
            [26.549270132653, -7.466191868427463],
            [26.570911027547822, -7.467292923954619],
            [26.577129014129213, -7.468886972410005],
            [26.581861816949687, -7.47311606033376],
            [26.584361068410651, -7.475349299294609],
            [26.586357245346203, -7.477133076022183],
            [26.587288213492585, -7.480804890106551],
            [26.59605206152181, -7.487510396835638],
            [26.596880052193889, -7.488143913776543],
            [26.601588834063673, -7.491746680481672],
            [26.612428166793297, -7.500039864083738],
            [26.618902263062175, -7.50052150131318],
            [26.621407960833647, -7.500707971260691],
            [26.625014276287811, -7.503737460253039],
            [26.63040510493537, -7.508265998748889],
            [26.647670210859804, -7.508914922120176],
            [26.651130242856492, -7.510973886039339],
            [26.649690243456075, -7.51907528945079],
            [26.650073643521004, -7.532885056745648],
            [26.651098923992453, -7.539409415543368],
            [26.653642682484183, -7.544566088883886],
            [26.661142226311132, -7.552973856452349],
            [26.668035120758763, -7.54859487431844],
            [26.670450158755099, -7.547556125822712],
            [26.671254994452429, -7.547209986919816],
            [26.674565165900162, -7.547752225358449],
            [26.675489250256518, -7.547903597436171],
            [26.682310101614995, -7.549020929519211],
            [26.685523917070402, -7.546257929133235],
            [26.686577302233808, -7.546174671979883],
            [26.691509276824135, -7.545784857677087],
            [26.69341154747314, -7.543703962219136],
            [26.699082955916548, -7.53749994352601],
            [26.701140971977956, -7.533131706380855],
            [26.696664115351599, -7.527063089163573],
            [26.696929607942266, -7.526536694769176],
            [26.698811885686304, -7.522804803039839],
            [26.711005433198324, -7.530991991384545],
            [26.736152974568217, -7.550386914408797],
            [26.744921027611255, -7.550376560703483],
            [26.752801065453227, -7.546573428739509],
            [26.763742215932101, -7.535330831384268],
            [26.775392040152077, -7.533495901536741],
            [26.78475384007206, -7.535609416741025],
            [26.794257120157706, -7.539695635971277],
            [26.80299828033607, -7.544996657179043],
            [26.808257880392006, -7.551212302920681],
            [26.808770880402985, -7.557066274883016],
            [26.809015680301044, -7.568446881708967],
            [26.811095399659727, -7.575728310212999],
            [26.82605916016681, -7.576165799268252],
            [26.826640919924589, -7.580717338712659],
            [26.822974320328306, -7.588308667350472],
            [26.81446571960392, -7.596816059633279],
            [26.80796916006306, -7.625955866190908],
            [26.815687043911399, -7.626761455407163],
            [26.818916829615933, -7.627098578483455],
            [26.823963309760583, -7.627625326981689],
            [26.828941342772126, -7.628144929834358],
            [26.837238240228444, -7.629010951391854],
            [26.842642761895888, -7.62877226151499],
            [26.848287360119624, -7.628522967855045],
            [26.855823239901508, -7.629705950999831],
            [26.85738751583164, -7.629951530770017],
            [26.865562319664427, -7.631234911872968],
            [26.872138912808925, -7.633069710846994],
            [26.886760199597074, -7.637148865567223],
            [26.898811022776719, -7.63740438659002],
            [26.906101199853691, -7.637558963904012],
            [26.924761439720005, -7.641412898692041],
            [26.934311893934492, -7.638164271747534],
            [26.941089239883741, -7.635858913265086],
            [26.945348829077147, -7.635388334660371],
            [26.949606479706215, -7.634917969733539],
            [26.950506470348319, -7.635241642614389],
            [26.954675280290708, -7.636740911539344],
            [26.955562319921395, -7.625717945375676],
            [26.969387400228801, -7.632441108394847],
            [26.980967207958908, -7.634197330790831],
            [26.997181559885405, -7.636656426361209],
            [27.029859479754425, -7.63176272354374],
            [27.054059039784772, -7.629306563380493],
            [27.054479675018225, -7.62937397094047],
            [27.087893999621176, -7.634728637702589],
            [27.121466973889817, -7.626471352764415],
            [27.13996188062471, -7.621922454891621],
            [27.190789560123427, -7.615186442908086],
            [27.21498011993296, -7.614550900768745],
            [27.225278279687632, -7.610897316677748],
            [27.222276240263827, -7.606652267646008],
            [27.219329640367786, -7.591482279043338],
            [27.221834160447898, -7.574484438060233],
            [27.225539279803549, -7.559305440061889],
            [27.220164479795603, -7.545957808515696],
            [27.219025799595961, -7.531997497160655],
            [27.225173880180261, -7.511957640287049],
            [27.227675520261577, -7.495563766194355],
            [27.233888399920602, -7.485998910614351],
            [27.236216217791053, -7.489379551183477],
            [27.237360240271702, -7.491040980528974],
            [27.244737359895119, -7.494692017852423],
            [27.250508367249015, -7.49529164038135],
            [27.251184239905836, -7.495361865459711],
            [27.25556723965299, -7.498104853655827],
            [27.260200439969719, -7.506358011450104],
            [27.264051175334604, -7.510174655324087],
            [27.265974480036011, -7.512080919600057],
            [27.267158051745341, -7.516213342944177],
            [27.268537319642686, -7.521028986680856],
            [27.274754826523697, -7.524807554691691],
            [27.278688275166694, -7.527198083726172],
            [27.280546188803619, -7.532014976401372],
            [27.279869399865195, -7.53569088483532],
            [27.282640567769405, -7.538552097783649],
            [27.285413285267509, -7.541414718712812],
            [27.304234066651503, -7.542216427133085],
            [27.307865509780843, -7.541605074868692],
            [27.319370026113727, -7.538556328129002],
            [27.333280908107199, -7.537932824615051],
            [27.354003747239517, -7.53890488370009],
            [27.356270017038309, -7.529022982202043],
            [27.361694737324889, -7.520257786374386],
            [27.362678015268589, -7.518668999834058],
            [27.364522456871178, -7.516742557849504],
            [27.368412093779469, -7.512679966493979],
            [27.381058889861329, -7.50873588692532],
            [27.388860191266971, -7.501821875384387],
            [27.391126205944218, -7.501500211451755],
            [27.392209793365769, -7.501346382618943],
            [27.397144046981968, -7.50064590188265],
            [27.40288280481716, -7.496723868763929],
            [27.406489063677512, -7.492449746120807],
            [27.412390991500889, -7.485454715747617],
            [27.414344840718602, -7.483138966274861],
            [27.416665882596881, -7.481292371197104],
            [27.419852840221903, -7.478756849885428],
            [27.423695422477302, -7.478265052500477],
            [27.429055826982825, -7.477578899133123],
            [27.430708585171764, -7.476010761704646],
            [27.433185076916704, -7.473660852673123],
            [27.436651179728109, -7.473009083239322],
            [27.437938526615664, -7.472767027247143],
            [27.439395668566689, -7.472493055294519],
            [27.440314100723274, -7.473475723055298],
            [27.445173080908553, -7.478674706620085],
            [27.444269113424667, -7.483728962360685],
            [27.446268636584669, -7.486980631281541],
            [27.447510913197814, -7.489000836542083],
            [27.444621114675478, -7.495795701787602],
            [27.44340310065984, -7.498659946009994],
            [27.444115753937687, -7.504627932001251],
            [27.443296658383531, -7.507781261993938],
            [27.441847034433113, -7.513361933642283],
            [27.443707873882918, -7.519096897557001],
            [27.443612833922504, -7.520739885902501],
            [27.442842287817882, -7.534025789833698],
            [27.463952108598157, -7.526244994345065],
            [27.484532942948675, -7.521971229455403],
            [27.497848259875113, -7.519527476252431],
            [27.503321337371748, -7.513450372688028],
            [27.502154937857405, -7.504952752030175],
            [27.499837258373226, -7.484921638453909],
            [27.50665638227138, -7.483014578572083],
            [27.510737113298497, -7.481873391581464],
            [27.520408949670784, -7.4824690888764],
            [27.528862250106254, -7.484887509936911],
            [27.552979363658132, -7.498822018526289],
            [27.575322036825938, -7.50486645391563],
            [27.586166674107321, -7.512745533185075],
            [27.593987776178455, -7.520627712072825],
            [27.59758559985826, -7.526694171283221],
            [27.597545640099469, -7.534585712399049],
            [27.586128259450813, -7.560641851040879],
            [27.587034239160932, -7.56274016962979],
            [27.59216723964386, -7.57462788655701],
            [27.593788906242523, -7.576100971064168],
            [27.594938159613072, -7.577144923289508],
            [27.608318777772443, -7.581541315822119],
            [27.614992333272049, -7.583734077016451],
            [27.615465360049551, -7.586946932741918],
            [27.618242400240753, -7.590840985387543],
            [27.619102440107245, -7.591487995887777],
            [27.624016440307052, -7.595183903571371],
            [27.626152723884235, -7.611939854062599],
            [27.627800400303627, -7.615913975355699],
            [27.631620360285218, -7.617555874783511],
            [27.632391422921138, -7.617886836989487],
            [27.638696997039361, -7.625808001240529],
            [27.650436480311207, -7.640555022473496],
            [27.6526231575792, -7.642765501056608],
            [27.661300376573962, -7.651537414698801],
            [27.665563320076664, -7.664487900808911],
            [27.666660240293673, -7.667820966616711],
            [27.669280770606207, -7.669722007125347],
            [27.673588091782253, -7.672847147977168],
            [27.641500559989332, -7.691118651308223],
            [27.631764360225244, -7.70326606609772],
            [27.626767200284668, -7.734823691801255],
            [27.630260280402339, -7.761515488589545],
            [27.630137520228857, -7.78578300206594],
            [27.633715219849684, -7.793489368479808],
            [27.639708120061922, -7.806397753061103],
            [27.680590799883465, -7.853058031243759],
            [27.692015400292028, -7.865782300948061],
            [27.704063160216574, -7.874866155396569],
            [27.706572185347859, -7.875321211141507],
            [27.72399924045002, -7.878481897534445],
            [27.734282279761853, -7.877863179945075],
            [27.747609839827263, -7.872995168882865],
            [27.774265320182558, -7.863258972061988],
            [27.782789399777599, -7.851724295498573],
            [27.789483600359095, -7.843224242792077],
            [27.801161280437697, -7.847092875072483],
            [27.802669806022969, -7.847501558055073],
            [27.807846479900046, -7.848903996344169],
            [27.808903244525567, -7.853252016886981],
            [27.809017183242954, -7.853720808278264],
            [27.806036399755399, -7.856715917524743],
            [27.806886019164594, -7.861069921284632],
            [27.806976349257994, -7.861532832041624],
            [27.806826821983996, -7.86198608064501],
            [27.806066280416683, -7.864290976775592],
            [27.809301202688026, -7.866803915812807],
            [27.808884692518312, -7.868454603145327],
            [27.806808240332337, -7.876682866784713],
            [27.807979456613253, -7.881269886051478],
            [27.831597120341904, -7.88563313458838],
            [27.848079359767596, -7.888235938706948],
            [27.852752507266683, -7.904515852748014],
            [27.851391360185254, -7.909340872601515],
            [27.854200408248371, -7.920347961326929],
            [27.847570320428684, -7.932078940499994],
            [27.846851994289835, -7.934330299174779],
            [27.845297095872969, -7.939203173632096],
            [27.841167359950528, -7.943120875298201],
            [27.841451400056833, -7.955972975617722],
            [27.836656200256705, -7.966089954859365],
            [27.834817860011533, -7.96712946201887],
            [27.832979519766333, -7.968168967399722],
            [27.827984520273979, -7.985631964635036],
            [27.824087519875345, -7.990006965161045],
            [27.814390200095062, -8.007449030069868],
            [27.807628320440042, -8.015379960214963],
            [27.796947480170946, -8.035319998214757],
            [27.788179320228387, -8.046730965694406],
            [27.781733159768216, -8.060332196456118],
            [27.77507244029567, -8.062158780201631],
            [27.76656383957128, -8.070656197205858],
            [27.744909479828699, -8.085864881517333],
            [27.739557359586737, -8.095375901755546],
            [27.737472240454903, -8.107121986378765],
            [27.733139687399149, -8.113495848249094],
            [27.730518479756903, -8.117352003033949],
            [27.725250239704582, -8.119054869162573],
            [27.72006432934975, -8.125117965874695],
            [27.708793199819237, -8.134980816734865],
            [27.708731640069445, -8.147103559604473],
            [27.716030280174699, -8.15618587429188],
            [27.717646753612712, -8.154133673201047],
            [27.725937479643012, -8.143607973738778],
            [27.740692440237044, -8.131628020289893],
            [27.745277400124678, -8.130396894025999],
            [27.749668320317671, -8.131004875199139],
            [27.762026399663874, -8.138812931917126],
            [27.76825548043902, -8.139156876089867],
            [27.768467179215502, -8.138965376110635],
            [27.771881399827642, -8.135876900355395],
            [27.80071199972647, -8.133660145410149],
            [27.81524303996455, -8.130006200542473],
            [27.831600359666801, -8.123925257257895],
            [27.847340640075171, -8.120269795649607],
            [27.853375320032946, -8.122687327872459],
            [27.837542879662958, -8.144527228774463],
            [27.822224159752849, -8.151435403290964],
            [27.807328440340321, -8.151509613434309],
            [27.789077519629849, -8.154455874465098],
            [27.763147080320142, -8.160295707197374],
            [27.73626515983457, -8.169471367673275],
            [27.698873399682441, -8.199637087330297],
            [27.696444480019995, -8.190607859814392],
            [27.696893040282418, -8.179660706241942],
            [27.702582479710198, -8.153458329604316],
            [27.699207839767766, -8.149667743021423],
            [27.693447480144936, -8.151600056412207],
            [27.681931800448023, -8.157368220599762],
            [27.674697960315786, -8.148361927820403],
            [27.68139179977452, -8.136906601135109],
            [27.681852599582662, -8.130241151447393],
            [27.673166160279823, -8.117433890443628],
            [27.65823407975958, -8.105133256909568],
            [27.650054520245657, -8.101366114716907],
            [27.644271840182981, -8.095683308665997],
            [27.642792599675957, -8.082839070273018],
            [27.641333159834453, -8.076658379635127],
            [27.635084999740986, -8.076213393547391],
            [27.618279840225185, -8.080580982548705],
            [27.607226759661899, -8.080159909103275],
            [27.590911920391122, -8.087857097713096],
            [27.571200119839702, -8.084147242720206],
            [27.559661039927963, -8.081824574125848],
            [27.533286000129639, -8.100043190931544],
            [27.514086840263126, -8.10727827248161],
            [27.505915559622888, -8.106366958379404],
            [27.501569999860127, -8.099249077170434],
            [27.484066439736797, -8.109352983913878],
            [27.475136280310839, -8.125577964704023],
            [27.471555234465594, -8.128912868849643],
            [27.465841439913838, -8.1342338695179],
            [27.455518439944889, -8.136937999234537],
            [27.449451360449771, -8.139915944025674],
            [27.440578951018484, -8.144269964545],
            [27.431759519731088, -8.148597938380625],
            [27.427038285414838, -8.149253502837553],
            [27.422332200287538, -8.149906963580261],
            [27.404959589379793, -8.162374838943087],
            [27.389559240458141, -8.173426943151124],
            [27.381100075820488, -8.176966351517029],
            [27.37811843983172, -8.178213893658929],
            [27.366037199696525, -8.185994973231068],
            [27.341612280209166, -8.186178876600399],
            [27.33863425724449, -8.184331243993759],
            [27.337650437616674, -8.183720791446239],
            [27.337162320040733, -8.18265099421032],
            [27.335256480385095, -8.178480924017171],
            [27.331976196785188, -8.175321715954917],
            [27.331527733540817, -8.175123359481535],
            [27.325474199741862, -8.172445857295232],
            [27.317426462606043, -8.17349989159354],
            [27.316377602256718, -8.172629383015131],
            [27.310648319851136, -8.16787396433306],
            [27.308374320947657, -8.167410862291963],
            [27.306484200012829, -8.167025937491195],
            [27.298456199762104, -8.169226986361487],
            [27.295353839182312, -8.172689828460843],
            [27.290313359783774, -8.178315925894179],
            [27.287475068863213, -8.18022875868273],
            [27.285072479720053, -8.181847949149194],
            [27.282320229437417, -8.182581928362872],
            [27.281375280810277, -8.181941166062069],
            [27.278356319821441, -8.179894021872853],
            [27.26517131969667, -8.190673857008756],
            [27.265938480050998, -8.195022880130022],
            [27.264506231314808, -8.197052329966082],
            [27.264135239678883, -8.197578010909165],
            [27.25766179468857, -8.200880585499474],
            [27.25111043971199, -8.20422287978173],
            [27.234075625893791, -8.206236200014041],
            [27.226268381234252, -8.207158923658252],
            [27.219380759897348, -8.219627968461076],
            [27.215079840116019, -8.227738360572127],
            [27.194969519955123, -8.25210437349636],
            [27.174089023795506, -8.271383173953968],
            [27.164179440198438, -8.285549962715852],
            [27.166251960458418, -8.290784029903577],
            [27.163738524599115, -8.294844514620706],
            [27.156208679699265, -8.307008815313226],
            [27.121266719650063, -8.35332486573798],
            [27.056165399581513, -8.438307335546707],
            [27.034613640020751, -8.462667174609253],
            [27.015464519908821, -8.487013689450482],
            [27.005460120031845, -8.516543106014884],
            [27.006469200285437, -8.532941163047324],
            [27.00846615606034, -8.534730528375897],
            [27.012009600224413, -8.537905599342047],
            [27.020906639664151, -8.540476274061236],
            [27.033888599873496, -8.543264344100047],
            [27.050238360252642, -8.547462004711909],
            [27.061762679945971, -8.544789977346129],
            [27.071843760015621, -8.541411870425424],
            [27.081715679947784, -8.548731896259175],
            [27.085578479686955, -8.555130832310342],
            [27.085113720105038, -8.560600350792416],
            [27.078876360456213, -8.563721324412603],
            [27.071679239859535, -8.567322689475933],
            [27.068071320014251, -8.572772963031191],
            [27.059597280173826, -8.57681188052468],
            [27.052528320422084, -8.582205886669403],
            [27.038883240039709, -8.609064995258267],
            [27.032245200333154, -8.612614966850753],
            [27.006349320110747, -8.638746946797582],
            [26.9762994000459, -8.66540192092844],
            [26.967828240204238, -8.669895893566075],
            [26.95831847967213, -8.681758892802588],
            [26.957002320220145, -8.686142932379967],
            [26.958101399987104, -8.697151971685816],
            [26.956114199916183, -8.702925969582457],
            [26.941995359731045, -8.715548861949831],
            [26.923149359942066, -8.721122006261266],
            [26.906561280111291, -8.738373853055981],
            [26.89464924035482, -8.744528898654472],
            [26.886253319808119, -8.754073940975983],
            [26.875004400224711, -8.758380002083271],
            [26.863405199664228, -8.770041931217937],
            [26.856069479799014, -8.773598906266493],
            [26.849722319971328, -8.781274996168491],
            [26.842560479809119, -8.781153892398207],
            [26.834152319716665, -8.775076932794715],
            [26.831705399612577, -8.76615400972948],
            [26.827535519776678, -8.765298946246668],
            [26.826107399697545, -8.762564012667527],
            [26.824403520182383, -8.741684984131041],
            [26.826357240042686, -8.733615854519027],
            [26.830444320362218, -8.728959856146338],
            [26.828291520360231, -8.724168960598844],
            [26.835914519656686, -8.709352897386315],
            [26.835260399704445, -8.696728902095387],
            [26.830789199769445, -8.691282935531776],
            [26.830713240025645, -8.686232002862594],
            [26.82304020007631, -8.682670976928533],
            [26.818012439923841, -8.671031937020746],
            [26.810861400206306, -8.6713689913508],
            [26.796865320194648, -8.66192994910991],
            [26.79228827985456, -8.664524890212316],
            [26.786035440436748, -8.66323989249698],
            [26.777904479779732, -8.659913984569513],
            [26.776451520384693, -8.655341859551527],
            [26.773199280391307, -8.654011934723462],
            [26.760442320312897, -8.665455900590763],
            [26.753116320219039, -8.66946887397577],
            [26.757536399726185, -8.671700877766961],
            [26.760570480259531, -8.673952999413304],
            [26.764595280380394, -8.680553940432265],
            [26.770397399985864, -8.682535945531459],
            [26.760364200120843, -8.690953025977329],
            [26.757360359574889, -8.690767941161903],
            [26.755253280227606, -8.688732003869749],
            [26.75115936013551, -8.677536911162262],
            [26.732135159746981, -8.671385024267378],
            [26.730646200366927, -8.679905858155395],
            [26.727474240115548, -8.68385686072396],
            [26.71921115973813, -8.687193955021861],
            [26.716024440166606, -8.690226937711179],
            [26.714250360006972, -8.695075988913427],
            [26.718672239737934, -8.712927916099162],
            [26.722471320177355, -8.719993954223352],
            [26.720964360355627, -8.727365866362224],
            [26.721563400106202, -8.73654586087798],
            [26.714960279711384, -8.742843961354939],
            [26.715446279958201, -8.744445898979007],
            [26.719867440138621, -8.746676916052179],
            [26.718778440367455, -8.751058937468722],
            [26.719726320197356, -8.752653002441619],
            [26.717886360289722, -8.753138879486109],
            [26.711099280196059, -8.762655913717451],
            [26.715467160398632, -8.776834919306916],
            [26.71355448007213, -8.78788986381776],
            [26.713617479821306, -8.791755471824059],
            [26.726320080146923, -8.80700005644152],
            [26.728893359973867, -8.809717918862235],
            [26.730589319941448, -8.814976928793891],
            [26.729290080257819, -8.820749964466055],
            [26.729330400241043, -8.823495859765469],
            [26.732471400056156, -8.832868964604847],
            [26.731850039865698, -8.83723998188856],
            [26.720865359723106, -8.844524953533154],
            [26.706770279977263, -8.859892859482756],
            [26.69162147999636, -8.866546006153676],
            [26.680088520306651, -8.899105950839472],
            [26.677404359627577, -8.95198690061148],
            [26.673200280030514, -8.964684996853761],
            [26.677231200373438, -8.971519905323634],
            [26.678802239719317, -8.984132941017918],
            [26.677547279792652, -8.99311189929055],
            [26.674812359808488, -8.995679028816449],
            [26.673361199738931, -9.006957948305178],
            [26.670870360102285, -9.010440867078525],
            [26.660064239885347, -9.014502895999533],
            [26.653444199722131, -9.020112024758031],
            [26.646894360203422, -9.030544989778413],
            [26.641363319811372, -9.031772984099478],
            [26.632690199829263, -9.039479889248037],
            [26.629543440016526, -9.045499008125844],
            [26.624973240347334, -9.049241017964865],
            [26.622558360454455, -9.058006032780908],
            [26.616173400417971, -9.064071994883724],
            [26.610391439905804, -9.06392286961858],
            [26.607710520348292, -9.070395880783266],
            [26.602853399675634, -9.070233945777591],
            [26.597269440428537, -9.06778587032065],
            [26.588953440297704, -9.068362967663122],
            [26.587125359711383, -9.069767892460861],
            [26.585579519905846, -9.074843906139836],
            [26.581251240135888, -9.07927194543133],
            [26.572790519616163, -9.085824928360843],
            [26.567470439585442, -9.085669940719979],
            [26.561968200079733, -9.088964003879839],
            [26.553354480297429, -9.101033019151538],
            [26.547426360295283, -9.106859992848937],
            [26.548216200415595, -9.113512993673053],
            [26.544656520101078, -9.123443954402001],
            [26.540065439991388, -9.125805886258249],
            [26.536249439783571, -9.133900918747651],
            [26.52686135964997, -9.140465875217695],
            [26.525350440054467, -9.14806900124398],
            [26.512916400066203, -9.151917915933785],
            [26.501123159811087, -9.152081947894439],
            [26.497946520235395, -9.156261904024046],
            [26.495420400164274, -9.173989914220112],
            [26.493156359984052, -9.177468875304783],
            [26.482610520332454, -9.184049026567918],
            [26.482277160022107, -9.193244914121838],
            [26.478698400389273, -9.202025911957026],
            [26.473425480114308, -9.205315861168536],
            [26.469171359864333, -9.215485956526614],
            [26.464573439982111, -9.217385856982675],
            [26.466263279727666, -9.222419893964188],
            [26.470728360338974, -9.22741401552733],
            [26.475832440459644, -9.228492979026475],
            [26.477714519676024, -9.230764911658856],
            [26.469459359744445, -9.235933933721606],
            [26.477146440361679, -9.239735991124697],
            [26.482710239617216, -9.240578002532121],
            [26.485082279752483, -9.244682018886197],
            [26.488331280420933, -9.245326946481931],
            [26.493288479704457, -9.252381944269393],
            [26.494066439605124, -9.258346904357719],
            [26.498018159980983, -9.259670855535472],
            [26.499464279603462, -9.26378798609819],
            [26.502243480242949, -9.263979888371928],
            [26.501297399738529, -9.278930899220109],
            [26.496286200028354, -9.284513931241758],
            [26.498748239677024, -9.29505303052947],
            [26.490343319807799, -9.322515918423548],
            [26.483951159774278, -9.328809877744268],
            [26.485166520166562, -9.332929918579353],
            [26.478407519612038, -9.345892876824571],
            [26.47736352004674, -9.353952026577982],
            [26.474384160388883, -9.356059909427925],
            [26.473114440243808, -9.364580924261222],
            [26.468300520451503, -9.367864882374928],
            [26.465133240422769, -9.373194891412863],
            [26.465545439577415, -9.386058900374318],
            [26.473316400384327, -9.395375999449966],
            [26.477375400266354, -9.404283951672648],
            [26.482315320455374, -9.426279939347786],
            [26.475969240402666, -9.436020972479414],
            [26.479969200309327, -9.440561904795674],
            [26.477256239642241, -9.445195922647901],
            [26.469492479730665, -9.452887977534093],
            [26.462326319570249, -9.453674896102195],
            [26.458523280255353, -9.463149943088652],
            [26.451936360078353, -9.47243400578393],
            [26.447261956734486, -9.485828108305215],
            [26.436961978789654, -9.494472672699114],
            [26.431894251691926, -9.496380894959266],
            [26.430360332530206, -9.49778081805885],
            [26.427548871592251, -9.500346844732743],
            [26.423038073021196, -9.508910989914449],
            [26.410349155833966, -9.518848873059873],
            [26.406312837514516, -9.522008894318333],
            [26.400642118977281, -9.530589905965867],
            [26.395601040402411, -9.534564980740102],
            [26.38517508362046, -9.551023865901728],
            [26.370298086895104, -9.564093833298244],
            [26.366609168655604, -9.565292923189634],
            [26.336179096833863, -9.593049911390104],
            [26.327950023978126, -9.606543554817735],
            [26.325429859737326, -9.610675892508118],
            [26.324658992934143, -9.611939432012996],
            [26.32303586028495, -9.61459991588524],
            [26.321476085812737, -9.619217086842776],
            [26.325849674808964, -9.624024653059051],
            [26.328296179891392, -9.62671388668916],
            [26.332635845807562, -9.641216013332501],
            [26.326125000358694, -9.643191007610566],
            [26.320283999871123, -9.646142003202943],
            [26.314796879909959, -9.648115003582259],
            [26.308268999708364, -9.651394074251385],
            [26.301048840019593, -9.655327921765259],
            [26.297246879581376, -9.658927038704707],
            [26.290369080423773, -9.66286097444862],
            [26.280038880457855, -9.669739076829206],
            [26.268699126826174, -9.674616920791296],
            [26.260341119676035, -9.673346031166975],
            [26.256913048838843, -9.675251545530287],
            [26.251185960119177, -9.67843495833924],
            [26.249758919815022, -9.679228986009848],
            [26.247214720250486, -9.681647551825952],
            [26.24289587997756, -9.685753085849923],
            [26.233631452942827, -9.698897001726415],
            [26.23243112136522, -9.700599934372867],
            [26.226455253210784, -9.704354848504673],
            [26.220108960257363, -9.710678944318113],
            [26.212578120024229, -9.712330074614307],
            [26.205090839997521, -9.710719085852535],
            [26.201742120044305, -9.705834030301039],
            [26.196665039687829, -9.702584982568588],
            [26.19225792017528, -9.700313010660404],
            [26.188503839941685, -9.700322958123353],
            [26.183703959918951, -9.701967034962895],
            [26.179572960066892, -9.70458802138061],
            [26.176129919703804, -9.706880922611496],
            [26.172695160010992, -9.70852105962185],
            [26.164823039919938, -9.710173976945541],
            [26.159703119805883, -9.710186942752797],
            [26.154596159686417, -9.709221943243787],
            [26.148486959984258, -9.706627992276996],
            [26.145747000451308, -9.707288026747698],
            [26.141289119837037, -9.708931003924032],
            [26.138510999870821, -9.712527052299526],
            [26.134619922064818, -9.71621033763371],
            [26.134017120169833, -9.716780945239043],
            [26.128859039622512, -9.719730042632454],
            [26.123042880247475, -9.720725028456382],
            [26.122792071518461, -9.720656936071151],
            [26.115900839852461, -9.718786028928534],
            [26.111174039574692, -9.714884018053013],
            [26.108146080161667, -9.711630086148825],
            [26.10405396029342, -9.711313927742568],
            [26.098575839654746, -9.71263397754451],
            [26.088319079658238, -9.71396592181749],
            [26.083176840002633, -9.715610996723983],
            [26.07325703986584, -9.717269029858942],
            [26.06299595987112, -9.71892705377949],
            [26.053071120185578, -9.720910988400144],
            [26.04622788011531, -9.7222340192708],
            [26.038727787417695, -9.722540608107105],
            [26.037690120076803, -9.722583026132344],
            [26.032609079946557, -9.719660063334167],
            [26.031326039582421, -9.71346504488608],
            [26.031084119683157, -9.705961916456085],
            [26.032197959668562, -9.699108012487397],
            [26.033627879971512, -9.694211061487989],
            [26.034694920425562, -9.690945913376074],
            [26.03475611995092, -9.686377991850298],
            [26.035494120092803, -9.682135075933875],
            [26.035534802097086, -9.679043098011327],
            [26.035549919845007, -9.677894059508638],
            [26.033519880016502, -9.676593944021297],
            [26.032156405400162, -9.677520037538967],
            [26.02869803977832, -9.67986900335322],
            [26.02286099996282, -9.682494959962709],
            [26.014997159643745, -9.683493966194858],
            [26.007816959713761, -9.684492080777561],
            [25.998225120114128, -9.687127947730053],
            [25.99170983968272, -9.689428963977994],
            [25.982454959942803, -9.692390028429825],
            [25.972850879899152, -9.696004018969028],
            [25.959146039990802, -9.699954922295404],
            [25.944451919596052, -9.701298996097769],
            [25.934893920431477, -9.701324929299023],
            [25.926365880164369, -9.701021016865742],
            [25.914786120044969, -9.699095045354548],
            [25.90766999963914, -9.695199018797606],
            [25.902257040096259, -9.691623919968789],
            [25.894457999750177, -9.687729936610312],
            [25.888016160186506, -9.684484975234593],
            [25.879884119754518, -9.679938991067205],
            [25.876536120250176, -9.675055079579561],
            [25.865704080044019, -9.668231977948938],
            [25.857901079924201, -9.66466404997723],
            [25.850111039798968, -9.660117971662281],
            [25.845024960119972, -9.657520972045358],
            [25.841314079868397, -9.654268963888384],
            [25.836582959592459, -9.650693069277777],
            [25.833570840172818, -9.646132942856831],
            [25.828873919658076, -9.639947032020226],
            [25.824527999670881, -9.633107931321657],
            [25.817757119795075, -9.628884944124822],
            [25.810977960147255, -9.625313928724793],
            [25.804518839692459, -9.623374015950528],
            [25.796347920174991, -9.621764017442304],
            [25.789898160165446, -9.619172048004057],
            [25.7848171200352, -9.616249063315928],
            [25.773959159839826, -9.611383938090874],
            [25.765818839635855, -9.60749097043106],
            [25.760034000023222, -9.606201062490181],
            [25.752238920349242, -9.601980932780309],
            [25.743075119897671, -9.598089987277875],
            [25.736308920244479, -9.593541046723463],
            [25.727520959636429, -9.587040016409972],
            [25.72312607966963, -9.583788920751642],
            [25.717389120261654, -9.578911063042941],
            [25.709632919673155, -9.571754066402798],
            [25.700141159582721, -9.566884918659095],
            [25.694429040388954, -9.560050010436186],
            [25.683959880031733, -9.551595030201122],
            [25.676229959656883, -9.5424810766844],
            [25.67187900012097, -9.535968039389367],
            [25.662429000013137, -9.527836961839554],
            [25.654695119864517, -9.519049013843452],
            [25.652050919842562, -9.512531080852336],
            [25.65039600030704, -9.508620971206946],
            [25.64745299996034, -9.498840966877657],
            [25.645142160248728, -9.492974926181033],
            [25.64074799983247, -9.489723988478273],
            [25.636988880050161, -9.490060085538719],
            [25.633212839601129, -9.491701997043885],
            [25.626363840431566, -9.493351010180715],
            [25.619149079617657, -9.496958975098947],
            [25.611571079628703, -9.502198987893321],
            [25.606724039850175, -9.507431987590472],
            [25.600164839886208, -9.512994937815911],
            [25.590183119775187, -9.5170750757548],
            [25.578597959882639, -9.51650707929255],
            [25.568108999758223, -9.51018103978506],
            [25.559087039696756, -9.510964980466591],
            [25.556942214937862, -9.51050467176638],
            [25.553980079577286, -9.509868955125539],
            [25.552603197605336, -9.509000358784782],
            [25.549318080170877, -9.506927956960693],
            [25.543406730816777, -9.506052291878287],
            [25.537721040058685, -9.505210051498775],
            [25.537256669447277, -9.505446583601826],
            [25.530351120432268, -9.508963980394114],
            [25.516673999838623, -9.507495080433237],
            [25.51039991975594, -9.505491038416663],
            [25.51004839461222, -9.504046253494318],
            [25.509674879608685, -9.502511078748091],
            [25.511609820187964, -9.488470944825867],
            [25.502923950416982, -9.487357601087369],
            [25.501640195892225, -9.487193049936097],
            [25.498026022874249, -9.495734084317061],
            [25.4987018030046, -9.496837623548668],
            [25.502501879675705, -9.503043019371427],
            [25.502559120325586, -9.508558945145033],
            [25.497982079985498, -9.535725997418471],
            [25.495273079990518, -9.542419944978102],
            [25.49253629690044, -9.545038662275097],
            [25.491146039912199, -9.546368935688966],
            [25.490555865635177, -9.549140493529571],
            [25.490262971733415, -9.550516051137095],
            [25.490672978998774, -9.551663981944786],
            [25.493125971714171, -9.558531739770999],
            [25.492930962737365, -9.559499605556907],
            [25.492244039904215, -9.562907027670441],
            [25.494303215690646, -9.573923765246208],
            [25.496660880086431, -9.586536993090688],
            [25.502465926403072, -9.587857063819738],
            [25.506456119825923, -9.592874033850482],
            [25.506717119941836, -9.595859056434223],
            [25.504540919725024, -9.600670926164982],
            [25.504216919859935, -9.601388916621922],
            [25.504000919949853, -9.601862956142213],
            [25.510124154031736, -9.614305415054677],
            [25.510866120235598, -9.615813064752984],
            [25.51531608040403, -9.620365077282738],
            [25.516342080425989, -9.62978000154652],
            [25.516956908067687, -9.63049086192952],
            [25.521266886460342, -9.635474610198425],
            [25.521311880377965, -9.639842037362355],
            [25.519254120336427, -9.6423919196575],
            [25.512994194109378, -9.641995934873375],
            [25.511955886269689, -9.641275860276355],
            [25.508094840041952, -9.638597912953525],
            [25.500190938454452, -9.62967264220844],
            [25.499420071651269, -9.628802147837749],
            [25.493151959975336, -9.627486922623667],
            [25.491746002232595, -9.6277347382998],
            [25.490377080232385, -9.627976026492352],
            [25.486259252377302, -9.633074802353216],
            [25.486521839816319, -9.636057950104675],
            [25.489347290218205, -9.640397995564266],
            [25.496562960127186, -9.643542939557731],
            [25.49752272646495, -9.643832932493339],
            [25.500978000085581, -9.644876938843437],
            [25.508949119910852, -9.653761067923643],
            [25.518220920317464, -9.654127022796619],
            [25.521954839661131, -9.65684698098476],
            [25.524327959571377, -9.66210794285089],
            [25.524157830334648, -9.667108320008149],
            [25.523975880167111, -9.672456064683425],
            [25.524527497853846, -9.674617083906336],
            [25.525906920261427, -9.680021057995967],
            [25.523009999895535, -9.690856033383975],
            [25.523970839720064, -9.694062920757961],
            [25.52724611970384, -9.697018970435943],
            [25.531885080018156, -9.697431060037806],
            [25.534940402114739, -9.694762066701749],
            [25.538543235698885, -9.69161507833946],
            [25.541127946587757, -9.691937642572942],
            [25.543647023867067, -9.692252058304739],
            [25.545307364735336, -9.695458343020595],
            [25.546015079974072, -9.696825004059493],
            [25.5448595006673, -9.699614813168466],
            [25.543528919661707, -9.702827081801031],
            [25.544730959834961, -9.706951970553664],
            [25.542665121244092, -9.708812884310614],
            [25.537496185454845, -9.708710908707978],
            [25.535017079612452, -9.708661911495884],
            [25.534359230753463, -9.708283687283185],
            [25.527660119980631, -9.704432069847869],
            [25.521774120185519, -9.705350014312272],
            [25.520510520262473, -9.706396997280406],
            [25.519246918542798, -9.70744406516738],
            [25.519089960404777, -9.714571947273802],
            [25.52080103991694, -9.723059912161826],
            [25.525274040075761, -9.72968100911784],
            [25.536948840155606, -9.73783593457455],
            [25.538837039594007, -9.741035084235808],
            [25.545066409626688, -9.741873572006368],
            [25.548352879923971, -9.742316091208552],
            [25.54722900036694, -9.746438918031084],
            [25.546344120286211, -9.749691973646199],
            [25.540601039757881, -9.754347993627182],
            [25.538696483794759, -9.759451852037644],
            [25.537672145656067, -9.76219685532368],
            [25.538178959867999, -9.766327926023479],
            [25.538973840435361, -9.767866010432995],
            [25.544568960351594, -9.778676081071037],
            [25.54211987979922, -9.788126986710472],
            [25.541587050376648, -9.794059016046059],
            [25.537288947712049, -9.798114940996783],
            [25.533972987520652, -9.798152941471765],
            [25.524555028522357, -9.8002660234323],
            [25.519989868401883, -9.803073916272488],
            [25.515179908383349, -9.806885032340032],
            [25.509345029016131, -9.81020798170173],
            [25.49972187055246, -9.817579999469928],
            [25.493641830164417, -9.821906930528604],
            [25.488306990813552, -9.824222984025949],
            [25.479123774175417, -9.824330045764755],
            [25.472209922032235, -9.821656927235715],
            [25.464550982039576, -9.820996061284703],
            [25.459692004549257, -9.819800907448913],
            [25.454837821367573, -9.819107018323894],
            [25.450729804013726, -9.816400994180544],
            [25.445621793763689, -9.815709937318159],
            [25.439496754068141, -9.815530953766924],
            [25.430825074983712, -9.815633049484136],
            [25.4239497947022, -9.816964932775347],
            [25.41709575598389, -9.820550032742995],
            [25.406657916287333, -9.822675044906395],
            [25.396254997699177, -9.828554975734122],
            [25.389394836962182, -9.831389081313217],
            [25.362467918965699, -9.843220075159021],
            [25.348756959733656, -9.849888991068422],
            [25.334533001388934, -9.856314009158702],
            [25.321557881850481, -9.859970935030667],
            [25.311135883045679, -9.863847962510112],
            [25.303771002968013, -9.867188972868165],
            [25.293098803593629, -9.871569036645568],
            [25.286502884094109, -9.875402076505351],
            [25.27709896486542, -9.879016003351502],
            [25.266665085840966, -9.881641964653211],
            [25.251185806446845, -9.890084947614815],
            [25.240630896505852, -9.893606077183467],
            [25.225009848586868, -9.900404934313167],
            [25.215097967997586, -9.904275976158505],
            [25.203138048934786, -9.907420065523544],
            [25.192732969898348, -9.913049066325941],
            [25.185872810059713, -9.915882966943959],
            [25.177467891088789, -9.917233077181637],
            [25.169343771102668, -9.921333962239018],
            [25.164283971637293, -9.925649039081602],
            [25.158243891906363, -9.934230918661289],
            [25.150931931582075, -9.943078984952596],
            [25.144466254323998, -9.951491598897501],
            [25.138865092339216, -9.961496028131577],
            [25.135607093246538, -9.967542047244091],
            [25.130566013773375, -9.973860020064617],
            [25.128328973357313, -9.979893915914039],
            [25.121702093421529, -9.980471939307751],
            [25.115582094173028, -9.980794047962076],
            [25.10691186946103, -9.98114596764982],
            [25.1030688542177, -9.979439057570213],
            [25.094369793585106, -9.976786911051331],
            [25.08542707301654, -9.975388964750996],
            [25.080104816367886, -9.978955980145981],
            [25.073770975860928, -9.983537022294575],
            [25.066662776799266, -9.987125071367698],
            [25.059827096950404, -9.992461995507064],
            [25.054516017140539, -9.99728099805186],
            [25.044623938115077, -10.003154031969705],
            [25.036508097900906, -10.008006057472169],
            [25.030912978883034, -10.009823907496575],
            [25.024565098606473, -10.012902018261498],
            [25.019225918596202, -10.014717001883144],
            [25.008765059570489, -10.014589056258723],
            [24.998809980795851, -10.013955024223032],
            [24.992687840862036, -10.014025999808254],
            [24.987850860418039, -10.015083971444092],
            [24.983272020752434, -10.016388947754857],
            [24.980811061777072, -10.02568102887582],
            [24.980879101973326, -10.032690058492042],
            [24.981418021973521, -10.03568792459285],
            [24.98297286110158, -10.038172964836336],
            [24.988598960318686, -10.039608974498],
            [24.998418359349419, -10.040118803323097],
            [24.999999780525055, -10.040472031652609],
            [25.0063238868876, -10.041889924262804],
            [25.016973079509217, -10.039272023320343],
            [25.040204938382907, -10.042754048994279],
            [25.041346857907449, -10.043007958931517],
            [25.061494002706798, -10.047489196688828],
            [25.062495417636057, -10.047711935516375],
            [25.072053735702539, -10.049838009373113],
            [25.062009776715378, -10.068318039613313],
            [25.059852928904739, -10.069409407480951],
            [25.05939876584992, -10.069639213876444],
            [25.058774816714795, -10.069954931547031],
            [25.058338116010784, -10.070555832917989],
            [25.056253116354895, -10.073425010784806],
            [25.053149368776282, -10.073891929191888],
            [25.051388040202081, -10.074156952174988],
            [25.038681119878252, -10.080474062202718],
            [25.029460851327936, -10.081068172670605],
            [25.026390000055031, -10.081266043665062],
            [25.020406268048607, -10.083714893899918],
            [25.010898119992426, -10.087606076888646],
            [24.999999839813864, -10.09311997155605],
            [24.996111120085477, -10.09508706771622],
            [24.991792246574889, -10.098790549044226],
            [24.980677919773868, -10.108321008157789],
            [24.976827000254342, -10.119390025082325],
            [24.96262103965633, -10.123027991249526],
            [24.950399039804342, -10.125424008773665],
            [24.94302804040295, -10.128264012175302],
            [24.930289079867883, -10.12991496293575],
            [24.924404880296589, -10.12823208279419],
            [24.916430160023683, -10.121314916646659],
            [24.912763919753509, -10.111595080180617],
            [24.90886800002815, -10.104380048413168],
            [24.903936000285004, -10.095676059027364],
            [24.902088119931491, -10.0891889358585],
            [24.901098119894513, -10.082529056848276],
            [24.888175920109475, -10.063318963463814],
            [24.870679920207579, -10.051732024164126],
            [24.86552795988225, -10.046025074031691],
            [24.863500487438817, -10.04455462156284],
            [24.855492959793413, -10.038746984313333],
            [24.845267341692878, -10.026929977852587],
            [24.842846030760878, -10.024131898488122],
            [24.842181379858598, -10.023977579902152],
            [24.83517601903236, -10.022351458315343],
            [24.835454999826979, -10.028096948958032],
            [24.83653813359933, -10.029124662073762],
            [24.840711000333545, -10.033083985299749],
            [24.84279030377224, -10.035055359819587],
            [24.843869999692, -10.036079008380154],
            [24.844190741367584, -10.038086799991447],
            [24.84607104012305, -10.049856924932859],
            [24.845428097907892, -10.056529902251356],
            [24.843605039802313, -10.060453007323311],
            [24.834351960286245, -10.064203070170073],
            [24.832609007649502, -10.065861063875873],
            [24.830209080214541, -10.068143994625522],
            [24.827703120135016, -10.07414098387372],
            [24.822924119654417, -10.080851956688015],
            [24.814523160457295, -10.082702923049021],
            [24.807859920312058, -10.079525954065289],
            [24.79837607976917, -10.074880997219518],
            [24.794009999790379, -10.071928031478789],
            [24.784021079682386, -10.067788972788822],
            [24.780426119831699, -10.06532705109171],
            [24.761004120282536, -10.061798961259965],
            [24.756395039731203, -10.060100992307106],
            [24.751801079622719, -10.059904049192138],
            [24.745399502550093, -10.052924727025509],
            [24.737432039766333, -10.042638009416539],
            [24.732255574298414, -10.039709720028338],
            [24.730209149199123, -10.038552064236008],
            [24.728070960295224, -10.032130057554911],
            [24.72269184028907, -10.026422933571434],
            [24.722347280682076, -10.023396713560146],
            [24.721697879580024, -10.017693037250734],
            [24.723953993026193, -10.009633011432326],
            [24.725309039648536, -10.004791972725197],
            [24.720801839728519, -10.000000056523039],
            [24.714785879762957, -9.993603980946636],
            [24.713045030980581, -9.993043383631672],
            [24.71199416109998, -9.992704975621976],
            [24.709511879713052, -10.000000056523039],
            [24.707683079576153, -10.005382017578668],
            [24.70356000016994, -10.012078996441611],
            [24.697329839619812, -10.016722915254979],
            [24.69667212011824, -10.021555926655971],
            [24.700712039783685, -10.034400954286406],
            [24.695484119714553, -10.048692966884506],
            [24.694683373148411, -10.049351933590621],
            [24.692946839872661, -10.050780991306318],
            [24.688187629277781, -10.052085959902572],
            [24.671414880079126, -10.056684979667878],
            [24.644738722302613, -10.058456539293413],
            [24.644280959698456, -10.058486939050619],
            [24.633628920315701, -10.061091031713232],
            [24.63295896037004, -10.061339073471538],
            [24.624834119935048, -10.064371977775972],
            [24.607755000308739, -10.076906931512383],
            [24.602461920042185, -10.082920964503286],
            [24.594397381715584, -10.092958476696269],
            [24.592802040246326, -10.094944077252496],
            [24.59141702762274, -10.095391097826765],
            [24.582615119771592, -10.098231947896677],
            [24.576146999994272, -10.098008949758519],
            [24.571239839567035, -10.091808035311047],
            [24.567849000305113, -10.084086926914669],
            [24.564722040259568, -10.07736395786571],
            [24.561081000428068, -10.070147084220597],
            [24.558989039727035, -10.064914008147449],
            [24.554332079869376, -10.058209087334255],
            [24.55019495979526, -10.052499945380333],
            [24.54477983980409, -10.046555069954534],
            [24.542456040097889, -10.043578065627463],
            [24.536527920095775, -10.037387980400762],
            [24.532926119574189, -10.034175958920539],
            [24.524187119844079, -10.027519012301811],
            [24.516993959919468, -10.022345924552791],
            [24.508015920288884, -10.017194047163528],
            [24.50234304040503, -10.011000966191432],
            [24.498743040107293, -10.008039070090655],
            [24.490279080262667, -10.003382071293867],
            [24.485906880061854, -9.999677966244391],
            [24.477701040334317, -9.995268052137998],
            [24.474601080052967, -9.991298011287274],
            [24.472014119782592, -9.987573004217134],
            [24.470439840213484, -9.983086079280126],
            [24.466334039901774, -9.980630071486402],
            [24.463022282029229, -9.981544865360879],
            [24.461790839996741, -9.985690075786074],
            [24.4613199601928, -9.989701001967621],
            [24.458555160445613, -9.993989963881255],
            [24.455521079912266, -9.996778964654522],
            [24.454797120438254, -10.001042987605624],
            [24.452822159913083, -10.007825946086397],
            [24.449578920140553, -10.015373931913475],
            [24.445796039918953, -10.019923933076376],
            [24.441505919683962, -10.024730988716122],
            [24.436244160078104, -10.03455603710902],
            [24.430690079695665, -10.040629956156458],
            [24.427136160277037, -10.042424020796608],
            [24.423881040284854, -10.048719936299165],
            [24.420596039631388, -10.052013075048412],
            [24.416305920294732, -10.056820003179658],
            [24.414552000126658, -10.060094960640017],
            [24.413072040069125, -10.065369987841589],
            [24.412096079801749, -10.069886985465038],
            [24.411621959774578, -10.073647937139167],
            [24.411674880426254, -10.079154977760698],
            [24.412520879624878, -10.087405956725748],
            [24.413326919963012, -10.091652979453176],
            [24.413883119956008, -10.096403071013246],
            [24.414703919614254, -10.102150986207514],
            [24.414995880166437, -10.105903041008473],
            [24.414509879919621, -10.108412014204536],
            [24.412444919881079, -10.105933021419732],
            [24.410370959621687, -10.102452039076748],
            [24.409059120167903, -10.098713070898146],
            [24.408779039835341, -10.09621200419924],
            [24.406192079564967, -10.092486978641388],
            [24.4020769197063, -10.089031040758803],
            [24.399249120209937, -10.08681091803663],
            [24.396411960268317, -10.08358892728765],
            [24.391532159829712, -10.080141940960646],
            [24.389723879908878, -10.077910046954035],
            [24.388152120114128, -10.073672065451285],
            [24.388111079682066, -10.069416996031133],
            [24.388318080269592, -10.064407994578666],
            [24.388269120289987, -10.059401043955376],
            [24.388737839645675, -10.05513992849896],
            [24.384351052601293, -10.048023258928211],
            [24.383073124549473, -10.043691900409687],
            [24.382928880267674, -10.043202966213277],
            [24.379764293388142, -10.040623291981873],
            [24.374531879945994, -10.036357943325735],
            [24.371694000453839, -10.02786804576194],
            [24.373327841021233, -10.020575247399442],
            [24.373499014100286, -10.019811015842894],
            [24.364616039582941, -10.000000056523039],
            [24.362911080292836, -9.996194937737583],
            [24.362156879933099, -9.987002980370008],
            [24.359581112671162, -9.983340082820796],
            [24.35635511965377, -9.986807944210438],
            [24.3509540403305, -9.988221999544093],
            [24.340218057876008, -9.988522961273899],
            [24.33015796424802, -9.988804975060084],
            [24.325072920326541, -9.992055075731244],
            [24.322826440413476, -9.995167367423045],
            [24.319338119570194, -10.000000056523039],
            [24.306904079581894, -10.017222084156836],
            [24.296264233930774, -10.022571834655103],
            [24.294893040091207, -10.025797083513067],
            [24.297492943288191, -10.03359993238241],
            [24.291993917056232, -10.045127027877376],
            [24.288344999898015, -10.041043030540056],
            [24.282191160214428, -10.03786103262024],
            [24.279081840386119, -10.032890041163377],
            [24.279042960402307, -10.028884978123132],
            [24.274920959872777, -10.024677931765295],
            [24.270780959799868, -10.018717987928516],
            [24.266651039722756, -10.013758942189098],
            [24.265323000051119, -10.00826692251205],
            [24.264028080365698, -10.006279948241968],
            [24.25917204036632, -10.005334991013306],
            [24.251495039744885, -10.002921034501307],
            [24.244836119597856, -10.00024495163],
            [24.238945080253998, -9.997811080930878],
            [24.233303880356985, -9.994873020059156],
            [24.226908119875798, -9.992945057963986],
            [24.221814119750956, -9.993755002509575],
            [24.218251919662052, -9.99479901799682],
            [24.208121879612797, -10.002426990086025],
            [24.205848119661177, -10.004706970708963],
            [24.183868194289929, -10.002513080828392],
            [24.175787039825522, -10.009223938132688],
            [24.164217000375817, -10.014344002042288],
            [24.159734407108061, -10.014491104046641],
            [24.155867880258764, -10.01461798834182],
            [24.143542920000485, -10.009396069641697],
            [24.140189637503944, -10.00916747986091],
            [24.137277119689784, -10.008968935542098],
            [24.133350014949322, -10.01174893303306],
            [24.122247839659135, -10.012445083061037],
            [24.111775079752579, -10.011065027432883],
            [24.103586159793437, -10.008406935055985],
            [24.09502608021338, -10.002981015571406],
            [24.092884079757734, -10.000559054904731],
            [24.092390159963404, -10.000000056523039],
            [24.085923840409901, -9.992682943599275],
            [24.085034999657104, -9.956363059082378],
            [24.086858039796375, -9.950146087482119],
            [24.093549000154642, -9.943675006787107],
            [24.100665547260228, -9.939365403138449],
            [24.105800231185981, -9.9362557727879],
            [24.108314039846146, -9.92911508818629],
            [24.105259079770629, -9.921775064281734],
            [24.104522160302025, -9.914192043939915],
            [24.087318120053975, -9.906004064171222],
            [24.079857839791426, -9.904274029946754],
            [24.070835160179445, -9.902180083709823],
            [24.061392210049934, -9.898252197080403],
            [24.059910960011671, -9.897636052703914],
            [24.033480867859495, -9.89845599901335],
            [24.025798976809622, -9.892287710914228],
            [24.021826920372337, -9.88655902315084],
            [24.01993511958797, -9.879211999851096],
            [24.0233129997536, -9.85942608127006],
            [24.027884999646641, -9.846989007717108],
            [24.027624000429054, -9.841243989268065],
            [24.020664120407329, -9.840127926225835],
            [24.01299125473113, -9.835567783619556],
            [24.019391879589566, -9.817836049205374],
            [24.021180662475462, -9.815957005003895],
            [24.027017040232604, -9.80982604931801],
            [24.028373439717743, -9.808400652081007],
            [24.028845119920625, -9.807904977077602],
            [24.031682035520468, -9.8021480410191],
            [24.040086119956491, -9.78509308707967],
            [24.044762419643895, -9.779000385906334],
            [24.046993080224809, -9.776094041605221],
            [24.064288920210071, -9.759228069265665],
            [24.07000974318062, -9.749719016965345],
            [24.071641920068124, -9.747005989856445],
            [24.078736011986532, -9.739738875272172],
            [24.082013880016643, -9.736381006821444],
            [24.091257759885902, -9.731301730688239],
            [24.106506120149714, -9.722922974377781],
            [24.109725959707422, -9.718538080717963],
            [24.109903079633696, -9.717772920485578],
            [24.113576872938769, -9.701969019810996],
            [24.113542317444722, -9.701699965389878],
            [24.112366920404479, -9.692550959039856],
            [24.119450999700742, -9.674583986704956],
            [24.118715175278464, -9.667003924006353],
            [24.122373632545017, -9.661307114927855],
            [24.129972000036396, -9.649474921793896],
            [24.132022917610406, -9.643029108164168],
            [24.129613980073159, -9.626262832416465],
            [24.127842711640341, -9.623040740040736],
            [24.119786879785476, -9.608386085231084],
            [24.117887168436702, -9.599661048685077],
            [24.118977710615219, -9.59194076422237],
            [24.119355959740325, -9.589263010468084],
            [24.120493058905041, -9.581209690144462],
            [24.121232962577036, -9.575969338087955],
            [24.122811960098005, -9.56837808178663],
            [24.131032920268385, -9.546958027984134],
            [24.15140718162943, -9.504561063054039],
            [24.151586467393841, -9.502217052155812],
            [24.152919119914472, -9.484788069920814],
            [24.156603000401851, -9.481090038028562],
            [24.162730920096223, -9.458993965884304],
            [24.162666120123234, -9.458210082338383],
            [24.162234839853642, -9.453020938097968],
            [24.157775880362692, -9.442244052101305],
            [24.151712040192468, -9.434233024696582],
            [24.150204269192027, -9.428176677097001],
            [24.150054960208664, -9.427576934546956],
            [24.149184479223639, -9.426471271909971],
            [24.146091000287047, -9.422541983725356],
            [24.145605015311617, -9.418178893832131],
            [24.146360167885508, -9.415887150401302],
            [24.151749840401301, -9.399530085783987],
            [24.143363999850397, -9.389693072346063],
            [24.141948120215346, -9.384873043915313],
            [24.144666120431147, -9.37405897876258],
            [24.140437920170385, -9.362819983974415],
            [24.13854777498107, -9.36125610644863],
            [24.136022880211993, -9.359167035749349],
            [24.140630880090047, -9.35582307368437],
            [24.148001880389735, -9.352982982343029],
            [24.150000959782009, -9.348704043677431],
            [24.149683080138942, -9.342199029542401],
            [24.148118879667297, -9.338711940084163],
            [24.15115115997683, -9.335672020994908],
            [24.160503959675992, -9.326801051258673],
            [24.164292960119617, -9.323001017379037],
            [24.169101119914302, -9.318940073743793],
            [24.174654119623497, -9.312866083400571],
            [24.180473159895627, -9.307791036550539],
            [24.183257039859431, -9.305505916254987],
            [24.185791080376426, -9.303724045045762],
            [24.190902000269631, -9.30466495228568],
            [24.195260159802576, -9.306867031907792],
            [24.20065296025216, -9.310558946227612],
            [24.204000959756506, -9.313774957466794],
            [24.20784107972969, -9.315232066626699],
            [24.211463040242872, -9.320446950816772],
            [24.215297039994031, -9.321153086238002],
            [24.218069039738186, -9.317615992550218],
            [24.224921999579848, -9.314031027803535],
            [24.229002959677324, -9.313983014574108],
            [24.23330999968071, -9.310927940162786],
            [24.239108879961247, -9.303851017203499],
            [24.240354839667056, -9.300831952956964],
            [24.242865119744756, -9.296547031114061],
            [24.244878960253768, -9.293769049683139],
            [24.246618120203369, -9.288991958815803],
            [24.251425919773649, -9.284930970271498],
            [24.257261160263631, -9.281607984944939],
            [24.263381160410464, -9.281286088672697],
            [24.266660039943574, -9.277491955827669],
            [24.268429079656194, -9.275719010472219],
            [24.27276312032204, -9.275417916572799],
            [24.277352039983445, -9.275113976578741],
            [24.281422920085156, -9.274065036150962],
            [24.287545079781903, -9.273994074831593],
            [24.292644120353827, -9.273684086726],
            [24.294425040286061, -9.273161926940489],
            [24.30026496010036, -9.270340006819941],
            [24.307144919706182, -9.26950802863294],
            [24.314291999649981, -9.269925084844813],
            [24.323731919761983, -9.270065052095308],
            [24.329859119905812, -9.270494024776868],
            [24.334458120461345, -9.271192080760875],
            [24.345956159941057, -9.273060019833249],
            [24.352086959634228, -9.273988916798565],
            [24.362825039654908, -9.276367081358137],
            [24.372037079637245, -9.279264002402003],
            [24.378167880228744, -9.28019306120005],
            [24.386379119729437, -9.285104010521261],
            [24.388962120226033, -9.288328082957491],
            [24.393308040213199, -9.289278991686228],
            [24.396870959852645, -9.288486004999362],
            [24.398173080433395, -9.291225081434277],
            [24.400746000035866, -9.293448053503115],
            [24.400757880255515, -9.294698958290104],
            [24.402308040059225, -9.296683964365968],
            [24.405140880002666, -9.299405015058726],
            [24.409496160435086, -9.301356026941042],
            [24.411045960014391, -9.303340994761243],
            [24.418190880408236, -9.303507979452863],
            [24.424058160211132, -9.303438980134578],
            [24.430434120026796, -9.303363935351703],
            [24.434001000338345, -9.302822080500572],
            [24.437554919756941, -9.301027925099707],
            [24.441380999960558, -9.300982933253593],
            [24.445464840056822, -9.301186018910435],
            [24.447250079987267, -9.301165034147639],
            [24.450311160284809, -9.301128934320559],
            [24.454363136239667, -9.3003342008824],
            [24.454384920385312, -9.300329928428845],
            [24.461012159647204, -9.299751968845912],
            [24.46662600045395, -9.299936916017694],
            [24.472238040138521, -9.299870940080289],
            [24.476319000236025, -9.299822924880877],
            [24.481420919908409, -9.299764061658452],
            [24.496215119812362, -9.299591028747283],
            [24.503613119876242, -9.299504067880129],
            [24.513307919882138, -9.299641000852247],
            [24.520454999825901, -9.300058020739844],
            [24.527345040325887, -9.300228030218074],
            [24.531937919761063, -9.300424002703553],
            [24.536787119987842, -9.300618019102394],
            [24.541113959758388, -9.299565954351708],
            [24.545432879981352, -9.297763068414257],
            [24.548736959953139, -9.296473051174315],
            [24.552546120388389, -9.294676017124207],
            [24.557648040060773, -9.294616086678475],
            [24.565298040019755, -9.294276063007469],
            [24.570137160250738, -9.293467971492388],
            [24.573428999778471, -9.290925957950387],
            [24.574893840291459, -9.284150066974867],
            [24.5748599998564, -9.280646028931667],
            [24.575339160330618, -9.277385070489016],
            [24.573519000190139, -9.273901949494336],
            [24.569637120234351, -9.268188916171136],
            [24.564259080003172, -9.265999040361827],
            [24.558860879780401, -9.261805992505913],
            [24.556530959852175, -9.258328940562665],
            [24.554217959692309, -9.256603918389681],
            [24.543986039910042, -9.253719080880852],
            [24.540405119828918, -9.252760071080226],
            [24.534035999785822, -9.253584975757049],
            [24.529196880453167, -9.254392982729907],
            [24.52433292000795, -9.252696931278086],
            [24.519481920455654, -9.252252996985471],
            [24.51408912000603, -9.24856099443662],
            [24.510504959701716, -9.247352076715307],
            [24.505653960149417, -9.246907957990238],
            [24.503091119644413, -9.245686050027581],
            [24.500268000370692, -9.243965945030377],
            [24.496683119617504, -9.24250604586909],
            [24.491595890094921, -9.238028940523517],
            [24.488957880363596, -9.235086042033339],
            [24.488912159708892, -9.230330020781203],
            [24.488607959610963, -9.225327047991167],
            [24.489152985460162, -9.218972141804361],
            [24.487266369751605, -9.217505944468492],
            [24.482409840170408, -9.213732083560179],
            [24.475586983772246, -9.205811536819949],
            [24.473550960265609, -9.203447914286158],
            [24.470564046674561, -9.202480815804309],
            [24.466596119792634, -9.201196082131816],
            [24.454806840209649, -9.201962051568302],
            [24.450802919630917, -9.191187983636292],
            [24.445198079943317, -9.182951068910384],
            [24.443811000296282, -9.18318891188631],
            [24.440198681401046, -9.180465270623902],
            [24.434746111544015, -9.176353905534103],
            [24.431664960188058, -9.174848983901397],
            [24.425000999593987, -9.171590058791947],
            [24.413648039829308, -9.168214932950223],
            [24.394613039894445, -9.157304972461443],
            [24.386924159951658, -9.148391020542684],
            [24.380885880444545, -9.144292989842613],
            [24.372551619360618, -9.14250590496887],
            [24.35956415966514, -9.136610964387851],
            [24.350271120390286, -9.129774073086159],
            [24.34425299997644, -9.128891941023369],
            [24.336601021028919, -9.125261171695431],
            [24.323577839826164, -9.11316105048348],
            [24.31579391992296, -9.088162911757975],
            [24.308118931527719, -9.08131340958006],
            [24.305564880139485, -9.079034031311776],
            [24.294594450870544, -9.072728593489767],
            [24.285381120009177, -9.067432991358354],
            [24.28521533412685, -9.06728037619021],
            [24.278353920240068, -9.060964018410631],
            [24.274909561150139, -9.057791424505162],
            [24.274222949134053, -9.057158983060617],
            [24.266754000129044, -9.045256087649717],
            [24.251507999739474, -9.007893955613113],
            [24.25302388701849, -9.003130523631508],
            [24.253778879692298, -9.000758056723406],
            [24.25049209228974, -8.992276091243351],
            [24.25206492018134, -8.984915934310642],
            [24.249724920257318, -8.979876017842091],
            [24.245543879752347, -8.976222990492523],
            [24.223766040285739, -8.966926942733185],
            [24.221423879913427, -8.961656078810721],
            [24.219897839875085, -8.960557964778902],
            [24.216445436371782, -8.958076443429908],
            [24.211910659969167, -8.954817077242931],
            [24.194519018252112, -8.955756317668193],
            [24.192968198186669, -8.955840069378485],
            [24.179195545355828, -8.950522331138279],
            [24.175366920225038, -8.949044033215475],
            [24.165660960448335, -8.948866912023556],
            [24.158243159718964, -8.944771918530529],
            [24.146907840171522, -8.942305002299893],
            [24.124875459475895, -8.9392051329478],
            [24.105975840145938, -8.936546008980294],
            [24.097896291869237, -8.937965999150055],
            [24.096247920153825, -8.932461912222385],
            [24.099208920043871, -8.92417608418393],
            [24.104037960279058, -8.920014940358557],
            [24.107806080282213, -8.916851057519716],
            [24.110574839803139, -8.913062977208062],
            [24.110283959924267, -8.909310997933355],
            [24.10614215962751, -8.903101052395851],
            [24.099702120287692, -8.89666702938047],
            [24.09304283991623, -8.89399094487638],
            [24.088425120266812, -8.89129205186004],
            [24.082545960244271, -8.890108976239544],
            [24.073857000268742, -8.888458005482173],
            [24.070002120077113, -8.885498950400912],
            [24.065628840101322, -8.88179493465551],
            [24.062268960377367, -8.877327953159527],
            [24.057384120390012, -8.873379927085493],
            [24.052993919747525, -8.86792305618015],
            [24.048366120102308, -8.864222065410306],
            [24.043209120228262, -8.858525037684819],
            [24.038326079566392, -8.854826978037467],
            [24.03112283964602, -8.848652066046046],
            [24.02623799965863, -8.844704085273365],
            [24.022537021536429, -8.840941253029246],
            [24.018254999613742, -8.837036986640856],
            [24.013875959640359, -8.832581917714258],
            [24.010543079680566, -8.830868004679774],
            [24.007979879849451, -8.829646981166881],
            [24.004377000451253, -8.826434051834346],
            [24.001795079729632, -8.82321005284963],
            [24.00050699981675, -8.821972977314529],
            [23.995868378167302, -8.819708215490163],
            [23.991213959643595, -8.812839997992505],
            [23.982872040421878, -8.806906920000877],
            [23.980079160237221, -8.802785032806067],
            [23.977227959627736, -8.786490071533731],
            [23.973032159802624, -8.7784700117081],
            [23.968637279835853, -8.777111858282556],
            [23.959173239958421, -8.777959858600797],
            [23.949709200081021, -8.778807857849264],
            [23.942770053176069, -8.776542852569799],
            [23.938358399866299, -8.771508929219555],
            [23.935350219559197, -8.770144926926466],
            [23.933298240176519, -8.775436865785528],
            [23.931734213978046, -8.776693297870578],
            [23.929846199592575, -8.778209993878676],
            [23.9250768155771, -8.778231232049977],
            [23.922687240327495, -8.778241872582422],
            [23.911197479721469, -8.790466999339515],
            [23.898661560000154, -8.77968728868284],
            [23.892309359725452, -8.780580608898548],
            [23.880312360004332, -8.785326600561996],
            [23.871475080090541, -8.78780580519291],
            [23.858065800283743, -8.786859966056003],
            [23.850556199817149, -8.785247528639355],
            [23.837604839819665, -8.784758132170925],
            [23.820067079935168, -8.779250957722951],
            [23.805055800346189, -8.776935899735491],
            [23.795519759600431, -8.777365643760643],
            [23.781440519847969, -8.77778327759553],
            [23.77166724032389, -8.777074814243839],
            [23.763004200337576, -8.773411369709919],
            [23.755012560296272, -8.768612149188481],
            [23.748411600349701, -8.767001946928506],
            [23.729001480121855, -8.781284256848888],
            [23.696059680138163, -8.704568338173432],
            [23.690885040046879, -8.673943201488472],
            [23.691605039747085, -8.653997504780833],
            [23.692796280374001, -8.629661983922306],
            [23.686765199965564, -8.622103899837372],
            [23.680717199788763, -8.609724960327064],
            [23.678146449617682, -8.601006731865869],
            [23.679237239731229, -8.584467992672991],
            [23.681524319901875, -8.579177904758641],
            [23.688419399950579, -8.572032923925724],
            [23.688177480051277, -8.568819000958149],
            [23.678659439747225, -8.554155887841784],
            [23.664939359920083, -8.546244678627801],
            [23.658079320455663, -8.542289012093152],
            [23.657827367272983, -8.542014788903538],
            [23.656515480208455, -8.540586941358265],
            [23.653179360923758, -8.536962845000353],
            [23.651128439756459, -8.534734868932839],
            [23.648565239925347, -8.527625933625595],
            [23.646896279721926, -8.513392869867909],
            [23.640091200084925, -8.481729006507656],
            [23.641655399658237, -8.467944993852393],
            [23.643590968159891, -8.461974026574719],
            [23.645530439841458, -8.455990923190388],
            [23.647580094384189, -8.452070596156478],
            [23.650341479634971, -8.446788893045881],
            [23.653768227253739, -8.443196087311787],
            [23.655395520001026, -8.441489924600228],
            [23.665668607776148, -8.43545806000483],
            [23.667593400087647, -8.434327903095165],
            [23.668289596229467, -8.432864604717601],
            [23.670110159713509, -8.429038030860577],
            [23.669394273398979, -8.42727259586127],
            [23.669180280325243, -8.426744868916481],
            [23.6723635234166, -8.418235693624885],
            [23.675115240099959, -8.410879887501368],
            [23.681867399983613, -8.367229970614488],
            [23.689594440359638, -8.33804186384466],
            [23.690933266102892, -8.326098123543158],
            [23.689970280203159, -8.31554088269003],
            [23.692703399963506, -8.306040903860202],
            [23.701343399959434, -8.276010016470661],
            [23.701368835756714, -8.275430598313697],
            [23.701978439695019, -8.26154396732314],
            [23.701373958848762, -8.25677751577928],
            [23.700552480064172, -8.250299892832608],
            [23.692398480315035, -8.228061894897545],
            [23.688200978182486, -8.21320503532062],
            [23.68468835970738, -8.200771857364829],
            [23.684425200041542, -8.192279908535461],
            [23.687473320344456, -8.184168961183579],
            [23.693321519930734, -8.168601938599883],
            [23.700798359737213, -8.135978943539804],
            [23.698290696451927, -8.128740617980842],
            [23.693809320401368, -8.115804877011188],
            [23.69179288465951, -8.100224556043029],
            [23.691671285109411, -8.099284980362913],
            [23.691947381413648, -8.096955898948362],
            [23.692787255000329, -8.089870837408535],
            [23.689071360352862, -8.081849909344847],
            [23.681213280031375, -8.075222967247969],
            [23.677591320416528, -8.066367008675872],
            [23.677148012603567, -8.06528297784177],
            [23.675401439756218, -8.061012013909343],
            [23.673728285318749, -8.059090430569979],
            [23.668230240047087, -8.052775974391515],
            [23.667755399571043, -8.049105941207152],
            [23.671956530897365, -8.03608043626496],
            [23.674129199836788, -8.029343961696069],
            [23.689920240448576, -8.003351003811874],
            [23.691078360190943, -7.999999955761689],
            [23.683523400192414, -7.992285908611804],
            [23.685140520417434, -7.987927886931803],
            [23.682613355605625, -7.981268075375941],
            [23.684595650875128, -7.976539672431386],
            [23.688383256235095, -7.967504882081477],
            [23.688386820750146, -7.963602519571324],
            [23.68839023973813, -7.959701863010208],
            [23.69162123996491, -7.952591015291183],
            [23.690473200218342, -7.948686973913066],
            [23.690758297641729, -7.947087530331054],
            [23.691168359704314, -7.944787000217358],
            [23.702210920995618, -7.932474519019428],
            [23.703733439638071, -7.930776877319412],
            [23.70461711956958, -7.929791565911543],
            [23.706384480330897, -7.927820936818128],
            [23.706619200233192, -7.923230896735003],
            [23.708891502219085, -7.921048404877448],
            [23.71330224014558, -7.916811964464953],
            [23.713419494544688, -7.914316498355766],
            [23.713539479822234, -7.911762888532795],
            [23.717687379679752, -7.907865871444526],
            [23.716791576983482, -7.904461451050373],
            [23.716539392933747, -7.903503041683384],
            [23.718389389718091, -7.895701034057294],
            [23.718374314190999, -7.895365619562725],
            [23.718162239918698, -7.890650939592956],
            [23.716587109645037, -7.886496370954917],
            [23.715637226572007, -7.883990936278424],
            [23.716098925593776, -7.882154626052113],
            [23.716560240136555, -7.880320013014931],
            [23.721299731812646, -7.873993491081555],
            [23.725322279857089, -7.868623905595538],
            [23.735695234240662, -7.858306967893743],
            [23.73900141716852, -7.851889975168342],
            [23.749996320139047, -7.830548904857833],
            [23.754492890294312, -7.825731878498158],
            [23.755989240114221, -7.824128875042915],
            [23.763697740161113, -7.830335916985031],
            [23.771406240208005, -7.836542866134935],
            [23.77439531963719, -7.844121868599973],
            [23.780378519841001, -7.849408859661205],
            [23.797180440031905, -7.859298912257232],
            [23.80040201962629, -7.865166248710053],
            [23.801090400425164, -7.866419958570067],
            [23.803304399952506, -7.879099899403301],
            [23.80565800036992, -7.892561092562085],
            [23.805904320217468, -7.893969869218051],
            [23.810955479686431, -7.91371598355408],
            [23.810839186484685, -7.918182549837491],
            [23.81071643978596, -7.922896940607017],
            [23.812337225137341, -7.928421823954056],
            [23.814623159955985, -7.936213922905116],
            [23.812313400019352, -7.944932997647577],
            [23.813923320247373, -7.948607015093554],
            [23.813091888129414, -7.950259543411134],
            [23.811845400214207, -7.952737009908341],
            [23.811844440813477, -7.954343009910468],
            [23.811842520215414, -7.957556949355402],
            [23.821334639631953, -7.953827863979926],
            [23.822147879967094, -7.944676520336309],
            [23.822339760111806, -7.925185186952199],
            [23.819072759899981, -7.895140314813884],
            [23.824147319583769, -7.886665975845153],
            [23.831416440150473, -7.882981759200361],
            [23.857735319972154, -7.873567301486294],
            [23.868327960053403, -7.871052231823665],
            [23.902457400216377, -7.862760551950754],
            [23.909942159570402, -7.857629937678837],
            [23.921181000056308, -7.850776165167716],
            [23.938987320278194, -7.840726304563699],
            [23.954940000148945, -7.833299971278413],
            [23.951437882081176, -7.826516050215461],
            [23.951263413083336, -7.826178085058361],
            [23.958406439828533, -7.819527851518923],
            [23.959843091207929, -7.816073836700063],
            [23.961174479798949, -7.812872870903954],
            [23.959799280371524, -7.800245876923733],
            [23.957966692039101, -7.794937853814959],
            [23.957500319981229, -7.793587014131888],
            [23.951978279810028, -7.786006011438745],
            [23.952903479873946, -7.77957886010913],
            [23.949963757479722, -7.776503537114418],
            [23.948070479865024, -7.774522916106429],
            [23.941400399947224, -7.763037896841244],
            [23.935845120313857, -7.75287661801031],
            [23.933067480048027, -7.747795884911032],
            [23.931612189524817, -7.745133928445583],
            [23.922312480258949, -7.728122884819162],
            [23.920589966091534, -7.721082420965095],
            [23.919784199739578, -7.717788959778566],
            [23.920480439898853, -7.711360931739652],
            [23.923493808875023, -7.706151271345232],
            [23.924860200321078, -7.703788965358937],
            [23.928091199649558, -7.691394931426147],
            [23.932930319880541, -7.685429948464608],
            [23.932137320385401, -7.684539216380058],
            [23.931089280197924, -7.683362008032012],
            [23.923080878491746, -7.681157043625583],
            [23.921882489970123, -7.680827088232804],
            [23.92971624032042, -7.672339013866359],
            [23.931329399873373, -7.667978850402527],
            [23.931089666473476, -7.664591826676089],
            [23.930874360062816, -7.661549879518468],
            [23.928370719433367, -7.653439993236814],
            [23.924209282862854, -7.639959788162949],
            [23.923061300608435, -7.63697396671845],
            [23.925598857131433, -7.63261204321218],
            [23.927671425002124, -7.626646540081152],
            [23.927666963070109, -7.626531821005645],
            [23.927447837022861, -7.620906520279541],
            [23.926033172808381, -7.617679326089071],
            [23.925836159690153, -7.617229889381528],
            [23.936439239991632, -7.595198015395289],
            [23.935062240340358, -7.590144849042121],
            [23.93092115959417, -7.583941026390586],
            [23.931617399753449, -7.575444987748431],
            [23.930905080648923, -7.573714063086141],
            [23.930010360422557, -7.571539896706826],
            [23.922414421077402, -7.567857924761171],
            [23.921495333150631, -7.566020828389169],
            [23.927025239868815, -7.558218908619172],
            [23.932554480037016, -7.552942884269497],
            [23.933164186383291, -7.553019383791088],
            [23.934395179258164, -7.553173834991596],
            [23.935089231121413, -7.548352972134374],
            [23.93290576263562, -7.543070106956955],
            [23.93072139673286, -7.537785004328605],
            [23.930217802981222, -7.536576789071749],
            [23.927274372341511, -7.52951482722996],
            [23.929204736902705, -7.525495236402959],
            [23.92980948005702, -7.524235974060602],
            [23.931658998039307, -7.522636387107517],
            [23.938562160230628, -7.516666016873352],
            [23.946851159698937, -7.512540985982201],
            [23.947000200086041, -7.51133891675592],
            [23.948080176280193, -7.502631730231539],
            [23.948702280275679, -7.497616005574245],
            [23.949854279796053, -7.496468925828408],
            [23.950693440120407, -7.495912000808329],
            [23.953905238857995, -7.493778821449625],
            [23.955379199966082, -7.492799857036848],
            [23.957453507873449, -7.488666602295441],
            [23.956110360335394, -7.486127022657962],
            [23.961021782370331, -7.47707067688824],
            [23.963848200257754, -7.471858858133359],
            [23.961843391410625, -7.46249285950825],
            [23.965988399591254, -7.458362873662029],
            [23.966085019688265, -7.457473681657804],
            [23.966304479908803, -7.455453987690219],
            [23.96675528955269, -7.45133047727967],
            [23.966915398980724, -7.449865963598157],
            [23.971750222569693, -7.44527784889144],
            [23.974754396390605, -7.425070844943135],
            [23.974529405242869, -7.417721029261579],
            [23.97683015956877, -7.411750074181917],
            [23.975265668941297, -7.401425559433611],
            [23.975229960010441, -7.401189903793573],
            [23.979379219917302, -7.388330372312231],
            [23.978841394963432, -7.385634921152946],
            [23.978691360141312, -7.384882977709369],
            [23.983524360150266, -7.383508983403757],
            [23.991354360034283, -7.378004022902036],
            [24.003782279800557, -7.377555966683211],
            [24.004507996379225, -7.377039426145698],
            [24.007005359581495, -7.375261883052307],
            [24.010000181041988, -7.369752027910498],
            [24.009655549569764, -7.367108579026406],
            [24.009311519968758, -7.364469912999009],
            [24.00056640001662, -7.365150864297206],
            [23.996195246353125, -7.361012821173451],
            [23.994589320034834, -7.354808869139623],
            [23.987917439893216, -7.349290858024335],
            [23.986677919311365, -7.349209031084404],
            [23.977331280258429, -7.348592008883639],
            [23.975364954339764, -7.347876259388393],
            [23.973108479770861, -7.347054893439799],
            [23.97187590226784, -7.346606548141338],
            [23.969738159826633, -7.345828950517792],
            [23.968848701931229, -7.344702951946815],
            [23.96739923967759, -7.342868015182053],
            [23.966867208857302, -7.342195288403517],
            [23.966287199916, -7.341461893561027],
            [23.965141319719354, -7.333880881664974],
            [23.961694330362292, -7.326527874175337],
            [23.962116089388179, -7.321935198328672],
            [23.962158359613866, -7.321474900441395],
            [23.965035384991172, -7.317063532857236],
            [23.965152480388461, -7.316883989001817],
            [23.967657163063645, -7.315386737077876],
            [23.974359840148153, -7.311379980601214],
            [23.971139999692117, -7.301959979600946],
            [23.971180698764378, -7.301917855797053],
            [23.973991200301633, -7.299008937481329],
            [23.976828274004994, -7.296067705312999],
            [23.977039319706254, -7.295848910429285],
            [23.974764531183656, -7.29231291097026],
            [23.972992200043837, -7.289557926365642],
            [23.97309607224015, -7.289293488946883],
            [23.974594434286288, -7.285478965130654],
            [23.978967479801771, -7.274345898213626],
            [23.979089520424715, -7.273823907417207],
            [23.978559699460018, -7.271384903498942],
            [23.978067506227646, -7.26911910408193],
            [23.978454380077782, -7.268251478112784],
            [23.979910320082961, -7.264986962640027],
            [23.984541359951404, -7.262772917154214],
            [23.985664154343578, -7.26223582757103],
            [23.985164160141242, -7.261506874645114],
            [23.977157399657091, -7.249823969628334],
            [23.967668193477007, -7.239220691572039],
            [23.965429319599465, -7.236718927905755],
            [23.964928059670921, -7.235437697318898],
            [23.963361652936939, -7.231433902105953],
            [23.961984501470418, -7.226838832480773],
            [23.963026319926232, -7.221526903025477],
            [23.963831279591062, -7.217422866477666],
            [23.963486085773482, -7.215521693910923],
            [23.962913280422441, -7.212366920259988],
            [23.96107338160024, -7.210298776058642],
            [23.963249070675669, -7.207225411441417],
            [23.963836320038141, -7.206395863811367],
            [23.969591279887783, -7.203184937623466],
            [23.970422160440162, -7.202044954293894],
            [23.973276240150177, -7.198134910384796],
            [23.977655280123557, -7.200999012764091],
            [23.978402944341244, -7.20148770991273],
            [23.97925547968185, -7.202044954293894],
            [23.982479127198054, -7.20090001493883],
            [23.983017480361312, -7.200222869514018],
            [23.985964439583491, -7.19651395455381],
            [23.986465200048716, -7.195881018641812],
            [23.986425155848302, -7.195781210453506],
            [23.9829501597156, -7.18711994793933],
            [23.983870121703109, -7.184589849599933],
            [23.988523411044529, -7.18186724074088],
            [23.989091040302899, -7.181535124247045],
            [24.002742240008995, -7.174730966978951],
            [24.003259199793746, -7.173970870370109],
            [24.004583279691612, -7.172029945080215],
            [24.006656520400462, -7.168990963700169],
            [24.011581507894498, -7.165525833439052],
            [24.014482227235749, -7.163484875085764],
            [24.019362483120215, -7.150546267006621],
            [24.026695199917437, -7.131104961803721],
            [24.03060731986065, -7.128809962495106],
            [24.031530360374646, -7.122148963789233],
            [24.045109199886284, -7.114808857767717],
            [24.047368050499141, -7.112654212380471],
            [24.050403359927817, -7.109758911812651],
            [24.055706159965734, -7.089086971488727],
            [24.060539159974692, -7.083576941594534],
            [24.061233239685684, -7.074847852714927],
            [24.063535508571157, -7.070713804000828],
            [24.065751428696593, -7.068674959798319],
            [24.066528480400496, -7.06796000049467],
            [24.074812440320088, -7.067506983379867],
            [24.080790289259721, -7.069579578745391],
            [24.084934199699063, -7.065447025810689],
            [24.089767199708021, -7.064531863938567],
            [24.090551707428798, -7.063489253870206],
            [24.091839359743563, -7.061777961193735],
            [24.097130196916837, -7.061321903767145],
            [24.099660000080654, -7.063849917601193],
            [24.105798642066247, -7.063069904253366],
            [24.108631102920619, -7.062710586030631],
            [24.113462390740636, -7.065010991516047],
            [24.113264400255364, -7.072033920693818],
            [24.119903160410797, -7.07007002354145],
            [24.121130746874105, -7.068232938406946],
            [24.121744200093413, -7.067314902343256],
            [24.121861372745816, -7.066530750684541],
            [24.122474279789451, -7.062428969484848],
            [24.123265619197952, -7.057129747010443],
            [24.124283280159155, -7.050314871150672],
            [24.126583208933319, -7.048249034061607],
            [24.141077125393949, -7.050556834586039],
            [24.141699538409902, -7.041288609783754],
            [24.141771359615209, -7.040218858646375],
            [24.143788029817344, -7.033310142325018],
            [24.147068399655506, -7.022072019371965],
            [24.147531350928762, -7.01701800156272],
            [24.142168789568242, -7.014392552093986],
            [24.136720200146247, -7.011724969880807],
            [24.132120480040172, -7.007815968092993],
            [24.130512386087119, -7.003449092130055],
            [24.131433240101714, -6.99954388574809],
            [24.134467635045446, -6.997155388962215],
            [24.135807239628047, -6.996100927064957],
            [24.149381496833424, -6.988758840689606],
            [24.152374439916656, -6.984624927770396],
            [24.151914359659088, -6.982326867737042],
            [24.146259480216909, -6.978470923048282],
            [24.144033433383285, -6.975577180774729],
            [24.141796199829447, -6.97266887848998],
            [24.141182513946461, -6.968211731120338],
            [24.139961280368858, -6.959341878829893],
            [24.136976487700156, -6.959008186450218],
            [24.135820199622639, -6.958878915853713],
            [24.126617301794962, -6.96093985459471],
            [24.125351749832824, -6.959904037918791],
            [24.124088520015643, -6.958869971079302],
            [24.123322763728115, -6.954806637977002],
            [24.12179316007305, -6.9466899975366],
            [24.125244480208085, -6.943934852845952],
            [24.139107796407284, -6.943131335091857],
            [24.148708199646514, -6.942574895252139],
            [24.152698907804034, -6.937859162367757],
            [24.157453319598652, -6.932240913847382],
            [24.158144159984776, -6.928794950078124],
            [24.147036015389542, -6.919563502001529],
            [24.146188199797418, -6.916377855034585],
            [24.148031372978842, -6.907877052688807],
            [24.147112294035246, -6.903051135193032],
            [24.148581765363534, -6.902318426139733],
            [24.148911685126365, -6.902153957809137],
            [24.150793271167636, -6.901215943643271],
            [24.156635476296017, -6.901668638319433],
            [24.159763344538291, -6.901911007263092],
            [24.17747536770646, -6.906290003860458],
            [24.178110702089501, -6.907208794856765],
            [24.178507482560597, -6.907782598429466],
            [24.179542127968855, -6.909278845515945],
            [24.187364207407025, -6.910892948395434],
            [24.189307059449007, -6.916966345371983],
            [24.189830462849272, -6.918602501397864],
            [24.191040167448563, -6.922384011828739],
            [24.201160283808878, -6.925837250308181],
            [24.201287722408345, -6.926040127511317],
            [24.202104249679099, -6.927340016740091],
            [24.207369406713347, -6.935721912145631],
            [24.209741525002062, -6.942331744966343],
            [24.210189006387804, -6.943578626478093],
            [24.21058636627226, -6.944685847014117],
            [24.216408453629843, -6.949883183470814],
            [24.217025354583242, -6.950433875067951],
            [24.219093165874501, -6.959167994892009],
            [24.228059324387139, -6.974107988767396],
            [24.227672980543023, -6.975960449243034],
            [24.227490648591488, -6.976834699838564],
            [24.227152125663189, -6.978457860550509],
            [24.226603928761033, -6.981081768124143],
            [24.226310259613175, -6.982487390668394],
            [24.225757125570244, -6.985134906519933],
            [24.228565124401115, -6.992696933277828],
            [24.228744425436876, -6.993178992812491],
            [24.228651855843474, -6.994198044053616],
            [24.228285405191315, -6.998232919780413],
            [24.227134769313569, -7.000670639139868],
            [24.226686905245529, -7.001619473034991],
            [24.226442205060447, -7.00213788866246],
            [24.223221285727764, -7.002594906092486],
            [24.221396839725067, -7.00429462348798],
            [24.220053419997456, -7.005546196210282],
            [24.219770342885106, -7.005809895359095],
            [24.217928188393227, -7.00994397631608],
            [24.223282084604516, -7.014972563801662],
            [24.224232495886906, -7.015865224572866],
            [24.225517377797324, -7.01707199731506],
            [24.231041149022094, -7.015007931078846],
            [24.232420364817177, -7.018224988472843],
            [24.233797333027386, -7.018776202563934],
            [24.23405758843991, -7.018880385546439],
            [24.235870243156207, -7.019605994983352],
            [24.238752827308488, -7.018686168688596],
            [24.239295924474753, -7.01851286536574],
            [24.241621231553982, -7.01777086666719],
            [24.244640376697454, -7.020141537069233],
            [24.244842176039487, -7.020300004109746],
            [24.249902298898355, -7.020532885446462],
            [24.25381423558526, -7.016629840827325],
            [24.258646372313205, -7.015943915396432],
            [24.26507410383536, -7.017080375532432],
            [24.265479447047756, -7.01715204226809],
            [24.266468442768208, -7.017326903276189],
            [24.27152824223359, -7.020545942263548],
            [24.271903258321974, -7.021296176404497],
            [24.272387248139186, -7.022264415573887],
            [24.273826144408435, -7.025142916810609],
            [24.276604296714012, -7.02503331620268],
            [24.279579253728624, -7.024915950480386],
            [24.282447960706378, -7.02670890514316],
            [24.283258097362214, -7.027215249106311],
            [24.286939134681742, -7.02951590845757],
            [24.28992063861817, -7.028870201435614],
            [24.292230379690164, -7.028369972061397],
            [24.29281641363206, -7.028928876166131],
            [24.297291307439529, -7.033196872998762],
            [24.299628483060314, -7.03334484675079],
            [24.30097225313089, -7.033429924591385],
            [24.302287813406583, -7.032520473006161],
            [24.302613112235608, -7.032295587983875],
            [24.303962273994497, -7.031363090505231],
            [24.306722200381266, -7.032283970155424],
            [24.30815377358434, -7.034070864099337],
            [24.308563240063883, -7.034581959225132],
            [24.309713444750287, -7.040786014800036],
            [24.316385319502054, -7.042167855311814],
            [24.319420119585942, -7.046252020172282],
            [24.3223652794826, -7.050212920070329],
            [24.325662655327413, -7.051445311304291],
            [24.329992877254998, -7.053063722240542],
            [24.345140307305059, -7.058724982472437],
            [24.34947238245709, -7.056760617018722],
            [24.352731764955259, -7.055282894203931],
            [24.379643407100335, -7.058070940088909],
            [24.397425662354081, -7.046315155688537],
            [24.413491670986122, -7.046632088668913],
            [24.43151658096102, -7.051751237242507],
            [24.451966350213258, -7.053948784735834],
            [24.471233548479397, -7.054236202133588],
            [24.474631128699212, -7.054201260574718],
            [24.483041547156301, -7.054114762368565],
            [24.49805930539511, -7.047209427384785],
            [24.50463038557869, -7.044248663344955],
            [24.516218424571768, -6.995905053591571],
            [24.520386143959382, -6.990074787227827],
            [24.524130144197173, -6.987624886649404],
            [24.529325635982815, -6.98757158574778],
            [24.536116807004291, -6.994731489420627],
            [24.537480022905836, -6.9961687142815],
            [24.547113622488073, -7.009090764478185],
            [24.553781541059287, -7.012880246061703],
            [24.619491975484326, -6.983268661129505],
            [24.643974168859259, -6.98024201678305],
            [24.643697869535742, -6.979277814531418],
            [24.642591437058172, -6.975416196775259],
            [24.643739457940136, -6.96071182260192],
            [24.645199855385744, -6.960150695854813],
            [24.646037409522354, -6.959828883124702],
            [24.65271025355629, -6.957264973257412],
            [24.653163365582241, -6.956510379338132],
            [24.653735229498825, -6.955558019375397],
            [24.655468212632577, -6.952671968373703],
            [24.656220045931498, -6.951170550432857],
            [24.65638910078313, -6.950832960027144],
            [24.66121809520423, -6.950603989521583],
            [24.669040230337959, -6.955199852287918],
            [24.671466729040695, -6.954715344815376],
            [24.674268112677812, -6.954155965670437],
            [24.682842285926327, -6.952443885636014],
            [24.685189743663852, -6.952657257097044],
            [24.690433331249825, -6.953133716772561],
            [24.692470444412876, -6.951099354584706],
            [24.695034368286112, -6.948538849659035],
            [24.69802300574419, -6.948308974098192],
            [24.698281135742782, -6.946413893333681],
            [24.698711409000925, -6.943253972858131],
            [24.704921407762829, -6.941875945331216],
            [24.706302393238989, -6.938658892147356],
            [24.705610087700666, -6.93337387241814],
            [24.707102501102995, -6.931957409633744],
            [24.710209087357867, -6.929008907812846],
            [24.714809166790083, -6.928779915779166],
            [24.716879196920072, -6.926251880009723],
            [24.717390224230691, -6.926276206298025],
            [24.721710328433236, -6.92648193524473],
            [24.720558366642138, -6.921196988149841],
            [24.727459205790097, -6.920277960789684],
            [24.727640284591814, -6.91979392949288],
            [24.727803468054752, -6.91935773139789],
            [24.728147166177394, -6.918439008320115],
            [24.726825223371595, -6.916398728382233],
            [24.72561643505394, -6.914533026961371],
            [24.729221226067068, -6.913193086698951],
            [24.731202016658465, -6.912456844923111],
            [24.735506285359172, -6.910856985163699],
            [24.735900118457824, -6.910364519052407],
            [24.736262605742958, -6.909911248395832],
            [24.73734408481856, -6.908558918044795],
            [24.734824079579582, -6.904064150593594],
            [24.734123242740989, -6.902814040988722],
            [24.734672164583571, -6.902154861821781],
            [24.736421405427297, -6.900056952566785],
            [24.74079108405709, -6.898218993207159],
            [24.748840362701959, -6.889946929029495],
            [24.776903000949218, -6.891784913718817],
            [24.778814028375628, -6.891081320785775],
            [24.779585959682439, -6.890797108369958],
            [24.7812731062788, -6.890175943710811],
            [24.782551611049023, -6.888799054744509],
            [24.784260360331348, -6.886958853436442],
            [24.787016100568874, -6.87477994819365],
            [24.787673202029513, -6.87355953177015],
            [24.790233119416595, -6.86880494021823],
            [24.803110318097467, -6.858233858798786],
            [24.807155006020409, -6.853381607791523],
            [24.816902272130477, -6.841687992467304],
            [24.835197115068464, -6.833025914766237],
            [24.847486073545134, -6.827207928106575],
            [24.846083153006344, -6.81532748032437],
            [24.840797633859555, -6.794679095454616],
            [24.848071073526143, -6.783455494605242],
            [24.875542310397677, -6.757845372750999],
            [24.894483348350441, -6.750576288546422],
            [24.91259535089047, -6.749591787379057],
            [24.926401979801962, -6.75022103571821],
            [24.932419424682692, -6.746114241154468],
            [24.9310161439195, -6.725521739016244],
            [24.92748494918261, -6.710354075105239],
            [24.93521243961461, -6.703333961682642],
            [24.944249128453492, -6.699272574739233],
            [24.980474809789804, -6.697723087989187],
            [25.00637747319092, -6.698116212794587],
            [25.010241023921665, -6.698174851610153],
            [25.021821887172234, -6.685754752069401],
            [25.025446508495282, -6.675059999684425],
            [25.029042045962672, -6.664450826960572],
            [25.034185366291585, -6.65823053850118],
            [25.044096159021048, -6.656281568506994],
            [25.04928412561954, -6.658459661087533],
            [25.054936485287364, -6.66694321556515],
            [25.057197433466381, -6.667996808050737],
            [25.067044364962285, -6.672585410483288],
            [25.079132443971719, -6.674448226284415],
            [25.096828216616426, -6.676396415354593],
            [25.109376401934611, -6.6837246192902],
            [25.122437421973775, -6.687438108384233],
            [25.128303234827808, -6.68910585827655],
            [25.137456772027242, -6.691708342281144],
            [25.142631400440429, -6.691367015343875],
            [25.159393358177589, -6.679865161429261],
            [25.173168757158251, -6.674615768826943],
            [25.181356583867693, -6.673060660318462],
            [25.19519895674436, -6.680408586105278],
            [25.210375475141632, -6.695333952608896],
            [25.222527634573549, -6.709373605469668],
            [25.241371040926307, -6.72135490846266],
            [25.25754591189607, -6.724179410354719],
            [25.266204992108644, -6.730188372135935],
            [25.274901511407279, -6.743334838382563],
            [25.284029671199978, -6.756487385557145],
            [25.292690910064142, -6.762915789466481],
            [25.300909708887975, -6.767238448089679],
            [25.301828069179329, -6.777747138037761],
            [25.301467709104788, -6.791174501988697],
            [25.29852147033148, -6.804982107669894],
            [25.310224371510028, -6.808639950876117],
            [25.330450683038713, -6.80590816137016],
            [25.337589260428349, -6.804944009178143],
            [25.339361367887626, -6.803626264598241],
            [25.341605803235126, -6.801957192827055],
            [25.345632146661643, -6.798962993772963],
            [25.354337305956694, -6.796146854366997],
            [25.367702305108239, -6.79182302622425],
            [25.377357143558715, -6.786989855429545],
            [25.386922821522312, -6.777413613785311],
            [25.389656223353683, -6.774677158354812],
            [25.394127382864482, -6.770200969611523],
            [25.398317421793681, -6.767424926374543],
            [25.409754260849667, -6.759846916636039],
            [25.412662347274548, -6.757214887130974],
            [25.414636858642101, -6.75542780249721],
            [25.421699060367949, -6.749035911802499],
            [25.432949059726337, -6.733168841020738],
            [25.436702059286617, -6.730925928811042],
            [25.438526230404836, -6.729835373556641],
            [25.441842137595671, -6.727852998861601],
            [25.448347263471089, -6.723963869034479],
            [25.441208178533358, -6.715236881526372],
            [25.440609051646199, -6.713722163514479],
            [25.43930998533741, -6.71043784104069],
            [25.438799419760834, -6.7091470118416],
            [25.438209445808099, -6.707654958770665],
            [25.438434717230226, -6.707504523893237],
            [25.439474872904444, -6.706809913335365],
            [25.4437231388337, -6.703972932538387],
            [25.444259166258675, -6.70257650997852],
            [25.444483414499675, -6.701992311959329],
            [25.444870007177155, -6.700984781404209],
            [25.444622517723115, -6.700300204108236],
            [25.440716418288954, -6.689496922615183],
            [25.451502377615967, -6.670182010798453],
            [25.457431299813653, -6.664666075156108],
            [25.457931304795718, -6.664200927861968],
            [25.45851979293499, -6.663538124148169],
            [25.461607216328243, -6.660061010219102],
            [25.462231141208814, -6.658001484068911],
            [25.462875915987151, -6.65587312509606],
            [25.463209217008718, -6.654772917730512],
            [25.463200560842623, -6.64779983752664],
            [25.463194096565839, -6.642591931789253],
            [25.466852416390143, -6.625120972706645],
            [25.465687067006371, -6.612251917422236],
            [25.463009378688916, -6.605417559188385],
            [25.458305296804713, -6.593410932771762],
            [25.457379891026559, -6.592610380994778],
            [25.456948256820748, -6.592236982075539],
            [25.456794377209214, -6.592103862275414],
            [25.454853258017433, -6.590424948356263],
            [25.447494308617237, -6.589511931549809],
            [25.446407560024198, -6.585459518685296],
            [25.445577499633675, -6.582363789048471],
            [25.444721418642622, -6.579170991860148],
            [25.439890186518156, -6.576647002397957],
            [25.429313438532628, -6.576196020536734],
            [25.427819032667003, -6.573960678138145],
            [25.423324099242187, -6.567236979372006],
            [25.417801307181083, -6.562414983381366],
            [25.414919794718941, -6.562118966487901],
            [25.41113345328856, -6.561729996321239],
            [25.412039180572062, -6.550696851507632],
            [25.408354221208036, -6.54495298264438],
            [25.405922400885526, -6.544499586465561],
            [25.405762803497201, -6.544469831518185],
            [25.404674333732057, -6.544266899494958],
            [25.403799587546047, -6.544802254910039],
            [25.401314021918431, -6.546323473266959],
            [25.400537314269283, -6.546798839789178],
            [25.3994613795956, -6.546859259473859],
            [25.399339102715757, -6.546866116914009],
            [25.396400195991792, -6.547030950592516],
            [25.394917974874666, -6.543690932243831],
            [25.393504410198105, -6.540505307416741],
            [25.391098341879854, -6.535082918463337],
            [25.383737073029653, -6.532789868918543],
            [25.38239970255713, -6.533248988004714],
            [25.382184553351667, -6.533322851486898],
            [25.379915302942777, -6.534101917166422],
            [25.373861151102886, -6.54130298028107],
            [25.37107852608553, -6.541073017560727],
            [25.368343135384148, -6.540846959200497],
            [25.359138264856114, -6.534187859736682],
            [25.358333321360934, -6.532873545005232],
            [25.356605299622515, -6.530052062770756],
            [25.355386561564746, -6.529415288761112],
            [25.354185298434214, -6.528787688664807],
            [25.351774105227289, -6.527527957998444],
            [25.34541230375881, -6.52163228057644],
            [25.33955441763883, -6.516203534631217],
            [25.331817146349998, -6.509032994163703],
            [25.330425072968296, -6.507743328473485],
            [25.329377807128584, -6.506773102180678],
            [25.329220113270374, -6.506626973737077],
            [25.325387262464467, -6.501801612998927],
            [25.314256347373409, -6.487787991096912],
            [25.314366417945159, -6.484137271749608],
            [25.314422547379067, -6.482275628692132],
            [25.314478016551206, -6.480432789967592],
            [25.312602759141122, -6.478092755710686],
            [25.308954320784924, -6.473540077008908],
            [25.305732504035269, -6.471473081957425],
            [25.296768360443821, -6.472168856769897],
            [25.292856239602312, -6.469643963418707],
            [25.28871119998065, -6.462059892335815],
            [25.286982809932955, -6.461773025586474],
            [25.281812520382612, -6.460914894462157],
            [25.28077562559286, -6.456329920272512],
            [25.279733519676174, -6.451721862983494],
            [25.275133361192214, -6.448506677297505],
            [25.274438558337394, -6.446774872099339],
            [25.272367388245286, -6.441611878314567],
            [25.282666079802645, -6.437836726753894],
            [25.286946839592343, -6.431600503462886],
            [25.298547480152241, -6.422954762956937],
            [25.306277040302653, -6.416350683377277],
            [25.306237079645534, -6.408788371390953],
            [25.305732360304834, -6.394917271691682],
            [25.300904760069063, -6.379299538501824],
            [25.296910920384462, -6.358232089818208],
            [25.293344040072945, -6.336329971421131],
            [25.295885639913045, -6.327545216263101],
            [25.368221519664335, -6.302592814128157],
            [25.376589223229676, -6.300559445084748],
            [25.382868759679361, -6.299033489673691],
            [25.385890580904054, -6.299499579685447],
            [25.388485820946403, -6.300799533612123],
            [25.415327812215928, -6.319275112136215],
            [25.427842424796989, -6.320305426258433],
            [25.439908217502563, -6.317967678585657],
            [25.474755134896395, -6.300429090695139],
            [25.486800727186175, -6.294309258757632],
            [25.492864572746278, -6.299023447864561],
            [25.495937893487906, -6.309154483283811],
            [25.503716042613721, -6.311793728446515],
            [25.511465771738866, -6.308970160556322],
            [25.536792129952619, -6.306458959910936],
            [25.54206828865415, -6.298636882107138],
            [25.550685068098304, -6.293186399094302],
            [25.553149225974362, -6.291627702686955],
            [25.560087367664526, -6.287238973355846],
            [25.560805518631906, -6.286784419836675],
            [25.561062317327234, -6.286621879200451],
            [25.561359247359555, -6.286433937649309],
            [25.579282205736238, -6.282736918864877],
            [25.587324283485774, -6.279281000376957],
            [25.598356045230709, -6.280418873720727],
            [25.599902543501351, -6.279703498706827],
            [25.600947989354275, -6.279219901361341],
            [25.601343363961981, -6.279037007864646],
            [25.602177104750211, -6.277991764035045],
            [25.603901060713635, -6.275830468994088],
            [25.605932310572832, -6.273283989465278],
            [25.613064276361964, -6.277184881927599],
            [25.636043040294233, -6.275321843222374],
            [25.643161319351687, -6.269335855966164],
            [25.670965197881358, -6.265626891066158],
            [25.677572090302053, -6.262915374211219],
            [25.677953156543929, -6.262758981702522],
            [25.681072197041892, -6.261477921740566],
            [25.682952460763104, -6.259121419077496],
            [25.684744196411359, -6.25687585732975],
            [25.688858276495051, -6.241696943714778],
            [25.68938107982072, -6.240857215110148],
            [25.690007932310834, -6.239850363133264],
            [25.691150076414182, -6.238015911698959],
            [25.691899398921912, -6.238077572942357],
            [25.693908525072292, -6.238242880557162],
            [25.699196395110217, -6.238006948330987],
            [25.701715488559174, -6.236519330937613],
            [25.702371910893472, -6.23613168895509],
            [25.703098073934864, -6.235702861392826],
            [25.706077074266581, -6.229721968379003],
            [25.709291152928373, -6.227648955098466],
            [25.713519413376268, -6.227567343750678],
            [25.713957191160297, -6.227558894408013],
            [25.721933272380877, -6.227404944465849],
            [25.728134271820256, -6.224867906155922],
            [25.735935111491827, -6.217041901903949],
            [25.739839310989161, -6.215197985239659],
            [25.746048116788355, -6.213969915957564],
            [25.747426680406505, -6.213697242817076],
            [25.752706069449836, -6.212653004015656],
            [25.760971308478883, -6.206894902790348],
            [25.768865139053723, -6.205586867625786],
            [25.769809952035271, -6.205430308562127],
            [25.777742267335192, -6.204115892190429],
            [25.788415240159043, -6.200118264550566],
            [25.791294105286038, -6.199039961914987],
            [25.797264353580065, -6.194664020686828],
            [25.801729064085439, -6.186525955394515],
            [25.802032963247743, -6.185971892853879],
            [25.803449144716748, -6.183389927061947],
            [25.810597007991451, -6.177447840288735],
            [25.81148115414862, -6.17671285776234],
            [25.813989223472394, -6.164063954342985],
            [25.80681047342329, -6.159289818115327],
            [25.805263298721236, -6.158260883362614],
            [25.802946224701568, -6.156719930147354],
            [25.802252144092247, -6.154191864166217],
            [25.803398025187189, -6.151431913524903],
            [25.80971067084333, -6.150133971171956],
            [25.811236596795641, -6.149820222759752],
            [25.825910193381105, -6.146803156631648],
            [25.828082821896359, -6.144936140271431],
            [25.829124480452055, -6.144040963429091],
            [25.83972972030346, -6.146277007816745],
            [25.847076960163921, -6.148910470883769],
            [25.857465839880838, -6.155793393519654],
            [25.865697959821993, -6.162643256758639],
            [25.876498320041343, -6.165749487669204],
            [25.882982279812051, -6.168369773321921],
            [25.894245240063356, -6.177367049989356],
            [25.911699479982651, -6.186233915285993],
            [25.912718474942039, -6.187046757661388],
            [25.925508360072236, -6.197249022355148],
            [25.939312199714806, -6.205506929444728],
            [25.940911914182866, -6.207517863751796],
            [25.94461032042841, -6.212166945406238],
            [25.952205240185727, -6.218592894690617],
            [25.948896479991298, -6.234092813810884],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kalemie",
        AREA: 134940,
        POPULATION: 3062000,
        DISTRICTS: [],
        OBJECTID: 24,
        NOM: "Tanganyika",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.968362159283256, -4.999520568156088],
            [27.088518319760471, -5.002930073141692],
            [27.106247799889566, -5.00344113932888],
            [27.264169816732494, -5.007993347207385],
            [27.313211827804384, -5.009305891662773],
            [27.320190916501815, -5.009503929726514],
            [27.329598573620427, -5.009770879679073],
            [27.388628407059056, -5.010926453467587],
            [27.392496818573797, -5.011002181245549],
            [27.410295964849794, -5.011350624761713],
            [27.535172447853238, -5.013795210357943],
            [27.550619956530713, -5.014436361449597],
            [27.596269205047626, -5.016331037446326],
            [27.596296790513399, -5.016332182438721],
            [27.60211086939022, -5.016573495617711],
            [27.625776869667657, -5.013508845762678],
            [27.638966574269595, -5.013861806652488],
            [27.673555699431414, -5.010024600270651],
            [27.857873325696037, -5.012462359636204],
            [27.85894267392203, -5.012476497809312],
            [27.97172418424455, -5.013968132791094],
            [28.010810308058048, -5.014485078269106],
            [28.094994232483309, -5.015598477932682],
            [28.287895164269607, -5.018149739511801],
            [28.406990008357806, -5.019724850776682],
            [28.592894196856385, -5.015307786402996],
            [28.801756115234891, -5.01034523993094],
            [28.803514509013041, -5.010333579097649],
            [28.97163028610327, -5.009215840763136],
            [29.026354117991026, -5.008852002028783],
            [29.097490273425883, -5.008379044249107],
            [29.114595931082341, -5.008265314734183],
            [29.118790440028359, -5.008215424510971],
            [29.122529198596457, -5.00822890874504],
            [29.122520949367214, -5.008336455591257],
            [29.122501459518816, -5.00859054520294],
            [29.372075724564571, -5.007911856203008],
            [29.372212514626156, -5.009128800556904],
            [29.373088027075084, -5.016916265216633],
            [29.388979701456584, -5.057999205415544],
            [29.391979550787735, -5.068999365784107],
            [29.400979456310669, -5.091999185510996],
            [29.409979364528528, -5.123999288381425],
            [29.428979244827367, -5.176999217687073],
            [29.438979216908351, -5.202999258262842],
            [29.465978924493971, -5.27099922528301],
            [29.475978894778297, -5.294999233408654],
            [29.494978763399043, -5.336999125425113],
            [29.500978453078204, -5.343999122152685],
            [29.521978461103199, -5.398999127334073],
            [29.526978084224311, -5.409999132828236],
            [29.529978289288316, -5.414999198325678],
            [29.54997786963256, -5.474999226682673],
            [29.557978062533664, -5.50199913665129],
            [29.560977908271557, -5.507999246266357],
            [29.563977753111125, -5.514999207438037],
            [29.566977963565044, -5.529999126025849],
            [29.56797767349191, -5.535999129489305],
            [29.575977861901432, -5.555999169343498],
            [29.587977622145395, -5.618999206890177],
            [29.595977457517019, -5.651999113087963],
            [29.59897730594988, -5.663999210286523],
            [29.604977395379315, -5.750999195257208],
            [29.606977538376857, -5.767999048035204],
            [29.606977543766739, -5.777999037135226],
            [29.604977426820351, -5.808999122077048],
            [29.599977476712493, -5.855999067023827],
            [29.588977842315352, -5.902999132599961],
            [29.580977684448534, -5.941999111464997],
            [29.577977854880316, -5.962999058180206],
            [29.577977889914603, -6.02799915759578],
            [29.577977916864086, -6.075599053631117],
            [29.57797793123714, -6.101999074067161],
            [29.578978023846307, -6.146999095892989],
            [29.579978095794235, -6.154999057926636],
            [29.588978018385149, -6.219999076869837],
            [29.594977721539042, -6.251999081711181],
            [29.602977915338442, -6.278998987366369],
            [29.611225732440911, -6.301910000572917],
            [29.611977815471487, -6.303999106002227],
            [29.620977711112957, -6.322999031366022],
            [29.623977561342404, -6.337999106093675],
            [29.650121709858194, -6.401206818803493],
            [29.654977165054291, -6.412999091753542],
            [29.663977055305878, -6.425998969209],
            [29.688943112733863, -6.465742863036465],
            [29.708742146885854, -6.497259035578019],
            [29.712976414368047, -6.503999022760292],
            [29.74697618631302, -6.553998939431627],
            [29.7739758382031, -6.586998909946488],
            [29.791975603434874, -6.608998848536332],
            [29.826975054763992, -6.642998978877015],
            [29.839043767892527, -6.652913092656464],
            [29.905973800063055, -6.707998764580918],
            [29.984972855280887, -6.763998754858822],
            [30.022972090364132, -6.792998776972558],
            [30.094970990492797, -6.847998740276358],
            [30.098190231772545, -6.85140683169998],
            [30.135721281099379, -6.891137740767186],
            [30.161639075723102, -6.921008720574147],
            [30.196828530616262, -6.978601587499123],
            [30.27619826485633, -7.10260550177849],
            [30.289966970489786, -7.134740565095871],
            [30.306180762765859, -7.182404619955818],
            [30.325617571042507, -7.22338748598703],
            [30.374966615498707, -7.291998427617388],
            [30.398966354277267, -7.360998553701698],
            [30.422965717560007, -7.417998436180741],
            [30.453965148795362, -7.478998475744062],
            [30.478964921792606, -7.533998466658015],
            [30.513964229391252, -7.602998405648727],
            [30.540963760907118, -7.666998269924497],
            [30.561963274858705, -7.718998397718196],
            [30.574963365765399, -7.750998375571885],
            [30.605962787119282, -7.837998278796463],
            [30.637784096889561, -7.95727318466679],
            [30.685205251643168, -8.017993140015918],
            [30.737452111187267, -8.105270191904788],
            [30.767466547798435, -8.187094170295801],
            [30.793141277170896, -8.27154814804563],
            [30.562764831705262, -8.296066027042167],
            [29.628376952648559, -8.395491715477361],
            [29.622551040264501, -8.380398795472905],
            [29.610949680154096, -8.371127910298711],
            [29.6051612400938, -8.371142173021234],
            [29.5906802396103, -8.367690315723474],
            [29.57502995961363, -8.359591406870193],
            [29.562836400423517, -8.345090502629013],
            [29.556434519720341, -8.331737349439059],
            [29.553424082845225, -8.310633484908806],
            [29.551129560132466, -8.29454757149678],
            [29.53893600004405, -8.280044228104105],
            [29.534245559975734, -8.256801371265261],
            [29.528407799711392, -8.237629768418765],
            [29.519121960433541, -8.228349758568037],
            [29.520233639970662, -8.210322739880603],
            [29.520174239770817, -8.187064498229622],
            [29.526456959849916, -8.153903408056975],
            [29.531663640152409, -8.15272765100743],
            [29.540975040093375, -8.171894842830435],
            [29.543312520243042, -8.180611628977015],
            [29.56010292043873, -8.181733432873614],
            [29.579186520128804, -8.174127436856166],
            [29.583223559795417, -8.168302614446185],
            [29.572705799682993, -8.129946972246426],
            [29.574939236956464, -8.119239886892302],
            [29.583015480331209, -8.110541893252364],
            [29.592682199899667, -8.110071967053317],
            [29.608415280311, -8.103477966609002],
            [29.613831384855683, -8.103224711378411],
            [29.619003240169597, -8.102982876326696],
            [29.62940820691664, -8.095374021754481],
            [29.635845480343725, -8.094751986211881],
            [29.636881810991436, -8.093974074708946],
            [29.63900952014923, -8.092376925300606],
            [29.645584199882176, -8.079123994732329],
            [29.649910312915637, -8.059037899449342],
            [29.648571479985872, -8.051723930176005],
            [29.651513562254344, -8.045195037466556],
            [29.656419480311531, -8.034307879467864],
            [29.660211359855648, -8.020435950851326],
            [29.664438547715083, -8.013601994032966],
            [29.666847240012284, -8.009707887839763],
            [29.667570479935723, -8.001883919871426],
            [29.667259440065223, -7.999999955761689],
            [29.668276716547471, -7.996756798784002],
            [29.668592488742878, -7.995750085457701],
            [29.665785369362698, -7.988770469046216],
            [29.662975475984883, -7.981783834658667],
            [29.665922400172771, -7.974422002669915],
            [29.66589936108068, -7.970749112544689],
            [29.662386480297485, -7.961588871208831],
            [29.660679359660794, -7.946680860099112],
            [29.656727279958794, -7.940965878212979],
            [29.657279567788734, -7.939705124687165],
            [29.657634479581077, -7.938894936694198],
            [29.66268131995016, -7.935880869467581],
            [29.662215839919373, -7.932529440895999],
            [29.660181119868259, -7.929043225923499],
            [29.652370560425293, -7.930807934229199],
            [29.642836319903388, -7.937522393606339],
            [29.635828559677034, -7.939851072899343],
            [29.631261960455475, -7.938714489195855],
            [29.626041599709485, -7.934654318207978],
            [29.623957560352622, -7.911966729762463],
            [29.601859319671934, -7.872451062091123],
            [29.58790679986673, -7.849207129038935],
            [29.582592511274637, -7.835125073455604],
            [29.580735178847696, -7.834464457563707],
            [29.580053399767859, -7.834221988584695],
            [29.576343239965158, -7.830111861069854],
            [29.573854977595047, -7.82470881225662],
            [29.573074440427842, -7.823013929102491],
            [29.566841313640637, -7.820296080011532],
            [29.560924439647554, -7.831808976036746],
            [29.557264138139722, -7.835194168574601],
            [29.555429400138813, -7.836890996502527],
            [29.536592399672362, -7.844116870060413],
            [29.534101199811278, -7.851017883560097],
            [29.527719926460676, -7.856578736886621],
            [29.524023359964822, -7.859800013115862],
            [29.521309320421128, -7.867619938748799],
            [29.520156975049368, -7.868781395829873],
            [29.517873480055037, -7.871082936782317],
            [29.508953759950991, -7.873987697497915],
            [29.5037474398729, -7.875455244183688],
            [29.497520879770438, -7.874015724002796],
            [29.493750239992892, -7.87082427034199],
            [29.485759679726559, -7.858768532752841],
            [29.484284760116111, -7.847860348855763],
            [29.485130399988595, -7.838982986668293],
            [29.485256400385275, -7.831707928146595],
            [29.485535400044533, -7.827633302391416],
            [29.483616240169862, -7.812796634690333],
            [29.481292799789767, -7.809746822506336],
            [29.474195400274482, -7.807290460218178],
            [29.453708519821188, -7.814446866323474],
            [29.454847200020829, -7.807858935127376],
            [29.463508439783325, -7.793345976051897],
            [29.457941400304595, -7.786489882484166],
            [29.45288843971348, -7.788584985560742],
            [29.448740520093029, -7.78814986024761],
            [29.447009738730088, -7.787014805801796],
            [29.446659311327625, -7.786784933327733],
            [29.443464763836761, -7.780716930957789],
            [29.443165190062548, -7.780147873974197],
            [29.438225279754999, -7.763186994560508],
            [29.43798761068366, -7.759155135359566],
            [29.437711199969037, -7.754466018878833],
            [29.438261078517392, -7.753291199409366],
            [29.439758519790342, -7.750091891986743],
            [29.443428359609854, -7.747544999084943],
            [29.444032222415213, -7.745249825566357],
            [29.445001200077879, -7.741566889974591],
            [29.443759633133809, -7.737181925220991],
            [29.443119399339238, -7.734920916689844],
            [29.440259726718292, -7.731509511642514],
            [29.438713323669077, -7.729664865763787],
            [29.437115510934468, -7.729474652694154],
            [29.435026319739421, -7.729225943067494],
            [29.434000949436466, -7.730305654705044],
            [29.429764199909162, -7.734766905739157],
            [29.423557439573866, -7.736638876707993],
            [29.419620480314741, -7.732757959964671],
            [29.418571506777681, -7.732668553391024],
            [29.417085360022806, -7.732541885981151],
            [29.402818920348274, -7.73892565898873],
            [29.36508911966316, -7.755317232842958],
            [29.359305720049907, -7.757368746237846],
            [29.347417909653284, -7.753630163160385],
            [29.337725160501172, -7.750581877135872],
            [29.326555079762027, -7.740131009757355],
            [29.315253240425239, -7.734774048014938],
            [29.307290400371944, -7.733483860347302],
            [29.304683999660522, -7.732907961894601],
            [29.286875880113151, -7.729895419503975],
            [29.273702039759122, -7.728181279294912],
            [29.26299563972524, -7.729226121380369],
            [29.245525559812563, -7.745277369809584],
            [29.23295976032826, -7.754912964510035],
            [29.225885039680627, -7.761478883531914],
            [29.213760959787848, -7.774023317936825],
            [29.206689839587884, -7.781898617073368],
            [29.171350080378005, -7.770780200501307],
            [29.160903599786771, -7.760328234982561],
            [29.147957280236334, -7.739762976115898],
            [29.1460354182293, -7.739940175150074],
            [29.142664199969772, -7.740251008463344],
            [29.133047351272648, -7.74971492866159],
            [29.122913160108475, -7.749079957781319],
            [29.122693217492628, -7.752800570548169],
            [29.122492152074159, -7.756198956088635],
            [29.120654998503458, -7.755947587920284],
            [29.117653199828133, -7.755536866400724],
            [29.113941239801584, -7.750734907384672],
            [29.110948199700296, -7.750979899204338],
            [29.108915279872967, -7.757648910449465],
            [29.104555301251597, -7.760196986801732],
            [29.09832945441147, -7.758622994557436],
            [29.097792972438963, -7.759163432134623],
            [29.09672532023222, -7.760238953503017],
            [29.096520597772233, -7.761129223758929],
            [29.09492820008213, -7.768053982597928],
            [29.102304239930604, -7.769392988491957],
            [29.104864248945823, -7.770904866337714],
            [29.105770320284083, -7.771439967738521],
            [29.107076692591061, -7.774009161959671],
            [29.107866239860588, -7.775561929104605],
            [29.111889822764255, -7.779349086536438],
            [29.112959520434917, -7.780355922491506],
            [29.112299280260654, -7.785868884287312],
            [29.109338124962047, -7.791209292806109],
            [29.109108239792626, -7.791623884230591],
            [29.098333440236388, -7.799945922621686],
            [29.095838279703237, -7.80684696293627],
            [29.098347348851952, -7.80857609911456],
            [29.100464280022933, -7.810034986307123],
            [29.101901990516041, -7.813798020214731],
            [29.102565240046484, -7.815533983237978],
            [29.102738611303071, -7.815631479440043],
            [29.104183386147561, -7.816443957942159],
            [29.104868850116691, -7.816279213591553],
            [29.105552159925779, -7.816114943979025],
            [29.105776659695067, -7.81606114420198],
            [29.108093400439742, -7.815505952739681],
            [29.109250464661688, -7.816503131012212],
            [29.10994520373611, -7.817102134687828],
            [29.109277643190602, -7.821466953752225],
            [29.111114553317858, -7.821731960737071],
            [29.113887240273232, -7.822131968506293],
            [29.114828263262591, -7.825340882760107],
            [29.114593121152126, -7.825781531084511],
            [29.113231508743365, -7.828333132574636],
            [29.11355468664998, -7.82861189866126],
            [29.11693535967785, -7.831527968976317],
            [29.116408796902693, -7.831843938194264],
            [29.108444400069029, -7.836623025189333],
            [29.107116594857665, -7.839608154545262],
            [29.106397439573833, -7.841224928825501],
            [29.106770021227813, -7.843144695960067],
            [29.107109507150103, -7.844893923654737],
            [29.110383083928077, -7.843604309817803],
            [29.111244480250651, -7.843264946040076],
            [29.113104239925484, -7.84623988675901],
            [29.111521257477921, -7.846805996712616],
            [29.109197519755451, -7.847637015546478],
            [29.10899520028887, -7.852689027758461],
            [29.111301359777837, -7.853364909688359],
            [29.112753237601275, -7.865293857181987],
            [29.108648519759466, -7.86914766714037],
            [29.096785439982604, -7.870631653647276],
            [29.089400760137746, -7.869049305818868],
            [29.079995400011342, -7.869654290721183],
            [29.070163439837966, -7.873024445002504],
            [29.054273040165846, -7.884265410794756],
            [29.039676839730337, -7.892302463904788],
            [29.024484839767453, -7.893648919543818],
            [29.020422599662165, -7.889730924007628],
            [29.025897480077603, -7.880115976820887],
            [29.027759400200686, -7.872546208702996],
            [29.016899639781499, -7.870245171326311],
            [29.002285079578183, -7.871008317431733],
            [28.995707840545005, -7.871427219298991],
            [28.973779920442187, -7.87282379641159],
            [28.967555519889689, -7.872257196613392],
            [28.962050040160712, -7.869797280328281],
            [28.9581278402217, -7.863987498728044],
            [28.954941637181513, -7.860641091864327],
            [28.949421240028936, -7.854843062786691],
            [28.944342719673052, -7.849617731371342],
            [28.937532240262861, -7.846288088373505],
            [28.914766919635369, -7.82888427729947],
            [28.909398239849445, -7.823368319412821],
            [28.903276629921621, -7.822541468235541],
            [28.903267439257949, -7.82299058436522],
            [28.90302975940682, -7.824080899268349],
            [28.902150343777961, -7.825100104221508],
            [28.902292952227647, -7.826071901754662],
            [28.90226973526913, -7.826233969016388],
            [28.902126576152195, -7.827233315198691],
            [28.902554399704549, -7.828608044803063],
            [28.902763171769855, -7.828997742067833],
            [28.903481350584979, -7.830338301672937],
            [28.904408301465413, -7.831215278230552],
            [28.905074794812368, -7.831819501054725],
            [28.906418482237946, -7.834030524633655],
            [28.908189620415055, -7.835341802457084],
            [28.907277215954025, -7.836572794321754],
            [28.906767342080212, -7.83825871098509],
            [28.905237723153764, -7.839784059346587],
            [28.905076710918877, -7.840533350339426],
            [28.905613419266853, -7.842138970955511],
            [28.904862027040711, -7.843316422143322],
            [28.904513166300113, -7.845269912380128],
            [28.904030128697123, -7.846902273496671],
            [28.901856459932766, -7.847169873515486],
            [28.900434181597923, -7.847624792519855],
            [28.898850891926529, -7.848507869200044],
            [28.898985068788917, -7.850728932419946],
            [28.898609372675864, -7.851772560068992],
            [28.89756279135241, -7.851210607118396],
            [28.896838234498759, -7.851745800464789],
            [28.896382032268225, -7.85278942552601],
            [28.896408868539051, -7.855117504006762],
            [28.895898994665238, -7.857793439146763],
            [28.894396211111282, -7.858221587183505],
            [28.892705579051619, -7.858328623898852],
            [28.890692922522181, -7.858837048810638],
            [28.889914694923547, -7.859800378586479],
            [28.889673176571179, -7.86137916390504],
            [28.889109631952447, -7.86325229242585],
            [28.888098375080887, -7.86485288133218],
            [28.88741900079108, -7.865928174424989],
            [28.88764017859047, -7.866224532530129],
            [28.888277734507163, -7.867078797787454],
            [28.888411911369591, -7.86884486539565],
            [28.889190138968193, -7.869754654770921],
            [28.889377986575571, -7.871547469141616],
            [28.888089886001453, -7.873393792039157],
            [28.887150646167964, -7.873955714550091],
            [28.885862545593849, -7.874250055031336],
            [28.884359762039892, -7.874972525816231],
            [28.883581534441259, -7.875775268540725],
            [28.883554699068767, -7.876604768566001],
            [28.884601280392221, -7.877327235189649],
            [28.88430609129491, -7.878531342196958],
            [28.882776471470159, -7.879334078828069],
            [28.882776471470159, -7.881608490121711],
            [28.882856978485904, -7.8825450086861],
            [28.882991155348332, -7.883561798581293],
            [28.882373940882911, -7.884391281903416],
            [28.883098496838265, -7.8856756411525],
            [28.883152167583216, -7.887548657479383],
            [28.882642294607738, -7.888859763973901],
            [28.881890903279924, -7.889742751670402],
            [28.881059004936336, -7.891562235335944],
            [28.881381029406111, -7.892418460241095],
            [28.881622548656768, -7.893221169569511],
            [28.880602802705805, -7.894799825804522],
            [28.87926103138674, -7.896030638882796],
            [28.878268120808269, -7.896592530243657],
            [28.877785082306946, -7.899054141861458],
            [28.87719470321402, -7.900552506288174],
            [28.876449256936731, -7.900552506288174],
            [28.876174957263053, -7.900552506288174],
            [28.875638248915077, -7.901542494063721],
            [28.875783950264275, -7.902236575805664],
            [28.875879767267406, -7.90269301798071],
            [28.876819007100927, -7.903442194640317],
            [28.876121286518071, -7.904753249135807],
            [28.87539672966442, -7.905422153742282],
            [28.874380694653894, -7.905788569519399],
            [28.874135464462793, -7.90587700792472],
            [28.873893946110464, -7.906545909789799],
            [28.873986155479425, -7.906787243203897],
            [28.874537995948337, -7.90823153894197],
            [28.875021033551331, -7.909515823092853],
            [28.874699009081557, -7.91029174297182],
            [28.87518204668455, -7.912432202575573],
            [28.875343058919469, -7.913903763141519],
            [28.874430654458408, -7.915188029391464],
            [28.873706097604757, -7.915883671357445],
            [28.873338411769083, -7.916381858212791],
            [28.872659516281296, -7.917301707926073],
            [28.872579010163854, -7.918264899722633],
            [28.874028122972859, -7.918987292520556],
            [28.87432371990532, -7.918992463000928],
            [28.875557742797636, -7.919014047718356],
            [28.877087361724083, -7.919816704625454],
            [28.877972930812621, -7.92040531826545],
            [28.878402297670657, -7.921422012789395],
            [28.87724837395897, -7.921823339063653],
            [28.876309134125449, -7.922625990423215],
            [28.8751283759396, -7.922599235463168],
            [28.873947616855414, -7.922358439847649],
            [28.873249895374261, -7.923749698946731],
            [28.872605845536345, -7.925007179292122],
            [28.870163822148868, -7.925676050592541],
            [28.869117239927082, -7.925595786309605],
            [28.868714708441534, -7.923615924498709],
            [28.86801698785867, -7.923455395102943],
            [28.866702051912096, -7.924284798089662],
            [28.866451686950821, -7.924742422823856],
            [28.86621901430911, -7.925167708970386],
            [28.866165343564127, -7.926318165180872],
            [28.866621545794654, -7.927281335607794],
            [28.867854393690564, -7.928146926018394],
            [28.868526860834155, -7.928619068721456],
            [28.8704053405012, -7.929582233691259],
            [28.870029644388143, -7.930759432715649],
            [28.868419519344226, -7.931802855679489],
            [28.867024077280199, -7.932578733014174],
            [28.86627268505406, -7.933568642828067],
            [28.865494457455426, -7.933568642828067],
            [28.865011419852433, -7.931883118735544],
            [28.864421040759506, -7.930598906143325],
            [28.863428130181035, -7.93078618713817],
            [28.862435219602531, -7.931508557671612],
            [28.861603321258944, -7.932498470095709],
            [28.861120283655957, -7.933381363117071],
            [28.861120283655957, -7.935682226623492],
            [28.860583574409684, -7.936511604632501],
            [28.859536993086223, -7.936939670009337],
            [28.859519743636124, -7.936957648120131],
            [28.8589466139933, -7.937555012805299],
            [28.859805347709379, -7.938598418293937],
            [28.86063946129844, -7.938795372422518],
            [28.862373240339522, -7.94164090003653],
            [28.859388480010185, -7.943032882937507],
            [28.858720320288377, -7.947626983395489],
            [28.854026639996864, -7.958361338085949],
            [28.842624360028147, -7.970316145035078],
            [28.830049560323022, -7.976455641888442],
            [28.807039800021876, -7.976657488531711],
            [28.790545320152138, -7.978006876419199],
            [28.779106679973964, -7.975707685466094],
            [28.770988319985442, -7.970200496029629],
            [28.765148039946702, -7.950142292777542],
            [28.758430800273114, -7.926594182977128],
            [28.747403999923485, -7.915565721428335],
            [28.726275960410945, -7.91590825125417],
            [28.720771560456942, -7.913885196468775],
            [28.712363040140058, -7.908086930915436],
            [28.708438474936923, -7.903760491705039],
            [28.704940560086367, -7.899904353606328],
            [28.690905960315337, -7.893010233168434],
            [28.678756319759451, -7.895658508832516],
            [28.670963553247329, -7.893223949785485],
            [28.65645035983902, -7.892603957576117],
            [28.658450519904537, -7.87795975397344],
            [28.671446880107855, -7.866871245454308],
            [28.682417160256438, -7.855787256656821],
            [28.687311359790758, -7.845590950171182],
            [28.6855487996263, -7.835410457694669],
            [28.668453479782134, -7.828177469535443],
            [28.658607479839183, -7.826164514057882],
            [28.648714320140446, -7.820791883839386],
            [28.650963141063144, -7.810450671493814],
            [28.644622919822737, -7.790404042115168],
            [28.637922239693111, -7.773249635735933],
            [28.628913239626229, -7.759010627194828],
            [28.622806559698429, -7.747965523623338],
            [28.62303587982754, -7.724388857904182],
            [28.629068760459791, -7.706618289325584],
            [28.629910799884613, -7.696428131726161],
            [28.632820295766173, -7.684726031130929],
            [28.62583642713312, -7.68013139520214],
            [28.618959321474943, -7.675607061934828],
            [28.612732320299678, -7.673339882682538],
            [28.609907399903779, -7.661184992251594],
            [28.603418399686024, -7.652948950543318],
            [28.599956462362627, -7.6513579959562],
            [28.595813557138069, -7.651836920160375],
            [28.594920136773936, -7.651130571564477],
            [28.592348400252707, -7.649096907441647],
            [28.581516706796236, -7.642673978994621],
            [28.580567759767774, -7.642111271893658],
            [28.571011920153158, -7.640387841616459],
            [28.562316120405061, -7.635459888174364],
            [28.548101159586199, -7.622684628315955],
            [28.533346560114961, -7.62534105923527],
            [28.522247399570865, -7.627149930748141],
            [28.52202851966199, -7.629446955901531],
            [28.520055194070636, -7.631433119277481],
            [28.51973747971757, -7.631752899716672],
            [28.509027835867208, -7.629270567864513],
            [28.506139428835276, -7.628601076878865],
            [28.503963746946358, -7.629480518959226],
            [28.501543440330877, -7.630459000837178],
            [28.494438264998482, -7.63602416003116],
            [28.493288280399298, -7.636924884037205],
            [28.485691198397102, -7.637188876468312],
            [28.480642200274723, -7.640426957768281],
            [28.479278519944177, -7.643877025722056],
            [28.480447440131211, -7.64754586307544],
            [28.477826538814476, -7.650467230152757],
            [28.474035480330535, -7.654692869522225],
            [28.471508128669161, -7.655622749188419],
            [28.470704670089148, -7.657856057270139],
            [28.470598222422929, -7.658151958212069],
            [28.473154145001917, -7.661478785701709],
            [28.475696487748753, -7.664787910560864],
            [28.474996834889701, -7.665806722772337],
            [28.473640255741511, -7.667781951590573],
            [28.470786728495412, -7.667990974763559],
            [28.466964360130568, -7.66827086288372],
            [28.463650970019167, -7.674442991341326],
            [28.461033083448484, -7.679319091112037],
            [28.441514879722302, -7.688050443523126],
            [28.42882559961571, -7.686244869979031],
            [28.422779040336618, -7.68625201398072],
            [28.413097559651423, -7.687477161866116],
            [28.407017159937244, -7.694159154578266],
            [28.397200680431176, -7.722082709034482],
            [28.377746280446335, -7.742734911361468],
            [28.368010079783947, -7.754880823584646],
            [28.355811840371221, -7.775523003894698],
            [28.360594080176721, -7.786437566970545],
            [28.36572623983653, -7.7879480996171],
            [28.371588200714609, -7.788084643732708],
            [28.37812103961658, -7.788236814390245],
            [28.386871919566342, -7.791563177378449],
            [28.404670320240651, -7.799428500916028],
            [28.417035959808256, -7.805480404592624],
            [28.425173039789001, -7.810627203325338],
            [28.431987479871289, -7.838219960103382],
            [28.444345199891352, -7.845787684052178],
            [28.470880800071956, -7.85970736271592],
            [28.483857000283681, -7.864544649054927],
            [28.503799560065261, -7.866947293378049],
            [28.51284239966887, -7.872395544513886],
            [28.526097959764286, -7.881781111117004],
            [28.529979120169532, -7.891480808884269],
            [28.527821259059234, -7.900314931900867],
            [28.526743814317598, -7.904725838270832],
            [28.526274360139986, -7.906647704092268],
            [28.515264120232612, -7.931525987913504],
            [28.503044279930581, -7.956404174555564],
            [28.495082160326156, -7.976424588480878],
            [28.479799080176598, -8.009186092404246],
            [28.456127280375664, -8.026797383473502],
            [28.439727120017501, -8.041367856416045],
            [28.42941347959551, -8.048049069484614],
            [28.429330680079143, -8.064418399376025],
            [28.426199760259827, -8.085640252662799],
            [28.426123080067189, -8.100795554225158],
            [28.430847000346127, -8.123218608798602],
            [28.43803584027253, -8.136545528183794],
            [28.439975465566004, -8.150654435255364],
            [28.440368640199551, -8.153514343628162],
            [28.432437119908659, -8.167464043210162],
            [28.422120600386172, -8.174749264376725],
            [28.408169519682051, -8.183250868154653],
            [28.39175999977693, -8.19963369795645],
            [28.356534720070222, -8.229976344787055],
            [28.338317279570372, -8.245147320069565],
            [28.327642326859657, -8.255046825817931],
            [28.312800839639159, -8.268809783112909],
            [28.30306715964943, -8.280333836764321],
            [28.289751840028064, -8.282773208767885],
            [28.272209760145358, -8.284005640053861],
            [28.263759479845866, -8.280986167957803],
            [28.262617560321324, -8.267657020180879],
            [28.262083679869843, -8.253720873920244],
            [28.238040941433589, -8.249891050319222],
            [28.231873559647116, -8.248908628281457],
            [28.219752359753137, -8.254376638618355],
            [28.203324480080234, -8.274392182217687],
            [28.185865329071277, -8.278783932950633],
            [28.183902421242262, -8.28096448656758],
            [28.182708456025122, -8.282290900433951],
            [28.174940279995578, -8.297141995418363],
            [28.164558240051228, -8.308369914696438],
            [28.161268199849015, -8.316701884348204],
            [28.131654959826907, -8.336882353329502],
            [28.115322120114421, -8.338113185368575],
            [28.108047599774562, -8.341756626136386],
            [28.101939119622944, -8.353880258720542],
            [28.097678880049241, -8.359337338768666],
            [28.094655239736127, -8.359340903887649],
            [28.083789359993215, -8.355719025648408],
            [28.06631459985789, -8.343623443383256],
            [28.062664920030006, -8.34786841354331],
            [28.072861919602207, -8.364212931566632],
            [28.089311400164444, -8.403916957560375],
            [28.081413360084174, -8.405999003502622],
            [28.075922592962932, -8.408984492533753],
            [28.070459280153411, -8.411955031546592],
            [28.066221039422729, -8.412158302176531],
            [28.062393479693856, -8.412341876460307],
            [28.055380266693721, -8.407654965896604],
            [28.043132399853111, -8.406515992593011],
            [28.038809187479682, -8.404391856479162],
            [28.030090319893386, -8.400107953372821],
            [28.020815280161873, -8.385818950383367],
            [28.007279176203255, -8.375910694020044],
            [28.005838287470677, -8.374855966482682],
            [28.004266165654862, -8.374426303986521],
            [27.9956363597408, -8.372067761120952],
            [27.990633240376582, -8.363895928826171],
            [27.987072674323198, -8.362273443299841],
            [27.984348383205457, -8.361031815090081],
            [27.985533800952687, -8.350850406461026],
            [27.985929473801061, -8.347451964596905],
            [27.981369360415847, -8.326412898218363],
            [27.977253480108335, -8.316387873922784],
            [27.979347129642107, -8.313298990336161],
            [27.985769279931397, -8.303823863132335],
            [27.986925946199623, -8.300056309930536],
            [27.989456399743705, -8.291813858719218],
            [27.988657200076435, -8.286318020858957],
            [27.990812519852781, -8.278698900787395],
            [27.989728854277779, -8.274895418793111],
            [27.989576279918364, -8.274359903869078],
            [27.988527493230897, -8.272886085505569],
            [27.985546440248747, -8.268696896744292],
            [27.986004161530403, -8.259035399107269],
            [27.986036390387866, -8.25835510228443],
            [27.983667250912632, -8.243244962166962],
            [27.984653280396035, -8.241181945731824],
            [27.98809631986083, -8.233975898151114],
            [27.985869719664997, -8.228595352402978],
            [27.981035279656627, -8.22799501263966],
            [27.971894159869375, -8.241943492360445],
            [27.971820359675498, -8.256486777262268],
            [27.968152320079835, -8.264368488930364],
            [27.960251760225209, -8.272255033344241],
            [27.915553799746384, -8.262612750711938],
            [27.910716120413113, -8.262618457222537],
            [27.904681799781443, -8.26020178591318],
            [27.900479520408201, -8.254147111524311],
            [27.898103879825264, -8.245666307922573],
            [27.890261280171096, -8.242039800301111],
            [27.8890271997866, -8.246889047738367],
            [27.881151119921775, -8.249928223939666],
            [27.87718715910183, -8.250654409098743],
            [27.874493280448021, -8.251147917634084],
            [27.86241780031045, -8.247526276375391],
            [27.851548680344301, -8.244509375207645],
            [27.833885280287529, -8.246309959432418],
            [27.832489200419634, -8.23347901015018],
            [27.836988479893812, -8.227654890577163],
            [27.840275279872795, -8.206469024621926],
            [27.839893650387246, -8.203373573634515],
            [27.839456280438366, -8.1998259775284],
            [27.840717359688725, -8.181205976447787],
            [27.833955840258142, -8.183168459158596],
            [27.827194319929262, -8.185130932076426],
            [27.818674200107992, -8.19768788643227],
            [27.807308280348725, -8.206164914270413],
            [27.801986400094155, -8.217283979467302],
            [27.795978193487809, -8.222911409405279],
            [27.789980400152249, -8.228529004513316],
            [27.787285800151274, -8.232366985493533],
            [27.784591200150295, -8.23620492879092],
            [27.776582280116191, -8.263906950628643],
            [27.77368932042237, -8.269470872670057],
            [27.763693919867883, -8.279151861690666],
            [27.751560120203742, -8.287043099252154],
            [27.743726880096496, -8.281599087742922],
            [27.752910839641366, -8.259168663483541],
            [27.760863959923267, -8.240980412542093],
            [27.757877400268441, -8.233712115671894],
            [27.747591480059487, -8.234936141333938],
            [27.735442559952503, -8.245858208710496],
            [27.721522080358508, -8.248298510837534],
            [27.730672559692753, -8.232532139863922],
            [27.751959360262092, -8.208266573649599],
            [27.790119554579629, -8.177971222846764],
            [27.793243799916375, -8.175490783368689],
            [27.819316079616183, -8.161519961789981],
            [27.837542879662958, -8.144527228774463],
            [27.853375320032946, -8.122687327872459],
            [27.847340640075171, -8.120269795649607],
            [27.831600359666801, -8.123925257257895],
            [27.81524303996455, -8.130006200542473],
            [27.80071199972647, -8.133660145410149],
            [27.771881399827642, -8.135876900355395],
            [27.768467179215502, -8.138965376110635],
            [27.76825548043902, -8.139156876089867],
            [27.762026399663874, -8.138812931917126],
            [27.749668320317671, -8.131004875199139],
            [27.745277400124678, -8.130396894025999],
            [27.740692440237044, -8.131628020289893],
            [27.725937479643012, -8.143607973738778],
            [27.717646753612712, -8.154133673201047],
            [27.716030280174699, -8.15618587429188],
            [27.708731640069445, -8.147103559604473],
            [27.708793199819237, -8.134980816734865],
            [27.72006432934975, -8.125117965874695],
            [27.725250239704582, -8.119054869162573],
            [27.730518479756903, -8.117352003033949],
            [27.733139687399149, -8.113495848249094],
            [27.737472240454903, -8.107121986378765],
            [27.739557359586737, -8.095375901755546],
            [27.744909479828699, -8.085864881517333],
            [27.76656383957128, -8.070656197205858],
            [27.77507244029567, -8.062158780201631],
            [27.781733159768216, -8.060332196456118],
            [27.788179320228387, -8.046730965694406],
            [27.796947480170946, -8.035319998214757],
            [27.807628320440042, -8.015379960214963],
            [27.814390200095062, -8.007449030069868],
            [27.824087519875345, -7.990006965161045],
            [27.827984520273979, -7.985631964635036],
            [27.832979519766333, -7.968168967399722],
            [27.834817860011533, -7.96712946201887],
            [27.836656200256705, -7.966089954859365],
            [27.841451400056833, -7.955972975617722],
            [27.841167359950528, -7.943120875298201],
            [27.845297095872969, -7.939203173632096],
            [27.846851994289835, -7.934330299174779],
            [27.847570320428684, -7.932078940499994],
            [27.854200408248371, -7.920347961326929],
            [27.851391360185254, -7.909340872601515],
            [27.852752507266683, -7.904515852748014],
            [27.848079359767596, -7.888235938706948],
            [27.831597120341904, -7.88563313458838],
            [27.807979456613253, -7.881269886051478],
            [27.806808240332337, -7.876682866784713],
            [27.808884692518312, -7.868454603145327],
            [27.809301202688026, -7.866803915812807],
            [27.806066280416683, -7.864290976775592],
            [27.806826821983996, -7.86198608064501],
            [27.806976349257994, -7.861532832041624],
            [27.806886019164594, -7.861069921284632],
            [27.806036399755399, -7.856715917524743],
            [27.809017183242954, -7.853720808278264],
            [27.808903244525567, -7.853252016886981],
            [27.807846479900046, -7.848903996344169],
            [27.802669806022969, -7.847501558055073],
            [27.801161280437697, -7.847092875072483],
            [27.789483600359095, -7.843224242792077],
            [27.782789399777599, -7.851724295498573],
            [27.774265320182558, -7.863258972061988],
            [27.747609839827263, -7.872995168882865],
            [27.734282279761853, -7.877863179945075],
            [27.72399924045002, -7.878481897534445],
            [27.706572185347859, -7.875321211141507],
            [27.704063160216574, -7.874866155396569],
            [27.692015400292028, -7.865782300948061],
            [27.680590799883465, -7.853058031243759],
            [27.639708120061922, -7.806397753061103],
            [27.633715219849684, -7.793489368479808],
            [27.630137520228857, -7.78578300206594],
            [27.630260280402339, -7.761515488589545],
            [27.626767200284668, -7.734823691801255],
            [27.631764360225244, -7.70326606609772],
            [27.641500559989332, -7.691118651308223],
            [27.673588091782253, -7.672847147977168],
            [27.669280770606207, -7.669722007125347],
            [27.666660240293673, -7.667820966616711],
            [27.665563320076664, -7.664487900808911],
            [27.661300376573962, -7.651537414698801],
            [27.6526231575792, -7.642765501056608],
            [27.650436480311207, -7.640555022473496],
            [27.638696997039361, -7.625808001240529],
            [27.632391422921138, -7.617886836989487],
            [27.631620360285218, -7.617555874783511],
            [27.627800400303627, -7.615913975355699],
            [27.626152723884235, -7.611939854062599],
            [27.624016440307052, -7.595183903571371],
            [27.619102440107245, -7.591487995887777],
            [27.618242400240753, -7.590840985387543],
            [27.615465360049551, -7.586946932741918],
            [27.614992333272049, -7.583734077016451],
            [27.608318777772443, -7.581541315822119],
            [27.594938159613072, -7.577144923289508],
            [27.593788906242523, -7.576100971064168],
            [27.59216723964386, -7.57462788655701],
            [27.587034239160932, -7.56274016962979],
            [27.586128259450813, -7.560641851040879],
            [27.597545640099469, -7.534585712399049],
            [27.59758559985826, -7.526694171283221],
            [27.593987776178455, -7.520627712072825],
            [27.586166674107321, -7.512745533185075],
            [27.575322036825938, -7.50486645391563],
            [27.552979363658132, -7.498822018526289],
            [27.528862250106254, -7.484887509936911],
            [27.520408949670784, -7.4824690888764],
            [27.510737113298497, -7.481873391581464],
            [27.50665638227138, -7.483014578572083],
            [27.499837258373226, -7.484921638453909],
            [27.502154937857405, -7.504952752030175],
            [27.503321337371748, -7.513450372688028],
            [27.497848259875113, -7.519527476252431],
            [27.484532942948675, -7.521971229455403],
            [27.463952108598157, -7.526244994345065],
            [27.442842287817882, -7.534025789833698],
            [27.443612833922504, -7.520739885902501],
            [27.443707873882918, -7.519096897557001],
            [27.441847034433113, -7.513361933642283],
            [27.443296658383531, -7.507781261993938],
            [27.444115753937687, -7.504627932001251],
            [27.44340310065984, -7.498659946009994],
            [27.444621114675478, -7.495795701787602],
            [27.447510913197814, -7.489000836542083],
            [27.446268636584669, -7.486980631281541],
            [27.444269113424667, -7.483728962360685],
            [27.445173080908553, -7.478674706620085],
            [27.440314100723274, -7.473475723055298],
            [27.439395668566689, -7.472493055294519],
            [27.437938526615664, -7.472767027247143],
            [27.436651179728109, -7.473009083239322],
            [27.433185076916704, -7.473660852673123],
            [27.430708585171764, -7.476010761704646],
            [27.429055826982825, -7.477578899133123],
            [27.423695422477302, -7.478265052500477],
            [27.419852840221903, -7.478756849885428],
            [27.416665882596881, -7.481292371197104],
            [27.414344840718602, -7.483138966274861],
            [27.412390991500889, -7.485454715747617],
            [27.406489063677512, -7.492449746120807],
            [27.40288280481716, -7.496723868763929],
            [27.397144046981968, -7.50064590188265],
            [27.392209793365769, -7.501346382618943],
            [27.391126205944218, -7.501500211451755],
            [27.388860191266971, -7.501821875384387],
            [27.381058889861329, -7.50873588692532],
            [27.368412093779469, -7.512679966493979],
            [27.364522456871178, -7.516742557849504],
            [27.362678015268589, -7.518668999834058],
            [27.361694737324889, -7.520257786374386],
            [27.356270017038309, -7.529022982202043],
            [27.354003747239517, -7.53890488370009],
            [27.333280908107199, -7.537932824615051],
            [27.319370026113727, -7.538556328129002],
            [27.307865509780843, -7.541605074868692],
            [27.304234066651503, -7.542216427133085],
            [27.285413285267509, -7.541414718712812],
            [27.282640567769405, -7.538552097783649],
            [27.279869399865195, -7.53569088483532],
            [27.280546188803619, -7.532014976401372],
            [27.278688275166694, -7.527198083726172],
            [27.274754826523697, -7.524807554691691],
            [27.268537319642686, -7.521028986680856],
            [27.267158051745341, -7.516213342944177],
            [27.265974480036011, -7.512080919600057],
            [27.264051175334604, -7.510174655324087],
            [27.260200439969719, -7.506358011450104],
            [27.25556723965299, -7.498104853655827],
            [27.251184239905836, -7.495361865459711],
            [27.250508367249015, -7.49529164038135],
            [27.244737359895119, -7.494692017852423],
            [27.237360240271702, -7.491040980528974],
            [27.236216217791053, -7.489379551183477],
            [27.233888399920602, -7.485998910614351],
            [27.227675520261577, -7.495563766194355],
            [27.225173880180261, -7.511957640287049],
            [27.219025799595961, -7.531997497160655],
            [27.220164479795603, -7.545957808515696],
            [27.225539279803549, -7.559305440061889],
            [27.221834160447898, -7.574484438060233],
            [27.219329640367786, -7.591482279043338],
            [27.222276240263827, -7.606652267646008],
            [27.225278279687632, -7.610897316677748],
            [27.21498011993296, -7.614550900768745],
            [27.190789560123427, -7.615186442908086],
            [27.13996188062471, -7.621922454891621],
            [27.121466973889817, -7.626471352764415],
            [27.087893999621176, -7.634728637702589],
            [27.054479675018225, -7.62937397094047],
            [27.054059039784772, -7.629306563380493],
            [27.029859479754425, -7.63176272354374],
            [26.997181559885405, -7.636656426361209],
            [26.980967207958908, -7.634197330790831],
            [26.969387400228801, -7.632441108394847],
            [26.955562319921395, -7.625717945375676],
            [26.954675280290708, -7.636740911539344],
            [26.950506470348319, -7.635241642614389],
            [26.949606479706215, -7.634917969733539],
            [26.945348829077147, -7.635388334660371],
            [26.941089239883741, -7.635858913265086],
            [26.934311893934492, -7.638164271747534],
            [26.924761439720005, -7.641412898692041],
            [26.906101199853691, -7.637558963904012],
            [26.898811022776719, -7.63740438659002],
            [26.886760199597074, -7.637148865567223],
            [26.872138912808925, -7.633069710846994],
            [26.865562319664427, -7.631234911872968],
            [26.85738751583164, -7.629951530770017],
            [26.855823239901508, -7.629705950999831],
            [26.848287360119624, -7.628522967855045],
            [26.842642761895888, -7.62877226151499],
            [26.837238240228444, -7.629010951391854],
            [26.828941342772126, -7.628144929834358],
            [26.823963309760583, -7.627625326981689],
            [26.818916829615933, -7.627098578483455],
            [26.815687043911399, -7.626761455407163],
            [26.80796916006306, -7.625955866190908],
            [26.81446571960392, -7.596816059633279],
            [26.822974320328306, -7.588308667350472],
            [26.826640919924589, -7.580717338712659],
            [26.82605916016681, -7.576165799268252],
            [26.811095399659727, -7.575728310212999],
            [26.809015680301044, -7.568446881708967],
            [26.808770880402985, -7.557066274883016],
            [26.808257880392006, -7.551212302920681],
            [26.80299828033607, -7.544996657179043],
            [26.794257120157706, -7.539695635971277],
            [26.78475384007206, -7.535609416741025],
            [26.775392040152077, -7.533495901536741],
            [26.763742215932101, -7.535330831384268],
            [26.752801065453227, -7.546573428739509],
            [26.744921027611255, -7.550376560703483],
            [26.736152974568217, -7.550386914408797],
            [26.711005433198324, -7.530991991384545],
            [26.698811885686304, -7.522804803039839],
            [26.696929607942266, -7.526536694769176],
            [26.696664115351599, -7.527063089163573],
            [26.701140971977956, -7.533131706380855],
            [26.699082955916548, -7.53749994352601],
            [26.69341154747314, -7.543703962219136],
            [26.691509276824135, -7.545784857677087],
            [26.686577302233808, -7.546174671979883],
            [26.685523917070402, -7.546257929133235],
            [26.682310101614995, -7.549020929519211],
            [26.675489250256518, -7.547903597436171],
            [26.674565165900162, -7.547752225358449],
            [26.671254994452429, -7.547209986919816],
            [26.670450158755099, -7.547556125822712],
            [26.668035120758763, -7.54859487431844],
            [26.661142226311132, -7.552973856452349],
            [26.653642682484183, -7.544566088883886],
            [26.651098923992453, -7.539409415543368],
            [26.650073643521004, -7.532885056745648],
            [26.649690243456075, -7.51907528945079],
            [26.651130242856492, -7.510973886039339],
            [26.647670210859804, -7.508914922120176],
            [26.63040510493537, -7.508265998748889],
            [26.625014276287811, -7.503737460253039],
            [26.621407960833647, -7.500707971260691],
            [26.618902263062175, -7.50052150131318],
            [26.612428166793297, -7.500039864083738],
            [26.601588834063673, -7.491746680481672],
            [26.596880052193889, -7.488143913776543],
            [26.59605206152181, -7.487510396835638],
            [26.587288213492585, -7.480804890106551],
            [26.586357245346203, -7.477133076022183],
            [26.584361068410651, -7.475349299294609],
            [26.581861816949687, -7.47311606033376],
            [26.577129014129213, -7.468886972410005],
            [26.570911027547822, -7.467292923954619],
            [26.549270132653, -7.466191868427463],
            [26.544923680863189, -7.464721509061361],
            [26.543148212806404, -7.464120898055721],
            [26.539825101127011, -7.462996953916179],
            [26.537375857081269, -7.460776226888987],
            [26.534519060865865, -7.458185958564697],
            [26.533958059377685, -7.457073526816096],
            [26.530586061380514, -7.450387007453107],
            [26.528496981576577, -7.443730849186891],
            [26.52787814116051, -7.432861274632206],
            [26.527294221852781, -7.422604836263917],
            [26.526687955155722, -7.421343780339818],
            [26.524977982368014, -7.417786959197503],
            [26.522694087623346, -7.416051462947321],
            [26.521593175293201, -7.415214893387242],
            [26.521059022652238, -7.414808997355781],
            [26.518985351650379, -7.414184399226584],
            [26.517791982016242, -7.413824950866595],
            [26.515760183286389, -7.41321296355371],
            [26.510456215438605, -7.40840196151889],
            [26.498028105229519, -7.408657853113839],
            [26.497588741020682, -7.408396114006298],
            [26.496885839853558, -7.407977287167244],
            [26.495722146963168, -7.407284040499334],
            [26.494426434963643, -7.407841386373093],
            [26.490894267351333, -7.409360904999557],
            [26.487462471200644, -7.412801648620431],
            [26.484007108646804, -7.416265992259169],
            [26.483628548704601, -7.419739181985291],
            [26.483331028479153, -7.422468843201989],
            [26.482991902781301, -7.423354569649317],
            [26.482186938624857, -7.425456776554364],
            [26.479938107820686, -7.425806559789725],
            [26.479479431629883, -7.42587786860268],
            [26.47919606975162, -7.425921922692754],
            [26.479201106605412, -7.427872827538005],
            [26.479206149747416, -7.429826014616094],
            [26.478584823692952, -7.430448639972332],
            [26.47553190369144, -7.433507922755865],
            [26.471388030981348, -7.432827997424598],
            [26.465548471391482, -7.402419430780046],
            [26.460802952019836, -7.38420812112174],
            [26.454513752392639, -7.372374231897725],
            [26.449703793272402, -7.3669145282898],
            [26.443983754531089, -7.362063148497314],
            [26.43463272002149, -7.357823355708915],
            [26.427673955707359, -7.358742539415026],
            [26.421908197209671, -7.363000221009905],
            [26.421852756783572, -7.37393091790016],
            [26.428432115840831, -7.388193547103346],
            [26.436239435060568, -7.398810685139466],
            [26.438311234871669, -7.407612948334852],
            [26.433733115654935, -7.416119096874804],
            [26.424044374785634, -7.418862928060463],
            [26.4176997976144, -7.417959767766555],
            [26.410825598904463, -7.40218049273838],
            [26.396173506190284, -7.370014178528597],
            [26.387707842241529, -7.370024179632823],
            [26.372871595792404, -7.374292421430656],
            [26.358158360146714, -7.339121131078189],
            [26.352377279983536, -7.32718898425163],
            [26.352600479890622, -7.324202898178734],
            [26.359480440394776, -7.313852967597218],
            [26.364282479967432, -7.300980949030214],
            [26.367780731686231, -7.296421525073574],
            [26.368871399628873, -7.295000000646102],
            [26.370237790176596, -7.289256711633972],
            [26.371605178752624, -7.283509151959383],
            [26.37847723767554, -7.269943001250654],
            [26.379149528749334, -7.269481932473878],
            [26.382843359875128, -7.266948935794171],
            [26.383299480358957, -7.264880953622303],
            [26.380991519747845, -7.262357994316251],
            [26.376848285739918, -7.261906959785819],
            [26.377954199889562, -7.243068943311045],
            [26.380894045352992, -7.238644848077529],
            [26.381622240383553, -7.237548999574783],
            [26.382301190668564, -7.232723886234043],
            [26.379987691045415, -7.226985708518969],
            [26.382190722143132, -7.224977051042286],
            [26.3825130682098, -7.224683145088612],
            [26.383673236111015, -7.221452168251686],
            [26.385484319673889, -7.216407891518485],
            [26.385704100592953, -7.213245777631895],
            [26.385931596243726, -7.209974533171618],
            [26.394469305078264, -7.190142241370743],
            [26.407211278562794, -7.160542210265038],
            [26.457151320152828, -7.152048746711844],
            [26.469187920306624, -7.144261729142141],
            [26.470853280062382, -7.132961659158093],
            [26.475514199693816, -7.117092482905493],
            [26.481477960354869, -7.102920409801238],
            [26.477519039981974, -7.090447032119433],
            [26.485657614759351, -7.061822726209966],
            [26.473455359877299, -7.057713964701797],
            [26.468691520263746, -7.055524671036077],
            [26.458025399788919, -7.05062285657313],
            [26.443352382616816, -7.044636275691757],
            [26.43885100018657, -7.041840000773008],
            [26.433838440427053, -7.038725936796178],
            [26.428960044055213, -7.038127012329477],
            [26.419111200046085, -7.036917861039082],
            [26.416050630889924, -7.039429149182303],
            [26.41405824035327, -7.041063957917499],
            [26.413377479962978, -7.045200000802311],
            [26.399861279976115, -7.051800065045167],
            [26.39019059973559, -7.050899899865137],
            [26.378704799801632, -7.050305929050509],
            [26.36298288005937, -7.050324529408368],
            [26.338753440266068, -7.043668462502796],
            [26.314981560057639, -7.02121096617643],
            [26.298394199777402, -7.01302605527733],
            [26.287016399798489, -7.036623997022204],
            [26.278855560276813, -7.043213095099477],
            [26.269800480229122, -7.043914746204374],
            [26.26158852027956, -7.040853443618356],
            [26.24534571870802, -7.034758078128066],
            [26.234791200432497, -7.03079728685586],
            [26.226074520243937, -7.013882651511173],
            [26.22386412026593, -7.003779218815919],
            [26.217814680089713, -6.993992173747271],
            [26.215339680446451, -6.98998768006228],
            [26.213199480214655, -6.986524615454143],
            [26.214927359120939, -6.980785325598597],
            [26.218143360177447, -6.978251972451239],
            [26.21981613911916, -6.971659901900178],
            [26.220651477111968, -6.968367792492823],
            [26.220386169574269, -6.951366512875505],
            [26.216813520281992, -6.942922667424938],
            [26.203513320205143, -6.942330525058463],
            [26.188991640412322, -6.944171172092033],
            [26.176292999860475, -6.944186199609653],
            [26.150311800347346, -6.961962409413298],
            [26.135210879672812, -6.961313762299342],
            [26.116665480432395, -6.961871712779167],
            [26.108466839803562, -6.961327715714691],
            [26.101558080209696, -6.959964052595074],
            [26.094320280303688, -6.947444926994794],
            [26.098402320176174, -6.941243021246059],
            [26.102346480330592, -6.935253920227262],
            [26.10923556412477, -6.929957753964669],
            [26.113863960251354, -6.921544067131332],
            [26.113401360219395, -6.91566169809853],
            [26.108629200409691, -6.91055338700749],
            [26.089634879784153, -6.907747218474579],
            [26.072801639830846, -6.905813215227829],
            [26.052497279975345, -6.900049445726845],
            [26.04078972013372, -6.888540478124026],
            [26.038152359884361, -6.879267365915953],
            [26.045009999948633, -6.870977427812988],
            [26.068274279919237, -6.865454598337582],
            [26.075594520015503, -6.863047341956541],
            [26.081587079766241, -6.854324290266127],
            [26.079799320061436, -6.842544906804971],
            [26.086665960346533, -6.835933457204692],
            [26.09483724008847, -6.819355667802876],
            [26.094880440070487, -6.810843499436761],
            [26.111849400191836, -6.814096532892506],
            [26.134774559854471, -6.81383634839647],
            [26.133573240130055, -6.795258905120788],
            [26.130167383731521, -6.794964140763152],
            [26.12575115979358, -6.794581932755706],
            [26.120456280201541, -6.79137386081577],
            [26.112869279991767, -6.793224942022866],
            [26.10657819659739, -6.790698850299282],
            [26.10090035980982, -6.788418986953396],
            [26.090784338868868, -6.789584761002152],
            [26.085443039732812, -6.763731687650751],
            [26.060370119616941, -6.759504921592306],
            [26.037040320122774, -6.750806628865855],
            [26.033794856121595, -6.742821950573444],
            [26.032232879878599, -6.73897903770691],
            [26.034307559688532, -6.723476928104513],
            [26.031663719891011, -6.712940913598276],
            [26.01051875971174, -6.711360500241277],
            [26.006155919956182, -6.702057613362586],
            [26.011661711400546, -6.68282763176467],
            [26.011809088107757, -6.682222259400861],
            [26.01461684439348, -6.670696268547764],
            [26.017114163578292, -6.653518814274552],
            [26.010603204941688, -6.645861858343507],
            [25.999704925661458, -6.624281212149424],
            [25.991021366357412, -6.61365119997261],
            [25.983650007629915, -6.606400532562391],
            [25.965945192543558, -6.602772302803529],
            [25.952145281233761, -6.60340280598809],
            [25.934451406729284, -6.601874322222607],
            [25.934389052868756, -6.59011505053916],
            [25.93734429276121, -6.577981325663766],
            [25.934237852931734, -6.561555427470458],
            [25.930319973889226, -6.554776475734931],
            [25.941914132205998, -6.544872948014579],
            [25.947911371281052, -6.536984037029362],
            [25.948442667279444, -6.527970843783551],
            [25.949098651235861, -6.516842132432363],
            [25.943652931032897, -6.465935561369314],
            [25.945783120439174, -6.460927260300444],
            [25.960893019774971, -6.463256995126903],
            [25.975564716423605, -6.464319783494987],
            [25.984617326104246, -6.46319717986108],
            [25.985012966613258, -6.456482245558783],
            [25.98106592735834, -6.444240303888123],
            [25.984010366806125, -6.430002521210411],
            [25.987859543594013, -6.423759608289681],
            [25.995635485559163, -6.425978103433782],
            [26.000836764291876, -6.430678029998906],
            [26.010356271544822, -6.436283508953674],
            [26.024145322222843, -6.433552512443725],
            [26.040488959685035, -6.424558839585017],
            [26.051236038129911, -6.41758048411072],
            [26.055509958147081, -6.410083559531251],
            [26.059697117077448, -6.386200864097545],
            [26.06353075750247, -6.377016316656742],
            [26.096932273027775, -6.330887423129274],
            [26.105068631661347, -6.319666311792425],
            [26.116496143509774, -6.295480555534438],
            [26.133456787926523, -6.259582387365588],
            [26.143193347016719, -6.242569765278502],
            [26.163707944089758, -6.232043278929233],
            [26.190242100677725, -6.213415153550056],
            [26.201478778918755, -6.193970429920291],
            [26.206666656584066, -6.181918038469266],
            [26.212639496517681, -6.168041690352955],
            [26.217827816154102, -6.15426622236877],
            [26.217751496185898, -6.147782680479033],
            [26.198326618434571, -6.1210298791382],
            [26.190950219259989, -6.111301234459009],
            [26.187348060310629, -6.09752105489679],
            [26.187582419090155, -6.084957858270733],
            [26.194739218805317, -6.076044306060626],
            [26.204981937235598, -6.069563567017858],
            [26.219868655528977, -6.067947805616171],
            [26.234387453526377, -6.067547805849862],
            [26.255031179828222, -6.035536577344121],
            [26.222572995962583, -6.037956568130526],
            [26.212607456306444, -6.035521144630259],
            [26.202182937727279, -6.026600492101996],
            [26.186002019299021, -6.015650831445321],
            [26.182552500286096, -6.014838926285792],
            [26.182366380139005, -5.999030735056417],
            [26.186126219471884, -5.993762668593788],
            [26.202885656536356, -5.988904645472111],
            [26.211996176111818, -5.983638452332895],
            [26.215006135981465, -5.979586023454734],
            [26.205924416394051, -5.954855494818851],
            [26.196971578100442, -5.941069498203334],
            [26.192714896753571, -5.936608635004214],
            [26.18395797832849, -5.939443086040147],
            [26.177771340255575, -5.933360128914182],
            [26.173170900598958, -5.89971012895171],
            [26.177036219214159, -5.870926321338463],
            [26.186820658509017, -5.857955905215222],
            [26.205218455565081, -5.84620449666259],
            [26.208178375680184, -5.837893720160905],
            [26.207263615836464, -5.825121362297418],
            [26.202940016289148, -5.814982905936282],
            [26.197121337139752, -5.807682177527585],
            [26.189350737455577, -5.796933962369684],
            [26.184353938637734, -5.778279277196662],
            [26.184248818681489, -5.769358193532392],
            [26.184290277728497, -5.761777155098949],
            [26.175858191008452, -5.757632557643458],
            [26.17211739955286, -5.755793903849907],
            [26.167503060263854, -5.753525893738848],
            [26.166984579631318, -5.753092180213267],
            [26.164993697366025, -5.751426802853463],
            [26.1603710288977, -5.747559919021202],
            [26.154293979001263, -5.747779757975055],
            [26.153709368889061, -5.747800898788497],
            [26.131014904676228, -5.733187740001955],
            [26.123600345966715, -5.724862907195186],
            [26.124684665515236, -5.710854911836981],
            [26.126546584740019, -5.691941819130325],
            [26.120629625406977, -5.682917684521801],
            [26.103601267780714, -5.659804345660182],
            [26.108133667241077, -5.651551608887976],
            [26.117701025952577, -5.634320481686128],
            [26.118019985370623, -5.623245411761124],
            [26.119111800461887, -5.60800370164162],
            [26.124392704963054, -5.599523955968206],
            [26.128628132170295, -5.598898351757047],
            [26.136834303376165, -5.600103117022042],
            [26.147530904586937, -5.601127980868152],
            [26.151029101508442, -5.599004880866325],
            [26.152558021545612, -5.593380399422392],
            [26.15685570020538, -5.582903629783337],
            [26.161865820140612, -5.577864991816397],
            [26.172129778337464, -5.568532695108871],
            [26.175677938656801, -5.558528130327787],
            [26.173711917267013, -5.554534324539818],
            [26.161270079902042, -5.553955124210139],
            [26.151645061027413, -5.540888106692634],
            [26.15140550100239, -5.53625134241574],
            [26.150536261489091, -5.519426614806482],
            [26.136939063107977, -5.504774621530546],
            [26.136511383286049, -5.493676987085154],
            [26.13466350293254, -5.470962260324816],
            [26.13277206327087, -5.455143814468959],
            [26.13286710323132, -5.440117226896391],
            [26.122797544055178, -5.418658704120946],
            [26.117683384837044, -5.4007816023156],
            [26.111864704789316, -5.376232058931106],
            [26.108688066111959, -5.348803859790757],
            [26.109768537277812, -5.345595343824078],
            [26.111086024439778, -5.341682972045875],
            [26.112833211734809, -5.33885521212656],
            [26.116350334362732, -5.333162930636847],
            [26.117656476701022, -5.332111929567881],
            [26.123404534794332, -5.327486991235599],
            [26.126663222894816, -5.324865005297138],
            [26.126905513798313, -5.32405823402645],
            [26.128473803401114, -5.318836182524174],
            [26.128944182843437, -5.317269914164672],
            [26.133104978016856, -5.312486051567067],
            [26.13375306039207, -5.311740916589395],
            [26.133744063764507, -5.307372136309328],
            [26.133735061747025, -5.303000933985435],
            [26.138988181356499, -5.289878884346654],
            [26.139136438412667, -5.288643018001741],
            [26.141472181220582, -5.269171988123935],
            [26.145815226598831, -5.260193004710175],
            [26.147480885493586, -5.258474622676578],
            [26.151344508089565, -5.254488966684396],
            [26.154748979285909, -5.250976943381279],
            [26.157000381966732, -5.249892757847541],
            [26.158251784564861, -5.249290132350751],
            [26.165298057364076, -5.245896915273638],
            [26.166282003654345, -5.244797173996764],
            [26.166602965417152, -5.24443844038148],
            [26.166723297444417, -5.244303946627977],
            [26.167283870436215, -5.243677427187184],
            [26.168782722064172, -5.242002244604777],
            [26.16942005699531, -5.241289928589694],
            [26.172868813338567, -5.239900431355812],
            [26.176018666949108, -5.238631357745444],
            [26.176299960905617, -5.238517993040104],
            [26.179598413830451, -5.234767687549284],
            [26.18156825575516, -5.232527944745485],
            [26.182279636120217, -5.231128962970905],
            [26.185927645081698, -5.223954836871203],
            [26.191169093778985, -5.213646929815285],
            [26.194042360605138, -5.205213976928778],
            [26.196188213036702, -5.198915887814212],
            [26.198000093405206, -5.187640867084575],
            [26.19765574041071, -5.182412888296345],
            [26.197288013252507, -5.176829979156127],
            [26.194775948222343, -5.171818705231995],
            [26.192736718628467, -5.167750653045728],
            [26.191757286372511, -5.165796898933174],
            [26.194460212857848, -5.140947844094865],
            [26.191693973111281, -5.135891867456772],
            [26.191335053036156, -5.131006018943964],
            [26.191281243950616, -5.130270484804213],
            [26.191223472396381, -5.129480773636458],
            [26.191221238286268, -5.129451094688119],
            [26.194135902175663, -5.113586946989273],
            [26.198028172046048, -5.092400934666755],
            [26.199801728487873, -5.088616429789486],
            [26.201333022772339, -5.085348856347839],
            [26.201912212450086, -5.084112941733784],
            [26.224793349273927, -5.062532604338368],
            [26.251595317902567, -5.037253406891599],
            [26.252988959742773, -5.035938982661298],
            [26.257202084476443, -5.029374008046916],
            [26.262834231152041, -5.020598941406786],
            [26.265110202755881, -5.01705287050628],
            [26.265464261148718, -5.016179793934931],
            [26.269218162617548, -5.006922931261943],
            [26.270477074233145, -4.999999962020482],
            [26.279764161270933, -5.001118464040816],
            [26.313480645897776, -5.001040224348539],
            [26.387572140039765, -5.000868293924846],
            [26.467842712033264, -5.000682024127681],
            [26.487654607365197, -5.000636050350843],
            [26.569757967117109, -5.000445531928902],
            [26.596110885003213, -5.000384382782668],
            [26.617061906099185, -5.000335770301867],
            [26.735795784648303, -5.000060253563275],
            [26.943835842458192, -4.999577505756718],
            [26.952442483516034, -4.999557534084389],
            [26.954550148564891, -4.999552648596539],
            [26.956885849151973, -4.999547218975322],
            [26.958055373905218, -4.999544502813391],
            [26.968362159283256, -4.999520568156088],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Lubumbashi",
        AREA: 132425,
        POPULATION: 4617000,
        DISTRICTS: [
          "Mitwaba",
          "Sakania",
          "Kambove",
          "Kipushi",
          "Kasenga",
          "Pweto",
        ],
        OBJECTID: 4,
        NOM: "Haut-Katanga",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.548101159586199, -7.622684628315955],
            [28.562316120405061, -7.635459888174364],
            [28.571011920153158, -7.640387841616459],
            [28.580567759767774, -7.642111271893658],
            [28.581516706796236, -7.642673978994621],
            [28.592348400252707, -7.649096907441647],
            [28.594920136773936, -7.651130571564477],
            [28.595813557138069, -7.651836920160375],
            [28.599956462362627, -7.6513579959562],
            [28.603418399686024, -7.652948950543318],
            [28.609907399903779, -7.661184992251594],
            [28.612732320299678, -7.673339882682538],
            [28.618959321474943, -7.675607061934828],
            [28.62583642713312, -7.68013139520214],
            [28.632820295766173, -7.684726031130929],
            [28.629910799884613, -7.696428131726161],
            [28.629068760459791, -7.706618289325584],
            [28.62303587982754, -7.724388857904182],
            [28.622806559698429, -7.747965523623338],
            [28.628913239626229, -7.759010627194828],
            [28.637922239693111, -7.773249635735933],
            [28.644622919822737, -7.790404042115168],
            [28.650963141063144, -7.810450671493814],
            [28.648714320140446, -7.820791883839386],
            [28.658607479839183, -7.826164514057882],
            [28.668453479782134, -7.828177469535443],
            [28.6855487996263, -7.835410457694669],
            [28.687311359790758, -7.845590950171182],
            [28.682417160256438, -7.855787256656821],
            [28.671446880107855, -7.866871245454308],
            [28.658450519904537, -7.87795975397344],
            [28.65645035983902, -7.892603957576117],
            [28.670963553247329, -7.893223949785485],
            [28.678756319759451, -7.895658508832516],
            [28.690905960315337, -7.893010233168434],
            [28.704940560086367, -7.899904353606328],
            [28.708438474936923, -7.903760491705039],
            [28.712363040140058, -7.908086930915436],
            [28.720771560456942, -7.913885196468775],
            [28.726275960410945, -7.91590825125417],
            [28.747403999923485, -7.915565721428335],
            [28.758430800273114, -7.926594182977128],
            [28.765148039946702, -7.950142292777542],
            [28.770988319985442, -7.970200496029629],
            [28.779106679973964, -7.975707685466094],
            [28.790545320152138, -7.978006876419199],
            [28.807039800021876, -7.976657488531711],
            [28.830049560323022, -7.976455641888442],
            [28.842624360028147, -7.970316145035078],
            [28.854026639996864, -7.958361338085949],
            [28.858720320288377, -7.947626983395489],
            [28.859388480010185, -7.943032882937507],
            [28.862373240339522, -7.94164090003653],
            [28.86063946129844, -7.938795372422518],
            [28.859805347709379, -7.938598418293937],
            [28.8589466139933, -7.937555012805299],
            [28.859519743636124, -7.936957648120131],
            [28.859536993086223, -7.936939670009337],
            [28.860583574409684, -7.936511604632501],
            [28.861120283655957, -7.935682226623492],
            [28.861120283655957, -7.933381363117071],
            [28.861603321258944, -7.932498470095709],
            [28.862435219602531, -7.931508557671612],
            [28.863428130181035, -7.93078618713817],
            [28.864421040759506, -7.930598906143325],
            [28.865011419852433, -7.931883118735544],
            [28.865494457455426, -7.933568642828067],
            [28.86627268505406, -7.933568642828067],
            [28.867024077280199, -7.932578733014174],
            [28.868419519344226, -7.931802855679489],
            [28.870029644388143, -7.930759432715649],
            [28.8704053405012, -7.929582233691259],
            [28.868526860834155, -7.928619068721456],
            [28.867854393690564, -7.928146926018394],
            [28.866621545794654, -7.927281335607794],
            [28.866165343564127, -7.926318165180872],
            [28.86621901430911, -7.925167708970386],
            [28.866451686950821, -7.924742422823856],
            [28.866702051912096, -7.924284798089662],
            [28.86801698785867, -7.923455395102943],
            [28.868714708441534, -7.923615924498709],
            [28.869117239927082, -7.925595786309605],
            [28.870163822148868, -7.925676050592541],
            [28.872605845536345, -7.925007179292122],
            [28.873249895374261, -7.923749698946731],
            [28.873947616855414, -7.922358439847649],
            [28.8751283759396, -7.922599235463168],
            [28.876309134125449, -7.922625990423215],
            [28.87724837395897, -7.921823339063653],
            [28.878402297670657, -7.921422012789395],
            [28.877972930812621, -7.92040531826545],
            [28.877087361724083, -7.919816704625454],
            [28.875557742797636, -7.919014047718356],
            [28.87432371990532, -7.918992463000928],
            [28.874028122972859, -7.918987292520556],
            [28.872579010163854, -7.918264899722633],
            [28.872659516281296, -7.917301707926073],
            [28.873338411769083, -7.916381858212791],
            [28.873706097604757, -7.915883671357445],
            [28.874430654458408, -7.915188029391464],
            [28.875343058919469, -7.913903763141519],
            [28.87518204668455, -7.912432202575573],
            [28.874699009081557, -7.91029174297182],
            [28.875021033551331, -7.909515823092853],
            [28.874537995948337, -7.90823153894197],
            [28.873986155479425, -7.906787243203897],
            [28.873893946110464, -7.906545909789799],
            [28.874135464462793, -7.90587700792472],
            [28.874380694653894, -7.905788569519399],
            [28.87539672966442, -7.905422153742282],
            [28.876121286518071, -7.904753249135807],
            [28.876819007100927, -7.903442194640317],
            [28.875879767267406, -7.90269301798071],
            [28.875783950264275, -7.902236575805664],
            [28.875638248915077, -7.901542494063721],
            [28.876174957263053, -7.900552506288174],
            [28.876449256936731, -7.900552506288174],
            [28.87719470321402, -7.900552506288174],
            [28.877785082306946, -7.899054141861458],
            [28.878268120808269, -7.896592530243657],
            [28.87926103138674, -7.896030638882796],
            [28.880602802705805, -7.894799825804522],
            [28.881622548656768, -7.893221169569511],
            [28.881381029406111, -7.892418460241095],
            [28.881059004936336, -7.891562235335944],
            [28.881890903279924, -7.889742751670402],
            [28.882642294607738, -7.888859763973901],
            [28.883152167583216, -7.887548657479383],
            [28.883098496838265, -7.8856756411525],
            [28.882373940882911, -7.884391281903416],
            [28.882991155348332, -7.883561798581293],
            [28.882856978485904, -7.8825450086861],
            [28.882776471470159, -7.881608490121711],
            [28.882776471470159, -7.879334078828069],
            [28.88430609129491, -7.878531342196958],
            [28.884601280392221, -7.877327235189649],
            [28.883554699068767, -7.876604768566001],
            [28.883581534441259, -7.875775268540725],
            [28.884359762039892, -7.874972525816231],
            [28.885862545593849, -7.874250055031336],
            [28.887150646167964, -7.873955714550091],
            [28.888089886001453, -7.873393792039157],
            [28.889377986575571, -7.871547469141616],
            [28.889190138968193, -7.869754654770921],
            [28.888411911369591, -7.86884486539565],
            [28.888277734507163, -7.867078797787454],
            [28.88764017859047, -7.866224532530129],
            [28.88741900079108, -7.865928174424989],
            [28.888098375080887, -7.86485288133218],
            [28.889109631952447, -7.86325229242585],
            [28.889673176571179, -7.86137916390504],
            [28.889914694923547, -7.859800378586479],
            [28.890692922522181, -7.858837048810638],
            [28.892705579051619, -7.858328623898852],
            [28.894396211111282, -7.858221587183505],
            [28.895898994665238, -7.857793439146763],
            [28.896408868539051, -7.855117504006762],
            [28.896382032268225, -7.85278942552601],
            [28.896838234498759, -7.851745800464789],
            [28.89756279135241, -7.851210607118396],
            [28.898609372675864, -7.851772560068992],
            [28.898985068788917, -7.850728932419946],
            [28.898850891926529, -7.848507869200044],
            [28.900434181597923, -7.847624792519855],
            [28.901856459932766, -7.847169873515486],
            [28.904030128697123, -7.846902273496671],
            [28.904513166300113, -7.845269912380128],
            [28.904862027040711, -7.843316422143322],
            [28.905613419266853, -7.842138970955511],
            [28.905076710918877, -7.840533350339426],
            [28.905237723153764, -7.839784059346587],
            [28.906767342080212, -7.83825871098509],
            [28.907277215954025, -7.836572794321754],
            [28.908189620415055, -7.835341802457084],
            [28.906418482237946, -7.834030524633655],
            [28.905074794812368, -7.831819501054725],
            [28.904408301465413, -7.831215278230552],
            [28.903481350584979, -7.830338301672937],
            [28.902763171769855, -7.828997742067833],
            [28.902554399704549, -7.828608044803063],
            [28.902126576152195, -7.827233315198691],
            [28.90226973526913, -7.826233969016388],
            [28.902292952227647, -7.826071901754662],
            [28.902150343777961, -7.825100104221508],
            [28.90302975940682, -7.824080899268349],
            [28.903267439257949, -7.82299058436522],
            [28.903276629921621, -7.822541468235541],
            [28.909398239849445, -7.823368319412821],
            [28.914766919635369, -7.82888427729947],
            [28.937532240262861, -7.846288088373505],
            [28.944342719673052, -7.849617731371342],
            [28.949421240028936, -7.854843062786691],
            [28.954941637181513, -7.860641091864327],
            [28.9581278402217, -7.863987498728044],
            [28.962050040160712, -7.869797280328281],
            [28.967555519889689, -7.872257196613392],
            [28.973779920442187, -7.87282379641159],
            [28.995707840545005, -7.871427219298991],
            [29.002285079578183, -7.871008317431733],
            [29.016899639781499, -7.870245171326311],
            [29.027759400200686, -7.872546208702996],
            [29.025897480077603, -7.880115976820887],
            [29.020422599662165, -7.889730924007628],
            [29.024484839767453, -7.893648919543818],
            [29.039676839730337, -7.892302463904788],
            [29.054273040165846, -7.884265410794756],
            [29.070163439837966, -7.873024445002504],
            [29.079995400011342, -7.869654290721183],
            [29.089400760137746, -7.869049305818868],
            [29.096785439982604, -7.870631653647276],
            [29.108648519759466, -7.86914766714037],
            [29.112753237601275, -7.865293857181987],
            [29.111301359777837, -7.853364909688359],
            [29.10899520028887, -7.852689027758461],
            [29.109197519755451, -7.847637015546478],
            [29.111521257477921, -7.846805996712616],
            [29.113104239925484, -7.84623988675901],
            [29.111244480250651, -7.843264946040076],
            [29.110383083928077, -7.843604309817803],
            [29.107109507150103, -7.844893923654737],
            [29.106770021227813, -7.843144695960067],
            [29.106397439573833, -7.841224928825501],
            [29.107116594857665, -7.839608154545262],
            [29.108444400069029, -7.836623025189333],
            [29.116408796902693, -7.831843938194264],
            [29.11693535967785, -7.831527968976317],
            [29.11355468664998, -7.82861189866126],
            [29.113231508743365, -7.828333132574636],
            [29.114593121152126, -7.825781531084511],
            [29.114828263262591, -7.825340882760107],
            [29.113887240273232, -7.822131968506293],
            [29.111114553317858, -7.821731960737071],
            [29.109277643190602, -7.821466953752225],
            [29.10994520373611, -7.817102134687828],
            [29.109250464661688, -7.816503131012212],
            [29.108093400439742, -7.815505952739681],
            [29.105776659695067, -7.81606114420198],
            [29.105552159925779, -7.816114943979025],
            [29.104868850116691, -7.816279213591553],
            [29.104183386147561, -7.816443957942159],
            [29.102738611303071, -7.815631479440043],
            [29.102565240046484, -7.815533983237978],
            [29.101901990516041, -7.813798020214731],
            [29.100464280022933, -7.810034986307123],
            [29.098347348851952, -7.80857609911456],
            [29.095838279703237, -7.80684696293627],
            [29.098333440236388, -7.799945922621686],
            [29.109108239792626, -7.791623884230591],
            [29.109338124962047, -7.791209292806109],
            [29.112299280260654, -7.785868884287312],
            [29.112959520434917, -7.780355922491506],
            [29.111889822764255, -7.779349086536438],
            [29.107866239860588, -7.775561929104605],
            [29.107076692591061, -7.774009161959671],
            [29.105770320284083, -7.771439967738521],
            [29.104864248945823, -7.770904866337714],
            [29.102304239930604, -7.769392988491957],
            [29.09492820008213, -7.768053982597928],
            [29.096520597772233, -7.761129223758929],
            [29.09672532023222, -7.760238953503017],
            [29.097792972438963, -7.759163432134623],
            [29.09832945441147, -7.758622994557436],
            [29.104555301251597, -7.760196986801732],
            [29.108915279872967, -7.757648910449465],
            [29.110948199700296, -7.750979899204338],
            [29.113941239801584, -7.750734907384672],
            [29.117653199828133, -7.755536866400724],
            [29.120654998503458, -7.755947587920284],
            [29.122492152074159, -7.756198956088635],
            [29.122693217492628, -7.752800570548169],
            [29.122913160108475, -7.749079957781319],
            [29.133047351272648, -7.74971492866159],
            [29.142664199969772, -7.740251008463344],
            [29.1460354182293, -7.739940175150074],
            [29.147957280236334, -7.739762976115898],
            [29.160903599786771, -7.760328234982561],
            [29.171350080378005, -7.770780200501307],
            [29.206689839587884, -7.781898617073368],
            [29.213760959787848, -7.774023317936825],
            [29.225885039680627, -7.761478883531914],
            [29.23295976032826, -7.754912964510035],
            [29.245525559812563, -7.745277369809584],
            [29.26299563972524, -7.729226121380369],
            [29.273702039759122, -7.728181279294912],
            [29.286875880113151, -7.729895419503975],
            [29.304683999660522, -7.732907961894601],
            [29.307290400371944, -7.733483860347302],
            [29.315253240425239, -7.734774048014938],
            [29.326555079762027, -7.740131009757355],
            [29.337725160501172, -7.750581877135872],
            [29.347417909653284, -7.753630163160385],
            [29.359305720049907, -7.757368746237846],
            [29.36508911966316, -7.755317232842958],
            [29.402818920348274, -7.73892565898873],
            [29.417085360022806, -7.732541885981151],
            [29.418571506777681, -7.732668553391024],
            [29.419620480314741, -7.732757959964671],
            [29.423557439573866, -7.736638876707993],
            [29.429764199909162, -7.734766905739157],
            [29.434000949436466, -7.730305654705044],
            [29.435026319739421, -7.729225943067494],
            [29.437115510934468, -7.729474652694154],
            [29.438713323669077, -7.729664865763787],
            [29.440259726718292, -7.731509511642514],
            [29.443119399339238, -7.734920916689844],
            [29.443759633133809, -7.737181925220991],
            [29.445001200077879, -7.741566889974591],
            [29.444032222415213, -7.745249825566357],
            [29.443428359609854, -7.747544999084943],
            [29.439758519790342, -7.750091891986743],
            [29.438261078517392, -7.753291199409366],
            [29.437711199969037, -7.754466018878833],
            [29.43798761068366, -7.759155135359566],
            [29.438225279754999, -7.763186994560508],
            [29.443165190062548, -7.780147873974197],
            [29.443464763836761, -7.780716930957789],
            [29.446659311327625, -7.786784933327733],
            [29.447009738730088, -7.787014805801796],
            [29.448740520093029, -7.78814986024761],
            [29.45288843971348, -7.788584985560742],
            [29.457941400304595, -7.786489882484166],
            [29.463508439783325, -7.793345976051897],
            [29.454847200020829, -7.807858935127376],
            [29.453708519821188, -7.814446866323474],
            [29.474195400274482, -7.807290460218178],
            [29.481292799789767, -7.809746822506336],
            [29.483616240169862, -7.812796634690333],
            [29.485535400044533, -7.827633302391416],
            [29.485256400385275, -7.831707928146595],
            [29.485130399988595, -7.838982986668293],
            [29.484284760116111, -7.847860348855763],
            [29.485759679726559, -7.858768532752841],
            [29.493750239992892, -7.87082427034199],
            [29.497520879770438, -7.874015724002796],
            [29.5037474398729, -7.875455244183688],
            [29.508953759950991, -7.873987697497915],
            [29.517873480055037, -7.871082936782317],
            [29.520156975049368, -7.868781395829873],
            [29.521309320421128, -7.867619938748799],
            [29.524023359964822, -7.859800013115862],
            [29.527719926460676, -7.856578736886621],
            [29.534101199811278, -7.851017883560097],
            [29.536592399672362, -7.844116870060413],
            [29.555429400138813, -7.836890996502527],
            [29.557264138139722, -7.835194168574601],
            [29.560924439647554, -7.831808976036746],
            [29.566841313640637, -7.820296080011532],
            [29.573074440427842, -7.823013929102491],
            [29.573854977595047, -7.82470881225662],
            [29.576343239965158, -7.830111861069854],
            [29.580053399767859, -7.834221988584695],
            [29.580735178847696, -7.834464457563707],
            [29.582592511274637, -7.835125073455604],
            [29.58790679986673, -7.849207129038935],
            [29.601859319671934, -7.872451062091123],
            [29.623957560352622, -7.911966729762463],
            [29.626041599709485, -7.934654318207978],
            [29.631261960455475, -7.938714489195855],
            [29.635828559677034, -7.939851072899343],
            [29.642836319903388, -7.937522393606339],
            [29.652370560425293, -7.930807934229199],
            [29.660181119868259, -7.929043225923499],
            [29.662215839919373, -7.932529440895999],
            [29.66268131995016, -7.935880869467581],
            [29.657634479581077, -7.938894936694198],
            [29.657279567788734, -7.939705124687165],
            [29.656727279958794, -7.940965878212979],
            [29.660679359660794, -7.946680860099112],
            [29.662386480297485, -7.961588871208831],
            [29.66589936108068, -7.970749112544689],
            [29.665922400172771, -7.974422002669915],
            [29.662975475984883, -7.981783834658667],
            [29.665785369362698, -7.988770469046216],
            [29.668592488742878, -7.995750085457701],
            [29.668276716547471, -7.996756798784002],
            [29.667259440065223, -7.999999955761689],
            [29.667570479935723, -8.001883919871426],
            [29.666847240012284, -8.009707887839763],
            [29.664438547715083, -8.013601994032966],
            [29.660211359855648, -8.020435950851326],
            [29.656419480311531, -8.034307879467864],
            [29.651513562254344, -8.045195037466556],
            [29.648571479985872, -8.051723930176005],
            [29.649910312915637, -8.059037899449342],
            [29.645584199882176, -8.079123994732329],
            [29.63900952014923, -8.092376925300606],
            [29.636881810991436, -8.093974074708946],
            [29.635845480343725, -8.094751986211881],
            [29.62940820691664, -8.095374021754481],
            [29.619003240169597, -8.102982876326696],
            [29.613831384855683, -8.103224711378411],
            [29.608415280311, -8.103477966609002],
            [29.592682199899667, -8.110071967053317],
            [29.583015480331209, -8.110541893252364],
            [29.574939236956464, -8.119239886892302],
            [29.572705799682993, -8.129946972246426],
            [29.583223559795417, -8.168302614446185],
            [29.579186520128804, -8.174127436856166],
            [29.56010292043873, -8.181733432873614],
            [29.543312520243042, -8.180611628977015],
            [29.540975040093375, -8.171894842830435],
            [29.531663640152409, -8.15272765100743],
            [29.526456959849916, -8.153903408056975],
            [29.520174239770817, -8.187064498229622],
            [29.520233639970662, -8.210322739880603],
            [29.519121960433541, -8.228349758568037],
            [29.528407799711392, -8.237629768418765],
            [29.534245559975734, -8.256801371265261],
            [29.53893600004405, -8.280044228104105],
            [29.551129560132466, -8.29454757149678],
            [29.553424082845225, -8.310633484908806],
            [29.556434519720341, -8.331737349439059],
            [29.562836400423517, -8.345090502629013],
            [29.57502995961363, -8.359591406870193],
            [29.5906802396103, -8.367690315723474],
            [29.6051612400938, -8.371142173021234],
            [29.610949680154096, -8.371127910298711],
            [29.622551040264501, -8.380398795472905],
            [29.628376952648559, -8.395491715477361],
            [29.628356989387996, -8.395493840034607],
            [29.626158284576697, -8.402622255410714],
            [29.625486894513127, -8.404799506832283],
            [29.501477014467604, -8.419366318588322],
            [29.36275867961038, -8.435659907567317],
            [29.144013016775649, -8.461762022795153],
            [29.087371148805623, -8.465962930468265],
            [29.046781519192702, -8.468972767193936],
            [29.004071861017646, -8.471775820208467],
            [28.964016811643777, -8.474404176758428],
            [28.91478687391276, -8.48241351486517],
            [28.911054785335651, -8.483020589602374],
            [28.909625236935231, -8.483253188103266],
            [28.897488302150723, -8.490836169674237],
            [28.89984124949298, -8.505355242288278],
            [28.934714904342954, -8.560461244317189],
            [28.945906886907032, -8.635945215147062],
            [28.933399195845212, -8.724827178315337],
            [28.879790643942272, -8.813207272751427],
            [28.829017043023658, -8.878343269431207],
            [28.78577025159753, -8.944029179331295],
            [28.651831509210659, -9.084183204866749],
            [28.55941622481895, -9.163870216289473],
            [28.494159483629819, -9.224339358155271],
            [28.481469572007601, -9.242344407143877],
            [28.550729217780844, -9.38767927637109],
            [28.565540322181775, -9.399185635097837],
            [28.566805274967653, -9.400168325691093],
            [28.5703951719134, -9.403401273476357],
            [28.575618019196085, -9.407599349836573],
            [28.578704459832419, -9.414314226774895],
            [28.57870687809714, -9.414319140070704],
            [28.578706799943728, -9.414319179319994],
            [28.579728039792997, -9.416480950345603],
            [28.579762102111939, -9.416463918943373],
            [28.581105106817887, -9.419337121327843],
            [28.581107835001404, -9.419342958679694],
            [28.581086438927972, -9.419356402250486],
            [28.583734863726711, -9.424962501680875],
            [28.5847400048678, -9.427112599456638],
            [28.631344962032358, -9.514205024220374],
            [28.658029088763726, -9.59101367319572],
            [28.657310912643524, -9.633786014962341],
            [28.664744524620207, -9.689205993827178],
            [28.674843543147794, -9.710978713407835],
            [28.689368397586826, -9.793189225421003],
            [28.69418840526183, -9.79828926253739],
            [28.695548476161534, -9.800199204717712],
            [28.69703850813006, -9.806159266723062],
            [28.694138371795429, -9.813559254880444],
            [28.682838779145147, -9.82739372075819],
            [28.682827622069333, -9.834897271489996],
            [28.681179198251623, -9.844373363686543],
            [28.686033418264216, -9.876296765642008],
            [28.68730350043035, -9.90107464243569],
            [28.678751777877395, -9.937031035665248],
            [28.667915868627304, -9.970721855094865],
            [28.659387537306035, -9.991344811058273],
            [28.660013581312395, -10.009598847660278],
            [28.653754318940333, -10.042587389604869],
            [28.639992345281591, -10.066188396139575],
            [28.639301880391287, -10.090644007127354],
            [28.621768941764877, -10.138119348783542],
            [28.621759230078354, -10.157049277501223],
            [28.616809266724452, -10.164489254124176],
            [28.608729123763073, -10.170579135900766],
            [28.60729921962977, -10.183019259188967],
            [28.598889320398939, -10.194649284320802],
            [28.589949503185352, -10.202369293082636],
            [28.582199479412793, -10.211919280524942],
            [28.578599507861131, -10.222359201885494],
            [28.577979592161675, -10.224169261646381],
            [28.577349875842451, -10.22906699991438],
            [28.577349598263016, -10.229069155027469],
            [28.577149440142978, -10.230619385771009],
            [28.578139434790039, -10.233279338539374],
            [28.578679432768585, -10.236159332721988],
            [28.579679506513145, -10.237409312898258],
            [28.580049585460749, -10.238399328081458],
            [28.583849362094522, -10.242619314229133],
            [28.584709396571132, -10.243579345620944],
            [28.589029369619631, -10.248379279564842],
            [28.597989354011318, -10.256989327371732],
            [28.606399263123656, -10.27090920531351],
            [28.611289115710285, -10.283069286208759],
            [28.613719099876324, -10.284839277989953],
            [28.615339089320376, -10.285919210603117],
            [28.630399232769204, -10.29604922703715],
            [28.636024921456237, -10.31323809220587],
            [28.631299244970908, -10.338359283196111],
            [28.623919303739171, -10.357329216518183],
            [28.621649166693114, -10.375759151102532],
            [28.638529112752941, -10.423009193324217],
            [28.643008934718051, -10.449729242146107],
            [28.636149190799376, -10.472139268003074],
            [28.636509191547812, -10.480189202012186],
            [28.639439215730242, -10.489569213534359],
            [28.637149275323736, -10.499389223172306],
            [28.634339140299097, -10.511369158116176],
            [28.63398922313975, -10.512879173551692],
            [28.634079225348074, -10.518399179353718],
            [28.636559252861957, -10.528709345815608],
            [28.643409289585666, -10.535509193180221],
            [28.664319033094309, -10.549909136196989],
            [28.671228830242331, -10.560619280418409],
            [28.672969060983764, -10.567489270236159],
            [28.67251906521355, -10.569029297253655],
            [28.670288884332987, -10.576599301622551],
            [28.665018888074311, -10.594529302721375],
            [28.663858982481113, -10.609949276617666],
            [28.665868853334889, -10.61911912762509],
            [28.667789082204735, -10.623219302464561],
            [28.676758783672895, -10.631389199937411],
            [28.687088915366825, -10.637659169926877],
            [28.693268995738201, -10.646539166005214],
            [28.696778978556264, -10.662589189674573],
            [28.694408758407743, -10.669469256463362],
            [28.692549014004268, -10.674839256225813],
            [28.689358718239635, -10.679259173875129],
            [28.688679043014201, -10.680189152679874],
            [28.681808851688782, -10.683499302918996],
            [28.677369003855475, -10.685649092685377],
            [28.672969114882694, -10.686639255942646],
            [28.672299160326951, -10.687639329551226],
            [28.668819066255015, -10.6929192347766],
            [28.667739073891184, -10.694539184358174],
            [28.667529203186298, -10.710889224746746],
            [28.666228892710862, -10.713929207781398],
            [28.665058901731989, -10.716659146438364],
            [28.662069123413499, -10.719009292453805],
            [28.661214494099955, -10.730651392423884],
            [28.643240176343554, -10.730167723392322],
            [28.630161466679816, -10.733867517748202],
            [28.620018537602839, -10.741443466748574],
            [28.608917658581632, -10.757860160173552],
            [28.601473996253556, -10.77918117592869],
            [28.585716906569598, -10.792856130974222],
            [28.583021965208825, -10.797285273593074],
            [28.581913898695767, -10.810420265345824],
            [28.581260143459517, -10.812505244117936],
            [28.565948008200433, -10.825251263219322],
            [28.563888102083666, -10.826904120084588],
            [28.557531265603743, -10.83416921887418],
            [28.547561139149792, -10.857383238917524],
            [28.544753160980186, -10.866678209463753],
            [28.543435212084145, -10.871042187519903],
            [28.543937411650454, -10.87904320627816],
            [28.545219371341279, -10.899529172940031],
            [28.543094316705176, -10.927407258638047],
            [28.540666501072231, -10.947243240291716],
            [28.523565151735877, -10.963701833266773],
            [28.523561575542733, -10.96370527467732],
            [28.513698360285673, -10.970582241501212],
            [28.510097664691884, -10.976409181366909],
            [28.51256546613477, -11.015235301590872],
            [28.511853394066947, -11.025371199710227],
            [28.508512617017466, -11.032342212307279],
            [28.504308566166479, -11.037892195203259],
            [28.498773602831601, -11.04519821795725],
            [28.497428653273033, -11.05025826133987],
            [28.496659698983105, -11.051417149252266],
            [28.498388771750395, -11.05969829630704],
            [28.494455801011121, -11.071743180567069],
            [28.493562651039912, -11.084414240728456],
            [28.491838623211251, -11.086454297910239],
            [28.4797056230477, -11.10080625926101],
            [28.478481633438797, -11.108884248449892],
            [28.480754663060075, -11.117118307139002],
            [28.493671750532833, -11.132722235452119],
            [28.498527764481064, -11.141823309782071],
            [28.500068557551305, -11.148461268255414],
            [28.501104633077507, -11.153271290698488],
            [28.49905769144695, -11.166427199927529],
            [28.498979578441407, -11.184372207243037],
            [28.493632894803547, -11.192071520509923],
            [28.493226817667558, -11.19265624822874],
            [28.486301903669951, -11.201661213566339],
            [28.486277665326966, -11.204111097546301],
            [28.486226667069982, -11.209023172846857],
            [28.484060923243053, -11.216660313780588],
            [28.484584721003777, -11.219410297522783],
            [28.486140634516893, -11.226739278466093],
            [28.490028614033474, -11.234019288960608],
            [28.489715778430714, -11.24115826127688],
            [28.486894840266512, -11.250878316070063],
            [28.475402997365649, -11.26929231583147],
            [28.472913977715756, -11.283607184874409],
            [28.468816844349906, -11.288293183168797],
            [28.458212029401597, -11.293804290297254],
            [28.454974930512357, -11.296582331358602],
            [28.454091856045324, -11.297340182707728],
            [28.452539906797565, -11.301054315220211],
            [28.45326386357662, -11.303841295639842],
            [28.455333855079068, -11.311808235454512],
            [28.44960413429564, -11.327340210742724],
            [28.450195972252583, -11.329559271620802],
            [28.451126208272001, -11.333059203486295],
            [28.457840170891441, -11.341662208528412],
            [28.458864006871892, -11.346012285825687],
            [28.454677956462579, -11.357372203419864],
            [28.458662057511177, -11.369254193427171],
            [28.45812818155132, -11.37110231299925],
            [28.456926869911744, -11.375270166089944],
            [28.453961208663692, -11.378323325116327],
            [28.449726193783185, -11.378801329230242],
            [28.449287356885414, -11.378851143677808],
            [28.448483122161008, -11.378942292721975],
            [28.436514272945967, -11.380294336212602],
            [28.433504511603974, -11.381623582392841],
            [28.430508068684382, -11.382948230109793],
            [28.428002125672837, -11.385760191095212],
            [28.425789220293524, -11.391326268731826],
            [28.426119340380641, -11.395921276269602],
            [28.432480148312429, -11.409823301365231],
            [28.433045347627946, -11.414413237852473],
            [28.423651209256054, -11.433241312020842],
            [28.421122228949077, -11.445947301391707],
            [28.413216319626933, -11.45807224669084],
            [28.411711170808822, -11.46408525156285],
            [28.401341433292288, -11.470049216448949],
            [28.397721295460816, -11.475414253021848],
            [28.395251352434318, -11.482836346837901],
            [28.395813314221531, -11.495468211754845],
            [28.397925425931049, -11.505979318805393],
            [28.398078064969159, -11.506738458047467],
            [28.398161584934396, -11.507154179631383],
            [28.396078278602801, -11.51183132463354],
            [28.395483563341987, -11.513721230322821],
            [28.390263596058091, -11.519738331700776],
            [28.389427322020779, -11.524356295650184],
            [28.389662401249151, -11.524880305296373],
            [28.389813600287876, -11.525217344411365],
            [28.393101463872156, -11.53256325029804],
            [28.386946583939494, -11.543259206856971],
            [28.384924479828186, -11.556252334340183],
            [28.38386248790605, -11.56121321678239],
            [28.383200460084364, -11.582918284964002],
            [28.384432256053106, -11.590310728612785],
            [28.385340652231321, -11.595757219389911],
            [28.389942688194214, -11.598956930227295],
            [28.398842379460682, -11.605145320548925],
            [28.39990653632265, -11.611334280342943],
            [28.40034141434495, -11.613051244001538],
            [28.402455325379989, -11.621403287514907],
            [28.404612433702056, -11.624121238047458],
            [28.418586835569286, -11.630374271721928],
            [28.419503391145238, -11.630784335485936],
            [28.421566179057429, -11.632187211618916],
            [28.425608236713234, -11.634934174933479],
            [28.427279347483442, -11.636308263071014],
            [28.431879403559428, -11.644035225737415],
            [28.433623240138417, -11.660104190960812],
            [28.431626332872561, -11.664976207192],
            [28.421715233817583, -11.670932308435914],
            [28.419039370876803, -11.676739172590082],
            [28.423243430710926, -11.687920230670459],
            [28.423511450262463, -11.688215692396946],
            [28.43328737712169, -11.698991257671839],
            [28.433947254376562, -11.701305275333818],
            [28.434046253212454, -11.701652596739502],
            [28.435307327971259, -11.706081281979884],
            [28.431788352118858, -11.71627630942907],
            [28.426966182198974, -11.720057181965913],
            [28.415024332748128, -11.724554290018485],
            [28.419470309786593, -11.729874324255356],
            [28.427727222331278, -11.733844301337637],
            [28.432493236766138, -11.73834717383011],
            [28.432862235040435, -11.738992324538676],
            [28.435251183266004, -11.74317016132413],
            [28.438486126198576, -11.748823774771324],
            [28.443455000885809, -11.757507191065407],
            [28.444294336381631, -11.758974335063225],
            [28.450445264625397, -11.769726199681193],
            [28.450880146240948, -11.779149257341846],
            [28.450487389324021, -11.782608230049748],
            [28.44108173005862, -11.795636839611896],
            [28.44065333248275, -11.796230264515735],
            [28.438011308180428, -11.799890265353412],
            [28.436577440680097, -11.807208176063847],
            [28.43380042204846, -11.821372165587865],
            [28.436268210016589, -11.827533294861114],
            [28.438101319371892, -11.828887189666695],
            [28.441962299124278, -11.831741156946407],
            [28.442265416752274, -11.831965127468093],
            [28.445050361219703, -11.834023180276796],
            [28.445057142601794, -11.834023041347701],
            [28.445058142426699, -11.834023780238057],
            [28.449726978910714, -11.833927843939035],
            [28.454564749872159, -11.832399372296441],
            [28.460631009205429, -11.830482752965889],
            [28.463077904156698, -11.829213141875888],
            [28.465127045761417, -11.82814990720756],
            [28.470795543663293, -11.825209802977454],
            [28.478254517775397, -11.824826230888807],
            [28.481835302210889, -11.826987979254387],
            [28.484880884773172, -11.828828269335883],
            [28.488890181768866, -11.833366246681841],
            [28.489421179526556, -11.833968053742829],
            [28.490865851064811, -11.83560522656796],
            [28.496201023690595, -11.845579186560753],
            [28.500846799522993, -11.85426214597439],
            [28.50461778155864, -11.866607271345059],
            [28.505575140411448, -11.880243110245996],
            [28.505632980237628, -11.881080233383702],
            [28.509657036553467, -11.883527227044965],
            [28.509662105746617, -11.883529065526382],
            [28.521990564044597, -11.887999218979777],
            [28.536990236501808, -11.896999226495925],
            [28.545990182448911, -11.899999161094046],
            [28.545997841485029, -11.899999586625977],
            [28.545998460424265, -11.899999792756823],
            [28.563990352820884, -11.900999372476454],
            [28.569990154789451, -11.904999266873645],
            [28.576990313471867, -11.910999278427974],
            [28.583990110133254, -11.911999265683399],
            [28.583992160987027, -11.911998991444333],
            [28.583998586636262, -11.911999909702924],
            [28.598998398332327, -11.90999996508495],
            [28.61098993899142, -11.910999265158292],
            [28.614989873745227, -11.912999238594256],
            [28.617989735652806, -11.916999143367217],
            [28.628989834478947, -11.939999199192407],
            [28.632989771029379, -11.945999133541086],
            [28.639989928813467, -11.95199928440773],
            [28.655989666930399, -11.956999303837266],
            [28.664989609284248, -11.961999232333755],
            [28.675989700025546, -11.969999276072086],
            [28.701130135721531, -11.977481402280697],
            [28.713989254010691, -11.989999214392222],
            [28.720989407303225, -11.990999082103803],
            [28.720991987264728, -11.990998823864595],
            [28.720998624018044, -11.990999771920771],
            [28.729894285442139, -11.990110294776283],
            [28.730998333790939, -11.989999900674285],
            [28.740998403788275, -11.984999964584809],
            [28.747066291767155, -11.984241417482464],
            [28.748991515269996, -11.984000744737548],
            [28.758988946017027, -11.989999195820175],
            [28.763988953617094, -11.994999212294227],
            [28.763988958108648, -12.005999133053782],
            [28.763988963498562, -12.016999127773765],
            [28.770988761058245, -12.031999136536562],
            [28.773988986783479, -12.045999169354774],
            [28.777988922435618, -12.054999137728078],
            [28.785988789248282, -12.061999076805947],
            [28.819249681600688, -12.080506099551618],
            [28.831988559490757, -12.100999120191716],
            [28.837988639937056, -12.109999154164672],
            [28.846988583189201, -12.127999183311507],
            [28.855988521949826, -12.137999195035949],
            [28.867988319024704, -12.148999154451774],
            [28.881988259097159, -12.155999237554205],
            [28.910987853660448, -12.178999163767541],
            [28.934987800848166, -12.19899914452647],
            [28.946987595228126, -12.211999193995778],
            [28.961987609943431, -12.231999120142737],
            [28.983987415930212, -12.268999009429185],
            [28.99898742705226, -12.286999018075285],
            [29.001987290756432, -12.30299901986904],
            [29.003987442737142, -12.317999060722371],
            [29.004987157155597, -12.322998998878356],
            [29.007987374795992, -12.325999194899495],
            [29.014987165169163, -12.336999152154492],
            [29.02398709943817, -12.348999083463079],
            [29.027987030598723, -12.355999079150497],
            [29.029987178986172, -12.36499912496434],
            [29.035987255839192, -12.374999019578848],
            [29.046986971982996, -12.384999052684924],
            [29.058986757379817, -12.388999164954804],
            [29.0589955429033, -12.388999164954804],
            [29.058997971049486, -12.388999974700324],
            [29.065998162969592, -12.388999974700324],
            [29.071148975247969, -12.385311515814967],
            [29.080915511119205, -12.378317626159241],
            [29.097986672570432, -12.381998988212199],
            [29.097988700068015, -12.381997772236286],
            [29.097998164717829, -12.38199981299182],
            [29.10299819836905, -12.378999737444648],
            [29.106987562646914, -12.378999737444648],
            [29.113986381042931, -12.384999022661187],
            [29.119986455201023, -12.393998933148714],
            [29.119998153062653, -12.394000232954927],
            [29.128986379588557, -12.394999016419398],
            [29.128987267124053, -12.394998650850324],
            [29.128998089128284, -12.394999853519597],
            [29.145997987228007, -12.387999857532852],
            [29.151192392950488, -12.38644154753295],
            [29.155998054530414, -12.384999850963373],
            [29.158418621657315, -12.383696460284927],
            [29.168997999011719, -12.377999758075457],
            [29.17499811089905, -12.373999822121293],
            [29.179993117577915, -12.373063253236685],
            [29.190997930762656, -12.370999827449607],
            [29.201955584191609, -12.371497904715163],
            [29.212988486796959, -12.371999401249425],
            [29.232985503349379, -12.374998928621054],
            [29.232989484682719, -12.374998530349412],
            [29.232997998016643, -12.374999807291241],
            [29.24299806531905, -12.373999816822781],
            [29.256997726015435, -12.365999932767048],
            [29.257900338839875, -12.365819406919583],
            [29.266988656553071, -12.364001706239966],
            [29.274984879798936, -12.369998919823271],
            [29.283984802389845, -12.378998825231312],
            [29.295984936332971, -12.388999054575091],
            [29.29698501097586, -12.395998845911805],
            [29.294984873368207, -12.402998976689618],
            [29.295984947112768, -12.408998885842211],
            [29.301984653859879, -12.412998980011249],
            [29.313984784209747, -12.416999007514322],
            [29.313997104603875, -12.41699965647638],
            [29.313997895121322, -12.416999919592968],
            [29.330498158344874, -12.417868350312636],
            [29.332997949693329, -12.417999916956997],
            [29.354997073858808, -12.412000084544841],
            [29.365984127350398, -12.41299894822485],
            [29.377984254106984, -12.416998975728418],
            [29.403983929270584, -12.432998830138015],
            [29.412983843776651, -12.438998913504587],
            [29.412993122475235, -12.439003263384855],
            [29.444983574233699, -12.453998944683793],
            [29.462983397855954, -12.463998889543037],
            [29.474983159896581, -12.470998917757758],
            [29.482982998861463, -12.471998878410133],
            [29.482983905261573, -12.47199857562615],
            [29.482990250960764, -12.471999369220356],
            [29.488990335000292, -12.469999435182762],
            [29.497637685910195, -12.469999432534518],
            [29.498990356488616, -12.469999432534518],
            [29.500053405727861, -12.469123983867664],
            [29.515990170146704, -12.455999288886812],
            [29.526989899765272, -12.443999411940442],
            [29.535989841220786, -12.428999305224247],
            [29.536989913168721, -12.421999354509556],
            [29.536989907778839, -12.406999372577168],
            [29.533990043176338, -12.401999302429118],
            [29.528934857458246, -12.398629302824991],
            [29.527989958238443, -12.397999388613981],
            [29.527982860649381, -12.397999135191061],
            [29.527982486950219, -12.397998886183132],
            [29.499989717869141, -12.396999074173126],
            [29.495990108305481, -12.393999244854943],
            [29.48691017906042, -12.384313896614712],
            [29.480990430458391, -12.377999244125556],
            [29.479949927136154, -12.37611345272054],
            [29.476227413701672, -12.369366714602986],
            [29.464990314150743, -12.34899936077989],
            [29.45899058674236, -12.340999408703098],
            [29.455990361017133, -12.332999384875587],
            [29.455990361017133, -12.331630462462323],
            [29.455990357423843, -12.32199925497755],
            [29.459990289482725, -12.306999268081334],
            [29.46280750772334, -12.295026073208772],
            [29.463990220643247, -12.289999371788669],
            [29.464032640887616, -12.289819103879939],
            [29.467990511129905, -12.272999418242012],
            [29.475364563006632, -12.25825129318561],
            [29.479990312696401, -12.248999353489392],
            [29.484990321194768, -12.242999254353782],
            [29.487990184000644, -12.24199928301188],
            [29.488990256846876, -12.238999346859933],
            [29.5059900714033, -12.226999430429675],
            [29.512660937346958, -12.223187447052885],
            [29.512990228289084, -12.22299927677359],
            [29.538989987894308, -12.215999207712825],
            [29.539990062537168, -12.215999206829217],
            [29.554164706067766, -12.207792721312526],
            [29.558989662561647, -12.204999228824587],
            [29.564989743906246, -12.199999311435652],
            [29.573501592040376, -12.194041059122483],
            [29.574989759106359, -12.192999336221225],
            [29.58798737695108, -12.191999519906835],
            [29.595981670615707, -12.192998808649643],
            [29.632981348485693, -12.206998722949447],
            [29.645981164507912, -12.207998644544254],
            [29.645981876871939, -12.207998610081773],
            [29.645989236769065, -12.207999176503831],
            [29.657220966191179, -12.207464360391782],
            [29.666988979791075, -12.206999240772577],
            [29.684988860007184, -12.20299930585573],
            [29.709988892617563, -12.19599922972874],
            [29.722988763437005, -12.189999143225366],
            [29.722988762538709, -12.188999321641509],
            [29.738988488977512, -12.174999301323171],
            [29.755988650283609, -12.163999363272236],
            [29.761988367810517, -12.159999303045289],
            [29.767114972288613, -12.159999301277676],
            [29.774984577995191, -12.159999298626239],
            [29.783979397256992, -12.160998662503799],
            [29.783981336719691, -12.160998468065079],
            [29.783988175593962, -12.160999228143732],
            [29.788264149159826, -12.160571658825898],
            [29.793988185404153, -12.159999292439513],
            [29.80198804862356, -12.155999347149008],
            [29.806979439583404, -12.155999345381344],
            [29.808979291526779, -12.159998715307829],
            [29.809979359881456, -12.160998647478998],
            [29.809979379644393, -12.18899872159702],
            [29.809979400305664, -12.219998632681657],
            [29.809979413780383, -12.239998657328284],
            [29.809979434441615, -12.269998634156783],
            [29.809979469475941, -12.321998574862114],
            [29.809979531459671, -12.413998725410096],
            [29.809979549425979, -12.440998699395569],
            [29.809979596138398, -12.510998650057109],
            [29.809979619494591, -12.546998746541558],
            [29.808979599648953, -12.619998665302647],
            [29.809979690461493, -12.653998687951493],
            [29.808979632886611, -12.670998650936662],
            [29.808979650852923, -12.697998743013192],
            [29.809979776699745, -12.787998781355867],
            [29.808979723616449, -12.809998630475537],
            [29.808979727209707, -12.815998729772478],
            [29.809979806344149, -12.833998688645085],
            [29.808979759549072, -12.86699864930141],
            [29.808979803566491, -12.934998650953645],
            [29.809979885395894, -12.956998784131796],
            [29.808979832312598, -12.980998617175182],
            [29.809979908752119, -12.99399878348288],
            [29.809979914142001, -13.002998670308225],
            [29.809979963549342, -13.081998773268515],
            [29.808979921245811, -13.122998768249518],
            [29.809980003973511, -13.146998775014051],
            [29.808979953585176, -13.17499867219186],
            [29.809980063262319, -13.242998661467617],
            [29.81097977139256, -13.244998680401848],
            [29.809980074042116, -13.261998692348806],
            [29.809980105483149, -13.312998687147372],
            [29.809980167466918, -13.415998775818958],
            [29.80898019523196, -13.454995841740343],
            [29.803988669524848, -13.452999225950425],
            [29.784988713767522, -13.438999213715046],
            [29.778988633321219, -13.437999320585069],
            [29.776988846954865, -13.43699924561529],
            [29.776981524786958, -13.43699924561529],
            [29.776980452198522, -13.436998709245186],
            [29.764980713514113, -13.436998715400222],
            [29.738980743703134, -13.449998670299948],
            [29.721981022571516, -13.454998735281148],
            [29.711986726944822, -13.455998172361413],
            [29.700989394031446, -13.450999403411197],
            [29.692989522727206, -13.442999304104555],
            [29.679989281801859, -13.430999262845058],
            [29.673989559783365, -13.428999227197711],
            [29.673985328718366, -13.428999932416362],
            [29.673981669880224, -13.428998712792582],
            [29.667981617281697, -13.429998824178123],
            [29.653982403946337, -13.437998465913642],
            [29.645989659875564, -13.436999284304294],
            [29.623989830532558, -13.416999362386303],
            [29.610989948933319, -13.408999343526729],
            [29.607989725004714, -13.401999279154253],
            [29.607989722309753, -13.393999276288811],
            [29.613989801857727, -13.381999379985892],
            [29.611990012796412, -13.376999361723287],
            [29.604989853215667, -13.369999406777261],
            [29.604989851419035, -13.362999420138738],
            [29.608989785274549, -13.359999286983248],
            [29.626989672677198, -13.356999286685861],
            [29.64598963382441, -13.354999321211475],
            [29.651989714270716, -13.349999260214453],
            [29.657989432695921, -13.338999390127139],
            [29.662989434906077, -13.31999933077431],
            [29.66298943131282, -13.309999393713328],
            [29.653989484467392, -13.297999307415916],
            [29.653989481772463, -13.288999327603035],
            [29.659989561320437, -13.280999390147811],
            [29.67498958232396, -13.272999359024208],
            [29.680989302545829, -13.267999337691249],
            [29.681989374493725, -13.26499923879804],
            [29.680989298952539, -13.258999283129455],
            [29.675989289555869, -13.253999323012962],
            [29.673989500494557, -13.247999266755237],
            [29.677989430756782, -13.235999407141479],
            [29.674989567950906, -13.229999252802839],
            [29.669989558554235, -13.225999301772566],
            [29.669983741064435, -13.226000465228717],
            [29.669981638108364, -13.225998783409732],
            [29.664981654762808, -13.226998867828305],
            [29.654981689868375, -13.23399880469378],
            [29.642983859205643, -13.239997908852372],
            [29.634989503557239, -13.237999320608045],
            [29.619989836489943, -13.232999277392782],
            [29.607989668410827, -13.226999402030236],
            [29.602990018340268, -13.22199930275977],
            [29.588990061199837, -13.213999245355982],
            [29.580989829671189, -13.212999287380182],
            [29.580988994237959, -13.212999621825864],
            [29.580982321552018, -13.212998787471882],
            [29.575982695735977, -13.21499888234136],
            [29.566982796501257, -13.223998834449663],
            [29.559983344792958, -13.227998439413998],
            [29.536990178171727, -13.224999254564931],
            [29.536989181041751, -13.224999587233814],
            [29.536982872173539, -13.224998764362386],
            [29.527982966650601, -13.227998838963712],
            [29.51598321628811, -13.238998901054549],
            [29.50299682289285, -13.24599160975208],
            [29.502983393079344, -13.245998840708632],
            [29.49798340973383, -13.255998820084161],
            [29.494983565792555, -13.265998907534071],
            [29.490983288780622, -13.270998972317745],
            [29.482983451612366, -13.272998935792021],
            [29.475983681900466, -13.27399882636553],
            [29.471983766909592, -13.282998846115097],
            [29.465983709819476, -13.288998907038645],
            [29.451983817357775, -13.303998925636467],
            [29.446983830418972, -13.310998893164333],
            [29.441983841683534, -13.313998942963122],
            [29.425984159262192, -13.316998960395519],
            [29.408984406689537, -13.319998940175148],
            [29.405984196235618, -13.321998843605869],
            [29.399984494878389, -13.322998878775245],
            [29.389984512915941, -13.326998971433188],
            [29.384989863766585, -13.32799791683671],
            [29.372997924255447, -13.324999852333651],
            [29.372993155099625, -13.325001044339961],
            [29.372984753156771, -13.324998944473464],
            [29.364984550374199, -13.326998982869318],
            [29.357984778865635, -13.33299899228078],
            [29.354984933127774, -13.343998963099239],
            [29.348984871546072, -13.34799887799967],
            [29.342995639155152, -13.347998880638563],
            [29.335997896042535, -13.344999805098723],
            [29.328997705020758, -13.338999925838802],
            [29.322997951561234, -13.334999865334765],
            [29.315997760539453, -13.331999905937073],
            [29.315995511157986, -13.332003504723028],
            [29.315985048479856, -13.331999020975289],
            [29.310985058846132, -13.339999005751899],
            [29.309985358800727, -13.360998976406343],
            [29.30698514924514, -13.367999023608313],
            [29.298985305788669, -13.374999042665682],
            [29.290985460535577, -13.378998962113862],
            [29.280985471386618, -13.3809990751567],
            [29.260985853313127, -13.386998957168283],
            [29.247985651015323, -13.392999036023836],
            [29.233986101710048, -13.406998972827042],
            [29.220985897615616, -13.411999066839646],
            [29.210986265996162, -13.416999052848221],
            [29.190986289494873, -13.439999026124859],
            [29.182993103452993, -13.442996528239593],
            [29.179998220907024, -13.440999746126408],
            [29.175997904369218, -13.429999882880976],
            [29.169998150011399, -13.415999909331052],
            [29.159998081810688, -13.400999933536436],
            [29.142998181016011, -13.380999952900494],
            [29.132998112815308, -13.373999940620809],
            [29.121997965480155, -13.369999940660158],
            [29.109998098336671, -13.368999755136969],
            [29.109997823452193, -13.368999858043994],
            [29.109986932277685, -13.368998950351294],
            [29.10198707893975, -13.371999147786202],
            [29.086987083089046, -13.376999103145133],
            [29.081987085370475, -13.381999123172118],
            [29.071987449259442, -13.387999150568255],
            [29.053987595094448, -13.395999011606735],
            [29.03898759654879, -13.402999085780165],
            [29.02898759931502, -13.411999149502096],
            [29.019987672232521, -13.417999119887364],
            [29.011995223707466, -13.417999122525469],
            [29.003998381522365, -13.415999919004163],
            [28.998998346972847, -13.410999915455097],
            [28.9909984343461, -13.391999818760189],
            [28.998998345176222, -13.384999777594391],
            [29.00099814232237, -13.377999881263074],
            [28.998998344277926, -13.371999956079863],
            [28.992998230593962, -13.367999922509284],
            [28.992993816272655, -13.368003132869935],
            [28.992987857747377, -13.367999159938668],
            [28.981988145196819, -13.375999166037385],
            [28.975997574316125, -13.375999168675948],
            [28.973998172428693, -13.373999950295625],
            [28.968998136980847, -13.366999905374062],
            [28.967998418070838, -13.352999900142276],
            [28.967998417172506, -13.34299994391905],
            [28.963998459960838, -13.333999905049717],
            [28.949998433650137, -13.315999862556893],
            [28.945998477336765, -13.303999898680608],
            [28.944998397303987, -13.288999887182472],
            [28.941998159900624, -13.271999860240928],
            [28.929998290960505, -13.239999937301958],
            [28.921998377435472, -13.212999830414336],
            [28.913998464808724, -13.190999824515176],
            [28.910998227405365, -13.178999933061878],
            [28.903998393014763, -13.161999856569899],
            [28.896998200196361, -13.157999829424893],
            [28.896993436430385, -13.158001995013853],
            [28.896988361847349, -13.157999095237432],
            [28.885988643906913, -13.162999122592785],
            [28.874998172325661, -13.16299912699429],
            [28.873998544145497, -13.154999942845098],
            [28.869998227607692, -13.150999800897461],
            [28.869989279489168, -13.150999800897461],
            [28.869988553650415, -13.15099907549221],
            [28.862988764175569, -13.150999078133255],
            [28.856992388381503, -13.156995395500406],
            [28.852998325914715, -13.153999914874754],
            [28.846998570658531, -13.144999990540645],
            [28.849998446040832, -13.123999920798095],
            [28.846998567963606, -13.105999792592591],
            [28.841998532515792, -13.097999931124406],
            [28.833998260562911, -13.090999925587816],
            [28.830998383383982, -13.083999893002568],
            [28.833998259664614, -13.081999947103503],
            [28.845998487930828, -13.080999791873202],
            [28.847998285076986, -13.071999794222828],
            [28.845998487032531, -13.066999828488102],
            [28.839998372450243, -13.061999934565174],
            [28.834998337002425, -13.056999939005902],
            [28.833998257867982, -13.048999872648],
            [28.834998336104096, -13.036999983071814],
            [28.833998256071357, -13.026999918169086],
            [28.826998422579056, -13.010999840427248],
            [28.818998509952308, -12.995999926490923],
            [28.79599849098209, -12.972999881897646],
            [28.790998455534275, -12.96399977309256],
            [28.792998612904832, -12.953999889322612],
            [28.789998375501504, -12.945999795990845],
            [28.781998462874757, -12.940999891067612],
            [28.77399855114631, -12.939999862829442],
            [28.773997830697471, -12.940000223202317],
            [28.773989375754027, -12.93999916587363],
            [28.769989443695145, -12.941999220056102],
            [28.764994015706407, -12.943997252623062],
            [28.755998568522237, -12.938999831410944],
            [28.755998568522237, -12.937999970391976],
            [28.751998610412237, -12.924999829685289],
            [28.73999838124768, -12.912999846690207],
            [28.73499834579987, -12.901999995268245],
            [28.73299854685709, -12.885999861853037],
            [28.725998353140355, -12.876999913019407],
            [28.708998448752421, -12.859999918682492],
            [28.697998658048416, -12.850999904560917],
            [28.687998587152787, -12.847999944489494],
            [28.677998516257123, -12.841999915509733],
            [28.666998725553157, -12.826999910227494],
            [28.658998452701979, -12.820999900092444],
            [28.652998698344152, -12.818999922710875],
            [28.63399863478897, -12.816999931886372],
            [28.633998146105451, -12.817000115247779],
            [28.633990204100048, -12.81699927954284],
            [28.625990336389055, -12.81999926592554],
            [28.615990322985578, -12.83099925030432],
            [28.604990236735862, -12.842999174128527],
            [28.599990230932448, -12.850999269053778],
            [28.591990370408006, -12.876999281985629],
            [28.587990437450827, -12.884999332207965],
            [28.581990356106225, -12.890999200947146],
            [28.579990569739834, -12.892999300797817],
            [28.572998071890169, -12.892999303441622],
            [28.568998535988335, -12.886999941514135],
            [28.566998737943855, -12.877999854562056],
            [28.563998499642192, -12.874999869748539],
            [28.554998507881006, -12.866999849724284],
            [28.543998716278708, -12.855999883407314],
            [28.542998637144262, -12.850999912493743],
            [28.538998679034261, -12.820999906263177],
            [28.528998605443672, -12.800999940393609],
            [28.512998778393527, -12.784999970765595],
            [28.50699866381127, -12.778999826461312],
            [28.502998706599566, -12.775999876077222],
            [28.47999868403609, -12.752999939565937],
            [28.464998575895983, -12.733999953472962],
            [28.45699866147261, -12.716999861583512],
            [28.454998862529827, -12.708999863822809],
            [28.453998783395384, -12.706999868609092],
            [28.455998581439871, -12.698999903860612],
            [28.463998854291017, -12.690999859705247],
            [28.476998803263907, -12.683999918800097],
            [28.499998824030758, -12.682999910066806],
            [28.508998816690273, -12.678999840648871],
            [28.513998852138091, -12.673999840369426],
            [28.514998570149796, -12.666999779059012],
            [28.516998728418688, -12.659999873269667],
            [28.522998842102645, -12.63399995648947],
            [28.522998842102645, -12.631999892662384],
            [28.521998762069906, -12.627999893030296],
            [28.515998646589317, -12.617999880130183],
            [28.489998747745211, -12.592999877573323],
            [28.472998840662321, -12.580999948962011],
            [28.450998899029948, -12.568999979068817],
            [28.444998783549359, -12.562999957754574],
            [28.442998624382142, -12.556999794629577],
            [28.449998817200548, -12.529999941327363],
            [28.448998738066102, -12.523999878476438],
            [28.441998903675472, -12.515999926658045],
            [28.416998722843108, -12.507999900232784],
            [28.403998772971921, -12.500999824811903],
            [28.386998865889034, -12.483999897544477],
            [28.345998855311564, -12.444999879724936],
            [28.337998940888191, -12.434999888242002],
            [28.33099874627316, -12.428999883523971],
            [28.326998788163159, -12.424999860141485],
            [28.314998917426419, -12.41899997311722],
            [28.3059989247669, -12.417999977879722],
            [28.305997995010568, -12.41800008912994],
            [28.305991990671203, -12.417999422511631],
            [28.280996539468827, -12.420998850020636],
            [28.264998914189462, -12.412999946847304],
            [28.264993250311594, -12.412999946847304],
            [28.264992162451776, -12.412999402946843],
            [28.258992073920634, -12.412999405595711],
            [28.241992244092863, -12.421999400421614],
            [28.234996753954963, -12.422998765576585],
            [28.228998941754764, -12.419999967111059],
            [28.21999894729862, -12.409999882949842],
            [28.212998751785292, -12.405999915183731],
            [28.203998758227442, -12.404999871137504],
            [28.188999009413475, -12.401000002206633],
            [28.180999094091774, -12.382999999371648],
            [28.18099292715733, -12.382999999371648],
            [28.180992696290311, -12.382999478367275],
            [28.173992530421351, -12.382999481016435],
            [28.16499257459278, -12.386999279947903],
            [28.152992756856637, -12.397999460137545],
            [28.146992668325492, -12.406999449396087],
            [28.143992805519616, -12.413999456494253],
            [28.146992671918781, -12.417999474604983],
            [28.145992599970846, -12.427999424852709],
            [28.138992794326324, -12.428999383802383],
            [28.128993573236915, -12.435998930858007],
            [28.123998895341455, -12.434999898836583],
            [28.117999139186971, -12.429999844756518],
            [28.111999021909753, -12.411999935324832],
            [28.093999032997498, -12.372999887825232],
            [28.086998836585803, -12.358999920282816],
            [28.075999044085211, -12.352999902350382],
            [28.062999091519064, -12.349999842883825],
            [28.062995283560568, -12.349999842883825],
            [28.062993164434815, -12.349999353607],
            [28.060993013352437, -12.349999354490189],
            [28.04599332292895, -12.350999441478752],
            [28.037993078823845, -12.350999444128256],
            [28.030993270484394, -12.350999445894608],
            [28.012998795431322, -12.34999967154863],
            [27.997998972955461, -12.340999981017934],
            [27.991999216801013, -12.338999910383711],
            [27.99199497136296, -12.338999910383711],
            [27.991993560109652, -12.338999439633438],
            [27.988993333486086, -12.338999440516652],
            [27.984993391545768, -12.340999512920906],
            [27.975993432123914, -12.344999435561791],
            [27.961993455220547, -12.352999444873035],
            [27.954997835725266, -12.353998919700567],
            [27.949999123495839, -12.349999847299694],
            [27.947998964328622, -12.339999861521953],
            [27.952999000674769, -12.326000041055968],
            [27.952998999776437, -12.313999920302347],
            [27.944999084454771, -12.297999892006089],
            [27.93299921102307, -12.276999909514766],
            [27.924998934578635, -12.24799998740459],
            [27.920998976468638, -12.241999868798096],
            [27.917999098391377, -12.23999991549713],
            [27.917995550046008, -12.240000703619712],
            [27.917993688736757, -12.239999463121787],
            [27.908993727518272, -12.241999419076862],
            [27.889993725946859, -12.241999424378083],
            [27.879993688288884, -12.241999427028707],
            [27.865995140605133, -12.243999215675499],
            [27.851999257324511, -12.241999871448694],
            [27.826999071102264, -12.230999938957892],
            [27.817999076646117, -12.229999922499262],
            [27.817998955373543, -12.230000043549634],
            [27.817994015537806, -12.229999494846815],
            [27.813994072699156, -12.233999540345835],
            [27.81999417470502, -12.253999545553839],
            [27.816993948081457, -12.259999565395409],
            [27.815994231866373, -12.259999566278903],
            [27.80899406150586, -12.263999504749663],
            [27.783994319949645, -12.269999476962107],
            [27.774994356036235, -12.273999613308609],
            [27.764994318378228, -12.285999474622374],
            [27.757995309539368, -12.288999055441696],
            [27.725999329548632, -12.282999935138559],
            [27.711999296949745, -12.280999945227487],
            [27.711998683400395, -12.281000125442384],
            [27.7119945978625, -12.280999541510775],
            [27.694995811877089, -12.285999178686913],
            [27.679999273641911, -12.282999936905345],
            [27.679996655052872, -12.282999936905345],
            [27.679994675165968, -12.282999541142335],
            [27.672999610829528, -12.282999542909145],
            [27.672994501212173, -12.282999542909145],
            [27.655996210198492, -12.286999113480972],
            [27.646999920394581, -12.284999978560135],
            [27.631000079869743, -12.274999949410033],
            [27.627999839771419, -12.269999966389973],
            [27.626000039930339, -12.260000064560298],
            [27.61899983992539, -12.233000032831741],
            [27.613000080177653, -12.223999988050496],
            [27.608000040238252, -12.221000021697833],
            [27.60199992026611, -12.218000020888251],
            [27.575999999862436, -12.214999985629596],
            [27.564999839950897, -12.210000084499823],
            [27.546999840258806, -12.194999985135759],
            [27.525999959794571, -12.173999986352566],
            [27.51500016010743, -12.157000055524561],
            [27.507999960102513, -12.137000034489391],
            [27.506999880069742, -12.100999969729054],
            [27.497000160415375, -12.066999979671417],
            [27.4910000404432, -12.060999952945778],
            [27.483000119731617, -12.058000064535253],
            [27.474000119885588, -12.052000009824271],
            [27.471999959820039, -12.048000014574503],
            [27.466999919880639, -12.034999968229098],
            [27.464000040006788, -12.016000001533932],
            [27.4659998398479, -11.999999959090946],
            [27.467999999913413, -11.980999958425853],
            [27.471999959820039, -11.960000053166858],
            [27.467999999913413, -11.938000018229006],
            [27.462999959974013, -11.928000044972574],
            [27.450000000221358, -11.913999984486056],
            [27.434999880403154, -11.905000012646468],
            [27.407000160158407, -11.895000042396576],
            [27.397000080279604, -11.875999990263772],
            [27.38400011962862, -11.872000003042729],
            [27.36899999981042, -11.860000037743426],
            [27.351000000118361, -11.852999913939183],
            [27.330999840360757, -11.835999914406083],
            [27.317999879709774, -11.829999991540948],
            [27.302000040083236, -11.816999935254414],
            [27.290999880171658, -11.80999993089412],
            [27.286999920265032, -11.808999915357303],
            [27.271000079740194, -11.802999921530686],
            [27.270996215187814, -11.802999663995653],
            [27.270995930421869, -11.802999556910626],
            [27.255997335943036, -11.801999793398405],
            [27.24599988004319, -11.801000011149169],
            [27.239000040262678, -11.796000084283403],
            [27.231999840257764, -11.787000052410121],
            [27.231000120449423, -11.783999916960115],
            [27.227999880351103, -11.778000074880406],
            [27.226000079611694, -11.660000065626674],
            [27.226000079611694, -11.656000072053008],
            [27.222999840411699, -11.629000048528576],
            [27.222000119705068, -11.623999969274077],
            [27.213000119859039, -11.586999979124251],
            [27.209000159952414, -11.573000004807838],
            [27.20599991985409, -11.567999968010819],
            [27.205996114590551, -11.567999968010819],
            [27.205995904384764, -11.567999618135275],
            [27.199996161705037, -11.567999619021034],
            [27.192995982361357, -11.57599963606301],
            [27.184996085904292, -11.582999637693637],
            [27.176996188548902, -11.586999635472683],
            [27.165996060078356, -11.595999547945627],
            [27.156996086283478, -11.59999971055977],
            [27.14799894577498, -11.599999712331083],
            [27.136000080253055, -11.595999889814609],
            [27.135996665756654, -11.595999688767332],
            [27.135996262413091, -11.59599955414533],
            [27.118996386771233, -11.594999641258358],
            [27.113996360306555, -11.597999733932488],
            [27.099996358250372, -11.603999647724111],
            [27.08899622888153, -11.605999757929002],
            [27.0780001203719, -11.605000036314864],
            [27.07799645614384, -11.604999712169842],
            [27.043996341940765, -11.602999594703936],
            [27.03799659746441, -11.604999720140619],
            [27.027996544535053, -11.610999656826115],
            [27.024996312521608, -11.616999638106766],
            [27.02499631521653, -11.627999762238444],
            [27.024996319708116, -11.651999706668123],
            [27.029996348867719, -11.660999783728462],
            [27.0379966100408, -11.669999742368875],
            [27.03799987901014, -11.669999742368875],
            [27.038000160182797, -11.670000058468315],
            [27.038996517597035, -11.670000058468315],
            [27.044996434549962, -11.679999720736802],
            [27.04899638816838, -11.69899975161116],
            [27.047996312627188, -11.707999695076536],
            [27.043996363500327, -11.714999682839066],
            [27.031996515221479, -11.722999651640245],
            [27.023996619662714, -11.742999776231834],
            [27.014996642274578, -11.750999803432247],
            [27.012996487598915, -11.752999730093931],
            [27.007996462930901, -11.7669996800884],
            [27.005996670276296, -11.779999667320157],
            [27.005996672971254, -11.791999659487399],
            [27.004996596531736, -11.79899977624105],
            [26.999996570965386, -11.809999621152063],
            [26.998996494525905, -11.816999625520371],
            [27.007996475507291, -11.833999761434219],
            [27.009996631979583, -11.838999690889018],
            [27.007996478202251, -11.846999704579492],
            [27.000996656388043, -11.853999632940623],
            [26.995996629025072, -11.85399963382544],
            [26.985996574299087, -11.861999732428886],
            [26.979996471394923, -11.87699980436391],
            [26.970996494006759, -11.879999613654052],
            [26.967996622217747, -11.885999658248162],
            [26.962996597549694, -11.902999674360592],
            [26.953996621059861, -11.918999712509866],
            [26.936996743621375, -11.933999776010516],
            [26.922996737073607, -11.94099973009423],
            [26.90799665408635, -11.954999614922912],
            [26.90299698694778, -11.964999637142915],
            [26.901996909609963, -11.96599977726291],
            [26.899996754934332, -11.969999771364281],
            [26.896996882246988, -11.974999812774696],
            [26.890996776647867, -11.979999761337314],
            [26.883996953935331, -11.984999791242315],
            [26.878998384538047, -11.984999792126686],
            [26.855999999603345, -11.980999958425853],
            [26.85599962949744, -11.981000143268368],
            [26.85599693455158, -11.980999674528995],
            [26.851996983628126, -11.982999655928941],
            [26.83499710259639, -11.98999973617882],
            [26.82799837313355, -11.992999066272269],
            [26.816000040312577, -11.985999969567896],
            [26.798000039722186, -11.967000029499774],
            [26.790000119908935, -11.963999961160539],
            [26.789997445624344, -11.963999782497535],
            [26.789997194096056, -11.963999688743677],
            [26.774997105718885, -11.962999719794098],
            [26.768996999221432, -11.965999800258944],
            [26.763996970061832, -11.96699976150831],
            [26.761997174712302, -11.969999795244458],
            [26.759997018240046, -11.970999741505715],
            [26.754996989978739, -11.973999731152466],
            [26.741997058073828, -11.987999648125678],
            [26.729997204405098, -11.996999823499074],
            [26.723997097009317, -12.002999712433772],
            [26.717997350736333, -12.008999642057036],
            [26.707999824767882, -12.00899964382568],
            [26.703000000424151, -12.002999974198637],
            [26.691999839614276, -11.991999929489584],
            [26.669000160207226, -11.987000030936874],
            [26.663000040235048, -11.985999969567896],
            [26.662998885001617, -11.985999969567896],
            [26.662997375831925, -11.985999717514636],
            [26.635999668794433, -11.985999721936638],
            [26.629999919826492, -11.982000038557191],
            [26.624999879887095, -11.980000051426165],
            [26.610000120293329, -11.978000048407214],
            [26.601999840255605, -11.971999950236979],
            [26.597999880348979, -11.971000008608748],
            [26.597999438377872, -11.971000292516253],
            [26.597997337218395, -11.970999767154687],
            [26.583997323484116, -11.979999811749094],
            [26.569998733579567, -11.981999649416503],
            [26.559000000192651, -11.978999963792154],
            [26.54399988037445, -11.9660000691359],
            [26.533000079789012, -11.960000053166858],
            [26.521999919877437, -11.957000083075988],
            [26.508999960124783, -11.950000021561534],
            [26.48699999962777, -11.928999971444878],
            [26.46799991990294, -11.919999974231283],
            [26.444000160463116, -11.914999962320334],
            [26.443998931567819, -11.914999962320334],
            [26.443997882335573, -11.914999743816164],
            [26.427997708535749, -11.914999745585417],
            [26.408997660251949, -11.919999760154241],
            [26.40799794224024, -11.920999892527945],
            [26.39199777023704, -11.929999857915318],
            [26.37399780018939, -11.938999874617126],
            [26.364997814716382, -11.943999791325485],
            [26.350997799185475, -11.955999703160948],
            [26.334997984711752, -11.96499972558961],
            [26.329997952857195, -11.965999865709275],
            [26.321999446992205, -11.965999867478198],
            [26.312000039951528, -11.962999989558568],
            [26.301999960072759, -11.958000077144964],
            [26.298000000166102, -11.953000070252868],
            [26.286999840254559, -11.947999969803458],
            [26.279999999575715, -11.945999903966603],
            [26.279997988247814, -11.945999696102088],
            [26.250999839972085, -11.942999952741461],
            [26.211999959815792, -11.928000044972574],
            [26.211998806378951, -11.928000150238692],
            [26.211998045505911, -11.927999857439627],
            [26.200998261988452, -11.928999784797181],
            [26.196997948145604, -11.932999804522398],
            [26.191998275617149, -11.938999898500025],
            [26.182999562158599, -11.938999899384589],
            [26.169999840459475, -11.934999977288291],
            [26.169999007721199, -11.935000109088657],
            [26.169997986336732, -11.934999795067622],
            [26.15099829288749, -11.937999837779499],
            [26.136998272864965, -11.93999978918708],
            [26.068998323834879, -11.942999782025291],
            [26.035998625634463, -11.941999923781012],
            [26.011000079735911, -11.93900008337161],
            [26.010999926124008, -11.939000098409032],
            [26.010998437615584, -11.938999919729298],
            [25.98999925514229, -11.940999765476093],
            [25.980999840099507, -11.936999949348499],
            [25.977999960225656, -11.932999990282681],
            [25.980000120291169, -11.928000044972574],
            [25.988000040104456, -11.918000051252312],
            [25.990999919978311, -11.910000034087515],
            [25.989999839945533, -11.905000012646468],
            [25.986999960071682, -11.898000001985203],
            [25.975000080351769, -11.88599996259456],
            [25.959999959635269, -11.878000050046795],
            [25.95999883314791, -11.878000136752686],
            [25.959998374108793, -11.877999891675783],
            [25.933999369986726, -11.879999694166091],
            [25.918999920311723, -11.875000043272005],
            [25.90599995966074, -11.86100004045645],
            [25.898000039847489, -11.84700001604882],
            [25.894000079940827, -11.835999914406083],
            [25.890000120034198, -11.81299995444075],
            [25.886999879935914, -11.806000022685078],
            [25.880000040155398, -11.799999963245286],
            [25.872000120342147, -11.798000030706064],
            [25.871999798745282, -11.798000174078712],
            [25.871998630935391, -11.797999882023287],
            [25.862998640970829, -11.801999908448852],
            [25.849998697387861, -11.814999805339573],
            [25.835998673772078, -11.823999789368166],
            [25.823998448200815, -11.827999784392279],
            [25.818998413651297, -11.827999785277211],
            [25.797999512350696, -11.826999884105165],
            [25.783999919926288, -11.823999934496902],
            [25.746999839611075, -11.817999920327749],
            [25.741000079863337, -11.816999935254414],
            [25.740999354024581, -11.816999902511112],
            [25.740998735983677, -11.816999798971436],
            [25.71899998731395, -11.815999865951579],
            [25.714000080325221, -11.81299995444075],
            [25.707999960353042, -11.807000049308341],
            [25.697999879575946, -11.791000064241418],
            [25.688000159921579, -11.787999973060865],
            [25.677000000010004, -11.782000043351864],
            [25.673000040103378, -11.774000048319797],
            [25.655000040411323, -11.732999947082465],
            [25.649999999573591, -11.728999963950013],
            [25.64999890003568, -11.728999963950013],
            [25.64999874103389, -11.728999836475252],
            [25.645998784720518, -11.728999837360503],
            [25.63499863648704, -11.737999850472329],
            [25.628999680731471, -11.737999850472329],
            [25.621999920002732, -11.735999940144664],
            [25.608999960250049, -11.734000066471733],
            [25.608999546126718, -11.734000066471733],
            [25.608998742134549, -11.7339999425402],
            [25.600998830406105, -11.733999943425436],
            [25.593998636689367, -11.735999817984519],
            [25.591998838644916, -11.741999881990495],
            [25.583998926916472, -11.754999831468915],
            [25.576998777217192, -11.761999803514341],
            [25.562999880088807, -11.760000106822613],
            [25.562999813613487, -11.76000014488366],
            [25.562998707787361, -11.759999987328639],
            [25.548998681476657, -11.767999866521787],
            [25.531998777088724, -11.777000001412663],
            [25.517998749879688, -11.778999912771196],
            [25.505998882736201, -11.785999828037296],
            [25.497000000394397, -11.785000024802619],
            [25.487999999650036, -11.77900002871646],
            [25.48400003974341, -11.77199992397734],
            [25.48400003974341, -11.761999966379019],
            [25.490000159715589, -11.757000025231697],
            [25.494999840328848, -11.743999996090993],
            [25.49699997164829, -11.726000332884887],
            [25.508135115109418, -11.729862021210632],
            [25.508134639900621, -11.729861581247098],
            [25.508136239800152, -11.729862136291651],
            [25.531746001947567, -11.739346717669434],
            [25.536829320205353, -11.734463870902927],
            [25.540156278470818, -11.73404337344941],
            [25.544756160273636, -11.733461988959755],
            [25.545021324979192, -11.733221871077744],
            [25.551693359631077, -11.727179990233614],
            [25.559934479793053, -11.712144980108574],
            [25.572431179967356, -11.702123896485107],
            [25.574307946547169, -11.697626688810667],
            [25.578119519857257, -11.688492967364004],
            [25.583753102938985, -11.684506004072933],
            [25.599893400448394, -11.673082972887133],
            [25.605127464994034, -11.659453686338257],
            [25.607609251409269, -11.652990981593947],
            [25.609083480215286, -11.652000021017329],
            [25.609503475848271, -11.651717463450552],
            [25.611778440440698, -11.650186946282723],
            [25.612751500946342, -11.650358953045721],
            [25.616689200417269, -11.651055013989669],
            [25.624437479661566, -11.655114902770325],
            [25.625447268685935, -11.655142708631656],
            [25.630506360278837, -11.655282019478603],
            [25.638620400269154, -11.650363948128527],
            [25.656553440438262, -11.646952887547787],
            [25.674360389480853, -11.632271102848808],
            [25.682396400008958, -11.62045303524622],
            [25.675989479756996, -11.590159018851361],
            [25.681490280161658, -11.581358910145218],
            [25.682930280460404, -11.575764857670332],
            [25.683517023173078, -11.573479847802444],
            [25.68439619985007, -11.570055951296851],
            [25.689666240126208, -11.561488927999827],
            [25.688054416368107, -11.558649050231539],
            [25.686811486679737, -11.556459107093691],
            [25.687472123909348, -11.555118773013843],
            [25.688179343278055, -11.553684114414164],
            [25.694965439716459, -11.555451021250452],
            [25.702123320104892, -11.548932978387455],
            [25.705526399810903, -11.540384896880047],
            [25.707032297823957, -11.540470965096452],
            [25.712297279686737, -11.540771878979951],
            [25.722525509189797, -11.529733127986038],
            [25.728660360284909, -11.523111918934745],
            [25.731374399828642, -11.495249944728862],
            [25.733504485030355, -11.484975401751804],
            [25.734911354563117, -11.478189108372032],
            [25.7368631520287, -11.476299397193758],
            [25.740679320221442, -11.472604934882552],
            [25.748714117125637, -11.468393355476952],
            [25.754125320462162, -11.465556942680859],
            [25.760637359772005, -11.463874911743861],
            [25.768125360247591, -11.466092010700713],
            [25.774797240389205, -11.45819796373819],
            [25.776844199986108, -11.453573956447936],
            [25.77688087999579, -11.453233317066848],
            [25.777687320084201, -11.44574401495772],
            [25.773588360443384, -11.434288950940619],
            [25.773779520139193, -11.430605895488162],
            [25.777254239590793, -11.428498015317034],
            [25.779972239806593, -11.421566007481541],
            [25.778324520268075, -11.420204983297175],
            [25.780087084924119, -11.415178423203621],
            [25.781482439851555, -11.411199024979897],
            [25.78123572744024, -11.40901022702562],
            [25.780964400291825, -11.406603030458511],
            [25.77787437178425, -11.401577977720121],
            [25.77113927989101, -11.403952894686743],
            [25.760172239965652, -11.40315488169905],
            [25.758039581090692, -11.400187442115133],
            [25.761631242327638, -11.394179721043859],
            [25.763300015681498, -11.391388343232785],
            [25.759475817448401, -11.387436808028536],
            [25.756693067565209, -11.384561362588487],
            [25.755953400150183, -11.380888909626277],
            [25.757833279392404, -11.371200366845869],
            [25.758592200398954, -11.367288938337516],
            [25.75854639170937, -11.36322416304338],
            [25.758501448097384, -11.359238590436627],
            [25.756581239888771, -11.338553528325511],
            [25.770590640119455, -11.311393192196245],
            [25.789642559822717, -11.295487158476698],
            [25.802980920332796, -11.28345592661856],
            [25.809659280022579, -11.273730096033963],
            [25.815394800329468, -11.260888393942039],
            [25.814904714544749, -11.245132666130971],
            [25.814807639900209, -11.242011703289252],
            [25.809448319661243, -11.230744719530465],
            [25.795856880379421, -11.216796413717971],
            [25.790502240363068, -11.203673046607896],
            [25.790608079869859, -11.160685065273904],
            [25.793529120001114, -11.13261015275279],
            [25.82970480021045, -11.111556589069149],
            [25.849386720100554, -11.097202337828978],
            [25.854194879895239, -11.07473788562479],
            [25.866588960124748, -11.060198240403707],
            [25.87358879990526, -11.048616400798144],
            [25.879564368022397, -11.039481013492011],
            [25.878214440000555, -11.036561005724199],
            [25.878621838558306, -11.032331527547454],
            [25.878835439966572, -11.030113960138534],
            [25.882703280152793, -11.022478943091004],
            [25.88256270908219, -11.020605081574232],
            [25.882427346443595, -11.018802854228781],
            [25.877115907307591, -11.016142248316731],
            [25.87703939959146, -11.016103923918896],
            [25.924794479695755, -10.971919241536142],
            [25.931472840283831, -10.962182874833569],
            [25.947269870861934, -10.951874115388728],
            [25.94915196175641, -10.956320967052468],
            [25.953014040148414, -10.957794943329297],
            [25.962304919873308, -10.959625020358081],
            [25.973129079159495, -10.962935055446909],
            [25.984757717511794, -10.964016977363839],
            [25.99523769987325, -10.963989036014683],
            [26.004906956284074, -10.966559925413401],
            [26.020392714327997, -10.969487070295219],
            [26.02695695384071, -10.972066054314682],
            [26.035472033214933, -10.973897987539209],
            [26.044752832045738, -10.976470918128191],
            [26.065182787157759, -10.979379027510696],
            [26.069562950025247, -10.975874961763235],
            [26.080231909176366, -10.972755064159976],
            [26.096661947500891, -10.964963930811233],
            [26.106319132350922, -10.955415006731572],
            [26.116777011664826, -10.954135932829292],
            [26.12345098398275, -10.948072964934035],
            [26.141556822283263, -10.92599895684616],
            [26.149306901751409, -10.913251994193724],
            [26.151532780600068, -10.905404072570834],
            [26.151093941007339, -10.897819938294774],
            [26.150934022920485, -10.895061797787267],
            [26.151858940913414, -10.894590034322629],
            [26.154740628547025, -10.893161813008684],
            [26.157247983710171, -10.891919114040329],
            [26.159953899788785, -10.890577996617345],
            [26.163280354997674, -10.886856480106353],
            [26.166606709595253, -10.883135024826215],
            [26.168376859625557, -10.882829824275325],
            [26.169665114709872, -10.882607700945107],
            [26.173804987222027, -10.881893963385778],
            [26.174458596032853, -10.882129619661075],
            [26.180585828516048, -10.8843389752974],
            [26.183278112660204, -10.88285429726273],
            [26.184669069436016, -10.882087256417355],
            [26.186132778071759, -10.881280073507334],
            [26.188349872295273, -10.881588536909721],
            [26.195223758391453, -10.882544899347478],
            [26.199671692858928, -10.881064608242985],
            [26.200375855260678, -10.880830266092886],
            [26.202407965705923, -10.880153980321763],
            [26.203390875340347, -10.880796345692939],
            [26.20474310754091, -10.881680076362548],
            [26.208276018958284, -10.883988987312495],
            [26.213377968275108, -10.883750813582596],
            [26.213562316944458, -10.883742208152684],
            [26.215022672169237, -10.88367404038879],
            [26.217639933512437, -10.888011035174831],
            [26.217499893346186, -10.895142980650055],
            [26.219401773228054, -10.898109058588577],
            [26.222204692984306, -10.898763012836417],
            [26.224566155457083, -10.89785299818247],
            [26.225241653516445, -10.897592677657636],
            [26.225907659078214, -10.897336108064037],
            [26.226935852786116, -10.904683054255329],
            [26.224482431574302, -10.907612074218656],
            [26.223041674894066, -10.909332088508654],
            [26.222982634020333, -10.909666908231216],
            [26.222390853555567, -10.913020035714757],
            [26.224074933303537, -10.917138985993402],
            [26.233018772274658, -10.924615935425813],
            [26.229791701278884, -10.926955972740554],
            [26.230485075812421, -10.928453629568711],
            [26.231712608376807, -10.931105207103599],
            [26.2343439328458, -10.93678901362647],
            [26.236222192425586, -10.937487150816935],
            [26.236457113550497, -10.937574469447817],
            [26.239724852177439, -10.938789062315095],
            [26.239926826691008, -10.939467723454309],
            [26.240654316544045, -10.941912181970128],
            [26.241429811467579, -10.944517917191341],
            [26.251042989648464, -10.949684997390539],
            [26.251338186830584, -10.949810029444359],
            [26.255257742129409, -10.951469950033554],
            [26.258487118202169, -10.949360063465189],
            [26.26457384924246, -10.951811950888922],
            [26.265397889123939, -10.961232008459364],
            [26.268057604847495, -10.97019017111316],
            [26.271039422295942, -10.98023287361497],
            [26.271247852103119, -10.98093513105497],
            [26.269707809126086, -10.987625973732657],
            [26.271708688742176, -10.991453958413079],
            [26.272574880271723, -10.993110970560227],
            [26.277934840111186, -10.993499974675343],
            [26.278955306511026, -10.994481568581042],
            [26.28049028837971, -10.995958026199819],
            [26.281001787305836, -10.996450014062427],
            [26.284908777868793, -10.996399563160514],
            [26.284959836312915, -10.996398913475147],
            [26.286849893467316, -10.998445977788244],
            [26.30002196593686, -11.025644985373933],
            [26.300078597528977, -11.025884077375922],
            [26.300564845710827, -11.027936954528029],
            [26.303231725498769, -11.039174929124108],
            [26.31080972458939, -11.048506032695856],
            [26.324166803295025, -11.052521027598734],
            [26.327814682899092, -11.055478963024816],
            [26.330859923203246, -11.061177049664778],
            [26.331255923038363, -11.067064948731618],
            [26.327823683119945, -11.075680924522835],
            [26.324428884084249, -11.081578961808873],
            [26.320535844357654, -11.089290930828959],
            [26.314710684761799, -11.099725004338724],
            [26.315130804362315, -11.103800997288056],
            [26.319282684654837, -11.112396957026109],
            [26.322965844693378, -11.120540922762581],
            [26.320968924851094, -11.128247960006167],
            [26.317968684752771, -11.140033982226083],
            [26.316445885835986, -11.147738905359795],
            [26.320142004970787, -11.154976910710079],
            [26.321924004678003, -11.163578941998981],
            [26.321839764263924, -11.169921005187929],
            [26.320238845155053, -11.183515945206867],
            [26.314886725811423, -11.193949071772035],
            [26.309055806217945, -11.204836958978319],
            [26.310423806546698, -11.208910043309428],
            [26.317953925432658, -11.212966986812763],
            [26.33209976358533, -11.218365019320419],
            [26.345310682801021, -11.222859972020496],
            [26.355677960730304, -11.22736298436973],
            [26.360398892314297, -11.228708991034333],
            [26.360020840818553, -11.221461920137004],
            [26.358676600929062, -11.21557700789843],
            [26.357374841471074, -11.206519988319382],
            [26.353306842266491, -11.191582046275098],
            [26.350569758240784, -11.180473005892592],
            [26.35018060266982, -11.177093914676279],
            [26.348842843226823, -11.17075589895377],
            [26.34944260252794, -11.161241011383538],
            [26.355237521238074, -11.153070975018968],
            [26.355309521208103, -11.147634938241993],
            [26.355884800519416, -11.139933017839995],
            [26.356016560015387, -11.129965915246119],
            [26.354186681001877, -11.124987891740787],
            [26.35335256112457, -11.116382936595954],
            [26.355805600552383, -11.110034917261784],
            [26.355901720287779, -11.10278605573302],
            [26.354581600163687, -11.09508894678981],
            [26.352277600224674, -11.090111912261099],
            [26.351377600599399, -11.086489994658956],
            [26.349127601087041, -11.07743597435352],
            [26.34732760093819, -11.070193013618942],
            [26.344177601800553, -11.057516910164791],
            [26.344477624732384, -11.053703004779367],
            [26.344747840664823, -11.050267968429589],
            [26.34580264067479, -11.042111056080305],
            [26.348784520107003, -11.031683922099749],
            [26.355095678153013, -11.02034201363414],
            [26.360938836393917, -11.008547925622384],
            [26.372066794231063, -10.991305006606812],
            [26.381748631547406, -10.975876890541464],
            [26.389007669423357, -10.964532983779467],
            [26.396266707299308, -10.953187928774687],
            [26.401149746164549, -10.942302940092361],
            [26.40813158370673, -10.929454957567369],
            [26.418914661238322, -10.918039893425725],
            [26.42636468004536, -10.918169936340229],
            [26.427381904425339, -10.917524650189396],
            [26.44043999146508, -10.909241008678025],
            [26.466949809098722, -10.912230015576267],
            [26.474082487251888, -10.910398934683858],
            [26.480267644901218, -10.90856996513148],
            [26.489824562494157, -10.902656036676925],
            [26.494625856465159, -10.899697678264298],
            [26.497947600908702, -10.897650939137817],
            [26.506040757763596, -10.894912051983919],
            [26.514115555749076, -10.893531007816254],
            [26.523588593152372, -10.893959035265841],
            [26.531141752028756, -10.896203909342347],
            [26.541058668573502, -10.89889501044679],
            [26.549595707264803, -10.898419924603127],
            [26.551551586675025, -10.893884010268801],
            [26.556380624215251, -10.88707602537645],
            [26.56117978378915, -10.882533919654627],
            [26.565931781810601, -10.881615013982605],
            [26.566009541778214, -10.875726025459088],
            [26.566572581543813, -10.868928946044765],
            [26.562853782642993, -10.863502990885289],
            [26.56150954275353, -10.857617887421959],
            [26.561160702674204, -10.848106020408682],
            [26.56030246303153, -10.841312905145427],
            [26.560470582736951, -10.828627935824189],
            [26.560554462028296, -10.822286043674469],
            [26.561639502025688, -10.811864004571863],
            [26.564395723760192, -10.805184801040232],
            [26.568472659405234, -10.796896936887487],
            [26.574207458364956, -10.793257051119701],
            [26.578521696568682, -10.789621899069637],
            [26.582348495424512, -10.78689404475665],
            [26.585714494472228, -10.783260939341439],
            [26.588635533705194, -10.777363973183014],
            [26.595162690762955, -10.767607010806604],
            [26.596440690680009, -10.760581920990827],
            [26.601527489011218, -10.752187884859881],
            [26.603510728410072, -10.745614040150626],
            [26.606185527745559, -10.740397915250739],
            [26.605996527599672, -10.736773979153371],
            [26.605093647077272, -10.733378911200946],
            [26.601820528440079, -10.729990000868296],
            [26.599721728864779, -10.727503972724451],
            [26.599413710926882, -10.727261505022089],
            [26.5971416101636, -10.725472928411561],
            [26.594078731438838, -10.724121900098671],
            [26.591033492033013, -10.721412036744228],
            [26.584911692560699, -10.718484024596901],
            [26.582334453858316, -10.71622487953988],
            [26.577400655687981, -10.713067889899936],
            [26.575306535436994, -10.710128995615653],
            [26.571073656750219, -10.707647937284635],
            [26.56022361969568, -10.703826893397821],
            [26.549370702642314, -10.700231905043838],
            [26.535011746375016, -10.693021969276286],
            [26.516630510659539, -10.686250986562239],
            [26.515982725626664, -10.685413608299545],
            [26.510468932888084, -10.678285944242067],
            [26.510180933008009, -10.674378910272708],
            [26.514700857564009, -10.670523658569143],
            [26.517305511052211, -10.668302007760923],
            [26.518895689903548, -10.665787584061878],
            [26.521853929270748, -10.661109896474164],
            [26.527852787109932, -10.65780605429212],
            [26.535134505650166, -10.646666895751952],
            [26.54341561072378, -10.640339969069089],
            [26.554864742326153, -10.627993406916964],
            [26.556746738897498, -10.613477899086229],
            [26.566325795470636, -10.600464970940083],
            [26.559560420470877, -10.599511325865667],
            [26.554442946469319, -10.598789965785439],
            [26.539946622523697, -10.593012997416368],
            [26.53752285020785, -10.593138771458811],
            [26.527863743861431, -10.593640001610844],
            [26.521737648645395, -10.587745954804365],
            [26.519623548065866, -10.586394042538195],
            [26.519330688300094, -10.582028913615625],
            [26.515719889354315, -10.573339916820764],
            [26.520295835546406, -10.568215938328713],
            [26.520108251145409, -10.567906548461547],
            [26.516009508896857, -10.561147020986482],
            [26.514952907764741, -10.561238863114415],
            [26.509740830383986, -10.561691906511122],
            [26.499292270192875, -10.550097427188703],
            [26.497459025191972, -10.548063080257689],
            [26.487418928960498, -10.544750970600328],
            [26.486908525978997, -10.542676314322465],
            [26.485445336569509, -10.536727961234579],
            [26.483982289093831, -10.534731847335731],
            [26.480940657322183, -10.530581943871383],
            [26.479472938606996, -10.525311956898745],
            [26.475453726905506, -10.520537949998777],
            [26.47509659896939, -10.51180289219557],
            [26.472727753243234, -10.510093540223847],
            [26.471342519634099, -10.509093955651199],
            [26.463893761163419, -10.508275955795961],
            [26.45612352350031, -10.501251902085972],
            [26.453803850654502, -10.501513879680115],
            [26.484868795125205, -10.479678036881491],
            [26.490957473713042, -10.476150906355356],
            [26.495596792455135, -10.474778918363013],
            [26.508283549194111, -10.474065899982884],
            [26.513953547282508, -10.475409894317359],
            [26.523882704271337, -10.477195972806236],
            [26.525777744380637, -10.477191010770373],
            [26.536174541848474, -10.479428023686939],
            [26.546151579041894, -10.477588978948143],
            [26.559926614204869, -10.475287986292704],
            [26.56469553379134, -10.473010012193081],
            [26.568510452427525, -10.471187939360716],
            [26.575632690360454, -10.470262989568919],
            [26.585591727112238, -10.469782971367977],
            [26.597433564427568, -10.470205046858062],
            [26.605952601778899, -10.471088002283141],
            [26.612108600114116, -10.471524960579032],
            [26.623500436269346, -10.470134877917332],
            [26.631563715157913, -10.469660884167487],
            [26.638246752375384, -10.466018990620869],
            [26.646351430123818, -10.462374043138432],
            [26.647140552490217, -10.462246467003604],
            [26.654900707462577, -10.46099189275278],
            [26.659166706135537, -10.460980020046673],
            [26.664379504863458, -10.460966907876777],
            [26.671465741913046, -10.462759980117204],
            [26.680428659304159, -10.465907001515237],
            [26.69083769721604, -10.467237919776366],
            [26.699346654571578, -10.467762950206083],
            [26.705996572701125, -10.467744876137635],
            [26.71333265009585, -10.466135939233263],
            [26.718003648824784, -10.464853035443518],
            [26.728614645080523, -10.46704902902416],
            [26.736224683484085, -10.469888929962726],
            [26.742209680318425, -10.469872982784464],
            [26.749524518844879, -10.469854022392179],
            [26.757513636416867, -10.469196985614545],
            [26.765842593847335, -10.467902932621209],
            [26.775485551179901, -10.467877948309043],
            [26.783797587943674, -10.467855975449444],
            [26.793456384371328, -10.466558903542177],
            [26.79978266286022, -10.46590593634086],
            [26.806125500893039, -10.463981932848547],
            [26.813773697933247, -10.463961909577698],
            [26.820410655169866, -10.464898041435225],
            [26.827027454211557, -10.46742290983037],
            [26.833980491765761, -10.469628983562519],
            [26.840588649014371, -10.472789047795068],
            [26.848509366165668, -10.477217936993329],
            [26.857104364159131, -10.481008001715477],
            [26.86404948216579, -10.483849899741898],
            [26.872323359394624, -10.486687871899704],
            [26.881600555981137, -10.489206003620959],
            [26.886200634515021, -10.49332494477556],
            [26.89078847350315, -10.498397931094209],
            [26.897022591132089, -10.504737983275998],
            [26.902317469825832, -10.506630901172285],
            [26.909577586578429, -10.510742873901942],
            [26.910975917624416, -10.511637730468623],
            [26.913534345604745, -10.513274981199581],
            [26.917802503827662, -10.51739501445118],
            [26.920714542839807, -10.52342587646142],
            [26.923614342306163, -10.530409912826505],
            [26.923530463014817, -10.536765951042998],
            [26.920778624160587, -10.543764916004511],
            [26.919705464382805, -10.54948896746231],
            [26.920623464449758, -10.555525039121987],
            [26.920522665390045, -10.563151886177833],
            [26.922088664288879, -10.570457927503984],
            [26.923982623724875, -10.57807997185421],
            [26.924908543339367, -10.583479940355286],
            [26.926457623368133, -10.592056881196239],
            [26.928330343037555, -10.601268899978368],
            [26.93194654175652, -10.604436982338751],
            [26.938891659763176, -10.607278966060511],
            [26.946543457251018, -10.606941032391742],
            [26.948954376471793, -10.600577963670226],
            [26.950701455070639, -10.594216885986388],
            [26.953823373770806, -10.584356897715185],
            [26.956268492752745, -10.575452043568431],
            [26.961012570328354, -10.568765038414465],
            [26.965721369266117, -10.56462090097887],
            [26.972422406026926, -10.5607890082366],
            [26.980444643585102, -10.557589999945298],
            [26.988761359673219, -10.557249885544874],
            [26.999737396226141, -10.556903037635044],
            [27.004900107588767, -10.557920042305105],
            [27.007696634035142, -10.558470929855782],
            [27.014346551266392, -10.558453038047864],
            [27.021981428087535, -10.559385869230496],
            [27.029010425385536, -10.555871884162219],
            [27.03238146398197, -10.552366892050907],
            [27.038051462070371, -10.551079923492319],
            [27.043703459717133, -10.551065042770629],
            [27.049663617235559, -10.552955901906186],
            [27.05395229567451, -10.555486949439521],
            [27.059222334154015, -10.559287023254381],
            [27.065834452074732, -10.562129961501629],
            [27.073132552292503, -10.563382001457171],
            [27.080153723467724, -10.560502944917852],
            [27.087177681216975, -10.557306058876611],
            [27.092872880642378, -10.554113036855476],
            [27.09958579941943, -10.549326894617323],
            [27.101946678885621, -10.54677896724851],
            [27.102341598945763, -10.542010956015149],
            [27.102745878552863, -10.536607060862229],
            [27.103153758607625, -10.530884893181588],
            [27.10319587791637, -10.527707006140886],
            [27.105902718361396, -10.524203992576867],
            [27.109319836938639, -10.517202983732599],
            [27.115376836437964, -10.511783942406682],
            [27.120468674317923, -10.50382502297076],
            [27.12552379356066, -10.498726966364782],
            [27.131264712742439, -10.49203703410609],
            [27.136011671215172, -10.485032982502089],
            [27.141402669644311, -10.479616028379141],
            [27.148136829086262, -10.473241965780417],
            [27.154530787546971, -10.467503901792627],
            [27.160249746513308, -10.462403999955828],
            [27.169719543693372, -10.450302002237555],
            [27.174100742318377, -10.445841003969145],
            [27.179488861647055, -10.440741981277048],
            [27.185544780473069, -10.435323003537519],
            [27.187909619713039, -10.432456023036355],
            [27.187976578337686, -10.429631092478168],
            [27.184336620976122, -10.426110043909606],
            [27.181117760582051, -10.42227245113077],
            [27.180080701400627, -10.421036036621963],
            [27.176802541418059, -10.417548993027744],
            [27.173868543088801, -10.413107013955852],
            [27.167651703656038, -10.40549591634181],
            [27.165483747278557, -10.402911131141749],
            [27.163396864753818, -10.400422987666389],
            [27.15947754571193, -10.395030062363572],
            [27.155239626578108, -10.388684906338561],
            [27.151021866537583, -10.380750974329663],
            [27.144834548439999, -10.370916004142545],
            [27.139278668732004, -10.363620976196497],
            [27.13537662968292, -10.356956995971148],
            [27.130481710598097, -10.349978939481243],
            [27.126882790973632, -10.345539000809081],
            [27.122294591761069, -10.340465974547183],
            [27.119352672985968, -10.336659997352523],
            [27.113127553781222, -10.329685029458419],
            [27.108876674652777, -10.324294061511408],
            [27.105597795119667, -10.320805926261169],
            [27.09734371586136, -10.316379044179993],
            [27.092426083772892, -10.312959124664719],
            [27.083508559151412, -10.306564014319859],
            [27.078247879320529, -10.302128065471388],
            [27.070577121091958, -10.297668218906955],
            [27.061748723719731, -10.292637924246778],
            [27.059798257557382, -10.291822895698166],
            [27.056457803901427, -10.290427038725815],
            [27.051200725416511, -10.285674024239544],
            [27.044609846364072, -10.281242919165567],
            [27.039007886675265, -10.277444018570296],
            [27.031106609066722, -10.271425895753287],
            [27.026165610001055, -10.267943905851787],
            [27.021569850567083, -10.263507051471155],
            [27.014969611069354, -10.25971006412597],
            [27.012565904422004, -10.257637271891657],
            [27.008723612322438, -10.254323913822333],
            [27.005444732789329, -10.250836945606091],
            [27.000183694530641, -10.246401977579096],
            [26.993633855011929, -10.238791933786494],
            [26.988381816075798, -10.233720892894979],
            [26.982168577090668, -10.225792050020903],
            [26.979945577342502, -10.217852898960771],
            [26.980703736577677, -10.210858959424138],
            [26.983763737100244, -10.205766007612825],
            [26.98614585633301, -10.201627990381114],
            [26.989890575223011, -10.194944053564761],
            [26.993948853757907, -10.189848006837364],
            [26.997689612874133, -10.183481998835783],
            [27.006818851543478, -10.172017044733689],
            [27.010875690078958, -10.166920981244159],
            [27.015615047906049, -10.158029541156084],
            [27.01903688982507, -10.153232928439659],
            [27.021771808910934, -10.147505984708328],
            [27.024520767766372, -10.14082391496728],
            [27.026919807665834, -10.135414973982432],
            [27.03032360692238, -10.129368054529085],
            [27.034078766032618, -10.122048056141791],
            [27.039869724968977, -10.111545032122606],
            [27.042592763835202, -10.106769976687955],
            [27.04835879092915, -10.098173907507729],
            [27.054414522905638, -10.092754999429891],
            [27.061838439365452, -10.084472933196595],
            [27.070277556300915, -10.074915903592917],
            [27.076346433324925, -10.068542972626135],
            [27.079742312135604, -10.063131912396432],
            [27.083139270721254, -10.057719874461474],
            [27.08752946866878, -10.052623037921538],
            [27.090597387840557, -10.046893924074709],
            [27.095369544955339, -10.037982888774158],
            [27.099418463044945, -10.033522929859785],
            [27.099805463557541, -10.029389938600465],
            [27.098534303413086, -10.024943877984489],
            [27.096589583773603, -10.021136039642904],
            [27.094657464802641, -10.016374002310661],
            [27.092085265649043, -10.009706925481563],
            [27.089825547263619, -10.004627956862029],
            [27.085014507470106, -9.991292997916139],
            [27.081386429429859, -9.989077875420339],
            [27.076120351622421, -9.984959927488401],
            [27.071533593307599, -9.979886956609208],
            [27.067601314271091, -9.97544802037212],
            [27.064364555843312, -9.968782932536708],
            [27.063771276090325, -9.963381900782881],
            [27.063211475649666, -9.955437967163617],
            [27.063286354720191, -9.949716878832945],
            [27.065711313710537, -9.942400929746848],
            [27.069452432152872, -9.936034948060932],
            [27.073185271721592, -9.930304994892655],
            [27.074229270388592, -9.926805950071433],
            [27.074961509634559, -9.921718928233185],
            [27.069717392042563, -9.916011976981004],
            [27.059114316232669, -9.913180029885851],
            [27.045478601685435, -9.913534867331458],
            [27.035903346782614, -9.919272027615195],
            [27.033858630278964, -9.921831870101681],
            [27.026330803893597, -9.915283162761648],
            [27.023648663525627, -9.921532689761635],
            [27.016419804551632, -9.919116145465884],
            [27.007397456417984, -9.935121024228676],
            [27.008414456219121, -9.940623877908267],
            [27.006371631567458, -9.943414701189887],
            [26.999240202072592, -9.941314011775683],
            [26.995000500681229, -9.940064954400663],
            [26.991308973734121, -9.938978195107817],
            [26.990058650910974, -9.938610107338],
            [26.988007503368241, -9.940941945626358],
            [26.986966384700033, -9.948315966888135],
            [26.982600306517902, -9.950911903486269],
            [26.984297345362165, -9.955482872559124],
            [26.97153587214774, -9.955221980700081],
            [26.965411514273491, -9.949339125267862],
            [26.963341393413625, -9.95052089938247],
            [26.95928851465192, -9.958169978374588],
            [26.958637678042038, -9.958229862709807],
            [26.956277475905587, -9.958447028937242],
            [26.952729317382911, -9.954132923137035],
            [26.949248649287501, -9.953957042973048],
            [26.943305601081953, -9.959565879039975],
            [26.941223364643868, -9.959827140526645],
            [26.941237795180577, -9.960753130883379],
            [26.941298601243872, -9.964654966045213],
            [26.939482532031175, -9.967212785849235],
            [26.937726349006947, -9.967123190272003],
            [26.936000483225193, -9.967034957198521],
            [26.935816279184607, -9.966912827402988],
            [26.932952538093744, -9.965014122166538],
            [26.930560548172636, -9.97516592718485],
            [26.928961405931393, -9.973815973024879],
            [26.924307042204912, -9.969886339596281],
            [26.922803608270691, -9.968616995207444],
            [26.919490050174328, -9.966996588209271],
            [26.913685589559229, -9.964158053105347],
            [26.908816532971407, -9.96423203283393],
            [26.908089371003442, -9.977118275835863],
            [26.900710424206729, -9.965045967243741],
            [26.900516192272644, -9.965040566965763],
            [26.895373418119433, -9.964897937790393],
            [26.894351532381446, -9.965622124909867],
            [26.892390850577709, -9.9670116089767],
            [26.886050641913691, -9.962050023554481],
            [26.884263462520583, -9.966445020904251],
            [26.888667340911542, -9.981092875881689],
            [26.886193502789965, -9.986189796114816],
            [26.883864582686638, -9.985534929240464],
            [26.882129383409108, -9.978434002736327],
            [26.879812958871408, -9.978797262079301],
            [26.878890464533082, -9.978941927028742],
            [26.872956603397949, -9.985239958607469],
            [26.870396626722094, -9.984819023125926],
            [26.867768641291011, -9.9798000271762],
            [26.867540471903784, -9.979719128230002],
            [26.863923469192684, -9.978437019784518],
            [26.860645623620432, -9.97727407562882],
            [26.860304322202978, -9.977153019227437],
            [26.855212611883776, -9.977920923360871],
            [26.848569475136284, -9.983307877122824],
            [26.843120462607793, -9.984314359314856],
            [26.839083987981478, -9.985059931506422],
            [26.836100519429536, -9.987172955468209],
            [26.835934559274033, -10.000000018233663],
            [26.835889559068203, -10.003501994070982],
            [26.834349480158586, -10.009042896046607],
            [26.83114167173747, -10.011619765460091],
            [26.825055104190586, -10.012466558997096],
            [26.821881605125114, -10.012908018764419],
            [26.814789606281309, -10.019451880953463],
            [26.81155789638542, -10.020628135855768],
            [26.81017656865113, -10.021130901193187],
            [26.802510371169287, -10.020554015974872],
            [26.801990322078282, -10.02081239995646],
            [26.79583237350057, -10.023871932303043],
            [26.790028837251946, -10.023728031979124],
            [26.783915657114747, -10.018300942909704],
            [26.775083420342959, -10.017282912884246],
            [26.771048541124593, -10.011362935856019],
            [26.770182381036079, -10.010816910146353],
            [26.763554722260945, -10.006645127012478],
            [26.755698715251128, -10.008829893807773],
            [26.752752333645681, -10.007695784994375],
            [26.747066429088548, -10.005506910906348],
            [26.772420500328789, -9.98977692062474],
            [26.776214539422831, -9.986830978433895],
            [26.779346537220501, -9.98225495223223],
            [26.781774376209643, -9.979311958108562],
            [26.782171456718068, -9.975070008463112],
            [26.782612456759022, -9.967564910973557],
            [26.782681576730251, -9.962344888996951],
            [26.782460536373122, -9.95321089019227],
            [26.782576455875709, -9.944401972192367],
            [26.782343535298931, -9.93624688433348],
            [26.78039845633338, -9.928421916965348],
            [26.780122696897351, -9.923528930797138],
            [26.779841536789807, -9.918963011862454],
            [26.777486416422938, -9.916359008060567],
            [26.773433538559527, -9.913106903316343],
            [26.769005539504839, -9.912466987010898],
            [26.761495581508804, -9.912487045399129],
            [26.755680503705371, -9.913480912042122],
            [26.750560585387944, -9.913494048820311],
            [26.740325428975698, -9.913194948056702],
            [26.731796671853004, -9.912891942227098],
            [26.720886514149754, -9.911941918174405],
            [26.70894459912185, -9.911647965081247],
            [26.697339642157072, -9.911679028940419],
            [26.686075605724039, -9.911709028416865],
            [26.675149608925704, -9.912064045613874],
            [26.670024651059524, -9.912403974983306],
            [26.664909412066411, -9.912091027385904],
            [26.654328654899732, -9.912118896286071],
            [26.652071868615405, -9.911816445242172],
            [26.647173658103384, -9.91115999418068],
            [26.641686539938817, -9.913131935280177],
            [26.635512541161962, -9.915431895455674],
            [26.629005543197461, -9.917080040661496],
            [26.623855745117041, -9.91937802041536],
            [26.619059465541969, -9.92069598783416],
            [26.613248707736744, -9.921363934100185],
            [26.60675970931559, -9.921707047629189],
            [26.599254432440492, -9.921401032190342],
            [26.593136593640214, -9.919460027358465],
            [26.589070754883917, -9.917186899920136],
            [26.583669676458978, -9.912634026496898],
            [26.579923517569558, -9.911990914338775],
            [26.575486518294053, -9.912002985017336],
            [26.569001480544994, -9.912020025764928],
            [26.558761643910106, -9.912047894671263],
            [26.553658644462743, -9.910755985883153],
            [26.549605765701035, -9.907504890127397],
            [26.546205566892151, -9.906534969652682],
            [26.540394447964196, -9.907202944257323],
            [26.532544651007949, -9.90722389100628],
            [26.526404492666149, -9.906913956118695],
            [26.518908574439653, -9.905955039488868],
            [26.514138575976531, -9.905314931796267],
            [26.508698617567784, -9.903699034757015],
            [26.50498269866576, -9.900772010058461],
            [26.499210459721613, -9.898503898946865],
            [26.494129780714129, -9.895580909583105],
            [26.487674622728029, -9.893314891922461],
            [26.483937464059466, -9.89201989058334],
            [26.479175745368291, -9.890727014752438],
            [26.47131658706849, -9.89140105765992],
            [26.467216548550994, -9.891737989958859],
            [26.461392469628411, -9.893385011351777],
            [26.455909671462084, -9.89503096172699],
            [26.450768512479751, -9.896674948582188],
            [26.443237674043218, -9.898326916068109],
            [26.437774676542379, -9.898503899837573],
            [26.432997477183925, -9.898353898984489],
            [26.430098758390844, -9.898198927780479],
            [26.425840680163724, -9.897557028643291],
            [26.422781759416139, -9.896586900242092],
            [26.419577760750144, -9.893658924134646],
            [26.415535681534781, -9.889591949779396],
            [26.412003722331594, -9.885685938420071],
            [26.409488763827877, -9.882267896068194],
            [26.406639724564947, -9.878360020351415],
            [26.404798683983998, -9.875592009772491],
            [26.403966724554977, -9.873963005352994],
            [26.400415685135176, -9.871526052651131],
            [26.394288486787971, -9.870237000521591],
            [26.3895235278736, -9.86927105122234],
            [26.38542780935428, -9.869282058080881],
            [26.378944570930742, -9.869135949040659],
            [26.375552651893837, -9.867514013846407],
            [26.371987572704473, -9.866055046057774],
            [26.368267693130374, -9.863455057364085],
            [26.366746694437406, -9.862317056242855],
            [26.36405965375954, -9.859061924389479],
            [26.361866534672664, -9.85711096019182],
            [26.360198655142515, -9.854178899201665],
            [26.355761656765303, -9.85419097202994],
            [26.347556538384968, -9.855191053565962],
            [26.341737500807763, -9.856511944460642],
            [26.326031783978284, -9.856879982041534],
            [26.316816505569378, -9.856903951110034],
            [26.310287547389432, -9.860183959757128],
            [26.308538668566769, -9.863450974704952],
            [26.307786628655318, -9.868672947802878],
            [26.305669829536644, -9.873898919558322],
            [26.303539709300644, -9.880102976407393],
            [26.299046550946859, -9.884355936804383],
            [26.29528383251348, -9.885017921263401],
            [26.291187752871458, -9.885028927588397],
            [26.286075754101542, -9.884390021205816],
            [26.282667634846817, -9.88407296416027],
            [26.279633556110095, -9.881145051493263],
            [26.275581756225037, -9.877894014268632],
            [26.273576556610774, -9.874636020346385],
            [26.271925679493989, -9.870400052230739],
            [26.269925959602951, -9.866815969059948],
            [26.269985719128929, -9.862249074334548],
            [26.270050879326359, -9.857354912422775],
            [26.269043959521017, -9.856053020480317],
            [26.269125679262441, -9.849854008623087],
            [26.267380726975858, -9.844657561973889],
            [26.266498759233283, -9.842031041122766],
            [26.2669048390642, -9.83713604269491],
            [26.266005919213899, -9.827678029166886],
            [26.267102839430905, -9.822129049891398],
            [26.270938998732024, -9.81591998219402],
            [26.275103838120838, -9.810688996744844],
            [26.278590797118156, -9.805134046361974],
            [26.280694997364975, -9.800886978050379],
            [26.285235676597317, -9.793044902665454],
            [26.285299756121468, -9.788150945676451],
            [26.285744716834525, -9.780319930952558],
            [26.286846676600277, -9.774444993445357],
            [26.288971755490902, -9.768566931813728],
            [26.292103755983526, -9.763991027701355],
            [26.297988675105326, -9.757776951991859],
            [26.30559691418334, -9.750252987279319],
            [26.312168713019197, -9.743710980754562],
            [26.321167992416353, -9.734225940494339],
            [26.327034911096511, -9.729316011982585],
            [26.331860710210137, -9.725714995285816],
            [26.33841090905495, -9.720804051575065],
            [26.340156909675482, -9.717862957148046],
            [26.340143045975676, -9.71759815966892],
            [26.339883669115515, -9.712643909485756],
            [26.339248989604329, -9.709056921009328],
            [26.337234789769212, -9.70645195642178],
            [26.336275749270204, -9.701560975971503],
            [26.334283868976669, -9.697325004221057],
            [26.332620670567465, -9.694066993046908],
            [26.330092962274907, -9.691055028377386],
            [26.330654710263111, -9.687873981068854],
            [26.330023990525731, -9.683960947259402],
            [26.330766669991924, -9.679390975667731],
            [26.33496570914194, -9.671549917861112],
            [26.337735909560575, -9.668606963246475],
            [26.34154182887427, -9.664681977124204],
            [26.345697667143938, -9.660103035733453],
            [26.352256866209604, -9.654540040140175],
            [26.352986946803938, -9.650949048086332],
            [26.352679866707213, -9.648340073860314],
            [26.350652649385321, -9.646714024857912],
            [26.346903005032601, -9.646397990861761],
            [26.342849708554311, -9.643146046890926],
            [26.33741077781821, -9.641529924410866],
            [26.332635845807562, -9.641216013332501],
            [26.328296179891392, -9.62671388668916],
            [26.325849674808964, -9.624024653059051],
            [26.321476085812737, -9.619217086842776],
            [26.32303586028495, -9.61459991588524],
            [26.324658992934143, -9.611939432012996],
            [26.325429859737326, -9.610675892508118],
            [26.327950023978126, -9.606543554817735],
            [26.336179096833863, -9.593049911390104],
            [26.366609168655604, -9.565292923189634],
            [26.370298086895104, -9.564093833298244],
            [26.38517508362046, -9.551023865901728],
            [26.395601040402411, -9.534564980740102],
            [26.400642118977281, -9.530589905965867],
            [26.406312837514516, -9.522008894318333],
            [26.410349155833966, -9.518848873059873],
            [26.423038073021196, -9.508910989914449],
            [26.427548871592251, -9.500346844732743],
            [26.430360332530206, -9.49778081805885],
            [26.431894251691926, -9.496380894959266],
            [26.436961978789654, -9.494472672699114],
            [26.447261956734486, -9.485828108305215],
            [26.451936360078353, -9.47243400578393],
            [26.458523280255353, -9.463149943088652],
            [26.462326319570249, -9.453674896102195],
            [26.469492479730665, -9.452887977534093],
            [26.477256239642241, -9.445195922647901],
            [26.479969200309327, -9.440561904795674],
            [26.475969240402666, -9.436020972479414],
            [26.482315320455374, -9.426279939347786],
            [26.477375400266354, -9.404283951672648],
            [26.473316400384327, -9.395375999449966],
            [26.465545439577415, -9.386058900374318],
            [26.465133240422769, -9.373194891412863],
            [26.468300520451503, -9.367864882374928],
            [26.473114440243808, -9.364580924261222],
            [26.474384160388883, -9.356059909427925],
            [26.47736352004674, -9.353952026577982],
            [26.478407519612038, -9.345892876824571],
            [26.485166520166562, -9.332929918579353],
            [26.483951159774278, -9.328809877744268],
            [26.490343319807799, -9.322515918423548],
            [26.498748239677024, -9.29505303052947],
            [26.496286200028354, -9.284513931241758],
            [26.501297399738529, -9.278930899220109],
            [26.502243480242949, -9.263979888371928],
            [26.499464279603462, -9.26378798609819],
            [26.498018159980983, -9.259670855535472],
            [26.494066439605124, -9.258346904357719],
            [26.493288479704457, -9.252381944269393],
            [26.488331280420933, -9.245326946481931],
            [26.485082279752483, -9.244682018886197],
            [26.482710239617216, -9.240578002532121],
            [26.477146440361679, -9.239735991124697],
            [26.469459359744445, -9.235933933721606],
            [26.477714519676024, -9.230764911658856],
            [26.475832440459644, -9.228492979026475],
            [26.470728360338974, -9.22741401552733],
            [26.466263279727666, -9.222419893964188],
            [26.464573439982111, -9.217385856982675],
            [26.469171359864333, -9.215485956526614],
            [26.473425480114308, -9.205315861168536],
            [26.478698400389273, -9.202025911957026],
            [26.482277160022107, -9.193244914121838],
            [26.482610520332454, -9.184049026567918],
            [26.493156359984052, -9.177468875304783],
            [26.495420400164274, -9.173989914220112],
            [26.497946520235395, -9.156261904024046],
            [26.501123159811087, -9.152081947894439],
            [26.512916400066203, -9.151917915933785],
            [26.525350440054467, -9.14806900124398],
            [26.52686135964997, -9.140465875217695],
            [26.536249439783571, -9.133900918747651],
            [26.540065439991388, -9.125805886258249],
            [26.544656520101078, -9.123443954402001],
            [26.548216200415595, -9.113512993673053],
            [26.547426360295283, -9.106859992848937],
            [26.553354480297429, -9.101033019151538],
            [26.561968200079733, -9.088964003879839],
            [26.567470439585442, -9.085669940719979],
            [26.572790519616163, -9.085824928360843],
            [26.581251240135888, -9.07927194543133],
            [26.585579519905846, -9.074843906139836],
            [26.587125359711383, -9.069767892460861],
            [26.588953440297704, -9.068362967663122],
            [26.597269440428537, -9.06778587032065],
            [26.602853399675634, -9.070233945777591],
            [26.607710520348292, -9.070395880783266],
            [26.610391439905804, -9.06392286961858],
            [26.616173400417971, -9.064071994883724],
            [26.622558360454455, -9.058006032780908],
            [26.624973240347334, -9.049241017964865],
            [26.629543440016526, -9.045499008125844],
            [26.632690199829263, -9.039479889248037],
            [26.641363319811372, -9.031772984099478],
            [26.646894360203422, -9.030544989778413],
            [26.653444199722131, -9.020112024758031],
            [26.660064239885347, -9.014502895999533],
            [26.670870360102285, -9.010440867078525],
            [26.673361199738931, -9.006957948305178],
            [26.674812359808488, -8.995679028816449],
            [26.677547279792652, -8.99311189929055],
            [26.678802239719317, -8.984132941017918],
            [26.677231200373438, -8.971519905323634],
            [26.673200280030514, -8.964684996853761],
            [26.677404359627577, -8.95198690061148],
            [26.680088520306651, -8.899105950839472],
            [26.69162147999636, -8.866546006153676],
            [26.706770279977263, -8.859892859482756],
            [26.720865359723106, -8.844524953533154],
            [26.731850039865698, -8.83723998188856],
            [26.732471400056156, -8.832868964604847],
            [26.729330400241043, -8.823495859765469],
            [26.729290080257819, -8.820749964466055],
            [26.730589319941448, -8.814976928793891],
            [26.728893359973867, -8.809717918862235],
            [26.726320080146923, -8.80700005644152],
            [26.713617479821306, -8.791755471824059],
            [26.71355448007213, -8.78788986381776],
            [26.715467160398632, -8.776834919306916],
            [26.711099280196059, -8.762655913717451],
            [26.717886360289722, -8.753138879486109],
            [26.719726320197356, -8.752653002441619],
            [26.718778440367455, -8.751058937468722],
            [26.719867440138621, -8.746676916052179],
            [26.715446279958201, -8.744445898979007],
            [26.714960279711384, -8.742843961354939],
            [26.721563400106202, -8.73654586087798],
            [26.720964360355627, -8.727365866362224],
            [26.722471320177355, -8.719993954223352],
            [26.718672239737934, -8.712927916099162],
            [26.714250360006972, -8.695075988913427],
            [26.716024440166606, -8.690226937711179],
            [26.71921115973813, -8.687193955021861],
            [26.727474240115548, -8.68385686072396],
            [26.730646200366927, -8.679905858155395],
            [26.732135159746981, -8.671385024267378],
            [26.75115936013551, -8.677536911162262],
            [26.755253280227606, -8.688732003869749],
            [26.757360359574889, -8.690767941161903],
            [26.760364200120843, -8.690953025977329],
            [26.770397399985864, -8.682535945531459],
            [26.764595280380394, -8.680553940432265],
            [26.760570480259531, -8.673952999413304],
            [26.757536399726185, -8.671700877766961],
            [26.753116320219039, -8.66946887397577],
            [26.760442320312897, -8.665455900590763],
            [26.773199280391307, -8.654011934723462],
            [26.776451520384693, -8.655341859551527],
            [26.777904479779732, -8.659913984569513],
            [26.786035440436748, -8.66323989249698],
            [26.79228827985456, -8.664524890212316],
            [26.796865320194648, -8.66192994910991],
            [26.810861400206306, -8.6713689913508],
            [26.818012439923841, -8.671031937020746],
            [26.82304020007631, -8.682670976928533],
            [26.830713240025645, -8.686232002862594],
            [26.830789199769445, -8.691282935531776],
            [26.835260399704445, -8.696728902095387],
            [26.835914519656686, -8.709352897386315],
            [26.828291520360231, -8.724168960598844],
            [26.830444320362218, -8.728959856146338],
            [26.826357240042686, -8.733615854519027],
            [26.824403520182383, -8.741684984131041],
            [26.826107399697545, -8.762564012667527],
            [26.827535519776678, -8.765298946246668],
            [26.831705399612577, -8.76615400972948],
            [26.834152319716665, -8.775076932794715],
            [26.842560479809119, -8.781153892398207],
            [26.849722319971328, -8.781274996168491],
            [26.856069479799014, -8.773598906266493],
            [26.863405199664228, -8.770041931217937],
            [26.875004400224711, -8.758380002083271],
            [26.886253319808119, -8.754073940975983],
            [26.89464924035482, -8.744528898654472],
            [26.906561280111291, -8.738373853055981],
            [26.923149359942066, -8.721122006261266],
            [26.941995359731045, -8.715548861949831],
            [26.956114199916183, -8.702925969582457],
            [26.958101399987104, -8.697151971685816],
            [26.957002320220145, -8.686142932379967],
            [26.95831847967213, -8.681758892802588],
            [26.967828240204238, -8.669895893566075],
            [26.9762994000459, -8.66540192092844],
            [27.006349320110747, -8.638746946797582],
            [27.032245200333154, -8.612614966850753],
            [27.038883240039709, -8.609064995258267],
            [27.052528320422084, -8.582205886669403],
            [27.059597280173826, -8.57681188052468],
            [27.068071320014251, -8.572772963031191],
            [27.071679239859535, -8.567322689475933],
            [27.078876360456213, -8.563721324412603],
            [27.085113720105038, -8.560600350792416],
            [27.085578479686955, -8.555130832310342],
            [27.081715679947784, -8.548731896259175],
            [27.071843760015621, -8.541411870425424],
            [27.061762679945971, -8.544789977346129],
            [27.050238360252642, -8.547462004711909],
            [27.033888599873496, -8.543264344100047],
            [27.020906639664151, -8.540476274061236],
            [27.012009600224413, -8.537905599342047],
            [27.00846615606034, -8.534730528375897],
            [27.006469200285437, -8.532941163047324],
            [27.005460120031845, -8.516543106014884],
            [27.015464519908821, -8.487013689450482],
            [27.034613640020751, -8.462667174609253],
            [27.056165399581513, -8.438307335546707],
            [27.121266719650063, -8.35332486573798],
            [27.156208679699265, -8.307008815313226],
            [27.163738524599115, -8.294844514620706],
            [27.166251960458418, -8.290784029903577],
            [27.164179440198438, -8.285549962715852],
            [27.174089023795506, -8.271383173953968],
            [27.194969519955123, -8.25210437349636],
            [27.215079840116019, -8.227738360572127],
            [27.219380759897348, -8.219627968461076],
            [27.226268381234252, -8.207158923658252],
            [27.234075625893791, -8.206236200014041],
            [27.25111043971199, -8.20422287978173],
            [27.25766179468857, -8.200880585499474],
            [27.264135239678883, -8.197578010909165],
            [27.264506231314808, -8.197052329966082],
            [27.265938480050998, -8.195022880130022],
            [27.26517131969667, -8.190673857008756],
            [27.278356319821441, -8.179894021872853],
            [27.281375280810277, -8.181941166062069],
            [27.282320229437417, -8.182581928362872],
            [27.285072479720053, -8.181847949149194],
            [27.287475068863213, -8.18022875868273],
            [27.290313359783774, -8.178315925894179],
            [27.295353839182312, -8.172689828460843],
            [27.298456199762104, -8.169226986361487],
            [27.306484200012829, -8.167025937491195],
            [27.308374320947657, -8.167410862291963],
            [27.310648319851136, -8.16787396433306],
            [27.316377602256718, -8.172629383015131],
            [27.317426462606043, -8.17349989159354],
            [27.325474199741862, -8.172445857295232],
            [27.331527733540817, -8.175123359481535],
            [27.331976196785188, -8.175321715954917],
            [27.335256480385095, -8.178480924017171],
            [27.337162320040733, -8.18265099421032],
            [27.337650437616674, -8.183720791446239],
            [27.33863425724449, -8.184331243993759],
            [27.341612280209166, -8.186178876600399],
            [27.366037199696525, -8.185994973231068],
            [27.37811843983172, -8.178213893658929],
            [27.381100075820488, -8.176966351517029],
            [27.389559240458141, -8.173426943151124],
            [27.404959589379793, -8.162374838943087],
            [27.422332200287538, -8.149906963580261],
            [27.427038285414838, -8.149253502837553],
            [27.431759519731088, -8.148597938380625],
            [27.440578951018484, -8.144269964545],
            [27.449451360449771, -8.139915944025674],
            [27.455518439944889, -8.136937999234537],
            [27.465841439913838, -8.1342338695179],
            [27.471555234465594, -8.128912868849643],
            [27.475136280310839, -8.125577964704023],
            [27.484066439736797, -8.109352983913878],
            [27.501569999860127, -8.099249077170434],
            [27.505915559622888, -8.106366958379404],
            [27.514086840263126, -8.10727827248161],
            [27.533286000129639, -8.100043190931544],
            [27.559661039927963, -8.081824574125848],
            [27.571200119839702, -8.084147242720206],
            [27.590911920391122, -8.087857097713096],
            [27.607226759661899, -8.080159909103275],
            [27.618279840225185, -8.080580982548705],
            [27.635084999740986, -8.076213393547391],
            [27.641333159834453, -8.076658379635127],
            [27.642792599675957, -8.082839070273018],
            [27.644271840182981, -8.095683308665997],
            [27.650054520245657, -8.101366114716907],
            [27.65823407975958, -8.105133256909568],
            [27.673166160279823, -8.117433890443628],
            [27.681852599582662, -8.130241151447393],
            [27.68139179977452, -8.136906601135109],
            [27.674697960315786, -8.148361927820403],
            [27.681931800448023, -8.157368220599762],
            [27.693447480144936, -8.151600056412207],
            [27.699207839767766, -8.149667743021423],
            [27.702582479710198, -8.153458329604316],
            [27.696893040282418, -8.179660706241942],
            [27.696444480019995, -8.190607859814392],
            [27.698873399682441, -8.199637087330297],
            [27.73626515983457, -8.169471367673275],
            [27.763147080320142, -8.160295707197374],
            [27.789077519629849, -8.154455874465098],
            [27.807328440340321, -8.151509613434309],
            [27.822224159752849, -8.151435403290964],
            [27.837542879662958, -8.144527228774463],
            [27.819316079616183, -8.161519961789981],
            [27.793243799916375, -8.175490783368689],
            [27.790119554579629, -8.177971222846764],
            [27.751959360262092, -8.208266573649599],
            [27.730672559692753, -8.232532139863922],
            [27.721522080358508, -8.248298510837534],
            [27.735442559952503, -8.245858208710496],
            [27.747591480059487, -8.234936141333938],
            [27.757877400268441, -8.233712115671894],
            [27.760863959923267, -8.240980412542093],
            [27.752910839641366, -8.259168663483541],
            [27.743726880096496, -8.281599087742922],
            [27.751560120203742, -8.287043099252154],
            [27.763693919867883, -8.279151861690666],
            [27.77368932042237, -8.269470872670057],
            [27.776582280116191, -8.263906950628643],
            [27.784591200150295, -8.23620492879092],
            [27.787285800151274, -8.232366985493533],
            [27.789980400152249, -8.228529004513316],
            [27.795978193487809, -8.222911409405279],
            [27.801986400094155, -8.217283979467302],
            [27.807308280348725, -8.206164914270413],
            [27.818674200107992, -8.19768788643227],
            [27.827194319929262, -8.185130932076426],
            [27.833955840258142, -8.183168459158596],
            [27.840717359688725, -8.181205976447787],
            [27.839456280438366, -8.1998259775284],
            [27.839893650387246, -8.203373573634515],
            [27.840275279872795, -8.206469024621926],
            [27.836988479893812, -8.227654890577163],
            [27.832489200419634, -8.23347901015018],
            [27.833885280287529, -8.246309959432418],
            [27.851548680344301, -8.244509375207645],
            [27.86241780031045, -8.247526276375391],
            [27.874493280448021, -8.251147917634084],
            [27.87718715910183, -8.250654409098743],
            [27.881151119921775, -8.249928223939666],
            [27.8890271997866, -8.246889047738367],
            [27.890261280171096, -8.242039800301111],
            [27.898103879825264, -8.245666307922573],
            [27.900479520408201, -8.254147111524311],
            [27.904681799781443, -8.26020178591318],
            [27.910716120413113, -8.262618457222537],
            [27.915553799746384, -8.262612750711938],
            [27.960251760225209, -8.272255033344241],
            [27.968152320079835, -8.264368488930364],
            [27.971820359675498, -8.256486777262268],
            [27.971894159869375, -8.241943492360445],
            [27.981035279656627, -8.22799501263966],
            [27.985869719664997, -8.228595352402978],
            [27.98809631986083, -8.233975898151114],
            [27.984653280396035, -8.241181945731824],
            [27.983667250912632, -8.243244962166962],
            [27.986036390387866, -8.25835510228443],
            [27.986004161530403, -8.259035399107269],
            [27.985546440248747, -8.268696896744292],
            [27.988527493230897, -8.272886085505569],
            [27.989576279918364, -8.274359903869078],
            [27.989728854277779, -8.274895418793111],
            [27.990812519852781, -8.278698900787395],
            [27.988657200076435, -8.286318020858957],
            [27.989456399743705, -8.291813858719218],
            [27.986925946199623, -8.300056309930536],
            [27.985769279931397, -8.303823863132335],
            [27.979347129642107, -8.313298990336161],
            [27.977253480108335, -8.316387873922784],
            [27.981369360415847, -8.326412898218363],
            [27.985929473801061, -8.347451964596905],
            [27.985533800952687, -8.350850406461026],
            [27.984348383205457, -8.361031815090081],
            [27.987072674323198, -8.362273443299841],
            [27.990633240376582, -8.363895928826171],
            [27.9956363597408, -8.372067761120952],
            [28.004266165654862, -8.374426303986521],
            [28.005838287470677, -8.374855966482682],
            [28.007279176203255, -8.375910694020044],
            [28.020815280161873, -8.385818950383367],
            [28.030090319893386, -8.400107953372821],
            [28.038809187479682, -8.404391856479162],
            [28.043132399853111, -8.406515992593011],
            [28.055380266693721, -8.407654965896604],
            [28.062393479693856, -8.412341876460307],
            [28.066221039422729, -8.412158302176531],
            [28.070459280153411, -8.411955031546592],
            [28.075922592962932, -8.408984492533753],
            [28.081413360084174, -8.405999003502622],
            [28.089311400164444, -8.403916957560375],
            [28.072861919602207, -8.364212931566632],
            [28.062664920030006, -8.34786841354331],
            [28.06631459985789, -8.343623443383256],
            [28.083789359993215, -8.355719025648408],
            [28.094655239736127, -8.359340903887649],
            [28.097678880049241, -8.359337338768666],
            [28.101939119622944, -8.353880258720542],
            [28.108047599774562, -8.341756626136386],
            [28.115322120114421, -8.338113185368575],
            [28.131654959826907, -8.336882353329502],
            [28.161268199849015, -8.316701884348204],
            [28.164558240051228, -8.308369914696438],
            [28.174940279995578, -8.297141995418363],
            [28.182708456025122, -8.282290900433951],
            [28.183902421242262, -8.28096448656758],
            [28.185865329071277, -8.278783932950633],
            [28.203324480080234, -8.274392182217687],
            [28.219752359753137, -8.254376638618355],
            [28.231873559647116, -8.248908628281457],
            [28.238040941433589, -8.249891050319222],
            [28.262083679869843, -8.253720873920244],
            [28.262617560321324, -8.267657020180879],
            [28.263759479845866, -8.280986167957803],
            [28.272209760145358, -8.284005640053861],
            [28.289751840028064, -8.282773208767885],
            [28.30306715964943, -8.280333836764321],
            [28.312800839639159, -8.268809783112909],
            [28.327642326859657, -8.255046825817931],
            [28.338317279570372, -8.245147320069565],
            [28.356534720070222, -8.229976344787055],
            [28.39175999977693, -8.19963369795645],
            [28.408169519682051, -8.183250868154653],
            [28.422120600386172, -8.174749264376725],
            [28.432437119908659, -8.167464043210162],
            [28.440368640199551, -8.153514343628162],
            [28.439975465566004, -8.150654435255364],
            [28.43803584027253, -8.136545528183794],
            [28.430847000346127, -8.123218608798602],
            [28.426123080067189, -8.100795554225158],
            [28.426199760259827, -8.085640252662799],
            [28.429330680079143, -8.064418399376025],
            [28.42941347959551, -8.048049069484614],
            [28.439727120017501, -8.041367856416045],
            [28.456127280375664, -8.026797383473502],
            [28.479799080176598, -8.009186092404246],
            [28.495082160326156, -7.976424588480878],
            [28.503044279930581, -7.956404174555564],
            [28.515264120232612, -7.931525987913504],
            [28.526274360139986, -7.906647704092268],
            [28.526743814317598, -7.904725838270832],
            [28.527821259059234, -7.900314931900867],
            [28.529979120169532, -7.891480808884269],
            [28.526097959764286, -7.881781111117004],
            [28.51284239966887, -7.872395544513886],
            [28.503799560065261, -7.866947293378049],
            [28.483857000283681, -7.864544649054927],
            [28.470880800071956, -7.85970736271592],
            [28.444345199891352, -7.845787684052178],
            [28.431987479871289, -7.838219960103382],
            [28.425173039789001, -7.810627203325338],
            [28.417035959808256, -7.805480404592624],
            [28.404670320240651, -7.799428500916028],
            [28.386871919566342, -7.791563177378449],
            [28.37812103961658, -7.788236814390245],
            [28.371588200714609, -7.788084643732708],
            [28.36572623983653, -7.7879480996171],
            [28.360594080176721, -7.786437566970545],
            [28.355811840371221, -7.775523003894698],
            [28.368010079783947, -7.754880823584646],
            [28.377746280446335, -7.742734911361468],
            [28.397200680431176, -7.722082709034482],
            [28.407017159937244, -7.694159154578266],
            [28.413097559651423, -7.687477161866116],
            [28.422779040336618, -7.68625201398072],
            [28.42882559961571, -7.686244869979031],
            [28.441514879722302, -7.688050443523126],
            [28.461033083448484, -7.679319091112037],
            [28.463650970019167, -7.674442991341326],
            [28.466964360130568, -7.66827086288372],
            [28.470786728495412, -7.667990974763559],
            [28.473640255741511, -7.667781951590573],
            [28.474996834889701, -7.665806722772337],
            [28.475696487748753, -7.664787910560864],
            [28.473154145001917, -7.661478785701709],
            [28.470598222422929, -7.658151958212069],
            [28.470704670089148, -7.657856057270139],
            [28.471508128669161, -7.655622749188419],
            [28.474035480330535, -7.654692869522225],
            [28.477826538814476, -7.650467230152757],
            [28.480447440131211, -7.64754586307544],
            [28.479278519944177, -7.643877025722056],
            [28.480642200274723, -7.640426957768281],
            [28.485691198397102, -7.637188876468312],
            [28.493288280399298, -7.636924884037205],
            [28.494438264998482, -7.63602416003116],
            [28.501543440330877, -7.630459000837178],
            [28.503963746946358, -7.629480518959226],
            [28.506139428835276, -7.628601076878865],
            [28.509027835867208, -7.629270567864513],
            [28.51973747971757, -7.631752899716672],
            [28.520055194070636, -7.631433119277481],
            [28.52202851966199, -7.629446955901531],
            [28.522247399570865, -7.627149930748141],
            [28.533346560114961, -7.62534105923527],
            [28.548101159586199, -7.622684628315955],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Lusambo",
        AREA: 104331,
        POPULATION: 2110000,
        DISTRICTS: [],
        OBJECTID: 21,
        NOM: "Sankuru",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [23.995447362048147, -1.701364548851994],
            [23.999080319737025, -1.703232907126079],
            [24.003904850429485, -1.702952356278371],
            [24.010738200048475, -1.702554990530099],
            [24.01965143970607, -1.704631977090697],
            [24.022396439686062, -1.703025010631778],
            [24.027881400097304, -1.70279999934983],
            [24.034825983606353, -1.705502488704258],
            [24.040909321709812, -1.707869820253836],
            [24.05759436030247, -1.704664945557855],
            [24.067571770296752, -1.706249241946294],
            [24.080656319908154, -1.708326914189368],
            [24.083684366457735, -1.708807956677781],
            [24.085251359791588, -1.709056893308542],
            [24.090967439657458, -1.705152980229535],
            [24.096224313326466, -1.704697030851718],
            [24.10020732921021, -1.707520587019722],
            [24.102394199615979, -1.709070945394557],
            [24.12159515970631, -1.704946884641106],
            [24.122737158282632, -1.705330655181227],
            [24.125023439850992, -1.706098963493545],
            [24.133249439570125, -1.71415286619781],
            [24.137890930438601, -1.714378865967413],
            [24.147649439862775, -1.714854018528121],
            [24.161594400344867, -1.708885927910889],
            [24.166851300065026, -1.708889891783722],
            [24.17005152041693, -1.712569867273791],
            [24.183771636176687, -1.712580411064562],
            [24.188337360439139, -1.712583919333751],
            [24.190766204643097, -1.713918129632861],
            [24.195879360443076, -1.716726878772781],
            [24.230458799969494, -1.713472070779437],
            [24.247308959691161, -1.711866732614863],
            [24.267176280177814, -1.709096887289729],
            [24.290016840100265, -1.709958557016083],
            [24.315852240347819, -1.712054091064573],
            [24.370545599584503, -1.71448074307612],
            [24.404809319916136, -1.715473561206108],
            [24.417434519600246, -1.715618584202944],
            [24.431863680105344, -1.715784143319691],
            [24.439673880222163, -1.716473405281422],
            [24.444044255046311, -1.715305850640144],
            [24.453371880357949, -1.736230390972557],
            [24.472652786915297, -1.780348253024772],
            [24.489424382677146, -1.818723544981712],
            [24.50287673580354, -1.86342347159248],
            [24.515102048642323, -1.904045208169783],
            [24.532535046998415, -1.912390575353429],
            [24.573266898785437, -1.943420205501381],
            [24.598389880215485, -1.980783041311686],
            [24.604048380766567, -2.020052480580124],
            [24.608722979943135, -2.064662828331981],
            [24.621559859539115, -2.091098679615887],
            [24.648085017702893, -2.120310460720037],
            [24.663639177065804, -2.139474287967816],
            [24.681097016534466, -2.189584700180501],
            [24.684868736086962, -2.237827096462136],
            [24.689645576119311, -2.322468540663301],
            [24.693368336590495, -2.351598250555169],
            [24.694308306754358, -2.362520265175486],
            [24.706181824954825, -2.368929763610272],
            [24.719853915881153, -2.365336678846738],
            [24.784621851384834, -2.369196288098415],
            [24.824753928599382, -2.369332608509787],
            [24.86853460676517, -2.369481355924489],
            [24.912322124703522, -2.372359711305147],
            [24.926003539244196, -2.372406174496733],
            [24.931480602565784, -2.374244582594407],
            [24.931517682325776, -2.388802842832805],
            [24.931541108591752, -2.397901655689819],
            [24.952521521665457, -2.398882874869334],
            [24.960730575565076, -2.39891060893407],
            [24.979016439841807, -2.416260256146019],
            [24.989061170481804, -2.420843597062327],
            [24.997265199205728, -2.419051722098672],
            [25.026255276118604, -2.413464101244318],
            [25.048323953243287, -2.411946279905707],
            [25.049268635969121, -2.424687579079658],
            [25.032901596495474, -2.444421170822301],
            [25.014238477528661, -2.458005233157659],
            [25.004905837821124, -2.464342277340633],
            [24.999453638069966, -2.472284742169125],
            [25.002681398073545, -2.486170480070614],
            [25.017976023371105, -2.492818527791443],
            [25.032338584577655, -2.49173006285998],
            [25.037810890421486, -2.49174861087232],
            [25.042691250510519, -2.494258389680672],
            [25.04671551523548, -2.496327919895486],
            [25.034435916305799, -2.509478221782323],
            [25.022371237511191, -2.51739790317828],
            [25.003935638449637, -2.530754693448424],
            [25.001692478709877, -2.545303480852436],
            [25.006751917950787, -2.562151179387915],
            [25.03599363633095, -2.583629684442992],
            [25.046967875355012, -2.595038573105918],
            [25.05884394207591, -2.602356718394704],
            [25.073973361802864, -2.600724726433515],
            [25.074278009261786, -2.600691865233198],
            [25.077279873514126, -2.631059984017071],
            [25.081383960738606, -2.642043943178606],
            [25.081758583364898, -2.643046559773957],
            [25.082779390226232, -2.645778575435353],
            [25.081419873587034, -2.657280036297758],
            [25.08262717519289, -2.663885263367261],
            [25.082675990543763, -2.66415233563188],
            [25.083479794076826, -2.668549975373287],
            [25.082742645537827, -2.676351678557561],
            [25.082698379255589, -2.676820173289947],
            [25.082349753873601, -2.680509880947785],
            [25.086939753309981, -2.697070024929241],
            [25.086900798766013, -2.697968920839958],
            [25.086891504796078, -2.698183389618102],
            [25.086710122363808, -2.702368834807665],
            [25.095429992469963, -2.730889930009938],
            [25.097039912697952, -2.742849932367341],
            [25.110099992201018, -2.761480002813245],
            [25.112398662435449, -2.774354129217281],
            [25.109502149006374, -2.782972953596565],
            [25.109400209086257, -2.783276284197911],
            [25.108710031656852, -2.785329955492119],
            [25.10857693816266, -2.785720946725041],
            [25.108557330634948, -2.785778548399319],
            [25.108059872376717, -2.787239946606051],
            [25.1052589235242, -2.808115763963693],
            [25.105119002833863, -2.809158598396091],
            [25.104879433825666, -2.810941404534403],
            [25.102590032408322, -2.816689957962029],
            [25.094358029248152, -2.823132981050636],
            [25.088409993596155, -2.830730010136441],
            [25.086589833455673, -2.841550065664878],
            [25.072418416673617, -2.867544107973288],
            [25.070529846230979, -2.872785457507747],
            [25.070431735828915, -2.873057741496377],
            [25.068769834586988, -2.877669994287937],
            [25.067339600771984, -2.887164760103887],
            [25.067272117531225, -2.887612751187612],
            [25.065369995104209, -2.900240062889444],
            [25.064889754855013, -2.90343991875184],
            [25.050489756358992, -2.929440002512761],
            [25.043179956482991, -2.95153006208364],
            [25.037100790155691, -2.964729035503696],
            [25.036814438684154, -2.96535075255083],
            [25.032899797169954, -2.973850062007827],
            [25.029318711798837, -2.978652335211081],
            [25.028880289024425, -2.979240263604718],
            [25.024659758579553, -2.984900009897178],
            [25.023245465369271, -2.997586121073451],
            [25.023133351130227, -2.99859176774424],
            [25.023069875273958, -2.999160352346393],
            [25.016669917863762, -3.015500103184479],
            [25.009049799464435, -3.021190009585786],
            [25.008628893838054, -3.021971306298126],
            [25.008558933942037, -3.022101167746159],
            [25.007379759486035, -3.024289983171399],
            [25.007849918841103, -3.029820020607631],
            [25.011650079055503, -3.033680014943135],
            [25.014728510312782, -3.035418742346553],
            [25.015236705235285, -3.03570577571752],
            [25.018980038024832, -3.037820040969903],
            [25.02368638995177, -3.038692030969603],
            [25.023744220794814, -3.038702746024605],
            [25.031339917594853, -3.040110070251243],
            [25.031799351065441, -3.041720793875312],
            [25.02858067392771, -3.0458612194035],
            [25.028350723181269, -3.04615702152183],
            [25.027680489249462, -3.047019192790475],
            [25.027597851429878, -3.047564560749996],
            [25.027584664161484, -3.047652183247103],
            [25.027229797284928, -3.050010013815505],
            [25.031395102899374, -3.056881262384829],
            [25.031624278399718, -3.057259318022507],
            [25.036850077546433, -3.065879931702747],
            [25.036400077284632, -3.074390078877774],
            [25.035495332758018, -3.076013988127487],
            [25.035441585656248, -3.076110458146459],
            [25.034346717191344, -3.078069524481683],
            [25.032417833952028, -3.077817230191175],
            [25.030910077324641, -3.077620015429701],
            [25.018310078079207, -3.065660005508939],
            [25.01372977865125, -3.063359958666902],
            [25.008919866243428, -3.063589956261696],
            [25.003658439014231, -3.069111873839685],
            [25.001149959160312, -3.074159895803806],
            [25.001719839596806, -3.077990034642338],
            [25.003087633313026, -3.079577670200713],
            [25.003129407668681, -3.079626158352219],
            [25.004580039528811, -3.081309944012086],
            [25.010153528911303, -3.083339248354639],
            [25.010212308375284, -3.083360650468281],
            [25.014660038026854, -3.084980064061914],
            [25.01923995836577, -3.088659889769448],
            [25.02084987859379, -3.09257006044229],
            [25.020637632743277, -3.098308798505593],
            [25.020629713195731, -3.098522935762576],
            [25.020619899999573, -3.098788237722763],
            [25.018339957842162, -3.10569000310168],
            [25.008500079019569, -3.116510025678934],
            [25.008000910369002, -3.11875592674525],
            [25.007978853135537, -3.118855169580088],
            [25.007579919402698, -3.120650085075153],
            [25.008959799052732, -3.123639988213883],
            [25.023620078114131, -3.133989945501511],
            [25.023615242482954, -3.134039376560118],
            [25.023595623277142, -3.134239921738616],
            [25.023170077852324, -3.138589913408336],
            [25.021512749035189, -3.140892402245869],
            [25.021450664669256, -3.140978655211841],
            [25.020189998643929, -3.142730065006188],
            [25.016208476658527, -3.143785670198429],
            [25.016081209637271, -3.143819412235135],
            [25.00713999913669, -3.146189955727906],
            [25.003769070134702, -3.14936725009574],
            [25.003351748786308, -3.149760598572681],
            [24.99999975986379, -3.152920028134857],
            [24.999099760238511, -3.157659917257555],
            [24.998219919706532, -3.163209945857636],
            [24.998746714247037, -3.171181405309413],
            [24.998767738417939, -3.171499548219646],
            [24.998919760313477, -3.173799923364325],
            [24.997099960397435, -3.185070007896174],
            [24.995267796069808, -3.18838233506386],
            [24.995179728832593, -3.188541549669452],
            [24.994810000227961, -3.189209971367297],
            [24.991862233420356, -3.191330480721716],
            [24.99175503296593, -3.191407596110788],
            [24.99000001325998, -3.192670067669205],
            [24.98027896897305, -3.192999155698717],
            [24.969620107784007, -3.193359992121648],
            [24.966189784870391, -3.195431914377301],
            [24.966039045769076, -3.196787367841069],
            [24.966018018903217, -3.196976441458986],
            [24.965959242134197, -3.197504962878575],
            [24.964361251533166, -3.201416943913358],
            [24.964814878293751, -3.202622014045422],
            [24.965456322119014, -3.204325930081025],
            [24.966091999658445, -3.206013511854109],
            [24.966607161016004, -3.207381147960757],
            [24.968260362074414, -3.211770008540189],
            [24.969866321630331, -3.217751971468371],
            [24.968878851249212, -3.220008229488836],
            [24.968748161646719, -3.220306841296717],
            [24.968098646458632, -3.221792346973697],
            [24.967350281555007, -3.22350392886957],
            [24.966876532532037, -3.224068103485079],
            [24.96526893714401, -3.225982541739686],
            [24.958654388382115, -3.233859864928635],
            [24.958242086819535, -3.236106406631638],
            [24.957514439761301, -3.240072948070904],
            [24.963249244110941, -3.256867063533429],
            [24.963482160196097, -3.261698862923921],
            [24.962114957571334, -3.264350984449853],
            [24.960279240406788, -3.267911925802024],
            [24.956157263233411, -3.269753927750438],
            [24.951683159943425, -3.269464960842636],
            [24.950253601661501, -3.269372349048547],
            [24.949058400362517, -3.269294920041974],
            [24.944575279783699, -3.266594862476833],
            [24.941040480107592, -3.264465946664084],
            [24.925008355928068, -3.262858035537855],
            [24.912185400218959, -3.26516194503918],
            [24.909648538991981, -3.267372928418825],
            [24.905092319803554, -3.27134385773932],
            [24.902660954028608, -3.273462019975372],
            [24.901886159790976, -3.274137005768938],
            [24.901859769084581, -3.274193278264696],
            [24.901661519884513, -3.274615994521159],
            [24.898226399967296, -3.281960943867274],
            [24.896627280183949, -3.289783921538321],
            [24.897773515215114, -3.293005060680567],
            [24.901668403674535, -3.295534922994715],
            [24.907028203613883, -3.295710628288445],
            [24.91304651986043, -3.295907920780654],
            [24.913677239597845, -3.295928972617875],
            [24.914548831798875, -3.295956933993011],
            [24.915640319903368, -3.295991949361959],
            [24.917057147261055, -3.298696947165808],
            [24.917930280072841, -3.300363922957704],
            [24.917377320303043, -3.301556865406569],
            [24.916330439840621, -3.303814994104187],
            [24.909692400134062, -3.310718899266035],
            [24.907863239772762, -3.317161961037222],
            [24.910098127825382, -3.331438281027052],
            [24.910101359963772, -3.331458930343145],
            [24.906447661073308, -3.345275255612848],
            [24.906276360433463, -3.345923017332618],
            [24.906860925629875, -3.349426917016244],
            [24.906967068767216, -3.350068025904088],
            [24.906921480164851, -3.351457961143466],
            [24.906515400333934, -3.363640014855135],
            [24.903084091968438, -3.371233049428577],
            [24.899650319524138, -3.373764833934114],
            [24.897474562176761, -3.373854691350293],
            [24.894487440176551, -3.373977943529339],
            [24.881111280355938, -3.374531009557971],
            [24.877996000205755, -3.374659884165927],
            [24.871708440003896, -3.374919990488661],
            [24.86929505311106, -3.376537236576886],
            [24.867588140883498, -3.377681211599819],
            [24.866009376924477, -3.381119994068578],
            [24.864841440392663, -3.383663926325418],
            [24.864628086919431, -3.384759145917062],
            [24.862745481290318, -3.3944230444746],
            [24.861673377032997, -3.399924573702369],
            [24.860730838585763, -3.404761273158925],
            [24.86004436850352, -3.408283971375123],
            [24.858573624262476, -3.411806387502264],
            [24.857627999203917, -3.414071141290997],
            [24.855240169380906, -3.41978992419639],
            [24.854339409780881, -3.420604237348219],
            [24.854123264343734, -3.420799639215725],
            [24.853885129046777, -3.421014921103653],
            [24.852952840376926, -3.421858213721478],
            [24.852108273991171, -3.422622157905929],
            [24.850660249041987, -3.423931953039076],
            [24.848456742735504, -3.424194559107681],
            [24.84832553929667, -3.424210195351802],
            [24.847271209105585, -3.424335846795326],
            [24.837148369951631, -3.425543926932778],
            [24.833942233295279, -3.42807492423191],
            [24.833950130384931, -3.444411011400496],
            [24.830747209697289, -3.454075945515024],
            [24.824794227921338, -3.458907927005872],
            [24.816318434569446, -3.459138917078175],
            [24.805767011888388, -3.455491546955494],
            [24.802343202658896, -3.454308027246718],
            [24.801425672410861, -3.454461797520659],
            [24.798221350351383, -3.454998819765839],
            [24.797422240515655, -3.455693814761134],
            [24.796685065027209, -3.456335032546388],
            [24.793552372831851, -3.459059941675649],
            [24.781392126765734, -3.469634664134896],
            [24.778586568657506, -3.472074400868749],
            [24.774408293166967, -3.47570785181923],
            [24.773883500971227, -3.477554592020787],
            [24.772770293399812, -3.481471946399695],
            [24.772690305610258, -3.481753012355651],
            [24.772577412531895, -3.482150086736616],
            [24.775099133553059, -3.485602009385182],
            [24.776167309477607, -3.486623526348205],
            [24.779911152510241, -3.490203803730812],
            [24.780958974407092, -3.490650825505423],
            [24.781233719645162, -3.490768018142884],
            [24.782783332374873, -3.491429005499294],
            [24.786185465256573, -3.492881166867437],
            [24.786780960255037, -3.493135347046978],
            [24.789076140534611, -3.494115008121201],
            [24.792318727231955, -3.497608766150745],
            [24.798471398207351, -3.504238058858111],
            [24.800081331910096, -3.51873395912008],
            [24.801199723659025, -3.52080884590536],
            [24.804613372044351, -3.527141962060174],
            [24.807646371904422, -3.532769020822536],
            [24.806854477337048, -3.534561102974672],
            [24.806635095269957, -3.535057571627104],
            [24.805816131768147, -3.536910907676381],
            [24.805335584295108, -3.537022763530282],
            [24.805297426556766, -3.537031645348272],
            [24.804836211726965, -3.537139002511054],
            [24.794738656555019, -3.539479667867792],
            [24.793905172684955, -3.539672873949046],
            [24.793203755534702, -3.540817613501093],
            [24.792072412774285, -3.542664005766239],
            [24.792541505829131, -3.545365361165916],
            [24.792821929318123, -3.546980223786182],
            [24.792953333081243, -3.547736927164221],
            [24.791160182586427, -3.552327829258591],
            [24.787723328920681, -3.549107006313924],
            [24.786649587034617, -3.549215014645369],
            [24.784614292960022, -3.549419919219374],
            [24.783142274907892, -3.549567956524201],
            [24.776954222886712, -3.545425969089653],
            [24.773977373121816, -3.545655847171517],
            [24.773290133183355, -3.547956924662121],
            [24.778564133233264, -3.561302953522892],
            [24.777191093355796, -3.564292934807176],
            [24.772356293123021, -3.565265009346364],
            [24.7722403017552, -3.565288426291602],
            [24.77220779531833, -3.565294989065498],
            [24.771465293718563, -3.565444889451526],
            [24.769403339442945, -3.568205701424042],
            [24.772727671932827, -3.571809983196418],
            [24.773599501289123, -3.572755148933465],
            [24.775133333314258, -3.574418001261073],
            [24.775674213438389, -3.575552752391546],
            [24.775988025509861, -3.576211119719283],
            [24.777656213162146, -3.57971091568325],
            [24.777526615911054, -3.581081370785101],
            [24.777466930046938, -3.581712528538745],
            [24.777199373127775, -3.584541874975399],
            [24.776091403632737, -3.585655285536065],
            [24.775891803366498, -3.585855865762075],
            [24.775367333665979, -3.586382910895479],
            [24.774701216713137, -3.586535070542204],
            [24.774424501469632, -3.586598279643376],
            [24.770328413742771, -3.587533938451993],
            [24.768451835809184, -3.589544827738106],
            [24.767757280889391, -3.590289091560043],
            [24.766893349521073, -3.59121498073173],
            [24.769184333769939, -3.593975996490832],
            [24.773309235857866, -3.594895871683525],
            [24.78333128852854, -3.594239722055591],
            [24.78384808032833, -3.594205887530761],
            [24.783221785692021, -3.598745433791684],
            [24.782844009979051, -3.601483068197152],
            [24.782705261590163, -3.602488960378049],
            [24.788206372811917, -3.610541949089431],
            [24.788208173035734, -3.613763980836346],
            [24.786219112553855, -3.61776315239727],
            [24.785919295336196, -3.618365911160664],
            [24.780651413711684, -3.620436982282811],
            [24.778940031467265, -3.624088152795193],
            [24.778818275610305, -3.624347883899674],
            [24.779911603464519, -3.626213913276459],
            [24.780176704389685, -3.626666379963248],
            [24.78111043126232, -3.62826000394925],
            [24.78304861745471, -3.628090621128318],
            [24.791649927011349, -3.627339170224854],
            [24.788080786538565, -3.632271576315389],
            [24.78798655506187, -3.632401831931308],
            [24.788217375377499, -3.636542967369898],
            [24.796711373088606, -3.639885873729063],
            [24.796966252982497, -3.640461983260713],
            [24.797841998095109, -3.644365456784658],
            [24.797411762566174, -3.645135219787551],
            [24.795782212352584, -3.648047954643897],
            [24.786161230506845, -3.651499880488436],
            [24.785705480128918, -3.656101809744596],
            [24.788913547264801, -3.660012922643492],
            [24.798753292238423, -3.657863971114473],
            [24.79910764977026, -3.6577869362044],
            [24.799142668794975, -3.657779323595051],
            [24.79945237915884, -3.657712001411365],
            [24.803173387016923, -3.659018857696567],
            [24.803999193884589, -3.65894188786722],
            [24.806099092099473, -3.661392854476889],
            [24.806690583306736, -3.663567242417078],
            [24.807146754994534, -3.665244177135407],
            [24.807476098038929, -3.666454792986643],
            [24.807370575637449, -3.666833801465898],
            [24.805874451294709, -3.672206940774242],
            [24.797397279028839, -3.676119894658173],
            [24.797283772401123, -3.676256799640229],
            [24.797024141317721, -3.676570131995742],
            [24.795109372408131, -3.6788809412468],
            [24.800387811932193, -3.689069720305951],
            [24.801069181380257, -3.690384952797574],
            [24.800505456200106, -3.691821650964202],
            [24.799410372139533, -3.694612664147416],
            [24.79763837247808, -3.699128896014045],
            [24.798090587087025, -3.703666493656491],
            [24.798326350831683, -3.706032023001016],
            [24.798173674064298, -3.706677960741604],
            [24.797681785360805, -3.708759325666983],
            [24.797184326204246, -3.7108638695164],
            [24.781372142843935, -3.70695285581146],
            [24.779506857631763, -3.70762212755641],
            [24.778960474428214, -3.707818175172124],
            [24.778164173624376, -3.708103896586219],
            [24.777900544139623, -3.709018646502504],
            [24.777742253800039, -3.709567887293821],
            [24.777474363605918, -3.710496276182563],
            [24.776106413582838, -3.715236961996207],
            [24.771213161771126, -3.719886465770877],
            [24.770517969945796, -3.720547026271863],
            [24.767631294865733, -3.723289893806347],
            [24.767470498226515, -3.72493853477758],
            [24.76706591049728, -3.729086753292083],
            [24.766262185117633, -3.737326917213711],
            [24.765239676847159, -3.736720251253188],
            [24.764721048890898, -3.736412533698648],
            [24.761219314403789, -3.734334859117497],
            [24.758011396388227, -3.734334856410259],
            [24.754575174238141, -3.736175941309965],
            [24.751598395440112, -3.741008158928513],
            [24.751706367547378, -3.741246640558433],
            [24.752112313529324, -3.742143272060802],
            [24.75274433851882, -3.743538990094514],
            [24.756534343278933, -3.743944067429292],
            [24.763513232550373, -3.744689974247829],
            [24.765119214564184, -3.746759979631482],
            [24.764953156492332, -3.74826555040171],
            [24.76489822541102, -3.748763588049157],
            [24.764662374529813, -3.750901947265716],
            [24.762999173425683, -3.753637590535344],
            [24.762527615393669, -3.754413210509823],
            [24.762144174006238, -3.755043895008151],
            [24.752979295576317, -3.759416019944815],
            [24.747257109861476, -3.775982822486132],
            [24.74688742347767, -3.776484106180907],
            [24.742675354264456, -3.782194895118483],
            [24.741741192607261, -3.781882632325331],
            [24.741645166296632, -3.781850532180924],
            [24.740614263269848, -3.781505703479617],
            [24.739074502363838, -3.77799605615157],
            [24.738090415038055, -3.775752976333703],
            [24.733884661879639, -3.775038771823746],
            [24.731624116145852, -3.774654896139971],
            [24.731238805364299, -3.776824977265405],
            [24.731111847363515, -3.777540046569414],
            [24.730530416389108, -3.780814848208496],
            [24.732394958694517, -3.786560335000119],
            [24.732795022507972, -3.787793105355944],
            [24.733741256624292, -3.790708853955759],
            [24.742223215113963, -3.79968290014824],
            [24.741783141236056, -3.802566895820069],
            [24.741624719742465, -3.803605099817368],
            [24.741310255494092, -3.805665906010937],
            [24.743145165971548, -3.810727876456094],
            [24.74534361296638, -3.810247772852246],
            [24.745665174803779, -3.810177536214019],
            [24.748415193671256, -3.809576879985279],
            [24.753599890402146, -3.815956652658821],
            [24.754860131524349, -3.817507382660326],
            [24.755521304149866, -3.818320876124831],
            [24.757238161625928, -3.817861453841763],
            [24.757387727527497, -3.817821429839346],
            [24.758959254658567, -3.817400891659005],
            [24.760896933302831, -3.815277058545036],
            [24.761362186958149, -3.814767106337952],
            [24.761478227733278, -3.814639976692481],
            [24.762734487522145, -3.814639439800691],
            [24.764000312572168, -3.814638899299595],
            [24.764721204299462, -3.817533634322861],
            [24.764917266101801, -3.818320915827581],
            [24.761253239280506, -3.825683969658626],
            [24.762484109086174, -3.826213875661617],
            [24.762985994242133, -3.826429944097015],
            [24.764461234551185, -3.827064986844515],
            [24.765970933336192, -3.826754023637264],
            [24.766641462813713, -3.826615909066116],
            [24.773399209320086, -3.825223954031086],
            [24.779358177469092, -3.82729497072823],
            [24.780323499886908, -3.828801828812165],
            [24.781421453166509, -3.830515879062826],
            [24.780944926552682, -3.831260739379932],
            [24.779360093575605, -3.833737994145299],
            [24.766298269544272, -3.835578855906626],
            [24.766406391670184, -3.835976229802068],
            [24.766696851137514, -3.837043167674405],
            [24.766987221671631, -3.838109776656486],
            [24.771115190607947, -3.840290137261956],
            [24.782114474662119, -3.843170859968813],
            [24.79609539111177, -3.84455099403858],
            [24.819702411600943, -3.854213908285027],
            [24.820399580618218, -3.855549166606115],
            [24.820817052883562, -3.856348733442794],
            [24.822225291448834, -3.859045861471839],
            [24.821345787785063, -3.86070403356036],
            [24.82088108569533, -3.861580157400361],
            [24.820394311999078, -3.862497827072231],
            [24.812141308922495, -3.857895909005758],
            [24.808411830849579, -3.857501928165783],
            [24.807787124434704, -3.857435947969513],
            [24.807101780839819, -3.857862037834767],
            [24.80663730422722, -3.858150816614732],
            [24.802976452950467, -3.860426876254361],
            [24.800916172236207, -3.869401981747219],
            [24.802452220405151, -3.874533381826695],
            [24.802892838662135, -3.876005327407665],
            [24.802982212948056, -3.876303893194828],
            [24.809341814442408, -3.880984468897788],
            [24.810712166560567, -3.881993025153766],
            [24.813299091796647, -3.883896954823035],
            [24.817655452004043, -3.889879900494765],
            [24.818243046319601, -3.891734057200875],
            [24.818943798716532, -3.893945276808064],
            [24.820692411637889, -3.899462990081046],
            [24.82217599729594, -3.904146051020836],
            [24.822772572069379, -3.906029180183661],
            [24.823852131445214, -3.909436874052082],
            [24.830272515646641, -3.916569922604469],
            [24.830717966839842, -3.916777432588529],
            [24.836691185862506, -3.919559869584194],
            [24.842953515082954, -3.918721099478849],
            [24.843249788446798, -3.918681416834234],
            [24.84356716952491, -3.91863890660848],
            [24.844612741141962, -3.915893729508744],
            [24.845294882242861, -3.914102742487333],
            [24.847686290055648, -3.907823985820191],
            [24.849092528971081, -3.906694669952272],
            [24.849345822440167, -3.90649125902196],
            [24.851124298954829, -3.905063031403251],
            [24.852285215152691, -3.905645591557553],
            [24.854332250208081, -3.906672845669142],
            [24.857440337547803, -3.914982169103824],
            [24.858463262636565, -3.917716888802939],
            [24.85740735141059, -3.920991271443317],
            [24.854820307596885, -3.929013834065938],
            [24.852972170325202, -3.934744958183791],
            [24.853322474658437, -3.936591012576272],
            [24.853492903034162, -3.937489143188411],
            [24.853889089718844, -3.939576981218955],
            [24.854727449644287, -3.940651134669114],
            [24.855254182201026, -3.941326006456842],
            [24.858019387986701, -3.944868903945073],
            [24.871540229568634, -3.943945991681172],
            [24.884451288447536, -3.95617886701456],
            [24.888050208071999, -3.959590901001947],
            [24.887609726358939, -3.964191732686344],
            [24.887367316877821, -3.966723942536033],
            [24.887686892540174, -3.967044743841182],
            [24.887937562030302, -3.967296309527628],
            [24.888971448362145, -3.968333891310483],
            [24.900447442286453, -3.969882863709494],
            [24.900892127216729, -3.969942885115017],
            [24.903915399220601, -3.973920184266783],
            [24.906163626356886, -3.976877881710111],
            [24.906160045672156, -3.976925114442844],
            [24.906079124533051, -3.977992679925818],
            [24.90593932691192, -3.979836982983649],
            [24.90258209811633, -3.983088360325285],
            [24.901918356309082, -3.983731174129963],
            [24.899524126887979, -3.986049904560089],
            [24.895408247478763, -4.002157862763457],
            [24.895641189615105, -4.009060937182704],
            [24.897476087516132, -4.012051927291517],
            [24.905040407061588, -4.01366101382408],
            [24.908252326173454, -4.020102901075466],
            [24.912264772662535, -4.021482949403218],
            [24.913766426135872, -4.021999429711813],
            [24.916277086200946, -4.022862948453096],
            [24.919033245951717, -4.031145912317609],
            [24.919641371263069, -4.035404574877738],
            [24.920019216146315, -4.0380505864114],
            [24.920873206757687, -4.044030972078763],
            [24.921865940368061, -4.044950076228999],
            [24.922718202620818, -4.04573912653011],
            [24.92385531526029, -4.046791884285596],
            [24.926612066102518, -4.047003662144181],
            [24.926836138273718, -4.047020865794464],
            [24.932794270091197, -4.044718984145671],
            [24.939450648005966, -4.044494304933288],
            [24.939670219617611, -4.044486896091314],
            [24.943031197082853, -4.037323566524678],
            [24.944457994841891, -4.034282587725261],
            [24.945392444858289, -4.032290944418704],
            [24.946768364734588, -4.030219854252477],
            [24.948128602720953, -4.030094723501238],
            [24.948193646137426, -4.03008873984943],
            [24.949289417409179, -4.029987942418138],
            [24.950429453166574, -4.030845929900056],
            [24.950662299183193, -4.031021175027382],
            [24.952041309264036, -4.032059028672525],
            [24.962356338481442, -4.03297698736374],
            [24.963247543600101, -4.033497817420964],
            [24.963449374383199, -4.033615768734174],
            [24.96510928406013, -4.034585856103737],
            [24.96900916355926, -4.043788989723956],
            [24.971304162379155, -4.046089980985842],
            [24.98001544279456, -4.04792785694088],
            [24.980911028098536, -4.049466894361535],
            [24.981086566091555, -4.049768551280506],
            [24.981622122799319, -4.050688888289751],
            [24.979562202309531, -4.055750873518114],
            [24.98028334376848, -4.057272700542159],
            [24.981331650755596, -4.059484939747026],
            [24.983923242739568, -4.064953942754059],
            [24.983923788915234, -4.066045785880049],
            [24.983924203038598, -4.066872474586428],
            [24.983926122738364, -4.070706884943546],
            [24.973573243006459, -4.099771903312513],
            [24.972944322594564, -4.101542962172016],
            [24.97432128721152, -4.10591474847174],
            [24.975328579817724, -4.106924535514291],
            [24.975746590173923, -4.107343548088528],
            [24.976845238749547, -4.108444830945269],
            [24.992435081890527, -4.110972001711698],
            [24.995992617926468, -4.113498644802935],
            [24.996466262744875, -4.113835038039851],
            [24.997940202293361, -4.11488186034934],
            [25.000000213513026, -4.117980722117347],
            [25.000692383405752, -4.11902202857082],
            [25.000797450361372, -4.119730710733695],
            [25.001613281437773, -4.125234890475537],
            [25.000924870994531, -4.127920428610154],
            [25.000517252349518, -4.129510575918259],
            [25.000000121884852, -4.13152793046573],
            [25.000000121884852, -4.132369023844848],
            [24.995434242213836, -4.138122014487084],
            [24.984892362336044, -4.145487915564395],
            [24.984326389571095, -4.147767769591599],
            [24.984138643473319, -4.148524048742394],
            [24.983978379535081, -4.149170049906729],
            [24.984831162810686, -4.152157918174397],
            [24.98534168077655, -4.153947374123399],
            [24.985595674931574, -4.154837667868279],
            [24.986276202658185, -4.157223026360215],
            [24.98765155569755, -4.158601882971518],
            [24.988035440852741, -4.158986745068426],
            [24.989029122185727, -4.159982955045371],
            [24.996980965961619, -4.162944477278039],
            [24.99859396381779, -4.163545208379706],
            [25.000000121884852, -4.164068905249829],
            [25.01310736114371, -4.168949870589607],
            [25.015859200896273, -4.172399997719956],
            [25.014757331860352, -4.174061242466199],
            [25.014014629936266, -4.17518098228801],
            [25.013111320917481, -4.176542862327466],
            [25.011047674215867, -4.177752169669398],
            [25.009251923996615, -4.178804487359496],
            [25.002111161904235, -4.182988992190066],
            [25.002315773871448, -4.184319181016306],
            [25.002412091236206, -4.184945346093412],
            [25.002571242161835, -4.185979984387028],
            [25.007391281277837, -4.191500885245193],
            [25.009132537895361, -4.196037467895773],
            [25.009687376042393, -4.197483002229507],
            [25.009266298837801, -4.198647374292152],
            [25.008231750447568, -4.20150830496633],
            [25.006941281016069, -4.205076940957803],
            [25.001440127573517, -4.209219964738653],
            [25.000000121884852, -4.21158897634501],
            [24.999736045937411, -4.212023623673494],
            [24.998922358241284, -4.213362890418767],
            [24.999479174478552, -4.21416018841161],
            [24.999820631304573, -4.214648971206989],
            [25.000000121884852, -4.214905905535645],
            [25.00120217643116, -4.216627361694422],
            [25.003485003977246, -4.219896577419983],
            [25.00534829043788, -4.222564924078729],
            [25.004052721270529, -4.225321748365982],
            [25.001455290237192, -4.230848929495985],
            [25.001915560039311, -4.232322449129955],
            [25.002605441923002, -4.234530924477112],
            [25.00524337350091, -4.237865947553685],
            [25.006197315162364, -4.239071956794313],
            [25.007881128110693, -4.241200873083204],
            [25.009031440594949, -4.244192898319746],
            [25.008372922491091, -4.246377083942728],
            [25.007958531447162, -4.24775154120432],
            [25.006742200874385, -4.251785865025686],
            [25.007458027900107, -4.253756029181533],
            [25.007944427897201, -4.255094741173746],
            [25.008581441231481, -4.256847981393928],
            [25.013172161116731, -4.26604992782948],
            [25.019136271222393, -4.270189985457577],
            [25.02051544120339, -4.273180959514894],
            [25.01849322210775, -4.279124507150637],
            [25.017540327881914, -4.281925008558546],
            [25.015529549729706, -4.284551202592333],
            [25.000000121884852, -4.304832963781815],
            [24.994631442098932, -4.311845015405555],
            [24.993946380575068, -4.315986829692806],
            [24.993721362477856, -4.324039974337382],
            [24.992480622882177, -4.329032314587034],
            [24.991522492376529, -4.332887506228967],
            [24.990976397532183, -4.33508502421284],
            [24.992198705494882, -4.34594998928494],
            [24.993746202692094, -4.359705000630908],
            [24.991686157336474, -4.368218076366197],
            [24.972894283738313, -4.385479889950031],
            [24.973207767026381, -4.388914636026983],
            [24.973360952240192, -4.390593033350837],
            [24.973587283674327, -4.393072862184538],
            [24.977258046063657, -4.39935694904611],
            [24.979097571186699, -4.402505964748441],
            [24.988946470891378, -4.410927231196003],
            [24.994699151715189, -4.415845937237559],
            [24.995082512254243, -4.418146655322201],
            [24.995159212209821, -4.418606905908105],
            [24.991495122506461, -4.425510935596034],
            [24.992414202348389, -4.428271858754293],
            [24.997565306579219, -4.433122302192435],
            [24.999725773702131, -4.435156656479753],
            [25.000000121884852, -4.435414990096991],
            [25.007559401881593, -4.44253289635489],
            [25.005672038774719, -4.446499922477675],
            [25.005041202256312, -4.447825864946048],
            [25.002675482667392, -4.448830663009849],
            [25.000000121884852, -4.44996697529008],
            [24.999911329707217, -4.450004630900863],
            [24.999833217600003, -4.450037756837104],
            [24.999078162044132, -4.450357966028566],
            [24.998688809742134, -4.452191960069325],
            [24.998560175485032, -4.452797876559363],
            [24.998394162328935, -4.453579860187446],
            [25.000000121884852, -4.456697884018541],
            [25.000054469959551, -4.45680342062685],
            [25.000445443720672, -4.457562642717731],
            [25.002067241473348, -4.460711962675192],
            [25.001605707741607, -4.461681653827805],
            [25.000897445428912, -4.463169724134824],
            [25.000000121884852, -4.465055012292797],
            [24.999999980849374, -4.466004004408111],
            [24.996287176406454, -4.468769183440979],
            [24.994627706904001, -4.470005100105779],
            [24.993818202662123, -4.470607991322723],
            [24.987858320926467, -4.473140002002465],
            [24.984585869737518, -4.47275038493935],
            [24.978224107794912, -4.471992954883406],
            [24.972498188681769, -4.483038878082032],
            [24.967909364241756, -4.481198882924784],
            [24.965158244938067, -4.482119886337128],
            [24.961267364761422, -4.494775931825248],
            [24.957262500053346, -4.498553171790337],
            [24.955618268673057, -4.500103945098185],
            [24.953703405440372, -4.501909962395724],
            [24.929172305086428, -4.519632946848184],
            [24.9291690945076, -4.519647504589176],
            [24.927395326063362, -4.527720957781477],
            [24.922080547889443, -4.533427736604415],
            [24.922069776190845, -4.533439329924543],
            [24.928037206469845, -4.541491890956878],
            [24.927748676583715, -4.543724235335693],
            [24.927612473122036, -4.544778028694135],
            [24.927353182500095, -4.546783950221218],
            [24.921749384858263, -4.54651694640959],
            [24.917719198438935, -4.546325070543985],
            [24.917556083247977, -4.546707505153001],
            [24.917139947675754, -4.547683250796286],
            [24.916345127295529, -4.549546924714489],
            [24.920480086921362, -4.561511001924099],
            [24.917503230868217, -4.568182952122499],
            [24.917463973591992, -4.568117319648754],
            [24.916815022545919, -4.567032887882414],
            [24.912227111692555, -4.567264979465075],
            [24.909627795993771, -4.565472863253943],
            [24.909215271649014, -4.565188442114506],
            [24.908556077113737, -4.564734032972683],
            [24.905803414504369, -4.565194978615888],
            [24.902139168494148, -4.576239901169607],
            [24.90123811694167, -4.577661999726497],
            [24.900375168330275, -4.579023959163425],
            [24.898771499478325, -4.581554392956699],
            [24.897327408251762, -4.583833020768741],
            [24.895376792969099, -4.584567314881325],
            [24.894726308498811, -4.584812184883737],
            [24.889988088837178, -4.586595848862187],
            [24.888126852332022, -4.586720245043395],
            [24.888050332937794, -4.58672535888179],
            [24.886980289415778, -4.586796875993508],
            [24.885547251958769, -4.586893147387552],
            [24.885446914633132, -4.586899888313729],
            [24.883108129231349, -4.587057008304783],
            [24.881522998013605, -4.58797783801883],
            [24.881014336865441, -4.588273327687394],
            [24.87875140969782, -4.589587898242955],
            [24.880130209572911, -4.596950925966532],
            [24.878971379263142, -4.599715718152746],
            [24.878510159941751, -4.600816114231391],
            [24.878298093754328, -4.601321906978081],
            [24.875204169253376, -4.602012448895649],
            [24.874792586343009, -4.602104311190539],
            [24.872106319114607, -4.602703867210264],
            [24.870960327526856, -4.605234942425593],
            [24.871544174071055, -4.606352020353701],
            [24.87348528338137, -4.610066005751638],
            [24.87262799685125, -4.612135645809058],
            [24.872341241137818, -4.612827864507599],
            [24.871843670590152, -4.613195737017564],
            [24.871085192453037, -4.613756444040392],
            [24.86798417036302, -4.616048879632932],
            [24.864420877024411, -4.625594316262856],
            [24.863861090956807, -4.627093873495654],
            [24.863677584008901, -4.627348249963815],
            [24.859047171164498, -4.633766881578765],
            [24.8594738565514, -4.635155524529019],
            [24.85982500889429, -4.636298343804421],
            [24.859966224056944, -4.636757924700174],
            [24.863868290953807, -4.64250886125123],
            [24.859510130522597, -4.645500851128502],
            [24.859628449425298, -4.649901394083568],
            [24.859673463105853, -4.651575534001592],
            [24.859745210649294, -4.65424394081838],
            [24.857914250962477, -4.660686941809675],
            [24.859291250613719, -4.665517895920625],
            [24.865478801374952, -4.670858462305185],
            [24.867553279063941, -4.672648963902708],
            [24.869621090355235, -4.681161949518608],
            [24.873525289852569, -4.686222858669778],
            [24.865268330595473, -4.691055968705317],
            [24.863893131168044, -4.694276945582826],
            [24.864386052035805, -4.695181172320115],
            [24.864796687223532, -4.695934449293326],
            [24.865272291267573, -4.696806906912705],
            [24.869105463670341, -4.699632531172945],
            [24.869956265262449, -4.700259697830077],
            [24.873075289590769, -4.702558875902191],
            [24.875938369521599, -4.708178956141932],
            [24.880420386070956, -4.714520871966416],
            [24.887764345283951, -4.71543995739756],
            [24.888014208985279, -4.715914866704713],
            [24.888539391049832, -4.716909042829645],
            [24.889118982274514, -4.718006214001881],
            [24.889829328678715, -4.719350906197723],
            [24.888225169346612, -4.723952979550694],
            [24.889144493530285, -4.726483184766599],
            [24.88958206021023, -4.727687473271956],
            [24.890064408805415, -4.729015010080993],
            [24.896263248694837, -4.736836000096059],
            [24.896000393557848, -4.739019248294046],
            [24.895841809469182, -4.740336433117584],
            [24.895349353928758, -4.74442812702741],
            [24.89613020550631, -4.745881078544772],
            [24.901779168644008, -4.756391854227805],
            [24.906339114044268, -4.761901767892087],
            [24.908472858982421, -4.764480018599274],
            [24.90958427082164, -4.765822956403367],
            [24.912249497709421, -4.766391910528495],
            [24.912907255838572, -4.766532309410438],
            [24.923582207650963, -4.768810888241824],
            [24.924980191048938, -4.770536063853277],
            [24.925367028068163, -4.771013438282961],
            [24.926565166858154, -4.772491994383969],
            [24.926953076465814, -4.774341782555071],
            [24.927449890632023, -4.77671088905432],
            [24.929556407633918, -4.786755914937749],
            [24.93254116706493, -4.790205962943887],
            [24.941490406707533, -4.792964911936574],
            [24.94612402474085, -4.796763145440144],
            [24.949066266909469, -4.799174918737364],
            [24.949318766267851, -4.799130853079969],
            [24.954342418424488, -4.79825397933091],
            [24.956840078070769, -4.798638259950299],
            [24.956939951865731, -4.798653626484516],
            [24.960308216464597, -4.799171859310749],
            [24.963295245040005, -4.806303862263011],
            [24.968919610508614, -4.811049589518641],
            [24.970798633656369, -4.812635063569281],
            [24.976379444308442, -4.817343994317837],
            [24.977533244950926, -4.82631601138363],
            [24.980287244253446, -4.828615969781324],
            [24.981754971053437, -4.831456496529812],
            [24.982574672970433, -4.833042855861513],
            [24.983734158152021, -4.83528707382189],
            [24.978853080309076, -4.837363180374139],
            [24.972511320254572, -4.838428468897851],
            [24.961668479603784, -4.840914972034181],
            [24.953553359838484, -4.843165136924126],
            [24.948787679576913, -4.845502749939825],
            [24.946431480333359, -4.847287784721452],
            [24.938847720346821, -4.854784341374546],
            [24.933633119598454, -4.860803614122054],
            [24.927676199608296, -4.863725685750069],
            [24.920461080366572, -4.865691325703926],
            [24.907737599600484, -4.866897535204045],
            [24.895252079858192, -4.866570887226659],
            [24.879931919948671, -4.864015521943629],
            [24.871960800123428, -4.862575857726777],
            [24.863963039860096, -4.86051988220528],
            [24.857845919712062, -4.859744287730211],
            [24.852933360409967, -4.858692322346809],
            [24.846551639698383, -4.858833111022955],
            [24.841176839690437, -4.861154866934373],
            [24.836531399827955, -4.866265788086914],
            [24.832799640034246, -4.871400374975595],
            [24.828445440275104, -4.876210972141045],
            [24.825560400128861, -4.87982899784922],
            [24.822952919642425, -4.882838437377504],
            [24.822119520214024, -4.884663415913915],
            [24.824464919911232, -4.889649176955045],
            [24.826492439965346, -4.894318680174597],
            [24.830002439851416, -4.898103783520072],
            [24.833937240458912, -4.904669977408361],
            [24.838123319614336, -4.910011482296111],
            [24.84015083966845, -4.914681021494835],
            [24.842445119836096, -4.92551267888011],
            [24.843545999826908, -4.929850104280074],
            [24.844646519593287, -4.934187321687969],
            [24.845429159716563, -4.938208671661292],
            [24.845907240415837, -4.94222191619328],
            [24.848259699074539, -4.947777229060964],
            [24.848279279652807, -4.947823467855347],
            [24.844346718545307, -4.954845577572122],
            [24.844289399741974, -4.954947927610049],
            [24.840404280461257, -4.95561891129582],
            [24.833266560064413, -4.952354661018171],
            [24.827955839580653, -4.94913833591395],
            [24.820420320023178, -4.943709526751705],
            [24.814447199815195, -4.939244709105187],
            [24.805509119943366, -4.936548853399333],
            [24.799445279773146, -4.937005824398629],
            [24.795790919722617, -4.936910120706242],
            [24.791142960085807, -4.934941999997199],
            [24.779052719729791, -4.929701610250635],
            [24.771345840243665, -4.927345799429554],
            [24.764382000448165, -4.928086839346994],
            [24.761192399979553, -4.931696500310182],
            [24.756797880237187, -4.935582300018336],
            [24.748818839966066, -4.94799134991481],
            [24.745180319908961, -4.955282072627488],
            [24.738814800313495, -4.962809181102434],
            [24.735400559938416, -4.96825919672393],
            [24.732873720316757, -4.973116843822507],
            [24.730306559813577, -4.977050335337633],
            [24.727726079989665, -4.980675524598761],
            [24.717775320314907, -4.996724794448355],
            [24.71304959981212, -4.999986308248739],
            [24.708813119779414, -5.000490812040492],
            [24.702708959625969, -5.000023472344541],
            [24.698141279731136, -4.999904079312178],
            [24.692050439796756, -4.999744648332701],
            [24.687191519798581, -4.999925264462298],
            [24.683063399945318, -4.999999953011676],
            [24.675037199918414, -5.000222760976772],
            [24.666088319601943, -5.004296845331471],
            [24.659351280161165, -5.010275066827512],
            [24.651262439711189, -5.013140636657043],
            [24.64682796021004, -5.016101884882902],
            [24.637839120134789, -5.019251630719447],
            [24.630068160226173, -5.022433138663655],
            [24.61366655986863, -5.030004707381209],
            [24.601672440146306, -5.033998892103324],
            [24.594139080138785, -5.035648048094144],
            [24.589082519998335, -5.038285144842999],
            [24.580013400181077, -5.039586364449643],
            [24.575367960318626, -5.044695889028855],
            [24.575608440218513, -5.050240720969419],
            [24.577344720169318, -5.055209413370906],
            [24.581212560355539, -5.060233719341748],
            [24.583213385174403, -5.064285878730391],
            [24.583718105413404, -5.068914451438768],
            [24.584527385076438, -5.07355106962711],
            [24.584701264779479, -5.077555573625915],
            [24.583047425018904, -5.08151212167679],
            [24.581076064941403, -5.085152699116292],
            [24.580691855494354, -5.085665961524297],
            [24.577913466033575, -5.089377573151736],
            [24.575134985842958, -5.095458578655621],
            [24.575455746383149, -5.102851027926595],
            [24.576529625711437, -5.106571185086264],
            [24.578279225881303, -5.111847472694241],
            [24.578944146278175, -5.12017172205763],
            [24.575914745967442, -5.12747646467346],
            [24.572554506019049, -5.134157176118697],
            [24.568862705984092, -5.140213696922494],
            [24.565780025695542, -5.146286135551685],
            [24.563544065952787, -5.150842489867461],
            [24.561957185715155, -5.156338646988773],
            [24.560396946813949, -5.162450777063288],
            [24.559723746645091, -5.167970703881748],
            [24.561145370108083, -5.172330874814044],
            [24.559311094739545, -5.17210083383254],
            [24.554258208708593, -5.165197011676274],
            [24.540027444727293, -5.163353990023976],
            [24.531994370791828, -5.16496187850463],
            [24.531456959062993, -5.164910848656755],
            [24.530773268368236, -5.164845928099794],
            [24.52235431950924, -5.164040009101811],
            [24.51799434897271, -5.164959008137729],
            [24.515938748481098, -5.168363970052359],
            [24.516470109158181, -5.173607789854888],
            [24.516988508942347, -5.178543564107018],
            [24.51818226844529, -5.185035090969913],
            [24.521005748841773, -5.194030177579606],
            [24.523431428280958, -5.200861482285282],
            [24.527857628010132, -5.211743922473236],
            [24.528429307772107, -5.217911326347495],
            [24.529014307753112, -5.224386468521284],
            [24.534156548307053, -5.237748076972826],
            [24.53700666824329, -5.247358335043742],
            [24.539207707776011, -5.256028759595321],
            [24.542693587896682, -5.266270621354676],
            [24.546046267623669, -5.273432770315432],
            [24.553629667385774, -5.301005965736072],
            [24.554863746871973, -5.308419835969978],
            [24.555568987252069, -5.317665422570228],
            [24.557281147437507, -5.329090047329187],
            [24.55639698690732, -5.33675587059105],
            [24.552507564696402, -5.345265683459679],
            [24.547610828319716, -5.351596283864109],
            [24.542342947593536, -5.356379361222483],
            [24.522847869197697, -5.376782556945754],
            [24.518493668540223, -5.381589298325387],
            [24.513436749073673, -5.384224924377259],
            [24.507533109959663, -5.388376159175171],
            [24.499511212862952, -5.392779281954167],
            [24.494652309932789, -5.392959780345278],
            [24.489475150965447, -5.392824491186473],
            [24.484880485679472, -5.39208939215673],
            [24.479041271042693, -5.390706551803579],
            [24.460408751389409, -5.381916217111687],
            [24.455376311912627, -5.378094191262253],
            [24.449440631689075, -5.367482787166625],
            [24.443398031285426, -5.35440789002503],
            [24.439979112484362, -5.345707103970724],
            [24.436164541496158, -5.341916801423349],
            [24.430763112728254, -5.34362093546889],
            [24.423801432482708, -5.351435149131512],
            [24.423646632097984, -5.36188785595294],
            [24.421637832036055, -5.37167666457014],
            [24.416423233084316, -5.377691011942296],
            [24.411630897113334, -5.379411026641518],
            [24.401276952877804, -5.379140267515964],
            [24.390923009540604, -5.378869688335125],
            [24.382780138121245, -5.381600974706783],
            [24.370113554848579, -5.390011992373632],
            [24.360528915245986, -5.39345176701972],
            [24.352771274658103, -5.396939248090673],
            [24.339083715640886, -5.4039620558375],
            [24.325235597139685, -5.407290329321492],
            [24.316762276849765, -5.408299034865379],
            [24.305296982758819, -5.410459437899764],
            [24.296770037538039, -5.410236594388826],
            [24.285117931597235, -5.408086784264236],
            [24.277059983311542, -5.4041951461591],
            [24.277039879015501, -5.404185436464952],
            [24.256620678534059, -5.396271072215227],
            [24.249814159795942, -5.393632987258479],
            [24.238055105827296, -5.389020118974883],
            [24.226402999886492, -5.386870408182806],
            [24.19570976121237, -5.380532461972362],
            [24.182812760967675, -5.377734973545924],
            [24.172934361487378, -5.374401332823669],
            [24.163691727581426, -5.371699457703469],
            [24.157696282441982, -5.375245734058775],
            [24.149208554971548, -5.381102503128945],
            [24.143651602675153, -5.379690579197332],
            [24.134923763614115, -5.375382640589837],
            [24.126327357062301, -5.37155395563865],
            [24.125773320212485, -5.385619440678803],
            [24.123591720222521, -5.390418395551586],
            [24.120686159860213, -5.395628375240897],
            [24.120302040244709, -5.404928784442773],
            [24.118478639880998, -5.411127242303215],
            [24.108387479815555, -5.422199691357056],
            [24.105473999905698, -5.420824460462674],
            [24.10256051999588, -5.419449047240006],
            [24.099633000316459, -5.419108691676756],
            [24.096705479738738, -5.418768335919176],
            [24.09377832028375, -5.418427800812609],
            [24.090850799706001, -5.418087265511509],
            [24.090230159964417, -5.415328887023896],
            [24.08960988044727, -5.41257049578044],
            [24.088989239807354, -5.409812091787502],
            [24.087499199753989, -5.410044440690713],
            [24.086008800374554, -5.410276790403757],
            [24.084175680239447, -5.412272658506388],
            [24.082342199879943, -5.414268520834836],
            [24.080509079744871, -5.416264376486384],
            [24.077748960220326, -5.416038129390525],
            [24.077167199564258, -5.413457007916947],
            [24.076585439806447, -5.41087569522089],
            [24.076004040273105, -5.408294551421293],
            [24.075422279617001, -5.405713395566695],
            [24.074840519859226, -5.403131870244081],
            [24.074344080290505, -5.400921022057845],
            [24.073848000047889, -5.39870998653854],
            [24.073351559580871, -5.396498942848683],
            [24.07162391962645, -5.39368466336728],
            [24.069896639896466, -5.390870549824053],
            [24.068168999942046, -5.388056243900829],
            [24.066441359987625, -5.385242103931048],
            [24.065620560329378, -5.38764104928695],
            [24.0647997597728, -5.390039805881258],
            [24.057027720089241, -5.397537451428061],
            [24.051217680037933, -5.407243681616222],
            [24.048673560423438, -5.412426421588891],
            [24.045027840369329, -5.424466618383651],
            [24.045090122364588, -5.426516133336964],
            [24.045363000005192, -5.435495580505786],
            [24.045332399793367, -5.448334577803513],
            [24.04456524033737, -5.466576948737911],
            [24.046339679823141, -5.480706586987366],
            [24.049191599983168, -5.497964163847105],
            [24.053122800143029, -5.517636155782096],
            [24.055985159624996, -5.530613640526265],
            [24.057406079707121, -5.541202927572597],
            [24.060624119939312, -5.556648821896029],
            [24.061307400103964, -5.573353308236331],
            [24.06236940011097, -5.582899153971209],
            [24.065964720186063, -5.591899034964218],
            [24.071380559727771, -5.595771867629329],
            [24.083309159926497, -5.598444559275096],
            [24.092704079832696, -5.602019787079007],
            [24.102824760335025, -5.604471298231366],
            [24.11474580031231, -5.610353051337197],
            [24.124789080173134, -5.613015810722454],
            [24.128468639764002, -5.61895146278089],
            [24.139653119598822, -5.630235023895934],
            [24.146143199591585, -5.638661141081763],
            [24.150101759740014, -5.646920161827031],
            [24.160936679944964, -5.65323890398969],
            [24.170322959854747, -5.66037897064525],
            [24.170307561832466, -5.665966462962513],
            [24.170307480085764, -5.665995980330939],
            [24.171676866515003, -5.668130832253989],
            [24.172374240348152, -5.669218023938677],
            [24.170902631927799, -5.675103664495711],
            [24.170534302000078, -5.676576776238772],
            [24.173055360064552, -5.687617900420203],
            [24.172257418038718, -5.689374343337515],
            [24.170757480347564, -5.692676018088322],
            [24.171299227345962, -5.693870309562343],
            [24.173053199616298, -5.697736959350702],
            [24.170984334601211, -5.701645018401384],
            [24.173740440453056, -5.705557022333183],
            [24.174288359775773, -5.708860973824825],
            [24.174656280071751, -5.711076927377985],
            [24.173966046048466, -5.712958777174852],
            [24.172126200226863, -5.71797489481119],
            [24.173813054870731, -5.719785403835311],
            [24.175342440235198, -5.721426895025507],
            [24.176260440302151, -5.726257867276827],
            [24.177406169581818, -5.726731483146446],
            [24.180162480249567, -5.727870871949702],
            [24.18245640019278, -5.739677675218306],
            [24.183603360164405, -5.745580983965062],
            [24.194168280032585, -5.748348009735429],
            [24.19508735987451, -5.749958977919993],
            [24.190029359734648, -5.76076493880625],
            [24.192325440126151, -5.766975003419537],
            [24.198984360273176, -5.772958892805491],
            [24.199377185462083, -5.774928873481284],
            [24.199672319762144, -5.776408942017365],
            [24.190250400091781, -5.786982014422832],
            [24.187721400021868, -5.798707962953499],
            [24.179030639822489, -5.799436277090374],
            [24.173971559907685, -5.797676452417],
            [24.166024559847809, -5.793637889482116],
            [24.157350720315126, -5.791079077713648],
            [24.143972400046259, -5.789584594464771],
            [24.136739639689004, -5.789412464780727],
            [24.125163840241676, -5.790277777582782],
            [24.116480640263738, -5.791639755089572],
            [24.10924067990948, -5.794319054034151],
            [24.101641800378388, -5.795956067963031],
            [24.095126519946984, -5.798224929776622],
            [24.087529080415308, -5.799149219090221],
            [24.079574520133992, -5.79831852449363],
            [24.071620320077116, -5.797131201679647],
            [24.06655619971523, -5.797509882569491],
            [24.062211000176909, -5.799616472897749],
            [24.057856440193333, -5.805643580542784],
            [24.055314119904388, -5.810109856542771],
            [24.049878839921629, -5.81443588815174],
            [24.041561399791416, -5.813988548079277],
            [24.030715319815691, -5.812304970520685],
            [24.024205800280203, -5.812078879139644],
            [24.012982799787682, -5.816837530541959],
            [24.011291930572785, -5.827285760063051],
            [24.011287200044503, -5.827314990971334],
            [24.007610160227987, -5.831451021195083],
            [24.006234145130264, -5.830990780689159],
            [24.003475199703828, -5.830067985582287],
            [24.000388760864123, -5.827645895145342],
            [23.998193280106374, -5.825922980156651],
            [23.992910279835616, -5.825687929445582],
            [23.988940533865264, -5.82752933232586],
            [23.98647722130384, -5.828671792099707],
            [23.982833788360441, -5.82757418985659],
            [23.974992360109386, -5.825211912608553],
            [23.973597560340757, -5.823625855898272],
            [23.97155040041957, -5.82129797859703],
            [23.964430320239963, -5.819682016343556],
            [23.962069224279805, -5.817631268646916],
            [23.960985479653058, -5.816689972466839],
            [23.958849891371926, -5.816259751887857],
            [23.957540162060727, -5.815996093535777],
            [23.948067890022056, -5.819078454959162],
            [23.946972417889274, -5.819434947304837],
            [23.945250245979985, -5.826524684440815],
            [23.945129207876903, -5.827022832058078],
            [23.94163084746199, -5.826727271471057],
            [23.939615398070313, -5.826557026327835],
            [23.93570729898634, -5.83069298394368],
            [23.935936258891015, -5.834372880504914],
            [23.929958459358687, -5.840805872814783],
            [23.924213219280404, -5.843100010141579],
            [23.920255724533899, -5.843603542280798],
            [23.920002795780803, -5.84363572393903],
            [23.915254259866433, -5.844239903570648],
            [23.911575408148011, -5.849065843865109],
            [23.906294233253917, -5.845610920116187],
            [23.905521658753383, -5.846803619518768],
            [23.905316514983522, -5.847120317217561],
            [23.903764123764621, -5.849516938405051],
            [23.899629377039506, -5.848822974678403],
            [23.901010140631787, -5.845604975531337],
            [23.899646111754937, -5.82306615450111],
            [23.89183842063267, -5.81937900816528],
            [23.882265656758133, -5.806642835827862],
            [23.880594181271906, -5.80441897659211],
            [23.873014365787785, -5.800961930203321],
            [23.857142001591626, -5.800691725741873],
            [23.847744543046463, -5.798186915549673],
            [23.837631445223433, -5.792528576042184],
            [23.836620903410896, -5.795957141286958],
            [23.834323383020017, -5.796879282321843],
            [23.832025863527431, -5.797801421830075],
            [23.829728704259285, -5.798723738847773],
            [23.82743120542797, -5.799645853709314],
            [23.826814144574488, -5.79742435426901],
            [23.826197464606675, -5.795202824375123],
            [23.825580424414429, -5.792980927546928],
            [23.826200344605468, -5.790258768848992],
            [23.826844743888017, -5.787432600719754],
            [23.8274895042933, -5.78460641827396],
            [23.828133904474143, -5.781780401460107],
            [23.828778663981129, -5.778954011360148],
            [23.830382104660984, -5.776576411582485],
            [23.83198554354421, -5.774198622647197],
            [23.833588983325768, -5.771820822701299],
            [23.83508046337851, -5.771244526003573],
            [23.836571583206819, -5.770668049666809],
            [23.8367213431445, -5.768139077466753],
            [23.836870743756002, -5.765610094741032],
            [23.837020503693648, -5.763081099695204],
            [23.83851054374701, -5.761469989243704],
            [23.840000583800339, -5.759858873260901],
            [23.841719943084485, -5.759511905304928],
            [23.843438943042489, -5.759164936234488],
            [23.843779143125438, -5.756291093454863],
            [23.84411934320838, -5.753417235951827],
            [23.846182503023073, -5.750885675592535],
            [23.847893516059916, -5.748786052974906],
            [23.848245643074858, -5.748353924766489],
            [23.843422402363167, -5.748263908136845],
            [23.832861406336143, -5.742042876970775],
            [23.828117721324301, -5.741919007223222],
            [23.823673162725683, -5.741802949267383],
            [23.820810424154647, -5.742442934103604],
            [23.812416304730093, -5.74431984655033],
            [23.809790562392294, -5.746177878363847],
            [23.808496674871112, -5.74709345940001],
            [23.806900384780917, -5.748223023873671],
            [23.796791161391734, -5.751890971696659],
            [23.785757182604666, -5.761996974086653],
            [23.780473160949438, -5.761071027158269],
            [23.779453239826974, -5.76296514328641],
            [23.779206577721329, -5.763423231153716],
            [23.778864306123346, -5.764058880702347],
            [23.771509146715371, -5.770029891086486],
            [23.770671287151547, -5.771381710594336],
            [23.769854519132306, -5.772699492143492],
            [23.76552737393455, -5.779680909056283],
            [23.762083267271237, -5.778756954562868],
            [23.761280191373523, -5.777388078999049],
            [23.761052659790167, -5.777000249641932],
            [23.759788249586737, -5.774845025093668],
            [23.751090833769432, -5.774616703406911],
            [23.750601445077361, -5.774603856316746],
            [23.746441589541742, -5.772464584510923],
            [23.745802882883165, -5.77213611907481],
            [23.741188148335404, -5.769762899869461],
            [23.73884914374473, -5.76636062325696],
            [23.737892189133781, -5.764968647263041],
            [23.736599119079521, -5.763087889115935],
            [23.73338515899535, -5.762393984879082],
            [23.731645442090251, -5.76343561783508],
            [23.731397369629594, -5.763584145523096],
            [23.729936330786892, -5.764458921242618],
            [23.725461667846478, -5.764225786230343],
            [23.721012325718952, -5.763993971034131],
            [23.718700453843109, -5.766576845116617],
            [23.712019920230318, -5.763520054560582],
            [23.710420101557695, -5.75845998456916],
            [23.71203000022615, -5.752710023178955],
            [23.715939959721076, -5.751630012801459],
            [23.720300086564471, -5.750419671311651],
            [23.721618688535731, -5.747842004423886],
            [23.726059919774535, -5.739159983009705],
            [23.730926109838283, -5.72544056158555],
            [23.735030039857605, -5.713869945495723],
            [23.733659879978934, -5.704670058673239],
            [23.737576591211543, -5.693816589522682],
            [23.737809960047638, -5.693169901492515],
            [23.73511230397807, -5.689228568556442],
            [23.732300160320488, -5.685119939216629],
            [23.728257402877077, -5.682736984291277],
            [23.725649880169847, -5.68120000686182],
            [23.72496958600518, -5.677117350145092],
            [23.72473007987908, -5.675679990116612],
            [23.725483151954794, -5.67399735800725],
            [23.730490080175809, -5.662809965696797],
            [23.74318141742442, -5.652167059584968],
            [23.744739960306376, -5.650860057921573],
            [23.747181318940534, -5.650167981466509],
            [23.747950580454305, -5.64994939782011],
            [23.749019999647235, -5.648550071018742],
            [23.750939879970776, -5.646040101857984],
            [23.750709840291126, -5.642589974529321],
            [23.745670062476819, -5.634079820896701],
            [23.755583118960772, -5.627006661611504],
            [23.75586339602437, -5.626808649273285],
            [23.758402319783251, -5.625014933812748],
            [23.756244570064055, -5.621669024240168],
            [23.753494439805472, -5.614995922768197],
            [23.749952399708192, -5.611750974663826],
            [23.749339807074907, -5.611190187579388],
            [23.748214320431835, -5.610159881454192],
            [23.743860915681722, -5.608510883468113],
            [23.732374319840439, -5.604159927178141],
            [23.727562200271951, -5.592193910987325],
            [23.723900279999981, -5.577699980222317],
            [23.71885343963093, -5.571252874563099],
            [23.717718359878955, -5.557220850544846],
            [23.714708736877515, -5.551179127691043],
            [23.714279301747499, -5.550316954607485],
            [23.718191400131147, -5.541581958664005],
            [23.717567887577278, -5.534441275008419],
            [23.71750849186899, -5.533760872817453],
            [23.718047150459466, -5.531569694602337],
            [23.720504400291013, -5.521573884017921],
            [23.716345938940684, -5.49513818032226],
            [23.71488407993613, -5.485844733185517],
            [23.707062359824096, -5.465367948771145],
            [23.703192720312359, -5.437943483591853],
            [23.707310760169825, -5.394661095020626],
            [23.707588680054101, -5.391866005213217],
            [23.707866239713979, -5.389070903265515],
            [23.708143800272119, -5.386275966547883],
            [23.708421359931997, -5.383481016804633],
            [23.708698919591839, -5.380686054942822],
            [23.708976840374451, -5.377891079168449],
            [23.709254400034293, -5.37509609128886],
            [23.704578324027402, -5.359161863341913],
            [23.694396840156767, -5.354897396221515],
            [23.676412320233663, -5.352362127044902],
            [23.637062880447463, -5.350316534504683],
            [23.612337360411509, -5.345513850067795],
            [23.588729640134762, -5.343399329506996],
            [23.569621919781, -5.340393696256193],
            [23.546581920390757, -5.336019083296763],
            [23.521860360128574, -5.329552838211773],
            [23.503890600423912, -5.320918090043504],
            [23.486489639584132, -5.3094685468192],
            [23.477496839735075, -5.308478160111655],
            [23.466250800150462, -5.309319423530923],
            [23.451630840173991, -5.310413352736852],
            [23.435795159580803, -5.307016891642992],
            [23.438099519744249, -5.301039884790085],
            [23.437185321347584, -5.296208027246216],
            [23.432819400370615, -5.299191876639362],
            [23.430530159751715, -5.294357023930128],
            [23.431686470287126, -5.2874579041555],
            [23.429857319807294, -5.281933958901003],
            [23.426191450541321, -5.276406987649391],
            [23.426885520370881, -5.271577861944801],
            [23.432398200096824, -5.269746993008627],
            [23.431711320382831, -5.267444849558239],
            [23.425378937841565, -5.262577667188113],
            [23.423914422518727, -5.26145196797289],
            [23.422771458253493, -5.257768918389129],
            [23.427602279847857, -5.248344875446832],
            [23.427377279716957, -5.244894946626943],
            [23.424578563177924, -5.240471433705484],
            [23.424171542810914, -5.239828114397808],
            [23.423561177999531, -5.239788999442713],
            [23.42049839988611, -5.239592862692794],
            [23.395456440206505, -5.255653857444722],
            [23.387190260641326, -5.256560145016018],
            [23.382595439946822, -5.260003024949749],
            [23.378233319741806, -5.260225920157181],
            [23.377677185325833, -5.260043713612729],
            [23.369055480418996, -5.25721897981246],
            [23.362131490787803, -5.256382152698708],
            [23.359415400390301, -5.256053887601003],
            [23.354135563985981, -5.253553229059688],
            [23.343814763092862, -5.248665019203088],
            [23.335107998508395, -5.249141946253252],
            [23.327514359748672, -5.24955790013931],
            [23.320860480048694, -5.247705967944937],
            [23.314432320030196, -5.24815499828797],
            [23.307607105554382, -5.250841190322747],
            [23.306896440248281, -5.251120884869782],
            [23.306771604966503, -5.251170017428065],
            [23.305704480070823, -5.251590012389882],
            [23.298099911509048, -5.25704098678544],
            [23.296741264439046, -5.258014863047241],
            [23.285257200050246, -5.262364957568479],
            [23.276533319864647, -5.263268918237141],
            [23.274632084074863, -5.264587519159001],
            [23.268261240164701, -5.26900599408678],
            [23.264013240136787, -5.269572466023233],
            [23.259765240108834, -5.270138938336747],
            [23.256207308814169, -5.274759234059389],
            [23.252865479837489, -5.279098867755325],
            [23.246891279854566, -5.283228929872786],
            [23.245289530702376, -5.283920828475482],
            [23.239999440029091, -5.286205953185848],
            [23.229611426288077, -5.288346615265913],
            [23.227829280155504, -5.288713862344937],
            [23.219195692334061, -5.292027845731577],
            [23.196819239816634, -5.300616914439133],
            [23.194805400205951, -5.302207942076327],
            [23.185148040184455, -5.309282816230695],
            [23.175047879898187, -5.301167834226908],
            [23.158272960369779, -5.263057868489556],
            [23.150448360258949, -5.243682630474672],
            [23.142036599718828, -5.234886042875747],
            [23.133619080079413, -5.228307633975986],
            [23.127449759728542, -5.222115387124251],
            [23.1211985381766, -5.214666225807381],
            [23.115574455677315, -5.211222243665071],
            [23.111739720205929, -5.208874050935929],
            [23.079228480042953, -5.168608799171195],
            [23.078659607516236, -5.168089009792047],
            [23.042203919737936, -5.134778970861364],
            [23.026506119761077, -5.116543734344843],
            [23.024973239950132, -5.107958970391487],
            [23.015339280143493, -5.104947885347974],
            [23.011496661955476, -5.102556811884488],
            [22.99493447965606, -5.092250869319007],
            [22.983643921362589, -5.08088924859889],
            [22.977981360426426, -5.075190970798113],
            [22.970546279704219, -5.070930995412706],
            [22.967169444279282, -5.068995109572957],
            [22.964683319899535, -5.067569850139897],
            [22.960560239595022, -5.06365001648878],
            [22.956217199606652, -5.052828029431266],
            [22.951933500529318, -5.046752027379854],
            [22.951181256700291, -5.045685036924271],
            [22.948460493266655, -5.044314476455439],
            [22.945678199727659, -5.042913008548106],
            [22.928240031567103, -5.04172391404326],
            [22.91379948042421, -5.032028912200826],
            [22.90944096066686, -5.030868966693301],
            [22.905082440011213, -5.029709019991961],
            [22.912073279570873, -5.009190487594919],
            [22.914386639955172, -4.982392325432676],
            [22.921160760054242, -4.970791175080254],
            [22.925958839853131, -4.963458610881065],
            [22.944813479638523, -4.954043167601865],
            [22.957759800087256, -4.947526844698212],
            [22.967899920132343, -4.93900141028105],
            [22.97466360001118, -4.931838171692654],
            [22.970183760079756, -4.924407130217501],
            [22.959509400257122, -4.921323003577031],
            [22.948263359774181, -4.922164962975987],
            [22.93364339979771, -4.923259382802488],
            [22.925781719926889, -4.919409961586782],
            [22.924126440166894, -4.906219623053778],
            [22.931265240338714, -4.894950938442359],
            [22.933868223858813, -4.89029588776446],
            [22.942314360229894, -4.875190996838446],
            [22.953794641813051, -4.870844854613612],
            [22.97482992039108, -4.862479245767372],
            [23.040096119941818, -4.841503284068066],
            [23.06205396023179, -4.828207954659697],
            [23.076685800427907, -4.822118887771405],
            [23.089063320215129, -4.818417938519709],
            [23.107050359912591, -4.819845485866066],
            [23.116115159731642, -4.809986923038407],
            [23.119802280442286, -4.80033097638599],
            [23.122558440193053, -4.798956008842401],
            [23.131275314417724, -4.799893828637471],
            [23.135874371567105, -4.794151098018852],
            [23.142528359963233, -4.793013945217711],
            [23.148262440270742, -4.793944965892719],
            [23.152377130310533, -4.796597342827993],
            [23.153991635539736, -4.797637952970721],
            [23.160646439606126, -4.796960001069248],
            [23.162939279774395, -4.798804970426542],
            [23.163938137200056, -4.799262997776467],
            [23.165460360296763, -4.799961014291739],
            [23.167738016241763, -4.799550017853187],
            [23.170509360215771, -4.79904993641751],
            [23.175338400450954, -4.791696971742451],
            [23.179067482366815, -4.788125993272276],
            [23.180853174149835, -4.786416004042684],
            [23.182309177935405, -4.786078235968515],
            [23.187738251457855, -4.784818770110326],
            [23.188694040055541, -4.768233829871975],
            [23.179186439971684, -4.747305219286271],
            [23.16687984037948, -4.721591240153079],
            [23.153457599679758, -4.692075326117563],
            [23.142832199836729, -4.66845302635557],
            [23.132759759763466, -4.648673541693357],
            [23.129248819341331, -4.63875938110024],
            [23.126058720307732, -4.629751087925581],
            [23.116006440226094, -4.601643816938792],
            [23.108186160113437, -4.580583689765683],
            [23.10092244021822, -4.56170143945194],
            [23.097049193072301, -4.544897890526619],
            [23.088579461551955, -4.535676973311587],
            [23.085369344460567, -4.534519954548546],
            [23.07734132265028, -4.534963820133076],
            [23.074375081988872, -4.526213844058692],
            [23.066002621844099, -4.522762374740284],
            [23.060893097034523, -4.52065601147984],
            [23.058738344993408, -4.519767731252363],
            [23.044924786477811, -4.517976277953595],
            [23.026663066221001, -4.515251633926811],
            [23.010979667136439, -4.517994065881036],
            [22.998771345931257, -4.522185130322375],
            [22.990443106254702, -4.523813975040512],
            [22.983492560627081, -4.524292832332991],
            [22.981109746098298, -4.524456996190168],
            [22.957043746686097, -4.526326227370488],
            [22.94180890786393, -4.527059436970744],
            [22.919164548084371, -4.526404199981984],
            [22.90693210801215, -4.523479080358434],
            [22.894925387621338, -4.520266842075777],
            [22.88406238787725, -4.51843029593387],
            [22.877847534619566, -4.510141229475644],
            [22.875313600103798, -4.508098931781353],
            [22.872122231750698, -4.505526832733927],
            [22.8693794290499, -4.50045894161108],
            [22.847845307909751, -4.487814857860617],
            [22.83318322862457, -4.479205905512429],
            [22.830611673562991, -4.476398402343661],
            [22.827692147991307, -4.473210986845888],
            [22.825178183922578, -4.468143714119726],
            [22.822433100399287, -4.462751077686424],
            [22.820839188149641, -4.459619864302615],
            [22.818569387971795, -4.447419960215223],
            [22.817177893105121, -4.444814427828515],
            [22.815370427956225, -4.441429989108416],
            [22.813267894084291, -4.439199836676452],
            [22.811022075331291, -4.436817891873677],
            [22.802772228036279, -4.434036973220468],
            [22.787677429380391, -4.413061948886273],
            [22.783556148401399, -4.410291985132169],
            [22.772781348845161, -4.40819496222611],
            [22.759585520427944, -4.390638643032776],
            [22.755628429923302, -4.385373871466608],
            [22.755520429069932, -4.383133016698425],
            [22.755190308982815, -4.376398915824857],
            [22.750614349316002, -4.371325926138204],
            [22.749636383110577, -4.367566456322299],
            [22.748338428916131, -4.36257687056633],
            [22.746280309548453, -4.360040874191092],
            [22.725897403699442, -4.347795907772346],
            [22.721982048024582, -4.342204807025075],
            [22.720409270438623, -4.339958879286551],
            [22.714912428909436, -4.337414001107978],
            [22.713037690725567, -4.334452417334631],
            [22.708055510192331, -4.326581847467245],
            [22.703241230175589, -4.32610992044603],
            [22.683807350406777, -4.299829939345513],
            [22.681930270314979, -4.296300843293986],
            [22.67878320597336, -4.290384011526106],
            [22.673759390323347, -4.280706960559364],
            [22.662779389505069, -4.26940400716701],
            [22.653260425732867, -4.265904114463737],
            [22.647657229962256, -4.263843947333283],
            [22.642134756803088, -4.255921500275075],
            [22.637373296826713, -4.249090876121144],
            [22.627067389102706, -4.243541908368336],
            [22.617813714901928, -4.243178199226026],
            [22.608268191540041, -4.242803019178419],
            [22.595222149111613, -4.232414002496018],
            [22.586740191520242, -4.23216200637269],
            [22.582701092915009, -4.228944649399282],
            [22.582391388839326, -4.228697953351436],
            [22.580409407081877, -4.228063832392028],
            [22.578375231409805, -4.227413012669769],
            [22.557651320587347, -4.220777926015669],
            [22.542528233084862, -4.215935995019917],
            [22.524914127180981, -4.198861078222212],
            [22.513475334289208, -4.188245148918189],
            [22.503620503008694, -4.186837916408367],
            [22.495831000974324, -4.182365312146437],
            [22.49194318315449, -4.180132981438129],
            [22.482830566012872, -4.173195726296564],
            [22.47889930297098, -4.170202913281194],
            [22.47181342255254, -4.161438953541751],
            [22.467641750577666, -4.1589997684138],
            [22.467464270426987, -4.158895994740756],
            [22.467350178097696, -4.158911644584356],
            [22.447742383591589, -4.16160198880789],
            [22.443830983198918, -4.159843993526225],
            [22.441559383695552, -4.15882301113956],
            [22.426225184016463, -4.147734865754891],
            [22.417406263870447, -4.147188947787239],
            [22.410639344666713, -4.146769937576931],
            [22.403309384799083, -4.144217940004392],
            [22.398508425001367, -4.139141961457823],
            [22.387777184753251, -4.121392856026528],
            [22.384877679934277, -4.119478963874966],
            [22.381826384985118, -4.117464874250753],
            [22.372686348566095, -4.10570292590219],
            [22.364448465034062, -4.099926863871474],
            [22.339716292075103, -4.090649777165975],
            [22.329883425501617, -4.080496016712647],
            [22.326338146079404, -4.069723887011333],
            [22.322605305612392, -4.058384957253462],
            [22.316208465356258, -4.050312974250655],
            [22.312349266064754, -4.03603489445099],
            [22.30481950560657, -4.02220602065984],
            [22.293010115439298, -4.010064673697552],
            [22.292474540765223, -4.009514040249631],
            [22.282266577254951, -4.002853176455992],
            [22.281492229480044, -4.002347903726953],
            [22.272607786217211, -3.997973455376469],
            [22.271479695358153, -3.997925159344855],
            [22.271427401730516, -3.99792292023483],
            [22.262265353892051, -3.997308413309834],
            [22.252505033464264, -3.996719602495625],
            [22.247127059708436, -3.996490563361264],
            [22.238870034874317, -3.999230003706442],
            [22.234554689047865, -4.002562415939249],
            [22.225289502936683, -4.009721066518778],
            [22.222559874029521, -4.011830073410817],
            [22.209710033540617, -4.015929912869956],
            [22.201670153968578, -4.023040038335698],
            [22.197360021963981, -4.024045693354362],
            [22.193870033847517, -4.024859989013089],
            [22.193041653306597, -4.025355138595974],
            [22.188680917405442, -4.027961683673697],
            [22.186980720982945, -4.02897946223047],
            [22.184248736693096, -4.029547555210787],
            [22.178270153829903, -4.030790126736845],
            [22.167240114155337, -4.039270047567604],
            [22.16650086805015, -4.039424694268577],
            [22.162889874169966, -4.040180094770049],
            [22.156469994821741, -4.039240024105717],
            [22.146940668982754, -4.035082545881752],
            [22.139989914945975, -4.032050039234234],
            [22.135409994607091, -4.028580060713557],
            [22.125302211217289, -4.026940909733945],
            [22.120980114551454, -4.026240006621936],
            [22.117539954187194, -4.024390035052127],
            [22.111599954863728, -4.017459885873212],
            [22.107410918454391, -4.008982790430126],
            [22.106119501300256, -4.006369975450268],
            [22.105712755817727, -4.005547040337072],
            [22.099070154466141, -3.99210995867629],
            [22.093519077151665, -3.98837163342608],
            [22.092209994627474, -3.987490041096664],
            [22.091145877291378, -3.987075839096715],
            [22.089828803354408, -3.98656317511366],
            [22.081449954391349, -3.983310049775455],
            [22.057850154560445, -3.97932007878864],
            [22.049239389337128, -3.974013987883055],
            [22.048469994872683, -3.973539872452796],
            [22.043697089461322, -3.972821061943368],
            [22.029680155060319, -3.970710075209448],
            [22.020749994736065, -3.967460084662411],
            [22.005707122296865, -3.968276025076177],
            [22.004709683311027, -3.968330010165327],
            [21.994639915725759, -3.961159999598527],
            [21.988910155416423, -3.961829924969919],
            [21.97952132518958, -3.967857103946819],
            [21.972545644700304, -3.972343218060824],
            [21.971475073867197, -3.973014270071805],
            [21.968242700116321, -3.975062748854295],
            [21.968222120611479, -3.975075790548925],
            [21.968259546222857, -3.969455210390489],
            [21.968260200196376, -3.969356933284593],
            [21.971521084677729, -3.962098154611721],
            [21.976104239849995, -3.951895872570313],
            [21.980328365352619, -3.947345568626099],
            [21.987602280227968, -3.939509917686602],
            [21.995455320102405, -3.919517984646292],
            [22.009004313088745, -3.909668936590948],
            [22.012235280077864, -3.902546927953242],
            [22.020057360414334, -3.892447991512738],
            [22.029177959985592, -3.88847753914545],
            [22.03754939964416, -3.888850471902633],
            [22.047352920053967, -3.887197805365882],
            [22.058107559618573, -3.884027502597009],
            [22.068305279639684, -3.877859663877581],
            [22.078929959932172, -3.86867929722349],
            [22.101163200332032, -3.850303336797705],
            [22.109382719604739, -3.843664472276442],
            [22.119537599868227, -3.835493089790996],
            [22.131145799751202, -3.826297155005063],
            [22.140349199737123, -3.819643175130378],
            [22.14856908013256, -3.813004249965988],
            [22.152919320117931, -3.809430487211198],
            [22.156242839632469, -3.803868314613136],
            [22.156080479924636, -3.796355096854538],
            [22.151567520007031, -3.792415662059136],
            [22.144574159774685, -3.787512113460261],
            [22.138607520013132, -3.784596981996982],
            [22.132083959809744, -3.778684145204834],
            [22.132916280361531, -3.771656629315621],
            [22.142208186860813, -3.76158100315726],
            [22.141122624043945, -3.757287201270086],
            [22.137523199566278, -3.743050880506535],
            [22.138583285263405, -3.732848505606416],
            [22.138767340183669, -3.731076865327917],
            [22.133096280286569, -3.710118954295656],
            [22.134671914515135, -3.686748958311586],
            [22.134771359813715, -3.685273958943621],
            [22.140127439829453, -3.654457922795046],
            [22.139139547240166, -3.638025091380076],
            [22.139080200040922, -3.637037881721451],
            [22.139007242466789, -3.635823928754981],
            [22.13772048038248, -3.614412956290514],
            [22.137174752050747, -3.609816054516605],
            [22.136600159950614, -3.604975991418748],
            [22.128656400113968, -3.578028879655061],
            [22.124433403793628, -3.572415727814434],
            [22.122528120195156, -3.570345990311205],
            [22.118169959763915, -3.571480039816811],
            [22.116861801606138, -3.572635519866135],
            [22.114400040435235, -3.574809958471592],
            [22.107599741632185, -3.572670056510535],
            [22.099681944005553, -3.576228247170219],
            [22.086259919799801, -3.582259959029874],
            [22.061970000031643, -3.584019875075342],
            [22.061867354035702, -3.583888198092463],
            [22.059460080178347, -3.580800075354441],
            [22.041630000415527, -3.569240000967351],
            [22.030459586401431, -3.574994870404966],
            [22.028780159926622, -3.575860089039588],
            [22.01459004022033, -3.572360009208063],
            [22.004259840254413, -3.577850081538345],
            [21.996470160353621, -3.576899965032155],
            [21.993478774050757, -3.578207810416086],
            [21.992490000214151, -3.578640105104099],
            [21.990855579335065, -3.579350270255999],
            [21.989130119591866, -3.580099992269147],
            [21.973290119898763, -3.591780084081674],
            [21.971137907394979, -3.60116728419966],
            [21.970969919741901, -3.601899985650519],
            [21.963320416551316, -3.600759434429856],
            [21.963189959612468, -3.600739983352091],
            [21.9585600004173, -3.601549952373689],
            [21.957989907080126, -3.597376665359837],
            [21.957249960289001, -3.591959958911389],
            [21.956517143426307, -3.591505175861764],
            [21.950162621006577, -3.587560390175679],
            [21.944670120136866, -3.584733265416162],
            [21.943410119763154, -3.582201859124173],
            [21.942150479613879, -3.579670264318367],
            [21.940890480138499, -3.577138843840965],
            [21.939630479764784, -3.574607055243937],
            [21.939173280404308, -3.572613098665789],
            [21.9387160801455, -3.570618958081866],
            [21.938258519662259, -3.568624812206708],
            [21.938793840113117, -3.566133653593424],
            [21.939328800339542, -3.563642488139886],
            [21.939863759667666, -3.561151314948287],
            [21.940399080118492, -3.558660135828528],
            [21.940934040344917, -3.556168949882778],
            [21.941469720121884, -3.553677756213177],
            [21.941529839872295, -3.550745122573809],
            [21.941589959622675, -3.547812480398569],
            [21.941650080271387, -3.54487982789],
            [21.941710200021767, -3.541946986337301],
            [21.941220240001176, -3.539120626684042],
            [21.940730640205025, -3.536294259195371],
            [21.940240680184466, -3.533467882975671],
            [21.939750720163875, -3.530641318408407],
            [21.939261120367725, -3.527814924746774],
            [21.938771160347134, -3.524988522374899],
            [21.938280840102138, -3.522161931674659],
            [21.936872880014601, -3.519446682990361],
            [21.93029928005663, -3.506398125639408],
            [21.929358239999292, -3.504210995426027],
            [21.929511959710709, -3.501604350465262],
            [21.929665680320454, -3.498997876878088],
            [21.929819760256308, -3.496391217216659],
            [21.929973479967725, -3.493784549310126],
            [21.930127199679141, -3.491177874066612],
            [21.930281279614992, -3.488571011860031],
            [21.930989399993884, -3.485678826952508],
            [21.931697879698916, -3.482786453401006],
            [21.932406000077808, -3.479894250477829],
            [21.933114120456732, -3.47700203946089],
            [21.933822600161729, -3.474109638917955],
            [21.934530719642325, -3.471217409027274],
            [21.935238840021217, -3.468324990527003],
            [21.935947319726246, -3.465432742695081],
            [21.936655440105138, -3.462540485903866],
            [21.937363559585734, -3.459648040523761],
            [21.938072040189059, -3.456755765835884],
            [21.938780159669658, -3.453863302572894],
            [21.939488999599121, -3.450970830379313],
            [21.941215194164247, -3.441650058464167],
            [21.969898199963531, -3.424720850694478],
            [21.97291764783926, -3.421896183681683],
            [21.977249399597767, -3.417843851143199],
            [21.983770440026763, -3.408880917248692],
            [21.989439360136846, -3.401087869461569],
            [21.991456430987586, -3.394479299163069],
            [21.995683200232101, -3.380630905169111],
            [21.996156960034835, -3.362284322024501],
            [21.996356400400956, -3.348746539313768],
            [21.996064079624375, -3.335216123517297],
            [21.996333000186134, -3.302125626331154],
            [21.998170076501719, -3.296081735432494],
            [22.00636835421119, -3.288436581980947],
            [22.01607431488619, -3.282272230484736],
            [22.027736874521953, -3.275576670917171],
            [22.03544303445754, -3.270404949205942],
            [22.055784834297469, -3.253088967574743],
            [22.073623914281104, -3.236271846468576],
            [22.086610194488628, -3.222536727405202],
            [22.095672834757757, -3.209362856619658],
            [22.102482954841808, -3.191118893740075],
            [22.10630868649908, -3.179342312818073],
            [22.108182474265416, -3.173574263652885],
            [22.111970034709628, -3.143934353855948],
            [22.11395255455794, -3.121842523280825],
            [22.114654554714807, -3.108795129595725],
            [22.112022234912466, -3.10081292442116],
            [22.106941914332758, -3.093369301042884],
            [22.101304674209516, -3.082925716087294],
            [22.103109354581012, -3.075376682723922],
            [22.108269954902728, -3.0637648951692],
            [22.108948770440438, -3.063046823499037],
            [22.127990034327762, -3.042904210557983],
            [22.138122594151408, -3.033723213117739],
            [22.149228233345337, -3.024025954841639],
            [22.159896473844245, -3.016842403197896],
            [22.163951919092725, -3.012070466083606],
            [22.164214313393938, -3.011761712150678],
            [22.169888633277171, -3.001144360593172],
            [22.176178194027166, -2.973467230109849],
            [22.181230434169404, -2.956841246283716],
            [22.188477593622334, -2.950712542351974],
            [22.198205513614479, -2.945548925383389],
            [22.209900472787588, -2.940355045352038],
            [22.214764072110043, -2.937773215578511],
            [22.218772314483605, -2.93075090965959],
            [22.221348831838785, -2.928797782089819],
            [22.215421625423286, -2.924866985444578],
            [22.210929247705479, -2.926934342565303],
            [22.206482272638738, -2.928981015886183],
            [22.189593735989831, -2.930499155283493],
            [22.181753153951743, -2.931203957205152],
            [22.173163958176733, -2.926255399419181],
            [22.166897290991766, -2.922644858697647],
            [22.157259239359014, -2.91100927481975],
            [22.151611434149675, -2.904190879255768],
            [22.14998499120864, -2.902762413575861],
            [22.142935434168773, -2.89657093927423],
            [22.141239473302825, -2.89282602052005],
            [22.137952156792544, -2.885570895394831],
            [22.134063234044945, -2.876987961966225],
            [22.12620221802911, -2.865856545801046],
            [22.123804314498479, -2.862461025373217],
            [22.109247354271183, -2.829974864776407],
            [22.102640275000887, -2.818910962131422],
            [22.085287194365737, -2.804360963445308],
            [22.084943044390489, -2.803663871241351],
            [22.082329434698927, -2.798369861247713],
            [22.079941194345803, -2.785254889647877],
            [22.07872439485244, -2.778572955061815],
            [22.075304394479737, -2.773500902359841],
            [22.06785710744947, -2.766981524418611],
            [22.063434474930308, -2.763109921146824],
            [22.05590831491979, -2.753882877598966],
            [22.050195474378853, -2.750872888531722],
            [22.032863274184169, -2.729650988775138],
            [22.026430439332909, -2.716352453223774],
            [22.021717315007056, -2.706608964848584],
            [22.013542434817449, -2.685186979939236],
            [22.013899194444356, -2.681904965638088],
            [22.014717450972022, -2.674378958430429],
            [21.994419234694735, -2.651306017162858],
            [21.991042815189754, -2.649733084958825],
            [21.977508359639675, -2.643427926822313],
            [21.97537103311846, -2.642343872186186],
            [21.974310355431548, -2.64180589126843],
            [21.963596395176268, -2.628196964397262],
            [21.948541195156398, -2.612502977856179],
            [21.936660475162302, -2.606021012037961],
            [21.935328084051459, -2.604869020585537],
            [21.925707475904844, -2.596550965809856],
            [21.921646542848297, -2.590030523701924],
            [21.919103275735051, -2.585946905618473],
            [21.90354947569821, -2.584052979352132],
            [21.899898716095347, -2.582464605885377],
            [21.898750315226014, -2.581964958998033],
            [21.893276155259443, -2.576884879108303],
            [21.876504101356804, -2.572177204520938],
            [21.87087047515595, -2.570595922552828],
            [21.851230491318251, -2.558564120447099],
            [21.845094475108205, -2.545429880161142],
            [21.830955557576466, -2.53042790537128],
            [21.844079275530913, -2.53238726020406],
            [21.85008911527445, -2.527899727179449],
            [21.86467919548793, -2.514837481880892],
            [21.876503035954883, -2.506271371932522],
            [21.885272995222959, -2.49687836707487],
            [21.892663075739296, -2.489938094491577],
            [21.900278155488206, -2.484431261688177],
            [21.90886811572955, -2.476470684672533],
            [21.913835395907164, -2.470138200387741],
            [21.919005355775806, -2.463806225813566],
            [21.926568955770751, -2.455024060240271],
            [21.935548075176314, -2.446041061806556],
            [21.942523075640885, -2.438485585802337],
            [21.951296275132194, -2.429297195118616],
            [21.961096195094331, -2.420930585582637],
            [21.974093634174331, -2.409706357032388],
            [21.980097354594136, -2.404809457329653],
            [21.985904514646652, -2.400321488141991],
            [21.992091114990323, -2.394196807291066],
            [21.996057594686331, -2.388680393316018],
            [22.000805994955069, -2.38132375909971],
            [22.005374394400441, -2.375399598492613],
            [22.009469112196534, -2.366725286951215],
            [22.011454434788522, -2.362519529652839],
            [22.016601714891173, -2.354754513621707],
            [22.019992555051431, -2.351283652144815],
            [22.02313535419206, -2.344946256529199],
            [22.031059314261515, -2.333299287770264],
            [22.037007594255289, -2.324922183082223],
            [22.042537554872361, -2.31572546293467],
            [22.04751455482134, -2.310007039108086],
            [22.051510554954195, -2.306332928664471],
            [22.05591479446792, -2.302864648152451],
            [22.061152794532852, -2.300831470750858],
            [22.068655914552945, -2.301056039211315],
            [22.074334914658824, -2.301275744297389],
            [22.078598034231323, -2.301696426633369],
            [22.083466314674716, -2.301914151766217],
            [22.088549874579357, -2.302951090235134],
            [22.093276674857087, -2.307057594940348],
            [22.094174874258549, -2.31258676154698],
            [22.094452074592287, -2.31729562198585],
            [22.094529834559903, -2.322208681266059],
            [22.094394834840703, -2.32650709864227],
            [22.093929354809916, -2.335512680528358],
            [22.093293234401052, -2.346564642972139],
            [22.092827395044157, -2.355570274973196],
            [22.093748274211571, -2.362532495272761],
            [22.09685003471677, -2.366430112823357],
            [22.100956194354588, -2.369716176192553],
            [22.105499754484054, -2.375050429071622],
            [22.111465314470628, -2.380593010038208],
            [22.118669994390416, -2.387571849567317],
            [22.126270313920887, -2.393937680711103],
            [22.130395553775386, -2.39845196220958],
            [22.130704793422037, -2.405207959895965],
            [22.13105327327693, -2.414420464902491],
            [22.131121313473184, -2.418719313124298],
            [22.131205193662858, -2.424041667911459],
            [22.131154791887216, -2.433662441100013],
            [22.136502593927595, -2.438589485623991],
            [22.141847153948149, -2.443311775068125],
            [22.148620553598345, -2.448651858166104],
            [22.155113513589871, -2.449078437554181],
            [22.16615543348405, -2.442352552562155],
            [22.17058559388532, -2.440521979983564],
            [22.177209954046749, -2.436445408082254],
            [22.183033313418754, -2.432980878653832],
            [22.191684833409887, -2.428909866645288],
            [22.200787072315034, -2.427705736411775],
            [22.206002393512275, -2.424239565093573],
            [22.211816033112921, -2.420160961875508],
            [22.216210913079717, -2.416078565749233],
            [22.22118755280426, -2.410360199322933],
            [22.223362314818321, -2.406886060692151],
            [22.224168353359829, -2.402374866889835],
            [22.223474274547101, -2.400163921693042],
            [22.220516152859222, -2.394864883800322],
            [22.212986393299367, -2.387480913888281],
            [22.212572393920908, -2.371607892170471],
            [22.209270236343812, -2.353279168914788],
            [22.208965204405935, -2.351585902892875],
            [22.210140234933561, -2.340778993070852],
            [22.20263135222088, -2.325804955102232],
            [22.197052512472574, -2.287202996735129],
            [22.196392194144863, -2.28263395200139],
            [22.196322607049709, -2.282152259079329],
            [22.195448274987026, -2.276099944561847],
            [22.191351472201212, -2.268267998618299],
            [22.192040038053019, -2.260003313675601],
            [22.192060309435721, -2.25976000410979],
            [22.187977191584917, -2.24755686090948],
            [22.187355198082173, -2.241130083518837],
            [22.186641234162362, -2.233752990599826],
            [22.192863440130623, -2.216981986556612],
            [22.188247803674344, -2.206625599640524],
            [22.183317372389695, -2.195562803238206],
            [22.183592393410542, -2.193371853153998],
            [22.184969472113561, -2.182402922791147],
            [22.185655193899159, -2.176940865340692],
            [22.184289150101115, -2.172534162376043],
            [22.181801393482512, -2.164508903982258],
            [22.1812232341724, -2.125408976019632],
            [22.179312333408447, -2.117958317593117],
            [22.177150193622438, -2.109528024095678],
            [22.162370393712528, -2.078892959909652],
            [22.160789293235453, -2.071759084326422],
            [22.159887485301521, -2.066926741176788],
            [22.160055642736186, -2.064907321912438],
            [22.160423153400391, -2.060493872752692],
            [22.16061113844999, -2.05824137890676],
            [22.162016153860009, -2.041405978894043],
            [22.150922168510295, -2.015327835032009],
            [22.146341393873541, -2.004559886691219],
            [22.146141849302854, -2.003721623842197],
            [22.144533473278813, -1.996965017521408],
            [22.145800550580326, -1.985232171598245],
            [22.147115394000433, -1.973056931427285],
            [22.151025353495395, -1.964560922161979],
            [22.151059019657282, -1.961689004531404],
            [22.15132991381773, -1.93857997819688],
            [22.15131983382193, -1.935240014692549],
            [22.141349184548471, -1.910026952526304],
            [22.139254073455717, -1.906432152646228],
            [22.138946634032884, -1.905905623909145],
            [22.139561549709498, -1.900030175013978],
            [22.139722074159195, -1.898496381284123],
            [22.138318793396003, -1.893068223690755],
            [22.137237353846245, -1.888766611250948],
            [22.13617535383927, -1.885693330411353],
            [22.1346950335573, -1.8818000667422],
            [22.133609993559908, -1.877293792728987],
            [22.134764873977375, -1.873407535935737],
            [22.15198367354553, -1.859942833606167],
            [22.159125713940583, -1.850136287728017],
            [22.16880359327978, -1.846886581584234],
            [22.177560593451595, -1.836674828064361],
            [22.181543631793197, -1.83218194805054],
            [22.185448914658803, -1.822776061838289],
            [22.189830472609913, -1.817874764509374],
            [22.195396074784192, -1.810929736617124],
            [22.214784226711753, -1.815927788506619],
            [22.224351946546019, -1.820097716610002],
            [22.232841106829323, -1.822066125089679],
            [22.250478585998586, -1.828645964479759],
            [22.270457505989615, -1.83654350604931],
            [22.296803745799895, -1.845972736088506],
            [22.334615984878642, -1.858687092372975],
            [22.352471265080133, -1.865927358210264],
            [22.375205264148626, -1.874040715245115],
            [22.39878634398735, -1.882152411730127],
            [22.419616302725689, -1.890489419401168],
            [22.423856116406458, -1.892028141889939],
            [22.438951903209151, -1.897506725909376],
            [22.445113663338581, -1.899699493039971],
            [22.454251903127076, -1.90320921198682],
            [22.465304263241489, -1.907596890771379],
            [22.472960022299727, -1.911109115177851],
            [22.480400141672352, -1.914180910344121],
            [22.488469541681273, -1.916590714452347],
            [22.492707461713394, -1.916803810425103],
            [22.497969222217552, -1.913048959697261],
            [22.501932461690323, -1.906211669909877],
            [22.506100181976269, -1.898492597699314],
            [22.508588862062989, -1.892539348900193],
            [22.512319181857318, -1.883278617966045],
            [22.519587221750715, -1.866961164741516],
            [22.522705540901544, -1.860345620811121],
            [22.527294461461249, -1.852405493751655],
            [22.532503301313728, -1.842701766222562],
            [22.53791050085902, -1.831455080478469],
            [22.542913420797216, -1.822412717003265],
            [22.546886741164119, -1.81667699983118],
            [22.55188354088029, -1.806973616954002],
            [22.559602660810469, -1.793739893158306],
            [22.563974141460708, -1.785139235566733],
            [22.568973099828504, -1.775656182092623],
            [22.573762540529337, -1.766393758534179],
            [22.577530660532496, -1.761429616667334],
            [22.584318558093084, -1.758180573407646],
            [22.58752921507196, -1.75474000039315],
            [22.588775920379462, -1.752381164600441],
            [22.589590485729619, -1.7508401626358],
            [22.59278998742931, -1.751999941965055],
            [22.594640922054786, -1.755976473796236],
            [22.596429951079088, -1.759819998967509],
            [22.602369949504219, -1.763749914247677],
            [22.606485572893593, -1.768481558296176],
            [22.607380070337747, -1.769509941736297],
            [22.607619182103452, -1.77032563844099],
            [22.608159830462263, -1.77216998790618],
            [22.608629220859449, -1.773792057248253],
            [22.60952296910866, -1.776869493585385],
            [22.616589038081813, -1.775686628242543],
            [22.618540069284467, -1.775360024062514],
            [22.618664340424235, -1.775415884196075],
            [22.622500071228934, -1.777140043071344],
            [22.622668057983685, -1.777917029254588],
            [22.622898994181977, -1.778985172066378],
            [22.620534931984768, -1.782798294185773],
            [22.618770109862417, -1.785640039605669],
            [22.621749829744676, -1.802339970139903],
            [22.623344997839094, -1.802709280382411],
            [22.62377986867488, -1.802809960339559],
            [22.625590323417018, -1.801731324472761],
            [22.627640151334621, -1.800510073363803],
            [22.629408203798697, -1.80110229618195],
            [22.629669830040356, -1.801189930000063],
            [22.638149990102836, -1.815559938093279],
            [22.641375853762845, -1.815913876439829],
            [22.644440452761355, -1.816249392145781],
            [22.644705656992787, -1.815922239407955],
            [22.648849909690252, -1.810809939381502],
            [22.650117111857597, -1.810595374207195],
            [22.655109949105036, -1.809749978637225],
            [22.65638781786808, -1.809134161130183],
            [22.663115835528444, -1.805891862373486],
            [22.674660110397497, -1.809390052456857],
            [22.68951010915529, -1.808399989563275],
            [22.690191834336197, -1.808339662406998],
            [22.690299949275602, -1.808330095391172],
            [22.693582388832173, -1.809392340259457],
            [22.700159988089791, -1.815450049823681],
            [22.711457844296646, -1.820638937231762],
            [22.715979829587923, -1.821140015198489],
            [22.72268095797687, -1.828690348815858],
            [22.738759908637228, -1.833630097098483],
            [22.747759909381582, -1.838879922671771],
            [22.748515292822532, -1.839548869070976],
            [22.751780028381507, -1.842440023361929],
            [22.759289988174174, -1.855490003041682],
            [22.762711594734583, -1.855876380271636],
            [22.770275224373933, -1.856733544989845],
            [22.775542556229489, -1.859599753456551],
            [22.77648061747335, -1.860109989353934],
            [22.777410295639001, -1.860097128856051],
            [22.780100146247054, -1.860059919461645],
            [22.786082862258898, -1.857490999606592],
            [22.788740148937936, -1.856349985370167],
            [22.792827905688849, -1.857053577460337],
            [22.79546700507662, -1.85750782276829],
            [22.795480068377511, -1.857510071641371],
            [22.807779828197116, -1.861089947624288],
            [22.811720028577799, -1.864539941638869],
            [22.815348347366537, -1.864706088209994],
            [22.817180147876471, -1.864789969561998],
            [22.824930334244137, -1.862750081784333],
            [22.825674934308392, -1.863008762856559],
            [22.828237234925908, -1.863898927601577],
            [22.83053426483664, -1.866337169009478],
            [22.830648229605174, -1.866458240559345],
            [22.829322925303565, -1.86867167748504],
            [22.829119907846003, -1.869010042098676],
            [22.830015430267881, -1.873155993449784],
            [22.830389601041595, -1.87488826728192],
            [22.838448883325476, -1.875550266214803],
            [22.842839867298864, -1.875909989031318],
            [22.86436359493117, -1.883466827212326],
            [22.868439917026862, -1.88489780975179],
            [22.869547908081429, -1.883911195284802],
            [22.86965494144923, -1.883815888084013],
            [22.870500461845769, -1.883062992376195],
            [22.874584605572618, -1.88232541973086],
            [22.878048214660783, -1.881699914652896],
            [22.884464383068597, -1.882344872023508],
            [22.887420444919531, -1.882642017267879],
            [22.893829182463286, -1.878746949786743],
            [22.89819875958348, -1.879103622256835],
            [22.902515244473712, -1.879455961469409],
            [22.90960725319902, -1.876942892047988],
            [22.914404261307769, -1.878792879383134],
            [22.924696292755613, -1.877206969861277],
            [22.928999249915989, -1.877793652328265],
            [22.931553139607484, -1.878141861090042],
            [22.934782187795168, -1.881255681590475],
            [22.936066937653283, -1.882494608842921],
            [22.936573421285178, -1.88298301936104],
            [22.9484573635362, -1.885078886355007],
            [22.953520432869212, -1.888960987010625],
            [22.953834212601326, -1.889201575882075],
            [22.960787372326401, -1.894532893530303],
            [22.979787894920662, -1.900886912847781],
            [22.980403274127944, -1.901092703044324],
            [22.984321291511002, -1.902402935356772],
            [22.990030180363007, -1.906324973566976],
            [23.006717240165038, -1.907280936887816],
            [23.012729921279828, -1.91008685225028],
            [23.013179825421872, -1.910296806320262],
            [23.015627260260633, -1.911438938072843],
            [23.029115359148793, -1.911926915494959],
            [23.038255418924042, -1.914475966650304],
            [23.073236237397527, -1.915008976095987],
            [23.077825711319473, -1.916866016551321],
            [23.07860707673337, -1.917182180149019],
            [23.083517128837499, -1.919168937739603],
            [23.102943447486574, -1.924267011628639],
            [23.105652447481521, -1.926480999988816],
            [23.106975491621867, -1.927563124070323],
            [23.107072397383153, -1.927642383657229],
            [23.107738287960562, -1.928187017880431],
            [23.146808366964734, -1.944821990246984],
            [23.17810640628538, -1.961439864927071],
            [23.201402365344457, -1.979190918551387],
            [23.204572576575988, -1.982468506438671],
            [23.205783174998956, -1.983720106342412],
            [23.210762364142294, -1.988867925705671],
            [23.211340109329075, -1.989914099418014],
            [23.211482690829278, -1.990172285514039],
            [23.212003284299357, -1.991114969635484],
            [23.229461483992456, -2.022708895529861],
            [23.237678123266335, -2.03330190597637],
            [23.241321323546089, -2.043657992445927],
            [23.251594282862087, -2.055174860987717],
            [23.255470402820286, -2.062541968175064],
            [23.256599915712449, -2.063681224068436],
            [23.260952123008298, -2.068070967344359],
            [23.266891401882887, -2.071531873716433],
            [23.268744559838716, -2.073571803611843],
            [23.270254796714585, -2.075234250324101],
            [23.274425237997537, -2.079824887270308],
            [23.275722324419423, -2.08002801312622],
            [23.280370149308965, -2.080755871445985],
            [23.287540289904385, -2.08779000559406],
            [23.302995461211239, -2.073938563118819],
            [23.327456380683607, -2.029258410267184],
            [23.423952214642718, -1.997393894753974],
            [23.435254058471088, -2.010712488121692],
            [23.445921945932106, -2.027620586946767],
            [23.459727570527111, -2.030177017936587],
            [23.585521294521119, -1.990409965779734],
            [23.58377395810577, -1.984532720073011],
            [23.583469311545148, -1.983508025812855],
            [23.584394135214982, -1.97476992508099],
            [23.583460332883892, -1.970143271780113],
            [23.583273969293352, -1.969219906647921],
            [23.58211929459009, -1.963498894421206],
            [23.58222934180565, -1.952875490144125],
            [23.582247239839386, -1.95114767882894],
            [23.582374366723425, -1.938893858210895],
            [23.58601324610667, -1.93729821981612],
            [23.58603430800682, -1.937288979802103],
            [23.586621504368697, -1.936194816440545],
            [23.586733963560796, -1.935985265099801],
            [23.587637374987516, -1.934301897420275],
            [23.586727319620962, -1.929471118781773],
            [23.587490831018613, -1.926413551878739],
            [23.587875335113043, -1.924873849160673],
            [23.587435562170757, -1.9236222843599],
            [23.587088224074577, -1.922633766241893],
            [23.585369375033519, -1.917741935653],
            [23.587811418183932, -1.90638817613417],
            [23.588167317224787, -1.904733492832033],
            [23.590690174614778, -1.893003914293623],
            [23.592052100535561, -1.886678603411517],
            [23.592245832108059, -1.885778838619443],
            [23.592491227589161, -1.884638914122372],
            [23.588388335124023, -1.871755864163924],
            [23.586413935147572, -1.868401577608677],
            [23.585950816787687, -1.867614790426364],
            [23.584053214683198, -1.864390967950232],
            [23.576078495308586, -1.839084920287801],
            [23.564895455473181, -1.820672907857782],
            [23.559202236832977, -1.801119741774191],
            [23.562313903959133, -1.793341233486944],
            [23.579142086397347, -1.794134048507302],
            [23.641464213911245, -1.817033320659197],
            [23.66123830094951, -1.824455157249953],
            [23.678099604272244, -1.821650901311424],
            [23.685374492921376, -1.815139124828646],
            [23.691540572150725, -1.798422201053291],
            [23.693857170961625, -1.790728947180844],
            [23.702522012070084, -1.781160541598971],
            [23.714016460085265, -1.77349802405617],
            [23.728472972494117, -1.770666123395183],
            [23.743525291616859, -1.768440587534649],
            [23.754970052017054, -1.766173619862614],
            [23.767606761814903, -1.765119578174211],
            [23.777275290590314, -1.759834407726689],
            [23.786376090394381, -1.750944992742116],
            [23.797291289443006, -1.740877356884876],
            [23.811168578936453, -1.735640398912323],
            [23.83642508864526, -1.735330720418053],
            [23.874317607465983, -1.733966984247011],
            [23.918200526487521, -1.735070405639703],
            [23.947025353812332, -1.738998751780154],
            [23.952229420017371, -1.737620508117246],
            [23.95470695290971, -1.736965019110862],
            [23.95518966711921, -1.727374522611677],
            [23.955772320700703, -1.71577909019124],
            [23.964909289373068, -1.708935364681187],
            [23.967714330949999, -1.698341191503972],
            [23.987884319906996, -1.697475020178023],
            [23.995447362048147, -1.701364548851994],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kabinda",
        AREA: 56426,
        POPULATION: 2443000,
        DISTRICTS: ["Lubao", "Luilu"],
        OBJECTID: 14,
        NOM: "Lomami",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [25.003251415952228, -4.865323929962594],
            [25.005092503245592, -4.867030076494911],
            [25.006779301295609, -4.869043965771699],
            [25.01106436311721, -4.874159882921036],
            [25.011628918340673, -4.875953214257104],
            [25.016351322263411, -4.890953922118999],
            [25.013123178679233, -4.90618233107688],
            [25.012693395002909, -4.908209882948548],
            [25.012874198021816, -4.908972865971067],
            [25.013529154305587, -4.911736143571301],
            [25.014765162474689, -4.916950863177618],
            [25.020504281432615, -4.922700947242694],
            [25.024059740563636, -4.924580711615986],
            [25.024636285601161, -4.924885528827012],
            [25.028768082258907, -4.927069993218756],
            [25.030843122293245, -4.941102925418749],
            [25.039800280585066, -4.952602978556494],
            [25.039888120548511, -4.953302871541141],
            [25.04074140867732, -4.960217185474354],
            [25.041115841759122, -4.963251251204587],
            [25.041647081163632, -4.967555904391192],
            [25.047572412795123, -4.973489200108059],
            [25.049920327775141, -4.975840256012436],
            [25.052671359942245, -4.978594958070786],
            [25.054251152472276, -4.979561762995491],
            [25.055055197652159, -4.98005382311352],
            [25.060936239645184, -4.983652898178447],
            [25.061329132207746, -4.986200221019526],
            [25.061397411355863, -4.986643009438083],
            [25.19861932183305, -4.98943620058227],
            [25.218511958641038, -4.98984111941146],
            [25.324774278165712, -4.992010462623209],
            [25.378743164092043, -4.993117059661626],
            [25.658533181797388, -4.998853945071927],
            [25.801165554500994, -4.998959834952396],
            [25.833465051870032, -4.998983813773775],
            [25.937100255532819, -4.999060750136461],
            [26.047148731434945, -4.999142447659063],
            [26.100138785179944, -4.999181787436805],
            [26.177515942033757, -5.00036343367861],
            [26.225170664151122, -5.00109118266981],
            [26.270477074233145, -4.999999962020482],
            [26.269218162617548, -5.006922931261943],
            [26.265464261148718, -5.016179793934931],
            [26.265110202755881, -5.01705287050628],
            [26.262834231152041, -5.020598941406786],
            [26.257202084476443, -5.029374008046916],
            [26.252988959742773, -5.035938982661298],
            [26.251595317902567, -5.037253406891599],
            [26.224793349273927, -5.062532604338368],
            [26.201912212450086, -5.084112941733784],
            [26.201333022772339, -5.085348856347839],
            [26.199801728487873, -5.088616429789486],
            [26.198028172046048, -5.092400934666755],
            [26.194135902175663, -5.113586946989273],
            [26.191221238286268, -5.129451094688119],
            [26.191223472396381, -5.129480773636458],
            [26.191281243950616, -5.130270484804213],
            [26.191335053036156, -5.131006018943964],
            [26.191693973111281, -5.135891867456772],
            [26.194460212857848, -5.140947844094865],
            [26.191757286372511, -5.165796898933174],
            [26.192736718628467, -5.167750653045728],
            [26.194775948222343, -5.171818705231995],
            [26.197288013252507, -5.176829979156127],
            [26.19765574041071, -5.182412888296345],
            [26.198000093405206, -5.187640867084575],
            [26.196188213036702, -5.198915887814212],
            [26.194042360605138, -5.205213976928778],
            [26.191169093778985, -5.213646929815285],
            [26.185927645081698, -5.223954836871203],
            [26.182279636120217, -5.231128962970905],
            [26.18156825575516, -5.232527944745485],
            [26.179598413830451, -5.234767687549284],
            [26.176299960905617, -5.238517993040104],
            [26.176018666949108, -5.238631357745444],
            [26.172868813338567, -5.239900431355812],
            [26.16942005699531, -5.241289928589694],
            [26.168782722064172, -5.242002244604777],
            [26.167283870436215, -5.243677427187184],
            [26.166723297444417, -5.244303946627977],
            [26.166602965417152, -5.24443844038148],
            [26.166282003654345, -5.244797173996764],
            [26.165298057364076, -5.245896915273638],
            [26.158251784564861, -5.249290132350751],
            [26.157000381966732, -5.249892757847541],
            [26.154748979285909, -5.250976943381279],
            [26.151344508089565, -5.254488966684396],
            [26.147480885493586, -5.258474622676578],
            [26.145815226598831, -5.260193004710175],
            [26.141472181220582, -5.269171988123935],
            [26.139136438412667, -5.288643018001741],
            [26.138988181356499, -5.289878884346654],
            [26.133735061747025, -5.303000933985435],
            [26.133744063764507, -5.307372136309328],
            [26.13375306039207, -5.311740916589395],
            [26.133104978016856, -5.312486051567067],
            [26.128944182843437, -5.317269914164672],
            [26.128473803401114, -5.318836182524174],
            [26.126905513798313, -5.32405823402645],
            [26.126663222894816, -5.324865005297138],
            [26.123404534794332, -5.327486991235599],
            [26.117656476701022, -5.332111929567881],
            [26.116350334362732, -5.333162930636847],
            [26.112833211734809, -5.33885521212656],
            [26.111086024439778, -5.341682972045875],
            [26.109768537277812, -5.345595343824078],
            [26.108688066111959, -5.348803859790757],
            [26.111864704789316, -5.376232058931106],
            [26.117683384837044, -5.4007816023156],
            [26.122797544055178, -5.418658704120946],
            [26.13286710323132, -5.440117226896391],
            [26.13277206327087, -5.455143814468959],
            [26.13466350293254, -5.470962260324816],
            [26.136511383286049, -5.493676987085154],
            [26.136939063107977, -5.504774621530546],
            [26.150536261489091, -5.519426614806482],
            [26.15140550100239, -5.53625134241574],
            [26.151645061027413, -5.540888106692634],
            [26.161270079902042, -5.553955124210139],
            [26.173711917267013, -5.554534324539818],
            [26.175677938656801, -5.558528130327787],
            [26.172129778337464, -5.568532695108871],
            [26.161865820140612, -5.577864991816397],
            [26.15685570020538, -5.582903629783337],
            [26.152558021545612, -5.593380399422392],
            [26.151029101508442, -5.599004880866325],
            [26.147530904586937, -5.601127980868152],
            [26.136834303376165, -5.600103117022042],
            [26.128628132170295, -5.598898351757047],
            [26.124392704963054, -5.599523955968206],
            [26.119111800461887, -5.60800370164162],
            [26.118019985370623, -5.623245411761124],
            [26.117701025952577, -5.634320481686128],
            [26.108133667241077, -5.651551608887976],
            [26.103601267780714, -5.659804345660182],
            [26.120629625406977, -5.682917684521801],
            [26.126546584740019, -5.691941819130325],
            [26.124684665515236, -5.710854911836981],
            [26.123600345966715, -5.724862907195186],
            [26.131014904676228, -5.733187740001955],
            [26.153709368889061, -5.747800898788497],
            [26.154293979001263, -5.747779757975055],
            [26.1603710288977, -5.747559919021202],
            [26.164993697366025, -5.751426802853463],
            [26.166984579631318, -5.753092180213267],
            [26.167503060263854, -5.753525893738848],
            [26.17211739955286, -5.755793903849907],
            [26.175858191008452, -5.757632557643458],
            [26.184290277728497, -5.761777155098949],
            [26.184248818681489, -5.769358193532392],
            [26.184353938637734, -5.778279277196662],
            [26.189350737455577, -5.796933962369684],
            [26.197121337139752, -5.807682177527585],
            [26.202940016289148, -5.814982905936282],
            [26.207263615836464, -5.825121362297418],
            [26.208178375680184, -5.837893720160905],
            [26.205218455565081, -5.84620449666259],
            [26.186820658509017, -5.857955905215222],
            [26.177036219214159, -5.870926321338463],
            [26.173170900598958, -5.89971012895171],
            [26.177771340255575, -5.933360128914182],
            [26.18395797832849, -5.939443086040147],
            [26.192714896753571, -5.936608635004214],
            [26.196971578100442, -5.941069498203334],
            [26.205924416394051, -5.954855494818851],
            [26.215006135981465, -5.979586023454734],
            [26.211996176111818, -5.983638452332895],
            [26.202885656536356, -5.988904645472111],
            [26.186126219471884, -5.993762668593788],
            [26.182366380139005, -5.999030735056417],
            [26.182552500286096, -6.014838926285792],
            [26.186002019299021, -6.015650831445321],
            [26.202182937727279, -6.026600492101996],
            [26.212607456306444, -6.035521144630259],
            [26.222572995962583, -6.037956568130526],
            [26.255031179828222, -6.035536577344121],
            [26.234387453526377, -6.067547805849862],
            [26.219868655528977, -6.067947805616171],
            [26.204981937235598, -6.069563567017858],
            [26.194739218805317, -6.076044306060626],
            [26.187582419090155, -6.084957858270733],
            [26.187348060310629, -6.09752105489679],
            [26.190950219259989, -6.111301234459009],
            [26.198326618434571, -6.1210298791382],
            [26.217751496185898, -6.147782680479033],
            [26.217827816154102, -6.15426622236877],
            [26.212639496517681, -6.168041690352955],
            [26.206666656584066, -6.181918038469266],
            [26.201478778918755, -6.193970429920291],
            [26.190242100677725, -6.213415153550056],
            [26.163707944089758, -6.232043278929233],
            [26.143193347016719, -6.242569765278502],
            [26.133456787926523, -6.259582387365588],
            [26.116496143509774, -6.295480555534438],
            [26.112653999632261, -6.285746419509516],
            [26.105340239982453, -6.289417083792884],
            [26.09328779983527, -6.29427644909926],
            [26.085105000098153, -6.296673244755174],
            [26.07216084009767, -6.296056491825905],
            [26.065196279853332, -6.284185067731883],
            [26.06038199983659, -6.271085537161724],
            [26.055181080429982, -6.266384134581475],
            [26.046110519715011, -6.264145203290746],
            [26.036624519622166, -6.264841533434132],
            [26.02798560029952, -6.262609223934029],
            [26.026669079724762, -6.258387138288661],
            [26.01994464005417, -6.210377118148533],
            [26.016462360381166, -6.204440366355252],
            [26.005684319703402, -6.205537566467228],
            [25.994517119861381, -6.214613750045102],
            [25.985915999849265, -6.219526134902289],
            [25.982994240167432, -6.237972737227846],
            [25.982191440052528, -6.249306885692456],
            [25.981485321120068, -6.252645376490151],
            [25.977141360358544, -6.273182917335051],
            [25.971115320397189, -6.275612593548607],
            [25.95984335992506, -6.264935942781026],
            [25.953755039765035, -6.25559855099347],
            [25.948967400186348, -6.247541551277174],
            [25.948896479991298, -6.234092813810884],
            [25.952205240185727, -6.218592894690617],
            [25.94461032042841, -6.212166945406238],
            [25.940911914182866, -6.207517863751796],
            [25.939312199714806, -6.205506929444728],
            [25.925508360072236, -6.197249022355148],
            [25.912718474942039, -6.187046757661388],
            [25.911699479982651, -6.186233915285993],
            [25.894245240063356, -6.177367049989356],
            [25.882982279812051, -6.168369773321921],
            [25.876498320041343, -6.165749487669204],
            [25.865697959821993, -6.162643256758639],
            [25.857465839880838, -6.155793393519654],
            [25.847076960163921, -6.148910470883769],
            [25.83972972030346, -6.146277007816745],
            [25.829124480452055, -6.144040963429091],
            [25.828082821896359, -6.144936140271431],
            [25.825910193381105, -6.146803156631648],
            [25.811236596795641, -6.149820222759752],
            [25.80971067084333, -6.150133971171956],
            [25.803398025187189, -6.151431913524903],
            [25.802252144092247, -6.154191864166217],
            [25.802946224701568, -6.156719930147354],
            [25.805263298721236, -6.158260883362614],
            [25.80681047342329, -6.159289818115327],
            [25.813989223472394, -6.164063954342985],
            [25.81148115414862, -6.17671285776234],
            [25.810597007991451, -6.177447840288735],
            [25.803449144716748, -6.183389927061947],
            [25.802032963247743, -6.185971892853879],
            [25.801729064085439, -6.186525955394515],
            [25.797264353580065, -6.194664020686828],
            [25.791294105286038, -6.199039961914987],
            [25.788415240159043, -6.200118264550566],
            [25.777742267335192, -6.204115892190429],
            [25.769809952035271, -6.205430308562127],
            [25.768865139053723, -6.205586867625786],
            [25.760971308478883, -6.206894902790348],
            [25.752706069449836, -6.212653004015656],
            [25.747426680406505, -6.213697242817076],
            [25.746048116788355, -6.213969915957564],
            [25.739839310989161, -6.215197985239659],
            [25.735935111491827, -6.217041901903949],
            [25.728134271820256, -6.224867906155922],
            [25.721933272380877, -6.227404944465849],
            [25.713957191160297, -6.227558894408013],
            [25.713519413376268, -6.227567343750678],
            [25.709291152928373, -6.227648955098466],
            [25.706077074266581, -6.229721968379003],
            [25.703098073934864, -6.235702861392826],
            [25.702371910893472, -6.23613168895509],
            [25.701715488559174, -6.236519330937613],
            [25.699196395110217, -6.238006948330987],
            [25.693908525072292, -6.238242880557162],
            [25.691899398921912, -6.238077572942357],
            [25.691150076414182, -6.238015911698959],
            [25.690007932310834, -6.239850363133264],
            [25.68938107982072, -6.240857215110148],
            [25.688858276495051, -6.241696943714778],
            [25.684744196411359, -6.25687585732975],
            [25.682952460763104, -6.259121419077496],
            [25.681072197041892, -6.261477921740566],
            [25.677953156543929, -6.262758981702522],
            [25.677572090302053, -6.262915374211219],
            [25.670965197881358, -6.265626891066158],
            [25.643161319351687, -6.269335855966164],
            [25.636043040294233, -6.275321843222374],
            [25.613064276361964, -6.277184881927599],
            [25.605932310572832, -6.273283989465278],
            [25.603901060713635, -6.275830468994088],
            [25.602177104750211, -6.277991764035045],
            [25.601343363961981, -6.279037007864646],
            [25.600947989354275, -6.279219901361341],
            [25.599902543501351, -6.279703498706827],
            [25.598356045230709, -6.280418873720727],
            [25.587324283485774, -6.279281000376957],
            [25.579282205736238, -6.282736918864877],
            [25.561359247359555, -6.286433937649309],
            [25.561062317327234, -6.286621879200451],
            [25.560805518631906, -6.286784419836675],
            [25.560087367664526, -6.287238973355846],
            [25.553149225974362, -6.291627702686955],
            [25.550685068098304, -6.293186399094302],
            [25.54206828865415, -6.298636882107138],
            [25.536792129952619, -6.306458959910936],
            [25.511465771738866, -6.308970160556322],
            [25.503716042613721, -6.311793728446515],
            [25.495937893487906, -6.309154483283811],
            [25.492864572746278, -6.299023447864561],
            [25.486800727186175, -6.294309258757632],
            [25.474755134896395, -6.300429090695139],
            [25.439908217502563, -6.317967678585657],
            [25.427842424796989, -6.320305426258433],
            [25.415327812215928, -6.319275112136215],
            [25.388485820946403, -6.300799533612123],
            [25.385890580904054, -6.299499579685447],
            [25.382868759679361, -6.299033489673691],
            [25.376589223229676, -6.300559445084748],
            [25.368221519664335, -6.302592814128157],
            [25.295885639913045, -6.327545216263101],
            [25.293344040072945, -6.336329971421131],
            [25.296910920384462, -6.358232089818208],
            [25.300904760069063, -6.379299538501824],
            [25.305732360304834, -6.394917271691682],
            [25.306237079645534, -6.408788371390953],
            [25.306277040302653, -6.416350683377277],
            [25.298547480152241, -6.422954762956937],
            [25.286946839592343, -6.431600503462886],
            [25.282666079802645, -6.437836726753894],
            [25.272367388245286, -6.441611878314567],
            [25.274438558337394, -6.446774872099339],
            [25.275133361192214, -6.448506677297505],
            [25.279733519676174, -6.451721862983494],
            [25.28077562559286, -6.456329920272512],
            [25.281812520382612, -6.460914894462157],
            [25.286982809932955, -6.461773025586474],
            [25.28871119998065, -6.462059892335815],
            [25.292856239602312, -6.469643963418707],
            [25.296768360443821, -6.472168856769897],
            [25.305732504035269, -6.471473081957425],
            [25.308954320784924, -6.473540077008908],
            [25.312602759141122, -6.478092755710686],
            [25.314478016551206, -6.480432789967592],
            [25.314422547379067, -6.482275628692132],
            [25.314366417945159, -6.484137271749608],
            [25.314256347373409, -6.487787991096912],
            [25.325387262464467, -6.501801612998927],
            [25.329220113270374, -6.506626973737077],
            [25.329377807128584, -6.506773102180678],
            [25.330425072968296, -6.507743328473485],
            [25.331817146349998, -6.509032994163703],
            [25.33955441763883, -6.516203534631217],
            [25.34541230375881, -6.52163228057644],
            [25.351774105227289, -6.527527957998444],
            [25.354185298434214, -6.528787688664807],
            [25.355386561564746, -6.529415288761112],
            [25.356605299622515, -6.530052062770756],
            [25.358333321360934, -6.532873545005232],
            [25.359138264856114, -6.534187859736682],
            [25.368343135384148, -6.540846959200497],
            [25.37107852608553, -6.541073017560727],
            [25.373861151102886, -6.54130298028107],
            [25.379915302942777, -6.534101917166422],
            [25.382184553351667, -6.533322851486898],
            [25.38239970255713, -6.533248988004714],
            [25.383737073029653, -6.532789868918543],
            [25.391098341879854, -6.535082918463337],
            [25.393504410198105, -6.540505307416741],
            [25.394917974874666, -6.543690932243831],
            [25.396400195991792, -6.547030950592516],
            [25.399339102715757, -6.546866116914009],
            [25.3994613795956, -6.546859259473859],
            [25.400537314269283, -6.546798839789178],
            [25.401314021918431, -6.546323473266959],
            [25.403799587546047, -6.544802254910039],
            [25.404674333732057, -6.544266899494958],
            [25.405762803497201, -6.544469831518185],
            [25.405922400885526, -6.544499586465561],
            [25.408354221208036, -6.54495298264438],
            [25.412039180572062, -6.550696851507632],
            [25.41113345328856, -6.561729996321239],
            [25.414919794718941, -6.562118966487901],
            [25.417801307181083, -6.562414983381366],
            [25.423324099242187, -6.567236979372006],
            [25.427819032667003, -6.573960678138145],
            [25.429313438532628, -6.576196020536734],
            [25.439890186518156, -6.576647002397957],
            [25.444721418642622, -6.579170991860148],
            [25.445577499633675, -6.582363789048471],
            [25.446407560024198, -6.585459518685296],
            [25.447494308617237, -6.589511931549809],
            [25.454853258017433, -6.590424948356263],
            [25.456794377209214, -6.592103862275414],
            [25.456948256820748, -6.592236982075539],
            [25.457379891026559, -6.592610380994778],
            [25.458305296804713, -6.593410932771762],
            [25.463009378688916, -6.605417559188385],
            [25.465687067006371, -6.612251917422236],
            [25.466852416390143, -6.625120972706645],
            [25.463194096565839, -6.642591931789253],
            [25.463200560842623, -6.64779983752664],
            [25.463209217008718, -6.654772917730512],
            [25.462875915987151, -6.65587312509606],
            [25.462231141208814, -6.658001484068911],
            [25.461607216328243, -6.660061010219102],
            [25.45851979293499, -6.663538124148169],
            [25.457931304795718, -6.664200927861968],
            [25.457431299813653, -6.664666075156108],
            [25.451502377615967, -6.670182010798453],
            [25.440716418288954, -6.689496922615183],
            [25.444622517723115, -6.700300204108236],
            [25.444870007177155, -6.700984781404209],
            [25.444483414499675, -6.701992311959329],
            [25.444259166258675, -6.70257650997852],
            [25.4437231388337, -6.703972932538387],
            [25.439474872904444, -6.706809913335365],
            [25.438434717230226, -6.707504523893237],
            [25.438209445808099, -6.707654958770665],
            [25.438799419760834, -6.7091470118416],
            [25.43930998533741, -6.71043784104069],
            [25.440609051646199, -6.713722163514479],
            [25.441208178533358, -6.715236881526372],
            [25.448347263471089, -6.723963869034479],
            [25.441842137595671, -6.727852998861601],
            [25.438526230404836, -6.729835373556641],
            [25.436702059286617, -6.730925928811042],
            [25.432949059726337, -6.733168841020738],
            [25.421699060367949, -6.749035911802499],
            [25.414636858642101, -6.75542780249721],
            [25.412662347274548, -6.757214887130974],
            [25.409754260849667, -6.759846916636039],
            [25.398317421793681, -6.767424926374543],
            [25.394127382864482, -6.770200969611523],
            [25.389656223353683, -6.774677158354812],
            [25.386922821522312, -6.777413613785311],
            [25.377357143558715, -6.786989855429545],
            [25.367702305108239, -6.79182302622425],
            [25.354337305956694, -6.796146854366997],
            [25.345632146661643, -6.798962993772963],
            [25.341605803235126, -6.801957192827055],
            [25.339361367887626, -6.803626264598241],
            [25.337589260428349, -6.804944009178143],
            [25.330450683038713, -6.80590816137016],
            [25.310224371510028, -6.808639950876117],
            [25.29852147033148, -6.804982107669894],
            [25.301467709104788, -6.791174501988697],
            [25.301828069179329, -6.777747138037761],
            [25.300909708887975, -6.767238448089679],
            [25.292690910064142, -6.762915789466481],
            [25.284029671199978, -6.756487385557145],
            [25.274901511407279, -6.743334838382563],
            [25.266204992108644, -6.730188372135935],
            [25.25754591189607, -6.724179410354719],
            [25.241371040926307, -6.72135490846266],
            [25.222527634573549, -6.709373605469668],
            [25.210375475141632, -6.695333952608896],
            [25.19519895674436, -6.680408586105278],
            [25.181356583867693, -6.673060660318462],
            [25.173168757158251, -6.674615768826943],
            [25.159393358177589, -6.679865161429261],
            [25.142631400440429, -6.691367015343875],
            [25.137456772027242, -6.691708342281144],
            [25.128303234827808, -6.68910585827655],
            [25.122437421973775, -6.687438108384233],
            [25.109376401934611, -6.6837246192902],
            [25.096828216616426, -6.676396415354593],
            [25.079132443971719, -6.674448226284415],
            [25.067044364962285, -6.672585410483288],
            [25.057197433466381, -6.667996808050737],
            [25.054936485287364, -6.66694321556515],
            [25.04928412561954, -6.658459661087533],
            [25.044096159021048, -6.656281568506994],
            [25.034185366291585, -6.65823053850118],
            [25.029042045962672, -6.664450826960572],
            [25.025446508495282, -6.675059999684425],
            [25.021821887172234, -6.685754752069401],
            [25.010241023921665, -6.698174851610153],
            [25.00637747319092, -6.698116212794587],
            [24.980474809789804, -6.697723087989187],
            [24.944249128453492, -6.699272574739233],
            [24.93521243961461, -6.703333961682642],
            [24.92748494918261, -6.710354075105239],
            [24.9310161439195, -6.725521739016244],
            [24.932419424682692, -6.746114241154468],
            [24.926401979801962, -6.75022103571821],
            [24.91259535089047, -6.749591787379057],
            [24.894483348350441, -6.750576288546422],
            [24.875542310397677, -6.757845372750999],
            [24.848071073526143, -6.783455494605242],
            [24.840797633859555, -6.794679095454616],
            [24.846083153006344, -6.81532748032437],
            [24.847486073545134, -6.827207928106575],
            [24.835197115068464, -6.833025914766237],
            [24.816902272130477, -6.841687992467304],
            [24.807155006020409, -6.853381607791523],
            [24.803110318097467, -6.858233858798786],
            [24.790233119416595, -6.86880494021823],
            [24.787673202029513, -6.87355953177015],
            [24.787016100568874, -6.87477994819365],
            [24.784260360331348, -6.886958853436442],
            [24.782551611049023, -6.888799054744509],
            [24.7812731062788, -6.890175943710811],
            [24.779585959682439, -6.890797108369958],
            [24.778814028375628, -6.891081320785775],
            [24.776903000949218, -6.891784913718817],
            [24.748840362701959, -6.889946929029495],
            [24.74079108405709, -6.898218993207159],
            [24.736421405427297, -6.900056952566785],
            [24.734672164583571, -6.902154861821781],
            [24.734123242740989, -6.902814040988722],
            [24.734824079579582, -6.904064150593594],
            [24.73734408481856, -6.908558918044795],
            [24.736262605742958, -6.909911248395832],
            [24.735900118457824, -6.910364519052407],
            [24.735506285359172, -6.910856985163699],
            [24.731202016658465, -6.912456844923111],
            [24.729221226067068, -6.913193086698951],
            [24.72561643505394, -6.914533026961371],
            [24.726825223371595, -6.916398728382233],
            [24.728147166177394, -6.918439008320115],
            [24.727803468054752, -6.91935773139789],
            [24.727640284591814, -6.91979392949288],
            [24.727459205790097, -6.920277960789684],
            [24.720558366642138, -6.921196988149841],
            [24.721710328433236, -6.92648193524473],
            [24.717390224230691, -6.926276206298025],
            [24.716879196920072, -6.926251880009723],
            [24.714809166790083, -6.928779915779166],
            [24.710209087357867, -6.929008907812846],
            [24.707102501102995, -6.931957409633744],
            [24.705610087700666, -6.93337387241814],
            [24.706302393238989, -6.938658892147356],
            [24.704921407762829, -6.941875945331216],
            [24.698711409000925, -6.943253972858131],
            [24.698281135742782, -6.946413893333681],
            [24.69802300574419, -6.948308974098192],
            [24.695034368286112, -6.948538849659035],
            [24.692470444412876, -6.951099354584706],
            [24.690433331249825, -6.953133716772561],
            [24.685189743663852, -6.952657257097044],
            [24.682842285926327, -6.952443885636014],
            [24.674268112677812, -6.954155965670437],
            [24.671466729040695, -6.954715344815376],
            [24.669040230337959, -6.955199852287918],
            [24.66121809520423, -6.950603989521583],
            [24.65638910078313, -6.950832960027144],
            [24.656220045931498, -6.951170550432857],
            [24.655468212632577, -6.952671968373703],
            [24.653735229498825, -6.955558019375397],
            [24.653163365582241, -6.956510379338132],
            [24.65271025355629, -6.957264973257412],
            [24.646037409522354, -6.959828883124702],
            [24.645199855385744, -6.960150695854813],
            [24.643739457940136, -6.96071182260192],
            [24.642591437058172, -6.975416196775259],
            [24.643697869535742, -6.979277814531418],
            [24.643974168859259, -6.98024201678305],
            [24.619491975484326, -6.983268661129505],
            [24.553781541059287, -7.012880246061703],
            [24.547113622488073, -7.009090764478185],
            [24.537480022905836, -6.9961687142815],
            [24.536116807004291, -6.994731489420627],
            [24.529325635982815, -6.98757158574778],
            [24.524130144197173, -6.987624886649404],
            [24.520386143959382, -6.990074787227827],
            [24.516218424571768, -6.995905053591571],
            [24.50463038557869, -7.044248663344955],
            [24.49805930539511, -7.047209427384785],
            [24.483041547156301, -7.054114762368565],
            [24.474631128699212, -7.054201260574718],
            [24.471233548479397, -7.054236202133588],
            [24.451966350213258, -7.053948784735834],
            [24.43151658096102, -7.051751237242507],
            [24.413491670986122, -7.046632088668913],
            [24.397425662354081, -7.046315155688537],
            [24.379643407100335, -7.058070940088909],
            [24.352731764955259, -7.055282894203931],
            [24.34947238245709, -7.056760617018722],
            [24.345140307305059, -7.058724982472437],
            [24.329992877254998, -7.053063722240542],
            [24.325662655327413, -7.051445311304291],
            [24.3223652794826, -7.050212920070329],
            [24.319420119585942, -7.046252020172282],
            [24.316385319502054, -7.042167855311814],
            [24.309713444750287, -7.040786014800036],
            [24.308563240063883, -7.034581959225132],
            [24.30815377358434, -7.034070864099337],
            [24.306722200381266, -7.032283970155424],
            [24.303962273994497, -7.031363090505231],
            [24.302613112235608, -7.032295587983875],
            [24.302287813406583, -7.032520473006161],
            [24.30097225313089, -7.033429924591385],
            [24.299628483060314, -7.03334484675079],
            [24.297291307439529, -7.033196872998762],
            [24.29281641363206, -7.028928876166131],
            [24.292230379690164, -7.028369972061397],
            [24.28992063861817, -7.028870201435614],
            [24.286939134681742, -7.02951590845757],
            [24.283258097362214, -7.027215249106311],
            [24.282447960706378, -7.02670890514316],
            [24.279579253728624, -7.024915950480386],
            [24.276604296714012, -7.02503331620268],
            [24.273826144408435, -7.025142916810609],
            [24.272387248139186, -7.022264415573887],
            [24.271903258321974, -7.021296176404497],
            [24.27152824223359, -7.020545942263548],
            [24.266468442768208, -7.017326903276189],
            [24.265479447047756, -7.01715204226809],
            [24.26507410383536, -7.017080375532432],
            [24.258646372313205, -7.015943915396432],
            [24.25381423558526, -7.016629840827325],
            [24.249902298898355, -7.020532885446462],
            [24.244842176039487, -7.020300004109746],
            [24.244640376697454, -7.020141537069233],
            [24.241621231553982, -7.01777086666719],
            [24.239295924474753, -7.01851286536574],
            [24.238752827308488, -7.018686168688596],
            [24.235870243156207, -7.019605994983352],
            [24.23405758843991, -7.018880385546439],
            [24.233797333027386, -7.018776202563934],
            [24.232420364817177, -7.018224988472843],
            [24.231041149022094, -7.015007931078846],
            [24.225517377797324, -7.01707199731506],
            [24.224232495886906, -7.015865224572866],
            [24.223282084604516, -7.014972563801662],
            [24.217928188393227, -7.00994397631608],
            [24.219770342885106, -7.005809895359095],
            [24.220053419997456, -7.005546196210282],
            [24.221396839725067, -7.00429462348798],
            [24.223221285727764, -7.002594906092486],
            [24.226442205060447, -7.00213788866246],
            [24.226686905245529, -7.001619473034991],
            [24.227134769313569, -7.000670639139868],
            [24.228285405191315, -6.998232919780413],
            [24.228651855843474, -6.994198044053616],
            [24.228744425436876, -6.993178992812491],
            [24.228565124401115, -6.992696933277828],
            [24.225757125570244, -6.985134906519933],
            [24.226310259613175, -6.982487390668394],
            [24.226603928761033, -6.981081768124143],
            [24.227152125663189, -6.978457860550509],
            [24.227490648591488, -6.976834699838564],
            [24.227672980543023, -6.975960449243034],
            [24.228059324387139, -6.974107988767396],
            [24.219093165874501, -6.959167994892009],
            [24.217025354583242, -6.950433875067951],
            [24.216408453629843, -6.949883183470814],
            [24.21058636627226, -6.944685847014117],
            [24.210189006387804, -6.943578626478093],
            [24.209741525002062, -6.942331744966343],
            [24.207369406713347, -6.935721912145631],
            [24.202104249679099, -6.927340016740091],
            [24.201287722408345, -6.926040127511317],
            [24.201160283808878, -6.925837250308181],
            [24.191040167448563, -6.922384011828739],
            [24.189830462849272, -6.918602501397864],
            [24.189307059449007, -6.916966345371983],
            [24.187364207407025, -6.910892948395434],
            [24.179542127968855, -6.909278845515945],
            [24.178507482560597, -6.907782598429466],
            [24.178110702089501, -6.907208794856765],
            [24.17747536770646, -6.906290003860458],
            [24.159763344538291, -6.901911007263092],
            [24.156635476296017, -6.901668638319433],
            [24.150793271167636, -6.901215943643271],
            [24.148911685126365, -6.902153957809137],
            [24.148581765363534, -6.902318426139733],
            [24.147112294035246, -6.903051135193032],
            [24.148031372978842, -6.907877052688807],
            [24.146188199797418, -6.916377855034585],
            [24.147036015389542, -6.919563502001529],
            [24.158144159984776, -6.928794950078124],
            [24.157453319598652, -6.932240913847382],
            [24.152698907804034, -6.937859162367757],
            [24.148708199646514, -6.942574895252139],
            [24.139107796407284, -6.943131335091857],
            [24.125244480208085, -6.943934852845952],
            [24.12179316007305, -6.9466899975366],
            [24.123322763728115, -6.954806637977002],
            [24.124088520015643, -6.958869971079302],
            [24.125351749832824, -6.959904037918791],
            [24.126617301794962, -6.96093985459471],
            [24.135820199622639, -6.958878915853713],
            [24.136976487700156, -6.959008186450218],
            [24.139961280368858, -6.959341878829893],
            [24.141182513946461, -6.968211731120338],
            [24.141796199829447, -6.97266887848998],
            [24.144033433383285, -6.975577180774729],
            [24.146259480216909, -6.978470923048282],
            [24.151914359659088, -6.982326867737042],
            [24.152374439916656, -6.984624927770396],
            [24.149381496833424, -6.988758840689606],
            [24.135807239628047, -6.996100927064957],
            [24.134467635045446, -6.997155388962215],
            [24.131433240101714, -6.99954388574809],
            [24.130512386087119, -7.003449092130055],
            [24.132120480040172, -7.007815968092993],
            [24.136720200146247, -7.011724969880807],
            [24.142168789568242, -7.014392552093986],
            [24.147531350928762, -7.01701800156272],
            [24.147068399655506, -7.022072019371965],
            [24.143788029817344, -7.033310142325018],
            [24.141771359615209, -7.040218858646375],
            [24.141699538409902, -7.041288609783754],
            [24.141077125393949, -7.050556834586039],
            [24.126583208933319, -7.048249034061607],
            [24.124283280159155, -7.050314871150672],
            [24.123265619197952, -7.057129747010443],
            [24.122474279789451, -7.062428969484848],
            [24.121861372745816, -7.066530750684541],
            [24.121744200093413, -7.067314902343256],
            [24.121130746874105, -7.068232938406946],
            [24.119903160410797, -7.07007002354145],
            [24.113264400255364, -7.072033920693818],
            [24.113462390740636, -7.065010991516047],
            [24.108631102920619, -7.062710586030631],
            [24.105798642066247, -7.063069904253366],
            [24.099660000080654, -7.063849917601193],
            [24.097130196916837, -7.061321903767145],
            [24.091839359743563, -7.061777961193735],
            [24.090551707428798, -7.063489253870206],
            [24.089767199708021, -7.064531863938567],
            [24.084934199699063, -7.065447025810689],
            [24.080790289259721, -7.069579578745391],
            [24.074812440320088, -7.067506983379867],
            [24.066528480400496, -7.06796000049467],
            [24.065751428696593, -7.068674959798319],
            [24.063535508571157, -7.070713804000828],
            [24.061233239685684, -7.074847852714927],
            [24.060539159974692, -7.083576941594534],
            [24.055706159965734, -7.089086971488727],
            [24.050403359927817, -7.109758911812651],
            [24.047368050499141, -7.112654212380471],
            [24.045109199886284, -7.114808857767717],
            [24.031530360374646, -7.122148963789233],
            [24.03060731986065, -7.128809962495106],
            [24.026695199917437, -7.131104961803721],
            [24.019362483120215, -7.150546267006621],
            [24.014482227235749, -7.163484875085764],
            [24.011581507894498, -7.165525833439052],
            [24.006656520400462, -7.168990963700169],
            [24.004583279691612, -7.172029945080215],
            [24.003259199793746, -7.173970870370109],
            [24.002742240008995, -7.174730966978951],
            [23.989091040302899, -7.181535124247045],
            [23.988523411044529, -7.18186724074088],
            [23.983870121703109, -7.184589849599933],
            [23.9829501597156, -7.18711994793933],
            [23.986425155848302, -7.195781210453506],
            [23.986465200048716, -7.195881018641812],
            [23.985964439583491, -7.19651395455381],
            [23.983017480361312, -7.200222869514018],
            [23.982479127198054, -7.20090001493883],
            [23.97925547968185, -7.202044954293894],
            [23.978402944341244, -7.20148770991273],
            [23.977655280123557, -7.200999012764091],
            [23.973276240150177, -7.198134910384796],
            [23.970422160440162, -7.202044954293894],
            [23.969591279887783, -7.203184937623466],
            [23.963836320038141, -7.206395863811367],
            [23.963249070675669, -7.207225411441417],
            [23.96107338160024, -7.210298776058642],
            [23.962913280422441, -7.212366920259988],
            [23.963486085773482, -7.215521693910923],
            [23.963831279591062, -7.217422866477666],
            [23.963026319926232, -7.221526903025477],
            [23.961984501470418, -7.226838832480773],
            [23.963361652936939, -7.231433902105953],
            [23.964928059670921, -7.235437697318898],
            [23.965429319599465, -7.236718927905755],
            [23.967668193477007, -7.239220691572039],
            [23.977157399657091, -7.249823969628334],
            [23.985164160141242, -7.261506874645114],
            [23.985664154343578, -7.26223582757103],
            [23.984541359951404, -7.262772917154214],
            [23.979910320082961, -7.264986962640027],
            [23.978454380077782, -7.268251478112784],
            [23.978067506227646, -7.26911910408193],
            [23.978559699460018, -7.271384903498942],
            [23.979089520424715, -7.273823907417207],
            [23.978967479801771, -7.274345898213626],
            [23.974594434286288, -7.285478965130654],
            [23.97309607224015, -7.289293488946883],
            [23.972992200043837, -7.289557926365642],
            [23.974764531183656, -7.29231291097026],
            [23.977039319706254, -7.295848910429285],
            [23.976828274004994, -7.296067705312999],
            [23.973991200301633, -7.299008937481329],
            [23.971180698764378, -7.301917855797053],
            [23.971139999692117, -7.301959979600946],
            [23.974359840148153, -7.311379980601214],
            [23.967657163063645, -7.315386737077876],
            [23.965152480388461, -7.316883989001817],
            [23.965035384991172, -7.317063532857236],
            [23.962158359613866, -7.321474900441395],
            [23.962116089388179, -7.321935198328672],
            [23.961694330362292, -7.326527874175337],
            [23.965141319719354, -7.333880881664974],
            [23.966287199916, -7.341461893561027],
            [23.966867208857302, -7.342195288403517],
            [23.96739923967759, -7.342868015182053],
            [23.968848701931229, -7.344702951946815],
            [23.969738159826633, -7.345828950517792],
            [23.97187590226784, -7.346606548141338],
            [23.973108479770861, -7.347054893439799],
            [23.975364954339764, -7.347876259388393],
            [23.977331280258429, -7.348592008883639],
            [23.986677919311365, -7.349209031084404],
            [23.987917439893216, -7.349290858024335],
            [23.994589320034834, -7.354808869139623],
            [23.996195246353125, -7.361012821173451],
            [24.00056640001662, -7.365150864297206],
            [24.009311519968758, -7.364469912999009],
            [24.009655549569764, -7.367108579026406],
            [24.010000181041988, -7.369752027910498],
            [24.007005359581495, -7.375261883052307],
            [24.004507996379225, -7.377039426145698],
            [24.003782279800557, -7.377555966683211],
            [23.991354360034283, -7.378004022902036],
            [23.983524360150266, -7.383508983403757],
            [23.978691360141312, -7.384882977709369],
            [23.978841394963432, -7.385634921152946],
            [23.979379219917302, -7.388330372312231],
            [23.975229960010441, -7.401189903793573],
            [23.975265668941297, -7.401425559433611],
            [23.97683015956877, -7.411750074181917],
            [23.974529405242869, -7.417721029261579],
            [23.974754396390605, -7.425070844943135],
            [23.971750222569693, -7.44527784889144],
            [23.966915398980724, -7.449865963598157],
            [23.96675528955269, -7.45133047727967],
            [23.966304479908803, -7.455453987690219],
            [23.966085019688265, -7.457473681657804],
            [23.965988399591254, -7.458362873662029],
            [23.961843391410625, -7.46249285950825],
            [23.963848200257754, -7.471858858133359],
            [23.961021782370331, -7.47707067688824],
            [23.956110360335394, -7.486127022657962],
            [23.957453507873449, -7.488666602295441],
            [23.955379199966082, -7.492799857036848],
            [23.953905238857995, -7.493778821449625],
            [23.950693440120407, -7.495912000808329],
            [23.949854279796053, -7.496468925828408],
            [23.948702280275679, -7.497616005574245],
            [23.948080176280193, -7.502631730231539],
            [23.947000200086041, -7.51133891675592],
            [23.946851159698937, -7.512540985982201],
            [23.938562160230628, -7.516666016873352],
            [23.931658998039307, -7.522636387107517],
            [23.92980948005702, -7.524235974060602],
            [23.929204736902705, -7.525495236402959],
            [23.927274372341511, -7.52951482722996],
            [23.930217802981222, -7.536576789071749],
            [23.93072139673286, -7.537785004328605],
            [23.93290576263562, -7.543070106956955],
            [23.935089231121413, -7.548352972134374],
            [23.934395179258164, -7.553173834991596],
            [23.933164186383291, -7.553019383791088],
            [23.932554480037016, -7.552942884269497],
            [23.927025239868815, -7.558218908619172],
            [23.921495333150631, -7.566020828389169],
            [23.922414421077402, -7.567857924761171],
            [23.930010360422557, -7.571539896706826],
            [23.930905080648923, -7.573714063086141],
            [23.931617399753449, -7.575444987748431],
            [23.93092115959417, -7.583941026390586],
            [23.935062240340358, -7.590144849042121],
            [23.936439239991632, -7.595198015395289],
            [23.925836159690153, -7.617229889381528],
            [23.926033172808381, -7.617679326089071],
            [23.927447837022861, -7.620906520279541],
            [23.927666963070109, -7.626531821005645],
            [23.927671425002124, -7.626646540081152],
            [23.925598857131433, -7.63261204321218],
            [23.923061300608435, -7.63697396671845],
            [23.924209282862854, -7.639959788162949],
            [23.928370719433367, -7.653439993236814],
            [23.930874360062816, -7.661549879518468],
            [23.931089666473476, -7.664591826676089],
            [23.931329399873373, -7.667978850402527],
            [23.92971624032042, -7.672339013866359],
            [23.921882489970123, -7.680827088232804],
            [23.923080878491746, -7.681157043625583],
            [23.931089280197924, -7.683362008032012],
            [23.932137320385401, -7.684539216380058],
            [23.932930319880541, -7.685429948464608],
            [23.928091199649558, -7.691394931426147],
            [23.924860200321078, -7.703788965358937],
            [23.923493808875023, -7.706151271345232],
            [23.920480439898853, -7.711360931739652],
            [23.919784199739578, -7.717788959778566],
            [23.920589966091534, -7.721082420965095],
            [23.922312480258949, -7.728122884819162],
            [23.931612189524817, -7.745133928445583],
            [23.933067480048027, -7.747795884911032],
            [23.935845120313857, -7.75287661801031],
            [23.941400399947224, -7.763037896841244],
            [23.948070479865024, -7.774522916106429],
            [23.949963757479722, -7.776503537114418],
            [23.952903479873946, -7.77957886010913],
            [23.951978279810028, -7.786006011438745],
            [23.957500319981229, -7.793587014131888],
            [23.957966692039101, -7.794937853814959],
            [23.959799280371524, -7.800245876923733],
            [23.961174479798949, -7.812872870903954],
            [23.959843091207929, -7.816073836700063],
            [23.958406439828533, -7.819527851518923],
            [23.951263413083336, -7.826178085058361],
            [23.951437882081176, -7.826516050215461],
            [23.954940000148945, -7.833299971278413],
            [23.938987320278194, -7.840726304563699],
            [23.921181000056308, -7.850776165167716],
            [23.909942159570402, -7.857629937678837],
            [23.902457400216377, -7.862760551950754],
            [23.868327960053403, -7.871052231823665],
            [23.857735319972154, -7.873567301486294],
            [23.831416440150473, -7.882981759200361],
            [23.824147319583769, -7.886665975845153],
            [23.819072759899981, -7.895140314813884],
            [23.822339760111806, -7.925185186952199],
            [23.822147879967094, -7.944676520336309],
            [23.821334639631953, -7.953827863979926],
            [23.811842520215414, -7.957556949355402],
            [23.811844440813477, -7.954343009910468],
            [23.811845400214207, -7.952737009908341],
            [23.813091888129414, -7.950259543411134],
            [23.813923320247373, -7.948607015093554],
            [23.812313400019352, -7.944932997647577],
            [23.814623159955985, -7.936213922905116],
            [23.812337225137341, -7.928421823954056],
            [23.81071643978596, -7.922896940607017],
            [23.810839186484685, -7.918182549837491],
            [23.810955479686431, -7.91371598355408],
            [23.805904320217468, -7.893969869218051],
            [23.80565800036992, -7.892561092562085],
            [23.803304399952506, -7.879099899403301],
            [23.801090400425164, -7.866419958570067],
            [23.80040201962629, -7.865166248710053],
            [23.797180440031905, -7.859298912257232],
            [23.780378519841001, -7.849408859661205],
            [23.77439531963719, -7.844121868599973],
            [23.771406240208005, -7.836542866134935],
            [23.763697740161113, -7.830335916985031],
            [23.755989240114221, -7.824128875042915],
            [23.754492890294312, -7.825731878498158],
            [23.749996320139047, -7.830548904857833],
            [23.73900141716852, -7.851889975168342],
            [23.735695234240662, -7.858306967893743],
            [23.725322279857089, -7.868623905595538],
            [23.721299731812646, -7.873993491081555],
            [23.716560240136555, -7.880320013014931],
            [23.716098925593776, -7.882154626052113],
            [23.715637226572007, -7.883990936278424],
            [23.716587109645037, -7.886496370954917],
            [23.718162239918698, -7.890650939592956],
            [23.718374314190999, -7.895365619562725],
            [23.718389389718091, -7.895701034057294],
            [23.716539392933747, -7.903503041683384],
            [23.716791576983482, -7.904461451050373],
            [23.717687379679752, -7.907865871444526],
            [23.713539479822234, -7.911762888532795],
            [23.713419494544688, -7.914316498355766],
            [23.71330224014558, -7.916811964464953],
            [23.708891502219085, -7.921048404877448],
            [23.706619200233192, -7.923230896735003],
            [23.706384480330897, -7.927820936818128],
            [23.70461711956958, -7.929791565911543],
            [23.703733439638071, -7.930776877319412],
            [23.702210920995618, -7.932474519019428],
            [23.691168359704314, -7.944787000217358],
            [23.690758297641729, -7.947087530331054],
            [23.690473200218342, -7.948686973913066],
            [23.69162123996491, -7.952591015291183],
            [23.68839023973813, -7.959701863010208],
            [23.688386820750146, -7.963602519571324],
            [23.688383256235095, -7.967504882081477],
            [23.647654439855401, -7.968946564310124],
            [23.63073047993992, -7.96795123261749],
            [23.625578879839026, -7.966846674798157],
            [23.592084839636112, -7.947182210817957],
            [23.589138239740038, -7.942983978979773],
            [23.583614759569425, -7.936504496312272],
            [23.574867310285747, -7.93820109307747],
            [23.57348436019403, -7.939805916583273],
            [23.567266440087991, -7.939337932566458],
            [23.55994224021795, -7.944903905813767],
            [23.559429240206974, -7.945293886132231],
            [23.541462221262254, -7.948022131203343],
            [23.541434946613581, -7.948056029322996],
            [23.532489284960782, -7.95917393734379],
            [23.526008279749028, -7.967278932292904],
            [23.518402200220937, -7.972775988546719],
            [23.510979626742454, -7.97379735784945],
            [23.508497160302586, -7.974138952797686],
            [23.49743435996794, -7.979630917883705],
            [23.492828519639808, -7.978934900913648],
            [23.488462439661053, -7.970665945866209],
            [23.48453312147171, -7.968903169148159],
            [23.48178631767464, -7.967670888961101],
            [23.479261200123382, -7.961929933783662],
            [23.460018480050415, -7.958780398071887],
            [23.449710240299911, -7.949656652120363],
            [23.442347879996603, -7.943962773474825],
            [23.437002004842498, -7.945193374124107],
            [23.40073435511443, -7.953541988539494],
            [23.399349479933065, -7.954916930276227],
            [23.389906319597802, -7.955130924193321],
            [23.38422087407978, -7.953501514816835],
            [23.380237439581126, -7.952359886219939],
            [23.376091320184486, -7.952811970705413],
            [23.340587847505653, -7.947480348395656],
            [23.322045600453585, -7.94469579668744],
            [23.309536679598168, -7.944043625204824],
            [23.29078463999463, -7.95766278589788],
            [23.279757480318892, -7.970441608882069],
            [23.26780943967908, -7.97557597620309],
            [23.263557694574732, -7.973291244659142],
            [23.25538224036168, -7.968898019901463],
            [23.247322199899717, -7.968195024425363],
            [23.241972240106008, -7.964508870392657],
            [23.236967410349518, -7.961060814570429],
            [23.235549403503839, -7.959381677228914],
            [23.22823140021265, -7.950715923563354],
            [23.224086359692691, -7.950478904206311],
            [23.214634200034901, -7.956657967644884],
            [23.214177169557715, -7.956722117554285],
            [23.209797240252172, -7.957336889391942],
            [23.20565616040432, -7.953656882879073],
            [23.204971440240254, -7.94929487464443],
            [23.20353606626519, -7.948695988679463],
            [23.19944723962077, -7.946989987581329],
            [23.198162220268095, -7.943124844500842],
            [23.197843476445723, -7.94216610450419],
            [23.200384300141398, -7.937350879017258],
            [23.18075640044092, -7.923726208599265],
            [23.176702440107604, -7.91113993754455],
            [23.17832027988317, -7.90815886547731],
            [23.174875440194562, -7.901036940068257],
            [23.172883929108565, -7.889009177072388],
            [23.170541400427012, -7.874860978982174],
            [23.176996155967846, -7.87051190066995],
            [23.173090200264117, -7.865224974051348],
            [23.172865200133216, -7.862010958491861],
            [23.174713389507197, -7.858112044985343],
            [23.185316371892291, -7.85216407886524],
            [23.188785452618845, -7.841841014350877],
            [23.187007409990478, -7.841265345615125],
            [23.18165027984417, -7.839530887733938],
            [23.18142348038775, -7.837235913302451],
            [23.185577520230229, -7.831963940751751],
            [23.184437400031204, -7.824156904954273],
            [23.187910206071216, -7.812226014721091],
            [23.184595649048283, -7.811952077903037],
            [23.179390154521929, -7.81152169753884],
            [23.177055304639431, -7.802987340258312],
            [23.176185480322854, -7.799807907787631],
            [23.175964450745489, -7.794297974590672],
            [23.178788686625133, -7.790288454163889],
            [23.182424279971066, -7.785127006230941],
            [23.182062637102302, -7.783306063830545],
            [23.181740280255838, -7.781682925245528],
            [23.186346479910075, -7.780773021761777],
            [23.185065745521289, -7.769547267040799],
            [23.184984230595774, -7.76883278236209],
            [23.183845200053195, -7.760106996575348],
            [23.184424843380143, -7.758669331117617],
            [23.186157479764187, -7.754371915710427],
            [23.193302400158032, -7.749563871926767],
            [23.2036934403232, -7.729609879150105],
            [23.206936306396571, -7.717447923805794],
            [23.210855279587076, -7.714470934447902],
            [23.213861279682984, -7.706210937764467],
            [23.218471440009296, -7.702546006807935],
            [23.218858080297455, -7.700480651054537],
            [23.21963133482269, -7.696349902680128],
            [23.215028803888064, -7.694963056570387],
            [23.212728360379263, -7.694269880017321],
            [23.211874303292571, -7.693050273907478],
            [23.211118440151242, -7.691970887132839],
            [23.212011698818635, -7.690887160322119],
            [23.213196360184408, -7.689449891504314],
            [23.214733151260081, -7.689233429493581],
            [23.216419241437656, -7.688995938765892],
            [23.216192280284488, -7.687158909591683],
            [23.21389224011925, -7.685547998556585],
            [23.213436479859858, -7.682332946209118],
            [23.214078888475736, -7.680950296056725],
            [23.21482247973195, -7.679349864953399],
            [23.219890199643174, -7.676833973196174],
            [23.219420361884932, -7.673035960110324],
            [23.218981199797042, -7.6694858827661],
            [23.225431320031021, -7.666971896307065],
            [23.226172319647645, -7.665024686396638],
            [23.229360359742596, -7.656647000241321],
            [23.2279912796389, -7.64883792425432],
            [23.229608355846462, -7.64516705565923],
            [23.226164279725822, -7.639190955522121],
            [23.226669375460641, -7.637187224695659],
            [23.227321319693242, -7.634600927934301],
            [23.226891394083108, -7.632653723362727],
            [23.226408360073371, -7.630465967431649],
            [23.219969399610168, -7.624943988820061],
            [23.219513280024671, -7.622646939177558],
            [23.222742480027634, -7.618061018651702],
            [23.220913319666337, -7.610479869706147],
            [23.225071320180916, -7.600842921509277],
            [23.223692280455634, -7.599233965208851],
            [23.222218115430007, -7.598998849197622],
            [23.220789479717908, -7.598770994166301],
            [23.220371230409814, -7.598704473571132],
            [23.219318159656758, -7.598536988442731],
            [23.218408454633138, -7.591646905847589],
            [23.218590746160505, -7.590684997193705],
            [23.219104437874247, -7.587974859445812],
            [23.222559848937134, -7.584539216799592],
            [23.224868280265426, -7.582243975621829],
            [23.2234935030462, -7.577878882525179],
            [23.227644239783388, -7.573293976451348],
            [23.228225424619385, -7.570602652204429],
            [23.228338289849972, -7.570079996543969],
            [23.227190432461416, -7.568700202308327],
            [23.21891820004787, -7.55835200101728],
            [23.219521250776182, -7.554780676173555],
            [23.219848439660534, -7.552843019559784],
            [23.218700399913971, -7.550085018186991],
            [23.214330360161409, -7.547320924769061],
            [23.214570089968014, -7.544274532537731],
            [23.214800160190403, -7.541350872206789],
            [23.209511399922054, -7.538586007779022],
            [23.208745225019573, -7.536284962819284],
            [23.208593422312997, -7.535828873524885],
            [23.210330190048992, -7.527009449557532],
            [23.21207421168095, -7.518153008775992],
            [23.207706361122749, -7.51332193708706],
            [23.207710319998188, -7.51125512207599],
            [23.213943612075397, -7.511044996094916],
            [23.214155220122034, -7.511037867966587],
            [23.214163320230963, -7.506215969076971],
            [23.217157440107226, -7.50507302194654],
            [23.220384479661938, -7.501174971029059],
            [23.227518240285004, -7.502794979282159],
            [23.228313396635141, -7.501829919019198],
            [23.229595439869296, -7.500273931001345],
            [23.231905199805929, -7.494765988777637],
            [23.236053479650785, -7.491099943856089],
            [23.23444757938368, -7.48673307648257],
            [23.236992712297798, -7.482036595615748],
            [23.23929632146967, -7.477785994009824],
            [23.240751479940542, -7.477606883988068],
            [23.241727677363148, -7.47748726089158],
            [23.242979520135751, -7.477333860104572],
            [23.243564520116792, -7.476635930483824],
            [23.245285320298613, -7.474581983480244],
            [23.243908319749039, -7.471363904950311],
            [23.244837479586767, -7.466542996809268],
            [23.25036636042886, -7.462419986766306],
            [23.254528319818917, -7.450484944020142],
            [23.250509279695642, -7.443817529857407],
            [23.246490239572363, -7.437150012986318],
            [23.245117199694896, -7.432324969869197],
            [23.245731359888346, -7.430291005427809],
            [23.246505360015242, -7.427733973026815],
            [23.245564944286986, -7.426119460352727],
            [23.244898192225261, -7.424974989218555],
            [23.243583648842453, -7.424972643487941],
            [23.243196239596376, -7.424971952142995],
            [23.242748477936274, -7.424971266178213],
            [23.241214598300424, -7.424968914170761],
            [23.240289240132984, -7.428640882618694],
            [23.237297279806679, -7.427946984763268],
            [23.232256200333513, -7.413697988505273],
            [23.232726940898601, -7.411985504406924],
            [23.232950280044538, -7.411173025326787],
            [23.236472121522645, -7.40715101079501],
            [23.239174320372637, -7.404065020683455],
            [23.235960239914188, -7.39946586081619],
            [23.237644319662191, -7.397478029734675],
            [23.2451667588508, -7.394432108649012],
            [23.245176239670297, -7.391673985160793],
            [23.247106390432489, -7.388744311867972],
            [23.249046240304768, -7.385799985453715],
            [23.249303383054848, -7.385409490885792],
            [23.249559234027569, -7.385020958994322],
            [23.24933673480642, -7.382306324227317],
            [23.249107446118341, -7.379508847806671],
            [23.251871722147719, -7.37469758307035],
            [23.2546442402198, -7.369871918356461],
            [23.254779424093641, -7.369229958339945],
            [23.25580452041045, -7.364361961210943],
            [23.247528480038405, -7.357455873786193],
            [23.249386440387713, -7.346434862872422],
            [23.247549179917488, -7.34413489153772],
            [23.238113400140609, -7.343887883136975],
            [23.233974479842676, -7.341353937002028],
            [23.226385320082951, -7.336975932312253],
            [23.229622439633491, -7.327335017123049],
            [23.227331399689039, -7.32089987697192],
            [23.230401456851244, -7.313778496827328],
            [23.231487239755367, -7.311259860712708],
            [23.231656442829021, -7.310189989069697],
            [23.232649320169838, -7.303911957497703],
            [23.234741271887728, -7.289215839677306],
            [23.23469853723304, -7.288561338914578],
            [23.234066279579864, -7.27887790292051],
            [23.235710399569083, -7.256829887623551],
            [23.236695148054892, -7.254932026468849],
            [23.237976239973154, -7.252463023105509],
            [23.239402199604001, -7.249715989773528],
            [23.238935593984184, -7.247839408502275],
            [23.238716253239566, -7.246957986492084],
            [23.23468440044542, -7.250554975323553],
            [23.233371500081265, -7.251725717946477],
            [23.23203450779949, -7.252917939738927],
            [23.230655280326346, -7.251077888739141],
            [23.23254744043685, -7.246010882430654],
            [23.235969203304094, -7.236845960193874],
            [23.236610640841143, -7.233463060988471],
            [23.237362226205093, -7.229497887265794],
            [23.233452500272112, -7.22788274350891],
            [23.235077160057305, -7.218925926021289],
            [23.233932359635638, -7.213870891242126],
            [23.234632200242551, -7.212757932137967],
            [23.235165717774635, -7.211908781039751],
            [23.237392148188881, -7.208364715900434],
            [23.232568499642042, -7.203531080954966],
            [23.231155314952815, -7.196832678058626],
            [23.230968483340021, -7.195947008663667],
            [23.231445479772766, -7.1840029327445],
            [23.233984199614039, -7.175263981814479],
            [23.234914440125038, -7.172063918448408],
            [23.233026977305187, -7.170753724033656],
            [23.231928239796318, -7.169991025983887],
            [23.227848360372121, -7.169765014876484],
            [23.223784772793913, -7.169540225648434],
            [23.219043479995708, -7.169277947481505],
            [23.214445241211514, -7.166971808917553],
            [23.216520207584026, -7.163529970999284],
            [23.214452399886017, -7.161228914437684],
            [23.216297213391172, -7.159164227413059],
            [23.216078160107458, -7.151352984352721],
            [23.217933292560236, -7.142279688994138],
            [23.219787240135176, -7.133212008521627],
            [23.22014776639805, -7.13275087244149],
            [23.223015360363195, -7.129083023553179],
            [23.222803320226884, -7.116905966400895],
            [23.225107320165897, -7.114383963411443],
            [23.227408679956305, -7.114081266834602],
            [23.228559359851509, -7.11392991847037],
            [23.229091594589374, -7.112727158935979],
            [23.231098439917254, -7.108192002579586],
            [23.231155491022616, -7.107682973066365],
            [23.231256479626875, -7.10678192321346],
            [23.231783993717894, -7.10211629359461],
            [23.231798267947774, -7.101989939307673],
            [23.228014319629288, -7.100659962513276],
            [23.227553590788052, -7.100497709657698],
            [23.227199522513779, -7.100371105459109],
            [23.227577280260409, -7.094603015084047],
            [23.227504346042497, -7.09359497359844],
            [23.229623810462595, -7.086234074827204],
            [23.230446480413267, -7.083377892928652],
            [23.229548435522037, -7.080373611691952],
            [23.229072359862521, -7.078780961941121],
            [23.229574176746535, -7.078138946371561],
            [23.232300480090505, -7.074650945899871],
            [23.231155320342733, -7.070283922839231],
            [23.235307199736958, -7.062709939890795],
            [23.234884499276646, -7.062021558140371],
            [23.233471199603063, -7.059719944914682],
            [23.235544440311912, -7.058116020464897],
            [23.244062279310647, -7.053995891026124],
            [23.24107742196329, -7.051003865543801],
            [23.244400440217884, -7.048038960123593],
            [23.247757439943079, -7.045042966624301],
            [23.253963479829505, -7.049188989905078],
            [23.255203320211589, -7.041623957592994],
            [23.255356268270202, -7.040690285479337],
            [23.257271160248958, -7.041422923402789],
            [23.259375654244824, -7.042228712749048],
            [23.260183200159396, -7.042537914283331],
            [23.261535359596401, -7.040030880101513],
            [23.259052965021734, -7.030130857022278],
            [23.259977280245113, -7.025765012556721],
            [23.251934256569598, -7.020695896388444],
            [23.252786561043148, -7.019634946567613],
            [23.254699297065237, -7.017253959417461],
            [23.251251239611292, -7.014721001556004],
            [23.251257359833321, -7.011503888220655],
            [23.247879561414358, -7.010748173102925],
            [23.247118431450545, -7.010577834880669],
            [23.246660172976359, -7.008048925762029],
            [23.247602056551738, -7.006576073874839],
            [23.251503240404688, -7.000475991851682],
            [23.24944548036315, -6.992659910095267],
            [23.251058279691634, -6.990366004487147],
            [23.257961334983435, -6.988769757724956],
            [23.259471024785306, -6.98522095547149],
            [23.263040159868172, -6.976830938960461],
            [23.270173982475008, -6.974776026496963],
            [23.264660160091985, -6.970400990949713],
            [23.265065416167801, -6.967788308297023],
            [23.265123479674525, -6.967413972279688],
            [23.270727733660546, -6.963567814630681],
            [23.271801480038164, -6.962830906743386],
            [23.2736623203863, -6.958493946609783],
            [23.273588895688246, -6.958167079125563],
            [23.27159149434895, -6.949275059466268],
            [23.272617941731927, -6.947671820123329],
            [23.280121439942768, -6.93596289174961],
            [23.275753200414059, -6.934575897356672],
            [23.272370622059476, -6.936980193744016],
            [23.270916217275136, -6.938013924270902],
            [23.269079521845217, -6.936172023941121],
            [23.278299479578475, -6.922631975180378],
            [23.278993199963359, -6.920105863005051],
            [23.278104029528826, -6.919052110881179],
            [23.276468519891655, -6.917113869785333],
            [23.276776299775985, -6.916296909311207],
            [23.277160560426971, -6.915276941720588],
            [23.268800879715439, -6.912866473729523],
            [23.261398200327243, -6.912340130204459],
            [23.253825600111476, -6.912157108855853],
            [23.246650439730242, -6.912678442477336],
            [23.236328160210167, -6.912950022503354],
            [23.231469240212025, -6.915959217282433],
            [23.22842904035495, -6.918317539097887],
            [23.220273240381996, -6.917425522316146],
            [23.212188719930197, -6.913756174174649],
            [23.206114440438071, -6.909614123041491],
            [23.20107768006482, -6.908276429101792],
            [23.195309039771672, -6.907094739664772],
            [23.189199479845076, -6.906599519867174],
            [23.183075880148913, -6.90575668031402],
            [23.179260959716071, -6.90271145857839],
            [23.178315599660525, -6.897651133475058],
            [23.177590919737671, -6.893464569352466],
            [23.174315639753896, -6.890084875784566],
            [23.167765440010754, -6.887841991238343],
            [23.162430240435487, -6.883717601980322],
            [23.15872151973387, -6.878763886769063],
            [23.157478079802416, -6.875433289945051],
            [23.156738999885558, -6.870898702543252],
            [23.155872120246499, -6.867750910007216],
            [23.152390920348438, -6.863844811640828],
            [23.148767519835879, -6.860977707320478],
            [23.145002279831516, -6.859149436512072],
            [23.140697400276416, -6.857655572802169],
            [23.136626520174737, -6.857383424713476],
            [23.132030399618003, -6.857793526360077],
            [23.128503106264407, -6.857852678800658],
            [23.123548080005595, -6.857935773220523],
            [23.113730159601786, -6.857003561120632],
            [23.103542879800912, -6.856062400428089],
            [23.094044640162348, -6.853921700355738],
            [23.084631719814475, -6.849350940093411],
            [23.075836199883319, -6.841841877558594],
            [23.0693925600958, -6.833173187248157],
            [23.065768800257132, -6.821271595250359],
            [23.063686920450198, -6.815487999566215],
            [23.055417000300174, -6.802778728490479],
            [23.050457639670103, -6.794319052723115],
            [23.045434919964748, -6.788811432000408],
            [23.038763760271973, -6.783611372332895],
            [23.030686439817174, -6.78011474834699],
            [23.024612160325049, -6.77597152202427],
            [23.02106688000454, -6.770499481323174],
            [23.020023273901305, -6.766556020080375],
            [23.02993944035277, -6.751409928357551],
            [23.033405159583552, -6.742223971860708],
            [23.034138249534095, -6.741162646418149],
            [23.038477200391274, -6.734880913344288],
            [23.041682279730541, -6.732076467827385],
            [23.04607715969734, -6.728230918231416],
            [23.057836200191264, -6.710099923971287],
            [23.061317430632027, -6.691261100955986],
            [23.067708653722672, -6.676697093416629],
            [23.07401424041732, -6.662328961441796],
            [23.07250490545, -6.654333725095696],
            [23.072191226329196, -6.652672088761329],
            [23.075885216456808, -6.646237588350569],
            [23.077726175291051, -6.643030820678209],
            [23.07676331515545, -6.641352251008253],
            [23.073370200460911, -6.635436935696314],
            [23.082695279947007, -6.624695998627224],
            [23.088809467095622, -6.617652431294396],
            [23.092491240135374, -6.613410966198805],
            [23.093185274930612, -6.610654068572771],
            [23.092209307476725, -6.608693807820986],
            [23.090894279901946, -6.606052881852533],
            [23.092283085212674, -6.600309253267554],
            [23.089225757178077, -6.594611812777656],
            [23.089073400210957, -6.594327887667744],
            [23.089079160208549, -6.590649991269375],
            [23.090572714471293, -6.587233417337434],
            [23.091388199696308, -6.585367947197375],
            [23.090015159818837, -6.580537899753789],
            [23.091885944517145, -6.576443606635697],
            [23.09463144036717, -6.570434909242886],
            [23.102926199833103, -6.559647964207393],
            [23.104082141160941, -6.555742915406009],
            [23.100412326494244, -6.550678872091449],
            [23.100443825021372, -6.55027067996352],
            [23.10135226252212, -6.538498112895076],
            [23.108345415243637, -6.529164376394758],
            [23.112873359958524, -6.523120984913295],
            [23.125538160075312, -6.510503948677117],
            [23.127159240074107, -6.503840862959084],
            [23.12694936038605, -6.49050887308249],
            [23.136860160302025, -6.475816858691661],
            [23.139877298609147, -6.458352857245136],
            [23.150449440033892, -6.458832974252643],
            [23.151826986759168, -6.460444800089756],
            [23.152506479626592, -6.467571928491891],
            [23.155481520184534, -6.475852851711516],
            [23.154869160214933, -6.478662968743923],
            [23.153629319832849, -6.484353887522018],
            [23.147646564295098, -6.488019992103101],
            [23.151087359768312, -6.4923949449872],
            [23.160736440017825, -6.496550974026513],
            [23.161655012311595, -6.499321300805465],
            [23.162109479895296, -6.500691927766503],
            [23.166706320002579, -6.502079997533934],
            [23.167852200199221, -6.503690990615892],
            [23.167297832769403, -6.505070788765448],
            [23.166006480293962, -6.508284899488189],
            [23.166928423066672, -6.511064723930438],
            [23.167379486035475, -6.512424755279368],
            [23.165071388880435, -6.517477548007791],
            [23.165738761678053, -6.520432095687235],
            [23.166214200432066, -6.522536022989091],
            [23.172416278748091, -6.52530595741506],
            [23.171943240292528, -6.533579998558735],
            [23.169951502831097, -6.538291079870546],
            [23.168253239583091, -6.542307968074118],
            [23.169624442405798, -6.546907030665645],
            [23.168468159718195, -6.551271939134454],
            [23.171447160049912, -6.557483921462079],
            [23.179714175048286, -6.563935893962612],
            [23.174503199900371, -6.578037907414105],
            [23.174416303168009, -6.578272952705204],
            [23.173942319684766, -6.57955501994781],
            [23.175309949907582, -6.587707772289656],
            [23.176449360437566, -6.594499953848019],
            [23.174016195337099, -6.597615136692448],
            [23.173223392572993, -6.598630237262241],
            [23.173235258419584, -6.598801638085833],
            [23.173446225967428, -6.601848902323402],
            [23.179878363726012, -6.606917862583166],
            [23.180739110566652, -6.604986447006063],
            [23.185456545009245, -6.604239568078722],
            [23.189611304402266, -6.603279292852331],
            [23.19424162382187, -6.601811664477318],
            [23.19583462517982, -6.60093749502924],
            [23.198936024562254, -6.598756627925996],
            [23.20243522939354, -6.59628501169541],
            [23.206829384419883, -6.595251326609046],
            [23.209561424405287, -6.596174377536251],
            [23.213343226648533, -6.597957461993872],
            [23.217837104552896, -6.598870842119235],
            [23.229826544052543, -6.596569842955097],
            [23.231263664352497, -6.596129263829627],
            [23.234461183470355, -6.595534898149123],
            [23.237334704519718, -6.594581588357625],
            [23.246523702715006, -6.592512226229833],
            [23.25018994388348, -6.590761166564278],
            [23.255933023513514, -6.588421635440298],
            [23.261350303952934, -6.585579021715056],
            [23.267644904251647, -6.582370991849774],
            [23.276000864141267, -6.577059675990967],
            [23.278621303723959, -6.574809238182625],
            [23.281956703458114, -6.571977646408215],
            [23.284733024098809, -6.5692935622351],
            [23.290216184286201, -6.56500762777464],
            [23.292909344287796, -6.562035254941475],
            [23.297198383849476, -6.558477229734767],
            [23.300931223418164, -6.555354961652972],
            [23.303470302585573, -6.552960474796026],
            [23.306733343023634, -6.550922806527175],
            [23.308242103069176, -6.549616160126955],
            [23.31022174291866, -6.547368997993201],
            [23.313309102531523, -6.543745156946493],
            [23.316404023264155, -6.540914638724476],
            [23.318709102978143, -6.539170735140293],
            [23.322197508263091, -6.535616840094405],
            [23.324057557195417, -6.535295925496055],
            [23.324356062872784, -6.535244427452591],
            [23.330353302846127, -6.53685799342683],
            [23.340236376260854, -6.538254017784],
            [23.347410341882785, -6.533787989475816],
            [23.350207354317721, -6.532046726323464],
            [23.360487467816675, -6.525646856047882],
            [23.364166303365419, -6.524733882519425],
            [23.3670447498775, -6.525392610379052],
            [23.369222231990236, -6.525890993327527],
            [23.379326262218765, -6.535332872807666],
            [23.379356196778978, -6.535349444069115],
            [23.379577737497723, -6.535472086659324],
            [23.385990227304422, -6.53902194889523],
            [23.392887456123283, -6.539493017289794],
            [23.39940101089103, -6.531661160793226],
            [23.399788023081719, -6.53119581596075],
            [23.400715307237139, -6.530080850086034],
            [23.404165178389661, -6.529856863849686],
            [23.413356341524754, -6.534238888916781],
            [23.425552422285886, -6.526213916639728],
            [23.426691792391637, -6.526900218943718],
            [23.428997183821046, -6.52828887829043],
            [23.43220738265914, -6.535878954199926],
            [23.437734302478969, -6.532669904749523],
            [23.442557022167811, -6.532678609537751],
            [23.441502806961086, -6.537216799308922],
            [23.439779961315342, -6.544629991633895],
            [23.440929801285726, -6.547389944921874],
            [23.446449887621203, -6.54625000882205],
            [23.446678115398914, -6.54900197443503],
            [23.446139850270566, -6.549521958660504],
            [23.43930980106191, -6.556119997593924],
            [23.434239922499064, -6.567829949189067],
            [23.432664556866797, -6.568845325274015],
            [23.430329802205691, -6.570350390597644],
            [23.42939119119287, -6.572369446339148],
            [23.427551531322532, -6.576326737108203],
            [23.422797654923819, -6.579545111322816],
            [23.421119487887012, -6.580680077884534],
            [23.416749890105589, -6.580902402431845],
            [23.416584450972969, -6.583437843417036],
            [23.416509922245449, -6.584580038767199],
            [23.419720042031763, -6.590559938902624],
            [23.419853945806338, -6.595627778361354],
            [23.420000122364325, -6.601160020575381],
            [23.428259675955942, -6.609351306535893],
            [23.428091964085674, -6.610168808337614],
            [23.426979802153213, -6.615589975795534],
            [23.431640002234104, -6.622989984183953],
            [23.431849881922126, -6.631499936248756],
            [23.432690149869238, -6.635209730742647],
            [23.434139842091604, -6.641610076997818],
            [23.440803303222388, -6.647367867364209],
            [23.441959408043562, -6.645530906639646],
            [23.446098340019624, -6.644847974470989],
            [23.450235455602154, -6.646463861192025],
            [23.457811305922618, -6.656588912877194],
            [23.468385215231855, -6.66005295708639],
            [23.475046300318716, -6.666038915385965],
            [23.477800300519529, -6.670639891567388],
            [23.480543140051271, -6.685352916912016],
            [23.487894209429761, -6.691109885871282],
            [23.495695180255371, -6.706289895966959],
            [23.507181346701945, -6.716649941963999],
            [23.514539435516085, -6.718039955366996],
            [23.534278179237784, -6.736231266582244],
            [23.542089098905183, -6.741183431422519],
            [23.543614588276238, -6.741858750047228],
            [23.550065979626346, -6.744714702996947],
            [23.56091097892876, -6.75037835665368],
            [23.571594338073915, -6.756512801807338],
            [23.580042818149593, -6.761956190912056],
            [23.586741338729301, -6.76545437963948],
            [23.599027779228205, -6.770363286601433],
            [23.609410538723065, -6.771739314139103],
            [23.6164442099555, -6.771445643302527],
            [23.619329617512722, -6.769303306934128],
            [23.620795897126794, -6.762532095571888],
            [23.62418961728584, -6.753276913350399],
            [23.628044497477468, -6.748625720540779],
            [23.638284344892121, -6.745881228743633],
            [23.648351737331762, -6.746299121126499],
            [23.659544136714128, -6.745162485427366],
            [23.669141009574297, -6.743351489659453],
            [23.675063376765365, -6.741128845302361],
            [23.682439776838244, -6.735143108615975],
            [23.68693437698807, -6.730349990563153],
            [23.690942984077623, -6.727127704068324],
            [23.695420293454884, -6.726609750895503],
            [23.701959336122215, -6.72994550569275],
            [23.704676984198418, -6.748250961246002],
            [23.709075447544873, -6.74865686029254],
            [23.71596765567962, -6.743767234370747],
            [23.72061777576468, -6.74008651449193],
            [23.724946775983479, -6.736714315905843],
            [23.737369240281048, -6.727768010114105],
            [23.731331375795563, -6.723352894190468],
            [23.728866456148133, -6.721552013555785],
            [23.72872377852817, -6.721204185104432],
            [23.72865425970496, -6.721034707260231],
            [23.727922304326651, -6.719249796483075],
            [23.74683032739609, -6.691927082818173],
            [23.748039044746868, -6.689516260272358],
            [23.749625385995309, -6.686352145444622],
            [23.755121254649033, -6.675389928864752],
            [23.759494175298688, -6.671948004853231],
            [23.763569370906989, -6.67076534378977],
            [23.763901397219175, -6.670668987655139],
            [23.765014414347771, -6.670345981913012],
            [23.771911301806803, -6.673112018988594],
            [23.773078496330214, -6.672918888193994],
            [23.77742936693291, -6.672198962476335],
            [23.783754235066791, -6.668346342822146],
            [23.784119647266508, -6.668123760903829],
            [23.785713311581119, -6.66715293799288],
            [23.785252071598496, -6.665765615156274],
            [23.78486121731332, -6.664589997751373],
            [23.783878413680092, -6.661633898728878],
            [23.778824222397059, -6.656342896200751],
            [23.773306285730069, -6.654037931903135],
            [23.764806334883563, -6.653254969498749],
            [23.764136084782077, -6.653193217464585],
            [23.760660222673469, -6.652872976396587],
            [23.756523454738954, -6.650799921507156],
            [23.762014662034673, -6.644147989625472],
            [23.762968175199745, -6.64299291411394],
            [23.762284274299198, -6.642605634105013],
            [23.757681079509616, -6.639999002968682],
            [23.746645422669602, -6.64021488358954],
            [23.743656335155546, -6.638142850709501],
            [23.741303702223671, -6.633585830260579],
            [23.741020133732878, -6.633036559448286],
            [23.740213347793048, -6.631473678041224],
            [23.747347439894448, -6.625046867051315],
            [23.748293948895245, -6.622371838465643],
            [23.748729479992768, -6.621140934221502],
            [23.747125319762372, -6.615622917073783],
            [23.748281279954817, -6.608499920209469],
            [23.746549311019013, -6.599805767088215],
            [23.745533399976026, -6.594706012777107],
            [23.748304319945206, -6.581147857109594],
            [23.755659480251509, -6.583914945532932],
            [23.762327399721055, -6.584152876122822],
            [23.765839244746697, -6.581924622786852],
            [23.76738935424477, -6.58094110794607],
            [23.771072135194267, -6.574739951694779],
            [23.766712243709481, -6.565310680681693],
            [23.770401454799771, -6.552903001657085],
            [23.769716390580946, -6.546466059284657],
            [23.771791413547305, -6.5388830082628],
            [23.777551545896372, -6.525098956594574],
            [23.780273290290307, -6.524983668702371],
            [23.782839252440894, -6.524874978881552],
            [23.78432623732396, -6.523709434772485],
            [23.784509893392219, -6.523565460386526],
            [23.786060319097267, -6.522350029195692],
            [23.784912254197884, -6.5200509270602],
            [23.77525927526003, -6.517050872509484],
            [23.773193247124606, -6.512450996496491],
            [23.770680846124492, -6.511820076641938],
            [23.766758212299187, -6.51083490257598],
            [23.766548115218864, -6.5102882337885],
            [23.766489854082813, -6.510136635654583],
            [23.765609134998471, -6.507844953833312],
            [23.768412740169275, -6.505342842648072],
            [23.768621141230341, -6.505156854976184],
            [23.769981233689649, -6.503942932963801],
            [23.771820205450478, -6.504174983925487],
            [23.773649337964031, -6.502526645531336],
            [23.774355952766523, -6.501889869361816],
            [23.77895325370951, -6.497746921099802],
            [23.779874856919054, -6.495334420858451],
            [23.780011388265841, -6.49497701950661],
            [23.780796453840413, -6.492921924173215],
            [23.780427265123269, -6.489758697421065],
            [23.780365292148442, -6.489227706679417],
            [23.78034033425488, -6.489013868492726],
            [23.77970372336587, -6.488107671381964],
            [23.779450898817373, -6.487747782274294],
            [23.775976413826047, -6.482801921358218],
            [23.776135456953863, -6.48138072529116],
            [23.776169232710231, -6.481078908516912],
            [23.776439383065615, -6.478664937395837],
            [23.787014293996414, -6.47913695538799],
            [23.788577016739399, -6.473356404623938],
            [23.788629333723222, -6.473162871731072],
            [23.789179034405151, -6.472913574327182],
            [23.789274567540673, -6.472870248208202],
            [23.791158333793138, -6.472015929763836],
            [23.792490555122427, -6.467084535438634],
            [23.79264687455828, -6.466505897033199],
            [23.792772213794926, -6.466041935971188],
            [23.796542144801702, -6.463953611654405],
            [23.796913293642813, -6.463748015748393],
            [23.797204474457313, -6.462707793153479],
            [23.799679174063275, -6.453867023978829],
            [23.798778149460244, -6.451814347885474],
            [23.798136945485172, -6.450353577748676],
            [23.797155241389856, -6.448116964748402],
            [23.797431405067744, -6.447565601242359],
            [23.797850040651426, -6.446729791491437],
            [23.798536173865426, -6.44535991739759],
            [23.801409800916016, -6.444501453482614],
            [23.801713755773839, -6.444410650267688],
            [23.803135173522627, -6.443986016612449],
            [23.805208413333183, -6.439620919084573],
            [23.805209942265776, -6.437663680567599],
            [23.805210226133422, -6.437318549509127],
            [23.805210212658668, -6.436172932486762],
            [23.798553453858226, -6.423521931441315],
            [23.791433441950602, -6.416847004256163],
            [23.793504453939217, -6.412481964545289],
            [23.794208254319905, -6.396850983341743],
            [23.79501240460268, -6.395446240687093],
            [23.795134337427768, -6.395233243146779],
            [23.796049301189061, -6.393634933300047],
            [23.796766366093252, -6.393738094309915],
            [23.79926732525157, -6.394097896396311],
            [23.807535462245752, -6.403302909981171],
            [23.809558590436453, -6.403386389420742],
            [23.813282124357141, -6.403540031130034],
            [23.813705783319858, -6.403010988848562],
            [23.813808137363338, -6.402883171583555],
            [23.81512235825096, -6.401242003898861],
            [23.813976213051305, -6.397792853568545],
            [23.808693212780543, -6.393878861024968],
            [23.808332481701804, -6.391162655637289],
            [23.808280848335901, -6.390773870087627],
            [23.808235327107184, -6.390430830426535],
            [23.839284640891957, -6.367712232346361],
            [23.843189837519276, -6.369549951406849],
            [23.844441088302091, -6.370935334116562],
            [23.848879983921172, -6.37584999656425],
            [23.846640992364311, -6.383251898504575],
            [23.849160064253738, -6.388409894439433],
            [23.852151320300855, -6.392009707633292],
            [23.852599864393596, -6.392549503280833],
            [23.852972491861635, -6.392685069714619],
            [23.855129944238488, -6.393469978807725],
            [23.857810970695521, -6.392312099274441],
            [23.862029346081989, -6.390490266135267],
            [23.86438295727924, -6.39056673083785],
            [23.876740022427448, -6.390969942073553],
            [23.87999074786126, -6.386945059502978],
            [23.881569782213173, -6.384989968830382],
            [23.892690964058119, -6.387787244131426],
            [23.896280101927452, -6.388690005497152],
            [23.904559597220068, -6.386630119940109],
            [23.904978644232116, -6.387003870139474],
            [23.906620039631072, -6.388470096060668],
            [23.907868486771914, -6.393152094775674],
            [23.907886866302626, -6.393221024619997],
            [23.909379153042497, -6.398817503074453],
            [23.907741815333701, -6.402076117209877],
            [23.907728817609829, -6.402101955335331],
            [23.907302582278874, -6.402951254464983],
            [23.912196481775894, -6.404446625806887],
            [23.912265115758526, -6.404467597617574],
            [23.912590196296929, -6.404566929058747],
            [23.916956380480279, -6.408248941805549],
            [23.920183261931502, -6.408252445618107],
            [23.923391363203404, -6.408255927863196],
            [23.924975521545694, -6.409096235584458],
            [23.92510149948448, -6.409163058628189],
            [23.927297354839716, -6.410327833359387],
            [23.927070210430241, -6.406419862946426],
            [23.928451248907002, -6.404812927376469],
            [23.935114410000491, -6.410336982415075],
            [23.937805247857053, -6.41131788944704],
            [23.937924860333776, -6.411361492280156],
            [23.940170251488723, -6.412180011859031],
            [23.942468130307379, -6.411722973918321],
            [23.946255132897825, -6.408362805367075],
            [23.946691183221571, -6.407975901362573],
            [23.948679209742558, -6.406211935719251],
            [23.965925379180813, -6.399562865208397],
            [23.970062479491993, -6.400255960284455],
            [23.974687322781623, -6.396077189711302],
            [23.974891173875761, -6.395893007262736],
            [23.979339554805929, -6.399132513215816],
            [23.979655498579582, -6.399362596226213],
            [23.979948357447025, -6.399575865215025],
            [23.984544341459838, -6.399579732146307],
            [23.9858748281423, -6.398200109298785],
            [23.990524179269514, -6.393378999220623],
            [24.007841481803531, -6.394467467651192],
            [24.015405207562605, -6.394942880125073],
            [24.016502212221273, -6.39500810451864],
            [24.021562104213121, -6.387430237837681],
            [24.025423674158631, -6.388608936578384],
            [24.026848178518748, -6.389043908663523],
            [24.037882036931574, -6.389512964508985],
            [24.042661178447652, -6.385506853731295],
            [24.048159067412453, -6.385213376564926],
            [24.048187155934762, -6.385211878457109],
            [24.056505337175114, -6.379316014285401],
            [24.065693111864956, -6.379806928222181],
            [24.06661704081278, -6.37734519383946],
            [24.066835678176542, -6.37676256339322],
            [24.067552458314786, -6.374852809783595],
            [24.076517257676386, -6.369027927535791],
            [24.076276271126705, -6.363824196648268],
            [24.076221446046581, -6.362640876454861],
            [24.076752891165331, -6.362336331707464],
            [24.083250450531125, -6.358612881876335],
            [24.088204392523409, -6.359825267408564],
            [24.09139149657382, -6.35502384973129],
            [24.08580608564921, -6.348111162635131],
            [24.076974565733043, -6.336764511102801],
            [24.068629046961956, -6.332481956366777],
            [24.055661486746647, -6.325222183507103],
            [24.04586732678213, -6.319849921508268],
            [24.020215527805576, -6.305321316024353],
            [24.009328407397792, -6.301397296579185],
            [24.004082848908087, -6.296455955212125],
            [24.000755729844208, -6.289192269561146],
            [24.001232760412908, -6.276151982208936],
            [24.003247319574132, -6.257401657017799],
            [24.005277360300934, -6.229304363504325],
            [24.007973759627429, -6.217459709934535],
            [24.010639200314287, -6.216498696483209],
            [24.013304640102817, -6.215537680353896],
            [24.015970079891346, -6.214576663344802],
            [24.018635879904313, -6.213615644557232],
            [24.021301319692874, -6.212654623092512],
            [24.023966760379697, -6.211693242052092],
            [24.0267434403465, -6.210692622767488],
            [24.029520479639441, -6.209691822656507],
            [24.03187308023195, -6.208323198660085],
            [24.0342260401506, -6.206954571959301],
            [24.036579000069249, -6.20558576185589],
            [24.03926567962435, -6.205951793146043],
            [24.041952360077783, -6.206317645277816],
            [24.044639399857317, -6.206683676951812],
            [24.04732608031075, -6.207049707469117],
            [24.050012759865854, -6.207415737728745],
            [24.052699440319284, -6.207781589729467],
            [24.055386480098822, -6.208147619473808],
            [24.058073519878391, -6.20851418655935],
            [24.059651039670733, -6.207356076703705],
            [24.061228919687508, -6.20619814316912],
            [24.062373720109179, -6.203495990957966],
            [24.063518519632517, -6.200793823812467],
            [24.064663320054184, -6.198091821541095],
            [24.065808119577522, -6.195389268534774],
            [24.068336400096925, -6.195385506146352],
            [24.070864320391859, -6.195381742858864],
            [24.073392600012934, -6.195377980470353],
            [24.075920879634008, -6.195374039177321],
            [24.077754359993513, -6.193379365294019],
            [24.079587480128584, -6.191384682876207],
            [24.081420959589796, -6.189389993724436],
            [24.083605799802992, -6.18927210058721],
            [24.085791000240654, -6.189154027617683],
            [24.088089600406512, -6.190299456741248],
            [24.090388199674042, -6.191444884247272],
            [24.092917920192825, -6.190291574078367],
            [24.095448000037713, -6.189138260459094],
            [24.097864319929975, -6.190973670310171],
            [24.100281000046671, -6.192809072799955],
            [24.102807480342193, -6.192728805412811],
            [24.10533395973945, -6.192648538013263],
            [24.107860440035005, -6.192568091695848],
            [24.108890399830734, -6.189961544101708],
            [24.109920359626496, -6.187355163282778],
            [24.110950320320555, -6.184748768540905],
            [24.111980640340725, -6.182142181871527],
            [24.113010600136484, -6.179535761996238],
            [24.114040920156651, -6.176928791481719],
            [24.114940433793365, -6.175784668107729],
            [24.115759920114659, -6.174742330335788],
            [24.139222200452, -6.145881906298227],
            [24.140501280143997, -6.141069889588298],
            [24.139124279594427, -6.136240984721616],
            [24.139763545005128, -6.129442899692467],
            [24.139816199755526, -6.128882953129462],
            [24.141306918935197, -6.127392859599016],
            [24.142803479859193, -6.125896921060603],
            [24.155283032991363, -6.119887355788181],
            [24.155676179777135, -6.119698034047014],
            [24.162342479584247, -6.113954951550806],
            [24.166248480203734, -6.113038009157216],
            [24.172685280218651, -6.107063955781609],
            [24.173977437584593, -6.10448153549868],
            [24.174755279805943, -6.102926985780566],
            [24.168325320461921, -6.087976925409282],
            [24.163271280095834, -6.085213951303873],
            [24.160976280377643, -6.075094869343601],
            [24.157072440206409, -6.070263928396749],
            [24.156114002476951, -6.067864887128638],
            [24.154775280039967, -6.064513946089182],
            [24.152212755741939, -6.0626797465945],
            [24.15156037582641, -6.062212864229247],
            [24.145355159695089, -6.062437951481263],
            [24.139839239745918, -6.065882944389589],
            [24.132387240153676, -6.063694947295216],
            [24.130654065678804, -6.063185221375743],
            [24.130418399850534, -6.063115912195163],
            [24.124671827570687, -6.064261845602746],
            [24.118929323760728, -6.065406840434902],
            [24.117735399866081, -6.06155294483833],
            [24.116863319879826, -6.058737915113452],
            [24.111812343667207, -6.051375129689201],
            [24.108143299755024, -6.049536373352607],
            [24.106298400011614, -6.048611879121201],
            [24.095499479791712, -6.048832853471525],
            [24.093113399886843, -6.050832913263682],
            [24.08837328028838, -6.054805948996334],
            [24.080330519819217, -6.055259004587644],
            [24.075964439840426, -6.05732499150998],
            [24.074656762281364, -6.057193009903306],
            [24.071367240407039, -6.056861005444509],
            [24.066774360073534, -6.051797993659363],
            [24.063711785877686, -6.05004388214816],
            [24.061950360285429, -6.049035010565364],
            [24.057819360433374, -6.037304943436683],
            [24.055752239946546, -6.035923864484436],
            [24.052307400257938, -6.035460934469757],
            [24.041275200135154, -6.039819946233149],
            [24.037530587246341, -6.039816608095864],
            [24.03001619965762, -6.039809909339096],
            [24.024502440156663, -6.037275909058831],
            [24.016464359910145, -6.028760870807426],
            [24.008653440242746, -6.024614868178563],
            [24.0041436280219, -6.02673942389859],
            [23.996473200373362, -6.030352914063909],
            [23.993026247847208, -6.029007540095205],
            [23.9923382398492, -6.028739005195978],
            [23.989582440322867, -6.025516907746131],
            [23.989867560204146, -6.025357742125026],
            [23.997396239989062, -6.021154912489386],
            [24.002569800305366, -6.006168325486906],
            [24.005361599816712, -5.994751878114728],
            [24.007764600388242, -5.979663463968312],
            [24.012321479838441, -5.970461011574625],
            [24.015178080221109, -5.961308948719404],
            [24.015201839762074, -5.952240799920305],
            [24.011348759794263, -5.946404768737946],
            [24.005002679741587, -5.942626497138128],
            [23.99821127964972, -5.943111733059215],
            [23.996848856062247, -5.943237575169054],
            [23.989161959599649, -5.943947586723775],
            [23.981488560324141, -5.943325581250126],
            [23.976267480027612, -5.939230367830012],
            [23.974959240123166, -5.933480956093256],
            [23.973255000383567, -5.913249800128895],
            [23.972814462974988, -5.908858912496116],
            [23.972811814741547, -5.908832937614876],
            [23.972064417323462, -5.901383226516573],
            [23.970493377079251, -5.886126932340982],
            [23.968888857522749, -5.88015681448635],
            [23.966698976862475, -5.878665798490101],
            [23.964509457324933, -5.877174778445808],
            [23.962896296873684, -5.874341524712829],
            [23.961283137320766, -5.871508256373928],
            [23.959669976869517, -5.868674973436052],
            [23.959128176870525, -5.866070255107875],
            [23.958586737095974, -5.863465883382935],
            [23.95804493709695, -5.860861498440092],
            [23.957503497322396, -5.858257102083842],
            [23.956961697323408, -5.855652692520376],
            [23.956420257548817, -5.853048270654717],
            [23.958027296879713, -5.850363876763716],
            [23.959634697333374, -5.847679469815152],
            [23.961241737562567, -5.844995049814901],
            [23.959395657432903, -5.842928434116878],
            [23.957549937527642, -5.840861989712411],
            [23.955912297086591, -5.832430113474414],
            [23.955644817422542, -5.823085156715526],
            [23.957540162060727, -5.815996093535777],
            [23.958849891371926, -5.816259751887857],
            [23.960985479653058, -5.816689972466839],
            [23.962069224279805, -5.817631268646916],
            [23.964430320239963, -5.819682016343556],
            [23.97155040041957, -5.82129797859703],
            [23.973597560340757, -5.823625855898272],
            [23.974992360109386, -5.825211912608553],
            [23.982833788360441, -5.82757418985659],
            [23.98647722130384, -5.828671792099707],
            [23.988940533865264, -5.82752933232586],
            [23.992910279835616, -5.825687929445582],
            [23.998193280106374, -5.825922980156651],
            [24.000388760864123, -5.827645895145342],
            [24.003475199703828, -5.830067985582287],
            [24.006234145130264, -5.830990780689159],
            [24.007610160227987, -5.831451021195083],
            [24.011287200044503, -5.827314990971334],
            [24.011291930572785, -5.827285760063051],
            [24.012982799787682, -5.816837530541959],
            [24.024205800280203, -5.812078879139644],
            [24.030715319815691, -5.812304970520685],
            [24.041561399791416, -5.813988548079277],
            [24.049878839921629, -5.81443588815174],
            [24.055314119904388, -5.810109856542771],
            [24.057856440193333, -5.805643580542784],
            [24.062211000176909, -5.799616472897749],
            [24.06655619971523, -5.797509882569491],
            [24.071620320077116, -5.797131201679647],
            [24.079574520133992, -5.79831852449363],
            [24.087529080415308, -5.799149219090221],
            [24.095126519946984, -5.798224929776622],
            [24.101641800378388, -5.795956067963031],
            [24.10924067990948, -5.794319054034151],
            [24.116480640263738, -5.791639755089572],
            [24.125163840241676, -5.790277777582782],
            [24.136739639689004, -5.789412464780727],
            [24.143972400046259, -5.789584594464771],
            [24.157350720315126, -5.791079077713648],
            [24.166024559847809, -5.793637889482116],
            [24.173971559907685, -5.797676452417],
            [24.179030639822489, -5.799436277090374],
            [24.187721400021868, -5.798707962953499],
            [24.190250400091781, -5.786982014422832],
            [24.199672319762144, -5.776408942017365],
            [24.199377185462083, -5.774928873481284],
            [24.198984360273176, -5.772958892805491],
            [24.192325440126151, -5.766975003419537],
            [24.190029359734648, -5.76076493880625],
            [24.19508735987451, -5.749958977919993],
            [24.194168280032585, -5.748348009735429],
            [24.183603360164405, -5.745580983965062],
            [24.18245640019278, -5.739677675218306],
            [24.180162480249567, -5.727870871949702],
            [24.177406169581818, -5.726731483146446],
            [24.176260440302151, -5.726257867276827],
            [24.175342440235198, -5.721426895025507],
            [24.173813054870731, -5.719785403835311],
            [24.172126200226863, -5.71797489481119],
            [24.173966046048466, -5.712958777174852],
            [24.174656280071751, -5.711076927377985],
            [24.174288359775773, -5.708860973824825],
            [24.173740440453056, -5.705557022333183],
            [24.170984334601211, -5.701645018401384],
            [24.173053199616298, -5.697736959350702],
            [24.171299227345962, -5.693870309562343],
            [24.170757480347564, -5.692676018088322],
            [24.172257418038718, -5.689374343337515],
            [24.173055360064552, -5.687617900420203],
            [24.170534302000078, -5.676576776238772],
            [24.170902631927799, -5.675103664495711],
            [24.172374240348152, -5.669218023938677],
            [24.171676866515003, -5.668130832253989],
            [24.170307480085764, -5.665995980330939],
            [24.170307561832466, -5.665966462962513],
            [24.170322959854747, -5.66037897064525],
            [24.160936679944964, -5.65323890398969],
            [24.150101759740014, -5.646920161827031],
            [24.146143199591585, -5.638661141081763],
            [24.139653119598822, -5.630235023895934],
            [24.128468639764002, -5.61895146278089],
            [24.124789080173134, -5.613015810722454],
            [24.11474580031231, -5.610353051337197],
            [24.102824760335025, -5.604471298231366],
            [24.092704079832696, -5.602019787079007],
            [24.083309159926497, -5.598444559275096],
            [24.071380559727771, -5.595771867629329],
            [24.065964720186063, -5.591899034964218],
            [24.06236940011097, -5.582899153971209],
            [24.061307400103964, -5.573353308236331],
            [24.060624119939312, -5.556648821896029],
            [24.057406079707121, -5.541202927572597],
            [24.055985159624996, -5.530613640526265],
            [24.053122800143029, -5.517636155782096],
            [24.049191599983168, -5.497964163847105],
            [24.046339679823141, -5.480706586987366],
            [24.04456524033737, -5.466576948737911],
            [24.045332399793367, -5.448334577803513],
            [24.045363000005192, -5.435495580505786],
            [24.045090122364588, -5.426516133336964],
            [24.045027840369329, -5.424466618383651],
            [24.048673560423438, -5.412426421588891],
            [24.051217680037933, -5.407243681616222],
            [24.057027720089241, -5.397537451428061],
            [24.0647997597728, -5.390039805881258],
            [24.065620560329378, -5.38764104928695],
            [24.066441359987625, -5.385242103931048],
            [24.068168999942046, -5.388056243900829],
            [24.069896639896466, -5.390870549824053],
            [24.07162391962645, -5.39368466336728],
            [24.073351559580871, -5.396498942848683],
            [24.073848000047889, -5.39870998653854],
            [24.074344080290505, -5.400921022057845],
            [24.074840519859226, -5.403131870244081],
            [24.075422279617001, -5.405713395566695],
            [24.076004040273105, -5.408294551421293],
            [24.076585439806447, -5.41087569522089],
            [24.077167199564258, -5.413457007916947],
            [24.077748960220326, -5.416038129390525],
            [24.080509079744871, -5.416264376486384],
            [24.082342199879943, -5.414268520834836],
            [24.084175680239447, -5.412272658506388],
            [24.086008800374554, -5.410276790403757],
            [24.087499199753989, -5.410044440690713],
            [24.088989239807354, -5.409812091787502],
            [24.08960988044727, -5.41257049578044],
            [24.090230159964417, -5.415328887023896],
            [24.090850799706001, -5.418087265511509],
            [24.09377832028375, -5.418427800812609],
            [24.096705479738738, -5.418768335919176],
            [24.099633000316459, -5.419108691676756],
            [24.10256051999588, -5.419449047240006],
            [24.105473999905698, -5.420824460462674],
            [24.108387479815555, -5.422199691357056],
            [24.118478639880998, -5.411127242303215],
            [24.120302040244709, -5.404928784442773],
            [24.120686159860213, -5.395628375240897],
            [24.123591720222521, -5.390418395551586],
            [24.125773320212485, -5.385619440678803],
            [24.126327357062301, -5.37155395563865],
            [24.134923763614115, -5.375382640589837],
            [24.143651602675153, -5.379690579197332],
            [24.149208554971548, -5.381102503128945],
            [24.157696282441982, -5.375245734058775],
            [24.163691727581426, -5.371699457703469],
            [24.172934361487378, -5.374401332823669],
            [24.182812760967675, -5.377734973545924],
            [24.19570976121237, -5.380532461972362],
            [24.226402999886492, -5.386870408182806],
            [24.238055105827296, -5.389020118974883],
            [24.249814159795942, -5.393632987258479],
            [24.256620678534059, -5.396271072215227],
            [24.277039879015501, -5.404185436464952],
            [24.277059983311542, -5.4041951461591],
            [24.285117931597235, -5.408086784264236],
            [24.296770037538039, -5.410236594388826],
            [24.305296982758819, -5.410459437899764],
            [24.316762276849765, -5.408299034865379],
            [24.325235597139685, -5.407290329321492],
            [24.339083715640886, -5.4039620558375],
            [24.352771274658103, -5.396939248090673],
            [24.360528915245986, -5.39345176701972],
            [24.370113554848579, -5.390011992373632],
            [24.382780138121245, -5.381600974706783],
            [24.390923009540604, -5.378869688335125],
            [24.401276952877804, -5.379140267515964],
            [24.411630897113334, -5.379411026641518],
            [24.416423233084316, -5.377691011942296],
            [24.421637832036055, -5.37167666457014],
            [24.423646632097984, -5.36188785595294],
            [24.423801432482708, -5.351435149131512],
            [24.430763112728254, -5.34362093546889],
            [24.436164541496158, -5.341916801423349],
            [24.439979112484362, -5.345707103970724],
            [24.443398031285426, -5.35440789002503],
            [24.449440631689075, -5.367482787166625],
            [24.455376311912627, -5.378094191262253],
            [24.460408751389409, -5.381916217111687],
            [24.479041271042693, -5.390706551803579],
            [24.484880485679472, -5.39208939215673],
            [24.489475150965447, -5.392824491186473],
            [24.494652309932789, -5.392959780345278],
            [24.499511212862952, -5.392779281954167],
            [24.507533109959663, -5.388376159175171],
            [24.513436749073673, -5.384224924377259],
            [24.518493668540223, -5.381589298325387],
            [24.522847869197697, -5.376782556945754],
            [24.542342947593536, -5.356379361222483],
            [24.547610828319716, -5.351596283864109],
            [24.552507564696402, -5.345265683459679],
            [24.55639698690732, -5.33675587059105],
            [24.557281147437507, -5.329090047329187],
            [24.555568987252069, -5.317665422570228],
            [24.554863746871973, -5.308419835969978],
            [24.553629667385774, -5.301005965736072],
            [24.546046267623669, -5.273432770315432],
            [24.542693587896682, -5.266270621354676],
            [24.539207707776011, -5.256028759595321],
            [24.53700666824329, -5.247358335043742],
            [24.534156548307053, -5.237748076972826],
            [24.529014307753112, -5.224386468521284],
            [24.528429307772107, -5.217911326347495],
            [24.527857628010132, -5.211743922473236],
            [24.523431428280958, -5.200861482285282],
            [24.521005748841773, -5.194030177579606],
            [24.51818226844529, -5.185035090969913],
            [24.516988508942347, -5.178543564107018],
            [24.516470109158181, -5.173607789854888],
            [24.515938748481098, -5.168363970052359],
            [24.51799434897271, -5.164959008137729],
            [24.52235431950924, -5.164040009101811],
            [24.530773268368236, -5.164845928099794],
            [24.531456959062993, -5.164910848656755],
            [24.531994370791828, -5.16496187850463],
            [24.540027444727293, -5.163353990023976],
            [24.554258208708593, -5.165197011676274],
            [24.559311094739545, -5.17210083383254],
            [24.561145370108083, -5.172330874814044],
            [24.559723746645091, -5.167970703881748],
            [24.560396946813949, -5.162450777063288],
            [24.561957185715155, -5.156338646988773],
            [24.563544065952787, -5.150842489867461],
            [24.565780025695542, -5.146286135551685],
            [24.568862705984092, -5.140213696922494],
            [24.572554506019049, -5.134157176118697],
            [24.575914745967442, -5.12747646467346],
            [24.578944146278175, -5.12017172205763],
            [24.578279225881303, -5.111847472694241],
            [24.576529625711437, -5.106571185086264],
            [24.575455746383149, -5.102851027926595],
            [24.575134985842958, -5.095458578655621],
            [24.577913466033575, -5.089377573151736],
            [24.580691855494354, -5.085665961524297],
            [24.581076064941403, -5.085152699116292],
            [24.583047425018904, -5.08151212167679],
            [24.584701264779479, -5.077555573625915],
            [24.584527385076438, -5.07355106962711],
            [24.583718105413404, -5.068914451438768],
            [24.583213385174403, -5.064285878730391],
            [24.581212560355539, -5.060233719341748],
            [24.577344720169318, -5.055209413370906],
            [24.575608440218513, -5.050240720969419],
            [24.575367960318626, -5.044695889028855],
            [24.580013400181077, -5.039586364449643],
            [24.589082519998335, -5.038285144842999],
            [24.594139080138785, -5.035648048094144],
            [24.601672440146306, -5.033998892103324],
            [24.61366655986863, -5.030004707381209],
            [24.630068160226173, -5.022433138663655],
            [24.637839120134789, -5.019251630719447],
            [24.64682796021004, -5.016101884882902],
            [24.651262439711189, -5.013140636657043],
            [24.659351280161165, -5.010275066827512],
            [24.666088319601943, -5.004296845331471],
            [24.675037199918414, -5.000222760976772],
            [24.683063399945318, -4.999999953011676],
            [24.687191519798581, -4.999925264462298],
            [24.692050439796756, -4.999744648332701],
            [24.698141279731136, -4.999904079312178],
            [24.702708959625969, -5.000023472344541],
            [24.708813119779414, -5.000490812040492],
            [24.71304959981212, -4.999986308248739],
            [24.717775320314907, -4.996724794448355],
            [24.727726079989665, -4.980675524598761],
            [24.730306559813577, -4.977050335337633],
            [24.732873720316757, -4.973116843822507],
            [24.735400559938416, -4.96825919672393],
            [24.738814800313495, -4.962809181102434],
            [24.745180319908961, -4.955282072627488],
            [24.748818839966066, -4.94799134991481],
            [24.756797880237187, -4.935582300018336],
            [24.761192399979553, -4.931696500310182],
            [24.764382000448165, -4.928086839346994],
            [24.771345840243665, -4.927345799429554],
            [24.779052719729791, -4.929701610250635],
            [24.791142960085807, -4.934941999997199],
            [24.795790919722617, -4.936910120706242],
            [24.799445279773146, -4.937005824398629],
            [24.805509119943366, -4.936548853399333],
            [24.814447199815195, -4.939244709105187],
            [24.820420320023178, -4.943709526751705],
            [24.827955839580653, -4.94913833591395],
            [24.833266560064413, -4.952354661018171],
            [24.840404280461257, -4.95561891129582],
            [24.844289399741974, -4.954947927610049],
            [24.844346718545307, -4.954845577572122],
            [24.848279279652807, -4.947823467855347],
            [24.848259699074539, -4.947777229060964],
            [24.845907240415837, -4.94222191619328],
            [24.845429159716563, -4.938208671661292],
            [24.844646519593287, -4.934187321687969],
            [24.843545999826908, -4.929850104280074],
            [24.842445119836096, -4.92551267888011],
            [24.84015083966845, -4.914681021494835],
            [24.838123319614336, -4.910011482296111],
            [24.833937240458912, -4.904669977408361],
            [24.830002439851416, -4.898103783520072],
            [24.826492439965346, -4.894318680174597],
            [24.824464919911232, -4.889649176955045],
            [24.822119520214024, -4.884663415913915],
            [24.822952919642425, -4.882838437377504],
            [24.825560400128861, -4.87982899784922],
            [24.828445440275104, -4.876210972141045],
            [24.832799640034246, -4.871400374975595],
            [24.836531399827955, -4.866265788086914],
            [24.841176839690437, -4.861154866934373],
            [24.846551639698383, -4.858833111022955],
            [24.852933360409967, -4.858692322346809],
            [24.857845919712062, -4.859744287730211],
            [24.863963039860096, -4.86051988220528],
            [24.871960800123428, -4.862575857726777],
            [24.879931919948671, -4.864015521943629],
            [24.895252079858192, -4.866570887226659],
            [24.907737599600484, -4.866897535204045],
            [24.920461080366572, -4.865691325703926],
            [24.927676199608296, -4.863725685750069],
            [24.933633119598454, -4.860803614122054],
            [24.938847720346821, -4.854784341374546],
            [24.946431480333359, -4.847287784721452],
            [24.948787679576913, -4.845502749939825],
            [24.953553359838484, -4.843165136924126],
            [24.961668479603784, -4.840914972034181],
            [24.972511320254572, -4.838428468897851],
            [24.978853080309076, -4.837363180374139],
            [24.983734158152021, -4.83528707382189],
            [24.984121456006989, -4.840677601396413],
            [24.984428345660895, -4.844949937368858],
            [24.986726368210022, -4.850010012898821],
            [25.000000122783185, -4.862310978785693],
            [25.003251415952228, -4.865323929962594],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kananga",
        AREA: 60958,
        POPULATION: 3317000,
        DISTRICTS: ["Luiza", "Kazumba", "Demba", "Dibaya"],
        OBJECTID: 9,
        NOM: "Kasaï-Central",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [22.919164548084371, -4.526404199981984],
            [22.94180890786393, -4.527059436970744],
            [22.957043746686097, -4.526326227370488],
            [22.981109746098298, -4.524456996190168],
            [22.983492560627081, -4.524292832332991],
            [22.990443106254702, -4.523813975040512],
            [22.998771345931257, -4.522185130322375],
            [23.010979667136439, -4.517994065881036],
            [23.026663066221001, -4.515251633926811],
            [23.044924786477811, -4.517976277953595],
            [23.058738344993408, -4.519767731252363],
            [23.060893097034523, -4.52065601147984],
            [23.066002621844099, -4.522762374740284],
            [23.074375081988872, -4.526213844058692],
            [23.07734132265028, -4.534963820133076],
            [23.085369344460567, -4.534519954548546],
            [23.088579461551955, -4.535676973311587],
            [23.097049193072301, -4.544897890526619],
            [23.10092244021822, -4.56170143945194],
            [23.108186160113437, -4.580583689765683],
            [23.116006440226094, -4.601643816938792],
            [23.126058720307732, -4.629751087925581],
            [23.129248819341331, -4.63875938110024],
            [23.132759759763466, -4.648673541693357],
            [23.142832199836729, -4.66845302635557],
            [23.153457599679758, -4.692075326117563],
            [23.16687984037948, -4.721591240153079],
            [23.179186439971684, -4.747305219286271],
            [23.188694040055541, -4.768233829871975],
            [23.187738251457855, -4.784818770110326],
            [23.182309177935405, -4.786078235968515],
            [23.180853174149835, -4.786416004042684],
            [23.179067482366815, -4.788125993272276],
            [23.175338400450954, -4.791696971742451],
            [23.170509360215771, -4.79904993641751],
            [23.167738016241763, -4.799550017853187],
            [23.165460360296763, -4.799961014291739],
            [23.163938137200056, -4.799262997776467],
            [23.162939279774395, -4.798804970426542],
            [23.160646439606126, -4.796960001069248],
            [23.153991635539736, -4.797637952970721],
            [23.152377130310533, -4.796597342827993],
            [23.148262440270742, -4.793944965892719],
            [23.142528359963233, -4.793013945217711],
            [23.135874371567105, -4.794151098018852],
            [23.131275314417724, -4.799893828637471],
            [23.122558440193053, -4.798956008842401],
            [23.119802280442286, -4.80033097638599],
            [23.116115159731642, -4.809986923038407],
            [23.107050359912591, -4.819845485866066],
            [23.089063320215129, -4.818417938519709],
            [23.076685800427907, -4.822118887771405],
            [23.06205396023179, -4.828207954659697],
            [23.040096119941818, -4.841503284068066],
            [22.97482992039108, -4.862479245767372],
            [22.953794641813051, -4.870844854613612],
            [22.942314360229894, -4.875190996838446],
            [22.933868223858813, -4.89029588776446],
            [22.931265240338714, -4.894950938442359],
            [22.924126440166894, -4.906219623053778],
            [22.925781719926889, -4.919409961586782],
            [22.93364339979771, -4.923259382802488],
            [22.948263359774181, -4.922164962975987],
            [22.959509400257122, -4.921323003577031],
            [22.970183760079756, -4.924407130217501],
            [22.97466360001118, -4.931838171692654],
            [22.967899920132343, -4.93900141028105],
            [22.957759800087256, -4.947526844698212],
            [22.944813479638523, -4.954043167601865],
            [22.925958839853131, -4.963458610881065],
            [22.921160760054242, -4.970791175080254],
            [22.914386639955172, -4.982392325432676],
            [22.912073279570873, -5.009190487594919],
            [22.905082440011213, -5.029709019991961],
            [22.90944096066686, -5.030868966693301],
            [22.91379948042421, -5.032028912200826],
            [22.928240031567103, -5.04172391404326],
            [22.945678199727659, -5.042913008548106],
            [22.948460493266655, -5.044314476455439],
            [22.951181256700291, -5.045685036924271],
            [22.951933500529318, -5.046752027379854],
            [22.956217199606652, -5.052828029431266],
            [22.960560239595022, -5.06365001648878],
            [22.964683319899535, -5.067569850139897],
            [22.967169444279282, -5.068995109572957],
            [22.970546279704219, -5.070930995412706],
            [22.977981360426426, -5.075190970798113],
            [22.983643921362589, -5.08088924859889],
            [22.99493447965606, -5.092250869319007],
            [23.011496661955476, -5.102556811884488],
            [23.015339280143493, -5.104947885347974],
            [23.024973239950132, -5.107958970391487],
            [23.026506119761077, -5.116543734344843],
            [23.042203919737936, -5.134778970861364],
            [23.078659607516236, -5.168089009792047],
            [23.079228480042953, -5.168608799171195],
            [23.111739720205929, -5.208874050935929],
            [23.115574455677315, -5.211222243665071],
            [23.1211985381766, -5.214666225807381],
            [23.127449759728542, -5.222115387124251],
            [23.133619080079413, -5.228307633975986],
            [23.142036599718828, -5.234886042875747],
            [23.150448360258949, -5.243682630474672],
            [23.158272960369779, -5.263057868489556],
            [23.175047879898187, -5.301167834226908],
            [23.185148040184455, -5.309282816230695],
            [23.194805400205951, -5.302207942076327],
            [23.196819239816634, -5.300616914439133],
            [23.219195692334061, -5.292027845731577],
            [23.227829280155504, -5.288713862344937],
            [23.229611426288077, -5.288346615265913],
            [23.239999440029091, -5.286205953185848],
            [23.245289530702376, -5.283920828475482],
            [23.246891279854566, -5.283228929872786],
            [23.252865479837489, -5.279098867755325],
            [23.256207308814169, -5.274759234059389],
            [23.259765240108834, -5.270138938336747],
            [23.264013240136787, -5.269572466023233],
            [23.268261240164701, -5.26900599408678],
            [23.274632084074863, -5.264587519159001],
            [23.276533319864647, -5.263268918237141],
            [23.285257200050246, -5.262364957568479],
            [23.296741264439046, -5.258014863047241],
            [23.298099911509048, -5.25704098678544],
            [23.305704480070823, -5.251590012389882],
            [23.306771604966503, -5.251170017428065],
            [23.306896440248281, -5.251120884869782],
            [23.307607105554382, -5.250841190322747],
            [23.314432320030196, -5.24815499828797],
            [23.320860480048694, -5.247705967944937],
            [23.327514359748672, -5.24955790013931],
            [23.335107998508395, -5.249141946253252],
            [23.343814763092862, -5.248665019203088],
            [23.354135563985981, -5.253553229059688],
            [23.359415400390301, -5.256053887601003],
            [23.362131490787803, -5.256382152698708],
            [23.369055480418996, -5.25721897981246],
            [23.377677185325833, -5.260043713612729],
            [23.378233319741806, -5.260225920157181],
            [23.382595439946822, -5.260003024949749],
            [23.387190260641326, -5.256560145016018],
            [23.395456440206505, -5.255653857444722],
            [23.42049839988611, -5.239592862692794],
            [23.423561177999531, -5.239788999442713],
            [23.424171542810914, -5.239828114397808],
            [23.424578563177924, -5.240471433705484],
            [23.427377279716957, -5.244894946626943],
            [23.427602279847857, -5.248344875446832],
            [23.422771458253493, -5.257768918389129],
            [23.423914422518727, -5.26145196797289],
            [23.425378937841565, -5.262577667188113],
            [23.431711320382831, -5.267444849558239],
            [23.432398200096824, -5.269746993008627],
            [23.426885520370881, -5.271577861944801],
            [23.426191450541321, -5.276406987649391],
            [23.429857319807294, -5.281933958901003],
            [23.431686470287126, -5.2874579041555],
            [23.430530159751715, -5.294357023930128],
            [23.432819400370615, -5.299191876639362],
            [23.437185321347584, -5.296208027246216],
            [23.438099519744249, -5.301039884790085],
            [23.435795159580803, -5.307016891642992],
            [23.451630840173991, -5.310413352736852],
            [23.466250800150462, -5.309319423530923],
            [23.477496839735075, -5.308478160111655],
            [23.486489639584132, -5.3094685468192],
            [23.503890600423912, -5.320918090043504],
            [23.521860360128574, -5.329552838211773],
            [23.546581920390757, -5.336019083296763],
            [23.569621919781, -5.340393696256193],
            [23.588729640134762, -5.343399329506996],
            [23.612337360411509, -5.345513850067795],
            [23.637062880447463, -5.350316534504683],
            [23.676412320233663, -5.352362127044902],
            [23.694396840156767, -5.354897396221515],
            [23.704578324027402, -5.359161863341913],
            [23.709254400034293, -5.37509609128886],
            [23.708976840374451, -5.377891079168449],
            [23.708698919591839, -5.380686054942822],
            [23.708421359931997, -5.383481016804633],
            [23.708143800272119, -5.386275966547883],
            [23.707866239713979, -5.389070903265515],
            [23.707588680054101, -5.391866005213217],
            [23.707310760169825, -5.394661095020626],
            [23.703192720312359, -5.437943483591853],
            [23.707062359824096, -5.465367948771145],
            [23.71488407993613, -5.485844733185517],
            [23.716345938940684, -5.49513818032226],
            [23.720504400291013, -5.521573884017921],
            [23.718047150459466, -5.531569694602337],
            [23.71750849186899, -5.533760872817453],
            [23.717567887577278, -5.534441275008419],
            [23.718191400131147, -5.541581958664005],
            [23.714279301747499, -5.550316954607485],
            [23.714708736877515, -5.551179127691043],
            [23.717718359878955, -5.557220850544846],
            [23.71885343963093, -5.571252874563099],
            [23.723900279999981, -5.577699980222317],
            [23.727562200271951, -5.592193910987325],
            [23.732374319840439, -5.604159927178141],
            [23.743860915681722, -5.608510883468113],
            [23.748214320431835, -5.610159881454192],
            [23.749339807074907, -5.611190187579388],
            [23.749952399708192, -5.611750974663826],
            [23.753494439805472, -5.614995922768197],
            [23.756244570064055, -5.621669024240168],
            [23.758402319783251, -5.625014933812748],
            [23.75586339602437, -5.626808649273285],
            [23.755583118960772, -5.627006661611504],
            [23.745670062476819, -5.634079820896701],
            [23.742718719476077, -5.633799302431975],
            [23.742276804950144, -5.633757272392412],
            [23.725192679911039, -5.631995729224085],
            [23.709096000100267, -5.628672858597437],
            [23.691832559652347, -5.627717441872146],
            [23.683002479735595, -5.628210126081324],
            [23.675707800302401, -5.628617258719112],
            [23.665291200372451, -5.636873554378283],
            [23.659891199925866, -5.641012418083327],
            [23.647608359874589, -5.641314084099041],
            [23.638000320057166, -5.64338520810478],
            [23.630359320319009, -5.652095933068367],
            [23.615503200440859, -5.657767006907813],
            [23.612148677370929, -5.659046838182463],
            [23.611747477188615, -5.659199905409778],
            [23.604969240110613, -5.668109506685548],
            [23.589899279872341, -5.687917927431104],
            [23.58093816001012, -5.692275028551244],
            [23.576803200384258, -5.691578855913887],
            [23.571525239662282, -5.68812201060563],
            [23.566702311564281, -5.688344915115191],
            [23.561884440083041, -5.683507888933434],
            [23.553188655606299, -5.681470265135518],
            [23.552009279927645, -5.681193909354387],
            [23.547416431933499, -5.680957007281621],
            [23.538912479990724, -5.686233970958619],
            [23.531998762594842, -5.686085833237332],
            [23.527429199831161, -5.685987923003685],
            [23.519623319712508, -5.682755931866041],
            [23.510206280589077, -5.68228198854478],
            [23.504562359695058, -5.683832308032691],
            [23.498351280259914, -5.694539107837952],
            [23.494817159710145, -5.706631202831262],
            [23.491684799891448, -5.716014866176654],
            [23.483889359993032, -5.734099411924094],
            [23.478465960229919, -5.741691954304637],
            [23.472300599652819, -5.74548899460429],
            [23.465768759677452, -5.746620838706702],
            [23.457322800274465, -5.747092081862288],
            [23.448502800353506, -5.746049537695299],
            [23.439685320206873, -5.744623074512467],
            [23.429327400027919, -5.744049977332475],
            [23.424699959708814, -5.747377552407944],
            [23.421961800399714, -5.755203740808486],
            [23.419231200413726, -5.761878463092661],
            [23.416899480261648, -5.766228896113642],
            [23.406879599717357, -5.772542719117852],
            [23.403790439880677, -5.775400700146189],
            [23.397997274681977, -5.781916872696232],
            [23.394549581045723, -5.783289949581736],
            [23.390972502160761, -5.779510376904526],
            [23.381470079966206, -5.76946991270053],
            [23.382159839679023, -5.768089949530045],
            [23.388368818853053, -5.768330005450628],
            [23.393890080184939, -5.76051999854419],
            [23.393352507657653, -5.759717513738737],
            [23.391820079699315, -5.757429912211018],
            [23.391923810860117, -5.756594344644082],
            [23.392180080447751, -5.754530059525236],
            [23.396359927091712, -5.75127977903811],
            [23.394413620129125, -5.747634408562687],
            [23.393679998375966, -5.746260350800838],
            [23.395476919100034, -5.743794019308067],
            [23.401039796684049, -5.736158720715903],
            [23.400949808848775, -5.735694777325016],
            [23.400591134013723, -5.733845574664057],
            [23.405931373137737, -5.73118866300833],
            [23.407480080365676, -5.730419930634221],
            [23.409290458750995, -5.730797096387673],
            [23.412996942647574, -5.731569287932748],
            [23.414283083097725, -5.728994706440447],
            [23.414370119967298, -5.728820023437803],
            [23.413286731073406, -5.726499635388326],
            [23.412539879831023, -5.724900034695436],
            [23.409560159948764, -5.72329007005278],
            [23.410249719337262, -5.721450563478933],
            [23.412224515470765, -5.720640021860855],
            [23.414150907681794, -5.719849345915246],
            [23.418059660739289, -5.715930506003414],
            [23.415779880278652, -5.709729996543222],
            [23.416153393485597, -5.708675091674352],
            [23.416919999579381, -5.706509976201111],
            [23.422209839622706, -5.703069899472911],
            [23.42512008020763, -5.698559912002736],
            [23.425179204624659, -5.698468356798708],
            [23.426357616411021, -5.696641427587056],
            [23.423831279845906, -5.698221513291263],
            [23.421990160213216, -5.698469849634731],
            [23.420683068355693, -5.699533668431097],
            [23.412414179471639, -5.706260092978996],
            [23.407808849386591, -5.706961317205313],
            [23.402373431961607, -5.707788006026447],
            [23.402360160251586, -5.707790024336348],
            [23.39438015968144, -5.713839907823766],
            [23.393842599730583, -5.713838743461271],
            [23.381550000382077, -5.713810050113509],
            [23.374879919565977, -5.719320011776522],
            [23.367237643321843, -5.72332403305529],
            [23.365680120027726, -5.724140063197529],
            [23.358800160421868, -5.722980020003427],
            [23.35479083378177, -5.724580847168963],
            [23.3531465143666, -5.725237382670391],
            [23.347498198914209, -5.724893559743054],
            [23.337669960461039, -5.72428997796175],
            [23.334228331351255, -5.72408197750303],
            [23.33168999958216, -5.726840128092271],
            [23.320660830375118, -5.725670139589777],
            [23.312160000077956, -5.72978997469675],
            [23.306400720230101, -5.730974032749252],
            [23.297616360069721, -5.737250775570081],
            [23.290758720005414, -5.740320172842847],
            [23.282001000283085, -5.741705762205538],
            [23.277862440209589, -5.742079101767573],
            [23.272613280373925, -5.741932240164465],
            [23.264499959934113, -5.741868403164535],
            [23.255592839600247, -5.741455972853157],
            [23.242552920088805, -5.74043888093907],
            [23.238258119631208, -5.740318737703002],
            [23.228397360368113, -5.73971676685108],
            [23.217899760247313, -5.739259863540655],
            [23.205017880445499, -5.738410251317645],
            [23.195639159858825, -5.737006363121592],
            [23.174812799771491, -5.734303837443983],
            [23.167654560056917, -5.734103536534565],
            [23.157637919735858, -5.733007889029428],
            [23.147301959772353, -5.732066455773334],
            [23.137442280284237, -5.731301294058353],
            [23.133306600209533, -5.731185631619907],
            [23.129170559910399, -5.73106997005754],
            [23.124560399584087, -5.730451669826281],
            [23.116134239948291, -5.729400667380783],
            [23.108183280114645, -5.728688938941945],
            [23.101507079974819, -5.727686708365337],
            [23.094189719877349, -5.727482101385504],
            [23.085595799862233, -5.72805682966275],
            [23.078586959860903, -5.729654406766755],
            [23.07635171966869, -5.731059569396666],
            [23.074579799957274, -5.735086568733311],
            [23.075028720444099, -5.74031712440786],
            [23.079945599744402, -5.743063733320111],
            [23.083744319959386, -5.746594300163745],
            [23.083724880416632, -5.750181149908132],
            [23.082557040004573, -5.760095029625841],
            [23.079660840087524, -5.766047075409936],
            [23.077888920376104, -5.770073823832254],
            [23.072941439965682, -5.772870314284052],
            [23.064979320361257, -5.774278058006592],
            [23.056113599785562, -5.77351994646457],
            [23.045728319618011, -5.774391738480543],
            [23.034749040146902, -5.774736725931107],
            [23.022649080019491, -5.776354791690448],
            [23.006887920069019, -5.778359615288172],
            [22.995589680281572, -5.778858622966261],
            [22.989564705722103, -5.779323146953577],
            [22.989382559721836, -5.779337190551632],
            [22.980471120288094, -5.779740090244332],
            [22.976480880152828, -5.78207428458357],
            [22.974705359993777, -5.786753044515419],
            [22.970540879931068, -5.791854020234267],
            [22.966372440094585, -5.797770047226219],
            [22.959133200189164, -5.812404479020424],
            [22.955280839771927, -5.818655385734676],
            [22.952378519632848, -5.825747812854916],
            [22.95091727956753, -5.83108724419452],
            [22.950247319621869, -5.837263715461765],
            [22.950225719630865, -5.841175922712788],
            [22.954546393365298, -5.846835908942832],
            [22.956560323705819, -5.849085288688593],
            [22.966924320089369, -5.860660888607647],
            [22.978166399900214, -5.869193983534648],
            [22.984947359771848, -5.879606987207416],
            [22.985305917825944, -5.880157637572618],
            [22.986414359834789, -5.881859909502778],
            [22.987472312931402, -5.885411489712268],
            [22.987785213212856, -5.886461901304788],
            [22.987487681309315, -5.887398587067604],
            [22.986398159616968, -5.890827941028147],
            [22.965894360293639, -5.922517935310643],
            [22.958259712542858, -5.931323676961195],
            [22.954153320241389, -5.936059898898811],
            [22.952596788687334, -5.940859300882635],
            [22.951843200080322, -5.943182896172844],
            [22.950634733359532, -5.944990279989303],
            [22.948618320075568, -5.948006018120767],
            [22.951771200110294, -5.982734916984683],
            [22.956773305276521, -5.989271165683708],
            [22.958158319696768, -5.991080948827569],
            [22.958646480391806, -5.991717954735155],
            [22.960325795475537, -5.996875090526047],
            [22.963217399611569, -6.005755017836669],
            [22.970863573645744, -6.015071613891208],
            [22.973993279841086, -6.018885004888144],
            [22.976278185190456, -6.025328860880538],
            [22.975353359723961, -6.028545980927901],
            [22.967545829400144, -6.034627225435548],
            [22.955335201321347, -6.044137895702418],
            [22.955617440305502, -6.048176739408031],
            [22.95463067959346, -6.054015967846801],
            [22.956001920145443, -6.065136169267512],
            [22.959313919664773, -6.070443676614016],
            [22.964217479644347, -6.075632673753153],
            [22.971825000070147, -6.080897244955279],
            [22.982775120227107, -6.085929157697931],
            [22.99594931990724, -6.091512249501527],
            [23.003073359860618, -6.097903836965273],
            [23.010149491761556, -6.103119016455726],
            [23.007206159936523, -6.114369967269157],
            [23.004030239911373, -6.126610100608545],
            [23.004173160076448, -6.129547031611396],
            [23.004458279957731, -6.13558408337195],
            [23.004277919808228, -6.139489646789498],
            [23.00424660004586, -6.145191688119281],
            [23.004204840063256, -6.152848725958986],
            [23.005275480066643, -6.160699702602635],
            [23.008588560259248, -6.165843197578599],
            [23.013815399655069, -6.170062809830569],
            [23.020009199995744, -6.172028188909441],
            [23.026849199842818, -6.172219369017629],
            [23.033689199689853, -6.172410727968267],
            [23.041797120356478, -6.173452093116383],
            [23.054979599808558, -6.17756808261277],
            [23.062286879910236, -6.179564608749162],
            [23.06848176002589, -6.181367084418087],
            [23.077365480144891, -6.186014610442485],
            [23.083078343143725, -6.190642169060199],
            [23.083534230963874, -6.193401137784463],
            [23.072246293954432, -6.208093851448927],
            [23.070515658118524, -6.208831704258561],
            [23.068697399711503, -6.209606899291534],
            [23.068532547178787, -6.209677222113657],
            [23.067417240244527, -6.210152986896499],
            [23.06623428028789, -6.22992191280969],
            [23.060228400318124, -6.248762989587754],
            [23.053765320089553, -6.254106078867611],
            [23.053787323424125, -6.254238520600004],
            [23.054227559897111, -6.256888404328029],
            [23.054993639578129, -6.262285689619641],
            [23.057504640104735, -6.268546204597659],
            [23.061415680272969, -6.28071016408091],
            [23.064370199716553, -6.293172988290373],
            [23.065757999812465, -6.30119344749809],
            [23.065233840030711, -6.309812067231656],
            [23.066312399581644, -6.316194882761873],
            [23.066917560452573, -6.321912712352844],
            [23.067500399985327, -6.331702070524742],
            [23.069985839848787, -6.342684513561788],
            [23.071228920454136, -6.34809432813478],
            [23.074234200101174, -6.351272877911261],
            [23.077243440420283, -6.353800157358044],
            [23.082638400419857, -6.356394052930336],
            [23.085819720218158, -6.356483071832876],
            [23.089494240260315, -6.353654001432135],
            [23.09430743960375, -6.349527955819224],
            [23.0998284, -6.347009969795617],
            [23.107181399858053, -6.347484981039547],
            [23.11164965331891, -6.349901872694247],
            [23.11614036017032, -6.352330898470364],
            [23.119335885028224, -6.352505314851626],
            [23.12924040033047, -6.353045915648377],
            [23.141184234159805, -6.359276891719812],
            [23.141735945271339, -6.36075659799205],
            [23.141870361983926, -6.361117021188283],
            [23.143928399604899, -6.361229855542122],
            [23.146238160439829, -6.36135594879483],
            [23.146346351736018, -6.361537001869817],
            [23.146925400378286, -6.362506009267026],
            [23.144157410713539, -6.368018857985297],
            [23.145515445132528, -6.370199368026151],
            [23.149891439817083, -6.377224982058967],
            [23.149310290015368, -6.378814116005824],
            [23.14896732042644, -6.379751952377132],
            [23.148518295735016, -6.379601416506775],
            [23.14483020035232, -6.378364977042688],
            [23.141611439671262, -6.379047898318976],
            [23.140858260696024, -6.381614366901211],
            [23.139993239671295, -6.384561920327267],
            [23.137237440144961, -6.383176927213912],
            [23.135164991750184, -6.383863966966132],
            [23.133098631238106, -6.38454898733537],
            [23.136424920258662, -6.388808035255638],
            [23.139751319771996, -6.393067011311553],
            [23.141119320100753, -6.399735870592335],
            [23.139961200358353, -6.404791902559865],
            [23.142254399852728, -6.408933973992316],
            [23.145475341643273, -6.410552200400672],
            [23.148685439870057, -6.412164974069148],
            [23.148841602100713, -6.41284652230713],
            [23.149370520258557, -6.415154898233991],
            [23.148346972637309, -6.416047219720491],
            [23.147529479677612, -6.416759903778114],
            [23.14540271734413, -6.416614315123725],
            [23.144081399765771, -6.416523863617386],
            [23.140398239727233, -6.419504985906387],
            [23.135803199843803, -6.417196882463167],
            [23.135401224415393, -6.417368190570499],
            [23.134193279615786, -6.417882974527976],
            [23.133843359761478, -6.421330971762822],
            [23.13349343990717, -6.424778946234961],
            [23.13224858782408, -6.426706475732609],
            [23.131418412449225, -6.427992096049946],
            [23.131568525424761, -6.42998694389235],
            [23.1316434000037, -6.430981944901073],
            [23.131921635196662, -6.431344676757601],
            [23.133938399721895, -6.433973905611133],
            [23.141285311697246, -6.439735161926557],
            [23.141759668879651, -6.442249701061457],
            [23.142196439652267, -6.444564983913547],
            [23.139980174573779, -6.447325562546183],
            [23.138511480288209, -6.449154960505791],
            [23.136202439902153, -6.455356941209017],
            [23.13870505106226, -6.457397188306679],
            [23.139877298609147, -6.458352857245136],
            [23.136860160302025, -6.475816858691661],
            [23.12694936038605, -6.49050887308249],
            [23.127159240074107, -6.503840862959084],
            [23.125538160075312, -6.510503948677117],
            [23.112873359958524, -6.523120984913295],
            [23.108345415243637, -6.529164376394758],
            [23.10135226252212, -6.538498112895076],
            [23.100443825021372, -6.55027067996352],
            [23.100412326494244, -6.550678872091449],
            [23.104082141160941, -6.555742915406009],
            [23.102926199833103, -6.559647964207393],
            [23.09463144036717, -6.570434909242886],
            [23.091885944517145, -6.576443606635697],
            [23.090015159818837, -6.580537899753789],
            [23.091388199696308, -6.585367947197375],
            [23.090572714471293, -6.587233417337434],
            [23.089079160208549, -6.590649991269375],
            [23.089073400210957, -6.594327887667744],
            [23.089225757178077, -6.594611812777656],
            [23.092283085212674, -6.600309253267554],
            [23.090894279901946, -6.606052881852533],
            [23.092209307476725, -6.608693807820986],
            [23.093185274930612, -6.610654068572771],
            [23.092491240135374, -6.613410966198805],
            [23.088809467095622, -6.617652431294396],
            [23.082695279947007, -6.624695998627224],
            [23.073370200460911, -6.635436935696314],
            [23.07676331515545, -6.641352251008253],
            [23.077726175291051, -6.643030820678209],
            [23.075885216456808, -6.646237588350569],
            [23.072191226329196, -6.652672088761329],
            [23.07250490545, -6.654333725095696],
            [23.07401424041732, -6.662328961441796],
            [23.067708653722672, -6.676697093416629],
            [23.061317430632027, -6.691261100955986],
            [23.057836200191264, -6.710099923971287],
            [23.04607715969734, -6.728230918231416],
            [23.041682279730541, -6.732076467827385],
            [23.038477200391274, -6.734880913344288],
            [23.034138249534095, -6.741162646418149],
            [23.033405159583552, -6.742223971860708],
            [23.02993944035277, -6.751409928357551],
            [23.020023273901305, -6.766556020080375],
            [23.02106688000454, -6.770499481323174],
            [23.024612160325049, -6.77597152202427],
            [23.030686439817174, -6.78011474834699],
            [23.038763760271973, -6.783611372332895],
            [23.045434919964748, -6.788811432000408],
            [23.050457639670103, -6.794319052723115],
            [23.055417000300174, -6.802778728490479],
            [23.063686920450198, -6.815487999566215],
            [23.065768800257132, -6.821271595250359],
            [23.0693925600958, -6.833173187248157],
            [23.075836199883319, -6.841841877558594],
            [23.084631719814475, -6.849350940093411],
            [23.094044640162348, -6.853921700355738],
            [23.103542879800912, -6.856062400428089],
            [23.113730159601786, -6.857003561120632],
            [23.123548080005595, -6.857935773220523],
            [23.128503106264407, -6.857852678800658],
            [23.132030399618003, -6.857793526360077],
            [23.136626520174737, -6.857383424713476],
            [23.140697400276416, -6.857655572802169],
            [23.145002279831516, -6.859149436512072],
            [23.148767519835879, -6.860977707320478],
            [23.152390920348438, -6.863844811640828],
            [23.155872120246499, -6.867750910007216],
            [23.156738999885558, -6.870898702543252],
            [23.157478079802416, -6.875433289945051],
            [23.15872151973387, -6.878763886769063],
            [23.162430240435487, -6.883717601980322],
            [23.167765440010754, -6.887841991238343],
            [23.174315639753896, -6.890084875784566],
            [23.177590919737671, -6.893464569352466],
            [23.178315599660525, -6.897651133475058],
            [23.179260959716071, -6.90271145857839],
            [23.183075880148913, -6.90575668031402],
            [23.189199479845076, -6.906599519867174],
            [23.195309039771672, -6.907094739664772],
            [23.20107768006482, -6.908276429101792],
            [23.206114440438071, -6.909614123041491],
            [23.212188719930197, -6.913756174174649],
            [23.220273240381996, -6.917425522316146],
            [23.22842904035495, -6.918317539097887],
            [23.231469240212025, -6.915959217282433],
            [23.236328160210167, -6.912950022503354],
            [23.246650439730242, -6.912678442477336],
            [23.253825600111476, -6.912157108855853],
            [23.261398200327243, -6.912340130204459],
            [23.268800879715439, -6.912866473729523],
            [23.277160560426971, -6.915276941720588],
            [23.276776299775985, -6.916296909311207],
            [23.276468519891655, -6.917113869785333],
            [23.278104029528826, -6.919052110881179],
            [23.278993199963359, -6.920105863005051],
            [23.278299479578475, -6.922631975180378],
            [23.269079521845217, -6.936172023941121],
            [23.270916217275136, -6.938013924270902],
            [23.272370622059476, -6.936980193744016],
            [23.275753200414059, -6.934575897356672],
            [23.280121439942768, -6.93596289174961],
            [23.272617941731927, -6.947671820123329],
            [23.27159149434895, -6.949275059466268],
            [23.273588895688246, -6.958167079125563],
            [23.2736623203863, -6.958493946609783],
            [23.271801480038164, -6.962830906743386],
            [23.270727733660546, -6.963567814630681],
            [23.265123479674525, -6.967413972279688],
            [23.265065416167801, -6.967788308297023],
            [23.264660160091985, -6.970400990949713],
            [23.270173982475008, -6.974776026496963],
            [23.263040159868172, -6.976830938960461],
            [23.259471024785306, -6.98522095547149],
            [23.257961334983435, -6.988769757724956],
            [23.251058279691634, -6.990366004487147],
            [23.24944548036315, -6.992659910095267],
            [23.251503240404688, -7.000475991851682],
            [23.247602056551738, -7.006576073874839],
            [23.246660172976359, -7.008048925762029],
            [23.247118431450545, -7.010577834880669],
            [23.247879561414358, -7.010748173102925],
            [23.251257359833321, -7.011503888220655],
            [23.251251239611292, -7.014721001556004],
            [23.254699297065237, -7.017253959417461],
            [23.252786561043148, -7.019634946567613],
            [23.251934256569598, -7.020695896388444],
            [23.259977280245113, -7.025765012556721],
            [23.259052965021734, -7.030130857022278],
            [23.261535359596401, -7.040030880101513],
            [23.260183200159396, -7.042537914283331],
            [23.259375654244824, -7.042228712749048],
            [23.257271160248958, -7.041422923402789],
            [23.255356268270202, -7.040690285479337],
            [23.255203320211589, -7.041623957592994],
            [23.253963479829505, -7.049188989905078],
            [23.247757439943079, -7.045042966624301],
            [23.244400440217884, -7.048038960123593],
            [23.24107742196329, -7.051003865543801],
            [23.244062279310647, -7.053995891026124],
            [23.235544440311912, -7.058116020464897],
            [23.233471199603063, -7.059719944914682],
            [23.234884499276646, -7.062021558140371],
            [23.235307199736958, -7.062709939890795],
            [23.231155320342733, -7.070283922839231],
            [23.232300480090505, -7.074650945899871],
            [23.229574176746535, -7.078138946371561],
            [23.229072359862521, -7.078780961941121],
            [23.229548435522037, -7.080373611691952],
            [23.230446480413267, -7.083377892928652],
            [23.229623810462595, -7.086234074827204],
            [23.227504346042497, -7.09359497359844],
            [23.227577280260409, -7.094603015084047],
            [23.227199522513779, -7.100371105459109],
            [23.227553590788052, -7.100497709657698],
            [23.228014319629288, -7.100659962513276],
            [23.231798267947774, -7.101989939307673],
            [23.231783993717894, -7.10211629359461],
            [23.231256479626875, -7.10678192321346],
            [23.231155491022616, -7.107682973066365],
            [23.231098439917254, -7.108192002579586],
            [23.229091594589374, -7.112727158935979],
            [23.228559359851509, -7.11392991847037],
            [23.227408679956305, -7.114081266834602],
            [23.225107320165897, -7.114383963411443],
            [23.222803320226884, -7.116905966400895],
            [23.223015360363195, -7.129083023553179],
            [23.22014776639805, -7.13275087244149],
            [23.219787240135176, -7.133212008521627],
            [23.217933292560236, -7.142279688994138],
            [23.216078160107458, -7.151352984352721],
            [23.216297213391172, -7.159164227413059],
            [23.214452399886017, -7.161228914437684],
            [23.216520207584026, -7.163529970999284],
            [23.214445241211514, -7.166971808917553],
            [23.219043479995708, -7.169277947481505],
            [23.223784772793913, -7.169540225648434],
            [23.227848360372121, -7.169765014876484],
            [23.231928239796318, -7.169991025983887],
            [23.233026977305187, -7.170753724033656],
            [23.234914440125038, -7.172063918448408],
            [23.233984199614039, -7.175263981814479],
            [23.231445479772766, -7.1840029327445],
            [23.230968483340021, -7.195947008663667],
            [23.231155314952815, -7.196832678058626],
            [23.232568499642042, -7.203531080954966],
            [23.237392148188881, -7.208364715900434],
            [23.235165717774635, -7.211908781039751],
            [23.234632200242551, -7.212757932137967],
            [23.233932359635638, -7.213870891242126],
            [23.235077160057305, -7.218925926021289],
            [23.233452500272112, -7.22788274350891],
            [23.237362226205093, -7.229497887265794],
            [23.236610640841143, -7.233463060988471],
            [23.235969203304094, -7.236845960193874],
            [23.23254744043685, -7.246010882430654],
            [23.230655280326346, -7.251077888739141],
            [23.23203450779949, -7.252917939738927],
            [23.233371500081265, -7.251725717946477],
            [23.23468440044542, -7.250554975323553],
            [23.238716253239566, -7.246957986492084],
            [23.238935593984184, -7.247839408502275],
            [23.239402199604001, -7.249715989773528],
            [23.237976239973154, -7.252463023105509],
            [23.236695148054892, -7.254932026468849],
            [23.235710399569083, -7.256829887623551],
            [23.234066279579864, -7.27887790292051],
            [23.23469853723304, -7.288561338914578],
            [23.234741271887728, -7.289215839677306],
            [23.232649320169838, -7.303911957497703],
            [23.231656442829021, -7.310189989069697],
            [23.231487239755367, -7.311259860712708],
            [23.230401456851244, -7.313778496827328],
            [23.227331399689039, -7.32089987697192],
            [23.229622439633491, -7.327335017123049],
            [23.226385320082951, -7.336975932312253],
            [23.233974479842676, -7.341353937002028],
            [23.238113400140609, -7.343887883136975],
            [23.247549179917488, -7.34413489153772],
            [23.249386440387713, -7.346434862872422],
            [23.247528480038405, -7.357455873786193],
            [23.25580452041045, -7.364361961210943],
            [23.254779424093641, -7.369229958339945],
            [23.2546442402198, -7.369871918356461],
            [23.251871722147719, -7.37469758307035],
            [23.249107446118341, -7.379508847806671],
            [23.24933673480642, -7.382306324227317],
            [23.249559234027569, -7.385020958994322],
            [23.249303383054848, -7.385409490885792],
            [23.249046240304768, -7.385799985453715],
            [23.247106390432489, -7.388744311867972],
            [23.245176239670297, -7.391673985160793],
            [23.2451667588508, -7.394432108649012],
            [23.237644319662191, -7.397478029734675],
            [23.235960239914188, -7.39946586081619],
            [23.239174320372637, -7.404065020683455],
            [23.236472121522645, -7.40715101079501],
            [23.232950280044538, -7.411173025326787],
            [23.232726940898601, -7.411985504406924],
            [23.232256200333513, -7.413697988505273],
            [23.237297279806679, -7.427946984763268],
            [23.240289240132984, -7.428640882618694],
            [23.241214598300424, -7.424968914170761],
            [23.242748477936274, -7.424971266178213],
            [23.243196239596376, -7.424971952142995],
            [23.243583648842453, -7.424972643487941],
            [23.244898192225261, -7.424974989218555],
            [23.245564944286986, -7.426119460352727],
            [23.246505360015242, -7.427733973026815],
            [23.245731359888346, -7.430291005427809],
            [23.245117199694896, -7.432324969869197],
            [23.246490239572363, -7.437150012986318],
            [23.250509279695642, -7.443817529857407],
            [23.254528319818917, -7.450484944020142],
            [23.25036636042886, -7.462419986766306],
            [23.244837479586767, -7.466542996809268],
            [23.243908319749039, -7.471363904950311],
            [23.245285320298613, -7.474581983480244],
            [23.243564520116792, -7.476635930483824],
            [23.242979520135751, -7.477333860104572],
            [23.241727677363148, -7.47748726089158],
            [23.240751479940542, -7.477606883988068],
            [23.23929632146967, -7.477785994009824],
            [23.236992712297798, -7.482036595615748],
            [23.23444757938368, -7.48673307648257],
            [23.236053479650785, -7.491099943856089],
            [23.231905199805929, -7.494765988777637],
            [23.229595439869296, -7.500273931001345],
            [23.228313396635141, -7.501829919019198],
            [23.227518240285004, -7.502794979282159],
            [23.220384479661938, -7.501174971029059],
            [23.217157440107226, -7.50507302194654],
            [23.214163320230963, -7.506215969076971],
            [23.214155220122034, -7.511037867966587],
            [23.213943612075397, -7.511044996094916],
            [23.207710319998188, -7.51125512207599],
            [23.207706361122749, -7.51332193708706],
            [23.21207421168095, -7.518153008775992],
            [23.210330190048992, -7.527009449557532],
            [23.208593422312997, -7.535828873524885],
            [23.208745225019573, -7.536284962819284],
            [23.209511399922054, -7.538586007779022],
            [23.214800160190403, -7.541350872206789],
            [23.214570089968014, -7.544274532537731],
            [23.214330360161409, -7.547320924769061],
            [23.218700399913971, -7.550085018186991],
            [23.219848439660534, -7.552843019559784],
            [23.219521250776182, -7.554780676173555],
            [23.21891820004787, -7.55835200101728],
            [23.227190432461416, -7.568700202308327],
            [23.228338289849972, -7.570079996543969],
            [23.228225424619385, -7.570602652204429],
            [23.227644239783388, -7.573293976451348],
            [23.2234935030462, -7.577878882525179],
            [23.224868280265426, -7.582243975621829],
            [23.222559848937134, -7.584539216799592],
            [23.219104437874247, -7.587974859445812],
            [23.218590746160505, -7.590684997193705],
            [23.218408454633138, -7.591646905847589],
            [23.219318159656758, -7.598536988442731],
            [23.220371230409814, -7.598704473571132],
            [23.220789479717908, -7.598770994166301],
            [23.222218115430007, -7.598998849197622],
            [23.223692280455634, -7.599233965208851],
            [23.225071320180916, -7.600842921509277],
            [23.220913319666337, -7.610479869706147],
            [23.222742480027634, -7.618061018651702],
            [23.219513280024671, -7.622646939177558],
            [23.219969399610168, -7.624943988820061],
            [23.226408360073371, -7.630465967431649],
            [23.226891394083108, -7.632653723362727],
            [23.227321319693242, -7.634600927934301],
            [23.226669375460641, -7.637187224695659],
            [23.226164279725822, -7.639190955522121],
            [23.229608355846462, -7.64516705565923],
            [23.2279912796389, -7.64883792425432],
            [23.229360359742596, -7.656647000241321],
            [23.226172319647645, -7.665024686396638],
            [23.225431320031021, -7.666971896307065],
            [23.218981199797042, -7.6694858827661],
            [23.219420361884932, -7.673035960110324],
            [23.219890199643174, -7.676833973196174],
            [23.21482247973195, -7.679349864953399],
            [23.214078888475736, -7.680950296056725],
            [23.213436479859858, -7.682332946209118],
            [23.21389224011925, -7.685547998556585],
            [23.216192280284488, -7.687158909591683],
            [23.216419241437656, -7.688995938765892],
            [23.214733151260081, -7.689233429493581],
            [23.213196360184408, -7.689449891504314],
            [23.212011698818635, -7.690887160322119],
            [23.211118440151242, -7.691970887132839],
            [23.211874303292571, -7.693050273907478],
            [23.212728360379263, -7.694269880017321],
            [23.215028803888064, -7.694963056570387],
            [23.21963133482269, -7.696349902680128],
            [23.218858080297455, -7.700480651054537],
            [23.218471440009296, -7.702546006807935],
            [23.213861279682984, -7.706210937764467],
            [23.210855279587076, -7.714470934447902],
            [23.206936306396571, -7.717447923805794],
            [23.2036934403232, -7.729609879150105],
            [23.193302400158032, -7.749563871926767],
            [23.186157479764187, -7.754371915710427],
            [23.184424843380143, -7.758669331117617],
            [23.183845200053195, -7.760106996575348],
            [23.184984230595774, -7.76883278236209],
            [23.170475519780712, -7.769493873341111],
            [23.166786240418478, -7.772470952682213],
            [23.15518452008364, -7.774435959978237],
            [23.150661480170204, -7.776572013101144],
            [23.120901360209249, -7.811866982301728],
            [23.113510088526859, -7.818048254470482],
            [23.103376200094903, -7.826523008157959],
            [23.097920991885868, -7.837776148569402],
            [23.091591239611766, -7.850832935289993],
            [23.089039200449761, -7.862074867132194],
            [23.087879399061162, -7.865007787883172],
            [23.083963199868265, -7.874910962415384],
            [23.070347279698307, -7.8732690067531],
            [23.052873977528673, -7.867528936496607],
            [23.045323679786478, -7.865048600041404],
            [23.021045640237965, -7.869116248130881],
            [23.000444639607643, -7.87084444234419],
            [22.984252559611981, -7.864847233626422],
            [22.963655879878164, -7.871954616625279],
            [22.940858880162164, -7.88830323615574],
            [22.917308040310864, -7.881606172014862],
            [22.892276880177601, -7.863396072532563],
            [22.834858680054218, -7.830115788371702],
            [22.817193479773593, -7.822594551387817],
            [22.798796399573146, -7.819691211379585],
            [22.784081759860662, -7.821364981497251],
            [22.777459560147488, -7.821426397952147],
            [22.773777479883925, -7.817617869723354],
            [22.766419799803266, -7.817686249308244],
            [22.756897069395066, -7.825801388175665],
            [22.743625319861625, -7.837111122383416],
            [22.719361680307124, -7.859622744590765],
            [22.687740359773628, -7.882201320433347],
            [22.661089919865379, -7.895989988354922],
            [22.666190040212278, -7.880159890234557],
            [22.666449948875123, -7.866620626424926],
            [22.674980160370282, -7.859299982693381],
            [22.677059879728933, -7.85540004639592],
            [22.676328721156278, -7.853713631331677],
            [22.675465305420929, -7.851722157274075],
            [22.675460040395045, -7.851710014093497],
            [22.672153723618219, -7.851021439808882],
            [22.671089999744183, -7.850799907844666],
            [22.670613757896302, -7.849888519502309],
            [22.670507851015898, -7.849685848543271],
            [22.663749959880761, -7.836769954450485],
            [22.656859920279103, -7.829179925790978],
            [22.655413998285987, -7.828771865994797],
            [22.64948999975439, -7.82710002606189],
            [22.648135047455145, -7.825421198082129],
            [22.646519999643495, -7.823420094531017],
            [22.644920160309606, -7.815839996531603],
            [22.6464855106248, -7.813028819238661],
            [22.64721984025044, -7.811710046282913],
            [22.644939960076794, -7.802980095235108],
            [22.646679429945159, -7.796680110153155],
            [22.647030119655678, -7.795409977198086],
            [22.646714280984952, -7.793817074546975],
            [22.646120040034603, -7.790820059742633],
            [22.644088488341453, -7.787424458648189],
            [22.642679879670311, -7.785070048762759],
            [22.645378840991992, -7.781942598317099],
            [22.645450080088981, -7.781860049039764],
            [22.65098003980772, -7.779119977621356],
            [22.651562947612454, -7.776063177538134],
            [22.65167986783824, -7.775449953040279],
            [22.65163895047538, -7.775378379586281],
            [22.645500119843565, -7.76463993674985],
            [22.636980000022294, -7.760490010856497],
            [22.631469840070707, -7.753130001333809],
            [22.628438358363468, -7.752309570165617],
            [22.624559999803566, -7.751270067949037],
            [22.619834433811043, -7.746538270752772],
            [22.616750159911177, -7.743449901501815],
            [22.612839180828381, -7.74320950627836],
            [22.611981856568981, -7.742459341720683],
            [22.610999856927954, -7.741599354496039],
            [22.610941247245524, -7.739702221350367],
            [22.61077991970199, -7.734480117862637],
            [22.609805882727603, -7.733171593699343],
            [22.609409126511029, -7.732640011023824],
            [22.604339880362144, -7.733089928071356],
            [22.599730360534629, -7.736288735476419],
            [22.605479999662865, -7.737449948435011],
            [22.6079993679963, -7.74296870054112],
            [22.600170359852381, -7.744553990767302],
            [22.59163318461712, -7.752107053786614],
            [22.590510109950589, -7.752520502520875],
            [22.581724319672261, -7.755754892440978],
            [22.576071052706038, -7.756219238532542],
            [22.570900199911982, -7.756643959150089],
            [22.564845986088358, -7.759015230741849],
            [22.559837399577336, -7.760976948168875],
            [22.55384051982843, -7.765322926465505],
            [22.548526199795297, -7.772424885553588],
            [22.545297360016736, -7.774712006536516],
            [22.542749279730206, -7.781591863671004],
            [22.524509160362669, -7.802433931028658],
            [22.521934439638052, -7.820102915530737],
            [22.512579120164531, -7.829170285783713],
            [22.496587919636113, -7.844881136196245],
            [22.48536887981566, -7.847482949845659],
            [22.473225360380159, -7.843753391867606],
            [22.446910080107813, -7.830356626682339],
            [22.432813371716332, -7.821463997463759],
            [22.432599492728659, -7.816980457027542],
            [22.432594324720828, -7.816872030818311],
            [22.430761220755404, -7.813652940768723],
            [22.427024760077817, -7.806332227662206],
            [22.421320919757701, -7.804463785898052],
            [22.41010944015872, -7.81648058859267],
            [22.397239080352083, -7.824285628058059],
            [22.348513799978004, -7.851251569350437],
            [22.32975708015185, -7.859110574573653],
            [22.316805711171231, -7.863160942545925],
            [22.291137359837258, -7.871188259278598],
            [22.266305640070112, -7.873147797191739],
            [22.253613840189129, -7.874034110657251],
            [22.246297753902741, -7.875021337623488],
            [22.204688760122856, -7.880635975074719],
            [22.189054320119606, -7.882125990125182],
            [22.181879880187211, -7.881808422308331],
            [22.165096319764086, -7.881365899453367],
            [22.163252400082676, -7.870243921771044],
            [22.160499479656806, -7.86610291510815],
            [22.151991240055182, -7.861944906295809],
            [22.14739717125055, -7.856826605783178],
            [22.14372631813141, -7.852736774456312],
            [22.138251479936798, -7.840140021671946],
            [22.132171799773189, -7.828476689312254],
            [22.094240760294735, -7.780409131124487],
            [22.086691560293826, -7.771447824354644],
            [22.079695320062651, -7.763634287396848],
            [22.072514399683794, -7.754861538311435],
            [22.06662227966666, -7.747421609311386],
            [22.060795035081039, -7.742282533526705],
            [22.059075240114002, -7.740765825851632],
            [22.052631959652626, -7.734483867761605],
            [22.042504799602167, -7.72170215940102],
            [22.038806159794643, -7.696752270698547],
            [22.033460519999142, -7.682579406639094],
            [22.023705240018401, -7.674981915886133],
            [22.008436199638442, -7.673393997558522],
            [22.00240944012651, -7.672058970732401],
            [22.002403316311231, -7.674241894351717],
            [22.002397199682459, -7.676421948770226],
            [21.998412983649498, -7.682520960088669],
            [21.994764479716313, -7.688105985832433],
            [21.994734059167538, -7.691633079445459],
            [21.979943999598742, -7.698644414258684],
            [21.970014479690555, -7.703349286919889],
            [21.9628375199838, -7.699764338075724],
            [21.94866539982085, -7.68913307005678],
            [21.940935480344329, -7.684015663981111],
            [21.928608359637764, -7.68105491863583],
            [21.902853959581059, -7.679180020026204],
            [21.873419999933478, -7.676378371308065],
            [21.86918820012335, -7.674880114699455],
            [21.853363319974832, -7.668299975130494],
            [21.839379480407228, -7.663816890302349],
            [21.835145159924441, -7.659051027123116],
            [21.830297047557448, -7.640788054034921],
            [21.829349880091574, -7.637219954529615],
            [21.828210120116953, -7.622170022639801],
            [21.83676984037087, -7.617549980826832],
            [21.844529999834812, -7.608729873054394],
            [21.847669919874949, -7.604880105567082],
            [21.848420159562579, -7.599909939148507],
            [21.842600040413807, -7.583049985901923],
            [21.845319839955128, -7.577109910243077],
            [21.85011000020647, -7.575080025267774],
            [21.851589960264036, -7.5730599566875],
            [21.852339839727232, -7.570119871255145],
            [21.852169919797962, -7.561839896623473],
            [21.853280160234032, -7.557060021522258],
            [21.853280160234032, -7.553750022151655],
            [21.848770080315219, -7.547670010148704],
            [21.838929840369858, -7.531720040788143],
            [21.836360160092287, -7.520000065756979],
            [21.840260039591449, -7.506090007491365],
            [21.84838991957519, -7.495799972899282],
            [21.851910000355353, -7.486419874634375],
            [21.856910040294757, -7.475039946264031],
            [21.856740120365483, -7.470239984161513],
            [21.851570159598516, -7.466009977712879],
            [21.851570108394544, -7.466009970540079],
            [21.846409920399566, -7.465260032199049],
            [21.843650160201133, -7.463050037545054],
            [21.843029879785654, -7.459079952271383],
            [21.843290160351025, -7.456609932120996],
            [21.846970080166336, -7.45404001015685],
            [21.853260000242436, -7.448900120393088],
            [21.855669839688236, -7.442469989215723],
            [21.852920160383924, -7.429220052216072],
            [21.853479959926258, -7.426460007219624],
            [21.851269920172683, -7.423509982925467],
            [21.851269869867046, -7.423509973958581],
            [21.846110040299845, -7.422580010478561],
            [21.839659920065895, -7.417420089128568],
            [21.829730039933274, -7.405080098978654],
            [21.828809880316399, -7.402869975884294],
            [21.828440159796607, -7.399929978411935],
            [21.830209919958065, -7.39601007017106],
            [21.834719999876878, -7.392579987126027],
            [21.838250159754544, -7.38577996872248],
            [21.8375200800585, -7.381249960021743],
            [21.83474015986847, -7.372529913571636],
            [21.829229999916887, -7.36553995284143],
            [21.827949840449911, -7.358349882646924],
            [21.827779919622344, -7.350069957097458],
            [21.827217410761097, -7.347884837706061],
            [21.826389909670805, -7.344670028545421],
            [21.826389680600411, -7.34466942227408],
            [21.826389574599222, -7.344669010619468],
            [21.820920120008115, -7.330200073916655],
            [21.820912761907621, -7.330183549787871],
            [21.81974004005027, -7.327550044702413],
            [21.814993656499347, -7.324676633137493],
            [21.810436470723641, -7.321917753672571],
            [21.80847995979779, -7.320740079035794],
            [21.802849919671516, -7.313460078759638],
            [21.79857455067183, -7.311078047976458],
            [21.798560159660962, -7.311070029515393],
            [21.784331177937169, -7.292661499993888],
            [21.784340160191714, -7.287650038246246],
            [21.781299960334639, -7.284600046923284],
            [21.781760039693907, -7.280509999922037],
            [21.780939959586206, -7.278200035620304],
            [21.780872709907396, -7.278010780433858],
            [21.779689992495907, -7.274680005978679],
            [21.779689173232352, -7.274680032888474],
            [21.783829964721036, -7.267553520416389],
            [21.787549919753591, -7.261149872159296],
            [21.786891016272474, -7.258020418276542],
            [21.786872849642503, -7.2579341368143],
            [21.786869879812169, -7.257920032853362],
            [21.783208983619627, -7.253789650284012],
            [21.780862828439254, -7.252958285790851],
            [21.778610039657977, -7.252160003438419],
            [21.777245137618646, -7.249221262599208],
            [21.775409999867428, -7.245270036668354],
            [21.761139959745265, -7.245669957916921],
            [21.758625027292695, -7.244621587161192],
            [21.757230845565005, -7.244040408690186],
            [21.753924878232784, -7.240073875003509],
            [21.750130080062327, -7.235520033335422],
            [21.748309919921848, -7.22953998924121],
            [21.744870119781989, -7.225389900575261],
            [21.735509719437218, -7.219949560382881],
            [21.73452983982024, -7.219380042602105],
            [21.720331558919618, -7.198882375493605],
            [21.717468033424389, -7.19839703890529],
            [21.714818358170788, -7.197947946572063],
            [21.713670003115542, -7.196329977577983],
            [21.712989959580828, -7.193110035424197],
            [21.713920427365593, -7.190818997414812],
            [21.714850080378394, -7.188529955554395],
            [21.714043777732204, -7.186229040503738],
            [21.71348016034991, -7.184619139663123],
            [21.713773356085596, -7.183604245528987],
            [21.714410160112418, -7.181399950472275],
            [21.713280119909193, -7.17450996550015],
            [21.710607825076714, -7.169661524134821],
            [21.707570160265348, -7.164150114269325],
            [21.704884710503872, -7.156349998124981],
            [21.703690079635077, -7.152880047485759],
            [21.702360909882824, -7.141481026279554],
            [21.701679839573732, -7.13564002675419],
            [21.701345769594312, -7.135305939845701],
            [21.699839879666094, -7.133799969620972],
            [21.695470050119322, -7.134240024947086],
            [21.688329959966772, -7.137649953543784],
            [21.686474877819631, -7.136313412076967],
            [21.684179879898064, -7.134659915400559],
            [21.683737672521346, -7.134716489436551],
            [21.680740079758205, -7.135099991423663],
            [21.672039960011869, -7.123349949468497],
            [21.663550080178027, -7.117349993497898],
            [21.661779959792163, -7.110469938835571],
            [21.662678491570251, -7.106844589113665],
            [21.662939395566411, -7.105791902060269],
            [21.661916051862736, -7.103499108447993],
            [21.661719840041748, -7.103060078514006],
            [21.661729920037544, -7.096359893630407],
            [21.661740000033376, -7.090689893155204],
            [21.660784005721492, -7.086999860225422],
            [21.658309919664877, -7.077450018073946],
            [21.655409909992738, -7.072668382503107],
            [21.653640466936551, -7.069749550418326],
            [21.637007221609942, -7.060032934303223],
            [21.631080728456769, -7.056570531828264],
            [21.628591403379662, -7.053815641458838],
            [21.626500499995718, -7.051501291724203],
            [21.621440159744552, -7.051709923683557],
            [21.615210000092759, -7.056509943733301],
            [21.612410661919537, -7.05099647782225],
            [21.609950441359356, -7.046150868710841],
            [21.609379368858512, -7.045672782141683],
            [21.607200000283676, -7.043850001222836],
            [21.601689030051705, -7.042219162912721],
            [21.598249083486454, -7.038299616296715],
            [21.589520121531312, -7.035739482577945],
            [21.590459912930417, -7.028849946145439],
            [21.583119490384657, -7.022159704734058],
            [21.57281298887424, -7.015238921353406],
            [21.570729839747838, -7.013840080714516],
            [21.564089999817426, -7.005079968572336],
            [21.560007460481689, -7.003024874108543],
            [21.556739879958208, -7.001380012152259],
            [21.556219319725788, -7.000807805347444],
            [21.554219880109112, -6.998609988957149],
            [21.553290161519293, -6.996649042409635],
            [21.551929919939671, -6.993780027670287],
            [21.551576904490865, -6.991219613627795],
            [21.550820039728038, -6.985730039585765],
            [21.54759727435745, -6.980672161820906],
            [21.547149839684092, -6.979969943864171],
            [21.546554512670586, -6.979498853308826],
            [21.54394008012218, -6.977430013244175],
            [21.541410000277288, -6.977880078250601],
            [21.537060119618022, -6.971890019892516],
            [21.535612368655023, -6.969147210840188],
            [21.533169959890255, -6.964519956164383],
            [21.532049999682826, -6.956480012727842],
            [21.530778735333779, -6.954452089543818],
            [21.530369879708633, -6.953799880896548],
            [21.526110000359363, -6.947029895203878],
            [21.521060737233974, -6.941950837329252],
            [21.519929879563858, -6.937599979197151],
            [21.511670040307962, -6.930200031002181],
            [21.511065122880478, -6.929421557108517],
            [21.509160120454666, -6.926969985688718],
            [21.507109919736237, -6.920070082715832],
            [21.502727645827839, -6.916381802226707],
            [21.49587000037365, -6.910610100882777],
            [21.493580040204208, -6.905309944193423],
            [21.487824179344308, -6.898168543128119],
            [21.487639882777252, -6.897940053945375],
            [21.482579880292633, -6.897229974240158],
            [21.477459495749574, -6.894226160134717],
            [21.47271011991042, -6.891439977085667],
            [21.461523018791606, -6.888290050284415],
            [21.456159840288475, -6.88677994465249],
            [21.450192560926489, -6.883081730615431],
            [21.444031147546735, -6.870878039043119],
            [21.438069343416391, -6.866258230007301],
            [21.437994531719518, -6.866001585585109],
            [21.436930080210132, -6.862349890875917],
            [21.431739706126656, -6.862723232988337],
            [21.430950474165776, -6.862780001138899],
            [21.427509882610174, -6.860930032844818],
            [21.422957417481282, -6.856229761536371],
            [21.418570079769641, -6.851699934894579],
            [21.416969880211315, -6.849399966976097],
            [21.416548695208874, -6.844445384386038],
            [21.416090039679336, -6.839049970551223],
            [21.404810159659633, -6.840610097794819],
            [21.401830080451266, -6.838990027436669],
            [21.400858182365603, -6.836706025956937],
            [21.400459919674258, -6.835770088830983],
            [21.401279103263327, -6.832697396387578],
            [21.403029960176266, -6.826130004845446],
            [21.406715280663057, -6.823616973167502],
            [21.410412366385138, -6.819495010822037],
            [21.415704480064417, -6.818367906980727],
            [21.417709786578236, -6.815692694226436],
            [21.421715399582933, -6.810348894769836],
            [21.423052150217888, -6.809883241626018],
            [21.425628239975016, -6.808985865848511],
            [21.4366604400978, -6.811098853965115],
            [21.443102279661471, -6.810894856784443],
            [21.446001329034615, -6.807909844134299],
            [21.449104199857494, -6.804714944064515],
            [21.458984400459936, -6.807511885562465],
            [21.464048159699054, -6.806382911569964],
            [21.466644618755232, -6.803808345877068],
            [21.467510280278795, -6.802949981205919],
            [21.467999245864331, -6.80175255598278],
            [21.471393240009562, -6.793440936944336],
            [21.472383240046501, -6.791018997591665],
            [21.476842418726381, -6.788552678422488],
            [21.480219360152578, -6.786684922956833],
            [21.485300400282824, -6.780730001202997],
            [21.522159359758483, -6.763409911898365],
            [21.524512290032693, -6.763109604249872],
            [21.530903399935642, -6.762293897172068],
            [21.53931415346435, -6.759314934417179],
            [21.539884319565051, -6.759112989390525],
            [21.542131786726625, -6.759281925723868],
            [21.546322200253275, -6.759596909097555],
            [21.551630400064351, -6.754332997150473],
            [21.557690782619041, -6.753447920767187],
            [21.560833439825867, -6.752988956869935],
            [21.574384240222535, -6.7580979360244],
            [21.581949239792692, -6.765022008678802],
            [21.585606119617577, -6.764461318986155],
            [21.593357639983434, -6.761407489457],
            [21.598851599717197, -6.758379590837244],
            [21.603205800374635, -6.753509929338645],
            [21.605490720097031, -6.746540017088543],
            [21.604058999570263, -6.738298941936829],
            [21.599323920418851, -6.732347891209151],
            [21.587927040223317, -6.724346581752926],
            [21.582126359718931, -6.716791873651054],
            [21.583124640426188, -6.712553596270706],
            [21.587666040107401, -6.710765740562578],
            [21.592796040217255, -6.711201742123104],
            [21.598201080212625, -6.714011939773883],
            [21.604820399926968, -6.718902407318497],
            [21.612069000277646, -6.723334103020906],
            [21.617751960157264, -6.728360318578496],
            [21.619961280360293, -6.726360254940907],
            [21.62110571965923, -6.722756719641064],
            [21.621663359651635, -6.716771648888899],
            [21.62052144012706, -6.70995745414579],
            [21.614134679866726, -6.700021107110875],
            [21.611017799817013, -6.690003471799732],
            [21.610797479908722, -6.683999736181698],
            [21.612318450753943, -6.680647326324814],
            [21.61256904029403, -6.680094994081203],
            [21.616801200328563, -6.678141985175662],
            [21.627372599744906, -6.679021207010168],
            [21.637038959987226, -6.677985007026304],
            [21.64579091971196, -6.675664510712984],
            [21.653944199910526, -6.671751289021172],
            [21.658815719678852, -6.66870832597207],
            [21.663069479704394, -6.665335090007796],
            [21.668396040181573, -6.663092040540042],
            [21.675089160089797, -6.66309096631668],
            [21.681609840294389, -6.664191101794696],
            [21.687515639856656, -6.66480310283502],
            [21.696540479916923, -6.665014680924822],
            [21.704162400336728, -6.665351199690139],
            [21.708083519602464, -6.663390970933793],
            [21.710920320217976, -6.66108937962154],
            [21.712491444005483, -6.657733937598143],
            [21.712528800446581, -6.657654154968205],
            [21.707446590709814, -6.655189731446971],
            [21.707428189619534, -6.655180628243598],
            [21.704456160214427, -6.649652858548159],
            [21.700782513334751, -6.648260968511097],
            [21.698721911921961, -6.645841220126506],
            [21.696659280316631, -6.643418954551885],
            [21.691633320388014, -6.633287012643865],
            [21.679687440196457, -6.630024876348435],
            [21.672352439881781, -6.623561940043309],
            [21.658849723607318, -6.618524412276918],
            [21.653061245817771, -6.616364724032798],
            [21.651291359892184, -6.614693991396212],
            [21.64572720041221, -6.609440850607387],
            [21.644130780066305, -6.605527901108449],
            [21.642534359720369, -6.601614920254686],
            [21.639324239934055, -6.598844887576091],
            [21.634727399826772, -6.598137921510425],
            [21.631757399715877, -6.592609975856931],
            [21.630236280648667, -6.591257850150376],
            [21.627861479990518, -6.589146877423517],
            [21.62423340015361, -6.574193007892687],
            [21.620117368929122, -6.567511852167992],
            [21.618752870233354, -6.566320643975305],
            [21.613241168772753, -6.561508892955225],
            [21.613264570784235, -6.561293842689945],
            [21.613716359591759, -6.55714392614241],
            [21.610046554806537, -6.55437098394169],
            [21.610191694708675, -6.553729187041919],
            [21.610981439607563, -6.550237973262794],
            [21.60825932870101, -6.539424020505469],
            [21.603911760305309, -6.542695062450619],
            [21.60323207968996, -6.546468770639421],
            [21.598961399896055, -6.550947694525822],
            [21.593295359784801, -6.555078166716397],
            [21.585103559826834, -6.561517658322931],
            [21.580366320227164, -6.565985524770722],
            [21.575772360118709, -6.571246113935982],
            [21.571815239969666, -6.575574246527392],
            [21.568219919894538, -6.57659526792716],
            [21.564772560431571, -6.578093407560414],
            [21.55572395993201, -6.579460133401509],
            [21.548451238019339, -6.576605473063792],
            [21.547917357567897, -6.570750904926036],
            [21.551893557035264, -6.565159987930007],
            [21.55292783772753, -6.558552605888579],
            [21.553023597238521, -6.552238940887634],
            [21.552453717700359, -6.548751923704601],
            [21.555335876949513, -6.543450808834346],
            [21.562581957525797, -6.537778474122748],
            [21.567178077184206, -6.532359606664677],
            [21.568664877014339, -6.526709883778888],
            [21.567508557495788, -6.520840219053862],
            [21.566929317512372, -6.517984144441858],
            [21.562299357418873, -6.515349006795085],
            [21.555778677214317, -6.514248716466969],
            [21.551294877509122, -6.512248669461773],
            [21.545561517650452, -6.510535103673137],
            [21.541139997245594, -6.504430681636125],
            [21.539447637725647, -6.492863193356008],
            [21.539866317326751, -6.485766713612445],
            [21.543373437214026, -6.48032167068634],
            [21.547921677566105, -6.478059510522601],
            [21.553082997438359, -6.47644341972093],
            [21.561664677009389, -6.475065485613037],
            [21.57473771740538, -6.475214113145649],
            [21.583286276990222, -6.476046424891641],
            [21.599506797647756, -6.473899924273823],
            [21.605503078220401, -6.472293016424588],
            [21.601522004494317, -6.464728477701258],
            [21.599563316950501, -6.461006938272042],
            [21.600961197042206, -6.455724942528455],
            [21.59983223751226, -6.449743948965213],
            [21.601483021204242, -6.446982205642421],
            [21.603533397094136, -6.443551927730832],
            [21.603327477179885, -6.436654960517165],
            [21.607502397462831, -6.425866899261172],
            [21.606369495227089, -6.421264067662681],
            [21.607785238318247, -6.419220641487438],
            [21.611452317614877, -6.413927947426938],
            [21.610777317222169, -6.409787886907679],
            [21.613548237191385, -6.405889926838481],
            [21.611747157267551, -6.394618895063811],
            [21.614680608522775, -6.392168297305116],
            [21.616129348530919, -6.390958018457465],
            [21.615396853265114, -6.389629247945566],
            [21.6149864714023, -6.388884750045566],
            [21.615940901747276, -6.385563027795386],
            [21.619407237222298, -6.373498890697176],
            [21.621074397201898, -6.356723976143292],
            [21.618232075540661, -6.346898960345483],
            [21.617212370912199, -6.343374114819342],
            [21.618375477202719, -6.339471876530192],
            [21.616586277498502, -6.324750914739121],
            [21.616003531390543, -6.324003598330071],
            [21.614069157648235, -6.321522939911071],
            [21.612947397216956, -6.313931986340742],
            [21.60790415729554, -6.310004987748004],
            [21.608685690694426, -6.30730080150997],
            [21.608833299166953, -6.306789975165498],
            [21.603109325804724, -6.300330760862249],
            [21.603248936576293, -6.297365451878441],
            [21.603607182016631, -6.289756342656529],
            [21.600148016894209, -6.285354766077539],
            [21.599258398200359, -6.28422277594081],
            [21.599273157520468, -6.27985495935488],
            [21.602600779640888, -6.271982601348407],
            [21.603445177143353, -6.269984852637302],
            [21.603147138589978, -6.269383222029797],
            [21.601391397536823, -6.265839003427367],
            [21.599870103298109, -6.264929524657497],
            [21.595197345667859, -6.262135990142204],
            [21.596134317255277, -6.257081882274701],
            [21.594076196989306, -6.254084939065903],
            [21.589487277327898, -6.251997871765677],
            [21.588354357125876, -6.247395902583161],
            [21.592569237167577, -6.224880991512837],
            [21.596973473088045, -6.214091743751849],
            [21.594251162755505, -6.203964884025895],
            [21.589897316932586, -6.200039894300907],
            [21.588991229424646, -6.196587835549398],
            [21.589730126085165, -6.195188273345331],
            [21.591535317598076, -6.191769000405413],
            [21.595680357219734, -6.18971590292159],
            [21.596609102035767, -6.186730037605358],
            [21.590439477156014, -6.177049912296242],
            [21.590248318358498, -6.16578304720091],
            [21.589754397665839, -6.159069886100264],
            [21.588272152294223, -6.138874946747825],
            [21.582844199869218, -6.114250981881274],
            [21.579392868954383, -6.106895134995668],
            [21.578737341342094, -6.105497900664241],
            [21.58660943987358, -6.088512923759319],
            [21.585095293529573, -6.086414975345231],
            [21.584779268009253, -6.085977099698531],
            [21.579954480398658, -6.086187928991858],
            [21.57904049849596, -6.084345101781002],
            [21.58434648036663, -6.078617915034036],
            [21.582065160193572, -6.073780016438292],
            [21.582623040036175, -6.070931434579983],
            [21.583235160155585, -6.067805879300029],
            [21.580122199455442, -6.057458497317781],
            [21.577556160049742, -6.048928914116316],
            [21.578075772559522, -6.046276734341974],
            [21.578245200212017, -6.045411945313358],
            [21.578726160011755, -6.042954856227566],
            [21.573246240047592, -6.033275859427227],
            [21.581402400244951, -6.000425898376088],
            [21.582630360407421, -5.977666007095123],
            [21.586548240348225, -5.974461886517002],
            [21.590027279797994, -5.965046939678127],
            [21.593191265704608, -5.96201536774544],
            [21.596481359805747, -5.958862947442244],
            [21.601577160154438, -5.94669497613931],
            [21.609169823343745, -5.942315191969992],
            [21.61147751985018, -5.940984003014603],
            [21.61379991818454, -5.93386473756806],
            [21.617246517672765, -5.933878006393071],
            [21.621368157079598, -5.937802969443382],
            [21.625157232981714, -5.937013304995851],
            [21.628954341619075, -5.93622196551482],
            [21.62950319878296, -5.935760529352555],
            [21.631950356940614, -5.933702874427069],
            [21.634546786352388, -5.928870830582324],
            [21.637499308841093, -5.9233760331903],
            [21.6483251937909, -5.915599114500022],
            [21.657797277183377, -5.899997860564756],
            [21.663788396934699, -5.894730983705873],
            [21.664999437328806, -5.876339006109507],
            [21.666425758082422, -5.873858885010387],
            [21.666847317682318, -5.873125864300793],
            [21.671222396983595, -5.869922921864552],
            [21.675474357683616, -5.867162058669622],
            [21.679462797595068, -5.860773296475807],
            [21.681602637602428, -5.853076242571166],
            [21.683881437102794, -5.846489029407704],
            [21.685550037081782, -5.83909692123019],
            [21.68703647758581, -5.833439510557476],
            [21.690330476663469, -5.821500041245888],
            [21.69293975647539, -5.813655239973608],
            [21.695371916361033, -5.80722928287453],
            [21.697605356329465, -5.80364495122793],
            [21.70278071597129, -5.801078296172345],
            [21.709045436507012, -5.798537270178374],
            [21.713905076055696, -5.796279526135793],
            [21.718838516696586, -5.789121456450772],
            [21.724674836063215, -5.784040179056785],
            [21.729086636696678, -5.780506799972414],
            [21.73239503666667, -5.777896288018995],
            [21.737125076269336, -5.773895954111576],
            [21.741524996683182, -5.771152902542157],
            [21.74341139679607, -5.769931990932692],
            [21.746630516803236, -5.769724531011263],
            [21.750351314455564, -5.769718972497622],
            [21.750670855083563, -5.773266160324011],
            [21.751014236100929, -5.777079906832892],
            [21.754362236503603, -5.779264930212247],
            [21.754911236499595, -5.779624975819034],
            [21.755132276856724, -5.78261488866446],
            [21.751657196282395, -5.791570902576429],
            [21.75260614331085, -5.794669005336841],
            [21.753702356553777, -5.798247880641087],
            [21.756214436855291, -5.802856936661691],
            [21.763775227818346, -5.809093727102951],
            [21.767361827946981, -5.810685247596914],
            [21.77318015675344, -5.813266887070869],
            [21.779150396064299, -5.813978865985589],
            [21.78121031655412, -5.816055989686947],
            [21.78226912484687, -5.819705805692118],
            [21.783481196506912, -5.823883903170935],
            [21.78691847597408, -5.826425890085128],
            [21.787522228286665, -5.828176371851823],
            [21.790333436798033, -5.836326939934041],
            [21.8049275234977, -5.845737014028758],
            [21.812570276747262, -5.850664896060326],
            [21.816327908021176, -5.855715123015008],
            [21.82217831656472, -5.863577935346516],
            [21.83079707679407, -5.864900470820349],
            [21.841035836348905, -5.864447972940384],
            [21.850944476714925, -5.86329485523739],
            [21.862211396740005, -5.862520012629404],
            [21.870415076019292, -5.861326910918932],
            [21.878246440444197, -5.858946997722673],
            [21.876886431528256, -5.852962936239958],
            [21.878296191839578, -5.84307885765068],
            [21.875122432262717, -5.829268891786974],
            [21.87630148275122, -5.824034775402951],
            [21.878383312252485, -5.814792862994926],
            [21.880914471872355, -5.813421977080454],
            [21.882526598362677, -5.810448064531887],
            [21.885767271648469, -5.804469899772858],
            [21.895910271692347, -5.792776885112128],
            [21.896280537489517, -5.792224914288049],
            [21.896484472127014, -5.791920899689513],
            [21.907449591454277, -5.775568664858091],
            [21.923345151049389, -5.760674924167645],
            [21.923631132415021, -5.760480134581546],
            [21.936460113124724, -5.751741877664522],
            [21.941993714613638, -5.74449204498354],
            [21.942230395538196, -5.744181955319933],
            [21.946154376836382, -5.734401508968019],
            [21.95218223588623, -5.719376858026227],
            [21.960300235650323, -5.693646030455113],
            [21.960615714096647, -5.690622983007643],
            [21.960907195846772, -5.687829873655605],
            [21.961956235859155, -5.677782911506183],
            [21.967531195783764, -5.656871898307656],
            [21.971228028180928, -5.648020951220638],
            [21.975397195652789, -5.638038974928361],
            [21.977262355100773, -5.628385892935276],
            [21.977056435186523, -5.620564951565687],
            [21.974350325970132, -5.604225979197392],
            [21.970472395906651, -5.595472868720095],
            [21.961078195550989, -5.588311009270957],
            [21.958520013709062, -5.585086422449089],
            [21.957418435727309, -5.583697877535974],
            [21.956434821813698, -5.581328662882727],
            [21.954454195614002, -5.576557934717015],
            [21.953613640206019, -5.57587957448821],
            [21.951019435921221, -5.573785949749863],
            [21.950411395949793, -5.573601915611949],
            [21.944135186859889, -5.57169198443188],
            [21.943701067015674, -5.570944859867909],
            [21.940252195688092, -5.565008927704447],
            [21.93960239573406, -5.55212602312063],
            [21.936876910755309, -5.54688339241993],
            [21.932296195407361, -5.538072011791521],
            [21.925689475463173, -5.520567883092078],
            [21.919190256909069, -5.516531075815096],
            [21.916752475366355, -5.51501690934627],
            [21.909897550909175, -5.50554340547847],
            [21.904405195566525, -5.497952861517147],
            [21.893171395527631, -5.491704004403335],
            [21.889114333311674, -5.487804304990864],
            [21.878605435977846, -5.477702901582141],
            [21.8741781564737, -5.471165889793496],
            [21.872268348959448, -5.464794061561229],
            [21.870313196286276, -5.458270874641045],
            [21.861633236531567, -5.444439956563475],
            [21.860271356424871, -5.439375010318765],
            [21.852483476747892, -5.432905931552614],
            [21.849253088273805, -5.4262637239947],
            [21.846096356263121, -5.419772895209602],
            [21.846776886684694, -5.415324634104149],
            [21.846800012015073, -5.41517349248251],
            [21.829569836182142, -5.419940112730204],
            [21.82519007665822, -5.422690037066586],
            [21.824243198449846, -5.42370153170186],
            [21.821969875977778, -5.426129981831065],
            [21.819869996627499, -5.431340008168465],
            [21.820638919476398, -5.432733606937615],
            [21.824399876313468, -5.439549936509635],
            [21.824190003811957, -5.448909610758522],
            [21.823543272502942, -5.449466725924398],
            [21.820740116489787, -5.451880045082412],
            [21.816480194919727, -5.45235683953898],
            [21.812699876693316, -5.452779953337641],
            [21.804661494612837, -5.451830166368201],
            [21.798658077823578, -5.46330076465519],
            [21.794911166145962, -5.464978910398199],
            [21.794060156144692, -5.465360054886631],
            [21.779949956854303, -5.465759945854943],
            [21.773683706487621, -5.466923704513547],
            [21.766650116103595, -5.468229969622002],
            [21.760769876306075, -5.464780042678374],
            [21.760471314933188, -5.463809598140802],
            [21.75872031069656, -5.458100834937712],
            [21.758732106474547, -5.457623703024559],
            [21.758989894215009, -5.447285716898127],
            [21.754410116708232, -5.441979881120876],
            [21.748492831286743, -5.439205863638077],
            [21.747990373005603, -5.438970310443094],
            [21.747344653199587, -5.438912658839501],
            [21.73191983686452, -5.437539985469074],
            [21.72620015655102, -5.432220033051769],
            [21.715179836647849, -5.432410032493761],
            [21.71197007618764, -5.430789924998538],
            [21.709465951366223, -5.427118735417799],
            [21.70488995666512, -5.420410007026926],
            [21.693189956146636, -5.417139937570172],
            [21.69033443643724, -5.414611929310887],
            [21.687639555263573, -5.401744885214289],
            [21.686375419046325, -5.395729506047651],
            [21.682929956825227, -5.395260015480426],
            [21.675959996807702, -5.398200063804321],
            [21.666980156953269, -5.397750068597724],
            [21.658780077223319, -5.392760083672321],
            [21.654029877629057, -5.385949946859394],
            [21.653590893407593, -5.379733269384505],
            [21.653589957363085, -5.379720007480483],
            [21.656369877553114, -5.371919976451968],
            [21.666980156953269, -5.357930051989633],
            [21.663857017442645, -5.341981900475506],
            [21.663600117237685, -5.3406700354067],
            [21.664097893499552, -5.330317360495205],
            [21.662712040951181, -5.328724510181993],
            [21.659280117239707, -5.324779956613997],
            [21.655968076397876, -5.324283436122023],
            [21.653210157745789, -5.323869985831593],
            [21.65114995249002, -5.325380806778954],
            [21.648260157560973, -5.32749999046733],
            [21.646465304758689, -5.326993175995235],
            [21.645709917724488, -5.326779876550614],
            [21.64160987741036, -5.32562999090127],
            [21.632052269911256, -5.319533843923212],
            [21.628550157233398, -5.31730006943185],
            [21.628488621738128, -5.317283557419771],
            [21.624192781031422, -5.316130857054162],
            [21.624441474227936, -5.310844099647521],
            [21.629274476931819, -5.307533889652686],
            [21.63264139585436, -5.305228705506453],
            [21.634798170003176, -5.303752050520887],
            [21.635757360520834, -5.301372418202478],
            [21.638038316876202, -5.295712983597074],
            [21.638871054246245, -5.289357484289834],
            [21.639454197409584, -5.284906860747495],
            [21.639364338931692, -5.27732743980661],
            [21.639274197484514, -5.269724022251816],
            [21.635648277197561, -5.256137877844563],
            [21.637565277522306, -5.232681940685302],
            [21.649676458505894, -5.219016006504217],
            [21.656461352100184, -5.211359915565512],
            [21.658492871453941, -5.205322333250321],
            [21.662491316801031, -5.193438944392549],
            [21.662046372257656, -5.189066136820482],
            [21.66602061788927, -5.179207087732958],
            [21.671768156756357, -5.164948959601801],
            [21.672968462282817, -5.160719032221643],
            [21.675485156331657, -5.151850005147802],
            [21.689790475989998, -5.129588855760028],
            [21.692123276815352, -5.11832497269044],
            [21.693113276852291, -5.096703856954816],
            [21.688808396398894, -5.080123924506121],
            [21.687618236445253, -5.07009694936009],
            [21.687469196058153, -5.068845877333888],
            [21.689811589992409, -5.054821953651532],
            [21.694029836021532, -5.053970340637918],
            [21.702552836739891, -5.053982369108725],
            [21.707948156065569, -5.05535608420708],
            [21.713737676799145, -5.05820529512819],
            [21.721367156542062, -5.060275368627505],
            [21.72621275632121, -5.062031093077081],
            [21.73477175612625, -5.064267749388661],
            [21.737197436463767, -5.065331050713513],
            [21.74465663605304, -5.068331733003259],
            [21.749311076136312, -5.069720497255402],
            [21.753021596163478, -5.070015806743559],
            [21.75846443636765, -5.074355493582466],
            [21.76331291614559, -5.076296800210459],
            [21.77485019673184, -5.079399754806927],
            [21.779707316506165, -5.08189700699714],
            [21.783979436299482, -5.082551881511951],
            [21.787892996242075, -5.083955693534914],
            [21.794372636014607, -5.08363849022244],
            [21.801843250496162, -5.083486442022098],
            [21.801966836221382, -5.083483927086433],
            [21.80933027629963, -5.071593959421283],
            [21.808212476540454, -5.062387981755784],
            [21.809448964409903, -5.059622239485689],
            [21.810985196733483, -5.056186021141692],
            [21.811647220961916, -5.044698994154291],
            [21.811714196654542, -5.043536864546444],
            [21.812759958714448, -5.041536383206265],
            [21.813518156577203, -5.040085990761444],
            [21.81471623607835, -5.037794852423104],
            [21.820007376882209, -5.034133096643188],
            [21.822078607161423, -5.029651007647961],
            [21.823934396282716, -5.025634917037404],
            [21.835411195995821, -5.02544586987973],
            [21.838857476582142, -5.024307995886084],
            [21.842298338530668, -5.021277650376542],
            [21.844841396336491, -5.019037985624115],
            [21.847759916693395, -5.01597764729803],
            [21.851825756347989, -5.015338503957064],
            [21.856291916734275, -5.016545873474634],
            [21.860949236816371, -5.018120208520411],
            [21.8648419163185, -5.018226313246292],
            [21.868537316801088, -5.017594892487087],
            [21.872612155778238, -5.017511947811057],
            [21.876501955281572, -5.017432773214819],
            [21.879841675912264, -5.017735646982473],
            [21.883202635411234, -5.019336370575879],
            [21.885102355743143, -5.022264916442419],
            [21.885338155420385, -5.025412835830184],
            [21.885406555841076, -5.029676705032446],
            [21.882517555921027, -5.034371774507848],
            [21.877919635140472, -5.036505298549395],
            [21.87165167527985, -5.038487293472912],
            [21.868158236734367, -5.042434748355253],
            [21.868469636829268, -5.048009760063889],
            [21.872618635326404, -5.052561435177019],
            [21.880257475514572, -5.055187691361565],
            [21.883812475606476, -5.057340713274342],
            [21.894826675287625, -5.062494258413724],
            [21.908469595221742, -5.06981977089549],
            [21.916108435409914, -5.072445775914941],
            [21.920951155190231, -5.074016203803765],
            [21.931771315176739, -5.078617420548784],
            [21.93958907551503, -5.080868918251173],
            [21.948297475931614, -5.080877175597148],
            [21.959578075501859, -5.079535110004606],
            [21.967724875253964, -5.079183795892452],
            [21.986731435425256, -5.074346697486671],
            [21.992422675076853, -5.071078380559465],
            [21.999592795909372, -5.067594623595739],
            [22.00421447533256, -5.066944222325701],
            [22.007365915367906, -5.067065577418596],
            [22.010517715627689, -5.06718675413236],
            [22.013684275207581, -5.068234971425015],
            [22.016656795092835, -5.068730805560846],
            [22.020023155263257, -5.07002388497432],
            [22.027159259590881, -5.085042248501969],
            [22.028234395662277, -5.087304905478184],
            [22.032999355474978, -5.106184883472991],
            [22.034742473401757, -5.138167945503568],
            [22.036817509842837, -5.134953984274786],
            [22.046707430216678, -5.127854859511163],
            [22.053562214536676, -5.12447704946534],
            [22.073139349542117, -5.114829986459706],
            [22.076786254474133, -5.110793617702414],
            [22.079357269648188, -5.10794802021482],
            [22.088121468918679, -5.093252911540405],
            [22.088934277164146, -5.092551260296353],
            [22.091572428829313, -5.090273888360652],
            [22.098753349208138, -5.067291952648647],
            [22.10272414890235, -5.042458984993947],
            [22.103008189008655, -5.041766009541056],
            [22.105730148998227, -5.035106947571706],
            [22.11516538888765, -5.025704934422376],
            [22.117167206344877, -5.022026175526023],
            [22.118164182698312, -5.020193844579712],
            [22.118136063633301, -5.019514758810609],
            [22.117735429389626, -5.009838973632775],
            [22.114084309562326, -5.002234850662515],
            [22.11504406961188, -4.999596349523062],
            [22.119588349291888, -4.994125590187462],
            [22.124517828362343, -4.989574219785771],
            [22.125205068300804, -4.986221805717578],
            [22.12623322877101, -4.981008041071443],
            [22.127305668099918, -4.978575211880446],
            [22.122042469392976, -4.973860165161883],
            [22.117919749312904, -4.970976647142118],
            [22.110266148906256, -4.967423042820645],
            [22.103718109611396, -4.963476026816911],
            [22.102305472894503, -4.956271400635464],
            [22.100648394707356, -4.945362324596626],
            [22.101416634836625, -4.935516402060027],
            [22.104963354258253, -4.925613950523364],
            [22.105221115049233, -4.918560457329291],
            [22.102165074300444, -4.912872644976104],
            [22.096898634471941, -4.907971814693069],
            [22.092582234921661, -4.904535483052562],
            [22.084937274511432, -4.901537814152901],
            [22.082048995040253, -4.894733481809151],
            [22.080071874965128, -4.886983285636716],
            [22.079315169204087, -4.883180053579223],
            [22.080413121585359, -4.881600327433733],
            [22.085537394935315, -4.874227945043619],
            [22.089439434882699, -4.873320020297983],
            [22.097040414674932, -4.863681946026388],
            [22.104977850371981, -4.856679116258626],
            [22.111070411478469, -4.851303883299095],
            [22.113691580493175, -4.846205401278343],
            [22.116148153893302, -4.841427040215835],
            [22.121435154362008, -4.837532886412286],
            [22.126487394504245, -4.835938005150767],
            [22.135223154909454, -4.829754905999918],
            [22.143028314579229, -4.828628903514557],
            [22.150133274315991, -4.831182968053059],
            [22.155191274455817, -4.827287935463054],
            [22.171724274983259, -4.822739002620112],
            [22.177242354482392, -4.818614945505839],
            [22.177396799134264, -4.818325259014066],
            [22.177650234537154, -4.817849898772502],
            [22.180483519146627, -4.812532106679575],
            [22.183239234231337, -4.807359863385126],
            [22.191742433385908, -4.802324997940414],
            [22.199124581778278, -4.793388075406519],
            [22.201410233627641, -4.790621012225513],
            [22.202310868361796, -4.789937319130521],
            [22.20623819408781, -4.786955987971226],
            [22.223253225206836, -4.78246184441286],
            [22.223032193832875, -4.769752899891379],
            [22.228323295110826, -4.764476186684767],
            [22.224893446507714, -4.760093931292206],
            [22.225631892213954, -4.758414023086487],
            [22.226509433957126, -4.756417898398547],
            [22.225607110390229, -4.750663863485926],
            [22.221826414871401, -4.750537009384515],
            [22.218038425930775, -4.750409909226005],
            [22.215531956506496, -4.743544708927932],
            [22.212572393920908, -4.735437914901817],
            [22.211856011736309, -4.734835819652968],
            [22.209825233492662, -4.733129017289576],
            [22.20386327395375, -4.731959927520185],
            [22.20287328828983, -4.728950943836084],
            [22.2024992342971, -4.727814033309026],
            [22.201931873635001, -4.721807314395165],
            [22.204289513776295, -4.718605326466144],
            [22.210216554003463, -4.718484625643652],
            [22.217810393985804, -4.718329976895152],
            [22.224063233403584, -4.715419668059839],
            [22.230307433723276, -4.71195271505132],
            [22.236960593872713, -4.710889563581596],
            [22.242840114119655, -4.707801221753254],
            [22.248137154159988, -4.703054985109413],
            [22.250297154158975, -4.69911467139112],
            [22.25339027376943, -4.68402246990613],
            [22.253659553657322, -4.677708477992673],
            [22.25412611166643, -4.672132515167046],
            [22.256289355481901, -4.668377403035191],
            [22.262547953100647, -4.665837815863347],
            [22.270067631766405, -4.661046024448114],
            [22.273500593930326, -4.655594952285524],
            [22.278950273907096, -4.648804137177852],
            [22.280528153923871, -4.643205306984828],
            [22.282264073650239, -4.63593312266756],
            [22.283112951949327, -4.631091362836258],
            [22.286043343542737, -4.626374981643743],
            [22.289247353886825, -4.628454996138631],
            [22.295865995373127, -4.630019863856148],
            [22.299106312027735, -4.630785982360245],
            [22.301902099160635, -4.633361148637383],
            [22.304369326580044, -4.635633674435209],
            [22.311250194382634, -4.635883901482778],
            [22.313173175690519, -4.635422347809029],
            [22.318824232801148, -4.6340659808796],
            [22.322492375703078, -4.634766997799882],
            [22.328674193416202, -4.639156867897879],
            [22.33900619270764, -4.635276014561344],
            [22.341535058030288, -4.636552893586414],
            [22.344032500284268, -4.63781390347678],
            [22.345116434455534, -4.637160723509712],
            [22.350479393769739, -4.633928917977941],
            [22.355528251754937, -4.633713898806641],
            [22.358832535644297, -4.63671477700671],
            [22.360103428090817, -4.637868855428243],
            [22.361063447753491, -4.63771136735124],
            [22.362858020281418, -4.637416973860847],
            [22.365139314403326, -4.642254861673888],
            [22.369724272494327, -4.643418890964096],
            [22.377487074801834, -4.641815577706314],
            [22.385101311032702, -4.640242945951712],
            [22.388548312067861, -4.637951876898588],
            [22.395231352878586, -4.625547003481911],
            [22.397798266345095, -4.623577778861979],
            [22.398220434104427, -4.623253909443384],
            [22.40502336946286, -4.622233298079593],
            [22.411758231387378, -4.621222897978473],
            [22.413826433445774, -4.619617993253531],
            [22.420329008105831, -4.620629076222832],
            [22.42437350828088, -4.621257904371056],
            [22.424496335827978, -4.619026436238146],
            [22.424614192996636, -4.616887986853841],
            [22.430618272742549, -4.600338871706397],
            [22.435015981504176, -4.5913967612876],
            [22.442144357625409, -4.576901989157448],
            [22.440786472326774, -4.569765944390074],
            [22.446077392145078, -4.5631079592741],
            [22.446790191848283, -4.55275687739007],
            [22.449562957855399, -4.546580505661757],
            [22.450710232237373, -4.544024921626244],
            [22.4530433914905, -4.528614965322418],
            [22.456718271757058, -4.525404012245268],
            [22.461347336230219, -4.508160676058602],
            [22.464485271891895, -4.505199902701338],
            [22.46775024280948, -4.502118028355373],
            [22.469854312800553, -4.500131944359669],
            [22.477890232598821, -4.496012977745937],
            [22.487524188812237, -4.495578886060101],
            [22.491093597881282, -4.492016418645034],
            [22.499019351886375, -4.484106017333568],
            [22.511699630873849, -4.472153227749868],
            [22.518686511558037, -4.460228982461421],
            [22.523407191613778, -4.451039865959371],
            [22.528698471656483, -4.443691867037226],
            [22.528654270951233, -4.443395297961454],
            [22.528604152144904, -4.44305901621158],
            [22.5264798206526, -4.428888009750547],
            [22.526214489758715, -4.427118016400347],
            [22.528942039964289, -4.414770304272457],
            [22.529922468451925, -4.410331822993895],
            [22.527694431849937, -4.382483940849591],
            [22.535791190949158, -4.352133971942457],
            [22.530683617280342, -4.341229874135669],
            [22.527805353126272, -4.335085030525071],
            [22.529477287651616, -4.330886124732031],
            [22.533352191290913, -4.321155019976846],
            [22.533571431424228, -4.320604912814303],
            [22.534754391380829, -4.305192941463404],
            [22.529739230998583, -4.292523930849798],
            [22.53183119080132, -4.280563899646075],
            [22.529742242151389, -4.27634565883997],
            [22.528408311328121, -4.273652023342258],
            [22.530254391457817, -4.268365001416046],
            [22.528433510868499, -4.263067877224174],
            [22.528236230950629, -4.248571005999354],
            [22.526424350582133, -4.239131958599668],
            [22.523454352267859, -4.234061996381556],
            [22.522515308267074, -4.230633969148307],
            [22.521183472315037, -4.225772011142314],
            [22.524914127180981, -4.198861078222212],
            [22.542528233084862, -4.215935995019917],
            [22.557651320587347, -4.220777926015669],
            [22.578375231409805, -4.227413012669769],
            [22.580409407081877, -4.228063832392028],
            [22.582391388839326, -4.228697953351436],
            [22.582701092915009, -4.228944649399282],
            [22.586740191520242, -4.23216200637269],
            [22.595222149111613, -4.232414002496018],
            [22.608268191540041, -4.242803019178419],
            [22.617813714901928, -4.243178199226026],
            [22.627067389102706, -4.243541908368336],
            [22.637373296826713, -4.249090876121144],
            [22.642134756803088, -4.255921500275075],
            [22.647657229962256, -4.263843947333283],
            [22.653260425732867, -4.265904114463737],
            [22.662779389505069, -4.26940400716701],
            [22.673759390323347, -4.280706960559364],
            [22.67878320597336, -4.290384011526106],
            [22.681930270314979, -4.296300843293986],
            [22.683807350406777, -4.299829939345513],
            [22.703241230175589, -4.32610992044603],
            [22.708055510192331, -4.326581847467245],
            [22.713037690725567, -4.334452417334631],
            [22.714912428909436, -4.337414001107978],
            [22.720409270438623, -4.339958879286551],
            [22.721982048024582, -4.342204807025075],
            [22.725897403699442, -4.347795907772346],
            [22.746280309548453, -4.360040874191092],
            [22.748338428916131, -4.36257687056633],
            [22.749636383110577, -4.367566456322299],
            [22.750614349316002, -4.371325926138204],
            [22.755190308982815, -4.376398915824857],
            [22.755520429069932, -4.383133016698425],
            [22.755628429923302, -4.385373871466608],
            [22.759585520427944, -4.390638643032776],
            [22.772781348845161, -4.40819496222611],
            [22.783556148401399, -4.410291985132169],
            [22.787677429380391, -4.413061948886273],
            [22.802772228036279, -4.434036973220468],
            [22.811022075331291, -4.436817891873677],
            [22.813267894084291, -4.439199836676452],
            [22.815370427956225, -4.441429989108416],
            [22.817177893105121, -4.444814427828515],
            [22.818569387971795, -4.447419960215223],
            [22.820839188149641, -4.459619864302615],
            [22.822433100399287, -4.462751077686424],
            [22.825178183922578, -4.468143714119726],
            [22.827692147991307, -4.473210986845888],
            [22.830611673562991, -4.476398402343661],
            [22.83318322862457, -4.479205905512429],
            [22.847845307909751, -4.487814857860617],
            [22.8693794290499, -4.50045894161108],
            [22.872122231750698, -4.505526832733927],
            [22.875313600103798, -4.508098931781353],
            [22.877847534619566, -4.510141229475644],
            [22.88406238787725, -4.51843029593387],
            [22.894925387621338, -4.520266842075777],
            [22.90693210801215, -4.523479080358434],
            [22.919164548084371, -4.526404199981984],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Luebo",
        AREA: 95631,
        POPULATION: 2801000,
        DISTRICTS: ["Luebo", "Dekese", "Mweka", "Ilebo", "Kamonia"],
        OBJECTID: 8,
        NOM: "Kasaï",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [21.755350439909986, -2.491279012414994],
            [21.768827399688636, -2.497998883818929],
            [21.774570276299393, -2.50454027670613],
            [21.776121359571249, -2.506307023759074],
            [21.79439538225591, -2.51534401715335],
            [21.812898250759179, -2.524842010986355],
            [21.817903499130587, -2.526390353964982],
            [21.830955557576466, -2.53042790537128],
            [21.845094475108205, -2.545429880161142],
            [21.851230491318251, -2.558564120447099],
            [21.87087047515595, -2.570595922552828],
            [21.876504101356804, -2.572177204520938],
            [21.893276155259443, -2.576884879108303],
            [21.898750315226014, -2.581964958998033],
            [21.899898716095347, -2.582464605885377],
            [21.90354947569821, -2.584052979352132],
            [21.919103275735051, -2.585946905618473],
            [21.921646542848297, -2.590030523701924],
            [21.925707475904844, -2.596550965809856],
            [21.935328084051459, -2.604869020585537],
            [21.936660475162302, -2.606021012037961],
            [21.948541195156398, -2.612502977856179],
            [21.963596395176268, -2.628196964397262],
            [21.974310355431548, -2.64180589126843],
            [21.97537103311846, -2.642343872186186],
            [21.977508359639675, -2.643427926822313],
            [21.991042815189754, -2.649733084958825],
            [21.994419234694735, -2.651306017162858],
            [22.014717450972022, -2.674378958430429],
            [22.013899194444356, -2.681904965638088],
            [22.013542434817449, -2.685186979939236],
            [22.021717315007056, -2.706608964848584],
            [22.026430439332909, -2.716352453223774],
            [22.032863274184169, -2.729650988775138],
            [22.050195474378853, -2.750872888531722],
            [22.05590831491979, -2.753882877598966],
            [22.063434474930308, -2.763109921146824],
            [22.06785710744947, -2.766981524418611],
            [22.075304394479737, -2.773500902359841],
            [22.07872439485244, -2.778572955061815],
            [22.079941194345803, -2.785254889647877],
            [22.082329434698927, -2.798369861247713],
            [22.084943044390489, -2.803663871241351],
            [22.085287194365737, -2.804360963445308],
            [22.102640275000887, -2.818910962131422],
            [22.109247354271183, -2.829974864776407],
            [22.123804314498479, -2.862461025373217],
            [22.12620221802911, -2.865856545801046],
            [22.134063234044945, -2.876987961966225],
            [22.137952156792544, -2.885570895394831],
            [22.141239473302825, -2.89282602052005],
            [22.142935434168773, -2.89657093927423],
            [22.14998499120864, -2.902762413575861],
            [22.151611434149675, -2.904190879255768],
            [22.157259239359014, -2.91100927481975],
            [22.166897290991766, -2.922644858697647],
            [22.173163958176733, -2.926255399419181],
            [22.181753153951743, -2.931203957205152],
            [22.189593735989831, -2.930499155283493],
            [22.206482272638738, -2.928981015886183],
            [22.210929247705479, -2.926934342565303],
            [22.215421625423286, -2.924866985444578],
            [22.221348831838785, -2.928797782089819],
            [22.218772314483605, -2.93075090965959],
            [22.214764072110043, -2.937773215578511],
            [22.209900472787588, -2.940355045352038],
            [22.198205513614479, -2.945548925383389],
            [22.188477593622334, -2.950712542351974],
            [22.181230434169404, -2.956841246283716],
            [22.176178194027166, -2.973467230109849],
            [22.169888633277171, -3.001144360593172],
            [22.164214313393938, -3.011761712150678],
            [22.163951919092725, -3.012070466083606],
            [22.159896473844245, -3.016842403197896],
            [22.149228233345337, -3.024025954841639],
            [22.138122594151408, -3.033723213117739],
            [22.127990034327762, -3.042904210557983],
            [22.108948770440438, -3.063046823499037],
            [22.108269954902728, -3.0637648951692],
            [22.103109354581012, -3.075376682723922],
            [22.101304674209516, -3.082925716087294],
            [22.106941914332758, -3.093369301042884],
            [22.112022234912466, -3.10081292442116],
            [22.114654554714807, -3.108795129595725],
            [22.11395255455794, -3.121842523280825],
            [22.111970034709628, -3.143934353855948],
            [22.108182474265416, -3.173574263652885],
            [22.10630868649908, -3.179342312818073],
            [22.102482954841808, -3.191118893740075],
            [22.095672834757757, -3.209362856619658],
            [22.086610194488628, -3.222536727405202],
            [22.073623914281104, -3.236271846468576],
            [22.055784834297469, -3.253088967574743],
            [22.03544303445754, -3.270404949205942],
            [22.027736874521953, -3.275576670917171],
            [22.01607431488619, -3.282272230484736],
            [22.00636835421119, -3.288436581980947],
            [21.998170076501719, -3.296081735432494],
            [21.996333000186134, -3.302125626331154],
            [21.996064079624375, -3.335216123517297],
            [21.996356400400956, -3.348746539313768],
            [21.996156960034835, -3.362284322024501],
            [21.995683200232101, -3.380630905169111],
            [21.991456430987586, -3.394479299163069],
            [21.989439360136846, -3.401087869461569],
            [21.983770440026763, -3.408880917248692],
            [21.977249399597767, -3.417843851143199],
            [21.97291764783926, -3.421896183681683],
            [21.969898199963531, -3.424720850694478],
            [21.941215194164247, -3.441650058464167],
            [21.939488999599121, -3.450970830379313],
            [21.938780159669658, -3.453863302572894],
            [21.938072040189059, -3.456755765835884],
            [21.937363559585734, -3.459648040523761],
            [21.936655440105138, -3.462540485903866],
            [21.935947319726246, -3.465432742695081],
            [21.935238840021217, -3.468324990527003],
            [21.934530719642325, -3.471217409027274],
            [21.933822600161729, -3.474109638917955],
            [21.933114120456732, -3.47700203946089],
            [21.932406000077808, -3.479894250477829],
            [21.931697879698916, -3.482786453401006],
            [21.930989399993884, -3.485678826952508],
            [21.930281279614992, -3.488571011860031],
            [21.930127199679141, -3.491177874066612],
            [21.929973479967725, -3.493784549310126],
            [21.929819760256308, -3.496391217216659],
            [21.929665680320454, -3.498997876878088],
            [21.929511959710709, -3.501604350465262],
            [21.929358239999292, -3.504210995426027],
            [21.93029928005663, -3.506398125639408],
            [21.936872880014601, -3.519446682990361],
            [21.938280840102138, -3.522161931674659],
            [21.938771160347134, -3.524988522374899],
            [21.939261120367725, -3.527814924746774],
            [21.939750720163875, -3.530641318408407],
            [21.940240680184466, -3.533467882975671],
            [21.940730640205025, -3.536294259195371],
            [21.941220240001176, -3.539120626684042],
            [21.941710200021767, -3.541946986337301],
            [21.941650080271387, -3.54487982789],
            [21.941589959622675, -3.547812480398569],
            [21.941529839872295, -3.550745122573809],
            [21.941469720121884, -3.553677756213177],
            [21.940934040344917, -3.556168949882778],
            [21.940399080118492, -3.558660135828528],
            [21.939863759667666, -3.561151314948287],
            [21.939328800339542, -3.563642488139886],
            [21.938793840113117, -3.566133653593424],
            [21.938258519662259, -3.568624812206708],
            [21.9387160801455, -3.570618958081866],
            [21.939173280404308, -3.572613098665789],
            [21.939630479764784, -3.574607055243937],
            [21.940890480138499, -3.577138843840965],
            [21.942150479613879, -3.579670264318367],
            [21.943410119763154, -3.582201859124173],
            [21.944670120136866, -3.584733265416162],
            [21.950162621006577, -3.587560390175679],
            [21.956517143426307, -3.591505175861764],
            [21.957249960289001, -3.591959958911389],
            [21.957989907080126, -3.597376665359837],
            [21.9585600004173, -3.601549952373689],
            [21.963189959612468, -3.600739983352091],
            [21.963320416551316, -3.600759434429856],
            [21.970969919741901, -3.601899985650519],
            [21.971137907394979, -3.60116728419966],
            [21.973290119898763, -3.591780084081674],
            [21.989130119591866, -3.580099992269147],
            [21.990855579335065, -3.579350270255999],
            [21.992490000214151, -3.578640105104099],
            [21.993478774050757, -3.578207810416086],
            [21.996470160353621, -3.576899965032155],
            [22.004259840254413, -3.577850081538345],
            [22.01459004022033, -3.572360009208063],
            [22.028780159926622, -3.575860089039588],
            [22.030459586401431, -3.574994870404966],
            [22.041630000415527, -3.569240000967351],
            [22.059460080178347, -3.580800075354441],
            [22.061867354035702, -3.583888198092463],
            [22.061970000031643, -3.584019875075342],
            [22.086259919799801, -3.582259959029874],
            [22.099681944005553, -3.576228247170219],
            [22.107599741632185, -3.572670056510535],
            [22.114400040435235, -3.574809958471592],
            [22.116861801606138, -3.572635519866135],
            [22.118169959763915, -3.571480039816811],
            [22.122528120195156, -3.570345990311205],
            [22.124433403793628, -3.572415727814434],
            [22.128656400113968, -3.578028879655061],
            [22.136600159950614, -3.604975991418748],
            [22.137174752050747, -3.609816054516605],
            [22.13772048038248, -3.614412956290514],
            [22.139007242466789, -3.635823928754981],
            [22.139080200040922, -3.637037881721451],
            [22.139139547240166, -3.638025091380076],
            [22.140127439829453, -3.654457922795046],
            [22.134771359813715, -3.685273958943621],
            [22.134671914515135, -3.686748958311586],
            [22.133096280286569, -3.710118954295656],
            [22.138767340183669, -3.731076865327917],
            [22.138583285263405, -3.732848505606416],
            [22.137523199566278, -3.743050880506535],
            [22.141122624043945, -3.757287201270086],
            [22.142208186860813, -3.76158100315726],
            [22.132916280361531, -3.771656629315621],
            [22.132083959809744, -3.778684145204834],
            [22.138607520013132, -3.784596981996982],
            [22.144574159774685, -3.787512113460261],
            [22.151567520007031, -3.792415662059136],
            [22.156080479924636, -3.796355096854538],
            [22.156242839632469, -3.803868314613136],
            [22.152919320117931, -3.809430487211198],
            [22.14856908013256, -3.813004249965988],
            [22.140349199737123, -3.819643175130378],
            [22.131145799751202, -3.826297155005063],
            [22.119537599868227, -3.835493089790996],
            [22.109382719604739, -3.843664472276442],
            [22.101163200332032, -3.850303336797705],
            [22.078929959932172, -3.86867929722349],
            [22.068305279639684, -3.877859663877581],
            [22.058107559618573, -3.884027502597009],
            [22.047352920053967, -3.887197805365882],
            [22.03754939964416, -3.888850471902633],
            [22.029177959985592, -3.88847753914545],
            [22.020057360414334, -3.892447991512738],
            [22.012235280077864, -3.902546927953242],
            [22.009004313088745, -3.909668936590948],
            [21.995455320102405, -3.919517984646292],
            [21.987602280227968, -3.939509917686602],
            [21.980328365352619, -3.947345568626099],
            [21.976104239849995, -3.951895872570313],
            [21.971521084677729, -3.962098154611721],
            [21.968260200196376, -3.969356933284593],
            [21.968259546222857, -3.969455210390489],
            [21.968222120611479, -3.975075790548925],
            [21.968242700116321, -3.975062748854295],
            [21.971475073867197, -3.973014270071805],
            [21.972545644700304, -3.972343218060824],
            [21.97952132518958, -3.967857103946819],
            [21.988910155416423, -3.961829924969919],
            [21.994639915725759, -3.961159999598527],
            [22.004709683311027, -3.968330010165327],
            [22.005707122296865, -3.968276025076177],
            [22.020749994736065, -3.967460084662411],
            [22.029680155060319, -3.970710075209448],
            [22.043697089461322, -3.972821061943368],
            [22.048469994872683, -3.973539872452796],
            [22.049239389337128, -3.974013987883055],
            [22.057850154560445, -3.97932007878864],
            [22.081449954391349, -3.983310049775455],
            [22.089828803354408, -3.98656317511366],
            [22.091145877291378, -3.987075839096715],
            [22.092209994627474, -3.987490041096664],
            [22.093519077151665, -3.98837163342608],
            [22.099070154466141, -3.99210995867629],
            [22.105712755817727, -4.005547040337072],
            [22.106119501300256, -4.006369975450268],
            [22.107410918454391, -4.008982790430126],
            [22.111599954863728, -4.017459885873212],
            [22.117539954187194, -4.024390035052127],
            [22.120980114551454, -4.026240006621936],
            [22.125302211217289, -4.026940909733945],
            [22.135409994607091, -4.028580060713557],
            [22.139989914945975, -4.032050039234234],
            [22.146940668982754, -4.035082545881752],
            [22.156469994821741, -4.039240024105717],
            [22.162889874169966, -4.040180094770049],
            [22.16650086805015, -4.039424694268577],
            [22.167240114155337, -4.039270047567604],
            [22.178270153829903, -4.030790126736845],
            [22.184248736693096, -4.029547555210787],
            [22.186980720982945, -4.02897946223047],
            [22.188680917405442, -4.027961683673697],
            [22.193041653306597, -4.025355138595974],
            [22.193870033847517, -4.024859989013089],
            [22.197360021963981, -4.024045693354362],
            [22.201670153968578, -4.023040038335698],
            [22.209710033540617, -4.015929912869956],
            [22.222559874029521, -4.011830073410817],
            [22.225289502936683, -4.009721066518778],
            [22.234554689047865, -4.002562415939249],
            [22.238870034874317, -3.999230003706442],
            [22.247127059708436, -3.996490563361264],
            [22.252505033464264, -3.996719602495625],
            [22.262265353892051, -3.997308413309834],
            [22.271427401730516, -3.99792292023483],
            [22.271479695358153, -3.997925159344855],
            [22.272607786217211, -3.997973455376469],
            [22.281492229480044, -4.002347903726953],
            [22.282266577254951, -4.002853176455992],
            [22.292474540765223, -4.009514040249631],
            [22.293010115439298, -4.010064673697552],
            [22.30481950560657, -4.02220602065984],
            [22.312349266064754, -4.03603489445099],
            [22.316208465356258, -4.050312974250655],
            [22.322605305612392, -4.058384957253462],
            [22.326338146079404, -4.069723887011333],
            [22.329883425501617, -4.080496016712647],
            [22.339716292075103, -4.090649777165975],
            [22.364448465034062, -4.099926863871474],
            [22.372686348566095, -4.10570292590219],
            [22.381826384985118, -4.117464874250753],
            [22.384877679934277, -4.119478963874966],
            [22.387777184753251, -4.121392856026528],
            [22.398508425001367, -4.139141961457823],
            [22.403309384799083, -4.144217940004392],
            [22.410639344666713, -4.146769937576931],
            [22.417406263870447, -4.147188947787239],
            [22.426225184016463, -4.147734865754891],
            [22.441559383695552, -4.15882301113956],
            [22.443830983198918, -4.159843993526225],
            [22.447742383591589, -4.16160198880789],
            [22.467350178097696, -4.158911644584356],
            [22.467464270426987, -4.158895994740756],
            [22.467641750577666, -4.1589997684138],
            [22.47181342255254, -4.161438953541751],
            [22.47889930297098, -4.170202913281194],
            [22.482830566012872, -4.173195726296564],
            [22.49194318315449, -4.180132981438129],
            [22.495831000974324, -4.182365312146437],
            [22.503620503008694, -4.186837916408367],
            [22.513475334289208, -4.188245148918189],
            [22.524914127180981, -4.198861078222212],
            [22.521183472315037, -4.225772011142314],
            [22.522515308267074, -4.230633969148307],
            [22.523454352267859, -4.234061996381556],
            [22.526424350582133, -4.239131958599668],
            [22.528236230950629, -4.248571005999354],
            [22.528433510868499, -4.263067877224174],
            [22.530254391457817, -4.268365001416046],
            [22.528408311328121, -4.273652023342258],
            [22.529742242151389, -4.27634565883997],
            [22.53183119080132, -4.280563899646075],
            [22.529739230998583, -4.292523930849798],
            [22.534754391380829, -4.305192941463404],
            [22.533571431424228, -4.320604912814303],
            [22.533352191290913, -4.321155019976846],
            [22.529477287651616, -4.330886124732031],
            [22.527805353126272, -4.335085030525071],
            [22.530683617280342, -4.341229874135669],
            [22.535791190949158, -4.352133971942457],
            [22.527694431849937, -4.382483940849591],
            [22.529922468451925, -4.410331822993895],
            [22.528942039964289, -4.414770304272457],
            [22.526214489758715, -4.427118016400347],
            [22.5264798206526, -4.428888009750547],
            [22.528604152144904, -4.44305901621158],
            [22.528654270951233, -4.443395297961454],
            [22.528698471656483, -4.443691867037226],
            [22.523407191613778, -4.451039865959371],
            [22.518686511558037, -4.460228982461421],
            [22.511699630873849, -4.472153227749868],
            [22.499019351886375, -4.484106017333568],
            [22.491093597881282, -4.492016418645034],
            [22.487524188812237, -4.495578886060101],
            [22.477890232598821, -4.496012977745937],
            [22.469854312800553, -4.500131944359669],
            [22.46775024280948, -4.502118028355373],
            [22.464485271891895, -4.505199902701338],
            [22.461347336230219, -4.508160676058602],
            [22.456718271757058, -4.525404012245268],
            [22.4530433914905, -4.528614965322418],
            [22.450710232237373, -4.544024921626244],
            [22.449562957855399, -4.546580505661757],
            [22.446790191848283, -4.55275687739007],
            [22.446077392145078, -4.5631079592741],
            [22.440786472326774, -4.569765944390074],
            [22.442144357625409, -4.576901989157448],
            [22.435015981504176, -4.5913967612876],
            [22.430618272742549, -4.600338871706397],
            [22.424614192996636, -4.616887986853841],
            [22.424496335827978, -4.619026436238146],
            [22.42437350828088, -4.621257904371056],
            [22.420329008105831, -4.620629076222832],
            [22.413826433445774, -4.619617993253531],
            [22.411758231387378, -4.621222897978473],
            [22.40502336946286, -4.622233298079593],
            [22.398220434104427, -4.623253909443384],
            [22.397798266345095, -4.623577778861979],
            [22.395231352878586, -4.625547003481911],
            [22.388548312067861, -4.637951876898588],
            [22.385101311032702, -4.640242945951712],
            [22.377487074801834, -4.641815577706314],
            [22.369724272494327, -4.643418890964096],
            [22.365139314403326, -4.642254861673888],
            [22.362858020281418, -4.637416973860847],
            [22.361063447753491, -4.63771136735124],
            [22.360103428090817, -4.637868855428243],
            [22.358832535644297, -4.63671477700671],
            [22.355528251754937, -4.633713898806641],
            [22.350479393769739, -4.633928917977941],
            [22.345116434455534, -4.637160723509712],
            [22.344032500284268, -4.63781390347678],
            [22.341535058030288, -4.636552893586414],
            [22.33900619270764, -4.635276014561344],
            [22.328674193416202, -4.639156867897879],
            [22.322492375703078, -4.634766997799882],
            [22.318824232801148, -4.6340659808796],
            [22.313173175690519, -4.635422347809029],
            [22.311250194382634, -4.635883901482778],
            [22.304369326580044, -4.635633674435209],
            [22.301902099160635, -4.633361148637383],
            [22.299106312027735, -4.630785982360245],
            [22.295865995373127, -4.630019863856148],
            [22.289247353886825, -4.628454996138631],
            [22.286043343542737, -4.626374981643743],
            [22.283112951949327, -4.631091362836258],
            [22.282264073650239, -4.63593312266756],
            [22.280528153923871, -4.643205306984828],
            [22.278950273907096, -4.648804137177852],
            [22.273500593930326, -4.655594952285524],
            [22.270067631766405, -4.661046024448114],
            [22.262547953100647, -4.665837815863347],
            [22.256289355481901, -4.668377403035191],
            [22.25412611166643, -4.672132515167046],
            [22.253659553657322, -4.677708477992673],
            [22.25339027376943, -4.68402246990613],
            [22.250297154158975, -4.69911467139112],
            [22.248137154159988, -4.703054985109413],
            [22.242840114119655, -4.707801221753254],
            [22.236960593872713, -4.710889563581596],
            [22.230307433723276, -4.71195271505132],
            [22.224063233403584, -4.715419668059839],
            [22.217810393985804, -4.718329976895152],
            [22.210216554003463, -4.718484625643652],
            [22.204289513776295, -4.718605326466144],
            [22.201931873635001, -4.721807314395165],
            [22.2024992342971, -4.727814033309026],
            [22.20287328828983, -4.728950943836084],
            [22.20386327395375, -4.731959927520185],
            [22.209825233492662, -4.733129017289576],
            [22.211856011736309, -4.734835819652968],
            [22.212572393920908, -4.735437914901817],
            [22.215531956506496, -4.743544708927932],
            [22.218038425930775, -4.750409909226005],
            [22.221826414871401, -4.750537009384515],
            [22.225607110390229, -4.750663863485926],
            [22.226509433957126, -4.756417898398547],
            [22.225631892213954, -4.758414023086487],
            [22.224893446507714, -4.760093931292206],
            [22.228323295110826, -4.764476186684767],
            [22.223032193832875, -4.769752899891379],
            [22.223253225206836, -4.78246184441286],
            [22.20623819408781, -4.786955987971226],
            [22.202310868361796, -4.789937319130521],
            [22.201410233627641, -4.790621012225513],
            [22.199124581778278, -4.793388075406519],
            [22.191742433385908, -4.802324997940414],
            [22.183239234231337, -4.807359863385126],
            [22.180483519146627, -4.812532106679575],
            [22.177650234537154, -4.817849898772502],
            [22.177396799134264, -4.818325259014066],
            [22.177242354482392, -4.818614945505839],
            [22.171724274983259, -4.822739002620112],
            [22.155191274455817, -4.827287935463054],
            [22.150133274315991, -4.831182968053059],
            [22.143028314579229, -4.828628903514557],
            [22.135223154909454, -4.829754905999918],
            [22.126487394504245, -4.835938005150767],
            [22.121435154362008, -4.837532886412286],
            [22.116148153893302, -4.841427040215835],
            [22.113691580493175, -4.846205401278343],
            [22.111070411478469, -4.851303883299095],
            [22.104977850371981, -4.856679116258626],
            [22.097040414674932, -4.863681946026388],
            [22.089439434882699, -4.873320020297983],
            [22.085537394935315, -4.874227945043619],
            [22.080413121585359, -4.881600327433733],
            [22.079315169204087, -4.883180053579223],
            [22.080071874965128, -4.886983285636716],
            [22.082048995040253, -4.894733481809151],
            [22.084937274511432, -4.901537814152901],
            [22.092582234921661, -4.904535483052562],
            [22.096898634471941, -4.907971814693069],
            [22.102165074300444, -4.912872644976104],
            [22.105221115049233, -4.918560457329291],
            [22.104963354258253, -4.925613950523364],
            [22.101416634836625, -4.935516402060027],
            [22.100648394707356, -4.945362324596626],
            [22.102305472894503, -4.956271400635464],
            [22.103718109611396, -4.963476026816911],
            [22.110266148906256, -4.967423042820645],
            [22.117919749312904, -4.970976647142118],
            [22.122042469392976, -4.973860165161883],
            [22.127305668099918, -4.978575211880446],
            [22.12623322877101, -4.981008041071443],
            [22.125205068300804, -4.986221805717578],
            [22.124517828362343, -4.989574219785771],
            [22.119588349291888, -4.994125590187462],
            [22.11504406961188, -4.999596349523062],
            [22.114084309562326, -5.002234850662515],
            [22.117735429389626, -5.009838973632775],
            [22.118136063633301, -5.019514758810609],
            [22.118164182698312, -5.020193844579712],
            [22.117167206344877, -5.022026175526023],
            [22.11516538888765, -5.025704934422376],
            [22.105730148998227, -5.035106947571706],
            [22.103008189008655, -5.041766009541056],
            [22.10272414890235, -5.042458984993947],
            [22.098753349208138, -5.067291952648647],
            [22.091572428829313, -5.090273888360652],
            [22.088934277164146, -5.092551260296353],
            [22.088121468918679, -5.093252911540405],
            [22.079357269648188, -5.10794802021482],
            [22.076786254474133, -5.110793617702414],
            [22.073139349542117, -5.114829986459706],
            [22.053562214536676, -5.12447704946534],
            [22.046707430216678, -5.127854859511163],
            [22.036817509842837, -5.134953984274786],
            [22.034742473401757, -5.138167945503568],
            [22.032999355474978, -5.106184883472991],
            [22.028234395662277, -5.087304905478184],
            [22.027159259590881, -5.085042248501969],
            [22.020023155263257, -5.07002388497432],
            [22.016656795092835, -5.068730805560846],
            [22.013684275207581, -5.068234971425015],
            [22.010517715627689, -5.06718675413236],
            [22.007365915367906, -5.067065577418596],
            [22.00421447533256, -5.066944222325701],
            [21.999592795909372, -5.067594623595739],
            [21.992422675076853, -5.071078380559465],
            [21.986731435425256, -5.074346697486671],
            [21.967724875253964, -5.079183795892452],
            [21.959578075501859, -5.079535110004606],
            [21.948297475931614, -5.080877175597148],
            [21.93958907551503, -5.080868918251173],
            [21.931771315176739, -5.078617420548784],
            [21.920951155190231, -5.074016203803765],
            [21.916108435409914, -5.072445775914941],
            [21.908469595221742, -5.06981977089549],
            [21.894826675287625, -5.062494258413724],
            [21.883812475606476, -5.057340713274342],
            [21.880257475514572, -5.055187691361565],
            [21.872618635326404, -5.052561435177019],
            [21.868469636829268, -5.048009760063889],
            [21.868158236734367, -5.042434748355253],
            [21.87165167527985, -5.038487293472912],
            [21.877919635140472, -5.036505298549395],
            [21.882517555921027, -5.034371774507848],
            [21.885406555841076, -5.029676705032446],
            [21.885338155420385, -5.025412835830184],
            [21.885102355743143, -5.022264916442419],
            [21.883202635411234, -5.019336370575879],
            [21.879841675912264, -5.017735646982473],
            [21.876501955281572, -5.017432773214819],
            [21.872612155778238, -5.017511947811057],
            [21.868537316801088, -5.017594892487087],
            [21.8648419163185, -5.018226313246292],
            [21.860949236816371, -5.018120208520411],
            [21.856291916734275, -5.016545873474634],
            [21.851825756347989, -5.015338503957064],
            [21.847759916693395, -5.01597764729803],
            [21.844841396336491, -5.019037985624115],
            [21.842298338530668, -5.021277650376542],
            [21.838857476582142, -5.024307995886084],
            [21.835411195995821, -5.02544586987973],
            [21.823934396282716, -5.025634917037404],
            [21.822078607161423, -5.029651007647961],
            [21.820007376882209, -5.034133096643188],
            [21.81471623607835, -5.037794852423104],
            [21.813518156577203, -5.040085990761444],
            [21.812759958714448, -5.041536383206265],
            [21.811714196654542, -5.043536864546444],
            [21.811647220961916, -5.044698994154291],
            [21.810985196733483, -5.056186021141692],
            [21.809448964409903, -5.059622239485689],
            [21.808212476540454, -5.062387981755784],
            [21.80933027629963, -5.071593959421283],
            [21.801966836221382, -5.083483927086433],
            [21.801843250496162, -5.083486442022098],
            [21.794372636014607, -5.08363849022244],
            [21.787892996242075, -5.083955693534914],
            [21.783979436299482, -5.082551881511951],
            [21.779707316506165, -5.08189700699714],
            [21.77485019673184, -5.079399754806927],
            [21.76331291614559, -5.076296800210459],
            [21.75846443636765, -5.074355493582466],
            [21.753021596163478, -5.070015806743559],
            [21.749311076136312, -5.069720497255402],
            [21.74465663605304, -5.068331733003259],
            [21.737197436463767, -5.065331050713513],
            [21.73477175612625, -5.064267749388661],
            [21.72621275632121, -5.062031093077081],
            [21.721367156542062, -5.060275368627505],
            [21.713737676799145, -5.05820529512819],
            [21.707948156065569, -5.05535608420708],
            [21.702552836739891, -5.053982369108725],
            [21.694029836021532, -5.053970340637918],
            [21.689811589992409, -5.054821953651532],
            [21.687469196058153, -5.068845877333888],
            [21.687618236445253, -5.07009694936009],
            [21.688808396398894, -5.080123924506121],
            [21.693113276852291, -5.096703856954816],
            [21.692123276815352, -5.11832497269044],
            [21.689790475989998, -5.129588855760028],
            [21.675485156331657, -5.151850005147802],
            [21.672968462282817, -5.160719032221643],
            [21.671768156756357, -5.164948959601801],
            [21.66602061788927, -5.179207087732958],
            [21.662046372257656, -5.189066136820482],
            [21.662491316801031, -5.193438944392549],
            [21.658492871453941, -5.205322333250321],
            [21.656461352100184, -5.211359915565512],
            [21.649676458505894, -5.219016006504217],
            [21.637565277522306, -5.232681940685302],
            [21.635648277197561, -5.256137877844563],
            [21.639274197484514, -5.269724022251816],
            [21.639364338931692, -5.27732743980661],
            [21.639454197409584, -5.284906860747495],
            [21.638871054246245, -5.289357484289834],
            [21.638038316876202, -5.295712983597074],
            [21.635757360520834, -5.301372418202478],
            [21.634798170003176, -5.303752050520887],
            [21.63264139585436, -5.305228705506453],
            [21.629274476931819, -5.307533889652686],
            [21.624441474227936, -5.310844099647521],
            [21.624192781031422, -5.316130857054162],
            [21.628488621738128, -5.317283557419771],
            [21.628550157233398, -5.31730006943185],
            [21.632052269911256, -5.319533843923212],
            [21.64160987741036, -5.32562999090127],
            [21.645709917724488, -5.326779876550614],
            [21.646465304758689, -5.326993175995235],
            [21.648260157560973, -5.32749999046733],
            [21.65114995249002, -5.325380806778954],
            [21.653210157745789, -5.323869985831593],
            [21.655968076397876, -5.324283436122023],
            [21.659280117239707, -5.324779956613997],
            [21.662712040951181, -5.328724510181993],
            [21.664097893499552, -5.330317360495205],
            [21.663600117237685, -5.3406700354067],
            [21.663857017442645, -5.341981900475506],
            [21.666980156953269, -5.357930051989633],
            [21.656369877553114, -5.371919976451968],
            [21.653589957363085, -5.379720007480483],
            [21.653590893407593, -5.379733269384505],
            [21.654029877629057, -5.385949946859394],
            [21.658780077223319, -5.392760083672321],
            [21.666980156953269, -5.397750068597724],
            [21.675959996807702, -5.398200063804321],
            [21.682929956825227, -5.395260015480426],
            [21.686375419046325, -5.395729506047651],
            [21.687639555263573, -5.401744885214289],
            [21.69033443643724, -5.414611929310887],
            [21.693189956146636, -5.417139937570172],
            [21.70488995666512, -5.420410007026926],
            [21.709465951366223, -5.427118735417799],
            [21.71197007618764, -5.430789924998538],
            [21.715179836647849, -5.432410032493761],
            [21.72620015655102, -5.432220033051769],
            [21.73191983686452, -5.437539985469074],
            [21.747344653199587, -5.438912658839501],
            [21.747990373005603, -5.438970310443094],
            [21.748492831286743, -5.439205863638077],
            [21.754410116708232, -5.441979881120876],
            [21.758989894215009, -5.447285716898127],
            [21.758732106474547, -5.457623703024559],
            [21.75872031069656, -5.458100834937712],
            [21.760471314933188, -5.463809598140802],
            [21.760769876306075, -5.464780042678374],
            [21.766650116103595, -5.468229969622002],
            [21.773683706487621, -5.466923704513547],
            [21.779949956854303, -5.465759945854943],
            [21.794060156144692, -5.465360054886631],
            [21.794911166145962, -5.464978910398199],
            [21.798658077823578, -5.46330076465519],
            [21.804661494612837, -5.451830166368201],
            [21.812699876693316, -5.452779953337641],
            [21.816480194919727, -5.45235683953898],
            [21.820740116489787, -5.451880045082412],
            [21.823543272502942, -5.449466725924398],
            [21.824190003811957, -5.448909610758522],
            [21.824399876313468, -5.439549936509635],
            [21.820638919476398, -5.432733606937615],
            [21.819869996627499, -5.431340008168465],
            [21.821969875977778, -5.426129981831065],
            [21.824243198449846, -5.42370153170186],
            [21.82519007665822, -5.422690037066586],
            [21.829569836182142, -5.419940112730204],
            [21.846800012015073, -5.41517349248251],
            [21.846776886684694, -5.415324634104149],
            [21.846096356263121, -5.419772895209602],
            [21.849253088273805, -5.4262637239947],
            [21.852483476747892, -5.432905931552614],
            [21.860271356424871, -5.439375010318765],
            [21.861633236531567, -5.444439956563475],
            [21.870313196286276, -5.458270874641045],
            [21.872268348959448, -5.464794061561229],
            [21.8741781564737, -5.471165889793496],
            [21.878605435977846, -5.477702901582141],
            [21.889114333311674, -5.487804304990864],
            [21.893171395527631, -5.491704004403335],
            [21.904405195566525, -5.497952861517147],
            [21.909897550909175, -5.50554340547847],
            [21.916752475366355, -5.51501690934627],
            [21.919190256909069, -5.516531075815096],
            [21.925689475463173, -5.520567883092078],
            [21.932296195407361, -5.538072011791521],
            [21.936876910755309, -5.54688339241993],
            [21.93960239573406, -5.55212602312063],
            [21.940252195688092, -5.565008927704447],
            [21.943701067015674, -5.570944859867909],
            [21.944135186859889, -5.57169198443188],
            [21.950411395949793, -5.573601915611949],
            [21.951019435921221, -5.573785949749863],
            [21.953613640206019, -5.57587957448821],
            [21.954454195614002, -5.576557934717015],
            [21.956434821813698, -5.581328662882727],
            [21.957418435727309, -5.583697877535974],
            [21.958520013709062, -5.585086422449089],
            [21.961078195550989, -5.588311009270957],
            [21.970472395906651, -5.595472868720095],
            [21.974350325970132, -5.604225979197392],
            [21.977056435186523, -5.620564951565687],
            [21.977262355100773, -5.628385892935276],
            [21.975397195652789, -5.638038974928361],
            [21.971228028180928, -5.648020951220638],
            [21.967531195783764, -5.656871898307656],
            [21.961956235859155, -5.677782911506183],
            [21.960907195846772, -5.687829873655605],
            [21.960615714096647, -5.690622983007643],
            [21.960300235650323, -5.693646030455113],
            [21.95218223588623, -5.719376858026227],
            [21.946154376836382, -5.734401508968019],
            [21.942230395538196, -5.744181955319933],
            [21.941993714613638, -5.74449204498354],
            [21.936460113124724, -5.751741877664522],
            [21.923631132415021, -5.760480134581546],
            [21.923345151049389, -5.760674924167645],
            [21.907449591454277, -5.775568664858091],
            [21.896484472127014, -5.791920899689513],
            [21.896280537489517, -5.792224914288049],
            [21.895910271692347, -5.792776885112128],
            [21.885767271648469, -5.804469899772858],
            [21.882526598362677, -5.810448064531887],
            [21.880914471872355, -5.813421977080454],
            [21.878383312252485, -5.814792862994926],
            [21.87630148275122, -5.824034775402951],
            [21.875122432262717, -5.829268891786974],
            [21.878296191839578, -5.84307885765068],
            [21.876886431528256, -5.852962936239958],
            [21.878246440444197, -5.858946997722673],
            [21.870415076019292, -5.861326910918932],
            [21.862211396740005, -5.862520012629404],
            [21.850944476714925, -5.86329485523739],
            [21.841035836348905, -5.864447972940384],
            [21.83079707679407, -5.864900470820349],
            [21.82217831656472, -5.863577935346516],
            [21.816327908021176, -5.855715123015008],
            [21.812570276747262, -5.850664896060326],
            [21.8049275234977, -5.845737014028758],
            [21.790333436798033, -5.836326939934041],
            [21.787522228286665, -5.828176371851823],
            [21.78691847597408, -5.826425890085128],
            [21.783481196506912, -5.823883903170935],
            [21.78226912484687, -5.819705805692118],
            [21.78121031655412, -5.816055989686947],
            [21.779150396064299, -5.813978865985589],
            [21.77318015675344, -5.813266887070869],
            [21.767361827946981, -5.810685247596914],
            [21.763775227818346, -5.809093727102951],
            [21.756214436855291, -5.802856936661691],
            [21.753702356553777, -5.798247880641087],
            [21.75260614331085, -5.794669005336841],
            [21.751657196282395, -5.791570902576429],
            [21.755132276856724, -5.78261488866446],
            [21.754911236499595, -5.779624975819034],
            [21.754362236503603, -5.779264930212247],
            [21.751014236100929, -5.777079906832892],
            [21.750670855083563, -5.773266160324011],
            [21.750351314455564, -5.769718972497622],
            [21.746630516803236, -5.769724531011263],
            [21.74341139679607, -5.769931990932692],
            [21.741524996683182, -5.771152902542157],
            [21.737125076269336, -5.773895954111576],
            [21.73239503666667, -5.777896288018995],
            [21.729086636696678, -5.780506799972414],
            [21.724674836063215, -5.784040179056785],
            [21.718838516696586, -5.789121456450772],
            [21.713905076055696, -5.796279526135793],
            [21.709045436507012, -5.798537270178374],
            [21.70278071597129, -5.801078296172345],
            [21.697605356329465, -5.80364495122793],
            [21.695371916361033, -5.80722928287453],
            [21.69293975647539, -5.813655239973608],
            [21.690330476663469, -5.821500041245888],
            [21.68703647758581, -5.833439510557476],
            [21.685550037081782, -5.83909692123019],
            [21.683881437102794, -5.846489029407704],
            [21.681602637602428, -5.853076242571166],
            [21.679462797595068, -5.860773296475807],
            [21.675474357683616, -5.867162058669622],
            [21.671222396983595, -5.869922921864552],
            [21.666847317682318, -5.873125864300793],
            [21.666425758082422, -5.873858885010387],
            [21.664999437328806, -5.876339006109507],
            [21.663788396934699, -5.894730983705873],
            [21.657797277183377, -5.899997860564756],
            [21.6483251937909, -5.915599114500022],
            [21.637499308841093, -5.9233760331903],
            [21.634546786352388, -5.928870830582324],
            [21.631950356940614, -5.933702874427069],
            [21.62950319878296, -5.935760529352555],
            [21.628954341619075, -5.93622196551482],
            [21.625157232981714, -5.937013304995851],
            [21.621368157079598, -5.937802969443382],
            [21.617246517672765, -5.933878006393071],
            [21.61379991818454, -5.93386473756806],
            [21.61147751985018, -5.940984003014603],
            [21.609169823343745, -5.942315191969992],
            [21.601577160154438, -5.94669497613931],
            [21.596481359805747, -5.958862947442244],
            [21.593191265704608, -5.96201536774544],
            [21.590027279797994, -5.965046939678127],
            [21.586548240348225, -5.974461886517002],
            [21.582630360407421, -5.977666007095123],
            [21.581402400244951, -6.000425898376088],
            [21.573246240047592, -6.033275859427227],
            [21.578726160011755, -6.042954856227566],
            [21.578245200212017, -6.045411945313358],
            [21.578075772559522, -6.046276734341974],
            [21.577556160049742, -6.048928914116316],
            [21.580122199455442, -6.057458497317781],
            [21.583235160155585, -6.067805879300029],
            [21.582623040036175, -6.070931434579983],
            [21.582065160193572, -6.073780016438292],
            [21.58434648036663, -6.078617915034036],
            [21.57904049849596, -6.084345101781002],
            [21.579954480398658, -6.086187928991858],
            [21.584779268009253, -6.085977099698531],
            [21.585095293529573, -6.086414975345231],
            [21.58660943987358, -6.088512923759319],
            [21.578737341342094, -6.105497900664241],
            [21.579392868954383, -6.106895134995668],
            [21.582844199869218, -6.114250981881274],
            [21.588272152294223, -6.138874946747825],
            [21.589754397665839, -6.159069886100264],
            [21.590248318358498, -6.16578304720091],
            [21.590439477156014, -6.177049912296242],
            [21.596609102035767, -6.186730037605358],
            [21.595680357219734, -6.18971590292159],
            [21.591535317598076, -6.191769000405413],
            [21.589730126085165, -6.195188273345331],
            [21.588991229424646, -6.196587835549398],
            [21.589897316932586, -6.200039894300907],
            [21.594251162755505, -6.203964884025895],
            [21.596973473088045, -6.214091743751849],
            [21.592569237167577, -6.224880991512837],
            [21.588354357125876, -6.247395902583161],
            [21.589487277327898, -6.251997871765677],
            [21.594076196989306, -6.254084939065903],
            [21.596134317255277, -6.257081882274701],
            [21.595197345667859, -6.262135990142204],
            [21.599870103298109, -6.264929524657497],
            [21.601391397536823, -6.265839003427367],
            [21.603147138589978, -6.269383222029797],
            [21.603445177143353, -6.269984852637302],
            [21.602600779640888, -6.271982601348407],
            [21.599273157520468, -6.27985495935488],
            [21.599258398200359, -6.28422277594081],
            [21.600148016894209, -6.285354766077539],
            [21.603607182016631, -6.289756342656529],
            [21.603248936576293, -6.297365451878441],
            [21.603109325804724, -6.300330760862249],
            [21.608833299166953, -6.306789975165498],
            [21.608685690694426, -6.30730080150997],
            [21.60790415729554, -6.310004987748004],
            [21.612947397216956, -6.313931986340742],
            [21.614069157648235, -6.321522939911071],
            [21.616003531390543, -6.324003598330071],
            [21.616586277498502, -6.324750914739121],
            [21.618375477202719, -6.339471876530192],
            [21.617212370912199, -6.343374114819342],
            [21.618232075540661, -6.346898960345483],
            [21.621074397201898, -6.356723976143292],
            [21.619407237222298, -6.373498890697176],
            [21.615940901747276, -6.385563027795386],
            [21.6149864714023, -6.388884750045566],
            [21.615396853265114, -6.389629247945566],
            [21.616129348530919, -6.390958018457465],
            [21.614680608522775, -6.392168297305116],
            [21.611747157267551, -6.394618895063811],
            [21.613548237191385, -6.405889926838481],
            [21.610777317222169, -6.409787886907679],
            [21.611452317614877, -6.413927947426938],
            [21.607785238318247, -6.419220641487438],
            [21.606369495227089, -6.421264067662681],
            [21.607502397462831, -6.425866899261172],
            [21.603327477179885, -6.436654960517165],
            [21.603533397094136, -6.443551927730832],
            [21.601483021204242, -6.446982205642421],
            [21.59983223751226, -6.449743948965213],
            [21.600961197042206, -6.455724942528455],
            [21.599563316950501, -6.461006938272042],
            [21.601522004494317, -6.464728477701258],
            [21.605503078220401, -6.472293016424588],
            [21.599506797647756, -6.473899924273823],
            [21.583286276990222, -6.476046424891641],
            [21.57473771740538, -6.475214113145649],
            [21.561664677009389, -6.475065485613037],
            [21.553082997438359, -6.47644341972093],
            [21.547921677566105, -6.478059510522601],
            [21.543373437214026, -6.48032167068634],
            [21.539866317326751, -6.485766713612445],
            [21.539447637725647, -6.492863193356008],
            [21.541139997245594, -6.504430681636125],
            [21.545561517650452, -6.510535103673137],
            [21.551294877509122, -6.512248669461773],
            [21.555778677214317, -6.514248716466969],
            [21.562299357418873, -6.515349006795085],
            [21.566929317512372, -6.517984144441858],
            [21.567508557495788, -6.520840219053862],
            [21.568664877014339, -6.526709883778888],
            [21.567178077184206, -6.532359606664677],
            [21.562581957525797, -6.537778474122748],
            [21.555335876949513, -6.543450808834346],
            [21.552453717700359, -6.548751923704601],
            [21.553023597238521, -6.552238940887634],
            [21.55292783772753, -6.558552605888579],
            [21.551893557035264, -6.565159987930007],
            [21.547917357567897, -6.570750904926036],
            [21.548451238019339, -6.576605473063792],
            [21.55572395993201, -6.579460133401509],
            [21.564772560431571, -6.578093407560414],
            [21.568219919894538, -6.57659526792716],
            [21.571815239969666, -6.575574246527392],
            [21.575772360118709, -6.571246113935982],
            [21.580366320227164, -6.565985524770722],
            [21.585103559826834, -6.561517658322931],
            [21.593295359784801, -6.555078166716397],
            [21.598961399896055, -6.550947694525822],
            [21.60323207968996, -6.546468770639421],
            [21.603911760305309, -6.542695062450619],
            [21.60825932870101, -6.539424020505469],
            [21.610981439607563, -6.550237973262794],
            [21.610191694708675, -6.553729187041919],
            [21.610046554806537, -6.55437098394169],
            [21.613716359591759, -6.55714392614241],
            [21.613264570784235, -6.561293842689945],
            [21.613241168772753, -6.561508892955225],
            [21.618752870233354, -6.566320643975305],
            [21.620117368929122, -6.567511852167992],
            [21.62423340015361, -6.574193007892687],
            [21.627861479990518, -6.589146877423517],
            [21.630236280648667, -6.591257850150376],
            [21.631757399715877, -6.592609975856931],
            [21.634727399826772, -6.598137921510425],
            [21.639324239934055, -6.598844887576091],
            [21.642534359720369, -6.601614920254686],
            [21.644130780066305, -6.605527901108449],
            [21.64572720041221, -6.609440850607387],
            [21.651291359892184, -6.614693991396212],
            [21.653061245817771, -6.616364724032798],
            [21.658849723607318, -6.618524412276918],
            [21.672352439881781, -6.623561940043309],
            [21.679687440196457, -6.630024876348435],
            [21.691633320388014, -6.633287012643865],
            [21.696659280316631, -6.643418954551885],
            [21.698721911921961, -6.645841220126506],
            [21.700782513334751, -6.648260968511097],
            [21.704456160214427, -6.649652858548159],
            [21.707428189619534, -6.655180628243598],
            [21.707446590709814, -6.655189731446971],
            [21.712528800446581, -6.657654154968205],
            [21.712491444005483, -6.657733937598143],
            [21.710920320217976, -6.66108937962154],
            [21.708083519602464, -6.663390970933793],
            [21.704162400336728, -6.665351199690139],
            [21.696540479916923, -6.665014680924822],
            [21.687515639856656, -6.66480310283502],
            [21.681609840294389, -6.664191101794696],
            [21.675089160089797, -6.66309096631668],
            [21.668396040181573, -6.663092040540042],
            [21.663069479704394, -6.665335090007796],
            [21.658815719678852, -6.66870832597207],
            [21.653944199910526, -6.671751289021172],
            [21.64579091971196, -6.675664510712984],
            [21.637038959987226, -6.677985007026304],
            [21.627372599744906, -6.679021207010168],
            [21.616801200328563, -6.678141985175662],
            [21.61256904029403, -6.680094994081203],
            [21.612318450753943, -6.680647326324814],
            [21.610797479908722, -6.683999736181698],
            [21.611017799817013, -6.690003471799732],
            [21.614134679866726, -6.700021107110875],
            [21.62052144012706, -6.70995745414579],
            [21.621663359651635, -6.716771648888899],
            [21.62110571965923, -6.722756719641064],
            [21.619961280360293, -6.726360254940907],
            [21.617751960157264, -6.728360318578496],
            [21.612069000277646, -6.723334103020906],
            [21.604820399926968, -6.718902407318497],
            [21.598201080212625, -6.714011939773883],
            [21.592796040217255, -6.711201742123104],
            [21.587666040107401, -6.710765740562578],
            [21.583124640426188, -6.712553596270706],
            [21.582126359718931, -6.716791873651054],
            [21.587927040223317, -6.724346581752926],
            [21.599323920418851, -6.732347891209151],
            [21.604058999570263, -6.738298941936829],
            [21.605490720097031, -6.746540017088543],
            [21.603205800374635, -6.753509929338645],
            [21.598851599717197, -6.758379590837244],
            [21.593357639983434, -6.761407489457],
            [21.585606119617577, -6.764461318986155],
            [21.581949239792692, -6.765022008678802],
            [21.574384240222535, -6.7580979360244],
            [21.560833439825867, -6.752988956869935],
            [21.557690782619041, -6.753447920767187],
            [21.551630400064351, -6.754332997150473],
            [21.546322200253275, -6.759596909097555],
            [21.542131786726625, -6.759281925723868],
            [21.539884319565051, -6.759112989390525],
            [21.53931415346435, -6.759314934417179],
            [21.530903399935642, -6.762293897172068],
            [21.524512290032693, -6.763109604249872],
            [21.522159359758483, -6.763409911898365],
            [21.485300400282824, -6.780730001202997],
            [21.480219360152578, -6.786684922956833],
            [21.476842418726381, -6.788552678422488],
            [21.472383240046501, -6.791018997591665],
            [21.471393240009562, -6.793440936944336],
            [21.467999245864331, -6.80175255598278],
            [21.467510280278795, -6.802949981205919],
            [21.466644618755232, -6.803808345877068],
            [21.464048159699054, -6.806382911569964],
            [21.458984400459936, -6.807511885562465],
            [21.449104199857494, -6.804714944064515],
            [21.446001329034615, -6.807909844134299],
            [21.443102279661471, -6.810894856784443],
            [21.4366604400978, -6.811098853965115],
            [21.425628239975016, -6.808985865848511],
            [21.423052150217888, -6.809883241626018],
            [21.421715399582933, -6.810348894769836],
            [21.417709786578236, -6.815692694226436],
            [21.415704480064417, -6.818367906980727],
            [21.410412366385138, -6.819495010822037],
            [21.406715280663057, -6.823616973167502],
            [21.403029960176266, -6.826130004845446],
            [21.401279103263327, -6.832697396387578],
            [21.400459919674258, -6.835770088830983],
            [21.400858182365603, -6.836706025956937],
            [21.401830080451266, -6.838990027436669],
            [21.404810159659633, -6.840610097794819],
            [21.416090039679336, -6.839049970551223],
            [21.416548695208874, -6.844445384386038],
            [21.416969880211315, -6.849399966976097],
            [21.418570079769641, -6.851699934894579],
            [21.422957417481282, -6.856229761536371],
            [21.427509882610174, -6.860930032844818],
            [21.430950474165776, -6.862780001138899],
            [21.431739706126656, -6.862723232988337],
            [21.436930080210132, -6.862349890875917],
            [21.437994531719518, -6.866001585585109],
            [21.438069343416391, -6.866258230007301],
            [21.444031147546735, -6.870878039043119],
            [21.450192560926489, -6.883081730615431],
            [21.456159840288475, -6.88677994465249],
            [21.461523018791606, -6.888290050284415],
            [21.47271011991042, -6.891439977085667],
            [21.477459495749574, -6.894226160134717],
            [21.482579880292633, -6.897229974240158],
            [21.487639882777252, -6.897940053945375],
            [21.487824179344308, -6.898168543128119],
            [21.493580040204208, -6.905309944193423],
            [21.49587000037365, -6.910610100882777],
            [21.502727645827839, -6.916381802226707],
            [21.507109919736237, -6.920070082715832],
            [21.509160120454666, -6.926969985688718],
            [21.511065122880478, -6.929421557108517],
            [21.511670040307962, -6.930200031002181],
            [21.519929879563858, -6.937599979197151],
            [21.521060737233974, -6.941950837329252],
            [21.526110000359363, -6.947029895203878],
            [21.530369879708633, -6.953799880896548],
            [21.530778735333779, -6.954452089543818],
            [21.532049999682826, -6.956480012727842],
            [21.533169959890255, -6.964519956164383],
            [21.535612368655023, -6.969147210840188],
            [21.537060119618022, -6.971890019892516],
            [21.541410000277288, -6.977880078250601],
            [21.54394008012218, -6.977430013244175],
            [21.546554512670586, -6.979498853308826],
            [21.547149839684092, -6.979969943864171],
            [21.54759727435745, -6.980672161820906],
            [21.550820039728038, -6.985730039585765],
            [21.551576904490865, -6.991219613627795],
            [21.551929919939671, -6.993780027670287],
            [21.553290161519293, -6.996649042409635],
            [21.554219880109112, -6.998609988957149],
            [21.556219319725788, -7.000807805347444],
            [21.556739879958208, -7.001380012152259],
            [21.560007460481689, -7.003024874108543],
            [21.564089999817426, -7.005079968572336],
            [21.570729839747838, -7.013840080714516],
            [21.57281298887424, -7.015238921353406],
            [21.583119490384657, -7.022159704734058],
            [21.590459912930417, -7.028849946145439],
            [21.589520121531312, -7.035739482577945],
            [21.598249083486454, -7.038299616296715],
            [21.601689030051705, -7.042219162912721],
            [21.607200000283676, -7.043850001222836],
            [21.609379368858512, -7.045672782141683],
            [21.609950441359356, -7.046150868710841],
            [21.612410661919537, -7.05099647782225],
            [21.615210000092759, -7.056509943733301],
            [21.621440159744552, -7.051709923683557],
            [21.626500499995718, -7.051501291724203],
            [21.628591403379662, -7.053815641458838],
            [21.631080728456769, -7.056570531828264],
            [21.637007221609942, -7.060032934303223],
            [21.653640466936551, -7.069749550418326],
            [21.655409909992738, -7.072668382503107],
            [21.658309919664877, -7.077450018073946],
            [21.660784005721492, -7.086999860225422],
            [21.661740000033376, -7.090689893155204],
            [21.661729920037544, -7.096359893630407],
            [21.661719840041748, -7.103060078514006],
            [21.661916051862736, -7.103499108447993],
            [21.662939395566411, -7.105791902060269],
            [21.662678491570251, -7.106844589113665],
            [21.661779959792163, -7.110469938835571],
            [21.663550080178027, -7.117349993497898],
            [21.672039960011869, -7.123349949468497],
            [21.680740079758205, -7.135099991423663],
            [21.683737672521346, -7.134716489436551],
            [21.684179879898064, -7.134659915400559],
            [21.686474877819631, -7.136313412076967],
            [21.688329959966772, -7.137649953543784],
            [21.695470050119322, -7.134240024947086],
            [21.699839879666094, -7.133799969620972],
            [21.701345769594312, -7.135305939845701],
            [21.701679839573732, -7.13564002675419],
            [21.702360909882824, -7.141481026279554],
            [21.703690079635077, -7.152880047485759],
            [21.704884710503872, -7.156349998124981],
            [21.707570160265348, -7.164150114269325],
            [21.710607825076714, -7.169661524134821],
            [21.713280119909193, -7.17450996550015],
            [21.714410160112418, -7.181399950472275],
            [21.713773356085596, -7.183604245528987],
            [21.71348016034991, -7.184619139663123],
            [21.714043777732204, -7.186229040503738],
            [21.714850080378394, -7.188529955554395],
            [21.713920427365593, -7.190818997414812],
            [21.712989959580828, -7.193110035424197],
            [21.713670003115542, -7.196329977577983],
            [21.714818358170788, -7.197947946572063],
            [21.717468033424389, -7.19839703890529],
            [21.720331558919618, -7.198882375493605],
            [21.73452983982024, -7.219380042602105],
            [21.735509719437218, -7.219949560382881],
            [21.744870119781989, -7.225389900575261],
            [21.748309919921848, -7.22953998924121],
            [21.750130080062327, -7.235520033335422],
            [21.753924878232784, -7.240073875003509],
            [21.757230845565005, -7.244040408690186],
            [21.758625027292695, -7.244621587161192],
            [21.761139959745265, -7.245669957916921],
            [21.775409999867428, -7.245270036668354],
            [21.777245137618646, -7.249221262599208],
            [21.778610039657977, -7.252160003438419],
            [21.780862828439254, -7.252958285790851],
            [21.783208983619627, -7.253789650284012],
            [21.786869879812169, -7.257920032853362],
            [21.786872849642503, -7.2579341368143],
            [21.786891016272474, -7.258020418276542],
            [21.787549919753591, -7.261149872159296],
            [21.783829964721036, -7.267553520416389],
            [21.779689173232352, -7.274680032888474],
            [21.681056160075752, -7.277457634394214],
            [21.681056116956626, -7.277457636188187],
            [21.651289305445122, -7.278483467064429],
            [21.634905600426325, -7.27904808515287],
            [21.634905560002121, -7.279048087843836],
            [21.5706016798012, -7.283607212905942],
            [21.570601642970253, -7.283607209318047],
            [21.487124159972641, -7.28723013452448],
            [21.487124125836651, -7.287230131833552],
            [21.415373280202324, -7.281318001152544],
            [21.415373248761291, -7.281317999358597],
            [21.403639440147074, -7.280580968207595],
            [21.401550360343137, -7.279205931992001],
            [21.397669199937891, -7.276651949321154],
            [21.39766916939519, -7.276651947527169],
            [21.392378280119619, -7.276399893415294],
            [21.38962714823947, -7.273402919566063],
            [21.385704209885311, -7.27660296831162],
            [21.381330240003383, -7.27658491370528],
            [21.381330209460682, -7.276584911911281],
            [21.377861249108374, -7.279065961158877],
            [21.377182320382961, -7.279062027881479],
            [21.377182290738556, -7.279062031469412],
            [21.367050480109857, -7.280200920567859],
            [21.367050450465452, -7.280200918773886],
            [21.361276440043561, -7.285460953940984],
            [21.361276413992414, -7.285460962910708],
            [21.354595200354986, -7.287729943662833],
            [21.354595170710581, -7.287729941868886],
            [21.351591330164627, -7.290703940809701],
            [21.34974345250604, -7.292533871963029],
            [21.342846239856861, -7.290668012139274],
            [21.342846211110789, -7.290668010345351],
            [21.339384462433578, -7.293409954370378],
            [21.33157716028186, -7.288783010384932],
            [21.331577133332381, -7.288783010384932],
            [21.310636308114926, -7.288465897308701],
            [21.30556715988239, -7.290511957033956],
            [21.298000319664247, -7.282899857561246],
            [21.298000293613097, -7.282899857561246],
            [21.190391628547896, -7.284457575239695],
            [20.837554559135331, -7.292330087710176],
            [20.542873318085462, -7.298904902714873],
            [20.544517438074646, -7.29179293172028],
            [20.543510518269308, -7.281422934346961],
            [20.543219516219562, -7.27842402919624],
            [20.541885476700113, -7.264675548295929],
            [20.541750477879241, -7.244919993037101],
            [20.53880927865465, -7.234567850817792],
            [20.538837357295492, -7.228595124936895],
            [20.542355968431874, -7.213596080281492],
            [20.54400441830073, -7.20656893112835],
            [20.544004431775456, -7.206568874609117],
            [20.543159158415619, -7.198506981579153],
            [20.542463282972328, -7.1918589391855],
            [20.545143478487748, -7.160629902117944],
            [20.544609237811869, -7.14096291624483],
            [20.548750318558049, -7.128026899535793],
            [20.551584238276437, -7.112648971146587],
            [20.553759780028141, -7.10845208278783],
            [20.556692278170878, -7.102794869623211],
            [20.567342158003711, -7.088835883452054],
            [20.575256398301804, -7.069576946662607],
            [20.575367278255641, -7.059927946720647],
            [20.577200357068211, -7.050482132545282],
            [20.585336398596478, -7.029650966847096],
            [20.585365198584487, -7.023653980096525],
            [20.58561719847955, -7.018235009998292],
            [20.586162077005028, -7.016521443539271],
            [20.587407504009892, -7.013867387522352],
            [20.591200438176138, -7.005784898309737],
            [20.599289278626113, -6.998013983049788],
            [20.608722358067251, -6.997602931478089],
            [20.609755787156637, -6.996807710515641],
            [20.610800268218949, -6.996003975845262],
            [20.6117632783732, -6.988589935818425],
            [20.612331358585841, -6.984213864264086],
            [20.619869397917675, -6.97537090363431],
            [20.6191144780074, -6.970097960389822],
            [20.619177478654905, -6.969565958625055],
            [20.622698278087313, -6.960679962634581],
            [20.621788258653343, -6.95837710431743],
            [20.621109238299763, -6.956305952679299],
            [20.624601228761023, -6.947132936419401],
            [20.624601204506501, -6.947132851143413],
            [20.621193477815542, -6.936538940862845],
            [20.621912388757632, -6.931953958985773],
            [20.610385558273084, -6.926500191397477],
            [20.570359317870366, -6.92149647872096],
            [20.546524437912762, -6.918932969545152],
            [20.534328358049958, -6.919789919491038],
            [20.522115358418791, -6.92409289105079],
            [20.518913158180023, -6.924643015348761],
            [20.503929238579641, -6.927215974394485],
            [20.495397238538761, -6.931538020173255],
            [20.488497478267448, -6.93127199680538],
            [20.478164398302702, -6.927541930975668],
            [20.429184959381931, -6.929393550512559],
            [20.384401319387951, -6.927193254105426],
            [20.350472399366076, -6.926233806974346],
            [20.336220719011688, -6.926407341478516],
            [20.315179080361442, -6.928036413073951],
            [20.315902320284881, -6.932531982553767],
            [20.315479319787272, -6.938167976971712],
            [20.312946359943588, -6.938844026936459],
            [20.311235280431426, -6.948722937452702],
            [20.315391479823859, -6.955631895746003],
            [20.312374319957172, -6.960899995096611],
            [20.309299199890059, -6.977655940243324],
            [20.304668160021617, -6.983834998945261],
            [20.304413280127726, -6.988658982520181],
            [20.306234520043184, -6.992574944083522],
            [20.305519199667255, -6.997396868823274],
            [20.299047480340601, -7.003564931246621],
            [20.297100240028463, -7.009959894727066],
            [20.216556720325787, -7.016400738709597],
            [20.067934680446697, -7.01752419735585],
            [19.988424359864684, -7.013541014294943],
            [19.970712360052673, -7.012977939560622],
            [19.958063399929301, -7.01244491383471],
            [19.954395360333642, -7.009895860276877],
            [19.952579159966934, -7.005519991073294],
            [19.955837159957909, -6.999419926470213],
            [19.95722765230472, -6.996815812658042],
            [19.957606555403345, -6.996651893912373],
            [19.968757147192395, -6.991827982270036],
            [19.96281036019866, -6.985589977827911],
            [19.964431440197423, -6.9835319780925],
            [19.969961399916201, -6.981954976817351],
            [19.96561440015406, -6.977793857390534],
            [19.963911806128078, -6.973183114250335],
            [19.962213515032296, -6.968583795563523],
            [19.96407935989486, -6.963998859324217],
            [19.960809815654191, -6.958890506808984],
            [19.959060239738843, -6.956156938081312],
            [19.959615355465278, -6.938926995649683],
            [19.951803359616189, -6.937272956062527],
            [19.949295239986743, -6.9333518750529],
            [19.950577290407409, -6.927730078313902],
            [19.950708239622998, -6.92715586302439],
            [19.953712387392795, -6.924645922053626],
            [19.952804994632707, -6.920866615866036],
            [19.950563159908, -6.911529861878481],
            [19.952203320123409, -6.906024864698399],
            [19.946241359686205, -6.903002903021219],
            [19.946143830494098, -6.902805992863552],
            [19.945942200035319, -6.902398902082894],
            [19.945647731386877, -6.901802168379485],
            [19.94464836012488, -6.899776963156454],
            [19.946296439887835, -6.89266285613056],
            [19.937553480383951, -6.893301936489585],
            [19.936056240333581, -6.872610986748523],
            [19.933096358846061, -6.867307964027249],
            [19.93224705115226, -6.865684099021011],
            [19.931047200173364, -6.86338998404555],
            [19.930616280128209, -6.858101997030883],
            [19.924090380711814, -6.852777985546769],
            [19.917564480397122, -6.847453913823777],
            [19.909765440051043, -6.843502019524942],
            [19.907470556215539, -6.842568930379134],
            [19.905308972486704, -6.838108975992573],
            [19.901104200288547, -6.829432857265158],
            [19.902641925612134, -6.822696693371856],
            [19.902990209634293, -6.82117098654275],
            [19.900251360419055, -6.817247905462635],
            [19.890831234684335, -6.815583855134693],
            [19.889963279761847, -6.806156006629675],
            [19.886984280328463, -6.804299964621318],
            [19.887868569317735, -6.802037909516809],
            [19.888149229063629, -6.801319968411087],
            [19.888080002192908, -6.800945298189081],
            [19.887256440215154, -6.796489013434886],
            [19.877365433778124, -6.796889853735643],
            [19.876566893474322, -6.795735803957665],
            [19.875768479832942, -6.794581932755706],
            [19.876233083107994, -6.788151582351638],
            [19.876266348621279, -6.787690987997365],
            [19.874495750331661, -6.785542343943151],
            [19.870556506656751, -6.780761984735928],
            [19.866590393473398, -6.776152123277726],
            [19.865986200088042, -6.775449858418165],
            [19.861499255381045, -6.774396782904986],
            [19.857946319617671, -6.773562915679606],
            [19.855886400026176, -6.771711936621176],
            [19.855088907157956, -6.769413038453637],
            [19.853170222492089, -6.763882079719515],
            [19.851522237950526, -6.763614847215536],
            [19.845817200176143, -6.762689943164174],
            [19.843301160100822, -6.760377015159454],
            [19.845060962437355, -6.75783796153226],
            [19.84631537439169, -6.756027901941966],
            [19.841382102634089, -6.749818041292817],
            [19.835125200136272, -6.741941913287184],
            [19.836361417612828, -6.737507482716209],
            [19.836532424503588, -6.73689406270841],
            [19.834715159633287, -6.733205895433025],
            [19.831051389730128, -6.733811172175034],
            [19.82665836029285, -6.734536925632057],
            [19.825659174982121, -6.728448148677074],
            [19.824657479778466, -6.7223439957608],
            [19.823059439770095, -6.720265872535567],
            [19.818002469997868, -6.719776036052879],
            [19.816892821551587, -6.718450213237342],
            [19.815489360227016, -6.716772901710558],
            [19.817737463395801, -6.712159599545527],
            [19.818281138178765, -6.711043924253521],
            [19.818164974334437, -6.710323430407641],
            [19.817613405156745, -6.706903197936256],
            [19.811863439940062, -6.707328006416193],
            [19.811885781041177, -6.703306100663801],
            [19.811908440145896, -6.699226941629214],
            [19.808578247945416, -6.697855262748861],
            [19.805256359771434, -6.696486999994306],
            [19.798642144284532, -6.689163223739951],
            [19.795656240399854, -6.685856961052373],
            [19.793133952541723, -6.684818825881616],
            [19.786020480369366, -6.68189101820748],
            [19.785264600160058, -6.680744107089411],
            [19.785108240300037, -6.680506859639169],
            [19.786631239541144, -6.67547637379356],
            [19.78698343392977, -6.674312883590654],
            [19.779649199878016, -6.669901885939265],
            [19.778309403055935, -6.667046368914971],
            [19.777378227398724, -6.665061943866883],
            [19.773713458568995, -6.665371800251014],
            [19.772316360011558, -6.665489924726966],
            [19.77015159355167, -6.657936242274809],
            [19.76961131979035, -6.65605100688346],
            [19.762752239726662, -6.649113872400931],
            [19.759811399828212, -6.640591878171709],
            [19.756603423422174, -6.638503842316363],
            [19.755037311335606, -6.63153840959974],
            [19.754585279982965, -6.629527936699213],
            [19.753238972171687, -6.629249991749863],
            [19.752289199591463, -6.629053910722893],
            [19.740343320298237, -6.627141869102661],
            [19.736006399633595, -6.621599931083906],
            [19.73432840956492, -6.615600788245761],
            [19.734203160159812, -6.615152994330091],
            [19.727277070267508, -6.612485202722449],
            [19.725713442921009, -6.61188292158612],
            [19.72229544040152, -6.60657598192284],
            [19.719814319637937, -6.598285974799448],
            [19.716161399586824, -6.593666947080792],
            [19.714653586365554, -6.58779988592475],
            [19.713913052974593, -6.584918801449518],
            [19.711584137362856, -6.582686792991015],
            [19.709568360086099, -6.580754884680918],
            [19.708504941639276, -6.576396231786812],
            [19.707771286648423, -6.57338871275271],
            [19.70943439881934, -6.564204790903577],
            [19.709251795576584, -6.563265140902983],
            [19.708763411201037, -6.560751965984803],
            [19.712003399970573, -6.557094869470648],
            [19.710797008358078, -6.554645503680369],
            [19.710186324644759, -6.553405889149381],
            [19.709284648763166, -6.553174539585217],
            [19.704675287039144, -6.551991875335666],
            [19.703623119092939, -6.549964046697767],
            [19.702402199925686, -6.547610885733274],
            [19.702209245395906, -6.541174061091711],
            [19.702135478439722, -6.540217412417379],
            [19.701996480319171, -6.538414983096261],
            [19.707325200346308, -6.531322020029606],
            [19.701631440022023, -6.521631988583505],
            [19.701421200109561, -6.518182894216258],
            [19.702810440204853, -6.516811879875364],
            [19.708101360023157, -6.516385015128914],
            [19.708518765813178, -6.515460018508934],
            [19.709963280146237, -6.512258875032257],
            [19.708614360034137, -6.506963993974217],
            [19.703827440006023, -6.50003889665793],
            [19.704763440514611, -6.497055926953629],
            [19.716484319676937, -6.497818009972261],
            [19.714668480432998, -6.493668974602375],
            [19.708498439633253, -6.487194935118231],
            [19.708517158727137, -6.483976147736765],
            [19.713136320172595, -6.480326863201849],
            [19.71522718313237, -6.476661913156187],
            [19.714057511953733, -6.466366821077365],
            [19.71347616362436, -6.461249852044729],
            [19.71374543991897, -6.454584943205821],
            [19.704822479591716, -6.44717399286729],
            [19.706005412598874, -6.441434078122937],
            [19.710366891406764, -6.44023634889158],
            [19.713373199624815, -6.439410857974207],
            [19.715906160366828, -6.438507031139659],
            [19.717605609391004, -6.436219313411571],
            [19.718456400203316, -6.435074015574369],
            [19.719403486820848, -6.430361599151158],
            [19.720348179428154, -6.42566087435061],
            [19.720024702382538, -6.424503262955146],
            [19.718546399716683, -6.419212891751399],
            [19.716488245314721, -6.417590847978518],
            [19.713972240273719, -6.415276858698651],
            [19.713673320473028, -6.413972541226786],
            [19.713075479973341, -6.411363897036356],
            [19.710822131541605, -6.410295241475833],
            [19.709636512571759, -6.409732958362667],
            [19.708369759562064, -6.407378049968916],
            [19.706907240295745, -6.404659014662951],
            [19.706728320145686, -6.395922009009001],
            [19.703537279677661, -6.391074896483795],
            [19.704379444866639, -6.387183147233261],
            [19.704481185360773, -6.386712991034439],
            [19.701059400035604, -6.382093897590486],
            [19.698973118483792, -6.374987979243739],
            [19.697002200377394, -6.368274901961892],
            [19.696944830370096, -6.358604056326479],
            [19.696886279976511, -6.348733944388198],
            [19.6957512002245, -6.346197863409938],
            [19.689560279882624, -6.343400976930966],
            [19.688588671054486, -6.341529210669843],
            [19.687286159706602, -6.339019964199759],
            [19.687759185585737, -6.336953006669368],
            [19.694329016212787, -6.327867029559314],
            [19.694709353022613, -6.327341008210521],
            [19.692461343278627, -6.324304220327935],
            [19.690605360121229, -6.321796998521724],
            [19.688538469603159, -6.321094357057873],
            [19.686475440044152, -6.320393026874367],
            [19.684196280319345, -6.317160009156263],
            [19.686099314536346, -6.313305912855113],
            [19.688383440148044, -6.308679979218993],
            [19.687088380325445, -6.303862374399841],
            [19.685907429001784, -6.299468762180883],
            [19.68730919969699, -6.295568892958865],
            [19.695585240069033, -6.295389939526325],
            [19.697710314468072, -6.285516970940988],
            [19.689480360365081, -6.277878883420509],
            [19.688815590885152, -6.275943261968351],
            [19.687898160350098, -6.273271949836015],
            [19.688204186722995, -6.271345021246886],
            [19.68867144002812, -6.268402890862282],
            [19.69696616805302, -6.255394732288669],
            [19.695486247521355, -6.249534788967664],
            [19.695913199707896, -6.239778951291889],
            [19.68904851595348, -6.23327404811089],
            [19.688275932469779, -6.231703636878567],
            [19.68700643959847, -6.229122878962147],
            [19.685347551306005, -6.228735372578831],
            [19.681955280129507, -6.227942957750761],
            [19.680137280437314, -6.224482903810751],
            [19.684474882923251, -6.216243361529083],
            [19.686411359621665, -6.21256486365715],
            [19.687959833287625, -6.204950598236931],
            [19.689960310458449, -6.195113792404689],
            [19.690144814536332, -6.194863448190397],
            [19.695521229715158, -6.187565488040759],
            [19.696407041348845, -6.184097493946772],
            [19.697399861197479, -6.180210534294015],
            [19.693559879564845, -6.169610031642799],
            [19.695440160354035, -6.161810075311978],
            [19.706109839954024, -6.144860017603192],
            [19.708880040372694, -6.142580066424445],
            [19.716689880265086, -6.142399985790667],
            [19.717481337352908, -6.141917229882093],
            [19.719690120363371, -6.140569960323052],
            [19.725289919603924, -6.125429948757724],
            [19.728290159702212, -6.123379996449809],
            [19.738180080076017, -6.12274995711327],
            [19.740020039983687, -6.120920043156654],
            [19.743849435869024, -6.106865858945365],
            [19.744959960172711, -6.102790077235118],
            [19.746203016523502, -6.10201367221383],
            [19.748450160291586, -6.100610117237329],
            [19.749095297989285, -6.100210582695358],
            [19.74934000985246, -6.100058638244773],
            [19.752453842816752, -6.099923729634781],
            [19.763359920371986, -6.099449977009542],
            [19.76502806670177, -6.098134921029582],
            [19.767984804085788, -6.095803372043052],
            [19.77211771375617, -6.090174602152794],
            [19.773529920180025, -6.088250031663342],
            [19.784350080166533, -6.085089940889877],
            [19.790153298411582, -6.07501191510265],
            [19.790160120217838, -6.075000068734958],
            [19.804420080344208, -6.071649937001305],
            [19.806689879623754, -6.069309993282883],
            [19.808004852401247, -6.067958901279628],
            [19.809969839830142, -6.065939933640736],
            [19.815080040172834, -6.056540031933978],
            [19.818299879730542, -6.055650051599811],
            [19.82919563115157, -6.046209671142917],
            [19.829379960057988, -6.046049962224995],
            [19.83089508017575, -6.041818891406497],
            [19.832420159915095, -6.037559974847488],
            [19.83542003978895, -6.034589916531546],
            [19.840950000406025, -6.033009894154232],
            [19.842344752563939, -6.032994978461645],
            [19.854960120187247, -6.032860063637892],
            [19.857960000061134, -6.031269999097959],
            [19.860660217227558, -6.029511372261668],
            [19.868799959814833, -6.024209997662521],
            [19.884037541193539, -6.01142189013272],
            [19.884957944253859, -6.00899651481455],
            [19.88543015985265, -6.007750041273096],
            [19.883880000048904, -5.997160077962176],
            [19.885730039952339, -5.995790008115913],
            [19.890759164645697, -6.000421359362966],
            [19.896064490746223, -6.006834842399953],
            [19.897831271195873, -6.008970475485413],
            [19.898631520993689, -6.009342025493495],
            [19.900351256671915, -6.010138765428149],
            [19.900984574337102, -6.009566954233536],
            [19.903129920118875, -6.007629956454683],
            [19.908699839596405, -5.997549912794346],
            [19.918010361883336, -5.997172426994615],
            [19.918809821163702, -5.997140013369446],
            [19.930330079573618, -5.991000113053675],
            [19.938369960043989, -5.991510040787993],
            [19.943083576646622, -5.993011660300002],
            [19.953055272457402, -5.996188336557453],
            [19.960449840058573, -5.988419997429408],
            [19.966390390947623, -5.977165226536034],
            [19.968801277829037, -5.972599924993029],
            [19.973859840314244, -5.972630030446321],
            [19.976262514797362, -5.970681797725319],
            [19.976397600754819, -5.970572261788067],
            [19.980989999591351, -5.971060042267043],
            [19.986500160441231, -5.971780060928232],
            [19.98784880656719, -5.970579336456844],
            [19.993428274237896, -5.965611807004464],
            [20.000000160210305, -5.966569982873054],
            [20.000518761217087, -5.965980390972552],
            [20.00401991988409, -5.961999943715917],
            [20.005753580347559, -5.957426850229909],
            [20.007500040007173, -5.952819954522449],
            [20.00823011970321, -5.946150052149079],
            [20.012839919805081, -5.943420047120921],
            [20.020430160238085, -5.942770078208476],
            [20.021237172553345, -5.94157686999811],
            [20.022750000170518, -5.939340071101909],
            [20.028110039960019, -5.925110016489792],
            [20.026540080389118, -5.918200102889858],
            [20.026976018423458, -5.917854876735992],
            [20.033459999753727, -5.912720080095825],
            [20.03693003988101, -5.907229962943882],
            [20.034266090397537, -5.893722354731958],
            [20.034250032113487, -5.893640930572713],
            [20.041409879812399, -5.886780019938216],
            [20.041580301899916, -5.886404271534532],
            [20.04297011961194, -5.883339981084698],
            [20.050009864354017, -5.867749305139257],
            [20.049934626855684, -5.866942409947124],
            [20.049580079779361, -5.86313995822932],
            [20.051439840352518, -5.859019942162984],
            [20.054009232270857, -5.857544217592483],
            [20.055809880105048, -5.856510017079663],
            [20.058941783579584, -5.85682064869634],
            [20.065690079809194, -5.857489964531488],
            [20.071884509868898, -5.855920447586271],
            [20.079029880318689, -5.854109980837817],
            [20.085021390837149, -5.850239586699629],
            [20.088427260710443, -5.849292951084502],
            [20.091463169315382, -5.848445327386873],
            [20.094672677349003, -5.843739060937577],
            [20.097249839694598, -5.839960005634009],
            [20.100377876820129, -5.839256472396696],
            [20.109210951720073, -5.837269051095022],
            [20.10969709659566, -5.836719892623941],
            [20.112450120327761, -5.833610013576165],
            [20.112544771317669, -5.831097376703019],
            [20.112710039770366, -5.826710065052902],
            [20.111191889635165, -5.817799214327422],
            [20.110709879704856, -5.814970005797544],
            [20.114939648424112, -5.797280988061249],
            [20.124108286303485, -5.787541433640762],
            [20.12579262027467, -5.785847872188625],
            [20.137240080112303, -5.777340080117041],
            [20.139104486772084, -5.775967093874775],
            [20.139630119790915, -5.775580006698465],
            [20.149300079582598, -5.771720054541352],
            [20.154151997213098, -5.765998136233589],
            [20.154075367326097, -5.765869168486804],
            [20.152090079768428, -5.762539941390383],
            [20.155819029631914, -5.753377248218113],
            [20.155828094531458, -5.753354974825218],
            [20.158616172322599, -5.749629218936848],
            [20.160450000330115, -5.747180125498981],
            [20.165969880053058, -5.746290000745736],
            [20.171059835064206, -5.738729553378576],
            [20.168851408684883, -5.727767751039427],
            [20.168600191222428, -5.726520783299671],
            [20.171599920179336, -5.721710048090617],
            [20.171159999913328, -5.7206199363995],
            [20.170799900350215, -5.719730376136851],
            [20.170479959971907, -5.718940021948392],
            [20.173019746113432, -5.715738722501702],
            [20.171210039667912, -5.709750081491859],
            [20.17172015698517, -5.700549996303357],
            [20.171704520909323, -5.700523358410634],
            [20.167379999690525, -5.693169901492515],
            [20.167959837053612, -5.691132534631905],
            [20.168099983221083, -5.690640105416763],
            [20.17224000036197, -5.689739966134947],
            [20.176322482205563, -5.692732560165617],
            [20.176359840443286, -5.692759945299867],
            [20.180260080166853, -5.692550125447994],
            [20.18188008039067, -5.69048994057535],
            [20.180549880270782, -5.681739989659342],
            [20.18091898364797, -5.676119894821198],
            [20.181290023792936, -5.670470252525703],
            [20.181149478773449, -5.670295904232713],
            [20.176260120260228, -5.664240042958913],
            [20.176061300629964, -5.661270061991072],
            [20.176059960343562, -5.661250041020654],
            [20.177679959669046, -5.659420020749507],
            [20.179725929322515, -5.658914073637026],
            [20.1841099199114, -5.6578299561795],
            [20.186200080388613, -5.653710044848778],
            [20.184520706016109, -5.648351071715756],
            [20.182590000095079, -5.642190026059049],
            [20.182714640442455, -5.6418053707271],
            [20.186309879669174, -5.630709950872136],
            [20.188768817435133, -5.627968507878477],
            [20.189790762461925, -5.626827013733728],
            [20.19072946061133, -5.623149484164086],
            [20.181819959741958, -5.61390004594204],
            [20.181390120370079, -5.608610037244302],
            [20.17909122465851, -5.606615359462912],
            [20.173381008994824, -5.601660759157316],
            [20.166491326922682, -5.601390096904028],
            [20.165820390508308, -5.600435950653136],
            [20.165360039857816, -5.599780093158106],
            [20.166980040081633, -5.596109967870884],
            [20.170438180226334, -5.594057039011418],
            [20.170448306934546, -5.594048851664274],
            [20.17256395980289, -5.59068626498183],
            [20.172750120374154, -5.59039003637272],
            [20.163390119779692, -5.580680012703149],
            [20.16017865611369, -5.579969036722431],
            [20.154459960353737, -5.575560100319908],
            [20.153698519572831, -5.57192768145208],
            [20.153109959568361, -5.569119966894182],
            [20.153706157049385, -5.567886613734052],
            [20.155439880394916, -5.564300044919791],
            [20.154530452052406, -5.561760746727916],
            [20.155037017431006, -5.5605134252401],
            [20.156860080028174, -5.556029974943653],
            [20.156744412952175, -5.554336729290864],
            [20.156640120344324, -5.552809987940853],
            [20.155065106851648, -5.551464399967128],
            [20.150939879573571, -5.547940062812325],
            [20.153009880059194, -5.545659978457913],
            [20.155809960240816, -5.53692988840946],
            [20.155839840003807, -5.531409924666415],
            [20.1535579574854, -5.530481471110114],
            [20.153153243093705, -5.530778855404746],
            [20.153069999809571, -5.530840022819285],
            [20.152006313664817, -5.531656251109316],
            [20.148469920377394, -5.534369925165647],
            [20.145259451146408, -5.534806673124001],
            [20.144810159655382, -5.532730006900881],
            [20.147429879687536, -5.514800028978655],
            [20.150439840455519, -5.510220038992194],
            [20.152600943585639, -5.508984129969503],
            [20.15642015976217, -5.506799958366291],
            [20.153239919738809, -5.500810059483877],
            [20.152820218753241, -5.49206114587891],
            [20.15086133717335, -5.488071737113466],
            [20.150330040276661, -5.486990005020692],
            [20.151719999922495, -5.484470008326023],
            [20.164110120378233, -5.486380054576487],
            [20.170429681265425, -5.48605895343779],
            [20.176509959707037, -5.485750010752644],
            [20.177612813296502, -5.4846631172967],
            [20.178587954300358, -5.483699321751283],
            [20.17377000017412, -5.482059972008097],
            [20.166192509529921, -5.482709703951127],
            [20.164359959825074, -5.481319952285515],
            [20.155280039563145, -5.482469897638858],
            [20.153092685863776, -5.479645159369744],
            [20.151299880322011, -5.477329928842727],
            [20.150942856590422, -5.476213767381973],
            [20.150660160363774, -5.475329973063855],
            [20.147344254071267, -5.464835598789875],
            [20.146780079733507, -5.463050048049139],
            [20.149170120310444, -5.445809930382278],
            [20.147711405409364, -5.437547636657916],
            [20.14603992004167, -5.428080046534437],
            [20.146961108229551, -5.426443994400815],
            [20.147199840007882, -5.426020000285022],
            [20.154419999696653, -5.424560093850328],
            [20.156776018378821, -5.422486142477427],
            [20.16201891516036, -5.417870910434599],
            [20.167319879940141, -5.4157399355366],
            [20.167893458740618, -5.414641022773216],
            [20.168629920068437, -5.41323004223113],
            [20.165540039782883, -5.412719951830829],
            [20.150669880135133, -5.422120030149615],
            [20.145160080407987, -5.421860055779952],
            [20.143618954062752, -5.420588025825483],
            [20.142640079660595, -5.419780072183186],
            [20.14014995957449, -5.413089915038376],
            [20.14234837961984, -5.402955958338338],
            [20.142740046880359, -5.401149234835322],
            [20.14260983967317, -5.400309907271284],
            [20.141629919632024, -5.394009961299901],
            [20.142180171879538, -5.392822261110496],
            [20.145350160328853, -5.385979911428438],
            [20.148109919628958, -5.383700098807782],
            [20.157289247460223, -5.384438692385585],
            [20.156379926915566, -5.382590151286171],
            [20.149742039922579, -5.379101149811394],
            [20.149989840193712, -5.374969950959033],
            [20.144601829561182, -5.353086851031448],
            [20.145745668785526, -5.351138009923464],
            [20.146219919966704, -5.350329992438135],
            [20.15746992022342, -5.350160064284488],
            [20.157250080913844, -5.348321111406065],
            [20.156418806001042, -5.347732057389763],
            [20.154960000370124, -5.346699945541578],
            [20.149001033119447, -5.346438096304979],
            [20.152394266391603, -5.341201293939932],
            [20.153379959905095, -5.339680057987217],
            [20.155479112518321, -5.336448876519293],
            [20.157329837836343, -5.333600079468103],
            [20.162850120004517, -5.331560099612693],
            [20.164034180397369, -5.33057331004243],
            [20.167229880426774, -5.327910022126958],
            [20.174818784166629, -5.326340333105209],
            [20.17944584000681, -5.329858140311516],
            [20.18121304625792, -5.331199732282037],
            [20.183969879745153, -5.33099000622686],
            [20.179879131604302, -5.327583004741199],
            [20.177570340051574, -5.325660106134971],
            [20.177281677214808, -5.325132608508034],
            [20.17529999998624, -5.321510085702581],
            [20.181080160274554, -5.313719890411281],
            [20.171059920404161, -5.298469935491921],
            [20.171155783221383, -5.298058343301318],
            [20.172930120299224, -5.290440051226229],
            [20.176390080430679, -5.287929996131361],
            [20.183500079716154, -5.289119971587096],
            [20.199849840095332, -5.278169986131833],
            [20.203800000995862, -5.270600203515587],
            [20.20366859184286, -5.270158046852577],
            [20.201939999674217, -5.264350007652595],
            [20.201540040065325, -5.263000081217546],
            [20.192640119728463, -5.253289925088139],
            [20.191954831829129, -5.250396085524917],
            [20.190620159895758, -5.244759986497155],
            [20.186290079901983, -5.238990019995657],
            [20.187229832673545, -5.234390996577101],
            [20.194589879814995, -5.231439987669167],
            [20.195140326098578, -5.230839537882319],
            [20.198990160453246, -5.226639958159449],
            [20.198789999638283, -5.219040059836209],
            [20.197020756906419, -5.214371722767426],
            [20.196519840134332, -5.213049992127942],
            [20.196983643908766, -5.211048923101357],
            [20.198170080345538, -5.205930037716386],
            [20.197190823261082, -5.203550771618633],
            [20.1970300472831, -5.203160138477607],
            [20.192010120439921, -5.198530008728138],
            [20.191343129426304, -5.197037570346896],
            [20.189949839725696, -5.193919977548171],
            [20.19250007956218, -5.192089954580664],
            [20.199390120062166, -5.19074992112593],
            [20.200319164017198, -5.188681779966925],
            [20.199430079820917, -5.1859300125947],
            [20.199416797331139, -5.185919365485112],
            [20.195344148446676, -5.182654624569842],
            [20.188439999905174, -5.177120041853003],
            [20.187884301172094, -5.175551655809905],
            [20.187540000279899, -5.174579909569925],
            [20.190110558211501, -5.166548694034942],
            [20.193812480463048, -5.15699262736988],
            [20.19428999971527, -5.15575995765178],
            [20.193989786340588, -5.153716105959337],
            [20.193410160081587, -5.149770000412103],
            [20.190670514060692, -5.14561099162351],
            [20.190329211744906, -5.144352145648164],
            [20.186174444267046, -5.129025824774708],
            [20.183310611548013, -5.126131863294961],
            [20.183199840290325, -5.12601997690374],
            [20.179550159564112, -5.121630022954732],
            [20.179471747419601, -5.120901345801151],
            [20.17846008001797, -5.111499948719805],
            [20.179169999722411, -5.109080001043159],
            [20.182659839616854, -5.097259983701483],
            [20.182590013569801, -5.096602849072736],
            [20.182219920249178, -5.093119892211254],
            [20.179260000134079, -5.088729890113877],
            [20.175609473194864, -5.087047096343777],
            [20.169650160092804, -5.084300004274533],
            [20.168290529367578, -5.080841157462043],
            [20.170190159867978, -5.067970000515483],
            [20.1696007662269, -5.065735564119166],
            [20.168610120301246, -5.061979928804793],
            [20.164047125120611, -5.057818958722754],
            [20.155472946482213, -5.054595362310856],
            [20.150989920226486, -5.052909892176483],
            [20.146449959646354, -5.043449974018935],
            [20.14018194409018, -5.035787685208217],
            [20.1398376279266, -5.035366664024453],
            [20.138939999853662, -5.031219948826714],
            [20.139135813721001, -5.028600254354521],
            [20.139919919894837, -5.018109975686111],
            [20.143672707452737, -5.007441638186543],
            [20.144120007378767, -5.006170051764929],
            [20.14394754881053, -5.004872198715558],
            [20.143299959610424, -4.999999953011676],
            [20.143274795104364, -4.999786529463478],
            [20.143239839860041, -4.999490062457482],
            [20.134776669634533, -4.984466732914587],
            [20.13140988006937, -4.978490107216643],
            [20.130329518497991, -4.974756755136209],
            [20.129609879920515, -4.972269922955213],
            [20.122697026703907, -4.96784752189351],
            [20.119089896477778, -4.965539833089357],
            [20.115223180083959, -4.9590653944263],
            [20.110089960412108, -4.931440092166603],
            [20.107940040408948, -4.904049939008001],
            [20.102789880307469, -4.891550094582035],
            [20.102050079941741, -4.889750094601024],
            [20.10117002201746, -4.883070980488475],
            [20.102609458174229, -4.87111351370023],
            [20.091239999951028, -4.852179905461318],
            [20.09125240748174, -4.848499628759539],
            [20.091260159942657, -4.846200063201314],
            [20.089131547978017, -4.841583553123449],
            [20.086049880090798, -4.834900009940382],
            [20.08549751680237, -4.832265075771821],
            [20.084700742586396, -4.828455429447707],
            [20.085051276888347, -4.826558635241711],
            [20.085890040157324, -4.822019935138494],
            [20.085125943058127, -4.82012559811214],
            [20.084450039858574, -4.818449905232481],
            [20.079447216040101, -4.812830026668913],
            [20.07837000036886, -4.81161994013607],
            [20.077226848355732, -4.808810766654356],
            [20.069079840194469, -4.788790030069988],
            [20.057329622953272, -4.783016647772669],
            [20.055810412806025, -4.782270191567736],
            [20.055610080412819, -4.776980025667967],
            [20.058440040357436, -4.762500015385307],
            [20.058009839862823, -4.756290020690598],
            [20.059496840017243, -4.751771246209335],
            [20.060579203035086, -4.748479470192595],
            [20.050759995345501, -4.740369531867334],
            [20.049630120432273, -4.737140082728414],
            [20.055117266444586, -4.730788471777907],
            [20.056550039796882, -4.729129964480895],
            [20.057903067904782, -4.726102023086468],
            [20.060039879691324, -4.721320022256863],
            [20.059542786149084, -4.71846605600714],
            [20.058919920382227, -4.714889982023578],
            [20.058230159771082, -4.713559924912236],
            [20.053730159848065, -4.704969901624371],
            [20.053363921198319, -4.704140067900081],
            [20.051889839715994, -4.700800045660115],
            [20.055149974104072, -4.690929702924464],
            [20.054909481627792, -4.68933344776192],
            [20.054490120205394, -4.68654995513975],
            [20.056798902774982, -4.683801081384128],
            [20.062370392507638, -4.68305500163209],
            [20.06666999985034, -4.682480037661443],
            [20.067586928227154, -4.681483389949642],
            [20.069200079695232, -4.679729983199104],
            [20.06944992004037, -4.676510015481089],
            [20.070870119673632, -4.668470091219665],
            [20.065021853612066, -4.662079597846158],
            [20.064940547994006, -4.661990753011431],
            [20.060870930025285, -4.650236466656334],
            [20.061541765828313, -4.647618239179137],
            [20.062048545904293, -4.645638008199083],
            [20.068970022049303, -4.636939933862684],
            [20.066709959609128, -4.630709994391435],
            [20.056460040283515, -4.618230086508916],
            [20.05929555271489, -4.611913232944804],
            [20.063879999664511, -4.601700046332105],
            [20.063019302231243, -4.598487938967873],
            [20.062090080409757, -4.595020085699534],
            [20.069259840119507, -4.58402003853798],
            [20.073449879946999, -4.571169934935333],
            [20.076920424927486, -4.568323783324811],
            [20.078619839815673, -4.56693011065013],
            [20.081286512991081, -4.564752819453892],
            [20.081853119068356, -4.563672409374115],
            [20.084760071819328, -4.558108604966177],
            [20.084874670798449, -4.555674492786634],
            [20.085540032268131, -4.541541920163383],
            [20.095176764275749, -4.540924248169267],
            [20.095400185168387, -4.540909927954923],
            [20.102349960041462, -4.528289956132752],
            [20.109221108072692, -4.522014905947781],
            [20.111108656232499, -4.520291100147682],
            [20.111831693136729, -4.515813767175191],
            [20.112999839874295, -4.508569959849155],
            [20.119209840432827, -4.505609910312602],
            [20.12264354370685, -4.502207224190466],
            [20.124749880147398, -4.500119906038709],
            [20.124048764831073, -4.495038451710045],
            [20.12386010873994, -4.493671130706268],
            [20.114510039919253, -4.484880057706963],
            [20.111652958039574, -4.480343736156845],
            [20.109270925943392, -4.476561650328108],
            [20.104619374842056, -4.476324733827368],
            [20.099189880009732, -4.476050068328613],
            [20.092330080395502, -4.470949921327649],
            [20.090059919993219, -4.465410062121113],
            [20.092179960233423, -4.455759947756023],
            [20.088289372009271, -4.444050171324064],
            [20.088119879678086, -4.443540034209162],
            [20.089938308764992, -4.440264006540739],
            [20.093209920029153, -4.434369933036494],
            [20.087100156184981, -4.418910411498429],
            [20.085728303880305, -4.417028277723677],
            [20.074809959829878, -4.402049951802939],
            [20.074457291130816, -4.400256112994918],
            [20.071910160363522, -4.387300064198407],
            [20.069695988359634, -4.384653760860849],
            [20.066889090863302, -4.381296998463725],
            [20.06559397444682, -4.376712637934497],
            [20.064869999701489, -4.374149949170581],
            [20.061910079586387, -4.369759997125746],
            [20.051849879957206, -4.364870080603401],
            [20.048331976693273, -4.361305796808681],
            [20.047280039614122, -4.360239986882302],
            [20.046309840242632, -4.358259990194221],
            [20.045823218361658, -4.357268372181468],
            [20.043659880223089, -4.352859989836647],
            [20.043565836494285, -4.347206916790477],
            [20.043479880298019, -4.342039924030923],
            [20.042881100160571, -4.339906077798449],
            [20.040569999937535, -4.331670059411755],
            [20.04398531290105, -4.318741681663484],
            [20.045000160338773, -4.314900021228229],
            [20.044106517192457, -4.312943058997071],
            [20.043420119873744, -4.311439935877822],
            [20.037690000238339, -4.309789950687149],
            [20.033589959924214, -4.305630017824512],
            [20.033081369742952, -4.295054868259327],
            [20.032970039733137, -4.292739956725088],
            [20.035749959923173, -4.287689942734712],
            [20.037587909401235, -4.286235691236296],
            [20.038049863544515, -4.285869699358011],
            [20.05499987999314, -4.290110086602754],
            [20.071630080030953, -4.290980120938094],
            [20.081475138539513, -4.289229065502053],
            [20.092160159567932, -4.287329958485329],
            [20.097426396377159, -4.290009345425856],
            [20.101299840254107, -4.29198009366346],
            [20.103189600964498, -4.292280011364919],
            [20.108859839801383, -4.293179915254926],
            [20.126109960030245, -4.292459950926504],
            [20.13044004002402, -4.294450005627827],
            [20.13274171512311, -4.296353314193047],
            [20.137719960137066, -4.300469922346122],
            [20.139540450857574, -4.305251556495062],
            [20.140880040168827, -4.308770053386089],
            [20.145449879613583, -4.312019882305492],
            [20.155306262284618, -4.313919321938517],
            [20.155769145285895, -4.31417523699573],
            [20.160330120155461, -4.316709942095335],
            [20.162890480411942, -4.319588258554679],
            [20.164439880240945, -4.321330063252763],
            [20.165498947248526, -4.330383834790186],
            [20.166191235718873, -4.336291682377118],
            [20.169328559627829, -4.339875780175699],
            [20.169839879789237, -4.340459913868566],
            [20.170158868851683, -4.340621572586949],
            [20.173506715642421, -4.3423182061059],
            [20.178270000097136, -4.341639889871723],
            [20.178558968361081, -4.341597471134091],
            [20.179697270369982, -4.341430376939204],
            [20.184959879782092, -4.342839990802923],
            [20.194929684639185, -4.337765856434118],
            [20.200600079782962, -4.33487989283413],
            [20.216400119717246, -4.338650050531739],
            [20.219177018872969, -4.34055741552153],
            [20.231250120271696, -4.348849994121944],
            [20.234170079729683, -4.361300068208073],
            [20.230689974877986, -4.368869894211907],
            [20.234060543655502, -4.382000118184084],
            [20.250330120412393, -4.384850047349426],
            [20.253385669782741, -4.386499628862611],
            [20.254219022498795, -4.386949525401239],
            [20.260130040374534, -4.397330063012165],
            [20.263196695616763, -4.398180453561205],
            [20.266080119693829, -4.398980033133499],
            [20.268438608743011, -4.398281160262034],
            [20.270670120028509, -4.397619913477384],
            [20.274806503484072, -4.394079138483721],
            [20.27574000038798, -4.393280055817436],
            [20.281719960368562, -4.390550089032535],
            [20.286647196345768, -4.390240485372938],
            [20.295249839900592, -4.389699937627813],
            [20.29900340539951, -4.386848238268568],
            [20.302160040392138, -4.384450036299119],
            [20.306446239480898, -4.383809923490049],
            [20.308120793493615, -4.383560280200532],
            [20.31338987975893, -4.385199921700172],
            [20.327109840110126, -4.393790036817801],
            [20.332135723681919, -4.395529289632288],
            [20.339933083280098, -4.398227628974884],
            [20.343949848869059, -4.398399142956212],
            [20.346118650561209, -4.398490910466744],
            [20.346421742138055, -4.398503819681754],
            [20.352539879179005, -4.39876996838548],
            [20.361135301177267, -4.393729784109174],
            [20.361508930266865, -4.393510694784847],
            [20.362488822460236, -4.391180852785642],
            [20.362668401075432, -4.390753526075392],
            [20.359720079108993, -4.384760017493292],
            [20.368976052996906, -4.373874091985225],
            [20.371019248652772, -4.371471072453428],
            [20.371294659542457, -4.370731142356078],
            [20.372640119344073, -4.367109911402284],
            [20.366211504778043, -4.354647896792086],
            [20.362880159140719, -4.348189925875191],
            [20.36521007906898, -4.341300058373965],
            [20.367804477389885, -4.337247708528008],
            [20.371669919074286, -4.331209995451538],
            [20.377019878867994, -4.310799963127124],
            [20.377945958382607, -4.30904333305352],
            [20.382839998915134, -4.299760028969502],
            [20.387439359695069, -4.297470392929576],
            [20.39753015953611, -4.296830050266717],
            [20.398148479827626, -4.296921829408893],
            [20.398812228821384, -4.297017934442956],
            [20.401808450755421, -4.294271197394733],
            [20.408119918720235, -4.292510092746859],
            [20.408553296556011, -4.292105442877039],
            [20.41128567340963, -4.289554185165995],
            [20.415730920117756, -4.284330923245189],
            [20.416524569993193, -4.284668994084514],
            [20.426950080312452, -4.289109931937471],
            [20.446580160224119, -4.289180023662871],
            [20.460049920005769, -4.295460038683814],
            [20.469237745001283, -4.294570097859375],
            [20.474629920223457, -4.290690049484501],
            [20.475984748555202, -4.287512014862729],
            [20.476249920447273, -4.286889996540886],
            [20.477179454882485, -4.284741597758225],
            [20.477528626440144, -4.282884024947474],
            [20.479759920333343, -4.270999981225096],
            [20.481540119816703, -4.267739910140905],
            [20.483670881449832, -4.266389900683149],
            [20.484870119777707, -4.265630085976677],
            [20.494963277696364, -4.263912622817553],
            [20.506380120254164, -4.261969915231022],
            [20.514259869736897, -4.257541642269126],
            [20.535580080448316, -4.245559949884678],
            [20.535639243492955, -4.245538128607337],
            [20.557427940896382, -4.237501550287378],
            [20.571465716211947, -4.232346703129695],
            [20.588636959867298, -4.226041161283496],
            [20.591279702821861, -4.223802932731552],
            [20.593230119576869, -4.222149934742201],
            [20.596776393434098, -4.221915357807002],
            [20.60607996006577, -4.22129995162167],
            [20.609977286552887, -4.217308077349522],
            [20.613909959949787, -4.213279978515745],
            [20.630678523897537, -4.20738044052012],
            [20.630753442493933, -4.206642466120705],
            [20.631139919288721, -4.202769947730489],
            [20.627049958970392, -4.197929997473751],
            [20.627464632983639, -4.194352495004204],
            [20.627529732095667, -4.193790864214039],
            [20.635599959452946, -4.183019911192491],
            [20.636529838841213, -4.179110035192684],
            [20.635716829373099, -4.169094998877459],
            [20.63567020770817, -4.168520679220335],
            [20.637290159422975, -4.164389944469284],
            [20.648549879451053, -4.158919899288168],
            [20.651214836844275, -4.155150420979379],
            [20.656434960435028, -4.147766683620693],
            [20.659933440325855, -4.130704455633969],
            [20.660491799868804, -4.120209125876594],
            [20.662129080085421, -4.103414148521001],
            [20.660152328319572, -4.07959599491533],
            [20.661678360273076, -4.071933479244718],
            [20.661713279584816, -4.058290754825619],
            [20.657534400426393, -4.029967982475682],
            [20.653360559918429, -3.99954535318238],
            [20.643459479773849, -3.971134932047415],
            [20.644458840256046, -3.947619685330588],
            [20.644519320230895, -3.924003432226439],
            [20.646728640433892, -3.891457942381684],
            [20.644177680148537, -3.850003214292608],
            [20.643755039875362, -3.807490295109691],
            [20.642787719604371, -3.770225834186219],
            [20.640773519769251, -3.726663846824957],
            [20.639251799729116, -3.698321896810369],
            [20.636146439674583, -3.665783976359888],
            [20.634645960299316, -3.629040098631607],
            [20.632603680026762, -3.596496399946715],
            [20.630567880200637, -3.561326339881906],
            [20.630640599721207, -3.532974273888581],
            [20.63096676003455, -3.509346012455199],
            [20.631023999786134, -3.487030565056529],
            [20.628951120200053, -3.466296261807166],
            [20.62792187995483, -3.453172297983293],
            [20.627420760163499, -3.441359296102511],
            [20.626651020746007, -3.434972464764742],
            [20.625590184955602, -3.426170216947274],
            [20.628834120024191, -3.408273358663602],
            [20.62781712022305, -3.39042225007972],
            [20.626284599738213, -3.366270971705398],
            [20.625275520382949, -3.345268278713634],
            [20.625322319914304, -3.326887736875275],
            [20.627475119916291, -3.316378014614981],
            [20.638799217709188, -3.293704058077769],
            [20.657842200073659, -3.236047997505121],
            [20.658544200230562, -3.233060943546866],
            [20.656944359998342, -3.232361863677665],
            [20.655828366751194, -3.226143940889223],
            [20.658195360151201, -3.20935997716908],
            [20.665405439844172, -3.184776869315551],
            [20.665517911612699, -3.183853257939816],
            [20.667309480174328, -3.169140911108452],
            [20.671974359579533, -3.150758019088025],
            [20.672754426927856, -3.149304275894408],
            [20.675668320062709, -3.143873887828689],
            [20.682971627814183, -3.137588116020528],
            [20.684173325729311, -3.136553816103543],
            [20.687505479850387, -3.118450216457216],
            [20.690192519629921, -3.106886057918104],
            [20.694473639644059, -3.095316910878076],
            [20.700365400335087, -3.077439147603525],
            [20.709470520137362, -3.050096044899266],
            [20.71803420016505, -3.026430839973622],
            [20.726610479962925, -2.998037301241863],
            [20.735708399768196, -2.973318919877222],
            [20.745877680025696, -2.945444349538298],
            [20.753903159603727, -2.92440552583039],
            [20.765131199645001, -2.898102743178088],
            [20.775824999908686, -2.872851648011822],
            [20.78704656040183, -2.849174699716869],
            [20.796379134532344, -2.8300559921412],
            [20.800402920455255, -2.82181276781771],
            [20.806826040026742, -2.803928926586989],
            [20.816960400074201, -2.789711591802941],
            [20.828152079906022, -2.777592570255504],
            [20.839868279744035, -2.768098849411889],
            [20.855310480276497, -2.756492127630764],
            [20.865428279881701, -2.748579566876863],
            [20.865990600096723, -2.736492524779861],
            [20.864966759624686, -2.721257392706399],
            [20.863930679606899, -2.710751452767596],
            [20.864483999601099, -2.702342421747704],
            [20.868229439838302, -2.692347067069314],
            [20.874646079861627, -2.677088688998979],
            [20.893325399944597, -2.646553532410957],
            [20.905588080004211, -2.631276755637908],
            [20.923189560086787, -2.606524418367147],
            [20.938134959927762, -2.581254307286938],
            [20.949886440200245, -2.558095337887873],
            [20.957387399772124, -2.534423507528951],
            [20.957437080200602, -2.51497828758471],
            [20.962133248825477, -2.489821043708165],
            [20.998298853530528, -2.492904179798402],
            [21.016336328241298, -2.49444189528112],
            [21.038742359586092, -2.498454976159066],
            [21.054319199613349, -2.493694893019654],
            [21.060021563103106, -2.493911360240174],
            [21.068046359961546, -2.494215989271622],
            [21.068689370448649, -2.494695039996913],
            [21.068905320053059, -2.494855925489948],
            [21.071299613254556, -2.496637467914637],
            [21.078310319955062, -2.501853971106136],
            [21.081240967568274, -2.503179088133218],
            [21.0844764000827, -2.504642014648394],
            [21.088840865788907, -2.505079537852779],
            [21.0940822803502, -2.505604972616579],
            [21.101292342975196, -2.503263684173366],
            [21.122032320166472, -2.496528869974218],
            [21.132557280275901, -2.496115990454705],
            [21.138271199693484, -2.497750940286966],
            [21.1515022797991, -2.507240991037378],
            [21.15622665462557, -2.509243745174109],
            [21.159725400417734, -2.510726930093414],
            [21.174812280424405, -2.514244011062551],
            [21.185972280269421, -2.513637934510768],
            [21.195543133427364, -2.513119003614918],
            [21.202274519770047, -2.51275402873057],
            [21.221403724232125, -2.508266306951679],
            [21.244640399872353, -2.502814949785577],
            [21.251037240128518, -2.505372876010232],
            [21.266592329247757, -2.506130018664766],
            [21.270597147243457, -2.505112786419123],
            [21.27460823997141, -2.504093913530504],
            [21.303812159939373, -2.484240935899062],
            [21.311989199678898, -2.481249017564665],
            [21.317070123926452, -2.48072749779557],
            [21.322746359916199, -2.480144872466537],
            [21.345587505540223, -2.48328104936934],
            [21.353845319993461, -2.484414876569785],
            [21.360874505039355, -2.481621831135968],
            [21.371031359799833, -2.477585996680832],
            [21.379687288722387, -2.475667270239622],
            [21.391409159624779, -2.473068922825746],
            [21.397812480327403, -2.47401587761858],
            [21.402060953767492, -2.476709538395939],
            [21.403290239843312, -2.477488942238156],
            [21.420662399796779, -2.48193091463708],
            [21.421529229130201, -2.482780883948878],
            [21.424000320203657, -2.485203909006878],
            [21.427728480448028, -2.488859885543332],
            [21.443254218013706, -2.497663864685804],
            [21.412697400193565, -2.445885662907314],
            [21.412233720386627, -2.442199854806061],
            [21.412117439761303, -2.434830369148156],
            [21.411524160008319, -2.422956201951405],
            [21.411375479845653, -2.413539553634689],
            [21.411181440151015, -2.401257150538871],
            [21.410549280414219, -2.386926459114887],
            [21.409302959585641, -2.372184679846148],
            [21.408857640444811, -2.356831011799152],
            [21.407784479768736, -2.340247394155154],
            [21.407963399918827, -2.325918946068304],
            [21.410085240382845, -2.309602927226076],
            [21.416465159972283, -2.31629993356812],
            [21.434520239866004, -2.320513909795161],
            [21.45530520019517, -2.329338006553048],
            [21.465793427294283, -2.338350942597782],
            [21.470888160444424, -2.340730013173927],
            [21.485662200356746, -2.347631981454982],
            [21.495491279633001, -2.349970867466445],
            [21.502468392036814, -2.352825783837772],
            [21.514221359919421, -2.357634886046303],
            [21.536810280171217, -2.373825904755561],
            [21.547371511556879, -2.375019517523908],
            [21.55579019990445, -2.375970982954049],
            [21.55771063538683, -2.376906952209737],
            [21.561498360222743, -2.378752988581653],
            [21.565932019562041, -2.382836669578791],
            [21.566515147453998, -2.383373765604023],
            [21.572859240433296, -2.401568858653248],
            [21.586048877661582, -2.41207001849394],
            [21.595215240108342, -2.419367929389647],
            [21.602499972496336, -2.420442468900189],
            [21.608021160166356, -2.421256874254784],
            [21.623277610657627, -2.42802349665824],
            [21.62423898138648, -2.428449887508302],
            [21.634065539990043, -2.431247891334873],
            [21.634112384437184, -2.431248069333153],
            [21.646419564341048, -2.431295031962203],
            [21.653017199622756, -2.442590963418791],
            [21.664425239589065, -2.451375011562491],
            [21.670023712916233, -2.458836218649003],
            [21.673080360027864, -2.462909860932351],
            [21.681068399621505, -2.468919884513109],
            [21.696373439986477, -2.475647974792263],
            [21.708022799777456, -2.478219648108349],
            [21.731353200244548, -2.483369974512895],
            [21.744113513733925, -2.487575311366051],
            [21.751810200036523, -2.490111853700193],
            [21.753929169484888, -2.490810442878634],
            [21.755350439909986, -2.491279012414994],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Bukavu",
        AREA: 65070,
        POPULATION: 5772000,
        DISTRICTS: [],
        OBJECTID: 22,
        NOM: "Sud-Kivu",
        SCE_SEM: "INS",
        MODIF: "2010/06/18",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.050726461779767, -1.583851273268235],
            [29.051395268288552, -1.58394704597834],
            [29.05204747213428, -1.58394704597834],
            [29.052420159789492, -1.584343026278481],
            [29.052769554129327, -1.584808886260946],
            [29.053305293195102, -1.585251453191095],
            [29.053841031362573, -1.585251453191095],
            [29.054260305648391, -1.585414503808168],
            [29.054563114255952, -1.585414503808168],
            [29.05507556000639, -1.585484382640075],
            [29.055588005756857, -1.58497193691331],
            [29.056543018210121, -1.584459491058065],
            [29.057125343008234, -1.584203268534239],
            [29.05759120212803, -1.584040217820566],
            [29.058266699289099, -1.584459491058065],
            [29.05905866033179, -1.58485547216295],
            [29.059710864177493, -1.585274746137193],
            [29.060549411850822, -1.585437796752396],
            [29.061248201428864, -1.585740605907209],
            [29.061714060548692, -1.585321332028574],
            [29.062179920566816, -1.585740605907209],
            [29.062575901537329, -1.585950242362268],
            [29.063996773110421, -1.585903656485225],
            [29.064742148420802, -1.585787191787967],
            [29.065464231314181, -1.58534462497387],
            [29.06583691896936, -1.585437796752396],
            [29.066186314207524, -1.585530968526685],
            [29.066349364719791, -1.585228160244743],
            [29.067001568565527, -1.585228160244743],
            [29.067118033345476, -1.585624140296661],
            [29.067281083857782, -1.5860667070502],
            [29.067420841953037, -1.586276344375777],
            [29.067933287703511, -1.586812082703765],
            [29.067979873435821, -1.587254649199794],
            [29.068142924846423, -1.587650630666626],
            [29.06823609631104, -1.588139782807798],
            [29.06842244013864, -1.588396005741584],
            [29.068888300156768, -1.588396005741584],
            [29.069074643984376, -1.588675521550466],
            [29.069214402079638, -1.589397604255961],
            [29.069633675467156, -1.589746998613349],
            [29.07009953548528, -1.589933342667992],
            [29.070588687920413, -1.590189565376303],
            [29.070891496527974, -1.590702011600175],
            [29.071287477498455, -1.591167871034299],
            [29.071520407058365, -1.591633730361862],
            [29.072032852808835, -1.591983125239513],
            [29.07266176333923, -1.592146176222146],
            [29.073313967184962, -1.592379106691269],
            [29.073872998667742, -1.592402399555881],
            [29.074385444418208, -1.592518863875098],
            [29.074664960608764, -1.593147774699552],
            [29.074455323465859, -1.594102786993996],
            [29.074664960608764, -1.594708404490355],
            [29.075130820626889, -1.595057799743527],
            [29.075363750186806, -1.59536060837187],
            [29.075783023574292, -1.595733296339226],
            [29.076295469324759, -1.595942932669264],
            [29.076831208390534, -1.595896347020903],
            [29.077693048480874, -1.595710003512781],
            [29.077856099891438, -1.595500366254632],
            [29.078461717106528, -1.59568670978204],
            [29.078974162857001, -1.59536060837187],
            [29.079533194339774, -1.59557024564442],
            [29.079859296262644, -1.596152569881702],
            [29.080534792525377, -1.59629232770995],
            [29.08074442966829, -1.597014410422455],
            [29.080814308715901, -1.598016008306382],
            [29.081210289686414, -1.598644919235628],
            [29.082048836461421, -1.599157365134066],
            [29.083423123200525, -1.5990409002918],
            [29.084168498510877, -1.599506759620636],
            [29.085519491934683, -1.599530052403469],
            [29.086148402465074, -1.600158962862553],
            [29.086404625340297, -1.600461772536879],
            [29.086567675852596, -1.600881046004955],
            [29.086567675852596, -1.60150995604413],
            [29.086660848215541, -1.602185453200548],
            [29.086893777775458, -1.602767777343685],
            [29.087103414918371, -1.603024000238974],
            [29.0875925673535, -1.603117172110639],
            [29.087336344478281, -1.603373394961592],
            [29.087196586382987, -1.60367620415447],
            [29.087266465430638, -1.604351700586625],
            [29.08691707109076, -1.604724388706495],
            [29.086870484460125, -1.605539642881277],
            [29.087056828287725, -1.606401483038073],
            [29.087429515942905, -1.60717015205019],
            [29.087452809258206, -1.608078577782525],
            [29.087391250406743, -1.608170916828911],
            [29.08703353587072, -1.608707489194758],
            [29.087173293067686, -1.609942016959291],
            [29.08752268830585, -1.610524341574105],
            [29.087802204496406, -1.610966908313281],
            [29.088268063616233, -1.611199838422302],
            [29.088687337902048, -1.61222472913499],
            [29.088896974146632, -1.613435964829579],
            [29.089036732241926, -1.613785359553583],
            [29.089414515141371, -1.613955970786092],
            [29.089758815135269, -1.614111461602651],
            [29.090084917058135, -1.614437563598706],
            [29.090341139035051, -1.61497330170235],
            [29.090387725665693, -1.615695384053773],
            [29.090876878100826, -1.616207830135602],
            [29.091039928613093, -1.616673690014087],
            [29.091389323851296, -1.617279307061314],
            [29.091435909583605, -1.617791752737952],
            [29.091435909583605, -1.61846724985086],
            [29.09190176960173, -1.619049573798877],
            [29.092297750572243, -1.619655191935201],
            [29.092786903007376, -1.620237516441291],
            [29.093229469710199, -1.620493738917116],
            [29.093881673555931, -1.620633496863909],
            [29.094580463133973, -1.62070337628563],
            [29.0950463222538, -1.620633496863909],
            [29.095535475587262, -1.620517032360932],
            [29.096187678534665, -1.620330688418856],
            [29.096397315677571, -1.619958000482554],
            [29.096933053845049, -1.619911414485642],
            [29.09721257003557, -1.620517032360932],
            [29.097492086226126, -1.621192528553286],
            [29.098051117708899, -1.622264006424666],
            [29.098214168221169, -1.6227764517275],
            [29.098680028239329, -1.623242311883572],
            [29.099308938769724, -1.623754756935168],
            [29.099821384520194, -1.623917808057809],
            [29.101102498896314, -1.624010979863624],
            [29.101568358016142, -1.623847928748591],
            [29.102383612374144, -1.623778050340945],
            [29.103571555285644, -1.623801342842439],
            [29.104293637280694, -1.624057565764878],
            [29.10452656773894, -1.624406960441708],
            [29.105202064001677, -1.624733062567008],
            [29.105761095484421, -1.624989285369705],
            [29.106296834550196, -1.625851126203971],
            [29.106529764110107, -1.625571610127541],
            [29.107112088908227, -1.625408559140188],
            [29.107647827075667, -1.625921004538948],
            [29.108509668064308, -1.626223813943537],
            [29.109068699547088, -1.626782844970086],
            [29.109627731029867, -1.627248705093627],
            [29.110047005315685, -1.627551513392273],
            [29.110466278703203, -1.627574806753662],
            [29.110699208263082, -1.627225411728459],
            [29.1113048263765, -1.627458341752089],
            [29.111817272126974, -1.627504927572734],
            [29.112446182657365, -1.627388462567052],
            [29.112981920824843, -1.628040666691815],
            [29.113634124670568, -1.628762748837953],
            [29.114589137123833, -1.62976434715254],
            [29.114915239046695, -1.629950691116498],
            [29.115241340969558, -1.630276793237371],
            [29.115893543916997, -1.630206914151402],
            [29.116522454447388, -1.630183620820851],
            [29.117151364977811, -1.630113741731638],
            [29.117989912651115, -1.629904105353166],
            [29.118222843109361, -1.629251901839566],
            [29.118222843109361, -1.628227010817321],
            [29.119247733711934, -1.628203717463603],
            [29.119387491807231, -1.628925799550506],
            [29.120016402337622, -1.628995678681524],
            [29.120528848088089, -1.629298487618215],
            [29.120971414790912, -1.629508124964555],
            [29.121460567226048, -1.629741054720827],
            [29.122881439697469, -1.629717761384806],
            [29.124279018853578, -1.629810932919154],
            [29.125466960866749, -1.629624589846107],
            [29.125839648521929, -1.629368366736104],
            [29.126258922807747, -1.629973984449746],
            [29.126817954290527, -1.630300085662824],
            [29.128168947714297, -1.630067155972097],
            [29.128867737292371, -1.629624589846107],
            [29.129496647822762, -1.629135436936195],
            [29.130055679305542, -1.628786042185131],
            [29.130428366960714, -1.628646283905893],
            [29.131127156538788, -1.628646283905893],
            [29.13163960228923, -1.628646283905893],
            [29.131942410896791, -1.629018972026006],
            [29.131942410896791, -1.629601296508737],
            [29.131616308973921, -1.630090449303996],
            [29.131732773753878, -1.630672773472743],
            [29.132454856647225, -1.630486429576517],
            [29.133153646225299, -1.630393258073848],
            [29.133526333880475, -1.630439843825742],
            [29.133735971023381, -1.630742652542313],
            [29.133386575785178, -1.631255098374748],
            [29.133153646225299, -1.631814129794554],
            [29.133503040565135, -1.632373161960874],
            [29.133968900583298, -1.632815728378165],
            [29.1339921938986, -1.633561103887218],
            [29.134481346333732, -1.634306479116039],
            [29.134248416773815, -1.634888803855237],
            [29.133945607267957, -1.635517714959847],
            [29.134318295821465, -1.635843816165381],
            [29.134854033988944, -1.63635626248724],
            [29.13490061972125, -1.637031758722645],
            [29.134970498768894, -1.637753841211328],
            [29.135319894007068, -1.638382752309373],
            [29.135366479739375, -1.639058248756515],
            [29.135599409299292, -1.639407643504653],
            [29.135040377816512, -1.639873503374017],
            [29.134854033988944, -1.640176311552171],
            [29.135180135911806, -1.640781929577176],
            [29.135366479739375, -1.641201202720709],
            [29.13590221880515, -1.641364254217371],
            [29.136391371240283, -1.641271082322628],
            [29.136903816990753, -1.641340961018088],
            [29.137206625598314, -1.641760234946849],
            [29.137206625598314, -1.642319266110556],
            [29.137695778033446, -1.642202801071847],
            [29.138068465688626, -1.642226094260977],
            [29.138184931366911, -1.642575489352285],
            [29.138674083802041, -1.642645368001525],
            [29.138837134314311, -1.64252890298209],
            [29.139302994332436, -1.642761833014091],
            [29.140258006785729, -1.642994763018548],
            [29.140980088780776, -1.643064641652942],
            [29.142028273597017, -1.642598782536949],
            [29.142890113687326, -1.641760234946849],
            [29.143565610848356, -1.640851808289952],
            [29.143682075628316, -1.639477522266053],
            [29.144217813795795, -1.638895197973455],
            [29.144377905257517, -1.638867753601909],
            [29.144639450650807, -1.63882291727777],
            [29.145033068153786, -1.638755439502977],
            [29.145568807219561, -1.638871904745077],
            [29.145568807219561, -1.639547401024998],
            [29.145685271999522, -1.640013260861411],
            [29.146197717749988, -1.639593987465584],
            [29.146710163500426, -1.638918490297576],
            [29.14733907403085, -1.638871904745077],
            [29.147828226465982, -1.639314471517585],
            [29.148643480823981, -1.63950081548732],
            [29.149482028497317, -1.639034955530045],
            [29.150273990438308, -1.638732146272907],
            [29.150739849558136, -1.638406044639537],
            [29.151019365748695, -1.637823720031225],
            [29.15178803437438, -1.637707255631387],
            [29.152114136297246, -1.637777134452887],
            [29.152649874464689, -1.637753841211328],
            [29.153208905947466, -1.637404446170897],
            [29.15351171545333, -1.636565899087599],
            [29.153930988840841, -1.635913695052718],
            [29.154769536514145, -1.63598357484159],
            [29.155794428015053, -1.635913695052718],
            [29.156679561420695, -1.636123332603936],
            [29.156819318617661, -1.636565899087599],
            [29.157192007171169, -1.636519313479694],
            [29.157424936731079, -1.635773937275576],
            [29.1577044529216, -1.634609288146429],
            [29.157890796749211, -1.634003670943406],
            [29.158403241601345, -1.634026963325095],
            [29.158682757791901, -1.634283186737619],
            [29.158542999696639, -1.63484221820783],
            [29.15898556639943, -1.635098440610961],
            [29.159358254054641, -1.635098440610961],
            [29.159381547369943, -1.636239797097028],
            [29.159777528340456, -1.63705505197274],
            [29.159707649292805, -1.637916892088545],
            [29.159567891197547, -1.638312872605257],
            [29.15954459788221, -1.638802025962227],
            [29.159940578852723, -1.639128127530281],
            [29.159987164585033, -1.63971045175423],
            [29.160196801727938, -1.640059846387003],
            [29.160709247478408, -1.64012972602934],
            [29.161338158008803, -1.640735343164617],
            [29.161710845664011, -1.640851808289952],
            [29.162176705682139, -1.641271082322628],
            [29.16180401802696, -1.641504011599208],
            [29.161873897074578, -1.642202801071847],
            [29.162432928557358, -1.642389145672858],
            [29.162782322897229, -1.642971469838565],
            [29.163457820058294, -1.643553794736232],
            [29.163807214398133, -1.643810017817481],
            [29.16427307441629, -1.643740138305534],
            [29.165134914506599, -1.644182704890021],
            [29.164925278262022, -1.644648564535499],
            [29.164296366833295, -1.645370647852984],
            [29.163271476230687, -1.646185901668286],
            [29.163085132403086, -1.646675054880083],
            [29.163690749618173, -1.6469778638211],
            [29.163178303867742, -1.647210793326782],
            [29.163318061963, -1.648398735365158],
            [29.163550991522914, -1.648771423376317],
            [29.163807214398133, -1.649050938886316],
            [29.163574284838255, -1.649423626773701],
            [29.163574284838255, -1.649959365374949],
            [29.164040144856379, -1.650005951569195],
            [29.164622468756164, -1.650541690011467],
            [29.165321258334203, -1.650588276191884],
            [29.165367844964845, -1.651077429211461],
            [29.165856997399978, -1.651217186807223],
            [29.165670653572374, -1.651776217994682],
            [29.165647360257072, -1.652335249926723],
            [29.165926876447624, -1.653057332226303],
            [29.16583370408464, -1.654082223912431],
            [29.166322857418102, -1.654524790878177],
            [29.166928474633192, -1.654617962144532],
            [29.167254576556061, -1.655060528989136],
            [29.16741762706836, -1.655899076324996],
            [29.1673011622884, -1.656481401003828],
            [29.166718837490286, -1.656807503254454],
            [29.166416028882757, -1.657063726413195],
            [29.166509201245709, -1.657552878718979],
            [29.166928474633192, -1.658018737900949],
            [29.167603970895929, -1.65841471888664],
            [29.168116416646402, -1.659043629698868],
            [29.168419225253924, -1.659090215676912],
            [29.168791913807432, -1.659695833290175],
            [29.169001550052045, -1.660254864766302],
            [29.16897825763504, -1.660837189954252],
            [29.168838499539742, -1.661396221103253],
            [29.168558983349225, -1.662025131858205],
            [29.16865215571217, -1.662677335356208],
            [29.168745327176794, -1.663096609241052],
            [29.169048136682651, -1.663376124511478],
            [29.169304358659573, -1.663492590099622],
            [29.170026441552952, -1.66332953863586],
            [29.170795110178638, -1.663399418352851],
            [29.17116779783381, -1.663632347711427],
            [29.17144731402437, -1.663911863808887],
            [29.17172682931659, -1.66405162139059],
            [29.172029637924151, -1.664261258648307],
            [29.172239275067064, -1.664354430353781],
            [29.172542083674593, -1.664610653424943],
            [29.172938064645106, -1.665146391478525],
            [29.17335733893092, -1.665029926893325],
            [29.173613560907839, -1.665239564045599],
            [29.1745685733611, -1.665821888646966],
            [29.175127605742208, -1.665961646091447],
            [29.175244070522169, -1.666380920172506],
            [29.176012739147822, -1.666846779955575],
            [29.17647859826765, -1.667172881375682],
            [29.176851285922861, -1.667475690756772],
            [29.177689833596158, -1.667918257394349],
            [29.178411916489534, -1.668290944392374],
            [29.178854483192357, -1.66833753105308],
            [29.179064119436934, -1.668686925096891],
            [29.180019131890226, -1.668686925096891],
            [29.180927558611174, -1.668896562758576],
            [29.18176610628451, -1.668989734241794],
            [29.182581360642509, -1.669059613755306],
            [29.182511481594862, -1.669409007669108],
            [29.182674532107129, -1.669665230977577],
            [29.183186977857599, -1.669502180031736],
            [29.183792595971017, -1.669688523839606],
            [29.184444799816752, -1.669688523839606],
            [29.185073710347144, -1.669641938115293],
            [29.185819085657528, -1.669525472895699],
            [29.186657633330832, -1.669362421938078],
            [29.187542766736474, -1.669152785230724],
            [29.188404606826815, -1.669269250472722],
            [29.189382912595413, -1.669152785230724],
            [29.189732306935252, -1.668943148500726],
            [29.190244752685715, -1.669106199493562],
            [29.191060007043717, -1.669968039969826],
            [29.191805382354101, -1.670084504258879],
            [29.192411000467487, -1.670154383732926],
            [29.193039910997911, -1.670270848914761],
            [29.193598942480691, -1.670596950663521],
            [29.194041509183513, -1.670596950663521],
            [29.194553954933951, -1.670736708668187],
            [29.19576519026246, -1.671388911954085],
            [29.196114584602331, -1.671458790477096],
            [29.196603737935796, -1.671784892929942],
            [29.198374004747084, -1.673275643847212],
            [29.199422188664997, -1.67313588602572],
            [29.201192455476253, -1.674160777084834],
            [29.201704901226726, -1.674533464690269],
            [29.202147467929546, -1.67474310171924],
            [29.202683206995321, -1.675092496415738],
            [29.203335409942721, -1.675395305463214],
            [29.204234758289434, -1.675681461388723],
            [29.205897638694996, -1.676210559381681],
            [29.206247033933202, -1.676792884302528],
            [29.206875944463594, -1.677375209047808],
            [29.207667905506291, -1.678004120045526],
            [29.208087178893813, -1.678493272500325],
            [29.208855847519498, -1.678842667422338],
            [29.209251828489972, -1.679075596732569],
            [29.209438172317579, -1.679494870685629],
            [29.210369891455532, -1.679634628951063],
            [29.210998802884262, -1.679844265426248],
            [29.211674299146992, -1.680123780992339],
            [29.212373088725037, -1.680449882886871],
            [29.213654203101193, -1.681754289913054],
            [29.214469457459188, -1.681963927061589],
            [29.215564228007743, -1.682057098818919],
            [29.216356189050433, -1.682266735934478],
            [29.216938513848518, -1.682196856898507],
            [29.217381080551341, -1.682429786707271],
            [29.217916818718788, -1.682849060834371],
            [29.218359385421611, -1.683035404258895],
            [29.22003648076824, -1.68224344322411],
            [29.22071197703098, -1.681730997196491],
            [29.221107958001493, -1.681265137381756],
            [29.221876626627179, -1.681521360022601],
            [29.222202728550045, -1.68203380610602],
            [29.223087861955687, -1.682429786707271],
            [29.223530428658517, -1.68287235353741],
            [29.223786651533729, -1.683617728926149],
            [29.222994689592742, -1.684712499691072],
            [29.222761760032824, -1.685155065996],
            [29.222179435234708, -1.685411289022773],
            [29.221876626627179, -1.685574339528922],
            [29.221597110436626, -1.685760683593284],
            [29.221387474192049, -1.685900441403708],
            [29.22127100851376, -1.686063492772346],
            [29.221573818019618, -1.686715696300488],
            [29.222132849502401, -1.686925332908074],
            [29.222854931497448, -1.687088384189667],
            [29.223250912467954, -1.686878746695915],
            [29.223693479170777, -1.686436179884159],
            [29.223903116313689, -1.686273129451125],
            [29.225091058326861, -1.686226543223165],
            [29.225836433637244, -1.686086785436468],
            [29.226465344167636, -1.686273129451125],
            [29.226558516530588, -1.686855454041423],
            [29.226209122190753, -1.687414485807337],
            [29.226302293655369, -1.687926931223755],
            [29.227117548013371, -1.68885865022289],
            [29.227746458543795, -1.689534147231183],
            [29.228095853781966, -1.690116471735517],
            [29.228701470997056, -1.690279522745821],
            [29.229283795795173, -1.69074538218226],
            [29.229819534860948, -1.691118070192198],
            [29.230052464420858, -1.691793566403877],
            [29.229749655813297, -1.692934923088729],
            [29.23019222251612, -1.693284318095981],
            [29.230075757736159, -1.694262623234249],
            [29.230355273028387, -1.694565431973707],
            [29.23079783973121, -1.695776667355521],
            [29.230867718778857, -1.696242527260927],
            [29.231333578796985, -1.696545335686465],
            [29.231752852184503, -1.696871437500909],
            [29.232777743685407, -1.696894730937499],
            [29.233429947531135, -1.696754973025552],
            [29.234221908573833, -1.696824851530816],
            [29.234617889544307, -1.697197539259593],
            [29.235200214342431, -1.6972208326922],
            [29.23629498399265, -1.698199137621964],
            [29.236621085915512, -1.69836218884674],
            [29.237180117398296, -1.698804755611869],
            [29.237762442196377, -1.699084271125124],
            [29.238251595529839, -1.699177442953763],
            [29.238717454649674, -1.699573423626665],
            [29.239346365180065, -1.700342092235309],
            [29.239579295638311, -1.700598315035946],
            [29.240883702431436, -1.700714780180466],
            [29.242363361553377, -1.700123112801564],
            [29.242660533232481, -1.703019726054351],
            [29.213972766362183, -1.758157124351286],
            [29.194952966820239, -1.794679463024953],
            [29.185923566911573, -1.812372649452579],
            [29.177844629489297, -1.84202029935243],
            [29.171666618836372, -1.865929330484129],
            [29.166914302811282, -1.886012662447714],
            [29.165963839426592, -1.903704927039745],
            [29.165488608183416, -1.928091259430254],
            [29.166914302811282, -1.943870462630753],
            [29.168815228682334, -1.957736912317846],
            [29.169290460823809, -1.976384711919374],
            [29.169997187017408, -2.013245802378551],
            [29.17318315649565, -2.036366712917535],
            [29.173125207074957, -2.088873648223971],
            [29.173350208104189, -2.107062748377399],
            [29.165201342226933, -2.139806657459713],
            [29.160892552305395, -2.161762750195703],
            [29.148599411272773, -2.196615699873325],
            [29.137567691748639, -2.21491768190486],
            [29.120403800803899, -2.24899262847825],
            [29.108972844814701, -2.270193770621376],
            [29.099480107357227, -2.283932636264429],
            [29.080361229029315, -2.294448268210607],
            [29.06088648849153, -2.297527951405431],
            [29.044455939025593, -2.289512352772102],
            [29.027325221965995, -2.288169582380831],
            [29.017091287262534, -2.291078917520751],
            [29.011974319910802, -2.29734515823432],
            [29.01108441195942, -2.303835162886608],
            [29.00605218268846, -2.315993449801108],
            [28.990609267097042, -2.3440352862211],
            [28.973160779090495, -2.361989833056921],
            [28.960124551654861, -2.375102554921071],
            [28.947890553903935, -2.382163200012268],
            [28.940515576762468, -2.388871424026836],
            [28.934690522269506, -2.394517500320973],
            [28.932572319982363, -2.395582794496061],
            [28.929924568021779, -2.396221971501621],
            [28.9289713773519, -2.395582794496061],
            [28.927488636110255, -2.393984852466852],
            [28.926788534093554, -2.391353412148652],
            [28.927233460670617, -2.388737080783465],
            [28.927986414168753, -2.385053552470704],
            [28.929663444836663, -2.381748696427021],
            [28.931902381596299, -2.379884250082871],
            [28.935995094352666, -2.37920119749751],
            [28.938185502324007, -2.377342208904229],
            [28.938698879627399, -2.375207811397332],
            [28.937911701215285, -2.373383242976488],
            [28.93555016777557, -2.372075060632228],
            [28.930621748717151, -2.372075060632228],
            [28.921415188458081, -2.372281616345727],
            [28.912927356783051, -2.370835729309253],
            [28.906730260523588, -2.372465710739007],
            [28.892750129201502, -2.38237308026398],
            [28.88173548036271, -2.396008912834544],
            [28.872079879242563, -2.42674527472562],
            [28.871277650456175, -2.445707336797609],
            [28.874085452555985, -2.459827844048212],
            [28.886785771160781, -2.472425872332827],
            [28.890302149983668, -2.478832076637372],
            [28.892040965878547, -2.485012934612171],
            [28.892729720376543, -2.48819951269352],
            [28.892895022066941, -2.48986207274113],
            [28.892857479674575, -2.490310977855916],
            [28.892881791679425, -2.490437403351401],
            [28.892875132468241, -2.490495117370237],
            [28.892863718474217, -2.490594043807643],
            [28.892863187569898, -2.490598638124261],
            [28.892875590609027, -2.49074747138604],
            [28.892870877148724, -2.490868183082506],
            [28.892869389538632, -2.490908707023999],
            [28.892863214519348, -2.490931552110797],
            [28.892807375241304, -2.491138157148974],
            [28.892714354693631, -2.491237378983017],
            [28.892621334145957, -2.491349004101975],
            [28.892515911457483, -2.491417219497944],
            [28.892398084831527, -2.491504038019845],
            [28.892317467323014, -2.491621863857323],
            [28.892212044634508, -2.491733488943242],
            [28.892181037485866, -2.491814106703533],
            [28.892181037485866, -2.491900926102403],
            [28.892193440524988, -2.492012550260834],
            [28.892193440524988, -2.492105571289057],
            [28.892181037485866, -2.492223397071982],
            [28.892181037485866, -2.492309808963822],
            [28.892181037485866, -2.492328820464706],
            [28.892152888776415, -2.492486451835151],
            [28.892150030337184, -2.492502458284349],
            [28.892106621047713, -2.492657492968033],
            [28.892075492626493, -2.492801995507831],
            [28.892068645667415, -2.492837602529998],
            [28.892050808719109, -2.492930353351998],
            [28.892023690377336, -2.492992337210991],
            [28.892007399429641, -2.493029575049174],
            [28.891957788171435, -2.493122595101082],
            [28.891870968694192, -2.493221817687046],
            [28.891808955295165, -2.493271428073723],
            [28.891746941896173, -2.493364449011771],
            [28.891744066388931, -2.493371276775132],
            [28.891705893379271, -2.493461827532193],
            [28.891697330637967, -2.493482274680463],
            [28.891651568660766, -2.493584359532302],
            [28.891616713129416, -2.493662114884586],
            [28.891585705980773, -2.493755134891126],
            [28.891529893652173, -2.493891565426723],
            [28.891498886503499, -2.494052800674339],
            [28.891381060775903, -2.494220237534477],
            [28.891294241298624, -2.494319459133082],
            [28.891273697726401, -2.494356439435392],
            [28.891207422719678, -2.494474493599801],
            [28.891157811461479, -2.494617124786859],
            [28.891080393751988, -2.494742184673407],
            [28.891077193952928, -2.494747353601871],
            [28.891008978585202, -2.494896186388246],
            [28.890953166256605, -2.495014012821403],
            [28.890860145708931, -2.495162845577193],
            [28.890791931239505, -2.49526206710374],
            [28.890748521051734, -2.495367491153211],
            [28.890736118910908, -2.495479115013586],
            [28.89068650765271, -2.495572135793421],
            [28.890624494253707, -2.49568996216518],
            [28.890599688175463, -2.495745774082741],
            [28.890624494253707, -2.495888406033539],
            [28.890612098401093, -2.495936679138189],
            [28.890599688175463, -2.495987627504604],
            [28.89050666762779, -2.496086849871504],
            [28.89045705726792, -2.496179869704297],
            [28.890388841900162, -2.49628529367919],
            [28.890339230641995, -2.496378313497683],
            [28.890314425462041, -2.496514743757412],
            [28.890277217242964, -2.496669777961824],
            [28.890264814203842, -2.496843416104153],
            [28.890264814203842, -2.497147283700797],
            [28.890283418313359, -2.497265109929458],
            [28.890314425462041, -2.497407740809668],
            [28.890302022422919, -2.497568976523795],
            [28.890253151376488, -2.497715590896777],
            [28.890221404914367, -2.497810829605567],
            [28.890184196695291, -2.497934857388686],
            [28.890159391515375, -2.498164308078477],
            [28.890159391515375, -2.498449570528799],
            [28.890177995624892, -2.498623209336232],
            [28.890184093389024, -2.498714682198205],
            [28.890140787405816, -2.498803048827491],
            [28.89003536381902, -2.498871263831551],
            [28.889706691816123, -2.498958082758172],
            [28.889657080557924, -2.499026297754052],
            [28.889644677518795, -2.499094512746383],
            [28.889644677518795, -2.499181332561536],
            [28.889663281628351, -2.499323964134331],
            [28.889613671268449, -2.499361171975317],
            [28.889464838392175, -2.499441790165072],
            [28.889446234282655, -2.499541011364111],
            [28.889508247681647, -2.499696046109968],
            [28.889508247681647, -2.499807670501101],
            [28.889502046611252, -2.499906892575606],
            [28.889502046611252, -2.500006114642516],
            [28.889415227134005, -2.500024718553321],
            [28.88935941480538, -2.500136342916135],
            [28.889371817844534, -2.500235564965462],
            [28.889334609625454, -2.500303779894055],
            [28.889266394257739, -2.500365794119496],
            [28.889266394257739, -2.500545633368804],
            [28.889216782999537, -2.500576640476079],
            [28.889222984968232, -2.500657257686708],
            [28.889148568530111, -2.500669660890062],
            [28.889160970670936, -2.500781285197253],
            [28.889154769600506, -2.500880507197155],
            [28.889111360311031, -2.50099213148618],
            [28.889092756201514, -2.501054145678645],
            [28.889046819951133, -2.50123315361569],
            [28.88895632546603, -2.50124638803014],
            [28.88890671510616, -2.501190575446049],
            [28.888844700808839, -2.501289797414566],
            [28.888826096699312, -2.501389019375474],
            [28.888863304918388, -2.501587463274455],
            [28.888912916176558, -2.5016928868093],
            [28.888925319215687, -2.501767303257505],
            [28.888919117246992, -2.501835518105438],
            [28.888943923325236, -2.5019781493858],
            [28.888968728505191, -2.502046364222602],
            [28.88895632546603, -2.502164190909071],
            [28.888937721356513, -2.502269613493426],
            [28.888894312067038, -2.50236883537921],
            [28.888832298668046, -2.502480460443349],
            [28.888795090448966, -2.502598286186822],
            [28.888751680261166, -2.502716111919507],
            [28.888726875081243, -2.502821535362395],
            [28.888702069901292, -2.502976569715289],
            [28.888695867932562, -2.50311300018347],
            [28.888702069901292, -2.503261832912239],
            [28.888688914073967, -2.503428561145863],
            [28.888677263823041, -2.503565699906206],
            [28.88861525042401, -2.503689727137957],
            [28.888609049353615, -2.503838559800366],
            [28.888540833985896, -2.504148628243757],
            [28.88846641754774, -2.504371878055187],
            [28.88841680718787, -2.504526912222222],
            [28.888348591820144, -2.504619932352129],
            [28.888044724997201, -2.504576523079468],
            [28.887920697300849, -2.504644737779187],
            [28.887827676753176, -2.504725355639794],
            [28.887709851025587, -2.5047997719135],
            [28.887651383276999, -2.504891649104124],
            [28.887623031548305, -2.504936202189284],
            [28.887443191523385, -2.505078834031231],
            [28.887356372944438, -2.505122243286972],
            [28.887287253871538, -2.505122243286972],
            [28.887233418734848, -2.505122243286972],
            [28.887220912389459, -2.505122243286972],
            [28.887040103082342, -2.505134645544021],
            [28.886947082534668, -2.505178055701399],
            [28.886779645548874, -2.505227666533645],
            [28.886637013742995, -2.505246270369414],
            [28.88650678497628, -2.505289680523052],
            [28.886469576757204, -2.50538270059805],
            [28.886364154068698, -2.505444714580013],
            [28.886240126372378, -2.505512929233895],
            [28.886122300644786, -2.505612150870781],
            [28.886060286347458, -2.505748581060804],
            [28.885992071878036, -2.505872608986603],
            [28.885886648291233, -2.505953226770571],
            [28.885579386734829, -2.506060559933626],
            [28.88548355985019, -2.506114462323444],
            [28.885371935192993, -2.50619508009231],
            [28.885254108567068, -2.50619508009231],
            [28.885173491058517, -2.506226087064183],
            [28.885037061221368, -2.506232287735643],
            [28.884913033525045, -2.506226087064183],
            [28.884811082825131, -2.506232287735643],
            [28.884602965631707, -2.506232287735643],
            [28.884485139005751, -2.506226087064183],
            [28.884162668073287, -2.506226087064183],
            [28.884020036267415, -2.506294301676806],
            [28.88392081464934, -2.506275697856202],
            [28.883815391062544, -2.506269496281427],
            [28.883740974624388, -2.506331510220796],
            [28.883554933529076, -2.506331510220796],
            [28.883437107801448, -2.50628189943094],
            [28.883356490292897, -2.50625709403528],
            [28.883251066706102, -2.506300503251468],
            [28.883089995182402, -2.506306698501647],
            [28.882978207031837, -2.506294301676806],
            [28.88288518648416, -2.506275697856202],
            [28.882722708198713, -2.506264092490779],
            [28.882711547529606, -2.506263294706625],
            [28.882612325911534, -2.506306704826091],
            [28.88246349303526, -2.506337711795279],
            [28.882302257119868, -2.506405926402012],
            [28.882141022102797, -2.506430731794797],
            [28.882060404594245, -2.506418329550202],
            [28.881868161530175, -2.506418329550202],
            [28.881762738841701, -2.506443134942758],
            [28.881632510074951, -2.506467940334843],
            [28.881471274159551, -2.506529954264696],
            [28.881378253611878, -2.506616772677313],
            [28.881304979830805, -2.506622409567531],
            [28.881297636103326, -2.50662297425041],
            [28.881270034467914, -2.506639959910844],
            [28.881217017696478, -2.506672585027137],
            [28.881173608407007, -2.506771807478462],
            [28.881061983749813, -2.506722196705513],
            [28.881006171421216, -2.506747002092216],
            [28.880931754983063, -2.506827619821631],
            [28.880882144623193, -2.506889632830714],
            [28.880745713887709, -2.5068958344025],
            [28.880683700488717, -2.506964049883274],
            [28.880553471721967, -2.506951646740313],
            [28.880491458322972, -2.506920639785883],
            [28.880392235806568, -2.506970250551198],
            [28.880404638845697, -2.507106681501297],
            [28.880212396679948, -2.507286520716497],
            [28.880187590601697, -2.50741054849459],
            [28.880125577202701, -2.507534575357295],
            [28.879995348435951, -2.507528373788575],
            [28.879889924849156, -2.507565582296994],
            [28.879821710379726, -2.507646199975291],
            [28.879796904301475, -2.507689610048269],
            [28.879821710379726, -2.507782629950436],
            [28.879734890902483, -2.507869449182326],
            [28.879604662135733, -2.507981073771328],
            [28.879530245697609, -2.508061691423697],
            [28.879325600492745, -2.508061691423697],
            [28.879226378874638, -2.508111303048665],
            [28.87915196243652, -2.508204322920439],
            [28.879065142959238, -2.508284941462358],
            [28.878991286171541, -2.508307097782255],
            [28.878941116161219, -2.508322149045451],
            [28.878817088464896, -2.508396566015445],
            [28.878693060768576, -2.508477183641836],
            [28.878637248439979, -2.50853299591128],
            [28.87852562378275, -2.508526794347369],
            [28.878469811454146, -2.508495787430749],
            [28.8784388052038, -2.508396566015445],
            [28.878407798055154, -2.508309746819024],
            [28.878370589836077, -2.508247732974639],
            [28.878347921748187, -2.508134392678314],
            [28.878345784656126, -2.508123705277001],
            [28.878364388765679, -2.508018282266693],
            [28.878401596984755, -2.507937664611652],
            [28.878401596984755, -2.507875650749417],
            [28.878370589836077, -2.50781363688418],
            [28.878277569288404, -2.507801234652868],
            [28.878141139451255, -2.507776429286418],
            [28.878048118903582, -2.507801234652868],
            [28.877855876737833, -2.507844643817149],
            [28.877744252080639, -2.507881852316458],
            [28.877669835642518, -2.507962469974998],
            [28.877539606875768, -2.508005879133871],
            [28.877409378109018, -2.508005879133871],
            [28.877297753451817, -2.507999678470884],
            [28.877217135044969, -2.507999678470884],
            [28.877080705207824, -2.508049289194751],
            [28.876962879480196, -2.508055490760977],
            [28.876814046603926, -2.508092698350711],
            [28.876690018907603, -2.508086497688169],
            [28.876596998359929, -2.508086497688169],
            [28.876485373702732, -2.508129906842883],
            [28.876410957264582, -2.508204322920439],
            [28.876311735646507, -2.50817331689959],
            [28.876224916169264, -2.50817331689959],
            [28.876082285261685, -2.508229129182164],
            [28.875995465784442, -2.508241531409341],
            [28.87589624416637, -2.508328350610368],
            [28.875865237017692, -2.508384162886249],
            [28.875809424689095, -2.508446176724057],
            [28.875747411290096, -2.508483385206001],
            [28.875728807180543, -2.508564002826984],
            [28.875617182523346, -2.508613613529159],
            [28.875486953756596, -2.508638418879553],
            [28.875437342498426, -2.508756244964911],
            [28.875455946607946, -2.508867869477248],
            [28.875387732138524, -2.508917481071251],
            [28.875251301403079, -2.508979493979929],
            [28.875050518055595, -2.508979146135933],
            [28.874916427431458, -2.508985695541678],
            [28.87476759455518, -2.509029105569657],
            [28.874624963647637, -2.50910972315652],
            [28.874432721481895, -2.509140730058357],
            [28.874277686636891, -2.509202743859805],
            [28.874146246042823, -2.509290192729159],
            [28.87407304143202, -2.509339173670401],
            [28.873936611594871, -2.509432194357198],
            [28.873769174609077, -2.509605832593098],
            [28.873688557100532, -2.509785672363584],
            [28.873638945842327, -2.509953108994875],
            [28.873552126365052, -2.510101941838919],
            [28.8734715088565, -2.510213566234823],
            [28.873366086168033, -2.510306586858493],
            [28.873235857401284, -2.510349996842034],
            [28.873074621485884, -2.510443017455869],
            [28.872888580390569, -2.510635259313792],
            [28.872788106520979, -2.510774019976241],
            [28.872665331076146, -2.511001140094602],
            [28.872535102309389, -2.51114997372119],
            [28.872194027267376, -2.511478645961471],
            [28.872069999571053, -2.511615075531312],
            [28.87197697902338, -2.511776311280234],
            [28.871888923464294, -2.511870473801174],
            [28.871716521489912, -2.512030567508288],
            [28.871648307020482, -2.512067775886838],
            [28.871592494691885, -2.512104984264294],
            [28.871598695762284, -2.512210406940542],
            [28.871573890582361, -2.512278622140296],
            [28.871510324894516, -2.512394321081038],
            [28.871437459846884, -2.512532878269231],
            [28.871201808391667, -2.512762329077415],
            [28.871069909656807, -2.51278771258049],
            [28.870910343709518, -2.512842946430914],
            [28.870804921021044, -2.51291116159717],
            [28.870736705653325, -2.513028988195564],
            [28.870656088144777, -2.513146813879751],
            [28.870575469737929, -2.513134410796229],
            [28.870463845080696, -2.513196424405597],
            [28.870352220423506, -2.513320452518819],
            [28.870265401844556, -2.513363861497317],
            [28.870122770038677, -2.513475486514205],
            [28.869980138232837, -2.513525097027379],
            [28.869806500176612, -2.513692534076378],
            [28.869639063190817, -2.513779353813811],
            [28.869459224064197, -2.513890977891201],
            [28.869266981000123, -2.514039811183997],
            [28.869118148123849, -2.514157636775707],
            [28.868994121325823, -2.514250657114691],
            [28.868894898809454, -2.514287865429083],
            [28.86873986486275, -2.514473906985063],
            [28.868603435025605, -2.514566927301211],
            [28.868510414477932, -2.514622739306987],
            [28.868442199110206, -2.514715760515879],
            [28.868367782672088, -2.514827384512089],
            [28.868293366233935, -2.51495141246823],
            [28.868200345686262, -2.515131251492672],
            [28.868125929248141, -2.515230473293014],
            [28.867939888152794, -2.515335896616924],
            [28.867778653135723, -2.515379306430967],
            [28.867555403821299, -2.515484729742664],
            [28.867493389523972, -2.515509534960772],
            [28.867325952538177, -2.515497132803528],
            [28.867152314481952, -2.515528139551669],
            [28.867015884644804, -2.515534341081917],
            [28.866916663026736, -2.515596354575678],
            [28.866798836400811, -2.515639764380929],
            [28.866575587086388, -2.515645965007137],
            [28.866513573687392, -2.515658368066449],
            [28.866470164397921, -2.515707979399023],
            [28.866389545991073, -2.51572658308355],
            [28.86622831097397, -2.515745187671291],
            [28.866104283277647, -2.515850610953027],
            [28.866042269878623, -2.515962234850818],
            [28.86593684629182, -2.516055255962906],
            [28.865912041111905, -2.516166880746418],
            [28.865812818595501, -2.516284706143414],
            [28.865779835153209, -2.516373543189663],
            [28.865701194836603, -2.516483150462076],
            [28.865639180539276, -2.516588573683381],
            [28.865639180539276, -2.516662990175948],
            [28.865583368210679, -2.516818023768753],
            [28.86557716714028, -2.516898641771733],
            [28.865521354811687, -2.517028870147778],
            [28.86548414659261, -2.517152897891712],
            [28.865465542483083, -2.517221112829566],
            [28.865409730154454, -2.517245918014203],
            [28.865353917825853, -2.517320334468743],
            [28.865248494239058, -2.517431959142487],
            [28.865186480840062, -2.517506375586277],
            [28.865074856182865, -2.517568389888484],
            [28.864975634564793, -2.517611798723692],
            [28.864907580893817, -2.517729345714982],
            [28.86487021097799, -2.517841249530006],
            [28.864826801688519, -2.517952874158548],
            [28.864814398649365, -2.518058297259349],
            [28.864845405798043, -2.51816372125498],
            [28.864857807938836, -2.51825674130433],
            [28.864913620267465, -2.518343560733809],
            [28.864913620267465, -2.518424178641132],
            [28.86487021097799, -2.518517198671641],
            [28.864839203829312, -2.518628823241508],
            [28.864758586320768, -2.518697039004525],
            [28.864696205510821, -2.518784225218814],
            [28.864609753444491, -2.518870676894635],
            [28.864529135935978, -2.518945093255133],
            [28.864406944396055, -2.518970481153671],
            [28.864318289660677, -2.518982301433791],
            [28.864212866073874, -2.518982301433791],
            [28.864132248565323, -2.519044315664742],
            [28.864062381195804, -2.519143145954755],
            [28.864014421939398, -2.519224155020381],
            [28.863989616759483, -2.519354384064393],
            [28.863924072981394, -2.519424772666941],
            [28.86388419317268, -2.519614841209243],
            [28.863863177086586, -2.519653052235113],
            [28.863815978703258, -2.519738868703695],
            [28.863722958155584, -2.519819486523488],
            [28.863611333498387, -2.519831888639041],
            [28.863561722240188, -2.519900104338231],
            [28.863499708841193, -2.520017930296544],
            [28.863499708841193, -2.520123353227974],
            [28.863468701692515, -2.520228776150715],
            [28.863381882215268, -2.520359005092847],
            [28.863319868816237, -2.52044582438027],
            [28.863195842018214, -2.520631865948871],
            [28.863115223611366, -2.520737288829869],
            [28.862984994844616, -2.520817906587019],
            [28.862904377336104, -2.520898524339105],
            [28.862860968046629, -2.520991545093966],
            [28.862842363937069, -2.521096967945462],
            [28.862817557858826, -2.521208593194632],
            [28.862730739279879, -2.521208593194632],
            [28.862643919802597, -2.521233398302337],
            [28.862581906403602, -2.521326419032911],
            [28.862544698184525, -2.521438043358678],
            [28.8625217623987, -2.521552290483278],
            [28.862383462269126, -2.521630286284364],
            [28.862296642791851, -2.521785320181356],
            [28.862265636541505, -2.521890742967715],
            [28.862191220103384, -2.52199616664884],
            [28.862185018134657, -2.522064381329539],
            [28.862160743859054, -2.522224597544839],
            [28.862154011884307, -2.522269027156935],
            [28.862110601696536, -2.522355846315215],
            [28.862023783117589, -2.522448866061],
            [28.861862547202158, -2.522554289696313],
            [28.861761096863891, -2.522656348758471],
            [28.861695110216363, -2.522727927968407],
            [28.861676506106843, -2.522876761141563],
            [28.861620693778246, -2.523000788320949],
            [28.861558680379215, -2.523193031012546],
            [28.861558680379215, -2.523488425883113],
            [28.861558680379215, -2.523682938948405],
            [28.861577284488771, -2.523763556520522],
            [28.861595888598291, -2.523806966049854],
            [28.86160829163742, -2.523856577067757],
            [28.86160829163742, -2.523924792553086],
            [28.861589687527896, -2.523980604152426],
            [28.861484263941097, -2.524024013674405],
            [28.861434652682892, -2.524141840157675],
            [28.861428451612497, -2.524296874654736],
            [28.861403646432549, -2.524414700209438],
            [28.861465659831541, -2.524489116248597],
            [28.861540076269694, -2.524563533186938],
            [28.861583485559169, -2.524656553676146],
            [28.861583485559169, -2.524768178615683],
            [28.861571533474319, -2.524884509771564],
            [28.861552479308816, -2.525010032015677],
            [28.861527673230572, -2.525096850988453],
            [28.86151527108974, -2.525177468471694],
            [28.861521472160138, -2.525344905809322],
            [28.861490465011496, -2.525493738678785],
            [28.861428451612497, -2.52563637004959],
            [28.861341632135218, -2.525716987498874],
            [28.861323028025701, -2.525841015307043],
            [28.861326645541343, -2.52587357307906],
            [28.861335431064823, -2.525952639239986],
            [28.861385042323022, -2.526194493319982],
            [28.861422250542066, -2.526268909255824],
            [28.861453256792419, -2.526380534054959],
            [28.861484263941097, -2.526510762372646],
            [28.861496666980223, -2.526634790104011],
            [28.861490465011496, -2.526808428727074],
            [28.861478062870663, -2.526882844627243],
            [28.861484263941097, -2.527000670847724],
            [28.861577369828698, -2.527082171812912],
            [28.861666115293954, -2.52752844660516],
            [28.861565291081391, -2.527615465979382],
            [28.861450062383273, -2.527764584987574],
            [28.861430819571581, -2.527803069524442],
            [28.86136194663705, -2.52787303483591],
            [28.861321277209189, -2.527954373119607],
            [28.861294165155588, -2.528056045063504],
            [28.861260274414892, -2.528150939111435],
            [28.861219604987035, -2.52828650228299],
            [28.861165379981543, -2.528442399099429],
            [28.861104377187214, -2.528625409245651],
            [28.861104377187214, -2.528971094905612],
            [28.861140873940592, -2.529070864950097],
            [28.861185714246307, -2.529181217409768],
            [28.861253495727762, -2.529276111374318],
            [28.861334081795246, -2.529366769833511],
            [28.86136194663705, -2.529398117760756],
            [28.861490730912802, -2.529493011709226],
            [28.861558512394257, -2.529581127770342],
            [28.861619516086886, -2.529676021705211],
            [28.861700854044308, -2.529750581994968],
            [28.861730823638801, -2.529870461553104],
            [28.861734744785036, -2.529886144093646],
            [28.861734744785036, -2.529905170399516],
            [28.861734890312096, -2.530011488766258],
            [28.861741522573837, -2.530075932814653],
            [28.861761856838598, -2.530211495782348],
            [28.861795747579333, -2.530421618082808],
            [28.86184319479602, -2.53056395888904],
            [28.86184319479602, -2.530685966056126],
            [28.86181608184409, -2.530794415656951],
            [28.861788969790531, -2.530868975881507],
            [28.861788969790531, -2.530963869720908],
            [28.86181608184409, -2.531079098074032],
            [28.861822860531227, -2.531228217582169],
            [28.861822593731588, -2.531404781034691],
            [28.86181608184409, -2.531526455642789],
            [28.861822860531227, -2.531655240587436],
            [28.86181608184409, -2.531797581256344],
            [28.861768635525731, -2.531953478548453],
            [28.86172796609787, -2.53206192894527],
            [28.861639850351679, -2.532217827108648],
            [28.861578846659022, -2.532339833214497],
            [28.861585625346152, -2.53245506144363],
            [28.861674237860736, -2.532554750807176],
            [28.861694075357175, -2.532577068430315],
            [28.861822860531227, -2.53263807191932],
            [28.861886038146856, -2.532670954769138],
            [28.862005869812503, -2.532732965627403],
            [28.86212109851062, -2.532787191245644],
            [28.862161767938478, -2.53290241943446],
            [28.862270217949469, -2.533004091888582],
            [28.862365111484522, -2.533058316591841],
            [28.862419337388314, -2.533187101382167],
            [28.862419337388314, -2.533268439328012],
            [28.862453228129041, -2.533437893064079],
            [28.862474226248793, -2.533600192170138],
            [28.86258201240479, -2.53363445911672],
            [28.862690463314109, -2.533709019175658],
            [28.862751466108435, -2.533776800468735],
            [28.862920919812048, -2.533871694092254],
            [28.863070039250896, -2.533966588612218],
            [28.863219158689741, -2.534020813274626],
            [28.863347942965497, -2.53413604225568],
            [28.863510618880305, -2.534217380141095],
            [28.863612291102463, -2.534197045670259],
            [28.863781744806108, -2.53422415799682],
            [28.863964754087352, -2.5342783826483],
            [28.864222323537181, -2.534325830345818],
            [28.864249436489114, -2.534434280541292],
            [28.86428332722981, -2.534535952873536],
            [28.86441211240389, -2.53469184983161],
            [28.864479893885353, -2.534807078752145],
            [28.864588343896333, -2.534922306758779],
            [28.864744241124018, -2.535091760275464],
            [28.864904162804159, -2.535251747185404],
            [28.865022144838616, -2.535362886036011],
            [28.865062814266469, -2.535396777090863],
            [28.865076369844108, -2.53549167149751],
            [28.865110260584835, -2.535600121594006],
            [28.86517126427746, -2.535640790490742],
            [28.865279714288448, -2.535674681538189],
            [28.865401721673695, -2.535688237234119],
            [28.865489837419918, -2.535728906128068],
            [28.865564396690214, -2.535776352868201],
            [28.865699959653092, -2.535776352868201],
            [28.865849079091937, -2.535783131619125],
            [28.865890262356139, -2.535839291441507],
            [28.865991419843656, -2.535979697310901],
            [28.866133760595371, -2.535986476060756],
            [28.866289658721346, -2.536054257232909],
            [28.866350661515675, -2.536183041721171],
            [28.866343883726842, -2.536277936069385],
            [28.86636421799161, -2.53635249597399],
            [28.866445555949031, -2.536413499282669],
            [28.866506558743325, -2.536379608254814],
            [28.866587896700747, -2.536494837023012],
            [28.866655678182173, -2.536637178056183],
            [28.86670312539886, -2.536793074757689],
            [28.86667601244697, -2.5368608567905],
            [28.86670312539886, -2.536948972343606],
            [28.866743793928393, -2.537098092070069],
            [28.86677768466912, -2.537199764190156],
            [28.866865800415344, -2.537226876453017],
            [28.866987807800591, -2.537281101880412],
            [28.867042032806086, -2.537348882983814],
            [28.867069144859684, -2.537436999406687],
            [28.867143705028276, -2.537450555083953],
            [28.867197930033765, -2.537511558340115],
            [28.867204052950751, -2.537687847172516],
            [28.867245377250459, -2.537843687730463],
            [28.867313158731882, -2.53793180411919],
            [28.867372862562309, -2.537953126927304],
            [28.867502946700295, -2.537999585188025],
            [28.867685922743878, -2.538034319110783],
            [28.867841854107514, -2.53805381058261],
            [28.868256149031719, -2.53805370487657],
            [28.868451886542239, -2.53805381058261],
            [28.868594228192254, -2.53807414499201],
            [28.868716234679201, -2.538148704791681],
            [28.868729791155168, -2.538216485848991],
            [28.868811129112562, -2.538324935713903],
            [28.868973804129038, -2.538426608639714],
            [28.869168051334505, -2.538524147278101],
            [28.869312711536296, -2.538616396091846],
            [28.869455052288014, -2.538684178027815],
            [28.869604171726859, -2.538812962250616],
            [28.869712621737843, -2.538955303928587],
            [28.869747225740902, -2.539050395930438],
            [28.869712621737843, -2.53924676416245],
            [28.86970584394901, -2.539416218008284],
            [28.869678730997116, -2.539572115273601],
            [28.869678730997116, -2.539775459111245],
            [28.869665175419481, -2.539883909746997],
            [28.869658396732348, -2.540046584779925],
            [28.869671953208314, -2.540182148496118],
            [28.869692287473082, -2.54028382037031],
            [28.869739734689738, -2.540378714413432],
            [28.869827850435961, -2.540507499368524],
            [28.869856201266323, -2.540534182413405],
            [28.869943079134078, -2.540615949038545],
            [28.869959371878398, -2.540634819787952],
            [28.870166757843219, -2.540866741067342],
            [28.870261652276568, -2.541015860335589],
            [28.870424327293055, -2.541232760483327],
            [28.8705734467319, -2.541368324073354],
            [28.870661562478123, -2.541429327142055],
            [28.870773923753873, -2.54154224709322],
            [28.870864906922463, -2.541646227219414],
            [28.871007247674179, -2.54179534639643],
            [28.871075029155634, -2.54192413120832],
            [28.871197035642552, -2.542046138193033],
            [28.871515608785046, -2.542188479509871],
            [28.871678284699826, -2.542215591666603],
            [28.871827403240374, -2.542215591666603],
            [28.871983301366349, -2.542256260352328],
            [28.872044304160674, -2.542371489492868],
            [28.872112085642101, -2.542459605568487],
            [28.872166310647593, -2.542513829869839],
            [28.872349320827169, -2.542527386396555],
            [28.872471327314123, -2.542622280272508],
            [28.872559443060346, -2.5427036185202],
            [28.872620446752968, -2.542812068906724],
            [28.87259938305619, -2.542922895402193],
            [28.872789526757419, -2.54313803346479],
            [28.872898350467565, -2.543178088667087],
            [28.872993244900918, -2.543239091649124],
            [28.873108473599075, -2.54328653901318],
            [28.873216923610055, -2.543340764182759],
            [28.873366043048904, -2.543449214514998],
            [28.873460936583925, -2.543537330516053],
            [28.873555831017281, -2.543618667801805],
            [28.873637168974707, -2.543754231137808],
            [28.873698171769, -2.543889793555852],
            [28.873765953250455, -2.544011800352225],
            [28.873818650221651, -2.54413981157285],
            [28.873817756397937, -2.544141307712795],
            [28.873901516213333, -2.544357486362225],
            [28.873955741218829, -2.544465936607825],
            [28.873976075483629, -2.544533717329039],
            [28.873982854170755, -2.544676059271136],
            [28.873982854170755, -2.544750618684395],
            [28.874003188435523, -2.544825178093228],
            [28.874057413441019, -2.544886180996285],
            [28.874190858176476, -2.545013559703105],
            [28.874206532879864, -2.545028521995488],
            [28.874287870837254, -2.545258979764103],
            [28.874348873631583, -2.545360651232877],
            [28.874310677265697, -2.545504554270305],
            [28.874226867144632, -2.545516548673849],
            [28.874213310668697, -2.545563995953022],
            [28.874240423620591, -2.545652111807644],
            [28.874294648626087, -2.545733449861615],
            [28.874310677265697, -2.545753485101554],
            [28.874403098637078, -2.545869012068788],
            [28.874491215281626, -2.545923238031763],
            [28.874538661599956, -2.546031688143869],
            [28.874545440287122, -2.546106247477602],
            [28.874543509807559, -2.546144860656762],
            [28.874538661599956, -2.546241810548499],
            [28.874595892368404, -2.546412914996492],
            [28.874735228255496, -2.546485823678285],
            [28.874803009736951, -2.546492602372239],
            [28.874904681959109, -2.546580718162449],
            [28.874965684753434, -2.546689168218474],
            [28.875067356975588, -2.546763727513659],
            [28.875103201552072, -2.546815081325659],
            [28.875169029197778, -2.546946737742004],
            [28.875250367155168, -2.547028075713191],
            [28.875318148636623, -2.547109412775707],
            [28.875413043069972, -2.54717719425944],
            [28.875453711599508, -2.547285645168007],
            [28.875473506875114, -2.547377980982925],
            [28.875473083768615, -2.547381226225037],
            [28.875408436509193, -2.547427403164476],
            [28.875379152329245, -2.547448320158341],
            [28.875392707906876, -2.547522880312467],
            [28.875467268075468, -2.547577105301454],
            [28.87550278836013, -2.54763292309453],
            [28.875514715292162, -2.547651664544567],
            [28.875602831038353, -2.547726224686758],
            [28.875690946784577, -2.547733002470629],
            [28.875765506054861, -2.54769911174401],
            [28.875846844012255, -2.547787227450635],
            [28.875928181969645, -2.547983794000104],
            [28.876016297715868, -2.548214251232949],
            [28.87607052272136, -2.548404039032651],
            [28.87607730140849, -2.54848537691056],
            [28.876029854191827, -2.548526045395821],
            [28.875981937156254, -2.54858466839978],
            [28.875968850499202, -2.548600605486729],
            [28.875934959758474, -2.548627717506735],
            [28.875934959758474, -2.548736168291528],
            [28.87598918476397, -2.548878508859613],
            [28.876016297715868, -2.548966625387851],
            [28.876117969938051, -2.549034406772567],
            [28.87619930789544, -2.54904796322973],
            [28.876232154793808, -2.549110656308704],
            [28.876248064855801, -2.549141816733677],
            [28.876259202168715, -2.549161979308088],
            [28.876259650428032, -2.549161897093002],
            [28.876341648647159, -2.549271641590434],
            [28.876429764393379, -2.549332645183544],
            [28.876504324561971, -2.549441095004667],
            [28.876504324561971, -2.549548586243007],
            [28.876504324561971, -2.549617327073556],
            [28.876517880139602, -2.549705442647055],
            [28.876538215302698, -2.549807115567039],
            [28.876633108837719, -2.549868118230969],
            [28.876667066952098, -2.54992245153526],
            [28.876700890319174, -2.549976568909786],
            [28.876795784752535, -2.550166357349582],
            [28.876782546280172, -2.550285392057651],
            [28.876850009758023, -2.550464595494716],
            [28.876888011189472, -2.550497530285142],
            [28.876888352549305, -2.550498217819426],
            [28.876951681980181, -2.550552711009451],
            [28.877094022731896, -2.550654383861536],
            [28.877236364381943, -2.550715386484781],
            [28.877351592181764, -2.550817059323839],
            [28.877548158837268, -2.550878061939247],
            [28.877690499588983, -2.550911953484476],
            [28.877859953292596, -2.551027181840399],
            [28.878009072731441, -2.551149187951478],
            [28.878124301429594, -2.551257638520871],
            [28.878198860699854, -2.551338976215974],
            [28.8783750921923, -2.551413536141633],
            [28.878524211631145, -2.551413536141633],
            [28.878619106064495, -2.551406757473976],
            [28.878720778286649, -2.551345753980544],
            [28.878795337556941, -2.551237304322151],
            [28.878863119038364, -2.551162744386097],
            [28.87903935053081, -2.551122075985312],
            [28.879242694975151, -2.551101740880936],
            [28.879364701462102, -2.551101740880936],
            [28.879479930160219, -2.551169522151622],
            [28.879581602382409, -2.551298307820799],
            [28.87975783387482, -2.551427092573416],
            [28.879839171832245, -2.551569432839806],
            [28.879940844054396, -2.551738886850737],
            [28.880022182011817, -2.551847337369712],
            [28.880103519969207, -2.551915118600552],
            [28.880184857028294, -2.552023569104451],
            [28.880259417196886, -2.552077793901206],
            [28.880327198678309, -2.552118463174838],
            [28.880415314424532, -2.552193023054697],
            [28.880544099598616, -2.552260804267116],
            [28.880638993133672, -2.552281138449424],
            [28.880740665355823, -2.552342141897857],
            [28.880828781102046, -2.552389588922039],
            [28.880916896848266, -2.552504817143768],
            [28.881052459811151, -2.55256582058145],
            [28.881154047591714, -2.552735133519502],
            [28.881249026466694, -2.552809834302896],
            [28.881368229311636, -2.552867310618334],
            [28.881438814435068, -2.552925062486432],
            [28.88151337370536, -2.553019956489365],
            [28.881554043133217, -2.553141963312277],
            [28.881709038452314, -2.553205013055536],
            [28.881852281112579, -2.553250413711269],
            [28.8819675098107, -2.553318194867124],
            [28.882143741303143, -2.553406311087116],
            [28.882299639429124, -2.553399532430094],
            [28.882380976488211, -2.553419866594146],
            [28.88248942739753, -2.553528316969373],
            [28.882600885866395, -2.553646333163252],
            [28.882604655197319, -2.553650323743355],
            [28.882814778328822, -2.553718105781306],
            [28.882950341291707, -2.553751996347167],
            [28.8830316783508, -2.55379944331859],
            [28.883140129260081, -2.553935006471443],
            [28.883201132054406, -2.554023121745092],
            [28.883282470011796, -2.554118015665853],
            [28.883350251493258, -2.55414512847143],
            [28.883404476498747, -2.554118015665853],
            [28.883533261672831, -2.554165463527017],
            [28.883662045948583, -2.554246801035612],
            [28.883736606117171, -2.5543145821382],
            [28.883905237862304, -2.554355568454127],
            [28.883986462631992, -2.55438510433132],
            [28.884065226017768, -2.554417102133124],
            [28.884136606150268, -2.554426948027439],
            [28.884200601232791, -2.554449099934125],
            [28.884276903234717, -2.554456483902915],
            [28.884340899215537, -2.554463867871717],
            [28.884407355681944, -2.554461406849927],
            [28.884476274430529, -2.554441715965273],
            [28.884537808129206, -2.554419564058421],
            [28.8846387239699, -2.554417102133124],
            [28.884732255658957, -2.554426948027439],
            [28.884818403196377, -2.554522941427226],
            [28.8848528625707, -2.55458693611963],
            [28.884916858551524, -2.554636163776803],
            [28.884973469482407, -2.554687852453426],
            [28.885037465463267, -2.554761693029191],
            [28.885106383313552, -2.554813381700662],
            [28.885159075793162, -2.554861200857274],
            [28.885303292227182, -2.554916759037344],
            [28.885411297572112, -2.554946862273357],
            [28.885664697042415, -2.555083675689839],
            [28.885754891490187, -2.555155820451289],
            [28.886869244413631, -2.55604716577603],
            [28.88688094946178, -2.5560565283078],
            [28.88780790034221, -2.556773649430407],
            [28.887839077272474, -2.556824008130941],
            [28.888191172846387, -2.557050245516973],
            [28.888571460248873, -2.557337093970351],
            [28.889213196026596, -2.557384901286711],
            [28.889973770831567, -2.557791269727041],
            [28.890425362009726, -2.557886885227086],
            [28.890710578010765, -2.557886885227086],
            [28.890781881786445, -2.558149829847773],
            [28.891043329263347, -2.558484485326784],
            [28.891352312890156, -2.558890853414046],
            [28.891756368816747, -2.559416740376617],
            [28.892398103696166, -2.560181667709273],
            [28.892849695772629, -2.560540226249028],
            [28.893111143249563, -2.560874881999048],
            [28.892992303323979, -2.561759327233902],
            [28.893149732179214, -2.562234313351743],
            [28.893206215549341, -2.562404732630118],
            [28.89321969656682, -2.562482693405002],
            [28.893301286950791, -2.562954522587036],
            [28.893301286950791, -2.563360889237362],
            [28.89351519917615, -2.563599928276092],
            [28.893752878128989, -2.563958486749284],
            [28.894061861755802, -2.564436563651758],
            [28.894275773981125, -2.564842929825128],
            [28.89429954160693, -2.565870795079599],
            [28.894275773981125, -2.566372776552538],
            [28.894275773981125, -2.566779141198885],
            [28.894465917682389, -2.567042083065429],
            [28.894703597533518, -2.567257217936122],
            [28.894965045010419, -2.567783101414968],
            [28.895083884936003, -2.568571927125396],
            [28.895083884936003, -2.569289041143432],
            [28.895107652561776, -2.569743212601704],
            [28.895083884936003, -2.570412518228352],
            [28.895060117310198, -2.570818881572212],
            [28.894869973608976, -2.571392572157387],
            [28.894869973608976, -2.572300913392893],
            [28.895060117310198, -2.572563855010386],
            [28.89529779716133, -2.572850699034562],
            [28.89529779716133, -2.573424388693585],
            [28.895107652561776, -2.573782943468302],
            [28.895083884936003, -2.574308825125428],
            [28.895202724861555, -2.57545620104467],
            [28.895511708488364, -2.575766948622195],
            [28.895654316039714, -2.576101600329589],
            [28.896058371966305, -2.576603576820061],
            [28.896581266920148, -2.577105553110044],
            [28.896676339219923, -2.577989986951516],
            [28.896652571594149, -2.578946131725659],
            [28.89681894677128, -2.579424203839655],
            [28.897341842623447, -2.579950082231967],
            [28.897698362400131, -2.580595478303751],
            [28.898197489728201, -2.581025742468303],
            [28.898458937205135, -2.581456006485226],
            [28.898411401055235, -2.582125305874082],
            [28.898387633429461, -2.583463903579818],
            [28.898435169579329, -2.583870262701657],
            [28.899005600683079, -2.58413320189647],
            [28.899362120459759, -2.584157105046283],
            [28.899528495636918, -2.584348332938361],
            [28.899980087713381, -2.584874210168677],
            [28.899599799412599, -2.585471796553607],
            [28.899599799412599, -2.585997673312144],
            [28.899671104086572, -2.586451838727706],
            [28.899718639338143, -2.586834293781798],
            [28.89976617548805, -2.587575300455216],
            [28.899409655711334, -2.588053369277019],
            [28.899337828217853, -2.588159600544513],
            [28.899005600683079, -2.588650955047364],
            [28.899195744384308, -2.589105119499765],
            [28.899267048159984, -2.590395902778031],
            [28.899267048159984, -2.591160194215875],
            [28.899267048159984, -2.591328134166051],
            [28.898715439456417, -2.591449343158437],
            [28.898309686612251, -2.591538501979609],
            [28.898000702985438, -2.592470732514948],
            [28.898000702985438, -2.593068316172883],
            [28.897501575657369, -2.594645934390517],
            [28.897525343283178, -2.595124000506571],
            [28.897507001481703, -2.595283871394953],
            [28.897454039507494, -2.595745485822156],
            [28.897454039507494, -2.596223551516775],
            [28.897311431956144, -2.596701616124699],
            [28.89733519958191, -2.596964552619846],
            [28.897287663432042, -2.597753359062206],
            [28.897406503357594, -2.598040198219675],
            [28.89783432690998, -2.598470456380307],
            [28.897430271881689, -2.598924617259571],
            [28.897430271881689, -2.599259262772822],
            [28.897430271881689, -2.599832939424712],
            [28.897644183208723, -2.600215390379171],
            [28.897976934461337, -2.600287099807135],
            [28.898333454238017, -2.60059784121614],
            [28.898357222762119, -2.600908582547577],
            [28.898357222762119, -2.601386646260927],
            [28.89876127779041, -2.60186470979058],
            [28.899236637492674, -2.602032032163268],
            [28.899664461045035, -2.602103741486566],
            [28.900020980821747, -2.602271062923688],
            [28.900211124523015, -2.602557901040289],
            [28.900211124523015, -2.603251091903701],
            [28.899902140896163, -2.60380086394224],
            [28.899902140896163, -2.60435063573772],
            [28.900068516073329, -2.60461356971374],
            [28.900401268224233, -2.604924310041916],
            [28.900781555626725, -2.605330663078501],
            [28.901066771627761, -2.605880434197223],
            [28.901375755254573, -2.606382398722843],
            [28.901803578806927, -2.606788750379042],
            [28.901993722508195, -2.607290715440967],
            [28.901969953984089, -2.607888291082288],
            [28.901969953984089, -2.608199030591192],
            [28.901993722508195, -2.608509770022286],
            [28.902017490133961, -2.608868315631547],
            [28.901589666581604, -2.609155152225044],
            [28.901589666581604, -2.609346376282697],
            [28.90139952288034, -2.610087369566577],
            [28.901351986730472, -2.610445914719849],
            [28.90125691532899, -2.610828362407725],
            [28.90125691532899, -2.61118690644335],
            [28.90125691532899, -2.612238637124233],
            [28.901518362805923, -2.612788405182155],
            [28.900971699327986, -2.613409881666331],
            [28.900757788000952, -2.61384013450372],
            [28.900496339625722, -2.614533319968776],
            [28.900425035850038, -2.615226504142324],
            [28.900425035850038, -2.61594359046727],
            [28.900187355998874, -2.616206522888941],
            [28.900211124523015, -2.616804094231399],
            [28.900068516073329, -2.617162637440372],
            [28.899807068596388, -2.617425568699562],
            [28.899799471544032, -2.617593659584792],
            [28.899783300970618, -2.617951431953617],
            [28.89961692489516, -2.618429489098981],
            [28.899070261417222, -2.618429489098981],
            [28.898832581566086, -2.618692420088803],
            [28.898737510164604, -2.619027059367353],
            [28.89911779756709, -2.619313893607901],
            [28.899212869866869, -2.619839755155296],
            [28.89911779756709, -2.620437325645188],
            [28.89876127779041, -2.62084367359389],
            [28.898523597939278, -2.62141734026146],
            [28.89876127779041, -2.621991006662537],
            [28.899165333716997, -2.622349548366624],
            [28.899307941268358, -2.622803700500278],
            [28.899165333716997, -2.623712005169685],
            [28.899165333716997, -2.624190060085378],
            [28.899236637492674, -2.624572503523168],
            [28.89961692489516, -2.624715919555921],
            [28.899878372372068, -2.625313487685256],
            [28.899949677046074, -2.626030568154725],
            [28.90054387577559, -2.626269595186339],
            [28.900781555626725, -2.626436914261594],
            [28.900805323252523, -2.627058383881103],
            [28.900662715701174, -2.627512534280744],
            [28.900876627926504, -2.627823268858452],
            [28.901161843029211, -2.62808619875022],
            [28.901477829023662, -2.628273125090177],
            [28.901565898955798, -2.628325224479689],
            [28.901946186358284, -2.628325224479689],
            [28.902160097685318, -2.628157906564256],
            [28.902635457387582, -2.628038393237412],
            [28.902801833463034, -2.627130091754984],
            [28.902801833463034, -2.626126179334318],
            [28.902421546060548, -2.625170070818561],
            [28.902255169985096, -2.624429086570356],
            [28.902730529687357, -2.624859335572009],
            [28.902873137238711, -2.625385195660635],
            [28.903063280939975, -2.625767638727802],
            [28.903300960791103, -2.625815444328698],
            [28.90344356834246, -2.625767638727802],
            [28.903586176792107, -2.625958860216889],
            [28.903990231820398, -2.626675941214407],
            [28.904180375521626, -2.628110101054247],
            [28.903705016717691, -2.628755472121247],
            [28.903419800716655, -2.629448649213391],
            [28.903419800716655, -2.63007011731332],
            [28.903277193165298, -2.630739389605885],
            [28.903657480567791, -2.631026221122288],
            [28.903895160418919, -2.631504273199871],
            [28.904061535596075, -2.631958421959466],
            [28.904370519222883, -2.632364766109988],
            [28.904679502849696, -2.633034038057526],
            [28.904180375521626, -2.633559893751416],
            [28.903895160418919, -2.634037944844057],
            [28.904027954774115, -2.634626900845968],
            [28.903932882474333, -2.634842023131843],
            [28.903576362697653, -2.634961535797705],
            [28.903362451370619, -2.634818120958601],
            [28.903196075295167, -2.634148849982455],
            [28.902792020266876, -2.633814214809365],
            [28.902720716491199, -2.634268362715756],
            [28.902958395444031, -2.634602997765161],
            [28.902982163968133, -2.635128853691116],
            [28.902649411817229, -2.635487391570217],
            [28.902673180341324, -2.635750318920327],
            [28.902887091668358, -2.636037149267533],
            [28.902982163968133, -2.636395685978099],
            [28.903053467743817, -2.636730321351347],
            [28.903291147594945, -2.637136663020426],
            [28.90343635666736, -2.637345278588867],
            [28.903623898847528, -2.637614712720951],
            [28.90398041862424, -2.638021055000671],
            [28.904241866101142, -2.638403494139063],
            [28.904574618252056, -2.639024957710506],
            [28.904669689653538, -2.639479103689469],
            [28.904645922027729, -2.640076664645101],
            [28.904836065728997, -2.640363493077663],
            [28.905097513205899, -2.640698127368709],
            [28.905358960682833, -2.641032760665018],
            [28.905454032982611, -2.641558613835633],
            [28.905240120757249, -2.642443001723497],
            [28.905382729206934, -2.644355190227749],
            [28.905596640533968, -2.645335185780298],
            [28.905572872908163, -2.6462434728913],
            [28.90526388928135, -2.646602007519518],
            [28.905240120757249, -2.647295173627362],
            [28.905240120757249, -2.648131753543569],
            [28.90490736950467, -2.648418580992336],
            [28.90398041862424, -2.649685399537019],
            [28.903243611445035, -2.649900520082215],
            [28.902887091668358, -2.650259052734418],
            [28.90215028448916, -2.650760999174106],
            [28.90129736197467, -2.650570390434323],
            [28.900534062579432, -2.650760999174106],
            [28.899012912071154, -2.651478065674821],
            [28.897634370012561, -2.65178879418034],
            [28.896612346832352, -2.652027816192811],
            [28.896018148102844, -2.652338544558399],
            [28.895423948474988, -2.652768783772695],
            [28.895210036249665, -2.653772674381703],
            [28.89509119722241, -2.654155108596076],
            [28.894972357296826, -2.654657053433388],
            [28.895114964848183, -2.655445823861729],
            [28.895305108549444, -2.655684845157646],
            [28.895355999008608, -2.655732610746325],
            [28.895661628326124, -2.656019474351178],
            [28.895828004401576, -2.656593125474003],
            [28.895923075803058, -2.65735799201318],
            [28.896184523279967, -2.658648703886556],
            [28.896541043056679, -2.659174548570498],
            [28.896683650608036, -2.659796001578695],
            [28.896778722907815, -2.660441356845743],
            [28.897087706534624, -2.661015004982014],
            [28.897467993937109, -2.661206220967342],
            [28.897943353639373, -2.661540849546862],
            [28.898371177191766, -2.66182767293789],
            [28.898989144445387, -2.6621862029849],
            [28.899512039399223, -2.662473027127098],
            [28.900391455028075, -2.66252083129476],
            [28.901080726057369, -2.662401321323745],
            [28.901674925685224, -2.662353517151338],
            [28.902269124414737, -2.662305712977085],
            [28.902839555518455, -2.662305712977085],
            [28.903172307669362, -2.662783752828361],
            [28.903671434997431, -2.663453008123686],
            [28.903956650998435, -2.663931046620376],
            [28.904645922027729, -2.66476761511801],
            [28.905168816981572, -2.66512614429776],
            [28.905691712833743, -2.665245654000858],
            [28.906262143937457, -2.665078340232588],
            [28.906785039789629, -2.664289576047052],
            [28.907141558668012, -2.664265674449883],
            [28.907711990670052, -2.664289576047052],
            [28.908116045698346, -2.66443298742673],
            [28.908615173026384, -2.664695909450034],
            [28.909233140280001, -2.665054437747587],
            [28.909779803757942, -2.665293457156086],
            [28.91018385968453, -2.665771495831994],
            [28.910278931086012, -2.666608063061936],
            [28.910136323534658, -2.666966590794953],
            [28.910017483609078, -2.667468530346628],
            [28.910017483609078, -2.667874862685792],
            [28.909827339907849, -2.668448507312334],
            [28.910160091160435, -2.668926544745599],
            [28.910659219386798, -2.669213367295777],
            [28.910944434489508, -2.669524091272212],
            [28.911134578190765, -2.669739207407683],
            [28.911443561817578, -2.670073833635972],
            [28.911491097967446, -2.670551869525168],
            [28.911467330341679, -2.671029906129199],
            [28.911705010192808, -2.67131672818176],
            [28.912085297595294, -2.671460138730906],
            [28.912394281222102, -2.671818665932911],
            [28.912679496324809, -2.672296701133821],
            [28.912964712325849, -2.672679130423461],
            [28.913440072028116, -2.673157165284777],
            [28.913321232102533, -2.673683004588696],
            [28.913606447205243, -2.674232745065394],
            [28.913962966981952, -2.674662976529392],
            [28.914105575431609, -2.675356126648753],
            [28.914343254384438, -2.675571241748496],
            [28.91465223801125, -2.675881964093968],
            [28.914913686386488, -2.676383900855776],
            [28.915222670013296, -2.677172656267638],
            [28.915219444163114, -2.677209957285606],
            [28.915175133863389, -2.677722395158677],
            [28.915222670013296, -2.67836774088719],
            [28.915341509938841, -2.678845773500758],
            [28.915816868742816, -2.678965281850479],
            [28.916458604520532, -2.678965281850479],
            [28.916767588147341, -2.679156495004719],
            [28.916981499474375, -2.679610626915236],
            [28.917551931476417, -2.680590594051972],
            [28.91807482643026, -2.681116429219935],
            [28.91857395375833, -2.681188133915704],
            [28.919120617236267, -2.681283740772351],
            [28.919151565994433, -2.681284389389254],
            [28.920261480342027, -2.681307642033652],
            [28.920641767744513, -2.681427150139756],
            [28.921235966474029, -2.68154665823404],
            [28.92168755855052, -2.681809575638441],
            [28.92261450943095, -2.682526623799428],
            [28.923588996461284, -2.682741737622623],
            [28.923897980088093, -2.682622229646719],
            [28.924492178817612, -2.682263706551231],
            [28.925300289772458, -2.682144198527924],
            [28.925870721774501, -2.682144198527924],
            [28.926441152878244, -2.682287607793105],
            [28.927249263833126, -2.682215903162652],
            [28.927534479834129, -2.681976887094779],
            [28.928033607162199, -2.681976887094779],
            [28.928627806790015, -2.68209639513465],
            [28.929435917744893, -2.682120296379833],
            [28.930053884998514, -2.682000788342366],
            [28.930291564849647, -2.68166616631648],
            [28.930743156027809, -2.68166616631648],
            [28.931456194682912, -2.681690067570212],
            [28.931717643058143, -2.68183347779269],
            [28.932454450237312, -2.682239804405493],
            [28.932858505265607, -2.682502721658894],
            [28.933119953640837, -2.682407115802202],
            [28.933428937267646, -2.681761772231911],
            [28.93414197592271, -2.68147495355958],
            [28.934664871774881, -2.681307642033652],
            [28.935116462953047, -2.681307642033652],
            [28.93556805413121, -2.68147495355958],
            [28.936114717609154, -2.681809575638441],
            [28.936732684862768, -2.682263706551231],
            [28.937398188266297, -2.682359312419297],
            [28.938026188803299, -2.682707724121098],
            [28.938929371159659, -2.683448672063933],
            [28.939642410713056, -2.683926703569217],
            [28.940022698115541, -2.68418962045501],
            [28.940379217892222, -2.684643750471901],
            [28.940616897743357, -2.685384698128702],
            [28.940616897743357, -2.686412462896462],
            [28.94021284181677, -2.686723182451926],
            [28.939642410713056, -2.687488030872437],
            [28.939499803161699, -2.687750946981386],
            [28.939499803161699, -2.688778710633814],
            [28.939523570787472, -2.689256739121363],
            [28.940284145592443, -2.690021585932602],
            [28.941971672176177, -2.691718586393431],
            [28.942542103279887, -2.692650740709984],
            [28.943088766757828, -2.693080965604902],
            [28.943587894085901, -2.693487289326696],
            [28.944300933639294, -2.693463387403712],
            [28.94453861349043, -2.693272176519535],
            [28.94453861349043, -2.692985360587888],
            [28.944562381116235, -2.69274634665703],
            [28.94453861349043, -2.692483430736103],
            [28.944324701265099, -2.6921488116219],
            [28.944324701265099, -2.691814192414534],
            [28.944324701265099, -2.691551276289847],
            [28.944847597117239, -2.691360065101585],
            [28.945275420669635, -2.691360065101585],
            [28.94560817192221, -2.691431769187833],
            [28.946273675325738, -2.691288361011075],
            [28.947200626206165, -2.691025445674759],
            [28.947794824935681, -2.691527375231758],
            [28.948579168264757, -2.692292219696066],
            [28.949125831742702, -2.692483430736103],
            [28.949648727594873, -2.691933699478598],
            [28.950409302399844, -2.691885896473709],
            [28.950599446101069, -2.691527375231758],
            [28.951312485654469, -2.691814192414534],
            [28.952382044086249, -2.692507332678577],
            [28.953475371042167, -2.693009261617022],
            [28.953713050893302, -2.693343880491741],
            [28.954521161848142, -2.693343880491741],
            [28.95542434420447, -2.693606796224417],
            [28.956351295983232, -2.694013118865052],
            [28.957111870788204, -2.694013118865052],
            [28.958300269145568, -2.69386971099621],
            [28.959155916250317, -2.6938458099842],
            [28.960320546981883, -2.695303791624488],
            [28.961342570162085, -2.696331548821535],
            [28.962055608817153, -2.697956836678439],
            [28.962839952146258, -2.699295307909533],
            [28.963719366876781, -2.700370863453344],
            [28.964123422803372, -2.700633776743456],
            [28.964456174055986, -2.700705480275893],
            [28.965478197236195, -2.701661529374091],
            [28.965908252203739, -2.70227051144597],
            [28.966642827967753, -2.703310710830098],
            [28.96764108262386, -2.703764833620566],
            [28.968259049877474, -2.704099449495081],
            [28.969019624682453, -2.704027746165817],
            [28.969209769282006, -2.703454118473592],
            [28.969542520534624, -2.702904391338607],
            [28.969946575562876, -2.702306861361451],
            [28.97006541548846, -2.701231307554935],
            [28.97006541548846, -2.700442567001518],
            [28.970535372722615, -2.700141827612319],
            [28.970588311340599, -2.7001079501056],
            [28.971277582369897, -2.699582122333762],
            [28.971396422295481, -2.699032393422604],
            [28.971396422295481, -2.698745578866915],
            [28.97220453325032, -2.697956836678439],
            [28.972917572803755, -2.697478810747827],
            [28.973559307683146, -2.696929080872884],
            [28.974391187162126, -2.696451055436251],
            [28.974937850640064, -2.695734015569438],
            [28.975793497744821, -2.695375495475464],
            [28.976672912475337, -2.695279890640976],
            [28.97719580742918, -2.69492137041146],
            [28.977956383132486, -2.694993074285259],
            [28.978598118011906, -2.694969173295577],
            [28.979382461340979, -2.694945271402058],
            [28.979834052519148, -2.694515047174624],
            [28.980665931998089, -2.694443343272276],
            [28.981474042952971, -2.694371639365678],
            [28.982353457683494, -2.694180428625988],
            [28.982686209834437, -2.694156527620162],
            [28.983470552265182, -2.694777962651012],
            [28.984302431744165, -2.695112581033177],
            [28.985039238923331, -2.695638409860145],
            [28.985419526325817, -2.696403252611139],
            [28.985562133877174, -2.696952982726901],
            [28.986322709580474, -2.697550514468897],
            [28.987225891936802, -2.697956836678439],
            [28.987558644087713, -2.698434862418611],
            [28.987962699116004, -2.699295307909533],
            [28.988438058818268, -2.699940641170946],
            [28.989388777324468, -2.70015575187978],
            [28.989982976952312, -2.70015575187978],
            [28.991218911459555, -2.699056295234701],
            [28.991432823684878, -2.698626072480691],
            [28.991622967386142, -2.698458763339301],
            [28.991955718638721, -2.698745578866915],
            [28.992502382116697, -2.698769479781409],
            [28.99342933299712, -2.69900849251339],
            [28.993928460325158, -2.698984591603654],
            [28.994641499878558, -2.699199702483984],
            [28.995449610833436, -2.699534319633405],
            [28.996233954162509, -2.700442567001518],
            [28.996780617640457, -2.701279110187675],
            [28.997255976444386, -2.702569774226806],
            [28.997588728595328, -2.703382415105653],
            [28.998373071026073, -2.703645327734884],
            [28.999109878205278, -2.704290658653272],
            [28.999632774057417, -2.704242857044111],
            [29.000179437535355, -2.704577472785004],
            [29.00091624471456, -2.705103297460725],
            [29.002318555297254, -2.705175001628904],
            [29.003245506177681, -2.704840385151725],
            [29.003887241057104, -2.704864286847974],
            [29.004909264237313, -2.705653023585883],
            [29.005503462966825, -2.706537365554615],
            [29.005907518893412, -2.706871980653788],
            [29.006715629848262, -2.707254398053445],
            [29.007143453400655, -2.707708519347143],
            [29.007785188280074, -2.708282144999437],
            [29.009116195087092, -2.709596703086232],
            [29.009377642563997, -2.710146427145315],
            [29.009615322415129, -2.710576645758357],
            [29.01001937834172, -2.711413180954719],
            [29.010494737145684, -2.712130211430817],
            [29.010922560698049, -2.712775537768366],
            [29.011730672551217, -2.713468666805625],
            [29.012158495205281, -2.713755477831075],
            [29.013085446984043, -2.714376902687394],
            [29.013941093190493, -2.714998327219894],
            [29.014582828968216, -2.715380742920182],
            [29.014606596593985, -2.71595436488564],
            [29.01515326007193, -2.716551887133985],
            [29.016103979476455, -2.717412319584696],
            [29.01703093035692, -2.717890337545079],
            [29.017577593834865, -2.718272751413927],
            [29.018052952638801, -2.718487859725793],
            [29.018504544715288, -2.718822471473983],
            [29.018908599743547, -2.718870273402739],
            [29.019312655670138, -2.718846372890267],
            [29.019701085402382, -2.718854778448869],
            [29.020128908954742, -2.718974282812197],
            [29.02053296488133, -2.719261092512566],
            [29.020841948508135, -2.719595704946852],
            [29.021174699760749, -2.720025920150225],
            [29.021673827088787, -2.720814646866449],
            [29.021982810715599, -2.721555572144116],
            [29.022268026716635, -2.721842382125684],
            [29.022244258192533, -2.722224794724586],
            [29.021840203164242, -2.722559406325263],
            [29.022006579239701, -2.722917917359592],
            [29.022339330492308, -2.723252528765185],
            [29.022814690194579, -2.723754444793618],
            [29.023503961223874, -2.724590970735545],
            [29.024217000777266, -2.725260191607014],
            [29.024739895731109, -2.725953312471507],
            [29.025310326834855, -2.726216221027388],
            [29.025904526462668, -2.726598632218692],
            [29.02621351008948, -2.727530759320192],
            [29.02671263741755, -2.72810437542572],
            [29.02728306852126, -2.728415084146663],
            [29.02799610807466, -2.729179905892372],
            [29.028519003028503, -2.729610117625276],
            [29.028827986655344, -2.729968626530733],
            [29.029136971180453, -2.730255434480383],
            [29.029612329984417, -2.730542242360647],
            [29.029873777461319, -2.730709546097397],
            [29.029826242209747, -2.731068055573699],
            [29.029945082135331, -2.731450465200933],
            [29.030396673313493, -2.731785074201023],
            [29.030776960715979, -2.731952377762346],
            [29.031157248118465, -2.732239185231949],
            [29.031157248118465, -2.73269329608881],
            [29.031703911596409, -2.733219109250668],
            [29.032179271298673, -2.733744921275745],
            [29.033106222179104, -2.734175131351403],
            [29.033557813357262, -2.7341990324586],
            [29.034175780610884, -2.734103429833529],
            [29.034627372687375, -2.733960026784779],
            [29.034983892464059, -2.734700943855216],
            [29.034960123939957, -2.735465760640214],
            [29.034936356314184, -2.736350079544632],
            [29.03510273149131, -2.736923692283543],
            [29.035126500015412, -2.737712407764482],
            [29.035601859717673, -2.738214318573892],
            [29.036338666896878, -2.739409341259064],
            [29.036837794224915, -2.740484860552083],
            [29.037455761478537, -2.741154072443815],
            [29.038073728732151, -2.742325192115912],
            [29.038655094129535, -2.742823824625338],
            [29.038881839687029, -2.743018302990079],
            [29.03949980694065, -2.743544111559712],
            [29.040141541820077, -2.744237221717923],
            [29.040545597746664, -2.744786929734046],
            [29.040616901522341, -2.746842356847562],
            [29.040450525446879, -2.747750568064283],
            [29.040331685521302, -2.747989570947218],
            [29.04021284649405, -2.748491476482186],
            [29.039689950641908, -2.749160682927295],
            [29.0393571993893, -2.749638688072333],
            [29.0393571993893, -2.750594697780113],
            [29.039167055688072, -2.7523394124107],
            [29.038929375836936, -2.752817416264445],
            [29.038667927461706, -2.753653921637598],
            [29.038667927461706, -2.754633827871647],
            [29.038501552284544, -2.755064030328426],
            [29.038358943834858, -2.756402437165005],
            [29.038358943834858, -2.757932042078036],
            [29.03857285606022, -2.758410043656247],
            [29.038810535911356, -2.758792444417329],
            [29.038881839687029, -2.759246545046327],
            [29.038620392210127, -2.76041764671296],
            [29.038192568657735, -2.761039047048679],
            [29.037241849253206, -2.760608847685167],
            [29.036053450895842, -2.760083046743267],
            [29.035174036165319, -2.76010694642162],
            [29.034437228986114, -2.76010694642162],
            [29.033961869283853, -2.759772346363278],
            [29.033724189432718, -2.759581146157992],
            [29.033346542178869, -2.759394855394319],
            [29.032464487299677, -2.758959745049844],
            [29.031941591447538, -2.759246545046327],
            [29.030776960715979, -2.759963546537344],
            [29.029707402284195, -2.76010694642162],
            [29.028233787925796, -2.76010694642162],
            [29.026974084894452, -2.76044154728786],
            [29.026617566016068, -2.760823947386661],
            [29.024977575582245, -2.762090646935955],
            [29.024658258634719, -2.762356377491037],
            [29.023599033523652, -2.763237846147332],
            [29.021602523313113, -2.765699539966416],
            [29.02072310858259, -2.766775035211376],
            [29.019962532879283, -2.768113428676038],
            [29.0196060140009, -2.76866312551592],
            [29.01908311814876, -2.769571318943073],
            [29.018037327342753, -2.7705273124029],
            [29.017466896239, -2.770718510820333],
            [29.017039072686647, -2.771268206434926],
            [29.015826905805177, -2.771746201665081],
            [29.015470386028497, -2.772080799203367],
            [29.014543435148067, -2.772391496315489],
            [29.014020540194224, -2.772797791927897],
            [29.013236196865119, -2.773060690023087],
            [29.011928958582203, -2.773562584826229],
            [29.011548671179717, -2.774279576640573],
            [29.010811864000551, -2.774805371200792],
            [29.01019389674693, -2.775044368567729],
            [29.009457089567725, -2.775689660491206],
            [29.009219409716597, -2.776263253112663],
            [29.008910426089788, -2.776836846355245],
            [29.008815353790009, -2.7772192410913],
            [29.008435066387523, -2.77807962924037],
            [29.008268690312065, -2.778462023568628],
            [29.007698259208322, -2.779155113081655],
            [29.006367252401301, -2.779752604177294],
            [29.005250157819649, -2.780230596833094],
            [29.004296582670815, -2.780811195848487],
            [29.003467559834437, -2.781473376097082],
            [29.002683217403693, -2.782166463817383],
            [29.002493073702436, -2.782405459674167],
            [29.002374233776884, -2.782763953367285],
            [29.002374233776884, -2.783433140214872],
            [29.001922641700386, -2.783887232167585],
            [29.001352210596675, -2.785536298694146],
            [29.000924387044286, -2.786922469781052],
            [29.000900619418513, -2.789384113594209],
            [29.000876850894411, -2.790626883069353],
            [29.001375978222448, -2.791272166347344],
            [29.00139974674655, -2.791845751282304],
            [29.001352210596675, -2.793566505287619],
            [29.001257138296896, -2.794211787832531],
            [29.001090763119741, -2.794809270279377],
            [29.001114530745546, -2.795669645400729],
            [29.000995690819963, -2.800210503601237],
            [29.001257138296896, -2.800927478963971],
            [29.001589890447811, -2.801692252434864],
            [29.001827570298943, -2.802265833109077],
            [29.001827570298943, -2.802480925111021],
            [29.002065250150071, -2.802958908398549],
            [29.002445537552557, -2.803317395734362],
            [29.002588145103914, -2.803843176236248],
            [29.002445537552557, -2.804631847443371],
            [29.002445537552557, -2.805516113999535],
            [29.002421769028455, -2.806256985701345],
            [29.002302929102871, -2.806782765767178],
            [29.002184090075623, -2.807523636655364],
            [29.002184090075623, -2.808622991851384],
            [29.002207857701428, -2.809363861556862],
            [29.0022553938513, -2.810630509096504],
            [29.002754521179369, -2.811251882579244],
            [29.003372488432987, -2.811825457595695],
            [29.003847848135251, -2.812255638896353],
            [29.00408552708809, -2.81282921341263],
            [29.004513350640448, -2.813187697678902],
            [29.004917406567035, -2.814239250340247],
            [29.005131317894065, -2.814645532182901],
            [29.00546407004498, -2.815266903497597],
            [29.005725517521913, -2.815625387004073],
            [29.006010733522917, -2.816055566883672],
            [29.006367252401301, -2.816437948662987],
            [29.007127828104608, -2.817250509747366],
            [29.008054778985038, -2.817632891129048],
            [29.008411298761718, -2.817871879653788],
            [29.009053033641138, -2.81825426082862],
            [29.009813608446116, -2.818708338195538],
            [29.010360271924053, -2.819329708216486],
            [29.01126345517871, -2.819951076997921],
            [29.01207156613356, -2.820429052129438],
            [29.012641997237303, -2.820548546107009],
            [29.013259964490924, -2.820787534024848],
            [29.013973004044324, -2.821074319641229],
            [29.014947491074654, -2.821122116484278],
            [29.015921978104956, -2.821361104282668],
            [29.017086608836514, -2.821528395892561],
            [29.018275007193882, -2.821480598163168],
            [29.019249494224219, -2.821074319641229],
            [29.019938765253514, -2.820715837835358],
            [29.020414124955778, -2.820978724142649],
            [29.020841948508135, -2.821002623469677],
            [29.021174699760749, -2.821241610389675],
            [29.02138861198608, -2.82140890201701],
            [29.022077883015374, -2.82140890201701],
            [29.022767154044672, -2.821600092031252],
            [29.023194977597065, -2.821671788165477],
            [29.023361353672517, -2.821982471964166],
            [29.023622801149457, -2.822603839309072],
            [29.023836712476484, -2.822938422141961],
            [29.024217000777266, -2.822651636991621],
            [29.024692359581241, -2.822603839309072],
            [29.025072646983727, -2.822603839309072],
            [29.02540539913463, -2.822986219810593],
            [29.025690615135645, -2.823511991324156],
            [29.025880758836902, -2.824085560219362],
            [29.026189742463711, -2.824587432880169],
            [29.026641333641873, -2.825423887428516],
            [29.026926549642877, -2.825686772656301],
            [29.027354373195273, -2.825997455366783],
            [29.02785350052331, -2.826308137992992],
            [29.028542771552637, -2.826284239679836],
            [29.02942218628316, -2.826212543834099],
            [29.030658120790395, -2.826093050446866],
            [29.031615755425985, -2.826052929671262],
            [29.031798983896188, -2.82604525290781],
            [29.032916078477836, -2.825854063634968],
            [29.033391438180139, -2.825352191528952],
            [29.033432161506891, -2.825276849182401],
            [29.033985636909659, -2.8242528514318],
            [29.034484764237696, -2.8242528514318],
            [29.034960123939957, -2.8242528514318],
            [29.035578091193578, -2.824396243364028],
            [29.036267362222876, -2.824396243364028],
            [29.03679025807504, -2.824515736928266],
            [29.037194313103299, -2.824467940226663],
            [29.037740976581244, -2.824420142619811],
            [29.038382712358992, -2.824300649045637],
            [29.039167055688072, -2.824037763499834],
            [29.039832558193265, -2.823488092952668],
            [29.040474293970984, -2.823010118192512],
            [29.041187332626052, -2.822866726086906],
            [29.041900372179452, -2.822436548759245],
            [29.04285109068568, -2.821886877444497],
            [29.043730506314532, -2.820859230209835],
            [29.044847600896222, -2.819998873887736],
            [29.045917159328003, -2.819305808854637],
            [29.046297446730488, -2.819305808854637],
            [29.046915413984109, -2.819353606674599],
            [29.047509613611926, -2.819425302949163],
            [29.048317724566804, -2.819592594841247],
            [29.04888815567055, -2.819712088905888],
            [29.049482355298363, -2.819903279202856],
            [29.049910178850759, -2.820142267255068],
            [29.050504378478571, -2.82038125525751],
            [29.050860898255284, -2.820644141641427],
            [29.051146113357991, -2.821193813551601],
            [29.051146113357991, -2.82210196577996],
            [29.051146113357991, -2.823177409561879],
            [29.051169881882096, -2.823727080258022],
            [29.051431329359005, -2.824157257101463],
            [29.051764080611612, -2.824587432880169],
            [29.051923873832674, -2.824725656339986],
            [29.051923873832674, -2.824892946555727],
            [29.051852570056994, -2.825275326293597],
            [29.051923873832674, -2.825896691853473],
            [29.051923873832674, -2.826207374507023],
            [29.051947641458444, -2.826422462031687],
            [29.052470537310615, -2.826828739561255],
            [29.05266068101184, -2.82730671182512],
            [29.052969664638649, -2.827521800046555],
            [29.053706471817854, -2.827665191569547],
            [29.054110527744442, -2.827832482259165],
            [29.054419511371247, -2.828047569478534],
            [29.054752262623861, -2.828167062661806],
            [29.055085013876447, -2.82833435327808],
            [29.055489069803034, -2.828621137005733],
            [29.055964429505298, -2.828764528390995],
            [29.056344716907784, -2.828860122336777],
            [29.056748771936075, -2.829146905932666],
            [29.057152827862662, -2.829600978984512],
            [29.057509347639343, -2.830007255385798],
            [29.05784209889196, -2.830509125450738],
            [29.05755688378925, -2.830700313945959],
            [29.057390507713798, -2.830963197961788],
            [29.057342971563891, -2.831417271195753],
            [29.05755688378925, -2.831990836129934],
            [29.058032242593185, -2.832444908052442],
            [29.058317458594221, -2.832683893487592],
            [29.058555138445357, -2.832922878872743],
            [29.058697745996707, -2.833161864207921],
            [29.058911658222037, -2.833544240278942],
            [29.059149337174876, -2.833926616221953],
            [29.059553393101464, -2.83423729669429],
            [29.060076288055299, -2.834571876125844],
            [29.060409040206213, -2.835790697788134],
            [29.060646720057349, -2.836388159531859],
            [29.060718023833022, -2.837009519052231],
            [29.061145847385415, -2.83770257336368],
            [29.061526134787901, -2.838562916372512],
            [29.061716278489129, -2.838825799481424],
            [29.061716278489129, -2.839184274708165],
            [29.061763814639029, -2.839542750725491],
            [29.061763814639029, -2.839853429668631],
            [29.061835118414713, -2.840211905475454],
            [29.061835118414713, -2.840594279183845],
            [29.061644974713449, -2.840857160921048],
            [29.061502367162095, -2.841048347682994],
            [29.06140729486232, -2.841311230218644],
            [29.061359758712442, -2.841789196421313],
            [29.061145847385415, -2.842171570503534],
            [29.060979471309956, -2.842649536345147],
            [29.06131222346087, -2.843246994494069],
            [29.061621207087679, -2.843485977665834],
            [29.062144102041518, -2.84398784180194],
            [29.062358014266845, -2.844179028038293],
            [29.062500621818202, -2.844489705716768],
            [29.062809605445015, -2.844848180064188],
            [29.063118589071816, -2.845134958738207],
            [29.063570180249986, -2.845565127516995],
            [29.06425945127928, -2.845875804816946],
            [29.06444959587887, -2.845851906913496],
            [29.0646635072059, -2.84568461886571],
            [29.065352778235198, -2.845111060819236],
            [29.065685530386109, -2.845063264076489],
            [29.066184657714146, -2.845063264076489],
            [29.066469872816853, -2.845182755477951],
            [29.067040304818896, -2.845445637058925],
            [29.067444359847187, -2.846162584135142],
            [29.067872183399544, -2.846879531662641],
            [29.068181167026353, -2.847524783328285],
            [29.068418846877488, -2.848074442300573],
            [29.068608990578745, -2.848456813367132],
            [29.068870438055647, -2.849149860710227],
            [29.06917942168246, -2.849627824522557],
            [29.06917942168246, -2.84991460289408],
            [29.06917942168246, -2.850177482477462],
            [29.06917942168246, -2.850392565481362],
            [29.069131886430885, -2.850679343659774],
            [29.068704062878524, -2.850870528770708],
            [29.068466383027395, -2.851013918260231],
            [29.068252470802033, -2.851229001105701],
            [29.067848415773774, -2.851396288337268],
            [29.067682039698322, -2.851467982599456],
            [29.067040304818896, -2.851683065358886],
            [29.06680262496776, -2.851826454745741],
            [29.066469872816853, -2.852041537437247],
            [29.066351032891301, -2.85228051875994],
            [29.06630349763973, -2.852543397795503],
            [29.06623219386405, -2.852877971846487],
            [29.06623219386405, -2.85314085074362],
            [29.06623219386405, -2.853499322361424],
            [29.06623219386405, -2.854001182074829],
            [29.06623219386405, -2.854287958438073],
            [29.066398569041173, -2.854646429693332],
            [29.066873928743441, -2.855028798546097],
            [29.06715914474448, -2.855172187510104],
            [29.067610735922639, -2.855339473256937],
            [29.067848415773774, -2.855411168173175],
            [29.068157399400587, -2.855578453884741],
            [29.068395079251715, -2.855697944179777],
            [29.068680294354422, -2.855793536767997],
            [29.06915565405669, -2.855936924732011],
            [29.069464637683495, -2.856128108956855],
            [29.069868693610083, -2.856534375892109],
            [29.070106372562922, -2.857107928167531],
            [29.070510428489509, -2.857896562636613],
            [29.070510428489509, -2.858780787989507],
            [29.070510428489509, -2.859139257823401],
            [29.069631013758954, -2.859258747742826],
            [29.069036814131106, -2.859617217425351],
            [29.06858522295294, -2.860023482205755],
            [29.068371310727617, -2.860358054048238],
            [29.068181167026353, -2.860979400460997],
            [29.068191575805553, -2.860996842681125],
            [29.068323775476038, -2.861218378995374],
            [29.068347543101812, -2.861744133761078],
            [29.068632759102847, -2.862174296240981],
            [29.068917974205558, -2.862747845658585],
            [29.069226957832367, -2.863249701273247],
            [29.069322030132145, -2.86375155666508],
            [29.069702317534631, -2.864157820863646],
            [29.069868693610083, -2.864420697141999],
            [29.070344052414058, -2.864540186503427],
            [29.07072434071484, -2.864540186503427],
            [29.07093825204187, -2.864540186503427],
            [29.071294771818582, -2.864635778344789],
            [29.071627523071168, -2.86456408491616],
            [29.071912739072204, -2.864349003699731],
            [29.072245490324782, -2.864110024923785],
            [29.072554473951591, -2.863894944524149],
            [29.072982297503984, -2.863584272161386],
            [29.073219977355119, -2.863512578666042],
            [29.073742873207255, -2.863488680231096],
            [29.074028088309962, -2.863512578666042],
            [29.074693591713491, -2.863440884262904],
            [29.07519271904156, -2.863488680231096],
            [29.075929526220726, -2.863894944524149],
            [29.076214742221762, -2.864301207767912],
            [29.076262278371637, -2.864635778344789],
            [29.076428653548795, -2.865185429017534],
            [29.076571261998449, -2.86616523948054],
            [29.076690101025697, -2.866690991945049],
            [29.076856477101156, -2.867049459270923],
            [29.077070389326515, -2.867312334876297],
            [29.077379372953327, -2.867503517178444],
            [29.077640820430229, -2.867503517178444],
            [29.077926036431265, -2.867503517178444],
            [29.078092411608392, -2.867479619731137],
            [29.078401395235201, -2.867360130680703],
            [29.078591538936461, -2.867360130680703],
            [29.07875791501192, -2.867360130680703],
            [29.078948058713145, -2.867431823931844],
            [29.079066898638729, -2.867503517178444],
            [29.079423418415441, -2.867670802004938],
            [29.079589794490893, -2.867838085903411],
            [29.0798274734437, -2.867981473243668],
            [29.080326601670066, -2.868244348631962],
            [29.080611816772773, -2.868387735017366],
            [29.081110944100843, -2.868459428203242],
            [29.081562536177302, -2.868602815464558],
            [29.081800216028437, -2.868698406058723],
            [29.082156734906821, -2.868841793289683],
            [29.082584558459214, -2.869009077014562],
            [29.082917310610124, -2.86920025902925],
            [29.083345134162482, -2.869510929846861],
            [29.08365411778929, -2.870060578145869],
            [29.083939332892001, -2.870203965203642],
            [29.084129476593258, -2.870323453952928],
            [29.084414692594301, -2.870610226176973],
            [29.084699908595304, -2.87087310095268],
            [29.084913819922331, -2.871207669581505],
            [29.085008892222117, -2.871781214410065],
            [29.08508019599779, -2.872402554537463],
            [29.085341643474724, -2.87292830409478],
            [29.086387434280709, -2.873023894322239],
            [29.086767721683195, -2.873143382772616],
            [29.087290617535366, -2.873143382772616],
            [29.087932352414754, -2.872952201426607],
            [29.088407712117018, -2.87256983863729],
            [29.08857408819247, -2.872044088912702],
            [29.088811767145309, -2.871542237207845],
            [29.089192055446123, -2.870825306200362],
            [29.089667414250055, -2.870825306200362],
            [29.090000166400969, -2.870825306200362],
            [29.090523061354812, -2.871183772212706],
            [29.090832044981621, -2.871494442483885],
            [29.090950884907205, -2.871876805638063],
            [29.091045957206983, -2.872330861602265],
            [29.091378708459562, -2.873071689884567],
            [29.091450012235235, -2.873740824834216],
            [29.091663924460597, -2.87429047107038],
            [29.091616388310698, -2.874433856686764],
            [29.091925371937506, -2.874744526061726],
            [29.092305659339992, -2.875055195350992],
            [29.092590875341028, -2.875341967273927],
            [29.092852322817929, -2.875604840945562],
            [29.093161306444742, -2.876106690840276],
            [29.093161306444742, -2.876536847843786],
            [29.09311377029487, -2.877110389958315],
            [29.092662179116704, -2.877444956734149],
            [29.092662179116704, -2.877683932683625],
            [29.092662179116704, -2.877922907679138],
            [29.092662179116704, -2.878329166771044],
            [29.093018698893392, -2.878520347203712],
            [29.093280146370326, -2.878687630394384],
            [29.093612897622901, -2.878926606079784],
            [29.093612897622901, -2.879404556395024],
            [29.093612897622901, -2.880360458222205],
            [29.093684202296913, -2.880814510763367],
            [29.093779273698363, -2.881053485996556],
            [29.094183329624983, -2.881244665965869],
            [29.09432593717634, -2.881937693194755],
            [29.094444777101884, -2.882391746001645],
            [29.094444777101884, -2.882821900600109],
            [29.094112025849306, -2.883180361886924],
            [29.093898113623947, -2.883730003508688],
            [29.093517826221458, -2.884255747770191],
            [29.092567107715222, -2.885331131719768],
            [29.092495803041253, -2.885832977270367],
            [29.092210587938542, -2.886406515541704],
            [29.091830300536056, -2.886956154679684],
            [29.091307404683885, -2.887386307528232],
            [29.091045957206983, -2.887744768259799],
            [29.090855813505726, -2.888389997468336],
            [29.090855813505726, -2.888987430518979],
            [29.090665669804498, -2.889537069294503],
            [29.090214077728003, -2.890038912962009],
            [29.090023934026775, -2.89066024299149],
            [29.090119006326553, -2.891735621699208],
            [29.09019031010223, -2.89228525912577],
            [29.090499293729039, -2.892787101561409],
            [29.090546829878914, -2.893575710132201],
            [29.09042672332879, -2.894096730550649],
            [29.089952630251101, -2.894459908355434],
            [29.089952630251101, -2.894866160553169],
            [29.090000166400969, -2.895535282507721],
            [29.090000166400969, -2.896132712647125],
            [29.089714950399966, -2.896777936116402],
            [29.08969118277416, -2.897279776535659],
            [29.08947727054883, -2.897733823123178],
            [29.08933466299748, -2.898235663112971],
            [29.08933466299748, -2.898976474324702],
            [29.089358430623253, -2.899478313756052],
            [29.08947727054883, -2.899932358546419],
            [29.089619878998484, -2.900601477466174],
            [29.089667414250055, -2.901151110532144],
            [29.090119006326553, -2.901629052265611],
            [29.090285381503676, -2.90303897774107],
            [29.090332917653587, -2.903851477551923],
            [29.090356686177689, -2.904544490778417],
            [29.090594365130489, -2.904998533506257],
            [29.090713205056073, -2.905333091044704],
            [29.090736973580174, -2.90590661931003],
            [29.091141028608433, -2.906910291708916],
            [29.091568852160819, -2.907555508943886],
            [29.091735228236278, -2.907913963203177],
            [29.091943428074732, -2.908085912390348],
            [29.092400731639771, -2.908463592662499],
            [29.092685946742478, -2.909252191056369],
            [29.092828555192163, -2.90951505676238],
            [29.092971162743513, -2.910112479411604],
            [29.092971162743513, -2.910518725907215],
            [29.093185074968844, -2.911307322844073],
            [29.093636666147006, -2.911856950626684],
            [29.094016953549492, -2.912310990371202],
            [29.094159561100849, -2.912908411518047],
            [29.094373473326208, -2.913314656991911],
            [29.094706224578825, -2.913720903220406],
            [29.095062744355506, -2.914127149300331],
            [29.095276656580864, -2.91443780764831],
            [29.09539549560812, -2.914844052562804],
            [29.095585640207677, -2.916230065790003],
            [29.09565694398335, -2.916660207349554],
            [29.095918391460252, -2.916994761379213],
            [29.095704479234932, -2.917998423766057],
            [29.096013463760031, -2.918524151879704],
            [29.09667896626523, -2.919049878840923],
            [29.0971780935933, -2.919599502790444],
            [29.097796060846914, -2.919695089929127],
            [29.098271420549185, -2.919623399124264],
            [29.098414028998832, -2.91979067615639],
            [29.098675476475773, -2.919957953163288],
            [29.098865620176998, -2.920173022789457],
            [29.099127067653935, -2.920698749871969],
            [29.099340979879294, -2.920579266507069],
            [29.099863874833137, -2.920483679444605],
            [29.100054018534365, -2.920746543394925],
            [29.100458074460953, -2.921176683202664],
            [29.100671985787979, -2.921559029357541],
            [29.100576914386529, -2.922706067030352],
            [29.100767058087758, -2.923327378832913],
            [29.101099809340372, -2.923805311029372],
            [29.101456329117052, -2.924115966665802],
            [29.101812848893772, -2.924426622215033],
            [29.102264440071931, -2.924474415577168],
            [29.103120087176688, -2.924498311805827],
            [29.103571678354847, -2.92464169187671],
            [29.104094574207021, -2.925000139714601],
            [29.104665005310732, -2.925095726387205],
            [29.105401812489937, -2.924808967247746],
            [29.105782099892423, -2.923924794046281],
            [29.106804123072632, -2.922467100720679],
            [29.107612234027471, -2.922180341803553],
            [29.108372808832442, -2.922180341803553],
            [29.108919472310387, -2.922228135262657],
            [29.109371064386885, -2.922371514724299],
            [29.10979888793927, -2.922514894167378],
            [29.109965263116397, -2.922706067030352],
            [29.110535695118443, -2.923040620138541],
            [29.110868446371061, -2.923853104418325],
            [29.111224966147738, -2.924307139252347],
            [29.111747861101577, -2.924689484326343],
            [29.111961773326936, -2.924976243496717],
            [29.112413364505105, -2.925334692129442],
            [29.112864955683264, -2.925693140646024],
            [29.113768138937921, -2.926290553679033],
            [29.114124658714609, -2.926457829703991],
            [29.114623786042678, -2.926290553679033],
            [29.115265520922065, -2.926505622978368],
            [29.115526969297296, -2.927103035572562],
            [29.116002328101271, -2.927580966138057],
            [29.116620295354885, -2.927963310080425],
            [29.117808694610545, -2.928082792648227],
            [29.118188982013038, -2.928082792648227],
            [29.118569269415524, -2.928273964549146],
            [29.118949556818009, -2.928465136417026],
            [29.119068396743593, -2.928751894608425],
            [29.120090419923795, -2.929444892285328],
            [29.120542011101964, -2.929707753203714],
            [29.120779690953093, -2.929922821838148],
            [29.121041138429998, -2.930209579651264],
            [29.121825481759075, -2.930568025683974],
            [29.122011801332153, -2.930692909835003],
            [29.122253305311467, -2.930854783329552],
            [29.123061416266307, -2.930950369495926],
            [29.12367938351996, -2.930878679420353],
            [29.124178510847997, -2.93078309415092],
            [29.124701406700169, -2.930711404967644],
            [29.125390677729467, -2.930472440387659],
            [29.126222556310111, -2.930305164970276],
            [29.126983132013386, -2.929994511072604],
            [29.127529795491323, -2.929946717949113],
            [29.127981386669493, -2.93009009731343],
            [29.128623121548912, -2.930137889527575],
            [29.128646890073014, -2.930305164970276],
            [29.1290271774755, -2.930926472503502],
            [29.129526304803569, -2.931428297494155],
            [29.129835288430378, -2.931715054916344],
            [29.130072968281514, -2.932025708330023],
            [29.130690935535128, -2.932264672573849],
            [29.131047455311815, -2.932647014895077],
            [29.131427742714301, -2.933770145036313],
            [29.131879333892464, -2.934845481122805],
            [29.132093246117822, -2.93525171944892],
            [29.132093246117822, -2.935801335344526],
            [29.132402229744635, -2.936159780464047],
            [29.132758749521315, -2.936327054090702],
            [29.133162804549606, -2.936422639782983],
            [29.133400484400738, -2.936685499039288],
            [29.133780771803224, -2.936900566313755],
            [29.134042220178458, -2.936900566313755],
            [29.134327435281165, -2.936876669450206],
            [29.134541347506531, -2.936685499039288],
            [29.134779026459331, -2.936637706205558],
            [29.135040474834561, -2.936924462273542],
            [29.135349458461373, -2.937259010172606],
            [29.135777282013766, -2.937760833185464],
            [29.13613380089215, -2.938047588058005],
            [29.136466553043064, -2.938382136519187],
            [29.136894376595425, -2.938453825203866],
            [29.137369736297689, -2.938501617958795],
            [29.137702487550296, -2.938788372638506],
            [29.138201614878334, -2.939099024059364],
            [29.138914654431765, -2.939457468106072],
            [29.139366245609931, -2.93957694942903],
            [29.139936676713646, -2.940341628866429],
            [29.140316964116131, -2.940819553696673],
            [29.140435804041715, -2.941393062677112],
            [29.140435804041715, -2.942396703802571],
            [29.140507108715685, -2.942802938440234],
            [29.140744787668524, -2.94316138128052],
            [29.141030003669528, -2.943591512353985],
            [29.141362754922138, -2.944069435772342],
            [29.141624203297376, -2.944451773996187],
            [29.141980723074056, -2.945622684543799],
            [29.142099562101311, -2.945981125561499],
            [29.14240854572812, -2.946291774950988],
            [29.142788834028934, -2.946626320904926],
            [29.143074049131641, -2.946841385333089],
            [29.143454336534127, -2.947056450622318],
            [29.144119839937655, -2.947247619231198],
            [29.144618967265693, -2.94727151496626],
            [29.145260703043412, -2.947534372533652],
            [29.145949974072707, -2.947725541059328],
            [29.146900692578942, -2.948036189955424],
            [29.147851411983471, -2.948131773727147],
            [29.148588219162676, -2.948490214829119],
            [29.149538937668872, -2.948681383188325],
            [29.150822408326015, -2.948561902854838],
            [29.151440375579636, -2.947773332508181],
            [29.151796895356316, -2.947104243003468],
            [29.15205834283325, -2.946817489588689],
            [29.152628774835296, -2.946698009052334],
            [29.152866453788096, -2.946626320904926],
            [29.1533418134904, -2.946626320904926],
            [29.153745869416987, -2.946745801449068],
            [29.153936013118216, -2.946841385333089],
            [29.154054853043796, -2.947056450622318],
            [29.154173692969341, -2.947462683537698],
            [29.154601516521737, -2.948179566061479],
            [29.154981803924223, -2.948609695170418],
            [29.155314555176805, -2.948848655814009],
            [29.155647307327712, -2.948944239515021],
            [29.156146434655781, -2.949015928414222],
            [29.156835705685076, -2.949254888066256],
            [29.15726352923744, -2.94963722538816],
            [29.157952800266735, -2.950330209920517],
            [29.158261783893575, -2.950688650304421],
            [29.158499463744711, -2.950975401804697],
            [29.158879751147197, -2.951238257581767],
            [29.159236270923877, -2.951596697668939],
            [29.159473950775013, -2.951811762026252],
            [29.160091918028627, -2.952146305394348],
            [29.160305829355661, -2.952433057416616],
            [29.160662349132377, -2.953771230421207],
            [29.160709885282248, -2.954535900879061],
            [29.160709885282248, -2.955515633530394],
            [29.161185244984512, -2.956351989383547],
            [29.161375388685776, -2.956949386675507],
            [29.161708139938355, -2.957403407857429],
            [29.162183499640616, -2.957690158503421],
            [29.16265885934288, -2.95800080457549],
            [29.163205521922528, -2.958430929829876],
            [29.163585810223342, -2.958622096455006],
            [29.163989865251601, -2.958693783817923],
            [29.164393921178192, -2.958932742262453],
            [29.164988119907708, -2.959243387981684],
            [29.165463479609972, -2.959434554464808],
            [29.166033910713718, -2.959625720914524],
            [29.166556806565858, -2.95976909550409],
            [29.167174773819475, -2.959721304578412],
            [29.167816508698898, -2.959673512747498],
            [29.168220564625486, -2.959673512747498],
            [29.168482012102427, -2.959816887330792],
            [29.168268100775393, -2.960318699127474],
            [29.168006652400123, -2.96072492802916],
            [29.167721437297416, -2.961155052212157],
            [29.167578829746066, -2.961537384476521],
            [29.167388685146509, -2.961895821191516],
            [29.166913326342573, -2.963018921414675],
            [29.166461734266079, -2.963664105819577],
            [29.166414199014504, -2.964165915849499],
            [29.166485502790181, -2.964691621906852],
            [29.166461734266079, -2.966244841433223],
            [29.166604342715765, -2.966818337106501],
            [29.166913326342573, -2.967439623971453],
            [29.167293613745059, -2.968132598129069],
            [29.167982884774357, -2.968682196639611],
            [29.168125492325707, -2.968849466206987],
            [29.168315636026964, -2.968992839585385],
            [29.168624620552073, -2.969184005264771],
            [29.169147515505916, -2.969446856664494],
            [29.169171283131721, -2.969972559273745],
            [29.169123747880143, -2.970354888449027],
            [29.168933604178882, -2.970593844341251],
            [29.168505780626528, -2.970593844341251],
            [29.168006652400123, -2.970593844341251],
            [29.167459989820514, -2.970785008836643],
            [29.1670797015197, -2.971023964634519],
            [29.166604342715765, -2.971454084758009],
            [29.166342894340527, -2.971788623016137],
            [29.166342894340527, -2.972170951554074],
            [29.166842022566893, -2.972863921799824],
            [29.167008397744016, -2.973174563553222],
            [29.167174773819475, -2.973819741948949],
            [29.167364917520736, -2.974345443350505],
            [29.168006652400123, -2.974918934760046],
            [29.168291868401166, -2.975301262198452],
            [29.1685533158781, -2.975707485518977],
            [29.169313891581368, -2.976806676422606],
            [29.169456499132725, -2.977666911928333],
            [29.169575339058309, -2.977977552310161],
            [29.169908090310887, -2.978144819546051],
            [29.170288378611708, -2.978527146753269],
            [29.170383450013151, -2.979052844975988],
            [29.170644897490092, -2.979698019884059],
            [29.170787505939739, -2.980558253100779],
            [29.170906345865323, -2.981131742135438],
            [29.171120257192353, -2.981490171499357],
            [29.171429240819165, -2.981872497529007],
            [29.171880831997324, -2.982398194132263],
            [29.172094744222655, -2.983067262907024],
            [29.17211851184846, -2.983927493453593],
            [29.171975904297103, -2.984500979804602],
            [29.171714456820169, -2.985026676037272],
            [29.170906345865323, -2.985767428771337],
            [29.169290123057266, -2.987129456612619],
            [29.169147515505916, -2.98753567460401],
            [29.168577084402202, -2.988085264205639],
            [29.168577084402202, -2.988539272403991],
            [29.168220564625486, -2.989041070955266],
            [29.167555061221961, -2.990259724127608],
            [29.167555061221961, -2.990665941847875],
            [29.167555061221961, -2.991215529860602],
            [29.167436221296413, -2.991550061125797],
            [29.167008397744016, -2.992051858281241],
            [29.166414199014504, -2.992673130713356],
            [29.166247822939045, -2.993151032619243],
            [29.166247822939045, -2.993628934313941],
            [29.166437966640306, -2.993939570121597],
            [29.166580574191663, -2.994226310232115],
            [29.167055933893927, -2.994489156470779],
            [29.167436221296413, -2.994967056670756],
            [29.167792741073097, -2.995516642497448],
            [29.167935348624447, -2.995922858242935],
            [29.167935348624447, -2.996472443583474],
            [29.16833940455107, -2.997022028644314],
            [29.168672155803652, -2.997284873299672],
            [29.169099979356041, -2.997452137554479],
            [29.169931858834989, -2.997452137554479],
            [29.170668666014194, -2.997571612522358],
            [29.171096489566548, -2.996448548024754],
            [29.171595616894617, -2.995946752910184],
            [29.172308655549688, -2.995421062884225],
            [29.173116767402895, -2.994871477008921],
            [29.173520822431154, -2.99453694586811],
            [29.173829806057967, -2.994202415526828],
            [29.174590380862938, -2.993843989465775],
            [29.175041972939432, -2.993366087866137],
            [29.175493564117595, -2.993174927347737],
            [29.175992691445632, -2.992935976426478],
            [29.176563123447671, -2.992649235973744],
            [29.177181090701293, -2.99233859979544],
            [29.177561378103778, -2.992099648689378],
            [29.177941665506296, -2.992434179681211],
            [29.177941665506296, -2.993031557162577],
            [29.177941665506296, -2.993605038692361],
            [29.178060505431848, -2.99405904547791],
            [29.178369489058657, -2.994417470564581],
            [29.178797312611053, -2.994752001742375],
            [29.178963688686505, -2.994919267292456],
            [29.17943904749044, -2.995062637227268],
            [29.179652959715799, -2.995182112459476],
            [29.179890639566935, -2.995277692093831],
            [29.180508606820549, -2.995612223005349],
            [29.180817590447361, -2.995707802601703],
            [29.181197877849847, -2.995851173334986],
            [29.181554397626531, -2.996066228044596],
            [29.182077292580367, -2.996281283614532],
            [29.182457579982852, -2.996376863151677],
            [29.182766563609665, -2.996878658066407],
            [29.183075547236506, -2.997356558112509],
            [29.183384530863318, -2.997691087477056],
            [29.18350337078887, -2.997858352572026],
            [29.183693514490127, -2.998121197023815],
            [29.183907426715457, -2.998360146798306],
            [29.184121338042488, -2.998766361474172],
            [29.184382786417721, -2.999076995804409],
            [29.18469177004453, -2.999698264196636],
            [29.185000753671339, -3.000008898258599],
            [29.1851908973726, -3.000343426801074],
            [29.185571184775085, -3.000725745266284],
            [29.185666256176535, -3.001227538159097],
            [29.185690024700637, -3.002087754261647],
            [29.185428577223735, -3.0023505985861],
            [29.185333504923957, -3.002637336462431],
            [29.185072057447016, -3.003091339449126],
            [29.184763073820207, -3.003569235839905],
            [29.184454090193395, -3.003999343042557],
            [29.18426394649217, -3.004477239933727],
            [29.184192641818164, -3.004979031080059],
            [29.18433525026785, -3.005887033985474],
            [29.1844303216693, -3.006221560703354],
            [29.184644233894659, -3.006651666846843],
            [29.185024521297144, -3.00712956256094],
            [29.185119593596923, -3.008037563652471],
            [29.184905681371564, -3.00818093184313],
            [29.185167128848498, -3.008873879032683],
            [29.185666256176535, -3.009256194470118],
            [29.186165384402898, -3.009542931410591],
            [29.186688279356744, -3.009542931410591],
            [29.187852910088335, -3.009471247408413],
            [29.18794798238811, -3.009041142391947],
            [29.188613484893306, -3.008945563074668],
            [29.189397828222386, -3.008873879032683],
            [29.190301011477004, -3.008802194985914],
            [29.191204193833332, -3.008778300603669],
            [29.192297520789218, -3.008778300603669],
            [29.193390847745132, -3.008730510934375],
            [29.19415142255011, -3.009327878486621],
            [29.194365334775433, -3.009829668274552],
            [29.194365334775433, -3.010403140870094],
            [29.194365334775433, -3.010952718825728],
            [29.194365334775433, -3.011717348086302],
            [29.194389102401239, -3.012266925369949],
            [29.194412870925341, -3.012601450103507],
            [29.194603014626569, -3.012840396665065],
            [29.194864462103503, -3.013318289628644],
            [29.195268517131762, -3.01377228720524],
            [29.195506196982898, -3.014536915362073],
            [29.195743876834026, -3.014943123030478],
            [29.196005324310967, -3.015468804429932],
            [29.196005324310967, -3.015970590446526],
            [29.196314307937776, -3.016663532612113],
            [29.196551987788904, -3.01714142387374],
            [29.19678966764004, -3.017332580138187],
            [29.197122419790951, -3.017595419833228],
            [29.19764531474479, -3.017977732166175],
            [29.198073138297183, -3.018264466778023],
            [29.199023857701707, -3.019196352608026],
            [29.199285305178616, -3.019506981038029],
            [29.199570520281327, -3.019841503514589],
            [29.200045879983588, -3.020104343497686],
            [29.200331095984627, -3.020391076637612],
            [29.200640079611436, -3.020821177106699],
            [29.201162974565278, -3.021394643829233],
            [29.201543261967764, -3.021657483431338],
            [29.201994854044223, -3.021968111147828],
            [29.202303837671032, -3.022326527840251],
            [29.202612821297873, -3.022565471332141],
            [29.202802964999101, -3.022708838485392],
            [29.203230788551494, -3.022899993756769],
            [29.203539772178306, -3.023091148993999],
            [29.203848755805115, -3.023234515173784],
            [29.204347883133146, -3.023330093218345],
            [29.204680634385763, -3.023306198256463],
            [29.205108457938124, -3.022971676861852],
            [29.205322370163486, -3.022708838485392],
            [29.205488746238938, -3.022422105062804],
            [29.205488746238938, -3.022135371563412],
            [29.205488746238938, -3.021848638890354],
            [29.205298601639381, -3.021538011139209],
            [29.205155994088024, -3.021394643829233],
            [29.204704402909865, -3.02115570007613],
            [29.204514259208604, -3.020868966237729],
            [29.204704402909865, -3.020725599741301],
            [29.204870778985317, -3.020534444081884],
            [29.205251066387802, -3.020367182513246],
            [29.205702657565972, -3.020677810603897],
            [29.206059177342652, -3.020988438604474],
            [29.206391928595266, -3.021251277403158],
            [29.207033664372982, -3.021920322065816],
            [29.207318879475689, -3.022207055622789],
            [29.207770471552188, -3.022469894122399],
            [29.208626118656937, -3.022374316001034],
            [29.208982637535325, -3.022350421920916],
            [29.209553069537368, -3.0222309497061],
            [29.210147268266887, -3.022159266551439],
            [29.211097987671412, -3.022159266551439],
            [29.212191313728969, -3.021992005236482],
            [29.212785513356813, -3.02194421615554],
            [29.213165800759299, -3.021633588432116],
            [29.213926376462606, -3.021131805065725],
            [29.214330431490865, -3.021107910957899],
            [29.214805791193129, -3.021107910957899],
            [29.215328686146965, -3.021179594182926],
            [29.215685205923684, -3.021466327938149],
            [29.216089261850271, -3.021657483431338],
            [29.21649331687853, -3.021872532981693],
            [29.216968676580795, -3.022135371563412],
            [29.217681716134226, -3.022374316001034],
            [29.218252147237937, -3.022493788199871],
            [29.218988954417142, -3.022493788199871],
            [29.219701993970538, -3.022493788199871],
            [29.22055764017696, -3.022398210983717],
            [29.221437055805811, -3.021992005236482],
            [29.222482846611818, -3.0216813775269],
            [29.223718781119061, -3.020821177106699],
            [29.224384284522582, -3.020295499233856],
            [29.225525146730046, -3.020223815949695],
            [29.225762826581175, -3.020223815949695],
            [29.226024274058076, -3.020223815949695],
            [29.226309490059119, -3.020367182513246],
            [29.226761081237282, -3.020653916485905],
            [29.22707006486409, -3.02091675536666],
            [29.227497888416487, -3.021370749727245],
            [29.227854408193167, -3.021896427975584],
            [29.227949480492942, -3.0222309497061],
            [29.228044551894424, -3.023019465896918],
            [29.228187159445781, -3.023760192507154],
            [29.228305999371333, -3.024453129635811],
            [29.228377304045338, -3.025002700392081],
            [29.22863875152224, -3.025600058882814],
            [29.228995271298956, -3.026030157259172],
            [29.229446862477118, -3.026197417943081],
            [29.229803382253799, -3.026197417943081],
            [29.230373813357549, -3.026149629049893],
            [29.231063084386847, -3.026006263260705],
            [29.231657284014659, -3.025982369261679],
            [29.23194249911737, -3.025982369261679],
            [29.232489162595339, -3.025862897452269],
            [29.233582489551221, -3.025552270866046],
            [29.234152920654935, -3.025552270866046],
            [29.234913496358242, -3.025313327137879],
            [29.235365087536401, -3.025002700392081],
            [29.236030590939901, -3.025002700392081],
            [29.236601022043644, -3.025337221151854],
            [29.236981309446129, -3.025719530721548],
            [29.236981309446129, -3.026030157259172],
            [29.236791165744872, -3.026364678600782],
            [29.236601022043644, -3.026914248374948],
            [29.236363342192508, -3.027368240191395],
            [29.236125662341379, -3.028204541399361],
            [29.236125662341379, -3.028825792940449],
            [29.236125662341379, -3.029494831962992],
            [29.235911751014349, -3.029853246133325],
            [29.234818424058464, -3.030785121871402],
            [29.234010313103585, -3.031382478033434],
            [29.23317843452293, -3.031501949225714],
            [29.232227715118405, -3.031693102924968],
            [29.232156411342729, -3.032218775195658],
            [29.232156411342729, -3.032577188451632],
            [29.232180178968534, -3.033031178764338],
            [29.232251482744211, -3.03343737941364],
            [29.232726842446475, -3.033939157004067],
            [29.233059594597385, -3.034464829071354],
            [29.233344809700093, -3.034751558359704],
            [29.233796401776551, -3.035157759256988],
            [29.234224225328944, -3.035492276836257],
            [29.234747120282787, -3.035802900531228],
            [29.235270016134923, -3.035802900531228],
            [29.235531463611864, -3.035802900531228],
            [29.235983054790022, -3.035802900531228],
            [29.236434645968185, -3.035802900531228],
            [29.236743629594994, -3.035802900531228],
            [29.237432901522627, -3.03577900675138],
            [29.237718116625334, -3.03577900675138],
            [29.237979565000565, -3.035874583673701],
            [29.238193476327599, -3.035898477451374],
            [29.238716372179738, -3.035898477451374],
            [29.239215499507807, -3.035922371228512],
            [29.239833466761421, -3.035994053459846],
            [29.240427665490937, -3.03597015968431],
            [29.240831721417525, -3.03597015968431],
            [29.24106940126866, -3.036185207257302],
            [29.241330848745562, -3.036710877314224],
            [29.241829976073632, -3.03709318281151],
            [29.241853744597734, -3.037690535440874],
            [29.24166359999818, -3.038311781458916],
            [29.241021865118753, -3.038813556754929],
            [29.240451434015039, -3.039554272408001],
            [29.240071146612554, -3.039936576884813],
            [29.239762162985745, -3.040892338379344],
            [29.239928538162868, -3.041394112459139],
            [29.240213754163907, -3.041704734432997],
            [29.240712881491941, -3.041943674490104],
            [29.241473456296912, -3.042469341704412],
            [29.241616064746601, -3.042612705280863],
            [29.241972583624989, -3.042803857890153],
            [29.242257799626024, -3.043018903179926],
            [29.242970839179424, -3.04352067625679],
            [29.243279822806233, -3.043711827799806],
            [29.244016629985399, -3.043711827799806],
            [29.24477720479037, -3.043855192111854],
            [29.24506242079141, -3.044285283125788],
            [29.245680388045027, -3.045002100493718],
            [29.246036907821715, -3.045503872634519],
            [29.246298355298649, -3.045957857436329],
            [29.246583570401356, -3.046364053154194],
            [29.247367913730432, -3.046722461648992],
            [29.247534289805884, -3.046865824651836],
            [29.247867041058502, -3.047128657074513],
            [29.248104720909634, -3.047319808871667],
            [29.248556312087796, -3.047630429114045],
            [29.249007904164259, -3.047964942772288],
            [29.249435727716648, -3.048251669326251],
            [29.249649639043678, -3.048466713513619],
            [29.249958622670491, -3.048633970675712],
            [29.250386446222851, -3.048896802660707],
            [29.250861805925116, -3.049111847620466],
            [29.250980645850699, -3.049183528963013],
            [29.251218325701828, -3.049326891633565],
            [29.251646149254221, -3.049541935603115],
            [29.251955132881033, -3.049876449562098],
            [29.252359187909292, -3.050234856871224],
            [29.252715707686004, -3.050688838747191],
            [29.25316729886417, -3.051262289402822],
            [29.253713962342108, -3.052122465256432],
            [29.254070482118788, -3.052552552921611],
            [29.254260625820056, -3.052934852721277],
            [29.25428439434415, -3.053508303065328],
            [29.254118018268699, -3.053962283539891],
            [29.254118018268699, -3.054440158083873],
            [29.253500051015077, -3.054989713362406],
            [29.253000923687008, -3.055372012282904],
            [29.252287884133608, -3.055825991958893],
            [29.252121508058156, -3.056136609709942],
            [29.252121508058156, -3.056710057417975],
            [29.252097740432383, -3.057689697098362],
            [29.252097740432383, -3.058239250690515],
            [29.252097740432383, -3.058669335872152],
            [29.252002668132604, -3.058956059530436],
            [29.251788756805578, -3.059338357018603],
            [29.251123253402049, -3.059696761126945],
            [29.250220070147392, -3.060389674850219],
            [29.249958622670491, -3.060628610698447],
            [29.24976847896923, -3.060867546492682],
            [29.249483263866523, -3.061106481329876],
            [29.249459495342421, -3.06141709753085],
            [29.249459495342421, -3.062325052403832],
            [29.249625871417873, -3.062635668246714],
            [29.249792247493335, -3.062850710416897],
            [29.250029926446167, -3.06308964480576],
            [29.250291374821401, -3.063304686883555],
            [29.250552822298307, -3.063448047642376],
            [29.250956877326598, -3.063543622072823],
            [29.251384700878951, -3.063782557208047],
            [29.251717453029897, -3.06402149228924],
            [29.252454260209067, -3.064403787945496],
            [29.252573100134651, -3.064475468252772],
            [29.253214835014038, -3.064642722886159],
            [29.253500051015077, -3.064762190336199],
            [29.254355698119831, -3.064762190336199],
            [29.254902361597772, -3.064809976589985],
            [29.255639168776941, -3.064809976589985],
            [29.256447279731816, -3.065120591702216],
            [29.256946407059893, -3.065574568096306],
            [29.257255390686694, -3.066171903781189],
            [29.257397998238051, -3.066984280456422],
            [29.257326694462378, -3.067247108787544],
            [29.257184086911021, -3.067772763447262],
            [29.256803798610207, -3.068298418748102],
            [29.25673249483453, -3.068800179848205],
            [29.256708727208757, -3.069588661481635],
            [29.256922638535787, -3.070209888801031],
            [29.257421766762153, -3.070807221861014],
            [29.257683214239059, -3.0716434888405],
            [29.258158573941319, -3.072097461523862],
            [29.258515092819703, -3.072455861300301],
            [29.258538861343805, -3.073005407206733],
            [29.258586396595387, -3.074200070721012],
            [29.258182341567124, -3.074486790160049],
            [29.257136550761111, -3.074367323811868],
            [29.25673249483453, -3.074367323811868],
            [29.256114527580909, -3.074391216721351],
            [29.255710472552618, -3.074558469781852],
            [29.255520328851393, -3.074845189123298],
            [29.255282649000257, -3.075203587061453],
            [29.255068736774895, -3.0756336653292],
            [29.255068736774895, -3.076135422935515],
            [29.255068736774895, -3.076876112470037],
            [29.255401488925809, -3.077497335490162],
            [29.255853080103968, -3.077855733427847],
            [29.25606699232933, -3.078214131243374],
            [29.256352207432037, -3.078907032798519],
            [29.256352207432037, -3.079432682541086],
            [29.256328439806239, -3.080077796830864],
            [29.255734240178423, -3.08086627001618],
            [29.255021201523324, -3.081630848962186],
            [29.255021201523324, -3.082180390074466],
            [29.255021201523324, -3.083064433437102],
            [29.255235112850354, -3.083590081099153],
            [29.255520328851393, -3.083972369649986],
            [29.255829312478202, -3.084259086423261],
            [29.25616206373078, -3.084545802215131],
            [29.2565661196574, -3.084760839910668],
            [29.257112783135344, -3.084999770230431],
            [29.257659445714953, -3.085238700495832],
            [29.25842002141826, -3.085262593158148],
            [29.259251899998908, -3.085023662898217],
            [29.259442043700133, -3.085453737146303],
            [29.259679723551269, -3.086146633924179],
            [29.259513348374146, -3.086576707711732],
            [29.258919148746291, -3.087197924993132],
            [29.257944661715992, -3.087389068628525],
            [29.257421766762153, -3.087819141906414],
            [29.256970174685659, -3.088297001097795],
            [29.255924383879652, -3.088798752653016],
            [29.255353952775938, -3.089372182578618],
            [29.255044969149129, -3.089850041061689],
            [29.2543794657456, -3.089706683900876],
            [29.253690194716302, -3.089706683900876],
            [29.253119763612592, -3.089802255042616],
            [29.252549331610549, -3.089993398202911],
            [29.252405752082037, -3.090412283593407],
            [29.252405752082037, -3.0907467845835],
            [29.252405752082037, -3.091176856483],
            [29.252572128157492, -3.091511356325779],
            [29.253499079037923, -3.092586535409519],
            [29.25404574251586, -3.093590034168618],
            [29.254212117693019, -3.094187353928552],
            [29.254188350067217, -3.095119172939809],
            [29.254021973991758, -3.095477564854541],
            [29.253451542888047, -3.095453672425233],
            [29.25226314453068, -3.095119172939809],
            [29.250528082695411, -3.095143066279774],
            [29.248674180036218, -3.095214744490314],
            [29.248103748932476, -3.095429779995428],
            [29.247034190500692, -3.0958120642253],
            [29.246986654350817, -3.096242134042555],
            [29.246986654350817, -3.096719988485202],
            [29.24727187035182, -3.097078379851034],
            [29.247628389230211, -3.097436771093982],
            [29.248460268709191, -3.097819054589768],
            [29.24929214728984, -3.098153553211086],
            [29.249767506992104, -3.098320801578539],
            [29.250171562918691, -3.098535836444566],
            [29.251217353724705, -3.099228724561461],
            [29.251882857128194, -3.099706578541007],
            [29.252500824381816, -3.100088861205982],
            [29.252904879410107, -3.100399465881058],
            [29.253261399186787, -3.100757855984324],
            [29.253712990364949, -3.101140138264273],
            [29.254259653842894, -3.10154631269466],
            [29.254426029918346, -3.102645373718876],
            [29.254235886217121, -3.103409937658567],
            [29.253594150439405, -3.103959466430523],
            [29.252833575634426, -3.103983359568204],
            [29.251930392379769, -3.104126714770611],
            [29.251597641127191, -3.104341748440214],
            [29.25133619365025, -3.104843492292882],
            [29.250813297798118, -3.105631945914442],
            [29.250718226396636, -3.106444292923738],
            [29.250908370097896, -3.106683217384944],
            [29.251264888976277, -3.107065498395471],
            [29.251597641127191, -3.107447778362699],
            [29.251716481052743, -3.107830058189614],
            [29.251455033575834, -3.108116768419228],
            [29.251193585200603, -3.108451262834771],
            [29.251146049949028, -3.109215821611442],
            [29.251241121350471, -3.109789241228397],
            [29.251764017202643, -3.110195412287637],
            [29.252453288231941, -3.109860918432558],
            [29.25311879163543, -3.109860918432558],
            [29.253570382813596, -3.11005205792047],
            [29.254259653842894, -3.110290982456776],
            [29.254758781170963, -3.1107449383828],
            [29.25575703582707, -3.111246679150343],
            [29.256066020352208, -3.111748419675858],
            [29.256279931679241, -3.11270411593332],
            [29.256493843006265, -3.113396994628877],
            [29.257016738858407, -3.11373148734673],
            [29.257872385963154, -3.113755380260105],
            [29.259179624246073, -3.113827057190905],
            [29.260415558753344, -3.113874842109736],
            [29.26079584615583, -3.114185442673856],
            [29.26105729453106, -3.114782750634378],
            [29.260867150829803, -3.115284489453194],
            [29.260439327277446, -3.115403951127028],
            [29.259987735200951, -3.115165028668643],
            [29.25936976794733, -3.115021674083672],
            [29.258442817066907, -3.115308382330859],
            [29.256921666558629, -3.116287967266865],
            [29.256161091753658, -3.117004735508099],
            [29.255828340501072, -3.11788875028517],
            [29.254972693396322, -3.119632883899865],
            [29.254830084946637, -3.120277973350541],
            [29.254758781170963, -3.123455632817504],
            [29.253831830290533, -3.124626346864659],
            [29.252643431933166, -3.125319217599097],
            [29.251050977649246, -3.125247541462279],
            [29.250337938095853, -3.124865267143741],
            [29.249482291889393, -3.124100719889406],
            [29.248365196409409, -3.123264494893738],
            [29.247628389230211, -3.123216711310308],
            [29.247248101827726, -3.123575093550467],
            [29.24701042197659, -3.124267964988126],
            [29.247034190500692, -3.125199757067298],
            [29.247176798052042, -3.125701490847073],
            [29.247580853978633, -3.126155440032815],
            [29.248127516558281, -3.126896094062894],
            [29.248911859887354, -3.127612855872412],
            [29.249696203216427, -3.128496860697997],
            [29.249933883067563, -3.129022485440895],
            [29.249815043141979, -3.129739244874144],
            [29.249529827140975, -3.130121516489159],
            [29.249030699812906, -3.130647140406283],
            [29.248650412410413, -3.1304560047136],
            [29.247818532931468, -3.129309188912619],
            [29.246986654350817, -3.128305724607884],
            [29.245845791245031, -3.128114588482506],
            [29.24499014503861, -3.128114588482506],
            [29.244609856737789, -3.128401293108835],
            [29.244110729409719, -3.128950808657533],
            [29.243991889484175, -3.129548109013667],
            [29.244110729409719, -3.130145409024774],
            [29.244491016812205, -3.130862167679665],
            [29.244633625261891, -3.131363898713247],
            [29.244633625261891, -3.13220011716332],
            [29.244395945410762, -3.132534603812038],
            [29.244229569335303, -3.134159254159146],
            [29.243944354232596, -3.13468487511908],
            [29.243754209633039, -3.135067144904246],
            [29.243587834455884, -3.135975035753884],
            [29.243730442007234, -3.136691791266183],
            [29.243991889484175, -3.137121844153955],
            [29.244443481560634, -3.137790814153728],
            [29.244443481560634, -3.138698702606564],
            [29.24415826555963, -3.139152646081684],
            [29.24380174578291, -3.139511022795998],
            [29.243231314679196, -3.139773831946086],
            [29.242494507500002, -3.139582697943308],
            [29.241947844022054, -3.138985404294798],
            [29.240973356991756, -3.138818161577766],
            [29.240260318336652, -3.139152646081684],
            [29.239666118708804, -3.13955880652908],
            [29.239452207381774, -3.140610043581681],
            [29.239594814933131, -3.141446253635687],
            [29.239975102335617, -3.141947980425901],
            [29.240497998187788, -3.142521381011599],
            [29.240521765813593, -3.143118672610266],
            [29.240212782186784, -3.143859314469927],
            [29.240093942261201, -3.144719414083568],
            [29.240474229663686, -3.145149463620855],
            [29.240355389738134, -3.145842320579789],
            [29.240141478411108, -3.146105129017039],
            [29.239689886334613, -3.146559069227408],
            [29.239666118708804, -3.146965226753287],
            [29.239689886334613, -3.147490841180793],
            [29.239571046409029, -3.149043792559929],
            [29.238905543903833, -3.149521623559294],
            [29.238358880425888, -3.149808322232884],
            [29.237812216947951, -3.149808322232884],
            [29.237289321095812, -3.150166694333613],
            [29.237099177394551, -3.15031004404184],
            [29.236077155112678, -3.150429501665327],
            [29.235197739483787, -3.150763982395287],
            [29.235007595782562, -3.15097900637369],
            [29.234674844529952, -3.151409052389454],
            [29.234199484827684, -3.152125797154786],
            [29.234151948677813, -3.153344261746265],
            [29.234080644902136, -3.154729964144954],
            [29.233795429799429, -3.155160009492051],
            [29.233533981424191, -3.156378470480229],
            [29.233153694021706, -3.157095210871064],
            [29.231062112409717, -3.158958735708806],
            [29.230420377530297, -3.159054300461245],
            [29.228899227022019, -3.159102083285565],
            [29.228447635843857, -3.159436561187694],
            [29.228209955992725, -3.159914387346649],
            [29.228138652217048, -3.161180624506025],
            [29.228495171095432, -3.162446861002242],
            [29.228994299321798, -3.163139706280844],
            [29.229707337976897, -3.16361753071123],
            [29.230610521231554, -3.164238701775838],
            [29.23179891958889, -3.16466874313055],
            [29.232416886842504, -3.165289913556654],
            [29.232678334319441, -3.165743845274624],
            [29.232678334319441, -3.167177313342206],
            [29.232678334319441, -3.168132958205415],
            [29.232939782694675, -3.168586888660477],
            [29.232820942769091, -3.169160274352706],
            [29.231870223364563, -3.16947085824773],
            [29.231038344783911, -3.169781442951276],
            [29.230301537604745, -3.170211481070283],
            [29.22956473042554, -3.170784866753072],
            [29.229493426649867, -3.171262686705416],
            [29.229374586724283, -3.172122763319918],
            [29.229374586724283, -3.173054512016922],
            [29.22956473042554, -3.174368515906949],
            [29.229303282948607, -3.174750770904902],
            [29.228732850946567, -3.175109135173871],
            [29.228542707245339, -3.175563062525284],
            [29.228043579917269, -3.175754189818186],
            [29.227283005112291, -3.176064771705554],
            [29.225595478528593, -3.177139861845223],
            [29.225120119724625, -3.177784916106764],
            [29.224716063798038, -3.178597205307939],
            [29.224478383946909, -3.17931393101353],
            [29.224407080171229, -3.180389017722678],
            [29.224668527648138, -3.181440212858902],
            [29.225524174752916, -3.181870246960805],
            [29.226902717709805, -3.181798574773599],
            [29.227900972365912, -3.181511885071348],
            [29.228685315694985, -3.181511885071348],
            [29.229327050574412, -3.181679120816058],
            [29.23015892915506, -3.182085263492079],
            [29.230871968708456, -3.182730314619069],
            [29.231299792260852, -3.183255910661595],
            [29.231442399812202, -3.184068195494711],
            [29.231442399812202, -3.184856589321843],
            [29.23099080863404, -3.185501638690164],
            [29.230491681305971, -3.18650504700126],
            [29.229826177902442, -3.187126204116386],
            [29.228899227022019, -3.187747360851538],
            [29.227401845037875, -3.187627907593286],
            [29.225666782304273, -3.187532345518354],
            [29.225048815050624, -3.187795142331477],
            [29.224620991498259, -3.187604017301133],
            [29.224407080171229, -3.188081829358055],
            [29.224430847797002, -3.188679095241619],
            [29.224597223872454, -3.189371922684446],
            [29.224787367573715, -3.190016969184047],
            [29.224858671349395, -3.190542561455441],
            [29.224811136097816, -3.191307060049835],
            [29.224502152471004, -3.19259714837142],
            [29.223955488993067, -3.193815564615274],
            [29.223385056991027, -3.194914526994116],
            [29.222862162037185, -3.196324063873488],
            [29.222743322111601, -3.197279680445027],
            [29.22238680233492, -3.198211406072235],
            [29.2223656074841, -3.198413792400036],
            [29.22233926618501, -3.198665323096895],
            [29.22233926618501, -3.199334253695562],
            [29.222695785961729, -3.199716499295396],
            [29.222957233438631, -3.200600442707422],
            [29.223741576767704, -3.201149920362305],
            [29.224430847797002, -3.201484384443778],
            [29.225191423500302, -3.201508274408564],
            [29.226023302080954, -3.201508274408564],
            [29.227045325261162, -3.201173810335042],
            [29.22778213244036, -3.200648223581223],
            [29.228518939619534, -3.200934906970671],
            [29.229065603097471, -3.201245481152776],
            [29.229136906873148, -3.201794958457048],
            [29.228471403469658, -3.202320545517561],
            [29.227449380289453, -3.202917802100917],
            [29.227449380289453, -3.203132815070758],
            [29.227401845037875, -3.204303437928789],
            [29.22778213244036, -3.205617400450168],
            [29.228305027394203, -3.206071314148502],
            [29.229350818200182, -3.206166875376301],
            [29.230087625379383, -3.206620788827532],
            [29.231157184709495, -3.207552505842242],
            [29.231822688112985, -3.208101979714771],
            [29.232250510767049, -3.208699233780781],
            [29.232583262917963, -3.209177035876066],
            [29.232987317946254, -3.209511498201262],
            [29.23348644617262, -3.210037080341076],
            [29.233533981424191, -3.210658223009207],
            [29.233795429799429, -3.211374926028919],
            [29.234413397053043, -3.212688879338153],
            [29.23465107600585, -3.213333910959348],
            [29.234342092379041, -3.214122281075546],
            [29.233676589873845, -3.214647861712992],
            [29.232607030543768, -3.214791201428794],
            [29.231989063290147, -3.215030101511736],
            [29.231180952335269, -3.215818471202554],
            [29.231062112409717, -3.21639183017937],
            [29.230895736334261, -3.217371318239841],
            [29.231252256110942, -3.218565814121217],
            [29.23191775951447, -3.219879758041961],
            [29.231775151963113, -3.22059645449454],
            [29.231276024635047, -3.221098141346045],
            [29.230634288857324, -3.221456489201685],
            [29.22859024339521, -3.221743167574787],
            [29.228043579917269, -3.222005955484851],
            [29.226878949185704, -3.222913768803151],
            [29.226213445782214, -3.223821580397781],
            [29.226260981932089, -3.225039958919544],
            [29.226379821857666, -3.225661092321562],
            [29.22680764541003, -3.226497232415617],
            [29.227211701336618, -3.227381152320787],
            [29.227069092886964, -3.227739497933131],
            [29.226569965558895, -3.228432298545359],
            [29.226284750456184, -3.229077319156644],
            [29.225761854604052, -3.229937346594517],
            [29.22595199830528, -3.230821262563038],
            [29.226047070605055, -3.231346834460282],
            [29.226308518081993, -3.232159080574521],
            [29.226284750456184, -3.233281890320979],
            [29.226546197933125, -3.233998577195674],
            [29.227116629036839, -3.234309141168072],
            [29.227687060140582, -3.23473915273245],
            [29.228043579917269, -3.235360280121044],
            [29.228019812291496, -3.236459197141448],
            [29.228067348441364, -3.23791645402065],
            [29.228162419842846, -3.238322574944565],
            [29.22859024339521, -3.238895921053583],
            [29.229184443023055, -3.239493156798313],
            [29.22942212287419, -3.239851497170846],
            [29.230040090127812, -3.241093745208006],
            [29.230349073754613, -3.242025431124512],
            [29.230681825007231, -3.242909336407272],
            [29.231157184709495, -3.243626015474265],
            [29.231157184709495, -3.244605476906012],
            [29.231085880933819, -3.245226598159087],
            [29.231038344783911, -3.246038832990639],
            [29.231038344783911, -3.246444950609716],
            [29.230681825007231, -3.246970513385728],
            [29.230491681305971, -3.248093307384191],
            [29.230444145156095, -3.248833872465733],
            [29.230135161529255, -3.249383323709443],
            [29.230135161529255, -3.250267222468313],
            [29.230135161529255, -3.250721115949871],
            [29.230349073754613, -3.250912228980339],
            [29.23099080863404, -3.25115112044254],
            [29.231180952335269, -3.251724459176157],
            [29.231608775887661, -3.252226130410018],
            [29.231751383439011, -3.253563919732186],
            [29.232036599440018, -3.25401781170994],
            [29.232298046916956, -3.254495593085641],
            [29.232464422992411, -3.255379487303086],
            [29.23277340661922, -3.256263381637487],
            [29.2331299263959, -3.256884495616837],
            [29.232725870469313, -3.257601164624346],
            [29.232393119216734, -3.258150611025],
            [29.232440655366606, -3.25850894558811],
            [29.232440655366606, -3.25903450289405],
            [29.232702102843547, -3.259607837080873],
            [29.233106157871799, -3.26003783772946],
            [29.233510213798386, -3.260443948730325],
            [29.23358151757407, -3.261112838084487],
            [29.233938037350779, -3.261638394011759],
            [29.234413397053043, -3.262665614720285],
            [29.235292811783605, -3.26304783614971],
            [29.236124690364253, -3.263430058334733],
            [29.236790193767742, -3.263836167946929],
            [29.237859753097858, -3.264911165088337],
            [29.238525255603051, -3.265675606068369],
            [29.239000615305315, -3.266511712602178],
            [29.239761191008583, -3.267992814749728],
            [29.240426693513815, -3.268613921384439],
            [29.241211036842888, -3.269091695731509],
            [29.241757700320829, -3.269258916879062],
            [29.241436918221076, -3.270775027570153],
            [29.240733573286221, -3.271255367750872],
            [29.240282711540065, -3.271500068836837],
            [29.239768728772166, -3.271790086097594],
            [29.23931786702601, -3.272152605973932],
            [29.239137522147857, -3.272288551006139],
            [29.23892110811444, -3.272741702182429],
            [29.239002263713857, -3.273357986293166],
            [29.239200643169635, -3.274028647392973],
            [29.239561332027552, -3.274617742483557],
            [29.239894969917334, -3.275070891689214],
            [29.240345831663483, -3.275614671003362],
            [29.240724555997389, -3.276230953322543],
            [29.241004090154256, -3.277282257408412],
            [29.241004090154256, -3.27759039809578],
            [29.240521667897209, -3.278247462714565],
            [29.239335901603638, -3.27936673713128],
            [29.23837105708958, -3.279892388095842],
            [29.237685746732353, -3.280100835082939],
            [29.237027488241619, -3.280254904998654],
            [29.234890403367224, -3.280680863566069],
            [29.233646024696306, -3.28136058267054],
            [29.233231231207142, -3.282013113292345],
            [29.233050886329021, -3.282366567349333],
            [29.23257297271638, -3.28307347508313],
            [29.232212283858463, -3.2833362991611],
            [29.231554025367696, -3.28368068978652],
            [29.23047195699727, -3.284115708924251],
            [29.229633353628415, -3.284441973377174],
            [29.22929971573863, -3.284768237722123],
            [29.228966077848849, -3.285221382265723],
            [29.228776715681896, -3.285756093046579],
            [29.228713595558446, -3.287169902240008],
            [29.2286414572479, -3.287949308969393],
            [29.228659491825528, -3.289580623801622],
            [29.229038216159427, -3.290994427500401],
            [29.229822715795368, -3.294728310238751],
            [29.230282594830317, -3.296078666633637],
            [29.230715421998841, -3.297619339688989],
            [29.230904784165794, -3.299631274757511],
            [29.230814612175884, -3.301452887058776],
            [29.229912887785243, -3.302957301457806],
            [29.22907428531472, -3.304253270822853],
            [29.228443077792114, -3.305630802364797],
            [29.227874992189591, -3.306754576969591],
            [29.227442165021063, -3.307615532774633],
            [29.226991303274914, -3.308739305099961],
            [29.226315010206552, -3.310125893039281],
            [29.226351079361844, -3.311385602105212],
            [29.226684717251626, -3.312010924681537],
            [29.226919164964368, -3.313116566583632],
            [29.226594544363376, -3.313977516785403],
            [29.226026458760852, -3.314965342686217],
            [29.225566579725903, -3.315839884344827],
            [29.224908321235137, -3.31767506132476],
            [29.224412373044895, -3.318980072902102],
            [29.224637803468809, -3.319949768494247],
            [29.225205889969629, -3.321571967408326],
            [29.225196872680829, -3.323085413419255],
            [29.223853303832868, -3.325124482877095],
            [29.223312270096805, -3.325523233325075],
            [29.222500718594411, -3.326012609267122],
            [29.221743270824934, -3.326465735622109],
            [29.2212202707682, -3.32676479828686],
            [29.220435771132262, -3.327272297808844],
            [29.220165254264234, -3.327625735528862],
            [29.219921788364356, -3.328087922775528],
            [29.219777512641528, -3.328667922837145],
            [29.219822599085621, -3.329411046366529],
            [29.219921788364356, -3.329818857586777],
            [29.220147219686602, -3.330679793026868],
            [29.220354615532852, -3.331477290105489],
            [29.220444788421091, -3.332301974049742],
            [29.220345599142348, -3.332773221574456],
            [29.219741443486242, -3.333316968850839],
            [29.219263529873622, -3.333516341963335],
            [29.218578220414731, -3.333715715937723],
            [29.218037185780336, -3.333987588898628],
            [29.216594427653661, -3.334875708091136],
            [29.216179635062797, -3.335392266756499],
            [29.21558449759382, -3.336289446229905],
            [29.215241842415207, -3.336525068601329],
            [29.213772032422039, -3.337902555421938],
            [29.212789153330355, -3.339062541665079],
            [29.212554705617613, -3.33942503753272],
            [29.20438653674152, -3.345092557075847],
            [29.202943122844673, -3.347080459788734],
            [29.19819061907172, -3.347436889409468],
            [29.197487520275239, -3.347362509038283],
            [29.196935482176965, -3.357247615395729],
            [29.196935482176965, -3.384407674611069],
            [29.215901478921584, -3.45798556573218],
            [29.228208914845318, -3.538291592636145],
            [29.233062024540203, -3.548536568089999],
            [29.234921179648847, -3.558262354365246],
            [29.235871078891531, -3.563231512877823],
            [29.235193844388739, -3.604708989114271],
            [29.234187049449233, -3.666370541582712],
            [29.231205947958038, -3.74860754534406],
            [29.225149040985212, -3.830725401856947],
            [29.22584925439299, -3.896404414753596],
            [29.231064175839915, -3.95077752375731],
            [29.272313606350952, -3.974135524969515],
            [29.302131360423886, -4.001251351317178],
            [29.328880155075939, -4.056388509103901],
            [29.352515701566936, -4.112451412041147],
            [29.379044544620012, -4.201949353410809],
            [29.385934528526079, -4.266777389882691],
            [29.384884443773039, -4.32402533424823],
            [29.389075534629402, -4.378332407762302],
            [29.383999616692908, -4.433345436092976],
            [29.383202590050317, -4.443154329581525],
            [29.383066525827516, -4.444829757958955],
            [29.382839879084699, -4.447620580144415],
            [29.382043053664727, -4.457428493118297],
            [29.380786322260356, -4.472882971067984],
            [29.380197912274532, -4.480149631917113],
            [29.380183853640322, -4.48032478787951],
            [29.378433748617287, -4.501873385932031],
            [29.37040191525525, -4.581758310643351],
            [29.367922775276831, -4.597968260508127],
            [29.359633029308505, -4.652168356844178],
            [29.353350057701153, -4.740426272706232],
            [29.352262174535877, -4.79867624643313],
            [29.355239004537871, -4.858107295496493],
            [29.372075724564571, -5.007911856203008],
            [29.122520949367214, -5.008336455591257],
            [29.122529198596457, -5.00822890874504],
            [29.118790440028359, -5.008215424510971],
            [29.114595931082341, -5.008265314734183],
            [29.097490273425883, -5.008379044249107],
            [29.026354117991026, -5.008852002028783],
            [28.97163028610327, -5.009215840763136],
            [28.803514509013041, -5.010333579097649],
            [28.802143094187926, -5.008619310891234],
            [28.801987662287573, -5.007570144845415],
            [28.801392001999076, -5.001245760273729],
            [28.801067770368636, -5.000807793453045],
            [28.800453651497683, -4.999978248955776],
            [28.799265253140351, -4.998214390185098],
            [28.798005550109014, -4.997642327212841],
            [28.796817151751647, -4.995497085433605],
            [28.796650775676195, -4.994400625676619],
            [28.795723824795765, -4.993471017270938],
            [28.794796873915335, -4.993113475012942],
            [28.793656011707878, -4.992088520526507],
            [28.79056617454145, -4.99194550280099],
            [28.790563626020987, -4.991900765329979],
            [28.790518639289878, -4.991111236159899],
            [28.788736041304698, -4.991158908800035],
            [28.787841601352685, -4.991739325186578],
            [28.787523874423229, -4.99194550280099],
            [28.785598668886692, -4.994066920595272],
            [28.784980701633078, -4.994281445117166],
            [28.783221871273668, -4.992708260935851],
            [28.78237103554557, -4.991414871817659],
            [28.780963913586223, -4.989275844504635],
            [28.779418995452179, -4.987130574997324],
            [28.778301900870488, -4.986320138201778],
            [28.777565093691283, -4.985605046493942],
            [28.776091479332916, -4.983841148560089],
            [28.775675539593461, -4.982148756234001],
            [28.775425975929426, -4.980861581230494],
            [28.775235832228166, -4.979669750647033],
            [28.773619610318438, -4.976475632918119],
            [28.771337885005192, -4.974020442165815],
            [28.771266581229515, -4.973019294038756],
            [28.772264835885622, -4.972423371373253],
            [28.774166273796386, -4.971922796272297],
            [28.77499815237703, -4.971303036003608],
            [28.775616119630651, -4.970135024521754],
            [28.775758728080337, -4.967942018311307],
            [28.776875822661989, -4.967632136353785],
            [28.777565093691283, -4.966940859923486],
            [28.776709446586537, -4.96596353769044],
            [28.775402208303618, -4.965892026403718],
            [28.774380185123412, -4.966249583659683],
            [28.773667146468348, -4.965796678309532],
            [28.772573819512431, -4.965105400830273],
            [28.772312372035522, -4.965558306661502],
            [28.772977874540722, -4.966082723451182],
            [28.771908316108934, -4.967012371094959],
            [28.771480492556549, -4.967083883159467],
            [28.771028901378379, -4.966511791828786],
            [28.770506005526247, -4.966702488694602],
            [28.76965035842149, -4.967322253347712],
            [28.769341374794681, -4.966702488694602],
            [28.768961087392196, -4.966392606146668],
            [28.767867760436278, -4.966535629503141],
            [28.766512986003494, -4.965892026403718],
            [28.764492709065475, -4.965391446275742],
            [28.763446918259501, -4.964318773405174],
            [28.76290025478156, -4.963246097866082],
            [28.761545480348737, -4.96045713481679],
            [28.760570993318403, -4.960171087203785],
            [28.759905489914914, -4.96098155661597],
            [28.758764626809121, -4.961458302275068],
            [28.757647532227431, -4.961339116568714],
            [28.755888702766352, -4.961291441739466],
            [28.754557695959342, -4.960933881760603],
            [28.754866679586144, -4.960218761214054],
            [28.754248712332529, -4.959312941809402],
            [28.754153640931083, -4.958478632353247],
            [28.75351190515336, -4.956810011138026],
            [28.753297993826333, -4.955594298410243],
            [28.752608721898703, -4.954235558291618],
            [28.751824379467926, -4.9536157811888],
            [28.751871914719505, -4.952638439869563],
            [28.75175307569225, -4.951494232241687],
            [28.751491627317012, -4.950493049484889],
            [28.750683516362169, -4.950588399817892],
            [28.749661494080261, -4.948180787258836],
            [28.748924686901095, -4.94717959942147],
            [28.748710774675732, -4.946202247566442],
            [28.749209902003802, -4.944271377958878],
            [28.749091062078218, -4.94367542900777],
            [28.750303228959684, -4.944319054031659],
            [28.750992499988982, -4.945153380688482],
            [28.751562931092693, -4.944438243748006],
            [28.751539163466919, -4.942912614278412],
            [28.751990754645089, -4.94245969272434],
            [28.752703794198478, -4.94245969272434],
            [28.753488137527558, -4.943007966618739],
            [28.753892192555845, -4.942912614278412],
            [28.754747839660599, -4.942268988770823],
            [28.755318270764313, -4.941553847774096],
            [28.755983774167834, -4.940719515622916],
            [28.756649277571324, -4.940385783005],
            [28.757528692301886, -4.939694478604242],
            [28.758408107930737, -4.938860144081564],
            [28.759976793690587, -4.938812468511755],
            [28.759762882363557, -4.938145000259232],
            [28.758693323033444, -4.938216514586514],
            [28.758051588154057, -4.93671470936922],
            [28.758669555407671, -4.936047238977493],
            [28.757932748228473, -4.934974516989823],
            [28.757005797348043, -4.933353512622555],
            [28.757742604527209, -4.932876745550754],
            [28.757718836003114, -4.931947049303419],
            [28.757100868749493, -4.931041190707082],
            [28.756411597720195, -4.929157952647981],
            [28.757100868749493, -4.928156735708197],
            [28.757219708675077, -4.927084000804154],
            [28.756459133870106, -4.925462976923992],
            [28.755484646839765, -4.923698917239494],
            [28.756055077943518, -4.923603562088561],
            [28.757504924676081, -4.923722755574589],
            [28.757861444452793, -4.92348436858093],
            [28.758027820528252, -4.922650014322299],
            [28.758526947856321, -4.922197077859747],
            [28.759002306660257, -4.921338882643462],
            [28.759667810063778, -4.921005140156896],
            [28.760761137019664, -4.920790591519044],
            [28.76156924797451, -4.920552203460776],
            [28.762210982853929, -4.919646328230495],
            [28.762567502630617, -4.919574811877695],
            [28.763066629958686, -4.920027749247812],
            [28.763470685885274, -4.920003910778612],
            [28.764017349363211, -4.919241067593798],
            [28.76468285276674, -4.918740451750992],
            [28.765395891421804, -4.918740451750992],
            [28.76660805830327, -4.918549740896333],
            [28.768248048737092, -4.918215996992703],
            [28.768866015990714, -4.917763057472606],
            [28.768889783616519, -4.917000212587188],
            [28.767606312959376, -4.915951298973598],
            [28.767439936883925, -4.915212290629543],
            [28.767416169258119, -4.914854705474312],
            [28.768248048737092, -4.914163374163492],
            [28.768034136511773, -4.913495880832015],
            [28.766821969630303, -4.913329008069063],
            [28.766346610826336, -4.912876065182171],
            [28.766132698601009, -4.912280088599523],
            [28.765681107422839, -4.912017857795075],
            [28.764278796840152, -4.911779467456451],
            [28.763969813213343, -4.91094509743751],
            [28.763660829586531, -4.910849740436143],
            [28.762591271154712, -4.910039208970828],
            [28.761307800497608, -4.90815591160386],
            [28.760903744571021, -4.907655287323984],
            [28.759620273913871, -4.907035466173944],
            [28.757980284378377, -4.906940108606299],
            [28.756482901495872, -4.90534287405386],
            [28.754676535884926, -4.905509749742273],
            [28.753702048854585, -4.904794568695136],
            [28.752228434496217, -4.903888672668949],
            [28.752347274421769, -4.903507241394813],
            [28.752798866498264, -4.902982774496563],
            [28.752561186647128, -4.902362948950984],
            [28.751658003392471, -4.902243751594525],
            [28.7508974285875, -4.90179080198417],
            [28.750041781482746, -4.900884900928967],
            [28.749566421780482, -4.899669084517518],
            [28.749281205779475, -4.898548624660326],
            [28.750089317632654, -4.898381747209961],
            [28.750612212586496, -4.897904955677927],
            [28.750422068885232, -4.897595040591887],
            [28.749566421780482, -4.897261285166571],
            [28.749400045705027, -4.896665294460454],
            [28.748758310825632, -4.895616348465407],
            [28.747831359945177, -4.894591240193606],
            [28.748259183497566, -4.893876047307847],
            [28.74818787972189, -4.893542290903352],
            [28.74733223261714, -4.893399252521366],
            [28.747118320391778, -4.893160854548547],
            [28.747379767868715, -4.892231102172997],
            [28.747403536392817, -4.891396707416173],
            [28.747213392691556, -4.891039109340638],
            [28.746191369511347, -4.890204713979585],
            [28.746547889288067, -4.889656396042518],
            [28.746761800615094, -4.888726638736041],
            [28.746547889288067, -4.887773040486819],
            [28.746452816988281, -4.88662871987143],
            [28.745977458184317, -4.885389037496055],
            [28.745882385884538, -4.883839431260064],
            [28.745264418630917, -4.882838145439351],
            [28.745335722406598, -4.882146779678135],
            [28.745763545958994, -4.881717656142906],
            [28.744884131228432, -4.880621006645821],
            [28.743838340422457, -4.879834277989099],
            [28.742958925691902, -4.87921443072888],
            [28.742626173540987, -4.878117776185744],
            [28.742031974811471, -4.877068800772233],
            [28.741675455034759, -4.876115185728576],
            [28.7415090789593, -4.874970844964106],
            [28.741746758810432, -4.874970844964106],
            [28.742412262213957, -4.87416026947382],
            [28.743053997093352, -4.873826503125447],
            [28.743790804272546, -4.873302011780284],
            [28.74326790931871, -4.872968244999955],
            [28.742150813838727, -4.873445054505991],
            [28.741437775183623, -4.872610636969704],
            [28.741342702883845, -4.871204044054123],
            [28.741722991184659, -4.870083535989403],
            [28.741675455034759, -4.86932063602899],
            [28.74065343185455, -4.869272954527066],
            [28.740059233125031, -4.868772300802912],
            [28.739583873422767, -4.867699469350155],
            [28.739465033497215, -4.866531273670764],
            [28.73877576246792, -4.865506121274289],
            [28.738704457793915, -4.864409444069688],
            [28.739678944824249, -4.863551173768712],
            [28.740463288153322, -4.86343196942254],
            [28.741057487781138, -4.86307435625563],
            [28.740605895704679, -4.862549857316942],
            [28.740059233125031, -4.862120721104239],
            [28.73972648097412, -4.861262447847702],
            [28.739132281346304, -4.860523378372319],
            [28.73877576246792, -4.85990351307576],
            [28.737706203137812, -4.858711463012614],
            [28.737112004408292, -4.856971065850113],
            [28.736707948481705, -4.854896887376549],
            [28.737254611959642, -4.853037274030487],
            [28.736565340930348, -4.852298195420016],
            [28.735139262721855, -4.851487592275418],
            [28.735139262721855, -4.851082289882695],
            [28.735020422796303, -4.849532603580069],
            [28.734663903019591, -4.848936569080665],
            [28.732905072660177, -4.848698156032729],
            [28.730552043571286, -4.848817362116807],
            [28.729886540167762, -4.848102120787141],
            [28.72926857291414, -4.848006754737936],
            [28.728460461959262, -4.849031934996821],
            [28.727961334631225, -4.848841204051921],
            [28.726915543825218, -4.848173644864528],
            [28.726915543825218, -4.84776834045639],
            [28.727438438779053, -4.847100781095796],
            [28.728246550632232, -4.846004073565064],
            [28.728412925809394, -4.845503402332096],
            [28.728056406032675, -4.844907364230906],
            [28.727105687526475, -4.844430533366541],
            [28.726036129094695, -4.844192117806552],
            [28.725679609317975, -4.84385833642011],
            [28.725513233242523, -4.84276162355873],
            [28.725085409690163, -4.842189425181253],
            [28.724491210960643, -4.842666257647103],
            [28.72351672393031, -4.842165583909487],
            [28.72377817140725, -4.84195100882059],
            [28.722257020898972, -4.840854292825219],
            [28.721068622541608, -4.840210567889484],
            [28.720189207811085, -4.839471475064109],
            [28.718763128704257, -4.839519158700338],
            [28.7186205211529, -4.839256900010529],
            [28.718501681227355, -4.838517806129731],
            [28.717836177823827, -4.838517806129731],
            [28.717265746720113, -4.83820786332026],
            [28.715910972287297, -4.837325716920777],
            [28.715934739913102, -4.836658146214917],
            [28.715578221034711, -4.836038258726851],
            [28.713843158301078, -4.834870007528627],
            [28.713153887271783, -4.83420243527105],
            [28.713153887271783, -4.833630228661025],
            [28.712369544841039, -4.831722871860679],
            [28.711727809063316, -4.830387719495088],
            [28.711894185138775, -4.830173140624601],
            [28.712393312466805, -4.82943403670166],
            [28.712535920018162, -4.828384984599888],
            [28.712963743570555, -4.828265773968328],
            [28.713605479348274, -4.828075037093844],
            [28.713676783123955, -4.826978299236383],
            [28.713819390675305, -4.825976926987264],
            [28.714175910452024, -4.825762347604097],
            [28.71491271763119, -4.825976926987264],
            [28.715673292436161, -4.826382244613852],
            [28.716315028213884, -4.826382244613852],
            [28.717337050495797, -4.825047080694782],
            [28.717313282869991, -4.824641763161321],
            [28.71598227606297, -4.823211227087195],
            [28.716433868139468, -4.822352903796551],
            [28.71669531561637, -4.821709160156661],
            [28.716077348362749, -4.8199686665667],
            [28.715102861332447, -4.81863348987063],
            [28.713843158301078, -4.817822845901653],
            [28.711513897736282, -4.816392295278716],
            [28.709018260197709, -4.815128639977069],
            [28.707259429838299, -4.813841139114806],
            [28.707378269763851, -4.813125859490754],
            [28.707045518511265, -4.812505950227441],
            [28.706498855033328, -4.812458264667853],
            [28.706071031480935, -4.812792062612847],
            [28.705453064227314, -4.812744377073527],
            [28.705191616750412, -4.812124467458076],
            [28.703908146093269, -4.810813118448044],
            [28.703147571288298, -4.810622376609795],
            [28.70160265315425, -4.810956174565934],
            [28.701198597227663, -4.810455477118913],
            [28.699653679093611, -4.809477923541873],
            [28.697823544958531, -4.809096439053151],
            [28.696706450376841, -4.809215653091772],
            [28.695185195663999, -4.809978673983552],
            [28.695137763718694, -4.81000246503609],
            [28.695085849180099, -4.809910325955184],
            [28.694828780091882, -4.80945408110558],
            [28.694876316241785, -4.808762640173162],
            [28.695185299868594, -4.808476526071872],
            [28.696611378077062, -4.808118883499257],
            [28.696064715497446, -4.806807526673039],
            [28.695922107047767, -4.806139925573262],
            [28.697134273929233, -4.805376952591182],
            [28.697229345330676, -4.804327862877174],
            [28.697609633631497, -4.803517201645966],
            [28.697324417630455, -4.8029449688585],
            [28.696730218002646, -4.802515794399156],
            [28.696635146601164, -4.801585915615234],
            [28.696373699124255, -4.801037524822359],
            [28.695684427196632, -4.800799094726293],
            [28.695304139794146, -4.801180583920823],
            [28.694448492689396, -4.801013682086889],
            [28.693426470407484, -4.801204426650402],
            [28.692523287152859, -4.800965995712317],
            [28.692356911077407, -4.800155330431855],
            [28.692000392199017, -4.800012272016676],
            [28.690693153017772, -4.800536819991157],
            [28.690574313092227, -4.800369918898763],
            [28.689908810587035, -4.799487722732403],
            [28.689932578212801, -4.79898701674881],
            [28.690455473166644, -4.798438623839365],
            [28.69043170554087, -4.797484896564658],
            [28.689956345838606, -4.796650383303267],
            [28.690312865615287, -4.796125832302322],
            [28.690003881988478, -4.79529131735787],
            [28.689433450884763, -4.794313741755032],
            [28.68881548363111, -4.793622285270658],
            [28.688007372676271, -4.792620864215393],
            [28.68781722897501, -4.79157175463377],
            [28.68762708437545, -4.790403426072472],
            [28.688126212601816, -4.789878870211957],
            [28.688149980227621, -4.788853599532969],
            [28.687532012974007, -4.788019075590804],
            [28.687555780599773, -4.787065333580511],
            [28.687532012974007, -4.785777779053754],
            [28.687151725571514, -4.784680971309546],
            [28.687127957047419, -4.782105851613666],
            [28.685963326315854, -4.781724351631661],
            [28.685749414988827, -4.781247475900802],
            [28.685297823810661, -4.780579849492653],
            [28.685725647363022, -4.779936066807586],
            [28.685725647363022, -4.779196907686856],
            [28.685202751510882, -4.7789346245554],
            [28.684965071659747, -4.778123932808894],
            [28.685274055286555, -4.777360928136734],
            [28.68570187883892, -4.776836361249592],
            [28.686105934765507, -4.776836361249592],
            [28.687009117121836, -4.777289396517234],
            [28.687365636898548, -4.776693297892136],
            [28.68738940542265, -4.776049511508135],
            [28.687698389049459, -4.773951239256343],
            [28.68738940542265, -4.773092853196995],
            [28.6865337583179, -4.771590674524452],
            [28.684870000258265, -4.770136181976555],
            [28.684656088032941, -4.768514776442719],
            [28.684870000258265, -4.768204801387207],
            [28.685012607809622, -4.767370251971077],
            [28.685297823810661, -4.766440324809468],
            [28.686105934765507, -4.762553692082365],
            [28.686509989793798, -4.761933736381287],
            [28.687056653271735, -4.760717667437919],
            [28.687246796972964, -4.759835420437859],
            [28.687579549123875, -4.758953172291568],
            [28.689005627332378, -4.756735623863078],
            [28.689029394958144, -4.755996439445209],
            [28.688554036154208, -4.75571030300589],
            [28.687508245348202, -4.75535263251265],
            [28.686509989793798, -4.754518068197733],
            [28.685559271287563, -4.753373520129899],
            [28.684965071659747, -4.752205125680294],
            [28.684061889303425, -4.75213359140816],
            [28.683657833376799, -4.752538953385713],
            [28.683657833376799, -4.7528489355933],
            [28.683396385899897, -4.753516589307007],
            [28.682659578720699, -4.752944314220429],
            [28.682305346953022, -4.752710513859358],
            [28.680853212211417, -4.751752074562294],
            [28.679545973928498, -4.750726746190193],
            [28.679545973928498, -4.749892176198788],
            [28.67999756510666, -4.748938379639667],
            [28.68071060466006, -4.747841513206018],
            [28.681257268138005, -4.74660157440425],
            [28.681466878331463, -4.746353050323211],
            [28.68178016309184, -4.745981604156689],
            [28.682849722421956, -4.744169379504198],
            [28.683039866123185, -4.742524067220073],
            [28.683871744703829, -4.741164892736696],
            [28.683847977078063, -4.739567262998708],
            [28.682516970271045, -4.739972631554501],
            [28.68178016309184, -4.73961495279337],
            [28.681352339539483, -4.738899595609519],
            [28.681043355912674, -4.738971131271542],
            [28.680496693333033, -4.738351154083108],
            [28.680377853407482, -4.737349651419467],
            [28.679308294077366, -4.737540413902021],
            [28.679332062601468, -4.736944280403681],
            [28.679046846600432, -4.736801208647067],
            [28.677573232242061, -4.735895084722445],
            [28.677430624690704, -4.735442022759645],
            [28.677739608317513, -4.734893578454294],
            [28.677240480989475, -4.734416669847796],
            [28.677192944839575, -4.733748997419286],
            [28.677121641063898, -4.732413651505035],
            [28.677002801138347, -4.730863692589026],
            [28.676717585137311, -4.730482162938527],
            [28.676527441436086, -4.730672928241026],
            [28.6761471540336, -4.730649082130517],
            [28.674863683376451, -4.730553700383849],
            [28.674388323674187, -4.730029097384804],
            [28.674435859824094, -4.728956045811532],
            [28.674982523302035, -4.728407596298684],
            [28.675386579228622, -4.727596844313235],
            [28.674673539675222, -4.725736880084539],
            [28.674031804795803, -4.725593805079662],
            [28.673104853017044, -4.724902278621837],
            [28.671060807554962, -4.724735358026867],
            [28.669444585645234, -4.724592283713761],
            [28.668289102458186, -4.723814548348152],
            [28.667566915360243, -4.723328457212283],
            [28.667067788032206, -4.722255394224801],
            [28.667023148949109, -4.722124023140864],
            [28.666711269153826, -4.721206175995659],
            [28.665499102272356, -4.720562337129949],
            [28.664358239166564, -4.718988504841256],
            [28.664667222793408, -4.718463893875558],
            [28.664976206420217, -4.717653130110328],
            [28.66374027191295, -4.716079291138196],
            [28.66374027191295, -4.715363909329906],
            [28.663431288286141, -4.714505449453483],
            [28.663431288286141, -4.713790065101614],
            [28.663906647988405, -4.710761598035199],
            [28.662979697107975, -4.710117749359068],
            [28.662361729854361, -4.709235436060932],
            [28.662005210077673, -4.708329276543563],
            [28.659295661212031, -4.705706174232865],
            [28.656918863599042, -4.705849252487695],
            [28.656372201019394, -4.704704623812036],
            [28.655635393840228, -4.703321528059456],
            [28.65268816512345, -4.703345374219632],
            [28.65147599824202, -4.703965383107509],
            [28.650786727212726, -4.703655378733504],
            [28.650619164462764, -4.703638436413039],
            [28.6477206585704, -4.703345374219632],
            [28.647239459818767, -4.702913346524694],
            [28.646692796340826, -4.7019356382426],
            [28.646146132862885, -4.701458706692815],
            [28.645076574431101, -4.701601786733235],
            [28.644393314927679, -4.701611579203634],
            [28.643412815473173, -4.701625632953117],
            [28.64163021838629, -4.701530246266119],
            [28.640182694697053, -4.701161750012908],
            [28.640037764102374, -4.701124854951868],
            [28.639324724548974, -4.700409456659552],
            [28.638374006042742, -4.700504843502054],
            [28.63742328663821, -4.700981775713457],
            [28.636254575758631, -4.701200390863581],
            [28.636020976055516, -4.701244087928249],
            [28.634880113848059, -4.700957928569993],
            [28.634655223311601, -4.700487856039567],
            [28.634309682744313, -4.699765598281215],
            [28.633739250742266, -4.698764039205182],
            [28.633549107041009, -4.69781017137609],
            [28.63314505201275, -4.697595551473088],
            [28.632455780085124, -4.697619397831871],
            [28.631505061578927, -4.697714785061242],
            [28.630792022025528, -4.698072484800421],
            [28.630517673842807, -4.69832939218665],
            [28.619634959671487, -4.691325045348653],
            [28.613833200290454, -4.686106285550999],
            [28.607288040096059, -4.676608989272538],
            [28.598916600437491, -4.651404319643616],
            [28.598450399957866, -4.647742862476859],
            [28.594419839839375, -4.634993803895159],
            [28.588535999594225, -4.611395252751048],
            [28.583656560278353, -4.593147623718346],
            [28.578017880155695, -4.575176006058109],
            [28.571864760022645, -4.559008219333868],
            [28.567439279844049, -4.540623593923975],
            [28.558118160131695, -4.529202288809744],
            [28.552787279656304, -4.523391764126034],
            [28.552746600346978, -4.516251298554555],
            [28.553635440201479, -4.47937174848293],
            [28.554634440459274, -4.464217168659291],
            [28.553137559735049, -4.460062239818702],
            [28.550022860794822, -4.459191322597005],
            [28.535474188424349, -4.459734442579585],
            [28.526978707594701, -4.459660495577155],
            [28.513014892373093, -4.459538950663985],
            [28.503376216411191, -4.461016901381194],
            [28.493872632694995, -4.454600941322674],
            [28.49171659336811, -4.427332032099661],
            [28.491800832883857, -4.40849750915924],
            [28.480845324631808, -4.396711851304025],
            [28.47760388687972, -4.395228814815406],
            [28.445691360378905, -4.387251130701933],
            [28.416775108812693, -4.375126575474142],
            [28.406444103956275, -4.367273825804816],
            [28.402465842855303, -4.364249867858227],
            [28.403593721711982, -4.359873873412875],
            [28.397779727276784, -4.343332880755874],
            [28.396364568090572, -4.334825925927944],
            [28.399995884557455, -4.326985971054982],
            [28.397447806965818, -4.321704894981682],
            [28.399717604448739, -4.317092863204768],
            [28.397144685744568, -4.306059852617121],
            [28.393451089977379, -4.303796475915579],
            [28.384975977548489, -4.285564486400438],
            [28.378940223205618, -4.274408619519345],
            [28.373296061563106, -4.273143167764602],
            [28.368415800288759, -4.275551548025224],
            [28.358444783604348, -4.282032233035077],
            [28.349949812119455, -4.276714501470027],
            [28.307582531543606, -4.243138176590688],
            [28.292073385861215, -4.233010495652932],
            [28.263244252012953, -4.214352620525252],
            [28.242659470465089, -4.199636257511298],
            [28.224721046692508, -4.178023948605587],
            [28.217159972760133, -4.15936564053756],
            [28.215365012159999, -4.152917689073715],
            [28.21318595979217, -4.145090477813721],
            [28.210347359851138, -4.136630385635377],
            [28.205170560209933, -4.126567099249563],
            [28.198172160428832, -4.121301537581375],
            [28.19031501525356, -4.119044805031273],
            [28.185965279223062, -4.119193244829991],
            [28.181185203459069, -4.122973454497038],
            [28.174647102226199, -4.136288547891319],
            [28.185139226217025, -4.157324603988441],
            [28.184537601115068, -4.157792267329494],
            [28.182968915355218, -4.158913890455465],
            [28.18216080350204, -4.159558227008125],
            [28.181281388771485, -4.159796869973474],
            [28.180829797593322, -4.160226426946094],
            [28.180568350116417, -4.161037811490741],
            [28.180544581592315, -4.162350343492883],
            [28.180116758039922, -4.163567417116442],
            [28.178999663458235, -4.164736760371768],
            [28.179641398337658, -4.167266353949299],
            [28.180235597965506, -4.167075440697205],
            [28.181186317370038, -4.167075440697205],
            [28.182279643427588, -4.167242489344373],
            [28.18216080350204, -4.16855501085865],
            [28.180972405144676, -4.170201626208293],
            [28.180901101368999, -4.170655041023229],
            [28.181043708920352, -4.171275503351605],
            [28.180663421517867, -4.171967557664475],
            [28.180045454264246, -4.173590301357065],
            [28.17966516686176, -4.174306216187313],
            [28.179213575683594, -4.174831220817465],
            [28.179094735758046, -4.1759289558837],
            [28.178239088653264, -4.176430095091817],
            [28.17790633650235, -4.176597141723112],
            [28.177549816725669, -4.177408509145127],
            [28.177193297847285, -4.178076692805718],
            [28.176670401995111, -4.178243739081693],
            [28.17612373851717, -4.177933510770139],
            [28.175838523414463, -4.17776646442718],
            [28.175482003637782, -4.177981238418896],
            [28.175482003637782, -4.179198287507758],
            [28.17505418008539, -4.180200561366282],
            [28.174364909056091, -4.180343742982397],
            [28.174174765354866, -4.180892606801181],
            [28.174483748981675, -4.181513060927021],
            [28.175743451114684, -4.181417606964206],
            [28.17683677807057, -4.182157378701266],
            [28.178286623904839, -4.184615324088266],
            [28.178262856279066, -4.18549827432871],
            [28.177739961325226, -4.185832362736321],
            [28.177145761697378, -4.18619031502116],
            [28.176337650742532, -4.18619031502116],
            [28.175648379713238, -4.185880089897602],
            [28.175149251486868, -4.185402819956023],
            [28.174792732608488, -4.185617591826984],
            [28.174959107785611, -4.186214178140117],
            [28.175553307413459, -4.186906218191241],
            [28.17560084356333, -4.187598258524237],
            [28.17560084356333, -4.18817098024971],
            [28.17560084356333, -4.190294820169799],
            [28.175553307413459, -4.190891403771054],
            [28.174911572534036, -4.19158343962948],
            [28.174792732608488, -4.19249024482614],
            [28.174459980457573, -4.19289591984924],
            [28.173675638026797, -4.192967510385895],
            [28.173010134623272, -4.193062962921278],
            [28.172511007295238, -4.193158416346745],
            [28.172273327444106, -4.193325458459972],
            [28.172796222397945, -4.193802723502887],
            [28.172606078696685, -4.194518620513352],
            [28.171441447965123, -4.195234515957166],
            [28.170871016861412, -4.195544737320112],
            [28.170276817233564, -4.196308359229085],
            [28.169730153755623, -4.19723902164658],
            [28.169516242428589, -4.198169682939927],
            [28.169468706278717, -4.199840097894874],
            [28.169373634877235, -4.201605960703084],
            [28.169349866353134, -4.202918424751747],
            [28.169278562577457, -4.204278611682],
            [28.16918349117601, -4.205066086561899],
            [28.168945811324843, -4.205710384657099],
            [28.168613059173932, -4.206497858972704],
            [28.168422915472707, -4.20730919494738],
            [28.168232771771446, -4.207595548085815],
            [28.167971324294541, -4.208048941839984],
            [28.167091909563986, -4.208764824698787],
            [28.166402637636395, -4.209719335342179],
            [28.166117422533688, -4.210387491004639],
            [28.165998582608104, -4.211914703697154],
            [28.165047863203572, -4.212558996049443],
            [28.164406128324185, -4.21315556149123],
            [28.163859464846208, -4.213441913351909],
            [28.162980050115685, -4.213370325622234],
            [28.162243242936484, -4.213370325622234],
            [28.161744115608446, -4.213823715065338],
            [28.161696579458543, -4.214682768676946],
            [28.161720347084348, -4.215661134168834],
            [28.161221219756275, -4.215637271060768],
            [28.160627020128462, -4.215374783136333],
            [28.160222965100171, -4.215040707548266],
            [28.159961517623266, -4.214611181063018],
            [28.160009052874845, -4.214205516588812],
            [28.160460644951304, -4.213680539670528],
            [28.16053194872698, -4.213131699207168],
            [28.160056589024716, -4.21306011144855],
            [28.159557461696679, -4.213227149240955],
            [28.158939494443025, -4.213704401937542],
            [28.158440367114991, -4.213966890433407],
            [28.157988775936829, -4.214038479009326],
            [28.157465880084658, -4.214945256838114],
            [28.156919216606713, -4.215470233793001],
            [28.156443856904453, -4.215637271060768],
            [28.156206177951649, -4.216209972822853],
            [28.156206177951649, -4.216687222762102],
            [28.155302994696992, -4.216663360587871],
            [28.154898938770405, -4.216281560287588],
            [28.154471115218008, -4.216806535425983],
            [28.154518651367919, -4.217832623388635],
            [28.154209667741107, -4.218596222254451],
            [28.152403302130125, -4.219049609510275],
            [28.151761566352402, -4.219837069239972],
            [28.151191135248691, -4.220934740176035],
            [28.150620704144945, -4.221316538158584],
            [28.150026504517129, -4.221602886971592],
            [28.149218393562251, -4.221769923804908],
            [28.14867173008431, -4.221650611913635],
            [28.147816082979556, -4.221746060887],
            [28.147136546992975, -4.222444539071729],
            [28.146817828323453, -4.222772142235943],
            [28.145700733741762, -4.222986902771165],
            [28.145296677815175, -4.222533518747153],
            [28.144559870635973, -4.222438069871927],
            [28.143585384503972, -4.222485793860083],
            [28.142682201249347, -4.222581243631221],
            [28.141470034367877, -4.22296304079306],
            [28.140923370889936, -4.222891453952451],
            [28.140329172160421, -4.222748280251146],
            [28.139853812458156, -4.222628968512349],
            [28.138499038025333, -4.222652830500835],
            [28.137548318620805, -4.222557380738604],
            [28.137025423666962, -4.222891453952451],
            [28.136692672414384, -4.223416424562767],
            [28.136146008936439, -4.223774359355382],
            [28.135623113084268, -4.223177801274733],
            [28.135123985756234, -4.222819867105151],
            [28.134363410951231, -4.222700555377498],
            [28.134008994130621, -4.222709026752477],
            [28.133365155396827, -4.222056271546527],
            [28.132699652891631, -4.221268814097568],
            [28.13196284571243, -4.220218868671404],
            [28.131558789785842, -4.219145058807637],
            [28.131130966233481, -4.218047385308327],
            [28.13067612674725, -4.217449018090925],
            [28.130441695204187, -4.217140611146845],
            [28.129657351875082, -4.216424735196982],
            [28.128968080845784, -4.215971347290938],
            [28.128492721143516, -4.215637271060768],
            [28.127969826189677, -4.215565683535907],
            [28.12754200263732, -4.215565683535907],
            [28.12704287530925, -4.215565683535907],
            [28.126282299605979, -4.215589546646188],
            [28.125426652501226, -4.216186109731884],
            [28.124594773920546, -4.217188336366779],
            [28.124285790293737, -4.218882572083977],
            [28.124000574292729, -4.220529079949308],
            [28.123382607039112, -4.222151721371199],
            [28.122965673762931, -4.22303814406229],
            [28.122574496084233, -4.223869808965901],
            [28.121908992680744, -4.225229958760455],
            [28.121386097726901, -4.226065136802251],
            [28.120886970398832, -4.226518519636392],
            [28.12057798677202, -4.22711507421128],
            [28.119555963591814, -4.227210523405134],
            [28.118819156412616, -4.22699576315316],
            [28.117915973157988, -4.22699576315316],
            [28.117345542054242, -4.22661396800283],
            [28.116822647100403, -4.226160586127105],
            [28.116323519772369, -4.225874239018697],
            [28.116085839921233, -4.225754927767097],
            [28.115824391545999, -4.224251605485217],
            [28.115491640293385, -4.223511874217903],
            [28.115349032742031, -4.223106214454201],
            [28.115349032742031, -4.222605105621208],
            [28.115610480218969, -4.221722198870219],
            [28.115658016368844, -4.221006327199512],
            [28.115349032742031, -4.220290455761788],
            [28.115063816740992, -4.219932519341123],
            [28.11480236926409, -4.219479133509463],
            [28.113899186009434, -4.218524635005841],
            [28.113233682605944, -4.21799966104373],
            [28.112663251502195, -4.217403098466923],
            [28.112045284248577, -4.217164473306217],
            [28.111498620770636, -4.216520185723005],
            [28.111094565742377, -4.215517959116901],
            [28.110262686263397, -4.214587317922318],
            [28.109763558935327, -4.214253241991322],
            [28.109288199233063, -4.213895302752713],
            [28.108860375680703, -4.213680539670528],
            [28.107957193324374, -4.212845347230755],
            [28.107630012524865, -4.212573498499265],
            [28.107267921396751, -4.212272643859436],
            [28.106792562592815, -4.211866978149229],
            [28.105723003262703, -4.211222686118126],
            [28.104914892307825, -4.211055646987712],
            [28.1040117090532, -4.21112723493322],
            [28.103156062846747, -4.211699940060853],
            [28.102792017882912, -4.21193252783619],
            [28.102110272040768, -4.212368094901943],
            [28.101040712710656, -4.212869210425639],
            [28.100137529455999, -4.212797621740678],
            [28.099567098352285, -4.212415819516833],
            [28.099258114725476, -4.211676076829636],
            [28.098758987397407, -4.211079510238217],
            [28.098331163845049, -4.210745431878779],
            [28.097998412592432, -4.210554530280379],
            [28.096548565859869, -4.210077275625804],
            [28.095621614979439, -4.209719335342179],
            [28.09500364772579, -4.209409119693544],
            [28.09429060817239, -4.209003452470817],
            [28.093648873292999, -4.208597785033888],
            [28.093078442189256, -4.208096666723262],
            [28.09241293878576, -4.207595548085815],
            [28.091937579083499, -4.207189880807608],
            [28.091319611829878, -4.206736486546701],
            [28.090796716876039, -4.206402407200846],
            [28.090202517248191, -4.205949013377405],
            [28.089893533621382, -4.205567206848183],
            [28.089513246218896, -4.205209264464107],
            [28.089228030217853, -4.204899046995189],
            [28.088895278965275, -4.203491135093964],
            [28.088562526814364, -4.202488891489907],
            [28.088134703261971, -4.201916179499844],
            [28.087516736008354, -4.201343467985503],
            [28.086470945202375, -4.200102591125058],
            [28.085852977948758, -4.199362836591185],
            [28.08556776284605, -4.198646944081065],
            [28.085187475443529, -4.198360587612245],
            [28.084783419516942, -4.198050367382925],
            [28.084331828338776, -4.197406062875549],
            [28.083927772412189, -4.197024253010499],
            [28.083428645084155, -4.196403811350791],
            [28.082925769984726, -4.196140390595648],
            [28.082881981606214, -4.196117453146343],
            [28.082335318128269, -4.195926547918204],
            [28.081574743323294, -4.195926547918204],
            [28.080647792442868, -4.195735642642828],
            [28.079839681487989, -4.195664053265091],
            [28.079245928322866, -4.195651887354284],
            [28.078675050756431, -4.195640190438325],
            [28.077914475053127, -4.19568791699301],
            [28.077035060322604, -4.196141316860217],
            [28.076607236770208, -4.196570853662752],
            [28.075561445964198, -4.196570853662752],
            [28.074586958933899, -4.196570853662752],
            [28.073707544203344, -4.196594716460702],
            [28.073184648351205, -4.196594716460702],
            [28.071901178592391, -4.196332222035139],
            [28.07135451511445, -4.195950411638007],
            [28.071449586515897, -4.19521065311713],
            [28.071972482368068, -4.194399304391101],
            [28.072257697470775, -4.193325458459972],
            [28.0731608807254, -4.192872056936803],
            [28.073707544203344, -4.192180022234317],
            [28.074515655158223, -4.191106173213431],
            [28.074682031233674, -4.190032323599919],
            [28.074254207681285, -4.189483466273207],
            [28.073541168127885, -4.188910745521327],
            [28.072780593322914, -4.188457340502194],
            [28.0722101622192, -4.188194843307512],
            [28.071758570142705, -4.187956209088752],
            [28.071467524973801, -4.187795490996923],
            [28.071283211338773, -4.187693711723669],
            [28.070427564233988, -4.187407351188014],
            [28.069405541053783, -4.187335760135601],
            [28.069236394574009, -4.187331042175326],
            [28.068549893949029, -4.187311897051234],
            [28.067694246844276, -4.187192579814671],
            [28.066719759813978, -4.187216442902675],
            [28.065911648859096, -4.187168716725878],
            [28.064889626577187, -4.186691447580468],
            [28.063915139546889, -4.185760772439837],
            [28.063107028592007, -4.184973276936915],
            [28.062346452888736, -4.184281235154464],
            [28.061918629336347, -4.18389941879556],
            [28.061696171437699, -4.183797894254495],
            [28.061134286905602, -4.183541465449548],
            [28.059446760321872, -4.183660783249987],
            [28.059266209729547, -4.183673102677441],
            [28.056998658933168, -4.183827828320011],
            [28.055762724425929, -4.183827828320011],
            [28.055192293322182, -4.183875554703162],
            [28.054550558442791, -4.183589192752339],
            [28.054075198740527, -4.183064194063717],
            [28.053552302888356, -4.18249146855299],
            [28.05295810415884, -4.181871015212123],
            [28.052482744456572, -4.181393742795194],
            [28.051767362096914, -4.180940103373189],
            [28.051127970023785, -4.180534652063295],
            [28.050272322919003, -4.180510788768962],
            [28.049369139664378, -4.180582379551626],
            [28.048465957308053, -4.180868743517928],
            [28.046825966874227, -4.182133514555079],
            [28.045257281114374, -4.184042599726762],
            [28.043189467128155, -4.186524403129495],
            [28.042381356173312, -4.187383487203959],
            [28.041145421666037, -4.188576657543396],
            [28.040123398485832, -4.189340286350546],
            [28.039953090484381, -4.189469684924976],
            [28.039243983755309, -4.190008460598947],
            [28.038388336650559, -4.190223230287055],
            [28.037794137022711, -4.190318684063871],
            [28.03724747354477, -4.190294820169799],
            [28.036439362589888, -4.189745963029749],
            [28.03546487555959, -4.188385750449035],
            [28.034609229353133, -4.187311897051234],
            [28.033706046098512, -4.186643720469324],
            [28.03289793514363, -4.186142587879013],
            [28.032113591814557, -4.185927817055932],
            [28.031543160710847, -4.185713045271203],
            [28.031242885352398, -4.185630823069606],
            [28.031020264858675, -4.18556986464952],
            [28.029808098875538, -4.185736908404931],
            [28.028928683246683, -4.186333495527872],
            [28.028338619462406, -4.186885072589843],
            [28.028239412217388, -4.1869778092835],
            [28.027668981113642, -4.187908482957691],
            [28.026742030233212, -4.188672111523819],
            [28.025292183500614, -4.189483466273207],
            [28.024602912471316, -4.18991300678376],
            [28.02365219396512, -4.18991300678376],
            [28.022962922037493, -4.189769826940779],
            [28.022178579606749, -4.189769826940779],
            [28.021322932501967, -4.189769826940779],
            [28.020372213097435, -4.190175503394213],
            [28.019564102142589, -4.190461863805024],
            [28.018613383636357, -4.191082310245626],
            [28.017805271783182, -4.19091526674471],
            [28.017377449129121, -4.190294820169799],
            [28.017258609203569, -4.18848120445307],
            [28.017020929352437, -4.187598258524237],
            [28.016807017127075, -4.187001672378146],
            [28.016807017127075, -4.184734641722922],
            [28.017306144455144, -4.184114190182427],
            [28.01782904030728, -4.183302829793483],
            [28.017971647858634, -4.182539195920574],
            [28.018066720158416, -4.180009652202919],
            [28.018946134888971, -4.178864195331787],
            [28.020348445471665, -4.177217599293009],
            [28.020584336777073, -4.176951151413358],
            [28.020918876575376, -4.176573277405466],
            [28.021204092576415, -4.175594862296798],
            [28.021513076203224, -4.174974403426715],
            [28.02146554005332, -4.17442553541166],
            [28.021061484126733, -4.174115305570449],
            [28.020586125322797, -4.173828940007954],
            [28.020134533246299, -4.173494845515369],
            [28.020115648862419, -4.173494287214947],
            [28.019326422291456, -4.173470982004083],
            [28.018732223561937, -4.17335166263268],
            [28.01839947141103, -4.173303934698626],
            [28.017947880232864, -4.173089160311783],
            [28.017496288156373, -4.172874384963446],
            [28.016569337275943, -4.172325515460859],
            [28.016284122173236, -4.172015284778913],
            [28.016284122173236, -4.171609186613584],
            [28.016284122173236, -4.171227776191622],
            [28.016975009271743, -4.170277740286477],
            [28.017377449129121, -4.16972434659971],
            [28.017971647858634, -4.16903229118675],
            [28.018147702382954, -4.168959278773901],
            [28.019064974814519, -4.168578875423207],
            [28.020895108949606, -4.167314081353039],
            [28.022035971157063, -4.166622023790151],
            [28.022820314486136, -4.166383382921539],
            [28.023889872917923, -4.166192470354244],
            [28.024270161218741, -4.165166314613169],
            [28.024412768770095, -4.163113997258876],
            [28.02422262506883, -4.162302614882083],
            [28.023723497740797, -4.160775304102712],
            [28.02363967863656, -4.160516816636893],
            [28.023390745589886, -4.159749141205873],
            [28.023414514113988, -4.158579790445266],
            [28.023129298112949, -4.157171794228669],
            [28.022844082111945, -4.156169490620711],
            [28.022463794709459, -4.15521491386841],
            [28.022035971157063, -4.154308065951659],
            [28.021251628726286, -4.153019384519036],
            [28.019920621919272, -4.151110223021355],
            [28.019041207188749, -4.150251098775811],
            [28.01832816763535, -4.14943970298569],
            [28.017757736531607, -4.148747629517943],
            [28.017282376829339, -4.147960096458027],
            [28.016830785651177, -4.146957780995978],
            [28.016616873425814, -4.146313434017243],
            [28.016640641949952, -4.145836140651362],
            [28.017044696978207, -4.145287252062596],
            [28.017757736531607, -4.144619039307245],
            [28.020063229470626, -4.143903096241051],
            [28.021750756054356, -4.143282612079858],
            [28.023248138038532, -4.142709857239875],
            [28.023697758312963, -4.142620837710574],
            [28.024935663723934, -4.142375750281334],
            [28.026124062979594, -4.141970047944738],
            [28.027882892440672, -4.141230237948606],
            [28.029760562725631, -4.139488102196497],
            [28.03014085012812, -4.138414181196414],
            [28.030592441306279, -4.137817557279798],
            [28.030797630890227, -4.137379750164],
            [28.033647970015394, -4.133875905276841],
            [28.036212967375359, -4.122530346155544],
            [28.025558416303056, -4.121314080789247],
            [28.008659681979069, -4.119434304862425],
            [28.003427074500816, -4.118852241046352],
            [27.983120930591113, -4.111445283430271],
            [27.985677287954701, -4.109031409830192],
            [27.966894812531034, -4.105019344192539],
            [27.943723467768148, -4.12234467249043],
            [27.943790827041408, -4.12214176609563],
            [27.943481843414595, -4.121282610019298],
            [27.94272126860962, -4.121211013787466],
            [27.942103301356003, -4.121473533572876],
            [27.941366494176837, -4.122117901012514],
            [27.941271421877058, -4.122595209752268],
            [27.941675477803646, -4.12374074846028],
            [27.941675477803646, -4.123840528253395],
            [27.941675477803646, -4.124552170924937],
            [27.941366494176837, -4.124957882293381],
            [27.940724758399114, -4.125053343177681],
            [27.940796063073087, -4.125817034343626],
            [27.941532870252292, -4.126270474973077],
            [27.942031997580326, -4.126676185452198],
            [27.942245908907356, -4.127201221276009],
            [27.941223885727148, -4.127320547714541],
            [27.940130559669598, -4.127010299116977],
            [27.939369983966294, -4.126652319605127],
            [27.938419265460059, -4.126222744155506],
            [27.938318106175917, -4.1262189819383],
            [27.937777529682339, -4.126198879196598],
            [27.937040722503173, -4.126103417549792],
            [27.936589131325007, -4.125912495123325],
            [27.935376964443545, -4.126007956793375],
            [27.935156600517828, -4.126662536486032],
            [27.934806533339831, -4.127702391834918],
            [27.93368943875814, -4.127988775254065],
            [27.932928863953165, -4.127630796189287],
            [27.931669160921828, -4.126867107692666],
            [27.930670906265725, -4.126485262263251],
            [27.929934099086523, -4.127010299116977],
            [27.929244828057225, -4.127630796189287],
            [27.928484252353922, -4.127606931273265],
            [27.927937589774309, -4.127225086204384],
            [27.927438461547943, -4.126819376911381],
            [27.926749190518649, -4.126676185452198],
            [27.926368903116163, -4.126676185452198],
            [27.925846008162324, -4.127177356346922],
            [27.925109200983119, -4.127439874134894],
            [27.924633841280855, -4.127225086204384],
            [27.924348625279816, -4.126079552587296],
            [27.924015874027234, -4.125649976823716],
            [27.923115419854426, -4.125423941427485],
            [27.923065154622705, -4.125411323419799],
            [27.922280812191929, -4.125268131703374],
            [27.921686612564113, -4.124838555495153],
            [27.920902269235039, -4.124695363674101],
            [27.920165462055838, -4.124671497766738],
            [27.919618798577897, -4.124623766851805],
            [27.919214743549606, -4.124599901844221],
            [27.919024599848377, -4.124456709979608],
            [27.918168952743628, -4.125172669943225],
            [27.917265769488971, -4.125196535835347],
            [27.916410122384221, -4.124814689592129],
            [27.915483171503791, -4.125124939058774],
            [27.914508684473457, -4.126318205787759],
            [27.914385974605679, -4.126852125583685],
            [27.914366076922104, -4.126938703408078],
            [27.914247236996555, -4.128012640158471],
            [27.914247236996555, -4.128704731990984],
            [27.913605502117129, -4.128728597775551],
            [27.912797391162282, -4.12808423576923],
            [27.912131887758758, -4.127463739056004],
            [27.91220948692796, -4.126489774035952],
            [27.91222695916024, -4.126270474973077],
            [27.911989279309108, -4.125148804952346],
            [27.91151392050514, -4.124456709979608],
            [27.910586969624713, -4.124098729301665],
            [27.90992146622122, -4.124313517186845],
            [27.909255962817696, -4.124719228678771],
            [27.908542923264299, -4.124862420495459],
            [27.907829884609196, -4.124647632760643],
            [27.90709307743003, -4.124599901844221],
            [27.906427574026502, -4.124528305915191],
            [27.905619463071659, -4.124050998351835],
            [27.904787583592679, -4.124289652169835],
            [27.904169616339061, -4.123907806386984],
            [27.90388440123635, -4.123287306367826],
            [27.90376556131077, -4.122523612738235],
            [27.903218897832826, -4.122499747666748],
            [27.902743958542136, -4.122795746481101],
            [27.902529626803531, -4.122929325156097],
            [27.90155513977323, -4.123191844366541],
            [27.900747028818351, -4.123406633402102],
            [27.899748773263916, -4.123716883425853],
            [27.899249645935878, -4.123454363489149],
            [27.899178342160205, -4.122523612738235],
            [27.898750518607809, -4.12214176609563],
            [27.897823567727382, -4.122786132986456],
            [27.897823567727382, -4.123597556438777],
            [27.896944152996859, -4.123788479428978],
            [27.896373721893116, -4.124050998351835],
            [27.896468793294595, -4.124647632760643],
            [27.896373721893116, -4.125339727564863],
            [27.896017202116433, -4.125912495123325],
            [27.895137787385877, -4.125721572650333],
            [27.894638659159508, -4.125363592549877],
            [27.894282140281124, -4.124098729301665],
            [27.894258371757022, -4.12350209447525],
            [27.893949388130213, -4.122666805857781],
            [27.893790583954292, -4.121769868318089],
            [27.893759244428953, -4.12159286088306],
            [27.893474029326246, -4.121115552435534],
            [27.893141277175335, -4.12073370420573],
            [27.892832293548526, -4.120232529193244],
            [27.892428238520267, -4.119325640691585],
            [27.891834038892419, -4.11942110226118],
            [27.891151915757828, -4.119786393991152],
            [27.891120999339019, -4.119802950227571],
            [27.890217816982695, -4.119826816283046],
            [27.889647384980652, -4.119516564721178],
            [27.888981882475459, -4.119254043379242],
            [27.888340146697736, -4.118991522851528],
            [27.887579571892765, -4.11934950585957],
            [27.887294355891726, -4.118919926410733],
            [27.887246819741854, -4.118227825943777],
            [27.886557548712556, -4.117702783212362],
            [27.88598711760881, -4.117416396940028],
            [27.88513147050406, -4.117177741031983],
            [27.884584807026119, -4.116772025641487],
            [27.884355944139497, -4.116373700171488],
            [27.8842282872494, -4.11615151998159],
            [27.883372640144653, -4.115698073505441],
            [27.882778441415134, -4.115769670239915],
            [27.882255545562998, -4.115984461306223],
            [27.881613810683575, -4.115769670239915],
            [27.880995843429954, -4.115769670239915],
            [27.880377876176336, -4.1155787452995],
            [27.879783676548485, -4.115554880016938],
            [27.878619045816926, -4.115173029083306],
            [27.878119918488888, -4.115149163788441],
            [27.877727779612862, -4.115286976881427],
            [27.877644558786628, -4.115316223543417],
            [27.876931520131524, -4.115769670239915],
            [27.876479928055062, -4.116008326575718],
            [27.875481673398962, -4.116461772872802],
            [27.874578490144302, -4.115888998416888],
            [27.874245738891688, -4.115149163788441],
            [27.874646371338738, -4.114553195058329],
            [27.874887473771111, -4.114194537868772],
            [27.874245738891688, -4.113192178277914],
            [27.873318788011261, -4.113359238448816],
            [27.871702566101536, -4.113311506846158],
            [27.870918222772463, -4.113120581308664],
            [27.869848664340676, -4.113072849691514],
            [27.867757082728691, -4.11309671595146],
            [27.867519402877555, -4.113287641494782],
            [27.867469496971939, -4.113350601714231],
            [27.866592451997128, -4.114457059999524],
            [27.865451588891339, -4.114385463145461],
            [27.864904925413398, -4.113884284082501],
            [27.864500870385108, -4.113335373098827],
            [27.863716527056031, -4.112356878695075],
            [27.862623200100149, -4.112118221250721],
            [27.861720016845524, -4.112046624183701],
            [27.860412778562576, -4.11156930903429],
            [27.859984955010216, -4.111068128176453],
            [27.859366987756598, -4.110543080662653],
            [27.858844092802759, -4.11013736275032],
            [27.858440036876171, -4.109636180980314],
            [27.858297429324818, -4.10894407234002],
            [27.858511340651845, -4.108419023409042],
            [27.859153076429568, -4.10815649926323],
            [27.859010467979882, -4.107106400902587],
            [27.858630180577396, -4.106318825987577],
            [27.85835271344402, -4.106154192552009],
            [27.858107285623554, -4.106008569095978],
            [27.857418014594259, -4.105889239420327],
            [27.85677627881654, -4.105984703523082],
            [27.856372223788284, -4.105960837047469],
            [27.855920631711786, -4.105125529789889],
            [27.855231360682492, -4.104982333475221],
            [27.85456585727897, -4.104815272428292],
            [27.854161802250708, -4.104170890808737],
            [27.854161802250708, -4.103144653696543],
            [27.85456585727897, -4.10235707482141],
            [27.85456585727897, -4.101951351790166],
            [27.854304409802062, -4.101617227473926],
            [27.853733978698319, -4.101378566774771],
            [27.852902099219371, -4.100781915612887],
            [27.852618425625682, -4.100655318445602],
            [27.852260364339948, -4.100495522281451],
            [27.851666164712135, -4.09954087769372],
            [27.850881821383059, -4.099015823399652],
            [27.850162818812795, -4.098809545531192],
            [27.849717190651464, -4.098681697839867],
            [27.848885312070813, -4.099111287432727],
            [27.848148504891647, -4.099278350590361],
            [27.84736416156257, -4.099159019895967],
            [27.846698658159049, -4.098896492665539],
            [27.846128227055331, -4.098466902053718],
            [27.845843011054296, -4.098037311208],
            [27.845843011054296, -4.097297459809061],
            [27.846722426683147, -4.097225861395267],
            [27.847174017861313, -4.097058797803131],
            [27.846460978307913, -4.096175748475419],
            [27.845866779578397, -4.09612801583179],
            [27.845320116100456, -4.09603255143785],
            [27.84453577277138, -4.095579092477553],
            [27.844369397594225, -4.095101768256729],
            [27.843656358040825, -4.094934704215167],
            [27.843014622263105, -4.095006302836728],
            [27.842372887383714, -4.094815372864103],
            [27.841778687755866, -4.094290314524968],
            [27.842444191159391, -4.093574326466264],
            [27.842230279832361, -4.092524208691363],
            [27.841469704129057, -4.091855951034939],
            [27.840637825548406, -4.091593421376705],
            [27.839853482219333, -4.091927549935511],
            [27.839092907414358, -4.092333278118898],
            [27.838451171636638, -4.092285545243089],
            [27.837167700979496, -4.091426356593323],
            [27.836502198474303, -4.090352369918845],
            [27.835171191667285, -4.089994373735838],
            [27.834268008412625, -4.089922774660195],
            [27.834476475050717, -4.089573891552826],
            [27.834695831965021, -4.089206781743106],
            [27.83514742404148, -4.088562388285144],
            [27.834196704636952, -4.088347589747841],
            [27.834173140928755, -4.088351814891156],
            [27.833587200411621, -4.079111240806179],
            [27.822326399710267, -4.070361723387803],
            [27.823262039994454, -4.058726531957429],
            [27.828129599989012, -4.054372167885617],
            [27.827117280410484, -4.044187562760342],
            [27.834876720323884, -4.029171006086203],
            [27.837782067785447, -4.022388089443514],
            [27.818296493565335, -4.019005462572991],
            [27.79855127299043, -4.004012562035199],
            [27.767229480417065, -4.003999797760774],
            [27.721132560071556, -4.009975034859841],
            [27.685441079885223, -4.014456029939646],
            [27.63639623552692, -4.021928400980551],
            [27.61846135021824, -4.020422528335901],
            [27.597331163732136, -4.00992466375386],
            [27.580569214978112, -3.994932639224971],
            [27.553686044935972, -3.993423329557363],
            [27.531312486790394, -3.993414140314248],
            [27.510287897265925, -3.987411442086845],
            [27.495230186454872, -3.981411227284118],
            [27.477225271181567, -3.976908323389355],
            [27.463802039640047, -3.976902749827721],
            [27.459398160350759, -3.979898115115404],
            [27.452395847508267, -3.996621685034919],
            [27.451618605361517, -3.996593807979798],
            [27.451618605361517, -3.995476082612458],
            [27.450077550881517, -3.994014440529265],
            [27.449050180928719, -3.992036920942156],
            [27.447937197037785, -3.992208878966537],
            [27.447937197037785, -3.994014440529265],
            [27.447650887787081, -3.994110283374914],
            [27.446909827085019, -3.994358356603981],
            [27.446452757081925, -3.993644327846336],
            [27.446139299845004, -3.993154650154558],
            [27.445882457132221, -3.991349086675468],
            [27.447166669797799, -3.991349086675468],
            [27.447166669797799, -3.990231354070241],
            [27.446053685008533, -3.989457538980813],
            [27.444512630528536, -3.987823926220548],
            [27.445111929892207, -3.987222068818045],
            [27.444255787815756, -3.985846391531923],
            [27.443913331164833, -3.984728652245203],
            [27.44245789062294, -3.983352970732595],
            [27.440060694066457, -3.982235227110804],
            [27.439033324113694, -3.982235227110804],
            [27.438177182935537, -3.981461404396264],
            [27.436721741495351, -3.980343659073741],
            [27.435951214255333, -3.97999973705733],
            [27.434238931000696, -3.980773561164063],
            [27.432612262582523, -3.981117482852953],
            [27.431413663855114, -3.981375424249633],
            [27.430814364491411, -3.979655814895338],
            [27.429444537887729, -3.979655814895338],
            [27.429444537887729, -3.978538067089426],
            [27.428331553996792, -3.978710027973991],
            [27.427389797982165, -3.977506298311722],
            [27.427240820477127, -3.976822591758099],
            [27.426312045118362, -3.976451301129301],
            [27.426312045118362, -3.97588983780983],
            [27.426248924994908, -3.9748393556715],
            [27.425996441806205, -3.974404673477293],
            [27.424887321569319, -3.974096773336472],
            [27.424304147863278, -3.974096773336472],
            [27.423904443375932, -3.974096773336472],
            [27.422605960972092, -3.97372548146381],
            [27.422353477783393, -3.972729333174715],
            [27.42254283995031, -3.971615456079856],
            [27.422725833061907, -3.97124789985986],
            [27.422912546995381, -3.970872869902107],
            [27.423651960187229, -3.97018461986008],
            [27.424211029399221, -3.969632207307437],
            [27.424436459823166, -3.968780948226736],
            [27.424400390667873, -3.968536437984053],
            [27.423899934731498, -3.967920633149155],
            [27.423534736330858, -3.967648953707725],
            [27.423291270430955, -3.967476891247669],
            [27.42247070253806, -3.96700598104476],
            [27.42165013374683, -3.966535069667718],
            [27.420658237366315, -3.966073214951416],
            [27.419422875984228, -3.965013665014223],
            [27.418250634725556, -3.965013665014223],
            [27.41732185936679, -3.965131392652507],
            [27.416852963043009, -3.964723873415855],
            [27.417610410812451, -3.963546592973973],
            [27.418169480024474, -3.963075680502069],
            [27.418232600147928, -3.96270438451097],
            [27.418394910448388, -3.961717277930879],
            [27.416880014909466, -3.960666777526598],
            [27.415761877383748, -3.960132471623547],
            [27.41441830853579, -3.960485656599527],
            [27.413602467577885, -3.960399058049062],
            [27.413430095247939, -3.96038076181709],
            [27.4133091882989, -3.960367928291163],
            [27.413246068175447, -3.95967061328402],
            [27.413714964499263, -3.958728782695683],
            [27.414589636125076, -3.958194475525053],
            [27.414652757146829, -3.957252644137442],
            [27.414301084679416, -3.956437596694873],
            [27.413246068175447, -3.956491933517035],
            [27.413074740586158, -3.957316036130929],
            [27.412605844262341, -3.957316036130929],
            [27.41213694793856, -3.957026241800732],
            [27.410667137945399, -3.95596668012457],
            [27.410549914089025, -3.955196912156628],
            [27.408448897471622, -3.954907116173128],
            [27.408300239766817, -3.954829741895746],
            [27.407213536089532, -3.954264133477307],
            [27.405987191097946, -3.952969108589358],
            [27.405987191097946, -3.952443852934603],
            [27.405806847118118, -3.95179181121204],
            [27.405455174650712, -3.951194106144114],
            [27.4044362264037, -3.950677905551399],
            [27.403669761345427, -3.950170760839957],
            [27.403056589298778, -3.949681728238852],
            [27.401947469061891, -3.949618335653859],
            [27.401190021292415, -3.949917188817571],
            [27.400243211355988, -3.949790402776914],
            [27.400243211355988, -3.948893841917615],
            [27.400008762744946, -3.948169348442763],
            [27.399287384130762, -3.948069729919597],
            [27.39898981539627, -3.947625977239516],
            [27.399350504254183, -3.947046381613938],
            [27.399575935576426, -3.946276605258071],
            [27.399539866421133, -3.945189859981408],
            [27.399043918230859, -3.944682712775241],
            [27.398052022748672, -3.943451065805693],
            [27.397348677813817, -3.942744680098116],
            [27.39652810902259, -3.941983956001216],
            [27.3953017649293, -3.940987768123287],
            [27.394075420836042, -3.940399111491657],
            [27.393191731023066, -3.939982522717027],
            [27.392199834642547, -3.939285190350848],
            [27.392136714519097, -3.940109310274274],
            [27.391902265908058, -3.940453448475506],
            [27.391262041994949, -3.939991579036187],
            [27.390441473203722, -3.938931995329162],
            [27.38891756037594, -3.939457258740006],
            [27.387808440139054, -3.939520653012767],
            [27.386582096045792, -3.939574990956915],
            [27.385995975865608, -3.939520653012767],
            [27.38587875111094, -3.938524462145498],
            [27.386230423578347, -3.937401482114076],
            [27.386636198880417, -3.936758484784713],
            [27.387050992369577, -3.936224163287466],
            [27.386582096045792, -3.935345700343497],
            [27.386050078700229, -3.935345700343497],
            [27.385058182319714, -3.935345700343497],
            [27.384066286837491, -3.935409094933538],
            [27.383065373168144, -3.935291363021771],
            [27.382190701542296, -3.935345700343497],
            [27.381541460340394, -3.93581662876045],
            [27.381514408473901, -3.936350951424898],
            [27.380522512093386, -3.936586414927959],
            [27.380116736791354, -3.937464876545484],
            [27.379115823122007, -3.937935803747821],
            [27.379061719389053, -3.937582608145836],
            [27.378412478187151, -3.937229412391961],
            [27.377709134150596, -3.936405289578784],
            [27.376545910180788, -3.93594341786299],
            [27.375779445122479, -3.935409094933538],
            [27.375427772655069, -3.93559022140452],
            [27.374841652474885, -3.935880023314156],
            [27.37356120464867, -3.935526826828422],
            [27.372677515734026, -3.935707953273476],
            [27.37197417079917, -3.935707953273476],
            [27.371270825864315, -3.935526826828422],
            [27.370278930382096, -3.935526826828422],
            [27.370278930382096, -3.936233219648062],
            [27.369990378038107, -3.936704147556406],
            [27.369927257914686, -3.937591664491459],
            [27.369755930325361, -3.93828899919794],
            [27.369547173531444, -3.93849865907772],
            [27.36922391297983, -3.938823319352128],
            [27.368529586232103, -3.938877657342446],
            [27.367997568886537, -3.938352392658655],
            [27.367536056714396, -3.937888880925079],
            [27.367357344973467, -3.937709396073644],
            [27.366356431304087, -3.9376460025633],
            [27.365716207391014, -3.938234661168655],
            [27.365130087210826, -3.938062591621114],
            [27.364895639498084, -3.937238468741527],
            [27.365012863354455, -3.936468683184851],
            [27.364075070706861, -3.935535883196742],
            [27.36296595046997, -3.934883828032252],
            [27.362668381735482, -3.93424082873307],
            [27.361965036800623, -3.934412899080864],
            [27.361739605478384, -3.935119292857851],
            [27.361324812887521, -3.935354756713814],
            [27.360684588974415, -3.934766096045259],
            [27.360557910349691, -3.934115628159686],
            [27.360248926722882, -3.934211111744317],
            [27.359583423319357, -3.934497564236029],
            [27.359559655693584, -3.934998855179733],
            [27.359155599766996, -3.935380790845696],
            [27.35832372028802, -3.935356920210095],
            [27.357373001781784, -3.935380790845696],
            [27.356826338303843, -3.934998855179733],
            [27.355495331496826, -3.934831757931731],
            [27.35416432558814, -3.935165952393755],
            [27.352500567528512, -3.934712402862659],
            [27.350955649394464, -3.934712402862659],
            [27.348982907708024, -3.934712402862659],
            [27.347723204676683, -3.935094338661747],
            [27.347319149648392, -3.935237565217319],
            [27.346606110094996, -3.935261435856355],
            [27.345988142841378, -3.93487950013491],
            [27.345441479363437, -3.934354337551556],
            [27.344775975959944, -3.933709820320286],
            [27.343944097379296, -3.933447239148083],
            [27.342565554422372, -3.932540138841774],
            [27.341757443467493, -3.932182072584773],
            [27.340640348885838, -3.931752393051056],
            [27.340117453931999, -3.931680779924003],
            [27.33930934207882, -3.931084002118983],
            [27.338786447124981, -3.930534967238761],
            [27.33826355127281, -3.929866575317803],
            [27.337811960094648, -3.92919818285409],
            [27.337336600392383, -3.928219464435463],
            [27.336789937812739, -3.927670426742434],
            [27.336861241588412, -3.927049775153434],
            [27.336885009214217, -3.926357509506598],
            [27.337859496244519, -3.926262024108567],
            [27.33840615972246, -3.926166539601689],
            [27.338358623572589, -3.925665243278026],
            [27.337978336170103, -3.924829748125997],
            [27.337502976467835, -3.924567164121319],
            [27.336980081513996, -3.924853619969139],
            [27.336171969660821, -3.925474273212677],
            [27.335720378482659, -3.926262024108567],
            [27.335696610856854, -3.926906548074826],
            [27.335268787304496, -3.927002032495918],
            [27.334603283900972, -3.927121388683374],
            [27.334199227974381, -3.926954290737889],
            [27.333937780497479, -3.92652460847537],
            [27.334032852797257, -3.925903956023002],
            [27.334745891452325, -3.925880084210303],
            [27.335007339827559, -3.925426530463892],
            [27.335102411229038, -3.925092332949248],
            [27.33491226752778, -3.924853619969139],
            [27.334555747751097, -3.924328450989091],
            [27.333676333020541, -3.924089737787757],
            [27.332559238438854, -3.923588440200777],
            [27.331703591334101, -3.923803282576658],
            [27.331014320304806, -3.924352322846775],
            [27.330443888302764, -3.924280708173896],
            [27.329968529498828, -3.923206499063446],
            [27.329469402170758, -3.922323259392972],
            [27.328994042468494, -3.922561973105803],
            [27.328851434018809, -3.923158756183304],
            [27.32916041854395, -3.923731667856083],
            [27.329065346244171, -3.924471678515839],
            [27.328423611364748, -3.924972976467845],
            [27.328209699139418, -3.925354916786603],
            [27.327781875587029, -3.925378787712308],
            [27.327306515884761, -3.924972976467845],
            [27.326260725078786, -3.924113609652336],
            [27.325405077974033, -3.923325855800667],
            [27.325191166647002, -3.92265745803025],
            [27.324977255319972, -3.922394873333649],
            [27.32438305569212, -3.921941317669617],
            [27.323978999765533, -3.921463889815559],
            [27.323479872437463, -3.921607117839885],
            [27.323313496362012, -3.922012931643436],
            [27.322766833782399, -3.922776814846934],
            [27.322291474080135, -3.922943914541699],
            [27.32155466690093, -3.922180030590758],
            [27.321031771048794, -3.921726474808588],
            [27.3203425000195, -3.921917445742126],
            [27.320223660093916, -3.921440017874251],
            [27.320794092095959, -3.9210342046911],
            [27.320936699647312, -3.920055476577544],
            [27.320199892468146, -3.919243847747367],
            [27.320009748766886, -3.918575446669567],
            [27.319700765140077, -3.918241246378821],
            [27.319106565512261, -3.91809801686803],
            [27.31889265418523, -3.918336731803314],
            [27.318441062108736, -3.918551575546947],
            [27.318369758333059, -3.91809801686803],
            [27.318821349511225, -3.917763816384007],
            [27.319082797886459, -3.917095414107889],
            [27.319082797886459, -3.916713469964971],
            [27.31889265418523, -3.916450883377009],
            [27.318512365884413, -3.916546369008556],
            [27.318108310856122, -3.91688057088757],
            [27.317680487303765, -3.916928313228748],
            [27.31691991249879, -3.9169760564694],
            [27.31680107257321, -3.916498625743033],
            [27.316848607824781, -3.915806351240897],
            [27.316373249020849, -3.9156153788935],
            [27.315897889318585, -3.916212167896514],
            [27.315802817018806, -3.916952185300548],
            [27.315683977991551, -3.917334129333036],
            [27.314757026212796, -3.917023799707316],
            [27.31428166740886, -3.916594112271268],
            [27.31428166740886, -3.916164424611717],
            [27.314234131258953, -3.915734736728572],
            [27.313687467781008, -3.915758607932665],
            [27.313473556453982, -3.916140553419366],
            [27.313021964377487, -3.916665726709104],
            [27.31285558920036, -3.916450883377009],
            [27.312499069423644, -3.915997323544224],
            [27.312499069423644, -3.91537666317155],
            [27.31202370972138, -3.915472149829501],
            [27.311595886169023, -3.915901837849193],
            [27.31074023906427, -3.916307653555669],
            [27.310383719287557, -3.916999928539838],
            [27.310217344110431, -3.917596715640155],
            [27.309718216782361, -3.917978659374524],
            [27.30919532093019, -3.918002531415929],
            [27.308410977601117, -3.917310258174539],
            [27.308268370049763, -3.916594112271268],
            [27.307721706571822, -3.916641855531283],
            [27.30719881161798, -3.91688057088757],
            [27.306770988065619, -3.917477358074119],
            [27.306485772064583, -3.917811559576352],
            [27.306034180886417, -3.916832827641372],
            [27.305368677482928, -3.916832827641372],
            [27.305226069931575, -3.916999928539838],
            [27.305226069931575, -3.917405743706701],
            [27.305249837557344, -3.917811559576352],
            [27.305085229366377, -3.91810914494237],
            [27.305012157706212, -3.918241246378821],
            [27.304655637929532, -3.918432218118973],
            [27.303946187145673, -3.918201690022975],
            [27.30384752697465, -3.918169632077672],
            [27.303814638753781, -3.91821237780892],
            [27.303443471946359, -3.918694804076817],
            [27.303110719795448, -3.918670932957607],
            [27.30288204645338, -3.918288149569919],
            [27.302825504692741, -3.918193503211322],
            [27.302944343719993, -3.918050274594471],
            [27.303110719795448, -3.917525101283067],
            [27.303182023571125, -3.917023799707316],
            [27.303514775722039, -3.916928313228748],
            [27.304013903050109, -3.916737341140719],
            [27.303966366900198, -3.916212167896514],
            [27.303324632020811, -3.916164424611717],
            [27.303015648394002, -3.916785084392439],
            [27.302587824841609, -3.916808955566125],
            [27.302516521065932, -3.916522497827249],
            [27.302373912616282, -3.915997323544224],
            [27.301637105437081, -3.915997323544224],
            [27.301185514258915, -3.916236039086791],
            [27.300900298257911, -3.916498625743033],
            [27.300662618406779, -3.916832827641372],
            [27.300234794854386, -3.916952185300548],
            [27.299569292349194, -3.916904442058497],
            [27.298832485169989, -3.916952185300548],
            [27.29864234146876, -3.917238642890383],
            [27.298095677990819, -3.918026402554426],
            [27.297263798511842, -3.918193503211322],
            [27.296859743483584, -3.918050274594471],
            [27.296550759856775, -3.917429615764684],
            [27.296122936304382, -3.917119286174827],
            [27.29588525645325, -3.917334129333036],
            [27.29517221689985, -3.9177876875294],
            [27.294482945870556, -3.918670932957607],
            [27.293793674841258, -3.918957389951089],
            [27.292795420185154, -3.918957389951089],
            [27.292717450910082, -3.919114008352982],
            [27.292676580259574, -3.919196104637844],
            [27.292676580259574, -3.919936119367107],
            [27.292367596632761, -3.920318062018904],
            [27.291773397004945, -3.920532905246702],
            [27.291464413378137, -3.920365805063467],
            [27.291298037302685, -3.919840634127633],
            [27.291559484779587, -3.919363205057928],
            [27.291541829290999, -3.919209525254446],
            [27.29148818100391, -3.918742547215296],
            [27.290727606198935, -3.918933518839524],
            [27.290550118861749, -3.919290039025001],
            [27.290513693973608, -3.919363205057928],
            [27.290513693973608, -3.919959990449677],
            [27.290180942720994, -3.920246447897927],
            [27.28982442294431, -3.920103219637349],
            [27.28884993591398, -3.919745147974907],
            [27.288634981642883, -3.919445299513551],
            [27.288422112361584, -3.919148361525598],
            [27.288517184661366, -3.918432218118973],
            [27.288707328362623, -3.918074145731607],
            [27.288231968660359, -3.917572844489203],
            [27.287661537556613, -3.917286386113096],
            [27.287043570302991, -3.91769220204141],
            [27.286591979124832, -3.917262514953187],
            [27.286259226973918, -3.916713469964971],
            [27.285593724468725, -3.916713469964971],
            [27.28507082861659, -3.916641855531283],
            [27.284167645361929, -3.91640314010599],
            [27.283549678108312, -3.916498625743033],
            [27.28259895960208, -3.917071542942471],
            [27.281933456198587, -3.917214771729101],
            [27.281386792720646, -3.917143157338896],
            [27.281386792720646, -3.917596715640155],
            [27.281430875746576, -3.917624679296843],
            [27.281838383898808, -3.917883173908581],
            [27.281838383898808, -3.918479961272694],
            [27.281600704945973, -3.918575446669567],
            [27.280840129242705, -3.918503832397362],
            [27.280578681765768, -3.918814161466777],
            [27.280127090587602, -3.918670932957607],
            [27.280127090587602, -3.918145760041063],
            [27.280531145615893, -3.917668329991035],
            [27.280558050158628, -3.91760227787624],
            [27.280745057841223, -3.917143157338896],
            [27.280317234288866, -3.916665726709104],
            [27.279627963259568, -3.916999928539838],
            [27.279556658585562, -3.917501230130041],
            [27.279556658585562, -3.91757657790912],
            [27.279556658585562, -3.918050274594471],
            [27.279105067407396, -3.918050274594471],
            [27.278415796378102, -3.917883173908581],
            [27.278130580377063, -3.918169632077672],
            [27.277726525348804, -3.918527703521407],
            [27.277441309347765, -3.918169632077672],
            [27.27760768542322, -3.917835430720384],
            [27.277968792896083, -3.917535825166907],
            [27.278154348901165, -3.917381872550278],
            [27.278225652676838, -3.91688057088757],
            [27.278487100153775, -3.916450883377009],
            [27.279105067407396, -3.916450883377009],
            [27.279556658585562, -3.916379268920548],
            [27.279841874586598, -3.915806351240897],
            [27.280602449391573, -3.915209562846908],
            [27.280721289317121, -3.914636644356075],
            [27.280602449391573, -3.9142308278288],
            [27.280554914139994, -3.913275962927239],
            [27.279794338436695, -3.912535942230695],
            [27.279105067407396, -3.912631429216867],
            [27.278582172453557, -3.91215399598019],
            [27.277322469422216, -3.912058509841115],
            [27.277274933272313, -3.911437846510449],
            [27.277417541721995, -3.910530721996187],
            [27.276775805944276, -3.909814570218648],
            [27.275302191585904, -3.907976446109686],
            [27.273472058349117, -3.907976446109686],
            [27.271903371690968, -3.90819129164396],
            [27.271237868287475, -3.908143547895959],
            [27.271129489243393, -3.908143547895959],
            [27.270334685931147, -3.908143547895959],
            [27.269835557704749, -3.90847775317178],
            [27.26952657407794, -3.908525495998259],
            [27.268908606824318, -3.90847775317178],
            [27.268338175720608, -3.907689984408348],
            [27.266959763917729, -3.90664664281461],
            [27.266698185286781, -3.906448650727429],
            [27.266389201659972, -3.905756367812764],
            [27.26700716891359, -3.905469905343296],
            [27.26679325758656, -3.905111827342708],
            [27.266056450407358, -3.904658262194427],
            [27.264701675974536, -3.904109208839368],
            [27.263703421318432, -3.904300183842961],
            [27.263727188944237, -3.903607899132656],
            [27.264250084796377, -3.903225948762302],
            [27.264297620047948, -3.902724638521307],
            [27.263085454064814, -3.901817504460853],
            [27.262871541839488, -3.901531040629662],
            [27.262728934288134, -3.901244577601739],
            [27.262847774213682, -3.900981985202878],
            [27.26310922169062, -3.900146466005283],
            [27.262348646885645, -3.899000608680104],
            [27.261469231256793, -3.898905121024515],
            [27.261112712378406, -3.899239329124313],
            [27.260803728751597, -3.899167713178715],
            [27.260375905199204, -3.899382561899192],
            [27.260542280376363, -3.900146466005283],
            [27.261136480004179, -3.900313570273037],
            [27.261516767406665, -3.900456801960193],
            [27.261730679632027, -3.90086262524018],
            [27.261445463630988, -3.901316193367991],
            [27.261255319929759, -3.901745888737894],
            [27.261158844461484, -3.902294975237311],
            [27.261112712378406, -3.902557534739504],
            [27.260684888826017, -3.903082716651382],
            [27.259829241721263, -3.902987229465892],
            [27.259258810617517, -3.903011101037746],
            [27.25847446728844, -3.903393051507117],
            [27.257476212632337, -3.903655643142162],
            [27.256882013004525, -3.902772381679417],
            [27.256477957077937, -3.90284399821591],
            [27.255788686048639, -3.902939485417914],
            [27.253958551913556, -3.902867869791899],
            [27.253411889333911, -3.903345308384757],
            [27.25265131363064, -3.902748510100693],
            [27.25270880401218, -3.902568066639262],
            [27.252841457331865, -3.902151711386898],
            [27.252722617406317, -3.901960735888208],
            [27.252271026228154, -3.901912991781058],
            [27.251462915273272, -3.902080095692806],
            [27.251063544060884, -3.902202659351787],
            [27.250607268168523, -3.902342686841633],
            [27.250084372316351, -3.902581406323699],
            [27.249704084913866, -3.903082716651382],
            [27.249585244988317, -3.9035362835644],
            [27.249846693363551, -3.904013720869934],
            [27.249870460989321, -3.90441954331065],
            [27.249656549662287, -3.904467287273338],
            [27.249181189960023, -3.90441954331065],
            [27.249038581510373, -3.903918233791718],
            [27.248848437809116, -3.903440795528963],
            [27.248420614256752, -3.903440795528963],
            [27.24766003945178, -3.903488539548075],
            [27.24680439234703, -3.903393051507117],
            [27.246780624721225, -3.902867869791899],
            [27.247042072198163, -3.902223327074794],
            [27.24659048102, -3.902223327074794],
            [27.246067585167829, -3.902820125737013],
            [27.245592225465561, -3.902629150392337],
            [27.245283241838756, -3.902080095692806],
            [27.245425850288438, -3.901459424881972],
            [27.245284804009042, -3.900916384683695],
            [27.244380059482427, -3.900480673604906],
            [27.24376209222881, -3.900432930314817],
            [27.243565628879537, -3.900537395149033],
            [27.242953981273931, -3.90086262524018],
            [27.242383549271885, -3.901578784758782],
            [27.241836885793944, -3.901363937509503],
            [27.241813118168174, -3.900719393623137],
            [27.24148036691556, -3.900623906165417],
            [27.240933703437619, -3.90088649777545],
            [27.24019689625845, -3.901340064987986],
            [27.23950762522912, -3.901578784758782],
            [27.239056033152661, -3.90155491314567],
            [27.238342994497557, -3.90088649777545],
            [27.238392089224462, -3.900215438282595],
            [27.238770818049954, -3.899573537991679],
            [27.237891402421099, -3.899525793747093],
            [27.237677491094068, -3.899764514040186],
            [27.237525880626936, -3.900236563494335],
            [27.237439811242933, -3.900504546151168],
            [27.23772502724394, -3.9010774735216],
            [27.237629954944161, -3.901531040629662],
            [27.237059523840447, -3.901531040629662],
            [27.236679236437961, -3.901459424881972],
            [27.236441556586829, -3.900814881972087],
            [27.236171118770542, -3.900271640150612],
            [27.236037500660242, -3.900003234264542],
            [27.235538373332172, -3.900098721793723],
            [27.235421350698417, -3.900291052896229],
            [27.235276925855267, -3.900528417794483],
            [27.235063013629908, -3.900981985202878],
            [27.234658958601614, -3.901149089302279],
            [27.233874615272541, -3.900695521985293],
            [27.233830772096805, -3.90033223415278],
            [27.233779542972766, -3.899907745822135],
            [27.234088527497903, -3.898785760762934],
            [27.234397511124712, -3.898332192153574],
            [27.234231135049257, -3.898021855403857],
            [27.233589399271537, -3.898117343161071],
            [27.23330418416883, -3.898547040188221],
            [27.232876360616434, -3.899119968910771],
            [27.232305929512723, -3.899215457443862],
            [27.232068249661591, -3.898761888167209],
            [27.232068249661591, -3.898045727118607],
            [27.231901873586136, -3.897425053288841],
            [27.231664193735003, -3.89718633232269],
            [27.231046226481386, -3.89706697181384],
            [27.230261883152277, -3.896828250744691],
            [27.229643915898656, -3.896326936636931],
            [27.228954644869361, -3.895706261521928],
            [27.228455517541327, -3.895539156326368],
            [27.228075230138842, -3.895968854688193],
            [27.228075230138842, -3.89639855282766],
            [27.228336677615744, -3.896923739541488],
            [27.228360445241549, -3.89737730892067],
            [27.228345917686752, -3.897390076661988],
            [27.22798015783906, -3.897711517635803],
            [27.227528566660897, -3.897759261984775],
            [27.227076975482735, -3.898021855403857],
            [27.226221328377981, -3.897568285474694],
            [27.225627128750137, -3.896947611287853],
            [27.225508288824585, -3.896565657850235],
            [27.225341912749094, -3.895754005986202],
            [27.225208894713425, -3.895705908741443],
            [27.224747714019578, -3.895539156326368],
            [27.224319890467218, -3.8955630290148],
            [27.223983972653237, -3.895849809792463],
            [27.223844530764957, -3.895968854688193],
            [27.223535547138145, -3.896565657850235],
            [27.223321635811114, -3.897090843556096],
            [27.22287004373462, -3.89737730892067],
            [27.222323380256679, -3.897663774186341],
            [27.221848021452743, -3.897520541114767],
            [27.221729181527163, -3.897019227425072],
            [27.221990629004097, -3.896303064872679],
            [27.222050213358575, -3.8960769832257],
            [27.222204540331131, -3.895491412751975],
            [27.221824252928645, -3.895157202240795],
            [27.221515269301833, -3.895300434817908],
            [27.221230054199125, -3.895706261521928],
            [27.221004839370849, -3.896199790477193],
            [27.220968605823892, -3.896279192205556],
            [27.220730925972724, -3.896661145774976],
            [27.220421942345919, -3.896828250744691],
            [27.220065423467531, -3.896995355680756],
            [27.220326870944469, -3.897711517635803],
            [27.22087353442241, -3.897997982786147],
            [27.221111214273542, -3.898379935564601],
            [27.220659622197051, -3.898690272180391],
            [27.219946583541983, -3.898618656187391],
            [27.219399920064042, -3.898666400484127],
            [27.218972096511646, -3.899096097226923],
            [27.218758184286319, -3.898570911887844],
            [27.218710649034744, -3.897950238450915],
            [27.21773616200441, -3.897735390261769],
            [27.217284569927948, -3.897974111069998],
            [27.217141962376594, -3.898594784489079],
            [27.217498482153278, -3.899191584860489],
            [27.217498482153278, -3.8995974096618],
            [27.216975586301142, -3.899669025570299],
            [27.215787187943771, -3.899740641472615],
            [27.21512168454025, -3.899000608680104],
            [27.214622557212213, -3.898618656187391],
            [27.214313573585404, -3.898475424182855],
            [27.214052126108466, -3.89902448126896],
            [27.214052126108466, -3.899525793747093],
            [27.213814446257334, -3.899860001596835],
            [27.213529230256331, -3.899812257368761],
            [27.2133153189293, -3.899549665418638],
            [27.213053871452363, -3.899048352954869],
            [27.212935031526811, -3.898212831809553],
            [27.212649815525776, -3.897997982786147],
            [27.212317064273194, -3.898045727118607],
            [27.211746632271151, -3.898475424182855],
            [27.211271273467183, -3.898379935564601],
            [27.210890986064697, -3.897878622394036],
            [27.211199969691503, -3.897544413746191],
            [27.211770400795253, -3.897448925020804],
            [27.211812528188801, -3.897279678234002],
            [27.211865472196703, -3.89706697181384],
            [27.211722864645346, -3.896756634590997],
            [27.211199969691503, -3.896637274020393],
            [27.210819681390685, -3.897090843556096],
            [27.210320554062651, -3.897210204061472],
            [27.210082874211523, -3.897401180653981],
            [27.210082874211523, -3.897482873080139],
            [27.210082874211523, -3.897783134609368],
            [27.210368090212526, -3.898093471448369],
            [27.210653306213562, -3.898618656187391],
            [27.210106642735621, -3.898833505050064],
            [27.20977389058471, -3.898642528787239],
            [27.209274763256641, -3.898141214873111],
            [27.209138510387621, -3.897593814635558],
            [27.209132155705287, -3.897568285474694],
            [27.209464906957901, -3.897257948439299],
            [27.20955997925768, -3.896732762839161],
            [27.209322299406548, -3.896446297252139],
            [27.208751868302802, -3.896541786092866],
            [27.208300276226343, -3.897234076701891],
            [27.2077773812725, -3.897114716199898],
            [27.207801148898273, -3.896350808400407],
            [27.207397093870014, -3.896207576004497],
            [27.206993037943423, -3.896255320439994],
            [27.20694550179352, -3.89658952960688],
            [27.206802894242166, -3.897162460583208],
            [27.206615704201596, -3.897308690089495],
            [27.206588982915132, -3.897329564549713],
            [27.206375070689806, -3.897329564549713],
            [27.206316091799806, -3.897237416832354],
            [27.206161159362775, -3.896995355680756],
            [27.206351303064, -3.896207576004497],
            [27.206137390838677, -3.895944982913725],
            [27.205566959734927, -3.895372051999443],
            [27.205804639586059, -3.894990096934768],
            [27.205638263510604, -3.894321677178881],
            [27.205519423585024, -3.894250059906751],
            [27.204972760107083, -3.894250059906751],
            [27.204687545004372, -3.894560398066433],
            [27.203855665525428, -3.894584270782981],
            [27.203689290348265, -3.894082955320458],
            [27.204069577750751, -3.893223556423],
            [27.203641754198394, -3.892913217763907],
            [27.202928714644994, -3.893175811813234],
            [27.202762338569542, -3.892913217763907],
            [27.202500891092605, -3.892674495500764],
            [27.202239443615699, -3.892173178885824],
            [27.202286979765571, -3.891552500667197],
            [27.202001763764567, -3.891266033293709],
            [27.201597708736276, -3.891433139348756],
            [27.201360028885144, -3.891791223252644],
            [27.201336260361042, -3.892388028513993],
            [27.200979740584327, -3.892746112006457],
            [27.200385541854811, -3.892197050768698],
            [27.200314238079134, -3.891719606664664],
            [27.200385541854811, -3.891266033293709],
            [27.200599453181841, -3.891003438640954],
            [27.200195398153586, -3.890669227226751],
            [27.199886414526777, -3.890406631483219],
            [27.199434822450279, -3.890120164617155],
            [27.198935695122245, -3.889881441551877],
            [27.198650480019538, -3.889976930244874],
            [27.198293960242822, -3.890000803093097],
            [27.197794832914784, -3.889475612003156],
            [27.197723529139111, -3.88852071949307],
            [27.197462080763877, -3.888377484845302],
            [27.196939185810031, -3.888281995968698],
            [27.196321218556417, -3.888401357739427],
            [27.196083538705285, -3.888926548605445],
            [27.195489339077433, -3.888592336356576],
            [27.195322963900278, -3.888162634180807],
            [27.195322963900278, -3.887637441930218],
            [27.194942675599492, -3.887637441930218],
            [27.194633691972683, -3.887971655465049],
            [27.194633691972683, -3.888258123973385],
            [27.194633691972683, -3.888783314929832],
            [27.194633691972683, -3.889069783158674],
            [27.194498225129525, -3.889141815916318],
            [27.194229636944392, -3.889284633588864],
            [27.193706741092253, -3.889069783158674],
            [27.193691910805207, -3.888682491941308],
            [27.193682973466451, -3.888449102623408],
            [27.19333548624995, -3.888479451033928],
            [27.19313630998851, -3.888496846602355],
            [27.192898630137378, -3.888974293459286],
            [27.192494575109119, -3.889213016784975],
            [27.192447038959212, -3.888902676628655],
            [27.192542110360694, -3.888234251075138],
            [27.192819880226324, -3.888185731137423],
            [27.193088773838635, -3.888138762182084],
            [27.193255149914094, -3.887732931783112],
            [27.193041237688732, -3.887637441930218],
            [27.192518342734889, -3.88766131484564],
            [27.192283608459572, -3.887880239345443],
            [27.192185591482307, -3.887971655465049],
            [27.192185591482307, -3.88861620834227],
            [27.191781535555723, -3.888974293459286],
            [27.191234872077782, -3.889022038310328],
            [27.191020960750748, -3.888711698082777],
            [27.191187335927872, -3.888401357739427],
            [27.191496319554684, -3.888043272375817],
            [27.191472551928914, -3.887685186858039],
            [27.191234872077782, -3.887709059772036],
            [27.190569368674254, -3.888091017280306],
            [27.190569368674254, -3.888640081229551],
            [27.190307921197316, -3.88887880465114],
            [27.189880097644959, -3.888783314929832],
            [27.189547346392345, -3.888162634180807],
            [27.18916705898986, -3.887995527468542],
            [27.189048219064311, -3.888425229730644],
            [27.189262130391338, -3.888902676628655],
            [27.18916705898986, -3.88935625038657],
            [27.188691699287595, -3.889308506456959],
            [27.188549090837945, -3.888568464370155],
            [27.188691699287595, -3.888281995968698],
            [27.188596626987813, -3.887923910553678],
            [27.18843025181069, -3.887900038548123],
            [27.18778851603297, -3.887900038548123],
            [27.187740979883063, -3.887422591074635],
            [27.187455764780356, -3.887112250250436],
            [27.187123012629446, -3.886587057336931],
            [27.187133568732335, -3.886575041013743],
            [27.187479532406158, -3.88618122708345],
            [27.188097499659779, -3.886133482069372],
            [27.188097499659779, -3.885632161511804],
            [27.187479532406158, -3.885154712737329],
            [27.188002428258297, -3.884581774387953],
            [27.187883588332745, -3.884247560394308],
            [27.18759837233171, -3.884008835644328],
            [27.187075477377867, -3.883770110825941],
            [27.186291134048794, -3.883507513807566],
            [27.185910846646308, -3.883125553294016],
            [27.186148525599112, -3.882719721353492],
            [27.186433741600148, -3.882170653499581],
            [27.187004172703894, -3.880881536364554],
            [27.187289388704901, -3.879544672746248],
            [27.186338670198701, -3.87832716929655],
            [27.186338670198701, -3.877420008619445],
            [27.186148525599112, -3.876870937275321],
            [27.185530558345491, -3.876584465753905],
            [27.184888823466103, -3.876536720190012],
            [27.183866800285895, -3.875701175537738],
            [27.182916081779663, -3.87465077590086],
            [27.181109716168709, -3.873624248259791],
            [27.180967107719027, -3.873194538367183],
            [27.180800732541869, -3.872311245466754],
            [27.180943340093222, -3.869995580096909],
            [27.180658124092218, -3.869422631336713],
            [27.179659869436112, -3.868587079568114],
            [27.178590311004331, -3.866987593146816],
            [27.178400167303071, -3.865244865950323],
            [27.176879016794828, -3.862451720160922],
            [27.175809457464716, -3.861090953383071],
            [27.176023369690039, -3.860517998526463],
            [27.176546264643914, -3.859324340189038],
            [27.176974088196275, -3.858512652089924],
            [27.177235536571509, -3.857891948842521],
            [27.177188000421637, -3.857104132243063],
            [27.176546264643914, -3.857104132243063],
            [27.17599960206427, -3.857581597046528],
            [27.175167722585293, -3.85793969547073],
            [27.174003091853731, -3.857915822608105],
            [27.17336135697434, -3.85729511891891],
            [27.172630758950376, -3.857017451592113],
            [27.172481941345488, -3.856960893109924],
            [27.171412382913704, -3.856053709259984],
            [27.171103399286864, -3.856101455992834],
            [27.170889487061533, -3.856674414770276],
            [27.170437895883371, -3.857509977523812],
            [27.170081376106655, -3.857963568332642],
            [27.169653552554294, -3.857772582711315],
            [27.169297033675914, -3.857533850397938],
            [27.16903558530068, -3.856960893109924],
            [27.16844138657116, -3.855958216688479],
            [27.167958936466338, -3.854989042220155],
            [27.167918490718989, -3.854907792270525],
            [27.166539948660397, -3.853427646499725],
            [27.165803141481195, -3.852544332748509],
            [27.164495903198279, -3.851780384166317],
            [27.164353294748629, -3.850443474054358],
            [27.164709814525313, -3.850324106863837],
            [27.165399085554608, -3.850133119504145],
            [27.166254732659361, -3.849727270656734],
            [27.166920236062882, -3.849560156262311],
            [27.16665878858598, -3.848915573276178],
            [27.166349804959168, -3.848461977578517],
            [27.165826909106997, -3.84824711575577],
            [27.165399085554608, -3.84824711575577],
            [27.165090101927799, -3.848915573276178],
            [27.164424598524306, -3.849584030264872],
            [27.163877935944662, -3.850300232882306],
            [27.163212432541172, -3.850515094180082],
            [27.162546929137648, -3.850419600076224],
            [27.162356785436419, -3.850180865671403],
            [27.16226171313664, -3.848915573276178],
            [27.162428089212096, -3.848557471002537],
            [27.163259967792744, -3.848605218161645],
            [27.163925471196237, -3.848557471002537],
            [27.164210687197276, -3.848127748253275],
            [27.164258223347147, -3.84729217616331],
            [27.163806631270688, -3.846337234583983],
            [27.163450112392304, -3.845048062273316],
            [27.163521416167978, -3.844618337730691],
            [27.163949239720338, -3.84442734907491],
            [27.164424598524306, -3.84442734907491],
            [27.165185174227574, -3.844785453107308],
            [27.165969517556654, -3.845310672259614],
            [27.166848932287206, -3.8458836374953],
            [27.16718168353982, -3.845644901802291],
            [27.166587484810304, -3.844594464489465],
            [27.166421108734848, -3.844355728430604],
            [27.166135892733809, -3.844116992304009],
            [27.165850677631102, -3.843973750956441],
            [27.165446621704511, -3.843663394018254],
            [27.165018798152122, -3.843400784420111],
            [27.164305758598722, -3.843209795488017],
            [27.163711559869206, -3.842421965120955],
            [27.16375909601911, -3.841753502440544],
            [27.16364025609353, -3.840177839146329],
            [27.163616487569428, -3.83903189961558],
            [27.164377063272731, -3.838697667447596],
            [27.165375317928838, -3.837599473687261],
            [27.165208941853383, -3.837289114400235],
            [27.164852422076667, -3.837169745343822],
            [27.163973007346144, -3.836931007180323],
            [27.16311736024139, -3.836811638073238],
            [27.162190409360964, -3.836931007180323],
            [27.161524905957439, -3.837217493148875],
            [27.160336507600071, -3.837790463891538],
            [27.159718540346454, -3.837623347126787],
            [27.159362020569773, -3.836692268949219],
            [27.158696517166248, -3.83554632558183],
            [27.157555654958788, -3.833851280255354],
            [27.157508118808916, -3.833063442042437],
            [27.157080295256524, -3.831750374915277],
            [27.15672377547984, -3.830723794821556],
            [27.156652471704163, -3.829434598629363],
            [27.156319720451553, -3.827381430662641],
            [27.155582913272347, -3.826354844357552],
            [27.155392769571122, -3.825399879968113],
            [27.154394514016687, -3.822869217993119],
            [27.153919155212751, -3.822343984871206],
            [27.153277419435032, -3.821914248766247],
            [27.15251684463006, -3.821221895944389],
            [27.151803805076661, -3.820768285354532],
            [27.150662942869168, -3.820052056757768],
            [27.149355704586252, -3.819025461559796],
            [27.148191073854694, -3.818858341985992],
            [27.145814276241662, -3.818906089923394],
            [27.145029932912589, -3.818643472625077],
            [27.144221821957746, -3.818476352975906],
            [27.143984142106614, -3.81892996479342],
            [27.142962119824702, -3.819693942232186],
            [27.141963864270299, -3.820625039142229],
            [27.141203289465292, -3.820362422376947],
            [27.14101314576407, -3.819789439814744],
            [27.141108218063845, -3.818547975815623],
            [27.141108218063845, -3.817067766223163],
            [27.141512273092104, -3.816518655468252],
            [27.142819511375052, -3.815850172290692],
            [27.142843279899154, -3.814417707079507],
            [27.143413711002868, -3.813653723982407],
            [27.144055445882291, -3.812674871128158],
            [27.143580087078323, -3.81205413414648],
            [27.143104727376056, -3.811600517748002],
            [27.142486760122438, -3.811266274738194],
            [27.141726185317463, -3.811266274738194],
            [27.140205034809188, -3.810860407211424],
            [27.139682138957049, -3.810550038113799],
            [27.138374900674137, -3.809977048920572],
            [27.138089684673098, -3.80961893014007],
            [27.136497231287475, -3.808377451253586],
            [27.135617815658623, -3.807780585411322],
            [27.134904777003523, -3.807828334874589],
            [27.134334345001477, -3.808114830695582],
            [27.133621306346413, -3.808974316676411],
            [27.132694355465983, -3.810048672478076],
            [27.132327458351096, -3.810526781113097],
            [27.131814939837099, -3.811194651283422],
            [27.131006828882253, -3.811648266996466],
            [27.130341326377057, -3.811003655073685],
            [27.130246254077278, -3.810120296029525],
            [27.130959293630678, -3.810000923139653],
            [27.131571997655033, -3.809584587811963],
            [27.131767404585556, -3.809451808712677],
            [27.131791172211326, -3.80859232321505],
            [27.131814939837099, -3.80780446059448],
            [27.131719868435649, -3.806849474401486],
            [27.131814939837099, -3.80589448803757],
            [27.132147691988042, -3.804820126982863],
            [27.131838708361233, -3.804772377350581],
            [27.131149437331903, -3.804748502082249],
            [27.13048393392841, -3.804963374961315],
            [27.129319303196851, -3.805464743598171],
            [27.128630032167557, -3.805416994002072],
            [27.128416119942194, -3.804820126982863],
            [27.128748872093105, -3.804008385576164],
            [27.129461910748205, -3.803029521606653],
            [27.128867712018685, -3.801811907544972],
            [27.128202208615161, -3.800379418660601],
            [27.128225976240966, -3.799591548430694],
            [27.128820175868782, -3.798087431251039],
            [27.12879640734468, -3.797800932052703],
            [27.128344816166514, -3.79739505809863],
            [27.127679312763025, -3.797156309632094],
            [27.126752361882563, -3.796965310269256],
            [27.125920483301911, -3.796702685285879],
            [27.124898460121706, -3.796702685285879],
            [27.124423100419442, -3.796058062034318],
            [27.124304260493894, -3.794458438197334],
            [27.123828901689926, -3.79321693719284],
            [27.122711807108271, -3.793002061349598],
            [27.122402823481462, -3.792357435299823],
            [27.122212678881869, -3.791569557653333],
            [27.122141375106192, -3.790519053293727],
            [27.121238192749868, -3.789253671756192],
            [27.121642247778158, -3.788250915107165],
            [27.12180862385361, -3.787081030560961],
            [27.121594711628248, -3.786340898712441],
            [27.120786600673405, -3.785553015513758],
            [27.119360522464909, -3.785290387920189],
            [27.119099074988004, -3.78607827045869],
            [27.118623715285739, -3.786555775330148],
            [27.117744300555184, -3.787176530903095],
            [27.117126333301563, -3.78720040666374],
            [27.116793581150656, -3.786794527665816],
            [27.116437062272269, -3.785505264802086],
            [27.115367502942156, -3.785027759343574],
            [27.113062010003134, -3.784932258761295],
            [27.112253899048291, -3.784550254520678],
            [27.112182594374282, -3.784024997734242],
            [27.112824330152005, -3.783690743903883],
            [27.113370993629946, -3.782735730692942],
            [27.113370993629946, -3.782377601366255],
            [27.112301434299834, -3.78125545883035],
            [27.112182594374282, -3.78015719168229],
            [27.112919401553484, -3.779226050509969],
            [27.113370993629946, -3.779106673293894],
            [27.114084032285042, -3.778772416639443],
            [27.114939679389796, -3.778772416639443],
            [27.115795326494549, -3.778390409648015],
            [27.116270686196813, -3.77769802142881],
            [27.116579669823622, -3.776886255124132],
            [27.116841117300524, -3.776313242408604],
            [27.116722277374976, -3.774928462052259],
            [27.115961702570004, -3.774212194912478],
            [27.114416784435956, -3.773973439968602],
            [27.112966937703359, -3.772970664507572],
            [27.112206362898384, -3.772254396634368],
            [27.111113035942498, -3.770988987182657],
            [27.111635931794638, -3.770439846753246],
            [27.112491578001091, -3.768959553645744],
            [27.111921146897348, -3.768529790623331],
            [27.111374483419404, -3.768434288201572],
            [27.110352461137527, -3.768529790623331],
            [27.109187830405968, -3.767765767342174],
            [27.108046967300176, -3.767503134295048],
            [27.106953640344294, -3.767527009701773],
            [27.106406977764646, -3.766858488135987],
            [27.106430745390451, -3.766142215161286],
            [27.106739729017264, -3.765593071631497],
            [27.107215088719528, -3.764590287281135],
            [27.107167552569621, -3.764065018262401],
            [27.107143784943851, -3.762895100692167],
            [27.107547839972142, -3.762513086631028],
            [27.108783774479381, -3.761605801878793],
            [27.109140294256061, -3.759791230405382],
            [27.109021454330513, -3.758597431367494],
            [27.108474790852569, -3.758597431367494],
            [27.107595376122013, -3.758764563639332],
            [27.106454513016224, -3.759027199356318],
            [27.105099738583437, -3.759647974860937],
            [27.103840036450393, -3.760340377641243],
            [27.103103229271223, -3.7605313851756],
            [27.10230562591023, -3.760353375760047],
            [27.102186785984646, -3.759708725141059],
            [27.102353162060101, -3.757106239433558],
            [27.102139249834774, -3.75242652267192],
            [27.101402442655569, -3.752283265000117],
            [27.098859269865418, -3.753596454470658],
            [27.097765942909536, -3.753787463501059],
            [27.096577544552172, -3.753429321195953],
            [27.096434936102519, -3.751948998811445],
            [27.098526517714507, -3.751925122972469],
            [27.099501004744841, -3.751375970371267],
            [27.099405933343363, -3.749656881863793],
            [27.09805115891054, -3.747484140450759],
            [27.097528263058404, -3.746314200362643],
            [27.097433191656922, -3.745072629703226],
            [27.096934063430552, -3.743258022527707],
            [27.095935808774453, -3.740368970622786],
            [27.094818714192797, -3.739175143808364],
            [27.093772923386783, -3.73915126761622],
            [27.092489452729641, -3.738339464960474],
            [27.0902790311921, -3.737288895528029],
            [27.088139914328501, -3.735641408770269],
            [27.088448897955313, -3.734710219451741],
            [27.090255263566295, -3.734996739695756],
            [27.0909920707455, -3.734065549684173],
            [27.090801927044236, -3.732704577797517],
            [27.089613527788575, -3.732609070506557],
            [27.088781649207924, -3.731677877929106],
            [27.087022818848521, -3.729624475447238],
            [27.086166692043417, -3.728922103277429],
            [27.085596740640053, -3.728454511215595],
            [27.085596740640053, -3.728072481921202],
            [27.085786884341282, -3.727356175864102],
            [27.086594995296156, -3.727093530522644],
            [27.086821988788653, -3.727345996443172],
            [27.087260498699649, -3.727833713301195],
            [27.088116145804399, -3.728191866206543],
            [27.088924256759281, -3.728000851522579],
            [27.090445407267556, -3.726974146086226],
            [27.09053541127248, -3.726506994263948],
            [27.090588014818913, -3.726233962574659],
            [27.090160191266516, -3.725613163072106],
            [27.089399616461545, -3.72609070146806],
            [27.08873411305802, -3.725756424257506],
            [27.088520201730987, -3.724968486542908],
            [27.089470920237222, -3.724347685233266],
            [27.092584525029416, -3.723488115469781],
            [27.092228005252736, -3.721291430815432],
            [27.091229750596632, -3.720455734736568],
            [27.089375848835775, -3.718688830444978],
            [27.089565992537004, -3.71651601138575],
            [27.087967376708523, -3.714302917123895],
            [27.087617018476365, -3.713817887376387],
            [27.087331802475326, -3.711931584013018],
            [27.087403107149335, -3.710546699583976],
            [27.08863904165657, -3.709925888888618],
            [27.089470920237222, -3.70851712423987],
            [27.090350334967781, -3.708421615194554],
            [27.091372358147986, -3.708779776091071],
            [27.091752645550471, -3.707776925029784],
            [27.088472665581119, -3.70553244651665],
            [27.089874976163809, -3.703646125236097],
            [27.089280776535993, -3.702691023568829],
            [27.090778158520138, -3.700613675462393],
            [27.092228005252736, -3.69999285770427],
            [27.094058139387823, -3.700518164650254],
            [27.095769433597326, -3.701449390562551],
            [27.097433191656922, -3.702165717928769],
            [27.097632110101863, -3.701937334000771],
            [27.098431446313025, -3.70101959404148],
            [27.098811733715547, -3.699945102265568],
            [27.097361886982949, -3.699419794072845],
            [27.096176822273613, -3.698361541921081],
            [27.096078417224135, -3.698273667488395],
            [27.096170279843381, -3.698186810120522],
            [27.098098694162118, -3.696363452274984],
            [27.098074926536345, -3.694692010655955],
            [27.097147975655915, -3.693283221451352],
            [27.096993362120791, -3.69165227129791],
            [27.096957831954658, -3.691277484432495],
            [27.097455600131685, -3.6909249757475],
            [27.099857524521525, -3.689223985897545],
            [27.099073181192448, -3.688030089882268],
            [27.097837246685209, -3.688030089882268],
            [27.096848378525511, -3.68902353276538],
            [27.095983344924356, -3.689892567281003],
            [27.095151465445372, -3.690417881189831],
            [27.094438426790308, -3.69008359031087],
            [27.094226372280946, -3.689509578015209],
            [27.093128160286543, -3.686536816684388],
            [27.092727132580769, -3.68545126807804],
            [27.09374915576101, -3.68456778143864],
            [27.095365377670738, -3.684209610633474],
            [27.096548731987767, -3.683734076293778],
            [27.099905060671432, -3.680030943156206],
            [27.100095204372657, -3.678669887014327],
            [27.097979854236566, -3.675685106718779],
            [27.096553776028067, -3.675016514523025],
            [27.095864504998772, -3.674061382578569],
            [27.096173488625581, -3.672795831043618],
            [27.096831557571797, -3.672196095577736],
            [27.097305740481062, -3.67176394638173],
            [27.099501004744841, -3.669763274657708],
            [27.100071435848555, -3.665751687816469],
            [27.100190275774139, -3.662504199054243],
            [27.098265070237574, -3.660164089628503],
            [27.097623335358183, -3.659113426293464],
            [27.097956086610761, -3.658349307048306],
            [27.09790855046089, -3.654934639864686],
            [27.100000132072879, -3.653406392594257],
            [27.100118971998459, -3.650779711408396],
            [27.099453468594938, -3.649490247886779],
            [27.099049413566679, -3.648272418502424],
            [27.097813479059408, -3.647914232964929],
            [27.096743600827391, -3.646861748262734],
            [27.096672615953651, -3.646791918065961],
            [27.09670495440556, -3.646687230070162],
            [27.096886528178981, -3.64609942528195],
            [27.09790855046089, -3.645717360128546],
            [27.098669126164193, -3.64509650367783],
            [27.099120717342355, -3.642589193807606],
            [27.099358397193487, -3.640678857941648],
            [27.099049413566679, -3.63683429491448],
            [27.098526517714507, -3.632440488124416],
            [27.099905060671432, -3.632273331733389],
            [27.099809988371653, -3.629574949649672],
            [27.099905060671432, -3.628309334574515],
            [27.099334025001504, -3.623829919826685],
            [27.099287093417811, -3.623461772169569],
            [27.10002390059698, -3.622984178105079],
            [27.100148835591771, -3.623136596892852],
            [27.100689403102177, -3.623796087321176],
            [27.102353162060101, -3.624034884168198],
            [27.103993151595631, -3.623414012594085],
            [27.103898080194181, -3.62179019272895],
            [27.103208808266558, -3.619545494746551],
            [27.102720550553432, -3.617606632438493],
            [27.102709680938489, -3.617563470106234],
            [27.10287605701394, -3.616918714525457],
            [27.103131563033575, -3.616975760723289],
            [27.104159527671086, -3.617205272217602],
            [27.105181549952995, -3.615820240115075],
            [27.106393716834429, -3.615844119654714],
            [27.107748491267248, -3.614482965021222],
            [27.108984425774487, -3.614196406457261],
            [27.109459785476755, -3.613575528050592],
            [27.108865585848939, -3.611665130044609],
            [27.107558347565991, -3.610709929062397],
            [27.107415740014638, -3.609157726197188],
            [27.106845308910923, -3.606578675077551],
            [27.109745001477791, -3.605910031786377],
            [27.110576880058439, -3.604811543879439],
            [27.111099775910578, -3.60261456403253],
            [27.111575134714545, -3.601014586392449],
            [27.111693974640094, -3.598578794592562],
            [27.111503830938869, -3.597742982504976],
            [27.110600648582544, -3.595928071984207],
            [27.111080291452065, -3.595056922876042],
            [27.111218615836158, -3.594805691776124],
            [27.111765140075221, -3.59459573768127],
            [27.112026726791008, -3.594495245920303],
            [27.113595412550858, -3.594113158705019],
            [27.114379755879931, -3.59456688714229],
            [27.115164099209007, -3.594447484801614],
            [27.116352497566375, -3.592871373684078],
            [27.116281193790694, -3.592035555392821],
            [27.115473082835816, -3.591772869844953],
            [27.114902650833773, -3.591032573141592],
            [27.114902650833773, -3.589862425469804],
            [27.115449314311718, -3.587641528827319],
            [27.115187866834813, -3.585540030252053],
            [27.117113072371346, -3.583940022270524],
            [27.117255680820996, -3.583104196603217],
            [27.116827857268635, -3.582148965290268],
            [27.119062046431981, -3.580142977689121],
            [27.120416820864804, -3.580548951299959],
            [27.123506657132896, -3.580644475006944],
            [27.124790127790039, -3.579951931061599],
            [27.124885200089818, -3.577969819128885],
            [27.122983762179057, -3.575677250521796],
            [27.122817386103598, -3.57386229561547],
            [27.126287509774183, -3.574363796415861],
            [27.12719069302884, -3.573575724120556],
            [27.12714315687893, -3.571474192841237],
            [27.125669542520562, -3.568632341632989],
            [27.125622007268984, -3.567056184581297],
            [27.12512287994095, -3.564405369474753],
            [27.123268977281764, -3.562256055026213],
            [27.121676523896138, -3.561659021830719],
            [27.12127246796955, -3.560823174697861],
            [27.121224931819647, -3.559270886028169],
            [27.121389929879456, -3.558640903177074],
            [27.121462611670779, -3.558363393518031],
            [27.122128115074304, -3.55745589919957],
            [27.123863176909612, -3.556620048202007],
            [27.125812150970248, -3.556309589244947],
            [27.128688075013009, -3.557049914344746],
            [27.131112408775913, -3.559748513871269],
            [27.131317580393549, -3.559760742313385],
            [27.133917029043001, -3.559915683737569],
            [27.134606300970596, -3.559366411977904],
            [27.134653836222171, -3.558267867462919],
            [27.132277039507475, -3.554948344805707],
            [27.132277039507475, -3.553133349353899],
            [27.133560510164617, -3.549025714380285],
            [27.13472514089618, -3.547592813222277],
            [27.134986588373081, -3.546542018150483],
            [27.133631813940294, -3.545825566804526],
            [27.133441670239034, -3.544918059996027],
            [27.134392388745265, -3.543819498057823],
            [27.134416157269367, -3.540117813724077],
            [27.135176732074342, -3.538780426692103],
            [27.132633559284155, -3.538828190741801],
            [27.128593003611531, -3.540929797430698],
            [27.127166925403035, -3.540953678948363],
            [27.123649265582582, -3.539616293139427],
            [27.122175651224175, -3.541216379212148],
            [27.121937971373047, -3.544512070457174],
            [27.121841756416224, -3.54451950621094],
            [27.120702036865808, -3.544607597052078],
            [27.120678268341706, -3.546255438040669],
            [27.120345517089124, -3.546852480436273],
            [27.11915711873176, -3.546398728106829],
            [27.118818780856429, -3.545917121755954],
            [27.118301471627007, -3.545180759119342],
            [27.118325239252812, -3.541383552478232],
            [27.116780321118732, -3.539711821148952],
            [27.117089304745541, -3.539019246012925],
            [27.118919438880628, -3.536869870782752],
            [27.122318258775532, -3.536057883470832],
            [27.123292745805863, -3.534839900700564],
            [27.123374540107445, -3.534731840122351],
            [27.125859687120119, -3.531448646638506],
            [27.128452042672091, -3.531941788986053],
            [27.126889920003734, -3.527939946610007],
            [27.129020040239734, -3.52181996253386],
            [27.127940039791092, -3.512520012193077],
            [27.132490080366985, -3.503760004904231],
            [27.1332152570582, -3.50051684123804],
            [27.133576369920938, -3.498900183667122],
            [27.133226858800079, -3.497793365118377],
            [27.131943388142968, -3.494569156357505],
            [27.129923110306656, -3.49079562266705],
            [27.128877319500642, -3.488431186265067],
            [27.128972390902092, -3.487308673980265],
            [27.129445706038798, -3.485406230172622],
            [27.129471519128458, -3.48530247858301],
            [27.129661662829719, -3.483941128979162],
            [27.128901087126415, -3.482603660409954],
            [27.127807761068862, -3.482030459392002],
            [27.126548058037525, -3.4815050241379],
            [27.124908067603663, -3.480788522188861],
            [27.12360082932075, -3.479713766875737],
            [27.123481989395199, -3.479212214332238],
            [27.123695901620529, -3.477564254328537],
            [27.124004885247338, -3.475868523196153],
            [27.123862276797688, -3.474578810392889],
            [27.123648365470654, -3.474029487680355],
            [27.121794463709801, -3.473623466925465],
            [27.121461711558887, -3.473026376196587],
            [27.120178241800073, -3.47137840434102],
            [27.120178241800073, -3.470518592762572],
            [27.11984548964913, -3.469754313834345],
            [27.119726649723582, -3.467939150562211],
            [27.119726649723582, -3.466888264758326],
            [27.119750418247683, -3.465455236919333],
            [27.120059401874492, -3.464786489601033],
            [27.120867512829367, -3.46278024477306],
            [27.120772440529592, -3.461968192392678],
            [27.119797953499258, -3.460415737216165],
            [27.119108682469964, -3.458672207629947],
            [27.119061146320053, -3.457191398930206],
            [27.120130705650169, -3.45621215306395],
            [27.121128960306272, -3.454898529370203],
            [27.122269823412061, -3.453895397341565],
            [27.123125469618483, -3.453178873290482],
            [27.123624597844849, -3.451674172083089],
            [27.123790973022007, -3.449906741452713],
            [27.123838509171883, -3.448067654851927],
            [27.124361405024054, -3.44708840035624],
            [27.125264587380379, -3.446252449509336],
            [27.127308632842496, -3.444867158979184],
            [27.128544567349735, -3.443983437219187],
            [27.129780502755303, -3.443099715530638],
            [27.129946877932429, -3.442526490280446],
            [27.130327165334915, -3.441547229105086],
            [27.130446005260499, -3.439755895289783],
            [27.130731221261502, -3.438537786093968],
            [27.130802525037176, -3.437558521668666],
            [27.131277884739443, -3.435791064485505],
            [27.13227613939555, -3.431300753553519],
            [27.132585123022356, -3.428721204404513],
            [27.13227613939555, -3.426738767879121],
            [27.13049354141037, -3.42458913293662],
            [27.128615872023708, -3.423657623092988],
            [27.127379937516473, -3.42435028420741],
            [27.126619361813201, -3.424302514273801],
            [27.125977626933778, -3.424684671869748],
            [27.12514574745483, -3.425496756473588],
            [27.124361405024054, -3.427073154695864],
            [27.1235057579193, -3.427909122573709],
            [27.122412430963418, -3.428936166726833],
            [27.12053476067846, -3.430536443563677],
            [27.118466947590541, -3.431181330045616],
            [27.116232757528898, -3.430990252582006],
            [27.115448415098122, -3.430560327921718],
            [27.11542464657402, -3.430058749054141],
            [27.115567255023706, -3.428816742919564],
            [27.115543486499604, -3.426882076400411],
            [27.115091895321438, -3.425281793368177],
            [27.114735375544722, -3.424517478504734],
            [27.11364204858884, -3.424063665472151],
            [27.113261761186354, -3.423442658666451],
            [27.113285529710453, -3.421579635801469],
            [27.11364204858884, -3.420146538861859],
            [27.113903496964074, -3.418474589538189],
            [27.114616535619138, -3.416444361195813],
            [27.115258271396893, -3.415441188213781],
            [27.116304062202872, -3.414318588531306],
            [27.118704627441673, -3.412981020716744],
            [27.119084914844159, -3.412049499449819],
            [27.119298826171185, -3.410711928434385],
            [27.119346362321096, -3.409637093828685],
            [27.119227522395512, -3.406985828967562],
            [27.118752162693248, -3.403594109985519],
            [27.118015355514078, -3.400560661098244],
            [27.117373620634655, -3.398315425226697],
            [27.116755653381034, -3.396476238245239],
            [27.116185222277323, -3.394637047713239],
            [27.116185222277323, -3.393251681612331],
            [27.115377111322442, -3.391125857084808],
            [27.115234502872791, -3.390027114075629],
            [27.114545231843465, -3.387208593774289],
            [27.113380601111903, -3.385799331407574],
            [27.112382346455796, -3.385106641292726],
            [27.111693075426501, -3.384700582270789],
            [27.111098875798689, -3.38448560903409],
            [27.110599748470616, -3.38472446778173],
            [27.109553957664605, -3.384557266484094],
            [27.108199183231818, -3.384605038415384],
            [27.106582961322093, -3.385393271777108],
            [27.105941225544374, -3.386157618111453],
            [27.105299490664951, -3.387065279266495],
            [27.103968483857933, -3.388976141514381],
            [27.103897180082257, -3.390767571342157],
            [27.103707036381, -3.391364714171816],
            [27.1029939968276, -3.39234402633947],
            [27.102209654396855, -3.392773968323464],
            [27.101520382469232, -3.392965053487171],
            [27.100569663963029, -3.392821739843674],
            [27.099832856783827, -3.392487340957502],
            [27.098478082351008, -3.391818541930723],
            [27.097931418873067, -3.391364714171816],
            [27.097265915469574, -3.390576485738337],
            [27.096410268364824, -3.39012265648593],
            [27.09607751711221, -3.389453856704558],
            [27.094698974155285, -3.387638538071449],
            [27.094152311575677, -3.386874192921746],
            [27.093819559424762, -3.386300933658156],
            [27.093795791798961, -3.385536586535669],
            [27.092892608544336, -3.384413951578706],
            [27.092227105140811, -3.383100228204391],
            [27.091870586262427, -3.381595415625894],
            [27.091965657663909, -3.380377231765527],
            [27.091918121514002, -3.379899512039802],
            [27.091941890038104, -3.378752984808805],
            [27.092179569889236, -3.378012518237399],
            [27.093272895946821, -3.376436038706788],
            [27.09536447755881, -3.37431017679715],
            [27.098430546201133, -3.372232081820446],
            [27.09942880085724, -3.371587155376085],
            [27.101045023665296, -3.370201754992678],
            [27.102542405649437, -3.368147537948047],
            [27.103588196455448, -3.366666587862422],
            [27.105014274663912, -3.363704680846593],
            [27.105038042289717, -3.361626563833466],
            [27.102637477050916, -3.356586512512489],
            [27.101377774917879, -3.354842792270987],
            [27.10014184041064, -3.353648461680163],
            [27.097931418873067, -3.35004157286154],
            [27.09693316421696, -3.348393388260833],
            [27.096267660813467, -3.346936294269936],
            [27.095792301111207, -3.344667045497684],
            [27.094960422530519, -3.342230583651678],
            [27.094603902753839, -3.341155672250112],
            [27.094770278829294, -3.339388036630785],
            [27.094865350230741, -3.336163288485523],
            [27.094936654006418, -3.334586740523598],
            [27.09429491912703, -3.333057965390618],
            [27.094437526678384, -3.332126366524875],
            [27.094603902753839, -3.331672509718408],
            [27.095174333857553, -3.330764797274911],
            [27.095250210058055, -3.330302509282293],
            [27.095226441533953, -3.329872539396883],
            [27.095178906282378, -3.329323133105225],
            [27.095178906282378, -3.328725951804925],
            [27.09529774530963, -3.328272094313034],
            [27.095369049983606, -3.327197167449125],
            [27.095844408787574, -3.326432773467157],
            [27.096310442180538, -3.326081493969972],
            [27.096985271893331, -3.325572830083788],
            [27.097698311446724, -3.324784548733716],
            [27.098126134100788, -3.323685730092117],
            [27.098435117727597, -3.322849671324489],
            [27.098601493803052, -3.322180824876949],
            [27.09886294127999, -3.321703076359356],
            [27.098553957653181, -3.321416426955788],
            [27.098601493803052, -3.320675916433837],
            [27.098649029952959, -3.320054842717155],
            [27.098767869878511, -3.319027681957326],
            [27.099029317355448, -3.318717144623371],
            [27.099100621131122, -3.318048294436785],
            [27.099766124534646, -3.317331668534405],
            [27.099861196834425, -3.316734479880242],
            [27.100360324162462, -3.31561176494318],
            [27.100740611564948, -3.315181788571716],
            [27.101287275042889, -3.314656262139878],
            [27.101833938520834, -3.313987409169708],
            [27.102832193176937, -3.313915746485517],
            [27.103236248205231, -3.313270780285507],
            [27.103806680207271, -3.313079679341465],
            [27.103854216357142, -3.312506376285046],
            [27.104947542414731, -3.311718083468807],
            [27.105826958043583, -3.3111686669422],
            [27.106848980325495, -3.310332598350208],
            [27.107823467355797, -3.309472640770636],
            [27.108488970759321, -3.308923222981985],
            [27.109344617864071, -3.308827672541025],
            [27.110224032594626, -3.308469356272835],
            [27.110414176295855, -3.308158815581474],
            [27.110865767474014, -3.308134927276314],
            [27.11122228725073, -3.307537733902997],
            [27.11122228725073, -3.307155529736084],
            [27.111887790654222, -3.306295569363273],
            [27.112291846580813, -3.305292280704784],
            [27.112624597833424, -3.305125066580787],
            [27.11314749368556, -3.30448009458274],
            [27.114430963444374, -3.304265104424243],
            [27.115120235372004, -3.303715683712052],
            [27.11590457780278, -3.303859010570042],
            [27.1165463135805, -3.303787347143649],
            [27.117877319489185, -3.303644020275189],
            [27.118804270369615, -3.303524580901139],
            [27.119113254894753, -3.302999047301819],
            [27.119945133475404, -3.302712393313228],
            [27.120468029327576, -3.302258522821686],
            [27.121062228057092, -3.30151799778194],
            [27.121537587759356, -3.300873024312124],
            [27.121799035236261, -3.300156385823233],
            [27.121917875161841, -3.298961988080735],
            [27.122203091162849, -3.298890324296325],
            [27.122512074789658, -3.297767588883921],
            [27.122678449966816, -3.295784882592354],
            [27.123130042043279, -3.294518814523084],
            [27.123748009296897, -3.293396074111369],
            [27.124865103878584, -3.292416660946218],
            [27.125744518609139, -3.291867233599314],
            [27.127265669117381, -3.291222253788858],
            [27.128263923773488, -3.290911707636078],
            [27.129428554505083, -3.29012339745312],
            [27.130379273909611, -3.289430639881036],
            [27.130664489012322, -3.288284004870289],
            [27.131472599967164, -3.2868507099053],
            [27.132138103370689, -3.286014620588266],
            [27.132779839148409, -3.28501131210968],
            [27.133492877803477, -3.28422299720127],
            [27.134681277059173, -3.282622477469536],
            [27.13496649216188, -3.282096932692487],
            [27.135061564461658, -3.28116528530662],
            [27.135536923265594, -3.280472521434227],
            [27.135513155639824, -3.278991437984152],
            [27.135346779564369, -3.27765368389164],
            [27.134752580834849, -3.276674255074509],
            [27.134633740909269, -3.275025945782065],
            [27.134633740909269, -3.273688185415756],
            [27.135631995565372, -3.273210414191507],
            [27.136083586743535, -3.272517644738729],
            [27.136535178820029, -3.271848763084778],
            [27.137248217475097, -3.271657654086681],
            [27.138056328429975, -3.271681542374894],
            [27.138294008281111, -3.271203769278228],
            [27.138674295683597, -3.270821550995911],
            [27.139078351610184, -3.269889892975592],
            [27.139482407536772, -3.269483784942198],
            [27.140147910041964, -3.268982122431567],
            [27.140837181969594, -3.268074351958011],
            [27.141407613073305, -3.26728602353232],
            [27.141573989148757, -3.266067696631493],
            [27.142025580326923, -3.265303255953919],
            [27.140718342044011, -3.264299926444056],
            [27.140052838640514, -3.264586591605999],
            [27.13936356761122, -3.264204370769748],
            [27.138080096954077, -3.263248818034409],
            [27.137367057400677, -3.262317152892344],
            [27.13646387414602, -3.262102152633717],
            [27.134205917356908, -3.262030486171472],
            [27.134039541281417, -3.261696042311468],
            [27.133469110177707, -3.261791597324615],
            [27.132898679073961, -3.262221597026936],
            [27.132043031969211, -3.262269374960798],
            [27.131211152490263, -3.262197708510626],
            [27.130307969235606, -3.261982708226109],
            [27.129808841907568, -3.261672152879591],
            [27.129024499476792, -3.261266042381369],
            [27.12795494014668, -3.260931597360819],
            [27.127527116594319, -3.260549375116091],
            [27.126528861938212, -3.259928263428763],
            [27.12531669505675, -3.259259373276332],
            [27.12457988787758, -3.25832770438905],
            [27.12389061684825, -3.257276589653954],
            [27.123296417220434, -3.256368807564146],
            [27.122226858788654, -3.255102689885691],
            [27.121109764206967, -3.254027683026824],
            [27.120277884728019, -3.253311010540042],
            [27.11946977377314, -3.252570448789126],
            [27.11832891156568, -3.251949332115032],
            [27.118067464088742, -3.251519327967224],
            [27.117568335862376, -3.25123265813115],
            [27.116926600982985, -3.250730986396555],
            [27.116522545056398, -3.250062090056177],
            [27.115999650102559, -3.250062090056177],
            [27.115857042551205, -3.249632085093167],
            [27.114478499594281, -3.248867631768385],
            [27.114146820930134, -3.248824149172386],
            [27.11393183611634, -3.248795964351986],
            [27.112695901609104, -3.248079288098435],
            [27.111697646952997, -3.247434279751776],
            [27.110628088521217, -3.246407042405094],
            [27.110533016221435, -3.245618697691528],
            [27.110461712445758, -3.244639237254824],
            [27.110628088521217, -3.244376455287004],
            [27.110984607399597, -3.243420882598149],
            [27.111317359550512, -3.242871428068252],
            [27.111935326804129, -3.242059190657677],
            [27.112386917982292, -3.241366399482524],
            [27.112779108960616, -3.240925137880171],
            [27.113979372266211, -3.239574695440224],
            [27.114835019371, -3.238714676286081],
            [27.115239075297588, -3.238093550981374],
            [27.116213561429589, -3.236899078364979],
            [27.116273773706435, -3.236613771329591],
            [27.116379937505044, -3.236110725241022],
            [27.117188048459891, -3.235011807837717],
            [27.11768717578796, -3.233936779324654],
            [27.117972391788964, -3.233052865203514],
            [27.117734711937832, -3.232312288418904],
            [27.116879064833082, -3.23159560123983],
            [27.1165463135805, -3.231022250946666],
            [27.116522545056398, -3.230257782475662],
            [27.116665153506048, -3.229373866010008],
            [27.11761587201228, -3.228322720772807],
            [27.118495286742803, -3.227199905468253],
            [27.119160790146331, -3.226411544708471],
            [27.119897597325529, -3.225838191449821],
            [27.119992669625312, -3.224882601054348],
            [27.12032542087789, -3.224189797990358],
            [27.120943388131511, -3.223855341447829],
            [27.120943388131511, -3.223258096377306],
            [27.121299907908224, -3.222875859706905],
            [27.121442515459577, -3.22211138592954],
            [27.121585123909231, -3.22139469055765],
            [27.120777012954385, -3.219364051797134],
            [27.121133531832768, -3.218217336905294],
            [27.121656427684908, -3.217548418829666],
            [27.121989178937522, -3.216855610708505],
            [27.122488306265559, -3.216091131449607],
            [27.122916129817948, -3.215183312873278],
            [27.123005479849351, -3.215020534999468],
            [27.123296417220434, -3.214490502220828],
            [27.123272649594632, -3.213080991601299],
            [27.123652936997118, -3.212627080155433],
            [27.12457988787758, -3.212579299848788],
            [27.124817567728712, -3.212149278792694],
            [27.12531669505675, -3.211575917400068],
            [27.125649447207657, -3.211098115538859],
            [27.126338718236955, -3.210763654642965],
            [27.126433789638437, -3.209808050826875],
            [27.126956685490573, -3.209186907634957],
            [27.127479580444415, -3.208446313259705],
            [27.127432045192837, -3.207251804474526],
            [27.127598420369999, -3.205842282831016],
            [27.127883636371003, -3.204599991182065],
            [27.127574652744194, -3.20450443070886],
            [27.126980453116378, -3.203883284252484],
            [27.12671900563944, -3.203524930145553],
            [27.125887127058789, -3.202664880131365],
            [27.125506838758007, -3.202234854849777],
            [27.124865103878584, -3.20199595173616],
            [27.124128296699382, -3.202043732543984],
            [27.123700473147021, -3.202569319475138],
            [27.123177578193182, -3.202593209414288],
            [27.122155555012977, -3.202593209414288],
            [27.122036715087393, -3.202306525592285],
            [27.121204836506745, -3.201470365409783],
            [27.121014691907185, -3.200108616598385],
            [27.12118106798264, -3.199487467440408],
            [27.121941642787615, -3.197958482925458],
            [27.122630914715241, -3.196620619466926],
            [27.122725986116691, -3.195688892375519],
            [27.122725986116691, -3.194136011985003],
            [27.12293989834205, -3.192630910466534],
            [27.122369466340007, -3.192272552374724],
            [27.122274394938525, -3.19074355696832],
            [27.122512074789658, -3.189692371458593],
            [27.121513820133554, -3.189716262604535],
            [27.120586868354827, -3.188927872550304],
            [27.120159045700763, -3.187948356918076],
            [27.119921365849631, -3.186968840340702],
            [27.119921365849631, -3.18529649306753],
            [27.11996890110121, -3.184149739524966],
            [27.119588613698724, -3.183122437587529],
            [27.118923110295199, -3.182166807681387],
            [27.119018182594974, -3.181712882371254],
            [27.118970646445071, -3.180231652904026],
            [27.118661662818262, -3.179395474521958],
            [27.118566591416812, -3.178630967868319],
            [27.118756735118037, -3.177747005318603],
            [27.118804270369615, -3.176791370364819],
            [27.118923110295199, -3.175357915801911],
            [27.119232093922005, -3.17411558682298],
            [27.119897597325529, -3.173040492590408],
            [27.120420493177669, -3.171774270124482],
            [27.120943388131511, -3.170938083900119],
            [27.121085996581193, -3.169982442564895],
            [27.12175149908639, -3.169217927949692],
            [27.122203091162849, -3.168333958143515],
            [27.122773522266595, -3.167497770004561],
            [27.124223368999193, -3.165897064080789],
            [27.124674960177359, -3.164702505248858],
            [27.125174087505396, -3.164009661028693],
            [27.125934662310367, -3.162982339704872],
            [27.126338718236955, -3.162408949644508],
            [27.126695238013671, -3.161620539367153],
            [27.12721813296751, -3.161190496731262],
            [27.128121316222135, -3.159279194042492],
            [27.129214643178049, -3.15808462748652],
            [27.130379273909611, -3.157224539065149],
            [27.131163616340356, -3.156555581707801],
            [27.131377528565714, -3.155528252004274],
            [27.131686512192527, -3.154357573051564],
            [27.131734048342398, -3.153473590413337],
            [27.131734048342398, -3.152852412822321],
            [27.131734048342398, -3.151729513984926],
            [27.131353760041616, -3.151036660091257],
            [27.131211152490263, -3.150343806633159],
            [27.131211152490263, -3.149603169443252],
            [27.130735792787995, -3.14881474841832],
            [27.130331737759704, -3.147739628520872],
            [27.130379273909611, -3.147070664080492],
            [27.13078332893787, -3.146377807948922],
            [27.1307595613121, -3.145828300780832],
            [27.130117825534377, -3.145326576784698],
            [27.129761306655993, -3.144824852543954],
            [27.129238410803822, -3.144800961251325],
            [27.128525371250426, -3.145111552527042],
            [27.127859868745233, -3.144968202093993],
            [27.126695238013671, -3.144657610775019],
            [27.126386254386858, -3.144299235851307],
            [27.126029734610142, -3.143749728476265],
            [27.12531669505675, -3.143152436340644],
            [27.124698727803128, -3.142268444066507],
            [27.123415257145986, -3.141145533672286],
            [27.122821058416466, -3.141049966351029],
            [27.121775267610488, -3.140763265237037],
            [27.119802525924051, -3.141073857730652],
            [27.118566591416812, -3.141026074970807],
            [27.117401960685253, -3.141097750012726],
            [27.1165463135805, -3.140978291305764],
            [27.115952113952652, -3.140787157526337],
            [27.114953859296548, -3.1407393738502],
            [27.1143596596687, -3.140452672649812],
            [27.113480244938177, -3.139950946034478],
            [27.112933581460236, -3.139329760276828],
            [27.112600830207619, -3.138374089496831],
            [27.112220542805133, -3.137179498647705],
            [27.111721414578767, -3.136462744377158],
            [27.111697646952997, -3.136080475108896],
            [27.111745183102869, -3.135459287020192],
            [27.111721414578767, -3.134431936251763],
            [27.112030398205579, -3.133117882125409],
            [27.112814741534653, -3.13228166441811],
            [27.113575317237956, -3.131517122644443],
            [27.114478499594281, -3.13037030802056],
            [27.114692411819643, -3.129629656477687],
            [27.115096466847902, -3.128889004404336],
            [27.115405450474711, -3.128315596245508],
            [27.115928346326882, -3.12757494323131],
            [27.116261097579461, -3.12640423251795],
            [27.116760224907534, -3.125568010285179],
            [27.117592104386478, -3.124851247059869],
            [27.118089907597827, -3.124049245752773],
            [27.118376447715551, -3.123537180761521],
            [27.118828038893717, -3.122677063506628],
            [27.119065718744849, -3.122270896425842],
            [27.119683685998503, -3.121721376429354],
            [27.120753244430283, -3.120359521544485],
            [27.121394980208002, -3.119260480137588],
            [27.12175149908639, -3.117874729203965],
            [27.12210801886307, -3.117062392025534],
            [27.122773522266595, -3.115509392576958],
            [27.122892362192143, -3.111591045259704],
            [27.122844826042272, -3.110085821826428],
            [27.121941642787615, -3.108437242529305],
            [27.121608891535036, -3.107409864985159],
            [27.121585123909231, -3.106549734378782],
            [27.121109764206967, -3.105235644932355],
            [27.121703963834811, -3.103634842445175],
            [27.121680195310709, -3.103109205756801],
            [27.121680195310709, -3.102464104755419],
            [27.121775267610488, -3.10155618458655],
            [27.122417002489879, -3.098689064314256],
            [27.122464538639782, -3.097374964967221],
            [27.121632659160806, -3.095033474237141],
            [27.120990924281415, -3.093695476921926],
            [27.120800780580154, -3.092978692651459],
            [27.120753244430283, -3.092022978322988],
            [27.120301653252117, -3.089609797024998],
            [27.119873829699728, -3.088773545247814],
            [27.119255862446106, -3.088128435400724],
            [27.11854282289271, -3.08753111218443],
            [27.117639640536385, -3.086599286420435],
            [27.117425728311023, -3.085810817541615],
            [27.117235584609794, -3.084496702028483],
            [27.117330656909573, -3.08313479854652],
            [27.117924855639092, -3.082776402409538],
            [27.118519055266908, -3.081964037921325],
            [27.119493542297239, -3.080721596794052],
            [27.119921365849631, -3.079622512755648],
            [27.11996890110121, -3.077926097983072],
            [27.119897597325529, -3.076731438698728],
            [27.119303398596017, -3.07599074906239],
            [27.119113254894753, -3.075393418942422],
            [27.118495286742803, -3.074318222246614],
            [27.118138767864423, -3.073601424742343],
            [27.117520800610802, -3.073314705062193],
            [27.116712689655955, -3.073075772086286],
            [27.116189793803784, -3.072669586625227],
            [27.115738202625622, -3.072382866691409],
            [27.115357914324839, -3.072048359852785],
            [27.115025163072222, -3.071522707324726],
            [27.11426458826725, -3.070304146869447],
            [27.113717924789309, -3.068966118947944],
            [27.112814741534653, -3.069061691975715],
            [27.111459967101865, -3.068440463979853],
            [27.110437944819953, -3.068177636849085],
            [27.109510993041194, -3.068177636849085],
            [27.108370130833737, -3.067675875452859],
            [27.106944052625273, -3.06738915416083],
            [27.105922029445068, -3.06738915416083],
            [27.104828702489183, -3.067150219841813],
            [27.104068127684176, -3.067102433693965],
            [27.103141176803746, -3.067221899962594],
            [27.100859451490532, -3.06738915416083],
            [27.098767869878511, -3.06753251436504],
            [27.097959758923661, -3.06695907252826],
            [27.097460631595592, -3.066624564871979],
            [27.096652520640749, -3.066313950202251],
            [27.095392817609408, -3.065740507703344],
            [27.094822386505665, -3.065262638264788],
            [27.094014275550784, -3.064402473091583],
            [27.092920948594902, -3.063112224018288],
            [27.092136605265825, -3.062204269821505],
            [27.090853134608714, -3.061439676779064],
            [27.089926183728288, -3.06024499881751],
            [27.088595177819567, -3.058118467641575],
            [27.087430547088008, -3.056469806724179],
            [27.08612330790676, -3.054916717546634],
            [27.085148821774759, -3.053793712350816],
            [27.084245638520102, -3.053053006625247],
            [27.083413759041154, -3.052503451245508],
            [27.081892609431208, -3.051906106940521],
            [27.081441017354717, -3.051069824348227],
            [27.080965658550781, -3.049827346859084],
            [27.079991171520444, -3.048226460048899],
            [27.078850308414655, -3.046506102232317],
            [27.078018429834007, -3.045287512969697],
            [27.07727643847732, -3.044458653867829],
            [27.076016736344279, -3.043502895577197],
            [27.074400513536258, -3.042069257433869],
            [27.072926899177887, -3.041065709674331],
            [27.069575615432857, -3.040683405603014],
            [27.067079977894277, -3.040611722784156],
            [27.066105490863944, -3.040946239553897],
            [27.06524984465749, -3.042642712742448],
            [27.064204053851512, -3.043980774829901],
            [27.063182030671307, -3.044649805242199],
            [27.062242343476765, -3.044717281261859],
            [27.0621837760152, -3.044721486885868],
            [27.061470736461768, -3.044530335524373],
            [27.060710161656793, -3.044076350112825],
            [27.059545530925234, -3.042977228873687],
            [27.057976844267088, -3.041280755315454],
            [27.056764678283947, -3.039201975352547],
            [27.055647583702264, -3.036645308097539],
            [27.054863240373187, -3.03411252943044],
            [27.054316576895246, -3.031006283488244],
            [27.054007593268437, -3.028879694724943],
            [27.054221504595468, -3.027613296478615],
            [27.054692578435514, -3.027131954664855],
            [27.055671351328066, -3.02613184808073],
            [27.057335109387697, -3.024507031640705],
            [27.059165243522749, -3.022404324031672],
            [27.060591321731245, -3.021018446673927],
            [27.060781465432473, -3.018867942998193],
            [27.060401178029988, -3.017338693214995],
            [27.059521762401133, -3.014327977434657],
            [27.059664370850818, -3.013563349129038],
            [27.059426690999686, -3.011914619327253],
            [27.059284083448333, -3.011173884536631],
            [27.05885625989594, -3.009740202147461],
            [27.058190756492451, -3.006968412943462],
            [27.058095684192669, -3.005415251767598],
            [27.058095684192669, -3.001138072220461],
            [27.058998867447293, -2.999465427896803],
            [27.058998867447293, -2.998342365369247],
            [27.058880027521745, -2.996621926506674],
            [27.058499740119256, -2.994543059977492],
            [27.058380900193676, -2.991006587412395],
            [27.057976844267088, -2.988091378351483],
            [27.057797557604381, -2.987701813268021],
            [27.057660031822572, -2.989270535435064],
            [27.057501485463153, -2.988712653056971],
            [27.057311341761892, -2.987589578457111],
            [27.056075406356324, -2.985869123395515],
            [27.055005847924544, -2.984292036061325],
            [27.053817449567209, -2.982738842295678],
            [27.052272531433161, -2.981090064525798],
            [27.050561237223626, -2.979704134077179],
            [27.049681822493106, -2.979345703220626],
            [27.048992550565476, -2.978628842055872],
            [27.047257488730203, -2.977577444042791],
            [27.045926482821482, -2.976956162961716],
            [27.044619243640238, -2.976454357918764],
            [27.043597221358361, -2.975856972209163],
            [27.043121861656097, -2.975450748944464],
            [27.041957230924538, -2.975164003869239],
            [27.040745064043072, -2.974805571515752],
            [27.038320731178469, -2.97363469221349],
            [27.037156100446907, -2.973228468119149],
            [27.036181613416574, -2.973108990468612],
            [27.034898142759463, -2.972583289373013],
            [27.034018728028908, -2.972200960979842],
            [27.033186849448256, -2.971531885517278],
            [27.032354969969308, -2.970862809643709],
            [27.031499322864523, -2.970241524729557],
            [27.030263388357287, -2.969333491947412],
            [27.029669188729471, -2.968998953838656],
            [27.029003686224279, -2.968521041302503],
            [27.026032688983403, -2.964124238493565],
            [27.025081970477203, -2.962547120549156],
            [27.024107483446869, -2.961113373838204],
            [27.023560819968928, -2.959655730685281],
            [27.023632123744605, -2.956907708141317],
            [27.024701683074717, -2.955258892206168],
            [27.025652401580913, -2.953442800986163],
            [27.025913849057851, -2.951985147619892],
            [27.025628633955144, -2.950694763756879],
            [27.025295881804233, -2.949738923381436],
            [27.024535306999262, -2.94916541785326],
            [27.023228068716346, -2.949022041875992],
            [27.022253581686012, -2.949261002429815],
            [27.020756198803539, -2.950718659416931],
            [27.019734176521631, -2.952940986037615],
            [27.018759689491329, -2.95482876570545],
            [27.018403169714613, -2.956931604569015],
            [27.017904042386579, -2.958580417984491],
            [27.017024627656024, -2.960181438009474],
            [27.015907533074333, -2.961113373838204],
            [27.015075653595385, -2.961328436326038],
            [27.013744647686668, -2.961304540897531],
            [27.012841464432046, -2.961280644565377],
            [27.011843209775904, -2.961208957372059],
            [27.010535970594695, -2.960468187927221],
            [27.009680324388238, -2.960396500680623],
            [27.00884844490929, -2.960396500680623],
            [27.007683814177732, -2.960468187927221],
            [27.006709327147398, -2.960109750744061],
            [27.005069337611868, -2.959870792556685],
            [27.003358043402365, -2.959464564240807],
            [27.002383556372031, -2.959130022205222],
            [27.00162298156706, -2.959106126728714],
            [27.001421608026448, -2.959008943536688],
            [27.001397839502349, -2.958435443763904],
            [27.00157036095268, -2.958478709974185],
            [26.998359154204845, -2.945510030854257],
            [26.991249157614327, -2.942070005938337],
            [26.983470641077531, -2.93412777615846],
            [26.979796842382576, -2.92877454707624],
            [26.975827843810549, -2.902607947591092],
            [26.961686689473741, -2.862957286535765],
            [26.957126571596977, -2.836788973394993],
            [26.944908536908638, -2.820132334109639],
            [26.916222669975131, -2.807460986786642],
            [26.915121337233451, -2.804389201532481],
            [26.915068869332643, -2.80424285882603],
            [26.918253128418584, -2.79779634277314],
            [26.915496550052897, -2.794118937884194],
            [26.918692628273014, -2.79134991545363],
            [26.919825547576739, -2.787665856387027],
            [26.927006824586744, -2.78238592153167],
            [26.931693662410765, -2.776361942475047],
            [26.933512741877969, -2.772446870215812],
            [26.93327082197867, -2.768305858686237],
            [26.937144779691987, -2.762773985958635],
            [26.938250699231517, -2.749657894341875],
            [26.945773616323883, -2.739745929896894],
            [26.942944737052542, -2.712378004695374],
            [26.905703832782724, -2.695617696824514],
            [26.900749155070219, -2.686099194875173],
            [26.910020950086913, -2.678172663901182],
            [26.904972673311704, -2.664688907363092],
            [26.889751519424586, -2.654372954773074],
            [26.881643603249547, -2.644853048526555],
            [26.873366846920245, -2.628195330136756],
            [26.865292011205518, -2.61268187156481],
            [26.864577167835051, -2.611308496550726],
            [26.86451778380486, -2.610502717153712],
            [26.864237928949464, -2.608774219056037],
            [26.862934948680991, -2.607340940213051],
            [26.862455729816261, -2.607232729378844],
            [26.860915330208083, -2.606884897870826],
            [26.857788177024762, -2.60701519557094],
            [26.856550346173954, -2.606950046270866],
            [26.856289750299929, -2.606168258017375],
            [26.856550346173954, -2.604995576521434],
            [26.856941239985002, -2.604083489947633],
            [26.857592730568406, -2.6031714036081],
            [26.858830561419214, -2.602324467048954],
            [26.859776461362248, -2.602085227607748],
            [26.85955371240944, -2.601657272622749],
            [26.854373973480598, -2.591705713712657],
            [26.854880854167885, -2.579809402980706],
            [26.865729449426379, -2.571882907814455],
            [26.871041246990192, -2.563160716684266],
            [26.870553806743995, -2.542539461236772],
            [26.862822089738582, -2.51556976497375],
            [26.856009451676769, -2.494152054811787],
            [26.845480536285155, -2.482250333310734],
            [26.826899864695111, -2.463206776592657],
            [26.820199907709281, -2.44654721990173],
            [26.818211626965081, -2.395781631063663],
            [26.824105544511074, -2.378333218796339],
            [26.821440825171415, -2.365640458083158],
            [26.81400862893959, -2.351359274249585],
            [26.810653685458117, -2.339839120909454],
            [26.810649209153048, -2.339823748774727],
            [26.820222726714118, -2.340483029950045],
            [26.82058490048723, -2.340507685714653],
            [26.823543156024076, -2.335209895845929],
            [26.82605890414694, -2.334743896785683],
            [26.82904385851235, -2.339336001477485],
            [26.832476621250283, -2.339556949319336],
            [26.834115828353205, -2.337307731388263],
            [26.835665860596162, -2.335178976173488],
            [26.842744539220941, -2.338077132679115],
            [26.844597823839187, -2.338835889063471],
            [26.848014575005489, -2.333536984976508],
            [26.851216772549332, -2.333758846388444],
            [26.853955652307302, -2.331221842472755],
            [26.856698851165152, -2.330984853301212],
            [26.861419528525936, -2.322821674919383],
            [26.861982928515932, -2.31330276878883],
            [26.857778850715498, -2.302195435473277],
            [26.852111012177023, -2.29584683021689],
            [26.851154133024597, -2.288707069314769],
            [26.855528490080374, -2.240318154335079],
            [26.858062889025177, -2.214139943469736],
            [26.861629407315629, -2.198275060190218],
            [26.864482766576771, -2.185582851177909],
            [26.864332646414692, -2.179236254906266],
            [26.865571765449637, -2.164956629918876],
            [26.867779599839171, -2.159551407603157],
            [26.868042001326927, -2.158908994598647],
            [26.869177270623421, -2.158508771758626],
            [26.87034190135498, -2.158269663001896],
            [26.871720443413572, -2.15877179288337],
            [26.872599858144131, -2.160349914144428],
            [26.872980146444913, -2.161306351230515],
            [26.873574345174465, -2.161210707187892],
            [26.876236358788496, -2.158030553303327],
            [26.877424757145828, -2.157456689509724],
            [26.878423011801967, -2.156930648560547],
            [26.880419522012474, -2.156356785250223],
            [26.882511103624466, -2.156404606523341],
            [26.884864132713389, -2.15638069588696],
            [26.88598122729508, -2.156332873709369],
            [26.887526145429124, -2.156452428698642],
            [26.890877430072454, -2.15614158588746],
            [26.892826403234793, -2.155519900072087],
            [26.89437132136884, -2.155806832366452],
            [26.895940008026987, -2.155735099523931],
            [26.896486671504928, -2.155759010170553],
            [26.896534206756506, -2.156332873709369],
            [26.897698837488068, -2.156332873709369],
            [26.89926752414625, -2.157504511651553],
            [26.900598530054936, -2.158150108157363],
            [26.901834465460503, -2.158915258274707],
            [26.902547504115571, -2.160015161562307],
            [26.903141703743419, -2.160517290859297],
            [26.904781693278945, -2.161067242016231],
            [26.906088932460158, -2.161354172345814],
            [26.907610082070104, -2.161306351230515],
            [26.909131232578382, -2.16068466755549],
            [26.909772968356101, -2.160015161562307],
            [26.910533543161076, -2.159608675344383],
            [26.910723686862333, -2.15860441597366],
            [26.911983388995342, -2.158078374523075],
            [26.913100484475361, -2.158365306328411],
            [26.913314395802391, -2.159082635149761],
            [26.914288882832693, -2.159010902463813],
            [26.914455258908148, -2.159680408001745],
            [26.915263369863027, -2.160230359465729],
            [26.915810033340968, -2.160660756083629],
            [26.9169984316983, -2.163482242061033],
            [26.917354951475016, -2.164606052500512],
            [26.918163062429894, -2.166686295743615],
            [26.91861465360806, -2.168814356967809],
            [26.918638422132158, -2.169483859022474],
            [26.919042477160417, -2.170201181609098],
            [26.920112036490533, -2.171229344496403],
            [26.921728258400254, -2.172305327439704],
            [26.924247663564636, -2.17311829195569],
            [26.9256737417731, -2.173572596127122],
            [26.927717787235217, -2.176178861228338],
            [26.928620970489874, -2.178019981828715],
            [26.929048794042235, -2.178785121764365],
            [26.932043558010548, -2.181008808482377],
            [26.934063835846896, -2.181750036648377],
            [26.936702080936826, -2.182323890195798],
            [26.93739135196612, -2.182252158627458],
            [26.937819175518516, -2.181630483685104],
            [26.937914247818291, -2.179526351040225],
            [26.937486424265899, -2.178402551845762],
            [26.936844689386476, -2.177446125714841],
            [26.936939760787961, -2.176107129363342],
            [26.936535704861374, -2.175868022519245],
            [26.93453919554916, -2.175724558755856],
            [26.93382615599576, -2.17574846908282],
            [26.932804133713852, -2.174648577378406],
            [26.932209934086007, -2.173620417753459],
            [26.932019790384778, -2.172257506674852],
            [26.932922973639435, -2.1699381633975],
            [26.933754852220087, -2.168551338511842],
            [26.934349051847899, -2.167810103774817],
            [26.935727593906492, -2.166662384367666],
            [26.936036577533301, -2.166136346651574],
            [26.936868457012281, -2.165347288826657],
            [26.93803308774384, -2.164940804056243],
            [26.93915018232553, -2.164390854322201],
            [26.939340326026759, -2.163577885054874],
            [26.939411629802432, -2.162932291790914],
            [26.939649309653568, -2.161258529209954],
            [26.938888734848593, -2.159895606856955],
            [26.937462656640129, -2.159034813058274],
            [26.936868457012281, -2.15860441597366],
            [26.936250489758663, -2.157743621433948],
            [26.935513682579462, -2.157217580585353],
            [26.93475310777449, -2.156356785250223],
            [26.93453919554916, -2.155854654560773],
            [26.93456296317493, -2.155400345008593],
            [26.934943251475747, -2.155041679760961],
            [26.93570037136012, -2.154722838722779],
            [26.935965273757624, -2.15461128153155],
            [26.936583241011242, -2.154037417335162],
            [26.936607009535344, -2.15329617541839],
            [26.936511937235565, -2.152124534194916],
            [26.936868457012281, -2.151383291335467],
            [26.937581495667384, -2.150426848834015],
            [26.938864966324491, -2.150163827152596],
            [26.940433652982641, -2.150139915513272],
            [26.941907267341012, -2.150355115734886],
            [26.942691610670121, -2.15116809216453],
            [26.943618561550547, -2.151192002883783],
            [26.944188992654261, -2.151311558281897],
            [26.944830727533684, -2.150905070612547],
            [26.945163479684595, -2.150020360022107],
            [26.944902031309361, -2.149303027779663],
            [26.945258551086042, -2.148203116653687],
            [26.94556753471285, -2.14734231616069],
            [26.946256805742149, -2.146170670305921],
            [26.947445204997845, -2.144592534169804],
            [26.9478492600261, -2.144042576989689],
            [26.948609835729403, -2.143277418408533],
            [26.949703161786957, -2.142034035904387],
            [26.951770975773176, -2.140790652377515],
            [26.95295937413054, -2.140288516502145],
            [26.953696181309709, -2.139953759460581],
            [26.956286890249771, -2.139284244251499],
            [26.957760504608139, -2.138566906005222],
            [26.958426008011664, -2.138064769392078],
            [26.958616151712892, -2.137108318455031],
            [26.95913904756506, -2.136462712940427],
            [26.959733246294579, -2.135721462394239],
            [26.959757014818681, -2.135051946218369],
            [26.961040485475792, -2.133186861044175],
            [26.961777292654993, -2.13203911615568],
            [26.961896132580577, -2.131106572456171],
            [26.962205116207386, -2.130580521425043],
            [26.962300187608832, -2.129791445892477],
            [26.963345978414843, -2.129050192089159],
            [26.964724521371732, -2.128978457072971],
            [26.966198135730103, -2.129934914037271],
            [26.967980733715315, -2.132397786865444],
            [26.96895521984732, -2.134717187115856],
            [26.968978988371422, -2.138782107876298],
            [26.969074059772868, -2.140264605610124],
            [26.969040699936492, -2.140391103424693],
            [26.96876507614606, -2.141436256046392],
            [26.968788844670161, -2.142368793389194],
            [26.969335508148102, -2.144305599738794],
            [26.970167386728754, -2.145907647881805],
            [26.97088042628215, -2.147772716468618],
            [26.971545928787343, -2.148776983074632],
            [26.972710559518937, -2.149972538545968],
            [26.973304759146753, -2.150355115734886],
            [26.973970262550278, -2.150665959742263],
            [26.975016053356256, -2.151598491379352],
            [26.975681556759781, -2.152459289439722],
            [26.977202706369727, -2.153104887209929],
            [26.978391105625388, -2.153702663345378],
            [26.97955573635695, -2.154730836657854],
            [26.981171958266675, -2.154922124659401],
            [26.982574268849401, -2.154563460201348],
            [26.98416672313332, -2.152459289439722],
            [26.984523242011704, -2.150928981336024],
            [26.98466449220868, -2.149226872701635],
            [26.984261794534802, -2.147916182909397],
            [26.982693108774953, -2.145644625411813],
            [26.980934278415543, -2.143612175617891],
            [26.979840951459657, -2.142225325517457],
            [26.978557480802547, -2.140862385931271],
            [26.977701833697797, -2.139619001441213],
            [26.977107634968281, -2.137706100022561],
            [26.976418363938951, -2.135099768166642],
            [26.976133147937944, -2.13366508827685],
            [26.975943004236687, -2.132373874945188],
            [26.975729092011356, -2.131297863448622],
            [26.975443876908649, -2.129887091022608],
            [26.974920981056478, -2.128882811885704],
            [26.974374317578537, -2.12775897483642],
            [26.974374317578537, -2.127065542243892],
            [26.974445622252542, -2.125678677918861],
            [26.974825909655031, -2.124985245282799],
            [26.975634020609874, -2.124172254800358],
            [26.976869955117145, -2.123885316507353],
            [26.978105889624384, -2.124459192135622],
            [26.980981814565446, -2.126515579610233],
            [26.983334843654376, -2.128667608610796],
            [26.986495983698148, -2.130030559158381],
            [26.988563797684364, -2.1318717362814],
            [26.990156251968283, -2.134262872105679],
            [26.991748706252238, -2.13751480983815],
            [26.992937104609602, -2.140862385931271],
            [26.994030431565488, -2.143683909037746],
            [26.994719702594782, -2.146314136899087],
            [26.995694189625084, -2.14822702742],
            [26.998332434715046, -2.150474671199475],
            [27.000171021996952, -2.151174541136232],
            [27.000970679804979, -2.151478936004048],
            [27.002681973116182, -2.151024626033486],
            [27.003965443773296, -2.149924716164605],
            [27.004963699327728, -2.146792359982716],
            [27.005320218206116, -2.144712090091285],
            [27.005272682954541, -2.144090399557572],
            [27.005748041758476, -2.14322959671861],
            [27.006128329160962, -2.142416615106355],
            [27.006128329160962, -2.141436256046392],
            [27.00584239450771, -2.140846556200193],
            [27.005652970357026, -2.140455895447042],
            [27.006294705236449, -2.13921251062291],
            [27.00684136871439, -2.138734285140507],
            [27.007673248193338, -2.138279971334513],
            [27.008267446922854, -2.137801745557577],
            [27.008956717952152, -2.136940939140071],
            [27.010002508758163, -2.137419165188791],
            [27.010525404610298, -2.138256059507014],
            [27.010715015610582, -2.139727594601806],
            [27.010858155862916, -2.140838475048296],
            [27.011190908013823, -2.143062218080815],
            [27.011452355490761, -2.144449066509231],
            [27.012593217698221, -2.145525069564185],
            [27.012997273624809, -2.145644625411813],
            [27.013211185850135, -2.145118579430604],
            [27.014161904356371, -2.144999023541285],
            [27.014377982419866, -2.145101675212407],
            [27.015017551461121, -2.14540551370704],
            [27.015873198565874, -2.147174937978961],
            [27.016895220847783, -2.148179205886955],
            [27.018392603730256, -2.148776983074632],
            [27.018891731058289, -2.148968271833074],
            [27.019842449564521, -2.14990080452149],
            [27.020246505491109, -2.151478936004048],
            [27.02084070511896, -2.153248353142609],
            [27.02094752648431, -2.153986273904933],
            [27.021197223997344, -2.155711187973192],
            [27.020793168969053, -2.157695799299753],
            [27.020436649192337, -2.158795703481661],
            [27.020507952968014, -2.160134716258167],
            [27.020793168969053, -2.161378083806607],
            [27.02243315850458, -2.163243133194179],
            [27.023716629161694, -2.16448649816165],
            [27.024737679466476, -2.165299689249129],
            [27.024857492267483, -2.165395110716574],
            [27.026393828795623, -2.16633962639225],
            [27.027852256235796, -2.167236243729586],
            [27.029135726892942, -2.167642727875747],
            [27.030229053848828, -2.167523173779739],
            [27.030901754554392, -2.167178417784996],
            [27.031488756880165, -2.166877582219042],
            [27.03331889011692, -2.165610307846664],
            [27.034697433073841, -2.164845161149574],
            [27.0351014881021, -2.164510408668722],
            [27.036361191133473, -2.164701695422486],
            [27.037240605863996, -2.16501253645818],
            [27.038001180668967, -2.166925403156281],
            [27.037874150802949, -2.167895129665199],
            [27.037597125640708, -2.170009895559483],
            [27.038001180668967, -2.171468452085056],
            [27.040805801834388, -2.174289916746446],
            [27.043277670848862, -2.176083218138444],
            [27.046272435715508, -2.177350483610129],
            [27.047698513923976, -2.177756964094136],
            [27.048910680805438, -2.178067802408459],
            [27.050336759013902, -2.178426462129674],
            [27.051413599189392, -2.17827459684686],
            [27.052879931804089, -2.178067802408459],
            [27.05506658571586, -2.178282998613084],
            [27.055565713043926, -2.178354730373109],
            [27.056540200074227, -2.178354730373109],
            [27.057752366057365, -2.180411043271257],
            [27.058869461537348, -2.182323890195798],
            [27.059368588865418, -2.183304223390599],
            [27.059915252343362, -2.185145335155916],
            [27.060295539745848, -2.187990684873554],
            [27.060604523372657, -2.189186208036994],
            [27.060865970849594, -2.191314237039294],
            [27.060652058624232, -2.193657456947987],
            [27.060496432687774, -2.194327181854093],
            [27.060224235970171, -2.195498555824462],
            [27.060248003595941, -2.196933176392151],
            [27.060390611147294, -2.199372028965159],
            [27.060366843521525, -2.202121709851695],
            [27.06074713092401, -2.203197670341896],
            [27.061600759514317, -2.204424438047341],
            [27.061745385580117, -2.204632283404621],
            [27.062220745282382, -2.206066895969677],
            [27.062363352833735, -2.206999392842859],
            [27.063809172418914, -2.208721349889865],
            [27.064431166819954, -2.20946213849233],
            [27.066213764805134, -2.210538093600765],
            [27.068210274117344, -2.210251171894047],
            [27.069588817074266, -2.209653419438147],
            [27.071276342759667, -2.20843400219006],
            [27.071514022610803, -2.207884068607154],
            [27.072345902089779, -2.207166763388127],
            [27.072678653342361, -2.206449458722109],
            [27.072702420968167, -2.203986708016027],
            [27.07348676429724, -2.20298247866834],
            [27.074271107626313, -2.202265171054902],
            [27.074936611029838, -2.201978248634481],
            [27.075174289982641, -2.201523953181509],
            [27.076410225388209, -2.200830555681963],
            [27.077503551445766, -2.200950107091814],
            [27.078438064344258, -2.20071893326944],
            [27.078953398178363, -2.200591452833164],
            [27.079523736755608, -2.200819571287998],
            [27.0809261398648, -2.201380491905988],
            [27.083588152580504, -2.203197670341896],
            [27.086725524998503, -2.204584463684593],
            [27.087890155730065, -2.205182218206149],
            [27.088698266684943, -2.205206128960326],
            [27.090243184818991, -2.205062667140574],
            [27.090913401682787, -2.204523285599956],
            [27.090956224372388, -2.2044888224325],
            [27.091693031551589, -2.203699785028003],
            [27.092238860494628, -2.203199749737174],
            [27.09404522700391, -2.203271480287915],
            [27.096873614896769, -2.20377359585253],
            [27.097919405702783, -2.203917056894508],
            [27.098679981406086, -2.203725775200841],
            [27.100343739465682, -2.204921285603361],
            [27.103908935436074, -2.207790506958882],
            [27.10557269349567, -2.208459991375386],
            [27.108781369689346, -2.208842553503653],
            [27.109660784419905, -2.209177295961763],
            [27.111158167302378, -2.209344667162136],
            [27.111799902181765, -2.209464217878728],
            [27.112394101809617, -2.210157611300561],
            [27.112655549286519, -2.210396712591359],
            [27.114200467420599, -2.210277161950858],
            [27.115198722076705, -2.210253251279364],
            [27.115959297779973, -2.210444532121889],
            [27.116696104959175, -2.211233565898161],
            [27.116933783911975, -2.212118239106257],
            [27.116767408734852, -2.213218102886368],
            [27.115483938077709, -2.215991668392614],
            [27.114509451047407, -2.217856648901483],
            [27.112227725734158, -2.219793356769216],
            [27.111134398778276, -2.221514873116821],
            [27.110849183675569, -2.223284207444934],
            [27.110849183675569, -2.223977594306275],
            [27.11160975848054, -2.225101358673944],
            [27.11246540558529, -2.225723015223837],
            [27.113416124091525, -2.227301065828707],
            [27.1151749544509, -2.231413551704018],
            [27.116767408734852, -2.233182873984138],
            [27.118407398270381, -2.234521818284574],
            [27.119604680067578, -2.235272113956992],
            [27.119857245002947, -2.235430387604425],
            [27.121734914389609, -2.23645850485544],
            [27.123588817048795, -2.236578053346649],
            [27.124800983031932, -2.235884671598813],
            [27.125276342734196, -2.234832644576057],
            [27.124872286807609, -2.232513400918346],
            [27.123351137197663, -2.229405130034538],
            [27.122400417793099, -2.227229335553517],
            [27.122305346391652, -2.224981809237449],
            [27.12311345734653, -2.223236387431112],
            [27.125014895257259, -2.221634422837926],
            [27.12741546049606, -2.220630205599056],
            [27.130719208091218, -2.218789138262615],
            [27.133214845629794, -2.217593639182488],
            [27.134569620062617, -2.216948068603453],
            [27.136125467100417, -2.215966932750921],
            [27.136162074346533, -2.215943848139678],
            [27.13706525760119, -2.215465647332006],
            [27.137968439957518, -2.21496353667701],
            [27.139180606838988, -2.213552844344219],
            [27.140131325345184, -2.212715991459667],
            [27.140677988823128, -2.212572531278576],
            [27.142151603181496, -2.21228560997056],
            [27.143149857837635, -2.212142149747294],
            [27.144837384421333, -2.211855228354866],
            [27.146572446256641, -2.21216605948424],
            [27.149353298897928, -2.212572531278576],
            [27.150589233405164, -2.212979002056357],
            [27.151777632660828, -2.213098552476216],
            [27.153013567168095, -2.213839764500048],
            [27.153322550794908, -2.216206858155763],
            [27.153037334793872, -2.21902823814187],
            [27.151920240212181, -2.221658332419469],
            [27.150921985556074, -2.22335593701091],
            [27.149638514898964, -2.225388277462134],
            [27.14809359676492, -2.227611893666728],
            [27.14793646435373, -2.228309584483658],
            [27.147404325735621, -2.230672348620255],
            [27.147570700912748, -2.231915656687144],
            [27.147974756839336, -2.233015505520747],
            [27.148830403944089, -2.234163173175896],
            [27.150042570825551, -2.234928283838637],
            [27.151516184285594, -2.235071741817016],
            [27.152324296138801, -2.234378360251744],
            [27.152775887316967, -2.233039414915108],
            [27.152585743615706, -2.229022572393499],
            [27.152799654942736, -2.225842564599381],
            [27.153346318420677, -2.224264513316035],
            [27.153395243365996, -2.224211390545932],
            [27.15484370130315, -2.222638639384821],
            [27.156055867286284, -2.222160441674869],
            [27.157363105569203, -2.221825702190501],
            [27.159003096003058, -2.221825702190501],
            [27.160880766288017, -2.222519089746132],
            [27.162592059599223, -2.22378631523626],
            [27.164344253205275, -2.224529603003814],
            [27.164564802183961, -2.224623160869109],
            [27.166157255569583, -2.224694891272768],
            [27.166894902673572, -2.224018315896163],
            [27.166965367422758, -2.223953684762796],
            [27.167607102302185, -2.223116837841454],
            [27.168011158228772, -2.222232171296187],
            [27.168320141855581, -2.221514873116821],
            [27.168225069555803, -2.219339067745582],
            [27.168129997256024, -2.218215298934818],
            [27.169056949034747, -2.217163259129426],
            [27.170340418793561, -2.216469869028143],
            [27.171409978123677, -2.216469869028143],
            [27.172669680256718, -2.21701979938477],
            [27.173240111360428, -2.217282809207083],
            [27.174143294615085, -2.217378448719998],
            [27.175284157720842, -2.218573948880012],
            [27.175688212749133, -2.219578167534713],
            [27.175379229122324, -2.222375630528227],
            [27.173406487435884, -2.225460006924425],
            [27.171861569301836, -2.228831293987012],
            [27.17114853064674, -2.231748288077524],
            [27.171077225972763, -2.233589339010063],
            [27.171077225972763, -2.235286929661579],
            [27.171528818049225, -2.237414891604911],
            [27.172598376481041, -2.23944721236518],
            [27.174024454689505, -2.240833970306039],
            [27.174856334168485, -2.241312162764832],
            [27.175556755087086, -2.241477949752966],
            [27.176068500151619, -2.241599078344886],
            [27.177589650659897, -2.241479530268739],
            [27.179253408719493, -2.240523145303725],
            [27.180370503301184, -2.238921199792429],
            [27.180750791601966, -2.23748662047268],
            [27.180940935303227, -2.235621665140699],
            [27.180655719302187, -2.234234902204716],
            [27.180346735675379, -2.232848137038056],
            [27.180418039451055, -2.228544376781899],
            [27.180881992345842, -2.22732266280753],
            [27.181226150405934, -2.226416400923207],
            [27.182343244987621, -2.224025414295784],
            [27.183032516915215, -2.222710368982578],
            [27.186312496884572, -2.220582385498125],
            [27.190804643735358, -2.219076058293779],
            [27.192777385421795, -2.218860868049767],
            [27.193775640077902, -2.2184065787358],
            [27.195059110735045, -2.218215298934818],
            [27.196532725093416, -2.218597858511758],
            [27.197768659600655, -2.220391105982401],
            [27.197412139823975, -2.222160441674869],
            [27.195059110735045, -2.223714585691491],
            [27.1939971547455, -2.224030219157731],
            [27.192967529123056, -2.224336242833731],
            [27.19089971513684, -2.224790530299402],
            [27.189188421825634, -2.225579556321634],
            [27.187263215390804, -2.227707532501511],
            [27.187358287690582, -2.229596408365455],
            [27.188071327243975, -2.231987385827155],
            [27.188309006196778, -2.233493700562774],
            [27.190139140331866, -2.234593547295634],
            [27.19156521854033, -2.234713095940756],
            [27.193728103928031, -2.234258811578976],
            [27.194701216535972, -2.233574622692149],
            [27.195938525465568, -2.232704678839596],
            [27.196984316271578, -2.230791897588623],
            [27.197768659600655, -2.228711744857211],
            [27.198481699154051, -2.227372795196662],
            [27.198933290332217, -2.225723015223837],
            [27.19950372143596, -2.224455792323214],
            [27.200858495868751, -2.22378631523626],
            [27.202474718676804, -2.223714585691491],
            [27.203520509482814, -2.224407972347865],
            [27.203805724585521, -2.225794744669627],
            [27.20304514978055, -2.229787686671144],
            [27.202641093853963, -2.233087234606384],
            [27.202831237555188, -2.2353825679905],
            [27.202997613630647, -2.23712797519458],
            [27.203098560912373, -2.237954871856158],
            [27.203163989706098, -2.238490826055503],
            [27.204423691839143, -2.240403597138586],
            [27.205659626346378, -2.242029451156194],
            [27.20653904197523, -2.242675009680914],
            [27.207299616780205, -2.242364185074731],
            [27.208440479885994, -2.240762241604321],
            [27.208773231138576, -2.239423302172945],
            [27.208939607214031, -2.237295343182821],
            [27.209153518541061, -2.236171588255573],
            [27.209323361215219, -2.236007567337307],
            [27.211530316154089, -2.233876256121363],
            [27.212362194734737, -2.233278512451923],
            [27.214643920047987, -2.233398061205528],
            [27.217163325212372, -2.234330540603076],
            [27.218803315646198, -2.234497908914614],
            [27.220110553929111, -2.234808735211236],
            [27.222986478870173, -2.236123768666101],
            [27.225577187810234, -2.23734316273358],
            [27.227336018169641, -2.238538645566746],
            [27.228619487928455, -2.241670807005066],
            [27.228952240079366, -2.245209423410833],
            [27.228928471555264, -2.247409099113001],
            [27.229189919930498, -2.249632681480119],
            [27.229023543855043, -2.253147369269155],
            [27.227930216899157, -2.256685957464292],
            [27.227811376973573, -2.259315984151962],
            [27.227869848315414, -2.259927703820509],
            [27.228049056824709, -2.261802549808162],
            [27.228358040451518, -2.263500106295648],
            [27.229261223706175, -2.266034483277909],
            [27.231424109093844, -2.26931003932974],
            [27.233872210482545, -2.270816314973975],
            [27.237484942602812, -2.271342314957989],
            [27.240028115392963, -2.270075132191768],
            [27.241192746124522, -2.2663931213462],
            [27.241192746124522, -2.259141671406544],
            [27.241192746124522, -2.253792923714597],
            [27.241905784779625, -2.25111506781657],
            [27.242951575585604, -2.248676302825478],
            [27.246112716527705, -2.245185514217661],
            [27.248441977990826, -2.24399003598126],
            [27.250486023452943, -2.242818466890833],
            [27.252078477736898, -2.241073066555238],
            [27.25340948364558, -2.23583685290356],
            [27.254312666900237, -2.233302422745631],
            [27.255833817408515, -2.230552799642013],
            [27.26008828440817, -2.227253245946866],
            [27.261443058840992, -2.226655499550545],
            [27.264152607706599, -2.226631590051022],
            [27.267028532647664, -2.227731442886997],
            [27.268834898258646, -2.229261670592073],
            [27.268858665884416, -2.231246183036474],
            [27.268597218407514, -2.233804527074771],
            [27.270356048766889, -2.236817149395752],
            [27.270902712244865, -2.237749626591987],
            [27.270936452068614, -2.238394507468312],
            [27.278879286640514, -2.238939887684928],
            [27.288039121030103, -2.242130079093169],
            [27.294611996945946, -2.229251490683232],
            [27.309248869504305, -2.210757162792245],
            [27.319193862893226, -2.195960775842991],
            [27.328543057653139, -2.187084348986795],
            [27.345447568144429, -2.171180453702565],
            [27.353028444538918, -2.165263341827203],
            [27.368811914149475, -2.164159667573213],
            [27.384691145067649, -2.167126332229472],
            [27.408686211708435, -2.155665413605872],
            [27.423848322026867, -2.143830866968583],
            [27.443868630097967, -2.135328393677831],
            [27.452578824450185, -2.130521506564673],
            [27.453445704089244, -2.12053107949263],
            [27.446145268251755, -2.107206927195457],
            [27.452956463619227, -2.084267529411672],
            [27.467786295198916, -2.058370470061432],
            [27.473625851195489, -2.040980705085343],
            [27.472356492173148, -2.033949059195242],
            [27.45643334172242, -2.029131952206203],
            [27.435108754418941, -2.029123307408847],
            [27.420305922603447, -2.025046658871474],
            [27.39364181931975, -2.016894592345394],
            [27.384319264099595, -2.01133983726091],
            [27.37831410817196, -2.006156654571365],
            [27.374856669611496, -1.999864261375757],
            [27.380909705743793, -1.991221049628431],
            [27.548601517545794, -1.995591378620785],
            [27.739681874169953, -2.000571238662255],
            [27.760517939655625, -2.013461122767106],
            [27.784569522005842, -2.028763605166259],
            [27.815467939484144, -2.032939308924878],
            [27.838393082977095, -2.033875567340683],
            [27.861603344554737, -2.013274875938025],
            [27.885019166720493, -2.0014502351674],
            [27.908659627894412, -1.99920014343277],
            [27.932374608812754, -2.000141284024144],
            [27.949751795738546, -2.00024647498075],
            [27.961973785709102, -2.016275151833846],
            [27.973653615456197, -2.009166125497575],
            [27.984655926832854, -2.006839492026323],
            [27.988642563825525, -2.008459147453483],
            [27.99061500188138, -2.025223531054511],
            [27.997892036605748, -2.03244722176777],
            [28.011623865498457, -2.011789053511334],
            [28.043032038272926, -2.004001667263283],
            [28.07765572881026, -1.998626809515798],
            [28.087134160596861, -1.998684268456095],
            [28.100786428399807, -2.008339724790347],
            [28.094860114011393, -2.025056378305689],
            [28.100122949798941, -2.0474247696799],
            [28.099762950847168, -2.065770155065835],
            [28.147496748065727, -2.046913596369315],
            [28.158573578288472, -2.047778339136622],
            [28.167056365923166, -2.045962088844991],
            [28.161292090543988, -2.035176899123099],
            [28.154032180403885, -2.02725018703765],
            [28.151640507588091, -2.024638836636914],
            [28.15145079687483, -2.022815053883711],
            [28.151163101523601, -2.020040512461244],
            [28.1545467380936, -2.009908676118327],
            [28.154763868084295, -2.005224446203195],
            [28.154963481825259, -2.000938301522204],
            [28.159870193094847, -1.998878325902781],
            [28.171651840591192, -1.993932724272328],
            [28.174734041179391, -1.993780043773352],
            [28.193445027774445, -1.992854333038721],
            [28.240038523334267, -1.990549160750054],
            [28.240211798471098, -1.990571590762826],
            [28.266388314184873, -1.993960695525492],
            [28.277351594660772, -1.993318975314084],
            [28.280786514253702, -1.993118285911578],
            [28.286580880499923, -1.99236669485439],
            [28.298197493105544, -1.990860587851802],
            [28.304196880950752, -1.990509346730986],
            [28.304197178293123, -1.990509041241024],
            [28.304197311243762, -1.990509033106679],
            [28.315705520550811, -1.978689945795412],
            [28.326070028974041, -1.976396905412906],
            [28.327120959041778, -1.976164458058321],
            [28.338387812591538, -1.989127436059911],
            [28.34831581255024, -1.99317832363112],
            [28.350332259970195, -1.994001388871571],
            [28.353050014945957, -1.994050057475842],
            [28.366519237535041, -1.994292119770405],
            [28.374324741259574, -1.993216241381045],
            [28.374324970329965, -1.993215800319342],
            [28.382268124702133, -1.977890366813404],
            [28.377036974291276, -1.960858725829436],
            [28.365704196976086, -1.954710621171124],
            [28.359867357484902, -1.952531575539818],
            [28.358533859649601, -1.952033996721797],
            [28.353979596991849, -1.949598747206891],
            [28.350183548366498, -1.947569263230376],
            [28.350183676825583, -1.947568994789869],
            [28.350993117287068, -1.945883637694088],
            [28.353857040735942, -1.939922332927325],
            [28.359304428212116, -1.934650420888396],
            [28.362371444577047, -1.927659987960167],
            [28.372022628680963, -1.921522140806739],
            [28.424398186262597, -1.89987955303574],
            [28.427292195188627, -1.899710171310204],
            [28.433397293183241, -1.899353027694459],
            [28.441670231672578, -1.896304914176629],
            [28.450781018945975, -1.892948384177139],
            [28.450706847747927, -1.892003592784991],
            [28.449808121035403, -1.88053512544193],
            [28.451349258160434, -1.868570327894443],
            [28.449736019555736, -1.865128370184284],
            [28.449746563980568, -1.865130293649307],
            [28.449750411464905, -1.865130995967128],
            [28.451740634366761, -1.865494066222385],
            [28.459524612660474, -1.866914071533407],
            [28.459574408971612, -1.866923076919839],
            [28.463573714904719, -1.869477918432902],
            [28.471727371497401, -1.874687194901281],
            [28.474636882650309, -1.875285448775317],
            [28.481567416508323, -1.876711658405538],
            [28.498723821791817, -1.878702658013984],
            [28.50602816080923, -1.87591021228926],
            [28.51105874975649, -1.876805933771006],
            [28.514274802016967, -1.879780785712199],
            [28.521432846797101, -1.894233910069749],
            [28.522366857537353, -1.895086300495695],
            [28.524191407744613, -1.89675140843084],
            [28.524191793121869, -1.896751760035231],
            [28.541564768745637, -1.896900723693238],
            [28.558525274821832, -1.904640086712414],
            [28.558526830703908, -1.904640123770799],
            [28.558647212138506, -1.90464298449768],
            [28.559103011923774, -1.904653548850177],
            [28.559446334550628, -1.90466117835901],
            [28.560213088866437, -1.904678344527703],
            [28.566755294501878, -1.904830932887347],
            [28.568040847453826, -1.903385162646566],
            [28.571949695732776, -1.898982736366807],
            [28.5792636871479, -1.890745163255026],
            [28.583621007654362, -1.888442957412524],
            [28.585518642996508, -1.887440502813853],
            [28.591119539978312, -1.884481741319862],
            [28.598294281744632, -1.882612678396139],
            [28.605505140276957, -1.880734204998517],
            [28.617158167889251, -1.8802194060849],
            [28.629978360380516, -1.88360794006965],
            [28.636059437424414, -1.889114790674347],
            [28.637556075603491, -1.890470505003877],
            [28.638378985404351, -1.890576451295987],
            [28.640990925127845, -1.89091379475299],
            [28.640991495558037, -1.890912800495516],
            [28.640993117915428, -1.89091300928958],
            [28.644166946662601, -1.885379791239865],
            [28.64704663913799, -1.883288913999837],
            [28.647354240257567, -1.883065697672778],
            [28.661730119886517, -1.877707114207092],
            [28.677747959954729, -1.867712155758375],
            [28.680011795319086, -1.863789931772062],
            [28.700315475149917, -1.828617095633557],
            [28.696294784821472, -1.81645011869859],
            [28.696187973337594, -1.815860748270467],
            [28.695737838328487, -1.805971145598007],
            [28.668870925996355, -1.79392051723429],
            [28.673006942040974, -1.776131688669613],
            [28.673250119581642, -1.775086018589249],
            [28.673350315871794, -1.774811520433101],
            [28.675100326571734, -1.770023346366724],
            [28.670984268397799, -1.761594772172531],
            [28.667768478445371, -1.752510071082771],
            [28.665945052928844, -1.747348785185433],
            [28.66544914246785, -1.742916107600414],
            [28.667676550249102, -1.739758070139936],
            [28.675657207487728, -1.740824071951419],
            [28.684600125685659, -1.741858940348344],
            [28.690326452633954, -1.748571840886297],
            [28.69931743159793, -1.763243829738084],
            [28.716095571586603, -1.780177718134875],
            [28.716096401629919, -1.780177588873304],
            [28.716096877737048, -1.780178069762536],
            [28.717853075134329, -1.779903939368049],
            [28.720664217170384, -1.779466027217499],
            [28.749476804051113, -1.781854616137098],
            [28.749477197513208, -1.78185445523823],
            [28.749479294181068, -1.781854629695993],
            [28.755186080975328, -1.779527664225682],
            [28.762683129282415, -1.773021026211234],
            [28.764513130466831, -1.77143314106612],
            [28.790338500125955, -1.770386085279504],
            [28.805176784852463, -1.766404313771245],
            [28.816609444047458, -1.767496836071927],
            [28.817846755672015, -1.766636335529739],
            [28.825269699256399, -1.761474609198463],
            [28.829716449744303, -1.755496925000356],
            [28.831541220038819, -1.753044714927251],
            [28.832231926575943, -1.748134363289959],
            [28.832314519479816, -1.747547195310192],
            [28.832723617650071, -1.744651794201437],
            [28.835897445498951, -1.739807129151735],
            [28.844928112032125, -1.730883388292522],
            [28.845723555843197, -1.73009745308099],
            [28.846048439650531, -1.729776452575348],
            [28.852270126392572, -1.723630905065367],
            [28.857595281904654, -1.715145102350627],
            [28.858285771947781, -1.714045161245087],
            [28.862692162926617, -1.707025877191803],
            [28.862975949708044, -1.707375125884367],
            [28.869891656872298, -1.715889835961534],
            [28.882958182685833, -1.728749404801824],
            [28.903302447502899, -1.733132288545213],
            [28.917004730805946, -1.742238688925892],
            [28.917005166488835, -1.742238750394208],
            [28.917005539289697, -1.742238998075375],
            [28.921774194771455, -1.742914215642525],
            [28.935568204149856, -1.744867938198609],
            [28.969178533062966, -1.741662058188388],
            [28.979455798902457, -1.733009634246721],
            [28.979455837529994, -1.733009430857882],
            [28.979909376255701, -1.730632859976898],
            [28.983878032569638, -1.709836744602693],
            [28.996040107605651, -1.693748063321378],
            [28.999063102030114, -1.689749279674134],
            [29.00114236234965, -1.68861036633388],
            [29.011724472379154, -1.682815551414478],
            [29.017296422947556, -1.675094529461888],
            [29.017548177602542, -1.675924301385074],
            [29.017548242281265, -1.675924515627734],
            [29.017866105754649, -1.675924515627734],
            [29.018044565069001, -1.675627082617868],
            [29.018270613533812, -1.675341547716996],
            [29.018401484595987, -1.67500842285938],
            [29.018460971034113, -1.674568222647727],
            [29.018484765609362, -1.67427079033322],
            [29.01874650593706, -1.67406853604392],
            [29.018865478813275, -1.673568849311032],
            [29.018722711361804, -1.67328331410629],
            [29.01852045747221, -1.67303347065462],
            [29.018401484595987, -1.67286690803426],
            [29.018163537945217, -1.672664653598234],
            [29.017949386767995, -1.672462400045092],
            [29.0178423111794, -1.672260145566841],
            [29.017759030166054, -1.672093583783933],
            [29.017685343159911, -1.671926114391453],
            [29.017628159103882, -1.671796151089108],
            [29.017497288940039, -1.671522512897251],
            [29.017318829625687, -1.671260771942585],
            [29.017259343187558, -1.670987133675108],
            [29.017104678448465, -1.670654009876094],
            [29.016938115523445, -1.670356576960309],
            [29.016807245359569, -1.669916376595164],
            [29.016831039934818, -1.669571354422039],
            [29.017021396536791, -1.669404792408083],
            [29.017425905214282, -1.669035976469114],
            [29.017461597077158, -1.668690954139417],
            [29.017592467241005, -1.668571981219766],
            [29.017687645541972, -1.66822695971158],
            [29.017759030166054, -1.667941423719944],
            [29.017889900329902, -1.667548812905895],
            [29.017937489480367, -1.667263277718506],
            [29.018211127095718, -1.667120510109099],
            [29.018413381883615, -1.666894461372706],
            [29.018710814074183, -1.666751693736214],
            [29.018865478813275, -1.66648995304201],
            [29.019067733601204, -1.666335288069756],
            [29.019484138667988, -1.666275801538686],
            [29.019793469044512, -1.666061650011825],
            [29.019912441920734, -1.665776114605932],
            [29.02013849038558, -1.665585757645359],
            [29.020233669584851, -1.665074173221505],
            [29.020209874111298, -1.664503102981811],
            [29.020352642461098, -1.66441982175937],
            [29.020459718049693, -1.663932032574502],
            [29.020697663802171, -1.663646496855999],
            [29.020995096891028, -1.663123015500669],
            [29.02117355620538, -1.662896967203676],
            [29.021423399245478, -1.66267091797651],
            [29.021697037759125, -1.662551944688488],
            [29.022077750963032, -1.662551944688488],
            [29.022387081339556, -1.662563842017635],
            [29.022827281879923, -1.662563842017635],
            [29.023029535769489, -1.662409177637282],
            [29.023196097796209, -1.662230717678602],
            [29.023374558008889, -1.662147436358937],
            [29.023529222747982, -1.66182620928231],
            [29.023529222747982, -1.661457392809962],
            [29.023743373925175, -1.661362214120859],
            [29.023981320575974, -1.66094580910943],
            [29.024671364156411, -1.660767349016696],
            [29.025123461086071, -1.660267662478242],
            [29.025230537572995, -1.659660899693467],
            [29.025242434860623, -1.659351569555987],
            [29.025254332148247, -1.658839986207173],
            [29.025408996887347, -1.658364093884776],
            [29.025646942639785, -1.657495590413838],
            [29.025908683865804, -1.656841238216282],
            [29.025896786578176, -1.656056016555692],
            [29.0260633486049, -1.65581807007],
            [29.026301294357378, -1.655365972661792],
            [29.026515446432896, -1.655354075288792],
            [29.02691995421209, -1.655187512963269],
            [29.027348257464798, -1.655056642748376],
            [29.0277408688547, -1.654997156777288],
            [29.028073992908137, -1.654890080397561],
            [29.028490398873227, -1.654461777531964],
            [29.028740241913319, -1.654033474572706],
            [29.029001983139345, -1.653664658437154],
            [29.029263723467032, -1.653188765759336],
            [29.029280991781739, -1.653147323332594],
            [29.029442182781377, -1.652760463425655],
            [29.029501669219506, -1.651903857573447],
            [29.029382696343287, -1.651344683592135],
            [29.029263723467032, -1.650904483455557],
            [29.029097161440312, -1.650642742444913],
            [29.028978188564093, -1.650404797109654],
            [29.028978188564093, -1.650083569912089],
            [29.028894906652422, -1.649726650440668],
            [29.028894906652422, -1.649393525722983],
            [29.028990085851717, -1.649036607030111],
            [29.029061469577432, -1.648751070944368],
            [29.029061469577432, -1.647668416901436],
            [29.029263723467032, -1.64732339441299],
            [29.029263723467032, -1.646561967409599],
            [29.029144750590817, -1.646300226724339],
            [29.028966291276465, -1.646062280863156],
            [29.028990085851717, -1.645622080446918],
            [29.028977513031009, -1.645391583394521],
            [29.028954393988844, -1.644967728807944],
            [29.028906803940043, -1.644563220462567],
            [29.028811625639044, -1.644253889750882],
            [29.028835420214293, -1.643920765914084],
            [29.028764036488575, -1.643444873587807],
            [29.028561782598974, -1.643242618817148],
            [29.028526090736097, -1.642968981146635],
            [29.028502296160848, -1.642719137433409],
            [29.028419015147502, -1.642469294592546],
            [29.028371425997001, -1.642112375547777],
            [29.028466604298007, -1.641660277697052],
            [29.028680755475197, -1.641362844891569],
            [29.028680755475197, -1.641005925646655],
            [29.028764036488575, -1.640351574283282],
            [29.028811625639044, -1.639899476933139],
            [29.028764036488575, -1.639459276044817],
            [29.028775933776195, -1.638947692033837],
            [29.029239928891784, -1.638459902841031],
            [29.029299415329913, -1.637781756579792],
            [29.029120956015561, -1.637365351087565],
            [29.029156647878438, -1.636627717924569],
            [29.029656334856902, -1.63646115582185],
            [29.029977561622719, -1.636199414700676],
            [29.030215508273489, -1.635854392918237],
            [29.030346378437365, -1.635604549209235],
            [29.03038207030021, -1.635330911384783],
            [29.03045345402596, -1.635033478530943],
            [29.030584324189803, -1.63477173812505],
            [29.030667605203181, -1.634046002401618],
            [29.030786578079404, -1.63364149453195],
            [29.030631913340311, -1.633213191566343],
            [29.03071519435365, -1.632820580131946],
            [29.030893654566327, -1.632427969523819],
            [29.03091744914158, -1.631499979683078],
            [29.03091744914158, -1.631035984600022],
            [29.031191086756895, -1.630774243666551],
            [29.03147662255817, -1.6304887085565],
            [29.031678876447732, -1.630334043462125],
            [29.032214255289102, -1.630238865075582],
            [29.032606865780636, -1.630119891633964],
            [29.032821017856193, -1.629834356429871],
            [29.032887893835809, -1.629691050029196],
            [29.032987579882874, -1.629477437819057],
            [29.032987579882874, -1.628799291197157],
            [29.032880504294287, -1.628442372400535],
            [29.032725839555187, -1.628299604683104],
            [29.032535482054918, -1.628156836955457],
            [29.032154768850972, -1.628014069217582],
            [29.031869233049704, -1.627930788258414],
            [29.031440930695293, -1.627835609756824],
            [29.03091744914158, -1.62781181467871],
            [29.030691399778433, -1.627669046916077],
            [29.030441556738339, -1.627669046916077],
            [29.029906177896997, -1.627669046916077],
            [29.029501669219506, -1.627859403930669],
            [29.029335107192782, -1.628109247710635],
            [29.028954393988844, -1.628252015441704],
            [29.028752139200947, -1.628073556002295],
            [29.028656960899941, -1.627716636171407],
            [29.028407117859881, -1.627597663482881],
            [29.028323836846535, -1.627169360118115],
            [29.028169171209111, -1.627145565936039],
            [29.027978814607138, -1.626860030304899],
            [29.027788458005169, -1.626622084818309],
            [29.027491024916305, -1.62661018727207],
            [29.027193592725705, -1.626515008707264],
            [29.026943748787307, -1.626169987049897],
            [29.026479754570019, -1.626015321619693],
            [29.026134732330654, -1.626229472985707],
            [29.025968170303933, -1.626455521876],
            [29.025480380613065, -1.626681570740621],
            [29.025040180072725, -1.626883825394387],
            [29.024790337032627, -1.627288333736241],
            [29.024385828355136, -1.627597663482881],
            [29.023909935951895, -1.627716636171407],
            [29.023505428172733, -1.627573868401917],
            [29.023259279005099, -1.627438884060488],
            [29.023136611358115, -1.627371614722291],
            [29.022970049331398, -1.627109874210371],
            [29.022898665605641, -1.626776749297412],
            [29.022601232516745, -1.626491214517414],
            [29.022589335229156, -1.626015321619693],
            [29.022648821667246, -1.625801170230615],
            [29.023029535769489, -1.625789272679427],
            [29.023219892371458, -1.625503737757805],
            [29.023184200508581, -1.625253894554829],
            [29.023041433057116, -1.625015947972398],
            [29.022720206291297, -1.624801796475918],
            [29.022898665605641, -1.624444877866656],
            [29.022839179167551, -1.624206931187638],
            [29.022803487304675, -1.623873806693305],
            [29.023065227632365, -1.623659655074183],
            [29.023005741194268, -1.623397914978636],
            [29.022744000866549, -1.623397914978636],
            [29.022648821667246, -1.623159969078726],
            [29.022577437941528, -1.622886330445128],
            [29.022529848791027, -1.622648384484229],
            [29.022506054215778, -1.622434232733546],
            [29.022398978627184, -1.622172492477267],
            [29.022196724737583, -1.621839367643326],
            [29.022018264524942, -1.621506243657792],
            [29.021732729621966, -1.621303989362614],
            [29.021685140471497, -1.62106604321312],
            [29.021482886581904, -1.620863788873376],
            [29.021518578444777, -1.620542561403696],
            [29.021816010635341, -1.620280820899574],
            [29.022137238299457, -1.619995286093801],
            [29.022434670490025, -1.619697852755715],
            [29.022601232516745, -1.619400420277435],
            [29.022827281879923, -1.619174371492023],
            [29.02324368694671, -1.619257652816751],
            [29.023445941734607, -1.619102987754881],
            [29.023588709186079, -1.618924528400926],
            [29.023850449513802, -1.618936425089013],
            [29.024100293452197, -1.619114885345915],
            [29.024397725642764, -1.619114885345915],
            [29.024635672293531, -1.619257652816751],
            [29.024945001771727, -1.619150577214581],
            [29.024933104484099, -1.618865041343436],
            [29.024730850594498, -1.61852002017169],
            [29.024683261444032, -1.618293971286803],
            [29.024968796346979, -1.618151203747216],
            [29.025290024011124, -1.618103614263738],
            [29.02553986705119, -1.617925154820664],
            [29.025754018228412, -1.617829975841838],
            [29.026110937755405, -1.617853771038956],
            [29.026432164521221, -1.617925154820664],
            [29.026467857282391, -1.618282073690909],
            [29.026777186760587, -1.618531916862181],
            [29.027229284588575, -1.618924528400926],
            [29.027574305929644, -1.619412317866675],
            [29.028014506470011, -1.619638366625204],
            [29.028454707010379, -1.619650264213045],
            [29.028835420214293, -1.619650264213045],
            [29.029251826179404, -1.619424215455876],
            [29.029513566507134, -1.619352830823676],
            [29.029822896883619, -1.619269550406894],
            [29.030286891999239, -1.619269550406894],
            [29.03045345402596, -1.619555085316303],
            [29.03110780574352, -1.620090464065562],
            [29.031393340646488, -1.620352204594618],
            [29.031666979160136, -1.620625842671453],
            [29.032083385125254, -1.620911378291156],
            [29.032761531418064, -1.62095896770783],
            [29.033154141909598, -1.620780507615541],
            [29.033189833772475, -1.620411691607911],
            [29.033035169033383, -1.619935799068104],
            [29.032773428705692, -1.619590777177107],
            [29.032571173917795, -1.619400420277435],
            [29.032202358001477, -1.619150577214581],
            [29.031809746611611, -1.618924528400926],
            [29.031619390009638, -1.618746069031068],
            [29.031381443358868, -1.618353457457325],
            [29.031036422017802, -1.618044128085812],
            [29.031024524730174, -1.617520646389437],
            [29.030988832867298, -1.617175624081978],
            [29.031012627442554, -1.616985267856596],
            [29.031417136120044, -1.616509375405895],
            [29.031666979160136, -1.61614055861104],
            [29.031821643899239, -1.61581933128722],
            [29.032059590550006, -1.615902612751511],
            [29.032487892904417, -1.616568861629406],
            [29.032797223280941, -1.616878192132827],
            [29.033201731060103, -1.61723511118972],
            [29.033808493627188, -1.617437364992409],
            [29.034498537207625, -1.617520646389437],
            [29.03453751780274, -1.617488162802968],
            [29.034712689283143, -1.617342186894367],
            [29.03465320284505, -1.616878192132827],
            [29.0345818191193, -1.616521273012349],
            [29.034439050769532, -1.616188148141196],
            [29.034407558530582, -1.61612701480938],
            [29.034236796879931, -1.61579553696992],
            [29.03390367282649, -1.615521899136728],
            [29.033594342449966, -1.615307747527135],
            [29.033380191272776, -1.615069801568767],
            [29.033273114785853, -1.614808060349097],
            [29.033166039197226, -1.614510628048597],
            [29.032999477170502, -1.614141811790084],
            [29.032987579882874, -1.613725405876357],
            [29.032951888020037, -1.613380383819767],
            [29.032951888020037, -1.613035362607881],
            [29.032904298869536, -1.612726032415747],
            [29.032904298869536, -1.612166859146638],
            [29.032892401581908, -1.611809940091946],
            [29.033249320210604, -1.611583891354624],
            [29.033392088560404, -1.611191280186719],
            [29.033427780423246, -1.610786771301703],
            [29.033558650587089, -1.610667798510127],
            [29.033570547874717, -1.610275188067287],
            [29.034022645702709, -1.610049139157427],
            [29.034236796879931, -1.609763603798759],
            [29.03445094805716, -1.609763603798759],
            [29.034712689283143, -1.609549451575153],
            [29.034950635035617, -1.609311505838686],
            [29.035200478974012, -1.60914494326396],
            [29.035307554562607, -1.608906997479645],
            [29.035783446965848, -1.608811818977228],
            [29.036354516771734, -1.608645257265221],
            [29.036568668847284, -1.608407310517834],
            [29.037127842263875, -1.608133672582368],
            [29.037777513758822, -1.607837331336623],
            [29.037805988556684, -1.607824342540305],
            [29.037996345158657, -1.607324656213841],
            [29.038091523459624, -1.606872558610194],
            [29.038044214583515, -1.606541391127606],
            [29.0379249614329, -1.606253898995365],
            [29.037829783131933, -1.605992157532243],
            [29.037794091269056, -1.605742314609411],
            [29.037603733768787, -1.605528162862329],
            [29.037341993441064, -1.605290216650903],
            [29.037187328701965, -1.60505227041145],
            [29.037127842263875, -1.604766735248628],
            [29.037199225989593, -1.604243253710555],
            [29.03708025311337, -1.603684080798075],
            [29.036949382051198, -1.603529415441762],
            [29.036770922736853, -1.603267675433298],
            [29.036735230874005, -1.602839372295395],
            [29.036747128161601, -1.602220712348388],
            [29.036949382051198, -1.601982765747243],
            [29.037234917852469, -1.601697231054545],
            [29.037401479879193, -1.601221338605066],
            [29.037591836481159, -1.600947700599335],
            [29.037675118392841, -1.600543192371765],
            [29.037603733768787, -1.600245759773286],
            [29.03756804190591, -1.599781764687761],
            [29.037758399406179, -1.599650894445236],
            [29.038055831596747, -1.599175002418554],
            [29.038246188198716, -1.598925158652977],
            [29.038329470110391, -1.598413575124054],
            [29.038496032137115, -1.598080449971218],
            [29.039031410978488, -1.597473687192474],
            [29.039435918757643, -1.597128665972332],
            [29.039852324722762, -1.596783643789487],
            [29.039995092174237, -1.596248265172208],
            [29.040054578612363, -1.595915140567662],
            [29.04035201170122, -1.595736680967863],
            [29.040447190002226, -1.595320275776681],
            [29.040625649316571, -1.59497525328634],
            [29.040768417666339, -1.594368491386994],
            [29.040708930329917, -1.593916393600439],
            [29.040625649316571, -1.593499988036051],
            [29.0403877035641, -1.593143068396366],
            [29.0403877035641, -1.592845636520801],
            [29.040566162878449, -1.592334052363553],
            [29.040827904104468, -1.591929543322461],
            [29.041089644432159, -1.591525035104904],
            [29.041458461246808, -1.591417959838817],
            [29.041958147326969, -1.59133467826883],
            [29.042588704469278, -1.591465549047584],
            [29.043064596872519, -1.591120526806993],
            [29.043968792528474, -1.591001553762881],
            [29.044397094882918, -1.591132424563009],
            [29.044861089998506, -1.591263294450737],
            [29.045348879689374, -1.591084835346506],
            [29.045610620017065, -1.590846889247176],
            [29.046027025982184, -1.590549456131882],
            [29.04655050753593, -1.590073563780262],
            [29.046633788549272, -1.589740439067997],
            [29.046681377699773, -1.589169368909942],
            [29.046669480412145, -1.588800552549321],
            [29.046621891261644, -1.588479325400444],
            [29.046621891261644, -1.588110508914967],
            [29.04677655600074, -1.587943946405227],
            [29.047181064678231, -1.58753943830035],
            [29.047430907718329, -1.587325286439608],
            [29.0476688543691, -1.587027853714453],
            [29.047692648944356, -1.586540064566085],
            [29.047811621820571, -1.586492475242322],
            [29.048037670285389, -1.586385399711842],
            [29.048299411511408, -1.58607606996828],
            [29.04822802778569, -1.585552588131172],
            [29.04826371964857, -1.58515997734328],
            [29.04851356268863, -1.584850647414114],
            [29.048810994879197, -1.584600803697466],
            [29.049037044242343, -1.584386652432607],
            [29.049227400844316, -1.584386652432607],
            [29.049346373720535, -1.584172501145293],
            [29.049489142070335, -1.583958348931522],
            [29.049869855274281, -1.583958348931522],
            [29.050095904637427, -1.583875067961031],
            [29.050226774801271, -1.583672814419657],
            [29.05045282326612, -1.583625225029153],
            [29.050726461779767, -1.583851273268235],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        PRINCIPALTOWN: "Kinshasa",
        AREA: 9965,
        POPULATION: 11575000,
        DISTRICTS: [],
        OBJECTID: 1,
        NOM: "Kinshasa",
        SCE_SEM: null,
        MODIF: "1899/12/30",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [15.950451055308729, -3.930469644241713],
            [15.951308544858126, -3.931361944222334],
            [15.952461871190145, -3.931691468437365],
            [15.953549428266975, -3.932120320674307],
            [15.954604684621133, -3.933111641951397],
            [15.956624724403881, -3.935004377601126],
            [15.957942369669372, -3.936955814593886],
            [15.958457294769996, -3.937127540632489],
            [15.95925798204736, -3.937126615870656],
            [15.960516205553448, -3.937125162415689],
            [15.961889142124651, -3.937410773035352],
            [15.96343391922322, -3.937925940833988],
            [15.963948845222177, -3.938097662158742],
            [15.96429285685684, -3.938843978940103],
            [15.964293848596936, -3.939705574148757],
            [15.964980285441523, -3.939819656013797],
            [15.965723848849962, -3.939876230501085],
            [15.966524869402283, -3.940162496968031],
            [15.966869281685588, -3.941253449558493],
            [15.966755561258829, -3.941827978906013],
            [15.967556915086107, -3.942401441449845],
            [15.96852904942871, -3.942285428331264],
            [15.969330272101979, -3.942744009763114],
            [15.969960385476551, -3.943604867389154],
            [15.97133426617714, -3.944694611869621],
            [15.97166725997487, -3.945361531969652],
            [15.971792872299336, -3.945613107937024],
            [15.97202197593448, -3.94590003732127],
            [15.972651158654392, -3.945956738599004],
            [15.973451851321641, -3.945955798509734],
            [15.97413849388043, -3.946242190064779],
            [15.974491984537998, -3.947047386660057],
            [15.975949811005247, -3.947896326284527],
            [15.976137058538033, -3.948008137990535],
            [15.97771279786946, -3.948949060683979],
            [15.978526353513281, -3.949322387443416],
            [15.979982629488338, -3.948844299750987],
            [15.980525585619125, -3.949592232504882],
            [15.981001302850871, -3.950782585954743],
            [15.981815702012732, -3.951870457865271],
            [15.984695296571738, -3.951696906173574],
            [15.985576215082066, -3.951729883947989],
            [15.986051578377587, -3.95261399689765],
            [15.986052422793959, -3.953328544318182],
            [15.986933262252546, -3.9532934681168],
            [15.98784769870274, -3.953020167988645],
            [15.988831063783024, -3.953733541307315],
            [15.990256243676223, -3.955603270522028],
            [15.990731008693777, -3.955976988501166],
            [15.992323330027061, -3.955941053532337],
            [15.99466129347033, -3.956142400667177],
            [15.996389458040891, -3.956378501742793],
            [15.997338871294975, -3.957023851011085],
            [15.997949770603965, -3.95790778952956],
            [15.998491932624018, -3.957975187167988],
            [15.999000622518254, -3.958382883894501],
            [15.9993066857221, -3.959335241543917],
            [15.999477229082157, -3.960287762280027],
            [15.999782721855745, -3.960763756539341],
            [15.999649488224405, -3.962669371864527],
            [15.999616262236993, -3.963213827413657],
            [15.999176186562456, -3.963520594020171],
            [15.999244355217797, -3.963860771743557],
            [15.999752763939343, -3.9640302854142],
            [16.000430532939738, -3.964165567752523],
            [16.001481312090529, -3.964572604603695],
            [16.002498253501159, -3.965013707416512],
            [16.002803709443864, -3.965455673372738],
            [16.002805144951694, -3.966646579302199],
            [16.002772331290984, -3.967531293193724],
            [16.002851384832621, -3.967998750478433],
            [16.009546320236009, -3.969563877787099],
            [16.010469359851708, -3.971403007064045],
            [16.019862839758499, -3.969885352798077],
            [16.025142960030429, -3.968440513632314],
            [16.029138239714445, -3.966805086773681],
            [16.032915397667665, -3.9645734165625],
            [16.034386679999574, -3.963704132109323],
            [16.03829843971835, -3.95765249944035],
            [16.042883399605984, -3.94847643555956],
            [16.047544680360183, -3.943348510950872],
            [16.055943119782945, -3.942287500687034],
            [16.06403087955961, -3.944168944919605],
            [16.0758136795945, -3.947909164517077],
            [16.089848639589963, -3.95460491049863],
            [16.099934063014011, -3.959346432212209],
            [16.123084919900226, -3.97023038063946],
            [16.185150360109876, -4.000722072642684],
            [16.229886840348065, -4.024500781651527],
            [16.269829920111686, -4.046414304967977],
            [16.313115959830903, -4.070920098835763],
            [16.34754743964352, -4.091700344840094],
            [16.38159911983885, -4.111742293054111],
            [16.413855119883529, -4.133614217669491],
            [16.423580159876849, -4.14316384820294],
            [16.425276162963591, -4.14406351584744],
            [16.427026439564838, -4.144991971610334],
            [16.429811400201913, -4.152804857073652],
            [16.435102320020221, -4.156695992139956],
            [16.441978319852272, -4.156668848589865],
            [16.450718400255692, -4.16261687125074],
            [16.451109359643766, -4.163692866747919],
            [16.453966320250871, -4.171578903024205],
            [16.469337240363846, -4.173588865469853],
            [16.471641240302855, -4.176571984931527],
            [16.470966239910183, -4.179564978078019],
            [16.467317279632809, -4.183951901036161],
            [16.460893439612484, -4.183056939855312],
            [16.456777199978834, -4.185834931418578],
            [16.45496748005862, -4.191134926383979],
            [16.455904200117754, -4.195733882107901],
            [16.463733480451225, -4.203527023668792],
            [16.465918027813665, -4.207325441770521],
            [16.467430320034897, -4.209954954090302],
            [16.468836479898588, -4.217082915548471],
            [16.470678240030075, -4.218915896778984],
            [16.477129646651527, -4.220244301817938],
            [16.480547279963446, -4.220948024022424],
            [16.483388763496528, -4.222882381024536],
            [16.482989559370793, -4.224679662817056],
            [16.48230609055992, -4.226231534132645],
            [16.480593212620533, -4.227900233078269],
            [16.478936005075973, -4.228764827354193],
            [16.477852332314459, -4.230432321281856],
            [16.477740542367229, -4.23181081608888],
            [16.477914979025741, -4.23330362124333],
            [16.478652530908306, -4.234842246462826],
            [16.480043502955468, -4.23571631691123],
            [16.482069741113719, -4.236668868480387],
            [16.483501704185606, -4.238220325845321],
            [16.484098414604674, -4.23889665366157],
            [16.48493207634116, -4.238934902555886],
            [16.486123064541491, -4.239012313023617],
            [16.487710311291703, -4.238730296065794],
            [16.488462981820515, -4.237931817881331],
            [16.491440596950042, -4.238205031143564],
            [16.493189750657216, -4.239556594048867],
            [16.493631516961127, -4.242225774831004],
            [16.492682980462707, -4.244379580757214],
            [16.491101618575915, -4.247730152878777],
            [16.489678683572595, -4.250901087325185],
            [16.489446482546391, -4.254009941799635],
            [16.489650933715158, -4.257117950258561],
            [16.490012255885354, -4.259229370901714],
            [16.491445055288803, -4.26117930470352],
            [16.49422955419184, -4.264182661315953],
            [16.497526375776143, -4.265252216025812],
            [16.50054533227339, -4.266322298601058],
            [16.503207420447584, -4.267592320498004],
            [16.504481096773173, -4.269343269155317],
            [16.504842939966256, -4.27169377074144],
            [16.505046703923838, -4.274403241062134],
            [16.506087244077015, -4.278725031031118],
            [16.507401193673413, -4.280754843217824],
            [16.510028961712198, -4.284734751230927],
            [16.511106008500182, -4.28740263314556],
            [16.513102641779891, -4.293396234928166],
            [16.513939653334091, -4.295108159879341],
            [16.515769565585295, -4.297057212054875],
            [16.516607219434917, -4.299087935295006],
            [16.516691617952482, -4.301618293322875],
            [16.517848124320626, -4.304285989166968],
            [16.519797640065377, -4.306473886138128],
            [16.521154160823091, -4.309898332684369],
            [16.521674668054914, -4.312128929490686],
            [16.521245131415288, -4.315716354358426],
            [16.521287685508629, -4.317150894763555],
            [16.522086807022415, -4.319739584846372],
            [16.522646633514228, -4.32177084456991],
            [16.522134692616959, -4.323844109128337],
            [16.52051111709833, -4.325879759190286],
            [16.518886977437688, -4.32763645437071],
            [16.517261083367284, -4.328516434844158],
            [16.516628127723159, -4.329633526978418],
            [16.51635452244717, -4.331786018364242],
            [16.51643685753454, -4.333260332079336],
            [16.517711195020162, -4.335250310023263],
            [16.519184750988053, -4.337598538649037],
            [16.521974257100478, -4.342873130583839],
            [16.523965938866354, -4.346216558175167],
            [16.526154976008584, -4.348981739706615],
            [16.526873338978351, -4.350853259758252],
            [16.529021617759515, -4.353080525853001],
            [16.531049359697541, -4.354590717575085],
            [16.532403665209742, -4.356819582935358],
            [16.532446108810305, -4.358174412498174],
            [16.532250595878594, -4.359649278077862],
            [16.532452406000459, -4.36128273542629],
            [16.531620804999211, -4.362320544714641],
            [16.531505904186165, -4.36439300384127],
            [16.531470727956258, -4.366624702664722],
            [16.530324750741592, -4.36925717529609],
            [16.528623281406343, -4.372050185850595],
            [16.52704106612001, -4.374922654417946],
            [16.525139135034173, -4.376759660532231],
            [16.522164540938917, -4.378240195008682],
            [16.520064323822098, -4.380197150484087],
            [16.519434333516692, -4.382788726432723],
            [16.518405636752249, -4.384544249121345],
            [16.517457304171408, -4.386777816693173],
            [16.516703295152855, -4.386938752975989],
            [16.516545935467896, -4.387656386227948],
            [16.514998051096804, -4.387898636130175],
            [16.513410783685288, -4.388300365720052],
            [16.512974706412098, -4.388620056415504],
            [16.512060441540111, -4.388063999432587],
            [16.510909891002292, -4.388464839873187],
            [16.509088168691562, -4.390740027025778],
            [16.508576605985006, -4.393012561628282],
            [16.508300773785447, -4.394049242520042],
            [16.509059363313632, -4.396159801157777],
            [16.511886259104816, -4.400139145877421],
            [16.512883164491381, -4.402289060972237],
            [16.514955355967952, -4.406070660781939],
            [16.514999658182845, -4.408342062382829],
            [16.515201441355227, -4.409955605188483],
            [16.514012694451523, -4.411113702468239],
            [16.51123541800338, -4.412075783837846],
            [16.50901236615292, -4.412239711677179],
            [16.507145353480492, -4.411765297513792],
            [16.50567681909504, -4.412007384384208],
            [16.504448426842931, -4.413205403587702],
            [16.503856407426277, -4.414960045753398],
            [16.503264226312904, -4.416634986142458],
            [16.501164589507741, -4.418950597828089],
            [16.49993553968886, -4.419829809610719],
            [16.499180928799049, -4.419711785282138],
            [16.4986264374017, -4.420390374193869],
            [16.497834523071422, -4.421467954560415],
            [16.497204823820177, -4.424238875939015],
            [16.497285992894312, -4.425115434154506],
            [16.496534337461785, -4.426471890826734],
            [16.496221748895756, -4.428983140138945],
            [16.496108643814946, -4.431972197546811],
            [16.49635079907285, -4.433924408734531],
            [16.496431250393037, -4.434442309273688],
            [16.495877912432562, -4.435698738616439],
            [16.495283665194002, -4.436357485063126],
            [16.494531440229583, -4.437434988665497],
            [16.494060033114579, -4.43994656177839],
            [16.492516749016019, -4.442540009204305],
            [16.491407249690091, -4.44365808714117],
            [16.491570316372037, -4.445769866793479],
            [16.493759402023279, -4.448395599909245],
            [16.495749011375786, -4.450543514799644],
            [16.497184044889348, -4.453330165866603],
            [16.498022457815388, -4.455599964281922],
            [16.497667648430976, -4.456855993729206],
            [16.497949704158827, -4.458887819365162],
            [16.497754404127861, -4.460482257341503],
            [16.49759994061138, -4.462634526303378],
            [16.496971348084596, -4.465943442105208],
            [16.496935197182601, -4.467696960034045],
            [16.497217750577143, -4.469967890013852],
            [16.498413478288892, -4.472197098596762],
            [16.498734451729796, -4.473830330976669],
            [16.4976261489598, -4.475546191728833],
            [16.496955346394429, -4.47761981679185],
            [16.496008536458003, -4.48065043095492],
            [16.494860594627784, -4.482406225713863],
            [16.494233545406644, -4.483520310397623],
            [16.486803665929965, -4.483185958593405],
            [16.478693262319894, -4.482820993060727],
            [16.475261399693888, -4.484905930772809],
            [16.468629594295386, -4.484101059631134],
            [16.464245399788929, -4.483568969667322],
            [16.458777986170123, -4.480968319494541],
            [16.453212480115571, -4.478321001816354],
            [16.445005217456629, -4.476214104367681],
            [16.441732440179234, -4.475373943990589],
            [16.424696319312289, -4.460895221456493],
            [16.419634200396871, -4.456592952367572],
            [16.415737199998205, -4.457298022914604],
            [16.406137439952733, -4.465158869828924],
            [16.404087240132633, -4.468618952565385],
            [16.401848400391049, -4.481514023244748],
            [16.398779399647633, -4.486395971852891],
            [16.3970643603617, -4.489125938175645],
            [16.397094240124687, -4.505055988384798],
            [16.395854389861135, -4.514374683685742],
            [16.394905440137684, -4.521506894761657],
            [16.388599319843799, -4.535666916182997],
            [16.383015000372229, -4.545021495315736],
            [16.376921639765158, -4.552674056810823],
            [16.371623880174283, -4.557648940212722],
            [16.365345840317833, -4.567357328567624],
            [16.359499800281508, -4.57911612283517],
            [16.355068920329728, -4.58839772988251],
            [16.34860152010295, -4.599750533617114],
            [16.341762960255323, -4.615009295947423],
            [16.336739520101066, -4.626760467269886],
            [16.331292720123091, -4.637282371455373],
            [16.326672479800987, -4.648208112555903],
            [16.322858279817016, -4.657483594635624],
            [16.317808200123036, -4.666564055153926],
            [16.312365359918832, -4.677496161008277],
            [16.306939080156923, -4.690071281931022],
            [16.30373363969489, -4.698519411154423],
            [16.298897400361032, -4.708419107717214],
            [16.294069439900827, -4.719140040479449],
            [16.290872640333507, -4.72840936004606],
            [16.287631560110931, -4.733365925549372],
            [16.283555639562174, -4.737096976462847],
            [16.278644160035057, -4.739602891554694],
            [16.275168359910186, -4.741685819158086],
            [16.27079615970937, -4.744326962214497],
            [16.262482024481077, -4.747762665935459],
            [16.262483634262075, -4.748648084687874],
            [16.262174372157535, -4.749103326943935],
            [16.262270741624587, -4.749629616778119],
            [16.262652433992169, -4.749652848492381],
            [16.263128536601165, -4.749125509652321],
            [16.263414816207501, -4.749148916221077],
            [16.263487333607124, -4.749675250179948],
            [16.263106468587903, -4.750106693182323],
            [16.263345609099684, -4.750441278943511],
            [16.264014104791404, -4.750775078675392],
            [16.26406290127764, -4.751373246743609],
            [16.263633763490027, -4.751493684903441],
            [16.263204015746282, -4.751279099864421],
            [16.262918039770536, -4.751423204984078],
            [16.262942502692361, -4.751758184832034],
            [16.26339667023877, -4.75228381922887],
            [16.263589326527843, -4.75328853891159],
            [16.26316049237078, -4.753576488718272],
            [16.262612131076956, -4.753721075502274],
            [16.262493475306012, -4.754056317373702],
            [16.262899284744037, -4.754223085696627],
            [16.263400681216506, -4.754485400015839],
            [16.26294943229647, -4.755563091406594],
            [16.262664413924792, -4.75623366238742],
            [16.262927889797641, -4.756831436329518],
            [16.262928892317504, -4.757381832117322],
            [16.262643263091434, -4.75771738039751],
            [16.262238105830306, -4.757909565593597],
            [16.262405994668708, -4.758411794391951],
            [16.262764275143365, -4.758674370247755],
            [16.262693892140845, -4.759320618113442],
            [16.262695200986219, -4.76003852498104],
            [16.262098997216977, -4.760111409332874],
            [16.261454955463943, -4.760112589916198],
            [16.261383917589573, -4.760399884356292],
            [16.262028658231916, -4.760781587403381],
            [16.262196199422309, -4.761092373332594],
            [16.262006026076644, -4.76145167739527],
            [16.261505190152928, -4.761500456116349],
            [16.261506236690249, -4.76207478235058],
            [16.261983699348583, -4.762289279267053],
            [16.262246611079423, -4.762575959966286],
            [16.262032365579106, -4.762815656220548],
            [16.261364511284512, -4.762840812457991],
            [16.260792070649455, -4.762865792058305],
            [16.26074514894723, -4.763296623780461],
            [16.261031827405546, -4.763535401453217],
            [16.261437467960278, -4.763606448775775],
            [16.261224617543622, -4.764611912326231],
            [16.261178786396137, -4.765641000280206],
            [16.261418675204567, -4.766382399260427],
            [16.261658303501537, -4.766980217436281],
            [16.261396567665397, -4.767339652659409],
            [16.261110629418894, -4.767507689311131],
            [16.260539668309161, -4.768346298453781],
            [16.260230486154658, -4.768849402700689],
            [16.259299973454137, -4.768731457627015],
            [16.258919271928292, -4.769258622633616],
            [16.25813351465095, -4.770037798475711],
            [16.257585660905256, -4.770469548464689],
            [16.257371891512033, -4.770972477204785],
            [16.256775850337867, -4.771141080708016],
            [16.255798060202274, -4.771262521994313],
            [16.255727456214203, -4.771789119082457],
            [16.256301297322732, -4.772529910241986],
            [16.256636645604818, -4.773295067898529],
            [16.256829131214012, -4.774204068133706],
            [16.257188378275917, -4.774993111711862],
            [16.257618185308434, -4.775231627523788],
            [16.258070887702608, -4.774943632836758],
            [16.258477320571448, -4.775445424559305],
            [16.259050426858085, -4.775779397636798],
            [16.259313824577482, -4.77632931123049],
            [16.259506098184264, -4.777118658734285],
            [16.259650226583403, -4.777668792030033],
            [16.25926886838911, -4.777837004553567],
            [16.259269610397514, -4.77824381829921],
            [16.259508980878014, -4.778698054803705],
            [16.259151913129003, -4.77910552679655],
            [16.259153354026715, -4.779895224324318],
            [16.258844561741054, -4.780613701470701],
            [16.258510778324208, -4.780710035950488],
            [16.258056719473952, -4.78025619371269],
            [16.257675839183381, -4.780687638892613],
            [16.256603448363485, -4.781263935061768],
            [16.256293867357037, -4.781551666616942],
            [16.256224223667996, -4.782604729918928],
            [16.25539093832559, -4.783491681149558],
            [16.252889066478957, -4.78505173752387],
            [16.252508311054182, -4.785554972636455],
            [16.252629497379289, -4.786607687252742],
            [16.251558006671313, -4.787686515290066],
            [16.251106119947437, -4.788429184195925],
            [16.251250203430789, -4.788955389423563],
            [16.251560790550386, -4.789218055266788],
            [16.251538806978751, -4.790247102189343],
            [16.250371304333235, -4.791003045178472],
            [16.250157874503184, -4.791697416918736],
            [16.250183163875072, -4.792487074490608],
            [16.250041557945245, -4.793324897476156],
            [16.250137716308213, -4.79373153788092],
            [16.250734649509464, -4.794041540883354],
            [16.250854401225034, -4.79430455619963],
            [16.25042562635678, -4.794640366435085],
            [16.250522656085568, -4.795525613072267],
            [16.250499976319585, -4.796171775273797],
            [16.251263458971128, -4.796242168529598],
            [16.251479328625461, -4.796887892981641],
            [16.251576578441504, -4.797892790674207],
            [16.251291061504872, -4.798300130324744],
            [16.251077240009351, -4.798779130647849],
            [16.250911933827407, -4.799700753313592],
            [16.250794271593186, -4.800586393414089],
            [16.250461131370059, -4.801041680945016],
            [16.249770557783609, -4.801712997151291],
            [16.249605097989726, -4.80255086453513],
            [16.249367767583266, -4.803221350177068],
            [16.248963930845601, -4.804155375595442],
            [16.248822630342989, -4.805160711212054],
            [16.24951569136444, -4.805853422862348],
            [16.250183459420779, -4.805756477391735],
            [16.250754978384347, -4.805205029697427],
            [16.25094437917884, -4.804414979715398],
            [16.25122976675809, -4.803935848229946],
            [16.251730940448347, -4.804054580167047],
            [16.251803597086852, -4.804652706535113],
            [16.251256938998793, -4.805754507482687],
            [16.250567060708359, -4.806808709878208],
            [16.250162789186103, -4.807503432989829],
            [16.250545562226989, -4.808100990371688],
            [16.250999291395512, -4.808363391922626],
            [16.251642900160611, -4.808098975412285],
            [16.252287645294544, -4.808456745957952],
            [16.252288650509364, -4.809007142955512],
            [16.251765409704106, -4.809869597930817],
            [16.251742865583747, -4.81058755020292],
            [16.252220888790841, -4.811089209068507],
            [16.251888489677825, -4.811951313531407],
            [16.251699046662498, -4.812717433935809],
            [16.250983998476126, -4.813053773862291],
            [16.251294774241945, -4.81341215814752],
            [16.251367214386448, -4.813890632256759],
            [16.250747237601523, -4.814035354821987],
            [16.249792759645839, -4.813893525807218],
            [16.249244260909791, -4.81399025473226],
            [16.248983073944281, -4.814660784833734],
            [16.248840595750345, -4.815020002712513],
            [16.248888917926109, -4.815354939319556],
            [16.249032443555659, -4.815570049197349],
            [16.248794413361598, -4.815857651654114],
            [16.248747356912073, -4.816216694072352],
            [16.249153205875967, -4.81638346146686],
            [16.249606896416946, -4.816621931992471],
            [16.250322604865055, -4.816644546830902],
            [16.250371277383753, -4.817170925542772],
            [16.250682098963658, -4.817553239892484],
            [16.251374476367218, -4.817863060699808],
            [16.251471124312005, -4.818532933611932],
            [16.251900830733216, -4.818699654473043],
            [16.2519257805419, -4.819297867826125],
            [16.25207014070639, -4.81996765189579],
            [16.252285410286134, -4.820278350187885],
            [16.251737695779287, -4.820805827225959],
            [16.251381000831106, -4.821428673703429],
            [16.252193362613916, -4.822121157707342],
            [16.252241863554403, -4.822551814605208],
            [16.252027688122695, -4.822839373517367],
            [16.252148171965231, -4.8234972366843],
            [16.251719251569881, -4.823761261447095],
            [16.250956044701113, -4.823858389047847],
            [16.250527342596392, -4.824242064785479],
            [16.249835700913057, -4.824339059851487],
            [16.249048461415505, -4.824340507955858],
            [16.248261833670682, -4.824676979925739],
            [16.247904696751359, -4.825060522729658],
            [16.24761847104395, -4.825084979176411],
            [16.247092900907223, -4.824679128201514],
            [16.24630539820329, -4.824536991451502],
            [16.245398965742261, -4.824586515343427],
            [16.244898691265565, -4.824970319524491],
            [16.244780371464568, -4.825497006190668],
            [16.244280271261044, -4.82597653139533],
            [16.243994501897824, -4.826252255326413],
            [16.243231331859974, -4.826373305502622],
            [16.242946019739211, -4.826900297446071],
            [16.242829135446044, -4.82821668648942],
            [16.242352234234723, -4.828337211860075],
            [16.24199361150194, -4.827907120078329],
            [16.241564552766071, -4.828099349251704],
            [16.241517885287056, -4.828673765625667],
            [16.241136929537998, -4.82908128034373],
            [16.241185425088602, -4.82951193907399],
            [16.241139149275057, -4.830301728818277],
            [16.241068886646786, -4.831019770950578],
            [16.241880427369413, -4.831257590168588],
            [16.242478005561043, -4.831902617725619],
            [16.242742209967574, -4.832883280779207],
            [16.243124605716012, -4.833265467214324],
            [16.243411445871072, -4.833576035884237],
            [16.243197264151146, -4.833863594566328],
            [16.242554216833099, -4.834451069371291],
            [16.242172300785008, -4.83433211753798],
            [16.242028291861814, -4.833853772467204],
            [16.242051363293271, -4.833422982266629],
            [16.241383522473363, -4.833495997452209],
            [16.240644809069153, -4.833952028595205],
            [16.240311737118009, -4.834455177528207],
            [16.240169688318751, -4.835053699402446],
            [16.240624523313397, -4.835914362800522],
            [16.241030646263475, -4.836224714875322],
            [16.24098450160394, -4.837086295893143],
            [16.241604983242066, -4.83720481110123],
            [16.242153720929974, -4.837227735224749],
            [16.242416794357556, -4.837586209301961],
            [16.242442395444872, -4.838543379453068],
            [16.242920744740374, -4.839212554040278],
            [16.242778305173982, -4.839595701936389],
            [16.242684276716563, -4.840361648342911],
            [16.243305197630839, -4.840719464736732],
            [16.243044263091942, -4.841533578138187],
            [16.242854940450865, -4.842371491262665],
            [16.242187659281417, -4.842755604224051],
            [16.242070036573068, -4.843665176440818],
            [16.242667409948794, -4.844190548998274],
            [16.242668720590792, -4.84490845906145],
            [16.242288284067985, -4.845603140848189],
            [16.241405852794713, -4.845748344047085],
            [16.240953625609336, -4.846323505771138],
            [16.240835696575445, -4.847065565512903],
            [16.241338345299432, -4.847973999181256],
            [16.240695439016896, -4.848645232312767],
            [16.240385956825101, -4.849004757234941],
            [16.240411429453292, -4.849890137519412],
            [16.240294766145642, -4.851326178880952],
            [16.240487586826458, -4.852402694252351],
            [16.240155207476374, -4.853288731416679],
            [16.240538272469717, -4.854029871506339],
            [16.241826761116016, -4.854147153726108],
            [16.2433768876821, -4.853833204756255],
            [16.24450268154898, -4.853695922939396],
            [16.24532462296597, -4.853084181764499],
            [16.24690193884074, -4.854588884099398],
            [16.247977507900099, -4.855681710962809],
            [16.250267037776531, -4.855282621373529],
            [16.253238071848287, -4.855743751255758],
            [16.255424886558501, -4.857857517737131],
            [16.256893081380785, -4.858393214455003],
            [16.258647492927302, -4.858892478430115],
            [16.259149953005039, -4.859681238606168],
            [16.258401258419713, -4.861190244866314],
            [16.25815342401259, -4.862626524057036],
            [16.257405924186568, -4.86478164481244],
            [16.257408722438697, -4.866289247344763],
            [16.257410788563853, -4.867402001845482],
            [16.258128771546243, -4.868621104251873],
            [16.259131842070587, -4.869193554731411],
            [16.259420600128784, -4.870521143332385],
            [16.259351433445165, -4.871813507796288],
            [16.260212035657041, -4.872745174763838],
            [16.261179930849806, -4.873640744113229],
            [16.261074245853255, -4.874538327012058],
            [16.262042413235541, -4.875577475035428],
            [16.263190789850388, -4.877298293147633],
            [16.26397902647788, -4.877799345007108],
            [16.265124857267185, -4.878156141095424],
            [16.265806140476993, -4.878872762923501],
            [16.266201404591889, -4.879733504800428],
            [16.266524692991275, -4.880379009790128],
            [16.265880672797802, -4.880452015318373],
            [16.265452380324824, -4.881063042882332],
            [16.265668646136216, -4.881888227580174],
            [16.266277486506556, -4.882138345900558],
            [16.266314619267146, -4.882856181630228],
            [16.267245404157222, -4.883033900751442],
            [16.26699756076696, -4.884452231649871],
            [16.265887639232826, -4.884167165494326],
            [16.265639220022464, -4.885280388258391],
            [16.26503300183445, -4.886430181413108],
            [16.26467715399756, -4.887507712083921],
            [16.264893489877558, -4.888368790529918],
            [16.264895039471416, -4.889194379690452],
            [16.266471614236078, -4.890232364899087],
            [16.267439074644251, -4.89087665045883],
            [16.267296804859438, -4.891343558239018],
            [16.266508750589921, -4.890950199953272],
            [16.265936294683552, -4.89102307276412],
            [16.266044532692121, -4.891489507399128],
            [16.266474650541735, -4.89184764675072],
            [16.266082140661506, -4.892458608824093],
            [16.266083354285453, -4.893104721303071],
            [16.266549057996716, -4.893355107491589],
            [16.267408757401739, -4.89378422347431],
            [16.268124700310125, -4.893890553868549],
            [16.268949526217497, -4.89480431968282],
            [16.26920125392304, -4.895449956827875],
            [16.268307252348915, -4.895810603389158],
            [16.267664098131345, -4.8963502510576],
            [16.267701237180145, -4.897068085769176],
            [16.268345406493967, -4.897066864881316],
            [16.269203757527713, -4.896778075727285],
            [16.269347989233122, -4.897352125499435],
            [16.268632989555758, -4.897748329007366],
            [16.267774366332489, -4.897893537912776],
            [16.267275035086847, -4.898791865482239],
            [16.267956144023479, -4.899400793831406],
            [16.26806431735336, -4.899831331297918],
            [16.267277333875651, -4.900012300338427],
            [16.266775634670957, -4.899654297866382],
            [16.266275625197274, -4.900193673887262],
            [16.266706223645564, -4.900803077581459],
            [16.265635505488763, -4.902348602957582],
            [16.266281878369966, -4.903513974683372],
            [16.266425772308832, -4.903908549959476],
            [16.26588909360526, -4.903981357367306],
            [16.265854185073319, -4.904448062157051],
            [16.266463927352216, -4.905164811343278],
            [16.266250148077525, -4.905667750415177],
            [16.265533853927845, -4.905381945578734],
            [16.265069221906682, -4.905705883966844],
            [16.265069898338098, -4.906064834620889],
            [16.265785719973941, -4.906099374012997],
            [16.265786869817489, -4.906709591265817],
            [16.265071791088417, -4.907069899195899],
            [16.263889578530097, -4.906426023191882],
            [16.26324573620305, -4.906606717415356],
            [16.263032426747237, -4.907360922852094],
            [16.263391452823591, -4.90797046317904],
            [16.263392466123218, -4.908508890839452],
            [16.263786402528133, -4.908651726821103],
            [16.263286655362535, -4.90933468275129],
            [16.263824420129296, -4.909836199552925],
            [16.263504085390529, -4.910770083442619],
            [16.263612530909967, -4.911344203018186],
            [16.263649061799299, -4.911738981734577],
            [16.263220348914814, -4.912134642296711],
            [16.263507869992836, -4.912780212909155],
            [16.262972130028729, -4.913355552489366],
            [16.263116702195639, -4.914109079847737],
            [16.26329658893297, -4.914611273265295],
            [16.264513015625475, -4.914411543098184],
            [16.265194548566942, -4.915235840952729],
            [16.265482886213558, -4.916312151451942],
            [16.265735030737389, -4.917173158938594],
            [16.265664606412404, -4.917783512783439],
            [16.266166795198945, -4.918392777659273],
            [16.266168151654998, -4.91911068024461],
            [16.266134330982876, -4.920151706931239],
            [16.265420968934286, -4.921427343740769],
            [16.265887102040264, -4.921893096420287],
            [16.266067266357034, -4.922538868278918],
            [16.266533332987695, -4.9229687247766],
            [16.267248289545897, -4.922536620310336],
            [16.267892483114242, -4.922535394063776],
            [16.267965284381482, -4.923181368913995],
            [16.267500576003567, -4.923469416683147],
            [16.267788380949241, -4.924258562876849],
            [16.268147899302335, -4.925119363531152],
            [16.268078022051348, -4.926016876378939],
            [16.267434504914416, -4.926377055697159],
            [16.267471722116628, -4.927130784353218],
            [16.267937860612488, -4.927596533885985],
            [16.268582672221772, -4.927918360236402],
            [16.267940140536687, -4.928799019111477],
            [16.267548368173312, -4.929804832768499],
            [16.267550749607118, -4.931061160878037],
            [16.267553132837552, -4.932317488381245],
            [16.267519454099236, -4.933430304480503],
            [16.266625746274229, -4.933970438434587],
            [16.266305345060143, -4.934868430193974],
            [16.266736313614341, -4.935657303186808],
            [16.266093127057442, -4.936196958690598],
            [16.266488375900988, -4.937021794984146],
            [16.266382505851464, -4.937811691585236],
            [16.265810760512498, -4.938279421060009],
            [16.26516750298866, -4.938783180775764],
            [16.265418914487224, -4.939249339171685],
            [16.266170765752484, -4.939391485531145],
            [16.266171651491355, -4.939858121906421],
            [16.265742722112869, -4.940146102881431],
            [16.265744526828271, -4.941097323225343],
            [16.265029687949355, -4.941601220420486],
            [16.264565647917983, -4.942248219788205],
            [16.264567077137595, -4.943002017571533],
            [16.263887208774388, -4.943075104446013],
            [16.263960353198083, -4.943900556432558],
            [16.264141071775363, -4.94483348815914],
            [16.26384025383447, -4.94534682181199],
            [16.263987548794979, -4.945823710435889],
            [16.264287840323103, -4.946735656149386],
            [16.265040859398226, -4.947488018941234],
            [16.265364673312082, -4.948384780358348],
            [16.264972211042537, -4.949031645074549],
            [16.26429240466306, -4.949140628838847],
            [16.264544366828908, -4.949893948373782],
            [16.264939625553922, -4.950718783602734],
            [16.264368483882805, -4.951509570006654],
            [16.263725556040704, -4.952192807426795],
            [16.264299562439263, -4.9529096161427],
            [16.264836962490005, -4.953195750729677],
            [16.264552550481135, -4.954201361092348],
            [16.265162146334635, -4.954810414591826],
            [16.26476947565596, -4.955349593895984],
            [16.264591889504061, -4.956067837949361],
            [16.264986881429433, -4.956749092125916],
            [16.265632475471321, -4.957465760693236],
            [16.266064353120548, -4.958721266234859],
            [16.265493140482526, -4.959476159456319],
            [16.26545871704085, -4.960194129582452],
            [16.265316648478656, -4.960768725662995],
            [16.264885930554449, -4.96012343661441],
            [16.264457194313739, -4.960519104875865],
            [16.264207411460781, -4.960914430541125],
            [16.262883838212744, -4.961275915008065],
            [16.263028093274308, -4.961849963266727],
            [16.263208139013464, -4.962423942548395],
            [16.263209163092888, -4.962962369580382],
            [16.263746707772359, -4.963320293323495],
            [16.263424863863971, -4.963464490369859],
            [16.262924133941446, -4.963644924702614],
            [16.262675099385099, -4.96443509630623],
            [16.262569024519738, -4.965117309332582],
            [16.261745627831985, -4.965011197703943],
            [16.261172428120553, -4.964725131369914],
            [16.260600454609488, -4.96508517673681],
            [16.260637677201583, -4.965838906688689],
            [16.260137489861506, -4.966306500757249],
            [16.259780669149198, -4.966881506771395],
            [16.259459163007314, -4.967205177787015],
            [16.260140352792323, -4.967814097503228],
            [16.259926696586835, -4.968388830105188],
            [16.259319133620831, -4.968856628652957],
            [16.258747087346205, -4.969180778878884],
            [16.258032148754307, -4.969648782267745],
            [16.257638377639388, -4.969613638105175],
            [16.257422609494657, -4.969075620190927],
            [16.257100691924407, -4.969183919503725],
            [16.257029857967609, -4.969578902960486],
            [16.257087765167476, -4.969951673895894],
            [16.24803227997959, -4.970290777105279],
            [16.235389440078247, -4.97016222070701],
            [16.222761719721415, -4.969288005172567],
            [16.205919839771727, -4.968371054831241],
            [16.196788439755835, -4.968278228793182],
            [16.184847960235793, -4.968156855084169],
            [16.169395320381426, -4.967999570414185],
            [16.152537959764459, -4.967828102413055],
            [16.094988000145104, -4.965005783109435],
            [16.083780480319863, -4.963400257447116],
            [16.054280279801514, -4.963100230440617],
            [16.038920160133209, -4.958469820259988],
            [16.035078105188909, -4.960697090377387],
            [16.02754272037873, -4.965065393197878],
            [16.021175040335045, -4.967237749029953],
            [16.006331880451491, -4.971560892484947],
            [15.997401720127202, -4.961776054139195],
            [15.991921800163041, -4.955008975625534],
            [15.980150880347804, -4.946686354927929],
            [15.964729200031371, -4.945038049907656],
            [15.955598160239914, -4.944945219646533],
            [15.944969520173656, -4.949311425141254],
            [15.935074200026662, -4.952193602964396],
            [15.927911280089479, -4.958832152966242],
            [15.916703760264269, -4.957226790473912],
            [15.909958079928776, -4.943735382509506],
            [15.907380119879225, -4.932523183865907],
            [15.904848600034954, -4.919074002575488],
            [15.90370667961208, -4.906384643337362],
            [15.898365720039193, -4.892906375808403],
            [15.888169440017501, -4.876395393271295],
            [15.879239279693246, -4.866609136566711],
            [15.86233944044143, -4.860103981467424],
            [15.857518634164139, -4.859094370826477],
            [15.857328570412957, -4.859740812283825],
            [15.857090953443889, -4.860518948692635],
            [15.857569213806213, -4.861356007149157],
            [15.858381636674459, -4.862288373603223],
            [15.859003243003288, -4.863268847793235],
            [15.860842113254513, -4.864558900715235],
            [15.862847627279129, -4.865547172994519],
            [15.863708131574619, -4.866752308686326],
            [15.864510787959089, -4.867497996760841],
            [15.864569592575881, -4.868704159728148],
            [15.864594629521186, -4.869625559860034],
            [15.865692907092608, -4.870174613427758],
            [15.865311662086015, -4.870581969412874],
            [15.865598843600868, -4.871251731724669],
            [15.865575932069566, -4.871993693372951],
            [15.865481072670498, -4.87244854840564],
            [15.866363815659168, -4.872375611377217],
            [15.866436285448078, -4.873069583278984],
            [15.865459355898501, -4.874123906478244],
            [15.864815429129793, -4.874364067465729],
            [15.865007078407455, -4.874962153393653],
            [15.864911972870019, -4.875225542349534],
            [15.864387041435426, -4.875226217239027],
            [15.864363823578611, -4.875728846607328],
            [15.864077956298976, -4.876088213613104],
            [15.863290496714205, -4.876041358863228],
            [15.862742192912529, -4.876424996447271],
            [15.862504473535525, -4.877119366880376],
            [15.861883945185049, -4.877000496558461],
            [15.86152652439811, -4.877383888501345],
            [15.861216916442185, -4.8778390182605],
            [15.860692378469684, -4.878150823999089],
            [15.860119723137291, -4.87815155745384],
            [15.859880873679675, -4.877960396055049],
            [15.859547189975805, -4.878248022963588],
            [15.858927208699328, -4.878559949250301],
            [15.858425769107729, -4.878273391122382],
            [15.858019409002418, -4.877699510403685],
            [15.857709312362974, -4.87777170618281],
            [15.857685967843702, -4.878178602470386],
            [15.8578297997988, -4.878704952425615],
            [15.857711135044683, -4.879207703500003],
            [15.857257022295535, -4.878609950286711],
            [15.856588104395607, -4.877964603959947],
            [15.856277643040174, -4.877749598906888],
            [15.855919703027016, -4.877726122033346],
            [15.855394253264496, -4.877319924683552],
            [15.854869137675266, -4.877176992722239],
            [15.854487549512248, -4.877321078029063],
            [15.854034831846723, -4.877824254548377],
            [15.85339041280124, -4.877681473171316],
            [15.853103963413353, -4.877586104157961],
            [15.852841888912341, -4.877897570319554],
            [15.852747171447117, -4.878472091512958],
            [15.852605003171943, -4.879262072770795],
            [15.852175903113544, -4.879573751692846],
            [15.851746379050313, -4.879550363186639],
            [15.851174264503737, -4.879981889418151],
            [15.85043518368858, -4.880461493430813],
            [15.850196725896398, -4.880581462408755],
            [15.849790611031194, -4.880199041843314],
            [15.849503769977805, -4.879792537851535],
            [15.849002663661198, -4.879769237655732],
            [15.84850173790594, -4.87988953834465],
            [15.848215138499372, -4.879674499676525],
            [15.847905218828055, -4.879890291620503],
            [15.847619970487653, -4.88075225399407],
            [15.847668413037663, -4.881326594304215],
            [15.847454446913408, -4.88194913281051],
            [15.846809903002097, -4.881710611771597],
            [15.846356547532732, -4.881711183935267],
            [15.846046715896296, -4.881998775876202],
            [15.846214282239506, -4.88242936522812],
            [15.845832927638467, -4.882764914012235],
            [15.845117131155444, -4.882789749481159],
            [15.84456832968711, -4.882790439680659],
            [15.844473365185184, -4.883173493984674],
            [15.844616889916441, -4.883460514029066],
            [15.845141830334175, -4.883459853564686],
            [15.845357208610066, -4.883962183846041],
            [15.845119168534495, -4.884417218078458],
            [15.844952620880829, -4.884800362445961],
            [15.845168029699453, -4.885326626042998],
            [15.845025462572268, -4.885805473814766],
            [15.844619406097545, -4.885470917716576],
            [15.844166047034893, -4.885471488074939],
            [15.843832592401451, -4.885950576319388],
            [15.843976446814411, -4.886500863396138],
            [15.844167903852595, -4.886955357061558],
            [15.844287987944822, -4.887577474893849],
            [15.844050156278415, -4.888200042658982],
            [15.843764212642029, -4.888511537164138],
            [15.843430485819033, -4.888775225279443],
            [15.842929103719618, -4.888536521989239],
            [15.842404129165862, -4.888513248231402],
            [15.842285690787246, -4.889207466322796],
            [15.842453466437913, -4.889805591100344],
            [15.843145110816174, -4.889541453779793],
            [15.843693707468638, -4.889373228808394],
            [15.843742058390477, -4.8898757699455],
            [15.843384650179965, -4.890283087682321],
            [15.842550675829756, -4.891217539880409],
            [15.842360444093611, -4.891744314660584],
            [15.84276665418024, -4.892198538916585],
            [15.843530513225902, -4.892436911106824],
            [15.843936964061051, -4.893082601024151],
            [15.844439580445647, -4.894302570694371],
            [15.844560687719005, -4.895738422193564],
            [15.844513715711107, -4.896336816771013],
            [15.843512842465964, -4.897379182344959],
            [15.843155910362547, -4.898169434745032],
            [15.843180161281957, -4.898480538009763],
            [15.843443087385815, -4.898839207875],
            [15.843372403447704, -4.899557299372882],
            [15.843086364589857, -4.89979699430701],
            [15.843468689371425, -4.900227313468098],
            [15.843731916410913, -4.900825316536149],
            [15.844352707069476, -4.901135667098632],
            [15.844878443394569, -4.901757270605258],
            [15.845355825204535, -4.901876333798007],
            [15.845284631023338, -4.902187558753546],
            [15.844497258575116, -4.902236420017576],
            [15.843781410888127, -4.902237324638813],
            [15.843542945011132, -4.902357292366021],
            [15.84404488047276, -4.903026793640966],
            [15.844690046018233, -4.903743980464329],
            [15.844929715637702, -4.904581346468913],
            [15.845026260276256, -4.905454793369317],
            [15.845384878517461, -4.906004807398411],
            [15.845838823281653, -4.906458966873804],
            [15.846006699543626, -4.907128889258196],
            [15.846031224449218, -4.907655392742146],
            [15.846485321927014, -4.908229218602227],
            [15.847153572378666, -4.908324103854551],
            [15.847917150251634, -4.908323134369005],
            [15.848538947023313, -4.909423279713839],
            [15.848945688014291, -4.910284363793476],
            [15.850235136959654, -4.911000722799102],
            [15.851285119304755, -4.911047250706986],
            [15.852263455616052, -4.911046001913804],
            [15.852549827748852, -4.911069568604303],
            [15.85275989787973, -4.911407557164051],
            [15.852824802057318, -4.911511984497123],
            [15.853314107206057, -4.911619058964496],
            [15.853719698353483, -4.911570673225884],
            [15.853911049390478, -4.911929427867573],
            [15.853959535059614, -4.912527699622852],
            [15.853912176776134, -4.912814960080539],
            [15.854484740480355, -4.912718493314664],
            [15.854962603787333, -4.913208514353438],
            [15.854843751285356, -4.913567666344699],
            [15.854820560377954, -4.914094229549733],
            [15.855202808802737, -4.914452739544962],
            [15.855060431220076, -4.915075188231819],
            [15.854703263758053, -4.915673979704912],
            [15.855516281311012, -4.917013202260818],
            [15.856113780450864, -4.917754367366558],
            [15.856019035137864, -4.918304955859933],
            [15.856639403588222, -4.918268258323934],
            [15.85695013084503, -4.918674725091595],
            [15.856687984478821, -4.918938329059397],
            [15.855995891841209, -4.918867418097777],
            [15.855399338627331, -4.918868184844056],
            [15.854970431706704, -4.91934740198752],
            [15.854994629625519, -4.919610637179052],
            [15.855519260124487, -4.919346697410373],
            [15.855901145629877, -4.919418006559463],
            [15.855902216421681, -4.920255670666227],
            [15.855521093585995, -4.92078269342485],
            [15.854996431645963, -4.921022700481121],
            [15.854877853130169, -4.921597252588118],
            [15.855546606638361, -4.922075060393973],
            [15.855762039711506, -4.922601315851475],
            [15.855380947418521, -4.923152272390051],
            [15.855405879260898, -4.92398990650542],
            [15.855358827302961, -4.924516499198827],
            [15.854737827336939, -4.92406256482924],
            [15.854212123351209, -4.923488839283879],
            [15.85387747126347, -4.923034535699196],
            [15.85342430174534, -4.923202650262536],
            [15.853400958124366, -4.923609547351446],
            [15.853854860667759, -4.924015831516694],
            [15.854308915924763, -4.924541781785814],
            [15.854309497134752, -4.924996514097514],
            [15.854047255547115, -4.925188316876492],
            [15.853736495052644, -4.924757915834733],
            [15.853521246134171, -4.924375258708273],
            [15.853199333055469, -4.924555172249333],
            [15.852829634993569, -4.924687279401483],
            [15.852436119898522, -4.924855316957666],
            [15.853188759884567, -4.925620218677238],
            [15.85392898156017, -4.926002202042095],
            [15.85407264463198, -4.926384951021066],
            [15.85388238684469, -4.926887794572371],
            [15.853692251228303, -4.927486371652465],
            [15.853430008742334, -4.927678175505427],
            [15.85307140128093, -4.927152102513956],
            [15.852617954183364, -4.927104817118807],
            [15.852547068124306, -4.92765537434476],
            [15.85252392213269, -4.928217837580587],
            [15.852214106665937, -4.928529368114278],
            [15.852214473178586, -4.928816567514398],
            [15.852548853076769, -4.929055471535223],
            [15.853264330657856, -4.928743420484484],
            [15.853741549872781, -4.928718875061868],
            [15.854242967006483, -4.92895756378386],
            [15.854864064888856, -4.929483298360458],
            [15.854936539169348, -4.93017727142837],
            [15.854865962130759, -4.930967161868077],
            [15.855224726797353, -4.931612899566292],
            [15.855010820860205, -4.932283307153996],
            [15.855059434090132, -4.932977310593049],
            [15.855633179078936, -4.933790304936607],
            [15.855634466364743, -4.934795501874979],
            [15.855706821169289, -4.935393741076099],
            [15.855588182466358, -4.935920426418541],
            [15.85635258678939, -4.936541706904051],
            [15.856925692177693, -4.936852100060027],
            [15.857021910727806, -4.937450308550906],
            [15.856497083497773, -4.937570652758909],
            [15.855852880946289, -4.937643283449116],
            [15.855710102715019, -4.937954600476091],
            [15.856283239544391, -4.938288927170871],
            [15.85671326127428, -4.938671304981745],
            [15.856785617875454, -4.939269544244604],
            [15.857430559740417, -4.939771310261858],
            [15.857932756611804, -4.940608325794048],
            [15.857766640149476, -4.941326539209511],
            [15.858936692213783, -4.941923357027752],
            [15.860249646476865, -4.942304587591192],
            [15.860966491293798, -4.94304558805674],
            [15.862089101531302, -4.943857859935622],
            [15.862400465693618, -4.94474298594668],
            [15.862807065649086, -4.945460454232721],
            [15.863451894326346, -4.945866478880953],
            [15.864191957898425, -4.946104846915924],
            [15.864907507344746, -4.945840647533338],
            [15.864955948098132, -4.946391048452979],
            [15.865076040275198, -4.946989222991157],
            [15.866103053596818, -4.947681944988151],
            [15.865865698037503, -4.948663517398059],
            [15.865652190054035, -4.949633093056233],
            [15.86496093554458, -4.950232326846545],
            [15.865224768048579, -4.951261111504086],
            [15.865417540220346, -4.952696853729522],
            [15.864774538716381, -4.953702890107938],
            [15.864107609686531, -4.9546610910544],
            [15.863416162937598, -4.955116725899456],
            [15.863202448341632, -4.955930735096525],
            [15.862749944475116, -4.956625390034688],
            [15.862750690076808, -4.957199786549827],
            [15.86244077579537, -4.957439523480113],
            [15.861652909273749, -4.957153352014542],
            [15.86115177690599, -4.957154005197271],
            [15.860699084393286, -4.95770505966842],
            [15.860030567141997, -4.957442663260669],
            [15.859600745736426, -4.957227822953001],
            [15.859314941338891, -4.957658993653994],
            [15.858624259954585, -4.958712955067271],
            [15.858577429880498, -4.959407080892388],
            [15.858865215063236, -4.960507636847646],
            [15.858985801313743, -4.961488743993446],
            [15.858986606204207, -4.962111008299134],
            [15.858462688967604, -4.962949353791039],
            [15.857866591199556, -4.963333061348798],
            [15.857413150390236, -4.963309716367605],
            [15.857246599143279, -4.963692865134692],
            [15.85748582319839, -4.964147287316433],
            [15.857032597984739, -4.964291475170319],
            [15.856483731837715, -4.964292187807412],
            [15.856197799879389, -4.964627624473157],
            [15.856484534931585, -4.964914451235763],
            [15.856914020367244, -4.96486602799462],
            [15.857463134449265, -4.965056780299463],
            [15.857177201592643, -4.965392218373037],
            [15.856318877508343, -4.965991663809366],
            [15.855651123825053, -4.966327596011102],
            [15.855627815238366, -4.966758425542379],
            [15.856010315191403, -4.967284462133827],
            [15.856726632697278, -4.967594664086166],
            [15.857513953941529, -4.967450041816179],
            [15.858015171649244, -4.967509223740235],
            [15.857514417472197, -4.967809040600032],
            [15.857299921341923, -4.968024718882347],
            [15.857133431180436, -4.968455733781439],
            [15.856655875097301, -4.968240954766597],
            [15.856131055053783, -4.96838523631063],
            [15.855678227793813, -4.968840556141094],
            [15.855583204901373, -4.969175745410384],
            [15.855894361552828, -4.969893339963707],
            [15.855847838702582, -4.970826798470091],
            [15.855442459557603, -4.971066657412231],
            [15.855013216667063, -4.9713065468972],
            [15.855061407688787, -4.971665483190302],
            [15.855395503719388, -4.971665049847004],
            [15.855705396441261, -4.971401381559061],
            [15.856039491573499, -4.971400948215572],
            [15.856206880050284, -4.971663996669588],
            [15.85630323244936, -4.972357936606006],
            [15.856447143456203, -4.972920181144334],
            [15.856710080339859, -4.973254905237527],
            [15.857139757116663, -4.97335008016261],
            [15.857307393528446, -4.973804593797154],
            [15.85694977331552, -4.97406832507522],
            [15.856974008963579, -4.974355492725402],
            [15.857356360694595, -4.974761860634884],
            [15.857261616279891, -4.97531244883603],
            [15.856807733499434, -4.974954040693052],
            [15.856473358092799, -4.974739076434563],
            [15.85611567499781, -4.974954940709228],
            [15.856092335868421, -4.975361836180788],
            [15.856546094681347, -4.975624512754772],
            [15.857071198592484, -4.975695629270603],
            [15.857286533749246, -4.976126148083861],
            [15.856952838367283, -4.976437714306531],
            [15.856642325807849, -4.976222719007024],
            [15.856069368641563, -4.976055931629802],
            [15.855950357137768, -4.976295418365419],
            [15.856213513210349, -4.976797675708272],
            [15.85614266308391, -4.97737216612799],
            [15.855928287327878, -4.97768357769657],
            [15.856334443515578, -4.978042048297844],
            [15.856549685247543, -4.978400767352968],
            [15.856311353219521, -4.978640409982404],
            [15.855571375885694, -4.978497772177464],
            [15.855141355054137, -4.978139332458881],
            [15.85509415217922, -4.978546259268751],
            [15.855476505706864, -4.978952628159307],
            [15.855429210305481, -4.979287755454203],
            [15.854736961361006, -4.979145054727727],
            [15.854164774050901, -4.979576597390836],
            [15.85373558775421, -4.979864353602065],
            [15.85366436482694, -4.980151644816147],
            [15.85464329582295, -4.980533307064912],
            [15.854786961589717, -4.980904086110587],
            [15.854500805950913, -4.981071991170562],
            [15.854071031257725, -4.980905015848499],
            [15.853569880025331, -4.980905666304666],
            [15.853355563558107, -4.981264943240964],
            [15.853761752085205, -4.981647348984652],
            [15.854286767961426, -4.981646667898331],
            [15.854382719711863, -4.982029475221665],
            [15.854096841652463, -4.982412779619565],
            [15.853834333265187, -4.982413120162305],
            [15.853428113297092, -4.98200678136715],
            [15.853093919350139, -4.981935415090515],
            [15.852903343559243, -4.982198928649536],
            [15.853166253493455, -4.982509719879895],
            [15.852999819925818, -4.982988602012748],
            [15.852690137409734, -4.983419802477816],
            [15.852427381985757, -4.983228677184097],
            [15.852569982350564, -4.982773759334804],
            [15.852092725406431, -4.982798310831058],
            [15.851926321483198, -4.983301126206834],
            [15.852261102030022, -4.983827225077004],
            [15.852380794456785, -4.984114269489966],
            [15.852118562750617, -4.984330008123294],
            [15.851450203602816, -4.984211207694119],
            [15.850806385530291, -4.984618907274315],
            [15.850425108184336, -4.985050200349146],
            [15.850402012498396, -4.985648562776327],
            [15.850855346408196, -4.985576176178133],
            [15.850974145909573, -4.985169156480761],
            [15.851284106903424, -4.984953355063449],
            [15.8515712821301, -4.985575249149633],
            [15.851452946159391, -4.986341267940707],
            [15.850857225683788, -4.987036104795707],
            [15.850022611733078, -4.987539784450719],
            [15.84935526408831, -4.988210779539249],
            [15.84954685767042, -4.988737064513609],
            [15.850048077174762, -4.988784283275946],
            [15.850596162685811, -4.988161307587322],
            [15.850930607262718, -4.988424141139923],
            [15.850620952594376, -4.988879274842432],
            [15.851122295167922, -4.989022224776945],
            [15.851528332778042, -4.989284965187765],
            [15.851409688685193, -4.989811651089171],
            [15.85112389776241, -4.990266754087127],
            [15.851148194495872, -4.990601789047392],
            [15.851434880140729, -4.990840750594667],
            [15.851529567063253, -4.990242295666103],
            [15.851911432805672, -4.990265733372183],
            [15.852150666742251, -4.990720155875135],
            [15.852222878714691, -4.991198727438248],
            [15.852796002967638, -4.991485183004233],
            [15.853488172860368, -4.991556083367862],
            [15.853775168423955, -4.992034375936993],
            [15.853059256956605, -4.992059239692333],
            [15.852701130992179, -4.991940038882008],
            [15.852462854659672, -4.992227547264021],
            [15.852845308798626, -4.992705715914772],
            [15.853156045936867, -4.99308824463509],
            [15.852822805102472, -4.993758809654437],
            [15.853348572868562, -4.994332524690355],
            [15.853683145006258, -4.994691088784504],
            [15.853230146168043, -4.995026743969088],
            [15.852872266341988, -4.995099009692605],
            [15.852920955030406, -4.995840877921876],
            [15.852993415836144, -4.996510914871031],
            [15.853041610451156, -4.996869851625696],
            [15.853471364483076, -4.997012892586653],
            [15.853280754556188, -4.997252473377824],
            [15.85297060311952, -4.997324676691517],
            [15.852613093399368, -4.997684140913403],
            [15.85227946359443, -4.998055539859694],
            [15.851992697101233, -4.997756746874658],
            [15.851825271793533, -4.997469764364398],
            [15.851777047534119, -4.997086894997094],
            [15.851334896751284, -4.996584869591879],
            [15.850917631098445, -4.996872611041415],
            [15.850918094629113, -4.997231609756478],
            [15.851157083325617, -4.99749456574976],
            [15.851205369568769, -4.997925302509358],
            [15.850967152525103, -4.998260677642082],
            [15.850872186226514, -4.99864373369829],
            [15.851349239253111, -4.998451648051084],
            [15.851635866507454, -4.998642741824832],
            [15.851207408744481, -4.999504896396366],
            [15.851733274426955, -5.000150412043851],
            [15.851853156398271, -5.000581055143899],
            [15.851615092966508, -5.001036097413527],
            [15.851185057761898, -5.000677656655054],
            [15.850730941419458, -5.000151713818407],
            [15.850372687894245, -4.999936779540641],
            [15.850158180085876, -5.000152457046125],
            [15.850492877987698, -5.000606755489518],
            [15.850684477858021, -5.001133039389575],
            [15.850422147337172, -5.001276979386793],
            [15.849968401998968, -5.001038235203713],
            [15.849586591053736, -5.001062663487493],
            [15.84949159331415, -5.001421785998751],
            [15.849853942258733, -5.002140571850942],
            [15.849668483271669, -5.002540467535342],
            [15.849323445760952, -5.002807351000047],
            [15.848792020405174, -5.002754752314518],
            [15.848366969952057, -5.00278194713094],
            [15.848207906163005, -5.003048589961468],
            [15.848394463789653, -5.003501290013645],
            [15.848209141346549, -5.004007759476064],
            [15.848847525509932, -5.004593093020564],
            [15.848502520338545, -5.004886620830789],
            [15.848130261179753, -5.004647310430149],
            [15.847545698678299, -5.004594779460194],
            [15.847068059051836, -5.005048339665218],
            [15.847520501832879, -5.005660558862511],
            [15.847521359723974, -5.006326649713248],
            [15.846803887882963, -5.006221003375332],
            [15.846272836226346, -5.006461482526131],
            [15.845821180369491, -5.006462066291982],
            [15.845423311140246, -5.006968810900547],
            [15.845769105930781, -5.007288088159081],
            [15.846061936052154, -5.00774065190958],
            [15.845716757505926, -5.007900960165425],
            [15.84505207695921, -5.007528807445015],
            [15.844414102427567, -5.00726319345903],
            [15.8440955939638, -5.007503397455592],
            [15.844389175076746, -5.008542123423567],
            [15.844123699554089, -5.008702327880241],
            [15.843804643117991, -5.008516233310127],
            [15.843405575536188, -5.008090448493971],
            [15.842874317267038, -5.008171063829331],
            [15.842874896680398, -5.008624006226888],
            [15.843220725606924, -5.008969928592506],
            [15.843460368276947, -5.009382597074061],
            [15.842769614129111, -5.009396809185982],
            [15.842145485330965, -5.009570796724926],
            [15.842690660300484, -5.009983072043472],
            [15.842558400442893, -5.010436185234538],
            [15.841815309548263, -5.011076591046432],
            [15.841868787155473, -5.011342959289243],
            [15.842321163461165, -5.011901894420261],
            [15.842268709035116, -5.012434836412028],
            [15.842455369967995, -5.012967469867689],
            [15.842907235132309, -5.013126748938634],
            [15.843597411663414, -5.012659594060237],
            [15.84396837545159, -5.011886449078427],
            [15.844260660295589, -5.011912715618426],
            [15.844261173233598, -5.012312370121887],
            [15.843983096144129, -5.013005464713624],
            [15.843891606325705, -5.013061231803289],
            [15.843545061441928, -5.013272467268461],
            [15.843731312743065, -5.013485375567856],
            [15.844502203800737, -5.013804104578378],
            [15.844582285015054, -5.014097081373879],
            [15.844370046351084, -5.014337149497462],
            [15.843758736512056, -5.014151433114077],
            [15.843094801567029, -5.014365439274144],
            [15.842563230684153, -5.014206262306791],
            [15.842005432588255, -5.014313555914661],
            [15.842218764501959, -5.014926086123676],
            [15.842511528147977, -5.015325364000546],
            [15.84283062231332, -5.015538102259892],
            [15.842432369503449, -5.015751765632536],
            [15.841901342999682, -5.016018886863868],
            [15.84174237712698, -5.01636545928554],
            [15.841928901515971, -5.016791518803621],
            [15.841636819691217, -5.016925113450192],
            [15.841158280851156, -5.016685936339563],
            [15.840520775240101, -5.016793331331571],
            [15.84012228258007, -5.01682048772006],
            [15.839311280846632, -5.016301977521113],
            [15.838979464740229, -5.016528875162843],
            [15.838288414148352, -5.016316612884433],
            [15.837863760750617, -5.016663525670645],
            [15.83677513288198, -5.017197796093859],
            [15.836244237532226, -5.017571488203713],
            [15.835446911750664, -5.017359358695014],
            [15.835234905750344, -5.017785929242701],
            [15.835448030153186, -5.018238600032274],
            [15.83534260297313, -5.018904828330962],
            [15.835422851274073, -5.019331025801608],
            [15.835263982419461, -5.019757529280697],
            [15.83457282582639, -5.019465331596835],
            [15.83409425285034, -5.019199505423401],
            [15.833855643242881, -5.019599466201632],
            [15.834414159092693, -5.020051697000191],
            [15.834282095067838, -5.020664671277678],
            [15.834654462922778, -5.020983921031881],
            [15.834575298888367, -5.021410321619441],
            [15.834229939780759, -5.021437406645838],
            [15.834071137401464, -5.021917197709732],
            [15.834071577575942, -5.022263565165685],
            [15.834205098668189, -5.022796269767491],
            [15.834206046390827, -5.023542293293276],
            [15.833488859315761, -5.023676428849975],
            [15.833117235265885, -5.023943340498568],
            [15.833250653950197, -5.024396114158195],
            [15.833330766605544, -5.024715736813466],
            [15.833171624663047, -5.024929089950773],
            [15.832268250965573, -5.024903599571392],
            [15.831767291074355, -5.025206305868899],
            [15.830826825040463, -5.025395373816485],
            [15.830794439876168, -5.025401884236109],
            [15.821928917828165, -5.024396977170768],
            [15.820922159719569, -5.0242828613172],
            [15.815860020142885, -5.020617880049484],
            [15.815843895383551, -5.020617932298999],
            [15.813335160408126, -5.020625958903328],
            [15.804857159895567, -5.024793988946675],
            [15.799048164584951, -5.022179763480825],
            [15.792673319578547, -5.019310877272373],
            [15.783547320234103, -5.023265990119575],
            [15.783418134411416, -5.023321788751233],
            [15.783047280217753, -5.023481967912244],
            [15.780602541223148, -5.023489978265541],
            [15.779376359724932, -5.023493996054081],
            [15.777291769700819, -5.022804694520563],
            [15.764899319913539, -5.018706925581822],
            [15.754350240038745, -5.018192920285108],
            [15.747951240232657, -4.998014248696455],
            [15.744640319589976, -4.988286903671281],
            [15.744825720186528, -4.979340791186151],
            [15.743621879789421, -4.969634531444734],
            [15.734645280158221, -4.962086315475518],
            [15.717895920394621, -4.956696038335033],
            [15.69913199967314, -4.946810965264802],
            [15.685454519753389, -4.937249123063661],
            [15.686002079750001, -4.934426492240765],
            [15.686549999971014, -4.931603848351909],
            [15.685725239640698, -4.929425808634606],
            [15.684900480208643, -4.927247760780439],
            [15.682670279565183, -4.925887958980639],
            [15.680440440044416, -4.924527974165159],
            [15.678210240299252, -4.923167986531338],
            [15.668860319700586, -4.915927901845734],
            [15.659119439713884, -4.911354258231102],
            [15.646537355570132, -4.906584481358775],
            [15.638904720045611, -4.903690987256271],
            [15.624385920251584, -4.892356716676528],
            [15.616250999820798, -4.878104027062269],
            [15.613781399950723, -4.861671150094415],
            [15.620018400273414, -4.831901487730353],
            [15.624510839974988, -4.818521740668234],
            [15.635918879941327, -4.810433206308144],
            [15.647921639660035, -4.807571961491967],
            [15.668037409899723, -4.81031897670004],
            [15.683758920010209, -4.807190689493178],
            [15.698787479591985, -4.793917667844933],
            [15.709694040440855, -4.776126927110934],
            [15.712766279610843, -4.763477775757062],
            [15.71484636009226, -4.742070900611349],
            [15.715614960445999, -4.727701507560669],
            [15.720184799890754, -4.710590501997725],
            [15.726097440123953, -4.696476946497945],
            [15.737690879788483, -4.679436834224505],
            [15.745772520241456, -4.662360555477688],
            [15.750998279862298, -4.647492812750595],
            [15.743627639787045, -4.630258565185605],
            [15.732621000327338, -4.61895547676504],
            [15.717260879760703, -4.614322524756406],
            [15.698419920418772, -4.608162214906126],
            [15.678328679576195, -4.594527853056781],
            [15.67150560039585, -4.584759117283917],
            [15.670289662386837, -4.571669872377835],
            [15.669654736737279, -4.571731152303363],
            [15.669080594693089, -4.572126146679846],
            [15.669081129190696, -4.572702661839301],
            [15.668748828892358, -4.573036744559801],
            [15.668053342419611, -4.573007050728259],
            [15.667720254298786, -4.572491531719049],
            [15.667719720699509, -4.571915016387437],
            [15.66814248044863, -4.57130776370031],
            [15.668565351588857, -4.570821882388051],
            [15.668594801957132, -4.569972252534629],
            [15.668321935994625, -4.569183590804351],
            [15.6674447499843, -4.568850635789843],
            [15.666960955999819, -4.568851086518549],
            [15.665993590813077, -4.569094729677563],
            [15.664906031939623, -4.570157742400626],
            [15.664332251018198, -4.570947191817713],
            [15.663848846004262, -4.571372441238085],
            [15.663183904946122, -4.571676486344348],
            [15.662520440718307, -4.5735887070479],
            [15.662491290387328, -4.574772109765774],
            [15.662492294703815, -4.57586445519927],
            [15.661857781380991, -4.576380872294404],
            [15.660920279787522, -4.576230024004027],
            [15.659800325868304, -4.574956652751865],
            [15.658650582017644, -4.574168794364842],
            [15.656291841440138, -4.573928216084244],
            [15.655416031648835, -4.575112395283018],
            [15.654359014596729, -4.576539483819311],
            [15.654390079237558, -4.577449746082873],
            [15.655782803897857, -4.579420764970897],
            [15.652096762962225, -4.582686009938068],
            [15.652945018728827, -4.584445130447843],
            [15.651283418422524, -4.586085169667348],
            [15.650112228192725, -4.59339310821513],
            [15.649305631797452, -4.596355651302063],
            [15.647165309394749, -4.604216762064182],
            [15.634610279812414, -4.602290180209735],
            [15.626166119734981, -4.602950375982152],
            [15.605094600423445, -4.602735880030226],
            [15.595963200407517, -4.602643002825528],
            [15.592739428923815, -4.603559722427827],
            [15.582480479732981, -4.606476976421346],
            [15.576158867991978, -4.605073234707088],
            [15.571231199925137, -4.603979021776013],
            [15.553568160092764, -4.604259985677676],
            [15.553078996877833, -4.603787551825188],
            [15.552590099564242, -4.604028899630609],
            [15.550567399869921, -4.604296900305513],
            [15.549355100037818, -4.60296760019668],
            [15.548567099667192, -4.60133629988535],
            [15.546385000213911, -4.600550900310752],
            [15.54426350021139, -4.597046600132533],
            [15.542748099819267, -4.595777799738974],
            [15.540148743696284, -4.595086791971045],
            [15.538665562280125, -4.594506052102625],
            [15.535271206113865, -4.593095446454339],
            [15.534746999619697, -4.592877599597134],
            [15.532097311789672, -4.590744332202153],
            [15.531595099646934, -4.5903400004185],
            [15.529837299655163, -4.589312899560285],
            [15.526927800180349, -4.587983599978394],
            [15.524927499977618, -4.587741899615712],
            [15.523230300334944, -4.588406599977675],
            [15.521593700142999, -4.589856600325699],
            [15.519635999847658, -4.592260100397554],
            [15.519084300414253, -4.59317830015821],
            [15.51712750023084, -4.594607899556108],
            [15.516424599962045, -4.597126400257226],
            [15.515600899643738, -4.597999800298237],
            [15.516005299625082, -4.598699700409108],
            [15.515900800404729, -4.599442700238718],
            [15.515382300009257, -4.600735200374575],
            [15.514786999945198, -4.601252399697312],
            [15.514297300436066, -4.60132009963923],
            [15.513366299950324, -4.601048800447884],
            [15.512833800209449, -4.60165329982943],
            [15.5123787999248, -4.601959399719624],
            [15.512358100045684, -4.602136000429901],
            [15.511314599943672, -4.602574900078954],
            [15.510663100377132, -4.603098599943555],
            [15.509918001747854, -4.603466064708305],
            [15.50961869387498, -4.603694622477598],
            [15.509361671499146, -4.603934755210918],
            [15.509343000015976, -4.603952200247389],
            [15.509272200195172, -4.603925699620601],
            [15.508920700204269, -4.603719699782325],
            [15.50877010034184, -4.603731400120421],
            [15.508362600274447, -4.604043399750446],
            [15.507922600058398, -4.603769700247444],
            [15.507752116885445, -4.603577755194863],
            [15.507683499970788, -4.603500499590503],
            [15.507559400409233, -4.60355779971386],
            [15.50737330002511, -4.603369399861708],
            [15.506375199879205, -4.603054400027556],
            [15.505651700342636, -4.603198600057344],
            [15.505104399959153, -4.602805699954837],
            [15.504747999658385, -4.602745299807184],
            [15.50465501414503, -4.602750884067249],
            [15.504110200298246, -4.602783599987996],
            [15.504027499596559, -4.602568700151528],
            [15.503652399964846, -4.602465700040933],
            [15.503280400419181, -4.602130099768333],
            [15.503182899973181, -4.601894699748952],
            [15.503109099779337, -4.601909400027036],
            [15.502958499916872, -4.602300899832561],
            [15.501793899728046, -4.602879300402376],
            [15.501563600435265, -4.603091899736226],
            [15.501235799798222, -4.603121400298881],
            [15.500954900202139, -4.603197500332881],
            [15.500863699641217, -4.603112799911916],
            [15.500624000377343, -4.60308269990886],
            [15.500350099555643, -4.603172100303491],
            [15.500285700231224, -4.603304399850268],
            [15.500042399621353, -4.603405499658814],
            [15.500125700397666, -4.603641799683341],
            [15.499793300386349, -4.603678199636949],
            [15.499461000088012, -4.603800100391505],
            [15.499227999561196, -4.604068499577991],
            [15.498985699674558, -4.604086499881131],
            [15.49888458440787, -4.604073515937779],
            [15.498709586302308, -4.604046732272042],
            [15.498501300225566, -4.603993500262989],
            [15.498395584686312, -4.603974292966167],
            [15.49829600014888, -4.603956199814633],
            [15.498149500197368, -4.604036600396766],
            [15.497996023031101, -4.604219024608699],
            [15.497834799692097, -4.604440000357615],
            [15.49754350029998, -4.604535699644856],
            [15.497271600026417, -4.604279899673763],
            [15.497023799755286, -4.604404900279504],
            [15.4968068000203, -4.60440689961115],
            [15.496606899716767, -4.604325100080004],
            [15.496441299785701, -4.604321099613375],
            [15.496410639386735, -4.604336142377226],
            [15.495007499659055, -4.605032900166304],
            [15.494453300214195, -4.605193600116668],
            [15.493961000082301, -4.605269299699674],
            [15.493900800381844, -4.605039999680239],
            [15.493684300110145, -4.605115900294478],
            [15.49348629974344, -4.605099600078919],
            [15.493268900258146, -4.604944200405098],
            [15.493099884034084, -4.604956669626602],
            [15.493043096135073, -4.60497913639941],
            [15.4924306139946, -4.605468470898282],
            [15.49208211168181, -4.605746902142585],
            [15.491743100069993, -4.605996599935638],
            [15.491639599776212, -4.60604699956313],
            [15.491537499955973, -4.606061899867253],
            [15.491457300164042, -4.606200000341826],
            [15.491309300026012, -4.60627670038085],
            [15.491068800363223, -4.606313300310715],
            [15.491065499952853, -4.606429800264499],
            [15.491159399951185, -4.606509500168285],
            [15.491203200007831, -4.606682999788526],
            [15.490978700238545, -4.606929399895555],
            [15.490661700046138, -4.606911699834385],
            [15.489321100130184, -4.607150700199592],
            [15.485920700098687, -4.608141399613054],
            [15.484246700346516, -4.608402100026801],
            [15.482677199814693, -4.608297800041994],
            [15.481003200062522, -4.60808930008202],
            [15.479538399973739, -4.607724200327098],
            [15.478282800446607, -4.607567799770299],
            [15.476713399627799, -4.607880700003834],
            [15.475457899813646, -4.607098499637248],
            [15.474202300286549, -4.605117000015889],
            [15.4729467995741, -4.604074100052969],
            [15.471482000383613, -4.603761199925232],
            [15.469807900020099, -4.60334399983854],
            [15.468678399704363, -4.602997500090825],
            [15.468493200330458, -4.602448199981273],
            [15.467846300138159, -4.601983700066558],
            [15.467288800282931, -4.601084300021079],
            [15.466360800170257, -4.600001900263112],
            [15.466496099926758, -4.599110699690057],
            [15.466338099743041, -4.598790500363914],
            [15.466308099605804, -4.598286499620776],
            [15.466125199919006, -4.598041499992861],
            [15.466140100274629, -4.597545000336102],
            [15.466037299768455, -4.597190799592174],
            [15.465699700308271, -4.596760299634288],
            [15.46530889992202, -4.596617199821046],
            [15.464994999815666, -4.595313600097679],
            [15.464509499930463, -4.59400979964509],
            [15.464126699940127, -4.593546100030069],
            [15.464314499936794, -4.592834999972515],
            [15.464346700048154, -4.59209709975132],
            [15.464915300385314, -4.591680000013571],
            [15.464933599067656, -4.591440940302076],
            [15.46496360010322, -4.591048999962222],
            [15.464359200105331, -4.59104699969118],
            [15.463960700258758, -4.59021390027208],
            [15.462976099994968, -4.58908819975157],
            [15.462127100423336, -4.587538400121735],
            [15.461964899717323, -4.58687420013835],
            [15.461234999684336, -4.58647280030421],
            [15.460636107257452, -4.585940162049716],
            [15.460594858416233, -4.585912781844703],
            [15.460006900283016, -4.58568979999012],
            [15.459566999779945, -4.585569499752522],
            [15.459263900118257, -4.585695100433235],
            [15.459104900109605, -4.584872199854158],
            [15.458735500288338, -4.584673799863435],
            [15.458596000009578, -4.585090900143164],
            [15.458006000005692, -4.584724600355278],
            [15.457871799787073, -4.584922500034216],
            [15.457667999896872, -4.585026699820521],
            [15.456513500365078, -4.584575399872763],
            [15.456090899617775, -4.583497399893118],
            [15.455526100052564, -4.583476299916942],
            [15.45525400035298, -4.583262100012217],
            [15.455425699844834, -4.582631199695137],
            [15.454224000133049, -4.582034899709771],
            [15.453617899624355, -4.582339700140445],
            [15.453601800017806, -4.582866399726685],
            [15.452923200075796, -4.582393199712109],
            [15.453212300392085, -4.581966700318189],
            [15.452920499740054, -4.581660599848358],
            [15.452274099909374, -4.58171950000444],
            [15.452193600080109, -4.581256900173588],
            [15.451678600419324, -4.581000200216508],
            [15.451053699968341, -4.580730200287321],
            [15.451150499728403, -4.58013879984114],
            [15.450855200138314, -4.57912330013471],
            [15.450517200029495, -4.578617999861062],
            [15.450509199633576, -4.577896099847137],
            [15.450619200136755, -4.577245399865917],
            [15.450622199611495, -4.57697909984229],
            [15.449885500230147, -4.576130300411771],
            [15.449316899892951, -4.576114199646787],
            [15.448827500421116, -4.57448039963293],
            [15.449204199952362, -4.573445900010736],
            [15.449209599725513, -4.572643799693722],
            [15.449791799657802, -4.572073600068063],
            [15.450503899573402, -4.571013099874067],
            [15.450033099719537, -4.569500799920409],
            [15.448030300403682, -4.567096600347725],
            [15.447834199973805, -4.566475099549034],
            [15.448049200058948, -4.565651400425423],
            [15.447037999781271, -4.565012400073925],
            [15.446686600401714, -4.56528509957457],
            [15.446306799886086, -4.56522090015677],
            [15.445281699976055, -4.563690399890791],
            [15.445582700274926, -4.563320500281183],
            [15.445504999596116, -4.562954400152986],
            [15.445467500322881, -4.562553699790936],
            [15.44490179974745, -4.56213389984348],
            [15.44481199966007, -4.561084399788365],
            [15.444307399795317, -4.560437200071259],
            [15.444090900421948, -4.559751699953324],
            [15.444099700318446, -4.55924230038441],
            [15.443896199567245, -4.559017900219288],
            [15.443306999962308, -4.559191299738466],
            [15.4431175003531, -4.559136100042721],
            [15.441814399710383, -4.557372999686579],
            [15.440986320105058, -4.55569366083143],
            [15.440960600440162, -4.555641499733063],
            [15.440327322300849, -4.554973938841542],
            [15.440059308139196, -4.554691414701707],
            [15.43989120011187, -4.554501600014219],
            [15.439817300205046, -4.554496999783969],
            [15.439678799751155, -4.55440499967997],
            [15.439738800025623, -4.554280799746034],
            [15.439840400382574, -4.554188699550157],
            [15.439831199837437, -4.554059900246744],
            [15.439706500201254, -4.554013899717165],
            [15.439581900278082, -4.55414269993037],
            [15.439457300354908, -4.554105899871862],
            [15.439401900353046, -4.553963299852345],
            [15.439508100084236, -4.553816099569551],
            [15.439461899729181, -4.553659599622442],
            [15.439521900003614, -4.553622800440356],
            [15.439637300279976, -4.553599800161788],
            [15.439738800025623, -4.553539999794586],
            [15.439720399833641, -4.553411200373455],
            [15.439623500360566, -4.553305400316367],
            [15.439489600179277, -4.553296199840333],
            [15.439346500351148, -4.553227199872095],
            [15.439309600254209, -4.553112200210662],
            [15.439272700157305, -4.552974100167728],
            [15.439359499871612, -4.552879299876595],
            [15.439471199987297, -4.552900499927587],
            [15.439512700356806, -4.55301090028491],
            [15.439678799751155, -4.552941900288976],
            [15.439669600104349, -4.552836100161941],
            [15.439517299731044, -4.552716500195337],
            [15.439512700356806, -4.552638299686221],
            [15.439604999557311, -4.552555499827105],
            [15.439604999557311, -4.552398999602193],
            [15.439711200186833, -4.552362200354753],
            [15.43974350001117, -4.552242600308317],
            [15.439725000106211, -4.552081599832633],
            [15.439489600179277, -4.551741100419816],
            [15.439383500161066, -4.551745699766406],
            [15.439318799901052, -4.551833099967485],
            [15.439258799626584, -4.551823900373866],
            [15.439194199977882, -4.551524900444194],
            [15.439295800334834, -4.551414399791629],
            [15.439295800334834, -4.551138400048608],
            [15.439383500161066, -4.551064799618233],
            [15.439454373643731, -4.550919465700116],
            [15.439475800259867, -4.550669100265188],
            [15.439323499886598, -4.550498899822067],
            [15.439397300080476, -4.550439100095264],
            [15.439378800175517, -4.550360900236864],
            [15.439263499612165, -4.550337899852663],
            [15.439207099785365, -4.550262499983224],
            [15.439295800334834, -4.550130799902749],
            [15.439263499612165, -4.549942200094748],
            [15.439300399709072, -4.549873199800693],
            [15.4391757997859, -4.549698299742584],
            [15.439069600054708, -4.549495899933441],
            [15.439088099959665, -4.549311900220808],
            [15.439028099685201, -4.549173800340528],
            [15.438880399584502, -4.54913700002451],
            [15.43875120028709, -4.54901740033665],
            [15.438561900103906, -4.548773599731643],
            [15.438621900378338, -4.548732200028833],
            [15.438691200012626, -4.548566500227336],
            [15.43849270018263, -4.548405499820097],
            [15.438418800275773, -4.54817090044924],
            [15.438534199653807, -4.547977599783951],
            [15.438575799736293, -4.547802800225581],
            [15.438423500261321, -4.547614199799801],
            [15.438506500102008, -4.547549700391714],
            [15.438500800291523, -4.547412699980321],
            [15.43831270025756, -4.547397900306748],
            [15.438169600429431, -4.547315099836941],
            [15.43804959988053, -4.547227699981651],
            [15.438128100059922, -4.547025200305623],
            [15.438146087925169, -4.546944430838687],
            [15.438156733859604, -4.546896627779295],
            [15.438174199803669, -4.546818200356826],
            [15.438081899704867, -4.54680899979675],
            [15.438003500136752, -4.5467215998793],
            [15.43804959988053, -4.546629599669846],
            [15.438081899704867, -4.546555999674061],
            [15.437906500052401, -4.546509999560105],
            [15.437851199763482, -4.546417900159863],
            [15.437957299781697, -4.546413299877236],
            [15.43832650017694, -4.546362700372632],
            [15.438432699908164, -4.546220099700542],
            [15.4383172996318, -4.546155700230954],
            [15.438165000156861, -4.546160299613738],
            [15.438132700332492, -4.546068300233175],
            [15.43807270005806, -4.545957899698709],
            [15.437888099860421, -4.545967100269764],
            [15.437837300131093, -4.546022300087681],
            [15.43774039975972, -4.546040700326539],
            [15.437717299582195, -4.545930199722776],
            [15.43774039975972, -4.545773799906793],
            [15.437772699584089, -4.545644999979507],
            [15.437638900014079, -4.545566799593708],
            [15.437472700008421, -4.545516200028865],
            [15.437343899562988, -4.545622799963089],
            [15.437191200337738, -4.545442599917829],
            [15.437170979260674, -4.545559372242394],
            [15.437149600255255, -4.545718600069589],
            [15.437043500237042, -4.545580599556338],
            [15.436895800136343, -4.545304500187429],
            [15.436895800136343, -4.545111299709498],
            [15.436761899955018, -4.545019300193266],
            [15.436715800211275, -4.544890400064144],
            [15.436531200013667, -4.544701799767432],
            [15.436277300181741, -4.544582200234998],
            [15.436074200079148, -4.544660399827543],
            [15.435940599935156, -4.544782199879021],
            [15.435374517575726, -4.544823845918029],
            [15.434285100087944, -4.544898399867236],
            [15.434093099569015, -4.544956599919355],
            [15.433063199960392, -4.544758799955119],
            [15.432827100245854, -4.544903100224794],
            [15.432612599623992, -4.545071599999082],
            [15.432451599965498, -4.545063600197949],
            [15.43209220018999, -4.544828300169865],
            [15.431818600303918, -4.544716000007589],
            [15.431469900361771, -4.544608999676732],
            [15.431196299577367, -4.544560899870711],
            [15.430993600123411, -4.54465000026036],
            [15.430842299575046, -4.544849699689854],
            [15.430863799853041, -4.54515979973876],
            [15.430662599687272, -4.545376400107833],
            [15.430418499576819, -4.545429899766822],
            [15.43009470542593, -4.545417917199408],
            [15.430056400363897, -4.545416500061591],
            [15.429860599971315, -4.545397799611346],
            [15.429702400361576, -4.545395099657179],
            [15.429640699576268, -4.545437899563845],
            [15.429678199747803, -4.545526100159589],
            [15.429756000139619, -4.545574299965417],
            [15.429756000139619, -4.545638400193994],
            [15.429678462055854, -4.545673532940408],
            [15.429514600364909, -4.545673200291728],
            [15.429367099690197, -4.545774799655597],
            [15.429187399802426, -4.545857700369758],
            [15.429078301207801, -4.545873704461478],
            [15.428916500252095, -4.545871100066707],
            [15.428836000422864, -4.545790800143227],
            [15.428814500144835, -4.545662499642731],
            [15.42877160020015, -4.545582299760773],
            [15.428718000422068, -4.545528800113247],
            [15.428597300085563, -4.545555500355757],
            [15.428433699804341, -4.54553949986281],
            [15.428345199579161, -4.54537110026443],
            [15.428280800254774, -4.545293500239064],
            [15.428151999809341, -4.54523469982389],
            [15.428101100367, -4.54530419999215],
            [15.428157399582492, -4.545403100356055],
            [15.428149400084907, -4.545502099869796],
            [15.428004500032927, -4.545494100073498],
            [15.427830199918375, -4.545400499565501],
            [15.42753240031683, -4.545379100062076],
            [15.427304500424198, -4.545451300170178],
            [15.427151599976334, -4.545424499858716],
            [15.42703619969997, -4.545373700153577],
            [15.426792200200822, -4.54543259972085],
            [15.426679500260233, -4.545520800317255],
            [15.426585600261902, -4.545643800100458],
            [15.426352299697752, -4.545641100147232],
            [15.425998562003516, -4.545556880532335],
            [15.425676400091486, -4.545469999717552],
            [15.425338399982666, -4.545408500264314],
            [15.425091600434767, -4.545250700323721],
            [15.42485829987065, -4.545060900242523],
            [15.424574000151219, -4.544972699589084],
            [15.424387400303774, -4.544834899962936],
            [15.424313800434215, -4.544820300366022],
            [15.423785399706, -4.545004799763783],
            [15.42351719959308, -4.545007399654264],
            [15.423104100326546, -4.544897800377817],
            [15.422675199694135, -4.544661899903806],
            [15.422613300381171, -4.544512800061432],
            [15.422476500438119, -4.544459300333476],
            [15.422326300325993, -4.544459300333476],
            [15.422208300325201, -4.544560899870711],
            [15.422117099764311, -4.544681199862985],
            [15.421972199712366, -4.544772099607606],
            [15.421548399714139, -4.544884399761052],
            [15.421103200049224, -4.545082299755476],
            [15.420733699616648, -4.545389999944022],
            [15.420475600160795, -4.545643800100458],
            [15.420255600052769, -4.545836299978615],
            [15.420153699658519, -4.545919199784118],
            [15.420030299884571, -4.546264100337043],
            [15.419939100221979, -4.546325599716276],
            [15.419797000218752, -4.5464686997904],
            [15.41973790005621, -4.546568899934742],
            [15.41973790005621, -4.546629100246823],
            [15.419703100220421, -4.546665200238311],
            [15.419611899659531, -4.546678499855176],
            [15.419523654555894, -4.546668329294813],
            [15.419242938216149, -4.546640965600695],
            [15.418855500224, -4.546638399972599],
            [15.418665099604571, -4.546616999604954],
            [15.418522899888366, -4.546646399756022],
            [15.418442400059135, -4.546715999851177],
            [15.418404899887568, -4.546812200069967],
            [15.418329799831525, -4.546913800172564],
            [15.418227900335571, -4.546959299936073],
            [15.418053499609679, -4.546991400021104],
            [15.417813732073826, -4.547023357670021],
            [15.41754660005779, -4.547050200291003],
            [15.417162999668539, -4.547181199587053],
            [15.417044999667779, -4.547178499639654],
            [15.416918899558087, -4.547250699565051],
            [15.416790199723961, -4.547317599654234],
            [15.416709699894696, -4.547400400123698],
            [15.416610499836191, -4.547445899856063],
            [15.416502199843851, -4.547426299777568],
            [15.416280599836297, -4.547333600107157],
            [15.416167899895708, -4.547392400348786],
            [15.416058000003838, -4.54741649973806],
            [15.415915800287632, -4.547384399672276],
            [15.415832699835638, -4.547381699725641],
            [15.41576289983977, -4.547453899630428],
            [15.415620799836544, -4.547512699862082],
            [15.415327499896259, -4.547573300353321],
            [15.414875100234342, -4.547699900309673],
            [15.414671300344173, -4.547876400092286],
            [15.414392299786584, -4.548084899802026],
            [15.414117600362598, -4.548322099981172],
            [15.414069633021352, -4.548349509586227],
            [15.413952400181845, -4.548416499720297],
            [15.41381560023879, -4.548416499720297],
            [15.413340899899961, -4.548101000302414],
            [15.413025600218393, -4.548065000448513],
            [15.412809799734301, -4.548119699780058],
            [15.412672999791281, -4.548221299695803],
            [15.412485300405924, -4.548223999639259],
            [15.412340400353944, -4.54825870044729],
            [15.412273400406795, -4.5483736999929],
            [15.41208679966102, -4.548618499578378],
            [15.412053400298769, -4.548710599594998],
            [15.411999799622393, -4.548911100203684],
            [15.411895199790733, -4.549028799584153],
            [15.411851200308098, -4.549129499690433],
            [15.411782499850109, -4.549397699689033],
            [15.411683299791603, -4.549534100232317],
            [15.411584000020117, -4.549638399883891],
            [15.411557199681912, -4.549713300398702],
            [15.411474100128247, -4.549822899834292],
            [15.411323900016091, -4.549953900422258],
            [15.411213900411244, -4.550036799747548],
            [15.411091699888219, -4.550056900076214],
            [15.411034199625178, -4.550047500330708],
            [15.410916199624415, -4.55017849997578],
            [15.41080890035531, -4.550253400433633],
            [15.410733800299232, -4.550290800176668],
            [15.410613099962728, -4.550309499596692],
            [15.410532600133463, -4.550341600431903],
            [15.410419999905852, -4.550427099582664],
            [15.410336799740881, -4.550475299957621],
            [15.410202700133567, -4.550539399744252],
            [15.410113100370507, -4.550573399988768],
            [15.409969299856474, -4.550479299827756],
            [15.409864700024782, -4.550508699819045],
            [15.409794999741891, -4.550583600242065],
            [15.409775793761112, -4.550657566723408],
            [15.409760100193086, -4.550752000408554],
            [15.409695799683382, -4.550810800367318],
            [15.409510700022457, -4.550917799764708],
            [15.409387300248508, -4.550880299990366],
            [15.409338999632306, -4.550802799729317],
            [15.409258600414383, -4.550690499609368],
            [15.409178099686823, -4.550722600427329],
            [15.409127099633208, -4.550816200234509],
            [15.409164700416051, -4.550923099566776],
            [15.409226400303027, -4.551011400447686],
            [15.409381899577024, -4.551112999949934],
            [15.409398000081836, -4.551203899773585],
            [15.409363200246043, -4.551326900376277],
            [15.409247799969716, -4.55142309997089],
            [15.409126699882899, -4.551449599863505],
            [15.409051999577132, -4.551415100241256],
            [15.408987699965724, -4.551308100017278],
            [15.408877700360877, -4.55129209965383],
            [15.408794500195871, -4.551345599769051],
            [15.408710699956272, -4.551381999713665],
            [15.408604099576475, -4.55136160013129],
            [15.408483400138268, -4.55123599966688],
            [15.408405599746448, -4.551214600339188],
            [15.408346600195214, -4.55130280021811],
            [15.408290200368414, -4.551329600307914],
            [15.408047400120161, -4.551316299876635],
            [15.407869000094623, -4.551448900315375],
            [15.407649900098523, -4.551611700287182],
            [15.407724199755686, -4.551774800414245],
            [15.407622300259735, -4.552054200287838],
            [15.407406400062664, -4.552075599590264],
            [15.407108199812509, -4.551933300256951],
            [15.406607799571722, -4.552380400301247],
            [15.406559499853817, -4.552567600367844],
            [15.40638250030182, -4.552669199647505],
            [15.406090099575161, -4.552669199647505],
            [15.405955399893259, -4.552980100402515],
            [15.406901200123281, -4.553778499884369],
            [15.40730900022797, -4.554168300048365],
            [15.407240837860844, -4.554349082938553],
            [15.406925434873012, -4.55445706170687],
            [15.406453276766433, -4.555292982509186],
            [15.405464034907572, -4.557122945732683],
            [15.404654382443676, -4.558139737268787],
            [15.403709614377885, -4.559021093225689],
            [15.403102363127307, -4.559766747273345],
            [15.402900045457315, -4.560195980686891],
            [15.402967803582582, -4.560625061492449],
            [15.403980837321733, -4.561076197337504],
            [15.404948973262989, -4.561730623527802],
            [15.405917529615818, -4.563130360671778],
            [15.406435873704432, -4.564372255189178],
            [15.406143747862252, -4.565185488924804],
            [15.404638356498991, -4.566044016535986],
            [15.404478805823082, -4.5661350072963],
            [15.404028893596193, -4.566519211612058],
            [15.403961652002225, -4.56701612523886],
            [15.404367235963109, -4.567851549850499],
            [15.404795441299468, -4.568890228699129],
            [15.405291345472284, -4.570245061904775],
            [15.405381967518142, -4.571306516989057],
            [15.405269752667818, -4.571871211155055],
            [15.405832798721594, -4.5725484485424],
            [15.406238565938787, -4.573700065128379],
            [15.405968906063549, -4.574445530636086],
            [15.405451710021863, -4.575258891615158],
            [15.405204808964358, -4.576456048529389],
            [15.404710104940765, -4.577246810629965],
            [15.404598078736596, -4.578150283195617],
            [15.404913694625177, -4.579076098706891],
            [15.405814629396666, -4.580250019869591],
            [15.406242781732431, -4.581175770427539],
            [15.406580627330984, -4.581604697880541],
            [15.407390862801497, -4.581581650734897],
            [15.407368687888715, -4.582168879007104],
            [15.406998617924282, -4.582354821799444],
            [15.406791330774148, -4.582458973287359],
            [15.406648671120497, -4.582530653090975],
            [15.406076376012571, -4.582599897196861],
            [15.405523400971422, -4.58266680386259],
            [15.405456351616932, -4.58350249482468],
            [15.405681866482505, -4.58429284879223],
            [15.406447703618408, -4.585353918581689],
            [15.407641126253139, -4.586324402468943],
            [15.407709543741809, -4.587905328549142],
            [15.407709761134106, -4.588289276734221],
            [15.406833550694197, -4.588855216613937],
            [15.406337313246389, -4.589148297289572],
            [15.404671925642859, -4.589397681870482],
            [15.404572693244988, -4.589404850952511],
            [15.40404175118285, -4.589443208649876],
            [15.403817060072415, -4.590120892509264],
            [15.404245027355211, -4.590707865774722],
            [15.404628157925577, -4.591611057876913],
            [15.405371202107794, -4.592152680880123],
            [15.4050791939449, -4.593191766565869],
            [15.404405134088321, -4.595247403152052],
            [15.403955724917976, -4.596557600505701],
            [15.403731084113179, -4.597325625145263],
            [15.40301143116265, -4.598364952883764],
            [15.403011735691534, -4.598906997959786],
            [15.403260016561344, -4.600149044047219],
            [15.403193065123238, -4.601165416656297],
            [15.402678484077335, -4.601443478223418],
            [15.402600065644613, -4.601485852874097],
            [15.402520880050638, -4.601528642173346],
            [15.402339186801271, -4.601626822552697],
            [15.40058988846533, -4.60197115597481],
            [15.400496771797933, -4.60199103127497],
            [15.399952047782692, -4.602107297578031],
            [15.399452312295187, -4.602974574434992],
            [15.398747864229163, -4.603705071655175],
            [15.397543333027626, -4.604686820408405],
            [15.396838767282317, -4.605211974476498],
            [15.396544761266213, -4.608064099440637],
            [15.396795404705223, -4.609022218949493],
            [15.396455063586799, -4.610322903326555],
            [15.39617670891789, -4.610662450534619],
            [15.396136953076681, -4.610710946963416],
            [15.3942954795078, -4.611191101179648],
            [15.393796212940845, -4.611404346103874],
            [15.393386191302469, -4.611579472446554],
            [15.392250165624482, -4.613131568106676],
            [15.391273704097193, -4.615425084717184],
            [15.390887825580371, -4.616634529610931],
            [15.390569997141275, -4.617547332388651],
            [15.391161453314222, -4.618048952232573],
            [15.391912136769621, -4.618664561058296],
            [15.391867074580022, -4.619417503732869],
            [15.391094439892351, -4.620239295690961],
            [15.390185325960186, -4.620969899310494],
            [15.390117424104485, -4.621540328808301],
            [15.389594808526708, -4.6221908642901],
            [15.389367927323617, -4.623103616552966],
            [15.389368188733339, -4.623582746407111],
            [15.389823409105277, -4.624426676924145],
            [15.389823720820669, -4.624997068448024],
            [15.389232658109819, -4.625225550687832],
            [15.388095770947482, -4.625248990306468],
            [15.386936368410861, -4.625683123377948],
            [15.386027194291596, -4.626322459819142],
            [15.385504849106713, -4.627486345338776],
            [15.384982341326756, -4.628353626827629],
            [15.38434708869042, -4.629101313034988],
            [15.382827171569058, -4.629102136896446],
            [15.382406855237511, -4.629264609745062],
            [15.381760464389997, -4.629978836690767],
            [15.381631579502901, -4.630855029711229],
            [15.381308661209419, -4.631731327093031],
            [15.380274287092352, -4.63260800826196],
            [15.379433754142266, -4.633127643894164],
            [15.378237216150131, -4.633128285673154],
            [15.377235089755137, -4.633842699756398],
            [15.377041348301168, -4.634394435978362],
            [15.377786160367872, -4.63630853109753],
            [15.37801313679239, -4.637444125810466],
            [15.37739884993648, -4.637736495716045],
            [15.37639635523224, -4.637769479510257],
            [15.375943607922311, -4.637769720175769],
            [15.375555075782133, -4.636893803546946],
            [15.374972904595953, -4.63676431631654],
            [15.374734273428926, -4.637290811879928],
            [15.374616212342726, -4.637551292309007],
            [15.37452879638411, -4.63762395798739],
            [15.373320148203609, -4.638628654835662],
            [15.373065899825377, -4.638679800246829],
            [15.371481000372979, -4.638096599740487],
            [15.370510500065897, -4.637415700225892],
            [15.369605099769139, -4.637724400245644],
            [15.368570200137636, -4.637627600420034],
            [15.368085199715756, -4.637725199759956],
            [15.36836230033648, -4.638949300140519],
            [15.366091200296433, -4.641154300025959],
            [15.364666100353276, -4.641154300025959],
            [15.363828600115589, -4.641901900401165],
            [15.362766000033991, -4.642350399849763],
            [15.361978500025016, -4.644007499686128],
            [15.360728499697059, -4.644007499686128],
            [15.359165900023243, -4.644443599567498],
            [15.358765899990182, -4.644019999758465],
            [15.359290899696724, -4.64340949967725],
            [15.359903399803541, -4.642998300179785],
            [15.359690899729815, -4.642325499696182],
            [15.358754200331921, -4.642600700199818],
            [15.357724200111987, -4.643285100042545],
            [15.357978399981175, -4.645739400234856],
            [15.357790800308829, -4.64656170020394],
            [15.357063788359509, -4.646499072075518],
            [15.355303199997083, -4.645976099672142],
            [15.353815700379377, -4.646217599661647],
            [15.353690699807565, -4.646852999975957],
            [15.346531100043686, -4.647823400435609],
            [15.341695200273, -4.646156100002588],
            [15.33430449991913, -4.646823000104397],
            [15.330563599767387, -4.645216400219722],
            [15.328890800164441, -4.642488100161476],
            [15.330472300391786, -4.640214499749881],
            [15.32670089974123, -4.633211799858491],
            [15.323416200023358, -4.632181000367001],
            [15.318823599964244, -4.629604300094714],
            [15.31474900443054, -4.625073297708214],
            [15.314352700066538, -4.624632600365866],
            [15.310611700201786, -4.62366250024528],
            [15.304437599915291, -4.624238499917569],
            [15.301183300084963, -4.622267999752137],
            [15.298447400038798, -4.622048399736729],
            [15.294146199983107, -4.622305600289657],
            [15.29189340042203, -4.621280100204218],
            [15.289186499789865, -4.621795499618784],
            [15.286120741066307, -4.621916700448048],
            [15.282708200303738, -4.621916700448048],
            [15.27911929958967, -4.622159300349135],
            [15.277902800133601, -4.620461600448123],
            [15.274800499740913, -4.618642699559228],
            [15.272732300377442, -4.616035500197757],
            [15.268535100078818, -4.615550499781961],
            [15.268109300430785, -4.615065399876492],
            [15.262721584445705, -4.615144253287228],
            [15.258265089931887, -4.615740491835142],
            [15.255591192504953, -4.615740491835142],
            [15.252917295976316, -4.616634847803812],
            [15.250837598177228, -4.616336728974033],
            [15.245575199869201, -4.615595999627082],
            [15.243166500385517, -4.609422199717611],
            [15.2412739001005, -4.605649400199835],
            [15.238865199718488, -4.600675999834542],
            [15.236972700044811, -4.596731600168563],
            [15.234908100230708, -4.595359699799802],
            [15.234133899779492, -4.594244900327127],
            [15.234133899779492, -4.592701499557855],
            [15.231381099727901, -4.591929700099143],
            [15.22991869993753, -4.589528800429419],
            [15.226047500052131, -4.588242499593211],
            [15.224069000164731, -4.588242499593211],
            [15.220972100443561, -4.58687049975016],
            [15.218047200251506, -4.586441799957178],
            [15.216240699893223, -4.585498499940619],
            [15.215156455803193, -4.58445263671784],
            [15.213573900055355, -4.582926100260332],
            [15.211980735204031, -4.579102811207004],
            [15.211251299600079, -4.57735229971683],
            [15.209960900237157, -4.575551500171088],
            [15.209702799882971, -4.573321999992877],
            [15.208892052372743, -4.571635225901413],
            [15.208407562193946, -4.570627234813539],
            [15.207540599909857, -4.568823500118737],
            [15.207897699998229, -4.568384800314494],
            [15.207609199756538, -4.5676139000642],
            [15.206789900284807, -4.566521899766851],
            [15.205908800314798, -4.566110500181022],
            [15.203780993240658, -4.565432530053432],
            [15.202497522583515, -4.565074761429176],
            [15.200928835925364, -4.564287669999951],
            [15.197434943730682, -4.562641930712911],
            [15.194796699539051, -4.561854837482144],
            [15.193513228881905, -4.561640174884586],
            [15.191302807344334, -4.561568620971433],
            [15.188807169805756, -4.561353959188668],
            [15.187167180270226, -4.560781525647148],
            [15.184174493206866, -4.560362720772343],
            [15.182603728745432, -4.560137538487198],
            [15.180678523208897, -4.559994430350318],
            [15.179976328117627, -4.559888731338002],
            [15.179629060988351, -4.559836457864519],
            [15.179612559834899, -4.559833974317773],
            [15.179332245042058, -4.559791779262954],
            [15.179270884718253, -4.559782542812265],
            [15.179252445000433, -4.559779767189394],
            [15.178852092827745, -4.559729547254272],
            [15.177541150790896, -4.559565104864917],
            [15.17722297560212, -4.559491421471782],
            [15.176614199910469, -4.559350441573947],
            [15.174752199837345, -4.559068000309316],
            [15.174551500033195, -4.558524200134329],
            [15.17405579977795, -4.557715699594216],
            [15.173682604574616, -4.55719390963017],
            [15.173181299730315, -4.556493000201822],
            [15.173076000111015, -4.556128600333275],
            [15.173128012565993, -4.555764601433516],
            [15.173342124217307, -4.55528672988105],
            [15.173663800140773, -4.554603099854816],
            [15.173767100110235, -4.553919900075891],
            [15.173798899572988, -4.553506700139668],
            [15.173751199929709, -4.553117399932353],
            [15.173520800025658, -4.552418300252737],
            [15.173473200095355, -4.552013100067163],
            [15.173593799820587, -4.551546800083622],
            [15.174141257409229, -4.550727914654522],
            [15.174354999853005, -4.550408200036986],
            [15.174485100160638, -4.549928100023449],
            [15.17443201601556, -4.549477031013375],
            [15.174338707108681, -4.549124566778374],
            [15.174184355881607, -4.548801259931558],
            [15.173873800203078, -4.548292199576053],
            [15.173771400345508, -4.547913100408828],
            [15.173822260261943, -4.54728456294119],
            [15.173883099562897, -4.546532699873423],
            [15.174059799975891, -4.545990900413904],
            [15.174323853465475, -4.545403284259429],
            [15.17476610036803, -4.544685399896075],
            [15.175142789119512, -4.544196596651841],
            [15.176156599901388, -4.543051300284005],
            [15.176072499624489, -4.542704799830563],
            [15.17640590035904, -4.54179519972869],
            [15.176476100105218, -4.540780599773776],
            [15.175914600052048, -4.539398599671381],
            [15.175884986190399, -4.539341891138777],
            [15.175247800379577, -4.538121699657564],
            [15.17420787467408, -4.537554527469659],
            [15.173773700032642, -4.537282000326797],
            [15.172615600053183, -4.536827200113155],
            [15.172106699953156, -4.535480200282327],
            [15.172479581644437, -4.533222487928375],
            [15.172457299832132, -4.530908800261056],
            [15.172333999771194, -4.529101700377471],
            [15.172438400176866, -4.52684979971229],
            [15.17320499998247, -4.524554799599694],
            [15.173784000115697, -4.520571400359921],
            [15.176905200163617, -4.516239300171222],
            [15.177643399731489, -4.514118400423092],
            [15.177697100120875, -4.511228099960096],
            [15.177119999924477, -4.509281200159627],
            [15.176442099770043, -4.507641999803341],
            [15.175328000171511, -4.506705299968199],
            [15.174166400355722, -4.505805799940483],
            [15.173701400025319, -4.50321319975809],
            [15.174175900039859, -4.501017999570885],
            [15.174735899906514, -4.49954189960837],
            [15.175808400320854, -4.498018499659429],
            [15.176064699552859, -4.496807400148048],
            [15.175487000180164, -4.49439740020956],
            [15.17587749963082, -4.493688500014432],
            [15.175908699917278, -4.49299799982251],
            [15.175295599735867, -4.49231489982555],
            [15.175070599604963, -4.491179299595522],
            [15.175675700288755, -4.490059600136629],
            [15.175841300219821, -4.488269000397163],
            [15.175273699707528, -4.487638600208377],
            [15.175410900299184, -4.487105000037356],
            [15.174906700184739, -4.486247600058543],
            [15.174204399990542, -4.484364600371659],
            [15.17421389967468, -4.481573300410666],
            [15.174206187637965, -4.481380568687846],
            [15.174081000216592, -4.478252000031256],
            [15.17325530024848, -4.475451099896646],
            [15.173232577363367, -4.475387630804657],
            [15.172314500939629, -4.472823300100505],
            [15.172296600210968, -4.472773300360885],
            [15.171288480256406, -4.470571177055953],
            [15.170880741237152, -4.469961759256123],
            [15.169802158330029, -4.468349681922476],
            [15.169634892024114, -4.468102534256207],
            [15.168893153992347, -4.467006568405548],
            [15.168870299953189, -4.466972800413812],
            [15.168306551416849, -4.466243738142386],
            [15.167748499996073, -4.465522041107084],
            [15.166887300404529, -4.464408300130233],
            [15.16569080014164, -4.463427300375315],
            [15.165749799692874, -4.463127299793462],
            [15.165684599969541, -4.46298190027339],
            [15.165793199999175, -4.462784000182722],
            [15.165684599969541, -4.462583000367456],
            [15.165635000389436, -4.462363399762717],
            [15.165724900189826, -4.462159300158349],
            [15.165365099765712, -4.461822200338247],
            [15.165256499736044, -4.461871600374131],
            [15.16503320011598, -4.46164279970519],
            [15.164983199887269, -4.461476199839326],
            [15.164885628474366, -4.461294223269931],
            [15.16477569983642, -4.461089200133129],
            [15.164580300092444, -4.46106140041186],
            [15.164530599901031, -4.46075520039526],
            [15.164419000396654, -4.46074900013684],
            [15.164294899936801, -4.460643800397171],
            [15.164474400398552, -4.460369000017911],
            [15.164304200194952, -4.46001910033107],
            [15.164049800001411, -4.460034599640263],
            [15.164080799963545, -4.459815000066508],
            [15.163854400257435, -4.459614000329381],
            [15.163655917495419, -4.459525525914329],
            [15.163209199677675, -4.45932639961191],
            [15.16308820020217, -4.459041800192153],
            [15.163022999580541, -4.458729500025537],
            [15.163119200164306, -4.458413999958847],
            [15.163051000067934, -4.458333600095647],
            [15.163074645522833, -4.458136290183337],
            [15.163074800033067, -4.458134999998379],
            [15.162944099650806, -4.458020599984858],
            [15.163069100222582, -4.457817199698743],
            [15.163003300424657, -4.45757009983027],
            [15.163027500140098, -4.457371100116179],
            [15.162575599941468, -4.456887800314561],
            [15.162509593531039, -4.45681158189552],
            [15.161940199981441, -4.456154099988152],
            [15.161788099932492, -4.456284199840386],
            [15.16155559976729, -4.456159599743296],
            [15.161441599964466, -4.45587530021518],
            [15.161187100057948, -4.455702499624345],
            [15.160884400146569, -4.455671900229181],
            [15.160880000198286, -4.456006500068675],
            [15.160693599776829, -4.455949700206468],
            [15.16053570020442, -4.455719999675609],
            [15.160526900307888, -4.455367899644653],
            [15.160447899766847, -4.455317600270267],
            [15.160362399914739, -4.455367899644653],
            [15.16026319985623, -4.455363499835733],
            [15.160248300398939, -4.455201699549411],
            [15.159967499617535, -4.4551076995883],
            [15.159702099553369, -4.4551076995883],
            [15.159487200079496, -4.455422599725701],
            [15.159030899932615, -4.455094600234438],
            [15.158958500212314, -4.454921800359254],
            [15.158704100018806, -4.454781899860929],
            [15.158287299693264, -4.454738100087333],
            [15.157657799868041, -4.454453800002339],
            [15.157609500150134, -4.454300699967831],
            [15.157670899999811, -4.453850300286254],
            [15.157629299917328, -4.453778099989012],
            [15.157330900241185, -4.45378459963896],
            [15.157159899638639, -4.453670900386098],
            [15.156908000354886, -4.453678600069646],
            [15.156705800364215, -4.453996799788376],
            [15.156628999797297, -4.454088599985048],
            [15.156082799850058, -4.453686199675208],
            [15.155645499969751, -4.453160200211023],
            [15.155488399897921, -4.452999600368961],
            [15.155521299796888, -4.452839900291467],
            [15.155025700152953, -4.452119600023228],
            [15.15521179963878, -4.451983600227098],
            [15.155284999758029, -4.451561599663425],
            [15.155069399598256, -4.451512500061542],
            [15.155098000160276, -4.451455599769568],
            [15.155038699673417, -4.451352799657048],
            [15.154554099900142, -4.451123800022314],
            [15.154363100104446, -4.451147300368082],
            [15.154183299605366, -4.451011699801206],
            [15.154056000244784, -4.45118439962717],
            [15.153901899647666, -4.451072699728218],
            [15.153575699808449, -4.45106630013226],
            [15.153345399617374, -4.451604299670714],
            [15.153071300267982, -4.451909299907421],
            [15.15302169978958, -4.452187699989807],
            [15.15277349976814, -4.452793899586855],
            [15.152277200336599, -4.453146400276522],
            [15.151904999568316, -4.453127900285507],
            [15.15183430035882, -4.45274299956622],
            [15.151746299596958, -4.45255780027767],
            [15.151707393562001, -4.452404551078698],
            [15.151638199928907, -4.452131999785921],
            [15.151383799735399, -4.452063999892239],
            [15.151086000133889, -4.45230849960632],
            [15.151073247650123, -4.452347650856607],
            [15.151057500183173, -4.452396000267623],
            [15.150966147806974, -4.452492363683283],
            [15.150943649500702, -4.452516095696977],
            [15.150906199634807, -4.452555600364712],
            [15.150853499968683, -4.452721800164136],
            [15.150754500234463, -4.452685800038299],
            [15.150463100231038, -4.452824600082897],
            [15.150099199895973, -4.452917599560101],
            [15.149995899926511, -4.452444099931092],
            [15.149925799893312, -4.451909299907421],
            [15.149870799641722, -4.451838300354479],
            [15.149646599909735, -4.451798000432428],
            [15.149568099730308, -4.451849299930084],
            [15.149438700108579, -4.451855799597308],
            [15.149375100284777, -4.451995799835959],
            [15.14916019991264, -4.452122599660479],
            [15.148940799879211, -4.452041699611469],
            [15.148845399694359, -4.452173900036819],
            [15.148618399913619, -4.452118199831865],
            [15.148511200357524, -4.452335399862273],
            [15.148303800019654, -4.452299000306692],
            [15.148247000442547, -4.452200999552232],
            [15.148060399696808, -4.452197100114435],
            [15.147984400427134, -4.452347899699312],
            [15.147837499827052, -4.452343499872086],
            [15.147624699715996, -4.452518400196051],
            [15.147507299789861, -4.452559800034607],
            [15.147247700147455, -4.452514299702339],
            [15.146950300296249, -4.452596499811116],
            [15.146615700310775, -4.45265840030697],
            [15.146368700438591, -4.452577600395675],
            [15.146012000100525, -4.451962199745093],
            [15.145430899706152, -4.45172069955328],
            [15.144792099622778, -4.451194400233945],
            [15.144509600127163, -4.451349599860265],
            [15.144165300133265, -4.451402100327658],
            [15.143938799815842, -4.450758800289971],
            [15.143858200273636, -4.450681500201826],
            [15.143619299612013, -4.450857800218202],
            [15.143377299762674, -4.450857800218202],
            [15.14351379966843, -4.450131000104932],
            [15.143333900354667, -4.449685700032711],
            [15.143359499645321, -4.449452700341524],
            [15.143454899830173, -4.449277399867191],
            [15.143248672692081, -4.448701128933956],
            [15.143029899682761, -4.448089800273362],
            [15.142877900245086, -4.448031100101219],
            [15.142759999957333, -4.447811499601019],
            [15.142803499976646, -4.447662999982671],
            [15.142635900395778, -4.447554799592033],
            [15.142677300153942, -4.447073099927221],
            [15.142521199907019, -4.447032100091137],
            [15.142397100345462, -4.447152700407275],
            [15.14210860010377, -4.446967200359037],
            [15.141665000338385, -4.446317699620412],
            [15.140904999556859, -4.446036200252828],
            [15.141013599586493, -4.445767199824883],
            [15.140855300263775, -4.445726999645155],
            [15.14083669974751, -4.445553799930789],
            [15.140524899902266, -4.44556489968052],
            [15.140241099646119, -4.445423900117989],
            [15.139868899776136, -4.445550700187487],
            [15.139403600306764, -4.445516700384344],
            [15.13853190030788, -4.445538300312508],
            [15.138023499671142, -4.445176600383103],
            [15.137706699803054, -4.445324900351241],
            [15.137846299794825, -4.445832099664091],
            [15.137188699769164, -4.446271299990646],
            [15.135826899612544, -4.445689900107501],
            [15.135635700390829, -4.445305600430673],
            [15.13519410027525, -4.445093000131817],
            [15.134784599659721, -4.445164100422735],
            [15.134483699972156, -4.445021799754874],
            [15.133934600263155, -4.444966099903432],
            [15.13354090011517, -4.445077699760174],
            [15.133124999901552, -4.444891899847052],
            [15.132727899630225, -4.444115599662342],
            [15.13227499960669, -4.444081599792089],
            [15.132048500187565, -4.444131100212563],
            [15.131846900271524, -4.444341399873958],
            [15.131112250845648, -4.444595284376567],
            [15.130148131272016, -4.444683426112024],
            [15.129432516248709, -4.443797911340609],
            [15.129432420128952, -4.443247378081598],
            [15.130386150686318, -4.442026462919517],
            [15.131149119501522, -4.440973133080129],
            [15.131816848930322, -4.44080546005574],
            [15.133772355539715, -4.44039819266855],
            [15.135155566142823, -4.440374004040278],
            [15.135012374686555, -4.439823497043502],
            [15.134416071204305, -4.439320945001152],
            [15.134201097170308, -4.437453958800952],
            [15.134177132813475, -4.43680768459755],
            [15.135655620532262, -4.436185072942365],
            [15.136895647763945, -4.435706119315121],
            [15.138159531554606, -4.43527503174921],
            [15.138803383763157, -4.434987675661443],
            [15.138683896152269, -4.433671205748839],
            [15.138492700523807, -4.43146910903141],
            [15.138754767838273, -4.430056822702283],
            [15.139684505292731, -4.428237493884882],
            [15.140232832450563, -4.427279941042694],
            [15.141472728528237, -4.426202574818288],
            [15.143261356903897, -4.426321911782739],
            [15.144143568089916, -4.425460036373629],
            [15.144143447715672, -4.424837694543982],
            [15.144214769457658, -4.423688741766159],
            [15.144071497152986, -4.422731320011499],
            [15.144190523928131, -4.421630230291776],
            [15.144929622709629, -4.420672637234285],
            [15.146121684396691, -4.418972930678808],
            [15.147361364878691, -4.416914169701145],
            [15.148625257652492, -4.416722427969708],
            [15.149889116290371, -4.416363130174137],
            [15.150652200988237, -4.416147548707219],
            [15.151868274642846, -4.415357405575979],
            [15.153251259768847, -4.414471481041377],
            [15.153823430909307, -4.413633594542595],
            [15.155182612476887, -4.4129870332815],
            [15.156160340628748, -4.412867146838544],
            [15.156899742142466, -4.413465396791286],
            [15.156899596615405, -4.41277124614559],
            [15.157257119810279, -4.411861594164469],
            [15.156946939627501, -4.41109570092808],
            [15.15687521633858, -4.410234012261855],
            [15.157876671692044, -4.409563585654816],
            [15.159021382282202, -4.409706958990225],
            [15.159712802081653, -4.408964787916273],
            [15.160309014834029, -4.409084340482561],
            [15.161215343988788, -4.409658613062107],
            [15.162575016036554, -4.411333851395606],
            [15.162073983381774, -4.410256831370926],
            [15.161716064029845, -4.409299460575889],
            [15.161143496732368, -4.408246391922468],
            [15.161024141173851, -4.407695885069592],
            [15.161023878865764, -4.406475137722049],
            [15.161906041542776, -4.405589306144412],
            [15.163288927854099, -4.404392192392484],
            [15.164075512479798, -4.402668611656525],
            [15.1657208326182, -4.402021968597149],
            [15.165911451528228, -4.40130383991469],
            [15.166722023866985, -4.400250464945063],
            [15.168486453425537, -4.399077193457921],
            [15.16870097560696, -4.398622356867373],
            [15.169297073375009, -4.39826317824389],
            [15.169988564141365, -4.397927913565901],
            [15.170680124976331, -4.397903819110686],
            [15.172063263714234, -4.397927436581933],
            [15.173160054573861, -4.397161224042358],
            [15.173994664931284, -4.396993475155518],
            [15.174089797418167, -4.395892387362919],
            [15.174184946973064, -4.39486310821196],
            [15.17461399223424, -4.39400130402052],
            [15.175400781675846, -4.393306969065675],
            [15.176330672742207, -4.392708344723836],
            [15.177189078573178, -4.392349098291831],
            [15.177188903401712, -4.391607075593044],
            [15.177784962542184, -4.391128209136153],
            [15.178810174741654, -4.390266260811504],
            [15.179668638963134, -4.390170309378907],
            [15.181171107208442, -4.390648670616252],
            [15.181791039077583, -4.390289476378409],
            [15.181671712265137, -4.389906526280319],
            [15.181290012711013, -4.389284277819276],
            [15.181599876686814, -4.388685797181424],
            [15.180383516469595, -4.387968006235719],
            [15.178904747578111, -4.386843360154528],
            [15.177926678964784, -4.385359549078647],
            [15.178037242711607, -4.383970563765256],
            [15.177976197696486, -4.381843665833491],
            [15.177673246256816, -4.380810665611043],
            [15.176825082118388, -4.378319339495564],
            [15.177126859459982, -4.374369285901733],
            [15.177005307520561, -4.372363938660437],
            [15.177247027993838, -4.370480042902042],
            [15.177851917573577, -4.368292216548623],
            [15.179486435470686, -4.367987982241937],
            [15.180576073944023, -4.367623107039353],
            [15.182634547247888, -4.368047990885904],
            [15.184147893192982, -4.367379161587178],
            [15.184147626393342, -4.366285320830693],
            [15.184086716125483, -4.364766112360676],
            [15.184389030659641, -4.363186045033154],
            [15.184328209325027, -4.362031449552612],
            [15.183722382802447, -4.360269298098216],
            [15.18396421646346, -4.358932321883174],
            [15.184266647778605, -4.357838406441743],
            [15.184326847479026, -4.35644070480872],
            [15.184508140079787, -4.355103743336477],
            [15.185294674399849, -4.353158942630663],
            [15.186020711677083, -4.351396463522558],
            [15.186868152671714, -4.350970870395762],
            [15.187117850184718, -4.349181080796027],
            [15.187233542413539, -4.348116866663839],
            [15.18655426693841, -4.347651453863012],
            [15.18632223210054, -4.34713604689034],
            [15.1864214779731, -4.346554045625868],
            [15.186620002955944, -4.345523066588656],
            [15.186404439627118, -4.344625213037371],
            [15.187148409972377, -4.343263691325848],
            [15.187624968925565, -4.341851335172871],
            [15.18848309268555, -4.340606437767248],
            [15.189746778846851, -4.340151332586006],
            [15.190618984597233, -4.338030363260037],
            [15.19078575682974, -4.337455851984569],
            [15.190356345954246, -4.336666064742653],
            [15.190451468559694, -4.335636782632965],
            [15.191166594001185, -4.334727025815824],
            [15.191190150522871, -4.333578080693469],
            [15.191952920810419, -4.332500757161115],
            [15.193431087830643, -4.331614739645719],
            [15.194813890598635, -4.330800552905914],
            [15.195624385682278, -4.329890766747584],
            [15.196315562038285, -4.328621968190249],
            [15.197125880153799, -4.327041966580125],
            [15.197697995598668, -4.326419476023466],
            [15.198580080122264, -4.32574903031399],
            [15.200010843943256, -4.326035887876985],
            [15.201322239629304, -4.325772242489176],
            [15.202705295722209, -4.325987298419889],
            [15.203110721579607, -4.326226552071661],
            [15.203802330025283, -4.326633281931623],
            [15.204422206198869, -4.326298007396854],
            [15.204922831018497, -4.32586702004461],
            [15.206592013105803, -4.32603412043023],
            [15.207426737549291, -4.326608360952075],
            [15.208428442634414, -4.327421916523004],
            [15.209582886470658, -4.328704577999811],
            [15.20994085612822, -4.329781607627858],
            [15.210060358112131, -4.330786894958014],
            [15.209821988354861, -4.331074195150446],
            [15.21209856542321, -4.332784947458552],
            [15.212505169870264, -4.332405938966907],
            [15.212847497163802, -4.332361785636937],
            [15.213185437085485, -4.332326444214647],
            [15.21351460406008, -4.332308728415329],
            [15.213887617803737, -4.332141204708657],
            [15.214216787473289, -4.332132299915778],
            [15.214462529704104, -4.331991246179139],
            [15.214853085748578, -4.331775253253581],
            [15.21509004604917, -4.331620985178712],
            [15.215331382043521, -4.331422658370376],
            [15.215779036804102, -4.331356444518753],
            [15.216112559709524, -4.331224176408005],
            [15.216568877822713, -4.330757037020246],
            [15.216977012100692, -4.330624747161234],
            [15.21736765168853, -4.330703939105706],
            [15.217745113889444, -4.330747887835835],
            [15.218100609586736, -4.330716945087745],
            [15.218416554258653, -4.330509783563843],
            [15.21864049976743, -4.330888612667689],
            [15.219290173059001, -4.331267318941019],
            [15.219658870397703, -4.331355326346118],
            [15.219992407676143, -4.331275926165998],
            [15.220343562713994, -4.331407995882103],
            [15.221019486574782, -4.331495913095399],
            [15.221506630376938, -4.331394438941559],
            [15.221844596349769, -4.331451614529534],
            [15.222379981479319, -4.331222358475415],
            [15.222687185543547, -4.331142964593379],
            [15.222928633827303, -4.331336745743435],
            [15.223126207494255, -4.331579003220751],
            [15.22339832426182, -4.331583328924363],
            [15.223635280969155, -4.331424652144118],
            [15.223881025894894, -4.331301218511717],
            [15.224205818972388, -4.331336367909327],
            [15.224583327885719, -4.331538920349956],
            [15.224820440899917, -4.331908931605926],
            [15.225031227886376, -4.33230538562451],
            [15.225312204737579, -4.332587270220013],
            [15.225601896145356, -4.332657675299016],
            [15.226422687718763, -4.332846876967719],
            [15.226839671300613, -4.332956895007178],
            [15.227199595692229, -4.333053713213061],
            [15.227581473112776, -4.333181364941787],
            [15.228024762061066, -4.333194448431182],
            [15.228375862301657, -4.333141473328023],
            [15.229034235776755, -4.33323820043319],
            [15.229411686299574, -4.33323808591097],
            [15.229710109331906, -4.333149880342861],
            [15.22992069689241, -4.332876659976631],
            [15.230078574006958, -4.33246247243084],
            [15.230385693629559, -4.332109920254609],
            [15.230824487408173, -4.33177494936326],
            [15.23122811304175, -4.33125494870386],
            [15.231535291953156, -4.331096248408298],
            [15.231903855442859, -4.330743675748265],
            [15.232246126142513, -4.330523283709999],
            [15.232799067946001, -4.330311638614535],
            [15.23317644480696, -4.33007361175423],
            [15.233448475336234, -4.329800372227015],
            [15.233773206429998, -4.329637259339032],
            [15.234141803157359, -4.329394829898399],
            [15.234484063975545, -4.329148002520959],
            [15.234764857570438, -4.328830701997122],
            [15.234966637149569, -4.328469368613604],
            [15.235150885207579, -4.328187344494927],
            [15.235414098772376, -4.32779074581258],
            [15.23561584780877, -4.327332485681916],
            [15.23573865020305, -4.327050480071002],
            [15.236045715028393, -4.326534912771493],
            [15.236528429237895, -4.326318881295972],
            [15.236923415773385, -4.326265888571688],
            [15.237265775406254, -4.326345084585273],
            [15.237590566687121, -4.326380228805577],
            [15.238213792678414, -4.326380033124036],
            [15.238784360326086, -4.326406287811444],
            [15.239275952585537, -4.326511870150506],
            [15.239679710271455, -4.32644124987371],
            [15.240101021936319, -4.326361813100902],
            [15.240337986728496, -4.326247188810339],
            [15.240741695007074, -4.326017961818716],
            [15.240987446221027, -4.325929768924241],
            [15.241821152873271, -4.325339134797444],
            [15.242101981502451, -4.325145192480234],
            [15.242444215371194, -4.324827869516287],
            [15.242821574265843, -4.324554592902214],
            [15.243497370565908, -4.324254785487481],
            [15.244041543913866, -4.324096003448306],
            [15.244533044545177, -4.323919615392076],
            [15.244971934443511, -4.32391947381555],
            [15.245533707584535, -4.323901668542534],
            [15.24626228799235, -4.32397192384605],
            [15.246666087000769, -4.324033472640913],
            [15.247201547588807, -4.324077355934831],
            [15.247456097800997, -4.32405964985927],
            [15.247785306996422, -4.324187308535536],
            [15.248312070095864, -4.324477914414042],
            [15.248623720820754, -4.324596766428049],
            [15.249106554506206, -4.324764025807396],
            [15.249738635191253, -4.325001727020313],
            [15.250282936998293, -4.32523945701398],
            [15.250555087003516, -4.325353916437107],
            [15.251073009782257, -4.325450670701831],
            [15.251555878501991, -4.325719259645502],
            [15.251731590768181, -4.326190615198569],
            [15.251951175854545, -4.326613492855995],
            [15.252227768028851, -4.326886555902563],
            [15.252570141136474, -4.327000990726021],
            [15.25302666137058, -4.327221124999236],
            [15.25350945822508, -4.327269426715596],
            [15.25373343247993, -4.327687895976553],
            [15.253716010553321, -4.328088823142597],
            [15.253760052256752, -4.328547005258389],
            [15.254334997394778, -4.328533594350302],
            [15.254585070403568, -4.328247138125765],
            [15.255138159530748, -4.328502483783947],
            [15.255524395577048, -4.328533193970846],
            [15.25609498568258, -4.328621115129632],
            [15.256454921752322, -4.328753165476643],
            [15.256792969471823, -4.329052640142788],
            [15.257030079791063, -4.329374177916823],
            [15.257341782618255, -4.329636947332076],
            [15.257749937557463, -4.329589814442323],
            [15.25805274975828, -4.329519218803834],
            [15.258460874154791, -4.329382502012692],
            [15.258838252812406, -4.329179709120323],
            [15.259114714730966, -4.329060659449066],
            [15.259430669284383, -4.328919568160216],
            [15.25970232701283, -4.328567613978556],
            [15.25927696394602, -4.328646465277632],
            [15.258930289704825, -4.328796379391124],
            [15.258574788617654, -4.328800906202226],
            [15.258254322724879, -4.328580729110222],
            [15.25789438485854, -4.328444274558206],
            [15.257613502330432, -4.328470804208548],
            [15.257358942236809, -4.328462079723018],
            [15.256961669488938, -4.328239725692436],
            [15.25678744573114, -4.327854282665765],
            [15.257270874999595, -4.327607397968661],
            [15.257731700858887, -4.327576400985091],
            [15.25820124486801, -4.327369170958365],
            [15.258512785100127, -4.327153183910091],
            [15.259100836658138, -4.326967942219162],
            [15.259386061642315, -4.32680923830745],
            [15.259508867629881, -4.326562475002424],
            [15.259462676257968, -4.326247480980023],
            [15.259947552712349, -4.325958738822695],
            [15.260465353320214, -4.325694216897997],
            [15.260930501872638, -4.325473770166353],
            [15.261667696225725, -4.325059377423183],
            [15.261983624727995, -4.324847793001418],
            [15.262457574075247, -4.324697833909628],
            [15.263089517318077, -4.324530196677891],
            [15.26338354040216, -4.324433168158834],
            [15.263774123396111, -4.324349323366976],
            [15.264072528462137, -4.32423466991149],
            [15.264370939816372, -4.324137640452325],
            [15.264620967909371, -4.32392568604774],
            [15.264770380199009, -4.323571970177746],
            [15.264842184336301, -4.323110475545702],
            [15.264757284558819, -4.322837260525628],
            [15.26481303670028, -4.322301710859175],
            [15.264773923154493, -4.322012679515752],
            [15.26474046899502, -4.321664599666793],
            [15.264381043168362, -4.321585771077208],
            [15.264318809682109, -4.321112242074758],
            [15.264296235917348, -4.320688045631554],
            [15.26445469873344, -4.320378580563749],
            [15.264404661673813, -4.319876578439355],
            [15.264405096458407, -4.319451530028271],
            [15.264330101505225, -4.318981133316043],
            [15.264475944788224, -4.318211349401093],
            [15.264526717568105, -4.317770484828792],
            [15.264528012040421, -4.317759245186052],
            [15.265276554810471, -4.316345763182632],
            [15.265491906136917, -4.315691020905934],
            [15.26552211288665, -4.315369012838405],
            [15.265614553122665, -4.314821676178105],
            [15.266583407716134, -4.313800351900577],
            [15.266892451530081, -4.313535228705184],
            [15.267364023935116, -4.313402465074995],
            [15.267577372916763, -4.313086001033426],
            [15.268471638595599, -4.312452545011212],
            [15.268916911024046, -4.312023117875665],
            [15.26922057213279, -4.311724349700038],
            [15.269394158086715, -4.311443535768067],
            [15.269882216373849, -4.310967512352914],
            [15.270185035761175, -4.310548898479233],
            [15.270705049817893, -4.309872610369017],
            [15.271257158883104, -4.30917849167815],
            [15.271976596237963, -4.308219570108045],
            [15.272289996881003, -4.307679208012201],
            [15.272849097534056, -4.306802561289418],
            [15.273312246436676, -4.306298053038731],
            [15.274021105230748, -4.305696766904979],
            [15.274288308213691, -4.305435545568014],
            [15.27446634172658, -4.304977630671995],
            [15.274818832559244, -4.304247764315469],
            [15.275060943799659, -4.303854225342423],
            [15.275331691534712, -4.303535748998117],
            [15.275787625168977, -4.303020479341759],
            [15.276418170633191, -4.30245865458436],
            [15.276834948500838, -4.302068579341453],
            [15.277294452938333, -4.301674870592868],
            [15.277818210274852, -4.301313428525305],
            [15.278175303176717, -4.301042336490024],
            [15.27871510262757, -4.300820231333826],
            [15.280143740136298, -4.300260025447806],
            [15.280608205070799, -4.29992483380595],
            [15.280956264514149, -4.299900554914771],
            [15.28121281078289, -4.299973994883364],
            [15.281490293187616, -4.300198566684141],
            [15.281648611374976, -4.300502324536573],
            [15.281641023305792, -4.300885196201536],
            [15.281629555412879, -4.301223297486415],
            [15.281714451597106, -4.301517946865701],
            [15.282019587739548, -4.301769280560428],
            [15.282563180775844, -4.302004787801497],
            [15.283000968441373, -4.302275157158205],
            [15.283453966381257, -4.302278063618077],
            [15.283753395526706, -4.30216452951221],
            [15.284193071450934, -4.302113985236297],
            [15.284529684560971, -4.302481623096578],
            [15.28503795853522, -4.303055328869983],
            [15.285416593037613, -4.303316130802379],
            [15.285886746104469, -4.303488710957123],
            [15.286806134068533, -4.303735288878507],
            [15.287180905815173, -4.30380054206551],
            [15.287665380722622, -4.303919298162104],
            [15.288301457114061, -4.304057624777982],
            [15.289273242910323, -4.303930718369207],
            [15.290386225004632, -4.303822479796124],
            [15.291065225595281, -4.303693783303581],
            [15.291455277684916, -4.303487321305393],
            [15.291695626430757, -4.303173101235747],
            [15.291993122401719, -4.303255114163715],
            [15.292255421481503, -4.30301668191991],
            [15.292499558422907, -4.30289366834717],
            [15.292879069681002, -4.302914145210369],
            [15.293169015311991, -4.302684294260061],
            [15.293734531732817, -4.302331960727284],
            [15.293928119574847, -4.302164103868628],
            [15.294322944413562, -4.302006751894569],
            [15.29492952462264, -4.301775014126836],
            [15.295156489369097, -4.301442663792985],
            [15.295585652309558, -4.301498846994822],
            [15.296313292181249, -4.301673400678683],
            [15.296815142302954, -4.301748259888011],
            [15.296822590234957, -4.301749370890532],
            [15.296901027532316, -4.301761071586657],
            [15.296939837447518, -4.301766861063934],
            [15.29701183112933, -4.301770984037488],
            [15.297190445852243, -4.301781213015684],
            [15.297442629003614, -4.301795656047681],
            [15.297822960423558, -4.301817437827558],
            [15.297835786569182, -4.301815076947427],
            [15.297863104336983, -4.301810047677501],
            [15.298382774338943, -4.301714378819262],
            [15.29848892735775, -4.30168192708274],
            [15.298556230935487, -4.301661351891089],
            [15.298700269503085, -4.301617318490117],
            [15.298935183441454, -4.301545502802264],
            [15.299091298959729, -4.301497777474191],
            [15.299297567420322, -4.30143471903957],
            [15.299323058913155, -4.301426926688221],
            [15.299441497291768, -4.301386041416124],
            [15.29955589414994, -4.301346551208183],
            [15.299555662384622, -4.301345805429342],
            [15.299585988610268, -4.301335117435008],
            [15.299569700357566, -4.300897400109221],
            [15.299628331599521, -4.300883785803862],
            [15.300196300421058, -4.300751900082387],
            [15.300857199958726, -4.30031539983282],
            [15.302057159633801, -4.299939147015848],
            [15.302522300101383, -4.299793299614379],
            [15.302532972985269, -4.299782966903269],
            [15.302757799741329, -4.299565299987358],
            [15.304135899828815, -4.29915990001308],
            [15.307079900000421, -4.298646400279692],
            [15.309079936996767, -4.297485272512118],
            [15.310828000149165, -4.296608300075332],
            [15.311278599587267, -4.296533399773669],
            [15.31182580025774, -4.296533399773669],
            [15.312769899976956, -4.296811599568256],
            [15.313011687823883, -4.296824518664399],
            [15.314572300424253, -4.29690790030559],
            [15.314583099970594, -4.296715299720385],
            [15.316778899630275, -4.296787999627248],
            [15.318724600230022, -4.296986200331362],
            [15.319431300372468, -4.297110600025009],
            [15.319495357438761, -4.297108223799605],
            [15.31980869969132, -4.297096599683566],
            [15.32024375019016, -4.297325410770769],
            [15.321352600034157, -4.29790860011951],
            [15.321583699725815, -4.29891799998529],
            [15.322730400084312, -4.300120900049104],
            [15.323226599802876, -4.30070929957084],
            [15.323955904252784, -4.301319904266923],
            [15.325499200029441, -4.302566400076508],
            [15.325481574185257, -4.302593670108227],
            [15.325452574771258, -4.302638539408243],
            [15.325250300220429, -4.302951499905936],
            [15.325579582179383, -4.303183329293057],
            [15.325979799604774, -4.303465100404257],
            [15.326141504440759, -4.303297983263107],
            [15.326328985535488, -4.303104228224679],
            [15.326451900219169, -4.302977199913754],
            [15.326843635751665, -4.303275179802696],
            [15.326958300307775, -4.303362399630893],
            [15.327358195237974, -4.303490011332057],
            [15.327516100200301, -4.303540400408301],
            [15.327559000145019, -4.303664699821234],
            [15.330271400263348, -4.305750300350402],
            [15.330220834095998, -4.305834315856715],
            [15.330154301272806, -4.305944858194749],
            [15.330116899915955, -4.30600700003968],
            [15.330314356801919, -4.30619041719749],
            [15.331370000329962, -4.307171000342173],
            [15.331780400159083, -4.30794760042749],
            [15.332080800383329, -4.308735000320928],
            [15.332093868175772, -4.308734379896742],
            [15.332441299696752, -4.308717899878511],
            [15.332639253351074, -4.309150917986052],
            [15.33295639727392, -4.309858544435529],
            [15.333051498319804, -4.310181001249616],
            [15.333422687585088, -4.311439585988667],
            [15.33348904703344, -4.31163903449228],
            [15.333504806178453, -4.311691548507157],
            [15.333867700400441, -4.312777100041167],
            [15.333541499662893, -4.312956800233927],
            [15.333690634373092, -4.313288916419757],
            [15.333693276318321, -4.313300309431083],
            [15.333694552824364, -4.313305813858844],
            [15.333998367545009, -4.313998615748204],
            [15.334199423980341, -4.314457094157079],
            [15.334565562018778, -4.315292017789245],
            [15.334575496487513, -4.315314671190438],
            [15.334648700200018, -4.315481599890365],
            [15.33494745560901, -4.315326548422233],
            [15.335023410861222, -4.315287128384236],
            [15.335161818788615, -4.315215295968942],
            [15.335275300263509, -4.315156400362974],
            [15.335930809909492, -4.316145452937103],
            [15.336167899567466, -4.316482999972657],
            [15.337867399795609, -4.318246099930874],
            [15.338715267490029, -4.319533368938894],
            [15.339201894760887, -4.319681643664852],
            [15.339393628480176, -4.319451594053715],
            [15.33991860483056, -4.319704568364891],
            [15.340256671414664, -4.319756016828672],
            [15.340545645068529, -4.320033788694499],
            [15.340947132711714, -4.319992046857273],
            [15.341278558949277, -4.320065748174766],
            [15.341435909651095, -4.320472241515516],
            [15.341379138820059, -4.321059726916739],
            [15.341683840177906, -4.321360102821729],
            [15.342072456759713, -4.32153177796128],
            [15.342043893028636, -4.321849294399286],
            [15.342042474588787, -4.321865064440792],
            [15.342034819145956, -4.321950162060634],
            [15.341978774153676, -4.322412718783521],
            [15.341972091586303, -4.322467870601129],
            [15.341971821193377, -4.322468096041835],
            [15.341964704739704, -4.322528835177472],
            [15.341442108924863, -4.323281778757663],
            [15.341261888014241, -4.32358359388357],
            [15.341213834434742, -4.323642107381452],
            [15.340989259206967, -4.323915561074179],
            [15.341587067367323, -4.323559297723111],
            [15.341798749075789, -4.32331987729365],
            [15.342048678354145, -4.323028069817933],
            [15.342255604381545, -4.322788741198186],
            [15.342550276049231, -4.322594868556993],
            [15.342298459410475, -4.323217848347629],
            [15.342282752367725, -4.32325670707215],
            [15.342593159824268, -4.323022848614941],
            [15.342777221931044, -4.32283689531186],
            [15.343071466898976, -4.32243847403358],
            [15.343452453190771, -4.322249401386648],
            [15.343383782377186, -4.322565095057633],
            [15.343144440642758, -4.322768169290928],
            [15.342922207322951, -4.323091983110693],
            [15.342826766713895, -4.323477894803724],
            [15.342800148733732, -4.323585522751414],
            [15.343095809446556, -4.323854471266015],
            [15.343440555903147, -4.324048280457419],
            [15.343683228590615, -4.324393047932501],
            [15.344075223736205, -4.324635948812862],
            [15.344440475137475, -4.324816678674616],
            [15.344741802423121, -4.324961620350865],
            [15.344987856369331, -4.325141408696845],
            [15.345310217707347, -4.325335046220419],
            [15.34534835119117, -4.324907797911274],
            [15.345280165467816, -4.324488648068266],
            [15.345973399864175, -4.324833299914958],
            [15.345722000043706, -4.325996800250196],
            [15.34676869994478, -4.327376400343661],
            [15.346964035908362, -4.327193366209568],
            [15.347110100176913, -4.327056500202805],
            [15.347562199801532, -4.326888199806537],
            [15.34759030000194, -4.327058400205474],
            [15.347276999970175, -4.327440000355067],
            [15.346984045881307, -4.327531409637562],
            [15.346919421978081, -4.327551573819693],
            [15.346881199561048, -4.327563499552122],
            [15.346593700042586, -4.327759499951827],
            [15.34652809967065, -4.328120500028952],
            [15.346737877849034, -4.328047373022207],
            [15.346833899668079, -4.328013899834493],
            [15.347481099897674, -4.328040100359104],
            [15.347942499780446, -4.328086899696937],
            [15.347982168485073, -4.32811066998647],
            [15.348220199577469, -4.328253299823624],
            [15.348422800216747, -4.328011999834267],
            [15.348522199701277, -4.328040100359104],
            [15.348872999904538, -4.328277700435178],
            [15.348886566261973, -4.328311172709321],
            [15.349001998877664, -4.328595985009149],
            [15.349055077632862, -4.32851503531958],
            [15.349153703667893, -4.32836462247869],
            [15.349399084775973, -4.327990397363479],
            [15.349565500377302, -4.32773659984614],
            [15.349599916632467, -4.327659554669466],
            [15.349617839819018, -4.327619431009265],
            [15.349715109397966, -4.327401682000362],
            [15.350057499573568, -4.326635199970518],
            [15.350163728949163, -4.326210021939885],
            [15.350232774360238, -4.325933672637506],
            [15.35036999561313, -4.325384450008568],
            [15.35042380020708, -4.325169099930794],
            [15.351668399863554, -4.324099200190662],
            [15.35185758685904, -4.324019970573995],
            [15.353814099581514, -4.323200600346813],
            [15.354286200195943, -4.323157800017617],
            [15.35475829991204, -4.32204519980829],
            [15.355093645499174, -4.321497918526866],
            [15.355121499561207, -4.320344600240612],
            [15.355144500025725, -4.319862700261019],
            [15.354649399845108, -4.3188467997725],
            [15.353833999960015, -4.317819799841325],
            [15.353319100012207, -4.317220699816185],
            [15.352675299905957, -4.316792700208869],
            [15.352312100256793, -4.316139699641536],
            [15.352612499582774, -4.315711700318395],
            [15.353385000421445, -4.315626099703016],
            [15.356174500245656, -4.316139699641536],
            [15.358726400168811, -4.316878299789181],
            [15.36191064308507, -4.318269712723755],
            [15.36969279959537, -4.322002400314766],
            [15.370532889676021, -4.322674636676922],
            [15.37298746162972, -4.324069798276637],
            [15.3754330531255, -4.323936085156516],
            [15.377607320167824, -4.323245651471252],
            [15.382357862918541, -4.324736862989886],
            [15.391229887870868, -4.328466315269138],
            [15.395007508456498, -4.329728161566901],
            [15.396954119049635, -4.331450518900861],
            [15.399243376736514, -4.331793988044835],
            [15.401132229250139, -4.332482338000347],
            [15.405023755315462, -4.332652599345162],
            [15.405710571249092, -4.332824568566279],
            [15.406568791128828, -4.332479432559397],
            [15.409945922997808, -4.333856306412148],
            [15.414238544142549, -4.33494543457104],
            [15.41956126252528, -4.336033964183509],
            [15.422194187792098, -4.336894182023023],
            [15.428546627917024, -4.337292721833439],
            [15.431751511423556, -4.337578123151638],
            [15.434326535778759, -4.337231972175853],
            [15.436051380176012, -4.337230977551126],
            [15.437014729893432, -4.336840898785679],
            [15.440848609270315, -4.336264213385279],
            [15.447372110184897, -4.335628474838316],
            [15.452522801190726, -4.336084968765376],
            [15.457272803155625, -4.336369334439654],
            [15.460020352554384, -4.337459127121454],
            [15.463454089066071, -4.337658085349573],
            [15.469233898113123, -4.337482177520207],
            [15.472781532918026, -4.336790620160723],
            [15.477931254641623, -4.335695916490098],
            [15.482794278144004, -4.333739684093877],
            [15.487542361307471, -4.331065432821761],
            [15.491889067320489, -4.327213791008626],
            [15.496351151152014, -4.324855625688523],
            [15.500584717948268, -4.323129484689872],
            [15.505904213175741, -4.319392020652422],
            [15.510022276389432, -4.316172339222889],
            [15.513110241466773, -4.312924613203267],
            [15.51625484352618, -4.30884388746692],
            [15.518599249686703, -4.306199822788181],
            [15.520714588144696, -4.303326128902368],
            [15.522487626258631, -4.302003679504713],
            [15.524603724691371, -4.300278876456235],
            [15.525860950169148, -4.297807878021679],
            [15.52757556006037, -4.294762112826005],
            [15.529519127161313, -4.291831075795876],
            [15.531177559109617, -4.290336355830833],
            [15.532034390193909, -4.288152853322207],
            [15.532433199060918, -4.285625001264338],
            [15.53380530199558, -4.283843252945194],
            [15.535176640463916, -4.280970051814067],
            [15.535461274356635, -4.27884439349218],
            [15.535288492394876, -4.277236058542422],
            [15.534658236188166, -4.276058878811442],
            [15.5349435878348, -4.274967227645337],
            [15.537745924584433, -4.272782360434422],
            [15.539804128393737, -4.270253341400533],
            [15.54237746840775, -4.267953732722358],
            [15.544320758827581, -4.264792892433282],
            [15.546320402361832, -4.260425668674197],
            [15.546891268250173, -4.258529585373392],
            [15.547689347718265, -4.2542781043764],
            [15.548315721406288, -4.249969300593416],
            [15.548911127471571, -4.247778974643866],
            [15.549227532979268, -4.246615006455841],
            [15.549238576867351, -4.246581055278964],
            [15.549799811917509, -4.244855659635733],
            [15.5505417906978, -4.242212670824347],
            [15.550767778975509, -4.238133931834814],
            [15.551164570226405, -4.232848729997214],
            [15.551274905801165, -4.227046730005404],
            [15.551788283104594, -4.224806017913228],
            [15.551386785579904, -4.223427629530743],
            [15.551213227473754, -4.220727848003755],
            [15.550983304575126, -4.219234446518622],
            [15.551039389093244, -4.217625953145259],
            [15.550179271971636, -4.214984102177894],
            [15.548572005366974, -4.207574857609566],
            [15.547081891651786, -4.204014326891673],
            [15.546737473978565, -4.202406112797663],
            [15.545248417580458, -4.200339140882884],
            [15.543759488743136, -4.198444500440609],
            [15.542270329038761, -4.196205186721753],
            [15.541639611098006, -4.194252497878229],
            [15.53934874183347, -4.190979723286401],
            [15.537629847876689, -4.187419321511489],
            [15.536026417078268, -4.185352403223381],
            [15.531152393705261, -4.181768730979873],
            [15.528380499962298, -4.177264403404575],
            [15.525376118630522, -4.172894048158407],
            [15.517705857170343, -4.167470580784479],
            [15.511982200913387, -4.163970175058461],
            [15.51152397208357, -4.16316624008629],
            [15.509119080558349, -4.160180648231173],
            [15.507458604044484, -4.158171136321884],
            [15.506198262310974, -4.155586909375796],
            [15.505910055818365, -4.152226545012453],
            [15.504421280592949, -4.150274358682803],
            [15.504077822320461, -4.149987351153092],
            [15.503833800363422, -4.145559077530313],
            [15.504015551104967, -4.14200249111488],
            [15.505099887721499, -4.137750844079499],
            [15.507156812329836, -4.133498574095616],
            [15.509443587073269, -4.130854622337535],
            [15.511557720890488, -4.126659753835967],
            [15.512127072219258, -4.122350990087973],
            [15.513499538971578, -4.121430979038816],
            [15.51446119805963, -4.120481653694434],
            [15.515157743646123, -4.119552927117283],
            [15.516086471394175, -4.117579380958932],
            [15.516666925899834, -4.116186289591609],
            [15.51701519824393, -4.115257562445101],
            [15.517479561668793, -4.114328835103078],
            [15.51817610725525, -4.113284017222978],
            [15.51950043239319, -4.11183372175365],
            [15.520757409037669, -4.109305309878261],
            [15.521041556941793, -4.10637541672171],
            [15.520639974077183, -4.104652322747623],
            [15.520238913133751, -4.103733460909663],
            [15.519490390126638, -4.09629478826571],
            [15.519374824560275, -4.094514059589078],
            [15.519774098754612, -4.092675551718421],
            [15.521774575027139, -4.089859431910982],
            [15.523718911085959, -4.088709257064919],
            [15.526521549669519, -4.087845739257028],
            [15.527950700116291, -4.086236332230401],
            [15.529321997262091, -4.08365039356085],
            [15.5306356638892, -4.080432594731148],
            [15.531548587576454, -4.076784221573234],
            [15.533261741298613, -4.072130027325304],
            [15.534862398099431, -4.070405608503416],
            [15.536520900116312, -4.069657716498178],
            [15.54058092946768, -4.067184856742896],
            [15.545612899125548, -4.063907091340167],
            [15.54789897857296, -4.060688616251247],
            [15.549784404912092, -4.057183185153328],
            [15.550812162937069, -4.054310232245944],
            [15.551954987963418, -4.052413765665935],
            [15.553556074158948, -4.051436104407401],
            [15.55635689545068, -4.048159815900352],
            [15.558072692016401, -4.047641628565262],
            [15.559445138107456, -4.046951340348531],
            [15.561104356979952, -4.047352305037041],
            [15.563106409795784, -4.047178578083079],
            [15.564994250806414, -4.047292150468805],
            [15.567453020587417, -4.045796861821386],
            [15.57008359496313, -4.044588669560667],
            [15.573686839975684, -4.043667004869034],
            [15.575802596150297, -4.042516606260848],
            [15.577860573584163, -4.040562016993283],
            [15.579518110810426, -4.038607709818692],
            [15.580547499277635, -4.038204859880821],
            [15.5815775821426, -4.038778568172119],
            [15.583179091444597, -4.038490193147452],
            [15.584208108009308, -4.037570336447993],
            [15.58546638990587, -4.03728220455406],
            [15.586267245168161, -4.037281626310976],
            [15.588497330827296, -4.036073671076946],
            [15.589468989062803, -4.034952794441523],
            [15.591698231203864, -4.032595940170943],
            [15.594728391489346, -4.030353383564107],
            [15.598274497361619, -4.029661443126823],
            [15.599990133128895, -4.029028286838479],
            [15.604221815259704, -4.027186924179813],
            [15.606280785331929, -4.026725833880937],
            [15.607539422063013, -4.026954671375077],
            [15.609998124470401, -4.025574162442641],
            [15.612457461986665, -4.025055312786121],
            [15.613716225380207, -4.02545647426555],
            [15.614745359624239, -4.024766363597189],
            [15.616346648838979, -4.024248151210841],
            [15.619092725898993, -4.024705619158104],
            [15.621209009384668, -4.024416783509275],
            [15.624068311899739, -4.023323151487149],
            [15.627042231360207, -4.022516643105705],
            [15.629272114000097, -4.021193703037098],
            [15.632474738243696, -4.020272111596439],
            [15.636705744841388, -4.017741268021173],
            [15.639850156457943, -4.015555925702703],
            [15.642137647158698, -4.014807351839274],
            [15.644939677582823, -4.013713701345326],
            [15.647227744103651, -4.013711887178474],
            [15.650144891834785, -4.013537233679203],
            [15.651116772852474, -4.012847129027409],
            [15.652546173030871, -4.012041770281564],
            [15.657407286714953, -4.010774098837224],
            [15.660838396552762, -4.009565003176194],
            [15.663011533514435, -4.008931357458573],
            [15.665814620357349, -4.009216294257537],
            [15.669246314100068, -4.008753937001496],
            [15.670790367156508, -4.008293118510532],
            [15.675192864836895, -4.005876850304611],
            [15.67702206202914, -4.00438179851385],
            [15.679024084302272, -4.004380136786341],
            [15.681655361160551, -4.004435389675399],
            [15.68354293267655, -4.004376368580138],
            [15.685601484133899, -4.003570432134],
            [15.687374220413876, -4.002994506545672],
            [15.689490203862253, -4.002475731660647],
            [15.691320374828251, -4.002186968334196],
            [15.693778732282551, -4.000691353097295],
            [15.694293485804964, -4.000633472931118],
            [15.695837502928789, -4.000172611917359],
            [15.696809468388107, -3.999654793291276],
            [15.698582087887127, -3.998963958670632],
            [15.70167039971418, -3.998386881377653],
            [15.705445643357553, -3.998441078271821],
            [15.707046748417687, -3.997865261796836],
            [15.710821936365509, -3.997861991541251],
            [15.71185113618653, -3.997401550247609],
            [15.71419597802994, -3.996997404061663],
            [15.716369017973564, -3.99636362850342],
            [15.718085255612095, -3.996649341064593],
            [15.719171397842326, -3.995901625652159],
            [15.721287831346682, -3.995957206598017],
            [15.727521311171783, -3.994515612809973],
            [15.731352700418713, -3.993420780999367],
            [15.732724768319056, -3.992615352371252],
            [15.733983149928632, -3.992614225591755],
            [15.735127439208885, -3.992957858085404],
            [15.736271524571595, -3.993071716888208],
            [15.737186198177026, -3.992496464043414],
            [15.738215114130426, -3.991748779077935],
            [15.739644729904494, -3.991345388775973],
            [15.741189411781638, -3.991688651025628],
            [15.742562289962365, -3.991802294393904],
            [15.744050394146251, -3.992834917372136],
            [15.74736783206634, -3.992717012414785],
            [15.750056131283911, -3.992657112677145],
            [15.752000214916146, -3.991908573527524],
            [15.754859632415547, -3.991331517367652],
            [15.75691894564423, -3.991501946403306],
            [15.75726161250094, -3.990927202157144],
            [15.760579030658063, -3.990809245499801],
            [15.765326252337143, -3.990517613691883],
            [15.767671019620398, -3.990113322433344],
            [15.769443799917832, -3.989709562338684],
            [15.770758668490792, -3.98896157438644],
            [15.773789645344834, -3.988384294199721],
            [15.779165040037526, -3.98705802882187],
            [15.78185270145122, -3.986366163123551],
            [15.78259643913283, -3.986537781337165],
            [15.784541281841481, -3.986650808355444],
            [15.785742386868524, -3.986592217192144],
            [15.787114374818826, -3.985786708705504],
            [15.78900086655988, -3.984693493494993],
            [15.790488010444735, -3.98469206267854],
            [15.79231872578981, -3.9850923934781],
            [15.794322524032236, -3.987043494258827],
            [15.795810223075962, -3.987616474846643],
            [15.801015568481969, -3.987956062411887],
            [15.803074525079472, -3.987781722709652],
            [15.805876604910939, -3.9871471117675],
            [15.807535845342963, -3.987662458378142],
            [15.809538330248467, -3.988234905357951],
            [15.811025191164036, -3.98794622626484],
            [15.812169005235525, -3.987801489733477],
            [15.813598836605262, -3.987685188970239],
            [15.815256154642601, -3.986247494004492],
            [15.816343022711589, -3.98636129781632],
            [15.817715537074621, -3.986130163662447],
            [15.820859863351256, -3.98457609346239],
            [15.822231517128234, -3.983483324992716],
            [15.823889724497734, -3.982964686467396],
            [15.824746596904527, -3.981872431863085],
            [15.826119042097282, -3.981583843429319],
            [15.829321102198872, -3.980604106912911],
            [15.830406924628905, -3.979683942430921],
            [15.83154953765284, -3.978361626938295],
            [15.834007440559608, -3.976808211281722],
            [15.837437935051437, -3.975512288441409],
            [15.839954117060563, -3.9750501907198],
            [15.841441049841333, -3.97487634714519],
            [15.842985236746744, -3.974759883946267],
            [15.844585391389318, -3.973437087713156],
            [15.847157934597703, -3.972170730768824],
            [15.850187860422874, -3.970731571205418],
            [15.85178858280068, -3.969983178755001],
            [15.853332990691641, -3.970096463388973],
            [15.854418886783503, -3.969291157787855],
            [15.855790758851111, -3.968485554576282],
            [15.857220179690776, -3.968024538181129],
            [15.859221020679291, -3.967045952753961],
            [15.861108000205538, -3.966584453783666],
            [15.862080949320106, -3.967186570948686],
            [15.864025300650312, -3.96689732954628],
            [15.865969589996718, -3.966550642097686],
            [15.867685094609984, -3.966204191773603],
            [15.86928686711836, -3.966489711050623],
            [15.871116639232383, -3.966028250559048],
            [15.871973907796228, -3.96539549195174],
            [15.872430265435291, -3.964246186275613],
            [15.873916859551191, -3.963785084483624],
            [15.874774304184832, -3.963324646433906],
            [15.875632653421953, -3.963725824062474],
            [15.87683490110607, -3.964815928771166],
            [15.878093801941834, -3.965388999896601],
            [15.880552223176528, -3.964467323312657],
            [15.882666919339098, -3.9630290387953],
            [15.883695514593935, -3.96216632326753],
            [15.884725572306049, -3.962682189115021],
            [15.886441297904835, -3.962565466150425],
            [15.88862021642373, -3.961496040908938],
            [15.889299084962035, -3.960128799745467],
            [15.88990911649843, -3.958010052057553],
            [15.890587908679917, -3.956574486180656],
            [15.892151409363956, -3.955411267200681],
            [15.893988717444895, -3.955819235861757],
            [15.895689742114081, -3.956022371159069],
            [15.897321632438977, -3.955200697732413],
            [15.898341672139059, -3.954789637869237],
            [15.898340495346028, -3.953696433394917],
            [15.899495565308014, -3.952328672154855],
            [15.900515083985216, -3.951439334309221],
            [15.901533421377831, -3.949456791675321],
            [15.902144819251777, -3.94863622315966],
            [15.904381158083607, -3.94888796051657],
            [15.906726971904147, -3.949689564686149],
            [15.908129625643298, -3.949324386703703],
            [15.908499476418806, -3.949228097414611],
            [15.910673209861853, -3.949570353422715],
            [15.912276136705369, -3.950947162839476],
            [15.913536346386538, -3.952726429568017],
            [15.914738674918993, -3.953873911888021],
            [15.915196477947351, -3.954103167816025],
            [15.917082801703449, -3.95312459096853],
            [15.918588437408456, -3.953135382052083],
            [15.918752422168604, -3.95247350520735],
            [15.919640486777011, -3.951215299517558],
            [15.919409233473417, -3.950620031751011],
            [15.919770690390942, -3.949792512103591],
            [15.921120857364652, -3.949360911095279],
            [15.923328403394983, -3.949722383755516],
            [15.92382085713878, -3.948199940054766],
            [15.923819723464909, -3.947174315672156],
            [15.924378828609553, -3.94634657601671],
            [15.92566251665896, -3.945385687408759],
            [15.926913331758884, -3.944491004618782],
            [15.927538353482442, -3.943696273733198],
            [15.927274156262424, -3.943101045614695],
            [15.927273459169776, -3.942472438341438],
            [15.927734062246854, -3.941942569317663],
            [15.928952699693314, -3.941742697400596],
            [15.930566860867762, -3.941740889388537],
            [15.932773794247106, -3.941572988748236],
            [15.933926433367947, -3.941273930449305],
            [15.934518576752073, -3.940545403709995],
            [15.934715157780664, -3.939585728988855],
            [15.935767895258731, -3.938327329393901],
            [15.936655550235397, -3.936738269932365],
            [15.937609752408271, -3.935744656908482],
            [15.938597671947038, -3.935445780537737],
            [15.938992565057733, -3.935081404594607],
            [15.938892999384906, -3.934419826246661],
            [15.938464238889674, -3.93395712608848],
            [15.938101584517913, -3.933692858763889],
            [15.938166653087201, -3.932964925272362],
            [15.938561361144927, -3.932435127706198],
            [15.939318240280841, -3.931739497726494],
            [15.939679930760319, -3.931143567142288],
            [15.940206995693719, -3.93114297168155],
            [15.940931895703791, -3.931307575059922],
            [15.941557080022426, -3.930678261352164],
            [15.942280827493992, -3.929817244925775],
            [15.942906195967231, -3.929353353961382],
            [15.943432702148534, -3.928856489456861],
            [15.944552412624304, -3.928590544176578],
            [15.945177219650491, -3.927630384543923],
            [15.945868988894615, -3.927629598712828],
            [15.946627161604514, -3.928091919889356],
            [15.948308105333851, -3.928917119255918],
            [15.9499233184355, -3.92987472682717],
            [15.950451055308729, -3.930469644241713],
          ],
        ],
      },
    },
  ],
};


